import { IConversion } from '../types';

export const getRecordById = (id: number): IConversion =>
  translationMap.filter((x) => x.av === id)[0];

export const translationMap: IConversion[] = [
  {
    av: 3333,
    group: 'special',
    pos: 'GREY',
    derivationExplanation: 'No Diacritic',
    english: 'No Diacritic',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 12321,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(diagonal line suggests an index finger pointing at something unspecific. The diagonal line has the opposite orientation to the one used in the, this and that.) - Character',
    english: 'a, an, any',
    swedish: 'en, ett',
    norwegian: 'en, ei, et',
    finnish: 'eräs, joku, jokin, mitä tahansa, mitään',
    hungarian: 'egy (határozatlan névelő)',
    german: 'ein, eine, einer, ein',
    dutch: 'een',
    afrikaans: 'n, enige',
    russian: 'неопределённый артикль в ин. яз.',
    latvian: 'artikuls pirms lietvārda vienskaitlī; jebkurš, jebkura',
    polish: 'jakikolwiek, jakiś',
    french: 'un, une, des',
    spanish: 'un, una, cualquier, cualquiera',
  },
  {
    av: 12322,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(dot + evaluation: evaluation beforehand of one’s potential to do something) - Character (sequenced)',
    english: 'ability, capability, capacity, potential',
    swedish: 'förmåga, kapacitet',
    norwegian: 'evne, kapasitet',
    finnish: 'kyky',
    hungarian: 'képesség, kapacitás, potenciál',
    german: 'Fähigkeit, Können, Eignung',
    dutch: 'vaardigheid, kunde',
    afrikaans: 'vermoë, kundigheid, kapasiteit, moontlikheid, potensiaal',
    russian: 'способность, потенциал',
    latvian: 'spēja, spējas, potenciāls',
    polish: 'zdolność, możliwość',
    french: 'capacité, aptitude, compétence',
    spanish: 'capacidad, habilidad, potencial',
  },
  {
    av: 12324,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(relation [half-sized], pointing forward: used to mean on when the symbol refers to time, e.g. on Wednesday) - Character',
    english: 'about, concerning, in relation to, of, on',
    swedish: 'om, på',
    norwegian: 'om, angående, på',
    finnish: 'jostakin (asiasta)',
    hungarian: 'ról, ről (valamivel kapcsolatban)',
    german: 'über (etwas), von (etwas)',
    dutch: 'over',
    afrikaans: 'oor, daaroor, aangaande, in verhouding tot, op, of, na',
    russian: 'в, о, об, про',
    latvian: 'par, attiecībā uz ',
    polish: 'o czymś, odnośnie do czegoś, w stosunku do, w nawiązaniu do',
    french: 'à propos de, au sujet de, concernant',
    spanish: 'sobre, con respecto a, en relación con, de, sobre',
  },
  {
    av: 12330,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(paper [modification] + container: written (financial) record of something held) - Character (superimposed - modified)',
    english: 'account',
    swedish: 'konto',
    norwegian: 'konto',
    finnish: 'tili, laskelma',
    hungarian: 'számla, bizonylat',
    german: 'Konto',
    dutch: 'rekening',
    afrikaans: 'rekening',
    russian: 'счёт',
    latvian: 'konts',
    polish: 'konto',
    french: 'compte-rendu, récit',
    spanish: 'cuenta',
  },
  {
    av: 12333,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(a vertical line with two horizontal lines [half sized] across it: CKB says this is a small road crossing a main road) - Character',
    english: 'across',
    swedish: 'tvärs över',
    norwegian: 'tvers over',
    finnish: 'poikki, yli',
    hungarian: 'keresztül, át',
    german: 'über, hinüber, herüber, auf der anderen Seite',
    dutch: 'aan de overkant',
    afrikaans: 'oorkant, anderkant, regoor, oor',
    russian: 'через',
    latvian: 'šķērsām, pāri',
    polish: 'w poprzek, przez',
    french: "à travers, d'un côté à l'autre",
    spanish: 'a través de',
  },
  {
    av: 12334,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(symbol suggests the shape of a volcano cone, which CKB says represents 'one of the primeval actions of our earth'. The Action [full-sized], is used primarily as the source of activity - action [half-sized]) - Character",
    english: 'action, act, deed',
    swedish: 'handling',
    norwegian: 'handling',
    finnish: 'toiminta, teko',
    hungarian: 'tett, cselekedet',
    german: 'Tat, Handlung, Aktion, Ausführung',
    dutch: 'handeling, actie',
    afrikaans: 'aksie, daad',
    russian: 'действие',
    latvian: 'darbība, rīcība',
    polish: 'działanie, akcja',
    french: 'action',
    spanish: 'acción, acto, hecho',
  },
  {
    av: 12335,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(action [half-sized]) (Also used as part of other characters to indicate male gender) - Character',
    english: 'activity, male gender (in combinations)',
    swedish: 'aktivitet, hankön (i kombinationer)',
    norwegian: 'aktivitet',
    finnish: 'toiminta, puuha, tekeminen',
    hungarian: 'tevékenység, hímnem (szóösszetételben)',
    german: 'Tätigkeit, Aktivität, männliches Geschlecht (in Kombinationen)',
    dutch: 'activiteit, daad',
    afrikaans: 'aktiwiteit, daad',
    russian: 'активность, мужской род (в комбинации)',
    latvian: 'darbība, vīriešu dzim. (sakarībās)',
    polish: 'aktywność, działanie, akt, czyn',
    french: 'activité',
    spanish: 'actividad, género masculino (en combinaciones)',
  },
  {
    av: 12339,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(based upon the international mathematical symbol) - Character',
    english: 'addition, gain',
    swedish: 'tillägg, vinst, addition',
    norwegian: 'addisjon, tillegg',
    finnish: 'yhteenlasku, lisääminen',
    hungarian: 'összeadás',
    german: 'Addition, Gewinn, Zugewinn, Ergänzung',
    dutch: 'optelling, toevoeging',
    afrikaans: 'plus, optel, saamvoeg, toevoeg, byvoeg',
    russian: 'сложение, прибавление',
    latvian: 'saskaitīšana',
    polish: 'dodawanie',
    french: 'addition',
    spanish: 'adición, ganancia',
  },
  {
    av: 12341,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      "(flower + big: CKB suggests that an adult is a person reaching 'full flower') - Character (superimposed)",
    english: 'adult, grownup',
    swedish: 'vuxen',
    norwegian: 'voksen',
    finnish: 'aikuinen',
    hungarian: 'felnőtt (fn.)',
    german: 'Erwachsener',
    dutch: 'volwassene',
    afrikaans: 'volwasse, grootmens',
    russian: 'взрослый человек',
    latvian: 'pieaugušais, pieaudzis',
    polish: 'osoba dorosła',
    french: 'adulte, grande personne',
    spanish: 'adulto, persona mayor',
  },
  {
    av: 12348,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(reference line + dot: dot comes after the reference line. This symbol refers to both time and space.) - Character (sequenced)',
    english: 'after, behind',
    swedish: 'efter, bakom',
    norwegian: 'etter, bak',
    finnish: 'jälkeen, takana',
    hungarian: 'mögött, után',
    german: 'nach, hinter',
    dutch: 'achter, na',
    afrikaans: 'agter, na',
    russian: 'потом, за, после',
    latvian: 'vēlāk, pēc tam, aiz',
    polish: 'po, za, z tyłu',
    french: 'après, derrière',
    spanish: 'después (de), detrás (de), atrás (de)',
  },
  {
    av: 12350,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(dot is repeated: it appears once and then again) - Character (sequenced)',
    english: 'again',
    swedish: 'igen',
    norwegian: 'igjen',
    finnish: 'taas, uudelleen',
    hungarian: 'újra, ismét',
    german: 'wieder, noch einmal, nochmals',
    dutch: 'weer, opnieuw, nog',
    afrikaans: 'weer, opnuut, nog',
    russian: 'снова, ещё раз',
    latvian: 'vēlreiz, atkārtoti',
    polish: 'znowu, ponownie, powtórnie',
    french: 'encore, de nouveau, à nouveau',
    spanish: 'de nuevo, otra vez',
  },
  {
    av: 12351,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(opposition [half-sized]) - Character',
    english: 'against, opposed to',
    swedish: 'mot',
    norwegian: 'mot',
    finnish: 'vastaan, vasten',
    hungarian: 'ellen (valamivel szemben, valami ellenében)',
    german: 'gegen, gegenüber, im Gegensatz zu, statt',
    dutch: 'tegen',
    afrikaans: 'teen, teengaan',
    russian: 'против',
    latvian: 'pret, pretējs attiecībā uz',
    polish: 'przeciwnie, w przeciwieństwie do',
    french: 'contre',
    spanish: 'contra, opuesto(a) a',
  },
  {
    av: 12352,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(past [half-sized]) - Character',
    english: 'ago, then (past)',
    swedish: 'förut, då',
    norwegian: 'før, da, tidligere',
    finnish: 'aikaisemmin, silloin, sitten',
    hungarian: 'előtt (időben), korábban',
    german: 'vor, vergangen, her, damals, derzeitig',
    dutch: 'dan, vroeger',
    afrikaans: 'dan, gelede, verlede, verby, toe, was (verlede tyd)',
    russian: 'раньше, прежде',
    latvian: 'pirms, tad, toreiz (pagātnē)',
    polish: 'kiedyś, dawniej, wtedy (w przeszłości)',
    french: 'il y a, alors',
    spanish: 'hace, entonces (pasado)',
  },
  {
    av: 12354,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(two parallel arrows: to be in harmony) - Character (superimposed)',
    english: 'agreement',
    swedish: 'enighet',
    norwegian: 'avtale, enighet',
    finnish: 'sopimus',
    hungarian: 'egyetértés, összhang',
    german: 'Übereinkunft, Vereinbarung, Zustimmung, Einvernehmen, Abmachung, Vertrag',
    dutch: 'overeenkomst',
    afrikaans: 'ooreenkoms',
    russian: 'согласие',
    latvian: 'noruna, vienošanās',
    polish: 'umowa',
    french: 'accord',
    spanish: 'acuerdo',
  },
  {
    av: 12356,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sky + nose: one breathes air from the sky) - Character (superimposed)',
    english: 'air, atmosphere',
    swedish: 'luft',
    norwegian: 'luft, atmosfære',
    finnish: 'ilma, ilmakehä',
    hungarian: 'levegő, atmoszféra',
    german: 'Luft, Atmosphäre',
    dutch: 'lucht',
    afrikaans: 'lug, atmosfeer',
    russian: 'воздух, атмосфера',
    latvian: 'gaiss, atmosfēra',
    polish: 'powietrze, klimat',
    french: 'air',
    spanish: 'aire, atmósfera',
  },
  {
    av: 12357,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(wings + wheel) - Character (superimposed)',
    english: 'airplane, aeroplane, plane',
    swedish: 'flygplan',
    norwegian: 'fly',
    finnish: 'lentokone',
    hungarian: 'repülőgép',
    german: 'Flugzeug',
    dutch: 'vliegtuig',
    afrikaans: 'vliegtuig',
    russian: 'самолёт',
    latvian: 'lidmašīna',
    polish: 'samolot',
    french: 'avion',
    spanish: 'avión',
  },
  {
    av: 12359,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a wine glass) - Character',
    english: 'alcoholic drink, alcoholic beverage, liquor',
    swedish: 'dryck med alkohol, sprit',
    norwegian: 'drikk alkoholholdig, sprit',
    finnish: 'alkoholijuoma',
    hungarian: 'alkohol, alkoholos ital, ital',
    german: 'alkoholisches Getränk',
    dutch: 'alcoholische drank',
    afrikaans: 'alkohol, alkoholiese drank, likeur',
    russian: 'спиртной напиток',
    latvian: 'alkohols, alkoholisks dzēriens',
    polish: 'napój alkoholowy',
    french: 'boisson alcoolisée',
    spanish: 'bebida alcohólica, licor',
  },
  {
    av: 12360,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(multitude + enclosure: symbol reminds us that “all” can only refer to some restricted multitude) - Character (superimposed)',
    english: 'all, every, everything, total, whole',
    swedish: 'all, hel',
    norwegian: 'alle, alt, hel',
    finnish: 'kaikki, koko',
    hungarian: 'minden, összes, teljes egész, totális',
    german: 'alle, alles, gesamt, ganz',
    dutch: 'heel, geheel, alles',
    afrikaans: 'alles, als, totaal, in geheel',
    russian: 'всё, полностью',
    latvian: 'viss, visi, kopums',
    polish: 'wszystko, wszyscy',
    french: 'tout',
    spanish: 'todo, toda, cada, ',
  },
  {
    av: 12366,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(a (lowercase) + b (lowercase) + c (lowercase): first three letters of the English alphabet, representing the entire alphabet) - Character (superimposed)',
    english: 'alphabet, letters (lowercase)',
    swedish: 'alfabetet, bokstäver (gemener)',
    norwegian: 'alfabetet (små), bokstaver (små)',
    finnish: 'aakkoset (pieniä), kirjaimet (pienet)',
    hungarian: 'ábécé (kisbetűs)',
    german: 'Alphabet, Buchstabe, Schriftzeichen, Kleinbuchstaben',
    dutch: 'alfabet, letters (kleine)',
    afrikaans: 'alfabet, kleinletters, letters (klein)',
    russian: 'алфавит, буквы',
    latvian: 'alfabēts, burti, (mazie burti)',
    polish: 'alfabet, litery (małe)',
    french: 'alphabet, lettres (minuscules)',
    spanish: 'alfabeto, letras (minúsculas)',
  },
  {
    av: 12367,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(three arrowheads: one arrowhead moves forward between and beyond two opposing arrowheads) - Character',
    english: 'although',
    swedish: 'fastän, även om',
    norwegian: 'selv om',
    finnish: 'vaikka',
    hungarian: 'noha, bár, ámbár',
    german: 'obwohl, trotzdem',
    dutch: 'hoewel',
    afrikaans: 'alhoewel, hoewel',
    russian: 'хотя, даже если',
    latvian: 'lai gan, lai arī',
    polish: 'jednak, pomimo',
    french: 'bien que, quoique',
    spanish: 'aunque, si bien',
  },
  {
    av: 12374,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(addition [half-sized] with the crossbar located in the midline) - Character',
    english: 'and, also, plus, too',
    swedish: 'och, också, plus',
    norwegian: 'og, pluss, også',
    finnish: 'myös, ja, plus',
    hungarian: 'és, is, szintén',
    german: 'und, auch, plus',
    dutch: 'en, plus',
    afrikaans: 'en, plus, ook',
    russian: 'и, также, плюс',
    latvian: 'un, arī, papildu',
    polish: 'i, plus, też, także',
    french: 'et, plus, ainsi que',
    spanish: 'y, también, además, más',
  },
  {
    av: 12376,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(international mathematical symbol) - Character',
    english: 'angle',
    swedish: 'vinkel',
    norwegian: 'vinkel',
    finnish: 'kulma',
    hungarian: 'szög (mértani elem)',
    german: 'Winkel, Ecke',
    dutch: 'hoek',
    afrikaans: 'hoek',
    russian: 'угол',
    latvian: 'stūris, leņķis',
    polish: 'kąt',
    french: 'angle',
    spanish: 'ángulo',
  },
  {
    av: 12378,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a creature with four legs) - Character',
    english: 'animal, beast',
    swedish: 'djur',
    norwegian: 'dyr',
    finnish: 'eläin',
    hungarian: 'állat (négylábú)',
    german: 'Tier, Biest',
    dutch: 'dier, beest',
    afrikaans: 'dier',
    russian: 'животное',
    latvian: 'dzīvnieks, zvērs',
    polish: 'zwierzę',
    french: 'animal',
    spanish: 'animal, bestia',
  },
  {
    av: 12379,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(animal + horn(s) pictograph) - Character (superimposed)',
    english: 'animal (bovine, ovine), bovid, bovine',
    swedish: 'ko, tjur, nötboskap',
    norwegian: 'ku, okse, hornkveg',
    finnish: 'nautaeläin',
    hungarian: 'szarvasmarhaféle, juhféle',
    german: 'Kuh, Rind, Stier',
    dutch: 'rund',
    afrikaans: 'bees',
    russian: 'корова, бык, крупный рогатый скот',
    latvian: 'dzīvnieks (govslops), liellopu',
    polish: 'bydło, bydło rogate',
    french: 'animal (bovin)',
    spanish: 'animal (bovino), ovino',
  },
  {
    av: 12380,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + curved line (representing a tail): the waving tail being characteristic of a dog) - Character (superimposed)',
    english: 'dog, canine (animal), canid',
    swedish: 'hund, hunddjur',
    norwegian: 'hund',
    finnish: 'koira',
    hungarian: 'kutya, kutyaféle',
    german: 'Hund',
    dutch: 'hond',
    afrikaans: 'hond',
    russian: 'собака',
    latvian: 'suns, suņveidīgais ',
    polish: 'pies',
    french: 'chien, canidé',
    spanish: 'perro, canino (animal), cánido',
  },
  {
    av: 12381,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + horn(s) pictograph: horns are raised to signify that males shed their horns annually) - Character (superimposed)',
    english: 'deer, cervine (animal), cervid',
    swedish: 'hjort, hjortdjur',
    norwegian: 'hjort, hjortedyr',
    finnish: 'hirvieläin',
    hungarian: 'szarvasféle, őzféle',
    german: 'Hirsch',
    dutch: 'hert',
    afrikaans: 'takbok',
    russian: 'олень',
    latvian: 'briedis, briežveidīgais',
    polish: 'jeleń, sarna, zwierzyna płowa',
    french: 'cerf, cervidé',
    spanish: 'venado, ciervo (animal), cérvido',
  },
  {
    av: 12383,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + small curved lines (representing claws): the claws being characteristic of cats) - Character (superimposed)',
    english: 'cat, feline (animal), felid',
    swedish: 'katt, kattdjur',
    norwegian: 'katt, kattedyr',
    finnish: 'kissa',
    hungarian: 'macskaféle',
    german: 'Katze',
    dutch: 'kat, poes',
    afrikaans: 'kat',
    russian: 'кот, кошка',
    latvian: 'kaķis, kaķveidīgais',
    polish: 'kot, zwierzę kotowate',
    french: 'chat, félin, félidé',
    spanish: 'gato, felino (animal) félido',
  },
  {
    av: 12389,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + water [modification, under earthline]) - Character (superimposed - modified)',
    english: 'animal (water)',
    swedish: 'djur (i vatten)',
    norwegian: 'dyr (i vann)',
    finnish: 'vesieläin',
    hungarian: 'víziállat',
    german: 'Tier (Wasser)',
    dutch: 'waterdier',
    afrikaans: 'dier (water)',
    russian: 'водное животное',
    latvian: 'ūdensdzīvnieks',
    polish: 'zwierzę wodne',
    french: 'animal (aquatique)',
    spanish: 'animal (marino)',
  },
  {
    av: 12391,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(kneeling person + pointer, to ankle joint) - Character (superimposed - pointer)',
    english: 'ankle',
    swedish: 'ankel, fotled',
    norwegian: 'ankel',
    finnish: 'nilkka',
    hungarian: 'boka',
    german: 'Fußknöchel',
    dutch: 'enkel',
    afrikaans: 'enkel',
    russian: 'лодыжка',
    latvian: 'potīte',
    polish: 'kostka u nogi',
    french: 'cheville',
    spanish: 'tobillo',
  },
  {
    av: 12393,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(question + enclosure (combination): an answer 'closes' a question) - Character (superimposed - combined)",
    english: 'answer, reply',
    swedish: 'svar',
    norwegian: 'svar',
    finnish: 'vastaus',
    hungarian: 'válasz, felelet',
    german: 'Antwort, Erwiderung',
    dutch: 'antwoord',
    afrikaans: 'antwoord',
    russian: 'ответ',
    latvian: 'atbilde',
    polish: 'odpowiedź',
    french: 'réponse',
    spanish: 'respuesta',
  },
  {
    av: 12402,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(any + earth, ground, land: can be interpreted as a combination of any and place) - Character (superimposed)',
    english: 'anywhere, anyplace, someplace, somewhere',
    swedish: 'någonstans, var som helst',
    norwegian: 'hvor som helst, et eller annet sted',
    finnish: 'missä tahansa, missään, jossakin',
    hungarian: 'akárhol, bárhol, valahol',
    german: 'überall, irgendwo',
    dutch: 'ergens',
    afrikaans: 'êrens, iewers, plek (enige)',
    russian: 'где угодно, где-нибудь',
    latvian: 'jebkur, jebkurā vietā, kādā vietā, kaut kur',
    polish: 'gdziekolwiek, gdzieś',
    french: 'quelque part',
    spanish: 'en cualquier lugar, en algún lugar',
  },
  {
    av: 12405,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph of apple with stem) - Character',
    english: 'apple',
    swedish: 'äpple',
    norwegian: 'eple',
    finnish: 'omena',
    hungarian: 'alma',
    german: 'Apfel',
    dutch: 'appel',
    afrikaans: 'appel',
    russian: 'яблоко',
    latvian: 'ābols',
    polish: 'jabłko',
    french: 'pomme',
    spanish: 'manzana',
  },
  {
    av: 12577,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests an arm bent upward) - Character',
    english: 'arm',
    swedish: 'arm',
    norwegian: 'arm',
    finnish: 'käsivarsi, käsi',
    hungarian: 'kar',
    german: 'Arm',
    dutch: 'arm',
    afrikaans: 'arm',
    russian: 'рука',
    latvian: 'roka',
    polish: 'ramię',
    french: 'bras',
    spanish: 'brazo',
  },
  {
    av: 12578,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a chair with support added for the arm) - Character',
    english: 'armchair',
    swedish: 'fåtölj',
    norwegian: 'lenestol',
    finnish: 'nojatuoli',
    hungarian: 'karosszék',
    german: 'Sessel, Lehnstuhl',
    dutch: 'leunstoel, fauteuil',
    afrikaans: 'leunstoel',
    russian: 'кресло',
    latvian: 'atzveltnes krēsls',
    polish: 'fotel',
    french: 'fauteuil',
    spanish: 'sillón',
  },
  {
    av: 12580,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(curved line + dot: half circle is around the dot) - Character (superimposed)',
    english: 'around',
    swedish: 'omkring',
    norwegian: 'rundt, omkring',
    finnish: 'ympärillä, ympäri',
    hungarian: 'köré, körül',
    german: 'herum, um',
    dutch: 'rondom, omheen, om',
    afrikaans: 'rondom, om',
    russian: 'кругом, вокруг',
    latvian: 'apkārt',
    polish: 'dookoła, naokoło, w pobliżu',
    french: 'autour de',
    spanish: 'alrededor de',
  },
  {
    av: 12591,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(position [half-sized]) - Character (sequenced)',
    english: 'at',
    swedish: 'vid, bredvid, hos',
    norwegian: 'til, ved, i, på, med',
    finnish: 'luona, kohdalla',
    hungarian: 'nál, nél, ',
    german: 'an, bei, zu',
    dutch: 'op',
    afrikaans: 'by',
    russian: 'возле, около, у ',
    latvian: 'pie, uz, iekšā',
    polish: 'do, przy, u',
    french: 'à, chez',
    spanish: 'en',
  },
  {
    av: 12592,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph of an atom with inner nucleus + pointer showing the movement of a circling electron) - Character',
    english: 'atom',
    swedish: 'atom',
    norwegian: 'atom',
    finnish: 'atomi',
    hungarian: 'atom',
    german: 'Atom',
    dutch: 'atoom',
    afrikaans: 'atoom',
    russian: 'атом',
    latvian: 'atoms',
    polish: 'atom',
    french: 'atome',
    spanish: 'átomo',
  },
  {
    av: 12596,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      "(sister + parent: the sister of one's father or mother) - Character (superimposed)",
    english: 'aunt',
    swedish: 'faster, moster',
    norwegian: 'tante',
    finnish: 'täti',
    hungarian: 'nagynéni',
    german: 'Tante',
    dutch: 'tante',
    afrikaans: 'tante, tannie',
    russian: 'тётя',
    latvian: 'tante',
    polish: 'ciotka',
    french: 'tante',
    spanish: 'tía',
  },
  {
    av: 12600,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pear + pit) - Character (superimposed)',
    english: 'avocado',
    swedish: 'avocado',
    norwegian: 'avocado',
    finnish: 'avokaado',
    hungarian: 'avokádó',
    german: 'Avocado',
    dutch: 'avocado',
    afrikaans: 'avokadopeer',
    russian: 'авокадо',
    latvian: 'avokado',
    polish: 'awokado',
    french: 'avocat',
    spanish: 'aguacate',
  },
  {
    av: 12603,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(child, turned on its side: child too young to stand) - Character',
    english: 'baby, infant',
    swedish: 'baby',
    norwegian: 'baby',
    finnish: 'vauva',
    hungarian: 'csecsemő, kisbaba',
    german: 'Baby, Kleinkind',
    dutch: 'baby',
    afrikaans: 'baba',
    russian: 'младенец',
    latvian: 'bērniņš, mazulis',
    polish: 'dziecko, niemowlę',
    french: 'bébé, nouveau-né',
    spanish: 'bebé',
  },
  {
    av: 12604,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(boy, turned on his side: boy too young to stand) - Character',
    english: 'baby boy',
    swedish: 'baby (pojke)',
    norwegian: 'baby (gutt)',
    finnish: 'poikavauva',
    hungarian: 'fiúcsecsemő, kisbaba-fiú',
    german: 'Baby (Junge)',
    dutch: 'baby (jongen)',
    afrikaans: 'baba seun',
    russian: 'малыш',
    latvian: 'mazulis zēns',
    polish: 'niemowlę, chłopczyk',
    french: 'bébé (garçon)',
    spanish: 'bebé (niño)',
  },
  {
    av: 12607,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(girl, turned on her side: girl too young to stand) - Character',
    english: 'baby girl',
    swedish: 'baby (flicka)',
    norwegian: 'baby (jente)',
    finnish: 'tytövauva',
    hungarian: 'lánycsecsemő, kisbaba-lány',
    german: 'Baby (Mädchen)',
    dutch: 'baby (meisje)',
    afrikaans: 'baba dogter',
    russian: 'малышка',
    latvian: 'mazulīte',
    polish: 'niemowlę, dziewczynka',
    french: 'bébé (fille)',
    spanish: 'bebé (niña)',
  },
  {
    av: 12609,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(standing person + pointer, to back) - Character (superimposed - pointer)',
    english: 'back (body)',
    swedish: 'rygg',
    norwegian: 'rygg',
    finnish: 'selkä',
    hungarian: 'hát (testrész)',
    german: 'Rücken (Körper)',
    dutch: 'rug',
    afrikaans: 'rug (liggaam)',
    russian: 'спина',
    latvian: 'mugura (ķermenis)',
    polish: 'plecy',
    french: 'dos',
    spanish: 'espalda (cuerpo)',
  },
  {
    av: 12610,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(backward [modification, on earthline] + forward) - Character (superimposed - modified)',
    english: 'back and forth, backward and forward, to and fro',
    swedish: 'fram och tillbaka',
    norwegian: 'til og fra, fram og tilbake',
    finnish: 'edestakaisin',
    hungarian: 'oda-vissza, ide-oda, előre-hátra',
    german: 'hin und her, rückwärts und vorwärts',
    dutch: 'heen en weer',
    afrikaans: 'heen en weer vorentoe en agtertoe',
    russian: 'вперёд и назад, туда и обратно',
    latvian: 'uz priekšu un atpakaļ, uz priekšu un atpakaļgaitā; uz un no',
    polish: 'tam i z powrotem, do przodu i do tyłu',
    french: 'va-et-vient',
    spanish: 'adelante y atrás',
  },
  {
    av: 12613,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(arrow, pointing backward) - Character',
    english: 'backward, back',
    swedish: 'tillbaka, bakåt',
    norwegian: 'bakover, tilbake',
    finnish: 'takaisin, taaksepäin',
    hungarian: 'hátra, vissza',
    german: 'rückwärts, zurück',
    dutch: 'terug, achteruit, naar achteren',
    afrikaans: 'terug, agtertoe',
    russian: 'назад, обратно',
    latvian: 'uz atpakaļu, atpakaļ',
    polish: 'z powrotem, wstecz',
    french: 'en arrière',
    spanish: 'hacia atrás',
  },
  {
    av: 12616,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol is shaped like a badge) - Character',
    english: 'badge, shield',
    swedish: 'märke, sköld',
    norwegian: 'merke, emblem (o l)',
    finnish: 'tunnus, merkki',
    hungarian: 'jelvény',
    german: 'Abzeichen, Schild',
    dutch: 'badge, insigne',
    afrikaans: 'skild, wapen (soortnaam)',
    russian: 'значок, эмблема, щит',
    latvian: 'nozīmīte, piespraude, vairogs',
    polish: 'odznaka',
    french: 'badge, insigne',
    spanish: 'insignia',
  },
  {
    av: 12618,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'baggage, bag, luggage, suitcase',
    swedish: 'väska, bagage',
    norwegian: 'veske, bagasje, koffert, bag',
    finnish: 'matkatavarat',
    hungarian: 'bőrönd, poggyász, ',
    german: 'Gepäck, Tasche, Koffer',
    dutch: 'koffer, valies',
    afrikaans: 'tas, reistas, kleretas, bagasie',
    russian: 'сумка, багаж',
    latvian: 'bagāža, soma, ceļasoma',
    polish: 'bagaż, torba, walizka',
    french: 'bagage, valise',
    spanish: 'equipaje, bolso, maleta',
  },
  {
    av: 12621,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a small stitched ball) - Character',
    english: 'ball',
    swedish: 'boll',
    norwegian: 'ball',
    finnish: 'pallo',
    hungarian: 'labda',
    german: 'Ball',
    dutch: 'bal',
    afrikaans: 'bal',
    russian: 'мяч',
    latvian: 'bumba',
    polish: 'piłka',
    french: 'balle',
    spanish: 'bola, pelota',
  },
  {
    av: 12622,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'balloon',
    swedish: 'ballong',
    norwegian: 'ballong',
    finnish: 'ilmapallo',
    hungarian: 'léggömb, lufi',
    german: 'Ballon, Luftballon',
    dutch: 'ballon',
    afrikaans: 'ballon',
    russian: 'шар',
    latvian: 'balons',
    polish: 'balon (zabawka)',
    french: 'ballon',
    spanish: 'globo',
  },
  {
    av: 12623,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph with stem: crescent-shaped fruit suggesting a banana) - Character',
    english: 'banana',
    swedish: 'banan',
    norwegian: 'banan',
    finnish: 'banaani',
    hungarian: 'banán',
    german: 'Banane',
    dutch: 'banaan',
    afrikaans: 'piesang',
    russian: 'банан',
    latvian: 'banāns',
    polish: 'banan',
    french: 'banane',
    spanish: 'banana, plátano',
  },
  {
    av: 12631,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sperm + vertical line: combination of sperm and stop (to)) - Character (superimposed - combined)',
    english: 'barrier (contraceptive)',
    swedish: 'preventivmedel',
    norwegian: 'prevensjon',
    finnish: 'ehkäisy',
    hungarian: 'fogamzásgátló (mechanikus, pl. óvszer, pesszárium)',
    german: 'Verhütungsmittel',
    dutch: 'anticonceptiemiddel',
    afrikaans: 'kontraseptiewe middel',
    russian: 'контрацептивы',
    latvian: 'pretapauglošanās līdzekļi',
    polish: 'środek antykoncepcyjny, bariera (antykoncepcyjna)',
    french: 'contraceptif, barrière contraceptive',
    spanish: 'barrera (contracepción)',
  },
  {
    av: 12636,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(animal + wing(s): flying animal) - Character (superimposed)',
    english: 'bat (animal)',
    swedish: 'fladdermus',
    norwegian: 'flaggermus',
    finnish: 'lepakko',
    hungarian: 'denevér',
    german: 'Fledermaus',
    dutch: 'vleermuis',
    afrikaans: 'vlermuis',
    russian: 'летучая мышь',
    latvian: 'sikspārnis',
    polish: 'nietoperz (zwierzę)',
    french: 'chauve-souris',
    spanish: 'murciélago (animal)',
  },
  {
    av: 12640,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + water (ground level): place where land touches water) - Character (superimposed)',
    english: 'beach, bank, coast, shore',
    swedish: 'strand, kust',
    norwegian: 'strand, kyst',
    finnish: 'ranta, rannikko',
    hungarian: 'vízpart',
    german: 'Strand, Ufer, Küste',
    dutch: 'strand',
    afrikaans: 'strand, kus, kuslyn',
    russian: 'берег, пляж',
    latvian: 'pludmale, piekraste, krasts',
    polish: 'plaża, brzeg, wybrzeże',
    french: "plage, bord de l'eau, côte, rive, rivage",
    spanish: 'playa, ribera, costa, orilla',
  },
  {
    av: 12642,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: cross section of bean in a pod) - Character ',
    english: 'bean',
    swedish: 'böna',
    norwegian: 'bønne',
    finnish: 'papu',
    hungarian: 'bab',
    german: 'Bohne',
    dutch: 'boon',
    afrikaans: 'boontjie',
    russian: 'боб',
    latvian: 'pupa',
    polish: 'fasola',
    french: 'haricot, fève, grain',
    spanish: 'alubia, grano',
  },
  {
    av: 12644,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(face with beard + pointer, to beard) - Character (superimposed - pointer)',
    english: 'beard',
    swedish: 'skägg',
    norwegian: 'skjegg',
    finnish: 'parta',
    hungarian: 'szakáll',
    german: 'Bart',
    dutch: 'baard',
    afrikaans: 'baard',
    russian: 'борода',
    latvian: 'bārda',
    polish: 'broda',
    french: 'barbe',
    spanish: 'barba',
  },
  {
    av: 12649,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a bed with a pillow at the head) - Character',
    english: 'bed',
    swedish: 'säng, bädd',
    norwegian: 'seng',
    finnish: 'sänky, vuode',
    hungarian: 'ágy',
    german: 'Bett',
    dutch: 'bed',
    afrikaans: 'bed, kooi, katel',
    russian: 'кровать',
    latvian: 'gulta',
    polish: 'łóżko',
    french: 'lit',
    spanish: 'cama',
  },
  {
    av: 12655,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(insect + pictograph of wing cases [hard shell]) - Character (superimposed)',
    english: 'beetle',
    swedish: 'skalbagge',
    norwegian: 'bille',
    finnish: 'kovakuoriainen',
    hungarian: 'bogár',
    german: 'Käfer (Insekt)',
    dutch: 'kever',
    afrikaans: 'kewer, besie',
    russian: 'жук',
    latvian: 'vabole',
    polish: 'chrząszcz, żuk',
    french: 'scarabée, coléoptère',
    spanish: 'escarabajo',
  },
  {
    av: 12656,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(dot + reference line: the dot comes before the reference line. This symbol refers to both time and space.) - Character (sequenced)',
    english: 'before, in front of, prior to',
    swedish: 'före, framför',
    norwegian: 'foran, før',
    finnish: 'ennen, edessä',
    hungarian: 'előtt, előzőleg',
    german: 'vor, früher als, im Vorfeld',
    dutch: 'voor',
    afrikaans: 'voor, voorafgaande',
    russian: 'перед, впереди',
    latvian: 'iepriekš, agrāk, priekšā, pirms kaut kā',
    polish: 'przed czymś, z przodu, najpierw',
    french: 'avant, devant, antérieur à',
    spanish: 'antes, antes de, frente a, delante',
  },
  {
    av: 12658,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(reference line + forward: advancing arrow begins at the reference line) - Character (superimposed)',
    english: 'beginning, start',
    swedish: 'början, start',
    norwegian: 'start, begynnelse, innledning',
    finnish: 'alku',
    hungarian: 'kezdet, indulás, start',
    german: 'Anfang, Beginn, Start',
    dutch: 'begin, start',
    afrikaans: 'begin',
    russian: 'начало',
    latvian: 'sākums, starts',
    polish: 'początek, start',
    french: 'commencement',
    spanish: 'comienzo',
  },
  {
    av: 12663,
    group: 'character',
    pos: 'GRAY',
    derivationExplanation:
      '(addition [half-sized, modification, with the crossbar located on the earthline]) - Character - (modified)',
    english: 'belongs to, of (possessive)',
    swedish: 'tillhör, hör ihop med...',
    norwegian: 'tilhørende (eiendomspronomen)',
    finnish: 'kuulua johonkin',
    hungarian: 'é (birtokjel; pl. valakié, valamié)',
    german: 'gehört zu (possessiv)',
    dutch: 'van, en, plus',
    afrikaans: 'van, en, plus (besitlik)',
    russian: 'принадлежать',
    latvian: 'piederēt',
    polish: 'należy do (rzeczy, dobytek)',
    french: 'de (possessif), appartenance',
    spanish: 'pertenece a, de (posesivo)',
  },
  {
    av: 12666,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a berry with a curved stem, in the position it would have if protruding from a bush) - Character',
    english: 'berry',
    swedish: 'bär',
    norwegian: 'bær',
    finnish: 'marja',
    hungarian: 'bogyó (mindenféle bogyós termésű gyümölcs)',
    german: 'Beere',
    dutch: 'bes',
    afrikaans: 'bessie',
    russian: 'ягода',
    latvian: 'oga',
    polish: 'jagoda',
    french: 'baie',
    spanish: 'baya',
  },
  {
    av: 12669,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(two reference lines + dot, between them) - Character (sequenced)',
    english: 'between',
    swedish: 'mellan',
    norwegian: 'mellom',
    finnish: 'välissä',
    hungarian: 'között, közte',
    german: 'zwischen',
    dutch: 'tussen',
    afrikaans: 'tussen, tussen-in',
    russian: 'между',
    latvian: 'starp',
    polish: 'między',
    french: 'entre',
    spanish: 'entre (dos personas o cosas)',
  },
  {
    av: 12837,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests the wings and feet of a bird) - Character',
    english: 'bird',
    swedish: 'fågel',
    norwegian: 'fugl',
    finnish: 'lintu',
    hungarian: 'madár',
    german: 'Vogel',
    dutch: 'vogel',
    afrikaans: 'voël',
    russian: 'птица',
    latvian: 'putns',
    polish: 'ptak',
    french: 'oiseau',
    spanish: 'pájaro, ave',
  },
  {
    av: 12840,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(bird + water [modification, under earthline]: aquatic bird) - Character (superimposed - modified)',
    english: 'duck, bird (water), waterbird, waterfowl, seabird, seafowl',
    swedish: 'and, anka, sjöfågel',
    norwegian: 'and, sjøfugl, vadefugl',
    finnish: 'vesilintu, ankka',
    hungarian: 'vízimadár, vízi szárnyas, pl. kacsa, tengeri madár',
    german: 'Ente, Wasservogel',
    dutch: 'eend, watervogel',
    afrikaans: 'eend, gans, seemeeu, voël (water)',
    russian: 'утка, водоплавающая птица',
    latvian: 'pīle, savvaļas pīle, ūdensputns, jūras putns',
    polish: 'kaczka, gęś, ptak wodny',
    french: 'oiseau aquatique, canard',
    spanish: 'pato, ave (acuática), ave marina',
  },
  {
    av: 12842,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(fetus [modification, opening in body] + down, downward [modification]: combination illustrating the birth of a baby) - Character (superimposed - modified - combined)',
    english: 'birth, giving birth, parturition, delivery',
    swedish: 'födelse, födande',
    norwegian: 'forløsning, fødsel',
    finnish: 'syntymä',
    hungarian: 'születés, megszületés, világra jövetel',
    german: 'Geburt, Entbindung',
    dutch: 'geboorte, bevalling',
    afrikaans: 'geboorte, bevalling, kraam',
    russian: 'рождение, роды',
    latvian: 'dzemdības',
    polish: 'urodziny, narodziny (reprodukcja)',
    french: 'naissance (reproduction)',
    spanish: 'nacimiento (reproducción)',
  },
  {
    av: 12843,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(protection, shelter + star: someone new under the roof. CKB points out that newspapers often use a star to denote a birth.) - Character (superimposed)',
    english: 'birth',
    swedish: 'födelse',
    norwegian: 'fødsel',
    finnish: 'syntymä',
    hungarian: 'születés (régi CKB jelkép)',
    german: 'Geburt',
    dutch: 'geboorte',
    afrikaans: 'geboorte, gebore',
    russian: 'рождение',
    latvian: 'dzemdības',
    polish: 'urodziny, narodziny',
    french: 'naissance (ckb)',
    spanish: 'nacimiento',
  },
  {
    av: 12857,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(world + pen: writing for the world) - Character (superimposed)',
    english: 'blissymbol, Bliss-word',
    swedish: 'blissymbol',
    norwegian: 'blissymbol',
    finnish: 'bliss-symboli',
    hungarian: 'Bliss-jelkép',
    german: 'BLISS-Symbol',
    dutch: 'Bliss-symbool',
    afrikaans: 'blissimbool',
    russian: 'блиссимвол',
    latvian: 'simbols bliss',
    polish: 'symbol bliss',
    french: 'symbole Bliss',
    spanish: 'símbolo Bliss',
  },
  {
    av: 12860,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a three-dimensional block. It is half the size of box.) - Character',
    english: 'block, brick',
    swedish: 'kloss',
    norwegian: 'kloss',
    finnish: 'palikka, noppa',
    hungarian: 'kőkocka, tégla',
    german: 'Klotz, Block',
    dutch: 'blok, kubus',
    afrikaans: 'blok, kubus',
    russian: 'кубик, блок',
    latvian: 'klucis, ķieģelis',
    polish: 'blok, cegła',
    french: 'bloc, brique',
    spanish: 'bloque, ladrillo',
  },
  {
    av: 12868,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(table + pointer, to underside: the top of a table is frequently made of boards) - Character (superimposed - pointer)',
    english: 'board (material)',
    swedish: 'platta, skiva (material)',
    norwegian: 'plate, planke (materiale)',
    finnish: 'pöytälevy',
    hungarian: 'deszka, deszkalap, asztallap',
    german: 'Brett, Bohle',
    dutch: 'tafelblad',
    afrikaans: 'tafelblad, rakblad',
    russian: 'доска (материал)',
    latvian: 'dēlis (materiāls)',
    polish: 'blat, deska (stołu, biurka)',
    french: 'panneau, planche (matériel)',
    spanish: 'tablero (material)',
  },
  {
    av: 12869,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a boat with a mast and also incorporates container.) - Character',
    english: 'boat, ship',
    swedish: 'båt, fartyg, skepp',
    norwegian: 'båt, skip',
    finnish: 'vene, laiva',
    hungarian: 'hajó, csónak',
    german: 'Boot, Schiff',
    dutch: 'boot, schip',
    afrikaans: 'boot, skip',
    russian: 'лодка, корабль',
    latvian: 'liellaiva, kuģis',
    polish: 'łódź, statek',
    french: 'bateau',
    spanish: 'barco, bote',
  },
  {
    av: 12870,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests the trunk of the body, without head and limbs. The symbol may be used for body in a general sense.) - Character',
    english: 'body, trunk',
    swedish: 'kropp',
    norwegian: 'kropp',
    finnish: 'keho, vartalo',
    hungarian: 'test, törzs (emberi)',
    german: 'Körper',
    dutch: 'lichaam, lijf',
    afrikaans: 'liggaam, lyf',
    russian: 'тело, туловище',
    latvian: 'ķermenis, rumpis',
    polish: 'ciało, tułów',
    french: 'corps',
    spanish: 'cuerpo, torso',
  },
  {
    av: 12873,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a bone shaft with ends) - Character',
    english: 'bone',
    swedish: 'ben (skelett-)',
    norwegian: 'bein, knokkel',
    finnish: 'luu, ruoto',
    hungarian: 'csont',
    german: 'Knochen',
    dutch: 'bot',
    afrikaans: 'been',
    russian: 'кость',
    latvian: 'kauls',
    polish: 'kość',
    french: 'os',
    spanish: 'hueso',
  },
  {
    av: 12875,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests an open book. It can also be explained as: two page symbols.) - Character',
    english: 'book',
    swedish: 'bok',
    norwegian: 'bok',
    finnish: 'kirja',
    hungarian: 'könyv',
    german: 'Buch',
    dutch: 'boek',
    afrikaans: 'boek',
    russian: 'книга',
    latvian: 'grāmata',
    polish: 'książka',
    french: 'livre',
    spanish: 'libro',
  },
  {
    av: 12880,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: suggests bottle with body and neck) - Character',
    english: 'bottle, flask',
    swedish: 'flaska',
    norwegian: 'flaske',
    finnish: 'pullo',
    hungarian: 'palack, üveg, flaska',
    german: 'Flasche',
    dutch: 'fles',
    afrikaans: 'fles, bottel',
    russian: 'бутылка',
    latvian: 'pudele, blašķe',
    polish: 'butelka, kolba',
    french: 'bouteille, flacon, fiole',
    spanish: 'botella, frasco',
  },
  {
    av: 12881,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + pointer, to bottom) - Character (superimposed - pointer)',
    english: 'bottom, base',
    swedish: 'undersida',
    norwegian: 'bunn, underside',
    finnish: 'alapuoli, pohja',
    hungarian: 'alap, alapzat, vmi alja vagy feneke, bázis',
    german: 'Boden, Basis, Unterseite',
    dutch: 'bodem, onderkant',
    afrikaans: 'basis, bodem, onderkant',
    russian: 'дно, нижняя часть',
    latvian: 'apakšdaļa, dibens',
    polish: 'dno, podstawa',
    french: 'dessous, fond',
    spanish: 'fondo, base',
  },
  {
    av: 12882,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'bow (knot)',
    swedish: 'rosett (etc)',
    norwegian: 'sløyfe, rosett (o.l.)',
    finnish: 'rusetti',
    hungarian: 'csokor, kötött csomó',
    german: 'Schleife',
    dutch: 'strik',
    afrikaans: 'strik',
    russian: 'бант',
    latvian: 'sasieta lente (mezgls)',
    polish: 'splot (węzeł)',
    french: 'nœud',
    spanish: 'moño (nudo)',
  },
  {
    av: 12886,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a three-dimensional box) - Character',
    english: 'box, cube',
    swedish: 'låda, kub',
    norwegian: 'eske, kasse',
    finnish: 'laatikko',
    hungarian: 'doboz, kocka',
    german: 'Schachtel, Kasten, Kiste, Würfel',
    dutch: 'doos',
    afrikaans: 'boks, kubus',
    russian: 'коробка, куб',
    latvian: 'kārba, kaste',
    polish: 'pudło, sześcian',
    french: 'boîte, cube',
    spanish: 'caja, cubo',
  },
  {
    av: 12888,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(child + male (combination)) - Character (superimposed - combined)',
    english: 'boy, lad',
    swedish: 'pojke, pojk, kille, grabb',
    norwegian: 'gutt',
    finnish: 'poika',
    hungarian: 'fiú, srác',
    german: 'Junge, Knabe, Bube, Bub',
    dutch: 'jongen',
    afrikaans: 'seun',
    russian: 'мальчик',
    latvian: 'puika, puisis',
    polish: 'chłopiec, chłopak',
    french: 'garçon',
    spanish: 'niño, muchacho',
  },
  {
    av: 12894,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(tree + pointer, to branch) - Character (superimposed - pointer)',
    english: 'branch',
    swedish: 'gren, kvist',
    norwegian: 'grein, kvist',
    finnish: 'oksa',
    hungarian: 'faág',
    german: 'Ast, Zweig',
    dutch: 'tak',
    afrikaans: 'tak',
    russian: 'ветка',
    latvian: 'zars',
    polish: 'gałąź',
    french: 'branche',
    spanish: 'rama',
  },
  {
    av: 12895,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a loaf of bread) - Character',
    english: 'bread, loaf of bread, loaf',
    swedish: 'bröd',
    norwegian: 'brød',
    finnish: 'leipä',
    hungarian: 'kenyér, cipó, vekni, kenyércipó',
    german: 'Brot, Laib',
    dutch: 'brood',
    afrikaans: 'brood',
    russian: 'хлеб',
    latvian: 'maize, maizes klaips',
    polish: 'pieczywo, chleb',
    french: 'pain',
    spanish: 'pan',
  },
  {
    av: 12899,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(body + two pointers, to breasts) - Character (superimposed - pointer)',
    english: 'breast(s)',
    swedish: 'bröst',
    norwegian: 'bryst',
    finnish: 'rinnat, rinta',
    hungarian: 'mell',
    german: 'Brust, Busen',
    dutch: 'borsten',
    afrikaans: 'borste',
    russian: 'грудь',
    latvian: 'krūtis',
    polish: 'piersi',
    french: 'seins, poitrine',
    spanish: 'pechos',
  },
  {
    av: 12902,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth [modification, half-sized] + bow, arc + earth [half-sized]: the symbol suggests a bridge between two banks of a river) - Character (superimposed – modified)',
    english: 'bridge, overpass',
    swedish: 'bro',
    norwegian: 'bro',
    finnish: 'silta',
    hungarian: 'híd, felüljáró',
    german: 'Brücke',
    dutch: 'brug',
    afrikaans: 'brug',
    russian: 'мост',
    latvian: 'tilts, pāreja',
    polish: 'most, wiadukt',
    french: 'pont',
    spanish: 'puente',
  },
  {
    av: 12908,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a broom) - Character',
    english: 'broom',
    swedish: 'kvast',
    norwegian: 'kost',
    finnish: 'luuta',
    hungarian: 'seprű',
    german: 'Besen',
    dutch: 'bezem, veegborstel, borstel, stoffer (Nl)',
    afrikaans: 'besem',
    russian: 'метла, веник',
    latvian: 'slota',
    polish: 'miotła',
    french: 'balai',
    spanish: 'escoba',
  },
  {
    av: 12912,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a brush in an upright position) - Character',
    english: 'brush',
    swedish: 'borste, pensel',
    norwegian: 'pensel, børste',
    finnish: 'harja, sivellin',
    hungarian: 'kefe',
    german: 'Bürste',
    dutch: 'borstel, bezem',
    afrikaans: 'borsel',
    russian: 'щётка, кисточка',
    latvian: 'birste, slota, ota, suka',
    polish: 'szczotka',
    french: 'brosse (habit, cheveux)',
    spanish: 'cepillo',
  },
  {
    av: 12916,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(gas + pointer, to bubble) - Character (superimposed - pointer)',
    english: 'bubble',
    swedish: 'bubbla',
    norwegian: 'boble',
    finnish: 'kupla, pore',
    hungarian: 'buborék',
    german: 'Blase',
    dutch: 'luchtbel, gasbel',
    afrikaans: 'borrel',
    russian: 'пузырь, пузырёк',
    latvian: 'burbulis',
    polish: 'bańka',
    french: 'bulle',
    spanish: 'burbuja',
  },
  {
    av: 12917,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(bovine + hump) - Character (superimposed)',
    english: 'buffalo, bison',
    swedish: 'bisonoxe, buffel',
    norwegian: 'bøffel, bisonokse',
    finnish: 'biisoni, puhveli',
    hungarian: 'bivaly, bölény, bison',
    german: 'Bison, Büffel',
    dutch: 'bizon, buffel',
    afrikaans: 'buffel, bison',
    russian: 'буйвол, бизон',
    latvian: 'bifelis, bizons',
    polish: 'żubr, bizon',
    french: 'buffle, bison',
    spanish: 'búfalo, bisonte',
  },
  {
    av: 12919,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(bulbous plant + pointer, to bulb) - Character (superimposed - pointer)',
    english: 'bulb (flower)',
    swedish: 'blomsterlök',
    norwegian: 'blomsterløk',
    finnish: 'kukkasipuli',
    hungarian: 'virághagyma',
    german: 'Blumenzwiebel',
    dutch: 'bloembol',
    afrikaans: 'knol, bol (blom)',
    russian: 'цветочная луковица',
    latvian: 'sīpols (puķes)',
    polish: 'cebula (kwiat)',
    french: 'bulbe (fleur)',
    spanish: 'bulbo (flor)',
  },
  {
    av: 13089,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vehicle (long) + pictograph of a steering wheel: suggests a bus with many wheels and a steering wheel) - Character (superimposed)',
    english: 'bus, coach',
    swedish: 'buss',
    norwegian: 'buss',
    finnish: 'linja-auto, bussi',
    hungarian: 'autóbusz, busz',
    german: 'Bus',
    dutch: 'bus, autobus',
    afrikaans: 'bus, wa',
    russian: 'автобус',
    latvian: 'autobuss, tālsatiksmes autobuss',
    polish: 'autobus',
    french: 'bus',
    spanish: 'autobús',
  },
  {
    av: 13092,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: small tree growing close to the ground) - Character',
    english: 'bush, shrub',
    swedish: 'buske',
    norwegian: 'busk',
    finnish: 'pensas',
    hungarian: 'fa, cserje',
    german: 'Strauch, Busch, Gebüsch',
    dutch: 'struik',
    afrikaans: 'struik',
    russian: 'куст',
    latvian: 'krūms',
    polish: 'krzak, krzew',
    french: 'buisson, taillis, arbuste',
    spanish: 'arbusto',
  },
  {
    av: 13093,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(money + to hold: money is taken into the till) - Character (superimposed)',
    english: 'business, economy, commerce, trade',
    swedish: 'handel',
    norwegian: 'handel',
    finnish: 'liiketoiminta, kaupankäynti',
    hungarian: 'kereskedelem, biznisz',
    german: 'Handel',
    dutch: 'handel',
    afrikaans: 'ekonomie, kommersiële handel, besigheid',
    russian: 'бизнес, торговля',
    latvian: 'bizness, komercija, tirdzniecība',
    polish: 'biznes, handel, sprzedaż',
    french: 'commerce',
    spanish: 'el comercio, negocio',
  },
  {
    av: 13094,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(CKB likens the but that halts a free flow of speech to a vertical line that stops a horizontal flowing line) - Character',
    english: 'but, except',
    swedish: 'men',
    norwegian: 'men, unntatt',
    finnish: 'mutta, paitsi',
    hungarian: 'de',
    german: 'aber, außer',
    dutch: 'behalve',
    afrikaans: 'maar, behalwe',
    russian: 'но, однако',
    latvian: 'bet, izņemot',
    polish: 'ale, z wyjątkiem',
    french: 'mais, cependant, toutefois',
    spanish: 'pero, excepto',
  },
  {
    av: 13096,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a butterfly or a moth) - Character',
    english: 'butterfly, moth',
    swedish: 'fjäril, mal',
    norwegian: 'sommerfugl, møll',
    finnish: 'perhonen',
    hungarian: 'lepke, pillangó, molylepke',
    german: 'Schmetterling, Motte',
    dutch: 'vlinder, mot',
    afrikaans: 'vlinder, mot',
    russian: 'бабочка',
    latvian: 'taurenis, naktstaurenis',
    polish: 'motyl, ćma',
    french: 'papillon',
    spanish: 'mariposa',
  },
  {
    av: 13097,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(standing person + pointer, to buttocks) - Character (superimposed - pointer)',
    english: 'buttocks, bottom, bum, rear, ass',
    swedish: 'stjärt',
    norwegian: 'rumpe, bakende',
    finnish: 'pakarat, takapuoli, pylly',
    hungarian: 'fenék, far, hátsó, segg',
    german: 'Po, Hintern, Arsch',
    dutch: 'billen, achterwerk, poep (Vl)',
    afrikaans: 'boude, agterstewe, gat',
    russian: 'зад, ягодица',
    latvian: 'sēžamvieta, dibens, pēcpuse, pakaļa',
    polish: 'pośladki, dół, tył, tyłek',
    french: 'fesses, croupe, derrière',
    spanish: 'nalgas',
  },
  {
    av: 13100,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(relation [half-sized], pointing backwards) - Character',
    english: 'by, by means of, of',
    swedish: 'av',
    norwegian: 'ved, av, hos',
    finnish: 'joltakin, jostakin (asiasta)',
    hungarian: 'nak a, -nek a (birtokviszonyt kifejező rag)',
    german: 'von, durch',
    dutch: 'van',
    afrikaans: 'deur, deur middel van, of',
    russian: 'у, при, около',
    latvian: 'caur kaut ko, kaut kādā veidā',
    polish: 'przez, z pomocą',
    french: 'par, en, de',
    spanish: 'por, por medio de',
  },
  {
    av: 13101,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph incorporating leafy vegetable) - Character (superimposed - combined)',
    english: 'cabbage',
    swedish: 'kål',
    norwegian: 'kål',
    finnish: 'kaali',
    hungarian: 'káposzta',
    german: 'Kohl',
    dutch: 'kool',
    afrikaans: 'kool',
    russian: 'капуста',
    latvian: 'kāposts',
    polish: 'kapusta',
    french: 'chou',
    spanish: 'col',
  },
  {
    av: 13110,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + pictograph of head and neck and two humps) - Character (superimposed)',
    english: 'camel',
    swedish: 'kamel',
    norwegian: 'kamel',
    finnish: 'kameli',
    hungarian: 'teve',
    german: 'Kamel',
    dutch: 'kameel',
    afrikaans: 'kameel',
    russian: 'верблюд',
    latvian: 'kamielis',
    polish: 'wielbłąd',
    french: 'chameau',
    spanish: 'camello',
  },
  {
    av: 13111,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure + light: box that uses the sunlight to record what the eye sees) - Character (superimposed)',
    english: 'camera',
    swedish: 'kamera',
    norwegian: 'fotoapparat, kamera',
    finnish: 'kamera',
    hungarian: 'fényképezőgép, filmfelvevő, kamera',
    german: 'Kamera, Fotoapparat',
    dutch: 'camera, fototoestel',
    afrikaans: 'kamera',
    russian: 'фотоаппарат',
    latvian: 'fotoaparāts',
    polish: 'kamera fotograficzna, aparat',
    french: 'appareil photographique, caméra',
    spanish: 'cámara',
  },
  {
    av: 13113,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vehicle + house [modification, high position] (combination)) - Character (superimposed - modified - combined)',
    english: 'camper, caravan, mobile home',
    swedish: 'husvagn',
    norwegian: 'campingbil, campingvogn, bobil',
    finnish: 'asuntovaunu',
    hungarian: 'lakókocsi, kempingautó, karaván',
    german: 'Wohnwagen, Wohnanhänger, Campingwagen',
    dutch: 'caravan, camper, mobilhome',
    afrikaans: 'karavaan, kampeerwa, motorwoning',
    russian: 'автодом, кемпер',
    latvian: 'treileru mājas, karavānas, pārvietojamās mājas',
    polish: 'przyczepa kempingowa',
    french: 'caravane, camping-car',
    spanish: 'rulot, caravana, casa rodante',
  },
  {
    av: 13115,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'cylinder, can',
    swedish: 'burk, rulle, cylinder',
    norwegian: 'kanne, sylinder',
    finnish: 'tölkki, purkki, rasia, rulla, kannu',
    hungarian: 'konzervdoboz, bádogdoboz, henger',
    german: 'Dose, Büchse',
    dutch: 'cilinder',
    afrikaans: 'silinder',
    russian: 'банка, цилиндр',
    latvian: 'metāla burka, cilindrs, kanna',
    polish: 'zbiornik, cylinder (pojemnik o cylindrycznym kształcie)',
    french: 'cylindre, canette',
    spanish: 'cilindro, lata',
  },
  {
    av: 13120,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph incorporating wheel and to destroy) - Character (superimposed)',
    english: 'cannon, gun',
    swedish: 'kanon',
    norwegian: 'kanon',
    finnish: 'tykki',
    hungarian: 'ágyú',
    german: 'Kanone, Waffe',
    dutch: 'kanon',
    afrikaans: 'kanon',
    russian: 'пушка',
    latvian: 'lielgabals',
    polish: 'armata, działo',
    french: 'canon',
    spanish: 'cañón, pistola',
  },
  {
    av: 13121,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vehicle + pictograph of a steering wheel: suggests a car with a steering wheel) - Character (superimposed)',
    english: 'car, automobile, motor vehicle',
    swedish: 'bil',
    norwegian: 'bil',
    finnish: 'auto',
    hungarian: 'autó, motoros jármű',
    german: 'Auto, Fahrzeug',
    dutch: 'auto',
    afrikaans: 'motor, kar, voertuig',
    russian: 'автомобиль, машина',
    latvian: 'mašīna, automašīna, automobīlis',
    polish: 'samochód, auto, pojazd silnikowy',
    french: 'voiture',
    spanish: 'coche, automóvil, vehículo',
  },
  {
    av: 13124,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vegetable below ground + pictograph of wedge shape (combination)) - Character (superimposed - combined)',
    english: 'carrot, vegetable (wedge-shaped)',
    swedish: 'morot, rotfrukt',
    norwegian: 'gulrot',
    finnish: 'porkkana',
    hungarian: 'sárgarépa, egyéb gyökérformájú zöldségféle',
    german: 'Möhre, Karotte, Mohrrübe',
    dutch: 'wortel',
    afrikaans: 'wortel (groente)',
    russian: 'морковь',
    latvian: 'burkāns, dārzenis ',
    polish: 'marchew, warzywo (w kształcie stożka)',
    french: 'carotte, légume poussant sous terre (forme allongée)',
    spanish: 'zanahoria, vegetal (en forma de cuña)',
  },
  {
    av: 13127,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(transport, transportation + forward [modification, short arrow, high position]: can also be interpreted as a combination of transport and to pull) - Character (superimposed - modified - combined)',
    english: 'cart, carriage',
    swedish: 'kärra, vagn',
    norwegian: 'kjerre, vogn',
    finnish: 'kärryt, rattaat',
    hungarian: 'kézikocsi, taliga, targonca, szekér, kordé, hintó',
    german: 'Wagen, Karren, Bollerwagen',
    dutch: 'kar',
    afrikaans: 'koets, wa',
    russian: 'телега, повозка',
    latvian: 'rati',
    polish: 'wóz, przewóz, transport towarowy',
    french: 'charrette, carriole',
    spanish: 'carreta, carruaje',
  },
  {
    av: 13128,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'cassette, audiocassette, videocassette',
    swedish: 'kassettband, videoband',
    norwegian: 'kassett, videokassett',
    finnish: 'kasetti, äänikasetti, videokasetti',
    hungarian: 'kazetta (video, audio)',
    german: 'Kassette, Musikkassette, Videokasette',
    dutch: 'cassette',
    afrikaans: 'kasset, videokasset, musiek kasset oudio',
    russian: 'кассета',
    latvian: 'kasete, audio kasete, video kasete',
    polish: 'kaseta, kaseta magnetofonowa, kaseta wideo',
    french: 'vidéocassette, cassette vidéo',
    spanish: 'casete, videocinta',
  },
  {
    av: 13134,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(wedge shape that incorporates relation: the wedge presses into the thing on which it has an effect). - Character See also: effect, result 13910',
    english: 'cause',
    swedish: 'orsak',
    norwegian: 'årsak',
    finnish: 'aihe, syy',
    hungarian: 'ok, indok, indítóok',
    german: 'Ursache',
    dutch: 'oorzaak',
    afrikaans: 'oorsaak',
    russian: 'причина',
    latvian: 'iemesls, cēlonis',
    polish: 'powód, przyczyna',
    french: 'cause',
    spanish: 'causa',
  },
  {
    av: 13138,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(teeth + dot) - Character (superimposed)',
    english: 'cavity, caries',
    swedish: 'hål (i tand)',
    norwegian: 'hull (i tann)',
    finnish: 'reikä hampaassa',
    hungarian: 'fogszuvasodás, lyukas fog',
    german: 'Loch im Zahn, Karies',
    dutch: 'gaatje (in tand)',
    afrikaans: 'holte, gaatjie (in tand)',
    russian: 'кариес',
    latvian: 'caurums, kariess',
    polish: 'próchnica, dziura w zębie',
    french: 'carie',
    spanish: 'cavidad, caries',
  },
  {
    av: 13139,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(room + pointer, to ceiling) - Character (superimposed - pointer)',
    english: 'ceiling',
    swedish: 'tak, innertak',
    norwegian: 'tak, innetak',
    finnish: 'katto',
    hungarian: 'mennyezet',
    german: 'Decke',
    dutch: 'plafond',
    afrikaans: 'plafon',
    russian: 'потолок',
    latvian: 'griesti',
    polish: 'sufit, strop, pułap',
    french: 'plafond',
    spanish: 'techo',
  },
  {
    av: 13140,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vegetable above ground [modification] + pictograph of a cluster of stalks) - Character (superimposed - combined - modified)',
    english: 'celery',
    swedish: 'bladselleri',
    norwegian: 'selleri, bladselleri',
    finnish: 'selleri',
    hungarian: 'zeller',
    german: 'Sellerie',
    dutch: 'selder (Vl), selderij',
    afrikaans: 'seldery',
    russian: 'сельдерей',
    latvian: 'kātu selerijas',
    polish: 'seler (nać)',
    french: 'céleri',
    spanish: 'apio',
  },
  {
    av: 13143,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(international symbol for cent) - Character',
    english: 'cent',
    swedish: 'cent',
    norwegian: 'cent',
    finnish: 'sentti',
    hungarian: 'cent (átvitt értelemben garas, fillér)',
    german: 'Cent',
    dutch: 'cent',
    afrikaans: 'sent',
    russian: 'цент',
    latvian: 'cents',
    polish: 'cent',
    french: 'cent, centime',
    spanish: 'ciento, céntimo, centavo',
  },
  {
    av: 13145,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(dish + grain) - Character (superimposed)',
    english: 'cereal',
    swedish: 'flingor, müsli',
    norwegian: 'kornblanding, kornvarer',
    finnish: 'murot',
    hungarian: 'gabonapehely, müzli, cereália',
    german: 'Cornflakes, Müsli',
    dutch: 'ontbijtgranen',
    afrikaans: 'graan, ontbytgraan, gewas',
    russian: 'хлопья, мюсли',
    latvian: 'brokastu pārslas',
    polish: 'kasza, krupa, owsianka',
    french: 'céréale',
    spanish: 'cereal',
  },
  {
    av: 13148,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'chair, seat',
    swedish: 'stol',
    norwegian: 'stol',
    finnish: 'tuoli, istuin',
    hungarian: 'szék, ülés',
    german: 'Stuhl, Platz',
    dutch: 'stoel',
    afrikaans: 'stoel',
    russian: 'стул',
    latvian: 'krēsls, sēdvieta',
    polish: 'krzesło, stołek',
    french: 'chaise',
    spanish: 'silla, asiento',
  },
  {
    av: 13151,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(weather [modification]: CKB says that weather is ever-changing. Can also be interpreted as; life + water, ever-changing in state. The symbol represents change in a general sense.) - Character (superimposed - modified)',
    english: 'change, alteration, conversion',
    swedish: 'förändring, omväxling',
    norwegian: 'forandring, endring',
    finnish: 'muutos',
    hungarian: 'változás, változtatás, átalakulás, átalakítás, módosulás, módosítás',
    german: 'Änderung, Veränderung',
    dutch: 'verandering',
    afrikaans: 'verandering',
    russian: 'перемена, изменение',
    latvian: 'pārmaiņas, izmaiņas',
    polish: 'zmiana',
    french: 'changement',
    spanish: 'cambio, alteración',
  },
  {
    av: 13156,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(face + pointer, to cheek) - Character (superimposed - pointer)',
    english: 'cheek',
    swedish: 'kind',
    norwegian: 'kinn',
    finnish: 'poski',
    hungarian: 'arc, orca, pofa',
    german: 'Wange',
    dutch: 'wang',
    afrikaans: 'wang',
    russian: 'щека',
    latvian: 'vaigs',
    polish: 'policzek',
    french: 'joue',
    spanish: 'mejilla',
  },
  {
    av: 13157,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a wedge of cheese) - Character',
    english: 'cheese',
    swedish: 'ost',
    norwegian: 'ost',
    finnish: 'juusto',
    hungarian: 'sajt',
    german: 'Käse',
    dutch: 'kaas',
    afrikaans: 'kaas',
    russian: 'сыр',
    latvian: 'siers',
    polish: 'ser',
    french: 'fromage',
    spanish: 'queso',
  },
  {
    av: 13158,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph symbol suggests the outline of a chemical retort + thing [modification, lower position] (combinaton)) - Character (superimposed - modified - combined)',
    english: 'chemical product',
    swedish: 'kemisk produkt',
    norwegian: 'kjemisk produkt',
    finnish: 'kemiallinen tuote',
    hungarian: 'vegyszer, kémiai anyag',
    german: 'Chemieprodukt',
    dutch: 'chemisch product',
    afrikaans: 'chemiese produk',
    russian: 'химический продукт',
    latvian: 'ķimijas produkts',
    polish: 'substancja chemiczna, produkt chemiczny',
    french: 'produit chimique',
    spanish: 'producto químico',
  },
  {
    av: 13159,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(fruit + pit, stone [modification, lower position] + fruit [modification] + pit, stone [modification, lower position]: pictograph of cherries combined in a cluster) - Character (superimposed - modified - combined)',
    english: 'cherry, cherries',
    swedish: 'körsbär',
    norwegian: 'kirsebær',
    finnish: 'kirsikka',
    hungarian: 'cseresznye',
    german: 'Kirsche',
    dutch: 'kers',
    afrikaans: 'kersie',
    russian: 'вишня',
    latvian: 'ķirši',
    polish: 'wiśnie',
    french: 'cerises',
    spanish: 'cerezas',
  },
  {
    av: 13161,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: 'chest (body + pointer, to chest) - Character (superimposed - pointer)',
    english: 'chest',
    swedish: 'bröstkorg',
    norwegian: 'brystkasse, bringe',
    finnish: 'rinta, rintakehä',
    hungarian: 'mellkas',
    german: 'Brust, Brustkorb',
    dutch: 'borstkas, borst',
    afrikaans: 'bors, borskas',
    russian: 'грудная клетка',
    latvian: 'krūšukurvis',
    polish: 'klatka piersiowa',
    french: 'torse, poitrine',
    spanish: 'pecho',
  },
  {
    av: 13162,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'chest of drawers, bureau, dresser',
    swedish: 'byrå',
    norwegian: 'kommode',
    finnish: 'lipasto',
    hungarian: 'fiókosszekrény',
    german: 'Kommode',
    dutch: 'ladenkast, ladenblok',
    afrikaans: 'laaikas',
    russian: 'комод',
    latvian: 'kumode',
    polish: 'komoda, kredens, szafka z szufladami',
    french: 'commode',
    spanish: 'cómoda, tocador',
  },
  {
    av: 13166,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      "(flower + little (combination): CKB writes: A child is like a 'little flower'. The symbol also can be explained as a pictograph showing the head, arms, feet and body of a child.) - Character (superimposed - combined)",
    english: 'child, kid, youngster',
    swedish: 'barn',
    norwegian: 'barn',
    finnish: 'lapsi',
    hungarian: 'gyerek, gyerkőc',
    german: 'Kind',
    dutch: 'kind',
    afrikaans: 'kind, jongeling',
    russian: 'ребёнок',
    latvian: 'bērns, bērniņš',
    polish: 'dziecko, dzieciak, ',
    french: 'enfant',
    spanish: 'niño(a), chico(a), joven',
  },
  {
    av: 13168,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(building with chimney + pointer, to chimney) - Character (superimposed - pointer)',
    english: 'chimney',
    swedish: 'skorsten',
    norwegian: 'pipe, skorstein',
    finnish: 'savupiippu',
    hungarian: 'kémény',
    german: 'Schornstein, Kamin',
    dutch: 'schoorsteen, schouw',
    afrikaans: 'skoorsteen',
    russian: 'труба, дымоход',
    latvian: 'skurstenis',
    polish: 'komin',
    french: 'cheminée',
    spanish: 'chimenea',
  },
  {
    av: 13169,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(face + pointer, to chin) - Character (superimposed - pointer)',
    english: 'chin',
    swedish: 'haka',
    norwegian: 'hake',
    finnish: 'leuka',
    hungarian: 'áll (testrész)',
    german: 'Kinn',
    dutch: 'kin',
    afrikaans: 'ken',
    russian: 'подбородок',
    latvian: 'zods',
    polish: 'podbródek',
    french: 'menton',
    spanish: 'barbilla',
  },
  {
    av: 13175,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(comparative more + eye [modification, low position]: combination of eye and to divide [half-sized] and many: the eye makes a choice among many things) - Character (superimposed - modified - combined)',
    english: 'choice, selection, election',
    swedish: 'val, urval',
    norwegian: 'utvalg, valg',
    finnish: 'valinta, valikoima, vaali',
    hungarian: 'választás, kiválasztás',
    german: 'Wahl, Auswahl',
    dutch: 'keuze',
    afrikaans: 'keuse, seleksie, verkiesing',
    russian: 'выбор, выборы',
    latvian: 'izvēle',
    polish: 'wybór, dobór',
    french: 'choix',
    spanish: 'elección, selección',
  },
  {
    av: 13346,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(smoking (cigarette) + pointer, to cigarette) - Character (superimposed - pointer)',
    english: 'cigarette',
    swedish: 'cigarett',
    norwegian: 'sigarett',
    finnish: 'tupakka, savuke',
    hungarian: 'cigaretta',
    german: 'Zigarette',
    dutch: 'sigaret',
    afrikaans: 'sigaret',
    russian: 'сигарета',
    latvian: 'cigarete',
    polish: 'papieros',
    french: 'cigarette',
    spanish: 'cigarrillo',
  },
  {
    av: 13349,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + man + woman (combination): man or woman having a relationship to a country or territory) - Character (superimposed - combined)',
    english: 'citizen',
    swedish: 'invånare',
    norwegian: 'innbyggere',
    finnish: 'asukas, kansalainen',
    hungarian: 'állampolgár',
    german: 'Bürger, Bürgerin, Einwohner, Einwohnerin',
    dutch: 'burger',
    afrikaans: 'burger',
    russian: 'гражданин, житель',
    latvian: 'pilsonis',
    polish: 'obywatel',
    french: 'citoyen',
    spanish: 'ciudadano',
  },
  {
    av: 13354,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(feline + pointer, to claw) - Character (superimposed - pointer)',
    english: 'claw (animal)',
    swedish: 'klo (djur)',
    norwegian: 'klo (dyr)',
    finnish: 'kynsi (eläimen), eläimen kynsi',
    hungarian: 'karom',
    german: 'Tatze, Pfote',
    dutch: 'klauw',
    afrikaans: 'klou (dier)',
    russian: 'лапа (животное)',
    latvian: 'ķepa (dzīvnieka)',
    polish: 'pazur (zwierzę)',
    french: 'griffe',
    spanish: 'garra (animal)',
  },
  {
    av: 13355,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(bird + pictograph of claws + pointer, to claw) - Character (superimposed - pointer)',
    english: 'claw (bird)',
    swedish: 'klo (fågel)',
    norwegian: 'klo (fugl)',
    finnish: 'kynsi (linnun), linnunkynsi',
    hungarian: 'madárkarom',
    german: 'Kralle, Klaue',
    dutch: 'vogelpoot',
    afrikaans: 'klou (voël)',
    russian: 'коготь (птица)',
    latvian: 'nagi (putna)',
    polish: 'pazur, szpon (ptak)',
    french: 'griffe, serre',
    spanish: 'garra (ave)',
  },
  {
    av: 13365,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol looks like woven threads, suggesting cloth) - Character',
    english: 'cloth, fabric, material, textile, net',
    swedish: 'tyg',
    norwegian: 'tøy, tekstil',
    finnish: 'kangas',
    hungarian: 'textil, textilnemű, ruhaanyag, szövet, textilháló',
    german: 'Stoff, Tuch',
    dutch: 'weefsel, stof (textiel)',
    afrikaans: 'materiaal, tekstiel (stof), net, lap',
    russian: 'ткань',
    latvian: 'audums, materiāls, tekstīlija',
    polish: 'tkanina, materiał, tekstylia',
    french: 'tissu, étoffe',
    spanish: 'paño, tela, material textil, red',
  },
  {
    av: 13366,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + protection) - Character (superimposed)',
    english: 'clothing, clothes, garment',
    swedish: 'kläder',
    norwegian: 'klær',
    finnish: 'vaatteet, vaatetus',
    hungarian: 'ruha, ruházat, ruhanemű, öltözet, öltözék',
    german: 'Kleidung, Kleider, Sachen',
    dutch: 'kleding, kleren',
    afrikaans: 'klere, kleed',
    russian: 'одежда',
    latvian: 'apģērbs',
    polish: 'odzież, ubrania, ubiór',
    french: 'vêtement',
    spanish: 'ropa, vestimenta',
  },
  {
    av: 13367,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water + sky: formation of water droplets in the sky) - Character (superimposed)',
    english: 'cloud',
    swedish: 'moln',
    norwegian: 'sky',
    finnish: 'pilvi',
    hungarian: 'felhő',
    german: 'Wolke',
    dutch: 'wolk',
    afrikaans: 'wolk',
    russian: 'облако, туча',
    latvian: 'mākonis',
    polish: 'chmura',
    french: 'nuage',
    spanish: 'nube',
  },
  {
    av: 13378,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a side view of a comb) - Character',
    english: 'comb',
    swedish: 'kam',
    norwegian: 'kam',
    finnish: 'kampa',
    hungarian: 'fésű',
    german: 'Kamm',
    dutch: 'kam',
    afrikaans: 'kam',
    russian: 'расчёска',
    latvian: 'ķemme',
    polish: 'grzebień',
    french: 'peigne',
    spanish: 'peine',
  },
  {
    av: 13380,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(circle [half-sized] + circle [half-sized]: two interlocking circles) - Character (superimposed)',
    english: 'combination, connection',
    swedish: 'kombination',
    norwegian: 'kombinasjon',
    finnish: 'yhdistelmä',
    hungarian: 'összekapcsolás, kombináció, kapcsolat, kapcsolódás',
    german: 'Kombination, Verbindung',
    dutch: 'verbinding, combinatie',
    afrikaans: 'kombinasie, konneksie, konnekteer, verband',
    russian: 'комбинация',
    latvian: 'kombinācija, savienojums',
    polish: 'połączenie, złączenie, związek',
    french: 'combinaison, association, union, connexion, liaison',
    spanish: 'combinación, relación',
  },
  {
    av: 13382,
    group: 'character',
    pos: 'GRAY',
    derivationExplanation:
      '(circle [quarter-sized] + circle [quarter-sized]: two small interlocking circles ¼ space above skyline, used before and after a novel multi-character Bliss-word created by a user to represent a new meaning. This signals that a Bliss-word is not contained in the published Blissymbol Vocabulary.) - Character (superimposed)',
    english: 'combine marker',
    swedish: 'operator (kombination)',
    norwegian: 'indikator (kombinasjon)',
    finnish: 'yhdistelmän merkki',
    hungarian: 'összekapcsolás jele (nyelvtani indikátor)',
    german: 'Indikator (kombinieren)',
    dutch: 'combinatie-indicator',
    afrikaans: 'aanwyser (kombineer)',
    russian: 'индикатор (комбинация)',
    latvian: 'indikators (kombinēt)',
    polish:
      'wyznacznik znaków kombinowanych (umieszczany przed i po ciągu znaków tworzących hasło nienależące do głównego słownika bliss)',
    french: "indicateur d'association",
    spanish: 'indicador (combinar)',
  },
  {
    av: 13384,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(star [modification, on earthline] + curve, curved line: pictograph that suggests a star with a curved tail) - Character (superimposed - modified)',
    english: 'comet',
    swedish: 'komet',
    norwegian: 'komet',
    finnish: 'pyrstötähti',
    hungarian: 'üstökös',
    german: 'Komet',
    dutch: 'komeet',
    afrikaans: 'komeet',
    russian: 'комета',
    latvian: 'komēta',
    polish: 'kometa',
    french: 'comète',
    spanish: 'cometa',
  },
  {
    av: 13388,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph of two tablets of the laws: two tablets on which the ten commandments were inscribed) - Character',
    english: 'commandments',
    swedish: 'budorden',
    norwegian: 'bud',
    finnish: 'kymmenen käskyä',
    hungarian: 'tízparancsolat',
    german: 'Gebote',
    dutch: 'Tien Geboden',
    afrikaans: 'Tien Gebooie',
    russian: 'заповедь',
    latvian: 'baušļi',
    polish: 'Przykazania',
    french: 'commandements',
    spanish: 'mandamientos',
  },
  {
    av: 13395,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sperm + egg (combination)) - Character (superimposed - combined)',
    english: 'conception, fertilization, fertilized egg',
    swedish: 'befruktning, befruktat ägg',
    norwegian: 'befruktning, befruktet egg',
    finnish: 'hedelmöityminen, hedelmöitys',
    hungarian: 'fogamzás, megtermékenyítés, megtermékenyített pete',
    german: 'Befruchtung, die Befruchtung der Eizelle ',
    dutch: 'bevruchting',
    afrikaans: 'bevrugting',
    russian: 'оплодотворение',
    latvian: 'apaugļošana, apaugļota olšūna',
    polish: 'zapłodnienie',
    french: 'conception, fécondation',
    spanish: 'concepción, fertilización, huevo fertilizado',
  },
  {
    av: 13400,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests the outline of a cone) - Character',
    english: 'cone',
    swedish: 'kägla, kon',
    norwegian: 'kjegle',
    finnish: 'kartio',
    hungarian: 'kúp (mint alak, forma), tölcsér',
    german: 'Kegel, Konus',
    dutch: 'kegel',
    afrikaans: 'kegel',
    russian: 'конус',
    latvian: 'konuss',
    polish: 'stożek, rożek',
    french: 'cône',
    spanish: 'cono',
  },
  {
    av: 13401,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + mind [modification, at a higher level]: another level of consciousness super-imposed on the rational mind) - Character (superimposed - modified)',
    english: 'conscience',
    swedish: 'samvete',
    norwegian: 'samvittighet',
    finnish: 'omatunto',
    hungarian: 'lelkiismeret',
    german: 'Gewissen',
    dutch: 'geweten',
    afrikaans: 'gewete',
    russian: 'совеcть',
    latvian: 'sirdsapziņa',
    polish: 'sumienie',
    french: 'conscience',
    spanish: 'conciencia',
  },
  {
    av: 13403,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests the outline of a bowl) - Character',
    english: 'container, bowl, holder, pouch, basket',
    swedish: 'behållare, skål, korg (etc)',
    norwegian: 'bolle, beholder (o l)',
    finnish: 'astia, kulho, säilö',
    hungarian: 'tartály, tartóelem (bármi, ami tarthat valamit)',
    german: 'Schale, Schüssel, Behälter, Korb',
    dutch: 'houder, kom, mand',
    afrikaans: 'houer, bak, sak, mandjie',
    russian: 'ёмкость, контейнер',
    latvian: 'tvertne, rezervuārs, bļoda',
    polish: 'pojemnik, miska, zbiornik, worek',
    french: 'récipient, contenant, bol',
    spanish: 'contenedor, bol',
  },
  {
    av: 13413,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vegetable (oval-shaped) + dot + dot [modification, higher] + dot [modification, lower]: dots suggesting kernels of corn) - Character (superimposed - modified)',
    english: 'corn',
    swedish: 'majs',
    norwegian: 'mais',
    finnish: 'maissi',
    hungarian: 'kukorica',
    german: 'Mais',
    dutch: 'maïs',
    afrikaans: 'koring',
    russian: 'кукуруза',
    latvian: 'kukurūza',
    polish: 'kukurydza',
    french: 'maïs',
    spanish: 'maíz',
  },
  {
    av: 13414,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(room + pointer, to corner) - Character (superimposed - pointer)',
    english: 'corner (room)',
    swedish: 'hörn, hörna (rum)',
    norwegian: 'hjørne (rom)',
    finnish: 'nurkka',
    hungarian: 'sarok (helyiségé)',
    german: 'Ecke',
    dutch: 'hoek (kamer)',
    afrikaans: 'hoek (vertrek)',
    russian: 'угол',
    latvian: 'stūris',
    polish: 'róg, narożnik, kąt (pomieszczenia)',
    french: 'coin, angle',
    spanish: 'esquina, rincón',
  },
  {
    av: 13419,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a couch with a reclining back) - Character',
    english: 'couch, chesterfield, sofa',
    swedish: 'soffa',
    norwegian: 'sofa',
    finnish: 'sohva',
    hungarian: 'dívány, kanapé, pamlag, szófa',
    german: 'Sofa',
    dutch: 'sofa, zetel (Vl), fauteuil',
    afrikaans: 'rusbank, sofa',
    russian: 'диван',
    latvian: 'dīvāns',
    polish: 'kanapa, sofa, leżanka',
    french: 'canapé, divan',
    spanish: 'sofá',
  },
  {
    av: 13423,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(flag + earth: territory identified by a flag) See also: countryside, country, nature 13424. - Character (superimposed)',
    english: 'country, state',
    swedish: 'land, stat',
    norwegian: 'land, stat',
    finnish: 'valtio, maa',
    hungarian: 'ország, állam',
    german: 'Staat, (Bundes)Land',
    dutch: 'land, staat',
    afrikaans: 'land, staat',
    russian: 'страна',
    latvian: 'valsts, pavalsts, štats',
    polish: 'kraj, państwo',
    french: 'pays',
    spanish: 'país, estado',
  },
  {
    av: 13424,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(tree + earth: place where trees dominate the landscape) See also: country, state 13423 - Character (superimposed)',
    english: 'countryside, country, nature',
    swedish: 'landsbygd, landet',
    norwegian: 'landsbygd, på landet',
    finnish: 'maaseutu',
    hungarian: 'vidék, vidéki táj',
    german: 'Landschaft, Gegend, Land',
    dutch: 'platteland',
    afrikaans: 'platteland',
    russian: 'сельская местность',
    latvian: 'lauki',
    polish: 'krajobraz (wiejski, leśny)',
    french: 'campagne',
    spanish: 'campo, campiña',
  },
  {
    av: 13425,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(man + woman) - Character (superimposed)',
    english: 'couple (heterosexual)',
    swedish: 'par (heterosex.)',
    norwegian: 'par (heteroseksuelt)',
    finnish: 'pari, pariskunta',
    hungarian: 'pár (férfi, nő)',
    german: '(heterosexuelles) Pärchen',
    dutch: 'stel, paar',
    afrikaans: 'paartjie (heteroseksueel)',
    russian: 'пара (гетеросексуальная)',
    latvian: 'pāris (heteroseksuālas personas)',
    polish: 'para (heteroseksualna)',
    french: 'couple (hétérosexuel)',
    spanish: 'pareja (heterosexual)',
  },
  {
    av: 13427,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(man + protection + woman: a man and a woman living under one roof) - Character (superimposed)',
    english: 'family, couple',
    swedish: 'familj, makar, sambopar',
    norwegian: 'ektepar, ektefeller',
    finnish: 'aviopari',
    hungarian: 'család, pár',
    german: 'Familie, Paar, Ehepaar ',
    dutch: 'echtpaar, koppel (man en vrouw)',
    afrikaans: 'egpaar',
    russian: 'пара (супруги, сожители)',
    latvian: 'ģimene, pāris',
    polish: 'para (konkubinat)',
    french: 'couple (cohabitant)',
    spanish: 'pareja (de hecho)',
  },
  {
    av: 13607,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(equal-sided triangle: CKB points out that the Greeks considered the equal-sided triangle to be the simplest and most harmonious geometrical creation, and proof that the world is not chaos, but organized according to harmonious lines) - Character',
    english: 'creation, nature',
    swedish: 'skapelse, natur',
    norwegian: 'skapelse, natur',
    finnish: 'luonto, luominen, luomakunta',
    hungarian: 'természet, teremtés, alkotás',
    german: 'Schöpfung, Natur',
    dutch: 'natuur, schepping, creatie',
    afrikaans: 'skepping, natuur',
    russian: 'создание, природа',
    latvian: 'radība, daba',
    polish: 'kreacja, stworzenie, natura',
    french: 'création, nature',
    spanish: 'creación, naturaleza',
  },
  {
    av: 13613,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph, of a cross: symbol for Christianity) - Character',
    english: 'cross, Christianity (in combinations)',
    swedish: 'kors, kristendom (i kombination)',
    norwegian: 'kors, kristendom (i kombinasjon)',
    finnish: 'risti',
    hungarian: 'kereszt (jelképösszetételben: kereszténység)',
    german: 'Kreuz, Christenheit (in Kombination)',
    dutch: 'Christelijk (in combinatie), kruis',
    afrikaans: 'kruis, Christenskap (in kombinase)',
    russian: 'крест, христианство (в комбинации)',
    latvian: 'krusts, kristietība',
    polish: 'krzyż',
    french: 'croix (christianisme)',
    spanish: 'cruz, Cristianismo (en combinaciones)',
  },
  {
    av: 13615,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(body + pointer, to crotch) - Character (superimposed - pointer)',
    english: 'crotch',
    swedish: 'skrev, underliv',
    norwegian: 'skritt, underliv',
    finnish: 'haarat, alavatsa',
    hungarian: 'ágyék',
    german: 'Schoß, Schritt',
    dutch: 'kruis (lichaamsdeel)',
    afrikaans: 'kruis (liggaamsdeel)',
    russian: 'промежность, пах',
    latvian: 'kājstarpe',
    polish: 'krocze',
    french: 'entre-jambes',
    spanish: 'entrepierna',
  },
  {
    av: 13619,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + pictograph, of the plane facet-like faces of a crystal) - Character (superimposed)',
    english: 'crystal',
    swedish: 'kristall',
    norwegian: 'krystall',
    finnish: 'kristalli, kide',
    hungarian: 'kristály',
    german: 'Kristall',
    dutch: 'kristal',
    afrikaans: 'kristal',
    russian: 'кристалл',
    latvian: 'kristāls',
    polish: 'kryształ',
    french: 'cristal',
    spanish: 'cristal',
  },
  {
    av: 13621,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a cup or a glass with a handle) - Character',
    english: 'mug, cup',
    swedish: 'mugg, kopp',
    norwegian: 'kopp, krus',
    finnish: 'muki, kuppi',
    hungarian: 'bögre, csésze',
    german: 'Tasse, Becher',
    dutch: 'beker, kopje, mok, tas (Vl)',
    afrikaans: 'koppie, beker',
    russian: 'кружка',
    latvian: 'krūze, tasīte',
    polish: 'kubek',
    french: 'tasse, chope',
    spanish: 'taza',
  },
  {
    av: 13622,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests double doors of a cupboard/closet) - Character',
    english: 'cupboard, closet, wardrobe',
    swedish: 'skåp, garderob',
    norwegian: 'skap, garderobe',
    finnish: 'kaappi',
    hungarian: 'szekrény (konyha-, ruhás, gardrób)',
    german: 'Schrank',
    dutch: 'kast',
    afrikaans: 'klerekas, kas, hangkas',
    russian: 'шкаф, шкаф для одежды',
    latvian: 'skapis, skapītis, trauku skapis, drēbju skapis',
    polish: 'szafka, szafa',
    french: 'armoire',
    spanish: 'armario',
  },
  {
    av: 13623,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph of cluster of currants) - Character',
    english: 'currant(s)',
    swedish: 'vinbär',
    norwegian: 'rips, solbær',
    finnish: 'viinimarja, herukka',
    hungarian: 'ribiszke, ribizli',
    german: 'Johannisbeeren',
    dutch: 'krenten',
    afrikaans: 'korente',
    russian: 'смородина',
    latvian: 'upenes, jāņogas',
    polish: 'porzeczka',
    french: 'groseilles',
    spanish: 'pasas de Corinto',
  },
  {
    av: 13626,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a curtained window) - Character',
    english: 'curtain(s), drape(s)',
    swedish: 'gardin, draperi',
    norwegian: 'gardin',
    finnish: 'verhot',
    hungarian: 'függöny',
    german: 'Vorhang, Gardine',
    dutch: 'gordijn',
    afrikaans: 'gordyn',
    russian: 'занавеска',
    latvian: 'aizkari, drapērijas',
    polish: 'kurtyna, zasłony, draperie',
    french: 'rideau',
    spanish: 'cortinas',
  },
  {
    av: 13627,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'curve, curved line',
    swedish: 'båge, krök, kurva',
    norwegian: 'bue, kurve',
    finnish: 'kaari, kaarre',
    hungarian: 'görbe, görbe vonal, görbület',
    german: 'Kurve, Kurvenlinie',
    dutch: 'curve, ronding',
    afrikaans: 'ronding, geboë lyn',
    russian: 'дуга, кривая',
    latvian: 'loks, liekta līnija, pagrieziens',
    polish: 'łuk, zakręt, krzywa',
    french: 'courbe (ligne)',
    spanish: 'curva, línea curva',
  },
  {
    av: 13632,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(creation + intensity: CKB says that this symbol implies that we must take care that we do not harm ourselves or others, since we are all part of a divine Creation) - Character (superimposed)',
    english: 'danger',
    swedish: 'fara',
    norwegian: 'fare',
    finnish: 'vaara',
    hungarian: 'veszély, vész',
    german: 'Gefahr',
    dutch: 'gevaar',
    afrikaans: 'gevaar',
    russian: 'опасность',
    latvian: 'briesmas',
    polish: 'niebezpieczeństwo, Uwaga!',
    french: 'danger',
    spanish: 'peligro',
  },
  {
    av: 13638,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(protection + female: female born under the family roof) - Character (superimposed)',
    english: 'daughter',
    swedish: 'dotter',
    norwegian: 'datter',
    finnish: 'tytär',
    hungarian: 'lánya (valakinek)',
    german: 'Tochter',
    dutch: 'dochter',
    afrikaans: 'dogter',
    russian: 'дочь',
    latvian: 'meita',
    polish: 'córka',
    french: 'fille (lien de parenté)',
    spanish: 'hija',
  },
  {
    av: 13639,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sun + earth: sun appears above the horizon; it shines on the earth during the day) - Character (superimposed)',
    english: 'day',
    swedish: 'dag',
    norwegian: 'dag',
    finnish: 'päivä',
    hungarian: 'nap',
    german: 'Tag',
    dutch: 'dag',
    afrikaans: 'dag',
    russian: 'день',
    latvian: 'diena',
    polish: 'dzień',
    french: 'jour',
    spanish: 'día',
  },
  {
    av: 13645,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(life + to cross out: life destroyed) - Character (superimposed)',
    english: 'death',
    swedish: 'död (subst.)',
    norwegian: 'død',
    finnish: 'kuolema',
    hungarian: 'halál',
    german: 'Tod',
    dutch: 'dood (de)',
    afrikaans: 'dood',
    russian: 'смерть',
    latvian: 'nāve',
    polish: 'Śmierć',
    french: 'mort (la)',
    spanish: 'muerte',
  },
  {
    av: 13649,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(to think + to arrive: arrival at a rational position) - Character (superimposed)',
    english: 'decision',
    swedish: 'beslut',
    norwegian: 'beslutning, bestemmelse',
    finnish: 'päätös',
    hungarian: 'döntés, elhatározás, határozat',
    german: 'Entscheidung',
    dutch: 'beslissing, besluit',
    afrikaans: 'besluit, beslissing',
    russian: 'решение',
    latvian: 'lēmums',
    polish: 'decyzja',
    french: 'décision',
    spanish: 'decisión',
  },
  {
    av: 13667,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(change + forward [modification, short arrow]: change through progression) - Character (superimposed - modified)',
    english: 'development',
    swedish: 'utveckling',
    norwegian: 'utvikling',
    finnish: 'kehitys',
    hungarian: 'fejlődés, fejlesztés',
    german: 'Entwicklung',
    dutch: 'ontwikkeling',
    afrikaans: 'ontwikkeling',
    russian: 'развитие, рост',
    latvian: 'attīstība',
    polish: 'rozwój',
    french: 'développement',
    spanish: 'desarrollo',
  },
  {
    av: 13675,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(to cross out + same) - Character (superimposed)',
    english: 'different, other, difference',
    swedish: 'olika, annorlunda, olikhet',
    norwegian: 'ulikhet, forskjellig, annerledes',
    finnish: 'erilainen, eri',
    hungarian: 'különböző, eltérő, nem azonos',
    german: 'ungleich, anders',
    dutch: 'anders, ongelijk, verschillend',
    afrikaans: 'anders, verskil',
    russian: 'разница, различие',
    latvian: 'atšķirīgs, citāds, atšķirība',
    polish: 'inny, inne, odmienne, różne',
    french: 'différence',
    spanish: 'diferente, otro, otra, diferencia',
  },
  {
    av: 13685,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: simplified three-dimensional drawing of a disc) - Character',
    english: 'disc, disk',
    swedish: 'skiva, platta',
    norwegian: 'skive, plate',
    finnish: 'levy, kiekko',
    hungarian: 'korong, lemez, diszk',
    german: 'Scheibe',
    dutch: 'schijf',
    afrikaans: 'skyf',
    russian: 'диск, пластина',
    latvian: 'disks, diskete',
    polish: 'plasterek, krążek',
    french: 'disque',
    spanish: 'disco',
  },
  {
    av: 13687,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(comfort + to destroy) - Character (superimposed)',
    english: 'discomfort',
    swedish: 'obehag',
    norwegian: 'ubehag',
    finnish: 'epämukavuus',
    hungarian: 'kellemetlenség, kényelmetlenség',
    german: 'Ungemach, Unbehagen',
    dutch: 'ongemak',
    afrikaans: 'ongemak',
    russian: 'неудобство, дискомфорт',
    latvian: 'neērtība',
    polish: 'dyskomfort, niewygoda',
    french: 'inconfort, gêne',
    spanish: 'malestar',
  },
  {
    av: 13690,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a dish) - Character',
    english: 'dish, plate, platter',
    swedish: 'tallrik, fat',
    norwegian: 'tallerken, fat, asjett, skål',
    finnish: 'lautanen, vati',
    hungarian: 'tányér, tál, edény',
    german: 'Teller, Platte, flache Schale',
    dutch: 'bord',
    afrikaans: 'bord',
    russian: 'тарелка',
    latvian: 'šķīvis',
    polish: 'talerz, patera, półmisek, miska',
    french: 'assiette',
    spanish: 'plato',
  },
  {
    av: 13857,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(based upon the international mathematical symbol) - Character',
    english: 'division',
    swedish: 'division, delning',
    norwegian: 'divisjon, deling',
    finnish: 'jakolasku, jakaminen',
    hungarian: 'osztás (el-, meg-, be-, szét-)',
    german: 'Division, Teilung',
    dutch: 'deling',
    afrikaans: 'deelteken',
    russian: 'деление',
    latvian: 'dalīšana',
    polish: 'podział, dzielenie',
    french: 'division',
    spanish: 'división',
  },
  {
    av: 13863,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(international symbol for dollar) - Character',
    english: 'dollar',
    swedish: 'dollar',
    norwegian: 'dollar',
    finnish: 'dollari',
    hungarian: 'dollár',
    german: 'Dollar',
    dutch: 'dollar',
    afrikaans: 'dollar',
    russian: 'доллар',
    latvian: 'dolārs',
    polish: 'dolar',
    french: 'dollar',
    spanish: 'dólar',
  },
  {
    av: 13864,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: the shape contains water creature + pictograph of a tail fin) - Character (superimposed)',
    english: 'dolphin, porpoise, water mammal (with tail)',
    swedish: 'delfin, tumlare',
    norwegian: 'delfin, nise',
    finnish: 'delfiini, pyöriäinen',
    hungarian: 'delfin',
    german: 'Delphin',
    dutch: 'dolfijn',
    afrikaans: 'dolfyn, tornyn',
    russian: 'дельфин',
    latvian: 'delfīns, jūras cūka',
    polish: 'delfin, morświn, orka itp(ssak morski)',
    french: 'dauphin, marsouin',
    spanish: 'delfín, marsopa, cetáceo',
  },
  {
    av: 13866,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a doorway) - Character',
    english: 'door',
    swedish: 'dörr',
    norwegian: 'dør',
    finnish: 'ovi',
    hungarian: 'ajtó',
    german: 'Tür',
    dutch: 'deur',
    afrikaans: 'deur',
    russian: 'дверь',
    latvian: 'durvis',
    polish: 'drzwi',
    french: 'porte',
    spanish: 'puerta',
  },
  {
    av: 13867,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: often used to create a meaning based on the relationship between the dot and an associated symbol) - Character',
    english: 'dot',
    swedish: 'punkt, prick',
    norwegian: 'punkt, prikk',
    finnish: 'piste',
    hungarian: 'pont',
    german: 'Punkt',
    dutch: 'punt',
    afrikaans: 'punt, kolletjie',
    russian: 'точка',
    latvian: 'punkts',
    polish: 'kropka',
    french: 'point',
    spanish: 'punto',
  },
  {
    av: 13869,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(arrow, pointing downward) - Character',
    english: 'down, downward',
    swedish: 'ner, nedåt',
    norwegian: 'ned, nedover',
    finnish: 'alas, alaspäin',
    hungarian: 'le, lefelé',
    german: 'herunter, hinunter, abwärts',
    dutch: 'naar beneden, omlaag',
    afrikaans: 'af, afgaan, ondertoe, na benede',
    russian: 'вниз, внизу',
    latvian: 'lejā, lejup',
    polish: 'w dół, na dół',
    french: 'en bas, vers le bas',
    spanish: 'abajo, hacia abajo',
  },
  {
    av: 13870,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(arrow, pointing downward and backward) - Character',
    english: 'downward and backward',
    swedish: 'nedåt bakåt',
    norwegian: 'nedover og bakover',
    finnish: 'alas ja taakse',
    hungarian: 'lefelé és vissza-, ill. hátrafelé',
    german: 'hinab, abwärts und rückwärts',
    dutch: 'achteruit naar beneden',
    afrikaans: 'ondertoe en agtertoe',
    russian: 'вниз и назад',
    latvian: 'lejā un atpakaļ',
    polish: 'w dół i do tyłu (w dół i na skos w lewo)',
    french: 'vers le bas et en arrière',
    spanish: 'hacia abajo y hacia atrás',
  },
  {
    av: 13871,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(arrow, pointing downward and forward) - Character',
    english: 'downward and forward',
    swedish: 'nedåt framåt',
    norwegian: 'nedover og framover',
    finnish: 'alas ja eteen',
    hungarian: 'lefelé és előrefelé',
    german: 'herab, abwärts und vorwärts',
    dutch: 'vooruit naar beneden',
    afrikaans: 'ondertoe en vorentoe',
    russian: 'вниз и вперед',
    latvian: 'lejā un uz priekšu',
    polish: 'w dół i do przodu (w dół i na skos w prawo)',
    french: 'vers le bas et en avant',
    spanish: 'hacia abajo y hacia adelante',
  },
  {
    av: 13874,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(chest of drawers + pointer, to drawer) - Character (superimposed - pointer)',
    english: 'drawer',
    swedish: 'byrålåda (etc)',
    norwegian: 'kommodeskuff, skuff',
    finnish: 'laatikko (lipaston)',
    hungarian: 'fiók',
    german: 'Schublade',
    dutch: 'lade, schuif (Vl)',
    afrikaans: 'laai',
    russian: 'ящик',
    latvian: 'atvilkne',
    polish: 'szuflada',
    french: 'tiroir',
    spanish: 'cajón',
  },
  {
    av: 13881,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + food) - Character (superimposed)',
    english: 'drink, beverage',
    swedish: 'dryck',
    norwegian: 'drikk',
    finnish: 'juoma',
    hungarian: 'ital, innivaló',
    german: 'Getränk, Drink',
    dutch: 'drank',
    afrikaans: 'drank',
    russian: 'напиток',
    latvian: 'dzēriens, dzeramais',
    polish: 'napój, picie',
    french: 'boisson',
    spanish: 'bebida',
  },
  {
    av: 13885,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + pictograph of head and neck and one hump) - Character (superimposed)',
    english: 'dromedary',
    swedish: 'dromedar',
    norwegian: 'dromedar',
    finnish: 'dromedaari',
    hungarian: 'egypúpú teve, dromedár',
    german: 'Dromedar',
    dutch: 'dromedaris',
    afrikaans: 'dromedaris',
    russian: 'одногорбый верблюд',
    latvian: 'kamielis ar vienu kupri',
    polish: 'dromader',
    french: 'dromadaire',
    spanish: 'dromedario',
  },
  {
    av: 13892,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(limited time + dot (in position above sky line): occurring at a time limited by reference to another event) - Character (superimposed)',
    english: 'during, while',
    swedish: 'medan, under tiden',
    norwegian: 'mens, i løpet av',
    finnish: 'aikana, kuluessa, sillä aikaa kun',
    hungarian: 'míg, amíg, mialatt, miközben',
    german: 'während',
    dutch: 'terwijl',
    afrikaans: 'terwyl, tydens',
    russian: 'пока, во время',
    latvian: 'laika periodā, laikā, kamēr',
    polish: 'podczas, w czasie, gdy',
    french: 'pendant',
    spanish: 'durante, mientras tanto',
  },
  {
    av: 13894,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a side view of an ear) - Character',
    english: 'ear',
    swedish: 'öra',
    norwegian: 'øre',
    finnish: 'korva',
    hungarian: 'fül',
    german: 'Ohr',
    dutch: 'oor',
    afrikaans: 'oor',
    russian: 'ухо',
    latvian: 'auss',
    polish: 'ucho',
    french: 'oreille',
    spanish: 'oreja',
  },
  {
    av: 13895,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + ear: part of a hearing aid that fits into the ear) - Character (superimposed)',
    english: 'ear mold',
    swedish: 'öroninsats',
    norwegian: 'ørepropp, øreinnsats',
    finnish: 'korvakappale',
    hungarian: 'hallójárat illeszték',
    german: 'Ohrmuschel',
    dutch: 'oorstukje, oordop',
    afrikaans: 'gehoor apparaat',
    russian: 'беруши',
    latvian: 'ausu aizbāžņi',
    polish: 'aparat słuchowy (douszny)',
    french: 'appareil auditif (embout)',
    spanish: 'molde auricular',
  },
  {
    av: 13900,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests the planet rotating on its diagonal axis) - Character',
    english: 'earth, globe, world',
    swedish: 'jorden, jordklotet',
    norwegian: 'jorda (planet)',
    finnish: 'maapallo, maa',
    hungarian: 'Föld, földgolyó, glóbusz, földkerekség, világ',
    german: 'Erde',
    dutch: 'aarde (planeet)',
    afrikaans: 'aarde, wêreld, planeet',
    russian: 'Земля, земной шар',
    latvian: 'zeme, zemeslode, pasaule',
    polish: 'planeta, ziemia, glob',
    french: 'planète Terre',
    spanish: 'tierra, globo, mundo',
  },
  {
    av: 13901,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(horizontal line, on the earthline of the symbol drawing area) - Character',
    english: 'earth, ground, land',
    swedish: 'mark, jord',
    norwegian: 'jord, mark',
    finnish: 'maa, maaperä',
    hungarian: 'föld, talaj, alap',
    german: 'Erde, Boden',
    dutch: 'aarde',
    afrikaans: 'aarde, grond, land',
    russian: 'земля, почва',
    latvian: 'zeme',
    polish: 'ziemia, ląd, grunt, podłoże',
    french: 'terre, sol',
    spanish: 'tierra, suelo, terreno',
  },
  {
    av: 13902,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sun + pointer, to east) - Character (superimposed - pointer)',
    english: 'east',
    swedish: 'öster',
    norwegian: 'øst',
    finnish: 'itä',
    hungarian: 'Kelet',
    german: 'Osten',
    dutch: 'oost, oosten',
    afrikaans: 'oos',
    russian: 'восток',
    latvian: 'austrumi',
    polish: 'wschód',
    french: 'est',
    spanish: 'este',
  },
  {
    av: 13907,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(table + pointer, to edge) - Character (superimposed - pointer)',
    english: 'edge',
    swedish: 'kant',
    norwegian: 'kant',
    finnish: 'reuna, särmä',
    hungarian: 'él, valami széle, pereme, szegélye',
    german: 'Rand',
    dutch: 'rand, zijkant',
    afrikaans: 'rand',
    russian: 'край, кант',
    latvian: 'apmale, mala',
    polish: 'krawędź, brzeg',
    french: 'coin',
    spanish: 'borde',
  },
  {
    av: 13910,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(greater than (relation) + pictograph, of imprint: the effect is the imprint left by the wedge-shaped cause) See also: cause 13134. - Character (superimposed)',
    english: 'effect, result',
    swedish: 'effekt, verkan',
    norwegian: 'virkning, effekt',
    finnish: 'vaikutus, seuraus, reaktio',
    hungarian: 'eredmény, hatás, kihatás, következmény',
    german: 'Wirkung, Folge, Ergebnis, Effekt',
    dutch: 'effect, gevolg, resultaat',
    afrikaans: 'resultaat, gevolg, effek',
    russian: 'эффект',
    latvian: 'rezultāts, sasniegums',
    polish: 'wynik, skutek, efekt, rezultat',
    french: 'effet, conséquence',
    spanish: 'efecto, resultado',
  },
  {
    av: 13912,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) SYMBOL SYNONYM - Character',
    english: 'egg, ovum (2)',
    swedish: 'ägg (2)',
    norwegian: 'egg, eggcelle (2)',
    finnish: 'muna',
    hungarian: 'pete, tojás (jelkép szinoníma)',
    german: 'Ei (2)',
    dutch: 'ei (2)',
    afrikaans: 'eier, eiersel (2)',
    russian: 'яйцо (2)',
    latvian: 'ola (2)',
    polish: 'jajo, komórka jajowa, jajko (2)',
    french: 'œuf, graine (2)',
    spanish: 'huevo, óvulo (2)',
  },
  {
    av: 13914,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      "(relation [half-sized], pointing forward + dot: altered form of position in order to represent the meaning “the first alternative”. The dot is within the relation symbol because, as CKB writes, 'We have not decided where to place it.') - Character (superimposed)",
    english: 'either',
    swedish: 'antingen',
    norwegian: 'enten',
    finnish: 'joko -',
    hungarian: 'akármelyik, bármelyik, valamelyik',
    german: 'entweder',
    dutch: 'ofwel',
    afrikaans: 'of',
    russian: 'либо, или',
    latvian: 'viens no diviem; viens vai otrs',
    polish: 'albo',
    french: "l'un ou l'autre",
    spanish: 'o.., o',
  },
  {
    av: 13916,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(arm + pointer, to elbow) - Character (superimposed - pointer)',
    english: 'elbow',
    swedish: 'armbåge',
    norwegian: 'albu',
    finnish: 'kyynärpää',
    hungarian: 'könyök',
    german: 'Ellenbogen',
    dutch: 'elleboog',
    afrikaans: 'elmboog',
    russian: 'локоть',
    latvian: 'elkonis',
    polish: 'łokieć',
    french: 'coude',
    spanish: 'codo',
  },
  {
    av: 13918,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a lightning bolt) - Character',
    english: 'electricity',
    swedish: 'elektricitet',
    norwegian: 'elektrisitet',
    finnish: 'sähkö',
    hungarian: 'elektromosság, villamosság',
    german: 'Strom, Elektrizität',
    dutch: 'elektriciteit',
    afrikaans: 'elektrisiteit',
    russian: 'электричество',
    latvian: 'elektrība',
    polish: 'energia elektryczna, prąd',
    french: 'électricité',
    spanish: 'electricidad',
  },
  {
    av: 13922,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: 'electromagnetic radiation (derived from electricity) - Character',
    english: 'electromagnetic radiation',
    swedish: 'elektromagnetism',
    norwegian: 'elektromagnetisme',
    finnish: 'sähkömagneettinen säteily',
    hungarian: 'elektromágneses sugárzás',
    german: 'elektromagnetische Strahlung',
    dutch: 'straling',
    afrikaans: 'elektromagnetiese uitstraling',
    russian: 'электромагнетизм',
    latvian: 'elektromagnētisms',
    polish: 'promieniowanie elektromagnetyczne',
    french: 'radiation électromagnétique',
    spanish: 'radiación electromagnética',
  },
  {
    av: 13929,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(body + being (state of): an embryo is a potential living being, which cannot live outside the mother's body) - Character (superimposed)",
    english: 'embryo',
    swedish: 'embryo',
    norwegian: 'embryo, foster',
    finnish: 'sikiö, alkio',
    hungarian: 'embrió (ébrény: 6-8 hetes magzat)',
    german: 'Embryo',
    dutch: 'embryo',
    afrikaans: 'embrio',
    russian: 'эмбрион',
    latvian: 'embrijs',
    polish: 'embrion, zarodek, płód',
    french: 'embryon',
    spanish: 'embrión',
  },
  {
    av: 13934,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: an enclosed space) - Character',
    english: 'enclosure',
    swedish: 'sluten enhet',
    norwegian: 'avlukke, sluttet enhet',
    finnish: 'rajattu kokonaisuus, aitaus, suljettu tila',
    hungarian: 'körülzárás, -kerítés, bekerítés, körülzárt terület',
    german: 'Umgrenzung, umgrenzter Raum, Einzäunung',
    dutch: 'omsloten ruimte',
    afrikaans: 'hok, kamp, omheinde plek',
    russian: 'замкнутое пространство (СТАРОЕ зн)',
    latvian: 'slēgta telpa',
    polish: 'przestrzeń ograniczona, pomieszczenie, zagroda, ograniczenie',
    french: 'espace délimité, enclos',
    spanish: 'recinto, vallado',
  },
  {
    av: 13935,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(forward + reference line: the arrow arrives at the line and stops) - Character',
    english: 'end, arrival, stop',
    swedish: 'slut, stopp, ankomst',
    norwegian: 'ankomst, slutt, ende',
    finnish: 'loppu, saapuminen, perilletulo',
    hungarian: 'befejezés, végződés, megérkezés, vég, stop',
    german: 'Ende, Ankunft',
    dutch: 'aankomst, einde, stop',
    afrikaans: 'aankoms, einde, stop',
    russian: 'конец, остановка, прибытие',
    latvian: 'gals, beigas, ierašanās',
    polish: 'koniec drogi, cel, przybyć do celu',
    french: 'fin',
    spanish: 'final, llegada',
  },
  {
    av: 13936,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sun + electromagnetic radiation: potential energy, as received from the sun) - Character (superimposed)',
    english: 'energy',
    swedish: 'energi',
    norwegian: 'energi',
    finnish: 'energia',
    hungarian: 'energia',
    german: 'Energie',
    dutch: 'energie',
    afrikaans: 'energie',
    russian: 'энергия',
    latvian: 'enerģija',
    polish: 'energia',
    french: 'énergie solaire',
    spanish: 'energía',
  },
  {
    av: 13942,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + water + sky: complete physical world that surrounds us) - Character (superimposed)',
    english: 'environment',
    swedish: 'miljö, omvärld',
    norwegian: 'miljø',
    finnish: 'ympäristö',
    hungarian: 'környezet',
    german: 'Umwelt',
    dutch: 'milieu',
    afrikaans: 'omgewing',
    russian: 'окружающая среда',
    latvian: 'apkārtējā vide',
    polish: 'otoczenie, srodowisko',
    french: 'environnement',
    spanish: 'medio ambiente',
  },
  {
    av: 13944,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(standing (standing person) + pictograph, of erect penis) - Character (superimposed)',
    english: 'erection, erect penis',
    swedish: 'erektion, stånd',
    norwegian: 'ereksjon, erigert penis',
    finnish: 'erektio',
    hungarian: 'erekció, merevedés, merev hímvessző',
    german: 'Erektion, Latte',
    dutch: 'erectie',
    afrikaans: 'ereksie penis',
    russian: 'эрекция',
    latvian: 'erekcija, erektēts loceklis',
    polish: 'erekcja',
    french: 'érection',
    spanish: 'erección',
  },
  {
    av: 13946,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: citrus fruit used as a Jewish ceremonial object (Hebrew)) - Character',
    english: 'etrog',
    swedish: 'etrog (Israel)',
    norwegian: 'etrog (Israel)',
    finnish: 'sukaattisitruuna, etrog',
    hungarian: 'etrog (héber)',
    german: 'Etrog (Zitrusfrucht)',
    dutch: 'etrog (Joods)',
    afrikaans: 'etrog',
    russian: 'этрог',
    latvian: 'etrog',
    polish: 'etrog (owoc wykorzystywany w hebrajskich tradycjach, podobny do cytryny)',
    french: 'etrog',
    spanish: 'etrog (Israel)',
  },
  {
    av: 13949,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(symbol represents a cone balancing unsteadily on its point, reminding us that our evaluations are variable and unreliable) - Character',
    english: 'evaluation, value',
    swedish: 'värde, värdering',
    norwegian: 'verdi, vurdering',
    finnish: 'arvio, arviointi, arvo',
    hungarian: 'értékelés, kiértékelés, érték',
    german: 'Wert, Nutzen, Bewertung',
    dutch: 'evaluatie, oordeel, waarde',
    afrikaans: 'evalueer, waarde',
    russian: 'ценность, оценка',
    latvian: 'novērtējums, vērtība',
    polish: 'ocena, wartość',
    french: 'évaluation',
    spanish: 'evaluación, valor',
  },
  {
    av: 13950,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(moon [modification, upper half] + earth: the moon begins to appear above the horizon) - Character (superimposed - modified)',
    english: 'evening',
    swedish: 'kväll',
    norwegian: 'kveld',
    finnish: 'ilta',
    hungarian: 'este',
    german: 'Abend',
    dutch: 'avond',
    afrikaans: 'aand',
    russian: 'вечер',
    latvian: 'vakars',
    polish: 'wieczór',
    french: 'soir',
    spanish: 'tarde',
  },
  {
    av: 14114,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(to be + earth [half-sized]: occurrence on earth) - Character (superimposed)',
    english: 'event, happening, occasion',
    swedish: 'händelse',
    norwegian: 'hendelse, begivenhet',
    finnish: 'tapahtuma, tapaus',
    hungarian: 'esemény, eset, történés',
    german: 'Ereignis',
    dutch: 'gebeurtenis',
    afrikaans: 'gebeurtenis, okkasie',
    russian: 'случай, событие',
    latvian: 'notikums, norise, gadījums',
    polish: 'wydarzenie, okazja, zdarzenie',
    french: 'événement, manifestation',
    spanish: 'evento, ocasión',
  },
  {
    av: 14116,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(tree + pictograph of spruce branches: pictograph symbo that suggests a spruce or pine tree. The symbol can be used for any tree that does not lose its leaves annually.) - Character (superimposed)',
    english: 'evergreen tree, spruce, fir, fir tree',
    swedish: 'gran, tall, barrträd',
    norwegian: 'bartre, nåletre, eviggrønt tre',
    finnish: 'havupuu',
    hungarian: 'örökzöld',
    german: 'immergrüner Baum',
    dutch: 'spar, den',
    afrikaans: 'immergroen boom, denneboom',
    russian: 'хвойное дерево',
    latvian: 'mūžzaļš koks; egle, egles koks',
    polish: 'choinka, drzewo wiecznie zielone, zimozielone',
    french: 'arbre à feuilles persistantes, sapin',
    spanish: 'pino, abeto',
  },
  {
    av: 14128,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + future (uncertain): thinking about an unknown future) - Character (superimposed)',
    english: 'expectation, anticipation',
    swedish: 'antagande, förväntan',
    norwegian: 'antagelse, forventning',
    finnish: 'odotus, aavistus',
    hungarian: 'elvárás, remény, várakozás valamire',
    german: 'Erwartung',
    dutch: 'verwachting',
    afrikaans: 'verwagting, afwagting',
    russian: 'предположение, ожидание',
    latvian: 'cerības, gaidas',
    polish: 'oczekiwanie, nadzieja, prawdopodobieństwo, przewidywanie',
    french: 'espérance, attentes, anticipation',
    spanish: 'expectativa',
  },
  {
    av: 14132,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + four arrows [modification, short arrows], moving outwards) - Character (superimposed - modified)',
    english: 'explosion, detonation, blowup',
    swedish: 'explosion',
    norwegian: 'eksplosjon, sprengning, detonasjon',
    finnish: 'räjähdys',
    hungarian: 'robbanás, detonáció',
    german: 'Explosion',
    dutch: 'explosie, ontploffing',
    afrikaans: 'ontploffing, uitbarsting',
    russian: 'взрыв',
    latvian: 'sprādziens, eksplozija, detonācija',
    polish: 'wybuch, detonacja',
    french: 'explosion',
    spanish: 'explosión, detonación',
  },
  {
    av: 14133,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests an eye with a pupil in the centre) - Character',
    english: 'eye',
    swedish: 'öga',
    norwegian: 'øye',
    finnish: 'silmä',
    hungarian: 'szem',
    german: 'Auge',
    dutch: 'oog',
    afrikaans: 'oog',
    russian: 'глаз',
    latvian: 'acs',
    polish: 'oko',
    french: 'œil',
    spanish: 'ojo',
  },
  {
    av: 14134,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(eye + line [half-sized] + pointer) - Character (superimposed - pointer)',
    english: 'eyebrow',
    swedish: 'ögonbryn',
    norwegian: 'øyebryn',
    finnish: 'kulmakarva',
    hungarian: 'szemöldök',
    german: 'Augenbraue',
    dutch: 'wenkbrauw',
    afrikaans: 'wenkbrou',
    russian: 'бровь',
    latvian: 'uzacs',
    polish: 'brew',
    french: 'sourcil',
    spanish: 'ceja',
  },
  {
    av: 14136,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(eye + pointer, to upper eyelid) - Character (superimposed - pointer)',
    english: 'eyelid (upper)',
    swedish: 'ögonlock (övre)',
    norwegian: 'øyelokk (øvre)',
    finnish: 'silmäluomi',
    hungarian: 'szemhéj',
    german: 'Augenlid, Lid',
    dutch: 'ooglid (bovenste)',
    afrikaans: 'ooglid',
    russian: 'веко',
    latvian: 'plakstiņš',
    polish: 'powieka',
    french: 'paupière',
    spanish: 'párpado',
  },
  {
    av: 14138,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(head + dot [modification, higher position] + dot [modification, higher position]: pictograph, suggesting a face with mouth, nose and two eyes) - Character (superimposed - modified)',
    english: 'face',
    swedish: 'ansikte',
    norwegian: 'ansikt',
    finnish: 'kasvot, naama',
    hungarian: 'arc',
    german: 'Gesicht',
    dutch: 'gezicht',
    afrikaans: 'gesig',
    russian: 'лицо',
    latvian: 'seja',
    polish: 'twarz',
    french: 'figure, visage',
    spanish: 'cara',
  },
  {
    av: 14139,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + real: something that one thinks is real) - Character (superimposed)',
    english: 'fact',
    swedish: 'faktum',
    norwegian: 'faktum',
    finnish: 'tosiasia',
    hungarian: 'tény, valóság',
    german: 'Tatsache',
    dutch: 'feit',
    afrikaans: 'feit',
    russian: 'факт',
    latvian: 'fakts',
    polish: 'fakt',
    french: 'fait',
    spanish: 'hecho',
  },
  {
    av: 14144,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(man + protection + protection + woman: a man and a woman join their roofs to create a family unit. The symbol also can be explained as husband + wife.) SYMBOL SYNONYM - Character (superimposed)',
    english: 'family (traditional)',
    swedish: 'familj, släkt',
    norwegian: 'familie (tradisjonell)',
    finnish: 'perhe',
    hungarian: 'család (hagyományos)',
    german: 'Familie (traditionell)',
    dutch: 'gezin',
    afrikaans: 'familie (traditioneel)',
    russian: 'семья',
    latvian: 'ģimene (tradic.)',
    polish: 'rodzina (tradycyjna)',
    french: 'famille (traditionnelle)',
    spanish: 'familia (tradicional)',
  },
  {
    av: 14145,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(person + protection + person: caring people, i.e., people joined together to protect those in their care) SYMBOL SYNONYM - Character (superimposed)',
    english: 'family (cohabiting)',
    swedish: 'familj, makar, sambopar (könsneutral)',
    norwegian: 'familie (samboende)',
    finnish: 'perhe',
    hungarian: 'család (élettársak)',
    german: 'Familie (in Lebensgemeinschaft zusammenleben)',
    dutch: 'familie (samenwonend), gezin (samenwonend)',
    afrikaans: 'familie, gesin (saamlewend)',
    russian: 'семейство, род',
    latvian: 'ģimene, kopdzīve',
    polish: 'małżonkowie, para żyjąca razem, konkubinat',
    french: 'famille (personnes sous le même toit)',
    spanish: 'familia (de hecho)',
  },
  {
    av: 14149,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'fan',
    swedish: 'solfjäder',
    norwegian: 'vifte (bildelik)',
    finnish: 'viuhka',
    hungarian: 'legyező',
    german: 'Fächer',
    dutch: 'waaier',
    afrikaans: 'waaier',
    russian: 'веер',
    latvian: 'vēdeklis',
    polish: 'wachlarz',
    french: 'éventail',
    spanish: 'abanico',
  },
  {
    av: 14151,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(protection + field: place where the fields are cared for) - Character (superimposed)',
    english: 'farm',
    swedish: 'bondgård, lantbruk',
    norwegian: 'bondegård, landbruk',
    finnish: 'maatila, maatalo, maalaistalo',
    hungarian: 'gazdaság, farm, kisbirtok, major',
    german: 'Bauernhof',
    dutch: 'boerderij',
    afrikaans: 'boerdery',
    russian: 'ферма, хозяйство',
    latvian: 'zemnieku saimniecība, ferma',
    polish: 'gospodarstwo rolne',
    french: 'ferme',
    spanish: 'granja',
  },
  {
    av: 14157,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(protection + man: man who gives protection to his family) - Character (superimposed)',
    english: 'father, dad, daddy, papa, pa, pop',
    swedish: 'pappa, far',
    norwegian: 'pappa, far',
    finnish: 'isä',
    hungarian: 'apa, édesapa, apu, papa',
    german: 'Vater',
    dutch: 'vader, papa',
    afrikaans: 'vader, pappa, pa',
    russian: 'папа‚ отец',
    latvian: 'tēvs, tētis, tētiņš, paps',
    polish: 'ojciec, tata, tatuś',
    french: 'père, papa',
    spanish: 'padre, papá, papito, pa',
  },
  {
    av: 14164,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(symbol is the familiar heart shape: traditionally one's feelings are supposed to come from the heart. In a few cases, this symbol is used to represent sensation.) - Character",
    english: 'feeling, emotion, sensation',
    swedish: 'känsla',
    norwegian: 'følelse',
    finnish: 'tunne',
    hungarian: 'érzés, érzelem, érzet',
    german: 'Gefühl',
    dutch: 'gevoel, emotie',
    afrikaans: 'gevoel, emosie, sensasie',
    russian: 'чувство',
    latvian: 'jūtas, emocijas, sajūtas',
    polish: 'uczucie, emocja',
    french: 'sentiment, émotion',
    spanish: 'sentimiento, emoción, sensación',
  },
  {
    av: 14166,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(woman [modification], and also creation [half sized]: this form of woman is used only in compound symbols to specify gender or sex) - Character (modified)',
    english: 'female (gender)',
    swedish: 'hona, honkön',
    norwegian: 'hunkjønn',
    finnish: 'naaras',
    hungarian: 'nőnem',
    german: 'Frau',
    dutch: 'vrouwelijk',
    afrikaans: 'vroulik (geslag)',
    russian: 'женский пол',
    latvian: 'seviešu (dzimte)',
    polish: 'żeński (rodzaj)',
    french: 'femelle (genre)',
    spanish: 'femenino (género)',
  },
  {
    av: 14167,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(building with yard and fence + pointer, to fence) - Character (superimposed - pointer)',
    english: 'fence, wall',
    swedish: 'staket, häck (etc)',
    norwegian: 'gjerde, hekk (o.l.)',
    finnish: 'aita, seinä',
    hungarian: 'kerítés, fal',
    german: 'Zaun, Mauer, Hecke',
    dutch: 'hek, omheining, schutting',
    afrikaans: 'omheining, heining, muur',
    russian: 'забор, изгородь',
    latvian: 'žogs, siena',
    polish: 'ściana, ogrodzenie, płot, zagroda',
    french: 'barrière, clôture',
    spanish: 'valla, pared',
  },
  {
    av: 14170,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(body + baby) - Character (superimposed)',
    english: 'fetus',
    swedish: 'foster',
    norwegian: 'foster',
    finnish: 'sikiö',
    hungarian: 'magzat',
    german: 'Fetus, Fötus',
    dutch: 'foetus',
    afrikaans: 'fetus',
    russian: 'плод',
    latvian: 'embrijs (auglis)',
    polish: 'płód, zarodek',
    french: 'fœtus',
    spanish: 'feto',
  },
  {
    av: 14173,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(grain + earth: ground covered with grain or crops) - Character (superimposed)',
    english: 'field',
    swedish: 'fält, åker',
    norwegian: 'jorde, åker',
    finnish: 'pelto',
    hungarian: 'mező',
    german: 'Feld',
    dutch: 'akker, veld',
    afrikaans: 'veld',
    russian: 'поле',
    latvian: 'lauks, tīrums',
    polish: '2',
    french: 'champ',
    spanish: 'campo',
  },
  {
    av: 14180,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(hand + pointer, to finger) - Character (superimposed - pointer)',
    english: 'finger',
    swedish: 'finger',
    norwegian: 'finger',
    finnish: 'sormi',
    hungarian: 'ujj, kézujj',
    german: 'Finger',
    dutch: 'vinger',
    afrikaans: 'vinger',
    russian: 'палец',
    latvian: 'pirksts',
    polish: 'palec',
    french: 'doigt',
    spanish: 'dedo',
  },
  {
    av: 14183,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(symbol looks like a flame, suggesting fire) - Character',
    english: 'fire',
    swedish: 'eld',
    norwegian: 'ild',
    finnish: 'tuli',
    hungarian: 'tűz',
    german: 'Feuer',
    dutch: 'vuur',
    afrikaans: 'vuur',
    russian: 'огонь',
    latvian: 'uguns',
    polish: 'ogień, płomień',
    french: 'feu',
    spanish: 'incendio, fuego',
  },
  {
    av: 14185,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(fire + open: opening in which a fire can be built) - Character (superimposed)',
    english: 'fireplace',
    swedish: 'öppen spis',
    norwegian: 'peis',
    finnish: 'takka, tulisija',
    hungarian: 'kandalló',
    german: 'Kaminfeuer, offener Kamin, Kamin',
    dutch: 'open haard, plaats voor vuur',
    afrikaans: 'kaggel, vuurherd',
    russian: 'камин, очаг',
    latvian: 'kamīns',
    polish: 'kominek, palenisko',
    french: 'cheminée, feu ouvert',
    spanish: 'chimenea, hogar',
  },
  {
    av: 14188,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a fish) - Character',
    english: 'fish (animal)',
    swedish: 'fisk',
    norwegian: 'fisk',
    finnish: 'kala',
    hungarian: 'hal',
    german: 'Fisch (Tier)',
    dutch: 'vis',
    afrikaans: 'vis (dier)',
    russian: 'рыба',
    latvian: 'zivs',
    polish: 'ryba (zwierzę)',
    french: 'poisson (animal)',
    spanish: 'pez (animal)',
  },
  {
    av: 14193,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a flag) - Character',
    english: 'flag',
    swedish: 'flagga',
    norwegian: 'flagg',
    finnish: 'lippu',
    hungarian: 'zászló',
    german: 'Flagge',
    dutch: 'vlag',
    afrikaans: 'vlag',
    russian: 'флаг, знамя',
    latvian: 'karogs',
    polish: 'bandera, flaga, chorągiew',
    french: 'drapeau',
    spanish: 'bandera',
  },
  {
    av: 14202,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(room + pointer, to floor from underneath) - Character (superimposed - pointer)',
    english: 'floor',
    swedish: 'golv',
    norwegian: 'golv',
    finnish: 'lattia',
    hungarian: 'padló, aljzat',
    german: 'Boden',
    dutch: 'vloer',
    afrikaans: 'vloer',
    russian: 'пол',
    latvian: 'grīda',
    polish: 'podłoga, podłoże',
    french: 'plancher, sol',
    spanish: 'suelo',
  },
  {
    av: 14203,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(room + pointer, to floor from above) - Character (superimposed - pointer)',
    english: 'floor covering, linoleum',
    swedish: 'korkmatta, parkett (etc)',
    norwegian: 'golvbelegg, parkett (o.l.)',
    finnish: 'lattiapinta',
    hungarian: 'padlóborítás, linóleum',
    german: 'Bodenbelag, Teppich',
    dutch: 'vloerbedekking',
    afrikaans: 'vloerbedekking',
    russian: 'линолеум, ковролин',
    latvian: 'grīdas segums, linolejs',
    polish: 'wykładzina podłogowa, linoleum, parkiet – coś pokrywające podłogę',
    french: 'revêtement de sol',
    spanish: 'recubrimiento para pisos, linóleo',
  },
  {
    av: 14205,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a flower) - Character',
    english: 'flower',
    swedish: 'blomma',
    norwegian: 'blomst',
    finnish: 'kukka',
    hungarian: 'virág',
    german: 'Blume',
    dutch: 'bloem',
    afrikaans: 'blom',
    russian: 'цветок',
    latvian: 'puķe',
    polish: 'kwiat, roślina',
    french: 'fleur',
    spanish: 'flor',
  },
  {
    av: 14206,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(flower + bulb + pointer, to flower) - Character (superimposed - pointer)',
    english: 'flower (from bulb)',
    swedish: 'lökväxt',
    norwegian: 'løkblomst',
    finnish: 'kukka (sipulista)',
    hungarian: 'virág (hagymás)',
    german: 'Blume (aus einer Zwiebel)',
    dutch: 'bloem (van bloembol)',
    afrikaans: 'blom (van bal, knol)',
    russian: 'цветок луковичный',
    latvian: 'sīpolpuķes',
    polish: 'kwiat cebulowy, roślina cebulowa',
    french: 'fleur (à bulbe)',
    spanish: 'flor (de bulbo)',
  },
  {
    av: 14371,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(insect + to fly) - Character (superimposed)',
    english: 'fly, flying insect',
    swedish: 'fluga',
    norwegian: 'flue',
    finnish: 'kärpänen',
    hungarian: 'légy',
    german: 'Fliege',
    dutch: 'vlieg',
    afrikaans: 'vlieg insek',
    russian: 'муха',
    latvian: 'muša ',
    polish: 'lot',
    french: 'mouche',
    spanish: 'vuelo',
  },
  {
    av: 14374,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sky + water: formation of water droplets below the sky) - Character (superimposed)',
    english: 'fog',
    swedish: 'dimma',
    norwegian: 'tåke',
    finnish: 'sumu',
    hungarian: 'köd',
    german: 'Nebel',
    dutch: 'mist',
    afrikaans: 'mis',
    russian: 'туман',
    latvian: 'migla',
    polish: 'mgła, zamglenie',
    french: 'brouillard',
    spanish: 'niebla',
  },
  {
    av: 14377,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mouth + earth [half-sized]: what the mouth gets from the earth) - Character (superimposed)',
    english: 'food',
    swedish: 'mat, livsmedel',
    norwegian: 'mat',
    finnish: 'ruoka',
    hungarian: 'étel, élelem',
    german: 'Nahrung, Essen',
    dutch: 'voedsel, voeding, eten (het)',
    afrikaans: 'kos, voedsel',
    russian: 'еда, продукты',
    latvian: 'ēdiens, pārtika',
    polish: 'jedzenie, żywność, posiłek',
    french: 'nourriture, aliment',
    spanish: 'comida, alimento',
  },
  {
    av: 14379,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      'foot (legs and feet + pointer, to foot) - Character (superimposed - pointer)',
    english: 'foot',
    swedish: 'fot',
    norwegian: 'fot',
    finnish: 'jalkaterä, jalka',
    hungarian: 'lábfej',
    german: 'Fuß',
    dutch: 'voet',
    afrikaans: 'voet',
    russian: 'стопа, ступня',
    latvian: 'pēda',
    polish: 'stopa',
    french: 'pied',
    spanish: 'pie',
  },
  {
    av: 14381,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(to exchange [modification]) - Character (modified)',
    english: 'for (in exchange for), instead',
    swedish: 'för, i stället för, i utbyte mot',
    norwegian: 'for, i stedet for',
    finnish: 'sijasta, asemasta',
    hungarian: 'ért (valamiért, cserébe valamiért)',
    german: 'für, dafür (im Austausch)',
    dutch: 'in ruil voor',
    afrikaans: 'vir (in ruil vir)',
    russian: 'вместо, взамен',
    latvian: 'vietā, apmaiņā pret',
    polish: 'w zamian za',
    french: 'pour (au lieu de)',
    spanish: 'por (en lugar de, a cambio de)',
  },
  {
    av: 14382,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(purpose [half-sized]) - Character',
    english: 'for (the purpose of), in order to',
    swedish: 'för, för att',
    norwegian: 'for, for at',
    finnish: 'puolesta, varten, vuoksi',
    hungarian: 'célból, valami céljából, valami érdekében',
    german: 'um zu, um, damit',
    dutch: 'om, voor',
    afrikaans: 'vir (die doel van)',
    russian: ' для того, чтобы',
    latvian: 'tāpēc, tādēļ, lai',
    polish: 'w celu',
    french: 'pour (afin de)',
    spanish: 'por (con el propósito de), a fin de, para',
  },
  {
    av: 14384,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(face + pointer, to forehead) - Character (superimposed - pointer)',
    english: 'forehead',
    swedish: 'panna',
    norwegian: 'panne',
    finnish: 'otsa',
    hungarian: 'homlok',
    german: 'Stirn',
    dutch: 'voorhoofd',
    afrikaans: 'voorkop',
    russian: 'лоб',
    latvian: 'piere',
    polish: 'czoło',
    french: 'front',
    spanish: 'frente',
  },
  {
    av: 14389,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a fork. The diagonal orientation of fork is the same as that of spoon and knife.) - Character',
    english: 'fork',
    swedish: 'gaffel',
    norwegian: 'gaffel',
    finnish: 'haarukka',
    hungarian: 'villa',
    german: 'Gabel',
    dutch: 'riek, hooivork',
    afrikaans: 'vurk, hooivurk',
    russian: 'вилка',
    latvian: 'dakšiņa',
    polish: 'widelec',
    french: 'fourchette',
    spanish: 'tenedor',
  },
  {
    av: 14390,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(arrow, pointing forward) - Character',
    english: 'forward',
    swedish: 'fram, framåt',
    norwegian: 'fram, framover',
    finnish: 'eteenpäin, edelleen',
    hungarian: 'előre',
    german: 'vorwärts',
    dutch: 'vooruit',
    afrikaans: 'vorentoe, vooruit',
    russian: 'вперед',
    latvian: 'uz priekšu',
    polish: 'naprzód, do przodu',
    french: "en avant, vers l'avant",
    spanish: 'hacia delante',
  },
  {
    av: 14396,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + open: feeling of being unconfined) - Character (superimposed)',
    english: 'freedom, liberty',
    swedish: 'frihet',
    norwegian: 'frihet',
    finnish: 'vapaus',
    hungarian: 'szabadság',
    german: 'Freiheit',
    dutch: 'vrijheid',
    afrikaans: 'vryheid, vrylik',
    russian: 'свобода',
    latvian: 'brīvība',
    polish: 'wolność',
    french: 'liberté',
    spanish: 'libertad',
  },
  {
    av: 14403,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(reference line [half-sized] + arrowhead: the arrowhead departs from the reference line. This symbol is a simplified form of departure.) - Character (sequenced)',
    english: 'from',
    swedish: 'från',
    norwegian: 'fra',
    finnish: 'jostakin',
    hungarian: 'ból, -ből, -ról, -ről, -tól, -től',
    german: 'von',
    dutch: 'van, vanaf, vanuit',
    afrikaans: 'van, vanaf, vanuit',
    russian: 'из, от, с',
    latvian: 'no',
    polish: 'z, od',
    french: 'de, en (provenance)',
    spanish: 'de, desde',
  },
  {
    av: 14405,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a piece of fruit with a curved stem, in the position it would have if hanging from a tree) - Character',
    english: 'fruit',
    swedish: 'frukt',
    norwegian: 'frukt',
    finnish: 'hedelmä',
    hungarian: 'gyümölcs',
    german: 'Obst, Frucht',
    dutch: 'fruit',
    afrikaans: 'vrugte',
    russian: 'фрукт',
    latvian: 'auglis',
    polish: 'owoc',
    french: 'fruit',
    spanish: 'fruta',
  },
  {
    av: 14412,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(energy + enclosure: energy that can be put into an enclosure and used to power something) - Character (superimposed)',
    english: 'fuel',
    swedish: 'bränsle',
    norwegian: 'brensel, drivstoff',
    finnish: 'polttoaine',
    hungarian: 'fűtőanyag, tüzelőanyag, üzemanyag',
    german: 'Kraftstoff, Brennstoff',
    dutch: 'brandstof',
    afrikaans: 'brandstof',
    russian: 'топливо',
    latvian: 'degviela',
    polish: 'paliwo, benzyna, ropa (płynne paliwo do maszyn)',
    french: 'combustible',
    spanish: 'combustible, gasolina',
  },
  {
    av: 14415,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(furred animal + pointer, to hair: hair protecting the skin of an animal) - Character (superimposed - pointer)',
    english: 'fur, coat (animal), hair (animal)',
    swedish: 'päls',
    norwegian: 'pels, skinn',
    finnish: 'turkki, karva',
    hungarian: 'állatszőr, állat szőrzete, bundája',
    german: 'Fell, Pelz',
    dutch: 'pels, vacht',
    afrikaans: 'pels, hare (dier)',
    russian: 'мех, шерсть',
    latvian: 'kažokāda, dzīvnieka spalva',
    polish: 'futro, sierść zwierzęcia',
    french: 'fourrure, pelage',
    spanish: 'abrigo de piel (animal) pelo (animal)',
  },
  {
    av: 14417,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(outline of parabolic mirror focused on what lies ahead of it) - Character',
    english: 'future',
    swedish: 'framtid',
    norwegian: 'framtid',
    finnish: 'tulevaisuus, tuleva aika',
    hungarian: 'jövő, a jövő',
    german: 'Zukunft',
    dutch: 'toekomst',
    afrikaans: 'toekoms',
    russian: 'будущее',
    latvian: 'nākotne',
    polish: 'przyszłość, jutro, w przyszłości, przyszły',
    french: 'futur',
    spanish: 'futuro',
  },
  {
    av: 14420,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(building + vehicle [modification]: the two wheels representing a modified vehicle, building for vehicles) - Character (superimposed - modified)',
    english: 'garage',
    swedish: 'garage',
    norwegian: 'garasje',
    finnish: 'autotalli',
    hungarian: 'garázs',
    german: 'Garage',
    dutch: 'garage',
    afrikaans: 'garage, motorhuis',
    russian: 'гараж',
    latvian: 'garāža',
    polish: 'garaż',
    french: 'garage',
    spanish: 'garaje',
  },
  {
    av: 14421,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(container + waste) - Character (superimposed)',
    english: 'garbage can, rubbish bin, trash can',
    swedish: 'papperskorg, soppåse, soptunna (etc)',
    norwegian: 'søppelkasse, avfallsbøtte',
    finnish: 'jäteastia',
    hungarian: 'szeméttároló, kuka, szemetesvödör, szemétkosár',
    german: 'Abfalleimer',
    dutch: 'vuilnisbak, prullenbak',
    afrikaans: 'vullisblik, asblik, asdrom, vuilgoeddrom, vullisdrom',
    russian: 'мусорный бак (ведро и пр.)',
    latvian: 'atkritumu spainis, miskaste',
    polish: 'pojemnik na śmieci, śmietnik',
    french: 'poubelle',
    spanish: 'cubo de basura',
  },
  {
    av: 14422,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(flower + earth: place with flowers) - Character (superimposed)',
    english: 'garden',
    swedish: 'trädgård',
    norwegian: 'hage',
    finnish: 'puutarha',
    hungarian: 'kert',
    german: 'Garten',
    dutch: 'tuin',
    afrikaans: 'tuin',
    russian: 'сад',
    latvian: 'dārzs',
    polish: 'ogród',
    french: 'jardin',
    spanish: 'jardín',
  },
  {
    av: 14424,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(up + pictograph of a bubble: symbol suggests a gas bubble rising upward) - Character (superimposed)',
    english: 'gas',
    swedish: 'gas',
    norwegian: 'gass',
    finnish: 'kaasu',
    hungarian: 'gáz',
    german: 'Gas',
    dutch: 'gas',
    afrikaans: 'gas',
    russian: 'газ',
    latvian: 'gāze',
    polish: 'gaz',
    french: 'gaz',
    spanish: 'gas',
  },
  {
    av: 14427,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(four arrows [modification], pointing inward towards each other, i.e., gathering together) - Character (modified)',
    english: 'gathering, assembly, meeting, conference',
    swedish: 'samling, möte',
    norwegian: 'samling, forsamling, møte',
    finnish: 'kokous, keräys, kokoaminen',
    hungarian: 'gyűlés, gyülekezés, találkozó',
    german: 'Versammlung',
    dutch: 'verzameling, bijeenkomst, samenkomst',
    afrikaans: 'versamel, samekoms, byeenkoms, konferensie, vergadering',
    russian: 'собрание, конференция и пр.',
    latvian: 'sapulce, pulcēšanās, konference',
    polish: 'zgromadzenie, spotkanie, konferencja',
    french: 'réunion, assemblée, conférence',
    spanish: 'reunión',
  },
  {
    av: 14428,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(male + female: having either a male or female gender) - Character (superimposed)',
    english: 'gender, sex',
    swedish: 'kön',
    norwegian: 'kjønn',
    finnish: 'sukupuoli',
    hungarian: 'nem (hímnem, nőnem)',
    german: 'Geschlecht, Sex',
    dutch: 'geslacht, sekse',
    afrikaans: 'geslag',
    russian: 'пол',
    latvian: 'dzimums',
    polish: 'płeć',
    french: 'sexe, genre',
    spanish: 'género',
  },
  {
    av: 14430,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(mouth + many: what one says to characterize many things: CKB describes this symbol as 'a saying about a multitude'.) - Character (superimposed)",
    english: 'generalization',
    swedish: 'kategori, generalisering',
    norwegian: 'kategori, generalisering',
    finnish: 'yleistys',
    hungarian: 'általánosítás, általában',
    german: 'Verallgemeinerung',
    dutch: 'generalisering',
    afrikaans: 'veralgemeen',
    russian: 'обобщение, категория',
    latvian: 'vispārinājums, vispārināšana',
    polish: 'uogólnienie, generalizacja',
    french: 'généralisation',
    spanish: 'generalización',
  },
  {
    av: 14431,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(standing person + pointer, to genital area) - Character (superimposed - pointer)',
    english: 'genitals, sex organs',
    swedish: 'könsorgan',
    norwegian: 'kjønnsorgan',
    finnish: 'sukupuolielimet',
    hungarian: 'nemiszerv, külső nemiszervek',
    german: 'Geschlechtsteile, Geschlechtsorgane',
    dutch: 'genitaliën, geslachtsdelen',
    afrikaans: 'geslagsdele, geslagsorgane',
    russian: 'гениталии',
    latvian: 'dzimumorgāni, ģenitālijas',
    polish: 'narządy płciowe',
    french: 'organes génitaux',
    spanish: 'genitales',
  },
  {
    av: 14438,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(animal + pictograph of head and long neck) - Character (superimposed)',
    english: 'giraffe',
    swedish: 'giraff',
    norwegian: 'giraff',
    finnish: 'kirahvi',
    hungarian: 'zsiráf',
    german: 'Giraffe',
    dutch: 'giraf',
    afrikaans: 'kameelperd',
    russian: 'жираф',
    latvian: 'žirafe',
    polish: 'żyrafa',
    french: 'girafe',
    spanish: 'jirafa',
  },
  {
    av: 14439,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(child + female (combination)) - Character (superimposed - combined)',
    english: 'girl',
    swedish: 'flicka, tjej, tös',
    norwegian: 'jente',
    finnish: 'tyttö',
    hungarian: 'lány, kislány, lányka',
    german: 'Mädchen',
    dutch: 'meisje',
    afrikaans: 'meisie, dogter',
    russian: 'девочка',
    latvian: 'meitene',
    polish: 'dziewczyna, dziewczynka',
    french: 'fille',
    spanish: 'chica',
  },
  {
    av: 14442,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a drinking glass) - Character',
    english: 'glass, drinking glass',
    swedish: 'glas (att dricka ur)',
    norwegian: 'glass, drikkeglass',
    finnish: 'lasi, juomalasi',
    hungarian: 'pohár, üvegpohár, ivópohár',
    german: 'Trinkglas, Becher, Glas',
    dutch: 'glas, drinkglas',
    afrikaans: 'glas, drinkglas',
    russian: 'стакан',
    latvian: 'glāze, ūdens glāze',
    polish: 'szklanka',
    french: 'verre',
    spanish: 'vidrio',
  },
  {
    av: 14443,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a pair of glasses and incorporates two eye symbols) - Character',
    english: 'glasses, eyeglasses',
    swedish: 'glasögon',
    norwegian: 'briller',
    finnish: 'silmälasit',
    hungarian: 'szemüveg',
    german: 'Brille',
    dutch: 'bril',
    afrikaans: 'bril',
    russian: 'очки',
    latvian: 'brilles',
    polish: 'okulary',
    french: 'lunettes',
    spanish: 'gafas',
  },
  {
    av: 14450,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(door + ball: also a pictograph where the symbol suggests a goal with a ball in it) - Character (superimposed)',
    english: 'goal',
    swedish: 'mål',
    norwegian: 'mål',
    finnish: 'maali',
    hungarian: 'gól',
    german: 'Tor (Sport, erzielen)',
    dutch: 'doel, goal',
    afrikaans: 'doel',
    russian: 'гол',
    latvian: 'vārti (sportā)',
    polish: 'gol, cel',
    french: 'but',
    spanish: 'gol',
  },
  {
    av: 14451,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(creation + creation [modification, on a higher level]: above our created world is a higher Creator) - Character (superimposed - modified)',
    english: 'God',
    swedish: 'Gud',
    norwegian: 'Gud',
    finnish: 'Jumala',
    hungarian: 'Isten, Teremtő',
    german: 'Gott, Göttin',
    dutch: 'God',
    afrikaans: 'God',
    russian: 'Бог',
    latvian: 'Dievs',
    polish: 'Bóg',
    french: 'dieu',
    spanish: 'Dios',
  },
  {
    av: 14457,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(container + thing) - Character (superimposed)',
    english: 'goods, contents',
    swedish: 'innehåll, varor',
    norwegian: 'varer, gods, innhold',
    finnish: 'tavarat',
    hungarian: 'áru, árucikk, ',
    german: 'Ware',
    dutch: 'goederen',
    afrikaans: 'goedere, inhoud',
    russian: 'товар, содержимое',
    latvian: 'preces',
    polish: 'towar, zawartość, artykuł (przedmiot)',
    french: 'marchandise, contenu',
    spanish: 'bienes',
  },
  {
    av: 14625,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(grass + grass: pictograph where symbol suggests two stalks of grain.) - Character (superimposed)',
    english: 'grain, cereal',
    swedish: 'säd',
    norwegian: 'korn',
    finnish: 'vilja',
    hungarian: 'gabona, gabonanemű, gabonanövény',
    german: 'Getreide, Korn',
    dutch: 'graan, koren',
    afrikaans: 'graan (gewas)',
    russian: 'зерновые',
    latvian: 'graudi, graudaugi',
    polish: 'zboże, ziarno',
    french: 'grain, céréale',
    spanish: 'grano, cereal',
  },
  {
    av: 14626,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      "(father + parent: father of one's father or mother) - Character (superimposed)",
    english: 'grandfather, granddad, grandpa',
    swedish: 'farfar, morfar',
    norwegian: 'bestefar',
    finnish: 'isoisä, ukki, vaari',
    hungarian: 'nagyapa, nagypapa',
    german: 'Großvater, Opa',
    dutch: 'opa, grootvader',
    afrikaans: 'oupa, grootvader',
    russian: 'дедушка',
    latvian: 'vectēvs, vectētiņš, opaps',
    polish: 'dziadek',
    french: 'grand-père, grand-papa, papi',
    spanish: 'abuelo',
  },
  {
    av: 14627,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(father + mother: father of one’s mother) - Character (superimposed)',
    english: 'grandfather (maternal)',
    swedish: 'morfar',
    norwegian: 'morfar',
    finnish: 'isoisä, ukki, vaari, äidinisä',
    hungarian: 'nagyapa (anyai)',
    german: 'Großvater (mütterlicherseits)',
    dutch: 'opa (moederskant), grootvader (moederskant)',
    afrikaans: 'oupa, grootvader (moederskant)',
    russian: 'дедушка, со стороны матери',
    latvian: 'vectēvs no mātes puses',
    polish: 'dziadek ze strony matki',
    french: 'grand-père (maternel)',
    spanish: 'abuelo (materno)',
  },
  {
    av: 14628,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(father + father: father of one’s father) - Character (superimposed)',
    english: 'grandfather (paternal)',
    swedish: 'farfar',
    norwegian: 'farfar',
    finnish: 'isoisä, ukki, vaari, isänisä',
    hungarian: 'nagyapa (apai)',
    german: 'Großvater (väterlicherseits)',
    dutch: 'opa (vaderskant), grootvader (vaderskant)',
    afrikaans: 'oupa, grootvader (vaderskant)',
    russian: 'дедушка, со стороны отца',
    latvian: 'vectevs no tēva puses',
    polish: 'dziadek ze stron ojca',
    french: 'grand- père (paternel)',
    spanish: 'abuelo (paterno)',
  },
  {
    av: 14629,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      "(mother + parent: mother of one's father or mother) - Character (superimposed)",
    english: 'grandmother, grandma, granny',
    swedish: 'farmor, mormor',
    norwegian: 'bestemor',
    finnish: 'isoäiti, mummo',
    hungarian: 'nagyanya, nagymama',
    german: 'Großmutter, Oma',
    dutch: 'oma, grootmoeder',
    afrikaans: 'ouma, grootmoeder',
    russian: 'бабушка',
    latvian: 'vecāmāte, vecmāmiņa, omīte, omamma',
    polish: 'babcia',
    french: 'grand-mère, grand-maman, mami',
    spanish: 'abuela',
  },
  {
    av: 14630,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(mother + mother: mother of one’s mother) - Character (superimposed)',
    english: 'grandmother (maternal)',
    swedish: 'mormor',
    norwegian: 'mormor',
    finnish: 'isoäiti, mummo, äidinäiti',
    hungarian: 'nagyanya (anyai)',
    german: 'Großmutter (mütterlicherseits)',
    dutch: 'oma (moederskant), grootmoeder (moederskant)',
    afrikaans: 'ouma, grootmoeder (moederskant)',
    russian: 'бабушка, со стороны матери',
    latvian: 'vecmāmiņa no mātes puses',
    polish: 'babcia ze strony matki',
    french: 'grand-mère (maternelle)',
    spanish: 'abuela (materna)',
  },
  {
    av: 14631,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(mother + father: mother of one’s father) - Character (superimposed)',
    english: 'grandmother (paternal)',
    swedish: 'farmor',
    norwegian: 'farmor',
    finnish: 'isoäiti, mummo, isänäiti',
    hungarian: 'nagyanya (apai)',
    german: 'Großmutter (väterlicherseits)',
    dutch: 'oma (vaderskant), grootmoeder (moederskant)',
    afrikaans: 'ouma, grootmoeder (vaderskant)',
    russian: 'бабушка, со стороны отца',
    latvian: 'vecmāmiņa no tēva puses',
    polish: 'babcia ze strony matki',
    french: 'grand-mère (paternelle)',
    spanish: 'abuela (paterna)',
  },
  {
    av: 14632,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      "(parent + parent: the parent of one's father or mother) - Character (superimposed)",
    english: 'grandparent',
    swedish: 'farförälder, morförälder',
    norwegian: 'besteforeldre',
    finnish: 'isovanhempi',
    hungarian: 'nagyszülő',
    german: 'Großeltern',
    dutch: 'grootouder',
    afrikaans: 'grootouer',
    russian: 'прародители',
    latvian: 'vecāmāte un vectēvs',
    polish: 'dziadkowie',
    french: 'grand-parent',
    spanish: 'abuelo',
  },
  {
    av: 14635,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a cluster of grapes hanging from a stem) - Character',
    english: 'grape, grapes',
    swedish: 'vindruvor',
    norwegian: 'druer',
    finnish: 'viinirypäle',
    hungarian: 'szőlő',
    german: 'Traube, Weintraube',
    dutch: 'druiven',
    afrikaans: 'druiwe',
    russian: 'виноград',
    latvian: 'vīnogas',
    polish: 'winogrono',
    french: 'raisin',
    spanish: 'uvas',
  },
  {
    av: 14636,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a blade of grass) - Character',
    english: 'grass',
    swedish: 'gräs',
    norwegian: 'gress',
    finnish: 'ruoho',
    hungarian: 'fű',
    german: 'Gras',
    dutch: 'gras',
    afrikaans: 'gras',
    russian: 'трава',
    latvian: 'zāle',
    polish: 'trawa',
    french: 'herbe',
    spanish: 'hierba',
  },
  {
    av: 14638,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + reclining, lying (person lying down) [modification, under earthline]: place of rest below the earth) - Character (superimposed - modified)',
    english: 'grave',
    swedish: 'grav',
    norwegian: 'grav',
    finnish: 'hauta',
    hungarian: 'sírhely, sír',
    german: 'Grab',
    dutch: 'graf',
    afrikaans: 'graf',
    russian: 'могила',
    latvian: 'kaps',
    polish: 'grób',
    french: 'tombe',
    spanish: 'tumba',
  },
  {
    av: 14647,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(multiplication [half-sized]: used before another symbol to create a collective or quantitative meaning) - Character',
    english: 'group of, much of, many of, quantity of',
    swedish: 'mängd, grupp av, mycket, många',
    norwegian: 'mengde av, mye, mange, meget',
    finnish: 'joukko, ryhmä',
    hungarian: 'sok, csoportja valaminek, nagyobb mennyiség',
    german: 'Gruppe von, Gruppen',
    dutch: 'hoeveelheid, groep van',
    afrikaans: 'baie van groep van hoeveelheid van',
    russian: 'множество',
    latvian: 'daudz, daudzums',
    polish: 'dużo, wiele, licznie, liczba mnoga',
    french: 'groupe de, plusieurs',
    spanish: 'grupo de, mucho de',
  },
  {
    av: 14655,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a gun with a trigger area) - Character',
    english: 'gun, firearm',
    swedish: 'skjutvapen',
    norwegian: 'gevær, skytevåpen',
    finnish: 'tuliase, ampuma-ase',
    hungarian: 'puska, lőfegyver',
    german: 'Gewehr',
    dutch: 'geweer, handvuurwapen',
    afrikaans: 'geweer, vuurwapen',
    russian: 'огнестрельное оружие',
    latvian: 'ierocis, šaujamierocis',
    polish: 'broń, strzelba, broń palna',
    french: 'fusil, arme à feu',
    spanish: 'pistola, arma de fuego',
  },
  {
    av: 14659,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(ice + down: ice particles that fall down from the sky) - Character (superimposed)',
    english: 'hail',
    swedish: 'hagel',
    norwegian: 'hagl',
    finnish: 'raesade, rae',
    hungarian: 'jég',
    german: 'Hagel',
    dutch: 'hagel',
    afrikaans: 'hael',
    russian: 'град',
    latvian: 'krusa',
    polish: 'grad',
    french: 'grêle',
    spanish: 'granizo',
  },
  {
    av: 14660,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: used only in association with a body part or animal symbol) - Character (sequenced)',
    english: 'hair',
    swedish: 'hår',
    norwegian: 'hår',
    finnish: 'hius',
    hungarian: 'szőr, szőrzet',
    german: 'Haar',
    dutch: 'haar (lichaam, dier)',
    afrikaans: 'haar (liggaam, dier)',
    russian: 'волосы',
    latvian: 'mati',
    polish: 'włosy, sierść',
    french: 'cheveux, poils',
    spanish: 'cabello, pelo',
  },
  {
    av: 14661,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(head with hair + pointer, to hair) - Character (superimposed - pointer)',
    english: 'hair (head)',
    swedish: 'hår (på huvudet)',
    norwegian: 'hår (på hodet)',
    finnish: 'hiukset, tukka',
    hungarian: 'haj',
    german: 'Haar, Kopfhaar',
    dutch: 'hoofdhaar, haar (hoofd)',
    afrikaans: 'haar (hoof)',
    russian: 'волосы (на голове)',
    latvian: 'mati (galvas)',
    polish: 'włosy na głowie',
    french: 'cheveux',
    spanish: 'cabello (cabeza)',
  },
  {
    av: 14666,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol looks like a hammer ready to strike) - Character',
    english: 'hammer, gavel, mallet',
    swedish: 'hammare, klubba, yxa',
    norwegian: 'hammer, klubbe, øks',
    finnish: 'vasara',
    hungarian: 'kalapács',
    german: 'Hammer, Klöpfer',
    dutch: 'hamer',
    afrikaans: 'hamer',
    russian: 'молоток, киянка',
    latvian: 'āmurs, āmuriņš, koka āmurs',
    polish: 'młotek',
    french: 'marteau, maillet',
    spanish: 'martillo',
  },
  {
    av: 14667,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol reproduces the shape formed by the thumb and the index finger) - Character',
    english: 'hand',
    swedish: 'hand',
    norwegian: 'hånd',
    finnish: 'käsi',
    hungarian: 'kéz',
    german: 'Hand',
    dutch: 'hand',
    afrikaans: 'hand',
    russian: 'кисть руки',
    latvian: 'roka, plauksta',
    polish: 'ręka',
    french: 'main',
    spanish: 'mano',
  },
  {
    av: 14668,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(container + pictograph of top with a handle: pictograph that suggests a handbag with a handle) - Character (superimposed)',
    english: 'handbag, shopping bag, carrier bag',
    swedish: 'handväska',
    norwegian: 'håndveske',
    finnish: 'käsilaukku, kukkaro',
    hungarian: 'kézitáska, retikül',
    german: 'Handtasche',
    dutch: 'handtas, tas (handtas)',
    afrikaans: 'handsak',
    russian: 'сумка',
    latvian: 'rokassoma, rokassomiņa',
    polish: 'torebka, saszetka',
    french: 'sac à main',
    spanish: 'bolso',
  },
  {
    av: 14689,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a human head, with two lines indicating nose and mouth) - Character',
    english: 'head',
    swedish: 'huvud',
    norwegian: 'hode',
    finnish: 'pää',
    hungarian: 'fej',
    german: 'Kopf',
    dutch: 'hoofd',
    afrikaans: 'hoof, kop',
    russian: 'голова',
    latvian: 'galva',
    polish: 'głowa',
    french: 'tête',
    spanish: 'cabeza',
  },
  {
    av: 14690,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(person [modification] + arm: symbol suggests the outline of a person, arm bent, as if exercising to maintain health) - Character (superimposed - modified)',
    english: 'health',
    swedish: 'hälsa',
    norwegian: 'helse',
    finnish: 'terveys',
    hungarian: 'egészség',
    german: 'Gesundheit',
    dutch: 'gezondheid',
    afrikaans: 'gesondheid',
    russian: 'здоровье',
    latvian: 'veselība',
    polish: 'zdrowie',
    french: 'santé',
    spanish: 'salud',
  },
  {
    av: 14696,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pointer (left) + fire + pointer (right): suggesting radiation of heat) - Character (superimposed - pointer)',
    english: 'heat',
    swedish: 'värme',
    norwegian: 'hete, varme',
    finnish: 'lämpö',
    hungarian: 'forróság, hőség',
    german: 'Hitze',
    dutch: 'hitte',
    afrikaans: 'hitte',
    russian: 'тепло, жара',
    latvian: 'siltums, karstums',
    polish: 'ciepło',
    french: 'chaleur',
    spanish: 'calor',
  },
  {
    av: 14700,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(legs and feet + pointer, to heel) - Character (superimposed - pointer)',
    english: 'heel',
    swedish: 'häl',
    norwegian: 'hæl',
    finnish: 'kantapää',
    hungarian: 'sarok (testrész)',
    german: 'Ferse',
    dutch: 'hiel',
    afrikaans: 'hakskeen',
    russian: 'пятка',
    latvian: 'papēdis',
    polish: 'pięta',
    french: 'talon',
    spanish: 'tacón',
  },
  {
    av: 14701,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(wheel + propeller, rotor (blades): pictograph derived from airplane) - Character (superimposed)',
    english: 'helicopter',
    swedish: 'helikopter',
    norwegian: 'helikopter',
    finnish: 'helikopteri',
    hungarian: 'helikopter',
    german: 'Hubschrauber, Helicopter',
    dutch: 'helikopter',
    afrikaans: 'helikopter',
    russian: 'вертолет',
    latvian: 'helikopteris',
    polish: 'helikopter',
    french: 'hélicoptère',
    spanish: 'helicóptero',
  },
  {
    av: 14704,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(diagonal line + person: the person symbol appears to be helping the leaning line) - Character (superimposed)',
    english: 'help, aid, assistance, support',
    swedish: 'hjälp, stöd',
    norwegian: 'hjelp, støtte',
    finnish: 'apu',
    hungarian: 'segítség, támasz, támogatás',
    german: 'Hilfe, Unterstützung',
    dutch: 'steun, hulp',
    afrikaans: 'hulp, steun',
    russian: 'помощь, поддержка',
    latvian: 'palīdzība, atbalsts',
    polish: 'pomoc, służba, asysta',
    french: 'aide, support, soutien',
    spanish: 'ayuda, asistencia',
  },
  {
    av: 14708,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      "(about, concerning, in relation to, of, on + two dots: the 'of, on' arrowhead pointing to the right to the first and closest one of two dots, indicating the 'here' relationship to certain points in space) - Character (sequenced)",
    english: 'here',
    swedish: 'här',
    norwegian: 'her',
    finnish: 'täällä, tässä',
    hungarian: 'itt',
    german: 'hier',
    dutch: 'hier',
    afrikaans: 'hier',
    russian: 'здесь, тут',
    latvian: 'te, šeit',
    polish: 'tu, tutaj',
    french: 'ici',
    spanish: 'aquí',
  },
  {
    av: 14713,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(legs and feet + pointer, to hip) - Character (superimposed - pointer)',
    english: 'hip',
    swedish: 'höft',
    norwegian: 'hofte',
    finnish: 'lantio, lonkka',
    hungarian: 'csípő',
    german: 'Hüfte',
    dutch: 'heup',
    afrikaans: 'heup',
    russian: 'бедро',
    latvian: 'gurns, gūža',
    polish: 'biodro',
    french: 'hanche',
    spanish: 'cadera',
  },
  {
    av: 14714,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(animal (water) + horse (combination): taken from Greek, 'horse of the river', an animal that spends much time in water) - Character (superimposed - combined)",
    english: 'hippopotamus',
    swedish: 'flodhäst',
    norwegian: 'flodhest',
    finnish: 'virtahepo',
    hungarian: 'víziló',
    german: 'Nilpferd',
    dutch: 'nijlpaard',
    afrikaans: 'seekoei',
    russian: 'бегемот',
    latvian: 'nīlzirgs',
    polish: 'hipopotam',
    french: 'hippopotame',
    spanish: 'hipopótamo',
  },
  {
    av: 14883,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth [half-sized] + container (low) + earth [half-sized]: symbol suggests a hole in the ground) - Character (superimposed - modified)',
    english: 'hole',
    swedish: 'hål, håla, grop',
    norwegian: 'hull, grop',
    finnish: 'kuoppa, kolo, aukko',
    hungarian: 'lyuk',
    german: 'Loch',
    dutch: 'kuil, put, gat, hol',
    afrikaans: 'gat, put, holte, kuil',
    russian: 'дыра‚ яма',
    latvian: 'bedre, caurums',
    polish: 'dziura',
    french: 'trou',
    spanish: 'agujero',
  },
  {
    av: 14891,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'hook, hanger',
    swedish: 'hängare, krok',
    norwegian: 'krok, henger',
    finnish: 'koukku, ripustin',
    hungarian: 'akasztó, fogas',
    german: 'Haken, Aufhänger, Kleiderbügel',
    dutch: 'haak, kapstok',
    afrikaans: 'hak, hanger, kapstok',
    russian: 'крючок',
    latvian: 'āķis, pakaramais',
    polish: 'hak, wieszak',
    french: 'crochet',
    spanish: 'gancho, percha',
  },
  {
    av: 14894,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(early morning + pointer, to horizon) - Character (superimposed - pointer)',
    english: 'horizon',
    swedish: 'horisont',
    norwegian: 'horisont',
    finnish: 'horisontti, taivaanranta',
    hungarian: 'látóhatár, horizont',
    german: 'Horizont',
    dutch: 'horizon',
    afrikaans: 'horison',
    russian: 'горизонт',
    latvian: 'horizonts',
    polish: 'horyzont',
    french: 'horizon',
    spanish: 'horizonte',
  },
  {
    av: 14895,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character SYMBOL SYNONYM',
    english: 'trumpet, horn, cornet (1)',
    swedish: 'trumpet, kornett (1)',
    norwegian: 'trompet, kornett (1)',
    finnish: 'torvi, puhallin',
    hungarian: 'trombita, kürt',
    german: 'Trompete, Kornett (1)',
    dutch: 'trompet, hoorn (muziekinstrument) (1)',
    afrikaans: 'trompet, horing (musiekinstrument) (1)',
    russian: 'труба, горн (1)',
    latvian: 'trompete, taure, rags, kornete (1)',
    polish: 'trąbka, róg (1)',
    french: 'trompette, cor, cornet à piston (1)',
    spanish: 'trompeta, corneta (1)',
  },
  {
    av: 14896,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal (bovine), bovine, ovine + pointer, to horns) - Character (superimposed - pointer)',
    english: 'horn(s)',
    swedish: 'horn (på djur)',
    norwegian: 'horn (på dyr)',
    finnish: 'sarvi, sarvet',
    hungarian: 'szarv',
    german: 'Hörner (Tier)',
    dutch: 'hoorn(s) (dier), gewei',
    afrikaans: 'horing (dier)',
    russian: 'рог',
    latvian: 'rags, ragi',
    polish: 'róg zwierzęcy',
    french: 'corne',
    spanish: 'cuernos',
  },
  {
    av: 14897,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(animal + pictograph of horse's head and neck) - Character (superimposed)",
    english: 'horse',
    swedish: 'häst',
    norwegian: 'hest',
    finnish: 'hevonen',
    hungarian: 'ló',
    german: 'Pferd',
    dutch: 'paard',
    afrikaans: 'perd',
    russian: 'лошадь',
    latvian: 'zirgs',
    polish: 'koń',
    french: 'cheval ',
    spanish: 'caballo',
  },
  {
    av: 14905,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(foundation + protection: pictograph of the outline of a house.The symbol can also be explained as: combination of enclosure and protection.) - Character (superimposed)',
    english: 'house, building, dwelling, residence',
    swedish: 'hus, byggnad',
    norwegian: 'hus, bygning',
    finnish: 'talo, rakennus',
    hungarian: 'ház, épület, lakóhely, rezidencia, tartózkodási hely',
    german: 'Haus, Unterkunft, Wohnsitz',
    dutch: 'gebouw, huis, woning',
    afrikaans: 'gebou, huis, woning, residensie',
    russian: 'здание, дом',
    latvian: 'māja, ēka, dzīvesvieta',
    polish: 'dom, budynek, mieszkanie',
    french: 'maison, bâtiment',
    spanish: 'casa, edificio, vivienda',
  },
  {
    av: 14914,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(man + protection: this symbol, joined to the symbol for wife, produces family) - Character (superimposed)',
    english: 'husband',
    swedish: 'man, make',
    norwegian: 'ektemann',
    finnish: 'aviomies',
    hungarian: 'férj',
    german: 'Ehemann',
    dutch: 'echtgenoot',
    afrikaans: 'eggenoot, man, gade',
    russian: 'муж, супруг',
    latvian: 'vīrs',
    polish: 'mąż',
    french: 'mari, époux',
    spanish: 'marido',
  },
  {
    av: 14919,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water + thing: water transformed into a solid thing) - Character (superimposed)',
    english: 'ice',
    swedish: 'is',
    norwegian: 'is',
    finnish: 'jää',
    hungarian: 'jég, jégkocka',
    german: 'Eis',
    dutch: 'ijs (natuur)',
    afrikaans: 'ys',
    russian: 'лёд',
    latvian: 'ledus',
    polish: 'lód',
    french: 'glace',
    spanish: 'hielo',
  },
  {
    av: 14921,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'ice cream (cone)',
    swedish: 'glass, glasstrut',
    norwegian: 'is i kjeks',
    finnish: 'jäätelötötterö, jäätelötuutti',
    hungarian: 'fagylalt, fagyi',
    german: 'Eiswaffel, Eistüte',
    dutch: 'ijsje',
    afrikaans: 'roomys (horinkie)',
    russian: 'мороженое',
    latvian: 'saldējums (saldējuma konuss)',
    polish: 'lody w wafelku, rożku',
    french: 'crème glacée (cornet)',
    spanish: 'helado (cono)',
  },
  {
    av: 14924,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(legs and feet + pictograph of two curved lines, suggesting skates) - Character (superimposed)',
    english: 'ice skates',
    swedish: 'skridskor',
    norwegian: 'skøyter',
    finnish: 'luistimet',
    hungarian: 'korcsolya',
    german: 'Schlittschuh',
    dutch: 'schaatsen',
    afrikaans: 'ys skaats',
    russian: 'коньки',
    latvian: 'slidas',
    polish: 'łyżwy',
    french: 'patins à glace',
    spanish: 'patines de hielo',
  },
  {
    av: 14926,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + down: a thought issuing from the mind) - Character (superimposed)',
    english: 'idea, thought',
    swedish: 'idé, tanke',
    norwegian: 'idé, tanke',
    finnish: 'ajatus',
    hungarian: 'gondolat, ötlet, idea',
    german: 'Idee, Einfall, Idee',
    dutch: 'idee, gedachte',
    afrikaans: 'idee, gedagte, denke',
    russian: 'идея, мысль',
    latvian: 'ideja, doma',
    polish: 'idea, myśl, pomysł',
    french: 'idée',
    spanish: 'idea, pensamiento',
  },
  {
    av: 14932,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(enclosure + dot, inside the enclosure) - Character (superimposed)',
    english: 'in, inside, interior, internal',
    swedish: 'i, inne, innanför',
    norwegian: 'i, inne i, innafor',
    finnish: 'sisällä, sisäpuolella, -ssa, -ssä',
    hungarian: 'bent, belül, belső',
    german: 'innen, innerhalb, drinnen, in',
    dutch: 'in, binnen',
    afrikaans: 'in, binne-in, binnekant, interne',
    russian: 'в, внутри',
    latvian: 'iekšā, iekšpusē, interiors, iekšējs',
    polish: 'w, wewnątrz, w środku',
    french: 'dans',
    spanish: 'en, adentro, interior',
  },
  {
    av: 14941,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph of hypodermic syringe) - Character',
    english: 'injection, inoculation, shot',
    swedish: 'injektion, spruta',
    norwegian: 'injeksjon, sprøyte',
    finnish: 'ruiske, pistos, rokotus',
    hungarian: 'injekció, oltás, szuri',
    german: 'Impfung, Injektion, Spritze',
    dutch: 'injectie, spuitje, prik, inenting, vaccinatie ',
    afrikaans: 'inenting, inspuit, inspuiting',
    russian: 'инъекция, укол',
    latvian: 'injekcija, vakcinācija, iešļircinājums',
    polish: 'zastrzyk, szczepienie',
    french: 'injection',
    spanish: 'inyección, vacuna',
  },
  {
    av: 14943,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a creature with six legs) - Character',
    english: 'insect, bug',
    swedish: 'insekt',
    norwegian: 'insekt',
    finnish: 'hyönteinen',
    hungarian: 'rovar',
    german: 'Insekt',
    dutch: 'insect',
    afrikaans: 'insek',
    russian: 'насекомое',
    latvian: 'kukainis, vabole, insekts',
    polish: 'owad, robak',
    french: 'insecte',
    spanish: 'insecto',
  },
  {
    av: 14947,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(exclamation mark: used following another symbol to enhance meaning in a qualitative way) - Character',
    english: 'intensity',
    swedish: 'uppmaning, förstärkning',
    norwegian: 'intensitet, forsterkning (utropstegn)',
    finnish: 'käsky, kehotus, tehostus, vahvistus',
    hungarian: 'intenzitás, nyomatékosítás jele',
    german: 'Intensität',
    dutch: 'intensiteit',
    afrikaans: 'intensiteit',
    russian: 'интенсивность',
    latvian: 'spraigums, intensitāte',
    polish: 'intensywność',
    french: 'intensité',
    spanish: 'intensidad',
  },
  {
    av: 14952,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(forward + enclosure: the arrow is entering the enclosure) - Character (superimposed)',
    english: 'into',
    swedish: 'in, ingång',
    norwegian: 'inn i, inn',
    finnish: 'sisään',
    hungarian: 'be, -be, bele',
    german: 'hinein, in, herein',
    dutch: 'in (voorwaarts), ingang (voorwaarts), erin (voorwaarts)',
    afrikaans: 'binne-in',
    russian: 'в, во внутрь',
    latvian: 'iekšā (prievārds)',
    polish: 'w, do środka',
    french: 'dans, en',
    spanish: 'en',
  },
  {
    av: 14955,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'iron, smoothing iron',
    swedish: 'strykjärn',
    norwegian: 'strykejern',
    finnish: 'silitysrauta',
    hungarian: 'vasaló',
    german: 'Bügeleisen',
    dutch: 'strijkijzer, strijkbout',
    afrikaans: 'strykyster',
    russian: 'утюг',
    latvian: 'gludeklis, gludināšana',
    polish: 'żelazko',
    french: 'fer à repasser',
    spanish: 'plancha',
  },
  {
    av: 14958,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water (ground level) + earth + water (ground level): land surrounded by water on ground level) - Character (superimposed)',
    english: 'island',
    swedish: 'ö',
    norwegian: 'øy',
    finnish: 'saari',
    hungarian: 'sziget',
    german: 'Insel',
    dutch: 'eiland',
    afrikaans: 'eiland',
    russian: 'остров',
    latvian: 'sala',
    polish: 'wyspa',
    french: 'île',
    spanish: 'isla',
  },
  {
    av: 14960,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(CKB says that this symbol is derived from small. The symbol also looks like the top part of the symbols for man and woman minus the specific gender parts. It refers to things rather than to people.) - Character',
    english: 'it, itself',
    swedish: 'den, det (pronomen)',
    norwegian: 'den, det (pronomen)',
    finnish: 'se',
    hungarian: 'az, azt, ő, őt (semleges nem)',
    german: 'es, sein',
    dutch: 'het',
    afrikaans: 'dit',
    russian: 'он, она, оно (кроме человека)',
    latvian: 'tas, tā (vsk. 3.pers.vietniekvārds)',
    polish: 'to',
    french: 'il, elle (3e pers. sing. personnel)',
    spanish: 'eso, lo',
  },
  {
    av: 14973,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(bones with joint + pointer to the junction where they meet) - Character (superimposed - sequenced - pointer)',
    english: 'joint',
    swedish: 'led',
    norwegian: 'ledd',
    finnish: 'nivel',
    hungarian: 'ízület',
    german: 'Gelenk',
    dutch: 'gewricht',
    afrikaans: 'gewrig',
    russian: 'сустав, сочленение',
    latvian: 'locītava',
    polish: 'wspólne',
    french: 'articulation',
    spanish: 'articulación',
  },
  {
    av: 15144,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a key) - Character',
    english: 'key',
    swedish: 'nyckel',
    norwegian: 'nøkkel',
    finnish: 'avain',
    hungarian: 'kulcs',
    german: 'Schlüssel',
    dutch: 'sleutel',
    afrikaans: 'sleutel',
    russian: 'ключ',
    latvian: 'atslēga',
    polish: 'klucz',
    french: 'clef',
    spanish: 'clave',
  },
  {
    av: 15152,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(mouth + mouth: two mouths touching) - Character (superimposed)',
    english: 'kiss',
    swedish: 'kyss, puss',
    norwegian: 'kyss',
    finnish: 'suudelma, suukko, pusu',
    hungarian: 'csók',
    german: 'Kuss',
    dutch: 'kus, zoen',
    afrikaans: 'kus, soen',
    russian: 'поцелуй',
    latvian: 'skūpsts ',
    polish: 'pocałunek, buziak',
    french: 'baiser, bisou',
    spanish: 'beso',
  },
  {
    av: 15155,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'kite',
    swedish: 'drake',
    norwegian: 'drake',
    finnish: 'leija',
    hungarian: 'sárkány (játék)',
    german: 'Drachen',
    dutch: 'vlieger',
    afrikaans: 'vlieër',
    russian: 'змей воздушный',
    latvian: 'gaisa pūķis',
    polish: 'latawiec',
    french: 'cerf-volant',
    spanish: 'cometa',
  },
  {
    av: 15157,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(kneeling (kneeling person) + pointer, to knee joint) - Character (superimposed - pointer)',
    english: 'knee',
    swedish: 'knä',
    norwegian: 'kne',
    finnish: 'polvi',
    hungarian: 'térd',
    german: 'Knie',
    dutch: 'knie',
    afrikaans: 'knieg',
    russian: 'колено',
    latvian: 'celis',
    polish: 'kolano',
    french: 'genou',
    spanish: 'rodilla',
  },
  {
    av: 15159,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a knife or sword. The diagonal orientation of knife is the same as that of fork and spoon.) - Character',
    english: 'knife, sword',
    swedish: 'kniv, svärd',
    norwegian: 'kniv, sverd',
    finnish: 'veitsi, puukko',
    hungarian: 'kés, tőr, kard',
    german: 'Messer',
    dutch: 'zwaard, mes',
    afrikaans: 'mes, swaard',
    russian: 'нож',
    latvian: 'nazis, zobens',
    polish: 'nóż, miecz, szpada, szabla',
    french: 'couteau, épée',
    spanish: 'cuchillo, espada',
  },
  {
    av: 15162,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(combination of mind and enclosure: store house of the mind) - Character',
    english: 'knowledge, class (in combinations)',
    swedish: 'kunskap, skolämne (i kombinationer)',
    norwegian: 'kunnskap',
    finnish: 'tieto',
    hungarian: 'tudás, tantermi oktatás (szóösszetételben)',
    german: 'Wissen',
    dutch: 'kennis',
    afrikaans: 'kennis',
    russian: 'знание, предмет (в сочетании)',
    latvian: 'zināšanas, mācības, kursi (kombinācijās)',
    polish: 'wiedza',
    french: 'cours (leçon), connaissance',
    spanish: 'conocimiento, clase (en combinaciones)',
  },
  {
    av: 15166,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'ladder',
    swedish: 'stege',
    norwegian: 'stige',
    finnish: 'tikapuut, tikkaat',
    hungarian: 'létra',
    german: 'Leiter',
    dutch: 'ladder',
    afrikaans: 'leer',
    russian: 'лестница переносная',
    latvian: 'pārnēsājamās kāpnes',
    polish: 'drabina',
    french: 'échelle',
    spanish: 'escalera',
  },
  {
    av: 15172,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(mouth + ear: what is spoken and heard) - Character (superimposed)',
    english: 'language',
    swedish: 'språk',
    norwegian: 'språk',
    finnish: 'kieli, puhekieli',
    hungarian: 'nyelv (beszélt)',
    german: 'Sprache',
    dutch: 'taal',
    afrikaans: 'taal',
    russian: 'язык',
    latvian: 'valoda',
    polish: 'język, mowa',
    french: 'langue (langage)',
    spanish: 'idioma',
  },
  {
    av: 15180,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(grass + earth: land covered with grass) - Character (superimposed)',
    english: 'lawn, meadow',
    swedish: 'gräsmatta, äng',
    norwegian: 'gressplen, eng',
    finnish: 'ruohikko, heinikkö, niitty',
    hungarian: 'gyep, pázsit, rét, tisztás',
    german: 'Wiese, Rasen',
    dutch: 'grasveld, wei, weide',
    afrikaans: 'weiveld, grasveld, weide, heide',
    russian: 'лужайка, луг',
    latvian: 'zāliens, pļava',
    polish: 'trawnik',
    french: 'pelouse, gazon',
    spanish: 'césped',
  },
  {
    av: 15183,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'leaf',
    swedish: 'blad, löv',
    norwegian: 'blad, løv',
    finnish: 'lehti',
    hungarian: 'falevél, levél',
    german: 'Blatt',
    dutch: 'blad (boom)',
    afrikaans: 'blaar',
    russian: 'листок, лист',
    latvian: 'lapa',
    polish: 'liść',
    french: 'feuille (arbre)',
    spanish: 'hoja',
  },
  {
    av: 15188,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(legs and feet + pointer, to leg) - Character (superimposed - pointer)',
    english: 'leg',
    swedish: 'ben',
    norwegian: 'bein, ben',
    finnish: 'jalka',
    hungarian: 'láb, lábszár',
    german: 'Bein',
    dutch: 'been',
    afrikaans: 'been',
    russian: 'нога',
    latvian: 'kāja',
    polish: 'noga',
    french: 'jambe',
    spanish: 'pierna',
  },
  {
    av: 15189,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a side view of a pair of legs and feet) - Character',
    english: 'legs and feet',
    swedish: 'ben och fötter',
    norwegian: 'bein og føtter, ben og føtter',
    finnish: 'jalat',
    hungarian: 'láb',
    german: 'Bein und Füsse',
    dutch: 'benen en voeten',
    afrikaans: 'bene en voete',
    russian: 'ноги',
    latvian: 'kājas un pēdas',
    polish: 'nogi, kończyny dolne',
    french: 'jambes et pieds',
    spanish: 'piernas y pies',
  },
  {
    av: 15190,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: suggests a lemon with stem) - Character',
    english: 'lemon',
    swedish: 'citron',
    norwegian: 'sitron',
    finnish: 'sitruuna',
    hungarian: 'citrom',
    german: 'Zitrone',
    dutch: 'citroen',
    afrikaans: 'suurlemoen',
    russian: 'лимон',
    latvian: 'citrons',
    polish: 'cytryna',
    french: 'citron',
    spanish: 'limón',
  },
  {
    av: 15193,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(horizontal line bounded by two reference lines [half-sized]: the horizontal line extends full length within the symbol square) - Character',
    english: 'length, longness',
    swedish: 'längd',
    norwegian: 'lengde',
    finnish: 'pituus',
    hungarian: 'hossz, hosszúság, hossza',
    german: 'lang',
    dutch: 'lengte',
    afrikaans: 'lengte',
    russian: 'длина',
    latvian: 'garums, attālums',
    polish: 'długość',
    french: 'longueur',
    spanish: 'longitud',
  },
  {
    av: 15198,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests an envelope) - Character',
    english: 'letter, mail, post',
    swedish: 'brev, post',
    norwegian: 'brev, post, mail',
    finnish: 'kirje, posti',
    hungarian: 'levél, postai levél, posta',
    german: 'Brief',
    dutch: 'brief, post',
    afrikaans: 'brief, pos',
    russian: 'письмо',
    latvian: 'vēstule, pasta sūtījums',
    polish: 'list, poczta, przesyłka pocztowa',
    french: 'lettre, courrier postal',
    spanish: 'carta',
  },
  {
    av: 15200,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + outline of leaves: symbol suggests a leafy vegetable with the grass-like edible portion above ground) - Character (superimposed)',
    english: 'lettuce, leafy vegetable',
    swedish: 'sallad, spenat (etc)',
    norwegian: 'salat, bladgrønnsak',
    finnish: 'lehtisalaatti, lehtivihannes, lehtivihreä',
    hungarian: 'fejessaláta, egyéb leveles zöldség',
    german: 'Blattgemüse, Salatkopf',
    dutch: 'bladgroente, sla',
    afrikaans: 'slaai, blaar groente',
    russian: 'салат, шпинат',
    latvian: 'salāti, lapu dārzāji',
    polish: 'sałata (warzywo)',
    french: 'laitue, salade',
    spanish: 'lechuga, vegetal de hoja',
  },
  {
    av: 15206,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sun + person, in combination: energy produced by the sun supports life on earth) - Character (superimposed)',
    english: 'life',
    swedish: 'liv',
    norwegian: 'liv',
    finnish: 'elämä',
    hungarian: 'élet',
    german: 'Leben',
    dutch: 'het leven, leven (zelfst. nw.)',
    afrikaans: 'lewe',
    russian: 'жизнь',
    latvian: 'dzīve',
    polish: 'życie',
    french: 'vie',
    spanish: 'vida',
  },
  {
    av: 15208,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sun + eye: we see by the light of the sun) - Character (superimposed)',
    english: 'light',
    swedish: 'ljus',
    norwegian: 'lys',
    finnish: 'valo',
    hungarian: 'fény, világosság',
    german: 'Licht',
    dutch: 'licht (zelfst.nw)',
    afrikaans: 'lig',
    russian: 'свет',
    latvian: 'gaisma',
    polish: 'światło',
    french: 'lumière',
    spanish: 'luz',
  },
  {
    av: 15209,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sky + electricity: electricity that comes from the sky) - Character (superimposed)',
    english: 'lightning',
    swedish: 'blixt',
    norwegian: 'lyn',
    finnish: 'salamointi, salama',
    hungarian: 'villám, villámlás',
    german: 'Blitz',
    dutch: 'bliksem',
    afrikaans: 'weerlig',
    russian: 'молния',
    latvian: 'zibens',
    polish: 'piorun, błyskawica, grzmot',
    french: 'éclair, foudre',
    spanish: 'relámpago',
  },
  {
    av: 15212,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(time + limit(s)) - Character (superimposed)',
    english: 'limited time, interval, period, awhile, for a while',
    swedish: 'begränsad tid, period, stund',
    norwegian: 'periode, begrenset tid',
    finnish: 'ajanjakso, rajattu aika',
    hungarian: 'időtartam, időköz, szünet, intervallum',
    german: 'Zeitspanne, begrenzte Zeit, Zeitabstand, eine Weile',
    dutch: 'beperkte tijd, periode',
    afrikaans: 'wyle, beperkte tyd, periode',
    russian: 'период',
    latvian: 'ierobežots laika periods, intervāls, mirklis, uz mirkli',
    polish: 'ograniczony czas, okres, limit czasowy',
    french: 'période de temps',
    spanish: 'tiempo limitado, intervalo, período',
  },
  {
    av: 15214,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(symbol is a full-sized vertical line) - Character',
    english: 'line, stripe',
    swedish: 'linje, rad, rand, streck',
    norwegian: 'linje, strek, rad, stripe',
    finnish: 'viiva, suora, juova, raita',
    hungarian: 'vonal, egyenes, egyenes vonal, csík',
    german: 'Linie, Streifen, Strich',
    dutch: 'lijn, streep',
    afrikaans: 'lyn, streep',
    russian: 'линия, полоса, черта',
    latvian: 'līnija, svītra',
    polish: 'linia, pasek, sznurek',
    french: 'ligne, bande',
    spanish: 'línea, franja',
  },
  {
    av: 15218,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mouth + pointer, from above + pointer, from below: the pinters indicating the lips) - Character (superimposed - pointer)',
    english: 'lip(s)',
    swedish: 'läppar',
    norwegian: 'lepper',
    finnish: 'huulet',
    hungarian: 'ajak',
    german: 'Lippe',
    dutch: 'lippen',
    afrikaans: 'lippe',
    russian: 'губы',
    latvian: 'lūpa (-as)',
    polish: 'wargi',
    french: 'lèvres',
    spanish: 'labios',
  },
  {
    av: 15226,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a crustacean with pincers) - Character',
    english: 'crab, shellfish (with claws)',
    swedish: 'hummer, krabba, kräfta, skaldjur',
    norwegian: 'hummer, krabbe, kreps, skalldyr',
    finnish: 'hummeri, rapu',
    hungarian: 'rák, rákfélék',
    german: 'Krabbe, Krebs, Hummer, Schalentier',
    dutch: 'krab',
    afrikaans: 'krap',
    russian: 'омар, краб',
    latvian: 'krabis, vēžveidīgais (ar spīlēm)',
    polish: 'rak, krab, skorupiak (ze szczypcami)',
    french: 'crabe, crustacé à pinces',
    spanish: 'cangrejo (con pinzas)',
  },
  {
    av: 15399,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(feeling + arrow [modification, prolonged and as if partly hidden]: feeling as if an arrow is piercing one's heart) - Character (superimposed - modified)",
    english: 'love, affection',
    swedish: 'kärlek',
    norwegian: 'kjærlighet',
    finnish: 'rakkaus, kiintymys, mieltymys',
    hungarian: 'szeretet, szerelem, vonzódás, vonzalom',
    german: 'Liebe, Zuneigung',
    dutch: 'liefde',
    afrikaans: 'liefde',
    russian: 'любовь',
    latvian: 'mīlestība, pieķeršanās',
    polish: 'miłość',
    french: 'amour, affection, passion',
    spanish: 'amor, afecto',
  },
  {
    av: 15406,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sun + wheel: the sun provides the energy that drives the wheels of machinery) - Character (superimposed)',
    english: 'machine, appliance, engine, motor',
    swedish: 'maskin, apparat, motor',
    norwegian: 'maskin, motor',
    finnish: 'kone',
    hungarian: 'gép, motor, eszköz, készülék',
    german: 'Maschine, Gerät, Motor',
    dutch: 'motor, machine, apparaat',
    afrikaans: 'motor, enjin, apparaat',
    russian: 'машина, устройство, двигатель',
    latvian: 'mašīna, iekārta, motors',
    polish: 'maszyna, urządzenie mechaniczne, silnik',
    french: 'machine, appareil, moteur',
    spanish: 'máquina, motor',
  },
  {
    av: 15416,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(person [modification] + action (combination): CKB says man embodies the action principle in society. The symbol also looks like a stick figure of a man wearing trousers.) See also: activity, male gender (in combinations) 12335, and male, masculine (person) 15414. - Character (superimposed - modified - combined)',
    english: 'man, male',
    swedish: 'man, karl, gubbe, farbror',
    norwegian: 'mann',
    finnish: 'mies',
    hungarian: 'férfi',
    german: 'Mann',
    dutch: 'man',
    afrikaans: 'man',
    russian: 'мужчина',
    latvian: 'vīrietis, vīriešu kārtas',
    polish: 'człowiek, mężczyzna',
    french: 'homme',
    spanish: 'hombre, masculino',
  },
  {
    av: 15417,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(standing (standing person) + pictograph of penis: used as the base character for penis) - Character (superimposed)',
    english: 'male genitals (man with penis)',
    swedish: 'manligt könsorgan (man med penis)',
    norwegian: 'mann (med penis)',
    finnish: 'mies',
    hungarian: 'férfi nemiszervek (jelkép szinoníma)',
    german: 'Mann (mit männlichen Geschlechtsteilen)',
    dutch: 'man',
    afrikaans: 'man geslagsdele (man met penis)',
    russian: 'мужские гениталии',
    latvian: 'vīriešu dzimumorgāni (vīrietis ar dzimumlocekli)',
    polish: 'mężczyzna (płciowe)',
    french: 'homme (en tant que mâle)',
    spanish: 'hombre, masculino (con pene)',
  },
  {
    av: 15419,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph, mango with stem + pit) - Character (superimposed)',
    english: 'mango',
    swedish: 'mango',
    norwegian: 'mango',
    finnish: 'mango',
    hungarian: 'mangó',
    german: 'Mango',
    dutch: 'mango',
    afrikaans: 'mango, veselperske',
    russian: 'манго',
    latvian: 'mango',
    polish: 'mango',
    french: 'mangue',
    spanish: 'mango',
  },
  {
    av: 15422,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'maple-leaf',
    swedish: 'lönnlöv',
    norwegian: 'lønneblad',
    finnish: 'vaahteranlehti',
    hungarian: 'juharlevél',
    german: 'Ahornblatt',
    dutch: 'esdoornblad',
    afrikaans: 'esdoornblaar',
    russian: 'кленовый лист',
    latvian: 'kļavas lapa',
    polish: 'liść klonu',
    french: "feuille d'érable",
    spanish: 'hojas de arce',
  },
  {
    av: 15425,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(protection + combination, connection: joining together and living under one roof) - Character (superimposed)',
    english: 'marriage',
    swedish: 'äktenskap',
    norwegian: 'ekteskap',
    finnish: 'avioliitto',
    hungarian: 'házasság',
    german: 'Hochzeit, Ehe',
    dutch: 'huwelijk',
    afrikaans: 'huwelik',
    russian: 'бракосочетание',
    latvian: 'lalība',
    polish: 'ślub, małżeństwo',
    french: 'mariage',
    spanish: 'matrimonio',
  },
  {
    av: 15431,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + earth [half-sized]: thing that you get from the earth, i.e., raw material. The symbol is also used for material in a general sense.) - Character (superimposed)',
    english: 'material, raw material, stuff',
    swedish: 'material',
    norwegian: 'materiale',
    finnish: 'materiaali, aine',
    hungarian: 'anyag, nyersanyag',
    german: 'Material',
    dutch: 'materiaal',
    afrikaans: 'materiaal (rou)',
    russian: 'материал',
    latvian: 'materiāls, izejmateriāls',
    polish: 'materiał, surowiec',
    french: 'matière',
    spanish: 'material (en crudo)',
  },
  {
    av: 15432,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + digits (computer): science of numbers) - Character (superimposed) SYMBOL SYNONYM',
    english: 'mathematics, arithmetic, math (2)',
    swedish: 'matematik (2)',
    norwegian: 'matematikk (2)',
    finnish: 'matematiikka',
    hungarian: 'matematika, matek',
    german: 'Mathematik, Arithmetik, Rechnen, Mathe (2)',
    dutch: 'wiskunde, rekenen (2)',
    afrikaans: 'wiskunde, rekenkunde (2)',
    russian: 'математика (2)',
    latvian: 'matemātika, aritmētika (2)',
    polish: 'matematyka (2)',
    french: 'mathématiques, arithmétique (science) (2)',
    spanish: 'matemáticas (2)',
  },
  {
    av: 15441,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(to think + to say + to write: significance the mind attaches to what is spoken or written) - Character (superimposed)',
    english: 'meaning, sense, significance',
    swedish: 'betydelse',
    norwegian: 'betydning, mening',
    finnish: 'merkitys',
    hungarian: 'jelentés, értelem, jelentőség, fontosság',
    german: 'Bedeutung, Sinn, Sinngehalt, Signifikanz',
    dutch: 'betekenis',
    afrikaans: 'betekenis, sin, beduidend',
    russian: 'значение',
    latvian: 'nozīme, jēga, nozīmīgums',
    polish: 'znaczenie',
    french: 'signification',
    spanish: 'significado',
  },
  {
    av: 15443,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(length, longness + shortness (ditance, lenght): combination of long and short) - Character (superimposed - combined)',
    english: 'measurement, measure',
    swedish: 'mått, längdmått',
    norwegian: 'mål (lengde), lengdemål',
    finnish: 'mitta, mittaus',
    hungarian: 'mérce, méret, mérés, mérték',
    german: 'Abmessung',
    dutch: 'afmeting, maat',
    afrikaans: 'mate',
    russian: 'измерение',
    latvian: 'mērījums, izmērs',
    polish: 'miara, linijka (1)',
    french: 'mesure (longueur)',
    spanish: 'medida',
  },
  {
    av: 15451,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a scroll on one post) - Character',
    english: 'Megillah (Book of Esther)',
    swedish: 'megillah (Israel)',
    norwegian: 'megillah (Israel)',
    finnish: 'Esterin kirja, Megila',
    hungarian: 'Megilla (héber)',
    german: 'boekrol',
    dutch: 'megillah (Joods)',
    afrikaans: 'Megillah',
    russian: 'свиток, мегилла (Израиль)',
    latvian: 'Megila (Esteres grāmata, Izraēla)',
    polish: 'Megilla (Księga Estery) hebr.',
    french: "livre d'Esther, Magila",
    spanish: 'Megillah (Libro de Esther)',
  },
  {
    av: 15452,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: fruit with stem [modification], showing thick rind) - Character',
    english: 'melon',
    swedish: 'melon',
    norwegian: 'melon',
    finnish: 'melooni',
    hungarian: 'görögdinnyel',
    german: 'Melone',
    dutch: 'meloen, watermeloen',
    afrikaans: 'spanspek',
    russian: 'дыня, арбуз',
    latvian: 'melone',
    polish: 'melon',
    french: 'melon',
    spanish: 'melón',
  },
  {
    av: 15454,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests the nine branched candelabra used on Chanukah) - Character',
    english: 'menorah',
    swedish: 'menorah (Israel)',
    norwegian: 'menorah (Israel)',
    finnish: 'menora',
    hungarian: 'menóra, kilencágú gyertyatartó (Izrael)',
    german: 'menorah',
    dutch: 'menorah (Joods)',
    afrikaans: 'menorah',
    russian: 'менора, восьмивечник (Израиль)',
    latvian: 'menora',
    polish: 'menora (hebr)',
    french: 'ménorah (chandelier juif)',
    spanish: 'menorah',
  },
  {
    av: 15460,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(mouth [modification, up in the sky] + flower [modification, longer stem] + earth [half-sized] (combination): 'flowery speech', a signal that what follows should not be taken literally) - Character (superimposed - modified - combined)",
    english: 'metaphor',
    swedish: 'bildlig betydelse, metafor, liknelse (allmän)',
    norwegian: 'metafor, billedlig betydning',
    finnish: 'kuvaannollinen ilmaus, vertaus, kielikuva',
    hungarian: 'hasonlat, szókép, metafóra',
    german: 'Metapher',
    dutch: 'metafoor',
    afrikaans: 'metafoor',
    russian: 'метафора',
    latvian: 'metafora',
    polish: 'metafora, przenośnia',
    french: 'métaphore',
    spanish: 'metáfora',
  },
  {
    av: 15463,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + electromagnetic radiation) - Character (superimposed)',
    english: 'microwave oven',
    swedish: 'mikrovågsugn, mikro',
    norwegian: 'mikrobølgeovn',
    finnish: 'mikroaaltouuni',
    hungarian: 'mikrohullámú sütő, mikró',
    german: 'Mikrowellenherd, Mikrowelle',
    dutch: 'magnetron (Nl), microgolfoven',
    afrikaans: 'mikrogolf oond',
    russian: 'микроволновая печь',
    latvian: 'mikroviļņu krāsns',
    polish: 'kuchenka mikrofalowa, mikrofalówka',
    french: 'four micro-ondes',
    spanish: 'horno microondas',
  },
  {
    av: 15464,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + pointer, to centre) - Character (superimposed - pointer)',
    english: 'middle, centre',
    swedish: 'mitt',
    norwegian: 'midten, sentrum',
    finnish: 'keskus, keskusta',
    hungarian: 'közép, központ, közepe valaminek, centrum',
    german: 'Mitte, mittlerer Teil',
    dutch: 'midden',
    afrikaans: 'middel',
    russian: 'средина, центр',
    latvian: 'vidus, centrs',
    polish: 'środek, centrum',
    french: 'centre, milieu',
    spanish: 'medio',
  },
  {
    av: 15471,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(symbol suggests an outline of a skull) - Character',
    english: 'mind, intellect, reason',
    swedish: 'förstånd, tankar',
    norwegian: 'forstand, sinn, tanke',
    finnish: 'mieli, järki',
    hungarian: 'ész, értelem, szellem, intellektus',
    german: 'Verstand, Intellekt, Vernunft',
    dutch: 'verstand',
    afrikaans: 'verstand, rede, intellek',
    russian: 'ум, разум',
    latvian: 'prāts, intelekts, spriestspēja',
    polish: 'umysł, rozum, intelekt',
    french: 'esprit',
    spanish: 'mente, intelecto, razón',
  },
  {
    av: 15472,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mountain + dot: dot locates the position of a mine deep within the mountain) - Character (superimposed)',
    english: 'mine',
    swedish: 'gruva',
    norwegian: 'gruve',
    finnish: 'kaivos',
    hungarian: 'bánya',
    german: 'Bergwerk',
    dutch: 'mijn (kolen of erts)',
    afrikaans: 'myn',
    russian: 'рудник, копь, шахта',
    latvian: 'raktuves',
    polish: 'kopalnia',
    french: 'mine',
    spanish: 'mina',
  },
  {
    av: 15474,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(subtraction [half-sized]: the small meaning of subtraction. The symbol is used before another symbol to create a negative meaning, e.g. (minus + sound) to represent silence.) - Character',
    english: 'minus, no, without',
    swedish: 'utan, minus',
    norwegian: 'uten, foruten, minus',
    finnish: 'miinus, ilman, paitsi, pois',
    hungarian: 'nélkül, mínusz, hiánya valaminek',
    german: 'kein, ohne',
    dutch: 'zonder, min',
    afrikaans: 'sonder, minus, daarsonder',
    russian: 'минус, без',
    latvian: 'mīnus, bez',
    polish: 'minus, brak, nie',
    french: 'moins (signe)',
    spanish: 'menos, sin',
  },
  {
    av: 15476,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: arrow bent into another direction as if reflected) - Character',
    english: 'arrow (bent)',
    swedish: 'pil (böjd), reflex',
    norwegian: 'pil (bøyd)',
    finnish: 'nuoli (taipunut), nuoli (taittunut)',
    hungarian: 'hajlított nyíl',
    german: 'gebeugter Pfeil',
    dutch: 'pijl (terugkerend)',
    afrikaans: 'pyl gebuig',
    russian: 'рефлекс',
    latvian: 'bulta (saliekta)',
    polish: 'strzałka (zagięta)',
    french: 'flèche (réflexion)',
    spanish: 'flecha (doblada)',
  },
  {
    av: 15484,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(symbol suggests a modified rod of Mercury, the traditional symbol for trade and commerce) - Character',
    english: 'money, cash',
    swedish: 'pengar',
    norwegian: 'penger, kontanter',
    finnish: 'raha',
    hungarian: 'pénz',
    german: 'Geld',
    dutch: 'geld',
    afrikaans: 'geld',
    russian: 'деньги',
    latvian: 'nauda, skaidra nauda',
    polish: 'pieniądze, gotówka, finanse',
    french: 'argent, argent liquide',
    spanish: 'dinero',
  },
  {
    av: 15649,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(moon [modification, as of half-moon]) - Character (modified)',
    english: 'month',
    swedish: 'månad',
    norwegian: 'måned',
    finnish: 'kuukausi',
    hungarian: 'hónap',
    german: 'Monat',
    dutch: 'maand',
    afrikaans: 'maand',
    russian: 'месяц',
    latvian: 'mēnesis ',
    polish: 'miesiąc',
    french: 'mois',
    spanish: 'mes',
  },
  {
    av: 15651,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: crescent shape resembling the curved shape of the moon in its first quarters) - Character',
    english: 'moon',
    swedish: 'måne',
    norwegian: 'måne',
    finnish: 'kuu',
    hungarian: 'hold',
    german: 'Mond',
    dutch: 'maan',
    afrikaans: 'maan',
    russian: 'луна',
    latvian: 'mēness',
    polish: 'księżyc',
    french: 'lune',
    spanish: 'luna',
  },
  {
    av: 15656,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(combination of sun and earth: time when the sun appears above the horizon) - Character ',
    english: 'morning (early)',
    swedish: 'morgon',
    norwegian: 'morgen',
    finnish: 'aamu',
    hungarian: 'reggel',
    german: 'früh am Morgen',
    dutch: 'ochtend, morgend',
    afrikaans: 'vroegoggend',
    russian: 'утро',
    latvian: 'agrs rīts',
    polish: 'rano, o świcie',
    french: 'matin',
    spanish: 'mañana (temprano)',
  },
  {
    av: 15662,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(protection + woman: woman who gives protection to her family) - Character (superimposed)',
    english: 'mother, mom, mommy, mum',
    swedish: 'mamma, mor',
    norwegian: 'mamma, mor',
    finnish: 'äiti',
    hungarian: 'anya, édesanya, anyu, mama, mami',
    german: 'Mutter',
    dutch: 'moeder, mama',
    afrikaans: 'moeder, mamma, ma',
    russian: 'мама, мать',
    latvian: 'māte, mamma, māmiņa',
    polish: 'mama, matka, mamusia',
    french: 'mère, maman',
    spanish: 'madre, mamá, mami',
  },
  {
    av: 15663,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests the side view of a mountain slope) - Character',
    english: 'mountain',
    swedish: 'berg, fjäll',
    norwegian: 'fjell, berg',
    finnish: 'vuori, vaara, kallio',
    hungarian: 'hegy',
    german: 'Berg, Hügel',
    dutch: 'berg',
    afrikaans: 'berg',
    russian: 'гора',
    latvian: 'kalns, augstkalne',
    polish: 'góra',
    french: 'montagne',
    spanish: 'montaña',
  },
  {
    av: 15666,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a round open mouth) - Character',
    english: 'mouth',
    swedish: 'mun',
    norwegian: 'munn',
    finnish: 'suu',
    hungarian: 'száj',
    german: 'Mund',
    dutch: 'mond',
    afrikaans: 'mond',
    russian: 'рот',
    latvian: 'mute',
    polish: 'usta',
    french: 'bouche',
    spanish: 'boca',
  },
  {
    av: 15672,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth [modification, extended line] + water (ground level): mixture composed of more earth than water) - Character (superimposed - modified)',
    english: 'mud, clay',
    swedish: 'lera',
    norwegian: 'leire, søle',
    finnish: 'muta, lieju, savi',
    hungarian: 'sár, agyag',
    german: 'Schlamm, Morast, Dreck, Schmutz',
    dutch: 'modder',
    afrikaans: 'modder, klei',
    russian: 'глина',
    latvian: 'māls, māli',
    polish: 'błoto, glina',
    french: 'boue',
    spanish: 'barro, arcilla',
  },
  {
    av: 15673,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(based upon the international mathematical symbol) - Character',
    english: 'multiplication',
    swedish: 'multiplikation',
    norwegian: 'multiplikasjon',
    finnish: 'kertolasku, kertominen',
    hungarian: 'szorzás',
    german: 'Multiplikation',
    dutch: 'vermenigvuldiging, maal',
    afrikaans: 'vermenigvuldig, maal',
    russian: 'умножение',
    latvian: 'reizināšana',
    polish: 'mnożenie',
    french: 'multiplication',
    spanish: 'multiplicación',
  },
  {
    av: 15678,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'mushroom',
    swedish: 'svamp',
    norwegian: 'sopp',
    finnish: 'sieni',
    hungarian: 'gomba',
    german: 'Pilz',
    dutch: 'paddestoel',
    afrikaans: 'sampioen',
    russian: 'гриб',
    latvian: 'sēne',
    polish: 'grzyb',
    french: 'champignon',
    spanish: 'seta',
  },
  {
    av: 15682,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(international symbol) - Character',
    english: 'musical note, music (in combinations)',
    swedish: 'ton',
    norwegian: 'note',
    finnish: 'nuotti',
    hungarian: 'hangjegy',
    german: 'Note',
    dutch: 'muzieknoot',
    afrikaans: 'musiek noot',
    russian: 'нота',
    latvian: 'nots',
    polish: 'nuta, dźwięk',
    french: 'note de musique',
    spanish: 'nota musical',
  },
  {
    av: 15689,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a nail. It is twice the height of the pin symbol) - Character',
    english: 'nail',
    swedish: 'spik',
    norwegian: 'spiker',
    finnish: 'naula',
    hungarian: 'szög',
    german: 'Nagel',
    dutch: 'spijker',
    afrikaans: 'spyker',
    russian: 'гвоздь',
    latvian: 'nagla',
    polish: 'gwóźdź',
    french: 'clou',
    spanish: 'clavo',
  },
  {
    av: 15691,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pen + mouth: something that can be spoken or written) - Character (superimposed)',
    english: 'name, label, term, title',
    swedish: 'namn, titel',
    norwegian: 'navn, tittel',
    finnish: 'nimi, termi',
    hungarian: 'név, címke, felirat',
    german: 'Name, Titel',
    dutch: 'naam, label',
    afrikaans: 'naam, terme, titel, etiket',
    russian: 'имя',
    latvian: 'vārds, nosaukums, apzīmējums, termins',
    polish: 'nazwa, etykieta, tytuł',
    french: 'nom',
    spanish: 'nombre, etiqueta, título',
  },
  {
    av: 15699,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(head + pictograph of neck + pointer, to neck) - Character (superimposed - pointer)',
    english: 'neck (head)',
    swedish: 'hals',
    norwegian: 'hals',
    finnish: 'kaula',
    hungarian: 'nyak (a fej felől)',
    german: 'Hals',
    dutch: 'hals',
    afrikaans: 'nek (hoof)',
    russian: 'шея, горло',
    latvian: 'kakls',
    polish: 'szyja (przy głowie)',
    french: 'cou, gorge',
    spanish: 'cuello (cabeza)',
  },
  {
    av: 15700,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(body + pointer, to neck) - Character (superimposed - pointer)',
    english: 'neck (body)',
    swedish: 'nacke',
    norwegian: 'nakke',
    finnish: 'kaula, niska',
    hungarian: 'nyak (a test felől)',
    german: 'Nacken, Genick',
    dutch: 'nek',
    afrikaans: 'nek (liggaam)',
    russian: 'затылок',
    latvian: 'pakausis',
    polish: 'kark, szyja (przy tułowiu)',
    french: 'cou (partie du corps)',
    spanish: 'cuello (cuerpo)',
  },
  {
    av: 15701,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(person, leaning, as if in need of support) - Character',
    english: 'need (needy person)',
    swedish: 'behov (behövande person)',
    norwegian: 'hjelpetrengende',
    finnish: 'tarve',
    hungarian: 'szükség, szükségben lévő, szükséget látó személy',
    german: 'Bedürfnis, Bedarf, Not, bedürftige Person',
    dutch: 'behoefte, nood',
    afrikaans: 'behoefte (behoeftige persoon)',
    russian: 'нужда',
    latvian: 'vajadzība (pēc palīdzības)',
    polish: 'potrzeba, konieczność',
    french: "personne en besoin d'aide, personne en état de besoin",
    spanish: 'persona necesitada',
  },
  {
    av: 15703,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a sewing needle with an eye) - Character',
    english: 'needle',
    swedish: 'nål, synål',
    norwegian: 'synål, nål',
    finnish: 'silmäneula, neula',
    hungarian: 'varrótű, tű',
    german: 'Nähnadel',
    dutch: 'naald',
    afrikaans: 'naald',
    russian: 'игла',
    latvian: 'adata',
    polish: 'igła',
    french: 'aiguille',
    spanish: 'aguja',
  },
  {
    av: 15712,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(eye + ear: information received through the eye and the ear) - Character (superimposed)',
    english: 'news',
    swedish: 'nyhet',
    norwegian: 'nyhet',
    finnish: 'uutiset',
    hungarian: 'hír',
    german: 'Nachrichten, Nachrichtensendung',
    dutch: 'nieuws',
    afrikaans: 'nuus',
    russian: 'новость',
    latvian: 'ziņas, jaunumi',
    polish: 'wiadomość, informacja',
    french: 'nouvelles',
    spanish: 'noticias',
  },
  {
    av: 15719,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(moon + earth: the moon appears above the horizon; it shines on the earth during the night) - Character (superimposed)',
    english: 'night',
    swedish: 'natt',
    norwegian: 'natt',
    finnish: 'oliivi',
    hungarian: 'éjszaka, éjjel',
    german: 'Nacht',
    dutch: 'nacht',
    afrikaans: 'nag',
    russian: 'ночь',
    latvian: 'nakts',
    polish: 'noc',
    french: 'nuit',
    spanish: 'noche',
  },
  {
    av: 15726,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(meaning + deletion, cancellation, destruction: something that has no meaning) - Character (superimposed)',
    english: 'nonsense',
    swedish: 'struntprat, nonsens',
    norwegian: 'tullprat, nonsens, tøv',
    finnish: 'nisan, nisán',
    hungarian: 'értelmetlenség, badarság, ostobaság, nonszensz',
    german: 'Unsinn, Quatsch, dummes Zeug',
    dutch: 'onzin',
    afrikaans: 'nonsens, onsin',
    russian: 'чепуха, бессмыслица',
    latvian: 'nieki, blēņas',
    polish: 'nonsens',
    french: 'absurdité, sottise',
    spanish: 'disparates',
  },
  {
    av: 15730,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sun + pointer, to north) - Character (superimposed - pointer)',
    english: 'north',
    swedish: 'norr',
    norwegian: 'nord',
    finnish: 'ei mitään (vanha), ei kukaan (vanha)',
    hungarian: 'észak',
    german: 'Norden, Nord',
    dutch: 'noord, noorden',
    afrikaans: 'noord',
    russian: 'север',
    latvian: 'ziemeļi',
    polish: 'Północ (kierunek)',
    french: 'nord',
    spanish: 'norte',
  },
  {
    av: 15732,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests the side view of a nose) - Character',
    english: 'nose',
    swedish: 'näsa, nos',
    norwegian: 'nese',
    finnish: 'pötyä!',
    hungarian: 'orr',
    german: 'Nase',
    dutch: 'neus',
    afrikaans: 'neus',
    russian: 'нос',
    latvian: 'deguns',
    polish: 'nos',
    french: 'nez',
    spanish: 'nariz',
  },
  {
    av: 15736,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(ago, then (past) + then, so, later: present [half-sized]) - Character (sequenced)',
    english: 'now',
    swedish: 'nu',
    norwegian: 'nå',
    finnish: 'pohjoinen, pohjois-',
    hungarian: 'most, jelenleg',
    german: 'nun, jetzt, gerade jetzt',
    dutch: 'nu',
    afrikaans: 'nou',
    russian: 'сейчас',
    latvian: 'tagad',
    polish: 'teraz',
    french: 'maintenant',
    spanish: 'ahora',
  },
  {
    av: 15737,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(minus + ground: a combination of minus and place) - Character (superimposed)',
    english: 'nowhere, no place',
    swedish: 'ingenstans',
    norwegian: 'ingensteds',
    finnish: 'nenä',
    hungarian: 'sehol, sehova',
    german: 'nirgends, nirgendwo',
    dutch: 'nergens',
    afrikaans: 'nêrens',
    russian: 'нигде',
    latvian: 'nekur, nevienā vietā',
    polish: 'nigdzie',
    french: 'nulle part',
    spanish: 'en ninguna parte',
  },
  {
    av: 15740,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pointer (left) + nucleus + pointer (right): suggesting radiation of radioactive particles) - Character (superimposed - pointer)',
    english: 'nuclear radiation, radioactivity',
    swedish: 'radioaktivitet',
    norwegian: 'radioaktivitet',
    finnish: 'marraskuu',
    hungarian: 'atomsugárzás, rádióaktivitás',
    german: 'radioaktive Strahlung',
    dutch: 'radioactieve straling, radioactiviteit',
    afrikaans: 'kern radiasie, radioaktiwiteit',
    russian: 'радиоактивность',
    latvian: 'radioaktīvais starojums, radioaktivitāte',
    polish: 'promieniowanie jądrowe',
    french: 'radioactivité',
    spanish: 'radiación nuclear, radioactividad',
  },
  {
    av: 15741,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(atom + pointer (small), to inner nucleus) - Character (superimposed - pointer (small))',
    english: 'nucleus (atom)',
    swedish: 'atomkärna',
    norwegian: 'atomkjerne',
    finnish: 'nyt',
    hungarian: 'atommag',
    german: 'Atomkern',
    dutch: 'kern (atoom)',
    afrikaans: 'kern (atoom)',
    russian: 'ядро атома',
    latvian: 'kodols',
    polish: 'jądro (atomu)',
    french: 'atome, noyau atomique',
    spanish: 'núcleo',
  },
  {
    av: 15742,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(international symbol) - Character',
    english: 'number',
    swedish: 'nummer, siffra',
    norwegian: 'tall, antall, siffer',
    finnish: 'ei missään',
    hungarian: 'szám',
    german: 'Nummer, Zahl',
    dutch: 'getal, cijfer',
    afrikaans: 'nommer',
    russian: 'номер',
    latvian: 'numurs',
    polish: 'numer, liczba',
    french: 'nombre',
    spanish: 'número',
  },
  {
    av: 15912,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(protection + male + female: male or female born under the family roof) - Character (superimposed)',
    english: 'offspring, child',
    swedish: 'barn, avkomma',
    norwegian: 'avkom, barn',
    finnish: 'totella, noudattaa',
    hungarian: 'utód, leszármazott, gyereke valakinek, sarjadék',
    german: 'Nachkommen, Kind',
    dutch: 'kind',
    afrikaans: 'kind',
    russian: 'потомок, отпрыск',
    latvian: 'pēcnacējs, bērns',
    polish: 'dzieci, potomstwo',
    french: 'progéniture, descendance',
    spanish: 'descendencia',
  },
  {
    av: 15914,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water, fluid, liquid + water (ground level): two parallel liquid symbols, suggesting oil that floats on water) - Character (superimposed)',
    english: 'oil, lubricant',
    swedish: 'olja',
    norwegian: 'olje',
    finnish: 'meri, valtameri',
    hungarian: 'olaj, síkosító',
    german: 'Öl',
    dutch: 'olie',
    afrikaans: 'olie, smeermiddel',
    russian: 'масло',
    latvian: 'eļļa, lubrikants',
    polish: 'olej, smar',
    french: 'huile, lubrifiant',
    spanish: 'petróleo',
  },
  {
    av: 15917,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: fruit [oval shaped] with stem) - Character',
    english: 'olive',
    swedish: 'oliv',
    norwegian: 'oliven',
    finnish: 'jälkeläinen',
    hungarian: 'olajbogyó, olíva',
    german: 'Olive',
    dutch: 'olijf',
    afrikaans: 'olyf',
    russian: 'олива',
    latvian: 'olīva',
    polish: 'oliwka',
    french: 'olive',
    spanish: 'oliva, aceituna',
  },
  {
    av: 15918,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(earth [half-sized] + pointer: refers only to space, e.g. on the table) - Character (superimposed - pointer)',
    english: 'on',
    swedish: 'på',
    norwegian: 'på',
    finnish: 'usein',
    hungarian: 'on, -en, -ön, rajta, -ra, -re (térben)',
    german: 'auf, drauf',
    dutch: 'op, bovenop',
    afrikaans: 'op, bo-op',
    russian: 'на, в',
    latvian: 'uz, iekšā',
    polish: 'na',
    french: 'sur',
    spanish: 'en',
  },
  {
    av: 15920,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph + earth) - Character (superimposed)',
    english: 'bulb (plant)',
    swedish: 'lök (allmänt)',
    norwegian: 'løk (plante)',
    finnish: 'vanha',
    hungarian: 'gumó, hagyma (növényé)',
    german: 'Blumenzwiebel',
    dutch: 'bol',
    afrikaans: 'bol (plant)',
    russian: 'луковица',
    latvian: 'sīpols',
    polish: 'cebula (warzywo)',
    french: 'oignon, bulbe',
    spanish: 'bulbo (planta)',
  },
  {
    av: 15923,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure, open at the top) - Character',
    english: 'opening',
    swedish: 'öppning',
    norwegian: 'åpning',
    finnish: 'avaus',
    hungarian: 'nyílás, nyitás, kinyitás',
    german: 'Öffnung',
    dutch: 'opening, gat',
    afrikaans: 'opening, gat',
    russian: 'открытость, отверстие',
    latvian: 'sprauga, atstarpe, atvere',
    polish: 'otwarcie',
    french: 'ouverture',
    spanish: 'abertura',
  },
  {
    av: 15925,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + mouth: expression of what one thinks) - Character (superimposed)',
    english: 'opinion',
    swedish: 'åsikt, mening',
    norwegian: 'mening',
    finnish: 'mielipide',
    hungarian: 'vélemény, nézet',
    german: 'Meinung',
    dutch: 'mening',
    afrikaans: 'opinie, mening',
    russian: 'мнение, взгляд, убеждение',
    latvian: 'domas, uzskati, viedoklis',
    polish: 'opinia',
    french: 'opinion, avis',
    spanish: 'opinión',
  },
  {
    av: 15927,
    group: 'character',
    pos: 'GRAY',
    derivationExplanation:
      '(combination of up and down: up is the opposite of down. The symbol is placed before a second symbol to create an antonym or meaning that is the opposite of that of the second symbol.) - Character',
    english: 'opposite meaning, opposite of, opposite',
    swedish: 'motsatt betydelse, motsats',
    norwegian: 'motsatt mening',
    finnish: 'vastakohta',
    hungarian: 'ellenkező értelem, ellentéte, ellenkezője valaminek',
    german: 'Gegenteil, gegensätzliche Bedeutung',
    dutch: 'tegenovergestelde',
    afrikaans: 'teenoorgeste',
    russian: 'противоположность',
    latvian: 'pretējs, pretējas nozīmes',
    polish: 'przeciwieństwo, odmienne od',
    french: 'contraire de, opposé à',
    spanish: 'significado opuesto, opuesto a',
  },
  {
    av: 15928,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(less than (relation) + less than (relation), pointing in the opposite direction from the purpose symbol) - Character (sequenced)',
    english: 'opposition, counter purpose',
    swedish: 'motstånd, motsatt avsikt',
    norwegian: 'motstand, opposisjon',
    finnish: 'vastustus, vastarinta',
    hungarian: 'ellenállás, ellenzés, ellenkezés, szembenállás',
    german: 'Gegenteil',
    dutch: 'tegenstelling, tegengesteld doel',
    afrikaans: 'opposisie teenstellende aanwyser doel',
    russian: 'сопротивление, возражение',
    latvian: 'pretestība, pretošanās',
    polish: 'przeciwieństwo, opozycja',
    french: 'opposition',
    spanish: 'oposición, propósito contrario',
  },
  {
    av: 15929,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(by, by means of, of (relation [half-sized], pointing backward) + dot: the second alternative, the reverse of either) - Character (superimposed)',
    english: 'or',
    swedish: 'eller, antingen eller',
    norwegian: 'eller, enten eller',
    finnish: 'tai, vai, eli',
    hungarian: 'vagy',
    german: 'oder',
    dutch: 'of',
    afrikaans: 'of',
    russian: 'или',
    latvian: 'vai, jeb',
    polish: 'lub',
    french: 'ou',
    spanish: 'o',
  },
  {
    av: 15933,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(fruit + pictograph of segments) - Character (superimposed)',
    english: 'orange, citrus fruit',
    swedish: 'apelsin, citrusfrukt',
    norwegian: 'appelsin, sitrusfrukt',
    finnish: 'appelsiini, sitrushedelmä',
    hungarian: 'narancs, citrusféle',
    german: 'Orange, Apfelsine, Zitrusfrucht',
    dutch: 'citrusvrucht, appelsien (Vl), sinaasappel',
    afrikaans: 'lemoen, sitrus vrug',
    russian: 'апельсин',
    latvian: 'apelsīns',
    polish: 'pomarańcza, owoc cytrusowy',
    french: 'orange (fruit), agrume',
    spanish: 'naranja, fruta cítrica',
  },
  {
    av: 15942,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(enclosure + dot, outside the enclosure) - Character (sequenced)',
    english: 'out, exterior, external, outside',
    swedish: 'ute, utanför',
    norwegian: 'ute, utenfor',
    finnish: 'ulkona, ulkopuolella',
    hungarian: 'kint, kívül, külső, kintlévő, kívüllévő, kül-',
    german: 'außerhalb, außen, draußen',
    dutch: 'buiten, uit',
    afrikaans: 'buite, eksterne',
    russian: 'снаружи, вне',
    latvian: 'aiz, ārpusē, ārpuses',
    polish: 'na zewnątrz, poza',
    french: 'dehors, extérieur',
    spanish: 'afuera, exterior, externo',
  },
  {
    av: 15943,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(enclosure + forward: the arrow is moving out of the enclosure) - Character (superimposed)',
    english: 'out of, exit (forward)',
    swedish: 'ut, ur, utgång',
    norwegian: 'ut av, utgang (forover)',
    finnish: 'ulos, pois jostakin',
    hungarian: 'ból, -ből, kifelé (kifelé irányuló)',
    german: 'aus, heraus, hinaus',
    dutch: 'uit (voorwaarts), uitgang (voorwaarts), eruit (voorwaarts)',
    afrikaans: 'uit uitgaan uitgang (vorentoe)',
    russian: 'из, наружу',
    latvian: 'ārā, iziet',
    polish: 'wyjście, opuszczenie (w przód)',
    french: 'sortie',
    spanish: 'fuera de (hacia delante), salida (hacia delante)',
  },
  {
    av: 15944,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(enclosure + downward) - Character (superimposed)',
    english: 'out of, exit (downward)',
    swedish: 'ut, ur, nedgång',
    norwegian: 'ut av, utgang (nedover)',
    finnish: 'alaspäin, ulos',
    hungarian: 'ból, -ből, lefelé (lefelé irányuló)',
    german: 'hinaus, Eingang',
    dutch: 'uit (neerwaarts), uitgang (neerwaarts), eruit (neerwaarts)',
    afrikaans: 'out uitgang (afwaarts)',
    russian: 'наружу вниз',
    latvian: 'ārā, noiet',
    polish: 'wyjście, opuszczenie (w dół)',
    french: 'sortie (vers le bas)',
    spanish: 'fuera de (hacia abajo), salida (hacia abajo)',
  },
  {
    av: 15948,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(dot + horizontal reference line: the dot is over or above the line) - Character (superimposed)',
    english: 'over, above, superior',
    swedish: 'över, ovanför',
    norwegian: 'over, ovenfor',
    finnish: 'yli, yläpuolella, yllä',
    hungarian: 'fent, felette, felső, felüllévő ',
    german: 'über, oberhalb, über',
    dutch: 'boven, over',
    afrikaans: 'bo-oor, bo, hoër',
    russian: 'над',
    latvian: 'virs',
    polish: 'nad',
    french: 'au-dessus',
    spanish: 'encima',
  },
  {
    av: 15952,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph of shell + water) - Character (superimposed)',
    english: 'oyster, clam, mussel',
    swedish: 'mussla, ostron',
    norwegian: 'musling, østers',
    finnish: 'osteri, simpukka',
    hungarian: 'osztriga, kagyló',
    german: 'Auster, Muschel',
    dutch: 'oester',
    afrikaans: 'oester, gapermossel, mossel',
    russian: 'устрица, моллюск',
    latvian: 'austere, ēdamais gliemezis',
    polish: 'ostryga, małż',
    french: 'huître, coquillage',
    spanish: 'ostra, almeja',
  },
  {
    av: 15953,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a pail with a handle) - Character',
    english: 'pail, bucket',
    swedish: 'hink, korg, spann',
    norwegian: 'spann, bøtte, kurv',
    finnish: 'sanko, ämpäri',
    hungarian: 'vödör, csöbör',
    german: 'Eimer',
    dutch: 'emmer',
    afrikaans: 'emmer',
    russian: 'ведро',
    latvian: 'spainis, liels kauss',
    polish: 'wiadro',
    french: 'seau',
    spanish: 'cubo',
  },
  {
    av: 15960,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: the symbols suggests a tree with curved fronds) - Character',
    english: 'palm',
    swedish: 'palm',
    norwegian: 'palme',
    finnish: 'palmu',
    hungarian: 'pálma',
    german: 'Palme',
    dutch: 'palmboom',
    afrikaans: 'palmboom',
    russian: 'пальма',
    latvian: 'palma',
    polish: 'palma',
    french: 'palmier',
    spanish: 'palma',
  },
  {
    av: 15962,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a sheet of paper or a page of a book) See also: book 12875 - Character',
    english: 'paper, card, page',
    swedish: 'papper, sida',
    norwegian: 'papir, side, ark',
    finnish: 'paperi, sivu',
    hungarian: 'papír, papírlap, cédula, oldal',
    german: 'Papier, Seite',
    dutch: 'papier, blad (papier)',
    afrikaans: 'papier, kaart, bladsy',
    russian: 'бумага‚ страница',
    latvian: 'papīrs, kartiņa, lappuse',
    polish: 'kartka, papier, dokument, strona',
    french: 'papier, page, feuille',
    spanish: 'papel, tarjeta, página',
  },
  {
    av: 15964,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(line + line: international mathematical symbol) - Character',
    english: 'parallel',
    swedish: 'parallell',
    norwegian: 'parallell',
    finnish: 'yhdensuuntainen',
    hungarian: 'párhuzamos',
    german: 'parallel',
    dutch: 'parallel',
    afrikaans: 'parralel',
    russian: 'параллель',
    latvian: 'paralēls',
    polish: 'równolegle',
    french: 'parallèle',
    spanish: 'paralelo',
  },
  {
    av: 15966,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'parcel, package',
    swedish: 'paket',
    norwegian: 'pakke',
    finnish: 'paketti',
    hungarian: 'csomag',
    german: 'Paket',
    dutch: 'pakje, pak',
    afrikaans: 'pakkie, pakket',
    russian: 'пакет, посылка',
    latvian: 'sūtijums, paciņa, paka',
    polish: 'paczka, ładunek',
    french: 'colis, paquet',
    spanish: 'paquete',
  },
  {
    av: 15968,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(protection + person: person who gives protection to his or her family) - Character (superimposed)',
    english: 'parent',
    swedish: 'förälder',
    norwegian: 'forelder',
    finnish: 'vanhempi',
    hungarian: 'szülő',
    german: 'Eltern',
    dutch: 'ouder (vader of moeder), ouders',
    afrikaans: 'ouer',
    russian: 'родитель',
    latvian: 'vecāks',
    polish: 'rodzic',
    french: 'parent',
    spanish: 'padre',
  },
  {
    av: 15969,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(flower + earth + tree: place with flowers and trees) - Character (superimposed)',
    english: 'park',
    swedish: 'park',
    norwegian: 'park',
    finnish: 'puisto',
    hungarian: 'park',
    german: 'Park',
    dutch: 'park',
    afrikaans: 'park',
    russian: 'парк',
    latvian: 'parks',
    polish: 'park, ogród miejski',
    french: 'parc',
    spanish: 'parque',
  },
  {
    av: 15972,
    group: 'character',
    pos: 'GRAY',
    derivationExplanation:
      "(division [half-sized]: a part is created when something is divided) With the gloss 'part of', the symbol is used before another symbol to create a new meaning, which is part of the meaning of the original symbol, i.e., part of + language = word. See Note p. II-106 in BRG) - Character",
    english: 'part, bit, piece, portion, part of',
    swedish: 'del, bit, stycke, del av',
    norwegian: 'del av, bit, del',
    finnish: 'osa, pala, viipale',
    hungarian: 'rész, része valaminek, darabka, részlet',
    german: 'Teil, Stück, Portion, Anteil',
    dutch: 'gedeelte, deel, stuk',
    afrikaans: 'deel van gedeelte deel stuk van, stuk',
    russian: 'часть, доля',
    latvian: 'daļa',
    polish: 'część, kawałek',
    french: 'partie de',
    spanish: 'parte, porción, trocito, pedacito',
  },
  {
    av: 15975,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(outline of parabolic mirror focused on what lies behind it) - Character',
    english: 'past',
    swedish: 'förfluten tid',
    norwegian: 'fortid',
    finnish: 'menneisyys, mennyt aika',
    hungarian: 'múlt, a múlt',
    german: 'Vergangenheit',
    dutch: 'verleden (zelfst nw)',
    afrikaans: 'verlede',
    russian: 'прошлое',
    latvian: 'pagātne',
    polish: 'przeszłość',
    french: 'passé',
    spanish: 'pasado',
  },
  {
    av: 15978,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + pointer, to paw or hoof) - Character (superimposed - pointer)',
    english: 'paw',
    swedish: 'tass, labb (etc)',
    norwegian: 'labb, pote (o.l.)',
    finnish: 'tassu, kavio, käpälä, sorkka',
    hungarian: 'mancs',
    german: 'Pfote, Tatze',
    dutch: 'poot, klauw',
    afrikaans: 'poot, klou',
    russian: 'лапа',
    latvian: 'ķepa, ķetna',
    polish: 'łapa, kopyto, racica',
    french: 'patte',
    spanish: 'pata',
  },
  {
    av: 15981,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + world: feeling of being at one with the world) - Character (superimposed)',
    english: 'peace, peace of mind, serenity',
    swedish: 'frid, ro, lugn',
    norwegian: 'fred, ro i sinnet, ro',
    finnish: 'rauha, mielenrauha',
    hungarian: 'lelkibéke, lelkinyugalom, békesség, nyugalom',
    german: 'Zufriedenheit, Gelassenheit, Ruhe, Friede',
    dutch: 'vrede (in gedachte)',
    afrikaans: 'vrede, rustig, kalm',
    russian: 'мир, покой',
    latvian: 'miers, mierīgums',
    polish: 'spokój, relaks, odprężenie',
    french: 'paix (sentiment)',
    spanish: 'paz, tranquilidad, serenidad',
  },
  {
    av: 15983,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph with stem + pit) - Character (superimposed)',
    english: 'peach, nectarine',
    swedish: 'persika, nektarin',
    norwegian: 'fersken, nektarin',
    finnish: 'persikka, nektariini',
    hungarian: 'őszibarack, nektarin',
    german: 'Pfirsich, Nektarine',
    dutch: 'nectarine',
    afrikaans: 'perske',
    russian: 'персик, нектарин',
    latvian: 'persiks, nektarīns',
    polish: 'brzoskwinia, nektarynka',
    french: 'pêche (fruit)',
    spanish: 'melocotón',
  },
  {
    av: 15986,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph with stem) - Character',
    english: 'pear',
    swedish: 'päron',
    norwegian: 'pære',
    finnish: 'päärynä',
    hungarian: 'körte',
    german: 'Birne',
    dutch: 'peer',
    afrikaans: 'peer',
    russian: 'груша',
    latvian: 'bumbieris',
    polish: 'gruszka',
    french: 'poire',
    spanish: 'pera',
  },
  {
    av: 15987,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a cross section of two peas in a pod) - Character',
    english: 'pea(s)',
    swedish: 'ärtor',
    norwegian: 'erter',
    finnish: 'herne, herneet',
    hungarian: 'zödborsó, borsó',
    german: 'Erbse',
    dutch: 'erwt',
    afrikaans: 'ertjie',
    russian: 'горох',
    latvian: 'zirņi',
    polish: 'groch',
    french: 'pois',
    spanish: 'guisante',
  },
  {
    av: 15991,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a pen or pencil in writing position) - Character',
    english: 'pen, pencil',
    swedish: 'penna',
    norwegian: 'penn, blyant, kulepenn',
    finnish: 'kynä',
    hungarian: 'toll, ceruza, írótoll',
    german: 'Stift, Kugelschreiber',
    dutch: 'potlood, pen',
    afrikaans: 'pen, potlood',
    russian: 'ручка, карандаш',
    latvian: 'pildspalva',
    polish: 'długopis, ołówek',
    french: 'crayon, stylo',
    spanish: 'lápiz',
  },
  {
    av: 15994,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(male genitals (man with penis) + pointer) - Character (superimposed - pointer)',
    english: 'penis',
    swedish: 'penis, snopp',
    norwegian: 'penis, tiss',
    finnish: 'penis, siitin',
    hungarian: 'hímvessző, pénisz',
    german: 'Penis',
    dutch: 'penis, piemel, plasser',
    afrikaans: 'penis',
    russian: 'пенис',
    latvian: 'dzimumlockelis',
    polish: 'penis',
    french: 'pénis',
    spanish: 'pene',
  },
  {
    av: 15995,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph with stem) - Character',
    english: 'pepper (vegetable)',
    swedish: 'paprika',
    norwegian: 'paprika',
    finnish: 'pippurikasvi, paprika',
    hungarian: 'paprika, zöldpaprika',
    german: 'Pfeffer, Paprika',
    dutch: 'paprika',
    afrikaans: 'peper (groente)',
    russian: 'паприка, болгарский перец',
    latvian: 'pipars (dārzenis)',
    polish: 'papryka (warzywo) (świeże)',
    french: 'poivron',
    spanish: 'pimiento (vegetal)',
  },
  {
    av: 15998,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(line, stripe + ground: international mathematical symbol) - Character (superimposed)',
    english: 'perpendicular',
    swedish: 'lod',
    norwegian: 'loddrett, vinkelrett, perpendikulær',
    finnish: 'kohtisuora, pystysuora',
    hungarian: 'merőleges',
    german: 'lotrecht, senkrecht',
    dutch: 'loodrecht',
    afrikaans: 'loodreguit',
    russian: 'перпендикуляр',
    latvian: 'perpendikuls, perpendikulārs',
    polish: 'prostopadle',
    french: 'perpendiculaire',
    spanish: 'perpendicular',
  },
  {
    av: 16161,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(symbol suggests a human being standing, with feet turned out) - Character',
    english: 'person, human being, individual, human',
    swedish: 'person, människa',
    norwegian: 'person, menneske',
    finnish: 'henkilö, ihminen',
    hungarian: 'személy, egyén, emberi lény',
    german: 'Person, Mensch, Individuum',
    dutch: 'persoon, mens',
    afrikaans: 'persoon, mens, individueel, homosapien',
    russian: 'человек',
    latvian: 'cilvēks, dzīva būtne, indivīds',
    polish: 'osoba, człowiek',
    french: 'personne, être humain, individu',
    spanish: 'persona, ser humano',
  },
  {
    av: 16162,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(person [modification]: showing knees bent) - Character (modified)',
    english: 'kneeling (kneeling person)',
    swedish: 'knäböjande (person på knä)',
    norwegian: 'person (knelende)',
    finnish: 'polvillaan oleva henkilö',
    hungarian: 'térdelés, térdelő személy',
    german: 'knieende Person',
    dutch: 'persoon (geknield), mens (geknield)',
    afrikaans: 'persoon (knielend)',
    russian: 'человек (на коленях)',
    latvian: 'uz ceļiem nometies cilvēks',
    polish: 'osoba na klęczkach, klęcząca',
    french: 'personne (à genoux)',
    spanish: 'persona (de rodillas)',
  },
  {
    av: 16163,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(person [modification]: lying on his back) - Character (modified)',
    english: 'reclining, lying (person lying down)',
    swedish: 'liggande (liggande person)',
    norwegian: 'person (liggende)',
    finnish: 'makaava henkilö',
    hungarian: 'fekvés, fekvő személy',
    german: 'liegende Person',
    dutch: 'persoon (liggend), mens (liggend)',
    afrikaans: 'persoon (lêend)',
    russian: 'человек (лежачее положение)',
    latvian: 'gulošs cilvēks',
    polish: 'osoba leżąca, leżący',
    french: 'personne (position couchée)',
    spanish: 'persona tumbada, persona acostada',
  },
  {
    av: 16164,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(person [modification]: lying on his back with knees drawn up as if sick or in pain) - Character (modified)',
    english: 'illness, disease, sickness (sick person)',
    swedish: 'sjukdom (sjuk person)',
    norwegian: 'person (syk)',
    finnish: 'sairaus, sairas henkilö',
    hungarian: 'betegség, ágyban fekvő személy',
    german: 'Krankheit (kranke Person)',
    dutch: 'ziekte',
    afrikaans: 'siekte (siek persoon)',
    russian: 'человек (больной)',
    latvian: 'slims cilvēks',
    polish: 'choroba, ból',
    french: 'maladie, personne (malade)',
    spanish: 'enfermedad (persona enferma)',
  },
  {
    av: 16165,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(person [modification]: in sitting position) - Character (modified)',
    english: 'seat, sitting (sitting person)',
    swedish: 'sits, säte (sittande person)',
    norwegian: 'person (sittende)',
    finnish: 'istuva henkilö',
    hungarian: 'ülés, ülő személy',
    german: 'Sitzfläche',
    dutch: 'zittend, persoon (zittend)',
    afrikaans: 'sit sittende (persoon)',
    russian: 'человек (сидящий)',
    latvian: 'sēdošs cilvēks',
    polish: 'osoba siedząca, siedzący',
    french: 'personne (position assise)',
    spanish: 'asiento, sentada (persona)',
  },
  {
    av: 16166,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(person [modification]: in standing position) - Character (modified)',
    english: 'standing (standing person)',
    swedish: 'stående (stående person)',
    norwegian: 'person (stående)',
    finnish: 'seisova henkilö',
    hungarian: 'állás, álló személy',
    german: 'stehende Person',
    dutch: 'persoon (staand), mens (staand)',
    afrikaans: 'staan staande (persoon)',
    russian: 'человек (стоящий)',
    latvian: 'stāvošs cilvēks',
    polish: 'osoba stojąca, stojący',
    french: 'personne (position debout)',
    spanish: 'persona (de pie)',
  },
  {
    av: 16167,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(person [modification]: buckling at the knees as though weak) - Character (modified)',
    english: 'weakness (weak person)',
    swedish: 'svaghet (svag person)',
    norwegian: 'person svak, svakhet, veikhet',
    finnish: 'heikko henkilö',
    hungarian: 'gyengeség, gyenge, megroggyanó térdű személy',
    german: 'schwach (Person), gebrechlich (Person)',
    dutch: 'persoon (zwak), mens (zwak)',
    afrikaans: 'swak (persoon)',
    russian: 'человек (слабый)',
    latvian: 'vārgs, vājš, novārdzis cilvēks',
    polish: 'osłabienie, słabość (osoba)',
    french: 'personne (faible)',
    spanish: 'debilidad, persona (débil)',
  },
  {
    av: 16175,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(animal + pictograph of curly tail) - Character (superimposed)',
    english: 'pig',
    swedish: 'gris',
    norwegian: 'gris',
    finnish: 'sika, porsas',
    hungarian: 'sertés, disznó',
    german: 'Schwein',
    dutch: 'varken',
    afrikaans: 'vark',
    russian: 'свинья',
    latvian: 'cūka',
    polish: 'świnia',
    french: 'cochon, porc',
    spanish: 'cerdo',
  },
  {
    av: 16177,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(bed + pointer, to pillow) - Character (superimposed - pointer)',
    english: 'pillow, cushion',
    swedish: 'kudde',
    norwegian: 'pute, sengepute',
    finnish: 'tyyny',
    hungarian: 'párna',
    german: 'Kopfkissen, Kissen',
    dutch: 'kussen (bed)',
    afrikaans: 'kussing',
    russian: 'подушка',
    latvian: 'spilvens',
    polish: 'poduszka',
    french: 'oreiller',
    spanish: 'almohada, almohadón',
  },
  {
    av: 16180,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(face + dot + pointer, to dot) - Character (superimposed - pointer)',
    english: 'pimple, blemish',
    swedish: 'finne, utslag',
    norwegian: 'kvise, blemme (o.l.)',
    finnish: 'finni, näppylä',
    hungarian: 'pattanás, kiütés',
    german: 'Pickel, Pustel',
    dutch: 'puist, pukkel',
    afrikaans: 'puisie, aknee, ontsiering',
    russian: 'прыщ, сыпь',
    latvian: 'pinne, ādas izsitums',
    polish: 'trądzik, krosty, wypryski',
    french: 'bouton, pustule',
    spanish: 'espinilla',
  },
  {
    av: 16181,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a pin. It is half the height of the nail symbol.) - Character',
    english: 'pin',
    swedish: 'stift (etc)',
    norwegian: 'stift',
    finnish: 'nuppineula, nasta',
    hungarian: 'biztosítótű, gombostű, hajtű',
    german: 'Stecknadel',
    dutch: 'speld',
    afrikaans: 'speld',
    russian: 'булавка',
    latvian: 'adata',
    polish: 'szpilka, pinezka',
    french: 'épingle',
    spanish: 'perno',
  },
  {
    av: 16182,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph with stem and leaves) - Character',
    english: 'pineapple',
    swedish: 'ananas',
    norwegian: 'ananas',
    finnish: 'ananas',
    hungarian: 'ananász',
    german: 'Ananas',
    dutch: 'ananas',
    afrikaans: 'pynappel',
    russian: 'ананас',
    latvian: 'ananāss',
    polish: 'ananas',
    french: 'ananas',
    spanish: 'piña',
  },
  {
    av: 16186,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(smoking (pipe) + pointer, to the pipe bowl) - Character (superimposed - pointer)',
    english: 'pipe, smoking pipe',
    swedish: 'pipa',
    norwegian: 'pipe',
    finnish: 'piippu',
    hungarian: 'pipa',
    german: 'Pfeife, Tabakpfeife',
    dutch: 'pijp (roken)',
    afrikaans: 'pyp (rook)',
    russian: 'трубка курительная',
    latvian: 'tabakas pīpe',
    polish: 'tytoń fajkowy',
    french: 'pipe (tabac)',
    spanish: 'pipa de tabaco',
  },
  {
    av: 16187,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: horizontal orientation) - Character SYMBOL SYNONYM',
    english: 'pipe, hose, tube (1)',
    swedish: 'rör, slang (1)',
    norwegian: 'rør, slange (1)',
    finnish: 'putki',
    hungarian: 'pipadohány',
    german: 'Rohr, Röhre (1)',
    dutch: 'buis, pijp (buis), darm (buis), tube (1)',
    afrikaans: 'pyp, buis, tuinslang (1)',
    russian: 'труба, шланг (1)',
    latvian: 'salmiņš, caurulīte (1)',
    polish: 'rura, wąż, tuba (1)',
    french: 'tuyau, canalisation (1)',
    spanish: 'tubería, manguera (1)',
  },
  {
    av: 16188,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a pit or stone) - Character',
    english: 'pit, stone',
    swedish: 'kärna',
    norwegian: 'kjerne (frukt)',
    finnish: 'siemen, kivi (hedelmän)',
    hungarian: 'gyümölcsmag, csonthéjas mag',
    german: 'Kern',
    dutch: 'pit',
    afrikaans: 'pit',
    russian: 'косточка, семя',
    latvian: 'kauliņš',
    polish: 'pestka',
    french: 'noyau',
    spanish: 'hoyo, piedra',
  },
  {
    av: 16190,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: Middle Eastern bread, the line in the middle suggests that the bread is hollow inside) - Character',
    english: 'pita',
    swedish: 'pitabröd',
    norwegian: 'pitabrød',
    finnish: 'pitaleipä',
    hungarian: 'pitakenyér',
    german: 'Pita, Pitasandwich',
    dutch: 'pita',
    afrikaans: 'pita (ongesuurde brood)',
    russian: 'пита',
    latvian: 'pitas maize',
    polish: 'pita (rodzaj pieczywa)',
    french: 'pita',
    spanish: 'pita',
  },
  {
    av: 16191,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph with handle and spout) - Character',
    english: 'pitcher, jug, kettle, pot',
    swedish: 'kanna, tillbringare',
    norwegian: 'kanne, mugge',
    finnish: 'kannu, pannu',
    hungarian: 'kancsó, füleskancsó, kiöntő, kanna',
    german: 'Kanne, Krug, Karaffe',
    dutch: 'gieter',
    afrikaans: 'gieter, ketel, beker, kruik',
    russian: 'кувшин, лейка',
    latvian: 'krūka, lejkanna',
    polish: 'czajnik, dzbanek z dziubkiem',
    french: 'cafetière, bouilloire, cruche',
    spanish: 'jarra',
  },
  {
    av: 16193,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + pointer: place on the earth) - Character (superimposed - pointer)',
    english: 'place, area, location, space',
    swedish: 'plats, ställe',
    norwegian: 'plass, sted',
    finnish: 'paikka, sijainti',
    hungarian: 'hely, terület, felszín',
    german: 'Platz',
    dutch: 'gebied, plaats',
    afrikaans: 'plek, area, gebied, ruimte',
    russian: 'место',
    latvian: 'vieta, telpa, teritorija',
    polish: 'miejsce, lokacja, lokalizacja',
    french: 'place, endroit',
    spanish: 'lugar, espacio, área',
  },
  {
    av: 16194,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + man-made: rational way for making something) - Character (superimposed)',
    english: 'plan, design, method, system',
    swedish: 'plan, metod, mönster',
    norwegian: 'plan, metode, system',
    finnish: 'suunnitelma, menetelmä',
    hungarian: 'terv, elgondolás, rendszer, módszer',
    german: 'Plan, Methode, System',
    dutch: 'methode, plan, ontwerp',
    afrikaans: 'plan, ontwerp, metode, sisteem',
    russian: 'план, метод, проект',
    latvian: 'plāns, plānojums',
    polish: 'plan, metoda, system',
    french: 'plan',
    spanish: 'plan, método, sistema',
  },
  {
    av: 16196,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a flower with a leaf) - Character',
    english: 'plant',
    swedish: 'växt',
    norwegian: 'plante',
    finnish: 'kasvi',
    hungarian: 'növény',
    german: 'Pflanze',
    dutch: 'plant',
    afrikaans: 'plant',
    russian: 'растение',
    latvian: 'augs',
    polish: 'roślina',
    french: 'plante',
    spanish: 'planta',
  },
  {
    av: 16205,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a pair of pliers in an open position) - Character',
    english: 'pliers, tongs, tweezer(s), pincer(s) (pair of)',
    swedish: 'tång',
    norwegian: 'tang',
    finnish: 'pihdit, hohtimet',
    hungarian: 'fogó, csipesz',
    german: 'Zange, Kneifzange, Spitzzange',
    dutch: 'tang',
    afrikaans: 'tang',
    russian: 'плоскогубцы',
    latvian: 'knaibles',
    polish: 'szczypce',
    french: 'pince',
    spanish: 'alicates',
  },
  {
    av: 16206,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(knife + earth: heavy blade that cuts the soil in preparation for planting) - Character (superimposed)',
    english: 'plough',
    swedish: 'plog',
    norwegian: 'plog',
    finnish: 'aura',
    hungarian: 'szántani, felszántani',
    german: 'Pflug',
    dutch: 'ploeg',
    afrikaans: 'ploeg',
    russian: 'плуг',
    latvian: 'arkls',
    polish: 'pług',
    french: 'charrue',
    spanish: 'arado',
  },
  {
    av: 16208,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(fruit + pit) - Character (superimposed)',
    english: 'plum, drupe',
    swedish: 'plommon',
    norwegian: 'plomme, steinfrukt',
    finnish: 'luumu',
    hungarian: 'szilva',
    german: 'Pflaume',
    dutch: 'pruim',
    afrikaans: 'pruim, drupe',
    russian: 'слива',
    latvian: 'plūme',
    polish: 'śliwka',
    french: 'prune, reine-claude, mirabelle',
    spanish: 'ciruela',
  },
  {
    av: 16212,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(knife + pointer, to tip) - Character (superimposed - pointer)',
    english: 'point, tip, peak',
    swedish: 'spets',
    norwegian: 'spiss, tupp',
    finnish: 'kärki',
    hungarian: 'csúcs, hegye valaminek',
    german: 'Spitze, Fingerzeig',
    dutch: 'prik, punt (van voorwerp)',
    afrikaans: 'punt, tip, piek',
    russian: 'острие',
    latvian: 'gals, uzgalis',
    polish: 'czubek, koniuszek, ostrze',
    french: 'pointe',
    spanish: 'punta',
  },
  {
    av: 16219,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(foundation, base, fundament + water: could also be interpreted as a combination of enclosure and water) - Character (superimposed)',
    english: 'pool',
    swedish: 'bassäng, pool',
    norwegian: 'basseng',
    finnish: 'lammikko, allas',
    hungarian: 'medence',
    german: 'Teich, Tümpel',
    dutch: 'zwembad',
    afrikaans: 'swembad',
    russian: 'бассейн',
    latvian: 'baseins',
    polish: 'basen',
    french: 'piscine, bassin de natation',
    spanish: 'piscina',
  },
  {
    av: 16224,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(greater than (relation) + dot: forward pointing relation to a certain point in space) - Character (sequenced)',
    english: 'position',
    swedish: 'läge, position',
    norwegian: 'posisjon, stilling',
    finnish: 'sijainti, asema',
    hungarian: 'helyzet, pozíció',
    german: 'Position, Stellung',
    dutch: 'positie',
    afrikaans: 'posisie',
    russian: 'местоположение',
    latvian: 'stāvoklis, pozīcija',
    polish: 'pozycja, stanowisko',
    french: 'position',
    spanish: 'posición',
  },
  {
    av: 16227,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure + stamp (combination): pictograph, which suggests a postcard with a stamp in the upper right corner) - Character (superimposed - combined)',
    english: 'postcard',
    swedish: 'kort, vykort',
    norwegian: 'kort, postkort',
    finnish: 'postikortti',
    hungarian: 'levelezőlap',
    german: 'Postkarte, Karte',
    dutch: 'kaart (post), postkaart',
    afrikaans: 'poskaart',
    russian: 'почтовая открытка',
    latvian: 'atklātnīte',
    polish: 'pocztówka',
    french: 'carte postale',
    spanish: 'tarjeta postal',
  },
  {
    av: 16229,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a pan with a handle) - Character',
    english: 'pot, pan',
    swedish: 'kastrull, stekpanna (etc)',
    norwegian: 'gryte, kjele, stekepanne',
    finnish: 'kattila, pata, pannu',
    hungarian: 'fazék, lábos',
    german: 'Topf, Kochtopf, Pfanne',
    dutch: 'pan, pot (kook) (Vl)',
    afrikaans: 'pot, pan',
    russian: 'кастрюля',
    latvian: 'katls, katliņš',
    polish: 'patelnia, rondel',
    french: 'casserole',
    spanish: 'olla, sartén',
  },
  {
    av: 16232,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(international symbol for British pound sterling) - Character',
    english: 'pound sterling',
    swedish: 'pund',
    norwegian: 'pund (eng. pund)',
    finnish: 'punta',
    hungarian: 'font, angol font',
    german: 'Pfund Sterling (Währung)',
    dutch: 'pond (munt GB)',
    afrikaans: 'pond sterling',
    russian: 'фунт стерлинг',
    latvian: 'sterliņu mārciņa',
    polish: 'funt szterling',
    french: 'livre sterling',
    spanish: 'libra esterlina',
  },
  {
    av: 16233,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(three powder-like dots: located at the corner points of the stone symbol) See stone, rock 17267 - Character (superimposed - sequenced)',
    english: 'powder, dust',
    swedish: 'pulver, damm, korn, stoft',
    norwegian: 'pulver, støv',
    finnish: 'pöly, jauhe, tomu',
    hungarian: 'por',
    german: 'Staub, Pulver',
    dutch: 'stof',
    afrikaans: 'poeier, stof',
    russian: 'порошок, пыль',
    latvian: 'pulveris',
    polish: 'proszek, pył',
    french: 'poudre, poussière',
    spanish: 'polvo',
  },
  {
    av: 16234,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(action + electromagnetic radiation: energy in action) - Character (superimposed)',
    english: 'power (physics)',
    swedish: 'kraft',
    norwegian: 'kraft',
    finnish: 'voima',
    hungarian: 'erő (fizikában)',
    german: 'Kraft, Stärke',
    dutch: 'kracht (fysisch)',
    afrikaans: 'krag (fisika)',
    russian: 'мощность, энергия',
    latvian: 'spēks, enerģija, jauda',
    polish: 'moc (fizyczne)',
    french: 'énergie physique',
    spanish: 'poder',
  },
  {
    av: 16246,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(past + future: time between past and future) - Character (sequenced)',
    english: 'present',
    swedish: 'nutid',
    norwegian: 'nåtid',
    finnish: 'nykyaika, nykyisyys',
    hungarian: 'jelen, a jelen',
    german: 'Gegenwart',
    dutch: 'heden (zelfst. nw)',
    afrikaans: 'huidig huidiglik nou',
    russian: 'настоящее',
    latvian: 'tagadne',
    polish: 'teraz, teraźniejszość',
    french: 'présent',
    spanish: 'presente',
  },
  {
    av: 16254,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(camera + forward [modification, short arrow]: device that projects the picture produced by a camera forward onto a screen) - Character (superimposed - modified)',
    english: 'projector',
    swedish: 'projektor',
    norwegian: 'filmapparat, prosjektor',
    finnish: 'diaprojektori, projektori, kuvaheijastin',
    hungarian: 'vetítő, projektor',
    german: 'Diaprojektor',
    dutch: 'projektor',
    afrikaans: 'projektor',
    russian: 'проектор',
    latvian: 'projektors',
    polish: 'projektor (filmowy lub multimedialny)',
    french: 'projecteur',
    spanish: 'proyector',
  },
  {
    av: 16420,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(symbol looks like a roof, suggesting the protection provided by a roof) - Character',
    english: 'protection, shelter',
    swedish: 'skydd, beskydd',
    norwegian: 'beskyttelse, skjul',
    finnish: 'suoja, turva',
    hungarian: 'védelem, oltalom',
    german: 'Schutz',
    dutch: 'bescherming, onderdak',
    afrikaans: 'onderdak beskerming, skuiling',
    russian: 'защита',
    latvian: 'aizsardzība',
    polish: 'ochrona, schronienie',
    french: 'protection',
    spanish: 'protección',
  },
  {
    av: 16426,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(hair + body + pointer, to hair) - Character (superimposed - pointer)',
    english: 'pubic hair',
    swedish: 'könshår',
    norwegian: 'kjønnshår',
    finnish: 'karvoitus (alapään)',
    hungarian: 'fanszőrzet, szeméremszőrzet',
    german: 'Schamhaar',
    dutch: 'schaamhaar',
    afrikaans: 'skaam haar, pubiese haar',
    russian: 'волосы лобковые',
    latvian: 'kaunuma mati',
    polish: 'włosy łonowe',
    french: 'poils du pubis, poils pubiens',
    spanish: 'vello púbico',
  },
  {
    av: 16430,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(ground + room, room with extended floor line [adaptation]: room opening out onto the street) - Character (superimposed - adapted)',
    english: 'public room',
    swedish: 'offentlig lokal',
    norwegian: 'offentlig rom',
    finnish: 'julkinen tila',
    hungarian: 'nyilvános helyiség',
    german: 'öffentlicher Raum',
    dutch: 'openbare ruimte',
    afrikaans: 'openbare ruimte vertrek kamer',
    russian: 'общественное помещение',
    latvian: 'sabiedriska telpa',
    polish: 'pomieszczenie publiczne',
    french: 'lieu public, espace public',
    spanish: 'sala pública',
  },
  {
    av: 16437,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(greater than (relation) + greater than (relation): the forward pointing doubled symbol stresses a purposeful relationship) - Character (sequenced)',
    english: 'purpose',
    swedish: 'avsikt',
    norwegian: 'formål, hensikt',
    finnish: 'tarkoitus, aikomus',
    hungarian: 'cél, szándék',
    german: 'Zweck, Absicht',
    dutch: 'doel',
    afrikaans: 'doel',
    russian: 'цель, намерение',
    latvian: 'mērķis, nolūks',
    polish: 'cel, osiągnięcie',
    french: 'but, fin',
    spanish: 'propósito',
  },
  {
    av: 16443,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a three-dimensional outline of a pyramid) - Character',
    english: 'pyramid',
    swedish: 'pyramid',
    norwegian: 'pyramide',
    finnish: 'pyramidi',
    hungarian: 'piramis',
    german: 'Pyramide',
    dutch: 'piramide',
    afrikaans: 'piramide',
    russian: 'пирамида',
    latvian: 'piramīda',
    polish: 'piramida',
    french: 'pyramide',
    spanish: 'pirámide',
  },
  {
    av: 16445,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(what, question mark + open: the question is open-ended. This symbol is also used to introduce a question.) - Character (superimposed)',
    english: 'question',
    swedish: 'fråga (subst.)',
    norwegian: 'spørsmål',
    finnish: 'kysymys',
    hungarian: 'kérdés',
    german: 'Frage',
    dutch: 'vraag',
    afrikaans: 'vraag',
    russian: 'вопрос',
    latvian: 'jautājums',
    polish: 'pytanie, zapytanie',
    french: 'question',
    spanish: 'pregunta, cuestión',
  },
  {
    av: 16451,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(forward + forward [modification, lower position]: two forward arrows, one overtaking another, appear to be competing) - Character (superimposed - modified)',
    english: 'race, competition, contest',
    swedish: 'tävling, match',
    norwegian: 'konkurranse, kamp',
    finnish: 'kilpailu, ottelu',
    hungarian: 'verseny, versenyzés, mérkőzés',
    german: 'Wettbewerb, Rennen, Wettrennen',
    dutch: 'wedstrijd, race',
    afrikaans: 'kompetisie, resies, wedstryd',
    russian: 'соревнование',
    latvian: 'sacensības',
    polish: 'wyścig, konkurs, rywalizacja',
    french: 'course, concours',
    spanish: 'carrera, competición, concurso',
  },
  {
    av: 16452,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'racket, racquet',
    swedish: 'racket',
    norwegian: 'racket',
    finnish: 'maila, tennismaila',
    hungarian: 'ütő, teniszütő, rakett',
    german: 'Tennisschläger, Racket',
    dutch: 'raket (sport)',
    afrikaans: 'raket',
    russian: 'ракетка',
    latvian: 'raķete (sporta)',
    polish: 'rakieta (tenisowa)',
    french: 'raquette',
    spanish: 'raqueta',
  },
  {
    av: 16455,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water + down: water that falls down from the sky) - Character (superimposed)',
    english: 'rain',
    swedish: 'regn',
    norwegian: 'regn',
    finnish: 'sade',
    hungarian: 'eső',
    german: 'Regen',
    dutch: 'regen',
    afrikaans: 'reën',
    russian: 'дождь',
    latvian: 'lietus',
    polish: 'deszcz, opad',
    french: 'pluie',
    spanish: 'lluvia',
  },
  {
    av: 16463,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'raspberry, blackberry, compound berry',
    swedish: 'björnbär, hallon, hjortron',
    norwegian: 'bjørnebær, bringebær, multe',
    finnish: 'vadelma',
    hungarian: 'málna, szeder, földiszeder',
    german: 'Brombeere, Himbeere, Multebeere',
    dutch: 'framboos, braambes (Vl), braam (Nl)',
    afrikaans: 'framboos, braambessie bessie',
    russian: 'малина, ежевика',
    latvian: 'avene',
    polish: 'malina, jeżyna, jagoda (owoc jagodowy)',
    french: 'framboise',
    spanish: 'frambuesa, mora',
  },
  {
    av: 16479,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(symbol is derived from the mathematical symbol for “smaller than”. This symbol in half-size is the basis for against, by, and there.) - Character',
    english: 'less than (relation)',
    swedish: 'mindre än (relation)',
    norwegian: 'mindre enn (relasjon)',
    finnish: 'pienempi kuin',
    hungarian: 'kisebb /kevesebb, mint…',
    german: 'weniger als (Relation)',
    dutch: 'kleiner dan, minder dan',
    afrikaans: 'minder as (verhouding)',
    russian: 'меньше (соотношение)',
    latvian: 'mazāk par, mazāk kā',
    polish: 'mniej niż … (określenie relacji)',
    french: 'plus petit que (relation)',
    spanish: 'menos que (relación)',
  },
  {
    av: 16480,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      "(symbol is derived from the mathematical symbol for 'greater than'. This symbol in half-size is the basis for about, at, for, here and on.) - Character",
    english: 'greater than (relation)',
    swedish: 'större än (relation)',
    norwegian: 'større enn (relasjon)',
    finnish: 'suurempi kuin',
    hungarian: 'nagyobb/több, mint…',
    german: 'grösser als (Relation)',
    dutch: 'groter dan',
    afrikaans: 'groter as (verhouding)',
    russian: 'больше (соотношение)',
    latvian: 'lielāks par, lielāks kā',
    polish: 'większy niż (relacja)',
    french: 'plus grand que (relation)',
    spanish: 'mayor que (relación)',
  },
  {
    av: 16481,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(protection + person + protection: two adjoining roofs are used to mean person who is related) - Character (superimposed)',
    english: 'relative, relation',
    swedish: 'släkting, släkt',
    norwegian: 'slektning',
    finnish: 'sukulainen',
    hungarian: 'rokon, rokonság',
    german: '(der) Verwandte, (die) Verwandte',
    dutch: 'familielid',
    afrikaans: 'familielid, verhouding',
    russian: 'родственник',
    latvian: 'radinieks, radiniece, radinieki',
    polish: 'związek, relacja (między ludźmi)',
    french: 'parent (de la parenté)',
    spanish: 'pariente',
  },
  {
    av: 16482,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(double commas, apostrophes or ditto marks in a sentence [modification, on the midline]: This symbol is equivalent to a relative pronoun or a conjunction used to introduce a relative clause. - Character (sequenced - modified)',
    english: 'who, that, which-(relative)',
    swedish: 'som',
    norwegian: 'som',
    finnish: 'joka, mikä, jossa, jolloin',
    hungarian: 'aki, ami, ahol, amikor, amennyi (vonatkozó névmás)',
    german: 'der, die, das, welcher, welche, welches (Relativpronomen)',
    dutch: 'dat (betrekkelijk vnw), die (betrekkelijk vnw)',
    afrikaans: 'wie, daardie, watter (relatiewe)',
    russian: 'который, которая, которые',
    latvian: 'kurš, kura, kas',
    polish: 'który, tego, co-(względne)',
    french: 'qui, que, lequel',
    spanish: 'quién, qué (relativo)',
  },
  {
    av: 16495,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + earth: feeling at rest on the earth. CKB points out that poets use the earth as a symbol for rest.) - Character (superimposed)',
    english: 'rest, comfort',
    swedish: 'vila (subst.)',
    norwegian: 'hvile',
    finnish: 'lepo',
    hungarian: 'kényelem, nyugalom, pihenés',
    german: 'Ruhe, Rast, Gemütlichkeit, Erholung',
    dutch: 'rust',
    afrikaans: 'rus, rustig, gemaklik',
    russian: 'отдых, покой, комфорт',
    latvian: 'miers, atpūta, ērtības',
    polish: 'odpoczynek, relaks, wypoczynek, odprężenie',
    french: 'repos',
    spanish: 'descanso',
  },
  {
    av: 16499,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(reference line + backward: the arrow, moving backward, returns toward the reference line) - Character (sequenced) ??',
    english: 'return',
    swedish: 'återkomst',
    norwegian: 'retur, tilbakekomst',
    finnish: 'paluu',
    hungarian: 'visszatérés, tolatás',
    german: 'Rückkehr, Wiederkehr',
    dutch: 'terugkomst',
    afrikaans: 'terugkom terugdraai terugkeer omdraai',
    russian: 'возвращение',
    latvian: 'atgriešanās',
    polish: 'powrót',
    french: 'retour',
    spanish: 'volver',
  },
  {
    av: 16501,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + pictograph of head and horn: animal with a distinctive horn protruding from its nose) - Character (superimposed)',
    english: 'rhinoceros',
    swedish: 'noshörning',
    norwegian: 'neshorn',
    finnish: 'sarvikuono',
    hungarian: 'rinocérosz',
    german: 'Nashorn, Rhinozeros',
    dutch: 'neushoorn',
    afrikaans: 'renoster',
    russian: 'носорог',
    latvian: 'degunradzis',
    polish: 'nosorożec',
    french: 'rhinocéros',
    spanish: 'rinoceronte',
  },
  {
    av: 16505,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(grain + water (ground level): grain that grows in water) - Character (superimposed)',
    english: 'rice',
    swedish: 'ris',
    norwegian: 'ris',
    finnish: 'riisi',
    hungarian: 'rizs',
    german: 'Reispflanze',
    dutch: 'rijst',
    afrikaans: 'rys',
    russian: 'рис',
    latvian: 'rīsi',
    polish: 'ryż',
    french: 'riz',
    spanish: 'arroz',
  },
  {
    av: 16674,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(international mathematical symbol) - Character',
    english: 'angle (right), right angle',
    swedish: 'vinkel (rät), rät vinkel',
    norwegian: 'rett vinkel',
    finnish: 'suorakulma',
    hungarian: 'derékszög',
    german: 'rechtwinkelig',
    dutch: 'rechte hoek',
    afrikaans: 'hoek (regs), regte hoek',
    russian: 'угол прямой',
    latvian: 'taisnlenķis',
    polish: 'kąt prosty',
    french: 'angle droit',
    spanish: 'ángulo derecho',
  },
  {
    av: 16675,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'ring',
    swedish: 'ring',
    norwegian: 'ring',
    finnish: 'sormus',
    hungarian: 'gyűrű',
    german: 'Ring',
    dutch: 'ring',
    afrikaans: 'ring',
    russian: 'кольцо',
    latvian: 'gredzenis',
    polish: 'pierścień',
    french: 'anneau',
    spanish: 'anillo',
  },
  {
    av: 16677,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water (ground level) + forward: water that flows forward) - Character (superimposed)',
    english: 'river, stream, current',
    swedish: 'flod, å, älv (etc)',
    norwegian: 'elv',
    finnish: 'joki, virta',
    hungarian: 'folyó, folyam, áramlat',
    german: 'Fluss, Strom, Bach, Flüsschen',
    dutch: 'rivier, stroom, beek',
    afrikaans: 'rivier, stroom, vloei',
    russian: 'река, речка',
    latvian: 'upe, straume',
    polish: 'rzeka',
    french: 'rivière',
    spanish: 'río, arroyo',
  },
  {
    av: 16678,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(road and car + pointer, to road: place where cars travel) SYMBOL SYNONYM - Character (superimposed - pointer)',
    english: 'road (1)',
    swedish: 'väg, körbana (1)',
    norwegian: 'vei, kjørebane (1)',
    finnish: 'tie',
    hungarian: 'úttest, autóút',
    german: 'Landstraße (1)',
    dutch: 'weg (straat), straat (1)',
    afrikaans: 'straat, pad, hoofweg (1)',
    russian: 'дорога, шоссе (1)',
    latvian: 'ceļš (1)',
    polish: 'droga (1)',
    french: 'route (1)',
    spanish: 'carretera (1)',
  },
  {
    av: 16683,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(bread [modification, half-sized]: pictograph of a bun) - Character (modified)',
    english: 'roll, bun',
    swedish: 'bulle, småfranska (etc)',
    norwegian: 'rundstykke',
    finnish: 'pulla, sämpylä',
    hungarian: 'péksütemény, kifli, zsömle',
    german: 'Brötchen',
    dutch: 'broodje, bolletje (brood), pistolet',
    afrikaans: 'broodrolletjie, broodbolletjie, bun',
    russian: 'булочка',
    latvian: 'maizīte, smalkmaizīte',
    polish: 'słodka bułka, bułka maślana',
    french: 'petit pain',
    spanish: 'rollo, bollo',
  },
  {
    av: 16685,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(feet and legs + wheel [modification, low position] + wheel [modification, low position]: wheeled skates) - Character (superimposed - modified)',
    english: 'roller skates',
    swedish: 'rullskridskor',
    norwegian: 'rulleskøyter',
    finnish: 'rullaluistimet',
    hungarian: 'görkorcsolya',
    german: 'Rollschuhe',
    dutch: 'rolschaatsen (znw)',
    afrikaans: 'rolskaats',
    russian: 'ролики, роликовые коньки',
    latvian: 'skrituļslidas',
    polish: 'rolki, wrotki',
    french: 'patins à roulettes',
    spanish: 'patines',
  },
  {
    av: 16687,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure, open on the left side) - Character',
    english: 'room',
    swedish: 'rum',
    norwegian: 'rom',
    finnish: 'huone, tila',
    hungarian: 'szoba, helyiség',
    german: 'Zimmer, Raum',
    dutch: 'kamer',
    afrikaans: 'kamer',
    russian: 'комната',
    latvian: 'istaba',
    polish: 'pokój, pomieszczenie, sala',
    french: 'pièce',
    spanish: 'habitación',
  },
  {
    av: 16688,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + pictograph of roots: symbol suggests two roots below the ground.) - Character (superimposed)',
    english: 'root(s), rootage, root system',
    swedish: 'rötter, rotsystem',
    norwegian: 'røtter, rot, rotsystem',
    finnish: 'juuret',
    hungarian: 'gyökér',
    german: 'Wurzeln, Verwurzelung, Wurzelwerk',
    dutch: 'wortel(s) (algemeen)',
    afrikaans: 'wortel(s) wortel sisteem',
    russian: 'корень',
    latvian: 'sakne',
    polish: 'korzeń',
    french: 'racine',
    spanish: 'raíces',
  },
  {
    av: 16701,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: the sides of the symbol for container are extended) - Character',
    english: 'sack, bag',
    swedish: 'påse, säck, kasse',
    norwegian: 'pose, sekk',
    finnish: 'laukku, säkki, kassi',
    hungarian: 'zsák, tarisznya, táska',
    german: 'Sack, Beutel',
    dutch: 'tas, zak',
    afrikaans: 'sak',
    russian: 'мешок, сумка, пакет',
    latvian: 'maisiņš, soma, kule',
    polish: 'worek, torba',
    french: 'sac',
    spanish: 'saco, bolsa',
  },
  {
    av: 16709,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      'lettuce + dish (combination): used in a general sense for all salads) - Character (superimposed - combined)',
    english: 'salad',
    swedish: 'sallad',
    norwegian: 'salat',
    finnish: 'salaatti',
    hungarian: 'salátaféle, savanyúság',
    german: 'Salat',
    dutch: 'slaatje, salade',
    afrikaans: 'slaai',
    russian: 'салат',
    latvian: 'salāti',
    polish: 'sałatka',
    french: 'salade',
    spanish: 'ensalada',
  },
  {
    av: 16713,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(international mathematical symbol) - Character',
    english: 'same, equal, equality',
    swedish: 'lika, samma, lika med, likhet',
    norwegian: 'lik, samme, likhet',
    finnish: 'sama, samanlainen, yhtä suuri',
    hungarian: 'egyenlő, ugyanaz, azonos',
    german: 'ebenso, gleich, Gleichheit',
    dutch: 'gelijk, hetzelfde, dezelfde, zelfde',
    afrikaans: 'dieselfde gelyk aan selfde gelykheid',
    russian: 'равенство, сходство',
    latvian: 'vienāds, vienādības zīme',
    polish: 'równy, taki sam',
    french: 'égalité',
    spanish: 'mismo, igual',
  },
  {
    av: 16727,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a saw and incorporates teeth) - Character',
    english: 'saw',
    swedish: 'såg',
    norwegian: 'sag',
    finnish: 'saha',
    hungarian: 'fűrész',
    german: 'Säge',
    dutch: 'zaag',
    afrikaans: 'saag',
    russian: 'пила‚ ножовка',
    latvian: 'zāģis',
    polish: 'piła',
    french: 'scie',
    spanish: 'sierra',
  },
  {
    av: 16735,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + nature: reasoned approach to nature) - Character (superimposed)',
    english: 'science, body of learning',
    swedish: 'vetenskap, kunskapsområde',
    norwegian: 'vitenskap, kunnskapsområde',
    finnish: 'tiede',
    hungarian: 'tudomány',
    german: 'Naturwissenschaft, Wissenschaft',
    dutch: 'wetenschap',
    afrikaans: 'wetenskap',
    russian: 'наука',
    latvian: 'zinātne',
    polish: 'nauka, ucznie się',
    french: 'science, corps de la connaissance, savoir',
    spanish: 'ciencia, cuerpo de conocimiento',
  },
  {
    av: 16736,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a pair of closed scissors) - Character',
    english: 'scissors',
    swedish: 'sax',
    norwegian: 'saks',
    finnish: 'sakset',
    hungarian: 'olló',
    german: 'Schere',
    dutch: 'schaar',
    afrikaans: 'skêr',
    russian: 'ножницы',
    latvian: 'šķēres',
    polish: 'nożyczki',
    french: 'ciseaux, paire de ciseaux',
    spanish: 'tijeras',
  },
  {
    av: 16739,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(line + wavy line (as of fire) + line: pictograph that suggests the path made by the thread of a screw) - Character (sequenced)',
    english: 'screw',
    swedish: 'skruv',
    norwegian: 'skrue',
    finnish: 'ruuvi',
    hungarian: 'csavar, facsavar, sróf',
    german: 'Schraube',
    dutch: 'schroef',
    afrikaans: 'skroef',
    russian: 'шуруп, болт',
    latvian: 'skrūve',
    polish: 'śruba, wkręt',
    french: 'vis',
    spanish: 'tornillo',
  },
  {
    av: 16745,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + mouth: the mouth is closed) - Character (superimposed)',
    english: 'secret',
    swedish: 'hemlighet',
    norwegian: 'hemmelighet',
    finnish: 'salaisuus',
    hungarian: 'titok',
    german: 'Geheimnis',
    dutch: 'geheim',
    afrikaans: 'geheim',
    russian: 'секрет',
    latvian: 'noslēpums',
    polish: 'tajemnica, sekret',
    french: 'secret',
    spanish: 'secreto',
  },
  {
    av: 16749,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + two dots below, to represent seeds) - Character (superimposed)',
    english: 'seed',
    swedish: 'frö',
    norwegian: 'frø, såkorn',
    finnish: 'siemen',
    hungarian: 'mag',
    german: 'Samen',
    dutch: 'zaad',
    afrikaans: 'saad',
    russian: 'семя, семечко',
    latvian: 'sēkla',
    polish: 'nasiono, nasiona',
    french: 'graine, semence',
    spanish: 'semilla',
  },
  {
    av: 16751,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(slanted line (as of a diagonal of a horizontal rectangle – character of Unicode draft, missing here) + small triangle (as of female (gender)): pictograph, slanted line on top of triangle, suggesting a seesaw) - Character (superimposed)',
    english: 'seesaw, teeter-totter, teeter board',
    swedish: 'gungbräda',
    norwegian: 'vippehuske',
    finnish: 'keinulauta',
    hungarian: 'mérleghinta, libikóka',
    german: 'Wippe, Schaukelbrett',
    dutch: 'wip',
    afrikaans: 'wipplank',
    russian: 'качели-балансир',
    latvian: 'šūpoles, šūpoļu dēlis',
    polish: 'huśtawka',
    french: 'balançoire à bascule',
    spanish: 'subibaja',
  },
  {
    av: 16939,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'shamrock, clover',
    swedish: 'klöver',
    norwegian: 'kløver',
    finnish: 'apilanlehti',
    hungarian: 'lóhere',
    german: 'Kleeblatt',
    dutch: 'klaver',
    afrikaans: 'klawer',
    russian: 'клевер',
    latvian: 'āboliņš',
    polish: 'shamrock (trójlistna koniczyna irlandzka)',
    french: 'trèfle',
    spanish: 'trébol',
  },
  {
    av: 16953,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a shelf) - Character',
    english: 'shelf',
    swedish: 'hylla',
    norwegian: 'hylle',
    finnish: 'hylly',
    hungarian: 'polc',
    german: 'Regal, Brett, Fach',
    dutch: 'boekenplank, rek',
    afrikaans: 'rak',
    russian: 'полка',
    latvian: 'plaukts',
    polish: 'półka',
    french: 'étagère',
    spanish: 'estante',
  },
  {
    av: 16954,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(case, casing + pointer, to enclosure: a crust or shell surrounds the thing) - Character (superimposed - pointer)',
    english: 'shell, crust',
    swedish: 'skal, hölje',
    norwegian: 'skorpe, skall',
    finnish: 'kuori',
    hungarian: 'kéreg, burok, felső réteg',
    german: 'Kruste, Schale',
    dutch: 'schil, korst',
    afrikaans: 'dop, kors',
    russian: 'оболочка, корпус',
    latvian: 'apvalks, korpuss',
    polish: 'powłoka, warstwa, skórka',
    french: 'coquille',
    spanish: 'caparazón, envoltura',
  },
  {
    av: 16964,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(body + pointer, to shoulder) - Character (superimposed - pointer)',
    english: 'shoulder',
    swedish: 'axel, skuldra',
    norwegian: 'skulder',
    finnish: 'hartia, olkapää',
    hungarian: 'váll',
    german: 'Schulter',
    dutch: 'schouder',
    afrikaans: 'skouer',
    russian: 'плечо',
    latvian: 'plecs',
    polish: 'ramię',
    french: 'épaule',
    spanish: 'hombro',
  },
  {
    av: 16966,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'shovel, spade',
    swedish: 'spade',
    norwegian: 'spade, skuffe',
    finnish: 'lapio',
    hungarian: 'ásó, lapát',
    german: 'Spaten, Schaufel, Handschippe',
    dutch: 'schop, schep, spade',
    afrikaans: 'graaf',
    russian: 'лопата',
    latvian: 'lāpsta, lāpstiņa',
    polish: 'szufla, łopata',
    french: 'pelle',
    spanish: 'pala',
  },
  {
    av: 16968,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(room + water + down: room where water pours down for bathing) - Character (superimposed)',
    english: 'shower',
    swedish: 'dusch',
    norwegian: 'dusj',
    finnish: 'suihku',
    hungarian: 'zuhany, tus',
    german: 'Dusche',
    dutch: 'douche',
    afrikaans: 'stort',
    russian: 'душ',
    latvian: 'duša',
    polish: 'prysznic, natrysk',
    french: 'douche',
    spanish: 'ducha',
  },
  {
    av: 16974,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(body + pointer, to side) - Character (superimposed - pointer)',
    english: 'side (body)',
    swedish: 'sida (på kroppen)',
    norwegian: 'side (kroppen)',
    finnish: 'kylki',
    hungarian: 'oldal (test oldala)',
    german: 'Körperseite, Seite',
    dutch: 'zijkant (lichaam)',
    afrikaans: 'sy (liggaam)',
    russian: 'сторона (туловище)',
    latvian: 'sāns, sāni ',
    polish: 'bok, strona ciała',
    french: 'côté (corps)',
    spanish: 'lado (cuerpo)',
  },
  {
    av: 16975,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + pointer, to side) - Character (superimposed - pointer)',
    english: 'side (enclosure)',
    swedish: 'sida',
    norwegian: 'side',
    finnish: 'sivu',
    hungarian: 'oldal',
    german: 'Seite, Kante',
    dutch: 'zijkant (ding)',
    afrikaans: 'sy, sykant (hok)',
    russian: 'сторона',
    latvian: 'mala',
    polish: 'bok (w przestrzeni)',
    french: 'côté (enceinte)',
    spanish: 'lado (lugar)',
  },
  {
    av: 16976,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(container + downward [modification, low position]: container through which something can pass) - Character (superimposed - modified)',
    english: 'sieve, colander, strainer',
    swedish: 'sil, durkslag, filter',
    norwegian: 'sil, dørslag',
    finnish: 'seula, siivilä, sihti',
    hungarian: 'szűrő',
    german: 'Sieb, Küchensieb, Durchschlag, Filtersieb',
    dutch: 'zeef, filter, vergiet',
    afrikaans: 'sif, vergietes, filter',
    russian: 'решето, сито, дуршлаг',
    latvian: 'siets, caurduris',
    polish: 'sitko, durszlak',
    french: 'passoire, tamis',
    spanish: 'tamiz, colador',
  },
  {
    av: 16992,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(container + water) - Character (superimposed)',
    english: 'bath, washing',
    swedish: 'bad, tvätt',
    norwegian: 'bad, vask (i kombinasjon)',
    finnish: 'pesu, kylpy',
    hungarian: 'fürdés, mosás',
    german: 'Waschbecken, Spülbecken',
    dutch: 'bad',
    afrikaans: 'bad, was',
    russian: 'ванна, раковина',
    latvian: 'vanna',
    polish: 'zlew, umywalka',
    french: 'bain, toilette, lavage',
    spanish: 'baño, lavado',
  },
  {
    av: 16997,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vehicle + ski, runner [modification, high position]: pictograph, combination of vehicle and ski) - Character (superimposed - combined - modified)',
    english: 'skateboard',
    swedish: 'rullbräda, skateboard',
    norwegian: 'rullebrett, skateboard',
    finnish: 'rullalauta, skeittilauta',
    hungarian: 'gördeszka',
    german: 'Skateboard',
    dutch: 'skateboard',
    afrikaans: 'skaatsplank',
    russian: 'скейтборд',
    latvian: 'skrituļdēlis',
    polish: 'deskorolka, longboard',
    french: 'planche à roulettes, skateboard (activité)',
    spanish: 'tabla de skate, skateboard',
  },
  {
    av: 17006,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(horizontal line, on the skyline of the symbol drawing area) - Character',
    english: 'sky',
    swedish: 'himmel',
    norwegian: 'himmel',
    finnish: 'taivas',
    hungarian: 'égbolt, ég, mennybolt',
    german: 'Himmel',
    dutch: 'hemel, lucht',
    afrikaans: 'hemel',
    russian: 'небо',
    latvian: 'debesis',
    polish: 'niebo, powietrze',
    french: 'ciel',
    spanish: 'cielo',
  },
  {
    av: 17007,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing [modification, on earthline] + ski, runner (sled etc): pictograph, symbol suggests a sled, a snow vehicle to carry things) - Character (superimposed - modified)',
    english: 'sled, sledge, sleigh, toboggan',
    swedish: 'kälke, pulka, släde',
    norwegian: 'slede, kjelke, pulk',
    finnish: 'kelkka, pulkka',
    hungarian: 'szánkó',
    german: 'Schlitten, Rodelschlitten',
    dutch: 'slee',
    afrikaans: 'slee',
    russian: 'санки, салазки',
    latvian: 'ragavas, ragaviņas, kamanas',
    polish: 'sanki',
    french: 'traîneau',
    spanish: 'trineo',
  },
  {
    av: 17008,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(eye + to close: one's eyes are closed in sleep) - Character (superimposed)",
    english: 'sleep',
    swedish: 'sömn',
    norwegian: 'søvn',
    finnish: 'uni',
    hungarian: 'alvás',
    german: 'Schlaf',
    dutch: 'slaap, dutje',
    afrikaans: 'slaap, dut',
    russian: 'сон',
    latvian: 'miegs',
    polish: 'sen',
    french: 'sommeil',
    spanish: 'sueño',
  },
  {
    av: 17017,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(nose + earth [half-sized]: what the nose gets from the earth) - Character (superimposed)',
    english: 'smell, odour',
    swedish: 'lukt, doft',
    norwegian: 'lukt, duft',
    finnish: 'haju, tuoksu',
    hungarian: 'szag',
    german: 'Geruch, Duft',
    dutch: 'geur',
    afrikaans: 'geur, reuk',
    russian: 'запах',
    latvian: 'smaka',
    polish: 'zapach, aromat',
    french: 'odeur',
    spanish: 'olor',
  },
  {
    av: 17188,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a snail) - Character',
    english: 'snail',
    swedish: 'snigel',
    norwegian: 'snegle',
    finnish: 'etana',
    hungarian: 'csiga',
    german: 'Schnecke',
    dutch: 'slak',
    afrikaans: 'slak',
    russian: 'улитка',
    latvian: 'gliemezis',
    polish: 'ślimak',
    french: 'escargot',
    spanish: 'caracol',
  },
  {
    av: 17189,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a snake) - Character',
    english: 'snake',
    swedish: 'orm',
    norwegian: 'slange, orm',
    finnish: 'käärme',
    hungarian: 'kígyó',
    german: 'Schlange',
    dutch: 'slang',
    afrikaans: 'slang',
    russian: 'змея',
    latvian: 'čūska',
    polish: 'wąż',
    french: 'serpent',
    spanish: 'serpiente',
  },
  {
    av: 17190,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(snake + water [modification, low position under the earthline]: snake that spends much time in the water) - Character (superimposed - modified)',
    english: 'water snake',
    swedish: 'vattenorm',
    norwegian: 'havslange',
    finnish: 'rantakäärme, tarhakäärme',
    hungarian: 'vízisikló',
    german: 'Wasserschlange',
    dutch: 'waterslang',
    afrikaans: 'water slang',
    russian: 'водяная змея',
    latvian: 'ūdens čūska',
    polish: 'wąż morski (zwierzę)',
    french: "serpent d'eau",
    spanish: 'serpiente de agua',
  },
  {
    av: 17192,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water + down [modification] + star [modification, on earthline] (combination): water that comes down from the sky in star-shaped flakes) - Character (superimposed - modified - combined)',
    english: 'snow',
    swedish: 'snö',
    norwegian: 'snø (subst.)',
    finnish: 'lumi',
    hungarian: 'hó',
    german: 'Schnee',
    dutch: 'sneeuw',
    afrikaans: 'sneeu',
    russian: 'снег',
    latvian: 'sniegs',
    polish: 'śnieg',
    french: 'neige',
    spanish: 'nieve',
  },
  {
    av: 17195,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(snow + pointer, to star-shaped flake) - Character (superimposed - pointer)',
    english: 'snowflake',
    swedish: 'snöflinga',
    norwegian: 'snøfille, snøfnugg',
    finnish: 'lumihiutale',
    hungarian: 'hópihe, hókristály',
    german: 'Schneeflocke',
    dutch: 'sneeuwvlok',
    afrikaans: 'sneeuvlok',
    russian: 'снежинка',
    latvian: 'sniegpārsla',
    polish: 'płatek śniegu, śnieżynka',
    french: 'flocon de neige, flocon',
    spanish: 'copo de nieve',
  },
  {
    av: 17205,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing [modification, low position] + thing [modification, high position]: simplified three dimensional drawing of a solid object) - Character (superimposed - modified)',
    english: 'solid thing',
    swedish: 'fast föremål',
    norwegian: 'fast stoff, fast form',
    finnish: 'kiinteä esine',
    hungarian: 'szilárd test, szolid tömb',
    german: '(fester) Gegenstand',
    dutch: 'voorwerp (massief)',
    afrikaans: 'solied voorwerp ding',
    russian: 'твердое тело',
    latvian: 'ciets, cieta lieta, objekts',
    polish: 'solidny przedmiot, coś materialnego',
    french: 'solide (chose)',
    spanish: 'sólido (objeto)',
  },
  {
    av: 17209,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(protection + male: male born under the family roof) - Character (superimposed)',
    english: 'son',
    swedish: 'son',
    norwegian: 'sønn',
    finnish: 'poika',
    hungarian: 'fia, valaki fiúgyermeke',
    german: 'Sohn',
    dutch: 'zoon',
    afrikaans: 'seun',
    russian: 'сын',
    latvian: 'dēls',
    polish: 'syn',
    french: 'fils',
    spanish: 'hijo',
  },
  {
    av: 17216,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(ear + earth [half-sized]: what the ear receives from the earth) - Character (superimposed)',
    english: 'sound',
    swedish: 'ljud',
    norwegian: 'lyd',
    finnish: 'ääni',
    hungarian: 'hang',
    german: 'Geräusch, Laut',
    dutch: 'geluid',
    afrikaans: 'geluid, klank',
    russian: 'звук',
    latvian: 'skaņa',
    polish: 'dźwięk',
    french: 'son',
    spanish: 'sonido',
  },
  {
    av: 17218,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(dish + liquid) - Character (superimposed)',
    english: 'soup, broth',
    swedish: 'soppa, buljong',
    norwegian: 'suppe',
    finnish: 'keitto, liemi',
    hungarian: 'leves',
    german: 'Suppe, Brühe',
    dutch: 'soep',
    afrikaans: 'sop, bouillon',
    russian: 'суп, бульон',
    latvian: 'zupa, buljons',
    polish: 'zupa, wywar, rosół',
    french: 'soupe',
    spanish: 'sopa, caldo',
  },
  {
    av: 17219,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sun + pointer, to south) - Character (superimposed - pointer)',
    english: 'south',
    swedish: 'söder',
    norwegian: 'sør, syd',
    finnish: 'etelä',
    hungarian: 'Dél',
    german: 'Süden, Süd',
    dutch: 'zuid, zuiden',
    afrikaans: 'suid',
    russian: 'юг',
    latvian: 'dienvidi',
    polish: 'południe',
    french: 'sud',
    spanish: 'sur',
  },
  {
    av: 17221,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(three coordinate axes drawn in perspective, illustrating the three dimensions of space) - Character',
    english: 'space, dimension',
    swedish: 'rymd, utrymme, dimension',
    norwegian: 'rominnhold',
    finnish: 'avaruus, tila',
    hungarian: 'tér',
    german: 'Raum, Platz, Dimension',
    dutch: 'ruimte',
    afrikaans: 'ruimte, dimensie',
    russian: 'пространство, измерение',
    latvian: 'telpa, izplatījums',
    polish: 'przestrzeń, obszar',
    french: 'espace, volume',
    spanish: 'espacio',
  },
  {
    av: 17226,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'sperm',
    swedish: 'spermie',
    norwegian: 'spermie',
    finnish: 'siittiö',
    hungarian: 'hímivarsejt, ondósejt, spermium',
    german: 'Sperma, Samen',
    dutch: 'sperma, zaadcel',
    afrikaans: 'sperm',
    russian: 'сперма',
    latvian: 'sperma',
    polish: 'sperma, plemnik',
    french: 'spermatozoïde',
    spanish: 'esperma',
  },
  {
    av: 17229,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a spider) - Character',
    english: 'spider',
    swedish: 'spindel',
    norwegian: 'edderkopp',
    finnish: 'hämähäkki',
    hungarian: 'pók',
    german: 'Spinne',
    dutch: 'spin',
    afrikaans: 'spinnekop',
    russian: 'паук',
    latvian: 'zirneklis',
    polish: 'pająk',
    french: 'araignée',
    spanish: 'araña',
  },
  {
    av: 17233,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a spoon. The diagonal orientation of spoon is the same as that of fork and knife.) - Character',
    english: 'spoon',
    swedish: 'sked',
    norwegian: 'skje',
    finnish: 'lusikka',
    hungarian: 'kanál',
    german: 'Löffel',
    dutch: 'lepel',
    afrikaans: 'lepel',
    russian: 'ложка',
    latvian: 'karote',
    polish: 'łyżka, łyżeczka',
    french: 'cuiller, cuillère',
    spanish: 'cuchara',
  },
  {
    av: 17235,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a hockey stick) - Character',
    english: 'sport stick',
    swedish: 'klubba',
    norwegian: 'kølle',
    finnish: 'maila, jääkiekkomaila',
    hungarian: 'ütő, sportütő',
    german: 'Schläger (Hockey)',
    dutch: 'stick',
    afrikaans: 'sport stok',
    russian: 'клюшка, бита',
    latvian: 'nūja, sporta nūja',
    polish: 'kij (do hokeja, golfa itp.)',
    french: 'canne, bâton (de sport)',
    spanish: 'palo para deporte',
  },
  {
    av: 17237,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      "(person + protection: person who shares one's roof) - Character (superimposed)",
    english: 'spouse, cohabitant, partner',
    swedish: 'maka, make, sambo, partner',
    norwegian: 'ektefelle, samboer',
    finnish: 'aviopuoliso',
    hungarian: 'házastárs, élettárs',
    german: 'Gatte, Gattin, Mitbewohner, Mitbewohnerin, Partner, Partnerin',
    dutch: 'echtgenoot, echtgenote',
    afrikaans: 'eggenoot, eggenote',
    russian: 'супруга, супруг, партнер',
    latvian: 'dzīvesbiedrs (-e), laulātais (-ā)',
    polish: 'małżonek, partner (w rodzinie)',
    french: 'époux, conjoint, colocataire',
    spanish: 'cónyuge, esposo(a), compañero',
  },
  {
    av: 17238,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + on (combination): food that is put on something else) - Character (superimposed - combined)',
    english: 'spread, paste',
    swedish: 'pålägg',
    norwegian: 'pålegg',
    finnish: 'tahna, leikkeleet, päällysteet',
    hungarian: 'kennivaló, kenhető ételnemű',
    german: 'Brotaufstrich',
    dutch: 'beleg, pasta (smeren)',
    afrikaans: 'smeer, purée',
    russian: 'спред, паста, начинка',
    latvian: 'pavalgs',
    polish: 'smarowidło, coś do smarowania',
    french: 'tartinade',
    spanish: 'propagación',
  },
  {
    av: 17244,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vegetable above ground [modification] + pictograph of thick rind) - Character (superimposed - modified - combined)',
    english: 'squash, pumpkin',
    swedish: 'squash, pumpa',
    norwegian: 'gresskar',
    finnish: 'kurpitsa',
    hungarian: 'tök, sütőtök',
    german: 'Kürbis',
    dutch: 'pompoen',
    afrikaans: 'pampoen',
    russian: 'кабачок, тыква',
    latvian: 'kabacis, ķirbis',
    polish: 'dynia, kabaczek',
    french: 'courge, citrouille',
    spanish: 'calabacín',
  },
  {
    av: 17247,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a side view of a flight of stairs) - Character',
    english: 'stairs, steps',
    swedish: 'trappa',
    norwegian: 'trapp',
    finnish: 'portaat, rappuset',
    hungarian: 'lépcső',
    german: 'Treppe, Stufe',
    dutch: 'trap',
    afrikaans: 'trap',
    russian: 'лестница',
    latvian: 'kāpnes, pakāpieni',
    polish: 'schody, stopnie',
    french: 'escalier',
    spanish: 'escaleras, escalones',
  },
  {
    av: 17248,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a stamp in the upper corner of an envelope) - Character',
    english: 'stamp',
    swedish: 'frimärke',
    norwegian: 'frimerke',
    finnish: 'postimerkki',
    hungarian: 'bélyeg, levélbélyeg',
    german: 'Briefmarke',
    dutch: 'stempel',
    afrikaans: 'stempel',
    russian: 'почтовая марка',
    latvian: 'pastmarka',
    polish: 'znaczek',
    french: 'timbre',
    spanish: 'sello',
  },
  {
    av: 17251,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(symbol for Judaism) - Character',
    english: 'star of David',
    swedish: 'davidsstjärna',
    norwegian: 'Davidstjernen',
    finnish: 'Daavidin tähti',
    hungarian: 'Dávidcsillag',
    german: 'Davidstern',
    dutch: 'Davidster',
    afrikaans: 'ster van Dawid',
    russian: 'звезда Давида',
    latvian: 'Dāvida zvaigzne',
    polish: 'gwiazda Dawida (symbol)',
    french: 'étoile de David',
    spanish: 'estrella de David',
  },
  {
    av: 17252,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a star giving off rays of light) - Character',
    english: 'star',
    swedish: 'stjärna',
    norwegian: 'stjerne',
    finnish: 'tähti',
    hungarian: 'csillag',
    german: 'Stern',
    dutch: 'ster',
    afrikaans: 'ster',
    russian: 'звезда',
    latvian: 'zvaigzne',
    polish: 'gwiazdka, gwiazda',
    french: 'étoile',
    spanish: 'estrella',
  },
  {
    av: 17255,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water + up: when water is converted into steam by boiling, it rises) - Character (superimposed)',
    english: 'steam',
    swedish: 'ånga (subst.)',
    norwegian: 'damp',
    finnish: 'höyry',
    hungarian: 'gőz',
    german: 'Dampf',
    dutch: 'stoom',
    afrikaans: 'stoom',
    russian: 'пар, испарение',
    latvian: 'tvaiks, garaiņi',
    polish: 'para wodna',
    french: 'vapeur',
    spanish: 'vapor',
  },
  {
    av: 17257,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(room + steam) - Character (superimposed)',
    english: 'steam bath',
    swedish: 'bastu, ångbad',
    norwegian: 'badstu, dampbad',
    finnish: 'höyrykylpy',
    hungarian: 'gőzfürdő',
    german: 'Sauna, Dampfbad',
    dutch: 'stoombad',
    afrikaans: 'stoom bad',
    russian: 'сауна, баня',
    latvian: 'tvaika pirts',
    polish: 'łaźnia parowa',
    french: 'bain à vapeur, bain de vapeur',
    spanish: 'baño de vapor',
  },
  {
    av: 17259,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(flower + pointer, to stem) - Character (superimposed - pointer)',
    english: 'stem, stalk',
    swedish: 'stjälk',
    norwegian: 'stilk',
    finnish: 'varsi',
    hungarian: 'szár, inda, kocsány',
    german: 'Stengel, Stamm, Halm',
    dutch: 'steel, stengel',
    afrikaans: 'steel, stingel',
    russian: 'стебель',
    latvian: 'kāts',
    polish: 'łodyga',
    french: 'tige',
    spanish: 'tallo',
  },
  {
    av: 17260,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: "(husband + mother: husband of one's mother) - Character (superimposed)",
    english: 'stepfather',
    swedish: 'styvfar',
    norwegian: 'stefar',
    finnish: 'isäpuoli, äidin mies',
    hungarian: 'nevelőapa, mostohaapa',
    german: 'Stiefvater',
    dutch: 'stiefvader',
    afrikaans: 'stiefvader',
    russian: 'отчим',
    latvian: 'patēvs',
    polish: 'ojczym',
    french: 'beau-père',
    spanish: 'padrastro',
  },
  {
    av: 17261,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: "(wife + father: wife of one's father) - Character (superimposed)",
    english: 'stepmother',
    swedish: 'styvmor',
    norwegian: 'stemor',
    finnish: 'äitipuoli, isän vaimo',
    hungarian: 'nevelőanya, mostohaanya',
    german: 'Stiefmutter',
    dutch: 'stiefmoeder',
    afrikaans: 'stiefmoeder',
    russian: 'мачеха',
    latvian: 'pamāte',
    polish: 'macocha',
    french: 'belle-mère',
    spanish: 'madrastra',
  },
  {
    av: 17265,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(body + pointer to stomach) - Character (superimposed - pointer)',
    english: 'stomach, abdomen, belly',
    swedish: 'mage, buk',
    norwegian: 'mage',
    finnish: 'vatsa',
    hungarian: 'gyomor',
    german: 'Magen, Bauch',
    dutch: 'buik, maag',
    afrikaans: 'buik, maag, abdomen',
    russian: 'живот, желудок',
    latvian: 'vēders, puncis',
    polish: 'brzuch, żołądek',
    french: 'ventre',
    spanish: 'estómago',
  },
  {
    av: 17267,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(mountain [half-sized]) - Character',
    english: 'stone, rock',
    swedish: 'sten, klippa',
    norwegian: 'stein, klippe',
    finnish: 'kivi',
    hungarian: 'kődarab, szikla',
    german: 'Stein, Fels, Felsen',
    dutch: 'steen, rots, kei',
    afrikaans: 'rots, klip',
    russian: 'камень, скала',
    latvian: 'akmens, klints',
    polish: 'kamień, skała',
    french: 'pierre, rocher',
    spanish: 'piedra, roca',
  },
  {
    av: 17273,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(fire + enclosure: enclosed source of heat) - Character (superimposed)',
    english: 'stove, furnace, heater, oven',
    swedish: 'spis, ugn',
    norwegian: 'ovn, komfyr',
    finnish: 'hella, uuni',
    hungarian: 'tűzhely, kályha, kemence',
    german: 'Kochherd, Ofen',
    dutch: 'oven',
    afrikaans: 'stoof, verwarmer, oond',
    russian: 'плита, печка',
    latvian: 'plīts, krāsns',
    polish: 'piec, piekarnik, kuchenka',
    french: 'four, fourneau, cuisinière, chauffage',
    spanish: 'estufa, horno, calentador',
  },
  {
    av: 17278,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(berry + pictograph of seeds showing on the outside) - Character (superimposed)',
    english: 'strawberry',
    swedish: 'jordgubbe',
    norwegian: 'jordbær',
    finnish: 'mansikka',
    hungarian: 'eper',
    german: 'Erdbeere',
    dutch: 'aardbei',
    afrikaans: 'aarbei',
    russian: 'клубника',
    latvian: 'zemene',
    polish: 'truskawka',
    french: 'fraise',
    spanish: 'fresa',
  },
  {
    av: 17441,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(street with building + pointer, to street: ground, next to a building, used as a public thoroughfare) - Character (superimposed - pointer)',
    english: 'street',
    swedish: 'gata, väg',
    norwegian: 'gate',
    finnish: 'katu, tie',
    hungarian: 'utca, út',
    german: 'Straße',
    dutch: 'straat',
    afrikaans: 'straat',
    russian: 'улица',
    latvian: 'iela',
    polish: 'ulica, droga',
    french: 'rue',
    spanish: 'calle',
  },
  {
    av: 17445,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure [modification, formed of lines and dots]) - Character (modified)',
    english: 'structure, construction',
    swedish: 'konstruktion',
    norwegian: 'konstruksjon',
    finnish: 'rakenne',
    hungarian: 'szerkezet, struktúra, konstrukció',
    german: 'Struktur, Gerüst, Konstruktion',
    dutch: 'structuur',
    afrikaans: 'struktuur, konstruksie',
    russian: 'структура, конструкция',
    latvian: 'struktūra, konstrukcija',
    polish: 'struktura, konstrukcja',
    french: 'structure',
    spanish: 'estructura, construcción',
  },
  {
    av: 17449,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(based upon the international mathematical symbol) - Character',
    english: 'subtraction, loss',
    swedish: 'avdrag, förlust, subtraktion',
    norwegian: 'subtraksjon, tap',
    finnish: 'vähennyslasku, vähentäminen',
    hungarian: 'kivonás, veszteség',
    german: 'Subtraktion',
    dutch: 'verlies',
    afrikaans: 'minus, verlies',
    russian: 'вычитание, потеря',
    latvian: 'atņemšana',
    polish: 'strata, różnica, odejmowanie',
    french: 'soustraction, perte',
    spanish: 'sustracción, pérdida',
  },
  {
    av: 17451,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(opposing forces, counter-forces + forward: the forward arrow moves forward through the two arrows of topposing forces, i.e., it has success in overcoming the opposing forces) - Character (superimposed)',
    english: 'success',
    swedish: 'framgång',
    norwegian: 'suksess, framgang',
    finnish: 'onnistuminen, menestyminen, menestys',
    hungarian: 'siker',
    german: 'Erfolg',
    dutch: 'succes',
    afrikaans: 'sukses',
    russian: 'успех, удача',
    latvian: 'panākumi',
    polish: 'powodzenie, sukces',
    french: 'réussite',
    spanish: 'éxito',
  },
  {
    av: 17462,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'sun',
    swedish: 'sol',
    norwegian: 'sol',
    finnish: 'aurinko',
    hungarian: 'Nap',
    german: 'Sonne',
    dutch: 'zon',
    afrikaans: 'son',
    russian: 'солнце',
    latvian: 'saule',
    polish: 'słońce',
    french: 'soleil',
    spanish: 'sol',
  },
  {
    av: 17472,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water (ground level) + earth [half-sized]: more water than earth) - Character (superimposed)',
    english: 'swamp, bog, marsh',
    swedish: 'mosse, myr, sankmark',
    norwegian: 'myr, sump',
    finnish: 'suo, räme',
    hungarian: 'mocsár, láp',
    german: 'Sumpf, Morast',
    dutch: 'moeras',
    afrikaans: 'moeras, vleiland, vlei',
    russian: 'болото, топь, трясина',
    latvian: 'purvs',
    polish: 'bagno, grzęzawisko, torfowisko, moczary',
    french: 'marais, marécage',
    spanish: 'pantano, ciénaga',
  },
  {
    av: 17473,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water creature + pictograph of swan neck and head: symbol also incorporates water) - Character (superimposed)',
    english: 'swan',
    swedish: 'svan',
    norwegian: 'svane',
    finnish: 'joutsen',
    hungarian: 'hattyú',
    german: 'Schwan',
    dutch: 'zwaan',
    afrikaans: 'swaan',
    russian: 'лебедь',
    latvian: 'gulbis',
    polish: 'łabędź',
    french: 'cygne',
    spanish: 'cisne',
  },
  {
    av: 17493,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests the side view of a table) - Character',
    english: 'table',
    swedish: 'bord',
    norwegian: 'bord',
    finnish: 'pöytä',
    hungarian: 'asztal',
    german: 'Tisch',
    dutch: 'tafel',
    afrikaans: 'tafel',
    russian: 'стол',
    latvian: 'galds',
    polish: 'stół',
    french: 'table',
    spanish: 'mesa',
  },
  {
    av: 17496,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(canine + pointer, to tail) - Character (superimposed - pointer)',
    english: 'tail',
    swedish: 'svans',
    norwegian: 'hale',
    finnish: 'häntä',
    hungarian: 'farok',
    german: 'Schwanz',
    dutch: 'staart',
    afrikaans: 'stert',
    russian: 'хвост',
    latvian: 'aste',
    polish: 'ogon',
    french: 'queue',
    spanish: 'cola',
  },
  {
    av: 17504,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(bus, coach [modification, prolonged] + cannon [modification, higher position]) - Character (superimposed - modified)',
    english: 'tank',
    swedish: 'stridsvagn',
    norwegian: 'stridsvogn, tanks',
    finnish: 'panssarivaunu, tankki',
    hungarian: 'tank',
    german: 'Panzer',
    dutch: 'tank',
    afrikaans: 'tank',
    russian: 'танк',
    latvian: 'tanks',
    polish: 'czołg',
    french: 'tank, char, blindé',
    spanish: 'tanque',
  },
  {
    av: 17506,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(nose + mouth: the nose and mouth are both used in tasting) - Character (superimposed)',
    english: 'taste',
    swedish: 'smak',
    norwegian: 'smak',
    finnish: 'maku',
    hungarian: 'íz',
    german: 'Geschmack',
    dutch: 'smaak',
    afrikaans: 'smaak',
    russian: 'вкус',
    latvian: 'garša',
    polish: 'smak',
    french: 'goût',
    spanish: 'sabor',
  },
  {
    av: 17516,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(child + adult (combination): person between childhood and adulthood) - Character (superimposed - combined)',
    english: 'teenager, adolescent, youth',
    swedish: 'tonåring, ungdom',
    norwegian: 'tenåring, ungdom',
    finnish: 'nuori (henkilö), teini-ikäinen',
    hungarian: 'serdülő, kamasz, tínédzser, adoleszcens, tini',
    german: 'Jugendlicher, Teenager, Jugendliche',
    dutch: 'tiener, adolescent',
    afrikaans: 'tiener, adolessent',
    russian: 'подросток',
    latvian: 'pusaudzis, jaunietis',
    polish: 'nastolatek, wyrostek, młodzieniec',
    french: 'adolescent',
    spanish: 'adolescente',
  },
  {
    av: 17517,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests two teeth) - Character',
    english: 'teeth',
    swedish: 'tänder',
    norwegian: 'tenner',
    finnish: 'hampaat',
    hungarian: 'fog',
    german: 'Zahn',
    dutch: 'tanden',
    afrikaans: 'tande',
    russian: 'зубы',
    latvian: 'zobi',
    polish: 'zęby',
    french: 'dents',
    spanish: 'dientes',
  },
  {
    av: 17520,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(scale, measurement + point [low position under earthline]: symbol suggests a thermometer and incorporates measurement in a vertical position) - Character (superimposed)',
    english: 'temperature',
    swedish: 'temperatur',
    norwegian: 'temperatur',
    finnish: 'lämpötila',
    hungarian: 'hőmérséklet',
    german: 'Temperatur',
    dutch: 'temperatuur',
    afrikaans: 'temperatuur',
    russian: 'температура',
    latvian: 'temperatūra',
    polish: 'temperatura',
    french: 'température',
    spanish: 'temperatura',
  },
  {
    av: 17697,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(dot [low position] + the: the diagonal line has the same orientation as the one used in the and this) - Character (superimposed)',
    english: 'that (there)',
    swedish: 'den där, det där',
    norwegian: 'den der, det der',
    finnish: 'tuo',
    hungarian: 'az (mutató nm.)',
    german: 'jener, jener, jene, jenes',
    dutch: 'die, dat',
    afrikaans: 'daar',
    russian: 'эта, этот (неопред.форма)',
    latvian: 'tas, tur',
    polish: 'tamten (tam)',
    french: 'cela, ça',
    spanish: 'ese (allí), aquel',
  },
  {
    av: 17700,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(diagonal line suggests an index finger pointing at something specific. The diagonal line has the same orientation as the one used in this and that.) - Character',
    english: 'the',
    swedish: 'den, det (bestämd form)',
    norwegian: 'den, det (bestemt form)',
    finnish: 'se',
    hungarian: 'a, az (névelő)',
    german: 'der, der, die, das (Demonstrativpronomen)',
    dutch: 'de, het',
    afrikaans: 'die',
    russian: 'этот, эта (опред.форма)',
    latvian: 'jo, tas, tās',
    polish: 'to',
    french: 'le, la, les',
    spanish: 'el, la',
  },
  {
    av: 17705,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(future [half-sized]) - Character',
    english: 'then, so, later',
    swedish: 'senare, sedan',
    norwegian: 'da, seinere, siden, så',
    finnish: 'sitten, myöhemmin',
    hungarian: 'majd, később',
    german: 'dann, später',
    dutch: 'dan',
    afrikaans: 'dan, later',
    russian: 'позже',
    latvian: 'vēlāk, tad',
    polish: 'następnie, potem, później',
    french: 'alors, ensuite (futur)',
    spanish: 'luego, entonces, más tarde',
  },
  {
    av: 17707,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      "(two dots + by, by means of, of: the 'by' arrowhead at the right hand end pointing to the left to the last one of two dots, indicating the furter away 'there' relationship to certain points in space) - Character (sequenced)",
    english: 'there',
    swedish: 'där',
    norwegian: 'der',
    finnish: 'tuolla, tuossa, siellä',
    hungarian: 'ott',
    german: 'dort, da, dahin',
    dutch: 'daar, ginds, er',
    afrikaans: 'daar',
    russian: 'там',
    latvian: 'tur',
    polish: 'tam',
    french: 'là, y',
    spanish: 'ahí',
  },
  {
    av: 17708,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(cause [half-sized]) - Character',
    english: 'therefore, so, so that',
    swedish: 'så, alltså',
    norwegian: 'derfor, så, altså',
    finnish: 'siksi, sentähden, niinpä',
    hungarian: 'azért, ezért, így, tehát',
    german: 'deshalb, damit, sodass',
    dutch: 'daarom',
    afrikaans: 'daarom, sodat',
    russian: 'итак',
    latvian: 'tā, tādēļ, tādējādi, tātad',
    polish: 'dlatego też, ',
    french: 'donc, par conséquent',
    spanish: 'por lo tanto, de manera que',
  },
  {
    av: 17717,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(symbol suggests the two dimensional outline of a crystal) - Character',
    english: 'thing, object',
    swedish: 'sak, föremål',
    norwegian: 'ting, objekt',
    finnish: 'tavara, esine',
    hungarian: 'dolog, tárgy',
    german: 'Ding, Sache, Gegenstand',
    dutch: 'ding, voorwerp',
    afrikaans: 'ding, voorwerp',
    russian: 'вещь, предмет',
    latvian: 'lieta, priekšmets, objekts',
    polish: 'rzecz, obiekt, przedmiot',
    french: 'chose',
    spanish: 'cosa, objeto',
  },
  {
    av: 17720,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(the + dot [high position]: the diagonal line has the same orientation as the one used in the and that) - Character (superimposed)',
    english: 'this',
    swedish: 'den här, det här, denna, detta',
    norwegian: 'dette, den her, det her',
    finnish: 'tämä',
    hungarian: 'ez',
    german: 'dieser, diesem, dieser, diese, dieses',
    dutch: 'dit, deze',
    afrikaans: 'dit',
    russian: 'это, эта',
    latvian: 'šis, šī',
    polish: 'to',
    french: 'ceci, ce',
    spanish: 'esta',
  },
  {
    av: 17724,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(forward + reference line: arrow is passing through the reference line) - Character (superimposed)',
    english: 'through',
    swedish: 'genom',
    norwegian: 'gjennom',
    finnish: 'läpi',
    hungarian: 'át, keresztül',
    german: 'durch',
    dutch: 'door, doorheen',
    afrikaans: 'deur',
    russian: 'через, сквозь',
    latvian: 'caur',
    polish: 'przez',
    french: 'à travers',
    spanish: 'a través de',
  },
  {
    av: 17726,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(hand + pointer, to thumb) - Character (superimposed - pointer)',
    english: 'thumb',
    swedish: 'tumme',
    norwegian: 'tommel',
    finnish: 'peukalo',
    hungarian: 'hüvelykujj',
    german: 'Daumen',
    dutch: 'duim',
    afrikaans: 'duim',
    russian: 'большой палец',
    latvian: 'īkšķis',
    polish: 'kciuk',
    french: 'pouce',
    spanish: 'pulgar',
  },
  {
    av: 17732,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(symbol looks like a clock face, suggesting time) - Character',
    english: 'time',
    swedish: 'tid',
    norwegian: 'tid',
    finnish: 'aika',
    hungarian: 'idő',
    german: 'Zeit',
    dutch: 'tijd',
    afrikaans: 'tyd',
    russian: 'время',
    latvian: 'laiks',
    polish: 'czas',
    french: 'temps',
    spanish: 'tiempo',
  },
  {
    av: 17734,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(wheel + pointer, to tire) - Character (superimposed - pointer)',
    english: 'tire, tyre',
    swedish: 'däck (till hjul)',
    norwegian: 'dekk (hjul)',
    finnish: 'pyöränrengas',
    hungarian: 'gumiabroncs, autógumi, kerékpárgumi',
    german: 'Autoreifen, Reifen',
    dutch: 'band',
    afrikaans: 'band',
    russian: 'автопокрышка, шина',
    latvian: 'riepa',
    polish: 'opona, opony',
    french: 'pneu',
    spanish: 'neumático',
  },
  {
    av: 17739,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(arrowhead + reference line [half-sized]: the arrowhead approaches the reference line. This symbol is a simplified form of approach.) - Character (sequenced)',
    english: 'to, toward, towards',
    swedish: 'till, mot, fram mot',
    norwegian: 'til, mot',
    finnish: 'luokse, jonnekin, kohti',
    hungarian: 'felé, oda, odafelé',
    german: 'zu, zum, zur, nach',
    dutch: 'naar, naartoe, erheen',
    afrikaans: 'na, daarnatoe',
    russian: 'к, вперёд к',
    latvian: 'uz, turp, virzienā uz',
    polish: 'do, w kierunku',
    french: 'vers, à',
    spanish: 'a, hacia',
  },
  {
    av: 17745,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(legs and feet + pointer, to toe) - Character (superimposed - pointer)',
    english: 'toe',
    swedish: 'tå',
    norwegian: 'tå',
    finnish: 'varvas',
    hungarian: 'lábujj',
    german: 'Zehe, Zeh',
    dutch: 'teen',
    afrikaans: 'toon',
    russian: 'палец ноги',
    latvian: 'kāju pirksts',
    polish: 'palec u nogi',
    french: 'orteil',
    spanish: 'dedo del pie',
  },
  {
    av: 17747,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(seat + water (ground level): water closet) - Character (superimposed)',
    english: 'toilet',
    swedish: 'toalett',
    norwegian: 'do, toalett',
    finnish: 'vessa, WC',
    hungarian: 'vécé, toilet',
    german: 'Toilette',
    dutch: 'toilet, wc',
    afrikaans: 'toilet',
    russian: 'туалет',
    latvian: 'tualete',
    polish: 'toaleta',
    french: 'toilettes',
    spanish: 'váter, toalet',
  },
  {
    av: 17755,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + hand: thing used by the hand to extend its capabilities) - Character (superimposed)',
    english: 'tool, instrument',
    swedish: 'verktyg, redskap',
    norwegian: 'verktøy, redskap',
    finnish: 'työkalu, väline',
    hungarian: 'eszköz, szerszám',
    german: 'Werkzeug',
    dutch: 'gereedschap',
    afrikaans: 'gereedskap',
    russian: 'инструмент',
    latvian: 'darbarīks, instruments',
    polish: 'narzędzie, przyrząd',
    french: 'outil',
    spanish: 'herramienta, instrumento',
  },
  {
    av: 17758,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + pointer, to top) - Character (superimposed - pointer)',
    english: 'top',
    swedish: 'översida',
    norwegian: 'topp, overside',
    finnish: 'huippu, yläpuoli',
    hungarian: 'teteje, felső része valaminek',
    german: 'Oberteil, Oberkante, oben, obere Seite',
    dutch: 'bovenkant',
    afrikaans: 'bokant, bo-kant',
    russian: 'верх',
    latvian: 'augšpuse, virsa, virsma',
    polish: 'szczyt, góra (w przestrzeni)',
    french: 'dessus, surface',
    spanish: 'lado superior',
  },
  {
    av: 17759,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'dreidel top',
    swedish: 'snurra',
    norwegian: 'snurrebass',
    finnish: 'hyrrä',
    hungarian: 'dreidel (héber)',
    german: 'Kreisel',
    dutch: 'tol, draaitol',
    afrikaans: 'tol, spintol',
    russian: 'юла, волчок',
    latvian: 'vilciņš, rotējama rotaļlieta',
    polish: 'drejdel (bączek do tradycyjnej hebrajskiej gry hazardowej)',
    french: 'toupie',
    spanish: 'dreidel (superior)',
  },
  {
    av: 17760,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph of a scroll on two posts: the Torah contains the Old Testament) - Character',
    english: 'Torah',
    swedish: 'Torah (Israel)',
    norwegian: 'Torah (Israel)',
    finnish: 'toora',
    hungarian: 'Tóratekercs (héber)',
    german: 'Thora',
    dutch: 'Torah (joods)',
    afrikaans: 'Torah',
    russian: 'Тора (Израиль)',
    latvian: 'Tora (Izraēla)',
    polish: 'Tora (hebr)',
    french: 'Torah',
    spanish: 'Torah ',
  },
  {
    av: 17765,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(car [modification, full sized back wheel]: pictograph of a tractor) - Character (modified)',
    english: 'tractor',
    swedish: 'traktor',
    norwegian: 'traktor',
    finnish: 'traktori',
    hungarian: 'traktor',
    german: 'Traktor',
    dutch: 'tractor',
    afrikaans: 'trekker',
    russian: 'трактор',
    latvian: 'traktors',
    polish: 'ciągnik, traktor',
    french: 'tracteur',
    spanish: 'tractor',
  },
  {
    av: 17773,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'tray',
    swedish: 'bricka',
    norwegian: 'serveringsbrett, brett',
    finnish: 'tarjotin',
    hungarian: 'tálca',
    german: 'Tablett',
    dutch: 'dienblad',
    afrikaans: 'skinkbord',
    russian: 'поднос',
    latvian: 'paplāte',
    polish: 'taca, podstawka',
    french: 'plateau',
    spanish: 'bandeja',
  },
  {
    av: 17775,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph, of tree with trunk and branches) - Character',
    english: 'tree',
    swedish: 'träd',
    norwegian: 'tre (subst.)',
    finnish: 'puu',
    hungarian: 'fa',
    german: 'Baum',
    dutch: 'boom',
    afrikaans: 'boom',
    russian: 'дерево',
    latvian: 'koks',
    polish: 'drzewo',
    french: 'arbre',
    spanish: 'árbol',
  },
  {
    av: 17779,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(wheel + earth: movement along the earth) - Character (superimposed)',
    english: 'trip, journey, travel, voyage',
    swedish: 'resa (subst.)',
    norwegian: 'reise',
    finnish: 'matka',
    hungarian: 'utazás',
    german: 'Reise, Fahrt',
    dutch: 'reis',
    afrikaans: 'reis',
    russian: 'путешествие, поездка',
    latvian: 'ceļojums',
    polish: 'podróż, wycieczka',
    french: 'voyage',
    spanish: 'viaje',
  },
  {
    av: 17781,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(transport, transportation + car: large motor vehicle for carrying things) - Character (superimposed)',
    english: 'truck, lorry',
    swedish: 'lastbil',
    norwegian: 'lastebil',
    finnish: 'kuorma-auto, rekka-auto',
    hungarian: 'teherautó, kamion',
    german: 'Lastwagen',
    dutch: 'vrachtauto, camion (Vl)',
    afrikaans: 'vragmotor',
    russian: 'грузовая машина',
    latvian: 'smagā mašīna, kravas mašīna',
    polish: 'ciężarówka, samochód ciężarowy',
    french: 'camion',
    spanish: 'camión',
  },
  {
    av: 17783,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(tree + pointer, to trunk) - Character (superimposed - pointer)',
    english: 'trunk, tree trunk, bole',
    swedish: 'stam, trädstam',
    norwegian: 'stamme',
    finnish: 'runko',
    hungarian: 'fatörzs',
    german: 'Stamm, Baumstamm',
    dutch: 'stam, boomstam',
    afrikaans: 'stam boom',
    russian: 'ствол',
    latvian: 'stumbrs',
    polish: 'pień',
    french: 'tronc',
    spanish: 'tronco',
  },
  {
    av: 17786,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + hypothesis, theory: the mind believes itself to understand the nature of things, but it may be in error) - Character (superimposed)',
    english: 'truth',
    swedish: 'sanning',
    norwegian: 'sannhet',
    finnish: 'totuus',
    hungarian: 'igazság',
    german: 'Wahrheit',
    dutch: 'waarheid',
    afrikaans: 'waarheid',
    russian: 'правда',
    latvian: 'patiesība',
    polish: 'PRAWDA',
    french: 'vérité',
    spanish: 'verdad',
  },
  {
    av: 17958,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vegetable below ground [modification] + leaf (combination): large-leafed vegetable with an edible root) - Character (superimposed - modified -combined)',
    english: 'turnip, rutabaga, vegetable (large-leafed)',
    swedish: 'kålrot, beta (etc)',
    norwegian: 'kålrot, nepe, turnips',
    finnish: 'nauris',
    hungarian: 'fehérrépa, petrezselyemgyökér',
    german: 'Rübe, Kohlrübe',
    dutch: 'groente (veel groen)',
    afrikaans: 'raap, koolraap, groente (groot blaar)',
    russian: 'турнепс, репа',
    latvian: 'rācenis',
    polish: 'rzepa, brukiew, warzywo (duże liście)',
    french: 'navet',
    spanish: 'colinabo, vegetal (de hojas alargadas)',
  },
  {
    av: 17959,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + pictograph of head and protective shell) - Character (superimposed)',
    english: 'turtle, tortoise',
    swedish: 'sköldpadda',
    norwegian: 'skilpadde',
    finnish: 'kilpikonna',
    hungarian: 'teknőc, teknősbéka',
    german: 'Schildkröte',
    dutch: 'schildpad',
    afrikaans: 'skilpad',
    russian: 'черепаха',
    latvian: 'bruņurupucis',
    polish: 'żółw',
    french: 'tortue',
    spanish: 'tortuga',
  },
  {
    av: 17961,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + division [half-sized]: the mind’s division of things into categories) - Character (superimposed)',
    english: 'type, kind, sort, category',
    swedish: 'sort, slag, typ',
    norwegian: 'slag, type, sort',
    finnish: 'laatu, tyyppi, laji',
    hungarian: 'féle, fajta',
    german: 'Art, Sorte',
    dutch: 'soort',
    afrikaans: 'tipe, soort',
    russian: 'сорт, тип',
    latvian: 'veids, šķira, tips',
    polish: 'rodzaj, typ',
    french: 'type, sorte',
    spanish: 'tipo, clase',
  },
  {
    av: 17966,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(protection + pictograph of an umbrella handle: symbol suggests an umbrella) - Character (superimposed)',
    english: 'umbrella',
    swedish: 'paraply, parasoll',
    norwegian: 'paraply, parasoll',
    finnish: 'sateenvarjo',
    hungarian: 'esernyő',
    german: 'Regenschirm',
    dutch: 'paraplu',
    afrikaans: 'sambreel',
    russian: 'зонт',
    latvian: 'lietussargs',
    polish: 'parasol',
    french: 'parapluie',
    spanish: 'paraguas, sombrilla',
  },
  {
    av: 17967,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      "(brother + parent: brother of one's father or mother) - Character (superimposed)",
    english: 'uncle',
    swedish: 'farbror, morbror',
    norwegian: 'onkel',
    finnish: 'setä, eno',
    hungarian: 'nagybácsi, nagybátyja valakinek',
    german: 'Onkel',
    dutch: 'oom, nonkel(Vl)',
    afrikaans: 'oom',
    russian: 'дядя',
    latvian: 'tēvocis',
    polish: 'wujek',
    french: 'oncle',
    spanish: 'tío',
  },
  {
    av: 17969,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(horizontal reference line + dot [low position]: the dot is under or below the line) - Character (superimposed)',
    english: 'under, below, inferior',
    swedish: 'under, nedanför',
    norwegian: 'under',
    finnish: 'ali, alapuolella, alla',
    hungarian: 'alatt, alatta, alul, alá',
    german: 'unter, unterhalb, darunter',
    dutch: 'onder',
    afrikaans: 'onder',
    russian: 'под',
    latvian: 'zem, zemāks',
    polish: 'dolny, poniżej, pod spodem',
    french: 'sous, en dessous',
    spanish: 'debajo de, abajo',
  },
  {
    av: 17982,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(arrowhead + reference line [half-sized]: the arrowhead has arrived at and touches the reference line. This symbol is a simplified form of arrival, end.) - Character (superimposed)',
    english: 'until, till, to',
    swedish: 'intill, tills',
    norwegian: 'inntil, til',
    finnish: 'kunnes, asti',
    hungarian: 'míg, amíg, ameddig, -ig',
    german: 'bis',
    dutch: 'tot',
    afrikaans: 'tot',
    russian: 'пока, до',
    latvian: 'līdz, līdzpat',
    polish: 'do czasu, aż do',
    french: "jusque, jusqu'à",
    spanish: 'hasta',
  },
  {
    av: 17983,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(arrow, pointing upward) - Character',
    english: 'up, upward',
    swedish: 'upp, uppåt',
    norwegian: 'opp, oppover',
    finnish: 'ylös, ylöspäin',
    hungarian: 'fel, felfelé',
    german: 'auf, aufwärts, hinauf',
    dutch: 'naar boven, omhoog',
    afrikaans: 'op, opwaarts',
    russian: 'вверх',
    latvian: 'augšā, augšup',
    polish: 'w górę, wzwyż',
    french: 'en haut, vers le haut',
    spanish: 'hasta',
  },
  {
    av: 17986,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(diagonal arrow, pointing upward and backward) - Character',
    english: 'upward and backward',
    swedish: 'uppåt bakåt',
    norwegian: 'oppover og bakover',
    finnish: 'ylös taakse',
    hungarian: 'felfelé és vissza/hátrafelé',
    german: 'upward and backward',
    dutch: 'omhoog en achteruit',
    afrikaans: 'opwaarts-en-terugwaarts',
    russian: 'вверх и назад',
    latvian: 'augšup un atpakaļ',
    polish: 'w górę i do tyłu',
    french: 'en haut et en arrière',
    spanish: 'arriba y atrás',
  },
  {
    av: 17987,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(diagonal arrow, pointing upward and forward) - Character',
    english: 'upward and forward',
    swedish: 'uppåt framåt',
    norwegian: 'oppover og framover',
    finnish: 'ylös eteen',
    hungarian: 'felfelé és előrefelé',
    german: 'voraus und hinauf',
    dutch: 'vooruit en omhoog',
    afrikaans: 'opwaarts-en-voorwaarts',
    russian: 'вверх и вперёд',
    latvian: 'augšup un uz priekšu',
    polish: 'w górę i do przodu',
    french: 'en haut et en avant',
    spanish: 'arriba y adelante',
  },
  {
    av: 17994,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(body + creation [half sized]: part of a woman’s body where new life is nurtured) - Character (superimposed)',
    english: 'uterus, womb',
    swedish: 'livmoder',
    norwegian: 'livmor',
    finnish: 'kohtu',
    hungarian: 'méh, anyaméh, uterusz',
    german: 'Uterus, Gebärmutter',
    dutch: 'baarmoeder',
    afrikaans: 'baarmoeder',
    russian: 'матка',
    latvian: 'dzemde',
    polish: 'macica',
    french: 'utérus',
    spanish: 'útero',
  },
  {
    av: 17996,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(uterus [modification, opening in body] + pointer, to passage) - Character (superimposed - modified - pointer)',
    english: 'vagina',
    swedish: 'slida',
    norwegian: 'skjede, vagina',
    finnish: 'emätin',
    hungarian: 'hüvely, vagina',
    german: 'Vagina, Scheide',
    dutch: 'vagina',
    afrikaans: 'vagina',
    russian: 'вагина, влагалище',
    latvian: 'maksts',
    polish: 'pochwa',
    french: 'vagin',
    spanish: 'vagina',
  },
  {
    av: 17999,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mountains with valley + pointer: the low place between two mountains) - Character (superimposed - pointer)',
    english: 'valley',
    swedish: 'dal',
    norwegian: 'dal',
    finnish: 'laakso',
    hungarian: 'völgy',
    german: 'Tal',
    dutch: 'vallei, dal',
    afrikaans: 'vallei, dal',
    russian: 'долина',
    latvian: 'ieleja',
    polish: 'dolina',
    french: 'vallée',
    spanish: 'valle',
  },
  {
    av: 18004,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + fruit [modification, upside down]: symbol suggests a vegetable with the edible portion above ground and the root below) - Character (superimposed - modified)',
    english: 'vegetable (above ground)',
    swedish: 'grönsak',
    norwegian: 'grønnsak (over jorda)',
    finnish: 'vihannes',
    hungarian: 'zöldség (föld feletti terméssel)',
    german: 'Gemüse (über der Erde wachsend)',
    dutch: 'groente (boven de grond)',
    afrikaans: 'groente (bo grond)',
    russian: 'овощ',
    latvian: 'dārzenis, lapu',
    polish: 'warzywo (naziemne)',
    french: 'légume (au-dessus de terre)',
    spanish: 'vegetales (encima de tierra)',
  },
  {
    av: 18005,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + fruit [modification, low position]: symbol looks like a vegetable with the edible portion below ground and the leafy portion above) - Character (superimposed - modified)',
    english: 'vegetable (below ground)',
    swedish: 'rotfrukt',
    norwegian: 'rotfrukt',
    finnish: 'juures',
    hungarian: 'zöldség (föld alatti terméssel)',
    german: 'Gemüse (unter der Erde wachsend)',
    dutch: 'groente (onder de grond)',
    afrikaans: 'groente (onder grond)',
    russian: 'корнеплод',
    latvian: 'dārzenis, sakņu',
    polish: 'warzywo (podziemne) korzeniowe lub bulwa',
    french: 'légume (sous terre)',
    spanish: 'vegetales (bajo tierra)',
  },
  {
    av: 18006,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vegetable below ground + bulb (plant) (combination)) - Character (superimposed - combined) See bulb (plant) 15920',
    english: 'onion, vegetable (bulb)',
    swedish: 'lök (grönsak)',
    norwegian: 'løk',
    finnish: 'sipuli, sipulivihannes',
    hungarian: 'hagyma',
    german: 'Speisezwiebel, Gemüsezwiebel',
    dutch: 'groente (knolgewas)',
    afrikaans: 'ui, groente (knolgewas)',
    russian: 'лук',
    latvian: 'sīpols',
    polish: 'cebula, bulwa (roślina)',
    french: 'oignon, échalotte (légume)',
    spanish: 'cebolla, vegetal (bulbo)',
  },
  {
    av: 18007,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vegetable above ground + oval (combination)) - Character (superimposed - combined) See oval 23599',
    english: 'vegetable (oval-shaped)',
    swedish: 'grönsak (avlång)',
    norwegian: 'grønnsak (avlang)',
    finnish: 'vihannes (lieriön muotoinen)',
    hungarian: 'zöldség (hengeres alakú)',
    german: 'Wurzelgemüse (längliche Form)',
    dutch: 'groente (cilindervormig)',
    afrikaans: 'groente (silindries)',
    russian: 'овощ (овальный)',
    latvian: 'dārzenis (cilindrveida)',
    polish: 'warzywo (podłużne)',
    french: 'légume (de forme cylindrique)',
    spanish: 'vegetales (forma cilíndrica)',
  },
  {
    av: 18010,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(wheel + wheel + horizontal line: pictograph, symbol suggests a vehicle such as a railroad car or a horse-drawn carriage that does not operate under its own power) - Character (superimposed)',
    english: 'vehicle, carriage, railway car',
    swedish: 'fordon, vagn',
    norwegian: 'kjøretøy, vogn',
    finnish: 'kulkuneuvo, vaunu, ajoneuvo',
    hungarian: 'jármű, kocsi, vonatszerelvény',
    german: 'Fahrzeug, Wagen',
    dutch: 'voertuig',
    afrikaans: 'voertuig, motor, koets, spoorlyn kar',
    russian: 'транспортное средство',
    latvian: 'transporta līdzeklis, vagons, vilciena vagoni',
    polish: 'pojazd, wagon',
    french: 'véhicule',
    spanish: 'vehículo, coche, vagón',
  },
  {
    av: 18028,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vehicle + diagonal line, representing a handle) - Character (superimposed)',
    english: 'wagon, cart, truck',
    swedish: 'vagn, lastkärra (etc)',
    norwegian: 'vogn, kjerre',
    finnish: 'vaunut, rattaat',
    hungarian: 'kocsi, kézikocsi, szekér',
    german: 'Karren, Wagen, Anhänger',
    dutch: 'kar, aanhangwagen',
    afrikaans: 'wa, trok',
    russian: 'тележка, повозка',
    latvian: 'furgons, kravas kaste',
    polish: 'wózek, taczka',
    french: 'wagon',
    spanish: 'vagón, carro',
  },
  {
    av: 18029,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(body + pointer + pointer, to waist) - Character (superimposed - pointer)',
    english: 'waist',
    swedish: 'midja',
    norwegian: 'liv, midje',
    finnish: 'vyötärö',
    hungarian: 'derék (testrész)',
    german: 'Taille',
    dutch: 'middel, taille',
    afrikaans: 'middellyf',
    russian: 'талия',
    latvian: 'viduklis',
    polish: 'talia',
    french: 'taille (partie du corps)',
    spanish: 'cintura',
  },
  {
    av: 18033,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(room + pointer, to wall) - Character (superimposed - pointer)',
    english: 'wall',
    swedish: 'vägg',
    norwegian: 'vegg',
    finnish: 'seinä',
    hungarian: 'fal',
    german: 'Wand',
    dutch: 'muur',
    afrikaans: 'muur',
    russian: 'стена',
    latvian: 'siena',
    polish: 'ściana',
    french: 'mur',
    spanish: 'pared',
  },
  {
    av: 18034,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vertical line + star [modification, position and shape at the top of the wand]: pictograph) - Character (superimposed - modified)',
    english: 'wand',
    swedish: 'trollspö',
    norwegian: 'tryllestav',
    finnish: 'taikasauva, sauva',
    hungarian: 'bűvészpálca, varázsbot',
    german: 'Stab, Zauberstab',
    dutch: 'toverstaf',
    afrikaans: 'towerstaf',
    russian: 'волшебная палочка, жезл',
    latvian: 'brīnumnūjiņa',
    polish: 'różdżka',
    french: 'baguette magique',
    spanish: 'varita mágica',
  },
  {
    av: 18036,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(knife, sword + knife sword [modification, mirrored]: two crossed swords, suggesting armed conflict) - Character (superimposed - modified)',
    english: 'war',
    swedish: 'krig, strid',
    norwegian: 'krig, strid',
    finnish: 'sota',
    hungarian: 'háború',
    german: 'Krieg',
    dutch: 'oorlog',
    afrikaans: 'oorlog',
    russian: 'война',
    latvian: 'karš',
    polish: 'wojna, walka, starcie',
    french: 'guerre',
    spanish: 'guerra',
  },
  {
    av: 18043,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + to destroy: something discarded or no longer of use) - Character (superimposed)',
    english: 'waste, garbage, rubbish, trash',
    swedish: 'skräp, avfall, sopor',
    norwegian: 'skrap, avfall',
    finnish: 'romu, roska, jätteet, roju',
    hungarian: 'szemét, hulladék, kidobnivaló limlom',
    german: 'Abfall, Müll',
    dutch: 'afval',
    afrikaans: 'gemors, vullis, afval',
    russian: 'мусор',
    latvian: 'atkritumi',
    polish: 'odpady, śmieci',
    french: 'déchet',
    spanish: 'residuos, desperdicios, basura',
  },
  {
    av: 18209,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(symbol looks like a wave, suggesting water or liquid) - Character',
    english: 'water, fluid, liquid',
    swedish: 'vatten, vätska',
    norwegian: 'vann, væske',
    finnish: 'vesi, neste',
    hungarian: 'víz, folyadék',
    german: 'Wasser, Flüssigkeit',
    dutch: 'water, vloeistof',
    afrikaans: 'water, vloeistof',
    russian: 'вода, жидкость',
    latvian: 'ūdens, šķidrums',
    polish: 'woda, płyn, ciecz',
    french: 'eau, fluide, liquide',
    spanish: 'agua, fluido, líquido',
  },
  {
    av: 18214,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sun + rain: these symbols represent the two major types of weather conditions) - Character (superimposed)',
    english: 'weather',
    swedish: 'väder',
    norwegian: 'vær',
    finnish: 'sää, ilma',
    hungarian: 'időjárás',
    german: 'Wetter',
    dutch: 'weer (zelfst.nw)',
    afrikaans: 'weer',
    russian: 'погода',
    latvian: 'laiks, laikapstākļi',
    polish: 'pogoda',
    french: 'temps météorologique',
    spanish: 'tiempo, clima',
  },
  {
    av: 18221,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a scale on which weight is measured) - Character',
    english: 'weight',
    swedish: 'vikt',
    norwegian: 'vekt (tyngde)',
    finnish: 'paino',
    hungarian: 'súly, súlya van',
    german: 'Gewicht',
    dutch: 'gewicht (van iets)',
    afrikaans: 'gewig',
    russian: 'вес',
    latvian: 'svars',
    polish: 'waga, ciężar',
    french: 'poids',
    spanish: 'peso',
  },
  {
    av: 18224,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sun + pointer, to west) - Character (superimposed - pointer)',
    english: 'west',
    swedish: 'väster',
    norwegian: 'vest',
    finnish: 'länsi',
    hungarian: 'Nyugat',
    german: 'Westen, West',
    dutch: 'west, westen',
    afrikaans: 'wes',
    russian: 'запад',
    latvian: 'rietumi',
    polish: 'zachód',
    french: 'ouest',
    spanish: 'oeste',
  },
  {
    av: 18229,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(question mark [half-sized]: interrogative) - Character',
    english: 'what, question mark (small)',
    swedish: 'fråga (använd som symboldel)',
    norwegian: 'hva spørsmål (som symboldel)',
    finnish: 'mitä?',
    hungarian: 'mi?; kérdőjel',
    german: 'Was? Wie bitte?',
    dutch: 'wat (vragend vnw.)',
    afrikaans: 'wat (vraag woord)',
    russian: 'вопросительный знак',
    latvian: 'ko?',
    polish: 'co, znak zapytania',
    french: 'que (mot interrogatif)',
    spanish: 'qué, signo de interrogación',
  },
  {
    av: 18232,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a wheel with spokes) - Character',
    english: 'wheel',
    swedish: 'hjul',
    norwegian: 'hjul',
    finnish: 'pyörä',
    hungarian: 'kerék',
    german: 'Rad',
    dutch: 'wiel',
    afrikaans: 'wiel',
    russian: 'колесо',
    latvian: 'ritenis',
    polish: 'koło',
    french: 'roue',
    spanish: 'rueda',
  },
  {
    av: 18233,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(chair + wheel) - Character (superimposed)',
    english: 'wheelchair',
    swedish: 'rullstol',
    norwegian: 'rullestol',
    finnish: 'pyörätuoli',
    hungarian: 'kerekesszék',
    german: 'Rollstuhl',
    dutch: 'rolstoel',
    afrikaans: 'rolstoel',
    russian: 'инвалидная коляска',
    latvian: 'ratiņkrēsls',
    polish: 'wózek inwalidzki',
    french: 'chaise roulante',
    spanish: 'silla de ruedas',
  },
  {
    av: 18236,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(who, that, which-(relative) + earth, ground, land: can be viewed as a combination of who, that, which-(relative) and place, conjunction used to introduce a relative clause) - Character (superimposed)',
    english: 'where',
    swedish: 'var, var som',
    norwegian: 'hvor',
    finnish: 'jossa, missä',
    hungarian: 'ahol',
    german: 'wo, an dem, auf dem, bei dem',
    dutch: 'waar (betrekkelijk vnw.)',
    afrikaans: 'waar (betreklike vnw.)',
    russian: 'где',
    latvian: 'kur',
    polish: 'gdzie',
    french: 'où',
    spanish: 'donde',
  },
  {
    av: 18237,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(what, question mark + earth, ground, land: can be viewed as a combination of what, question mark and place: interrogative) - Character (superimposed)',
    english: 'where-(question)',
    swedish: 'var (fråga)',
    norwegian: 'hvor (spørsmål)',
    finnish: 'missä?',
    hungarian: 'hol?',
    german: 'Wo?',
    dutch: 'waar',
    afrikaans: 'waar (vraag)',
    russian: 'где?',
    latvian: 'kur?',
    polish: 'gdzie-(pytanie)',
    french: 'où (question)',
    spanish: 'dónde (pregunta)',
  },
  {
    av: 18251,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(protection + woman: this symbol, joined to husband, produces family) - Character (superimposed)',
    english: 'wife',
    swedish: 'fru, hustru, maka',
    norwegian: 'kone, hustru',
    finnish: 'aviovaimo',
    hungarian: 'feleség',
    german: 'Ehefrau',
    dutch: 'vrouw, echtgenote',
    afrikaans: 'vrou, eggenote',
    russian: 'жена, супруга',
    latvian: 'sieva',
    polish: 'żona',
    french: 'épouse',
    spanish: 'esposa',
  },
  {
    av: 18255,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(air + forward: air that moves forward) - Character (superimposed)',
    english: 'wind',
    swedish: 'vind, blåst',
    norwegian: 'vind',
    finnish: 'tuuli, puhallus',
    hungarian: 'szél',
    german: 'Wind',
    dutch: 'wind',
    afrikaans: 'wind',
    russian: 'ветер',
    latvian: 'vējš',
    polish: 'wiatr',
    french: 'vent',
    spanish: 'viento',
  },
  {
    av: 18256,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure + pictograph of two traversing bars) - Character (superimposed)',
    english: 'window',
    swedish: 'fönster',
    norwegian: 'vindu',
    finnish: 'ikkuna',
    hungarian: 'ablak',
    german: 'Fenster',
    dutch: 'raam, ruit, venster',
    afrikaans: 'venster',
    russian: 'окно',
    latvian: 'logs',
    polish: 'okno',
    french: 'fenêtre',
    spanish: 'ventana',
  },
  {
    av: 18257,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure + pictograph of bars of a lattice) - Character (superimposed)',
    english: 'barred window',
    swedish: 'galler, fönster med galler',
    norwegian: 'vindu med sprosser',
    finnish: 'kalterit',
    hungarian: 'rácsos ablak',
    german: '(Fenster) vergittert, Fenstergitter',
    dutch: 'tralies',
    afrikaans: 'diefwering, tralies',
    russian: 'решётка',
    latvian: 'restes, aizrestots logs',
    polish: 'zakratowane okno, krata w oknie',
    french: 'fenêtre munie de barreaux',
    spanish: 'ventana con barrotes',
  },
  {
    av: 18259,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: symbol suggests a pair of wings in flight) - Character',
    english: 'wing(s)',
    swedish: 'vinge, vingar',
    norwegian: 'vinge, vinger',
    finnish: 'siivet',
    hungarian: 'szárny',
    german: 'Flügel',
    dutch: 'vleugel(s)',
    afrikaans: 'vlerke',
    russian: 'крыло, крылья',
    latvian: 'spārns (-i)',
    polish: 'skrzydła',
    french: 'aile(s)',
    spanish: 'alas',
  },
  {
    av: 18267,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(addition [half-sized, modification with the crossbar located on the skyline]) - Character (modified)',
    english: 'with',
    swedish: 'med',
    norwegian: 'med',
    finnish: 'kanssa',
    hungarian: 'val, -vel',
    german: 'mit, mit Hilfe von, mittels',
    dutch: 'met',
    afrikaans: 'met',
    russian: 'с, со',
    latvian: 'ar',
    polish: 'z, razem, i',
    french: "avec, à l'aide de",
    spanish: 'con',
  },
  {
    av: 18269,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(person [modification] + creation [half-sized] (combination): CKB says woman embodies the creative principle in society. The symbol also looks like a stick figure of a woman wearing a skirt.) - Character (superimposed - modified - combined)',
    english: 'woman, female',
    swedish: 'kvinna, tant',
    norwegian: 'kvinne',
    finnish: 'nainen',
    hungarian: 'nő, asszony',
    german: 'Frau',
    dutch: 'vrouw',
    afrikaans: 'vrou, vroulik',
    russian: 'женщина',
    latvian: 'sieviete',
    polish: 'kobieta',
    french: 'femme',
    spanish: 'mujer',
  },
  {
    av: 18278,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sky + earth: what exists between sky and earth) - Character (superimposed)',
    english: 'world',
    swedish: 'värld',
    norwegian: 'verden',
    finnish: 'maailma',
    hungarian: 'világ, föld, földkerekség',
    german: 'Welt',
    dutch: 'wereld',
    afrikaans: 'wêreld',
    russian: 'мир',
    latvian: 'pasaule',
    polish: 'świat',
    french: 'monde',
    spanish: 'mundo',
  },
  {
    av: 18279,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth [modification, extended] + snake [modification, under earthline]: snake-like creature that lives underground) - Character (superimposed - modified)',
    english: 'worm',
    swedish: 'mask',
    norwegian: 'mark',
    finnish: 'mato',
    hungarian: 'féreg, hernyó, giliszta',
    german: 'Wurm',
    dutch: 'worm',
    afrikaans: 'wurm',
    russian: 'червь',
    latvian: 'tārps',
    polish: 'robak',
    french: 'ver de terre',
    spanish: 'gusano',
  },
  {
    av: 18284,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(arm + pointer, to wrist) - Character (superimposed - pointer)',
    english: 'wrist',
    swedish: 'handled',
    norwegian: 'håndledd',
    finnish: 'ranne',
    hungarian: 'csukló',
    german: 'Handgelenk',
    dutch: 'pols',
    afrikaans: 'gewrig',
    russian: 'запястье',
    latvian: 'plaukstas locītava',
    polish: 'nadgarstek',
    french: 'poignet',
    spanish: 'muñeca',
  },
  {
    av: 18287,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(building with yard and fence + pointer, to yard: area next to a building) - Character (superimposed - pointer)',
    english: 'yard',
    swedish: 'gård',
    norwegian: 'gårdsplass',
    finnish: 'piha',
    hungarian: 'kert',
    german: 'Hof, Hof',
    dutch: 'tuin',
    afrikaans: 'erf',
    russian: 'двор',
    latvian: 'pagalms, iekšpagalms',
    polish: 'podwórze, podwórko, ogródek przydomowy',
    french: 'cour, préau',
    spanish: 'patio',
  },
  {
    av: 18289,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sun with arrow head, indicating movement around: the earth completes one circuit around the sun in a year) - Character (superimposed)',
    english: 'year',
    swedish: 'år',
    norwegian: 'år',
    finnish: 'vuosi',
    hungarian: 'év',
    german: 'Jahr',
    dutch: 'jaar',
    afrikaans: 'jaar',
    russian: 'год',
    latvian: 'gads',
    polish: 'rok',
    french: 'année',
    spanish: 'año',
  },
  {
    av: 18293,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(international symbol for Japanese yen) - Character',
    english: 'yen',
    swedish: 'yen',
    norwegian: 'yen',
    finnish: 'jeni',
    hungarian: 'jen',
    german: 'Yen',
    dutch: 'yen',
    afrikaans: 'jen',
    russian: 'йена',
    latvian: 'jena',
    polish: 'jen',
    french: 'yen',
    spanish: 'yen',
  },
  {
    av: 20517,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(arm + the pictograph of a protruding biceps) - Character (superimposed) Preferred NEW SYNONYM, replacing 15676',
    english: 'muscle',
    swedish: 'muskel',
    norwegian: 'muskel',
    finnish: 'lihas',
    hungarian: 'izom',
    german: 'Muskel',
    dutch: 'spier',
    afrikaans: 'spier',
    russian: 'мускул',
    latvian: 'muskuļi',
    polish: 'mięsień',
    french: 'muscle',
    spanish: 'músculo',
  },
  {
    av: 20518,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + health) - Character (superimposed) Preferred NEW SYNONYM, replacing 17234',
    english: 'sport',
    swedish: 'sport',
    norwegian: 'sport',
    finnish: 'liikunta, urheilu, voimistelu',
    hungarian: 'sport',
    german: 'Sport',
    dutch: 'sport',
    afrikaans: 'sport',
    russian: 'спорт',
    latvian: 'sports',
    polish: 'sport',
    french: 'sport',
    spanish: 'deporte',
  },
  {
    av: 20519,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a sail on a mast) - Character Preferred NEW SYNONYM, replacing 16706',
    english: 'sail',
    swedish: 'segel ',
    norwegian: 'seiling',
    finnish: 'purje',
    hungarian: 'vitorla',
    german: 'Segel',
    dutch: 'zeil',
    afrikaans: 'seil',
    russian: 'парус',
    latvian: 'bura',
    polish: 'żagiel',
    french: 'voile',
    spanish: 'navegación a vela',
  },
  {
    av: 20520,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(boat + sail (combination): pictograph, suggests the outline of a sailboat.The symbol can be explained as: combination of boat and sail) - Character (superimposed - combined) Preferred NEW SYNONYM, replacing 16707',
    english: 'sailboat, sailing boat, yacht',
    swedish: 'segelbåt',
    norwegian: 'seilbåt',
    finnish: 'purjevene',
    hungarian: 'vitrolás, vitorláshajó, yacht',
    german: 'Segelboot',
    dutch: 'zeilboot',
    afrikaans: 'seilboot, seiljag',
    russian: 'парусное судно, парусник',
    latvian: 'burulaiva, jahta',
    polish: 'żaglówka, jacht, łódź żaglowa',
    french: 'voilier',
    spanish: 'velero, barco de vela, yate',
  },
  {
    av: 20522,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(spread + liquid) - Character (superimposed) Preferred NEW SYNONYM, replacing 16723',
    english: 'sauce, gravy, relish, dressing',
    swedish: 'sås, dressing (etc)',
    norwegian: 'saus, dressing',
    finnish: 'kastike',
    hungarian: 'mártás, öntet, szósz, szaft',
    german: 'Bratensoße, Soße',
    dutch: 'jus (Nl), saus, dressing',
    afrikaans: 'sous, atjar, slaaisous',
    russian: 'соус, подлива',
    latvian: 'mērce, salātu piedevas',
    polish: 'sos, dressing',
    french: 'sauce, tartinade liquide',
    spanish: 'salsa, condimento, aderezo',
  },
  {
    av: 20524,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(up, upward + down, downward) - Character (sequenced) Preferred NEW SYNONYM, replacing 17984',
    english: 'up and down',
    swedish: 'upp och ner',
    norwegian: 'opp og ned',
    finnish: 'ylös ja alas',
    hungarian: 'fel-le',
    german: 'auf und ab',
    dutch: 'op en neer',
    afrikaans: 'op en af',
    russian: 'вверх и вниз',
    latvian: 'augšā un lejā, augšup un lejup',
    polish: 'w górę i w dół',
    french: 'de haut en bas',
    spanish: 'arriba y abajo',
  },
  {
    av: 20528,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'can, tin, jar',
    swedish: 'burk',
    norwegian: 'boks',
    finnish: 'tölkki, purkki',
    hungarian: 'konzervdoboz',
    german: 'Dose, Büchse',
    dutch: 'blikje',
    afrikaans: 'blik, fles, kan',
    russian: 'банка ',
    latvian: 'kanna, burka, krūka',
    polish: 'konserwa, puszka, słoik',
    french: 'bocal, boîte cylindrique',
    spanish: 'jarra, lata, bote',
  },
  {
    av: 20561,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + God: God-based religion) - Character (superimposed)',
    english: 'religion (God based)',
    swedish: 'religion, tro',
    norwegian: 'religion, tro (tro på Gud)',
    finnish: 'uskonto',
    hungarian: 'vallás, Istenhit',
    german: 'Religion',
    dutch: 'godsdienst',
    afrikaans: 'godsdiens (op God gebaseer)',
    russian: 'вера в Бога',
    latvian: 'reliģija, ticība Dievam',
    polish: 'religia, wiara w Boga',
    french: 'religion (dieux)',
    spanish: 'religión (basada en un Dios)',
  },
  {
    av: 20563,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + creation: doctrine that all religious truths are derived from nature) - Character (superimposed) Preferred NEW SYNONYM, replacing 16483',
    english: 'religion, naturalism',
    swedish: 'tro, naturalism',
    norwegian: 'tro, naturalisme',
    finnish: 'uskonto, naturalismi',
    hungarian: 'vallás, naturalizmus',
    german: 'Religion, Glaube, Naturalismus',
    dutch: 'religie, naturalisme',
    afrikaans: 'godsdiens, naturalisme',
    russian: 'натурализм, вера',
    latvian: 'naturālisms, reliģija',
    polish: 'religia, wyznanie, wiara',
    french: 'religion (général)',
    spanish: 'religión, naturalismo',
  },
  {
    av: 20564,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + supernatural) - Character (superimposed)',
    english: 'belief (supernatural)',
    swedish: 'tro (övernaturlig)',
    norwegian: 'tro (overnaturlig)',
    finnish: 'usko',
    hungarian: 'hit a természetfölöttiben',
    german: 'Glaube (übernatürlich)',
    dutch: 'geloof',
    afrikaans: 'geloof (bonatuurlike)',
    russian: 'вера в Высший разум',
    latvian: 'ticība, (pārdabiskajam)',
    polish: 'wiara (w siły nadprzyrodzone)',
    french: 'croyance (surnaturelle)',
    spanish: 'creencia (sobrenatural)',
  },
  {
    av: 20568,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(person + horns) - Character (superimposed) SYMBOL SYNONYM',
    english: 'devil (1)',
    swedish: 'djävul (1)',
    norwegian: 'djevel (1)',
    finnish: 'paholainen',
    hungarian: 'ördög',
    german: 'Teufel (1)',
    dutch: 'duivel (1)',
    afrikaans: 'duiwel (1)',
    russian: 'Дьявол, Сатана, Лукавый (1)',
    latvian: 'velns, Sātans (1)',
    polish: 'Diabeł (1)',
    french: 'démon, diable (1)',
    spanish: 'diablo (1)',
  },
  {
    av: 20571,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(person + wings) - Character (superimposed) SYMBOL SYNONYM',
    english: 'angel (1)',
    swedish: 'ängel (1)',
    norwegian: 'engel (1)',
    finnish: 'enkeli',
    hungarian: 'angyal',
    german: 'Engel (1)',
    dutch: 'engel (1)',
    afrikaans: 'engel (1)',
    russian: 'Ангел (1)',
    latvian: 'Enģelis (1)',
    polish: 'anioł (1)',
    french: 'ange (1)',
    spanish: 'ángel (1)',
  },
  {
    av: 20572,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(couple + star, representing a child or children) - Character (superimposed)',
    english: 'family',
    swedish: 'familj, kärnfamilj',
    norwegian: 'familie',
    finnish: 'perhe',
    hungarian: 'család',
    german: 'Familie',
    dutch: 'gezin',
    afrikaans: 'gesin',
    russian: 'семья',
    latvian: 'ģimene',
    polish: 'rodzina',
    french: 'famille',
    spanish: 'familia',
  },
  {
    av: 20599,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'board',
    swedish: 'bräda',
    norwegian: 'brett, fjøl',
    finnish: 'lauta',
    hungarian: 'deszka (pl. gördeszka, hódeszka)',
    german: 'Brett, Bohle, Diele',
    dutch: 'board',
    afrikaans: 'bord',
    russian: 'доска',
    latvian: 'dēlis',
    polish: 'płyta, deska',
    french: 'planche',
    spanish: 'tabla',
  },
  {
    av: 20769,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(roll, bun + horizontal line: pictograph, a bun cut horizontally for food to be placed in between) - Character',
    english: 'bun (food)',
    swedish: 'bröd (att lägga mat i)',
    norwegian: 'brød (hamburger, pita o.l.)',
    finnish: 'sämpylä',
    hungarian: 'hamburgerzsömle',
    german: 'Brötchen',
    dutch: 'broodje, bolletje (brood), pistoletje',
    afrikaans: 'brood, bolletjie (brood) (voedsel)',
    russian: 'булка бутербродная',
    latvian: 'maizīte, smalkmaizīte',
    polish: 'drożdżówka, słodka bułka (żywność)',
    french: 'brioche',
    spanish: 'bollo (comida)',
  },
  {
    av: 21036,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(nature + mind [modification, at a higher position]: claimed to be experienced at a higher level of consciousness) - Character (superimposed - modified)',
    english: 'supernatural-(noun)',
    swedish: 'övernaturliga (det)',
    norwegian: 'overnaturlige (det)',
    finnish: 'yliluonnollinen',
    hungarian: 'természetfölötti (mint főnév)',
    german: 'überirdisch, übernatürlich',
    dutch: 'bovennatuurlijk',
    afrikaans: 'bonatuurlike',
    russian: 'сверъестественный',
    latvian: 'pārdabiskais',
    polish: 'nadprzyrodzony, nadludzki',
    french: 'surnaturel',
    spanish: 'sobrenatural (sustantivo)',
  },
  {
    av: 21040,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pointer (left) + God + pointer (right): suggesting the graze radiating from God) - Character (superimposed - pointer)',
    english: 'grace, grace of God',
    swedish: 'nåd',
    norwegian: 'nåde',
    finnish: 'armo',
    hungarian: 'asztali áldás, asztali ima, isteni kegyelem',
    german: 'Gnade',
    dutch: 'genade',
    afrikaans: 'genade',
    russian: 'благодать, милость Божия ',
    latvian: 'Dieva žēlastība',
    polish: 'łaska (religijna)',
    french: 'grâce',
    spanish: 'gracia',
  },
  {
    av: 21044,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + to be: a feeling of being: a vital force, traditionally believed to be within living beings) - Character (superimposed)',
    english: 'spirit',
    swedish: 'ande',
    norwegian: 'ånd',
    finnish: 'henki',
    hungarian: 'szellem, lelkierő, lélek',
    german: 'Geist',
    dutch: 'geest',
    afrikaans: 'gees',
    russian: 'дух',
    latvian: 'gars',
    polish: 'duch',
    french: 'esprit, âme',
    spanish: 'espíritu',
  },
  {
    av: 21054,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(person + leadership, guidance) - Character (superimposed) SYMBOL SYNONYM',
    english: 'leader, director, guide (1)',
    swedish: 'ledare (1)',
    norwegian: 'leder (1)',
    finnish: 'johtaja, esimies, työnjohtaja, opas, ohjaaja, manageri',
    hungarian: 'vezető, igazgató, irányító, vezér',
    german: 'Leiter, Leiterin, Führer, Führerin, Reiseführer, Reiseführerin',
    dutch: 'leider, directeur (1)',
    afrikaans: 'leier, direkteur, gids (1)',
    russian: 'лидер, руководитель (1)',
    latvian: 'vadītājs, līderis, direktors (1)',
    polish: 'dyrektor, przewodnik, przywódca (1)',
    french: 'directeur, dirigeant (1)',
    spanish: 'líder, director, guía (1)',
  },
  {
    av: 21061,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'horn(s), antler(s)',
    swedish: 'horn',
    norwegian: 'horn',
    finnish: 'sarvet',
    hungarian: 'szarv, agancs',
    german: 'Hörner (Tier)',
    dutch: 'hoorns, gewei',
    afrikaans: 'horing(s)',
    russian: 'рог',
    latvian: 'rags, briežveidīgo',
    polish: 'róg, poroże',
    french: 'corne, ramure',
    spanish: 'cuernos, astas',
  },
  {
    av: 21082,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: the symbol suggests a halo) - Character',
    english: 'holiness',
    swedish: 'helighet, gloria',
    norwegian: 'hellighet',
    finnish: 'pyhyys',
    hungarian: 'szentség',
    german: 'Heiligkeit',
    dutch: 'heiligheid',
    afrikaans: 'heiligheid',
    russian: 'святость',
    latvian: 'svētums',
    polish: 'świętość',
    french: 'sainteté',
    spanish: 'santidad',
  },
  {
    av: 21090,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(parent + protection: one parent who offers protection to a child or children) - Character (superimposed)',
    english: 'single parent',
    swedish: 'ensamstående förälder',
    norwegian: 'eneforsørger',
    finnish: 'yksinhuoltaja',
    hungarian: 'egyedülálló szülő',
    german: '(alleinerziehender) Elternteil',
    dutch: 'alleenstaande ouder',
    afrikaans: 'enekl ouer, alleen ouer',
    russian: 'родитель-одиночка',
    latvian: 'vientuļais vecāks',
    polish: 'samotny rodzic',
    french: 'parent célibataire',
    spanish: 'padres solteros',
  },
  {
    av: 21091,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(mother + protection) - Character (superimposed)',
    english: 'single mother',
    swedish: 'ensamstående mamma',
    norwegian: 'alenemor',
    finnish: 'yksinhuoltajaäiti',
    hungarian: 'egyedülálló anya',
    german: 'Mutter (alleinerziehend)',
    dutch: 'alleenstaande moeder',
    afrikaans: 'enkel moeder, alleen moeder',
    russian: 'мать-одиночка',
    latvian: 'vientuļā māte',
    polish: 'samotna matka',
    french: 'mère célibataire',
    spanish: 'madre soltera',
  },
  {
    av: 21092,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(father + protection) - Character (superimposed)',
    english: 'single father',
    swedish: 'ensamstående pappa',
    norwegian: 'alenefar',
    finnish: 'yksinhuoltajaisä',
    hungarian: 'egyedülálló apa',
    german: 'Vater (alleinerziehend)',
    dutch: 'alleenstaande vader',
    afrikaans: 'enkel vader, alleen vader',
    russian: 'отец-одиночка ',
    latvian: 'vientuļais tēvs',
    polish: 'samotny ojciec',
    french: 'père célibataire',
    spanish: 'padre soltero',
  },
  {
    av: 21093,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(single parent + star: family consisting of a single parent and a child or children) - Character (superimposed)',
    english: 'single parent family',
    swedish: 'familj med en förälder',
    norwegian: 'familie (en forelder)',
    finnish: 'yksinhuoltajaperhe',
    hungarian: 'egyszülős család',
    german: 'Einelternfamilie',
    dutch: 'eenoudergezin',
    afrikaans: 'enkelouer gesin, een ouer gesin',
    russian: 'неполная семья',
    latvian: 'viena vecāka ģimene, nepilna ģimene',
    polish: 'rodzina z jednym rodzicem',
    french: 'famille monoparentale',
    spanish: 'familia monoparental',
  },
  {
    av: 21098,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(to see + world: to be able to see the world as it is) - Character (superimposed)',
    english: 'insight',
    swedish: 'insikt',
    norwegian: 'innsikt',
    finnish: 'käsitys, oivallus',
    hungarian: 'bepillantás, ösztönös megérzés, intuíció',
    german: 'Erkenntnis',
    dutch: 'inzicht',
    afrikaans: 'insig',
    russian: 'понимание, озарение',
    latvian: 'ieskats, izpratne',
    polish: 'intuicja, wgląd',
    french: 'perspicacité',
    spanish: 'visión profunda',
  },
  {
    av: 21116,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure [modification, rectangular] + reclining, lying (person lying down) [modification, higher position, shortened line for feet]) - Character (superimposed - modified)',
    english: 'coffin',
    swedish: 'kista',
    norwegian: 'kiste',
    finnish: 'arkku',
    hungarian: 'koporsó',
    german: 'Sarg',
    dutch: 'doodskist',
    afrikaans: 'kis, doodskis',
    russian: 'гроб',
    latvian: 'zārks',
    polish: 'trumna',
    french: 'cercueil',
    spanish: 'ataúd',
  },
  {
    av: 21282,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'vase, urn, trophy cup',
    swedish: 'vas, urna, pokal',
    norwegian: 'vase, urne, pokal',
    finnish: 'maljakko, uurna, vaasi',
    hungarian: 'váza, urna, trófea',
    german: 'Vase, Blumenvase',
    dutch: 'urn, vaas, beker, trofee',
    afrikaans: 'vaas, beker, trofee',
    russian: 'ваза, урна, кубок',
    latvian: 'vāze, urna, balvas kauss',
    polish: 'waza, puchar',
    french: 'urne, vase, coupe',
    spanish: 'florero, urna, copa',
  },
  {
    av: 21297,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(knowledge + what, question mark: something known, but not fully understood) - Character (superimposed)',
    english: 'mystery, unknown',
    swedish: 'gåta, mysterium, oförklarlighet',
    norwegian: 'mysterium, gåte',
    finnish: 'mysteeri, tuntematon',
    hungarian: 'rejtély, titokzatosság, misztérium',
    german: 'Mysterium',
    dutch: 'mysterieus',
    afrikaans: 'geheim, raaisel, onbekend, mysterieus',
    russian: 'тайна, загадка',
    latvian: 'noslēpums, mistērija',
    polish: 'tajemnica, zagadka',
    french: 'mystère',
    spanish: 'misterio, desconocido',
  },
  {
    av: 21363,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'goblet, wineglass',
    swedish: 'bägare, vinglas',
    norwegian: 'glass med stett, vinglass',
    finnish: 'viinilasi, pikari',
    hungarian: 'borospohár, serleg, talpas pohár',
    german: 'Weinglas',
    dutch: 'wijnglas',
    afrikaans: 'wynglas, beker',
    russian: 'чаша, кубок, бокал',
    latvian: 'pokāls, kauss',
    polish: 'kielich, kieliszek do wina, puchar',
    french: 'verre à vin',
    spanish: 'copa, copa de vino',
  },
  {
    av: 21540,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph, of circular cell + being (state of): the symbol suggests a cell, with the symbol for to live [half-sized] as a cell nucleus in it) - Character (superimposed)',
    english: 'cell',
    swedish: 'cell',
    norwegian: 'celle',
    finnish: 'solu',
    hungarian: 'sejt',
    german: 'Zelle, Körperzelle',
    dutch: 'cel',
    afrikaans: 'sel',
    russian: 'клетка (живая)',
    latvian: 'šūna',
    polish: 'komórka',
    french: 'cellule',
    spanish: 'célula',
  },
  {
    av: 21541,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(international symbol for Euro) - Character',
    english: 'Euro',
    swedish: 'euro',
    norwegian: 'euro',
    finnish: 'euro',
    hungarian: 'Euro',
    german: 'Euro',
    dutch: 'Euro',
    afrikaans: 'Euro',
    russian: 'евро',
    latvian: 'eiro',
    polish: 'euro',
    french: 'Euro',
    spanish: 'Euro',
  },
  {
    av: 21589,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(need (needy person) + need [modification, mirrored]: mutual aid) - Character (superimposed - modified)',
    english: 'therapy',
    swedish: 'terapi',
    norwegian: 'terapi',
    finnish: 'terapia',
    hungarian: 'terápia',
    german: 'Therapie',
    dutch: 'therapie',
    afrikaans: 'terapie',
    russian: 'терапия',
    latvian: 'ārstniecība, terapija',
    polish: 'terapia',
    french: 'thérapie',
    spanish: 'terapia',
  },
  {
    av: 21607,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(mind + activity: how people think or act) - Character (superimposed)',
    english: 'view of life',
    swedish: 'livssyn',
    norwegian: 'livssyn',
    finnish: 'elämänkatsomus',
    hungarian: 'életszemlélet',
    german: 'Lebensauffassung',
    dutch: 'levensbeschouwing',
    afrikaans: 'lewensuitkyk',
    russian: 'мироощущение, представление о жизни',
    latvian: 'dzīves uzskats',
    polish: 'perspektywy (na życie)',
    french: 'mode de vie',
    spanish: 'visión de la vida',
  },
  {
    av: 21623,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'cap',
    swedish: 'keps',
    norwegian: 'caps',
    finnish: 'lippalakki',
    hungarian: 'sapka',
    german: 'Mütze, Kappe',
    dutch: 'pet',
    afrikaans: 'pet',
    russian: 'кепка',
    latvian: 'cepure, naģene',
    polish: 'czapka',
    french: 'casquette',
    spanish: 'gorra',
  },
  {
    av: 21624,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(name + Blissymbol: combination of name and Blissymbol) - Character (superimposed - combined)',
    english: 'bliss-name',
    swedish: 'blissnamn',
    norwegian: 'blissnavn',
    finnish: 'blissnimi',
    hungarian: 'Bliss-név',
    german: 'Name (in Bliss), Bliss-Name',
    dutch: 'Blissnaam',
    afrikaans: 'Blissnaam',
    russian: 'блисс-имя',
    latvian: 'bliss nosaukums',
    polish: 'Bliss (nazwa)',
    french: 'nom Bliss',
    spanish: 'palabra Bliss',
  },
  {
    av: 21807,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'rugby ball, football (N.A.)',
    swedish: 'rugbyboll',
    norwegian: 'rugbyball',
    finnish: 'rugby-pallo, amerikkalainen jalkapallo',
    hungarian: 'rögbilabda',
    german: 'Rugbyball',
    dutch: 'rugbybal',
    afrikaans: 'rugby bal',
    russian: 'мяч для регби',
    latvian: 'regbija bumba',
    polish: 'piłka do rugby',
    french: 'ballon de rugby, ballon de football américain',
    spanish: 'balón de rugby',
  },
  {
    av: 21809,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'wicket',
    swedish: 'kricketgrind',
    norwegian: 'cricketgjerde',
    finnish: 'hila',
    hungarian: 'krikett kapu',
    german: 'Crickettor, Wicket (Kricket)',
    dutch: 'wicket',
    afrikaans: 'paaltjie',
    russian: 'калитка (снаряжение для крикета)',
    latvian: 'vārti kriketā',
    polish: 'furtka, bramka',
    french: 'guichet (de criquet)',
    spanish: 'puerta de criquet',
  },
  {
    av: 21813,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vehicle [modification, horizontal line replaced by board] + board [modification, higer position] (combination)) Vehicles have different names in different countries. - Character (superimposed - modified - combined)',
    english: 'prone board, scooter-board',
    swedish: 'rullbräda, magrullbräda',
    norwegian: 'rullebrett, magebrett',
    finnish: 'rullalauta, mahalauta',
    hungarian: 'fekvő roller, kerekes fekvődeszka',
    german: 'Rollbrett',
    dutch: 'ligbord (hulpmiddel), ligplank (hulpmiddel)',
    afrikaans: 'skaatsplank',
    russian: 'доска для скейтборда',
    latvian: 'skūteru, skrituļdēļu rampa',
    polish: 'deskorolka',
    french: 'planche à roulettes',
    spanish: 'bipedestador, monopatín para discapacitados',
  },
  {
    av: 21820,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(wheel + standing (standing person)) - Character (superimposed)',
    english: 'stander (wheeled)',
    swedish: 'stårullstol',
    norwegian: 'stårullestol',
    finnish: 'seisomapyörätuoli',
    hungarian: 'állító kerékkel, kerekes állító, guruló állító, stander',
    german: 'Stehbrett (rollend auf Rädern)',
    dutch: 'Sta-rijder',
    afrikaans: 'staander (gewiel)',
    russian: 'стоячая инвалидная коляска',
    latvian: 'stāvratiņkrēsls',
    polish: 'pionizator na kółkach, pionizator mobilny',
    french: 'verticalisateur sur roues',
    spanish: 'andador (con ruedas)',
  },
  {
    av: 21841,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(to stop + to start) - Character (superimposed)',
    english: 'relay',
    swedish: 'stafett',
    norwegian: 'stafett',
    finnish: 'viesti, linkki',
    hungarian: 'felváltás, staféta',
    german: 'Stafette, Staffellauf',
    dutch: 'estafette',
    afrikaans: 'aflos',
    russian: 'эстафета',
    latvian: 'stafete',
    polish: 'zmiana, przejście',
    french: 'relais',
    spanish: 'relevo',
  },
  {
    av: 21849,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'chain',
    swedish: 'kedja',
    norwegian: 'lenke',
    finnish: 'ketju',
    hungarian: 'lánc',
    german: 'Kette',
    dutch: 'ketting',
    afrikaans: 'ketting',
    russian: 'цепь',
    latvian: 'ķēde, ķēdīte',
    polish: 'łańcuch',
    french: 'chaîne',
    spanish: 'cadena',
  },
  {
    av: 21855,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(curve, curved line + forward: pictograph, suggesting a bow and arrow) - Character (superimposed)',
    english: 'bow and arrow',
    swedish: 'pil och båge',
    norwegian: 'pil og bue',
    finnish: 'jousi ja nuoli',
    hungarian: 'íj és nyíl',
    german: 'Pfeil und Bogen',
    dutch: 'boog, pijl en boog',
    afrikaans: 'pyl en boog',
    russian: 'лук со стрелой',
    latvian: 'loks un bultas',
    polish: 'łuk i strzała',
    french: 'arc et flèche',
    spanish: 'arco y flecha',
  },
  {
    av: 21880,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(water + pointer, to wave) - Character (superimposed - pointer)',
    english: 'wave',
    swedish: 'våg (vatten)',
    norwegian: 'bølge',
    finnish: 'aalto, laine',
    hungarian: 'hullám',
    german: 'Welle, Woge',
    dutch: 'golf (zee)',
    afrikaans: 'brander (see)',
    russian: 'волна',
    latvian: 'vilnis',
    polish: 'fala',
    french: 'vague',
    spanish: 'ola',
  },
  {
    av: 22059,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sail + pointer, to the mast) - Character (superimposed - pointer)',
    english: 'mast',
    swedish: 'mast',
    norwegian: 'mast',
    finnish: 'masto',
    hungarian: 'árboc',
    german: 'Mast',
    dutch: 'mast',
    afrikaans: 'mas',
    russian: 'мачта',
    latvian: 'masts ',
    polish: 'maszt (flagowy)',
    french: 'mât',
    spanish: 'mástil',
  },
  {
    av: 22060,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sail + pointer, to the boom) - Character (superimposed - pointer)',
    english: 'boom',
    swedish: 'bom',
    norwegian: 'seilbom',
    finnish: 'puomi',
    hungarian: 'vitorla keresztrúd, alsó vitorlafa',
    german: 'Schiffbaum',
    dutch: 'giek',
    afrikaans: 'giek',
    russian: 'гик',
    latvian: 'klīverkoks',
    polish: 'bom (żagla)',
    french: 'bôme',
    spanish: 'botavara',
  },
  {
    av: 22061,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(boat + pointer, to the deck) - Character (superimposed - pointer)',
    english: 'deck',
    swedish: 'däck (på båt)',
    norwegian: 'båtdekk',
    finnish: 'kansi',
    hungarian: 'hajófedélzet, fedélzet',
    german: 'Deck, Schiffsdeck',
    dutch: 'dek',
    afrikaans: 'dek',
    russian: 'палуба',
    latvian: 'klājs',
    polish: 'pokład (statku)',
    french: 'pont (bateau)',
    spanish: 'cubierta',
  },
  {
    av: 22062,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(boat + pointer, to the bow) - Character (superimposed - pointer)',
    english: 'bow, fore',
    swedish: 'för',
    norwegian: 'baug',
    finnish: 'keula',
    hungarian: 'hajóorr',
    german: 'Bug',
    dutch: 'voorsteven, boeg',
    afrikaans: 'voorskip, boeg voor',
    russian: 'нос судна',
    latvian: 'borts, ',
    polish: 'dziób łodzi',
    french: 'proue',
    spanish: 'proa',
  },
  {
    av: 22063,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(boat + pointer, to the stern) - Character (superimposed - pointer)',
    english: 'stern',
    swedish: 'akter',
    norwegian: 'akter',
    finnish: 'perä',
    hungarian: 'hajófar',
    german: 'Heck, Bootsheck, Achterschiff',
    dutch: 'achtersteven, spiegel (boot)',
    afrikaans: 'agterskip, boeg agter',
    russian: 'корма судна',
    latvian: 'priekšgals',
    polish: 'rufa',
    french: 'poupe',
    spanish: 'popa',
  },
  {
    av: 22064,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(boat + pointer, to the keel) - Character (superimposed - pointer)',
    english: 'keel',
    swedish: 'köl',
    norwegian: 'kjøl',
    finnish: 'köli',
    hungarian: 'hajógerinc',
    german: 'Kiel (Boot), Schiffskiel',
    dutch: 'kiel',
    afrikaans: 'kiel',
    russian: 'киль',
    latvian: 'ķīlis',
    polish: 'stępka, kil (łodzi)',
    french: 'quille',
    spanish: 'quilla',
  },
  {
    av: 22065,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(boat + pointer, to the hull) - Character (superimposed - pointer)',
    english: 'hull, body',
    swedish: 'skrov',
    norwegian: 'skrog',
    finnish: 'runko',
    hungarian: 'hajótest',
    german: 'Schiffsrumpf, Rumpf (Schiff)',
    dutch: 'romp',
    afrikaans: 'romp',
    russian: 'корпус',
    latvian: 'korpuss',
    polish: 'kadłub statku',
    french: 'coque',
    spanish: 'calavera, cuerpo',
  },
  {
    av: 22066,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(boat + pictograph, of rudder) - Character (superimposed)',
    english: 'rudder',
    swedish: 'roder',
    norwegian: 'ror',
    finnish: 'peräsin',
    hungarian: 'hajókormány',
    german: 'Steuerruder, Ruder (Steuerung)',
    dutch: 'roer',
    afrikaans: 'roer',
    russian: 'руль, перо руля',
    latvian: 'stūre',
    polish: 'ster (przy łodzi)',
    french: 'gouvernail',
    spanish: 'timón',
  },
  {
    av: 22067,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water (ground level) + pictograph, of paddle in water) - Character (superimposed)',
    english: 'paddle, oar',
    swedish: 'paddel, åra',
    norwegian: 'åre, padleåre',
    finnish: 'airo, mela',
    hungarian: 'evező, evezőlapát',
    german: 'Paddel, Ruder, Riemen',
    dutch: 'peddel, roeispaan',
    afrikaans: 'roeispaan',
    russian: 'весло',
    latvian: 'airis',
    polish: 'wiosło',
    french: 'rame, pagaie simple, aviron',
    spanish: 'remo, pala',
  },
  {
    av: 22068,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water (ground level) + pictograph, of paddle with two blades in water) - Character (superimposed)',
    english: 'paddle (two blades)',
    swedish: 'paddel med två blad',
    norwegian: 'åre, padleåre (to blader)',
    finnish: 'mela (kaksilapainen)',
    hungarian: 'evezőlapát (kenuhoz)',
    german: 'Zweiblättriges Paddel, Ruder, Riemen',
    dutch: 'peddel, roeispaan',
    afrikaans: 'roeispaan (dubbel spaan)',
    russian: 'весло двухстороннее',
    latvian: 'airi ',
    polish: 'wiosło dwupiórowe (kajakowe)',
    french: 'rames, pagaie double',
    spanish: 'remo (dos palas)',
  },
  {
    av: 22069,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(boat + thing [modification, higher position]: boat carrying goods) - Character (superimposed - modified)',
    english: 'freighter',
    swedish: 'fraktfartyg',
    norwegian: 'fraktfartøy',
    finnish: 'rahtilaiva, rahtialus',
    hungarian: 'teherhajó',
    german: 'Frachtschiff, Frachter',
    dutch: 'vrachtboot',
    afrikaans: 'vragskip',
    russian: 'грузовое судно',
    latvian: 'kravas kuģis ',
    polish: 'frachtowiec, transportowiec (statek)',
    french: 'cargo',
    spanish: 'carguero',
  },
  {
    av: 22105,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(from sky + pictograph, of the parachute canope) - Character (superimposed)',
    english: 'parachute',
    swedish: 'fallskärm',
    norwegian: 'fallskjerm',
    finnish: 'laskuvarjo',
    hungarian: 'ejtőernyő',
    german: 'Fallschirm',
    dutch: 'parachute',
    afrikaans: 'valskerm',
    russian: 'парашют',
    latvian: 'izpletnis',
    polish: 'spadochron',
    french: 'parachute',
    spanish: 'paracaídas',
  },
  {
    av: 22107,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'balloon (hot air)',
    swedish: 'luftballong, varmluftsballong',
    norwegian: 'luftballong',
    finnish: 'kuumailmapallo',
    hungarian: 'hőlégballon',
    german: 'Ballon, Luftballon',
    dutch: 'luchtballon',
    afrikaans: 'lugballon, warmlugballon',
    russian: 'воздушный шар',
    latvian: 'gaisa balons',
    polish: 'balon, balon z koszem, gondolą',
    french: 'montgolfière',
    spanish: 'balón, canasta',
  },
  {
    av: 22116,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(house + dot (inside the house): can also be seen as a combination of house and inside) - Character (superimposed - combined)',
    english: 'indoor (character)',
    swedish: 'inomhustecken',
    norwegian: 'innendørs',
    finnish: 'sisätilassa',
    hungarian: 'házon belüli, szobai, fedett',
    german: 'innen (Haus)',
    dutch: 'binnen',
    afrikaans: 'binne in',
    russian: 'нахождение внутри (значение)',
    latvian: 'iekštelpu',
    polish: 'domowy',
    french: "à l'intérieur",
    spanish: 'interior (personaje)',
  },
  {
    av: 22307,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(plate + pictograph of pudding) - Character (superimposed)',
    english: 'pudding, cream',
    swedish: 'pudding, kräm, gröt',
    norwegian: 'pudding',
    finnish: 'vanukas',
    hungarian: 'puding, krém',
    german: 'Pudding',
    dutch: 'pudding',
    afrikaans: 'poeding, nagereg',
    russian: 'пудинг, каша',
    latvian: 'pudiņš, krēms',
    polish: 'budyń, krem',
    french: 'pudding, crème',
    spanish: 'budín, crema',
  },
  {
    av: 22362,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(four dots (two in high and two in low positions): indicating bit4s from thing) - Character (superimposed - sequenced)',
    english: 'lump(s)',
    swedish: 'klump, klumpar',
    norwegian: 'biter, klumper',
    finnish: 'kokkare, rae',
    hungarian: 'csomók',
    german: 'Beule, Klumpen',
    dutch: 'klont(je)',
    afrikaans: 'klontjie(s)',
    russian: 'кусок, комок',
    latvian: 'kumoss, kumosi',
    polish: 'bryłka, zbity proszek',
    french: 'grumeau, morceau',
    spanish: 'bulto',
  },
  {
    av: 22365,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'lollipop, sucker',
    swedish: 'klubba (godis)',
    norwegian: 'kjærlighet på pinne',
    finnish: 'tikkukaramelli',
    hungarian: 'nyalóka',
    german: 'Lutscher',
    dutch: 'lollie',
    afrikaans: 'suigstokkie',
    russian: 'леденец',
    latvian: 'ledene, ledene uz kociņa',
    polish: 'lizak',
    french: 'sucette',
    spanish: 'chupachups',
  },
  {
    av: 22366,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'ice cream (lollipop)',
    swedish: 'glass (pinne)',
    norwegian: 'iskrem (pinne)',
    finnish: 'jäätelöpuikko',
    hungarian: 'jégkrém –pálcikás',
    german: 'Eis am Stiel',
    dutch: 'ijsje',
    afrikaans: 'ysie roomys',
    russian: ' мороженое на палочке',
    latvian: 'saldējums (uz kociņa)',
    polish: 'lody na patyku',
    french: 'crème glacée (sucette)',
    spanish: 'helado (polo)',
  },
  {
    av: 22369,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(ice cream cone + pointer, to the ice cream) - Character (superimposed - pointer) Preferred NEW SYNONYM, replacing 14920 (See also: ice cream (cone) 14921, ice cream (bar) 22370, and ice cream (lollipop) 22366)',
    english: 'ice cream, sherbet, sorbet',
    swedish: 'glass, sorbet',
    norwegian: 'iskrem',
    finnish: 'jäätelö',
    hungarian: 'fagylalt, fagyi, sörbet',
    german: 'Eiskrem, Eisbecher, Sorbet',
    dutch: 'sorbet, ijs, roomijs',
    afrikaans: 'roomys, sap roomys',
    russian: 'мороженое, щербет',
    latvian: 'saldējums, sorbets',
    polish: 'lody',
    french: 'crème glacée, sorbet',
    spanish: 'helado',
  },
  {
    av: 22371,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'bar, cake',
    swedish: 'kaka',
    norwegian: 'formkake (o.l.)',
    finnish: 'patukka',
    hungarian: 'darab, rúd, szelet, tábla',
    german: 'Süßigkeit, Bonbon',
    dutch: 'reep',
    afrikaans: 'reep, koek',
    russian: 'торт',
    latvian: 'kūka',
    polish: 'batonik, ciastko',
    french: 'barre, cake',
    spanish: 'barra, pastel',
  },
  {
    av: 22375,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character Preferred NEW SYNONYM, replacing 13118',
    english: 'candy',
    swedish: 'karamell, kola',
    norwegian: 'sukkertøy, karamell',
    finnish: 'karamelli, makeinen, karkki',
    hungarian: 'cukorka, cukor',
    german: 'Süßigkeit, Bonbon',
    dutch: 'snoepje',
    afrikaans: 'lekkergoed',
    russian: 'конфета',
    latvian: 'konfekte',
    polish: 'cukierek',
    french: 'caramel, bonbon',
    spanish: 'caramelo',
  },
  {
    av: 22377,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(two curved arrows mingling) - Character (superimposed)',
    english: 'mixture',
    swedish: 'blandning',
    norwegian: 'blanding',
    finnish: 'sekoitus',
    hungarian: 'keverék',
    german: 'Mischung, Gemisch',
    dutch: 'mengsel',
    afrikaans: 'mengsel',
    russian: 'смешивание',
    latvian: 'maisījums',
    polish: 'mieszanina',
    french: 'mélange, mixture',
    spanish: 'mezcla',
  },
  {
    av: 22384,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(arrow (bent) + vertical line: a ray of light strikes a mirror and is reflected back from it) - Character (superimposed)',
    english: 'reflection',
    swedish: 'reflektion',
    norwegian: 'refleksjon',
    finnish: 'heijastus',
    hungarian: 'visszatükrözés, visszatükröződés',
    german: 'Spiegelbild, Spiegelung',
    dutch: 'reflectie, weerspiegeling',
    afrikaans: 'weerspieël, reflekteer',
    russian: 'отражение',
    latvian: 'atspulgs',
    polish: 'odbicie, refleks (światła), błysk',
    french: 'reflet, réflexion',
    spanish: 'reflejo',
  },
  {
    av: 22386,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(reflection + arrow (bent) [modification, flipped vertically]) - Character (superimposed - modified)',
    english: 'shine',
    swedish: 'glans, sken',
    norwegian: 'skinn, glans',
    finnish: 'kiilto, hohto, loisto',
    hungarian: 'csillogás',
    german: 'Glanz, Schein (Licht)',
    dutch: 'glans',
    afrikaans: 'glans, blink',
    russian: 'блеск, сияние',
    latvian: 'spīdums, mirdzums',
    polish: 'lśnienie',
    french: 'lustre, brillant',
    spanish: 'brillo',
  },
  {
    av: 22561,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(hand + mouth: tool for food - modified]) - Character (superimposed)',
    english: 'kitchen tool, utensil',
    swedish: 'köksredskap (i sammansättningar)',
    norwegian: 'kjøkkenredskap (i kombinasjon)',
    finnish: 'keittiöväline',
    hungarian: 'konyhai eszköz',
    german: 'Küchenutensilien',
    dutch: 'keukengerief, gerei',
    afrikaans: 'kombuis gereedskap',
    russian: 'кухонная утварь ',
    latvian: 'virtuves rīki, piederumi',
    polish: 'narzędzia kuchenne, przybory kuchenne',
    french: 'ustensile de cuisine (classificateur)',
    spanish: 'utensilios de cocina',
  },
  {
    av: 22574,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'funnel',
    swedish: 'tratt',
    norwegian: 'trakt',
    finnish: 'suppilo',
    hungarian: 'tölcsér',
    german: 'Trichter',
    dutch: 'trechter',
    afrikaans: 'tregter',
    russian: 'воронка',
    latvian: 'piltuve',
    polish: 'lejek',
    french: 'entonnoir',
    spanish: 'embudo',
  },
  {
    av: 22577,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(stove + pointer, to the top) - Character (superimposed - pointer)',
    english: 'stovetop',
    swedish: 'spishäll',
    norwegian: 'ovnstopp, ovnsplate',
    finnish: 'liesi',
    hungarian: 'főzőlap',
    german: 'Kochfeld',
    dutch: 'kookplaat',
    afrikaans: 'stoofplaat',
    russian: 'плита',
    latvian: 'cepeškrāsns',
    polish: 'płyta grzejna kuchenki',
    french: 'dessus de cuisinière',
    spanish: 'plancha',
  },
  {
    av: 22578,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'cup',
    swedish: 'kopp',
    norwegian: 'kopp',
    finnish: 'kuppi, muki',
    hungarian: 'csésze',
    german: 'Tasse, Krug',
    dutch: 'beker, kopje, mok, tas (Vl)',
    afrikaans: 'beker, koppie',
    russian: 'чашка',
    latvian: 'krūze',
    polish: 'kubek, filiżanka',
    french: 'tasse',
    spanish: 'taza',
  },
  {
    av: 22579,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'saucepan',
    swedish: 'såskastrull',
    norwegian: 'sauskopp',
    finnish: 'kasari',
    hungarian: 'serpenyő',
    german: 'Topf, Kochtopf, Pfanne',
    dutch: 'steelpan',
    afrikaans: 'souspan',
    russian: 'сотейник',
    latvian: 'mērces katliņš',
    polish: 'patelnia, rondelek do sosu',
    french: 'saucière',
    spanish: 'cacerola',
  },
  {
    av: 22583,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'lid',
    swedish: 'lock',
    norwegian: 'lokk',
    finnish: 'kansi',
    hungarian: 'fedő',
    german: 'Deckel, Topfdeckel',
    dutch: 'deksel',
    afrikaans: 'deksel',
    russian: 'крышка',
    latvian: 'vāks',
    polish: 'pokrywka, wieko, przykrywka',
    french: 'couvercle',
    spanish: 'tapa',
  },
  {
    av: 22584,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'pot, kettle, boiler',
    swedish: 'gryta, kittel',
    norwegian: 'gryte, kjele',
    finnish: 'kattila, pata',
    hungarian: 'fazék',
    german: 'Kochtopf',
    dutch: 'kookpot (Vl), pan',
    afrikaans: 'pot',
    russian: 'кострюля (большая), котёл',
    latvian: 'katls, katliņš',
    polish: 'garnek (z 2 uchwytami)',
    french: 'casserole, marmite',
    spanish: 'tetera, pava',
  },
  {
    av: 22592,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'rolling pin',
    swedish: 'kavel',
    norwegian: 'kjevle',
    finnish: 'kaulin',
    hungarian: 'gyúrófa',
    german: 'Nudelholz, Teigrolle',
    dutch: 'deegrol, deegroller',
    afrikaans: 'deegroller',
    russian: 'скалка',
    latvian: 'mīklas rullis',
    polish: 'wałek do ciasta',
    french: 'rouleau à pâtisserie',
    spanish: 'amasador',
  },
  {
    av: 22598,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(earth + pointer, to the equator) - Character (superimposed - pointer)',
    english: 'equator',
    swedish: 'ekvatorn',
    norwegian: 'ekvator',
    finnish: 'päiväntasaaja',
    hungarian: 'egyenlítő, ekvátor',
    german: 'Äquator',
    dutch: 'evenaar',
    afrikaans: 'ewenaar',
    russian: 'экватор',
    latvian: 'ekvators',
    polish: 'równik',
    french: 'équateur',
    spanish: 'Ecuador',
  },
  {
    av: 22599,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + pointer, to the south pole) - Character (superimposed - pointer)',
    english: 'South Pole',
    swedish: 'Sydpolen',
    norwegian: 'Sydpolen, Sørpolen',
    finnish: 'etelänapa',
    hungarian: 'déli-sark',
    german: 'Südpol',
    dutch: 'Zuidpool',
    afrikaans: 'Suidpool',
    russian: 'Южный полюс',
    latvian: 'Dienvidpols',
    polish: 'Biegun Południowy',
    french: 'Pôle Sud',
    spanish: 'Polo Sur',
  },
  {
    av: 22600,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + pointer, to the north pole) - Character (superimposed - pointer)',
    english: 'North Pole',
    swedish: 'Nordpolen',
    norwegian: 'Nordpolen',
    finnish: 'pohjoisnapa',
    hungarian: 'északi-sark',
    german: 'Nordpol',
    dutch: 'noordpool',
    afrikaans: 'Noordpool',
    russian: 'Северный полюс',
    latvian: 'Ziemeļpols',
    polish: 'biegun północny',
    french: 'pôle Nord',
    spanish: 'Polo Norte',
  },
  {
    av: 22613,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water (ground level) + mountain: a long and narrow inlet of the sea in between steep mountains) - Character (superimposed)',
    english: 'fjord',
    swedish: 'fjord',
    norwegian: 'fjord',
    finnish: 'vuono',
    hungarian: 'fjord',
    german: 'Fjord, Förde',
    dutch: 'fjord',
    afrikaans: 'fjord',
    russian: 'фьорд',
    latvian: 'fjords',
    polish: 'fiord, głęboka zatoka',
    french: 'fjord',
    spanish: 'fiordo',
  },
  {
    av: 22618,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'crown',
    swedish: 'krona',
    norwegian: 'krone',
    finnish: 'kruunu',
    hungarian: 'korona',
    german: 'Krone',
    dutch: 'kroon',
    afrikaans: 'kroon',
    russian: 'корона',
    latvian: 'kronis',
    polish: 'korona',
    french: 'couronne',
    spanish: 'corona',
  },
  {
    av: 22625,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + water (ground level) + earth: an arm of water reaching into land) - Character (superimposed)',
    english: 'inlet',
    swedish: 'sund (vatten)',
    norwegian: 'sund (vann)',
    finnish: 'salmi',
    hungarian: 'benyúló kis keskeny öböl',
    german: 'Meeresarm, (kleine) Bucht, Zulauf',
    dutch: 'binnenzee, meer',
    afrikaans: 'mond (meer, see)',
    russian: 'пролив',
    latvian: 'bēgums',
    polish: 'zatoczka, mała zatoka',
    french: "crique, bras de mer, bras d'eau",
    spanish: 'estrecho (agua)',
  },
  {
    av: 22834,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests the planet rotating on its horizontal axis) - Character',
    english: 'planet',
    swedish: 'planet',
    norwegian: 'planet',
    finnish: 'planeetta',
    hungarian: 'bolygó, planéta',
    german: 'Planet',
    dutch: 'planeet',
    afrikaans: 'planeet',
    russian: 'планета',
    latvian: 'planēta',
    polish: 'planeta',
    french: 'planète',
    spanish: 'planeta',
  },
  {
    av: 22837,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'pod, seedcase, seedpod',
    swedish: 'fröskida',
    norwegian: 'frøhus',
    finnish: 'palko',
    hungarian: 'a föld központi burka, földmag',
    german: 'Hülse (Pflanze), Schale (Pflanze)',
    dutch: 'peul',
    afrikaans: 'saad',
    russian: 'стручок',
    latvian: 'kūniņa',
    polish: 'strąk, łupina',
    french: 'cosse, gousse',
    spanish: 'vaina',
  },
  {
    av: 22911,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(to think + what, question mark) - Character (superimposed)',
    english: 'doubt, uncertainty',
    swedish: 'undran, tvivel, osäkerhet',
    norwegian: 'tvil, usikkerhet',
    finnish: 'epäilys, epäröinti',
    hungarian: 'kétség, kételkedés, bizonytalanság',
    german: 'Zweifel, Bedenken',
    dutch: 'twijfel',
    afrikaans: 'twyfel',
    russian: 'сомнение',
    latvian: 'šaubas, nedrošība',
    polish: 'wątpliwości, niepewność',
    french: 'doute, hésitation',
    spanish: 'duda, incertidumbre',
  },
  {
    av: 22913,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + forward [modification, short arrow]: the use of mental powers to carry events or persons forward) - Character (superimposed - modified)',
    english: 'leadership, guidance',
    swedish: 'ledarskap, ledning',
    norwegian: 'lederskap, ledelse',
    finnish: 'johtajuus, opastus',
    hungarian: 'vezetés, irányítás, útmutatás',
    german: 'Leitung, Führung',
    dutch: 'leiding, leiderschap',
    afrikaans: 'leierskap, leiding',
    russian: 'лидерство, руководство',
    latvian: 'vadība, vadīšanas spēja',
    polish: 'kierownictwo, przewodnictwo',
    french: 'direction, conduite',
    spanish: 'liderazgo',
  },
  {
    av: 22914,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + strong [modification]: the use of the power of the mind, and/or physical strength, to make something happen) - Character (superimposed)',
    english: 'must (a)',
    swedish: 'tvång',
    norwegian: 'tvang',
    finnish: 'pakko',
    hungarian: 'kell, el/kikerülhetetlen, muszáj',
    german: 'Zwang',
    dutch: 'moeten',
    afrikaans: 'moet',
    russian: 'принуждение',
    latvian: 'nepieciešams, noteikti',
    polish: 'przymus, konieczność zrobienia czegoś',
    french: 'devoir, impératif',
    spanish: 'algo necesario',
  },
  {
    av: 23026,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(building with attic + pointer, to the attic) - Character (superimposed - pointer)',
    english: 'attic',
    swedish: 'vind (hus)',
    norwegian: 'kvistetasje',
    finnish: 'ullakko, vintti',
    hungarian: 'padlás',
    german: 'Dachboden',
    dutch: 'zolder',
    afrikaans: 'solder',
    russian: 'чердак, мансарда',
    latvian: 'bēniņi',
    polish: 'poddasze',
    french: 'grenier',
    spanish: 'ático',
  },
  {
    av: 23029,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(building with cellar + pointer, to cellar) - Character (superimposed - pointer)',
    english: 'basement, cellar',
    swedish: 'källare',
    norwegian: 'underetasje, kjeller',
    finnish: 'kellari',
    hungarian: 'pince, alagsor',
    german: 'Keller',
    dutch: 'kelder',
    afrikaans: 'kelder',
    russian: 'подвальное помещение',
    latvian: 'pagrabstāvs, pagrabs',
    polish: 'piwnica',
    french: 'sous-sol, cave',
    spanish: 'sótano, bodega',
  },
  {
    av: 23044,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(fish + pictograph of beard) - Character (superimposed)',
    english: 'cod, codfish',
    swedish: 'torsk',
    norwegian: 'torsk',
    finnish: 'turska',
    hungarian: 'tőkehal',
    german: 'Kabeljau, Dorsch',
    dutch: 'kabeljauw',
    afrikaans: 'kabeljou',
    russian: 'треска',
    latvian: 'menca',
    polish: 'dorsz',
    french: 'cabillaud, morue',
    spanish: 'bacalao',
  },
  {
    av: 23085,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(building with storey + pointer) - Character (superimposed - pointer)',
    english: 'floor, storey, level, etage',
    swedish: 'våning',
    norwegian: 'etasje',
    finnish: 'kerros',
    hungarian: 'emelet, szint',
    german: 'Stockwerk, Stock, Etage, Geschoss',
    dutch: 'etage, verdiep (Vl), verdiepeing',
    afrikaans: 'vloer, storie, verdieping',
    russian: 'этаж',
    latvian: 'stāvs',
    polish: 'piętro, kondygnacja, poziom',
    french: 'étage, niveau',
    spanish: 'piso, nivel, planta',
  },
  {
    av: 23089,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(building with foundation + pointer (to foundation)) - Character (superimposed - pointer)',
    english: 'foundation (building)',
    swedish: 'husgrund',
    norwegian: 'grunnmur, fundament (bygning)',
    finnish: 'talon perustukset, sokkeli',
    hungarian: 'alapszint, alapzat',
    german: 'Fundament',
    dutch: 'fundament (gebouw)',
    afrikaans: 'fondasie (gebou), fondament',
    russian: 'фундамент (здание)',
    latvian: 'pamats, pamati, fundaments (celtnes)',
    polish: 'podstawa, podmurówka, fundament',
    french: 'fondations',
    spanish: 'cimientos (construcción)',
  },
  {
    av: 23097,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(ovine + pictograph of beard) - Character (superimposed)',
    english: 'goat',
    swedish: 'get',
    norwegian: 'geit',
    finnish: 'vuohi',
    hungarian: 'kecske',
    german: 'Ziege',
    dutch: 'geit',
    afrikaans: 'bok',
    russian: 'козёл, коза',
    latvian: 'kaza, āzis',
    polish: 'koza',
    french: 'chèvre',
    spanish: 'cabra',
  },
  {
    av: 23117,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(right angle + pointer to horizontal arm of angle) - Character (superimposed - pointer)',
    english: 'horizontal-(a)',
    swedish: 'horisontallinje',
    norwegian: 'horisontallinje',
    finnish: 'vaakasuora, horisontaali',
    hungarian: 'vízszintes (fn.)',
    german: 'horizantal, waagerecht',
    dutch: 'horizontaal (zelfst.nw)',
    afrikaans: 'horisontaal, horisontale',
    russian: 'горизонтальная линия',
    latvian: 'horizontāla līnija',
    polish: 'poziom',
    french: 'horizontale',
    spanish: 'una horizontal',
  },
  {
    av: 23124,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water creature + pictograph of jellyfish tentacles) - Character (superimposed)',
    english: 'jellyfish',
    swedish: 'manet',
    norwegian: 'manet',
    finnish: 'meduusa',
    hungarian: 'medúza',
    german: 'Qualle',
    dutch: 'kwal',
    afrikaans: 'jellievis',
    russian: 'медуза',
    latvian: 'medūza',
    polish: 'meduza',
    french: 'méduse',
    spanish: 'medusa',
  },
  {
    av: 23127,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + weight [modification, shorter horizontal line]: the mind weighs something to reach a judgement) - Character (superimposed - modified)',
    english: 'judgement, law (in combinations)',
    swedish: 'juridik (i kombinationer)',
    norwegian: 'jus (brukes i kombinasjon)',
    finnish: 'tuomio',
    hungarian: 'döntés, ítélet (szóösszetételben)',
    german: 'Urteil, Gerichtsurteil, Richterspruch',
    dutch: 'wet (in combinaties)',
    afrikaans: 'oordeel',
    russian: 'закон, право (в комбинации)',
    latvian: 'tiesa, likums (dažādās nozīmēs)',
    polish: 'wyrok',
    french: 'jugement, loi (classificateur)',
    spanish: 'sentencia, ley (en combinaciones)',
  },
  {
    av: 23150,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + thing: a combination of rectangular shape + thing) - Character (superimposed)',
    english: 'metal bar',
    swedish: 'metall (stång, tacka)',
    norwegian: 'metallbarre',
    finnish: 'metallitanko, metalliharkko, metallipalkki',
    hungarian: 'fémrúd',
    german: 'Metall (Barren, Massel)',
    dutch: 'metalen lat',
    afrikaans: 'metaal bar',
    russian: 'металл',
    latvian: 'metāla stienis',
    polish: 'metal (sztabka)',
    french: 'métal (barre)',
    spanish: 'barra de mental',
  },
  {
    av: 23169,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure + up and down: the arrows press against the top and bottom of the enclosure) - Character (superimposed)',
    english: 'pressure',
    swedish: 'tryck',
    norwegian: 'trykk',
    finnish: 'paine',
    hungarian: 'nyomás',
    german: 'Druck',
    dutch: 'druk',
    afrikaans: 'druk',
    russian: 'давление',
    latvian: 'spiediens',
    polish: 'ciśnienie',
    french: 'pression',
    spanish: 'presión',
  },
  {
    av: 23193,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(semi-detached house + semi-detached house: pictograph of attached houses) - Character (superimposed)',
    english: 'row house, attached houses',
    swedish: 'radhus',
    norwegian: 'rekkehus',
    finnish: 'rivitalo',
    hungarian: 'sorház',
    german: 'Reihenhaus',
    dutch: 'rijhuis',
    afrikaans: 'woonstel huise',
    russian: 'рядный дом',
    latvian: 'rindu māja',
    polish: 'szeregowiec, bliźniak (o budynku)',
    french: 'maison attenante, maison mitoyenne',
    spanish: 'casas adosadas',
  },
  {
    av: 23201,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(house + line: the line separating the building into two parts, creating a pictograph of a semi-detached house) - Character (superimposed)',
    english: 'semi-detached house',
    swedish: 'parhus',
    norwegian: 'vertikaltdelt hus',
    finnish: 'paritalo',
    hungarian: 'ikerház',
    german: 'Doppelhaus, Zweifamilienhaus',
    dutch: 'huis-(half open bebouwing)',
    afrikaans: 'semi-losstaande huis',
    russian: 'двухквартирный дом',
    latvian: 'dvīņu māja',
    polish: 'bliźniak (dom)',
    french: 'maison jumelée',
    spanish: 'casa semiadosada',
  },
  {
    av: 23204,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'shellfish (without claws)',
    swedish: 'skaldjur utan klor',
    norwegian: 'skalldyr uten klør',
    finnish: 'äyriäinen (sakseton)',
    hungarian: 'kagyló',
    german: ' Schalentier ohne Klauen',
    dutch: 'schelpdier (zonder klauwen)',
    afrikaans: 'skulpvis (sonder kloue)',
    russian: 'моллюск (без клешней)',
    latvian: 'vēžveidīgie (bez spīlēm)',
    polish: 'skorupiak',
    french: 'crustacé sans pince',
    spanish: 'marisco (sin pinzas)',
  },
  {
    av: 23223,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(public room + business: public room where money is exchanged for goods) - Character (superimposed) Preferred NEW SYNONYM, replacing 17269',
    english: 'store, shop',
    swedish: 'affär, butik',
    norwegian: 'butikk',
    finnish: 'kauppa, liike',
    hungarian: 'bolt, üzlet',
    german: 'Geschäft, Laden',
    dutch: 'winkel',
    afrikaans: 'winkel',
    russian: 'магазин',
    latvian: 'veikals',
    polish: 'sklep',
    french: 'magasin',
    spanish: 'almacén, tienda',
  },
  {
    av: 23230,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(money + leadership: money + to govern [contr.] ) - Character (superimposed)',
    english: 'tax',
    swedish: 'skatt',
    norwegian: 'skatt',
    finnish: 'vero, verot',
    hungarian: 'adó, adózás, adóteher',
    german: 'Steuern, Abgabe',
    dutch: 'belasting',
    afrikaans: 'belasting',
    russian: 'налог',
    latvian: 'nodoklis',
    polish: 'podatek',
    french: 'taxe, impôt',
    spanish: 'impuesto',
  },
  {
    av: 23240,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'tower',
    swedish: 'torn',
    norwegian: 'tårn',
    finnish: 'torni',
    hungarian: 'torony',
    german: 'Turm',
    dutch: 'toren',
    afrikaans: 'toring',
    russian: 'башня',
    latvian: 'tornis',
    polish: 'wieża',
    french: 'tour (construction haute)',
    spanish: 'torre',
  },
  {
    av: 23250,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(right angle + pointer, to vertical arm of angle) - Character (superimposed - pointer)',
    english: 'vertical-(a)',
    swedish: 'lodlinje',
    norwegian: 'vertikallinje, loddlinje',
    finnish: 'pystysuora',
    hungarian: 'függőleges (fn.)',
    german: 'senkrecht, vertikal',
    dutch: 'vertikaal (zelfst.nw.)',
    afrikaans: 'vertikaal (selfs.nw)',
    russian: 'вертикаль',
    latvian: 'vertikāla līnija',
    polish: 'pion',
    french: 'verticale (ligne)',
    spanish: 'vertical',
  },
  {
    av: 23409,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vertical line + plus + vertical line: representing something attached to something else) - Character (sequenced)',
    english: 'attachment, appendix, annex',
    swedish: 'bilaga, sammansättning, tillbehör',
    norwegian: 'vedlegg',
    finnish: 'liite, saate',
    hungarian: 'melléklet, függelék',
    german: 'Anhang (Datei an Email), Zubehör',
    dutch: 'bijlage, appendix',
    afrikaans: 'bylaag, aanhangsel',
    russian: 'добавление',
    latvian: 'pielikums, papildinājums',
    polish: 'załącznik, dodatek, aneks',
    french: 'attache, annexe',
    spanish: 'adjunto, apéndice, anexo',
  },
  {
    av: 23431,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: horizontally oriented rectangle representing a lying card) - Character',
    english: 'card',
    swedish: 'kort (bank- etc)',
    norwegian: 'kort (subst.)',
    finnish: 'kortti',
    hungarian: 'kártya',
    german: 'Karte',
    dutch: 'kaart, card, pasje',
    afrikaans: 'kaart',
    russian: 'карта (банковская и пр.)',
    latvian: 'karte (bankas un tml.)',
    polish: 'karta',
    french: 'carte',
    spanish: 'tarjeta, carta',
  },
  {
    av: 23437,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(tower [modification] + house [modification] + tower [modification]: pictograph suggests a castle as a combination of house and towers) - Character (superimposed - modified - combined)',
    english: 'castle, palace',
    swedish: 'slott',
    norwegian: 'slott, palass',
    finnish: 'linna',
    hungarian: 'kastély, palota',
    german: 'Schloss, Burg',
    dutch: 'kasteel, burcht',
    afrikaans: 'kasteel, paleis',
    russian: 'замок, дворец',
    latvian: 'pils',
    polish: 'zamek, pałac',
    french: 'château, palais',
    spanish: 'castillo, palacio',
  },
  {
    av: 23439,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + cause: mental reflection on cause and effect) - Character (superimposed)',
    english: 'causality',
    swedish: 'orsakssammanhang',
    norwegian: 'årsakssammenheng, årsaksforhold',
    finnish: 'syy-seuraussuhde, syy-yhteys',
    hungarian: 'okság, okozatiság, okbeli viszony, kazualitás',
    german: 'Kausalität, Kausalzusammenhang',
    dutch: 'oorzakelijkheid, causaliteit',
    afrikaans: 'ongevalle',
    russian: 'причинность',
    latvian: 'cēlonība, kauzalitāte',
    polish: 'przyczynowość',
    french: 'causalité',
    spanish: 'causalidad',
  },
  {
    av: 23472,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(wheel [modification, to full size]: forms a pictograph of a big wheel with spokes, used as a symbol in Buddhism) - Character (modified)',
    english: 'Dharma wheel',
    swedish: 'dharmahjulet',
    norwegian: 'dharmahjul',
    finnish: 'Dharman pyörä',
    hungarian: 'Dharma kerék',
    german: 'Rad von Dharma (Hindu)',
    dutch: 'Dharmawiel',
    afrikaans: 'Dharma wiel',
    russian: 'колесо Дхармы',
    latvian: 'Dharma ritenis',
    polish: 'Koło Dharmy (buddyzm), koło życia, krąg narodzin i śmierci',
    french: 'roue de Dharma',
    spanish: 'rueda Dharma',
  },
  {
    av: 23475,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(mind + digits (computer)) - Character (superimposed)',
    english: 'digital processing, artificial intelligence, calculation',
    swedish: 'artificiell intelligens, AI, digital intelligens',
    norwegian: 'kunstig intelligens',
    finnish: 'datamuisti',
    hungarian: 'mesterséges intelligencia, digitális feldolgozás',
    german: 'Digitalspeicher, Datenspeicher',
    dutch: 'hoofdrekenen',
    afrikaans: 'kunsmatige intelligensie',
    russian: 'цифровая обработка',
    latvian: 'digitāla, elektroniska apstrāde, mākslīgais intelekts',
    polish: 'pamięć cyfrowa',
    french: 'mémoire informatique, mémoire numérique',
    spanish: 'memoria digital',
  },
  {
    av: 23476,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(quarter-sized vertical line + quarter-sized circle: representing the two digits 1 and 0) - Character (superimposed)',
    english: 'digits (computer)',
    swedish: 'digitala siffror, binärtal',
    norwegian: 'digitalisering (PC)',
    finnish: 'bitti',
    hungarian: 'számjegy, digit (szgépes alkalmazás)',
    german: 'Zahl am Computer, Binärzahl',
    dutch: 'digitale cijfers',
    afrikaans: 'syfers (rekenaar)',
    russian: 'электронная цифра',
    latvian: 'cipari (programmēšanas tehnoloģijā)',
    polish: 'cyfrowe (element symbolu złożonego oznaczającego urządzenie cyfrowe) (komputer)',
    french: 'chiffre numérique, caractère numérique (informatique)',
    spanish: 'dígitos (ordenador)',
  },
  {
    av: 23477,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + pictograph of dinosaur head and tail) - Character (superimposed) Preferred NEW SYNONYM, replacing 13681',
    english: 'dinosaur',
    swedish: 'dinosaurie',
    norwegian: 'dinosaur',
    finnish: 'dinosaurus',
    hungarian: 'dinoszaurusz',
    german: 'Dinosaurier',
    dutch: 'dinosaurus',
    afrikaans: 'dinosourus',
    russian: 'динозавр',
    latvian: 'dinozaurs',
    polish: 'dinozaur',
    french: 'dinosaure',
    spanish: 'dinosaurio',
  },
  {
    av: 23488,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(backwards + short vertical line: pictograph, looks like the enter symbol on a computer keyboard) - Character (superimposed)',
    english: 'enter (computer)',
    swedish: 'enter (dator), retur',
    norwegian: 'enter (PC)',
    finnish: 'enter (näppäin), rivinvaihto',
    hungarian: 'enter, mehet (szgép)',
    german: 'bestätigen (Computer)',
    dutch: 'enter (computer)',
    afrikaans: 'enter rekenaar',
    russian: 'ввод (компьютер)',
    latvian: 'ievadīt (darbība datorā)',
    polish: 'enter (informatyczne)',
    french: 'enter, entrée (ordinateur)',
    spanish: 'intro (ordenador)',
  },
  {
    av: 23500,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(container + digits (computer)) - Character (superimposed)',
    english: 'file, data file (digital)',
    swedish: 'fil (dator)',
    norwegian: 'datafil, fil (digital)',
    finnish: 'tiedosto',
    hungarian: 'adatállomány, adat (digitális)',
    german: 'Feile',
    dutch: 'file (computer)',
    afrikaans: 'lêer, data lêer (digitaal)',
    russian: 'файл (компьютер)',
    latvian: 'datnes, datu mapes (digitālā formātā)',
    polish: 'plik, plik z danymi, dokument',
    french: 'fichier (ordinateur)',
    spanish: 'archivo, fichero de datos (digital)',
  },
  {
    av: 23511,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: looks like a paper folder, or a folder icon on a computer) - Character ',
    english: 'folder',
    swedish: 'mapp, dokumentmapp',
    norwegian: 'mappe',
    finnish: 'kansio',
    hungarian: 'irattartó, dosszié',
    german: 'Ordner',
    dutch: 'map, ordner',
    afrikaans: 'leêr',
    russian: 'папка',
    latvian: 'mape ',
    polish: 'teczka na dokumenty',
    french: 'classeur, dossier',
    spanish: 'carpeta',
  },
  {
    av: 23527,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + quill(s), spine(s): pictograph of animal with spines) - Character (superimposed) Preferred NEW SYNONYM, replacing 14699 ',
    english: 'hedgehog',
    swedish: 'igelkott',
    norwegian: 'pinnsvin',
    finnish: 'siili',
    hungarian: 'sün, sündisznó, süni',
    german: 'Igel',
    dutch: 'egel',
    afrikaans: 'ystervark',
    russian: 'ёж',
    latvian: 'ezis',
    polish: 'jeż',
    french: 'hérisson',
    spanish: 'erizo',
  },
  {
    av: 23542,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + up, upward: upward arrow, bringing information into the mind) - Character (superimposed)',
    english: 'information',
    swedish: 'information',
    norwegian: 'informasjon',
    finnish: 'informaatio, tieto',
    hungarian: 'információ, tájékoztatás',
    german: 'Auskunft, Information',
    dutch: 'informatie',
    afrikaans: 'informasie',
    russian: 'информация',
    latvian: 'informācija',
    polish: 'informacja',
    french: 'information',
    spanish: 'información',
  },
  {
    av: 23550,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(curved arrow, forward, indicating the path of a jump) - Character',
    english: 'jump',
    swedish: 'hopp, skutt',
    norwegian: 'hopp',
    finnish: 'hyppy',
    hungarian: 'ugrás',
    german: 'Sprung',
    dutch: 'sprong',
    afrikaans: 'spring',
    russian: 'прыжок',
    latvian: 'lēciens',
    polish: 'skok',
    french: 'saut',
    spanish: 'salto',
  },
  {
    av: 23576,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(man + fantasy, phantasy, imagination, illusion) - Character (superimposed)',
    english: 'make-believe man',
    swedish: 'övernaturligt manligt väsen',
    norwegian: 'fantasifigur mann',
    finnish: 'mielikuvitusolento (mies)',
    hungarian: 'képzelt férfi, képzeletbeli férfi',
    german: 'Phantasiewesen (Mann)',
    dutch: 'sprookjesfiguur (mannelijk)',
    afrikaans: 'verbeeldings figuur (manlik)',
    russian: 'сверхъестественное существо муж.пола',
    latvian: 'liekuļots, neīsts cilvēks',
    polish: 'mityczna postać człekokształtna',
    french: 'personnage imaginaire (masculin)',
    spanish: 'ser sobrenatural masculino',
  },
  {
    av: 23577,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(person + fantasy, phantasy, imagination, illusion) - Character (superimposed)',
    english: 'make-believe person, imaginary person',
    swedish: 'övernaturligt väsen, fantasifigur',
    norwegian: 'fantasifigur personlignende',
    finnish: 'mielikuvitusolento',
    hungarian: 'képzelt személy, képzeletbeli ember',
    german: 'Phantasiewesen',
    dutch: 'sprookjesfiguur',
    afrikaans: 'verbeeldings figuur (persoon)',
    russian: 'сверхъестественное существо',
    latvian: 'iedomāta, neīsta persona',
    polish: 'mityczna postać, bajkowa',
    french: 'personnage imaginaire',
    spanish: 'persona de fantasía, ser sobrenatural',
  },
  {
    av: 23581,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(woman + fantasy, phantasy, imagination, illusion) - Character (superimposed)',
    english: 'make-believe woman',
    swedish: 'övernaturligt kvinnligt väsen',
    norwegian: 'fantasifigur kvinne',
    finnish: 'mielikuvitusolento (nainen)',
    hungarian: 'képzelt nő, képzeletbeli lány',
    german: 'Phantasiewesen (Frau)',
    dutch: 'sprookjesfiguur (vrouwelijk)',
    afrikaans: 'verbeeldings figuur vrou',
    russian: 'сверхъестественное существо жен.рода',
    latvian: 'iedomāta, neīsta sieviete',
    polish: 'mityczna postać kobieca',
    french: 'personnage imaginaire (féminin)',
    spanish: 'ser sobrenatural femenino',
  },
  {
    av: 23583,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(creation [modification, half height]: imperfect version of creation, represents man-made) - Character (modified)',
    english: 'making, production, fashioning',
    swedish: 'tillverkning, produktion',
    norwegian: 'produksjon, forming',
    finnish: 'valmistus, tuotanto',
    hungarian: 'készítés, előállítás',
    german: 'Herstellung, Anfertigung, Produktion',
    dutch: 'gemaakt, product',
    afrikaans: 'maak, produksie, modellering',
    russian: 'изготовление, производство ',
    latvian: 'izgatavošana, ražošana, radīšana',
    polish: 'wytwarzanie, produkcja, kształtowanie',
    french: 'fabrication (humaine)',
    spanish: 'producción, creación',
  },
  {
    av: 23589,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(knowledge + dot (inside the knowledge): can also be seen as a combination of knowledge and inside) - Character (superimposed - combined)',
    english: 'memory',
    swedish: 'minne',
    norwegian: 'minne, hukommelse',
    finnish: 'muisti',
    hungarian: 'emlékezet, memória',
    german: 'Gedächtnis, Erinnerung',
    dutch: 'herinnering, gedachtenis',
    afrikaans: 'herinnering',
    russian: 'память',
    latvian: 'atmiņa',
    polish: 'pamięć',
    french: 'mémoire',
    spanish: 'memoria',
  },
  {
    av: 23599,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'oval',
    swedish: 'ovalform',
    norwegian: 'form oval',
    finnish: 'ovaali',
    hungarian: 'tojásdad, ovális (alak)',
    german: 'oval',
    dutch: 'ovaal (vorm)',
    afrikaans: 'ovaal vorm',
    russian: 'овал (форма)',
    latvian: 'ovāls, ovāla veida',
    polish: 'owal (kształt)',
    french: 'ovale (forme)',
    spanish: 'forma ovalada',
  },
  {
    av: 23603,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(dish + horizontal line [low, in the dish]) - Character (superimposed)',
    english: 'pancake, crepe, tortilla',
    swedish: 'pannkaka, crêpe, tortilla',
    norwegian: 'pannekake, tortilla',
    finnish: 'pannukakku, tortilla',
    hungarian: 'palacsinta, tortilla, lapos tészta',
    german: 'Pfannkuchen, Crêpe, Tortilla',
    dutch: 'pannenkoek, tortilla',
    afrikaans: 'pannekoek, crêpe, tortilla',
    russian: 'блин, тортила',
    latvian: 'pankūka, kukurūzas plācenis',
    polish: 'naleśnik',
    french: 'crêpe, tortilla',
    spanish: 'tortilla, crepe',
  },
  {
    av: 23619,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(hand, on its side, as if pointing) - Character (modified)',
    english: 'pointing',
    swedish: 'pekare',
    norwegian: 'peker',
    finnish: 'osoitin',
    hungarian: 'mutató (fn.)',
    german: 'Pointer, Zeigegerät',
    dutch: 'aanwijzer',
    afrikaans: 'aanwyser',
    russian: 'указатель',
    latvian: 'rādāmais kociņš, bultiņa, uguntiņa',
    polish: 'wskaźnik',
    french: 'pointeur, désignation',
    spanish: 'puntero',
  },
  {
    av: 23627,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'quill(s), spine(s)',
    swedish: 'taggar, piggar',
    norwegian: 'pigger, tagger',
    finnish: 'piikki, piikit',
    hungarian: 'tüske, tövis, tüsketövis',
    german: 'Stachel',
    dutch: 'stekels',
    afrikaans: 'penne, stekels',
    russian: 'шипы, колючки',
    latvian: 'putna, dzīvnieka spalva, adata, dzelonis',
    polish: 'kolce',
    french: 'piquant',
    spanish: 'púas espinas',
  },
  {
    av: 23629,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'ramp',
    swedish: 'ramp',
    norwegian: 'rampe',
    finnish: 'ramppi, ajoluiska',
    hungarian: 'rámpa, felhajtó, feljáró',
    german: 'Rampe',
    dutch: 'helling',
    afrikaans: 'helling, skuunste',
    russian: 'пандус',
    latvian: 'rampa, pandus',
    polish: 'rampa',
    french: 'rampe',
    spanish: 'rampa',
  },
  {
    av: 23658,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water (ground level) + grass: representing plants growing in water) - Character (superimposed)',
    english: 'seaweed',
    swedish: 'sjögräs, tång',
    norwegian: 'sjøgress, tang',
    finnish: 'merilevä',
    hungarian: 'hínár',
    german: 'Alge',
    dutch: 'zeewier',
    afrikaans: 'seewier',
    russian: 'морская водоросль',
    latvian: 'jūraszāles',
    polish: 'wodorost',
    french: 'algue',
    spanish: 'alga',
  },
  {
    av: 23673,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(table + pointer to the top) - Character (superimposed - pointer)',
    english: 'tabletop',
    swedish: 'bordsskiva',
    norwegian: 'bordplate',
    finnish: 'pöytälevy',
    hungarian: 'asztaltető, asztallap',
    german: 'Tischplatte',
    dutch: 'tafelblad',
    afrikaans: 'tafelblad',
    russian: 'столешница',
    latvian: 'galdvirsma',
    polish: 'blat biurka',
    french: 'dessus de table, tablette',
    spanish: 'mesa',
  },
  {
    av: 23690,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'track',
    swedish: 'spår, räls',
    norwegian: 'skinne (jernbane)',
    finnish: 'raiteet, kiskot, rata',
    hungarian: 'sín, sínpár, pálya, pályatest',
    german: 'Aschenbahn, Spur',
    dutch: 'spoor, rails',
    afrikaans: 'spoorlyn',
    russian: 'трасса, трек, рельсы',
    latvian: 'trase, ceļš, treks',
    polish: 'tor',
    french: 'voie, rails',
    spanish: 'pista',
  },
  {
    av: 23702,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(horse + pictograph of a single horn) - Character (superimposed)',
    english: 'unicorn',
    swedish: 'enhörning',
    norwegian: 'enhjørning',
    finnish: 'yksisarvinen',
    hungarian: 'egyszarvú, unikornis',
    german: 'Einhorn',
    dutch: 'eenhoorn',
    afrikaans: 'unicorn',
    russian: 'единорог',
    latvian: 'vienradzis',
    polish: 'jednorożec',
    french: 'licorne, unicorne',
    spanish: 'unicornio',
  },
  {
    av: 23706,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water (ground level) + arc: pictograph that could be associated with smooth water creatures) Used in conjunction with a specifier. - Character (superimposed)',
    english: 'water creature',
    swedish: 'vattendjur',
    norwegian: 'vannskapning',
    finnish: 'vesieläin',
    hungarian: 'vízilény',
    german: 'Wasserlebewesen, Lebewesen (im Wasser)',
    dutch: 'waterdier',
    afrikaans: 'water dier',
    russian: 'водный обитатель',
    latvian: 'zemūdens radījumi',
    polish: 'stworzenie wodne',
    french: 'créature marine',
    spanish: 'criatura de agua',
  },
  {
    av: 23803,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(stave + pointer, to alto position in stave) - Character (superimposed - pointer)',
    english: 'alto',
    swedish: 'altstämma, alt',
    norwegian: 'alt (musikk)',
    finnish: 'altto',
    hungarian: 'alt',
    german: 'Altstimme, Alt',
    dutch: 'alt',
    afrikaans: 'alt',
    russian: 'альт',
    latvian: 'alts',
    polish: 'alt',
    french: 'alto',
    spanish: 'alto',
  },
  {
    av: 23809,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(stave + pointer, to bass position in stave) - Character (superimposed - pointer)',
    english: 'bass',
    swedish: 'basstämma, bas',
    norwegian: 'basstemme',
    finnish: 'basso',
    hungarian: 'basszus, basszushang',
    german: 'Bass',
    dutch: 'bas',
    afrikaans: 'bas',
    russian: 'бас',
    latvian: 'bass',
    polish: 'bas',
    french: 'basse',
    spanish: 'bajo',
  },
  {
    av: 23817,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'bow, arc',
    swedish: 'båge, valv',
    norwegian: 'bue, hvelv',
    finnish: 'kaari',
    hungarian: 'ív, körív',
    german: 'Bogen, Gewölbe',
    dutch: 'boog',
    afrikaans: 'boog',
    russian: 'дуга, арка',
    latvian: 'loks, arka',
    polish: 'łuk (geometryczny wycinek koła)',
    french: 'arc',
    spanish: 'arco',
  },
  {
    av: 23818,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(bow and string (musical) + pointer, to bow) - Character (superimposed - pointer)',
    english: 'bow (musical instrument)',
    swedish: 'stråke',
    norwegian: 'bue (musikkinstrument)',
    finnish: 'jousi (soitin)',
    hungarian: 'vonó',
    german: 'Streicher',
    dutch: 'strijkstok',
    afrikaans: 'boog (musiek instrument)',
    russian: 'смычок',
    latvian: 'lociņš (mūzikas instruments)',
    polish: 'włosie smyczka (instrument muzyczny)',
    french: 'archet',
    spanish: 'arco (instrumento musical)',
  },
  {
    av: 23819,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'bow and string (musical)',
    swedish: 'stråke och sträng',
    norwegian: 'bue og streng (musikkinstrument)',
    finnish: 'jousi ja kieli (soitin)',
    hungarian: 'vonó és húr',
    german: 'Streicher und Saite (Musik)',
    dutch: 'boog en snaar',
    afrikaans: 'boog en snaar (musiek)',
    russian: 'струны и смычок',
    latvian: 'lociņš un stīgas (mūzikas instr.)',
    polish: 'smyczek (musical)',
    french: 'archet et corde',
    spanish: 'arco y cuerda (musical)',
  },
  {
    av: 23833,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(celery [modification, upper part] + vegetable (below ground) [modification, lower part] (combination): pictograph) - Character (superimposed - modified - combined)',
    english: 'celeriac, celery',
    swedish: 'rotselleri, selleri',
    norwegian: 'sellerirot',
    finnish: 'juuriselleri',
    hungarian: 'zeller',
    german: 'Stangensellerie',
    dutch: 'selderij, selder (Vl)',
    afrikaans: 'seldery',
    russian: 'сельдерей',
    latvian: 'selerijas, selerija',
    polish: 'seler (bulwa, korzeń)',
    french: 'céleri, céleri-rave ',
    spanish: 'apio nabo',
  },
  {
    av: 23839,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(seven dots + liquid: the symbol suggests droplets converting into liquid) - Character (superimposed - sequenced)',
    english: 'condensation',
    swedish: 'kondens, imma',
    norwegian: 'kondensering',
    finnish: 'kondensaatio, tiivistyminen, tislaus',
    hungarian: 'sűrítés, sűrüsödés, kondenzáció',
    german: 'Kondensation',
    dutch: 'condensatie',
    afrikaans: 'kondensasie',
    russian: 'конденсат',
    latvian: 'kondensāts, gaisa, mitruma',
    polish: 'kondensacja, skroplenie',
    french: 'condensation',
    spanish: 'condensación',
  },
  {
    av: 23854,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character SYMBOL SYNONYM',
    english: 'drum (1)',
    swedish: 'trumma (1)',
    norwegian: 'tromme (1)',
    finnish: 'rumpu',
    hungarian: 'dob',
    german: 'Trommel (1)',
    dutch: 'trommel, drum (1)',
    afrikaans: 'trom (1)',
    russian: 'барабан (1)',
    latvian: 'bungas (1)',
    polish: 'bęben (1)',
    french: 'tambour (1)',
    spanish: 'tambor (1)',
  },
  {
    av: 23859,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(water + to delete) - Character (superimposed)',
    english: 'dryness, drought',
    swedish: 'torka, torrhet',
    norwegian: 'tørrhet, tørke (subst.)',
    finnish: 'kuivuus',
    hungarian: 'szárazság, aszály',
    german: 'Trockenheit, Dürre',
    dutch: 'droogte',
    afrikaans: 'droogte',
    russian: 'сухость',
    latvian: 'sausums, sauss laiks',
    polish: 'susz, coś ususzone',
    french: 'sécheresse',
    spanish: 'sequedad, sequía',
  },
  {
    av: 23871,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pipe, hose, tube (2) + dot + dot (high position): pictograph) - Character (superimposed)',
    english: 'flute, recorder',
    swedish: 'flöjt',
    norwegian: 'fløyte',
    finnish: 'huilu',
    hungarian: 'furulya, flóta',
    german: 'Blockflöte',
    dutch: 'fluit',
    afrikaans: 'fluit',
    russian: 'флейта',
    latvian: 'flauta',
    polish: 'flet',
    french: 'flûte',
    spanish: 'flauta',
  },
  {
    av: 23872,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pipe, hose, tube (1) + dot + dot: pictograph) - Character (superimposed)',
    english: 'flute, transverse flute',
    swedish: 'flöjt, tvärflöjt',
    norwegian: 'fløyte, tverrfløyte',
    finnish: 'huilu',
    hungarian: 'fuvola',
    german: 'Querflöte',
    dutch: 'dwarsfluit',
    afrikaans: 'dwarsfluit',
    russian: 'флейта, поперечная флейта',
    latvian: 'flauta, šķērsflauta',
    polish: 'flet, flet poprzeczny',
    french: 'flûte traversière',
    spanish: 'flauta travesera',
  },
  {
    av: 23886,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(air + water) - Character (superimposed)',
    english: 'humidity',
    swedish: 'fukt, fuktighet',
    norwegian: 'fuktighet, fukt',
    finnish: 'kosteus',
    hungarian: 'nedvesség, nyirkosság, páratartalom',
    german: 'Luftfeuchtigkeit',
    dutch: 'vochtigheid',
    afrikaans: 'vogtigheid',
    russian: 'влажно, сыро',
    latvian: 'mitrums, valgums',
    polish: 'wilgotność',
    french: 'humidité',
    spanish: 'humedad',
  },
  {
    av: 23892,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'keyboard',
    swedish: 'klaviatur, keyboard',
    norwegian: 'tastatur, keyboard',
    finnish: 'koskettimet',
    hungarian: 'billentyűzet',
    german: 'Tastatur, Keyboard',
    dutch: 'klavier, toetsenbord',
    afrikaans: 'klawerbord',
    russian: 'клавиатура',
    latvian: 'tastatūra, klaviatūra',
    polish: 'klawiatura, klawisze',
    french: 'clavier',
    spanish: 'teclado',
  },
  {
    av: 23904,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + musical note) Used as classifier to create Bliss-words denoting musical instruments. - Character (superimposed)',
    english: 'musical instrument (in combinations)',
    swedish: 'musikinstrument (i kombinationer)',
    norwegian: 'musikkinstrument (i kombinasjon med)',
    finnish: 'musiikki-instrumentti, musiikkisoitin',
    hungarian: 'hangszer (szóösszetételben)',
    german: 'Musikinstrument (in Kombinationen)',
    dutch: 'muziekinstrument (in combinatie)',
    afrikaans: 'musiek instrument (in kombinasie)',
    russian: 'музыкальный инструмент',
    latvian: 'mūzikas instruments (dažādās nozīmēs)',
    polish: 'instrument muzyczny (w złożonym symbolu)',
    french: 'instrument de musique (classificateur)',
    spanish: 'instrumento musical (en combinaciones)',
  },
  {
    av: 23926,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: vertical orientation) - Character SYMBOL SYNONYM',
    english: 'pipe, hose, tube (2)',
    swedish: 'rör, slang (2)',
    norwegian: 'rør, slange (2)',
    finnish: 'letku, putki, tuubi',
    hungarian: 'cső, tömlő (nyitott végű)',
    german: 'Rohr, Röhre (2)',
    dutch: 'buis, pijp (buis), darm (buis), tube (2)',
    afrikaans: 'pyp, buis, tuinslang (2)',
    russian: 'труба, трубка, шланг (2)',
    latvian: 'caurule, šļūtene, cauruļvads (2)',
    polish: 'rura, wąż, tuba (2)',
    french: 'tube, tuyau (2)',
    spanish: 'tubería, manguera (2)',
  },
  {
    av: 23927,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character ',
    english: 'pipe, tube (closed)',
    swedish: 'tub',
    norwegian: 'rør, slange (lukket), tube',
    finnish: 'putki (suljettu), tuubi (suljettu), letku (suljettu)',
    hungarian: 'cső, tömlő (zárt végű)',
    german: 'Tube',
    dutch: 'tube (gesloten), buis (gesloten)',
    afrikaans: 'pyp, buis (geslote, geseël)',
    russian: 'труба, трубка (зкрытая)',
    latvian: 'caurule, cauruļvads (slēgts)',
    polish: 'rura, wąż, tuba (zamknięta)',
    french: 'tube, tuyau (fermé)',
    spanish: 'tubería, manguera (cerrada)',
  },
  {
    av: 23929,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(stave, staff + pointer) - Character (superimposed - pointer)',
    english: 'pitch (sound)',
    swedish: 'tonhöjd, stämma (allmän)',
    norwegian: 'tonehøyde',
    finnish: 'sävelkorkeus (yl.)',
    hungarian: 'hangmagasság',
    german: 'Tonhöhe, Stimme, Stimmlage',
    dutch: 'toonhoogte',
    afrikaans: 'toonhoogte',
    russian: 'шаг, уровень (музыка)',
    latvian: 'skaņas augstuma pakāpe',
    polish: 'ton (dźwięk)',
    french: 'hauteur du son',
    spanish: 'tono (sonido, música)',
  },
  {
    av: 23942,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'reed',
    swedish: 'rörblad',
    norwegian: 'rørblad',
    finnish: 'ruoko, kaisla',
    hungarian: 'nád, nádfúvóka',
    german: 'Ried, Schilfrohr',
    dutch: 'riet (muziek)',
    afrikaans: 'riet',
    russian: 'камыш',
    latvian: 'niedre, meldri',
    polish: 'trzcina',
    french: 'anche',
    spanish: 'lengüeta',
  },
  {
    av: 23952,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(stave + pointer, to soprano position in stave) - Character (superimposed - pointer)',
    english: 'soprano',
    swedish: 'sopranstämma, sopran',
    norwegian: 'sopran',
    finnish: 'sopraano',
    hungarian: 'szoprán',
    german: 'Sopran',
    dutch: 'sopraan',
    afrikaans: 'sopraan',
    russian: 'сопрано',
    latvian: 'soprāns',
    polish: 'sopran',
    french: 'soprano',
    spanish: 'soprano',
  },
  {
    av: 23955,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: five half-sized horizontal lines, as in a stave for musical notation) - Character',
    english: 'stave, staff',
    swedish: 'notplan, notlinjer',
    norwegian: 'notelinjer',
    finnish: 'nuottiviivasto',
    hungarian: 'kotta öt vonala, hangjegyvonal',
    german: 'Notenlinien, Notensystem',
    dutch: 'maat, gradatie',
    afrikaans: 'staaf',
    russian: 'нотный стан',
    latvian: 'nošu līnija',
    polish: 'pięciolinia (muzyczna)',
    french: 'portée (musique)',
    spanish: 'pentagrama',
  },
  {
    av: 23958,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(line + pointer, to the line) - Character (superimposed - pointer)',
    english: 'string',
    swedish: 'sträng',
    norwegian: 'streng',
    finnish: 'kieli (soitin)',
    hungarian: 'kötél, húr, madzag',
    german: 'Saite',
    dutch: 'snaar, draad',
    afrikaans: 'snaar',
    russian: 'струна, шнурок, веревка, тетева',
    latvian: 'aukliņa',
    polish: 'sznurek, tasiemka',
    french: 'corde',
    spanish: 'cuerda',
  },
  {
    av: 23959,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(bow and string (musical) + pointer, to string) - Character (superimposed - pointer)',
    english: 'string (for musical instrument)',
    swedish: 'sträng (på musikinstrument)',
    norwegian: 'streng (for musikkinstrument)',
    finnish: 'kieli (soitin)',
    hungarian: 'húr (hangszer)',
    german: 'Saite',
    dutch: 'snaar (instrument)',
    afrikaans: 'snaar (vir musiek instrument)',
    russian: 'струна (муз. инструмент)',
    latvian: 'stīga, mūzikas instr.',
    polish: 'struna (w instrumencie muzycznym)',
    french: "corde (d'instrument de musique)",
    spanish: 'cuerda (para instrumento musical)',
  },
  {
    av: 23966,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(stave + pointer, to tenor position in stave) - Character (superimposed - pointer)',
    english: 'tenor',
    swedish: 'tenorstämma, tenor',
    norwegian: 'tenor',
    finnish: 'tenori',
    hungarian: 'tenor',
    german: 'Tenor',
    dutch: 'tenor',
    afrikaans: 'tenoor',
    russian: 'тенор',
    latvian: 'tenors',
    polish: 'tenor',
    french: 'ténor',
    spanish: 'tenor',
  },
  {
    av: 24015,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(root(s) + line, stripe: the line representing a modified stalk of asparagus, pictograph) - Character (superimposed)',
    english: 'asparagus',
    swedish: 'sparris',
    norwegian: 'asparges',
    finnish: 'parsa',
    hungarian: 'spárga',
    german: 'Spargel',
    dutch: 'asperge',
    afrikaans: 'aspersie',
    russian: 'спаржа',
    latvian: 'sparģelis',
    polish: 'szparagi',
    french: 'asperge',
    spanish: 'espárragos',
  },
  {
    av: 24051,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation:
      '(leader + meeting [modification, short arrows] (combination)) - Character (superimposed - modified - combined)',
    english: 'chairman',
    swedish: 'ordförande',
    norwegian: 'møteleder, ordstyrer',
    finnish: 'puheenjohtaja, puhemies',
    hungarian: 'elnök, üléselnök',
    german: 'Vorsitzende (der), Vorsitzende (die)',
    dutch: 'verantwoordelijke (congres), voorzitter (congres)',
    afrikaans: 'voorsitter',
    russian: 'председатель',
    latvian: 'vadītājs, priekšsēdētājs',
    polish: 'przewodniczący',
    french: 'président',
    spanish: 'presidente',
  },
  {
    av: 24098,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(life + world) - Character (superimposed) SYMBOL SYNONYM',
    english: 'existence, being (1)',
    swedish: 'tillvaro, existens (1)',
    norwegian: 'tilværelse, eksistens (1)',
    finnish: 'olemassaolo, olento',
    hungarian: 'lét, létezés, fennállás',
    german: 'Existenz, Dasein (1)',
    dutch: 'bestaan (zelfst.nw) (1)',
    afrikaans: 'bestaan, is, wees (1)',
    russian: 'существование, бытие (1)',
    latvian: 'pastāvēšana, eksistence (1)',
    polish: 'egzystencja, istnienie',
    french: 'existence (1)',
    spanish: 'existencia',
  },
  {
    av: 24120,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'foundation, base, fundament',
    swedish: 'grund, bas',
    norwegian: 'grunnlag, basis',
    finnish: 'pohja, perusta, alusta',
    hungarian: 'alap, alapzat, fundamentum',
    german: 'Grundierung',
    dutch: 'fundament',
    afrikaans: 'fondament, basis, fondasie',
    russian: 'основание, фудамент',
    latvian: 'pamats, pamatne, fundaments',
    polish: 'podstawa, oparcie, baza',
    french: 'fondation, base, fondement',
    spanish: 'cimientos, bases',
  },
  {
    av: 24155,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(horse + pointer, to hoof) - Character (superimposed - pointer)',
    english: 'hoof',
    swedish: 'hov, klöv',
    norwegian: 'hov, klov',
    finnish: 'kavio',
    hungarian: 'pata',
    german: 'Huf',
    dutch: 'hoef',
    afrikaans: 'hoef',
    russian: 'копыто',
    latvian: 'pakavs',
    polish: 'kopyto',
    french: 'sabot du cheval',
    spanish: 'pezuña',
  },
  {
    av: 24176,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'kidney',
    swedish: 'njure',
    norwegian: 'nyre',
    finnish: 'munuainen',
    hungarian: 'vese',
    german: 'Niere',
    dutch: 'nier',
    afrikaans: 'nier',
    russian: 'почка',
    latvian: 'niere',
    polish: 'nerka',
    french: 'rein',
    spanish: 'riñón',
  },
  {
    av: 24196,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(horse + pointer, to muzzle) - Character (superimposed - pointer)',
    english: 'muzzle',
    swedish: 'mule, nos',
    norwegian: 'mule',
    finnish: 'turpa',
    hungarian: 'orr, pofa (ló)',
    german: 'Maul, Schnauze',
    dutch: 'neus (paard), muil (paard)',
    afrikaans: 'neus, snoet (perd, donkie, muil)',
    russian: 'морда',
    latvian: 'purns, uzpurnis',
    polish: 'pysk (konia)',
    french: 'museau',
    spanish: 'hocico',
  },
  {
    av: 24198,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(body with navel + pointer, to navel) - Character (superimposed - pointer)',
    english: 'navel',
    swedish: 'navel',
    norwegian: 'navle',
    finnish: 'napa',
    hungarian: 'köldök',
    german: 'Bauchnabel',
    dutch: 'navel',
    afrikaans: 'naeltjie',
    russian: 'пупок',
    latvian: 'naba',
    polish: 'pępek',
    french: 'nombril',
    spanish: 'ombligo',
  },
  {
    av: 24210,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pointer (left) + person + pointer (right): suggesting the charisma radiating from a person) - Character (superimposed - pointer)',
    english: 'personality',
    swedish: 'personlighet, utstrålning',
    norwegian: 'personlighet',
    finnish: 'persoonallisuus, luonne',
    hungarian: 'személyiség, egyéniség',
    german: 'Persönlichkeit, Ausstrahlung',
    dutch: 'persoonlijkheid',
    afrikaans: 'persoonlikheid',
    russian: 'личность',
    latvian: 'personība',
    polish: 'osobowość, indywidualność',
    french: 'personnalité',
    spanish: 'personalidad',
  },
  {
    av: 24214,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'platform, stage',
    swedish: 'plattform, scen (etc)',
    norwegian: 'plattform, scene',
    finnish: 'laituri, lava',
    hungarian: 'színpad, emelvény, platform',
    german: 'Bühne, Podium',
    dutch: 'podium',
    afrikaans: 'verhoog, podium, platform',
    russian: 'платформа, сцена',
    latvian: 'paaugstinājums, skatuve',
    polish: 'podwyższenie, scena, platforma',
    french: 'quai, estrade, terre-plein, scène',
    spanish: 'plataforma, escenario',
  },
  {
    av: 24216,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(leadership + say, speak, talk, tell, express-(to): combination of opinion and to lead) - Character (superimposed - combined)',
    english: 'politics',
    swedish: 'politik',
    norwegian: 'politikk',
    finnish: 'politiikka',
    hungarian: 'politika',
    german: 'Politik',
    dutch: 'politiek',
    afrikaans: 'politiek',
    russian: 'политика',
    latvian: 'politika',
    polish: 'polityka',
    french: 'politique',
    spanish: 'política',
  },
  {
    av: 24240,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(conscience + other) - Character (superimposed)',
    english: 'responsibility',
    swedish: 'ansvar',
    norwegian: 'ansvar',
    finnish: 'vastuu, velvollisuus',
    hungarian: 'felelősség',
    german: 'Verantwortlichkeit',
    dutch: 'verantwoordelijkheid',
    afrikaans: 'verantwoordelikheid',
    russian: 'ответственность',
    latvian: 'atbildība',
    polish: 'odpowiedzialność',
    french: 'responsabilité',
    spanish: 'responsabilidad',
  },
  {
    av: 24249,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(curved arrow suggesting circular motion) - Character',
    english: 'rotation, circulation, orbit, lap, circle, round',
    swedish: 'rotation, cirkulation, omloppsbana, runda, varv',
    norwegian: 'rotasjon, sirkulering, runde, omgang',
    finnish: 'pyöriminen, pyörähdys, pyöriä',
    hungarian: 'forgás, körforgás, keringés, körpálya, forduló',
    german: 'Drehung, Kreislauf, Zirkulation, Umlauf, Umkreisung',
    dutch: 'omwenteling, rotatie',
    afrikaans: 'rotasie, sirkulasie, wentel, sirkel',
    russian: 'вращение, циркуляция, орбита, круг',
    latvian: 'rotācija, cirkulācija, riņķošana, orbīta, aplis',
    polish: 'obrót, rotacja',
    french: 'rotation, orbite, mouvement circulaire',
    spanish: 'circulación, rotación',
  },
  {
    av: 24272,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(rotation + ground) - Character (superimposed) SYMBOL SYNONYM',
    english: 'somersault',
    swedish: 'kullerbytta (1)',
    norwegian: 'salto, kollbøtte (1)',
    finnish: 'kierähdys, kuperkeikka',
    hungarian: 'bukfenc',
    german: 'Purzelbaum, Salto (1)',
    dutch: 'salto',
    afrikaans: 'bolmakiesie (1)',
    russian: 'кувырок (1)',
    latvian: 'kūlenis (1)',
    polish: 'salto, fikołek (1)',
    french: 'culbute, tonneau, saut périlleux (1)',
    spanish: 'voltereta (1)',
  },
  {
    av: 24281,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(buildings with courtyard + pointer, to courtyard) - Character (superimposed - pointer)',
    english: 'square (public)',
    swedish: 'torg',
    norwegian: 'torg',
    finnish: 'aukio, tori',
    hungarian: 'tér (pl. városban)',
    german: 'Marktplatz',
    dutch: 'plein',
    afrikaans: 'plein (publiek)',
    russian: 'площадь',
    latvian: 'laukums, sabiedrisks',
    polish: 'plac, podwórko, skwer',
    french: 'place (de ville), square',
    spanish: 'plaza (pública)',
  },
  {
    av: 24302,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: the symbol also incorporates water) - Character',
    english: 'tadpole',
    swedish: 'grodyngel',
    norwegian: 'rumpetroll',
    finnish: 'nuijapää, sammakonpoikanen',
    hungarian: 'ebihal',
    german: 'Kaulquappe',
    dutch: 'kikkervisje',
    afrikaans: 'paddavis',
    russian: 'головастик',
    latvian: 'kurkulis',
    polish: 'kijanka',
    french: 'têtard',
    spanish: 'renacuajo',
  },
  {
    av: 24309,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(ideograph: “…indicates a halt and afterwards a free flow” [C.K. Bliss, Semantography. p. 449]) See also: but, except 13094 - Character',
    english: 'that (conj)',
    swedish: 'att',
    norwegian: 'at',
    finnish: 'että',
    hungarian: 'hogy (kötőszó)',
    german: 'zu ',
    dutch: 'die, dat',
    afrikaans: 'daardie',
    russian: 'что',
    latvian: 'lai (saiklis)',
    polish: 'że',
    french: "que, qu' (conj)",
    spanish: 'que (conj)',
  },
  {
    av: 24332,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vehicle [modification, lengthened] + wheel: pictograph of a long vehicle that does not operate under its own power) - Character (superimposed - modified)',
    english: 'vehicle (long)',
    swedish: 'fordon (långt), vagn',
    norwegian: 'kjøretøy (langt)',
    finnish: 'pitkä kulkuneuvo, pitkä vaunu, pitkä ajoneuvo',
    hungarian: 'jármű (hosszú)',
    german: 'Fahrzeug (lang)',
    dutch: 'voertuig (lang)',
    afrikaans: 'voertuig (lank)',
    russian: 'транспортное средство (длинное)',
    latvian: 'transportlīdzeklis (garš)',
    polish: 'pojazd (długi)',
    french: 'véhicule (long)',
    spanish: 'vehículo (largo)',
  },
  {
    av: 24422,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(down, downward + earth, ground, land) - Character (superimposed)',
    english: 'bump, press, pressing',
    swedish: 'stöt',
    norwegian: 'støt',
    finnish: 'maahantörmäys',
    hungarian: 'koccanás, beütés, beverés',
    german: 'Beule, Presse, Pressen',
    dutch: 'knobbel, buil, bult',
    afrikaans: 'stamp, druk',
    russian: 'удар, пресс, нажатие',
    latvian: 'belziens, saspiedums, saspiešana',
    polish: 'uderzenia, upadek',
    french: 'choc, chute',
    spanish: 'bache',
  },
  {
    av: 24443,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(life [half sized]) - Character SYMBOL SYNONYM',
    english: 'being (state of)',
    swedish: 'tillvaro, existens (2)',
    norwegian: 'tilværelse, eksistens (2)',
    finnish: 'olemassaolo, olento',
    hungarian: 'lét, létezés, levés',
    german: 'Existenz, Dasein (2)',
    dutch: 'bestaand, wezen, schepsel (2)',
    afrikaans: 'bestaan (2)',
    russian: 'существование, бытие (2)',
    latvian: 'pastāvēšana, eksistence, esība (2)',
    polish: 'egzystencja, istnienie (2)',
    french: 'existence (2)',
    spanish: 'existencia',
  },
  {
    av: 24445,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(success + stop (combination) - Character (superimposed - combined)',
    english: 'failure',
    swedish: 'misslyckande',
    norwegian: 'mislykking, feiltak',
    finnish: 'epäonnistuminen',
    hungarian: 'kudarc, bukás, balsiker, sikertelenség',
    german: 'Misserfolg, Scheitern, Versagen',
    dutch: 'mislukking',
    afrikaans: 'mislukking',
    russian: 'поражение, проигрыш',
    latvian: 'kļūda, neizdošanās, nenokārtošana',
    polish: 'porażka, niepowodzenie, klęska, fiasko',
    french: 'échec',
    spanish: 'fracaso',
  },
  {
    av: 24451,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sun + star: the sun here representing a circular gathering of stars) - Character (superimposed)',
    english: 'galaxy',
    swedish: 'galax',
    norwegian: 'galakse',
    finnish: 'galaksi',
    hungarian: 'tejút, tejútrendszer, galaxis, galaktika',
    german: 'Galaxis, Milchstraβe, Sternsystem',
    dutch: 'heelal',
    afrikaans: 'sterrestelsel',
    russian: 'галактика',
    latvian: 'galktika',
    polish: 'galaktyka',
    french: 'galaxie',
    spanish: 'galaxia',
  },
  {
    av: 24482,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(illness + mind) - Character (superimposed)',
    english: 'mental illness',
    swedish: 'mental sjukdom',
    norwegian: 'mental sykdom',
    finnish: 'mielisairaus',
    hungarian: 'elmebetegség',
    german: 'Geisteskrankheit',
    dutch: 'geestesziekte, ziekte (mentaal)',
    afrikaans: 'geestesongesteldheid',
    russian: ' психическое заболевание',
    latvian: 'garīga slimība',
    polish: 'choroba psychiczna',
    french: 'maladie mentale',
    spanish: 'enfermedad mental',
  },
  {
    av: 24515,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(material + dot, in the material: can also be seen as a combination of material and in [modification, half-sized]; what is in a material) - Character (superimposed - combined - modified)',
    english: 'substance',
    swedish: 'substans, ämne',
    norwegian: 'substans, emne',
    finnish: 'substanssi, perusaines',
    hungarian: 'anyag',
    german: 'Substanz, Stoff',
    dutch: 'substantie',
    afrikaans: 'stof',
    russian: 'содержание, субтанция',
    latvian: 'viela',
    polish: 'substancja',
    french: 'substance',
    spanish: 'sustancia',
  },
  {
    av: 24518,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'tile',
    swedish: 'spelbricka',
    norwegian: 'brikke (spill)',
    finnish: 'tiili, kaakeli, laatta',
    hungarian: 'csempe',
    german: 'Spielstein',
    dutch: 'tegel',
    afrikaans: 'teël',
    russian: 'игровая фишка, кость',
    latvian: 'flīze',
    polish: 'dachówka, kafel',
    french: 'domino, tuile',
    spanish: 'azulejo',
  },
  {
    av: 24605,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth, globe, world + pointer [modification, at an angle], to the axis of the earth) - Character (superimposed - modified - pointer)',
    english: 'Earth axis, axis',
    swedish: 'jordaxel',
    norwegian: 'jordakse',
    finnish: 'akseli, halkaisija',
    hungarian: 'földtengely',
    german: 'Erdachse',
    dutch: 'aardas',
    afrikaans: 'aard as',
    russian: 'Земная Ось',
    latvian: 'Zemes ass',
    polish: 'oś',
    french: 'axe',
    spanish: 'Eje de la Tierra',
  },
  {
    av: 24638,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + digits (computer)) - Character (superimposed)',
    english: 'digital device',
    swedish: 'digital enhet, digital apparat',
    norwegian: 'digital enhet, digitalt apparat',
    finnish: 'digitaalinen laite',
    hungarian: 'digitális eszköz',
    german: 'Tastengerät',
    dutch: 'digitaal toestel',
    afrikaans: 'digitale toestel',
    russian: 'цифровое устроиство',
    latvian: 'elektroniska, digitāla iekārta, ierīce, aparāts',
    polish: 'urządzenie cyfrowe',
    french: 'dispositif informatique, dispositif numérique',
    spanish: 'dispositivo digital',
  },
  {
    av: 24714,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(container + forward [modification, short arrow]) - Character (superimposed - modified)',
    english: 'portability',
    swedish: 'bärbarhet, portabilitet',
    norwegian: 'flyttbarhet',
    finnish: 'siirrettävyys, kannettavuus, liikuteltavuus',
    hungarian: 'hordozhatóság',
    german: 'Beweglichkeit, Tragbarkeit',
    dutch: 'draagbaarheid',
    afrikaans: 'oordraagbaarheid',
    russian: 'портативность, мобильность',
    latvian: 'pārvietojamība, pārnēsājamība',
    polish: 'przenoszenie',
    french: 'portabilité',
    spanish: 'portabilidad',
  },
  {
    av: 24717,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(container + pictograph of a handle) - Character (superimposed)',
    english: 'potty, chamber pot, bedpan',
    swedish: 'potta, bäcken (etc)',
    norwegian: 'potte, bekken',
    finnish: 'potta',
    hungarian: 'bili, ágytál',
    german: 'Töpfchen, Nachttopf',
    dutch: 'potje, po (Nl), bedpan (Vl), beddepan',
    afrikaans: 'potjie, pot, bedpan',
    russian: 'ночной горшок',
    latvian: 'naktspods',
    polish: 'nocnik',
    french: 'pot de chambre',
    spanish: 'orinal, chata, bacinilla, cuña',
  },
  {
    av: 24726,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'receiver, dish',
    swedish: 'parabol, parabolantenn, mottagare',
    norwegian: 'parabolantenne',
    finnish: 'lautasvastaanotin',
    hungarian: 'parabola antenna',
    german: 'Parabolantenne, Empfänger',
    dutch: 'satelliet, schotelantenne',
    afrikaans: 'satelliet skottel',
    russian: 'спутниковая тарелка, антенна',
    latvian: 'uztvērējs, radiouztvērējs (signālu)',
    polish: 'zbiornik, naczynie',
    french: 'récepteur, réceptacle ',
    spanish: 'receptor, antena parabólica',
  },
  {
    av: 24727,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(down + container: drawing into what one holds) - Character (superimposed)',
    english: 'acquiring, getting, receiving',
    swedish: 'mottagande',
    norwegian: 'mottak',
    finnish: 'vastaanotto',
    hungarian: 'vétel (pl. tévéadás vétele)',
    german: 'Annahme, Empfang',
    dutch: 'ontvangst',
    afrikaans: 'ontvang',
    russian: 'получение',
    latvian: 'uztveršana',
    polish: 'odbieranie, odbiór',
    french: 'réception',
    spanish: 'receptor',
  },
  {
    av: 24739,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(planet [half-sized]) - Character',
    english: 'satellite',
    swedish: 'satellit',
    norwegian: 'satellitt',
    finnish: 'satelliitti',
    hungarian: 'műhold, szatellita',
    german: 'Satellit',
    dutch: 'satelliet',
    afrikaans: 'satelliet',
    russian: 'спутник ',
    latvian: 'satelīts',
    polish: 'satelita',
    french: 'satellite',
    spanish: 'satélite',
  },
  {
    av: 24750,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: as of waves spreading in water) - Character',
    english: 'signal, broadcast, transmitting',
    swedish: 'signal, sändning, överföring',
    norwegian: 'signal, overføring',
    finnish: 'lähetys, signaali',
    hungarian: 'sugárzás, közvetítés, jelátvitel',
    german: 'Signal, Sendung, Übertragung',
    dutch: 'signaal',
    afrikaans: 'sein, uitsending',
    russian: 'сигнал, вещание',
    latvian: 'signāls, pārraide, pārraidīšana',
    polish: 'sygnał, transmisja',
    french: 'onde émettrice, transmission',
    spanish: 'señal, transmisión',
  },
  {
    av: 24761,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(stairs + pointer, to step) - Character (superimposed - pointer)',
    english: 'step, stair',
    swedish: 'trappsteg',
    norwegian: 'trinn, trappetrinn',
    finnish: 'porras, askelma',
    hungarian: 'lépcső',
    german: 'Treppenstufe',
    dutch: 'trap',
    afrikaans: 'trap',
    russian: 'ступенька',
    latvian: 'pakāpiens, kāpslis',
    polish: 'stopień schodów',
    french: 'marche (escalier)',
    spanish: 'escalón, escalera',
  },
  {
    av: 24778,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(flower + water) - Character (superimposed)',
    english: 'water flower, water lily',
    swedish: 'näckros, vattenväxt',
    norwegian: 'vannblomst, vannlilje',
    finnish: 'lumme',
    hungarian: 'vízililiom',
    german: 'Seerose, Seeblume',
    dutch: 'waterlelie',
    afrikaans: 'waterblom. Waterlelie',
    russian: 'водяная лилия',
    latvian: 'ūdensroze',
    polish: 'lilia wodna, nenufar',
    french: "fleur de nénuphar, fleur de lotus, fleur d'eau",
    spanish: 'flor acuática, nenúfar',
  },
  {
    av: 24801,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: "(pictograph: of a bear's head) - Character",
    english: "bear's head",
    swedish: 'björnhuvud',
    norwegian: 'bamse',
    finnish: 'karhun pää',
    hungarian: 'medvefej, mackófej',
    german: 'Bärenkopf',
    dutch: 'berekop',
    afrikaans: 'die beer se kop',
    russian: 'медвежья голова',
    latvian: 'lāča galva',
    polish: 'głowa niedźwiedzia',
    french: "tête d'ours",
    spanish: 'cabeza de oso',
  },
  {
    av: 24805,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(curved arrow, backward, indicating the path of a backward jump) - Character',
    english: 'jump (backward)',
    swedish: 'hopp (bakåt)',
    norwegian: 'hopp (bakover)',
    finnish: 'hyppy taaksepäin',
    hungarian: 'ugrás (hátrafelé, visszafelé)',
    german: 'Sprung (rückwärts)',
    dutch: 'sprong (terug)',
    afrikaans: 'spring (terug)',
    russian: 'прыгать (назад)',
    latvian: 'lēkt (atpakaļ)',
    polish: 'skok do tyłu, odskok',
    french: 'recul, saut en arrière',
    spanish: 'saltar (hacia atrás)',
  },
  {
    av: 24806,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(height, tallness + lowness, shortness (height): combination of high, tall and short ) - Character (superimposed - combined)',
    english: 'scale, measurement',
    swedish: 'skala, mått',
    norwegian: 'høydemål',
    finnish: 'mitta, mittaus',
    hungarian: 'méret, mérés, mérték, skála',
    german: 'Maβstab, Maβeinheit',
    dutch: 'schaal (meetinstr), meetschaal',
    afrikaans: 'skaal (meet gewig)',
    russian: 'шкала, измерение',
    latvian: 'mērogs, skala, mērījums',
    polish: 'miara, linijka (2)',
    french: 'mesure (hauteur)',
    spanish: 'balanza, medida',
  },
  {
    av: 24825,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(forward + thing: the forward moving arrow seems to be pushing the thing) - Character (superimposed)',
    english: 'push, pushing',
    swedish: 'knuff',
    norwegian: 'dytt',
    finnish: 'työntää',
    hungarian: 'tolás, eltolás',
    german: 'Stoβ, Drang, Schubs',
    dutch: 'duw',
    afrikaans: 'stoot, druk',
    russian: 'нажатие, толчок',
    latvian: 'grūst, grūšana',
    polish: 'popchnąć, pchać',
    french: 'poussée',
    spanish: 'empujón, empujando',
  },
  {
    av: 24833,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + fire: a rational desire, a strong feeling shown by fire) See also: want, desire 24834 - Character (superimposed)',
    english: 'wish, desire',
    swedish: 'önskan, önskning',
    norwegian: 'ønske',
    finnish: 'toive',
    hungarian: 'vágy valamire, áhítás, kívánság',
    german: 'Wunsch, Sehnsucht',
    dutch: 'wens, verlangen',
    afrikaans: 'wens, begeerte',
    russian: 'желание',
    latvian: 'vēlme, alkas, iekāre',
    polish: 'życzenie, pragnienie, potrzeba',
    french: 'souhait, vœu, désir',
    spanish: 'deseo',
  },
  {
    av: 24846,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + eye: to look at something thoughtfully) - Character (superimposed)',
    english: 'observation',
    swedish: 'observation',
    norwegian: 'observasjon',
    finnish: 'tarkkailu',
    hungarian: 'megfigyelés',
    german: 'Beobachtung',
    dutch: 'observatie, waarneming',
    afrikaans: 'observasie, waarneming',
    russian: 'наблюдение, наблюдательность',
    latvian: 'novērošana',
    polish: '',
    french: 'observation',
    spanish: 'observación',
  },
  {
    av: 24847,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + tool: rational manipulation of a tool) - Character (superimposed)',
    english: 'usage, use',
    swedish: 'användning',
    norwegian: 'bruk, bruksområde',
    finnish: 'käyttö',
    hungarian: 'használat, kezelés',
    german: 'Anwendung, Gebrauch, Benutzung',
    dutch: 'gebruik',
    afrikaans: 'gebruik',
    russian: 'использование',
    latvian: 'pielietojums, lietot',
    polish: '',
    french: 'utilisation, usage',
    spanish: 'uso',
  },
  {
    av: 24852,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(horizontal line [broken]) - Character',
    english: 'break, fracture, injury, damage',
    swedish: 'brott, bristning',
    norwegian: 'brudd, brist',
    finnish: 'rikkoutuminen, katkeaminen, särkyminen',
    hungarian: 'törés',
    german: 'Bruch, Fraktur',
    dutch: 'breuk',
    afrikaans: 'breek, fraktuur',
    russian: 'поломка, надлом',
    latvian: 'lūzums',
    polish: '',
    french: 'cassure, brisure, fracture, déchirure',
    spanish: 'rotura, fractura',
  },
  {
    av: 24855,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(hand [modification, at an angle] + hand [modification, mirrored at an angle]: crossing hands, symbol represents physical conflict but may be used in a general sense to represent any sort of conflict or struggle) - Character (superimposed - modified)',
    english: 'fight, combat',
    swedish: 'slagsmål, bråk',
    norwegian: 'slagsmål',
    finnish: 'tappeleminen, taisteleminen',
    hungarian: 'harc, csata',
    german: 'Kampf, Gefecht',
    dutch: 'gevecht',
    afrikaans: 'veg, geveg',
    russian: 'драка, потасовка',
    latvian: 'cīnīties, kauties',
    polish: '',
    french: 'bataille, combat',
    spanish: 'lucha, combate',
  },
  {
    av: 24859,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(forward + house: can be understood as a combination of house and to enter) - Character (superimposed)',
    english: 'visit',
    swedish: 'besök',
    norwegian: 'besøk',
    finnish: 'vieraileminen, kylässä käyminen',
    hungarian: 'látogatás, vendégség',
    german: 'Besuch',
    dutch: 'visite, bezoek',
    afrikaans: 'besoek',
    russian: 'визит',
    latvian: 'apciemot',
    polish: '',
    french: 'visite',
    spanish: 'visita  ',
  },
  {
    av: 24875,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vertical line bounded by two horizontal reference lines [half-sized]: the vertical line extends to the biggest possible size within the symbol square) - Character ',
    english: 'bigness, largeness',
    swedish: 'storhet',
    norwegian: 'størrelse (betydelig)',
    finnish: 'suuruus',
    hungarian: 'nagyság, terjedelmesség',
    german: 'Größe, Weite',
    dutch: 'grootte',
    afrikaans: 'groot, grootte',
    russian: 'величина',
    latvian: 'lielums',
    polish: '',
    french: 'grandeur',
    spanish: 'magnitud',
  },
  {
    av: 24879,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(horizontal reference line [modification, half-sized on midline] + much, many, very [modification, higher position]: much, many on a higher level) - Character (superimposed - modified)',
    english: 'comparative more',
    swedish: 'mer (för komparation av adj.)',
    norwegian: 'mer (koparativ)',
    finnish: 'komparatiivi',
    hungarian: 'több',
    german: 'mehr (Komparativ von Adjektiv)',
    dutch: 'meer (vergelijkende trap)',
    afrikaans: 'meer (vergelykende)',
    russian: 'более, больше (срав.ст.прил.)',
    latvian: 'vairāk (pārākā pakāpe)',
    polish: '',
    french: 'plus que (comparatif)',
    spanish: 'comparativo, más',
  },
  {
    av: 24880,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(mind + other: mindfulness of others) - Character (superimposed)',
    english: 'consideration, thoughtfulness',
    swedish: 'omtänksamhet',
    norwegian: 'omtenksomhet, hensynsfullhet',
    finnish: 'hienotunteisuus, huomaavaisuus',
    hungarian: 'tapintat, tapintatosság, előzékenység',
    german: 'Rücksicht, Bedenken, Bedachtsamkeit',
    dutch: 'beschouwing',
    afrikaans: 'oorweging, sorgsaamheid, bedagsaamheid',
    russian: 'предусмотрение, внимание',
    latvian: 'apdomīgums, apsvēršana',
    polish: '',
    french: 'prévenance, galanterie, serviabilité',
    spanish: 'consideración, amabilidad',
  },
  {
    av: 24883,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(diagonal line used to cross out something: in the top-right to bottom left orientation) - Character',
    english: 'deletion, cancellation, destruction',
    swedish: 'förstörelse, strykning, radering, borttagning, utplåning',
    norwegian: 'ødeleggelse, strykning, kansellering',
    finnish: 'poistaminen, yliviivaaminen, pilaaminen',
    hungarian: 'törlés, áthúzás, érvénytelenítés, megsemmisítés',
    german: 'Beseitigung, Löschung, Stornierung, Abbestellung, Zerstörung',
    dutch: 'verwijdering, destructie',
    afrikaans: 'skrap, kansellasie, vernietiging',
    russian: 'удаление, уничтожение',
    latvian: 'atcelšana, atsaukšana, pārtraukšana, iznīcināšana',
    polish: '',
    french: 'destruction, suppression',
    spanish: 'eliminación, cancelación, destrucción',
  },
  {
    av: 24884,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(forward + reference line [modification, the line has an opening]: the forward arrow is halted at the reference line as by a difficulty passing through the opening) - Character (superimposed - modified)',
    english: 'difficulty',
    swedish: 'svårighet',
    norwegian: 'vanskelighet',
    finnish: 'vaikeus',
    hungarian: 'nehézség, probléma',
    german: 'Schwierigkeit',
    dutch: 'moeilijkheid, moeite',
    afrikaans: 'moeilikheid',
    russian: 'трудность',
    latvian: 'grūtības',
    polish: '',
    french: 'difficulté',
    spanish: 'dificultad',
  },
  {
    av: 24887,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(backward + upward + downward + forward [modification, short arrows]: the four arrows pointing outward from each other, i.e. spreading out) - Character (superimposed - modified)',
    english: 'dispersion, dissemination, scattering, spread, spreading',
    swedish: 'spridning',
    norwegian: 'spredning',
    finnish: 'levitteleminen, levittäminen, hajottaminen',
    hungarian: 'szórás, szétszórás, szétszóródás, elterjedés',
    german: 'Ausbreitung, Verbreitung',
    dutch: 'verspreiding',
    afrikaans: 'versprei, verspreiding, dispersie',
    russian: 'распространение',
    latvian: 'izkliedēšana, izplatīšanās',
    polish: '',
    french: 'dispersion, dissémination, étaler',
    spanish: 'dispersión, diseminación, propagación',
  },
  {
    av: 24889,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'earmuffs (general)',
    swedish: 'öronmuff(ar)',
    norwegian: 'ørevarmer',
    finnish: 'korvaläpät',
    hungarian: 'fülvédő',
    german: 'Ohrenschützer (Kälte)',
    dutch: 'oorverwarmers',
    afrikaans: 'oormowwe',
    russian: 'тёплые наушники',
    latvian: 'ausu sildītājs',
    polish: '',
    french: 'casque (oreilles)',
    spanish: 'orejeras (general)',
  },
  {
    av: 24890,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(forward + reference line [modification, the line has an opening]: the forward arrow easily passing through the broken reference line) - Character (superimposed - modified)',
    english: 'ease, easiness, simplicity',
    swedish: 'enkelhet, lätthet',
    norwegian: 'enkelhet, letthet',
    finnish: 'helppous, yksinkertaisuus',
    hungarian: 'könnyűség, egyszerűség, problémamentesség',
    german: 'Leichtigkeit, Einfachheit, Simplizität',
    dutch: 'gemak, eenvoudig',
    afrikaans: 'maklik, maklikheid, verlig, eenvoud',
    russian: 'простота, лёгкость',
    latvian: 'vieglums, vienkāršība',
    polish: '',
    french: 'facilité, simplicité',
    spanish: 'facilidad, sencillez',
  },
  {
    av: 24891,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(container + jump [modification, higher position]: the curved forward arrow representing content moving out of the container) - Character (superimposed - modified)',
    english: 'emptying, voidance, evacuation',
    swedish: 'tömning',
    norwegian: 'tømming',
    finnish: 'tyhjentäminen',
    hungarian: 'kiürítés, kiüresedés',
    german: 'Entleeren, Leermachen',
    dutch: 'ledigen (zelfst.nw), lediging',
    afrikaans: 'leegmaak, ontruiming',
    russian: 'опорожнение',
    latvian: 'iztukšošana, atbrīvošanās, evakuācija',
    polish: '',
    french: 'évacuation, déversement',
    spanish: 'vacío, evacuación',
  },
  {
    av: 24895,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(being (state of) [modification, high position over the skyline] + sky: imaginary existence up the sky, or up in the clouds) - Character (superimposed - modified)',
    english: 'fantasy, phantasy, imagination, illusion',
    swedish: 'fantasi',
    norwegian: 'fantasi',
    finnish: 'fantasia, mielikuvitus, illuusio',
    hungarian: 'fantázia, illúzió, elképzelés',
    german: 'Fantasie, Fantasterei',
    dutch: 'fantasie, verbeelding, illusie',
    afrikaans: 'fantasie, illusie, verbeelding',
    russian: 'фантазия, воображение, вымысел',
    latvian: 'izdoma, fantāzija, iedoma, ilūzija',
    polish: '',
    french: 'imagination, fantaisie, illusion',
    spanish: 'fantasía, imaginación, ilusión',
  },
  {
    av: 24897,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(container + horizontal line: the container is closed over, as if filled up) - Character (superimposed)',
    english: 'filling, fill, fullness',
    swedish: 'fyllning',
    norwegian: 'fylling, fyll',
    finnish: 'täysinäinen',
    hungarian: 'teltség, telítettség, teljesség',
    german: 'Füllung, Fülle',
    dutch: 'vol',
    afrikaans: 'vul, vulsel, volheid',
    russian: 'заполнение, наполнение',
    latvian: 'pildīt, iepildīt, piepildīt',
    polish: '',
    french: 'remplissage',
    spanish: 'relleno',
  },
  {
    av: 24899,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(konowledge + forward: combination of knowledge and out of) - Character (superimposed)',
    english: 'forgetting, amnesia',
    swedish: 'glömska',
    norwegian: 'glemsel, hukommelsestap',
    finnish: 'unohtaminen, amnesia',
    hungarian: 'felejtés, emlékezethiány, amnézia',
    german: 'Vergessenheit, Erinnerungsverlust, Amnesie',
    dutch: 'amnesie, vergeetachtig',
    afrikaans: 'vergeet, geheueverlies',
    russian: 'забывание, амнезия',
    latvian: 'aizmiršana, amnēzija, neatcerēšanās',
    polish: '',
    french: 'oubli, amnésie',
    spanish: 'olvido, amnesia',
  },
  {
    av: 24903,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(up + container: drawing from what one holds) - Character (superimposed)',
    english: 'giving, gift',
    swedish: 'givande',
    norwegian: 'givning',
    finnish: 'antaminen, tarjoaminen',
    hungarian: 'adás, adományozás, ajándékozás',
    german: 'Vergabe, Bescherung, Geben',
    dutch: 'gift',
    afrikaans: 'geskenk',
    russian: 'дарение, отдавание',
    latvian: 'došana, dāvināšana, dāvana, balva',
    polish: '',
    french: 'don (cadeau)',
    spanish: 'dar',
  },
  {
    av: 24904,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + pictograph, of a matrix grid) - Character (superimposed)',
    english: 'grid, matrix',
    swedish: 'rutnät',
    norwegian: 'rutenett',
    finnish: 'matriisi, taulukko, ruudukko, ristikko',
    hungarian: 'hálózat, négyzetháló, mátrix',
    german: 'Gitter, Rastermuster, Matrix',
    dutch: 'rooster, grid, raster',
    afrikaans: 'rooster, grid',
    russian: 'сетка',
    latvian: 'režģis, matrice, forma ',
    polish: '',
    french: 'grille, matrice',
    spanish: 'matriz',
  },
  {
    av: 24906,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(one (digit), 1 [modification, higher position] + slash (slanted line) + two (digit), 2: a common way to write 1/2) - Character (superimposed - modified)',
    english: 'half, one-half',
    swedish: 'halv, en halv',
    norwegian: 'halv, en halv',
    finnish: '½, puoli',
    hungarian: 'fél',
    german: 'Hälfte, die Hälfte',
    dutch: 'half, helft',
    afrikaans: 'half, een helfte',
    russian: 'половина',
    latvian: 'puse, viena puse, viena daļa',
    polish: '',
    french: 'moitié',
    spanish: 'mitad, un medio',
  },
  {
    av: 24909,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(two horizontal reference lines [half-sized]: the space between the reference lines is the highest possible within the symbol square) See also: lowness, shortness (height) 24918. - Character (superimposed)',
    english: 'height, tallness',
    swedish: 'höjd',
    norwegian: 'høyde',
    finnish: 'korkeus',
    hungarian: 'magasság, nagyság',
    german: 'Höhe, Größe',
    dutch: 'hoogte',
    afrikaans: 'lank (hoogte)',
    russian: 'высота',
    latvian: 'augstums, garums',
    polish: '',
    french: 'hauteur',
    spanish: 'altura',
  },
  {
    av: 24912,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(plus sign (low) + earth, ground, land [half-sized]: ownership, possession [half-sized], something in one's possession without necessarily being owned) - Character (superimposed)",
    english: 'holding',
    swedish: 'innehav',
    norwegian: 'eie',
    finnish: 'hallussa pitäminen',
    hungarian: 'vagyon',
    german: 'Besitz',
    dutch: 'bezit',
    afrikaans: 'hou, besit',
    russian: 'обладание, владение',
    latvian: 'turēšana',
    polish: '',
    french: 'possession, avoir (sur terre)',
    spanish: 'tenencia',
  },
  {
    av: 24913,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(interest [modification, intensity moved to the left to make room for another one] + intensity: of intense interest) - Character (superimposed - modified)',
    english: 'importance, significance',
    swedish: 'viktighet',
    norwegian: 'viktighet, betydelighet',
    finnish: 'tärkeys',
    hungarian: 'jelentőség, fontosság',
    german: 'Bedeutung, Wichtigkeit',
    dutch: 'belangrijk',
    afrikaans: 'belangrikheid',
    russian: 'важность',
    latvian: 'svarīgums, nozīmīgums',
    polish: '',
    french: 'importance',
    spanish: 'importancia, significativo',
  },
  {
    av: 24916,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(mind + intensity: engaging the mind) - Character (superimposed)',
    english: 'interest',
    swedish: 'intresse',
    norwegian: 'interesse',
    finnish: 'mielenkiinto, kiinnostavuus',
    hungarian: 'érdeklődés',
    german: 'Interesse',
    dutch: 'interesse',
    afrikaans: 'belangstelling',
    russian: 'интерес',
    latvian: 'interese, procenti',
    polish: '',
    french: 'intérêt',
    spanish: 'interés',
  },
  {
    av: 24917,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vertical line [half-sized] bounded by two horizontal reference lines [half-sized]: the vertical line is relatively little) See also: bigness, largeness 24875. - Character (superimposed)',
    english: 'littleness, smallness',
    swedish: 'litenhet',
    norwegian: 'litenhet',
    finnish: 'pienuus',
    hungarian: 'kicsiség, apróság, kicsinység',
    german: 'Kleinheit',
    dutch: 'kleinheid',
    afrikaans: 'klein',
    russian: 'малость',
    latvian: 'mazums, niecīgums',
    polish: '',
    french: 'petitesse (hauteur)',
    spanish: 'pequeñez',
  },
  {
    av: 24918,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(two horizontal reference lines [half-sized]: the space between the reference lines is relatively low) See also: height, tallness 24909. - Character (superimposed)',
    english: 'lowness, shortness (height)',
    swedish: 'låghet',
    norwegian: 'lavhet',
    finnish: 'mataluus',
    hungarian: 'alacsonyság, rövidség (magasságban)',
    german: 'Tiefe, Niedrigkeit',
    dutch: 'laagte',
    afrikaans: 'laagte, kortheid (hoogte)',
    russian: 'низость',
    latvian: 'zemums, īsums',
    polish: '',
    french: 'faible élévation, faible hauteur',
    spanish: 'bajo, corto (altura)',
  },
  {
    av: 24920,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(symbol suggests a modified caduceus (modeled after the staff with a snake - of Hermes), the traditional medical symbol) - Character',
    english: 'medicine, medical practice',
    swedish: 'läkekonst',
    norwegian: 'legekunst',
    finnish: 'lääketiede',
    hungarian: 'orvoslás, gyógyászat, orvosi rendelés/gyakorlat',
    german: 'Medizin, Heilkunde',
    dutch: 'medicijn, geneesmiddel',
    afrikaans: 'medisinale, mediese praktyk',
    russian: 'медицина, медицинская практика',
    latvian: 'medicīna, medicīnas prakse',
    polish: '',
    french: 'médecine, pratique médicale',
    spanish: 'medicina, práctica médica',
  },
  {
    av: 24925,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(addition + earth: CKB writes 'an addition, a gain, a plus of some very earthly (material) thing') - Character (superimposed)",
    english: 'ownership, possession',
    swedish: 'ägande',
    norwegian: 'eiendom',
    finnish: 'omistaminen',
    hungarian: 'tulajdonlás, tulajdonjog, birtoklás, birtokban levés',
    german: 'Besitz',
    dutch: 'bezitting, eigendom',
    afrikaans: 'eienaarskap, besitting',
    russian: 'собственность, владение',
    latvian: 'īpašums',
    polish: '',
    french: 'possession',
    spanish: 'posesión',
  },
  {
    av: 24926,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + through: CKB says that the symbol represents a thought that is allowed to pass through a mental barrier) - Character (superimposed)',
    english: 'permission, allowance',
    swedish: 'tillåtelse',
    norwegian: 'tillatelse',
    finnish: 'antaminen, salliminen',
    hungarian: 'engedély, megengedés',
    german: 'Genehmigung, Erlaubnis',
    dutch: 'toelating',
    afrikaans: 'toestemming, vergunning',
    russian: 'разрешение, позволение',
    latvian: 'atļauja, atlaide',
    polish: '',
    french: 'permission, autorisation',
    spanish: 'permiso',
  },
  {
    av: 24927,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(leadership + agreement [modification, short arrows] (combination): leadership to agreement) - Character (superimposed - modified - combined)',
    english: 'persuasion',
    swedish: 'övertygande',
    norwegian: 'overbevisning',
    finnish: 'vakuuttaminen',
    hungarian: 'meggyőzés, rábeszélés',
    german: 'Überzeugung',
    dutch: 'overtuiging, overreding',
    afrikaans: 'oortuiging',
    russian: 'убеждение, уговаривание',
    latvian: 'pierunāšana',
    polish: '',
    french: 'persuasion',
    spanish: 'persuasión',
  },
  {
    av: 24932,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(one (digit), 1 [modification, higher position] + slash (slanted line) + four (digit), 4: a common way to write 1/4) - Character (superimposed - modified)',
    english: 'quarter, one quarter',
    swedish: 'kvart, fjärdedel',
    norwegian: 'kvart, en fjerdedel',
    finnish: 'neljäsosa',
    hungarian: 'negyed, egynegyed',
    german: 'Viertel, ein Viertel',
    dutch: 'kwart',
    afrikaans: 'kwart',
    russian: 'четверть',
    latvian: 'ceturksnies, viens ceturksnis',
    polish: '',
    french: 'quart, un quart',
    spanish: 'cuarto, una cuarta parte',
  },
  {
    av: 24934,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(line, stripe + line, stripe + action indicator: the vertical line is repeated) - Character (sequenced)',
    english: 'repetition, copying, duplication, replication',
    swedish: 'upprepning',
    norwegian: 'repetisjon, kopiering',
    finnish: 'toistaminen, kopioiminen, monistaminen',
    hungarian: 'ismétlés, másolás, duplikáció, replikáció',
    german: 'Wiederholung',
    dutch: 'herhaling',
    afrikaans: 'herhaling',
    russian: 'повторение, дублирование, копирование',
    latvian: 'atkārtošana, kopēšana, dublēšana, reproducēšana',
    polish: '',
    french: 'répétition, copie, duplication',
    spanish: 'repetición, copiado, duplicación',
  },
  {
    av: 24937,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(mind + self: thinking only about oneself) - Character (superimposed)',
    english: 'selfishness, egoism',
    swedish: 'egoism, själviskhet',
    norwegian: 'egoisme, selvgodhet',
    finnish: 'itsekkyys',
    hungarian: 'önzés, egoizmus',
    german: 'Selbstzucht, Egoismus',
    dutch: 'egoïsme',
    afrikaans: 'selfsugtigheid, egoïsme',
    russian: 'эгоизм, себялюбие',
    latvian: 'savtība, egoisms',
    polish: '',
    french: 'égoïsme, égocentrisme, narcissisme',
    spanish: 'egoísmo',
  },
  {
    av: 24938,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(horizontal line [half-sized] bounded by reference lines [half-sized]: horizontal line is relatively short) See also: length, longness 15193. - Character',
    english: 'shortness (distance, length)',
    swedish: 'korthet',
    norwegian: 'korthet',
    finnish: 'lyhyys',
    hungarian: 'közelség, rövidség',
    german: 'Kürze',
    dutch: 'kortheid',
    afrikaans: 'kortheid',
    russian: 'краткость',
    latvian: 'īsums (distances attālums)',
    polish: '',
    french: 'petitesse (longueur)',
    spanish: 'brevedad',
  },
  {
    av: 24940,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water, fluid, liquid + a cluster of seven dots: a liquid transformed into a spray of small drops) - Character (superimposed - sequenced)',
    english: 'spray, vaporization',
    swedish: 'sprej',
    norwegian: 'spray',
    finnish: 'spreijaus, haihtuminen ',
    hungarian: 'permet',
    german: 'Spray',
    dutch: 'spray, verdamping',
    afrikaans: 'spuit, sproei, sprei',
    russian: 'спрей, вапоризация',
    latvian: 'izsmidzināšana',
    polish: '',
    french: 'vaporisation, spray',
    spanish: 'rocío, vaporización',
  },
  {
    av: 24941,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(combination of health and muscle: symbol suggests the outline of a person, arm bent, biceps flexed, showing strength) - Character (superimposed)',
    english: 'strength',
    swedish: 'styrka, muskelkraft',
    norwegian: 'styrke, muskelstyrke, muskelkraft',
    finnish: 'vahvuus, voimakkuus',
    hungarian: 'erő (fizikai)',
    german: 'Stärke, Kraft, Dauerhaftigkeit',
    dutch: 'spierkracht, sterk (spier)',
    afrikaans: 'sterkte, krag',
    russian: 'сила, мышечная сила',
    latvian: 'spēks, stiprums',
    polish: '',
    french: 'force',
    spanish: 'fortaleza',
  },
  {
    av: 24944,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(horizontal reference line [modification, half-sized on skyline] + much, many, very [modification, higher position]: much, many on the highest level) - Character (superimposed - modified)',
    english: 'superlative most',
    swedish: 'mest (för komparation av adj.)',
    norwegian: 'mest (superlativ)',
    finnish: 'superlatiivi',
    hungarian: 'legtöbb',
    german: 'am meisten',
    dutch: 'meest',
    afrikaans: 'meeste (oortreffende)',
    russian: 'ниболее (превосх.ст.прил.)',
    latvian: 'visvairāk (vispārākā pakāpe)',
    polish: '',
    french: 'le plus (subst.)',
    spanish: 'superlativo, el mejor',
  },
  {
    av: 24949,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(eye + open: state one is in when one's eyes are open) - Character (superimposed)",
    english: 'wakefulness, alertness',
    swedish: 'vakenhet',
    norwegian: 'våkenhet',
    finnish: 'valvominen',
    hungarian: 'éberség, óvatosság',
    german: 'Wachsamkeit, Wachheit',
    dutch: 'alert',
    afrikaans: 'bewus maak, waaksaamheid',
    russian: 'настороженность, бдительность',
    latvian: 'modrība, izmanība, veiklība',
    polish: '',
    french: 'éveil, vigilance',
    spanish: 'estado de alerta',
  },
  {
    av: 24961,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + to speak: emotional talk) - Character (superimposed)',
    english: 'slang',
    swedish: 'slang (språk)',
    norwegian: 'slang (språk)',
    finnish: 'slangi',
    hungarian: 'szleng',
    german: 'Slang, Jargong (Sprache)',
    dutch: 'dialect',
    afrikaans: 'slang dialek',
    russian: 'сленг',
    latvian: 'slengs, žargons',
    polish: '',
    french: 'argot',
    spanish: 'argot',
  },
  {
    av: 24962,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(knife + to speak: sharp talk) - Character (superimposed)',
    english: 'coarse slang',
    swedish: 'svordom, grov slang',
    norwegian: 'banning, sverging',
    finnish: 'ruman kielen käyttö, kiroilu',
    hungarian: 'trágárság, gorombaság, durva szleng',
    german: 'Fluch, grober Slang',
    dutch: 'dialect (gemeen)',
    afrikaans: 'growwe slang dialek',
    russian: 'ругательство, грубый сленг',
    latvian: 'rupjš, vulgārs žargons',
    polish: '',
    french: 'grossièreté, gros mot, obscénité',
    spanish: 'ordinario (argot)',
  },
  {
    av: 25011,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(A (uppercase) + B (uppercase) + C (uppercase): first three letters of the English alphabet, representing the entire alphabet) - Character (superimposed)',
    english: 'alphabet, letters (uppercase)',
    swedish: 'alfabetet (versaler)',
    norwegian: 'alfabetet (store), bokstaver (store)',
    finnish: 'aakkoset (isoja), kirjaimet (isoja)',
    hungarian: 'ábécé (nagybetűs)',
    german: 'Alphabet, Buchstabe, Schriftzeichen (Großbuchstaben)',
    dutch: 'alfabet, letters (hoofdletters)',
    afrikaans: 'alfabet letters (hoofletters)',
    russian: 'алфавит, буквы (заглавные буквы)',
    latvian: 'alfabēts, burti (lielie burti)',
    polish: 'alfabet, litery (wielkie)',
    french: 'alphabet, lettres (majuscules)',
    spanish: 'alfabeto, letras (mayúsculas)',
  },
  {
    av: 25070,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + down [modification, short arrow]) - Character (superimposed - modified)',
    english: 'gravity, gravitation',
    swedish: 'tyngdkraft, gravitation',
    norwegian: 'tyngdekraft, gravitasjon',
    finnish: 'painovoima',
    hungarian: '',
    german: 'Anziehungskraft, Gravitation',
    dutch: 'zwaartekracht',
    afrikaans: 'swaartekrag, aantrekkingskrag',
    russian: 'гравитация',
    latvian: 'gravitācija, zemes pievilkšanas spēks',
    polish: '',
    french: '',
    spanish: 'gravedad',
  },
  {
    av: 25119,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(wheel + earth [half-sized]: the wheel moves by rolling over the ground) - Character (superimposed)',
    english: 'move, movement',
    swedish: 'förflyttning',
    norwegian: 'forflytning, bevegelse',
    finnish: 'matka',
    hungarian: '',
    german: 'Bewegung',
    dutch: 'beweging, verplaatsing',
    afrikaans: 'beweeg, beweeging',
    russian: 'движение, передвижение',
    latvian: 'kustība',
    polish: '',
    french: '',
    spanish: 'movimiento',
  },
  {
    av: 25132,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + enclosure: feeling of being confined) - Character (superimposed)',
    english: 'oppression, captivity, slavery',
    swedish: 'ofrihet, fångenskap, förtryck',
    norwegian: 'ufrihet, fangenskap, undertrykkelse',
    finnish: 'sortaminen, orjuuttaminen, orjuutus',
    hungarian: '',
    german: 'Unterdrückung, Gefangenschaft, Sklaverei',
    dutch: 'slavernij, gevangenschap, onderdrukking',
    afrikaans: 'onderdrukking, ballingskap, slawerny',
    russian: 'неволя, угнетение',
    latvian: 'apspiešana, ieslodzījums, verdzība',
    polish: '',
    french: '',
    spanish: 'opresión, cautiverio, esclavitud',
  },
  {
    av: 25133,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(enclosure + backward) - Character (superimposed)',
    english: 'out of (backward)',
    swedish: 'ut ur (bakåt)',
    norwegian: 'ut av (bakover)',
    finnish: 'ulos (taaksepäin), pois jostakin taaksepäin',
    hungarian: '',
    german: 'aus (rückwärts)',
    dutch: 'uit (achterwaarts), uitgang (achterwaarts), eruit (achterwaarts)',
    afrikaans: 'uit buite (agteruit)',
    russian: 'из (назад)',
    latvian: 'ārā, uz āru, atpakaļ',
    polish: '',
    french: '',
    spanish: 'fuera de (hacia atrás), salida (hacia atrás)',
  },
  {
    av: 25134,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(enclosure + upward) - Character (superimposed)',
    english: 'out of (upward)',
    swedish: 'ut ur (uppåt)',
    norwegian: 'ut av (oppover)',
    finnish: 'ulos (ylöspäin), pois jostakin ylöspäin',
    hungarian: '',
    german: 'aus (aufwärts)',
    dutch: 'uit (opwaarts), uitgang (opwaarts), eruit (opwaarts)',
    afrikaans: 'uit buite (opwaartse)',
    russian: 'из (снизу вверх)',
    latvian: 'ārā, augšup',
    polish: '',
    french: '',
    spanish: 'fuera de (hacia arriba), salida (hacia arriba)',
  },
  {
    av: 25267,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(bird + pictograph of claws) - Character (superimposed)',
    english: 'bird of prey, raptor, falcon, hawk, eagle',
    swedish: 'rovfågel',
    norwegian: 'rovfugl',
    finnish: 'petolintu',
    hungarian: '',
    german: 'Raubvogel',
    dutch: 'roofvogel',
    afrikaans: 'roofvoël',
    russian: 'хищная птица',
    latvian: 'plēsējputns',
    polish: '',
    french: '',
    spanish: 'ave de rapiña',
  },
  {
    av: 25290,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pointer (left) + electricity + pointer (right): suggesting the field of force surrounding an electrically charged particle or varying magnetic field) - Character (superimposed - pointer)',
    english: 'electric field',
    swedish: 'elektriskt fält',
    norwegian: 'elektrisk felt',
    finnish: 'sähkökenttä',
    hungarian: '',
    german: 'elektrisches Feld, Kraftfeld',
    dutch: 'elektrisch veld',
    afrikaans: 'elektriese veld',
    russian: 'электрическое поле',
    latvian: 'elektriskais lauks',
    polish: '',
    french: '',
    spanish: 'campo eléctrico',
  },
  {
    av: 25311,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      "(thing + pointer: pointer pointing to the left on the 'front' right-hand side of the thing) - Character (superimposed - pointer)",
    english: 'front, front of a thing',
    swedish: 'framsida, framdel, front, främre del',
    norwegian: 'front (i), foran',
    finnish: 'esineen edessä',
    hungarian: '',
    german: 'Vorderseite, vorderer Teil',
    dutch: 'voorkant',
    afrikaans: 'voorkant, voor',
    russian: 'спереди, перед',
    latvian: 'priekšpuse, priekša, frontālā puse',
    polish: '',
    french: '',
    spanish: 'frente (general)',
  },
  {
    av: 25339,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pointer (left) + magnetism + pointer (right): suggesting the lines of force surrounding a permanent magnet or a moving charged particle) - Character (superimposed - pointer)',
    english: 'magnetic field',
    swedish: 'magnetfält',
    norwegian: 'magnetisk felt',
    finnish: 'magneettikenttä',
    hungarian: '',
    german: 'Magnetfeld',
    dutch: 'magnetisch veld',
    afrikaans: 'magnetiese veld',
    russian: 'магнитное поле',
    latvian: 'magnētiskais lauks',
    polish: '',
    french: '',
    spanish: 'campo magnético',
  },
  {
    av: 25340,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(metal bar + pictorgraph of lines of flux) - Character (superimposed)',
    english: 'magnetism',
    swedish: 'magnetism',
    norwegian: 'magnetisme',
    finnish: 'magnetismi',
    hungarian: '',
    german: 'Magnetismus',
    dutch: 'magnetisme',
    afrikaans: 'magnetisme',
    russian: 'магнетизм',
    latvian: 'magnētisms',
    polish: '',
    french: '',
    spanish: 'magnetismo',
  },
  {
    av: 25362,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: suggesting the rotor blades of a propeller) - Character',
    english: 'propeller, rotor (blades)',
    swedish: 'propeller, rotorblad',
    norwegian: 'propell, rotor',
    finnish: 'propelli, potkuri',
    hungarian: '',
    german: 'Propeller, Rotorblatt',
    dutch: 'rotor, schroefbladen',
    afrikaans: 'skroef (skroefblad)',
    russian: 'пропеллер, лопасти ротора',
    latvian: 'propellers. helikoptera propellers',
    polish: '',
    french: '',
    spanish: 'hélice',
  },
  {
    av: 25364,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      "(pointer + thing: pointer pointing to the right on the 'back' left-hand side of the thing) - Character (superimposed - pointer)",
    english: 'rear, back of a thing',
    swedish: 'baksida, bakdel, bakre del ',
    norwegian: 'bak, bakside',
    finnish: 'esineen takana',
    hungarian: '',
    german: 'Hinterseite, hinterer Teil',
    dutch: 'achterkant',
    afrikaans: 'agterkant (van `n ding)',
    russian: 'сзади, позади',
    latvian: 'aizmugure, gals (lietas)',
    polish: '',
    french: '',
    spanish: 'trasero, parte de atrás',
  },
  {
    av: 25379,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + being (state of): what you think exists) - Character (superimposed)',
    english: 'state of mind',
    swedish: 'sinnestillstånd',
    norwegian: 'sinnstilstand ',
    finnish: 'mielentila',
    hungarian: '',
    german: 'Geisteszustand ',
    dutch: 'gemoedstoestand, geestestoestand',
    afrikaans: 'gemoedstoestand',
    russian: 'состояние разума',
    latvian: 'garastāvoklis',
    polish: '',
    french: '',
    spanish: 'estado de la mente',
  },
  {
    av: 25387,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      "(pointer + thing: pointer pointing down on the 'top' of the thing) - Character (superimposed - pointer)",
    english: 'top, top of a thing',
    swedish: 'ovansida, överdel, övre del',
    norwegian: 'overside, overdel',
    finnish: 'esineen päällä',
    hungarian: '',
    german: 'oben, Oberseite',
    dutch: 'bovenkant, top (ding)',
    afrikaans: 'bokant',
    russian: 'верх, сверху',
    latvian: 'virsa, virsotne, gals (lietas)',
    polish: '',
    french: '',
    spanish: 'parte superior ',
  },
  {
    av: 25396,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vertical line + electricity + vertical line: a combination of limit(s) and electricity) - Character (sequenced)',
    english: 'voltage',
    swedish: 'elektrisk spänning',
    norwegian: 'spenning',
    finnish: 'jännite',
    hungarian: '',
    german: 'Spannung (Elektrizität)',
    dutch: 'voltage',
    afrikaans: 'stroomspanning',
    russian: 'электрическое напряжение',
    latvian: 'voltāža',
    polish: '',
    french: '',
    spanish: 'voltaje',
  },
  {
    av: 25401,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(upward and forward + downward and backward) - Character (superimposed)',
    english: 'ascending and descending',
    swedish: 'start och landning, upp- och nedgående',
    norwegian: 'oppad og nedadgående',
    finnish: 'nousu ja lasku',
    hungarian: '',
    german: 'aufsteigend und absteigend',
    dutch: 'stijgen en dalen',
    afrikaans: 'opstyg en neerdaal',
    russian: 'взлёт и посадка, восхождение и ниспадение',
    latvian: 'pacelšanās un nolaišanās, uzkāpšana un nokāpsāna',
    polish: '',
    french: '',
    spanish: 'ascenso y descenso',
  },
  {
    av: 25406,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(two-headed curved arrow suggests swinging motion) - Character',
    english: 'swing, swinging',
    swedish: 'svängning, gungning',
    norwegian: 'sving, svinging, gynging',
    finnish: 'keinuminen',
    hungarian: '',
    german: 'Schwingen, Schwung, Schaukel',
    dutch: 'slinger, zwaai',
    afrikaans: 'swaai',
    russian: 'качание, колебание',
    latvian: 'šūpošanās',
    polish: '',
    french: '',
    spanish: 'balanceo',
  },
  {
    av: 25408,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      "(pointer + thing: pointer pointing up on the 'bottom' of the thing) - Character (superimposed - pointer)",
    english: 'bottom, bottom of a thing',
    swedish: 'undersida, underdel, botten, undre del',
    norwegian: 'bunn, bunnen av en ting',
    finnish: 'esineen pohja',
    hungarian: '',
    german: 'Boden, Unterteil, Bodensatz',
    dutch: 'onderkant, bodem',
    afrikaans: 'onderkant',
    russian: 'низ, нижняя часть, дно',
    latvian: 'apakša, lejasdaļa (lietas)',
    polish: '',
    french: '',
    spanish: 'fondo',
  },
  {
    av: 25434,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + electricity: the electrical impulses of the brain (and CNS)) - Character (superimposed)',
    english: 'brain signal',
    swedish: 'signal (hjärna)',
    norwegian: 'signal (hjerne)',
    finnish: 'aivosignaali',
    hungarian: '',
    german: 'Gehirnsignal, Signal an das/vom Gehirn',
    dutch: 'hersensignaal',
    afrikaans: 'brein sein',
    russian: 'сигнал мозга',
    latvian: 'smadzeņu signāls',
    polish: '',
    french: '',
    spanish: 'señal cerebral',
  },
  {
    av: 25480,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(body [modification, half vertical size] + dot: a reduced body with a dot inside that represents an inner organ) - Character (superimposed - modified) Preferred NEW SYNONYM, replacing 24202',
    english: 'organ, inner organ, inner body part',
    swedish: 'organ, inre organ',
    norwegian: 'organ indre',
    finnish: 'sisäelin',
    hungarian: '',
    german: 'Organ, inneres Organ',
    dutch: 'orgaan, inwendig orgaan',
    afrikaans: 'orgaan, innerlike deel van die liggaam',
    russian: 'внутренний орган, орган',
    latvian: 'iekšējie orgāni, orgāns',
    polish: '',
    french: '',
    spanish: 'órgano (cuerpo)',
  },
  {
    av: 25520,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(dot + evaluation, value (half-sized): evaluation beforehand of one’s potential to do something - half sized, used in can, be able-(to)) - Character (sequenced)',
    english: 'ability (half sized)',
    swedish: 'förmåga (halv storlek), kunnande',
    norwegian: 'evne (halv størrelse), dyktighet',
    finnish: '',
    hungarian: '',
    german: 'Fähigkeit (halbe Größe), Können',
    dutch: 'mogelijkheid (halve grootte)',
    afrikaans: 'vermoë (half grootte)',
    russian: 'умение',
    latvian: 'varēšana, spējas (nelielas)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25521,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + raised wavy line: pictographof an animal with a wavy line in high position as tail, used for representing animals with a bushy tail, e.g. a squirrel) - Character (superimposed)',
    english: 'animal (bushy tailed)',
    swedish: 'djur (med yvig svans)',
    norwegian: 'dyr (med lodden hale)',
    finnish: '',
    hungarian: '',
    german: 'Tier (mit buschigem Schwanz)',
    dutch: 'dier (harige staart)',
    afrikaans: 'dier (bossige stert)',
    russian: 'животное (пушистый хвост)',
    latvian: 'dzīvnieks (ar kuplu asti)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25522,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(reference line [half-sized] + three connecting dots + arrowhead: full square between reference line and arrowhead emphasizes distance. This symbol is a simplified form of departure.) - Character (sequenced) Preferred NEW SYNONYM, replacing 12602',
    english: 'away, at a distance, off',
    swedish: 'iväg, bort',
    norwegian: 'bort, bort fra, på avstand',
    finnish: 'pois, poissa',
    hungarian: 'el-, tól, től (távolságra valamitől)',
    german: ' entfernt, weg, fort, ab, davon, in einer Entfernung von',
    dutch: 'van, vanuit, weg, weg van',
    afrikaans: "weg, ver, op 'n afstand, 'n afstand van",
    russian: 'вдали, прочь',
    latvian: 'prom, atstatus',
    polish: 'daleko, w odległości, odległość',
    french: 'loin, au loin',
    spanish: 'lejos, a la distancia',
  },
  {
    av: 25523,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(conscience + minus, no, without: conscience in a negative state) - Character (superimposed)',
    english: 'bad conscience',
    swedish: 'samvete (dåligt), dåligt samvete',
    norwegian: 'dårlig samvittighet',
    finnish: '',
    hungarian: '',
    german: 'schlechtes Gewissen',
    dutch: 'slecht geweten',
    afrikaans: 'slegte gewete',
    russian: 'нечистая совесть',
    latvian: 'netīra sirdsapziņa',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25524,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(ball + earth, ground, land) - Character (superimposed)',
    english: 'ball field',
    swedish: 'bollplan',
    norwegian: 'ballplass',
    finnish: '',
    hungarian: '',
    german: 'Spielfeld, Ballspielfeld',
    dutch: 'ballenveld',
    afrikaans: 'bal veld',
    russian: 'мяч для поля',
    latvian: 'spēļu laukums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25525,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(chemical product + life [modification] (combination): chemical substances that constitute biological processes) - Character (superimposed - modified - combined)',
    english: 'biochemical product, organic compound',
    swedish: 'biokemisk produkt, organisk förening',
    norwegian: 'biokjemisk produkt, organisk forbindelse',
    finnish: '',
    hungarian: '',
    german: 'biochemisches Produkt, organische Verbindung ',
    dutch: 'biochemisch product (organisch)',
    afrikaans: 'biochemiese produk, organiese verbinding',
    russian: 'биохимический продукт, органическое соединение',
    latvian: 'bioķīmisks produkts, organisks savienojums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25526,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(eye + deletion, cancellation, destruction: for destroyed vision and lack of sight) - Character (superimposed)',
    english: 'blindness',
    swedish: 'blindhet',
    norwegian: 'blindhet',
    finnish: '',
    hungarian: '',
    german: 'Blindheit',
    dutch: 'blind',
    afrikaans: 'blindheid',
    russian: 'слепота',
    latvian: 'aklums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25527,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(shore + forward: going forward from shore to water) - Character (superimposed)',
    english: 'boarding, embarkation (to sea)',
    swedish: 'ombordstigning (till sjöss)',
    norwegian: 'ombordstiging (til sjøs)',
    finnish: '',
    hungarian: '',
    german: 'Anbordgehen, Einschiffen, Einschiffung',
    dutch: 'ontscheping',
    afrikaans: 'uitvaar (see)',
    russian: 'посадка на рейс (в море)',
    latvian: 'iekāpšana (jūras transportā)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25528,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(bone + bone [modification, horiontal]: indicating the junction where bones meet) - Character (superimposed - sequenced - modified)',
    english: 'bones with joint',
    swedish: 'ben med led',
    norwegian: 'bein med ledd',
    finnish: '',
    hungarian: '',
    german: 'Gebeine (Knochen) mit Gelenk',
    dutch: 'beenderen met gewricht',
    afrikaans: 'bene met gesamentlike gewrig',
    russian: 'соединение костей, кости с суставом',
    latvian: 'kauli ar locītavu',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25529,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(bottle + pointer, to neck or opening) - Character (superimposed - pointer)',
    english: 'bottleneck, bottle opening',
    swedish: 'flaskhals, flasköppning ',
    norwegian: 'flaskehals, flaskeåpning',
    finnish: '',
    hungarian: '',
    german: 'Flaschenhals, Flaschenöffnung',
    dutch: 'flesopening',
    afrikaans: 'bottelnek, bottel opening',
    russian: 'бутылочное горлышко',
    latvian: 'pudeles kakls',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25530,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(bread + pointer, down to top of bread + pointer, up to bottom of bread) - Character (superimposed - pointer)',
    english: 'bread surface',
    swedish: 'brödyta',
    norwegian: 'brødskorpe',
    finnish: '',
    hungarian: '',
    german: 'Brotoberfläche',
    dutch: 'broodkruim',
    afrikaans: 'brood oppervlak',
    russian: 'хлебная корка',
    latvian: 'maizes garoza',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25531,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(standing person + pointer, to the right to buttocks + pointer, to the left to genitals) - Character (superimposed - pointer)',
    english: 'buttocks and genitals',
    swedish: 'stjärt och könsorgan',
    norwegian: 'rumpe og kjønnsorgan',
    finnish: '',
    hungarian: '',
    german: 'Hintern (Po) und Geschlechtsorgane',
    dutch: 'onderlichaam en genitaliën',
    afrikaans: 'boude en geslagsdele/geslagsorgane',
    russian: 'ягодицы и гениталии',
    latvian: 'dibens un ģenitālijas',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25532,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure + thing: a crust or shell surrounds the thing) - Character (superimposed)',
    english: 'case, casing',
    swedish: 'fodral, ask, skrin',
    norwegian: 'etui, futteral, kasse, eske',
    finnish: '',
    hungarian: '',
    german: 'Gehäuse, Kasten, Etui, Hülle',
    dutch: 'omhulsel, kist',
    afrikaans: 'omhulsel',
    russian: 'чехол, футляр',
    latvian: 'futlāris, kaste',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25533,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pointer (left) + ice + pointer (right): suggesting the spreading of cold from something cold like ice) - Character (superimposed - pointer)',
    english: 'coldness, cold',
    swedish: 'kyla',
    norwegian: 'kulde',
    finnish: '',
    hungarian: '',
    german: 'Kälte, kalt',
    dutch: 'koude (zelfst nw)',
    afrikaans: 'koud, koue',
    russian: 'холод, мороз',
    latvian: 'aukstums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25534,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(forward + thing + backward: squeezing a thing by pressure from two directions) - Character (superimposed)',
    english: 'compression, compressing, squeezing',
    swedish: 'tryck, press, kompression, komprimering',
    norwegian: 'trykk, press, kompresjon, komprimering',
    finnish: '',
    hungarian: '',
    german: 'Zusammendrückung, Komprimierung. Pressen. Quetschen',
    dutch: 'platgedrukt, compressie',
    afrikaans: 'kompressie, druk',
    russian: 'сжатие, сдавливание',
    latvian: 'kompresija, saspiešana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25535,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(container [modification, high position, under the skyline]) - Character (modified)',
    english: 'container, basket (high)',
    swedish: 'behållare (högt läge)',
    norwegian: 'basketkurv, beholder (høy plassering)',
    finnish: '',
    hungarian: '',
    german: 'Behälter, Container (hohe Position/Lage)',
    dutch: 'mand (hoog)',
    afrikaans: 'houer, mandjie (hoog)',
    russian: 'ёмкость (высокая позиция)',
    latvian: 'konteineris, grozs (augstu)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25536,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(container [modification, low position, under the earthline]) - Character (modified)',
    english: 'container (low)',
    swedish: 'behållare (lågt läge)',
    norwegian: 'beholder (under jordlinjen)',
    finnish: '',
    hungarian: '',
    german: 'Behälter, Container (niedrige Position/Lage)',
    dutch: 'mand (laag)',
    afrikaans: 'houer, mandjie (laag)',
    russian: 'ёмкость (низкая позиция)',
    latvian: 'konteineris (pie zemes)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25537,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(square (oblique) + pointer to the right corner) - Character (superimposed - pointer)',
    english: 'corner',
    swedish: 'hörn',
    norwegian: 'hjørne',
    finnish: '',
    hungarian: '',
    german: 'Ecke',
    dutch: 'hoek',
    afrikaans: 'hoek',
    russian: 'угол',
    latvian: 'stūris, kakts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25538,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(mind + plus) - Character (superimposed)',
    english: 'correct thinking',
    swedish: 'korrekt tänkande',
    norwegian: 'tenkning riktig, korrekt, riktig, korrekt tenkning, ',
    finnish: '',
    hungarian: '',
    german: 'Korrektes Denken',
    dutch: 'juiste gedachte',
    afrikaans: 'positiewe denke',
    russian: 'правильное мышление',
    latvian: 'pareiza domāšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25539,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(mind + minus) - Character (superimposed)',
    english: 'incorrect thinking',
    swedish: 'felaktigt tänkande',
    norwegian: 'tenkning uriktig, ukorrekt, uriktig, ukorrekt tenkning, ',
    finnish: '',
    hungarian: '',
    german: 'inkorrektes Denken',
    dutch: 'foute gedachte',
    afrikaans: 'negatiewe denke',
    russian: 'неправильное мышление',
    latvian: 'nepareiza domāšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25540,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(woman + woman) - Character (superimposed)',
    english: 'couple (female)',
    swedish: 'par (kvinnligt)',
    norwegian: 'par (hunkjønn)',
    finnish: '',
    hungarian: '',
    german: 'Paar (weiblich)',
    dutch: 'koppel (vrouwelijk), paar (vrouwelijk)',
    afrikaans: 'egpaar (vroulik)',
    russian: 'пара (женская)',
    latvian: 'pāris (sieviešu)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25541,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(man + man) - Character (superimposed)',
    english: 'couple (male)',
    swedish: 'par (manligt)',
    norwegian: 'par (hankjønn)',
    finnish: '',
    hungarian: '',
    german: 'Paar (männlich)',
    dutch: 'koppel (mannelijk), paar (mannelijk)',
    afrikaans: 'egpaar (manlik)',
    russian: 'пара (мужская)',
    latvian: 'pāris (vīriešu)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25543,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(ear + deletion, cancellation, destruction: representing destroyed hearing, lack of hearing - Character (superimposed)',
    english: 'deafness',
    swedish: 'dövhet',
    norwegian: 'døvhet',
    finnish: '',
    hungarian: '',
    german: 'Taubheit',
    dutch: 'doof',
    afrikaans: 'doofheid',
    russian: 'глухота',
    latvian: 'kurlums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25544,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(shore + backward, back: going back to shore from water) - Character (superimposed)',
    english: 'debarkation, disembarkation (ashore)',
    swedish: 'ilandstigning',
    norwegian: 'ilandstiging',
    finnish: '',
    hungarian: '',
    german: 'Ausschiffung, Landung',
    dutch: 'ontscheping (wal)',
    afrikaans: 'aanlanding, ontskeping (aan land)',
    russian: 'высадка (на берег)',
    latvian: 'izsēšanās (krastā)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25545,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(forward + arrow, high position pointing backward + arrow, low position pointing backward: one arrow is 'frustrated' in its efforts to penetrate the opposition of the other two) - Character (superimposed - sequenced)",
    english: 'adversity, hardship, setback',
    swedish: 'motgång, bakslag, prövning',
    norwegian: 'utfordring, motgang, prøvelse',
    finnish: '',
    hungarian: '',
    german: 'Elend, Missgechick, Not, Bedrängnis, Rückschlag',
    dutch: 'tegenspoed, tegenslag',
    afrikaans: 'teenspoed, swaarkry, terugslag',
    russian: 'невзгода, неудача, испытание',
    latvian: 'grūtība, neveiksme, šķērslis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25546,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vertical line + vertical line + pointer: the pointer points downward to the bottom of a relatively deep space) See also shallowness 25606 - Character (superimposed - pointer)',
    english: 'depth',
    swedish: 'djup',
    norwegian: 'dyp, dybde',
    finnish: '',
    hungarian: '',
    german: 'Tiefe',
    dutch: 'diepte',
    afrikaans: 'diepte',
    russian: 'глубина',
    latvian: 'dziļums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25547,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(conception + to cancel: cancelled pregnancy due to the natural death of an embryo) - Character (superimposed)',
    english: 'miscarriage, abortion (general)',
    swedish: 'missfall, abort (generellt)',
    norwegian: 'abort (generelt)',
    finnish: '',
    hungarian: '',
    german: 'Fehlgeburt',
    dutch: 'miskraam, abortus',
    afrikaans: 'miskraam, aborsie (algemeen)',
    russian: 'выкидыш, аборт (обобщ.)',
    latvian: 'aborts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25548,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vertical line + minus + vertical line: representing the separation of two things previously attached) - Character (sequenced)',
    english: 'detachment, separation, breakup',
    swedish: 'avskiljande, isärtagning',
    norwegian: 'frigjøring, separasjon',
    finnish: '',
    hungarian: '',
    german: 'Abtrennung, Trennung, Distanziertheit',
    dutch: 'scheiding, ontkoppeling',
    afrikaans: 'losmaking, skeiding, op breek',
    russian: 'разъединение, разборка',
    latvian: 'šķiršanās, atdalīšanās',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25549,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph, of a diamond shape) - Character',
    english: 'diamond (character)',
    swedish: 'ruter (tecken)',
    norwegian: 'ruter (tegn, eks kortspill)',
    finnish: '',
    hungarian: '',
    german: 'Raute (Figur)',
    dutch: 'diamand (karakter)',
    afrikaans: 'diamant',
    russian: 'алмаз (символ)',
    latvian: 'kāravs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25550,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(shovel + earth) - Character (superimposed)',
    english: 'digging, excavation',
    swedish: 'grävning, utgrävning (allmän)',
    norwegian: 'graving, utgraving (generelt)',
    finnish: '',
    hungarian: '',
    german: 'Graben, Ausgrabung',
    dutch: 'uitgraven, spitten',
    afrikaans: 'grawe, uitgrawing',
    russian: 'копание, раскопка',
    latvian: 'rakšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25551,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(limit(s), limitation, restriction [modification] + digits (computer)) - Character (superimposed - sequenced - modified)',
    english: 'digital space (limited)',
    swedish: 'digital domän',
    norwegian: 'domène digitalt, digitalt domène',
    finnish: '',
    hungarian: '',
    german: 'digitaler Raum',
    dutch: 'digitale ruimte (beperkt)',
    afrikaans: 'digitale ruimte (beperkte)',
    russian: 'цифровое пространство, домен',
    latvian: 'digitāls domeins',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25552,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(world + digits (computer)) - Character (superimposed)',
    english: 'digital world',
    swedish: 'digital värld',
    norwegian: 'verden digital, digital verden',
    finnish: '',
    hungarian: '',
    german: 'digitale Welt',
    dutch: 'digitale wereld',
    afrikaans: 'digitale wêreld',
    russian: 'цифровой мир',
    latvian: 'digitālā pasaule',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25553,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(peace, peace of mind, serenity + deletion, cancellation, destruction: used in harassment 14677 and sexual harassment 16930) - Character (superimposed)',
    english: 'disturbance, unrest',
    swedish: 'oro, ängslan',
    norwegian: 'uro, bekymring, engstelse',
    finnish: '',
    hungarian: '',
    german: 'Störung, Unruhe, Ruhelosigkeit',
    dutch: 'onrust, verstoring, verwarring',
    afrikaans: 'versteuring, onrus',
    russian: 'беспокойство, тревога',
    latvian: 'trauksme, nemiers',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25554,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(ideograph: symbol represents a half-sized cone balancing unsteadily on its point, reminding us that our evaluations are variable and unreliable) - Character',
    english: 'evaluation, value (half-sized)',
    swedish: 'värdering (halv storlek)',
    norwegian: 'vurdering (halv størrelse)',
    finnish: '',
    hungarian: '',
    german: 'Bewertung, Auswertung, Wert (halbe Größe)',
    dutch: 'evaluatie, waarde (halve grootte)',
    afrikaans: 'evaluering, evaluering (half grootte)',
    russian: 'оценка',
    latvian: 'novērtēšana (daļēja)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25555,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(receiving + giving, gift (combination)) - Character (superimposed - combined)',
    english: 'exchange, substitution',
    swedish: 'byte, utbyte',
    norwegian: 'erstatning, utbytting',
    finnish: '',
    hungarian: '',
    german: 'Austausch, Ersatz',
    dutch: 'uitwisseling, vervanging',
    afrikaans: 'ruil, vervanging, omruil',
    russian: 'обмен, замена',
    latvian: 'apmaiņa, aizvietošana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25556,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(fire + deletion, cancellation, destruction) - Character (superimposed)',
    english: 'extinction, extinguishing (fire)',
    swedish: 'eldsläckning',
    norwegian: 'ildslokking, brannslokking',
    finnish: '',
    hungarian: '',
    german: 'Löschen, Löschung (Feuer)',
    dutch: 'uitdoving',
    afrikaans: 'blus',
    russian: 'огнетушение',
    latvian: 'nodzēšana (uguns)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25557,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(eye + pointer, to upper eyelid (and eyelashes) + pointer, to lower eyelid) - Character (superimposed - pointer)',
    english: 'eyelid(s)',
    swedish: 'ögonlock',
    norwegian: 'øyelokk (flertall)',
    finnish: '',
    hungarian: '',
    german: 'Augenlid(er) (Oberlid)',
    dutch: 'ooglid, oogleden',
    afrikaans: 'ooglede',
    russian: 'веки',
    latvian: 'plakstiņs, plakstiņi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25558,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(eye + pointer, to lower eyelid) - Character (superimposed - pointer)',
    english: 'eyelid (lower)',
    swedish: 'ögonlock (nedre)',
    norwegian: 'øyelokk (nedre)',
    finnish: '',
    hungarian: '',
    german: 'Augenlid (Unterlid)',
    dutch: 'ooglid (onderste)',
    afrikaans: 'ooglid (onder)',
    russian: 'нижнее веко',
    latvian: 'apakšējais plakstiņš',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25559,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(reference line [half-sized] + three connecting dots + reference line [half-sized]: full square between the reference lines emphasizes distance.) See also: nearness, closeness, proximity 25586 - Character (sequenced) Preferred NEW SYNONYM, replacing 24896',
    english: 'farness, remoteness, farawayness',
    swedish: 'långt avstånd, avlägsenhet',
    norwegian: 'avstand (lang, langt borte), fjernhet',
    finnish: 'kaukaisuus, etäisyys',
    hungarian: 'messziség, távoliság, távollévőség',
    german: 'Abgelegenheit, Entferntheit',
    dutch: 'afstand, lengte',
    afrikaans: 'afstand, afgeleë',
    russian: 'удалённость',
    latvian: 'tālums, attālums',
    polish: '',
    french: 'éloignement',
    spanish: 'lejanía',
  },
  {
    av: 25560,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(reference line + three connecting dots + reference line + pointer, to the right on the left line + pointer, to the left on the right line : the full square between the reference lines, and the pointers pointing inwards from the outside, emphasize thickness.) See also: thinness, narrowness 25622 - Character (superimposed - sequenced - pointer) Preferred NEW SYNONYM, replacing 25561',
    english: 'fatness, thickness',
    swedish: 'tjockhet',
    norwegian: 'tykkelse, fedme',
    finnish: '',
    hungarian: '',
    german: 'Dickheit',
    dutch: 'dikte',
    afrikaans: 'vet, duk',
    russian: 'толщина',
    latvian: 'resnums, biezums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25562,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(container + water (ground level): container appears to float on water) - Character (superimposed)',
    english: 'floating container',
    swedish: 'flytetyg, flytande behållare',
    norwegian: 'beholder flytende',
    finnish: '',
    hungarian: '',
    german: 'fließender Behälter, Container',
    dutch: 'drijvend vat',
    afrikaans: 'drywende houer',
    russian: 'плавучий контейнер',
    latvian: 'peldoš konteineris',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25563,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(flower + pointer, to blossom) - Character (superimposed - pointer)',
    english: 'flower, bloom, blossom',
    swedish: 'blomkrona, blomställning, blomma',
    norwegian: 'blomsterkrone, blomst',
    finnish: '',
    hungarian: '',
    german: 'Blume, Blüte',
    dutch: 'bloem (natuur), bloesem',
    afrikaans: 'blom, bloeisel',
    russian: 'венчик цветка, соцветие',
    latvian: 'puķe, zieds',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25564,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vertical reference line + horizontal reference line + pictograph, of asmall curved arrow (to the right and down): the arrow pulls the vertical reference line down onto the horizontal one, as if closing a folder) - Character (superimposed)',
    english: 'fold, folding, pleating',
    swedish: 'veck, vikning',
    norwegian: 'brett, fold',
    finnish: '',
    hungarian: '',
    german: 'Falte, Faltung, Fälteln, Falz',
    dutch: 'gevouwen, geplooid',
    afrikaans: 'vou',
    russian: 'складывание, сгибание',
    latvian: 'salocīšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25565,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water + thing + action indicator: to convert water to solid ice) - Character (superimposed)',
    english: 'freezing, hardening, solidifying',
    swedish: 'infrysning, tillfrysning, stelning',
    norwegian: 'innfrysing, nedfrysing, ising',
    finnish: '',
    hungarian: '',
    german: 'Einfrieren, Härten, Verhärtung, Verfestigen',
    dutch: 'verharding, bevriezing',
    afrikaans: 'bevriesing, verharding, gestol, stol',
    russian: 'замораживание, оледенение',
    latvian: 'sasaldēšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25566,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sky + down) - Character (superimposed)',
    english: 'from sky',
    swedish: 'från skyn',
    norwegian: 'retning ovenfra',
    finnish: '',
    hungarian: '',
    german: 'vom Himmel',
    dutch: 'vanuit de lucht',
    afrikaans: 'uit die lug',
    russian: 'спуск с небес',
    latvian: 'no debesīm',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25567,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(fruit + pictograph of wedge shape (combination)) - Character (superimposed - combined)',
    english: 'fruit (pointed)',
    swedish: 'frukt (kilformad)',
    norwegian: 'frukt spissformet',
    finnish: '',
    hungarian: '',
    german: 'Obst (spitzig)',
    dutch: 'fruit (puntvormig)',
    afrikaans: 'vrugte (gepunte)',
    russian: 'фрукт (клиновидный)',
    latvian: 'auglis (noteiktas formas)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25568,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(future + what, question mark: unpredictable future) - Character (superimposed)',
    english: 'future (uncertain)',
    swedish: 'framtid (oviss), oviss framtid',
    norwegian: 'framtid uviss, usikker, uviss, usikker framtid',
    finnish: '',
    hungarian: '',
    german: 'Zukunft (unsicher)',
    dutch: 'toekomst (onzeker)',
    afrikaans: 'toekoms (onseker)',
    russian: 'будущее (неопределённое)',
    latvian: 'nākotne (neskaidra)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25569,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(conscience + and also, plus, too: conscience in a positive state) - Character (superimposed)',
    english: 'good conscience',
    swedish: 'samvete (gott)',
    norwegian: 'samvittighet god',
    finnish: '',
    hungarian: '',
    german: '(gutes) Gewissen',
    dutch: 'goed geweten',
    afrikaans: 'goeie gewete',
    russian: 'чистая совесть',
    latvian: 'tīra sirdsapziņa',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25570,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + earth: something half hidden in the earth) - Character (superimposed)',
    english: 'hidden thing',
    swedish: 'gömt föremål',
    norwegian: 'gjemt ting, ting gjemt',
    finnish: '',
    hungarian: '',
    german: 'verstecktes Ding',
    dutch: 'verborgen ding',
    afrikaans: 'verborge ding',
    russian: 'скрытый объект',
    latvian: 'noslēpta lieta',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25571,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(horse + pointer, to neck) - Character (superimposed - pointer)',
    english: 'horse neck',
    swedish: 'hästnacke, nacke (hovdjur)',
    norwegian: 'hestehals, hals (hovdyr)',
    finnish: '',
    hungarian: '',
    german: 'der Hals des Pferdes',
    dutch: 'paardennek',
    afrikaans: 'perdnek',
    russian: 'шея лошади',
    latvian: 'zirga kakls',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25572,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(horse + pointer, to tail) - Character (superimposed - pointer)',
    english: 'horse rump',
    swedish: 'hästbak, hästrumpa',
    norwegian: 'hesterumpe',
    finnish: '',
    hungarian: '',
    german: 'die Kruppe des Pferdes',
    dutch: 'paardenromp',
    afrikaans: 'perdkruis',
    russian: 'круп лошади',
    latvian: 'zirga dibens',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25573,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(injection, inoculation, shot + pointer, to the needlepoint) - Character (superimposed - pointer)',
    english: 'hypodermic needlepoint',
    swedish: 'nålspets (injektionsspruta etc)',
    norwegian: 'nålespiss (injekssjpnssprøyte etc)',
    finnish: '',
    hungarian: '',
    german: 'Injektionsnadelspitze',
    dutch: 'naald van een spuit',
    afrikaans: 'spuitnaald punt',
    russian: 'кончик иглы (шприц)',
    latvian: 'adata (šprices)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25574,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(creation + what, question mark: the nature of things, but with uncertainty) - Character (superimposed)',
    english: 'hypothesis, theory',
    swedish: 'hypotes, teori',
    norwegian: 'hypotese, teori',
    finnish: '',
    hungarian: '',
    german: 'Hypothese, Theorie',
    dutch: 'hypothese, theorie, veronderstelling',
    afrikaans: 'hipotese, teorie',
    russian: 'гипотеза, теория',
    latvian: 'teorija, hipotēze',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25575,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph of impression, like made by a thumb pressed into something soft) - Character',
    english: 'imprint, depression',
    swedish: 'fördjupning, avtryck',
    norwegian: 'avtrykk, fordyping',
    finnish: '',
    hungarian: '',
    german: 'Aufdruck, Abdruck, Spur, Vertiefung',
    dutch: 'indruk',
    afrikaans: 'afdruk',
    russian: 'углубление, отпечаток',
    latvian: 'nospiedums, pēdas',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25576,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(protection + future (uncertain): protection against unpredictable future problems and expense) - Character (superimposed)',
    english: 'insurance',
    swedish: 'försäkring',
    norwegian: 'forsikring',
    finnish: '',
    hungarian: '',
    german: 'Versicherung',
    dutch: 'verzekering',
    afrikaans: 'versekering',
    russian: 'страхование',
    latvian: 'apdrošināšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25577,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(horizontal line [modification, half-sized, on skyline, extending to the left] + vertical line) - Character (superimposed - modified)',
    english: 'left turn, left (position or direction)',
    swedish: 'vänsterriktning',
    norwegian: 'retning venstre',
    finnish: '',
    hungarian: '',
    german: 'Linksabbieger, links, linksdrehend',
    dutch: 'linkse bocht, linkse draai',
    afrikaans: 'links, draai links (posisie of rigting)',
    russian: 'левая сторона',
    latvian: 'kreisā puse',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25578,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(legs and feet + two pointers: to leg and foot) - Character (superimposed - pointer)',
    english: 'leg and foot',
    swedish: 'ben och fot',
    norwegian: 'bein og fot',
    finnish: '',
    hungarian: '',
    german: 'Bein und Fuß ',
    dutch: 'been en voet',
    afrikaans: 'been en voet',
    russian: 'нога и стопа',
    latvian: 'kāja, pēda',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25579,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(line, stripe + three connecting dots + line, stripe: two reference lines on the vertical boundaries of the symbol for enclosure, limiting what lies between them) - Character (sequenced) Preferred NEW SYNONYM, replacing 15213',
    english: 'limit(s), limitation, restriction',
    swedish: 'begränsning, gränser',
    norwegian: 'grense(r), begrensning',
    finnish: '',
    hungarian: '',
    german: 'Grenze, Limit, Beschränkung, Einschränkung, Begrenzung',
    dutch: 'limiet, beperking',
    afrikaans: 'limiet, beperking',
    russian: 'ограничение, границы',
    latvian: 'robeža, ierobežojums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25580,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(body + hair + pointer, to mane: specifier for species that has a mane) - Character (superimposed - pointer)',
    english: 'mane (lion etc)',
    swedish: 'man (djur)',
    norwegian: 'man (på dyr)',
    finnish: '',
    hungarian: '',
    german: 'Mähne (Löwe etc)',
    dutch: 'manen (leeuw)',
    afrikaans: 'maanhare (leeu)',
    russian: 'грива',
    latvian: 'krēpes',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25581,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(forward + food + backward: crushed food) - Character (superimposed)',
    english: 'mash, mush, pulp (food)',
    swedish: 'mos, pure',
    norwegian: 'mos, stappe, puré',
    finnish: '',
    hungarian: '',
    german: 'Brei, Mark, Pulpe',
    dutch: 'gemixt voedsel, puree',
    afrikaans: 'pulp voedsel)',
    russian: 'пюре (еда)',
    latvian: 'biezenis, biezumi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25582,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph of mask) - Character',
    english: 'mask (disguise)',
    swedish: 'ansiktsmask, förklädnad',
    norwegian: 'ansiktsmaske, forkledning',
    finnish: '',
    hungarian: '',
    german: 'Maske (Verhüllung, Verkleidung)',
    dutch: 'masker (verkleden)',
    afrikaans: 'masker (vermom)',
    russian: 'маска (для маскировки)',
    latvian: 'maska',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25583,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(forward + backward: two arrows approaching each other from opposite directions) - Character (sequenced)',
    english: 'meeting, encounter',
    swedish: 'möte',
    norwegian: 'møte',
    finnish: '',
    hungarian: '',
    german: 'Treffen, Begegnung',
    dutch: 'samenkomst, bijeenkomst, ontmoeting',
    afrikaans: 'ontmoeting',
    russian: 'встреча',
    latvian: 'tikšanās',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25584,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(meeting, encounter [modification, higher position] + parting [modification, lower position]) - Character (superimposed - sequenced - modified)',
    english: 'meeting and parting',
    swedish: 'möte och avsked',
    norwegian: 'møte og avskjed',
    finnish: '',
    hungarian: '',
    german: 'sich treffen und sich trennen, Treffen und Abschied',
    dutch: 'samenkomst en vertrek',
    afrikaans: 'vergadering en afskeid',
    russian: 'встреча и расставание',
    latvian: 'tikšanās un šķiršanās',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25585,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(metaphor + wings: 'winged speech', used in poetry) - Character (superimposed)",
    english: 'metaphor (winged)',
    swedish: 'metafor (bevingad)',
    norwegian: 'metafor (bevinget)',
    finnish: '',
    hungarian: '',
    german: 'Metapher (geflügelt)',
    dutch: 'metafoor (met vleugels)',
    afrikaans: 'metafoor gevlerkte',
    russian: 'метафора, крылатая фраза',
    latvian: 'metafora, spārnots izteiciens',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25586,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(reference line [half-sized] + reference line [half-sized]: with a half square between them, the lines are relatively near each other) See also: farness, remoteness, farawayness 25559. - Character (sequenced)',
    english: 'nearness, closeness, proximity',
    swedish: 'närhet',
    norwegian: 'nærhet',
    finnish: '',
    hungarian: '',
    german: 'Nähe',
    dutch: 'intiem, nabijheid',
    afrikaans: 'nabyheid',
    russian: 'близость',
    latvian: 'tuvība',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25587,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(life + beginning, start + time (combination): combination of beginning and life and time) - Character (superimposed - combined)',
    english: 'newness, novelty',
    swedish: 'nyhet, något nytt',
    norwegian: 'nyhet',
    finnish: '',
    hungarian: '',
    german: 'Neuheit, Neuigkeit',
    dutch: 'nieuws, nieuwtje',
    afrikaans: 'nuwigheid',
    russian: 'новинка, новизна, новшество',
    latvian: 'jaunums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25588,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(to speak + deletion, cancellation, destruction: unable to speak). See also: speech impaired 26025. - Character (superimposed)',
    english: 'no speech, anarthria',
    swedish: 'stumhet, utan tal',
    norwegian: 'stumhet, anartri',
    finnish: '',
    hungarian: '',
    german: 'keine Lautsprache, Anarthrie',
    dutch: 'anarthrie, zonder spraak',
    afrikaans: 'geen spraak, anarthria',
    russian: 'отсутствие речи, анартрия',
    latvian: 'runas trūkums, anartrija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25589,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(backward, back [modification, on skyline] + backward, back [modification, on earthline]: forces working against something) See also: adversity, hardship, setback 25545 - Character (superimposed - modified)',
    english: 'opposing forces, counter-forces',
    swedish: 'motverkan, motkrafter',
    norwegian: 'motvirkning, motkrefter',
    finnish: '',
    hungarian: '',
    german: 'Gegenkräfte, Gegenwirkung',
    dutch: 'tegenovergestelde krachten',
    afrikaans: 'opponerende magte',
    russian: 'противостояние, противоборство',
    latvian: 'pretspēks, pretdarbība',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25590,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(body + up, upward: e.g., used in burp, belch-(to) 12925) - Character (superimposed)',
    english: 'out of body (upward), regurgitation',
    swedish: 'upp ur kropp',
    norwegian: 'ut av kropp (opp)',
    finnish: '',
    hungarian: '',
    german: 'aus dem Körper heraus',
    dutch: 'uit het lichaam (aan bovenkant)',
    afrikaans: 'uit die liggaam (opwaartse)',
    russian: 'вверх из тела',
    latvian: 'ārā no ķermeņa (uz aukšu)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25591,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(house + dot (outside the house): can also be seen as a combination of house and out, exterior, external, outside)) - Character (sequenced - combined)',
    english: 'outdoor (character)',
    swedish: 'utomhustecken',
    norwegian: 'utside (hus)',
    finnish: '',
    hungarian: '',
    german: 'Außen, im Freien (Zeichen)',
    dutch: 'buitenshuis (karakter)',
    afrikaans: 'buite (karakter)',
    russian: 'нахождение вне здания, наружность (знак)',
    latvian: 'āra, ārpus telpām',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25592,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(backward + forward: two arrows, pointing away from each other) - Character (sequenced)',
    english: 'parting',
    swedish: 'avsked, åtskiljande (allmänt)',
    norwegian: 'avskjed, atskillelse (generelt)',
    finnish: '',
    hungarian: '',
    german: 'Teilen, Scheiden, Trennung',
    dutch: 'vertrek (zelfst nw)',
    afrikaans: 'afskeid',
    russian: 'расставание',
    latvian: 'atvadas, atdalīšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25593,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(conscience + permission, allowance (combination): represents a moral consideration that is allowed to pass through a mental barrier) - Character (superimposed - combined)',
    english: 'permission, allowance (moral)',
    swedish: 'tillåtelse',
    norwegian: 'tillatelse',
    finnish: '',
    hungarian: '',
    german: 'Erlaubnis (Moral)',
    dutch: 'toelating (moreel)',
    afrikaans: 'toestemming, toelae (morele)',
    russian: 'разрешение, позволение',
    latvian: 'atļauja',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25594,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph of pizza divided into pieces, a circle divided into circle ectors) - Character',
    english: 'pizza slice(s), sector(s), circle sector(s)',
    swedish: 'sektor(er), cirkelsektor(er), sektion(er)',
    norwegian: 'pizzabit(er), sektor(er), sirkelsektor(er), seksjon(er)',
    finnish: '',
    hungarian: '',
    german: 'Pizzastück(e), Sektor(en), Kreisausschnitt(e)',
    dutch: 'cirkel segment, pizza stuk, sector',
    afrikaans: 'pizza sny, sektor',
    russian: 'сектор, сектор(ы) круга',
    latvian: 'apļa sektors',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25595,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(plus sign (low) + minus [modification, higher position]) - Character (superimposed - modified)',
    english: 'plus minus',
    swedish: 'plus minus',
    norwegian: 'pluss minus',
    finnish: '',
    hungarian: '',
    german: 'Plus, Minus',
    dutch: 'plus minus',
    afrikaans: 'plus minus',
    russian: 'плюс минус',
    latvian: 'plus mīnus',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25596,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(and, also, plus, too [modification, on earthline]) - Character (modified)',
    english: 'plus sign (low)',
    swedish: 'plustecken (lågt läge)',
    norwegian: 'plusstegn (lav posisjon)',
    finnish: '',
    hungarian: '',
    german: 'Pluszeichen (niedrige Lage)',
    dutch: 'plusteken (laag)',
    afrikaans: 'plus teken',
    russian: "знак 'плюс' (низкая позиция)",
    latvian: 'plus zīme (apakšējā)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25597,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(protection + water (ground level): water with protection) - Character (superimposed)',
    english: 'protected water',
    swedish: 'skyddat vatten',
    norwegian: 'vernet vann',
    finnish: '',
    hungarian: '',
    german: 'Wasserschutz',
    dutch: 'beschermd water',
    afrikaans: 'beskermde water',
    russian: 'защищённые воды',
    latvian: 'aizsargāti ūdeņi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25598,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(protection + pointer) - Character (superimposed - pointer)',
    english: 'protection with pointer',
    swedish: 'skydd med pilspets',
    norwegian: 'beskyttelse med pilspiss',
    finnish: '',
    hungarian: '',
    german: 'Schutz mit Zeiger',
    dutch: 'bescherming met aanwijzer',
    afrikaans: 'beskerming (met wyser)',
    russian: 'защита (с указателем)',
    latvian: 'aisardzība ar norādi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25599,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + forward [modification, short arrow]: the forward moving arrow seems to be pulling the thing) - Character (superimposed - modified)',
    english: 'pull, pulling',
    swedish: 'drag',
    norwegian: 'trekking, draing',
    finnish: '',
    hungarian: '',
    german: 'Ziehen, Zug',
    dutch: 'trek (zelfst nw)',
    afrikaans: 'trek',
    russian: 'таскание, перетаскивание',
    latvian: 'raut, vilkt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25600,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: wavy line, as in fire, but in a higher position) - Character',
    english: 'raised wavy line',
    swedish: 'våglinje (vertikal, högt läge)',
    norwegian: 'bølgelinje (vertikal, høy posisjon)',
    finnish: '',
    hungarian: '',
    german: 'erhöhte Wellenlinie',
    dutch: 'golflijn (hoog)',
    afrikaans: 'opgewek kronkellyn',
    russian: 'вертикальная волнистая линия (высокая позиция)',
    latvian: 'vertikāli vērsta viļņa līnija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25601,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph, of a disk or record: circle (as in sun) + dot (in the middle), suggesting any kind of rotating recordng disk, gramophone, CD, DVD, video, etc.) - Character (superimposed)',
    english: 'recording disk',
    swedish: 'skiva (för inspelning etc)',
    norwegian: 'CD (for opptak)',
    finnish: '',
    hungarian: '',
    german: 'Aufnahmeplatte, Schallplattenaufnahme',
    dutch: 'schijf voor opname',
    afrikaans: 'opname skyf',
    russian: 'диск (зля записи и пр.)',
    latvian: 'disks (ierakstam)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25602,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + reflection: mirroring thoughts in the mind) - Character (superimposed)',
    english: 'reflection (mental), consideration',
    swedish: 'reflektion, fundering, eftertanke',
    norwegian: 'refleksjon, fundering, ettertanke',
    finnish: '',
    hungarian: '',
    german: 'Reflexion, Bedenken, Reflektierung',
    dutch: 'reflectie (mentaal), beschouwing',
    afrikaans: 'oorweging (verstandelike)',
    russian: 'рефлексия, осознание',
    latvian: 'refleksija (mentāla), pārdomas',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25603,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(seat, sitting (sitting person) + forward [modification, on groundlevel]: going forward in a sitting position) - Character (superimposed - modified)',
    english: 'ride, drive',
    swedish: 'åktur, färd',
    norwegian: 'kjøretur, ferd',
    finnish: '',
    hungarian: '',
    german: 'Fahrt, Mitfahrt',
    dutch: 'rit',
    afrikaans: 'ry, bestuur',
    russian: 'поездка',
    latvian: 'brauciens',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25604,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vertical line + horizontal line [modification, half-sized, on skyline, extending to the right]) - Character (superimposed - modified)',
    english: 'right turn, right (position or direction)',
    swedish: 'högerriktning',
    norwegian: 'retning høyre',
    finnish: '',
    hungarian: '',
    german: ' Rechtsabbieger, rechts, rechtsdrehend',
    dutch: 'rechtse draai, rechts, rechtse bocht',
    afrikaans: 'regs, regs draai (posisie of rigting)',
    russian: 'правая сторона',
    latvian: 'labā puse, labais pagrieziens',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25605,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(house, building, dwelling, residence + deletion, cancellation, destruction) - Character (superimposed) SYMBOL SYNONYM',
    english: 'ruin, wreck, wreckage (building) (1)',
    swedish: 'ruin (1)',
    norwegian: 'ruin, rønne (1)',
    finnish: 'rauniot (1)',
    hungarian: 'rom, romház (1)',
    german: 'Ruine, Wrack (1)',
    dutch: 'ruïne (1)',
    afrikaans: 'wrak, ruïne (gebou) (1)',
    russian: 'руины, развалины, обломки (1)',
    latvian: 'krāsmatas, drupas (1)',
    polish: 'ruina, rudera (1)',
    french: 'ruine (1)',
    spanish: 'ruina (1)',
  },
  {
    av: 25606,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(two vertical lines [half-sized] + pointer: pointer points downward into a relatively shallow space) See also depth 25546 - Character (superimposed - pointer)',
    english: 'shallowness',
    swedish: 'grundhet',
    norwegian: 'grunnhet (generelt)',
    finnish: '',
    hungarian: '',
    german: 'Oberflächlichkeit, Seichtheit',
    dutch: 'oppervlakkigheid',
    afrikaans: 'oppervlakkigheid',
    russian: 'мелкость',
    latvian: 'seklums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25607,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(international symbol for Israeli shekel) - Character',
    english: 'shekel (character)',
    swedish: 'shekeltecken',
    norwegian: 'shekeltegn',
    finnish: '',
    hungarian: '',
    german: 'Scheckel (Zeichen)',
    dutch: 'sjekel (munt Israel, karakter)',
    afrikaans: 'sikkel',
    russian: 'шекель (символ)',
    latvian: 'šekelis (naudas zime)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25608,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(ball + wing(s)) - Character (superimposed)',
    english: 'shuttlecock, birdie (badminton)',
    swedish: 'badmintonboll',
    norwegian: 'badmintonball, fjærball',
    finnish: '',
    hungarian: '',
    german: 'Federball',
    dutch: 'pluimbal (badminton), pluimpje (badminton)',
    afrikaans: 'pluimbal',
    russian: 'воланчик',
    latvian: 'badmintona mušiņa',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25609,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(ski, runner (sled etc) + seat, sitting (sitting person)) - Character (superimposed) Preferred NEW SYNONYM, replacing 23948',
    english: 'sitski, sit ski',
    swedish: 'sitski',
    norwegian: 'sitski',
    finnish: 'hiihtokelkka, biski-kelkka',
    hungarian: 'ülősí',
    german: 'Sitzski, Skischlitten, Sit-Ski',
    dutch: 'zitski',
    afrikaans: 'sitski',
    russian: 'сидячие лыжи',
    latvian: 'sēdslēpes',
    polish: 'narty z siedziskiem ew nartosanki',
    french: 'ski assis',
    spanish: 'silla esquí',
  },
  {
    av: 25610,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph of a ski) - Character',
    english: 'ski, runner (sled etc)',
    swedish: 'skida, med (släde etc)',
    norwegian: 'ski, meie',
    finnish: '',
    hungarian: '',
    german: 'Ski, Skiläufer (Schlitten etc)',
    dutch: 'ski',
    afrikaans: 'ski slee',
    russian: 'полоз, лыжа',
    latvian: 'slēpe, sliece',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25611,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mouth [modification, on earthline] + pictograph of cigarette + fire: symbol suggests a mouth holding a smoking cigarette) - Character (superimposed - modified)',
    english: 'smoking (cigarette)',
    swedish: 'rökning (cigarett)',
    norwegian: 'røyking (sigarett)',
    finnish: '',
    hungarian: '',
    german: 'Rauchen (Zigarette)',
    dutch: 'rokend (sigaret)',
    afrikaans: 'rook (sigaret)',
    russian: 'курение',
    latvian: 'smēķēšana (cigarešu)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25612,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mouth [modification, on earthline] + pictograph of smoking pipe + fire:combination of smoking (cigarette) and pictograph of a smoking pipe) - Character (superimposed - combined - modified)',
    english: 'smoking (pipe)',
    swedish: 'rökning (pipa)',
    norwegian: 'røyking (pipe)',
    finnish: '',
    hungarian: '',
    german: 'Rauchen (Pfeife)',
    dutch: 'rokend (pijp)',
    afrikaans: 'rook (pyp)',
    russian: 'курение (трубки)',
    latvian: 'smēķēšana (pīpes)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25613,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph of a snowshoe: special shoe for walking over snow) - Character Preferred NEW SYNONYM, replacing 17197',
    english: 'snowshoe',
    swedish: 'snösko',
    norwegian: 'truge, snøsko',
    finnish: 'lumikenkä',
    hungarian: 'hótalp (finn)',
    german: 'Schneeschuh',
    dutch: 'sneeuwschoen',
    afrikaans: 'sneeuskoen',
    russian: 'снегоступы',
    latvian: 'sniega apavi',
    polish: 'rakiety śnieżne, buty śniegowe',
    french: 'raquette de neige',
    spanish: 'raqueta de nieve',
  },
  {
    av: 25614,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing [modification, on earthline] + pictograph of a pointed top: together, a pictograph suggesting a projectile or a rocket) - Character (superimposed - modified)',
    english: 'projectile, rocket, spacecraft',
    swedish: 'projektil, raket, rymdfarkost',
    norwegian: 'prosjektil, rakett, romfartøy',
    finnish: '',
    hungarian: '',
    german: 'Projektil, Rakete, Raumschiff ',
    dutch: 'raket, projectiel, ruimtetuig',
    afrikaans: 'projektiel, vuurpyl, ruimtetuig',
    russian: 'снаряд, ракета, космический корабль',
    latvian: 'mīna, raķete, kosmosa raķete',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25615,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(sperm + deletion, cancellation, destruction) - Character (superimposed)',
    english: 'sperm destruction',
    swedish: 'spermiedöd',
    norwegian: 'spermie død',
    finnish: '',
    hungarian: '',
    german: 'die Vernichtung von Sperma, Spermizid',
    dutch: 'zaaddoding',
    afrikaans: 'sperm vernietiging',
    russian: 'уничтожение спермы',
    latvian: 'spermas iznīcināšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25616,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'spiral',
    swedish: 'spiral',
    norwegian: 'spiral',
    finnish: '',
    hungarian: '',
    german: 'Spirale',
    dutch: 'spiraal',
    afrikaans: 'spiraal',
    russian: 'спираль',
    latvian: 'spirāle',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25617,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(mouth + downward curving arrow: to expel from one's mouth) - Character (superimposed)",
    english: 'spitting',
    swedish: 'spottande',
    norwegian: 'spytting',
    finnish: '',
    hungarian: '',
    german: 'Spucken',
    dutch: 'gespuw',
    afrikaans: 'spoeg',
    russian: 'плевок',
    latvian: 'spļaušana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25618,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sport stick + ball) - Character (superimposed)',
    english: 'sport stick and ball, bandy stick',
    swedish: 'klubba och boll, bandyklubba',
    norwegian: 'bandykølle',
    finnish: '',
    hungarian: '',
    german: 'Schläger und Ball, Bandyschläger',
    dutch: 'stick met bal',
    afrikaans: 'sport stok en bal, krom stok',
    russian: 'клюшка с мячом',
    latvian: 'nūja ar bumbu',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25619,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sport stick + disk) - Character (superimposed)',
    english: 'sport stick and puck, hockey stick',
    swedish: 'klubba och puck, hockeyklubba',
    norwegian: 'hockeykølle',
    finnish: '',
    hungarian: '',
    german: 'Schläger und Puck (Eishockeyscheibe), Hockeyschläger',
    dutch: 'stick met puck, stick met schijfje',
    afrikaans: 'sport stok en puk, hokkiestok',
    russian: 'клюшка с шайбой',
    latvian: 'nūja ar ripu',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25620,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: a square standing on a corner) - Character',
    english: 'square (oblique)',
    swedish: 'fyrkant (snedställd)',
    norwegian: 'firkant (på skrå)',
    finnish: '',
    hungarian: '',
    german: 'Viereck (schiefwinklig)',
    dutch: 'vierkant (schuin)',
    afrikaans: 'vierkant (skuins)',
    russian: 'квадрат (косой)',
    latvian: 'kvadrāts (slīps)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25621,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(thing + water: solid ice becoming water) - Character (superimposed)',
    english: 'thawing, melting',
    swedish: 'upptining, smältning',
    norwegian: 'tining, smelting',
    finnish: '',
    hungarian: '',
    german: 'Tauen, Auftauen, Schmelzen',
    dutch: 'smeltend',
    afrikaans: 'ontdooi, smelt',
    russian: 'размораживание, таяние',
    latvian: 'atsaldēšana, izkušana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25622,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(two reference lines + two pointers: the pointers point inward toward the narrow space formed by the reference lines) - Character (superimposed - sequenced - pointer)',
    english: 'thinness, narrowness',
    swedish: 'tunnhet, smalhet',
    norwegian: 'tynnhet, smalhet',
    finnish: '',
    hungarian: '',
    german: 'Magerkeit, Dünne',
    dutch: 'engte',
    afrikaans: 'dun, nouheid',
    russian: 'тонкость, худоба',
    latvian: 'šaurība, saspiestība',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25624,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vehicle + enclosure [modification, high position] (combination)) - Character (superimposed - modified - combined) ',
    english: 'trailer, container transport',
    swedish: 'släp, släpvagn, trailer',
    norwegian: 'trailer, containertransport',
    finnish: '',
    hungarian: '',
    german: 'Anhänger, Containertransport',
    dutch: 'aanhangwagen, container transport',
    afrikaans: 'sleepwa, houer vervoer',
    russian: 'трейлер, прицеп',
    latvian: 'treileris, piekabe',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25625,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing [modification, high position] + wheel: moving something by vehicle) - Character (superimposed - modified)',
    english: 'transport, transportation',
    swedish: 'transport',
    norwegian: 'transport',
    finnish: '',
    hungarian: '',
    german: 'Transport',
    dutch: 'transport',
    afrikaans: 'vervoer, transport',
    russian: 'транспортировка, перевозка',
    latvian: 'transports, transportēšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25626,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(tree + deletion, cancellation, destruction: processes that destroy trees or wood) - Character (superimposed)',
    english: 'tree or wood destruction',
    swedish: 'träddöd, träförstörelse',
    norwegian: 'tredød, treødeleggelse',
    finnish: '',
    hungarian: '',
    german: 'Zerstörung von Holz oder Bäumen',
    dutch: 'vernietiging van boom of bos',
    afrikaans: 'boom of hout vernietiging',
    russian: 'уничтожение дерева',
    latvian: 'koku, mežu iznīcināšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25627,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(curved arrow: from skyline - down, forward and backward, to earthline) - Character',
    english: 'turn, turning',
    swedish: 'vändning',
    norwegian: 'sving, dreiing, snuing',
    finnish: '',
    hungarian: '',
    german: 'Abbiegen, Wende, Drehung, Biegung',
    dutch: 'draai',
    afrikaans: 'draai',
    russian: 'поворот, разворот, оборот',
    latvian: 'pagrieziens',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25628,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(earth, ground, land + reference dot (under ground level): combination of ground and under) - Character (superimposed - combined)',
    english: 'under (ground level)',
    swedish: 'under (marknivå)',
    norwegian: 'under (jordnivå)',
    finnish: '',
    hungarian: '',
    german: 'unter (Bodenhöhe)',
    dutch: 'onder (aardlijn)',
    afrikaans: 'onder (grondvlak)',
    russian: 'под (уровень земли)',
    latvian: 'zem zemes',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25629,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      "(forward (arrow into) + knowledge: combination of knowledge and into - to enter into one's store of knowledge) - Character (superimposed - combined)",
    english: 'understanding, comprehension',
    swedish: 'förståelse',
    norwegian: 'forståelse',
    finnish: '',
    hungarian: '',
    german: 'Verständnis',
    dutch: 'begrip',
    afrikaans: 'begrip, verstaan',
    russian: 'понимание',
    latvian: 'sapratne, izpratne',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25630,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(vertical reference line + horizontal reference line + pictograph, of asmall curved arrow (to the left and up): the arrow has pushed the vertical reference line up from the horizontal line, as if opening a folder) - Character (superimposed)',
    english: 'unfolding',
    swedish: 'utvikning, uppslagning, uppveckling ',
    norwegian: 'utbretting',
    finnish: '',
    hungarian: '',
    german: 'Entfaltung, Ausweitung',
    dutch: 'ontplooing',
    afrikaans: 'ontvou',
    russian: 'раскладывание, разгибание',
    latvian: 'atlocīšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25631,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph of Union Jack flag pattern) - Character',
    english: 'Union Jack pattern',
    swedish: 'Union-Jackmönster',
    norwegian: 'Union-Jackmønster',
    finnish: '',
    hungarian: '',
    german: 'Union Jack-Muster',
    dutch: 'Union Jack patroon',
    afrikaans: 'Union Jack patroon',
    russian: 'Юнион Джек (орнамент)',
    latvian: 'Union Jack paterns',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25632,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal (water) + pictograph, of a big tail: used in beaver 12646) - Character (superimposed)',
    english: 'water animal (big tail)',
    swedish: 'vattendjur (stor svans)',
    norwegian: 'vanndyr (stor hale)',
    finnish: '',
    hungarian: '',
    german: 'Wassertier (großer Schwanz)',
    dutch: 'waterdier (grote staart)',
    afrikaans: 'water dier (groot stert)',
    russian: 'водное животное (большой хвост)',
    latvian: 'ūdens dzīvnieks (ar lielu asti)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25633,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(water + land: water flooding over land) - Character (superimposed)',
    english: 'water on ground (flooding)',
    swedish: 'vattensamling (översvämmande)',
    norwegian: 'vannansamling, oversvømmelse',
    finnish: '',
    hungarian: '',
    german: 'Wasser auf Land (Überflutung, Überschwemmung)',
    dutch: 'overstroming (water op de aarde)',
    afrikaans: 'water op die grond (oorstromings)',
    russian: 'затопление, наводнение',
    latvian: 'plūdi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25634,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(reference line + pointer (left) + pointer (right) + reference line: the pointers point outward to the widest space bounded by the reference lines) - Character (superimposed - sequenced - pointer)',
    english: 'wideness, broadness',
    swedish: 'vidd, bredd',
    norwegian: 'vidde, bredde',
    finnish: '',
    hungarian: '',
    german: 'Weite, Breite',
    dutch: 'breedte',
    afrikaans: 'breedte, wydte',
    russian: 'ширина',
    latvian: 'plašums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25635,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(container, bowl, holder, pouch, basket + pictograph, of a handle) - Character (superimposed)',
    english: 'wok, wok pan',
    swedish: 'wok, wokpanna',
    norwegian: 'wok, wokpanne',
    finnish: '',
    hungarian: '',
    german: 'Wok',
    dutch: 'wokpan',
    afrikaans: 'wok pan',
    russian: 'сковорода вок',
    latvian: 'voks, vokpanna',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25636,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(woman + pointer, to lower part of the body) - Character (superimposed - pointer)',
    english: 'woman (below waist)',
    swedish: 'kvinna (nederdel)',
    norwegian: 'kvinne (underdel)',
    finnish: '',
    hungarian: '',
    german: 'Frau (under der Taille)',
    dutch: 'vrouw (onder de taille)',
    afrikaans: 'vrou (onder middellyf)',
    russian: 'женщина (ниже талии)',
    latvian: 'sieviete (zem jostas vietas)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25681,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(crab, shellfish (with claws) + pointer, to claw) - Character (superimposed - pointer)',
    english: 'claw (shellfish)',
    swedish: 'klo (skaldjur)',
    norwegian: 'klo (skalldyr)',
    finnish: '',
    hungarian: '',
    german: 'Schere (Schalentier)',
    dutch: 'scharen (schaaldier)',
    afrikaans: 'klou (skulpvis)',
    russian: 'клешня',
    latvian: 'spīles',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25710,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(woman + protection + woman) - Character (superimposed)',
    english: 'family, couple (female)',
    swedish: 'par, familj (kvinnor)',
    norwegian: 'par (hunkjønn)',
    finnish: '',
    hungarian: '',
    german: 'Paar, Familie (Frauen)',
    dutch: 'koppel (vrouwen)',
    afrikaans: 'familie, egpaar (vroulik)',
    russian: 'женская супружеская пара',
    latvian: 'ģimene, pāris (sieviešu)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25711,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(man + protection + man) - Character (superimposed)',
    english: 'family, couple (male)',
    swedish: 'par, familj (män)',
    norwegian: 'par (hankjønn)',
    finnish: '',
    hungarian: '',
    german: 'Paar, Familie (Männer)',
    dutch: 'koppel (mannen)',
    afrikaans: 'familie, egpaar (manlik)',
    russian: 'мужская супружеская пара',
    latvian: 'ģimene, pāris (vīriešu)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25712,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(woman + birth + woman) - Character (superimposed)',
    english: 'family (female)',
    swedish: 'familj (kvinnor)',
    norwegian: 'familie (hunkjønn)',
    finnish: '',
    hungarian: '',
    german: 'Familie (Frauen)',
    dutch: 'gezin (vrouwen), familie (vrouwen)',
    afrikaans: 'familie (vroulike)',
    russian: 'женская семья (с ребёнком)',
    latvian: 'ģimene (sieviešu)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25713,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(man + birth + man) - Character (superimposed)',
    english: 'family (male)',
    swedish: 'familj (män)',
    norwegian: 'familie (hankjønn)',
    finnish: '',
    hungarian: '',
    german: 'Familie (Männer)',
    dutch: 'gezin (mannen), familie (mannen)',
    afrikaans: 'familie (manlik)',
    russian: 'мужская семья (с ребёнком)',
    latvian: 'ģimene (vīriešu)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25748,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: three half-sized horizontal reference lines on top of each other suggesting layers or levels) - Character (superimposed)',
    english: 'layer, level',
    swedish: 'lager, skikt',
    norwegian: 'skikt, lag, nivå',
    finnish: '',
    hungarian: '',
    german: 'Schicht, Lage',
    dutch: 'laag, niveau',
    afrikaans: 'laag, vlak',
    russian: 'уровень, слой',
    latvian: 'līmenis, slānis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25777,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(water, fluid, liquid [modification, on the ground]) - Character (modified)',
    english: 'puddle, pool, water (ground level)',
    swedish: 'vattenpöl, vattenpuss',
    norwegian: 'dam, pytt',
    finnish: '',
    hungarian: '',
    german: 'Pfütze, Wasserlache',
    dutch: 'plas',
    afrikaans: 'poel',
    russian: 'лужа',
    latvian: 'peļķes, lāmas',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25779,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(life + earth, ground, land) - Character (superimposed)',
    english: 'reality',
    swedish: 'verklighet',
    norwegian: 'virkelighet',
    finnish: '',
    hungarian: '',
    german: 'Realität',
    dutch: 'werkelijkheid',
    afrikaans: 'werklikheid',
    russian: 'реальность',
    latvian: 'realitāte',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25783,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(earth + pictograph of root) - Character (superimposed)',
    english: 'root',
    swedish: 'rot',
    norwegian: 'rot',
    finnish: '',
    hungarian: '',
    german: 'Wurzel',
    dutch: 'wortel (plant)',
    afrikaans: 'wortel',
    russian: 'корень',
    latvian: 'sakne',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25812,
    group: 'character',
    pos: 'BLUE',
    derivationExplanation: '(spouse + parent) - Character (superimposed)',
    english: 'stepparent, step-parent',
    swedish: 'styvförälder',
    norwegian: 'steforeldre',
    finnish: '',
    hungarian: '',
    german: 'Stiefeltern, Stiefelternteil',
    dutch: 'stiefouder',
    afrikaans: 'stiefouer',
    russian: 'отчим, мачеха',
    latvian: 'audžu vecāki',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25822,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph) - Character',
    english: 'tooth',
    swedish: 'tand',
    norwegian: 'tann',
    finnish: '',
    hungarian: '',
    german: 'Zahn',
    dutch: 'tand',
    afrikaans: 'tand',
    russian: 'зуб',
    latvian: 'zobs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25878,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph, of a fiber) - Character',
    english: 'fiber, fibre, fibril, filament, strand',
    swedish: 'fiber, filament, fibrill, tråd (otvinnad)',
    norwegian: 'fiber, tråd (ikke tvunnet)',
    finnish: '',
    hungarian: '',
    german: 'Faser, Fiber, Fäserchen, Faden, Draht, Spinnfaden',
    dutch: 'vezel',
    afrikaans: 'vesel, filament, strand',
    russian: 'волокно, нить',
    latvian: 'dzijas pavedieni',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25894,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(backward + enclosure: the arrow going backward into an enclosure) - Character (superimposed)',
    english: 'into (backward)',
    swedish: 'in i (bakåt)',
    norwegian: 'inni (bakover)',
    finnish: '',
    hungarian: '',
    german: 'in…hinein (rückwärts)',
    dutch: 'in (achterwaarts), ingang (achterwaarts), erin (achterwaarts)',
    afrikaans: 'in (agtertoe)',
    russian: 'в, во внутрь (назад)',
    latvian: 'iekšā (no mugurpuses)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25895,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(downward [modification, higher position] + enclosure: the arrow going downward into an enclosure) - Character (superimposed - modified)',
    english: 'into (downward)',
    swedish: 'in i (nedåt)',
    norwegian: 'inni (nedover)',
    finnish: '',
    hungarian: '',
    german: 'in…hinein (abwärts)',
    dutch: 'in (neerwaarts), ingang (neerwaarts), erin (neerwaarts)',
    afrikaans: 'in (afwaartse)',
    russian: 'в, во внутрь (ввниз)',
    latvian: 'iekšā (no apakšas)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25896,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(upward [modification, lower position] + enclosure: the arrow going upward into an enclosure) - Character (superimposed - modified)',
    english: 'into (upward)',
    swedish: 'in i (uppåt)',
    norwegian: 'inni (oppover)',
    finnish: '',
    hungarian: '',
    german: 'in…hinein (aufwärts)',
    dutch: 'in (opwaarts), ingang (opwaarts), erin (opwaarts)',
    afrikaans: 'in (opwaartse)',
    russian: 'в, во внутрь (вверх)',
    latvian: 'iekšā (no aukšas)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25972,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation: '(pictograph) - Character',
    english: 'zigzag line',
    swedish: 'sicksacklinje',
    norwegian: 'sikksakklinje',
    finnish: '',
    hungarian: '',
    german: 'geknickter Linienzug',
    dutch: 'zigzag lijn',
    afrikaans: 'sig-sag lyn',
    russian: 'зигзагообразная линия',
    latvian: 'zigzaga līnija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26040,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(body + hair (on top)) - Character (superimposed)',
    english: 'body with mane',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26041,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(body + dot) - Character (superimposed)',
    english: 'body with navel',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26042,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(body + hair (at bottom)) - Character (superimposed)',
    english: 'body with pubic hair',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26043,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(house + pictograph of attic) - Character (superimposed)',
    english: 'building with attic',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26044,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(house + pictograph of cellar) - Character (superimposed)',
    english: 'building with cellar',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26045,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(house + pictograph of chimney) - Character (superimposed)',
    english: 'building with chimney',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26046,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(house + pictograph of foundation) - Character (superimposed)',
    english: 'building with foundation',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26047,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(house + pictograph of storey) - Character (superimposed)',
    english: 'building with storey',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26048,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(house + pictograph of yard and fence) - Character (superimposed)',
    english: 'building with yard and fence',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26049,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(house + ground + house) - Character (superimposed)',
    english: 'buildings with courtyard',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26050,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(bulb + flower) - Character (superimposed)',
    english: 'bulbous plant',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26051,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(eye + line [half-sized, above]) - Character (superimposed)',
    english: 'eye with eyebrow',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26052,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(face + hair [modification, below chin]) - Character (superimposed - modified)',
    english: 'face with beard',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26053,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(face + dot (on cheek)) - Character (superimposed)',
    english: 'face with pimple',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26054,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(animal + hair (on top)) - Character (superimposed)',
    english: 'furred animal',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26055,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(head + pictograph of neck) - Character (superimposed)',
    english: 'throat',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26056,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(head + hair [modification, on top of head]) - Character (superimposed - modified)',
    english: 'head with hair',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26057,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(mountain + ground + mountain [modification, mirrored]) - Character (superimposed - modified)',
    english: 'mountains with valley',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26058,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(body + down, downward) - Character (superimposed)',
    english: 'out of body (downward), excretion',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26059,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph of pointer or arrowhead: pointing downward, but can be in any of 8 directions) - Character',
    english: 'pointer, arrowhead',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26060,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph of small pointer or arrowhead: pointing downward, but can be in any of 8 directions) - Character',
    english: 'pointer, arrowhead (small)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26061,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(ground [modification, prolonged] + car) - Character (superimposed - modified)',
    english: 'road and car',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26062,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(car, automobile, motor vehicle + pointer to steering wheel) - Character (superimposed - pointer)',
    english: 'steering wheel',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26063,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(ground + house) - Character (superimposed)',
    english: 'street and building',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26064,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(one (digit), 1 [modification, higher position] + slash (slanted line) + three (digit), 3: a common way to write 1/3) - Character (superimposed - modified)',
    english: 'one third',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26065,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(two (digit), 2 [modification, higher position] + slash (slanted line) + three (digit), 3: a common way to write 2/3) - Character (superimposed - modified)',
    english: 'two thirds',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26066,
    group: 'character',
    pos: 'WHITE',
    derivationExplanation:
      '(three (digit), 3 [modification, higher position] + slash (slanted line) + four (digit), 4: a common way to write ¾) - Character (superimposed - modified)',
    english: 'three quarters',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26165,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(earth, ground, land [half-sized]) - Character',
    english: 'environs',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26197,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(drum (1) + pointer, to the membrane of the drum skin) - Character (superimposed - pointer)',
    english: 'membrane, drumhead, drum skin',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26211,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sun + pointer, to northeast) - Character (superimposed - pointer)',
    english: 'northeast',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26212,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sun + pointer, to northwest) - Character (superimposed - pointer)',
    english: 'northwest',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26245,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sun + pointer, to southeast) - Character (superimposed - pointer)',
    english: 'southeast',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26246,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation: '(sun + pointer, to southwest) - Character (superimposed - pointer)',
    english: 'southwest',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26323,
    group: 'character',
    pos: 'YELLOW',
    derivationExplanation:
      '(head + pointer to the top of the head) - Character (superimposed - pointer)',
    english: 'pate, crown (body part)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 12375,
    group: 'deprecated',
    pos: 'BLUE',
    derivationExplanation:
      '(angel (1) + God: winged person sent by God) SUPERSEDED SYNONYM See angel (1) 20571 and angel (2) 20570',
    english: 'angel (OLD)',
    swedish: 'ängel (FD)',
    norwegian: 'engel (OLD)',
    finnish: 'enkeli (vanha)',
    hungarian: 'angyal (régi jelkép)',
    german: 'Engel (ALT)',
    dutch: 'engel (OUD)',
    afrikaans: 'engel (OUD)',
    russian: 'ангел (СТАРОЕ зн.)',
    latvian: 'eņģelis (novec.)',
    polish: 'anioł (stare)',
    french: 'ange (ancien)',
    spanish: 'ángel (ANTIGUO)',
  },
  {
    av: 12602,
    group: 'deprecated',
    pos: 'WHITE',
    derivationExplanation:
      '(reference line [half-sized] + arrowhead: full square between reference line and arrowhead emphasizes distance. This symbol is a simplified form of departure.) - Character (sequenced) SUPERSEDED SYNONYM See away, at a distance, off 25522',
    english: 'away, at a distance, off (OLD)',
    swedish: 'iväg, bort (FD)',
    norwegian: 'bort fra, bort, på avstand (OLD)',
    finnish: 'pois, poissa (vanha)',
    hungarian: 'el-, tól, től (távolságra valamitől) (régi jelkép)',
    german: 'weg, fort, entfernt (von) (ALT)',
    dutch: 'van, vanuit, weg (OUD)',
    afrikaans: "weg, ver, op 'n afstand, 'n afstand van (OUD)",
    russian: 'вдали, прочь (СТАРОЕ зн)',
    latvian: 'prom, atstatus (novec.)',
    polish: 'daleko, w odległości, odległość (stare)',
    french: 'loin, au loin (ancien)',
    spanish: 'lejos, a la distancia (ANTIGUO)',
  },
  {
    av: 12624,
    group: 'deprecated',
    pos: 'BLUE',
    derivationExplanation:
      '(group + musical instrument) SUPERSEDED SYNONYM See band, orchestra 24873',
    english: 'band, orchestra (OLD)',
    swedish: 'orkester, band, musikkår (FD)',
    norwegian: 'orkester, band (OLD)',
    finnish: 'yhtye, orkesteri (vanha)',
    hungarian: 'zenekar, együttes (régi jelkép)',
    german: 'Orchester, Band (ALT)',
    dutch: 'band, orkest, fanfare (OUD)',
    afrikaans: 'musiekgroep, orkes (OUD)',
    russian: 'оркестр, инструментальная группа (СТАРОЕ зн.)',
    latvian: 'instrumentāla grupa, orķestris (novec.)',
    polish: 'zespół, orkiestra (stare)',
    french: 'groupe musical, orchestre (ancien)',
    spanish: 'banda, orquesta (ANTIGUO)',
  },
  {
    av: 12641,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(tennis (activity) (OLD) + beach) SUPERSEDED SYNONYM See beach tennis (activity) 25981',
    english: 'beach tennis (activity) (OLD)',
    swedish: 'strandtennis (aktivitet) (FD)',
    norwegian: 'strandtennis (OLD)',
    finnish: 'rantatennis (vanha)',
    hungarian: 'strandlabda (játék, sport) (régi jelkép)',
    german: 'Strandtennis (Aktivität) (ALT)',
    dutch: 'strandtennis (OUD)',
    afrikaans: 'strandtennis (aktiwiteit) (OUD)',
    russian: 'пляжный теннис (СТАРОЕ зн)',
    latvian: 'pludmales teniss (novec.)',
    polish: 'tenis plażowy (aktywności) (stare)',
    french: 'tennis de plage (activité) (ancien)',
    spanish: 'tenis de playa (actividad) (ANTIGUO)',
  },
  {
    av: 12670,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(outside + limit(s), limitation (OLD) + description indicator) SUPERSEDED SYNONYM See beyond, past 25983',
    english: 'beyond, past (OLD)',
    swedish: 'bortom (FD)',
    norwegian: 'bortenfor (OLD)',
    finnish: 'ulkopuolella, entinen (vanha)',
    hungarian: 'túl, valamin kívül, amott (régi jelkép)',
    german: 'jenseits, vorbei (ALT)',
    dutch: 'voorbij, verder dan (OUD)',
    afrikaans: 'verby, verlede, buite, afgelope (OUD)',
    russian: 'запредельный (СТАРОЕ зн)',
    latvian: 'pāri, pēc (novec.)',
    polish: 'poza czymś, w przeszłości (stare)',
    french: "au-delà, de l'autre côté de (ancien)",
    spanish: 'más allá (ANTIGUO)',
  },
  {
    av: 12878,
    group: 'deprecated',
    pos: 'BLUE',
    derivationExplanation:
      '(person + to guide + work: person who directs work) SUPERSEDED SYNONYM See boss, supervisor 24849',
    english: 'boss, supervisor (OLD)',
    swedish: 'chef, arbetsledare, föreståndare (FD)',
    norwegian: 'sjef, arbeidsleder (OLD)',
    finnish: 'johtaja, työnjohtaja, esimies (vanha)',
    hungarian: 'főnök, felügyelő (hivatal, munkahely) (régi jelkép)',
    german: 'Chef, Chefin (ALT)',
    dutch: 'baas, opzichter (OUD)',
    afrikaans: 'baas, toesighouer (OUD)',
    russian: 'начальник (СТАРОЕ зн)',
    latvian: 'priekšnieks, pārraugs (novec.)',
    polish: 'szef, nadzorca, kierownik (stare)',
    french: 'chef, patron (ancien)',
    spanish: 'jefe, supervisor (ANTIGUO)',
  },
  {
    av: 12883,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(tube + bowel movement) SUPERSEDED SYNONYM See intestine(s), bowel(s), gut(s) 25460',
    english: 'bowel, intestine (OLD)',
    swedish: 'tarm (FD)',
    norwegian: 'tarm (OLD)',
    finnish: 'suoli, suolisto (vanha)',
    hungarian: 'bél (régi jelkép)',
    german: 'Darm (ALT)',
    dutch: 'darm (OUD)',
    afrikaans: 'derm (OUD)',
    russian: 'прямая кишка (СТАРОЕ зн)',
    latvian: 'zarna, zarnas, iekšas (novec.)',
    polish: 'jelito cienkie, jelito grube, wnętrzności, jelita (stare)',
    french: 'boyau, intestin (ancien)',
    spanish: 'intestinos (ANTIGUO)',
  },
  {
    av: 13090,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(platform + earth [modification, extended] + bus) - Character (superimposed - modified) SUPERSEDED SYNONYM and SUPERSEDED CHARACTER See bus stop, bus bay 24041',
    english: 'bus stop, bus bay (OLD)',
    swedish: 'busshållplats (FD)',
    norwegian: 'bussholdeplass (OLD)',
    finnish: 'linja-autopysäkki, bussipysäkki (vanha)',
    hungarian: 'buszmegálló (régi jelkép)',
    german: 'Bushaltestelle (ALT)',
    dutch: 'bushalte (OUD)',
    afrikaans: 'bus stop, bushalte (OUD)',
    russian: 'автобусная остановка (СТАРОЕ зн)',
    latvian: 'autobusu pietura, autoosta (novec.)',
    polish: 'zatoczka autobusowa (stare)',
    french: 'arrêt de bus (ancien)',
    spanish: 'parada de autobús, andén para autobús (ANTIGUO)',
  },
  {
    av: 13118,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(food + sweet + intensity) SUPERSEDED SYNONYM See candy 22375',
    english: 'candy (OLD)',
    swedish: 'godis (FD)',
    norwegian: 'godteri (OLD)',
    finnish: 'karamelli (vanha), makeinen (vanha)',
    hungarian: 'cukorka (régi jelkép)',
    german: 'Süßigkeit, Bonbon (ALT)',
    dutch: 'snoep (OUD)',
    afrikaans: 'lekkergoed (OUD)',
    russian: 'сласть (СТАРОЕ зн)',
    latvian: 'saldumi, stiklenes (novec.)',
    polish: 'cukierek (stare)',
    french: 'bonbon (ancien)',
    spanish: 'caramelo (ANTIGUO)',
  },
  {
    av: 13146,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + to doubt + description indicator) SUPERSEDED SYNONYM See certain, sure 24049',
    english: 'certain (OLD)',
    swedish: 'säker (FD)',
    norwegian: 'sikker (OLD)',
    finnish: 'varma (vanha)',
    hungarian: 'bizonyos, biztos (régi jelkép)',
    german: 'sicher, gewiss, bestimmt (ALT)',
    dutch: 'zeker (OUD)',
    afrikaans: 'seker, verseker (OUD)',
    russian: 'определенный, несомненный (СТАРОЕ зн)',
    latvian: 'noteikts, konkrēts (novec.)',
    polish: 'pewność, brak wątpliwości (stare)',
    french: 'certain (ancien)',
    spanish: 'cierto (ANTIGUO)',
  },
  {
    av: 13155,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + expensive + description indicator) SUPERSEDED SYNONYM See cheap, inexpensive 23039',
    english: 'cheap (OLD)',
    swedish: 'billig (FD)',
    norwegian: 'billig (OLD)',
    finnish: 'halpa (vanha)',
    hungarian: 'olcsó (régi jelkép)',
    german: 'billig (ALT)',
    dutch: 'goedkoop (OUD)',
    afrikaans: 'goedkoop (OUD)',
    russian: 'дешёвый (СТАРОЕ зн)',
    latvian: 'lēts, nedārgs (novec.)',
    polish: 'tanie (stare)',
    french: 'bon marché (contraire de cher) (ancien)',
    spanish: 'barato (ANTIGUO)',
  },
  {
    av: 13171,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(food + powder + brown) SUPERSEDED SYNONYM See chocolate 22905',
    english: 'chocolate (OLD)',
    swedish: 'choklad (FD)',
    norwegian: 'sjokolade (OLD)',
    finnish: 'suklaa (vanha)',
    hungarian: 'csokoládé (régi jelkép)',
    german: 'Schokolade (ALT)',
    dutch: 'chocola (OUD)',
    afrikaans: 'sjokolade (OUD)',
    russian: 'шоколад (СТАРОЕ зн)',
    latvian: 'šokolāde (novec.)',
    polish: 'czekolada (stare)',
    french: 'chocolat (ancien)',
    spanish: 'chocolate (ANTIGUO)',
  },
  {
    av: 13172,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(drink + chocolate [contraction]) SUPERSEDED SYNONYM See chocolate drink 20772',
    english: 'chocolate drink (OLD)',
    swedish: "choklad (dryck), O'boy (FD)",
    norwegian: 'sjokoladedrikk (OLD)',
    finnish: 'kaakao (vanha), suklaajuoma (vanha)',
    hungarian: 'kakaó, kakaóital, csokiital (régi jelkép)',
    german: 'Schokoladenmilch, Kakao, Kakaotrunk (ALT)',
    dutch: 'chocolademelk (OUD)',
    afrikaans: 'sjokolade drankie (OUD)',
    russian: 'горячий шоколад СТАРОЕ зн)',
    latvian: 'šokolādes dzērienis (novec.)',
    polish: 'napój czekoladowy (stare)',
    french: 'chocolat, boisson chocolatée (ancien)',
    spanish: 'batido de chocolate (ANTIGUO)',
  },
  {
    av: 13173,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(adding, additive + chocolate [contraction]) SUPERSEDED SYNONYM See chocolate flavouring 20771',
    english: 'chocolate flavouring, cocoa, cacao powder (OLD)',
    swedish: 'kakao (FD)',
    norwegian: 'sjokoladepulver, kakao (OLD)',
    finnish: 'kaakaojauhe (vanha)',
    hungarian: 'kakaó, kakaópor (régi jelkép)',
    german: 'Kakaopulver, Schokoladenpulver (ALT)',
    dutch: 'cacao, chocoladepoeder (OUD)',
    afrikaans: 'sjokolade gegeurde poeier, kakao (OUD)',
    russian: 'какао (СТАРОЕ зн)',
    latvian: 'kakao (novec.)',
    polish: 'aromat czekoladowy, kakao, proszek kakaowy (stare)',
    french: 'arôme de chocolat (ancien)',
    spanish: 'sabor a chocolate, cacao, polvo de cacao (ANTIGUO)',
  },
  {
    av: 13174,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(spread + chocolate [contraction]) SUPERSEDED SYNONYM See chocolate spread 22906',
    english: 'chocolate spread (OLD)',
    swedish: 'choklad (pålägg) (FD)',
    norwegian: 'sjokoladepålegg (OLD)',
    finnish: 'suklaalevite (vanha), suklaatahna (vanha)',
    hungarian: 'csokoládékrém, -máz, -bevonat (régi jelkép)',
    german: 'Schokoladenaufstrich, Schokoladencreme (ALT)',
    dutch: 'chocoladepasta (OUD)',
    afrikaans: 'sjokoladesmeer (OUD)',
    russian: 'шоколадное масло (СТАРОЕ зн)',
    latvian: 'sokolādes sviests (novec.)',
    polish: 'krem czekoladowy (stare)',
    french: 'choco (ancien)',
    spanish: 'cobertura de chocolate (ANTIGUO)',
  },
  {
    av: 13356,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + dirty + description indicator) SUPERSEDED SYNONYM See clean 24062',
    english: 'clean (OLD)',
    swedish: 'ren (FD)',
    norwegian: 'ren (OLD)',
    finnish: 'puhdas (vanha), siisti (vanha)',
    hungarian: 'tiszta (régi jelkép)',
    german: 'sauber (ALT)',
    dutch: 'schoon, proper (OUD)',
    afrikaans: 'skoon (OUD)',
    russian: 'чистый (СТАРОЕ зн)',
    latvian: 'tīrs (novec.)',
    polish: 'czysty (stare)',
    french: 'propre (ancien)',
    spanish: 'limpio (ANTIGUO)',
  },
  {
    av: 13394,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(machine + mind: machine that works like a mind) SUPERSEDED SYNONYM See computer 23447',
    english: 'computer (OLD)',
    swedish: 'dator (FD)',
    norwegian: 'datamaskin (OLD)',
    finnish: 'tietokone (vanha)',
    hungarian: 'számítógép, kompjúter (régi jelkép)',
    german: 'Computer, PC (ALT)',
    dutch: 'computer (OUD)',
    afrikaans: 'rekenaar (OUD)',
    russian: 'компьютер (СТАРОЕ зн)',
    latvian: 'dators (novec.)',
    polish: 'komputer (stare)',
    french: 'ordinateur (ancien)',
    spanish: 'ordenador (ANTIGUO)',
  },
  {
    av: 13399,
    group: 'deprecated',
    pos: 'BLUE',
    derivationExplanation:
      '(person + to lead + musical note: person who leads or directs musicians) SUPERSEDED SYNONYM See conductor (music) 24811',
    english: 'conductor (music) (OLD)',
    swedish: 'dirigent (FD)',
    norwegian: 'dirigent (OLD)',
    finnish: 'kuoronjohtaja (vanha), orkesterinjohtja (vanha)',
    hungarian: 'karmester (régi jelkép)',
    german: 'Dirigent (ALT)',
    dutch: 'dirigent (OUD)',
    afrikaans: 'dirigent (OUD)',
    russian: 'дирижёр (СТАРОЕ зн)',
    latvian: 'diriģents (novec.)',
    polish: 'dyrygent (muzyka) (stare)',
    french: "chef d'orchestre (ancien)",
    spanish: 'director (música) (ANTIGUO)',
  },
  {
    av: 13428,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(place + sport (OLD): place where sports are played) SUPERSEDED SYNONYM See court, field 22840',
    english: 'court, field (OLD)',
    swedish: 'idrottsplats, idrottsplan (FD)',
    norwegian: 'idrettsplass (OLD)',
    finnish: 'kenttä, urheilukenttä (vanha)',
    hungarian: 'sportpálya (régi jelkép)',
    german: 'Sportplatz, Spielfeld (ALT)',
    dutch: 'hof (OUD)',
    afrikaans: 'veld (sport) (OUD)',
    russian: 'спортивная площадка (СТАРОЕ зн)',
    latvian: 'sporta laukums (novec.)',
    polish: 'boisko, plac zabaw (stare)',
    french: 'court (ancien)',
    spanish: 'pista, campo (ANTIGUO)',
  },
  {
    av: 13437,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(crash (downward) + airplane)',
    english: 'crash (air), plane crash, air crash (OLD)',
    swedish: 'flygkrash',
    norwegian: 'flystyrt',
    finnish: 'lentokone onnettomuus, lentokoneen maahansyöksy',
    hungarian: 'légikatasztrófa, repülőszerencsétlenség',
    german: 'Flugzeugabsturz',
    dutch: 'vliegtuigcrash, vliegtuigongeluk',
    afrikaans: 'vliegtuigongeluk, ongeluk (lug)',
    russian: 'авиакатастрофа',
    latvian: 'avārija (gaisā)',
    polish: 'katastrofa, wypadek (lotnicza)',
    french: "accident d'avion",
    spanish: 'accidente aéreo',
  },
  {
    av: 13438,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(crash (forward) + car) ',
    english: 'crash (car), car crash (OLD)',
    swedish: 'krock (-bil)',
    norwegian: 'bilkrasj, bilkollisjon',
    finnish: 'kolari',
    hungarian: 'autóbaleset, autóütközés',
    german: 'Autounfall, Unfall, Zusammenstoß',
    dutch: 'auto-ongeluk, aanrijding, botsing',
    afrikaans: 'ongeluk (motorvoertuig, kar, motor)',
    russian: 'автокатастрофа',
    latvian: 'autoavārija',
    polish: 'katastrofa, wypadek (samochodowy)',
    french: 'accident de voiture, collision',
    spanish: 'accidente automovilístico',
  },
  {
    av: 13634,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + light + description indicator) SUPERSEDED SYNONYM See dark 23844',
    english: 'dark (OLD)',
    swedish: 'mörk (FD)',
    norwegian: 'mørk (OLD)',
    finnish: 'pimeä (vanha), tumma (vanha)',
    hungarian: 'sötét (régi jelkép)',
    german: 'dunkel (ALT)',
    dutch: 'donker (OUD)',
    afrikaans: 'donker (OUD)',
    russian: 'тёмный (СТАРОЕ зн)',
    latvian: 'tumšs (novec.)',
    polish: 'ciemny, mroczny, bez światła (stare)',
    french: 'sombre (ancien)',
    spanish: 'oscuro (ANTIGUO)',
  },
  {
    av: 13650,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + plus + beautiful: thing added to beautify) SUPERSEDED SYNONYM See decoration, ornament 24079',
    english: 'decoration (OLD)',
    swedish: 'prydnadssak, dekoration (FD)',
    norwegian: 'dekorasjon (OLD)',
    finnish: 'koriste (vanha), kunniamerkki (vanha)',
    hungarian: 'díszítés, dekoráció (régi jelkép)',
    german: 'Dekoration (ALT)',
    dutch: 'versiering (OUD)',
    afrikaans: 'versiering (OUD)',
    russian: 'украшение (СТАРОЕ зн)',
    latvian: 'rotājums (novec.)',
    polish: 'dekoracja, ornament, ozdoba (stare)',
    french: 'décoration (ancien)',
    spanish: 'decoración (ANTIGUO)',
  },
  {
    av: 13654,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(country + three Danish waters (OLD): country divided by three channels of water) SUPERSEDED SYNONYM See Denmark 25991',
    english: 'Denmark (OLD)',
    swedish: 'Danmark (FD)',
    norwegian: 'Danmark (OLD)',
    finnish: 'Tanska (vanha)',
    hungarian: 'Dánia (régi jelkép)',
    german: 'Dänemark (ALT)',
    dutch: 'Denemarken (OUD)',
    afrikaans: 'Denemarke (OUD)',
    russian: 'Дания (СТАРОЕ зн)',
    latvian: 'Dānija (novec.)',
    polish: 'Dania (stare)',
    french: 'Danemark (ancien)',
    spanish: 'Dinamarca (ANTIGUO)',
  },
  {
    av: 13681,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(reptile + past: extinct reptile) SUPERSEDED SYNONYM See dinosaur 23477',
    english: 'dinosaur (OLD)',
    swedish: 'dinosaurie (FD)',
    norwegian: 'dinosaurus (OLD)',
    finnish: 'dinosaurus (vanha)',
    hungarian: 'dinoszaurusz (régi jelkép)',
    german: 'Dinosaurier (ALT)',
    dutch: 'dinosaurus (OUD)',
    afrikaans: 'dinosourus (OUD)',
    russian: 'динозавр (СТАРОЕ зн)',
    latvian: 'dinozaurs (novec.)',
    polish: 'dinozaur (stare)',
    french: 'dinosaure (ancien)',
    spanish: 'dinosaurio (ANTIGUO)',
  },
  {
    av: 13684,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(ability + limits: limited ability) SUPERSEDED SYNONYM See disability, handicap, impairment 25992',
    english: 'disability, handicap, impairment (OLD)',
    swedish: 'handikapp (FD)',
    norwegian: 'handikap, funksjonshemming (OLD)',
    finnish: 'vamma (vanha)',
    hungarian: 'fogyatékosság, akadályozottság, korlátozottság (régi jelkép)',
    german: 'Behinderung, Körperbehinderung (ALT)',
    dutch: 'handicap, beperking (OUD)',
    afrikaans: 'gestremdheid, gestremde, beperking, benadeling (OUD)',
    russian: 'инвалидность (СТАРОЕ зн)',
    latvian: 'invaliditāte, handikaps (novec.)',
    polish: 'niepełnosprawność (stare)',
    french: 'handicap, incapacité (ancien)',
    spanish: 'discapacidad (ANTIGUO)',
  },
  {
    av: 13880,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(bean + dry) SUPERSEDED SYNONYM See bean (dried), chick-pea, kidney bean, pinto bean 24021',
    english: 'dried bean (OLD)',
    swedish: 'torkad böna (FD)',
    norwegian: 'bønne tørket (OLD)',
    finnish: 'kuivattu papu (vanha)',
    hungarian: 'szárazbab (régi jelkép)',
    german: 'getrocknete Bohne (ALT)',
    dutch: 'gedroogde bonen (OUD)',
    afrikaans: 'gedroogte boontjie (OUD)',
    russian: 'фасоль сушёная (СТАРОЕ зн)',
    latvian: 'kaltētas pupas (novec.)',
    polish: 'suszona fasola (stare)',
    french: 'haricot sec (ancien)',
    spanish: 'habichuela seca (ANTIGUO)',
  },
  {
    av: 13887,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + wet + description after the fact indicator) SUPERSEDED SYNONYM See dry 23857',
    english: 'dry (OLD)',
    swedish: 'torr (FD)',
    norwegian: 'tørr (OLD)',
    finnish: 'kuiva (vanha)',
    hungarian: 'száraz (régi jelkép)',
    german: 'trocken (ALT)',
    dutch: 'droog (OUD)',
    afrikaans: 'dry (OUD)',
    russian: 'сухой (СТАРОЕ зн)',
    latvian: 'sauss (novec.)',
    polish: 'suchy, sucha, suche (stare)',
    french: 'sec (ancien)',
    spanish: 'seco (ANTIGUO)',
  },
  {
    av: 13888,
    group: 'deprecated',
    pos: 'RED',
    derivationExplanation:
      '(to cause + dry + action indicator) SUPERSEDED SYNONYM See dry-(to) 23858',
    english: 'dry-(to) (OLD)',
    swedish: 'torka (FD)',
    norwegian: 'tørke (OLD)',
    finnish: 'kuivata (vanha)',
    hungarian: 'szárítani (meg-, ki-) (régi jelkép)',
    german: 'trocknen (ALT)',
    dutch: 'drogen, afdrogen (OUD)',
    afrikaans: 'afdroog (om af te droog) (om te) (OUD)',
    russian: 'сушить (СТАРОЕ зн)',
    latvian: 'žāvēt (novec.)',
    polish: 'suszyć (stare)',
    french: 'sécher (ancien)',
    spanish: 'secar (ANTIGUO)',
  },
  {
    av: 13905,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + difficult + description indicator) SUPERSEDED SYNONYM See easy, easily 23861',
    english: 'easy (OLD)',
    swedish: 'enkel, lätt (FD)',
    norwegian: 'lett, enkel (OLD)',
    finnish: 'helppo (vanha)',
    hungarian: 'könnyű, egyszerű (régi jelkép)',
    german: 'leicht, nicht schwierig (ALT)',
    dutch: 'gemakkelijk (OUD)',
    afrikaans: 'maklik (OUD)',
    russian: 'легко, просто (СТАРОЕ зн)',
    latvian: 'viegli (novec.)',
    polish: 'łatwy, łatwe (stare)',
    french: 'facile (ancien)',
    spanish: 'fácil (ANTIGUO)',
  },
  {
    av: 13921,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + electricity + thing indicator)',
    english: 'electric wire, electric cord, cord, cable, lead (OLD)',
    swedish: 'sladd, ledning',
    norwegian: 'ledning, kabel',
    finnish: 'sähköjohto',
    hungarian: 'elektromos vezeték, kábel, huzal',
    german: 'Elektrokabel',
    dutch: 'elektrisch snoer, snoer, draad (elektrisch)',
    afrikaans: 'elektries draad, koord, kabel',
    russian: 'провод, кабель',
    latvian: 'elektrības vads, elektrības kabelis',
    polish: 'kabel elektryczny, przewód',
    french: 'fil électrique, câble électrique',
    spanish: 'cable eléctrico',
  },
  {
    av: 13932,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + full + description indicator) SUPERSEDED SYNONYM See empty 23863',
    english: 'empty (OLD)',
    swedish: 'tom (FD)',
    norwegian: 'tom (OLD)',
    finnish: 'tyhjä (vanha)',
    hungarian: 'üres (régi jelkép)',
    german: 'leer (ALT)',
    dutch: 'leeg (OUD)',
    afrikaans: 'leeg (OUD)',
    russian: 'пустой (СТАРОЕ зн)',
    latvian: 'tukšs (novec.)',
    polish: 'puste (stare)',
    french: 'vide (ancien)',
    spanish: 'vacío (ANTIGUO)',
  },
  {
    av: 13933,
    group: 'deprecated',
    pos: 'RED',
    derivationExplanation:
      '(empty + action indicator) SUPERSEDED SYNONYM See empty, evacuate, throw away, void-(to) 23864',
    english: 'empty-(to) (OLD)',
    swedish: 'tömma (FD)',
    norwegian: 'tømme(OLD)',
    finnish: 'tyhjentää (vanha)',
    hungarian: 'kiüríteni, kiönteni (régi jelkép)',
    german: 'leeren, ausleeren, entleeren, ausschütten (ALT)',
    dutch: 'ledigen, leegmaken (OUD)',
    afrikaans: 'leegmaak (om te) (OUD)',
    russian: 'опустошить (СТАРОЕ зн)',
    latvian: 'tukšs (novec.)',
    polish: 'opróżniać, wyrzucać (stare)',
    french: 'vider (ancien)',
    spanish: 'vaciar (ANTIGUO)',
  },
  {
    av: 14129,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(much + cost + description indicator: costing a lot of money) SUPERSEDED SYNONYM See expensive 23080',
    english: 'expensive (OLD)',
    swedish: 'dyr (FD)',
    norwegian: 'dyrt, dyr (OLD)',
    finnish: 'kallis (vanha)',
    hungarian: 'drága, költséges (régi jelkép)',
    german: 'teuer (ALT)',
    dutch: 'duur (OUD)',
    afrikaans: 'duur (OUD)',
    russian: 'дорогой (СТАРОЕ зн)',
    latvian: 'dārgs (novec.)',
    polish: 'drogo (stare)',
    french: 'cher, coûteux (ancien)',
    spanish: 'caro (ANTIGUO)',
  },
  {
    av: 14150,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(farness, remoteness, farawayness (OLD) + description indicator: a full space between the two lines, the lines are relatively far apart) SUPERSEDED SYNONYM See far, distant 26002',
    english: 'far, distant (OLD)',
    swedish: 'långt bort, avlägsen (FD)',
    norwegian: 'fjernt, langt borte (OLD)',
    finnish: 'kaukana, kaukainen (vanha)',
    hungarian: 'távoli, messzi (régi jelkép)',
    german: 'entfernt, fern (ALT)',
    dutch: 'ver (OUD)',
    afrikaans: 'ver (OUD)',
    russian: 'далеко (СТАРОЕ зн)',
    latvian: 'tāls, attāls (novec.)',
    polish: 'odległy, oddalony (stare)',
    french: 'éloigné, loin (ancien)',
    spanish: 'lejos, distante (ANTIGUO)',
  },
  {
    av: 14156,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(fatness, thickness (OLD) + description indicator: the pointers point inward to the widest space bounded by the reference lines) SUPERSEDED SYNONYM See fat, thick 26003',
    english: 'fat, thick (OLD)',
    swedish: 'tjock, fet (FD)',
    norwegian: 'tykk, fet (OLD)',
    finnish: 'lihava, paksu (vanha)',
    hungarian: 'kövér, vastag (régi jelkép)',
    german: 'dick, fett (ALT)',
    dutch: 'dik (OUD)',
    afrikaans: 'vet, dik (OUD)',
    russian: 'толстый (СТАРОЕ зн)',
    latvian: 'resns, biezs (novec.)',
    polish: 'grube, szerokie (stare)',
    french: 'gros, gras (ancien)',
    spanish: 'gordo, grueso (ANTIGUO)',
  },
  {
    av: 14171,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + much/many + description indicator) SUPERSEDED SYNONYM See few, little 24111',
    english: 'few, little (OLD)',
    swedish: 'lite, få (FD)',
    norwegian: 'få, lite (OLD)',
    finnish: 'vähän, harvat (vanha)',
    hungarian: 'kevés, kicsi (régi jelkép)',
    german: 'wenig (ALT)',
    dutch: 'weinig, beetje (OUD)',
    afrikaans: 'weinig, min, bietjie (OUD)',
    russian: 'мало, немного (СТАРОЕ зн)',
    latvian: 'maz, nedaudz (novec.)',
    polish: 'mało (przeciwieństwo dużo) (stare)',
    french: 'peu de (ancien)',
    spanish: 'pocos (ANTIGUO)',
  },
  {
    av: 14376,
    group: 'deprecated',
    pos: 'RED',
    derivationExplanation:
      '(opposite meaning + to lead + action indicator) SUPERSEDED SYNONYM See follow-(to) 21053',
    english: 'follow-(to) (OLD)',
    swedish: 'följa (FD)',
    norwegian: 'følge (OLD)',
    finnish: 'seurata (vanha)',
    hungarian: 'követni (régi jelkép)',
    german: 'folgen (ALT)',
    dutch: 'volgen (OUD)',
    afrikaans: 'volg (om te) (OUD)',
    russian: 'следовать (СТАРОЕ зн)',
    latvian: 'sekot (novec.)',
    polish: 'iść za, podążać za, naśladować (stare)',
    french: 'suivre (ancien)',
    spanish: 'seguir (ANTIGUO)',
  },
  {
    av: 14398,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(potato + linear thing + plural indicator + thing indicator: potatoes cut in strips) SUPERSEDED SYNONYM See French fries, chips 24657',
    english: 'French fries, chips (OLD)',
    swedish: 'pommes frites (FD)',
    norwegian: 'chips, pommes frites (OLD)',
    finnish: 'ranskalaiset perunat (vanha)',
    hungarian: 'hasábburgonya, szalmakrumpli (régi jelkép)',
    german: 'Pommes frites, Pommes (ALT)',
    dutch: 'frieten (Vl), patates frites (Nl), friet (OUD)',
    afrikaans: 'aartappelskyfies (OUD)',
    russian: 'картофель фри (СТАРОЕ зн)',
    latvian: 'kartupeļu čipsi (novec.)',
    polish: 'frytki (stare)',
    french: 'frites (ancien)',
    spanish: 'patatas fritas (ANTIGUO)',
  },
  {
    av: 14400,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 6: sixth day of the week - based on the convention of Sunday being the first) SUPERSEDED SYNONYM See Friday (day5) 25064, Friday (day6) 25065, Friday (day7) 25066',
    english: 'Friday (OLD)',
    swedish: 'fredag (FD)',
    norwegian: 'fredag (OLD)',
    finnish: 'perjantai (vanha)',
    hungarian: 'szombat (régi jelkép)',
    german: 'Freitag (ALT)',
    dutch: 'vrijdag (OUD)',
    afrikaans: 'Vrydag (OUD)',
    russian: 'пятница (СТАРОЕ зн)',
    latvian: 'piekdiena (novec.)',
    polish: 'piątek (stare)',
    french: 'vendredi (ancien)',
    spanish: 'Viernes (ANTIGUO)',
  },
  {
    av: 14436,
    group: 'deprecated',
    pos: 'BLUE',
    derivationExplanation:
      '(person + transparent: person that you can see through) SUPERSEDED SYNONYM See ghost, phantom 23520',
    english: 'ghost (OLD)',
    swedish: 'ande, spöke, vålnad (FD)',
    norwegian: 'spøkelse (OLD)',
    finnish: 'aave (vanha), kummitus (vanha), haamu (vanha)',
    hungarian: 'kísértet, szellem (régi jelkép)',
    german: 'Gespenst (ALT)',
    dutch: 'spook, geest (OUD)',
    afrikaans: 'spook, gees (OUD)',
    russian: 'дух, призрак (СТАРОЕ зн)',
    latvian: 'gars, spoks (novec.)',
    polish: 'duch (stare)',
    french: 'fantôme (ancien)',
    spanish: 'fantasma (ANTIGUO)',
  },
  {
    av: 14462,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(group + leadership + country) SUPERSEDED SYNONYM See government 24812',
    english: 'government (OLD)',
    swedish: 'regering (FD)',
    norwegian: 'regjering (OLD)',
    finnish: 'hallitus (vanha)',
    hungarian: 'kormány, ország iránító szerve (régi jelkép)',
    german: 'Regierung (ALT)',
    dutch: 'regering (OUD)',
    afrikaans: 'regering (OUD)',
    russian: 'правительство (СТАРОЕ зн)',
    latvian: 'valdība (novec.)',
    polish: 'rząd (stare)',
    french: 'gouvernment (ancien)',
    spanish: 'gobierno (ANTIGUO)',
  },
  {
    av: 14645,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(store (OLD) + food) SUPERSEDED SYNONYM See grocery store, food store, supermarket 23102',
    english: 'grocery store, food store, supermarket (OLD)',
    swedish: 'livsmedelsbutik (FD)',
    norwegian: 'matbutikk, supermarked (OLD)',
    finnish: 'ruokakauppa (vanha), marketti (vanha)',
    hungarian: 'élelmiszerbolt, szupermarket (régi jelkép)',
    german: 'Supermarkt, Lebensmittelgeschäft, Lebensmittelladen (ALT)',
    dutch: 'supermarkt (OUD)',
    afrikaans: 'supermark, kruidenierswinkel (OUD)',
    russian: 'магазин (продуктовый) (СТАРОЕ зн)',
    latvian: 'pārtikas veikals, lielveikals (novec.)',
    polish: 'sklep spożywczy (stare)',
    french: 'épicerie (ancien)',
    spanish: 'almacén, tienda, supermercado (ANTIGUO)',
  },
  {
    av: 14656,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(room + activity + health: room for activity that keeps one healthy) SUPERSEDED SYNONYM See gym, gymnasium 26005',
    english: 'gym, gymnasium (OLD)',
    swedish: 'gymnastiksal, gym (FD)',
    norwegian: 'gymsal (OLD)',
    finnish: 'voimistelusali (vanha)',
    hungarian: 'tornaterem, tornacsarnok (régi jelkép)',
    german: 'Turnhalle, Gymnastikhalle (ALT)',
    dutch: 'gymzaal, sportzaal (OUD)',
    afrikaans: 'gimnasium (OUD)',
    russian: 'спортзал (СТАРОЕ зн)',
    latvian: 'sporta zāle (novec.)',
    polish: 'siłownia, sala gimnastyczna (stare)',
    french: 'gymnase (ancien)',
    spanish: 'gimnasio (ANTIGUO)',
  },
  {
    av: 14657,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(floor covering + sport (OLD): floor covering used for sports) SUPERSEDED SYNONYM See gym mat 26006',
    english: 'gym mat (OLD)',
    swedish: 'gymnastikmatta (FD)',
    norwegian: 'gymmatte (OLD)',
    finnish: 'voimistelumatto (vanha)',
    hungarian: 'tornamatrac, polifóm (régi jelkép)',
    german: 'Gymnastikmatte (ALT)',
    dutch: 'mat (gym, turnen) (OUD)',
    afrikaans: 'oefen mat (OUD)',
    russian: 'гимнастические маты (СТАРОЕ зн)',
    latvian: 'vingrošanas paklājs (novec.)',
    polish: 'mata / materac do ćwiczeń (stare)',
    french: 'tapis de gym (ancien)',
    spanish: 'alfombra de gimnasia (ANTIGUO)',
  },
  {
    av: 14662,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + ghost (OLD): day for ghosts) SUPERSEDED SYNONYM See Halloween 26007',
    english: 'Halloween (OLD)',
    swedish: 'Halloween (FD)',
    norwegian: 'Halloween (OLD)',
    finnish: 'halloween, pyhäinpäivä (vanha)',
    hungarian: 'Halloween, Mindenszentek előestéje (régi jelkép)',
    german: 'Halloween (ALT)',
    dutch: 'Allerheiligen, Halloween (OUD)',
    afrikaans: "Halloween, All Saint's Day (OUD)",
    russian: 'Хэллоуин (СТАРОЕ зн)',
    latvian: 'Helovīns, Visu Svēto dienas priekšvakars (novec.)',
    polish: 'Halloween, Dzień wszystkich Świętych (stare)',
    french: 'halloween, Toussaint (ancien)',
    spanish: 'halloween (ANTIGUO)',
  },
  {
    av: 14664,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(roll + meat) SUPERSEDED SYNONYM See hamburger 20770',
    english: 'hamburger (OLD)',
    swedish: 'hamburgare (FD)',
    norwegian: 'hamburger (OLD)',
    finnish: 'hampurilainen (vanha)',
    hungarian: 'hamburger (régi jelkép)',
    german: 'Hamburger (ALT)',
    dutch: 'hamburger (OUD)',
    afrikaans: 'frikkadelbroodjie, hamburger (OUD)',
    russian: 'котлета, гамбургер (СТАРОЕ зн)',
    latvian: 'kotlete, hamburgers (novec.)',
    polish: 'hamburger (stare)',
    french: 'hamburger (ancien)',
    spanish: 'hamburguesa (ANTIGUO)',
  },
  {
    av: 14679,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + soft + description indicator) SUPERSEDED SYNONYM See hard, firm 20530',
    english: 'hard (OLD)',
    swedish: 'hård (FD)',
    norwegian: 'hard (OLD)',
    finnish: 'kova (vanha)',
    hungarian: 'kemény (régi jelkép)',
    german: 'hart (ALT)',
    dutch: 'hard (OUD)',
    afrikaans: 'hard (OUD)',
    russian: 'твёрдый (СТАРОЕ зн)',
    latvian: 'ciets (novec.)',
    polish: 'twardy, stały, zbity (stare)',
    french: 'dur (ancien)',
    spanish: 'duro (ANTIGUO)',
  },
  {
    av: 14683,
    group: 'deprecated',
    pos: 'RED',
    derivationExplanation:
      '(opposite meaning + to love + action indicator) SUPERSEDED SYNONYM See hate-(to) 23883',
    english: 'hate-(to) (OLD)',
    swedish: 'hata, avsky (FD)',
    norwegian: 'hate (OLD)',
    finnish: 'vihata (vanha)',
    hungarian: 'gyűlölni, utálni, nem szeretni (régi jelkép)',
    german: 'etwas ungern tun, etwas ungern tun, hassen (ALT)',
    dutch: 'haten (OUD)',
    afrikaans: 'haat (om te) (OUD)',
    russian: 'ненавидеть (СТАРОЕ зн)',
    latvian: 'ienīst (novec.)',
    polish: 'nienawidzić (stare)',
    french: 'haïr (ancien)',
    spanish: 'odiar (ANTIGUO)',
  },
  {
    av: 14686,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(bird + up + intensity: bird that soars)',
    english: 'hawk, eagle (OLD)',
    swedish: 'hök, örn (etc)',
    norwegian: 'hauk, ørn (o l)',
    finnish: 'haukka, kotka',
    hungarian: 'héja, sólyom, sas',
    german: 'Habicht, Falke',
    dutch: 'adelaar',
    afrikaans: 'valk, arend',
    russian: 'ястреб, орёл',
    latvian: 'vanags, ērglis',
    polish: 'ptak drapieżny, jastrząb, orzeł',
    french: 'faucon, aigle',
    spanish: 'halcón, águila',
  },
  {
    av: 14694,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(limit(s), limitation (OLD) + to hear + description indicator) SUPERSEDED SYNONYM See hearing-impaired 26009',
    english: 'hearing-impaired (OLD)',
    swedish: 'hörselskadad (FD)',
    norwegian: 'hørselshemmet (OLD)',
    finnish: 'kuulovammainen (vanha)',
    hungarian: 'hallássérült (régi jelkép)',
    german: ' hörgeschädigt, schwerhörig (ALT)',
    dutch: 'slechthorend, gehoorgestoord (bijv.nw) (OUD)',
    afrikaans: 'gehoorgestremd (OUD)',
    russian: 'нарушенный слух (СТАРОЕ зн)',
    latvian: 'dzirdes traucējums (novec.)',
    polish: 'niedosłyszący (stare)',
    french: 'malentendant (ancien)',
    spanish: 'discapacitado auditivo (ANTIGUO)',
  },
  {
    av: 14699,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + obsolete old pictograph of spines) - Character SUPERSEDED SYNONYM ans SUPERSEDED CHARACTER See hedgehog 23527',
    english: 'hedgehog (OLD)',
    swedish: 'igelkott (FD)',
    norwegian: 'pinnsvin (OLD)',
    finnish: 'siili (vanha)',
    hungarian: 'sün, sündisznó (régi jelkép)',
    german: 'Igel (ALT)',
    dutch: 'egel (OUD)',
    afrikaans: 'ystervark (OUD)',
    russian: 'ёж (СТАРОЕ зн)',
    latvian: 'ezis (novec.)',
    polish: 'jeż (stare)',
    french: 'hérisson (ancien)',
    spanish: 'erizo (ANTIGUO)',
  },
  {
    av: 14703,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(hat + intensity: reinforced hat) SUPERSEDED SYNONYM See helmet 21615',
    english: 'helmet (OLD)',
    swedish: 'hjälm (FD)',
    norwegian: 'hjelm (OLD)',
    finnish: 'kypärä (vanha)',
    hungarian: 'bukósisak (régi jelkép)',
    german: 'Helm (ALT)',
    dutch: 'helm (OUD)',
    afrikaans: 'helmet (OUD)',
    russian: 'шлем (СТАРОЕ зн)',
    latvian: 'ķivere (novec.)',
    polish: 'hełm, kask (stare)',
    french: 'casque (ancien)',
    spanish: 'casco (ANTIGUO)',
  },
  {
    av: 14920,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + sweet + ice: sweet frozen food) SUPERSEDED SYNONYM See ice cream, sherbet, sorbet 22369 (and ice cream (cone) 14921, ice cream (bar) 22370, and ice cream (lollipop) 22366)',
    english: 'ice cream (OLD)',
    swedish: 'glass, sorbet (FD)',
    norwegian: 'is, sorbet (OLD)',
    finnish: 'jäätelö (vanha)',
    hungarian: 'jégkrém (régi jelkép)',
    german: 'Eiskrem, Eisbecher (ALT)',
    dutch: 'ijsje (OUD)',
    afrikaans: 'roomys (OUD)',
    russian: 'мороженое, щербет (СТАРОЕ зн)',
    latvian: 'saldējums, sorbets (novec.)',
    polish: 'lody (stare)',
    french: 'crème glacée (ancien)',
    spanish: 'helado (ANTIGUO)',
  },
  {
    av: 14931,
    group: 'deprecated',
    pos: 'RED',
    derivationExplanation:
      '(to cause + more + correct + action indicator: to cause to be better, in a rational sense.) ',
    english: 'improve-(to) (OLD)',
    swedish: 'förbättra',
    norwegian: 'forbedre',
    finnish: 'parantaa, edistää',
    hungarian: 'javítani, javulni, tökéletesíteni, tökéletesedni',
    german: 'verbessern, sich verbessern, bessern, sich bessern',
    dutch: 'verbeteren',
    afrikaans: 'verbeter, vorder (om te)',
    russian: 'совершенствовать, улучшать',
    latvian: 'uzlabot',
    polish: 'poprawić',
    french: 'améliorer',
    spanish: 'mejorar',
  },
  {
    av: 14940,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(infiniteness, boundlessness, limitlessness (OLD) + description indicator) SUPERSEDED SYNONYM See infinite, limitless 26010',
    english: 'infinite, limitless (OLD)',
    swedish: 'obegränsad (FD)',
    norwegian: 'ubegrenset (OLD)',
    finnish: 'ääretön, rajaton (vanha)',
    hungarian: 'határtalan/ul, korlátlan/ul, végtelen/ül (régi jelkép)',
    german: 'unendlich, unbegrenzt (ALT)',
    dutch: 'oneindig, onbegrensd (OUD)',
    afrikaans: 'oneindig, onbeperk (OUD)',
    russian: 'неограниченный, безграничный (СТАРОЕ зн)',
    latvian: 'bezgalīgs, neierobežots, bezgalīgs (novec.)',
    polish: 'nieskończone, nieograniczone (stare)',
    french: 'illimité, infini (ancien)',
    spanish: 'infinito (ANTIGUO)',
  },
  {
    av: 15156,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(cat + baby) SUPERSEDED SYNONYM See kitten 24474',
    english: 'kitten (OLD)',
    swedish: 'kattunge (FD)',
    norwegian: 'kattunge (OLD)',
    finnish: 'kissanpentu (vanha)',
    hungarian: 'kismacska, kiscica (régi jelkép)',
    german: 'Kätzchen (ALT)',
    dutch: 'poesje, katje (OUD)',
    afrikaans: 'katjie (OUD)',
    russian: 'котёнок (СТАРОЕ зн)',
    latvian: 'kaķēns (novec.)',
    polish: 'kociak (stare)',
    french: 'chaton (ancien)',
    spanish: 'gatito (ANTIGUO)',
  },
  {
    av: 15203,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(opposite meaning + truth) SUPERSEDED SYNONYM See lie 23894',
    english: 'lie (OLD)',
    swedish: 'lögn, osanning (FD)',
    norwegian: 'løgn (OLD)',
    finnish: 'valhe (vanha)',
    hungarian: 'hazugság (régi jelkép)',
    german: 'Lüge (ALT)',
    dutch: 'leugen (OUD)',
    afrikaans: 'lieg, jok, leuen (OUD)',
    russian: 'ложь (СТАРОЕ зн)',
    latvian: 'meli (novec.)',
    polish: 'kłamstwo (stare)',
    french: 'mensonge (ancien)',
    spanish: 'mentira (ANTIGUO)',
  },
  {
    av: 15204,
    group: 'deprecated',
    pos: 'RED',
    derivationExplanation: '(lie + action indicator) SUPERSEDED SYNONYM See lie-(to) 23895',
    english: 'lie-(to) (OLD)',
    swedish: 'ljuga (FD)',
    norwegian: 'lyve (OLD)',
    finnish: 'valehdella (vanha)',
    hungarian: 'hazudni, lódítani, tódítani (régi jelkép)',
    german: 'lügen (ALT)',
    dutch: 'liegen, jokken (OUD)',
    afrikaans: 'lieg, jok (om te), (OUD)',
    russian: 'лгать (СТАРОЕ зн)',
    latvian: 'melot (novec.)',
    polish: 'kłamać (stare)',
    french: 'mentir (ancien)',
    spanish: 'mentir (ANTIGUO)',
  },
  {
    av: 15213,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(two reference lines on the vertical boundaries of the symbol for enclosure, limiting what lies between them) - Character (sequenced) SUPERSEDED SYNONYM and SUPERSEDED CHARACTER See limit(s), limitation, restriction 25579',
    english: 'limit(s), limitation (OLD)',
    swedish: 'begränsning, gränser (FD)',
    norwegian: 'begrensning, grenser (OLD)',
    finnish: 'rajat, rajoitus (vanha)',
    hungarian: 'határ, korlát, limit (régi jelkép)',
    german: 'Begrenzung, Beschränkung, Einschränkung (ALT)',
    dutch: 'grenzen, beperking (OUD)',
    afrikaans: 'beperking (OUD)',
    russian: 'ограничение, границы (СТАРОЕ зн)',
    latvian: 'robeža, ierobežojums (novec.)',
    polish: 'ograniczenie, granice, limit (stare)',
    french: 'limites (ancien)',
    spanish: 'límites, limitación (ANTIGUO)',
  },
  {
    av: 15395,
    group: 'deprecated',
    pos: 'RED',
    derivationExplanation:
      '(opposite meaning + to win + action indicator) SUPERSEDED SYNONYM See lose (fail to win)-(to) 23897',
    english: 'lose (fail to win)-(to) (OLD)',
    swedish: 'förlora (FD)',
    norwegian: 'tape (OLD)',
    finnish: 'hävitä (vanha)',
    hungarian: 'veszíteni, lemaradni (régi jelkép)',
    german: 'verlieren (Spiel) (ALT)',
    dutch: 'verliezen (wedstrijd, spel) (OUD)',
    afrikaans: 'verloor (wedstryd, spel) (om te) (OUD)',
    russian: 'проиграть (СТАРОЕ зн)',
    latvian: 'zaudēt (neizdoties uzvarēt) (novec.)',
    polish: 'przegrać (stare)',
    french: "perdre, n'avoir pas gagné (ancien)",
    spanish: 'perder (no ganar) (ANTIGUO)',
  },
  {
    av: 15457,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      "(limit(s), limitation (OLD) + mind + description indicator: having limits to one's mental abilities) SUPERSEDED SYNONYM See disabled, impaired, handicapped (intellectually, mentally) 25994",
    english: 'disabled, handicapped (intellectually, mentally) (OLD)',
    swedish: 'förståndshandikappad, utvecklingsstörd (FD)',
    norwegian: 'psykisk utviklingshemmet (OLD)',
    finnish: 'kehitysvammainen (vanha)',
    hungarian: 'értelmileg akadályozott (régi jelkép)',
    german: 'geistig behindert (ALT)',
    dutch: 'verstandelijke beperking, mentale handicap (OUD)',
    afrikaans: 'verstandelik gestrem (OUD)',
    russian: 'умственно отсталый (СТАРОЕ зн)',
    latvian: 'invalīds, cilvēks ar īpašām vajadzībām (novec.)',
    polish: 'niepełnosprawny intelektualnie (stare)',
    french: 'handicapé mental (ancien)',
    spanish: 'discapacitado (intelectual o mental) (ANTIGUO)',
  },
  {
    av: 15470,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(milk + to shake)',
    english: 'milkshake (OLD)',
    swedish: 'milkshake, mjölkdrink',
    norwegian: 'milkshake',
    finnish: 'pirtelö',
    hungarian: 'tejes turmix, shake',
    german: 'Milchmixgetränk, Milchshake',
    dutch: 'milkshake',
    afrikaans: 'melkskommel',
    russian: 'молочный коктейль',
    latvian: 'piena kokteilis',
    polish: 'shake (napój mleczny)',
    french: 'milkshake',
    spanish: 'batido de leche',
  },
  {
    av: 15483,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 2: second day of the week - based on the convention of Sunday being the first) SUPERSEDED SYNONYM See Monday (day1) 25113, Monday (day2) 25114, Monday (day3) 25115',
    english: 'Monday (OLD)',
    swedish: 'måndag (FD)',
    norwegian: 'mandag (OLD)',
    finnish: 'maanantai (vanha)',
    hungarian: 'hétfő (régi jelkép)',
    german: 'Montag (ALT)',
    dutch: 'maandag (OUD)',
    afrikaans: 'Maandag (OUD)',
    russian: 'понедельник (СТАРОЕ зн)',
    latvian: 'pirmdiena (novec.)',
    polish: 'poniedziałek (stare)',
    french: 'lundi (ancien)',
    spanish: 'Lunes (ANTIGUO)',
  },
  {
    av: 15676,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(arm + pictograph of bulging biceps + pointer) - Character (superimposed - pointer) SUPERSEDED SYNONYM and SUPERSEDED CHARACTER See muscle 20517',
    english: 'muscle (OLD)',
    swedish: 'muskel (FD)',
    norwegian: 'muskel (OLD)',
    finnish: 'lihas (vanha)',
    hungarian: 'izom (régi jelkép)',
    german: 'Muskel (ALT)',
    dutch: 'spier (OUD)',
    afrikaans: 'spier (OUD)',
    russian: 'мускул, мышца (СТАРОЕ зн)',
    latvian: 'muskulis (novec.)',
    polish: 'mięsień (stare)',
    french: 'muscle (ancien)',
    spanish: 'músculo (ANTIGUO)',
  },
  {
    av: 15709,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + always + description indicator) SUPERSEDED SYNONYM See never 23906',
    english: 'never (OLD)',
    swedish: 'aldrig (FD)',
    norwegian: 'aldri (OLD)',
    finnish: 'ei koskaan (vanha)',
    hungarian: 'soha (régi jelkép)',
    german: 'nie, niemals (ALT)',
    dutch: 'nooit (OUD)',
    afrikaans: 'nooit (OUD)',
    russian: 'никогда (СТАРОЕ зн)',
    latvian: 'nekad (novec.)',
    polish: 'nigdy (stare)',
    french: 'jamais (ancien)',
    spanish: 'nunca (ANTIGUO)',
  },
  {
    av: 15725,
    group: 'deprecated',
    pos: 'WHITE',
    derivationExplanation: '(opposite meaning + all) SUPERSEDED SYNONYM See nothing, none 23907',
    english: 'none, nothing (OLD)',
    swedish: 'ingen, inget, ingenting (FD)',
    norwegian: 'ingen, ingenting (OLD)',
    finnish: 'sipuli (vanha)',
    hungarian: 'semmi (régi jelkép)',
    german: 'nichts (ALT)',
    dutch: 'niets, niks (OUD)',
    afrikaans: 'niks, geen (OUD)',
    russian: 'ничто (СТАРОЕ зн)',
    latvian: 'nekas, neviens, neviena (novec.)',
    polish: 'nic, nikt (stare)',
    french: 'rien (contraire de tout) (ancien)',
    spanish: 'ninguno, nada (ANTIGUO)',
  },
  {
    av: 16170,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      "(limit(s), limitation (OLD) + body + description indicator: having limits to one's physical abilities) SUPERSEDED SYNONYM See disabled, impaired, handicapped (physically) 25995",
    english: 'disabled, handicapped (physically) (OLD)',
    swedish: 'rörelsehindrad (FD)',
    norwegian: 'funksjonshemmet (fysisk), bevegelseshemmet (OLD)',
    finnish: 'liikuntavammainen (vanha)',
    hungarian: 'sérült, fogyatékos, korlátozott (fizikailag) (régi jelkép)',
    german: 'körperbehindert (ALT)',
    dutch: 'motorische beperking, lichamelijk beperking, fysich gehandicapt (OUD)',
    afrikaans: "liggaamlike liggaamlik gestremde (persoon), persoon met 'n gestremdheid (OUD)",
    russian: 'физически неспособный (СТАРОЕ зн)',
    latvian: 'invalīds, cilvēks ar īpašām vajadzībām (ar fizisku invaliditāti) (novec.)',
    polish: 'niepełnosprawny fizycznie (stare)',
    french: 'handicapé physique (ancien)',
    spanish: 'discapacitado (con discapacidad física) (ANTIGUO)',
  },
  {
    av: 16174,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(platform + combination of boat and to float) - Character (superimposed - combined) SUPERSEDED SYNONYM and SUPERSEDED CHARACTER See pier 24857',
    english: 'pier (OLD)',
    swedish: 'brygga, kaj (FD)',
    norwegian: 'brygge, kai (OLD)',
    finnish: 'laituri (vanha)',
    hungarian: 'kikötő (régi jelkép)',
    german: 'Pier, Mole, Anlegestelle (ALT)',
    dutch: 'pier, aanlegsteiger (OUD)',
    afrikaans: 'dok (OUD)',
    russian: 'пристань, причал (СТАРОЕ зн)',
    latvian: 'krastmala (novec.)',
    polish: 'molo, pomost (dla statków) (stare)',
    french: 'quai (bateau), ponton, embarcadère (ancien)',
    spanish: 'muelle (ANTIGUO)',
  },
  {
    av: 16183,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(tennis (activity) (OLD) + table: game like tennis, played on a table) SUPERSEDED SYNONYM See table tennis, ping-pong (activity) 26028',
    english: 'table tennis, ping-pong (activity) (OLD)',
    swedish: 'bordtennis (aktivitet) (FD)',
    norwegian: 'bordtennis (OLD)',
    finnish: 'pöytätennis (vanha)',
    hungarian: 'asztalitenisz, pingpong (játék, sport) (régi jelkép)',
    german: 'Tischtennis, Ping Pong (ALT)',
    dutch: 'tafeltennis, ping pong (OUD)',
    afrikaans: 'tafel tennis (aktiwiteit) (OUD)',
    russian: 'настольный теннис (СТАРОЕ зн)',
    latvian: 'galda teniss (novec.)',
    polish: 'ping-pong, tenis stołowy (stare)',
    french: 'ping-pong, tennis de table (activité) (ancien)',
    spanish: 'ping-pong (ANTIGUO)',
  },
  {
    av: 16198,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(platform + earth [modification, extended] + vehicle) - Character (superimposed - modified) SUPERSEDED SYNONYM and SUPERSEDED CHARACTER See stop, platform (vehicle) 24290',
    english: 'stop, platform (vehicle) (OLD)',
    swedish: 'plattform (FD)',
    norwegian: 'perrong, plattform (OLD)',
    finnish: 'asemalaituri (vanha)',
    hungarian: 'peron, platform (régi jelkép)',
    german: 'Bahnsteig (ALT)',
    dutch: 'perron, platform (OUD)',
    afrikaans: 'perron, platform voertuig (OUD)',
    russian: 'платформа (СТАРОЕ зн)',
    latvian: 'pietura, platforma (novec.)',
    polish: 'peron (na stacji kolejowej) (stare)',
    french: 'quai (véhicule terrestre), arrêt (véhicule terrestre) (ancien)',
    spanish: ' plataforma (vehículo) (ANTIGUO)',
  },
  {
    av: 16222,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(hedgehog (OLD) + teeth: combination of rodent + pictograph of spines (OLD)) SUPERSEDED SYNONYM See porcupine 23620',
    english: 'porcupine (OLD)',
    swedish: 'piggsvin (FD)',
    norwegian: 'pinnsvin-(OLD)',
    finnish: 'piikkisika (vanha)',
    hungarian: 'sün, tarajos sül (régi jelkép)',
    german: 'Stachelschwein (ALT)',
    dutch: 'stekelvarken (OUD)',
    afrikaans: 'ystervark krimpvark (OUD)',
    russian: 'дикобраз (СТАРОЕ зн)',
    latvian: 'dzeloņcūka (novec.)',
    polish: 'jeżozwierz (stare)',
    french: 'porc-épic (ancien)',
    spanish: 'puerco espín (ANTIGUO)',
  },
  {
    av: 16231,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(potato + disc + plural indicator: potatoes cut in disc shapes) SUPERSEDED SYNONYM See potato chip(s), chip(s), crisp(s) 24716',
    english: 'potato chips, crisps (OLD)',
    swedish: 'chips (FD)',
    norwegian: 'potetgull (OLD)',
    finnish: 'perunalastut (vanhat), sipsit (vanhat)',
    hungarian: 'chips, burgonyszirom (régi jelkép)',
    german: 'Kartoffelchip, Chip (ALT)',
    dutch: 'chips (OUD)',
    afrikaans: 'aartappel skyfies (OUD)',
    russian: 'чипсы (СТАРОЕ зн)',
    latvian: 'kartupeļu pārslas, salmiņi, čipsi (novec.)',
    polish: 'chipsy, chrupki ziemniaczane (stare)',
    french: 'pomme de terre chips (ancien)',
    spanish: 'patatas chips (ANTIGUO)',
  },
  {
    av: 16239,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + next + description indicator) SUPERSEDED SYNONYM See preceding, previous, former, earlier 24218',
    english: 'preceding (OLD)',
    swedish: 'föregående (FD)',
    norwegian: 'foregående (OLD)',
    finnish: 'edellinen (vanha), edeltäjä (vanha)',
    hungarian: 'megelőző, előbbi (régi jelkép)',
    german: 'vorhergehend (ALT)',
    dutch: 'voorafgaand (OUD)',
    afrikaans: 'voorafgaande (OUD)',
    russian: 'предыдущий (СТАРОЕ зн)',
    latvian: 'iepriekšējs (novec.)',
    polish: 'poprzedni (stare)',
    french: 'précédent (ancien)',
    spanish: 'anterior (ANTIGUO)',
  },
  {
    av: 16424,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(plum + dry (OLD)) SUPERSEDED SYNONYM See prune 24225',
    english: 'prune (OLD)',
    swedish: 'katrinplommon (FD)',
    norwegian: 'sviske (OLD)',
    finnish: 'kuivattu luumu (vanha)',
    hungarian: 'aszalt szilva (régi jelkép)',
    german: 'Backpflaume, Dörrpflaume (ALT)',
    dutch: 'pruim (gedroogd) (OUD)',
    afrikaans: 'pruimedant, pruim (gedroog) (OUD)',
    russian: 'чернослив (СТАРОЕ зн)',
    latvian: 'žāvētas plūmes (novec.)',
    polish: 'suszona śliwka (stare)',
    french: 'pruneau (ancien)',
    spanish: 'podar (ANTIGUO)',
  },
  {
    av: 16460,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(grape, grapes + dry (OLD)) SUPERSEDED SYNONYM See raisin(s), currant(s) 24231',
    english: 'raisins (OLD)',
    swedish: 'russin (FD)',
    norwegian: 'rosiner, korinter (OLD)',
    finnish: 'rusina (vanha), korintti (vanha)',
    hungarian: 'mazsola (régi jelkép)',
    german: 'Rosine (ALT)',
    dutch: 'rozijn (OUD)',
    afrikaans: 'rosyn (OUD)',
    russian: 'изюм (СТАРОЕ зн)',
    latvian: 'rozīnes (novec.)',
    polish: 'rodzynki (stare)',
    french: 'raisins secs (ancien)',
    spanish: 'pasas (ANTIGUO)',
  },
  {
    av: 16476,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(cupboard + ice + electricity: electrically powered ice box) SUPERSEDED SYNONYM See refrigerator, fridge 23632',
    english: 'refrigerator (OLD)',
    swedish: 'kylskåp, frys (FD)',
    norwegian: 'kjøleskap (OLD)',
    finnish: 'jääkaappi (vanha)',
    hungarian: 'hűtőgép, hűtő, fridzsider, jégszekrény (régi jelkép)',
    german: 'Kühlschrank (ALT)',
    dutch: 'koelkast, ijskast (OUD)',
    afrikaans: 'koelkas, yskas (OUD)',
    russian: 'холодильник (СТАРОЕ зн)',
    latvian: 'ledusskapis (novec.)',
    polish: 'lodówka (stare)',
    french: 'réfrigérateur (ancien)',
    spanish: 'refrigerador (ANTIGUO)',
  },
  {
    av: 16483,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + creation: feeling in relation to creation) SUPERSEDED SYNONYM See religion, naturalism 20563',
    english: 'religion, naturalism (OLD)',
    swedish: 'religion (FD)',
    norwegian: 'religion (OLD)',
    finnish: 'uskonto (vanha)',
    hungarian: 'vallás, hit (régi jelkép)',
    german: 'Religion (ALT)',
    dutch: 'godsdienst, geloof, religie (OUD)',
    afrikaans: 'godsdiens, geloof, naturalisme (OUD)',
    russian: 'религия (СТАРОЕ зн)',
    latvian: 'reliģija (novec.)',
    polish: 'religia, wyznanie (stare)',
    french: 'religion (général) (ancien)',
    spanish: 'religión, naturalismo (ANTIGUO)',
  },
  {
    av: 16484,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(religion + description indicator) SUPERSEDED SYNONYM See religious 20562',
    english: 'religious (OLD)',
    swedish: 'religiös (FD)',
    norwegian: 'religiøs, from (OLD)',
    finnish: 'uskonnollinen (vanha)',
    hungarian: 'vallásos, hívő, természethívő (régi jelkép)',
    german: 'religiös (ALT)',
    dutch: 'religieus (OUD)',
    afrikaans: 'godsdiens (OUD)',
    russian: 'религиозный (СТАРОЕ зн)',
    latvian: 'reliģiozs (novec.)',
    polish: 'religijne (stare)',
    french: 'religieux (ancien)',
    spanish: 'religioso (ANTIGUO)',
  },
  {
    av: 16485,
    group: 'deprecated',
    pos: 'RED',
    derivationExplanation:
      '(opposite meaning + to forget + action indicator) SUPERSEDED SYNONYM See remember, recall-(to) 23634',
    english: 'remember-(to) (OLD)',
    swedish: 'komma ihåg, minnas (FD)',
    norwegian: 'huske (OLD)',
    finnish: 'muistaa (vanha)',
    hungarian: 'emlékezni, felidézni (régi jelkép)',
    german: 'erinnern, sich erinnern (ALT)',
    dutch: 'herinneren, zich herinneren (OUD)',
    afrikaans: 'onhou (om te) (OUD)',
    russian: 'помнить (СТАРОЕ зн)',
    latvian: 'atcerēties (novec.)',
    polish: 'pamiętać, przypominać sobie (stare)',
    french: 'souvenir-(se), rappeler-(se) (ancien)',
    spanish: 'recordar (ANTIGUO)',
  },
  {
    av: 16682,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(horse + to rock) SUPERSEDED SYNONYM See rocking horse 21876',
    english: 'rocking horse (OLD)',
    swedish: 'gunghäst (FD)',
    norwegian: 'gyngehest (OLD)',
    finnish: 'keinuhevonen (vanha)',
    hungarian: 'hintaló (régi jelkép)',
    german: 'Schaukelpferd (ALT)',
    dutch: 'hobbelpaard (OUD)',
    afrikaans: 'wiegperdjie, skommelperd, hobbelperd (OUD)',
    russian: 'конь-качалка (СТАРОЕ зн)',
    latvian: 'šūpuļzirgs (novec.)',
    polish: 'koń na biegunach (stare)',
    french: 'cheval à bascule (ancien)',
    spanish: 'caballo de juguete (ANTIGUO)',
  },
  {
    av: 16706,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests a sail on a mast) - Character SUPERSEDED SYNONYM See sail 20519',
    english: 'sail (OLD)',
    swedish: 'segel (FD)',
    norwegian: 'seil (OLD)',
    finnish: 'purje (vanha)',
    hungarian: 'vitorla (régi jelkép)',
    german: 'Segel (ALT)',
    dutch: 'zeil (OUD)',
    afrikaans: 'sel (OUD)',
    russian: 'парус (СТАРОЕ зн)',
    latvian: 'bura (novec.)',
    polish: 'żagiel (stare)',
    french: 'voile (ancien)',
    spanish: 'vela (ANTIGUO)',
  },
  {
    av: 16707,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(pictograph: symbol suggests the outline of a sailboat.The symbol also can be explained as: combination of boat and sail) - Character SUPERSEDED SYNONYM See sailboat, sailing boat, yacht 20520',
    english: 'sailboat (OLD)',
    swedish: 'segelbåt (FD)',
    norwegian: 'seilbåt (OLD)',
    finnish: 'purjevene (vanha)',
    hungarian: 'vitrolás (régi jelkép)',
    german: 'Segelboot (ALT)',
    dutch: 'zeilboot (OUD)',
    afrikaans: 'seilboot (OUD)',
    russian: 'парусная шлюпка, судно (СТАРОЕ зн)',
    latvian: 'burulaiva (novec.)',
    polish: 'żaglówka (stare)',
    french: 'voilier (ancien)',
    spanish: 'velero (ANTIGUO)',
  },
  {
    av: 16712,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(taste + sea + description indicator) SUPERSEDED SYNONYM See salty 26247',
    english: 'salty (OLD)',
    swedish: 'salt (adj.)',
    norwegian: 'salt (smak)',
    finnish: 'suolainen',
    hungarian: 'sós',
    german: 'salzig',
    dutch: 'zout',
    afrikaans: 'sou souterig',
    russian: 'солёный',
    latvian: 'sāļš',
    polish: 'słony',
    french: 'salé',
    spanish: 'salado',
  },
  {
    av: 16722,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 7: seventh day of the week - based on the convention of Sunday being the first) SUPERSEDED SYNONYM See Saturday (day6) 25164, Saturday (day7) 25165, Saturday (day1) 25163',
    english: 'Saturday (OLD)',
    swedish: 'lördag (FD)',
    norwegian: 'lørdag (OLD)',
    finnish: 'lauantai (vanha)',
    hungarian: 'vasárnap (régi jelkép)',
    german: 'Samstag, Sonnabend (ALT)',
    dutch: 'zaterdag (OUD)',
    afrikaans: 'Saterdag (OUD)',
    russian: 'суббота (СТАРОЕ зн)',
    latvian: 'sestdiena (novec.)',
    polish: 'sobota (stare)',
    french: 'samedi (ancien)',
    spanish: 'Sábado (ANTIGUO)',
  },
  {
    av: 16723,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(spread, paste + liquid: liquid served on or to accompany food) SUPERSEDED SYNONYM See sauce, gravy, relish, dressing 20522',
    english: 'sauce, gravy, relish, dressing (OLD)',
    swedish: 'sås (FD)',
    norwegian: 'saus (OLD)',
    finnish: 'kastike (vanha)',
    hungarian: 'mártás, öntet, szósz, szaft (régi jelkép)',
    german: 'Soße, Bratensaft, Relish, Dressing (ALT)',
    dutch: 'saus, dressing (OUD)',
    afrikaans: 'sous smoor (OUD)',
    russian: 'соус (СТАРОЕ зн)',
    latvian: 'mērce, salātu piedevas (novec.)',
    polish: 'sos, dressing (stare)',
    french: 'sauce (ancien)',
    spanish: 'salsa, condimento, aderezo (ANTIGUO)',
  },
  {
    av: 16961,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(many + public room: group of stores) SUPERSEDED SYNONYM See shopping centre, mall, plaza 23207',
    english: 'shopping centre (OLD)',
    swedish: 'center, köpcentrum (FD)',
    norwegian: 'supermarked, kjøpesenter (OLD)',
    finnish: 'ostoskeskus (vanha)',
    hungarian: 'bevásárló központ (régi jelkép)',
    german: 'Einkaufszentrum (ALT)',
    dutch: 'winkelcentrum (OUD)',
    afrikaans: 'winkelsentrum (OUD)',
    russian: 'торговый центр (СТАРОЕ зн)',
    latvian: 'tirdzniecības centrs (novec.)',
    polish: 'centrum handlowe (stare)',
    french: 'centre commercial (ancien)',
    spanish: 'centro comercial (ANTIGUO)',
  },
  {
    av: 16978,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(to point + thing: the hand points to the thing) SUPERSEDED SYNONYM See sign, signal 24749',
    english: 'sign (OLD)',
    swedish: 'tecken (FD)',
    norwegian: 'tegn (OLD)',
    finnish: 'merkki (vanha), opastin (vanha)',
    hungarian: 'jel (régi jelkép)',
    german: 'Zeichen, Gebärde, Geste (ALT)',
    dutch: 'gebaar (OUD)',
    afrikaans: 'gebaar (OUD)',
    russian: 'знак, признак (СТАРОЕ зн)',
    latvian: 'zīme, pazīme (novec.)',
    polish: 'znak migowy (stare)',
    french: 'désignation (ancien)',
    spanish: 'signo (ANTIGUO)',
  },
  {
    av: 17014,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + fast + description indicator) SUPERSEDED SYNONYM See slow, slowly 24268',
    english: 'slow, slowly (OLD)',
    swedish: 'långsam, sakta (FD)',
    norwegian: 'langsom, sein (OLD)',
    finnish: 'hidas (vanha), hitaasti (vanha)',
    hungarian: 'lassú, lassan (régi jelkép)',
    german: 'langsam (ALT)',
    dutch: 'langzaam, traag (OUD)',
    afrikaans: 'stadig, langsaam, traag (OUD)',
    russian: 'медленный, не быстрый (СТАРОЕ зн)',
    latvian: 'lēns, lēni (novec.)',
    polish: 'powoli, wolno (stare)',
    french: 'lent (ancien)',
    spanish: 'lento, poco a poco (ANTIGUO)',
  },
  {
    av: 17197,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(snowshoe + legs and feet + snow: special shoe for walking over snow) SUPERSEDED SYNONYM See snowshoe 25613',
    english: 'snowshoe (OLD)',
    swedish: 'snöskor (FD)',
    norwegian: 'truge (OLD)',
    finnish: 'lumikenkä (vanha)',
    hungarian: 'hótalp (finn) (régi jelkép)',
    german: 'Schneeschuh (ALT)',
    dutch: 'sneeuwschoen (OUD)',
    afrikaans: 'sneeuskoen (OUD)',
    russian: 'снегоступы (СТАРОЕ зн)',
    latvian: 'sniega apavi (novec.)',
    polish: 'rakiety śnieżne, buty śniegowe (stare)',
    french: 'raquette de neige (ancien)',
    spanish: 'raqueta de nieve (ANTIGUO)',
  },
  {
    av: 17222,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + flour + linear thing + thing indicator: long, thin pasta) SUPERSEDED SYNONYM See spaghetti 20521',
    english: 'spaghetti (OLD)',
    swedish: 'spagetti (FD)',
    norwegian: 'spaghetti (OLD)',
    finnish: 'spagetti (vanha)',
    hungarian: 'spagetti (régi jelkép)',
    german: 'Spagetti, Spaghetti (ALT)',
    dutch: 'spaghetti (OUD)',
    afrikaans: 'spaghetti (OUD)',
    russian: 'спагетти (СТАРОЕ зн)',
    latvian: 'spageti (novec.)',
    polish: 'spaghetti, makaron nitki (stare)',
    french: 'spaghetti (ancien)',
    spanish: 'espagueti (ANTIGUO)',
  },
  {
    av: 17225,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(limit(s), limitation (OLD) + to speak + description indicator: having difficulties to speak intelligibly) See also: nonspeaking SUPERSEDED SYNONYM See speech impaired 26025',
    english: 'speech impaired (OLD)',
    swedish: 'talskadad (FD)',
    norwegian: 'talehemmet (OLD)',
    finnish: 'puhevammainen, puhehäiriöinen (vanha)',
    hungarian: 'beszédsérült, beszédfogyatékos, beszédzavaros (régi jelkép)',
    german: 'sprachgeschädigt (ALT)',
    dutch: 'spraakstoornis (OUD)',
    afrikaans: 'spraakgestremd (OUD)',
    russian: 'нарушенная речь (СТАРОЕ зн)',
    latvian: 'runas invaliditāte (novec.)',
    polish: 'zaburzenia mowy (stare)',
    french: 'handicapé de la parole (ancien)',
    spanish: 'discapacitado del habla (ANTIGUO)',
  },
  {
    av: 17234,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(activity + healthy) SUPERSEDED SYNONYM See sport 20518',
    english: 'sport (OLD)',
    swedish: 'sport, idrott (FD)',
    norwegian: 'sport (OLD)',
    finnish: 'urheilu (vanha), voimistelu (vanha), liikunta (vanha)',
    hungarian: 'sport (régi jelkép)',
    german: 'Sport (ALT)',
    dutch: 'sport (OUD)',
    afrikaans: 'sport (OUD)',
    russian: 'спорт (СТАРОЕ зн)',
    latvian: 'sports (novec.)',
    polish: 'sport (stare)',
    french: 'sport (ancien)',
    spanish: 'deporte (ANTIGUO)',
  },
  {
    av: 17253,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(fish + star) SUPERSEDED SYNONYM See starfish 23220',
    english: 'starfish (OLD)',
    swedish: 'sjöstjärna (FD)',
    norwegian: 'sjøstjerne (OLD)',
    finnish: 'meritähti (vanha)',
    hungarian: 'tengeri csillag (régi jelkép)',
    german: 'Seestern (ALT)',
    dutch: 'zeester (OUD)',
    afrikaans: 'seester (OUD)',
    russian: 'морская звезда (СТАРОЕ зн)',
    latvian: 'jūraszvaigzne (novec.)',
    polish: 'rozgwiazda (stare)',
    french: 'étoile de mer (ancien)',
    spanish: 'estrella de mar (ANTIGUO)',
  },
  {
    av: 17269,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(public room + business: public room where money is exchanged for goods) SUPERSEDED SYNONYM See store, shop 23223',
    english: 'store (OLD)',
    swedish: 'affär, butik (FD)',
    norwegian: 'butikk (OLD)',
    finnish: 'kauppa (vanha), liike (vanha)',
    hungarian: 'bolt (régi jelkép)',
    german: 'Geschäft, Laden (ALT)',
    dutch: 'winkel (OUD)',
    afrikaans: 'winkel (OUD)',
    russian: 'магазин (СТАРОЕ зн)',
    latvian: 'veikals (novec.)',
    polish: 'sklep (stare)',
    french: 'magasin (ancien)',
    spanish: 'tienda (ANTIGUO)',
  },
  {
    av: 17447,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(opposite meaning + smart + description indicator) SUPERSEDED SYNONYM See stupid, dumb 24295',
    english: 'stupid, dumb (OLD)',
    swedish: 'dum, obegåvad (FD)',
    norwegian: 'dum (OLD)',
    finnish: 'tyhmä (vanha)',
    hungarian: 'buta, ostoba (régi jelkép)',
    german: 'dumm, doof, blöde, idiotisch (ALT)',
    dutch: 'dom, idioot, stom (OUD)',
    afrikaans: 'dom, idioot, stom (OUD)',
    russian: 'глупый, тупой СТАРОЕ зн)',
    latvian: 'muļķis, dumjš, stulbs (novec.)',
    polish: 'głupi (stare)',
    french: 'stupide, bête (ancien)',
    spanish: 'estúpido (ANTIGUO)',
  },
  {
    av: 17464,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 1: first day of the week - based on the convention of Sunday being the first) SUPERSEDED SYNONYM See Sunday (day7) 25182, Sunday (day1) 25180, Sunday (day2) 25181',
    english: 'Sunday (OLD)',
    swedish: 'söndag (FD)',
    norwegian: 'søndag (OLD)',
    finnish: 'sunnuntai (vanha)',
    hungarian: 'hétfő (régi jelkép)',
    german: 'Sonntag (ALT)',
    dutch: 'zondag (OUD)',
    afrikaans: 'Sondag (OUD)',
    russian: 'воскресенье (СТАРОЕ зн)',
    latvian: 'svētdiena (novec.)',
    polish: 'niedziela (stare)',
    french: 'dimanche (ancien)',
    spanish: 'Domingo (ANTIGUO)',
  },
  {
    av: 17470,
    group: 'deprecated',
    pos: 'RED',
    derivationExplanation:
      '(feeling + two intensity symbols + action indicator: to produce an intense emotional reaction) SUPERSEDED SYNONYM See surprise-(to) 23961',
    english: 'surprise-(to) (OLD)',
    swedish: 'överraska (FD)',
    norwegian: 'overraske (OLD)',
    finnish: 'yllättää (vanha)',
    hungarian: 'meglepni, meglepődni (régi CKB-jelkép)',
    german: 'überraschen (ALT)',
    dutch: 'verrassen (OUD)',
    afrikaans: 'verras (om te) (OUD)',
    russian: 'удивлять (СТАРОЕ зн)',
    latvian: 'pārsteigt (novec.)',
    polish: 'zaskakiwać, robić niespodziankę (stare)',
    french: 'surprendre, étonner (ancien)',
    spanish: 'sorprender (ANTIGUO)',
  },
  {
    av: 17522,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + crossed racquets: game played with racquets) SUPERSEDED SYNONYM See tennis (activity) 26031 and tennis, racket sport, racquet sport 26030',
    english: 'tennis (activity) (OLD)',
    swedish: 'tennis (FD)',
    norwegian: 'tennis (OLD)',
    finnish: 'tennis (vanha)',
    hungarian: 'tenisz (játék, sport) (régi jelkép)',
    german: 'Tennis (ALT)',
    dutch: 'tennis (OUD)',
    afrikaans: 'tennis (aktiwiteit) (OUD)',
    russian: 'теннис (СТАРОЕ зн)',
    latvian: 'teniss (novec.)',
    polish: 'tenis (aktywność) (stare)',
    french: 'tennis (activité) (ancien)',
    spanish: 'tenis (actividad) (ANTIGUO)',
  },
  {
    av: 17706,
    group: 'deprecated',
    pos: 'BLUE',
    derivationExplanation:
      '(mutual aid + forward + person: person working cooperatively with another person to produce one free-standing person) SUPERSEDED SYNONYM See therapist 20516',
    english: 'therapist (OLD)',
    swedish: 'terapeut (FD)',
    norwegian: 'terapeut (OLD)',
    finnish: 'terapeutti (vanha)',
    hungarian: 'terapeuta (régi jelkép)',
    german: 'Therapeut, Therapeutin (ALT)',
    dutch: 'therapeut (OUD)',
    afrikaans: 'terapeut (OUD)',
    russian: 'терапевт (СТАРОЕ зн)',
    latvian: 'terapeits (novec.)',
    polish: 'terapeuta (stare)',
    french: 'thérapeute (ancien)',
    spanish: 'terapeuta (ANTIGUO)',
  },
  {
    av: 17728,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 5: fifth day of the week - based on the convention of Sunday being the first) SUPERSEDED SYNONYM See Thursday (day4) 25193, Thursday (day5) 25194, Thursday (day6) 25195',
    english: 'Thursday (OLD)',
    swedish: 'torsdag (FD)',
    norwegian: 'torsdag (OLD)',
    finnish: 'torstai (vanha)',
    hungarian: 'péntek (régi jelkép)',
    german: 'Donnerstag (ALT)',
    dutch: 'donderdag (OUD)',
    afrikaans: 'Donderdag (OUD)',
    russian: 'четверг (СТАРОЕ зн)',
    latvian: 'otdiena (novec.)',
    polish: 'czwartek (stare)',
    french: 'jeudi (ancien)',
    spanish: 'Jueves (ANTIGUO)',
  },
  {
    av: 17735,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(rest + to need + description after the fact indicator: feeling in need of rest)',
    english: 'tired, exhausted, weary (OLD)',
    swedish: 'trött',
    norwegian: 'trøtt, sliten',
    finnish: 'väsynyt',
    hungarian: 'fáradt, kimerült',
    german: 'müde, erschöpft',
    dutch: 'moe',
    afrikaans: 'moeg, uitgeput, gedaan',
    russian: 'усталый',
    latvian: 'noguris, pārguris',
    polish: 'zmęczony, wyczerpany',
    french: 'fatigué',
    spanish: 'cansado, exhausto',
  },
  {
    av: 17762,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + dry (OLD)) SUPERSEDED SYNONYM See towel 24312',
    english: 'towel (OLD)',
    swedish: 'handduk (FD)',
    norwegian: 'håndkle (OLD)',
    finnish: 'pyyhe (vanha), pyyheliina (vanha)',
    hungarian: 'törülköző (régi jelkép)',
    german: 'Handtuch (ALT)',
    dutch: 'handdoek (OUD)',
    afrikaans: 'handdoek (OUD)',
    russian: 'полотенце (СТАРОЕ зн)',
    latvian: 'dvielis (novec.)',
    polish: 'ręcznik (stare)',
    french: 'serviette de bain (ancien)',
    spanish: 'toalla (ANTIGUO)',
  },
  {
    av: 17790,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 3: third day of the week - based on the convention of Sunday being the first) SUPERSEDED SYNONYM See Tuesday (day2) 25203, Tuesday (day3) 25204, Tuesday (day4) 25205',
    english: 'Tuesday (OLD)',
    swedish: 'tisdag (FD)',
    norwegian: 'tirsdag (OLD)',
    finnish: 'tiistaii (vanha)',
    hungarian: 'szerda (régi jelkép)',
    german: 'Dienstag (ALT)',
    dutch: 'dinsdag (OUD)',
    afrikaans: 'Dinsdag (OUD)',
    russian: 'вторник (СТАРОЕ зн)',
    latvian: 'otrdiena (novec.)',
    polish: 'wtorek (stare)',
    french: 'mardi (ancien)',
    spanish: 'Martes (ANTIGUO)',
  },
  {
    av: 17976,
    group: 'deprecated',
    pos: 'RED',
    derivationExplanation:
      '(opposite meaning + to fold + action indicator) SUPERSEDED SYNONYM See unfold-(to) 23980',
    english: 'unfold-(to) (OLD)',
    swedish: 'veckla ut, vika upp (FD)',
    norwegian: 'brette ut, folde ut (OLD)',
    finnish: 'avata (vanha), kääriä auki (vanha)',
    hungarian: 'felbont, kibont, szétbont, széthajtogat (régi jelkép)',
    german: 'entfalten (ALT)',
    dutch: 'openvouwen (OUD)',
    afrikaans: 'ontvou (om te) (OUD)',
    russian: 'разворачивать, раскрывать (СТАРОЕ зн)',
    latvian: 'attīt, iztīt (novec.)',
    polish: 'rozwinąć, rozłożyć, rozpakować (stare)',
    french: 'déplier (contraire de plier) (ancien)',
    spanish: 'desplegar (ANTIGUO)',
  },
  {
    av: 17984,
    group: 'deprecated',
    pos: 'WHITE',
    derivationExplanation: '(up + down) SUPERSEDED SYNONYM See up and down 20524',
    english: 'up and down (OLD)',
    swedish: 'upp och ner (FD)',
    norwegian: 'opp og ned(OLD)',
    finnish: 'ylös ja alas (vanha)',
    hungarian: 'fel-le (régi jelkép)',
    german: 'auf und ab (ALT)',
    dutch: 'op en neer (OUD)',
    afrikaans: 'op-en-af (OUD)',
    russian: 'вверх и вниз (СТАРОЕ зн)',
    latvian: 'augšā un lejā (novec.)',
    polish: 'w górę i w dół (stare)',
    french: 'de haut en bas (ancien)',
    spanish: 'arriba y abajo (ANTIGUO)',
  },
  {
    av: 18019,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(limit(s), limitation (OLD) + to see + description indicator) SUPERSEDED SYNONYM See visually impaired 26033',
    english: 'visually impaired (OLD)',
    swedish: 'synskadad (FD)',
    norwegian: 'synshemmet (OLD)',
    finnish: 'näkövammainen (vanha)',
    hungarian: 'látássérült, gyengénlátó (mn.) (régi jelkép)',
    german: 'sehbehindert (ALT)',
    dutch: 'slechtziend (OUD)',
    afrikaans: 'visueel gestrem, swaksiende (OUD)',
    russian: 'слабовидящий, нарушенное зрение (СТАРОЕ зн)',
    latvian: 'redzes invaliditāte, ar redzes traucējumiem (novec.)',
    polish: 'niedowidzący (stare)',
    french: 'malvoyant (ancien)',
    spanish: 'discapacitado visual (ANTIGUO)',
  },
  {
    av: 18216,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 4: fourth day of the week - based on the convention of Sunday being the first) SUPERSEDED SYNONYM See Wednesday (day3) 25214, Wednesday (day4) 25215, Wednesday (day5) 25216',
    english: 'Wednesday (OLD)',
    swedish: 'onsdag (FD)',
    norwegian: 'onsdag (OLD)',
    finnish: 'keskiviikko (vanha)',
    hungarian: 'csütörtök (régi jelkép)',
    german: 'Mittwoch (ALT)',
    dutch: 'woensdag (OUD)',
    afrikaans: 'Woensdag (OUD)',
    russian: 'среда (СТАРОЕ зн)',
    latvian: 'trešdiena (novec.)',
    polish: 'środa (stare)',
    french: 'mercredi (ancien)',
    spanish: 'Miércoles (ANTIGUO)',
  },
  {
    av: 18265,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + metal + thing indicator)',
    english: 'wire, cable (OLD)',
    swedish: 'ståltråd (etc)',
    norwegian: 'ståltråd, kabel, wire',
    finnish: 'metallilanka, johto',
    hungarian: 'huzal, drót, kábel',
    german: 'Draht',
    dutch: 'metaaldraad',
    afrikaans: 'draad, kabel metaal',
    russian: 'провод',
    latvian: 'stieple, kabelis',
    polish: 'drut, kabel, przewód',
    french: 'fil métallique, fil de fer, câble métallique',
    spanish: 'alambre, cable',
  },
  {
    av: 20523,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring + sea + thing indicator) SUPERSEDED SYNONYM See salt 26245',
    english: 'salt (OLD)',
    swedish: 'salt (subst.)',
    norwegian: 'salt',
    finnish: 'suola',
    hungarian: 'só',
    german: 'Salz',
    dutch: 'zout',
    afrikaans: 'sout',
    russian: 'соль',
    latvian: 'sāls',
    polish: 'sól',
    french: 'sel',
    spanish: 'sal',
  },
  {
    av: 20602,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(sport + crossed racquets) SUPERSEDED SYNONYM See tennis, racket sport, racquet sport 26030',
    english: 'tennis, racquet sports (OLD)',
    swedish: 'tennis, racketsport (FD)',
    norwegian: 'tennis (sport) (OLD)',
    finnish: 'tennis (vanha)',
    hungarian: 'tenisz (régi jelkép)',
    german: 'Tennis (Sportarten mit Schläger) (ALT)',
    dutch: 'racketsport, tennis (OUD)',
    afrikaans: 'tennis, raket sport (OUD)',
    russian: 'теннис, ракетный спорт (СТАРОЕ зн)',
    latvian: 'teniss (sports) (novec.)',
    polish: 'tenis (sport) (stare)',
    french: 'tennis (sport) (ancien)',
    spanish: 'tenis (deporte con raqueta) (ANTIGUO)',
  },
  {
    av: 20603,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(tennis, racquet sports (OLD) + table) SUPERSEDED SYNONYM See table tennis, ping-pong (sport) 26029',
    english: 'table tennis, ping-pong (sport) (OLD)',
    swedish: 'bordtennis (sport) (FD)',
    norwegian: 'bordtennis (sport) (OLD)',
    finnish: 'pöytätennis (vanha)',
    hungarian: 'asztalitenisz, pingpong (régi jelkép)',
    german: 'Tischtennis, Ping Pong (Sport) (ALT)',
    dutch: 'tafeltennis, pingpong (OUD)',
    afrikaans: 'tafeltennis, ping-pong (sport) (OUD)',
    russian: 'настольный теннис (спорт) (СТАРОЕ зн)',
    latvian: 'galda teniss (sports) (novec.)',
    polish: 'tenis stołowy (stare)',
    french: 'tennis de table (ancien)',
    spanish: 'tenis de mesa, ping pong (ANTIGUO)',
  },
  {
    av: 20604,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(tennis, racquet sports (OLD) + beach) SUPERSEDED SYNONYM See beach tennis (sport) 25982',
    english: 'beach tennis (sport) (OLD)',
    swedish: 'strandtennis (sport) (FD)',
    norwegian: 'strandtennis (sport) (OLD)',
    finnish: 'rantatennis (vanha)',
    hungarian: 'strandtenisz (régi jelkép)',
    german: 'Strandtennis (Sport) (ALT)',
    dutch: 'strandtennis (OUD)',
    afrikaans: 'strandtennis (sport) (OUD)',
    russian: 'пляжный тенис (спорт) (СТАРОЕ зн)',
    latvian: 'pludmales teniss (sports) (novec.)',
    polish: 'tenis plażowy (sport) (stare)',
    french: 'tennis de plage (sport) (ancien)',
    spanish: 'tenis de playa (deporte) (ANTIGUO)',
  },
  {
    av: 21332,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(eternity, infinity (OLD) + description indicator) SUPERSEDED SYNONYM See eternal 26000',
    english: 'eternal (OLD)',
    swedish: 'evig (FD)',
    norwegian: 'evig (OLD)',
    finnish: 'ikuinen, loputon (vanha)',
    hungarian: 'örök, örökös, szüntelen, örökkévaló (régi jelkép)',
    german: 'ewig, unaufhörlich (ALT)',
    dutch: 'eeuwig (OUD)',
    afrikaans: 'ewig (OUD)',
    russian: 'вечный (СТАРОЕ зн)',
    latvian: 'mūžīgs (novec.)',
    polish: 'wieczny, trwały (stare)',
    french: 'éternel (ancien)',
    spanish: 'eterno (ANTIGUO)',
  },
  {
    av: 21552,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + mind: science of mental processes and behaviour) SUPERSEDED SYNONYM See psychology 23183',
    english: 'psychology (OLD)',
    swedish: 'psykologi (FD)',
    norwegian: 'psykologi (OLD)',
    finnish: 'psykologia (vanha)',
    hungarian: 'pszichológia (régi jelkép)',
    german: 'Psychologie (ALT)',
    dutch: 'psychologie (OUD)',
    afrikaans: 'sielkunde (OUD)',
    russian: 'психология (СТАРОЕ зн)',
    latvian: 'psiholoģija (novec.)',
    polish: 'psychologia (stare)',
    french: 'psychologie (ancien)',
    spanish: 'psicología (ANTIGUO)',
  },
  {
    av: 21586,
    group: 'deprecated',
    pos: 'BLUE',
    derivationExplanation:
      '(person + psychology (OLD)) SUPERSEDED SYNONYM See psychologist (researcher) 23182',
    english: 'psychologist (researcher) (OLD)',
    swedish: 'psykolog (forskare) (FD)',
    norwegian: 'psykolog (forsker) (OLD)',
    finnish: 'psykologi (vanha)',
    hungarian: 'kutató pszichológus (régi jelkép)',
    german: 'Psychologe, Psychologin (Forschung) (ALT)',
    dutch: 'psycholoog (OUD)',
    afrikaans: 'sielkundige (navorser) (OUD)',
    russian: 'научный психолог (СТАРОЕ зн)',
    latvian: 'psihologs pētnieks (novec.)',
    polish: 'psycholog (naukowiec) (stare)',
    french: 'psychologue (chercheur) (ancien)',
    spanish: 'psicólogo (investigador) (ANTIGUO)',
  },
  {
    av: 21587,
    group: 'deprecated',
    pos: 'BLUE',
    derivationExplanation: '(person + knowledge + mind) SUPERSEDED SYNONYM See psychologist 23181',
    english: 'psychologist (OLD)',
    swedish: 'psykolog (FD)',
    norwegian: 'psykolog (OLD)',
    finnish: 'psykologi (tutkija) (vanha)',
    hungarian: 'pszichológus (régi jelkép)',
    german: 'Psychologe, Psychologin (ALT)',
    dutch: 'psycholoog (OUD)',
    afrikaans: 'sielkundige (OUD)',
    russian: 'психолог (СТАРОЕ зн)',
    latvian: 'psihologs (novec.)',
    polish: 'psycholog (stare)',
    french: 'psychologue (ancien)',
    spanish: 'psicólogo (ANTIGUO)',
  },
  {
    av: 21588,
    group: 'deprecated',
    pos: 'BLUE',
    derivationExplanation: '(teacher + mind) SUPERSEDED SYNONYM See psychology teacher 23184',
    english: 'psychology teacher (OLD)',
    swedish: 'psykologilärare (FD)',
    norwegian: 'psykologilærer (OLD)',
    finnish: 'psykologian opettaja (vanha)',
    hungarian: 'pszichológia tanár (régi jelkép)',
    german: 'Psychologielehrer, Psychologielehrerin (ALT)',
    dutch: 'psychologieleraar (OUD)',
    afrikaans: 'sielkunde onderwyser (OUD)',
    russian: 'преподаватель психологии (СТАРОЕ зн)',
    latvian: 'psiholoģijas skolotājs (novec.)',
    polish: 'wykładowca psychologii (stare)',
    french: 'enseignant en psychologie (ancien)',
    spanish: 'profesor de psicología (ANTIGUO)',
  },
  {
    av: 21845,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(sport + jump + far, distant (OLD)) SUPERSEDED SYNONYM See long jump (sport) 26017',
    english: 'long jump (OLD)',
    swedish: 'längdhopp (FD)',
    norwegian: 'lengdehopp (sport) (OLD)',
    finnish: 'pituushyppy (vanha)',
    hungarian: 'távolugrás (régi jelkép)',
    german: 'Weitsprung (ALT)',
    dutch: 'verspringen (OUD)',
    afrikaans: 'verspring (OUD)',
    russian: 'прыжки в длину (СТАРОЕ зн)',
    latvian: 'tāllēkšana (novec.)',
    polish: 'skok w dal (sport) (stare)',
    french: 'saut en longueur (sport) (ancien)',
    spanish: 'salto de longitud (ANTIGUO)',
  },
  {
    av: 22101,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(tennis, racquet sports (OLD) + room) SUPERSEDED SYNONYM See squash (sport) 26027',
    english: 'squash (sport) (OLD)',
    swedish: 'squash (sport) (FD)',
    norwegian: 'squash (sport) (OLD)',
    finnish: 'squash (vanha)',
    hungarian: 'fallabda, squash (régi jelkép)',
    german: 'Squash (Sport) (ALT)',
    dutch: 'squash (OUD)',
    afrikaans: 'muurbal (sport) (OUD)',
    russian: 'сквош (СТАРОЕ зн)',
    latvian: 'skvošs (novec.)',
    polish: 'squash (sport) (stare)',
    french: 'squash, tennis en salle (sport) (ancien)',
    spanish: 'squash (deporte) (ANTIGUO)',
  },
  {
    av: 22102,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(tennis, racquet sports (OLD) + group: group representing team (sport) [contr.]) SUPERSEDED SYNONYM See lacrosse (sport) 26013',
    english: 'lacrosse (sport) (OLD)',
    swedish: 'lacrosse (sport) (FD)',
    norwegian: 'lacrosse (sport) (OLD)',
    finnish: 'lacrosse, haavipallo (vanha)',
    hungarian: 'lacrosse, kanadai labdajáték (régi jelkép)',
    german: 'Lacrosse (kanad. Nationalsport) (ALT)',
    dutch: 'lacrosse (OUD)',
    afrikaans: 'lacrosse (sport) (OUD)',
    russian: 'лакросс (СТАРОЕ зн)',
    latvian: 'lakross (novec.)',
    polish: 'lacrosse (sport)- odmiana hokeja na trawie (stare)',
    french: 'crosse (sport) (ancien)',
    spanish: 'lacrosse (ANTIGUO)',
  },
  {
    av: 22822,
    group: 'deprecated',
    pos: 'BLUE',
    derivationExplanation:
      '(Nordic God + lie (OLD): the God of falseness) SUPERSEDED SYNONYM See Loki 26016',
    english: 'Loki (OLD)',
    swedish: 'Loke (FD)',
    norwegian: 'Loke (OLD)',
    finnish: 'Loke, Loki, Lopt (vanha)',
    hungarian: 'Loki (északi istenség) (régi jelkép)',
    german: 'Loki (nordischer Gott) (ALT))',
    dutch: 'Loki (Noorse God) (OUD)',
    afrikaans: 'Loki (Nordise God) (OUD)',
    russian: 'Локи (СТАРОЕ зн) (Бог коварства)',
    latvian: 'Loki (novec.)',
    polish: 'Loki (skandynawski bóg kłamstwa) (stare)',
    french: 'Loki (mythologie nordique) (ancien)',
    spanish: 'Loki (ANTIGUO)',
  },
  {
    av: 23071,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(measurement + farness, remoteness, farawayness (OLD)) SUPERSEDED SYNONYM See distance 25996',
    english: 'distance (OLD)',
    swedish: 'avstånd (FD)',
    norwegian: 'distanse, avstand (OLD)',
    finnish: 'välimatka, etäisyys (vanha)',
    hungarian: 'távolság (régi jelkép)',
    german: 'Abstand, Distanz (ALT)',
    dutch: 'afstand (OUD)',
    afrikaans: 'afstand (OUD)',
    russian: 'расстояние (СТАРОЕ зн)',
    latvian: 'ceļa posms, distance (novec.)',
    polish: 'odległość (stare)',
    french: 'distance (ancien)',
    spanish: 'distancia (ANTIGUO)',
  },
  {
    av: 23161,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(gauge + farness, remoteness, farawayness (OLD) + thing indicator) SUPERSEDED SYNONYM See odometer 26019',
    english: 'odometer (OLD)',
    swedish: 'vägmätare, odometer (FD)',
    norwegian: 'avstandsmåler, odometer (OLD)',
    finnish: 'matkamittari, odometri (vanha)',
    hungarian: 'távolságmérő, útmérő, hodométer (régi jelkép)',
    german: 'Wegmesser, Wegstreckenzähler, Kilometerzähler (ALT)',
    dutch: 'kilometerteller (OUD)',
    afrikaans: 'odometer (OUD)',
    russian: 'одометр (СТАРОЕ зн)',
    latvian: 'odometrs (novec.)',
    polish: 'miernik odległości, drogomierz (stare)',
    french: 'compteur kilométrique, odomètre (ancien)',
    spanish: 'cuentakilómetros (ANTIGUO)',
  },
  {
    av: 23449,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(computer program + to play [contr.]) SUPERSEDED SYNONYM See digital game, video game, computer game 26159',
    english: 'computer game (OLD)',
    swedish: 'dataspel',
    norwegian: 'dataspill, PC-spill',
    finnish: 'tietokonepeli',
    hungarian: 'számítógépes játék',
    german: 'Computerspiel',
    dutch: 'computerspel',
    afrikaans: 'rekenaar speletjie',
    russian: 'компютерная игра',
    latvian: 'datorspēle',
    polish: 'gry komputerowe',
    french: "jeu informatique, jeu d'ordinateur",
    spanish: 'juego de computadora, juego de ordenador, videojuego',
  },
  {
    av: 23827,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation: '(sickness + without + energy (mental) + description indicator)',
    english: 'burned out, burnt out (OLD)',
    swedish: 'utbränd (om person)',
    norwegian: 'utbrent (om person)',
    finnish: 'uupunut, loppuunpalanut',
    hungarian: 'kiégett',
    german: 'ausgebrannt',
    dutch: 'burn out',
    afrikaans: 'uitgebrand',
    russian: 'сгоревший',
    latvian: 'izdedzis, izdegšanas sindroms cilvēkam',
    polish: 'oparzony, poparzony (o człowieku)',
    french: 'épuisé (physiquement)',
    spanish: 'exhausto ',
  },
  {
    av: 23836,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(sickness + tired + intensity + intensity + intensity)',
    english: 'chronic fatigue syndrome (OLD)',
    swedish: 'kroniskt trötthetssyndrom',
    norwegian: 'kronisk tretthetssyndrom, ME',
    finnish: 'krooninen väsymysoireyhtymä',
    hungarian: 'krónikus fáradtság szindróma',
    german: 'Chronisches Erschöpfungssyndrom',
    dutch: 'chronisch vermoeidheidssyndroom, CVS',
    afrikaans: 'Chroniese moegheid sindroom',
    russian: 'синдром хронической усталости',
    latvian: 'hroniska noguruma sindroms',
    polish: 'syndrom chronicznego zmęczenia',
    french: 'syndrome de fatigue chronique',
    spanish: 'Síndrome de Fatiga Crónica',
  },
  {
    av: 23870,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation: '(feeling + without + energy (mental) + description indicator)',
    english: 'exhausted, worn out (OLD)',
    swedish: 'utmattad, utsliten, slutkörd',
    norwegian: 'utmattet, utbrent',
    finnish: 'uupunut',
    hungarian: 'kimerült',
    german: 'ausgebrannt',
    dutch: 'uitgeput',
    afrikaans: 'uitgeput, moeg, gedaan, poot-uit',
    russian: 'измученный, истощённый',
    latvian: 'noguris, pārguris',
    polish: 'zmęczony, wyczerpany, zziajany, utrudzony, wyniszczony',
    french: 'épuisé',
    spanish: 'agotado, exhausto (2)',
  },
  {
    av: 23948,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(2 + sitski, sit ski) SUPERSEDED SYNONYM See sitski, sit ski 25609',
    english: 'sit ski (OLD)',
    swedish: 'sitski (FD)',
    norwegian: 'sitski (OLD)',
    finnish: 'hiihtokelkka, biski-kelkka (vanha)',
    hungarian: 'ülősí (régi jelkép)',
    german: 'Sitzski, Skischlitten, Sit-Ski (ALT)',
    dutch: 'zitski (OUD)',
    afrikaans: 'sit ski (OUD)',
    russian: 'сидячие лыжи (СТАРОЕ зн)',
    latvian: 'sēdslēpes (novec.)',
    polish: 'narty z siedziskiem ew nartosanki (stare)',
    french: 'ski assis (ancien)',
    spanish: 'silla esquí (ANTIGUO)',
  },
  {
    av: 24202,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(generalization + kidney) SUPERSEDED SYNONYM See organ, inner organ, inner body part 25480',
    english: 'organ (body) (OLD)',
    swedish: 'organ, inre organ (FD)',
    norwegian: 'organ (kropp) (OLD)',
    finnish: 'elin (kehonosa) (vanha)',
    hungarian: 'testrész, szerv (régi jelkép)',
    german: 'Organe (Körper) (ALT)',
    dutch: 'orgaan (OUD)',
    afrikaans: 'orgaan (ligaam) (OUD)',
    russian: 'внутренний орган (СТАРОЕ зн)',
    latvian: 'iekšējais orgāns (novec.)',
    polish: 'organ, narząd (ciało) (stare)',
    french: 'organe (corps) (ancien)',
    spanish: 'órgano (cuerpo) (ANTIGUO)',
  },
  {
    av: 24213,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(organ (body) (OLD) + food + fetus) SUPERSEDED SYNONYM See placenta 26021',
    english: 'placenta (OLD)',
    swedish: 'moderkaka (FD)',
    norwegian: 'morkake (OLD)',
    finnish: 'istukka (vanha)',
    hungarian: 'méhlepény, placenta (régi jelkép)',
    german: 'Mutterkuchen (ALT)',
    dutch: 'placenta (OUD)',
    afrikaans: 'plasenta (OUD)',
    russian: 'плацента (СТАРОЕ зн)',
    latvian: 'placenta (novec.)',
    polish: 'łożysko (stare)',
    french: 'placenta (ancien)',
    spanish: 'placenta (ANTIGUO)',
  },
  {
    av: 24416,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(tool + to look + distance (OLD)) SUPERSEDED SYNONYM See binoculars, field glass 25984',
    english: 'binoculars, field glass (OLD)',
    swedish: 'kikare (FD)',
    norwegian: 'kikkert (OLD)',
    finnish: 'kiikarit (vanha)',
    hungarian: 'távcső, kétcsövű látcső (régi jelkép)',
    german: 'Fernglas (ALT)',
    dutch: 'verrekijker, telescoop (OUD)',
    afrikaans: 'verkyker (OUD)',
    russian: 'бинокль (СТАРОЕ зн)',
    latvian: 'binoklis (novec.)',
    polish: 'lornetki, lornetka polowa (stare)',
    french: 'jumelles, longue-vue (ancien)',
    spanish: 'binoculares, prismáticos (ANTIGUO)',
  },
  {
    av: 24428,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(leadership + limit(s), limitation (OLD)) SUPERSEDED SYNONYM See control 25987',
    english: 'control (OLD)',
    swedish: 'kontroll (FD)',
    norwegian: 'kontroll (OLD)',
    finnish: 'hallinta, kontrolli (vanha)',
    hungarian: 'ellenőrzés, felügyelet, kontroll (régi jelkép)',
    german: 'Kontrolle (ALT)',
    dutch: 'controle (OUD)',
    afrikaans: 'beheer, kontrole (OUD)',
    russian: 'контроль, проверка (СТАРОЕ зн)',
    latvian: 'kontrolēt, pārbaudīt (novec.)',
    polish: 'kontrola (stare)',
    french: 'contrôle (ancien)',
    spanish: 'control (ANTIGUO)',
  },
  {
    av: 24430,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(money + disability, handicap, impairment (OLD)) SUPERSEDED SYNONYM See disability benefit 25993',
    english: 'disability benefit (OLD)',
    swedish: 'aktivitetsersättning, sjukersättning (FD)',
    norwegian: 'sykelønn (OLD)',
    finnish: 'vammaisetu, vammaisavustus (vanha)',
    hungarian: 'fogyatékossági támogatás, rokkantsági járadék (régi jelkép)',
    german: 'Aktivitätszuschuss, Krankenzuschuss, Krankengeld (ALT)',
    dutch: 'uitkering voor pers. met beperking (OUD)',
    afrikaans: 'ongeskiktheidsvoordeel (OUD)',
    russian: 'пособие по нетрудоспособности (СТАРОЕ зн)',
    latvian: 'darbnespējas/invaliditātes pabalsts (novec.)',
    polish: 'renta, świadczenie dla niepełnosprawnych (stare)',
    french: "pension d'invalidité, rente d'invalidité (ancien)",
    spanish: 'beneficio por discapacidad (ANTIGUO)',
  },
  {
    av: 24601,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + future (uncertain) + excited) SUPERSEDED SYNONYM See adventure 25006',
    english: 'adventure (OLD)',
    swedish: 'äventyr (FD)',
    norwegian: 'eventyr, opplevelse (OLD)',
    finnish: 'seikkailu (vanha)',
    hungarian: 'kaland (régi jelkép)',
    german: 'Abenteuer (ALT)',
    dutch: 'avontuur (OUD)',
    afrikaans: 'avontuur (OUD)',
    russian: 'приключение (СТАРОЕ зн)',
    latvian: 'piedzīvojums (novec.)',
    polish: 'przygoda (stare)',
    french: 'aventure (ancien)',
    spanish: 'aventura (ANTIGUO)',
  },
  {
    av: 24606,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(signal + limit(s), limitation (OLD): signal or frequencies in a certain range) SUPERSEDED SYNONYM See band (of frequencies) 25980',
    english: 'band (of frequencies) (OLD)',
    swedish: 'frekvensband, frekvensområde (FD)',
    norwegian: 'frekvensbånd (OLD)',
    finnish: 'taajuuskaista (vanha)',
    hungarian: 'frekvenciasáv (régi jelkép)',
    german: 'Frequenzband (ALT)',
    dutch: 'frequentieband (OUD)',
    afrikaans: 'frekwensieband (OUD)',
    russian: 'диапазон частот (СТАРОЕ зн)',
    latvian: 'frekvenču josla (novec.)',
    polish: 'pasmo (częstotliwości) (stare)',
    french: 'bande (de fréquences) (ancien)',
    spanish: 'banda (de frecuencias) (ANTIGUO)',
  },
  {
    av: 24614,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(band (of frequencies) (OLD) + fast) SUPERSEDED SYNONYM See broadband 25985',
    english: 'broadband (OLD)',
    swedish: 'bredband (FD)',
    norwegian: 'bredbånd (OLD)',
    finnish: 'laajakaista (vanha)',
    hungarian: 'szélessávú (régi jelkép)',
    german: 'Breitband (ALT)',
    dutch: 'breedband (OUD)',
    afrikaans: 'breëband (OUD)',
    russian: 'широкополосная передача (СТАРОЕ зн)',
    latvian: 'garie viļņi (frekvence) (novec.)',
    polish: 'szerokopasmowe (stare)',
    french: 'large bande (télécommunications) (ancien)',
    spanish: 'banda ancha (ANTIGUO)',
  },
  {
    av: 24629,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(abuse [contr.] + power, powerfulness (OLD) [contr.] + selfish) SUPERSEDED SYNONYM See corruption 25988',
    english: 'corruption (OLD)',
    swedish: 'korruption (FD)',
    norwegian: 'korrupsjon (OLD)',
    finnish: 'korruptio, lahjonta (vanha)',
    hungarian: 'megvesztegetés, lekenyerezés, korrupció (régi jelkép)',
    german: 'Korruption, Bestechlichkeit (ALT)',
    dutch: 'corruptie, omkoping (OUD)',
    afrikaans: 'korrupsie (OUD)',
    russian: 'коррупция (СТАРОЕ зн)',
    latvian: 'korupcija, piekukuļošana (novec.)',
    polish: 'korupcja (stare)',
    french: 'corruption (ancien)',
    spanish: 'corrupción (ANTIGUO)',
  },
  {
    av: 24648,
    group: 'deprecated',
    pos: 'RED',
    derivationExplanation:
      '(empowerment (OLD) + action indicator) SUPERSEDED SYNONYM See empower-(to) 25997',
    english: 'empower-(to) (OLD)',
    swedish: 'ge egenmakt, ge rättighet, stärka (FD)',
    norwegian: 'bemyndige, gi fullmakt til (OLD)',
    finnish: 'valtuuttaa (vanha)',
    hungarian: 'képessé tenni, megerősíteni, feljogosítani (régi jelkép)',
    german: 'befähigen, bevollmächtigen (ALT)',
    dutch: 'machtigen, in staat stellen (OUD)',
    afrikaans: 'bemagtig (om te) (OUD)',
    russian: 'предоставлять полномочия (СТАРОЕ зн)',
    latvian: 'pilnvarots (novec.)',
    polish: 'upoważniać (stare)',
    french: 'autoriser, habiliter (ancien)',
    spanish: 'autorizar (ANTIGUO)',
  },
  {
    av: 24649,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(empowerment (OLD) + description indicator) SUPERSEDED SYNONYM See empowered 25998',
    english: 'empowered (OLD)',
    swedish: 'berättigad, styrkt (FD)',
    norwegian: 'bemyndiget (OLD)',
    finnish: 'valtuutettu (vanha)',
    hungarian: 'képessé tett, feljogosított, megerősített (régi jelkép)',
    german: 'ermächtigt (ALT)',
    dutch: 'gemachtigd (OUD)',
    afrikaans: 'bemagtig (OUD)',
    russian: 'предоставленные полномочия (СТАРОЕ зн)',
    latvian: 'pilnvarots (adj) (novec.)',
    polish: 'upoważniony (stare)',
    french: 'autorisé, habilité (ancien)',
    spanish: 'autorizado(a) (ANTIGUO)',
  },
  {
    av: 24650,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(give + power, powerfulness (OLD) [contr.]) SUPERSEDED SYNONYM See empowerment 25999',
    english: 'empowerment (OLD)',
    swedish: 'egenmakt, befogenhet (FD)',
    norwegian: 'bemyndigelse, fullmakt (OLD)',
    finnish: 'valtuutus (vanha)',
    hungarian: 'képessé tétel, erőnyújtás, megerősítés (régi jelkép)',
    german: 'Bevollmächtigung, Ermächtigung (ALT)',
    dutch: 'machtiging (OUD)',
    afrikaans: 'bemagtiging (OUD)',
    russian: 'предоставление полномочий (СТАРОЕ зн)',
    latvian: 'pilnvarošana (novec.)',
    polish: 'upoważnienie (stare)',
    french: 'autorisation (ancien)',
    spanish: 'autorización (ANTIGUO)',
  },
  {
    av: 24718,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(ability + control (OLD)) SUPERSEDED SYNONYM See power, powerfulness 26022',
    english: 'power, powerfulness (OLD)',
    swedish: 'makt (FD)',
    norwegian: 'makt, mektighet (OLD)',
    finnish: 'valta (vanha)',
    hungarian: 'erő, erőteljesség, hathatósság (régi jelkép)',
    german: 'Kraft, Macht, Leistung (ALT)',
    dutch: 'vermogen, kracht (OUD)',
    afrikaans: 'krag (OUD)',
    russian: 'сила, власть, могущество (СТАРОЕ зн)',
    latvian: 'spēks, enerģija, stiprums, enerģiskums (novec.)',
    polish: 'moc, kontrola nad czymś (stare)',
    french: 'pouvoir, puissance (ancien)',
    spanish: 'poder (ANTIGUO)',
  },
  {
    av: 24719,
    group: 'deprecated',
    pos: 'GREEN',
    derivationExplanation:
      '(power, powerfulness (OLD) + description indicator) SUPERSEDED SYNONYM See powerful, mighty 26023',
    english: 'powerful, mighty (OLD)',
    swedish: 'mäktig (FD)',
    norwegian: 'kraftig, mektig (OLD)',
    finnish: 'mahtava, valtava (vanha)',
    hungarian: 'erős, erőteljes, hathatós, tekintélyes (régi jelkép)',
    german: 'kräftig, mächtig (ALT)',
    dutch: 'krachtig (OUD)',
    afrikaans: 'kragtig, sterk (OUD)',
    russian: 'сильный, могущественный (СТАРОЕ зн)',
    latvian: 'stiprs, spēcīgs, varens (novec.)',
    polish: 'potężny, silny (stare)',
    french: 'puissant (ancien)',
    spanish: 'poderoso (ANTIGUO)',
  },
  {
    av: 24782,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(digital signal + without + linear thing (wire, cable [contr.)] + thing indicator)',
    english: 'wireless connection, WIFI (OLD)',
    swedish: 'trådlös anslutning, WiFi, trådlöst nätverk',
    norwegian: 'trådløs forbindelse',
    finnish: 'langaton yhteys',
    hungarian: 'vezeték/drót nélküli összeköttetés',
    german: 'WLAN (Wireless Local Area Network), WiFi (Wireless Fidelity)',
    dutch: 'draadloze verbinding',
    afrikaans: 'draad lose internet verbinding, WiFi',
    russian: 'беспроводное соединение',
    latvian: 'bezvadu (interneta) pieslēgums',
    polish: 'połączenie bezprzewodowe',
    french: 'connexion sans fil',
    spanish: 'conexión inalámbrica',
  },
  {
    av: 24856,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(cause + more + correct: to cause to be better, in a rational sense.)',
    english: 'improvement (OLD)',
    swedish: 'bättring, förbättring',
    norwegian: 'bedring, forbedring',
    finnish: 'kehittäminen, parantaminen',
    hungarian: 'javulás, javítás, tökéletesedés, tökéletesítés',
    german: 'Verbesserung, Optimierung',
    dutch: 'verbetering, beterschap',
    afrikaans: 'verbetering',
    russian: 'улучшение',
    latvian: 'uzlabošanās',
    polish: '',
    french: 'amélioration',
    spanish: 'mejora',
  },
  {
    av: 24892,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(time + infiniteness, boundlessness, limitlessness (OLD)) SUPERSEDED SYNONYM See eternity, infinity 26001',
    english: 'eternity, infinity (OLD)',
    swedish: 'evighet, oändlighet (FD)',
    norwegian: 'evighet, uendelighet (OLD)',
    finnish: 'ikuisuus, loputtomuus (vanha)',
    hungarian: 'örökkévalóság, végtelenség (régi jelkép)',
    german: 'Ewigkeit, Unendlichkeit, Endlosigkeit (ALT)',
    dutch: 'eeuwigheid (OUD)',
    afrikaans: 'ewigheid, oneindigheid (OUD)',
    russian: 'вечность, бесконечность (СТАРОЕ зн)',
    latvian: 'mūžība, bezgalība (novec.)',
    polish: '',
    french: 'éternité, infini (temps) (ancien)',
    spanish: 'eternidad, infinito (ANTIGUO)',
  },
  {
    av: 24896,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(reference line [half-sized + reference line [half-sized]]: with a full square between them, the lines are relatively far apart) See also: nearness, closeness, proximity 25586 - Character (sequenced) SUPERSEDED SYNONYM and SUPERSEDED CHARACTER See farness, remoteness, farawayness 25559',
    english: 'farness, remoteness, farawayness (OLD)',
    swedish: 'långt avstånd (FD)',
    norwegian: 'avstand (lang), fjernhet (OLD)',
    finnish: 'kaukaisuus, etäisyys (vanha)',
    hungarian: 'messziség, távoliság, távollévőség (régi jelkép)',
    german: 'Abgelegenheit, Entferntheit (ALT)',
    dutch: 'afstand, lengte (OUD)',
    afrikaans: 'ver, afstand (OUD)',
    russian: 'удалённость (СТАРОЕ зн)',
    latvian: 'tālums, attālums (novec.)',
    polish: '',
    french: 'éloignement (ancien)',
    spanish: 'lejanía (ANTIGUO)',
  },
  {
    av: 24915,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(minus, no, without + limit(s), limitation (OLD)) SUPERSEDED SYNONYM See infiniteness, boundlessness, limitlessness 26011',
    english: 'infiniteness, boundlessness, limitlessness (OLD)',
    swedish: 'gränslöshet (FD)',
    norwegian: 'grenseløshet (OLD)',
    finnish: 'äärettömyys, rajattomuus (vanha)',
    hungarian: 'határtalanság, végtelenség, korlátlanság (régi jelkép)',
    german: 'Unendlichkeit, Grenzenlosigkeit (ALT)',
    dutch: 'grenzeloos (OUD)',
    afrikaans: 'ewigheid, ewige, grensloos (OUD)',
    russian: 'беспредельность, безграничность (СТАРОЕ зн)',
    latvian: 'nebeidzamība, bezgalīgums (novec.)',
    polish: '',
    french: 'infini (ancien)',
    spanish: 'infinito, ilimitado (ANTIGUO)',
  },
  {
    av: 25283,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(language + three Danish waters (OLD): based on Denmark (OLD) [contr.]) SUPERSEDED SYNONYM See Danish (language) 25990',
    english: 'Danish (language) (OLD)',
    swedish: 'danska (FD)',
    norwegian: 'dansk (OLD)',
    finnish: 'tanska (kieli) (vanha)',
    hungarian: '',
    german: 'Dänisch (Sprache) (ALT)',
    dutch: 'Deens (OUD)',
    afrikaans: 'Deens (taal) (OUD)',
    russian: 'датский язык (СТАРОЕ зн)',
    latvian: 'dāņu valoda (novec.)',
    polish: '',
    french: '',
    spanish: 'Danés (lenguage) (ANTIGUO)',
  },
  {
    av: 25288,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(through + electricity + thing indicator)',
    english: 'electric conductor (OLD)',
    swedish: 'elektrisk ledare',
    norwegian: 'elektrisk ledning',
    finnish: 'sähköjohde',
    hungarian: '',
    german: 'elektrischer Leiter',
    dutch: 'elektrische geleider',
    afrikaans: 'elektriese kondukteur, elektriese geleier',
    russian: 'электрический проводник',
    latvian: 'elektriskais vads, vadītājs',
    polish: '',
    french: '',
    spanish: 'conductor eléctrico',
  },
  {
    av: 25542,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(racket, racquet + racket, racquet [modification, mirrored]: pictograph of two crossed racquets) - Character (superimposed - modified - redundant)',
    english: 'crossed racquets (OLD)',
    swedish: 'racketar i kors',
    norwegian: 'racketer i kryss',
    finnish: '',
    hungarian: '',
    german: 'Schläger gekreuzt',
    dutch: 'gekruiste raketten',
    afrikaans: 'gekruis rakette',
    russian: 'скрещивание ракеток',
    latvian: 'sakrustotas raķetes',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25561,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(reference line + reference line + pointer, to the right on the left line + pointer, to the left on the right line : the full square between the reference lines, and the pointers pointing inwards from the outside, emphasize thickness.) - Character (superimposed - sequenced - pointer) SUPERSEDED SYNONYM See fatness, thickness 25560',
    english: 'fatness, thickness (OLD)',
    swedish: 'tjockhet (FD)',
    norwegian: 'tykkelse, fedme (OLD)',
    finnish: '',
    hungarian: '',
    german: 'Dickheit (ALT)',
    dutch: 'dikte (OUD)',
    afrikaans: 'vet, dikte (OUD)',
    russian: 'толщина (СТАРОЕ зн.)',
    latvian: 'resnums, biezums (novec.)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25623,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation:
      '(three parallel water symbols: three channels of water used inthe old Bliss-word for Denmark) - Character (superimposed) SUPERSEDED CHARACTER',
    english: 'three Danish waters (OLD)',
    swedish: 'tre vatten (Danmark) (FD)',
    norwegian: 'tre vann (Danmark) (OLD)',
    finnish: '',
    hungarian: '',
    german: 'drei Wasser (in altes Bliss-Wort für Dänemark) (ALT)',
    dutch: 'drie waters Deens (OUD)',
    afrikaans: 'drie Deense waters (OUD)',
    russian: 'три датские воды (СТАРОЕ зн.)',
    latvian: 'trīs Dāņu ūdeņi (novec.)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25693,
    group: 'deprecated',
    pos: 'BLUE',
    derivationExplanation: '(leader + dictatorship (country))',
    english: 'dictator (OLD)',
    swedish: 'diktator',
    norwegian: 'diktator, enehersker',
    finnish: '',
    hungarian: '',
    german: 'Diktator ',
    dutch: 'dictator',
    afrikaans: 'diktator',
    russian: 'диктатор',
    latvian: 'diktators',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26101,
    group: 'deprecated',
    pos: 'YELLOW',
    derivationExplanation: '(permission, allowance + choice)',
    english: 'democracy (OLD)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8483,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation:
      '(punctuation mark - 1. used as punctuation in symbol sentences; 2. used to indicate that the symbol statement that follows it is in the imperative form) - Character',
    english: 'exclamation mark',
    swedish: 'utropstecken',
    norwegian: 'utropstegn',
    finnish: 'huutomerkki',
    hungarian: 'felkiáltó jel, nyomatékosító jel',
    german: 'Ausrufezeichen',
    dutch: 'uitroepteken',
    afrikaans: 'uitroepteken',
    russian: 'восклицательный знак',
    latvian: 'izsaukuma zīme',
    polish: 'znak zapytania',
    french: "point d'exclamation (ponctuation)",
    spanish: 'signo de exclamación',
  },
  {
    av: 8484,
    group: 'diacritics',
    pos: 'YELLOW',
    derivationExplanation: '(international mathematical symbol) - Character',
    english: 'percent, percentage, %',
    swedish: 'procent, %',
    norwegian: 'prosent, %',
    finnish: 'prosentti, %',
    hungarian: 'százalék, %',
    german: 'Prozent, %',
    dutch: 'procent, percentage, %',
    afrikaans: 'persent, persentasie, %',
    russian: 'процент, %',
    latvian: 'procents, procenti, %',
    polish: 'procent, odsetek, %',
    french: 'pourcent (signe), %',
    spanish: 'por ciento, porcentaje, %',
  },
  {
    av: 8485,
    group: 'diacritics',
    pos: 'YELLOW',
    derivationExplanation:
      '(punctuation mark - used as punctuation in symbol sentences) - Character',
    english: 'question mark',
    swedish: 'frågetecken',
    norwegian: 'spørsmålstegn',
    finnish: 'kysymysmerkki',
    hungarian: 'kérdés, kérdőjel',
    german: 'Fragezeichen',
    dutch: 'vraagteken',
    afrikaans: 'vraagteken',
    russian: 'вопросительный знак',
    latvian: 'jautājuma zīme',
    polish: 'wykrzyknik (znak)',
    french: "point d'interrogation (ponctuation)",
    spanish: 'signo de interrogación',
  },
  {
    av: 8486,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation:
      '(punctuation mark - 1. used as punctuation in symbol sentences; 2. international mathematical symbol) - Character',
    english: 'period, point, full stop, decimal point',
    swedish: 'punkt',
    norwegian: 'punktum',
    finnish: 'piste',
    hungarian: 'pont',
    german: 'Punkt',
    dutch: 'punt',
    afrikaans: 'punt',
    russian: 'точка',
    latvian: 'punkts',
    polish: 'kropka',
    french: 'point (ponctuation)',
    spanish: 'punto, punto y aparte, punto decimal',
  },
  {
    av: 8487,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation:
      '(punctuation mark - 1. used as punctuation in symbol sentences; 2. used to divide component parts of compound and combined symbols, in order to clarify meaning) - Character',
    english: 'comma',
    swedish: 'kommatecken',
    norwegian: 'komma',
    finnish: 'pilkku',
    hungarian: 'vessző',
    german: 'Komma',
    dutch: 'komma',
    afrikaans: 'komma',
    russian: 'запятая',
    latvian: 'komats',
    polish: 'przecinek',
    french: 'virgule (ponctuation)',
    spanish: 'coma',
  },
  {
    av: 8488,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(punctuation mark) - Character',
    english: 'colon',
    swedish: 'kolon',
    norwegian: 'kolon',
    finnish: 'kaksoispiste',
    hungarian: 'kettőspont',
    german: 'Doppelpunkt',
    dutch: 'dubbelpunt, deelteken',
    afrikaans: 'dubbelpunt, deelteken',
    russian: 'двоеточие',
    latvian: 'kols',
    polish: 'dwukropek',
    french: 'deux-points (ponctuation)',
    spanish: 'punto y coma',
  },
  {
    av: 8489,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(punctuation mark) - Character',
    english: 'apostrophe',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8490,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(punctuation mark) - Character',
    english: 'degree',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8496,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 0) - Character',
    english: 'zero (digit), 0',
    swedish: 'noll, 0',
    norwegian: 'null, 0',
    finnish: 'nolla, 0',
    hungarian: 'nulla, 0',
    german: 'Null, 0',
    dutch: 'nul, 0',
    afrikaans: 'nul, zero, 0',
    russian: 'ноль, 0',
    latvian: 'nulle (cipars), 0',
    polish: 'zero (cyfra), 0',
    french: 'zéro (chiffre), 0',
    spanish: 'cero (dígito), 0',
  },
  {
    av: 8497,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 1) - Character',
    english: 'one (digit), 1',
    swedish: 'ett, 1',
    norwegian: 'en, 1',
    finnish: 'yksi, 1',
    hungarian: 'egy, 1',
    german: 'eins, 1',
    dutch: 'één, 1',
    afrikaans: 'een, 1',
    russian: 'один, 1',
    latvian: 'viens, (cipars), 1',
    polish: 'jeden (cyfra), 1',
    french: 'un (chiffre), 1',
    spanish: 'uno (dígito), 1',
  },
  {
    av: 8498,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 2) - Character',
    english: 'two (digit), 2',
    swedish: 'två, 2',
    norwegian: 'to, 2',
    finnish: 'kaksi, 2',
    hungarian: 'kettő, 2',
    german: 'zwei, 2',
    dutch: 'twee, 2',
    afrikaans: 'twee, 2',
    russian: 'два, 2',
    latvian: 'divi, (cipars), 2',
    polish: 'dwa (cyfra), 2',
    french: 'deux (chiffre), 2',
    spanish: 'dos (dígito), 2',
  },
  {
    av: 8499,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 3) - Character',
    english: 'three (digit), 3',
    swedish: 'tre, 3',
    norwegian: 'tre, 3',
    finnish: 'kolme, 3',
    hungarian: 'három, 3',
    german: 'drei, 3',
    dutch: 'drie, 3',
    afrikaans: 'drie, 3',
    russian: 'три, 3',
    latvian: 'trīs, (cipars), 3',
    polish: 'trzy (cyfra), 3',
    french: 'trois (chiffre), 3',
    spanish: 'tres (dígito), 3',
  },
  {
    av: 8500,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 4) - Character',
    english: 'four (digit), 4',
    swedish: 'fyra, 4',
    norwegian: 'fire, 4',
    finnish: 'neljä, 4',
    hungarian: 'négy, 4',
    german: 'vier, 4',
    dutch: 'vier, 4',
    afrikaans: 'vier, 4',
    russian: 'четыре, 4',
    latvian: 'četri, (cipars), 4',
    polish: 'cztery (cyfra), 4',
    french: 'quatre (chiffre), 4',
    spanish: 'cuatro (dígito), 4',
  },
  {
    av: 8501,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 5) - Character',
    english: 'five (digit), 5',
    swedish: 'fem, 5',
    norwegian: 'fem, 5',
    finnish: 'viisi, 5',
    hungarian: 'öt, 5',
    german: 'fünf, 5',
    dutch: 'vijf, 5',
    afrikaans: 'vyf, 5',
    russian: 'пять, 5',
    latvian: 'pieci, (cipars), 5',
    polish: 'pięć (cyfra), 5',
    french: 'cinq (chiffre), 5',
    spanish: 'cinco (dígito), 5',
  },
  {
    av: 8502,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 6) - Character',
    english: 'six (digit), 6',
    swedish: 'sex, 6',
    norwegian: 'seks, 6',
    finnish: 'kuusi, 6',
    hungarian: 'hat, 6',
    german: 'sechs, 6',
    dutch: 'zes, 6',
    afrikaans: 'ses, 6',
    russian: 'шесть, 6',
    latvian: 'seši, (cipars), 6',
    polish: 'sześć (cyfra), 6',
    french: 'six (chiffre), 6',
    spanish: 'seis (dígito), 6',
  },
  {
    av: 8503,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 7) - Character',
    english: 'seven (digit), 7',
    swedish: 'sju, 7',
    norwegian: 'syv, 7',
    finnish: 'seitsemän, 7',
    hungarian: 'hét, 7',
    german: 'sieben, 7',
    dutch: 'zeven, 7',
    afrikaans: 'sewe, 7',
    russian: 'семь, 7',
    latvian: 'septiņi, (cipars), 7',
    polish: 'siedem (cyfra), 7',
    french: 'sept (chiffre), 7',
    spanish: 'siete (dígito), 7',
  },
  {
    av: 8504,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 8) - Character',
    english: 'eight (digit), 8',
    swedish: 'åtta, 8',
    norwegian: 'åtte, 8',
    finnish: 'kahdeksan, 8',
    hungarian: 'nyolc, 8',
    german: 'acht, 8',
    dutch: 'acht, 8',
    afrikaans: 'agt, 8',
    russian: 'восемь, 8',
    latvian: 'astoņi, (cipars), 8',
    polish: 'osiem (cyfra), 8',
    french: 'huit (chiffre), 8',
    spanish: 'ocho (dígito), 8',
  },
  {
    av: 8505,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 9) - Character',
    english: 'nine (digit), 9',
    swedish: 'nio, 9',
    norwegian: 'ni, 9',
    finnish: 'yhdeksän, 9',
    hungarian: 'kilenc, 9',
    german: 'neun, 9',
    dutch: 'negen, 9',
    afrikaans: 'nege, 9',
    russian: 'девять, 9',
    latvian: 'deviņi, (cipars), 9',
    polish: 'dziewięć (cyfr), 9',
    french: 'neuf (chiffre), 9',
    spanish: 'nueve (dígito), 9',
  },
  {
    av: 8510,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 0 - small) - Character',
    english: 'zero (index number)',
    swedish: 'noll (indexsiffra)',
    norwegian: 'null (indekstall)',
    finnish: '',
    hungarian: '',
    german: 'Null (Indexnummer)',
    dutch: 'nul (index nummer)',
    afrikaans: 'nul (indeks nommer)',
    russian: 'ноль (номер индекса)',
    latvian: 'nulle (ideksa numurs)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8511,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 1 - small) - Character',
    english: 'one (index number)',
    swedish: 'ett (indexsiffra)',
    norwegian: 'en (indekstall)',
    finnish: '',
    hungarian: '',
    german: 'eins (Indexnummer)',
    dutch: 'één (index nummer)',
    afrikaans: 'een (indeks nommer)',
    russian: 'один (номер индекса)',
    latvian: 'viens (indeksa numurs)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8512,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 2 - small) - Character',
    english: 'two (index number)',
    swedish: 'två (indexsiffra)',
    norwegian: 'to (indekstall)',
    finnish: '',
    hungarian: '',
    german: 'zwei (Indexnummer)',
    dutch: 'twee (index nummer)',
    afrikaans: 'twee (indeks nommer)',
    russian: 'два (номер индекса)',
    latvian: 'divi (indeksa numurs)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8513,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 3 - small) - Character',
    english: 'three (index number)',
    swedish: 'tre (indexsiffra)',
    norwegian: 'tre (indekstall)',
    finnish: '',
    hungarian: '',
    german: 'drei (Indexnummer)',
    dutch: 'drie (index nummer)',
    afrikaans: 'drie (indeks nommer)',
    russian: 'три (номер индекса)',
    latvian: 'trīs (indeksa numurs)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8514,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 4 - small) - Character',
    english: 'four (index number)',
    swedish: 'fyra (indexsiffra)',
    norwegian: 'fire (indekstall)',
    finnish: '',
    hungarian: '',
    german: 'vier (Indexnummer)',
    dutch: 'vier (index nummer)',
    afrikaans: 'vier (indeks nommer)',
    russian: 'четыре (номер индекса)',
    latvian: 'četri (indeksa numurs)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8515,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 5 - small) - Character',
    english: 'five (index number)',
    swedish: 'fem (indexsiffra)',
    norwegian: 'fem (indekstall)',
    finnish: '',
    hungarian: '',
    german: 'fünf (Indexnummer)',
    dutch: 'vijf (index nummer)',
    afrikaans: 'vyf (indeks nommer)',
    russian: 'пять (номер индекса)',
    latvian: 'pieci (indeksa numurs)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8516,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 6 - small) - Character',
    english: 'six (index number)',
    swedish: 'sex (indexsiffra)',
    norwegian: 'seks (indekstall)',
    finnish: '',
    hungarian: '',
    german: 'sechs (Indexnummer)',
    dutch: 'zes (index nummer)',
    afrikaans: 'ses (indeks nommer)',
    russian: 'шесть (номер индекса)',
    latvian: 'seši (indeksa numurs)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8517,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 7 - small) - Character',
    english: 'seven (index number)',
    swedish: 'sju (indexsiffra)',
    norwegian: 'syv (indekstall)',
    finnish: '',
    hungarian: '',
    german: 'sieben (Indexnummer)',
    dutch: 'zeven (index nummer)',
    afrikaans: 'sewe (indeks nommer)',
    russian: 'семь (номер индекса)',
    latvian: 'septiņi (indeksa numurs)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8518,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 8 - small) - Character',
    english: 'eight (index number)',
    swedish: 'åtta (indexsiffra)',
    norwegian: 'åtte (indekstall)',
    finnish: '',
    hungarian: '',
    german: 'acht (Indexnummer)',
    dutch: 'acht (index nummer)',
    afrikaans: 'agt (indeks nommer)',
    russian: 'восемь (номер индекса)',
    latvian: 'astoņi (indeksa numurs)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8519,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Arabic numeral 9 - small) - Character',
    english: 'nine (index number)',
    swedish: 'nio (indexsiffra)',
    norwegian: 'ni (indekstall)',
    finnish: '',
    hungarian: '',
    german: 'neun (Indexnummer)',
    dutch: 'negen (index nummer)',
    afrikaans: 'nege (indeks nommer)',
    russian: 'девять (номер индекса)',
    latvian: 'deviņi (indeksa numurs)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 8521,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter a) - Character',
    english: 'a (lowercase)',
    swedish: 'a (lilla)',
    norwegian: 'a (liten bokstav)',
    finnish: 'a (pieni kirjain)',
    hungarian: 'a (kisbetű)',
    german: 'a (Kleinbuchstabe)',
    dutch: 'a (kleine letter)',
    afrikaans: 'a (kleinletter)',
    russian: 'a (строчная буква)',
    latvian: 'a (mazais burts)',
    polish: 'a (mała litera)',
    french: 'a (lettre minuscule)',
    spanish: 'a (letra minúscula)',
  },
  {
    av: 8522,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter b) - Character',
    english: 'b (lowercase)',
    swedish: 'b (lilla)',
    norwegian: 'b (liten bokstav)',
    finnish: 'b (pieni kirjain)',
    hungarian: 'b (kisbetű)',
    german: 'b (Kleinbuchstabe)',
    dutch: 'b (kleine letter)',
    afrikaans: 'b (kleinletter)',
    russian: 'b (строчная буква)',
    latvian: 'b (mazais burts)',
    polish: 'b (mała litera)',
    french: 'b (lettre minuscule)',
    spanish: 'b (letra minúscula)',
  },
  {
    av: 8523,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter c) - Character',
    english: 'c (lowercase)',
    swedish: 'c (lilla)',
    norwegian: 'c (liten bokstav)',
    finnish: 'c (pieni kirjain)',
    hungarian: 'c (kisbetű)',
    german: 'c (Kleinbuchstabe)',
    dutch: 'c (kleine letter)',
    afrikaans: 'c kleinletter',
    russian: 'c (строчная буква)',
    latvian: 'c (mazais burts)',
    polish: 'c (mała litera)',
    french: 'c (lettre minuscule)',
    spanish: 'c (letra minúscula)',
  },
  {
    av: 8524,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter d) - Character',
    english: 'd (lowercase)',
    swedish: 'd (lilla)',
    norwegian: 'd (liten bokstav)',
    finnish: 'd (pieni kirjain)',
    hungarian: 'd (kisbetű)',
    german: 'd (Kleinbuchstabe)',
    dutch: 'd (kleine letter)',
    afrikaans: 'd (kleinletter)',
    russian: 'd (строчная буква)',
    latvian: 'd (mazais burts)',
    polish: 'd (mała litera)',
    french: 'd (lettre minuscule)',
    spanish: 'd (letra minúscula)',
  },
  {
    av: 8525,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter e) - Character',
    english: 'e (lowercase)',
    swedish: 'e (lilla)',
    norwegian: 'e (liten bokstav)',
    finnish: 'e (pieni kirjain)',
    hungarian: 'e (kisbetű)',
    german: 'e (Kleinbuchstabe)',
    dutch: 'e (kleine letter)',
    afrikaans: 'e (kleinletter)',
    russian: 'e (строчная буква)',
    latvian: 'e (mazais burts)',
    polish: 'e (mała litera)',
    french: 'e (lettre minuscule)',
    spanish: 'e (letra minúscula)',
  },
  {
    av: 8526,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter f) - Character',
    english: 'f (lowercase)',
    swedish: 'f (lilla)',
    norwegian: 'f (liten bokstav)',
    finnish: 'f (pieni kirjain)',
    hungarian: 'f (kisbetű)',
    german: 'f (Kleinbuchstabe)',
    dutch: 'f (kleine letter)',
    afrikaans: 'f (kleinletter)',
    russian: 'f (строчная буква)',
    latvian: 'f (mazais burts)',
    polish: 'f (mała litera)',
    french: 'f (lettre minuscule)',
    spanish: 'f (letra minúscula)',
  },
  {
    av: 8527,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter g) - Character',
    english: 'g (lowercase)',
    swedish: 'g (lilla)',
    norwegian: 'g (liten bokstav)',
    finnish: 'g (pieni kirjain)',
    hungarian: 'g (kisbetű)',
    german: 'g (Kleinbuchstabe)',
    dutch: 'g (kleine letter)',
    afrikaans: 'g (kleinletter)',
    russian: 'g (строчная буква)',
    latvian: 'g (mazais burts)',
    polish: 'g (mała litera)',
    french: 'g (lettre minuscule)',
    spanish: 'g (letra minúscula)',
  },
  {
    av: 8528,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter h) - Character',
    english: 'h (lowercase)',
    swedish: 'h (lilla)',
    norwegian: 'h (liten bokstav)',
    finnish: 'h (pieni kirjain)',
    hungarian: 'h (kisbetű)',
    german: 'h (Kleinbuchstabe)',
    dutch: 'h (kleine letter)',
    afrikaans: 'h (kleinletter)',
    russian: 'h (строчная буква)',
    latvian: 'h (mazais burts)',
    polish: 'h (mała litera)',
    french: 'h (lettre minuscule)',
    spanish: 'h (letra minúscula)',
  },
  {
    av: 8529,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter i) - Character',
    english: 'i (lowercase)',
    swedish: 'i (lilla)',
    norwegian: 'i (liten bokstav)',
    finnish: 'i (pieni kirjain)',
    hungarian: 'i (kisbetű)',
    german: 'i (Kleinbuchstabe)',
    dutch: 'i (kleine letter)',
    afrikaans: 'i (kleinletter)',
    russian: 'i (строчная буква)',
    latvian: 'i (mazais burts)',
    polish: 'i (mała litera)',
    french: 'i (lettre minuscule)',
    spanish: 'i (letra minúscula)',
  },
  {
    av: 8530,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter j) - Character',
    english: 'j (lowercase)',
    swedish: 'j (lilla)',
    norwegian: 'j (liten bokstav)',
    finnish: 'j (pieni kirjain)',
    hungarian: 'j (kisbetű)',
    german: 'j (Kleinbuchstabe)',
    dutch: 'j (kleine letter)',
    afrikaans: 'j (kleinletter)',
    russian: 'j (строчная буква)',
    latvian: 'j (mazais burts)',
    polish: 'j (mała litera)',
    french: 'j (lettre minuscule)',
    spanish: 'j (letra minúscula)',
  },
  {
    av: 8531,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter k) - Character',
    english: 'k (lowercase)',
    swedish: 'k (lilla)',
    norwegian: 'k (liten bokstav)',
    finnish: 'k (pieni kirjain)',
    hungarian: 'k (kisbetű)',
    german: 'k (Kleinbuchstabe)',
    dutch: 'k (kleine letter)',
    afrikaans: 'k (kleinletter)',
    russian: 'k (строчная буква)',
    latvian: 'k (mazais burts)',
    polish: 'k (mała litera)',
    french: 'k (lettre minuscule)',
    spanish: 'k (letra minúscula)',
  },
  {
    av: 8532,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter l) - Character',
    english: 'l (lowercase)',
    swedish: 'l (lilla)',
    norwegian: 'l (liten bokstav)',
    finnish: 'l (pieni kirjain)',
    hungarian: 'l (kisbetű)',
    german: 'l (Kleinbuchstabe)',
    dutch: 'l (kleine letter)',
    afrikaans: 'l (kleinletter)',
    russian: 'l (строчная буква)',
    latvian: 'l (mazais burts)',
    polish: 'l (mała litera)',
    french: 'l (lettre minuscule)',
    spanish: 'l (letra minúscula)',
  },
  {
    av: 8533,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter m) - Character',
    english: 'm (lowercase)',
    swedish: 'm (lilla)',
    norwegian: 'm (liten bokstav)',
    finnish: 'm (pieni kirjain)',
    hungarian: 'm (kisbetű)',
    german: 'm (Kleinbuchstabe)',
    dutch: 'm (kleine letter)',
    afrikaans: 'm kleinletter',
    russian: 'm (строчная буква)',
    latvian: 'm (mazais burts)',
    polish: 'm (mała litera)',
    french: 'm (lettre minuscule)',
    spanish: 'm (letra minúscula)',
  },
  {
    av: 8534,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter n) - Character',
    english: 'n (lowercase)',
    swedish: 'n (lilla)',
    norwegian: 'n (liten bokstav)',
    finnish: 'n (pieni kirjain)',
    hungarian: 'n (kisbetű)',
    german: 'n (Kleinbuchstabe)',
    dutch: 'n (kleine letter)',
    afrikaans: 'n (kleinletter)',
    russian: 'n (строчная буква)',
    latvian: 'n (mazais burts)',
    polish: 'n (mała litera)',
    french: 'n (lettre minuscule)',
    spanish: 'n (letra minúscula)',
  },
  {
    av: 8535,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter o) - Character',
    english: 'o (lowercase)',
    swedish: 'o (lilla)',
    norwegian: 'o (liten bokstav)',
    finnish: 'o (pieni kirjain)',
    hungarian: 'o (kisbetű)',
    german: 'o (Kleinbuchstabe)',
    dutch: 'o (kleine letter)',
    afrikaans: 'o (kleinletter)',
    russian: 'o (строчная буква)',
    latvian: 'o (mazais burts)',
    polish: 'o (mała litera)',
    french: 'o (lettre minuscule)',
    spanish: 'o (letra minúscula)',
  },
  {
    av: 8536,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter p) - Character',
    english: 'p (lowercase)',
    swedish: 'p (lilla)',
    norwegian: 'p (liten bokstav)',
    finnish: 'p (pieni kirjain)',
    hungarian: 'p (kisbetű)',
    german: 'p (Kleinbuchstabe)',
    dutch: 'p (kleine letter)',
    afrikaans: 'p (kleinletter)',
    russian: 'p (строчная буква)',
    latvian: 'p (mazais burts)',
    polish: 'p (mała litera)',
    french: 'p (lettre minuscule)',
    spanish: 'p (letra minúscula)',
  },
  {
    av: 8537,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter q) - Character',
    english: 'q (lowercase)',
    swedish: 'q (lilla)',
    norwegian: 'q (liten bokstav)',
    finnish: 'q (pieni kirjain)',
    hungarian: 'q (kisbetű)',
    german: 'q (Kleinbuchstabe)',
    dutch: 'q (kleine letter)',
    afrikaans: 'q (kleinletter)',
    russian: 'q (строчная буква)',
    latvian: 'q (mazais burts)',
    polish: 'q (mała litera)',
    french: 'q (lettre minuscule)',
    spanish: 'q (letra minúscula)',
  },
  {
    av: 8538,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter r) - Character',
    english: 'r (lowercase)',
    swedish: 'r (lilla)',
    norwegian: 'r (liten bokstav)',
    finnish: 'r (pieni kirjain)',
    hungarian: 'r (kisbetű)',
    german: 'r (Kleinbuchstabe)',
    dutch: 'r (kleine letter)',
    afrikaans: 'r (kleinletter)',
    russian: 'r (строчная буква)',
    latvian: 'r (mazais burts)',
    polish: 'r (mała litera)',
    french: 'r (lettre minuscule)',
    spanish: 'r (letra minúscula)',
  },
  {
    av: 8539,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter s) - Character',
    english: 's (lowercase)',
    swedish: 's (lilla)',
    norwegian: 's (liten bokstav)',
    finnish: 's (pieni kirjain)',
    hungarian: 's (kisbetű)',
    german: 's (Kleinbuchstabe)',
    dutch: 's (kleine letter)',
    afrikaans: 's (kleinletter)',
    russian: 's (строчная буква)',
    latvian: 's (mazais burts)',
    polish: 's (mała litera)',
    french: 's (lettre minuscule)',
    spanish: 's (letra minúscula)',
  },
  {
    av: 8540,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter t) - Character',
    english: 't (lowercase)',
    swedish: 't (lilla)',
    norwegian: 't (liten bokstav)',
    finnish: 't (pieni kirjain)',
    hungarian: 't (kisbetű)',
    german: 't (Kleinbuchstabe)',
    dutch: 't (kleine letter)',
    afrikaans: 't (kleinletter)',
    russian: 't (строчная буква)',
    latvian: 't (mazais burts)',
    polish: 't (mała litera)',
    french: 't (lettre minuscule)',
    spanish: 't (letra minúscula)',
  },
  {
    av: 8541,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter u) - Character',
    english: 'u (lowercase)',
    swedish: 'u (lilla)',
    norwegian: 'u (liten bokstav)',
    finnish: 'u (pieni kirjain)',
    hungarian: 'u (kisbetű)',
    german: 'u (Kleinbuchstabe)',
    dutch: 'u (kleine letter)',
    afrikaans: 'u (kleinletter)',
    russian: 'u (строчная буква)',
    latvian: 'u (mazais burts)',
    polish: 'u (mała litera)',
    french: 'u (lettre minuscule)',
    spanish: 'u (letra minúscula)',
  },
  {
    av: 8542,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter v) - Character',
    english: 'v (lowercase)',
    swedish: 'v (lilla)',
    norwegian: 'v (liten bokstav)',
    finnish: 'v (pieni kirjain)',
    hungarian: 'v (kisbetű)',
    german: 'v (Kleinbuchstabe)',
    dutch: 'v (kleine letter)',
    afrikaans: 'v (kleinletter)',
    russian: 'v (строчная буква)',
    latvian: 'v (mazais burts)',
    polish: 'v (mała litera)',
    french: 'v (lettre minuscule)',
    spanish: 'v (letra minúscula)',
  },
  {
    av: 8543,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter w) - Character',
    english: 'w (lowercase)',
    swedish: 'w (lilla)',
    norwegian: 'w (liten bokstav)',
    finnish: 'w (pieni kirjain)',
    hungarian: 'w (kisbetű)',
    german: 'w (Kleinbuchstabe)',
    dutch: 'w (kleine letter)',
    afrikaans: 'w (kleinletter)',
    russian: 'w (строчная буква)',
    latvian: 'w (mazais burts)',
    polish: 'w (mała litera)',
    french: 'w (lettre minuscule)',
    spanish: 'w (letra minúscula)',
  },
  {
    av: 8544,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter x) - Character',
    english: 'x (lowercase)',
    swedish: 'x (lilla)',
    norwegian: 'x (liten bokstav)',
    finnish: 'x (pieni kirjain)',
    hungarian: 'x (kisbetű)',
    german: 'x (Kleinbuchstabe)',
    dutch: 'x (kleine letter)',
    afrikaans: 'x (kleinletter)',
    russian: 'x (строчная буква)',
    latvian: 'x (mazais burts)',
    polish: 'x (mała litera)',
    french: 'x (lettre minuscule)',
    spanish: 'x (letra minúscula)',
  },
  {
    av: 8545,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter y) - Character',
    english: 'y (lowercase)',
    swedish: 'y (lilla)',
    norwegian: 'y (liten bokstav)',
    finnish: 'y (pieni kirjain)',
    hungarian: 'y (kisbetű)',
    german: 'y (Kleinbuchstabe)',
    dutch: 'y (kleine letter)',
    afrikaans: 'y (kleinletter)',
    russian: 'y (строчная буква)',
    latvian: 'y (mazais burts)',
    polish: 'y (mała litera)',
    french: 'y (lettre minuscule)',
    spanish: 'y (letra minúscula)',
  },
  {
    av: 8546,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English lowercase letter z) - Character',
    english: 'z (lowercase)',
    swedish: 'z (lilla)',
    norwegian: 'z (liten bokstav)',
    finnish: 'z (pieni kirjain)',
    hungarian: 'z (kisbetű)',
    german: 'z (Kleinbuchstabe)',
    dutch: 'z (kleine letter)',
    afrikaans: 'z (kleinletter)',
    russian: 'z (строчная буква)',
    latvian: 'z (mazais burts)',
    polish: 'z (mała litera)',
    french: 'z (lettre minuscule)',
    spanish: 'z (letra minúscula)',
  },
  {
    av: 8551,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter A) - Character',
    english: 'A (uppercase)',
    swedish: 'A (stora)',
    norwegian: 'A (stor bokstav)',
    finnish: 'A (iso kirjain)',
    hungarian: 'A (nagybetű)',
    german: 'A (Großbuchstabe)',
    dutch: 'A (hoofdletter)',
    afrikaans: 'A (hoofletter)',
    russian: 'A (прописная буква)',
    latvian: 'A (lielais burts)',
    polish: 'A (wielka litera)',
    french: 'A (lettre majuscule)',
    spanish: 'A (letra mayúscula)',
  },
  {
    av: 8552,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter B) - Character',
    english: 'B (uppercase)',
    swedish: 'B (stora)',
    norwegian: 'B (stor bokstav)',
    finnish: 'B (iso kirjain)',
    hungarian: 'B (nagybetű)',
    german: 'B (Großbuchstabe)',
    dutch: 'B (hoofdletter)',
    afrikaans: 'B (hoofletter)',
    russian: 'B (прописная буква)',
    latvian: 'B (lielais burts)',
    polish: 'B (wielka litera)',
    french: 'B (lettre majuscule)',
    spanish: 'B (letra mayúscula)',
  },
  {
    av: 8553,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter C) - Character',
    english: 'C (uppercase)',
    swedish: 'C (stora)',
    norwegian: 'C (stor bokstav)',
    finnish: 'C (iso kirjain)',
    hungarian: 'C (nagybetű)',
    german: 'C (Großbuchstabe)',
    dutch: 'C (hoofdletter)',
    afrikaans: 'C (hoofletter)',
    russian: 'C (прописная буква)',
    latvian: 'C (lielais burts)',
    polish: 'C (wielka litera)',
    french: 'C (lettre majuscule)',
    spanish: 'C (letra mayúscula)',
  },
  {
    av: 8554,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter D) - Character',
    english: 'D (uppercase)',
    swedish: 'D (stora)',
    norwegian: 'D (stor bokstav)',
    finnish: 'D (iso kirjain)',
    hungarian: 'D (nagybetű)',
    german: 'D (Großbuchstabe)',
    dutch: 'D (hoofdletter)',
    afrikaans: 'D (hoofletter)',
    russian: 'D (прописная буква)',
    latvian: 'D (lielais burts)',
    polish: 'D (wielka litera)',
    french: 'D (lettre majuscule)',
    spanish: 'D (letra mayúscula)',
  },
  {
    av: 8555,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter E) - Character',
    english: 'E (uppercase)',
    swedish: 'E (stora)',
    norwegian: 'E (stor bokstav)',
    finnish: 'E (iso kirjain)',
    hungarian: 'E (nagybetű)',
    german: 'E (Großbuchstabe)',
    dutch: 'E (hoofdletter)',
    afrikaans: 'E (hoofletter)',
    russian: 'E (прописная буква)',
    latvian: 'E (lielais burts)',
    polish: 'E (wielka litera)',
    french: 'E (lettre majuscule)',
    spanish: 'E (letra mayúscula)',
  },
  {
    av: 8556,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter F) - Character',
    english: 'F (uppercase)',
    swedish: 'F (stora)',
    norwegian: 'F (stor bokstav)',
    finnish: 'F (iso kirjain)',
    hungarian: 'F (nagybetű)',
    german: 'F (Großbuchstabe)',
    dutch: 'F (hoofdletter)',
    afrikaans: 'F (hoofletter)',
    russian: 'F (прописная буква)',
    latvian: 'F (lielais burts)',
    polish: 'F (wielka litera)',
    french: 'F (lettre majuscule)',
    spanish: 'F (letra mayúscula)',
  },
  {
    av: 8557,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter G) - Character',
    english: 'G (uppercase)',
    swedish: 'G (stora)',
    norwegian: 'G (stor bokstav)',
    finnish: 'G (iso kirjain)',
    hungarian: 'G (nagybetű)',
    german: 'G (Großbuchstabe)',
    dutch: 'G (hoofdletter)',
    afrikaans: 'G (hoofletter)',
    russian: 'G (прописная буква)',
    latvian: 'G (lielais burts)',
    polish: 'G (wielka litera)',
    french: 'G (lettre majuscule)',
    spanish: 'G (letra mayúscula)',
  },
  {
    av: 8558,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter H) - Character',
    english: 'H (uppercase)',
    swedish: 'H (stora)',
    norwegian: 'H (stor bokstav)',
    finnish: 'H (iso kirjain)',
    hungarian: 'H (nagybetű)',
    german: 'H (Großbuchstabe)',
    dutch: 'H (hoofdletter)',
    afrikaans: 'H (hoofletter)',
    russian: 'H (прописная буква)',
    latvian: 'H (lielais burts)',
    polish: 'H (wielka litera)',
    french: 'H (lettre majuscule)',
    spanish: 'H (letra mayúscula)',
  },
  {
    av: 8559,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter I) - Character',
    english: 'I (uppercase)',
    swedish: 'I (stora)',
    norwegian: 'I (stor bokstav)',
    finnish: 'I (iso kirjain)',
    hungarian: 'I (nagybetű)',
    german: 'I (Großbuchstabe)',
    dutch: 'I (hoofdletter)',
    afrikaans: 'I (hoofletter)',
    russian: 'I (прописная буква)',
    latvian: 'I (lielais burts)',
    polish: 'I (wielka litera)',
    french: 'I (lettre majuscule)',
    spanish: 'I (letra mayúscula)',
  },
  {
    av: 8560,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter J) - Character',
    english: 'J (uppercase)',
    swedish: 'J (stora)',
    norwegian: 'J (stor bokstav)',
    finnish: 'J (iso kirjain)',
    hungarian: 'J (nagybetű)',
    german: 'J (Großbuchstabe)',
    dutch: 'J (hoofdletter)',
    afrikaans: 'J (hoofletter)',
    russian: 'J (прописная буква)',
    latvian: 'J (lielais burts)',
    polish: 'J (wielka litera)',
    french: 'J (lettre majuscule)',
    spanish: 'J (letra mayúscula)',
  },
  {
    av: 8561,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter K) - Character',
    english: 'K (uppercase)',
    swedish: 'K (stora)',
    norwegian: 'K (stor bokstav)',
    finnish: 'K (iso kirjain)',
    hungarian: 'K (nagybetű)',
    german: 'K (Großbuchstabe)',
    dutch: 'K (hoofdletter)',
    afrikaans: 'K (hoofletter)',
    russian: 'K (прописная буква)',
    latvian: 'K (lielais burts)',
    polish: 'K (wielka litera)',
    french: 'K (lettre majuscule)',
    spanish: 'K (letra mayúscula)',
  },
  {
    av: 8562,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter L) - Character',
    english: 'L (uppercase)',
    swedish: 'L (stora)',
    norwegian: 'L (stor bokstav)',
    finnish: 'L (iso kirjain)',
    hungarian: 'L (nagybetű)',
    german: 'L (Großbuchstabe)',
    dutch: 'L (hoofdletter)',
    afrikaans: 'L (hoofletter)',
    russian: 'L (прописная буква)',
    latvian: 'L (lielais burts)',
    polish: 'L (wielka litera)',
    french: 'L (lettre majuscule)',
    spanish: 'L (letra mayúscula)',
  },
  {
    av: 8563,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter M) - Character',
    english: 'M (uppercase)',
    swedish: 'M (stora)',
    norwegian: 'M (stor bokstav)',
    finnish: 'M (iso kirjain)',
    hungarian: 'M (nagybetű)',
    german: 'M (Großbuchstabe)',
    dutch: 'M (hoofdletter)',
    afrikaans: 'M (hoofletter)',
    russian: 'M (прописная буква)',
    latvian: 'M (lielais burts)',
    polish: 'M (wielka litera)',
    french: 'M (lettre majuscule)',
    spanish: 'M (letra mayúscula)',
  },
  {
    av: 8564,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter N) - Character',
    english: 'N (uppercase)',
    swedish: 'N (stora)',
    norwegian: 'N (stor bokstav)',
    finnish: 'N (iso kirjain)',
    hungarian: 'N (nagybetű)',
    german: 'N (Großbuchstabe)',
    dutch: 'N (hoofdletter)',
    afrikaans: 'N (hoofletter)',
    russian: 'N (прописная буква)',
    latvian: 'N (lielais burts)',
    polish: 'N (wielka litera)',
    french: 'N (lettre majuscule)',
    spanish: 'N (letra mayúscula)',
  },
  {
    av: 8565,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter O) - Character',
    english: 'O (uppercase)',
    swedish: 'O (stora)',
    norwegian: 'O (stor bokstav)',
    finnish: 'O (iso kirjain)',
    hungarian: 'O (nagybetű)',
    german: 'O (Großbuchstabe)',
    dutch: 'O (hoofdletter)',
    afrikaans: 'O (hoofletter)',
    russian: 'O (прописная буква)',
    latvian: 'O (lielais burts)',
    polish: 'O (wielka litera)',
    french: 'O (lettre majuscule)',
    spanish: 'O (letra mayúscula)',
  },
  {
    av: 8566,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter P) - Character',
    english: 'P (uppercase)',
    swedish: 'P (stora)',
    norwegian: 'P (stor bokstav)',
    finnish: 'P (iso kirjain)',
    hungarian: 'P (nagybetű)',
    german: 'P (Großbuchstabe)',
    dutch: 'P (hoofdletter)',
    afrikaans: 'P (hoofletter)',
    russian: 'P (прописная буква)',
    latvian: 'P (lielais burts)',
    polish: 'P (wielka litera)',
    french: 'P (lettre majuscule)',
    spanish: 'P (letra mayúscula)',
  },
  {
    av: 8567,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter Q) - Character',
    english: 'Q (uppercase)',
    swedish: 'Q (stora)',
    norwegian: 'Q (stor bokstav)',
    finnish: 'Q (iso kirjain)',
    hungarian: 'Q (nagybetű)',
    german: 'Q (Großbuchstabe)',
    dutch: 'Q (hoofdletter)',
    afrikaans: 'Q (hoofletter)',
    russian: 'Q (прописная буква)',
    latvian: 'Q (lielais burts)',
    polish: 'Q (wielka litera)',
    french: 'Q (lettre majuscule)',
    spanish: 'Q (letra mayúscula)',
  },
  {
    av: 8568,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter R) - Character',
    english: 'R (uppercase)',
    swedish: 'R (stora)',
    norwegian: 'R (stor bokstav)',
    finnish: 'R (iso kirjain)',
    hungarian: 'R (nagybetű)',
    german: 'R (Großbuchstabe)',
    dutch: 'R (hoofdletter)',
    afrikaans: 'R (hoofletter)',
    russian: 'R (прописная буква)',
    latvian: 'R (lielais burts)',
    polish: 'R (wielka litera)',
    french: 'R (lettre majuscule)',
    spanish: 'R (letra mayúscula)',
  },
  {
    av: 8569,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter S) - Character',
    english: 'S (uppercase)',
    swedish: 'S (stora)',
    norwegian: 'S (stor bokstav)',
    finnish: 'S (iso kirjain)',
    hungarian: 'S (nagybetű)',
    german: 'S (Großbuchstabe)',
    dutch: 'S (hoofdletter)',
    afrikaans: 'S (hoofletter)',
    russian: 'S (прописная буква)',
    latvian: 'S (lielais burts)',
    polish: 'S (wielka litera)',
    french: 'S (lettre majuscule)',
    spanish: 'S (letra mayúscula)',
  },
  {
    av: 8570,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter T) - Character',
    english: 'T (uppercase)',
    swedish: 'T (stora)',
    norwegian: 'T (stor bokstav)',
    finnish: 'T (iso kirjain)',
    hungarian: 'T (nagybetű)',
    german: 'T (Großbuchstabe)',
    dutch: 'T (hoofdletter)',
    afrikaans: 'T (hoofletter)',
    russian: 'T (прописная буква)',
    latvian: 'T (lielais burts)',
    polish: 'T (wielka litera)',
    french: 'T (lettre majuscule)',
    spanish: 'T (letra mayúscula)',
  },
  {
    av: 8571,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter U) - Character',
    english: 'U (uppercase)',
    swedish: 'U (stora)',
    norwegian: 'U (stor bokstav)',
    finnish: 'U (iso kirjain)',
    hungarian: 'U (nagybetű)',
    german: 'U (Großbuchstabe)',
    dutch: 'U (hoofdletter)',
    afrikaans: 'U (hoofletter)',
    russian: 'U (прописная буква)',
    latvian: 'U (lielais burts)',
    polish: 'U (wielka litera)',
    french: 'U (lettre majuscule)',
    spanish: 'U (letra mayúscula)',
  },
  {
    av: 8572,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter V) - Character',
    english: 'V (uppercase)',
    swedish: 'V (stora)',
    norwegian: 'V (stor bokstav)',
    finnish: 'V (iso kirjain)',
    hungarian: 'V (nagybetű)',
    german: 'V (Großbuchstabe)',
    dutch: 'V (hoofdletter)',
    afrikaans: 'V (hoofletter)',
    russian: 'V (прописная буква)',
    latvian: 'V (lielais burts)',
    polish: 'V (wielka litera)',
    french: 'V (lettre majuscule)',
    spanish: 'V (letra mayúscula)',
  },
  {
    av: 8573,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter W) - Character',
    english: 'W (uppercase)',
    swedish: 'W (stora)',
    norwegian: 'W (stor bokstav)',
    finnish: 'W (iso kirjain)',
    hungarian: 'W (nagybetű)',
    german: 'W (Großbuchstabe)',
    dutch: 'W (hoofdletter)',
    afrikaans: 'W (hoofletter)',
    russian: 'W (прописная буква)',
    latvian: 'W (lielais burts)',
    polish: 'W (wielka litera)',
    french: 'W (lettre majuscule)',
    spanish: 'W (letra mayúscula)',
  },
  {
    av: 8574,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter X) - Character',
    english: 'X (uppercase)',
    swedish: 'X (stora)',
    norwegian: 'X (stor bokstav)',
    finnish: 'X (iso kirjain)',
    hungarian: 'X (nagybetű)',
    german: 'X (Großbuchstabe)',
    dutch: 'X (hoofdletter)',
    afrikaans: 'X (hoofletter)',
    russian: 'X (прописная буква)',
    latvian: 'X (lielais burts)',
    polish: 'X (wielka litera)',
    french: 'X (lettre majuscule)',
    spanish: 'X (letra mayúscula)',
  },
  {
    av: 8575,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter Y) - Character',
    english: 'Y (uppercase)',
    swedish: 'Y (stora)',
    norwegian: 'Y (stor bokstav)',
    finnish: 'Y (iso kirjain)',
    hungarian: 'Y (nagybetű)',
    german: 'Y (Großbuchstabe)',
    dutch: 'Y (hoofdletter)',
    afrikaans: 'Y (hoofletter)',
    russian: 'Y (прописная буква)',
    latvian: 'Y (lielais burts)',
    polish: 'Y (wielka litera)',
    french: 'Y (lettre majuscule)',
    spanish: 'Y (letra mayúscula)',
  },
  {
    av: 8576,
    group: 'diacritics',
    pos: 'WHITE',
    derivationExplanation: '(Latin English uppercase letter Z) - Character',
    english: 'Z (uppercase)',
    swedish: 'Z (stora)',
    norwegian: 'Z (stor bokstav)',
    finnish: 'Z (iso kirjain)',
    hungarian: 'Z (nagybetű)',
    german: 'Z (Großbuchstabe)',
    dutch: 'Z (hoofdletter)',
    afrikaans: 'Z (hoofletter)',
    russian: 'Z (прописная буква)',
    latvian: 'Z (lielais burts)',
    polish: 'Z (wielka litera)',
    french: 'Z (lettre majuscule)',
    spanish: 'Z (letra mayúscula)',
  },
  {
    av: 8993,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(action [quarter-sized]: placed above a symbol to create (1) the infinitive form of a verb, and (2) the present tense of a verb) - Character (indicator)',
    english: 'indicator (action)',
    swedish: 'operator (handling, infinitiv)',
    norwegian: 'indikator (infinitiv, handling)',
    finnish: 'toiminnan merkki',
    hungarian: 'cselekvésjel (igét jelző nyelvtani indikátor)',
    german: 'Indikator (Handlung, Infinitiv, Gegenwart)',
    dutch: 'indicator tegenwoordige tijd',
    afrikaans: 'aanwyser (teenwoordige tyd, infinitief) (aksie)',
    russian: 'индикатор (неопр.ф.гл.)',
    latvian: 'indikators (darbības vārds)',
    polish: 'wyznacznik czasownika ',
    french: 'indicateur de verbe (action)',
    spanish: 'indicador (acción)',
  },
  {
    av: 8994,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(action indicator [modification]: turned on its side and pointing forward: placed above a symbol to emphasize that something is acting on something else. The symbol is logically related to about.) - Character (indicator - modified)',
    english: 'indicator (active)',
    swedish: 'operator (handling aktiv form)',
    norwegian: 'indikator (aktiv form)',
    finnish: 'aktiivin merkki',
    hungarian: '',
    german: 'Indikator (Handlung, aktive Form)',
    dutch: 'indicator (active)',
    afrikaans: 'aanwyser (aktief)',
    russian: 'индикатор (творит.залог гл.)',
    latvian: 'indikators (aktīvā forma)',
    polish: 'wyznacznik strony czynnej',
    french: 'indicateur du verbe à la voix active',
    spanish: 'indicador (activo)',
  },
  {
    av: 8995,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(question mark [quarter-sized]: placed above a symbol to indicate the equivalent of the English present conditional form) - Character (indicator)',
    english: 'indicator (conditional)',
    swedish: 'operator (konditionalis)',
    norwegian: 'indikator (preteritum futurum)',
    finnish: 'mahdollisen toiminnan merkki',
    hungarian: 'feltételes jelen idő jele (nyelvtani indikátor)',
    german: 'Indikator (Bedingungsform, Irrealis)',
    dutch: 'indicator voorwaardelijk tegenwoordige tijd',
    afrikaans: 'aanwyser (kondisioneel, voorwaardelik, voorwaardelike wys)',
    russian: 'индикатор (услов.наклон.гл.)',
    latvian: 'indikators (nosacītais laiks)',
    polish: 'wyznacznik trybu przypuszczającego',
    french: 'indicateur du conditionnel',
    spanish: 'indicador (condicional)',
  },
  {
    av: 8996,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(description indicator + dot: placed above a symbol to indicate meanings equivalent to an English past participle, usually with an -ed or -en ending) - Character (superimposed - indicator)',
    english: 'indicator (description after fact)',
    swedish: 'operator (värdering efter faktum)',
    norwegian: 'indikator (vurdering etter fakta)',
    finnish: 'kuvailu tilanteen jälkeen -merkki',
    hungarian: 'múlt idejű melléknévi igenév jele ',
    german: 'Indikator (Beschreibung nach Tatsache, Partizip II)',
    dutch: 'indicator beschrijving na feit',
    afrikaans: 'aanwyser (na die feit)',
    russian: 'индикатор (описание после факта)',
    latvian: 'indikators (pagātnes forma)',
    polish:
      'wyznacznik przymiotnika o zakończonym wartościowaniu (np. śmierć z tym wyznacznikem utworzy symbol „zmarły)',
    french: "indicateur d'évaluation après le fait",
    spanish: 'indicador (descripción posterior al hecho)',
  },
  {
    av: 8997,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(dot + description indicator: the dot comes before the indicator: placed above a symbol to produce meanings equivalent to English words ending in -able) - Character (superimposed - indicator)',
    english: 'indicator (description before fact)',
    swedish: 'operator (värdering före faktum)',
    norwegian: 'indikator (vurdering før fakta)',
    finnish: 'kuvailu ennen tilannetta -merkki',
    hungarian: 'jelen idejű melléknévi igenév jele',
    german: 'Indikator (Beschreibung vor der Tatsache)',
    dutch: 'indictor beschrijving voor het feit',
    afrikaans: 'aanwyser (voor die feit)',
    russian: 'индикатор (описание до факта)',
    latvian: 'indikators (līdz faktam)',
    polish: 'wyznacznik przymiotnika o niezakończonym wartościowaniu (śmierć--> umierający)',
    french: "indicateur d'évaluation avant le fait",
    spanish: 'indicador (descripción anterior al hecho)',
  },
  {
    av: 8998,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(evaluation [quarter-sized]: placed above a symbol to show that it is describing or evaluating something. This indicator produces meanings equivalent to English adjectives and adverbs.) - Character (indicator)',
    english: 'indicator (description)',
    swedish: 'operator (värdering, adjektiv, adverb)',
    norwegian: 'indikator (vurdering)',
    finnish: 'kuvailun merkki',
    hungarian: 'minősítő jel (melléknevet jelző nyelvtani indikátor)',
    german: 'Indikator (Beschreibung, Adjektive, Adverbien)',
    dutch: 'indicator beschrijving',
    afrikaans: 'aanwyser (beskrywing)',
    russian: 'индикатор (имя прилаг., описание)',
    latvian: 'indikators (aprakstoša forma)',
    polish: 'wyznacznik przymiotnika',
    french: 'indicateur de description',
    spanish: 'indicador (descripción)',
  },
  {
    av: 8999,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(future [quarter-sized]: placed above a symbol to indicate future action) - Character (indicator)',
    english: 'indicator (future action)',
    swedish: 'operator (handling framtid, futurum)',
    norwegian: 'indikator (presens futurum, handling framtid)',
    finnish: 'tulevan toiminnan merkki',
    hungarian: 'jövő idő jele (jövő idejű cselekvés indikátora)',
    german: 'Indikator (Handlung, Zukunft)',
    dutch: 'indicator toekomende tijd',
    afrikaans: 'aanwyser (toekomende tyd)',
    russian: 'индикатор (буд. вр. гл.)',
    latvian: 'indikators (nākotnes forma)',
    polish: 'wyznacznik czasu przyszłego',
    french: 'indicateur de verbe au futur',
    spanish: 'indicador (acción futura)',
  },
  {
    av: 9000,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(conditional indicator + future action indicator: placed above a symbol to indicate the future conditional form) - Character (superimposed - indicator)',
    english: 'indicator (future conditional)',
    swedish: 'operator (konditionalis framtid)',
    norwegian: 'indikator (presens futurum perfektum, i framtiden)',
    finnish: 'tulevan mahdollisen toiminnan merkki',
    hungarian: 'feltételes jövő idő jele',
    german: 'Indikator (Bedingungsform, Irrealis, Zukunft)',
    dutch: 'indicator voorwaardelijk toekomende tijd',
    afrikaans: 'aanwyser (toekomstige tyd kondisioneel, voorwaardelik, voorwaardelike wys)',
    russian: 'индикатор (услов.наклон.буд.вр.гл.)',
    latvian: 'indikators (nākotnes laiks)',
    polish: 'wyznacznik trybu przypuszczającego czasu przyszłego niedokonanego',
    french: 'indicateur conditionnel futur',
    spanish: 'indicador (futuro condicional)',
  },
  {
    av: 9001,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(passive indicator + future action indicator) - Character (superimposed - indicator)',
    english: 'indicator (future passive)',
    swedish: 'operator (passiv form framtid)',
    norwegian: 'indikator (passiv presens futurum, passiv form framtid)',
    finnish: 'passiivin ja tulevan toiminnan merkki',
    hungarian: '',
    german: 'Indikator (Passiv, Zukunft)',
    dutch: 'indicator passief toekomende tijd',
    afrikaans: 'aanwyser (toekomstige tyd passief)',
    russian: 'индикатор (страдат.залог буд.вр.гл.)',
    latvian: 'indikators (nākotnes pasīvais laiks) ',
    polish: 'wyznacznik strony biernej czasu przyszłego',
    french: 'indicateur futur passif',
    spanish: 'indicador (futuro pasivo)',
  },
  {
    av: 9002,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(passive indicator + future conditional indicator) - Character (superimposed - indicator)',
    english: 'indicator (future passive conditional)',
    swedish: 'operator (konditionalis passiv form i framtiden)',
    norwegian: 'indikator (passiv presens futurum perfektum, passiv form i framtiden)',
    finnish: 'passiivin ja tulevan mahdollisen toiminnan merkki',
    hungarian: '',
    german: 'Indikator (Bedingungsform, Irrealis, Passiv, Zukunft)',
    dutch: 'indicator (future passive conditional)',
    afrikaans: 'aanwyser (toekomstige tyd kondisioneel)',
    russian: 'индикатор (страдат., услов., буд.вр.гл.)',
    latvian: 'indikators (nākotnes laiks)',
    polish: 'wyznacznik strony biernej czasu przyszłego trybu przypuszczającego',
    french: 'indicateur conditionnel futur passif',
    spanish: 'indicador (futuro pasivo condicional)',
  },
  {
    av: 9003,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(action indicator [modification]: turned on its side and pointing backward: placed above a symbol to emphasize that something is being acted upon. The symbol is logically related to by.) - Character (indicator - modified)',
    english: 'indicator (passive)',
    swedish: 'operator (passiv form)',
    norwegian: 'indikator (passiv form)',
    finnish: 'passiivin merkki',
    hungarian: 't (tárgyrag; ige fölött a csúcs a tárgyra mutat)',
    german: 'Indikator (Passiv)',
    dutch: 'indicator passief tegenwoordige tijd',
    afrikaans: 'aanwyser (teenwoordige tyd passief)',
    russian: 'индикатор (страдат. залог гл.)',
    latvian: 'indikators (pasīvā forma)',
    polish: 'wyznacznik formy biernej',
    french: 'indicateur du verbe à la voix passive',
    spanish: 'indicador (pasivo)',
  },
  {
    av: 9004,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(past [quarter-sized]: placed above a symbol to indicate past action) - Character (indicator)',
    english: 'indicator (past action)',
    swedish: 'operator (handling i förfluten tid)',
    norwegian: 'indikator (preteritum, handling fortid)',
    finnish: 'menneen toiminnan merkki',
    hungarian: 'múlt idő jele (ige fölött múltbeli cselekvést jelent)',
    german: 'Indikator (Handlung, Vergangenheit)',
    dutch: 'indicator verleden tijd',
    afrikaans: 'aanwyser (verlede tyd aktief)',
    russian: 'индикатор (прош.вр.гл.)',
    latvian: 'indikators (pagatnes forma)',
    polish: 'wyznacznik czasu przeszłego',
    french: 'indicateur du verbe au passé',
    spanish: 'indicador (acción pasada)',
  },
  {
    av: 9005,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(conditional indicator + past action indicator: placed above a symbol to indicate the past conditional form) - Character (superimposed - indicator)',
    english: 'indicator (past conditional)',
    swedish: 'operator (konditionalis i förfluten tid)',
    norwegian: 'indikator (preteritum futurum perfektum, i fortiden)',
    finnish: 'menneen mahdollisen toiminnan merkki',
    hungarian: 'feltételes múlt idő jele (nyelvtani indikátor)',
    german: 'Indikator (Bedingungsform, Irrealis, Vergangenheit)',
    dutch: 'indicator voorwaardelijk verleden tijd',
    afrikaans: 'aanwyser (voorwaardelik verlede tyd)',
    russian: 'индикатор (услов.наклон.прош.вр.гл.)',
    latvian: 'indikators (pagatnes forma)',
    polish: 'wyznacznik czasu przeszłego niedokonanego',
    french: 'indicateur du conditionnel passé',
    spanish: 'indicador (condicional pasado)',
  },
  {
    av: 9006,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(passive indicator + past conditional indicator) - Character (superimposed - indicator)',
    english: 'indicator (past passive conditional)',
    swedish: 'operator (konditionalis passiv form i förfluten tid)',
    norwegian: 'indikator (passiv preteritum futurum perfektum, passiv form i fortiden)',
    finnish: 'passiivin ja menneen mahdollisen toiminnan merkki',
    hungarian: '',
    german: 'Indikator (Bedingungsform, Irrealis, Passiv, Vergangenheit)',
    dutch: 'indicator (past passive conditional)',
    afrikaans: 'aanwyser (verlede tyd passief voorwaardelik)',
    russian: 'индикатор (страдат., услов., прош.вр.гл.)',
    latvian: 'indikators (pagatnes forma)',
    polish: 'wyznacznik strony biernej czasu przeszłego trybu przypuszczającego',
    french: 'indicateur du conditionnel passé passif',
    spanish: 'indicador (pasado pasivo condicional)',
  },
  {
    av: 9007,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(passive indicator + past action indicator) - Character (superimposed - indicator)',
    english: 'indicator (past passive)',
    swedish: 'operator (passiv form i förfluten tid)',
    norwegian: 'indikator (passiv preteritum, passiv form fortid)',
    finnish: 'passiivin ja menneen toiminnan merkki',
    hungarian: '',
    german: 'Indikator (Passiv, Vergangenheit)',
    dutch: 'indicator passief verleden tijd',
    afrikaans: 'aanwyser (verlede tyd passief)',
    russian: 'индикатор (страдат.залог прош.вр.гл.)',
    latvian: 'indikators (pagatnes laiks)',
    polish: 'wyznacznik strony biernej czasu przeszłego',
    french: 'indicateur du passé passif',
    spanish: 'indicador (pasado pasivo)',
  },
  {
    av: 9008,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(passive indicator + conditional indicator) - Character (superimposed - indicator)',
    english: 'indicator (present passive conditional)',
    swedish: 'operator (konditionalis i passiv form)',
    norwegian: 'indikator (passiv preteritum futurum, passiv form i framtiden)',
    finnish: 'passiivin ja mahdollisen toiminnan merkki',
    hungarian: '',
    german: 'Indikator (Bedingungsform, Irrealis, Passiv, Gegenwart)',
    dutch: 'indicator (present passive conditional)',
    afrikaans: 'aanwyser (teenwoordige tyd passief)',
    russian: 'индикатор (страдат.залог услов.наклон.гл.)',
    latvian: 'indikators (tagatnes laiks)',
    polish: 'wyznacznik strony biernej przypuszczającej',
    french: 'indicateur du conditionnel présent passif',
    spanish: 'indicador (presente pasivo condicional)',
  },
  {
    av: 9009,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(thing [quarter-sized]: placed above a symbol to represent a concrete object) - Character (indicator)',
    english: 'indicator (thing)',
    swedish: 'operator (konkretisering)',
    norwegian: 'indikator (konkretisering)',
    finnish: 'esineen merkki',
    hungarian: 'konkrét tárgy jele',
    german: 'Indikator (Ding)',
    dutch: 'dingindicator',
    afrikaans: 'aanwyser (iets ding goed)',
    russian: 'индикатор (конкретная форма)',
    latvian: 'indikators (konkrētā forma)',
    polish: 'wyznacznik rzeczownika',
    french: "indicateur d'objet (signification concrète)",
    spanish: 'indicador (cosa)',
  },
  {
    av: 9010,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(thing indicator + plural indicator) - Character (superimposed - indicator)',
    english: 'indicator (things)',
    swedish: 'operator (konkretisering i plural)',
    norwegian: 'indikator (konkretisering i pluralis, flertall)',
    finnish: 'esineen ja monikon merkki',
    hungarian: 'konkrét tárgyak jele (tbsz.)',
    german: 'Indikator (Ding Plural)',
    dutch: 'dingindicator meervoud',
    afrikaans: 'aanwyser (dinge goedere voorwerpe meervoud)',
    russian: 'индикатор (конкретная форма, мн.ч.)',
    latvian: 'indikators (konrtētē forma, daudz)',
    polish: 'wyznacznik rzeczownika w liczbie mnogiej',
    french: "indicateur d'objet pluriel",
    spanish: 'indicador (cosas)',
  },
  {
    av: 9011,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(multiplication [quarter-sized]: placed above a symbol to indicate a plural form) - Character (indicator)',
    english: 'indicator (plural)',
    swedish: 'operator (flertal, plural)',
    norwegian: 'indikator (plural, flertall)',
    finnish: 'monikon merkki',
    hungarian: 'többes szám jele',
    german: 'Indikator (Plural)',
    dutch: 'indicator meervoud',
    afrikaans: 'aanwyser (meervoud)',
    russian: 'индикатор (мн.ч.)',
    latvian: 'indikators (daudz)',
    polish: 'wyznacznik liczby mnogiej',
    french: 'indicateur du pluriel',
    spanish: 'indicador (plural)',
  },
  {
    av: 24665,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(indicator (description) + indicator (action): may be placed above a symbol to show that it is representing an adverb in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (superimposed - indicator)',
    english: 'indicator (adverb)',
    swedish: 'operator (adverb)',
    norwegian: 'indikator (adverb)',
    finnish: 'adverbin merkki',
    hungarian: 'indikátor – határozószó',
    german: 'indikator (Adverb)',
    dutch: 'indicator (bijwoord)',
    afrikaans: 'aanwyser (bywoord)',
    russian: 'индикатор (наречие)',
    latvian: 'indikators (apst.v.)',
    polish: 'wyznacznik przysłówka',
    french: 'indicateur (adverbe)',
    spanish: 'indicador (adverbio)',
  },
  {
    av: 24666,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(horizontal line [quarter-sized]: may be placed above a symbol to show that it is representing a verb in continuous form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (indicator) NOTE: This indicator character has been removed – BCI Board decision 2017-06-19',
    english: 'indicator (continuous form)',
    swedish: 'operator (pågående form)',
    norwegian: 'indikator (pågående form)',
    finnish: 'jatkuvan toiminnan merkki',
    hungarian: 'indikátor – folyamatos igeidő jelzése',
    german: 'Indikator (Partizip, Gegenwart, Aktiv)',
    dutch: 'indicator (continous)',
    afrikaans: 'aanwyser (deurlopende vorm)',
    russian: 'идикатор (длительная ф. гл.в англ.яз.)',
    latvian: 'indikators (ilgstošā forma)',
    polish: 'wyznacznik formy ciągłej, nieprzerwanej',
    french: 'indicateur de verbe à la forme continue',
    spanish: 'indicador (forma continua)',
  },
  {
    av: 24667,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(the [quarter-sized]: may be placed above a symbol to show that it is representing a noun or other word in definite form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (indicator)',
    english: 'indicator (definite form)',
    swedish: 'operator (bestämd form)',
    norwegian: 'indikator (bestemt form)',
    finnish: 'määrätyn muodon merkki',
    hungarian: 'indikátor – határozott névelős szerkezet',
    german: 'indikator (bestimmte Form)',
    dutch: 'indicator (bepaalde vorm)',
    afrikaans: 'aanwyser (definitiewe vorm)',
    russian: 'индикатор (определенная форма)',
    latvian: 'indikators (noteiktā forma)',
    polish: 'wyznacznik formy określonej',
    french: 'indicateur du nom défini',
    spanish: 'indicador (forma definida)',
  },
  {
    av: 24668,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(female (gender) [quarter-sized]: may be placed above a symbol to show that it is representing a word in feminine form in a natural language (male = unmarked).) Used restrictively, primarily for language teaching purposes. - Character (indicator) NOTE: This indicator character has been removed (to be replaced by a spacing non-indicator marker character - pending) – BCI Board decision 2017-06-19',
    english: 'indicator (female)',
    swedish: 'operator (femininum)',
    norwegian: 'indikator (hunkjønn)',
    finnish: 'femiini-muodon merkki',
    hungarian: ' indikátor –nőnem',
    german: 'indikator (Femininum)',
    dutch: 'indicator (vrouwelijk)',
    afrikaans: 'aanwyser (vroulik)',
    russian: 'индикаор (женский род)',
    latvian: 'indikators (siev.dz.)',
    polish: 'wyznacznik rodzaju żeńskiego',
    french: 'indicateur du féminin',
    spanish: 'indicador (femenino)',
  },
  {
    av: 24669,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(one (digit) [quarter-sized]: may be placed above a symbol to show that it is representing a verb or other word in first person form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (indicator) NOTE: This indicator character has been removed (to be replaced by a spacing non-indicator marker character - pending) – BCI Board decision 2017-06-19',
    english: 'indicator (first person)',
    swedish: 'operator (första person)',
    norwegian: 'indikator (1.person)',
    finnish: 'ensimmäisen persoonan merkki',
    hungarian: 'indikátor – egyes szám első személy',
    german: 'indikator (erste Person)',
    dutch: 'indicator (eerste persoon)',
    afrikaans: 'aanwyser (eerste persoon)',
    russian: 'индикатор (первое лицо)',
    latvian: 'indikators (pirmā persona)',
    polish: 'wyznacznik pierwszej osoby',
    french: 'indicateur de 1re personne',
    spanish: 'indicador (primera persona)',
  },
  {
    av: 24670,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(exclamation mark [quarter-sized]: may be placed above a symbol to show that it is representing a verb in imperative form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (indicator)',
    english: 'indicator (imperative form)',
    swedish: 'operator (imperativ)',
    norwegian: 'indikator (imperativ)',
    finnish: 'käskymuodon merkki',
    hungarian: 'indikátor – felszólító, parancsoló mód',
    german: 'indikator (Imperativ)',
    dutch: 'indicator (gebiedende wijs)',
    afrikaans: 'aanwyser (imperatiewe vorm)',
    russian: 'индикатор (повелит.наклон.)',
    latvian: 'indikators (pavēles forma)',
    polish: 'wyznacznik trybu rozkazującego',
    french: "indicateur de verbe à l'impératif",
    spanish: 'indicador (forma imperativa)',
  },
  {
    av: 24671,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(a, an, any [quarter-sized]: may be placed above a symbol to show that it is representing a noun or other word in indefinite form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (indicator) NOTE: This indicator character has been removed – BCI Board decision 2017-06-19',
    english: 'indicator (indefinite form)',
    swedish: 'operator (obestämd form)',
    norwegian: 'indikator (ubestemt form en, ei, et)',
    finnish: 'epämääräisen muodon merkki',
    hungarian: 'indikátor – határozatlan névelős szerkezet',
    german: 'indikator (unbestimmte Form)',
    dutch: 'indicator (onbepaalde vorm)',
    afrikaans: 'aanwyser (onbepaalde vorm)',
    russian: 'индикатор (неопределённая форма)',
    latvian: 'indikators (nenoteiksme)',
    polish: 'wyznacznik formy nieokreślonej',
    french: 'indicateur du nom indéfini',
    spanish: 'indicador (forma indefinida)',
  },
  {
    av: 24672,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(vertical line [quarter-sized]: may be placed above a symbol to show that it is representing a word in neutral form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (indicator) NOTE: This indicator character has been removed (to be replaced by a spacing non-indicator marker character – pending) – BCI Board decision 2017-06-19',
    english: 'indicator (neutral form)',
    swedish: 'operator (neutrum)',
    norwegian: 'indikator (nøytral form)',
    finnish: 'neutraalimuodon merkki',
    hungarian: 'indikátor – semleges forma',
    german: 'indikator (Neutrum)',
    dutch: 'indicator (neutrale vorm)',
    afrikaans: 'aanwyser (neutrale vorm)',
    russian: 'индикаор (нейральная форма)',
    latvian: 'indikators (neitrāla forma)',
    polish: 'wyznacznik rodzaju nieokreślonego (ono, tamto)',
    french: 'indicateur du nom neutre',
    spanish: 'indicador (forma neutra)',
  },
  {
    av: 24673,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(to, toward, towards [quarter-sized]: may be placed above a symbol to show that it is representing a word in object form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (indicator) NOTE: This indicator character has been removed (to be replaced by a spacing non-indicator marker character – pending) – BCI Board decision 2017-06-19',
    english: 'indicator (object form)',
    swedish: 'operator (objektform)',
    norwegian: 'indikator (objektform)',
    finnish: 'objektimuodon merkki',
    hungarian: 'indikátor – tárgyas szerkezet',
    german: 'indikator (Objektsform)',
    dutch: 'indicator (object, lijdendvoorwerp)',
    afrikaans: 'aanwyser (vorm voorwerp)',
    russian: 'индикатор (обьективная форма)',
    latvian: 'indikators (papildinātāja)',
    polish: 'wyznacznik dopełniacza',
    french: 'indicateur de but',
    spanish: 'indicador (forma de objeto)',
  },
  {
    av: 24674,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(indicator (past action) + indicator (description): may be placed above a symbol to show that it is representing a verb in past participle form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (superimposed - indicator)',
    english: 'indicator (past participle 1)',
    swedish: 'operator (perfektparticip 1)',
    norwegian: 'indikator (perfektum som attributt, beskrivelse)',
    finnish: 'menneen partisiippi 1:n merkki',
    hungarian: 'indikátor – múlt idő',
    german: 'Indikator (Partizip II, Partizip Perfekt) (1)',
    dutch: 'indicator (voltooid deelw 1)',
    afrikaans: 'aanwyser (voltooid deelw 1)',
    russian: 'оператор (причастие прош. вр.1)',
    latvian: 'indikators (pagātnes divdabis 1)',
    polish: 'wyznacznik imiesłowu przymiotnikowego przeszłego czynnego',
    french: 'indicateur du participe passé 1',
    spanish: 'indicador (participio pasado 1)',
  },
  {
    av: 24675,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(indicator (past action) + dot: may be placed above a symbol to show that it is representing a verb in past participle form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (superimposed - indicator)',
    english: 'indicator (past participle 2)',
    swedish: 'operator (perfektparticip 2)',
    norwegian: 'indikator (presens perfektum)',
    finnish: 'menneen partisiippi 2:n merkki',
    hungarian: 'indikátor – befejezett múlt',
    german: 'Indikator (Partizip II, Partizip Perfekt) (2)',
    dutch: 'indicator (voltooid deelw 2)',
    afrikaans: 'aanwyser (voltooid deelw 2)',
    russian: 'оператор (причастие прош. вр. 2)',
    latvian: 'indikators (pagātnes divdabis 2)',
    polish: 'wyznacznik imiesłowu przymiotnikowego przeszłego',
    french: 'indicateur du participe passé 2',
    spanish: 'indicador (participio pasado 2)',
  },
  {
    av: 24676,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(plus [quarter-sized]: may be placed above a symbol to show that it is representing a word in possessive form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (indicator) NOTE: This indicator character has been removed (since long covered by belongs to, of (possessive) 12663) – BCI Board decision 2017-06-19',
    english: 'indicator (possessive form)',
    swedish: 'operator (possessiv form)',
    norwegian: 'indikator (genitiv, eieform)',
    finnish: 'omistusmuodon merkki',
    hungarian: 'indikátor – birtokviszony jelzése',
    german: 'Indikator (Genitiv, Possessiv)',
    dutch: 'indicator (bezittelijke vorm)',
    afrikaans: 'aanwyser (besitlike vorm)',
    russian: 'индикатор (пасивная форма)',
    latvian: 'indikators (piederības)',
    polish: 'wyznacznik dopełniacza (formy dzierżawczej)',
    french: 'indicateur (forme possesive)',
    spanish: 'indicador (forma posesiva)',
  },
  {
    av: 24677,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(indicator (present action) + indicator (description): may be placed above a symbol to show that it is representing a verb in present participle form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (superimposed - indicator)',
    english: 'indicator (present participle)',
    swedish: 'operator (presensparticip)',
    norwegian: 'indikator (presens som attributt, beskrivelse)',
    finnish: 'parhaillaan tapahtuvan partisiipin merkki',
    hungarian: 'indikátor – közelmúlt',
    german: 'Indikator (Partizip, Gegenwart)',
    dutch: 'indicator (tegenwoordig deelwoord)',
    afrikaans: 'aanwyser (teenwoordige deelwoord)',
    russian: 'индикатор (причастие наст. вр.)',
    latvian: 'indikators (tagadnes divdabis)',
    polish: 'wyznacznik czasu teraźniejszego biernego',
    french: 'indicateur de verbe au participe présent',
    spanish: 'indicador (participio presente)',
  },
  {
    av: 24678,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(two (digit) [quarter-sized]: may be placed above a symbol to show that it is representing a verb or other word in second person form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (indicator) NOTE: This indicator character has been removed (to be replaced by a spacing non-indicator marker character – pending) – BCI Board decision 2017-06-19',
    english: 'indicator (second person)',
    swedish: 'operator (andra person)',
    norwegian: 'indikator (2.person)',
    finnish: 'toisen persoonan merkki',
    hungarian: 'indikátor – egyes szám második személy',
    german: 'indikator (zweite Person)',
    dutch: 'indicator (tweede persoon)',
    afrikaans: 'aanwyser (tweede persoon)',
    russian: 'индикатор (второе лицо)',
    latvian: 'indikators (otrā persona)',
    polish: 'wyznacznik drugiej osoby',
    french: 'indicateur de 2e personne',
    spanish: 'indicador (segunda persona)',
  },
  {
    av: 24679,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(three (digit) [quarter-sized]: may be placed above a symbol to show that it is representing a verb or other word in third person form in a natural language.) Used restrictively, primarily for language teaching purposes. - Character (indicator) NOTE: This indicator character has been removed (to be replaced by a spacing non-indicator marker character – pending) – BCI Board decision 2017-06-19',
    english: 'indicator (third person)',
    swedish: 'operator (tredje person)',
    norwegian: 'indikator (3.person)',
    finnish: 'kolmannen persoonan merkki',
    hungarian: 'indikátor – egyes szám harmadik személy',
    german: 'Indikator (3. Person)',
    dutch: 'indicator (derde persoon)',
    afrikaans: 'aanwyser (derde persoon)',
    russian: 'индикатор (третье лицо)',
    latvian: 'indikators (trešā persona)',
    polish: 'wyznacznik trzeciej osoby',
    french: 'indicateur de 3e personne',
    spanish: 'indicador (tercera persona)',
  },
  {
    av: 24807,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(indicator (past action) + indicator (future action): may be placed above a symbol to show that it is representing a verb in present action form in a natural language) Used restrictively, primarily for language teaching purposes. - Character (superimposed - indicator)',
    english: 'indicator (present action)',
    swedish: 'operator (presens)',
    norwegian: 'indikator (presens)',
    finnish: 'parhaillaan tapahtuvan toiminnan merkki',
    hungarian: 'indikátor – jelen idejű cselekvés',
    german: 'Indikator (Handlung, Gegenwart)',
    dutch: 'indicator (tegenwoordige tijd)',
    afrikaans: 'aanwyser (teenwoordige tyd) nou',
    russian: 'индикатор (гл.наст.вр.)',
    latvian: 'indikators (tagadnes darbība)',
    polish: 'wyznacznik czasu teraźniejszego',
    french: 'indicateur de verbe au présent',
    spanish: 'indicador (acción presente)',
  },
  {
    av: 25458,
    group: 'diacritics',
    pos: 'GRAY',
    derivationExplanation:
      '(little [quarter-sized]: may be placed above a symbol to show that it is representing a word in diminutive form in a natural language) Used restrictively, primarily for language teaching purposes. - Character (indicator) NOTE: This indicator character has been removed (to be replaced by a spacing non-indicator marker character – pending) – BCI Board decision 2017-06-19',
    english: 'indicator (diminutive form)',
    swedish: 'operator (diminutiv)',
    norwegian: 'indikator (forminskende form)',
    finnish: 'deminutiivin merkki, diminutiivin merkki, pienennysmuodon merkki',
    hungarian: '',
    german: 'Indikator (diminutive Form)',
    dutch: 'indicator (verkleinwoord)',
    afrikaans: 'aanwyser (verkleinvorm)',
    russian: 'индикаор (уменьш.-ласк.)',
    latvian: 'indikators (pamazināmā forma)',
    polish: '',
    french: '',
    spanish: 'indicador (forma diminutiva)',
  },
  {
    av: 12323,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to cause + miscarriage, abortion (spontaneous))',
    english: 'abortion (induced)',
    swedish: 'abort',
    norwegian: 'abort',
    finnish: 'abortti, raskauden keskeytys',
    hungarian: 'vetélés, abortusz (művi)',
    german: 'Abtreibung',
    dutch: 'abortus, zwangerschapsonderbreking',
    afrikaans: 'aborsie (geïnduseerde)',
    russian: 'аборт',
    latvian: 'aborts (medicīniski izsaukts)',
    polish: 'aborcja (wywołana)',
    french: 'avortement, interruption de grossesse',
    spanish: 'aborto (inducido)',
  },
  {
    av: 12325,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + into)',
    english: 'absorbent material, sponge',
    swedish: 'absorberande material, tvättsvamp',
    norwegian: 'absorberende materiale, svamp',
    finnish: 'imukykyinen aine, pesusieni',
    hungarian: 'szivacs, nedvszívó anyag',
    german: 'Absorptionsmaterial',
    dutch: 'spons, absorberend materiaal',
    afrikaans: 'absorberende materiaal, spons',
    russian: 'губка, спонж',
    latvian: 'uzsūcošs, absorbējošs materiāls, sūklis',
    polish: 'gąbka, coś chłonnego',
    french: 'éponge, matière absorbante',
    spanish: 'material absorbente, esponja',
  },
  {
    av: 12326,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to decide + without + sexual intercourse)',
    english: 'celibacy, chastity, abstinence',
    swedish: 'avhållsamhet (sexuell)',
    norwegian: 'seksuell avholdenhet, sølibat',
    finnish: 'seksuaalinen pidättäytyminen, sukupuolinen pidättäytyminen',
    hungarian: 'önmegtartóztatás, szűziesség, absztinencia',
    german: 'Abstinenz, Enthaltsamkeit',
    dutch: 'seksuele onthouding',
    afrikaans: 'selibaatheid, kuisheid, onthouding',
    russian: 'воздержание, целибат',
    latvian: 'celibāts, šķīstība, atturēšanās',
    polish: 'celibat, czystość, wstrzemięźliwość',
    french: 'célibat, chasteté, abstinence',
    spanish: 'celibato, castidad, abstinencia',
  },
  {
    av: 12327,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(force + intensity)',
    english: 'abuse, assault, violence',
    swedish: 'misshandel, våld',
    norwegian: 'mishandling, overfall, vold',
    finnish: 'väärinkäyttö, väkivalta',
    hungarian: 'bántalmazás, támadás, erőszak',
    german: 'Misshandlung, Angriff, Gewalt',
    dutch: 'mishandeling',
    afrikaans: 'mishandeling, aanranding, geweld',
    russian: 'насилие',
    latvian: 'ļaunprātīga izmantošana, vardarbība',
    polish: 'nadużycie, napaść, przemoc',
    french: 'abus, violence',
    spanish: 'abuso, agresión, violencia',
  },
  {
    av: 12328,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(thing + plus + clothing: something added to one's clothing)",
    english: 'accessory',
    swedish: 'accessoarer',
    norwegian: 'tilbehør',
    finnish: 'somiste, lisävaruste',
    hungarian: 'kiegészítő (öltözékhez)',
    german: 'Accessoire, Zubehör',
    dutch: 'accessoire',
    afrikaans: 'bykomstigheid, versiering',
    russian: 'аксессуары',
    latvian: 'piederums, aksesuārs',
    polish: 'dodatek do ubrania (pasek, apaszka, ozdoba itp.)',
    french: 'accessoire',
    spanish: 'accesorio',
  },
  {
    av: 12329,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + without + to expect: unexpected event)',
    english: 'accident, chance event',
    swedish: 'slump, tillfällighet',
    norwegian: 'tilfeldighet',
    finnish: 'sattuma',
    hungarian: 'baleset, véletlenszerű esemény',
    german: 'Unfall, Missgeschick, Zufall',
    dutch: 'toeval',
    afrikaans: 'ongeluk, kans gebeurtenis',
    russian: 'случай, случайность',
    latvian: 'atgadījums, nejaušība',
    polish: 'wypadek, zdarzenie losowe',
    french: 'accident, événement imprévisible',
    spanish: 'accidente, posibilidad, acontecimiento',
  },
  {
    av: 12331,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pain + to continue: pain that goes on and on)',
    english: 'ache',
    swedish: 'värk',
    norwegian: 'verk',
    finnish: 'särky',
    hungarian: 'fájdalom (tartós)',
    german: 'Schmerz',
    dutch: 'chronische pijn',
    afrikaans: 'pyn aanhoudend, kronies',
    russian: 'боль ',
    latvian: 'sāpes',
    polish: 'coś, cokolwiek',
    french: 'douleur',
    spanish: 'dolor',
  },
  {
    av: 12332,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + pimple)',
    english: 'acne',
    swedish: 'acne, finnar, utslag',
    norwegian: 'akne, kvise',
    finnish: 'akne',
    hungarian: 'pattanás, akné (serdülőkori)',
    german: 'Akne, Pickel',
    dutch: 'acne, jeugdpuistjes',
    afrikaans: 'aknee, puisie',
    russian: 'прыщи, угри',
    latvian: 'pūtīte, pinnes',
    polish: 'trądzik',
    french: 'acné',
    spanish: 'acné',
  },
  {
    av: 12336,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(activity + description indicator)',
    english: 'active, actively',
    swedish: 'aktiv, verksam',
    norwegian: 'aktiv',
    finnish: 'aktiivinen',
    hungarian: 'tevékeny, aktív',
    german: 'aktiv, tätig, energisch',
    dutch: 'actief',
    afrikaans: 'aktief, aktiewe',
    russian: 'активный',
    latvian: 'darbīgs, darbīgi (īpašības v.)',
    polish: 'aktywny',
    french: 'actif',
    spanish: 'activo, activa',
  },
  {
    av: 12337,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + megillah: month of Purim (Hebrew))',
    english: 'Adar',
    swedish: 'Adar (Israel)',
    norwegian: 'Adar (Israel)',
    finnish: 'Adar, adár',
    hungarian: 'Adar ',
    german: 'Adar',
    dutch: 'Adar',
    afrikaans: 'Adar',
    russian: 'Адар (Израиль)',
    latvian: 'Adars (ebreju kalendāra 12.mēnesis)',
    polish: 'Adar (hebrajski miesiąc)',
    french: 'Adar (12e mois du calendrier juif)',
    spanish: 'Adar',
  },
  {
    av: 12338,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(addition + action indicator)',
    english: 'add, gain-(to)',
    swedish: 'lägga till, sätta till, addera',
    norwegian: 'addere, legge til',
    finnish: 'laskea yhteen, lisätä',
    hungarian: 'összeadni, hozzáadni',
    german: 'addieren, hinzufügen',
    dutch: 'optellen, toevoegen',
    afrikaans: 'plus, optel, toevoeg, byvoeg, voeg, wins (om te)',
    russian: 'прибавлять, складывать',
    latvian: 'saskaitīt, pieskaitīt, pievienot',
    polish: 'dodać, zyskać, zwiększyć ilość',
    french: 'ajouter',
    spanish: 'agregar, ganar',
  },
  {
    av: 12340,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limited time + adolescent)',
    english: 'adolescence',
    swedish: 'tonåren',
    norwegian: 'ungdomstid',
    finnish: 'nuoruus, teini-ikä',
    hungarian: 'serdülőkor, kamaszkor',
    german: 'Adoleszenz, Jugendalter, Jugend',
    dutch: 'puberteit',
    afrikaans: 'puberteit, adolessensie',
    russian: 'отрочество, юность',
    latvian: 'pusaudzība, pusaudža gadi',
    polish: 'dorastanie, wiek dojrzewania',
    french: 'adolescence',
    spanish: 'adolescencia',
  },
  {
    av: 12342,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(adult + description indicator)',
    english: 'adult, mature',
    swedish: 'vuxen, mogen',
    norwegian: 'voksen, moden (person)',
    finnish: 'täysikasvuinen, kypsä',
    hungarian: 'felnőtt (mn.), érett',
    german: 'erwachsen, reif',
    dutch: 'volwassen',
    afrikaans: 'volwassene, grootmens',
    russian: 'взрослый',
    latvian: 'pieaudzis, nobriedis',
    polish: 'dorosły, dojrzały',
    french: 'adulte, mature, mûr',
    spanish: 'adulto, maduro',
  },
  {
    av: 12343,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(forward + action indicator) See also: go, depart, leave-(to) 14449, and walk, go-(to) 18031',
    english: 'advance, go-(to)',
    swedish: 'gå, gå framåt',
    norwegian: 'gå framover, avansere, gjøre framskritt',
    finnish: 'edetä',
    hungarian: 'haladni',
    german: 'vorwärts bewegen',
    dutch: 'vooruitgaan, gaan',
    afrikaans: 'vooruitgaan, gaan (om te)',
    russian: 'продвигаться вперед',
    latvian: 'virzīties, doties tālāk',
    polish: 'posuwać się naprzód, przemieszczać się do przodu',
    french: 'aller, avancer',
    spanish: 'avanzar, ir',
  },
  {
    av: 12344,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(page + attention: paper that attracts one's attention)",
    english: 'advertisement',
    swedish: 'annons, reklamblad',
    norwegian: 'annonse, avertering',
    finnish: 'mainos, ilmoitus',
    hungarian: 'hirdetés, reklám',
    german: 'Inserat, Anzeige, Werbung, Annonce, Zeitungsinserat, Zeitungsanzeige, Zeitungsannonce',
    dutch: 'advertentie',
    afrikaans: 'advertensie',
    russian: 'реклама',
    latvian: 'sludinājums, reklāma',
    polish: 'reklama',
    french: 'annonce publicitaire, affiche',
    spanish: 'anuncio',
  },
  {
    av: 12345,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(suggestion + to help)',
    english: 'advice, counsel, recommendation',
    swedish: 'råd',
    norwegian: 'råd, anbefaling',
    finnish: 'neuvo',
    hungarian: 'tanács',
    german: 'Rat, Ratschlag, Empfehlung',
    dutch: 'advies, raad',
    afrikaans: 'advies, raad, voorstel, aanbeveling',
    russian: 'совет, рекомендация',
    latvian: 'padoms, ieteikums, rekomendācija',
    polish: 'porada, doradztwo, rada, zalecenie',
    french: 'conseil',
    spanish: 'consejo, asesoramiento, recomendación',
  },
  {
    av: 12346,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(advice + action indicator)',
    english: 'advise, counsel, recommend-(to)',
    swedish: 'råda',
    norwegian: 'råde, anbefale',
    finnish: 'neuvoa',
    hungarian: 'tanácsolni',
    german: 'beraten, empfehlen, anraten',
    dutch: 'adviseren, raad geven',
    afrikaans: 'adviseer, advies, raad, voorstel, stel voor (om te)',
    russian: 'советовать, рекомендовать',
    latvian: 'dot padomu, ieteikt, rekomendēt',
    polish: 'radzić, zalecać, doradzać',
    french: 'conseiller (verbe)',
    spanish: 'aconsejar, asesorar, recomendar',
  },
  {
    av: 12347,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(fear, fright, concern + description indicator: sad about the future because of its uncertainties)',
    english: 'afraid, frightened, scared',
    swedish: 'rädd',
    norwegian: 'redd',
    finnish: 'peloissaan oleva, pelokas',
    hungarian: 'ijedt, rémült',
    german: 'erschrocken, verängstigt, ängstlich',
    dutch: 'bang, geschrokken',
    afrikaans: 'bang, benoud, skok',
    russian: 'испуганный',
    latvian: 'nobijies, izbijies',
    polish: 'przerażony, przestraszony',
    french: 'effrayé',
    spanish: 'temeroso, asustado, aterrado',
  },
  {
    av: 12349,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + after + 12: the part of the day after noon)',
    english: 'afternoon',
    swedish: 'eftermiddag',
    norwegian: 'ettermiddag',
    finnish: 'iltapäivä',
    hungarian: 'délután',
    german: 'Nachmittag',
    dutch: 'middag, namiddag',
    afrikaans: 'middag, namiddag',
    russian: 'после обеда',
    latvian: 'pēcpusdiena',
    polish: 'popołudnie',
    french: 'après-midi',
    spanish: 'tarde',
  },
  {
    av: 12353,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(agreement + action indicator)',
    english: 'agree-(to)',
    swedish: 'hålla med, komma överens',
    norwegian: 'enes, være enig i',
    finnish: 'olla yhtä mieltä',
    hungarian: 'egyetérteni',
    german: 'übereinstimmen, einwilligen, zustimmen',
    dutch: 'akkoord gaan, het eens zijn',
    afrikaans: 'saamstem (om te)',
    russian: 'соглашаться',
    latvian: 'piekrist',
    polish: 'zgadzać się, aprobować',
    french: "être d'accord, mettre d'accord-(se)",
    spanish: 'acordar, estar de acuerdo',
  },
  {
    av: 12355,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(help + thing indicator: concrete thing that aids or supports a person. The symbol is the concrete form of help.) - (character with thing indicator)',
    english: 'aid, device, support',
    swedish: 'hjälpmedel',
    norwegian: 'hjelpemiddel',
    finnish: 'apuväline',
    hungarian: 'segédeszköz, támasz',
    german: 'Hilfsmittel, Förderung, Unterstützung',
    dutch: 'steun, ondersteuning, hulp',
    afrikaans: 'hulp, toestel, ondersteuning, bystaan, hulp (met)',
    russian: 'вспомогательное средство',
    latvian: 'palīglīdzeklis',
    polish: 'pomoc, wsparcie',
    french: 'aide technique, support matériel',
    spanish: 'ayuda, dispositivo, ayuda',
  },
  {
    av: 12358,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + airplane)',
    english: 'airport',
    swedish: 'flygplats',
    norwegian: 'flyplass',
    finnish: 'lentoasema',
    hungarian: 'repülőtér',
    german: 'Flughafen',
    dutch: 'vliegveld, luchthaven',
    afrikaans: 'lughawe',
    russian: 'аэропорт',
    latvian: 'lidosta',
    polish: 'lotnisko, hangar',
    french: 'aéroport',
    spanish: 'aeropuerto',
  },
  {
    av: 12361,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(all + to take away: all taken away)',
    english: 'all gone',
    swedish: 'borta, slut, väck',
    norwegian: 'borte, vekk',
    finnish: 'kaikki on lopussa',
    hungarian: 'elfogyott, nincs több',
    german: 'fort, vorbei, alles weg',
    dutch: 'niets, niks',
    afrikaans: 'niks, geen, weg',
    russian: 'ничего',
    latvian: 'viss zudis',
    polish: 'wszystko stracone, nic nie zostało',
    french: 'plus rien',
    spanish: 'todo se fue, todos se fueron, todo desapareció',
  },
  {
    av: 12362,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal (water) + snake + teeth: combination of water animal and reptile + teeth)',
    english: 'alligator, crocodile',
    swedish: 'krokodil (etc)',
    norwegian: 'alligator, krokodille',
    finnish: 'alligaattori, krokotiili',
    hungarian: 'krokodil, alligátor',
    german: 'Alligator, Krokodil',
    dutch: 'krokodil',
    afrikaans: 'krokodil',
    russian: 'крокодил',
    latvian: 'aligators, krokodils',
    polish: 'aligator, krokodyl',
    french: 'alligator',
    spanish: 'caimán, cocodrilo',
  },
  {
    av: 12363,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to be + 1 + description indicator: to be only one)',
    english: 'alone, just, only, solitary',
    swedish: 'bara, endast',
    norwegian: 'bare, kun',
    finnish: 'yksin, ainoa, vain',
    hungarian: 'egyedüli, kizárólagos, pusztán, csupán csak…',
    german: 'allein, nur, einsam',
    dutch: 'alleen',
    afrikaans: 'alleen, net, eensaam',
    russian: 'только, лишь',
    latvian: 'viens, tikai, vienīgais, vienīgs',
    polish: 'sam, samotny, pojedynczy ',
    french: 'seul, solitaire',
    spanish: 'solo, solitario, único',
  },
  {
    av: 12364,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(and + and: in addition to)',
    english: 'along with',
    swedish: 'dessutom',
    norwegian: 'sammen med, i tillegg',
    finnish: 'lisäksi, yhdessä jonkun kanssa',
    hungarian: 'együtt valakivel, valamivel; (valami) mentén',
    german: 'zusammen mit, zusätzlich',
    dutch: 'met, samen met',
    afrikaans: 'saam met, met',
    russian: 'кроме того, а также',
    latvian: 'līdztekus, kopā ar',
    polish: 'wraz z',
    french: 'avec',
    spanish: 'junto con, en compañía de',
  },
  {
    av: 12365,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(design + floor: decoration used on special occasions) (India)',
    english: 'alpana, rangoli (decoration)',
    swedish: 'alpana (Indien)',
    norwegian: 'alpana (India)',
    finnish: 'alpana',
    hungarian: 'alpana (indiai padlódíszítés)',
    german: 'Alpana, Rangoli, Kolam (Dekoration in Indien)',
    dutch: 'alpana (Indisch)',
    afrikaans: 'alpana, rangoli (versiering)',
    russian: 'ранголи (Индия)',
    latvian: 'alpana (indiešu rotājums)',
    polish: 'rangoli, kolam (indyjska ozdoba z kolorowego piasku)',
    french: 'alpana',
    spanish: 'alpana, rangoli (decoración)',
  },
  {
    av: 12368,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(time + all + description indicator: all the time)',
    english: 'always, ever, forever',
    swedish: 'alltid',
    norwegian: 'alltid',
    finnish: 'aina',
    hungarian: 'mindig, örökre',
    german: 'immer, stets, ständig, beständig',
    dutch: 'altijd, ooit',
    afrikaans: 'altyd, ewig (vir)',
    russian: 'всегда',
    latvian: 'vienmēr, uz visiem laikiem',
    polish: 'wieczny, na zawsze, w każdym czasie',
    french: 'toujours',
    spanish: 'siempre, por siempre',
  },
  {
    av: 12369,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(car + medical)',
    english: 'ambulance',
    swedish: 'ambulans',
    norwegian: 'sykebil, ambulanse',
    finnish: 'ambulanssi, sairasauto',
    hungarian: 'mentőautó',
    german: 'Rettungswagen, Krankenwagen',
    dutch: 'ambulance, ziekenwagen',
    afrikaans: 'ambulans',
    russian: 'скорая помощь',
    latvian: 'ātrās palīdzības mašīna',
    polish: 'karetka pogotowia',
    french: 'ambulance',
    spanish: 'ambulancia',
  },
  {
    av: 12370,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + menstruation)',
    english: 'amenorrhea',
    swedish: 'mensbortfall',
    norwegian: 'amenoré, menstruasjon manglende',
    finnish: 'kuukautisten puuttuminen',
    hungarian: 'vérzéshiány, menzeszhiány, amenorrea',
    german: 'Amenorrhö, Ausbleiben der Regelblutung ',
    dutch: 'amenorroe',
    afrikaans: 'amenorrhea',
    russian: 'аменорея',
    latvian: 'amenoreja',
    polish: 'brak miesiączki',
    french: 'aménorrhée',
    spanish: 'amenorrea',
  },
  {
    av: 12371,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + water + earth: animal adapted to life in water and on land)',
    english: 'amphibian',
    swedish: 'amfibie',
    norwegian: 'amfibie',
    finnish: 'sammakkoeläin',
    hungarian: 'kétéltű (állat)',
    german: 'Amphibie',
    dutch: 'amfibie',
    afrikaans: 'amfibie, amfibies',
    russian: 'амфибия',
    latvian: 'amfībija',
    polish: 'płaz, zwierzę wodno-lądowe',
    french: 'amphibien',
    spanish: 'anfibio',
  },
  {
    av: 12372,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to give + happiness + action indicator: to give happiness or pleasure)',
    english: 'amuse, entertain, please-(to)',
    swedish: 'roa, underhålla',
    norwegian: 'more, underholde',
    finnish: 'huvittaa',
    hungarian: 'szórakoztatni, mulattatni, örömet okozni',
    german: 'erfreuen, amüsieren, sich amüsieren',
    dutch: 'vermaken, amuseren (zich)',
    afrikaans: 'vermaak, amuseer (om te)',
    russian: 'забавлять, развлекать',
    latvian: 'izklaidēt',
    polish: 'bawić, cieszyć się, radować',
    french: 'amuser, distraire',
    spanish: 'divertir, entretener, agradar',
  },
  {
    av: 12373,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to combine + erect penis + anus [contraction])',
    english: 'anal intercourse',
    swedish: 'analsex, analt samlag',
    norwegian: 'analsex, analt samleie',
    finnish: 'anaaliseksi',
    hungarian: 'anális közösülés',
    german: 'Analverkehr',
    dutch: 'anale seks',
    afrikaans: 'anale seks',
    russian: 'анальный секс',
    latvian: 'anālais dzimumakts',
    polish: 'stosunek analny, odbytniczy',
    french: 'relation sexuelle anale',
    spanish: 'sexo anal',
  },
  {
    av: 12377,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(much + feeling + opposition + description indicator: having strong feelings against someone or something)',
    english: 'angry, angrily, mad',
    swedish: 'arg, ilsken',
    norwegian: 'sint',
    finnish: 'vihainen',
    hungarian: 'dühös, mérges, haragos',
    german: 'ärgerlich, zornig, wütend',
    dutch: 'boos, kwaad, woedend, woest',
    afrikaans: 'kwaad, woedend, boos',
    russian: 'сердитый',
    latvian: 'dusmīgs, dusmīgi (īpašības v.), saniknots',
    polish: 'zły, rozgniewany, wściekły',
    french: 'fâché',
    spanish: 'enojado, con enfado, enfadado',
  },
  {
    av: 12382,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + protection: animal that is cared for in a domestic setting)',
    english: 'domestic animal',
    swedish: 'husdjur',
    norwegian: 'husdyr',
    finnish: 'kotieläin',
    hungarian: 'háziállat',
    german: 'Haustier',
    dutch: 'huisdier',
    afrikaans: 'huisdier, dier (mak)',
    russian: 'домашнее животное',
    latvian: 'mājdzīvnieks, mājlops',
    polish: 'zwierzę domowe',
    french: 'animal (domestique)',
    spanish: 'animal doméstico',
  },
  {
    av: 12384,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + pouch)',
    english: 'marsupial (animal), pouched mammal',
    swedish: 'känguru, pungdjur',
    norwegian: 'kenguru, pungdyr',
    finnish: 'kenguru, pussieläin',
    hungarian: 'kenguru, erszényes állat',
    german: 'Känguru',
    dutch: 'buideldier',
    afrikaans: 'kangaroo',
    russian: 'кенгуру',
    latvian: 'ķengurs (dzīvnieks), somainis',
    polish: 'kangur, torbacz',
    french: 'kangourou, marsupial',
    spanish: 'canguro, marsupial (animal), marsupio, mamífero',
  },
  {
    av: 12385,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + protection + description after the fact indicator)',
    english: 'animal (protected)',
    swedish: 'fridlyst djur',
    norwegian: 'dyr (fredet)',
    finnish: 'rauhoitettu eläin',
    hungarian: 'védett állat',
    german: 'Tier (geschützt), beschütztes Tier',
    dutch: 'beschermd dier',
    afrikaans: 'dier (beskermd)',
    russian: 'охраняемое животное',
    latvian: 'dzīvnieks, aizsargājams',
    polish: 'zwierzę pod ochroną, zwierzę chronione',
    french: 'animal (protégé)',
    spanish: 'animal (protegido)',
  },
  {
    av: 12386,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + teeth: animal that gnaws to file its continuously growing teeth)',
    english: 'rat, rodent, gnawer, gnawing animal',
    swedish: 'råtta, gnagare',
    norwegian: 'rotte, gnager',
    finnish: 'rotta, jyrsijä',
    hungarian: 'rágcsáló',
    german: 'Ratte, Nagetier',
    dutch: 'knaagdier',
    afrikaans: 'knaagdier, rot',
    russian: 'мышь, крыса',
    latvian: 'žurka, grauzējs, grauzējdzīvnieks ',
    polish: 'szczur, gryzoń',
    french: 'rat, rongeur',
    spanish: 'rata, roedor',
  },
  {
    av: 12387,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + animal: protective covering of an animal)',
    english: 'animal skin, hide, pelt',
    swedish: 'djurhud, skinn',
    norwegian: 'skinn, dyrehud',
    finnish: 'nahka, vuota',
    hungarian: 'állatbőr, állati szőr',
    german: 'Tierhaut, Fell, Pelz',
    dutch: 'dierenhuid, vel',
    afrikaans: 'dier huid, vel, pels',
    russian: 'шкура, кожа животного',
    latvian: 'dzīvnieku āda, zvērāda',
    polish: 'skóra, skóra zwierzęcia',
    french: 'peau (animal), fourrure',
    spanish: 'piel de animal, cuero',
  },
  {
    av: 12388,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + snake: snake-like animal)',
    english: 'lizard, reptile (snake like animal)',
    swedish: 'ödla, kräldjur',
    norwegian: 'firfisle, krypdyr, dyr slangelignende, reptil',
    finnish: 'matelija, lisko, sisilisko',
    hungarian: 'gyíkféle, hüllő',
    german: 'Eidechse, Echse, Reptil, Kriechtier',
    dutch: 'reptiel, hagedis',
    afrikaans: 'reptiel akkedis',
    russian: 'ящерица, рептилия',
    latvian: 'ķirzaka, rāpulis (čūskveidīgs dzīvnieks)',
    polish: 'jaszczurka, gad',
    french: 'animal (rampant, reptile)',
    spanish: 'lagartija, reptil (animal similar a la víbora)',
  },
  {
    av: 12390,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + open: untamed animal that lives in the open)',
    english: 'animal (wild)',
    swedish: 'vilt djur',
    norwegian: 'dyr (vilt)',
    finnish: 'villieläin',
    hungarian: 'vadállat, vadon élő állat',
    german: 'wild lebendes Tier',
    dutch: 'wild dier',
    afrikaans: 'dier (wild)',
    russian: 'дикое животное',
    latvian: 'savvaļas dzīvnieks',
    polish: 'zwierzę dzikie',
    french: 'animal (sauvage)',
    spanish: 'animal (salvaje)',
  },
  {
    av: 12392,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(year + again: occasion that comes again every year)',
    english: 'anniversary',
    swedish: 'årsdag',
    norwegian: 'årsdag',
    finnish: 'vuosipäivä',
    hungarian: 'évforduló',
    german: 'Jahrestag, Hochzeitstag',
    dutch: 'jubileum, gedenkdag',
    afrikaans: 'gedenkdag, herdenking',
    russian: 'годовщина',
    latvian: 'ikgadējs, katru gadu',
    polish: 'rocznica',
    french: 'anniversaire (date)',
    spanish: 'aniversario',
  },
  {
    av: 12394,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(answer + action indicator)',
    english: 'answer, reply-(to)',
    swedish: 'svara',
    norwegian: 'svare',
    finnish: 'vastata',
    hungarian: 'válaszolni, felelni',
    german: 'antworten',
    dutch: 'antwoorden',
    afrikaans: 'antwoord, antwoord (om te)',
    russian: 'отвечать',
    latvian: 'atbildēt',
    polish: 'odpowiadać',
    french: 'répondre',
    spanish: 'responder',
  },
  {
    av: 12395,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(insect + work + intensity: industrious insect)',
    english: 'ant',
    swedish: 'myra',
    norwegian: 'maur',
    finnish: 'muurahainen',
    hungarian: 'hangya',
    german: 'Ameise',
    dutch: 'mier',
    afrikaans: 'mier',
    russian: 'муравей',
    latvian: 'skudra',
    polish: 'mrówka',
    french: 'fourmi',
    spanish: 'hormiga',
  },
  {
    av: 12396,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(opening + buttocks)',
    english: 'anus',
    swedish: 'analöppning',
    norwegian: 'anus, endetarmsåpning',
    finnish: 'peräaukko',
    hungarian: 'végbélnyílás',
    german: 'After, Anus',
    dutch: 'anus',
    afrikaans: 'anus',
    russian: 'анус',
    latvian: 'ānus',
    polish: 'odbyt',
    french: 'anus',
    spanish: 'ano',
  },
  {
    av: 12397,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(upset + future (uncertain): upset about an uncertain future)',
    english: 'anxiety',
    swedish: 'nervositet, oro',
    norwegian: 'nervøsitet, uro',
    finnish: 'levottomuus, huolestuneisuus',
    hungarian: 'szorongás',
    german: 'Angst, Sorge, Besorgnis',
    dutch: 'ongerustheid',
    afrikaans: 'angs, onrustig, rusteloos',
    russian: 'беспокойство, тревога',
    latvian: 'sasprindzinājums, trauksme',
    polish: 'niepokój, troska, niepewność, zmartwienie',
    french: 'anxiété',
    spanish: 'ansiedad',
  },
  {
    av: 12398,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(anxiety + description indicator)',
    english: 'anxious, anxiously',
    swedish: 'nervös, orolig',
    norwegian: 'urolig, nervøs',
    finnish: 'huolestunut, jännittynyt, ahdistunut',
    hungarian: 'szorongó, szorongva',
    german: 'ängstlich, besorgt',
    dutch: 'ongerust, bezorgd',
    afrikaans: 'angstig, angstigheid, rusteloos, benoud',
    russian: 'беспокойный, тревожный',
    latvian: 'sasprindzis, saspringti, trauksmains',
    polish: 'niespokojny, zatroskany, niepewny, zmartwiony',
    french: 'anxieux',
    spanish: 'ansioso, con ansiedad',
  },
  {
    av: 12399,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(any + person)',
    english: 'anyone, anybody, somebody, someone',
    swedish: 'någon, vem som helst',
    norwegian: 'noen, hvem som helst',
    finnish: 'kuka tahansa, kukaan, jokainen, joku',
    hungarian: 'akárki, bárki, valaki',
    german: 'irgendjemand, jemand, irgendwer',
    dutch: 'iemand',
    afrikaans: 'iemand (enige)',
    russian: 'кто-то, кто-нибудь',
    latvian: 'jebkurš, jebkura, kāds, kāda',
    polish: 'ktoś, kto, ktokolwiek',
    french: "quelqu'un",
    spanish: 'alguien, alguno',
  },
  {
    av: 12400,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(any + thing)',
    english: 'anything, something',
    swedish: 'någon, något, vad som helst',
    norwegian: 'hva som helst',
    finnish: 'mikä tahansa, mikään, jotakin',
    hungarian: 'akármi, bármi, valami',
    german: 'irgendetwas, etwas',
    dutch: 'iets',
    afrikaans: 'iets (enige)',
    russian: 'что-то, что-нибудь',
    latvian: 'jebkas, kaut kas',
    polish: 'coś, cokolwiek',
    french: 'quelque chose',
    spanish: 'cualquier cosa, algo',
  },
  {
    av: 12401,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(any + time)',
    english: 'anytime, sometime',
    swedish: 'någonsin, när som helst',
    norwegian: 'når som helst',
    finnish: 'milloin tahansa, jonkin aikaa',
    hungarian: 'akármikor, bármikor, valamikor',
    german: 'irgendwann, jederzeit',
    dutch: 'ooit, eens',
    afrikaans: 'soms, somtyds, enige tyd',
    russian: 'когда угодно, когда-нибудь',
    latvian: 'jepkurā laikā, kaut kad',
    polish: 'kiedyś, w jakimś momencie',
    french: 'une fois',
    spanish: 'en cualquier momento, en algún momento',
  },
  {
    av: 12403,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + inside + house: dwelling inside a larger building)',
    english: 'apartment, flat, unit',
    swedish: 'lägenhet',
    norwegian: 'leilighet',
    finnish: 'asunto, huoneisto',
    hungarian: 'lakás, apartment',
    german: 'Wohnung',
    dutch: 'appartement, flat',
    afrikaans: 'eenheid, woonstel, wooneenheid',
    russian: 'квартира, апартаменты',
    latvian: 'liels dzīvoklis, dzīvoklis, objekts',
    polish: 'mieszkanie (w większym budynku)',
    french: 'appartement',
    spanish: 'apartamento',
  },
  {
    av: 12404,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to speak + comma + to regret + action indicator)',
    english: 'apologize, apologise, regret (express)-(to)',
    swedish: 'be om förlåtelse, be om ursäkt',
    norwegian: 'be om forlatelse, be om unnskyldning',
    finnish: 'pyytää anteeksi, pahoitella',
    hungarian: 'bocsánatot / elnézést kérni',
    german: 'entschuldigen, um Verzeihung bitten',
    dutch: 'verontschuldigen',
    afrikaans: 'jammer om, verskoning vra, verskoning maak (om te)',
    russian: 'извиняться',
    latvian: 'atvainoties, lūgt piedošanu, izteikt nožēlu',
    polish: 'przepraszać, wyrażać żal',
    french: "excuser-(s')",
    spanish: 'disculparse, arrepentirse (expresar)',
  },
  {
    av: 12406,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(time + to meet: time agreed upon for a meeting)',
    english: 'appointment',
    swedish: 'avtalad tid',
    norwegian: 'avtalt møte',
    finnish: 'sovittu tapaaminen',
    hungarian: 'találkozó',
    german: 'Verabredung, Termin',
    dutch: 'afspraak',
    afrikaans: 'afspraak',
    russian: 'назначенное время',
    latvian: 'norunāta tikšanās',
    polish: 'spotkanie, wizyta',
    french: 'rendez-vous',
    spanish: 'cita',
  },
  {
    av: 12407,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(forward + reference line: advancing arrow approaches the line but does not reach it)',
    english: 'approach',
    swedish: 'ankommande',
    norwegian: 'ankomst',
    finnish: 'tuleminen, lähestyminen',
    hungarian: 'megközelítés, közeledés',
    german: 'Ansatz, Annäherung, Herangehensweise, Vorgehen',
    dutch: 'aankomst, komst',
    afrikaans: 'aankom, kom, naderkom, aankom',
    russian: 'приближение, приход',
    latvian: 'pieeja, tuvošanās',
    polish: 'podejście, podchodzenie, zbliżenie',
    french: 'approche',
    spanish: 'enfoque',
  },
  {
    av: 12408,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(evaluation + correct + action indicator: to evaluate as correct or good in a rational sense)',
    english: 'approve-(to)',
    swedish: 'godkänna, godta',
    norwegian: 'godkjenne, godta',
    finnish: 'hyväksyä',
    hungarian: 'jóváhagyni, megfelelőnek találni',
    german: 'billigen, genehmigen, zustimmen',
    dutch: 'goedkeuren',
    afrikaans: 'goedkeur, goedgekeur, goedkeur (om te)',
    russian: 'одобрять',
    latvian: 'apstiprināt, piekrist',
    polish: 'poprzeć, zatwierdzić, wyrazić zgodę',
    french: 'approuver',
    spanish: 'aprobar',
  },
  {
    av: 12409,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(peach + small)',
    english: 'apricot',
    swedish: 'aprikos',
    norwegian: 'aprikos',
    finnish: 'aprikoosi',
    hungarian: 'sárgabarack',
    german: 'Aprikose',
    dutch: 'abrikoos',
    afrikaans: 'appelkoos',
    russian: 'абрикос',
    latvian: 'aprikoze',
    polish: 'morela',
    french: 'abricot',
    spanish: 'albaricoque',
  },
  {
    av: 12410,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 4: fourth month of the year)',
    english: 'April',
    swedish: 'april',
    norwegian: 'april',
    finnish: 'huhtikuu',
    hungarian: 'április',
    german: 'April',
    dutch: 'april',
    afrikaans: 'April',
    russian: 'апрель',
    latvian: 'aprīlis',
    polish: 'kwiecień',
    french: 'avril',
    spanish: 'Abril',
  },
  {
    av: 12411,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + clothing: protective covering worn over other clothing)',
    english: 'apron, coverall, smock, overall',
    swedish: 'förkläde, overall (etc)',
    norwegian: 'forkle, beskyttelsesklær, overall',
    finnish: 'esiliina, suojapuku',
    hungarian: 'kötény, köpeny, ruházatot védő overál',
    german: 'Overall, Arbeitsanzug',
    dutch: 'schort, overall',
    afrikaans: 'voorskoot, oorpak',
    russian: 'передник, фартук',
    latvian: 'priekšauts, darba apģērbs',
    polish: 'fartuch, kombinezon, ubranie ochronne, robocze',
    french: 'tablier',
    spanish: 'delantal, mono, mameluco, bata',
  },
  {
    av: 12412,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to plan + building: person who designs buildings)',
    english: 'architect',
    swedish: 'arkitekt',
    norwegian: 'arkitekt',
    finnish: 'arkkitehti',
    hungarian: 'építész',
    german: 'Architekt, Architektin',
    dutch: 'architect',
    afrikaans: 'argitek',
    russian: 'архитектор',
    latvian: 'arhitekts',
    polish: 'architekt',
    french: 'architecte',
    spanish: 'arquitecto',
  },
  {
    av: 12413,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(argument + action indicator)',
    english: 'argue, dispute, quarrel-(to)',
    swedish: 'diskutera',
    norwegian: 'argumentere, drøfte, diskutere',
    finnish: 'väitellä',
    hungarian: 'vitatkozni',
    german: 'streiten, sich streiten, diskutieren, auseinandersetzen',
    dutch: 'discussiëren, discuteren, debateren',
    afrikaans: 'bespreek, argumenteer, dispuut, stry, debateer (om te)',
    russian: 'спорить, обсуждать',
    latvian: 'argumentēt, apspriesties, strīdēties',
    polish: 'kłócić się, spierać',
    french: 'disputer-(se)',
    spanish: 'discutir, disputar, reñir',
  },
  {
    av: 12414,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(discussion + intensity)',
    english: 'argument, dispute, quarrel',
    swedish: 'diskussion',
    norwegian: 'argument, drøfting, diskusjon',
    finnish: 'väittely',
    hungarian: 'vita',
    german: 'Streit, Auseinandersetzung, Wortwechsel',
    dutch: 'discussie, debat',
    afrikaans: 'bespreek, argumenteer, dispuut, stry, debateer',
    russian: 'спор, дискуссия',
    latvian: 'strīds, arguments',
    polish: 'kłótnia, spór',
    french: 'dispute',
    spanish: 'discusiones, disputas, riñas',
  },
  {
    av: 12579,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group + war: group trained for war)',
    english: 'military, armed forces, armed services',
    swedish: 'militär, väpnade styrkor',
    norwegian: 'væpnede styrker',
    finnish: 'armeija, intti, asepalvelus',
    hungarian: 'hadsereg',
    german: 'Militär, Streitkräfte, Armee',
    dutch: 'leger, militairen',
    afrikaans: 'militêre gewapende mag diens, weermag, leër',
    russian: 'армия, войско',
    latvian: 'kara, militārs, bruņotie spēki, militārie dienesti',
    polish: 'wojsko, armia',
    french: 'militaire, forces armées',
    spanish: 'militar, fuerzas armadas',
  },
  {
    av: 12581,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(man-made + feeling: process of making or producing something that inspires emotion in the beholder)',
    english: 'art',
    swedish: 'konst',
    norwegian: 'kunst',
    finnish: 'taide',
    hungarian: 'művészet',
    german: 'Kunst',
    dutch: 'kunst',
    afrikaans: 'kuns',
    russian: 'искусство',
    latvian: 'māksla',
    polish: 'sztuka',
    french: 'art',
    spanish: 'arte',
  },
  {
    av: 12582,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(building + work of art + thing indicator: building where works of art are displayed)',
    english: 'art gallery, gallery',
    swedish: 'konstmuseum, konstgalleri',
    norwegian: 'kunstgalleri, kunstmuseum',
    finnish: 'taidehalli, taidegalleria',
    hungarian: 'kiállítóterem, művészeti galéria',
    german: 'Kunstmuseum, Galerie, Kunstgalerie',
    dutch: 'kunstgalerie',
    afrikaans: 'kunsgallery',
    russian: 'галерея, музей искусств',
    latvian: 'mākslas galerija, galerija',
    polish: 'galeria sztuki, galeria',
    french: "galerie d'art",
    spanish: 'galería de arte, museo',
  },
  {
    av: 12583,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid + medical + conception)',
    english: 'artificial insemination',
    swedish: 'konstgjord befruktning',
    norwegian: 'befruktning kunstig',
    finnish: 'keinohedelmöitys',
    hungarian: 'mesterséges megtermékenyítés',
    german: 'künstliche Befruchtung',
    dutch: 'kunstmatige inseminatie',
    afrikaans: 'kunsmatige inseminasie',
    russian: 'искусственное оплодотворение',
    latvian: 'mākslīgā apaugļošana',
    polish: 'sztuczne zapłodnienie',
    french: 'insémination artificielle',
    spanish: 'inseminación artificial',
  },
  {
    av: 12584,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to cause + to breathe)',
    english: 'artificial respiration',
    swedish: 'konstgjord andning',
    norwegian: 'åndedrett kunstig',
    finnish: 'tekohengitys',
    hungarian: 'mesterséges légzés',
    german: 'künstliche Beatmung',
    dutch: 'beademing',
    afrikaans: 'kunsmatige asemhaling',
    russian: 'искусственное дыхание',
    latvian: 'mākslīgā elpināšana',
    polish: 'sztuczne oddychanie, oddychanie usta – usta',
    french: 'respiration artificielle',
    spanish: 'respiración artificial',
  },
  {
    av: 12585,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(artificial respiration + action indicator)',
    english: 'give artificial respiration, resuscitate, revive-(to)',
    swedish: 'ge konstgjord andning',
    norwegian: 'gi kunstig åndedrett',
    finnish: 'antaa tekohengitystä',
    hungarian: 'lélegeztetés, újraélesztés',
    german: 'künstliche Beatmung geben',
    dutch: 'beademen',
    afrikaans: 'gee kunsmatige asemhaling (om te)',
    russian: 'делать искусственное дыхание',
    latvian: 'mākslīga elpināšana, atdzīvināšana',
    polish: 'sztuczne oddychanie, reanimacja',
    french: 'pratiquer la respiration artificielle',
    spanish: 'dar respiración artificial, resucitar, revivir',
  },
  {
    av: 12586,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(waste + fire)',
    english: 'ashes',
    swedish: 'aska',
    norwegian: 'aske',
    finnish: 'tuhka',
    hungarian: 'hamu',
    german: 'Asche',
    dutch: 'as',
    afrikaans: 'as',
    russian: 'пепел',
    latvian: 'pelni ',
    polish: 'popiół, prochy',
    french: 'cendres',
    spanish: 'cenizas',
  },
  {
    av: 12587,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + ashes)',
    english: 'ashtray',
    swedish: 'askfat',
    norwegian: 'askebeger',
    finnish: 'tuhkakuppi',
    hungarian: 'hamutálca',
    german: 'Aschenbecher',
    dutch: 'asbak',
    afrikaans: 'asbak',
    russian: 'пепельница',
    latvian: 'pelnutrauks',
    polish: 'popielniczka',
    french: 'cendrier',
    spanish: 'cenicero',
  },
  {
    av: 12588,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(question + action indicator)',
    english: 'ask, inquire, question-(to)',
    swedish: 'fråga (verb)',
    norwegian: 'spørre',
    finnish: 'kysyä',
    hungarian: 'kérdezni, érdeklődni',
    german: 'fragen',
    dutch: 'vragen',
    afrikaans: 'vraag, vra (om te)',
    russian: 'спрашивать',
    latvian: 'jautāt, vaicāt, uzdot jautājumu',
    polish: 'zapytać, pytać',
    french: 'demander, questionner, poser une question',
    spanish: 'preguntar',
  },
  {
    av: 12589,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(sleep + description indicator)',
    english: 'asleep',
    swedish: 'sovande',
    norwegian: 'sovende, i søvn',
    finnish: 'nukkuva, unessa oleva',
    hungarian: 'alvó',
    german: 'schlafend, schlafen',
    dutch: 'slapend, slaperig',
    afrikaans: 'slaap (om te)',
    russian: 'спящий',
    latvian: 'aizmidzis',
    polish: 'śpiący, uśpiony',
    french: 'endormi',
    spanish: 'dormido',
  },
  {
    av: 12590,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + rocket: person who goes up in a rocket)',
    english: 'astronaut, cosmonaut',
    swedish: 'astronaut, rymdfarare',
    norwegian: 'astronaut, kosmonaut, romfarer',
    finnish: 'astronautti, kosmonautti',
    hungarian: 'űrhajós, asztronauta',
    german: 'Astronaut, Kosmonaut',
    dutch: 'astronaut, ruimtevaarder',
    afrikaans: 'ruimtevaarder',
    russian: 'космонавт, астронавт',
    latvian: 'astronauts, kosmonauts',
    polish: 'astronauta, kosmonauta',
    french: 'astronaute, cosmonaute',
    spanish: 'astronauta, cosmonauta',
  },
  {
    av: 12593,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(of illness) (illness + limited time)',
    english: 'attack (of illness)',
    swedish: 'anfall, attack',
    norwegian: 'anfall',
    finnish: 'sairaskohtaus, kohtaus',
    hungarian: 'roham (betegségé)',
    german: 'Anfall, Schub',
    dutch: 'aanval (ziekte)',
    afrikaans: 'aanval (siekte)',
    russian: 'припадок, приступ',
    latvian: 'slimības lēkme',
    polish: 'atak choroby (ograniczony w czasie)',
    french: 'crise (période de maladie)',
    spanish: 'ataque (enfermedad)',
  },
  {
    av: 12594,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(eye + intensity + intensity: using the eyes intently)',
    english: 'attention',
    swedish: 'uppmärksamhet',
    norwegian: 'oppmerksomhet',
    finnish: 'huomio, tarkkaavaisuus',
    hungarian: 'figyelem',
    german: 'Achtung, Vorsicht, Aufmerksamkeit',
    dutch: 'aandacht',
    afrikaans: 'aandag',
    russian: 'внимание',
    latvian: 'uzmanība',
    polish: 'uwaga',
    french: 'attention',
    spanish: 'atención',
  },
  {
    av: 12595,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 8: eighth month of the year)',
    english: 'August',
    swedish: 'augusti',
    norwegian: 'august',
    finnish: 'elokuu',
    hungarian: 'augusztus',
    german: 'August',
    dutch: 'augustus',
    afrikaans: 'Augustus',
    russian: 'август',
    latvian: 'augusts',
    polish: 'sierpień',
    french: 'août',
    spanish: 'Agosto',
  },
  {
    av: 12597,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sun + 3: third season) (CKB) SYMBOL SYNONYM',
    english: 'autumn, fall (ckb)',
    swedish: 'höst (CKB)',
    norwegian: 'høst (CKB)',
    finnish: 'syksy',
    hungarian: 'ősz (régi CKB-jelkép)',
    german: 'Herbst (CKB)',
    dutch: 'herfst (CKB)',
    afrikaans: 'herfs (ckb)',
    russian: 'осень (Ч.Б.)',
    latvian: 'rudens',
    polish: 'jesień (CKB)',
    french: 'automne (ckb)',
    spanish: 'otoño (ckb)',
  },
  {
    av: 12598,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sun + 3 + leaf + down: third season when the leaves fall) (BCI) SYMBOL SYNONYM',
    english: 'autumn, fall',
    swedish: 'höst',
    norwegian: 'høst',
    finnish: 'syksy',
    hungarian: 'ősz',
    german: 'Herbst',
    dutch: 'herfst',
    afrikaans: 'herfs',
    russian: 'осень',
    latvian: 'rudens, lapkritis',
    polish: 'jesień',
    french: 'automne',
    spanish: 'otoño',
  },
  {
    av: 12599,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(month + church ruin, temple ruin, wreck, wreckage (church, temple, mosque) (1): month of the Tisha B'Av, the destruction of the Holy Temple (Hebrew))",
    english: 'Av (Hebrew month)',
    swedish: 'Av (Israel)',
    norwegian: 'Av (Israel)',
    finnish: 'av',
    hungarian: 'Av',
    german: 'Aw (Monat)',
    dutch: 'Av (Joods)',
    afrikaans: 'Av (Joods)',
    russian: 'Ав (Израиль)',
    latvian: 'Av, ebreju kalendāra 5.mēnesis',
    polish: 'Aw (miesiąc hebrajski)',
    french: 'Av (5e mois du calendrier juif)',
    spanish: 'Av',
  },
  {
    av: 12601,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      "(wakefulness, alertness + description indicator: state one is in when one's eyes are open)",
    english: 'awake',
    swedish: 'vaken',
    norwegian: 'våken',
    finnish: 'valveilla, hereillä',
    hungarian: 'ébren, éber',
    german: 'wach',
    dutch: 'wakker',
    afrikaans: 'wakker',
    russian: 'проснувшийся',
    latvian: 'nomodā',
    polish: 'rozbudzony, obudzony',
    french: 'éveillé, réveillé',
    spanish: 'despierto',
  },
  {
    av: 12605,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wagon + baby: carriage for a baby)',
    english: 'baby carriage, buggy, pram, pushchair, stroller',
    swedish: 'barnvagn, sulky',
    norwegian: 'barnevogn',
    finnish: 'lastenvaunut, rattaat',
    hungarian: 'babakocsi',
    german: 'Kinderwagen, Buggy',
    dutch: 'kinderwagen, buggy, wandelwagen',
    afrikaans: 'stootwaentjie, stootkarretjie',
    russian: 'детская коляска',
    latvian: 'bērnu ratiņi',
    polish: 'wózek dziecięcy, wózek spacerowy',
    french: 'landau, poussette',
    spanish: 'carrito de bebé, cochecito, sillita de paseo',
  },
  {
    av: 12606,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clinic + baby)',
    english: 'baby clinic',
    swedish: 'barnavårdscentral',
    norwegian: 'barneavdeling',
    finnish: 'lastenklinikka, lastenneuvola',
    hungarian: 'gyermekrendelő, csecsemőrendelő',
    german: 'Babyklinik, Kinderklinik',
    dutch: 'kraamkliniek',
    afrikaans: 'baba kliniek',
    russian: 'детская поликлиника',
    latvian: 'bērnu klīnika, bērnu poliklīnika',
    polish: 'klinika dziecięca, oddział pediatryczny, noworodkowy',
    french: 'pédiatrie (clinique)',
    spanish: 'clínica pediátrica',
  },
  {
    av: 12608,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to protect + child: person who cares for a child)',
    english: 'babysitter',
    swedish: 'barnvakt',
    norwegian: 'barnevakt',
    finnish: 'lapsenvahti, lastenhoitaja',
    hungarian: 'bébiszitter, gyermekfelügyelő',
    german: 'Babysitter',
    dutch: 'babysitter, oppas',
    afrikaans: 'baba oppasser',
    russian: 'няня',
    latvian: 'aukle, bērnaukle',
    polish: 'niania, opiekunka do dziecka',
    french: "baby-sitter, gardienne d'enfant",
    spanish: 'niñera',
  },
  {
    av: 12611,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sack + back)',
    english: 'backpack, rucksack',
    swedish: 'ryggsäck',
    norwegian: 'ryggsekk',
    finnish: 'reppu',
    hungarian: 'hátizsák',
    german: 'Rucksack',
    dutch: 'rugzak',
    afrikaans: 'rugsak',
    russian: 'рюкзак',
    latvian: 'mugursoma',
    polish: 'plecak',
    french: 'sac à dos',
    spanish: 'mochila',
  },
  {
    av: 12612,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(backward + action indicator)',
    english: 'back up-(to)',
    swedish: 'gå tillbaka, gå bakåt, backa',
    norwegian: 'rygge, gå tilbake, returnere',
    finnish: 'perääntyä, peruuttaa',
    hungarian: 'hátrálni, visszafelé menni',
    german: 'zurückgehen, zurückfahren',
    dutch: 'terugtrekken',
    afrikaans: 'terugtrek, terugkeer, teruggaan (om te)',
    russian: 'вернуться назад',
    latvian: 'atgrieties atpakaļ',
    polish: 'cofać się, poruszać się do tyłu, iść z powrotem',
    french: 'reculer',
    spanish: 'guardar, respaldar',
  },
  {
    av: 12614,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pork + linear thing + thing indicator: pork in strips)',
    english: 'bacon',
    swedish: 'bacon, fläsk',
    norwegian: 'bacon',
    finnish: 'pekoni',
    hungarian: 'szalonna',
    german: 'Speck',
    dutch: 'spek',
    afrikaans: 'spek',
    russian: 'бекон',
    latvian: 'speķis, bekons',
    polish: 'boczek, bekon',
    french: 'lard en tranche, bacon',
    spanish: 'tocino',
  },
  {
    av: 12615,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(feeling + negative + description indicator: felt to be negative or bad in an emotional sense) See also: immoral, bad, wrong, morally wrong 14929 and incorrect, bad, inaccurate, wrong 14935',
    english: 'bad, wrong',
    swedish: 'dålig',
    norwegian: 'dårlig',
    finnish: 'huono, paha',
    hungarian: 'rossz',
    german: 'schlecht, falsch, verkehrt',
    dutch: 'slecht',
    afrikaans: 'sleg, verkeerd, nie goed nie',
    russian: 'плохой, плохо',
    latvian: 'slikts, nepareizs',
    polish: 'źle, niedobrze',
    french: 'mauvais',
    spanish: 'malo',
  },
  {
    av: 12617,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + shuttlecock: game played with a feathered shuttlecock)',
    english: 'badminton (activity)',
    swedish: 'badminton (aktivitet)',
    norwegian: 'badminton',
    finnish: 'sulkapallo',
    hungarian: 'tollaslabda (játék, sport)',
    german: 'Federballspiel, Badminton (Aktivität)',
    dutch: 'badminton',
    afrikaans: 'pluimbal (aktiwiteit)',
    russian: 'бадминтон',
    latvian: 'badmintons (spēle)',
    polish: 'badminton (czynność)',
    french: 'badminton (activité)',
    spanish: 'bádminton (actividad)',
  },
  {
    av: 12619,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to cook + enclosure + action indicator: to cook inside an enclosure e.g. oven)',
    english: 'bake, cook, roast-(to)',
    swedish: 'baka, grädda, steka (i ugn)',
    norwegian: 'bake, steke i ovn',
    finnish: 'leipoa, paistaa',
    hungarian: 'sütni, pirítani',
    german: 'backen, zubereiten, braten (im Ofen)',
    dutch: 'bakken, roosteren',
    afrikaans: 'bak, kook, rooster (om te)',
    russian: 'печь, выпекать',
    latvian: 'cept, izcept',
    polish: 'piec, gotować',
    french: 'cuire au four',
    spanish: 'cocinar, hornear',
  },
  {
    av: 12620,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + outside)',
    english: 'balcony, porch, veranda',
    swedish: 'balkong, uterum, veranda',
    norwegian: 'balkong, veranda, uterom, terrasse',
    finnish: 'parveke, kuisti',
    hungarian: 'terasz, balkon, veranda',
    german: 'Balkon, Terasse, Veranda',
    dutch: 'balkon',
    afrikaans: 'balkon, veranda, stoep',
    russian: 'балкон, веранда',
    latvian: 'balkons, lievenis, veranda',
    polish: 'balkon, weranda, ganek',
    french: 'balcon, véranda, porche, loggia, pergola',
    spanish: 'balcón, galería',
  },
  {
    av: 12625,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + protection + medical)',
    english: 'bandage, dressing',
    swedish: 'bandage, förband, plåster',
    norwegian: 'bandasje, forbinding, plaster',
    finnish: 'side',
    hungarian: 'kötés (orvosi)',
    german: 'Bandage, Verband, Binde, Pflaster',
    dutch: 'verband, rekverband',
    afrikaans: 'verband, rekverband',
    russian: 'перевязочный материал',
    latvian: 'pārsējs, bandāža, pārsienamais materiāls',
    polish: 'bandaż, opatrunek',
    french: 'pansement, sparadrap, bandage, compresse',
    spanish: 'vendaje, apósito',
  },
  {
    av: 12626,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + money)',
    english: 'bank',
    swedish: 'bank',
    norwegian: 'bank',
    finnish: 'pankki',
    hungarian: 'bank',
    german: 'Bank',
    dutch: 'bank (geld)',
    afrikaans: 'bank (geld)',
    russian: 'банк',
    latvian: 'banka',
    polish: 'bank',
    french: 'banque',
    spanish: 'banco',
  },
  {
    av: 12627,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(public room + alcoholic drink)',
    english: 'bar, pub',
    swedish: 'bar, pub',
    norwegian: 'bar, pub',
    finnish: 'baari, pubi',
    hungarian: 'bár, kocsma, pub, italbolt',
    german: 'Kneipe, Bar, Theke',
    dutch: 'café, bar, kroeg',
    afrikaans: 'kroeg (alkohol)',
    russian: 'бар',
    latvian: 'bārs, krogs',
    polish: 'bar, pub',
    french: 'bar, café, pub',
    spanish: 'bar, pub, taberna',
  },
  {
    av: 12628,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + hair)',
    english: 'barber, hairdresser',
    swedish: 'frisör, hårfrisörska',
    norwegian: 'frisør',
    finnish: 'parturi, kampaaja',
    hungarian: 'fodrász',
    german: 'Friseur, Friseurin',
    dutch: 'kapper',
    afrikaans: 'barbier, haarkapper',
    russian: 'парикмахер',
    latvian: 'frizieris, friziere',
    polish: 'fryzjer',
    french: 'coiffeur',
    spanish: 'barbero, peluquero',
  },
  {
    av: 12629,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(public room + hair)',
    english: 'barbershop, beauty shop',
    swedish: 'frisersalong',
    norwegian: 'frisørsalong',
    finnish: 'parturi, kampaamo',
    hungarian: 'fodrászat',
    german: 'Frisiersalon, Friseurladen',
    dutch: 'kapsalon',
    afrikaans: 'haarsalon',
    russian: 'парикмахерская',
    latvian: 'frizētava, skaistumkopšanas salons',
    polish: 'salon fryzjerski, salon kosmetyczny',
    french: 'salon de coiffure',
    spanish: 'barbería, peluquería',
  },
  {
    av: 12630,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + animal: building for animals)',
    english: 'barn, stable, shed',
    swedish: 'ladugård, stall',
    norwegian: 'fjøs, stall',
    finnish: 'navetta, talli',
    hungarian: 'istálló',
    german: 'Stall, Scheune',
    dutch: 'stal',
    afrikaans: 'stal, kraal',
    russian: 'хлев, конюшня, ферма',
    latvian: 'kūts',
    polish: 'stodoła, stajnia, szopa',
    french: 'grange, écurie, étable',
    spanish: 'granero, establo, cobertizo',
  },
  {
    av: 12632,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + ball + corner: the corner character here represents the baseball diamond with the pointer to a base in a corner: ball game played on a diamond)',
    english: 'baseball (activity)',
    swedish: 'baseboll (aktivitet)',
    norwegian: 'baseball',
    finnish: 'baseball, pesäpallo',
    hungarian: 'bézból (játék, sport)',
    german: 'Baseball (Aktivität)',
    dutch: 'honkbal',
    afrikaans: 'sagtebal (aktiwiteit)',
    russian: 'бейсбол',
    latvian: 'beisbols (spēle)',
    polish: 'Baseball (aktywności)',
    french: 'baseball (activité)',
    spanish: 'béisbol (actividad)',
  },
  {
    av: 12633,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + to gather)',
    english: 'base camp',
    swedish: 'samlingsplats',
    norwegian: 'møteplass',
    finnish: 'kokoontumispaikka',
    hungarian: 'gyülekezési hely, alaptábor, bázis',
    german: 'Hauptlager, Basislager',
    dutch: 'verzamelplaats, ontmoetingsplaats, trefpunt',
    afrikaans: 'basis kamp',
    russian: 'место сбора',
    latvian: 'atbalsta punkts, bāze',
    polish: 'obóz bazowy, baza',
    french: 'camp (lieu)',
    spanish: 'campamento base',
  },
  {
    av: 12634,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + ball + container, basket (high): game in which a ball is tossed into a high basket)',
    english: 'basketball (activity)',
    swedish: 'basketboll (aktivitet)',
    norwegian: 'basketball',
    finnish: 'koripallo',
    hungarian: 'kosárlabda (játék)',
    german: 'Basketball (Aktivität)',
    dutch: 'basketbal, korfbal',
    afrikaans: 'basketbal, netbal, korfbal',
    russian: 'баскетбол',
    latvian: 'basketbols (spēle)',
    polish: 'koszykówka (aktywności)',
    french: 'basketball (activité)',
    spanish: 'baloncesto (actividad)',
  },
  {
    av: 12635,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(linear thing + ball + thing indicator: linear thing used to hit a ball)',
    english: 'bat (sport)',
    swedish: 'slagträ',
    norwegian: 'balltre',
    finnish: 'maila',
    hungarian: 'ütő (labdajátékban)',
    german: 'Baseballschläger',
    dutch: 'knuppel, bat',
    afrikaans: 'kolf',
    russian: 'бита (спорт)',
    latvian: 'nūja (sportā, kriketa nūja)',
    polish: 'kij do bejsbola (sport)',
    french: 'batte (accessoire de sport)',
    spanish: 'bate (deporte)',
  },
  {
    av: 12637,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + bath)',
    english: 'bathroom, washroom',
    swedish: 'badrum, tvättrum',
    norwegian: 'baderom, vaskerom',
    finnish: 'kylpyhuone, pesuhuone',
    hungarian: 'fürdőszoba, mosdóhelyiség',
    german: 'Badezimmer, Bad, Waschraum',
    dutch: 'badkamer',
    afrikaans: 'badkamer, waskamer',
    russian: 'ванная комната',
    latvian: 'vannas istaba, mazgājamā telpa',
    polish: 'łazienka',
    french: 'salle de bain',
    spanish: 'cuarto de baño, servicio',
  },
  {
    av: 12638,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(container + electricity: receptacle that stores and generates electricity)',
    english: 'battery',
    swedish: 'batteri',
    norwegian: 'batteri',
    finnish: 'patteri, paristo',
    hungarian: 'elem',
    german: 'Batterie',
    dutch: 'batterij, accu',
    afrikaans: 'battery',
    russian: 'батарея',
    latvian: 'akumulators, betrija',
    polish: 'bateria',
    french: 'pile, batterie, accumulateur',
    spanish: 'batería',
  },
  {
    av: 12639,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(to live [half-sized] + action indicator: the 'little meaning' of to live) (See Note p. II-30 in BRG)",
    english: 'be, am, are, is, exist-(to)',
    swedish: 'vara, finnas',
    norwegian: 'være, eksistere',
    finnish: 'olla, olla olemassa',
    hungarian: 'lenni',
    german: 'sein, bin, bist, ist, sind, existieren',
    dutch: 'zijn',
    afrikaans: 'is, wees, bestaan (om te)',
    russian: 'быть, находиться',
    latvian: 'būt, esmu, ir, pastāvēt, eksistēt',
    polish: 'być, istnieć, jest, istnieje',
    french: 'être, exister',
    spanish: 'ser, estar, existir',
  },
  {
    av: 12643,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(animal + bear's head: animal + pictograph of a bear's head)",
    english: 'bear',
    swedish: 'björn',
    norwegian: 'bjørn',
    finnish: 'karhu',
    hungarian: 'medve, mackó',
    german: 'Bär',
    dutch: 'beer',
    afrikaans: 'beer',
    russian: 'медведь',
    latvian: 'lācis',
    polish: 'niedźwiedź',
    french: 'ours',
    spanish: 'oso',
  },
  {
    av: 12645,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(beauty + description indicator: pleasing to the eye)',
    english: 'beautiful, attractive, good-looking, handsome, pretty',
    swedish: 'vacker, snygg, söt',
    norwegian: 'pen, vakker, søt',
    finnish: 'kaunis',
    hungarian: 'szép, gyönyörű, csinos, vonzó, jóképű, jóvágású',
    german: 'schön, hübsch, attraktiv, gut aussehend',
    dutch: 'mooi, knap, aantrekkelijk',
    afrikaans: 'mooi, aantreklik, pragtig, wonderlik',
    russian: 'красивый, привлекательный',
    latvian: 'skaists, pievilcīgs, izskatīgs ',
    polish: 'piękny, atrakcyjny, przystojny, ładny, śliczny',
    french: 'beau, magnifique, joli, attirant',
    spanish: 'hermoso, atractivo, guapo, bonito',
  },
  {
    av: 12646,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(water animal (big tail) + teeth: can be interpreted as a combination of water animal (with a big tail) and rodent, a large, flat-tailed rodent that makes its home in water)',
    english: 'beaver',
    swedish: 'bäver',
    norwegian: 'bever',
    finnish: 'majava',
    hungarian: 'hód',
    german: 'Biber',
    dutch: 'bever',
    afrikaans: 'bewer',
    russian: 'бобр',
    latvian: 'bebrs',
    polish: 'bóbr',
    french: 'castor',
    spanish: 'castor',
  },
  {
    av: 12647,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation:
      "(cause [half-sized] + what, question mark. CKB points out that this symbol is the reverse of why, and reminds us that the question mark remains to show that not all answers beginning with 'because' are complete or satisfactory.)",
    english: 'because',
    swedish: 'därför',
    norwegian: 'fordi, derfor',
    finnish: 'siksi että, koska',
    hungarian: 'mert',
    german: 'weil, da',
    dutch: 'omdat',
    afrikaans: 'omdat',
    russian: 'потому что, поэтому',
    latvian: 'tāpēc, tādēļ',
    polish: 'ponieważ, dlatego, bo',
    french: 'parce que, car',
    spanish: 'porque',
  },
  {
    av: 12648,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to advance + to be + action indicator: to come to be)',
    english: 'become-(to)',
    swedish: 'bli',
    norwegian: 'bli',
    finnish: 'tulla (joksikin)',
    hungarian: 'válni/lenni valamivé',
    german: 'werden',
    dutch: 'worden',
    afrikaans: 'word (om te)',
    russian: 'стать, становиться ',
    latvian: 'kļūt',
    polish: 'stać się',
    french: 'devenir',
    spanish: 'convertirse en',
  },
  {
    av: 12650,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + to sleep)',
    english: 'bedroom',
    swedish: 'sovrum',
    norwegian: 'soverom',
    finnish: 'makuuhuone',
    hungarian: 'hálószoba',
    german: 'Schlafzimmer',
    dutch: 'slaapkamer',
    afrikaans: 'slaapkamer',
    russian: 'спальня',
    latvian: 'guļamistaba',
    polish: 'sypialnia',
    french: 'chambre à coucher',
    spanish: 'dormitorio',
  },
  {
    av: 12651,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(fly + flower: flying insect that obtains nectar and pollen from flowers)',
    english: 'bee, bumblebee, hoverfly',
    swedish: 'bi',
    norwegian: 'bie',
    finnish: 'ampiainen, mehiläinen',
    hungarian: 'méh',
    german: 'Biene',
    dutch: 'bij',
    afrikaans: 'by',
    russian: 'пчела',
    latvian: 'bite',
    polish: 'pszczoła',
    french: 'abeille',
    spanish: 'abeja',
  },
  {
    av: 12652,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + bovine: food that comes from a steer or cow. The symbol also can be explained as: combination of meat and bovine)',
    english: 'beef',
    swedish: 'nötkött',
    norwegian: 'oksekjøtt, storfekjøtt',
    finnish: 'pihvi, naudanliha, häränliha',
    hungarian: 'marhahús',
    german: 'Rindfleisch, Rind',
    dutch: 'rundvlees',
    afrikaans: 'beesvleis',
    russian: 'говядина',
    latvian: 'liellopu gaļa',
    polish: 'wołowina',
    french: 'viande de boeuf',
    spanish: 'carne de res',
  },
  {
    av: 12653,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(alcoholic drink + gas: alcoholic drink that has bubbles or foam)',
    english: 'beer',
    swedish: 'öl',
    norwegian: 'øl',
    finnish: 'olut',
    hungarian: 'sör',
    german: 'Bier',
    dutch: 'bier',
    afrikaans: 'bier',
    russian: 'пиво',
    latvian: 'alus',
    polish: 'piwo',
    french: 'bière',
    spanish: 'cerveza',
  },
  {
    av: 12654,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vegetable (large-leafed) + red: vegetable with a red, edible root)',
    english: 'beet, beetroot',
    swedish: 'rödbeta',
    norwegian: 'rødbete',
    finnish: 'punajuuri',
    hungarian: 'cékla',
    german: 'Rote Beete',
    dutch: 'rode biet',
    afrikaans: 'beet',
    russian: 'свёкла',
    latvian: 'bietes',
    polish: 'buraki',
    french: 'betterave rouge',
    spanish: 'remolacha',
  },
  {
    av: 12657,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(beginning + action indicator)',
    english: 'begin, start-(to)',
    swedish: 'börja, starta',
    norwegian: 'starte, begynne',
    finnish: 'aloittaa, alkaa, lähteä liikkeelle',
    hungarian: 'kezdeni, kezdődni, indulni, startolni',
    german: 'anfangen, beginnen, starten',
    dutch: 'beginnen, starten',
    afrikaans: 'begin (om te)',
    russian: 'начать',
    latvian: 'sākt, uzsākt',
    polish: 'rozpoczynać',
    french: 'commencer',
    spanish: 'comenzar',
  },
  {
    av: 12659,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + creature + thing indicator: action of a living being)',
    english: 'behaviour',
    swedish: 'beteende, uppträdande',
    norwegian: 'adferd, oppførsel',
    finnish: 'käytös, käyttäytyminen',
    hungarian: 'viselkedés',
    german: 'Verhalten',
    dutch: 'gedrag',
    afrikaans: 'gedrag',
    russian: 'поведение',
    latvian: 'uzvedība',
    polish: 'zachowanie',
    french: 'comportement',
    spanish: 'comportamiento',
  },
  {
    av: 12660,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + hypothesis, theory: where hypothesis, theory represents truth [contraction], what one feels to be true, without needing proof)',
    english: 'belief',
    swedish: 'tro (subst.)',
    norwegian: 'tro',
    finnish: 'usko',
    hungarian: 'hit, hiedelem',
    german: 'Glaube',
    dutch: 'geloof',
    afrikaans: 'geloof',
    russian: 'вера',
    latvian: 'ticība, pārliecība',
    polish: 'wiara',
    french: 'croyance, foi',
    spanish: 'creencia',
  },
  {
    av: 12661,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(belief + action indicator)',
    english: 'believe-(to)',
    swedish: 'tro (verb)',
    norwegian: 'tro (å)',
    finnish: 'uskoa',
    hungarian: 'hinni',
    german: 'glauben',
    dutch: 'geloven',
    afrikaans: 'glo (om te)',
    russian: 'верить',
    latvian: 'ticēt',
    polish: 'wierzyć',
    french: 'croire, avoir foi en',
    spanish: 'creer',
  },
  {
    av: 12662,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + 1 + musical note: thing with one musical note)',
    english: 'bell',
    swedish: 'ringklocka, klocka',
    norwegian: 'klokke, bjelle',
    finnish: 'soittokello, tiuku',
    hungarian: 'csengő',
    german: 'Klingel, Glocke',
    dutch: 'bel',
    afrikaans: 'klok',
    russian: 'звонок, колокол ',
    latvian: 'zvans',
    polish: 'dzwon, dzwonek',
    french: 'cloche',
    spanish: 'campana, timbre',
  },
  {
    av: 12664,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(linear thing + waist + thing indicator: linear thing worn at the waist)',
    english: 'belt, sash',
    swedish: 'bälte, skärp',
    norwegian: 'belte',
    finnish: 'vyö',
    hungarian: 'öv, derékszalag, széles selyemöv',
    german: 'Gürtel, Gurt',
    dutch: 'riem',
    afrikaans: 'gordel',
    russian: 'пояс, ремень',
    latvian: 'josta, siksna',
    polish: 'pas, szarfa, wstęga',
    french: 'ceinture',
    spanish: 'cinturón, faja',
  },
  {
    av: 12665,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(seat + long)',
    english: 'bench, pew',
    swedish: 'bänk',
    norwegian: 'benk, sittebenk',
    finnish: 'penkki',
    hungarian: 'pad, templomi padsor',
    german: 'Sitzbank, Parkbank',
    dutch: 'bank (zitten), zitbank, zetel',
    afrikaans: 'stoel, sofa, bank (sit)',
    russian: 'скамейка, скамья',
    latvian: 'sols, sēdvieta',
    polish: 'ławka, ława (długie siedzisko)',
    french: 'banc',
    spanish: 'banco',
  },
  {
    av: 12667,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(most + good + description indicator)',
    english: 'best',
    swedish: 'bäst',
    norwegian: 'best',
    finnish: 'paras',
    hungarian: 'legjobb',
    german: 'beste, bester, am besten',
    dutch: 'best',
    afrikaans: 'beste',
    russian: 'лучший',
    latvian: 'vislabākais, vislabākā',
    polish: 'najlepszy',
    french: 'meilleur (le), mieux (le)',
    spanish: 'el mejor',
  },
  {
    av: 12668,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(more + good + description indicator)',
    english: 'better',
    swedish: 'bättre',
    norwegian: 'bedre',
    finnish: 'parempi',
    hungarian: 'jobb',
    german: 'besser',
    dutch: 'beter',
    afrikaans: 'beter',
    russian: 'лучше',
    latvian: 'labāk',
    polish: 'lepszy',
    french: 'meilleur que, mieux que',
    spanish: 'mejor que',
  },
  {
    av: 12833,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + chest: protective covering for the upper body)',
    english: 'bib',
    swedish: 'haklapp',
    norwegian: 'smekke',
    finnish: 'leukalappu, ruokalappu',
    hungarian: 'előke (régen: partedli)',
    german: 'Lätzchen, Latz',
    dutch: 'slab, slabbetje',
    afrikaans: 'borslap',
    russian: 'нагрудник',
    latvian: 'krūšautiņš, lacīte',
    polish: 'śliniaczek',
    french: 'bavoir, bavette',
    spanish: 'babero',
  },
  {
    av: 12834,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(2 + wheel: two wheeled cycle)',
    english: 'bicycle',
    swedish: 'cykel',
    norwegian: 'sykkel',
    finnish: 'polkupyörä',
    hungarian: 'kerékpár, bicikli',
    german: 'Fahrrad',
    dutch: 'fiets',
    afrikaans: 'fiets',
    russian: 'велосипед',
    latvian: 'divritenis',
    polish: 'rower',
    french: 'vélo, bicyclette',
    spanish: 'bicicleta',
  },
  {
    av: 12835,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(bigness, largeness + description indicator: the vertical line extends to the biggest possible size within the symbol square) See also: little, small 15221. ',
    english: 'big, large',
    swedish: 'stor',
    norwegian: 'stor',
    finnish: 'iso, suuri',
    hungarian: 'nagy; nagy méretű, terjedelmű vagy mennyiségű ',
    german: 'groß',
    dutch: 'groot',
    afrikaans: 'groot',
    russian: 'большой',
    latvian: 'liels, milzīgs',
    polish: 'wielki, duży, wysoki',
    french: 'grand',
    spanish: 'grande',
  },
  {
    av: 12836,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(dot + colour + forehead: spot worn on the forehead of Hindu women) (India)',
    english: 'bindi, tika (decoration)',
    swedish: 'bindi, tiki (Indien)',
    norwegian: 'bindi, tiki (India)',
    finnish: 'kastin merkki',
    hungarian: 'bindi, tika (hindu nők homlokdíszítése)',
    german: 'Bindi (Punkt/Schmuckstück auf der Stirn, Indien)',
    dutch: 'bindi (Indisch)',
    afrikaans: 'bindi, tika (versiering)',
    russian: 'бинди (Индия)',
    latvian: 'bindi, tika (Indiešu rotājums)',
    polish: 'bindi, tika (indyjska ozdoba na czole)',
    french: 'bindi (ornement hindou)',
    spanish: 'bindi, tika (decoración)',
  },
  {
    av: 12838,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + protection: bird that is cared for in a domestic setting)',
    english: 'bird (domestic)',
    swedish: 'tamfågel',
    norwegian: 'fugl (tam), tamfugl',
    finnish: 'kotieläin (lintu)',
    hungarian: 'háziszárnyas',
    german: 'Vogel (Haustier), Hausvogel',
    dutch: 'huisvogel, tamme vogel',
    afrikaans: 'mak voël (troeteldier)',
    russian: 'домашняя птица',
    latvian: 'mājputns',
    polish: 'ptak (udomowiony)',
    french: 'oiseau (domestique)',
    spanish: 'ave (doméstica)',
  },
  {
    av: 12839,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + protection + description after the fact indicator)',
    english: 'bird (protected)',
    swedish: 'fridlyst fågel',
    norwegian: 'fugl (fredet)',
    finnish: 'rauhoitettu lintu',
    hungarian: 'védett madár',
    german: 'Vogel (geschützt), beschützter Vogel',
    dutch: 'beschermde vogel',
    afrikaans: 'voël (beskermde spesie)',
    russian: 'охраняемая птица',
    latvian: 'putns (aizsargājams)',
    polish: 'ptak (chroniony)',
    french: 'oiseau (protégé)',
    spanish: 'ave, pájaro (protegida)',
  },
  {
    av: 12841,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + open: untamed bird that lives in the open)',
    english: 'bird (wild)',
    swedish: 'vildfågel',
    norwegian: 'fugl (vill)',
    finnish: 'villilintu',
    hungarian: 'vadon élő madár',
    german: 'wild lebender Vogel',
    dutch: 'wilde vogel',
    afrikaans: 'voël (wild)',
    russian: 'дикая птица',
    latvian: 'savvaļas putns',
    polish: 'ptak (dziki)',
    french: 'oiseau (sauvage)',
    spanish: 'ave (salvaje)',
  },
  {
    av: 12844,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to stop + conception)',
    english: 'birth control',
    swedish: 'födelsekontroll',
    norwegian: 'befruktningshindring, fødselskontroll, prevensjon',
    finnish: 'syntyvyyden säännöstely, ehkäisy',
    hungarian: 'fogamzásgátlás, születésszabályozás',
    german: 'Geburtenregelung, Geburtenkontrolle, Verhütung',
    dutch: 'geboortebeperking',
    afrikaans: 'geboortebeperking',
    russian: 'контрацепция',
    latvian: 'kontracepcija',
    polish: 'antykoncepcja',
    french: 'contraception',
    spanish: 'control de la natalidad',
  },
  {
    av: 12845,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pill + without + egg: pill that prevents the release of an egg)',
    english: 'birth control pill, pill',
    swedish: 'p-piller',
    norwegian: 'p-pille, prevensjonspille',
    finnish: 'ehkäisypilleri',
    hungarian: 'fogamzásgátló tabletta',
    german: 'Antibabypille, Pille',
    dutch: 'anticonceptiepil, de pil',
    afrikaans: 'geboorte beperkings pil',
    russian: 'противозачаточные таблетки',
    latvian: 'pretapaugļošanas tabletes',
    polish: 'pigułki antykoncepcyjnej, pigułka',
    french: 'pilule contraceptive',
    spanish: 'píldora anticonceptiva',
  },
  {
    av: 12846,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(day + birth: day of one's birth)",
    english: 'birthday',
    swedish: 'födelsedag',
    norwegian: 'fødselsdag',
    finnish: 'syntymäpäivä',
    hungarian: 'születésnap',
    german: 'Geburtstag',
    dutch: 'verjaardag',
    afrikaans: 'verjaarsdag',
    russian: 'день рождения',
    latvian: 'dzimšanas diena',
    polish: 'urodziny, dzień urodzin',
    french: 'anniversaire (jour de la naissance)',
    spanish: 'cumpleaños',
  },
  {
    av: 12847,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(teeth + action indicator)',
    english: 'bite-(to)',
    swedish: 'bita',
    norwegian: 'bite',
    finnish: 'purra',
    hungarian: 'harapni',
    german: 'beißen',
    dutch: 'bijten',
    afrikaans: 'byt (om te)',
    russian: 'кусать',
    latvian: 'kost, iekost',
    polish: 'gryźć, wgryzać się',
    french: 'mordre',
    spanish: 'morder',
  },
  {
    av: 12848,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(taste + down + description indicator: unpleasant taste)',
    english: 'bitter',
    swedish: 'besk, bitter (smak)',
    norwegian: 'bitter, besk, sur (smak)',
    finnish: 'karvas, kitkerä',
    hungarian: 'keserű',
    german: 'bitter',
    dutch: 'bitter',
    afrikaans: 'bitter',
    russian: 'горький',
    latvian: 'rūgts',
    polish: 'gorzki',
    french: 'amer, âpre',
    spanish: 'amargo',
  },
  {
    av: 12849,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + night) (BCI) SYMBOL SYNONYM',
    english: 'black (bci)',
    swedish: 'svart',
    norwegian: 'svart',
    finnish: 'musta',
    hungarian: 'fekete',
    german: 'schwarz (BCI)',
    dutch: 'zwart',
    afrikaans: 'swart (bci)',
    russian: 'чёрный',
    latvian: 'melns ',
    polish: 'czarny (BCI)',
    french: 'noir (bci)',
    spanish: 'negro (BCI)',
  },
  {
    av: 12850,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + zero: the absence of colour) (CKB) SYMBOL SYNONYM',
    english: 'black (ckb)',
    swedish: 'svart (CKB)',
    norwegian: 'svart (CKB)',
    finnish: 'musta',
    hungarian: 'fekete (régi CKB-jelkép)',
    german: 'schwarz (CKB)',
    dutch: 'zwart (CKB)',
    afrikaans: 'swart (ckb)',
    russian: 'чёрный',
    latvian: 'melns ',
    polish: 'czarny (CKB)',
    french: 'noir (ckb)',
    spanish: 'negro (CKB)',
  },
  {
    av: 12851,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + black)',
    english: 'blackbird, crow, raven',
    swedish: 'kaja, koltrast, korp (etc)',
    norwegian: 'kråke, ravn, svarttrost (o.l.)',
    finnish: 'mustarastas, varis, korppi',
    hungarian: 'varjú, holló, fekete madár',
    german: 'Amsel, Krähe, Rabe',
    dutch: 'kraai, merel',
    afrikaans: 'kraai, spreeu, swart voël',
    russian: 'ворона, галка, чёрный дрозд',
    latvian: 'melnais strazds, vārna, krauklis',
    polish: 'kos, wrona, kruk (czarny ptak)',
    french: 'corbeau, corneille',
    spanish: 'mirlo, cuervo, ',
  },
  {
    av: 12852,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + to write: panel on which one writes, usually with chalk)',
    english: 'blackboard, chalkboard, whiteboard, writing board',
    swedish: 'skrivtavla',
    norwegian: 'tavle',
    finnish: 'liitutaulu',
    hungarian: 'falitábla, iskolai tábla',
    german: 'Wandtafel, Schultafel, Tafel, Whiteboard',
    dutch: 'whiteboard, schoolbord',
    afrikaans: 'swartbord, witbord, groenbord, skryfbord',
    russian: 'доска, школьная доска',
    latvian: 'tāfele, krīta tāfele, baltā tāfele',
    polish: 'tablica szkolna, tablica do pisania',
    french: 'tableau noir',
    spanish: 'pizarra, pizarrón, tablero',
  },
  {
    av: 12853,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + urine)',
    english: 'bladder',
    swedish: 'urinblåsa',
    norwegian: 'urinblære',
    finnish: 'virtsarakko',
    hungarian: 'hólyag (testrész)',
    german: 'Blase, Urinblase',
    dutch: 'blaas',
    afrikaans: 'blaas',
    russian: 'мочевой пузырь',
    latvian: 'urinpūslis',
    polish: 'pęcherz (moczowy)',
    french: 'vessie',
    spanish: 'vejiga',
  },
  {
    av: 12854,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + protection + bed)',
    english: 'blanket, duvet, quilt',
    swedish: 'filt, pläd, täcke',
    norwegian: 'ullteppe, dyne, sengeteppe',
    finnish: 'huopa, peite, peitto',
    hungarian: 'ágyterítő, ágytakaró, quilt',
    german: 'Bettdecke, Decke',
    dutch: 'deken, dekbed',
    afrikaans: 'deken, duvet, quilt, kombers',
    russian: 'одеяло, плед',
    latvian: 'sega, dūnu sega, vatēta sega ',
    polish: 'koc, pościel, kołdra',
    french: 'couverture, couette, duvet, couvre-lit',
    spanish: 'manta, edredón, acolchado',
  },
  {
    av: 12855,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(blood + action indicator)',
    english: 'bleed-(to)',
    swedish: 'blöda',
    norwegian: 'blø',
    finnish: 'vuotaa verta',
    hungarian: 'vérezni',
    german: 'bluten',
    dutch: 'bloeden',
    afrikaans: 'bloei (om te)',
    russian: 'кровоточить',
    latvian: 'asiņot',
    polish: 'krwawić',
    french: 'saigner',
    spanish: 'sangrar',
  },
  {
    av: 12856,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(blindness + description indicator: unable to see) See also: visually impaired 26033',
    english: 'blind',
    swedish: 'blind',
    norwegian: 'blind',
    finnish: 'sokea',
    hungarian: 'vak (mn.)',
    german: 'blind',
    dutch: 'blind',
    afrikaans: 'blind',
    russian: 'слепой',
    latvian: 'akls',
    polish: 'ślepy, niewidomy',
    french: 'aveugle',
    spanish: 'ciego',
  },
  {
    av: 12858,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation:
      '(part + blissymbol: used with a compound symbol to produce a new meaning, represented by one of the component parts of the compound symbol)',
    english: 'blissymbol part',
    swedish: 'del av blissymbol',
    norwegian: 'del av blissymbol',
    finnish: 'bliss-symbolin osa',
    hungarian: 'Bliss-jelkép része, jelképrész',
    german: 'BLISS-Symbolelement',
    dutch: 'deel van Bliss symbool',
    afrikaans: 'blissimbool gedeelte',
    russian: 'часть блиссимвола',
    latvian: 'bliss simbola daļa',
    polish: 'część symbolu bliss',
    french: 'partie de symbole Bliss',
    spanish: 'parte de símbolo Bliss',
  },
  {
    av: 12859,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(resource centre + blissymbol)',
    english: 'blissymbolics resource centre',
    swedish: 'blissymbolcenter',
    norwegian: 'ressurssenter bliss',
    finnish: 'bliss-symboli resurssikeskus',
    hungarian: 'Bliss Intézet, Bliss-nyelv forrásközpont',
    german: 'Blissymbolics resource centre',
    dutch: 'Bliss-symbolencentrum',
    afrikaans: 'simbool hulpbron sentrum',
    russian: 'ресурсный центр блиссимволики',
    latvian: 'bliss simbolu resursu centrs',
    polish: 'centrum zasobów Systemu Bliss',
    french: 'centre de ressources Bliss',
    spanish: 'centro de recursos de símbolos Bliss',
  },
  {
    av: 12861,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + life: body fluid that sustains life)',
    english: 'blood',
    swedish: 'blod',
    norwegian: 'blod',
    finnish: 'veri',
    hungarian: 'vér',
    german: 'Blut',
    dutch: 'bloed',
    afrikaans: 'bloed',
    russian: 'кровь',
    latvian: 'asinis',
    polish: 'krew',
    french: 'sang',
    spanish: 'sangre',
  },
  {
    av: 12862,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(wind + action indicator)',
    english: 'blow (wind)-(to)',
    swedish: 'blåsa (vind)',
    norwegian: 'blåse (vind)',
    finnish: 'tuulla, puhaltaa',
    hungarian: 'fújni (szél)',
    german: 'blasen, wehen',
    dutch: 'waaien',
    afrikaans: 'waai (wind) (om te)',
    russian: 'дуть (ветер)',
    latvian: 'pūst (vējš)',
    polish: 'wiać (wiatr)',
    french: 'souffler (vent)',
    spanish: 'soplar (viento)',
  },
  {
    av: 12863,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(mouth + wind + action indicator: to use the mouth to make a wind)',
    english: 'blow (mouth)-(to)',
    swedish: 'blåsa',
    norwegian: 'blåse',
    finnish: 'puhaltaa',
    hungarian: 'fújni (szájjal)',
    german: 'pusten',
    dutch: 'blazen',
    afrikaans: 'blaas (mond) (om te)',
    russian: 'дуть (ртом)',
    latvian: 'pūst (ar muti)',
    polish: 'dmuchać (ustami)',
    french: 'souffler',
    spanish: 'soplar (boca)',
  },
  {
    av: 12864,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + sky) (BCI) SYMBOL SYNONYM',
    english: 'blue (bci)',
    swedish: 'blå',
    norwegian: 'blå',
    finnish: 'sininen',
    hungarian: 'kék',
    german: 'blau (BCI)',
    dutch: 'blauw',
    afrikaans: 'blou (bci)',
    russian: 'синий, голубой',
    latvian: 'zils, gaiši zils',
    polish: 'niebieski (BCI)',
    french: 'bleu (bci)',
    spanish: 'azul (BCI)',
  },
  {
    av: 12865,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + 5) (CKB) SYMBOL SYNONYM',
    english: 'blue (ckb)',
    swedish: 'blå (CKB)',
    norwegian: 'blå (CKB)',
    finnish: 'sininen',
    hungarian: 'kék (régi CKB-jelkép)',
    german: 'blau (CKB)',
    dutch: 'blauw (CKB)',
    afrikaans: 'blou (ckb)',
    russian: 'синий, голубой',
    latvian: 'zils, gaiši zils',
    polish: 'niebieski (CKB)',
    french: 'bleu (ckb)',
    spanish: 'azul (CKB)',
  },
  {
    av: 12866,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(berry + blue)',
    english: 'blueberry',
    swedish: 'blåbär',
    norwegian: 'blåbær',
    finnish: 'mustikka',
    hungarian: 'fekete áfonya',
    german: 'Blaubeere, Heidelbeere',
    dutch: 'bosbes',
    afrikaans: 'bloubessie',
    russian: 'черника, голубика',
    latvian: 'mellenes',
    polish: 'borówka amerykańska',
    french: 'myrtille, bleuet (baie)',
    spanish: 'arándano',
  },
  {
    av: 12867,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + blue)',
    english: 'bluebird',
    swedish: 'blåmes',
    norwegian: 'blåmeis, blåstrupe',
    finnish: 'lintu sininen',
    hungarian: 'amerikai barázdabillegető, kékmadár',
    german: 'Blaumeise (Vogel) ',
    dutch: 'blauwe vogel, siali',
    afrikaans: 'Sialia, bluebird',
    russian: 'синица, синяя птица',
    latvian: 'zilais putns, laimes putns',
    polish: 'niebieski ptak (amerykański ptak śpiewający)',
    french: 'oiseau bleu',
    spanish: 'azulejo',
  },
  {
    av: 12871,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(fire + water + intensity + action indicator: to bring water or a liquid to a boil)',
    english: 'boil (food)-(to)',
    swedish: 'koka (mat)',
    norwegian: 'koke (mat)',
    finnish: 'keittää',
    hungarian: 'forralni (ételt)',
    german: 'kochen (Essen)',
    dutch: 'koken in water',
    afrikaans: 'kook (kos) (om te)',
    russian: 'варить',
    latvian: 'vārīt (ēdienu)',
    polish: 'gotować (żywność)',
    french: "cuire à l'eau, faire bouillir",
    spanish: 'hervir (alimento)',
  },
  {
    av: 12872,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(fire + water + intensity + action indicator: to cook in boiling water)',
    english: 'boil (liquid)-(to)',
    swedish: 'koka (vätska)',
    norwegian: 'koke',
    finnish: 'kiehua, kiehuttaa',
    hungarian: 'forralni (folyadékot)',
    german: 'kochen, sieden (Flüssigkeit)',
    dutch: 'water koken',
    afrikaans: 'kook (vloeistof) (om te)',
    russian: 'кипятить',
    latvian: 'vārīt (šķidrumu)',
    polish: 'wrzeć (płyn)',
    french: 'bouillir',
    spanish: 'hervir (líquido)',
  },
  {
    av: 12874,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fire + happiness: a fire to enjoy)',
    english: 'bonfire, barbeque, campfire',
    swedish: 'brasa, bål, lägereld',
    norwegian: 'bål',
    finnish: 'kokko, nuotio, takkatuli',
    hungarian: 'tábortűz, örömtűz, máglya',
    german: 'Lagerfeuer',
    dutch: 'kampvuur',
    afrikaans: 'kampvuur, braaivleisvuur, vreugdevuur',
    russian: 'костёр',
    latvian: 'ugunskurs',
    polish: 'ognisko, grill, barbeque',
    french: 'feu de joie',
    spanish: 'hoguera, fogata',
  },
  {
    av: 12876,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + leg and foot)',
    english: 'boot',
    swedish: 'stövel, stövlar',
    norwegian: 'støvel',
    finnish: 'saapas, saappaat',
    hungarian: 'csizma',
    german: 'Stiefel',
    dutch: 'laarzen',
    afrikaans: 'stewel',
    russian: 'сапог, сапоги',
    latvian: 'zābaks',
    polish: 'buty',
    french: 'botte',
    spanish: 'bota',
  },
  {
    av: 12877,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to receive + limited time + action indicator)',
    english: 'borrow-(to)',
    swedish: 'låna',
    norwegian: 'låne',
    finnish: 'lainata, saada lainaksi',
    hungarian: 'kölcsönözni, kölcsönkérni, kölcsönvenni',
    german: 'leihen, borgen',
    dutch: 'lenen',
    afrikaans: 'leen (om te)',
    russian: 'брать взаймы, занимать',
    latvian: 'aizņemties',
    polish: 'pożyczyć',
    french: 'emprunter',
    spanish: 'prestar',
  },
  {
    av: 12879,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(2 + all: two of all)',
    english: 'both',
    swedish: 'båda',
    norwegian: 'begge',
    finnish: 'molemmat, kumpikin',
    hungarian: 'mindkettő, mindkét',
    german: 'beide',
    dutch: 'beiden',
    afrikaans: 'beide, altwee',
    russian: 'оба, обе',
    latvian: 'abi, abas',
    polish: 'oba',
    french: 'tous les deux',
    spanish: 'ambos',
  },
  {
    av: 12884,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(waste + buttocks)',
    english: 'bowel movement, defecation, shitting, feces, shit, poop',
    swedish: 'avföring, bajs',
    norwegian: 'avføring, bæsj',
    finnish: 'kakka, uloste',
    hungarian: 'széklet (gyermekeknek: kaki, kaka)',
    german: 'Stuhlgang, Scheiße, Kacke',
    dutch: 'stoelgang, poep (Nl)',
    afrikaans: 'stoelgang, ontlasting, poef',
    russian: 'испражнение, дефекация',
    latvian: 'zarnu iztukšošana, defekācija, kakāšana, kakas, mēsli',
    polish: 'wypróżnianie, defekacja, wydalanie',
    french: 'selles, excrément, caca',
    spanish: 'movimiento intestinal, defecación, ',
  },
  {
    av: 12885,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + ball field: sport in which a ball is rolled along the ground)',
    english: 'bowling (activity)',
    swedish: 'bowling (aktivitet)',
    norwegian: 'bowling',
    finnish: 'keilailu',
    hungarian: 'teke, tekézés (játék, sport)',
    german: 'Bowling (Aktivität)',
    dutch: 'bowlen',
    afrikaans: 'rolbal (aktiwiteit)',
    russian: 'боулинг',
    latvian: 'boulings',
    polish: 'gra w kręgle (aktywność)',
    french: 'bowling (activité)',
    spanish: 'bolos (actividad)',
  },
  {
    av: 12887,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + fight)',
    english: 'boxing (activity)',
    swedish: 'boxning (aktivitet)',
    norwegian: 'boksing',
    finnish: 'nyrkkeily',
    hungarian: 'ökölvívás, boksz',
    german: 'Boxen (Aktivität)',
    dutch: 'boksen',
    afrikaans: 'boks (aktiwiteit)',
    russian: 'бокс',
    latvian: 'bokss',
    polish: 'boks (aktywności)',
    french: 'boxe (activité)',
    spanish: 'boxeo (actividad)',
  },
  {
    av: 12889,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + breasts)',
    english: 'bra, brassiere',
    swedish: 'bh',
    norwegian: 'bh',
    finnish: 'rintaliivit',
    hungarian: 'melltartó',
    german: 'Büstenhalter, BH',
    dutch: 'bh',
    afrikaans: 'brassiere, bra, buustelyfie',
    russian: 'бюстгалтер',
    latvian: 'krūšturis',
    polish: 'biustonosz, stanik',
    french: 'soutien-gorge',
    spanish: 'sostén',
  },
  {
    av: 12890,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(support + medical + thing indicator)',
    english: 'medical aid',
    swedish: 'hjälpmedel (medicinskt)',
    norwegian: 'hjelpemiddel (medisinsk), medisinsk hjelpemiddel',
    finnish: 'tuki',
    hungarian: 'gyógyászati segédeszköz (pl. sín, rögzítő kötés)',
    german: 'Hilfsmittel (medizinisch)',
    dutch: 'medisch hulpmiddel',
    afrikaans: 'mediese hulp mediese bystand',
    russian: 'вспомогательное средство (медицинское)',
    latvian: 'medicīnisks palīglīdzeklis',
    polish: 'klamra, zacisk, szyna (medyczne)',
    french: 'aide technique médicale',
    spanish: 'ayuda médica',
  },
  {
    av: 12891,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(prayer + comma + little (Hebrew))',
    english: 'bracha, berakah, prayer (small)',
    swedish: 'bracha, liten bön (Israel)',
    norwegian: 'bracha, liten bønn (Israel)',
    finnish: 'rukous',
    hungarian: 'rövid áldás, rövid ima (héber)',
    german: 'Bracha, Gebet (klleines)',
    dutch: 'schietgebedje',
    afrikaans: 'skietgebed, gebed',
    russian: 'браха (еврейская молитва)',
    latvian: 'braha (ebreju lūgšana)',
    polish: 'forma modlitwy (hebrajskie)',
    french: 'berakhah (bénédiction juive)',
    spanish: 'Bracha, pequeña plegaria (Israel)',
  },
  {
    av: 12892,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(god + creation: Hindu god for the creator) (India)',
    english: 'Brahma',
    swedish: 'Brahma (Indien)',
    norwegian: 'Brahma (India)',
    finnish: 'Brahma, luojajumala',
    hungarian: 'Brahma (hindu teremtésIsten; India)',
    german: 'Brahma',
    dutch: 'Brahama (Indisch)',
    afrikaans: 'Brahma',
    russian: 'Брахма (Индия)',
    latvian: 'Brahma',
    polish: 'Brahma (bóg indyjski)',
    french: 'Brahma (hindouisme)',
    spanish: 'Brahma',
  },
  {
    av: 12893,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + thing indicator: organ of the body. The symbol is the concrete form of mind.) - (character with thing indicator)',
    english: 'brain',
    swedish: 'hjärna',
    norwegian: 'hjerne',
    finnish: 'aivot',
    hungarian: 'agy',
    german: 'Gehirn',
    dutch: 'hersenen',
    afrikaans: 'brein',
    russian: 'мозг',
    latvian: 'smadzenes',
    polish: 'mózg',
    french: 'cerveau',
    spanish: 'cerebro',
  },
  {
    av: 12896,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(break, fracture, injury, damage + action indicator)',
    english: 'break, crack, fracture, tear, injure, damage-(to)',
    swedish: 'gå sönder, ha sönder, bryta',
    norwegian: 'ødelegge, brekke',
    finnish: 'katkaista, rikkoa, särkyä',
    hungarian: 'törni, repedni, tépni (el-, meg-, be-, ki-, össze-, szét)',
    german: 'zerbrechen, bechen, reißen',
    dutch: 'breken',
    afrikaans: 'breuk, fraktuur, kraak, skeur (om te)',
    russian: 'ломать',
    latvian: 'salauzt, lauzt, lūzums',
    polish: 'łamać, przełamywać',
    french: 'casser, briser, fracturer, déchirer',
    spanish: 'romper, fracturar, rasgar',
  },
  {
    av: 12897,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(break, fracture, injury, damage + description before the fact indicator)',
    english: 'breakable, fragile, vulnerable',
    swedish: 'ömtålig, skör',
    norwegian: 'skjør, ømtålig',
    finnish: 'särkyvä',
    hungarian: 'törékeny',
    german: 'zerbrechlich, fragil',
    dutch: 'breekbaar',
    afrikaans: 'breekbaar',
    russian: 'хрупкий, ломкий',
    latvian: 'trausls, lūstošs',
    polish: 'łamliwe, kruche',
    french: 'cassable, fragile',
    spanish: 'rompible, frágil',
  },
  {
    av: 12898,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meal + 1: first meal of the day)',
    english: 'breakfast',
    swedish: 'frukost',
    norwegian: 'frokost',
    finnish: 'aamiainen',
    hungarian: 'reggeli',
    german: 'Frühstück',
    dutch: 'ontbijt',
    afrikaans: 'ontbyt',
    russian: 'завтрак',
    latvian: 'brokastis',
    polish: 'śniadanie',
    french: 'petit déjeuner',
    spanish: 'desayuno',
  },
  {
    av: 12900,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(nose + mouth: mouth and nose are both used in breathing)',
    english: 'breath, breathing, respiration',
    swedish: 'andedräkt, andning',
    norwegian: 'pust, åndedrett',
    finnish: 'hengitys',
    hungarian: 'lélegzet',
    german: 'Atem',
    dutch: 'adem',
    afrikaans: 'asem',
    russian: 'дыхание',
    latvian: 'elpa',
    polish: 'oddech',
    french: 'respiration',
    spanish: 'respiración',
  },
  {
    av: 12901,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(breath + action indicator)',
    english: 'breathe-(to)',
    swedish: 'andas',
    norwegian: 'puste, ånde',
    finnish: 'hengittää',
    hungarian: 'lélegezni',
    german: 'atmen',
    dutch: 'ademen',
    afrikaans: 'asemhaal (om te)',
    russian: 'дышать',
    latvian: 'elpot',
    polish: 'oddychać',
    french: 'respirer',
    spanish: 'respirar',
  },
  {
    av: 12903,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(light + intensity + description indicator)',
    english: 'bright',
    swedish: 'ljusstark, bländande, lysande, skinande',
    norwegian: 'lys, lysende, lyssterk',
    finnish: 'kirkas',
    hungarian: 'fényes, ragyogó',
    german: 'hell, glänzend, scheinend',
    dutch: 'stralend, helder',
    afrikaans: 'helder, stralend',
    russian: 'яркий, светлый',
    latvian: 'gaišs',
    polish: 'jasny',
    french: 'brillant, clair, lumineux',
    spanish: 'brillante',
  },
  {
    av: 12904,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to carry + forward + reference line + action indicator: to carry toward a given location)',
    english: 'bring-(to)',
    swedish: 'flytta, hämta, komma med',
    norwegian: 'bringe, flytte',
    finnish: 'viedä, tuoda',
    hungarian: 'hozni (el-, meg-), célbajuttatni',
    german: 'bringen',
    dutch: 'brengen',
    afrikaans: 'bring (om te)',
    russian: 'привозить, доставлять',
    latvian: 'atnest',
    polish: 'przywieźć, dowieźć, dotransportować',
    french: 'apporter, amener',
    spanish: 'traer',
  },
  {
    av: 12905,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cabbage + flower + green: cabbage with green flowerets)',
    english: 'broccoli',
    swedish: 'broccoli',
    norwegian: 'broccoli',
    finnish: 'parsakaali',
    hungarian: 'brokkoli',
    german: 'Brokkoli',
    dutch: 'broccoli',
    afrikaans: 'brokkoli',
    russian: 'брокколи',
    latvian: 'brokoļi',
    polish: 'brokuły',
    french: 'brocoli',
    spanish: 'brócoli',
  },
  {
    av: 12906,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cook + intensity + action indicator: to cook with intense heat)',
    english: 'broil, barbecue, grill-(to)',
    swedish: 'grilla',
    norwegian: 'grille',
    finnish: 'grillata, paahtaa',
    hungarian: 'grillezni, roston / nyárson sütni',
    german: 'grillen',
    dutch: 'barbecuen, grillen',
    afrikaans: 'braai, rooster (om te)',
    russian: 'жарить',
    latvian: 'cept, grillēt',
    polish: 'grillować, smażyć na ruszcie',
    french: 'griller',
    spanish: 'asar, cocinar a la parrilla',
  },
  {
    av: 12907,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(break, fracture, injury, damage + description after the fact indicator)',
    english: 'broken, injured, damaged',
    swedish: 'trasig, sönder, avbruten',
    norwegian: 'ødelagt, i stykker, brutt',
    finnish: 'rikki, särkynyt',
    hungarian: 'törött',
    german: 'kaputt, entzwei, zerbrochen, gebrochen',
    dutch: 'gebroken, kapot, stuk',
    afrikaans: 'gebreek, stukkend',
    russian: 'сломанный',
    latvian: 'salauzts, salauzta',
    polish: 'złamany, połamany, rozbity',
    french: 'cassé',
    spanish: 'roto',
  },
  {
    av: 12909,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(son + 2: a son considered in relation to another child of his parents)',
    english: 'brother',
    swedish: 'bror',
    norwegian: 'bror',
    finnish: 'veli',
    hungarian: 'fiútestvér, báty, öccs',
    german: 'Bruder',
    dutch: 'broer',
    afrikaans: 'broer, boetie, boeta',
    russian: 'брат',
    latvian: 'brālis',
    polish: 'brat',
    french: 'frère',
    spanish: 'hermano',
  },
  {
    av: 12910,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + earth) (BCI) SYMBOL SYNONYM',
    english: 'brown (bci)',
    swedish: 'brun',
    norwegian: 'brun',
    finnish: 'ruskea',
    hungarian: 'barna',
    german: 'braun (BCI)',
    dutch: 'bruin',
    afrikaans: 'bruin (bci)',
    russian: 'коричневый',
    latvian: 'zemes krāsa, brūna krāsa',
    polish: 'brązowy (BCI)',
    french: 'brun (bci)',
    spanish: 'marrón (BCI)',
  },
  {
    av: 12911,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation:
      '(colour + 1 + comma + 0: combination of red and black) (CKB) SYMBOL SYNONYM',
    english: 'brown (ckb)',
    swedish: 'brun (CKB)',
    norwegian: 'brun (CKB)',
    finnish: 'ruskea',
    hungarian: 'barna (régi CKB-jelkép)',
    german: 'braun (CKB)',
    dutch: 'bruin (CKB)',
    afrikaans: 'bruin (ckb)',
    russian: 'коричневый (Ч.Б.)',
    latvian: 'zemes krāsa, brūna krāsa',
    polish: 'brązowy (CKB)',
    french: 'brun (ckb)',
    spanish: 'marrón (CKB)',
  },
  {
    av: 12913,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(brush + action indicator)',
    english: 'brush-(to)',
    swedish: 'borsta',
    norwegian: 'børste (å)',
    finnish: 'harjata',
    hungarian: 'kefélni (át-, ki-, le-)',
    german: 'bürsten, kehren, fegen',
    dutch: 'borstelen, boenen, kuisen, vegen',
    afrikaans: 'borsel (om te)',
    russian: 'чистить',
    latvian: 'tīrīt',
    polish: 'szczotkować, pędzlować',
    french: 'brosser',
    spanish: 'cepillar',
  },
  {
    av: 12914,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(toothbrush + action indicator)',
    english: 'brush teeth-(to)',
    swedish: 'borsta tänderna',
    norwegian: 'pusse tennene',
    finnish: 'harjata hampaat',
    hungarian: 'fogat mosni',
    german: 'Zähne putzen',
    dutch: 'tandenpoetsen',
    afrikaans: 'borsel tande, tande borsel (om te)',
    russian: 'чистить зубы',
    latvian: 'tīrīt zobus',
    polish: 'myć zęby szczotką, szczotkować',
    french: 'brosser les dents-(se)',
    spanish: 'cepillarse los dientes',
  },
  {
    av: 12915,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cabbage + little)',
    english: 'brussels sprout(s)',
    swedish: 'brysselkål',
    norwegian: 'rosenkål',
    finnish: 'ruusukaali',
    hungarian: 'kelbimbó',
    german: 'Rosenkohl',
    dutch: 'spruitjes',
    afrikaans: 'brusselse spruite',
    russian: 'капуста брюссельская',
    latvian: 'Briseles kāposti',
    polish: 'brukselka',
    french: 'chou de Bruxelles',
    spanish: 'col de Bruselas',
  },
  {
    av: 12920,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bovine + male)',
    english: 'bull',
    swedish: 'tjur',
    norwegian: 'okse, tyr',
    finnish: 'härkä, sonni',
    hungarian: 'bika',
    german: 'Bulle, Stier',
    dutch: 'stier',
    afrikaans: 'bul',
    russian: 'бык',
    latvian: 'bullis',
    polish: 'byk',
    french: 'taureau',
    spanish: 'toro',
  },
  {
    av: 12921,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bovine + to fight)',
    english: 'bull (fighting)',
    swedish: 'tjur (för tjurfäktning)',
    norwegian: 'kampokse, tyr',
    finnish: 'härkä (taistelu-)',
    hungarian: 'bikaviadal',
    german: 'Kampfstier',
    dutch: 'stier (vechten)',
    afrikaans: 'bul vegter, stiervegter',
    russian: 'бык (коррида)',
    latvian: 'vēršu cīņas',
    polish: 'walka byków, corrida',
    french: 'taureau (de combat)',
    spanish: 'toreo',
  },
  {
    av: 12922,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(fire + action indicator)',
    english: 'burn-(to)',
    swedish: 'brinna, bränna',
    norwegian: 'brenne',
    finnish: 'palaa, polttaa',
    hungarian: 'égni',
    german: 'brennen',
    dutch: 'branden',
    afrikaans: 'brand (om te)',
    russian: 'гореть, жечь',
    latvian: 'dedzināt',
    polish: 'palić',
    french: 'brûler',
    spanish: 'quemar',
  },
  {
    av: 12923,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(fire + description after the fact indicator)',
    english: 'burned, burnt',
    swedish: 'bränd',
    norwegian: 'brent',
    finnish: 'palanut, poltettu',
    hungarian: 'égett',
    german: 'verbrannt',
    dutch: 'verbrand',
    afrikaans: 'verbrand, verbrande',
    russian: 'сгоревший, обожжённый',
    latvian: 'apdedzis, apdedzināts',
    polish: 'spalony',
    french: 'brûlé, incendié',
    spanish: 'quemado',
  },
  {
    av: 12924,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(fire + description indicator)',
    english: 'burning',
    swedish: 'brinnande',
    norwegian: 'brennende',
    finnish: 'palava, hehkuva',
    hungarian: 'égő',
    german: 'brennend',
    dutch: 'brandend, vurig',
    afrikaans: 'brand, brandende',
    russian: 'горящий, огненный',
    latvian: 'degošs, liesmojošs',
    polish: 'palony, spalony',
    french: 'brûlé',
    spanish: 'ardiente',
  },
  {
    av: 12925,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(wind + out of body (upward) + action indicator: to expel wind from the stomach)',
    english: 'burp, belch-(to)',
    swedish: 'rapa',
    norwegian: 'rape',
    finnish: 'röyhtäistä',
    hungarian: 'büfögni, böfögni',
    german: 'aufstoßen, rülpsen',
    dutch: 'boeren (lucht), oprispen',
    afrikaans: 'winde opbreek, wind opbreek (om te)',
    russian: 'отрыгивать',
    latvian: 'atraugāties',
    polish: 'bekać, czkać',
    french: 'roter',
    spanish: 'eructar',
  },
  {
    av: 12926,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(grave + action indicator: to lay to rest below the earth)',
    english: 'bury (person)-(to)',
    swedish: 'begrava (person)',
    norwegian: 'begrave',
    finnish: 'haudata',
    hungarian: 'temetni, eltemetni',
    german: 'beerdigen',
    dutch: 'begraven',
    afrikaans: 'begrawe, ter aarde bestel (om te)',
    russian: 'хоронить',
    latvian: 'apglabāt',
    polish: 'pogrzebać, pochować (osoba)',
    french: 'enterrer (personne)',
    spanish: 'enterrar (a una persona)',
  },
  {
    av: 13091,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + bus)',
    english: 'bus driver',
    swedish: 'busschaufför',
    norwegian: 'bussjåfør',
    finnish: 'linja-auton kuljettaja',
    hungarian: 'buszsofőr',
    german: 'Busfahrerin, Busfahrer',
    dutch: 'buschauffeur',
    afrikaans: 'busdrywer',
    russian: 'водитель автобуса',
    latvian: 'autobusa vadītajs',
    polish: 'kierowca autobusu',
    french: 'chauffeur de bus',
    spanish: 'conductor de autobús',
  },
  {
    av: 13095,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spread + cream: spread made from cream)',
    english: 'butter',
    swedish: 'smör',
    norwegian: 'smør',
    finnish: 'voi',
    hungarian: 'vaj',
    german: 'Butter',
    dutch: 'boter',
    afrikaans: 'botter',
    russian: 'масло',
    latvian: 'sviests',
    polish: 'masło',
    french: 'beurre',
    spanish: 'mantequilla',
  },
  {
    av: 13098,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(disc + clothing)',
    english: 'button, gripper, snap',
    swedish: 'knapp',
    norwegian: 'knapp',
    finnish: 'nappi, neppari',
    hungarian: 'gomb, kapocs, ruhát összefogó egyéb csat, patent',
    german: 'Knopf, Verschluss',
    dutch: 'knoop',
    afrikaans: 'knoop',
    russian: 'пуговица',
    latvian: 'poga, spiedpoga, aizdare',
    polish: 'guzik, nap, zatrzask (przy ubraniu)',
    french: 'bouton',
    spanish: 'botón',
  },
  {
    av: 13099,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(money + thing + action indicator: first you must have money, which you can then spend to buy something)',
    english: 'buy, purchase-(to)',
    swedish: 'köpa, handla',
    norwegian: 'kjøpe, handle',
    finnish: 'ostaa',
    hungarian: 'vásárolni, venni valamit',
    german: 'kaufen, einkaufen',
    dutch: 'kopen',
    afrikaans: 'koop, aankoop (om te)',
    russian: 'покупать',
    latvian: 'pirkt, iegādāties',
    polish: 'kupować, zakupić',
    french: 'acheter',
    spanish: 'comprar',
  },
  {
    av: 13102,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + little)',
    english: 'cabin, cottage, hut',
    swedish: 'stuga',
    norwegian: 'hytte',
    finnish: 'mökki, maja, tupa',
    hungarian: 'házikó, kalyiba, kunyhó, faház, kis nyaraló',
    german: 'Häuschen, Hütte',
    dutch: 'hut, huisje',
    afrikaans: 'hut, huisie',
    russian: 'домик, дача',
    latvian: 'māja, vasarnīca, būda',
    polish: 'domek, chatka, altana',
    french: 'cabane, cabine, chalet',
    spanish: 'cabina',
  },
  {
    av: 13103,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to remove + medical + fetus)',
    english: 'caesarean section, C-section',
    swedish: 'kejsarsnitt',
    norwegian: 'keisersnitt',
    finnish: 'keisarinleikkaus',
    hungarian: 'császármetszés',
    german: 'Kaiserschnitt',
    dutch: 'keizersnede',
    afrikaans: 'keisersnit',
    russian: 'кесарево сечение',
    latvian: 'ķeizargrieziens',
    polish: 'cesarskie cięcie',
    french: 'césarienne',
    spanish: 'cesárea',
  },
  {
    av: 13104,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(public room + snack)',
    english: 'cafe, coffee house, snack bar',
    swedish: 'kafé, konditori',
    norwegian: 'kafé, kaffebar',
    finnish: 'kahvila',
    hungarian: 'kávézó, teázó, snack bár',
    german: 'Kaffee',
    dutch: 'cafetaria, snackbar',
    afrikaans: 'kafee, snoepie, koffiekroeg, kafeteria',
    russian: 'кафе',
    latvian: 'kafija, kafijas nams, uzkodu bārs',
    polish: 'kawiarnia, snack bar',
    french: 'café, snack-bar',
    spanish: 'café, cafetería, bar',
  },
  {
    av: 13105,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure + pictograph of a barred window: enclosed space with bars that prevent escape)',
    english: 'cage',
    swedish: 'bur, cell',
    norwegian: 'celle, bur',
    finnish: 'häkki',
    hungarian: 'ketrec',
    german: 'Käfig',
    dutch: 'kooi',
    afrikaans: 'hok',
    russian: 'клетка, камера',
    latvian: 'būris, ieslodzījuma kamera',
    polish: 'klatka',
    french: 'cage',
    spanish: 'jaula',
  },
  {
    av: 13106,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bread + sweet)',
    english: 'cake, bread with sugar',
    swedish: 'sockerkaka, mjuk kaka, kaffebröd',
    norwegian: 'kake',
    finnish: 'kakku',
    hungarian: 'sütemény, édestészta, süti',
    german: 'Kuchen',
    dutch: 'taart',
    afrikaans: 'koek, suikerbrood, tert',
    russian: 'торт, сладкая сдоба',
    latvian: 'torte, kūka, smalkmaizīte',
    polish: 'ciastko, placek',
    french: 'gâteau, cake',
    spanish: 'pastel, torta',
  },
  {
    av: 13107,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(digital processing, artificial intelligence, calculation + action indicator: to think using numbers)',
    english: 'calculate-(to)',
    swedish: 'beräkna, räkna ut',
    norwegian: 'beregne, regne ut, kalkulere',
    finnish: 'laskea, arvioida',
    hungarian: 'számolni, kiszámolni',
    german: 'rechnen, ausrechnen',
    dutch: 'rekenen',
    afrikaans: 'bereken (om te)',
    russian: 'вычислять (математика)',
    latvian: 'matematiski saskaitīt',
    polish: 'obliczać (cyfrowo, na komputerze itp.)',
    french: 'calculer',
    spanish: 'calcular',
  },
  {
    av: 13108,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to calculate)',
    english: 'calculator',
    swedish: 'räknare',
    norwegian: 'regnemaskin, kalkulator',
    finnish: 'laskin, laskukone',
    hungarian: 'számológép, kalkulátor',
    german: 'Taschenrechner',
    dutch: 'rekenmachine',
    afrikaans: 'sakrekenaar',
    russian: 'калькулятор',
    latvian: 'kalkulaors',
    polish: 'kalkulator',
    french: 'calculatrice',
    spanish: 'calculadora',
  },
  {
    av: 13109,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(page + day + month)',
    english: 'calendar',
    swedish: 'almanacka, kalender',
    norwegian: 'kalender, almanakk',
    finnish: 'kalenteri',
    hungarian: 'naptár, kalendárium',
    german: 'Kalender',
    dutch: 'kalender',
    afrikaans: 'kalender, almanak',
    russian: 'календарь',
    latvian: 'kalendārs',
    polish: 'kalendarz',
    french: 'calendrier',
    spanish: 'calendario',
  },
  {
    av: 13112,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(gathering + countryside + limited time: temporary gathering in the country)',
    english: 'camp',
    swedish: 'läger',
    norwegian: 'leir',
    finnish: 'leiri',
    hungarian: 'tábor',
    german: 'Ferienlager',
    dutch: 'kamp',
    afrikaans: 'kamp',
    russian: 'лагерь',
    latvian: 'treileru parks',
    polish: 'obóz',
    french: 'camp, campement',
    spanish: 'campamento',
  },
  {
    av: 13114,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(ability (half sized) + action indicator)',
    english: 'can, be able-(to)',
    swedish: 'kunna',
    norwegian: 'kunne, være i stand til',
    finnish: 'kyetä, osata, voida',
    hungarian: 'képesnek lenni valamire (-hat, -het)',
    german: 'können',
    dutch: 'kunnen',
    afrikaans: 'kan, in staat om (om te)',
    russian: 'мочь, уметь',
    latvian: 'spēt, varēt, būt spējīgam',
    polish: 'może być w stanie, zdolny',
    french: 'être capable de, pouvoir',
    spanish: 'poder, ser capaz de',
  },
  {
    av: 13116,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + maple leaf)',
    english: 'Canada',
    swedish: 'Kanada',
    norwegian: 'Canada',
    finnish: 'Kanada',
    hungarian: 'Kanada',
    german: 'Kanada',
    dutch: 'Canada',
    afrikaans: 'Kanada',
    russian: 'Канада',
    latvian: 'Kanāda',
    polish: 'Kanada',
    french: 'Canada',
    spanish: 'Canadá',
  },
  {
    av: 13117,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + fire + light + thing indicator)',
    english: 'candle',
    swedish: 'stearinljus',
    norwegian: 'stearinlys',
    finnish: 'kynttilä',
    hungarian: 'gyertya',
    german: 'Kerze',
    dutch: 'kaars',
    afrikaans: 'kers',
    russian: 'свеча',
    latvian: 'svece',
    polish: 'świeca',
    french: 'bougie, chandelle',
    spanish: 'vela',
  },
  {
    av: 13119,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(linear thing + to walk + thing indicator: linear thing used to help a person walk) ',
    english: 'cane, stick, walking stick',
    swedish: 'käpp',
    norwegian: 'stokk, gåstav',
    finnish: 'kävelykeppi',
    hungarian: 'sétabot, sétapálca, bot',
    german: 'Spazierstock, Stock',
    dutch: 'wandelstok',
    afrikaans: 'kierie, wandelstok, stok',
    russian: 'трость, палка',
    latvian: 'nūja, spieķis, soļošanas nūjas',
    polish: 'laska, kijek do podparcia przy chodzeniu',
    french: 'canne',
    spanish: 'caña, palo, bastón',
  },
  {
    av: 13122,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + to play + plural indicator)',
    english: 'cards, playing cards',
    swedish: 'spelkort',
    norwegian: 'spillkort',
    finnish: 'pelikortit',
    hungarian: 'kártya, játékkártya',
    german: 'Spielkarte, Karten',
    dutch: 'kaarten (spel), speelkaarten',
    afrikaans: 'kaarte speel kaarte',
    russian: 'игральные карты',
    latvian: 'spēļu kārtis',
    polish: 'karty, karty do gry',
    french: 'jeu de cartes',
    spanish: 'tarjetas, cartas',
  },
  {
    av: 13123,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(observation + intensity + intensity + description indicator: also a combination of to observe and attention)',
    english: 'careful',
    swedish: 'försiktig, noggrann',
    norwegian: 'forsiktig, omhyggelig',
    finnish: 'varovainen, huolellinen',
    hungarian: 'óvatos, figyelmes',
    german: 'vorsichtig, genau, sorgfältig, umsichtig',
    dutch: 'voorzichtig',
    afrikaans: 'versigtig',
    russian: 'осторожный, бдительный',
    latvian: 'uzmanīgs, piesardzīgs',
    polish: 'ostrożny, uważny (bardzo)',
    french: 'prudent, attentif',
    spanish: 'cuidadoso',
  },
  {
    av: 13125,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(transport, transportation + action indicator: to move something by vehicle). See also: take, bring, carry, move-(to) 17497',
    english: 'carry, move, transport-(to)',
    swedish: 'förflytta, transportera',
    norwegian: 'bære, transportere',
    finnish: 'kantaa, siirtää, kuljettaa',
    hungarian: 'szállítani, transzportálni, költözni',
    german: 'tragen, transportieren',
    dutch: 'vervoeren, verplaatsen',
    afrikaans: 'vervoer, dra, skuif (om te)',
    russian: 'перевозить',
    latvian: 'pārvietot, transportēt',
    polish: 'przewozić, przemieszczać, transportować',
    french: 'transporter',
    spanish: 'llevar, mover, transportar',
  },
  {
    av: 13126,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + baby: holder for a baby)',
    english: 'carrycot, bassinet',
    swedish: 'babykorg (etc)',
    norwegian: 'babykurv',
    finnish: 'vauvan kantokassi',
    hungarian: 'mózeskosár, bölcső, egyéb „fiahordó”',
    german: 'Tragebettchen, Babytragetasche',
    dutch: 'wieg',
    afrikaans: 'wieg, babawieg, drabed',
    russian: 'люлька, корзина-переноска',
    latvian: 'gultiņa, grozs mazbērna pārnēsāšanai',
    polish: 'nosidełko, kołyska pleciona, chusta do noszenia dziecka',
    french: 'couffin, porte-bébé',
    spanish: 'capazo, cuna portátil',
  },
  {
    av: 13129,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + medical + body: medical enclosure for the body)',
    english: 'plaster cast, cast (medical)',
    swedish: 'stödkorsett (gjuten)',
    norwegian: 'støttekorsett (støpt)',
    finnish: 'kipsi',
    hungarian: 'gipsz (gyógyászati)',
    german: 'Gipsverband, Gips',
    dutch: 'gips',
    afrikaans: 'gips, stut (medies)',
    russian: 'корсет (медицинский)',
    latvian: 'medicīniskā korsete',
    polish: 'gorset',
    french: 'plâtre',
    spanish: 'escayola (medicina)',
  },
  {
    av: 13131,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hand + to receive + action indicator)',
    english: 'catch, grab-(to)',
    swedish: 'ta, fånga',
    norwegian: 'gripe, fange',
    finnish: 'ottaa, ottaa kiinni',
    hungarian: 'fogni, megfogni, megragadni, megmarkolni',
    german: 'fangen, auffangen',
    dutch: 'vangen',
    afrikaans: 'vang, gryp (om te)',
    russian: 'брать, ловить',
    latvian: 'ķert, saķert',
    polish: 'łowić, chwytać',
    french: 'attraper, saisir',
    spanish: 'coger',
  },
  {
    av: 13132,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(worm + butterfly: larva of the butterfly)',
    english: 'caterpillar',
    swedish: 'larv',
    norwegian: 'larve',
    finnish: 'toukka',
    hungarian: 'hernyó',
    german: 'Raupe',
    dutch: 'rups',
    afrikaans: 'ruspe',
    russian: 'гусеница, личинка',
    latvian: 'kāpurs',
    polish: 'gąsienica, liszka',
    french: 'chenille',
    spanish: 'oruga',
  },
  {
    av: 13133,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cabbage + flower: cabbage with flowerets)',
    english: 'cauliflower',
    swedish: 'blomkål',
    norwegian: 'blomkål',
    finnish: 'kukkakaali',
    hungarian: 'karfiol',
    german: 'Blumenkohl',
    dutch: 'bloemkool',
    afrikaans: 'blomkool',
    russian: 'капуста цветная',
    latvian: 'pūķkāposts',
    polish: 'kalafior',
    french: 'chou-fleur',
    spanish: 'coliflor',
  },
  {
    av: 13135,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(cause + action indicator)',
    english: 'cause-(to)',
    swedish: 'orsaka',
    norwegian: 'forårsake',
    finnish: 'aiheuttaa',
    hungarian: 'okozni, előidézni',
    german: 'verursachen, auslösen',
    dutch: 'veroorzaken',
    afrikaans: 'veroorsaak (om te)',
    russian: 'причинять, вызывать',
    latvian: 'izsaukt, dot ieganstu',
    polish: 'powodować, przyczyniać się',
    french: 'causer. provoquer, occasionner',
    spanish: 'causar',
  },
  {
    av: 13136,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(cause + passive indicator)',
    english: 'be caused by-(to)',
    swedish: 'orsakas av',
    norwegian: 'bli forårsaket av',
    finnish: 'aiheutua, johtua',
    hungarian: 'okozott, előidézett (valami által; angol szenvedő szerk.)',
    german: 'verursacht (durch), ausgelöst (durch)',
    dutch: 'veroorzaakt door',
    afrikaans: 'veroorsaak deur (om te)',
    russian: 'причинён, вызван',
    latvian: 'būt par cēloni, ieganstu',
    polish: 'być spowodowane przez (czynność)',
    french: 'causé par, provoqué par',
    spanish: 'causado por',
  },
  {
    av: 13137,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hole + mountain: hole in a mountainside)',
    english: 'cave',
    swedish: 'grotta',
    norwegian: 'hule, grotte',
    finnish: 'luola',
    hungarian: 'barlang',
    german: 'Höhle',
    dutch: 'grot',
    afrikaans: 'grot',
    russian: 'пещера',
    latvian: 'ala',
    polish: 'jaskinia',
    french: 'caverne, grotte',
    spanish: 'cueva',
  },
  {
    av: 13141,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + sexual intercourse)',
    english: 'celibacy, chastity',
    swedish: 'kyskhet, oskuld',
    norwegian: 'sølibat',
    finnish: 'selibaatti, siveys',
    hungarian: 'önmegtartóztatás, szűziesség, absztinencia',
    german: 'Zölibat',
    dutch: 'celibaat',
    afrikaans: 'selibaatheid',
    russian: 'целомудрие',
    latvian: 'celibāts, šķīstība',
    polish: 'celibat, cnota',
    french: 'célibat, chasteté',
    spanish: 'celibato, castidad',
  },
  {
    av: 13142,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + grave)',
    english: 'cemetery',
    swedish: 'kyrkogård, begravningsplats',
    norwegian: 'kirkegård, gravplass, gravlund',
    finnish: 'hautausmaa',
    hungarian: 'temető',
    german: 'Friedhof',
    dutch: 'begraafplaats, kerkhof',
    afrikaans: 'begraafplaas',
    russian: 'кладбище',
    latvian: 'kapi',
    polish: 'cmentarz',
    french: 'cimetière',
    spanish: 'cementerio',
  },
  {
    av: 13144,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(100 + year: period of one hundred years)',
    english: 'century',
    swedish: 'århundrade, sekel',
    norwegian: 'århundre, sekel',
    finnish: 'vuosisata',
    hungarian: 'évszázad',
    german: 'Jahrhundert',
    dutch: 'eeuw',
    afrikaans: 'eeu',
    russian: 'столетие, век',
    latvian: 'gadsimts',
    polish: 'wiek (100 lat)',
    french: 'siècle',
    spanish: 'siglo',
  },
  {
    av: 13147,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + uterus)',
    english: 'cervix',
    swedish: 'livmoderhals',
    norwegian: 'livmorhals',
    finnish: 'kohdunkaula',
    hungarian: 'méhnyak',
    german: 'Gebärmutterhals',
    dutch: 'baarmoederhals',
    afrikaans: 'serviks',
    russian: 'шейка матки',
    latvian: 'dzemdes kakls',
    polish: 'szyjka macicy',
    french: "col de l'utérus",
    spanish: 'cerviz',
  },
  {
    av: 13149,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bread + Sabbath: traditional bread eaten on the Sabbath (Hebrew))',
    english: 'challah',
    swedish: 'challah (Israel)',
    norwegian: 'challah (Israel)',
    finnish: 'challah-leipä',
    hungarian: 'kalács (challah; héber)',
    german: 'Challa, Schabbat-Brot',
    dutch: 'challah (Joods)',
    afrikaans: 'challah',
    russian: 'хала (Израиль)',
    latvian: 'hala (ebreju īpašas maizes šķēle)',
    polish: 'chałka (świąteczne pieczywo, rodzaj słodkiej bułki w formie warkocza)',
    french: 'challah',
    spanish: 'jalá',
  },
  {
    av: 13150,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lizard + to change: lizard that is able to change colour)',
    english: 'chameleon',
    swedish: 'kameleont',
    norwegian: 'kameleon',
    finnish: 'kameleontti',
    hungarian: 'kaméleon',
    german: 'Chamäleon',
    dutch: 'kameleon',
    afrikaans: 'verkleurmannetjie',
    russian: 'хамелеон',
    latvian: 'hameleons',
    polish: 'kameleon',
    french: 'caméléon',
    spanish: 'camaleón',
  },
  {
    av: 13152,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(change + action indicator)',
    english: 'change, alter, convert-(to)',
    swedish: 'ändra, växla',
    norwegian: 'forandre, endre',
    finnish: 'muuttua',
    hungarian: 'változni, változtatni, átalakulni, átalakítani, módosítani',
    german: 'wechseln, ändern, verändern',
    dutch: 'veranderen',
    afrikaans: 'verander (om te)',
    russian: 'изменять',
    latvian: 'mainīt, izmainīt',
    polish: 'zmieniać',
    french: 'changer',
    spanish: 'cambiar, alterar',
  },
  {
    av: 13153,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(holiday + light: holiday of lights (Hebrew))',
    english: 'Chanukah, Hanukkah',
    swedish: 'Chanukah (Israel)',
    norwegian: 'Chanukah (Israel)',
    finnish: 'hanukka, valon juhla',
    hungarian: 'Hanuka (héber)',
    german: 'Chanukah, Hannuka',
    dutch: 'Chanukah (Joods)',
    afrikaans: 'Chanukah, Hanukkah',
    russian: 'Ханука (Израиль)',
    latvian: 'Hanuka (ebreju svētki)',
    polish: 'Chanuka (święto hebrajskie)',
    french: 'Hanoukkah',
    spanish: 'Janucá',
  },
  {
    av: 13154,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(help + needy person + feeling)',
    english: 'charity',
    swedish: 'hjälpverksamhet, välgörenhet',
    norwegian: 'veldedighet',
    finnish: 'hyväntekeväisyys, lähimmäisenrakkaus',
    hungarian: 'jótékonyság, jótett',
    german: 'Wohltätigkeit',
    dutch: 'liefdadigheid',
    afrikaans: 'liefdadigheid',
    russian: 'благотворительность',
    latvian: 'labdarība',
    polish: 'miłosierdzie',
    french: 'charité, secours',
    spanish: 'caridad',
  },
  {
    av: 13160,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + beginning + rain: month when rainy season begins (Hebrew))',
    english: 'Cheshvan',
    swedish: 'Cheshvan (Israel)',
    norwegian: 'Cheshvan (Israel)',
    finnish: 'hesvan, hešván',
    hungarian: 'Cheshvan (esős hónap; héber)',
    german: 'Cheschwan, Marcheschwan (Monat)',
    dutch: 'Cheshvan',
    afrikaans: 'Cheshvan',
    russian: 'хешван (Израиль)',
    latvian: 'Heišvan (ebr.)',
    polish: 'Cheszwan (miesiąc hebrajski)',
    french: 'Markheshvan, Kheshvan (8e mois du calendrier juif)',
    spanish: 'Jeshvan',
  },
  {
    av: 13163,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(many + to bite + action indicator: to bite many times)',
    english: 'chew-(to)',
    swedish: 'tugga',
    norwegian: 'tygge',
    finnish: 'pureskella',
    hungarian: 'rágni, megrágni, elrágni',
    german: 'kauen',
    dutch: 'kauwen',
    afrikaans: 'kou (om te)',
    russian: 'жевать',
    latvian: 'košļāt',
    polish: 'żuć, gryźć, przeżuwać',
    french: 'mâcher',
    spanish: 'masticar',
  },
  {
    av: 13164,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + food: bird commonly used for food)',
    english: 'chicken (bird)',
    swedish: 'höna, hönsfågel',
    norwegian: 'høne, hønsefugl',
    finnish: 'kananpoika',
    hungarian: 'csirke, szárnyas',
    german: 'Huhn',
    dutch: 'kip (vogel)',
    afrikaans: 'hoender (voël)',
    russian: 'курица (птица)',
    latvian: 'vista (putns)',
    polish: 'kurczak (ptak)',
    french: 'poulet',
    spanish: 'pollo (ave)',
  },
  {
    av: 13165,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + bird)',
    english: 'chicken (food), poultry',
    swedish: 'kyckling, höna (mat)',
    norwegian: 'kylling (mat)',
    finnish: 'kananpoika (ruoka)',
    hungarian: 'csirkehús, szárnyashús',
    german: 'Brathuhn, Hühnerfleisch',
    dutch: 'kip (voedsel)',
    afrikaans: 'hoender (kos), pluimvee',
    russian: 'курица (еда)',
    latvian: 'cālis (putnu gaļa)',
    polish: 'kurczak (żywności), drób',
    french: 'poulet (nourriture)',
    spanish: 'pollo (comida), avícola',
  },
  {
    av: 13167,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(abuse + child)',
    english: 'child abuse',
    swedish: 'barnmisshandel',
    norwegian: 'barnemishandling',
    finnish: 'lapseen kohdistuva väkivalta, hyväksikäyttö',
    hungarian: 'gyermekbántalmazás',
    german: 'Kindesmissbrauch',
    dutch: 'kindermishandeling',
    afrikaans: 'kindermishandeling',
    russian: 'насилие над ребёнком',
    latvian: 'vardarbība pret bērnu, bērna ļaunprātīga izmantošana',
    polish: 'krzywdzenie dzieci, nadużycia wobec dzieci',
    french: "abus d'enfant",
    spanish: 'abuso infantil',
  },
  {
    av: 13170,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rodent + stripe)',
    english: 'chipmunk',
    swedish: 'jordekorre',
    norwegian: 'jordekorn',
    finnish: 'maaorava',
    hungarian: 'amerikai mókus (chipmunk)',
    german: 'Streifenhörnchen, nordamerikanisches Erdhörnchen',
    dutch: 'gestreepte eekhoorn, aardeekhoorn',
    afrikaans: 'Amerikaanse gestreepte eekhoring',
    russian: 'бурундук',
    latvian: 'burunduks',
    polish: 'wiewiórka ziemna ',
    french: 'tamia, chipmunk',
    spanish: 'ardilla',
  },
  {
    av: 13176,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(group + to sing)',
    english: 'choir, chorus',
    swedish: 'kör, sånggrupp',
    norwegian: 'kor, sanggruppe',
    finnish: 'kuoro',
    hungarian: 'énekkar, kórus, énekegyüttes',
    german: 'Chor',
    dutch: 'koor',
    afrikaans: 'koor',
    russian: 'хор',
    latvian: 'koris',
    polish: 'chór',
    french: 'chorale',
    spanish: 'coro',
  },
  {
    av: 13177,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to swallow + negative + action indicator: to swallow badly )',
    english: 'choke, gag-(to)',
    swedish: 'sätta i halsen',
    norwegian: 'sette i halsen',
    finnish: 'tukehtua, yökkiä',
    hungarian: 'fulladni, megfulladni, félrenyelni',
    german: 'verschlucken, würgen, ersticken',
    dutch: 'verslikken',
    afrikaans: 'verstik (om te)',
    russian: 'подавиться, поперхнуться',
    latvian: 'aizrīties, rīstīties',
    polish: 'dławić, dusić, krztusić się',
    french: "étouffer-(s'), étrangler-(s')",
    spanish: 'estrangular, amordazar',
  },
  {
    av: 13178,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(choice + action indicator)',
    english: 'choose, pick, select-(to)',
    swedish: 'välja',
    norwegian: 'velge',
    finnish: 'valita',
    hungarian: 'választani, kiválasztani, válogatni, kiválogatni',
    german: 'auswählen, wählen',
    dutch: 'kiezen, selecteren',
    afrikaans: 'kies, selekteer (om te)',
    russian: 'выбирать',
    latvian: 'izvēlēties, atlasīt',
    polish: 'wybierać',
    french: 'choisir',
    spanish: 'elegir, seleccionar',
  },
  {
    av: 13179,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cut + intensity + action indicator)',
    english: 'chop-(to)',
    swedish: 'hacka, hugga',
    norwegian: 'kutte, hogge',
    finnish: 'hakata, pilkkoa',
    hungarian: 'aprítani, felaprítani, darabolni, feldarabolni',
    german: 'hacken, zerhacken',
    dutch: 'hakken',
    afrikaans: 'kap (om te)',
    russian: 'рубить',
    latvian: 'kapāt, sagriezt',
    polish: 'ciąć',
    french: 'hacher',
    spanish: 'cortar, trozar',
  },
  {
    av: 13180,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(cross + description indicator)',
    english: 'christian',
    swedish: 'kristen',
    norwegian: 'kristen',
    finnish: 'kristillinen, kristitty',
    hungarian: 'keresztény',
    german: 'christlich',
    dutch: 'christen',
    afrikaans: 'christen',
    russian: 'христианский',
    latvian: 'kristietis',
    polish: 'chrześcijański',
    french: 'chrétien',
    spanish: 'cristiano',
  },
  {
    av: 13181,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(birthday + Christ [contraction]: day of Christ's birth)",
    english: 'Christmas',
    swedish: 'jul',
    norwegian: 'jul',
    finnish: 'joulu',
    hungarian: 'karácsony',
    german: 'Weihnachten',
    dutch: 'Kerst, Kerstmis',
    afrikaans: 'Kersfees',
    russian: 'рождество',
    latvian: 'Ziemassvētki',
    polish: 'Boże Narodzenie',
    french: 'Noël',
    spanish: 'Navidad',
  },
  {
    av: 13182,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(5 + book + Torah (Hebrew))',
    english: 'Chumash, Pentateuch',
    swedish: 'Chumash (Israel)',
    norwegian: 'Chumash (Israel)',
    finnish: 'humaš',
    hungarian: 'Chumash (héber)',
    german: 'Chumasch, Ḥumash, Pentateuch',
    dutch: 'Chumash (Joods)',
    afrikaans: 'Chumash, Pentateug',
    russian: 'хумаш (Израиль)',
    latvian: 'šumats',
    polish: 'Pięcioksiąg (hebrajskie)',
    french: 'Houmach, Pentateuque',
    spanish: 'Chumash, Pentateuco',
  },
  {
    av: 13345,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + God: building devoted to the worship of God)',
    english: 'church, mosque, temple',
    swedish: 'kyrka, moské, tempel',
    norwegian: 'kirke, moské, tempel',
    finnish: 'kirkko, kappeli, temppeli',
    hungarian: 'templom, mecset, imaház',
    german: 'Kirche, Moschee, Tempel',
    dutch: 'moskee, kerk, tempel',
    afrikaans: 'kerk, moskee, tempel',
    russian: 'церковь, мечеть',
    latvian: 'baznīca, mošeja, templis',
    polish: 'kościół, meczet, świątynia',
    french: 'église, mosquée, temple, synagogue',
    spanish: 'iglesia, mezquita, templo',
  },
  {
    av: 13347,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + circular shape [as of sun]: circle, a geometric shape)',
    english: 'circle (shape)',
    swedish: 'cirkel',
    norwegian: 'sirkel',
    finnish: 'ympyrä',
    hungarian: 'kör, köralak, körforma',
    german: 'Kreis',
    dutch: 'cirkel',
    afrikaans: 'sirkel',
    russian: 'круг',
    latvian: 'aplis',
    polish: 'koło (kształt)',
    french: 'rond, cercle (figure géométrique)',
    spanish: 'círculo',
  },
  {
    av: 13348,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to remove + foreskin)',
    english: 'circumcision',
    swedish: 'omskärelse',
    norwegian: 'omskjæring',
    finnish: 'ympärileikkaus',
    hungarian: 'körülmetélés, cirkumcízió',
    german: 'Beschneidung',
    dutch: 'besnijdenis',
    afrikaans: 'besnydenis',
    russian: 'обрезание',
    latvian: 'apgraizīšana',
    polish: 'obrzezanie',
    french: 'circoncision',
    spanish: 'circuncisión',
  },
  {
    av: 13351,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + many + building: a large group of buildings comprise a city)',
    english: 'town, city (small)',
    swedish: 'stad, småstad',
    norwegian: 'by',
    finnish: 'kaupunki',
    hungarian: 'város',
    german: 'Stadt, Kleinstadt',
    dutch: 'stad',
    afrikaans: 'dorp, stad (klein)',
    russian: 'город',
    latvian: 'pilsēta, lielpilsēta',
    polish: 'miasto',
    french: 'ville',
    spanish: 'ciudad',
  },
  {
    av: 13352,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group + to learn: group of people who come together to learn)',
    english: 'class',
    swedish: 'klass, studiegrupp',
    norwegian: 'klasse, studiegruppe',
    finnish: 'luokka',
    hungarian: 'osztály (iskolai)',
    german: 'Klasse',
    dutch: 'klas',
    afrikaans: 'klas',
    russian: 'класс',
    latvian: 'klase',
    polish: 'klasa (uczniowie)',
    french: 'classe (groupe)',
    spanish: 'clase',
  },
  {
    av: 13353,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + to teach)',
    english: 'classroom',
    swedish: 'klassrum, föreläsningssal',
    norwegian: 'klasserom, forelesningssal',
    finnish: 'luokkahuone',
    hungarian: 'tanterem',
    german: 'Klassenzimmer',
    dutch: 'klaslokaal',
    afrikaans: 'klaskamer',
    russian: 'класс (комната)',
    latvian: 'klases telpa (kabinets)',
    polish: 'klasa (pomieszczenie)',
    french: 'classe',
    spanish: 'aula',
  },
  {
    av: 13357,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to remove + dirty + action indicator)',
    english: 'clean-(to)',
    swedish: 'städa, göra ren',
    norwegian: 'gjøre rent',
    finnish: 'siivota, puhdistaa, siistiä',
    hungarian: 'tisztítani, kitisztítani',
    german: 'säubern, putzen, reinigen',
    dutch: 'schoonmaken, poetsen',
    afrikaans: 'skoonmaak (om te)',
    russian: 'убирать, чистить',
    latvian: 'tīrīt, kārtot',
    polish: 'czyścić',
    french: 'nettoyer',
    spanish: 'limpiar',
  },
  {
    av: 13358,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(clearness, clarity, transparency, transparence + description indicator)',
    english: 'clear, transparent',
    swedish: 'genomskinlig, klar',
    norwegian: 'klar, gjennomsiktig',
    finnish: 'kirkas, läpinäkyvä',
    hungarian: 'átlátszó, áttetsző, transzparens',
    german: 'klar, durchsichtig, transparent',
    dutch: 'transparant, doorzichtig',
    afrikaans: 'deurskynend, duidelik, deursigtig',
    russian: 'прозрачный',
    latvian: 'dzidrs, caurspīdīgs',
    polish: 'jasne, przejrzyste',
    french: 'transparent, limpide, clair, net',
    spanish: 'claro, transparente',
  },
  {
    av: 13359,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(helper + business: person who helps in a business)',
    english: 'clerk',
    swedish: 'affärsbiträde, expedit',
    norwegian: 'ekspeditør',
    finnish: 'kauppa-apulainen, kassanhoitaja, liiketyöntekijä',
    hungarian: 'hivatalnok, ügyintéző, adminisztrátor, tisztviselő',
    german: 'Angestellte, Angestellte, Beamte, Beamtin, Verkäufer, Verkäuferin',
    dutch: 'verkoper, verkoopster, winkelbediende',
    afrikaans: 'klerk',
    russian: 'продавец-консультант',
    latvian: 'ierēdnis, apkalpotājs',
    polish: 'bankowiec, urzędnik bankowy, doradca finansowy',
    french: 'employé de banque, employé commercial',
    spanish: 'empleado',
  },
  {
    av: 13360,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to walk + up + action indicator)',
    english: 'climb-(to)',
    swedish: 'klättra',
    norwegian: 'klatre, klyve',
    finnish: 'kiivetä',
    hungarian: 'mászni, felmászni',
    german: 'klettern',
    dutch: 'klimmen',
    afrikaans: 'klim (om te)',
    russian: 'взбираться, подниматься',
    latvian: 'rāpties, uzrāpties',
    polish: 'wspinać się, wchodzić ',
    french: 'grimper',
    spanish: 'trepar, subir',
  },
  {
    av: 13361,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(public room + medical)',
    english: 'clinic',
    swedish: 'klinik, vårdcentral',
    norwegian: 'klinikk',
    finnish: 'klinikka, vastaanotto',
    hungarian: 'járóbetegrendelés, ambulancia',
    german: 'Klinik',
    dutch: 'polikliniek',
    afrikaans: 'kliniek',
    russian: 'клиника, лечебница',
    latvian: 'klīnika',
    polish: 'klinika',
    french: 'centre hospitalier',
    spanish: 'clínica',
  },
  {
    av: 13362,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(part of + female genitals + intensity: part of the body that produces intense sexual excitement)',
    english: 'clitoris',
    swedish: 'klitoris',
    norwegian: 'klitoris',
    finnish: 'klitoris',
    hungarian: 'csikló, klitórisz',
    german: 'Klitoris',
    dutch: 'clitoris',
    afrikaans: 'klitoris',
    russian: 'клитор',
    latvian: 'klitors',
    polish: 'łechtaczka',
    french: 'clitoris',
    spanish: 'clítoris',
  },
  {
    av: 13363,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(time + thing indicator: object for telling time.The symbol is the concrete form of time.) - (character with thing indicator)',
    english: 'clock, timepiece',
    swedish: 'klocka',
    norwegian: 'klokke',
    finnish: 'kello',
    hungarian: 'óra (bármilyen: kar-, zseb-, torony-, fali-, asztali-)',
    german: 'Uhr',
    dutch: 'klok, uurwerk',
    afrikaans: 'horlosie, klok',
    russian: 'часы',
    latvian: 'pulkstenis, laikrādis',
    polish: 'zegar, zegarek',
    french: 'horloge',
    spanish: 'reloj',
  },
  {
    av: 13364,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(enclosure + action indicator)',
    english: 'close, enclose, shut-(to)',
    swedish: 'stänga',
    norwegian: 'stenge',
    finnish: 'sulkea',
    hungarian: 'körülkeríteni, körülzárni, bekeríteni, bezárni',
    german: 'schließen, verschließen, einschließen, einzäunen, zumachen',
    dutch: 'sluiten, dichtdoen',
    afrikaans: 'toe, omsluit, omring, omhein (om te)',
    russian: 'закрывать',
    latvian: 'aizvērt, taisīt ciet',
    polish: 'zamykać, zamknąć',
    french: 'fermer',
    spanish: 'cerrar, encerrar',
  },
  {
    av: 13368,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(cloud + description indicator)',
    english: 'cloudy',
    swedish: 'molnig',
    norwegian: 'overskyet, skyet',
    finnish: 'pilvinen',
    hungarian: 'felhős',
    german: 'bewölkt',
    dutch: 'bewolkt',
    afrikaans: 'bewolk',
    russian: 'облачный, пасмурный',
    latvian: 'apmācies',
    polish: 'pochmurne, zachmurzone, niepogodne',
    french: 'nuageux',
    spanish: 'nublado',
  },
  {
    av: 13369,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gathering + interest: gathering of people sharing the same interest)',
    english: 'club',
    swedish: 'förening, klubb',
    norwegian: 'klubb, forening',
    finnish: 'kerho',
    hungarian: 'klub, egyesület, egylet, társaskör',
    german: 'Klub, Verein',
    dutch: 'club',
    afrikaans: 'klub',
    russian: 'объединение, клуб',
    latvian: 'apvienība, klubs',
    polish: 'klub',
    french: 'club, cercle',
    spanish: 'club',
  },
  {
    av: 13370,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fuel + plant: fuel derived from plants)',
    english: 'biomass, biofuel',
    swedish: 'biobränsle',
    norwegian: 'biobrensel',
    finnish: 'biomassa, biopolttoaine',
    hungarian: 'biomassza, biológiai fűtőanyag',
    german: 'Biomasse, Biokraftstoff',
    dutch: 'steenkool',
    afrikaans: 'steenkool',
    russian: 'биотопливо',
    latvian: 'biomasa, biodegviela',
    polish: 'biomasa, biopaliwo',
    french: 'charbon, houille',
    spanish: 'biomasa',
  },
  {
    av: 13371,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + over: clothing worn over other clothing)',
    english: 'coat, jacket, jumper, sweater',
    swedish: 'ytterkläder, jacka, kappa, rock (etc)',
    norwegian: 'ytterklær, jakke, kappe (o.l.)',
    finnish: 'takki, päällysvaatteet, jakku',
    hungarian: 'kabát, felsőkabát, dzseki',
    german: 'Mantel, Jacke, Pullover, Sweatshirt',
    dutch: 'jas, trui, sweater',
    afrikaans: 'jas, trui, baadjie, sweetpakbaadjie',
    russian: 'верхняя одежда, пальто',
    latvian: 'virsdrēbes, mētelis, jaka, džemperis, svīteris',
    polish: 'płaszcz, kurtka',
    french: 'manteau, veste, pull, veston, parka',
    spanish: 'abrigo chaqueta, jersey',
  },
  {
    av: 13372,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fruit + palm tree)',
    english: 'coconut',
    swedish: 'kokosnöt',
    norwegian: 'kokosnøtt',
    finnish: 'kookospähkinä',
    hungarian: 'kókusz',
    german: 'Kokosnuss',
    dutch: 'kokosnoot',
    afrikaans: 'klapper, kokosneut',
    russian: 'кокос (орех)',
    latvian: 'kokosrieksts',
    polish: 'kokos',
    french: 'noix de coco',
    spanish: 'coco',
  },
  {
    av: 13373,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drink + bean: drink made from coffee beans)',
    english: 'coffee',
    swedish: 'kaffe',
    norwegian: 'kaffe',
    finnish: 'kahvi',
    hungarian: 'kávé',
    german: 'Kaffee',
    dutch: 'koffie',
    afrikaans: 'koffie',
    russian: 'кофе',
    latvian: 'kafija',
    polish: 'kawa',
    french: 'café (boisson)',
    spanish: 'café',
  },
  {
    av: 13374,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(disc + money: money in the form of a disc)',
    english: 'coin',
    swedish: 'mynt, slant',
    norwegian: 'mynt',
    finnish: 'kolikko, lantti',
    hungarian: 'pénzérem, érme',
    german: 'Münze',
    dutch: 'munt, geldstuk',
    afrikaans: 'munt, muntstuk',
    russian: 'монета',
    latvian: 'monēta',
    polish: 'moneta',
    french: 'pièce de monnaie',
    spanish: 'moneda',
  },
  {
    av: 13375,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(coldness, cold + description indicator) SYMBOL SYNONYM',
    english: 'cold',
    swedish: 'kall',
    norwegian: 'kald',
    finnish: 'kylmä',
    hungarian: 'hideg (jelkép-szinoníma)',
    german: 'kalt',
    dutch: 'koud',
    afrikaans: 'koud',
    russian: 'холодный',
    latvian: 'auksts',
    polish: 'zimny, zamarznięty',
    french: 'froid, glacé',
    spanish: 'frío',
  },
  {
    av: 13376,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(opposite meaning + hot + description indicator) SYMBOL SYNONYM',
    english: 'cold (opposite hot)',
    swedish: 'kall (FD)',
    norwegian: 'kald (motsatt varm)',
    finnish: 'kylmä',
    hungarian: 'hideg (jelkép-szinoníma)',
    german: 'kalt (ALT)',
    dutch: 'koud (OUD)',
    afrikaans: 'koud (opposite hot)',
    russian: 'холодный (СТАРОЕ зн)',
    latvian: 'auksts (novec.)',
    polish: 'zimne (przeciwieństwo gorącego)',
    french: 'froid (contraire de chaud)',
    spanish: 'frío (opuesto a calor)',
  },
  {
    av: 13377,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(eye + earth [half-sized]: what the eye receives from things on earth)',
    english: 'colour',
    swedish: 'färg',
    norwegian: 'farge',
    finnish: 'väri',
    hungarian: 'szín',
    german: 'Farbe',
    dutch: 'kleur',
    afrikaans: 'kleur',
    russian: 'цвет',
    latvian: 'krāsa',
    polish: 'kolor',
    french: 'couleur',
    spanish: 'color',
  },
  {
    av: 13379,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(comb + action indicator)',
    english: 'comb-(to)',
    swedish: 'kamma',
    norwegian: 'gre, kjemme',
    finnish: 'kammata',
    hungarian: 'fésülni, megfésülni, fésülködni',
    german: 'kämmen',
    dutch: 'kammen',
    afrikaans: 'kam (om te)',
    russian: 'расчёсывать',
    latvian: 'ķemmēt',
    polish: 'czesać',
    french: 'peigner, peigner-(se), coiffer, coiffer-(se)',
    spanish: 'peinar',
  },
  {
    av: 13381,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(combination + action indicator)',
    english: 'combine, connect, link-(to)',
    swedish: 'kombinera',
    norwegian: 'kombinere, binde sammen',
    finnish: 'yhdistää, liittää yhteen liittyä',
    hungarian: 'összekapcsolni, összekötni, kombinálni, egyesülni',
    german: 'verbinden, zusammenschließen, verknüpfen',
    dutch: 'verbinden, combineren',
    afrikaans: 'kombineer, konnekteer, verbind (om te)',
    russian: 'комбинировать, соединять',
    latvian: 'kombinēt, savienot',
    polish: 'łączyć, złączać, wiązać',
    french: 'combiner, associer, unir, connecter, lier',
    spanish: 'combinar, relacionar, vincular',
  },
  {
    av: 13383,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(approach + action indicator)',
    english: 'come, approach-(to)',
    swedish: 'komma, närma sig',
    norwegian: 'komme, nærme seg',
    finnish: 'tulla, lähestyä',
    hungarian: 'jönni, közeledni, megközelíteni',
    german: 'kommen, herangehen, näher kommen',
    dutch: 'komen',
    afrikaans: 'kom, benader (om te)',
    russian: 'прийти, приблизиться',
    latvian: 'nākt, tuvoties',
    polish: 'dojść, podchodzić',
    french: "venir, arriver, approcher-(s')",
    spanish: 'venir, llegar, acercarse, aproximarse',
  },
  {
    av: 13385,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to give + peace + action indicator)',
    english: 'comfort, console-(to)',
    swedish: 'trösta',
    norwegian: 'trøste',
    finnish: 'lohduttaa',
    hungarian: 'vigasztalni, megvigasztalni',
    german: 'trösten, beruhigen',
    dutch: 'troosten',
    afrikaans: 'troos (om te)',
    russian: 'утешать, успокаивать',
    latvian: 'mierināt',
    polish: 'pocieszać, koić',
    french: 'consoler',
    spanish: 'consolar',
  },
  {
    av: 13386,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(rest + description indicator: feeling at rest)',
    english: 'comfortable, restful',
    swedish: 'behaglig, bekväm, skön',
    norwegian: 'behagelig, bekvem, komfortabel',
    finnish: 'mukava, rento',
    hungarian: 'kényelmes, pihentető',
    german: 'bequem, gemütlich',
    dutch: 'comfortabel, rustig (als persoon)',
    afrikaans: 'gemaklik, rustig, kalm',
    russian: 'удобный, уютный',
    latvian: 'ērts',
    polish: 'spokojny, wyciszony',
    french: 'confortable, commode',
    spanish: 'cómodo, relajado',
  },
  {
    av: 13389,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(communication + action indicator)',
    english: 'communicate-(to)',
    swedish: 'kommunicera',
    norwegian: 'kommunisere',
    finnish: 'kommunikoida, keskustella',
    hungarian: 'kommunikálni, eszmét cserélni',
    german: 'kommunizieren',
    dutch: 'communiceren',
    afrikaans: 'kommunikeer (om te)',
    russian: 'общаться',
    latvian: 'sazināties, komunicēt',
    polish: 'przekazywać, porozumiewać się',
    french: 'communiquer',
    spanish: 'comunicar',
  },
  {
    av: 13390,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(exchange, substitution + meaning)',
    english: 'communication',
    swedish: 'kommunikation',
    norwegian: 'kommunikasjon',
    finnish: 'kommunikaatio',
    hungarian: 'kommunikáció, eszmecsere',
    german: 'Kommunikation',
    dutch: 'communicatie',
    afrikaans: 'kommunikasie',
    russian: 'общение',
    latvian: 'saziņa, komunikācija',
    polish: 'komunikacja',
    french: 'communication',
    spanish: 'comunicación',
  },
  {
    av: 13391,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to observe + same + action indicator: to observe the similarities between two or more persons or things)',
    english: 'compare-(to)',
    swedish: 'jämföra',
    norwegian: 'sammenlikne',
    finnish: 'verrata, vertailla',
    hungarian: 'összehasonlítani, egybevetni (két hasonló dolgot)',
    german: 'vergleichen',
    dutch: 'vergelijken',
    afrikaans: 'vergelyk (om te)',
    russian: 'сравнивать',
    latvian: 'salīdzināt',
    polish: 'porównywać',
    french: 'comparer',
    spanish: 'comparar',
  },
  {
    av: 13392,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(race + action indicator)',
    english: 'compete, race-(to)',
    swedish: 'tävla',
    norwegian: 'konkurrere',
    finnish: 'kilpailla, otella',
    hungarian: 'versenyezni, konkurálni',
    german: 'wetteifern, um die Wette laufen',
    dutch: 'wedijveren',
    afrikaans: 'kompeteer (om te)',
    russian: 'соревноваться',
    latvian: 'sacensties',
    polish: 'rywalizować, konkurować',
    french: 'concourir, faire la course, rivaliser, faire concurrence-(se)',
    spanish: 'competir',
  },
  {
    av: 13393,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + tune: person who creates tunes)',
    english: 'composer',
    swedish: 'kompositör, tonsättare',
    norwegian: 'komponist',
    finnish: 'säveltäjä',
    hungarian: 'zeneszerző',
    german: 'Komponist, Komponistin',
    dutch: 'componist',
    afrikaans: 'komponis',
    russian: 'композитор',
    latvian: 'komponists',
    polish: 'kompozytor',
    french: 'compositeur',
    spanish: 'compositor',
  },
  {
    av: 13396,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + music: building where music is performed)',
    english: 'concert hall',
    swedish: 'konserthus',
    norwegian: 'konserthus',
    finnish: 'konserttitalo',
    hungarian: 'hangversenyterem, koncertterem, koncerthall',
    german: 'Konzertsaal',
    dutch: 'concertzaal',
    afrikaans: 'konsertsaal',
    russian: 'концертный зал',
    latvian: 'koncertzāle',
    polish: 'sala koncertowa',
    french: 'salle de concert',
    spanish: 'sala de conciertos',
  },
  {
    av: 13397,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(material + stone + man-made: man-made material that can be used like stone)',
    english: 'concrete, cement',
    swedish: 'betong, cement',
    norwegian: 'sement, betong',
    finnish: 'sementti, betoni',
    hungarian: 'beton, cement',
    german: 'Beton, Zement',
    dutch: 'cement',
    afrikaans: 'sement',
    russian: 'бетон, цемент',
    latvian: 'betons, cements',
    polish: 'beton, cement',
    french: 'béton, ciment',
    spanish: 'hormigón, cemento',
  },
  {
    av: 13398,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(barrier contraceptive + male)',
    english: 'condom',
    swedish: 'kondom',
    norwegian: 'kondom',
    finnish: 'kondomi',
    hungarian: 'óvszer',
    german: 'Kondom',
    dutch: 'condoom',
    afrikaans: 'kondoom',
    russian: 'презерватив',
    latvian: 'prezervatīvs',
    polish: 'prezerwatywa',
    french: 'préservatif, condom',
    spanish: 'condón',
  },
  {
    av: 13402,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(consideration (mind + other) + description indicator: mindful of others)',
    english: 'considerate, thoughtful',
    swedish: 'omtänksam',
    norwegian: 'hensynsfull, omtenksom',
    finnish: 'huomaavainen, hienotunteinen',
    hungarian: 'tapintatos, előzékeny, figyelmes',
    german: 'rücksichtsvoll, aufmerksam',
    dutch: 'attent, voorkomend, vriendelijk',
    afrikaans: 'bedagsaam, deurdagte',
    russian: 'внимательный, заботливый',
    latvian: 'rūpīgs, apdomīgs',
    polish: 'troskliwy, delikatny, dbający o innych',
    french: 'prévenant',
    spanish: 'considerado, amable',
  },
  {
    av: 13404,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(continuance, continuation (forward [extended] + reference line [half-sized]) + action indicator: the arrow passes a reference line and continues on)',
    english: 'continue, pass-(to)',
    swedish: 'fortsätta, passera',
    norwegian: 'fortsette, passere',
    finnish: 'jatkaa, jatkua',
    hungarian: 'folytatni, túlhaladni, továbbhaladni',
    german: 'fortsetzen, fortführen, dauern, jmdm etwas reichen',
    dutch: 'doorgaan, voortgaan',
    afrikaans: 'voortgaan, aangaan (om te)',
    russian: 'продолжать',
    latvian: 'turpināt',
    polish: 'kontynuować, przejść dalej',
    french: 'continuer, poursuivre',
    spanish: 'continuar, pasar',
  },
  {
    av: 13405,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + uterus)',
    english: 'uterine contraction',
    swedish: 'sammandragning, värk (i livmodern)',
    norwegian: 'sammentrekning av livmor, kynner',
    finnish: 'kohdun supistus',
    hungarian: 'méhgörcs, méhösszehúzódás',
    german: 'Wehe',
    dutch: 'weeën',
    afrikaans: 'uteruskontraksie',
    russian: 'схватки (родовые)',
    latvian: 'dzemdību sāpes',
    polish: 'skurcze macicy',
    french: 'contraction utérine',
    spanish: 'contracción uterina',
  },
  {
    av: 13406,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to observe + different + action indicator: to observe the differences between two persons or things)',
    english: 'contrast-(to)',
    swedish: 'jämföra, särskilja',
    norwegian: 'kontrastere, bryte',
    finnish: 'asettaa vastakkain, verrata',
    hungarian: 'összehasonlítani (két eltérő, különböző dolgot)',
    german: 'gegenüberstellen, vergleichen, kontrastieren, entgegensetzen',
    dutch: 'contrasteren',
    afrikaans: 'kontras, kontrasteer (om te)',
    russian: 'различать',
    latvian: 'salīdzināt',
    polish: 'kontrastować, przeciwstawiać, widzieć różnice',
    french: 'contraster',
    spanish: 'contrastar',
  },
  {
    av: 13407,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(self-control + action indicator)',
    english: 'control oneself-(to)',
    swedish: 'behärska sig',
    norwegian: 'beherske seg',
    finnish: 'kontrolloida itseään, hallita itsensä',
    hungarian: 'önuralmat, önfegyelmet gyakorolni',
    german: 'sich beherrschen',
    dutch: 'beheersen zich',
    afrikaans: 'beheer jouself (om te)',
    russian: 'контролировать себя',
    latvian: 'kontrolēt sevi',
    polish: 'samokontrola',
    french: 'contrôler-(se), dominer-(se)',
    spanish: 'controlarse',
  },
  {
    av: 13408,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(fire + food + action indicator: to use fire (heat) to prepare food)',
    english: 'cook-(to)',
    swedish: 'laga mat',
    norwegian: 'varme mat',
    finnish: 'keittää',
    hungarian: 'főzni, ételt melegíteni',
    german: 'kochen',
    dutch: 'koken',
    afrikaans: 'kook (om te)',
    russian: 'готовить еду',
    latvian: 'gatavot',
    polish: 'gotować (na ogniu)',
    french: 'cuisiner, cuire',
    spanish: 'cocinar',
  },
  {
    av: 13409,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(disc + sweet: sweet, disc-shaped food)',
    english: 'cookie, biscuit',
    swedish: 'kaka, kex',
    norwegian: 'kjeks, småkake',
    finnish: 'pikkuleipä, keksi',
    hungarian: 'keksz, teasütemény, kétszersült',
    german: 'Plätzchen, Keks',
    dutch: 'koek, koekje',
    afrikaans: 'koekie, beskuit',
    russian: 'печенье',
    latvian: 'cepumi',
    polish: 'ciasteczko, herbatnik',
    french: 'biscuit',
    spanish: 'galleta',
  },
  {
    av: 13410,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(cold + little + description indicator) SYMBOL SYNONYM',
    english: 'cool, chilly',
    swedish: 'kylig',
    norwegian: 'kjølig',
    finnish: 'viileä, kalsea',
    hungarian: 'hűvös (jelkép szinonima)',
    german: 'kühl',
    dutch: 'koel, kil',
    afrikaans: 'koel, koud, yskoud',
    russian: 'прохладный',
    latvian: 'auksts, vēss',
    polish: 'chłodny',
    french: 'frais',
    spanish: 'fresco',
  },
  {
    av: 13411,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(opposite meaning + warm + description indicator) SYMBOL SYNONYM',
    english: 'cool, chilly (opposite warm)',
    swedish: 'kylig (motsats varm)',
    norwegian: 'kjølig (motsatt varm)',
    finnish: 'viileä, kalsea',
    hungarian: 'hűvös (jelkép szinonima)',
    german: 'kühl, frisch',
    dutch: 'koel, kil (tegenovegesteld warm)',
    afrikaans: 'koel, koud, yskoud (teenoorgesteld warm)',
    russian: 'прохладный',
    latvian: 'auksts',
    polish: 'chłodny (przeciwieństwo ciepłego)',
    french: 'frais (contraire de tiède)',
    spanish: 'fresco (opuesto a cálido)',
  },
  {
    av: 13412,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to repeat + thing indicator) - (character with thing indicator)',
    english: 'copy, duplicate',
    swedish: 'kopia',
    norwegian: 'kopi, duplikat',
    finnish: 'kopio, moniste, jäljennös',
    hungarian: 'másolat, duplikátum, copy',
    german: 'Kopie',
    dutch: 'kopie',
    afrikaans: 'duplikaat, afskrif, kopie',
    russian: 'копия, дубликат',
    latvian: 'kopija, dublikāts',
    polish: 'kopia, duplikat',
    french: 'copie',
    spanish: 'copia, duplicado',
  },
  {
    av: 13415,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(powder + corn)',
    english: 'cornmeal',
    swedish: 'majsmjöl',
    norwegian: 'maismel',
    finnish: 'maissijauho',
    hungarian: 'kukoricaliszt, kukoricadara',
    german: 'Maismehl',
    dutch: 'maismeel',
    afrikaans: 'koringmeel',
    russian: 'кукурузная мука',
    latvian: 'kukurūzu milti',
    polish: 'mąka kukurydziana',
    french: 'farine de maïs, fécule de maïs, semoule de maïs',
    spanish: 'harina de maíz',
  },
  {
    av: 13416,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(correctness + description indicator: thought to be correct, good, or right in a rational sense) See also: good, well, fine, ok, okay, all right 14463 and moral, good, right, morally right 15653',
    english: 'correct, accurate, good, right',
    swedish: 'rätt, riktig',
    norwegian: 'riktig, rett, korrekt',
    finnish: 'oikein, hyvä',
    hungarian: 'korrekt, pontos, hibátlan, helyénvaló',
    german: 'richtig, korrekt, genau',
    dutch: 'goed, juist, correct',
    afrikaans: 'korrek, akkuraat, goed, reg, perfek',
    russian: 'правильный',
    latvian: 'pareizs, precīzs, atbilstošs',
    polish: 'poprawne, prawdziwe, prawidłowe',
    french: 'correct, juste, bon (exactitude)',
    spanish: 'correcto, bueno, exacto',
  },
  {
    av: 13417,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + for (in exchange for) + thing)',
    english: 'cost, price',
    swedish: 'pris, kostnad',
    norwegian: 'pris, kostnad',
    finnish: 'maksu, hinta',
    hungarian: 'ár, valaminek az ára, díja',
    german: 'Preis, Kosten',
    dutch: 'prijs',
    afrikaans: 'prys',
    russian: 'цена, стоимость',
    latvian: 'cena, maksa',
    polish: 'koszt, cena',
    french: 'coût',
    spanish: 'costo',
  },
  {
    av: 13418,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + make believe)',
    english: 'costume, disguise',
    swedish: 'maskeraddräkt, utklädningskläder',
    norwegian: 'kostyme, utkledningsklær',
    finnish: 'naamiaispuku, valepuku',
    hungarian: 'jelmez, kosztüm, álöltözet, álruha',
    german: 'Kostüm, Verkleidung',
    dutch: 'kostuum (verkleden), verkleedkleren',
    afrikaans: 'kostuum',
    russian: 'маскарадный костюм',
    latvian: 'kostīms, masku balles tērps',
    polish: 'kostium, przebranie',
    french: 'costume, déguisement',
    spanish: 'traje, disfraz',
  },
  {
    av: 13420,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(to blow + intensity + action indicator: to blow air forcefully from one's mouth)",
    english: 'cough-(to)',
    swedish: 'hosta',
    norwegian: 'hoste',
    finnish: 'yskiä',
    hungarian: 'köhögni',
    german: 'husten',
    dutch: 'hoesten',
    afrikaans: 'hoes (om te)',
    russian: 'кашлять',
    latvian: 'klepot',
    polish: 'kaszleć',
    french: 'tousser',
    spanish: 'toser',
  },
  {
    av: 13421,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + suggestion + to help: person who makes suggestions in order to help)',
    english: 'counsellor, adviser',
    swedish: 'konsulent, konsult, rådgivare',
    norwegian: 'rådgiver, konsulent',
    finnish: 'neuvonantaja, neuvoja',
    hungarian: 'tanácsadó, konzultáns',
    german: 'Berater, Beraterin, Anwalt, Anwältin, Ratgeber, Ratgeberin',
    dutch: 'raadsman, consulent',
    afrikaans: 'berader, adviseur',
    russian: 'консультант',
    latvian: 'konsultants, padomdevējs',
    polish: 'konsultant, doradca, radca',
    french: 'conseiller (personne)',
    spanish: 'consejero, asesor, consultor',
  },
  {
    av: 13422,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(number + action indicator)',
    english: 'count-(to)',
    swedish: 'räkna',
    norwegian: 'telle, regne',
    finnish: 'laskea, luetella',
    hungarian: 'számlálni, megszámolni',
    german: 'zählen',
    dutch: 'tellen',
    afrikaans: 'tel (om te)',
    russian: 'считать',
    latvian: 'skaitīt',
    polish: 'liczyć',
    french: 'compter',
    spanish: 'contar',
  },
  {
    av: 13426,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + person)',
    english: 'couple (two persons)',
    swedish: 'par (två personer)',
    norwegian: 'par (to personer)',
    finnish: 'pari',
    hungarian: 'pár (két személy)',
    german: 'Paar',
    dutch: 'koppel (twee-personen), paar (twee-personen), stel',
    afrikaans: 'paar (twee persone)',
    russian: 'пара (однополая)',
    latvian: 'pāris (divas personas)',
    polish: 'para (dwie osoby)',
    french: 'couple (deux personnes)',
    spanish: 'pareja (dos personas)',
  },
  {
    av: 13429,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: "(offspring + sibling + parent: child of one's uncle or aunt)",
    english: 'cousin',
    swedish: 'kusin',
    norwegian: 'søskenbarn (fetter, kusine)',
    finnish: 'serkku',
    hungarian: 'unokatestvér',
    german: 'Cousin, Cousine',
    dutch: 'neef, nicht, kozijn (Vl)',
    afrikaans: 'neef, nig',
    russian: 'кузен, кузина',
    latvian: 'māsīca, bralēns',
    polish: 'kuzyn',
    french: 'cousin, cousine',
    spanish: 'primo',
  },
  {
    av: 13430,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bovine + female)',
    english: 'cow',
    swedish: 'ko',
    norwegian: 'ku',
    finnish: 'lehmä',
    hungarian: 'tehén',
    german: 'Kuh',
    dutch: 'koe',
    afrikaans: 'koei',
    russian: 'корова',
    latvian: 'govs',
    polish: 'krowa',
    french: 'vache',
    spanish: 'vaca',
  },
  {
    av: 13431,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(man-made + hand: production of things by hand, e.g. quilting or wood carving)',
    english: 'craft',
    swedish: 'hantverk, slöjd, pyssel',
    norwegian: 'håndverk',
    finnish: 'käsityö',
    hungarian: 'kézművesség, mesterség',
    german: 'Handarbeit, Bastelarbeit, Bastelei',
    dutch: 'handwerk',
    afrikaans: 'handwerk',
    russian: 'рукоделие, ремесло',
    latvian: 'rokdarbi, amatniecība',
    polish: 'rzemiosło',
    french: 'artisanat',
    spanish: 'manualidad',
  },
  {
    av: 13432,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pain + muscle: pain caused by muscle spasm or contraction)',
    english: 'cramp, spasm',
    swedish: 'kramp',
    norwegian: 'krampe, muskelsmerte',
    finnish: 'kramppi, suonenveto',
    hungarian: 'izomgörcs, görcsös izomfájdalom',
    german: 'Krampf, Krämpfe',
    dutch: 'kramp, spasme, spierpijn',
    afrikaans: 'kramp, spasma, spierpyn',
    russian: 'судорога',
    latvian: 'krampji, spazmas',
    polish: 'kurcz, skurcze',
    french: 'crampe, spasme',
    spanish: 'calambre',
  },
  {
    av: 13433,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(berry + bog: berry that grows in marsh land)',
    english: 'cranberry',
    swedish: 'tranbär',
    norwegian: 'tranebær',
    finnish: 'karpalo',
    hungarian: 'vörös áfonya, tőzegáfonya',
    german: 'Moosbeere',
    dutch: 'veenbes, cranberry',
    afrikaans: 'rooibosbessie, cranberry',
    russian: 'клюква',
    latvian: 'dzērvene',
    polish: 'żurawina',
    french: 'airelle, canneberge',
    spanish: 'arándano agrio',
  },
  {
    av: 13434,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + up and down: equipment to raise and lower)',
    english: 'crane',
    swedish: 'lyft, lyftkran',
    norwegian: 'heisekran, kran',
    finnish: 'nostolaite, nosturi',
    hungarian: 'daru (ipari)',
    german: 'Kran',
    dutch: 'kraan (machine), hijskraan',
    afrikaans: 'kraan (masjien), hyskraan',
    russian: 'кран',
    latvian: 'celtnis',
    polish: 'dźwig, żuraw',
    french: 'grue',
    spanish: 'grúa',
  },
  {
    av: 13435,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to stop + intensity) SYMBOL SYNONYM',
    english: 'crash (forward)',
    swedish: 'kollision, krock',
    norwegian: 'kræsj, kollisjon',
    finnish: 'törmäys',
    hungarian: 'ütközés, összeütközés (jelkép szinonima)',
    german: 'Zusammenstoß, Unfall',
    dutch: 'botsing',
    afrikaans: 'bots',
    russian: 'столкновение',
    latvian: 'trieciens (virzienā uz priekšu)',
    polish: 'walnąć, zderzyć, uderzyć (do przodu)',
    french: 'collision frontale',
    spanish: 'colisión, choque (hacia delante)',
  },
  {
    av: 13436,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(crash (downward) + action indicator) SYMBOL SYNONYM',
    english: 'crash (downward)-(to)',
    swedish: 'krascha, störta',
    norwegian: 'kræsje, styrte',
    finnish: 'rysähtää, romahtaa',
    hungarian: 'zuhanás (jelkép szinonima)',
    german: 'stürzen, hinfallen, abstürzen',
    dutch: 'neerstorten',
    afrikaans: 'val, neerval, neerstort (om te)',
    russian: 'рухнуть, разбиться',
    latvian: 'trieciens (virzienā uz leju)',
    polish: 'upadać, spaść (w dół)',
    french: "tomber, écraser-(s')",
    spanish: 'estrellarse (hacia abajo)',
  },
  {
    av: 13439,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(crash (forward) + action indicator)',
    english: 'crash (forward)-(to)',
    swedish: 'kollidera, krocka',
    norwegian: 'kræsje, kollidere',
    finnish: 'törmätä',
    hungarian: 'ütközni, összeütközni, belerohanni',
    german: 'zusammenstoßen',
    dutch: 'botsen',
    afrikaans: 'botsing, bots (om te)',
    russian: 'столкнуться',
    latvian: 'sasisties, sadurties',
    polish: 'zderzenie, uderzenie (forward)',
    french: 'cogner, percuter',
    spanish: 'colisionar, chocar (hacia delante)',
  },
  {
    av: 13440,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(bump, press, pressing + intensity: an intense fall and hit onto the ground)',
    english: 'crash (downward)',
    swedish: 'krasch',
    norwegian: 'kræsj, styrt',
    finnish: 'rysähdys',
    hungarian: 'zuhanni, lezuhanni',
    german: 'Absturz',
    dutch: 'crash',
    afrikaans: 'bots',
    russian: 'крушение, падение',
    latvian: 'trieciens (lejup)',
    polish: 'upadek (w dół)',
    french: 'chute, fracas',
    spanish: 'estrellón (hacia abajo)',
  },
  {
    av: 13603,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(kneeling person + forward + action indicator: to go forward on one's knees)",
    english: 'crawl-(to)',
    swedish: 'krypa, gå på knä',
    norwegian: 'krabbe, krype',
    finnish: 'ryömiä, kontata',
    hungarian: 'kúszni, mászni, csúszni-mászni',
    german: 'krabblen, kriechen',
    dutch: 'kruipen',
    afrikaans: 'kruip (om te)',
    russian: 'ползать',
    latvian: 'rāpot',
    polish: 'pełzać, iść na kolanach',
    french: 'ramper',
    spanish: 'arrastrarse',
  },
  {
    av: 13604,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pencil + colour)',
    english: 'crayon, coloured pencil, marker',
    swedish: 'krita, färgpenna',
    norwegian: 'fargeblyant, fargestift',
    finnish: 'värikynä, väriliitu',
    hungarian: 'színes (ceruza, kréta, filctoll)',
    german: 'Buntstift, Wachsmaler, Filzstift',
    dutch: 'kleurpotlood',
    afrikaans: 'inkleurpotlood, kleurkruit, veselpenne (gekleurd)',
    russian: 'цветной карандаш',
    latvian: 'zīmulis, krāsainais zīmulis, marķieris',
    polish: 'pastel, kredka, marker',
    french: 'crayon de couleur',
    spanish: 'lápiz de color',
  },
  {
    av: 13605,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(milk + intensity: the intensity symbol suggests that cream is rich milk)',
    english: 'cream',
    swedish: 'grädde',
    norwegian: 'fløte',
    finnish: 'kerma',
    hungarian: 'tejszín',
    german: 'Sahne',
    dutch: 'room',
    afrikaans: 'room',
    russian: 'сливки',
    latvian: 'saldais kējums',
    polish: 'śmietanka, gęsta śmietana',
    french: 'crème fraîche',
    spanish: 'crema',
  },
  {
    av: 13606,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(creation + action indicator)',
    english: 'create-(to)',
    swedish: 'skapa',
    norwegian: 'skape',
    finnish: 'luoda',
    hungarian: 'teremteni, alkotni, létrehozni',
    german: 'erschaffen, schaffen',
    dutch: 'creëren, scheppen',
    afrikaans: 'skep, maak (om te)',
    russian: 'создавать, творить',
    latvian: 'rādīt, veidot',
    polish: 'tworzyć',
    french: 'créer',
    spanish: 'crear',
  },
  {
    av: 13608,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(creation + description indicator)',
    english: 'creative',
    swedish: 'kreativ, skapande',
    norwegian: 'skapende, kreativ',
    finnish: 'luova',
    hungarian: 'kreatív',
    german: 'kreativ, schöpferisch',
    dutch: 'creatief',
    afrikaans: 'kreatief',
    russian: 'творческий, созидательный',
    latvian: 'radošs',
    polish: 'twórczy, kreatywny',
    french: 'créatif',
    spanish: 'creativo, creativa',
  },
  {
    av: 13609,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(life + thing indicator: a living creature. The symbol is the concrete form of life.) - (character with thing indicator)',
    english: 'creature, being',
    swedish: 'figur, gestalt, levande varelse',
    norwegian: 'levende vesen, skapning',
    finnish: 'olento, luontokappale, eliö',
    hungarian: 'élőlény, kreatúra',
    german: 'Lebewesen, Geschöpf',
    dutch: 'levend wezen, schepsel',
    afrikaans: 'skepsel',
    russian: 'живое существо',
    latvian: 'dzīva radība',
    polish: 'stworzenie, istota',
    french: 'créature, être vivant',
    spanish: 'criatura, ser',
  },
  {
    av: 13610,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + crescent shape)',
    english: 'crescent',
    swedish: 'månform',
    norwegian: 'måneform',
    finnish: 'kuunsirppi, puolikuu',
    hungarian: 'félhold alakú',
    german: 'Mondsichel, Halbmond',
    dutch: 'maanvormig, sikkelvormig',
    afrikaans: 'halfmaan, sekelmaan, halfmaanvorming, sekelmaanvormig',
    russian: 'полумесяц (форма)',
    latvian: 'pussmēness',
    polish: 'półksiężyc',
    french: 'croissant (forme)',
    spanish: 'creciente',
  },
  {
    av: 13611,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to make + cloth + hook + action indicator: to make cloth with a hook)',
    english: 'crochet-(to)',
    swedish: 'virka',
    norwegian: 'hekle',
    finnish: 'virkata',
    hungarian: 'horgolni',
    german: 'häkeln',
    dutch: 'haken',
    afrikaans: 'hekel (om te)',
    russian: 'вязать крючком',
    latvian: 'tamborēt',
    polish: 'szydełkować',
    french: 'crocheter',
    spanish: 'hacer ganchillo',
  },
  {
    av: 13612,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + ball + hammer: game in which a mallet is used to move a ball)',
    english: 'croquet (activity)',
    swedish: 'krocket (aktivitet)',
    norwegian: 'krokket',
    finnish: 'kroketti',
    hungarian: 'krokettjáték',
    german: 'Krocketspiel',
    dutch: 'croquet',
    afrikaans: 'croquet, kroukie',
    russian: 'крокет',
    latvian: 'krikets',
    polish: 'krokiet (aktywności)',
    french: 'croquet (activité)',
    spanish: 'croquet (actividad)',
  },
  {
    av: 13614,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(across + action indicator)',
    english: 'cross-(to)',
    swedish: 'gå över, korsa',
    norwegian: 'krysse',
    finnish: 'ylittää, risteillä, kulkea poikki',
    hungarian: 'keresztezni',
    german: 'überqueren',
    dutch: 'oversteken',
    afrikaans: 'kruis, oorsteek (om te)',
    russian: 'пересекать, переходить',
    latvian: 'šķērsot',
    polish: 'krzyżować',
    french: 'traverser, franchir, croiser',
    spanish: 'cruzar',
  },
  {
    av: 13616,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(compression, compressing, squeezing + action indicator: to crush a thing by pressure from two directions)',
    english: 'crush, squeeze-(to)',
    swedish: 'pressa, trycka, klämma',
    norwegian: 'presse sammen, trykke sammen',
    finnish: 'rypistää, musertaa',
    hungarian: 'összenyom, -zúz, -présel, -roppant',
    german: 'zerdrücken, quetschen',
    dutch: 'platdrukken',
    afrikaans: 'druk (om te)',
    russian: 'давить, выжимать',
    latvian: 'spiest, izspiest',
    polish: 'zgniatać, ściskać',
    french: 'écraser',
    spanish: 'aplastar',
  },
  {
    av: 13617,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(tools + medical + to walk + plural indicator: medical devices for walking)',
    english: 'crutches',
    swedish: 'kryckor',
    norwegian: 'krykker',
    finnish: 'kainalosauvat',
    hungarian: 'mankó',
    german: 'Krücken, Gehhilfen',
    dutch: 'krukken',
    afrikaans: 'krukke',
    russian: 'костыли',
    latvian: 'kruķis, kruķi',
    polish: 'kule (inwalidzkie)',
    french: 'béquilles',
    spanish: 'muletas',
  },
  {
    av: 13618,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(eye + rain + action indicator: to have water falling from one's eyes like raindrops)",
    english: 'cry, weep-(to)',
    swedish: 'gråta',
    norwegian: 'gråte',
    finnish: 'itkeä',
    hungarian: 'sírni, könnyezni',
    german: 'weinen',
    dutch: 'huilen, wenen',
    afrikaans: 'huil, ween (om te)',
    russian: 'плакать',
    latvian: 'raudāt',
    polish: 'krzyczeć, płakać',
    french: 'pleurer',
    spanish: 'gritar',
  },
  {
    av: 13620,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vegetable (cylinder-shaped) + long)',
    english: 'cucumber',
    swedish: 'gurka',
    norwegian: 'agurk',
    finnish: 'kurkku',
    hungarian: 'uborka',
    german: 'Gurke',
    dutch: 'komkommer',
    afrikaans: 'komkommer',
    russian: 'огурец',
    latvian: 'gurķis',
    polish: 'ogórek',
    french: 'concombre',
    spanish: 'pepino',
  },
  {
    av: 13624,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(now + description indicator)',
    english: 'current',
    swedish: 'aktuell, nuvarande, på gång',
    norwegian: 'nåværende, aktuell',
    finnish: 'nykyinen, ajankohtainen, tämänhetkinen',
    hungarian: 'aktuális, érvényes, időszerű, mostani',
    german: 'aktuell',
    dutch: 'nu',
    afrikaans: 'nou (op die oomblik)',
    russian: 'нынешний, текущий',
    latvian: 'patreizējs, tekošais',
    polish: 'aktualny, bieżący',
    french: 'actuel, présent, courant',
    spanish: 'actual',
  },
  {
    av: 13625,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + now + plural indicator)',
    english: 'current events',
    swedish: 'aktuella händelser, nyheter',
    norwegian: 'aktuelle begivenheter, nyheter',
    finnish: 'ajankohtaisia tapahtumia',
    hungarian: 'jelenlegi, folyamatban lévő, aktuális események',
    german: 'Tagesereignis, Neuigkeiten',
    dutch: 'actualiteiten',
    afrikaans: 'tans, huidige aktiwiteit gebeurtenis',
    russian: 'текущие события',
    latvian: 'patreizēji notikumi',
    polish: 'aktualności',
    french: 'actualité',
    spanish: 'acontecimientos actuales',
  },
  {
    av: 13628,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(scissors + action indicator) SYMBOL SYNONYM',
    english: 'cut (scissors)-(to)',
    swedish: 'klippa',
    norwegian: 'klippe (å)',
    finnish: 'leikata saksilla',
    hungarian: 'olló',
    german: 'schneiden, ausschneiden, zuschneiden',
    dutch: 'knippen',
    afrikaans: 'knip (om te)',
    russian: 'стричь, вырезать',
    latvian: 'griezt, nogriezt (ar šķērēm)',
    polish: 'ciąć (nożyce)',
    french: 'couper, découper',
    spanish: 'cortar (tijeras)',
  },
  {
    av: 13629,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(knife + action indicator) SYMBOL SYNONYM',
    english: 'cut (knife)-(to)',
    swedish: 'skära',
    norwegian: 'skjære',
    finnish: 'leikata',
    hungarian: 'vágni (késsel)',
    german: 'schneiden',
    dutch: 'snijden',
    afrikaans: 'sny (om te)',
    russian: 'резать',
    latvian: 'griezt (ar nazi)',
    polish: 'ciąć (nóż)',
    french: 'couper',
    spanish: 'cortar (cuchillo)',
  },
  {
    av: 13630,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + knife)',
    english: 'cutlery',
    swedish: 'bestick',
    norwegian: 'bestikk',
    finnish: 'teräaseet',
    hungarian: 'evőeszköz',
    german: 'Besteck',
    dutch: 'bestek',
    afrikaans: 'eetgerei',
    russian: 'столовые приборы',
    latvian: 'galda piederumi',
    polish: 'sztućce',
    french: 'couverts, coutellerie',
    spanish: 'cubiertos',
  },
  {
    av: 13631,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(dance, dancing + action indicator: to step to the rhythm of the music)',
    english: 'dance-(to)',
    swedish: 'dansa',
    norwegian: 'danse',
    finnish: 'tanssia',
    hungarian: 'táncolni',
    german: 'tanzen',
    dutch: 'dansen',
    afrikaans: 'dans (om te)',
    russian: 'танцевать',
    latvian: 'dejot',
    polish: 'tańczyć',
    french: 'danser',
    spanish: 'bailar',
  },
  {
    av: 13633,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(danger + description indicator)',
    english: 'dangerous',
    swedish: 'farlig',
    norwegian: 'farlig',
    finnish: 'vaarallinen',
    hungarian: 'veszélyes',
    german: 'gefährlich',
    dutch: 'gevaarlijk',
    afrikaans: 'gevaarlik, gevaarlike',
    russian: 'опасный',
    latvian: 'bīstams',
    polish: 'niebezpiecznie',
    french: 'dangereux',
    spanish: 'peligroso',
  },
  {
    av: 13635,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(to meet + man + woman: a man and a woman meeting each other socially) SYMBOL SYNONYM',
    english: 'date (man woman)',
    swedish: 'träff (man kvinna)',
    norwegian: 'stevnemøte (mann kvinne), date (mann kvinne) ',
    finnish: 'treffit',
    hungarian: 'randevú, randi, találka (férfi, nő között)',
    german: 'Verabredung, Date, Rendezvous (Mann und Frau)',
    dutch: 'afspraakje (man vrouw), date (man vrouw)',
    afrikaans: 'afspraak (man en vrou)',
    russian: 'свидание (женщина, мужчина)',
    latvian: 'tikšanās, randiņš (vīr ar siev.)',
    polish: 'randka, spotkanie (heteroseksualna para)',
    french: 'rendez-vous amoureux (hétérosexuel)',
    spanish: 'cita (heterosexual)',
  },
  {
    av: 13636,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to meet + person + person) SYMBOL SYNONYM',
    english: 'date (two persons)',
    swedish: 'träff (två personer)',
    norwegian: 'stevnemøte, date (to personer)',
    finnish: 'treffit',
    hungarian: 'találkozó, randevú (két személy között)',
    german: 'Verabredung, Date, Rendezvous (zwei Personen)',
    dutch: 'afspraak',
    afrikaans: 'afspraak (twee persone)',
    russian: 'свидание (две персоны)',
    latvian: 'tikšanās (divu personu)',
    polish: 'randka, spotkanie (2 osoby)',
    french: 'rendez-vous (2 personnes)',
    spanish: 'cita (dos personas)',
  },
  {
    av: 13637,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plum (fruit + pit) + palm tree: fruit that grows on a palm tree)',
    english: 'date (fruit)',
    swedish: 'dadel',
    norwegian: 'daddel',
    finnish: 'taateli',
    hungarian: 'datolya',
    german: 'Dattel',
    dutch: 'dadel',
    afrikaans: 'dadel (vrug)',
    russian: 'финик',
    latvian: 'datele (auglis)',
    polish: 'daktyl',
    french: 'datte (fruit)',
    spanish: 'dátil (fruta)',
  },
  {
    av: 13640,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + day)',
    english: 'daycare',
    swedish: 'dagvård',
    norwegian: 'dagtilsyn',
    finnish: 'päivähoito',
    hungarian: 'napközi',
    german: 'Tagesbetreuung',
    dutch: 'dagzorg',
    afrikaans: 'dagsorg',
    russian: 'дневной уход',
    latvian: 'dienas aprūpe',
    polish: 'opieka dzienna, forma przedszkola (niekoniecznie tylko dla dzieci)',
    french: "service d'accueil de jour",
    spanish: 'guardería',
  },
  {
    av: 13641,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + day care)',
    english: 'day care centre',
    swedish: 'daghem (etc)',
    norwegian: 'daghjem',
    finnish: 'päiväkoti',
    hungarian: 'napközi otthon',
    german: 'Tagesstätte',
    dutch: 'dagcentrum, dagverblijf',
    afrikaans: 'dagsorgsentrum',
    russian: 'дневной центр',
    latvian: 'dienas (aprūpes) centrs',
    polish: 'dzienne centrum opieki',
    french: "centre d'accueil de jour",
    spanish: 'centro de día',
  },
  {
    av: 13642,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(death + description after the fact indicator)',
    english: 'dead, deceased',
    swedish: 'död (adj.)',
    norwegian: 'avdød, død',
    finnish: 'kuollut',
    hungarian: 'halott, meghalt, elhúnyt',
    german: 'tot',
    dutch: 'dood',
    afrikaans: 'dood, oorlede',
    russian: 'мёртвый',
    latvian: 'miris',
    polish: 'martwy, zmarły',
    french: 'mort (après le fait)',
    spanish: 'muerto',
  },
  {
    av: 13643,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(deafness + description indicator: unable to hear) See also: hearing-impaired 26009',
    english: 'deaf',
    swedish: 'döv',
    norwegian: 'døv',
    finnish: 'kuuro',
    hungarian: 'siket',
    german: 'taub',
    dutch: 'doof',
    afrikaans: 'doof',
    russian: 'глухой',
    latvian: 'kurls',
    polish: 'głuchy, niesłyszący',
    french: 'sourd',
    spanish: 'sordo',
  },
  {
    av: 13644,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation:
      '(feeling + toward: symbol showing affectionate or friendly feelings toward someone. It is used as a salutation in letters.)',
    english: 'dear',
    swedish: 'kära',
    norwegian: 'kjære',
    finnish: 'rakas, hyvä, kulta',
    hungarian: 'drága, kedves',
    german: 'Liebe (Briefanrede), Lieber (Briefanrede)',
    dutch: 'lieve, beste',
    afrikaans: 'geagte, beste, liewe',
    russian: 'дорогой, милый',
    latvian: 'mīļotais, dārgais',
    polish: 'drogi, kochany (uczucie)',
    french: 'cher',
    spanish: 'querido, querida',
  },
  {
    av: 13646,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(10 + year: a period of ten years)',
    english: 'decade',
    swedish: 'årtionde, decennium',
    norwegian: 'tiår, decennium',
    finnish: 'vuosikymmen',
    hungarian: 'évtized',
    german: 'Jahrzehnt',
    dutch: 'decennium',
    afrikaans: 'dekade',
    russian: 'десятилетие',
    latvian: 'desmitgade',
    polish: 'Dekada (10 lat)',
    french: 'décennie',
    spanish: 'década',
  },
  {
    av: 13647,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 12: twelfth month of the year)',
    english: 'December',
    swedish: 'december',
    norwegian: 'desember',
    finnish: 'joulukuu',
    hungarian: 'december',
    german: 'Dezember',
    dutch: 'december',
    afrikaans: 'Desember',
    russian: 'декабрь',
    latvian: 'decembris',
    polish: 'grudzień',
    french: 'décembre',
    spanish: 'Diciembre',
  },
  {
    av: 13648,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(decision + action indicator)',
    english: 'decide-(to)',
    swedish: 'besluta, bestämma',
    norwegian: 'beslutte, bestemme',
    finnish: 'päättää',
    hungarian: 'dönteni, eldönteni, határozni, elhatározni',
    german: 'sich entscheiden',
    dutch: 'beslissen, besluiten',
    afrikaans: 'beslis, besluit (om te)',
    russian: 'решать',
    latvian: 'pieņemt lēmumu',
    polish: 'decydować',
    french: 'décider',
    spanish: 'decidir',
  },
  {
    av: 13651,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(little + action indicator: to become smaller)',
    english: 'decrease, reduce-(to)',
    swedish: 'minska, förminska',
    norwegian: 'forminske, redusere',
    finnish: 'vähetä, vähentyä, vähentää, pienentyä',
    hungarian: 'csökkenni, csökkenteni, kicsinyíteni, redukálnią',
    german: 'verkleinern, vermindern, verringern, herabsetzen, reduzieren',
    dutch: 'verkleinen, krimpen',
    afrikaans: 'verminder, verklein (om te)',
    russian: 'уменьшать',
    latvian: 'samazināt',
    polish: 'zmniejszać, pomniejszać',
    french: 'diminuer',
    spanish: 'disminuir, reducir',
  },
  {
    av: 13652,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(depth + description indicator: the pointer points downward to the bottom of a relatively deep space)',
    english: 'deep',
    swedish: 'djup',
    norwegian: 'dyp',
    finnish: 'syvä',
    hungarian: 'mély',
    german: 'tief',
    dutch: 'diep',
    afrikaans: 'diep',
    russian: 'глубокий',
    latvian: 'dziļš, dziļa',
    polish: 'głęboki',
    french: 'profond',
    spanish: 'profundo',
  },
  {
    av: 13653,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to fry + intensity + action indicator: to fry at a high temperature)',
    english: 'deep-fry-(to)',
    swedish: 'fritera',
    norwegian: 'fritere',
    finnish: 'paistaa, friteerata',
    hungarian: 'sütni, hirtelen kisütni, kirántani zsírban, olajban',
    german: 'fritieren',
    dutch: 'frituren',
    afrikaans: 'diep-braai (om te)',
    russian: 'жарить во фритюре',
    latvian: 'uzcept',
    polish: 'smażyć w głębokim tłuszczu',
    french: 'frire, plonger dans la friture',
    spanish: 'freír',
  },
  {
    av: 13655,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + teeth + thing indicator)',
    english: 'toothpick',
    swedish: 'tandpetare, tandtråd',
    norwegian: 'tannpirker, tanntråd',
    finnish: 'hammaslanka',
    hungarian: 'fogselyem',
    german: 'Zahnseide',
    dutch: 'tandzijde, flosdraad, tandenstoker',
    afrikaans: 'tande flos',
    russian: 'зубочистка, зубная нить',
    latvian: 'zobu diegs',
    polish: 'nić dentystyczna',
    french: 'fil dentaire',
    spanish: 'hilo dental',
  },
  {
    av: 13656,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(doctor + teeth)',
    english: 'dentist',
    swedish: 'tandläkare',
    norwegian: 'tannlege',
    finnish: 'hammaslääkäri',
    hungarian: 'fogorvos',
    german: 'Zahnarzt, Zahnärztin',
    dutch: 'tandarts',
    afrikaans: 'tandarts',
    russian: 'стоматолог',
    latvian: 'zobārsts',
    polish: 'dentysta',
    french: 'dentiste',
    spanish: 'dentista',
  },
  {
    av: 13657,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical product + against + odour)',
    english: 'deodorant',
    swedish: 'deodorant',
    norwegian: 'deodorant',
    finnish: 'deodorantti',
    hungarian: 'dezodor, szagtalanító',
    german: 'Deodorant, Deo',
    dutch: 'deodorant',
    afrikaans: 'deodorant',
    russian: 'дезодорант',
    latvian: 'dezodorants',
    polish: 'dezodorant, perfum',
    french: 'déodorant',
    spanish: 'desodorante',
  },
  {
    av: 13658,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(reference line + forward: advancing arrow departs from the line)',
    english: 'departure',
    swedish: 'avresa, avgång',
    norwegian: 'avgang, avreise',
    finnish: 'lähtö, poistuminen',
    hungarian: 'távozás, eltávozás',
    german: 'Abreise',
    dutch: 'vertrek',
    afrikaans: 'vertrek',
    russian: 'отьезд',
    latvian: 'aizbraukšana ',
    polish: 'odejście, odjazd',
    french: 'départ',
    spanish: 'salida',
  },
  {
    av: 13659,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mood + fall-(to): also a combination of mood and sad + intensity)',
    english: 'depression',
    swedish: 'depression',
    norwegian: 'depresjon',
    finnish: 'masennus',
    hungarian: 'depresszió, lehangoltság, levertség',
    german: 'Depression',
    dutch: 'neerslachtigheid, depressie',
    afrikaans: 'depressie, neerslagtig, neerslagtigheid',
    russian: 'депрессия',
    latvian: 'depresija',
    polish: 'depresja, smutek, złe samopoczucie',
    french: 'dépression',
    spanish: 'depresión',
  },
  {
    av: 13660,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(down + action indicator)',
    english: 'descend, go down-(to)',
    swedish: 'gå ner, sjunka',
    norwegian: 'dale, synke',
    finnish: 'laskea, alentua, laskeutua',
    hungarian: 'lemenni, leereszkedni',
    german: 'heruntergehen, absteigen',
    dutch: 'naar beneden gaan, afdalen',
    afrikaans: 'na benede gaan, af gaan, afgaan, daal (om te)',
    russian: 'спускаться',
    latvian: 'doties lejup, nolaisties, piezemēties',
    polish: 'zejść na dół, zstąpić',
    french: 'descendre',
    spanish: 'descender',
  },
  {
    av: 13661,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to say + state of mind + action indicator: to say what you think exists)',
    english: 'describe-(to)',
    swedish: 'beskriva',
    norwegian: 'beskrive',
    finnish: 'kuvailla, kuvata',
    hungarian: 'leírni (szóban), elmesélni',
    german: 'beschreiben',
    dutch: 'beschrijven, omschrijven',
    afrikaans: 'beskryf (om te)',
    russian: 'описывать',
    latvian: 'aprakstīt',
    polish: 'opisywać, określać (słownie)',
    french: 'décrire',
    spanish: 'describir',
  },
  {
    av: 13662,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to want + description before the fact indicator)',
    english: 'desirable',
    swedish: 'efterlängtad, åtråvärd',
    norwegian: 'ønskelig, ønsket',
    finnish: 'toivottava, tavoiteltava',
    hungarian: 'kívánatos',
    german: 'erwünscht, wünschenswert, begehrenswert, erstrebenswert',
    dutch: 'wenselijk',
    afrikaans: 'wenslik',
    russian: 'желаемое',
    latvian: 'vēlamais',
    polish: 'pożądanie, pragnienie',
    french: 'souhaitable, attirant',
    spanish: 'deseable',
  },
  {
    av: 13663,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(table + work)',
    english: 'desk, worktable, work table',
    swedish: 'arbetsbord, skrivbord',
    norwegian: 'pult, arbeidsbord, skrivebord',
    finnish: 'työpöytä, kirjoituspöytä, pulpetti',
    hungarian: 'íróasztal, munkaasztal',
    german: 'Schreibtisch',
    dutch: 'bureau, werktafel',
    afrikaans: 'tafel, werkblad, werkoppervlak, lessenaar, werktafel',
    russian: 'письменный стол',
    latvian: 'sols, rakstamgalds, darba galds',
    polish: 'biurko, stół roboczy, stół warsztatowy',
    french: 'bureau',
    spanish: 'escritorio, mesa de trabajo',
  },
  {
    av: 13664,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + end: food that one eats at the end of a meal)',
    english: 'dessert',
    swedish: 'efterrätt, dessert',
    norwegian: 'dessert',
    finnish: 'jälkiruoka',
    hungarian: 'desszert, étkezés végi csemege',
    german: 'Nachtisch, Nachspeise',
    dutch: 'dessert, nagerecht, toetje',
    afrikaans: 'nagereg, poeding',
    russian: 'десерт',
    latvian: 'deserts',
    polish: 'deser, potrawa kończąca posiłek',
    french: 'dessert',
    spanish: 'postre',
  },
  {
    av: 13665,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(deletion, cancellation, destruction + action indicator: diagonal line used to cross out something)',
    english: 'destroy, annul, cancel, cross out, delete-(to)',
    swedish: 'förstöra, stryka ut, stryka, radera, sudda, ta bort, utplåna',
    norwegian: 'slette, stryke ut, annulere',
    finnish: 'yliviivata, poistaa, pilata',
    hungarian: 'megsemmisít, elpusztít, el/kitöröl, érvénytelenít',
    german: 'ausstreichen, zerstören, auslöschen',
    dutch: 'verwijderen, vernietigen',
    afrikaans: 'vernietig, kanselleer, uitvee, nietig verklaar (om te)',
    russian: 'уничтожить, удалить, стереть',
    latvian: 'iznīcināt, anulēt, atcelt, pārtraukt, iznīcināt, atsaukt',
    polish: 'przekreślić, zniszczyć, odwołać, unieważnić, przekreślić',
    french: 'détruire, supprimer',
    spanish: 'destruir, anular, cancelar, tachar, eliminar',
  },
  {
    av: 13666,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(development + action indicator)',
    english: 'develop-(to)',
    swedish: 'utveckla',
    norwegian: 'utvikle',
    finnish: 'kehittyä, kehittää, edistyä',
    hungarian: 'fejlődni, fejleszteni',
    german: 'entwickeln',
    dutch: 'ontwikkelen',
    afrikaans: 'onwikkel (om te)',
    russian: 'развивать, совершенствовать',
    latvian: 'attīstīt, uzlabot',
    polish: 'rozwijać się, wzmacniać',
    french: 'développer',
    spanish: 'desarrollar',
  },
  {
    av: 13668,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + around + man) (India)',
    english: 'dhoti, lungi',
    swedish: 'dhoti, lungi (Indien)',
    norwegian: 'dhoti, lungi (India)',
    finnish: 'dhoti',
    hungarian: 'dhoti, lungi (indiai férfiruházat)',
    german: 'Dhoti (traditionelles Beinkleid der indischen Männer)',
    dutch: 'dhoti (Indisch)',
    afrikaans: 'dhoti, lungi',
    russian: 'дхоти (Индия)',
    latvian: 'doti (India)',
    polish: 'dhoti (indyjski strój męski)',
    french: 'dhoti',
    spanish: 'dhoti, lungi (India)',
  },
  {
    av: 13669,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + diamond (character))',
    english: 'diamond (shape), rhombus, rhomb',
    swedish: 'romb',
    norwegian: 'rombe',
    finnish: 'timantin muotoinen',
    hungarian: 'gyémánt',
    german: 'Raute, Rhombus, Innenfeld',
    dutch: 'diamant (vorm), ruit (vorm)',
    afrikaans: 'diamant (vorm), ruit (vorm)',
    russian: 'ромб',
    latvian: 'rombs',
    polish: 'diament',
    french: 'losange (figure géométrique)',
    spanish: 'diamante',
  },
  {
    av: 13670,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(absorbent material + buttocks and genitals)',
    english: 'diaper, nappy',
    swedish: 'blöja',
    norwegian: 'bleie',
    finnish: 'vaippa',
    hungarian: 'pelenka',
    german: 'Windel',
    dutch: 'luier',
    afrikaans: 'doek, luier',
    russian: 'подгузник, памперс',
    latvian: 'autiņbiksītes',
    polish: 'pielucha, pieluchomajtki',
    french: 'lange, couche',
    spanish: 'pañal',
  },
  {
    av: 13671,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(barrier (contraceptive) + female)',
    english: 'diaphragm (contraceptive), pessary',
    swedish: 'pessar',
    norwegian: 'pessar',
    finnish: 'ehkäisyväline (naisen)',
    hungarian: 'fogamzásgátló (pesszárium, diafragma nőknél)',
    german: 'Diaphragma',
    dutch: 'pessarium',
    afrikaans: 'diafragma (kontraseptief), pessarium (kontraseptiewe)',
    russian: 'пессарий противозачаточный',
    latvian: 'gumijas uzmava, diafragma (kontracepcijas līdzeklis sievietēm) ',
    polish: 'wkładka antykoncepcyjna, membrana',
    french: 'diaphragme (contraceptif)',
    spanish: 'diafragma',
  },
  {
    av: 13672,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(death + action indicator)',
    english: 'die-(to)',
    swedish: 'dö, avlida',
    norwegian: 'dø',
    finnish: 'kuolla',
    hungarian: 'meghalni, elhalálozni',
    german: 'sterben',
    dutch: 'overlijden, doodgaan, sterven',
    afrikaans: 'doodgaan, sterf (om te)',
    russian: 'умирать',
    latvian: 'mirt',
    polish: 'umierać',
    french: 'mourir',
    spanish: 'morir',
  },
  {
    av: 13673,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plan + to eat)',
    english: 'diet',
    swedish: 'bantning, diet',
    norwegian: 'diett',
    finnish: 'dieetti, ruokavalio',
    hungarian: 'diéta, étrend',
    german: 'Diät',
    dutch: 'dieet',
    afrikaans: 'dieet',
    russian: 'диета',
    latvian: 'diēta',
    polish: 'dieta, odchudzanie',
    french: 'régime',
    spanish: 'dieta',
  },
  {
    av: 13674,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to eat + plan + action indicator: to eat according to a plan)',
    english: 'diet-(to)',
    swedish: 'banta, hålla diet',
    norwegian: 'slanke seg, være på diett',
    finnish: 'olla dieetillä, olla ruokavaliolla',
    hungarian: 'diétázni',
    german: 'Diät halten',
    dutch: 'dieet houden, lijnen, diëten',
    afrikaans: 'dieet (om te)',
    russian: 'соблюдать диету',
    latvian: 'ievērot diētu',
    polish: 'odchudzać się',
    french: 'faire régime, faire un régime',
    spanish: 'estar a dieta',
  },
  {
    av: 13676,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(difficulty + description indicator)',
    english: 'difficult, hard',
    swedish: 'svår',
    norwegian: 'vanskelig',
    finnish: 'vaikea',
    hungarian: 'nehéz, bonyolult',
    german: 'schwierig, schwer',
    dutch: 'moeilijk',
    afrikaans: 'moeilik, hard',
    russian: 'трудно',
    latvian: 'grūti',
    polish: 'trudny',
    french: 'difficile',
    spanish: 'difícil',
  },
  {
    av: 13677,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(digging, excavation + action indicator)',
    english: 'dig-(to)',
    swedish: 'gräva',
    norwegian: 'grave',
    finnish: 'kaivaa',
    hungarian: 'ásni (el-, le-, ki-)',
    german: 'graben',
    dutch: 'graven, spitten, omspitten',
    afrikaans: 'grou, spit, grawe (om te)',
    russian: 'копать, выкопать',
    latvian: 'izrakt, rakt',
    polish: 'kopać',
    french: 'creuser',
    spanish: 'cavar',
  },
  {
    av: 13678,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(digestion + action indicator)',
    english: 'digest-(to)',
    swedish: 'smälta maten',
    norwegian: 'fordøye',
    finnish: 'sulattaa ruoka (elimistössä)',
    hungarian: 'emészteni, megemészteni',
    german: 'verdauen',
    dutch: 'verteren',
    afrikaans: 'verteer (om te)',
    russian: 'переваривать пищу',
    latvian: 'sagremot',
    polish: 'trawić, przetrawiać',
    french: 'digérer',
    spanish: 'digerir',
  },
  {
    av: 13679,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + through: food passing through the body)',
    english: 'digestion',
    swedish: 'matsmältning',
    norwegian: 'fordøyelse',
    finnish: 'ruuansulatus, ruoansulatus',
    hungarian: 'emésztés',
    german: 'Verdauung',
    dutch: 'spijsvertering',
    afrikaans: 'spysvertering',
    russian: 'переваривание пищи',
    latvian: 'gremošana',
    polish: 'trawienie',
    french: 'digestion',
    spanish: 'digestión',
  },
  {
    av: 13680,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + to eat)',
    english: 'dining room',
    swedish: 'matrum, matsal',
    norwegian: 'spisestue, matsal, spiserom',
    finnish: 'ruokahuone, ruokailutila, ruokailuhuone, ruokasali',
    hungarian: 'ebédlő, étkező',
    german: 'Esszimmer',
    dutch: 'eetkamer',
    afrikaans: 'eetkamer',
    russian: 'столовая',
    latvian: 'ēdnīca, ēdamtelpa',
    polish: 'jadalnia',
    french: 'salle à manger',
    spanish: 'comedor',
  },
  {
    av: 13682,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + forward)',
    english: 'direction, cardinal point',
    swedish: 'riktning',
    norwegian: 'retning',
    finnish: 'suunta',
    hungarian: 'irány, irányzat',
    german: 'Richtung',
    dutch: 'richting',
    afrikaans: 'rigting, kardinale punt',
    russian: 'направление',
    latvian: 'virziens, galvenie horizonta punkti',
    polish: 'kierunek, cel',
    french: 'direction, orientation, point cardinal',
    spanish: 'dirección, punto cardinal',
  },
  {
    av: 13683,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(many + spot + description indicator: having many spots)',
    english: 'dirty, soiled',
    swedish: 'smutsig, fläckig',
    norwegian: 'skitten, flekket',
    finnish: 'likainen',
    hungarian: 'piszkos, szennyes',
    german: 'schmutzig',
    dutch: 'vies, vuil, smerig',
    afrikaans: 'vuil, besmeer',
    russian: 'грязный',
    latvian: 'netīrs, savazāts',
    polish: 'brudne, zanieczyszczone',
    french: 'sale',
    spanish: 'sucio, manchado',
  },
  {
    av: 13686,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gathering + record: gathering to listen to recorded music)',
    english: 'disco',
    swedish: 'disco',
    norwegian: 'diskotek',
    finnish: 'disko',
    hungarian: 'diszkó',
    german: 'Disco',
    dutch: 'disco, fuif',
    afrikaans: 'diskoteek',
    russian: 'дискотека',
    latvian: 'diskotēka',
    polish: 'disco (muzyka dyskotekowa)',
    french: 'discothèque, disco',
    spanish: 'discoteca',
  },
  {
    av: 13688,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(discussion + action indicator)',
    english: 'discuss, converse, debate-(to)',
    swedish: 'samtala',
    norwegian: 'samtale, drøfte, diskutere',
    finnish: 'keskustella',
    hungarian: 'beszélgetni, megbeszélni, megvitatni',
    german: 'sich unterhalten, diskutieren',
    dutch: 'converseren, bespreken, debateren',
    afrikaans: 'bespreek, debatteer, kommunikeer (om te)',
    russian: 'разговаривать, беседовать',
    latvian: 'sarunāties, runāties, debatēt',
    polish: 'dyskutować, debatować, wymieniać poglądy',
    french: 'discuter de, débattre',
    spanish: 'discutir, conversar, debatir',
  },
  {
    av: 13689,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to speak + back and forth: talk that goes back and forth)',
    english: 'discussion, conversation, debate, chat',
    swedish: 'samtal',
    norwegian: 'samtale, drøfting, diskusjon',
    finnish: 'jutteleminen, keskustelu',
    hungarian: 'társalgás, beszélgetés, megvitatás, csevegés',
    german: 'Gespräch, Diskussion, Debatte, Chat',
    dutch: 'gesprek, conversatie',
    afrikaans: 'bespreek, kommunikeer, gesels, debatteer',
    russian: 'разговор, беседа',
    latvian: 'saruna, diskusija, debate, pļāpāšana',
    polish: 'dyskusja, debata, wymiana poglądów',
    french: 'discussion, conversation',
    spanish: 'discusión, conversación, debate',
  },
  {
    av: 13691,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + negative)',
    english: 'dislike',
    swedish: 'motvilja, ogillande',
    norwegian: 'motvilje',
    finnish: 'vastenmielisyys',
    hungarian: 'idegenkedés, rosszallás, utálat',
    german: 'Abneigung, Widerwille',
    dutch: 'afkeer, hekel',
    afrikaans: 'hekel, afkeur (hou nie van)',
    russian: 'неприязнь, отвращение',
    latvian: 'nepatika',
    polish: 'niechęć, nienawiść',
    french: 'aversion, antipathie',
    spanish: 'aversión',
  },
  {
    av: 13692,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(dislike + action indicator)',
    english: 'dislike-(to)',
    swedish: 'tycka illa om, ogilla',
    norwegian: 'mislike',
    finnish: 'halveksia, vihata',
    hungarian: 'idegenkedni, rosszallni, nem szeretni, utálni',
    german: '(jemanden) nicht leiden können, nicht gern haben',
    dutch: 'een hekel hebben aan',
    afrikaans: "om 'n hekel te hê, afkeur (om te)",
    russian: 'ненавидеть (СТАРОЕ зн)',
    latvian: 'nepatikt',
    polish: 'nie lubić, nienawidzić, nie znosić',
    french: 'détester, ne pas aimer',
    spanish: 'desagradar',
  },
  {
    av: 13694,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(division + action indicator)',
    english: 'divide-(to)',
    swedish: 'dela, dividera',
    norwegian: 'dele, dividere',
    finnish: 'jakaa, suorittaa jakolasku',
    hungarian: 'osztani (el-, meg-, be-, szét-)',
    german: 'teilen, dividieren, aufteilen, verteilen',
    dutch: 'delen, verdelen',
    afrikaans: 'deel, verdeel (om te)',
    russian: 'делить, разделить',
    latvian: 'dalīt, sadalīt',
    polish: 'dzielić',
    french: 'diviser',
    spanish: 'dividir',
  },
  {
    av: 13858,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(marriage + division: legal division of a marriage)',
    english: 'divorce',
    swedish: 'skilsmässa',
    norwegian: 'skilsmisse',
    finnish: 'avioero',
    hungarian: 'válás',
    german: 'Scheidung, Trennung',
    dutch: 'scheiding',
    afrikaans: 'egskeiding',
    russian: 'развод, расторжение брака',
    latvian: 'šķiršanās',
    polish: 'rozwód',
    french: 'divorce',
    spanish: 'divorcio',
  },
  {
    av: 13859,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(divorce + action indicator)',
    english: 'divorce-(to)',
    swedish: 'skiljas',
    norwegian: 'skille seg',
    finnish: 'erota avioliitosta',
    hungarian: 'válni, elválni',
    german: 'sich scheiden, trennen',
    dutch: 'scheiden',
    afrikaans: 'skei (om te)',
    russian: 'развестись',
    latvian: 'šķirties',
    polish: 'rozwodzić się',
    french: 'divorcer',
    spanish: 'divorciarse',
  },
  {
    av: 13860,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(action + action indicator)',
    english: 'do, act-(to)',
    swedish: 'göra',
    norwegian: 'gjøre, handle',
    finnish: 'tehdä, toimia',
    hungarian: 'tenni, cselekedni',
    german: 'tun',
    dutch: 'doen',
    afrikaans: 'doen, reageer (om te)',
    russian: 'делать',
    latvian: 'darīt, rīkoties',
    polish: 'robić, działać',
    french: 'faire, agir',
    spanish: 'hacer',
  },
  {
    av: 13861,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + medical)',
    english: 'doctor, physician',
    swedish: 'läkare, doktor',
    norwegian: 'doktor, lege',
    finnish: 'lääkäri',
    hungarian: 'orvos, doktor',
    german: 'Ärztin, Arzt, Doktor, Doktorin',
    dutch: 'dokter, arts',
    afrikaans: 'dokter, arts',
    russian: 'врач, доктор',
    latvian: 'ārsts, mediķis',
    polish: 'lekarz',
    french: 'docteur, médecin',
    spanish: 'doctor, médico',
  },
  {
    av: 13862,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(child + man-made)',
    english: 'doll',
    swedish: 'docka',
    norwegian: 'dokke',
    finnish: 'nukke',
    hungarian: 'baba',
    german: 'Puppe',
    dutch: 'pop',
    afrikaans: 'pop',
    russian: 'кукла',
    latvian: 'lelle',
    polish: 'lalka',
    french: 'poupée',
    spanish: 'muñeca',
  },
  {
    av: 13865,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(horse + work: animal that resembles a horse and is commonly used to assist with work)',
    english: 'donkey, mule',
    swedish: 'åsna, mula',
    norwegian: 'esel, muldyr',
    finnish: 'aasi, muuli',
    hungarian: 'szamár, öszvér',
    german: 'Esel',
    dutch: 'ezel',
    afrikaans: 'donkie, esel',
    russian: 'осёл',
    latvian: 'ēzelis, mūlis',
    polish: 'muł, osioł',
    french: 'âne, mulet',
    spanish: 'asno, mula',
  },
  {
    av: 13868,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(doubt, uncertainty + action indicator)',
    english: 'doubt-(to)',
    swedish: 'undra, vara osäker',
    norwegian: 'tvile, undre',
    finnish: 'epäillä, epäröidä',
    hungarian: 'kételkedni, kétségbe vonni',
    german: 'zweifeln',
    dutch: 'twijfelen',
    afrikaans: 'twyfel (om te)',
    russian: 'сомневаться',
    latvian: 'šaubas',
    polish: 'wątpić, być niepewnym',
    french: 'douter',
    spanish: 'dudar',
  },
  {
    av: 13872,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(sieve + action indicator)',
    english: 'drain, sift, strain-(to)',
    swedish: 'sila, filtrera, tömma',
    norwegian: 'sile, filtrere, tømme',
    finnish: 'siivilöidä, valuttaa',
    hungarian: 'szűrni (le-, át-, meg-)',
    german: 'abschütten, sieben, durchsieben, filtern',
    dutch: 'afgieten, zeven',
    afrikaans: 'drein, sif, giet (om te)',
    russian: 'процедить, фильтровать',
    latvian: 'filtrēt',
    polish: 'ciec, przesiewać (przez durszlak lub sito)',
    french: 'égoutter',
    spanish: 'drenar, tamizar, colar, filtrar',
  },
  {
    av: 13873,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(pencil + picture + action indicator: to use a pencil or pen to make a picture)',
    english: 'draw, sketch-(to)',
    swedish: 'rita, teckna',
    norwegian: 'tegne, skissere',
    finnish: 'piirtää',
    hungarian: 'rajzolni, skiccelni, felvázolni',
    german: 'zeichnen',
    dutch: 'tekenen',
    afrikaans: 'teken, skets (om te)',
    russian: 'рисовать',
    latvian: 'zīmēt',
    polish: 'rysować, szkicować',
    french: 'dessiner',
    spanish: 'dibujar',
  },
  {
    av: 13875,
    group: 'word',
    pos: 'RED',
    derivationExplanation: "(to think + to sleep + action indicator: to think in one's sleep)",
    english: 'dream-(to)',
    swedish: 'drömma',
    norwegian: 'drømme',
    finnish: 'uneksia, nähdä unta',
    hungarian: 'álmodni',
    german: 'träumen',
    dutch: 'dromen',
    afrikaans: 'droom (om te)',
    russian: 'сниться',
    latvian: 'sapņot',
    polish: 'śnić, spać',
    french: 'rêver',
    spanish: 'soñar',
  },
  {
    av: 13876,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + woman)',
    english: 'dress',
    swedish: 'klänning',
    norwegian: 'kjole',
    finnish: 'mekko',
    hungarian: 'ruha, női ruhanemű',
    german: 'Kleid',
    dutch: 'jurk, kleed (Vl)',
    afrikaans: 'rok',
    russian: 'платье',
    latvian: 'kleita',
    polish: 'sukienka',
    french: 'robe',
    spanish: 'vestido',
  },
  {
    av: 13877,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(clothing + action indicator)',
    english: 'dress, wear-(to)',
    swedish: 'klä på, ha på sig',
    norwegian: 'kle på seg, ha på seg',
    finnish: 'pukea, riisua',
    hungarian: 'öltözni, öltözködni, felöltözni, viselni',
    german: 'anziehen, tragen, ankleiden',
    dutch: 'aankleden, aantrekken',
    afrikaans: 'aantrek, klee (om te)',
    russian: 'одевать (ся)',
    latvian: 'ģerbties, uzvilkt',
    polish: 'ubierać się',
    french: "habiller-(s')",
    spanish: 'vestirse, llevar puesto',
  },
  {
    av: 13878,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(costume + action indicator: people 'dress up' to imagine themselves as someone or something else, e.g. at Halloween)",
    english: 'dress up, disguise-(to)',
    swedish: 'klä ut sig',
    norwegian: 'kle seg ut',
    finnish: 'pukeutua naamiopukuun, naamioitua, pukeutua naamiaisasuun',
    hungarian: 'jelmezt vagy álruhát ölteni',
    german: 'sich kostümieren, (sich schick anziehen), verkleiden',
    dutch: 'verkleden, vermommen',
    afrikaans: 'vermom (om te)',
    russian: 'наряжать (ся)',
    latvian: 'apģēbties svētku tērpā, karnevāla tērpā',
    polish: 'przebierać się, ubierać kostium',
    french: 'déguiser-(se)',
    spanish: 'vestirse, disfrazarse',
  },
  {
    av: 13879,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + comfort)',
    english: 'dressing gown, housecoat, robe',
    swedish: 'morgonrock, hemmadress',
    norwegian: 'morgenkåpe, kosedress',
    finnish: 'aamutakki, kotiasu',
    hungarian: 'házikabát, pongyola, otthonka, köpeny',
    german: 'Hausanzug, Hausmantel, Bademantel',
    dutch: 'ochtendjas, kamerjas',
    afrikaans: 'japon, kamerjas, oorjas',
    russian: 'халат',
    latvian: 'rītasvārki, rītakleita, halāts, virssvārki',
    polish: 'szlafrok, podomka',
    french: 'peignoir, robe de chambre',
    spanish: 'bata, salto de cama, batón',
  },
  {
    av: 13882,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(drink + action indicator)',
    english: 'drink-(to)',
    swedish: 'dricka',
    norwegian: 'drikke',
    finnish: 'juoda',
    hungarian: 'inni',
    german: 'trinken',
    dutch: 'drinken',
    afrikaans: 'drink (om te)',
    russian: 'пить',
    latvian: 'dzert',
    polish: 'pić',
    french: 'boire',
    spanish: 'beber',
  },
  {
    av: 13883,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(car + action indicator)',
    english: 'drive-(to)',
    swedish: 'köra bil, åka bil',
    norwegian: 'kjøre bil',
    finnish: 'ajaa autolla, ajaa autoa',
    hungarian: 'vezetni (autót, járművet)',
    german: 'fahren, lenken, führen, steuern',
    dutch: 'autorijden',
    afrikaans: 'bestuur, ry (om te)',
    russian: 'водить автомобиль',
    latvian: 'vadīt, braukt',
    polish: 'prowadzić samochód, jechać',
    french: 'conduire',
    spanish: 'conducir',
  },
  {
    av: 13884,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + car)',
    english: 'driver, chauffeur',
    swedish: 'bilförare, chaufför',
    norwegian: 'sjåfør, bilfører',
    finnish: 'autonkuljettaja',
    hungarian: 'gépkocsivezető, járművezető, sofőr',
    german: 'Fahrer, Fahrerin, Chauffeur, Chauffeurin',
    dutch: 'chauffeur, bestuurder',
    afrikaans: 'bestuurder, chauffeur',
    russian: 'водитель, шофёр',
    latvian: 'autovadītājs, šoferis',
    polish: 'kierowca, szofer',
    french: 'chauffeur',
    spanish: 'conductor, chofer',
  },
  {
    av: 13886,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(weak person + alcoholic drink + description indicator: when drunk a person’s knees may buckle)',
    english: 'drunk',
    swedish: 'berusad, full',
    norwegian: 'beruset, full',
    finnish: 'juopunut',
    hungarian: 'részeg (mn.)',
    german: 'betrunken',
    dutch: 'dronken, zat',
    afrikaans: 'dronk',
    russian: 'пьяный',
    latvian: 'piedzēries',
    polish: 'pijany',
    french: 'saoul, ivre',
    spanish: 'ebrio, borracho',
  },
  {
    av: 13889,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + duck)',
    english: 'duck (food)',
    swedish: 'anka (mat)',
    norwegian: 'and (mat)',
    finnish: 'vesilintu (ruoka), ankka (ruoka)',
    hungarian: 'kacsahús',
    german: 'Ente (Essen)',
    dutch: 'eend (voedsel)',
    afrikaans: 'eend kos',
    russian: 'утка (еда)',
    latvian: 'pīles gaļa (pārtika)',
    polish: 'kaczka (drób)',
    french: 'canard (nourriture)',
    spanish: 'pato (alimento)',
  },
  {
    av: 13890,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(truck + out of (downward))',
    english: 'dump truck, dumper, tipper lorry, tipper',
    swedish: 'tippbil, dumper',
    norwegian: 'lastebil med tipp, dumper',
    finnish: 'jäteauto, kippiauto',
    hungarian: 'dömper, billenős teherautó, billencs',
    german: 'Kipper, LKW',
    dutch: 'vuilniswagen',
    afrikaans: 'vullistrok',
    russian: 'самосвал',
    latvian: 'pašizgāzējs',
    polish: 'wywrotka, samochód ciężarowy z możliwością zrzucenia towaru (podniesienia paki)',
    french: 'camion benne',
    spanish: 'volquete',
  },
  {
    av: 13891,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(goddess + 10 + hand: Hindu goddess) (India)',
    english: 'Durga',
    swedish: 'Durga (Indien)',
    norwegian: 'Durga (India)',
    finnish: 'Durga',
    hungarian: 'Durga (tízkarú hindu Istennő)',
    german: 'Durga (indische Hindu-Göttin)',
    dutch: 'Durga (Indisch)',
    afrikaans: 'Durga',
    russian: 'Дурга (Индии)',
    latvian: 'Duga (India)',
    polish: 'Durga (indyjska bogini o 10 rękach)',
    french: 'Durga (hindouisme)',
    spanish: 'Durga (India)',
  },
  {
    av: 13893,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(1 + all: one of all)',
    english: 'each, every',
    swedish: 'varje, var och en',
    norwegian: 'hver, enhver, hver og en',
    finnish: 'jokainen, kukin',
    hungarian: 'mind, mindegyik, minden egyes',
    german: 'jede, jedes (einzelne)',
    dutch: 'elk, ieder',
    afrikaans: 'ieder, elk',
    russian: 'каждый',
    latvian: 'jebkurš, jekura, ikviens, ikviena',
    polish: 'każdy, wszyscy',
    french: 'chaque',
    spanish: 'cada, cada uno, cada una',
  },
  {
    av: 13896,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(before + time + description indicator: before the appointed time)',
    english: 'early',
    swedish: 'tidig',
    norwegian: 'tidlig',
    finnish: 'aikainen, ajoissa',
    hungarian: 'korai, korán, időnek előtte',
    german: 'früh',
    dutch: 'vroeg',
    afrikaans: 'vroeg',
    russian: 'ранний, рано',
    latvian: 'agrs, agri',
    polish: 'wcześnie, na czas, rychło',
    french: 'tôt',
    spanish: 'temprano',
  },
  {
    av: 13897,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + ear)',
    english: 'earmuffs (protection)',
    swedish: 'öronlappar',
    norwegian: 'ørebeskyttelse, hørselsvern',
    finnish: 'korvalaput, kuulonsuojaimet',
    hungarian: 'fülvédő',
    german: 'Ohrenschützer (Kälte)',
    dutch: 'oorwarmers, oorverwarmers',
    afrikaans: 'gehoortoestel (beskerming)',
    russian: 'утеплитель для ушей',
    latvian: 'ausu sildītājs',
    polish: 'nauszniki, ocieplacze na uszy',
    french: 'protège-oreille',
    spanish: 'orejeras (protección)',
  },
  {
    av: 13898,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to work + for (in exchange for) + money: to work in exchange for money)',
    english: 'earn-(to)',
    swedish: 'tjäna, förtjäna',
    norwegian: 'tjene penger',
    finnish: 'ansaita rahaa',
    hungarian: 'keresni (pénzt)',
    german: 'verdienen',
    dutch: 'verdienen',
    afrikaans: 'verdien (om te)',
    russian: 'зарабатывать',
    latvian: 'pelnīt',
    polish: 'zarabiać, zasługiwać',
    french: 'gagner (argent)',
    spanish: 'ganar',
  },
  {
    av: 13899,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(earmuffs (general) + electricity)',
    english: 'earphones, headphones',
    swedish: 'hörlurar',
    norwegian: 'hodetelefoner',
    finnish: 'korvakuulokkeet',
    hungarian: 'fülhallgató, fejhallgató',
    german: 'Kopfhörer',
    dutch: 'koptelefoon',
    afrikaans: 'oorfone',
    russian: 'наушники',
    latvian: 'austiņas',
    polish: 'słuchawki',
    french: 'écouteurs',
    spanish: 'auriculares',
  },
  {
    av: 13903,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(day + to rise + Christ [contraction]: the day of Christ's rising from the dead)",
    english: 'easter',
    swedish: 'påsk',
    norwegian: 'påske',
    finnish: 'pääsiäinen',
    hungarian: 'húsvét',
    german: 'Ostern',
    dutch: 'Pasen',
    afrikaans: 'Pase, Paasfees',
    russian: 'Пасха',
    latvian: 'Lieldienas',
    polish: 'Wielkanoc',
    french: 'jour de Pâques, Pâques',
    spanish: 'pascua',
  },
  {
    av: 13904,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(east + description indicator)',
    english: 'eastern',
    swedish: 'ostlig',
    norwegian: 'østlig',
    finnish: 'itäinen, itä-',
    hungarian: 'keleti',
    german: 'östlich',
    dutch: 'oostelijk, oosters',
    afrikaans: 'ooste, oostelike',
    russian: 'восточный',
    latvian: 'austrumu',
    polish: 'wschodni, wschodnia',
    french: "de l'est",
    spanish: 'oriental',
  },
  {
    av: 13906,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(food + action indicator)',
    english: 'eat-(to)',
    swedish: 'äta',
    norwegian: 'spise',
    finnish: 'syödä',
    hungarian: 'enni',
    german: 'essen',
    dutch: 'eten',
    afrikaans: 'eet (om te)',
    russian: 'есть, кушать',
    latvian: 'ēst',
    polish: 'jeść',
    french: 'manger',
    spanish: 'comer',
  },
  {
    av: 13908,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to exchange + knowledge)',
    english: 'education',
    swedish: 'utbildning',
    norwegian: 'utdannelse',
    finnish: 'koulutus',
    hungarian: 'nevelés, oktatás',
    german: 'Ausbildung, Erziehung',
    dutch: 'onderwijs',
    afrikaans: 'onderwys',
    russian: 'образование',
    latvian: 'izglītība',
    polish: 'edukacja, nauka',
    french: 'instruction, éducation, formation',
    spanish: 'educación',
  },
  {
    av: 13909,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + snake: snake-like fish)',
    english: 'eel',
    swedish: 'ål',
    norwegian: 'ål',
    finnish: 'ankerias',
    hungarian: 'angolna',
    german: 'Aal',
    dutch: 'paling',
    afrikaans: 'paling',
    russian: 'угорь',
    latvian: 'zutis',
    polish: 'węgorz',
    french: 'anguille',
    spanish: 'anguila',
  },
  {
    av: 13911,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(seed + life) SYMBOL SYNONYM',
    english: 'egg, ovum (1)',
    swedish: 'ägg (1)',
    norwegian: 'egg, eggcelle (1)',
    finnish: 'muna',
    hungarian: 'tojás, pete (jelkép szinoníma)',
    german: 'Ei (1)',
    dutch: 'ei (1)',
    afrikaans: 'eier, eiersel (1)',
    russian: 'яйцо (1)',
    latvian: 'ola (1)',
    polish: 'jajo, komórka jajowa, jajko (1)',
    french: 'œuf, graine (1)',
    spanish: 'huevo, óvulo (1)',
  },
  {
    av: 13913,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vegetable (cylinder-shaped) + purple)',
    english: 'eggplant, aubergine, brinjal',
    swedish: 'aubergine, äggplanta',
    norwegian: 'aubergine',
    finnish: 'munakoiso',
    hungarian: 'padlizsán',
    german: 'Aubergine',
    dutch: 'aubergine',
    afrikaans: 'eiervrug',
    russian: 'баклажан',
    latvian: 'baklažāns',
    polish: 'bakłażan, oberżyna (warzywo)',
    french: 'aubergine',
    spanish: 'berenjena',
  },
  {
    av: 13915,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: 'ejaculation (erection + sperm + intensity)',
    english: 'ejaculation',
    swedish: 'utlösning',
    norwegian: 'utløsning',
    finnish: 'siemensyöksy',
    hungarian: 'magömlés, ejakuláció',
    german: 'Ejakulation',
    dutch: 'zaadlozing, ejaculatie',
    afrikaans: 'ejakulasie',
    russian: 'эякуляция',
    latvian: 'ejakulācija',
    polish: 'wytrysk',
    french: 'éjaculation',
    spanish: 'eyaculación',
  },
  {
    av: 13917,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(electricity + description indicator)',
    english: 'electric, electrical',
    swedish: 'elektrisk',
    norwegian: 'elektrisk',
    finnish: 'sähköinen',
    hungarian: 'elektromos, villamos',
    german: 'elektrisch',
    dutch: 'elektrisch',
    afrikaans: 'elektriese, elektries',
    russian: 'электрический',
    latvian: 'elektrisks, elektriskais',
    polish: 'elektryczny, na prąd',
    french: 'électrique',
    spanish: 'eléctrico',
  },
  {
    av: 13919,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(light + electricity + thing indicator: object that provides light by means of electricity)',
    english: 'electric light, lamp',
    swedish: 'lampa',
    norwegian: 'lampe',
    finnish: 'sähkövalo, lamppu',
    hungarian: 'lámpa, villanyégő, elektromos világítás',
    german: 'Lampe',
    dutch: 'lamp',
    afrikaans: 'elektriese lig, lamp',
    russian: 'лампа, люстра ',
    latvian: 'elektriskā gaisma, lampa',
    polish: 'światło elektryczne, lampa',
    french: 'lampe, lampe électrique',
    spanish: 'luz eléctrica, lámpara',
  },
  {
    av: 13920,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wheelchair + electricity)',
    english: 'electric wheelchair',
    swedish: 'elrullstol',
    norwegian: 'elektrisk rullestol',
    finnish: 'sähköpyörätuoli',
    hungarian: 'elektromos kerekesszék',
    german: 'Elektrischer Rollstuhl',
    dutch: 'elektrische rolstoel',
    afrikaans: 'elektries rolstoel',
    russian: 'электроколяска',
    latvian: 'elektriskais ratiņkrēsls',
    polish: 'elektryczny wózek inwalidzki',
    french: 'chaise roulante électrique, fauteuil roulant électrique, fauteuil roulant motorisé',
    spanish: 'silla de ruedas eléctrica',
  },
  {
    av: 13923,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + nose: animal distinguished by its nose, i.e., trunk)',
    english: 'elephant',
    swedish: 'elefant',
    norwegian: 'elefant',
    finnish: 'norsu, elefantti',
    hungarian: 'elefánt',
    german: 'Elefant',
    dutch: 'olifant',
    afrikaans: 'olifant',
    russian: 'слон',
    latvian: 'zilonis',
    polish: 'słoń',
    french: 'éléphant',
    spanish: 'elefante',
  },
  {
    av: 13924,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + up and down)',
    english: 'elevator, lift',
    swedish: 'hiss',
    norwegian: 'heis',
    finnish: 'hissi',
    hungarian: 'felvonó, lift',
    german: 'Fahrstuhl, Aufzug, Lift',
    dutch: 'lift',
    afrikaans: 'hysbak',
    russian: 'лифт',
    latvian: 'lifts',
    polish: 'winda, podnośnik, dźwig',
    french: 'élévateur, ascenseur',
    spanish: 'ascensor, elevador',
  },
  {
    av: 13925,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + before + shofar: month before Rosh Hashana (Hebrew))',
    english: 'Elul',
    swedish: 'Elul (Israel)',
    norwegian: 'Elul (Israel)',
    finnish: 'elul, elúl',
    hungarian: 'Elul (héber)',
    german: 'Elul (Monat)',
    dutch: 'Elul (Joods)',
    afrikaans: 'Elul',
    russian: 'элюль (Израиль)',
    latvian: 'Eļuļs (Izraēla)',
    polish: 'Elul – miesiąc kalendarza hebrajskiego',
    french: 'Elloul (6e mois du calendrier juif)',
    spanish: 'Elul (Israel)',
  },
  {
    av: 13926,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(embarrassment + description after the fact indicator)',
    english: 'embarrassed',
    swedish: 'generad',
    norwegian: 'forlegen, brydd, flau',
    finnish: 'hämmästynyt',
    hungarian: 'zavart, zavarban lévő (=kínosan érzi magát)',
    german: 'verlegen, peinlich',
    dutch: 'beschaamd',
    afrikaans: 'verleë',
    russian: 'смущённый',
    latvian: 'apmulsis, apkaunots',
    polish: 'zakłopotany',
    french: 'embarrassé, gêné, confus',
    spanish: 'avergonzado',
  },
  {
    av: 13927,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(embarrassment + description indicator)',
    english: 'embarrassing',
    swedish: 'pinsam',
    norwegian: 'pinlig, flaut',
    finnish: 'hämmästyttävä',
    hungarian: 'kínos, zavarba hozó, zavaró',
    german: 'peinlich, unangenehm',
    dutch: 'gênant, beschamend',
    afrikaans: 'verleentheid, verbouererend',
    russian: 'неприятный',
    latvian: 'mulsinošs, apkaunojošs',
    polish: 'kłopotliwe, żenujące, wstydliwe',
    french: 'embarrassant, gênant',
    spanish: 'embarazoso',
  },
  {
    av: 13928,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(discomfort + up and down: also a combination of uncomfortable and upset)',
    english: 'embarrassment',
    swedish: 'pinsamhet',
    norwegian: 'forlegenhet, flauhet',
    finnish: 'hämmennys, pulma, tukala asema',
    hungarian: 'feszengés, zavar',
    german: 'Verlegenheit, Peinlichkeit, Verwirrung',
    dutch: 'beschaamdheid',
    afrikaans: 'verleentheid',
    russian: 'смущение',
    latvian: 'apmulsums, neveiklība',
    polish: 'wstyd, zakłopotanie, zażenowanie',
    french: 'embarras, gêne, confusion',
    spanish: 'vergüenza',
  },
  {
    av: 13930,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(danger + limited time)',
    english: 'emergency',
    swedish: 'nöd, nödläge',
    norwegian: 'krise, nød',
    finnish: 'hätätilanne',
    hungarian: 'vészhelyzet, váratlan esemény, sürgető helyzet',
    german: 'Notfall, Notruf',
    dutch: 'noodgeval, noodsituatie',
    afrikaans: 'noodgeval, noodsituasie',
    russian: 'неотложная помощь',
    latvian: 'neatliekamā palīdzība',
    polish: 'nagły, awaryjny, doraźny',
    french: 'urgence',
    spanish: 'emergencia',
  },
  {
    av: 13931,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + understanding, comprehension)',
    english: 'empathy',
    swedish: 'medkänsla',
    norwegian: 'medfølelse, empati',
    finnish: 'empatia, myötätunto',
    hungarian: 'empátia, átélés, beleélés, beleérzés',
    german: 'Empathie, Einfühlung, Einfühlungsvermögen',
    dutch: 'meeleven (zelfst.nw), empathie',
    afrikaans: 'empatie',
    russian: 'эмпатия',
    latvian: 'empātija',
    polish: 'empatia, współczucie',
    french: 'empathie, compassion',
    spanish: 'empatía',
  },
  {
    av: 13937,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(before + marriage + description indicator)',
    english: 'engaged',
    swedish: 'förlovad',
    norwegian: 'forlovet',
    finnish: 'kihlattu, kihloissa oleva',
    hungarian: 'jegyes, eljegyzett',
    german: 'verlobt',
    dutch: 'verloofd',
    afrikaans: 'verloof',
    russian: 'помолвленный',
    latvian: 'saderināts',
    polish: 'zaręczony',
    french: 'fiancé',
    spanish: 'comprometido(a)',
  },
  {
    av: 13938,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(happiness + action indicator)',
    english: 'enjoy-(to)',
    swedish: 'glädja',
    norwegian: 'more, glede',
    finnish: 'nauttia, iloita',
    hungarian: 'élvezni, örülni',
    german: 'genießen, sich erfreuen, sich gut unterhalten, erfreuen',
    dutch: 'genieten',
    afrikaans: 'geniet (om te)',
    russian: 'радовать(ся)',
    latvian: 'iepriecināt',
    polish: 'cieszyć się, bawić, lubić coś',
    french: "plaire-(se), amuser-(s')",
    spanish: 'disfrutar (de)',
  },
  {
    av: 13939,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(minus + more + description indicator: no more needed, i.e., the right amount or number)',
    english: 'enough',
    swedish: 'nog, tillräckligt',
    norwegian: 'nok, tilstrekkelig',
    finnish: 'tarpeeksi, riittävästi, kyllin',
    hungarian: 'elég, elegendő',
    german: 'genug',
    dutch: 'genoeg, voldoende',
    afrikaans: 'genoeg, voldoende',
    russian: 'достаточно',
    latvian: 'pietiekami',
    polish: 'dość, wystarczy',
    french: 'assez',
    spanish: 'suficiente',
  },
  {
    av: 13940,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(into + action indicator)',
    english: 'enter, absorb, insert, penetrate-(to)',
    swedish: 'gå in, komma in, sätta in (etc)',
    norwegian: 'gå inn, komme inn, trekke inn',
    finnish: 'mennä sisään, tulla sisään, saapua',
    hungarian: 'belépni, behatolni, betenni',
    german: 'eintreten, reingehen, absorbieren, etwas einsetzen',
    dutch: 'binnengaan',
    afrikaans: 'binnegaan, absorbeer, penetreer, insit (om te)',
    russian: 'входить, проникать, вставлять',
    latvian: 'ieiet, uzsūkt, ievietot, iespiesties',
    polish: 'wejść, przybyć, wstawić do środka',
    french: 'entrer, pénétrer, absorber',
    spanish: 'entrar, absorber, insertar, penetrar',
  },
  {
    av: 13941,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(to want + comma + other + to have + description indicator: wanting what another person has)',
    english: 'envious',
    swedish: 'avundsjuk',
    norwegian: 'misunnelig',
    finnish: 'kateellinen',
    hungarian: 'irigy',
    german: 'neidisch, missgünstig',
    dutch: 'jaloers',
    afrikaans: 'jaloers',
    russian: 'завистливый',
    latvian: 'skaudīgs',
    polish: 'zazdrosny',
    french: 'jaloux, envieux',
    spanish: 'envidioso',
  },
  {
    av: 13943,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(equal + action indicator)',
    english: 'equal-(to)',
    swedish: 'likna, vara lika med',
    norwegian: 'likne, være lik med',
    finnish: 'olla samanlainen, olla sama, olla yhtä suuri',
    hungarian: 'egyenlíteni, kiegyenlíteni, egyenlővé tenni',
    german: 'gleichen, angleichen',
    dutch: 'gelijk zijn aan, hetzelfde zijn',
    afrikaans: 'gelyk aan (om te)',
    russian: 'равняться, сравнивать',
    latvian: 'vienāds ar',
    polish: 'równać, dorównywać',
    french: 'égaler',
    spanish: 'ser igual a, igualar',
  },
  {
    av: 13945,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(life + after + death)',
    english: 'eternal life, immortality (after death)',
    swedish: 'evigt liv',
    norwegian: 'evig liv',
    finnish: 'kuolemanjälkeinen elämä',
    hungarian: 'örökélet, öröklét, halhatatlanság',
    german: 'ewiges Leben (nach dem Tod), Unsterblichkeit',
    dutch: 'leven na de dood, eeuwig leven',
    afrikaans: 'ewige lewe, lewe na die dood',
    russian: 'вечная жизнь, бессмертие',
    latvian: 'mūžīgā dzīve, nemirstība (pēc nāves)',
    polish: 'życie wieczne (po śmierci)',
    french: 'vie éternelle (après la mort)',
    spanish: 'vida eterna, inmortalidad (después de la muerte)',
  },
  {
    av: 13947,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(evaluation + action indicator) ',
    english: 'evaluate-(to)',
    swedish: 'värdera',
    norwegian: 'vurdere',
    finnish: 'arvioida',
    hungarian: 'értékelni, kiértékelni, minősíteni',
    german: 'abschätzen, bewerten, beurteilen, evaluieren',
    dutch: 'evalueren',
    afrikaans: 'evalueer (om te)',
    russian: 'оценивать',
    latvian: 'novērtēt, izvērtēt',
    polish: 'oceniać, szacować',
    french: 'évaluer',
    spanish: 'evaluar',
  },
  {
    av: 13948,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to evaluate + good + action indicator)',
    english: 'appreciate, value, treasure-(to)',
    swedish: 'uppskatta',
    norwegian: 'verdsette, sette pris på',
    finnish: 'arvostaa',
    hungarian: 'méltányolni, nagyra becsülni, értékelni',
    german: 'billigen, würdigen, schätzen',
    dutch: 'goed bevinden, waarderen',
    afrikaans: 'waardeer (om te)',
    russian: 'ценить',
    latvian: 'novērtēt, noteikt, vērtēt',
    polish: 'docenić, cenić',
    french: 'apprécier, estimer',
    spanish: 'apreciar, valorar, atesorar',
  },
  {
    av: 14113,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(evening + before + Sabbath, day of rest)',
    english: 'evening before holiday, evening of Sabbath',
    swedish: 'afton, kväll före helgdag',
    norwegian: 'kveld før fridag, kveld før helg',
    finnish: 'lepopäivän aatto',
    hungarian: 'Szombat előestéje (héber); ünnep előestéje',
    german: 'Abend vor Schabbat',
    dutch: 'avond voor Sabbat (Joods), sabbatavond',
    afrikaans: 'aand voor Sabbat (Joods)',
    russian: 'вечер предпраздничный, шабат',
    latvian: 'sestdienas vakars, sabats',
    polish: 'wigilia Szabatu',
    french: 'soir du sabbath',
    spanish: 'tarde de Sabbat',
  },
  {
    av: 14115,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(anytime + description indicator)',
    english: 'ever, whenever',
    swedish: 'någonsin',
    norwegian: 'noen gang, noensinne',
    finnish: 'milloin tahansa, koskaan',
    hungarian: 'akármikor, bármikor, valamikor',
    german: 'je(mals), wann auch immer',
    dutch: 'ooit, eens',
    afrikaans: 'ooit, eens, wanneer',
    russian: 'когда-нибудь',
    latvian: 'vienmēr, jebkad ',
    polish: 'zawsze, kiedykolwiek',
    french: "n'importe quand",
    spanish: 'alguna vez, cuando (sea)',
  },
  {
    av: 14117,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(all + person)',
    english: 'everybody, everyone',
    swedish: 'alla',
    norwegian: 'alle',
    finnish: 'jokainen',
    hungarian: 'mindenki',
    german: 'jeder, jeder, jede, jedes',
    dutch: 'iedereen, allemaal',
    afrikaans: 'almal, elkeen',
    russian: 'все, каждый',
    latvian: 'ikviens, kikviena, ikkatrs, ikkatra',
    polish: 'wszyscy',
    french: 'tout le monde',
    spanish: 'todos, cada uno, ',
  },
  {
    av: 14118,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(exchange, substitution + action indicator)',
    english: 'exchange, substitute, trade-(to)',
    swedish: 'byta',
    norwegian: 'bytte, veksle',
    finnish: 'vaihtaa',
    hungarian: 'cserélni, el/kicserélni, helyettesíteni',
    german: 'tauschen, austauschen, ersetzen, umtauschen',
    dutch: 'ruilen',
    afrikaans: 'ruil (om te)',
    russian: 'менять',
    latvian: 'mainīt, aizstāt, mainīties',
    polish: 'wymieniać, zastępować',
    french: 'échanger',
    spanish: 'cambiar, intercambiar',
  },
  {
    av: 14119,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(ecstasy + description indicator)',
    english: 'ecstatic',
    swedish: 'extatisk, exalterad',
    norwegian: 'begeistret, ekstatisk, opphisset',
    finnish: 'haltioitunut, hurmioitunut, ekstaattinen',
    hungarian: 'elragadtatott, eksztatikus, rajongó',
    german: 'aufgeregt, gespannt',
    dutch: 'extatisch, verrukking',
    afrikaans: 'in ekstase, veruk, eksaties',
    russian: 'возбуждённый, восторженный',
    latvian: 'sajūsmināts',
    polish: 'zachwycony, w ekstazie (przymiotnik)',
    french: 'enchanté, enthousiasmé',
    spanish: 'extasiado',
  },
  {
    av: 14120,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + three intensity symbols: experiencing very intense feelings)',
    english: 'ecstasy',
    swedish: 'extas',
    norwegian: 'begeistring, ekstase, opphisselse',
    finnish: 'ekstaasi, hurmio, hurmos',
    hungarian: 'elragadtatás, eksztázis',
    german: 'Aufregung, Erregung',
    dutch: 'extase',
    afrikaans: 'vervoering, verukking, ekstase',
    russian: 'возбуждение, восторг',
    latvian: 'sajūsma, ekstāze',
    polish: 'ekstaza, zachwyt',
    french: 'exaltation, ravissement, extase',
    spanish: 'éxtasis',
  },
  {
    av: 14121,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(outside + action indicator)',
    english: 'exclude-(to)',
    swedish: 'stänga ute, utesluta',
    norwegian: 'utelukke, unnta, ekskludere',
    finnish: 'sulkea pois',
    hungarian: 'kizárni, kirekeszteni',
    german: 'ausschließen',
    dutch: 'uitsluiten',
    afrikaans: 'uitsluit (om te)',
    russian: 'исключать',
    latvian: 'izslēgt, neietvert',
    polish: 'wykluczać, omijać, eliminować, wyłączać',
    french: 'exclure',
    spanish: 'excluir',
  },
  {
    av: 14122,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to allow + after: condoning of something after it has occurred)',
    english: 'excuse',
    swedish: 'förlåtelse, ursäkt',
    norwegian: 'unnskyldning',
    finnish: 'selitys',
    hungarian: 'megbocsátás, felmentés, elnézés',
    german: 'Entschuldigung',
    dutch: 'excuus, verontschuldiging',
    afrikaans: 'verskoning, askies, verontskuldiging',
    russian: 'извинение',
    latvian: 'artvainošanās',
    polish: 'wymówka, pretekst',
    french: 'excuse',
    spanish: 'excusa',
  },
  {
    av: 14123,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(excuse + action indicator)',
    english: 'excuse-(to)',
    swedish: 'förlåta, ursäkta',
    norwegian: 'unnskylde',
    finnish: 'selittää, antaa anteeksi',
    hungarian: 'megbocsátani, elnézni, felmenteni',
    german: 'entschuldigen',
    dutch: 'verontschuldigen, excuseren',
    afrikaans: 'verskoon, verontskuldig (om te)',
    russian: 'извинять(ся)',
    latvian: 'atvainoties',
    polish: 'tłumaczyć się, usprawiedliwiać',
    french: 'excuser',
    spanish: 'excusar',
  },
  {
    av: 14124,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(exercise (physical) + action indicator: to work in order to maintain health)',
    english: 'exercise, work out-(to)',
    swedish: 'träna',
    norwegian: 'trene, mosjonere',
    finnish: 'harjotella, työstää',
    hungarian: 'edzeni',
    german: 'üben, trainieren, Sport treiben',
    dutch: 'trainen',
    afrikaans: 'oefen (om te)',
    russian: 'тренировать(ся)',
    latvian: 'vingrināt, trenēt',
    polish: 'ćwiczyć, pracować, odrabiać zadanie',
    french: "exercer, faire de l'exercice",
    spanish: 'hacer ejercicio',
  },
  {
    av: 14125,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to cause + to see + genitals)',
    english: 'exhibitionism, immodesty, indecent exposure',
    swedish: 'blottande',
    norwegian: 'blotting, ekshibisjonisme',
    finnish: 'itsensäpaljastaminen',
    hungarian: 'illetlen, szemérmetlen, magamutogató',
    german: 'Exhibitionismus',
    dutch: 'exhibitionisme',
    afrikaans: 'ekshibisionisme, onbeskeie, onsedelik blootstelling',
    russian: 'эксгибиционизм',
    latvian: 'ekscibicionisms, nekautrība, piedauzīga izpausme',
    polish: 'ekshibicjonizm, bezwstyd',
    french: 'exhibitionnisme',
    spanish: 'exhibicionismo, exposición indecente',
  },
  {
    av: 14126,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(out of (forward) + action indicator)',
    english: 'exit-(to)',
    swedish: 'gå ut, komma ut',
    norwegian: 'gå ut av',
    finnish: 'poistua, mennä ulos',
    hungarian: 'kilépni, elmenni, eltávozni',
    german: 'hinausgehen, rausgehen',
    dutch: 'eruit gaan, naar buiten gaan',
    afrikaans: 'uitgaan (om te)',
    russian: 'выходить',
    latvian: 'aiziet, iziet',
    polish: 'wyjść, opuścić miejsce',
    french: 'sortir',
    spanish: 'salir',
  },
  {
    av: 14127,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(expectation + action indicator)',
    english: 'expect, anticipate-(to)',
    swedish: 'anta, förvänta',
    norwegian: 'anta, forvente',
    finnish: 'odottaa, aavistaa',
    hungarian: 'elvárni, számítani valamire, elébe nézni valaminek',
    german: 'erwarten, ahnen, vermuten, voraussehen',
    dutch: 'verwachten',
    afrikaans: 'verwag, afwag (om te)',
    russian: 'предполагать, ожидать',
    latvian: 'sagaidīt, paredzēt',
    polish: 'spodziewać się, liczyć na, przypuszczać',
    french: "espérer, attendre à-(s'), anticiper",
    spanish: 'esperar',
  },
  {
    av: 14130,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to say + understanding, comprehension + action indicator: to say something in such a way that another person understands it)',
    english: 'explain, give a reason-(to)',
    swedish: 'förklara',
    norwegian: 'forklare',
    finnish: 'selittää',
    hungarian: 'magyarázni, meg/elmagyarázni',
    german: 'erklären, erläutern',
    dutch: 'uitleggen',
    afrikaans: 'verduidelik (om te)',
    russian: 'объяснять',
    latvian: 'paskaidrot, izskaidrot',
    polish: 'wyjaśniać, objaśniać',
    french: 'expliquer',
    spanish: 'explicar',
  },
  {
    av: 14131,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(explosion + action indicator)',
    english: 'explode, blow up, detonate, burst-(to)',
    swedish: 'explodera, spränga',
    norwegian: 'eksplodere, sprenge',
    finnish: 'räjähtää',
    hungarian: 'robbanni, fel/szétrobbani',
    german: 'explodieren, platzen',
    dutch: 'ontploffen, exploderen, uitbarsten',
    afrikaans: 'ontplof, bars (om te)',
    russian: 'взорвать',
    latvian: 'uzspridzināt, eksplodēt, detonēt, sagraut',
    polish: 'wysadzać, detonować, rozsadzać, wybuchać',
    french: 'exploser',
    spanish: 'explotar, detonar',
  },
  {
    av: 14135,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pencil + eyebrow)',
    english: 'eyebrow pencil',
    swedish: 'kajalpenna, ögonpenna',
    norwegian: 'øyebrynsblyant, kajal',
    finnish: 'kulmakynä',
    hungarian: 'szemöldök ceruza',
    german: 'Augenbrauenstift',
    dutch: 'wenkbrauwpotlood',
    afrikaans: 'wenkbroupotlood',
    russian: 'карандаш для бровей',
    latvian: 'uzacu zīmulis',
    polish: 'ołówek do oczu',
    french: 'crayon à sourcils',
    spanish: 'lápiz de cejas',
  },
  {
    av: 14137,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(colour + plus + eyelid(s): colour added to eyelids and eyelashes) ',
    english: 'eye makeup',
    swedish: 'mascara',
    norwegian: 'øyesminke, mascara',
    finnish: 'silmämeikki',
    hungarian: 'szemfestés, szemkihúzás, smink',
    german: 'Lidschatten',
    dutch: 'maskara, oogmake- up, schmink (ogen)',
    afrikaans: 'oog grimering, maskara',
    russian: 'макияж глаз',
    latvian: 'skropstu tuša',
    polish: 'makijaż oka',
    french: 'maquillage pour le yeux, fard pour les yeux',
    spanish: 'pintura de ojos',
  },
  {
    av: 14140,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + to make: building where things are manufactured)',
    english: 'factory, plant',
    swedish: 'fabrik, verkstad',
    norwegian: 'fabrikk, verksted',
    finnish: 'tehdas',
    hungarian: 'gyár, gyártelep',
    german: 'Fabrik, Werksanlage',
    dutch: 'fabriek',
    afrikaans: 'fabriek',
    russian: 'фабрика, завод',
    latvian: 'rūpnīca, fabrika',
    polish: 'fabryka, zakład produkcyjny',
    french: 'usine, fabrique',
    spanish: 'fábrica, planta',
  },
  {
    av: 14141,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + ball + bean: Middle Eastern food made from chick-pea meal and shaped into balls)',
    english: 'falafel',
    swedish: 'falafel',
    norwegian: 'falafel',
    finnish: 'falafel',
    hungarian: 'falafel, fűszeres zöldségből készült gombóckák',
    german: 'Falafel',
    dutch: 'falafel',
    afrikaans: 'falafel',
    russian: 'фалафель',
    latvian: 'falafēls, austrumu ēdiens',
    polish: 'falafel – arabska potrawa wegetariańska',
    french: 'falafel',
    spanish: 'Falafel',
  },
  {
    av: 14142,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(fall, drop, spill, tumble + action indicator)',
    english: 'fall-(to)',
    swedish: 'falla, ramla, tappa',
    norwegian: 'falle, miste',
    finnish: 'pudota',
    hungarian: 'esni, leesni, zuhanni, lezuhanni',
    german: 'fallen, umfallen',
    dutch: 'vallen',
    afrikaans: 'val (om te)',
    russian: 'падать',
    latvian: 'krist, nokrist',
    polish: 'paść, upaść, polec, spadać',
    french: 'chuter, tomber',
    spanish: 'caer',
  },
  {
    av: 14143,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tube + egg)',
    english: 'fallopian tube',
    swedish: 'äggledare',
    norwegian: 'eggleder',
    finnish: 'munajohdin',
    hungarian: 'petevezeték',
    german: 'Eileiter',
    dutch: 'eileider',
    afrikaans: 'fallopiese buis',
    russian: 'фаллопиева труба',
    latvian: 'olvads, olvadi',
    polish: 'jajowód',
    french: 'trompe de Fallope',
    spanish: 'trompa de falopio',
  },
  {
    av: 14146,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(group + protection: group of caring people) (Note: The similarity between police and parent, and the lacking aspect of law enforcement, can be seen as problematic.)',
    english: 'police force, police',
    swedish: 'polisstyrka, poliskår, polismakt, polis',
    norwegian: 'politistyrke, politikorps',
    finnish: 'poliisivoimat',
    hungarian: 'rendőrség',
    german: 'Polizei, Polizeitruppe, Polizeikräfte',
    dutch: 'politie',
    afrikaans: 'polisie mag, polisie',
    russian: 'полиция',
    latvian: 'policija',
    polish: 'policja',
    french: 'famille (groupe)',
    spanish: 'fuerza policial',
  },
  {
    av: 14147,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plan + conception)',
    english: 'family planning',
    swedish: 'familjeplanering',
    norwegian: 'familieplanlegging',
    finnish: 'perhesuunnittelu',
    hungarian: 'családtervezés',
    german: 'Familienplanung',
    dutch: 'gezinsplanning',
    afrikaans: 'gesinsbeplanning',
    russian: 'планирование семьи',
    latvian: 'ģimenes plānošana',
    polish: 'planowanie rodziny',
    french: 'planning familial',
    spanish: 'planificación familiar',
  },
  {
    av: 14148,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(public room + family planning)',
    english: 'family planning clinic',
    swedish: 'mottagning för familjeplanering',
    norwegian: 'klinikk for familieplanlegging',
    finnish: 'perhesuunnitteluneuvola',
    hungarian: 'családtervezési rendelő',
    german: 'Familienplanungsberatungsstelle',
    dutch: 'bureau voor gezinsplanning',
    afrikaans: 'gesinsbeplannings kliniek',
    russian: 'клиника семейного планирования',
    latvian: 'ģimenes plānošanas klīnika',
    polish: 'klinika planowania rodziny (leczenia niepłodności)',
    french: 'centre de planning familial',
    spanish: 'clínica de planificación familiar',
  },
  {
    av: 14152,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + farm: person who farms)',
    english: 'farmer',
    swedish: 'bonde, lantbrukare',
    norwegian: 'bonde, landbruker',
    finnish: 'maanviljelijä',
    hungarian: 'gazda, gazdálkodó, kisbirtokos, farmer',
    german: 'Bauer',
    dutch: 'boer',
    afrikaans: 'boer',
    russian: 'фермер',
    latvian: 'lauksaimnieks, fermeris',
    polish: 'rolnik',
    french: 'fermier',
    spanish: 'agricultor',
  },
  {
    av: 14153,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + without + food)',
    english: 'fast day',
    swedish: 'fastedag',
    norwegian: 'fastedag',
    finnish: 'paastopäivä',
    hungarian: 'böjtnap',
    german: 'Fastentag',
    dutch: 'vastendag',
    afrikaans: 'vasdag',
    russian: 'пост',
    latvian: 'gavēņa diena',
    polish: 'dzień postu',
    french: 'jeûne (jour de)',
    spanish: 'día de ayuno',
  },
  {
    av: 14154,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(together + action indicator)',
    english: 'fasten, attach, join, append, connect-(to)',
    swedish: 'sätta ihop, sätta fast',
    norwegian: 'feste, sammenføye, sette sammen',
    finnish: 'liittää, yhdistää',
    hungarian: 'hozzá/összeerősít, -kapcsol, -csatol, -fűz, -köt',
    german: 'befestigen, zusammenfügen, zusammensetzen',
    dutch: 'vastmaken',
    afrikaans: 'vasmaak, konnek, saamvoeg (om te)',
    russian: 'соединять',
    latvian: 'piesprādzēt, piestiprināt, pievienot, savienot',
    polish: 'przymocowywać, związywać, przyłączać, przyczepiać',
    french: 'attacher, annexer, joindre',
    spanish: 'abrochar, asegurar, conectar',
  },
  {
    av: 14155,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: ' (thing + to fasten + clothing)',
    english: 'fastener, gripper, velcro, zipper',
    swedish: 'dragkedja, kardborrband, spänne (etc)',
    norwegian: 'spenne, hekte, glidelås',
    finnish: 'solki, hakanen, vetoketju',
    hungarian: 'cipzár, tépőzár, ruhakapocs, csat',
    german: 'Verschluss, Reißverschluss, Klettverschluss',
    dutch: 'ritssluiting, sluiting, klittenband, velcro (Vl)',
    afrikaans: 'ritsluiter, zip, glip-en-strip, velcro',
    russian: 'застёжка, молния, липучка',
    latvian: 'saspraude, aizdare, līplente, rāvējslēdzējs',
    polish: 'rzep, zamek błyskawiczny, zapięcie przy ubraniu',
    french: 'attache, fermeture, fermoir, velcro',
    spanish: 'broche, seguro, velcro, cierre',
  },
  {
    av: 14158,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      "(to choose + first + description after the fact indicator: one's first choice)",
    english: 'favourite',
    swedish: 'favorit-, älsklings-',
    norwegian: 'favoritt, yndlings-',
    finnish: 'suosikki-, mieli-, lempi-',
    hungarian: 'kedvenc',
    german: 'beliebt, Lieblings-..., bevorzugt',
    dutch: 'favoriet',
    afrikaans: 'gunsteling',
    russian: 'предпочтительный, любимый',
    latvian: 'mīlulis, favorīts',
    polish: 'ulubiony, polecany, faworyzowany',
    french: 'favori, préféré',
    spanish: 'favorito',
  },
  {
    av: 14159,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(afraid + action indicator: to feel afraid of the future because of its uncertainties) ',
    english: 'fear, be afraid, dread-(to)',
    swedish: 'vara rädd',
    norwegian: 'frykte, være redd',
    finnish: 'pelätä',
    hungarian: 'félni, rettegni, tartani valamitől',
    german: 'ängstigen, fürchten, befürchten',
    dutch: 'bang, angstig',
    afrikaans: 'bang, angstig (wees) (om te)',
    russian: 'бояться, пугаться',
    latvian: 'bailes, baidīties, bīties',
    polish: 'bać się, przestraszyć się, obawiać',
    french: 'craindre, avoir peur',
    spanish: 'temer, tener miedo',
  },
  {
    av: 14160,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + wings)',
    english: 'feather',
    swedish: 'fjäder',
    norwegian: 'fjær',
    finnish: 'sulka, höyhen',
    hungarian: 'madártoll, toll',
    german: 'Feder',
    dutch: 'veer, pluim',
    afrikaans: 'veer',
    russian: 'перо',
    latvian: 'spalva',
    polish: 'pióro',
    french: 'plume',
    spanish: 'pluma',
  },
  {
    av: 14161,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 2: second month of the year)',
    english: 'February',
    swedish: 'februari',
    norwegian: 'februar',
    finnish: 'helmikuu',
    hungarian: 'február',
    german: 'Februar',
    dutch: 'februari',
    afrikaans: 'Februarie',
    russian: 'февраль',
    latvian: 'ferbuāris',
    polish: 'luty',
    french: 'février',
    spanish: 'Febrero',
  },
  {
    av: 14162,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to give + food + action indicator)',
    english: 'feed-(to)',
    swedish: 'mata',
    norwegian: 'gi mat, mate, fore',
    finnish: 'syöttää, ruokkia',
    hungarian: 'etetni, enni adni, ételt adni',
    german: 'füttern',
    dutch: 'voeden, voederen, voeren',
    afrikaans: 'voer (om te)',
    russian: 'кормить',
    latvian: 'barot, ēdināt',
    polish: 'żywić, karmić, odżywiać, posilać, wyżywiać',
    french: 'nourrir, donner à manger',
    spanish: 'alimentar',
  },
  {
    av: 14163,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(feeling + action indicator)',
    english: 'feel-(to)',
    swedish: 'känna',
    norwegian: 'føle',
    finnish: 'tuntea',
    hungarian: 'érezni',
    german: 'fühlen, empfinden, spüren, verspüren',
    dutch: 'voelen',
    afrikaans: 'voel (om te)',
    russian: 'чувствовать',
    latvian: 'just, sajust',
    polish: 'czuć, doznawać, dotykać, poczuć',
    french: 'ressentir',
    spanish: 'sentir',
  },
  {
    av: 14165,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(woman + description indicator)',
    english: 'female, feminine (person)',
    swedish: 'kvinnlig, feminin',
    norwegian: 'feminin, kvinnelig',
    finnish: 'naispuolinen, naisellinen',
    hungarian: 'női, feminin',
    german: 'weiblich',
    dutch: 'vrouwelijk',
    afrikaans: 'vroulik, vroulike (persoon)',
    russian: 'женский',
    latvian: 'seviešu, sievišķīga (persona)',
    polish: 'kobieta, kobiecy, żeński (osoba)',
    french: 'féminin',
    spanish: 'femenino (persona)',
  },
  {
    av: 14168,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(conception + description before the fact indicator: capable of conception)',
    english: 'fertile',
    swedish: 'fertil, fruktsam',
    norwegian: 'fruktbar, fertil',
    finnish: 'hedelmällinen',
    hungarian: 'termékeny, fogamzóképes',
    german: 'fruchtbar',
    dutch: 'vruchtbaar',
    afrikaans: 'vrugbaar',
    russian: 'детородный',
    latvian: 'auglība',
    polish: 'płodny, zdolny do rozmnażania',
    french: 'fertile',
    spanish: 'fértil',
  },
  {
    av: 14169,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(help + conception)',
    english: 'fertility counselling',
    swedish: 'fertilitetsrådgivning',
    norwegian: 'fruktbarhetsrådgivning, fertilitetsrådgivning',
    finnish: 'hedelmöitysneuvonta',
    hungarian: 'meddőségi tanácsadó',
    german: 'Schwangerschaftsberatung',
    dutch: 'vruchtbaarheidsadvies',
    afrikaans: 'vrugbaarheids berading',
    russian: 'родовспоможение',
    latvian: 'auglības konsultācija',
    polish: 'poradnictwo w sprawach płodności',
    french: 'fertilité, fécondité',
    spanish: 'asesoramiento sobre fertilidad',
  },
  {
    av: 14172,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + attachment)',
    english: 'fidelity, loyalty, solidarity',
    swedish: 'trohet, samhörighet, solidaritet',
    norwegian: 'lojalitet, troskap',
    finnish: 'uskollisuus',
    hungarian: 'hűség, együttérzés, lojalitás, szolidaritás ',
    german: 'Treue, Loyalität, Solidarität',
    dutch: 'trouw, solidariteit',
    afrikaans: 'trou, lojaal, solidariteit',
    russian: 'верность, преданность',
    latvian: 'uzticība, lojalitāte, solidaritāte',
    polish: 'wierność, oddanie, przywiązanie (uczucie)',
    french: 'fidélité, loyauté',
    spanish: 'fidelidad, lealtad, solidaridad',
  },
  {
    av: 14174,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + sport stick and ball: game played with a stick and a ball)',
    english: 'field hockey, hockey (activity)',
    swedish: 'landhockey',
    norwegian: 'landhockey',
    finnish: 'maahockey, nurmipallo',
    hungarian: 'hoki (játék, sport)',
    german: 'Feldhockey, Hockey',
    dutch: 'hockey',
    afrikaans: 'hokkie (aktiwiteit)',
    russian: 'хоккей на траве',
    latvian: 'lauka hokejs, hokejs',
    polish: 'hokej na trawie (czasownik, aktywność)',
    french: 'hockey sur gazon (activité)',
    spanish: 'campo de hockey, hockey (actividad)',
  },
  {
    av: 14175,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(fight + action indicator)',
    english: 'fight, combat-(to)',
    swedish: 'bråka, slåss',
    norwegian: 'slåss, bråke',
    finnish: 'tapella, taistella',
    hungarian: 'harcolni, csatázni, küzdeni',
    german: 'kämpfen',
    dutch: 'vechten, knokken, strijden',
    afrikaans: 'veg, stry (om te)',
    russian: 'драться',
    latvian: 'kauties, cīnīties',
    polish: 'walczyć, potykać się',
    french: 'battre-(se), combattre-(se)',
    spanish: 'luchar, combatir, pelear',
  },
  {
    av: 14176,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(filling, fill, fullness + action indicator)',
    english: 'fill-(to)',
    swedish: 'fylla',
    norwegian: 'fylle',
    finnish: 'täyttää, täyttyä',
    hungarian: 'megtölteni, feltölteni, telitölteni',
    german: 'füllen',
    dutch: 'vullen',
    afrikaans: 'vul (om te)',
    russian: 'наполнять',
    latvian: 'piepildīt',
    polish: 'napełniać, wypełniać',
    french: 'remplir',
    spanish: 'rellenar, llenar',
  },
  {
    av: 14177,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cylinder + camera)',
    english: 'film',
    swedish: 'filmrulle',
    norwegian: 'filmrull',
    finnish: 'filmi',
    hungarian: 'filmtekercs, filmszalag',
    german: 'Film',
    dutch: 'filmrolletje',
    afrikaans: 'film, fliek',
    russian: 'фотоплёнка, киноплёнка',
    latvian: 'filma',
    polish: 'film',
    french: 'film',
    spanish: 'película',
  },
  {
    av: 14178,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(time + last + description indicator)',
    english: 'finally, at last',
    swedish: 'slutligen, till sist',
    norwegian: 'endelig, til slutt',
    finnish: 'lopulta, viimein',
    hungarian: 'végre, végül',
    german: 'endlich, schließlich',
    dutch: 'tenslotte',
    afrikaans: 'ten slotte, uiteindelik',
    russian: 'наконец',
    latvian: 'beidzot',
    polish: 'ukończony, zakończony, ostateczny, wreszcie koniec',
    french: 'finalement, enfin',
    spanish: 'finalmente, al final',
  },
  {
    av: 14179,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(eye + hidden thing + action indicator: to see something on the earth)',
    english: 'find-(to)',
    swedish: 'hitta, upptäcka',
    norwegian: 'finne, oppdage',
    finnish: 'löytää, huomata',
    hungarian: 'megtalálni, rátalálni, találni',
    german: 'finden, entdecken, finden',
    dutch: 'vinden',
    afrikaans: 'vind (om te)',
    russian: 'находить, искать',
    latvian: 'atrast, meklēt',
    polish: 'znaleźć',
    french: 'trouver',
    spanish: 'encontrar',
  },
  {
    av: 14181,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to do + all + action indicator)',
    english: 'finish, complete-(to)',
    swedish: 'avsluta',
    norwegian: 'avslutte',
    finnish: 'tehdä loppuun, päättää',
    hungarian: 'befejezni, bevégezni, teljesíteni',
    german: 'fertigstellen, beenden, abschließen',
    dutch: 'voltooien, afmaken',
    afrikaans: 'voltooi, klaar maak (om te)',
    russian: 'заканчивать',
    latvian: 'pabeigt',
    polish: 'skończyć, wykończyć, ukończyć, skompletować',
    french: 'finir, terminer, achever',
    spanish: 'acabar, terminar',
  },
  {
    av: 14182,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + sauna)',
    english: 'Finland',
    swedish: 'Finland',
    norwegian: 'Finland',
    finnish: 'Suomi',
    hungarian: 'Finnország',
    german: 'Finnland',
    dutch: 'Finland',
    afrikaans: 'Finland',
    russian: 'Финляндия',
    latvian: 'Somija',
    polish: 'Finlandia',
    french: 'Finlande',
    spanish: 'Finlandia',
  },
  {
    av: 14184,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + extinction, extinguishing (fire): person who puts out fires)',
    english: 'firefighter, fireman',
    swedish: 'brandman',
    norwegian: 'brannmann',
    finnish: 'palomies',
    hungarian: 'tűzoltó',
    german: 'Feuerwehrmann, Feuerwehrfrau',
    dutch: 'brandweerman',
    afrikaans: 'brandweerman',
    russian: 'пожарный',
    latvian: 'ugunsdzēsējs',
    polish: 'strażak',
    french: 'pompier',
    spanish: 'bombero',
  },
  {
    av: 14186,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(truck + extinction, extinguishing (fire): truck used to put out fires)',
    english: 'fire truck, fire engine',
    swedish: 'brandbil',
    norwegian: 'brannbil',
    finnish: 'paloauto',
    hungarian: 'tűzoltóautó',
    german: 'Feuerwehrauto, Feuerwehr',
    dutch: 'brandweerwagen, brandweerauto',
    afrikaans: 'brandweerwa',
    russian: 'пожарная машина',
    latvian: 'ugunsdzesēju mašīna',
    polish: 'samochód strażacki, beczkowóz',
    french: 'camion de pompiers',
    spanish: 'camión de bomberos',
  },
  {
    av: 14187,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(1 + decimal point + description indicator: the dot indicates an ordinal numeral)',
    english: 'first, primary',
    swedish: 'första, först',
    norwegian: 'først, første',
    finnish: 'ensimmäinen, ensi, ensin',
    hungarian: 'első, elsődleges, primer',
    german: 'erster, erste, erstes',
    dutch: 'eerste',
    afrikaans: 'eerste, primêre',
    russian: 'первый, первичный',
    latvian: 'pirmais, primārais',
    polish: 'po pierwsze, głównie',
    french: 'premier',
    spanish: 'primero',
  },
  {
    av: 14189,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + fish: food obtained from a fish)',
    english: 'fish (food)',
    swedish: 'fisk (mat)',
    norwegian: 'fisk (mat)',
    finnish: 'kalaruoka',
    hungarian: 'halétel',
    german: 'Fisch (Essen)',
    dutch: 'vis (eten)',
    afrikaans: 'vis (kos)',
    russian: 'рыба (еда)',
    latvian: 'zivs (pārtika)',
    polish: 'ryba (żywność)',
    french: 'poisson (nourriture)',
    spanish: 'pescado (alimento)',
  },
  {
    av: 14190,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(fishing + action indicator)',
    english: 'fish-(to)',
    swedish: 'fiska, meta',
    norwegian: 'fiske',
    finnish: 'kalastaa',
    hungarian: 'halászni, horgászni',
    german: 'angeln, fischen',
    dutch: 'vissen',
    afrikaans: 'visvang (om vis te vang) (om te)',
    russian: 'рыбачить, ловить рыбу',
    latvian: 'makšķerēt, zvejot',
    polish: 'łowić',
    french: 'pêcher',
    spanish: 'pescar',
  },
  {
    av: 14191,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(receiving + fish)',
    english: 'fishing',
    swedish: 'fiske',
    norwegian: 'fiske, fisking, fiskeri',
    finnish: 'kalastus',
    hungarian: 'halászat, horgászat',
    german: 'Fischen, Angeln, Fischfang, Fischerei',
    dutch: 'visserij',
    afrikaans: 'visvang',
    russian: 'рыбалка, рыболовство',
    latvian: 'makšķerēšana, zvejošana',
    polish: 'łowienie, poławianie, wędkarstwo',
    french: 'pêche',
    spanish: 'pesca',
  },
  {
    av: 14192,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(fixing, fix, mending, mend, repair, reparation + work + action indicator: to make something work again)',
    english: 'fix, mend, repair-(to)',
    swedish: 'laga, reparera',
    norwegian: 'reparere, fikse',
    finnish: 'korjata, kunnostaa',
    hungarian: 'javítani, meg/kijavítani',
    german: 'reparieren',
    dutch: 'repareren, herstellen',
    afrikaans: 'regmaak, herstel (om te)',
    russian: 'ремонтировать, чинить',
    latvian: 'salabot, saremontēt',
    polish: 'naprawiać, reperować, poprawiać',
    french: 'bricoler, réparer',
    spanish: 'arreglar, reparar',
  },
  {
    av: 14194,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + fire)',
    english: 'flame',
    swedish: 'låga',
    norwegian: 'flamme',
    finnish: 'liekki',
    hungarian: 'láng',
    german: 'Flamme',
    dutch: 'vlam',
    afrikaans: 'vlam',
    russian: 'пламя',
    latvian: 'liesma, uguns',
    polish: 'płomień',
    french: 'flamme',
    spanish: 'llama',
  },
  {
    av: 14195,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(fire + description before the fact indicator)',
    english: 'burnable, combustible, ignitable',
    swedish: 'brännbar',
    norwegian: 'brennbar',
    finnish: 'tulenarka, syttyvä',
    hungarian: 'gyúlékony, éghető',
    german: 'brennbar',
    dutch: 'brandbaar',
    afrikaans: 'vlambaar, vlambare, ontvlambaar, brandbaar',
    russian: 'горючий, воспламеняющийся',
    latvian: 'degošs, uzliesmojošs',
    polish: 'palne, łatwopalne, zapalne',
    french: 'inflammable, combustible',
    spanish: 'incinerable, inflamable',
  },
  {
    av: 14196,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(light + hand + thing indicator: portable lamp)',
    english: 'flashlight, lantern',
    swedish: 'ficklampa, lykta',
    norwegian: 'lommelykt, lykt, lanterne',
    finnish: 'taskulamppu, lyhty, salamavalo',
    hungarian: 'elemlámpa, zseblámpa, lámpás',
    german: 'Taschenlampe',
    dutch: 'zaklamp, lantaarn',
    afrikaans: 'lantern, flits',
    russian: 'фонарик, фонарь',
    latvian: 'kabatas baterija, lukturis',
    polish: 'latarnia, lampion',
    french: 'lampe de poche, torche, lanterne',
    spanish: 'linterna',
  },
  {
    av: 14197,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + mountain + description indicator)',
    english: 'flat',
    swedish: 'platt, plan, flat',
    norwegian: 'flat, plan',
    finnish: 'litteä, tasainen, laakea',
    hungarian: 'lapos, sík, apályos',
    german: 'flach',
    dutch: 'plat, vlak',
    afrikaans: 'plat, vlak',
    russian: 'плоский',
    latvian: 'plakans, līdzens',
    polish: 'płaski, nizinny',
    french: 'plat (adj)',
    spanish: 'plano',
  },
  {
    av: 14198,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(addition + taste + thing indicator)',
    english: 'flavouring, condiment, seasoning',
    swedish: 'krydda, smaktillsats',
    norwegian: 'krydder, smakstilsetning',
    finnish: 'mauste',
    hungarian: 'fűszer, ízesítő anyag',
    german: 'Gewürz, Aromat, Würzmittel',
    dutch: 'kruiden',
    afrikaans: 'geurmiddel',
    russian: 'специя, приправа',
    latvian: 'garšviela, garšvielas',
    polish: 'przyprawa',
    french: 'assaisonnement, arôme',
    spanish: 'condimento, sazón',
  },
  {
    av: 14199,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(louse, stinging insect + to jump: stinging insect that jumps)',
    english: 'flea',
    swedish: 'loppa',
    norwegian: 'loppe',
    finnish: 'kirppu',
    hungarian: 'bolha',
    german: 'Floh',
    dutch: 'vlo',
    afrikaans: 'vlooi',
    russian: 'блоха',
    latvian: 'blusa',
    polish: 'pchła',
    french: 'puce',
    spanish: 'pulga',
  },
  {
    av: 14200,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(floating container + action indicator: container appears to float on water)',
    english: 'float-(to)',
    swedish: 'flyta',
    norwegian: 'flyte',
    finnish: 'kellua',
    hungarian: 'lebegni',
    german: 'treiben (schwimmen), treiben lassen',
    dutch: 'drijven',
    afrikaans: 'dryf (om te)',
    russian: 'плыть, плавать',
    latvian: 'peldēt (par objektu)',
    polish: 'pływać, unosić się na widzie (statek, łódź)',
    french: 'flotter',
    spanish: 'flotar',
  },
  {
    av: 14201,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(much + water on ground (flooding))',
    english: 'flood',
    swedish: 'översvämning',
    norwegian: 'oversvømmelse',
    finnish: 'tulva',
    hungarian: 'árvíz, áradás',
    german: 'Überflutung, Hochwasser, Überschwemmung',
    dutch: 'overstroming',
    afrikaans: 'vloed, oorstroming',
    russian: 'наводнение',
    latvian: 'plūdi',
    polish: 'powódź, potop',
    french: 'inondation, flot, afflux',
    spanish: 'inundación',
  },
  {
    av: 14204,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(powder + grain: powder made from grain)',
    english: 'flour',
    swedish: 'mjöl, gryn',
    norwegian: 'mel, gryn',
    finnish: 'jauho',
    hungarian: 'liszt',
    german: 'Mehl',
    dutch: 'meel, bloem (voedsel)',
    afrikaans: 'meel',
    russian: 'мука',
    latvian: 'milti',
    polish: 'mąka',
    french: 'farine',
    spanish: 'harina',
  },
  {
    av: 14369,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flower + protection + description after the fact indicator)',
    english: 'flower (protected)',
    swedish: 'fridlyst blomma',
    norwegian: 'blomst fredet, fredet blomst',
    finnish: 'rauhoitettu kukka',
    hungarian: 'védett virág',
    german: 'beschützte Blume',
    dutch: 'bloem (beschermd), beschermde bloem',
    afrikaans: 'blom (beskermde spesie)',
    russian: 'цветок охраняемый',
    latvian: 'zieds (aizsargājams)',
    polish: 'kwiat chroniony, roślina pod ochroną',
    french: 'fleur (protégée)',
    spanish: 'flor (protegida)',
  },
  {
    av: 14370,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flower + open: uncultivated flower that grows in the open)',
    english: 'wildflower',
    swedish: 'vild blomma',
    norwegian: 'villblomst, blomst vill',
    finnish: 'villikukka',
    hungarian: 'vadvirág',
    german: 'wilde Blume',
    dutch: 'bloem (wild), wilde bloem',
    afrikaans: 'blom (wild, veldblom)',
    russian: 'цветок полевой',
    latvian: 'savvaļas puķes',
    polish: 'kwiat polny, dziki kwiat, roślina',
    french: 'fleur sauvage',
    spanish: 'flor silvestre',
  },
  {
    av: 14372,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(wings + action indicator)',
    english: 'fly-(to)',
    swedish: 'flyga',
    norwegian: 'fly (å)',
    finnish: 'lentää',
    hungarian: 'szállni, röpülni',
    german: 'fliegen',
    dutch: 'vliegen',
    afrikaans: 'vlieg (om te)',
    russian: 'летать',
    latvian: 'lidot',
    polish: 'latać, fruwać',
    french: 'voler',
    spanish: 'volar',
  },
  {
    av: 14373,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(wings + description indicator)',
    english: 'flying',
    swedish: 'flyg-, flygande',
    norwegian: 'flyende',
    finnish: 'lentävä, lento-',
    hungarian: 'szálló, röpülő',
    german: 'fliegend',
    dutch: 'vliegend',
    afrikaans: 'vlieg',
    russian: 'летающий',
    latvian: 'lidojošs',
    polish: 'latanie',
    french: 'volant (adj)',
    spanish: 'que vuela',
  },
  {
    av: 14375,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(fold, folding, pleating + action indicator)',
    english: 'fold, pleat-(to)',
    swedish: 'vika, vecka',
    norwegian: 'brette, folde',
    finnish: 'taittaa, taittua',
    hungarian: 'be/lehajtani, be/lehajlítani, be/gyűrni, redőzni',
    german: 'falten, plissieren',
    dutch: 'vouwen, plooien (Vl)',
    afrikaans: 'vou, plooi (om te)',
    russian: 'складывать, сгибать',
    latvian: 'salocīt, ielocīt',
    polish: 'zaginać, zakładać, zwijać, zmarszczyć, pomarszczyć',
    french: 'plier',
    spanish: 'doblar, plegar',
  },
  {
    av: 14378,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + ball: food shaped into a ball)',
    english: 'food ball',
    swedish: 'matboll',
    norwegian: 'ballmat',
    finnish: 'pyörykkä',
    hungarian: 'gombóc',
    german: 'Fleischkloß, Kloß',
    dutch: 'voedselballetje',
    afrikaans: 'voedselballetjie',
    russian: 'шарики (еда)',
    latvian: 'ēdiena bumbiņas',
    polish: 'klops, okrągły kotlet, mielone',
    french: 'boulette de nourriture',
    spanish: 'bola de comida',
  },
  {
    av: 14380,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + ball + legs and feet: game in which legs and feet are used to move the ball)',
    english: 'football, soccer (activity)',
    swedish: 'fotboll (aktivitet)',
    norwegian: 'fotball',
    finnish: 'jalkapallo',
    hungarian: 'futball (játék, sport)',
    german: 'Fußball (Spiel)',
    dutch: 'voetbal',
    afrikaans: 'sokker, voetbal (aktiwiteit)',
    russian: 'футбол',
    latvian: 'futbols',
    polish: 'piłka nożna, futbol',
    french: 'football (activité)',
    spanish: 'fútbol',
  },
  {
    av: 14383,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(must (a) + description indicator)',
    english: 'forced, compelled, obliged',
    swedish: 'tvungen',
    norwegian: 'tvungen',
    finnish: 'pakotettu',
    hungarian: 'erőltetett, rá/kényszerített, valamire kötelezett',
    german: 'gezwungen, verpflichtet',
    dutch: 'dwingend, geforceerd',
    afrikaans: 'geforseer, gedwing, gedwonge',
    russian: 'вынужденный',
    latvian: 'piespiedu, obligāts',
    polish: 'wymuszony, zmuszony, przymuszony, przymusowy',
    french: 'forcé, obligé',
    spanish: 'forzados, obligados',
  },
  {
    av: 14385,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + penis [contraction])',
    english: 'foreskin',
    swedish: 'förhud',
    norwegian: 'forhud',
    finnish: 'esinahka',
    hungarian: 'fityma, előbőr',
    german: 'Vorhaut',
    dutch: 'voorhuid',
    afrikaans: 'voorhuid',
    russian: 'крайняя плоть',
    latvian: 'priekšāda',
    polish: 'napletek',
    french: 'prépuce',
    spanish: 'prepucio',
  },
  {
    av: 14386,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + many + trees: large group of trees)',
    english: 'forest, bush, wood, woods',
    swedish: 'skog',
    norwegian: 'skog',
    finnish: 'metsä',
    hungarian: 'erdő, erdőség',
    german: 'Wald',
    dutch: 'bos, woud',
    afrikaans: 'bos, woud',
    russian: 'лес',
    latvian: 'mežs',
    polish: 'las, puszcza, (dużo drzew)',
    french: 'forêt',
    spanish: 'bosque',
  },
  {
    av: 14387,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(forgetting, amnesia + action indicator)',
    english: 'forget-(to)',
    swedish: 'glömma',
    norwegian: 'glemme',
    finnish: 'unohtaa',
    hungarian: 'felejteni, el/kifelejteni',
    german: 'vergessen',
    dutch: 'vergeten',
    afrikaans: 'vergeet (om te)',
    russian: 'забыть‚ забывать',
    latvian: 'aizmirst',
    polish: 'zapominać, zapomnieć',
    french: 'oublier',
    spanish: 'olvidar',
  },
  {
    av: 14388,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(permission, allowance (moral) + after + action indicator: to give moral permission for a misdeed after it is done)',
    english: 'forgive, pardon-(to)',
    swedish: 'förlåta',
    norwegian: 'tilgi',
    finnish: 'antaa anteeksi',
    hungarian: 'megbocsátani, megkegyelmezni',
    german: 'vergeben, verzeihen',
    dutch: 'vergeven',
    afrikaans: 'vergewe, verskoon (om te)',
    russian: 'прощать',
    latvian: 'piedot ',
    polish: 'wybaczać, przebaczać',
    french: 'pardonner',
    spanish: 'perdonar, disculpar',
  },
  {
    av: 14391,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(woman + similar + mother: woman who acts as a mother)',
    english: 'foster mother',
    swedish: 'fostermamma, fostermor',
    norwegian: 'fostermor',
    finnish: 'kasvatusäiti',
    hungarian: 'nevelőanya',
    german: 'Pflegemutter',
    dutch: 'pleegmoeder',
    afrikaans: 'pleegmoeder',
    russian: 'приемная мать',
    latvian: 'audžumāte',
    polish: 'matka przybrana, zastępcza matka, opiekunka',
    french: "mère de famille d'accueil",
    spanish: 'madre adoptiva',
  },
  {
    av: 14392,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(similar + parent: unrelated person who cares for a child like a parent)',
    english: 'foster parent',
    swedish: 'fosterförälder',
    norwegian: 'fosterforeldre',
    finnish: 'kasvatusvanhemmat',
    hungarian: 'nevelőszülő',
    german: 'Pflegemutter, Pflegevater, Pflegeeltern',
    dutch: 'pleegouder',
    afrikaans: 'pleegouer',
    russian: 'приемные родители',
    latvian: 'audžuvecāks',
    polish: 'rodzic przybrany, zastępczy rodzic, opiekun',
    french: 'parent nourricier, parent adoptif',
    spanish: 'padres adoptivos',
  },
  {
    av: 14393,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + time + 4: break for eating at four o’clock)',
    english: "four o'clock eating break",
    swedish: "four o'clock eating break (Israel)",
    norwegian: 'four o`clock eating break (Israel)',
    finnish: 'kello neljän ruoka',
    hungarian: 'uzsonnaszünet (délután)',
    german: 'nachmittags Essenpause',
    dutch: 'vieruurtje',
    afrikaans: 'vieruurtjie, vier uur breek, eet breek',
    russian: 'полдник',
    latvian: 'launags',
    polish: 'pora obiadowa, przerwa obiadowa',
    french: 'collation de 4 heures',
    spanish: 'descanso de las cuatro en punto',
  },
  {
    av: 14394,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(canine + little + open: small, wild animal similar to a dog)',
    english: 'fox, jackal, coyote',
    swedish: 'räv',
    norwegian: 'rev',
    finnish: 'kettu',
    hungarian: 'róka',
    german: 'Fuchs',
    dutch: 'vos',
    afrikaans: 'jakkals',
    russian: 'лиса',
    latvian: 'lapsa',
    polish: 'lis',
    french: 'renard',
    spanish: 'zorro',
  },
  {
    av: 14395,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(freedom + description indicator)',
    english: 'free, freely',
    swedish: 'fri',
    norwegian: 'fri',
    finnish: 'vapaa',
    hungarian: 'szabad, szabadon, szabadságban',
    german: 'frei',
    dutch: 'vrij',
    afrikaans: 'verniet, vrylik',
    russian: 'свободный',
    latvian: 'brīvs, brīvi',
    polish: 'wolny, swobodny, niezależny',
    french: 'libre',
    spanish: 'libre, libremente',
  },
  {
    av: 14397,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(freezing, hardening, solidifying + action indicator: to convert water to solid ice)',
    english: 'freeze, solidify-(to)',
    swedish: 'frysa, stelna',
    norwegian: 'fryse til is, stivne',
    finnish: 'jäädyttää, jäätyä, pakastaa',
    hungarian: 'megfagyni',
    german: 'gefrieren',
    dutch: 'bevriezen, vriezen',
    afrikaans: 'vries, bevries (om te)',
    russian: 'замерзать',
    latvian: 'salt, sasalt',
    polish: 'zamarzać, zamrażać',
    french: 'geler, solidifier-(se)',
    spanish: 'congelar, solidificar',
  },
  {
    av: 14399,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(taste + new + description indicator)',
    english: 'fresh',
    swedish: 'färsk',
    norwegian: 'fersk',
    finnish: 'tuore, raikas',
    hungarian: 'friss',
    german: 'frisch',
    dutch: 'vers',
    afrikaans: 'vars',
    russian: 'свежий',
    latvian: 'svaigs',
    polish: 'świeży, rześki',
    french: 'frais, nouveau',
    spanish: 'fresco',
  },
  {
    av: 14401,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to like: person whom one likes)',
    english: 'friend',
    swedish: 'vän, kamrat, kompis',
    norwegian: 'venn, kamerat',
    finnish: 'ystävä',
    hungarian: 'barát',
    german: 'Freund, Freundin',
    dutch: 'vriend, vriendin',
    afrikaans: 'vriend, vriendin, maat',
    russian: 'друг, подруга',
    latvian: 'draugs',
    polish: 'przyjaciel, znajomy, kolega',
    french: 'ami',
    spanish: 'amigo',
  },
  {
    av: 14402,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(amphibian + to jump: amphibian that hops)',
    english: 'frog, toad',
    swedish: 'groda, padda, groddjur',
    norwegian: 'frosk, padde',
    finnish: 'sammakko',
    hungarian: 'béka, varangy',
    german: 'Frosch, Kröte',
    dutch: 'pad',
    afrikaans: 'padda',
    russian: 'лягушка',
    latvian: 'varde, krupis',
    polish: 'żaba, ropucha',
    french: 'grenouille, crapaud',
    spanish: 'rana sapo',
  },
  {
    av: 14404,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + ice)',
    english: 'food (frozen)',
    swedish: 'djupfryst mat',
    norwegian: 'mat frossen, frysemat',
    finnish: 'pakaste',
    hungarian: 'mirelit, fagyasztott étel',
    german: 'Tiefkühlkost',
    dutch: 'voedsel (bevroren), diepvriesvoedsel',
    afrikaans: 'kos (gevries)',
    russian: 'замороженная еда',
    latvian: 'sasaldēta pārtika',
    polish: 'mrożonka, zamrożone jedzenie',
    french: 'aliment surgelé',
    spanish: 'comida congelada',
  },
  {
    av: 14406,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drink + fruit)',
    english: 'fruit juice, juice',
    swedish: 'juice, saft',
    norwegian: 'juice, saft',
    finnish: 'hedelmämehu, mehu',
    hungarian: 'gyümölcslé',
    german: 'Fruchtsaft, Saft',
    dutch: 'vruchtensap, fruitsap (Vl)',
    afrikaans: 'vrugtesap',
    russian: 'сок',
    latvian: 'augļu sula, sula',
    polish: 'sok owocowy',
    french: 'jus de fruit',
    spanish: 'zumo de frutas, jugo de frutas',
  },
  {
    av: 14407,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(yogurt + fruit)',
    english: 'fruit yogurt, fruit yoghurt',
    swedish: 'fruktyoghurt',
    norwegian: 'fruktyoghurt',
    finnish: 'hedelmäjugurtti',
    hungarian: 'gyümölcsjoghurt',
    german: 'Fruchtjoghurt',
    dutch: 'vruchtenyoghurt',
    afrikaans: 'vrugte yogurt',
    russian: 'фруктовый йогурт',
    latvian: 'augļu jogurts',
    polish: 'jogurt owocowy',
    french: 'yaourt aux fruits',
    spanish: 'yogur de frutas',
  },
  {
    av: 14408,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(frustration + description after the fact indicator)',
    english: 'frustrated',
    swedish: 'besviken, missräknad',
    norwegian: 'frustrert, skuffet',
    finnish: 'turhautunut',
    hungarian: 'csalódott, frusztrált, meghiúsult',
    german: 'frustriert',
    dutch: 'gefrustreerd',
    afrikaans: 'gefrustreerd',
    russian: 'разочарованный',
    latvian: 'vīlies, ',
    polish: 'sfrustrowany, przygnębiony, zniechęcony',
    french: 'frustré',
    spanish: 'frustrado',
  },
  {
    av: 14409,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(frustration + description indicator)',
    english: 'frustrating',
    swedish: 'frustrerande',
    norwegian: 'frustrerende, skuffende',
    finnish: 'turhautunut, pettynyt, turhauttava',
    hungarian: 'frusztráló, csalódást okozó',
    german: 'frustrierend',
    dutch: 'frustrerend',
    afrikaans: 'frustrerend',
    russian: 'расстроенный',
    latvian: 'vilšanos, spriedzi radošs',
    polish: 'frustrujące, zniechęcające',
    french: 'frustrant',
    spanish: 'frustrante',
  },
  {
    av: 14410,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + adversity, hardship, setback)',
    english: 'frustration',
    swedish: 'besvikelse, missräkning',
    norwegian: 'frustrasjon, skuffelse',
    finnish: 'turhauma, pettymys',
    hungarian: 'csalódás, frusztráció, meghiúsulás',
    german: 'Enttäuschung, Frustration',
    dutch: 'frustratie',
    afrikaans: 'frustrasie',
    russian: 'разочарование',
    latvian: 'vilšanās, frustrācija',
    polish: 'frustracja, poczucie klęski, zniechęcenie',
    french: 'frustration',
    spanish: 'frustración',
  },
  {
    av: 14411,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cook + oil + action indicator: to cook with oil or fat)',
    english: 'fry, saute-(to)',
    swedish: 'steka',
    norwegian: 'steke, fritere',
    finnish: 'paistaa',
    hungarian: 'sütni, párolni zsírban, vajban vagy olajban',
    german: 'braten, in der Pfanne',
    dutch: 'braden, bakken',
    afrikaans: 'saute, braai (om te)',
    russian: 'жарить',
    latvian: 'cept',
    polish: 'smażyć jedzenie (na patelni / w małej ilości oleju)',
    french: 'frire, sauter, rissoler',
    spanish: 'freír, saltear',
  },
  {
    av: 14413,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(filling, fill, fullness + description indicator)',
    english: 'full',
    swedish: 'full',
    norwegian: 'full',
    finnish: 'täynnä, täysi',
    hungarian: 'teli, tele, teljes',
    german: 'voll',
    dutch: 'vol',
    afrikaans: 'vol',
    russian: 'полный',
    latvian: 'pilns',
    polish: 'pełny, zapełniony',
    french: 'plein',
    spanish: 'lleno, completo',
  },
  {
    av: 14414,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(laugh, laughter + description indicator: causing laughter)',
    english: 'funny, humorous',
    swedish: 'rolig',
    norwegian: 'morsom, humoristisk',
    finnish: 'hauska, hassu, huvittava',
    hungarian: 'mulatságos, vicces, humoros, furcsa',
    german: 'lustig, spaßig, komisch, humorvoll, witzig',
    dutch: 'grappig',
    afrikaans: 'humoristies, snaaks, pret, prettig',
    russian: 'смешной',
    latvian: 'jautrs',
    polish: 'zabawne, dowcipne',
    french: 'amusant, comique',
    spanish: 'gracioso',
  },
  {
    av: 14416,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(generalization + chair + table: two common pieces of furniture stand for furniture in general)',
    english: 'furniture',
    swedish: 'möbler',
    norwegian: 'møbler',
    finnish: 'huonekalu',
    hungarian: 'bútor',
    german: 'Möbel',
    dutch: 'meubels',
    afrikaans: 'meubels',
    russian: 'мебель',
    latvian: 'mēbeles',
    polish: 'meble',
    french: 'meuble',
    spanish: 'muebles',
  },
  {
    av: 14418,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(competition + to enjoy)',
    english: 'game',
    swedish: 'spel',
    norwegian: 'spill, lek',
    finnish: 'peli, kisa',
    hungarian: 'játszma, társasjáték, versenyjáték',
    german: 'Spiel, Spotart, Spielrunde, Runde',
    dutch: 'spel (wedstrijd), spelletje',
    afrikaans: 'speletjie, spel',
    russian: 'игра',
    latvian: 'spēle',
    polish: 'gra, rozgrywka',
    french: 'partie de jeu',
    spanish: 'juego',
  },
  {
    av: 14419,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(god + elephant: Hindu god) (India)',
    english: 'Ganesh',
    swedish: 'Ganesha (Indien)',
    norwegian: 'Ganesha (India)',
    finnish: 'Ganesha',
    hungarian: 'Ganesh (hindu elefántIsten)',
    german: 'Ganesh (Hindu-Gott in Indien)',
    dutch: 'Ganesh (Indisch)',
    afrikaans: 'Ganesh',
    russian: 'Ганеша (Индия)',
    latvian: 'Ganeša',
    polish: 'Ganeśa – hinduski bóg pokoju z głową słonia',
    french: 'Ganesh (hindouisme)',
    spanish: 'Ganesh',
  },
  {
    av: 14423,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(onion, vegetable (bulb) + smell + intensity: bulb vegetable having a strong odour)',
    english: 'garlic',
    swedish: 'vitlök',
    norwegian: 'hvitløk',
    finnish: 'valkosipuli',
    hungarian: 'fokhagyma',
    german: 'Knoblauch',
    dutch: 'knoflook',
    afrikaans: 'knoffel',
    russian: 'чеснок',
    latvian: 'ķiploks',
    polish: 'czosnek',
    french: 'ail',
    spanish: 'ajo',
  },
  {
    av: 14425,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + wheel: liquid that powers machinery and vehicles)',
    english: 'gasoline, gas, petrol',
    swedish: 'bensin',
    norwegian: 'bensin',
    finnish: 'bensiini, diesel, petroli',
    hungarian: 'üzemanyag, benzin, motorbenzin',
    german: 'Benzin, Tankstelle, Tanksäule',
    dutch: 'benzine',
    afrikaans: 'petrol',
    russian: 'бензин',
    latvian: 'benzīns',
    polish: 'benzyna',
    french: 'essence',
    spanish: 'gasolina',
  },
  {
    av: 14426,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(gathering + action indicator)',
    english: 'gather, assemble-(to)',
    swedish: 'samla, samlas',
    norwegian: 'samles, møtes',
    finnish: 'kokoontua, kerätä, koota',
    hungarian: 'gyűlni, gyülekezni, összegyűlni, összetalálkozni',
    german: 'sich versammeln, zusammenkommen, versammeln',
    dutch: 'samenkomen, verzamelen',
    afrikaans: 'versamel, bymekaarkom (om te)',
    russian: 'собираться',
    latvian: 'savākt, savākties',
    polish: 'zbierać się, gromadzić, zgarniać',
    french: 'réunir',
    spanish: 'reunir',
  },
  {
    av: 14429,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(a + description indicator)',
    english: 'indefinite',
    swedish: 'obestämd',
    norwegian: 'ubestemt',
    finnish: 'epämääräinen',
    hungarian: 'általános, határozatlan',
    german: 'infinit, unbestimmt, allgemein',
    dutch: 'algemeen, onbepaald',
    afrikaans: "onbepaald, infinitief, 'n",
    russian: 'неопределённый',
    latvian: 'nenoteikts',
    polish: 'nieokreślony',
    french: 'indéfini',
    spanish: 'indefinido',
  },
  {
    av: 14432,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(genitals + female)',
    english: 'genitals, sex organs (female)',
    swedish: 'könsorgan (kvinnligt)',
    norwegian: 'kjønnsorgan (hunkjønn)',
    finnish: 'naisen sukupuolielimet',
    hungarian: 'nemiszerv (női)',
    german: 'Geschlechtsteile, Geschlechtsorgane (weiblich)',
    dutch: 'genitaliën (vrouwelijk), geslachtsdelen (vrouwelijk)',
    afrikaans: 'geslagsdele, geslagsorgane (vroulik)',
    russian: 'женские гениталии',
    latvian: 'dzimumorgāni, ģenitālijas (sieviešu)',
    polish: 'kobiece narządy płciowe',
    french: 'organes génitaux féminins',
    spanish: 'genitales femeninos',
  },
  {
    av: 14433,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(genitals + male)',
    english: 'genitals, sex organs (male)',
    swedish: 'könsorgan (manligt)',
    norwegian: 'kjønnsorgan (hankjønn)',
    finnish: 'miehen sukupuolielimet',
    hungarian: 'nemiszerv (férfi)',
    german: 'Geschlechtsteile, Geschlechtsorgane (männlich)',
    dutch: 'genitaliën (mannelijk), geslachtsdelen (mannelijk)',
    afrikaans: 'geslagsdele, geslagsorgane (manlik)',
    russian: 'мужские гениталии',
    latvian: 'dzimumorgāni, ģenitālijas (vīriešu)',
    polish: 'męskie narządy płciowe',
    french: 'organes génitaux masculins',
    spanish: 'genitales masculinos',
  },
  {
    av: 14434,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(rodent + feeling: combination of rodent and pet, rodent often kept as a pet)',
    english: 'gerbil, guinea pig, hamster',
    swedish: 'hamster, marsvin',
    norwegian: 'hamster, marsvin',
    finnish: 'marsu, hamsteri, gerbiili',
    hungarian: 'aranyhörcsög, tengerimalac, verseny/ugróegér',
    german: 'Meerschweinchen, Guineaschwein',
    dutch: 'hamster, cavia',
    afrikaans: 'hamster',
    russian: 'хомяк, морская свинка',
    latvian: 'jūras cūciņa, kāmis',
    polish: 'mały gryzoń (myszoskoczek, świnka morska, chomik)',
    french: "gerbille, cochon d'Inde, hamster",
    spanish: 'gerbo, hámster',
  },
  {
    av: 14435,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(receiving + action indicator: to draw into what one holds)',
    english: 'get, acquire, receive-(to)',
    swedish: 'få, ta emot',
    norwegian: 'få, motta',
    finnish: 'vastaanottaa, saada',
    hungarian: 'kapni, megkapni, szert tenni',
    german: 'bekommen, erhalten, kriegen',
    dutch: 'ontvangen, krijgen',
    afrikaans: 'kry, ontvang (om te)',
    russian: 'получать',
    latvian: 'dabūt, iegūt, saņemt',
    polish: 'dostawać, otrzymywać, zdobywać',
    french: 'recevoir, procurer-(se)',
    spanish: 'conseguir, obtener, recibir',
  },
  {
    av: 14437,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + giving: thing that is given)',
    english: 'gift, offering, present',
    swedish: 'present, gåva',
    norwegian: 'gave, presang',
    finnish: 'lahja',
    hungarian: 'ajándék, adomány, felajánlás',
    german: 'Geschenk',
    dutch: 'geschenk, cadeau, pesentje (Nl)',
    afrikaans: 'geskenk, present, offer',
    russian: 'подарок',
    latvian: 'dāvana, ziedojums, velte',
    polish: 'prezent, dar',
    french: 'cadeau, présent',
    spanish: 'regalo, presente',
  },
  {
    av: 14440,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(giving + action indicator: to draw from what one holds)',
    english: 'give, offer, provide-(to)',
    swedish: 'ge',
    norwegian: 'gi, tilby',
    finnish: 'antaa, tarjota',
    hungarian: 'adni, nyújtani, felajánlani, adományozni',
    german: 'geben',
    dutch: 'geven',
    afrikaans: 'gee, offer, voorsien (om te)',
    russian: 'давать',
    latvian: 'dot, piedāvāt, nodrošināt ar',
    polish: 'oferować, dawać, zapewniać',
    french: 'donner',
    spanish: 'dar, ofrecer, proporcionar',
  },
  {
    av: 14441,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + glass: material of which drinking glasses are made)',
    english: 'glass material',
    swedish: 'glas (material)',
    norwegian: 'glass, glassmateriale',
    finnish: 'lasi',
    hungarian: 'üveg',
    german: 'Glas (Material)',
    dutch: 'glas (materiaal)',
    afrikaans: 'glas (materiaal)',
    russian: 'стекло',
    latvian: 'stikls',
    polish: 'szkło (materiał)',
    french: 'verre (matière)',
    spanish: 'material de vidrio',
  },
  {
    av: 14444,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + glass)',
    english: 'glassware',
    swedish: 'glasvaror',
    norwegian: 'glasstøy',
    finnish: 'lasiastia',
    hungarian: 'üvegnemű',
    german: 'Glasware',
    dutch: 'glaswerk',
    afrikaans: 'glasware',
    russian: 'изделия из стекла',
    latvian: 'stikla izstrādājumi',
    polish: 'naczynie szklane (ogólnie o wszystkich szklanych naczyniach)',
    french: 'verrerie, articles de verrerie',
    spanish: 'cristalería',
  },
  {
    av: 14445,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(glove + receiving: combination of glove and to catch, glove for use when catching a ball)',
    english: 'sports glove, glove, mitt',
    swedish: 'handske (sport)',
    norwegian: 'sportshanske',
    finnish: 'urheiluhansikas, räpylä',
    hungarian: 'sportkesztyű, bézbólkesztyű, védőkesztyű',
    german: 'Handschuh (Sport)',
    dutch: 'handschoen (sport)',
    afrikaans: 'handskoen (sport)',
    russian: 'перчатки (спорт)',
    latvian: 'sporta cimdi',
    polish: 'rękawice sportowe',
    french: 'gant de sport',
    spanish: 'guante de deporte',
  },
  {
    av: 14446,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + hand: protective covering for the hand)',
    english: 'glove(s), mitt(s), mitten(s)',
    swedish: 'handskar, vantar',
    norwegian: 'vott, hanske, vante',
    finnish: 'käsine, lapanen',
    hungarian: 'kesztyű, egyujjas kesztyű',
    german: 'Handschuh, Handschuh',
    dutch: 'handschoen, want',
    afrikaans: 'handskoen',
    russian: 'перчатки, варежки',
    latvian: 'dūraiņi, cimdi',
    polish: 'rękawiczka(ki)',
    french: 'gant, mitaine, moufle',
    spanish: 'guante',
  },
  {
    av: 14447,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical product + attachment: chemical product to fasten)',
    english: 'glue, adhesive, paste',
    swedish: 'klister, lim',
    norwegian: 'klister, lim',
    finnish: 'liima',
    hungarian: 'ragasztó, enyv, csiriz',
    german: 'Klebstoff, Kleister',
    dutch: 'lijm, plaksel (Nl)',
    afrikaans: 'gom, lym',
    russian: 'клей',
    latvian: 'līme',
    polish: 'klej',
    french: 'colle',
    spanish: 'pegamento',
  },
  {
    av: 14448,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(glue + action indicator)',
    english: 'glue, paste, stick-(to)',
    swedish: 'klistra, limma',
    norwegian: 'lime, klistre',
    finnish: 'liimata',
    hungarian: 'ragasztani, összeragasztani, enyvezni',
    german: 'kleben, ankleben, anheften',
    dutch: 'kleven (Vl), plakken, lijmen',
    afrikaans: 'gom, vasplak (om te)',
    russian: 'клеить',
    latvian: 'līmēt, pielīmēt',
    polish: 'kleić',
    french: 'coller',
    spanish: 'pegar, encolar',
  },
  {
    av: 14449,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(departure + action indicator)',
    english: 'go, depart, leave-(to)',
    swedish: 'ge sig av, lämna',
    norwegian: 'gå, forlate',
    finnish: 'mennä, lähteä pois',
    hungarian: 'eltávozni, elmenni, elhagyni',
    german: 'zurücklassen, hinterlassen',
    dutch: 'weggaan, gaan, vertrekken',
    afrikaans: 'gaan, vertrek, weggaan (om te)',
    russian: 'оставить, покинуть',
    latvian: 'iet, aiziet, doties projām',
    polish: 'idź, odejdź, zostaw',
    french: "partir, aller-(s'en), quitter",
    spanish: 'irse, partir',
  },
  {
    av: 14452,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + feeling: fish frequently kept as a pet)',
    english: 'goldfish, guppy, pet fish',
    swedish: 'akvariefisk',
    norwegian: 'akvariefisk',
    finnish: 'kultakala, akvaariokala',
    hungarian: 'aranyhal, guppi, akváriumi hal',
    german: 'Goldfisch',
    dutch: 'goudvis',
    afrikaans: 'goudvis, guppy (troeteldier)',
    russian: 'аквариумная рыбка',
    latvian: 'zelta zivtiņa, gupija, akvārija zivtiņa',
    polish: 'złota rybka, karaś',
    french: 'poisson domestique, poisson rouge',
    spanish: 'pez de colores',
  },
  {
    av: 14453,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + sport stick and ball + container (low): game in which a stick is used to propel the ball into a hole)',
    english: 'golf (activity)',
    swedish: 'golf (aktivitet)',
    norwegian: 'golf',
    finnish: 'golf',
    hungarian: 'golf',
    german: 'Golf (Spiel)',
    dutch: 'golf',
    afrikaans: 'golf (aktiwiteit',
    russian: 'гольф',
    latvian: 'golfs',
    polish: 'golf (grać w golfa)',
    french: 'golf (activité)',
    spanish: 'golf (actividad)',
  },
  {
    av: 14454,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(mouth + parting: what you say when you part from someone)',
    english: 'goodbye, farewell',
    swedish: 'hej då, adjö',
    norwegian: 'morna, farvel, ha det',
    finnish: 'hei!, näkemiin!',
    hungarian: 'búcsú, elköszönés',
    german: 'Auf Wiedersehen!, Verabschiedung',
    dutch: 'tot ziens, dag, vaarwel, tot later, tot weeziens',
    afrikaans: 'totsiens, vaarwel, tot weersiens (groet)',
    russian: 'пока, до свидания',
    latvian: 'atvadīšanās; uz redzēšanos!',
    polish: 'Żegnaj, pożegnanie',
    french: 'au revoir',
    spanish: 'despedida',
  },
  {
    av: 14455,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + death + Christ [contraction]: day Christ died on the cross)',
    english: 'Good Friday',
    swedish: 'långfredag',
    norwegian: 'langfredag',
    finnish: 'pitkäperjantai',
    hungarian: 'Nagypéntek',
    german: 'Karfreitag',
    dutch: 'Goede Vrijdag',
    afrikaans: 'Goeie Vrydag',
    russian: 'Страстная Пятница',
    latvian: 'Lielā Piekdiena',
    polish: 'Wielki Piątek',
    french: 'Vendredi saint',
    spanish: 'Viernes Santo',
  },
  {
    av: 14456,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + positive)',
    english: 'goodness',
    swedish: 'godhet',
    norwegian: 'godhet',
    finnish: 'hyvyys',
    hungarian: 'jóság, szívjóság',
    german: 'Gutmütigkeit',
    dutch: 'goedheid',
    afrikaans: 'goedheid',
    russian: 'доброта',
    latvian: 'labestība',
    polish: 'dobroć, uprzejmość',
    french: 'bonté, bienveillance, qualité, valeur',
    spanish: 'bondad',
  },
  {
    av: 14458,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water bird + big)',
    english: 'goose (bird)',
    swedish: 'gås',
    norwegian: 'gås',
    finnish: 'hanhi',
    hungarian: 'liba, lúd',
    german: 'Gans (Vogel)',
    dutch: 'gans',
    afrikaans: 'gans (voël)',
    russian: 'гусь',
    latvian: 'zoss',
    polish: 'gęś (ptak)',
    french: 'oie (oiseau)',
    spanish: 'ganso (ave)',
  },
  {
    av: 14459,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + goose)',
    english: 'goose (food)',
    swedish: 'gås (mat)',
    norwegian: 'gås (mat)',
    finnish: 'hanhi (ruoka)',
    hungarian: 'libahús, lúdhús',
    german: 'Gans (Essen)',
    dutch: 'gans (eten)',
    afrikaans: 'gans (kos, voedsel)',
    russian: 'гусятина',
    latvian: 'zoss (pārtika)',
    polish: 'gęś (mięso)',
    french: 'oie (nourriture)',
    spanish: 'ganso (alimento)',
  },
  {
    av: 14460,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rodent + hole: rodent that lives in a burrow underground)',
    english: 'gopher, ground hog',
    swedish: 'mullvad, sork (etc)',
    norwegian: 'muldvarp (o.l.)',
    finnish: 'myyrä',
    hungarian: 'hörcsög, amerikai mormota',
    german: 'Erdhörnchen, Waldmurmeltier, Ziesel',
    dutch: 'mol',
    afrikaans: 'mol',
    russian: 'крот, суслик',
    latvian: 'susliks',
    polish: 'suseł, piesek ziemny, świstak',
    french: 'marmotte, gopher',
    spanish: 'taltuza, marmota',
  },
  {
    av: 14461,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to lead + country + action indicator: to lead a country)',
    english: 'govern, rule-(to)',
    swedish: 'regera',
    norwegian: 'styre, regjere',
    finnish: 'hallita',
    hungarian: 'kormányozni, irányítani, uralkodni',
    german: 'regieren',
    dutch: 'regeren',
    afrikaans: 'regeer (om te)',
    russian: 'править, управлять',
    latvian: 'vadīt, valdīt',
    polish: 'rządzić państwem, kierować, przewodzić',
    french: 'gouverner',
    spanish: 'gobernar',
  },
  {
    av: 14463,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(goodness + description indicator: felt to be positive or good in an emotional sense)',
    english: 'good, well, fine, ok, okay, all right',
    swedish: 'bra, god, fin, OK',
    norwegian: 'god, bra, fin',
    finnish: 'hyvä, mieluinen, hyvin',
    hungarian: 'jó, rendben van, oké, minden rendben',
    german: 'gut, brav, fein, OK',
    dutch: 'goed, aardig, lief',
    afrikaans: 'goed, wel, gesond',
    russian: 'хорошо, хороший',
    latvian: 'labi, jauki, viss kārtībā',
    polish: 'dobrze, ok',
    french: 'bon',
    spanish: 'bueno, está bien, bien, ok',
  },
  {
    av: 14633,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drink + grape, grapes)',
    english: 'grape juice',
    swedish: 'druvjuice',
    norwegian: 'druejuice',
    finnish: 'viinirypälemehu',
    hungarian: 'szőlőlé, szőlőital',
    german: 'Traubensaft',
    dutch: 'druivensap',
    afrikaans: 'druiwesap',
    russian: 'виноградный сок',
    latvian: 'vīnogu sula',
    polish: 'sok winogronowy',
    french: 'jus de raisin',
    spanish: 'zumo de uva, mosto, jugo de uva',
  },
  {
    av: 14634,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(citrus fruit + big)',
    english: 'grapefruit',
    swedish: 'grapefrukt',
    norwegian: 'grapefrukt',
    finnish: 'greippi',
    hungarian: 'grépfrút, grapefruit, citrancs',
    german: 'Grapefruit, Pampelmuse',
    dutch: 'grapefruit, pompelmoes (Vl)',
    afrikaans: 'pomelo',
    russian: 'грейпфрут',
    latvian: 'greipfrūts',
    polish: 'grejpfrut',
    french: 'pamplemousse',
    spanish: 'pomelo',
  },
  {
    av: 14637,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(insect + to jump)',
    english: 'grasshopper',
    swedish: 'gräshoppa, syrsa',
    norwegian: 'gresshoppe',
    finnish: 'heinäsirkka',
    hungarian: 'szöcske',
    german: 'Heuschrecke, Grashüpfer',
    dutch: 'sprinkhaan',
    afrikaans: 'sprinkaan',
    russian: 'кузнечик',
    latvian: 'sienāzis',
    polish: 'konik polny',
    french: 'sauterelle, grillon',
    spanish: 'saltamontes',
  },
  {
    av: 14639,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + night + snow: combination of black and white)',
    english: 'gray, grey',
    swedish: 'grå',
    norwegian: 'grå',
    finnish: 'harmaa',
    hungarian: 'szürke',
    german: 'grau',
    dutch: 'grijs',
    afrikaans: 'grys (bci)',
    russian: 'серый',
    latvian: 'pelēks',
    polish: 'szary',
    french: 'gris',
    spanish: 'gris',
  },
  {
    av: 14640,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(good + intensity: intensely good feeling)',
    english: 'great experience',
    swedish: 'upplevelse (stark)',
    norwegian: 'opplevelse (sterk)',
    finnish: 'huippukokemus',
    hungarian: 'nagy élmény, jó élmény, különlegesen jó; Óriási! ',
    german: 'starke Erfahrung, starkes Erlebnis',
    dutch: 'groots',
    afrikaans: 'groot ondervinding',
    russian: 'положительный опыт',
    latvian: 'laba, lieliska pieredze',
    polish: 'wspaniałe doświadczenie',
    french: 'excellence (sentiment)',
    spanish: 'gran experiencia',
  },
  {
    av: 14641,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + grass) (BCI) SYMBOL SYNONYM',
    english: 'green (bci)',
    swedish: 'grön',
    norwegian: 'grønn',
    finnish: 'vihreä',
    hungarian: 'zöld',
    german: 'grün',
    dutch: 'groen',
    afrikaans: 'groen (bci)',
    russian: 'зелёный',
    latvian: 'zaļš',
    polish: 'zielony (BCI)',
    french: 'vert (bci)',
    spanish: 'verde (BCI)',
  },
  {
    av: 14642,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + 4) (CKB) SYMBOL SYNONYM',
    english: 'green (ckb)',
    swedish: 'grön (CKB)',
    norwegian: 'grønn (CKB)',
    finnish: 'vihreä',
    hungarian: 'zöld (régi CKB-jelkép)',
    german: 'grün',
    dutch: 'groen (CKB)',
    afrikaans: 'groen (ckb)',
    russian: 'зелёный',
    latvian: 'zaļš',
    polish: 'zielony (CKB)',
    french: 'vert (ckb)',
    spanish: 'verde (CKB)',
  },
  {
    av: 14643,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + plant: building for cultivating plants)',
    english: 'greenhouse, glasshouse, hothouse',
    swedish: 'växthus',
    norwegian: 'drivhus, veksthus',
    finnish: 'kasvihuone',
    hungarian: 'melegház, üvegház',
    german: 'Gewächshaus',
    dutch: 'serre, broeikas, kas',
    afrikaans: 'kweekhuis',
    russian: 'теплица',
    latvian: 'siltumnīca',
    polish: 'szklarnia, cieplarnia',
    french: 'serre',
    spanish: 'invernadero',
  },
  {
    av: 14644,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(onion + little)',
    english: 'green onion, scallion, spring onion',
    swedish: 'smålök (etc)',
    norwegian: 'småløk (o.l.)',
    finnish: 'pikkusipuli',
    hungarian: 'újhagyma, zöldhagyma',
    german: 'Schalotte, Lauchzwiebel',
    dutch: 'sjalot',
    afrikaans: 'sprietui',
    russian: 'лук-батун',
    latvian: 'loki, lociņi',
    polish: 'zielona cebulka, szalotka, dymka, szczypiorek',
    french: 'oignon vert, petit oignon',
    spanish: 'cebollino',
  },
  {
    av: 14646,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(group of + person: a number of people considered together)',
    english: 'group (people)',
    swedish: 'grupp',
    norwegian: 'gruppe (av mennesker)',
    finnish: 'ryhmä',
    hungarian: 'csoport',
    german: 'Gruppe',
    dutch: 'groep (van mensen)',
    afrikaans: 'groep (mense)',
    russian: 'группа',
    latvian: 'grupa',
    polish: 'grupa, zespół, zgromadzenie',
    french: 'groupe de personnes',
    spanish: 'grupo',
  },
  {
    av: 14648,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + tree)',
    english: 'grove',
    swedish: 'dunge',
    norwegian: 'skogsholt, lund',
    finnish: 'metsikkö, lehto',
    hungarian: 'liget, erdőcske, berek',
    german: 'Wäldchen, Gehölz',
    dutch: 'bos',
    afrikaans: 'bos, woud, plantasie',
    russian: 'роща, лесок',
    latvian: 'birztala, audze',
    polish: 'gaj, lasek, zagajnik',
    french: 'bosquet',
    spanish: 'arboleda',
  },
  {
    av: 14649,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(growth, growing + action indicator: to come up as flowers do. CKB says that this symbol applies primarily to agriculture and horticulture, but that it may be used in a general sense, such as 'children grow up'.)",
    english: 'grow-(to)',
    swedish: 'växa',
    norwegian: 'vokse, gro',
    finnish: 'kasvaa',
    hungarian: 'nőni, növekedni',
    german: 'wachsen',
    dutch: 'groeien',
    afrikaans: 'groei (om te)',
    russian: 'расти',
    latvian: 'augt',
    polish: 'rosnąć',
    french: 'pousser, grandir',
    spanish: 'crecer',
  },
  {
    av: 14650,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limited time + person + to watch)',
    english: 'guard duty',
    swedish: 'bevakning, vakt',
    norwegian: 'vakt, overvåking',
    finnish: 'vartio, varuillaanolo',
    hungarian: 'őrség, őr, őrtálló',
    german: 'Wachdienst',
    dutch: 'bewaking, wacht (dienst)',
    afrikaans: 'wagdiens, sekuriteitsdiens',
    russian: 'охрана, караул',
    latvian: 'sardzes dienests',
    polish: 'warta, służba wartownicza',
    french: 'tour de garde',
    spanish: 'turno de guardia',
  },
  {
    av: 14651,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(doubt + plus minus + action indicator: to reason on the basis of information of uncertain accuracy)',
    english: 'guess, estimate-(to)',
    swedish: 'gissa',
    norwegian: 'gjette',
    finnish: 'arvata',
    hungarian: 'feltételezni, felbecsülni, kitalálni',
    german: 'erraten, raten, vermuten, annehmen',
    dutch: 'raden, schatten',
    afrikaans: 'raai, skat (om te)',
    russian: 'отгадывать',
    latvian: 'minēt, novērtēt',
    polish: 'przypuszczać, szacować',
    french: 'deviner',
    spanish: 'adivinar, estimar',
  },
  {
    av: 14652,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(judgement + negative: the mind weighs something and judges it to be negative)',
    english: 'guilt',
    swedish: 'skuld',
    norwegian: 'skyld',
    finnish: 'syyllisyys',
    hungarian: 'bűntudat',
    german: 'Schuld',
    dutch: 'schuld',
    afrikaans: 'skuld',
    russian: 'вина',
    latvian: 'vaina',
    polish: 'wina, przewinienie',
    french: 'culpabilité',
    spanish: 'culpa',
  },
  {
    av: 14653,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(guilt + description indicator)',
    english: 'guilty',
    swedish: 'skyldig',
    norwegian: 'skyldig',
    finnish: 'syyllinen',
    hungarian: 'bűntudatos',
    german: 'schuldig',
    dutch: 'schuldig',
    afrikaans: 'skuldig',
    russian: 'виновный',
    latvian: 'vainīgs',
    polish: 'winny',
    french: 'coupable',
    spanish: 'culpable',
  },
  {
    av: 14654,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water bird + waste: water bird that feeds on refuse, a scavenger)',
    english: 'gull, seagull, sea gull',
    swedish: 'mås, trut',
    norwegian: 'måke',
    finnish: 'lokki',
    hungarian: 'sirály',
    german: 'Möwe',
    dutch: 'meeuw, zeemeeuw',
    afrikaans: 'meeu, seemeeu',
    russian: 'чайка',
    latvian: 'kaija, jūras kaija',
    polish: 'mewa',
    french: 'mouette, goéland',
    spanish: 'gaviota',
  },
  {
    av: 14658,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + Passover: book used at Passover ceremonial meal (Hebrew))',
    english: 'Haggadah',
    swedish: 'Haggadah (Israel)',
    norwegian: 'Haggadah (Israel)',
    finnish: 'haggadah',
    hungarian: 'Haggada (héber)',
    german: 'Haggada',
    dutch: 'Haggada (Joods)',
    afrikaans: 'Haggadah',
    russian: 'Хаггада (Израиль)',
    latvian: 'Hagada',
    polish: 'Hagada – hebrajska opowieść, legenda',
    french: 'Haggadah (judaïsme)',
    spanish: 'Hagadá',
  },
  {
    av: 14663,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + sweet + grain: Middle Eastern sweet)',
    english: 'halva, halvah, halwa',
    swedish: 'halvah',
    norwegian: 'halvah',
    finnish: 'halva',
    hungarian: 'halva (mézes, gabonából készült keleti édesség)',
    german: 'Halvah (orientalisches Dessert mit Sesam)',
    dutch: 'halvah',
    afrikaans: 'halvah',
    russian: 'халва',
    latvian: 'halva',
    polish: 'chałwa',
    french: 'halvah (aliment)',
    spanish: 'halvah',
  },
  {
    av: 14665,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cookie + ear: cookie shaped like an ear, eaten on Purim (Hebrew))',
    english: 'hamentasch',
    swedish: 'hamantasch (Israel)',
    norwegian: 'hamantasch (Israel)',
    finnish: 'hamantash, hamentasch',
    hungarian: 'hamentas (sütemény; héber)',
    german: 'Hamantasch (Gebäck zum Purimfest)',
    dutch: 'Hamantasch (Joods)',
    afrikaans: 'Hamantasch',
    russian: 'хоменташ',
    latvian: 'hamenash (Izrael)',
    polish: 'hamentasz (ciasteczka hebr)',
    french: "hamentasch, oreilles d'Aman (juif)",
    spanish: 'hamentasch',
  },
  {
    av: 14669,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + ball + hand)',
    english: 'handball (activity)',
    swedish: 'handboll (aktivitet)',
    norwegian: 'håndball',
    finnish: 'käsipallo',
    hungarian: 'kézilabda (játék, sport)',
    german: 'Handball',
    dutch: 'handbal',
    afrikaans: 'handbal (aktiwiteit)',
    russian: 'гандбол',
    latvian: 'rokasbumba',
    polish: 'piłka ręczna (aktywność)',
    french: 'handball (activité)',
    spanish: 'balonmano (actividad), handball',
  },
  {
    av: 14670,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gun + small)',
    english: 'handgun, pistol',
    swedish: 'pistol',
    norwegian: 'pistol, revolver',
    finnish: 'käsiase, pistooli',
    hungarian: 'pisztoly, kézifegyver',
    german: 'Pistole',
    dutch: 'pistool, revolver',
    afrikaans: 'handwapen, pistool, rewolwer',
    russian: 'пистолет',
    latvian: 'pistole',
    polish: 'pistolet, krótka broń palna',
    french: 'pistolet, révolver',
    spanish: 'pistola',
  },
  {
    av: 14671,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + nose)',
    english: 'handkerchief',
    swedish: 'näsduk',
    norwegian: 'lommetørkle',
    finnish: 'nenäliina',
    hungarian: 'zsebkendő',
    german: 'Taschentuch',
    dutch: 'zakdoek',
    afrikaans: 'sakdoek, sneesdoek',
    russian: 'носовой платок',
    latvian: 'kabataslakatiņš',
    polish: 'chusteczka do nosa',
    french: 'mouchoir',
    spanish: 'pañuelo',
  },
  {
    av: 14672,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(craft + thing indicator: handmade object produced by a craftsman, e.g. a quilt or a plaque)',
    english: 'handmade object, handicraft',
    swedish: 'hantverksprodukt',
    norwegian: 'produkt (håndlaget), håndlaget produkt',
    finnish: 'käsintehty tuote, käsityö',
    hungarian: 'kézműves termék, kézzel gyártott',
    german: 'handwerkliches Produkt',
    dutch: 'handgemaakt voorwerp',
    afrikaans: 'handgemaakte voorwerp',
    russian: 'изделие ручной работы',
    latvian: 'rokdarbi, amatniecība',
    polish: 'rękodzieło (przedmiot)',
    french: 'objet artisanal',
    spanish: 'objeto hecho a mano',
  },
  {
    av: 14673,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hook + action indicator)',
    english: 'hang, hook-(to)',
    swedish: 'hänga',
    norwegian: 'henge',
    finnish: 'ripustaa',
    hungarian: 'akasztani, fel-, függeszteni, fel- (pl. fogasra)',
    german: 'hängen, aufhängen',
    dutch: 'hangen, ophangen',
    afrikaans: 'hang, haak (om te)',
    russian: 'вешать, висеть',
    latvian: 'kārt, uzkārt, pakārt',
    polish: 'powiesić, zmontować',
    french: 'accrocher, pendre, suspendre',
    spanish: 'colgar',
  },
  {
    av: 14674,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(event + action indicator)',
    english: 'happen, occur-(to)',
    swedish: 'hända, ske',
    norwegian: 'hende, skje',
    finnish: 'tapahtua',
    hungarian: 'előfordulni, adódni, meg/történni, bekövetkezni',
    german: 'geschehen, ereignen',
    dutch: 'gebeuren',
    afrikaans: 'gebeur, voorkom (om te)',
    russian: 'случиться',
    latvian: 'notikt',
    polish: 'zdarzyć, wystąpić',
    french: 'passer-(se), produire-(se)',
    spanish: 'suceder',
  },
  {
    av: 14675,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + up: uplifted feeling)',
    english: 'happiness, fun, joy, pleasure',
    swedish: 'glädje, lycka',
    norwegian: 'glede, lykke',
    finnish: 'onni',
    hungarian: 'öröm, boldogság, élvezet, vidámság, kedvtelés',
    german: 'Glück',
    dutch: 'plezier, geluk, blijdschap',
    afrikaans: 'plesier, geluk, blydskap, vreugde, bly',
    russian: 'счастье, радость',
    latvian: 'laime, prieks, patika',
    polish: 'radość, zabawa, przyjemność',
    french: 'joie, plaisir',
    spanish: 'felicidad, diversión, placer',
  },
  {
    av: 14676,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(happiness + description indicator)',
    english: 'happy, glad, gladly, happily',
    swedish: 'glad, lycklig',
    norwegian: 'glad, lykkelig',
    finnish: 'onnellinen, iloinen',
    hungarian: 'boldog, vidám, boldogan, örömmel, szívesen',
    german: 'fröhlich, froh, vergnügt, glücklich',
    dutch: 'blij, gelukkig, plezierig, prettig',
    afrikaans: 'bly, gelukkig, vreugdevol, prettig, ',
    russian: 'счастливый, радостный',
    latvian: 'laimīgs, priecīgs, priecīgi',
    polish: 'zadowolony, radosny',
    french: 'joyeux, heureux',
    spanish: 'feliz, contento',
  },
  {
    av: 14677,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(group of, much of, many of, quantity of + disturbance, unrest: harassment is destroying peace of mind)',
    english: 'harassment',
    swedish: 'mobbing, trakasserier',
    norwegian: 'mobbing, trakassering',
    finnish: 'ahdistelu, häirintä',
    hungarian: 'zaklatás, bosszantás',
    german: 'Belästigung, Schikane',
    dutch: 'kwelling',
    afrikaans: 'teistering',
    russian: 'преследование, запугивание',
    latvian: 'aizskaršana, uzmākšanās',
    polish: 'molestowanie, nękanie',
    french: 'harcèlement',
    spanish: 'acoso',
  },
  {
    av: 14678,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protected water + boat)',
    english: 'harbour',
    swedish: 'hamn',
    norwegian: 'havn',
    finnish: 'satama',
    hungarian: 'kikötő',
    german: 'Hafen',
    dutch: 'haven',
    afrikaans: 'hawe, dok',
    russian: 'порт',
    latvian: 'osta',
    polish: 'port, przystań',
    french: 'port',
    spanish: 'puerto',
  },
  {
    av: 14680,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + agreement: feeling of agreement)',
    english: 'harmony, harmoniousness, concord, concordance',
    swedish: 'samförstånd',
    norwegian: 'harmoni, enighet',
    finnish: 'sopusointu, yksimielisyys, harmonia',
    hungarian: 'összhang, harmónia, egyetértés, egyezés',
    german: 'Harmonie',
    dutch: 'eensgezindheid, harmonie',
    afrikaans: 'harmonie, harmonieuse, eensinnigheid',
    russian: 'гармония',
    latvian: 'harmonija, līdzsvars',
    polish: 'harmonia, zgoda, wspólne dążenie do czegoś',
    french: 'harmonie, entente',
    spanish: 'armonía, concordia',
  },
  {
    av: 14681,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knife + grain: cutting of grain)',
    english: 'harvest',
    swedish: 'skörd',
    norwegian: 'innhøsting, skuronn',
    finnish: 'elonkorjuu',
    hungarian: 'aratás',
    german: 'Ernte',
    dutch: 'oogst',
    afrikaans: 'oes',
    russian: 'жатва',
    latvian: 'raža',
    polish: 'koszenie',
    french: 'moisson, récolte',
    spanish: 'cosecha',
  },
  {
    av: 14682,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + head: protective covering for the head)',
    english: 'hat, cap, hood',
    swedish: 'hatt, mössa',
    norwegian: 'hatt, lue',
    finnish: 'hattu, päähine, myssy, lakki',
    hungarian: 'sapka, kalap, kapucni',
    german: 'Hut',
    dutch: 'hoed, muts',
    afrikaans: 'hoed, mus, kappie',
    russian: 'шляпа, шапка',
    latvian: 'cepure, kapuce, galvassega',
    polish: 'czapka, kaptur, kapelusz, chusta na głowę',
    french: 'chapeau',
    spanish: 'sombrero, gorra',
  },
  {
    av: 14684,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(end + Sabbath: ceremony to mark the end of the Sabbath (Hebrew))',
    english: 'Havdalah',
    swedish: 'havdalah (Israel)',
    norwegian: 'havdalah (Israel)',
    finnish: 'havdala',
    hungarian: 'Havdala (héber)',
    german: 'Hawdala, Habdalah, Hawdole (religiöses Ritual)',
    dutch: 'havdalah (Joods)',
    afrikaans: 'Havdalah',
    russian: 'Хавдала (Израиль)',
    latvian: 'havdala (Izraela)',
    polish: 'Hawdala – ceremonia hebr.',
    french: 'Havdalah (fin du Sabbath)',
    spanish: 'Havdalá',
  },
  {
    av: 14685,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(holding + action indicator: to have something in one's possession without necessarily owning it, hus the half-size of own, possess-(to) 15950)",
    english: 'have-(to)',
    swedish: 'ha',
    norwegian: 'ha',
    finnish: 'olla (jollakin), pitää hallussaan',
    hungarian: 'bírni, birtokolni valamit',
    german: 'haben',
    dutch: 'hebben',
    afrikaans: 'het, hê (om te)',
    russian: 'иметь',
    latvian: 'būt, piederēt',
    polish: 'mieć, posiadać',
    french: 'avoir',
    spanish: 'tener',
  },
  {
    av: 14687,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(male + 3: third person (m.sing.)',
    english: 'he, him, himself',
    swedish: 'han, honom, sig',
    norwegian: 'han, ham, seg',
    finnish: 'hän (mies), hän (mask.)',
    hungarian: 'ő, őt, önmaga, önmagát (hímnem)',
    german: 'er, ihm, ihn, sein',
    dutch: 'hij, hem',
    afrikaans: 'hy, hom, homself',
    russian: 'он, ему, его',
    latvian: 'viņš, viņu, pats',
    polish: 'on, jego, jemu (3 os, l.poj, r.m)',
    french: 'il',
    spanish: 'él, suyo',
  },
  {
    av: 14688,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + 3: third person (sing.), unmarked for gender)',
    english: 'he, she, him, her, one',
    swedish: 'man, sig',
    norwegian: 'man, seg',
    finnish: 'hän',
    hungarian: 'ő',
    german: 'er, sie',
    dutch: 'hij, zij (3de pers. enk.), haar, hem',
    afrikaans: 'hy, sy, hom, haar (3de persoon enkel)',
    russian: 'он, она, его, её',
    latvian: 'viņš, viņa, viņu, viņai',
    polish: 'on, ona, ono (3 os l.poj)',
    french: 'il, elle, on',
    spanish: 'él, ella, una',
  },
  {
    av: 14691,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(health + description indicator)',
    english: 'healthy, well',
    swedish: 'frisk, kry',
    norwegian: 'sunn, frisk',
    finnish: 'terve, terveellinen',
    hungarian: 'egészséges, jól lévő',
    german: 'gesund',
    dutch: 'gezond',
    afrikaans: 'gesondheid',
    russian: 'здоровый',
    latvian: 'vesels, veselīgs',
    polish: 'zdrowy',
    french: 'en bonne santé',
    spanish: 'saludable',
  },
  {
    av: 14692,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(ear + action indicator)',
    english: 'hear, listen-(to)',
    swedish: 'höra, lyssna',
    norwegian: 'høre, lytte',
    finnish: 'kuulla, kuunnella',
    hungarian: 'hallani, hallgatni, figyelni, hallgatózni',
    german: 'hören, zuhören',
    dutch: 'luisteren, horen',
    afrikaans: 'hoor, luister (om te)',
    russian: 'слышать, слушать',
    latvian: 'dzirdēt, klausīties',
    polish: 'słuchać',
    french: 'entendre, écouter',
    spanish: 'oír, escuchar',
  },
  {
    av: 14693,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(aid + ear + electricity + thing indicator: electrical aid for the ear)',
    english: 'hearing aid',
    swedish: 'hörapparat',
    norwegian: 'høreapparat, hørehjelpemiddel',
    finnish: 'kuulokoje, kuulolaite',
    hungarian: 'hallókészülék',
    german: 'Hörgerät',
    dutch: 'gehoorapparaat, hoorapparaat, oorapparaat',
    afrikaans: 'gehoorapparaat',
    russian: 'слуховой аппарат',
    latvian: 'dzirdes aparāts',
    polish: 'aparat słuchowy',
    french: 'appareil auditif',
    spanish: 'ayuda auditiva, prótesis auditiva',
  },
  {
    av: 14695,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + thing indicator: organ of the body. The symbol is the concrete form of feeling, emotion.) - (character with thing indicator)',
    english: 'heart',
    swedish: 'hjärta',
    norwegian: 'hjerte',
    finnish: 'sydän',
    hungarian: 'szív (testrész)',
    german: 'Herz',
    dutch: 'hart',
    afrikaans: 'hart',
    russian: 'сердце',
    latvian: 'sirds',
    polish: 'serce',
    french: 'cœur',
    spanish: 'corazón',
  },
  {
    av: 14697,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(heat + action indicator)',
    english: 'heat-(to)',
    swedish: 'värma',
    norwegian: 'varme',
    finnish: 'lämmittää',
    hungarian: 'fűteni, forrósítani',
    german: 'heizen, erhitzen',
    dutch: 'verhitten, verwarmen',
    afrikaans: 'verwarm, verhit (om te)',
    russian: 'греть',
    latvian: 'sildīt',
    polish: 'podgrzewać, ocieplać',
    french: 'chauffer',
    spanish: 'calentar',
  },
  {
    av: 14698,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(weight + down + description indicator: causing the scales to go down)',
    english: 'heavy',
    swedish: 'tung',
    norwegian: 'tung',
    finnish: 'painava, raskas',
    hungarian: 'súlyos, nehéz (tárgy)',
    german: 'schwer',
    dutch: 'zwaar',
    afrikaans: 'swaar',
    russian: 'тяжёлый',
    latvian: 'smags',
    polish: 'ciężki',
    french: 'lourd',
    spanish: 'pesado',
  },
  {
    av: 14702,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(mouth + meeting, encounter: what you say when you meet someone)',
    english: 'hello, greetings',
    swedish: 'hej, goddag',
    norwegian: 'hei, hallo, goddag',
    finnish: 'hei! Terve!',
    hungarian: 'üdvözlés, köszöntés; Helló! Jónapot! Szia!',
    german: 'Guten Tag, Hallo',
    dutch: 'hallo, dag (begroeting)',
    afrikaans: 'hello, groet',
    russian: 'здравствуйте, привет',
    latvian: 'labdien, sveiki, sveicieni',
    polish: 'hej, witaj, cześć (przywitanie)',
    french: 'bonjour',
    spanish: 'hola, saludos',
  },
  {
    av: 14705,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(help + action indicator)',
    english: 'help, aid, assist, serve, support-(to)',
    swedish: 'hjälpa, stödja',
    norwegian: 'hjelpe, støtte',
    finnish: 'auttaa, avustaa, tukea',
    hungarian: 'segíteni, segédkezni, támogatni',
    german: 'helfen, unterstützen',
    dutch: 'assisteren, ondersteunen, helpen',
    afrikaans: 'assisteer, help, ondersteun, bystaan (om te)',
    russian: 'помогать, поддерживать',
    latvian: 'palīdzēt, atbalstīt',
    polish: 'pomagać, asystować, wspierać',
    french: 'aider, soutenir',
    spanish: 'ayudar, asistir',
  },
  {
    av: 14706,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + help: person who gives aid)',
    english: 'helper, aide, assistant, personal assistant',
    swedish: 'assistent, medhjälpare',
    norwegian: 'hjelper, assistent',
    finnish: 'auttaja, avustaja, apulainen',
    hungarian: 'segítő (személy), asszisztens, személyi segítő',
    german: 'Helfer, Helferin, Assistent, Assistentin',
    dutch: 'hulpverlener, assistent',
    afrikaans: 'assistent, helper, persoonlike assistent',
    russian: 'помощник, ассистент',
    latvian: 'palīgs, personīgais asistents',
    polish: 'pomocnik, asystent, doradca',
    french: 'assistant',
    spanish: 'ayudante, asistente, asistente personal',
  },
  {
    av: 14707,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(she + belongs to: third person (f.sing.) possessive)',
    english: 'her, hers',
    swedish: 'hennes, sin, sitt, sina',
    norwegian: 'hennes, sin',
    finnish: 'hänen (naisesta)',
    hungarian: 'övé (nőnem)',
    german: 'ihr, ihr, ihre, ihr',
    dutch: 'haar (bezitt. voornw.)',
    afrikaans: 'haar, hare (besitlike vnw)',
    russian: 'её (принадлежность)',
    latvian: 'viņu, viņas',
    polish: 'jej',
    french: 'son, sa, ses (fém.)',
    spanish: 'su, suya',
  },
  {
    av: 14709,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + couple (heterosexual): intimate sexual relationship between a man and a woman)',
    english: 'heterosexuality',
    swedish: 'heterosexualitet',
    norwegian: 'heteroseksualitet',
    finnish: 'heteroseksuaalisuus',
    hungarian: 'heteroszexualitás',
    german: 'Heterosexualität',
    dutch: 'heteroseksualiteit',
    afrikaans: 'heteroseksueel',
    russian: 'гетеросексуальность',
    latvian: 'heteroseksualitāte',
    polish: 'heteroseksualność',
    french: 'hétérosexualité',
    spanish: 'heterosexualidad',
  },
  {
    av: 14710,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to make + minus + to see + action indicator: to make invisible)',
    english: 'hide, conceal-(to)',
    swedish: 'gömma, dölja',
    norwegian: 'gjemme, skjule',
    finnish: 'piilottaa, kätkeä',
    hungarian: 'bújni, elbújni, el/bújtatni, el/rejteni, el/rejtőzni',
    german: 'verstecken',
    dutch: 'verstoppen, verbergen',
    afrikaans: 'verberg, wegsteek (om te)',
    russian: 'прятать(ся)',
    latvian: 'slēpt, apslēpt',
    polish: 'ukryć, ukrywać, chować',
    french: 'cacher, dissimuler',
    spanish: 'ocultar',
  },
  {
    av: 14711,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(height, tallness + description indicator: the space between the reference lines is the highest possible within the symbol square)',
    english: 'high, tall',
    swedish: 'hög',
    norwegian: 'høy, høyt',
    finnish: 'korkea',
    hungarian: 'magas',
    german: 'hoch, groβ',
    dutch: 'hoog',
    afrikaans: 'hoog',
    russian: 'высокий',
    latvian: 'augsts, garš',
    polish: 'wysoki, wysoko',
    french: 'haut',
    spanish: 'alto',
  },
  {
    av: 14712,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mountain + little: small mountain)',
    english: 'hill',
    swedish: 'kulle',
    norwegian: 'ås, haug',
    finnish: 'kukkula, mäki, kallio',
    hungarian: 'domb',
    german: 'Hügel',
    dutch: 'heuvel',
    afrikaans: 'heuwel',
    russian: 'холм',
    latvian: 'kalns',
    polish: 'wzgórze',
    french: 'colline',
    spanish: 'colina',
  },
  {
    av: 14715,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(he + belongs to: third person (m.sing.) possessive)',
    english: 'his',
    swedish: 'hans, sin, sitt, sina',
    norwegian: 'hans, sin',
    finnish: 'hänen (miehestä)',
    hungarian: 'övé (hímnem)',
    german: 'sein, sein, seine, sein',
    dutch: 'zijn (bezitt. voornw.)',
    afrikaans: 'syne (besitlike vnw.)',
    russian: 'его (принадлежность)',
    latvian: 'viņa',
    polish: 'jego (r. męski)',
    french: 'son, sa, ses (masc.)',
    spanish: 'su, suyo',
  },
  {
    av: 14716,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(he, she, him, her, one + belongs to: third person (sing.) possessive, unmarked for gender)',
    english: "his, her, hers, one's",
    swedish: 'sin, sitt, sina',
    norwegian: 'sin, sitt, sine',
    finnish: 'hänen',
    hungarian: 'övé',
    german: 'sein, sein, seine, sein',
    dutch: 'zijn (bezitt. voornw.), haar (bezitt. voornw.)',
    afrikaans: 'syne, hare, hulle sin (besitlike vnwe)',
    russian: 'его, её (принадлежность)',
    latvian: 'viņa, viņu, viņas, kāda, kādas',
    polish: 'jego, jej',
    french: 'son, sa, ses',
    spanish: 'suyo, suya, de uno',
  },
  {
    av: 14717,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to touch + intensity + intensity + action indicator: to use the hand forcefully)',
    english: 'hit-(to)',
    swedish: 'slå',
    norwegian: 'slå',
    finnish: 'lyödä',
    hungarian: 'ütni, megütni',
    german: 'schlagen, hauen',
    dutch: 'slaan',
    afrikaans: 'slaan, klap (om te)',
    russian: 'бить, колотить',
    latvian: 'sist',
    polish: 'cios, uderzenie',
    french: 'taper, cogner',
    spanish: 'golpear',
  },
  {
    av: 14718,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + interesting)',
    english: 'hobby, pastime',
    swedish: 'hobby',
    norwegian: 'hobby',
    finnish: 'harrastus, ajanviete',
    hungarian: 'hobbi, időtöltés, szórakozás',
    german: 'Hobby',
    dutch: 'hobby',
    afrikaans: 'stokperdjie, tydverdryf',
    russian: 'хобби',
    latvian: 'vaļasprieks, hobijs',
    polish: 'rozrywka, hobby',
    french: 'passe-temps, marotte, hobby',
    spanish: 'afición, pasatiempo',
  },
  {
    av: 14881,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid + up and down + thing indicator)',
    english: 'hoist, lift',
    swedish: 'lyft',
    norwegian: 'heiseapparat, lift',
    finnish: 'nostolaite',
    hungarian: 'emelő (eszköz), be/fel/ki/megemelő ',
    german: 'Hebeapparat, Kran',
    dutch: 'tillift, hijstoestel (Vl)',
    afrikaans: 'hyser',
    russian: 'подъёмник, лифт',
    latvian: 'lifts, celtnis',
    polish: 'winda, wciągarka, podnośnik',
    french: 'élévateur (personne)',
    spanish: 'montacargas',
  },
  {
    av: 14882,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(container + action indicator)',
    english: 'hold, contain (1)-(to)',
    swedish: 'innehålla, rymma (1)',
    norwegian: 'inneholde, romme (1)',
    finnish: 'sisältää, pitää sisällään',
    hungarian: 'tartalmazni, tartani, magába foglalni',
    german: 'halten, enthalten (1)',
    dutch: 'houden, bevatten, vasthouden (1)',
    afrikaans: 'hou, bevat (1) (om te)',
    russian: 'содержать, вмещать (1)',
    latvian: 'turēt, saturēt (1)',
    polish: 'zawierać, wypełniać (1)',
    french: 'contenir (1)',
    spanish: 'contener (1)',
  },
  {
    av: 14884,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + happy: day for happy activities)',
    english: 'holiday, festival',
    swedish: 'helgdag',
    norwegian: 'festdag, fridag, festival',
    finnish: 'lomapäivä, vapaapäivä',
    hungarian: 'ünnep, fesztivál',
    german: 'Feiertag, Feiertage',
    dutch: 'feestdag',
    afrikaans: 'vakansiedag, feestelik',
    russian: 'праздник, праздничный день',
    latvian: 'brīvdiena, svētki',
    polish: 'wakacje, czas wolny, święto',
    french: 'jour férié, jour de congé',
    spanish: 'feriado',
  },
  {
    av: 14885,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + feeling: house to which one is emotionally tied)',
    english: 'home',
    swedish: 'hem, bostad',
    norwegian: 'hjem',
    finnish: 'koti',
    hungarian: 'otthon, lakóhely',
    german: 'Zuhause, Eigenheim, Heim',
    dutch: 'thuis',
    afrikaans: 'huis',
    russian: 'дом (родной)',
    latvian: 'māja',
    polish: 'dom (miejsce zamieszkania)',
    french: 'chez soi, foyer',
    spanish: 'casa',
  },
  {
    av: 14886,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(4 + corner: a run around all four bases in baseball)',
    english: 'home run',
    swedish: 'home run (Am)',
    norwegian: 'home run (Am)',
    finnish: 'kunniajuoksu, kunnari',
    hungarian: 'hazafutás (bézbólban)',
    german: 'Home Run (Baseball)',
    dutch: 'home run (Amerikaans)',
    afrikaans: 'home run',
    russian: 'хоум-ран (спорт)',
    latvian: 'skrējiens starp bāzēm (beisbolā)',
    polish: 'baza domowa, czwarta baza (z futbolu amerykańskiego)',
    french: 'tour complet, home run, circuit (baseball)',
    spanish: 'home run',
  },
  {
    av: 14887,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + couple (female): intimate sexual relationship between two women)',
    english: 'homosexuality (female), lesbianism',
    swedish: 'homosexualitet, kvinnlig',
    norwegian: 'homoseksualitet (hunkjønn)',
    finnish: 'homoseksuaalisuus (naisen), lebolaisuus',
    hungarian: 'homoszexualitás (női), leszbianizmus',
    german: 'Homosexualität, Lesbentum (weiblich)',
    dutch: 'homoseksualiteit (vrouwen)',
    afrikaans: 'homoseksualiteit (vroulik), lesbianisme',
    russian: 'гомосексуализм (женский)',
    latvian: 'sievešu homoseksualitāte',
    polish: 'lesbijski',
    french: 'homosexualité féminine',
    spanish: 'homosexualidad (femenina)',
  },
  {
    av: 14888,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + couple (male): intimate sexual relationship between two men)',
    english: 'homosexuality (male)',
    swedish: 'homosexualitet, manlig',
    norwegian: 'homoseksualitet (hankjønn)',
    finnish: 'homoseksuaalisuus (miehen)',
    hungarian: 'homoszexualitás (férfi)',
    german: 'Homosexualität Schwulen (männlich)',
    dutch: 'homoseksualiteit (mannen)',
    afrikaans: 'homoseksualiteit (manlik)',
    russian: 'гомосексуализм (мужской)',
    latvian: 'vīriesu homoseksualitāte',
    polish: 'gejowski',
    french: 'homosexualité masculine',
    spanish: 'homosexualidad (masculina)',
  },
  {
    av: 14889,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spread + flower: spread obtained from the nectar of flowers)',
    english: 'honey (spread)',
    swedish: 'honung (pålägg)',
    norwegian: 'honning (pålegg)',
    finnish: 'hunaja',
    hungarian: 'méz (kenhető formában) ',
    german: 'Honig (Aufstrich)',
    dutch: 'honing (beleg)',
    afrikaans: 'heuning (smeer)',
    russian: 'мёд (начинка)',
    latvian: 'medus (smērējamais)',
    polish: 'miód (do smarowania)',
    french: 'miel (à étaler)',
    spanish: 'miel (untada)',
  },
  {
    av: 14890,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + flower: food obtained from the nectar of flowers)',
    english: 'honey (food)',
    swedish: 'honung',
    norwegian: 'honning (mat)',
    finnish: 'hunaja',
    hungarian: 'méz',
    german: 'Honig',
    dutch: 'honing',
    afrikaans: 'heuning (voedsel)',
    russian: 'мёд',
    latvian: 'medus ',
    polish: 'miód (jedzenie)',
    french: 'miel (nourriture)',
    spanish: 'miel (alimento)',
  },
  {
    av: 14892,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(1 + foot + action indicator: to go on one foot)',
    english: 'hop-(to)',
    swedish: 'hoppa på ett ben',
    norwegian: 'hinke',
    finnish: 'hypätä yhdellä jalalla, hyppiä yhdellä jalalla',
    hungarian: 'féllábon ugrálni / szökdécselni / ugrándozni',
    german: 'hüpfen',
    dutch: 'hinkelen, hinken',
    afrikaans: 'hop, huppel, spring (om te)',
    russian: 'прыгать на одной ноге',
    latvian: 'lēkt (uz vienas kājas)',
    polish: 'podskoczyć',
    french: 'sautiller sur un pied',
    spanish: 'saltar a la pata coja, saltar en una pata',
  },
  {
    av: 14893,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(hope + action indicator: to have a happy feeling about the future despite its uncertainties)',
    english: 'hope-(to)',
    swedish: 'hoppas',
    norwegian: 'håpe',
    finnish: 'toivoa',
    hungarian: 'remélni, reménykedni',
    german: 'hoffen',
    dutch: 'hopen',
    afrikaans: 'hoop (om te)',
    russian: 'надеяться',
    latvian: 'cerēt',
    polish: 'mieć nadzieję',
    french: 'espérer, souhaiter',
    spanish: 'tener esperanza',
  },
  {
    av: 14898,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(vegetable (wedge-shaped) + hot, spicy, peppery: wedge-shaped vegetable with a hot-tasting edible root)',
    english: 'horseradish',
    swedish: 'pepparrot',
    norwegian: 'pepperrot',
    finnish: 'piparjuuri',
    hungarian: 'torma',
    german: 'Meerrettich',
    dutch: 'mierikswortel',
    afrikaans: 'peperwortel',
    russian: 'хрен',
    latvian: 'mārrutki',
    polish: 'chrzan',
    french: 'raifort, radis noir',
    spanish: 'rábano picante',
  },
  {
    av: 14899,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + medical: building where medical services are available)',
    english: 'hospital, clinic',
    swedish: 'sjukhus, vårdcentral',
    norwegian: 'sykehus, klinikk',
    finnish: 'sairaala',
    hungarian: 'kórház, klinika',
    german: 'Krankenhaus, Hospital',
    dutch: 'ziekenhuis',
    afrikaans: 'hospitaal, kliniek',
    russian: 'больница',
    latvian: 'slimnīca, hospitālis, klīnika',
    polish: 'szpital, klinika',
    french: 'hôpital, clinique',
    spanish: 'hospital, clínica',
  },
  {
    av: 14900,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(heat + description indicator)',
    english: 'hot (temperature)',
    swedish: 'varm, het',
    norwegian: 'varm, het',
    finnish: 'kuuma, lämmin',
    hungarian: 'forró',
    german: 'heiß',
    dutch: 'heet (temperatuur)',
    afrikaans: 'warm (temperatuur)',
    russian: 'теплый, горячий',
    latvian: 'silts (temperatūra)',
    polish: 'gorący (temperatura)',
    french: 'chaud, brûlant',
    spanish: 'calor (temperatura)',
  },
  {
    av: 14901,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(taste + fire + description indicator)',
    english: 'hot, spicy, peppery',
    swedish: 'kryddstark',
    norwegian: 'krydret sterkt',
    finnish: 'vahvasti maustettu, mausteinen',
    hungarian: 'csípős, erős, fűszeres',
    german: 'scharf (Geschmack), gepfeffert',
    dutch: 'scherp gekruid, gepeperd, heet (smaak)',
    afrikaans: 'gekrui(d), speseryagtig',
    russian: 'горький, жгучий',
    latvian: 'pikants, piparots',
    polish: 'ostry w smaku, piekący, pieprzny',
    french: 'épicé, poivré',
    spanish: 'caliente, picante, pimienta',
  },
  {
    av: 14902,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(roll + meat + long)',
    english: 'hot dog, frankfurter',
    swedish: 'varm korv',
    norwegian: 'varm pølse',
    finnish: 'hot dog, kuuma koira, nakkisämpylä',
    hungarian: 'hot dog',
    german: 'Hot Dog, Frankfurter Würstchen',
    dutch: 'hotdog, worstenbroodje',
    afrikaans: 'worsbroodjie',
    russian: 'хот-дог',
    latvian: 'karsts cīsiņš',
    polish: 'hod dog, bułka z parówką',
    french: 'hot dog',
    spanish: 'perrito caliente',
  },
  {
    av: 14903,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + person + to travel: building where travelers stay)',
    english: 'hotel, motel',
    swedish: 'hotell, motell',
    norwegian: 'hotell, motell',
    finnish: 'hotelli, motelli',
    hungarian: 'hotel, motel',
    german: 'Hotel, Motel',
    dutch: 'hotel',
    afrikaans: 'hotel, motel, bed en ontbyt',
    russian: 'гостиница, мотель',
    latvian: 'viesnīca, motelis',
    polish: 'motel, hotel',
    french: 'hôtel',
    spanish: 'hotel',
  },
  {
    av: 14904,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(time + degree, to indicate an hour)',
    english: "hour, o'clock",
    swedish: 'timme, klockan...',
    norwegian: 'time',
    finnish: 'tunti',
    hungarian: 'idő, óra, órakor',
    german: 'Stunde, …Uhr',
    dutch: 'uur',
    afrikaans: 'uur',
    russian: 'час',
    latvian: 'stunda, pulkstens',
    polish: 'godzina',
    french: 'heure',
    spanish: 'hora, en punto',
  },
  {
    av: 14906,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(who, that, which-(relative) + action)',
    english: 'how',
    swedish: 'hur',
    norwegian: 'hvordan',
    finnish: 'kuinka, miten',
    hungarian: 'hogy (jelkép szinoníma)',
    german: 'wie',
    dutch: 'hoe (betrekk.voornw.)',
    afrikaans: 'hoe (betreklike vnw)',
    russian: 'как',
    latvian: 'kā, kādā veidā',
    polish: 'jak',
    french: 'comment',
    spanish: 'cómo',
  },
  {
    av: 14907,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(what, question mark + action: interrogative)',
    english: 'how-(question)',
    swedish: 'hur (fråga)',
    norwegian: 'hvordan (spørsmål)',
    finnish: 'kuinka?, miten?',
    hungarian: 'hogy? hogyan?',
    german: 'Wie?',
    dutch: 'hoe (vraagwoord)',
    afrikaans: 'hoe (vraagwoord)',
    russian: 'как?',
    latvian: 'kā (jautājums)',
    polish: 'jak? (pytanie)',
    french: 'comment (question)',
    spanish: 'cómo (pregunta)',
  },
  {
    av: 14908,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(what, question mark + quantity)',
    english: 'how much, how many',
    swedish: 'hur mycket, hur många',
    norwegian: 'hvor mye, hvor mange',
    finnish: 'paljonko?, montako?',
    hungarian: 'hány? mennyi?',
    german: 'Wie viel?, wie viel',
    dutch: 'hoeveel',
    afrikaans: 'hoeveel',
    russian: 'сколько?',
    latvian: 'cik, cik daudz',
    polish: 'ile, jak wiele (pytanie)',
    french: 'combien (question)',
    spanish: 'cuánto',
  },
  {
    av: 14909,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hug, squeeze, embrace + action indicator)',
    english: 'hug, cuddle, embrace-(to)',
    swedish: 'krama, hålla om',
    norwegian: 'klemme, omfavne',
    finnish: 'halata, syleillä',
    hungarian: 'ölelni, megölelni, átkarolni, ölelkezni',
    german: 'umarmen',
    dutch: 'knuffelen, omhelzen',
    afrikaans: 'omhels, druk, vashou (om te)',
    russian: 'обнимать',
    latvian: 'apskaut',
    polish: 'przytulic, objąć',
    french: 'serrer dans ses bras, étreindre',
    spanish: 'abrazar',
  },
  {
    av: 14910,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(feeling + inferior + description indicator: lacking a feeling of pride)',
    english: 'humble, meek',
    swedish: 'underlägsen, ödmjuk',
    norwegian: 'underdanig, ydmyk',
    finnish: 'vaatimaton, nöyrä',
    hungarian: 'szerény, szelíd, alázatos',
    german: 'bescheiden, demütig',
    dutch: 'nederig',
    afrikaans: 'nederig, nederige, sagmoedige, sagmoedig',
    russian: 'смирённый',
    latvian: 'pazemīgs, lēnprātīgs',
    polish: 'pokorny, uległy',
    french: 'humble',
    spanish: 'humilde',
  },
  {
    av: 14911,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spread + bean: Middle Eastern spread made from chick-peas)',
    english: 'hummus',
    swedish: 'hummus',
    norwegian: 'hummus',
    finnish: 'hummus',
    hungarian: 'hummusz, csicseriborsóból készült sűrű mártás',
    german: 'Hummus',
    dutch: 'hummus',
    afrikaans: 'hummus, humus, hommos',
    russian: 'хумус',
    latvian: 'humuss',
    polish: 'Hummus – arabska potrawa',
    french: 'hoummos (crème de pois chiches)',
    spanish: 'hummus',
  },
  {
    av: 14912,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(feeling + minus + food + description indicator: having a feeling caused by the lack of food)',
    english: 'hungry',
    swedish: 'hungrig',
    norwegian: 'sulten',
    finnish: 'nälkäinen',
    hungarian: 'éhes',
    german: 'hungrig, Hunger',
    dutch: 'hongerig, honger',
    afrikaans: 'honger, hongerig',
    russian: 'голодный',
    latvian: 'izsalcis',
    polish: 'głodny',
    french: 'affamé',
    spanish: 'hambriento',
  },
  {
    av: 14913,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(pain + action indicator)',
    english: 'hurt, pain (feel), suffer-(to)',
    swedish: 'göra ont, ha ont',
    norwegian: 'gjøre vondt, ha vondt, lide, smerte',
    finnish: 'sattua, särkeä, tuntea kipua',
    hungarian: 'fájni, fájdalmat érezni, szenvedni, kínlódni',
    german: 'sich verletzen, sich wehtun, leiden, erleiden, ertragen (Krankheit)',
    dutch: 'zeer doen, pijn hebben, pijn lijden',
    afrikaans: 'seer, pyn (voel), swaar kry (om te)',
    russian: 'причинять боль',
    latvian: 'sāpēt, sāpes, just sāpes, ciest',
    polish: 'boleć, cierpieć',
    french: 'blesser-(se), faire mal-(se)',
    spanish: 'dañar, sentir dolor, sufrir',
  },
  {
    av: 14915,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to remove + medical + uterus)',
    english: 'hysterectomy',
    swedish: 'hysterektomi (bortoperation av livmodern)',
    norwegian: 'fjerning av livmor',
    finnish: 'kohdunpoisto',
    hungarian: 'méheltávolítás, méhkiirtás, hiszterektómia',
    german: 'Gebärmutteroperation, Hysterectomie',
    dutch: 'baarmoederverwijdering, hysterectomie',
    afrikaans: 'histerektomie',
    russian: 'гистерэктомия (удаление матки)',
    latvian: 'histerektomija (dzemdes izņemšana)',
    polish: 'Histerektomia – usunięcie macicy',
    french: 'hystérectomie',
    spanish: 'histerectomía',
  },
  {
    av: 14916,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + 1: the first person singular)',
    english: 'I, me, myself',
    swedish: 'jag, mig',
    norwegian: 'jeg, meg',
    finnish: 'minä',
    hungarian: 'én, énmagam, engem',
    german: 'ich, mich, mir',
    dutch: 'ik',
    afrikaans: 'ek, my, myself',
    russian: 'я, меня, мне',
    latvian: 'es, mani, sev, pats, pati',
    polish: 'ja',
    french: 'je, moi',
    spanish: 'Yo, a mí',
  },
  {
    av: 14917,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(female + l: first person singular (f.))',
    english: 'I, me, myself-(feminine)',
    swedish: 'jag, mig (fem.)',
    norwegian: 'jeg, meg (hunkjønn)',
    finnish: 'minä (nainen), minä (fem.)',
    hungarian: 'én, énmagam, engem (nő)',
    german: 'ich (weiblich)',
    dutch: 'ik (vrouwelijk)',
    afrikaans: 'ek, my, myself (vroulik)',
    russian: 'я (жен.род)',
    latvian: 'es, man, sev, pati',
    polish: 'ja (rodzaj żeński)',
    french: 'je (pers. féminine)',
    spanish: 'Yo, a mí (femenino)',
  },
  {
    av: 14918,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(male + 1: first person singular (m.))',
    english: 'I, me, myself-(masculine)',
    swedish: 'jag, mig (mask.)',
    norwegian: 'jeg, meg (hankjønn)',
    finnish: 'minä (mies), minä (mask.)',
    hungarian: 'én, énmagam, engem (férfi)',
    german: 'ich (männlich)',
    dutch: 'Ik (mannelijk)',
    afrikaans: 'ek, my, myself (manlik)',
    russian: 'я (муж.род)',
    latvian: 'es, mani sev, pats',
    polish: 'ja (rodzaj męski)',
    french: 'je (pers. masculine)',
    spanish: 'Yo, a mí (masculino)',
  },
  {
    av: 14922,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + sport stick and puck, hockey stick + ice: game played on ice with a stick and a rubber disc)',
    english: 'ice hockey (activity)',
    swedish: 'ishockey (aktivitet)',
    norwegian: 'ishockey',
    finnish: 'jääkiekko',
    hungarian: 'jéghoki (játék, sport)',
    german: 'Eishockey',
    dutch: 'ijshockey',
    afrikaans: 'ys hokkie (aktiwiteit)',
    russian: 'хоккей',
    latvian: 'ledus hokejs ',
    polish: 'hokej na lodzie (aktywność)',
    french: 'hockey sur glace (activité)',
    spanish: 'hockey sobre hielo (actividad)',
  },
  {
    av: 14923,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(country + ice + fire: country characterized by ice and fiery volcanoes)',
    english: 'Iceland',
    swedish: 'Island',
    norwegian: 'Island',
    finnish: 'Islanti',
    hungarian: 'Izland',
    german: 'Island',
    dutch: 'IJsland',
    afrikaans: 'Ysland',
    russian: 'Исландия',
    latvian: 'Islande',
    polish: 'Islandia',
    french: 'Islande',
    spanish: 'Islandia',
  },
  {
    av: 14925,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(ice + description indicator)',
    english: 'icy, frozen',
    swedish: 'frusen, isig, djupfryst',
    norwegian: 'frossen, iset, dypfryst',
    finnish: 'jäinen, pakastettu',
    hungarian: 'jeges, fagyott',
    german: 'eiskalt',
    dutch: 'ijskoud, bevroren',
    afrikaans: 'ysig, gevries, yskoud',
    russian: 'ледяной, замороженный',
    latvian: 'ledusauksts, sasalis',
    polish: 'zamrożone, zmrożone',
    french: 'glacial, gelé',
    spanish: 'helado, congelado',
  },
  {
    av: 14927,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(what, question mark + either)',
    english: 'if',
    swedish: 'om, ifall',
    norwegian: 'hvis, om',
    finnish: 'jos',
    hungarian: 'ha',
    german: 'ob',
    dutch: 'indien, als',
    afrikaans: 'indien, as',
    russian: 'если',
    latvian: 'ja',
    polish: 'jeśli',
    french: 'si',
    spanish: 'si',
  },
  {
    av: 14929,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(bad conscience + intensity + description indicator: morally wrong or bad) See also: bad, wrong 12615 and incorrect, bad, inaccurate, wrong 14935.',
    english: 'immoral, bad, wrong, morally wrong',
    swedish: 'orätt, omoralisk',
    norwegian: 'urett, umoralsk, forkastelig',
    finnish: 'paha, väärä',
    hungarian: 'helytelen, rossz, erkölcstelen, amorális',
    german: 'unmoralisch, falsch, schlecht',
    dutch: 'slecht, fout, immoreel',
    afrikaans: 'immoreel, sleg, verkeerd',
    russian: 'аморально',
    latvian: 'amorāls, slikts, nepareizs',
    polish: 'niemoralne, złe',
    french: 'immoral',
    spanish: 'inmoral, mal',
  },
  {
    av: 14930,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(importance, significance + description indicator: of intense interest)',
    english: 'important, significant',
    swedish: 'viktig',
    norwegian: 'viktig',
    finnish: 'tärkeä',
    hungarian: 'fontos, jelentős, jelentőségteljes',
    german: 'wichtig, einflussreich',
    dutch: 'belangrijk',
    afrikaans: 'belangrik, beduidende',
    russian: 'важный',
    latvian: 'svarīgs, nozīmīgs',
    polish: 'ważne, znaczące',
    french: 'important',
    spanish: 'importante',
  },
  {
    av: 14933,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sexual intercourse + relative)',
    english: 'incest',
    swedish: 'incest',
    norwegian: 'incest',
    finnish: 'insesti, sukurutsaus',
    hungarian: 'vérfertőzés, inceszt',
    german: 'Inzest',
    dutch: 'incest',
    afrikaans: 'bloedskande',
    russian: 'инцест, кровосмешение',
    latvian: 'incests',
    polish: 'kazirodztwo',
    french: 'inceste',
    spanish: 'incesto',
  },
  {
    av: 14934,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(inside + action indicator)',
    english: 'include-(to)',
    swedish: 'innesluta, omfatta, vara inne',
    norwegian: 'omfatte, inkludere',
    finnish: 'sisältää, pitää sisällään',
    hungarian: 'magában foglalni, beleérteni, tartalmazni, belevenni',
    german: 'einschließen',
    dutch: 'insluiten',
    afrikaans: 'insluit (om te)',
    russian: 'охватывать, включать',
    latvian: 'ietvert, iekļaut',
    polish: 'włożyć do środka',
    french: 'inclure',
    spanish: 'incluir',
  },
  {
    av: 14935,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(incorrect thinking + intensity + description indicator: thought to be wrong or bad in a rational sense) See also: bad, wrong 12615 and immoral, bad, wrong, morally wrong 14929.',
    english: 'incorrect, bad, inaccurate, wrong',
    swedish: 'fel, oriktig',
    norwegian: 'galt, urett',
    finnish: 'väärä, väärin, virheellinen, paha',
    hungarian: 'hibás, pontatlan, rossz',
    german: 'falsch, unrichtig, fehlerhaft, unzutreffend',
    dutch: 'verkeerd, onjuist, fout',
    afrikaans: 'verkeerd, onwaar, foutief, onakkuraat, onnoukeurig',
    russian: 'ошибочный, неправильный',
    latvian: 'nepareizs, slikts, neprecīzs, kļūdains',
    polish: 'błędne, nieprawdziwe, złe, niepoprawne',
    french: 'incorrect, faux',
    spanish: 'incorrecto, equivocado',
  },
  {
    av: 14936,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(big + action indicator: to become bigger)',
    english: 'increase, enlarge-(to)',
    swedish: 'förstora, öka',
    norwegian: 'øke, forstørre',
    finnish: 'kasvaa, lisääntyä, suurentua',
    hungarian: 'növekedni, növelni, megnagyobbítani',
    german: 'vergrößern, anwachsen, erweitern, vermehren, zunehmen',
    dutch: 'vergroten, toenemen',
    afrikaans: 'verhoog, vergroot (om te)',
    russian: 'увеличивать, повышать',
    latvian: 'palielināt, pavairot',
    polish: 'rosnąć, powiększać',
    french: 'augmenter',
    spanish: 'aumentar, agrandar',
  },
  {
    av: 14937,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + Israel) (Israel)',
    english: 'Independence Day (Israel)',
    swedish: 'Independence Day (Israel)',
    norwegian: 'Independence Day (Israel)',
    finnish: 'itsenäisyyspäivä',
    hungarian: 'Függetlenség Napja (Izrael)',
    german: 'Unabhängigkeitstag',
    dutch: 'Onafhankelijkheidsdag (Joods)',
    afrikaans: 'Onafhanklikheidsdag (Israel)',
    russian: 'День независимости Израиля',
    latvian: 'Neatkarības diena (Izraēla)',
    polish: 'Dzień Niepodległości (Izraelski)',
    french: "Fête nationale d'Indépendance, yom ha-Atsmaout, Jour de l'Indépendance (Israël)",
    spanish: 'Día de la Independencia (Israel)',
  },
  {
    av: 14938,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + 6) (CKB)',
    english: 'indigo',
    swedish: 'indigo (CKB)',
    norwegian: 'indigo (CKB)',
    finnish: 'indigonsininen',
    hungarian: 'indigókék (régi CKB-jelkép)',
    german: 'Indigo',
    dutch: 'indigoblauw (CKB)',
    afrikaans: 'indigo (ckb)',
    russian: 'индиго',
    latvian: 'indigo',
    polish: 'ciemnobłękitny',
    french: 'bleu indigo',
    spanish: 'añil',
  },
  {
    av: 14939,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(without + fertilization + description before the fact indicator: incapable of conception)',
    english: 'infertile, sterile',
    swedish: 'steril, ofruktsam',
    norwegian: 'ufruktbar, steril',
    finnish: 'hedelmätön',
    hungarian: 'terméketlen, steril',
    german: 'unfruchtbar, steril',
    dutch: 'onvruchtbaar',
    afrikaans: 'onvrugbaar, steriel',
    russian: 'бесплодный',
    latvian: 'neauglība, neauglīgs',
    polish: 'niepłodny, sterylny',
    french: 'stérile',
    spanish: 'infértil, estéril',
  },
  {
    av: 14942,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cause + pain + action indicator)',
    english: 'injure, hurt-(to)',
    swedish: 'skada, såra',
    norwegian: 'skade, såre',
    finnish: 'satuttaa, loukata, tuottaa tuskaa',
    hungarian: 'bántani, fájdalmat okozni, megsebesíteni, sérteni ',
    german: 'verletzen (jemanden), schaden (jemanden), schädigen (jemanden), wehtun (jemandem)',
    dutch: 'pijn doen, bezeren, pijnigen',
    afrikaans: 'beseer (om te)',
    russian: 'травмировать, ранить',
    latvian: 'ievainot, savainot',
    polish: 'zranić, sprawić ból',
    french: 'blesser',
    spanish: 'lesionar, herir',
  },
  {
    av: 14944,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(insect + negative: undesirable insect, a pest)',
    english: 'insect (pest)',
    swedish: 'skadeinsekt',
    norwegian: 'skadeinsekt',
    finnish: 'tuhohyönteinen',
    hungarian: 'rovarkártevő',
    german: 'Ungeziefer, Schädling',
    dutch: 'insect (schadelijk), ongedierte',
    afrikaans: 'insek (plaag, pes)',
    russian: 'насекомое-вредитель',
    latvian: 'kukainis (kaitēklis)',
    polish: 'owad szkodnik',
    french: 'insecte nuisible',
    spanish: 'insecto (plaga)',
  },
  {
    av: 14945,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to give + knowledge)',
    english: 'instruction, teaching',
    swedish: 'undervisning',
    norwegian: 'undervisning',
    finnish: 'opetus, koulutus',
    hungarian: 'tanítás, oktatás',
    german: 'Unterricht, Schulung, Instruktion, Belehrung',
    dutch: 'onderwijs, instructie, les',
    afrikaans: 'instruksie, onderrig',
    russian: 'преподавание',
    latvian: 'apmācība, mācīšana, instruēšana',
    polish: 'nauka, nauczanie',
    french: 'enseignement',
    spanish: 'instrucción',
  },
  {
    av: 14946,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(page + to use: paper that tells one how to use something)',
    english: 'instruction(s), direction(s)',
    swedish: 'bruksanvisning',
    norwegian: 'bruksanvisning',
    finnish: 'ohjeet, käyttöohjeet',
    hungarian: 'útmutatás, útmutató',
    german: 'Gebrauchsanleitung',
    dutch: 'handleiding, gebruiksaanwijzing',
    afrikaans: 'instruksie(s), direksie(s)',
    russian: 'инструкция',
    latvian: 'instrukcija (-as), norāde (-es)',
    polish: 'instrukcja użytkowania',
    french: "instructions, consignes, mode d'emploi",
    spanish: 'instrucciones',
  },
  {
    av: 14948,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(interest + description indicator: engaging the mind)',
    english: 'interesting, interested',
    swedish: 'intressant, intresserad',
    norwegian: 'interessant',
    finnish: 'mielenkiintoinen, kiinnostava',
    hungarian: 'érdekes',
    german: 'interessant, interessiert',
    dutch: 'interessant, geïnteresseerd',
    afrikaans: 'geïnteresseerd, interessant',
    russian: 'интересный',
    latvian: 'interesants, ieinteresēts',
    polish: 'interesujący',
    french: 'intéressant',
    spanish: 'interesante',
  },
  {
    av: 14949,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(country + all + description indicator)',
    english: 'international',
    swedish: 'internationell',
    norwegian: 'internasjonal',
    finnish: 'kansainvälinen',
    hungarian: 'nemzetközi',
    german: 'International',
    dutch: 'internationaal',
    afrikaans: 'internasionaal, internasionale',
    russian: 'международный',
    latvian: 'starptautisks',
    polish: 'międzynarodowy',
    french: 'international',
    spanish: 'internacional',
  },
  {
    av: 14950,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + close)',
    english: 'intimacy, closeness',
    swedish: 'förtrolighet, närhet',
    norwegian: 'intimitet, fortrolighet',
    finnish: 'läheisyys, intimiteetti',
    hungarian: 'bizalmasság, meghittség, közelség, intimitás',
    german: 'Intimität, Vertraulichkeit',
    dutch: 'intimiteit',
    afrikaans: 'nabyheid, intimiteit',
    russian: 'интимность, близость',
    latvian: 'intimitāte, tuvība',
    polish: 'intymność, bliskość',
    french: 'intimité',
    spanish: 'intimidad, cercanía',
  },
  {
    av: 14951,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(intimacy + description indicator)',
    english: 'intimate, close',
    swedish: 'förtrolig, intim, nära',
    norwegian: 'intim, fortrolig, nær',
    finnish: 'läheinen, intiimi',
    hungarian: 'bizalmas, meghitt, közeli, intím',
    german: 'intim, vertraut, innig',
    dutch: 'intiem',
    afrikaans: 'intiem, naby',
    russian: 'интимный, близкий',
    latvian: 'intimitāte, tuvums',
    polish: 'bliski, intymny',
    french: 'intime',
    spanish: 'íntimo, cercano',
  },
  {
    av: 14953,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(plan + first + action indicator: to plan for the first time)',
    english: 'invent-(to)',
    swedish: 'uppfinna',
    norwegian: 'finne opp',
    finnish: 'keksiä, oivaltaa',
    hungarian: 'feltalálni, felfedezni',
    german: 'erfinden',
    dutch: 'uitvinden',
    afrikaans: 'uitvind (om te)',
    russian: 'придумывать, изобретать',
    latvian: 'izgudrot, ieviest',
    polish: 'wynajdywać, wymyślać, odkrywać',
    french: 'inventer',
    spanish: 'inventar',
  },
  {
    av: 14954,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + shamrock)',
    english: 'Ireland',
    swedish: 'Irland',
    norwegian: 'Irland',
    finnish: 'Irlanti',
    hungarian: 'Írország',
    german: 'Irland',
    dutch: 'Ierland',
    afrikaans: 'Ierland',
    russian: 'Ирландия',
    latvian: 'Īrija',
    polish: 'Irlandia',
    french: 'Irlande',
    spanish: 'Irlanda',
  },
  {
    av: 14956,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(iron + action indicator)',
    english: 'iron-(to)',
    swedish: 'stryka',
    norwegian: 'stryke',
    finnish: 'silittää silitysradalla',
    hungarian: 'vasalni',
    german: 'bügeln',
    dutch: 'strijken',
    afrikaans: 'stryk (om te)',
    russian: 'гладить, утюжить',
    latvian: 'gludināt',
    polish: 'prasować',
    french: 'repasser',
    spanish: 'planchar',
  },
  {
    av: 14957,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(table + iron)',
    english: 'ironing board',
    swedish: 'strykbräda',
    norwegian: 'strykebrett',
    finnish: 'silityslauta',
    hungarian: 'vasalóállvány',
    german: 'Bügelbrett',
    dutch: 'strijkplank',
    afrikaans: 'strykplank',
    russian: 'гладильная доска',
    latvian: 'gludināmais dēlis',
    polish: 'deska do prasowania',
    french: 'planche à repasser, table de repassage ',
    spanish: 'tabla de planchar',
  },
  {
    av: 14959,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + Star of David)',
    english: 'Israel',
    swedish: 'Israel',
    norwegian: 'Israel',
    finnish: 'Israel',
    hungarian: 'Izrael',
    german: 'Israel',
    dutch: 'Israël',
    afrikaans: 'Israel',
    russian: 'Израиль',
    latvian: 'Izraēla',
    polish: 'Izrael',
    french: 'Israël',
    spanish: 'Israel',
  },
  {
    av: 14961,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(understanding, comprehension + through + description indicator)',
    english: 'apparent(ly), clear(ly), evident(ly), obvious(ly), plain(ly)',
    swedish: 'självklart',
    norwegian: 'selvfølgelig',
    finnish: 'ilmeisesti, selvästi',
    hungarian: 'kétségtelen/ül, nyivánvaló/an, kézenfekvő/en',
    german: 'klar, verständlich, offensichtlich',
    dutch: 'duidelijk, begrijpelijk',
    afrikaans: 'duidelik, voor die hand liggend, klaarblyklik, deursigtig',
    russian: 'ясно, очевидно, конечно',
    latvian: 'acīmredzams (-i), skaidrs (-i), acīmredzot',
    polish: 'jasny, zrozumiały, oczywisty',
    french: 'évident, explicite',
    spanish: 'aparente, aparentemente, claro, evidentemente, sencillamente',
  },
  {
    av: 14962,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(it + belongs to: refers to things rather than to people)',
    english: 'its',
    swedish: 'dess, sin, sitt, sina',
    norwegian: 'dens, dets, sitt',
    finnish: 'sen',
    hungarian: 'övé (semleges nem)',
    german: 'sein, sein, seine, sein',
    dutch: 'van het',
    afrikaans: 'sy',
    russian: 'его, её (кроме человека)',
    latvian: 'tā, tās (vsk.3.pers.piederības vietniekv.)',
    polish: 'jego',
    french: 'son, sa, ses (impersonnel)',
    spanish: 'su, sus',
  },
  {
    av: 14963,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(birth control + uterus)',
    english: 'intrauterine device, IUD',
    swedish: 'spiral (prev)',
    norwegian: 'prevensjonsmiddel',
    finnish: 'kierukka',
    hungarian: 'spirál (méhen belül), IUD',
    german: 'Intrauterinspirale',
    dutch: 'spiraaltje (anticonceptie)',
    afrikaans: 'intra-uteriene apparaat',
    russian: 'спираль внутриматочная',
    latvian: 'spirāle (dzemdes pretapaugļošanas līdzeklis)',
    polish: 'wkładka wewnątrzmaciczna',
    french: 'stérilet, dispositif intra-utérin',
    spanish: 'dispositivo intrauterino, DIU',
  },
  {
    av: 14964,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + Israel: month of Independence Day)',
    english: 'Iyar',
    swedish: 'Iyar (Israel)',
    norwegian: 'Iyar (Israel)',
    finnish: 'Ijjár',
    hungarian: 'Iyar (héber)',
    german: 'Ijjar (Monat)',
    dutch: 'Iyar (Joods)',
    afrikaans: 'lyar',
    russian: 'Ияр (Израиль)',
    latvian: 'lyar (Neatkarības dienas mēnesis Izraēlā)',
    polish: 'Iyar miesiąc hebr.',
    french: 'Iyar (2e mois du calendrier juif)',
    spanish: 'Iyar',
  },
  {
    av: 14965,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spread + fruit)',
    english: 'jam, jelly, marmalade, preserves',
    swedish: 'marmelad, sylt',
    norwegian: 'syltetøy, marmelade',
    finnish: 'hillo, hyytelö, marmeladi',
    hungarian: 'lekvár, dzsem, befőtt',
    german: 'Konfitüre, Marmelade, Gelee',
    dutch: 'confituur, jam',
    afrikaans: 'konfyt, marmelade',
    russian: 'варенье',
    latvian: 'ievārījums, želeja, marmelāde, konservēts',
    polish: 'dżem (przetwory owocowe)',
    french: 'confiture, gelée de fruits, marmelade',
    spanish: 'mermelada, jalea, conserva',
  },
  {
    av: 14966,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 1: first month of the year)',
    english: 'January',
    swedish: 'januari',
    norwegian: 'januar',
    finnish: 'tammikuu',
    hungarian: 'január',
    german: 'Januar',
    dutch: 'januari',
    afrikaans: 'Januarie',
    russian: 'январь',
    latvian: 'janvāris',
    polish: 'styczeń',
    french: 'janvier',
    spanish: 'Enero',
  },
  {
    av: 14967,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to resent + other + to have + description indicator)',
    english: 'jealous',
    swedish: 'missunnsam, svartsjuk',
    norwegian: 'sjalu, misunnelig',
    finnish: 'mustasukkainen',
    hungarian: 'féltékeny, irigy',
    german: 'eifersüchtig',
    dutch: 'jaloers',
    afrikaans: 'jaloers',
    russian: 'ревнивый',
    latvian: 'greizsirdīgs',
    polish: 'zazdrosny',
    french: 'jaloux',
    spanish: 'celoso',
  },
  {
    av: 14968,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + city + first) (Israel)',
    english: 'Jerusalem Day',
    swedish: 'Jerusalem Day (Israel)',
    norwegian: 'Jerusalem Day (Israel)',
    finnish: 'Jerusalemin päivä, Jom Jerušalajim',
    hungarian: 'Jeruzsálem Napja (héber)',
    german: 'Tag von Jerusalem',
    dutch: 'Dag van Jeruzalem (Joods)',
    afrikaans: 'Jerusalem Dag',
    russian: 'День Иерусалима',
    latvian: 'Jeruzālemes diena',
    polish: 'Dzień Jerozolimy',
    french: 'Journée de Jérusalem',
    spanish: 'Día de Jerusalén',
  },
  {
    av: 14969,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(man + cross: a man regarded by Christians as being the Son of God, who died on the cross - biblical figure)',
    english: 'Jesus (of Nazareth), Jesus Christ, Christ',
    swedish: 'Jesus, Kristus',
    norwegian: 'Jesus, Kristus',
    finnish: 'Jeesus',
    hungarian: 'Jézus, Jézus Krisztus',
    german: 'Christus, Jesus',
    dutch: 'Jezus, Christus',
    afrikaans: 'Jesus (van Nasaret), Jesus Christus',
    russian: 'Иисус',
    latvian: 'Jēzus (Nācarietis), Jēzus Kristus, Kristus',
    polish: 'Jezus Chrystus',
    french: 'Jésus (de Nazareth), Jésus-Christ, le Christ',
    spanish: 'Jesús (de Nazaret), Jesucristo',
  },
  {
    av: 14970,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plane + out of: plane driven forward by expelling gas)',
    english: 'jet, jet plane',
    swedish: 'jetplan',
    norwegian: 'jetfly',
    finnish: 'suihkukone',
    hungarian: 'lökhajtásos repülőgép',
    german: 'Düsenflugzeug',
    dutch: 'straaljager',
    afrikaans: 'straalvliegtuig',
    russian: 'реактивный самолет',
    latvian: 'reaktīvā lidmašīna',
    polish: 'samolot, odrzutowiec',
    french: 'avion à réaction',
    spanish: 'jet, avión',
  },
  {
    av: 14971,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(stone + to shine)',
    english: 'jewel, gem, gemstone',
    swedish: 'juvel, ädelsten',
    norwegian: 'edelstein, juvel',
    finnish: 'jalokivi',
    hungarian: 'ékszer',
    german: 'Juwelen, Schmuck',
    dutch: 'edelsteen, juweel',
    afrikaans: 'juweel, edelsteen, edelgesteente',
    russian: 'драгоценность',
    latvian: 'dārglieta, dārgakmens',
    polish: 'klejnot',
    french: 'bijou',
    spanish: 'joya',
  },
  {
    av: 14972,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(Star of David + description indicator: having to do with Judaism, for which the Star of David is a symbol)',
    english: 'Jewish',
    swedish: 'judisk',
    norwegian: 'jødisk',
    finnish: 'juutalainen',
    hungarian: 'zsidó',
    german: 'jüdisch',
    dutch: 'Joods',
    afrikaans: 'Joods',
    russian: 'еврейский, иудейский',
    latvian: 'ebreju',
    polish: 'hebrajski, żydowski',
    french: 'juif',
    spanish: 'Judío',
  },
  {
    av: 14974,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to say + comma + funny + action indicator: to say something in order to be funny)',
    english: 'joke (spoken)-(to)',
    swedish: 'skoja, skämta',
    norwegian: 'spøke med, tøyse med',
    finnish: 'pilailla, laskea leikkiä',
    hungarian: 'tréfálkozni, viccelni, mókázni',
    german: 'scherzen, Spaß machen, einen Witz machen',
    dutch: 'grappen maken',
    afrikaans: 'grap (om te)',
    russian: 'шутить',
    latvian: 'jokot, maldināt',
    polish: 'żartować',
    french: 'plaisanter, blaguer',
    spanish: 'bromear',
  },
  {
    av: 15137,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 7: seventh month of the year)',
    english: 'July',
    swedish: 'juli',
    norwegian: 'juli',
    finnish: 'heinäkuu',
    hungarian: 'július',
    german: 'Juli',
    dutch: 'juli',
    afrikaans: 'Julie',
    russian: 'июль',
    latvian: 'jūlijs',
    polish: 'lipiec',
    french: 'juillet',
    spanish: 'Julio',
  },
  {
    av: 15138,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + to jump + thing indicator)',
    english: 'jump rope, skipping rope',
    swedish: 'hopprep',
    norwegian: 'hoppetau',
    finnish: 'hyppynaru',
    hungarian: 'ugrókötél',
    german: 'Springseil, Seilchen',
    dutch: 'springtouw',
    afrikaans: 'springtou',
    russian: 'скакалка',
    latvian: 'lecamaukla, lecamā aukla',
    polish: 'skakanka',
    french: 'corde à sauter',
    spanish: 'salto de cuerda',
  },
  {
    av: 15139,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(jump + action indicator)',
    english: 'jump-(to)',
    swedish: 'hoppa',
    norwegian: 'hoppe',
    finnish: 'hypätä, hyppiä',
    hungarian: 'ugrani, átugrani',
    german: 'springen, hüpfen',
    dutch: 'springen',
    afrikaans: 'spring (om te)',
    russian: 'прыгать',
    latvian: 'lēkt (ar vienu kāju)',
    polish: 'skakać',
    french: 'sauter',
    spanish: 'saltar',
  },
  {
    av: 15140,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 6: sixth month of the year)',
    english: 'June',
    swedish: 'juni',
    norwegian: 'juni',
    finnish: 'kesäkuu',
    hungarian: 'június',
    german: 'Juni',
    dutch: 'juni',
    afrikaans: 'Junie',
    russian: 'июнь',
    latvian: 'jūnijs',
    polish: 'czerwiec',
    french: 'juin',
    spanish: 'Junio',
  },
  {
    av: 15141,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(greeting + Sabbath: ceremony to welcome the Sabbath)',
    english: 'Kabbalat Shabbat',
    swedish: 'Kabbalat Shabbat (Israel)',
    norwegian: 'Kabbalat Shabbat (Israel)',
    finnish: 'hyvää vapaapäivää',
    hungarian: 'a Shabbat köszöntése (héber)',
    german: 'Shabbat, Schabbat',
    dutch: 'Kabbalat Shabbat (Joods)',
    afrikaans: 'Kabbalat Shabbat',
    russian: 'Каббалат Шаббат (Израиль)',
    latvian: 'Kabbala (Izraēla)',
    polish: 'Kabalat szabat (hebr. święto)',
    french: 'Kabbalat Sabbath',
    spanish: 'kabbalat shabbat',
  },
  {
    av: 15142,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(god + black: Hindu goddess) (India)',
    english: 'Kali',
    swedish: 'Kali (Indien)',
    norwegian: 'Kali (India)',
    finnish: 'Kali',
    hungarian: 'Kali (indiai fekete Istennő)',
    german: 'Kali (Hindu-Göttin)',
    dutch: 'Kali (Indisch)',
    afrikaans: 'Kali',
    russian: 'Кали (Индия)',
    latvian: 'Kali (Indija)',
    polish: 'Kali – bogini hind.',
    french: 'Kali (hindouisme)',
    spanish: 'Kali',
  },
  {
    av: 15143,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to hold + future + action indicator: to hold for the future)',
    english: 'keep, preserve, save-(to)',
    swedish: 'behålla, spara',
    norwegian: 'beholde, spare',
    finnish: 'pitää tallessa, säästää, säilyttää',
    hungarian: 'őrizni, megőrizni, megóvni',
    german: 'aufbewahren, sparen, behalten, erhalten, bewahren',
    dutch: 'bewaren, behouden',
    afrikaans: 'hou, bewaar, spaar (om te)',
    russian: 'сохранить, сберечь',
    latvian: 'glabāt, saglabāt',
    polish: 'utrzymywać, konserwować, zachowywać na przyszłość',
    french: 'garder, conserver',
    spanish: 'mantener, conservar',
  },
  {
    av: 15145,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(village + to work + to live + together: collective settlement ) (Israel)',
    english: 'kibbutz',
    swedish: 'kibbutz (Israel)',
    norwegian: 'kibbutz (Israel)',
    finnish: 'kibbutsi',
    hungarian: 'kibuc (héber)',
    german: 'Kibbutz',
    dutch: 'kibboets (Joods)',
    afrikaans: 'kibboets',
    russian: 'киббуц (Израиль)',
    latvian: 'kibucs',
    polish: 'Kibuc ',
    french: 'kibboutz',
    spanish: 'kibutz',
  },
  {
    av: 15146,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(leg and foot + intensity + action indicator: to move legs and feet forcefully)',
    english: 'kick-(to)',
    swedish: 'sparka',
    norwegian: 'sparke',
    finnish: 'potkia, potkaista',
    hungarian: 'rúgni, belerúgni, megrúgni',
    german: 'treten, kicken, schießen',
    dutch: 'schoppen, trappen',
    afrikaans: 'skop, trap (om te)',
    russian: 'пинать, ударять',
    latvian: 'iesist',
    polish: 'kopnąć',
    french: 'donner un coup de pied',
    spanish: 'patear',
  },
  {
    av: 15147,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(prayer + wine: blessing over wine)',
    english: 'kiddush, blessing over wine',
    swedish: 'kiddush, välsignelse av vin (Israel)',
    norwegian: 'kiddush (Israel)',
    finnish: 'kiddush',
    hungarian: 'áldomás',
    german: 'kiddush',
    dutch: 'kiddush (Joods)',
    afrikaans: 'kiddush',
    russian: 'киддуш (Израиль)',
    latvian: 'kiduss (Izraēlā vīna svētīšana)',
    polish: 'Kiddusz ceremonia hebr.',
    french: 'kiddoush (prière de sanctification du vin)',
    spanish: 'kidush, bendición del vino',
  },
  {
    av: 15148,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cause + to die + action indicator)',
    english: 'kill, murder-(to)',
    swedish: 'döda, mörda, avliva, dräpa',
    norwegian: 'drepe, avlive',
    finnish: 'tappaa, murhata',
    hungarian: 'ölni, gyilkolni, megölni, meggyilkolni',
    german: 'töten, ermorden',
    dutch: 'vermoorden, doden',
    afrikaans: 'vermoor, doodmaak (om te)',
    russian: 'убивать',
    latvian: 'nogalināt, noslepkavot',
    polish: 'zabić, popełnić morderstwo',
    french: 'tuer, assassiner',
    spanish: 'matar. Asesinar',
  },
  {
    av: 15149,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(feeling + help + description indicator: feeling of wanting to be helpful)',
    english: 'kind, kindly',
    swedish: 'hjälpsam, vänlig',
    norwegian: 'hjelpsom, snill, vennlig',
    finnish: 'kiltti, ystävällinen',
    hungarian: 'segítőkész/en, szívélyes/en, jóindulatú/an',
    german: 'freundlich',
    dutch: 'vriendelijk, behulpzaam',
    afrikaans: 'vriendelik, behulpsaam',
    russian: 'добрый, любезный',
    latvian: 'laipns, laipni',
    polish: 'uprzejmy, miły',
    french: 'gentil, aimable',
    spanish: 'amable, amablemente',
  },
  {
    av: 15151,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + happy + light: month of Chanukah)',
    english: 'Kislev',
    swedish: 'Kislev (Israel)',
    norwegian: 'Kislev (Israel)',
    finnish: 'kislev, kislév',
    hungarian: 'Kislev (héber)',
    german: 'Kislev',
    dutch: 'Kislev (Joods)',
    afrikaans: 'Kislev',
    russian: 'Кислев (Израиль)',
    latvian: 'Kisleva (Izraēla)',
    polish: 'Kislew – miesiąc hebr.',
    french: 'Kislev (9e mois du calendrier juif)',
    spanish: 'Kislev',
  },
  {
    av: 15153,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(kiss + action indicator)',
    english: 'kiss-(to)',
    swedish: 'kyssa, pussa',
    norwegian: 'kysse',
    finnish: 'suudella',
    hungarian: 'csókolni, megcsókolni',
    german: 'küssen',
    dutch: 'kussen, zoenen',
    afrikaans: 'kus, soen (om te)',
    russian: 'целоваться',
    latvian: 'skūpstīties ',
    polish: 'całować',
    french: 'embrasser, donner un bisou',
    spanish: 'besar',
  },
  {
    av: 15154,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + to prepare food)',
    english: 'kitchen',
    swedish: 'kök',
    norwegian: 'kjøkken',
    finnish: 'keittiö',
    hungarian: 'konyha',
    german: 'Küche',
    dutch: 'keuken',
    afrikaans: 'kombuis',
    russian: 'кухня',
    latvian: 'virtuve',
    polish: 'kuchnia',
    french: 'cuisine',
    spanish: 'cocina',
  },
  {
    av: 15158,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(kneeling (kneeling person) + action indicator)',
    english: 'kneel-(to)',
    swedish: 'stå på knä',
    norwegian: 'stå på kne, knele',
    finnish: 'polvistua',
    hungarian: 'térdelni, letérdelni',
    german: 'knien',
    dutch: 'knielen',
    afrikaans: 'kniel (om te)',
    russian: 'стоять на коленях',
    latvian: 'notupties uz ceļiem',
    polish: 'klęczeć, klęknąć, uklęknąć',
    french: "agenouiller-(s')",
    spanish: 'arrodillar',
  },
  {
    av: 15160,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to make + cloth + 2 + linear thing + thing indicator + action indicator: to make cloth using two linear things, i.e., knitting needles)',
    english: 'knit-(to)',
    swedish: 'sticka (kläder)',
    norwegian: 'strikke',
    finnish: 'kutoa, neuloa',
    hungarian: 'kötni (fonalból)',
    german: 'stricken',
    dutch: 'breien',
    afrikaans: 'brei (om te)',
    russian: 'вязать',
    latvian: 'adīt',
    polish: 'robić na drutach',
    french: 'tricoter',
    spanish: 'tejer',
  },
  {
    av: 15161,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(knowledge + action indicator)',
    english: 'know-(to)',
    swedish: 'veta',
    norwegian: 'vite',
    finnish: 'tietää',
    hungarian: 'tudni',
    german: 'wissen, kennen, sich auskennen, auskennen',
    dutch: 'weten',
    afrikaans: 'weet (om te)',
    russian: 'знать',
    latvian: 'zināt',
    polish: 'wiedzieć',
    french: 'savoir',
    spanish: 'saber, conocer',
  },
  {
    av: 15163,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(marsupial + tree: marsupial adapted to living in trees)',
    english: 'koala',
    swedish: 'koala',
    norwegian: 'koala',
    finnish: 'pussikarhu',
    hungarian: 'koalamedve',
    german: 'Koala',
    dutch: 'koala',
    afrikaans: 'koala, koalabeer',
    russian: 'коала',
    latvian: 'koala',
    polish: 'koala',
    french: 'koala',
    spanish: 'koala',
  },
  {
    av: 15164,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(colour + plus + eyelid (lower): eye make-up, traditionally used by women in African, Middle East, and Eastern cultures)',
    english: 'eyeliner, kohl',
    swedish: 'eyeliner',
    norwegian: 'eyeliner',
    finnish: 'rajausväri, kajaali',
    hungarian: 'szemfestés, kohl (India)',
    german: 'Eyeliner',
    dutch: 'kohl, oogpotlood',
    afrikaans: 'oogpotlood',
    russian: 'подводка для глаз',
    latvian: 'acu lainieris, acu ēnas',
    polish: 'kredka do oczu, cień do oka, przybory do makijażu oka',
    french: 'maquillage à paupières (crayon)',
    spanish: 'delineador, kohl',
  },
  {
    av: 15165,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + birth)',
    english: 'labour',
    swedish: 'förlossning',
    norwegian: 'forløsning',
    finnish: 'synnytys',
    hungarian: 'szülés',
    german: 'Entbindung',
    dutch: 'arbeid (bevalling)',
    afrikaans: 'kraam, bevalling',
    russian: 'роды',
    latvian: 'dzemdības',
    polish: 'poród, rodzenie',
    french: 'travail (accouchement)',
    spanish: 'mano de obra',
  },
  {
    av: 15167,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(night + comma + bonfire)',
    english: "Lag B'Omer",
    swedish: "Lag B'Omer (Israel)",
    norwegian: "Lag B'Omer (Israel)",
    finnish: 'lag baomer',
    hungarian: "Lag B'Omer (héber)",
    german: "Lag B'Omer",
    dutch: "Lag B'Omer (Joods)",
    afrikaans: "Lag B'Omer",
    russian: 'Лаг Бомер (Израиль)',
    latvian: 'lag bomer (Izraēla)',
    polish: "Lag B'Omer – święto hebr.",
    french: 'Lag BaOmer (fête juive)',
    spanish: "Lag B'Omer",
  },
  {
    av: 15168,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(much + water: body of water)',
    english: 'lake, pond',
    swedish: 'sjö',
    norwegian: 'sjø, innsjø',
    finnish: 'järvi',
    hungarian: 'tó, tavacska, mesterséges tó',
    german: 'See',
    dutch: 'meer, plas, vijver',
    afrikaans: 'meer, dam',
    russian: 'озеро',
    latvian: 'ezers, dīķis',
    polish: 'jezioro, staw, mały zbiornik wodny',
    french: 'lac, étang',
    spanish: 'lago',
  },
  {
    av: 15169,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(God + money: Hindu goddess) (India)',
    english: 'Lakshmi',
    swedish: 'Lakshmi (Indien)',
    norwegian: 'Lakshmi (India)',
    finnish: 'Lakshmi, Laxmi',
    hungarian: 'Lakshmi (a pénz hindu Istene)',
    german: 'Lakshmi (Hindu-Göttin)',
    dutch: 'Lakshmi (Indisch)',
    afrikaans: 'Lakshmi',
    russian: 'Лакшми (Индия)',
    latvian: 'Lakšmi (Indija)',
    polish: 'Lakszimi – indyjska bogini szczęścia, bogactwa i piękna',
    french: 'Lakshmi (hindouisme)',
    spanish: 'Lakshmi',
  },
  {
    av: 15170,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + sheep: food that comes from a lamb or sheep. The symbol also can be explained as: combination of meat and sheep.)',
    english: 'lamb, mutton',
    swedish: 'lammkött',
    norwegian: 'fårekjøtt, lammekjøtt',
    finnish: 'lampaanliha',
    hungarian: 'bárányhús, birkahús, ürühús',
    german: 'Hammelfleisch, Lammfleisch',
    dutch: 'schapenvlees',
    afrikaans: 'lamsvleis, skaapvleis',
    russian: 'баранина',
    latvian: 'jēra gaļa, aitas gaļa',
    polish: 'baranina',
    french: 'agneau, mouton (viande)',
    spanish: 'cordero, oveja',
  },
  {
    av: 15171,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(airplane + downward and forward)',
    english: 'landing, airplane landing',
    swedish: 'landning',
    norwegian: 'landing',
    finnish: 'laskeutuminen (lentokoneen)',
    hungarian: 'leszállás (repülőgép)',
    german: 'Landung (Flugzeug)',
    dutch: 'landing',
    afrikaans: 'landingstrook',
    russian: 'приземление',
    latvian: 'nolaišanās, lidmašīnas nosēšanās',
    polish: 'lądowanie (samolot)',
    french: 'atterrissage',
    spanish: 'aterrizaje',
  },
  {
    av: 15173,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(opposite meaning + first + description indicator)',
    english: 'last, final',
    swedish: 'sista, sist',
    norwegian: 'sist, siste',
    finnish: 'viimeinen, viime',
    hungarian: 'utolsó, végső',
    german: 'letzter, zuletzt',
    dutch: 'laatste',
    afrikaans: 'laaste, finale',
    russian: 'последний',
    latvian: 'pēdējais, pēdējā',
    polish: 'ostatni, kończący, na końcu, finałowy',
    french: 'dernier (contraire de premier)',
    spanish: 'pasado',
  },
  {
    av: 15174,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(night + ago, then (past))',
    english: 'last night',
    swedish: 'igår natt',
    norwegian: 'i går natt',
    finnish: 'viime yö',
    hungarian: 'tegnap éjjel, előző éjjel',
    german: 'gestern Abend, letzte Nacht',
    dutch: 'gisteravond',
    afrikaans: 'laasnag',
    russian: 'прошлой ночью',
    latvian: 'pagājušajā naktī',
    polish: 'wczoraj wieczorem',
    french: 'nuit passée, nuit dernière',
    spanish: 'anoche',
  },
  {
    av: 15175,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(week + ago, then (past))',
    english: 'last week',
    swedish: 'förra veckan',
    norwegian: 'forrige uke',
    finnish: 'viime viikko',
    hungarian: 'múlt hét, előző hét',
    german: 'vorige Woche, letzte Woche',
    dutch: 'verleden week, vorige week',
    afrikaans: 'laas week, verlede week',
    russian: 'на прошлой неделе',
    latvian: 'pagājušajā nedēļā',
    polish: 'w zeszłym tygodniu, tydzień temu',
    french: 'semaine passée, semaine dernière',
    spanish: 'la semana pasada',
  },
  {
    av: 15176,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(year + ago, then (past))',
    english: 'last year',
    swedish: 'förra året',
    norwegian: 'forrige år',
    finnish: 'viime vuosi',
    hungarian: 'múlt év, előző év',
    german: 'voriges Jahr, letztes Jahr',
    dutch: 'verleden jaar, vorig jaar',
    afrikaans: 'laas jaar, verlede jaar',
    russian: 'в прошлом году',
    latvian: 'pagājušajā gadā',
    polish: 'w zeszłym roku, rok temu',
    french: 'année passée, an dernier',
    spanish: 'el año pasado',
  },
  {
    av: 15177,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(after + time + description indicator: after the appointed time)',
    english: 'late',
    swedish: 'sen, för sen, försenad',
    norwegian: 'for seint, forsinket',
    finnish: 'myöhäinen, myöhässä',
    hungarian: 'késő, késői',
    german: 'spät, verspätet, zu spät',
    dutch: 'laat',
    afrikaans: 'laat',
    russian: 'поздний, поздно',
    latvian: 'vēls',
    polish: 'późno',
    french: 'tard, en retard',
    spanish: 'tarde, atrasado, retrasado',
  },
  {
    av: 15178,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(laugh, laughter + action indicator: to express happiness with the mouth by laughing)',
    english: 'laugh-(to)',
    swedish: 'skratta',
    norwegian: 'le',
    finnish: 'nauraa',
    hungarian: 'nevetni',
    german: 'lachen',
    dutch: 'lachen',
    afrikaans: 'lag (om te)',
    russian: 'смеяться',
    latvian: 'smieties',
    polish: 'śmiać się, cieszyć się',
    french: 'rire',
    spanish: 'reír',
  },
  {
    av: 15179,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(public room + bath, washing + clothing)',
    english: 'laundromat, launderette, laundry',
    swedish: 'tvättinrättning',
    norwegian: 'vaskeri',
    finnish: 'pesula',
    hungarian: 'mosoda (nyilvános)',
    german: 'Waschsalon',
    dutch: 'wasserette, wasserij',
    afrikaans: 'wassery',
    russian: 'прачечная',
    latvian: 'veļas mazgājamā mašīna, mazgātava',
    polish: 'pralnia (punkt usługowy)',
    french: 'blanchisserie',
    spanish: 'lavandería',
  },
  {
    av: 15181,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(leadership, guidance + action indicator: to use mental powers to carry events or persons forward)',
    english: 'lead, direct, guide-(to)',
    swedish: 'leda, styra',
    norwegian: 'lede, styre',
    finnish: 'johtaa, ohjata, opastaa',
    hungarian: 'vezetni, irányítani',
    german: 'leiten, führen, lenken, anführen',
    dutch: 'leiden',
    afrikaans: 'lei (om te)',
    russian: 'руководить, управлять',
    latvian: 'vadīt, virzīt',
    polish: 'prowadzić, przewodzić, kierować',
    french: 'diriger',
    spanish: 'liderar, dirigir, guiar',
  },
  {
    av: 15182,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + leadership)',
    english: 'leader, director, guide (2)',
    swedish: 'ledare (2)',
    norwegian: 'leder (2)',
    finnish: 'johtaja, esimies, työnjohtaja, opas, ohjaaja, manageri',
    hungarian: 'vezető, irányító, útmutató személy (pl. igazgató)',
    german: 'Leiter, Leiterin, Führer, Führerin, Reiseführer, Reiseführerin (2)',
    dutch: 'leider, directeur (2)',
    afrikaans: 'leier, direkteur, gids (2)',
    russian: 'руководитель, лидер (2)',
    latvian: 'vadītājs, direktors, padomdevējs (2)',
    polish: 'dyrektor, przewodnik, przywódca (2)',
    french: 'directeur, dirigeant (2)',
    spanish: 'líder, director, guía (2)',
  },
  {
    av: 15184,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to receive + knowledge + action indicator)',
    english: 'learn-(to)',
    swedish: 'lära sig, studera',
    norwegian: 'lære, studere',
    finnish: 'oppia',
    hungarian: 'tanulni, megtanulni, okulni',
    german: 'lernen',
    dutch: 'leren',
    afrikaans: 'leer (om te)',
    russian: 'учиться',
    latvian: 'mācīties',
    polish: 'uczyć się, dowiadywać',
    french: 'apprendre',
    spanish: 'aprender',
  },
  {
    av: 15185,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(opposite meaning + most + description indicator)',
    english: 'fewest, least',
    swedish: 'minst',
    norwegian: 'minst, færrest',
    finnish: 'vähiten',
    hungarian: 'legkevesebb, legcsekélyebb',
    german: 'am wenigsten, die wenigsten',
    dutch: 'minst',
    afrikaans: 'minste',
    russian: 'наименьший, меньше всего',
    latvian: 'vismazāk ',
    polish: 'najmniej',
    french: 'le moins',
    spanish: 'menos',
  },
  {
    av: 15186,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + animal skin: material made from an animal skin)',
    english: 'leather',
    swedish: 'läder, skinn',
    norwegian: 'lær, skinn',
    finnish: 'nahka-aine',
    hungarian: 'bőr, bőr-, bőráru, állati bőrből készült',
    german: 'Leder',
    dutch: 'leer',
    afrikaans: 'leer (dier)',
    russian: 'кожа',
    latvian: 'āda, ādas izstrādājums',
    polish: 'skóra zwierzęca',
    french: 'cuir (matière)',
    spanish: 'cuero',
  },
  {
    av: 15187,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(left turn, left (position or direction) + description indicator)',
    english: 'left',
    swedish: 'vänster',
    norwegian: 'venstre',
    finnish: 'vasen, vasemmanpuoleinen',
    hungarian: 'bal, balra',
    german: 'links',
    dutch: 'links',
    afrikaans: 'links',
    russian: 'левый',
    latvian: 'kreisais',
    polish: 'lewy',
    french: 'gauche',
    spanish: 'izquierda',
  },
  {
    av: 15191,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drink + lemon)',
    english: 'lemonade',
    swedish: 'citronsaft',
    norwegian: 'sitronsaft',
    finnish: 'sitruunajuoma',
    hungarian: 'citromlé, limonádé',
    german: 'Limonade',
    dutch: 'citroensap',
    afrikaans: 'lemonade',
    russian: 'лимонад, ситро',
    latvian: 'limonāde',
    polish: 'lemoniada, napój cytrynowy',
    french: 'citronnade, limonade',
    spanish: 'limonada',
  },
  {
    av: 15192,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to give + limited time + action indicator: to give for a limited time)',
    english: 'lend, loan-(to)',
    swedish: 'låna ut',
    norwegian: 'låne ut',
    finnish: 'lainata, antaa lainaksi',
    hungarian: 'kölcsönadni, kölcsönt nyújtani, kölcsönözni',
    german: 'verleihen, borgen, ausleihen',
    dutch: 'uitlenen',
    afrikaans: 'leen, uitleen (om te)',
    russian: 'одалживать, давать взаймы',
    latvian: 'aizdot',
    polish: 'pożyczyć, użyczyć, wypożyczyć',
    french: 'prêter',
    spanish: 'prestar',
  },
  {
    av: 15194,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feline + spot: feline with spots)',
    english: 'leopard',
    swedish: 'leopard',
    norwegian: 'leopard',
    finnish: 'leopardi',
    hungarian: 'leopárd, párduc',
    german: 'Leopard',
    dutch: 'luipaard',
    afrikaans: 'luiperd',
    russian: 'леопард',
    latvian: 'leopards',
    polish: 'leopard',
    french: 'léopard',
    spanish: 'leopardo',
  },
  {
    av: 15195,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(opposite meaning + more + description indicator)',
    english: 'fewer, less',
    swedish: 'mindre, färre',
    norwegian: 'mindre, færre',
    finnish: 'vähemmän',
    hungarian: 'kevesebb, csekélyebb',
    german: 'weniger, geringer',
    dutch: 'minder',
    afrikaans: 'minder',
    russian: 'меньше, менее',
    latvian: 'mazāk',
    polish: 'mniej, rzadszy',
    french: 'moins',
    spanish: 'menos',
  },
  {
    av: 15196,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(permission, allowance + action indicator: CKB says that the symbol represents a thought that is allowed to pass through a mental barrier)',
    english: 'let, allow, permit-(to)',
    swedish: 'tillåta, låta, få',
    norwegian: 'la, tilate',
    finnish: 'antaa, sallia',
    hungarian: 'engedni, megengedni, engedélyezni',
    german: 'lassen, zulassen, erlauben, genehmigen, gestatten, gewähren',
    dutch: 'mogen, laten, toestaan',
    afrikaans: 'toelaat, laat, toegee, toestaan (om te)',
    russian: 'позволять, разрешать',
    latvian: 'ļaut, atļaut, dot atļauju',
    polish: 'pozwalać, zezwalać',
    french: 'permettre, autoriser',
    spanish: 'dejar, permitir',
  },
  {
    av: 15197,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(command + to let + us + action indicator + plural indicator: the first person plural imperative of 'to let')",
    english: "let us, let's",
    swedish: 'låt oss',
    norwegian: 'la oss',
    finnish: 'päättäkäämme',
    hungarian: 'hadd…, engedd/engedje meg',
    german: 'lasst uns, wollen wir...?',
    dutch: 'laat ons',
    afrikaans: 'laat ons',
    russian: 'давайте, пусть ',
    latvian: 'uzrunas forma: iesim, darīsim u.c.',
    polish: 'pozwól nam!',
    french: 'permets-nous de',
    spanish: 'dejadnos',
  },
  {
    av: 15199,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + letter)',
    english: 'letter carrier, postman, mailman',
    swedish: 'brevbärare',
    norwegian: 'postmann',
    finnish: 'postinkantaja, postimies',
    hungarian: 'levélhordó, postás',
    german: 'Briefträger, Briefträgerin, Postbote, Postbotin, Zusteller, Zustellerin',
    dutch: 'postbode',
    afrikaans: 'posbode',
    russian: 'почтальон',
    latvian: 'pastnieks',
    polish: 'listonosz, kurier',
    french: 'facteur',
    spanish: 'cartero, mensajero',
  },
  {
    av: 15201,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + book: building that contains a collection of books)',
    english: 'library (building)',
    swedish: 'bibliotek (byggnad)',
    norwegian: 'bibliotek (bygning)',
    finnish: 'kirjasto',
    hungarian: 'könyvtár (épület)',
    german: 'Bücherei',
    dutch: 'bibliotheek',
    afrikaans: 'biblioteek',
    russian: 'библиотека (здание)',
    latvian: 'bibliotēka (ēka)',
    polish: 'biblioteka (instytucja)',
    french: 'bibliothèque',
    spanish: 'biblioteca (edificio)',
  },
  {
    av: 15202,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + book: room that contains a collection of books)',
    english: 'library (room)',
    swedish: 'bibliotek (rum)',
    norwegian: 'bibliotek (rom)',
    finnish: 'kirjastohuone',
    hungarian: 'könyvtár (szoba, helyiség, terem)',
    german: 'Bibliothek, Bücherei, Leseraum',
    dutch: 'bibliotheek (kamer)',
    afrikaans: 'biblioteek (kamer)',
    russian: 'библиотека (помещение)',
    latvian: 'bibliotēka (telpa)',
    polish: 'biblioteczka, domowa biblioteka',
    french: 'bibliothèque (pièce)',
    spanish: 'biblioteca (habitación)',
  },
  {
    av: 15205,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(reclining, lying (person lying down) + action indicator)',
    english: 'lie down, lie-(to)',
    swedish: 'ligga',
    norwegian: 'ligge',
    finnish: 'maata',
    hungarian: 'feküdni, lefeküdni',
    german: 'liegen, sich hinlegen',
    dutch: 'liggen',
    afrikaans: 'lê (om te)',
    russian: 'лежать',
    latvian: 'gulēt, nogulties',
    polish: 'leżeć',
    french: "allonger-(s'), coucher-(se)",
    spanish: 'tumbarse, acostarse',
  },
  {
    av: 15207,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(up + weight + action indicator: to raise a weight)',
    english: 'lift, raise-(to)',
    swedish: 'lyfta',
    norwegian: 'løfte, heve',
    finnish: 'nostaa',
    hungarian: 'emelni, felemelni, megemelni',
    german: 'heben, hochheben, anheben',
    dutch: 'omhoogbrengen, (op)tillen, heffen',
    afrikaans: 'hef, oplig (om te)',
    russian: 'поднимать',
    latvian: 'celt, pacelt',
    polish: 'podnosić, dźwigać, unosić',
    french: 'soulever',
    spanish: 'levantar',
  },
  {
    av: 15210,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(goodness + action indicator: to have a positive or good feeling toward someone or something)',
    english: 'like-(to)',
    swedish: 'tycka om, gilla',
    norwegian: 'like',
    finnish: 'pitää jostakin',
    hungarian: 'kedvelni, tetszeni (kedve van valamihez, tetszik)',
    german: 'mögen, möchten, gern haben',
    dutch: 'houden van, graag hebben, aardig vinden, leuk vinden',
    afrikaans: 'hou van (om te)',
    russian: 'нравиться',
    latvian: 'patikt',
    polish: 'lubić',
    french: 'aimer, apprécier',
    spanish: 'gustar, querer',
  },
  {
    av: 15211,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(citrus fruit + green)',
    english: 'lime',
    swedish: 'lime',
    norwegian: 'lime',
    finnish: 'limejuoma',
    hungarian: 'zöldcitrom, lima',
    german: 'Limone',
    dutch: 'limoen',
    afrikaans: 'lemmetjie',
    russian: 'лайм ',
    latvian: 'laims',
    polish: 'limetka',
    french: 'citron vert, lime',
    spanish: 'cal (fruta)',
  },
  {
    av: 15215,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(line + description indicator)',
    english: 'linear, straight',
    swedish: 'rak',
    norwegian: 'rett',
    finnish: 'suora',
    hungarian: 'egyenes, vonalas, hosszirányú, lineáris',
    german: 'gerade',
    dutch: 'recht',
    afrikaans: 'lineêre, reguit',
    russian: 'прямой',
    latvian: 'lineārs, taisns',
    polish: 'prosty, liniowy',
    french: 'linéaire, droit',
    spanish: 'lineal, recto',
  },
  {
    av: 15216,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(line + thing indicator) ',
    english: 'linear thing',
    swedish: 'rak sak, sticka, strå (etc)',
    norwegian: 'rett ting, rett sak',
    finnish: 'suora esine',
    hungarian: 'egyenes tárgy, bot, rúd',
    german: 'eine gerade Sache, Stange, Pol (etc)',
    dutch: 'rechte',
    afrikaans: 'lineêre, reguit ding, paal',
    russian: 'прямой предмет',
    latvian: 'lineāra lieta, miets, stabs',
    polish: 'słup, kołek, prosty pionowy przedmiot, ',
    french: 'objet linéaire',
    spanish: 'algo lineal',
  },
  {
    av: 15217,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feline + mane (lion etc): male of the species has a mane)',
    english: 'lion',
    swedish: 'lejon',
    norwegian: 'løve',
    finnish: 'leijona',
    hungarian: 'oroszlán',
    german: 'Löwe',
    dutch: 'leeuw',
    afrikaans: 'leeu',
    russian: 'лев',
    latvian: 'lauva',
    polish: 'lew',
    french: 'lion',
    spanish: 'león',
  },
  {
    av: 15219,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(colour + plus + lips: colour added to lips)',
    english: 'lipstick',
    swedish: 'läppstift',
    norwegian: 'leppestift',
    finnish: 'huulipuna',
    hungarian: 'rúzs, ajakrúzs, szájrúzs',
    german: 'Lippenstift',
    dutch: 'lippenstift, lipstick',
    afrikaans: 'lipstiffie',
    russian: 'губная помада',
    latvian: 'lūpu krāsa',
    polish: 'szminka, pomadka',
    french: 'maquillage, rouge à lèvres',
    spanish: 'lápiz labial',
  },
  {
    av: 15220,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + many + thing: written record of many things)',
    english: 'list, inventory',
    swedish: 'lista',
    norwegian: 'liste',
    finnish: 'lista, luettelo',
    hungarian: 'lista, leltár',
    german: 'Liste',
    dutch: 'lijst',
    afrikaans: 'lys, inventaris',
    russian: 'список',
    latvian: 'saraksts, inventārs',
    polish: 'lista, spis, indeks',
    french: 'liste',
    spanish: 'lista, inventario',
  },
  {
    av: 15221,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(vertical line [half-sized] bounded by two horizontal reference lines [half-sized] + description indicator: the vertical line is relatively little) See also: big, large 12835.',
    english: 'little, small',
    swedish: 'liten',
    norwegian: 'liten',
    finnish: 'pieni, lyhyt',
    hungarian: 'kis, kicsi',
    german: 'klein',
    dutch: 'klein',
    afrikaans: 'klein',
    russian: 'маленький',
    latvian: 'mazs, neliels',
    polish: 'mały',
    french: 'petit',
    spanish: 'poco',
  },
  {
    av: 15222,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(life + action indicator)',
    english: 'live (life)-(to)',
    swedish: 'leva',
    norwegian: 'leve',
    finnish: 'elää',
    hungarian: 'élni, létezni',
    german: 'leben',
    dutch: 'leven',
    afrikaans: 'lewe (om te)',
    russian: 'жить, существовать',
    latvian: 'dzīvot, eksistēt',
    polish: 'żyć',
    french: 'vivre',
    spanish: 'vivir (la vida)',
  },
  {
    av: 15223,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(house + action indicator)',
    english: 'live, dwell, reside-(to)',
    swedish: 'bo',
    norwegian: 'bo',
    finnish: 'asua',
    hungarian: 'lakni, lakni, tartózkodni valahol',
    german: 'wohnen, wohnhaft sein, residieren',
    dutch: 'wonen',
    afrikaans: 'woon, bly (om te)',
    russian: 'жить, проживать',
    latvian: 'dzīvot, mitināties, apdzīvot',
    polish: 'mieszkać, przebywać',
    french: 'habiter',
    spanish: 'vivir (en un lugar), residir',
  },
  {
    av: 15224,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + chair: room where one can sit)',
    english: 'living room, lounge, sitting room, front room, parlor, parlour, waiting room',
    swedish: 'vardagsrum, dagrum',
    norwegian: 'dagligstue',
    finnish: 'olohuone, oleskelutila',
    hungarian: 'nappali, társalgó, szalon',
    german: 'Wohnzimmer, Foyer, Vorzimmer, Warteraum',
    dutch: 'huiskamer, woonkamer, zitkamer, living',
    afrikaans: 'sitkamer, woonkamer, voorkamer',
    russian: 'зал, холл, гостиная',
    latvian: 'dzīvojamā istaba, viesistaba, halle',
    polish: 'pokój dzienny, salon, bawialnia',
    french: "salon, salle d'attente",
    spanish: 'salón',
  },
  {
    av: 15227,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(key + action indicator)',
    english: 'lock-(to)',
    swedish: 'låsa',
    norwegian: 'låse',
    finnish: 'lukita',
    hungarian: 'bezárni, rázárni, kulcsra zárni, becsukni',
    german: 'abschließen, zuschließen, verriegeln',
    dutch: 'op slot doen, sluiten',
    afrikaans: 'sluit (om te)',
    russian: 'запирать, отпирать ключом',
    latvian: 'aizslēgt',
    polish: 'zamykać, zakluczyć',
    french: 'fermer à clef, serrer',
    spanish: 'cerrar, bloquear',
  },
  {
    av: 15228,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(feeling + minus + person + description indicator: feeling of being without companionship)',
    english: 'lonely, lonesome',
    swedish: 'ensam',
    norwegian: 'ensom',
    finnish: 'yksinäinen',
    hungarian: 'magányos, egyedülálló, társtalan',
    german: 'einsam, allein',
    dutch: 'eenzaam',
    afrikaans: 'eensaam, alleen',
    russian: 'одинокий',
    latvian: 'vientuļš, vientulīgs',
    polish: 'samotny',
    french: 'seul, solitaire, isolé',
    spanish: 'solitario',
  },
  {
    av: 15229,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(length + description indicator)',
    english: 'long',
    swedish: 'lång',
    norwegian: 'lang',
    finnish: 'pitkä',
    hungarian: 'hosszú',
    german: 'lang',
    dutch: 'lang',
    afrikaans: 'lank',
    russian: 'длинный',
    latvian: 'garš',
    polish: 'długi',
    french: 'long',
    spanish: 'largo',
  },
  {
    av: 15230,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(more + long + description indicator)',
    english: 'longer',
    swedish: 'längre',
    norwegian: 'lenger, lengre',
    finnish: 'pitempi',
    hungarian: 'hosszabb',
    german: 'länger',
    dutch: 'langer',
    afrikaans: 'langer',
    russian: 'длиннее',
    latvian: 'garāks',
    polish: 'dłuższy (odległość)',
    french: 'plus long',
    spanish: 'más largo',
  },
  {
    av: 15393,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(most + long + description indicator)',
    english: 'longest',
    swedish: 'längst',
    norwegian: 'lengst',
    finnish: 'pisin',
    hungarian: 'leghosszabb',
    german: 'am längsten',
    dutch: 'langst',
    afrikaans: 'langste',
    russian: 'самый длинный',
    latvian: 'visgarākais',
    polish: 'najdłuższy',
    french: 'le plus long',
    spanish: 'el más largo',
  },
  {
    av: 15394,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(opposite meaning + to find + action indicator)',
    english: 'lose (fail to keep)-(to)',
    swedish: 'förlora, tappa bort',
    norwegian: 'miste',
    finnish: 'hukata, kadottaa, kadota',
    hungarian: 'elveszíteni, elhagyni',
    german: '(etwas) verlieren',
    dutch: 'verliezen, kwijtraken',
    afrikaans: 'verloor, verplaas (om te)',
    russian: 'терять',
    latvian: 'pazaudēt (neizdoties paturēt)',
    polish: 'zgubić coś',
    french: 'perdre',
    spanish: 'perder (no guardar)',
  },
  {
    av: 15396,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + to take away: emotional response to the loss of someone or something)',
    english: 'loss (emotional)',
    swedish: 'saknad',
    norwegian: 'savn',
    finnish: 'kaipaus, puute',
    hungarian: 'veszteség, kár, elveszés, elvesztés',
    german: 'Verlust',
    dutch: 'verlies',
    afrikaans: 'verlies',
    russian: 'потеря, лишение',
    latvian: 'zaudējums',
    polish: 'strata (uczucie)',
    french: 'perte',
    spanish: 'pérdida',
  },
  {
    av: 15397,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(noise (loud) + description indicator)',
    english: 'loud, noisy',
    swedish: 'hög, högljudd, ljudlig',
    norwegian: 'bråkete, høylytt',
    finnish: 'kovaääninen, meluisa, äänekäs',
    hungarian: 'hangos, zajos',
    german: 'laut, geräuschvoll',
    dutch: 'luid, hard (geluid)',
    afrikaans: 'hard, luid (geluid)',
    russian: 'громкий',
    latvian: 'skaļš, trokšņains',
    polish: 'głośny, hałaśliwy',
    french: 'bruyant, sonore',
    spanish: 'fuerte, alto',
  },
  {
    av: 15398,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(love + description before the fact indicator)',
    english: 'lovable',
    swedish: 'förtjusande, älskvärd',
    norwegian: 'elskelig, elskverdig',
    finnish: 'rakastettava',
    hungarian: 'szeretetreméltó, szerethető, rokonszenves',
    german: 'liebenswürdig',
    dutch: 'beminnelijk',
    afrikaans: 'beminlik',
    russian: 'приятный, привлекательный',
    latvian: 'jauks, mīļš, patīkams',
    polish: 'kochany, uroczy, miły, sympatyczny',
    french: 'adorable',
    spanish: 'adorable',
  },
  {
    av: 15400,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(love + action indicator)',
    english: 'love-(to)',
    swedish: 'älska',
    norwegian: 'elske',
    finnish: 'rakastaa',
    hungarian: 'szeretni, szerelmesnek lenni',
    german: 'lieben',
    dutch: 'liefhebben, houden van',
    afrikaans: 'lief te hê (om te)',
    russian: 'любить',
    latvian: 'mīlēt',
    polish: 'kochać',
    french: "aimer (d'amour)",
    spanish: 'amar, querer',
  },
  {
    av: 15401,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(lowness, shortness (height) + description indicator: the space between the reference lines is relatively low) See also: high, tall 14711 and short 16962.',
    english: 'low, short',
    swedish: 'låg',
    norwegian: 'lav',
    finnish: 'matala',
    hungarian: 'alacsony, rövid',
    german: 'niedrig, kurz',
    dutch: 'laag',
    afrikaans: 'laag, kort',
    russian: 'низкий',
    latvian: 'zems',
    polish: 'niski, nisko',
    french: 'bas',
    spanish: 'bajo, corto',
  },
  {
    av: 15402,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(feeling + addition: having a 'big plus' or advantage)",
    english: 'luck, fortune',
    swedish: 'tur',
    norwegian: 'flaks, hell',
    finnish: 'onni',
    hungarian: 'szerencse, jószerencse',
    german: 'Glück',
    dutch: 'geluk, meevaller',
    afrikaans: 'geluk, meevaller',
    russian: 'удача',
    latvian: 'laime, laimes gadījums, veiksme',
    polish: 'szczęście, fortuna',
    french: 'chance',
    spanish: 'suerte',
  },
  {
    av: 15403,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      "(luck + description after the fact indicator: feeling one has a 'big plus' or advantage)",
    english: 'lucky, fortunate',
    swedish: 'lyckosam, tursam',
    norwegian: 'heldig',
    finnish: 'onnekas',
    hungarian: 'szerencsés',
    german: 'glücklich, glücklicherweise, günstig',
    dutch: 'gelukkig',
    afrikaans: 'gelukkig',
    russian: 'удачливый',
    latvian: 'laimēties, veikties',
    polish: 'szczęśliwy, przynoszący szczęście',
    french: 'chanceux',
    spanish: 'afortunado',
  },
  {
    av: 15404,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(3 + branch + Sukkot)',
    english: 'lulav',
    swedish: 'lulav (Israel)',
    norwegian: 'lulav (Israel)',
    finnish: 'lulav-oksakimppu',
    hungarian: 'lulav (héber)',
    german: 'lulav',
    dutch: 'lulav (Joods)',
    afrikaans: 'lulav',
    russian: 'лулав(Израиль)',
    latvian: 'lulav (Izraēla)',
    polish: 'Lulaw – gałąź palmy daktylowej (hebr)',
    french: 'loulav, 3 branches de dattier (judaïsme)',
    spanish: 'lulav',
  },
  {
    av: 15405,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meal + 2: second meal of the day)',
    english: 'lunch, dinner',
    swedish: 'lunch',
    norwegian: 'lunsj',
    finnish: 'lounas',
    hungarian: 'ebéd',
    german: 'Mittagessen, Lunch',
    dutch: 'lunch, middagmaal',
    afrikaans: 'middagete',
    russian: 'обед',
    latvian: 'pusdienas, lenčs',
    polish: 'obiad, lunch (popołudniowy posiłek)',
    french: 'lunch, repas de midi',
    spanish: 'almuerzo, cena',
  },
  {
    av: 15407,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + often: book that is published at frequent intervals)',
    english: 'magazine, journal',
    swedish: 'tidning, tidskrift',
    norwegian: 'ukeblad, magasin, tidsskrift',
    finnish: 'aikakausilehti',
    hungarian: 'magazin, folyóirat',
    german: 'Zeitschrift, Magazin, Illustrierte, Journal',
    dutch: 'tijdschrift',
    afrikaans: 'tydskrif',
    russian: 'журнал, газета',
    latvian: 'žurnāls',
    polish: 'czasopismo, gazeta, periodyk',
    french: 'magazine, revue, périodique',
    spanish: 'revista, publicación',
  },
  {
    av: 15408,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(mail + action indicator)',
    english: 'mail, post-(to)',
    swedish: 'posta',
    norwegian: 'poste, maile',
    finnish: 'postittaa',
    hungarian: 'postázni, feladni, postán küldeni',
    german: 'senden, abschicken, verschicken, versenden',
    dutch: 'posten',
    afrikaans: 'pos (om te)',
    russian: 'посылать по почте',
    latvian: 'sūtīt pa pastu',
    polish: 'korespondować, pisać list',
    french: 'poster, envoyer par la poste',
    spanish: 'mandar por correo',
  },
  {
    av: 15409,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + letter)',
    english: 'mailbox, letterbox, postbox',
    swedish: 'brevlåda, postlåda',
    norwegian: 'postkasse, mailboks',
    finnish: 'postilaatikko, kirjelaatikko',
    hungarian: 'levélszekrény, postaláda, levelesláda',
    german: 'Briefkasten',
    dutch: 'brievenbus',
    afrikaans: 'posbus',
    russian: 'почтовый ящик',
    latvian: 'pastkastīte',
    polish: 'skrzynka pocztowa',
    french: 'boîte aux lettres',
    spanish: 'buzón',
  },
  {
    av: 15410,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(making, production, fashioning + action indicator: imperfect version of creation, represents man-made)',
    english: 'make, manufacture, produce-(to)',
    swedish: 'göra, tillverka',
    norwegian: 'lage, produsere',
    finnish: 'valmistaa, tehdä, laittaa',
    hungarian: 'csinálni, készíteni, előállítani',
    german: 'machen, herstellen, anfertigen',
    dutch: 'maken, produceren',
    afrikaans: 'maak, produseer, vervaardig (om te)',
    russian: 'изготавливать, производить',
    latvian: 'izgatavot, taisīt, ražot',
    polish: 'robić, wytwarzać, produkować',
    french: 'faire, fabriquer',
    spanish: 'hacer, fabricar, producir',
  },
  {
    av: 15411,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      "(fantasy, phantasy, imagination, illusion + description indicator: to let one's mind soar into the sky, or up into the clouds)",
    english: 'make-believe, pretend, imaginary',
    swedish: 'overklig, på låtsas',
    norwegian: 'på lissom, på liksom',
    finnish: 'kuviteltu, epätodellinen',
    hungarian: 'képzelt, képzeletbeli, színlelt, tettetett',
    german: 'unwirklich, imaginär, vorgeben, sich stellen',
    dutch: 'verzonnen',
    afrikaans: 'denkbeeldige, voorgee',
    russian: 'нереальный, вымышленный',
    latvian: 'izlikšanās, izlikties, iedomāts',
    polish: 'udawany, wymyślony',
    french: 'imaginaire',
    spanish: 'hacer creer, pretender, imaginario',
  },
  {
    av: 15412,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to make)',
    english: 'maker, manufacturer, producer',
    swedish: 'producent, tillverkare',
    norwegian: 'fabrikant, produsent',
    finnish: 'valmistaja, tuottaja',
    hungarian: 'gyártó, készítő, kézműves, előállító',
    german: 'Hersteller, Herstellerin',
    dutch: 'producent, fabrikant',
    afrikaans: 'produsent, vervaardiger',
    russian: 'изготовитель, производитель',
    latvian: 'izgatavotājs, ražotājs',
    polish: 'producent, rzemieślnik (osoba wytwarzająca coś)',
    french: 'fabricant, producteur',
    spanish: 'fabricante, productor',
  },
  {
    av: 15413,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(colour + plus + face: colour added to the face)',
    english: 'makeup',
    swedish: 'smink',
    norwegian: 'sminke, make-up',
    finnish: 'meikki, ehostus',
    hungarian: 'smink, kikészítés, makeup',
    german: 'Makeup, Schminke',
    dutch: 'make-up, schmink',
    afrikaans: 'grimering',
    russian: 'косметика',
    latvian: 'kosmētika',
    polish: 'makijaż',
    french: 'maquillage, fard pour le visage',
    spanish: 'maquillaje',
  },
  {
    av: 15414,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(man + description indicator)',
    english: 'male, masculine (person)',
    swedish: 'manlig, maskulin',
    norwegian: 'mannlig, maskulin',
    finnish: 'miespuolinen, maskuliininen',
    hungarian: 'férfias, maszkulin',
    german: 'männlich',
    dutch: 'mannelijk',
    afrikaans: 'manlike (persoon)',
    russian: 'мужской',
    latvian: 'vīriešu kārtas, vīrišķīgs',
    polish: 'męski (przymiotnik)',
    french: 'masculin',
    spanish: 'hombre (persona)',
  },
  {
    av: 15418,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to plan + work: person who organizes the work)',
    english: 'manager, secretary',
    swedish: 'chef, direktör, föreståndare',
    norwegian: 'sjef, direktør, arbeidsleder',
    finnish: 'johtaja, manageri',
    hungarian: 'menedzser, titkár',
    german: 'Manager, Managerin, Geschäftsführer, Geschäftsführerin',
    dutch: 'manager',
    afrikaans: 'bestuurder, sekretaris',
    russian: 'исполнительный директор',
    latvian: 'vadītajs, ministrs',
    polish: 'menadżer, sekretarka (osoba planująca pracę)',
    french: 'chef, directeur, patron',
    spanish: 'gerente, secretario(a)',
  },
  {
    av: 15420,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(making, production, fashioning + description indicator)',
    english: 'man-made, produced',
    swedish: 'tillverkad',
    norwegian: 'laget, framstilt, tilvirket',
    finnish: 'valmistettu',
    hungarian: 'mesterséges, mű-',
    german: 'künstlich (hergestellt)',
    dutch: 'zelfgemaakt',
    afrikaans: 'mensgemaakte',
    russian: 'изготовленный',
    latvian: 'cilvēka radīts',
    polish: 'produktywny, produkujący, robiący coś',
    french: 'fait main, artisanal',
    spanish: 'artificial',
  },
  {
    av: 15421,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + earth: graphic representation of the earth)',
    english: 'map',
    swedish: 'karta',
    norwegian: 'kart',
    finnish: 'kartta',
    hungarian: 'térkép',
    german: 'Landkarte',
    dutch: 'landkaart, plattegrond, kaart (aardrijkskundig)',
    afrikaans: 'kaart land',
    russian: 'карта',
    latvian: 'karte',
    polish: 'mapa',
    french: 'carte géographique, carte topographique',
    spanish: 'mapa',
  },
  {
    av: 15423,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 3: third month of the year)',
    english: 'March',
    swedish: 'mars',
    norwegian: 'mars',
    finnish: 'maaliskuu',
    hungarian: 'március',
    german: 'März',
    dutch: 'maart',
    afrikaans: 'Maart',
    russian: 'март',
    latvian: 'marts',
    polish: 'marzec',
    french: 'mars',
    spanish: 'Marzo',
  },
  {
    av: 15424,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spread + oil)',
    english: 'margarine',
    swedish: 'margarin',
    norwegian: 'margarin',
    finnish: 'margariini',
    hungarian: 'margarin',
    german: 'Margarine',
    dutch: 'margarine',
    afrikaans: 'margarien',
    russian: 'маргарин',
    latvian: 'margarīns',
    polish: 'margaryna (utwardzony tłuszcz)',
    french: 'margarine',
    spanish: 'margarina',
  },
  {
    av: 15426,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(marriage + action indicator)',
    english: 'marry-(to)',
    swedish: 'gifta sig',
    norwegian: 'gifte seg',
    finnish: 'mennä naimisiin, avioitua',
    hungarian: 'házasodni, össze/meg-, egybekelni, hozzámenni',
    german: 'heiraten',
    dutch: 'trouwen, huwen',
    afrikaans: 'trou (om te)',
    russian: 'бракосочетаться, пожениться',
    latvian: 'apprecēties, iziet pie vīra, apņemt sievu',
    polish: 'poślubić',
    french: 'marier-(se), épouser',
    spanish: 'casarse',
  },
  {
    av: 15427,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(mash, mush, pulp (food) + action indicator: to crush food)',
    english: 'mash, crush, squeeze, squash (food)-(to)',
    swedish: 'mosa',
    norwegian: 'mose',
    finnish: 'soseuttaa, puristaa',
    hungarian: 'pépesíteni, szétmorzsolni, szétnyomkodni (ételt)',
    german: 'zerstampfen, stampfen, zerquetschen',
    dutch: 'fijnstampen, malen, pureren',
    afrikaans: 'pulp, maal, stamp (om te)',
    russian: 'раздавливать, разминать',
    latvian: 'samīcīt, saspiest',
    polish: 'ściskać, miażdżyć, kruszyć, rozdrabniać (np. jedzenie)',
    french: 'écraser, broyer',
    spanish: 'hacer puré, aplastar',
  },
  {
    av: 15428,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(face + fantasy, phantasy, imagination, illusion)',
    english: 'mask, false face',
    swedish: 'ansiktsmask',
    norwegian: 'ansiktsmaske',
    finnish: 'naamio, naamari',
    hungarian: 'álarc, maszk',
    german: 'Maske',
    dutch: 'masker',
    afrikaans: 'masker',
    russian: 'маска',
    latvian: 'maska, karnevāla maska',
    polish: 'maska (sztuczna twarz, przebranie)',
    french: 'masque',
    spanish: 'máscara',
  },
  {
    av: 15429,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(genitals + to touch + pleasure)',
    english: 'masturbation',
    swedish: 'onani',
    norwegian: 'masturbasjon, onani',
    finnish: 'masturbointi, itsetyydytys',
    hungarian: 'maszturbáció, maszturbálás',
    german: 'Masturbation, Onanie, Selbstbefriedigung',
    dutch: 'masturbatie',
    afrikaans: 'masturbasie',
    russian: 'мастурбация',
    latvian: 'masturbācija',
    polish: 'masturbacja',
    french: 'masturbation',
    spanish: 'masturbación',
  },
  {
    av: 15430,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + fire + thing indicator)',
    english: 'match',
    swedish: 'tändsticka',
    norwegian: 'fyrstikk, lunte',
    finnish: 'tulitikku',
    hungarian: 'gyufa',
    german: 'Zündholz, Streichholz',
    dutch: 'lucifer',
    afrikaans: 'vuurhoutjie',
    russian: 'спичка',
    latvian: 'sērkociņš',
    polish: 'zapałka',
    french: 'allumette',
    spanish: 'partido',
  },
  {
    av: 15433,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to advance + adult: advancing toward adulthood)',
    english: 'maturation',
    swedish: 'mognad',
    norwegian: 'modning',
    finnish: 'kypsyminen',
    hungarian: 'érés, megérés',
    german: 'Reifung',
    dutch: 'groei (persoon)',
    afrikaans: 'groei (persoon)',
    russian: 'зрелость, созревание',
    latvian: 'briedums, nobriešana',
    polish: 'dojrzewanie',
    french: 'maturation',
    spanish: 'maduración',
  },
  {
    av: 15434,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bread + low: unleavened bread eaten on Passover)',
    english: 'matzo',
    swedish: 'knäckebröd, tunnbröd (etc)',
    norwegian: 'knekkebrød (o.l.)',
    finnish: 'matsa-leipä',
    hungarian: 'pászka, macesz',
    german: 'Matze, ungesäuertes Brot',
    dutch: 'ongedesemd brood, matze',
    afrikaans: 'matse (ongesuurde brood)',
    russian: 'лаваш, маца, хлебец',
    latvian: 'maca',
    polish: 'maca',
    french: 'pain azyme',
    spanish: 'matzá',
  },
  {
    av: 15435,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 5: fifth month of the year)',
    english: 'May',
    swedish: 'maj',
    norwegian: 'mai',
    finnish: 'toukokuu',
    hungarian: 'május',
    german: 'Mai',
    dutch: 'mei',
    afrikaans: 'Mei',
    russian: 'май',
    latvian: 'maijs',
    polish: 'maj',
    french: 'mai',
    spanish: 'mayo',
  },
  {
    av: 15436,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(being (state of) + what, question mark: expression that indicates doubt or uncertainty)',
    english: 'possibility',
    swedish: 'möjlighet',
    norwegian: 'mulighet',
    finnish: 'mahdollisuus',
    hungarian: 'lehetőség',
    german: 'Möglichkeit',
    dutch: 'mogelijkheid',
    afrikaans: 'moontlikheid',
    russian: 'возможность',
    latvian: 'varbūt, iespējams',
    polish: 'możliwość',
    french: 'possibilité',
    spanish: 'posibilidad',
  },
  {
    av: 15437,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(congratulations + action indicator)',
    english: 'congratulate-(to)',
    swedish: 'gratulera, lyckönska',
    norwegian: 'gratulere, lykkønske',
    finnish: 'onnitella',
    hungarian: 'gratulálni',
    german: 'gratulieren, beglückwünschen',
    dutch: 'gelukwensen, feliciteren',
    afrikaans: 'geluk wens (om te)',
    russian: 'поздравлять',
    latvian: 'apsveikt',
    polish: 'gratulować',
    french: 'féliciter',
    spanish: 'felicitar',
  },
  {
    av: 15438,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + food: group of foods served and eaten in a single sitting)',
    english: 'meal',
    swedish: 'måltid',
    norwegian: 'måltid',
    finnish: 'ateria',
    hungarian: 'étkezés',
    german: 'Mahlzeit, Essen, Mahl',
    dutch: 'maaltijd',
    afrikaans: 'maaltyd',
    russian: 'еда, приём пищи',
    latvian: 'ēdiens',
    polish: 'posiłek',
    french: 'repas',
    spanish: 'comida',
  },
  {
    av: 15439,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(feeling + sharp + description indicator: sharp or “cutting” in one’s manner)',
    english: 'mean, cruel',
    swedish: 'elak, ond',
    norwegian: 'ond, grusom',
    finnish: 'ilkeä, häijy, julma',
    hungarian: 'gonosz, kegyetlen, komisz',
    german: 'gemein, grausam, böse',
    dutch: 'gemeen, vals, wreed',
    afrikaans: 'gemeen, wreed, vals',
    russian: 'злой',
    latvian: 'negodīgs, ļauns',
    polish: 'podły, okrutny',
    french: 'méchant, cruel',
    spanish: 'miserable, cruel',
  },
  {
    av: 15440,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(meaning + action indicator)',
    english: 'mean, signify-(to)',
    swedish: 'betyda',
    norwegian: 'mene, bety',
    finnish: 'tarkoittaa, merkitä',
    hungarian: 'jelent, jelez, kifejez',
    german: 'bedeuten',
    dutch: 'betekenen',
    afrikaans: 'aandui, beteken (om te)',
    russian: 'значить',
    latvian: 'domāts, nozīmēt',
    polish: 'znaczyć, oznaczać',
    french: 'signifier',
    spanish: 'significar, querer decir',
  },
  {
    av: 15442,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(measurement + action indicator)',
    english: 'measure-(to)',
    swedish: 'mäta',
    norwegian: 'måle',
    finnish: 'mitata, arvioida',
    hungarian: 'mérni, megmérni',
    german: 'messen, abmessen',
    dutch: 'meten',
    afrikaans: 'meet (om te)',
    russian: 'измерять',
    latvian: 'mērīt',
    polish: 'mierzyć, odmierzać',
    french: 'mesurer',
    spanish: 'medir',
  },
  {
    av: 15444,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + animal: food that comes from an animal)',
    english: 'meat',
    swedish: 'kött',
    norwegian: 'kjøtt',
    finnish: 'liharuoka, liha',
    hungarian: 'hús',
    german: 'Fleisch',
    dutch: 'vlees',
    afrikaans: 'vleis',
    russian: 'мясо',
    latvian: 'gaļa',
    polish: 'mięso',
    french: 'viande',
    spanish: 'carne',
  },
  {
    av: 15445,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + ball: meat shaped into a ball)',
    english: 'meatball',
    swedish: 'köttbulle',
    norwegian: 'kjøttbolle',
    finnish: 'lihapyörykkä',
    hungarian: 'húsgombóc',
    german: 'Frikadelle, Fleischklößchen',
    dutch: 'gehaktbal',
    afrikaans: 'frikkadel',
    russian: 'тефтель, биточек',
    latvian: 'gaļas bumbiņa',
    polish: 'klops, klopsik (kulka z mięsa)',
    french: 'boulette de viande',
    spanish: 'albóndiga',
  },
  {
    av: 15446,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(medicine, medical practice + description indicator)',
    english: 'medical, medically',
    swedish: 'medicinsk, sjuk-',
    norwegian: 'medisinsk',
    finnish: 'lääketieteellinen',
    hungarian: 'egészségügyi, orvosi, gyógyászati',
    german: 'medizinisch, ärztlich',
    dutch: 'medisch',
    afrikaans: 'mediese',
    russian: 'медицинский',
    latvian: 'medicīnisks, medicīniski',
    polish: 'medyczny, lekarski',
    french: 'médical',
    spanish: 'médico, de medicina',
  },
  {
    av: 15447,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(insurance + medical: protection against unpredictable future medical expense)',
    english: 'medical insurance',
    swedish: 'sjukförsäkring',
    norwegian: 'sykeforsikring',
    finnish: 'sairausvakuutus',
    hungarian: 'egészségügyi biztosítás, egészségbiztosítás',
    german: 'Krankenversicherung',
    dutch: 'ziektekostenverzekering',
    afrikaans: 'siekefonds',
    russian: 'медицинское страхование',
    latvian: 'veselības apdrošināšanas polise',
    polish: 'ubezpieczenie zdrowotne, medyczne',
    french: 'assurance médicale',
    spanish: 'seguro médico',
  },
  {
    av: 15448,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical product + medical)',
    english: 'medicine, medication',
    swedish: 'medicin',
    norwegian: 'medisin',
    finnish: 'lääke',
    hungarian: 'gyógyszer, orvosság',
    german: 'Medizin, Arznei, Medikament, Arzneimittel',
    dutch: 'medicijn, geneesmiddel',
    afrikaans: 'medisyne, geneesmiddel',
    russian: 'лекарство',
    latvian: 'zāles, medikamenti',
    polish: 'lek, lekarstwo',
    french: 'médicament',
    spanish: 'medicina',
  },
  {
    av: 15449,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(meeting, encounter + action indicator)',
    english: 'meet, encounter, see-(to)',
    swedish: 'möta, träffa',
    norwegian: 'treffe, møte',
    finnish: 'tavata, kohdata',
    hungarian: 'találkozni, összetalálkozni',
    german: 'zusammentreffen, treffen, begegnen, sich treffen, sich begegnen',
    dutch: 'ontmoeten',
    afrikaans: 'ontmoet (om te)',
    russian: 'встречать(ся)',
    latvian: 'satikt, satikties, saredzēties',
    polish: 'spotkać się, zobaczyć się z kimś',
    french: 'rencontrer',
    spanish: 'encontrar, encontrarse',
  },
  {
    av: 15450,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gathering + discussion)',
    english: 'meeting, assembly, conference',
    swedish: 'konferens, sammanträde',
    norwegian: 'konferanse, debattmøte',
    finnish: 'kokous, konferenssi',
    hungarian: 'találkozó, értekezlet, megbeszélés, konferencia',
    german: 'Versammlung, Konferenz',
    dutch: 'vergadering, conferentie, overleg',
    afrikaans: 'vergadering, konferensie, byeenkoms',
    russian: 'конференция, собрание',
    latvian: 'sapulce, sanāksme, asambleja, konference',
    polish: 'zgromadzenie, konferencja (spotkanie+ mowa+wymiana)',
    french: 'réunion, rencontre, meeting, forum',
    spanish: 'reunión, conferencia',
  },
  {
    av: 15453,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(end + menstruation)',
    english: 'menopause',
    swedish: 'klimakteriet',
    norwegian: 'klimakteriet, menstruasjonsopphør',
    finnish: 'vaihdevuodet',
    hungarian: 'menopauza, klimax, klimaktérium',
    german: 'Menopause, Wechseljahre',
    dutch: 'menopauze',
    afrikaans: 'menopouse',
    russian: 'менопауза',
    latvian: 'menopauze',
    polish: 'menopauza',
    french: 'ménopause',
    spanish: 'menopausia',
  },
  {
    av: 15455,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + uterus + month)',
    english: 'menstruation, menstrual period, period',
    swedish: 'mens, menstruation',
    norwegian: 'menstruasjon',
    finnish: 'kuukautiset',
    hungarian: 'menstruáció, havivérzés, havi ciklus, női ciklus',
    german: 'Menstruation, Periode, Regel',
    dutch: 'maandstonden, menstruatie',
    afrikaans: 'maandstonde, menstruasie',
    russian: 'менструация',
    latvian: 'mēnešreizes, menstruācija',
    polish: 'menstruacja, okres, miesiączka',
    french: 'menstruation',
    spanish: 'menstruación, período menstrual',
  },
  {
    av: 15456,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(mind + description indicator)',
    english: 'mental, intellectual, rational, thinking',
    swedish: 'intellektuell, tänkande, mental',
    norwegian: 'intellektuell, tenkende, mental',
    finnish: 'henkinen, älyllinen',
    hungarian: 'értelmi, szellemi, intellektuális, észbeli',
    german: 'geistig, seelisch, intellektuell, rational',
    dutch: 'verstandelijk',
    afrikaans: 'verstandelik, intellektuele, rasionele, denke',
    russian: 'умственный, мыслительный',
    latvian: 'garīgs, intelektuāls, racionāls, domājošs',
    polish: 'umysłowy, intelektualny, psychiczny',
    french: 'mental, intellectuel, rationnel',
    spanish: 'mental, intelectual, racional',
  },
  {
    av: 15458,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(to circle + happy + thing indicator: thing to enjoy by going around and around)',
    english: 'merry-go-round, carousel',
    swedish: 'karusell',
    norwegian: 'karusell',
    finnish: 'karuselli',
    hungarian: 'körhinta, ringlispíl',
    german: 'Karussell',
    dutch: 'draaimolen',
    afrikaans: 'mallemeule',
    russian: 'карусель',
    latvian: 'karuselis',
    polish: 'karuzela',
    french: 'manège',
    spanish: 'tiovivo, carrusel, calesita',
  },
  {
    av: 15459,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + metal bar)',
    english: 'metal',
    swedish: 'metall',
    norwegian: 'metall',
    finnish: 'metalli',
    hungarian: 'fém, fémből való',
    german: 'Metall',
    dutch: 'metaal',
    afrikaans: 'metaal',
    russian: 'металл',
    latvian: 'metāls',
    polish: 'metal (dowolny)',
    french: 'métal',
    spanish: 'metal',
  },
  {
    av: 15461,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + Torah + door)',
    english: 'mezuzah',
    swedish: 'mezuzah (Israel)',
    norwegian: 'mezuzah (Israel)',
    finnish: 'mezuza',
    hungarian: 'mezuza (héber)',
    german: 'mezuzah',
    dutch: 'mezuzah (Joods)',
    afrikaans: 'mezuzah',
    russian: 'мезуза (Израиль)',
    latvian: 'mezuza (Izraēla)',
    polish: 'mezuza (hebr)',
    french: 'mezouzah',
    spanish: 'mezuzá',
  },
  {
    av: 15462,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(microwave oven + action indicator)',
    english: 'microwave-(to)',
    swedish: 'använda mikrovågsugn, mikra',
    norwegian: 'bruke mikrobølgeovn, mikre',
    finnish: 'käyttää mikroaaltouunia, valmistaa ruokaa mikroaaltouunisssa',
    hungarian: 'mikrohullámú sütőben sütni, mikrózni',
    german: 'in der Mikrowelle zubereiten',
    dutch: 'koken (microgolfoven (Vl)), koken (magnetron (Nl))',
    afrikaans: 'mikrogolf (om te)',
    russian: 'передавать микроволны',
    latvian: 'mikroviļņu pārraide',
    polish: 'gotować w mikrofalówce',
    french: 'cuire au four micro-ondes',
    spanish: 'cocinar con microondas',
  },
  {
    av: 15465,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + most + sun)',
    english: 'midsummer',
    swedish: 'midsommar',
    norwegian: 'midtsommer',
    finnish: 'juhannus',
    hungarian: 'nyárközép, nyár közepe',
    german: 'Mittsommer',
    dutch: 'midzomer',
    afrikaans: 'midsomer',
    russian: 'день солнцестояния',
    latvian: 'vasaras saulgrieži',
    polish: 'Noc Świętojańska, przesilenie letnie, Noc Kupały',
    french: "milieu de l'été, plein été",
    spanish: 'pleno verano',
  },
  {
    av: 15466,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(airplane + war)',
    english: 'military plane',
    swedish: 'militärplan',
    norwegian: 'militærfly',
    finnish: 'sotilaslentokone',
    hungarian: 'katonai / hadi repülőgép',
    german: 'Militärflugzeug',
    dutch: 'militair vliegtuig, legervliegtuig',
    afrikaans: 'militêre vliegtuig',
    russian: 'военный самолет',
    latvian: 'miltāra lidmašīna',
    polish: 'samolot wojskowy',
    french: 'avion militaire',
    spanish: 'avión militar',
  },
  {
    av: 15467,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limited time + soldier: service as a soldier for a limited time only)',
    english: 'military reserve duty',
    swedish: 'militärtjänst',
    norwegian: 'militærtjeneste',
    finnish: 'asepalvelu',
    hungarian: 'tartalékos katonai szolgálat',
    german: 'Wehrpflicht',
    dutch: 'dienstplicht',
    afrikaans: 'diensplig',
    russian: 'воинская служба',
    latvian: 'militārais rezerves dienests',
    polish: 'rezerwa (wojskowa), żołnierze rezerwy wojskowej',
    french: 'militaire de réserve',
    spanish: 'guardia de reserva militar',
  },
  {
    av: 15468,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drink + life: drink that sustains life)',
    english: 'milk',
    swedish: 'mjölk',
    norwegian: 'melk',
    finnish: 'maito',
    hungarian: 'tej',
    german: 'Milch',
    dutch: 'melk',
    afrikaans: 'melk',
    russian: 'молоко',
    latvian: 'piens',
    polish: 'mleko',
    french: 'lait',
    spanish: 'leche',
  },
  {
    av: 15469,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + milk)',
    english: 'milkman',
    swedish: 'mjölkbud',
    norwegian: 'melkekjører',
    finnish: 'maitomies',
    hungarian: 'tejesember',
    german: 'Milchmann',
    dutch: 'melkboer',
    afrikaans: 'melkman',
    russian: 'молочник',
    latvian: 'piena pārdevējs',
    polish: 'mleczarz',
    french: 'laitier',
    spanish: 'lechero',
  },
  {
    av: 15473,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to teach + God: person who gives us knowledge about God)',
    english: 'minister, pastor, preacher, priest, rabbi',
    swedish: 'präst, pastor',
    norwegian: 'prest, pastor',
    finnish: 'pappi',
    hungarian: 'lelkész, lelkipásztor, pap, prédikátor, rabbi',
    german: 'Pfarrer, Pfarrerin, Priester, Priesterin',
    dutch: 'rabbijn, pastoor, priester, dominee',
    afrikaans: 'pastoor, dominee, priester, rabbi',
    russian: 'священник, проповедник',
    latvian: 'priesteris, mācītājs, garīdznieks, rabīns',
    polish: 'ksiądz, pastor, kaznodzieja, kapłan',
    french: 'ministre du culte, pasteur, prêtre, rabin, imam',
    spanish: 'pastor, predicador, sacerdote, rabino',
  },
  {
    av: 15475,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(time + apostrophe, used in astronomy to indicate a minute)',
    english: 'minute',
    swedish: 'minut',
    norwegian: 'minutt',
    finnish: 'minuutti',
    hungarian: 'perc',
    german: 'Minute',
    dutch: 'minuut',
    afrikaans: 'minuut',
    russian: 'минута',
    latvian: 'minūte',
    polish: 'minuta',
    french: 'minute',
    spanish: 'minuto',
  },
  {
    av: 15477,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(miscarriage, abortion (general) + woman: cancelled human pregnancy due to the natural death of an embryo)',
    english: 'miscarriage, abortion (spontaneous)',
    swedish: 'missfall',
    norwegian: 'spontanabort',
    finnish: 'keskenmeno, abortti',
    hungarian: 'művi vetélés, művi abortusz',
    german: 'Fehlgeburt',
    dutch: 'miskraam',
    afrikaans: 'miskraam',
    russian: 'выкидыш',
    latvian: 'spontānais aborts',
    polish: 'poronienie',
    french: 'fausse-couche',
    spanish: 'aborto involuntario',
  },
  {
    av: 15478,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(loss + action indicator)',
    english: 'miss, lose-(to)',
    swedish: 'sakna',
    norwegian: 'savne',
    finnish: 'kaivata, tuntea puutetta',
    hungarian: 'hiányolni, hiányozni, elveszíteni',
    german: 'vermissen',
    dutch: 'missen (iemand)',
    afrikaans: 'mis, verloor (persoon) (om te)',
    russian: 'скучать',
    latvian: 'trūkt, skumt pēc kaut kā, kāda',
    polish: 'utracić, odczuwać brak (czegoś lub kogoś)',
    french: "manquer (ressentir l'absence)",
    spanish: 'echar de menos',
  },
  {
    av: 15479,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + incorrect)',
    english: 'mistake, error, fault',
    swedish: 'fel, misstag',
    norwegian: 'feil, feiltakelse',
    finnish: 'erehdys',
    hungarian: 'hiba, tévedés, botlás',
    german: 'Fehler',
    dutch: 'fout',
    afrikaans: 'fout',
    russian: 'ошибка',
    latvian: 'kļūda',
    polish: 'błąd, pomyłka',
    french: 'erreur, faute, méprise',
    spanish: 'error',
  },
  {
    av: 15480,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spider + little: tiny spider-like insect)',
    english: 'mite, tick',
    swedish: 'fästing, kvalster (etc)',
    norwegian: 'midd',
    finnish: 'punkki',
    hungarian: 'atka, kullancs',
    german: 'Zecke, Milbe',
    dutch: 'mijt (insect), teek',
    afrikaans: 'myt, bosluis (insek)',
    russian: 'клещ',
    latvian: 'atzīmīte, ķeksītis',
    polish: 'kleszcz, roztocze (mały, ssący robak)',
    french: 'mite, tique',
    spanish: 'ácaro, garrapata',
  },
  {
    av: 15481,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(mixture + action indicator)',
    english: 'mix, blend-(to)',
    swedish: 'blanda',
    norwegian: 'blande',
    finnish: 'sekoittaa, sekoittua',
    hungarian: 'keverni, keveredni, összekeverni, vegyülni',
    german: 'mischen, verrühren, mixen',
    dutch: 'mengen, mixen',
    afrikaans: 'meng (om te)',
    russian: 'смешивать',
    latvian: 'jaukt, sajaukt, sablendēt',
    polish: 'mieszać',
    french: 'mélanger',
    spanish: 'mezclar',
  },
  {
    av: 15482,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + happiness: room for social gatherings) (Israel)',
    english: 'recreation room, moadan',
    swedish: 'sällskapsrum',
    norwegian: 'rekreasjonsrom',
    finnish: 'leikkihuone',
    hungarian: 'rekreációs helyiség',
    german: 'Gemeinschaftsraum, Freizeitraum',
    dutch: 'recreatieruimte',
    afrikaans: 'ontspannings vertrek ruimte',
    russian: 'комната отдыха',
    latvian: 'atpūtas, rekreācijas telpa',
    polish: 'pokój rekreacyjny',
    french: 'salle de récréation',
    spanish: 'salón recreativo',
  },
  {
    av: 15485,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + similar to + person: animal that resembles a person)',
    english: 'monkey, ape, gorilla, primate',
    swedish: 'apa, gorilla',
    norwegian: 'ape, gorilla, ',
    finnish: 'apina, gorilla',
    hungarian: 'majom, emberszabású majom, főemlős',
    german: 'Affe, Gorilla, Primat',
    dutch: 'aap, gorilla',
    afrikaans: 'aap, gorilla, bobbejaan',
    russian: 'обезьяна',
    latvian: 'pērtiķis, gorilla, primāts',
    polish: 'małpa człekokształtna, goryl',
    french: 'singe, primate',
    spanish: 'mono, gorila, primate',
  },
  {
    av: 15486,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(creature + strange + thing indicator: creature that is strange or unusual)',
    english: 'monster',
    swedish: 'monster, seriefigur (etc)',
    norwegian: 'monster, uhyre',
    finnish: 'hirviö, mörkö',
    hungarian: 'szörnyeteg',
    german: 'Monster, Ungeheuer',
    dutch: 'monster',
    afrikaans: 'monster',
    russian: 'чудовище, монстр',
    latvian: 'briesmonis',
    polish: 'monstrum, potwór',
    french: 'monstre',
    spanish: 'monstruo',
  },
  {
    av: 15487,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(command + luck)',
    english: 'congratulations, best of luck, mazel tov',
    swedish: 'grattis, gratulation',
    norwegian: 'gratulerer, til lykke',
    finnish: 'onnea, onneksi olkoon, onnittelut',
    hungarian: 'gratuláció, jókívánság',
    german: 'Glückwunsch',
    dutch: 'gefeliciteerd',
    afrikaans: 'gelukwensinge',
    russian: 'поздравление',
    latvian: 'apsveikums, vēlējums, laimes vēlējumi',
    polish: 'gratulacje, powodzenia, wszystkiego dobrego',
    french: 'félicitations',
    spanish: ' felicitaciones',
  },
  {
    av: 15650,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(state of mind + feeling: state of one’s mind and emotions)',
    english: 'mood',
    swedish: 'humör, sinnesstämning',
    norwegian: 'humør, sinnsstemning',
    finnish: 'mieliala, tunnelma',
    hungarian: 'hangulat, lelkiállapot, kedélyállapot',
    german: 'Stimmung, Laune',
    dutch: 'stemming',
    afrikaans: 'bui, stemming',
    russian: 'настроение',
    latvian: 'noskaņojums',
    polish: 'nastrój, humor',
    french: 'humeur, disposition',
    spanish: 'humor',
  },
  {
    av: 15652,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cervine + big)',
    english: 'moose, elk',
    swedish: 'älg',
    norwegian: 'elg',
    finnish: 'hirvi',
    hungarian: 'jávorszarvas',
    german: 'Elch',
    dutch: 'eland',
    afrikaans: 'eland',
    russian: 'лось',
    latvian: 'alnis',
    polish: 'łoś',
    french: 'élan, orignal',
    spanish: 'alce',
  },
  {
    av: 15653,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(good conscience + intensity + description indicator: can also be seen as a combination of conscience + positive) See also: correct, accurate, good, right 13416 and good, well, fine, ok, okay, all right 14463.',
    english: 'moral, good, right, morally right',
    swedish: 'rätt, moralisk',
    norwegian: 'moralsk, riktig, rett, korrekt',
    finnish: 'hyvä, moraalisesti oikein',
    hungarian: 'helyes, jó, erkölcsös, morális',
    german: 'richtig (moralisch), gut',
    dutch: 'goed (moreel), moreel',
    afrikaans: 'moreel',
    russian: 'честный, правдивый',
    latvian: 'tikumisks, morāls, labs, pareizs',
    polish: 'prawo, prawo moralne',
    french: 'moral',
    spanish: 'moral',
  },
  {
    av: 15654,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(comparative more + description indicator: much/many on a higher level)',
    english: 'more',
    swedish: 'mer, fler',
    norwegian: 'mer, fler',
    finnish: 'enemmän, useampia',
    hungarian: 'több',
    german: 'mehr',
    dutch: 'meer',
    afrikaans: 'meer',
    russian: 'больше, более',
    latvian: 'vairāk',
    polish: 'więcej',
    french: 'plus',
    spanish: 'más',
  },
  {
    av: 15655,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + before + 12: part of the day before noon)',
    english: 'morning (before noon)',
    swedish: 'förmiddag',
    norwegian: 'formiddag',
    finnish: 'aamupäivä',
    hungarian: 'délelőtt',
    german: 'Vormittag, Morgen',
    dutch: 'ochtend (voor twaalf uur), voormiddag (Vl)',
    afrikaans: 'oggend, môre, voormiddag',
    russian: 'до обеда',
    latvian: 'rīts, priekšpusdiena',
    polish: 'rano, przed południem',
    french: 'matinée',
    spanish: 'mañana (antes de mediodía)',
  },
  {
    av: 15657,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(death + description before the fact indicator: pertaining to beings who must eventually die)',
    english: 'mortal',
    swedish: 'dödlig',
    norwegian: 'dødelig',
    finnish: 'kuolevainen',
    hungarian: 'halálos, halandó',
    german: 'sterblich',
    dutch: 'dodelijk',
    afrikaans: 'sterflik',
    russian: 'смертный',
    latvian: 'mirstīgs',
    polish: 'śmiertelne',
    french: 'mortel',
    spanish: 'mortal',
  },
  {
    av: 15658,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(village + to work + together) (Israel)',
    english: 'moshav',
    swedish: 'Moshav (Israel)',
    norwegian: 'Moshav (Istrael)',
    finnish: 'moshav',
    hungarian: 'mosav (héber)',
    german: 'moshav',
    dutch: 'moshav (Joods)',
    afrikaans: 'moshav',
    russian: 'мошав (Израиль)',
    latvian: 'moiša (Izraēla)',
    polish: 'moszaw (hebr)',
    french: 'moshav',
    spanish: 'moshav',
  },
  {
    av: 15659,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(star + crescent moon + description indicator: the star and crescent are traditional symbols for Islam) ',
    english: 'Muslim, Moslem, Islamic',
    swedish: 'muslimsk',
    norwegian: 'muslimsk',
    finnish: 'muslimi, islamilainen',
    hungarian: 'mohamedán, muzulmán',
    german: 'muslimisch, islamisch',
    dutch: 'moslim',
    afrikaans: 'Moslem, Islamitiese',
    russian: 'мусульманский',
    latvian: 'musulmanis, musulmaņu, Islāma',
    polish: 'muzułmański, islamski',
    french: 'musulman (adj)',
    spanish: 'Musulmán',
  },
  {
    av: 15660,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(insect + to fly + to puncture: flying insect that punctures the skin)',
    english: 'mosquito, gadfly, horsefly, cleg',
    swedish: 'mygga',
    norwegian: 'mygg, moskito',
    finnish: 'itikka, hyttynen, sääski, moskiitto',
    hungarian: 'szúnyog',
    german: 'Mücke, Stechmücke, Moskito',
    dutch: 'mug',
    afrikaans: 'muskiet',
    russian: 'комар, москит',
    latvian: 'ods, moskīts',
    polish: 'komar',
    french: 'moustique',
    spanish: 'mosquito',
  },
  {
    av: 15661,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(superlative most + description indicator: much/many on the highest level)',
    english: 'most, maximum',
    swedish: 'mest, flest',
    norwegian: 'mest, flest',
    finnish: 'eniten, useimmat',
    hungarian: 'legtöbb, maximum',
    german: 'am meisten',
    dutch: 'meest',
    afrikaans: 'meeste, maksimum',
    russian: 'самый',
    latvian: 'vissvairāk, maksimums',
    polish: 'najbardziej, najmocniej, maksymalnie',
    french: 'le plus (adj.)',
    spanish: 'más, máximo',
  },
  {
    av: 15664,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(berry + mountain: berry that grows in uplands)',
    english: 'mountain berry, cowberry, lingonberry',
    swedish: 'lingon',
    norwegian: 'tyttebær, fjellbær',
    finnish: 'puolukka',
    hungarian: 'piros áfonya',
    german: 'Preiselbeere',
    dutch: 'vossebes',
    afrikaans: 'bosbessie',
    russian: 'брусника',
    latvian: 'brūklene',
    polish: 'brusznica, borówka (jagody górskie)',
    french: 'baie de montagne',
    spanish: 'baya de montaña',
  },
  {
    av: 15665,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rodent + little: rodent that is smaller than a rat)',
    english: 'mouse',
    swedish: 'mus',
    norwegian: 'mus',
    finnish: 'hiiri',
    hungarian: 'egér',
    german: 'Maus',
    dutch: 'muis',
    afrikaans: 'muis',
    russian: 'мышь',
    latvian: 'pele',
    polish: 'mysz (mały gryzoń)',
    french: 'souris',
    spanish: 'ratón',
  },
  {
    av: 15667,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(move, movement + action indicator: the wheel moves by rolling over the ground)',
    english: 'move-(to)',
    swedish: 'förflytta, flytta, köra',
    norwegian: 'kjøre, flytte, forflytte',
    finnish: 'liikkua, siirtyä, kulkea',
    hungarian: 'mozogni, mozgatni',
    german: 'fortbewegen, sich rücken, umziehen',
    dutch: 'bewegen, verplaatsen',
    afrikaans: 'beweeg, verplaas, skuif (om te)',
    russian: 'двигаться, передвигаться',
    latvian: 'virzīt, kustināt, stumt',
    polish: 'ruszać się, przemieszczać, jechać',
    french: 'bouger, circuler',
    spanish: 'mover, moverse',
  },
  {
    av: 15668,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(bowel movement + action indicator)',
    english: 'move bowels, defecate, stool, shit, ca-ca-(to)',
    swedish: 'baja, bajsa, ha avföring',
    norwegian: 'ha avføring, bæsje',
    finnish: 'ulostaa, kakata',
    hungarian: 'székelni, székletet üríteni, kakilni, kakálni',
    german: 'Stuhlgang',
    dutch: 'ontlasting maken, poepen (Nl), kaka doen (Vl)',
    afrikaans: 'onlasting, poep (om te)',
    russian: 'испражняться',
    latvian: 'atbrīvot taisno zarnu, izkārnīties, defekācija, kakāšana, kakāt',
    polish: 'kał, stolec, gówno',
    french: 'faire caca, aller à selles',
    spanish: 'mover los intestinos, defecar, hacer caca',
  },
  {
    av: 15669,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cylinder + projector)',
    english: 'movie, film',
    swedish: 'film',
    norwegian: 'film',
    finnish: 'elokuva, filmi',
    hungarian: 'mozifilm, film',
    german: 'Film, Spielfilm',
    dutch: 'film',
    afrikaans: 'film, fliek',
    russian: 'фильм',
    latvian: 'filma, kino',
    polish: 'film',
    french: 'film (bobine)',
    spanish: 'película',
  },
  {
    av: 15670,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + projector)',
    english: 'movie theatre, cinema',
    swedish: 'bio',
    norwegian: 'kino',
    finnish: 'elokuvateatteri',
    hungarian: 'filmszínház, mozi',
    german: 'Kino',
    dutch: 'bioscoop, cinema',
    afrikaans: 'bioskoop, cinema, filmteater, fliekteater',
    russian: 'кинотеатр',
    latvian: 'kinoteātris',
    polish: 'kino',
    french: 'salle de cinéma',
    spanish: 'cine',
  },
  {
    av: 15671,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(quantity + description indicator)',
    english: 'much, many, very',
    swedish: 'mycket, många',
    norwegian: 'mye, mange',
    finnish: 'paljon, monta, monet, useat',
    hungarian: 'sok, nagyon…',
    german: 'viel',
    dutch: 'veel, heel',
    afrikaans: 'baie, meer',
    russian: 'много',
    latvian: 'daudz',
    polish: 'dużo, wiele, bardzo',
    french: 'beaucoup',
    spanish: 'mucho',
  },
  {
    av: 15674,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(multiplication + action indicator)',
    english: 'multiply-(to)',
    swedish: 'multiplicera',
    norwegian: 'multiplisere, gange',
    finnish: 'suorittaa kertolasku, kertoa',
    hungarian: 'szorozni, megszorozni, megsokszorozni',
    german: 'multiplizieren, vermehren',
    dutch: 'vermenigvuldigen',
    afrikaans: 'vermenigvuldig, maal (om te)',
    russian: 'умножать',
    latvian: 'reizināt',
    polish: 'mnożyć, pomnażać, zwielokrotniać',
    french: 'multiplier',
    spanish: 'multiplicar',
  },
  {
    av: 15675,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(multiplication + thing indicator: large number of people or things. The symbol is the concrete form of multiplication.) - (character with thing indicator)',
    english: 'multitude',
    swedish: 'mängd',
    norwegian: 'mengde, masse',
    finnish: 'joukko, paljous',
    hungarian: 'sokaság, nagy mennyiség',
    german: 'Menge',
    dutch: 'groot aantal, massa',
    afrikaans: 'groot aantal, massa, menigte',
    russian: 'множество',
    latvian: 'daudzums, liels daudzums',
    polish: 'mnóstwo, bardzo wiele',
    french: 'multitude',
    spanish: 'multitud',
  },
  {
    av: 15677,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(building + thing + interesting + plural indicator: building where interesting things are displayed)',
    english: 'museum',
    swedish: 'museum',
    norwegian: 'museum',
    finnish: 'museo',
    hungarian: 'múzeum',
    german: 'Museum',
    dutch: 'museum',
    afrikaans: 'museum',
    russian: 'музей',
    latvian: 'muzejs',
    polish: 'muzeum',
    french: 'musée',
    spanish: 'museo',
  },
  {
    av: 15679,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ear + musical note)',
    english: 'music',
    swedish: 'musik',
    norwegian: 'musikk',
    finnish: 'musiikki',
    hungarian: 'zene',
    german: 'Musik',
    dutch: 'muziek',
    afrikaans: 'musiek',
    russian: 'музыка',
    latvian: 'mūzika',
    polish: 'muzyka',
    french: 'musique',
    spanish: 'música',
  },
  {
    av: 15680,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(group + musical note)',
    english: 'musical group',
    swedish: 'musikgrupp',
    norwegian: 'musikkgruppe',
    finnish: 'musiikkiryhmä',
    hungarian: 'együttes',
    german: 'Musikgruppe',
    dutch: 'muziekgroep, popgroep, band',
    afrikaans: 'musiek groep',
    russian: 'музыкальная группа',
    latvian: 'mūzikas grupa',
    polish: 'zespół muzyczny',
    french: 'groupe musical, groupe de musique, groupe de musiciens',
    spanish: 'grupo musical',
  },
  {
    av: 15681,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(instrument + musical note)',
    english: 'musical instrument',
    swedish: 'musikinstrument',
    norwegian: 'musikkinstrument',
    finnish: 'soitin',
    hungarian: 'hangszer',
    german: 'Musikinstrument',
    dutch: 'muziekinstrument',
    afrikaans: 'musiek instrument',
    russian: 'муз. инструмент',
    latvian: 'mūzikas instruments',
    polish: 'instrument muzyczny',
    french: 'instrument de musique',
    spanish: 'instrumento musical',
  },
  {
    av: 15683,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + musical note: person who makes music)',
    english: 'musician',
    swedish: 'musiker',
    norwegian: 'musiker',
    finnish: 'muusikko',
    hungarian: 'zenész, muzsikus',
    german: 'Musiker, Musikerin',
    dutch: 'musicus, zanger, muzikant',
    afrikaans: 'musikant',
    russian: 'музыкант',
    latvian: 'mūziķis',
    polish: 'muzyk',
    french: 'musicien',
    spanish: 'músico',
  },
  {
    av: 15684,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(combination of water animal and rodent: rodent at home in water)',
    english: 'muskrat',
    swedish: 'vattenråtta, bisamråtta',
    norwegian: 'bisamrotte',
    finnish: 'piisami',
    hungarian: 'cickány',
    german: 'Bisamratte',
    dutch: 'muskusrat',
    afrikaans: 'muskusrot',
    russian: 'ондатра',
    latvian: 'ondatra',
    polish: 'piżmak (wodny gryzoń)',
    french: 'rat musqué',
    spanish: 'rata almizclera',
  },
  {
    av: 15685,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(must (a) + action indicator) - Note, original derivation in BRG is: (to force + passive indicator: to be forced to do something)',
    english: 'must, have to, be forced to-(to)',
    swedish: 'måste',
    norwegian: 'måtte, bli tvunget',
    finnish: 'pakottaa',
    hungarian: 'rárőltetni, kelleni (valamit meg kell tenni)',
    german: 'müssen, gezwungen werden',
    dutch: 'moeten, verplichten',
    afrikaans: 'moet, hê verplig om (om te)',
    russian: 'должен',
    latvian: 'vajag, nepieciešams, obligāti',
    polish: 'zmuszać, być zmuszonym',
    french: 'devoir, être forcé',
    spanish: 'deber, tener que',
  },
  {
    av: 15686,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(I + belongs to: first person singular, possessive)',
    english: 'my, mine',
    swedish: 'min, mitt, mina',
    norwegian: 'min, mitt, mine',
    finnish: 'minun',
    hungarian: 'enyém',
    german: 'mein, mein, meine, mein',
    dutch: 'mijn (bez. vnw.)',
    afrikaans: 'my, myne',
    russian: 'мой, моя, моё, мои',
    latvian: 'mans, manējais, manējā',
    polish: 'mam, mój (bez rodzaju)',
    french: 'mon, ma, mes',
    spanish: 'mi, mío',
  },
  {
    av: 15687,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(female + 1 + belongs to: first person singular (f.), possessive)',
    english: 'my, mine-(feminine)',
    swedish: 'min, mitt, mina (fem.)',
    norwegian: 'min, mitt, mine (hunkjønn)',
    finnish: 'minun (nainen), minun (fem.)',
    hungarian: 'enyém (nő)',
    german: 'mein, meine (1. Person singular ist weiblich)',
    dutch: 'mijn (bez. vnw. vrouwelijk)',
    afrikaans: 'my, myne (vroulik)',
    russian: 'мой, моя, моё, мои (жен.)',
    latvian: 'mana, manējā',
    polish: 'mam, ja mam, moja (rodzaj żeński)',
    french: 'mon, ma, mes (fém.)',
    spanish: 'mi, mía (femenino)',
  },
  {
    av: 15688,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(male + 1 + belongs to: first person singular (m.), possessive)',
    english: 'my, mine-(masculine)',
    swedish: 'min, mitt, mina (mask.)',
    norwegian: 'min, mitt, mine (hankjønn)',
    finnish: 'minun (mies), minun (mask.)',
    hungarian: 'enyém (férfi)',
    german: 'mein, meine (1. Person singular ist männlich)',
    dutch: 'mijn (bez. vnw. mannelijk)',
    afrikaans: 'my, myne (manlik)',
    russian: 'мой, моя, моё, мои (муж.)',
    latvian: 'mans, manējais',
    polish: 'mam, ja mam, mój (rodzaj męski)',
    french: 'mon, ma, mes (masc.)',
    spanish: 'mi, mío (masculino)',
  },
  {
    av: 15690,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(colour + plus + finger: colour added to fingernails)',
    english: 'nail polish, nail varnish',
    swedish: 'nagellack',
    norwegian: 'neglelakk',
    finnish: 'kynsilakka',
    hungarian: 'körömlakk',
    german: 'Nagellack',
    dutch: 'nagellak',
    afrikaans: 'naellak, naelpolitoer',
    russian: 'лак для ногтей',
    latvian: 'nagu laka',
    polish: 'lakier do paznokci',
    french: 'vernis à ongle',
    spanish: 'pintura de uñas',
  },
  {
    av: 15692,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + to eat)',
    english: 'napkin, serviette',
    swedish: 'servett',
    norwegian: 'serviett',
    finnish: 'lautasliina',
    hungarian: 'szalvéta, asztalkendő',
    german: 'Serviette',
    dutch: 'servet',
    afrikaans: 'servet',
    russian: 'салфетка',
    latvian: 'salvete',
    polish: 'serwetka',
    french: 'serviette de table',
    spanish: 'servilleta',
  },
  {
    av: 15693,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(opposite meaning + wide + description indicator)',
    english: 'narrow',
    swedish: 'trång, smal',
    norwegian: 'trang, smal',
    finnish: 'kapea, ahdas',
    hungarian: 'keskeny, szűk',
    german: 'eng, schmal',
    dutch: 'smal',
    afrikaans: 'smal, nou',
    russian: 'узкий',
    latvian: 'šaurs',
    polish: 'wąski, chudy',
    french: 'étroit',
    spanish: 'estrecho',
  },
  {
    av: 15694,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(bad + comma + little + description indicator)',
    english: 'naughty',
    swedish: 'olydig',
    norwegian: 'ulydig, uskikkelig',
    finnish: 'tuhma, tottelematon, pahankurinen',
    hungarian: 'pajkos, rakoncátlan, rosszalkodó (jelkép szinon.)',
    german: 'ungezogen',
    dutch: 'ondeugend',
    afrikaans: 'stout',
    russian: 'непослушный',
    latvian: 'palaidnīgs',
    polish: 'niegrzeczny, nieposłuszny',
    french: 'méchant, vilain',
    spanish: 'travieso',
  },
  {
    av: 15695,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(feeling + incorrect + description indicator)',
    english: 'naughty, not nice',
    swedish: 'otrevlig',
    norwegian: 'utrivelig, uskikkelig',
    finnish: 'ilkeä, paha',
    hungarian: 'rossz, nem kedves, nem jó (jelkép szinoníma)',
    german: 'unartig, ungezogen, frech',
    dutch: 'stout',
    afrikaans: 'stout',
    russian: 'неприятный',
    latvian: 'nepaklausīgs, nejauks',
    polish: 'niedobrze, źle, niemiło',
    french: 'méchant, désobéissant',
    spanish: 'travieso, no bueno',
  },
  {
    av: 15696,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group + war + water: group trained for war at sea)',
    english: 'navy',
    swedish: 'marin, flotta (militär)',
    norwegian: 'marinen',
    finnish: 'merivoimat',
    hungarian: 'haditengerészet, hadiflotta',
    german: 'Marine',
    dutch: 'marine',
    afrikaans: 'vloot',
    russian: 'военно-морской флот',
    latvian: 'jūras kara flote',
    polish: 'marynarz (wojskowy) żołnierz marynarki',
    french: 'marine',
    spanish: 'marina de guerra',
  },
  {
    av: 15697,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(nearness, closeness, proximity + description indicator)',
    english: 'near, almost, close, nearly',
    swedish: 'nära, nästan',
    norwegian: 'nær, nesten',
    finnish: 'lähellä, melkein, lähes',
    hungarian: 'közel, közeli, csaknem, majdnem',
    german: 'beinahe, fast, dicht dran',
    dutch: 'bijna, dichtbij',
    afrikaans: 'naby, amper',
    russian: 'близко‚ возле‚ рядом',
    latvian: 'tuvu, netālu, tuvumā',
    polish: 'blisko, prawie',
    french: 'près, proche, à proximité',
    spanish: 'cerca de, casi',
  },
  {
    av: 15698,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(need + description indicator)',
    english: 'necessary, necessarily, needed',
    swedish: 'nödvändig',
    norwegian: 'nødvendig',
    finnish: 'tarpeellinen, välttämätön',
    hungarian: 'szükséges, szükségelt',
    german: 'nötig, notwendig',
    dutch: 'noodzakelijk, nodig',
    afrikaans: 'nodig, noodsaaklik, nodige',
    russian: 'необходимый',
    latvian: 'nepieciešams, nepieciešami',
    polish: 'konieczny, potrzebny',
    french: 'nécessaire',
    spanish: 'necesario, necesariamente',
  },
  {
    av: 15702,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(need + action indicator: the leaning person needs support)',
    english: 'need-(to)',
    swedish: 'behöva',
    norwegian: 'trenge, ha behov for',
    finnish: 'tarvita',
    hungarian: 'szükségelni, igényelni, szükséget látni',
    german: 'brauchen',
    dutch: 'nodig hebben',
    afrikaans: 'nodig hê, moet hê (om te)',
    russian: 'нуждаться',
    latvian: 'nepieciešams, vajag',
    polish: 'potrzebować',
    french: 'avoir besoin',
    spanish: 'necesitar',
  },
  {
    av: 15704,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(hypodermic needlepoint + thing indicator: or semantically more reasonable; syringe + pointer, to needlepoint) - (character with thing indicator)',
    english: 'hypodermic needle',
    swedish: 'injektionsnål',
    norwegian: 'sprøytespiss',
    finnish: 'injektioneula',
    hungarian: 'injekciós tű',
    german: 'Injektionsnadel',
    dutch: 'injectienaald',
    afrikaans: 'spuitnaald',
    russian: 'инъекционная игла',
    latvian: 'šļirce zemādas injekcijām',
    polish: 'igła od strzykawki',
    french: 'aiguille de seringue hypodermique',
    spanish: 'aguja hipodérmica',
  },
  {
    av: 15705,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to live + near)',
    english: 'neighbour',
    swedish: 'granne',
    norwegian: 'nabo',
    finnish: 'naapuri',
    hungarian: 'szomszéd, szomszédban lakó személy',
    german: 'Nachbar, Nachbarin',
    dutch: 'buurman, buur',
    afrikaans: 'buur',
    russian: 'сосед, соседка',
    latvian: 'kaimiņš, kaimiņiene',
    polish: 'sąsiad',
    french: 'voisin',
    spanish: 'vecino',
  },
  {
    av: 15706,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(minus + either)',
    english: 'neither',
    swedish: 'varken',
    norwegian: 'verken',
    finnish: 'ei -',
    hungarian: 'sem (sem…)',
    german: 'weder',
    dutch: 'evenmin, geen van beide',
    afrikaans: 'geeneen',
    russian: 'ни... ни',
    latvian: 'ne viens, ne otrs',
    polish: 'żaden',
    french: "ni, ni l'un ni l'autre, aucun",
    spanish: 'ni',
  },
  {
    av: 15707,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: "(son + sibling: son of one's brother or sister)",
    english: 'nephew',
    swedish: 'brorson, systerson',
    norwegian: 'nevø',
    finnish: 'veljenpoika, sisarenpoika',
    hungarian: 'unokaöccs',
    german: 'Neffe',
    dutch: 'neef',
    afrikaans: 'neef',
    russian: 'племянник',
    latvian: 'brāļa/māsas dēls',
    polish: 'bratanek',
    french: 'neveu',
    spanish: 'sobrino',
  },
  {
    av: 15708,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + low)',
    english: 'Netherlands (The), Holland',
    swedish: 'Holland, Nederländerna',
    norwegian: 'Holland, Nederland',
    finnish: 'Hollanti, Alankomaat',
    hungarian: 'Hollandia',
    german: 'Niederlande',
    dutch: 'Nederland',
    afrikaans: 'Nederland Holland',
    russian: 'Нидерланды',
    latvian: 'Nīderlande, Holande',
    polish: 'Holandia',
    french: 'Pays-Bas',
    spanish: 'Países Bajos, Holanda',
  },
  {
    av: 15710,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(newness, novelty + description indicator)',
    english: 'new',
    swedish: 'ny',
    norwegian: 'ny',
    finnish: 'uusi',
    hungarian: 'új',
    german: 'neu',
    dutch: 'nieuw',
    afrikaans: 'nuwe',
    russian: 'новый',
    latvian: 'jauns',
    polish: 'nowy',
    french: 'nouveau',
    spanish: 'nuevo',
  },
  {
    av: 15711,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(birthday + year: day that a new year is born)',
    english: "New Year's Day",
    swedish: 'nyår',
    norwegian: 'nyttårsdag',
    finnish: 'uudenvuodenpäivä',
    hungarian: 'újév, újév napja',
    german: 'Neujahrstag',
    dutch: 'nieuwjaar (dag), nieuwjaarsdag',
    afrikaans: 'Nuwejaarsdag',
    russian: 'новый год',
    latvian: 'Jaungada diena',
    polish: 'Nowy Rok',
    french: 'Nouvel An',
    spanish: 'Día de Año Nuevo',
  },
  {
    av: 15713,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(page + news)',
    english: 'newspaper, bulletin, newsletter',
    swedish: 'dagstidning, bulletin',
    norwegian: 'dagsavis, nyhetsbrev',
    finnish: 'sanomalehti',
    hungarian: 'újság, hírlevél, hírlap',
    german: 'Zeitung',
    dutch: 'krant, dagblad',
    afrikaans: 'koerant, nuusbrief, bulletin',
    russian: 'газета',
    latvian: 'avīze, informatīvs izdevums, biļetens, ziņojums, apkārtraksts',
    polish: 'gazeta, czasopismo',
    french: "journal, bulletin d'information, lettre d'information",
    spanish: 'diario, periódico, boletín',
  },
  {
    av: 15714,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(first + after + description indicator: coming directly after)',
    english: 'next',
    swedish: 'nästa',
    norwegian: 'neste',
    finnish: 'seuraava',
    hungarian: 'következő',
    german: 'nächste, nächster, nächstes',
    dutch: 'volgende',
    afrikaans: 'volgende',
    russian: 'следующий',
    latvian: 'nākamais',
    polish: 'następny',
    french: 'prochain, suivant',
    spanish: 'próximo',
  },
  {
    av: 15715,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(week + then (future))',
    english: 'next week',
    swedish: 'nästa vecka',
    norwegian: 'neste uke',
    finnish: 'öljy',
    hungarian: 'jövő hét, következő hét',
    german: 'nächste Woche',
    dutch: 'volgende week',
    afrikaans: 'volgende week',
    russian: 'на следующей неделе',
    latvian: 'nākošā nedēļa',
    polish: 'w przyszłym tygodniu',
    french: 'semaine prochaine',
    spanish: 'próxima semana',
  },
  {
    av: 15716,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(year + then (future))',
    english: 'next year',
    swedish: 'nästa år',
    norwegian: 'neste år',
    finnish: 'ensi viikko',
    hungarian: 'jövő év, következő év',
    german: 'nächstes Jahr',
    dutch: 'volgend jaar',
    afrikaans: 'volgende jaar',
    russian: 'в следующем году',
    latvian: 'nākošais gads',
    polish: 'w przyszłym roku',
    french: 'année prochaine',
    spanish: 'próximo año',
  },
  {
    av: 15717,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      "(feeling + correct + description indicator: felt to be socially 'correct')",
    english: 'nice, pleasant',
    swedish: 'trevlig',
    norwegian: 'hyggelig, koselig, trivelig',
    finnish: 'ensi vuosi',
    hungarian: 'kedves, kellemes, barátságos',
    german: 'nett, sympathisch, lieb, angenehm, freundlich',
    dutch: 'leuk, gezellig',
    afrikaans: 'aangenaam, aangename, gesellige, gesellig',
    russian: 'приятный',
    latvian: 'jauks, patīkams',
    polish: 'miły, dobry, przyjemny, grzeczny',
    french: 'gentil, agréable',
    spanish: 'agradable',
  },
  {
    av: 15718,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: "(daughter + sibling: daughter of one's brother or sister)",
    english: 'niece',
    swedish: 'brorsdotter, systerdotter',
    norwegian: 'niese',
    finnish: 'mukava, hauska, miellyttävä',
    hungarian: 'unokahúg',
    german: 'Nichte',
    dutch: 'nicht',
    afrikaans: 'nig',
    russian: 'племянница',
    latvian: 'brāļa/māsas meita',
    polish: 'bratanica',
    french: 'nièce',
    spanish: 'sobrina',
  },
  {
    av: 15720,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + breasts)',
    english: 'nipple(s)',
    swedish: 'bröstvårtor',
    norwegian: 'brystvorter',
    finnish: 'veljentytär, sisarentytär',
    hungarian: 'mellbimbó',
    german: 'Brustwarze',
    dutch: 'tepels',
    afrikaans: 'tepel(s)',
    russian: 'соски',
    latvian: 'krūtsgals (-i)',
    polish: 'sutek',
    french: 'mamelon',
    spanish: 'pezones',
  },
  {
    av: 15721,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(month + unleavened bread: month of Passover, the first month of the year)',
    english: 'Nisan, Nissan',
    swedish: 'Nissan (Israel)',
    norwegian: 'Nissan (Israel)',
    finnish: 'päällä, -lla, -llä',
    hungarian: 'Niszán (héber)',
    german: 'Nissan',
    dutch: 'Nissan (Joods)',
    afrikaans: 'Nisan, Nissan',
    russian: 'ниссан (Израиль)',
    latvian: 'nisan (Izraēla)',
    polish: 'Nisan (miesiąc hebr.)',
    french: 'Nissan (1er mois du calendrier juif)',
    spanish: 'Nisan',
  },
  {
    av: 15722,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(not + intensity: strong negative response)',
    english: 'no-(exclamatory)',
    swedish: 'nej',
    norwegian: 'nei (utsagn)',
    finnish: 'yö',
    hungarian: 'ne (tiltószó)',
    german: 'nein',
    dutch: 'niet',
    afrikaans: 'nee-(uitroepend)',
    russian: 'нет',
    latvian: 'nē!',
    polish: 'NIE !! (wykrzyknik)',
    french: 'non (exclamation)',
    spanish: 'no (exclamativo)',
  },
  {
    av: 15723,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(minus + person)',
    english: 'no one, nobody',
    swedish: 'ingen',
    norwegian: 'ingen',
    finnish: 'kerran, kerta',
    hungarian: 'senki',
    german: 'niemand, keiner',
    dutch: 'niemand',
    afrikaans: 'niemand, geeneen, ',
    russian: 'никто',
    latvian: 'neviens, neviena, nekas',
    polish: 'nikt',
    french: 'personne, aucune personne',
    spanish: 'nadie',
  },
  {
    av: 15724,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ejaculation + to sleep)',
    english: 'nocturnal emission, wet dream',
    swedish: 'utlösning i sömnen',
    norwegian: 'utløsning i søvne',
    finnish: 'nännit',
    hungarian: 'éjszakai magömlés',
    german: 'nächtlicher Samenerguss',
    dutch: 'natte droom',
    afrikaans: 'nat droom',
    russian: 'поллюция',
    latvian: 'ilūzija',
    polish: 'nocny wytrysk, „mokry sen”',
    french: 'pollution nocturne',
    spanish: 'emisión nocturna',
  },
  {
    av: 15727,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(nonsense + intensity symbol: exclamation)',
    english: 'nonsense-(exclamatory)',
    swedish: 'dumheter',
    norwegian: 'tull (utsagn)',
    finnish: 'ei',
    hungarian: 'Képtelenség! Szamárság! Hülyeség! Ostobaság!',
    german: 'Quatsch, Unsinn',
    dutch: 'onzin!',
    afrikaans: 'nonsens (uitroepend), onsin!',
    russian: 'глупость',
    latvian: 'muļķības!',
    polish: 'nonsens BZDURA! (wykrzyknik)',
    french: 'non-sens (pas de sens)',
    spanish: 'disparate (exclamativo)',
  },
  {
    av: 15728,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(no speech, anarthria + description indicator: unable to speak). See also: speech impaired 26025',
    english: 'nonspeaking',
    swedish: 'stum',
    norwegian: 'stum, talehemmet',
    finnish: 'ei kukaan',
    hungarian: 'beszédképtelen, nem beszélő',
    german: 'nichtsprechend',
    dutch: 'nietsprekend',
    afrikaans: 'nie-verbaal',
    russian: 'немой',
    latvian: 'bezvārda, mēms',
    polish: 'niemówiący',
    french: 'non oral, muet',
    spanish: 'mudo',
  },
  {
    av: 15729,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(minus + or)',
    english: 'nor',
    swedish: 'eller, varken eller',
    norwegian: 'eller, hverken eller',
    finnish: 'siemensyöksy (yöllinen)',
    hungarian: 'sem (… sem)',
    german: '(weder) noch',
    dutch: 'noch',
    afrikaans: 'nie',
    russian: 'также не',
    latvian: 'nedz, arī ne',
    polish: 'ani',
    french: 'ni',
    spanish: 'ni',
  },
  {
    av: 15731,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(north + description indicator)',
    english: 'northern',
    swedish: 'nordlig',
    norwegian: 'nordlig',
    finnish: 'hölynpöly',
    hungarian: 'északi',
    german: 'nördlich',
    dutch: 'noordelijk',
    afrikaans: 'noorde, noordelik, noordelike',
    russian: 'северный',
    latvian: 'ziemeļu',
    polish: 'północny',
    french: 'nordique',
    spanish: 'del norte',
  },
  {
    av: 15733,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation:
      '(minus + intensity: also used before a verb to create a negative sentence)',
    english: "not, negative, no, don't, doesn't",
    swedish: 'inte, negativ',
    norwegian: 'ikke, negativ',
    finnish: 'puhumaton, puhekyvytön',
    hungarian: 'nem (tagadás)',
    german: 'nicht, negativ',
    dutch: 'niet',
    afrikaans: 'nie, negatief, moenie, nee',
    russian: 'не, ни',
    latvian: 'nē, noliegums, nolieguma vietniekvārdi',
    polish: 'nie, negacja, zaprzeczenie, odmowa',
    french: 'ne pas, négation',
    spanish: 'no, negativo',
  },
  {
    av: 15734,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + to write)',
    english: 'notebook, writing book',
    swedish: 'anteckningsbok, skrivbok',
    norwegian: 'skrivebok, notisbok',
    finnish: 'eikä',
    hungarian: 'füzet, jegyzetfüzet, notesz',
    german: 'Notizbuch, Heft',
    dutch: 'notitieboekje',
    afrikaans: 'notaboek, skryf boek',
    russian: 'тетрадь',
    latvian: 'piezīmju burtnīca, piezīmes',
    polish: 'notatnik',
    french: 'carnet, calepin, bloc-notes',
    spanish: 'cuaderno',
  },
  {
    av: 15735,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 11: eleventh month of the year)',
    english: 'November',
    swedish: 'november',
    norwegian: 'november',
    finnish: 'pohjoinen',
    hungarian: 'november',
    german: 'November',
    dutch: 'november',
    afrikaans: 'November',
    russian: 'ноябрь',
    latvian: 'novembris',
    polish: 'listopad',
    french: 'novembre',
    spanish: 'Noviembre',
  },
  {
    av: 15738,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(energy + nucleus: energy released by a nuclear reaction)',
    english: 'nuclear energy',
    swedish: 'kärnkraft, atomenergi',
    norwegian: 'atomenergi, kjernekraft',
    finnish: 'ei',
    hungarian: 'atomenergia, nukleáris energia',
    german: 'Atomenergie, Kernkraft, Kernenergie',
    dutch: 'kernenergie',
    afrikaans: 'kernenergie',
    russian: 'ядерная энергетика',
    latvian: 'atomenerģija',
    polish: 'energia jądrowa',
    french: 'énergie nucléaire',
    spanish: 'energía nuclear',
  },
  {
    av: 15739,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dust + nucleus)',
    english: 'nuclear fallout, radioactive dust',
    swedish: 'radioaktivt stoft',
    norwegian: 'radioaktivt støv',
    finnish: 'muistikirja',
    hungarian: 'atomhulladék, rádióaktív por',
    german: 'radioaktiver Niederschlag',
    dutch: 'radioactiestof',
    afrikaans: 'kern, radioaktiewe neerslag, radioaktiewe stof',
    russian: 'радиоактивная пыль',
    latvian: 'radioaktīvie nokrišņi, putekļi',
    polish: 'pył, opad radioaktywny',
    french: 'retombées radioactives, poussières radioactives',
    spanish: 'desastre nuclear, polvo radioactivo',
  },
  {
    av: 15905,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to care for + medical: person who gives medical care)',
    english: 'nurse',
    swedish: 'sjuksköterska',
    norwegian: 'sykepleier',
    finnish: 'ydinvoima, ydinenergia',
    hungarian: 'ápoló (nő vagy férfi)',
    german: 'Krankenschwester, Krankenpflegerin',
    dutch: 'verpleegkundige',
    afrikaans: 'verpleër, verpleegkundige, verpleegster',
    russian: 'медсестра, медбрат',
    latvian: 'medmāsa, medbrālis',
    polish: 'pielęgniarka, pielęgniarz',
    french: 'infirmière',
    spanish: 'enfermera',
  },
  {
    av: 15906,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(seed + tree: edible seed from a tree)',
    english: 'nut',
    swedish: 'nöt',
    norwegian: 'nøtt',
    finnish: 'ydinlaskeuma',
    hungarian: 'dió, mogyoró, mandula, egyéb csonthéjasok',
    german: 'Nuss',
    dutch: 'noot',
    afrikaans: 'neut',
    russian: 'орех',
    latvian: 'rieksts',
    polish: 'orzechy, nasiona drzewa',
    french: 'noix',
    spanish: 'nuez, tuerca',
  },
  {
    av: 15907,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to do + by + to guide + action indicator: to do something by the rules)',
    english: 'obey, comply-(to)',
    swedish: 'lyda',
    norwegian: 'lyde, lystre',
    finnish: 'ydinsäteily',
    hungarian: 'engedelmeskedni',
    german: 'gehorchen',
    dutch: 'gehoorzamen',
    afrikaans: 'gehoorsaam, voldoen (om te)',
    russian: 'слушаться, повиноваться',
    latvian: 'klausīt, paklausīt, pakļauties',
    polish: 'być posłusznym',
    french: 'obéir',
    spanish: 'obedecer',
  },
  {
    av: 15908,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(observation + action indicator: to look at something thoughtfully)',
    english: 'observe-(to)',
    swedish: 'lägga märke till, observera',
    norwegian: 'iaktta, observere',
    finnish: 'atomin ydin',
    hungarian: 'megfigyelni',
    german: 'beobachten',
    dutch: 'waarnemen, observeren',
    afrikaans: 'waarneem, observeer (om te)',
    russian: 'наблюдать',
    latvian: 'novērot',
    polish: 'zauważyć, widzieć, obserwować',
    french: 'observer, remarquer',
    spanish: 'observar',
  },
  {
    av: 15909,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(much + much + water: large body of water)',
    english: 'ocean, sea',
    swedish: 'hav, ocean',
    norwegian: 'hav, osean',
    finnish: 'numero, luku',
    hungarian: 'tenger, óceán',
    german: 'Meer, Ozean, See, Weltmeer',
    dutch: 'zee, oceaan',
    afrikaans: 'oseaan, see',
    russian: 'море, океан',
    latvian: 'okeāns, jūra',
    polish: 'ocean, morze',
    french: 'mer, océan',
    spanish: 'océano, mar',
  },
  {
    av: 15910,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 10: tenth month of the year)',
    english: 'October',
    swedish: 'oktober',
    norwegian: 'oktober',
    finnish: 'sairaanhoitaja',
    hungarian: ' október',
    german: 'Oktober',
    dutch: 'oktober',
    afrikaans: 'Oktober',
    russian: 'октябрь',
    latvian: 'oktobris',
    polish: 'październik',
    french: 'octobre',
    spanish: 'Octubre',
  },
  {
    av: 15911,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + work + pencil: room where work is done)',
    english: 'office',
    swedish: 'arbetsrum, kontor',
    norwegian: 'kontor, arbeidsrom',
    finnish: 'pähkinä',
    hungarian: 'hivatal, iroda',
    german: 'Büro',
    dutch: 'kantoor',
    afrikaans: 'kantoor',
    russian: 'кабинет, контора',
    latvian: 'birojs, kantoris',
    polish: 'urząd',
    french: 'bureau (pièce)',
    spanish: 'oficina',
  },
  {
    av: 15913,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(many + time + description indicator: on many occasions)',
    english: 'often, frequent, frequently',
    swedish: 'ofta',
    norwegian: 'ofte',
    finnish: 'tarkkailla, tehdä havaintoja',
    hungarian: 'gyakori, gyakran',
    german: 'oft',
    dutch: 'vaak, frequent, regelmatig',
    afrikaans: 'baie, gereeld, gereelde',
    russian: 'часто',
    latvian: 'bieži',
    polish: 'często',
    french: 'souvent',
    spanish: 'a menudo, frecuentemente',
  },
  {
    av: 15915,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(opposite meaning + new + description indicator) Also see old 23910',
    english: 'old (opposite new)',
    swedish: 'gammal (FD)',
    norwegian: 'gammel (OLD)',
    finnish: 'lokakuu (vanha)',
    hungarian: 'régi (régi jelkép)',
    german: 'alt, gebraucht (ALT)',
    dutch: 'oud (OUD)',
    afrikaans: 'oud (teenoorgesteld nuwe) (OUD)',
    russian: 'старый (СТАРОЕ зн)',
    latvian: 'vecs (antonīms jaunam) (novec.)',
    polish: 'stary (przeciwieństwo nowego) (stare)',
    french: 'vieux (ancien)',
    spanish: 'viejo (opuesto a nuevo) (ANTIGUO)',
  },
  {
    av: 15916,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(opposite meaning + young + description indicator)',
    english: 'old, elderly',
    swedish: 'gammal, äldre (motsats ung)',
    norwegian: 'gammel (motsatt ung), eldre',
    finnish: 'toimisto',
    hungarian: 'idős, öreg',
    german: 'alt (Gegensatz jung)',
    dutch: 'oud (mensen), ouder (niet jong)',
    afrikaans: 'oud, bejaarde',
    russian: 'старый, пожилой',
    latvian: 'vecs, pavecāks',
    polish: 'stary (o człowieku)',
    french: 'vieux (contraire de jeune)',
    spanish: 'viejo (opuesto a joven)',
  },
  {
    av: 15919,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(1 + time + description indicator: on one occasion)',
    english: 'once',
    swedish: 'en gång',
    norwegian: 'en gang',
    finnish: 'vanha (vanha)',
    hungarian: 'egyszer, egyszeri, egyetlenszer',
    german: 'einmal',
    dutch: 'eens',
    afrikaans: 'eens',
    russian: 'однажды',
    latvian: 'vienreiz',
    polish: 'raz',
    french: 'une seule fois, une fois',
    spanish: 'una vez',
  },
  {
    av: 15921,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(opening + description indicator)',
    english: 'open',
    swedish: 'öppen',
    norwegian: 'åpen',
    finnish: 'avoinna, auki, avoin',
    hungarian: 'nyitva, nyitott',
    german: 'offen',
    dutch: 'open',
    afrikaans: 'oop',
    russian: 'открытый',
    latvian: 'atvērts',
    polish: 'otwarty',
    french: 'ouvert',
    spanish: 'abierto',
  },
  {
    av: 15922,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(opening + action indicator)',
    english: 'open-(to)',
    swedish: 'öppna',
    norwegian: 'åpne',
    finnish: 'avata, aukaista',
    hungarian: 'nyitni, kinyitni',
    german: 'öffnen, aufmachen',
    dutch: 'openen',
    afrikaans: 'oop (om te)',
    russian: 'открывать',
    latvian: 'atvērt',
    polish: 'otwierać',
    french: 'ouvrir',
    spanish: 'abrir',
  },
  {
    av: 15924,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to cut + medical)',
    english: 'operation',
    swedish: 'operation',
    norwegian: 'operasjon',
    finnish: 'leikkaus',
    hungarian: 'műtét, operáció',
    german: 'Operation',
    dutch: 'operatie',
    afrikaans: 'operasie',
    russian: 'операция',
    latvian: 'operācija',
    polish: 'operacja',
    french: 'opération chirurgicale',
    spanish: 'operación',
  },
  {
    av: 15926,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(marsupial + night: marsupial that comes out at night)',
    english: 'opossum, possum',
    swedish: 'opossum, pungråtta',
    norwegian: 'pungrotte, opossum',
    finnish: 'opossumi, pussirotta',
    hungarian: 'oposszum',
    german: 'Opossum',
    dutch: 'buidelrat',
    afrikaans: 'buidelrot',
    russian: 'опоссум',
    latvian: 'oposums',
    polish: 'opos',
    french: 'opossum',
    spanish: 'zarigüeya, comadreja',
  },
  {
    av: 15930,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to combine + genitals + mouth)',
    english: 'oral sex',
    swedish: 'munsex, oralt samlag',
    norwegian: 'munnsex, oralsex',
    finnish: 'suuseksi',
    hungarian: 'orális szex',
    german: 'Oralverkehr, Oralsex',
    dutch: 'orale seks',
    afrikaans: 'orale seks',
    russian: 'оральный секс',
    latvian: 'orālais sekss',
    polish: 'seks oralny',
    french: 'rapport bucco-génital',
    spanish: 'sexo oral',
  },
  {
    av: 15931,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation:
      '(colour + mouth + sun: combination of red and yellow) (BCI) SYMBOL SYNONYM ',
    english: 'orange (bci)',
    swedish: 'orange',
    norwegian: 'oransje',
    finnish: 'oranssi',
    hungarian: 'narancsszín, narancssárga',
    german: 'orange',
    dutch: 'oranje',
    afrikaans: 'oranje (bci)',
    russian: 'оранжевый',
    latvian: 'oranža krāsa',
    polish: 'pomarańczowy (BCI)',
    french: 'orange (bci)',
    spanish: 'naranja (BCI)',
  },
  {
    av: 15932,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + 2) (CKB) SYMBOL SYNONYM',
    english: 'orange (ckb)',
    swedish: 'orange (CKB)',
    norwegian: 'oransje (CKB)',
    finnish: 'oranssi',
    hungarian: 'narancsszín, narancssárga (régi CKB-jelkép)',
    german: 'orange',
    dutch: 'oranje (CKB)',
    afrikaans: 'oranje (ckb)',
    russian: 'оранжевый',
    latvian: 'oranžs',
    polish: 'pomarańczowy (CKB)',
    french: 'orange (ckb)',
    spanish: 'naranja (CKB)',
  },
  {
    av: 15934,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(grove + fruit)',
    english: 'orchard',
    swedish: 'fruktträdgård',
    norwegian: 'frukthage',
    finnish: 'hedelmätarha',
    hungarian: 'gyümölcsös, gyümölcsöskert',
    german: 'Obstgarten',
    dutch: 'boomgaard',
    afrikaans: 'boord',
    russian: 'фруктовый сад',
    latvian: 'augļudārzs',
    polish: 'sad',
    french: 'verger',
    spanish: 'huerto',
  },
  {
    av: 15935,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to plan + many + thing + action indicator: to make a system from many things)',
    english: 'organize, arrange-(to)',
    swedish: 'ordna, organisera',
    norwegian: 'organisere, arrangere',
    finnish: 'järjestää, oraganisoida',
    hungarian: 'szervezni, megszervezni, elintézni, elrendezni',
    german: 'organisieren, einsortieren',
    dutch: 'organiseren, plannen',
    afrikaans: 'organiseer, reël (om te)',
    russian: 'организовывать',
    latvian: 'organizēt',
    polish: 'zorganizować',
    french: 'organiser',
    spanish: 'organizar',
  },
  {
    av: 15936,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ecstacy + genitals)',
    english: 'orgasm',
    swedish: 'orgasm',
    norwegian: 'orgasme',
    finnish: 'orgasmi',
    hungarian: 'orgazmus, szexuális kielégülés',
    german: 'Orgasmus',
    dutch: 'orgasme',
    afrikaans: 'orgasme',
    russian: 'оргазм',
    latvian: 'orgasms',
    polish: 'orgazm',
    french: 'orgasme',
    spanish: 'orgasmo',
  },
  {
    av: 15937,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + to walk: bird that walks or runs but does not fly)',
    english: 'ostrich',
    swedish: 'struts',
    norwegian: 'struts',
    finnish: 'strutsi',
    hungarian: 'strucc',
    german: 'Strauß',
    dutch: 'struisvogel',
    afrikaans: 'volstruis',
    russian: 'страус',
    latvian: 'strauss',
    polish: 'struś',
    french: 'autruche',
    spanish: 'avestruz',
  },
  {
    av: 15938,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person [modification] + 2: referring to a second person)',
    english: 'other, another (person)',
    swedish: 'annan (person)',
    norwegian: 'annen (person)',
    finnish: 'toinen',
    hungarian: 'más, másik egy másik személy',
    german: '(ein) Anderer, (eine) Andere, (jemand) anders',
    dutch: 'ander (persoon)',
    afrikaans: 'ander (persoon)',
    russian: 'другой',
    latvian: 'cits, cita',
    polish: 'otolaryngolog',
    french: 'autre (personne)',
    spanish: 'otro',
  },
  {
    av: 15939,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(female + 1 + belongs to + plural indicator: first person plural (f.), possessive)',
    english: 'our, ours-(feminine)',
    swedish: 'vår, vårt, våra (fem.)',
    norwegian: 'vår, vårt, våre (hunkjønn)',
    finnish: 'meidän (naiset), meidän (fem.)',
    hungarian: 'mien (nőnem)',
    german: 'unser, unser, unsere, unser (weiblich)',
    dutch: 'ons, onze (vrouwelijk)',
    afrikaans: "ons, ons s'n (vroulik)",
    russian: 'наш, наша, наше, наши (жен.)',
    latvian: 'mūsu, mūsējā',
    polish: 'nasz(rodzaj męski, l. mn. „mieć”)',
    french: 'notre, nos, nôtre (fém.)',
    spanish: 'nuestra, nuestras (femenino)',
  },
  {
    av: 15940,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(male + 1 + belongs to + plural indicator: first person plural (m.), possessive)',
    english: 'our, ours-(masculine)',
    swedish: 'vår, vårt, våra (mask.)',
    norwegian: 'vår, vårt, våre (hankjønn)',
    finnish: 'meidän (miehet), meidän (mask.)',
    hungarian: 'mienk (hímnem)',
    german: 'unser, unser, unsere, unser (männlich)',
    dutch: 'ons, onze (mannelijk)',
    afrikaans: "ons, ons s'n (manlik)",
    russian: 'наш, наша, наше, наши (муж.)',
    latvian: 'mūsu, mūsējais',
    polish: 'nasz (l. mn. „mieć”)',
    french: 'notre, nos, nôtre (masc.)',
    spanish: 'nuestro, nuestros (masculino)',
  },
  {
    av: 15941,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(we + belongs to + plural indicator: first person plural, possessive)',
    english: 'our, ours',
    swedish: 'vår, vårt, våra',
    norwegian: 'vår, vårt, våre',
    finnish: 'meidän',
    hungarian: 'mienk',
    german: 'unser, unser, unsere, unser',
    dutch: 'ons, onze',
    afrikaans: "ons, ons s'n",
    russian: 'наш, наша, наше, наши',
    latvian: 'mūsu, mūsējais, mūsējā',
    polish: 'nasz, nasza',
    french: 'notre, nos, nôtre',
    spanish: 'nuestro, nuestros',
  },
  {
    av: 15945,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(legs and feet + out of)',
    english: 'outing, excursion',
    swedish: 'utflykt, utfärd',
    norwegian: 'tur, utflukt',
    finnish: 'ulkoilu, retki',
    hungarian: 'kirándulás, séta ',
    german: 'Ausflug, Spaziergang, Exkursion',
    dutch: 'uitstapje, excursie',
    afrikaans: 'uitstappie, ekskursie',
    russian: 'прогулка, экскурсия',
    latvian: 'izbraukums, ekskursija ',
    polish: 'wycieczka',
    french: 'sortie, excursion',
    spanish: 'excursión',
  },
  {
    av: 15946,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + oval)',
    english: 'oval, ellipse (shape)',
    swedish: 'oval, ellips',
    norwegian: 'oval',
    finnish: 'soikio',
    hungarian: 'ovális, tojásdad, elliptikus (fn.)',
    german: 'oval',
    dutch: 'ovaal',
    afrikaans: 'ovaal, ellips',
    russian: 'овал',
    latvian: 'ovāls, elipse',
    polish: 'owal (przedmiot owalny)',
    french: 'ovale (figure géométrique)',
    spanish: 'óvalo, elipse',
  },
  {
    av: 15947,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + egg)',
    english: 'ovary',
    swedish: 'äggstock',
    norwegian: 'eggstokk, ovarie',
    finnish: 'munasarja',
    hungarian: 'petefészek, ovárium',
    german: 'Eierstock',
    dutch: 'eierstok',
    afrikaans: 'eierstok',
    russian: 'яичник',
    latvian: 'olnīca',
    polish: 'jajnik',
    french: 'ovaire',
    spanish: 'ovario',
  },
  {
    av: 15949,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + night)',
    english: 'owl, night bird',
    swedish: 'uggla, uv',
    norwegian: 'ugle, nattfugl',
    finnish: 'pöllö',
    hungarian: 'bagoly, éjszakai madár',
    german: 'Eule',
    dutch: 'uil',
    afrikaans: 'uil, nag voël',
    russian: 'сова, сыч, филин ',
    latvian: 'pūce',
    polish: 'sowa, ptak nocny',
    french: 'hibou, chouette, oiseau nocturne',
    spanish: 'lechuza',
  },
  {
    av: 15950,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(ownership, possession + action indicator: CKB writes 'an addition, a gain, a plus of some very earthly (material) thing')",
    english: 'own, possess-(to)',
    swedish: 'äga',
    norwegian: 'eie (å)',
    finnish: 'omistaa',
    hungarian: 'tulajdonolni, tulajdonul bírni, rendelkezni valamivel',
    german: 'besitzen',
    dutch: 'bezitten',
    afrikaans: 'besit (om te)',
    russian: 'владеть, обладать',
    latvian: 'piederēt, būt',
    polish: 'mieć, posiadać',
    french: 'posséder',
    spanish: 'poseer',
  },
  {
    av: 15951,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(bovine + work: horned animal commonly used to assist with heavy labour)',
    english: 'ox',
    swedish: 'oxe',
    norwegian: 'okse',
    finnish: 'härkä, juhta',
    hungarian: 'ökör',
    german: 'Ochse',
    dutch: 'os',
    afrikaans: 'os',
    russian: 'вол, бык',
    latvian: 'vērsis',
    polish: 'wół',
    french: 'boeuf',
    spanish: 'buey',
  },
  {
    av: 15954,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(feeling + sick: discomfort that makes one 'draw up one's knees'. The symbol usually represents physical pain but also can be used to represent emotional distress and suffering.)",
    english: 'pain, suffering',
    swedish: 'smärta',
    norwegian: 'smerte, lidelse',
    finnish: 'kipu, särky, tuska',
    hungarian: 'fájdalom, fizikai szenvedés',
    german: 'Schmerz, starker Schmerz',
    dutch: 'pijn',
    afrikaans: 'pyn, ly, lyding',
    russian: 'боль',
    latvian: 'sāpes, ciešanas',
    polish: 'ból, cierpienie',
    french: 'douleur, souffrance',
    spanish: 'dolor',
  },
  {
    av: 15955,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(pain + description indicator)',
    english: 'painful, painfully, sore',
    swedish: 'ont, smärtsam',
    norwegian: 'vond, smertefull',
    finnish: 'tuskallinen, kipeä, sairas',
    hungarian: 'fájdalmas, érzékeny, sebes, sérült',
    german: 'schmerzhaft',
    dutch: 'pijnlijk',
    afrikaans: 'seer, pyn, lyding',
    russian: 'болезненный',
    latvian: 'sāpīgs, sāpīgi',
    polish: 'bolesne, sprawiające cierpienie',
    french: 'douloureux, pénible',
    spanish: 'doloroso',
  },
  {
    av: 15956,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical product + colour + liquid)',
    english: 'paint, dye',
    swedish: 'färg (målarfärg etc)',
    norwegian: 'maling',
    finnish: 'maali',
    hungarian: 'festék',
    german: 'Farbe, Färbung',
    dutch: 'verf',
    afrikaans: 'verf, kleursel',
    russian: 'краска',
    latvian: 'krāsa, krāsviela',
    polish: 'farba, barwnik',
    french: 'peinture, teinture',
    spanish: 'pintura',
  },
  {
    av: 15957,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(paint + action indicator)',
    english: 'paint, dye-(to)',
    swedish: 'måla, färga',
    norwegian: 'male, farge (å)',
    finnish: 'maalata',
    hungarian: 'festeni, be//ki/megfestenei, színezni',
    german: 'anstreichen, malen',
    dutch: 'verven',
    afrikaans: 'verf (om te)',
    russian: 'красить',
    latvian: 'krāsot, nokrāsot',
    polish: 'farbować, barwić, malować',
    french: 'peindre',
    spanish: 'pintar, teñir',
  },
  {
    av: 15958,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + paint [contraction])',
    english: 'painter',
    swedish: 'målare',
    norwegian: 'maler',
    finnish: 'maalari',
    hungarian: 'festő, mázoló',
    german: 'Maler, Anstreicher, Malermeister, Malermeisterin, Kunstmaler',
    dutch: 'schilder',
    afrikaans: 'skildenaar, skilder, verwer',
    russian: 'художник, живописец',
    latvian: 'gleznotājs',
    polish: 'malarz',
    french: 'peintre',
    spanish: 'pintor',
  },
  {
    av: 15959,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(2 + thing indicator: two items) - (character with thing indicator)',
    english: 'pair',
    swedish: 'par (ej mänskligt)',
    norwegian: 'par',
    finnish: 'pari',
    hungarian: 'pár, egy pár (valamiből)',
    german: 'Paar, Pärchen',
    dutch: 'paar',
    afrikaans: 'paar',
    russian: 'пара',
    latvian: 'pāris',
    polish: 'para (dwie osoby, dwa przedmioty)',
    french: 'paire',
    spanish: 'par',
  },
  {
    av: 15961,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + leg: clothing that covers the legs)',
    english: 'pants, jeans, slacks, trousers',
    swedish: 'byxor, jeans',
    norwegian: 'bukser, jeans',
    finnish: 'housut',
    hungarian: 'nadrág, farmer, pantalló',
    german: 'Hose (lang), Jeans',
    dutch: 'broek',
    afrikaans: 'jeans, langbroek, broek',
    russian: 'брюки',
    latvian: 'bikses, džinsi, platas bikses',
    polish: 'spodnie',
    french: 'pantalon',
    spanish: 'pantalones, tejanos, jeans',
  },
  {
    av: 15963,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(parrot + little: small bird that can be trained to talk)',
    english: 'parakeet, budgie',
    swedish: 'undulat (etc)',
    norwegian: 'undulat, parakitt',
    finnish: 'papukaija, undulaatti',
    hungarian: 'törpepapagáj, arapapagáj',
    german: 'Sittich, Wellensittich',
    dutch: 'parkiet',
    afrikaans: 'parakiet, budgie, parkiet',
    russian: 'попугай волнистый',
    latvian: 'mazs papagailis',
    polish: 'papużka',
    french: 'perruche',
    spanish: 'perico',
  },
  {
    av: 15965,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(soldier + from sky: soldier trained to jump down from the sky using a parachute)',
    english: 'paratrooper',
    swedish: 'fallskärmsjägare',
    norwegian: 'fallskjermjeger, fallskjermsoldat',
    finnish: 'laskuvarjo-sotilas',
    hungarian: 'ejtőernyős',
    german: 'Fallschirmjäger',
    dutch: 'valschermspringer (leger)',
    afrikaans: 'valskermtroep',
    russian: 'парашютист',
    latvian: 'izpletņlēcējs',
    polish: 'spadochroniarz (żołnierz)',
    french: 'parachutiste (militaire)',
    spanish: 'paracaidista',
  },
  {
    av: 15967,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(what, question mark + to say + action indicator)',
    english: 'pardon, what did you say',
    swedish: 'hur sa, vad',
    norwegian: 'hva sa du, hva (utsagn)',
    finnish: 'mitä sanoit?',
    hungarian: 'Mit mondtál? Pardon? Bocsánat, mit mondott?',
    german: 'bitte?, Entschuldigung',
    dutch: 'wat zeg je?, sorry (herhalen van boodschap)',
    afrikaans: 'verskoon my',
    russian: 'что вы сказали? что?',
    latvian: 'piedodiet, ko jūs teicāt?',
    polish: 'Co mówiłaś, co mówiłeś? Słucham?',
    french: 'pardon (question)',
    spanish: 'perdón, ¿qué dijo?',
  },
  {
    av: 15970,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + to talk: bird that can be trained to talk)',
    english: 'parrot, myna, talking bird',
    swedish: 'papegoja',
    norwegian: 'papegøye',
    finnish: 'papukaija',
    hungarian: 'papagáj, trópusi seregély, más beszélő madár',
    german: 'Papagei',
    dutch: 'papegaai',
    afrikaans: 'papegaai',
    russian: 'попугай',
    latvian: 'papagailis',
    polish: 'papuga (mówiąca)',
    french: 'perroquet',
    spanish: 'loro',
  },
  {
    av: 15971,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(vegetable (wedge-shaped) + white: vegetable with a long, white, edible root)',
    english: 'parsnip',
    swedish: 'palsternacka',
    norwegian: 'pastinakk',
    finnish: 'palsternakka',
    hungarian: 'fehérrépa, parsznip',
    german: 'Pastinak',
    dutch: 'pastinaak, ',
    afrikaans: 'witwortel',
    russian: 'пастернак',
    latvian: 'pastinaks',
    polish: 'pasternak',
    french: 'salsifis, scorsonère',
    spanish: 'chirivía',
  },
  {
    av: 15973,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gathering + happy)',
    english: 'party, festival',
    swedish: 'fest, kalas',
    norwegian: 'fest, selskap, party',
    finnish: 'juhla, juhlat, kutsut',
    hungarian: 'parti, buli, fesztivál',
    german: 'Fest, Feier, Party',
    dutch: 'feest',
    afrikaans: 'partytjie, fees, party, feestelikheid',
    russian: 'вечеринка',
    latvian: 'viesības, svētki',
    polish: 'przyjęcie, party, zabawa towarzyska',
    french: 'fête, soirée, réception',
    spanish: 'fiesta, festival',
  },
  {
    av: 15974,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(week + bread + low: the week when unleavened bread, matzo, is eaten)',
    english: 'Passover',
    swedish: 'Passover (Israel)',
    norwegian: 'Passover (Israel)',
    finnish: 'pesah, pesach, pääsiäinen',
    hungarian: 'Pészach (héber), zsidó húsvét',
    german: 'Pessach, Passah, Pascha',
    dutch: 'Passover (Joods)',
    afrikaans: 'Pasga',
    russian: 'еврейская пасха, пасхальный агнец',
    latvian: 'Pasa svētki, ebreju Lieldienas',
    polish: 'pascha (hebr)',
    french: 'Pâque juive',
    spanish: 'Pascua Judía',
  },
  {
    av: 15976,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ability + to wait)',
    english: 'patience',
    swedish: 'tålamod',
    norwegian: 'tålmodighet',
    finnish: 'kärsivällisyys',
    hungarian: 'türelem',
    german: 'Geduld',
    dutch: 'geduld',
    afrikaans: 'geduld',
    russian: 'терпение',
    latvian: 'pacietība',
    polish: 'cierpliwość',
    french: 'patience',
    spanish: 'paciencia',
  },
  {
    av: 15977,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(patience + action indicator)',
    english: 'be patient-(to)',
    swedish: 'ha tålamod',
    norwegian: 'ha tålmodighet, være tålmodig',
    finnish: 'olla kärsivällinen, malttaa',
    hungarian: 'türelmesnek lenni, türelemmel lenni',
    german: 'geduldig sein',
    dutch: 'geduldig zijn',
    afrikaans: 'geduldig wees (om te)',
    russian: 'терпеть',
    latvian: 'pacietīgs',
    polish: 'mieć cierpliwość (czynność)',
    french: 'être patient',
    spanish: 'ser paciente',
  },
  {
    av: 15979,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to give + money + action indicator)',
    english: 'pay, spend-(to)',
    swedish: 'betala',
    norwegian: 'betale',
    finnish: 'maksaa',
    hungarian: 'fizetni, kifizetni, pénzt költeni, kiadni',
    german: 'bezahlen',
    dutch: 'betalen',
    afrikaans: 'betaal, spandeer (om te)',
    russian: 'платить',
    latvian: 'maksāt, samaksāt',
    polish: 'płacić, wydawać pieniądze',
    french: 'payer',
    spanish: 'pagar, gastar',
  },
  {
    av: 15980,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(opposite meaning + war)',
    english: 'peace (opposite war)',
    swedish: 'fred',
    norwegian: 'fred',
    finnish: 'rauha',
    hungarian: 'béke',
    german: 'Frieden',
    dutch: 'vrede (geen oorlog)',
    afrikaans: 'vrede (geen oorlog)',
    russian: 'мир',
    latvian: 'miers (ant. Karš)',
    polish: 'pacyfizm',
    french: 'paix (contraire de guerre)',
    spanish: 'paz (opuesto a guerra)',
  },
  {
    av: 15982,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(peace + description indicator)',
    english: 'peaceful, serene, calm',
    swedish: 'lugn, fridfull',
    norwegian: 'fredelig, i fred',
    finnish: 'rauhallinen',
    hungarian: 'békés, nyugodt, nyugalmas',
    german: 'friedlich, ruhig, gelassen',
    dutch: 'vredig, rustig, sereen',
    afrikaans: 'vrede, rustigheid, kalmte, rustige',
    russian: 'мирный, спокойный',
    latvian: 'mierīgs',
    polish: 'spokojny, spokojna, odprężony',
    french: 'pacifique, paisible, tranquille',
    spanish: 'pacífico, sereno, calmo',
  },
  {
    av: 15984,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + fan: bird with a tail that opens like a fan)',
    english: 'peacock',
    swedish: 'påfågel',
    norwegian: 'påfugl',
    finnish: 'riikinkukko',
    hungarian: 'páva',
    german: 'Pfau',
    dutch: 'pauw',
    afrikaans: 'pou',
    russian: 'павлин',
    latvian: 'pāvs',
    polish: 'paw (ptak)',
    french: 'paon',
    spanish: 'pavo real',
  },
  {
    av: 15985,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spread + seed)',
    english: 'peanut butter',
    swedish: 'jordnötssmör',
    norwegian: 'peanøttsmør',
    finnish: 'maapähkinävoi',
    hungarian: 'mogyoróvaj',
    german: 'Erdnussbutter',
    dutch: 'pindakaas',
    afrikaans: 'grondboontjiebotter',
    russian: 'арахисовое масло',
    latvian: 'zemesriekstu sviests',
    polish: 'masło orzechowe',
    french: "beurre d'arachide",
    spanish: 'mantequilla de cacahuete',
  },
  {
    av: 15988,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + fruit)',
    english: 'peel',
    swedish: 'skal',
    norwegian: 'skall',
    finnish: 'kuori',
    hungarian: 'héj, gyümölcshéj',
    german: 'Schale',
    dutch: 'schil',
    afrikaans: 'skil',
    russian: 'корка, кожура',
    latvian: 'miza',
    polish: 'skórka owocu',
    french: 'pelure',
    spanish: 'piel, cáscara',
  },
  {
    av: 15989,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to remove + peel + action indicator)',
    english: 'peel-(to)',
    swedish: 'skala',
    norwegian: 'skrelle',
    finnish: 'kuoria',
    hungarian: 'hámozni, meg/lehámozni',
    german: 'schälen',
    dutch: 'schillen, pellen',
    afrikaans: 'skil (om te)',
    russian: 'очищать кожуру ',
    latvian: 'mizot',
    polish: 'obierać owoce, obierać ze skórki',
    french: 'peler',
    spanish: 'pelar',
  },
  {
    av: 15990,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water bird + pouch: water bird with a pouch-shaped bill)',
    english: 'pelican',
    swedish: 'pelikan',
    norwegian: 'pelikan',
    finnish: 'pelikaani',
    hungarian: 'pelikán',
    german: 'Pelikan',
    dutch: 'pelikaan',
    afrikaans: 'pelikaan',
    russian: 'пеликан',
    latvian: 'pelikāns',
    polish: 'pelikan',
    french: 'pélican',
    spanish: 'pelícano',
  },
  {
    av: 15992,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(through + action indicator)',
    english: 'penetrate, go through-(to)',
    swedish: 'gå igenom',
    norwegian: 'gå gjennom',
    finnish: 'lävistää, tunkeutua, mennä läpi',
    hungarian: 'áthatolni, átmenni, keresztülmenni',
    german: 'eindringen, durchdringen, durchhin gehen',
    dutch: 'doordringen, doorgaan, doorheen gaan',
    afrikaans: 'deurgaan, penetreer (om te)',
    russian: 'проникать, проходить',
    latvian: 'iespiesties, iekļūt',
    polish: 'przechodzić, przenikać',
    french: 'pénétrer, passer à travers, traverser',
    spanish: 'penetrar',
  },
  {
    av: 15993,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water bird + to walk: water bird that walks)',
    english: 'penguin',
    swedish: 'pingvin',
    norwegian: 'pingvin',
    finnish: 'pingviini',
    hungarian: 'pingvin',
    german: 'Pinguin',
    dutch: 'pinguïn',
    afrikaans: 'pikkewyn',
    russian: 'пингвин',
    latvian: 'pingvīns',
    polish: 'pingwin',
    french: 'pingouin, manchot',
    spanish: 'pingüino',
  },
  {
    av: 15996,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(adding, additive + taste + fire: combination of seasoning and hot + thing indicator)',
    english: 'pepper (seasoning)',
    swedish: 'peppar',
    norwegian: 'pepper',
    finnish: 'pippuri',
    hungarian: 'csípős, erős fűszer (pl. bors, csili)',
    german: 'Pfeffer',
    dutch: 'peper',
    afrikaans: 'peper (geurmiddel)',
    russian: 'перец',
    latvian: 'pipars (garšviela)',
    polish: 'papryka (przyprawa)',
    french: 'poivre (assaisonnement)',
    spanish: 'pimienta (condimento)',
  },
  {
    av: 15997,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(smell + happy: pleasant smell)',
    english: 'perfume, fragrance, aroma, scent',
    swedish: 'parfym',
    norwegian: 'parfyme',
    finnish: 'hajuste, aromi, tuoksu',
    hungarian: 'illat, aroma',
    german: 'Parfüm',
    dutch: 'parfum',
    afrikaans: 'parfuum, geur, aroma, reuk',
    russian: 'духи, аромат',
    latvian: 'smaržas',
    polish: 'perfum, zapach, aromat',
    french: 'parfum, senteur, fragrance',
    spanish: 'perfume, fragancia, aroma',
  },
  {
    av: 16168,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + feeling: animal for which one has feeling)',
    english: 'pet',
    swedish: 'sällskapsdjur',
    norwegian: 'kjæledyr',
    finnish: 'lemmikkieläin',
    hungarian: 'díszállat, házi kedvenc, kedvenc állat',
    german: 'Haustier',
    dutch: 'huisdier, troeteldier',
    afrikaans: 'troeteldier huisdier',
    russian: 'домашнее животное',
    latvian: 'mājdzīvnieks',
    polish: 'zwierzątko ulubione',
    french: 'animal familier, animal de compagnie',
    spanish: 'animal de compañía, mascota',
  },
  {
    av: 16169,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + camera)',
    english: 'photograph, photo, pic',
    swedish: 'foto, kort',
    norwegian: 'fotografi, foto',
    finnish: 'valokuva',
    hungarian: 'fénykép, fotográfia',
    german: 'Foto',
    dutch: 'foto',
    afrikaans: 'foto, kiekie',
    russian: 'фотография',
    latvian: 'fotogrāfija, attēls, bilde',
    polish: 'zdjęcie, fotografia, ilustracja',
    french: 'photo, photographie',
    spanish: 'fotografía',
  },
  {
    av: 16171,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + outside: food eaten outside)',
    english: 'picnic',
    swedish: 'picknick',
    norwegian: 'piknik',
    finnish: 'retkieväs',
    hungarian: 'piknik, étkezés a szabadban',
    german: 'Picknick',
    dutch: 'picknick',
    afrikaans: 'piekniek',
    russian: 'пикник',
    latvian: 'pikniks',
    polish: 'piknik (jedzenie +na zewnątrz)',
    french: 'pique-nique',
    spanish: 'picnic',
  },
  {
    av: 16172,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(eye + enclosure: what the eyes see in a frame)',
    english: 'picture, image, icon, painting',
    swedish: 'bild, tavla',
    norwegian: 'bilde, maleri, ikon',
    finnish: 'kuva, taulu',
    hungarian: 'kép, képmás, ikon, festmény',
    german: 'Bild, Gemälde, Zeichnung',
    dutch: 'afbeelding, schilderij, tekening',
    afrikaans: 'prent, prentjie, skildery, portret',
    russian: 'картина',
    latvian: 'glezna, attēls gleznojums',
    polish: 'obrazek, ilustracja',
    french: 'image, dessin',
    spanish: 'imagen, cuadro, icono',
  },
  {
    av: 16173,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + protection: food with a crust covering it)',
    english: 'pie, tart',
    swedish: 'paj',
    norwegian: 'pai',
    finnish: 'piirakka, piiras',
    hungarian: 'pite, lepény',
    german: 'Pastete, Torte, Obstkuchen',
    dutch: 'taart',
    afrikaans: 'tert, pastei',
    russian: 'пирог, пай',
    latvian: 'pīrags',
    polish: 'tarta, ciasto kruche z nadzieniem',
    french: 'tarte',
    spanish: 'pastel',
  },
  {
    av: 16176,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(disc + medical: medicine in disc form)',
    english: 'pill, tablet',
    swedish: 'tablett, piller',
    norwegian: 'pille, tablett',
    finnish: 'pilleri, tabletti',
    hungarian: 'tabletta, pirula, kapszula, labdacs',
    german: 'Tablette, Pillen',
    dutch: 'pil (medicament), tablet-(medicament)',
    afrikaans: 'pil, tablet',
    russian: 'пилюля, таблетка',
    latvian: 'tablete',
    polish: 'tabletka, pigułka',
    french: 'pilule',
    spanish: 'píldora, tableta',
  },
  {
    av: 16178,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + pillow)',
    english: 'pillowcase',
    swedish: 'örngott, kuddvar',
    norwegian: 'putevar',
    finnish: 'tyynyliina',
    hungarian: 'párnahuzat',
    german: 'Kissenbezug, Kopfkissenbezug',
    dutch: 'kussensloop',
    afrikaans: 'kussingsloop',
    russian: 'наволочка',
    latvian: 'spilvendrāna',
    polish: 'poszewka na poduszkę',
    french: "taie d'oreiller",
    spanish: 'funda de almohada',
  },
  {
    av: 16179,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + airplane)',
    english: 'pilot',
    swedish: 'pilot',
    norwegian: 'flyver, pilot',
    finnish: 'lentäjä',
    hungarian: 'pilóta',
    german: 'Pilot, Flugzeugführer, Pilotin, Flugzeugführerin',
    dutch: 'piloot',
    afrikaans: 'vlieënier',
    russian: 'лётчик, пилот',
    latvian: 'lidotājs, pilots',
    polish: 'pilot',
    french: 'pilote',
    spanish: 'piloto',
  },
  {
    av: 16184,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation:
      '(colour + mouth + sun: combination of red and white) (BCI) SYMBOL SYNONYM',
    english: 'pink (bci)',
    swedish: 'rosa',
    norwegian: 'rosa',
    finnish: 'vaaleanpunainen',
    hungarian: 'rózsaszín, rózsaszínű',
    german: 'rosa, pink',
    dutch: 'roze (BCI)',
    afrikaans: 'pienk (bci)',
    russian: 'розовый',
    latvian: 'sārts, rozā',
    polish: 'różowy (BCI)',
    french: 'rose (bci)',
    spanish: 'rosa (BCI)',
  },
  {
    av: 16185,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + 1 + sun: combination of red and white) (CKB) SYMBOL SYNONYM',
    english: 'pink (ckb)',
    swedish: 'rosa (CKB)',
    norwegian: 'rosa (CKB)',
    finnish: 'vaaleanpunainen',
    hungarian: 'rózsaszín (régi CKB-jelkép)',
    german: 'rosa, pink',
    dutch: 'roze',
    afrikaans: 'pienk (ckb)',
    russian: 'розовый (Ч.Б.)',
    latvian: 'sārta, rozā krāsa',
    polish: 'różowy (CKB)',
    french: 'rose (ckb)',
    spanish: 'rosa (CKB)',
  },
  {
    av: 16189,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to remove + pit + action indicator)',
    english: 'pit, stone-(to)',
    swedish: 'kärna ur',
    norwegian: 'kjerne ut',
    finnish: 'poistaa siemen',
    hungarian: 'magozni, kimagozni',
    german: 'entkernen, entsteinen',
    dutch: 'ontpitten',
    afrikaans: 'ontpit (om te)',
    russian: 'удалять косточку, семя',
    latvian: 'izņem kauliņu',
    polish: 'drylować (usuwać pestki)',
    french: 'dénoyauter',
    spanish: 'apedrear',
  },
  {
    av: 16192,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + pizza slice(s), sector(s), circle sector(s))',
    english: 'pizza',
    swedish: 'pizza',
    norwegian: 'pizza',
    finnish: 'pizza',
    hungarian: 'pizza',
    german: 'Pizza',
    dutch: 'pizza',
    afrikaans: 'pizza',
    russian: 'пицца',
    latvian: 'pica',
    polish: 'pizza',
    french: 'pizza',
    spanish: 'pizza',
  },
  {
    av: 16195,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(plan + action indicator)',
    english: 'plan, design-(to)',
    swedish: 'planera',
    norwegian: 'planlegge',
    finnish: 'suunnitella',
    hungarian: 'tervezni, megtervezni, elgondolni, megszerkeszteni',
    german: 'planen',
    dutch: 'ontwerpen',
    afrikaans: 'ontwerp (om te)',
    russian: 'планировать',
    latvian: 'plānot, izstrādāt',
    polish: 'planowy, projektowany',
    french: 'planifier, élaborer',
    spanish: 'planear, diseñar',
  },
  {
    av: 16197,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(chemical product + many + shape: chemical product that can be formed into many shapes)',
    english: 'plastic',
    swedish: 'plast',
    norwegian: 'plast',
    finnish: 'muovi',
    hungarian: 'műanyag',
    german: 'Plastik (Material)',
    dutch: 'plastic',
    afrikaans: 'plastiek',
    russian: 'пластик',
    latvian: 'palstmasa, plastikāts',
    polish: 'tworzywo sztuczne, plastik',
    french: 'plastique (matière)',
    spanish: '(de) plástico',
  },
  {
    av: 16199,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + happy)',
    english: 'play, recreation',
    swedish: 'lek',
    norwegian: 'lek, spill',
    finnish: 'leikki, huvi',
    hungarian: 'játék, rekreáció, kikapcsolódás',
    german: 'Spiel, Theaterstück',
    dutch: 'spel ',
    afrikaans: 'spel, ontspanning',
    russian: 'игра',
    latvian: 'spēle, izklaide',
    polish: 'zabawa, rozrywka, wypoczynek',
    french: 'jeu',
    spanish: 'juego',
  },
  {
    av: 16200,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(play + action indicator)',
    english: 'play-(to)',
    swedish: 'leka',
    norwegian: 'leke, spille',
    finnish: 'pelata, leikkiä',
    hungarian: 'játszani, kikapcsolódni',
    german: 'spielen',
    dutch: 'spelen',
    afrikaans: 'speel (om te)',
    russian: 'играть',
    latvian: 'spēlēt, spēlēties',
    polish: 'bawić się',
    french: 'jouer',
    spanish: 'jugar',
  },
  {
    av: 16201,
    group: 'word',
    pos: 'RED',
    derivationExplanation: 'football, soccer (activity) + action indicator)',
    english: 'play football-(to)',
    swedish: 'spela fotboll',
    norwegian: 'spille fotball',
    finnish: 'pelata jalkapalloa',
    hungarian: 'futballozni, focizni',
    german: 'Fußball spielen',
    dutch: 'voetballen',
    afrikaans: 'speel sokker (om te)',
    russian: 'играть в футбол',
    latvian: 'spēlēt futbolu',
    polish: 'grać w piłkę',
    french: 'jouer au football',
    spanish: 'jugar al fútbol',
  },
  {
    av: 16202,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + to play)',
    english: 'playground',
    swedish: 'lekplats',
    norwegian: 'lekeplass',
    finnish: 'leikkikenttä',
    hungarian: 'játszótér',
    german: 'Spielplatz',
    dutch: 'speelplaats, speeltuin',
    afrikaans: 'speelgrond',
    russian: 'игровая площадка',
    latvian: 'rotaļlaukums, spēļlaukums',
    polish: 'plac zabaw',
    french: 'cour de récréation, plaine de jeux, terrain de jeux, place de jeux',
    spanish: 'patio de recreo',
  },
  {
    av: 16203,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + to play)',
    english: 'playroom, family room, recreation room',
    swedish: 'lekrum',
    norwegian: 'lekerom',
    finnish: 'leikkihuone',
    hungarian: 'játszószoba, játékszoba, kikapcsolódási helyiség',
    german: 'Spielzimmer',
    dutch: 'recreatieruimte',
    afrikaans: 'speel kamer, familie kamer, ontspannings lokaal',
    russian: 'игровая комната',
    latvian: 'rotaļistaba, atpūtas telpa',
    polish: 'pokój zabaw, małpi gaj',
    french: 'salle de jeu, salle de récréation',
    spanish: 'cuarto de juego',
  },
  {
    av: 16204,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(command + feeling: polite command)',
    english: 'please',
    swedish: 'var snäll, var så god',
    norwegian: 'vær så snill (utsagn)',
    finnish: 'ole kiltti, ole hyvä',
    hungarian: 'kérem, kérlek, légyszíves',
    german: 'bitte, bitte schön',
    dutch: 'alstublieft, alsjeblieft',
    afrikaans: 'asseblief',
    russian: 'пожалуйста',
    latvian: 'lūdzu',
    polish: 'proszę',
    french: "s'il te plaît, s'il vous plaît",
    spanish: 'por favor',
  },
  {
    av: 16207,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(into + electricity + thing indicator: fitting inserted into an electrical socket)',
    english: 'plug',
    swedish: 'elkontakt',
    norwegian: 'stikkontakt',
    finnish: 'pistoke',
    hungarian: 'kapcsoló, hálózati dugó, konnektor',
    german: 'Stecker',
    dutch: 'stekker',
    afrikaans: 'muurprop, prop',
    russian: 'вилка штепсельная',
    latvian: 'kontaktdakša, kontaktligzda',
    polish: 'wtyczka (do prądu)',
    french: 'fiche électrique',
    spanish: 'enchufe',
  },
  {
    av: 16209,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + clothing: container sewn into an article of clothing)',
    english: 'pocket',
    swedish: 'ficka',
    norwegian: 'lomme',
    finnish: 'tasku',
    hungarian: 'zseb, ruhazseb',
    german: 'Tasche (in der Kleidung), Hosentasche',
    dutch: 'zak, broekzak',
    afrikaans: 'sak, hemp sak, broek sak',
    russian: 'карман',
    latvian: 'kabata',
    polish: 'kieszeń',
    french: 'poche',
    spanish: 'bolsillo',
  },
  {
    av: 16210,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(page + poetry)',
    english: 'poem',
    swedish: 'dikt',
    norwegian: 'dikt',
    finnish: 'runo',
    hungarian: 'vers, költemény',
    german: 'Gedicht',
    dutch: 'gedicht',
    afrikaans: 'gedig',
    russian: 'поэма, стихотворение',
    latvian: 'dzejolis',
    polish: 'poemat, wiersz',
    french: 'poème',
    spanish: 'poema',
  },
  {
    av: 16211,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(metaphor (winged) + feeling: 'winged speech', which appeals to the emotions)",
    english: 'poetry',
    swedish: 'poesi',
    norwegian: 'poesi',
    finnish: 'runous',
    hungarian: 'költészet, líra',
    german: 'Dichtung, Lyrik',
    dutch: 'poëzie',
    afrikaans: 'gedigte, poësie, digkuns',
    russian: 'поэзия',
    latvian: 'dzeja',
    polish: 'poezja',
    french: 'poésie',
    spanish: 'poesía',
  },
  {
    av: 16213,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(pointer + action indicator)',
    english: 'point, indicate-(to)',
    swedish: 'peka',
    norwegian: 'peke',
    finnish: 'osoittaa',
    hungarian: 'mutatni, megmutatni, rámutatni',
    german: 'zeigen, hinweisen',
    dutch: 'wijzen, aanwijzen',
    afrikaans: 'wys na, wys (om te)',
    russian: 'указывать, показывать',
    latvian: 'norādīt, rādīt',
    polish: 'wskazywać',
    french: 'pointer, montrer, viser',
    spanish: 'apuntar, indicar',
  },
  {
    av: 16214,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mind + position: rational position in regard to something)',
    english: 'point of view',
    swedish: 'ståndpunkt',
    norwegian: 'synspunkt, standpunkt',
    finnish: 'näkökanta, näkökohta',
    hungarian: 'álláspont, nézőpont',
    german: 'Standpunkt, Meinung',
    dutch: 'standpunt',
    afrikaans: 'standpunt, myns insiens',
    russian: 'точка зрения',
    latvian: 'uzskats, viedoklis',
    polish: 'stan wiedzy, punkt widzenia',
    french: 'point de vue, opinion',
    spanish: 'punto de vista',
  },
  {
    av: 16215,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical product + death: chemical product that kills)',
    english: 'poison',
    swedish: 'gift',
    norwegian: 'gift',
    finnish: 'myrkky',
    hungarian: 'méreg',
    german: 'Gift',
    dutch: 'vergif, gif',
    afrikaans: 'gif',
    russian: 'яд, отрава',
    latvian: 'inde',
    polish: 'trucizna',
    french: 'poison',
    spanish: 'veneno',
  },
  {
    av: 16216,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + cornmeal: dish made with cornmeal)',
    english: 'polenta',
    swedish: 'mat av majsmjöl, polenta',
    norwegian: 'maismelmat, polenta',
    finnish: 'polenta',
    hungarian: 'puliszka, kukoricakása',
    german: 'Polenta',
    dutch: 'polenta',
    afrikaans: 'polenta',
    russian: 'кукурузная каша',
    latvian: 'kukurūzas putra',
    polish: 'polenta (potrawa)',
    french: 'polenta',
    spanish: 'polenta',
  },
  {
    av: 16217,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + protection) Note: (The similarity between police and parent, and the lacking aspect of law enforcement, can be seen as problematic.)',
    english: 'police officer, policeman, policewoman',
    swedish: 'polis',
    norwegian: 'politi',
    finnish: 'poliisi',
    hungarian: 'rendőr',
    german: 'Polizist, Polizistin',
    dutch: 'politieman, agent',
    afrikaans: 'polisie beampte, polisieman, polisievrou',
    russian: 'полицейский',
    latvian: 'policists',
    polish: 'policjant, policjantka',
    french: 'police, officier de police',
    spanish: 'oficial de policía',
  },
  {
    av: 16218,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(waste + environment: waste products that spoil the environment)',
    english: 'pollution',
    swedish: 'förorening, miljöförstöring',
    norwegian: 'forurensning',
    finnish: 'saaste, saastuminen',
    hungarian: 'környezetszennyezés',
    german: 'Umweltverschmutzung',
    dutch: 'vervuiling',
    afrikaans: 'besoedeling',
    russian: 'загрязнение',
    latvian: 'piesārņojums',
    polish: 'zanieczyszczenie',
    french: 'pollution',
    spanish: 'polución',
  },
  {
    av: 16220,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + money + description indicator)',
    english: 'poor (little money)',
    swedish: 'fattig (utan pengar)',
    norwegian: 'fattig (uten penger)',
    finnish: 'köyhä, rahaton',
    hungarian: 'szegény, pénztelen',
    german: 'arm (wenig Geld)',
    dutch: 'arm (geen geld)',
    afrikaans: 'arm (geen min geld)',
    russian: 'бедный',
    latvian: 'nabadzīgs, nabadzīga',
    polish: 'biedny, ubogi (bez pieniędzy)',
    french: 'pauvre',
    spanish: 'pobre (escaso de dinero)',
  },
  {
    av: 16221,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(corn + to jump: corn that jumps as it cooks)',
    english: 'popcorn',
    swedish: 'popcorn',
    norwegian: 'popcorn',
    finnish: 'popcorn',
    hungarian: 'pattogatott kukorica, popcorn',
    german: 'Popcorn',
    dutch: 'popcorn',
    afrikaans: 'springmieles',
    russian: 'попкорн',
    latvian: 'kukurūzas pārslas, popkorns',
    polish: 'popcorn, prażona kukurydza',
    french: 'popcorn',
    spanish: 'palomitas de maíz',
  },
  {
    av: 16223,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + pig: food that comes from a pig. The symbol also can be explained as a combination of meat and pig.)',
    english: 'pork, ham',
    swedish: 'fläskkött',
    norwegian: 'flesk, svinekjøtt, skinke',
    finnish: 'sianliha, kinkku',
    hungarian: 'sertéshús, disznóhús, sonka',
    german: 'Schweinefleisch, Schweinekotelett',
    dutch: 'ham, varkensvlees',
    afrikaans: 'varkvleis ham',
    russian: 'свинина',
    latvian: 'cūkgaļa',
    polish: 'wieprzowina, mięso wieprzowe',
    french: 'porc (viande)',
    spanish: 'carne de cerdo, jamón',
  },
  {
    av: 16225,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(plus + intensity)',
    english: 'positive',
    swedish: 'gärna, positiv',
    norwegian: 'gjerne, positiv',
    finnish: 'positiivinen',
    hungarian: 'pozitív',
    german: 'positiv',
    dutch: 'positief',
    afrikaans: 'positief',
    russian: 'позитив',
    latvian: 'pozitīvs, labs, atbilstošs',
    polish: 'pozytywny, dobry, poprawny',
    french: 'positif',
    spanish: 'positiva, positivo',
  },
  {
    av: 16226,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(possibility + description before the fact indicator)',
    english: 'maybe, perhaps, possibly',
    swedish: 'kanske, möjligen, eventuellt',
    norwegian: 'kanskje, muligens',
    finnish: 'ehkä',
    hungarian: 'talán, esetleg',
    german: 'vielleicht, möglicherweise',
    dutch: 'misschien, wellicht',
    afrikaans: 'miskien, moontlik',
    russian: 'возможно',
    latvian: 'iespējams, iespējami',
    polish: 'być może, podobno (przypuszczenie), ewentualnie',
    french: 'peut-être, possiblement',
    spanish: 'tal vez, quizá, posiblemente',
  },
  {
    av: 16228,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + letter: building where mail is processed)',
    english: 'post office',
    swedish: 'postkontor',
    norwegian: 'posthus, postkontor',
    finnish: 'postitoimisto',
    hungarian: 'posta, postahivatal',
    german: 'Postamt',
    dutch: 'postkantoor',
    afrikaans: 'poskantoor',
    russian: 'почта, почтовое отделение',
    latvian: 'pasta nodaļa',
    polish: 'poczta (budynek poczty)',
    french: 'poste',
    spanish: 'oficina de correos',
  },
  {
    av: 16230,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vegetable below ground + white: starchy, white tuber)',
    english: 'potato',
    swedish: 'potatis',
    norwegian: 'potet',
    finnish: 'peruna',
    hungarian: 'burgonya, krumpli',
    german: 'Kartoffel',
    dutch: 'aardappel',
    afrikaans: 'aartappel',
    russian: 'картофель',
    latvian: 'kartupelis',
    polish: 'ziemniak',
    french: 'pomme de terre',
    spanish: 'patata',
  },
  {
    av: 16235,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to work + repetition + action indicator: to work at something repeatedly)',
    english: 'practise, practice, drill, exercise, rehearse-(to)',
    swedish: 'öva',
    norwegian: 'øve, drille, praktisere',
    finnish: 'harjoittaa, toimia, harjoitella',
    hungarian: 'gyakorolni, gyakorlatozni, próbálni',
    german: 'üben, proben',
    dutch: 'trainen, oefenen',
    afrikaans: 'oefen, oefening, repeteer (om te)',
    russian: 'упражняться, репитировать',
    latvian: 'vingrināties',
    polish: 'ćwiczenie',
    french: 'pratiquer, exercer, répéter',
    spanish: 'practicar, ejercitar, ensayar',
  },
  {
    av: 16236,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(prayer + action indicator)',
    english: 'pray-(to)',
    swedish: 'bedja',
    norwegian: 'be',
    finnish: 'rukoilla',
    hungarian: 'imádkozni',
    german: 'beten',
    dutch: 'bidden',
    afrikaans: 'bid (om te)',
    russian: 'молиться',
    latvian: 'skaitīt lūgšanas',
    polish: 'modlić się',
    french: 'prier',
    spanish: 'rezar, orar',
  },
  {
    av: 16237,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to speak + to + God: talking to God)',
    english: 'prayer',
    swedish: 'bön',
    norwegian: 'bønn',
    finnish: 'rukous',
    hungarian: 'ima',
    german: 'Gebet',
    dutch: 'gebed',
    afrikaans: 'gebed',
    russian: 'молитва',
    latvian: 'lūgšana',
    polish: 'modlitwa',
    french: 'prière',
    spanish: 'oración',
  },
  {
    av: 16238,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + prayer)',
    english: 'prayer book, Siddur',
    swedish: 'bönbok',
    norwegian: 'bønnebok',
    finnish: 'rukouskirja',
    hungarian: 'imakönyv',
    german: 'Gebetbuch',
    dutch: 'gebedenboek',
    afrikaans: 'gebedsboek',
    russian: 'молитвенник',
    latvian: 'lūgšanu grāmata',
    polish: 'modlitewnik, katechizm',
    french: 'livre de prières, missel, siddour',
    spanish: 'libro de oraciones',
  },
  {
    av: 16240,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(conception + woman)',
    english: 'pregnancy',
    swedish: 'graviditet, havandeskap',
    norwegian: 'graviditet',
    finnish: 'raskaus',
    hungarian: 'várandósság, terhesség',
    german: 'Schwangerschaft',
    dutch: 'zwangerschap',
    afrikaans: 'swangerskap',
    russian: 'беременность',
    latvian: 'grūtniecība',
    polish: 'ciąża',
    french: 'grossesse',
    spanish: 'embarazo',
  },
  {
    av: 16241,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(pregnancy + description indicator) SYMBOL SYNONYM',
    english: 'pregnant',
    swedish: 'gravid',
    norwegian: 'gravid',
    finnish: 'raskaana oleva',
    hungarian: 'várandós, terhes, állapotos, áldott állapotban lévő',
    german: 'schwanger, schwangere Frau',
    dutch: 'zwanger',
    afrikaans: 'swanger',
    russian: 'беременная',
    latvian: 'grūtniece',
    polish: 'być w ciąży',
    french: 'enceinte',
    spanish: 'embarazada',
  },
  {
    av: 16242,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      "(before + birth + description indicator: woman's condition before she bears a child) SYMBOL SYNONYM",
    english: 'pregnant (ckb)',
    swedish: 'gravid (CKB)',
    norwegian: 'gravid (OLD)',
    finnish: 'raskaana oleva',
    hungarian: 'várandós, terhes (régi CKB-jelkép)',
    german: 'schwanger, schwangere Frau',
    dutch: 'zwanger (CKB)',
    afrikaans: 'swanger (ckb)',
    russian: 'беременная',
    latvian: 'grūtniece, grūta sievietae',
    polish: 'być w ciąży (CKB)',
    french: 'enceinte (ckb)',
    spanish: 'embarazada (CKB)',
  },
  {
    av: 16243,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(birth + early)',
    english: 'premature birth',
    swedish: 'för tidig födsel',
    norwegian: 'for tidlig fødsel, prematur fødsel',
    finnish: 'ennenaikainen syntymä',
    hungarian: 'koraszülés',
    german: 'Frühgeburt',
    dutch: 'vroeggeboorte',
    afrikaans: 'voortydige, vroeg gebore',
    russian: 'преждевременные роды',
    latvian: 'priekšlaicīgas dzemdības',
    polish: 'poród przedwczesny, wcześniaczy',
    french: 'naissance prématurée',
    spanish: 'parto prematuro',
  },
  {
    av: 16244,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(preparation, readying, readiness, preparedness + action indicator: to do something in order to be ready for the future)',
    english: 'prepare, set, set up, ready, gear up, fix-(to)',
    swedish: 'förbereda',
    norwegian: 'forberede',
    finnish: 'valmistella, valmistautua',
    hungarian: 'előkészülni, -készíteni, felkészülni, -készíteni',
    german: 'vorbereiten',
    dutch: 'voorbereiden, klaarmaken (voor iets)',
    afrikaans: 'voorberei, regmaak, gereed maak, gereed kry (om te)',
    russian: 'подготовить(ся)',
    latvian: 'sagatavot',
    polish: 'przygotowywać się, być gotowym',
    french: 'préparer, anticiper',
    spanish: 'preparar, alistar, disponer',
  },
  {
    av: 16245,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(cooking, cookery, preparation (general) + action indicator)',
    english: 'prepare food, cook-(to)',
    swedish: 'laga mat, tillaga',
    norwegian: 'lage mat',
    finnish: 'laittaa ruokaa, valmistaa ruokaa',
    hungarian: 'főzni, ételt készíteni',
    german: 'kochen',
    dutch: 'koken, klaarmaken (eten)',
    afrikaans: 'voorberei kos, maak kos, kook (om te)',
    russian: 'готовить еду',
    latvian: 'gatavot ēdienu',
    polish: 'gotować, przygotowywać posiłek',
    french: 'préparer le repas, cuisiner',
    spanish: 'preparar comida, cocinar',
  },
  {
    av: 16247,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(fantasy + action indicator: to let one's mind soar into the sky, or up into the clouds)",
    english: 'pretend, make believe-(to)',
    swedish: 'låtsas, fantisera',
    norwegian: 'late som om, fantasere',
    finnish: 'olla olevinaan, kuvitella, uskotella',
    hungarian: 'színlelni, tettetni; úgy tenni, mintha',
    german: 'sich verstellen, so tun als ob, vorgeben',
    dutch: 'doen alsof, spelen (toneel)',
    afrikaans: 'voorgee toneelspel, fantaseer (om te)',
    russian: 'притворяться',
    latvian: 'izlikties',
    polish: 'udawać, pozorować',
    french: 'prétendre, feindre',
    spanish: 'pretender',
  },
  {
    av: 16250,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + barred window: building where people are put behind bars)',
    english: 'prison, jail',
    swedish: 'fängelse',
    norwegian: 'fengsel',
    finnish: 'vankila',
    hungarian: 'börtön, fogház, fogda, dutyi',
    german: 'Gefängnis',
    dutch: 'gevangenis',
    afrikaans: 'gevangenis, tronk',
    russian: 'тюрьма',
    latvian: 'cietums, ieslodzījums',
    polish: 'więzienie',
    french: 'prison',
    spanish: 'prisión, carcel',
  },
  {
    av: 16251,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to close + public + description indicator)',
    english: 'private',
    swedish: 'privat',
    norwegian: 'fortrolig, privat',
    finnish: 'yksityinen',
    hungarian: 'bizalmas, privát, magánjellegű, nem nyilvános',
    german: 'privat, persönlich',
    dutch: 'privé',
    afrikaans: 'privaat',
    russian: 'частный',
    latvian: 'personisks, privāts',
    polish: 'prywatny, osobisty',
    french: 'privé',
    spanish: 'privado',
  },
  {
    av: 16252,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(to doubt + plus + description before the fact indicator: in doubt, but tending towards the positive)',
    english: 'probable, likely, probably',
    swedish: 'trolig, tänkbar',
    norwegian: 'sannsynlig, trolig',
    finnish: 'todennäköinen',
    hungarian: 'valószínű, várható, feltehető, valószínűleg',
    german: 'wahrscheinlich',
    dutch: 'waarschijnlijk',
    afrikaans: 'waarskynlik, moontlik, moontlikheid',
    russian: 'вероятный',
    latvian: 'iespējams',
    polish: 'prawdopodobne, możliwe',
    french: 'probable',
    spanish: 'probable',
  },
  {
    av: 16253,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(question + difficult: difficult question to solve)',
    english: 'problem',
    swedish: 'problem',
    norwegian: 'problem',
    finnish: 'ongelma',
    hungarian: 'probléma',
    german: 'Problem',
    dutch: 'probleem',
    afrikaans: 'probleem',
    russian: 'проблема',
    latvian: 'problēma',
    polish: 'problem, zagadnienie',
    french: 'problème',
    spanish: 'problema',
  },
  {
    av: 16417,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(promise + action indicator: to say that something will be done in the future)',
    english: 'promise, pledge-(to)',
    swedish: 'lova',
    norwegian: 'love',
    finnish: 'luvata',
    hungarian: 'ígéret, fogadalom',
    german: 'versprechen, zusagen',
    dutch: 'beloven',
    afrikaans: 'belowe belofte eed af lê (om te)',
    russian: 'обещать',
    latvian: 'solīt',
    polish: 'obiecywać',
    french: 'promettre',
    spanish: 'prometer',
  },
  {
    av: 16418,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sexual intercourse + money)',
    english: 'prostitution',
    swedish: 'prostitution',
    norwegian: 'prostitusjon',
    finnish: 'prostituutio',
    hungarian: 'prostitúció',
    german: 'Prostitution',
    dutch: 'prostitutie',
    afrikaans: 'prostituut',
    russian: 'проституция',
    latvian: 'prostitūcija',
    polish: 'prostytucja',
    french: 'prostitution',
    spanish: 'prostitución',
  },
  {
    av: 16419,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(protection + action indicator)',
    english: 'protect, cover, shelter, take care of-(to)',
    swedish: 'skydda, beskydda',
    norwegian: 'beskytte, ta vare på, passe på',
    finnish: 'suojata, suojella, huolehtia',
    hungarian: 'védeni, megvédeni, oltalmazni, őrizni',
    german: 'beschützen',
    dutch: 'verzorgen, beschermen, ',
    afrikaans: 'bedek, beskerm, toemaak, versorg, skuil (om te)',
    russian: 'защищать',
    latvian: 'sargāt',
    polish: 'ochraniać, opiekować się',
    french: 'protéger, prendre soin de, couvrir',
    spanish: 'proteger, cubrir',
  },
  {
    av: 16421,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to say + against + action indicator)',
    english: 'protest, object, oppose-(to)',
    swedish: 'protestera, säga emot',
    norwegian: 'protestere, si imot',
    finnish: 'vastustaa, sanoa vastaan',
    hungarian: 'tiltakozni, ellenezni, ellenállni',
    german: 'protestieren',
    dutch: 'protesteren, weerstand bieden, verzetten tegen',
    afrikaans: 'protesteer, verset, teenstaan, weerbarstig (om te)',
    russian: 'протестовать',
    latvian: 'protestēt',
    polish: 'protestować, sprzeciwiać się (słownie)',
    french: 'protester',
    spanish: 'protestar, oponerse',
  },
  {
    av: 16422,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(feeling + above + description indicator)',
    english: 'proud',
    swedish: 'stolt, överlägsen',
    norwegian: 'stolt',
    finnish: 'ylpeä',
    hungarian: 'büszke, önhitt, öntelt',
    german: 'stolz, hochmütig, eingebildet',
    dutch: 'trots',
    afrikaans: 'trots',
    russian: 'гордый',
    latvian: 'lepns',
    polish: 'dumny',
    french: 'fier',
    spanish: 'orgullo',
  },
  {
    av: 16423,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + country)',
    english: 'province, county, region, state',
    swedish: 'landskap, län',
    norwegian: 'landsdel, fylke, region',
    finnish: 'osavaltio, maakunta, lääni',
    hungarian: 'megye, régió, tartomány, provincia',
    german: 'Provinz, Land',
    dutch: 'provincie, regio, streek',
    afrikaans: 'provinsie, streek, staat, land',
    russian: 'область, округ',
    latvian: 'novads, pagasts, reģions',
    polish: 'województwo, powiat, region państwa',
    french: 'province, comté, département, arrondissement, canton, région',
    spanish: 'provincia, región, estado, condado',
  },
  {
    av: 16425,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(awake + sexuality)',
    english: 'puberty',
    swedish: 'pubertet',
    norwegian: 'pubertet',
    finnish: 'puberteetti, murrosikä',
    hungarian: 'serdülés, serdülőkor, kamaszkor, pubertás',
    german: 'Pubertät, Geschlechtsreife',
    dutch: 'puberteit',
    afrikaans: 'puberteit',
    russian: 'половая зрелость',
    latvian: 'pubertāte',
    polish: 'dojrzewanie',
    french: 'puberté',
    spanish: 'pubertad',
  },
  {
    av: 16427,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(public + description indicator)',
    english: 'public (of the public)',
    swedish: 'allmän',
    norwegian: 'offentlig, allmenn',
    finnish: 'julkinen, yleinen',
    hungarian: 'nyilvános, közösségi (jelkép szinoníma)',
    german: 'öffentlich',
    dutch: 'openbaar',
    afrikaans: 'openbaar publiseer',
    russian: ' народный, всеобщий',
    latvian: 'sabiedrisks',
    polish: 'publicznie, na forum, na oczach ludzi',
    french: 'public (du public)',
    spanish: 'público (del público)',
  },
  {
    av: 16428,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(open + public + description indicator)',
    english: 'public (not private)',
    swedish: 'offentlig',
    norwegian: 'offentlig',
    finnish: 'julkinen, yleinen',
    hungarian: 'nyilvános, mindenki számára nyitott (jelkép szinoníma)',
    german: 'öffentlich',
    dutch: 'openbaar',
    afrikaans: 'openbaar (nie privaat)',
    russian: 'общественный‚ публичный',
    latvian: 'sabiedrības',
    polish: 'publiczny, otwarty',
    french: 'public (non privé)',
    spanish: 'público (no privado)',
  },
  {
    av: 16429,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(many + many + person: large group of people)',
    english: 'public (the public)',
    swedish: 'allmänheten, folk',
    norwegian: 'allmennheten, folk',
    finnish: 'kansa, väki, yleisö',
    hungarian: 'nyilvánosság, közönség',
    german: 'Öffentlichkeit',
    dutch: 'publiek (mensen)',
    afrikaans: 'publiek (mense)',
    russian: 'народ, общественность',
    latvian: 'tauta, ļaudis',
    polish: 'publiczność, tłum, duża grupa ludzi',
    french: 'public (le)',
    spanish: 'público (el público)',
  },
  {
    av: 16431,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(pull, pulling + action indicator: the forward moving arrow seems to be pulling the thing)',
    english: 'pull, drag, tow, tug-(to)',
    swedish: 'dra',
    norwegian: 'dra, trekke',
    finnish: 'vetää',
    hungarian: 'húzni, vontatni',
    german: 'ziehen',
    dutch: 'trekken, slepen',
    afrikaans: 'trek sleep tou (om te)',
    russian: 'тянуть',
    latvian: 'vilkt, stumt, grūst',
    polish: 'ciągnąć, przeciągać, pociągać',
    french: 'tirer, traîner',
    spanish: 'tirar',
  },
  {
    av: 16432,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(point + action indicator)',
    english: 'puncture, prick-(to)',
    swedish: 'sticka, sticka hål, punktera',
    norwegian: 'punktere, stikke',
    finnish: 'pistää',
    hungarian: '',
    german: 'durchstechen, perforieren, durchlöchern',
    dutch: 'prikken',
    afrikaans: 'prik (om te)',
    russian: 'прокалывать, уколоть',
    latvian: 'durt, caurdurt',
    polish: 'kłuć, nakłuwać, przekłuwać',
    french: 'piquer',
    spanish: 'pinchar',
  },
  {
    av: 16433,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(doll + hand: doll manipulated by the hand)',
    english: 'puppet',
    swedish: 'handdocka',
    norwegian: 'hånddukke',
    finnish: 'käsinukke',
    hungarian: 'báb, bábu',
    german: 'Handpuppe, Kasperlepuppe',
    dutch: 'pop',
    afrikaans: 'pop',
    russian: 'тряпичная кукла',
    latvian: 'auduma lelle',
    polish: 'marionetka, pacynka',
    french: 'marionnette',
    spanish: 'títere',
  },
  {
    av: 16434,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dog + baby)',
    english: 'puppy',
    swedish: 'valp',
    norwegian: 'valp',
    finnish: 'koiranpentu',
    hungarian: 'kutyakölyök, kölyökkutya, kiskutya',
    german: 'junger Hund',
    dutch: 'puppy',
    afrikaans: 'hondjie',
    russian: 'щенок',
    latvian: 'kucēns',
    polish: 'szczenię, szczeniak',
    french: 'chiot',
    spanish: 'cachorro',
  },
  {
    av: 16435,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(holiday + megillah: the holiday on which megillah or story of Esther is read)',
    english: 'Purim',
    swedish: 'Purim (Israel)',
    norwegian: 'Purim (Israel)',
    finnish: 'purim',
    hungarian: 'Purim (héber)',
    german: 'Purimfest, Purim',
    dutch: 'Purim (Joods)',
    afrikaans: 'Purim',
    russian: 'пурим (Израиль)',
    latvian: 'Purima svētki (Izraēla)',
    polish: 'Purim (święto hebr.)',
    french: 'fête de Pourim (judaïsme)',
    spanish: 'Purim',
  },
  {
    av: 16436,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation:
      '(colour + mouth + sky: combination of red and blue) (BCI) SYMBOL SYNONYM',
    english: 'purple, violet (bci)',
    swedish: 'lila',
    norwegian: 'lilla',
    finnish: 'purppuranpunainen, lila',
    hungarian: 'lila, violaszínű',
    german: 'lila',
    dutch: 'purper (BCI), violet (BCI)',
    afrikaans: 'pers violet (bci)',
    russian: 'фиолетовый',
    latvian: 'violets',
    polish: 'purpura, fiolet (BCI)',
    french: 'violet, pourpre (bci)',
    spanish: 'púrpura, violeta (BCI)',
  },
  {
    av: 16438,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + money + person: personal container for money)',
    english: 'purse, pocketbook, wallet',
    swedish: 'plånbok, portmonnä',
    norwegian: 'portemoné, lommebok, pung',
    finnish: 'lompakko',
    hungarian: 'pénztárca, tárca, erszény',
    german: 'Brieftasche',
    dutch: 'portemonnee, portefeuille',
    afrikaans: 'beursie',
    russian: 'кошелёк',
    latvian: 'maks, maciņš',
    polish: 'portfel, portmonetka',
    french: 'porte-monnaie, bourse',
    spanish: 'bolso, monedero, cartera',
  },
  {
    av: 16439,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(push, pushing + action indicator: the forward moving arrow seems to be pushing the thing)',
    english: 'push, shove-(to)',
    swedish: 'knuffa, skjuta på',
    norwegian: 'skyve, dytte',
    finnish: 'työntää',
    hungarian: 'tolni, eltolni, lökni',
    german: 'schieben, drücken, stoßen, schubsen',
    dutch: 'duwen',
    afrikaans: 'stoot skuif (om te)',
    russian: 'толкать',
    latvian: 'grūst, stumt',
    polish: 'popychać, pchać, przepychać',
    french: 'pousser',
    spanish: 'empujar',
  },
  {
    av: 16440,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(place + action indicator)',
    english: 'put, locate, place-(to)',
    swedish: 'lägga, ställa, sätta',
    norwegian: 'legge, sette',
    finnish: 'panna, asettaa',
    hungarian: 'tenni, rátenni, helyezni, elhelyezni, ráhelyezni',
    german: 'setzen, stellen, legen',
    dutch: 'plaatsen op, leggen',
    afrikaans: 'neersit plaas (om te)',
    russian: 'класть‚ ставить‚ положить',
    latvian: 'likt, nolikt, novietot',
    polish: 'ustawiać, lokować, umiejscawiać',
    french: 'poser, mettre',
    spanish: 'poner, ponerse',
  },
  {
    av: 16441,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(picture + piece: picture made from many pieces)',
    english: 'jigsaw puzzle',
    swedish: 'pussel',
    norwegian: 'puslespill',
    finnish: 'palapeli',
    hungarian: 'kirakós játék, mozaikjáték, mozaikrejtvény, puzzle',
    german: 'Puzzle',
    dutch: 'puzzel',
    afrikaans: 'legkaart',
    russian: 'пазл',
    latvian: 'puzle',
    polish: 'układanka, puzzle',
    french: 'puzzle',
    spanish: 'puzzle de piezas, rompecabeza',
  },
  {
    av: 16442,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + to sleep)',
    english: 'pyjama(s), nightgown, nightie, pajama(s)',
    swedish: 'nattdräkt, nattlinne, pyjamas',
    norwegian: 'pysjamas, nattdrakt',
    finnish: 'pyjama, yöpuku',
    hungarian: 'pizsama, hálóing, hálóruha, hálóköntös',
    german: 'Schlafanzug, Nachthemd',
    dutch: 'pyjama, slaapkleding (Vl), nachtkleed',
    afrikaans: 'slaapklere',
    russian: 'пижама, ночная сорочка',
    latvian: 'pidžama, naktskrekls',
    polish: 'piżama, koszula nocna',
    french: 'pyjama, chemise de nuit',
    spanish: 'pijama, ropa para dormir',
  },
  {
    av: 16446,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(quickness, rapidity, speediness + description indicator)',
    english: 'quick, fast, quickly, rapid, rapidly',
    swedish: 'fort, snabb',
    norwegian: 'hurtig, rask',
    finnish: 'nopea, nopeasti',
    hungarian: 'gyors, gyorsan, sebes, sebesen, fürge, fürgén',
    german: 'schnell',
    dutch: 'snel, vlug',
    afrikaans: 'vinnig, snel, vlugtig',
    russian: 'быстрый',
    latvian: 'ātrs',
    polish: 'szybko, prędko',
    french: 'rapide',
    spanish: 'rápido',
  },
  {
    av: 16447,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(minus + loud + description indicator: absence of noise)',
    english: 'quiet, quietly',
    swedish: 'tyst, ljudlös',
    norwegian: 'rolig, lydløs',
    finnish: 'hiljainen',
    hungarian: 'halk, halkan, csendes, csendesen, zajtalan/ul',
    german: 'ruhig, leise',
    dutch: 'rustig',
    afrikaans: 'stil, saggies, rustig',
    russian: 'тихий, бесшумный',
    latvian: 'kluss, klusi',
    polish: 'cicho',
    french: 'tranquille, silencieux',
    spanish: 'tranquilo',
  },
  {
    av: 16448,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rodent + ear: animal known for its long ears)',
    english: 'rabbit, hare',
    swedish: 'hare, kanin',
    norwegian: 'hare, kanin',
    finnish: 'jänis, kaniini',
    hungarian: 'nyúl',
    german: 'Hase, Kaninchen',
    dutch: 'haas',
    afrikaans: 'haas, konyn',
    russian: 'заяц‚ кролик',
    latvian: 'trusis, zaķis',
    polish: 'królik, zając',
    french: 'lapin, lièvre',
    spanish: 'conejo',
  },
  {
    av: 16449,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(illness + animal + comma + to bite: viral nervous system illness of animals (including humans), usually spread by bite of infected animal)',
    english: 'rabies',
    swedish: 'rabies',
    norwegian: 'hundegalskap, rabies',
    finnish: 'vesikauhu',
    hungarian: 'veszettség, rábiesz',
    german: 'Tollwut',
    dutch: 'hondsdolheid',
    afrikaans: 'hondsdolheid',
    russian: 'бешенство',
    latvian: 'trakumsērga',
    polish: 'wścieklizna, wodowstręt',
    french: 'rage',
    spanish: 'rabia',
  },
  {
    av: 16450,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + mask (disguise): animal with a dark band across the eyes, which resembles a mask)',
    english: 'raccoon',
    swedish: 'tvättbjörn',
    norwegian: 'vaskebjørn',
    finnish: 'pesukarhu',
    hungarian: 'mosómedve',
    german: 'Waschbär',
    dutch: 'wasbeer',
    afrikaans: 'wasbeer',
    russian: 'енот',
    latvian: 'jenots',
    polish: 'szop pracz (zwierzę)',
    french: 'raton laveur',
    spanish: 'mapache',
  },
  {
    av: 16453,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure + ear + electricity: box for hearing by means of electricity) SYMBOL SYNONYM',
    english: 'radio (1)',
    swedish: 'radio (1)',
    norwegian: 'radio (1)',
    finnish: 'radio',
    hungarian: 'rádió',
    german: 'Radio (1)',
    dutch: 'radio (1)',
    afrikaans: 'radio (1)',
    russian: 'радио (1)',
    latvian: 'radio (1)',
    polish: 'radio',
    french: 'radio (1)',
    spanish: 'radio (1)',
  },
  {
    av: 16454,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(vegetable (large-leafed) + hot: large-leafed vegetable with a hot-tasting, edible root)',
    english: 'radish',
    swedish: 'rädisa',
    norwegian: 'reddik',
    finnish: 'retiisi',
    hungarian: 'retek',
    german: 'Radieschen',
    dutch: 'radijs',
    afrikaans: 'radys',
    russian: 'редис',
    latvian: 'redīsi',
    polish: 'rzodkiew, rzodkiewka',
    french: 'radis',
    spanish: 'rábano',
  },
  {
    av: 16456,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(rain + action indicator)',
    english: 'rain-(to)',
    swedish: 'regna',
    norwegian: 'regne',
    finnish: 'sataa',
    hungarian: 'esni (eső), esőzni',
    german: 'regnen',
    dutch: 'regenen',
    afrikaans: 'reën (om te)',
    russian: 'дождь идёт',
    latvian: 'līt',
    polish: 'pada deszcz (czasownik)',
    french: 'pleuvoir',
    spanish: 'llover',
  },
  {
    av: 16457,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + rain)',
    english: 'raincoat',
    swedish: 'regnkläder',
    norwegian: 'regntøy, regnklær',
    finnish: 'sadetakki',
    hungarian: 'esőkabát, esőköpeny, vízálló öltözék',
    german: 'Regenmantel',
    dutch: 'regenkleding, regenjas',
    afrikaans: 'reënjas',
    russian: 'дождевик',
    latvian: 'lietusmētelis',
    polish: 'płaszcz przeciwdeszczowy',
    french: 'vêtement de pluie, imperméable',
    spanish: 'impermeable',
  },
  {
    av: 16458,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(rain + description indicator)',
    english: 'rainy',
    swedish: 'regnig',
    norwegian: 'regnfull',
    finnish: 'sateinen',
    hungarian: 'esős',
    german: 'regnerisch',
    dutch: 'regenachtig',
    afrikaans: 'reënerig',
    russian: 'дождливый',
    latvian: 'lietains',
    polish: 'deszczowy, dżdżysty',
    french: 'pluvieux',
    spanish: 'lluvioso',
  },
  {
    av: 16459,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cause + to grow + action indicator)',
    english: 'raise, grow, bring up, cultivate-(to)',
    swedish: 'odla',
    norwegian: 'dyrke',
    finnish: 'kasvattaa, viljellä, kasvaa',
    hungarian: 'termelni, növeszteni, földet művelni',
    german: 'anbauen, anpflanzen, aufziehen',
    dutch: 'groeien',
    afrikaans: 'kultiveer, groei (om te)',
    russian: 'выращивать',
    latvian: 'audzēt',
    polish: 'hodować, uprawiać (o roślinach)',
    french: 'cultiver, faire pousser',
    spanish: 'cultivar',
  },
  {
    av: 16461,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(comb + garden)',
    english: 'rake',
    swedish: 'kratta',
    norwegian: 'rake, rive',
    finnish: 'harava',
    hungarian: 'gereblye',
    german: 'Rechen, Harke',
    dutch: 'hark',
    afrikaans: 'hark',
    russian: 'грабли',
    latvian: 'grābeklis',
    polish: 'grabie',
    french: 'râteau',
    spanish: 'rastrillo',
  },
  {
    av: 16462,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(assault + sexual intercourse)',
    english: 'rape',
    swedish: 'våldtäkt',
    norwegian: 'voldtekt',
    finnish: 'raiskaus',
    hungarian: 'megerőszakolás, erőszakos nemi közösülés',
    german: 'Vergewaltigung',
    dutch: 'verkrachting',
    afrikaans: 'verkrag, verkragting',
    russian: 'изнасилование',
    latvian: 'izvarot, izvarošana',
    polish: 'gwałt',
    french: 'viol',
    spanish: 'violación',
  },
  {
    av: 16464,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + to cook + description indicator)',
    english: 'raw, uncooked',
    swedish: 'rå, okokt',
    norwegian: 'rå, ukokt',
    finnish: 'raaka, keittämätön',
    hungarian: 'nyers, főtlen, sületlen',
    german: 'roh, ungekocht',
    dutch: 'rauw',
    afrikaans: 'rou ongekook',
    russian: 'сырой',
    latvian: 'jēls, negatavs',
    polish: 'surowe, niedogotowane',
    french: 'cru',
    spanish: 'crudo',
  },
  {
    av: 16465,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(reading + action indicator: to see and perceive what is written on the printed page)',
    english: 'read-(to)',
    swedish: 'läsa',
    norwegian: 'lese',
    finnish: 'lukea',
    hungarian: 'olvasni, elolvasni, felolvasni, átolvasni, kiolvasni',
    german: '(vor)lesen',
    dutch: 'lezen',
    afrikaans: 'lees (om te)',
    russian: 'читать',
    latvian: 'lasīt',
    polish: 'czytać',
    french: 'lire',
    spanish: 'leer',
  },
  {
    av: 16466,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to prepare + description after the fact indicator)',
    english: 'ready, prepared',
    swedish: 'förberedd',
    norwegian: 'klar, forberedt',
    finnish: 'valmis',
    hungarian: 'felkészült, előkészült, valamire kész',
    german: 'fertig, vorbereitet',
    dutch: 'klaar, af (klaar), gedaan',
    afrikaans: 'gereed voorberei gedaan klaar',
    russian: 'готовый',
    latvian: 'gatavs',
    polish: 'szykować cię, przygotowywać',
    french: 'prêt',
    spanish: 'listo',
  },
  {
    av: 16467,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(event, happening, occasion + description indicator: existing on earth)',
    english: 'real, really',
    swedish: 'verklig',
    norwegian: 'virkelig',
    finnish: 'todellinen',
    hungarian: 'valódi, valóságos, valóban',
    german: 'wirklich',
    dutch: 'werkelijk',
    afrikaans: 'rêrig, regtig, waarlik, werklik',
    russian: 'настоящий‚ реальный',
    latvian: 'īsts, reāls',
    polish: 'prawdziwy, rzeczywisty, naprawdę',
    french: 'vrai, véritable, réel',
    spanish: 'real',
  },
  {
    av: 16468,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(past + near + description indicator: in the near past)',
    english: 'recent, recently',
    swedish: 'nyss, nyligen',
    norwegian: 'nylig',
    finnish: 'äsken, hiljattain, äskeinen',
    hungarian: 'nemrégi, nemrégiben, minap, nemrégiben',
    german: 'neulich, kürzlich',
    dutch: 'pas, kortgeleden',
    afrikaans: 'pas, onlangs',
    russian: 'недавно',
    latvian: 'nesen',
    polish: 'niedawno',
    french: 'récent',
    spanish: 'reciente',
  },
  {
    av: 16469,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(page + to prepare food: written instructions for cooking)',
    english: 'recipe',
    swedish: 'recept',
    norwegian: 'oppskrift',
    finnish: 'resepti, ruokaohje',
    hungarian: 'ételrecept, konyhai recept',
    german: 'Kochrezept',
    dutch: 'recept',
    afrikaans: 'resep',
    russian: 'рецепт',
    latvian: 'recepte (ediena)',
    polish: 'przepis na coś, recepta',
    french: 'recette de cuisine',
    spanish: 'receta',
  },
  {
    av: 16470,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(recording disk + ear: represents music or sound in general, recorded on any kind of disk medium)',
    english: 'CD, record',
    swedish: 'cd-skiva, grammofonskiva',
    norwegian: 'CD-plate, grammofonplate',
    finnish: 'äänilevy, CD-levy',
    hungarian: 'CD, lemez, hanglemez, korong',
    german: 'CD, Schallplatte',
    dutch: 'CD (audio), fonoplaat',
    afrikaans: 'CD, rekord, plaat',
    russian: 'компакт-диск, пластинка',
    latvian: 'CD disks',
    polish: 'audio CD, płyta audio, płyta CD z muzyką',
    french: 'disque de musique, CD, disque compact',
    spanish: 'disco compacto, disco, CD',
  },
  {
    av: 16471,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + record)',
    english: 'CD player, record player, stereo',
    swedish: 'cd-spelare, skivspelare',
    norwegian: 'CD-spiller, platespiller',
    finnish: 'levysoitin, CD-soitin',
    hungarian: 'lemezjátszó',
    german: 'CD-Spieler, Plattenspieler, Schallplattenspieler',
    dutch: 'CD speler, stereo-installatie',
    afrikaans: 'CD speler, plate speler, stereo',
    russian: 'проигрыватель, CD-плеер',
    latvian: 'mūzikas centrs',
    polish: 'odtwarzacz CD, odtwarzacz muzyki',
    french: 'tourne-disque, lecteur de disque compact, lecteur CD',
    spanish: 'tocadiscos, reproductor de CD',
  },
  {
    av: 16472,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + rectangular shape [as of card]: rectangle, a geometric shape)',
    english: 'rectangle, oblong (shape)',
    swedish: 'rektangel',
    norwegian: 'rektangel',
    finnish: 'suorakulmio',
    hungarian: 'téglalap',
    german: 'Rechteck',
    dutch: 'rechthoek',
    afrikaans: 'reghoek',
    russian: 'прямоугольник',
    latvian: 'taisnstūris',
    polish: 'prostokąt, podłużny (kształt)',
    french: 'rectangle (figure géométrique)',
    spanish: 'rectángulo',
  },
  {
    av: 16473,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(rectangle + description indicator)',
    english: 'rectangular, oblong',
    swedish: 'rektangulär, avlång',
    norwegian: 'rektangulær, avlang',
    finnish: 'suorakulmainen, nelikulmainen',
    hungarian: 'téglalap alakú',
    german: 'rechteckig',
    dutch: 'rechthoekig',
    afrikaans: 'reghoekig, langwerpig',
    russian: 'прямоугольный',
    latvian: 'taisnstūra',
    polish: 'prostokątny, podłużny',
    french: 'rectangulaire, oblong',
    spanish: 'rectangular',
  },
  {
    av: 16474,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + mouth) (BCI) SYMBOL SYNONYM',
    english: 'red (bci)',
    swedish: 'röd',
    norwegian: 'rød',
    finnish: 'punainen',
    hungarian: 'piros, vörös',
    german: 'rot',
    dutch: 'rood (BCI)',
    afrikaans: 'rooi (bci)',
    russian: 'красный',
    latvian: 'sarkans',
    polish: 'czerwony (BCI)',
    french: 'rouge (bci)',
    spanish: 'rojo (BCI)',
  },
  {
    av: 16475,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + 1) (CKB) SYMBOL SYNONYM',
    english: 'red (ckb)',
    swedish: 'röd (CKB)',
    norwegian: 'rød (CKB)',
    finnish: 'punainen',
    hungarian: 'piros, vörös (régi CKB-jelkép)',
    german: 'rot',
    dutch: 'rood (CKB)',
    afrikaans: 'rooi (ckb)',
    russian: 'красный (Ч.Б.)',
    latvian: 'sarkans, sarkana',
    polish: 'czerwony (CKB)',
    french: 'rouge (ckb)',
    spanish: 'rojo (CKB)',
  },
  {
    av: 16477,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(sorry + action indicator: to feel sorry about something that occurred in the past)',
    english: 'regret-(to)',
    swedish: 'ångra',
    norwegian: 'angre, beklage',
    finnish: 'katua, olla pahoillaan',
    hungarian: 'megbánni, sajnálni, sajnálkozni',
    german: 'bedauern, bereuen',
    dutch: 'betreuren',
    afrikaans: 'spyt (om te)',
    russian: 'сожалеть',
    latvian: 'nožēlot',
    polish: 'żałować, mieć żal, ubolewać',
    french: 'regretter',
    spanish: 'lamentarse',
  },
  {
    av: 16478,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cervine + north: animal common to Northern regions)',
    english: 'reindeer, caribou',
    swedish: 'ren (djuret)',
    norwegian: 'reinsdyr',
    finnish: 'poro, peura',
    hungarian: 'rénszarvas',
    german: 'Ren, Rentier',
    dutch: 'rendier',
    afrikaans: 'takbok',
    russian: 'северный олень',
    latvian: 'ziemeļbriedis',
    polish: 'renifer, karibu',
    french: 'renne, caribou',
    spanish: 'reno',
  },
  {
    av: 16486,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + to remember)',
    english: 'remembrance day',
    swedish: 'minnesdag',
    norwegian: 'minnedag',
    finnish: 'muistamispäivä',
    hungarian: 'Az Emlékezet Napja',
    german: 'Gedächtnis, Memorial Day',
    dutch: 'herdenkingsdag',
    afrikaans: 'herdenkingsdag',
    russian: 'день памяти',
    latvian: 'piemiņas diena',
    polish: 'Dzień Pamięci',
    french: 'journée du souvenir, jour du Souvenir',
    spanish: 'día del recuerdo',
  },
  {
    av: 16487,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(repetition, copying, duplication, replication + action indicator: the line is repeated)',
    english: 'repeat, copy, duplicate, reproduce-(to)',
    swedish: 'upprepa, kopiera',
    norwegian: 'gjenta, kopiere',
    finnish: 'toistaa, kopioida, monistaa, toistua',
    hungarian: 'ismételni, megismételni, másolni, reprodukálni',
    german: 'wiederholen, kopieren',
    dutch: 'kopiëren, herhalen',
    afrikaans: 'kopieër, dupliseer, afskrif, herhaal, herproduseer (om te)',
    russian: 'повторять, копировать',
    latvian: 'atkārtot, kopēt, dublēt, reproducēt',
    polish: 'powtarzać, kopiować, ponawiać',
    french: 'copier, reproduire, répéter, dupliquer',
    spanish: 'repetir, copiar, reproducir',
  },
  {
    av: 16488,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(conception + to cause + baby)',
    english: 'reproduction',
    swedish: 'fortplantning',
    norwegian: 'formering, forplantning',
    finnish: 'lisääntyminen',
    hungarian: 'szaporodás, utódok létrehozása',
    german: 'Fortpflanzung',
    dutch: 'voortplanting',
    afrikaans: 'voortplanting, reproduseer',
    russian: 'размножение',
    latvian: 'reprodukcija',
    polish: 'reprodukcja, rozmnażanie',
    french: 'reproduction',
    spanish: 'reproducción',
  },
  {
    av: 16489,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to ask + please + action indicator: to ask politely)',
    english: 'request-(to)',
    swedish: 'be om, begära',
    norwegian: 'be om',
    finnish: 'pyytää',
    hungarian: 'kérni, megkérni, kérelmezni',
    german: 'bitten',
    dutch: 'verzoeken',
    afrikaans: 'versoek, vra (om te)',
    russian: 'просить',
    latvian: 'lūgt',
    polish: 'prosić',
    french: 'demander, requérir, solliciter',
    spanish: 'solicitar, pedir',
  },
  {
    av: 16490,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(feeling + against + action indicator: to harbour feelings against someone or something)',
    english: 'resent-(to)',
    swedish: 'ta illa upp',
    norwegian: 'ergre seg, ta ille opp',
    finnish: 'harmittaa',
    hungarian: 'neheztelni, rossznéven venni, zokon venni',
    german: 'übelnehmen, sich ärgern über, ärgern',
    dutch: 'kwalijk nemen',
    afrikaans: 'aanstoot neem, kwalik neem (om te)',
    russian: 'обижаться, возмущаться',
    latvian: 'apvainoties, ņemt ļaunā',
    polish: 'obrażać',
    french: 'en vouloir, éprouver de la rancune',
    spanish: 'resentirse, estar resentido',
  },
  {
    av: 16491,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + house: person who lives in a house)',
    english: 'resident',
    swedish: 'boende, bofast person',
    norwegian: 'beboer',
    finnish: 'asukas',
    hungarian: 'lakos, lakó, rezidens, bennlakó',
    german: 'Bewohner, Bewohnerin',
    dutch: 'bewoner',
    afrikaans: 'inwoner',
    russian: 'житель',
    latvian: 'iedzīvotājs',
    polish: 'mieszkaniec, rezydent',
    french: 'résident',
    spanish: 'residente',
  },
  {
    av: 16492,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + many + person: house in which a group of people live)',
    english: 'residential institution, group home, hostel, residential home',
    swedish: 'gruppbostad, elevhem, internat',
    norwegian: 'internat, gruppebolig, hostel',
    finnish: 'asuntola',
    hungarian: 'lakóotthon, csoportotthon, bentlakásos intézmény',
    german: 'Wohnheim, Wohneinrichtung',
    dutch: 'tehuis, internaat ',
    afrikaans: 'residensie instituut, groep koshuis kwartiere huis',
    russian: 'интернат',
    latvian: 'apdzīvojama vieta, telpa, māja, rajons',
    polish: 'internat, dom grupowy, grupowy dom rodzinny',
    french: 'institution résidentielle, établissement de logement, home, internat',
    spanish: 'institución residencial, albergue juvenil',
  },
  {
    av: 16493,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(building + for (the purpose of) + to exchange + knowledge: building where knowledge is given out and received)',
    english: 'resource centre',
    swedish: 'resurscenter',
    norwegian: 'ressurssenter',
    finnish: 'resurssikeskus',
    hungarian: 'forrásközpont, művelődési/továbbképző központ',
    german: 'Ressourcenzenter',
    dutch: 'onderzoekcentrum',
    afrikaans: 'hullpbronsentrum, hulpmiddelsentrum',
    russian: 'ресурсный центр',
    latvian: 'resursu centrs',
    polish: 'centrum zasobów (wymiany wiedzy)',
    french: "centre de ressources, centre de documentation, centre d'échange",
    spanish: 'centro de recursos',
  },
  {
    av: 16494,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + about + person + superior: feeling one has about a person who is superior)',
    english: 'respect, admiration',
    swedish: 'beundran, respekt',
    norwegian: 'respekt, beundring',
    finnish: 'kunnioitus, ihailu',
    hungarian: 'tisztelet, csodálat',
    german: 'Achtung, Respekt, Bewunderung',
    dutch: 'respect',
    afrikaans: 'respekteer, admireer',
    russian: 'уважать, почитать',
    latvian: 'cienīt, apbrīnot',
    polish: 'respekt, podziw dla kogoś/ czegoś',
    french: 'respect, admiration',
    spanish: 'respeto, admiración',
  },
  {
    av: 16496,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(rest + action indicator)',
    english: 'rest-(to)',
    swedish: 'vila (verb)',
    norwegian: 'hvile (å)',
    finnish: 'levätä',
    hungarian: 'pihenni, nyugalomban/kényelemben lenni',
    german: 'ausruhen, ruhen, entspannen',
    dutch: 'uitrusten, rusten',
    afrikaans: 'rus (om te)',
    russian: 'отдыхать',
    latvian: 'atpūsties',
    polish: 'odpoczywać, wypoczywać, relaksować się',
    french: 'reposer-(se)',
    spanish: 'descansar',
  },
  {
    av: 16497,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limited time + rest)',
    english: 'rest period, break',
    swedish: 'rast, paus',
    norwegian: 'hvilestund, pause',
    finnish: 'tauko, välitunti',
    hungarian: 'szünet, pihenő',
    german: 'Pause, Ruhepause, Unterbrechung',
    dutch: 'pauze, rust, speeltijd',
    afrikaans: 'rus periode breek speeltyd pouse ruskans',
    russian: 'перерыв',
    latvian: 'atpūtas brīdis, starpbrīdis',
    polish: 'przerwa, czas na odpoczynek',
    french: 'pause, période de repos',
    spanish: 'periodo de descanso',
  },
  {
    av: 16498,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(public room + to eat)',
    english: 'restaurant, cafeteria',
    swedish: 'restaurang, matställe',
    norwegian: 'restaurant, kafeteria',
    finnish: 'ravintola',
    hungarian: 'étterem, vendéglő, étkező',
    german: 'Restaurant, Gaststätte, Café',
    dutch: 'restaurant',
    afrikaans: 'restaurant, kafeteria',
    russian: 'ресторан, кафетерий',
    latvian: 'restorāns, kafejnīca',
    polish: 'restauracja, bar (z jedzeniem)',
    french: 'restaurant, cafétaria, cantine, mess',
    spanish: 'restaurante',
  },
  {
    av: 16500,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(return + action indicator)',
    english: 'return, come back, reverse-(to)',
    swedish: 'komma tillbaka, återvända',
    norwegian: 'komme tilbake',
    finnish: 'tulla takaisin, palata',
    hungarian: 'visszatérni, tolatni',
    german: 'zurückkehren, umkehren',
    dutch: 'terugkomen, terugkeren',
    afrikaans: 'terugkom, terugdraai, terugkeer, omdraai, tru (om te)',
    russian: 'возвращать(ся), вернуть(ся)',
    latvian: 'atgriesties, atnākt atpakaļ',
    polish: 'wracać, powracać, przybywać z powrotem',
    french: 'retourner, revenir',
    spanish: 'volver, devolver',
  },
  {
    av: 16502,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(similar sound + end: the effect produced when words have a similar sound. The symbol applies particularly to ends of lines of poetry.)',
    english: 'rhyme',
    swedish: 'rim',
    norwegian: 'rim',
    finnish: 'riimi',
    hungarian: 'rím',
    german: 'Reim',
    dutch: 'rijm',
    afrikaans: 'rym',
    russian: 'рифма',
    latvian: 'atskaņa, ritms',
    polish: 'rym',
    french: 'rime, vers',
    spanish: 'rima',
  },
  {
    av: 16503,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(birth control + month: birth control based upon a woman’s monthly cycle)',
    english: 'rhythm method',
    swedish: 'säker period',
    norwegian: 'sikker periode',
    finnish: 'varmat päivät',
    hungarian: 'fogamzásgátlás: biológiai, számolásos',
    german: 'Knaus-Ogino-Methode (Empfängnisverhütung)',
    dutch: 'periodieke onthouding',
    afrikaans: 'gesinsbeplanning ritme metode',
    russian: 'безопасный период цикла',
    latvian: 'menstruālā cikla (pret) apaugļošanās metode',
    polish: 'kalendarzyk małżeński (naturalna metoda planowania ciąży)',
    french: 'méthode contraceptive naturelle ogino',
    spanish: 'método de ritmo',
  },
  {
    av: 16504,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + cloth + thing indicator)',
    english: 'ribbon, tape',
    swedish: 'band, remsa',
    norwegian: 'bånd',
    finnish: 'nauha (kangas)',
    hungarian: 'szalag, pántlika',
    german: 'Band',
    dutch: 'lint',
    afrikaans: 'lint kleeflint',
    russian: 'лента, тесьма',
    latvian: 'lente, lenta',
    polish: 'wstążka, taśma z materiału, tkaniny',
    french: 'ruban',
    spanish: 'cinta',
  },
  {
    av: 16506,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(taste + intensity + description indicator)',
    english: 'rich (taste)',
    swedish: 'läcker',
    norwegian: 'smakfull (mat)',
    finnish: 'herkullinen, täyteläinen',
    hungarian: 'ízes, jóízű, finom',
    german: 'aromatisch',
    dutch: 'lekker',
    afrikaans: 'ryk smaak smaaklik (proe)',
    russian: 'вкусный',
    latvian: 'bagātīga (garša)',
    polish: 'głęboki, intensywny, bogaty (smak)',
    french: 'riche (en goût), savoureux, goûteux',
    spanish: 'rico (sabor)',
  },
  {
    av: 16507,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(much + money + description indicator)',
    english: 'rich, wealthy',
    swedish: 'rik',
    norwegian: 'rik',
    finnish: 'rikas, varakas',
    hungarian: 'gazdag, jómódú',
    german: 'reich',
    dutch: 'rijk',
    afrikaans: 'ryk',
    russian: 'богатый',
    latvian: 'bagāts, turīgs',
    polish: 'bogaty (mający dużo pieniędzy)',
    french: 'riche',
    spanish: 'rico (adinerado)',
  },
  {
    av: 16508,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cart + person: cart pulled by a person)',
    english: 'rickshaw',
    swedish: 'ricksha',
    norwegian: 'rickshaw',
    finnish: 'riksa',
    hungarian: 'riksa',
    german: 'Rikscha',
    dutch: 'riksja',
    afrikaans: 'riksja',
    russian: 'рикша',
    latvian: 'rikša',
    polish: 'riksza',
    french: 'pousse-pousse',
    spanish: 'jinrikisha',
  },
  {
    av: 16509,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(ride, drive + action indicator: to go forward in a sitting position)',
    english: 'ride-(to)',
    swedish: 'åka',
    norwegian: 'kjøre',
    finnish: 'ajaa',
    hungarian: 'utazni (járművön, ülő helyzetben)',
    german: 'fahren, mitfahren, reiten',
    dutch: 'rijden',
    afrikaans: 'ry (om te)',
    russian: 'ехать',
    latvian: 'braukt',
    polish: 'jechać',
    french: 'aller (assis)',
    spanish: 'pasear',
  },
  {
    av: 16510,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gun + long)',
    english: 'rifle, shotgun',
    swedish: 'gevär',
    norwegian: 'gevær, rifle',
    finnish: 'kivääri, haulikko',
    hungarian: 'puska, vadászpuska, karabély',
    german: 'Büchse, Jagdgewehr',
    dutch: 'geweer',
    afrikaans: 'geweer haelgeweer',
    russian: 'винтовка',
    latvian: 'šautene, bise',
    polish: 'karabin, strzelba',
    french: 'fusil, carabine',
    spanish: 'fusil',
  },
  {
    av: 16673,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(right turn, right (position or direction) + description indicator)',
    english: 'right',
    swedish: 'höger',
    norwegian: 'høyre',
    finnish: 'oikea, oikeanpuoleinen',
    hungarian: 'jobb, jobbra',
    german: 'rechts',
    dutch: 'rechts',
    afrikaans: 'regs',
    russian: 'правый',
    latvian: 'labā (piem.puse)',
    polish: 'prawy, prawo',
    french: 'droit',
    spanish: 'derecho',
  },
  {
    av: 16676,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(up + action indicator)',
    english: 'rise, ascend, go up-(to)',
    swedish: 'gå upp, stiga',
    norwegian: 'ese, stige',
    finnish: 'nousta, kohota',
    hungarian: 'emelkedni, felemelkedni, felmenni',
    german: 'steigen, aufsteigen',
    dutch: 'stijgen, omhoog gaan, naar boven gaan',
    afrikaans: 'styg, opklim, opgaan, opstyg, rys, op gaan (om te)',
    russian: 'подниматься, восходить',
    latvian: 'celties, kāpt, uzkāpt',
    polish: 'w górę, rosnąć, powiększać się',
    french: 'monter, augmenter',
    spanish: 'levantar, levantarse, ascender',
  },
  {
    av: 16679,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(bird + to walk + little: small bird that walks or runs but does not fly)',
    english: 'roadrunner (bird)',
    swedish: 'roadrunner, tuppgök (fågel)',
    norwegian: 'road runner (Am)',
    finnish: 'maantiekiitäjä',
    hungarian: 'gyalogkakukk, amerikai futókakukk',
    german: 'Laufvogel',
    dutch: 'roadrunner (vogel), renkoekoek',
    afrikaans: 'roadrunner (voël), renvoël',
    russian: 'кукушка земляная (бегающая)',
    latvian: 'irbe',
    polish: 'kukawka kalifornijska (ptak)',
    french: 'géocoucou, autruche nord-américaine',
    spanish: 'correcaminos',
  },
  {
    av: 16680,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(projectile, rocket, spacecraft + upward)',
    english: 'rocket, spaceship',
    swedish: 'raket, rymdskepp',
    norwegian: 'rakett, romskip',
    finnish: 'raketti',
    hungarian: 'rakéta, űrhajó',
    german: 'Rakete, Raumschiff',
    dutch: 'ruimteschip, raket',
    afrikaans: 'vuurpyl, ruimteskip',
    russian: 'ракета, космический корабль',
    latvian: 'raķete, kosmosa kuģis',
    polish: 'rakieta, statek kosmiczny',
    french: 'fusée, véhicule spatial',
    spanish: 'cohete',
  },
  {
    av: 16681,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chair + to rock: chair that rocks back and forth)',
    english: 'rocking chair',
    swedish: 'gungstol',
    norwegian: 'gyngestol',
    finnish: 'keinutuoli, kiikkutuoli',
    hungarian: 'hintaszék',
    german: 'Schaukelstuhl',
    dutch: 'schommelstoel',
    afrikaans: 'wiegstoel',
    russian: 'кресло-качалка',
    latvian: 'šūpuļkrēsls',
    polish: 'fotel na biegunach, krzesło bujane',
    french: 'fauteuil à bascule',
    spanish: 'mecedora',
  },
  {
    av: 16684,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(roller skates + action indicator)',
    english: 'roller skate-(to)',
    swedish: 'åka rullskridskor',
    norwegian: 'gå på rulleskøyter',
    finnish: 'luistella rullaluistimilla',
    hungarian: 'görkorcsolyázni',
    german: 'Rollschuh laufen',
    dutch: 'rolschaatsen (ww)',
    afrikaans: 'rol skaats (om te)',
    russian: 'кататься на роликах',
    latvian: 'skriet ar skrituļslidām, skrituļot',
    polish: 'jeździć na rolkach, wrotkach',
    french: 'faire du patin à roulettes',
    spanish: 'patinar',
  },
  {
    av: 16686,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(protection + thing indicator: thing that provides protective cover. The symbol is the concrete form of protection.) - (character with thing indicator)',
    english: 'roof, cover',
    swedish: 'tak, yttertak',
    norwegian: 'tak',
    finnish: 'katto',
    hungarian: 'tető, háztető, fedél',
    german: 'Dach',
    dutch: 'dak',
    afrikaans: 'dak',
    russian: 'крыша',
    latvian: 'jumts',
    polish: 'dach, pokrywa, pokrycie',
    french: 'toit',
    spanish: 'techo',
  },
  {
    av: 16689,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(day + horn + Jewish: Jewish New Year, the day on which the shofar or ram's horn is blown)",
    english: 'Rosh Hashana',
    swedish: 'Rosh Hashana (Israel)',
    norwegian: 'Rosh Hashana (Israel)',
    finnish: 'Roš hašana, rosh hasana, uusi vuosi',
    hungarian: 'Rós Hasana (héber)',
    german: 'Rosh Hashana, Rosh Hashanah',
    dutch: 'Rosh Hashana (Joods)',
    afrikaans: 'Rosh Hashanah',
    russian: 'рош хашана (Израиль)',
    latvian: 'Rosh Hashana (atzīmējama diena Izraēlā)',
    polish: 'Rosz Haszana (hebrajski Nowy Rok)',
    french: 'Rosh ha-Shanah (fête juive)',
    spanish: 'Rosh Hashana',
  },
  {
    av: 16690,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(rotation, circulation, orbit, lap, circle, round + action indicator)',
    english: 'rotate, circle, circulate, wind up, orbit-(to)',
    swedish: 'rotera, cirkulera, snurra, kretsa kring, vrida, veva',
    norwegian: 'dreie, rotere, gå rundt, sirkulere',
    finnish: 'pyöriä, kiertää',
    hungarian: 'körözni, keringeni, forogni, pörögni',
    german: 'kreisen, rollen, rotieren, drehen',
    dutch: 'draaien, rondgaan, ronddraaien',
    afrikaans: 'sirkuleer, roteer, draai, op te wen, wentel (om te)',
    russian: 'вращать(ся), циркулировать, поворачивать',
    latvian: 'rotēt, apļot, cirkulēt',
    polish: 'obracać, kręcić, okrążać, orbitować',
    french: 'tourner',
    spanish: 'girar, rotar, orbitar',
  },
  {
    av: 16691,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(toast + disc: disc-shaped toasted bread)',
    english: 'roti, chapati, flatbread',
    swedish: 'roti, chapati (Indien)',
    norwegian: 'roti (ristet brød India), chapati',
    finnish: 'roti',
    hungarian: 'roti, chapati (indiai kenyér)',
    german: 'roti (indisches Fladenbrot)',
    dutch: 'chapati (brood Indisch)',
    afrikaans: 'roti, chapati, platbrood (ongesuurde brood)',
    russian: 'роти, чапати',
    latvian: 'roti (indiešu maize)',
    polish: 'czapati, roti – azjatyckie placki chlebowe',
    french: 'pain grillé plat et rond',
    spanish: 'roti, pan plano',
  },
  {
    av: 16692,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(colour + plus + cheek: colour added to cheeks)',
    english: 'rouge, blusher',
    swedish: 'rouge',
    norwegian: 'rouge',
    finnish: 'poskipuna',
    hungarian: 'rúzs, arcpirosító',
    german: 'Wangenrouge, Rouge',
    dutch: 'rouge, blush(er)',
    afrikaans: 'rouge, blosser',
    russian: 'румяна',
    latvian: 'vajgu sārtums',
    polish: 'róż (do policzków)',
    french: 'fard à joue',
    spanish: 'colorete',
  },
  {
    av: 16693,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(circle + description indicator)',
    english: 'round, circular',
    swedish: 'cirkelformad, rund',
    norwegian: 'rund, sirkelformet',
    finnish: 'ympyrän muotoinen, pyöreä',
    hungarian: 'kerek, köralakú',
    german: 'rund',
    dutch: 'rond',
    afrikaans: 'rond, sirkelvormig',
    russian: 'круглый',
    latvian: 'apaļš, apļveida',
    polish: 'okrągły (kształt)',
    french: 'rond (adj)',
    spanish: 'redondo, circular',
  },
  {
    av: 16695,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hand + back and forth + intensity + action indicator)',
    english: 'rub, massage-(to)',
    swedish: 'gnugga, gnida, massera',
    norwegian: 'gni, massere',
    finnish: 'hieroa, hangata',
    hungarian: 'dörzsölni, bedörzsölni, masszírozni, meg-, ',
    german: 'einreiben, reiben, massieren',
    dutch: 'wrijven, masseren',
    afrikaans: 'vryf, masseer (om te)',
    russian: 'тереть, массировать',
    latvian: 'berzēt, masēt',
    polish: 'nacierać, masować',
    french: 'frotter, frictionner',
    spanish: 'frotar, masajear',
  },
  {
    av: 16696,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + floor covering)',
    english: 'rug, carpet, mat',
    swedish: 'matta',
    norwegian: 'teppe, rye',
    finnish: 'matto',
    hungarian: 'szőnyeg, szőnyegpadló, gyékény',
    german: 'Teppich, Läufer',
    dutch: 'vloerkleed, mat, tapijt',
    afrikaans: 'mat, tapyt',
    russian: 'палас, ковёр',
    latvian: 'paklājs',
    polish: 'dywan, mata, wykładzina dywanowa, chodnik(dywanik)',
    french: 'carpette, descente de lit',
    spanish: 'alfombra',
  },
  {
    av: 16697,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(page + to guide: written guidance)',
    english: 'rule, regulation',
    swedish: 'regel, föreskrift',
    norwegian: 'regel, forskrift',
    finnish: 'säännöt, sääntö, määräys',
    hungarian: 'szabály, előírás, szabályozás, rendszabály',
    german: 'Regel, Vorschrift, Anweisung, Anordnung',
    dutch: 'voorschrift, wet, regel',
    afrikaans: 'reël, regulasie',
    russian: 'правило, регулирование',
    latvian: 'noteikums, likums',
    polish: 'zasady, rozporządzenia, reguły',
    french: 'règlement, règle',
    spanish: 'regla, reglamentación',
  },
  {
    av: 16698,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(measurement + thing indicator) - (character with thing indicator)',
    english: 'ruler, measuring stick, tapeline, tape measure',
    swedish: 'linjal, måttband (etc)',
    norwegian: 'målestokk, linjal, målbånd',
    finnish: 'mitta, viivain',
    hungarian: 'vonalzó, mérőszalag',
    german: 'Lineal, Maßstab, Maßband',
    dutch: 'liniaal, meetlat',
    afrikaans: 'liniaal, maatband, meetstok, meetlat',
    russian: 'линейка, рулетка',
    latvian: 'lineāls',
    polish: 'miara, centymetr, linijka',
    french: 'règle à mesurer',
    spanish: 'regla, cinta métrica',
  },
  {
    av: 16699,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to walk + fast + action indicator)',
    english: 'run, jog-(to)',
    swedish: 'springa',
    norwegian: 'springe, løpe',
    finnish: 'juosta',
    hungarian: 'futni, elfutni',
    german: 'rennen, laufen, eilen',
    dutch: 'rennen, hollen, hardlopen',
    afrikaans: 'hardloop (om te)',
    russian: 'бегать',
    latvian: 'skriet',
    polish: 'biec, pędzić',
    french: 'courir',
    spanish: 'correr',
  },
  {
    av: 16700,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + rest: day for resting)',
    english: 'Sabbath, day of rest',
    swedish: 'vilodag',
    norwegian: 'hviledag, sabbat',
    finnish: 'pyhäpäivä, lepopäivä',
    hungarian: 'pihenőnap',
    german: 'Ruhetag, Schabbat',
    dutch: 'Sabbath',
    afrikaans: 'Sabbath',
    russian: 'выходной день',
    latvian: 'Sabats, atpūtas diena Izraēlā',
    polish: 'szabat, dzień odpoczynku',
    french: 'jour de repos, Sabbath',
    spanish: 'sábado, día de descanso',
  },
  {
    av: 16702,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(sadness + description indicator: having a downhearted feeling)',
    english: 'sad, sadly, unhappily, unhappy',
    swedish: 'ledsen, olycklig',
    norwegian: 'trist, lei seg, ulykkelig',
    finnish: 'surullinen, onneton',
    hungarian: 'szomorú, szomorúan, bús, búsan, boldogtalan/ul',
    german: 'traurig, unglücklich, betrübt',
    dutch: 'verdrietig, ongelukkig',
    afrikaans: 'ongelukkig, hartseer, verdrietig',
    russian: 'печальный, грустный',
    latvian: 'noskumis, skumjš, nelaimīgs',
    polish: 'smutny, nieszczęśliwy, niezadowolony',
    french: 'triste, malheureux',
    spanish: 'triste, infeliz',
  },
  {
    av: 16703,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + down)',
    english: 'sadness, sorrow, unhappiness',
    swedish: 'sorg',
    norwegian: 'sorg, sørgmodighet, tristhet',
    finnish: 'suru, surullisuus',
    hungarian: 'szomorúság, bánat, bú, búsulás',
    german: 'Traurigkeit',
    dutch: 'verdriet',
    afrikaans: 'ongelukkig, hartseer, verdrietig',
    russian: 'печаль, горе',
    latvian: 'skumjas, bēdas',
    polish: 'smutek, nieszczęście, żal',
    french: 'tristesse, malheur',
    spanish: 'tristeza, infelicidad',
  },
  {
    av: 16704,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(safety + description indicator)',
    english: 'safe, safely, secure, securely',
    swedish: 'säker, trygg',
    norwegian: 'sikker, trygg',
    finnish: 'turvallinen, varma',
    hungarian: 'biztonságos',
    german: 'sicher, geschützt, geborgen',
    dutch: 'veilig',
    afrikaans: 'veilig',
    russian: 'безопасный',
    latvian: 'drošs, nodrošināts',
    polish: 'bezpieczny, chroniony',
    french: 'en sécurité',
    spanish: 'seguro, de manera segura',
  },
  {
    av: 16705,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + protection: feeling of being protected)',
    english: 'safety, security',
    swedish: 'säkerhet, trygghet',
    norwegian: 'sikkerhet, trygghet',
    finnish: 'turvallisuus, varmuus',
    hungarian: 'biztonság ',
    german: 'Sicherheit',
    dutch: 'veiligheid',
    afrikaans: 'veiligheid, sekuriteit',
    russian: 'безопасность',
    latvian: 'drošība',
    polish: 'bezpieczeństwo',
    french: 'sécurité',
    spanish: 'seguridad',
  },
  {
    av: 16708,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + boat)',
    english: 'sailor',
    swedish: 'sjöman',
    norwegian: 'matros, sjømann',
    finnish: 'merimies',
    hungarian: 'hajós, matróz, tengerész',
    german: 'Seemann, Matrose',
    dutch: 'zeeman',
    afrikaans: 'matroos',
    russian: 'моряк',
    latvian: 'jūrnieks',
    polish: 'marynarz, żeglarz',
    french: 'marin',
    spanish: 'marinero',
  },
  {
    av: 16710,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + mouth: liquid contained in the mouth)',
    english: 'saliva, spit',
    swedish: 'saliv, spott',
    norwegian: 'spytt',
    finnish: 'sylki, kuola',
    hungarian: 'nyál, köpet, köpés',
    german: 'Speichel, Spucke',
    dutch: 'speeksel, spuug (Nl)',
    afrikaans: 'speeksel, spoeg',
    russian: 'слюна',
    latvian: 'siekalas, spļāviens',
    polish: 'ślina, plwocina',
    french: 'salive, crachat',
    spanish: 'saliva',
  },
  {
    av: 16711,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(crystal + sea)',
    english: 'salt crystal',
    swedish: 'saltkristall',
    norwegian: 'saltkrystall',
    finnish: 'merisuola, karkea suola',
    hungarian: 'só, sókristály',
    german: 'Salz',
    dutch: 'zoutkristal',
    afrikaans: 'sout kristal',
    russian: 'соль кристаллическая',
    latvian: 'sāls kristāli',
    polish: 'sól kryształ',
    french: 'sel marin (cristaux)',
    spanish: 'cristal de sal',
  },
  {
    av: 16714,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation:
      '(same + sound: used before a second symbol to create a meaning that is a homonym of the second symbol)',
    english: 'same sound',
    swedish: 'låter lika, låter som',
    norwegian: 'høres ut som, låter som',
    finnish: 'kuulostaa samalta kuin, samalta kuulostava kuin',
    hungarian: 'azonos hang, azonos hangzás',
    german: 'der gleiche Laut, Klang (etc), hört sich gleich an',
    dutch: 'zelfde geluid, klinkt als',
    afrikaans: 'selfde geluid klank',
    russian: 'одинаково звучит',
    latvian: 'vienāda skaņa',
    polish: 'ten sam dźwięk',
    french: 'même son',
    spanish: 'mismo sonido',
  },
  {
    av: 16715,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(powder + rock: powder made from a rock)',
    english: 'sand',
    swedish: 'sand, grus',
    norwegian: 'sand, grus',
    finnish: 'hiekka',
    hungarian: 'homok',
    german: 'Sand',
    dutch: 'zand',
    afrikaans: 'sand',
    russian: 'песок, гравий',
    latvian: 'smiltis, grants',
    polish: 'piasek',
    french: 'sable',
    spanish: 'arena',
  },
  {
    av: 16716,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shoe + comma + open)',
    english: 'sandal(s)',
    swedish: 'sandaler',
    norwegian: 'sandal',
    finnish: 'sandaalit',
    hungarian: 'szandál',
    german: 'Sandale',
    dutch: 'sandalen',
    afrikaans: 'sandaal',
    russian: 'сандалия',
    latvian: 'sandales',
    polish: 'sandały',
    french: 'sandale',
    spanish: 'sandalias',
  },
  {
    av: 16717,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      'foundation + sand: could also be interpreted as (enclosure [modification] + sand)',
    english: 'sandbox, sandpit, sandtray',
    swedish: 'sandlåda',
    norwegian: 'sandkasse',
    finnish: 'hiekkalaatikko',
    hungarian: 'homokozó, homokozótálca',
    german: 'Sandkasten',
    dutch: 'zandbak',
    afrikaans: 'sandboks, sandput, santbak',
    russian: 'песочница',
    latvian: 'smilšu kaste',
    polish: 'piaskownica',
    french: 'bac à sable',
    spanish: 'caja de arena',
  },
  {
    av: 16718,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + between + bread)',
    english: 'sandwich',
    swedish: 'sandwich, smörgås, baguette',
    norwegian: 'sandwich, smørbrød',
    finnish: 'kerrosvoileipä',
    hungarian: 'szendvics',
    german: 'belegtes Brot, Sandwich',
    dutch: 'sandwich',
    afrikaans: 'toebroodjie',
    russian: 'бутерброд',
    latvian: 'sviestmaize',
    polish: 'kanapka, sandwich (złożona z 2 kromek)',
    french: 'sandwich',
    spanish: 'sándwich',
  },
  {
    av: 16719,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(absorbent material + woman)',
    english: 'sanitary napkin, sanitary towel, tampon',
    swedish: 'binda, tampong',
    norwegian: 'bind, tampong',
    finnish: 'terveysside, tamponi',
    hungarian: 'betét, tisztasági betét, tampon',
    german: 'Damenbinde, Monatsbinde',
    dutch: 'tampon, maandverband',
    afrikaans: 'tampon, sanitêre doekie',
    russian: 'гигиеническая прокладка, тампон',
    latvian: 'higiēniskā pakete, tampons',
    polish: 'podpaska higieniczna, tampon, wkładka higieniczna',
    french: 'serviette hygiénique',
    spanish: 'tampón, toalla higiénica',
  },
  {
    av: 16720,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + around + woman) (India)',
    english: 'sari',
    swedish: 'sari (Indien)',
    norwegian: 'sari (India)',
    finnish: 'sari',
    hungarian: 'szári (India)',
    german: 'Sari (indisches Kleid)',
    dutch: 'sari (Indisch)',
    afrikaans: 'sari',
    russian: 'сари',
    latvian: 'sari (India)',
    polish: 'sari (hinduski strój)',
    french: 'sari',
    spanish: 'sari',
  },
  {
    av: 16721,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + full: CKB quotes the Chinese phrase to describe a contented man: “his rice bowl is full”)',
    english: 'satisfaction, contentment',
    swedish: 'tillfredsställelse, belåtenhet',
    norwegian: 'tilfredsstillelse',
    finnish: 'tyytyväisyys, mielihyvä',
    hungarian: 'elégedettség, megelégedettség, megelégedés',
    german: 'Befriedigung, Zufriedenheit',
    dutch: 'tevredenheid',
    afrikaans: 'tevredenheid, satisfaksie, gelukkig, tevrede',
    russian: 'удовлетворённость',
    latvian: 'apmierinājums, apmierinātība',
    polish: 'satysfakcja, zadowolenie',
    french: 'satisfaction',
    spanish: 'satisfacción, conformidad',
  },
  {
    av: 16724,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cabbage + sour)',
    english: 'sauerkraut',
    swedish: 'surkål',
    norwegian: 'surkål',
    finnish: 'hapankaali',
    hungarian: 'savanyúkáposzta',
    german: 'Sauerkraut',
    dutch: 'zuurkool',
    afrikaans: 'suurkool',
    russian: 'капуста квашеная',
    latvian: 'skābs kāposts',
    polish: 'kapusta kiszona',
    french: 'choucroute',
    spanish: 'chucrut',
  },
  {
    av: 16725,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(steam bath + rock)',
    english: 'sauna',
    swedish: 'bastu',
    norwegian: 'badstu',
    finnish: 'sauna',
    hungarian: 'szauna',
    german: 'Sauna',
    dutch: 'sauna',
    afrikaans: 'sauna',
    russian: 'баня, сауна',
    latvian: 'sauna',
    polish: 'sauna',
    french: 'sauna',
    spanish: 'sauna',
  },
  {
    av: 16726,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + long)',
    english: 'sausage, frankfurter, hotdog, hot dog',
    swedish: 'korv',
    norwegian: 'pølse',
    finnish: 'makkara',
    hungarian: 'virsli, kolbász, frankfurter, hotdog',
    german: 'Würstchen, Wurst, Bratwurst, Wurstware',
    dutch: 'hotdog',
    afrikaans: 'worsbroodjie',
    russian: 'колбаса‚ сосиска',
    latvian: 'sardele, cīsiņš, ',
    polish: 'kiełbasa, parówka',
    french: 'saucisse, saucisse de Francfort',
    spanish: 'salchicha',
  },
  {
    av: 16728,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(mouth + action indicator)',
    english: 'say, speak, talk, tell, express-(to)',
    swedish: 'säga, tala, prata',
    norwegian: 'si, snakke, fortelle',
    finnish: 'kertoa, puhua, sanoa',
    hungarian: 'mondani, elmondani, beszélni, kifejezni',
    german: ' sagen, sprechen, erzählen, reden, berichten, (sich) unterhalten',
    dutch: 'vertellen, spreken, zeggen, praten',
    afrikaans: 'sê, praat, spreek, verduidelik, vertel, beskryf (om te)',
    russian: 'говорить',
    latvian: 'runāt, teikt, izteikties',
    polish: 'mówić, powiedzieć',
    french: 'dire, exprimer, parler',
    spanish: 'decir, hablar, expresar',
  },
  {
    av: 16729,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to weigh)',
    english: 'scales',
    swedish: 'våg (apparat)',
    norwegian: 'vekt (skala)',
    finnish: 'vaaka',
    hungarian: 'mérleg',
    german: 'Waage',
    dutch: 'weegschaal',
    afrikaans: 'weegskaal',
    russian: 'весы',
    latvian: 'svari',
    polish: 'waga (urządzenie)',
    french: 'balance',
    spanish: 'balanzas',
  },
  {
    av: 16730,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + neck)',
    english: 'scarf',
    swedish: 'halsduk, scarf',
    norwegian: 'skjerf, halstørkle',
    finnish: 'kaulaliina',
    hungarian: 'sál, nyaksál',
    german: 'Schal, Kopftuch',
    dutch: 'sjaal, das',
    afrikaans: 'serp, das',
    russian: 'шарф',
    latvian: 'šalle',
    polish: 'szalik',
    french: 'foulard, écharpe',
    spanish: 'bufanda',
  },
  {
    av: 16731,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(generalization + countryside: general term for the countryside, which is characteristic of a particular area or region, e.g. a prairie landscape)',
    english: 'scenery, landscape',
    swedish: 'landskap',
    norwegian: 'landskap',
    finnish: 'maisema',
    hungarian: 'táj, tájkép, vidék',
    german: 'Landschaft',
    dutch: 'landschap',
    afrikaans: 'landskap, natuurskoon',
    russian: 'пейзаж, ландшафт',
    latvian: 'skats, ainava',
    polish: 'sceneria, krajobraz',
    french: 'paysage, décor',
    spanish: 'paisaje',
  },
  {
    av: 16732,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(roof + tree + thing indicator + plural indicator: material used in making roof for Sukkot)',
    english: 'schach',
    swedish: 'schach (Israel)',
    norwegian: 'schach (Israel)',
    finnish: 'puukatos',
    hungarian: 'fatető',
    german: 'Schach',
    dutch: 'schach (Joods)',
    afrikaans: 'Schach',
    russian: 'шах (Израиль)',
    latvian: 'šahs',
    polish: 'Schach (hebr)',
    french: 'toit de la soukka en branchages',
    spanish: 'schach',
  },
  {
    av: 16733,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + time: paper that gives the times of events)',
    english: 'schedule, timetable',
    swedish: 'schema, tidtabell',
    norwegian: 'skjema, timeplan, tidtabell',
    finnish: 'aikataulu, lukujärjestys',
    hungarian: 'órarend, menetrend, ütemterv',
    german: 'Zeitplan, Stundenplan',
    dutch: 'agenda (tijdsschema), programma (tijdschema)',
    afrikaans: 'skedule, rooster',
    russian: 'расписание, график',
    latvian: 'saraksts, grafiks',
    polish: 'harmonogram, plan lekcji',
    french: 'horaire, emploi du temps, calendrier de réunions',
    spanish: 'horario',
  },
  {
    av: 16734,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + to teach: building used for teaching)',
    english: 'school',
    swedish: 'skola',
    norwegian: 'skole',
    finnish: 'koulu',
    hungarian: 'iskola',
    german: 'Schule',
    dutch: 'school',
    afrikaans: 'skool',
    russian: 'школа',
    latvian: 'skola',
    polish: 'szkoła (budynek+ dawać+wiedza)',
    french: 'école',
    spanish: 'escuela',
  },
  {
    av: 16737,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(number + competition)',
    english: 'score',
    swedish: 'poäng',
    norwegian: 'poeng, skåre',
    finnish: 'pistemäärä, piste',
    hungarian: 'gólszám, pontszám, sporteredmény',
    german: 'Punktzahl, Spielstand',
    dutch: 'score',
    afrikaans: 'telling punt',
    russian: 'счёт, балл, очко',
    latvian: 'punkti, punktu skaits',
    polish: 'punkt, stan gry, wynik rywalizacji',
    french: 'score, résultat',
    spanish: 'puntuación',
  },
  {
    av: 16738,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spider + to puncture: spider-like insect with a poisonous sting)',
    english: 'scorpion',
    swedish: 'skorpion',
    norwegian: 'skorpion',
    finnish: 'skorpioni',
    hungarian: 'skorpió',
    german: 'Skorpion',
    dutch: 'schorpioen',
    afrikaans: 'skerpioen',
    russian: 'скорпион',
    latvian: 'skorpions',
    polish: 'skorpion (zwierzę)',
    french: 'scorpion',
    spanish: 'escorpión',
  },
  {
    av: 16740,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + screw)',
    english: 'screwdriver',
    swedish: 'skruvmejsel',
    norwegian: 'skrutrekker, skrujern',
    finnish: 'ruuvimeisseli',
    hungarian: 'csavarhúzó',
    german: 'Schraubenzieher',
    dutch: 'schroevendraaier',
    afrikaans: 'skroewedraaier',
    russian: 'отвертка',
    latvian: 'skrūvgriezis',
    polish: 'śrubokręt',
    french: 'tournevis',
    spanish: 'destornillador',
  },
  {
    av: 16741,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + testicle)',
    english: 'scrotum',
    swedish: 'pung',
    norwegian: 'pung, testikkel',
    finnish: 'kivespussi',
    hungarian: 'herezacskó',
    german: 'Hodensack',
    dutch: 'scrotum',
    afrikaans: 'skrotum',
    russian: 'мошонка',
    latvian: 'sēklinieku maisiņš',
    polish: 'moszna',
    french: 'scrotum',
    spanish: 'escroto',
  },
  {
    av: 16742,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to watch + intensity + action indicator: to watch very intently)',
    english: 'search-(to)',
    swedish: 'leta, söka',
    norwegian: 'lete, søke',
    finnish: 'etsiä, tutkia, tarkkailla',
    hungarian: 'keresni, megkeresni, felkutatni',
    german: 'suchen',
    dutch: 'zoeken',
    afrikaans: 'soek (om te)',
    russian: 'искать',
    latvian: 'meklēt',
    polish: 'szukać, wyszukiwać',
    french: 'chercher partout, fouiller',
    spanish: 'buscar',
  },
  {
    av: 16743,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(time + two apostrophes, used in astronomy to indicate a second)',
    english: 'second (time)',
    swedish: 'sekund',
    norwegian: 'sekund',
    finnish: 'sekunti',
    hungarian: 'másodperc',
    german: 'Sekunde',
    dutch: 'seconde',
    afrikaans: 'sekonde (tyd)',
    russian: 'секунда',
    latvian: 'sekunde',
    polish: 'sekunda (jednostka czasu)',
    french: 'seconde (temps)',
    spanish: 'segundo (tiempo)',
  },
  {
    av: 16744,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(2 + decimal point + description indicator: the dot indicates an ordinal numeral)',
    english: 'second (ordinal)',
    swedish: 'andra (ordningstal)',
    norwegian: 'andre',
    finnish: 'toinen',
    hungarian: 'második',
    german: 'zweitens, zweiter, an zweiter Stelle (Ordnungszahl)',
    dutch: 'tweede',
    afrikaans: 'tweede (ordinaal)',
    russian: 'второй',
    latvian: 'otrais',
    polish: 'drugi (liczebnik porządkowy)',
    french: 'deuxième, second (ordinal)',
    spanish: 'segundo (ordinal)',
  },
  {
    av: 16746,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: "(person + secret: historically, a person who keeps the boss's secrets)",
    english: 'secretary',
    swedish: 'sekreterare',
    norwegian: 'sekretær',
    finnish: 'sihteeri',
    hungarian: 'titkár',
    german: 'Sekretär, Sekretärin',
    dutch: 'secretaresse',
    afrikaans: 'sekretaris sekretaresse',
    russian: 'секретарь',
    latvian: 'sekretārs',
    polish: 'sekretarz, sekretarka',
    french: 'secrétaire',
    spanish: 'secretario(a)',
  },
  {
    av: 16747,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(eye + action indicator)',
    english: 'see, look, watch-(to)',
    swedish: 'se, titta',
    norwegian: 'se',
    finnish: 'nähdä, katsoa',
    hungarian: 'nézni, látni, megnézni, ránézni',
    german: 'sehen, schauen',
    dutch: 'zien, kijken',
    afrikaans: 'sien, kyk (om te)',
    russian: 'видеть, смотреть',
    latvian: 'redzēt, skatīties, novērot',
    polish: 'patrzeć, widzieć',
    french: 'voir, regarder',
    spanish: 'ver, mirar',
  },
  {
    av: 16748,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(to see + again + action indicator)',
    english: 'see you again',
    swedish: 'vi ses',
    norwegian: 'på gjensyn (utsagn), vi ses (utsagn)',
    finnish: 'nähdään',
    hungarian: 'Viszlát! Látjuk egymást!',
    german: 'bis bald, bis später, tschüss, auf Wiedersehen',
    dutch: 'tot weerziens, tot later',
    afrikaans: 'tot weer siens, tot later',
    russian: 'видиться',
    latvian: 'uz redzēšanos',
    polish: 'zobaczymy się ponownie, do zobaczenia',
    french: 'revoir',
    spanish: 'nos vemos de nuevo',
  },
  {
    av: 16750,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(state of mind + what, question mark + action indicator: can also be interpreted as mind + maybe + action indicator: to give the impression of being)',
    english: 'seem-(to)',
    swedish: 'verka, förefalla',
    norwegian: 'synes, virke som',
    finnish: 'näyttää (joltakin), tuntua (joltakin)',
    hungarian: 'látszani, tűnni valaminek/valamilyennek',
    german: 'erscheinen, scheinen, vorkommen',
    dutch: 'lijken, schijnen (niet de zon)',
    afrikaans: 'lyk (om te)',
    russian: 'казаться',
    latvian: 'likties, šķist',
    polish: 'wydaje się, wydawać się',
    french: "sembler, paraître, avoir l'air",
    spanish: 'parecer, parecerse',
  },
  {
    av: 16752,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(1 + person [modification]: referring to oneself as person number one)',
    english: 'self, oneself, ego (person)',
    swedish: 'själv, ego',
    norwegian: 'selv',
    finnish: 'itse',
    hungarian: 'maga, önmaga, saját maga',
    german: 'sich, selbst, sich selbst, Ego',
    dutch: 'persoon, mens',
    afrikaans: 'self, ekpersoon, mens, jyself, jouself, eie',
    russian: 'сам',
    latvian: 'pats, sev, sevi',
    polish: 'siebie, się',
    french: 'soi, soi-même',
    spanish: 'sí mismo, uno mismo, ego',
  },
  {
    av: 16753,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(abuse, assault, violence + self)',
    english: 'self-harm',
    swedish: 'självdestruktivitet',
    norwegian: 'selvplaging, selvskading',
    finnish: 'itsetuho',
    hungarian: 'autoagresszivitás, önmagának baj, ártalom okozása',
    german: 'Selbstverletzung, selbstverletzendes Verhalten, Selbstbeschädigung',
    dutch: 'automutulatie (zelfst.nw)',
    afrikaans: 'selfbeskadiging',
    russian: 'саморазрушение',
    latvian: 'paškaitējums',
    polish: 'masturbacja, samogwałt',
    french: 'automutilation',
    spanish: 'autodestrucción',
  },
  {
    av: 16754,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to lead + self: guidance of oneself)',
    english: 'self-control',
    swedish: 'självbehärskning, självkontroll',
    norwegian: 'selvkontroll',
    finnish: 'itsehillintä, itsekontrolli',
    hungarian: 'önuralom, önkontroll',
    german: 'Selbstbeherrschung',
    dutch: 'zelfbeheersing',
    afrikaans: 'selbeheersing',
    russian: 'самообладание, самоконтроль',
    latvian: 'paškontrole',
    polish: 'samokontrola',
    french: 'maîtrise de soi',
    spanish: 'autocontrol',
  },
  {
    av: 16755,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(selfishness, egoism + description indicator: thinking only about oneself)',
    english: 'selfish, self-centred, self-centered, egoistic, egoistical, egocentric',
    swedish: 'egoistisk, självisk',
    norwegian: 'egoistisk',
    finnish: 'itsekäs',
    hungarian: 'önző, önös, egoista, egocentrikus',
    german: 'egoistisch, ichbezogen, egozentrisch',
    dutch: 'egoïstisch',
    afrikaans: 'selfsugtig, egoïsties, selfgesentreerd, egosentriese',
    russian: 'эгоистичный',
    latvian: 'savtīgs, egoistisks',
    polish: 'egoistyczny, egocentryczny',
    french: 'égoïste, égocentrique',
    spanish: 'egoísta, egocéntrico, ególatra',
  },
  {
    av: 16756,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(thing + money + action indicator: first you must have something, which you can then sell for money)',
    english: 'sell-(to)',
    swedish: 'sälja',
    norwegian: 'selge',
    finnish: 'myydä',
    hungarian: 'eladni, elárusítani',
    german: 'verkaufen',
    dutch: 'verkopen',
    afrikaans: 'verkoop (om te)',
    russian: 'продавать',
    latvian: 'pārdot',
    polish: 'sprzedawać',
    french: 'vendre',
    spanish: 'vender',
  },
  {
    av: 16757,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + sperm)',
    english: 'semen',
    swedish: 'sädesvätska',
    norwegian: 'sæd',
    finnish: 'siemenneste',
    hungarian: 'ondó, ondósejt, sperma',
    german: 'Samen, Samenflüssigkeit',
    dutch: 'zaad',
    afrikaans: 'saad',
    russian: 'семя, сперма',
    latvian: 'sperma',
    polish: 'nasienie (plemniki)',
    french: 'sperme, semence',
    spanish: 'semen',
  },
  {
    av: 16758,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + semen: pouch in which semen is produced)',
    english: 'seminal vesicle',
    swedish: 'sädesblåsa',
    norwegian: 'sædblære',
    finnish: 'kivespussi',
    hungarian: 'ondóhólyag',
    german: 'Samenblase',
    dutch: 'zaadbal',
    afrikaans: 'seminale vesikel',
    russian: 'семенной пузырёк',
    latvian: 'spermas pūslītis',
    polish: 'pęcherzyk nasienny',
    french: 'vésicule séminale, bourse séminale',
    spanish: 'vesícula seminal',
  },
  {
    av: 16759,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to carry + departure + action indicator: to carry away from a given location)',
    english: 'send-(to)',
    swedish: 'skicka, sända',
    norwegian: 'sende',
    finnish: 'lähettää',
    hungarian: 'küldeni, elküldeni',
    german: 'schicken, versenden, senden',
    dutch: 'verzenden',
    afrikaans: 'stuur (om te)',
    russian: 'отправлять',
    latvian: 'sūtīt, nosūtīt',
    polish: 'wysłać, wysyłać',
    french: 'envoyer',
    spanish: 'enviar',
  },
  {
    av: 16760,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + word: a group of words considered together)',
    english: 'sentence, clause, phrase',
    swedish: 'mening, sats',
    norwegian: 'setning, mening, frase',
    finnish: 'lause, virke',
    hungarian: 'mondat',
    german: 'Satz, Phrase',
    dutch: 'zin',
    afrikaans: 'sin, klousule, frase',
    russian: 'предложение',
    latvian: 'teikums, frāze',
    polish: 'fraza, zdanie, klauzula',
    french: 'phrase',
    spanish: 'oración, cláusula, frase',
  },
  {
    av: 16761,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + 9: ninth month of the year)',
    english: 'September',
    swedish: 'september',
    norwegian: 'september',
    finnish: 'syyskuu',
    hungarian: 'szeptember',
    german: 'September',
    dutch: 'september',
    afrikaans: 'September',
    russian: 'сентябрь',
    latvian: 'septembris',
    polish: 'wrzesień',
    french: 'septembre',
    spanish: 'Septiembre',
  },
  {
    av: 16762,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(greater than (relation) + 2: greater than two)',
    english: 'several',
    swedish: 'flera, åtskilliga',
    norwegian: 'noen, flere, adskillige',
    finnish: 'muutama',
    hungarian: 'néhány',
    german: 'mehrere',
    dutch: 'verscheidene',
    afrikaans: 'verskeie',
    russian: 'несколько',
    latvian: 'vairāki, vairākas',
    polish: 'kilka, parę',
    french: 'plusieurs',
    spanish: 'varios',
  },
  {
    av: 16763,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(needle + action indicator)',
    english: 'sew-(to)',
    swedish: 'sy',
    norwegian: 'sy',
    finnish: 'ommella',
    hungarian: 'varrni, ölteni, megölteni',
    german: 'nähen',
    dutch: 'naaien',
    afrikaans: 'naaldwerk (om te)',
    russian: 'шить',
    latvian: 'šūt',
    polish: 'szyć, zszywać',
    french: 'coudre',
    spanish: 'coser',
  },
  {
    av: 16764,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to sew)',
    english: 'sewing machine',
    swedish: 'symaskin',
    norwegian: 'symaskin',
    finnish: 'ompelukone',
    hungarian: 'varrógép',
    german: 'Nähmaschine',
    dutch: 'naaimachine',
    afrikaans: 'naaldwerkmasjien naaldwerk rekenaar',
    russian: 'швейная машина',
    latvian: 'šūjmašīna',
    polish: 'maszyna do szycia',
    french: 'machine à coudre',
    spanish: 'máquina de coser',
  },
  {
    av: 16765,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fire + gender, sex: sexual desire)',
    english: 'sex drive, sexual urge, libido',
    swedish: 'könsdrift',
    norwegian: 'kjønnsdrift',
    finnish: 'sukupuolivietti',
    hungarian: 'szexuális/nemi vágy, szexuális késztetés, libidó',
    german: 'Geschlechtstrieb, Sexualtrieb',
    dutch: 'libido',
    afrikaans: 'seks libido seksdrang',
    russian: 'сексуальное влечение, либидо',
    latvian: 'dzimumdziņa, libido, seksuāla vēlme',
    polish: 'popęd płciowy, libido, pożądanie',
    french: 'désir sexuel, pulsion sexuelle, libido',
    spanish: 'deseo sexual, libido',
  },
  {
    av: 16766,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(abuse, assault, violence + sexual)',
    english: 'sexual abuse, sexual assault, sexual violence',
    swedish: 'sexuellt våld',
    norwegian: 'seksuell mishandling',
    finnish: 'väkisinmakaaminen, seksuaalinen väkivalta, sukupuolinen väkivalta',
    hungarian: 'szexuális/nemi erőszak, szexuális bántalmazás',
    german: 'sexueller Missbrauch',
    dutch: 'seksueel misbruik',
    afrikaans: 'seksuele mishandeling, seksuele aanranding, seksuele geweld',
    russian: 'сексуальное насилие',
    latvian: 'seksuāla vardarbība',
    polish: 'nadużycie seksualne, wykorzystywanie seksualne',
    french: 'abus sexuel, violence sexuelle',
    spanish: 'abuso sexual, acoso sexual, violencia sexual',
  },
  {
    av: 16929,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(excitement + gender, sex)',
    english: 'sexual arousal, sexual excitement',
    swedish: 'sexuell upphetsning',
    norwegian: 'seksuell opphisselse',
    finnish: 'sukupuolinen kiihotus, seksuaalinen kiihotus',
    hungarian: 'szexuális/nemi izgalom, izgalmi állapot',
    german: '(sexuelle) Erregung',
    dutch: 'seksuele opwinding',
    afrikaans: 'seksuele opwekking, seksuele opwinding',
    russian: 'сексуальное возбуждение',
    latvian: 'dzimumuzbudinājums',
    polish: 'podniecenie seksualne, pożądanie',
    french: 'excitation sexuelle',
    spanish: 'excitación sexual',
  },
  {
    av: 16930,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(harassment + gender, sex)',
    english: 'sexual harassment',
    swedish: 'sexuella trakasserier',
    norwegian: 'seksuell trakassering',
    finnish: 'sukupuolinen ahdistelu, seksuaalinen ahdistelu',
    hungarian: 'szexuális/nemi zaklatás',
    german: 'sexuelle Belästigung',
    dutch: 'ongewenste intimiteit',
    afrikaans: 'seksuele teistering',
    russian: 'сексуальное домогательство',
    latvian: 'seksuālā uzmākšanās',
    polish: 'molestowanie seksualne',
    french: 'harcèlement sexuel',
    spanish: 'acoso sexual',
  },
  {
    av: 16931,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to combine + gender, sex)',
    english: 'sexual intercourse, intercourse, copulation',
    swedish: 'samlag',
    norwegian: 'samleie, parring',
    finnish: 'yhdyntä, seksuaalinen kanssakäyminen, sukupuolinen kanssakäyminen',
    hungarian: 'szexuális együttlét, közösülés, elhálás',
    german: 'Geschlechtsverkehr',
    dutch: 'seks',
    afrikaans: 'seksuele omgang, kopulasie',
    russian: 'секс, половой акт',
    latvian: 'dzimumakts, kopošanās, pārošanās',
    polish: 'stosunek płciowy, kopulacja',
    french: 'rapport sexuel, relation sexuelle',
    spanish: 'encuentro sexual',
  },
  {
    av: 16932,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pleasure + gender, sex)',
    english: 'sexual pleasure',
    swedish: 'sexuell njutning',
    norwegian: 'seksuell nytelse',
    finnish: 'seksuaalinen tyydytys',
    hungarian: 'szexuális/nemi öröm',
    german: 'sexuelles Vergnügen',
    dutch: 'seksueel genot',
    afrikaans: 'seksuele genot, plesier',
    russian: 'сексуальное удовольствие',
    latvian: 'seksuāla bauda',
    polish: 'seksualna przyjemność',
    french: 'plaisir sexuel',
    spanish: 'placer sexual',
  },
  {
    av: 16933,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + gender, sex)',
    english: 'sexuality',
    swedish: 'erotik, sexualitet',
    norwegian: 'seksualitet, erotikk',
    finnish: 'seksuaalisuus, sukupuolisuus',
    hungarian: 'szexualitás, nemiség',
    german: 'Sexualität',
    dutch: 'seksualiteit',
    afrikaans: 'seksualiteit',
    russian: 'сексуальность',
    latvian: 'seksualitāte',
    polish: 'seksualność',
    french: 'sexualité',
    spanish: 'sexualidad',
  },
  {
    av: 16934,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(up and down + action indicator)',
    english: 'shake, jiggle-(to)',
    swedish: 'skaka',
    norwegian: 'riste',
    finnish: 'ravistaa',
    hungarian: 'rázni, rázogatni, fel-le mozgatni',
    german: 'schütteln, wackeln',
    dutch: 'schudden',
    afrikaans: 'skud (om te)',
    russian: 'трясти, встряхивать',
    latvian: 'kratīt, sakratīt, pakratīt',
    polish: 'skakać, podskakiwać',
    french: 'secouer, agiter',
    spanish: 'agitar',
  },
  {
    av: 16935,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(shallowness + description indicator: pointer points downward into a relatively shallow space)',
    english: 'shallow',
    swedish: 'grund',
    norwegian: 'grunn',
    finnish: 'matala',
    hungarian: 'sekély, felszínes',
    german: 'seicht, flach, untief',
    dutch: 'ondiep',
    afrikaans: 'vlak',
    russian: 'мелкий, неглубокий',
    latvian: 'sekls',
    polish: 'płytki, powierzchowny, niegłęboki',
    french: 'peu profond',
    spanish: 'poco profundo',
  },
  {
    av: 16936,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(mouth (to say) + meeting and parting: a combination of hello and goodbye, expression of greeting, either when meeting or parting)',
    english: 'greeting, shalom, salam (etc)',
    swedish: 'hälsning',
    norwegian: 'hilsen',
    finnish: 'tervehdys, shalom',
    hungarian: 'Helló! Szia! Csau! Csá!',
    german: 'Shalom',
    dutch: 'shalom',
    afrikaans: 'shalom',
    russian: 'приветствие, шалом',
    latvian: 'šalom',
    polish: 'szalom (hebr. przywitanie)',
    french: 'salut, salutation',
    spanish: 'shalom',
  },
  {
    av: 16937,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(sad + wrong: feeling of sadness about one's wrong behaviour)",
    english: 'shame',
    swedish: 'skam',
    norwegian: 'skam',
    finnish: 'häpeä',
    hungarian: 'szégyen, szégyenkezés',
    german: 'Scham, Schamgefühl, Schande',
    dutch: 'schaamte',
    afrikaans: 'skaamte',
    russian: 'стыд',
    latvian: 'kauns, apkaunojums',
    polish: 'wstyd',
    french: 'honte',
    spanish: 'vergüenza',
  },
  {
    av: 16938,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(soap + hair)',
    english: 'shampoo',
    swedish: 'schampo',
    norwegian: 'sjampo',
    finnish: 'shampoo',
    hungarian: 'sampon',
    german: 'Shampoo, Haarwaschmittel',
    dutch: 'shampoo',
    afrikaans: 'sjampoo',
    russian: 'шампунь',
    latvian: 'šampūns',
    polish: 'szampon',
    french: 'shampooing (savon)',
    spanish: 'champú',
  },
  {
    av: 16940,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(eye + thing: how the eye perceives an object)',
    english: 'shape, form',
    swedish: 'form',
    norwegian: 'form',
    finnish: 'muoto',
    hungarian: 'alak, forma',
    german: 'Gestalt, Form, Formen',
    dutch: 'vorm',
    afrikaans: 'vorm',
    russian: 'форма',
    latvian: 'forma, veids, veidne',
    polish: 'kształt, forma',
    french: 'forme',
    spanish: 'forma',
  },
  {
    av: 16941,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to have + together + action indicator)',
    english: 'share-(to)',
    swedish: 'dela, ha tillsammans',
    norwegian: 'dele, ha sammen',
    finnish: 'olla yhteinen (jonkun kanssa), jakaa (jonkun kanssa)',
    hungarian: 'megosztani, osztozni',
    german: 'teilen, teilhaben',
    dutch: 'delen',
    afrikaans: 'deel (om te)',
    russian: 'делиться, разделять',
    latvian: 'dalīties, dalīt (kaut ko)',
    polish: 'dzielić, rozdzielać, podzielić się',
    french: 'partager',
    spanish: 'compartir',
  },
  {
    av: 16942,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + teeth)',
    english: 'shark',
    swedish: 'haj',
    norwegian: 'hai',
    finnish: 'hai',
    hungarian: 'cápa',
    german: 'Hai, Haifisch',
    dutch: 'haai',
    afrikaans: 'haai',
    russian: 'акула',
    latvian: 'haizivs',
    polish: 'rekin',
    french: 'requin',
    spanish: 'tiburón',
  },
  {
    av: 16943,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(knife + description indicator)',
    english: 'sharp (knife)',
    swedish: 'skarp, vass',
    norwegian: 'skarp',
    finnish: 'terävä',
    hungarian: 'éles, hegyes',
    german: 'scharf, spitz, scharfkantig',
    dutch: 'scherp',
    afrikaans: 'skerp',
    russian: 'острый, отточенный',
    latvian: 'ass, uzasināts',
    polish: 'ostry (nóż)',
    french: 'aiguisé, acéré',
    spanish: 'afilado (cuchillo)',
  },
  {
    av: 16944,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(taste + sharp + description indicator)',
    english: 'sharp (taste), acid, sour',
    swedish: 'sur, skarp (smak)',
    norwegian: 'skarp (smak), syrlig',
    finnish: 'hapan, kirpeä',
    hungarian: 'savanyú, savas, fanyar',
    german: 'sauer, säuerlich (Geschmack)',
    dutch: 'zuur',
    afrikaans: 'skerp (smaak), suur',
    russian: 'кислый, острый',
    latvian: 'ass, stiprs, skābs',
    polish: 'kwaśny lub ostry (smak)',
    french: 'acide, aigre (goût)',
    spanish: 'fuerte, ácido, amargo (sabor)',
  },
  {
    av: 16945,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cut + beard + action indicator)',
    english: 'shave (beard)-(to)',
    swedish: 'raka, raka sig',
    norwegian: 'barbere seg, barbere (skjegg)',
    finnish: 'ajaa parta',
    hungarian: 'borotválkozni, borotválni, megborotválni',
    german: 'rasieren',
    dutch: 'scheren',
    afrikaans: 'skeer (om te)',
    russian: 'брить(ся)',
    latvian: 'skūt',
    polish: 'golić brodę',
    french: 'raser-(se)',
    spanish: 'afeitar (barba)',
  },
  {
    av: 16946,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knife + beard)',
    english: 'shaver, razor',
    swedish: 'rakapparat, rakhyvel',
    norwegian: 'barberhøvel',
    finnish: 'partakone',
    hungarian: 'borotva, borotvakés, borotvapenge',
    german: 'Rasierapparat, Rasierer',
    dutch: 'scheermes',
    afrikaans: 'skeermes',
    russian: 'бритва',
    latvian: 'bārdas skujamais, bārdas nazis',
    polish: 'brzytwa, golarka',
    french: 'rasoir',
    spanish: 'máquina de afeitar',
  },
  {
    av: 16947,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(soap + beard)',
    english: 'shaving soap, shaving cream',
    swedish: 'rakkräm, raktvål',
    norwegian: 'barbersåpe, barberkrem',
    finnish: 'partavaahto',
    hungarian: 'borotválkozó szappan, borotválkozó krém',
    german: 'Rasierschaum, Rasierseife, Rasiercreme',
    dutch: 'scheerzeep, scheerschuim',
    afrikaans: 'skeer seep, skeer room',
    russian: 'мыло для бритья',
    latvian: 'skūšanās putas, krēms',
    polish: 'mydło, żel, pianka do golenia',
    french: 'savon à barbe',
    spanish: 'espuma de afeitar',
  },
  {
    av: 16948,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + commandments)',
    english: 'Shavuot',
    swedish: 'Shavuot (Israel)',
    norwegian: 'Shavout (Israel)',
    finnish: 'Šavuot, viikojen juhla',
    hungarian: 'Sávuot (héber)',
    german: 'Shavuot',
    dutch: 'Shavuot (Joods)',
    afrikaans: 'Shavuot',
    russian: 'Шавуот (Израиль)',
    latvian: 'Šaviots (Izraēla)',
    polish: 'Szawuot (hebr.)',
    french: 'Shavouot (fête juive)',
    spanish: 'Shavuot',
  },
  {
    av: 16949,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(female + 3: third person singular (f.))',
    english: 'she, her, herself',
    swedish: 'hon, henne, sig',
    norwegian: 'hun, henne, seg',
    finnish: 'hän (nainen), hän (fem.)',
    hungarian: 'ő, önmaga (nőnem)',
    german: 'sie, ihr, ihr selbst',
    dutch: 'zij, haar(pers. vnw)',
    afrikaans: 'sy, haar, haarself',
    russian: 'она‚ ей, её',
    latvian: 'viņa, viņu, viņai',
    polish: 'ona sama, samodzielnie',
    french: 'elle',
    spanish: 'ella, a ella',
  },
  {
    av: 16950,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ovine + cloth: animal whose fleece is used to make cloth)',
    english: 'sheep',
    swedish: 'får',
    norwegian: 'sau, får (subst.)',
    finnish: 'lammas',
    hungarian: 'juh, birka',
    german: 'Schaf',
    dutch: 'schaap',
    afrikaans: 'skaap',
    russian: 'баран, овца',
    latvian: 'aita, auns',
    polish: 'owca',
    french: 'mouton',
    spanish: 'oveja',
  },
  {
    av: 16951,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + bed)',
    english: 'sheet(s), bedclothes, bed linen',
    swedish: 'lakan',
    norwegian: 'sengetøy',
    finnish: 'lakana',
    hungarian: 'ágynemű',
    german: 'Bettlaken, Laken',
    dutch: 'laken, dekbedhoes, hoeslaken, deken',
    afrikaans: 'laken(s), beddegoed, linne, deken, kombers',
    russian: 'постельное бельё',
    latvian: 'palags (-i), gultasveļa',
    polish: 'pościel, bielizna pościelowa, poszewki',
    french: 'drap de lit',
    spanish: 'sábanas, ropa de cama, ropa blanca, blanquería',
  },
  {
    av: 16952,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + shekel (character); the Israeli currency shekel)',
    english: 'shekel',
    swedish: 'shekel',
    norwegian: 'shekel (israelsk valuta)',
    finnish: 'sekeli',
    hungarian: 'sékel (héber)',
    german: 'Scheckel (israelische Währung)',
    dutch: 'shekel (geld Joods)',
    afrikaans: 'sikkel',
    russian: 'шекель',
    latvian: 'šekelis',
    polish: 'szekel (izraelska moneta)',
    french: 'shekel (pièce de monnaie israélienne)',
    spanish: 'siclo (dinero)',
  },
  {
    av: 16955,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + protection)',
    english: 'shelter, refuge',
    swedish: 'skyddsrum',
    norwegian: 'tilfluktsrom',
    finnish: 'suoja, turvapaikka',
    hungarian: 'menedék, búvóhely, rejtekhely',
    german: 'Zuflucht, Schutzort',
    dutch: 'schuilplaats',
    afrikaans: 'skuiling, toevlug',
    russian: 'приют, убежище',
    latvian: 'pajumte, patvērums',
    polish: 'schronienie, azyl',
    french: 'abri, refuge',
    spanish: 'refugio',
  },
  {
    av: 16956,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(sun + action indicator)',
    english: 'shine, beam-(to)',
    swedish: 'lysa, skina',
    norwegian: 'skinne, stråle',
    finnish: 'aurinko paistaa',
    hungarian: 'sütni (Nap), sugározni',
    german: '(aus)strahlen, beamen, leuchten',
    dutch: 'schijnen (zon)',
    afrikaans: 'skyn, ligstraal (om te)',
    russian: 'светить, сиять, озарять',
    latvian: 'starot, izstarot',
    polish: 'świecić, lśnić',
    french: 'briller',
    spanish: 'brillar',
  },
  {
    av: 16957,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + chest: clothing that covers the upper part of the body)',
    english: 'shirt, blouse',
    swedish: 'blus, skjorta, tröja (etc)',
    norwegian: 'skjorte, bluse, trøye',
    finnish: 'paita, pusero',
    hungarian: 'ing, blúz, ingblúz',
    german: 'Hemd, Bluse',
    dutch: 'blouse, bloes, overhemd',
    afrikaans: 'hemp, bloes',
    russian: 'блузка, рубашка',
    latvian: 'krekls, blūze',
    polish: 'koszula, bluzka',
    french: 'chemise',
    spanish: 'camisa, blusa',
  },
  {
    av: 16958,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(god + destruction: Hindu god) (India)',
    english: 'Shiva',
    swedish: 'Shiva (Indien)',
    norwegian: 'Shiva (India)',
    finnish: 'Shiva',
    hungarian: 'Síva (a pusztítás hindu Istene)',
    german: 'Shiva (Hindu-Gott)',
    dutch: 'Shiva (Indisch)',
    afrikaans: 'Shiva',
    russian: 'Шива (Индия)',
    latvian: 'Šiva (Indiešu)',
    polish: 'Śiwa (indyjskie bóstwo zniszczenia)',
    french: 'Shiva',
    spanish: 'Shiva',
  },
  {
    av: 16959,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + foot: protective covering for the feet)',
    english: 'shoe',
    swedish: 'skor',
    norwegian: 'sko',
    finnish: 'kenkä',
    hungarian: 'cipő, lábbeli, saru',
    german: 'Schuh',
    dutch: 'schoen',
    afrikaans: 'skoen',
    russian: 'обувь, туфли',
    latvian: 'kurpe (-es), apavi',
    polish: 'buty',
    french: 'chaussure',
    spanish: 'zapato',
  },
  {
    av: 16960,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(horn + Jewish)',
    english: 'shofar',
    swedish: 'shofar (Israel)',
    norwegian: 'shofar (Israel)',
    finnish: 'Šofar, shofar',
    hungarian: 'sófár (héber)',
    german: 'sjofar, Shofar',
    dutch: 'shofar (Joods)',
    afrikaans: 'shofar',
    russian: 'шофар (Израиль)',
    latvian: 'šofars',
    polish: 'szofar (róg hebr.)',
    french: 'shofar',
    spanish: 'shofar',
  },
  {
    av: 16962,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(shortness (distance, length) + description indicator: horizontal line is relatively short) See also: low, short 15401 and long 15229.',
    english: 'short',
    swedish: 'kort',
    norwegian: 'kort',
    finnish: 'lyhyt',
    hungarian: 'rövid',
    german: 'kurz',
    dutch: 'kort',
    afrikaans: 'kort',
    russian: 'короткий',
    latvian: 'īss',
    polish: 'krótki',
    french: 'court',
    spanish: 'corto',
  },
  {
    av: 16963,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(trousers + comma + short)',
    english: 'shorts',
    swedish: 'kortbyxor, shorts',
    norwegian: 'kortbukse, shorts',
    finnish: 'shortsit',
    hungarian: 'sort, rövidnadrág',
    german: 'kurze Hose, Shorts',
    dutch: 'korte broek, short',
    afrikaans: 'kortbroek',
    russian: 'шорты',
    latvian: 'šorti',
    polish: 'szorty, krótkie spodenki',
    french: 'short',
    spanish: 'pantalones cortos',
  },
  {
    av: 16965,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to say + two intensity symbols + action indicator: to say forcefully)',
    english: 'shout-(to)',
    swedish: 'skrika',
    norwegian: 'skrike',
    finnish: 'huutaa',
    hungarian: 'kiabálni, kiáltani, kiáltozni',
    german: 'laut rufen, schreien, rufen',
    dutch: 'roepen, schreeuwen',
    afrikaans: 'skreeu, skree (om te)',
    russian: 'кричать',
    latvian: 'kliegt',
    polish: 'informować, powiadamiać',
    french: 'crier fort',
    spanish: 'gritar',
  },
  {
    av: 16967,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cause + to observe + action indicator: to cause to be seen)',
    english: 'show, demonstrate-(to)',
    swedish: 'visa, demonstrera',
    norwegian: 'vise, demonstrere',
    finnish: 'näyttää, osoittaa',
    hungarian: 'megmutatni, szemléltetni, bemutatni, demonstrálni',
    german: 'zeigen',
    dutch: 'laten zien, tonen',
    afrikaans: 'wys, demonstreer (om te)',
    russian: 'показывать, демонстрировать',
    latvian: 'rādīt, demonstrēt',
    polish: 'pokazywać, demonstrować',
    french: 'montrer, faire voir',
    spanish: 'mostrar, presentar',
  },
  {
    av: 16969,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(shower + action indicator)',
    english: 'shower-(to)',
    swedish: 'duscha',
    norwegian: 'dusje',
    finnish: 'olla suihkussa, käydä suihkussa, suihkuttaa',
    hungarian: 'zuhanyozni, tusolni',
    german: 'duschen',
    dutch: 'douchen',
    afrikaans: 'stort (om te)',
    russian: 'принимать душ',
    latvian: 'iet dušā',
    polish: 'brać prysznic, natrysk',
    french: 'doucher-(se)',
    spanish: 'ducharse, duchar',
  },
  {
    av: 16970,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + to see: building in which to see shows)',
    english: 'exhibition hall, showplace',
    swedish: 'utställningshall, galleri',
    norwegian: 'kino, teater, utstillingshall',
    finnish: 'messuhalli, näyttelyhalli',
    hungarian: 'bemutatóterem ',
    german: 'Ausstellungshalle, Messehalle',
    dutch: 'schouwburg, theater',
    afrikaans: 'skou saal, teater',
    russian: 'театр',
    latvian: 'izstāžu zāle, ekspozīcija, galerija',
    polish: 'sala wystawowa, wystawa, atrakcja warta zobaczenia',
    french: "théâtre, salle d'exposition",
    spanish: 'sitio de interés turístico',
  },
  {
    av: 16971,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + birth + tree + plural indicator: month of Tu B’Shvat)',
    english: 'Shevat, Shvat',
    swedish: 'Shvat, Shevat',
    norwegian: 'Shvat (Israel)',
    finnish: 'sevat, sebat',
    hungarian: 'Sevat (héber)',
    german: 'Shvat',
    dutch: 'Shevat (Joods)',
    afrikaans: 'Shevat',
    russian: 'шват (Израиль)',
    latvian: 'Ševats (ebreju kalendāra 5. mēnesis)',
    polish: 'Szwat (hebrajski miesiąc)',
    french: 'Shevat (11e mois du calendrier juif)',
    spanish: 'Shevat',
  },
  {
    av: 16972,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(offspring, child + 2: male or female family member considered in relation to another child of the same parents)',
    english: 'sibling(s)',
    swedish: 'syskon',
    norwegian: 'søsken',
    finnish: 'sisarus, yksi sisaruksista',
    hungarian: 'testvér',
    german: 'Geschwister',
    dutch: 'brus (broer of zus)',
    afrikaans: 'broers of susters',
    russian: 'брат и сестра',
    latvian: 'vienu vecāku bērni, brālis un māsa',
    polish: 'rodzeństwo',
    french: 'frère ou sœur, fratrie',
    spanish: 'hermano',
  },
  {
    av: 16973,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(illness + description indicator)',
    english: 'sick, ill',
    swedish: 'sjuk',
    norwegian: 'syk',
    finnish: 'sairas, kipeä',
    hungarian: 'beteg',
    german: 'krank',
    dutch: 'ziek',
    afrikaans: 'siek, knieserig',
    russian: 'больной',
    latvian: 'slims, saslimis, saslimusi',
    polish: 'chory, schorowany, bolący',
    french: 'malade',
    spanish: 'enfermo',
  },
  {
    av: 16977,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(enclosure + attention: large square that attracts one's attention) SYMBOL SYNONYM",
    english: 'sign, advertisement',
    swedish: 'signal, skylt',
    norwegian: 'skilt, varsel',
    finnish: 'merkki, ilmoitus',
    hungarian: 'reklám',
    german: 'Schild, Werbeplakat',
    dutch: 'wegwijzer, aankondiging, reclame',
    afrikaans: 'advertensie, teken',
    russian: 'вывеска',
    latvian: 'izkārtne, sludinājums',
    polish: 'reklama, tablica informacyjna, baner',
    french: 'annonce, publicité, panneau publicitaire',
    spanish: 'signo, anuncio',
  },
  {
    av: 16979,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(to write + name: writing of one's name)",
    english: 'signature',
    swedish: 'namnteckning',
    norwegian: 'signatur',
    finnish: 'nimikirjoitus, allekirjoitus',
    hungarian: 'aláírás',
    german: 'Unterschrift',
    dutch: 'handtekening',
    afrikaans: 'handtekening',
    russian: 'подпись',
    latvian: 'paraksts',
    polish: 'podpis, sygnatura',
    french: 'signature',
    spanish: 'firma',
  },
  {
    av: 16980,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + signature)',
    english: 'signature stamp',
    swedish: 'namnstämpel',
    norwegian: 'navnestempel',
    finnish: 'nimileimasin',
    hungarian: 'névbélyegző',
    german: 'Unterschriftsstempel',
    dutch: 'handtekeningstempel',
    afrikaans: 'handtekening stempel',
    russian: 'штамп именной',
    latvian: 'grifs, zīmogs',
    polish: 'pieczątka imienna',
    french: 'signature, cachet, tampon',
    spanish: 'estampilla',
  },
  {
    av: 16981,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(minus + sound: absence of sound)',
    english: 'silence, quiet',
    swedish: 'tystnad',
    norwegian: 'stillhet',
    finnish: 'hiljaisuus, äänettömyys',
    hungarian: 'csend, csendesség, hallgatás',
    german: 'Stille',
    dutch: 'stilte',
    afrikaans: 'stilte',
    russian: 'тишина',
    latvian: 'klusums, miers',
    polish: 'cisza, milczenie, brak dźwięków',
    french: 'silence',
    spanish: 'silencio',
  },
  {
    av: 16982,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(silence + description indicator)',
    english: 'silent',
    swedish: 'tyst, låg, lågmäld',
    norwegian: 'stille',
    finnish: 'hiljainen, äänetön',
    hungarian: 'csendes, zajtalan',
    german: 'still, ruhig, schweigsam, wortkarg',
    dutch: 'stil',
    afrikaans: 'stil',
    russian: 'тихий',
    latvian: 'kluss, mierīgs',
    polish: 'cichy, milczący',
    french: 'silencieux',
    spanish: 'silencioso',
  },
  {
    av: 16983,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(holiday + Torah)',
    english: 'Simchat Torah',
    swedish: 'Simchat Torah (Israel)',
    norwegian: 'Simchat Torah (Israel)',
    finnish: 'simhat tora, Tooran ilojuhla',
    hungarian: 'Simchat Tóra (héber)',
    german: 'Simchat Torah',
    dutch: 'Simchat Torah (Joods)',
    afrikaans: 'Simchat Torah',
    russian: 'Симхат Тора (Израиль)',
    latvian: 'Toras Simhats (Izraēla)',
    polish: 'Simchat Tora, Sukkot (hebr.)',
    french: 'Simchat Torah (fête juive)',
    spanish: 'Simchat Torah',
  },
  {
    av: 16984,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(near + same: nearly the same)',
    english: 'similar, like, alike',
    swedish: 'nästan samma som, liknande',
    norwegian: 'nesten samme som, liknende',
    finnish: 'melkein sama, noin, samankaltainen, melkein sama kuin',
    hungarian: 'hasonló, hasonlóság',
    german: 'ähnlich, gleichartig',
    dutch: 'gelijkend op, ongeveer, net zoiets als, lijkt op',
    afrikaans: 'soortgelyke, soos, gelyk',
    russian: 'похожий',
    latvian: 'līdzīgs',
    polish: 'podobnie, podobnie jak',
    french: 'semblable',
    spanish: 'similar, parecido',
  },
  {
    av: 16985,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(similar + eye)',
    english: 'similar looking, looks similar',
    swedish: 'ser nästan ut som',
    norwegian: 'ser ut som',
    finnish:
      'näyttää samalta, melkein samanlainen kuin, näyttää samalta kuin, näyttää melkein samalta kuin',
    hungarian: 'hasonló küllem, hasonló kinézet',
    german: 'sieht ähnlich aus wie',
    dutch: 'gelijk uitziend, ziet eruit als',
    afrikaans: 'soortgelyke soos, gelyk',
    russian: 'похожий внешне',
    latvian: 'līdzīgs uzskats',
    polish: 'podobnie wyglądający',
    french: 'aspect similaire',
    spanish: 'de aspecto similar',
  },
  {
    av: 16986,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(similar + sound)',
    english: 'similar sound, sounds like',
    swedish: 'låter nästan lika, låter nästan som',
    norwegian: 'høres nesten ut som',
    finnish: 'kuulostaa melkein samalta kuin, melkein samalta kuulostava',
    hungarian: 'hasonló hangzás',
    german: 'klingt ähnlich wie',
    dutch: 'gelijkluidend, klinkt als',
    afrikaans: 'soortgelyke klank, klanke soos',
    russian: 'похожий по звучанию',
    latvian: 'līdzīga skaņa, izklausās kā..',
    polish: 'podobnie brzmiący',
    french: 'son semblable',
    spanish: 'sonido similar',
  },
  {
    av: 16987,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cook + water + action indicator)',
    english: 'simmer, poach-(to)',
    swedish: 'sjuda',
    norwegian: 'småkoke',
    finnish: 'kiehua, kuohua',
    hungarian: 'párolni, lassú tűzön főzni/készíteni, buggyantani',
    german: 'simmern, sieden (lassen)',
    dutch: 'pocheren, sudderen',
    afrikaans: 'stowe (om te)',
    russian: 'закипать',
    latvian: 'vārīties, uzvārīties',
    polish: 'dusić, gotować',
    french: 'mijoter, frémir',
    spanish: 'cocinar a fuego lento',
  },
  {
    av: 16988,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(wrong + God: something wrong in God's eyes)",
    english: 'sin',
    swedish: 'synd',
    norwegian: 'synd',
    finnish: 'synti',
    hungarian: 'bűn, vétek (vallási értelemben)',
    german: 'Sünde',
    dutch: 'zonde',
    afrikaans: 'sonde',
    russian: 'грех',
    latvian: 'grēks',
    polish: 'grzech',
    french: 'péché',
    spanish: 'pecado',
  },
  {
    av: 16989,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(sin + action indicator)',
    english: 'sin-(to)',
    swedish: 'synda',
    norwegian: 'synde',
    finnish: 'tehdä syntiä',
    hungarian: 'bűnözni, vétkezni (vallási értelemben)',
    german: 'sündigen',
    dutch: 'zondigen',
    afrikaans: 'sondig (om te)',
    russian: 'грешить',
    latvian: 'grēkot',
    polish: 'grzeszyć',
    french: 'pécher',
    spanish: 'pecar',
  },
  {
    av: 16990,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(song + action indicator)',
    english: 'sing-(to)',
    swedish: 'sjunga',
    norwegian: 'synge',
    finnish: 'laulaa',
    hungarian: 'énekelni',
    german: 'singen',
    dutch: 'zingen',
    afrikaans: 'sing (om te)',
    russian: 'петь',
    latvian: 'dziedāt',
    polish: 'śpiewać',
    french: 'chanter',
    spanish: 'cantar',
  },
  {
    av: 16991,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to sing)',
    english: 'singer',
    swedish: 'sångare, sångerska',
    norwegian: 'sanger',
    finnish: 'laulaja',
    hungarian: 'énekes',
    german: 'Sänger, Sängerin',
    dutch: 'zanger',
    afrikaans: 'sanger',
    russian: 'певец, певица',
    latvian: 'dziedatājs (-a)',
    polish: 'piosenkarz',
    french: 'chanteur',
    spanish: 'cantante',
  },
  {
    av: 16993,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + sin: person who sins)',
    english: 'sinner',
    swedish: 'syndare',
    norwegian: 'synder',
    finnish: 'syntinen ihminen',
    hungarian: 'bűnös, vétkes (fn.; vallási értelemben)',
    german: 'Sünder, Sünderin',
    dutch: 'zondaar',
    afrikaans: 'sondaar',
    russian: 'грешник, грешница',
    latvian: 'grēcinieks, grēciniece',
    polish: 'grzesznik',
    french: 'pécheur',
    spanish: 'pecador(a)',
  },
  {
    av: 16994,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(daughter + 2: daughter considered in relation to another child of her parents)',
    english: 'sister',
    swedish: 'syster',
    norwegian: 'søster',
    finnish: 'sisko, sisar',
    hungarian: 'lánytestvér, nővér, húg',
    german: 'Schwester',
    dutch: 'zus, zusje',
    afrikaans: 'suster, sussie, sus',
    russian: 'сестра',
    latvian: 'māsa',
    polish: 'siostra',
    french: 'sœur',
    spanish: 'hermana',
  },
  {
    av: 16995,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(seat, sitting (sitting person) + action indicator)',
    english: 'sit-(to)',
    swedish: 'sitta',
    norwegian: 'sitte',
    finnish: 'istua',
    hungarian: 'ülni',
    german: 'sitzen',
    dutch: 'zitten',
    afrikaans: 'sit (om te)',
    russian: 'сидеть',
    latvian: 'sēdēt',
    polish: 'siadać',
    french: "asseoir-(s')",
    spanish: 'sentar, sentarse',
  },
  {
    av: 16996,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + commandments: month of the holiday of Shavout)',
    english: 'Sivan',
    swedish: 'Sivan (Israel)',
    norwegian: 'Sivan (Israel)',
    finnish: 'sivan, siván',
    hungarian: 'Sivan (héber)',
    german: 'Sivan',
    dutch: 'Sivan (Joods)',
    afrikaans: 'Sivan',
    russian: 'Сиван (Израиль)',
    latvian: 'Sivans (ebr. Kalendāra 3. mēnesis)',
    polish: 'Siwan, miesiąc hebr.',
    french: 'Sivan (3e mois du calendrier juif)',
    spanish: 'Sivan',
  },
  {
    av: 16998,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(structure + creature + thing indicator: supporting structure of a living creature)',
    english: 'skeleton',
    swedish: 'skelett',
    norwegian: 'skjelett',
    finnish: 'luuranko, luusto',
    hungarian: 'csontváz',
    german: 'Skelett',
    dutch: 'skelet',
    afrikaans: 'skelet',
    russian: 'скелет',
    latvian: 'skelets',
    polish: 'szkielet',
    french: 'squelette',
    spanish: 'esqueleto',
  },
  {
    av: 16999,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boot(s) + ski)',
    english: 'ski boot(s)',
    swedish: 'kängor, pjäxor',
    norwegian: 'skistøvel, skistøvler',
    finnish: 'monot, hiihtokengät',
    hungarian: 'sícipő',
    german: 'Skischuh, Skistiefel',
    dutch: 'skischoenen',
    afrikaans: 'ski stewel(s)',
    russian: 'лыжные ботинки',
    latvian: 'slēpju zābaki',
    polish: 'buty narciarskie',
    french: 'chaussure de skis',
    spanish: 'botas de esquí',
  },
  {
    av: 17000,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(2 + linear thing + ski + thing indicator)',
    english: 'ski pole(s)',
    swedish: 'stavar',
    norwegian: 'skistav, skistaver',
    finnish: 'suksisauvat, suksikepit',
    hungarian: 'síbot',
    german: 'Skistock',
    dutch: 'skistok(ken)',
    afrikaans: 'ski paal pale',
    russian: 'лыжная палка',
    latvian: 'slēpošanas nūjas',
    polish: 'kijki do nart',
    french: 'bâtons de ski',
    spanish: 'bastones de esquí',
  },
  {
    av: 17001,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + body: protective covering for the body)',
    english: 'skin',
    swedish: 'hud, skinn',
    norwegian: 'hud, skinn',
    finnish: 'iho, nahka',
    hungarian: 'bőr',
    german: 'Haut',
    dutch: 'huid',
    afrikaans: 'vel, huid',
    russian: 'кожа',
    latvian: 'āda',
    polish: 'skóra',
    french: 'peau (corps humain)',
    spanish: 'piel',
  },
  {
    av: 17002,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(clothing, clothes, garment + woman (below waist): can also be explained as dress + pointer, to skirt)',
    english: 'skirt',
    swedish: 'kjol',
    norwegian: 'skjørt',
    finnish: 'hame, mekko, leninki',
    hungarian: 'szoknya',
    german: 'Rock',
    dutch: 'rok',
    afrikaans: 'romp',
    russian: 'юбка',
    latvian: 'svārki',
    polish: 'spódnica',
    french: 'jupe',
    spanish: 'falda',
  },
  {
    av: 17003,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(2 + ski)',
    english: 'skis (pair of)',
    swedish: 'skidor',
    norwegian: 'ski',
    finnish: 'sukset',
    hungarian: 'síléc',
    german: 'Skier (2 Stück, ein Paar)',
    dutch: "ski('s)",
    afrikaans: "ski's (paar)",
    russian: 'лыжа',
    latvian: 'slēpe (-es)',
    polish: 'narty',
    french: 'skis',
    spanish: 'esquís',
  },
  {
    av: 17004,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hat + Jewish: head covering for religious purposes)',
    english: 'skullcap, kipa, yarmulke',
    swedish: 'kalott (Israel)',
    norwegian: 'kalott (Israel)',
    finnish: 'kipa',
    hungarian: 'kipa, kis kerek sapka (héber)',
    german: 'Kalot',
    dutch: 'keppel (Joods)',
    afrikaans: 'skullup, kipa, yarmulke',
    russian: 'кипа (еврейская шапочка)',
    latvian: 'cepurīte, micīte, skufija (Izraēla)',
    polish: 'jarmułka (hebr.)',
    french: 'couvre-chef juif, kippa',
    spanish: 'casquete, kipa',
  },
  {
    av: 17005,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + to smell bad: animal that gives off a disagreeable smell)',
    english: 'skunk',
    swedish: 'skunk',
    norwegian: 'skunk, stinkdyr',
    finnish: 'haisunäätä, skunkki',
    hungarian: 'görény',
    german: 'Stinktier',
    dutch: 'stinkdier',
    afrikaans: 'muishond',
    russian: 'скунс',
    latvian: 'skunkss',
    polish: 'skunks',
    french: 'moufette',
    spanish: 'zorrillo',
  },
  {
    av: 17009,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(sleep + action indicator)',
    english: 'sleep-(to)',
    swedish: 'sova',
    norwegian: 'sove',
    finnish: 'nukkua',
    hungarian: 'aludni',
    german: 'schlafen',
    dutch: 'slapen',
    afrikaans: 'sleep (om te)',
    russian: 'спать',
    latvian: 'gulēt',
    polish: 'spać, zasypiać',
    french: 'dormir',
    spanish: 'dormir',
  },
  {
    av: 17010,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sack + to sleep)',
    english: 'sleeping bag',
    swedish: 'sovsäck',
    norwegian: 'sovepose',
    finnish: 'makuupussi',
    hungarian: 'hálózsák',
    german: 'Schlafsack',
    dutch: 'slaapzak',
    afrikaans: 'slaapsak',
    russian: 'спальный мешок',
    latvian: 'guļammaiss',
    polish: 'śpiwór',
    french: 'sac de couchage',
    spanish: 'saco de dormir',
  },
  {
    av: 17011,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(downward and forward + thing indicator: thing for sliding) - (character with thing indicator)',
    english: 'slide',
    swedish: 'rutschbana',
    norwegian: 'rutsjebane',
    finnish: 'liukumäki',
    hungarian: 'csúszda',
    german: 'Rutsche, Rutschbahn',
    dutch: 'glijbaan',
    afrikaans: 'glybaan',
    russian: 'горка',
    latvian: 'slidkalniņš',
    polish: 'zjazd, ślizg',
    french: 'toboggan',
    spanish: 'tobogán',
  },
  {
    av: 17012,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dress + under)',
    english: 'slip, petticoat, half-slip, underskirt',
    swedish: 'underkjol, underklänning',
    norwegian: 'underkjole, underskjørt',
    finnish: 'alushame',
    hungarian: 'aalsószoknya, kombiné',
    german: 'Unterrock, Unterkleid',
    dutch: 'onderjurk, onderkleding (vrouw)',
    afrikaans: 'onderrok',
    russian: 'нижняя юбка, комбинация',
    latvian: 'apakšsvārki',
    polish: 'halka, koszulka pod sukienkę (bielizna)',
    french: 'jupon, combinaison',
    spanish: 'combinación, viso, enagua',
  },
  {
    av: 17013,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shoe + comma + house: shoe worn mainly indoors)',
    english: 'slipper(s)',
    swedish: 'tofflor, inneskor',
    norwegian: 'tøffel, innesko',
    finnish: 'tossut',
    hungarian: 'papucs, házicipő, mamusz',
    german: 'Hausschuh, Pantoffel',
    dutch: 'pantoffel',
    afrikaans: 'pantoffel(s)',
    russian: 'тапочки',
    latvian: 'rītakurpes, čības',
    polish: 'kapeć, laczek',
    french: 'pantoufle',
    spanish: 'pantuflas',
  },
  {
    av: 17015,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(smartness, brightness, cleverness, intelligence + description indicator: having striking mental abilities)',
    english: 'smart, bright, clever, intelligent',
    swedish: 'klok, begåvad, förståndig',
    norwegian: 'smart, lur, skarp, klok',
    finnish: 'viisas, etevä, nokkela, älykäs',
    hungarian: 'okos, eszes, értelmes, intelligens',
    german: 'klug, tüchtig, gescheit, schlau, intelligent',
    dutch: 'intelligent, slim, knap',
    afrikaans: 'skerp, slim, intelligent, knap',
    russian: 'умный',
    latvian: 'gudrs, saprātīgs, gudrs, inteliģents',
    polish: 'mądry, inteligentny, sprytny',
    french: 'intelligent',
    spanish: 'inteligente, brillante, astuto',
  },
  {
    av: 17016,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to break + many + piece + action indicator)',
    english: 'smash, grind, shatter, splinter-(to)',
    swedish: 'mala, krossa',
    norwegian: 'knuse, male',
    finnish: 'murskata, särkeä, särkyä, pirstoa, jauhaa',
    hungarian: 'összetörni, darabokra törni, szilánkokra törni',
    german: 'zertrümmern, zerschlagen, zersplittern',
    dutch: 'kapot gooien, breken',
    afrikaans: 'splinter, breek, maal, verbrysel (om te)',
    russian: 'измельчать, крошить',
    latvian: 'drupināt, sasmalcināt',
    polish: 'rozbijać, tłuc',
    french: 'casser en morceaux, écraser',
    spanish: 'machacar, moler',
  },
  {
    av: 17018,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(nose + action indicator)',
    english: 'smell-(to)',
    swedish: 'lukta, nosa',
    norwegian: 'lukte',
    finnish: 'tuoksua, haista, haistaa',
    hungarian: 'szagolni',
    german: 'riechen',
    dutch: 'ruiken',
    afrikaans: 'ruik (om te)',
    russian: 'нюхать',
    latvian: 'smaržot, sasmaržot',
    polish: 'pachnieć',
    french: 'sentir, flairer',
    spanish: 'oler',
  },
  {
    av: 17019,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(smell + action indicator: to give off a smell or odour)',
    english: 'smell, give off odour-(to)',
    swedish: 'lukta',
    norwegian: 'dufte',
    finnish: 'haistaa, haista, tuoksua',
    hungarian: 'szaglani',
    german: 'duften, riechen',
    dutch: 'geuren',
    afrikaans: ' geur, reuk (af gee) (om te)',
    russian: 'пахнуть, издавать запах',
    latvian: 'smaržot, izgarot aromātu',
    polish: 'czuć zapach, wąchać',
    french: 'sentir, dégager une odeur',
    spanish: 'oler',
  },
  {
    av: 17020,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to smell + negative + action indicator)',
    english: 'smell bad, stink-(to)',
    swedish: 'lukta illa, stinka',
    norwegian: 'lukte vondt, stinke',
    finnish: 'haista pahalta, lemuta',
    hungarian: 'bűzleni, rossz szagot árasztani',
    german: 'stinken, stinkend',
    dutch: 'stinken, vies ruiken',
    afrikaans: 'stink, sleg ruik (om te)',
    russian: 'вонять, смердеть',
    latvian: 'smirdēt',
    polish: 'śmierdzieć',
    french: 'sentir mauvais, puer',
    spanish: 'oler mal, apestar',
  },
  {
    av: 17021,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(happy + face + action indicator: to make a happy face)',
    english: 'smile, grin-(to)',
    swedish: 'le',
    norwegian: 'smile',
    finnish: 'hymyillä',
    hungarian: 'mosolyogni, vigyorogni',
    german: 'lächeln, grinsen',
    dutch: 'glimlachen, grijnzen',
    afrikaans: 'glimlag, gryslag (om te)',
    russian: 'улыбаться',
    latvian: 'smaidīt, plati smaidīt',
    polish: 'uśmiechać się',
    french: 'sourire',
    spanish: 'sonreír',
  },
  {
    av: 17022,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloud + fire)',
    english: 'smoke',
    swedish: 'rök',
    norwegian: 'røyk',
    finnish: 'savu',
    hungarian: 'füst',
    german: 'Rauch',
    dutch: 'rook',
    afrikaans: 'rook',
    russian: 'дым',
    latvian: 'dūmi',
    polish: 'dym',
    french: 'fumée',
    spanish: 'humo',
  },
  {
    av: 17185,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(smoking (cigarette) + action indicator)',
    english: 'smoke-(to)',
    swedish: 'röka',
    norwegian: 'røyke',
    finnish: 'tupakoida',
    hungarian: 'dohányozni',
    german: 'rauchen (Zigarette)',
    dutch: 'roken',
    afrikaans: 'rook (om te)',
    russian: 'курить',
    latvian: 'smēķēt',
    polish: 'palić (papierosy)',
    french: 'fumer',
    spanish: 'fumar',
  },
  {
    av: 17186,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(hand + glass + description indicator: feeling like glass)',
    english: 'smooth',
    swedish: 'jämn, slät',
    norwegian: 'glatt, jevn',
    finnish: 'sileä',
    hungarian: 'sima, egyenletes, elsimult, redőtlen',
    german: 'glatt, eben, weich (Oberfläche)',
    dutch: 'glad, effen',
    afrikaans: 'glad',
    russian: 'гладкий, ровный',
    latvian: 'gluds, vienmērīgs',
    polish: 'gładki, płynny',
    french: 'lisse',
    spanish: 'liso, suave',
  },
  {
    av: 17187,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meal + comma + little: small or light meal)',
    english: 'snack (food)',
    swedish: 'mellanmål (litet mål)',
    norwegian: 'mellommat',
    finnish: 'välipala',
    hungarian: ' falat, falatka, gyorsétkezés, kóstoló, snack',
    german: 'Imbiss, Snack, Kleinigkeit zu essen',
    dutch: 'hapje, tussendoortje',
    afrikaans: 'happie (voedsel)',
    russian: 'полдник, перекус',
    latvian: 'uzkožamais ',
    polish: 'przekąska (mała porcja)',
    french: 'casse-croûte, snack',
    spanish: 'refrigerio (alimento)',
  },
  {
    av: 17191,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(nose + to blow + intensity + action indicator: to blow air forcefully from one's nose)",
    english: 'sneeze-(to)',
    swedish: 'nysa',
    norwegian: 'nyse',
    finnish: 'aivastaa',
    hungarian: 'tüsszenteni',
    german: 'niesen',
    dutch: 'niezen',
    afrikaans: 'nies (om te)',
    russian: 'чихать',
    latvian: 'šķaudīt',
    polish: 'kichać',
    french: 'éternuer',
    spanish: 'estornudar',
  },
  {
    av: 17193,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(snow + action indicator)',
    english: 'snow-(to)',
    swedish: 'snöa',
    norwegian: 'snø',
    finnish: 'sataa lunta',
    hungarian: 'havazni',
    german: 'schneien',
    dutch: 'sneeuwen',
    afrikaans: 'sneeu (om te)',
    russian: 'снег идёт',
    latvian: 'snigt',
    polish: 'pada śnieg, śnieży',
    french: 'neiger',
    spanish: 'nevar',
  },
  {
    av: 17194,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(snow + ball: snow shaped into a ball)',
    english: 'snowball',
    swedish: 'snöboll',
    norwegian: 'snøball',
    finnish: 'lumipallo',
    hungarian: 'hólabda',
    german: 'Schneeball',
    dutch: 'sneeuwbal ',
    afrikaans: 'sneeubal',
    russian: 'снежок',
    latvian: 'sniega pika',
    polish: 'śnieżka, śnieżna kula',
    french: 'boule de neige',
    spanish: 'bola de nieve',
  },
  {
    av: 17196,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(snow + man: snow shaped like a man)',
    english: 'snowman',
    swedish: 'snögubbe',
    norwegian: 'snømann',
    finnish: 'lumiukko',
    hungarian: 'hóember',
    german: 'Schneemann',
    dutch: 'sneeuwpop',
    afrikaans: 'sneeuman',
    russian: 'снежная баба, снеговик',
    latvian: 'sniegavīrs',
    polish: 'bałwan',
    french: 'bonhomme de neige',
    spanish: 'muñeco de nieve',
  },
  {
    av: 17198,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(storm + snow)',
    english: 'snowstorm',
    swedish: 'snöstorm',
    norwegian: 'snøstorm',
    finnish: 'lumimyrsky',
    hungarian: 'hóvihar',
    german: 'Schneesturm',
    dutch: 'sneeuwstorm',
    afrikaans: 'sneeustorm',
    russian: 'метель',
    latvian: 'sniegputenis',
    polish: 'zamieć, śnieżyca',
    french: 'tempête de neige',
    spanish: 'nevada',
  },
  {
    av: 17199,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + snow)',
    english: 'snowsuit, winter clothing',
    swedish: 'vinterkläder',
    norwegian: 'vinterklær',
    finnish: 'talvivaatteet',
    hungarian: 'hódzseki, téli öltözet',
    german: 'Skianzug, Winterbekleidung',
    dutch: 'skikleding, sneeuwkleding',
    afrikaans: 'sneeupak, winter klere',
    russian: 'зимний комбинезон',
    latvian: 'ziemas kombinezons, ziemas drēbes',
    polish: 'ubranie zimowe',
    french: 'vêtement de neige',
    spanish: 'traje de invierno',
  },
  {
    av: 17200,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + to wash)',
    english: 'soap, detergent',
    swedish: 'tvål, tvättmedel',
    norwegian: 'såpe, vaskemiddel',
    finnish: 'saippua',
    hungarian: 'szappan, mosópor, mosószer, detergens',
    german: 'Seife, Waschmittel',
    dutch: 'zeep',
    afrikaans: 'seep',
    russian: 'мыло',
    latvian: 'ziepes, mazājamais līdzeklis',
    polish: 'mydło, płyn do mycia',
    french: 'savon',
    spanish: 'jabón, detergente',
  },
  {
    av: 17201,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(worker + to help + person: person whose work consists of helping others)',
    english: 'social worker',
    swedish: 'kurator (etc)',
    norwegian: 'kurator, sosialarbeider',
    finnish: 'sosiaalityöntekijä',
    hungarian: 'szociális munkás, szociális gondozó',
    german: 'Sozialarbeiter, Sozialarbeiterin',
    dutch: 'maatschappelijk werker',
    afrikaans: 'maatskaplike werker, sosiale werker',
    russian: 'социальный работник',
    latvian: 'sociālais darbinieks',
    polish: 'pracownik socjalny, pracownik opieki społecznej',
    french: 'assistant social',
    spanish: 'trabajador social',
  },
  {
    av: 17202,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drink + gas: carbonated drink)',
    english: 'soda pop, pop, soft drink',
    swedish: 'läskedryck, dryck med kolsyra',
    norwegian: 'brus, drikk med kullsyre',
    finnish: 'limonadi, limsa, virvoitusjuoma',
    hungarian: 'szóda, szénsavas üdítő',
    german: 'Limonade, Limo, Erfrischungsgetränk',
    dutch: 'frisdrank',
    afrikaans: 'gaskoeldrank',
    russian: 'газированный напиток',
    latvian: 'soda, gāzēts dzēriens, bezlkoholisks dzēriens',
    polish: 'cola, napój gazowany',
    french: 'boisson gazeuse, soda',
    spanish: 'refresco',
  },
  {
    av: 17203,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(hand + imprint, depression + description indicator)',
    english: 'soft',
    swedish: 'mjuk',
    norwegian: 'bløt, myk',
    finnish: 'pehmeä',
    hungarian: 'puha, lágy',
    german: 'weich',
    dutch: 'zacht (aanvoelen)',
    afrikaans: 'sag',
    russian: 'мягкий',
    latvian: 'mīksts',
    polish: 'miękki, miękkie',
    french: 'mou',
    spanish: 'suave',
  },
  {
    av: 17204,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + war)',
    english: 'soldier, warrior',
    swedish: 'soldat, militär',
    norwegian: 'soldat, militær',
    finnish: 'sotilas',
    hungarian: 'katona',
    german: 'Soldat, Soldatin',
    dutch: 'soldaat',
    afrikaans: 'soldaat',
    russian: 'солдат, военнослужащий',
    latvian: 'kareivis, karavīrs',
    polish: 'żołnierz, wojownik, komandos',
    french: 'soldat',
    spanish: 'soldado',
  },
  {
    av: 17206,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to answer + difficult + action indicator: to answer a difficult question)',
    english: 'solve-(to)',
    swedish: 'lösa (problem), klara',
    norwegian: 'løse (problem), oppklare',
    finnish: 'ratkaista, selvittää',
    hungarian: 'megoldani, oldani',
    german: 'lösen (Problem)',
    dutch: 'oplossen',
    afrikaans: 'oplos (om te)',
    russian: 'решать (проблему)',
    latvian: 'atrisināt, noskaidrot',
    polish: 'rozwiązywać problem',
    french: 'résoudre',
    spanish: 'resolver',
  },
  {
    av: 17207,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(part + description indicator)',
    english: 'some, any',
    swedish: 'endera, någon, en del, vissa',
    norwegian: 'noen, noe, litt, delvis',
    finnish: 'joku, muutama, vähän, hiukan, jokin, kukaan, mikään',
    hungarian: 'néhány, valamennyi',
    german: 'einige, etwas, manch',
    dutch: 'sommige, enkele',
    afrikaans: 'sommige, enige, enkele',
    russian: 'некоторый, любой',
    latvian: 'dažs, daži, dažas',
    polish: 'niektóre, kilka',
    french: 'quelques, un peu, environ',
    spanish: 'algunos, algunas, ciertos',
  },
  {
    av: 17208,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(part of + time: part of the time, i.e., sometimes)',
    english: 'sometimes',
    swedish: 'ibland',
    norwegian: 'av og til, noen ganger, i blant',
    finnish: 'joskus',
    hungarian: 'néha',
    german: 'manchmal, gelegentlich, zuweilen',
    dutch: 'soms',
    afrikaans: 'soms',
    russian: 'иногда',
    latvian: 'dažreiz',
    polish: 'czasem, co jakiś czas',
    french: 'parfois',
    spanish: 'a veces',
  },
  {
    av: 17210,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mouth + musical note: vocal music)',
    english: 'song',
    swedish: 'sång',
    norwegian: 'sang',
    finnish: 'laulu',
    hungarian: 'ének, dal',
    german: 'Lied',
    dutch: 'lied',
    afrikaans: 'lied',
    russian: 'песня',
    latvian: 'dziesma',
    polish: 'piosenka',
    french: 'chanson',
    spanish: 'canción',
  },
  {
    av: 17211,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + song)',
    english: 'songbird, finch, thrush',
    swedish: 'sångfågel',
    norwegian: 'sangfugl',
    finnish: 'laululintu',
    hungarian: 'énekesmadár, pinty, rigó',
    german: 'Singvogel, Fink, Drossel',
    dutch: 'zangvogel',
    afrikaans: 'sangvoël, finch, sproei',
    russian: 'певчая птица',
    latvian: 'dziedātājpunts, žubīte, strazds',
    polish: 'śpiewający ptak (drozd, zięba, słowik)',
    french: 'oiseau chanteur',
    spanish: 'pájaro cantor, pinzón, zorzal',
  },
  {
    av: 17212,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(future + near + description indicator: in the near future)',
    english: 'soon',
    swedish: 'snart',
    norwegian: 'snart',
    finnish: 'pian',
    hungarian: 'hamarosan, nemsokára, a közeljövőben',
    german: 'bald',
    dutch: 'spoedig, binnenkort',
    afrikaans: 'binnekort',
    russian: 'скоро',
    latvian: 'drīz',
    polish: 'wkrótce, w niedalekiej przyszłości',
    french: 'bientôt',
    spanish: 'pronto',
  },
  {
    av: 17213,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to break + skin)',
    english: 'wound, cut, sore',
    swedish: 'sår',
    norwegian: 'sår',
    finnish: 'haava',
    hungarian: 'seb, sebzés, sérülés',
    german: 'Verletzung, Wunde',
    dutch: 'wonde, wond',
    afrikaans: 'wond, sny, seer',
    russian: 'рана, ссадина',
    latvian: 'brūce, savainojums',
    polish: 'rana cięta, zranienie, cięcie',
    french: 'plaie',
    spanish: 'herida, corte',
  },
  {
    av: 17214,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(sadness + about + past)',
    english: 'sorry',
    swedish: 'förlåt, ursäkta',
    norwegian: 'beklager, unnskyld (utsagn)',
    finnish: 'anteeksi',
    hungarian: 'sajnálkozás, sajnos, sajnálat',
    german: 'es tut mir leid, Verzeihung',
    dutch: 'sorry, spijt',
    afrikaans: 'jammer, spyt',
    russian: 'извините, простите',
    latvian: 'atvainojiet, man žēl',
    polish: 'przepraszam, przeprosiny',
    french: 'désolé, navré',
    spanish: 'perdón, disculpe',
  },
  {
    av: 17215,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(disc + Chanukah: traditional sweet eaten at Chanukah)',
    english: 'sufganiya',
    swedish: 'soufganiya, Chanukah kaka (Israel)',
    norwegian: 'soufganiya, Chanukha kaka (Israel)',
    finnish: 'sufganiyot',
    hungarian: 'sufganiya (hanuka sütemény)',
    german: 'Soufganiya (gefüllter Donut Israel)',
    dutch: 'sufganiya (Joods)',
    afrikaans: 'sufganiya',
    russian: 'суфгания (Израиль)',
    latvian: 'sufgania (Izraēla)',
    polish: 'chanuka (święto hebr.)',
    french: 'soufganiot (beignet juif)',
    spanish: 'sufganiya',
  },
  {
    av: 17217,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(sound + action indicator)',
    english: 'sound-(to)',
    swedish: 'ljuda, låta',
    norwegian: 'lyde',
    finnish: 'kuulostaa, kuulua',
    hungarian: 'hallatszani, hangozni, hangzani',
    german: 'klingen',
    dutch: 'klinken',
    afrikaans: 'klink, klank (om te)',
    russian: 'звучать',
    latvian: 'skanēt',
    polish: 'słuchać',
    french: 'sonner, tinter',
    spanish: 'sonar',
  },
  {
    av: 17220,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(south + description indicator)',
    english: 'southern',
    swedish: 'sydlig',
    norwegian: 'sørlig, sydlig',
    finnish: 'eteläinen, etelä-',
    hungarian: 'déli',
    german: 'südlich',
    dutch: 'zuidelijk',
    afrikaans: 'suide, suidelik, suidelike',
    russian: 'южный',
    latvian: 'dienvidu',
    polish: 'południowe, na południu',
    french: 'sudiste, du sud',
    spanish: 'del sur',
  },
  {
    av: 17223,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(feeling + interesting + description indicator)',
    english: 'special, particular',
    swedish: 'särskild',
    norwegian: 'spesiell, særskilt',
    finnish: 'erikoinen, erityinen',
    hungarian: 'különleges, speciális',
    german: 'besonders, speziell, bestimmt',
    dutch: 'bijzonder, speciaal',
    afrikaans: 'spesiaal, besonder(s)',
    russian: 'специальный',
    latvian: 'īpašs, konkrēts',
    polish: 'specjalny, szczególny, wyjątkowy',
    french: 'spécial',
    spanish: 'especial, particular',
  },
  {
    av: 17224,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(the + description indicator)',
    english: 'specific',
    swedish: 'bestämd',
    norwegian: 'bestemt',
    finnish: 'täsmällinen, tarkoin määrätty',
    hungarian: 'bizonyos, specifikus',
    german: 'spezifisch',
    dutch: 'specifiek',
    afrikaans: 'spesifiek',
    russian: 'определенный, специфичный',
    latvian: 'noteiktais(-ā), konkretais(-ā)',
    polish: 'specyficzny, osobliwy',
    french: 'spécifique',
    spanish: 'específico',
  },
  {
    av: 17227,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical product + sperm destruction)',
    english: 'spermicide',
    swedish: 'spermiedödande medel',
    norwegian: 'sæddrepende middel',
    finnish: 'ehkäisyaine',
    hungarian: 'hímivarsejt pusztító, spermaölő, spermicid',
    german: 'samentötendes Mittel, Spermizid',
    dutch: 'zaaddodend middel',
    afrikaans: 'spermdoder',
    russian: 'спермицид',
    latvian: 'spermicīds',
    polish: 'środek plemnikobójczy',
    french: 'spermicide',
    spanish: 'espermicida',
  },
  {
    av: 17228,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + seasoning)',
    english: 'spice box',
    swedish: 'kryddburk (etc)',
    norwegian: 'krydderboks',
    finnish: 'maustepurkki',
    hungarian: 'fűszertartó',
    german: 'Gewürzdose',
    dutch: 'kruidenpotje',
    afrikaans: 'spesery houer',
    russian: 'банка для специй',
    latvian: 'garšvielu trauks',
    polish: 'pojemnik na przyprawy, pieprzniczka',
    french: 'pot à épices',
    spanish: 'bote de especias',
  },
  {
    av: 17230,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + spiral)',
    english: 'spiral, curl (shape)',
    swedish: 'spiral',
    norwegian: 'spiral',
    finnish: 'spiraali',
    hungarian: 'spirál, kacskaringós, göndör',
    german: 'Spirale (Form)',
    dutch: 'krul',
    afrikaans: 'spiraal, krul (vorm)',
    russian: 'спираль',
    latvian: 'spirāle',
    polish: 'spirala, zwój, skręt',
    french: 'spirale (figure géométrique)',
    spanish: 'espiral',
  },
  {
    av: 17231,
    group: 'word',
    pos: 'RED',
    derivationExplanation: "(spitting + action indicator: to expel from one's mouth)",
    english: 'spit-(to)',
    swedish: 'spotta',
    norwegian: 'spytte',
    finnish: 'sylkeä',
    hungarian: 'köpni, kiköpni',
    german: 'spucken',
    dutch: 'spugen, spuwen',
    afrikaans: 'spoeg (om te)',
    russian: 'плевать',
    latvian: 'spļaut',
    polish: 'pluć, spluwać',
    french: 'cracher',
    spanish: 'escupir',
  },
  {
    av: 17232,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to hit + water + action indicator)',
    english: 'splash-(to)',
    swedish: 'plaska',
    norwegian: 'plaske',
    finnish: 'loiskia, roiskia, roiskuttaa',
    hungarian: 'fröcskölni, ki/loccsantani',
    german: 'spritzen, bespritzen, planschen',
    dutch: 'spetteren, plonzen',
    afrikaans: 'plons, spat (om te)',
    russian: 'брызгать',
    latvian: 'šļakstīties',
    polish: 'pluskać, rozbryzgiwać',
    french: 'éclabousser',
    spanish: 'verter',
  },
  {
    av: 17236,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(eye + dot: dot perceived by the eye)',
    english: 'spot, mark',
    swedish: 'fläck, märke',
    norwegian: 'flekk, merke',
    finnish: 'tahra',
    hungarian: 'folt, jel, petty',
    german: 'Fleck, Marke',
    dutch: 'vlek',
    afrikaans: 'merk, vlek',
    russian: 'пятно, метка',
    latvian: 'traips, pleķis',
    polish: 'znak, miejsce, punkt',
    french: 'tache',
    spanish: 'mancha, marca',
  },
  {
    av: 17239,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(spread + action indicator)',
    english: 'spread (cover with spread)-(to)',
    swedish: 'bre på',
    norwegian: 'smøre',
    finnish: 'päällystää, voidella, levittää',
    hungarian: 'kenni, rákenni (étel)',
    german: 'bestreichen, streichen, schmieren',
    dutch: 'beleggen, smeren',
    afrikaans: 'smeer (om te)',
    russian: 'намазывать, покрывать',
    latvian: 'smērēt, uzmērēt',
    polish: 'smarować, mazać, pomazać',
    french: 'tartiner, étaler',
    spanish: 'dispersar',
  },
  {
    av: 17240,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sun + 1: first season) (CKB) SYMBOL SYNONYM',
    english: 'spring (ckb)',
    swedish: 'vår (CKB)',
    norwegian: 'vår (CKB)',
    finnish: 'kevät',
    hungarian: 'tavasz (régi CKB-jelkép)',
    german: 'Frühling',
    dutch: 'lente (CKB)',
    afrikaans: 'lente (ckb)',
    russian: 'весна',
    latvian: 'pavasaris',
    polish: 'wiosna (CKB)',
    french: 'printemps (ckb)',
    spanish: 'primavera (CKB)',
  },
  {
    av: 17241,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sun + 1 + flower + up: first season when flowers begin to grow) (BCI) SYMBOL SYNONYM',
    english: 'spring',
    swedish: 'vår',
    norwegian: 'vår',
    finnish: 'kevät',
    hungarian: 'tavasz',
    german: 'Frühling',
    dutch: 'lente',
    afrikaans: 'lente',
    russian: 'весна',
    latvian: 'pavasaris',
    polish: 'wiosna',
    french: 'printemps',
    spanish: 'primavera',
  },
  {
    av: 17242,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + enclosure (with a square shape): square, a geometric shape)',
    english: 'square (shape)',
    swedish: 'kvadrat',
    norwegian: 'firkant, kvadrat',
    finnish: 'neliö',
    hungarian: 'négyzet',
    german: 'Quadrat (Form)',
    dutch: 'vierkant (zelfst. nw)',
    afrikaans: 'vierkant (vorm)',
    russian: 'квадрат',
    latvian: 'kvadrāts, kvadrātveida',
    polish: 'kwadrat (kształt)',
    french: 'carré (figure géométrique)',
    spanish: 'cuadrado (forma)',
  },
  {
    av: 17243,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(square (shape) + description indicator)',
    english: 'square (description)',
    swedish: 'kvadratisk, fyrkantig',
    norwegian: 'firkantet, kvadratisk',
    finnish: 'neliön muotoinen, neliömäinen, neliskulmainen',
    hungarian: 'négyzetalakú, négyzetes, négyzetformájú',
    german: 'quadratisch, rechtwinklig (Beschreibung)',
    dutch: 'vierkant (bijv. nw), rechthoekig',
    afrikaans: 'vierkantig, vierkantige (beskrywing)',
    russian: 'четырехугольный',
    latvian: 'četrstūris',
    polish: 'kwadratowy (kształt)',
    french: 'carré (de forme carrée)',
    spanish: 'cuadrado (descripción)',
  },
  {
    av: 17245,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal (bushy tailed) + teeth: rodent with a bushy tail)',
    english: 'squirrel',
    swedish: 'ekorre',
    norwegian: 'ekorn',
    finnish: 'orava',
    hungarian: 'mókus',
    german: 'Eichhörnchen',
    dutch: 'eekhoorn',
    afrikaans: 'eekhoring',
    russian: 'белка',
    latvian: 'vāvere',
    polish: 'wiewiórka',
    french: 'écureuil',
    spanish: 'ardilla',
  },
  {
    av: 17246,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(group + to serve: group of people working to serve others)',
    english: 'staff',
    swedish: 'personal, vårdpersonal',
    norwegian: 'personale',
    finnish: 'henkilökunta',
    hungarian: 'személyzet, stáb',
    german: 'Stab',
    dutch: 'personeel, medewerkers',
    afrikaans: 'personeel, kollega, medewerker',
    russian: 'персонал, трудовой коллектив',
    latvian: 'darbinieki, personāls',
    polish: 'personel, załoga, pracownicy',
    french: "personnel d'assistance, personnel d'aide",
    spanish: 'personal, empleados',
  },
  {
    av: 17249,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(standing (standing person) + action indicator)',
    english: 'stand-(to)',
    swedish: 'stå',
    norwegian: 'stå',
    finnish: 'seisoa',
    hungarian: 'állni, megállni',
    german: 'stehen',
    dutch: 'staan',
    afrikaans: 'staan (om te)',
    russian: 'стоять',
    latvian: 'stāvēt',
    polish: 'stać',
    french: 'être debout, mettre debout',
    spanish: 'permanecer',
  },
  {
    av: 17250,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(support + medical + to stand + thing indicator: medical device for standing)',
    english: 'stander',
    swedish: 'tippbräda, ståstöd',
    norwegian: 'ståstativ',
    finnish: 'seisomateline',
    hungarian: 'állító, sztender (gyógyászati segédeszköz)',
    german: 'Stehtrainer',
    dutch: 'sta-apparaat, staplank, statafel',
    afrikaans: 'staander',
    russian: 'вертикализатор, стойка',
    latvian: 'stāvēšana',
    polish: 'pionizator',
    french: 'verticalisateur',
    spanish: 'andador',
  },
  {
    av: 17254,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(without + to advance + action indicator)',
    english: 'stay, remain-(to)',
    swedish: 'stanna, stå stilla',
    norwegian: 'stanse, stå stille',
    finnish: 'jäädä, pysyä',
    hungarian: 'maradni, időzni',
    german: 'bleiben',
    dutch: 'blijven',
    afrikaans: 'bly, oorbly (om te)',
    russian: 'остановиться, стоять на месте',
    latvian: 'palikt, uzkavēties',
    polish: 'zostać, pozostawać',
    french: 'rester',
    spanish: 'estar, permanecer',
  },
  {
    av: 17256,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(steam + action indicator)',
    english: 'steam-(to)',
    swedish: 'ånga (verb)',
    norwegian: 'dampe',
    finnish: 'höyrytä',
    hungarian: 'gőzölögni',
    german: 'dampfen, dämpfen',
    dutch: 'stomen',
    afrikaans: 'stoom (om te)',
    russian: 'испаряться',
    latvian: 'iztvaicēt',
    polish: 'parować',
    french: 'passer à la vapeur, cuire à la vapeur',
    spanish: 'echar vapor',
  },
  {
    av: 17258,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + knife: the material of which knives are made)',
    english: 'steel',
    swedish: 'stål',
    norwegian: 'stål',
    finnish: 'teräs',
    hungarian: 'acél',
    german: 'Stahl (Material)',
    dutch: 'staal',
    afrikaans: 'staal',
    russian: 'сталь',
    latvian: 'tērauds',
    polish: 'stal (metal)',
    french: 'acier',
    spanish: 'acero',
  },
  {
    av: 17262,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to cause + infertile)',
    english: 'sterilization',
    swedish: 'sterilisering',
    norwegian: 'sterilisering',
    finnish: 'sterilointi',
    hungarian: 'sterilizálás, sterilizáció',
    german: 'Sterilisation, Sterilisierung',
    dutch: 'sterilisatie',
    afrikaans: 'sterilisasie',
    russian: 'стерилизация',
    latvian: 'sterilizācija',
    polish: 'sterylizacja',
    french: 'stérilisation',
    spanish: 'esterilización',
  },
  {
    av: 17263,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + tree + thing indicator)',
    english: 'stick, log',
    swedish: 'bräda, pinne, stock (etc)',
    norwegian: 'stokk, pinne',
    finnish: 'tikku, keppi',
    hungarian: 'fahasáb, fatönk, farönk, hasábfa, rönkfa',
    german: 'Stock, Brett, Stückchen, Holz',
    dutch: 'tak, stok',
    afrikaans: 'tak, stok',
    russian: 'палка, бревно, доска',
    latvian: 'sprungulis, žagars',
    polish: 'kij, pałka, drewniana laska',
    french: 'bâton, bûche',
    spanish: 'palo, tronco, leño',
  },
  {
    av: 17264,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '1',
    english: 'stocking(s), sock(s), pantyhose, tights',
    swedish: 'strumpor, strumpbyxor, sockor',
    norwegian: 'sokk, sokker, strømpe, strømper, strømpebukse',
    finnish: 'sukat, sukkahousut',
    hungarian: 'harisnya, harisnyanadrág',
    german: 'Socke, Strumpf, Kniestrumpf, Strumpfhose, Trikot',
    dutch: 'panty, maillot, broekkousen (Vl)',
    afrikaans: 'sykouse, broekiekouse',
    russian: 'носки, колготки',
    latvian: 'zeķes, zeķubikses',
    polish: 'skarpetki, pończochy, rajstopy, podkolanówki',
    french: 'chaussette, bas',
    spanish: 'pantis, leotardo',
  },
  {
    av: 17266,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + stone)',
    english: 'stone (material)',
    swedish: 'sten',
    norwegian: 'stein',
    finnish: 'kivi',
    hungarian: 'kő (mint anyag)',
    german: 'Stein (Material)',
    dutch: 'steen (materiaal)',
    afrikaans: 'klip materiaal',
    russian: 'камень',
    latvian: 'akmens (materiāls)',
    polish: 'kamienny materiał, kamienie',
    french: 'pierre (matière)',
    spanish: 'material de piedra',
  },
  {
    av: 17268,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(end + action indicator) ',
    english: 'stop, arrive, end-(to)',
    swedish: 'sluta, stoppa, komma fram',
    norwegian: 'slutte, stoppe, ankomme',
    finnish: 'lopettaa, loppua, pysähtyä, saapua',
    hungarian: 'abbahagyni, befejezni, megállni, megérkezni',
    german: 'anhalten, ankommen, aufhören, enden, beenden',
    dutch: 'aankomen, arriveren',
    afrikaans: 'stop, arriveer, eindig (om te)',
    russian: 'остановить(ся), прибыть',
    latvian: 'apstāties, ierasties',
    polish: 'koniec, cel, miejsce docelowe',
    french: 'arrêter',
    spanish: 'detener, parar, llegar',
  },
  {
    av: 17270,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + to hold)',
    english: 'storeroom',
    swedish: 'förråd',
    norwegian: 'lagerrom',
    finnish: 'varasto, varastohuone',
    hungarian: 'raktár',
    german: 'Lagerraum, Vorratskammer',
    dutch: 'hok, magazijn, berging',
    afrikaans: 'stoorkamer',
    russian: 'кладовая, склад',
    latvian: 'noliktava',
    polish: 'spiżarka',
    french: 'réserve, magasin',
    spanish: 'despensa',
  },
  {
    av: 17271,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(much + wind) See storm 23956 and hurricane 23887',
    english: 'gale',
    swedish: 'kuling',
    norwegian: 'kuling',
    finnish: 'myrskytuuli',
    hungarian: 'erős szél',
    german: 'Sturm',
    dutch: 'stormwind',
    afrikaans: 'stormwind',
    russian: 'шторм',
    latvian: 'orkāns',
    polish: 'wichura, huraganowe wiatry, sztorm, burza',
    french: 'vent, grand vent, coup de vent, rafale de vent',
    spanish: 'vendaval',
  },
  {
    av: 17272,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(page + mouth: spoken narrative. The symbol is used for story in a general sense, whether spoken, written, or printed.)',
    english: 'story, report, tale',
    swedish: 'berättelse, historia, saga',
    norwegian: 'fortelling, historie',
    finnish: 'kertomus, tarina, satu, selostus',
    hungarian: 'mese, történet, sztori',
    german: 'Geschichte, Erzählung, Märchen',
    dutch: 'rapport, verhaal',
    afrikaans: 'storie, verslag, verhaal',
    russian: 'повесть, рассказ',
    latvian: 'stāsts, stāstījums, nostāsts',
    polish: 'opowieść, historia',
    french: 'histoire, conte, anecdote',
    spanish: 'historia, cuento, saga',
  },
  {
    av: 17274,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(feeling + what, question mark + description indicator: characteristic of someone or something about which one feels doubtful)',
    english: 'strange',
    swedish: 'konstig, okänd',
    norwegian: 'merkelig, eiendommelig',
    finnish: 'outo, vieras, arvaamaton',
    hungarian: 'furcsa, idegen',
    german: 'fremd, seltsam',
    dutch: 'vreemd, raar',
    afrikaans: 'vreemd, raar',
    russian: 'странный',
    latvian: 'svešs, dīvains',
    polish: 'dziwny, niezwykły',
    french: 'étrange, insolite, bizarre',
    spanish: 'extraño, raro',
  },
  {
    av: 17275,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + strange: person who is strange, unknown)',
    english: 'stranger',
    swedish: 'konstig person, kuf',
    norwegian: 'fremmed',
    finnish: 'muukalainen, vieras',
    hungarian: 'idegen (fn.)',
    german: 'Fremder',
    dutch: 'vreemdeling, onbekende',
    afrikaans: 'vreemdeling, onbekende (persoon)',
    russian: 'незнакомец',
    latvian: 'svešinieks',
    polish: 'obcy',
    french: 'étranger',
    spanish: 'desconocido, extraño',
  },
  {
    av: 17276,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(linear thing + to fasten + thing indicator: linear thing that fastens or joins)',
    english: 'strap, string, velcro, rope, cord',
    swedish: 'snöre, tråd (etc)',
    norwegian: 'reim, stropp, tråd, velcro',
    finnish: 'nauha, naru, hihna',
    hungarian: 'kötél, szíj, kapocs, tépőzár',
    german: 'Schnur, Kordel, Faden, Gurt, Seil, Leine',
    dutch: 'koord, touw',
    afrikaans: 'koord, tou, kabel, glip-en-strip, velcro, band, lyn',
    russian: 'ремень, ремешок',
    latvian: 'šņore, striķis, virve',
    polish: 'taśma, sznurek, rzep (zamykanie)',
    french: 'sangle, courroie, lanière',
    spanish: 'correa, velcro, cuerda',
  },
  {
    av: 17277,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + drink + thing indicator)',
    english: 'straw, drinking straw',
    swedish: 'sugrör',
    norwegian: 'sugerør',
    finnish: 'pilli, juomapilli',
    hungarian: 'szívószál',
    german: 'Trinkröhrchen, Trinkhalm, Strohhalm',
    dutch: 'rietje',
    afrikaans: 'strooitjie',
    russian: 'соломинка',
    latvian: 'salmiņš dzeršanai',
    polish: 'słomka (do picia)',
    french: 'paille, chalumeau',
    spanish: 'paja, pajita para beber',
  },
  {
    av: 17442,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bean + long)',
    english: 'string bean, green bean, runner bean, wax bean',
    swedish: 'skärböna (etc)',
    norwegian: 'belgfrukt, bønner (o.l.)',
    finnish: 'palko',
    hungarian: 'zöldbab',
    german: 'Bohne, (grüne) Wachsbohne',
    dutch: 'sperzieboon, boon',
    afrikaans: 'string boon, groen boon, was boon',
    russian: 'фасоль',
    latvian: 'kāršupupas',
    polish: 'fasolka szparagowa',
    french: 'haricot (long)',
    spanish: 'judía verde, habichuela',
  },
  {
    av: 17443,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hand + back and forth + action indicator)',
    english: 'stroke-(to)',
    swedish: 'smeka, stryka, klappa',
    norwegian: 'stryke, stake, gni, klappe',
    finnish: 'silittää',
    hungarian: 'simogatni, cirógatni',
    german: 'streicheln',
    dutch: 'aaien, strelen',
    afrikaans: 'streel, vryf (om te)',
    russian: 'гладить, поглаживать',
    latvian: 'glāstīt, glaudīt',
    polish: 'pociągać, przeciągać (raz w jedną raz w drugą)',
    french: 'caresser',
    spanish: 'acariciar',
  },
  {
    av: 17444,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(strength + description indicator: symbol suggests the outline of a person, arm bent, biceps flexed, showing strength)',
    english: 'strong, powerful',
    swedish: 'stark',
    norwegian: 'sterk',
    finnish: 'vahva, voimakas',
    hungarian: 'erős, erőteljes',
    german: 'stark, kräftig, stark',
    dutch: 'sterk',
    afrikaans: 'sterk',
    russian: 'сильный',
    latvian: 'stiprs, spēcīgs',
    polish: 'silny, potężny',
    french: 'fort',
    spanish: 'fuerte, poderoso',
  },
  {
    av: 17446,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to learn)',
    english: 'student, pupil',
    swedish: 'elev, studerande',
    norwegian: 'student, elev',
    finnish: 'opiskelija, oppilas',
    hungarian: 'tanuló, diák, hallgató',
    german: 'Schüler, Schülerin, Student, Studentin',
    dutch: 'leerling, student',
    afrikaans: 'leerder, student, leerling',
    russian: 'ученик, студент',
    latvian: 'students, skolnieks',
    polish: 'student, uczeń',
    french: 'étudiant, élève',
    spanish: 'estudiante, alumno',
  },
  {
    av: 17448,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(subtraction + action indicator)',
    english: 'subtract, remove, take away-(to)',
    swedish: 'dra ifrån, förlora, ta bort, subtrahera',
    norwegian: 'ta bort, fjerne, subtrahere',
    finnish: 'vähentää, ottaa pois',
    hungarian: 'kivonni, eltávolítani, elmozdítani, elvenni',
    german: 'subtrahieren, abziehen',
    dutch: 'verwijderen, weghalen',
    afrikaans: 'minus, weg vat, verwyder (om te)',
    russian: 'вычитать, убирать',
    latvian: 'noņemt, paņemt nost',
    polish: 'zabierać, odbierać, odejmować',
    french: 'soustraire',
    spanish: 'restar, substraer, quitar',
  },
  {
    av: 17450,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(success + action indicator)',
    english: 'succeed-(to)',
    swedish: 'gå bra, ha framgång, lyckas',
    norwegian: 'lykkes, ha framgang',
    finnish: 'onnistua',
    hungarian: 'sikerülni, sikeresnek lenni valamiben ',
    german: 'gelingen',
    dutch: 'slagen, lukken',
    afrikaans: 'slaag, sukses (om te)',
    russian: 'преуспевать, процветать',
    latvian: 'izdoties, veikties',
    polish: 'osiągnąć sukces, powieść się',
    french: 'réussir',
    spanish: 'tener éxito',
  },
  {
    av: 17452,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(time + lightning + description indicator: occurring as suddenly as a bolt of lightning)',
    english: 'suddenly, abrupt, sudden',
    swedish: 'plötsligt',
    norwegian: 'plutselig',
    finnish: 'yhtäkkiä, äkkiä',
    hungarian: 'hirtelen, hirtelenül, váratlan, váratlanul ',
    german: 'plötzlich, abrupt',
    dutch: 'plotseling',
    afrikaans: 'skielik, skielike',
    russian: 'внезапно, вдруг',
    latvian: 'pēkšņi, negaidīti',
    polish: 'nagle, niespodziewanie',
    french: 'tout à coup, soudainement, brusquement',
    spanish: 'de repente, abruptamente',
  },
  {
    av: 17453,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(adding, additive + sweetness + thing indicator: combination of flavouring and sweet)',
    english: 'sugar, sweetener',
    swedish: 'socker, sötningsmedel',
    norwegian: 'sukker, søtningsmiddel',
    finnish: 'sokeri, makeutusaine',
    hungarian: 'cukor, édesítőszer',
    german: 'Zucker, Süßungsmittel',
    dutch: 'suiker, zoetmiddel',
    afrikaans: 'suiker, versoeter',
    russian: 'сахар, подсластитель',
    latvian: 'cukurs, saldinātājs',
    polish: 'cukier, coś słodkiego, słodzik',
    french: 'sucre, édulcorant',
    spanish: 'azúcar, endulzante',
  },
  {
    av: 17454,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(suggestion + action indicator)',
    english: 'suggest, propose-(to)',
    swedish: 'föreslå',
    norwegian: 'foreslå',
    finnish: 'ehdottaa',
    hungarian: 'javasolni, ajánlani, felvetni',
    german: 'vorschlagen',
    dutch: 'voorstellen',
    afrikaans: 'voorstel (om te)',
    russian: 'предлагать',
    latvian: 'ieteikt, piedāvāt',
    polish: 'sugerować, podpowiadać, proponować',
    french: 'suggérer',
    spanish: 'sugerir, proponer',
  },
  {
    av: 17455,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(opinion + purpose)',
    english: 'suggestion, proposal',
    swedish: 'förslag',
    norwegian: 'forslag',
    finnish: 'ehdotus, esitys',
    hungarian: 'javaslat, ajánlat, felvetés',
    german: 'Vorschlag, Rat, Tipp, Angebot',
    dutch: 'voorstel, suggestie',
    afrikaans: 'voorstel, voorstelling',
    russian: 'предложение',
    latvian: 'ieteikums, piedāvājums',
    polish: 'sugestia, podpowiedź, propozycja',
    french: 'suggestion',
    spanish: 'sugerencia, propuesta',
  },
  {
    av: 17456,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + 2 + part: two piece clothing)',
    english: 'suit',
    swedish: 'dräkt, kostym',
    norwegian: 'drakt, dress',
    finnish: 'puku',
    hungarian: 'öltöny, kosztüm',
    german: 'Anzug, Herrenanzug, Kostüm, Damenkostüm',
    dutch: 'pak, kostuum',
    afrikaans: 'pak',
    russian: 'костюм',
    latvian: 'kostīms, tērps (kleita)',
    polish: 'garnitur, kostium (2 częściowy ubiór)',
    french: 'costume, ensemble, habit',
    spanish: 'traje',
  },
  {
    av: 17457,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(house + roof + tree + thing indicator + plural indicator: house for Sukkot)',
    english: 'sukkah',
    swedish: 'sukkah (Israel)',
    norwegian: 'sukkah (Israel)',
    finnish: 'lehtimaja, sukaa',
    hungarian: 'sukkah (héber)',
    german: 'sukkah',
    dutch: 'loofhut (Joods)',
    afrikaans: 'sukkah',
    russian: 'сукка (Израиль)',
    latvian: 'Sukots (Izraēla)',
    polish: 'suka (hebr. szałas)',
    french: 'soukka (hébergement pour la fête Soukkot)',
    spanish: 'sucá',
  },
  {
    av: 17458,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(week + roof + tree + thing indicator + plural indicator: week-long holiday when a ceremonial hut is built from branches)',
    english: 'Sukkot',
    swedish: 'Sukkot (Israel)',
    norwegian: 'Sukkot (Israel)',
    finnish: 'sukkot, lehtimajajuhla, lehtimajanjuhla',
    hungarian: 'Szukkot (héber)',
    german: 'sukkot',
    dutch: 'loofhuttenfeest (Joods)',
    afrikaans: 'Sukkot',
    russian: 'суккот (Израиль)',
    latvian: 'Sukkot (Izraela)',
    polish: 'Sukkot (hebr.)',
    french: 'Soukkot (fête juive)',
    spanish: 'Sucot',
  },
  {
    av: 17459,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sun + 2: second season) (CKB) SYMBOL SYNONYM',
    english: 'summer (ckb)',
    swedish: 'sommar (CKB)',
    norwegian: 'sommer (CKB)',
    finnish: 'kesä',
    hungarian: 'nyár (régi CKB-jelkép)',
    german: 'Sommer',
    dutch: 'zomer (CKB)',
    afrikaans: 'somer (ckb)',
    russian: 'лето (Ч.Б.)',
    latvian: 'vasara',
    polish: 'lato (CKB)',
    french: 'été (ckb)',
    spanish: 'verano (CKB)',
  },
  {
    av: 17460,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sun + 2 + hot: second season when it is hot) (BCI) SYMBOL SYNONYM',
    english: 'summer',
    swedish: 'sommar',
    norwegian: 'sommer',
    finnish: 'kesä',
    hungarian: 'nyár',
    german: 'Sommer',
    dutch: 'zomer',
    afrikaans: 'somer',
    russian: 'лето',
    latvian: 'vasara',
    polish: 'lato',
    french: 'été (saison)',
    spanish: 'verano',
  },
  {
    av: 17461,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gathering + day + summer)',
    english: 'summer day camp',
    swedish: 'dagläger',
    norwegian: 'sommertreff',
    finnish: 'kesäleiri',
    hungarian: 'nyári napközis tábor',
    german: 'Sommerlager, Sommercamp',
    dutch: 'zomerkamp, vakantiekamp',
    afrikaans: 'somer kamp',
    russian: 'летний лагерь',
    latvian: 'vasaras nomente',
    polish: 'obóz letni, kolonie',
    french: 'colonie de vacances, camp de vacances',
    spanish: 'campamento de verano',
  },
  {
    av: 17463,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical product + against + sun)',
    english: 'sunscreen, sunblock, sun lotion',
    swedish: 'solkräm',
    norwegian: 'solkrem',
    finnish: 'aurinkovoide',
    hungarian: 'naptej, napvédő krém',
    german: 'Sonnencreme, Sonnenschutzmittel',
    dutch: 'zonnebrandolie, zonnecrème',
    afrikaans: 'sonblok',
    russian: 'солнцезащитный крем',
    latvian: 'pretiedeguma krēms',
    polish: 'krem do opalania, krem z filtrem',
    french: 'crème solaire, produit solaire, écran total',
    spanish: 'protección solar',
  },
  {
    av: 17465,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(sun + description indicator)',
    english: 'sunny',
    swedish: 'solig',
    norwegian: 'solfylt',
    finnish: 'aurinkoinen',
    hungarian: 'napos',
    german: 'sonnig',
    dutch: 'zonnig',
    afrikaans: 'sonnig',
    russian: 'солнечный',
    latvian: 'saulains',
    polish: 'słoneczne, słonecznie',
    french: 'ensoleillé',
    spanish: 'soleado',
  },
  {
    av: 17466,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(morning (early) + up: half sun going up)',
    english: 'sunrise',
    swedish: 'soluppgång',
    norwegian: 'soloppgang',
    finnish: 'auringonnousu',
    hungarian: 'napkelte',
    german: 'Sonnenaufgang',
    dutch: 'zonsopgang',
    afrikaans: 'sonsopkoms',
    russian: 'восход солнца',
    latvian: 'saullēkts',
    polish: 'świt',
    french: 'lever du soleil',
    spanish: 'salida del sol, amanecer',
  },
  {
    av: 17467,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(morning (early) + down: half sun going down)',
    english: 'sunset',
    swedish: 'solnedgång',
    norwegian: 'solnedgang',
    finnish: 'auringonlasku',
    hungarian: 'napnyugta',
    german: 'Sonnenuntergang',
    dutch: 'zonsondergang',
    afrikaans: 'sonsondergang',
    russian: 'закат',
    latvian: 'saulriets',
    polish: 'zachód słońca',
    french: 'coucher du soleil',
    spanish: 'puesta del sol',
  },
  {
    av: 17468,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meal + 3: third meal of the day)',
    english: 'supper, dinner',
    swedish: 'middag, kvällsmål',
    norwegian: 'middag, kveldsmåltid',
    finnish: 'päivällinen',
    hungarian: 'vacsora',
    german: 'Abendessen, Hauptmahlzeit, Abendbrot',
    dutch: 'diner, avondeten',
    afrikaans: 'aandete',
    russian: 'ужин',
    latvian: 'vakariņas',
    polish: 'kolacja (trzeci duży posiłek)',
    french: 'souper, repas du soir',
    spanish: 'cena',
  },
  {
    av: 17469,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to help + with (the help of) + money + action indicator: to provide financial support)',
    english: 'support-(to)',
    swedish: 'ge bidrag, finansiera',
    norwegian: 'finansiere, støtte økonomisk',
    finnish: 'tukea taloudellisesti, rahoittaa, avustaa',
    hungarian: 'támogatni anyagilag, pénzzel segíteni',
    german: 'unterstützen, fördern, begünstigen',
    dutch: 'steunen (met geld), ondersteunen (met geld)',
    afrikaans: 'finansiële bystand, finansiële steun, hulp (om te)',
    russian: 'поддерживать, финансировать',
    latvian: 'atbalstīt, palīdzēt',
    polish: 'wspomagać (finansowo)',
    french: 'supporter financièrement',
    spanish: 'apoyar',
  },
  {
    av: 17471,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(down + drink, beverage + action indicator: combination of food and liquid going down)',
    english: 'swallow-(to)',
    swedish: 'svälja',
    norwegian: 'svelge',
    finnish: 'niellä',
    hungarian: 'nyelni, lenyelni',
    german: 'schlucken',
    dutch: 'slikken',
    afrikaans: 'sluk (om te)',
    russian: 'глотать',
    latvian: 'rīt, norīt',
    polish: 'połykać, przełykać',
    french: 'avaler',
    spanish: 'tragar',
  },
  {
    av: 17474,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(sweat, perspiration + action indicator)',
    english: 'sweat, perspire-(to)',
    swedish: 'svettas',
    norwegian: 'svette (å)',
    finnish: 'hikoilla',
    hungarian: 'verejtékezni, izzadni',
    german: 'schwitzen',
    dutch: 'zweten',
    afrikaans: 'sweet (om te)',
    russian: 'потеть',
    latvian: 'svīst',
    polish: 'pocić się',
    french: 'transpirer',
    spanish: 'sudar',
  },
  {
    av: 17475,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + skin)',
    english: 'sweat, perspiration',
    swedish: 'svett',
    norwegian: 'svette',
    finnish: 'hiki, hikoilu',
    hungarian: 'verejték',
    german: 'Schweiß',
    dutch: 'zweet',
    afrikaans: 'sweet',
    russian: 'пот',
    latvian: 'sviedri',
    polish: 'pot',
    french: 'transpiration, sueur',
    spanish: 'sudor',
  },
  {
    av: 17477,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      "(metaphor + sweet + description indicator: 'sweet' as in 'a sweet child')",
    english: 'sweet (metaphor)',
    swedish: 'söt, gullig',
    norwegian: 'elskelig, søt',
    finnish: 'suloinen, söpö',
    hungarian: 'édes (metafóra)',
    german: 'niedlich, süß',
    dutch: 'zoetje (metafoor)',
    afrikaans: 'soet(e) metafoor',
    russian: 'милый, сладкий (метафора)',
    latvian: 'mīļš, jauks',
    polish: 'słodkie (przenośnia)',
    french: 'délicieux (métaphore)',
    spanish: 'dulce (metáfora)',
  },
  {
    av: 17478,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(sweetness, sweet + description indicator: pleasant taste)',
    english: 'sweet (taste)',
    swedish: 'söt',
    norwegian: 'søt (smak)',
    finnish: 'makea',
    hungarian: 'édes (íz)',
    german: 'süß (Geschmack)',
    dutch: 'zoet (smaak)',
    afrikaans: 'soet (smaak)',
    russian: 'сладкий',
    latvian: 'salds',
    polish: 'słodki (smak)',
    french: 'sucré (goût)',
    spanish: 'dulce (sabor)',
  },
  {
    av: 17479,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + sweet)',
    english: 'sweet, confection',
    swedish: 'sötsak',
    norwegian: 'søtsak',
    finnish: 'makea ruoka',
    hungarian: 'csemege, édesség, édes étel',
    german: 'Süßigkeit, Bonbon',
    dutch: 'snoep',
    afrikaans: 'snoep happie, soet happie, sout happie',
    russian: 'сласть',
    latvian: 'saldumi, konfektes',
    polish: 'słodycze, coś o słodkim smaku',
    french: 'sucrerie, pâtisserie',
    spanish: 'dulces',
  },
  {
    av: 17480,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vegetable below ground + sweet)',
    english: 'sweet potato, yam',
    swedish: 'sötpotatis',
    norwegian: 'søtpotet',
    finnish: 'bataatti, jamssi',
    hungarian: 'édeskrumpli, yamgyökér',
    german: 'Süßkartoffel',
    dutch: 'zoete aardappel',
    afrikaans: 'soet patat',
    russian: 'батат',
    latvian: 'saldie kartupeļi',
    polish: 'słodkie ziemniaki',
    french: 'patate douce',
    spanish: 'batata',
  },
  {
    av: 17481,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to love)',
    english: 'sweetheart, lover',
    swedish: 'älskling',
    norwegian: 'kjæreste',
    finnish: 'kulta, mielitietty',
    hungarian: 'kedvese, szerelmese, szeretője, párja, szívszerelme',
    german: 'Liebling, Liebste, Liebster',
    dutch: 'lieveling',
    afrikaans: 'liefling, minnaar',
    russian: 'возлюбленный',
    latvian: 'mīļotais (-ā), miļākais (-ā)',
    polish: 'kochanek',
    french: 'petit ami, petit copain, copain',
    spanish: 'amante',
  },
  {
    av: 17482,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(swimming, swim + action indicator: to move through water)',
    english: 'swim-(to)',
    swedish: 'simma',
    norwegian: 'svømme',
    finnish: 'uida',
    hungarian: 'úszni',
    german: 'schwimmen',
    dutch: 'zwemmen',
    afrikaans: 'swem (om te)',
    russian: 'плавать',
    latvian: 'peldēt',
    polish: 'pływać, przepływać',
    french: 'nager',
    spanish: 'nadar',
  },
  {
    av: 17483,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pool + swimming)',
    english: 'swimming pool',
    swedish: 'simbassäng',
    norwegian: 'svømmebasseng',
    finnish: 'uima-allas',
    hungarian: 'uszoda',
    german: 'Schwimmbad, Swimmingpool',
    dutch: 'zwembad',
    afrikaans: 'swembad',
    russian: 'бассейн',
    latvian: 'baseins',
    polish: 'basen pływacki',
    french: 'piscine',
    spanish: 'piscina',
  },
  {
    av: 17484,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + comma + to swim)',
    english: 'swimsuit, swimwear, bathing suit',
    swedish: 'badbyxor, baddräkt',
    norwegian: 'badebukse, badedrakt',
    finnish: 'uimapuku',
    hungarian: 'úszóruha, úszónadrág, fürdőruha',
    german: 'Badesachen, Badeanzug, Badehose',
    dutch: 'badpak',
    afrikaans: 'swemklere',
    russian: 'купальный костюм',
    latvian: 'peldkostīms',
    polish: 'strój kąpielowy',
    french: 'maillot de bain',
    spanish: 'bañador, traje de baño',
  },
  {
    av: 17485,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(swing, swinging + thing indicator: thing to swing upon) - (character with thing indicator)',
    english: 'swing',
    swedish: 'gunga (subst.)',
    norwegian: 'gynge, vippehuske',
    finnish: 'keinu',
    hungarian: 'hinta',
    german: 'Schaukel',
    dutch: 'schommel',
    afrikaans: 'swaai',
    russian: 'качели',
    latvian: 'šūpoles',
    polish: 'huśtawka, kołyska',
    french: 'balançoire',
    spanish: 'columpio',
  },
  {
    av: 17486,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(swing, swinging + action indicator)',
    english: 'swing, sway, rock-(to)',
    swedish: 'gunga (verb)',
    norwegian: 'svinge, gynge (å)',
    finnish: 'keinua, heilua',
    hungarian: 'hintázni, ringatózni, ingázni',
    german: 'schaukeln, sich wiegen (hin und her), schwingen',
    dutch: 'schommelen',
    afrikaans: 'swaai, wieg, skommel (om te)',
    russian: 'качать(ся)',
    latvian: 'šūpot',
    polish: 'huśtać się, kołysać',
    french: 'balancer-(se)',
    spanish: 'columpiarse',
  },
  {
    av: 17487,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + hand: thing operated by the hand)',
    english: 'handle, switch',
    swedish: 'handtag',
    norwegian: 'håndtak, hendel, bryter',
    finnish: 'kädensija, kahva, katkaisija',
    hungarian: 'fogó, fogantyú, kapcsoló',
    german: 'Griff, Stiel',
    dutch: 'handvat, knop (hulpmiddel)',
    afrikaans: 'handvatsel',
    russian: 'ручка, выключатель',
    latvian: 'rokturis',
    polish: 'uchwyt, rączka, włącznik',
    french: 'interrupteur, commutateur (marche, arrêt)',
    spanish: 'picaporte, asa, tirador',
  },
  {
    av: 17488,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(handle + action indicator)',
    english: 'switch-(to)',
    swedish: 'sätta på',
    norwegian: 'sette på, skru på',
    finnish: 'käynnistää, avata, sytyttää',
    hungarian: 'kapcsolni',
    german: 'schalten, wechseln',
    dutch: 'omschakelen, aanzetten ',
    afrikaans: 'aanskakel afskakel skakel (om te)',
    russian: 'включать, выключать',
    latvian: 'ieslēgt',
    polish: 'przełączać, wciskać przycisk',
    french: "actionner l'interrupteur",
    spanish: 'cambiar',
  },
  {
    av: 17489,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + plus + Blissymbol)',
    english: 'symbol display, symbol board, symbol chart',
    swedish: 'blisskarta, symbolkarta',
    norwegian: 'symboltavle',
    finnish: 'symbolikartta, symbolitaulu',
    hungarian: 'jelképtábla, jelképalbum, jelképfüzet',
    german: 'Symboltafel, Blisstafel',
    dutch: 'symbolenkaart',
    afrikaans: 'simbool bord, simbool kaart',
    russian: 'карта блисс',
    latvian: 'bliss karte, simbolu karte',
    polish: 'tablica symboli',
    french: 'tableau de symboles',
    spanish: 'mapa de símbolos',
  },
  {
    av: 17490,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(house + commandments: building for Jewish religious services and instruction)',
    english: 'synagogue',
    swedish: 'synagoga',
    norwegian: 'synagoge',
    finnish: 'synagooga',
    hungarian: 'zsinagóga',
    german: 'Synagoge',
    dutch: 'synagoge',
    afrikaans: 'sinagoge',
    russian: 'синагога',
    latvian: 'sinagoga',
    polish: 'synagoga',
    french: 'synagogue',
    spanish: 'sinagoga',
  },
  {
    av: 17491,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(injection + thing indicator) - (character with thing indicator)',
    english: 'syringe',
    swedish: 'spruta',
    norwegian: 'sprøyte',
    finnish: 'lääkeruisku',
    hungarian: 'fecskendő',
    german: 'Spritze, Injektionsnadel',
    dutch: 'injectiespuit',
    afrikaans: 'spuit',
    russian: 'шприц',
    latvian: 'šļirce, šprice',
    polish: 'strzykawka',
    french: 'seringue',
    spanish: 'jeringa',
  },
  {
    av: 17492,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to play + table: enjoyable activity that uses a table)',
    english: 'table game',
    swedish: 'sällskapsspel',
    norwegian: 'bordlek, selskapslek',
    finnish: 'pöytäpeli',
    hungarian: 'asztali játék',
    german: 'Gesellschaftspiel, Spiel',
    dutch: 'speeltafel',
    afrikaans: 'tafel spel',
    russian: ' игра настольная',
    latvian: 'galda spēle',
    polish: 'gra stołowa',
    french: 'jeu de table, jeu de société',
    spanish: 'juego de mesa',
  },
  {
    av: 17494,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + table)',
    english: 'tablecloth',
    swedish: 'duk',
    norwegian: 'duk',
    finnish: 'pöytäliina, pikkuliina',
    hungarian: 'abrosz, asztalterítő',
    german: 'Tischtuch',
    dutch: 'tafelkleed',
    afrikaans: 'tafeldoek',
    russian: 'скатерть',
    latvian: 'galdauts',
    polish: 'obrus',
    french: 'nappe',
    spanish: 'mantel',
  },
  {
    av: 17495,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(spread + seed + white: Middle Eastern food, used rather like peanut butter)',
    english: 'tahini, sesame seed spread',
    swedish: 'tahini, sesampasta',
    norwegian: 'tahini (sesammasse)',
    finnish: 'tahinilevite',
    hungarian: 'tahini, szézámmagos kennivaló',
    german: 'Sesampaste, Tahin',
    dutch: 'sesampasta, tahin',
    afrikaans: 'sesami smeer',
    russian: 'кунжутная паста, тахини',
    latvian: 'sezama pavalgs',
    polish: 'pasta sezamowa',
    french: 'crème de sésame',
    spanish: 'tahini, cubierto con semillas de sésamo',
  },
  {
    av: 17497,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(portability + action indicator)',
    english: 'take, bring, carry, move-(to)',
    swedish: 'bära, ta med',
    norwegian: 'bære, ta med',
    finnish: 'viedä, tuoda',
    hungarian: 'vinni, elvinni, elmozdítani, odavinni',
    german: 'tragen, bringen, nehmen',
    dutch: 'verplaatsen, brengen, dragen naar',
    afrikaans: 'vat, bring, dra, skuif (om te)',
    russian: 'нести, приносить',
    latvian: 'ņemt, nest, pārvietot',
    polish: 'wziąć, przynieść, przeprowadzi',
    french: 'porter, transporter, amener',
    spanish: 'tomar, llevar, traer, mover',
  },
  {
    av: 17498,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hand + to take away + action indicator)',
    english: 'take away, remove-(to)',
    swedish: 'ta bort',
    norwegian: 'ta vekk',
    finnish: 'viedä pois, ottaa pois',
    hungarian: 'elvenni, áthelyezni',
    german: 'wegholen, (weg)nehmen',
    dutch: 'weghalen, verwijderen (met de hand)',
    afrikaans: 'vat weg, verwyder (om te)',
    russian: 'отнять, удалить',
    latvian: 'aiznest, noņemt',
    polish: 'zabrać, usunąć',
    french: 'enlever, retirer, emporter',
    spanish: 'quitar, retirar',
  },
  {
    av: 17499,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(airplane + upward and forward)',
    english: 'takeoff, take-off, airplane take-off',
    swedish: 'start (flyg)',
    norwegian: 'flyavgang, take off',
    finnish: 'lähtö, lentokoneen nousu',
    hungarian: 'felszállás (repülőgép)',
    german: 'Start (Flugzeug)',
    dutch: 'opstijgen (zelfst.nw)',
    afrikaans: 'opstyg, vliegtuig',
    russian: 'взлёт',
    latvian: 'pacelšanās, lidmašīnas',
    polish: 'start, poderwanie się (do lotu)',
    french: 'décoller',
    spanish: 'despegue',
  },
  {
    av: 17500,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(powder + body)',
    english: 'talcum powder',
    swedish: 'talkpuder',
    norwegian: 'talkum',
    finnish: 'talkki',
    hungarian: 'hintőpor',
    german: 'Babypuder, Talkum, Talkumpuder',
    dutch: 'talkpoeder',
    afrikaans: 'poeier',
    russian: 'тальк, присыпка',
    latvian: 'talks, pūderis',
    polish: 'talk, puder do ciała',
    french: 'talc',
    spanish: 'polvo de talco',
  },
  {
    av: 17501,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + comma + to pray + Jewish)',
    english: 'tallith',
    swedish: 'tallit (Israel)',
    norwegian: 'tallit (Israel)',
    finnish: 'tallit',
    hungarian: 'tallit (héber)',
    german: 'tallit',
    dutch: 'tallith (Joods)',
    afrikaans: 'tallith',
    russian: 'таллит (Израиль)',
    latvian: 'talits (Izraēla)',
    polish: 'tałes, talit (hebr)',
    french: 'tallith (châle de prière juif)',
    spanish: 'talit',
  },
  {
    av: 17502,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + summer: month that is the heart of summer)',
    english: 'Tammuz',
    swedish: 'Tamuz (Israel)',
    norwegian: 'Tamuz (Israel)',
    finnish: 'tammus, tammúz',
    hungarian: 'Tammúz (héber)',
    german: 'Tamuz',
    dutch: 'Tammuz (Joods)',
    afrikaans: 'Tammuz',
    russian: 'Тамуз (Израиль)',
    latvian: 'Tamuz (Izraēla)',
    polish: 'Tamuz (miesiąc hebr)',
    french: 'Tamouz (4e mois du calendrier juif)',
    spanish: 'Tamuz',
  },
  {
    av: 17503,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(citrus fruit + little)',
    english: 'tangerine, clementine, mandarin',
    swedish: 'klementin (etc)',
    norwegian: 'klementin, mandarin',
    finnish: 'mandariini, klementiini',
    hungarian: 'mandarin, klementin',
    german: 'Mandarine, Tangerine',
    dutch: 'mandarijn, clementine',
    afrikaans: 'nartjie, naartjie',
    russian: 'мандарин',
    latvian: 'mandarīns',
    polish: 'mandarynki, klementynki',
    french: 'mandarine, clémentine',
    spanish: 'mandarina',
  },
  {
    av: 17505,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(machine + to reproduce + ear: machine to reproduce material for listening)',
    english: 'sound recorder, tape recorder',
    swedish: 'bandspelare',
    norwegian: 'båndspiller',
    finnish: 'nauhuri',
    hungarian: 'magnetofon, magnó',
    german: 'Tonbandgerät, Kassettenrecorder',
    dutch: 'cassetterecorder',
    afrikaans: 'band opnemer',
    russian: 'магнитофон',
    latvian: 'magnetafons',
    polish: 'magnetofon',
    french: 'enregistreur',
    spanish: 'grabadora de cinta',
  },
  {
    av: 17507,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(taste + action indicator)',
    english: 'taste-(to)',
    swedish: 'smaka',
    norwegian: 'smake',
    finnish: 'maistaa, maistua',
    hungarian: 'ízlelni, megízlelni',
    german: 'schmecken',
    dutch: 'proeven',
    afrikaans: 'proe (om te)',
    russian: 'пробовать',
    latvian: 'garšot, nogaršot',
    polish: 'smakować, sprawdzać smak',
    french: 'goûter',
    spanish: 'saber, tener sabor',
  },
  {
    av: 17509,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(car + limited time: car hired for a short time)',
    english: 'taxi, cab',
    swedish: 'taxi, hyrbil',
    norwegian: 'taxi, leiebil',
    finnish: 'taksi',
    hungarian: 'taxi',
    german: 'Taxi',
    dutch: 'taxi',
    afrikaans: 'taxi',
    russian: 'такси',
    latvian: 'taksometrs',
    polish: 'taksówka',
    french: 'taxi',
    spanish: 'taxi',
  },
  {
    av: 17510,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + taxi)',
    english: 'taxi driver, cab driver',
    swedish: 'taxichaufför',
    norwegian: 'taxisjåfør',
    finnish: 'taksinkuljettaja',
    hungarian: 'taxisofőr',
    german: 'Taxifahrer, Taxifahrerin',
    dutch: 'taxichauffeur',
    afrikaans: 'taxi bestuurder',
    russian: 'шофёр такси',
    latvian: 'taksometra vadītājs',
    polish: 'taksówkarz',
    french: 'chauffeur de taxi',
    spanish: 'conductor de taxi',
  },
  {
    av: 17511,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drink + leaf: drink made from tea leaves)',
    english: 'tea',
    swedish: 'te',
    norwegian: 'te',
    finnish: 'tee',
    hungarian: 'tea',
    german: 'Tee',
    dutch: 'thee',
    afrikaans: 'tee',
    russian: 'чай',
    latvian: 'tēja',
    polish: 'herbata',
    french: 'thé',
    spanish: 'té',
  },
  {
    av: 17512,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to give + knowledge + action indicator)',
    english: 'teach, instruct-(to)',
    swedish: 'lära ut, undervisa',
    norwegian: 'undervise, instruere',
    finnish: 'opettaa',
    hungarian: 'tanítani, oktatni, instrukciókat adni',
    german: 'lehren',
    dutch: 'lesgeven, aanleren',
    afrikaans: 'leer (om te)',
    russian: 'учить, обучать',
    latvian: 'mācīt, apmācīt, skolot',
    polish: 'nauczać, tłumaczyć',
    french: 'enseigner, apprendre',
    spanish: 'enseñar, instruir',
  },
  {
    av: 17513,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to teach)',
    english: 'teacher, instructor',
    swedish: 'lärare, instruktör',
    norwegian: 'lærer, instruktør',
    finnish: 'opettaja',
    hungarian: 'tanár, tanító, oktató',
    german: 'Lehrer, Lehrerin',
    dutch: 'onderwijzer, onderwijzeres, leraar, juf, leerkracht',
    afrikaans: 'onderwyser, instrukteur, leraar',
    russian: 'учитель, педагог',
    latvian: 'skolotājs, instruktors',
    polish: 'nauczyciel, instruktor',
    french: 'enseignant',
    spanish: 'profesor, maestro, instructor',
  },
  {
    av: 17514,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(group + to work + together: group that works together)',
    english: 'team',
    swedish: 'arbetslag, team, arbetsgrupp',
    norwegian: 'arbeidslag, team',
    finnish: 'joukkue, työryhmä',
    hungarian: 'munkacsoport, csapat, team',
    german: 'Mannschaft, Team',
    dutch: 'team',
    afrikaans: 'span',
    russian: 'бригада, команда',
    latvian: 'komanda',
    polish: 'zespół',
    french: 'équipe (de travail)',
    spanish: 'equipo',
  },
  {
    av: 17515,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to act + upset + action indicator: to act in a way that upsets someone)',
    english: 'tease-(to)',
    swedish: 'reta',
    norwegian: 'erte',
    finnish: 'kiusata, härnätä, ärsyttää',
    hungarian: 'ugratni, ingerelni, kötekedni',
    german: 'necken, hänseln',
    dutch: 'plagen',
    afrikaans: 'terg (om te)',
    russian: 'дразнить',
    latvian: 'ķircināt',
    polish: 'dokuczać, wyśmiewać',
    french: 'taquiner',
    spanish: 'burlarse de, reírse de',
  },
  {
    av: 17518,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + electricity: electrical device for speaking and listening)',
    english: 'telephone, call',
    swedish: 'telefon',
    norwegian: 'telefon',
    finnish: 'puhelin',
    hungarian: 'telefon',
    german: 'Telefon',
    dutch: 'telefoon',
    afrikaans: 'telefoon',
    russian: 'телефон',
    latvian: 'telefons',
    polish: 'telefon',
    french: 'téléphone',
    spanish: 'teléfono',
  },
  {
    av: 17519,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure + eye + ear + electricity: box for seeing and hearing by a means of electricity)',
    english: 'television',
    swedish: 'tv',
    norwegian: 'TV, fjernsynsapparat',
    finnish: 'televisio, TV',
    hungarian: 'televízió',
    german: 'Fernseher, Fernsehapparat, TV-Gerät',
    dutch: 'televisie, tv',
    afrikaans: 'televisie, TV',
    russian: 'телевизор',
    latvian: 'televizors',
    polish: 'telewizja',
    french: 'télévision',
    spanish: 'televisión',
  },
  {
    av: 17521,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + time + 10) (Israel)',
    english: "ten o'clock eating break",
    swedish: "ten o'clock eating break (Israel)",
    norwegian: 'ten 0`clock eating break (Israel)',
    finnish: 'kello kymmenen ruoka',
    hungarian: 'tízórai szünet',
    german: 'Kaffeetisch',
    dutch: 'tussendoortje (om tien uur)',
    afrikaans: 'versnapering',
    russian: 'второй завтрак',
    latvian: 'otrās brokastis',
    polish: 'przerwa na śniadaniowa (o 10:00)',
    french: 'collation de 10 heures',
    spanish: 'pausa de las diez para comer (Israel)',
  },
  {
    av: 17523,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + cloth: shelter made of cloth)',
    english: 'tent',
    swedish: 'tält',
    norwegian: 'telt',
    finnish: 'teltta',
    hungarian: 'sátor',
    german: 'Zelt',
    dutch: 'tent',
    afrikaans: 'tent',
    russian: 'палатка',
    latvian: 'telts',
    polish: 'namiot',
    french: 'tente',
    spanish: 'tienda, carpa',
  },
  {
    av: 17524,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(insect + tree or wood destruction: insect that destroys trees or wood)',
    english: 'termite, wood destroying insect',
    swedish: 'termit',
    norwegian: 'termitt',
    finnish: 'termiitti, tuhohyönteinen',
    hungarian: 'termesz',
    german: 'Termite',
    dutch: 'termiet',
    afrikaans: 'termiet',
    russian: 'термит',
    latvian: 'termīts',
    polish: 'termit',
    french: 'termite',
    spanish: 'termita',
  },
  {
    av: 17525,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(terror + description indicator)',
    english: 'terrified',
    swedish: 'skräckslagen, vettskrämd',
    norwegian: 'forferdet, vettskremt',
    finnish: 'kauhistuttava',
    hungarian: 'rémült, megrettent, riadt',
    german: 'in Panik, erschrecken, fürchterliche Angst haben',
    dutch: 'doodsbang',
    afrikaans: 'bevrees',
    russian: 'испуганный, запуганный',
    latvian: 'pārbaidīts, sabaidīts',
    polish: 'przerażający, straszny',
    french: 'terrifié',
    spanish: 'aterrorizado',
  },
  {
    av: 17526,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + terrorism)',
    english: 'terrorist',
    swedish: 'terrorist',
    norwegian: 'terrorist',
    finnish: 'terroristi',
    hungarian: 'terrorista (fn.)',
    german: 'Terrorist, Terroristin',
    dutch: 'terrorist',
    afrikaans: 'terroris',
    russian: 'террорист',
    latvian: 'terorists',
    polish: 'terrorysta',
    french: 'terroriste',
    spanish: 'terrorista',
  },
  {
    av: 17527,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(terrorism + action indicator)',
    english: 'terrorize-(to)',
    swedish: 'terrorisera',
    norwegian: 'terrorisere',
    finnish: 'terrorisoida, pelästyttää',
    hungarian: 'terrorizálni, rettegésben tartani',
    german: 'terrorisieren',
    dutch: 'terroriseren',
    afrikaans: 'terroriseer (om te)',
    russian: 'терроризировать',
    latvian: 'terorizēt',
    polish: 'sterroryzować',
    french: 'terroriser',
    spanish: 'aterrorizar',
  },
  {
    av: 17528,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(question + for (the purpose of) + evaluation)',
    english: 'test, assessment, exam',
    swedish: 'prov, test',
    norwegian: 'prøve, test',
    finnish: 'testi, koe',
    hungarian: 'vizsga, felmérés, teszt',
    german: 'Test, Prüfung, Klausur',
    dutch: 'toets, overhoring, examen',
    afrikaans: 'toets, eksamen, assessering',
    russian: 'экзамен, тест',
    latvian: 'tests, kontroldarbs',
    polish: 'test, ocena, egzamin',
    french: 'test, évaluation',
    spanish: 'prueba, examen, evaluación',
  },
  {
    av: 17529,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + sperm)',
    english: 'testicle',
    swedish: 'testikel',
    norwegian: 'testikkel',
    finnish: 'kives',
    hungarian: 'here, heregolyó',
    german: 'Hoden',
    dutch: 'testikel',
    afrikaans: 'testikel',
    russian: 'яичко',
    latvian: 'sēklinieks',
    polish: 'jądro (męskie)',
    french: 'testicule',
    spanish: 'testículo',
  },
  {
    av: 17530,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + winter: month of rain, typifying winter)',
    english: 'Tevet',
    swedish: 'Tevet (Israel)',
    norwegian: 'Tevet (Israel)',
    finnish: 'tebet, tevét',
    hungarian: 'Tevet (héber)',
    german: 'Tevet',
    dutch: 'Tevet (Joods)',
    afrikaans: 'Tevet',
    russian: 'Тевет (Израиль)',
    latvian: 'Tevet (Izraēla)',
    polish: 'Tewet (miesiąc hebr)',
    french: 'Tevet (10e mois du calendrier juif)',
    spanish: 'Tevet',
  },
  {
    av: 17531,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(2 + box + part + Torah: two boxes with part of Torah)',
    english: 'tefillin',
    swedish: 'tfillim (Israel)',
    norwegian: 'tfillim (Israel)',
    finnish: 'tefillin',
    hungarian: 'tefillin (héber)',
    german: 'Tfillim',
    dutch: 'tefillin (Joods)',
    afrikaans: 'tefillin',
    russian: 'тфилим (Израиль)',
    latvian: 'tfilim (Izraēla)',
    polish: 'tefilin (hebr)',
    french: 'tefilin (judaïsme)',
    spanish: 'tefilín',
  },
  {
    av: 17532,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(thanks + action indicator)',
    english: 'thank-(to)',
    swedish: 'tacka',
    norwegian: 'takke',
    finnish: 'kiittää',
    hungarian: 'megköszönni, köszönetet mondani',
    german: 'bedanken',
    dutch: 'bedanken',
    afrikaans: 'bedank (om te)',
    russian: 'благодарить',
    latvian: 'pateikties',
    polish: 'dziękować',
    french: 'remercier',
    spanish: 'agradecer',
  },
  {
    av: 17533,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: 'feeling + to give: polite phrase used to express gratitude to another)',
    english: 'thanks, thank you',
    swedish: 'tack',
    norwegian: 'takk',
    finnish: 'kiitos',
    hungarian: 'köszönet, megköszönés, hála',
    german: 'danke, dankeschön',
    dutch: 'bedankt, dankuwel, dankjewel',
    afrikaans: 'bedank, dankie, dankbaar',
    russian: 'спасибо',
    latvian: 'paldies',
    polish: 'podziękowanie',
    french: 'remerciement',
    spanish: 'gracias',
  },
  {
    av: 17534,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + thanks: day for giving thanks)',
    english: 'thanksgiving',
    swedish: 'tacksägelsedagen',
    norwegian: 'høsttakkefest',
    finnish: 'kiitospäivä',
    hungarian: 'Hálaadás ünnepe',
    german: 'Erntedankfest',
    dutch: 'Thanksgiving',
    afrikaans: 'Thanksgiving',
    russian: 'День благодарения',
    latvian: 'Pateicības diena',
    polish: 'dziękczynienie',
    french: 'action de grâce',
    spanish: 'acción de gracias',
  },
  {
    av: 17698,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(sad + about )',
    english: "too bad, I'm sorry, I'm so sorry",
    swedish: 'tyvärr',
    norwegian: 'beklager så mye (utsagn)',
    finnish: 'olen pahoillani, mikä vahinko',
    hungarian: 'Sajnálom! Nagyon sajnálom! Ez tényleg rossz!',
    german: 'wie Schade',
    dutch: 'sorry, het spijt me, excuseer',
    afrikaans: 'dis jammer ek is jammer so jammer tot my spyt',
    russian: 'к сожалению',
    latvian: 'žēl, atvainojos, man žēl',
    polish: 'przykro mi, to niedobrze',
    french: 'dommage, tant pis',
    spanish: 'qué pena, qué lástima, lo siento',
  },
  {
    av: 17699,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(thawing, melting + action indicator: solid ice turns into water)',
    english: 'thaw, melt-(to)',
    swedish: 'smälta, tina',
    norwegian: 'smelte, tine',
    finnish: 'sulaa, sulattaa',
    hungarian: 'olvadni, elolvadni, felolvadni, feolvasztani',
    german: 'tauen, auftauen, schmelzen',
    dutch: 'smelten',
    afrikaans: 'smelt (om te)',
    russian: 'таять, оттаивать',
    latvian: 'kust, atkust',
    polish: 'stopić, rozmrozić',
    french: 'dégeler, fondre',
    spanish: 'descongelar, derretir',
  },
  {
    av: 17701,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(they + belongs to + plural indicator)',
    english: 'their, theirs-(persons)',
    swedish: 'deras, sin, sitt, sina ',
    norwegian: 'deres, sin, sitt, sine (personer)',
    finnish: 'heidän',
    hungarian: 'övék',
    german: 'ihr, ihr, ihre, ihr, Ihr',
    dutch: 'hun, van hen',
    afrikaans: 'hulle, hulle sin (persone)',
    russian: 'их (притяж.местоим., 3 л., мн.ч.)',
    latvian: 'viņu',
    polish: 'ich-(r. męski l. mn.)',
    french: 'leur, leurs',
    spanish: 'sus, suyos (personas)',
  },
  {
    av: 17702,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(its + plural indicator: refers to things rather than to people)',
    english: 'their, theirs-(indefinite)',
    swedish: 'deras, sin, sitt, sina (opersonligt)',
    norwegian: 'deres, sin, sitt, sine (ubestemt)',
    finnish: 'niiden',
    hungarian: 'azoké',
    german: 'ihre, ihren',
    dutch: 'hun (onbepaald), van hen (onbepaald)',
    afrikaans: 'hulle, hulle sin (onbepaald)',
    russian: 'их (кроме человека)',
    latvian: 'viņu, to',
    polish: 'ich-(r. żeński, l. mn.)',
    french: 'leur, leurs (indéfini)',
    spanish: 'sus, suyos (indefinido)',
  },
  {
    av: 17703,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(female + 3 + belongs to + plural indicator: third person (f. pl.))',
    english: 'their, theirs-(feminine plural)',
    swedish: 'deras, sin, sitt, sina (fem.)',
    norwegian: 'deres, sin, sitt, sine (hunkjønn)',
    finnish: 'heidän (naisia), heidän (fem.)',
    hungarian: 'övék (nőnem)',
    german: 'ihren',
    dutch: 'hun (vrouwelijk), van hen (vrouwelijk)',
    afrikaans: 'hulle, hulle sin (vroulik meervoud)',
    russian: 'их (жен.)',
    latvian: 'viņu, to (siev.dz.dsk.)',
    polish: 'ich-(osób)',
    french: 'leur, leurs (fém.plur.)',
    spanish: 'sus, suyas (plural femenino)',
  },
  {
    av: 17704,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(male + 3 + belongs to + plural indicator: third person (m.pl.))',
    english: 'their, theirs-(masculine plural)',
    swedish: 'deras, sin, sitt, sina (mask.)',
    norwegian: 'deres, sin, sitt, sine (hankjønn)',
    finnish: 'heidän (miehiä), heidän (mask.)',
    hungarian: 'övék (hímnem)',
    german: 'ihren',
    dutch: 'hun (mannelijk), van hen (mannelijk)',
    afrikaans: 'hulle, hulle sin (manlik meervoud)',
    russian: 'их (муж.)',
    latvian: 'viņu, to (vīr.dz.dsk.)',
    polish: 'ich-(r. nieokreślony, l. mn) ',
    french: 'leur, leurs (masc. plur.)',
    spanish: 'sus, suyos (plural masculino)',
  },
  {
    av: 17709,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(temperature + thing indicator: The symbol is the concrete form of temperature) - (character with thing indicator)',
    english: 'thermometer',
    swedish: 'termometer',
    norwegian: 'termometer',
    finnish: 'lämpömittari, kuumemittari',
    hungarian: 'hőmérő',
    german: 'Thermometer',
    dutch: 'thermometer',
    afrikaans: 'termometer',
    russian: 'градусник, термометр',
    latvian: 'termometrs',
    polish: 'termometr',
    french: 'thermomètre',
    spanish: 'termómetro',
  },
  {
    av: 17710,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(container + same + temperature: container that keeps food or drink at a constant temperature for several hours)',
    english: 'thermos, cooler, flask',
    swedish: 'termos, kylväska (etc)',
    norwegian: 'termos',
    finnish: 'termospullo, termosastia',
    hungarian: 'termosz, hűtőedény, hűtőtáska',
    german: 'Warmhalteflasche, Thermosflasche',
    dutch: 'thermos (Vl), thermoskan',
    afrikaans: 'termosfles, verkoeler',
    russian: 'термос',
    latvian: 'termoss',
    polish: 'termos',
    french: 'thermos',
    spanish: 'termos',
  },
  {
    av: 17711,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(this + plural indicator)',
    english: 'these',
    swedish: 'de här, dom här, dessa',
    norwegian: 'disse, de her',
    finnish: 'nämä',
    hungarian: 'ezek',
    german: 'diese',
    dutch: 'deze',
    afrikaans: 'hierdie',
    russian: 'эти',
    latvian: 'šie, šīs',
    polish: 'te',
    french: 'ces',
    spanish: 'estos',
  },
  {
    av: 17712,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(it + plural indicator: refers to things rather than to people)',
    english: 'they, them, themselves-(indefinite)',
    swedish: 'de, dem, sig (obestämd plur)',
    norwegian: 'de, dem, seg (ubestemt)',
    finnish: 'ne, niitä',
    hungarian: 'azok, azokat',
    german: 'sie',
    dutch: 'zij (onbepaald meerv), hen (onbepaald meerv)',
    afrikaans: 'hulle, hulself (onbepaald)',
    russian: 'они',
    latvian: 'viņi, viņiem, paši',
    polish: 'oni, ich, same (r nieokreślony) – niekoniecznie człowiek',
    french: 'ils, elles (3e pers. plur. impersonnel)',
    spanish: 'ellos, a ellos, se (indefinido)',
  },
  {
    av: 17713,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + 3 + plural indicator: third person plural)',
    english: 'they, them, themselves-(persons)',
    swedish: 'de, dem, sig (plur.)',
    norwegian: 'de, dem, seg (personer)',
    finnish: 'he',
    hungarian: 'ők, őket, önmaguk, önmagukat',
    german: 'sie, ihr, ihnen',
    dutch: 'zij (derde pers.meerv), hen (derde pers.meerv)',
    afrikaans: 'hulle, hulself (persone)',
    russian: 'они, им',
    latvian: 'viņi, viņiem, pašiem',
    polish: 'oni, ich (r dowolny, l. mn. osoby) ',
    french: 'ils',
    spanish: 'ellos, a ellos, se (personas)',
  },
  {
    av: 17714,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(female + 3 + plural indicator)',
    english: 'they, them, themselves-(feminine plural)',
    swedish: 'de, dem, sig (fem. plur)',
    norwegian: 'de, dem, seg (hunkjønn)',
    finnish: 'he (naisia), he (fem.), heitä',
    hungarian: 'ők, őket, önmaguk, önmagukat (nőnem)',
    german: 'sie',
    dutch: 'zij (vrouwelijk meerv), hen (vrouwelijk meerv)',
    afrikaans: 'hulle, hulself (vroulik meervoud)',
    russian: 'они жен. род мн.ч.',
    latvian: 'viņas, viņām, pašām',
    polish: 'one, ich, same (r. żeński, l. mn.)',
    french: 'elles (3e pers. fém. plur.), elles-mêmes',
    spanish: 'ellas, a ellas, se (plural femenino)',
  },
  {
    av: 17715,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(male + 3 + plural indicator)',
    english: 'they, them, themselves-(masculine plural)',
    swedish: 'de, dem, sig (mask. plur.)',
    norwegian: 'de, dem, seg (hankjønn)',
    finnish: 'he (miehiä), he (mask.), heitä',
    hungarian: 'ők, őket, önmaguk, önmagukat (hímnem)',
    german: 'sie',
    dutch: 'zij (mannelijk meerv), hen (mannelijk meerv)',
    afrikaans: 'hulle, hulself (manlik meervoud)',
    russian: 'они муж.род.мн.ч.',
    latvian: 'viņi, viņiem, pašiem',
    polish: 'oni, ich, sami (r. męski, l. mn.)',
    french: 'ils (3e pers. masc. plur.), eux-mêmes ',
    spanish: 'ellos, a ellos, se (plural masculino)',
  },
  {
    av: 17716,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(thinness, narrowness + description indicator: the pointers point inward toward the narrow space formed by the reference lines)',
    english: 'thin, slim, narrow',
    swedish: 'smal, tunn',
    norwegian: 'tynn, slank',
    finnish: 'ohut, laiha',
    hungarian: 'vékony, keskeny, karcsú',
    german: 'dünn, schlank, schmal, eng',
    dutch: 'dun, smal',
    afrikaans: 'dun, smal, nou',
    russian: 'тонкий',
    latvian: 'plāns, tievs',
    polish: 'cienki, szczupły',
    french: 'mince, fin',
    spanish: 'delgado',
  },
  {
    av: 17718,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(mind + action indicator)',
    english: 'think, reason-(to)',
    swedish: 'tänka, tycka, tro',
    norwegian: 'tenke, tro (å), synes, mene',
    finnish: 'ajatella, järkeillä',
    hungarian: 'gondolni, gondolkodni, kigondolni',
    german: 'denken, überlegen, sich klar machen',
    dutch: 'denken',
    afrikaans: 'dink, redeneer (om te)',
    russian: 'думать',
    latvian: 'domāt, spriest, pamatot',
    polish: 'myśleć, wnioskować',
    french: 'penser',
    spanish: 'pensar, razonar',
  },
  {
    av: 17719,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(feeling + minus + drink + description indicator: having a feeling caused by the lack of drink)',
    english: 'thirsty',
    swedish: 'törstig',
    norwegian: 'tørst',
    finnish: 'janoinen',
    hungarian: 'szomjas',
    german: 'durstig',
    dutch: 'dorstig, dorst',
    afrikaans: 'dors, dorstig',
    russian: 'жаждущий',
    latvian: 'izslāpis (-usi)',
    polish: 'spragniony',
    french: 'assoiffé',
    spanish: 'sediento',
  },
  {
    av: 17721,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(week + now)',
    english: 'this week',
    swedish: 'den här veckan',
    norwegian: 'denne uka',
    finnish: 'tämä viikko',
    hungarian: 'ezen a héten',
    german: 'diese Woche',
    dutch: 'deze week',
    afrikaans: 'hierdie week',
    russian: 'на этой неделе',
    latvian: 'šonedēļ',
    polish: 'w tym tygodniu',
    french: 'cette semaine-ci',
    spanish: 'esta semana',
  },
  {
    av: 17722,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(year + now)',
    english: 'this year',
    swedish: 'i år',
    norwegian: 'i år',
    finnish: 'tämä vuosi',
    hungarian: 'idén, ebben az évben',
    german: 'dieses Jahr',
    dutch: 'dit jaar',
    afrikaans: 'hierdie jaar',
    russian: 'в этом году',
    latvian: 'šogad',
    polish: 'w tym roku',
    french: 'cette année-ci',
    spanish: 'este año',
  },
  {
    av: 17723,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(that + plural indicator)',
    english: 'those',
    swedish: 'de där, dom där, de, dom',
    norwegian: 'de der',
    finnish: 'nuo',
    hungarian: 'azok',
    german: 'jene, diese',
    dutch: 'die (meervoud)',
    afrikaans: 'daardie',
    russian: 'те',
    latvian: 'tie, tās',
    polish: 'tamte',
    french: 'ces, ceux-là',
    spanish: 'aquellos',
  },
  {
    av: 17725,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(hand + to give + intensity + action indicator: to discharge into the air with a swift motion of the arm)',
    english: 'throw-(to)',
    swedish: 'kasta',
    norwegian: 'hive, kaste',
    finnish: 'heittää',
    hungarian: 'dobni, hajítani, eldobni',
    german: 'werfen, schleudern',
    dutch: 'gooien, werpen',
    afrikaans: 'gooi (om te)',
    russian: 'бросать',
    latvian: 'mest',
    polish: 'rzucać',
    french: 'lancer, jeter',
    spanish: 'tirar, lanzar',
  },
  {
    av: 17727,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ear + lightning: sound that accompanies lightning)',
    english: 'thunder',
    swedish: 'åska',
    norwegian: 'torden',
    finnish: 'ukkonen, ukonilma',
    hungarian: 'dörgés, égzengés',
    german: 'Donner',
    dutch: 'donder',
    afrikaans: 'donderweer',
    russian: 'гром, гроза',
    latvian: 'pērkons',
    polish: 'grzmot',
    french: 'tonnerre',
    spanish: 'trueno',
  },
  {
    av: 17729,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + to enter: piece of paper that allows you to enter)',
    english: 'ticket, pass',
    swedish: 'biljett',
    norwegian: 'billett',
    finnish: 'lippu, matkalippu, pääsylippu',
    hungarian: 'jegy, belépő',
    german: 'Fahrkarte, Karte, Eintrittskarte',
    dutch: 'ticket, kaartje',
    afrikaans: 'kaartjie',
    russian: 'билет',
    latvian: 'biļete, caurlaide',
    polish: 'bilet, wejściówka',
    french: 'ticket',
    spanish: 'boleto',
  },
  {
    av: 17730,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + neck + thing indicator)',
    english: 'tie, necktie',
    swedish: 'slips',
    norwegian: 'slips',
    finnish: 'solmio',
    hungarian: 'nyakkendő',
    german: 'Krawatte, Schlips',
    dutch: 'stropdas, das',
    afrikaans: 'das',
    russian: 'галстук',
    latvian: 'kaklasaite',
    polish: 'krawat',
    french: 'cravate',
    spanish: 'corbata',
  },
  {
    av: 17731,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feline + stripe)',
    english: 'tiger',
    swedish: 'tiger',
    norwegian: 'tiger',
    finnish: 'tiikeri',
    hungarian: 'tigris',
    german: 'Tiger, Tigerin',
    dutch: 'tijger',
    afrikaans: 'tier',
    russian: 'тигр',
    latvian: 'tīģeris',
    polish: 'tygrys',
    french: 'tigre',
    spanish: 'tigre',
  },
  {
    av: 17733,
    group: 'word',
    pos: 'RED',
    derivationExplanation: "(toe + action indicator: to walk on one's toes)",
    english: 'tiptoe-(to)',
    swedish: 'gå på tå, trippa',
    norwegian: 'gå på tærne, liste seg',
    finnish: 'kävellä varpaisillaan',
    hungarian: 'lábujjhegyen járni, lábujjhegyezni',
    german: 'auf Zehenspitzen gehen, trippeln',
    dutch: 'op de tenen lopen',
    afrikaans: 'op die punte van die tone loop (om te)',
    russian: 'ходить на цыпочках',
    latvian: 'staigāt uz pirkstgaliem',
    polish: 'chodzić na palcach',
    french: 'marcher sur la pointe des pieds',
    spanish: 'andar de puntillas',
  },
  {
    av: 17736,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + temple ruin: day of temple destruction)',
    english: "Tisha B'Av",
    swedish: "Tisha B'Av (Israel)",
    norwegian: 'Tisha B`Av (Israel)',
    finnish: "tiša be'av",
    hungarian: 'Tisha Bav (héber)',
    german: "Tisha B'Av",
    dutch: "Tisha B'Av (Joods)",
    afrikaans: "Tisha B'Av",
    russian: 'Тиша БАв (Израиль)',
    latvian: 'Tiša (Izraēla)',
    polish: 'Tisza be-Aw (hebr święto)',
    french: 'Tishah be-Av (fête juive)',
    spanish: "Tisha B'Av ",
  },
  {
    av: 17737,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + shofar: month of Rosh Hashana)',
    english: 'Tishri',
    swedish: 'Tishrai (Israel)',
    norwegian: 'Tishrai (Israel)',
    finnish: 'tisri, tišri',
    hungarian: 'Tishri (héber)',
    german: 'Tishrai',
    dutch: 'Tishrai (Joods)',
    afrikaans: 'Tishri',
    russian: 'Тишрей (Израиль)',
    latvian: 'Tišra (Izraēla)',
    polish: 'Tiszri (miesiąc hebr)',
    french: 'Tishri (7e mois du calendrier juif)',
    spanish: 'Tishri ',
  },
  {
    av: 17738,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + nose)',
    english: 'tissue',
    swedish: 'pappersnäsduk',
    norwegian: 'papirlommetørkle',
    finnish: 'paperinenäliina',
    hungarian: 'papírzsebkendő, papírzsepi',
    german: 'Papiertaschentuch, Taschentuch',
    dutch: 'papieren zakdoek, tissue',
    afrikaans: 'sneesdoekie',
    russian: 'бумажный носовой платок',
    latvian: 'papīra salvete',
    polish: 'chusteczka higieniczna (papierowa)',
    french: 'mouchoir en papier',
    spanish: 'pañuelos desechables',
  },
  {
    av: 17740,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bread surface + fire: bread browned on both sides)',
    english: 'toast',
    swedish: 'rostat bröd',
    norwegian: 'ristet brød',
    finnish: 'paahtoleipä',
    hungarian: 'pirítós, pirítós kenyér, pirított kenyér',
    german: 'Toast, geröstetes Brot, Toast',
    dutch: 'geroosterd brood, toast',
    afrikaans: 'geroosterde brood, roosterbrood',
    russian: 'тост, сухарик',
    latvian: 'grauzdiņš, grauzdēta maizes šķēle',
    polish: 'tost, grzanka',
    french: 'pain grillé, toast',
    spanish: 'tostada',
  },
  {
    av: 17741,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(fire + bread surface + action indicator)',
    english: 'toast-(to)',
    swedish: 'rosta bröd',
    norwegian: 'riste brød',
    finnish: 'paahtaa leipää',
    hungarian: 'pirítani (kenyeret)',
    german: 'toasten',
    dutch: 'roosteren',
    afrikaans: 'rooster (om te)',
    russian: 'поджаривать хлеб',
    latvian: 'apgrauzdēt',
    polish: 'tostować (robić grzanki)',
    french: 'griller du pain',
    spanish: 'tostar',
  },
  {
    av: 17742,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to toast)',
    english: 'toaster',
    swedish: 'brödrost',
    norwegian: 'brødrister',
    finnish: 'leivänpaahdin',
    hungarian: 'kenyérpirító',
    german: 'Toaster',
    dutch: 'broodrooster, toaster',
    afrikaans: 'broodrooster, rooster',
    russian: 'тостер',
    latvian: 'tosters',
    polish: 'toster',
    french: 'grille-pain',
    spanish: 'tostador',
  },
  {
    av: 17743,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(leaf + to smoke: leaf used for smoking)',
    english: 'tobacco',
    swedish: 'tobak',
    norwegian: 'tobakk',
    finnish: 'tupakka',
    hungarian: 'dohány, dohánylevél',
    german: 'Tabak',
    dutch: 'tabak',
    afrikaans: 'tabak',
    russian: 'табак',
    latvian: 'tabaka',
    polish: 'tytoń',
    french: 'tabac',
    spanish: 'tabaco',
  },
  {
    av: 17744,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + now)',
    english: 'today',
    swedish: 'idag',
    norwegian: 'i dag',
    finnish: 'tänään',
    hungarian: 'ma',
    german: 'heute',
    dutch: 'vandaag',
    afrikaans: 'vandag',
    russian: 'сегодня',
    latvian: 'šodien',
    polish: 'dzisiaj',
    french: "aujourd'hui",
    spanish: 'hoy',
  },
  {
    av: 17746,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(attachment, appendix, annex + description indicator)',
    english: 'together, attached, appended, fastened, joined',
    swedish: 'tillsammans, ihop',
    norwegian: 'sammenføyd, vedlagt, isammen, tilsluttet',
    finnish: 'yhdessä',
    hungarian: 'együtt, csatlakozva, összefűzve',
    german: 'zusammen, gemeinsam, miteinander',
    dutch: 'samen, vast aan',
    afrikaans: 'saam, aangeheg, vasgemaak, saam gevoeg, vas',
    russian: 'вместе',
    latvian: 'klāt, kopā, pievienots, piestiprināts',
    polish: 'razem, przytwierdzony, połączony',
    french: 'ensemble',
    spanish: 'juntos, adjuntos, unidos',
  },
  {
    av: 17748,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + toilet)',
    english: 'toilet paper',
    swedish: 'toalettpapper',
    norwegian: 'toalettpapir',
    finnish: 'vessapaperi, WC-paperi',
    hungarian: 'vécépapír',
    german: 'Toilettenpapier, Klopapier',
    dutch: 'toiletpapier, wc-papier',
    afrikaans: 'toiletpapier',
    russian: 'туалетная бумага',
    latvian: 'tualetes paīrs',
    polish: 'papier toaletowy',
    french: 'papier toilette',
    spanish: 'papel higiénico',
  },
  {
    av: 17749,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vegetable above ground + red)',
    english: 'tomato',
    swedish: 'tomat',
    norwegian: 'tomat',
    finnish: 'tomaatti',
    hungarian: 'paradicsom',
    german: 'Tomate',
    dutch: 'tomaat',
    afrikaans: 'tamatie',
    russian: 'помидор, томат',
    latvian: 'tomāts',
    polish: 'pomidor',
    french: 'tomate',
    spanish: 'tomate',
  },
  {
    av: 17750,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + then (future))',
    english: 'tomorrow',
    swedish: 'imorgon',
    norwegian: 'i morgen',
    finnish: 'huomenna',
    hungarian: 'holnap',
    german: 'morgen',
    dutch: 'morgen',
    afrikaans: 'môre',
    russian: 'завтра',
    latvian: 'rīt',
    polish: 'jutro',
    french: 'demain',
    spanish: 'mañana',
  },
  {
    av: 17751,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(night + then (future))',
    english: 'tomorrow night',
    swedish: 'imorgon natt',
    norwegian: 'i morgen natt',
    finnish: 'ensi yö',
    hungarian: 'holnap este, holnap éjjel',
    german: 'morgen Abend',
    dutch: 'morgenavond',
    afrikaans: 'môre aand',
    russian: 'завтра ночью ',
    latvian: 'rītvakar',
    polish: 'jutro wieczorem',
    french: 'demain soir',
    spanish: 'mañana por la noche',
  },
  {
    av: 17752,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(part of + mouth + up and down: the part of the mouth that moves up and down)',
    english: 'tongue',
    swedish: 'tunga',
    norwegian: 'tunge',
    finnish: 'kieli',
    hungarian: 'nyelv (testrész)',
    german: 'Zunge',
    dutch: 'tong',
    afrikaans: 'tong',
    russian: 'язык',
    latvian: 'mēle',
    polish: 'język',
    french: 'langue (partie de la bouche)',
    spanish: 'lengua',
  },
  {
    av: 17753,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(night + now)',
    english: 'tonight',
    swedish: 'inatt',
    norwegian: 'i natt',
    finnish: 'tämä yö',
    hungarian: 'ma este, ma éjjel',
    german: 'heute Nacht',
    dutch: 'vanavond',
    afrikaans: 'vanaand',
    russian: 'сегодня ночью',
    latvian: 'šovakar',
    polish: 'dziś wieczór',
    french: 'ce soir',
    spanish: 'esta noche',
  },
  {
    av: 17754,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(over + much/many + description indicator: over the amount or number needed)',
    english: 'too much, too many',
    swedish: 'för mycket, för många',
    norwegian: 'for mye, for mange',
    finnish: 'liian paljon, liian monta, liikaa',
    hungarian: 'túl sok',
    german: 'zu viel',
    dutch: 'teveel',
    afrikaans: 'teveel',
    russian: 'слишком много',
    latvian: 'par daudz',
    polish: 'zbyt wiele, za dużo',
    french: 'trop',
    spanish: 'demasiado',
  },
  {
    av: 17756,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(brush + teeth)',
    english: 'toothbrush',
    swedish: 'tandborste',
    norwegian: 'tannbørste',
    finnish: 'hammasharja',
    hungarian: 'fogkefe',
    german: 'Zahnbürste',
    dutch: 'tandenborstel',
    afrikaans: 'tandeborsel',
    russian: 'зубная щётка',
    latvian: 'zobu birste',
    polish: 'szczoteczka do zębów',
    french: 'brosse à dents',
    spanish: 'cepillo de dientes',
  },
  {
    av: 17757,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(chemical product + brush + teeth: chemical product for brushing teeth)',
    english: 'toothpaste',
    swedish: 'tandkräm',
    norwegian: 'tannkrem',
    finnish: 'hammastahna',
    hungarian: 'fogkrém, fogpaszta',
    german: 'Zahnpasta, Zahncreme',
    dutch: 'tandpasta',
    afrikaans: 'tandepasta',
    russian: 'зубная паста',
    latvian: 'zobu pasta',
    polish: 'pasta do zębów',
    french: 'dentifrice',
    spanish: 'dentífrico',
  },
  {
    av: 17761,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hand + action indicator)',
    english: 'touch, feel-(to)',
    swedish: 'röra, beröra, känna',
    norwegian: 'røre, berøre, kjenne',
    finnish: 'koskettaa, koskea',
    hungarian: 'megérinteni, megtapintani',
    german: 'berühren, anfassen, befühlen, tasten',
    dutch: 'aanraken, voelen (met hand)',
    afrikaans: 'aanraak, vat, voel (om te)',
    russian: 'трогать, щупать, касаться',
    latvian: 'aizskart, aiztikt, sataustīt',
    polish: 'dotknąć, poczuć',
    french: 'toucher',
    spanish: 'tocar, palpar',
  },
  {
    av: 17763,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + play: a plaything)',
    english: 'toy',
    swedish: 'leksak',
    norwegian: 'leketøy, leke',
    finnish: 'leikkikalu, lelu',
    hungarian: 'játék, játéktárgy',
    german: 'Spielzeug',
    dutch: 'speelgoed',
    afrikaans: 'speelding, speelgoed',
    russian: 'игрушка',
    latvian: 'rotaļlieta',
    polish: 'zabawka',
    french: 'jouet',
    spanish: 'juguete',
  },
  {
    av: 17764,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + man-made)',
    english: 'toy animal, stuffed animal',
    swedish: 'leksaksdjur',
    norwegian: 'lekedyr',
    finnish: 'leikkieläin',
    hungarian: 'játékállat, plüssállat',
    german: 'Spielzeugtier',
    dutch: 'knuffeldier, dier (gemaakt)',
    afrikaans: 'opgestopte speelgoed dier',
    russian: 'животное игрушка',
    latvian: 'dzīvnieku izbāzenis',
    polish: 'zwierzę pluszowe, maskotka',
    french: 'animal en peluche',
    spanish: 'animal de juguete, animal de peluche',
  },
  {
    av: 17766,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + car)',
    english: 'traffic',
    swedish: 'trafik',
    norwegian: 'trafikk',
    finnish: 'liikenne',
    hungarian: 'forgalom',
    german: 'Verkehr',
    dutch: 'verkeer',
    afrikaans: 'verkeer',
    russian: 'дорожное движение',
    latvian: 'satiksme, ielas',
    polish: 'ruch uliczny, samochodowy',
    french: 'trafic, circulation',
    spanish: 'tráfico',
  },
  {
    av: 17767,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + railway car: many connected railway cars)',
    english: 'train',
    swedish: 'tåg',
    norwegian: 'tog',
    finnish: 'juna',
    hungarian: 'vonat',
    german: 'Zug, Eisenbahn, ICE',
    dutch: 'trein',
    afrikaans: 'trein',
    russian: 'поезд',
    latvian: 'viciens',
    polish: 'pociąg',
    french: 'train',
    spanish: 'tren',
  },
  {
    av: 17768,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(platform + to jump)',
    english: 'trampoline',
    swedish: 'studsmatta, trampolin (etc)',
    norwegian: 'trampoline',
    finnish: 'trampoliini',
    hungarian: 'ugrószőnyeg',
    german: 'Trampolin',
    dutch: 'trampoline',
    afrikaans: 'trampolien',
    russian: 'трамплин',
    latvian: 'tramplīns',
    polish: 'trampolina',
    french: 'trampoline',
    spanish: 'trampolín',
  },
  {
    av: 17769,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(bridge + language + action indicator: to form a bridge of understanding between languages)',
    english: 'translate-(to)',
    swedish: 'översätta',
    norwegian: 'oversette',
    finnish: 'kääntää, tulkita',
    hungarian: 'fordítani, lefordítani (nyelvet)',
    german: 'übersetzen, übertragen',
    dutch: 'vertalen',
    afrikaans: 'vertaal (om te)',
    russian: 'переводить',
    latvian: 'tulkot',
    polish: 'tłumaczyć',
    french: 'traduire, interpréter',
    spanish: 'traducir',
  },
  {
    av: 17770,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(woman + to dress + man: woman who dresses like a man)',
    english: 'transvestite (female)',
    swedish: 'transvestit (kvinna)',
    norwegian: 'transvestitt (hunkjønn)',
    finnish: 'transvestiitti (nainen)',
    hungarian: 'transzvesztita nő, nemváltó nő',
    german: 'Transvestitin',
    dutch: 'travestiet (vrouw)',
    afrikaans: 'transvestiet (vroulik)',
    russian: 'трансвестит жен.',
    latvian: 'transvestīte',
    polish: 'transwestyta (kobieta)',
    french: 'travestie (femme)',
    spanish: 'travestido (mujer)',
  },
  {
    av: 17771,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + to dress + woman: man who dresses like a woman)',
    english: 'transvestite (male)',
    swedish: 'transvestit (man)',
    norwegian: 'transvestitt (hankjønn)',
    finnish: 'transvestiitti (mies)',
    hungarian: 'transzvesztita férfi, nemváltó férfi',
    german: 'Transvestit',
    dutch: 'travestiet (man)',
    afrikaans: 'transvestiet (manlik)',
    russian: 'трансвестит муж.',
    latvian: 'transvestīts',
    polish: 'transwestyta (mężczyzna)',
    french: 'travesti (homme)',
    spanish: 'travestido (hombre)',
  },
  {
    av: 17772,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(trip + action indicator)',
    english: 'travel-(to)',
    swedish: 'resa (verb)',
    norwegian: 'reise (å)',
    finnish: 'matkustaa',
    hungarian: 'utazni',
    german: 'reisen, verreisen',
    dutch: 'reizen',
    afrikaans: 'reis (om te)',
    russian: 'ездить, путешествовать',
    latvian: 'ceļot',
    polish: 'podróżować',
    french: 'voyager',
    spanish: 'viajar',
  },
  {
    av: 17774,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + special: a thing or occurrence that causes special pleasure or delight)',
    english: 'treat',
    swedish: 'nöje, upplevelse, belöning',
    norwegian: 'belønning',
    finnish: 'mukava yllätys',
    hungarian: 'kellemes dolog, kellemes élmény',
    german: 'Vergnügen, Leckerei, Genuss',
    dutch: 'traktatie, beloning',
    afrikaans: 'beloning, trakteer, bederf',
    russian: 'вознаграждение ',
    latvian: 'cienasts, pacienājums, atlīdzība',
    polish: 'prezent, niespodzianka, nagroda',
    french: 'cadeau, gâterie',
    spanish: 'premio, placer, darse un gusto',
  },
  {
    av: 17776,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + triangular shape: triangle, a geometric shape)',
    english: 'triangle',
    swedish: 'triangel',
    norwegian: 'trekant, triangel',
    finnish: 'kolmio',
    hungarian: 'háromszög',
    german: 'Dreieck, Triangel',
    dutch: 'driehoek',
    afrikaans: 'driehoek (vorm)',
    russian: 'треугольник',
    latvian: 'trīsstūris',
    polish: 'trójkąt (kształt)',
    french: 'triangle (figure géométrique)',
    spanish: 'triángulo',
  },
  {
    av: 17777,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(triangle + description indicator)',
    english: 'triangular',
    swedish: 'trekantig',
    norwegian: 'trekantet, triangulær',
    finnish: 'kolmion muotoinen, kolmikulmainen',
    hungarian: 'háromszögű, háromszögletű',
    german: 'dreieckig',
    dutch: 'driehoekig',
    afrikaans: 'driehoekig',
    russian: 'треугольный',
    latvian: 'trīsstūrains',
    polish: 'trójkątny',
    french: 'triangulaire',
    spanish: 'triangular',
  },
  {
    av: 17778,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(3 + wheel: three-wheeled cycle)',
    english: 'tricycle',
    swedish: 'trehjuling',
    norwegian: 'trehjulssykkel',
    finnish: 'kolmipyörä',
    hungarian: 'háromkerekű, tricikli',
    german: 'Dreirad',
    dutch: 'driewieler',
    afrikaans: 'driewiel',
    russian: 'трехколёсник',
    latvian: 'trīsriteņu',
    polish: 'trójkołowy',
    french: 'tricycle',
    spanish: 'triciclo',
  },
  {
    av: 17780,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + opposing forces, counter-forces: feeling of being beset by opposing forces) See also worry 18280.',
    english: 'trouble',
    swedish: 'besvär',
    norwegian: 'besvær, plage, trøbbel',
    finnish: 'hankaluus, vaiva',
    hungarian: 'baj, gond, aggodalom',
    german: 'Sorge, Schwierigkeit, Kummer, Mühe',
    dutch: 'ongemak, moeite',
    afrikaans: 'moeilikheid',
    russian: 'беда, неприятность',
    latvian: 'rūpes, nepatikšanas',
    polish: 'kłopoty',
    french: 'problème, ennui',
    spanish: 'problema',
  },
  {
    av: 17782,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(truth + description indicator)',
    english: 'true, truly, truthful, truthfully',
    swedish: 'sann',
    norwegian: 'sant',
    finnish: 'totta',
    hungarian: 'igaz, becsületes, igazmondó, hiteles',
    german: 'wahr, echt, ehrlich',
    dutch: 'waar',
    afrikaans: 'waar, regtig, eerlikwaar, waarheid',
    russian: 'правдивый',
    latvian: 'patiess, īsts, patiesi',
    polish: 'prawdziwy, szczery',
    french: 'vrai, véritable, véridique',
    spanish: 'cierto, real, realmente, veraz, sinceridad',
  },
  {
    av: 17784,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(trust + action indicator)',
    english: 'trust-(to)',
    swedish: 'lita på',
    norwegian: 'stole på',
    finnish: 'luottaa',
    hungarian: 'bízni, megbízni, bizalommal lenni',
    german: 'vertrauen, sich verlassen, verlassen',
    dutch: 'vertrouwen',
    afrikaans: 'vertrou (om te)',
    russian: 'доверять, верить',
    latvian: 'uzticēties, ticēt',
    polish: 'zaufać',
    french: 'fier-(se), avoir confiance',
    spanish: 'confiar',
  },
  {
    av: 17785,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + certain)',
    english: 'trust, confidence',
    swedish: 'förtroende, tillit',
    norwegian: 'tillit',
    finnish: 'luottamus',
    hungarian: 'bizalom',
    german: 'Vertrauen, Zuversicht',
    dutch: 'vertrouwen (zelfst.nw)',
    afrikaans: 'vertroue, geloof',
    russian: 'доверие',
    latvian: 'uzticība, paļaušanās',
    polish: 'zaufanie',
    french: 'confiance',
    spanish: 'confianza',
  },
  {
    av: 17787,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(attempt, effort, try + action indicator: to move forward with difficulty)',
    english: 'try, attempt-(to)',
    swedish: 'försöka, pröva',
    norwegian: 'prøve, forsøke',
    finnish: 'yrittää, koettaa',
    hungarian: 'próbálni, megpróbálni, megkísérelni',
    german: 'versuchen',
    dutch: 'proberen',
    afrikaans: 'probeer (om te)',
    russian: 'пытаться',
    latvian: 'mēģināt',
    polish: 'próbować, próbowanie',
    french: 'essayer',
    spanish: 'intentar',
  },
  {
    av: 17788,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + birth + tree + plural indicator)',
    english: 'Tu Bishvat',
    swedish: "Tu Bishvat, Tu B'Shvat",
    norwegian: 'Tu B`Shvat (Israel)',
    finnish: 'tu bišvat, puiden uusivuosi',
    hungarian: 'Tu Bishvat (héber)',
    german: "Tu B'Shvat",
    dutch: 'Tu Bishvat (Joods)',
    afrikaans: 'Tu Bishvat',
    russian: 'Ту би-Шват (Израиль)',
    latvian: 'tu Bišvats (Izraēla)',
    polish: 'Tu bi- szwat (hebr) (Dzień Sadzenia Drzew)',
    french: 'Tou bichvat (fête juive)',
    spanish: 'Tu Bishvat ',
  },
  {
    av: 17789,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(operation + fallopian tube)',
    english: 'tubal ligation',
    swedish: 'sterilisering (kvinna)',
    norwegian: 'sterilisering (kvinne)',
    finnish: 'munajohtimien katkaisu',
    hungarian: 'petevezeték lekötése',
    german: 'Tubenligatur',
    dutch: 'sterilisatie (eileider)',
    afrikaans: 'buisafbinding',
    russian: 'стерилизация (женская)',
    latvian: 'olvadu sterilizēšana',
    polish: 'podwiązanie jajowodów',
    french: 'ligature des trompes',
    spanish: 'ligadura de trompas',
  },
  {
    av: 17953,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plan + musical note: planned sequence of notes)',
    english: 'tune, melody',
    swedish: 'melodi, musikstycke',
    norwegian: 'melodi, musikkstykke',
    finnish: 'sävelmä, melodia',
    hungarian: 'dallam, melódia',
    german: 'Melodie',
    dutch: 'melodie',
    afrikaans: 'melodie, wysie',
    russian: 'мелодия',
    latvian: 'melodija',
    polish: 'melodia',
    french: 'ton, air, mélodie',
    spanish: 'melodía',
  },
  {
    av: 17954,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + food + big: large bird used for food)',
    english: 'turkey (bird)',
    swedish: 'kalkon',
    norwegian: 'kalkun',
    finnish: 'kalkkuna',
    hungarian: 'pulyka',
    german: 'Truthahn, Truthenne',
    dutch: 'kalkoen (vogel)',
    afrikaans: 'kalkoen (voël)',
    russian: 'индюк',
    latvian: 'tītars',
    polish: 'indyk',
    french: 'dinde, dindon',
    spanish: 'pavo (ave)',
  },
  {
    av: 17955,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + bird + big: turkey as a dish)',
    english: 'turkey (food)',
    swedish: 'kalkon (mat)',
    norwegian: 'kalkun (mat)',
    finnish: 'kalkkuna (ruoka)',
    hungarian: 'pulykahús',
    german: 'Pute, Putenfleisch',
    dutch: 'kalkoen (voedsel)',
    afrikaans: 'kalkoen (voedsel)',
    russian: 'индюшатина',
    latvian: 'tītara gaļa',
    polish: 'indyk (żywność)',
    french: 'dinde (viande)',
    spanish: 'pavo (comida)',
  },
  {
    av: 17956,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(time + activity: person's time to do something)",
    english: 'turn, play',
    swedish: 'tur, turordning',
    norwegian: 'tur (din tur, min tur)',
    finnish: 'vuoro',
    hungarian: 'sorrakerülés, fordulat, váltás, valaki sora',
    german: 'an der Reihe sein, dran sein',
    dutch: 'beurt',
    afrikaans: 'beurt',
    russian: 'очерёдность (время действия)',
    latvian: 'rinda, kārta, spēles laiks',
    polish: 'runda (w grze)',
    french: 'tour',
    spanish: 'turno',
  },
  {
    av: 17957,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(turn, turning + action indicator) See turn.turning 25627',
    english: 'turn-(to)',
    swedish: 'svänga, vända',
    norwegian: 'snu, vende',
    finnish: 'kääntyä, kääntää',
    hungarian: 'fordulni, fordítani',
    german: 'umdrehen',
    dutch: 'omdraaien',
    afrikaans: 'omdraai (om te)',
    russian: 'повернуть',
    latvian: 'griezt, pagriezt',
    polish: 'obracać',
    french: 'tourner, pivoter',
    spanish: 'girar, volver',
  },
  {
    av: 17960,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(star + action indicator)',
    english: 'twinkle, shine, sparkle-(to)',
    swedish: 'lysa, stråla, blinka',
    norwegian: 'blinke, tindre, stråle',
    finnish: 'loistaa, välkkyä, tuikkia',
    hungarian: 'csillogni, villogni, ragyogni',
    german: 'flimmern, funkeln, glitzern',
    dutch: 'flonkeren',
    afrikaans: 'blink, skitter, vonkel (om te)',
    russian: 'мерцать',
    latvian: 'starot, mirdzēt',
    polish: 'migotać, lśnić, błyszczeć',
    french: 'briller, scintiller',
    spanish: 'centellear, brillar, destellar',
  },
  {
    av: 17962,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to write)',
    english: 'printer, typewriter',
    swedish: 'skrivare, skrivmaskin',
    norwegian: 'skrivemaskin, skriver',
    finnish: 'kirjoituskone, tulostin',
    hungarian: 'írógép, nyomtató, printer',
    german: 'Drucker',
    dutch: 'typemachine',
    afrikaans: 'tikmasjien, drukker',
    russian: 'принтер, пишущая машинка',
    latvian: 'rakstāmmašīna',
    polish: 'drukarka',
    french: 'imprimante, machine à écrire',
    spanish: 'impresora, máquina de escribir',
  },
  {
    av: 17963,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation:
      '(to speak + bad + description indicator: expressing a bad or negative feeling about something.The symbol does not have a specific word equivalent: it can represent ugh!, yuk! or similar negative expressions.)',
    english: 'ugh, yuk-(exclamatory)',
    swedish: 'urdålig, botten (etc)',
    norwegian: 'æsj, uff (o.l.) (utsagn)',
    finnish: 'yäk! (negatiivinen tunne)',
    hungarian: 'Fúj! Pfujj! Genyó! Görény! Szemétláda! Szar!',
    german: 'pfui, wiederlich, igitt',
    dutch: 'bah',
    afrikaans: 'ugh, jig (uitroepend)',
    russian: 'тьфу!',
    latvian: 'ak vai!',
    polish: 'phi!',
    french: 'berk (exclamation)',
    spanish: 'malísimo (exclamativo)',
  },
  {
    av: 17964,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(eye + sad + description indicator: displeasing to the eye)',
    english: 'ugly, unattractive',
    swedish: 'ful',
    norwegian: 'stygg, lite tiltrekkende',
    finnish: 'ruma',
    hungarian: 'csúnya, taszító, csúf, ronda, nem vonzó',
    german: 'hässlich',
    dutch: 'lelijk',
    afrikaans: 'lelik, onaantreklik',
    russian: 'некрасивый',
    latvian: 'neglīts, nepievilcīgs',
    polish: 'brzydki, nieatrakcyjny',
    french: 'laid, moche',
    spanish: 'feo',
  },
  {
    av: 17965,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tube + fetus)',
    english: 'umbilical cord',
    swedish: 'navelsträng',
    norwegian: 'navlestreng',
    finnish: 'napanuora',
    hungarian: 'köldökzsinór',
    german: 'Nabelschnur',
    dutch: 'navelstreng',
    afrikaans: 'naelstring',
    russian: 'пуповина',
    latvian: 'nabassaite',
    polish: 'pępowina',
    french: 'cordon ombilical',
    spanish: 'cordón umbilical',
  },
  {
    av: 17968,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(discomfort + description indicator) See discomfort 13687',
    english: 'uncomfortable',
    swedish: 'obehaglig, obekväm',
    norwegian: 'ubekvem, ubehagelig',
    finnish: 'epämukava, epämiellyttävä',
    hungarian: 'kényelmetlen, kellemetlen',
    german: 'unbehaglich, unwohl, ungemütlich',
    dutch: 'ongemakkelijk',
    afrikaans: 'ongemaklik',
    russian: 'неудобный',
    latvian: 'neērts',
    polish: 'niewygodny',
    french: 'inconfortable',
    spanish: 'incómodo',
  },
  {
    av: 17970,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shelter + under)',
    english: 'bomb shelter',
    swedish: 'skyddsrum under jord',
    norwegian: 'tilfluktsrom under jorden',
    finnish: 'väestösuoja',
    hungarian: 'óvóhely',
    german: 'Schutzkeller',
    dutch: 'schuilkelder',
    afrikaans: 'bom skuiling',
    russian: 'подземное укрытие',
    latvian: 'bumbu patversme',
    polish: 'schron',
    french: 'abri souterrain',
    spanish: 'refugio subterráneo',
  },
  {
    av: 17971,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pants + under)',
    english: 'underpants, briefs, panties',
    swedish: 'kalsonger, trosor',
    norwegian: 'truse, underbukser',
    finnish: 'alushousut, kalsarit',
    hungarian: 'alsónemű, alsónadrág, bugyi',
    german: 'Unterhose',
    dutch: 'maillot (Nl), onderbroek (lang)',
    afrikaans: 'onderklere, onderbroeke, panties',
    russian: 'кальсоны, трусы',
    latvian: 'apakšbikses',
    polish: 'kalesony, majtki, figi',
    french: 'caleçon, slip (sous-vêtement)',
    spanish: 'calzoncillos, bragas',
  },
  {
    av: 17972,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shirt + under)',
    english: 'undershirt',
    swedish: 'linne, undertröja',
    norwegian: 'undertrøye',
    finnish: 'aluspaita',
    hungarian: 'alsóing, kising, trikó, atléta',
    german: 'Unterhemd',
    dutch: 'onderhemd (Vl), hemd (Nl)',
    afrikaans: 'onderhemp, vest',
    russian: 'майка',
    latvian: 'apakškrekls',
    polish: 'podkoszulek',
    french: 'chemisette, maillot de corps',
    spanish: 'camiseta interior',
  },
  {
    av: 17973,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(understanding, comprehension + action indicator: to enter into one's store of knowledge) See understanding, comprehension 25629",
    english: 'understand, see-(to)',
    swedish: 'förstå',
    norwegian: 'forstå',
    finnish: 'ymmärtää',
    hungarian: 'érteni, megérteni, felfogni',
    german: 'verstehen',
    dutch: 'begrijpen',
    afrikaans: 'verstaan, begryp, sien (om te)',
    russian: 'понимать',
    latvian: 'saprast, uztvert',
    polish: 'zrozumieć, zobaczyć, pojąć',
    french: 'comprendre',
    spanish: 'entender',
  },
  {
    av: 17974,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + under: clothing worn under other clothing)',
    english: 'underwear, underclothes',
    swedish: 'underkläder',
    norwegian: 'undertøy',
    finnish: 'alusvaatteet',
    hungarian: 'alsónemű',
    german: 'Unterwäsche',
    dutch: 'ondergoed',
    afrikaans: 'onderklere',
    russian: 'нижнее бельё',
    latvian: 'apakšveļa',
    polish: 'bielizna',
    french: 'sous-vêtement',
    spanish: 'ropa interior',
  },
  {
    av: 17975,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + work)',
    english: 'unemployment',
    swedish: 'arbetslöshet',
    norwegian: 'arbeidsløshet',
    finnish: 'työttömyys',
    hungarian: 'munkanélküliség',
    german: 'Arbeitslosigkeit',
    dutch: 'werkloosheid',
    afrikaans: 'werkloosheid',
    russian: 'безработица',
    latvian: 'bezdarbs',
    polish: 'bezrobocie',
    french: 'chômage',
    spanish: 'desempleo',
  },
  {
    av: 17977,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(explosive + maybe)',
    english: 'unidentified object (suspected explosive)',
    swedish: 'oidentifierat föremål (misstänkt bomb)',
    norwegian: 'uidentifisert objekt',
    finnish: 'tunnistamaton esine, tunnistamaton kohde',
    hungarian: 'ismeretlen, robbanásgyanús tárgy',
    german: 'unbekanntes/unidentifiziertes Objekt (befürchtete Bombe)',
    dutch: 'onbekend voorwerp (explosief)',
    afrikaans: 'ongeïdentifiseerde voorwerp (vermoedelik plofbaar)',
    russian: 'неопознаный обьект',
    latvian: 'bīstams objekts, aizdomas par sprāgstvielām)',
    polish: 'niezidentyfikowany obiekt (ryzyko wybuchu)',
    french: 'objet suspect (explosif)',
    spanish: 'objeto no identificado (sospecha de explosivo)',
  },
  {
    av: 17978,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(1 + thing indicator: a single item) - (character with thing indicator)',
    english: 'unit, example, sample, for example, e.g.',
    swedish: 'exemplar',
    norwegian: 'eksempel, utvalg, eksemplar',
    finnish: 'esimerkki, mallikappale',
    hungarian: 'egység, egységnyi, minta, mintapéldány',
    german: 'Beispiel, Probe',
    dutch: 'voorbeeld',
    afrikaans: 'eenheid, voorbeeld, monster',
    russian: 'экземпляр',
    latvian: 'vienība, paraugs, eksemplārs',
    polish: 'jednostka, przykład, próbka',
    french: 'exemplaire unique',
    spanish: 'unidad, ejemplo, muestra',
  },
  {
    av: 17979,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + Union Jack pattern)',
    english: 'United Kingdom',
    swedish: 'Storbritannien',
    norwegian: 'Storbritania',
    finnish: 'Iso-Britannia',
    hungarian: 'Egyesült Királyság',
    german: 'Großbritannien, England',
    dutch: 'Groot-Brittannië',
    afrikaans: 'Verenigde Koninkryk',
    russian: 'Великобритания',
    latvian: 'Apvienotā Karaliste',
    polish: 'Wielka Brytania',
    french: 'Royaume-Uni, United Kingdom',
    spanish: 'Reino Unido',
  },
  {
    av: 17980,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + to exchange + knowledge)',
    english: 'university',
    swedish: 'högskola, universitet',
    norwegian: 'universitet',
    finnish: 'yliopisto',
    hungarian: '',
    german: 'Universität',
    dutch: 'universiteit',
    afrikaans: 'universiteit',
    russian: 'университет, институт',
    latvian: 'universitāte, institūts',
    polish: 'uniwersytet',
    french: 'université',
    spanish: 'universidad',
  },
  {
    av: 17981,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(but + or)',
    english: 'unless',
    swedish: 'utom',
    norwegian: 'uten at',
    finnish: 'jollei, ellei',
    hungarian: 'ha nem, hacsak, hacsak nem; kivéve, ha…',
    german: 'wenn nicht, außer wenn, es sei denn',
    dutch: 'tenzij',
    afrikaans: 'tensy',
    russian: 'кроме',
    latvian: 'ja ne, izņemot',
    polish: 'chyba że',
    french: 'sauf, à moins',
    spanish: 'a menos que',
  },
  {
    av: 17985,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(upset, disturbance, agitation + description indicator: having unsettled feelings)',
    english: 'upset',
    swedish: 'upprörd',
    norwegian: 'opprørt',
    finnish: 'levoton, järkyttynyt, kiihtynyt',
    hungarian: 'zaklatott, feldúlt',
    german: 'verärgert, aufgebracht',
    dutch: 'van streek, overstuur',
    afrikaans: 'omgekrap',
    russian: 'расстроенный',
    latvian: 'apbēdināts, sarūgtināts',
    polish: 'zdenerwowany',
    french: 'troublé, dérangé, perturbé',
    spanish: 'alterado',
  },
  {
    av: 17988,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tube + urine)',
    english: 'urethra',
    swedish: 'urinrör',
    norwegian: 'urinrør',
    finnish: 'virtsaputki',
    hungarian: 'húgycső',
    german: 'Harnröhre',
    dutch: 'urinebuis',
    afrikaans: 'uretra',
    russian: 'уретра',
    latvian: 'urīnizvadkanāls',
    polish: 'cewka moczowa',
    french: 'urètre',
    spanish: 'uretra',
  },
  {
    av: 17989,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(urine + action indicator)',
    english: 'urinate, make water, pass water, micturate, pee, piddle, piss, wee-(to)',
    swedish: 'kissa, kasta vatten',
    norwegian: 'urinere, tisse',
    finnish: 'pissata, virtsata',
    hungarian: 'vizelni, pisilni',
    german: 'urinieren',
    dutch: 'plassen, urineren',
    afrikaans: 'urineer, piepie, wee-wee, pis (om te)',
    russian: 'мочиться',
    latvian: 'urinēt, čurāt',
    polish: 'oddawać mocz, siusiać, sikać',
    french: 'uriner, faire pipi',
    spanish: 'orinar, hacer pis',
  },
  {
    av: 17990,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(waste + genitals)',
    english: 'urine, piss, pee, piddle, weewee, water',
    swedish: 'urin, kiss',
    norwegian: 'urin, tiss',
    finnish: 'pissa, virtsa',
    hungarian: 'vizelet, pisi',
    german: 'Urin, Harn',
    dutch: 'urine, plas (urine)',
    afrikaans: 'urineer, piepie, wee-wee, pis, water afslaan',
    russian: 'моча',
    latvian: 'urīns, čuras',
    polish: 'mocz, siusiu, siki',
    french: 'urine, pipi',
    spanish: 'orina, pis',
  },
  {
    av: 17991,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(usage, use + action indicator: to manipulate a tool rationally) See usage, use 24847',
    english: 'use-(to)',
    swedish: 'använda',
    norwegian: 'bruke, anvende',
    finnish: 'käyttää',
    hungarian: 'használni, felhasználni, alkalmazni',
    german: 'gebrauchen, benutzen, benutzen',
    dutch: 'gebruiken',
    afrikaans: 'gebruik (om te)',
    russian: 'использовать',
    latvian: 'lietot, izmantot',
    polish: 'używać',
    french: 'utiliser',
    spanish: 'usar',
  },
  {
    av: 17992,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(most + time + description indicator: on most occasions)',
    english: 'usually, usual',
    swedish: 'oftast, vanligen',
    norwegian: 'valigvis, oftest',
    finnish: 'tavallisesti, useimmiten',
    hungarian: 'szokásos, szokásosan, általában, rendszerint',
    german: 'normalerweise, meistens',
    dutch: 'gewoonlijk',
    afrikaans: 'gewoonlik, gewone',
    russian: 'обычно',
    latvian: 'parasti, parasts',
    polish: 'zwykle, zazwyczaj',
    french: 'habituellement',
    spanish: 'generalmente',
  },
  {
    av: 17993,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + food)',
    english: 'utensil',
    swedish: 'köksredskap ',
    norwegian: 'kjøkkenredskap',
    finnish: 'ruokailuväline',
    hungarian: 'konyhaedény, konyhai eszköz',
    german: 'Kochgerät, Kochutensil',
    dutch: 'eetgerei',
    afrikaans: 'eetgerei',
    russian: 'кухонная посуда, утварь',
    latvian: 'virtuves piederumi, trauki',
    polish: 'naczynia, przybory (kuchenne)',
    french: 'ustensile de cuisine',
    spanish: 'utensilio',
  },
  {
    av: 17995,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(unemployment + happy: time of not working, which is happy) See also: holiday, festival 14884',
    english: 'vacation, holiday',
    swedish: 'ledighet, lov, semester',
    norwegian: 'ferie',
    finnish: 'loma',
    hungarian: 'szünidő, vakáció',
    german: 'Ferien, Urlaub',
    dutch: 'vakantie, vrij (vakantie)',
    afrikaans: 'vakansie',
    russian: 'отпуск',
    latvian: 'atvaļinājums, brīvdienas',
    polish: 'urlop, wakacje',
    french: 'vacances',
    spanish: 'licencia, permiso, vacaciones',
  },
  {
    av: 17997,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + love: message of love)',
    english: 'Valentine (card)',
    swedish: 'kärleksbrev',
    norwegian: 'Valentinkort',
    finnish: 'ystävänpäiväkortti',
    hungarian: 'Valentin-napi üdvözlőlap',
    german: 'Valentinstagkarte',
    dutch: 'valentijnskaart',
    afrikaans: 'Vaaltyn kaartjie, Valentyns kaartjie',
    russian: 'валентинка, любовное письмо',
    latvian: 'mīlas vēstule',
    polish: 'Kartka walentynkowa',
    french: 'carte de la Saint-Valentin',
    spanish: 'San Valentín (tarjeta)',
  },
  {
    av: 17998,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + love: day to celebrate love)',
    english: "Valentine's Day",
    swedish: 'alla hjärtans dag',
    norwegian: 'Valentinsdag',
    finnish: 'ystävänpäivä, Valentinen päivä',
    hungarian: 'Valentin-nap',
    german: 'Valentinstag',
    dutch: 'Valentijnsdag',
    afrikaans: 'Vaaltyns dag, Valentynsdag',
    russian: 'День Святого Валентина',
    latvian: 'Svēta Valentīna diena',
    polish: 'Walentynki',
    french: 'jour de la Saint-Valentin',
    spanish: 'Día de San Valentín',
  },
  {
    av: 18000,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bus + little)',
    english: 'van, minibus',
    swedish: 'minibuss, skåpbil',
    norwegian: 'varevogn, minibuss',
    finnish: 'pakettiauto, pikkubussi',
    hungarian: 'mikrobusz',
    german: 'Lieferwagen, Kleintransporter',
    dutch: 'busje, minibus',
    afrikaans: 'minibus, vervoerwa',
    russian: 'фургон, микроавтобус',
    latvian: 'mikroautobuss',
    polish: 'van, minibus',
    french: 'camionnette, fourgon',
    spanish: 'furgoneta',
  },
  {
    av: 18001,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tube + sperm)',
    english: 'vas deferens',
    swedish: 'sädesledare',
    norwegian: 'sædleder',
    finnish: 'siemenjohdin',
    hungarian: 'ondóvezeték',
    german: 'Samenleiter',
    dutch: 'zaadleider',
    afrikaans: 'vas deferens',
    russian: 'семенной канал',
    latvian: 'sēklvads',
    polish: 'nasieniowód',
    french: 'canal déférent',
    spanish: 'conducto deferente',
  },
  {
    av: 18002,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(operation + vas deferens)',
    english: 'vasectomy',
    swedish: 'sterilisering (man)',
    norwegian: 'sterilisering (mann)',
    finnish: 'sterilisaatioleikkaus',
    hungarian: 'ondóvezeték elkötése, vazektómia',
    german: 'Samenleiterunterbrechung, Vasektomie',
    dutch: 'sterilisatie (man), vasectomie',
    afrikaans: 'vasektomie',
    russian: 'стерилизация (мужская)',
    latvian: 'vasektomija',
    polish: 'wazektomia',
    french: 'vasectomie',
    spanish: 'vasectomía',
  },
  {
    av: 18003,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + calf: food that comes from a calf) The symbol also can be explained as: combination of meat and calf.)',
    english: 'veal',
    swedish: 'kalvkött',
    norwegian: 'kalvekjøtt',
    finnish: 'vasikanliha',
    hungarian: 'borjúhús',
    german: 'Kalbfleisch',
    dutch: 'kalfsvlees',
    afrikaans: 'kalfsvleis',
    russian: 'телятина',
    latvian: 'teļa gaļa',
    polish: 'cielęcina',
    french: 'veau (viande)',
    spanish: 'ternera',
  },
  {
    av: 18011,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(machine + to reproduce + eye + ear: machine to reproduce materials to see and to hear)',
    english: 'video recorder',
    swedish: 'video',
    norwegian: 'videospiller',
    finnish: 'video, kuvanauhuri',
    hungarian: 'videófelvevő',
    german: 'Videorecorder, Videogerät',
    dutch: 'videorecorder',
    afrikaans: 'video opnemer',
    russian: 'видео',
    latvian: 'videokamera',
    polish: 'wideo (nagrywarka wideo)',
    french: 'magnétoscope',
    spanish: 'videograbador',
  },
  {
    av: 18012,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + building)',
    english: 'village',
    swedish: 'by, samhälle',
    norwegian: 'tettsted',
    finnish: 'kylä',
    hungarian: 'falu, község',
    german: 'Dorf, Gemeinde',
    dutch: 'dorp',
    afrikaans: 'dorp',
    russian: 'деревня, посёлок',
    latvian: 'ciems, ciemats',
    polish: 'wieś, osiedle',
    french: 'village',
    spanish: 'pueblo',
  },
  {
    av: 18013,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(combination of flavouring and sharp + thing indicator)',
    english: 'vinegar',
    swedish: 'vinäger',
    norwegian: 'eddik',
    finnish: 'etikka',
    hungarian: 'ecet',
    german: 'Essig',
    dutch: 'azijn',
    afrikaans: 'asyn',
    russian: 'уксус',
    latvian: 'etiķis',
    polish: 'ocet',
    french: 'vinaigre',
    spanish: 'vinagre',
  },
  {
    av: 18014,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + 7) (CKB) SYMBOL SYNONYM',
    english: 'purple, violet (ckb)',
    swedish: 'violett (CKB)',
    norwegian: 'fiolett (CKB)',
    finnish: 'purppuranpunainen, lila',
    hungarian: 'lila, violaszín (régi CKB-jelkép)',
    german: 'violet',
    dutch: 'violet (CKB), purper (CKB)',
    afrikaans: 'pers, violet (ckb)',
    russian: 'фиолетовый',
    latvian: 'violets',
    polish: 'purpura, fiolet (CKB)',
    french: 'violet, pourpre (ckb)',
    spanish: 'púrpura, violeta (CKB)',
  },
  {
    av: 18015,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + sexual intercourse + past)',
    english: 'virginity',
    swedish: 'oskuld',
    norwegian: 'uskyld',
    finnish: 'neitsyys',
    hungarian: 'szűzesség',
    german: 'Jungfräulichkeit',
    dutch: 'maagdelijkheid',
    afrikaans: 'maagdelikheid',
    russian: 'девственность',
    latvian: 'jaunavība, nevainība',
    polish: 'dziewictwo',
    french: 'virginité',
    spanish: 'virginidad',
  },
  {
    av: 18016,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(god + protection: Hindu god) (India)',
    english: 'Vishnu',
    swedish: 'Vishnu (Indien)',
    norwegian: 'Vishnu (India)',
    finnish: 'Vishnu',
    hungarian: 'Visnu (India)',
    german: 'Vishnu (Hindu-Gott)',
    dutch: 'Vishnu (Indisch)',
    afrikaans: 'Vishnu',
    russian: 'Вишну (Индия)',
    latvian: 'Višnu (India)',
    polish: 'Wisznu (bóg hinduski)',
    french: 'Vishnou (hindouisme)',
    spanish: 'Vishnu ',
  },
  {
    av: 18017,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(visit + action indicator) See visit 24859',
    english: 'visit-(to)',
    swedish: 'besöka, hälsa på',
    norwegian: 'besøke',
    finnish: 'vierailla, käydä vierailulla',
    hungarian: 'látogatni, meg/ellátogatni, látogatóba menni',
    german: 'besuchen',
    dutch: 'bezoeken',
    afrikaans: 'besoek, kuier (om te)',
    russian: 'посещать, навещать',
    latvian: 'apciemot',
    polish: 'odwiedzać',
    french: 'visiter, rendre visite',
    spanish: 'visitar',
  },
  {
    av: 18018,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + visit: person who comes to visit)',
    english: 'visitor, guest',
    swedish: 'besökare, gäst',
    norwegian: 'gjest',
    finnish: 'vieras, vierailija',
    hungarian: 'vendég, látogató',
    german: 'Besucher, Gast, Besucherin',
    dutch: 'bezoeker',
    afrikaans: 'besoeker, kuiergas',
    russian: 'гость, посетитель',
    latvian: 'viesis, ciemiņš, apmeklētājs',
    polish: 'gość',
    french: 'visiteur',
    spanish: 'visitante, huésped, invitado',
  },
  {
    av: 18020,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mountain + fire)',
    english: 'volcano',
    swedish: 'vulkan',
    norwegian: 'vulkan',
    finnish: 'tulivuori',
    hungarian: 'vulkán',
    german: 'Vulkan',
    dutch: 'vulkaan',
    afrikaans: 'vulkaan',
    russian: 'вулкан',
    latvian: 'vulkāns',
    polish: 'wulkan',
    french: 'volcan',
    spanish: 'volcán',
  },
  {
    av: 18021,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(helper + free: person who gives assistance freely)',
    english: 'volunteer',
    swedish: 'frivillig medhjälpare',
    norwegian: 'frivillig hjelper',
    finnish: 'vapaaehtoinen auttaja, vapaaehtoinen avustaja',
    hungarian: 'önkéntes (fn.)',
    german: 'freiwilliger Helfer',
    dutch: 'vrijwilliger',
    afrikaans: 'vrywilliger',
    russian: 'доброволец, волонтёр',
    latvian: 'brīvprātīgais (-ā)',
    polish: 'wolontariusz',
    french: 'bénévole',
    spanish: 'voluntario',
  },
  {
    av: 18022,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(vomiting, vomit, puking + action indicator: to expel food)',
    english: 'vomit, throw up, puke-(to)',
    swedish: 'kräkas',
    norwegian: 'kaste opp',
    finnish: 'oksentaa, ylenantaa',
    hungarian: 'hányni, kihányni, visszaöklendezni',
    german: 'erbrechen, brechen, übergeben, sich übergeben',
    dutch: 'overgeven, braken',
    afrikaans: 'vormeer, opgooi, braak (om te)',
    russian: 'блевать, рыгать',
    latvian: 'vemt, izvemties',
    polish: 'wymiotować, mieć torsje, rzygać ',
    french: 'vomir',
    spanish: 'vomitar',
  },
  {
    av: 18023,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to watch + sex)',
    english: 'voyeurism',
    swedish: 'smygtittande',
    norwegian: 'kikking (seksuell)',
    finnish: 'tirkistely, salakatselu',
    hungarian: 'kukkolás',
    german: 'Voyeurismus',
    dutch: 'voyeurisme',
    afrikaans: 'voyeurisme',
    russian: 'вуайеризм',
    latvian: 'lūriķis, seksuāla perversija',
    polish: 'podglądactwo',
    french: 'voyeurisme',
    spanish: 'voyerismo',
  },
  {
    av: 18024,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + death: bird that feeds upon decaying flesh)',
    english: 'vulture',
    swedish: 'gam',
    norwegian: 'gribb',
    finnish: 'korppikotka',
    hungarian: 'keselyű',
    german: 'Geier',
    dutch: 'gier',
    afrikaans: 'aasvoël',
    russian: 'гриф',
    latvian: 'maitu lija',
    polish: 'sęp',
    french: 'vautour',
    spanish: 'buitre',
  },
  {
    av: 18025,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + vagina)',
    english: 'vulva',
    swedish: 'blygd',
    norwegian: 'vulva, ytre kjønnsorganer kvinne',
    finnish: 'vulva, häpy',
    hungarian: 'szeméremajak, szeméremtest, vulva',
    german: 'Vulva, Schamlippe',
    dutch: 'schaamlip, vulva',
    afrikaans: 'vulva',
    russian: 'вульва',
    latvian: 'vulva',
    polish: 'srom',
    french: 'vulve',
    spanish: 'vulva',
  },
  {
    av: 18026,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pool + child: pool for a child to wade in)',
    english: 'wading pool, paddling pool',
    swedish: 'barnbassäng, plaskdamm',
    norwegian: 'barnebasseng, plaskedam',
    finnish: 'kahluuallas',
    hungarian: 'gyermekmedence',
    german: 'Planschbecken',
    dutch: 'badje, kinderbadje',
    afrikaans: 'peuterpoel',
    russian: 'детский бассейн',
    latvian: 'bērnu baseins',
    polish: 'brodzik, brodzik dla dzieci',
    french: 'petit bassin, pataugeoire',
    spanish: 'piscina para niños',
  },
  {
    av: 18027,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + for (in exchange for) + work)',
    english: 'wage(s), pay, salary',
    swedish: 'lön, inkomst',
    norwegian: 'lønn, inntekt',
    finnish: 'palkka',
    hungarian: 'fizetés, fizetség, kereset, illetmény',
    german: 'Lohn, Gehalt, Einkommen',
    dutch: 'loon, wedde (Vl), salaris',
    afrikaans: 'salaris, loon',
    russian: 'зарплата, доход',
    latvian: 'darba alga',
    polish: 'wynagrodzenie, zapłata, pensja',
    french: 'gage, salaire',
    spanish: 'salario, sueldo',
  },
  {
    av: 18030,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(wait, waiting + action indicator: to halt for a limited time)',
    english: 'wait-(to)',
    swedish: 'vänta',
    norwegian: 'vente',
    finnish: 'odottaa',
    hungarian: 'várni, várakozni',
    german: 'warten',
    dutch: 'wachten',
    afrikaans: 'wag (om te)',
    russian: 'ждать',
    latvian: 'gaidīt',
    polish: 'czekać',
    french: 'attendre',
    spanish: 'esperar',
  },
  {
    av: 18031,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(legs and feet + action indicator)',
    english: 'walk, go-(to)',
    swedish: 'gå',
    norwegian: 'gå',
    finnish: 'kävellä, kulkea',
    hungarian: 'menni, járni',
    german: 'gehen, laufen',
    dutch: 'gaan, stappen (Vl), wandelen, lopen (Nl)',
    afrikaans: 'stap, loop, wandel, gaan (om te)',
    russian: 'идти',
    latvian: 'iet, doties',
    polish: 'chodzić, iść',
    french: 'aller à pied, marcher',
    spanish: 'caminar, ir',
  },
  {
    av: 18032,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(aid + medical + to walk + thing indicator: medical support that helps a person to walk) SYMBOL SYNONYM (See also 24298)',
    english: 'walker, walking aid (2)',
    swedish: 'rollator, gåstol (etc)',
    norwegian: 'gåstol, rullator',
    finnish: 'kävelyteline',
    hungarian: 'járógép',
    german: 'Rollator, Gehhilfe',
    dutch: 'looprek, rollator',
    afrikaans: 'walker',
    russian: 'ходунки',
    latvian: 'staigāšanas palīgierīce uz riteņiem',
    polish: 'chodzik (urządzenie rehabilitacyjne)',
    french: 'déambulateur, trotteur',
    spanish: 'caminante',
  },
  {
    av: 18035,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(want, desire + action indicator: to have an emotional desire, a strong feeling shown by fire) See also: wish, desire 24833',
    english: 'want, desire-(to)',
    swedish: 'vilja (verb)',
    norwegian: 'ønske (å), ville (å)',
    finnish: 'tahtoa, haluta',
    hungarian: 'akarni, vágyni, kívánni (erősen)',
    german: 'wollen, begehren, brauchen, wünschen, benötigen',
    dutch: 'willen',
    afrikaans: 'begeer, wil (om te)',
    russian: 'хотеть, желать',
    latvian: 'vēlēties, alkt',
    polish: 'potrzebować, pragnąć, chcieć',
    french: 'vouloir, désirer',
    spanish: 'querer, desear',
  },
  {
    av: 18037,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(hot + little + description indicator)',
    english: 'warm',
    swedish: 'ljummen',
    norwegian: 'varm, lunken',
    finnish: 'lämmin, haalea',
    hungarian: 'meleg',
    german: 'warm',
    dutch: 'warm',
    afrikaans: 'warm',
    russian: 'тёплый',
    latvian: 'silts',
    polish: 'ciepły',
    french: 'chaud',
    spanish: 'caliente',
  },
  {
    av: 18038,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(bath, washing + action indicator)',
    english: 'wash, bathe, bath-(to)',
    swedish: 'bada, tvätta',
    norwegian: 'vaske, bade',
    finnish: 'pestä, kylpeä',
    hungarian: 'mosakodni, mosdani, fürdeni, mosni',
    german: 'waschen (Wäsche)',
    dutch: 'wassen, bad nemen',
    afrikaans: 'was, bad (om te)',
    russian: 'мыть(ся), купаться',
    latvian: 'mazgāt, peldēt',
    polish: 'mycie, kąpiel',
    french: 'laver',
    spanish: 'lavar, bañar',
  },
  {
    av: 18039,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(bath, washing + description before the fact indicator)',
    english: 'washable',
    swedish: 'tvättbar',
    norwegian: 'vaskbar',
    finnish: 'pesunkestävä',
    hungarian: 'mosható',
    german: 'waschbar',
    dutch: 'wasbaar',
    afrikaans: 'wasbaar',
    russian: 'моющийся, стирающийся',
    latvian: 'mazgājams',
    polish: 'zmywalny',
    french: 'lavable',
    spanish: 'lavable',
  },
  {
    av: 18040,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + to wash)',
    english: 'washcloth, washrag, flannel',
    swedish: 'tvättlapp',
    norwegian: 'oppvaskklut, vaskeklut',
    finnish: 'pesulappu',
    hungarian: 'mosdókesztyű, mosdóruha',
    german: 'Waschlappen',
    dutch: 'washandje',
    afrikaans: 'waslap',
    russian: 'мочалка',
    latvian: 'mazgājama lupata',
    polish: 'myjka, rękawica do kąpieli, gąbka',
    french: 'gant de toilette',
    spanish: 'toallita de aseo',
  },
  {
    av: 18041,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to wash)',
    english: 'washer',
    swedish: 'maskin som tvättar',
    norwegian: 'vaskemaskin',
    finnish: 'pesukone',
    hungarian: 'mosógép',
    german: 'Waschmaschine',
    dutch: 'wasmachine',
    afrikaans: 'wasmasjien',
    russian: 'моечная машина',
    latvian: 'mazgātājs',
    polish: 'zmywarka',
    french: 'machine à laver',
    spanish: 'lavadora',
  },
  {
    av: 18042,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to wash + clothing)',
    english: 'washing machine, washer',
    swedish: 'tvättmaskin',
    norwegian: 'vaskemaskin (klær)',
    finnish: 'pyykinpesukone',
    hungarian: 'mosógép, ruhamosógép',
    german: 'Waschmaschine',
    dutch: 'wasmachine',
    afrikaans: 'wasmasjien',
    russian: 'стиральная машина',
    latvian: 'mazgājamā mašīna',
    polish: 'pralka',
    french: 'machine à laver le linge, lave-linge',
    spanish: 'lavadora',
  },
  {
    av: 18044,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(clock + hand + thing indicator: clock worn on the wrist or carried in a pocket)',
    english: 'watch, wristwatch',
    swedish: 'armbandsur',
    norwegian: 'armbåndsur',
    finnish: 'rannekello',
    hungarian: 'karóra',
    german: 'Armbanduhr',
    dutch: 'horloge, polshorloge',
    afrikaans: 'arm horlosie, pols horlosie',
    russian: 'часы наручные',
    latvian: 'pulkstenis, rokaspulkstenis',
    polish: 'zegarek na rękę',
    french: 'montre',
    spanish: 'reloj, reloj de pulsera',
  },
  {
    av: 18045,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(wakefulness, alertness + intensity + action indicator: to be wide awake and attentive)',
    english: 'watch-(to)',
    swedish: 'vakta',
    norwegian: 'se, iaktta',
    finnish: 'tarkata, valvoa jotakin, pitää silmällä',
    hungarian: 'figyelni, őrizni, vigyázni',
    german: 'beobachten, ansehen, überwachen',
    dutch: 'uitkijken',
    afrikaans: 'uitkyk, dophou, kyk (om te)',
    russian: 'сторожить, охранять',
    latvian: 'sargāt, uzmanīt',
    polish: 'czuwać, pilnować, dozorować',
    french: 'observer',
    spanish: 'mirar, ver, vigilar',
  },
  {
    av: 18046,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(wakefulness, alertness + description indicator)',
    english: 'watchful, alert',
    swedish: 'vaksam',
    norwegian: 'påpasselig, årvåken',
    finnish: 'valpas, takkaavainen, varuillaan',
    hungarian: 'éber, körültekintő',
    german: 'wachsam',
    dutch: 'waakzaam',
    afrikaans: 'waaksaam',
    russian: 'бдительный, настороженный',
    latvian: 'piesardzīgs, uzmanīgs',
    polish: 'alarmowy, czuwający',
    french: 'attentif, vigilant',
    spanish: 'alerta, vigilante, atento',
  },
  {
    av: 18210,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(female + 1 + plural indicator: first person plural, (f.))',
    english: 'we, us, ourselves-(feminine)',
    swedish: 'vi, oss (fem.)',
    norwegian: 'vi, oss (hunkjønn)',
    finnish: 'me (fem.), meitä (fem.)',
    hungarian: 'mi (nőnem)',
    german: 'wir (weiblich), unser (weiblich), uns (weiblich)',
    dutch: 'wij (vrouwelijk), ons (vrouwelijk)',
    afrikaans: 'ons, onsself (vroulik)',
    russian: 'мы (жен.р. мн.ч.)',
    latvian: 'mēs, mūs',
    polish: 'my, nas-(r. żeński)',
    french: 'nous (fém.), nous-mêmes',
    spanish: 'nosotras, a nosotras (femenino)',
  },
  {
    av: 18211,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(male + 1 + plural indicator: first person plural, (m.))',
    english: 'we, us, ourselves-(masculine)',
    swedish: 'vi, oss (mask.)',
    norwegian: 'vi oss (hankjønn)',
    finnish: 'me (mask.), meitä (mask.)',
    hungarian: 'mi (hímnem)',
    german: 'wir (männlich), unser (männlich), uns (männlich)',
    dutch: 'wij (mannelijk), ons (mannelijk)',
    afrikaans: 'ons, onsself (manlik)',
    russian: 'мы (муж.р. мн.ч.)',
    latvian: 'mēs, mūs',
    polish: 'my, nas-(r. męski)',
    french: 'nous (1ere pers. masc. plur.), nous-mêmes',
    spanish: 'nosotros, a nosotros (masculino)',
  },
  {
    av: 18212,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + 1 + plural indicator: first person plural)',
    english: 'we, us, ourselves',
    swedish: 'vi, oss',
    norwegian: 'vi, oss',
    finnish: 'me',
    hungarian: 'mi, bennünket, magunk',
    german: 'wir, unser, uns',
    dutch: 'wij (eerste pers.mv), ons-(eerste pers.mv)',
    afrikaans: 'ons, onsself',
    russian: 'мы, нам',
    latvian: 'mēs, mums, mums pašiem, pašām',
    polish: 'my, nas (r. nieokreślony – osoby)',
    french: 'nous',
    spanish: 'nosotros, a nosotros',
  },
  {
    av: 18213,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(weakness (weak person) + description indicator: feeling experienced by a person whose knees are giving out)',
    english: 'weak',
    swedish: 'svag',
    norwegian: 'svak',
    finnish: 'heikko',
    hungarian: 'gyenge',
    german: 'schwach',
    dutch: 'zwak, slap',
    afrikaans: 'swak',
    russian: 'слабый',
    latvian: 'vājš, nevarīgs',
    polish: 'słaby',
    french: 'faible',
    spanish: 'débil',
  },
  {
    av: 18215,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to make + cloth + action indicator)',
    english: 'weave-(to)',
    swedish: 'väva',
    norwegian: 'veve',
    finnish: 'kutoa, kutoa kangasta',
    hungarian: 'szőni, fonni',
    german: 'weben',
    dutch: 'weven',
    afrikaans: 'weef (om te)',
    russian: 'ткать',
    latvian: 'aust, izaust',
    polish: 'splatać, pleść',
    french: 'tisser',
    spanish: 'tejer, entretejer',
  },
  {
    av: 18217,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(7 + day: period of seven days)',
    english: 'week',
    swedish: 'vecka',
    norwegian: 'uke',
    finnish: 'viikko',
    hungarian: 'a hét',
    german: 'Woche',
    dutch: 'week',
    afrikaans: 'week',
    russian: 'неделя',
    latvian: 'nedēļa',
    polish: 'tydzień',
    french: 'semaine',
    spanish: 'semana',
  },
  {
    av: 18218,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 6 + plus sign (low) + 7: a combination of Saturday and Sunday in modern western week day numbering) SYMBOL SYNONYM',
    english: 'weekend (6-7)',
    swedish: 'veckoslut (sverige)',
    norwegian: 'helg, weekend (6-7 Norge)',
    finnish: 'viikonloppu',
    hungarian: 'hétvége, szombat-vasárnap, víkend',
    german: 'Wochenende (Schweden)',
    dutch: 'weekend (6-7)',
    afrikaans: 'naweek (6-7)',
    russian: 'выходные дни (6-7)',
    latvian: 'nedēļas nogale',
    polish: 'weekend (6-7) (tydzień liczony od poniedziałku)',
    french: 'weekend (6-7)',
    spanish: 'fin de semana (6-7)',
  },
  {
    av: 18219,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 7 + plus sign (low) + 1: a combination of Saturday and Sunday in traditional English or US week day numbering, and (possibly) Friday and Saturday in Israel) SYMBOL SYNONYM',
    english: 'weekend (7-1)',
    swedish: 'veckoslut (int)',
    norwegian: 'helg, weekend (int.)',
    finnish: 'viikonloppu',
    hungarian: 'hétvége (héber)',
    german: 'Wochenende',
    dutch: 'weekend (7-1)',
    afrikaans: 'naweek (7-1)',
    russian: 'выходные дни (7-1)',
    latvian: 'brīvdienas',
    polish: 'weekend (7-1) (tydzień liczony od niedzieli)',
    french: 'weekend (7-1)',
    spanish: 'fin de semana (7-1)',
  },
  {
    av: 18220,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(weight + action indicator)',
    english: 'weigh-(to)',
    swedish: 'väga',
    norwegian: 'veie',
    finnish: 'punnita, painaa',
    hungarian: 'mérni (súlyt), megmérni, mázsálni',
    german: 'wiegen, messen',
    dutch: 'wegen',
    afrikaans: 'weeg (om te)',
    russian: 'взвешивать',
    latvian: 'svērt',
    polish: 'ważyć',
    french: 'peser',
    spanish: 'pesar',
  },
  {
    av: 18222,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(weight + thing indicator) - (character with thing indicator)',
    english: 'weight (a)',
    swedish: 'vikt, tyngd',
    norwegian: 'vekt (subst.)',
    finnish: 'paino, punnus',
    hungarian: 'súly, mérlegsúly',
    german: 'Gewicht (Waage)',
    dutch: 'gewicht (voorwerp)',
    afrikaans: 'gewig (voorwerp)',
    russian: 'весы',
    latvian: 'svaru bumba',
    polish: 'waga (przyrząd)',
    french: 'poids (objet)',
    spanish: 'peso (unidad de medida)',
  },
  {
    av: 18223,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(feeling + visitor [contraction]: feeling expressed to visitors)',
    english: 'welcome',
    swedish: 'välkommen',
    norwegian: 'velkommen',
    finnish: 'tervetuloa',
    hungarian: 'Isten hozott/hozta! Jó, hogy jött/él! Örvendek!',
    german: 'willkommen',
    dutch: 'welkom',
    afrikaans: 'welkom',
    russian: 'добро пожаловать!',
    latvian: 'laipni lūgti',
    polish: 'Witamy',
    french: 'bienvenue, accueil',
    spanish: 'bienvenido(a)',
  },
  {
    av: 18225,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(west + description indicator)',
    english: 'western',
    swedish: 'västlig',
    norwegian: 'vestlig',
    finnish: 'läntinen, länsi-',
    hungarian: 'nyugati',
    german: 'westlich',
    dutch: 'westelijk, westers',
    afrikaans: 'westelike, weste, westers',
    russian: 'западный',
    latvian: 'rietumu',
    polish: 'zachodnie, zachodni',
    french: "occidental, de l'ouest",
    spanish: 'occidental',
  },
  {
    av: 18226,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(water + description indicator)',
    english: 'wet, damp, moist, watery',
    swedish: 'våt, fuktig, vattnig',
    norwegian: 'våt, fuktig, vannholdig',
    finnish: 'märkä, kostea, märkä, vetinen',
    hungarian: 'nedves, nyirkos, vizes',
    german: 'nass, wässrig, feucht',
    dutch: 'nat, vochtig, waterig, vloeibaar',
    afrikaans: 'nat, waterig, vog, vogtig, vleibaar',
    russian: 'мокрый, влажный, водянистый',
    latvian: 'slapjš, mitrs',
    polish: 'mokre, mokry, wilgotne, zmoczone, wodnisty',
    french: 'mouillé, humide, aqueux',
    spanish: 'mojado, húmedo, acuoso',
  },
  {
    av: 18227,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water mammal (with tail) + big: bigger whale, noted for its size)',
    english: 'whale',
    swedish: 'val (djur)',
    norwegian: 'hval',
    finnish: 'valas',
    hungarian: 'bálna, cet',
    german: 'Wal',
    dutch: 'walvis',
    afrikaans: 'walvis',
    russian: 'кит',
    latvian: 'valis',
    polish: 'wieloryb',
    french: 'baleine',
    spanish: 'ballena',
  },
  {
    av: 18228,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(who, that, which-(relative) + thing: relative pronoun)',
    english: 'what',
    swedish: 'vad, vad som',
    norwegian: 'hva, hva som',
    finnish: 'mitä, mikä',
    hungarian: 'ami',
    german: 'was',
    dutch: 'wat (betrekkelijk vnw.)',
    afrikaans: 'wat (betreklike vnw.)',
    russian: 'что',
    latvian: 'kas, ko',
    polish: 'co',
    french: 'que',
    spanish: 'qué',
  },
  {
    av: 18230,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(what, question mark + type)',
    english: 'what kind-(question)',
    swedish: 'vilken sort (fråga)',
    norwegian: 'hva slags',
    finnish: 'millainen',
    hungarian: 'milyen? miféle, fajta?',
    german: 'welche Art?, welche Sorte?',
    dutch: 'welke?',
    afrikaans: 'watter soort (vraag woord)',
    russian: 'какого рода (сорта)?',
    latvian: 'kāds? kāda veida?',
    polish: 'jakiego rodzaju-(pytanie)',
    french: 'quelle sorte de (question)',
    spanish: 'qué tipo (pregunta)',
  },
  {
    av: 18231,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(what, question mark + thing: interrogative)',
    english: 'what (thing)-(question)',
    swedish: 'vad (fråga)',
    norwegian: 'hvilken ting',
    finnish: 'mikä?',
    hungarian: 'Mi ez? Mi az? (tárgy)',
    german: 'Was?, Was für ein?',
    dutch: 'welk ding?',
    afrikaans: 'wat (ding) (vraag woord)',
    russian: 'что?',
    latvian: 'kas, kurš?',
    polish: 'co to (pytanie)',
    french: 'quoi, quel (question)',
    spanish: 'qué cosa (pregunta)',
  },
  {
    av: 18234,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation:
      '(who, that, which-(relative) + time: conjunction used to introduce a relative clause)',
    english: 'when',
    swedish: 'när',
    norwegian: 'når',
    finnish: 'kun',
    hungarian: 'amikor',
    german: 'wann, als, wenn',
    dutch: 'wanneer (betrekkelijk vnw.)',
    afrikaans: 'wanneer (betreklike vnw.)',
    russian: 'когда',
    latvian: 'kad',
    polish: 'kiedy',
    french: 'quand',
    spanish: 'cuando',
  },
  {
    av: 18235,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(what, question mark + time: interrogative)',
    english: 'when, what time-(question)',
    swedish: 'när (fråga)',
    norwegian: 'når (spørsmål)',
    finnish: 'koska?, milloin?',
    hungarian: 'mikor? hány óra?',
    german: 'Wann?',
    dutch: 'wanneer?',
    afrikaans: 'wanneer, watter tyd (vraag)',
    russian: 'когда?',
    latvian: 'kad? cikos?',
    polish: 'kiedy, która godzina-(pytanie)',
    french: 'quand (question)',
    spanish: 'cuándo, a qué hora (pregunta)',
  },
  {
    av: 18238,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(who, that, which-(relative) + part: relative pronoun)',
    english: 'which, that-(relative)',
    swedish: 'vilken, vilken som',
    norwegian: 'hvilken',
    finnish: 'mikä',
    hungarian: 'amely',
    german: 'welche',
    dutch: 'welke(betrekkelijk vnw.)',
    afrikaans: 'watter, welke, daardie (betreklike vnw)',
    russian: 'какой',
    latvian: 'kurš, kas',
    polish: 'które, że-(względne)',
    french: 'lequel (relatif)',
    spanish: 'cuál, que (relativo)',
  },
  {
    av: 18239,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(what, question mark + part: interrogative)',
    english: 'which-(question)',
    swedish: 'vilken (fråga)',
    norwegian: 'hvilken (spørsmål)',
    finnish: 'kumpi?',
    hungarian: 'melyik?',
    german: 'welcher, welche?, welcher?, welches?',
    dutch: 'welke?',
    afrikaans: 'welke, wat (vraag)',
    russian: 'какой?',
    latvian: 'kurš? kāds?',
    polish: 'który-(pytanie)',
    french: 'quel, lequel (question)',
    spanish: 'cuál (pregunta)',
  },
  {
    av: 18240,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to say + quiet + action indicator)',
    english: 'whisper-(to)',
    swedish: 'viska',
    norwegian: 'hviske',
    finnish: 'kuiskata',
    hungarian: 'suttogni',
    german: 'flüstern',
    dutch: 'fluisteren',
    afrikaans: 'fluister (om te)',
    russian: 'шептать',
    latvian: 'čukstēt',
    polish: 'szeptać',
    french: 'chuchoter',
    spanish: 'susurrar',
  },
  {
    av: 18241,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to sing + teeth + action indicator: to make musical sounds through your teeth)',
    english: 'whistle-(to)',
    swedish: 'vissla',
    norwegian: 'plystre',
    finnish: 'viheltää',
    hungarian: 'fütyülni',
    german: 'pfeifen',
    dutch: 'fluiten',
    afrikaans: 'fluit (om te)',
    russian: 'свистеть',
    latvian: 'svilpot',
    polish: 'gwizdać',
    french: 'siffler',
    spanish: 'silbar',
  },
  {
    av: 18242,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + snow) (BCI)',
    english: 'white',
    swedish: 'vit',
    norwegian: 'hvit',
    finnish: 'valkoinen',
    hungarian: 'fehér',
    german: 'weiß',
    dutch: 'wit',
    afrikaans: 'wit (bci)',
    russian: 'белый',
    latvian: 'balts',
    polish: 'biały (BCI)',
    french: 'blanc (bci)',
    spanish: 'blanco',
  },
  {
    av: 18244,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(what, question mark + person: interrogative)',
    english: 'who, whom-(question)',
    swedish: 'vem (fråga)',
    norwegian: 'hvem (spørsmål)',
    finnish: 'kuka?',
    hungarian: 'ki? kit?',
    german: 'Wer?, Wen?',
    dutch: 'wie?',
    afrikaans: 'wie (vraag)',
    russian: 'кто?',
    latvian: 'kurš, kuram?',
    polish: 'którzy, którego-(pytanie)',
    french: 'qui (question)',
    spanish: 'quién, a quién (pregunta)',
  },
  {
    av: 18245,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(who, that, which-(relative) + person: relative pronoun)',
    english: 'who, whom, that-(relative)',
    swedish: 'vem, vem som',
    norwegian: 'hvem, hvem som',
    finnish: 'joka, ketä',
    hungarian: 'aki',
    german: 'welche, welcher, welches, wer, wen',
    dutch: 'die (betrekkelijk vnw.), dat (betrekkelijk vnw.)',
    afrikaans: 'die, wie (betreklike vnwe.)',
    russian: 'кто',
    latvian: 'kuru, kuram, kam',
    polish: 'kto, komu, czemu-(względne)',
    french: 'qui (relatif)',
    spanish: 'quién, qué (relativo)',
  },
  {
    av: 18246,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation:
      '(who, that, which-(relative) + belongs to: relative pronoun, possessive form)',
    english: 'whose (neutral)',
    swedish: 'vars, vilkens',
    norwegian: 'hvem sin, hvis',
    finnish: 'kenen (neutraali)',
    hungarian: 'akié, amié',
    german: 'dessen, deren',
    dutch: 'wiens, van welke',
    afrikaans: 'wie sin (neutraal)',
    russian: 'чей',
    latvian: 'kura',
    polish: 'którego (neutralne)',
    french: 'de qui, à qui',
    spanish: 'cuyo (neutral)',
  },
  {
    av: 18247,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation:
      '(who, whom, that-(relative) + belongs to: relative pronoun, possessive form)',
    english: 'whose (person)',
    swedish: 'vems, vars',
    norwegian: 'hvem sin',
    finnish: 'kenen, joiden',
    hungarian: 'akié',
    german: 'von wem',
    dutch: 'wiens (betrekkelijk vnw.), ',
    afrikaans: 'wie sin (persoon)',
    russian: 'чей, который',
    latvian: 'kura, kuras',
    polish: 'czyjeś (osoba)',
    french: 'dont (personne)',
    spanish: 'cuyo (persona)',
  },
  {
    av: 18248,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(who, whom-(question) + belongs to: interrogative)',
    english: 'whose-(question)',
    swedish: 'vems (fråga)',
    norwegian: 'hvem sin (spørsmål)',
    finnish: 'kenen?',
    hungarian: 'kié?',
    german: 'wessen, wessen?',
    dutch: 'van wie',
    afrikaans: 'wie sin (vraag)',
    russian: 'чей?',
    latvian: 'kura, kuras?',
    polish: 'którego, czyj-(pytanie)',
    french: 'de qui, à qui (question)',
    spanish: 'de quién (pregunta)',
  },
  {
    av: 18249,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(what, question mark + cause [half-sized])',
    english: 'why-(question)',
    swedish: 'varför',
    norwegian: 'hvorfor (spørsmål)',
    finnish: 'miksi?',
    hungarian: 'miért?',
    german: 'Warum?, wieso?',
    dutch: 'waarom?',
    afrikaans: 'hoekom, waarom (vraag)',
    russian: 'почему? зачем?',
    latvian: 'kāpēc, kādēļ?',
    polish: 'dlaczego?',
    french: 'pourquoi (question)',
    spanish: 'por qué (pregunta)',
  },
  {
    av: 18250,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(wideness, broadness + description indicator: the pointers point outward to the widest space bounded by the reference lines)',
    english: 'wide, broad',
    swedish: 'bred, vid',
    norwegian: 'vid, bred',
    finnish: 'leveä, laaja, avara',
    hungarian: 'széles',
    german: 'weit, breit',
    dutch: 'breed',
    afrikaans: 'wyd, breed, breë',
    russian: 'широкий',
    latvian: 'plats',
    polish: 'szeroki, gruby',
    french: 'large',
    spanish: 'ancho',
  },
  {
    av: 18252,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(worm + action indicator: to wriggle like a worm)',
    english: 'wiggle, squirm-(to)',
    swedish: 'slingra',
    norwegian: 'slynge, bukte, sno',
    finnish: 'kiemurrella',
    hungarian: 'kígyózni, tekerőzni, vonaglani',
    german: 'winden, schlängeln',
    dutch: 'kronkelen',
    afrikaans: 'wikkel, kronkel (om te)',
    russian: 'извиваться',
    latvian: 'gorīties, locīties',
    polish: 'pełzać pod ziemią ',
    french: 'remuer, tortiller',
    spanish: 'temblar',
  },
  {
    av: 18253,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(worm + description indicator: wriggling like a worm)',
    english: 'wiggly',
    swedish: 'krokig, slingrig',
    norwegian: 'krokete, svingete',
    finnish: 'kiemurteleva',
    hungarian: 'kígyózó, hullámos, tekergő',
    german: 'zappelig, wackelig, verwackelt',
    dutch: 'kronkelend',
    afrikaans: 'wikkelend',
    russian: 'извилистый',
    latvian: 'izlocījies',
    polish: 'pełzający, robakowaty',
    french: 'ondulé, remuant, qui se tortille',
    spanish: 'ondulados',
  },
  {
    av: 18254,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(competition + gain + action indicator: to achieve a victory in a competition or contest)',
    english: 'win-(to)',
    swedish: 'vinna',
    norwegian: 'vinne, seire',
    finnish: 'voittaa',
    hungarian: 'győzni, nyerni, megnyerni, ',
    german: 'gewinnen, siegen',
    dutch: 'winnen',
    afrikaans: 'wen (om te)',
    russian: 'выигрывать',
    latvian: 'uzvarēt',
    polish: 'wygrać',
    french: 'gagner',
    spanish: 'ganar',
  },
  {
    av: 18258,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(alcoholic drink + grape, grapes)',
    english: 'wine',
    swedish: 'vin',
    norwegian: 'vin',
    finnish: 'viini',
    hungarian: 'bor',
    german: 'Wein',
    dutch: 'wijn',
    afrikaans: 'wyn',
    russian: 'вино',
    latvian: 'vīns',
    polish: 'wino',
    french: 'vin',
    spanish: 'vino',
  },
  {
    av: 18260,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(eyelid (upper) + action indicator)',
    english: 'wink, blink-(to)',
    swedish: 'blinka',
    norwegian: 'blunke',
    finnish: 'iskeä silmää, räpyttää',
    hungarian: 'pislogni, pislantani, hunyorogni, kacsintani',
    german: 'zwinkern',
    dutch: 'knipperen',
    afrikaans: 'knipoog (om te)',
    russian: 'моргать, подмигивать',
    latvian: 'mirkšķināt',
    polish: 'mrugać',
    french: "cligner, faire un clin d'oeil",
    spanish: 'parpadear',
  },
  {
    av: 18261,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sun + 4: fourth season) (CKB) SYMBOL SYNONYM',
    english: 'winter (ckb)',
    swedish: 'vinter (CKB)',
    norwegian: 'vinter (CKB)',
    finnish: 'talvi',
    hungarian: 'tél (régi CKB-jelkép)',
    german: 'Winter',
    dutch: 'winter (CKB)',
    afrikaans: 'winter (ckb)',
    russian: 'зима',
    latvian: 'ziema',
    polish: 'zima',
    french: 'hiver (ckb)',
    spanish: 'invierno (CKB)',
  },
  {
    av: 18262,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sun + 4 + snow: fourth season when it snows) (BCI) SYMBOL SYNONYM',
    english: 'winter (snow)',
    swedish: 'vinter',
    norwegian: 'vinter (snø)',
    finnish: 'talvi (lumi)',
    hungarian: 'tél (havas)',
    german: 'Winter',
    dutch: 'winter (sneeuw)',
    afrikaans: 'winter (sneeu)',
    russian: 'зима',
    latvian: 'ziema',
    polish: 'zima (śnieg)',
    french: 'hiver (neigeux)',
    spanish: 'invierno (nieve)',
  },
  {
    av: 18263,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sun + 4 + rain: for use in parts of the world where it rains in winter) SYMBOL SYNONYM',
    english: 'winter (rain)',
    swedish: 'vinter (regn)',
    norwegian: 'vinter (regn)',
    finnish: 'talvi (sade)',
    hungarian: 'tél (esős)',
    german: 'Winter',
    dutch: 'winter (regen)',
    afrikaans: 'winter (reën)',
    russian: 'зима (дождь)',
    latvian: 'ziemas lietus',
    polish: 'zima (pora deszczowa)',
    french: 'hiver (pluvieux)',
    spanish: 'invierno (lluvia)',
  },
  {
    av: 18264,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(cloth + back and forth + action indicator)',
    english: 'wipe, dust, polish-(to)',
    swedish: 'damma, putsa, torka av',
    norwegian: 'pusse, tørke, gni',
    finnish: 'pyyhkiä, hangata',
    hungarian: 'törülni, letörülni, törülgetni, leporolni, fényesíteni',
    german: 'wischen, abwischen',
    dutch: 'poetsen',
    afrikaans: 'poets, afstof (om te)',
    russian: 'вытирать ',
    latvian: 'slaucīt, noslaucīt, nopulēt',
    polish: 'wycierać, polerować, ścierać ',
    french: 'essuyer',
    spanish: 'limpiar, quitar el polvo, lustrar',
  },
  {
    av: 18266,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(wish, desire + action indicator: to have a rational desire, a strong feeling shown by fire) See also: want, desire 24834',
    english: 'wish, desire-(to)',
    swedish: 'önska',
    norwegian: 'ønske, ville',
    finnish: 'toivoa',
    hungarian: 'vágyni, kívánni, óhajtani',
    german: 'wünschen',
    dutch: 'wensen, verlangen',
    afrikaans: 'wens, verlang, begeer (om te)',
    russian: 'желать',
    latvian: 'vēlēties, alkt',
    polish: 'chcieć, pragnąć',
    french: 'souhaiter, désirer',
    spanish: 'desear',
  },
  {
    av: 18268,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dog + open: untamed animal similar to a dog that lives in the open)',
    english: 'wolf, dingo, wild dog',
    swedish: 'varg, vildhund',
    norwegian: 'ulv, villhund',
    finnish: 'susi, dingo, villikoira',
    hungarian: 'farkas, vadkutya, dingó',
    german: 'Wolf',
    dutch: 'wilde hond, wolf',
    afrikaans: 'wolf, dingo, wilde hond',
    russian: 'волк',
    latvian: 'vilks, dingo, savvaļas suns',
    polish: 'wilk, dingo, dziki pies',
    french: 'loup',
    spanish: 'lobo, perro salvaje',
  },
  {
    av: 18270,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + tree)',
    english: 'wood, lumber, timber',
    swedish: 'trä',
    norwegian: 'tre (subst.), tømmer (subst.)',
    finnish: 'puu, puutavara',
    hungarian: 'faanyag, fűrészáru, hasított fa',
    german: 'Holz',
    dutch: 'hout',
    afrikaans: 'hout',
    russian: 'древесина',
    latvian: 'koks, kokmateriāls',
    polish: 'drewno, tarcica',
    french: 'bois (matière)',
    spanish: 'madera',
  },
  {
    av: 18271,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + sheep: material obtained from the fleece of sheep)',
    english: 'wool',
    swedish: 'ull, ylle',
    norwegian: 'ull',
    finnish: 'villa',
    hungarian: 'gyapjú',
    german: 'Wolle',
    dutch: 'wol',
    afrikaans: 'wol',
    russian: 'шерсть',
    latvian: 'vilna',
    polish: 'wełna',
    french: 'laine (matière)',
    spanish: 'lana',
  },
  {
    av: 18272,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + language)',
    english: 'word',
    swedish: 'ord',
    norwegian: 'ord',
    finnish: 'sana',
    hungarian: 'szó',
    german: 'Wort',
    dutch: 'woord',
    afrikaans: 'woord',
    russian: 'слово',
    latvian: 'vārds',
    polish: 'słowo, wyraz',
    french: 'mot',
    spanish: 'palabra',
  },
  {
    av: 18273,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '',
    english: 'work, employment, job',
    swedish: 'arbete, jobb, anställning',
    norwegian: 'arbeid, jobb',
    finnish: 'työ, tehtävä, toimi',
    hungarian: 'munka, foglalkozás, alkalmazás',
    german: 'Job, Arbeit, Arbeitsplatz, Stellung',
    dutch: 'baan, job, werk',
    afrikaans: 'werk, loopbaan',
    russian: 'работа',
    latvian: 'darbs, nodarbinātība, strādāšana',
    polish: 'praca, zatrudnienie, robota',
    french: 'travail',
    spanish: 'trabajo, empleo',
  },
  {
    av: 18274,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(work + action indicator: to do with a purpose)',
    english: 'work-(to)',
    swedish: 'arbeta, jobba',
    norwegian: 'arbeide, jobbe',
    finnish: 'tehdä työtä, työskennellä',
    hungarian: 'dolgozni, munkálkodni',
    german: 'arbeiten',
    dutch: 'werken',
    afrikaans: 'werk (om te)',
    russian: 'работать',
    latvian: 'strādāt',
    polish: 'pracować',
    french: 'travailler',
    spanish: 'trabajar',
  },
  {
    av: 18275,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(man-made + feeling + thing indicator: man-made thing that inspires emotion in the beholder)',
    english: 'work of art, art object',
    swedish: 'konstverk',
    norwegian: 'kunstverk',
    finnish: 'taideteos',
    hungarian: 'műtárgy, művészi alkotás',
    german: 'Kunstarbeit, Kunstobjekt',
    dutch: 'kunstwerk',
    afrikaans: 'kunswerk',
    russian: 'произведение искусства',
    latvian: 'mākslas darbs',
    polish: 'dzieło sztuki, obiekt sztuki',
    french: "œuvre, travail d'art",
    spanish: 'obra de arte, objeto de arte',
  },
  {
    av: 18276,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + to work)',
    english: 'workbook',
    swedish: 'arbetsbok',
    norwegian: 'arbeidsbok',
    finnish: 'työkirja, vihko',
    hungarian: 'munkafüzet',
    german: 'Arbeitsheft',
    dutch: 'schrift',
    afrikaans: 'werkboek',
    russian: 'рабочая тетрадь',
    latvian: 'darba burtnīca',
    polish: 'podręcznik z ćwiczeniami, zeszyt ćwiczeń',
    french: 'cahier',
    spanish: 'cuaderno de ejercicios',
  },
  {
    av: 18277,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to work)',
    english: 'worker',
    swedish: 'arbetare',
    norwegian: 'arbeider',
    finnish: 'työntekijä',
    hungarian: 'dolgozó, munkás',
    german: 'Arbeiter, Arbeiterin, Arbeitnehmer, Arbeitnehmerin',
    dutch: 'werknemer',
    afrikaans: 'werker',
    russian: 'рабочий, работник',
    latvian: 'strādnieks, darbinieks',
    polish: 'pracownik',
    french: 'travailleur, ouvrier',
    spanish: 'obrero, trabajador',
  },
  {
    av: 18280,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + opposing forces, counter-forces: thinking that one is beset by opposing forces)',
    english: 'worry',
    swedish: 'bekymmer, motgång',
    norwegian: 'bekymring, uro',
    finnish: 'vastoinkäyminen, harmi, huoli',
    hungarian: 'aggodalom, gond',
    german: 'Sorge, Ärger, Unruhe',
    dutch: 'bezorgdheid',
    afrikaans: 'besorgd, bekommerd',
    russian: 'тревога, беспокойство',
    latvian: 'rūpes, raizes, trauksme',
    polish: 'zmartwienie',
    french: 'inquiétude, ennui, souci, tracas',
    spanish: 'preocupación',
  },
  {
    av: 18281,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(worry + action indicator)',
    english: 'worry-(to)',
    swedish: 'bekymra, gå emot',
    norwegian: 'bekymre, uroe',
    finnish: 'olla huolissaan',
    hungarian: 'aggódni',
    german: 'sich sorgen (machen), sorgen (machen)',
    dutch: 'bezorgd zijn',
    afrikaans: 'besorgd, bekommerd (wees) (om te)',
    russian: 'тревожиться, беспокоиться',
    latvian: 'uztraukties, raizēties',
    polish: 'martwić się, obawiać',
    french: "inquiéter-(s'), soucier-(se)",
    spanish: 'preocuparse',
  },
  {
    av: 18282,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation:
      '(slang + positive + description indicator: expressing a positive feeling about something. It can represent wow!, great!, or similar positive expressions.)',
    english: 'wow, super, great, neat, cool-(exclamatory)',
    swedish: 'jättebra, toppen (etc)',
    norwegian: 'supert, kjempebra (o.l.) (utsagn)',
    finnish: 'hienoa!, positiivinen tunne',
    hungarian: 'Ejha! Pompás! Remek! Szuper (király, zsír stb.)!',
    german: 'Phantastisch!, Spitze!, Wow!',
    dutch: 'joepie, super, cool',
    afrikaans: 'wow, fantasties, koel, eish, jippie, jê (uitroepend)',
    russian: 'отлично! супер!',
    latvian: 'lieliski, ļoti labi, jauki, superīgi',
    polish: 'wow, super (wołacz)',
    french: 'wow (exclamation), super, cool',
    spanish: '¡Estupendo! (exclamativo)',
  },
  {
    av: 18283,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + 2 + person + to mix: informal activity in which two people grapple with each other)',
    english: 'wrestling (activity)',
    swedish: 'brottning, judo',
    norwegian: 'bryting, judo',
    finnish: 'paini',
    hungarian: 'birkózás',
    german: 'Ringen (Sport)',
    dutch: 'worstelen (zelfst;nw)',
    afrikaans: 'stoei (aktiwiteit)',
    russian: 'борьба, дзюдо',
    latvian: 'cīkstēšanās, cīņa',
    polish: 'wrestling (uprawiać)',
    french: 'lutte, catch (activité)',
    spanish: 'lucha (actividad)',
  },
  {
    av: 18285,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(pen + action indicator)',
    english: 'write-(to)',
    swedish: 'skriva',
    norwegian: 'skrive',
    finnish: 'kirjoittaa',
    hungarian: 'írni',
    german: 'schreiben',
    dutch: 'schrijven',
    afrikaans: 'skryf (om te)',
    russian: 'писать',
    latvian: 'rakstīt',
    polish: 'pisać',
    french: 'écrire',
    spanish: 'escribir',
  },
  {
    av: 18286,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(anniversary + death)',
    english: 'Yahrzeit',
    swedish: 'yahrzeit (Israel)',
    norwegian: 'yahrzeit (Israel)',
    finnish: 'suruaika',
    hungarian: 'évforduló',
    german: 'Todestag',
    dutch: 'sterfdag',
    afrikaans: 'Yahrzeit',
    russian: 'годовщина смерти (йорцейт, Израиль)',
    latvian: 'dvēseļu svece (mirušo piemiņa Izraēlā)',
    polish: 'jorcait (z hebr. rocznica śmierci)',
    french: 'Yahrzeit, anniversaire du décès',
    spanish: 'yahrzeit ',
  },
  {
    av: 18288,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      "(mouth + to sleep + action indicator: what one's mouth does when one is sleepy)",
    english: 'yawn-(to)',
    swedish: 'gäspa',
    norwegian: 'gjespe',
    finnish: 'haukotella',
    hungarian: 'ásítani',
    german: 'gähnen',
    dutch: 'gapen, geeuwen',
    afrikaans: 'gaap (om te)',
    russian: 'зевать',
    latvian: 'žāvāties',
    polish: 'ziewać',
    french: 'bâiller',
    spanish: 'bostezar',
  },
  {
    av: 18290,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to say + three intensity symbols + action indicator: to say very forcefully)',
    english: 'yell, scream-(to)',
    swedish: 'vråla',
    norwegian: 'skrike, hyle',
    finnish: 'kiljua, kirkua',
    hungarian: 'ordítani, sikoltani, sikoltozni, rikoltani',
    german: 'rufen',
    dutch: 'gillen, krijsen',
    afrikaans: 'gil, skree (om te)',
    russian: 'кричать, вопить, орать',
    latvian: 'kliegt, bļaut',
    polish: 'wrzeszczeć, krzyczeć',
    french: 'hurler',
    spanish: 'gritar',
  },
  {
    av: 18291,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + sun) (BCI) SYMBOL SYNONYM',
    english: 'yellow (bci)',
    swedish: 'gul',
    norwegian: 'gul',
    finnish: 'keltainen',
    hungarian: 'sárga',
    german: 'gelb',
    dutch: 'geel (BCI)',
    afrikaans: 'geel (bci)',
    russian: 'жёлтый',
    latvian: 'dzeltens',
    polish: 'żółty (BCI)',
    french: 'jaune (bci)',
    spanish: 'amarillo (BCI)',
  },
  {
    av: 18292,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + 3) (CKB) SYMBOL SYNONYM',
    english: 'yellow (ckb)',
    swedish: 'gul (CKB)',
    norwegian: 'gul (CKB)',
    finnish: 'keltainen',
    hungarian: 'sárga (régi CKB-jelkép)',
    german: 'gelb',
    dutch: 'geel (CKB)',
    afrikaans: 'geel (ckb)',
    russian: 'жёлтый [Ч.Б.]',
    latvian: 'dzeltens',
    polish: 'żółty (CKB)',
    french: 'jaune (ckb)',
    spanish: 'amarillo (CKB)',
  },
  {
    av: 18294,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(positive + intensity: strong positive response)',
    english: 'yes-(exclamatory)',
    swedish: 'ja',
    norwegian: 'ja',
    finnish: 'kyllä',
    hungarian: 'Igen!',
    german: 'ja',
    dutch: 'ja',
    afrikaans: 'ja (uitroepend)',
    russian: 'да',
    latvian: 'jā',
    polish: 'TAK!! (wołacz)',
    french: 'oui (exclamation)',
    spanish: 'sí (exclamativo)',
  },
  {
    av: 18295,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + then (past))',
    english: 'yesterday',
    swedish: 'igår',
    norwegian: 'i går',
    finnish: 'eilen',
    hungarian: 'tegnap',
    german: 'gestern',
    dutch: 'gisteren',
    afrikaans: 'gister',
    russian: 'вчера',
    latvian: 'vakar',
    polish: 'wczoraj',
    french: 'hier',
    spanish: 'ayer',
  },
  {
    av: 18296,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + comma + milk: food made from fermented milk)',
    english: 'yogurt, yoghurt',
    swedish: 'fil, yoghurt',
    norwegian: 'yoghurt',
    finnish: 'jugurtti',
    hungarian: 'joghurt',
    german: 'Joghurt',
    dutch: 'yoghurt',
    afrikaans: 'joghurt',
    russian: 'кефир, йогурт',
    latvian: 'kefīrs, jogurts',
    polish: 'jogurt',
    french: 'yaourt, yoghourt',
    spanish: 'yogur',
  },
  {
    av: 18297,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + to forgive: the Day of Atonement, a holiday when one atones for sins and asks for forgiveness)',
    english: 'Yom Kippur',
    swedish: 'Yom Kippur (Israel)',
    norwegian: 'Yom Kippur (Israel)',
    finnish: 'jom kippur, suuri sovituspäivä',
    hungarian: 'Jom Kippur (héber)',
    german: 'Yom Kippur',
    dutch: 'Yom-Kippur (Joods)',
    afrikaans: 'Yom Kippur',
    russian: 'Йом-Киппур (Израиль)',
    latvian: 'grākatlaides diena Izraēlā',
    polish: 'Jom Kippur (hebr. Dzień Pojednania)',
    french: 'Kippour (fête juive)',
    spanish: 'Yom Kippur ',
  },
  {
    av: 18298,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(female + 2 + plural indicator: second person (f.pl.))',
    english: 'you, yourselves-(feminine plural)',
    swedish: 'ni, er (fem.)',
    norwegian: 'dere (hunkjønn)',
    finnish: 'te (naisia), te (fem.), te itse',
    hungarian: 'ti, titeket (nőnem)',
    german: 'ihr, euch, euer',
    dutch: 'jullie (vrouwelijk mv)',
    afrikaans: 'julle, julself (vroulik meervoud)',
    russian: 'вы (жен.р.мн.ч)',
    latvian: 'jūs, jūs pašas',
    polish: 'wy, was (r. żeński liczba mnoga)',
    french: 'vous (2e pers. fém. pluriel), vous-mêmes',
    spanish: 'tú (femenino plural)',
  },
  {
    av: 18299,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(female + 2: second person (f.sing.))',
    english: 'you, yourself-(feminine singular)',
    swedish: 'du, dig (fem.)',
    norwegian: 'du, deg (hunkjønn)',
    finnish: 'sinä (nainen), sinä (fem.), sinä itse',
    hungarian: 'te, téged (nőnem)',
    german: 'du, dein, dir, dich',
    dutch: 'jij (vrouwelijk enk.), je (vrouwelijk enk.)',
    afrikaans: 'jy, jouself (vroulik enkelvoud)',
    russian: 'ты (жен.р. ед.ч.)',
    latvian: 'jūs, jūs pati',
    polish: 'ciebie, siebie (r. żeński, liczba pojedyncza)',
    french: 'vous (2e pers. fém. sing.), vous-même',
    spanish: 'tú (femenino singular)',
  },
  {
    av: 18300,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(male + 2 + plural indicator: second person (m.pl.))',
    english: 'you, yourselves-(masculine plural)',
    swedish: 'ni, er (mask.)',
    norwegian: 'dere (hankjønn)',
    finnish: 'te (miehiä), te (mask.), te itse',
    hungarian: 'ti, titeket (hímnem)',
    german: 'ihr, euch, euer',
    dutch: 'jullie (mannelijk mv)',
    afrikaans: 'julle, julself (manlik meervoud)',
    russian: 'вы (муж.р. мн.ч.)',
    latvian: 'jūs, jūs paši',
    polish: 'wy, was (r. męski, liczba mnoga)',
    french: 'vous (2e pers. masc. pluriel), vous-mêmes',
    spanish: 'tú (masculino plural)',
  },
  {
    av: 18301,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(male + 2: second person (m.sing.))',
    english: 'you, yourself-(masculine singular)',
    swedish: 'du, dig (mask.)',
    norwegian: 'du, deg (hankjønn)',
    finnish: 'sinä (mies), sinä (mask.), sinä itse',
    hungarian: 'te, téged (hímnem)',
    german: 'du, dir, dich, dein',
    dutch: 'jij (mannelijk enk.), je (mannelijk enk.',
    afrikaans: 'jy, jouself (manlik enkelvoud)',
    russian: 'ты (муж.р. ед.ч.)',
    latvian: 'jūs, jūs pats',
    polish: 'ciebie, siebie-(r. męski, liczby pojedynczej)',
    french: 'vous (2e pers. masc. sing.), vous-même',
    spanish: 'tú (masculino singular)',
  },
  {
    av: 18302,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + 2 + plural indicator: second person plural)',
    english: 'you, yourselves-(plural)',
    swedish: 'ni, er',
    norwegian: 'dere',
    finnish: 'te, te itse',
    hungarian: 'ti, titeket, önök, önöket',
    german: 'ihr, euer, euch, sie, ihnen',
    dutch: 'jullie',
    afrikaans: 'julle, julself (meervoud)',
    russian: 'вы',
    latvian: 'jūs, jūs paši/pašas',
    polish: 'wy, was (r. nieokreślony, liczba mnoga)',
    french: 'vous (2e pers. pluriel), vous-mêmes',
    spanish: 'vosotros, vosotras',
  },
  {
    av: 18465,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + 2: second person singular)',
    english: 'you, yourself',
    swedish: 'du, dig',
    norwegian: 'du, deg',
    finnish: 'sinä, sinä itse',
    hungarian: 'ön, önt',
    german: 'du, dir, dich, dein',
    dutch: 'jij, je',
    afrikaans: 'jy, jouself',
    russian: 'ты, тебе',
    latvian: 'tu, tevi',
    polish: 'Ciebie, siebie (r. nieokreślony, liczba pojedyncza)',
    french: 'tu',
    spanish: 'tú',
  },
  {
    av: 18466,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation:
      '(happy + to help + action indicator: polite phrase used in response to thank you)',
    english: "you are welcome, you're welcome",
    swedish: 'ingen orsak',
    norwegian: 'ingen årsak, selv takk (utsagn)',
    finnish: 'ei kestä kiittää!, ole hyvä!',
    hungarian: 'Szívesen! Örömmel!',
    german: 'bitte sehr, gern geschehen',
    dutch: 'graag gedaan',
    afrikaans: 'jy is welkom',
    russian: 'не за что, ничего',
    latvian: 'nav par ko, vienmēr laipni',
    polish: 'nie ma za co (dziękuję)',
    french: 'à votre service, de rien, bienvenue',
    spanish: 'de nada',
  },
  {
    av: 18467,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(child + description indicator)',
    english: 'young',
    swedish: 'ung',
    norwegian: 'ung',
    finnish: 'nuori',
    hungarian: 'fiatal',
    german: 'jung',
    dutch: 'jong',
    afrikaans: 'jonk',
    russian: 'молодой',
    latvian: 'jauns',
    polish: 'młody',
    french: 'jeune',
    spanish: 'joven',
  },
  {
    av: 18468,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(female + 2 + belongs to + plural indicator: second person plural (f.), possessive)',
    english: 'your, yours-(feminine plural)',
    swedish: 'er, ert, era (fem.)',
    norwegian: 'deres (hunkjønn)',
    finnish: 'teidän (naisia), teidän (fem.)',
    hungarian: 'tiétek (nőnem)',
    german: 'ihre, ihrer, ihres',
    dutch: 'jullie (bezit.vnw vr mv.), uw (bezit.vnw vr mv.)',
    afrikaans: 'julle, julle sin (vroulik meervoud)',
    russian: 'ваш (мн.ч. жен.р.)',
    latvian: 'jūsu (siev.dz., dsk.)',
    polish: 'wasze (r. żeński liczba mnoga)',
    french: 'votre, vos (fém. pluriel)',
    spanish: 'su, suyo (femenino plural)',
  },
  {
    av: 18469,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(female + 2 + belongs to: second person singular (f.), possessive)',
    english: 'your, yours-(feminine singular)',
    swedish: 'din, ditt, dina (fem.)',
    norwegian: 'din, ditt, dine (hunkjønn)',
    finnish: 'sinun (nainen), sinun (fem.)',
    hungarian: 'tiéd (nőnem)',
    german: 'deine, deiner, deines',
    dutch: 'jouw (bezit.vnw vr enk.), uw (bezit.vnw vr enk.)',
    afrikaans: 'jou, joune vroulik enkelvoud)',
    russian: 'твой (жен.р. ед.ч.)',
    latvian: 'jūsu (siev.dz., vsk.)',
    polish: 'twój, twoje-(r. żeński liczba pojedyncza)',
    french: 'votre, vos (fém.sing.)',
    spanish: 'su, suyo (femenino singular)',
  },
  {
    av: 18470,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(male + 2 + belongs to + plural indicator: second person plural (m.), possessive)',
    english: 'your, yours-(masculine plural)',
    swedish: 'er, ert, era (mask.)',
    norwegian: 'deres (hankjønn)',
    finnish: 'teidän (miehet), teidän (mask.)',
    hungarian: 'tiétek (hímnem)',
    german: 'ihre, ihrer, ihres',
    dutch: 'jullie (bezit.vnw m mv.), uw (bezit.vnw m mv.)',
    afrikaans: 'julle, julle sin (manlik meervoud)',
    russian: 'ваш (муж.р. мн.ч.)',
    latvian: 'jūsu (vīr.dz., dsk.)',
    polish: 'wasze (r. męski liczba mnoga)',
    french: 'votre, vos (masc. pluriel)',
    spanish: 'su, suyo (masculino plural)',
  },
  {
    av: 18471,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(male + 2 + belongs to: second person singular (m.), possessive)',
    english: 'your, yours-(masculine singular)',
    swedish: 'din, ditt, dina (mask.)',
    norwegian: 'din, ditt, dine (hankjønn)',
    finnish: 'sinun (mies), sinun (mask.)',
    hungarian: 'tiéd (hímnem)',
    german: 'deine, deiner, deines',
    dutch: 'jouw (bezit.vnw m enk.), uw (bezit.vnw m enk.)',
    afrikaans: 'jou, joune (manlik enkelvoud)',
    russian: 'твой (муж.р. ед.ч.)',
    latvian: 'jūsu (vīr. dz. Vsk.)',
    polish: 'twój, twoje-(r. męski liczby pojedynczej)',
    french: 'votre, vos (masc. sing.)',
    spanish: 'su, suyo (masculino singular)',
  },
  {
    av: 18472,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(you + belongs to + plural indicator)',
    english: 'your, yours-(plural)',
    swedish: 'er, ert, era',
    norwegian: 'deres',
    finnish: 'teidän',
    hungarian: 'önöké',
    german: 'euer, eure',
    dutch: 'jullie (bezit.vnw), uw',
    afrikaans: 'jou, julle sin (meervoud)',
    russian: 'ваш',
    latvian: 'jūsu (dsk.)',
    polish: 'Państwa, wasze (r. nieokreślony, liczba mnoga)',
    french: 'votre, vos (pluriel)',
    spanish: 'su, suyo (plural)',
  },
  {
    av: 18473,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(you + belongs to: second person (sing.), possessive)',
    english: 'your, yours-(singular)',
    swedish: 'din, ditt, dina',
    norwegian: 'din, ditt, dine',
    finnish: 'sinun',
    hungarian: 'öné',
    german: 'dein, dein, deine, dein',
    dutch: 'jouw, uw',
    afrikaans: 'jou, joune (enkelvoud)',
    russian: 'твой',
    latvian: 'tavs, tavējais',
    polish: 'twój, twoje-(r. nieokreślony, liczba pojedyncza)',
    french: 'votre, vos (sing.)',
    spanish: 'tu, tuyo (singular)',
  },
  {
    av: 18474,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(horse + stripe: striped animal that resembles a horse)',
    english: 'zebra',
    swedish: 'zebra',
    norwegian: 'sebra',
    finnish: 'seepra',
    hungarian: 'zebra',
    german: 'Zebra',
    dutch: 'zebra',
    afrikaans: 'zebra, sebra',
    russian: 'зебра',
    latvian: 'zebra',
    polish: 'zebra',
    french: 'zèbre',
    spanish: 'cebra',
  },
  {
    av: 18475,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(park + animal)',
    english: 'zoo',
    swedish: 'djurpark, zoo',
    norwegian: 'zoologisk hage, dyrepark',
    finnish: 'eläintarha, eläinpuisto',
    hungarian: 'állatkert',
    german: 'Zoologischer Garten, Zoo',
    dutch: 'dierentuin',
    afrikaans: 'dieretuin',
    russian: 'зоопарк',
    latvian: 'zooloģiskais darzs',
    polish: 'ZOO',
    french: 'zoo',
    spanish: 'zoo, zoológico',
  },
  {
    av: 20513,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cross + thing indicator) - (character with thing indicator)',
    english: 'cross (a)',
    swedish: 'kors',
    norwegian: 'kors',
    finnish: 'risti',
    hungarian: 'kereszt',
    german: 'Kreuz',
    dutch: 'kruis',
    afrikaans: 'kruis',
    russian: 'крест',
    latvian: 'krusts',
    polish: 'krzyż, krzyżyk (przedmiot)',
    french: 'croix (objet)',
    spanish: 'cruz',
  },
  {
    av: 20514,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(life + without + end)',
    english: 'eternal life, immortality',
    swedish: 'evigt liv, odödlighet',
    norwegian: 'evig liv, udødelighet',
    finnish: 'ikuinen elämä, kuolemattomuus',
    hungarian: 'örökélet, halhatatlanság',
    german: 'Unsterblichkeit',
    dutch: 'eeuwig leven, onsterfelijkheid',
    afrikaans: 'ewige lewe, onsterflikheid',
    russian: 'бессмертие, вечная жизнь',
    latvian: 'mūzīģā dzīve, nemirstība',
    polish: 'nieśmiertelność, życie wieczne',
    french: 'vie éternelle, immortalité',
    spanish: 'vida eterna, inmortalidad',
  },
  {
    av: 20515,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(star of David + thing indicator) - (character with thing indicator)',
    english: 'star of David (a)',
    swedish: 'Davidsstjärna (konkret)',
    norwegian: 'Davidstjernen (konkret)',
    finnish: 'Daavidin tähti',
    hungarian: 'Dávidcsillag',
    german: 'Davidstern',
    dutch: 'Davidster',
    afrikaans: 'ster van Dawid, Dawidster',
    russian: 'звезда Давида',
    latvian: 'Dāvida zvaigzne',
    polish: 'gwiazda Dawida (przedmiot)',
    french: 'étoile de David (objet)',
    spanish: 'estrella de David',
  },
  {
    av: 20516,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + therapy) Preferred NEW SYNONYM, replacing 17706',
    english: 'therapist',
    swedish: 'terapeut',
    norwegian: 'terapeut',
    finnish: 'terapeutti',
    hungarian: 'terapeuta',
    german: 'Therapeut, Therapeutin',
    dutch: 'therapeut',
    afrikaans: 'terapeut',
    russian: 'терапевт',
    latvian: 'terapeits',
    polish: 'terapeuta',
    french: 'thérapeute',
    spanish: 'terapeuta',
  },
  {
    av: 20521,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pasta + line)',
    english: 'spaghetti',
    swedish: 'spaghetti',
    norwegian: 'spaghetti',
    finnish: 'spagetti',
    hungarian: 'spagetti',
    german: 'Spaghetti',
    dutch: 'spaghetti',
    afrikaans: 'spaghetti',
    russian: 'спагетти',
    latvian: 'spageti',
    polish: 'spaghetti, makaron nitki',
    french: 'spaghetti',
    spanish: 'espagueti',
  },
  {
    av: 20526,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(taste + description indicator)',
    english: 'tasty, good, appetizing',
    swedish: 'god, smaklig, välsmakande',
    norwegian: 'velsmakende, god',
    finnish: 'maukas',
    hungarian: 'étvágygerjesztő, ízes',
    german: 'schmackhaft, lecker',
    dutch: 'smakelijk',
    afrikaans: 'smaaklik, heerlik',
    russian: 'вкусный',
    latvian: 'gards, garšīgs, apetitlīgs',
    polish: 'smaczne, dobre, smakowite',
    french: 'savoureux, délicieux',
    spanish: 'sabroso, bueno, apetitoso',
  },
  {
    av: 20527,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(reflection + thing indicator: a ray of light is reflected by a mirror) - (character with thing indicator)',
    english: 'mirror',
    swedish: 'spegel',
    norwegian: 'speil',
    finnish: 'peili',
    hungarian: 'tükör',
    german: 'Spiegel',
    dutch: 'spiegel',
    afrikaans: 'spieël',
    russian: 'зеркало',
    latvian: 'spogulis',
    polish: 'lustro',
    french: 'miroir',
    spanish: 'espejo',
  },
  {
    av: 20530,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(hand + table + description indicator: a table top is hard to touch) Preferred NEW SYNONYM, replacing 14679',
    english: 'hard, firm',
    swedish: 'hård',
    norwegian: 'hard, fast',
    finnish: 'kova',
    hungarian: 'kemény, merev',
    german: 'hart',
    dutch: 'hard',
    afrikaans: 'hard, ferm',
    russian: 'твёрдый',
    latvian: 'ciets',
    polish: 'twardy, stały, zbity',
    french: 'dur',
    spanish: 'duro, firme',
  },
  {
    av: 20562,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(religion, naturalism + description indicator) Preferred NEW SYNONYM, replacing 16484',
    english: 'religious',
    swedish: 'religiös, troende',
    norwegian: 'religiøs, troende',
    finnish: 'uskonnollinen',
    hungarian: 'vallásos, hívő',
    german: 'religiös',
    dutch: 'religieus, godsdienstig',
    afrikaans: 'godsdienstige',
    russian: 'религиозный',
    latvian: 'reliģisks',
    polish: 'religijne',
    french: 'religieux',
    spanish: 'religioso',
  },
  {
    av: 20565,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + religion (God based))',
    english: 'believer (in God)',
    swedish: 'religiös person, troende',
    norwegian: 'religiøs person, troende (tro på Gud)',
    finnish: 'uskovainen',
    hungarian: 'Istenhívő ember',
    german: 'Gläubige (der), Gläubige (die)',
    dutch: 'gelovige (in God)',
    afrikaans: 'gelowige (in God)',
    russian: 'верующий в Бога',
    latvian: 'ticīgais (Dievticīgais)',
    polish: 'wierzący (w Boga)',
    french: 'croyant (en une religion)',
    spanish: 'creyente (en Dios)',
  },
  {
    av: 20566,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + religion, naturalism)',
    english: 'believer',
    swedish: 'troende (person)',
    norwegian: 'person troende',
    finnish: 'uskovainen',
    hungarian: 'vallásos ember',
    german: 'Gläubige (der), Gläubige (die)',
    dutch: 'gelovige',
    afrikaans: 'gelowige',
    russian: 'верующий (человек)',
    latvian: 'ticīgais',
    polish: 'wierzący',
    french: 'croyant',
    spanish: 'creyente',
  },
  {
    av: 20567,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + Christianity)',
    english: 'Jesus Christ',
    swedish: 'Jesus Kristus',
    norwegian: 'Jesus Kristus',
    finnish: 'Jeesus Kristus',
    hungarian: 'Jézus, Jézus Krisztus',
    german: 'Christus, Jesus',
    dutch: 'Jezus Christus',
    afrikaans: 'Jesus Christus',
    russian: 'Иисус Христос',
    latvian: 'Jēzus Kristus',
    polish: 'Jezus Chrystus',
    french: 'Jésus-Christ',
    spanish: 'Jesucristo',
  },
  {
    av: 20569,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(spirit + supernatural + incorrect, bad, inaccurate, wrong + intensity: very bad supernatural spirit) SYMBOL SYNONYM',
    english: 'devil (2)',
    swedish: 'djävul (2)',
    norwegian: 'djevel (2)',
    finnish: 'paha henki, pahuus',
    hungarian: 'ördög',
    german: 'Teufel (2)',
    dutch: 'duivel (2)',
    afrikaans: 'duiwel (2)',
    russian: 'Дьявол, Сатана, Лукавый (2)',
    latvian: 'velns, Sātans (2)',
    polish: 'Diabeł (2)',
    french: 'démon, diable (2)',
    spanish: 'diablo (2)',
  },
  {
    av: 20570,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(spirit + supernatural + peace) SYMBOL SYNONYM',
    english: 'angel (2)',
    swedish: 'ängel (2)',
    norwegian: 'engel (2)',
    finnish: 'enkeli (2)',
    hungarian: 'angyal',
    german: 'Engel (2)',
    dutch: 'engel (2)',
    afrikaans: 'engel (2)',
    russian: 'Ангел (2)',
    latvian: 'Enģelis (2)',
    polish: 'anioł (2)',
    french: 'ange (2)',
    spanish: 'ángel (2)',
  },
  {
    av: 20573,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ceremony + religion, naturalism)',
    english: 'religious ceremony',
    swedish: 'religiös ceremoni ',
    norwegian: 'seremoni religiøs',
    finnish: 'uskonnolliset juhlamenot',
    hungarian: 'vallási szertartás',
    german: 'religiöse Zeremonie',
    dutch: 'religieuze ceremonie',
    afrikaans: 'godsdienstige seremonie',
    russian: 'религиозная церемония',
    latvian: 'reliģiska ceremonija',
    polish: 'ceremonia religijna (dowolnej wiary)',
    french: 'cérémonie religieuse',
    spanish: 'ceremonia religiosa',
  },
  {
    av: 20574,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ceremony + religion (God based))',
    english: 'religious ceremony (God based)',
    swedish: 'religiös ceremoni (gudsbaserad)',
    norwegian: 'seremoni religiøs (tro på Gud)',
    finnish: 'uskonnolliset juhlamenot',
    hungarian: 'vallási szertartás (Istenhívőknél)',
    german: 'religiöse Zeremonie (basiert auf Gott)',
    dutch: 'religieuze ceremonie (God)',
    afrikaans: 'godsdienstige seremonie (op God gebaseer)',
    russian: 'религиозная церемония (на основе веры в Бога)',
    latvian: 'reliģioza ceremonija (Dievticībā)',
    polish: 'ceremonia religijna (w wierze w Boga)',
    french: 'cérémonie religieuse (basée sur dieu)',
    spanish: 'ceremonia religiosa (basada en un Dios)',
  },
  {
    av: 20575,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ceremony + marriage)',
    english: 'marriage, wedding',
    swedish: 'bröllop, vigsel',
    norwegian: 'vielse, giftermål, bryllup',
    finnish: 'häät',
    hungarian: 'esküvő, házasságkötés',
    german: 'Ehe, Hochzeit',
    dutch: 'huwelijk',
    afrikaans: 'huwelik, troue',
    russian: 'свадьба',
    latvian: 'kāzas, precības',
    polish: 'małżeństwo, ślub (ceremonia)',
    french: 'mariage (cérémonie)',
    spanish: 'matrimonio, boda',
  },
  {
    av: 20576,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(religious ceremony + marriage)',
    english: 'marriage (religious)',
    swedish: 'vigsel (religiös)',
    norwegian: 'vielse, bryllup, giftermål (religiøs)',
    finnish: 'kirkkohäät',
    hungarian: 'esküvő, házasságkötés (vallásos, egyházi)',
    german: 'Hochzeit, Ehe',
    dutch: 'huwelijk (kerkelijk)',
    afrikaans: 'huwelik, troue (gelowig)',
    russian: 'венчание',
    latvian: 'laulības',
    polish: 'ślub kościelny (religijny)',
    french: 'mariage (religieux)',
    spanish: 'matrimonio (religioso)',
  },
  {
    av: 20577,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(religious ceremony + death)',
    english: 'funeral (religious)',
    swedish: 'begravningsakt (religiös)',
    norwegian: 'begravelsesseremoni (religiøs)',
    finnish: 'hautajaiset',
    hungarian: 'temetés (vallásos, egyházi)',
    german: 'Begräbnis, Beerdigung, Begräbnisfeier',
    dutch: 'begrafenis (kerkelijk)',
    afrikaans: 'begrafnis (gelowig)',
    russian: 'похоронный ритуал (религиозный)',
    latvian: 'bēres (reliģiskas)',
    polish: 'pogrzeb religijny',
    french: 'enterrement, funérailles (service religieux)',
    spanish: 'funeral (religioso)',
  },
  {
    av: 20578,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ceremony + death)',
    english: 'funeral',
    swedish: 'begravningsakt',
    norwegian: 'begravelsesseremoni',
    finnish: 'hautajaiset',
    hungarian: 'temetés, temetési szertartás',
    german: 'Begräbnis, Beerdigung, Begräbnisfeier',
    dutch: 'begrafenis',
    afrikaans: 'begrafnis',
    russian: 'похоронный ритуал',
    latvian: 'bēres, bēru ceremonija',
    polish: 'pogrzeb',
    french: 'enterrement, funérailles (service)',
    spanish: 'funeral',
  },
  {
    av: 20579,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ceremony + grave)',
    english: 'burial',
    swedish: 'begravning, gravsättning',
    norwegian: 'begravelse',
    finnish: 'hautaus',
    hungarian: 'temetés, elföldelés',
    german: 'Begräbnis, Bestattung, Beerdigung',
    dutch: 'begrafenis',
    afrikaans: 'begrafnis, ter aarde bestelling',
    russian: 'погребение',
    latvian: 'apbedīšana, apglabāšana',
    polish: 'pogrzeb',
    french: 'funérailles',
    spanish: 'entierro',
  },
  {
    av: 20580,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(religious ceremony + grave)',
    english: 'burial (religious)',
    swedish: 'begravning, gravsättning (religiös)',
    norwegian: 'begravelse (religiøs)',
    finnish: 'hautaus',
    hungarian: 'temetés, elföldelés (vallásos, egyházi)',
    german: 'Begräbnis, Bestattung, Beerdigung',
    dutch: 'begrafenis (kerkelijk)',
    afrikaans: 'begrafnis, ter aarde bestelling (gelowig)',
    russian: 'погребение (религиозное)',
    latvian: 'apbedīšana (reliģiska)',
    polish: 'pogrzeb (religijne)',
    french: 'funérailles (religieuses)',
    spanish: 'entierro (religioso)',
  },
  {
    av: 20581,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(burial site + action indicator)',
    english: 'bury-(to)',
    swedish: 'begrava, placera under jord, gräva ner',
    norwegian: 'begrave, gravlegge',
    finnish: 'haudata, kätkeä maan alle',
    hungarian: 'temetni, eltemetni',
    german: 'beerdigen',
    dutch: 'begraven',
    afrikaans: 'begrawe (om te)',
    russian: 'похоронить',
    latvian: 'apbedīt, apglabāt',
    polish: 'pogrzebać, zakopać',
    french: 'ensevelir, enterrer',
    spanish: 'enterrar',
  },
  {
    av: 20582,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(poverty + description indicator)',
    english: 'poor (without possessions)',
    swedish: 'fattig (utan ägodelar)',
    norwegian: 'fattig (uten eiendeler)',
    finnish: 'köyhä, varaton',
    hungarian: 'szegény, nincstelen',
    german: 'arm',
    dutch: 'arm (zonder bezit)',
    afrikaans: 'arm (sonder besittings)',
    russian: 'бедный, неимущий',
    latvian: 'nabadzīgs, bez īpašuma, iztikas)',
    polish: 'biedny, ubogi (nie posiadający niczego)',
    french: 'pauvre (sans possession)',
    spanish: 'pobre (sin posesiones)',
  },
  {
    av: 20583,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball + legs and feet)',
    english: 'football, soccer (sport)',
    swedish: 'fotboll (sport)',
    norwegian: 'fotball (sport)',
    finnish: 'jalkapalloilu',
    hungarian: 'futball, foci',
    german: 'Fußball (Spiel)',
    dutch: 'voetbal',
    afrikaans: 'sokker (sport)',
    russian: 'футбол (спорт)',
    latvian: 'futbols, sports',
    polish: 'futbol, piłka nożna (sport)',
    french: 'football (sport)',
    spanish: 'fútbol',
  },
  {
    av: 20584,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sport + ball + corner: the corner character here representing the baseball diamond with the pointer to a base in the corner: ball game played on a diamond)',
    english: 'baseball (sport)',
    swedish: 'baseboll (sport)',
    norwegian: 'baseball (sport)',
    finnish: 'baseball',
    hungarian: 'bézból',
    german: 'Baseball (Sport)',
    dutch: 'honkbal',
    afrikaans: 'bofbal (sport)',
    russian: 'бейсбол (спорт)',
    latvian: 'beisbols, sports',
    polish: 'Baseball (sport)',
    french: 'baseball (sport)',
    spanish: 'béisbol (deporte)',
  },
  {
    av: 20585,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball + container, basket (high))',
    english: 'basketball (sport)',
    swedish: 'basketboll (sport)',
    norwegian: 'basketball (sport)',
    finnish: 'koripallo',
    hungarian: 'kosárlabda',
    german: 'Basketball (Sport)',
    dutch: 'basketbal, korfbal',
    afrikaans: 'basketbal (sport',
    russian: 'баскетбол (спорт)',
    latvian: 'basketbols, sports',
    polish: 'koszykówka (sport)',
    french: 'basketball (sport)',
    spanish: 'baloncesto (deporte)',
  },
  {
    av: 20586,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball + hammer, gavel, mallet)',
    english: 'croquet (sport)',
    swedish: 'krocket (sport)',
    norwegian: 'krokket (sport)',
    finnish: 'kroketti',
    hungarian: 'krokettjáték',
    german: 'Krocketspiel',
    dutch: 'croquet (sport)',
    afrikaans: 'kroukie, croquet (sport)',
    russian: 'крокет (спорт)',
    latvian: 'krikets, sports',
    polish: 'krokiet (sport)',
    french: 'croquet (sport)',
    spanish: 'croquet (deporte)',
  },
  {
    av: 20587,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball field)',
    english: 'bowling (sport)',
    swedish: 'bowling (sport)',
    norwegian: 'bowling (sport)',
    finnish: 'keilailu',
    hungarian: 'tekézés, bowling',
    german: 'Bowling, Kegelsport',
    dutch: 'bowlen',
    afrikaans: 'rolbal (sport)',
    russian: 'боулинг (спорт)',
    latvian: 'boulings (sports)',
    polish: 'gra w kręgle (sport)',
    french: 'bowling (sport)',
    spanish: 'bolos (deporte)',
  },
  {
    av: 20588,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + shuttlecock, birdie (badminton))',
    english: 'badminton (sport)',
    swedish: 'badminton (sport)',
    norwegian: 'badminton (sport)',
    finnish: 'sulkapallo',
    hungarian: 'tollaslabda',
    german: 'Federball, Badminton (Sport)',
    dutch: 'badminton',
    afrikaans: 'pluimbal (sport)',
    russian: 'бадминтон (спорт)',
    latvian: 'bandmintons (sports)',
    polish: 'badminton (sport)',
    french: 'badminton (sport)',
    spanish: 'bádminton (deporte)',
  },
  {
    av: 20589,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball + hand)',
    english: 'handball (sport)',
    swedish: 'handboll (sport)',
    norwegian: 'håndball (sport)',
    finnish: 'käsipallo',
    hungarian: 'kézilabda',
    german: 'Handball (Sport)',
    dutch: 'handbal',
    afrikaans: 'handball (sport)',
    russian: 'гандбол (спорт)',
    latvian: 'rokasbumba, sports',
    polish: 'piłka ręczna (sport)',
    french: 'handball (sport)',
    spanish: 'balonmano (deporte), handball',
  },
  {
    av: 20590,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + sport stick and puck, hockey stick + ice)',
    english: 'ice hockey (sport)',
    swedish: 'ishockey (sport)',
    norwegian: 'ishockey (sport)',
    finnish: 'jääkiekkoilu',
    hungarian: 'jéghoki',
    german: 'Eishockey (Sport)',
    dutch: 'ijshockey',
    afrikaans: 'yshokkie (sport)',
    russian: 'хоккей (спорт)',
    latvian: 'hokejs, sports',
    polish: 'hokej (sport)',
    french: 'hockey sur glace (sport)',
    spanish: 'hockey sobre hielo (deporte)',
  },
  {
    av: 20591,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + sport stick and ball, bandy stick)',
    english: 'field hockey, hockey (sport)',
    swedish: 'landhockey, innebandy',
    norwegian: 'innebandy, landhockey (sport)',
    finnish: 'maahockey, nurmipallo',
    hungarian: 'gyephoki',
    german: 'Feldhockey, Hockey (Sport)',
    dutch: 'hockey',
    afrikaans: 'hokkie (sport)',
    russian: 'хоккей на траве (спорт)',
    latvian: 'lauka hokejs, sports',
    polish: 'hokej na trawie (sport)',
    french: 'hockey sur gazon (sport)',
    spanish: 'campo de hockey, hockey (deporte)',
  },
  {
    av: 20592,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sport + sport stick and ball, bandy stick + container (low): the container below ground representing the golf hole)',
    english: 'golf (sport)',
    swedish: 'golf (sport)',
    norwegian: 'golf (sport)',
    finnish: 'golf',
    hungarian: 'golf',
    german: 'Golf (Sport/Spiel)',
    dutch: 'golf (sport)',
    afrikaans: 'golf (sport)',
    russian: 'гольф (спорт)',
    latvian: 'golfs, sports',
    polish: 'golf (sport)',
    french: 'golf (sport)',
    spanish: 'golf (deporte)',
  },
  {
    av: 20593,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + rugby ball + legs and feet)',
    english: 'rugby, football (N.A.)',
    swedish: 'rugby',
    norwegian: 'rugby (sport)',
    finnish: 'rugby, amerikkalainen jalkapallo',
    hungarian: 'rögbi',
    german: 'Football, Rugby',
    dutch: 'rugby, American football',
    afrikaans: 'rugby, Amerikaanse voetbal (sport)',
    russian: 'регби (спорт)',
    latvian: 'regbijs, sports',
    polish: 'rugby (sport)',
    french: 'rugby, football américain (sport)',
    spanish: 'rugby, fútbol (N.A.)',
  },
  {
    av: 20594,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + to fight + mixture)',
    english: 'wrestling (sport)',
    swedish: 'brottning',
    norwegian: 'bryting (sport)',
    finnish: 'paini',
    hungarian: 'birkózás',
    german: 'Ringen (Sport)',
    dutch: 'worstelen',
    afrikaans: 'stoei (sport)',
    russian: 'борьба',
    latvian: 'cīkstēšanās, cīņa, reslings (sports)',
    polish: 'zapasy (sport)',
    french: 'lutte, catch (sport)',
    spanish: 'lucha (deporte)',
  },
  {
    av: 20595,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + to fight + east + mixture)',
    english: 'judo',
    swedish: 'judo (etc)',
    norwegian: 'judo (sport)',
    finnish: 'judo',
    hungarian: 'cselgáncs, dzsúdó',
    german: 'Judo',
    dutch: 'judo',
    afrikaans: 'judo',
    russian: 'дзюдо (спорт)',
    latvian: 'džudo, sports',
    polish: 'judo, dżudo',
    french: 'judo',
    spanish: 'judo',
  },
  {
    av: 20596,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + to fight + hand)',
    english: 'boxing (sport)',
    swedish: 'boxning (sport)',
    norwegian: 'boksing (sport)',
    finnish: 'nyrkkeily',
    hungarian: 'ökölvívás, boksz',
    german: 'Boxen (Sport)',
    dutch: 'boksen',
    afrikaans: 'boks (sport)',
    russian: 'бокс (спорт)',
    latvian: 'bokss, sports',
    polish: 'boks (sport)',
    french: 'boxe (sport)',
    spanish: 'boxeo (deporte)',
  },
  {
    av: 20597,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + skis)',
    english: 'skiing (sport)',
    swedish: 'skidsport',
    norwegian: 'skisport',
    finnish: 'hiihto',
    hungarian: 'sí, sízés, síelés (mint sportág)',
    german: 'Skifahren (Sport)',
    dutch: 'skisport',
    afrikaans: 'ski (sport)',
    russian: 'лыжный спорт ',
    latvian: 'slēpošana (sports)',
    polish: 'narciarstwo (sport)',
    french: 'ski (sport)',
    spanish: 'esquí (deporte)',
  },
  {
    av: 20598,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + skis)',
    english: 'skiing (activity)',
    swedish: 'skidåkning',
    norwegian: 'stå på ski, skiløping',
    finnish: 'hiihto',
    hungarian: 'sízés, síelés (mint tevékenység)',
    german: 'Skifahren (Aktivität)',
    dutch: 'skiën (activiteit)',
    afrikaans: 'ski (aktiwiteit)',
    russian: 'кататься на лыжах',
    latvian: 'slēpošana (aktivitāte)',
    polish: 'jazda na nartach (aktywność)',
    french: 'ski (activité)',
    spanish: 'esquí (actividad)',
  },
  {
    av: 20600,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + horse)',
    english: 'stable',
    swedish: 'stall',
    norwegian: 'stall',
    finnish: 'talli',
    hungarian: 'istálló',
    german: 'Pferdestall',
    dutch: 'paardenstal',
    afrikaans: 'stal, perdestal',
    russian: 'стойло',
    latvian: 'stallis',
    polish: 'stajnia',
    french: 'écurie',
    spanish: 'establo, caballeriza',
  },
  {
    av: 20601,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cart, carriage + big + horse)',
    english: 'carriage',
    swedish: 'hästvagn, hästkärra',
    norwegian: 'vogn, doning',
    finnish: 'hevoskärryt, hevosrattaat',
    hungarian: 'lovaskocsi',
    german: 'Planwagen, Pferdewagen',
    dutch: 'koets',
    afrikaans: 'koets',
    russian: 'карета',
    latvian: 'kariete',
    polish: 'zaprzęg',
    french: 'calèche, attelage, carrosse, équipage',
    spanish: 'carruaje',
  },
  {
    av: 20605,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group + sport: group which comes together to play a sport)',
    english: 'team (sport)',
    swedish: 'lag (sport)',
    norwegian: 'lag (sport)',
    finnish: 'joukkue',
    hungarian: 'csapat, team (sportban)',
    german: 'Mannschaft, Team (Sport)',
    dutch: 'team, ploeg',
    afrikaans: 'span (sport)',
    russian: 'спортивная команда ',
    latvian: 'komanda, sportā',
    polish: 'zespół drużyna (sport)',
    french: 'équipe (sport)',
    spanish: 'equipo (deporte)',
  },
  {
    av: 20606,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + between)',
    english: 'snack (meal)',
    swedish: 'mellanmål',
    norwegian: 'måltid lite',
    finnish: 'välipala',
    hungarian: 'nasi, snack',
    german: 'Imbiss, Snack, Kleinigkeit zu essen',
    dutch: 'snack, tussendoortje',
    afrikaans: 'happie, tussenhappie (ete)',
    russian: 'перекус, полдник',
    latvian: 'uzkodas',
    polish: 'przekąska (posiłek)',
    french: 'casse-croûte, collation',
    spanish: 'merienda (comida)',
  },
  {
    av: 20770,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(bun (food) + animal (meat [contr.])) Preferred NEW SYNONYM, replacing 14664',
    english: 'hamburger',
    swedish: 'hamburgare',
    norwegian: 'hamburger',
    finnish: 'hampurilainen',
    hungarian: 'hamburger',
    german: 'Hamburger',
    dutch: 'hamburger',
    afrikaans: 'frikkadelbroodjie, hamburger',
    russian: 'гамбургер',
    latvian: 'hamburgers',
    polish: 'hamburger',
    french: 'hamburger',
    spanish: 'hamburguesa',
  },
  {
    av: 20771,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(flavouring + chocolate [contr.] + thing indicator) Preferred NEW SYNONYM, replacing 13173',
    english: 'chocolate flavouring',
    swedish: 'choklad (smaktillsats)',
    norwegian: 'sjokolade (smakstilsetning)',
    finnish: 'suklaa',
    hungarian: 'csokoládé vagy kakaó ízesítés, csokoládé adalék',
    german: 'Kakaopulver, Schokoladenpulver (mit Schokoladengeschmack)',
    dutch: 'chocola',
    afrikaans: 'sjokolade geur',
    russian: 'шоколадный ароматизатор',
    latvian: 'šokolāde',
    polish: 'aromat czekoladowy',
    french: 'arôme de chocolat',
    spanish: 'sabor a chocolate',
  },
  {
    av: 20772,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drink + chocolate [contr.]) Preferred NEW SYNONYM, replacing 13172',
    english: 'chocolate drink',
    swedish: "chokladdryck, O'boy",
    norwegian: 'sjokoladedrikk',
    finnish: 'suklaajuoma, kaakaojuoma',
    hungarian: 'kakaó, kakaóital',
    german: 'Schokoladenmilch, heiße Schokolade, Kakao, Kakaotrunk',
    dutch: 'chocolademelk, chocoladedrank',
    afrikaans: 'sjokolademelk, sjokolade drankie',
    russian: 'какao (напиток)',
    latvian: 'kakao, šokolādes dzēriens',
    polish: 'napój czekoladowy',
    french: 'chocolat, cacao (boisson)',
    spanish: 'batido de chocolate',
  },
  {
    av: 21025,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(religion (God based) + 1 + God: belief that there is only one God)',
    english: 'monotheism',
    swedish: 'monoteism',
    norwegian: 'monoteisme',
    finnish: 'yksijumalaisuus, monoteismi',
    hungarian: 'egyistenhit, monoteizmus',
    german: 'Monotheismus',
    dutch: 'monotheisme',
    afrikaans: 'monoteïsme',
    russian: 'монотеизм (единобожие)',
    latvian: 'monoteisms',
    polish: 'monoteizm',
    french: 'monothéisme',
    spanish: 'monoteísmo',
  },
  {
    av: 21026,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(religion (God based) + many + God: belief in more than one God)',
    english: 'polytheism',
    swedish: 'polyteism',
    norwegian: 'polyteisme',
    finnish: 'monijumalaisuus, polyteismi',
    hungarian: 'többistenhit, politeizmus',
    german: 'Vielgötterei, Polytheismus',
    dutch: 'polytheisme',
    afrikaans: 'politeïsme',
    russian: 'политеизм (многобожие)',
    latvian: 'politeisms',
    polish: 'politeizm',
    french: 'polythéisme',
    spanish: 'politeísmo',
  },
  {
    av: 21027,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(religion (God based) + Christ [contr.]: religion founded on the teachings of Christ)',
    english: 'Christianity',
    swedish: 'kristendom',
    norwegian: 'kristendom',
    finnish: 'kristinusko',
    hungarian: 'kereszténység (mint vallás, hit)',
    german: 'Christentum, Christenheit',
    dutch: 'christendom',
    afrikaans: 'Christendom',
    russian: 'христианство',
    latvian: 'kristietība',
    polish: 'chrześcijaństwo',
    french: 'christianisme, chrétienté',
    spanish: 'cristianismo',
  },
  {
    av: 21028,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(religion (God based) + Star of David: religion of the Jewish people)',
    english: 'Judaism',
    swedish: 'judendom',
    norwegian: 'jødedom',
    finnish: 'juutalaisuus',
    hungarian: 'zsidóság, judaizmus (mint vallás, hit)',
    german: 'Judentum',
    dutch: 'jodendom',
    afrikaans: 'Judaïsme',
    russian: 'иудаизм',
    latvian: 'jūdaisms',
    polish: 'Judaizm',
    french: 'judaïsme',
    spanish: 'judaísmo',
  },
  {
    av: 21029,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(religion (God based) + Muslim: religion based on the teaching of the prophet Muhammed)',
    english: 'Islam',
    swedish: 'islam',
    norwegian: 'islam',
    finnish: 'islam',
    hungarian: 'mohamedán vallás, iszlám vallás ',
    german: 'Islam',
    dutch: 'islam',
    afrikaans: 'Islam',
    russian: 'ислам',
    latvian: 'islāms',
    polish: 'islam',
    french: 'islam',
    spanish: 'el Islam',
  },
  {
    av: 21030,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(Christianity + east: group of churches, including Greek and Russian Orthodox)',
    english: 'Eastern Orthodox Church',
    swedish: 'ortodoxa kyrkan',
    norwegian: 'Gresk- og Russiskortodoks kirke',
    finnish: 'ortodoksisuus',
    hungarian: 'keleti ortodox vallás',
    german: 'Orthodoxe Kirche',
    dutch: 'orthodoxe kerk (Oosters)',
    afrikaans: 'Oos-Ortodokse kerk',
    russian: 'ортодоксальная церковь',
    latvian: 'Austrumu ortodoksālā baznīca, pareizticība',
    polish: 'cerkiew, kościół prawosławny',
    french: 'Eglise orthodoxe orientale',
    spanish: 'Iglesia ortodoxa oriental',
  },
  {
    av: 21031,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + Christianity [contr.])',
    english: 'Christian (person)',
    swedish: 'kristen (person)',
    norwegian: 'kristen (person)',
    finnish: 'kristitty',
    hungarian: 'keresztény (ember, személy)',
    german: 'christlich',
    dutch: 'christen',
    afrikaans: 'Christen (persoon)',
    russian: 'христианин',
    latvian: 'kristietis, kristiete',
    polish: 'chrześcijanin',
    french: 'chrétien (personne)',
    spanish: 'cristiano (persona)',
  },
  {
    av: 21032,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + Star of David)',
    english: 'Jew',
    swedish: 'jude',
    norwegian: 'jøde',
    finnish: 'juutalainen',
    hungarian: 'zsidó (ember, személy)',
    german: 'Jude, Jüdin',
    dutch: 'Jood',
    afrikaans: 'Jood',
    russian: 'иудей',
    latvian: 'ebrejs, jūds',
    polish: 'Hebrajczyk, Żyd',
    french: 'juif (personne)',
    spanish: 'judío',
  },
  {
    av: 21033,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + Muslim)',
    english: 'Muslim, Moslem',
    swedish: 'muslim',
    norwegian: 'muslim',
    finnish: 'muslimi',
    hungarian: 'mohamedán vagy muszlim (ember, személy)',
    german: 'Muslim, Muslimin',
    dutch: 'moslim',
    afrikaans: 'Moslem',
    russian: 'мусульманин',
    latvian: 'musulmanis',
    polish: 'muzułmanin',
    french: 'musulman',
    spanish: 'musulmán',
  },
  {
    av: 21034,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + Islam: founder of Islam)',
    english: 'Muhammad, Mohammed, Muhammed',
    swedish: 'Mohammed',
    norwegian: 'Muhammed',
    finnish: 'Muhammed',
    hungarian: 'Mohamed',
    german: 'Mohammed',
    dutch: 'Mohammed',
    afrikaans: 'Mohammed',
    russian: 'пророк Мухаммед',
    latvian: 'Muhameds',
    polish: 'Mahomet',
    french: 'Mahomet',
    spanish: 'Mohamed',
  },
  {
    av: 21035,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(God + ALLAH)',
    english: 'Allah',
    swedish: 'Allah',
    norwegian: 'Allah',
    finnish: 'Allah',
    hungarian: 'Allah',
    german: 'Allah',
    dutch: 'Allah',
    afrikaans: 'Allah',
    russian: 'Аллах',
    latvian: 'Allahs',
    polish: 'Bóg Allah',
    french: 'Allah',
    spanish: 'Alá',
  },
  {
    av: 21037,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + Christian: the Vatican is the seat of papal government)',
    english: 'Vatican, Vatican City',
    swedish: 'Vatikanen, Vatikanstaten',
    norwegian: 'Vatikanet, Vatikanstaten',
    finnish: 'Vatikaani',
    hungarian: 'Vatikán, Vatikán Város',
    german: 'Vatikanstaat',
    dutch: 'Vaticaanstad',
    afrikaans: 'Vatikaanstad',
    russian: 'Ватикан',
    latvian: 'Vatikāns, Vatikāna valsts',
    polish: 'Watykan',
    french: 'Vatican, Cité du Vatican',
    spanish: 'Vaticano, ciudad del Vaticano',
  },
  {
    av: 21038,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(religion + Vatican: the doctrines, practices and organization of the Roman Catholic Church)',
    english: 'Roman Catholicism, Roman Catholic Church',
    swedish: 'katolicism (romersk)',
    norwegian: 'katolisisme',
    finnish: 'roomalaiskatolisuus',
    hungarian: 'katolicizmus; római katolikus egyház',
    german: 'Römisch Katholische Kirche',
    dutch: 'rooms-katholicisme',
    afrikaans: 'Rooms-Katolisisme, Rooms-Katolieke kerk',
    russian: 'католицизм',
    latvian: 'katoļu baznīca, Romas katolicisms',
    polish: 'kościół rzymskokatolicki',
    french: 'Eglise catholique romaine',
    spanish: 'catolicismo romano, Iglesia católica romana',
  },
  {
    av: 21039,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(religion + Christ [contr.] + group: Christian religion, which emphasizes the importance of the congregation)',
    english: 'protestantism',
    swedish: 'protestantism',
    norwegian: 'protestantisme',
    finnish: 'protestanttisuus',
    hungarian: 'protestantizmus',
    german: 'Protestantismus',
    dutch: 'protestantisme',
    afrikaans: 'Protestantisme',
    russian: 'протестанство',
    latvian: 'protestantisms',
    polish: 'protestantyzm',
    french: 'protestantisme',
    spanish: 'protestantismo',
  },
  {
    av: 21041,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(God + description indicator)',
    english: 'divine, holy',
    swedish: 'gudomlig',
    norwegian: 'gudommelig',
    finnish: 'jumalallinen, pyhä',
    hungarian: 'isteni, szent',
    german: 'göttlich, heilig',
    dutch: 'heilig',
    afrikaans: 'heilig, Goddelike',
    russian: 'божественный',
    latvian: 'dievišķais, svētais',
    polish: 'boski, święty',
    french: 'divin, saint',
    spanish: 'divino, sagrado',
  },
  {
    av: 21042,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + sport stick and ball, bandy stick + ice)',
    english: 'bandy (sport)',
    swedish: 'bandy (sport)',
    norwegian: 'bandy (på is) (sport)',
    finnish: 'jääpalloilu',
    hungarian: 'bandy: jéghokira emlékeztető sport',
    german: 'Bandy (Sport)',
    dutch: 'bandy (Scandinavische sport)',
    afrikaans: 'bandy (sport)',
    russian: 'хокей с мячом (спорт)',
    latvian: 'lauka hokejs, lauka hokeja bumba',
    polish: 'bandy – odmiana hokeja (sport)',
    french: 'bandy (hockey avec balle)',
    spanish: 'bandy (deporte)',
  },
  {
    av: 21043,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + God + peace: Jesus Christ - biblical figure)',
    english: 'Messiah',
    swedish: 'Messias',
    norwegian: 'Messias',
    finnish: 'Messias',
    hungarian: 'Messiás',
    german: 'Messisas',
    dutch: 'Messias',
    afrikaans: 'Messias',
    russian: 'Мессия',
    latvian: 'Mesija',
    polish: 'Mesjasz',
    french: 'Messie',
    spanish: 'Mesías',
  },
  {
    av: 21045,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spirit + person: the animating vital principal in man)',
    english: 'soul',
    swedish: 'själ',
    norwegian: 'sjel',
    finnish: 'sielu',
    hungarian: 'lélek',
    german: 'Seele',
    dutch: 'ziel',
    afrikaans: 'siel',
    russian: 'душа',
    latvian: 'dvēsele',
    polish: 'dusza',
    french: 'âme',
    spanish: 'alma',
  },
  {
    av: 21046,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(mother + Christ [contr.]: biblical figure)',
    english: 'Mary (Mother of Christ)',
    swedish: 'Maria, Jesu mor',
    norwegian: 'Maria, Jesus mor',
    finnish: 'Maria, Kristuksen äiti',
    hungarian: 'Szűzmária',
    german: 'Heilige Jungfrau Maria',
    dutch: 'Maria (christelijk), moeder van Jezus',
    afrikaans: 'Maria (Moeder van Jesus)',
    russian: 'Мария (Богородица)',
    latvian: 'Svētā Jaunava Marija, Kristus Māte',
    polish: 'Maryja (matka Jezusa)',
    french: 'Marie (mère du Christ)',
    spanish: 'María (madre de Cristo)',
  },
  {
    av: 21047,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(father + Christ [contr.] + earth: the earthly father of Christ - biblical figure)',
    english: 'Joseph, Saint Joseph',
    swedish: 'Josef',
    norwegian: 'Josef',
    finnish: 'Joosef',
    hungarian: 'Szent József',
    german: 'Joseph (biblisch)',
    dutch: 'Jozef (christelijk)',
    afrikaans: 'Joseph (heilige)',
    russian: 'Иосиф',
    latvian: 'Jāzeps, Svētais Jāzeps',
    polish: 'Święty Józef',
    french: 'Joseph, saint Joseph',
    spanish: 'José, San José',
  },
  {
    av: 21048,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to speak + future: what is said about the future)',
    english: 'prophecy',
    swedish: 'profetsia, spådom',
    norwegian: 'profeti, spådom',
    finnish: 'ennustus',
    hungarian: 'jóslat, jövendölés, prófécia',
    german: 'Prophezeiung',
    dutch: 'profetie',
    afrikaans: 'profesie',
    russian: 'предсказание, гадание',
    latvian: 'pareģojums',
    polish: 'proroctwo, przepowiednia, przewidywanie',
    french: 'prophétie',
    spanish: 'profecía',
  },
  {
    av: 21049,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(prophecy + action indicator)',
    english: 'prophesy-(to)',
    swedish: 'profetera, spå',
    norwegian: 'profetere, spå',
    finnish: 'ennustaa',
    hungarian: 'jósolni, jövendölni, jövőt mondani',
    german: 'prophezeien, weissagen',
    dutch: 'profeteren',
    afrikaans: 'profeseer (om te)',
    russian: 'предсказывать, гадать',
    latvian: 'pareģot',
    polish: 'prorokować, przepowiadać, przewidywać',
    french: 'prophétiser, prédire',
    spanish: 'profetizar',
  },
  {
    av: 21050,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to prophesy)',
    english: 'prophet',
    swedish: 'profet, spåman, spåkvinna',
    norwegian: 'profet, spåmann, spåkvinne',
    finnish: 'profeetta',
    hungarian: 'jós, jövendőmondó, látnok, próféta',
    german: 'Prophet',
    dutch: 'profeet',
    afrikaans: 'profeet',
    russian: 'прорицатель, гадалка',
    latvian: 'pravietis, pareģis',
    polish: 'prorok',
    french: 'prophète',
    spanish: 'profeta',
  },
  {
    av: 21051,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to prophesy + fact + action indicator)',
    english: 'predict-(to)',
    swedish: 'förutsäga',
    norwegian: 'forutsi',
    finnish: 'ennustaa',
    hungarian: 'megjósolni, megjövendölni, előre vetíteni',
    german: 'vorhersagen',
    dutch: 'voorspellen',
    afrikaans: 'voorspel (om te)',
    russian: 'предсказазывать',
    latvian: 'paredzēt',
    polish: 'przewidywać, przepowiadać',
    french: 'prédire',
    spanish: 'predecir',
  },
  {
    av: 21053,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to go + leadership, guidance + action indicator: to go behind a leader) Preferred NEW SYNONYM, replacing 14376',
    english: 'follow-(to)',
    swedish: 'följa, följa efter',
    norwegian: 'følge (å), følge etter',
    finnish: 'seurata',
    hungarian: 'követni, utána menni',
    german: 'folgen',
    dutch: 'volgen',
    afrikaans: 'volg (om te)',
    russian: 'следовать',
    latvian: 'sekot',
    polish: 'iść za, podążać za, naśladować',
    french: 'suivre, poursuivre',
    spanish: 'seguir',
  },
  {
    av: 21055,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(leader + religion)',
    english: 'religious leader',
    swedish: 'religiös ledare',
    norwegian: 'leder religiøs',
    finnish: 'uskonnollinen johtaja',
    hungarian: 'vallási vezető',
    german: 'religiöser Führer',
    dutch: 'religieus leider',
    afrikaans: 'godsdienstige leier',
    russian: 'религиозный лидер',
    latvian: 'reliģiskais vadītājs',
    polish: 'przywódca religijny',
    french: 'chef religieux',
    spanish: 'líder religioso',
  },
  {
    av: 21056,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(leader + Christian)',
    english: 'bishop',
    swedish: 'biskop',
    norwegian: 'biskop',
    finnish: 'piispa',
    hungarian: 'püspök',
    german: 'Bischof, Bischöfin',
    dutch: 'bisschop',
    afrikaans: 'biskop',
    russian: 'епископ, владыка',
    latvian: 'bīskaps',
    polish: 'biskup',
    french: 'évêque',
    spanish: 'obispo',
  },
  {
    av: 21057,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(leader + Vatican: bishop of Rome and leader of the Roman Catholic Church)',
    english: 'Pope',
    swedish: 'påve',
    norwegian: 'pave',
    finnish: 'paavi',
    hungarian: 'pápa',
    german: 'Papst',
    dutch: 'Paus',
    afrikaans: 'Pous',
    russian: 'Папа римский',
    latvian: 'Pāvests',
    polish: 'papież',
    french: 'Pape',
    spanish: 'Papa',
  },
  {
    av: 21058,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(dispersion, dissemination, scattering, spread, spreading + action indicator) See dispersion, dissemination, scattering, spread, spreading 24887',
    english: 'disperse, disseminate, scatter, spread-(to)',
    swedish: 'sprida, skingra (etc)',
    norwegian: 'spre',
    finnish: 'levittää, levitellä, hajottaa',
    hungarian: 'elterjeszteni, szétszórni, elterjedni, elszórni',
    german: 'ausbreiten, verbreiten, ausstreuen',
    dutch: 'verspreiden, verdelen (verspreiden)',
    afrikaans: 'versprei, verdaag (om te)',
    russian: 'распростронять',
    latvian: 'izplatīt',
    polish: 'rozpowszechniać, rozpraszać na różne strony, rozrzucać',
    french: 'diffuser, disséminer, disperser',
    spanish: 'dispersar, diseminar, desparramar',
  },
  {
    av: 21059,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      "(man + past + to disseminate + Christianity [contr.]: one of Christ's 12 disciples, whom he chose to preach the gospel)",
    english: 'apostle',
    swedish: 'apostel, lärjunge',
    norwegian: 'apostel, disippel',
    finnish: 'opetuslapsi, apostoli',
    hungarian: 'apostol',
    german: 'Apostel',
    dutch: 'apostel',
    afrikaans: 'apostel',
    russian: 'апостол',
    latvian: 'Apustulis',
    polish: 'apostoł',
    french: 'apôtre',
    spanish: 'apóstol',
  },
  {
    av: 21060,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to disseminate + religion)',
    english: 'missionary',
    swedish: 'missionär',
    norwegian: 'misjonær',
    finnish: 'lähetyssaarnaaja',
    hungarian: 'misszionárius',
    german: 'Missionar, Missionarin',
    dutch: 'missionaris, zendeling',
    afrikaans: 'sendeling',
    russian: 'миссионер',
    latvian: 'misionārs',
    polish: 'misjonarz',
    french: 'missionnaire',
    spanish: 'misionero',
  },
  {
    av: 21062,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + devil)',
    english: 'hell',
    swedish: 'helvetet',
    norwegian: 'helvete',
    finnish: 'helvetti',
    hungarian: 'pokol',
    german: 'Hölle',
    dutch: 'hel',
    afrikaans: 'hel',
    russian: 'ад',
    latvian: 'elle',
    polish: 'piekło',
    french: 'enfer',
    spanish: 'infierno',
  },
  {
    av: 21063,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + first: the first man on earth - biblical figure)',
    english: 'Adam',
    swedish: 'Adam',
    norwegian: 'Adam',
    finnish: 'Aatami',
    hungarian: 'Ádám',
    german: 'Adam (erster Mann)',
    dutch: 'Adam',
    afrikaans: 'Adam',
    russian: 'Адам',
    latvian: 'Ādams',
    polish: 'Adam',
    french: 'Adam',
    spanish: 'Adán',
  },
  {
    av: 21064,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(woman + first: the first woman on earth - biblical figure)',
    english: 'Eve',
    swedish: 'Eva',
    norwegian: 'Eva',
    finnish: 'Eeva',
    hungarian: 'Éva',
    german: 'Eva (erste Frau, Frau von Adam)',
    dutch: 'Eva',
    afrikaans: 'Eva',
    russian: 'Ева',
    latvian: 'Ieva',
    polish: 'Ewa (pierwsza kobieta)',
    french: 'Eve',
    spanish: 'Eva',
  },
  {
    av: 21065,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + boat + animal: biblical figure)',
    english: 'Noah',
    swedish: 'Noak',
    norwegian: 'Noah',
    finnish: 'Nooa',
    hungarian: 'Noé',
    german: 'Noah',
    dutch: 'Noach',
    afrikaans: 'Noag',
    russian: 'Ной',
    latvian: 'Noass',
    polish: 'Noe',
    french: 'Noé',
    spanish: 'Noé',
  },
  {
    av: 21066,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + multitude + offspring: biblical figure)',
    english: 'Abraham',
    swedish: 'Abraham',
    norwegian: 'Abraham',
    finnish: 'Abraham',
    hungarian: 'Ábrahám',
    german: 'Abraham',
    dutch: 'Abraham',
    afrikaans: 'Abraham',
    russian: 'Абрам',
    latvian: 'Ābrams',
    polish: 'Abraham',
    french: 'Abraham',
    spanish: 'Abraham',
  },
  {
    av: 21067,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + commandments: biblical figure)',
    english: 'Moses',
    swedish: 'Moses',
    norwegian: 'Moses',
    finnish: 'Mooses',
    hungarian: 'Mózes',
    german: 'Moses',
    dutch: 'Mozes',
    afrikaans: 'Moses',
    russian: 'Моисей',
    latvian: 'Mozus',
    polish: 'Mojżesz',
    french: 'Moïse',
    spanish: 'Moisés',
  },
  {
    av: 21068,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + God)',
    english: 'holy book',
    swedish: 'helig bok',
    norwegian: 'hellig bok',
    finnish: 'pyhä kirja',
    hungarian: 'szent könyv',
    german: 'Heiliges Buch',
    dutch: 'heilig boek',
    afrikaans: 'heilige boek',
    russian: 'священная книга',
    latvian: 'Svētie raksti',
    polish: 'Biblia',
    french: 'livre saint',
    spanish: 'libro santo',
  },
  {
    av: 21069,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(holy book + Christian)',
    english: 'Bible (Christian)',
    swedish: 'Bibeln (kristen)',
    norwegian: 'Bibelen (kristen)',
    finnish: 'raamattu',
    hungarian: 'Biblia (keresztény)',
    german: 'Bibel',
    dutch: 'bijbel (christelijk)',
    afrikaans: 'Bybel (Christene)',
    russian: 'Библия',
    latvian: 'Bībele',
    polish: 'Biblia (chrześcijańska)',
    french: 'bible (christianisme)',
    spanish: 'Biblia (cristiana)',
  },
  {
    av: 21070,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(holy book + before + Christ [contr.])',
    english: 'Old Testament',
    swedish: 'Gamla Testamentet',
    norwegian: 'Det Gamle Testamentet',
    finnish: 'vanha testamentti',
    hungarian: 'Ószövetség',
    german: 'Altes Testament',
    dutch: 'Oude Testament',
    afrikaans: 'Ou Testament',
    russian: 'Старый Завет',
    latvian: 'Vecā Derība',
    polish: 'Stary Testament',
    french: 'Ancien Testament',
    spanish: 'Viejo testamento',
  },
  {
    av: 21071,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(holy book + after + Christ [contr.])',
    english: 'New Testament',
    swedish: 'Nya Testamentet',
    norwegian: 'Det Nye Testamentet',
    finnish: 'uusi testamentti',
    hungarian: 'Újszövetség',
    german: 'Neues Testament',
    dutch: 'Nieuwe Testament',
    afrikaans: 'Nuwe Testament',
    russian: 'Новый Завет',
    latvian: 'Jaunā Derība',
    polish: 'Nowy Testament',
    french: 'Nouveau Testament',
    spanish: 'Nuevo Testamento',
  },
  {
    av: 21072,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(holy book + Muslim)',
    english: 'Koran',
    swedish: 'Koranen',
    norwegian: 'Koranen',
    finnish: 'koraani',
    hungarian: 'Korán',
    german: 'Koran, Heiliges Buch (Islam)',
    dutch: 'Koran',
    afrikaans: 'Koran',
    russian: 'Коран',
    latvian: 'Korāns',
    polish: 'Koran',
    french: 'Coran',
    spanish: 'Corán',
  },
  {
    av: 21073,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + song + religion)',
    english: 'hymnal, hymn book',
    swedish: 'psalmbok, sångbok (religiös)',
    norwegian: 'salmebok, sangbok (religiøs)',
    finnish: 'virsikirja',
    hungarian: 'egyházi énekeskönyv',
    german: 'Gesangbuch',
    dutch: 'psalmboek, liedboek',
    afrikaans: 'Psalm en Gesange boek',
    russian: 'Псалтырь',
    latvian: 'Psalmu grāmata',
    polish: 'śpiewnik, książka z psalmami',
    french: 'livre de cantiques',
    spanish: 'himnario, cantoral',
  },
  {
    av: 21074,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(song + religion)',
    english: 'hymn, psalm, gospel song',
    swedish: 'psalm, sång (religiös)',
    norwegian: 'sang religiøs',
    finnish: 'virsi, psalmi, gospel-laulu',
    hungarian: 'zsoltár, goszpel',
    german: 'Kirchenlied, Psalm (religiös)',
    dutch: 'psalm, lied',
    afrikaans: 'gesang, psalm, evangelie lied',
    russian: 'псалом',
    latvian: 'Psalmi, lūgšanu grāmata',
    polish: 'hymn (do Boga), pieśń religijna',
    french: 'hymne, psaume, cantique',
    spanish: 'himno, salmo',
  },
  {
    av: 21075,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + action + religion)',
    english: 'missal, liturgical book',
    swedish: 'mässbok',
    norwegian: 'messebok',
    finnish: 'rukouskirja',
    hungarian: 'misekönyv, szertartáskönyv, liturgikus könyv',
    german: 'Messbuch',
    dutch: 'missaal, gebedenboek',
    afrikaans: 'missaal, liturgiese boek',
    russian: 'богослужебная книга',
    latvian: 'lūgšanu grāmata, liturģijas grāmata',
    polish: 'modlitewnik',
    french: 'missel, livre de prières',
    spanish: 'misal, libro litúrgico',
  },
  {
    av: 21076,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(story + Jesus Christ [contr.])',
    english: 'gospel',
    swedish: 'evangelium',
    norwegian: 'evangelium',
    finnish: 'evankeliumi',
    hungarian: 'evangéliumos könyv',
    german: 'Evangelium',
    dutch: 'evangelie',
    afrikaans: 'evangelie',
    russian: 'Евангелие',
    latvian: 'Evanģelijs',
    polish: 'gospel (muzyka religijna)',
    french: 'évangile',
    spanish: 'evangelio',
  },
  {
    av: 21078,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(beginning + to see: coming into view for the first time)',
    english: 'appearance, manifestation',
    swedish: 'framträdande, syn',
    norwegian: 'tilsynekomst',
    finnish: 'ilmestyminen',
    hungarian: 'kinyilvánítás, megnyilatkozás, manifesztáció',
    german: 'Erscheinung, Offenbarung',
    dutch: 'verschijning',
    afrikaans: 'verskynsel, manifestering',
    russian: 'появление, явление',
    latvian: 'parādīšanās, izpaušanās',
    polish: 'objaw, okazanie, prezentacja, wygląd',
    french: 'apparition, manifestation',
    spanish: 'aparición, manifestación',
  },
  {
    av: 21079,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(appearance + action indicator)',
    english: 'appear-(to)',
    swedish: 'visa sig, synas',
    norwegian: 'vise seg, komme til syne',
    finnish: 'lmestyä',
    hungarian: 'kinyilvánítani, megnyilvánulni ',
    german: 'erscheinen',
    dutch: 'verschijnen',
    afrikaans: 'verskyn, manifisteer (om te)',
    russian: 'являться',
    latvian: 'parādīties, ierasties, uzrasties',
    polish: 'ujawniać, okazywać, prezentować',
    french: 'apparaître',
    spanish: 'aparecer',
  },
  {
    av: 21080,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ending + to see)',
    english: 'disappearance',
    swedish: 'försvinnande',
    norwegian: 'forsvinning',
    finnish: 'katoaminen',
    hungarian: 'eltűnés',
    german: 'Verschwinden',
    dutch: 'verdwijning',
    afrikaans: 'verdwyning',
    russian: 'исчезнoвение',
    latvian: 'pazušana, izzušana',
    polish: 'zniknięcie, zaginięcie',
    french: 'disparition',
    spanish: 'desaparición',
  },
  {
    av: 21081,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(disappearance + action indicator)',
    english: 'disappear-(to)',
    swedish: 'försvinna',
    norwegian: 'forsvinne',
    finnish: 'kadota',
    hungarian: 'eltűnni',
    german: 'verschwinden',
    dutch: 'verdwijnen',
    afrikaans: 'verdwyn (om te)',
    russian: 'исчезать',
    latvian: 'pazust, izzust',
    polish: 'znikać, gubić z pola widzenia',
    french: 'disparaître',
    spanish: 'desaparecer',
  },
  {
    av: 21083,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(holiness + description indicator)',
    english: 'holy',
    swedish: 'helig',
    norwegian: 'hellig',
    finnish: 'pyhä',
    hungarian: 'szent, szentséges',
    german: 'heilig',
    dutch: 'heilig',
    afrikaans: 'heilig',
    russian: 'святой',
    latvian: 'svēts',
    polish: 'święty, święte',
    french: 'saint',
    spanish: 'santo',
  },
  {
    av: 21084,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(holiness + action indicator)',
    english: 'sanctify, consecrate-(to)',
    swedish: 'helga',
    norwegian: 'helliggjøre',
    finnish: 'pyhittää',
    hungarian: 'szentelni, meg/fel/beszentelni, szentesíteni',
    german: 'einsegnen, weihen, heiligen',
    dutch: 'heiligen, inwijden, inzegenen',
    afrikaans: 'heilig, inwy (om te)',
    russian: 'освящять',
    latvian: 'iesvētīt, konsekrēt',
    polish: 'poświęcić, uświęcić (religijne)',
    french: 'sanctifier, consacrer',
    spanish: 'santificar, consagrar',
  },
  {
    av: 21085,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + holy)',
    english: 'saint',
    swedish: 'helgon',
    norwegian: 'helgen',
    finnish: 'pyhimys',
    hungarian: 'szent',
    german: 'Heilige, Heilige',
    dutch: 'heilige',
    afrikaans: 'heilige',
    russian: 'священник',
    latvian: 'svētais',
    polish: 'święty (człowiek)',
    french: 'saint (personne)',
    spanish: 'santo',
  },
  {
    av: 21086,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(infant + holy)',
    english: 'Holy Infant',
    swedish: 'Jesusbarnet',
    norwegian: 'Jesusbarnet',
    finnish: 'pyhä lapsi',
    hungarian: 'a szent gyermek',
    german: 'Heiliges Kind',
    dutch: 'heilig kind, kindje Jezeus',
    afrikaans: 'Heilige kind, Jesus',
    russian: 'младенец Иисус',
    latvian: 'Jēzusbērns',
    polish: 'Dzieciątko Jezus',
    french: 'Enfant saint',
    spanish: 'Niño Jesús',
  },
  {
    av: 21087,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(holiness + life)',
    english: 'sanctity of life',
    swedish: 'livets okränkbarhet',
    norwegian: 'livets ukrenkelighet',
    finnish: 'elämän pyhyys',
    hungarian: 'az élet szentsége',
    german: 'Heiligkeit (des Lebens), Unverletzlichkeit (des Lebens)',
    dutch: 'gewijdheid',
    afrikaans: 'gewydheid',
    russian: 'святое житие',
    latvian: 'svētdzīve, svētdarīšana',
    polish: 'świętość życia',
    french: 'caractère sacré de la vie',
    spanish: 'santidad de la vida',
  },
  {
    av: 21088,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(city + holy)',
    english: 'Holy City',
    swedish: 'helig stad (Jerusalem etc)',
    norwegian: 'den hellige by (Jerusalem)',
    finnish: 'pyhä kaupunki',
    hungarian: 'Szent Város',
    german: 'Heilige Stadt (Jerusalem)',
    dutch: 'heilige stad',
    afrikaans: 'Heilige Stad',
    russian: 'святое место (Иерусалим и др.)',
    latvian: 'Svētā pilsēta, Jeruzāleme',
    polish: 'święte miasto',
    french: 'ville sainte',
    spanish: 'Ciudad Santa',
  },
  {
    av: 21089,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(family + holy)',
    english: 'Holy Family',
    swedish: 'heliga familjen',
    norwegian: 'den hellige familie',
    finnish: 'pyhä perhe',
    hungarian: 'szentcsalád',
    german: 'Heilige Familie',
    dutch: 'Heilige familie',
    afrikaans: 'Heilige Familie',
    russian: 'святое семейство',
    latvian: 'Svētā Ģimene',
    polish: 'Święta Rodzina',
    french: 'Sainte-Famille',
    spanish: 'Sagrada Familia',
  },
  {
    av: 21094,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(group of + family: family consisting of members of a group home)',
    english: 'family (group home)',
    swedish: 'storfamilj, familj i gruppbostad',
    norwegian: 'bokollektiv, bofellesskap, storfamilie',
    finnish: 'ryhmäkotiperhe',
    hungarian: 'csoportotthon',
    german: 'Wohnheim',
    dutch: 'woongroep, leefgroep',
    afrikaans: 'familie (groeps huis)',
    russian: 'семейство, род',
    latvian: 'ģimeņu grupu māja',
    polish:
      'rodzina jako grupa rodzinna (osoby mieszkające razem współdzielące wydatki i obowiązki)',
    french: 'groupe de résidents',
    spanish: 'familia (grupo, hogar)',
  },
  {
    av: 21095,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + religion)',
    english: 'religious event',
    swedish: 'religiös händelse',
    norwegian: 'hendelse religiøs',
    finnish: 'uskonnollinen tapahtuma',
    hungarian: 'vallási esemény',
    german: 'religiöses Ereignis',
    dutch: 'religieuze gebeurtenis',
    afrikaans: 'heilige, godsdienstige gebeure',
    russian: 'религиозное событие',
    latvian: 'reliģisks notikums',
    polish: 'wydarzenie religijne',
    french: 'événement religieux',
    spanish: 'evento religioso',
  },
  {
    av: 21096,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(event + plan: event which consists of an act or a set of acts which follow a plan)',
    english: 'ceremony',
    swedish: 'ceremoni',
    norwegian: 'seremoni',
    finnish: 'seremonia, juhlamenot',
    hungarian: 'szertartás, ceremónia',
    german: 'Zeremonie, Festlichkeit',
    dutch: 'ceremonie',
    afrikaans: 'seremonie',
    russian: 'церемония',
    latvian: 'ceremonija',
    polish: 'ceremonia',
    french: 'cérémonie',
    spanish: 'ceremonia',
  },
  {
    av: 21097,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to reflect + spirit + action indicator:to think and reflect within the spirit)',
    english: 'meditate-(to)',
    swedish: 'meditera',
    norwegian: 'meditere',
    finnish: 'meditoida, mietiskellä',
    hungarian: 'elmélkedni, meditálni',
    german: 'meditieren',
    dutch: 'mediteren',
    afrikaans: 'mediteer (om te)',
    russian: 'медитация',
    latvian: 'meditācija',
    polish: 'medytować',
    french: 'méditer, réfléchir, songer',
    spanish: 'meditar',
  },
  {
    av: 21099,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to speak + guilty)',
    english: 'confess-(to)',
    swedish: 'bekänna, erkänna',
    norwegian: 'bekjenne',
    finnish: 'tunnustaa',
    hungarian: 'beismerni, meg/bevallani, meg/gyónni',
    german: 'gestehen, zugeben',
    dutch: 'bekennen',
    afrikaans: 'bely (om te)',
    russian: 'исповедоваться',
    latvian: 'nožēlot, izsūdzēt grēkus',
    polish: 'przyznać się do czegoś, wyznać',
    french: 'avouer',
    spanish: 'confesar',
  },
  {
    av: 21100,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + Christian [contr.])',
    english: 'Christian event',
    swedish: 'kristen händelse',
    norwegian: 'hendelse kristen',
    finnish: 'kristillinen tapahtuma',
    hungarian: 'keresztény esemény, történés',
    german: '(christliches) Ereignis',
    dutch: 'christelijke gebeurtenis',
    afrikaans: 'Christelike gebeurtenis',
    russian: 'христианское событие',
    latvian: 'kristīgs notikums',
    polish: 'wydarzenie chrześcijańskie',
    french: 'événement chrétien',
    spanish: 'evento cristiano',
  },
  {
    av: 21101,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + holy)',
    english: 'holy event',
    swedish: 'helig händelse',
    norwegian: 'hendelse hellig',
    finnish: 'pyhä tapahtuma',
    hungarian: 'szent esemény, történés',
    german: '(geistliches) Ereignis, (heiliges) Ereignis',
    dutch: 'heilige gebeurtenis',
    afrikaans: 'heilige gebeurtenis',
    russian: 'святое событие ',
    latvian: 'svēts notikums',
    polish: 'święte wydarzenie',
    french: 'événement saint',
    spanish: 'evento santo',
  },
  {
    av: 21102,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(Christian event + holy)',
    english: 'sacrament',
    swedish: 'sakrament',
    norwegian: 'sakrament',
    finnish: 'sakramentti',
    hungarian: 'szentség, szakramentum',
    german: 'Sakrament',
    dutch: 'sacrament',
    afrikaans: 'sakrament',
    russian: 'таинство',
    latvian: 'sakraments',
    polish: 'sakrament',
    french: 'sacrement',
    spanish: 'sacramento',
  },
  {
    av: 21103,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sacrament + water)',
    english: 'sacrament of baptism',
    swedish: 'dopet (som sakrament)',
    norwegian: 'dåp (som sakrament)',
    finnish: 'kaste',
    hungarian: 'a keresztelés szentsége',
    german: 'Taufe (als Sakrament)',
    dutch: 'doopsel',
    afrikaans: 'sakrament van die doop',
    russian: 'таинство крещения',
    latvian: 'kristības sakraments',
    polish: 'chrzest (sakrament)',
    french: 'sacrement du baptême, baptême (sacrement)',
    spanish: 'sacramento del bautismo',
  },
  {
    av: 21104,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sacrament + fire: Christian sacrament in commemoration of the flame of the Holy Spirit)',
    english: 'sacrament of confirmation',
    swedish: 'konfirmationen (som sakrament)',
    norwegian: 'konfirmasjon (som sakrament)',
    finnish: 'konfirmaatio',
    hungarian: 'a bérmálás szentsége, konfirmáció',
    german: 'Konfirmation (als Sakrament)',
    dutch: 'vormsel',
    afrikaans: 'sakrament van bevestiging',
    russian: 'таинство миропомазания ',
    latvian: 'iesvētes sakraments',
    polish: 'bierzmowanie (sakrament)',
    french: 'sacrement de confirmation',
    spanish: 'sacramento de la confirmación',
  },
  {
    av: 21105,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sacrament + food: Christian sacrament in which consecrated bread and wine are partaken of)',
    english: 'sacrament of communion',
    swedish: 'nattvarden (som sakrament)',
    norwegian: 'nattverd (som sakrament)',
    finnish: 'ehtoollinen',
    hungarian: 'az áldozás szentsége, Úrvacsora',
    german: 'Kommunion',
    dutch: 'communie',
    afrikaans: 'sakrament van die nagmaal',
    russian: 'таинство причащения',
    latvian: 'komunījas, Svētā Vakarēdiena sakraments',
    polish: 'komunia (sakrament)',
    french: 'sacrement de communion, eucharistie',
    spanish: 'sacramento de la comunión',
  },
  {
    av: 21106,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sacrament + to forgive)',
    english: 'sacrament of absolution',
    swedish: 'förlåtelsen (som sakrament)',
    norwegian: 'skriftemål (som sakrament)',
    finnish: 'synninpäästö',
    hungarian: 'a feloldozás/bűnbocsánat szentsége',
    german: '(Sakrament der) Absolution',
    dutch: 'biecht',
    afrikaans: 'sakrament van absolusie',
    russian: 'таинство отпущения грехов',
    latvian: 'grēkatlaides sakraments',
    polish: 'odpuszczenie grzechów (sakrament)',
    french: "sacrement de l'absolution",
    spanish: 'sacramento de la absolución',
  },
  {
    av: 21107,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sacrament + person + belongs to + God)',
    english: 'sacrament of holy orders',
    swedish: 'prästvigning, biskopsvigning (som sakrament)',
    norwegian: 'vigsling (som sakrament)',
    finnish: 'pappeuden sakramentti',
    hungarian: 'a felszentelés, a pappá szentelés szentsége',
    german: 'Ordinationsritus',
    dutch: 'priesterwijding',
    afrikaans: 'sakrament van die heilige bestellings',
    russian: 'таинство рукоположения',
    latvian: 'ordinācijas sakraments',
    polish: 'kapłaństwo (sakrament)',
    french: "sacrement de l'ordination sacerdotale",
    spanish: 'sacramento de la ordenación',
  },
  {
    av: 21108,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sacrament + marriage)',
    english: 'sacrament of marriage',
    swedish: 'äktenskapet (som sakrament)',
    norwegian: 'ekteskap (som sakrament)',
    finnish: 'avioliiton sakramentti',
    hungarian: 'a házasság szentsége',
    german: 'Ehesakrament',
    dutch: 'huwelijkssacrament',
    afrikaans: 'sakrament van die huwelik',
    russian: 'таинство венчания',
    latvian: 'laulības sakraments',
    polish: 'małżeństwo (sakrament)',
    french: 'sacrement du mariage',
    spanish: 'sacramento del matrimonio',
  },
  {
    av: 21109,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sacrament + oil + illness)',
    english: 'sacrament of anointment of sick',
    swedish: 'sista smörjelsen (som sakrament)',
    norwegian: 'siste olje (som sakrament)',
    finnish: 'sairaanvoitelun sakramentti',
    hungarian: 'az utolsó kenet szentsége',
    german: 'Heilige Sakramente',
    dutch: 'ziekenzalving',
    afrikaans: 'sakrament van salwing van siekes',
    russian: 'таинство помазания больных',
    latvian: 'iesvaidīšanas sakraments',
    polish: 'namaszczenie chorych (sakrament)',
    french: 'sacrement des malades, onction des malades',
    spanish: 'sacramento de la extremaunción',
  },
  {
    av: 21110,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(religious ceremony + knowledge)',
    english: 'confirmation',
    swedish: 'konfirmation (som ceremoni)',
    norwegian: 'konfirmasjon (som seremoni)',
    finnish: 'konfirmaatio',
    hungarian: 'bérmálás',
    german: 'Konfirmation',
    dutch: 'belijdenis',
    afrikaans: 'bevestiging',
    russian: 'миропомазание (обряд)',
    latvian: 'iesvētīšana, konfirmācija',
    polish: 'bierzmowanie, potwierdzenie wiary',
    french: 'confirmation (religieuse)',
    spanish: 'confirmación',
  },
  {
    av: 21111,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(religious ceremony + of + woman: religious ceremony that recognizes a Jewish girl as a woman)',
    english: 'bat mitzvah (Hebrew)',
    swedish: 'bat mitzvah (Israel)',
    norwegian: 'bat mitzvah (hebraisk) (hunkjønn)',
    finnish: 'bat mitzvah',
    hungarian: 'Bat Mitzva (héber)',
    german: 'Bat Mitzvah',
    dutch: 'bat mitzvah',
    afrikaans: 'bat mitzvah (Hebrew)',
    russian: 'бат-мицва(Израиль)',
    latvian: 'bat mitzvan, meiteņu iesvētīšanas cermonija (Izraēla)',
    polish: 'Bat Micwa (hebr.)',
    french: "bat mitsvah (fête juive de passage à l'âge adulte pour les filles)",
    spanish: 'bat mitzvah (hebreo)',
  },
  {
    av: 21112,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(religious ceremony + of + man: religious ceremony that recognizes a Jewish boy as a man)',
    english: 'bar mitzvah (Hebrew)',
    swedish: 'bar mitzvah (Israel)',
    norwegian: 'bar mitzvah (hebraisk) (hankjønn)',
    finnish: 'bar mitzvah',
    hungarian: 'Bar Mitzvah (héber)',
    german: 'Bar Mitzvah',
    dutch: 'bar mitzvah (Joods)',
    afrikaans: 'bar mitzvah (Hebrew)',
    russian: 'бат-мицва(Израиль)',
    latvian: 'bar mitzvan, zēnu iesvētīšanas ceremonija (Izraēla)',
    polish: 'Bar Micwa (heb..)',
    french: "bar mitsvah (fête juive de passage à l'âge adulte pour les garçons)",
    spanish: 'bar mitzvah (hebreo)',
  },
  {
    av: 21113,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(religious ceremony + circumcision: religious procedure performed on male babies)',
    english: 'circumcision ceremony',
    swedish: 'omskärelseceremoni',
    norwegian: 'omskjærelsesseremoni',
    finnish: 'ympärileikkausseremonia',
    hungarian: 'a körülmetélés szertartása',
    german: 'Beschneidungszeremonie',
    dutch: 'besnijdenisceremonie',
    afrikaans: 'besnydenis seremonie',
    russian: 'обряд обрезания',
    latvian: 'apgraizīšanas ceremonija',
    polish: 'ceremonia obrzezania',
    french: 'cérémonie de la circoncision',
    spanish: 'ceremonia de la circuncisión',
  },
  {
    av: 21117,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + coffin: building in which coffins or tombs are placed)',
    english: 'mausoleum',
    swedish: 'mausoleum',
    norwegian: 'mausoleum',
    finnish: 'mausoleumi',
    hungarian: 'mauzóleum',
    german: 'Mausoleum',
    dutch: 'mausoleum',
    afrikaans: 'mausoleum',
    russian: 'мавзолей',
    latvian: 'mauzolejs',
    polish: 'mauzoleum',
    french: 'mausolée',
    spanish: 'mausoleo',
  },
  {
    av: 21118,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to scatter + ashes + action indicator)',
    english: 'scatter ashes-(to)',
    swedish: 'strö ut aska',
    norwegian: 'spre aske',
    finnish: 'levittää tuhka',
    hungarian: 'szétszórni a hamvakat',
    german: '(Asche) verstreuen',
    dutch: 'asuitstrooiing',
    afrikaans: 'strooi as (om te)',
    russian: 'развеевать прах',
    latvian: 'izbērt pelnus',
    polish: 'rozrzucać prochy',
    french: 'disperser les cendres (funéraires)',
    spanish: 'esparcir cenizas',
  },
  {
    av: 21281,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vase + ashes: burial urn)',
    english: 'urn',
    swedish: 'urna',
    norwegian: 'urne',
    finnish: 'uurna',
    hungarian: 'urna',
    german: 'Urne',
    dutch: 'urn',
    afrikaans: 'vaas',
    russian: 'урна для праха',
    latvian: 'pelnu urna',
    polish: 'urna',
    french: 'urne funéraire',
    spanish: 'urna',
  },
  {
    av: 21283,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + coffin)',
    english: 'tomb',
    swedish: 'grav, gravplats',
    norwegian: 'grav, gravsted',
    finnish: 'hauta',
    hungarian: 'sír (főnév)',
    german: 'Grab',
    dutch: 'begraafplaats',
    afrikaans: 'graf',
    russian: 'могила, захоронение',
    latvian: 'kaps',
    polish: 'grób',
    french: 'tombe, tombeau',
    spanish: 'tumba',
  },
  {
    av: 21284,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(stone + grave)',
    english: 'tombstone',
    swedish: 'gravsten',
    norwegian: 'gravsten',
    finnish: 'hautakivi',
    hungarian: 'sírkő',
    german: 'Grabstein',
    dutch: 'grafsteen',
    afrikaans: 'grafsteen',
    russian: 'надгробная плита',
    latvian: 'kapakmens',
    polish: 'nagrobek',
    french: 'pierre tombale',
    spanish: 'lápida sepulcral',
  },
  {
    av: 21285,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fire + death: death representing a dead person [contr.])',
    english: 'cremation',
    swedish: 'kremering',
    norwegian: 'kremasjon',
    finnish: 'polttohautaus',
    hungarian: 'hamvasztás, elhamvasztás, halotthamvasztás',
    german: 'Einäscherung, Feuerbestattung',
    dutch: 'crematie',
    afrikaans: 'verassing',
    russian: 'кремация',
    latvian: 'krematorija',
    polish: 'kremacja, spopielenie',
    french: 'incinération',
    spanish: 'cremación',
  },
  {
    av: 21286,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(cremation + action indicator)',
    english: 'cremate-(to)',
    swedish: 'kremera',
    norwegian: 'kremere',
    finnish: 'polttohaudata, tuhkata',
    hungarian: 'hamvasztani, elhamvasztani',
    german: 'einäschern',
    dutch: 'cremeren',
    afrikaans: 'veras (om te)',
    russian: 'кремироваать',
    latvian: 'kremēt',
    polish: 'skremować, spopielić',
    french: 'incinérer',
    spanish: 'cremar',
  },
  {
    av: 21287,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(party + intensity: lively or boisterous gathering)',
    english: 'revelry, revel',
    swedish: 'fest, party',
    norwegian: 'fest, kalas',
    finnish: 'juhlinta, rellestys',
    hungarian: 'mulatozás, mulatság, dáridó, tivornya',
    german: '(wüstes) Gelage, Prasserei, ausgelassene Lustbarkeit',
    dutch: 'festival',
    afrikaans: 'joligheid',
    russian: 'вечеринка, банкет',
    latvian: 'dzīres, līksmība',
    polish: 'zabawa w dużym gronie, popijawa, huczne przyjęcie towarzyskie',
    french: 'festivités, réjouissances',
    spanish: 'jolgorio',
  },
  {
    av: 21288,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gathering + religion)',
    english: 'religious gathering',
    swedish: 'gudstjänst, möte (religiöst)',
    norwegian: 'gudstjeneste, møte religiøst',
    finnish: 'uskonnollinen kokoontuminen',
    hungarian: 'vallásos vagy vallási összejövetel',
    german: '(religiöse) Zusammenkunft',
    dutch: 'religieuze bijeenkomst',
    afrikaans: 'godsdienstige byeenkoms',
    russian: 'религиозное собрание',
    latvian: 'reliģika sanāksme',
    polish: 'spotkanie modlitewne, zgromadzenie religijne',
    french: 'assemblée religieuse',
    spanish: 'reunión religiosa',
  },
  {
    av: 21289,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(bad + intensity + description indicator)',
    english: 'awful, dreadful, terrible',
    swedish: 'hemsk, förfärlig',
    norwegian: 'forferdelig',
    finnish: 'kauhea',
    hungarian: 'borzalmas, borzasztó, rémes, szörnyű',
    german: 'schrecklich, furchtbar, fürchterlich',
    dutch: 'vreselijk, verschrikkelijk',
    afrikaans: 'vreeslik, verskriklik',
    russian: 'ужасный',
    latvian: 'drausmīgs, šausmīgs',
    polish: 'okropny',
    french: 'affreux, horrible',
    spanish: 'horrible',
  },
  {
    av: 21290,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + happy + purpose: event to mark a special occasion)',
    english: 'celebration',
    swedish: 'firande',
    norwegian: 'feiring',
    finnish: 'juhlinta',
    hungarian: 'ünneplés, valami megünneplése ',
    german: 'Feier, Fest',
    dutch: 'viering',
    afrikaans: 'viering',
    russian: 'празднование',
    latvian: 'svinības',
    polish: 'uroczystość',
    french: 'célébration',
    spanish: 'celebración',
  },
  {
    av: 21291,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(celebration + life)',
    english: 'celebration of life',
    swedish: 'firande av livet',
    norwegian: 'feire livet',
    finnish: 'elämänjuhla',
    hungarian: 'az élet ünneplése',
    german: 'Celebration of Life, Wir feiern das Leben (spirituelle Veranstaltung)',
    dutch: 'viering van het leven',
    afrikaans: 'viering van die lewe',
    russian: 'празднование жизни',
    latvian: 'dzīves svinēšana',
    polish: 'celebracja życia',
    french: 'célébration (de vie)',
    spanish: 'celebración de la vida',
  },
  {
    av: 21292,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to forgive + God)',
    english: 'misericordia (forgiveness from God)',
    swedish: 'förbarmande, Guds förlåtelse',
    norwegian: 'tilgivelse, Guds tilgivelse',
    finnish: 'anteeksianto Jumalalta',
    hungarian: 'isteni bocsánat, megbocsátás',
    german: 'Vergebung (von Gott)',
    dutch: 'vergiffenis door god',
    afrikaans: 'misericordia (vergifnis van God)',
    russian: 'милосердие, Божье прощение',
    latvian: 'nožēlošana, Dieva žēlastības saņemšana',
    polish: 'przebaczenie, odpuszczenie grzechów',
    french: 'pardon (de Dieu), miséricorde',
    spanish: 'misericordia (perdón de Dios)',
  },
  {
    av: 21293,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(permission, allowance (moral) + after: giving moral permission for a misdeed after it is done)',
    english: 'forgiveness, pardon',
    swedish: 'förlåtelse',
    norwegian: 'tilgivelse',
    finnish: 'anteeksianto, armahdus',
    hungarian: 'megbocsájtás (vallási értelemben)',
    german: 'Vergebung',
    dutch: 'vergiffenis',
    afrikaans: 'vergifnis, verskoon',
    russian: 'прощение',
    latvian: 'piedošana',
    polish: 'wybaczenie, przebaczenie',
    french: 'pardon',
    spanish: 'perdón',
  },
  {
    av: 21294,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + forgiveness + description indicator)',
    english: 'unforgivable, inexcusable',
    swedish: 'oförlåtlig',
    norwegian: 'uforsonet',
    finnish: 'anteeksiantamaton',
    hungarian: 'megbocsáthatatlan',
    german: 'unverzeihlich',
    dutch: 'onvergeeflijk',
    afrikaans: 'onvergeeflik, onverskoonbaar',
    russian: 'непростительный',
    latvian: 'nepiedodams',
    polish: 'niewybaczalne',
    french: 'impardonnable',
    spanish: 'imperdonable',
  },
  {
    av: 21295,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(week + to mourn)',
    english: 'shiva (Judaism)',
    swedish: 'shiva (Israel)',
    norwegian: 'shiva (Israel)',
    finnish: 'shiva',
    hungarian: 'siva (héber)',
    german: 'Shiva (Jüdischer Feiertag)',
    dutch: 'shiva (Joods)',
    afrikaans: 'shiva (Joods)',
    russian: 'Шива (Семь дней траура, Израиль)',
    latvian: 'Šiva, sērošanas periods jūdaismā',
    polish: 'sziwa (hebr. żałoba)',
    french: 'shiva (judaïsme)',
    spanish: 'shiva (judaísmo)',
  },
  {
    av: 21296,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(sadness + loss + action indicator: to feel sadness or grief after a loss)',
    english: 'mourn-(to)',
    swedish: 'sörja, sakna',
    norwegian: 'sørge, savne',
    finnish: 'surra, murehtia',
    hungarian: 'gyászolni, meggyászolni, gyászban lenni',
    german: 'trauern',
    dutch: 'rouwen',
    afrikaans: 'rou (om te)',
    russian: 'горе, скорбь',
    latvian: 'sērot',
    polish: 'opłakiwać, żałować straty',
    french: 'être en deuil',
    spanish: 'lamentar, llorar',
  },
  {
    av: 21298,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(mystery + description indicator)',
    english: 'mysterious, unknown',
    swedish: 'okänd, gåtfull, mystisk, oförklarlig',
    norwegian: 'mystisk, uforklarlig, gåtefullt',
    finnish: 'mystinen, tuntematon',
    hungarian: 'rejtélyes, titokzatos, ismeretlen',
    german: 'mysteriös',
    dutch: 'mysterieus',
    afrikaans: 'geheimsinnig, raaisel, onbekende, mysterieus',
    russian: 'таинственный, загадочный',
    latvian: 'noslēpumains, nezināms',
    polish: 'tajemniczy',
    french: 'mystérieux',
    spanish: 'misterioso, desconocido',
  },
  {
    av: 21299,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(supernatural + positive: something positive which cannot be explained by laws of nature)',
    english: 'miracle',
    swedish: 'mirakel, under',
    norwegian: 'mirakel',
    finnish: 'ihme',
    hungarian: 'csoda',
    german: 'Wunder',
    dutch: 'wonder, mirakel',
    afrikaans: 'wonderwerk',
    russian: 'чудо',
    latvian: 'brīnums',
    polish: 'cud',
    french: 'miracle',
    spanish: 'milagro',
  },
  {
    av: 21300,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + supernatural + to see)',
    english: 'vision, apparition',
    swedish: 'vision, uppenbarelse',
    norwegian: 'åpenbaring, tilsynekomst, syn',
    finnish: 'ilmestys, näky, visio',
    hungarian: 'jelenés, vízió',
    german: 'Vision, Erscheinung',
    dutch: 'visioen, verschijning',
    afrikaans: 'visioen, verskynsel',
    russian: 'видение',
    latvian: 'vīzija, parādība',
    polish: 'wizja, objawienie',
    french: 'vision, apparition',
    spanish: 'visión, aparición',
  },
  {
    av: 21301,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + belief + God: disbelief or denial of existence of God)',
    english: 'atheism',
    swedish: 'ateism',
    norwegian: 'ateisme',
    finnish: 'ateismi',
    hungarian: 'ateizmus, istentagadás',
    german: 'Atheismus',
    dutch: 'atheïsme',
    afrikaans: 'ateïsme',
    russian: 'атеизм',
    latvian: 'ateisms',
    polish: 'ateizm',
    french: 'athéisme',
    spanish: 'ateísmo',
  },
  {
    av: 21302,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(belief + Christian)',
    english: 'Christian faith',
    swedish: 'tro (kristen)',
    norwegian: 'tro (kristen)',
    finnish: 'kristillinen usko',
    hungarian: 'keresztény hit',
    german: '(christlicher) Glaube',
    dutch: 'christelijk geloof',
    afrikaans: 'Christelike (geloof)',
    russian: 'христианская вера',
    latvian: 'kristīgā ticība',
    polish: 'wiara chrześcijańska',
    french: 'foi chrétienne',
    spanish: 'fé cristiana',
  },
  {
    av: 21303,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hope + Christian)',
    english: 'Christian hope',
    swedish: 'hopp (kristet)',
    norwegian: 'håp (kristent)',
    finnish: 'kristillinen toivo',
    hungarian: 'keresztény remény',
    german: '(christliche) Hoffnung',
    dutch: 'christelijke hoop',
    afrikaans: 'Christelike hoop',
    russian: 'христианская надежда',
    latvian: 'kristīgā cerība',
    polish: 'nadzieja chrześcijańska',
    french: 'Espérance chrétienne',
    spanish: 'esperanza cristiana',
  },
  {
    av: 21304,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(love + Christian)',
    english: 'Christian love',
    swedish: 'kärlek (kristen)',
    norwegian: 'kjærlighet (kristen)',
    finnish: 'kristillinen rakkaus',
    hungarian: 'keresztény szeretet',
    german: '(christliche) Liebe',
    dutch: 'christelijke liefde',
    afrikaans: 'Christelike liefde',
    russian: 'христианская любовь',
    latvian: 'kristīgā mīlestība',
    polish: 'miłość chrześcijańska',
    french: 'amour chrétien',
    spanish: 'amor cristiano',
  },
  {
    av: 21305,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(charity + Christian)',
    english: 'Christian charity',
    swedish: 'välgörenhet (kristen)',
    norwegian: 'veldedighet (kristen)',
    finnish: 'kristillinen hyväntekeväisyys',
    hungarian: 'keresztény jótékonyság',
    german: '(christliche) Barmherzigkeit',
    dutch: 'christelijke naastenliefde',
    afrikaans: 'Christelike liefde omgee bystand',
    russian: 'христианская благотворительность',
    latvian: 'kristīga labdarība',
    polish: 'chrześcijańskie miłosierdzie',
    french: 'charité chrétienne',
    spanish: 'caridad cristiana',
  },
  {
    av: 21306,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + ownership, possession: state of being without possessions)',
    english: 'poverty',
    swedish: 'fattigdom',
    norwegian: 'fattigdom',
    finnish: 'köyhyys',
    hungarian: 'szegénység, nincstelenség, nyomor',
    german: 'Bedürftigkeit, Mangel, Armut',
    dutch: 'armoede',
    afrikaans: 'armoede',
    russian: 'бедность',
    latvian: 'nabadzība',
    polish: 'ubóstwo',
    french: 'pauvreté',
    spanish: 'pobreza',
  },
  {
    av: 21307,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cause + poverty + action indicator)',
    english: 'impoverish-(to)',
    swedish: 'utarma, suga ut',
    norwegian: 'utarme, gjøre fattig',
    finnish: 'köyhdyttää',
    hungarian: 'elszegényedni, tönkremenni',
    german: 'verarmen',
    dutch: 'verarmen',
    afrikaans: 'verarm (om te)',
    russian: 'обеднять, доводить до бедности',
    latvian: 'novest nabadzībā, noplicināt',
    polish: 'zubożyć, wyjałowić',
    french: 'appauvrir',
    spanish: 'empobrecer',
  },
  {
    av: 21308,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(decision + without + action: decision to not do something)',
    english: 'abstention',
    swedish: 'avhållsamhet',
    norwegian: 'avholdenhet',
    finnish: 'pidättäytyminen',
    hungarian: 'tartózkodás',
    german: 'Enthaltsamkeit',
    dutch: 'onthouding',
    afrikaans: 'onthouding',
    russian: 'воздержание, неучастие',
    latvian: 'nepiedalīšanos',
    polish: 'abstynencja, wstrzymywanie się',
    french: 'abstention',
    spanish: 'abstención',
  },
  {
    av: 21309,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(action + by + rule [contr.]: act of doing something according to the rules)',
    english: 'obedience',
    swedish: 'lydnad',
    norwegian: 'lydighet',
    finnish: 'kuuliaisuus, tottelevaisuus',
    hungarian: 'engedelmesség',
    german: 'Gehorsam, Folgsamkeit',
    dutch: 'gehoorzaamheid',
    afrikaans: 'gehoorsaamheid',
    russian: 'послушание',
    latvian: 'atturība, atturēšanās',
    polish: 'posłuszeństwo',
    french: 'obéissance',
    spanish: 'obediencia',
  },
  {
    av: 21310,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to speak + to persuade + action indicator)',
    english: 'preach-(to)',
    swedish: 'predika',
    norwegian: 'preke',
    finnish: 'saarnata, julistaa',
    hungarian: 'prédikálni, igét hirdetni',
    german: 'predigen',
    dutch: 'preken',
    afrikaans: 'preek (om te)',
    russian: 'проповедовать',
    latvian: 'sludināt',
    polish: 'głosić, propagować',
    french: 'prêcher',
    spanish: 'predicar',
  },
  {
    av: 21311,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(persuasion + action indicator: to lead to agreement)',
    english: 'persuade, convince-(to)',
    swedish: 'övertyga, övertala',
    norwegian: 'overbevise, overtale',
    finnish: 'vakuuttaa',
    hungarian: 'meggyőzni, rábeszélni, rávenni',
    german: 'überreden, überzeugen',
    dutch: 'overtuigen, overreden',
    afrikaans: 'oortuig, oorreed (om te)',
    russian: 'убеждать, уговаривать',
    latvian: 'pierunāt, pārliecināt',
    polish: 'przekonywać, nakłaniać, namawiać',
    french: 'persuader, convaincre',
    spanish: 'persuadir, convencer',
  },
  {
    av: 21312,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(yes + religion)',
    english: 'amen',
    swedish: 'amen',
    norwegian: 'amen',
    finnish: 'amen',
    hungarian: 'Ámen',
    german: 'Amen',
    dutch: 'amen',
    afrikaans: 'amen',
    russian: 'Аминь',
    latvian: 'Āmen',
    polish: 'amen',
    french: 'amen',
    spanish: 'amén',
  },
  {
    av: 21313,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + dead)',
    english: 'dead person',
    swedish: 'död person',
    norwegian: 'død person',
    finnish: 'kuollut ihminen',
    hungarian: 'halott (személy)',
    german: 'Tote',
    dutch: 'dode',
    afrikaans: 'dood (persoon)',
    russian: 'мертвец, покойник',
    latvian: 'mirusi persona',
    polish: 'zmarły, umarły, nieżywy (o osobie)',
    french: 'mort, défunt',
    spanish: 'persona muerta',
  },
  {
    av: 21314,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(dead person + plural indicator)',
    english: 'dead (the dead)',
    swedish: 'de döda',
    norwegian: 'døde (de)',
    finnish: 'edesmenneet, kuolleet',
    hungarian: 'halottak, a holtak',
    german: 'Tote',
    dutch: 'doden (de doden)',
    afrikaans: 'dood (die dooies, oorledenes)',
    russian: 'мертвецы',
    latvian: 'mirušais, mirušie',
    polish: 'zmarli',
    french: 'défunts, morts (les)',
    spanish: 'los muertos (el muerto)',
  },
  {
    av: 21315,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(body + dead)',
    english: 'corpse, cadaver, carrion',
    swedish: 'lik, kadaver',
    norwegian: 'lik (subst.), kadaver',
    finnish: 'ruumis',
    hungarian: 'holttest, tetem',
    german: 'Leiche, Leichnam, Kadaver',
    dutch: 'lijk, kadaver',
    afrikaans: 'lyk, kadawer',
    russian: 'труп',
    latvian: 'līķis',
    polish: 'trup, zwłoki',
    french: 'cadavre, corps sans vie',
    spanish: 'cuerpo, cadáver',
  },
  {
    av: 21316,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(up + dead: rising from the dead)',
    english: 'resurrection',
    swedish: 'uppståndelse',
    norwegian: 'oppstandelse',
    finnish: 'ylösnousemus',
    hungarian: 'feltámadás',
    german: 'Auferstehung',
    dutch: 'verrijzenis',
    afrikaans: 'opstanding',
    russian: 'воскрешение',
    latvian: 'Augšāmcelšanās',
    polish: 'zmartwychwstanie',
    french: 'résurrection',
    spanish: 'resurrección',
  },
  {
    av: 21317,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + plan + to repeat: plan or procedures repeated over and over)',
    english: 'ritual',
    swedish: 'ritual',
    norwegian: 'rituale',
    finnish: 'rituaali',
    hungarian: ' szertartás, rítus, rituálé',
    german: 'Ritual',
    dutch: 'ritueel',
    afrikaans: 'ritueel',
    russian: 'ритуал',
    latvian: 'rituāls',
    polish: 'rytuał',
    french: 'rituel',
    spanish: 'ritual',
  },
  {
    av: 21318,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + to repeat + intensity: repeated performance of actions)',
    english: 'perseverance',
    swedish: 'envishet, ihärdighet',
    norwegian: 'stahet, utholdenhet',
    finnish: 'sinnikkyys, kestävyys, sisu',
    hungarian: 'állhatatosság, kitartás',
    german: 'Ausdauer, Beharrlichkeit',
    dutch: 'volharding',
    afrikaans: 'volharding',
    russian: 'настойчивость',
    latvian: 'neatlaidība',
    polish: 'wytrwałość',
    french: 'persévérance',
    spanish: 'perseverancia',
  },
  {
    av: 21319,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(perseverance + action indicator)',
    english: 'persevere-(to)',
    swedish: 'envisas, hålla fast vid',
    norwegian: 'fastholde, holde ut',
    finnish: 'jaksaa sinnitellä',
    hungarian: 'kitartani vmi mellett, állhatatosan ismételni',
    german: 'andauern, bestehen, bleiben',
    dutch: 'volharden',
    afrikaans: 'volhard (om te)',
    russian: 'настаивать',
    latvian: 'pierunāt, pārliecināt',
    polish: 'wytrwać, wytrzymać',
    french: 'persévérer',
    spanish: 'perseverar',
  },
  {
    av: 21320,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(conversion + action indicator)',
    english: 'convert (belief)-(to)',
    swedish: 'konvertera, byta religion',
    norwegian: 'konvertere, bytte religion',
    finnish: 'käännyttää',
    hungarian: 'átalakítani, megváltoztatni, megtéríteni',
    german: 'konvertieren',
    dutch: 'bekeren',
    afrikaans: 'omskakel, omwissel (om te)',
    russian: 'новообращаться',
    latvian: 'konvertēties',
    polish: 'zmieniać, konwertować, przemieniać, przeistaczać',
    french: 'convertir-(se)',
    spanish: 'convertir',
  },
  {
    av: 21321,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(change + belief)',
    english: 'conversion (belief)',
    swedish: 'konvertering, religionsbyte',
    norwegian: 'konvertering, religionsbytte',
    finnish: 'kääntymys',
    hungarian: 'átalakulás, megtérés, áttérés, megtérítés',
    german: 'Konversion, Bekehrung',
    dutch: 'bekering',
    afrikaans: 'omskakeling, omwisseling',
    russian: 'новообращение, изменение вероисповедания',
    latvian: 'atgriešanās, pievēršanās (ticība)',
    polish: 'konwersja, zmiana, przemiana, przeistoczenie',
    french: 'conversion',
    spanish: 'conversión',
  },
  {
    av: 21322,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(decision + without + food: decision to go without food)',
    english: 'fast, go without food',
    swedish: 'fasta (subst.)',
    norwegian: 'faste',
    finnish: 'paasto',
    hungarian: 'böjt',
    german: 'Fastenzeit',
    dutch: 'vasten',
    afrikaans: 'vas',
    russian: 'голодание',
    latvian: 'gavēnis',
    polish: 'post',
    french: 'jeûne',
    spanish: 'ayuno',
  },
  {
    av: 21323,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(fast + action indicator)',
    english: 'fast-(to)',
    swedish: 'fasta (verb)',
    norwegian: 'faste (å)',
    finnish: 'paastota',
    hungarian: 'böjtölni, éhezni',
    german: 'fasten',
    dutch: 'vasten',
    afrikaans: 'vas (om te)',
    russian: 'голодать',
    latvian: 'gavēt',
    polish: 'pościć',
    french: 'jeûner',
    spanish: 'ayunar',
  },
  {
    av: 21324,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fast + month + Muslim: month of fasting observed by Muslims)',
    english: 'Ramadan',
    swedish: 'Ramadan',
    norwegian: 'Ramadan',
    finnish: 'ramadan',
    hungarian: 'Ramadan',
    german: 'Ramadan',
    dutch: 'Ramadan',
    afrikaans: 'Ramadan',
    russian: 'Рамадан',
    latvian: 'Ramadāns',
    polish: 'Ramadan (islam)',
    french: 'Ramadan',
    spanish: 'Ramadán',
  },
  {
    av: 21325,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(father + past)',
    english: 'forefather',
    swedish: 'förfader, anfader',
    norwegian: 'stamfar',
    finnish: 'esi-isä',
    hungarian: 'ősapa, ős, előd',
    german: 'Ahn',
    dutch: 'voorvader',
    afrikaans: 'voorvader',
    russian: 'праотец',
    latvian: 'priekštecis, sencis',
    polish: 'przodek',
    french: 'ancêtre, aïeul',
    spanish: 'antepasado',
  },
  {
    av: 21326,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(mother + past)',
    english: 'foremother',
    swedish: 'förmoder, anmoder',
    norwegian: 'stammor',
    finnish: 'esiäiti',
    hungarian: 'ősanya, ős, előd',
    german: 'Ahnin',
    dutch: 'voormoeder',
    afrikaans: 'voormoeder',
    russian: 'праматерь',
    latvian: 'priekštece, sence',
    polish: 'przodkini, kobieta przodek',
    french: 'ancêtre, aïeule',
    spanish: 'antepasada',
  },
  {
    av: 21327,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(parent + past)',
    english: 'ancestor',
    swedish: 'anfader',
    norwegian: 'avstamming, ane',
    finnish: 'esivanhempi',
    hungarian: 'előd, ős, őselőd',
    german: 'Vorfahr, Vorfahrin',
    dutch: 'voorouder',
    afrikaans: 'voorouer',
    russian: 'предок',
    latvian: 'ciltstēvs/māte, priekštecis/-e, sencis/-e',
    polish: 'przodek',
    french: 'ancêtre',
    spanish: 'antepasado',
  },
  {
    av: 21328,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(knowledge + all + description indicator)',
    english: 'all knowing',
    swedish: 'allvetande',
    norwegian: 'allvitende',
    finnish: 'kaikkitietävä',
    hungarian: 'mindentudó',
    german: 'allwissend',
    dutch: 'alwetend',
    afrikaans: 'alwetend',
    russian: 'всеведущий, всезнающий',
    latvian: 'viszinība, viszinis',
    polish: 'wszystkowiedzący',
    french: 'omniscient',
    spanish: 'omnisciente',
  },
  {
    av: 21329,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(ability + all + description indicator)',
    english: 'all powerful',
    swedish: 'allsmäktig',
    norwegian: 'allmektig',
    finnish: 'kaikkivoimainen',
    hungarian: 'mindenható, teljhatalmú, korlátlan hatalmú',
    german: 'allmächtig',
    dutch: 'almachtig',
    afrikaans: 'almagtig',
    russian: 'всемогущий, всесильный',
    latvian: 'visspēcīgs, visvarens',
    polish: 'wszechmocny',
    french: 'tout-puissant',
    spanish: 'todopoderoso',
  },
  {
    av: 21331,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + end + description indicator)',
    english: 'unending, endless',
    swedish: 'oändlig',
    norwegian: 'uendelig',
    finnish: 'loputon',
    hungarian: 'végtelen, szűnni nem akaró, véget nem érő',
    german: 'endlos',
    dutch: 'oneindig',
    afrikaans: 'oneindig',
    russian: 'бесконечный',
    latvian: 'nemirstīgs, nebeidzams, mūžīgs, bezgalīgs',
    polish: 'bezustanny, bez końca',
    french: 'sans fin, interminable',
    spanish: 'sin fin',
  },
  {
    av: 21333,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to ask + intensity + action indicator)',
    english: 'interrogate-(to)',
    swedish: 'förhöra',
    norwegian: 'forhøre',
    finnish: 'kysyä, kuulustella',
    hungarian: 'kikérdezni, kihallgatni, vallatni',
    german: 'fragen, befragen, ausfragen, verhören',
    dutch: 'ondervragen',
    afrikaans: 'ondervra (om te)',
    russian: 'выспрашивать',
    latvian: 'iztaujāt, izvaicāt',
    polish: 'przesłuchanie',
    french: 'interroger',
    spanish: 'interrogar',
  },
  {
    av: 21334,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to ask + comma + please + action indicator)',
    english: 'beg, plead-(to)',
    swedish: 'be om, vädja',
    norwegian: 'be, bønnfalle',
    finnish: 'pyytää',
    hungarian: 'könyörögni, esedezni, kérve-kérni',
    german: 'bitten, erbitten',
    dutch: 'smeken, pleiten',
    afrikaans: 'smeek, pleit (om te)',
    russian: 'просить, умолять',
    latvian: 'ubagot, ļoti lūgt',
    polish: 'tłumaczyć się, wyjaśniać, usprawiedliwiać',
    french: 'supplier, implorer',
    spanish: 'suplicar, rogar',
  },
  {
    av: 21335,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to say + for the purpose of + action + action indicator: to speak with authority)',
    english: 'command, order-(to)',
    swedish: 'befalla',
    norwegian: 'befale',
    finnish: 'käskeä, määrätä',
    hungarian: 'parancsolni, megparancsolni, elrendelni',
    german: 'befehlen',
    dutch: 'bevelen',
    afrikaans: 'beveel, opdrag (om te)',
    russian: 'повелевать',
    latvian: 'pavēlēt, komandēt',
    polish: 'polecenie, rozkaz',
    french: 'commander',
    spanish: 'ordenar, comandar',
  },
  {
    av: 21336,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to say + to want + intensity + action indicator: to speak or ask with urgency)',
    english: 'demand-(to)',
    swedish: 'begära, kräva',
    norwegian: 'begjære, kreve',
    finnish: 'vaatia',
    hungarian: 'kívánni, követelni, megkövetelni',
    german: 'fordern, verlangen',
    dutch: 'eisen',
    afrikaans: 'eis (om te)',
    russian: 'запрос, требование',
    latvian: 'prasība',
    polish: 'pragnąć, wymagać, pożądać (czegoś)',
    french: 'exiger, réclamer',
    spanish: 'demandar',
  },
  {
    av: 21337,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(proclamation + action indicator: to make a public announcement)',
    english: 'proclaim, announce-(to)',
    swedish: 'tillkännage, förkunna',
    norwegian: 'opplyse, forkynne',
    finnish: 'ilmoittaa, julistaa',
    hungarian: 'kihirdetni, bejelenteni, nyilvánosságra hozni, közölni',
    german: 'ausrufen, verlautbaren, bekanntmachen, erklären',
    dutch: 'aankondigen',
    afrikaans: 'aankondig, verkondig (om te)',
    russian: 'проповедовать, провозглашать',
    latvian: 'pavēstīt, paziņot, izziņot, pasludināt',
    polish: 'ogłaszać, rozgłaszać',
    french: 'proclamer, déclarer',
    spanish: 'proclamar, anunciar',
  },
  {
    av: 21338,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to say + to disseminate: a public announcement)',
    english: 'proclamation, announcement',
    swedish: 'tillkännagivande, förkunnelse',
    norwegian: 'opplysning, forkynnelse',
    finnish: 'ilmoitus, julistus',
    hungarian: 'kihirdetés, közlés, bejelentés',
    german: 'Ankündigung, Bekanntmachung, Bekanntgabe',
    dutch: 'aankondiging, proclamatie',
    afrikaans: 'aankondiging, verkondiging',
    russian: 'проповедь, провозглашение',
    latvian: 'paziņošana, pasludināšana',
    polish: 'ogłoszenie, proklamacja',
    french: 'proclamation, déclaration',
    spanish: 'proclamación, anuncio',
  },
  {
    av: 21339,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + proclamation)',
    english: 'proclamation (written)',
    swedish: 'skriftligt tillkännagivande',
    norwegian: 'skriftlig bekjentgjøring',
    finnish: 'pamfletti, julistus, ilmoitus',
    hungarian: 'hirdetmény, kiáltvány, nyilvánosságra hozatal',
    german: '(schriftliche) Bekanntmachung, (schriftliche) Ankündigung',
    dutch: 'aankondiging (geschreven)',
    afrikaans: 'aankondiging, verkondiging, afkondiging (geskrewe)',
    russian: 'прокламация, письменная проповедь',
    latvian: 'paziņojums, pasludinājums',
    polish: 'pisemne ogłoszenie',
    french: 'proclamation, déclaration (écrite)',
    spanish: 'proclamación (por escrito)',
  },
  {
    av: 21340,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + to disseminate)',
    english: 'flyer',
    swedish: 'flygblad, reklamblad',
    norwegian: 'flygeblad, reklameblad',
    finnish: 'lentolehtinen, mainoslehtinen',
    hungarian: 'szórólap, brosúra',
    german: 'Flyer, Handzettel',
    dutch: 'flyer, folder, brochure',
    afrikaans: 'brosjure, pamflet, gids',
    russian: 'флаер, информативная листовка',
    latvian: 'reklāmlapiņa, reklāma',
    polish: 'ulotka, folder',
    french: 'tract, dépliant, prospectus, folder',
    spanish: 'aviador',
  },
  {
    av: 21341,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(correct thinking + intensity: a combination of mind and positive)',
    english: 'correctness, rightness',
    swedish: 'riktighet, rätt',
    norwegian: 'riktighet, nøyaktighet',
    finnish: 'oikeus, tarkkuus',
    hungarian: 'helyesség, kifogástalanság, korrektség',
    german: 'Genauigkeit, Korrektheit, Richtigkeit',
    dutch: 'nauwkeurigheid, juistheid',
    afrikaans: 'korrektheid',
    russian: 'правильность, корректность',
    latvian: 'pareizība, korektums',
    polish: 'poprawność',
    french: 'correction, justesse',
    spanish: 'exactitud, lo correcto',
  },
  {
    av: 21342,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(correctness + intensity)',
    english: 'excellence',
    swedish: 'förträfflighet',
    norwegian: 'fortreffelighet',
    finnish: 'erinomaisuus',
    hungarian: 'kitűnőség, kiválóság',
    german: 'Vortrefflichkeit, Güte, Spitzenleistung',
    dutch: 'uitmuntendheid',
    afrikaans: 'uitstekend, uitmuntend',
    russian: 'превосхдность',
    latvian: 'izcilība',
    polish: 'doskonałość',
    french: 'excellence (jugement de valeur)',
    spanish: 'excelencia',
  },
  {
    av: 21343,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(excellence + description indicator)',
    english: 'excellent',
    swedish: 'förträfflig, utmärkt',
    norwegian: 'fortreffelig, utmerket',
    finnish: 'erinomainen',
    hungarian: 'kitűnő, kiváló',
    german: 'ausgezeichnet, hervorragend',
    dutch: 'uitstekend, uitmuntend',
    afrikaans: 'uitstekend, uitmuntend',
    russian: 'превосходный',
    latvian: 'izcils',
    polish: 'doskonały, wspaniały',
    french: 'excellent',
    spanish: 'excelente',
  },
  {
    av: 21344,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(excellence + intensity)',
    english: 'perfection',
    swedish: 'perfektion',
    norwegian: 'perfeksjon',
    finnish: 'täydellisyys',
    hungarian: 'tökéletesség',
    german: 'Perfektion, Vollkommenheit',
    dutch: 'perfectie',
    afrikaans: 'perfeksie',
    russian: 'идеальность',
    latvian: 'pilnība',
    polish: 'doskonałość',
    french: 'perfection',
    spanish: 'perfección',
  },
  {
    av: 21345,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(perfection + description indicator)',
    english: 'perfect',
    swedish: 'perfekt',
    norwegian: 'perfekt',
    finnish: 'täydellinen',
    hungarian: 'tökéletes',
    german: 'perfekt, vollkommen',
    dutch: 'perfect',
    afrikaans: 'perfek',
    russian: 'идеальный',
    latvian: 'pilnīgs, neatkārtojams, ideāls',
    polish: 'doskonale!!, perfekcyjnie, wspaniale (wykrzyknik)',
    french: 'parfait, idéal',
    spanish: 'perfecto',
  },
  {
    av: 21346,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to disseminate + news + positive + action indicator)',
    english: 'evangelise-(to)',
    swedish: 'evangelisera',
    norwegian: 'evangelisere',
    finnish: 'julistaa',
    hungarian: 'téríteni, megtéríteni',
    german: 'missionieren',
    dutch: 'evangeliseren',
    afrikaans: 'evangeliseer (om te)',
    russian: 'евангелизировать',
    latvian: 'evanģelizēt',
    polish: 'ewangelizować, nauczać wiary, głosić wiarę',
    french: 'évangéliser',
    spanish: 'evangelizar',
  },
  {
    av: 21347,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to disseminate + news + positive + Christianity [contr.] + action indicator)',
    english: 'evangelise (christian)-(to)',
    swedish: 'predika evangelium, missionera (kristendom)',
    norwegian: 'misjonere',
    finnish: 'saarnata evankeliumia, saarnata kristinuskoa',
    hungarian: 'evangelizálni, keresztény hitre téríteni',
    german: 'evangelisieren',
    dutch: 'evangeliseren (christelijk)',
    afrikaans: 'evangeliseer (Christelik) (om te)',
    russian: 'евангелизировать(христианство)',
    latvian: 'evanģelizācija',
    polish: 'ewangelizacja chrześcijańska',
    french: "évangéliser, prêcher l'Evangile",
    spanish: 'evangelizar (cristiano)',
  },
  {
    av: 21348,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(drowning + action indicator)',
    english: 'drown-(to)',
    swedish: 'drunkna',
    norwegian: 'drukne',
    finnish: 'hukkua',
    hungarian: 'megfulladni, vízbe fulladni',
    german: 'ertrinken',
    dutch: 'verdrinken',
    afrikaans: 'verdrink (om te)',
    russian: 'тонуть, утонуть',
    latvian: 'slīkt, noslīkt',
    polish: 'topić, tonąć',
    french: 'noyer-(se)',
    spanish: 'ahogarse',
  },
  {
    av: 21349,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cause + drowning + action indicator)',
    english: 'drown (cause to)-(to)',
    swedish: 'dränka',
    norwegian: 'drukne (forårsake)',
    finnish: 'hukuttaa',
    hungarian: 'megfojtani, vízbe fojtani',
    german: 'ertränken',
    dutch: 'verdrinken',
    afrikaans: 'verdrink (om te)',
    russian: 'топить, затоплять',
    latvian: 'noslīcināt',
    polish: 'utopić (kazać utopić)',
    french: 'noyer',
    spanish: 'ahogar',
  },
  {
    av: 21350,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(earth + without + water)',
    english: 'desert',
    swedish: 'öken',
    norwegian: 'ørken',
    finnish: 'autiomaa',
    hungarian: 'sivatag',
    german: 'Wüste',
    dutch: 'woestijn',
    afrikaans: 'woestyn',
    russian: 'пустыня',
    latvian: 'tuksnesis',
    polish: 'pustynia',
    french: 'désert',
    spanish: 'desierto',
  },
  {
    av: 21351,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(countryside + open/wild)',
    english: 'wilderness',
    swedish: 'vildmark',
    norwegian: 'villmark',
    finnish: 'erämaa',
    hungarian: 'vadon',
    german: 'Wildnis',
    dutch: 'wildernis',
    afrikaans: 'wildernis',
    russian: 'дикая местность',
    latvian: 'mežonīgs, mežonīgs apgabals',
    polish: 'puszcza',
    french: 'région sauvage, région inhabitée',
    spanish: 'páramo, jungla, desierto, tierra inexplorada',
  },
  {
    av: 21352,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(big + intensity + description indicator)',
    english: 'huge',
    swedish: 'jättestor',
    norwegian: 'kjempestor',
    finnish: 'valtava',
    hungarian: 'hatalmas, igen nagy',
    german: 'sehr groß, gewaltig',
    dutch: 'enorm',
    afrikaans: 'enormies, enorm, groot',
    russian: 'огромный',
    latvian: 'ļoti liels, milzīgs',
    polish: 'wielki, duży',
    french: 'énorme, immense',
    spanish: 'enorme',
  },
  {
    av: 21353,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(huge + intensity + description indicator)',
    english: 'enormous',
    swedish: 'enorm',
    norwegian: 'enorm',
    finnish: 'valtava',
    hungarian: 'roppant nagy, rettentő nagy',
    german: 'enorm, gewaltig, riesig',
    dutch: 'reusachtig',
    afrikaans: 'enormies, reusagtig',
    russian: 'громадный',
    latvian: 'milzīgs',
    polish: 'olbrzymi, wielki',
    french: 'énorme',
    spanish: 'enorme',
  },
  {
    av: 21354,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(enormous + intensity + description indicator)',
    english: 'gigantic',
    swedish: 'ofantlig',
    norwegian: 'gigantisk',
    finnish: 'jättiläismäinen',
    hungarian: 'óriási, gigantikus, kolosszális',
    german: 'riesig, gewaltig, gigantisch',
    dutch: 'gigantisch',
    afrikaans: 'reusagtig',
    russian: 'гигантский',
    latvian: 'gantisks',
    polish: 'gigantyczny, kolosalny, wielki, ogromny',
    french: 'gigantesque, géant(e)',
    spanish: 'gigantesco',
  },
  {
    av: 21355,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + from sky: food, or something, provided unexpectedly, as though it had dropped from heaven)',
    english: 'manna',
    swedish: 'manna',
    norwegian: 'manna',
    finnish: 'manna',
    hungarian: 'manna',
    german: 'Manna',
    dutch: 'manna',
    afrikaans: 'manna',
    russian: 'манна небесная',
    latvian: 'manna, debesmanna',
    polish: 'manna (jedzenie spadające z nieba)',
    french: 'manne céleste',
    spanish: 'maná',
  },
  {
    av: 21356,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(place + without + human being + description indicator)',
    english: 'uninhabited',
    swedish: 'obebodd',
    norwegian: 'ubebodd',
    finnish: 'asumaton',
    hungarian: 'lakatlan',
    german: 'unbewohnt, unbelebt',
    dutch: 'onbewoond',
    afrikaans: 'onbewoon',
    russian: 'необитаемый',
    latvian: 'neapdzīvots',
    polish: 'bezludny, niezamieszkały',
    french: 'inhabité',
    spanish: 'inhabitado',
  },
  {
    av: 21357,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + fish)',
    english: 'fishnet',
    swedish: 'fisknät',
    norwegian: 'fiskegarn',
    finnish: 'kalaverkko',
    hungarian: 'halászháló',
    german: 'Fischnetz',
    dutch: 'visnet',
    afrikaans: 'visnet',
    russian: 'рыболовная сеть',
    latvian: 'zvejas tīkls',
    polish: 'sieć do połowu ryb',
    french: 'filet de pêche',
    spanish: 'red de pesca',
  },
  {
    av: 21358,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(smoke + smell)',
    english: 'incense',
    swedish: 'rökelse',
    norwegian: 'røkelse',
    finnish: 'suitsuke',
    hungarian: 'tömjén, füstölő',
    german: 'Weihrauch',
    dutch: 'wierook',
    afrikaans: 'wierook',
    russian: 'ладан',
    latvian: 'vīraks',
    polish: 'kadzidło',
    french: 'encens',
    spanish: 'incienso',
  },
  {
    av: 21359,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(life + choice: chosen way of life)',
    english: 'calling, vocation',
    swedish: 'kall, livsuppgift',
    norwegian: 'kall, livsoppgave',
    finnish: 'ammatti, kutsumus',
    hungarian: 'hivatás, elhivatottság',
    german: 'Berufung',
    dutch: 'roeping',
    afrikaans: 'roeping',
    russian: 'призвание',
    latvian: 'aicinājums, arods',
    polish: 'powołanie',
    french: 'métier, vocation',
    spanish: 'vocación',
  },
  {
    av: 21360,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + choice: chosen work)',
    english: 'calling, profession, career',
    swedish: 'yrke',
    norwegian: 'yrke',
    finnish: 'ammatti, ura, kutsumus',
    hungarian: 'foglalkozás, életpálya, karrier',
    german: 'Beruf, Profession',
    dutch: 'carrière',
    afrikaans: 'roeping, beroep, professie',
    russian: 'профессия, карьера',
    latvian: 'aicinājums, profesija, karjera',
    polish: 'fach, zawód, kariera',
    french: 'métier, profession, carrière',
    spanish: 'vocación, profesión, carrera',
  },
  {
    av: 21361,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to say + to repeat + action indicator: to say repeatedly or over and over again)',
    english: 'nag-(to)',
    swedish: 'tjata',
    norwegian: 'mase',
    finnish: 'nalkuttaa, jankuttaa',
    hungarian: 'korholni, szekálni, zsémbelni',
    german: 'nörgeln, meckern, herumnörgeln',
    dutch: 'zeuren (blijven zeggen)',
    afrikaans: 'kla (om te)',
    russian: 'приставать, докучать',
    latvian: 'šķendēties, piesieties',
    polish: 'narzekać, gderać',
    french: 'agacer (verbalement)',
    spanish: 'molestar',
  },
  {
    av: 21362,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lamp + oil + thing indicator)',
    english: 'oil lamp',
    swedish: 'oljelampa',
    norwegian: 'oljelampe',
    finnish: 'öljylamppu',
    hungarian: 'olajlámpa',
    german: 'Spirituslampe, Öllampe',
    dutch: 'olielamp',
    afrikaans: 'olie lamp',
    russian: 'масляная лампа',
    latvian: 'eļļas lampa',
    polish: 'lampa naftowa, olejowa',
    french: 'lampe à huile',
    spanish: 'lámpara de aceite',
  },
  {
    av: 21364,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(goblet + holy)',
    english: 'chalice',
    swedish: 'nattvardskalk',
    norwegian: 'nattverdsvin',
    finnish: 'ehtoollismalja',
    hungarian: 'áldozati kehely',
    german: 'Abendmahlskelch, Kelch',
    dutch: 'kelk',
    afrikaans: 'kelk',
    russian: 'чаша, потир (церковные)',
    latvian: 'biķeris, kauss',
    polish: 'kielich mszalny',
    french: 'calice',
    spanish: 'cáliz',
  },
  {
    av: 21365,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(two + bottle + holy)',
    english: 'ampullae',
    swedish: 'ampulla',
    norwegian: 'ampulla (katolsk krukke)',
    finnish: 'ampullae',
    hungarian: 'áldozati kancsó, korsó',
    german: 'Phiole, Ampulle',
    dutch: 'ampullen (christelijk)',
    afrikaans: 'ampule',
    russian: 'ампула для святой воды',
    latvian: 'ampula',
    polish: 'ampulla (rodzaj naczynia liturgicznego np. na wodę święconą)',
    french: 'burettes (service religieux)',
    spanish: 'ampolla',
  },
  {
    av: 21366,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plate + holy)',
    english: 'paten, holy tray',
    swedish: 'patén',
    norwegian: 'fat hellig, oblatfat',
    finnish: 'pyhä tarjotin',
    hungarian: 'áldozati tál',
    german: 'Hostienteller, Patene',
    dutch: 'pateen',
    afrikaans: 'pateen, helige bord',
    russian: 'дискос (литургический сосуд)',
    latvian: 'metāla trauks, Svētā Vakarēdiena trauks',
    polish: 'patena (relig., talerzyk pod hostię)',
    french: 'patène',
    spanish: 'patena, bandeja sagrada para la hostia',
  },
  {
    av: 21367,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bread + holy)',
    english: 'Host, wafer (in religious ceremony)',
    swedish: 'oblat',
    norwegian: 'oblat, nattverdsbrød',
    finnish: 'öylätti',
    hungarian: 'szentostya',
    german: 'Hostie',
    dutch: 'hostie',
    afrikaans: 'wafer (godsdienstige seremonie)',
    russian: 'просфора (литургический хлеб)',
    latvian: 'Svētīts ūdens (reliģiskā ceremonijā)',
    polish: 'hostia',
    french: 'hostie',
    spanish: 'anfitrión',
  },
  {
    av: 21368,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(table + holy)',
    english: 'altar',
    swedish: 'altare',
    norwegian: 'alter',
    finnish: 'alttari',
    hungarian: 'oltár',
    german: 'Altar',
    dutch: 'altaar',
    afrikaans: 'altaar',
    russian: 'алтарь',
    latvian: 'altāris',
    polish: 'ołtarz',
    french: 'autel',
    spanish: 'altar',
  },
  {
    av: 21369,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + altar)',
    english: 'altar cloth',
    swedish: 'altarduk',
    norwegian: 'alterduk',
    finnish: 'alttariliina',
    hungarian: 'oltárterítő',
    german: 'Altardecke',
    dutch: 'altaarkleed',
    afrikaans: 'altaarkleed',
    russian: 'алтарная скатерть',
    latvian: 'altāra sega',
    polish: 'obrus ołtarzowy, tkanina na ołtarzu',
    french: "nappe d'autel",
    spanish: 'paño de altar',
  },
  {
    av: 21370,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + holy)',
    english: 'vestment',
    swedish: 'kyrkskrud',
    norwegian: 'ornat',
    finnish: 'kirkollinen vaate',
    hungarian: 'miseruha, papi öltözék',
    german: 'Messgewand, Amtstracht, Robe',
    dutch: 'albe, kazuifel (christelijk)',
    afrikaans: 'vestmet',
    russian: 'облачение',
    latvian: 'amata tērps, talārs',
    polish: 'ornat',
    french: 'habit sacerdotal',
    spanish: 'vestiduras',
  },
  {
    av: 21371,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tree + Christmas [contr.])',
    english: 'Christmas tree',
    swedish: 'julgran',
    norwegian: 'juletre',
    finnish: 'joulukuusi',
    hungarian: 'karácsonyfa',
    german: 'Weihnachtsbaum, Christbaum',
    dutch: 'kerstboom',
    afrikaans: 'kersboom',
    russian: 'Рождественская ель',
    latvian: 'Ziemassvētku egle',
    polish: 'choinka, drzewko bożonarodzeniowe',
    french: 'sapin de Noël',
    spanish: 'árbol de Navidad',
  },
  {
    av: 21372,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(question + person)',
    english: 'interview',
    swedish: 'intervju, utfrågning',
    norwegian: 'intervju, utspørring',
    finnish: 'haastattelu',
    hungarian: 'interjú',
    german: 'Interview',
    dutch: 'interview',
    afrikaans: 'onderhoud',
    russian: 'интервью',
    latvian: 'intervija',
    polish: 'wywiad',
    french: 'interview, interrogatoire, interrogation',
    spanish: 'entrevista',
  },
  {
    av: 21373,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(interview + action indicator)',
    english: 'interview-(to)',
    swedish: 'intervjua, fråga ut',
    norwegian: 'intervjue, spørre om',
    finnish: 'haastatella',
    hungarian: 'interjúvolni, véleményt megkérdezni',
    german: 'befragen',
    dutch: 'interviewen',
    afrikaans: 'onderhoud voer (om te)',
    russian: 'интервьюировать',
    latvian: 'intervēt',
    polish: 'przeprowadzać wywiad, zadawać pytania',
    french: 'interviewer, questionner, interroger',
    spanish: 'entrevistar',
  },
  {
    av: 21374,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + interview)',
    english: 'interviewer',
    swedish: 'intervjuare',
    norwegian: 'intervjuer',
    finnish: 'haastattelija',
    hungarian: 'interjúvoló, kikérdező',
    german: 'Interviewer, Befrager',
    dutch: 'interviewer',
    afrikaans: 'onderhoudvoerder',
    russian: 'итервьюер',
    latvian: 'intervētājs',
    polish: 'ankieter, osoba przeprowadzająca wywiad',
    french: 'intervieweur',
    spanish: 'entrevistador',
  },
  {
    av: 21380,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(world + all + description indicator)',
    english: 'universal, world-wide',
    swedish: 'allomfattande, universell',
    norwegian: 'universell, verdensomspennende',
    finnish: 'universaali, maailmanlaajuinen',
    hungarian: 'egyetemes, általános, univerzális',
    german: 'universal, weltweit',
    dutch: 'universeel',
    afrikaans: 'universeel, universele, wêreld-wyd, wêreldwye',
    russian: 'универсальный, всеобъемлющий',
    latvian: 'vispasaules',
    polish: 'ogólnoświatowy, na całym świecie',
    french: 'universel, mondial',
    spanish: 'universal, mundial',
  },
  {
    av: 21381,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(forgiveness + description after the fact indicator)',
    english: 'forgiven',
    swedish: 'förlåten',
    norwegian: 'tilgitt',
    finnish: 'anteeksiannettu',
    hungarian: 'megbocsátott (pl. bűn)',
    german: 'vergeben, verziehen',
    dutch: 'vergeven (zijn)',
    afrikaans: 'vergewe, vergifnis',
    russian: 'прощённый',
    latvian: 'piedots',
    polish: 'wybaczony, przebaczony',
    french: 'pardonné',
    spanish: 'perdonado',
  },
  {
    av: 21537,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(sign language + action indicator)',
    english: 'sign-(to)',
    swedish: 'teckna, kommunicera med tecken',
    norwegian: 'tegne, kommunisere med håndtegn',
    finnish: 'viittoa',
    hungarian: 'jelelni',
    german: 'gebärden, in Gebärdensprache ausdrücken',
    dutch: 'gebaren',
    afrikaans: 'gebaar, wys, beduie (om te)',
    russian: 'дактилировать',
    latvian: 'dziedāt',
    polish: 'migać (używać języka gestów, migowego)',
    french: 'signer (langue des signes)',
    spanish: 'señalar (lenguaje de signos)',
  },
  {
    av: 21538,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + hand: language expressed with the hands)',
    english: 'sign language',
    swedish: 'teckenspråk',
    norwegian: 'tegnspråk',
    finnish: 'viittomakieli',
    hungarian: 'jelelés, jelnyelv',
    german: 'Zeichensprache, Gebärdensprache',
    dutch: 'gebarentaal, gebaren',
    afrikaans: 'gebare taal',
    russian: 'язык жестов',
    latvian: 'zīmju valoda',
    polish: 'język migowy',
    french: 'langue des signes',
    spanish: 'lenguaje de signos',
  },
  {
    av: 21539,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(earth + dryness: land protected by dykes which has been reclaimed from a body of water)',
    english: 'polder (Dutch)',
    swedish: 'polder (Nederländerna)',
    norwegian: 'dikelandskap, polder (Nederland)',
    finnish: 'polderi',
    hungarian: 'belvízártér, belvizes terület, polder (holland)',
    german: 'Polder (Holland)',
    dutch: 'polder',
    afrikaans: 'polder',
    russian: 'польдер(осушенная земля)',
    latvian: 'polderis',
    polish: 'polder (osuszone tereny nadmorskie, np. Żuławy)',
    french: 'polder (Pays-Bas)',
    spanish: 'polder (neerlandés)',
  },
  {
    av: 21542,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(science + star: scientific study of the universe beyond the earth)',
    english: 'astronomy',
    swedish: 'astronomi',
    norwegian: 'astronomi',
    finnish: 'tähtitiede',
    hungarian: 'csillagászat, asztronómia',
    german: 'Astronomie',
    dutch: 'astronomie',
    afrikaans: 'astronomie, sterrekunde',
    russian: 'астрономия',
    latvian: 'astronomija',
    polish: 'astronomia',
    french: 'astronomie',
    spanish: 'astronomía',
  },
  {
    av: 21543,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + business: science that deals with the production, distribution and consumption of commodities)',
    english: 'economics',
    swedish: 'ekonomi',
    norwegian: 'økonomi',
    finnish: 'taloustiede',
    hungarian: 'közgazdaságtan',
    german: 'Wirtschaftswissenschaften',
    dutch: 'economie',
    afrikaans: 'ekonomie',
    russian: 'экономика',
    latvian: 'ekonomika, tautsaimniecība',
    polish: 'ekonomia, gospodarka',
    french: 'économie',
    spanish: 'economía',
  },
  {
    av: 21544,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + chemical product: science of the composition, structure, properties and reactions of matter)',
    english: 'chemistry',
    swedish: 'kemi',
    norwegian: 'kjemi',
    finnish: 'kemia',
    hungarian: 'kémia, vegytan',
    german: 'Chemie',
    dutch: 'scheikunde',
    afrikaans: 'chemie',
    russian: 'химия',
    latvian: 'ķimija',
    polish: 'chemia',
    french: 'chimie',
    spanish: 'química',
  },
  {
    av: 21545,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + biochemical product: chemistry of biological substances and processes)',
    english: 'biochemistry',
    swedish: 'biokemi',
    norwegian: 'biokjemi',
    finnish: 'biokemia',
    hungarian: 'biokémia',
    german: 'Biochemie',
    dutch: 'biochemie',
    afrikaans: 'biochemie',
    russian: 'биохимия',
    latvian: 'bioķīmija',
    polish: 'biochemia',
    french: 'biochimie',
    spanish: 'bioquímica',
  },
  {
    av: 21546,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + combination of chemical product and life: science of living organisms and life processes)',
    english: 'biology',
    swedish: 'biologi',
    norwegian: 'biologi',
    finnish: 'biologia',
    hungarian: 'biológia',
    german: 'Biologie',
    dutch: 'biologie',
    afrikaans: 'biologie',
    russian: 'биология',
    latvian: 'bioloģija',
    polish: 'biologia',
    french: 'biologie',
    spanish: 'biología',
  },
  {
    av: 21547,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(science + plant: biological science of plants)',
    english: 'botany',
    swedish: 'botanik',
    norwegian: 'botanikk',
    finnish: 'kasvitiede',
    hungarian: 'növénytan, botanika',
    german: 'Botanik, Pflanzenkunde',
    dutch: 'plantkunde',
    afrikaans: 'plantkunde',
    russian: 'ботаника',
    latvian: 'botānika',
    polish: 'botanika',
    french: 'botanique',
    spanish: 'botánica',
  },
  {
    av: 21548,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(science + human being: scientific study of human beings)',
    english: 'anthropology',
    swedish: 'antropologi',
    norwegian: 'antropologi',
    finnish: 'antropologia',
    hungarian: 'embertan, antropológia',
    german: 'Anthropologie, Menschenkunde',
    dutch: 'antropologie',
    afrikaans: 'antropologie',
    russian: 'антропология',
    latvian: 'astroloģija',
    polish: 'antropologia',
    french: 'anthropologie',
    spanish: 'antropología',
  },
  {
    av: 21549,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(science + animal: biological science of animals)',
    english: 'zoology',
    swedish: 'zoologi',
    norwegian: 'zoologi',
    finnish: 'eläintiede',
    hungarian: 'állattan, zoológia',
    german: 'Zoologie',
    dutch: 'dierkunde',
    afrikaans: 'dierkunde',
    russian: 'зоология',
    latvian: 'zooloģija',
    polish: 'zoologia',
    french: 'zoologie',
    spanish: 'zoología',
  },
  {
    av: 21550,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + earth: scientific study of the origins, history and structure of the earth)',
    english: 'geology',
    swedish: 'geologi',
    norwegian: 'geologi',
    finnish: 'maantiede',
    hungarian: 'földtan, geológia',
    german: 'Geologie',
    dutch: 'geologie',
    afrikaans: 'geologie',
    russian: 'геология',
    latvian: 'ģeoloģija',
    polish: 'geologia – nauka',
    french: 'géologie',
    spanish: 'geología',
  },
  {
    av: 21551,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(science + life + group: study of human social behaviour)',
    english: 'sociology',
    swedish: 'sociologi',
    norwegian: 'sosiologi, samfunnsfag',
    finnish: 'sosiologia',
    hungarian: 'szociológia',
    german: 'Soziologie',
    dutch: 'sociologie',
    afrikaans: 'sosiologie',
    russian: 'социология',
    latvian: 'socioloģija',
    polish: 'socjologia',
    french: 'sociologie',
    spanish: 'sociología',
  },
  {
    av: 21553,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + past: study of the past, especially as revealed in recorded materials)',
    english: 'history',
    swedish: 'historia',
    norwegian: 'historie',
    finnish: 'historia',
    hungarian: 'történelemtudomány, történelem',
    german: 'Geschichte',
    dutch: 'geschiedenis',
    afrikaans: 'geskiedenis',
    russian: 'история',
    latvian: 'vēsture',
    polish: 'historia',
    french: 'histoire',
    spanish: 'historia',
  },
  {
    av: 21554,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(history + thing: study of physical objects and material evidence from the past)',
    english: 'archeology',
    swedish: 'arkeologi',
    norwegian: 'arkeologi',
    finnish: 'arkeologia',
    hungarian: 'régészet, archeológia',
    german: 'Archäologie',
    dutch: 'archeologie',
    afrikaans: 'argeologie',
    russian: 'археология',
    latvian: 'arheoloģija',
    polish: 'archeologia',
    french: 'archéologie',
    spanish: 'arqueología',
  },
  {
    av: 21555,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + weather: science dealing with the phenomena of the atmosphere, especially of weather)',
    english: 'meteorology',
    swedish: 'meteorologi',
    norwegian: 'meteorologi',
    finnish: 'meteorologia',
    hungarian: 'meteorológia',
    german: 'Metereologie',
    dutch: 'meteorologie',
    afrikaans: 'meteorologie, weerkunde',
    russian: 'метеорология',
    latvian: 'meteoroloģija',
    polish: 'meteorologia',
    french: 'météorologie',
    spanish: 'meteorología',
  },
  {
    av: 21556,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + energy: science of matter and energy and of interactions between them)',
    english: 'physics',
    swedish: 'fysik',
    norwegian: 'fysikk',
    finnish: 'fysiikka',
    hungarian: 'fizika',
    german: 'Physik',
    dutch: 'fysica',
    afrikaans: 'fisika',
    russian: 'физика',
    latvian: 'fizika',
    polish: 'fizyka',
    french: 'physique',
    spanish: 'física',
  },
  {
    av: 21557,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(science + language: study of the nature and structure of language)',
    english: 'linguistics',
    swedish: 'lingvistik',
    norwegian: 'lingvistikk',
    finnish: 'kielitiede',
    hungarian: 'nyelvészet',
    german: 'Linguistik',
    dutch: 'linguistiek, taalkunde',
    afrikaans: 'taalkunde, linguistiek',
    russian: 'лингвистика',
    latvian: 'lingvistika',
    polish: 'lingwistyka, językoznawstwo',
    french: 'linguistique',
    spanish: 'lingüística',
  },
  {
    av: 21558,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + number: study of numbers, their form, arrangement and associated relationships) SYMBOL SYNONYM',
    english: 'mathematics, arithmetic, math (1)',
    swedish: 'matematik (1)',
    norwegian: 'matematikk (1)',
    finnish: 'matematiikka',
    hungarian: 'matematikatudomány',
    german: 'Mathematik, Arithmetik, Rechnen, Mathe (1)',
    dutch: 'wiskunde, rekenen (1)',
    afrikaans: 'wiskunde, rekenkunde (1)',
    russian: 'математика, арифметика (1)',
    latvian: 'matemātika, aritmētika (1)',
    polish: 'matematyka (nauka +liczba) (1)',
    french: 'mathématiques, arithmétique (science) (1)',
    spanish: 'matemáticas, aritmética, (1)',
  },
  {
    av: 21559,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + science)',
    english: 'scientist, academic',
    swedish: 'vetenskapsman, forskare',
    norwegian: 'vitenskapsmann',
    finnish: 'tiedemies, tutkija',
    hungarian: 'tudós',
    german: 'Wissenschaftler, Wissenschaftlerin',
    dutch: 'wetenschapper',
    afrikaans: 'wetenskaplike, akademikus',
    russian: 'учёный, исследователь',
    latvian: 'zinātnieks, akadēmiķis',
    polish: 'naukowiec, akademik',
    french: 'savant, scientifique, académicien',
    spanish: 'científico, académico',
  },
  {
    av: 21560,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + astronomy)',
    english: 'astronomer',
    swedish: 'astronom',
    norwegian: 'astronom',
    finnish: 'tähtitieteilijä, astronomi',
    hungarian: 'csillagász',
    german: 'Astronom, Astronomin',
    dutch: 'astronoom',
    afrikaans: 'astronoom, sterrekundige',
    russian: 'астроном',
    latvian: 'astronoms',
    polish: 'astronom',
    french: 'astronome',
    spanish: 'astrónomo',
  },
  {
    av: 21561,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + economics)',
    english: 'economist',
    swedish: 'ekonom',
    norwegian: 'økonom',
    finnish: 'ekonomi, taloustieteilijä',
    hungarian: 'közgazdász',
    german: 'Wirtschaftswissenschaftler, Wirtschaftswissenschaftlerin',
    dutch: 'econoom',
    afrikaans: 'ekonoom',
    russian: 'экономист',
    latvian: 'ekonomists',
    polish: 'ekonomista',
    french: 'économiste',
    spanish: 'economista',
  },
  {
    av: 21562,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + chemistry)',
    english: 'chemist',
    swedish: 'kemist',
    norwegian: 'kjemiker',
    finnish: 'kemisti',
    hungarian: 'vegyész',
    german: 'Apotheker, Apothekerin, Drogist, Drogistin',
    dutch: 'scheikundige',
    afrikaans: 'chemikus, apteker',
    russian: 'химик',
    latvian: 'ķīmiķis',
    polish: 'chemik',
    french: 'chimiste',
    spanish: 'químico',
  },
  {
    av: 21563,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + biochemistry)',
    english: 'biochemist',
    swedish: 'biokemist',
    norwegian: 'biokjemiker',
    finnish: 'biokemisti',
    hungarian: 'biokémikus',
    german: 'Biochemiker, Biochemikerin',
    dutch: 'biochemicus',
    afrikaans: 'biochemikus',
    russian: 'биохимик',
    latvian: 'bioķīmiķis',
    polish: 'biochemik',
    french: 'biochimiste',
    spanish: 'bioquímico',
  },
  {
    av: 21564,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + biology)',
    english: 'biologist',
    swedish: 'biolog',
    norwegian: 'biolog',
    finnish: 'biologi',
    hungarian: 'biológus',
    german: 'Biologe, Biologin',
    dutch: 'bioloog',
    afrikaans: 'bioloog',
    russian: 'биолог',
    latvian: 'biologs',
    polish: 'biolog',
    french: 'biologiste',
    spanish: 'biólogo',
  },
  {
    av: 21565,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + botany)',
    english: 'botanist',
    swedish: 'botanist',
    norwegian: 'botaniker',
    finnish: 'kasvitieteilijä',
    hungarian: 'botanikus, növénytan-tudós',
    german: 'Botaniker, Botanikerin',
    dutch: 'plantkundige',
    afrikaans: 'plantkundige',
    russian: 'ботаник',
    latvian: 'botāniķis',
    polish: 'botanik',
    french: 'botaniste',
    spanish: 'botánico',
  },
  {
    av: 21566,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + zoology)',
    english: 'zoologist',
    swedish: 'zoolog',
    norwegian: 'zoolog',
    finnish: 'eläintieteilijä',
    hungarian: 'zoológis, állattan-tudós',
    german: 'Zoologe, Zoologin',
    dutch: 'dierkundige',
    afrikaans: 'dierkundige',
    russian: 'зоолог',
    latvian: 'zoologs',
    polish: 'zoolog',
    french: 'zoologue',
    spanish: 'zoólogo',
  },
  {
    av: 21567,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + geology)',
    english: 'geologist',
    swedish: 'geolog',
    norwegian: 'geolog',
    finnish: 'geologi, maantieteilijä',
    hungarian: 'geológus',
    german: 'Geologe, Geologin',
    dutch: 'geoloog',
    afrikaans: 'geoloog',
    russian: 'геолог',
    latvian: 'ģeoloģs',
    polish: 'geolog',
    french: 'géologue',
    spanish: 'geólogo',
  },
  {
    av: 21568,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + sociology)',
    english: 'sociologist',
    swedish: 'sociolog',
    norwegian: 'sosiolog',
    finnish: 'sosiologi',
    hungarian: 'szociológus',
    german: 'Soziologe, Soziologin',
    dutch: 'socioloog',
    afrikaans: 'sosioloog',
    russian: 'социолог',
    latvian: 'geologs',
    polish: 'socjolog',
    french: 'sociologue',
    spanish: 'sociólogo',
  },
  {
    av: 21569,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + history)',
    english: 'historian',
    swedish: 'historiker',
    norwegian: 'historiker',
    finnish: 'historioitsija',
    hungarian: 'történész',
    german: 'Historiker, Historikerin, Geschichtsforscher, Geschichtsforscherin',
    dutch: 'historicus',
    afrikaans: 'historikus',
    russian: 'историк',
    latvian: 'vēsturnieks',
    polish: 'historyk',
    french: 'historien',
    spanish: 'historiador',
  },
  {
    av: 21570,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + archeology)',
    english: 'archeologist',
    swedish: 'arkeolog',
    norwegian: 'arkeolog',
    finnish: 'arkeologi',
    hungarian: 'régész, archeológus',
    german: 'Archäologe, Archäologin',
    dutch: 'archeoloog',
    afrikaans: 'argeoloog',
    russian: 'археолог',
    latvian: 'arheologs',
    polish: 'archeolog',
    french: 'archéologue',
    spanish: 'arqueólogo',
  },
  {
    av: 21571,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + meteorology)',
    english: 'meteorologist',
    swedish: 'meteorolog',
    norwegian: 'meteorolog',
    finnish: 'meteorologi',
    hungarian: 'meteorológus',
    german: 'Metereologe, Metereologin',
    dutch: 'meteoroloog',
    afrikaans: 'weerkundige, meteoroloog',
    russian: 'метеоролог',
    latvian: 'sinoptiķis, meteorologs',
    polish: 'meteorolog',
    french: 'météorologue',
    spanish: 'meteorólogo',
  },
  {
    av: 21572,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + linguistics)',
    english: 'linguist',
    swedish: 'lingvist',
    norwegian: 'lingvist',
    finnish: 'kielitieteilijä, lingvisti',
    hungarian: 'nyelvész',
    german: 'Linguist, Linguistin',
    dutch: 'linguist, taalkundige',
    afrikaans: 'taalkundige, taalwetenskaplike',
    russian: 'лингвист',
    latvian: 'lingvists',
    polish: 'językoznawca, lingwista',
    french: 'linguiste',
    spanish: 'lingüista',
  },
  {
    av: 21573,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + mathematics, arithmetic, math (1))',
    english: 'mathematician (academic)',
    swedish: 'matematiker',
    norwegian: 'matematiker',
    finnish: 'matemaatikko',
    hungarian: 'matematikus, matematikatudós',
    german: 'Mathematiker, Mathematikerin (1)',
    dutch: 'wiskundige',
    afrikaans: 'wiskundige (akademikus)',
    russian: 'математик',
    latvian: 'matemātiķis',
    polish: 'matematyk, nauczyciel matematyki',
    french: 'mathématicien (scientifique)',
    spanish: 'matemático (académico)',
  },
  {
    av: 21574,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(doctor + child)',
    english: 'paediatrician',
    swedish: 'barnläkare',
    norwegian: 'barnelege',
    finnish: 'lastenlääkäri',
    hungarian: 'gyermekorvos',
    german: 'Kinderarzt, Kinderärztin, Pädiater',
    dutch: 'pediater, kinderarts',
    afrikaans: 'pediater, kinderarts',
    russian: 'педиатр',
    latvian: 'pediatrs, bērnu ārsts',
    polish: 'pediatra',
    french: 'pédiatre',
    spanish: 'pediatra',
  },
  {
    av: 21575,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(doctor + knife)',
    english: 'surgeon',
    swedish: 'kirurg',
    norwegian: 'kirurg',
    finnish: 'kirurgi',
    hungarian: 'sebész',
    german: 'Chirurg, Chirurgin',
    dutch: 'chirurg',
    afrikaans: 'chirurg',
    russian: 'хирург',
    latvian: 'ķirurgs',
    polish: 'chirurg',
    french: 'chirurgien',
    spanish: 'cirujano',
  },
  {
    av: 21576,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(doctor + ear + nose + neck (head): specialist doctor of ear, nose and throat)',
    english: 'otolaryngologist',
    swedish: 'öron näs och halsläkare',
    norwegian: 'øre nese halslege',
    finnish: 'korva- nenä- ja kurkkulääkäri',
    hungarian: 'fül-orr-gégész',
    german: 'Hals-Nasen-Ohren-Arzt, Hals-Nasen-Ohren-Ärztin',
    dutch: 'neus- keel- en oorarts (Vl), KNO-arts (Nl)',
    afrikaans: 'otolaryngologist, oor neus en keel spesialis',
    russian: 'отоларинголог',
    latvian: 'ausu, kakla un deguna ārsts, otorinolaringologs',
    polish: 'nasza (rodzaj żeński, l. mn. „mieć”)',
    french: 'oto-rhino-laryngologue, ORL',
    spanish: 'otorrinolaringólogo',
  },
  {
    av: 21577,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(doctor + bone)',
    english: 'orthopaedist',
    swedish: 'ortoped',
    norwegian: 'ortoped',
    finnish: 'ortopedi',
    hungarian: 'ortopédus',
    german: 'Orthopäde, Orthopädin',
    dutch: 'orthopedist',
    afrikaans: 'ortopeed',
    russian: 'ортопед',
    latvian: 'ortopēds',
    polish: 'ortopeda',
    french: 'orthopédiste',
    spanish: 'ortopedista',
  },
  {
    av: 21578,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(doctor + eye)',
    english: 'ophthalmologist, oculist',
    swedish: 'ögonläkare',
    norwegian: 'øyelege',
    finnish: 'silmälääkäri',
    hungarian: 'szemész',
    german: 'Augenarzt, Augenärztin',
    dutch: 'oogarts',
    afrikaans: 'oogarts',
    russian: 'офтальмолог',
    latvian: 'acu ārsts, okulists, oftalmologs',
    polish: 'okulista, optyk (lekarz)',
    french: 'ophtalmologue, oculiste',
    spanish: 'oftalmólogo, oculista',
  },
  {
    av: 21579,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(doctor + to advance + ability: physician who works to improve or restore physical abilities)',
    english: 'doctor (rehab, hab)',
    swedish: 'rehabiliteringsläkare, habiliteringsläkare',
    norwegian: 'rehabiliteringslege, habiliteringslege',
    finnish: 'kuntoutuslääkäri',
    hungarian: 'rehabilitációs szakorvos',
    german: 'Rehabilitationsarzt, Rehabilitationsärztin',
    dutch: 'revalidatiearts',
    afrikaans: 'dokter (rehabilitasie)',
    russian: 'реабилитолог',
    latvian: 'ārsts, rehabilitologs',
    polish: 'lekarz (specjalista od rehabilitacji, lekarz osób niepełnosprawnych)',
    french: 'médecin en rééducation fonctionnelle, médecin en réhabilitation',
    spanish: 'doctor (rehabilitación)',
  },
  {
    av: 21580,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(doctor + woman: physician who diagnoses and treats female reproduction organs)',
    english: 'gynecologist',
    swedish: 'gynekolog',
    norwegian: 'gynekolog',
    finnish: 'gynekologi, naistentautien erikoislääkäri',
    hungarian: 'nőgyógyász',
    german: 'Gynäkologe, Gynäkologin',
    dutch: 'gynaecoloog',
    afrikaans: 'ginekoloog',
    russian: 'генеколог',
    latvian: 'ginekologs',
    polish: 'ginekolog',
    french: 'gynécologue',
    spanish: 'ginecólogo',
  },
  {
    av: 21581,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(doctor + generalization: physician who treats a variety of medical problems)',
    english: 'general practitioner',
    swedish: 'allmänläkare',
    norwegian: 'almennpraktiker',
    finnish: 'yleislääkäri',
    hungarian: 'általános orvos, háziorvos',
    german:
      'Allgemeinmediziner, Allgemeinmedizinerin, Allgemeinarzt, Allgemeinärztin, Hausartzt, Hausärztin',
    dutch: 'huisarts',
    afrikaans: 'algemene praktiseer',
    russian: 'врач общей практики',
    latvian: 'ģimenes ārsts, praktizējošs ārsts',
    polish: 'lekarz ogólny, lekarz pierwszego kontaktu, lekarz rodzinny',
    french: 'médecin généraliste',
    spanish: 'médico general',
  },
  {
    av: 21582,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(doctor + heart + thing indicator: physician who diagnoses and treats disorders of the heart)',
    english: 'cardiologist',
    swedish: 'kardiolog',
    norwegian: 'kardiolog',
    finnish: 'sydänlääkäri, kardiologi',
    hungarian: 'kardiológus, szívgyógyász',
    german: 'Kardiologe, Kardiologin',
    dutch: 'cardioloog',
    afrikaans: 'kardioloog',
    russian: 'кардиолог',
    latvian: 'kardiologs',
    polish: 'kardiolog',
    french: 'cardiologue',
    spanish: 'cardiólogo',
  },
  {
    av: 21583,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(doctor + central nervous system + thing indicator: physician who diagnoses and treats disorders of the nervous system)',
    english: 'neurologist',
    swedish: 'neurolog',
    norwegian: 'nevrolog',
    finnish: 'neurologi',
    hungarian: 'ideggyógyász, neurológus',
    german: 'Neurologe, Neurologin',
    dutch: 'neuroloog',
    afrikaans: 'neuroloog',
    russian: 'невролог',
    latvian: 'neirologs',
    polish: 'neurolog',
    french: 'neurologue',
    spanish: 'neurólogo',
  },
  {
    av: 21584,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(doctor + mind: physician who diagnoses and treats mental illness)',
    english: 'psychiatrist',
    swedish: 'psykiater',
    norwegian: 'psykiater',
    finnish: 'psykiatri',
    hungarian: 'pszichiáter, elmeorvos',
    german: 'Psychiater',
    dutch: 'psychiater',
    afrikaans: 'psigiater',
    russian: 'психиатр',
    latvian: 'psihiatrs',
    polish: 'psychiatra',
    french: 'psychiatre',
    spanish: 'psiquiatra',
  },
  {
    av: 21585,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(brain signal + thing indicator: system consisting of brain and spinal cord which is activated by electrical impulses) - (character with thing indicator)',
    english: 'central nervous system, CNS',
    swedish: 'centrala nervsystem(et), CNS',
    norwegian: 'sentralnervesystemet',
    finnish: 'keskushermosto',
    hungarian: 'központi idegrendszer',
    german: 'Zentralnervensystem',
    dutch: 'centraal zenuwstelsel',
    afrikaans: 'sentrale senuwee stelsel',
    russian: 'центральная нервная система',
    latvian: 'centrālā nervu sistēma, CNS',
    polish: 'ośrodkowy uklad nerwowy',
    french: 'système nerveux central',
    spanish: 'sistema nervioso central',
  },
  {
    av: 21590,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(therapist + language)',
    english: 'speech therapist',
    swedish: 'logoped',
    norwegian: 'logoped',
    finnish: 'puheterapeutti',
    hungarian: 'logopédus, beszédterapeuta',
    german: 'Sprachtherapeut',
    dutch: 'logopedist',
    afrikaans: 'spraak terapeut',
    russian: 'логопед',
    latvian: 'runas terapeits, logopēds',
    polish: 'logopeda',
    french: 'logopède, orthophoniste',
    spanish: 'logopeda',
  },
  {
    av: 21591,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(therapist + activity)',
    english: 'occupational therapist',
    swedish: 'arbetsterapeut',
    norwegian: 'aktivitør, arbeidsterapeut',
    finnish: 'toimintaterapeutti',
    hungarian: 'foglalkoztató terapeuta, ergoterapeuta',
    german: 'Ergotherapeut, Ergotherapeutin',
    dutch: 'ergotherapeut',
    afrikaans: 'arbeids terapeut',
    russian: 'трудотерапевт',
    latvian: 'darba terapeits',
    polish: 'terapeuta zajęciowy',
    french: 'ergothérapeute',
    spanish: 'terapeuta ocupacional',
  },
  {
    av: 21592,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(therapist + muscle)',
    english: 'physiotherapist',
    swedish: 'sjukgymnast',
    norwegian: 'fysioterapeut',
    finnish: 'fysioterapeutti',
    hungarian: 'gyógytornász, fizioterapeuta, mozgásfejlesztő ',
    german: 'Physiotherapeut, Physiotherapeutin',
    dutch: 'fysiotherapeut, kinesist (Vl)',
    afrikaans: 'fisio terapeut',
    russian: 'физиотерапевт',
    latvian: 'fizioterapeits',
    polish: 'fizjoterapeuta',
    french: 'kinésithérapeute, physiothérapeute',
    spanish: 'fisioterapeuta',
  },
  {
    av: 21593,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(therapist + ear [hearing])',
    english: 'audiologist',
    swedish: 'audionom, hörselassistent',
    norwegian: 'audiopedagog',
    finnish: 'kuulontutkija, audiologi',
    hungarian: 'audiológus',
    german: 'Audiologe, Audiologin',
    dutch: 'audioloog, akoepedist',
    afrikaans: 'oudioloog',
    russian: 'аудиолог',
    latvian: 'audiologs',
    polish: 'audiolog',
    french: 'audiologue, audiologiste',
    spanish: 'audiólogo',
  },
  {
    av: 21594,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(therapist + eye [vision])',
    english: 'orthoptist',
    swedish: 'ortoptist',
    norwegian: 'ortoptist',
    finnish: 'näönkäytönohjaaja, näönkuntouttaja',
    hungarian: 'ortoptikus',
    german: 'Orthoptist, Orthoptistin',
    dutch: 'orthoptist',
    afrikaans: 'orthoptist',
    russian: 'ортоптист',
    latvian: 'ortoptists',
    polish: 'ortopysta (lekarz zajmujący się zaburzeniami widzenia obuocznego)',
    french: 'thérapeute (œil), orthoptiste',
    spanish: 'optometrista',
  },
  {
    av: 21595,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(therapist + communication)',
    english: 'communication therapist',
    swedish: 'kommunikationsterapeut',
    norwegian: 'kommunikasjonsterapeut',
    finnish: 'kommunikaatioterapeutti',
    hungarian: 'kommunikációs terapeuta, AAK-terapeuta',
    german: 'Kommunikationstherapeut, Kommunikationstherapeutin',
    dutch: 'communicatietherapeut',
    afrikaans: 'kommunikasie terapeut',
    russian: 'специалист по коммуникации',
    latvian: 'komunikācijas terapeits',
    polish: 'terapeuta porozumiewania się, terapeuta komunikacji',
    french: 'thérapeute en communication',
    spanish: 'terapeuta de comunicación',
  },
  {
    av: 21596,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(therapist + foot)',
    english: 'podiatrist, chiropodist',
    swedish: 'fotterapeut, fotvårdare, fotvårdsspecialist',
    norwegian: 'fotterapeut',
    finnish: 'jalkaterapeutti, jalkojenhoitaja',
    hungarian: 'lábápoló',
    german: 'Fußspezialist, Fußspezialistin, Fußpfleger, Fußpflegerin',
    dutch: 'pedicure (persoon)',
    afrikaans: 'voetheelkundige',
    russian: 'ортопед',
    latvian: 'ortopēds',
    polish: 'pedicurzysta',
    french: 'podologue, podologiste, chiropodiste',
    spanish: 'podólogo',
  },
  {
    av: 21597,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(therapist + water)',
    english: 'hydrotherapist',
    swedish: 'hydroterapeut',
    norwegian: 'vannterapeut',
    finnish: 'vesiterapeutti',
    hungarian: 'hidroterapeuta',
    german: 'Hydrotherapeut, Hydrotherapeutin',
    dutch: 'hydrotherapeut',
    afrikaans: 'hydroterapeut',
    russian: 'гидротерапевт',
    latvian: 'hidroterapeits',
    polish: 'hydroterapeuta',
    french: 'hydrothérapeute',
    spanish: 'hidroterapeuta',
  },
  {
    av: 21598,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(therapist + music)',
    english: 'music therapist',
    swedish: 'musikterapeut',
    norwegian: 'musikkterapeut',
    finnish: 'musiikkiterapeutti',
    hungarian: 'zeneterapeuta',
    german: 'Musiktherapeut, Musiktherapeutin',
    dutch: 'muziektherapeut',
    afrikaans: 'musiek terapeut',
    russian: 'музыкальный терапевт',
    latvian: 'mūzikas terapeits',
    polish: 'muzykoterapeuta',
    french: 'musicothérapeute',
    spanish: 'terapeuta musical',
  },
  {
    av: 21599,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(therapist + dance)',
    english: 'dance therapist',
    swedish: 'dansterapeut',
    norwegian: 'danseterapeut',
    finnish: 'tanssiterapeutti',
    hungarian: 'táncterapeuta',
    german: 'Tanztherapeut, Tanztherapeutin',
    dutch: 'danstherapeut',
    afrikaans: 'dans terapeut',
    russian: 'танцевальный терапевт',
    latvian: 'dejas terapeits',
    polish: 'choreoterapeuta, terapeuta zajmujący się terapią tańca',
    french: 'thérapeute de danse',
    spanish: 'terapeuta de baile',
  },
  {
    av: 21600,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + hand + bone: person who treats medical disorders by manipulation techniques)',
    english: 'osteopath',
    swedish: 'osteopat',
    norwegian: 'osteopat',
    finnish: 'osteopaatti',
    hungarian: 'csontkovács',
    german: 'Osteopath, Osteopathin',
    dutch: 'osteopaat, manueel therapeut',
    afrikaans: 'osteopaat',
    russian: 'остеопат',
    latvian: 'kaulu ārsts, osteopāts',
    polish: 'kręgarz, osteopata',
    french: 'ostéopathe',
    spanish: 'osteópata',
  },
  {
    av: 21601,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + hand + joint: person who treats medical disorders by manipulation of the spinal column and other structures)',
    english: 'chiropractor',
    swedish: 'kiropraktor',
    norwegian: 'kiropraktor',
    finnish: 'kiropraktikko',
    hungarian: 'csontrakó, csontkovács, kiropraktor',
    german: 'Chiropraktiker, Chiropraktikerin',
    dutch: 'chiropractor',
    afrikaans: 'chiropraktisyn',
    russian: 'костоправ',
    latvian: 'kaulu slimību ārsts, hiropraktiķis',
    polish: 'kręgarz',
    french: 'chiropracteur, chiropraticien',
    spanish: 'quiropráctico',
  },
  {
    av: 21602,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + hand + muscle: person who manipulates the body to relax muscles)',
    english: 'masseur',
    swedish: 'massör',
    norwegian: 'massør',
    finnish: 'hieroja',
    hungarian: 'masszőr',
    german: 'Masseur, Masseurin',
    dutch: 'masseur',
    afrikaans: 'masseur, masseuse',
    russian: 'массажист',
    latvian: 'masieris',
    polish: 'masażysta',
    french: 'masseur',
    spanish: 'masajista',
  },
  {
    av: 21603,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + hand + smell: person who gives therapy, based of different scents)',
    english: 'aroma therapist',
    swedish: 'aromterapeut',
    norwegian: 'aromaterapeut',
    finnish: 'aromaterapeutti',
    hungarian: 'aromaterapeuta',
    german: 'Aromatherapeut, Aromatherpeutin',
    dutch: 'aromatherapeut',
    afrikaans: 'aroma terapeut',
    russian: 'ароматерапевт',
    latvian: 'aromaterapeits',
    polish: 'aromoterapeuta, specjalista od aromaterapii',
    french: 'aromathérapeute',
    spanish: 'terapeuta de aromaterapia',
  },
  {
    av: 21604,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + hand + foot: person who gives therapy, based on manipulation of different zones of the foot)',
    english: 'reflexologist',
    swedish: 'reflexologist',
    norwegian: 'refleksolog',
    finnish: 'refleksologi',
    hungarian: 'reflexológus',
    german:
      'Reflexzonenmasseur, Reflexzonenmasseurin, Fußreflexzonenmasseur, Fußreflexzonenmasseurin',
    dutch: 'voetreflexoloog',
    afrikaans: 'refleksoloog',
    russian: 'рефлексолог',
    latvian: 'refleksologs',
    polish: 'terapeuta refleksologii',
    french: 'réflexologue',
    spanish: 'reflexólogo',
  },
  {
    av: 21605,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + hand + linear thing + thing indicator: person who treats illness by puncturing the body with needles)',
    english: 'acupuncturist',
    swedish: 'akupunktör',
    norwegian: 'akupunktör',
    finnish: 'akupunktion antaja',
    hungarian: 'akupunkturista, akupuntúrával gyógyító',
    german: 'Akupunkteur, Akupunkteurin',
    dutch: 'acupuncturist',
    afrikaans: 'akupunkturis',
    russian: ' акупунтолог',
    latvian: 'akupunktūras speciālists',
    polish: 'specjalista od akupunktury',
    french: 'acupuncteur',
    spanish: 'acupunturista',
  },
  {
    av: 21606,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + hand + muscle: manipulation of the body to relax muscles)',
    english: 'massage',
    swedish: 'massage',
    norwegian: 'massasje',
    finnish: 'hieronta',
    hungarian: 'masszázs, maszírozás',
    german: 'Massage',
    dutch: 'massage',
    afrikaans: 'massering',
    russian: 'массаж',
    latvian: 'masāža',
    polish: 'masaż',
    french: 'massage',
    spanish: 'masaje',
  },
  {
    av: 21608,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(view of life + group: view of life shared by a group of people)',
    english: 'culture',
    swedish: 'kultur',
    norwegian: 'kultur',
    finnish: 'kulttuuri',
    hungarian: 'kultúra',
    german: 'Kultur',
    dutch: 'cultuur',
    afrikaans: 'kultuur',
    russian: 'культура',
    latvian: 'kultūra ',
    polish: 'kultura',
    french: 'culture',
    spanish: 'cultura',
  },
  {
    av: 21609,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group + view of life: group of people who share a common culture)',
    english: 'people, tribe, clan, folk',
    swedish: 'folkgrupp, stam (etc)',
    norwegian: 'folkegruppe, stamme',
    finnish: 'kansa, heimo, klaani',
    hungarian: 'népcsoport, törzs, nép, emberek, nemzetség, klán',
    german: 'Volk, Stamm, Sippe',
    dutch: 'volk, stam',
    afrikaans: 'volk, stam, mense',
    russian: 'этническая группа, народность',
    latvian: 'cilvēki, ļaudis, tauta, cilts, klans',
    polish: 'plemię, szczep, klan',
    french: 'peuple, tribu, clan',
    spanish: 'pueblo, tribu, clan, folk',
  },
  {
    av: 21610,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group + country: group of people organized under a single government)',
    english: 'nation',
    swedish: 'nation',
    norwegian: 'nasjon',
    finnish: 'kansakunta, kansalaiset',
    hungarian: 'nemzet',
    german: 'Nation',
    dutch: 'natie, volk',
    afrikaans: 'nasie, volk',
    russian: 'нация',
    latvian: 'nācija',
    polish: 'naród',
    french: 'nation',
    spanish: 'nación',
  },
  {
    av: 21611,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(music + culture)',
    english: 'folk music',
    swedish: 'folkmusik',
    norwegian: 'folkemusikk',
    finnish: 'kansanmusiikki',
    hungarian: 'népzene',
    german: 'Volksmusik, Folk',
    dutch: 'volksmuziek',
    afrikaans: 'volksmusiek, tradisionele musiek',
    russian: 'народная музыка, фольклорная музыка',
    latvian: 'tautas mūzika',
    polish: 'muzyka ludowa, folk',
    french: 'musique folklorique',
    spanish: 'música folclórica',
  },
  {
    av: 21612,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(to destroy + a people: systematic annihilation of a racial, political or cultural group)',
    english: 'genocide, holocaust',
    swedish: 'förintelse, holocaust',
    norwegian: 'utryddelse, holocaust',
    finnish: 'kansanmurha',
    hungarian: 'népirtás, holokauszt',
    german: 'Genozid, Völkermord, Holocaust',
    dutch: 'genocide, holocaust',
    afrikaans: 'volksmoord, holocaust',
    russian: 'геноцид, холокост',
    latvian: 'genocīds, holokausts',
    polish: 'ludobójstwo, holocaust',
    french: 'génocide, holocauste',
    spanish: 'genocidio, holocausto',
  },
  {
    av: 21613,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + head)',
    english: 'headscarf',
    swedish: 'scarf',
    norwegian: 'skaut, skjerf',
    finnish: 'päässä pidettävä huivi',
    hungarian: 'fejkendő',
    german: 'Kopftuch',
    dutch: 'hoofddoek',
    afrikaans: 'hoofdoek, kopdoek',
    russian: 'головной платок',
    latvian: 'galvas lakats',
    polish: 'chusta na głowę',
    french: 'voile (tête), fichu, foulard',
    spanish: 'pañuelo, bufanda',
  },
  {
    av: 21614,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + face)',
    english: 'veil',
    swedish: 'slöja',
    norwegian: 'slør',
    finnish: 'huntu',
    hungarian: 'fátyol, arcfátyol',
    german: 'Schleier',
    dutch: 'sluier',
    afrikaans: 'sluier',
    russian: 'вуаль, паранджа',
    latvian: 'plīvurs',
    polish: 'welon',
    french: 'voile, hijab',
    spanish: 'velo',
  },
  {
    av: 21615,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(protection + intensity + head: strong protection for the head) Preferred NEW SYNONYM, replacing 14703',
    english: 'helmet',
    swedish: 'hjälm',
    norwegian: 'hjelm',
    finnish: 'kypärä',
    hungarian: 'sisak, védősisak',
    german: 'Helm',
    dutch: 'helm',
    afrikaans: 'helm',
    russian: 'шлем',
    latvian: 'ķivere',
    polish: 'hełm, kask',
    french: 'casque',
    spanish: 'casco',
  },
  {
    av: 21616,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(helmet + horse: helmet worn when riding a horse)',
    english: 'riding helmet',
    swedish: 'ridhjälm',
    norwegian: 'ridehjelm',
    finnish: 'ratsastuskypärä',
    hungarian: 'sisak – lovas, kobak',
    german: 'Reithelm',
    dutch: 'tok (Vl), rijhelm',
    afrikaans: 'valhelm',
    russian: 'шлем конный',
    latvian: 'ķivere (žokeja)',
    polish: 'toczek (kask do jazdy konnej)',
    french: "bombe d'équitation",
    spanish: 'casco de montar',
  },
  {
    av: 21617,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(helmet + sport stick and puck, hockey stick (ice hockey [contr.]))',
    english: 'hockey helmet',
    swedish: 'hockeyhjälm',
    norwegian: 'hockeyhjelm',
    finnish: 'jääkiekkokypärä',
    hungarian: 'sisak – hoki, hokifejvédő',
    german: 'Hockeyhelm',
    dutch: 'ijshockeyhelm',
    afrikaans: 'hokkie helm',
    russian: 'шлем хоккейный',
    latvian: 'ķivere (hokejista)',
    polish: 'kask hokejowy',
    french: 'casque de hockey',
    spanish: 'casco de hockey',
  },
  {
    av: 21618,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(helmet + bicycle)',
    english: 'bicycle helmet, crash helmet',
    swedish: 'cykelhjälm',
    norwegian: 'sykkelhjelm',
    finnish: 'pyöräilykypärä',
    hungarian: 'sisak – kerékpár, kerékpáros sisak',
    german: 'Fahrradhelm',
    dutch: 'fietshelm',
    afrikaans: 'fiets helm, val helm',
    russian: 'шлем велосипедный',
    latvian: 'ķivere (velosipēdista)',
    polish: 'kask rowerowy, kask',
    french: 'casque de cycliste',
    spanish: 'casco de bicicleta',
  },
  {
    av: 21619,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + intensity + knee)',
    english: 'knee pad',
    swedish: 'knäskydd',
    norwegian: 'knebeskytter',
    finnish: 'polvisuojus',
    hungarian: 'védőpárna – térd, térdvédő',
    german: 'Knieschützer, Knieschoner',
    dutch: 'kniebeschermer',
    afrikaans: 'knieg beskermer',
    russian: 'наколенники',
    latvian: 'ceļgalu aizsargi',
    polish: 'ochraniacz na kolano',
    french: 'genouillère',
    spanish: 'rodillera',
  },
  {
    av: 21620,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + intensity + elbow)',
    english: 'elbow pad',
    swedish: 'armbågsskydd',
    norwegian: 'albuebeskytter',
    finnish: 'kyynärpääsuojus, kyynärsuojus',
    hungarian: 'védőpárna – könyök, könyökvdő',
    german: 'Ellbogenschoner',
    dutch: 'elleboogbeschermer',
    afrikaans: 'elmboog beskermer',
    russian: 'налокотники',
    latvian: 'elkoņu aizsargi',
    polish: 'ochraniacz na łokieć',
    french: 'coudière, protège-coude',
    spanish: 'codera',
  },
  {
    av: 21621,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + intensity + face)',
    english: 'protective mask',
    swedish: 'skyddsmask',
    norwegian: 'beskyttelsesmaske',
    finnish: 'kasvosuojus',
    hungarian: 'védőmaszk, arcvédő',
    german: 'Schutzmaske',
    dutch: 'gezichtsbeschermer',
    afrikaans: 'veiligheids masker',
    russian: 'защитная маска',
    latvian: 'sejas aizsargmaska',
    polish: 'maska ochronna',
    french: 'masque de protection',
    spanish: 'máscara protectora',
  },
  {
    av: 21622,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + intensity + body)',
    english: 'suit of armour',
    swedish: 'rustning',
    norwegian: 'rustning',
    finnish: 'rintapanssari',
    hungarian: 'vért, vértezet, páncélruha, páncélzat',
    german: '(Ritter) Rüstung',
    dutch: 'harnas',
    afrikaans: 'harnas',
    russian: 'доспехи, бронежилет',
    latvian: 'ložu aizsargveste',
    polish: 'zbroja',
    french: 'armure',
    spanish: 'armadura',
  },
  {
    av: 21625,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball)',
    english: 'ball sports',
    swedish: 'bollsport',
    norwegian: 'ballsport',
    finnish: 'palloilu',
    hungarian: 'labdajáték, labdasport',
    german: 'Ballsportart',
    dutch: 'balsport',
    afrikaans: 'bal sport',
    russian: 'спортивные игры с мячом',
    latvian: 'sporta bumba',
    polish: 'sporty zespołowe',
    french: 'sports de balle',
    spanish: 'pelota de deportes',
  },
  {
    av: 21626,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + water)',
    english: 'water sports',
    swedish: 'vattensport',
    norwegian: 'vannsport',
    finnish: 'vesiurheilu',
    hungarian: 'vízisport',
    german: 'Wassersport',
    dutch: 'watersport',
    afrikaans: 'water sport',
    russian: 'водный спорт',
    latvian: 'ūdenssports',
    polish: 'sporty wodne',
    french: 'sports nautiques',
    spanish: 'deportes acuáticos',
  },
  {
    av: 21627,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + to fight)',
    english: 'contact sports',
    swedish: 'kampsport',
    norwegian: 'kampsport',
    finnish: 'kamppailulaji',
    hungarian: 'kontaktsport',
    german: 'Kontaktsport, Kontaktsportarten',
    dutch: 'vechtsport',
    afrikaans: 'kontak sport',
    russian: 'контактный спорт',
    latvian: 'kontakta sporta veids',
    polish: 'sporty kontaktowe, sporty walki',
    french: 'sport de contact',
    spanish: 'deportes de contacto',
  },
  {
    av: 21628,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + beginning: the original sports/contests)',
    english: 'athletics',
    swedish: 'friidrott',
    norwegian: 'friidrett (sport)',
    finnish: 'yleisurheilu',
    hungarian: 'atlétika',
    german: 'Leichtathletik',
    dutch: 'atletiek',
    afrikaans: 'atletiek',
    russian: 'атлетика',
    latvian: 'atlētika',
    polish: 'lekkoatletyka (sport)',
    french: 'athlétisme',
    spanish: 'atletismo',
  },
  {
    av: 21629,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + horse)',
    english: 'equestrian sports',
    swedish: 'hästsport',
    norwegian: 'hestesport',
    finnish: 'hevosurheilu',
    hungarian: 'lovassport',
    german: 'Reitsport, Pferdesport',
    dutch: 'paardensport',
    afrikaans: 'perde sport',
    russian: 'конный спорт',
    latvian: 'jāšana',
    polish: 'jeździectwo (sporty konne)',
    french: 'sport(s) équestre',
    spanish: 'deportes ecuestres',
  },
  {
    av: 21630,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + snow)',
    english: 'winter sports',
    swedish: 'vintersport',
    norwegian: 'vintersport',
    finnish: 'talviurheilu',
    hungarian: 'téli sport',
    german: 'Wintersport',
    dutch: 'wintersport',
    afrikaans: 'winter sport',
    russian: 'зимний вид спорта',
    latvian: 'ziemas sporta veidi',
    polish: 'sporty zimowe',
    french: "sports d'hiver",
    spanish: 'deportes de invierno',
  },
  {
    av: 21794,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + motor)',
    english: 'motor sports',
    swedish: 'motorsport',
    norwegian: 'motorsport',
    finnish: 'moottoriurheilu',
    hungarian: 'motorsport, motoros sport',
    german: 'Motorsport',
    dutch: 'motorsport',
    afrikaans: 'motor sport',
    russian: 'мотоспорт',
    latvian: 'motoru sports',
    polish: 'sporty motorowe',
    french: 'sport moteur',
    spanish: 'deportes de motor',
  },
  {
    av: 21795,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + mountain)',
    english: 'mountain sports',
    swedish: 'klättersport',
    norwegian: 'klatresport',
    finnish: 'alppiurheilu, alppilajit',
    hungarian: 'hegymászó sport',
    german: 'Bergsport',
    dutch: 'bergsport',
    afrikaans: 'berg sport',
    russian: 'горный спорт',
    latvian: 'kalnu sporta veidi',
    polish: 'sporty górskie',
    french: 'sport de montagne',
    spanish: 'deportes de montaña',
  },
  {
    av: 21796,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + sky)',
    english: 'sky sports',
    swedish: 'sport utövad i luften',
    norwegian: 'luftsport, sport utøvd i lufta',
    finnish: 'ilmaurheilu',
    hungarian: 'levegő sportok',
    german: 'Skisport',
    dutch: 'luchtsport',
    afrikaans: 'lug sport',
    russian: 'воздушный спорт',
    latvian: 'gaisa sporta veidi',
    polish: 'sporty powietrzne (lotniarstwo, paralotniarstwo, skoki spadochronowe itp.)',
    french: 'sport aérien',
    spanish: 'deportes aéreos',
  },
  {
    av: 21797,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + gun)',
    english: 'shooting sports',
    swedish: 'skytte',
    norwegian: 'skytesport',
    finnish: 'ampumaurheilu',
    hungarian: 'lövészet',
    german: 'Schießsport',
    dutch: 'schietsport',
    afrikaans: 'skiet sport, skyfskiet',
    russian: 'стрелковый спорт',
    latvian: 'šaušanas sporta veidi',
    polish: 'zawody strzeleckie (sport)',
    french: 'tir (sport)',
    spanish: 'deportes de tiro',
  },
  {
    av: 21798,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sport + muscle + design: sport in which movements are carefully planned)',
    english: 'gymnastics',
    swedish: 'gymnastik',
    norwegian: 'gymnastikk, turn (sport)',
    finnish: 'voimistelu',
    hungarian: 'torna, gimnasztika',
    german: 'Gymnastik',
    dutch: 'turnen, gymnastiek',
    afrikaans: 'gimnastiek',
    russian: 'гимнастика',
    latvian: 'vingrošana',
    polish: 'gimnastyka',
    french: 'gymnastique (sport)',
    spanish: 'gimnasia',
  },
  {
    av: 21799,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + mind)',
    english: 'mind sports',
    swedish: 'tankesport',
    norwegian: 'tankesport',
    finnish: 'aivourheilu',
    hungarian: 'elmesport',
    german: 'Denksport',
    dutch: 'denksport',
    afrikaans: 'gedagte sport',
    russian: 'интеллектуальный спорт',
    latvian: 'analītiskie sporta veidi',
    polish: 'sporty umysłowe (np. szachy)',
    french: 'sport cérébral',
    spanish: 'deportes de estrategia',
  },
  {
    av: 21800,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + table)',
    english: 'table sports',
    swedish: 'sport utövad på bord',
    norwegian: 'bordsport ',
    finnish: 'pöytäurheilulajit',
    hungarian: 'asztali sport, asztali játék',
    german: 'Tischsportarten',
    dutch: 'tafelsport',
    afrikaans: 'tafel sport',
    russian: 'настольный вид спорта',
    latvian: 'galda sporta veidi',
    polish: 'stół sportowy',
    french: 'sport de table',
    spanish: 'deportes de mesa',
  },
  {
    av: 21801,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + boat)',
    english: 'boating',
    swedish: 'båtsport',
    norwegian: 'båtsport',
    finnish: 'veneily',
    hungarian: 'hajósport',
    german: 'Bootfahren',
    dutch: 'varen (sport)',
    afrikaans: 'boot sport',
    russian: 'лодочный спорт',
    latvian: 'airēšana',
    polish: 'pływanie łodzią (sport)',
    french: 'canotage (sport)',
    spanish: 'deportes en botes',
  },
  {
    av: 21803,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball + linear thing (bat [contr.]) + thing indicator)',
    english: 'stickball',
    swedish: 'brännboll',
    norwegian: 'stikkball (sport)',
    finnish: 'pesäpallo',
    hungarian: 'ütősport',
    german: 'Stockball (Spiel)',
    dutch: 'slagbal',
    afrikaans: 'stokbalspel',
    russian: 'городошный спорт',
    latvian: 'ielas beisbols',
    polish: 'stickball, bejsbol uliczny',
    french: 'stickball (sport)',
    spanish: 'stickball, béisbol callejero',
  },
  {
    av: 21804,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball + to hit)',
    english: 'volleyball',
    swedish: 'volleyboll',
    norwegian: 'volleyball (sport)',
    finnish: 'lentopallo',
    hungarian: 'röplabda',
    german: 'Volleyballspiel',
    dutch: 'volleybal',
    afrikaans: 'vlugbal',
    russian: 'волейбол',
    latvian: 'volejbols',
    polish: 'siatkówka (sport)',
    french: 'volleyball',
    spanish: 'voleibol',
  },
  {
    av: 21805,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball + water)',
    english: 'water polo',
    swedish: 'vattenpolo',
    norwegian: 'vannpolo (sport)',
    finnish: 'vesipoolo',
    hungarian: 'vízilabda, vízipóló',
    german: 'Wasserball',
    dutch: 'waterpolo',
    afrikaans: 'water polo',
    russian: 'водное поло',
    latvian: 'ūdenspolo',
    polish: 'piłka wodna (sport)',
    french: 'water-polo',
    spanish: 'waterpolo',
  },
  {
    av: 21806,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball field + measurement)',
    english: 'boules, boccia (sport)',
    swedish: 'boccia, boule',
    norwegian: 'boccia, boule (sport)',
    finnish: 'boccia, petankki, pukka',
    hungarian: 'golyósport, boules',
    german: 'Boule, Boccia',
    dutch: 'jeu de boules, boccia, petanque',
    afrikaans: 'rolbal',
    russian: 'боча(спортивная игра)',
    latvian: 'boccia, boule',
    polish: 'gra w bule, gra w kule (sport)',
    french: 'pétanque (sport)',
    spanish: 'petanca, bocha',
  },
  {
    av: 21808,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball + wicket)',
    english: 'cricket',
    swedish: 'kricket',
    norwegian: 'cricket (sport)',
    finnish: 'kriketti',
    hungarian: 'krikettjáték',
    german: 'Kricket',
    dutch: 'cricket',
    afrikaans: 'krieket',
    russian: 'крикет',
    latvian: 'krikets',
    polish: 'krykiet (sport)',
    french: 'cricket (sport)',
    spanish: 'criquet',
  },
  {
    av: 21810,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bicycle + motor)',
    english: 'motorcycle, scooter',
    swedish: 'moped, motorcykel, skoter',
    norwegian: 'moped, motorsykkel, scooter',
    finnish: 'moottoripyörä, mopo, skootteri',
    hungarian: 'motorkerékpár, robogó',
    german: 'Motorrad',
    dutch: 'motorfiets, bromfiets, brommer',
    afrikaans: 'motorfiets, bromponie',
    russian: 'мотоцикл, мопед',
    latvian: 'motocikls, mopēds, skūteris',
    polish: 'motocykl, skuter',
    french: 'motocyclette, moto, scooter, vélomoteur',
    spanish: 'motocicleta, scooter',
  },
  {
    av: 21811,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(bicycle + legs and feet: bicycle operated with legs and feet) Vehicles have different names in different countries.',
    english: 'scooter',
    swedish: 'sparkcykel',
    norwegian: 'sparkesykkel',
    finnish: 'potkulauta, potkupyörä',
    hungarian: 'roller',
    german: 'Roller',
    dutch: 'step, autoped',
    afrikaans: "gyro's",
    russian: 'самокат, скутер',
    latvian: 'skrejrats',
    polish: 'hulajnoga',
    french: 'trottinette',
    spanish: 'scooter',
  },
  {
    av: 21812,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(tricycle + electricity) Vehicles have different names in different countries.',
    english: 'scooter (3 wheeled electric)',
    swedish: 'elmoped',
    norwegian: 'elmoped, moped elektrisk drevet',
    finnish: '3-pyöräinen mopo, invamopo',
    hungarian: 'háromkerekű elektromos roller',
    german: 'Scooter, elektrisches Dreirad',
    dutch: 'scooter (drie wielen)',
    afrikaans: 'driewiel elektries',
    russian: 'скутер (электрический)',
    latvian: 'skūteris, elektriskais',
    polish: 'skuter (3 kołowy, elektryczny)',
    french: 'scooter électrique à 3 roues',
    spanish: 'scooter (3 ruedas y eléctrico)',
  },
  {
    av: 21814,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bicycle + hand: bicycle operated with the hands)',
    english: 'handcycle',
    swedish: 'handcykel',
    norwegian: 'håndsykkel',
    finnish: 'käsipolkupyörä',
    hungarian: 'kerékpár – kéti hajtású, kézi bringa, handcycle',
    german: 'Handbike, Rollstuhlbike',
    dutch: 'handbike',
    afrikaans: 'ware sportstoele',
    russian: 'велосипед с ручным приводом',
    latvian: 'rokas motocikls',
    polish: 'rower z napędem ręcznym',
    french: 'vélo manuel',
    spanish: 'bicicleta de mano',
  },
  {
    av: 21815,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bicycle + reclining, lying (person lying down))',
    english: 'recumbent bicycle',
    swedish: 'liggcykel',
    norwegian: 'liggesykkel',
    finnish: 'nojapyörä, recumbent',
    hungarian: 'kerékpár – fekvő',
    german: 'Liegerad',
    dutch: 'ligfiets',
    afrikaans: 'ligfiets',
    russian: 'лежачий велосипед (лигерад)',
    latvian: 'guļus velosipēds',
    polish: 'rower poziomy (kierowany w pozycji „leżącej”)',
    french: 'vélo couché',
    spanish: 'bicicleta reclinada',
  },
  {
    av: 21816,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bicycle + two + person)',
    english: 'tandem bicycle',
    swedish: 'tandemcykel',
    norwegian: 'tandemsykkel',
    finnish: 'tandempyörä',
    hungarian: 'kerékpár – tandem',
    german: 'Tandem',
    dutch: 'tandem',
    afrikaans: 'tandem fiets',
    russian: 'тандем',
    latvian: 'tandēma velosipēds',
    polish: 'rower tandem',
    french: 'bicyclette tandem',
    spanish: 'bicicleta tándem',
  },
  {
    av: 21817,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bicycle + mountain)',
    english: 'mountain bike',
    swedish: 'mountainbike',
    norwegian: 'mountainbike',
    finnish: 'maastopyörä',
    hungarian: 'kerékpár – mountain bike',
    german: '(geländegängiges) Fahrrad, Mountainbike',
    dutch: 'mountain bike (berg)',
    afrikaans: 'berg fiets',
    russian: 'горный велосипед',
    latvian: 'kalnu velosipēds',
    polish: 'rower górski',
    french: 'vélo de montagne',
    spanish: 'bicicleta de montaña',
  },
  {
    av: 21818,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bicycle + countryside)',
    english: 'ATB, all-terrain bike',
    swedish: 'terrängcykel',
    norwegian: 'terrengsykkel',
    finnish: 'maastopyörä',
    hungarian: 'kerékpár – ATB, terep kerékpár',
    german: 'Geländefahrrad, Mountainbike',
    dutch: 'mountain bike (ATB)',
    afrikaans: 'berg fiets',
    russian: 'вседорожный велосипед',
    latvian: 'visurgājējs velosipēds',
    polish: 'rower terenowy',
    french: 'vélo tout terrain',
    spanish: 'bicicleta todoterreno',
  },
  {
    av: 21819,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bicycle + wheelchair)',
    english: 'wheelchair bike',
    swedish: 'rullstolscykel',
    norwegian: 'rullestolsykkel',
    finnish: 'pyörätuolipyörä',
    hungarian: 'kerékpár – kerekesszékes, kerekesszékkel',
    german: 'Rollstuhlfahrrad, Rolli-Bike',
    dutch: 'rolstoelfiets',
    afrikaans: 'rolstoel fiets',
    russian: 'инвалидная велоколяска',
    latvian: 'invalīdu velosipēds',
    polish: 'rower inwalidzki',
    french: 'vélo chaise roulante',
    spanish: 'bicicleta adaptada',
  },
  {
    av: 21821,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(plus + transport, transportation (cart [modification]): a car added to another vehicle)',
    english: 'sidecar (motorcycle)',
    swedish: 'sidovagn',
    norwegian: 'sidevogn',
    finnish: 'sivuvaunu',
    hungarian: 'oldalkocsi (motorhoz)',
    german: 'Beiwagen',
    dutch: 'zijspan',
    afrikaans: 'syspan (motorfiets)',
    russian: 'коляска мотоциклетная',
    latvian: 'motocikla blakusvāģis',
    polish: 'kosz motocyklowy, przyczepka motocykla',
    french: 'side-car (moto)',
    spanish: 'sidecar (motocicleta)',
  },
  {
    av: 21822,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(car + small)',
    english: 'go-kart, kart',
    swedish: 'gokart',
    norwegian: 'gokart',
    finnish: 'mikroauto, karting-auto',
    hungarian: 'gokart',
    german: 'Gokart',
    dutch: 'gocart',
    afrikaans: 'go-cart',
    russian: 'карт',
    latvian: 'gokarts, karts ',
    polish: 'gokart',
    french: 'go-cart, go-kart, karting',
    spanish: 'kart',
  },
  {
    av: 21823,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + bicycle)',
    english: 'cycling',
    swedish: 'cykelsport',
    norwegian: 'sykkelsport',
    finnish: 'pyöräily',
    hungarian: 'kerékpársport',
    german: 'Radfahren',
    dutch: 'wielrennen, wielersport',
    afrikaans: 'fietsry',
    russian: 'велоспорт',
    latvian: 'riteņbraukšana',
    polish: 'kolarstwo (sport)',
    french: 'cyclisme (sport)',
    spanish: 'ciclismo',
  },
  {
    av: 21824,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + bicycle + fast)',
    english: 'speed cycling',
    swedish: 'cykellopp',
    norwegian: 'sykkelløp (sport)',
    finnish: 'kilpapyöräily',
    hungarian: 'gyorskerékpár sport',
    german: 'Radrennsport',
    dutch: 'wielrennen (snel)',
    afrikaans: 'spoed fietsry',
    russian: 'скоростной велоспорт',
    latvian: 'iedzīšanas riteņbraukšana',
    polish: 'wyścigi kolarskie (sport)',
    french: 'course cycliste (sport)',
    spanish: 'ciclismo en pista',
  },
  {
    av: 21825,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + mountain bike)',
    english: 'mountain biking',
    swedish: 'mountainbikecykling',
    norwegian: 'mountainbikesykling (sport)',
    finnish: 'maastopyöräily',
    hungarian: 'mountain bike sport',
    german: 'Mountainbike fahren',
    dutch: 'mountainbiken',
    afrikaans: 'berg fietsry',
    russian: 'горный велосипед',
    latvian: 'kalnu riteņbraukšana',
    polish: 'kolarstwo górskie (sport)',
    french: 'vélo de montagne (sport)',
    spanish: 'ciclismo de montaña',
  },
  {
    av: 21826,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + motor cycle)',
    english: 'motorcycling, motocross',
    swedish: 'motorcykelsport, motocross',
    norwegian: 'motorsykkelsport, motorcross (sport)',
    finnish: 'moottoripyöräily, motocrossi',
    hungarian: 'motorkerékpár sport, motorsport',
    german: 'Motorcross, Motarradrennen',
    dutch: 'motorcross',
    afrikaans: 'motorfiets wedren, motocross',
    russian: 'мотокросс',
    latvian: 'motokross',
    polish: 'sport motocyklowy, motocross (rożne rodzaje)',
    french: 'motocyclisme, motocross',
    spanish: 'motociclismo, motocross',
  },
  {
    av: 21827,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + motor cycle + fast)',
    english: 'motorcycle racing',
    swedish: 'motorcykellopp',
    norwegian: 'motorsykkelløp (sport)',
    finnish: 'moottoripyöräkilpailu',
    hungarian: 'motorkerékpár verseny',
    german: 'Motorradrennen',
    dutch: 'motorrace',
    afrikaans: 'motorfiets wedren',
    russian: 'мотогонка',
    latvian: 'motokrosa sacensības',
    polish: 'wyścigi motocyklowe (sport)',
    french: 'course de moto',
    spanish: 'carrera de motos',
  },
  {
    av: 21828,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + motor cycle + side car)',
    english: 'sidecar (motorcycle sport)',
    swedish: 'motorcykelsport (med sidovagn)',
    norwegian: 'motorsykkelsport (med sidevogn)',
    finnish: 'sivuvaunumoottoripyöräily',
    hungarian: 'oldalkocsis motorkerékpársport',
    german: 'Motorradgespannsport (mit Beiwagen)',
    dutch: 'motorcross met zijspan',
    afrikaans: 'motorfiets met syspan sport',
    russian: 'мотокросс с колясками',
    latvian: 'sacensības motocikliem ar blakusvāģi',
    polish: 'wyścigi motocykli z przyczepami (sport)',
    french: 'side-car motocyclisme (sport)',
    spanish: 'sidecar (deporte motocicleta)',
  },
  {
    av: 21829,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + car)',
    english: 'car racing, auto racing',
    swedish: 'bilsport',
    norwegian: 'bilsport',
    finnish: 'autourheilu, kilpa-autoilu',
    hungarian: 'autóverseny sport',
    german: 'Autorennen',
    dutch: 'autosport',
    afrikaans: 'motor resies (sport)',
    russian: 'автоспорт',
    latvian: 'sacīkšu mašīna, autosacensības',
    polish: 'wyścigi samochodowe (sport)',
    french: 'course automobile (sport)',
    spanish: 'automovilismo',
  },
  {
    av: 21830,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + car + fast)',
    english: 'Formula One, NASCAR Kart',
    swedish: 'biltävling, rally',
    norwegian: 'billøp, rally (sport)',
    finnish: 'formula-ajot',
    hungarian: 'Formula 1 verseny sport',
    german: 'Autorennen',
    dutch: 'autoracen',
    afrikaans: 'Formule-1 resies',
    russian: 'автогонка (Формула-1 и др.) ',
    latvian: 'Formula-I, Naskar autosacensības',
    polish: 'wyścigi samochodowe (sport)',
    french: 'Formule 1 (sport automobile)',
    spanish: 'competencia automovilística, Fórmula 1, NASCAR, rally',
  },
  {
    av: 21831,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + car + small)',
    english: 'kart racing, karting, go-karting',
    swedish: 'karting, gokart',
    norwegian: 'gokart (sport) ',
    finnish: 'karting, mikroautokisat',
    hungarian: 'gokart sport',
    german: 'Gokartrennen',
    dutch: 'carten, carting',
    afrikaans: 'stampkar resies sport',
    russian: 'картинг',
    latvian: 'kartings ',
    polish: 'gokarstwo (sport)',
    french: 'go-cart, go-kart, karting (sport)',
    spanish: 'carrera de karting, go-kart',
  },
  {
    av: 21832,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(bicycle + action indicator)',
    english: 'cycle, ride a bike-(to)',
    swedish: 'cykla',
    norwegian: 'sykle',
    finnish: 'pyöräillä, ajaa polkupyörällä',
    hungarian: 'kerékpározni, kerekezni',
    german: '(Rad) fahren',
    dutch: 'fietsen',
    afrikaans: 'fietsry (om te)',
    russian: 'ездить на велосипеде',
    latvian: 'braukt ar velosipēdu',
    polish: 'jeździć na rowerze',
    french: 'rouler à vélo, faire du vélo',
    spanish: 'ir en bicicleta, montar en bicicleta',
  },
  {
    av: 21833,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(ride + car + action indicator)',
    english: 'go by car-(to)',
    swedish: 'åka bil',
    norwegian: 'bile',
    finnish: 'mennä autolla',
    hungarian: 'autózni, autón menni, autón utazni',
    german: 'fahren, mit dem Auto fahren',
    dutch: 'met de auto gaan',
    afrikaans: 'met voertuig gaan (om te)',
    russian: 'ездить на машине',
    latvian: 'braukt ar mašīnu',
    polish: 'podróżować samochodem',
    french: 'aller en voiture, promener en voiture-(se)',
    spanish: 'ir en coche',
  },
  {
    av: 21834,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(ride + airplane + action indicator)',
    english: 'go by airplane, fly-(to)',
    swedish: 'flyga (åka flygplan)',
    norwegian: 'fly (å), reise (å) med fly',
    finnish: 'mennä lentokoneella, lentää',
    hungarian: 'repülőgéppel utazni, repülni',
    german: 'fliegen, mit dem Flugzeug fliegen',
    dutch: 'reizen (met het vliegtuig), vliegen',
    afrikaans: 'met vliegtuig reis (om te)',
    russian: 'лететь на самолёте',
    latvian: 'braukt ar lidmašīnu',
    polish: 'podróżować samolotem',
    french: 'aller en avion',
    spanish: 'ir en avión',
  },
  {
    av: 21835,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(ride + horse + action indicator)',
    english: 'go by horse-(to)',
    swedish: 'åka häst',
    norwegian: 'kjøre hest',
    finnish: 'mennä hevosella',
    hungarian: 'lovaskocsin utazni',
    german: 'reiten, auf dem Pferd reiten',
    dutch: 'te paard gaan',
    afrikaans: 'te perd gaan (om te)',
    russian: 'ехать на лошади',
    latvian: 'jāt ar zirgu',
    polish: 'jechać konno, podróżować konno',
    french: 'aller à cheval, promener à cheval-(se)',
    spanish: 'ir a caballo',
  },
  {
    av: 21836,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(riding, horseback riding + action indicator)',
    english: 'ride (horse)-(to)',
    swedish: 'rida',
    norwegian: 'ri',
    finnish: 'ratsastaa',
    hungarian: 'lovagolni',
    german: 'reiten',
    dutch: 'paardrijden',
    afrikaans: 'perdry (om te)',
    russian: 'ездить верхом на лошади',
    latvian: 'jāt uz zirga',
    polish: 'jechać konno',
    french: 'monter à cheval',
    spanish: 'pasear (a caballo)',
  },
  {
    av: 21837,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + to fight + sword)',
    english: 'fencing',
    swedish: 'fäktning',
    norwegian: 'fekting (sport)',
    finnish: 'miekkailu',
    hungarian: 'vívás, vívósport',
    german: 'Fechten',
    dutch: 'schermen',
    afrikaans: 'skermsport',
    russian: 'фехтование',
    latvian: 'paukošana',
    polish: 'szermierka (sport)',
    french: 'escrime (sport)',
    spanish: 'esgrima',
  },
  {
    av: 21838,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + to fight + east)',
    english: 'martial arts',
    swedish: 'kampsport (österländsk)',
    norwegian: 'kampsport ',
    finnish: 'itämaiset kamppailulajit',
    hungarian: 'harcművészet, küzdő sportok',
    german: 'Kampfsportart, Kampkunst',
    dutch: 'oosterse vechtsporten',
    afrikaans: 'gevegkuns',
    russian: 'восточное боевое искусство',
    latvian: 'Austrumu cīņas veidi',
    polish: 'sztuki walki (sport)',
    french: 'arts martiaux (sport)',
    spanish: 'artes marciales',
  },
  {
    av: 21839,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + legs and feet + fast)',
    english: 'running',
    swedish: 'löpning',
    norwegian: 'løping (sport)',
    finnish: 'juoksu',
    hungarian: 'futás, futó sport',
    german: 'Rennen, laufen',
    dutch: 'hardlopen',
    afrikaans: 'hardloop',
    russian: 'бег',
    latvian: 'skriešana',
    polish: 'bieg (sport)',
    french: 'course à pied (sport)',
    spanish: 'funcionamiento',
  },
  {
    av: 21840,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(running + jump)',
    english: 'hurdles',
    swedish: 'häcklöpning',
    norwegian: 'hekkeløp (sport)',
    finnish: 'aitajuoksu',
    hungarian: 'gátfutás, akadályverseny',
    german: 'Hürdenlauf',
    dutch: 'hordenlopen',
    afrikaans: 'hekkie(s)',
    russian: 'бег с препятствиями',
    latvian: 'barjerskrējiens',
    polish: 'bieg przez płotki (sport)',
    french: "course de haies, course d'obstacles (sport)",
    spanish: 'obstáculos, vallas',
  },
  {
    av: 21842,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + relay)',
    english: 'relay (sport)',
    swedish: 'stafettlöpning (sport)',
    norwegian: 'stafettløp (sport)',
    finnish: 'viestiurheilu',
    hungarian: 'váltófutás',
    german: 'Staffellauf',
    dutch: 'estafette (sport)',
    afrikaans: 'aflos (sport)',
    russian: 'спортивная эстафета',
    latvian: 'stafetes skrējiens sportā',
    polish: 'sztafeta, bieg sztafetowy (sport)',
    french: 'sport de relais',
    spanish: 'relevo (deporte)',
  },
  {
    av: 21843,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + to jump + high)',
    english: 'high jump',
    swedish: 'höjdhopp',
    norwegian: 'høydehopp (sport)',
    finnish: 'korkeushyppy',
    hungarian: 'magasugrás',
    german: 'Hochsprung',
    dutch: 'hoogspringen',
    afrikaans: 'hoogspring',
    russian: 'прыжки в высоту',
    latvian: 'augstlēkšana',
    polish: 'skok wzwyż (sport)',
    french: 'saut en hauteur (sport)',
    spanish: 'salto de altura',
  },
  {
    av: 21844,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + to jump + high + linear thing + thing indicator)',
    english: 'pole vaulting',
    swedish: 'stavhopp',
    norwegian: 'stavhopp (sport)',
    finnish: 'seiväshyppy',
    hungarian: 'rúdugrás',
    german: 'Stabhochsprung',
    dutch: 'polsstokhoogspringen',
    afrikaans: 'paal spring',
    russian: 'прыжки с шестом',
    latvian: 'kārtslēkšana',
    polish: 'skok o tyczce (sport)',
    french: 'saut à la perche (sport)',
    spanish: 'salto con pértiga',
  },
  {
    av: 21846,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball + metal [contr.])',
    english: 'shot put',
    swedish: 'kulstötning',
    norwegian: 'kulestøt (sport)',
    finnish: 'kuulantyöntö',
    hungarian: 'súlylökés',
    german: 'Kugelstoßen',
    dutch: 'kogelstoten',
    afrikaans: 'gewigstoot',
    russian: 'толкание ядра',
    latvian: 'lodes grūšana',
    polish: 'pchnięcie kulą (sport)',
    french: 'lancer du poids',
    spanish: 'lanzamiento de peso',
  },
  {
    av: 21847,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + disc)',
    english: 'discus',
    swedish: 'diskus',
    norwegian: 'diskos (sport)',
    finnish: 'kiekonheitto',
    hungarian: 'diszkoszvetés',
    german: 'Diskus',
    dutch: 'discuswerpen',
    afrikaans: 'diskusgooi',
    russian: 'метание диска',
    latvian: 'diska mešana',
    polish: 'rzut dyskiem (sport)',
    french: 'lancer du disque (sport)',
    spanish: 'disco (deporte)',
  },
  {
    av: 21848,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ball + chain)',
    english: 'hammer throw',
    swedish: 'släggkastning',
    norwegian: 'sleggekast (sport)',
    finnish: 'moukarinheitto',
    hungarian: 'kalapácsvetés',
    german: 'Hammerwerfen',
    dutch: 'kogel slingeren',
    afrikaans: 'hamergooi',
    russian: 'кидание молота',
    latvian: 'vesera mešana ',
    polish: 'rzut młotem (sport)',
    french: 'lancer du marteau (sport)',
    spanish: 'lanzamiento de martillo',
  },
  {
    av: 21850,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(arrow + small + thing indicator)',
    english: 'dart',
    swedish: 'dartpil',
    norwegian: 'dartpil, liten pil',
    finnish: 'tikka',
    hungarian: 'hajítódárda',
    german: 'Wurfpfeil, Dart',
    dutch: 'dart',
    afrikaans: 'pyltjie',
    russian: 'дарт, дротик',
    latvian: 'šautriņa',
    polish: 'rzutka, strzałka',
    french: 'fléchettes',
    spanish: 'dardo',
  },
  {
    av: 21851,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + javelin + thing indicator)',
    english: 'javelin throw',
    swedish: 'spjutkastning',
    norwegian: 'spydkast (sport)',
    finnish: 'keihäänheitto',
    hungarian: 'gerelyhajítás, gerelyvetés',
    german: 'Speerwurf',
    dutch: 'speerwerpen',
    afrikaans: 'spiesgooi',
    russian: 'метание копья ',
    latvian: 'šķēpmešana',
    polish: 'rzut oszczepem (sport)',
    french: 'lancer du javelot (sport)',
    spanish: 'lanzamiento de jabalina',
  },
  {
    av: 21852,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(forward + thing indicator) - (character with thing indicator)',
    english: 'arrow',
    swedish: 'pil',
    norwegian: 'pil',
    finnish: 'nuoli',
    hungarian: 'nyíl',
    german: 'Pfeil',
    dutch: 'pijl',
    afrikaans: 'pyl',
    russian: 'стрела',
    latvian: 'bulta',
    polish: 'strzała',
    french: 'flèche',
    spanish: 'flecha',
  },
  {
    av: 21853,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + dart + thing indicator)',
    english: 'darts',
    swedish: 'dart, pilkastning',
    norwegian: 'dart, pilkastspill (sport)',
    finnish: 'tikanheitto, darts',
    hungarian: 'dárdahajítás',
    german: 'Darts',
    dutch: 'darts',
    afrikaans: 'veerpyltjies',
    russian: 'дартс',
    latvian: 'šautriņas',
    polish: 'grać w rzutki, strzałki (sport)',
    french: 'fléchettes (sport)',
    spanish: 'dardos',
  },
  {
    av: 21854,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(arrow + big + thing indicator)',
    english: 'javelin, spear',
    swedish: 'spjut',
    norwegian: 'spyd',
    finnish: 'keihäs',
    hungarian: 'gerely',
    german: 'Speer',
    dutch: 'speer',
    afrikaans: 'spies',
    russian: 'копьё',
    latvian: 'šķēps',
    polish: 'oszczep, włócznia',
    french: 'javelot, lance',
    spanish: 'jabalina',
  },
  {
    av: 21856,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + bow and arrow)',
    english: 'archery',
    swedish: 'bågskytte',
    norwegian: 'bueskyting (sport)',
    finnish: 'jousiammunta',
    hungarian: 'íjászat',
    german: 'Bogenschießen',
    dutch: 'boogschieten',
    afrikaans: 'boogskiet',
    russian: 'стрельба из лука',
    latvian: 'loka šaušana',
    polish: 'łucznictwo (sport)',
    french: "tir à l'arc",
    spanish: 'tiro al arco',
  },
  {
    av: 21857,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sport + many + activity) Many can be replaced by an appropriate number.',
    english: 'multi-sport event',
    swedish: 'flerkamp',
    norwegian: 'mangekamp (sport)',
    finnish: 'moniottelu, 7-ottelu, 10-ottelu',
    hungarian: 'sportesemény több sportágban',
    german: 'Mehrkampfwettbewerb',
    dutch: 'meerkamp',
    afrikaans: 'multi sport gebeure',
    russian: 'многоборье',
    latvian: 'daudzu sporta veidu sacensības',
    polish: 'wydarzenie sportowe (wiele dyscyplin)',
    french: 'sport multiple',
    spanish: 'evento multideporte',
  },
  {
    av: 21858,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + three + activity)',
    english: 'triathlon',
    swedish: 'triatlon',
    norwegian: 'triatlon (sport)',
    finnish: 'triathlon, teräsmieskilpailu',
    hungarian: 'triatlon',
    german: 'Triathlon',
    dutch: 'triathlon',
    afrikaans: 'driekamp',
    russian: 'триатлон',
    latvian: 'triatlons',
    polish: 'triathlon (sport)',
    french: 'triathlon',
    spanish: 'triatlón ',
  },
  {
    av: 21859,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + weight + thing indicator)',
    english: 'weight lifting',
    swedish: 'tyngdlyftning',
    norwegian: 'vektløfting (sport)',
    finnish: 'painonnosto, voimanosto',
    hungarian: 'súlyemelés',
    german: 'Gewichtheben',
    dutch: 'gewichtheffen',
    afrikaans: 'gewig optel',
    russian: 'тяжёлая атлетика',
    latvian: 'svarcelšana',
    polish: 'podnoszenie ciężarów (sport)',
    french: 'haltérophilie',
    spanish: 'halterofilia',
  },
  {
    av: 21860,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ice skates)',
    english: 'skating',
    swedish: 'skridskosport',
    norwegian: 'skøytesport',
    finnish: 'luistelu',
    hungarian: 'korcsolyázás',
    german: 'Eislaufen',
    dutch: 'schaatsen',
    afrikaans: 'skaats',
    russian: 'коньковый вид спорта',
    latvian: 'slidošana ',
    polish: 'łyżwiarstwo (sport)',
    french: 'patinage',
    spanish: 'patinaje',
  },
  {
    av: 21861,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ice skates + fast)',
    english: 'speed skating',
    swedish: 'hastighetsåkning på skridskor',
    norwegian: 'hurtigløp på skøyter (sport)',
    finnish: 'pikaluistelu',
    hungarian: 'gyorskorcsolyázás',
    german: 'Eisschnelllauf',
    dutch: 'wedstrijdschaatsen',
    afrikaans: 'spoedskaats wedstryd',
    russian: 'конькобежный спорт',
    latvian: 'ātrslidošana',
    polish: 'łyżwiarstwo szybkie (sport)',
    french: 'patinage de vitesse',
    spanish: 'patinaje en pista',
  },
  {
    av: 21862,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + ice skates + design)',
    english: 'figure skating',
    swedish: 'konståkning',
    norwegian: 'kunstløp (sport) ',
    finnish: 'taitoluistelu',
    hungarian: 'műkorcsolyázás',
    german: 'Eiskunstlauf',
    dutch: 'kunstschaatsen',
    afrikaans: 'figuur skaats',
    russian: 'фигурное катание',
    latvian: 'daiļslidošana',
    polish: 'łyżwiarstwo figurowe',
    french: 'patinage artistique',
    spanish: 'patinaje artístico',
  },
  {
    av: 21863,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + skis + to turn)',
    english: 'slalom',
    swedish: 'slalom',
    norwegian: 'slalåm (sport)',
    finnish: 'pujottelu, slalom',
    hungarian: 'műlesiklás, szlalom',
    german: 'Slalom',
    dutch: 'slalom skiën',
    afrikaans: 'slalom',
    russian: 'слалом',
    latvian: 'slaloms',
    polish: 'slalom narciarski (sport)',
    french: 'descente en slalom (sport skis)',
    spanish: 'slalom',
  },
  {
    av: 21864,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + skis + downward/forward)',
    english: 'downhill skiing',
    swedish: 'utförsåkning',
    norwegian: 'utforkjøring (sport) ',
    finnish: 'laskettelu',
    hungarian: 'síelés',
    german: 'Abfahrtsski',
    dutch: 'skiën (afdaling)',
    afrikaans: 'afdraande ski',
    russian: 'скоростной спуск',
    latvian: 'nobrauciens',
    polish: 'narciarstwo zjazdowe (sport)',
    french: 'ski de descente',
    spanish: 'esquí alpino',
  },
  {
    av: 21865,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + skis + forward)',
    english: 'cross country skiing',
    swedish: 'längdåkning',
    norwegian: 'langrenn (sport)',
    finnish: 'murtomaahiihto',
    hungarian: 'sífutás',
    german: 'Skilanglauf',
    dutch: 'langlaufen',
    afrikaans: 'land ski',
    russian: 'лыжные гонки',
    latvian: 'distanču slēpošana ',
    polish: 'narciarstwo biegowe (sport)',
    french: 'ski de fond',
    spanish: 'esquí de fondo',
  },
  {
    av: 21866,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + skis + to jump)',
    english: 'ski jumping',
    swedish: 'backhoppning',
    norwegian: 'skihopp (sport)',
    finnish: 'mäkihyppy',
    hungarian: 'síugrás',
    german: 'Skispringen',
    dutch: 'schansspringen',
    afrikaans: 'ski spring',
    russian: 'прыжки с трамплина',
    latvian: 'lēkšana no tramplīna ',
    polish: 'skoki narciarskie (sport)',
    french: 'saut à skis',
    spanish: 'salto con esquís',
  },
  {
    av: 21867,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + skis + design)',
    english: 'freestyle skiing',
    swedish: 'freestyleåkning',
    norwegian: 'fristilskjøring (sport)',
    finnish: 'freestyle hiihto',
    hungarian: 'szabadstílusú síelés',
    german: 'Freistilskilauf, Skilauf (Freistil)',
    dutch: 'free style skiën',
    afrikaans: 'vryslag ski',
    russian: 'фристайл',
    latvian: 'frīstails',
    polish: 'narciarstwo akrobatyczne, dowolne',
    french: 'ski (figures libres), ski acrobatique, ski artistique',
    spanish: 'esquí libre',
  },
  {
    av: 21868,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + snowboard)',
    english: 'snowboarding',
    swedish: 'snowboardåkning',
    norwegian: 'snowboardkjøring, snøbrettkjøring (sport)',
    finnish: 'lumilautailu',
    hungarian: 'hódeszkázás, snowboardozás',
    german: 'Snowboarden',
    dutch: 'snowboarden',
    afrikaans: 'sneeuplankry',
    russian: 'сноуборд (спорт)',
    latvian: 'snovbords',
    polish: 'snowboard (sport)',
    french: 'snowboard (sport), surf des neiges (sport)',
    spanish: 'practicar snowboard',
  },
  {
    av: 21869,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(board + snow)',
    english: 'snowboard',
    swedish: 'snowboard',
    norwegian: 'snowboard, snøbrett',
    finnish: 'lumilauta',
    hungarian: 'hódeszka, snowboard',
    german: 'Snowboard',
    dutch: 'snowboard',
    afrikaans: 'sneeuplank',
    russian: 'сноуборд',
    latvian: 'snovbords',
    polish: 'snowboard',
    french: 'snowboard, surf des neiges',
    spanish: 'snowboard',
  },
  {
    av: 21870,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + sled)',
    english: 'sled sport',
    swedish: 'slädsport',
    norwegian: 'akesport',
    finnish: 'kelkkailu, kelkkaurheilu',
    hungarian: 'szánkó-sport',
    german: 'Schlittensport',
    dutch: 'sledesport',
    afrikaans: 'slee sport',
    russian: 'санный спорт',
    latvian: 'kamanu sports ',
    polish: 'saneczkarstwo (sport)',
    french: 'traîneau (sport)',
    spanish: 'deporte en trineo (invernal)',
  },
  {
    av: 21871,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sled + small)',
    english: 'toboggan',
    swedish: 'kälke, bob',
    norwegian: 'akebrett, kjelke (liten)',
    finnish: 'pieni kelkka, toboggan',
    hungarian: 'szánkó, tobogán',
    german: 'Schlitten, Rodelschlitten',
    dutch: 'rodel',
    afrikaans: 'slee',
    russian: 'тобогган',
    latvian: 'kamanas',
    polish: 'sanki, saneczki',
    french: 'luge',
    spanish: 'tobogán',
  },
  {
    av: 21872,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sled + big)',
    english: 'bobsleigh',
    swedish: 'släde',
    norwegian: 'bobsleigh, kjelke (stor)',
    finnish: 'iso kelkka, bobsleigh',
    hungarian: 'versenyszán',
    german: 'Bob',
    dutch: 'bobslee',
    afrikaans: 'bobslee',
    russian: 'бобслей',
    latvian: 'bobslejs',
    polish: 'tor bobslejowy',
    french: 'bobsleigh',
    spanish: 'trineo',
  },
  {
    av: 21873,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sled + horse)',
    english: 'horse sled, horse-drawn sleigh',
    swedish: 'hästsläde',
    norwegian: 'hesteslede',
    finnish: 'hevosreki',
    hungarian: 'lóvontatta szán',
    german: 'Pferdeschlitten',
    dutch: 'arreslee',
    afrikaans: 'perde slee',
    russian: 'конные сани',
    latvian: 'ragavas',
    polish: 'sanie konne',
    french: 'traîneau (pour cheval)',
    spanish: 'carruaje tirado por caballos',
  },
  {
    av: 21874,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sled + dog)',
    english: 'dog sled',
    swedish: 'hundsläde',
    norwegian: 'hundeslede',
    finnish: 'koirareki, valjakkoreki',
    hungarian: 'kutyaszán',
    german: 'Hundeschlitten',
    dutch: 'hondenslee',
    afrikaans: 'honde slee',
    russian: 'собачьи сани',
    latvian: 'suņu pajūgs',
    polish: 'psi zaprzęg',
    french: 'traîneau de chien',
    spanish: 'trineo tirado por perros',
  },
  {
    av: 21875,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + horse sled)',
    english: 'horse sled sport',
    swedish: 'hästslädsport',
    norwegian: 'hestesledesport',
    finnish: 'rekiurheilu (hevos)',
    hungarian: 'lovas szánhúzás (mint sportág)',
    german: 'Pferdeschlittensport',
    dutch: 'arresleesport',
    afrikaans: 'perde slee sport',
    russian: 'конно-санный спорт',
    latvian: 'divjūga, četrjūga kamanu sports',
    polish: 'wyścigi zaprzęgów (końskich)',
    french: 'course de chevaux avec traîneau',
    spanish: 'carreras de carruajes tirados por caballos',
  },
  {
    av: 21876,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(horse + man-made + to rock) Preferred NEW SYNONYM, replacing 16682',
    english: 'rocking horse',
    swedish: 'gunghäst',
    norwegian: 'gyngehest',
    finnish: 'keinuhevonen',
    hungarian: 'hintaló',
    german: 'Schaukelpferd',
    dutch: 'hobbelpaard',
    afrikaans: 'hobbelperd',
    russian: 'конь-качалка',
    latvian: 'jājamzirdziņš',
    polish: 'koń na biegunach',
    french: 'cheval à bascule',
    spanish: 'caballo de juguete',
  },
  {
    av: 21877,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + dog sled)',
    english: 'dogsled sport, dogsled racing',
    swedish: 'hundslädsport',
    norwegian: 'hundesledesport',
    finnish: 'koiravaljakkourheilu',
    hungarian: 'kutyaszán verseny (mint sportág)',
    german: 'Hundeschlittensport',
    dutch: 'hondensledesport',
    afrikaans: 'honde slee sport',
    russian: 'гонки на собачьих упряжках',
    latvian: 'suņu pajūgu sacensības',
    polish: 'wyścigi psich zaprzęgów (sport)',
    french: 'course de chiens de traîneau (sport)',
    spanish: 'carrera de perros de tiro',
  },
  {
    av: 21878,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dog + sled)',
    english: 'sled dog',
    swedish: 'slädhund',
    norwegian: 'sledehund',
    finnish: 'rekikoira, valjakkokoira',
    hungarian: 'szánhúzó kutya',
    german: 'Schlittenhund',
    dutch: 'sledehond',
    afrikaans: 'slee hond',
    russian: 'собака ездовая',
    latvian: 'vilcējsuns, pajūga suns',
    polish: 'psi zaprzęg',
    french: 'chien de luge',
    spanish: 'perro de tiro',
  },
  {
    av: 21879,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + disc + broom + ice)',
    english: 'curling',
    swedish: 'curling',
    norwegian: 'curling (sport)',
    finnish: 'curling',
    hungarian: 'curling (mint sportág)',
    german: 'Curling',
    dutch: 'curling',
    afrikaans: 'krul sport',
    russian: 'керлинг',
    latvian: 'kērlings',
    polish: 'curling (sport)',
    french: 'curling',
    spanish: 'curling',
  },
  {
    av: 21881,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(board + wave)',
    english: 'surfboard',
    swedish: 'surfingbräda',
    norwegian: 'surfebrett',
    finnish: 'surffauslauta, lainelauta',
    hungarian: 'szörfdeszka, szörf',
    german: 'Surfbrett',
    dutch: 'surfplank',
    afrikaans: 'branderplank',
    russian: 'доска для сёрфинга',
    latvian: 'sērfinga dēlis',
    polish: 'deska surfingowa',
    french: 'planche de surf, surf',
    spanish: 'tabla de surf',
  },
  {
    av: 21882,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(board + sail)',
    english: 'sailboard, windsurf board, windsurfing board',
    swedish: 'vindsurfingbräda',
    norwegian: 'vindsurfebrett, seilbrett',
    finnish: 'purjelauta',
    hungarian: 'szélvitorla, windsurf',
    german: 'Windsurfbrett',
    dutch: 'windsurfplank',
    afrikaans: 'windseilplank',
    russian: 'доска для виндсёрфига',
    latvian: 'vindsērfinga dēlis',
    polish: 'deska windsurfingowa',
    french: 'planche à voile',
    spanish: 'tabla a vela, tabla de windsurf',
  },
  {
    av: 21883,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ski + water)',
    english: 'water ski',
    swedish: 'vattenskidor',
    norwegian: 'vannski',
    finnish: 'vesisuksi',
    hungarian: 'vízisí',
    german: 'Wasserski',
    dutch: 'waterski',
    afrikaans: 'water ski',
    russian: 'водные лыжи',
    latvian: 'ūdensslēpes',
    polish: 'narty wodne',
    french: 'ski nautique',
    spanish: 'esquí acuático',
  },
  {
    av: 21884,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ski + water + motor)',
    english: 'jet ski, water scooter',
    swedish: 'jet ski',
    norwegian: 'jet-ski',
    finnish: 'vesiskootteri, jet ski',
    hungarian: 'jetski',
    german: 'Wassermotorrad, Jetboot',
    dutch: 'jetski',
    afrikaans: 'jet ski',
    russian: 'гидроцикл',
    latvian: 'ūdens motocikls',
    polish: 'narty wodne',
    french: 'jet-ski',
    spanish: 'moto acuática',
  },
  {
    av: 21885,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + sailboard)',
    english: 'wind surfing',
    swedish: 'vindsurfing',
    norwegian: 'vindsurfing (sport)',
    finnish: 'purjelautailu',
    hungarian: 'széllovaglás',
    german: 'Windsurfen',
    dutch: 'windsurfen',
    afrikaans: 'wind seil',
    russian: 'сёрфинг',
    latvian: 'vindsērfings',
    polish: 'windsurfing (sport)',
    french: 'planche à voile (sport)',
    spanish: 'surf a vela, windsurfing',
  },
  {
    av: 21886,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + water ski)',
    english: 'water skiing',
    swedish: 'vattenskidåkning',
    norwegian: 'vannskikjøring (sport) ',
    finnish: 'vesihiihto',
    hungarian: 'vízisízés, vízisíelés',
    german: 'Wasserski',
    dutch: 'waterskiën',
    afrikaans: 'water ski sport',
    russian: 'водные лыжи (спорт)',
    latvian: 'ūdensslēpošana',
    polish: 'narty wodne (sport)',
    french: 'ski nautique (sport)',
    spanish: 'esquí acuático',
  },
  {
    av: 22049,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + sailboat)',
    english: 'sailing',
    swedish: 'segling',
    norwegian: 'seiling (sport)',
    finnish: 'purjehtiminen',
    hungarian: 'vitorlázás',
    german: 'segeln',
    dutch: 'zeilen',
    afrikaans: 'seil',
    russian: 'парусный спорт',
    latvian: 'burusports',
    polish: 'żeglarstwo (sport)',
    french: 'voile (sport)',
    spanish: 'navegación',
  },
  {
    av: 22050,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + boat + one + paddle)',
    english: 'canoeing',
    swedish: 'kanotpaddling',
    norwegian: 'kanopadling (sport)',
    finnish: 'melonta',
    hungarian: 'kajakozás, kenuzás',
    german: 'paddeln',
    dutch: 'kanoën',
    afrikaans: 'kanovaart',
    russian: 'каноэ (спорт)',
    latvian: 'kanoe',
    polish: 'kajakarstwo (sport)',
    french: 'canoë (sport)',
    spanish: 'piragüismo, canoeing',
  },
  {
    av: 22051,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + boat + two + oar)',
    english: 'rowing',
    swedish: 'rodd',
    norwegian: 'roing (sport)',
    finnish: 'soutu',
    hungarian: 'evezés',
    german: 'Rudern',
    dutch: 'roeien',
    afrikaans: 'roei',
    russian: 'гребля',
    latvian: 'airēšana ',
    polish: 'wioślarstwo (sport)',
    french: 'aviron, canotage (sport)',
    spanish: 'remo',
  },
  {
    av: 22052,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + boat + motor)',
    english: 'motorboat sport',
    swedish: 'motorbåtsport',
    norwegian: 'motorbåtsport',
    finnish: 'moottoriveneurheilu',
    hungarian: 'motorcsónaksport',
    german: 'Motorbootsport',
    dutch: 'motorbootsport',
    afrikaans: 'motorboot sport',
    russian: 'катерный спорт',
    latvian: 'motorlaiva (sports)',
    polish: 'wyścigi motorówek (sport)',
    french: 'sport bateau à moteur',
    spanish: 'deportes náuticos a motor',
  },
  {
    av: 22053,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + swimming)',
    english: 'swimming (sport)',
    swedish: 'simning (sport)',
    norwegian: 'svømming (sport)',
    finnish: 'uinti',
    hungarian: 'úszás (mint sportág)',
    german: 'Schwimmsport',
    dutch: 'zwemmen',
    afrikaans: 'swem sport',
    russian: 'плавание (спорт)',
    latvian: 'peldēšanas sporta veidi',
    polish: 'pływanie (sport)',
    french: 'natation (sport)',
    spanish: 'natación (deporte)',
  },
  {
    av: 22054,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + diving + design)',
    english: 'synchronized diving, synchro diving (sport)',
    swedish: 'parhopp, synkroniserat simhopp (sport)',
    norwegian: 'synkrondykking (sport)',
    finnish: 'kuviosukellus',
    hungarian: 'szinkron műugrás',
    german: 'Synchronspringen',
    dutch: 'synchroonspringen',
    afrikaans: 'gesinchroniseerde duik sport',
    russian: 'синхронные прыжки в воду',
    latvian: 'sinhronā peldēšana, sinhronā daiļlēkšana',
    polish: 'nurkowanie synchroniczne (sport)',
    french: 'plongeon synchronisé (sport)',
    spanish: 'saltos sincronizados',
  },
  {
    av: 22055,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + to jump + water)',
    english: 'diving (sport)',
    swedish: 'simhopp (sport)',
    norwegian: 'dykking, stuping (sport)',
    finnish: 'sukellus',
    hungarian: 'műugrás',
    german: 'Kopfsprung',
    dutch: 'duiken',
    afrikaans: 'duik sport',
    russian: 'прыжки в воду',
    latvian: 'niršana',
    polish: 'nurkowanie (sport)',
    french: 'plongeon (sport)',
    spanish: 'buceo',
  },
  {
    av: 22056,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + swimming + plan)',
    english: 'synchronized swimming (sport)',
    swedish: 'konstsim, synkroniserad simning (sport)',
    norwegian: 'synkronsvømming (sport)',
    finnish: 'kuviouinti',
    hungarian: 'szinkronúszás',
    german: 'Synchronschwimmen',
    dutch: 'kunstzwemmen',
    afrikaans: 'gesinchroniseerde swem sport',
    russian: 'синхронное плавание',
    latvian: 'sinhronā peldēšana, sporta veids',
    polish: 'pływanie synchroniczne (sport)',
    french: 'nage synchronisée (sport)',
    spanish: 'natación sincronizada',
  },
  {
    av: 22057,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + under + water)',
    english: 'snorkeling, scuba diving, deep sea diving (sport)',
    swedish: 'sportdykning',
    norwegian: 'sportsdykking (sport)',
    finnish: 'syvänmerensukellus, snorklaus',
    hungarian: 'búvársport',
    german: 'Schnorcheln, Gerätetauchen, Sporttauchen, Tiefseetauchen',
    dutch: 'snorkelen, diepzeeduiken',
    afrikaans: 'snorkel, diepseeduik sport',
    russian: 'дайвинг, подводное плавание',
    latvian: 'snorkelings, niršana ar akvalangiem',
    polish: 'nurkowanie (sport)',
    french: 'plongée sous-marine',
    spanish: 'buceo, submarinismo',
  },
  {
    av: 22058,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + fishing)',
    english: 'fishing (sport)',
    swedish: 'sportfiske',
    norwegian: 'sportsfiske',
    finnish: 'kalastus',
    hungarian: 'horgászsport',
    german: 'Angeln, Angelsport',
    dutch: 'sportvissen',
    afrikaans: 'visvang sport (kompetisie)',
    russian: 'спортивная рыбалка',
    latvian: 'zvejas sports',
    polish: 'łowienie, wędkarstwo (sport)',
    french: 'pêche (sport)',
    spanish: 'pesca (deporte)',
  },
  {
    av: 22070,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(freighter + liquid)',
    english: 'tanker',
    swedish: 'tankfartyg',
    norwegian: 'tankbåt',
    finnish: 'tankkeri',
    hungarian: 'tankhajó',
    german: 'Tankschiff, Tanker',
    dutch: 'tanker',
    afrikaans: 'tanker',
    russian: 'танкер',
    latvian: 'tankkuģis',
    polish: 'tankowiec (statek)',
    french: 'bateau-citerne',
    spanish: 'petrolero',
  },
  {
    av: 22071,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(freighter + oil)',
    english: 'oil tanker',
    swedish: 'oljetanker',
    norwegian: 'oljetanker',
    finnish: 'öljytankkeri',
    hungarian: 'olajszállító hajó',
    german: 'Öltanker',
    dutch: 'olietanker',
    afrikaans: 'olie tanker',
    russian: 'нефтяной танкер',
    latvian: 'naftas tankkuģis',
    polish: 'tankowiec (statek do przewozu oleju, nafty itp.)',
    french: 'pétrolier',
    spanish: 'petrolero',
  },
  {
    av: 22072,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(freighter + river)',
    english: 'barge, river boat',
    swedish: 'pråm, flodbåt',
    norwegian: 'pram, lekter, elvebåt',
    finnish: 'proomu, jokilaiva',
    hungarian: 'uszály, folyami hajó',
    german: 'Lastkahn, Schleppkahn',
    dutch: 'aak, binnenvaartschip',
    afrikaans: 'skip boot, rivier, rivier boot',
    russian: 'баржа, речная баржа',
    latvian: 'barža, upju kuģis',
    polish: 'barka, łódka rzeczna',
    french: 'péniche',
    spanish: 'embarcación fluvial, lancha',
  },
  {
    av: 22073,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sailing boat + many + mast) Many can be replaced by an appropriate number.',
    english: 'schooner',
    swedish: 'skonare',
    norwegian: 'skonnert',
    finnish: 'kuunari',
    hungarian: 'szkúner',
    german: 'Segelschoner, Schoner',
    dutch: 'schoener',
    afrikaans: 'skoener',
    russian: 'шхуна',
    latvian: 'šoneris',
    polish: 'szkuner, żaglowiec',
    french: 'voilier à plusieurs mâts, goélette',
    spanish: 'goleta',
  },
  {
    av: 22074,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + motor)',
    english: 'motorboat',
    swedish: 'motorbåt',
    norwegian: 'motorbåt',
    finnish: 'moottorivene',
    hungarian: 'motorcsónak',
    german: 'Motorboot',
    dutch: 'motorboot',
    afrikaans: 'motorboot',
    russian: 'моторная лодка, катер',
    latvian: 'motorlaiva',
    polish: 'motorówka',
    french: 'bateau à moteur, canot automobile',
    spanish: 'lancha de motor',
  },
  {
    av: 22075,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + one + paddle)',
    english: 'canoe',
    swedish: 'kanot',
    norwegian: 'kano',
    finnish: 'kanootti',
    hungarian: 'kenu',
    german: 'Kanu',
    dutch: 'kano',
    afrikaans: 'kano',
    russian: 'каноэ',
    latvian: 'kanoe',
    polish: 'kajak, czółno',
    french: 'canoë',
    spanish: 'canoa',
  },
  {
    av: 22076,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + two + oar)',
    english: 'rowing boat',
    swedish: 'roddbåt',
    norwegian: 'robåt',
    finnish: 'soutuvene',
    hungarian: 'evezős csónak',
    german: 'Ruderboot',
    dutch: 'roeiboot, sloep',
    afrikaans: 'roeiboot',
    russian: 'весельная лодка',
    latvian: 'airu laiva',
    polish: 'łódź wiosłowa',
    french: 'barque, skiff, canot',
    spanish: 'barca de remos',
  },
  {
    av: 22077,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + paddle [two blades])',
    english: 'kayak',
    swedish: 'kajak',
    norwegian: 'kajak',
    finnish: 'kajakki',
    hungarian: 'kajak',
    german: 'Kajak',
    dutch: 'kajak',
    afrikaans: 'kajak',
    russian: 'байдарка, каяк',
    latvian: 'kajaks',
    polish: 'kajak',
    french: 'kayak',
    spanish: 'kayak',
  },
  {
    av: 22078,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + to aid)',
    english: 'lifeboat',
    swedish: 'livbåt',
    norwegian: 'livbåt',
    finnish: 'pelastusvene',
    hungarian: 'mentőcsónak',
    german: 'Rettungsboot',
    dutch: 'reddingsboot',
    afrikaans: 'reddingsboot',
    russian: 'спасательная лодка',
    latvian: 'glābšanas laiva',
    polish: 'łódź ratunkowa, szalupa',
    french: 'canot de sauvetage',
    spanish: 'bote salvavidas',
  },
  {
    av: 22079,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + to guide)',
    english: 'pilot boat',
    swedish: 'lotsbåt',
    norwegian: 'losbåt, ledebåt',
    finnish: 'luotsivene',
    hungarian: 'vezérhajó, vezető hajó',
    german: 'Lotsenboot',
    dutch: 'loodsboot',
    afrikaans: 'loodsboot',
    russian: 'лоцманский катер',
    latvian: 'loča kuteris',
    polish: 'łódź pilot (łódź pilotująca statki do portu)',
    french: 'pilote (de bateau)',
    spanish: 'barco piloto',
  },
  {
    av: 22080,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + pull, pulling: a boat that pulls other boats)',
    english: 'towboat, tugboat',
    swedish: 'bogserbåt',
    norwegian: 'taubåt',
    finnish: 'hinaaja',
    hungarian: 'vontatóhajó',
    german: 'Schlepper, Schleppdampfer',
    dutch: 'sleepboot',
    afrikaans: 'sleepboot, touboot',
    russian: 'буксир',
    latvian: 'velkonis',
    polish: 'pchacz, holownik (statek)',
    french: 'remorqueur',
    spanish: 'remolcador',
  },
  {
    av: 22081,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + to push)',
    english: 'pushboat',
    swedish: 'bogserbåt (som skjuter på)',
    norwegian: 'taubåt, slepebåt',
    finnish: 'puskuproomu',
    hungarian: 'tolóhajó',
    german: 'Schubschiff',
    dutch: 'duwboot',
    afrikaans: 'stootboot',
    russian: 'буксир -толкач',
    latvian: 'stūmējvelkonis',
    polish: 'pchacz (rodzaj łodzi)',
    french: 'bateau pousseur',
    spanish: 'remolcador',
  },
  {
    av: 22082,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + person + to travel)',
    english: 'cruise ship',
    swedish: 'kryssningsfartyg',
    norwegian: 'cruisebåt',
    finnish: 'risteilyalus, risteilulaiva, risteilijä',
    hungarian: 'sétahajó, kiránduló hajó',
    german: 'Kreuzfahrtschiff',
    dutch: 'cruiseschip, passagiersschip',
    afrikaans: 'passasierskip',
    russian: 'круизное судно',
    latvian: 'kruīza kuģis',
    polish: 'statek wycieczkowy',
    french: 'bateau de croisière',
    spanish: 'crucero',
  },
  {
    av: 22083,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(boat + back and forth: vessel that makes regular return trips between two ports)',
    english: 'ferry',
    swedish: 'färja',
    norwegian: 'ferge',
    finnish: 'lautta',
    hungarian: 'komp, rév',
    german: 'Fähre',
    dutch: 'veerboot',
    afrikaans: 'veerboot',
    russian: 'паром',
    latvian: 'prāmis',
    polish: 'prom, bród',
    french: 'ferry',
    spanish: 'transbordador',
  },
  {
    av: 22084,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + steam)',
    english: 'steamship',
    swedish: 'ångbåt',
    norwegian: 'dampbåt',
    finnish: 'höyrylaiva',
    hungarian: 'gőzhajó',
    german: 'Dampfschiff',
    dutch: 'stoomboot',
    afrikaans: 'stoomskip',
    russian: 'пароход',
    latvian: 'tvaikonis',
    polish: 'parowiec, statek parowy',
    french: 'bateau à vapeur',
    spanish: 'buque de vapor',
  },
  {
    av: 22085,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + up + air: boat is pressed upward by air)',
    english: 'hovercraft',
    swedish: 'svävare',
    norwegian: 'luftputebåt',
    finnish: 'ilmatyynyalus',
    hungarian: 'légpárnás hajó, légpárnás siklóhajó',
    german: 'Luftkissenboot, Hovercraft',
    dutch: 'hovercraft',
    afrikaans: 'skeertuig, sweefboot',
    russian: 'судно на воздушной подушке',
    latvian: 'kuģis uz gaisa spilvena',
    polish: 'poduszkowiec',
    french: 'aéroglisseur',
    spanish: 'aerodeslizador',
  },
  {
    av: 22086,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + air: rubber boat inflated with air)',
    english: 'rubber boat, dinghy',
    swedish: 'gummibåt',
    norwegian: 'gummibåt',
    finnish: 'kumivene',
    hungarian: 'gumicsónak, dingi',
    german: 'Gummiboot, Schlauchboot',
    dutch: 'opblaasboot, rubberboot',
    afrikaans: 'opblaasboot, rubberboot',
    russian: 'резиновая лодка',
    latvian: 'gumijas laiva',
    polish: 'ponton',
    french: 'canot pneumatique',
    spanish: 'barca de goma',
  },
  {
    av: 22087,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(two + hull)',
    english: 'catamaran, pontoon boat',
    swedish: 'katamaran',
    norwegian: 'katamaran',
    finnish: 'katamaraani, kantosiipialus',
    hungarian: 'katamarán',
    german: 'Katamaran',
    dutch: 'catamaran',
    afrikaans: 'catamaran',
    russian: 'катамаран',
    latvian: 'katamarāns, pontonu laiva',
    polish: 'katamaran',
    french: 'catamaran',
    spanish: 'catamarán',
  },
  {
    av: 22088,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + legs and feet: boat propelled by the legs and feet)',
    english: 'paddle boat, pedal boat, water bike, pedalo',
    swedish: 'vattencykel',
    norwegian: 'vannsykkel',
    finnish: 'polkuvene',
    hungarian: 'vízibicikli',
    german: 'Tretboot',
    dutch: 'waterfiets',
    afrikaans: 'waterfiets',
    russian: 'водный велосипед',
    latvian: 'smailīte',
    polish: 'obieg wody',
    french: 'pédalo',
    spanish: 'bicicleta de agua',
  },
  {
    av: 22089,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + house)',
    english: 'houseboat',
    swedish: 'husbåt',
    norwegian: 'husbåt',
    finnish: 'asuntolaiva',
    hungarian: 'lakóhajó',
    german: 'Hausboot',
    dutch: 'woonboot, woonark',
    afrikaans: 'huisboot',
    russian: 'плавучий дом',
    latvian: 'peldoša māja',
    polish: 'łódź mieszkalna',
    french: 'péniche aménagée, bateau-logement',
    spanish: 'casa flotante',
  },
  {
    av: 22090,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + boat)',
    english: 'boathouse',
    swedish: 'båthus',
    norwegian: 'båthus, naust',
    finnish: 'venevaja, venesuoja',
    hungarian: 'csónakház',
    german: 'Bootshaus',
    dutch: 'botenhuis',
    afrikaans: 'boothuis',
    russian: 'эллинг',
    latvian: 'peldošs mājoklis',
    polish: 'łódź mieszkalna, barka',
    french: 'hangar à bateau',
    spanish: 'cobertizo',
  },
  {
    av: 22091,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + horse)',
    english: 'horse rider, equestrian',
    swedish: 'ryttare',
    norwegian: 'rytter',
    finnish: 'ratsastaja',
    hungarian: 'lovas',
    german: 'Reiter, Reiterin',
    dutch: 'ruiter',
    afrikaans: 'ruiter',
    russian: 'наездник',
    latvian: 'jātnieks',
    polish: 'jeździec, dżokej',
    french: 'cavalier',
    spanish: 'jinete',
  },
  {
    av: 22092,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(horse rider + fast)',
    english: 'jockey',
    swedish: 'jockey',
    norwegian: 'jockey',
    finnish: 'kilparatsastaja',
    hungarian: 'zsoké',
    german: 'Jockey',
    dutch: 'jockey',
    afrikaans: 'jokkie',
    russian: 'жокей',
    latvian: 'žokejs',
    polish: 'dżokej',
    french: 'jockey',
    spanish: 'jockey',
  },
  {
    av: 22093,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cart + small + horse)',
    english: 'sulky',
    swedish: 'sulky',
    norwegian: 'sulky',
    finnish: 'hevoskärryt, ravirattaat',
    hungarian: 'ügetőverseny kocsi',
    german: 'Pferdewagen',
    dutch: 'sulky',
    afrikaans: 'sulky',
    russian: 'повозка, одноколка',
    latvian: 'divriči',
    polish: 'sulki (pojazd konny w wyścigach kłusaków)',
    french: 'sulky',
    spanish: 'sulky',
  },
  {
    av: 22094,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + horse + fast)',
    english: 'horse racing',
    swedish: 'hästkapplöpning',
    norwegian: 'hesteveddeløp (sport)',
    finnish: 'kilparatsastus',
    hungarian: 'lóverseny',
    german: 'Pferderennen',
    dutch: 'paardenrennen',
    afrikaans: 'perderesies',
    russian: 'скачки',
    latvian: 'zirgu sacensības',
    polish: 'wyścigi konne (sport)',
    french: 'course de chevaux (sport)',
    spanish: 'carrera de caballos',
  },
  {
    av: 22095,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + horse + carriage)',
    english: 'carriage racing',
    swedish: 'kapplöpning med häst och vagn',
    norwegian: 'travløp(med hest og vogn) (sport)',
    finnish: 'raviurheilu, ravit',
    hungarian: 'ügetőverseny',
    german: 'Kutschrennen',
    dutch: 'draverij',
    afrikaans: 'wa resies',
    russian: 'скачки конных экипажей',
    latvian: 'zirgu pajūgu sacensības',
    polish: 'wyścigi zaprzęgów (sport)',
    french: "course d'attelage",
    spanish: 'carrera de carruajes',
  },
  {
    av: 22096,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + horse + to jump)',
    english: 'showjumping (horse)',
    swedish: 'hästhoppning',
    norwegian: 'sprangridning (sport)',
    finnish: 'esteratsastus',
    hungarian: 'díjugratás',
    german: 'Springreiten',
    dutch: 'paardspringen, concours hippique',
    afrikaans: 'skouspring perd',
    russian: 'конкур',
    latvian: 'konkūrs',
    polish: 'konkurs skoków przez przeszkody (jazda konna) (sport)',
    french: "saut d'obstacles (sport équestre)",
    spanish: 'concurso de saltos (caballo)',
  },
  {
    av: 22097,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + horse + plan)',
    english: 'dressage',
    swedish: 'hästdressyr',
    norwegian: 'hestedressur (sport)',
    finnish: 'kouluratsastus',
    hungarian: 'díjlovaglás',
    german: 'Dressur, Dressurreiten',
    dutch: 'dressuur',
    afrikaans: 'dressage',
    russian: 'выездка',
    latvian: 'iejāde',
    polish: 'konkurs ujeżdżenia (sport konny)',
    french: 'dressage (sport)',
    spanish: 'doma, adiestramiento, destreza',
  },
  {
    av: 22098,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + horse + sport stick and ball, bandy stick)',
    english: 'polo',
    swedish: 'hästpolo',
    norwegian: 'polo (sport)',
    finnish: 'hevospoolo',
    hungarian: 'lovaspóló',
    german: 'Polo',
    dutch: 'polo (paard)',
    afrikaans: 'polo (perd)',
    russian: 'поло на лошадях',
    latvian: 'polo',
    polish: 'polo (sport)',
    french: 'polo (sport)',
    spanish: 'polo',
  },
  {
    av: 22099,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + table + three + ball)',
    english: 'billiards',
    swedish: 'biljard',
    norwegian: 'biljard (sport)',
    finnish: 'biljardi',
    hungarian: 'billiárd',
    german: 'Billard, Poolbillard',
    dutch: 'biljarten',
    afrikaans: 'biljart',
    russian: 'бильярд',
    latvian: 'biljards',
    polish: 'bilard (sport)',
    french: 'billard (sport)',
    spanish: 'billar',
  },
  {
    av: 22100,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sport + table + many + ball) Many can be replaced by an appropriate number.',
    english: 'pool, snooker',
    swedish: 'snooker (etc)',
    norwegian: 'snooker (sport)',
    finnish: 'snooker',
    hungarian: 'billiárdjáték egy fajtája, pool',
    german: 'Lochbillard, Snooker',
    dutch: 'snooker, pool',
    afrikaans: 'snoeker, pool',
    russian: 'пул, снукер',
    latvian: 'biljarda paveidi',
    polish: 'bilard, snooker (sport)',
    french: 'billard américain (sport)',
    spanish: 'billar, snooker',
  },
  {
    av: 22103,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(airplane + air: plane propelled by air currents)',
    english: 'glider',
    swedish: 'segelflygplan',
    norwegian: 'seilfly, glidefly',
    finnish: 'purjelentokone',
    hungarian: 'vitorlázó repülő',
    german: 'Segelflugzeug',
    dutch: 'zweefvliegtuig',
    afrikaans: 'sweefvliegtuig',
    russian: 'планер',
    latvian: 'planieru sports',
    polish: 'szybowiec',
    french: 'planeur',
    spanish: 'planeador',
  },
  {
    av: 22104,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(airplane + water: plane that can land on water)',
    english: 'seaplane',
    swedish: 'sjöflygplan',
    norwegian: 'sjøfly',
    finnish: 'vesitaso',
    hungarian: 'hidroplán',
    german: 'Wasserflugzeug',
    dutch: 'watervliegtuig',
    afrikaans: 'watervliegtuig',
    russian: 'гидросамолет, гидроплан',
    latvian: 'hidrolidmašīna',
    polish: 'hydroplan, wodnosamolot',
    french: 'hydravion',
    spanish: 'hidroavión',
  },
  {
    av: 22106,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + parachute)',
    english: 'parachuting',
    swedish: 'fallskärmshoppning',
    norwegian: 'fallskjermhopping (sport)',
    finnish: 'laskuvarjourheilu',
    hungarian: 'ejtőernyő sport',
    german: 'Fallschirmspringen',
    dutch: 'parachute springen',
    afrikaans: 'valskerm spring',
    russian: 'парашютный спорт',
    latvian: 'izpetņlēkšana',
    polish: 'spadochroniarstwo (sport)',
    french: 'parachutisme (sport)',
    spanish: 'paracaidismo',
  },
  {
    av: 22108,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + balloon (hot air))',
    english: 'ballooning',
    swedish: 'ballongflygning',
    norwegian: 'ballongferd, ballongflyging (sport)',
    finnish: 'kuumailmapalloilu',
    hungarian: 'hőlégballonozás (mint sport)',
    german: 'Ballonfahren, Ballonluftfahrt',
    dutch: 'ballonvaren',
    afrikaans: 'ballon vaart',
    russian: 'воздухоплавание',
    latvian: 'gaisa balonu sports',
    polish: 'lot balonem (sport)',
    french: 'montgolfière (sport)',
    spanish: 'vuelo en globo',
  },
  {
    av: 22109,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + mountain + to go up)',
    english: 'mountain climbing',
    swedish: 'bergsklättring',
    norwegian: 'fjellklatring (sport)',
    finnish: 'vuorikiipeily, kalliokiipeily',
    hungarian: 'hegymászás (sport)',
    german: 'Bergsteigen',
    dutch: 'bergbeklimmen',
    afrikaans: 'bergklim',
    russian: 'альпинизм',
    latvian: 'alpīnisms',
    polish: 'taternictwo (sport)',
    french: 'alpinisme, escalade',
    spanish: 'montañismo, alpinismo',
  },
  {
    av: 22110,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + mountain + to go down)',
    english: 'abseiling, rappelling',
    swedish: 'abseiling',
    norwegian: 'rappelering (sport)',
    finnish: 'laskeutuminen vuorelta',
    hungarian: 'kötélen lereszkedés hegyről (sport)',
    german: 'Abseilen',
    dutch: 'abseilen, rappel doen',
    afrikaans: 'abseil',
    russian: 'горный спуск',
    latvian: 'klinšukāpšana',
    polish: 'zjeżdżanie na linie z góry, z wysokości (sport)',
    french: 'descente en rappel (sport)',
    spanish: 'descenso (escalada)',
  },
  {
    av: 22111,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + wall + to go up)',
    english: 'wall climbing',
    swedish: 'väggklättring',
    norwegian: 'veggklatring (sport)',
    finnish: 'seinäkiipeily',
    hungarian: 'falmászás (sport)',
    german: 'Wandklettern',
    dutch: 'muurklimmen',
    afrikaans: 'muur klim',
    russian: 'скалолазание по отвесной стене',
    latvian: 'rāpšanās pa sienu',
    polish: 'ściana wspinaczkowa',
    french: "mur d'escalade (sport)",
    spanish: 'escalada',
  },
  {
    av: 22112,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + parachute + boat)',
    english: 'parasailing',
    swedish: 'parasailing',
    norwegian: 'paraseiling (sport)',
    finnish: 'laskuvarjoliito veneellä',
    hungarian: 'siklóernyőzés (sport)',
    german: 'Parasailing (am Fallschirm von Motorkraft gezogen)',
    dutch: 'parasailen',
    afrikaans: 'paraseil',
    russian: 'парасейлинг (водный)',
    latvian: 'paraseilings',
    polish: 'szybowanie na spadochronie za motorówką (sport)',
    french: 'parachutisme ascentionnel (nautique)',
    spanish: 'parasailing',
  },
  {
    av: 22113,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + parachute + skiis)',
    english: 'paraskiing',
    swedish: 'paraskiing',
    norwegian: 'paraskiing (sport)',
    finnish: 'laskuvarjoliito suksilla',
    hungarian: 'ejtőernyős sízés',
    german: 'Paraskiing (Skifahren komb. mit Drachenfliegen)',
    dutch: 'paraskiën, parapente',
    afrikaans: 'paraskiïng',
    russian: 'скайсёрфинг',
    latvian: 'paraplanierisms',
    polish: 'Para-ski (dyscyplina sportowa łącząca slalom narciarski ze skokami na spadochronie)',
    french: 'parachutisme à skis (sport), paraski (sport)',
    spanish: 'parapente',
  },
  {
    av: 22114,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sport + wings + person: sport in which a person flies by hanging from wings propelled by air currents)',
    english: 'hang gliding',
    swedish: 'hängflygning',
    norwegian: 'hanggliding (sport)',
    finnish: 'riippuliito',
    hungarian: 'sárkányrepülés',
    german: 'Drachenfliegen',
    dutch: 'deltavliegen',
    afrikaans: 'hangswewery, hangsweef',
    russian: 'дельтапланеризм',
    latvian: 'deltaplanierisms',
    polish: 'paralotniarstwo (sport)',
    french: 'deltaplane, vol à voile (sport)',
    spanish: 'ala delta',
  },
  {
    av: 22115,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + kite)',
    english: 'kite flying',
    swedish: 'drakflygning',
    norwegian: 'drakeflyging (sport)',
    finnish: 'leijailu, leijanlennätys',
    hungarian: 'sárkányreptetés',
    german: 'Drachensteigen',
    dutch: 'vliegeren',
    afrikaans: 'vlieër vlieg',
    russian: 'запуск воздушных змеев',
    latvian: 'gaisa pūķis',
    polish: 'puszczanie latawca',
    french: 'cerf-volant (sport)',
    spanish: 'vuelo de cometas',
  },
  {
    av: 22117,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(outdoor (character) + description indicator: the dot is outside the house)',
    english: 'outdoor, outdoors',
    swedish: 'utomhus',
    norwegian: 'utendørs',
    finnish: 'ulkona, ulkotilassa',
    hungarian: 'kültéri, szabadtéri',
    german: 'drauβen',
    dutch: 'buiten',
    afrikaans: 'buitekant buite',
    russian: 'наружный',
    latvian: 'āra, ārpustelpu, brīvdabas',
    polish: 'na dworze, na zewnątrz, poza domem',
    french: 'extérieur',
    spanish: 'al aire libre',
  },
  {
    av: 22118,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + to start)',
    english: 'appetizer, starter, entree',
    swedish: 'förrätt',
    norwegian: 'forrett',
    finnish: 'alkupala',
    hungarian: 'előétel',
    german: 'Vorspeise',
    dutch: 'voorgerecht',
    afrikaans: 'voorgereg',
    russian: 'закуска',
    latvian: 'uzkoda, starteris',
    polish: 'przekąska, przystawka',
    french: "amuse-gueule, hors-d'oeuvre, entrée",
    spanish: 'aperitivo, entrada',
  },
  {
    av: 22119,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + middle)',
    english: 'main dish, main course',
    swedish: 'huvudrätt',
    norwegian: 'hovedrett',
    finnish: 'pääruokalaji',
    hungarian: 'főétel, főfogás',
    german: 'Hauptgericht',
    dutch: 'hoofdgerecht',
    afrikaans: 'hoofgereg',
    russian: 'главное блюдо ',
    latvian: 'otrais ēdiens',
    polish: 'danie główne, posiłek główny',
    french: 'plat principal',
    spanish: 'plato principal',
  },
  {
    av: 22120,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bun + fish[contr.])',
    english: 'fishburger',
    swedish: 'fiskburgare',
    norwegian: 'fiskeburger',
    finnish: 'kalahampurilainen',
    hungarian: 'halburger',
    german: 'Fishburger, Fischbrötchen',
    dutch: 'visburger',
    afrikaans: 'visburger',
    russian: 'рыбный бургер',
    latvian: 'zivju burgeris',
    polish: 'bułka z kotletem rybnym, kotlet rybny',
    french: 'burger de poisson',
    spanish: 'hamburguesa de pescado',
  },
  {
    av: 22121,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cake + intensity)',
    english: 'decorated cake',
    swedish: 'tårta',
    norwegian: 'kake (stor, myk)',
    finnish: 'täytekakku',
    hungarian: 'dísztorta, díszített torta',
    german: 'Torte',
    dutch: 'taart',
    afrikaans: 'versierde koek',
    russian: 'торт',
    latvian: 'torte',
    polish: 'tort (ciasto dekorowany)',
    french: 'gâteau de fête',
    spanish: 'pastel decorado',
  },
  {
    av: 22122,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bun + sweet)',
    english: 'muffin, bun (sweet)',
    swedish: 'muffins, bulle',
    norwegian: 'muffins, bolle',
    finnish: 'muffini, teeleipä, briossi',
    hungarian: 'muffin, briós, kalácska',
    german: 'Brötchen, Muffin',
    dutch: 'muffin, cakeje',
    afrikaans: 'muffin, bun (soet)',
    russian: 'маффин, сдобная булочка',
    latvian: 'kēkss, kēksiņš, mafins',
    polish: 'babeczka, muffinka',
    french: 'petit pain sucré, brioche',
    spanish: 'mollete, bollo, muffin',
  },
  {
    av: 22123,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(muffin + intensity)',
    english: 'cupcake, fancy cake, pastry',
    swedish: 'bakelse',
    norwegian: 'kake (liten myk)',
    finnish: 'leivos',
    hungarian: 'cukrászsütemény, minitorta',
    german: 'Kuchen, Muffin, Gebäck, Feingebäck',
    dutch: 'cupcake, gebakje',
    afrikaans: 'kolwyntjie, koek, deeg',
    russian: 'пирожное, кекс, выпечка',
    latvian: 'dekorēts kēkss, kapkeiks',
    polish: 'ciastko tortowe',
    french: 'petit pain très sucré, madeleine',
    spanish: 'magdalena',
  },
  {
    av: 22124,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(muffin + ring: muffin in the shape of a ring)',
    english: 'doughnut',
    swedish: 'flottyrmunk',
    norwegian: 'doughnut',
    finnish: 'donitsi',
    hungarian: 'fánk, amerikai fánk',
    german: 'Donut (Krapfen)',
    dutch: 'donut',
    afrikaans: 'doughnut',
    russian: 'пончик',
    latvian: 'virtulis',
    polish: 'pączek (donut – pączek z dziurką)',
    french: 'beignet',
    spanish: 'dona, rosquilla',
  },
  {
    av: 22125,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bun (food) + ring: bun in the shape of a ring)',
    english: 'bagel',
    swedish: 'bagel',
    norwegian: 'bagel',
    finnish: 'rinkeli',
    hungarian: 'zsömleféle (kerek, gyűrűformájú)',
    german: 'Bagel (ringförmiges Brötchen)',
    dutch: 'beignet, bagel',
    afrikaans: 'bagel',
    russian: 'бублик, рогалик',
    latvian: 'bagete',
    polish: 'obwarzanek',
    french: 'bagel, petit pain en couronne',
    spanish: 'rosquilla',
  },
  {
    av: 22126,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + grid, matrix: the waffle iron creates a grid pattern)',
    english: 'waffle',
    swedish: 'våffla',
    norwegian: 'vaffel',
    finnish: 'vohveli',
    hungarian: 'édes ostya, waffle ',
    german: 'Waffel',
    dutch: 'wafel',
    afrikaans: 'wafel',
    russian: 'вафля',
    latvian: 'vafele',
    polish: 'wafel',
    french: 'gaufre',
    spanish: 'gofre',
  },
  {
    av: 22127,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish (food) + ball: fish shaped into a ball)',
    english: 'fishball',
    swedish: 'fiskbulle',
    norwegian: 'fiskebolle',
    finnish: 'kalapulla',
    hungarian: 'halgolyó, halgombóc',
    german: 'Fischball (gebackener Fisch in Kugelform)',
    dutch: 'visbal',
    afrikaans: 'viskoekie',
    russian: 'рыбная фрикаделька',
    latvian: 'zivju teftelis',
    polish: 'kulki, klopsiki rybne',
    french: 'boulette de poisson',
    spanish: 'croqueta de pescado',
  },
  {
    av: 22128,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + bun + ball: bun-like food shaped into a ball)',
    english: 'dumpling',
    swedish: 'klimp (etc)',
    norwegian: 'bolle',
    finnish: 'myky',
    hungarian: 'galuska, gombóc',
    german: 'Teigtasche (gefüllt)',
    dutch: 'deegbal, knoedel',
    afrikaans: 'deegbal',
    russian: 'клёцка',
    latvian: 'pelmenis, klimpa',
    polish: 'kluska',
    french: 'boulette de pâte',
    spanish: 'bola de masa hervida, dumpling',
  },
  {
    av: 22129,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + flour: food made from [wheat] flour)',
    english: 'pasta',
    swedish: 'pasta',
    norwegian: 'pasta',
    finnish: 'pasta',
    hungarian: 'tésztaféle',
    german: 'Nudeln, Pasta',
    dutch: 'deegwaren, pasta',
    afrikaans: 'pasta',
    russian: 'паста (макаронное изделие)',
    latvian: 'pasta, makaroni',
    polish: 'makaron',
    french: 'pâte alimentaire',
    spanish: 'pasta',
  },
  {
    av: 22130,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pasta + tube)',
    english: 'macaroni',
    swedish: 'makaroner',
    norwegian: 'makaroni',
    finnish: 'makarooni',
    hungarian: 'makaróni',
    german: 'Makkaroni',
    dutch: 'macaroni',
    afrikaans: 'macaroni',
    russian: 'макароны',
    latvian: 'makaroni',
    polish: 'makaron (rurki)',
    french: 'macaroni',
    spanish: 'macarrones',
  },
  {
    av: 22131,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pasta + butterfly)',
    english: 'farfalle',
    swedish: 'fjärilsmakaroner',
    norwegian: 'sommerfuglpasta',
    finnish: 'kuviopasta (perhonen) (farfalle)',
    hungarian: 'farfalle',
    german: 'Schmetterlingsnudeln, Farfalle',
    dutch: 'farfalle, strikjesmacaroni',
    afrikaans: 'farfalle',
    russian: 'паста в виде бабочки',
    latvian: 'tauriņveida makaroni',
    polish: 'farfale – makaron kokardki',
    french: 'farfalle',
    spanish: 'farfalle',
  },
  {
    av: 22132,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pasta + wheel)',
    english: 'pasta wheel',
    swedish: 'pastahjul',
    norwegian: 'pastahjul',
    finnish: 'kuviopasta (pyörä)',
    hungarian: 'tészta – kerék alakú',
    german: 'Nudelrad, Nudelrädchen',
    dutch: 'wieltjesmacaroni',
    afrikaans: 'wieletjies pasta',
    russian: 'паста в виде колеса',
    latvian: 'spirālveida makaroni',
    polish: 'makaron w kształcie kółek',
    french: 'pâte (roue), rotelle, rotelline',
    spanish: 'rueda para cortar pasta',
  },
  {
    av: 22133,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pasta + page)',
    english: 'lasagne, lasagna',
    swedish: 'lasagne',
    norwegian: 'lasagne',
    finnish: 'lasagne',
    hungarian: 'tészta – széles tésztalap, lasagne',
    german: 'Lasagne',
    dutch: 'lasagne',
    afrikaans: 'lasagne',
    russian: 'лазанья',
    latvian: 'lazanja',
    polish: 'lazania',
    french: 'lasagne(s)',
    spanish: 'lasaña',
  },
  {
    av: 22134,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pasta + filled)',
    english: 'ravioli',
    swedish: 'ravioli',
    norwegian: 'ravioli',
    finnish: 'ravioli',
    hungarian: 'ravioli',
    german: 'Ravioli',
    dutch: 'ravioli',
    afrikaans: 'ravioli',
    russian: 'равиоли, пельмени',
    latvian: 'ravioli',
    polish: 'ravioli (włoskie pierożki)',
    french: 'ravioli',
    spanish: 'ravioles',
  },
  {
    av: 22135,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(powder + rice)',
    english: 'rice flour',
    swedish: 'rismjöl',
    norwegian: 'rismel',
    finnish: 'riisijauho',
    hungarian: 'rizsliszt',
    german: 'Reismehl',
    dutch: 'rijstebloem',
    afrikaans: 'rys meel',
    russian: 'рисовая мука',
    latvian: 'rīsa milti',
    polish: 'mąka ryżowa',
    french: 'farine de riz',
    spanish: 'harina de arroz',
  },
  {
    av: 22136,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + rice flour + line)',
    english: 'rice noodle',
    swedish: 'risnudlar',
    norwegian: 'risnudler',
    finnish: 'riisinuudeli',
    hungarian: 'rizstészta',
    german: 'Reisnudeln',
    dutch: 'mihoen',
    afrikaans: 'rys noedels',
    russian: 'рисовая лапша',
    latvian: 'rīsa nūdeles',
    polish: 'makaron ryżowy',
    french: 'nouilles de riz, pâtes chinoises (à base de riz)',
    spanish: 'fideo de arroz',
  },
  {
    av: 22137,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(egg + to boil [contr.])',
    english: 'egg (boiled), boiled egg',
    swedish: 'ägg (kokt)',
    norwegian: 'egg kokt',
    finnish: 'keitetty muna',
    hungarian: 'tojás – főtt ',
    german: 'gekochtes Ei',
    dutch: 'gekookt ei',
    afrikaans: 'gekookte eier',
    russian: 'яйцо (варёное)',
    latvian: 'ola, vārīta; vārīta ola',
    polish: 'gotowane jajko',
    french: "œuf cuit (dans l'eau)",
    spanish: 'huevo duro',
  },
  {
    av: 22138,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(egg + to fry [contr.])',
    english: 'egg (fried), fried egg',
    swedish: 'ägg (stekt)',
    norwegian: 'egg stekt',
    finnish: 'paistettu muna',
    hungarian: 'tojás – sült, tükörtojás',
    german: 'Spiegelei',
    dutch: 'gebakken ei',
    afrikaans: 'gabakte eier',
    russian: 'яйцо (жареное)',
    latvian: 'ola, cepta; cepta ola',
    polish: 'jajko sadzone, smażone',
    french: 'œuf frit',
    spanish: 'huevo frito',
  },
  {
    av: 22139,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(egg + mixture + to heat [modification])',
    english: 'omelette, omelet',
    swedish: 'omelett',
    norwegian: 'omelett',
    finnish: 'munakas',
    hungarian: 'tojáslepény, omlett',
    german: 'Omelett, Eierkuchen',
    dutch: 'omelet',
    afrikaans: 'omelet',
    russian: 'омлет',
    latvian: 'omlete',
    polish: 'omlet, jajecznica (jajko+mieszać+ogień)',
    french: 'omelette',
    spanish: 'tortilla francesa',
  },
  {
    av: 22140,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(egg + to heat [modification] + mixture)',
    english: 'scrambled eggs',
    swedish: 'äggröra',
    norwegian: 'eggerøre',
    finnish: 'munakokkeli',
    hungarian: 'tojásrántotta, rántotta',
    german: 'Rührei',
    dutch: 'roerei, omelet',
    afrikaans: 'roereier',
    russian: 'яичница болтунья',
    latvian: 'olu kultenis',
    polish: 'jajecznica',
    french: 'œuf brouillé',
    spanish: 'huevo revuelto',
  },
  {
    av: 22141,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(egg + heat [modification] + water: egg cooked in water)',
    english: 'egg (poached), poached egg',
    swedish: 'ägg (pocherat)',
    norwegian: 'egg posjert',
    finnish: 'uppomuna',
    hungarian: 'tojás buggyantva, buggyantott tojás',
    german: 'pochiertes Ei, verlorene Eier',
    dutch: 'gepocheerd ei',
    afrikaans: 'geposjeerde eier',
    russian: 'яйцо (пашот)',
    latvian: 'ola mundierī, bez čaumalas vārīta ola',
    polish: 'jajko gotowane',
    french: 'œuf poché',
    spanish: 'huevo escalfado',
  },
  {
    av: 22142,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(salad + fruit) The specifier fruit can be replaced with another appropriate one.',
    english: 'fruit salad',
    swedish: 'fruktsallad',
    norwegian: 'fruktsalat',
    finnish: 'hedelmäsalaatti',
    hungarian: 'gyümölcssaláta',
    german: 'Obstsalat',
    dutch: 'fruitsalade',
    afrikaans: 'vrugte slaai',
    russian: 'фруктовый салат',
    latvian: 'augļu salāti',
    polish: 'sałatka owocowa',
    french: 'salade de fruits',
    spanish: 'ensalada de frutas',
  },
  {
    av: 22305,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(salad + crab)',
    english: 'shellfish salad',
    swedish: 'skaldjurssallad',
    norwegian: 'skalldyrsalat',
    finnish: 'äyriäissalaatti',
    hungarian: 'ráksaláta',
    german: 'Meeresfrüchtesalat',
    dutch: 'krabsalade',
    afrikaans: 'skulpvis slaai',
    russian: 'салат с морепродуктами',
    latvian: 'vēžveidīgo salāti; jūras velšu salāti',
    polish: 'sałatka z owoców morza, skorupiaków, krabów',
    french: 'salade de crustacés',
    spanish: 'ensalada de mariscos',
  },
  {
    av: 22306,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(salad + pasta [contr.]))',
    english: 'pasta salad',
    swedish: 'pastasallad',
    norwegian: 'pastasalat',
    finnish: 'pastasalaatti',
    hungarian: 'tésztasaláta',
    german: 'Nudelsalat',
    dutch: 'pastasalade',
    afrikaans: 'pasta slaai',
    russian: 'салат с пастой',
    latvian: 'pastas/makaronu salāti',
    polish: 'sałatka z makaronem',
    french: 'salade de pâtes',
    spanish: 'ensalada de pasta',
  },
  {
    av: 22308,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pudding + Christmas [contr.])',
    english: 'Christmas pudding',
    swedish: 'julpudding',
    norwegian: 'julepudding',
    finnish: 'jouluvanukas',
    hungarian: 'karácsonyi puding',
    german: 'Weihnachtspudding',
    dutch: 'Kerstpudding',
    afrikaans: 'Kerspoeding',
    russian: 'Рождественский пудинг',
    latvian: 'Ziemassvētku pudiņš',
    polish: 'bożonarodzeniowy pudding',
    french: 'Christmas pudding',
    spanish: 'budín de Navidad',
  },
  {
    av: 22309,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring [contr.] + liquid + thing indicator)',
    english: 'flavouring, seasoning (liquid)',
    swedish: 'smaktillsats (flytande)',
    norwegian: 'smakstilsetning (flytende)',
    finnish: 'mauste (nestemäinen)',
    hungarian: 'fűszer – folyékony, folyékony ételízesítő',
    german: 'Aroma (flüssig), Geschmacksstoff (flüssig)',
    dutch: 'kruiden (vloeibaar), specerij (vloeibaar)',
    afrikaans: 'geurmiddels (vloeistof)',
    russian: 'ароматизатор, приправа (жидкие)',
    latvian: 'garšvielu mērce',
    polish: 'przyprawa w płynie',
    french: 'assaisonnement (liquide)',
    spanish: 'saborizante, condimento (líquido)',
  },
  {
    av: 22310,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring [contr.] + powder + thing indicator)',
    english: 'flavouring, seasoning (powder)',
    swedish: 'smaktillsats (pulverform)',
    norwegian: 'smakstilsetning (pulverform)',
    finnish: 'mauste (jauhettu)',
    hungarian: 'fűszer – poralakú, fűszerpor',
    german: 'Gewürz, Salz und Pfeffer',
    dutch: 'kruiden (poedervorm), specerij (poedervorm',
    afrikaans: 'geurmiddels (poeier)',
    russian: 'ароматизатор, приправа (порошковые)',
    latvian: 'garšvielu pulveris',
    polish: 'przyprawa sypka',
    french: 'assaisonnement (poudre)',
    spanish: 'saborizante, condimento (en polvo)',
  },
  {
    av: 22311,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + tree trunk)',
    english: 'bark',
    swedish: 'bark',
    norwegian: 'bark',
    finnish: 'kaarna',
    hungarian: 'fakéreg',
    german: 'Baumrinde, Borke',
    dutch: 'boomschors',
    afrikaans: 'bas',
    russian: 'кора',
    latvian: 'miza',
    polish: 'kora',
    french: 'écorce',
    spanish: 'corteza',
  },
  {
    av: 22312,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring + bark + thing indicator)',
    english: 'cinnamon',
    swedish: 'kanel',
    norwegian: 'kanel',
    finnish: 'kaneli',
    hungarian: 'fahéj',
    german: 'Zimt, Zimtstange',
    dutch: 'kaneelstokje',
    afrikaans: 'kaneel, kaneelstokkie',
    russian: 'корица',
    latvian: 'kanēlis',
    polish: 'cynamon (kora, przyprawa)',
    french: 'cannelle',
    spanish: 'canela',
  },
  {
    av: 22313,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring (powder) + cinnamon [contr.] + thing indicator)',
    english: 'cinnamon (powder)',
    swedish: 'kanel (pulverform)',
    norwegian: 'kanel (pulverform)',
    finnish: 'kaneli (jauhettu)',
    hungarian: 'fahéj – őrölt, fahéjpor',
    german: 'Zimt',
    dutch: 'kaneel (poeder)',
    afrikaans: 'kaneel poeier',
    russian: 'корица (порошок)',
    latvian: 'kanēļa pulveris',
    polish: 'cynamon (w proszku)',
    french: 'cannelle (poudre)',
    spanish: 'canela (en polvo)',
  },
  {
    av: 22314,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring + pod + thing indicator)',
    english: 'vanilla',
    swedish: 'vanilj',
    norwegian: 'vanilje',
    finnish: 'vanilja',
    hungarian: 'vanília',
    german: 'Vanille',
    dutch: 'vanillestokje',
    afrikaans: 'vanilla stokkie',
    russian: 'ваниль',
    latvian: 'vaniļa',
    polish: 'wanilia',
    french: 'vanille',
    spanish: 'vainilla',
  },
  {
    av: 22315,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring (powder) + vanilla [contr.] + thing indicator)',
    english: 'vanilla (powder)',
    swedish: 'vanilj (pulverform)',
    norwegian: 'vanilje (pulverform)',
    finnish: 'vanilja (jauhettu)',
    hungarian: 'vaníliapor',
    german: 'Vanille (Pulver)',
    dutch: 'vanillepoeder',
    afrikaans: 'vanilla poeier',
    russian: 'ванильный порошок',
    latvian: 'vaniļas pulveris',
    polish: 'wanilia (w proszku)',
    french: 'vanille (poudre)',
    spanish: 'vainilla (en polvo)',
  },
  {
    av: 22316,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring (liquid) + vanilla [contr.] + thing indicator)',
    english: 'vanilla (liquid)',
    swedish: 'vanilj (flytande)',
    norwegian: 'vanilje (flytende)',
    finnish: 'vanilja (nestemäinen)',
    hungarian: 'vanília – folyékony',
    german: 'Vanille (flüssig)',
    dutch: 'vanille-essence',
    afrikaans: 'vanilla essence',
    russian: 'ванильная эссенция',
    latvian: 'vaniļas esence',
    polish: 'wanilia (esencja w płynie)',
    french: 'vanille (liquide)',
    spanish: 'vainilla (líquido)',
  },
  {
    av: 22317,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sauce + vanilla [contr.])',
    english: 'vanilla sauce',
    swedish: 'vaniljsås',
    norwegian: 'vaniljesaus',
    finnish: 'vaniljakastike',
    hungarian: 'vaníliamártás, vaníliaöntet, vaníliaszósz',
    german: 'Vanillesoβe',
    dutch: 'vanillesaus',
    afrikaans: 'vanilla sous',
    russian: 'ванильный соус',
    latvian: 'vaniļas mērce',
    polish: 'sos waniliowy',
    french: 'sauce vanillée, sauce vanille',
    spanish: 'salsa de vainilla',
  },
  {
    av: 22318,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring + roots + thing indicator)',
    english: 'ginger',
    swedish: 'ingefära',
    norwegian: 'ingefær',
    finnish: 'inkivääri',
    hungarian: 'gyömbér',
    german: 'Ingwer',
    dutch: 'gember',
    afrikaans: 'gemmer',
    russian: 'имбирь',
    latvian: 'ingvers',
    polish: 'imbir',
    french: 'gingembre',
    spanish: 'jengibre',
  },
  {
    av: 22319,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring (powder) + ginger [contr.] + thing indicator)',
    english: 'ginger (powder)',
    swedish: 'ingefära (pulverform)',
    norwegian: 'ingefær (pulverform)',
    finnish: 'inkivääri (jauhettu)',
    hungarian: 'gyömbérpor',
    german: 'Ingwer (getrocknet und pulverisiert)',
    dutch: 'gemberpoeder',
    afrikaans: 'gemmer poeier',
    russian: 'имбирный порошок',
    latvian: 'ingvera pulveris',
    polish: 'imbir sproszkowany',
    french: 'gingembre (poudre)',
    spanish: 'jengibre (polvo)',
  },
  {
    av: 22320,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sauce + ginger [contr.])',
    english: 'ginger sauce',
    swedish: 'ingefärssås',
    norwegian: 'ingefærsaus',
    finnish: 'inkiväärikastike',
    hungarian: 'gyömbérszósz',
    german: 'Ingwersoße',
    dutch: 'gembersaus',
    afrikaans: 'gemmer sous',
    russian: 'имбирный соус',
    latvian: 'ingvera mērce',
    polish: 'sos imbirowy',
    french: 'sauce au gingembre',
    spanish: 'salsa de jengibre',
  },
  {
    av: 22321,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring (powder) + herb flavouring [contr.] + thing indicator)',
    english: 'herb flavouring (powder)',
    swedish: 'örtkrydda (pulverform)',
    norwegian: 'urtekrydder (pulverform)',
    finnish: 'yrttimauste (jauhettu)',
    hungarian: 'fűszernövényből készült por',
    german: 'Heilkraut, Kräuter (getrocknet und pulverisiert)',
    dutch: 'tuinkruiden (poeder)',
    afrikaans: 'krui geurmiddel poeier',
    russian: 'травяные приправы (порошок)',
    latvian: 'zaļumu garšvielas, pulveris',
    polish: 'zioła, przyprawy aromatyczne',
    french: "assaisonnement d'herbes en poudre",
    spanish: 'saborizante vegetal (en polvo)',
  },
  {
    av: 22322,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring + leaf + thing indicator)',
    english: 'herb flavouring',
    swedish: 'örtkrydda',
    norwegian: 'urtekrydder',
    finnish: 'yrttimauste',
    hungarian: 'fűszernövény ízű ízesítő',
    german: 'Heilkraut, Kräuter ',
    dutch: 'tuinkruiden (onder vorm van blad)',
    afrikaans: 'krui geurmiddel',
    russian: 'травяные приправы',
    latvian: 'zaļumu garšvielas ',
    polish: 'zioło, przyprawa',
    french: 'assaisonnement aux herbes',
    spanish: 'saborizante vegetal',
  },
  {
    av: 22323,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sauce + herb flavouring [contr.])',
    english: 'herb sauce',
    swedish: 'örtsås',
    norwegian: 'urtesaus',
    finnish: 'yrttikastike',
    hungarian: 'fűszernövényből készült öntet, szósz',
    german: 'Kräutersoße',
    dutch: 'tuinkruidensaus',
    afrikaans: 'krui sous',
    russian: 'соус из трав',
    latvian: 'zaļumu mērce',
    polish: 'sos ziołowy',
    french: 'sauce aux herbes',
    spanish: 'salsa de hierbas',
  },
  {
    av: 22324,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sauce + salad)',
    english: 'salad dressing',
    swedish: 'salladsdressing',
    norwegian: 'salatdressing',
    finnish: 'salaattikastike',
    hungarian: 'salátaöntet',
    german: 'Salatsoße, Salatdressing',
    dutch: 'slasaus, dressing',
    afrikaans: 'slaai sous',
    russian: 'заправка к салату',
    latvian: 'salātu mērce',
    polish: 'sos sałatkowy, sos do sałatki',
    french: 'sauce pour salade, vinaigrette',
    spanish: 'aliño de ensalada',
  },
  {
    av: 22325,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring (powder) + pepper [contr.] + thing indicator)',
    english: 'pepper (powder)',
    swedish: 'peppar (pulverform)',
    norwegian: 'pepper (pulverform)',
    finnish: 'pippuri (jauhettu)',
    hungarian: 'bors – őrölt, őrölt bors',
    german: 'Pfeffer',
    dutch: 'peper',
    afrikaans: 'peper poeier',
    russian: 'перец (порошок)',
    latvian: 'pipari, pulveris',
    polish: 'papryka w proszku',
    french: 'poivre en poudre',
    spanish: 'pimienta (en polvo)',
  },
  {
    av: 22326,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sauce + pepper [contr.])',
    english: 'pepper sauce',
    swedish: 'pepparsås',
    norwegian: 'peppersaus',
    finnish: 'pippurikastike',
    hungarian: 'borsmártás',
    german: 'Pfeffersoße',
    dutch: 'pepersaus',
    afrikaans: 'peper sous',
    russian: 'перечный соус',
    latvian: 'piparu mērce',
    polish: 'ostry sos',
    french: 'sauce au poivre',
    spanish: 'salsa a la pimienta',
  },
  {
    av: 22327,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring + mixture + hot [modification] + thing indicator)',
    english: 'curry',
    swedish: 'curry',
    norwegian: 'karry',
    finnish: 'curry',
    hungarian: 'curry',
    german: 'Curry',
    dutch: 'curry',
    afrikaans: 'kerrie',
    russian: 'карри',
    latvian: 'karijs',
    polish: 'curry (przyprawa)',
    french: 'curry',
    spanish: 'curry',
  },
  {
    av: 22328,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(flavouring [contr.] + powder + mixture + hot [modification] + thing indicator)',
    english: 'curry (powder)',
    swedish: 'curry (pulverform)',
    norwegian: 'karry (pulverform)',
    finnish: 'curry (jauhettu)',
    hungarian: 'currypor',
    german: 'Currypulver',
    dutch: 'kerriepoeder',
    afrikaans: 'kerrie poeier',
    russian: 'карри (порошок)',
    latvian: 'karija pulveris',
    polish: 'curry (w proszku)',
    french: 'curry (poudre)',
    spanish: 'curry (polvo)',
  },
  {
    av: 22329,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sauce + mixture + hot [modification])',
    english: 'curry sauce',
    swedish: 'currysås',
    norwegian: 'karrysaus',
    finnish: 'curry-kastike',
    hungarian: 'currymártás, curryszósz',
    german: 'Currysoße',
    dutch: 'kerriesaus',
    afrikaans: 'kerrie sous',
    russian: 'соус карри',
    latvian: 'karija mērce',
    polish: 'sos curry',
    french: 'curry (sauce)',
    spanish: 'salsa de curry',
  },
  {
    av: 22330,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring + seeds + intensity + thing indicator)',
    english: 'mustard',
    swedish: 'senap',
    norwegian: 'sennep',
    finnish: 'sinappi',
    hungarian: 'mustár',
    german: 'Senf',
    dutch: 'mosterd',
    afrikaans: 'mosterd',
    russian: 'горчица',
    latvian: 'sinepes',
    polish: 'musztarda',
    french: 'moutarde',
    spanish: 'mostaza',
  },
  {
    av: 22331,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring [contr.] + powder + mustard [contr.] + thing indicator)',
    english: 'mustard (powder)',
    swedish: 'senap (pulverform)',
    norwegian: 'sennep (pulverform)',
    finnish: 'sinappijauhe',
    hungarian: 'mustárpor',
    german: 'Senfpulver',
    dutch: 'mosterd (poeder)',
    afrikaans: 'mosterd poeier',
    russian: 'горчичный порошок',
    latvian: 'sinepju pulveris',
    polish: 'musztarda w proszku',
    french: 'moutarde en poudre',
    spanish: 'mostaza (en polvo)',
  },
  {
    av: 22332,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sauce + mustard [contr.])',
    english: 'mustard sauce',
    swedish: 'senapssås',
    norwegian: 'sennepssaus',
    finnish: 'sinappikastike',
    hungarian: 'mustárszósz',
    german: 'Senfsoße',
    dutch: 'mosterdsaus',
    afrikaans: 'mosterd sous',
    russian: 'горчичный соус',
    latvian: 'sinepju mērce',
    polish: 'sos musztardowy',
    french: 'sauce moutarde',
    spanish: 'salsa de mostaza',
  },
  {
    av: 22333,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring + trunk + thing indicator)',
    english: 'sap (flavouring)',
    swedish: 'sav (smaktillsats)',
    norwegian: 'sevje (smakstilsetning)',
    finnish: 'mahlamauste',
    hungarian: 'fából nyert ízesítő anyag, fűszer',
    german: 'Getränkesirup, Saftkonzentrat',
    dutch: 'sap (boom)',
    afrikaans: 'sap (geurmiddel)',
    russian: 'ароматизированная смола',
    latvian: 'auga sulas garša',
    polish: 'sok roślinny (aromat, przyprawa)',
    french: 'sève (arôme, assaisonnement)',
    spanish: 'savia (saborizante)',
  },
  {
    av: 22334,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sap flavouring + maple leaf + thing indicator)',
    english: 'maple syrup flavouring',
    swedish: 'lönnsirap (smaktillsats)',
    norwegian: 'lønnesirup (smakstilsetning)',
    finnish: 'vaahterasiirappi (mauste)',
    hungarian: 'juharszírup ízű ízesítő',
    german: 'Ahornsiruparoma, Ahornsirupgeschmack',
    dutch: 'maplesiroopkruiden',
    afrikaans: 'esdoring stroop geursel',
    russian: 'кленовый сироп (ароматизатор)',
    latvian: 'kļavu sīrupa garša',
    polish: 'aromat syropu klonowego',
    french: "arôme de sirop d'érable",
    spanish: 'sabor a sirope de arce',
  },
  {
    av: 22335,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring [contr.] + liquid + sweet + thing indicator)',
    english: 'syrup',
    swedish: 'sirap',
    norwegian: 'sirup',
    finnish: 'siirappi',
    hungarian: 'szirup',
    german: 'Zuckersirup',
    dutch: 'siroop (limonade)',
    afrikaans: 'stroop',
    russian: 'сироп',
    latvian: 'sīrups',
    polish: 'syrop (gęsty, słodki płyn)',
    french: 'sirop',
    spanish: 'jarabe',
  },
  {
    av: 22336,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + trunk)',
    english: 'sap',
    swedish: 'sav',
    norwegian: 'sevje',
    finnish: 'mahla, ydinneste',
    hungarian: 'fanedv, fából nyert folyadék',
    german: 'Pflanzensaft',
    dutch: 'sap (boom)',
    afrikaans: 'sap boom',
    russian: 'смола',
    latvian: 'augu sula',
    polish: 'sok roślinny',
    french: 'sève',
    spanish: 'savia',
  },
  {
    av: 22337,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring [contr.] + sap + thing indicator)',
    english: 'syrup (from tree)',
    swedish: 'sirap från träd',
    norwegian: 'sirup fra tre',
    finnish: 'siirappi (puusta)',
    hungarian: 'szirup (fából nyert)',
    german: 'Baumsirup',
    dutch: 'siroop (boom)',
    afrikaans: 'sap (van boom)',
    russian: 'сироп (из дерева)',
    latvian: 'sīrups (iegūts no koka)',
    polish: 'syrop z drzewa, syrop klonowy, brzozowy',
    french: 'sirop de sève',
    spanish: 'almíbar (de árbol)',
  },
  {
    av: 22338,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring [contr.] + sap + maple leaf + thing indicator)',
    english: 'maple syrup',
    swedish: 'lönnsirap',
    norwegian: 'lønnesirup',
    finnish: 'vaahterasiirappi',
    hungarian: 'juharszirup, jávorfa szirup',
    german: 'Ahornsirup',
    dutch: 'maplesiroop',
    afrikaans: 'esdoring stroop',
    russian: 'кленовый сироп',
    latvian: 'kļavu sīrups',
    polish: 'syrop klonowy (płynny)',
    french: "sirop d'érable",
    spanish: 'sirope de arce',
  },
  {
    av: 22339,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flavouring [contr.] + liquid + corn + thing indicator)',
    english: 'corn syrup',
    swedish: 'majssirap',
    norwegian: 'maissirup',
    finnish: 'maissisiirappi',
    hungarian: 'kukoricaszirup',
    german: 'Maissirup',
    dutch: 'maissiroop',
    afrikaans: 'koring stroop',
    russian: 'кукурузный сироп',
    latvian: 'kukurūzas sīrups',
    polish: 'syrop kukurydziany',
    french: 'sirop de maïs',
    spanish: 'sirope de maíz',
  },
  {
    av: 22340,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(flavouring [contr.] + powder + bean + sweet [contr.] + thing indicator)',
    english: 'chocolate, cocoa, cacao (sweet powder)',
    swedish: 'chokladpulver',
    norwegian: 'sjokoladepulver',
    finnish: 'kaakao (makeutettu)',
    hungarian: 'kakaópor, csokoládépor – édes',
    german: 'Schokolade, Kakao (süβes Pulver)',
    dutch: 'chocola (melk)',
    afrikaans: 'sjokolade, kakao (soet poeier)',
    russian: 'шоколадный порошок',
    latvian: 'šokolāde, kakao, kakao pulveris',
    polish: 'czekolada, kakao, kakao z cukrem (słodki proszek)',
    french: 'cacao sucré (poudre)',
    spanish: 'cacao (polvo dulce)',
  },
  {
    av: 22341,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(flavouring [contr.] + powder + bean + bitter [contr.] + thing indicator)',
    english: 'chocolate, cocoa, cacao (bitter powder)',
    swedish: 'kakao (pulver)',
    norwegian: 'kakaopulver',
    finnish: 'kaakaojauhe',
    hungarian: 'kakaópor, csokoládépor – keserű',
    german: 'Kakaopulver, Schokoladenpulver (bitteres Pulver)',
    dutch: 'chocola (puur), chocola (zwart) (Vl)',
    afrikaans: 'sjokolade, kakao (bitter poeier)',
    russian: 'какао порошок (горький)',
    latvian: 'šokolāde, rūgtās šokolādes pulveris)',
    polish: 'czekolada, kakao, kakao bez cukru (gorzki proszek)',
    french: 'cacao (poudre)',
    spanish: 'cacao (polvo amargo)',
  },
  {
    av: 22342,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sauce + chocolate [contr.])',
    english: 'chocolate sauce',
    swedish: 'chokladsås',
    norwegian: 'sjokoladesaus',
    finnish: 'suklaakastike',
    hungarian: 'csokoládé öntet, csokiszósz',
    german: 'Schokoladensoße',
    dutch: 'chocoladesaus',
    afrikaans: 'sjokolade sous',
    russian: 'шоколадный соус',
    latvian: 'šokoādes mērce',
    polish: 'sos, polewa czekoladowa',
    french: 'chocolat liquide, sauce chocolat',
    spanish: 'salsa de chocolate',
  },
  {
    av: 22343,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spread + piece + chocolate [contr.])',
    english: 'chocolate (hagel)',
    swedish: 'chokladströssel',
    norwegian: 'sjokoladedryss',
    finnish: 'suklaarae',
    hungarian: 'csokoládé reszelék, csokireszelék',
    german: 'Schokoladenstreusel',
    dutch: 'hagelslag, chocoladehagel, chocoladekorrels (Vl)',
    afrikaans: 'sjokolade (hagel)',
    russian: 'шоколадная крошка',
    latvian: 'šokolādes drupačas',
    polish: 'czekolada (groszek czekoladowy, czekolada w kawałkach)',
    french: 'chocolat vermicelle, chocolat granulé',
    spanish: 'chocolate (Hagel), chispas de chocolate',
  },
  {
    av: 22344,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drink + sweet)',
    english: 'sweet drink',
    swedish: 'dryck (söt)',
    norwegian: 'drikk (søt)',
    finnish: 'juoma (makea)',
    hungarian: 'üdítőital (édes)',
    german: '(süßes) Getränk',
    dutch: 'limonade',
    afrikaans: 'soet drankie',
    russian: 'сдадкий напиток',
    latvian: 'salds dzēriens',
    polish: 'słodki napój',
    french: 'boisson sucrée',
    spanish: 'bebida dulce',
  },
  {
    av: 22345,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wine + gas)',
    english: 'sparkling wine',
    swedish: 'vin (mousserande)',
    norwegian: 'vin (musserende)',
    finnish: 'kuohuviini',
    hungarian: 'habzóbor',
    german: 'Schaumwein, Sekt',
    dutch: 'mousserende wijn',
    afrikaans: 'vonkelwyn',
    russian: 'вино игристое',
    latvian: 'dzirkstošais vīns',
    polish: 'szampan, wino musujące',
    french: 'vin mousseux',
    spanish: 'vino espumoso',
  },
  {
    av: 22346,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sparkling wine + intensity)',
    english: 'champagne',
    swedish: 'champagne',
    norwegian: 'champagne',
    finnish: 'samppanja',
    hungarian: 'pezsgő',
    german: 'Champagner',
    dutch: 'champagne',
    afrikaans: 'sjampanje, champagne',
    russian: 'шампанское',
    latvian: 'šampanietis',
    polish: 'szampan',
    french: 'champagne',
    spanish: 'champaña',
  },
  {
    av: 22347,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(alcoholic drink + apple)',
    english: 'cider',
    swedish: 'cider',
    norwegian: 'eplesider, sider (alkoholholdig)',
    finnish: 'siideri',
    hungarian: 'almabor',
    german: 'Apfelwein, Most, Cidre',
    dutch: 'cider',
    afrikaans: 'appelwyn',
    russian: 'сидр',
    latvian: 'sidrs',
    polish: 'jabłecznik, cydr (alkoholowy napój jabłkowy)',
    french: 'cidre',
    spanish: 'sidra',
  },
  {
    av: 22349,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(liquid + intensity + description indicator)',
    english: 'juicy',
    swedish: 'saftig',
    norwegian: 'saftig',
    finnish: 'mehukas',
    hungarian: 'lédús, leves',
    german: 'saftig',
    dutch: 'sappig',
    afrikaans: 'sappig',
    russian: 'сочный',
    latvian: 'sulīgs',
    polish: 'soczysty',
    french: 'juteux',
    spanish: 'jugoso',
  },
  {
    av: 22350,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(taste + sharp + description after the fact indicator)',
    english: 'pickled',
    swedish: 'inlagd (t ex i ättikslag)',
    norwegian: 'syltet, lagt i lake',
    finnish: 'karvas',
    hungarian: 'savanyított',
    german: 'gesäuert, eingelegt (in Essig)',
    dutch: 'zuur',
    afrikaans: 'piekel',
    russian: 'маринованный',
    latvian: 'marinēts',
    polish: 'marynowane, kiszone',
    french: 'vinaigré (conserve)',
    spanish: 'en vinagre',
  },
  {
    av: 22351,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to fry [contr.] + description indicator)',
    english: 'fried',
    swedish: 'stekt',
    norwegian: 'stekt',
    finnish: 'paistettu, friteerattu',
    hungarian: 'sült, olajban vagy zsírban sütött',
    german: 'gebraten',
    dutch: 'gefrituurd',
    afrikaans: 'gebraai',
    russian: 'жаренный',
    latvian: 'cepts',
    polish: 'smażony',
    french: "frit (à l'huile)",
    spanish: 'frito',
  },
  {
    av: 22352,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(tasty + one intensity character + description indicator)',
    english: 'delicious, scrumptious, yummy',
    swedish: 'jättegod, läcker',
    norwegian: 'kjempegod',
    finnish: 'herkullinen',
    hungarian: 'ízletes, finom, pompás, remek',
    german: 'lecker, schmackhaft',
    dutch: 'verrukkelijk',
    afrikaans: 'heerlik, yummy, smaaklik',
    russian: 'вкусный',
    latvian: 'gards, garšīgs, brīnišķīgs',
    polish: 'pyszne, doskonałe (w smaku)',
    french: 'délicieux, succulent',
    spanish: 'delicioso, suculento',
  },
  {
    av: 22353,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(tasty + negative + description indicator)',
    english: 'tasteless, not tasty, not good',
    swedish: 'smaklös',
    norwegian: 'smakløs',
    finnish: 'mauton',
    hungarian: 'íztelen, ízetlen',
    german: 'geschmacklos',
    dutch: 'smaakloos, smakeloos',
    afrikaans: 'smaakloos, yukky',
    russian: 'безвкусный',
    latvian: 'bezgaršīgs',
    polish: 'niesmaczne, bez smaku',
    french: 'fade, insipide, sans goût',
    spanish: 'insípido',
  },
  {
    av: 22354,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(not tasty + one intensity character + description indicator)',
    english: 'disgusting (taste)',
    swedish: 'äcklig, osmaklig',
    norwegian: 'ekkel, usmakelig',
    finnish: 'pahanmakuinen',
    hungarian: 'förtelmes, undorító, gusztustalan',
    german: 'ekelhaft, eklig',
    dutch: 'afschuwelijk (smaak), onsmakelijk',
    afrikaans: 'afskuwelik, onsmaaklik, sleg (smaak)',
    russian: 'отвратительный',
    latvian: 'pretīgs, neēdams',
    polish: 'obrzydliwe, paskudne (w smaku)',
    french: 'écoeurant, dégoûtant',
    spanish: 'desagradable (sabor)',
  },
  {
    av: 22355,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + frozen)',
    english: 'meat (frozen), frozen meat',
    swedish: 'kött (djupfryst)',
    norwegian: 'kjøtt (dypfryst)',
    finnish: 'pakasteliha',
    hungarian: 'mélyhűtött hús, fagyasztott hús',
    german: 'Gefrierfleisch ',
    dutch: 'diepvriesvlees, vlees uit diepvries',
    afrikaans: 'gevriesde vleis (vleis)',
    russian: 'мясо (замороженное)',
    latvian: 'gaļa, saldēta gaļa',
    polish: 'mięso mrożone, mrożonka',
    french: 'viande surgelée',
    spanish: 'carne congelada',
  },
  {
    av: 22356,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + frozen)',
    english: 'fish (frozen)',
    swedish: 'fisk (djupfryst)',
    norwegian: 'fisk (dypfryst)',
    finnish: 'pakastekala',
    hungarian: 'mélyhűtött hal, fagyasztott hal',
    german: 'Gefrierfisch ',
    dutch: 'diepvriesvis, vis uit diepvries',
    afrikaans: 'gevriesde vis (vis)',
    russian: 'рыба (замороженная)',
    latvian: 'zivs, saldēta zivs',
    polish: 'ryba mrożona',
    french: 'poisson surgelé',
    spanish: 'pescado congelado',
  },
  {
    av: 22357,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(yoghurt + frozen)',
    english: 'yogurt, yoghurt (frozen)',
    swedish: 'yoghurt (frusen)',
    norwegian: 'yoghurt frossen',
    finnish: 'jugurttijäädyke',
    hungarian: 'mélyhűtött joghurt',
    german: 'Joghurteis',
    dutch: 'diepvriesyoghurt, yoghurt uit diepvries',
    afrikaans: 'yoghurt gevries',
    russian: 'йогурт (замороженный) ',
    latvian: 'jogurts, saldēts jogurts',
    polish: 'jogurt (mrożony)',
    french: 'yaourt surgelé',
    spanish: 'yogur congelado',
  },
  {
    av: 22358,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cheese + hard)',
    english: 'hard cheese',
    swedish: 'hårdost',
    norwegian: 'ost (fast)',
    finnish: 'juusto (kova)',
    hungarian: 'sajt – kemény, kemény sajt',
    german: 'Käse',
    dutch: 'harde kaas',
    afrikaans: 'harde kaas',
    russian: 'твердый сыр',
    latvian: 'cietais siers',
    polish: 'twardy ser',
    french: 'fromage à pâte dure',
    spanish: 'queso duro',
  },
  {
    av: 22359,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cheese + soft)',
    english: 'soft cheese',
    swedish: 'dessertost, mjukost',
    norwegian: 'mykost',
    finnish: 'juusto (pehmeä)',
    hungarian: 'sajt – lágy, lágy sajt',
    german: 'Quark, Weichkäse, Frischkäse',
    dutch: 'zachte kaas',
    afrikaans: 'sagte kaas',
    russian: 'мягкий сыр',
    latvian: 'mīkstais siers',
    polish: 'ser półtwardy',
    french: 'fromage à pâte molle',
    spanish: 'queso blando',
  },
  {
    av: 22360,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cheese + spread: cheese used as a spread)',
    english: 'spreadable cheese',
    swedish: 'smältost',
    norwegian: 'smøreost',
    finnish: 'juustolevite',
    hungarian: 'sajt – kenhető krémsajt',
    german: 'Schmierkäse',
    dutch: 'smeerkaas',
    afrikaans: 'smeerkaas',
    russian: 'плавленый сыр',
    latvian: 'kausētais siers',
    polish: 'serek topiony',
    french: 'fromage à tartiner',
    spanish: 'queso untable',
  },
  {
    av: 22361,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cheese + new)',
    english: 'fresh cheese',
    swedish: 'färskost',
    norwegian: 'ost (fersk)',
    finnish: 'tuorejuusto',
    hungarian: 'sajt – friss',
    german: 'Quark, Weichkäse, Frischkäse',
    dutch: 'kwark (Nl), platte kaas (vl), verse kaas',
    afrikaans: 'vars kaas',
    russian: 'свежий сыр',
    latvian: 'svaigais siers',
    polish: 'twaróg',
    french: 'fromage frais',
    spanish: 'queso fresco',
  },
  {
    av: 22363,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(lump(s) + description indicator)',
    english: 'lumpy',
    swedish: 'klumpig',
    norwegian: 'smuldret, klumpete',
    finnish: 'kokkareinen, rakeinen',
    hungarian: 'csomós',
    german: 'klumpig',
    dutch: 'klonterig',
    afrikaans: 'klonterig',
    russian: 'кусковой, зернистый',
    latvian: 'kunkuļains',
    polish: 'zbity, zbrylony',
    french: 'grumeleux, en grumeaux',
    spanish: 'grumoso',
  },
  {
    av: 22364,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cheese + lump(s))',
    english: 'cottage cheese',
    swedish: 'keso, kvarg',
    norwegian: 'cottage cheese',
    finnish: 'raejuusto',
    hungarian: 'túró',
    german: 'Hüttenkäse',
    dutch: 'Hüttenkäse, cottage cheese',
    afrikaans: 'maas kaas',
    russian: 'творог',
    latvian: 'mājas siers',
    polish: 'twaróg',
    french: 'fromage blanc granuleux, cottage',
    spanish: 'queso blanco grumoso',
  },
  {
    av: 22367,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ice cream (lollipop) + frozen)',
    english: 'water ice lollipop',
    swedish: 'isglass (pinne)',
    norwegian: 'saftis (pinne)',
    finnish: 'mehujääpuikko',
    hungarian: 'jégnyalóka',
    german: 'Wassereis am Stiel',
    dutch: 'waterijs',
    afrikaans: 'ysie sap melk',
    russian: 'мороженое-лёд на палочке',
    latvian: 'ledus gabaliņi',
    polish: 'lody na patyku',
    french: "glace à l'eau (sucette)",
    spanish: 'sorbete (palito)',
  },
  {
    av: 22368,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cylinder + frozen)',
    english: 'popsicle',
    swedish: 'isglass (cylinder)',
    norwegian: 'saftis (sylinderformet)',
    finnish: 'mehujää',
    hungarian: 'jégkrém',
    german: 'Eis am Stiel (Zylinder)',
    dutch: 'ijs (cilindervormig)',
    afrikaans: 'ysie silindries',
    russian: 'эскимо',
    latvian: 'eskimo',
    polish: 'lizak lodowy (lody na patyku)',
    french: 'glace en bâtonnet',
    spanish: 'sorbete (cilíndrico)',
  },
  {
    av: 22370,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ice cream + bar)',
    english: 'ice cream (bar)',
    swedish: 'glass (kaka)',
    norwegian: 'is med kjeks, sandwich',
    finnish: 'jäätelöpatukka',
    hungarian: 'jégkrémszelet',
    german: 'Eiscafé, Eisbude, Eisdiele',
    dutch: 'ijsjesreep',
    afrikaans: 'roomys (koek)',
    russian: 'мороженое-торт',
    latvian: 'glazēts saldējums',
    polish: 'lody typu sandwich („w kanapce”)',
    french: 'crème glacée (en barre)',
    spanish: 'helado (barra)',
  },
  {
    av: 22372,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bar + sweet)',
    english: 'candy bar',
    swedish: 'chokladbit (etc)',
    norwegian: 'sukkerstang',
    finnish: 'karkkipatukka',
    hungarian: 'cukorka, cukorkadarab',
    german: 'Schokoladenriegel',
    dutch: 'snoepreep',
    afrikaans: 'lekkergoed reep',
    russian: 'сладкий торт',
    latvian: 'saldā rulete',
    polish: 'batonik, wafelek, słodka przekąska',
    french: 'barre sucrée',
    spanish: 'barra de chocolate',
  },
  {
    av: 22373,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bar + chocolate [contr.])',
    english: 'chocolate bar',
    swedish: 'chokladkaka',
    norwegian: 'sjokoladeplate',
    finnish: 'suklaapatukka',
    hungarian: 'csokoládészelet, csokoládé tábla',
    german: 'Schokoladentafel, Schokoriegel, Tafel (Schokolade)',
    dutch: 'chocoladereep',
    afrikaans: 'sjokolade reep plak',
    russian: 'шоколадный торт',
    latvian: 'šokolādes rulete',
    polish: 'tabliczka czekolady',
    french: 'barre de chocolat',
    spanish: 'barra de chocolate',
  },
  {
    av: 22374,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(reflection (mental), consideration + action indicator)',
    english: 'reflect, consider-(to)',
    swedish: 'reflektera, fundera',
    norwegian: 'reflektere, overveie',
    finnish: 'harkita, miettiä',
    hungarian: 'figyelembe venni, reflektálni',
    german: 'reflektieren, nachdenken, überlegen',
    dutch: 'overwegen, reflecteren, bedenken',
    afrikaans: 'reflekteer, oorweeg (om te)',
    russian: 'отображать, раздумывать',
    latvian: 'pārdomāt, apdomāt, apsvērt',
    polish: 'odbijać, błyszczeć',
    french: 'réfléchir, considérer',
    spanish: 'reflexionar, considerar',
  },
  {
    av: 22376,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + candy)',
    english: 'candy, sweets',
    swedish: 'godis',
    norwegian: 'godteri, smågodt',
    finnish: 'makeiset',
    hungarian: 'édesség',
    german: 'Süßigkeit, Bonbon',
    dutch: 'snoep, lekkers',
    afrikaans: 'lekkers, toffies, lekkergoed',
    russian: 'сладости',
    latvian: 'konfektes, saldumi',
    polish: 'cukierki, słodycze',
    french: 'sucreries, bonbons, douceurs',
    spanish: 'caramelos, dulces',
  },
  {
    av: 22378,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mixture + flour [contr.] + liquid)',
    english: 'dough',
    swedish: 'deg',
    norwegian: 'deig',
    finnish: 'taikina',
    hungarian: 'tészta, kovász',
    german: 'Teig',
    dutch: 'deeg',
    afrikaans: 'deeg',
    russian: 'тесто',
    latvian: 'mīkla',
    polish: 'ciasto',
    french: 'pâte (à pain)',
    spanish: 'masa',
  },
  {
    av: 22379,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mixture + flour [contr.] + much + liquid)',
    english: 'batter',
    swedish: 'smet',
    norwegian: 'røre',
    finnish: 'taikina',
    hungarian: 'tészta – felvert, híg, folyékony tészta',
    german: 'Backteig, Pfannkuchenteig',
    dutch: 'beslag',
    afrikaans: 'beslag',
    russian: 'жидкое тесто',
    latvian: 'mīcīt',
    polish: 'ciasto zagniatane (urabiane, wygniatane)',
    french: 'pâte à frire',
    spanish: 'mezcla (comida)',
  },
  {
    av: 22380,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + mixture)',
    english: 'ingredient',
    swedish: 'ingrediens',
    norwegian: 'ingrediens',
    finnish: 'aine, ainesosa',
    hungarian: 'alkotórész, hozzávaló, összetevő',
    german: 'Zutat, Ingredienz',
    dutch: 'ingrediënt',
    afrikaans: 'bestandeel',
    russian: 'ингредиент',
    latvian: 'sastāvdaļas',
    polish: 'składnik, cześć mieszanki',
    french: 'ingrédient',
    spanish: 'ingrediente',
  },
  {
    av: 22381,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thin + knife + thing indicator: a piece of food cut thin)',
    english: 'slice',
    swedish: 'skiva (subst.)',
    norwegian: 'skive',
    finnish: 'viipale',
    hungarian: 'szelet',
    german: 'Scheibe',
    dutch: 'plak, sneetje',
    afrikaans: 'sny',
    russian: 'ломтик, нарезка',
    latvian: 'šķēle',
    polish: 'płat (ucięty kawałek)',
    french: 'tranche',
    spanish: 'rebanada',
  },
  {
    av: 22382,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(slice + action indicator)',
    english: 'slice-(to)',
    swedish: 'skiva (verb)',
    norwegian: 'skive opp, skjære i skiver',
    finnish: 'viipaloida',
    hungarian: 'szeletelni, vágni, levágni',
    german: 'schneiden, abschneiden',
    dutch: 'in plakken snijden, afsnijden-(plakjes)',
    afrikaans: 'sny (om te)',
    russian: 'нарезать ломтики',
    latvian: 'sagriezt šķēlēs',
    polish: 'pociąć, przeciąć, rozciąć',
    french: 'trancher, couper',
    spanish: 'rebanar',
  },
  {
    av: 22383,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(slice + description indicator)',
    english: 'sliced',
    swedish: 'skivad',
    norwegian: 'skivet, oppdelt',
    finnish: 'viipaloitu',
    hungarian: 'szeletelt',
    german: 'geschnitten',
    dutch: 'gesneden',
    afrikaans: 'gesnyde',
    russian: 'нарезанный ломтиками',
    latvian: 'sagriezts šķēlēs',
    polish: 'pocięty, rozcięty',
    french: 'en tranches',
    spanish: 'rebanado',
  },
  {
    av: 22385,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + reflection)',
    english: 'reflector',
    swedish: 'reflex, reflektor',
    norwegian: 'refleks, reflektor',
    finnish: 'heijastin',
    hungarian: 'reflektor',
    german: 'Reflektor',
    dutch: 'reflector',
    afrikaans: 'reflektor',
    russian: 'отражатель',
    latvian: 'reflektors',
    polish: 'reflektor, odbłyśnik (przedmiot odbijający)',
    french: 'réflecteur, catadioptre',
    spanish: 'reflector',
  },
  {
    av: 22387,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(shine + action indicator)',
    english: 'shine-(to)',
    swedish: 'blänka, glänsa, skina',
    norwegian: 'skinne, glinse',
    finnish: 'kiiltää, hohtaa, loistaa',
    hungarian: 'csillogni, ragyogni',
    german: 'leuchten, scheinen',
    dutch: 'glimmen, glanzen, blinken',
    afrikaans: 'glans, blink, glim (om te)',
    russian: 'блестеть, сиять',
    latvian: 'spīdēt, mirdzēt',
    polish: 'lśnić, odbijać światło',
    french: 'briller, reluire',
    spanish: 'brillar',
  },
  {
    av: 22388,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(shine + description indicator)',
    english: 'shiny, glossy',
    swedish: 'blank, glänsande, skinande',
    norwegian: 'skinnende, glinsende, blank',
    finnish: 'kiiltävä, hohtava, loistava',
    hungarian: 'csillogó, fényes',
    german: 'hell, glänzend',
    dutch: 'blinkend, glanzend, glimmend',
    afrikaans: 'glansend, glimmerend, blink',
    russian: 'блестящий, глянцевый',
    latvian: 'spīdīgs, mirdzošs',
    polish: 'lśniący, błyszczący',
    french: 'luisant, reluisant',
    spanish: 'brillante',
  },
  {
    av: 22389,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to rub [contr.] + shine + action indicator)',
    english: 'polish-(to)',
    swedish: 'polera, putsa',
    norwegian: 'polere, pusse',
    finnish: 'kiillottaa',
    hungarian: 'kifényesíteni, fényesre csiszolni',
    german: 'polieren, blank reiben',
    dutch: 'poetsen (polieren), opblinken (Vl)',
    afrikaans: 'poets (om te)',
    russian: 'полировать',
    latvian: 'spodrināt, pulēt',
    polish: 'polerować, nabłyszczać',
    french: 'polir, cirer',
    spanish: 'pulir, sacar brillo',
  },
  {
    av: 22390,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to polish [contr.])',
    english: 'polisher',
    swedish: 'polermaskin',
    norwegian: 'poleringsmaskin',
    finnish: 'kiillotuskone',
    hungarian: 'csiszológép, fényesítő gép',
    german: 'Poliermaschine',
    dutch: 'poetsmachine',
    afrikaans: 'poetsmasjien',
    russian: 'полировальная машина',
    latvian: 'spodrinātājs, pulētājs',
    polish: 'polerka',
    french: 'cireuse',
    spanish: 'enceradora',
  },
  {
    av: 22391,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to clean)',
    english: 'vacuum cleaner',
    swedish: 'dammsugare',
    norwegian: 'støvsuger',
    finnish: 'pölynimuri',
    hungarian: 'porszívó',
    german: 'Staubsauger',
    dutch: 'stofzuiger',
    afrikaans: 'stofsuier',
    russian: 'пылесос',
    latvian: 'putekļusūcējs',
    polish: 'odkurzacz',
    french: 'aspirateur',
    spanish: 'aspiradora',
  },
  {
    av: 22392,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + mixture)',
    english: 'mixer, blender',
    swedish: 'mixer',
    norwegian: 'mikser',
    finnish: 'vatkain',
    hungarian: 'keverőgép, turmixgép, mixer',
    german: 'Mixer',
    dutch: 'blender, mixer',
    afrikaans: 'menger',
    russian: 'миксер',
    latvian: 'mikseris, blenderis',
    polish: 'mikser',
    french: 'mixer, malaxer',
    spanish: 'mezcladora, licuadora',
  },
  {
    av: 22393,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + cooking, cookery, preparation (general))',
    english: 'food processor, kitchen machine',
    swedish: 'matberedare (etc)',
    norwegian: 'kjøkkenmaskin',
    finnish: 'yleiskone',
    hungarian: 'konyhai turmixgép, ételelőkészítő gép',
    german: 'Küchenmaschine',
    dutch: 'keukenmachine, keukenrobot',
    afrikaans: 'voedselverwerker, menger voedsel',
    russian: 'кухонный комбайн',
    latvian: 'virtuves kombains',
    polish: 'robot kuchenny',
    french: 'appareil ménager',
    spanish: 'máquina de cocina',
  },
  {
    av: 22394,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + to open)',
    english: 'opener',
    swedish: 'öppnare',
    norwegian: 'åpner',
    finnish: 'avaaja',
    hungarian: 'nyitó',
    german: 'Öffner',
    dutch: 'opener',
    afrikaans: 'oopmaker',
    russian: 'открывалка',
    latvian: 'attaisāmais',
    polish: 'otwieracz',
    french: 'outil servant à ouvrir, ouvre-boîte',
    spanish: 'abridor ',
  },
  {
    av: 22395,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(opener + bottle)',
    english: 'bottle opener',
    swedish: 'flasköppnare',
    norwegian: 'flaskeåpner',
    finnish: 'pullonavaaja',
    hungarian: 'üvegnyitó',
    german: 'Flaschenöffner',
    dutch: 'flesopener',
    afrikaans: 'bottel oopmaker',
    russian: 'открывалка для бутылок',
    latvian: 'pudeļu attaisāmais',
    polish: 'otwieracz do butelek',
    french: 'ouvre-bouteille',
    spanish: 'abridor de botellas',
  },
  {
    av: 22396,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(opener + can)',
    english: 'can opener',
    swedish: 'burköppnare, konservöppnare',
    norwegian: 'bokseåpner',
    finnish: 'tölkinavaaja, purkinavaaja',
    hungarian: 'konzervnyitó',
    german: 'Dosenöffner, Büchsenöffner',
    dutch: 'blikopener',
    afrikaans: 'blik oopmaker',
    russian: 'консервный нож',
    latvian: 'konservu attaisāmais',
    polish: 'otwieracz do puszek',
    french: 'ouvre-boîte',
    spanish: 'abrelatas',
  },
  {
    av: 22397,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + to clean)',
    english: 'cleaning tool',
    swedish: 'städredskap',
    norwegian: 'rengjøringsredskap',
    finnish: 'puhdistusväline',
    hungarian: 'takarító eszköz',
    german: 'Reinigungsutensil',
    dutch: 'poetsgerief',
    afrikaans: 'skoonmaakmiddel',
    russian: 'чистящее средство',
    latvian: 'trauku mazgājamais šķīdums',
    polish: 'przyrząd do czyszczenia',
    french: 'ustensile de nettoyage, outil de nettoyage',
    spanish: 'elemento de limpieza',
  },
  {
    av: 22398,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + to clean)',
    english: 'cleaning cloth',
    swedish: 'disktrasa, skurtrasa (etc)',
    norwegian: 'oppvaskklut, skurefille (o.l.)',
    finnish: 'puhdistusliina',
    hungarian: 'tisztítókendő, lemosókendő, portörlő',
    german: 'Putzlappen',
    dutch: 'poetsdoek',
    afrikaans: 'poetsdoek, poetslap',
    russian: 'тряпка для чистки',
    latvian: 'trauku mazgājamā lupata',
    polish: 'ściereczka czyszcząca',
    french: 'lavette, torchon',
    spanish: 'trapo de limpieza',
  },
  {
    av: 22562,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(kitchen tool + to cut + piece)',
    english: 'grater, grinder',
    swedish: 'rivjärn, kvarn (etc)',
    norwegian: 'rivjern, kvern',
    finnish: 'raastin',
    hungarian: 'reszelő, daráló',
    german: 'Reibe, Trennschleifer, Mahlwerk',
    dutch: 'rasp',
    afrikaans: 'rasper',
    russian: 'терка, измельчитель',
    latvian: 'rīve',
    polish: 'tarka, tarnik, szlifierka',
    french: 'râpe (de cuisine)',
    spanish: 'rallador, molinillo',
  },
  {
    av: 22563,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(kitchen tool + to mix)',
    english: 'whisk, beater',
    swedish: 'visp',
    norwegian: 'visp',
    finnish: 'vispilä',
    hungarian: 'habverő',
    german: 'Schneebesen, Schaumschläger',
    dutch: 'garde, klopper',
    afrikaans: 'klitser, klopper',
    russian: 'венчик',
    latvian: 'putojamā slotiņa',
    polish: 'trzepaczka, rózga do mieszania',
    french: 'batteur',
    spanish: 'batidora',
  },
  {
    av: 22564,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(kitchen tool + screw)',
    english: 'corkscrew',
    swedish: 'korkskruv',
    norwegian: 'korketrekker',
    finnish: 'korkkiruuvi',
    hungarian: 'dugóhúzó',
    german: 'Korkenzieher',
    dutch: 'kurkentrekker',
    afrikaans: 'kurktrekker',
    russian: 'штопор',
    latvian: 'korķuviļķis',
    polish: 'korkociąg',
    french: 'tire-bouchon',
    spanish: 'sacacorchos',
  },
  {
    av: 22565,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(kitchen tool + tongs)',
    english: 'kitchen tongs',
    swedish: 'kökstång',
    norwegian: 'kjøkkenklype',
    finnish: 'pihdit (keittiö)',
    hungarian: 'konyhai fogó',
    german: 'Küchenzange',
    dutch: 'keukentang',
    afrikaans: 'kombuis tang, vleis tang, braai tang',
    russian: 'кухонные щипцы',
    latvian: 'virtuves knaibles',
    polish: 'szczypce kuchenne',
    french: 'pinces de cuisine',
    spanish: 'pinzas de cocina',
  },
  {
    av: 22566,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(kitchen tool + nut)',
    english: 'nutcracker',
    swedish: 'nötknäppare',
    norwegian: 'nøtteknekker',
    finnish: 'pähkinänsärkijä',
    hungarian: 'diótörő',
    german: 'Nussknacker',
    dutch: 'notenkraker',
    afrikaans: 'neutkraker',
    russian: 'орехоколка',
    latvian: 'riekstu knaibles',
    polish: 'dziadek do orzechów',
    french: 'casse-noix',
    spanish: 'cascanueces',
  },
  {
    av: 22567,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid + to bring + thing indicator)',
    english: 'reaching aid, grabber',
    swedish: 'gripverktyg',
    norwegian: 'griperedskap',
    finnish: 'pihdit (apuväline)',
    hungarian: 'segédeszköz valami megfogásához, ',
    german: 'Greifer',
    dutch: 'grijper',
    afrikaans: 'tang',
    russian: 'переноска',
    latvian: 'satvērējs',
    polish: 'chwytak (urządzenie wspomagające chwytanie)',
    french: 'aide technique pour saisir, pince de préhension',
    spanish: 'agarraderas',
  },
  {
    av: 22568,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spoon + to measure)',
    english: 'measuring spoon',
    swedish: 'måttsked',
    norwegian: 'måleskje',
    finnish: 'mittalusikka',
    hungarian: 'mérőkanál, mérce',
    german: 'Messlöffel',
    dutch: 'maatlepel, maatschep',
    afrikaans: 'maatlepel',
    russian: 'мерная ложка',
    latvian: 'mērkarote',
    polish: 'menzurka, naczynie z podziałką, miarka',
    french: 'cuiller mesurette, cuillère à mesure',
    spanish: 'cuchara de medir',
  },
  {
    av: 22569,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spoon + small)',
    english: 'teaspoon',
    swedish: 'tesked',
    norwegian: 'teskje',
    finnish: 'teelusikka',
    hungarian: 'kiskanál, teáskanál, kávéskanál',
    german: 'Löffel, Teelöffel',
    dutch: 'theelepel, koffielepel',
    afrikaans: 'teelepel',
    russian: 'чайная ложка',
    latvian: 'tējkarote',
    polish: 'łyżeczka ',
    french: 'cuiller à café',
    spanish: 'cucharita de te',
  },
  {
    av: 22570,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spoon + big)',
    english: 'tablespoon',
    swedish: 'matsked',
    norwegian: 'spiseskje',
    finnish: 'ruokalusikka',
    hungarian: 'nagykanál, evőkanál, leveses kanál',
    german: 'Eβlöffel',
    dutch: 'soeplepel, eetlepel',
    afrikaans: 'eetlepel',
    russian: 'столовая ложка',
    latvian: 'deserta karote',
    polish: 'łyżka stołowa',
    french: 'cuiller à soupe, grande cuiller',
    spanish: 'cuchara de servir',
  },
  {
    av: 22571,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spoon + to give)',
    english: 'serving spoon',
    swedish: 'serveringssked',
    norwegian: 'serveringsskje, øse',
    finnish: 'lusikka (tarjoiluun)',
    hungarian: 'tálalókanál',
    german: 'Kelle, Schöpflöffel',
    dutch: 'opscheplepel',
    afrikaans: 'opskeplepel',
    russian: 'порционная ложка',
    latvian: 'servēšanas karote',
    polish: 'chochla (łyżka do nalewania zupy itp.)',
    french: 'cuiller de service, cuillère à servir',
    spanish: 'cuchara de servir',
  },
  {
    av: 22572,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spoon + to mix)',
    english: 'mixing spoon',
    swedish: 'slev',
    norwegian: 'sleiv, slev',
    finnish: 'lusikka (sekoittamiseen)',
    hungarian: 'keverőkanál',
    german: 'Kochlöffel',
    dutch: 'klopper, houten lepel, roerlepel',
    afrikaans: 'houtlepel, roerlepel',
    russian: 'ложка для смешивания',
    latvian: 'maisāmā karote',
    polish: 'trzepaczka, mieszadło, łyżka',
    french: 'cuiller à mélanger',
    spanish: 'cuchara mezcladora',
  },
  {
    av: 22573,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spoon + container: spoon with deep bowl for serving liquids)',
    english: 'ladle',
    swedish: 'soppslev',
    norwegian: 'suppeslev',
    finnish: 'kauha',
    hungarian: 'levesmerő kanál',
    german: 'Suppenkelle, Gieβlöffel',
    dutch: 'soeplepel, pollepel (Vl)',
    afrikaans: 'soplepel',
    russian: 'половник',
    latvian: 'pavārnīca',
    polish: 'chochla',
    french: 'louche',
    spanish: 'cucharón',
  },
  {
    av: 22575,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tray + oven)',
    english: 'oven tray',
    swedish: 'bakplåt',
    norwegian: 'stekebrett, langpanne',
    finnish: 'uunipelti',
    hungarian: 'sütőtepsi, sütőtálca',
    german: 'Backblech',
    dutch: 'ovenplaat, bakplaat',
    afrikaans: 'oondplaat, oondbak',
    russian: 'противень',
    latvian: 'cepešpanna',
    polish: 'blacha do piekarnika',
    french: 'platine (four), platine (four)',
    spanish: 'bandeja de horno',
  },
  {
    av: 22576,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + oven)',
    english: 'baking tin, baking pan, ovenware',
    swedish: 'bakform, eldfast form',
    norwegian: 'kakeform, ildfast form',
    finnish: 'uunivuoka',
    hungarian: 'sütőedény, tűzálló edény',
    german: 'Kuchenform',
    dutch: 'bakvorm, taartvorm, bakblik, ovenschotel, ovenschaal',
    afrikaans: 'koekpan, tertpan, koekieplaat, oondbak, broodpan',
    russian: 'форма для выпечки',
    latvian: 'cepampanna',
    polish: 'forma do pieczenia, naczynie żaroodporne',
    french: 'plat à four',
    spanish: 'bandeja de horno, bandeja de hornear',
  },
  {
    av: 22580,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pan + electricity)',
    english: 'electric pan',
    swedish: 'kastrull (elektrisk)',
    norwegian: 'kjele, gryte (elektrisk)',
    finnish: 'sähkökattila',
    hungarian: 'elektromos serpenyő',
    german: '(elektrische) Pfanne, Elektropfanne',
    dutch: 'elektrische pan',
    afrikaans: 'elektriese pan',
    russian: 'электрокастрюля',
    latvian: 'elektriskā tējkanna',
    polish: 'Garnek elektryczny, patelnia elektryczna',
    french: 'casserole électrique',
    spanish: 'sartén eléctrica',
  },
  {
    av: 22581,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pan + oil)',
    english: 'frying pan',
    swedish: 'stekpanna',
    norwegian: 'stekepanne',
    finnish: 'paistinpannu',
    hungarian: 'olajsütő',
    german: 'Pfanne, Bratpfanne',
    dutch: 'braadpan',
    afrikaans: 'braai pan',
    russian: 'сковорода',
    latvian: 'panna cepšanai',
    polish: 'patelnia',
    french: 'poêle à frire',
    spanish: 'sartén',
  },
  {
    av: 22582,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wok, wok pan + oil)',
    english: 'woking',
    swedish: 'wokning',
    norwegian: 'woking',
    finnish: 'wokki',
    hungarian: 'wok',
    german: 'Wok',
    dutch: 'wok',
    afrikaans: 'wok',
    russian: 'сковорода вок',
    latvian: 'vokpanna',
    polish: 'wok (głęboka patelnia)',
    french: 'wok',
    spanish: 'wok',
  },
  {
    av: 22585,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pot + oil + electricity)',
    english: 'deep fryer',
    swedish: 'fritös (elektrisk)',
    norwegian: 'friteringsgryte (elektrisk)',
    finnish: 'friteerauskattila',
    hungarian: 'elektromos olajsütő',
    german: 'Friteuse',
    dutch: 'friteuse, frietpot (Vl)',
    afrikaans: 'diepbraaipot',
    russian: 'электрофритюрница',
    latvian: 'fritēšanas katls',
    polish: 'frytkownica',
    french: 'friteuse',
    spanish: 'freidora',
  },
  {
    av: 22586,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pot + steam)',
    english: 'steamer',
    swedish: 'tryckkokare',
    norwegian: 'trykkoker',
    finnish: 'höyrykeitin',
    hungarian: 'kuktafazék',
    german: 'Dampfkochtopf, Dampfgarer',
    dutch: 'stoompan',
    afrikaans: 'stoompot',
    russian: 'пароварка',
    latvian: 'tvaika katls',
    polish: 'szybkowar',
    french: 'casserole à vapeur, casserole à pression, marmite à vapeur',
    spanish: 'vaporera',
  },
  {
    av: 22587,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pitcher, jug, kettle, pot + electricity)',
    english: 'electric kettle',
    swedish: 'vattenkokare',
    norwegian: 'vannkoker',
    finnish: 'vedenkeitin',
    hungarian: 'elektromos vízforraló',
    german: 'Wasserkocher',
    dutch: 'elektrische ketel, waterkoker',
    afrikaans: 'elektriese ketel',
    russian: 'электрический чайник',
    latvian: 'elektriskā tējkanna',
    polish: 'czajnik elektryczny',
    french: 'bouilloire électrique',
    spanish: 'pava eléctrica',
  },
  {
    av: 22588,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(can + future)',
    english: 'storage jar, preserving jar',
    swedish: 'konservburk',
    norwegian: 'hermetikkboks',
    finnish: 'säilytyspurkki, säilöntäpurkki',
    hungarian: 'tároló doboz, tartály',
    german: 'Konservenglas',
    dutch: 'voorraadbus',
    afrikaans: 'inlê bottel, inlê houer',
    russian: 'консервная банка',
    latvian: 'uzglabāšanas trauks',
    polish: 'słój na przetwory, wek',
    french: 'bocal de conservation',
    spanish: 'bote de conservas',
  },
  {
    av: 22589,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(can + glass)',
    english: 'glass jar',
    swedish: 'glasburk',
    norwegian: 'glasskrukke',
    finnish: 'lasipurkki',
    hungarian: 'konzerves üveg',
    german: 'Einmachglas',
    dutch: 'voorraadpot, bokaal',
    afrikaans: 'glas bottel',
    russian: 'стеклянная банка',
    latvian: 'stikla trauks',
    polish: 'szklany słoik',
    french: 'bocal en verre',
    spanish: 'jarrón de cristal',
  },
  {
    av: 22590,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(can + metal [contr.])',
    english: 'tin, can',
    swedish: 'plåtburk',
    norwegian: 'blikkboks',
    finnish: 'säilykepurkki',
    hungarian: 'konzervdoboz',
    german: 'Dose, Büchse',
    dutch: 'voorraadblik',
    afrikaans: 'vorraadblik',
    russian: 'жестяная банка',
    latvian: 'metāla uzglabāšanas trauks',
    polish: 'puszka, kanister',
    french: 'boîte en fer, boîte de conserve',
    spanish: 'lata',
  },
  {
    av: 22591,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(can + cookie/biscuit)',
    english: 'cookie jar, biscuit tin',
    swedish: 'kakburk',
    norwegian: 'kakeboks',
    finnish: 'pikkuleipärasia',
    hungarian: 'kekszes doboz, kétszersültes doboz, sütis doboz',
    german: 'Keksdose',
    dutch: 'koekjestrommel',
    afrikaans: 'koekieblik, koekiehouer',
    russian: 'банка для печенья',
    latvian: 'cepumu kārba',
    polish: 'słoik z ciasteczkami, pudełko z ciastkami',
    french: 'boîte à biscuits',
    spanish: 'bote de galletas',
  },
  {
    av: 22593,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tray + hot)',
    english: 'hot tray, chafing dish',
    swedish: 'värmeplatta',
    norwegian: 'varmeplate',
    finnish: 'lämpöalusta',
    hungarian: 'melegítő tálca, forró tálca',
    german: 'Speisewärmer, Warmhalteplatte',
    dutch: 'rechaud, warmhoudplaat',
    afrikaans: 'warm plaat',
    russian: 'подставка под горячее',
    latvian: 'karstumizturīgs paliktnis',
    polish: 'forma żaroodporna',
    french: 'chauffe-plats, réchaud',
    spanish: 'bandeja caliente',
  },
  {
    av: 22594,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + table)',
    english: 'table mat, placemat',
    swedish: 'bordstablett',
    norwegian: 'bordbrikke',
    finnish: 'pöytäliina',
    hungarian: 'tányéralátét',
    german: 'Untersetzer',
    dutch: 'placemat',
    afrikaans: 'tafel plekmat',
    russian: 'сет, постановочная салфетка',
    latvian: 'galda paliktnis, galda sedziņa',
    polish: 'mata na stolik, podkładka',
    french: 'tapis de protection de la table',
    spanish: 'mantel',
  },
  {
    av: 22595,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + table + hot)',
    english: 'pot stand, trivet',
    swedish: 'karottunderlägg',
    norwegian: 'kjeleunderlag gryteunderlag bordskåner',
    finnish: 'pannunalusta',
    hungarian: 'edényalátét, lábosalátét',
    german: 'Topfuntersatz',
    dutch: 'onderzetter, onderlegger',
    afrikaans: 'pot staander',
    russian: 'термосалфетка',
    latvian: 'katla paliktnis, trijkājis',
    polish: 'podstawka, podkładka pod gorące naczynie',
    french: 'sous-plat, dessous de plat',
    spanish: 'salvamanteles',
  },
  {
    av: 22596,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + hand + hot)',
    english: 'potholder, oven mitt',
    swedish: 'grytlapp, grillvante',
    norwegian: 'gryteklut, grillvott',
    finnish: 'pannulappu, patakinnas',
    hungarian: 'edényfogó',
    german: 'Topflappen, Küchenhandschuh',
    dutch: 'ovenwant, pannenlap',
    afrikaans: 'oondhandskoen',
    russian: 'прихватка',
    latvian: 'karstumizturīgs cimds',
    polish: 'rękawica kuchenna',
    french: 'gant isolant, manique',
    spanish: 'agarradera',
  },
  {
    av: 22597,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + hand + water)',
    english: 'dish gloves, rubber gloves',
    swedish: 'gummihandskar',
    norwegian: 'gummihansker',
    finnish: 'kumikäsineet',
    hungarian: 'mosogató kesztyű',
    german: 'Gummihandschuh',
    dutch: 'huishoudhandschoenen',
    afrikaans: 'plastiekhandskoene skottelgoed',
    russian: 'резиновые перчатки',
    latvian: 'gumijas cimdi trauku mazgāšanai',
    polish: 'gumowe rękawice, rękawice do zmywania',
    french: 'gant en caoutchouc',
    spanish: 'guantes de plástico',
  },
  {
    av: 22601,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + earth)',
    english: 'continent',
    swedish: 'kontinent',
    norwegian: 'kontinent',
    finnish: 'manner',
    hungarian: 'földrész, kontinens',
    german: 'Kontinent',
    dutch: 'continent',
    afrikaans: 'kontinent, vasteland',
    russian: 'континет',
    latvian: 'kontinents',
    polish: 'kontynent',
    french: 'continent',
    spanish: 'continente',
  },
  {
    av: 22602,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(part of + equator: shuld be understood as a combination of continent and equator)',
    english: 'Africa',
    swedish: 'Afrika',
    norwegian: 'Afrika',
    finnish: 'Afrikka',
    hungarian: 'Afrika',
    german: 'Afrika',
    dutch: 'Afrika',
    afrikaans: 'Afrika',
    russian: 'Африка',
    latvian: 'Āfrika',
    polish: 'Afryka',
    french: 'Afrique',
    spanish: 'África',
  },
  {
    av: 22603,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(part of + South Pole: shuld be understood as a combination of continent and South Pole)',
    english: 'Antarctic',
    swedish: 'Antarktis',
    norwegian: 'Antarktis',
    finnish: 'etelämanner',
    hungarian: 'Antarktisz',
    german: 'Antarktis',
    dutch: 'Antarctica',
    afrikaans: 'Antartika',
    russian: 'Антарктида',
    latvian: 'Antarktika',
    polish: 'Antarktyka',
    french: 'Antarctique',
    spanish: 'Región Antártica, Antártico',
  },
  {
    av: 22604,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(continent + east)',
    english: 'Asia',
    swedish: 'Asien',
    norwegian: 'Asia',
    finnish: 'aasia',
    hungarian: 'Ázsia',
    german: 'Asien',
    dutch: 'Azië',
    afrikaans: 'Asië',
    russian: 'Азия',
    latvian: 'Āzija',
    polish: 'Azja',
    french: 'Asie',
    spanish: 'Asia',
  },
  {
    av: 22605,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(continent + south + east)',
    english: 'Australia',
    swedish: 'Australien',
    norwegian: 'Australia',
    finnish: 'Australia',
    hungarian: 'Ausztrália',
    german: 'Australien',
    dutch: 'Australië',
    afrikaans: 'Australië',
    russian: 'Австралия',
    latvian: 'Austrālija',
    polish: 'Australia',
    french: 'Australie',
    spanish: 'Australia',
  },
  {
    av: 22606,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(continent + north)',
    english: 'Europe',
    swedish: 'Europa',
    norwegian: 'Europa',
    finnish: 'eurooppa',
    hungarian: 'Európa',
    german: 'Europa',
    dutch: 'Europa',
    afrikaans: 'Europa',
    russian: 'Европа',
    latvian: 'Eiropa',
    polish: 'Europa',
    french: 'Europe',
    spanish: 'Europa',
  },
  {
    av: 22607,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(continent + north + west)',
    english: 'North America',
    swedish: 'Nordamerika',
    norwegian: 'Nord-Amerika',
    finnish: 'Pohjois-Amerikka',
    hungarian: 'Észak-Amerika',
    german: 'Nordamerika',
    dutch: 'Noord-Amerika',
    afrikaans: 'Noord-Amerika',
    russian: 'Северная Америка',
    latvian: 'Ziemeļamerika',
    polish: 'Ameryka Północna',
    french: 'Amérique du Nord',
    spanish: 'América del Norte',
  },
  {
    av: 22608,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(continent + south + west)',
    english: 'South America',
    swedish: 'Sydamerika',
    norwegian: 'Sør-Amerika',
    finnish: 'Etelä-Amerikka',
    hungarian: 'Dél-Amerika',
    german: 'Südamerika',
    dutch: 'Zuid-Amerika',
    afrikaans: 'Suid-Amerika',
    russian: 'Южная Америка',
    latvian: 'Dienvidamerika',
    polish: 'Ameryka Południowa',
    french: 'Amérique du Sud',
    spanish: 'América del Sur',
  },
  {
    av: 22609,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(country + strong + intensity: acc. to Caesar, Belgians were the bravest of all people in the Roman empire)',
    english: 'Belgium',
    swedish: 'Belgien',
    norwegian: 'Belgia',
    finnish: 'Belgia',
    hungarian: 'Belgium',
    german: 'Belgien',
    dutch: 'België',
    afrikaans: 'België',
    russian: 'Бельгия',
    latvian: 'Beļģija',
    polish: 'Belgia',
    french: 'Belgique',
    spanish: 'Bélgica',
  },
  {
    av: 22610,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + rose)',
    english: 'England',
    swedish: 'England',
    norwegian: 'England',
    finnish: 'Englanti, Iso-Britannia',
    hungarian: 'Anglia',
    german: 'Großbritannien, England',
    dutch: 'Engeland',
    afrikaans: 'Engeland',
    russian: 'Англия',
    latvian: 'Anglija',
    polish: 'Anglia',
    french: 'Angleterre',
    spanish: 'Inglaterra',
  },
  {
    av: 22611,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flower + love)',
    english: 'rose',
    swedish: 'ros',
    norwegian: 'rose',
    finnish: 'ruusu',
    hungarian: 'rózsa',
    german: 'Rose',
    dutch: 'roos',
    afrikaans: 'roos',
    russian: 'роза',
    latvian: 'roze',
    polish: 'róża',
    french: 'rose',
    spanish: 'rosa',
  },
  {
    av: 22612,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + fjord)',
    english: 'Norway',
    swedish: 'Norge',
    norwegian: 'Norge',
    finnish: 'Norja',
    hungarian: 'Norvégia',
    german: 'Norwegen',
    dutch: 'Noorwegen',
    afrikaans: 'Noorweë',
    russian: 'Норвегия',
    latvian: 'Norvēģija',
    polish: 'Norwegia',
    french: 'Norvège',
    spanish: 'Noruega',
  },
  {
    av: 22614,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + cloth: cloth representing tartan)',
    english: 'Scotland',
    swedish: 'Skottland',
    norwegian: 'Skottland',
    finnish: 'Skotlanti',
    hungarian: 'Skócia',
    german: 'Schottland',
    dutch: 'Schotland',
    afrikaans: 'Skotland',
    russian: 'Шотландия',
    latvian: 'Skotija',
    polish: 'Szkocja',
    french: 'Ecosse',
    spanish: 'Escocia',
  },
  {
    av: 22615,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + springbok)',
    english: 'South Africa',
    swedish: 'Sydafrika',
    norwegian: 'Sør-Afrika',
    finnish: 'Etelä-Afrikka',
    hungarian: 'Dél-Afrika',
    german: 'Südafrika',
    dutch: 'Zuid-Afrika',
    afrikaans: 'Suid-Afrika',
    russian: 'Южная Африка',
    latvian: 'Dienvidāfrika',
    polish: 'Republika Południowej Afryki',
    french: 'Afrique du Sud',
    spanish: 'África del Sur',
  },
  {
    av: 22616,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal (bovine) + to jump)',
    english: 'springbok',
    swedish: 'springbock',
    norwegian: 'springbukk',
    finnish: 'antilooppi',
    hungarian: 'gazella, dél-afrikai gazella',
    german: 'Springbock',
    dutch: 'springbok',
    afrikaans: 'springbok',
    russian: 'спрингбок, газель',
    latvian: 'Dienvidāfrikas gazele',
    polish: 'springbok, antylopa południowoafrykańska',
    french: 'springbok',
    spanish: 'gacela',
  },
  {
    av: 22617,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(country + three + crown: three crowns have been the symbol for Sweden since The Middle-Ages)',
    english: 'Sweden',
    swedish: 'Sverige',
    norwegian: 'Sverige',
    finnish: 'Ruotsi',
    hungarian: 'Svédország',
    german: 'Schweden',
    dutch: 'Zweden',
    afrikaans: 'Swede',
    russian: 'Швеция',
    latvian: 'Zviedrija',
    polish: 'Szwecja',
    french: 'Suède',
    spanish: 'Suecia',
  },
  {
    av: 22619,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(five + country + north)',
    english: 'The Nordic countries',
    swedish: 'Norden',
    norwegian: 'Norden',
    finnish: 'pohjoismaat',
    hungarian: 'skandináv országok',
    german: 'die nordischen Länder',
    dutch: 'Scandinavische landen',
    afrikaans: 'Skandinawiese lande',
    russian: 'Скандинавия',
    latvian: 'Ziemeļvalstis',
    polish: 'kraje nordyckie',
    french: 'pays scandinaves, pays nordiques',
    spanish: 'Países nórdicos',
  },
  {
    av: 22620,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(earth + to shake + intensity)',
    english: 'earthquake',
    swedish: 'jordbävning',
    norwegian: 'jordskjelv',
    finnish: 'maanjäristys',
    hungarian: 'földrengés',
    german: 'Erdbeben',
    dutch: 'aardbeving',
    afrikaans: 'aardbewing',
    russian: 'землетрясение',
    latvian: 'zemestrīce',
    polish: 'trzęsienie ziemi',
    french: 'tremblement de terre',
    spanish: 'terremoto',
  },
  {
    av: 22621,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(continent + back and forth)',
    english: 'continental drift',
    swedish: 'kontinentaldrift',
    norwegian: 'kontinentaldrift',
    finnish: 'mannerten liikkuminen',
    hungarian: 'kontinensek vándorlása, földrészek elmozdulása',
    german: 'Kontinentaldrift',
    dutch: 'continentverschuiving',
    afrikaans: 'kontinentale drywing',
    russian: 'континентальный дрейф',
    latvian: 'kontinentu lēna virzīšanās ',
    polish: 'ruchy, przesuwanie się kontynentów, dryft kontynentalny',
    french: 'dérive de continent, dérive continentale, déplacement continental',
    spanish: 'deriva continental',
  },
  {
    av: 22622,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water + to fall)',
    english: 'waterfall',
    swedish: 'vattenfall',
    norwegian: 'vannfall, foss',
    finnish: 'vesiputous',
    hungarian: 'vízesés',
    german: 'Wasserfall ',
    dutch: 'waterval',
    afrikaans: 'waterval',
    russian: 'водопад',
    latvian: 'ūdenskritums',
    polish: 'wodospad',
    french: "chute d'eau, cascade",
    spanish: 'cascada',
  },
  {
    av: 22623,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(river + intensity + stone: part of a river moving fast over rocks in the river bed)',
    english: 'rapid(s)',
    swedish: 'fors',
    norwegian: 'elvestryk',
    finnish: 'koski',
    hungarian: 'zuhatag, zúgó',
    german: 'Stromschnellen',
    dutch: 'stroomversnelling',
    afrikaans: 'stroomversnelling(s)',
    russian: 'речной порог',
    latvian: 'krāces',
    polish: 'próg rzeczny, kaskada, katarakta',
    french: "rapides (cours d'eau)",
    spanish: 'rápidos',
  },
  {
    av: 22624,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wave + enormous)',
    english: 'tidal wave',
    swedish: 'flodvåg',
    norwegian: 'flodbølge',
    finnish: 'tulva-aalto, vuorovesiaalto',
    hungarian: 'szökőár',
    german: 'Flutwelle, Springflut',
    dutch: 'vloedgolf',
    afrikaans: 'vloedgolf',
    russian: 'приливная волна',
    latvian: 'paisuma vilnis',
    polish: 'fala pływowa',
    french: 'raz-de-marée',
    spanish: 'maremoto',
  },
  {
    av: 22626,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sea + back and forth: daily variations in surface levels of oceans)',
    english: 'tide',
    swedish: 'tidvatten',
    norwegian: 'tidevann',
    finnish: 'vuorovesi',
    hungarian: 'árapály',
    german: 'Flut, Tide',
    dutch: 'getij',
    afrikaans: 'gety',
    russian: 'морской прилив и отлив',
    latvian: 'paisums',
    polish: 'pływy (morskie, oceaniczne)',
    french: 'marée',
    spanish: 'marea',
  },
  {
    av: 22627,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tide + low)',
    english: 'low tide, ebb',
    swedish: 'ebb',
    norwegian: 'fjære, ebbe',
    finnish: 'laskuvesi',
    hungarian: 'apály',
    german: 'Ebbe',
    dutch: 'eb',
    afrikaans: 'laag gety, eb gety',
    russian: 'отлив',
    latvian: 'neliels paisums',
    polish: 'odpływ (pływy morskie)',
    french: 'marée basse',
    spanish: 'marea baja',
  },
  {
    av: 22628,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tide + high)',
    english: 'high tide',
    swedish: 'flod',
    norwegian: 'flo',
    finnish: 'nousuvesi',
    hungarian: 'dagály',
    german: 'Hochflut',
    dutch: 'vloed',
    afrikaans: 'hoog gety',
    russian: 'прилив',
    latvian: 'liels paisums',
    polish: 'wysoki przypływ',
    french: 'marée haute',
    spanish: 'marea alta',
  },
  {
    av: 22629,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sea + low)',
    english: 'low water',
    swedish: 'lågvatten',
    norwegian: 'vann lavt, vannstand lav, lavvann',
    finnish: 'vesi matalalla',
    hungarian: 'sekély víz',
    german: 'Niedrigwasser',
    dutch: 'laag water',
    afrikaans: 'laag water',
    russian: 'низкая вода, отлив',
    latvian: 'zems ūdens līmenis',
    polish: 'niski poziom wody',
    french: 'bord de mer',
    spanish: 'bajamar',
  },
  {
    av: 22630,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sea + high)',
    english: 'high water',
    swedish: 'högvatten',
    norwegian: 'vann høyt, vannstand høy, høyvann',
    finnish: 'vesi korkealla',
    hungarian: 'ár, áradás, dagály',
    german: 'Hochwasser',
    dutch: 'hoog water',
    afrikaans: 'hoog water',
    russian: 'полная вода, паводок',
    latvian: 'augsts ūdens līmenis',
    polish: 'wysoka fala',
    french: 'mer (haute)',
    spanish: 'nivel alto de agua',
  },
  {
    av: 22631,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water (ground level) + up)',
    english: 'spring (water)',
    swedish: 'vattenkälla, springkälla',
    norwegian: 'springvann',
    finnish: 'lähde',
    hungarian: 'forrásvíz',
    german: 'Brunnen, Brunnenschacht',
    dutch: 'bron',
    afrikaans: 'fontein water',
    russian: 'водный источник',
    latvian: 'pavasara plūdi',
    polish: 'woda źródlana',
    french: 'source (eau)',
    spanish: 'agua mineral',
  },
  {
    av: 22632,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spring water + hot)',
    english: 'hot spring',
    swedish: 'varmvattenkälla',
    norwegian: 'varm kilde',
    finnish: 'kuumavesilähde',
    hungarian: 'hőforrás',
    german: 'Heißquelle, Thermalquelle, (heiße) Quelle',
    dutch: 'warmwaterbron',
    afrikaans: 'warmwaterbron',
    russian: 'горячий источник',
    latvian: 'karstie avoti',
    polish: 'gejzer, gorące źródło',
    french: 'source chaude',
    spanish: 'manantial termal',
  },
  {
    av: 22633,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + star)',
    english: 'constellation of stars',
    swedish: 'stjärnbild',
    norwegian: 'stjernebilde',
    finnish: 'tähtikuvio',
    hungarian: 'csillagkép',
    german: 'Sternbild, Konstellation',
    dutch: 'sterrenbeeld',
    afrikaans: 'konstellasie van sterre, sterrebeeld',
    russian: 'созвездие',
    latvian: 'zvaigznājs',
    polish: 'Konstelacja gwiazd',
    french: 'constellation (étoiles)',
    spanish: 'constelación de estrellas',
  },
  {
    av: 22634,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(distance [contr.] + light + year)',
    english: 'light year',
    swedish: 'ljusår',
    norwegian: 'lysår',
    finnish: 'valovuosi',
    hungarian: 'fényév',
    german: 'Lichtjahr',
    dutch: 'lichtjaar',
    afrikaans: 'ligjaar',
    russian: 'световой год',
    latvian: 'gaismas gads',
    polish: 'rok świetlny',
    french: 'année-lumière',
    spanish: 'año luz',
  },
  {
    av: 22635,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + to see + star)',
    english: 'telescope',
    swedish: 'teleskop',
    norwegian: 'teleskop',
    finnish: 'teleskooppi',
    hungarian: 'teleszkóp',
    german: 'Teleskop, Fernrohr',
    dutch: 'telescoop',
    afrikaans: 'teleskoop',
    russian: 'телескоп',
    latvian: 'teleskops',
    polish: 'teleskop',
    french: 'téléscope (lunette)',
    spanish: 'telescopio',
  },
  {
    av: 22636,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(knowledge + star + person: knowledge of stars as they relate to human beings)',
    english: 'astrology',
    swedish: 'astrologi',
    norwegian: 'astrologi',
    finnish: 'astrologia',
    hungarian: 'csillagjóslás, asztrológia',
    german: 'Astrologie',
    dutch: 'astrologie',
    afrikaans: 'astrologie, sterrekunde',
    russian: 'астрология',
    latvian: 'astroloģija',
    polish: 'astrologia',
    french: 'astrologie',
    spanish: 'astrología',
  },
  {
    av: 22637,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(prediction + weather)',
    english: 'weather forecast',
    swedish: 'väderprognos',
    norwegian: 'værprognose',
    finnish: 'sääennuste',
    hungarian: 'időjárás előrejelzés',
    german: 'Wettervorhersage',
    dutch: 'weerbericht',
    afrikaans: 'weervoorspelling',
    russian: 'метеопрогноз',
    latvian: 'laika prognoze',
    polish: 'prognoza pogody',
    french: 'prévisions météorologiques',
    spanish: 'previsión del tiempo',
  },
  {
    av: 22638,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(constellation of stars + ram)',
    english: 'Aries (in zodiac)',
    swedish: 'Väduren',
    norwegian: 'Væren',
    finnish: 'oinas',
    hungarian: 'Kos (csillagkép)',
    german: 'Widder (Sternzeichen)',
    dutch: 'Ram',
    afrikaans: 'Ram (in zodiak)',
    russian: 'Овен (знак зодиака)',
    latvian: 'Auna zvaigznājs, zodiaka zīme',
    polish: 'Baran (znak zodiaku)',
    french: 'Bélier (zodiaque)',
    spanish: 'Aries (zodíaco)',
  },
  {
    av: 22639,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(constellation of stars + bull)',
    english: 'Taurus (in zodiac)',
    swedish: 'Oxen',
    norwegian: 'Tyren',
    finnish: 'härkä',
    hungarian: 'Bika (csillagkép)',
    german: 'Stier (Sternzeichen)',
    dutch: 'Stier',
    afrikaans: 'Bul (in zodiak)',
    russian: 'Телец (знак зодиака)',
    latvian: 'Vērša zvaigznājs, zodiaka zīme',
    polish: 'Byk (zodiak)',
    french: 'constellation du Taureau, Taureau (zodiaque)',
    spanish: 'Tauro (zodíaco)',
  },
  {
    av: 22640,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(constellation of stars + crab, shellfish (with claws))',
    english: 'Cancer (in zodiac)',
    swedish: 'Kräftan',
    norwegian: 'Krepsen',
    finnish: 'krapu',
    hungarian: 'Rák (csillagkép)',
    german: 'Krebs (Sternzeichen)',
    dutch: 'Kreeft',
    afrikaans: 'Kreef (in zodiak)',
    russian: 'Рак (знак зодиака)',
    latvian: 'Vēža zvaigznājs, zodiaka zīme',
    polish: 'Rak (w zodiaku)',
    french: 'Cancer (zodiaque)',
    spanish: 'Cáncer (zodíaco)',
  },
  {
    av: 22641,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(constellation of stars + lion)',
    english: 'Leo (in zodiac)',
    swedish: 'Lejonet',
    norwegian: 'Løven',
    finnish: 'leijona',
    hungarian: 'Oroszlán (csillagkép)',
    german: 'Löwe (Sternzeichen)',
    dutch: 'leeuw',
    afrikaans: 'Leeu (in zodiak)',
    russian: 'Лев (знак зодиака)',
    latvian: 'Lauvas zvaigznājs, zodiaka zīme',
    polish: 'Lew (Zodiak)',
    french: 'Lion (zodiaque)',
    spanish: 'Leo (zodíaco)',
  },
  {
    av: 22642,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(constellation of stars + woman, female)',
    english: 'Virgo (in zodiac)',
    swedish: 'Jungfrun',
    norwegian: 'Jomfruen',
    finnish: 'neitsyt',
    hungarian: 'Szűz (csillagkép)',
    german: 'Jungfrau (Sternzeichen)',
    dutch: 'Maagd (sterrebeeld)',
    afrikaans: 'Maagd (in zodiak)',
    russian: 'Дева (знак зодиака)',
    latvian: 'Jaunavas zvaigznājs, zodiaka zīme',
    polish: 'Panna (zodiak)',
    french: 'Vierge (zodiaque)',
    spanish: 'Virgo (zodíaco)',
  },
  {
    av: 22643,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(constellation of stars + weight (a))',
    english: 'Libra (in zodiac)',
    swedish: 'Vågen',
    norwegian: 'Vekten',
    finnish: 'vaaka',
    hungarian: 'Mérleg (csillagkép)',
    german: 'Waage (Sternzeichen)',
    dutch: 'Weegschaal',
    afrikaans: 'Weegskaal (in zodiak)',
    russian: 'Весы (знак зодиака)',
    latvian: 'Svari, zvaigznājs, zodiaka zīme',
    polish: 'Waga (zodiak)',
    french: 'Balance (zodiaque)',
    spanish: 'Libra (zodíaco)',
  },
  {
    av: 22644,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(constellation of stars + scorpion)',
    english: 'Scorpio (in zodiac)',
    swedish: 'Skorpionen',
    norwegian: 'Skorpionen',
    finnish: 'skorpioni',
    hungarian: 'Skorpió (csillagkép)',
    german: 'Skorpion (Sternzeichen)',
    dutch: 'Schorpioen',
    afrikaans: 'Skerpioen (in zodiak)',
    russian: 'Скорпион (знак зодиака)',
    latvian: 'Skorpiona zvaigznājs, zodiaka zīme',
    polish: 'Skorpion (znak zodiaku)',
    french: 'Scorpion (zodiaque)',
    spanish: 'Escorpio (zodíaco)',
  },
  {
    av: 22645,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(constellation of stars + man + bow and arrow)',
    english: 'Sagittarius (in zodiac)',
    swedish: 'Skytten',
    norwegian: 'Skytten',
    finnish: 'jousimies',
    hungarian: 'Nyilas (csillagkép)',
    german: 'Schütze (Sternzeichen)',
    dutch: 'Boogschutter',
    afrikaans: 'Boogskutter (in zodiak)',
    russian: 'Стрелец (знак зодиака)',
    latvian: 'Strēlnieka zvaigznājs, zodiaka zīme',
    polish: 'Strzelec (znak zodiaku)',
    french: 'Sagittaire (zodiaque)',
    spanish: 'Sagitario (zodíaco)',
  },
  {
    av: 22646,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(constellation of stars + animal (bovine), bovine, ovine + stone, rock)',
    english: 'Capricorn (in zodiac)',
    swedish: 'Stenbocken',
    norwegian: 'Steinbukken',
    finnish: 'kauris',
    hungarian: 'Bak (csillagkép)',
    german: 'Steinbock (Sternzeichen)',
    dutch: 'Steenbok',
    afrikaans: 'Steenbok (in zodiak)',
    russian: 'Козерог (знак зодиака)',
    latvian: 'Mežāzis, zvaigznājs, zodiaka zīme',
    polish: 'Koziorożec (znak zodiaku)',
    french: 'Capricorne (zodiaque)',
    spanish: 'Capricornio (zodíaco)',
  },
  {
    av: 22647,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(constellation of stars + man + water)',
    english: 'Aquarius (in zodiac)',
    swedish: 'Vattumannen',
    norwegian: 'Vannmannen',
    finnish: 'vesimies',
    hungarian: 'Vízöntő',
    german: 'Wassermann (Sternzeichen)',
    dutch: 'Waterman',
    afrikaans: 'Waterdraer (in zodiak)',
    russian: 'Водолей (знак зодиака)',
    latvian: 'Ūdensvīrs, zvaigznājs, zodiaka zīme',
    polish: 'Wodnik (znak zodiaku)',
    french: 'Verseau (zodiaque)',
    spanish: 'Acuario (zodíaco)',
  },
  {
    av: 22648,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(constellation of stars + fish (animal))',
    english: 'Pisces (in zodiac)',
    swedish: 'Fiskarna',
    norwegian: 'Fiskene',
    finnish: 'kalat',
    hungarian: 'Halak',
    german: 'Fische (Sternzeichen)',
    dutch: 'Vissen',
    afrikaans: 'Vis (in zodiak)',
    russian: 'Рыбы (знак зодиака)',
    latvian: 'Zivis, zvaigznājs, zodiaka zīme',
    polish: 'Ryby (znak zodiaku)',
    french: 'Poissons (zodiaque)',
    spanish: 'Piscis (zodíaco)',
  },
  {
    av: 22649,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(God + north)',
    english: 'Nordic God, Nordic Goddess',
    swedish: 'nordisk Gud',
    norwegian: 'nordisk gud',
    finnish: 'pohjolan jumala',
    hungarian: 'Észak Istene',
    german: '(nordischer) Gott',
    dutch: 'Noordse goden',
    afrikaans: 'Nordiese God',
    russian: 'скандинавский Бог',
    latvian: 'Ziemeļu Dievs',
    polish: 'Bóg (nordycki)',
    french: 'dieu nordique',
    spanish: 'Dios nórdico',
  },
  {
    av: 22650,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(Nordic God + eye: Woden gave away one eye in exchange for wisdom)',
    english: 'Woden',
    swedish: 'Oden',
    norwegian: 'Odin',
    finnish: 'Odin',
    hungarian: 'Woden (északi istenség)',
    german: 'Odin, Wodan, Wotan (nordischer Gott)',
    dutch: 'Wodan (Noorse God)',
    afrikaans: 'Woden (Nordise God)',
    russian: 'Один (глава скандинавских богов)',
    latvian: 'Ziemeļu Dievs, Odens',
    polish: 'Odyn (bóg nordycki)',
    french: 'Odin (mythologie nordique)',
    spanish: 'Woden ',
  },
  {
    av: 22651,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(wife + Woden)',
    english: 'Frigg',
    swedish: 'Frigg',
    norwegian: 'Frigg',
    finnish: 'Frigg, Frigga',
    hungarian: 'Frigg (északi istenség)',
    german: 'Frigg (nordische Göttin)',
    dutch: 'Frigg (Noorse God)',
    afrikaans: 'Frigg (Nordise God)',
    russian: 'Фригг (жена Одина)',
    latvian: 'Ziemeļu Dieva sieva, Friga',
    polish: 'Frigg – nordycka bogini, bogini małżeństwa, rodziny i deszczu, żona Odyna',
    french: 'Frigg (mythologie nordique)',
    spanish: 'Frigg',
  },
  {
    av: 22652,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(Nordic God + hammer: the God of thunder; his hammer made the lightning)',
    english: 'Thor',
    swedish: 'Tor',
    norwegian: 'Tor',
    finnish: 'Thor, Tor',
    hungarian: 'Thor (északi istenség)',
    german: 'Thor (nordischer Gott)',
    dutch: 'Thor (Noorse God)',
    afrikaans: 'Thor (Nordiese God)',
    russian: 'Тор (старший сын Одина)',
    latvian: 'Ziemeļu Dievs, Tors',
    polish: 'Thor (bóg nordycki)',
    french: 'Thor (mythologie nordique)',
    spanish: 'Thor ',
  },
  {
    av: 22653,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(wife + Thor)',
    english: 'Sif',
    swedish: 'Siv',
    norwegian: 'Siv',
    finnish: 'Siv, Sif',
    hungarian: 'Sif (északi istenség)',
    german: 'Siv (nordische Göttin)',
    dutch: 'Sif (Noorse God)',
    afrikaans: 'Sif (Nordise God)',
    russian: 'Сиф (жена Тора)',
    latvian: 'Ziemeļu Dieva sieva, Sifa',
    polish: 'Sif (nordycka bogini, żona Thora)',
    french: 'Sif (mythologie nordique)',
    spanish: 'Sif',
  },
  {
    av: 22654,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: "(hammer + Nordic God: Thor's hammer)",
    english: 'Mjolnir',
    swedish: 'Mjölner',
    norwegian: 'Mjølner',
    finnish: 'mjollnir, mjolnir, mjölner',
    hungarian: 'Mjolnir (északi istenség)',
    german: 'Mjölner',
    dutch: 'Mjolnir (Noorse God)',
    afrikaans: 'Mjolnir (Nordise God)',
    russian: 'молот Тора (символ очищения)',
    latvian: 'Mjelnirs',
    polish: 'Mjollnir, młot Thora (nord)',
    french: 'Mjolnir (mythologie nordique)',
    spanish: 'Mjolnir',
  },
  {
    av: 22655,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(constellation of stars + twins)',
    english: 'Gemini (in zodiac)',
    swedish: 'Tvillingarna',
    norwegian: 'Tvillingene',
    finnish: 'kaksoset',
    hungarian: 'Ikrek (csillagkép)',
    german: 'Zwillinge (Sternzeichen)',
    dutch: 'Tweeling (sterrenbeeld)',
    afrikaans: 'Tweeling (in zodiak)',
    russian: 'Близнецы (знак зодиака)',
    latvian: 'Dvīņi, zvaigznājs, zodiaka zīme',
    polish: 'Bliźnięta (zodiak)',
    french: 'Gémeaux (zodiaque)',
    spanish: 'Géminis (zodíaco)',
  },
  {
    av: 22817,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(Nordic God + light: the God of light and goodness)',
    english: 'Balder',
    swedish: 'Balder',
    norwegian: 'Balder',
    finnish: 'Balder',
    hungarian: 'Balder (északi istenség)',
    german: 'Balder (nordischer Gott)',
    dutch: 'Balder (Noorse God)',
    afrikaans: 'Balder (Nordiese God)',
    russian: 'Бальдр (сын Одина)',
    latvian: 'Balders',
    polish: 'Baldur (bóg norweski)',
    french: 'Balder (mythologie nordique)',
    spanish: 'Balder',
  },
  {
    av: 22818,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(Nordic God + plant: the God of growing power)',
    english: 'Frey',
    swedish: 'Frej, Frö',
    norwegian: 'Frøy (bror til Frøya)',
    finnish: 'Frey, Freyr',
    hungarian: 'Frey (északi istenség)',
    german: 'Frej (nordischer Gott)',
    dutch: 'Frey (Noorse God)',
    afrikaans: 'Frey (Nordiese God)',
    russian: 'Фрей (господин, Бог плодородия и любви)',
    latvian: 'Frejs',
    polish: 'Frej – nordycki bóg urodzaju, płodności oraz pokoju, brat Freji',
    french: 'Frey (mythologie nordique)',
    spanish: 'Frey',
  },
  {
    av: 22819,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(Nordic God(ess) + love: the Godess of love)',
    english: 'Freya',
    swedish: 'Freja, Fröja',
    norwegian: 'Frøya',
    finnish: 'Freya, Freyja, Frea',
    hungarian: 'Freya (északi istenség)',
    german: 'Freya, Freia, Freyja (nordische Göttin)',
    dutch: 'Freya (Noorse God)',
    afrikaans: 'Freya (Nordiese God)',
    russian: 'Фрейя (госпожа, Богиня любви и плодородия)',
    latvian: 'Freja',
    polish: 'Freja – nordycka bogini płodności, miłości, magii i wojny',
    french: 'Freya (mythologie nordique)',
    spanish: 'Freya',
  },
  {
    av: 22820,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(Nordic God + war: the God of war)',
    english: 'Tyr',
    swedish: 'Tyr',
    norwegian: 'Tyr',
    finnish: 'Tyr, Tiv, Tiwaz',
    hungarian: 'Tyr (északi istenség)',
    german: 'Tyr (nordischer Gott)',
    dutch: 'Tyr (Noorse God)',
    afrikaans: 'Tyr (Nordiese God)',
    russian: 'Тир (Бог битвы)',
    latvian: 'Tīrs',
    polish: 'Tyr, Tiu (bóg nordycki)',
    french: 'Tyr (mythologie nordique)',
    spanish: 'Tyr ',
  },
  {
    av: 22821,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(Nordic God + sea: the God of the sea)',
    english: 'Aegir',
    swedish: 'Ägir',
    norwegian: 'Ægir',
    finnish: 'Aegir, Eagor',
    hungarian: 'Aegir (északi istenség)',
    german: 'Aegir (nordischer Gott)',
    dutch: 'Aegir (Noorse God)',
    afrikaans: 'Aegir (Nordiese God)',
    russian: 'Эгир (Бог мирового моря)',
    latvian: 'Ēgirs',
    polish: 'Agir, Egir (bóg morza z mitologi nordyckiej)',
    french: 'Aegir (mythologie nordique)',
    spanish: 'Aegir',
  },
  {
    av: 22823,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(2 + bird + Nordic God: two ravens belonging to Woden)',
    english: 'Hugin and Munin',
    swedish: 'Hugin och Munin',
    norwegian: 'Hugin og Munin',
    finnish: 'Hugin ja Munin',
    hungarian: 'Hugin és Munin (északi istenségek)',
    german: 'Hugin und Munin (Odins Raben)',
    dutch: 'Hugin en Munin (Noorse God)',
    afrikaans: 'Hugin en Munin (Nordiese God)',
    russian: 'Хугин и Мунин (2 птицы Одина)',
    latvian: 'Hugins un Munins',
    polish: 'Hugin i Mugin – kruki Odyna ',
    french: 'Hugin et Munin (mythologie nordique)',
    spanish: 'Hugin y Munin',
  },
  {
    av: 22824,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(horse + Nordic God: Woden's horse)",
    english: 'Sleipnir',
    swedish: 'Sleipner',
    norwegian: 'Sleipner',
    finnish: 'Sleipner, Sleipnir',
    hungarian: 'Sleipnir (északi istenség)',
    german: 'Sleipner (Odins Pferd)',
    dutch: 'Sleipnir (Noors)',
    afrikaans: 'Sleipnir (Nordiese)',
    russian: 'Слейпнир (восьминогий конь Одина)',
    latvian: 'Sleipners',
    polish: 'Sleipnir (ośmionogi koń z mit. Nord.)',
    french: 'Sleipnir (mythologie nordique)',
    spanish: 'Sleipnir',
  },
  {
    av: 22825,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(pig/boar + Nordic God: a boar which was slaughtered every evening and healthy again every morning)',
    english: 'Saehrimnir',
    swedish: 'Särimner',
    norwegian: 'Særimne',
    finnish: 'Särimne',
    hungarian: 'Saehrimnir (északi istenség)',
    german: 'Särimner (myth. Tier nordische Sage)',
    dutch: 'Saehrimnir (Noors)',
    afrikaans: 'Saehrimnir (Nordiese)',
    russian: 'Серимнер (кабан)',
    latvian: 'Serimners',
    polish: 'Sahrimnir – dzik z mitologi nordyckiej',
    french: 'Saehrimnir (mythologie nordique)',
    spanish: 'Sæhrimnir',
  },
  {
    av: 22826,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(snake + past time + north: a big snake curled around the world to keep it together)',
    english: "Midgard's serpent",
    swedish: 'Midgårdsormen',
    norwegian: 'Midgardsormen',
    finnish: 'Midgardskäärme, Midgaardinkäärme',
    hungarian: 'Midgard kígyója (északi mitológia)',
    german: 'Midgardsormen. Midgardschlange (nordischer Mythos)',
    dutch: 'Midgards slang (Noors)',
    afrikaans: 'Midgard se slag (Nordiese)',
    russian: 'Мидгард (змея)',
    latvian: 'Midgerda čūska',
    polish: 'Jormungand, Wąż z Mitgardu (nord.)',
    french: 'serpent de Midgard (mythologie nordique)',
    spanish: 'Serpiente de Midgard',
  },
  {
    av: 22827,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + Nordic God: home of the Gods)',
    english: 'Valhalla',
    swedish: 'Valhall',
    norwegian: 'Valhall',
    finnish: 'Valhalla',
    hungarian: 'Valhalla (az északi istenek lakóhelye)',
    german: 'Walhalla',
    dutch: 'Walhalla (Noors)',
    afrikaans: 'Walhalla (Nordiese)',
    russian: 'Вальхалла (дворец Одина, чертог мёртвых)',
    latvian: 'Valhala',
    polish: 'Valhalla. Walhalla (mityczny raj Wikingów)',
    french: 'Valhalla (mythologie nordique)',
    spanish: 'Valhalla ',
  },
  {
    av: 22828,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + horns + sword)',
    english: 'Viking',
    swedish: 'viking',
    norwegian: 'viking',
    finnish: 'viikinki',
    hungarian: 'viking',
    german: 'Wikinger',
    dutch: 'viking',
    afrikaans: 'viking',
    russian: 'викинг',
    latvian: 'vikings',
    polish: 'Wiking',
    french: 'Viking',
    spanish: 'vikingo',
  },
  {
    av: 22829,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + viking [contr.])',
    english: 'Viking ship',
    swedish: 'vikingaskepp',
    norwegian: 'vikingskip',
    finnish: 'viikinkialus, viikinkilaiva',
    hungarian: 'viking hajó',
    german: 'Wikingerboot',
    dutch: 'vikingschip',
    afrikaans: 'viking skip',
    russian: 'корабль викинга',
    latvian: 'vikingu kuģis',
    polish: 'drakkar, statek wikingów',
    french: 'drakkar (bateau viking)',
    spanish: 'barco vikingo',
  },
  {
    av: 22830,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(alphabet + past + north)',
    english: 'runes',
    swedish: 'runor',
    norwegian: 'runer',
    finnish: 'riimukirjoitus, riimut',
    hungarian: 'viking rovásírás',
    german: 'Rune',
    dutch: 'runen',
    afrikaans: 'runen alfabet',
    russian: 'руны',
    latvian: 'rūnas',
    polish: 'runy (alfabet runiczny)',
    french: 'alphabet runique',
    spanish: 'runas',
  },
  {
    av: 22831,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to give + Nordic God + action indicator: to make a sacrifice the Gods)',
    english: 'offer, sacrifice-(to)',
    swedish: 'offra',
    norwegian: 'ofre',
    finnish: 'uhrata',
    hungarian: 'áldozni az északi isteneknek ',
    german: 'anbieten',
    dutch: 'offeren',
    afrikaans: 'offer (om te)',
    russian: 'жертваоприношать',
    latvian: 'ziedot',
    polish: 'ofiarować, poświęcić',
    french: 'sacrifier (à Dieu), offrir',
    spanish: 'ofrendar, sacrificar',
  },
  {
    av: 22832,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gift + Nordic God)',
    english: 'sacrifice',
    swedish: 'offer',
    norwegian: 'offer',
    finnish: 'uhrilahja',
    hungarian: 'áldozati ajándék az északi istenek részére',
    german: 'Opfer, Opfergabe',
    dutch: 'offer',
    afrikaans: 'offer, offerande',
    russian: 'жертва',
    latvian: 'ziedojums',
    polish: 'ofiara (religijne)',
    french: 'sacrifice',
    spanish: 'sacrificio',
  },
  {
    av: 22833,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(gathering + to sacrifice: ancient Scandinavian gathering to sacrifice to the Nordic Gods)',
    english: 'blot',
    swedish: 'blot',
    norwegian: 'blot',
    finnish: 'blot',
    hungarian: 'áldozati összejövetel az északi istenek részére',
    german: 'Blot (nord. Opferritual)',
    dutch: 'blot (Noors)',
    afrikaans: 'blot (Nordiese)',
    russian: 'блот (обряд жертвоприношения)',
    latvian: 'blot',
    polish: 'blot (staronordycka ceremonia ofiarna)',
    french: 'cérémonie de sacrifice (mythologie nordique)',
    spanish: 'mancha',
  },
  {
    av: 22835,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bowling (sport) + lawn)',
    english: 'lawn bowling, bowls (sport)',
    swedish: 'bowls, lawn bowling (sport)',
    norwegian: 'bowling på gress, bowls (sport)',
    finnish: 'nurmipallo',
    hungarian: 'gyeplabda (sport)',
    german: 'Rasenbowling (Sport)',
    dutch: 'grasbowling',
    afrikaans: 'grasperk rolbal (sport)',
    russian: 'боулинг на траве',
    latvian: 'mazais boulings, zāliena boulings',
    polish: 'kręgle na trawie (sport)',
    french: 'bowling sur gazon, boulingrin (jeu de boules)',
    spanish: 'bowling sobre césped, bochas, petanca',
  },
  {
    av: 22836,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(all + planet)',
    english: 'solar system',
    swedish: 'solsystem',
    norwegian: 'solsystem',
    finnish: 'aurinkokunta',
    hungarian: 'naprendszer',
    german: 'Sonnensystem',
    dutch: 'zonnestelsel',
    afrikaans: 'sonnestelsel',
    russian: 'солнечная система',
    latvian: 'saules sistēma',
    polish: 'Układ Słoneczny',
    french: 'système solaire',
    spanish: 'sistema solar',
  },
  {
    av: 22839,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(seat + horse)',
    english: 'saddle',
    swedish: 'sadel',
    norwegian: 'sal',
    finnish: 'satula',
    hungarian: 'nyereg',
    german: 'Sattel (Pferd)',
    dutch: 'zadel',
    afrikaans: 'saal',
    russian: 'седло',
    latvian: 'sedli',
    polish: 'siodło',
    french: 'selle',
    spanish: 'silla de montar',
  },
  {
    av: 22840,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + sport) Preferred NEW SYNONYM, replacing 13428',
    english: 'court, field',
    swedish: 'idrottsplats, idrottsplan',
    norwegian: 'idrettsplass',
    finnish: 'urheilukenttä',
    hungarian: 'sportpálya',
    german: 'Sportplatz, Spielfeld',
    dutch: 'sportveld, sportterrein',
    afrikaans: 'baan, veld',
    russian: 'спортивное поле, корт',
    latvian: 'korts, laukums',
    polish: 'boisko, stadion',
    french: 'court, terrain de sport',
    spanish: 'pista, campo',
  },
  {
    av: 22841,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + under (ground level))',
    english: 'burial site',
    swedish: 'gravplats',
    norwegian: 'gravplass',
    finnish: 'hautapaikka, kätköpaikka',
    hungarian: 'temetkezési hely',
    german: 'Friedhof',
    dutch: 'begraafplaats, kerkhof',
    afrikaans: 'graf',
    russian: 'место захоронения',
    latvian: 'apbedījumu vieta',
    polish: 'miejsce pochówku',
    french: 'sépulture, enterrement',
    spanish: 'sitio de enterramiento',
  },
  {
    av: 22901,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + astrology)',
    english: 'astrologer, astrologist',
    swedish: 'astrolog',
    norwegian: 'astrolog',
    finnish: 'astrologi, tähdistä ennustaja',
    hungarian: 'csillagjós, asztrológus',
    german: 'Astrologe, Astrologin',
    dutch: 'astroloog',
    afrikaans: 'astroloog, sterrekundige',
    russian: 'астролог',
    latvian: 'astrologs, zvaigžņu pētnieks',
    polish: 'astrolog',
    french: 'astrologue',
    spanish: 'astrólogo',
  },
  {
    av: 22903,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(eye + happiness, fun, joy, pleasure: pleasing to the eye)',
    english: 'beauty',
    swedish: 'skönhet',
    norwegian: 'skjønnhet',
    finnish: 'kauneus',
    hungarian: 'szépség',
    german: 'Schönheit',
    dutch: 'schoonheid',
    afrikaans: 'skoonheid',
    russian: 'красота',
    latvian: 'skaistums',
    polish: 'piękno',
    french: 'beauté',
    spanish: 'belleza',
  },
  {
    av: 22904,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(telephone + action indicator)',
    english: 'call, telephone, ring-(to)',
    swedish: 'ringa, telefonera',
    norwegian: 'ringe, telefonere',
    finnish: 'soittaa puhelimella',
    hungarian: 'telefonálni, felhívni valakit',
    german: 'anrufen, telefonieren',
    dutch: 'bellen, telefoneren',
    afrikaans: 'bel (om te)',
    russian: 'звонить (телефон)',
    latvian: 'zvanīt, zvanīt pa telefonu',
    polish: 'telefonować, dzwonić',
    french: 'téléphoner, appeler, sonner',
    spanish: 'llamar, telefonear',
  },
  {
    av: 22905,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + bean + up (sweet [contr.])) Preferred NEW SYNONYM, replacing 13171',
    english: 'chocolate',
    swedish: 'choklad',
    norwegian: 'sjokolade',
    finnish: 'suklaa',
    hungarian: 'csokoládé',
    german: 'Schokolade',
    dutch: 'chocola',
    afrikaans: 'sjokolade',
    russian: 'шоколад',
    latvian: 'šokolāde',
    polish: 'czekolada',
    french: 'chocolat',
    spanish: 'chocolate',
  },
  {
    av: 22906,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spread + chocolate [contr.]) Preferred NEW SYNONYM, replacing 13174',
    english: 'chocolate spread',
    swedish: 'chokladpålägg',
    norwegian: 'sjokoladepålegg',
    finnish: 'suklaalevite',
    hungarian: 'csokoládémáz',
    german: 'Schokoladenaufstrich, Schokoladencreme',
    dutch: 'chocoladepasta, choco',
    afrikaans: 'sjokolade verprei',
    russian: 'школодадная паста',
    latvian: 'šokoādes sviests',
    polish: 'masło czekoladowe',
    french: 'chocolat à tartiner, choco',
    spanish: 'cobertura de chocolate',
  },
  {
    av: 22907,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + cooking, cookery, preparation (general))',
    english: 'cook, chef',
    swedish: 'kock',
    norwegian: 'kokk',
    finnish: 'kokki',
    hungarian: 'szakács, séf',
    german: 'Koch, Küchenchef',
    dutch: 'kok',
    afrikaans: 'kok',
    russian: 'повар',
    latvian: 'pavārs, šefpavārs',
    polish: 'kucharz, szef kuchni',
    french: 'cuisinier, chef cuisinier',
    spanish: 'cocinero, chef',
  },
  {
    av: 22908,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fire + food: to use fire (heat) to prepare food)',
    english: 'cooking, cookery, preparation (hot food)',
    swedish: 'matlagning (varm mat)',
    norwegian: 'matkoking',
    finnish: 'ruoanvalmistus, ruoanlaitto',
    hungarian: 'főzés',
    german: 'kochen (warmes Essen)',
    dutch: 'koken (het koken)',
    afrikaans: 'kook, kookuns, voorbereiding (warm kos)',
    russian: 'приготовление пищи (горячее блюдо)',
    latvian: 'gatavošana, ēdiena gatavošana, maltītes gatavošan',
    polish: 'gotowanie, przyrządzanie (gorące dania)',
    french: 'plat chaud',
    spanish: 'cocina, preparación (alimentos calientes)',
  },
  {
    av: 22909,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to make + food)',
    english: 'cooking, cookery, preparation (general)',
    swedish: 'matlagning',
    norwegian: 'matlaging',
    finnish: 'ruoanlaitto, ruoanvalmistus',
    hungarian: 'ételkészítés',
    german: 'kochen',
    dutch: 'koken (zelfst.nw))',
    afrikaans: 'kook, kookuns, voorbereiding (algemeen)',
    russian: 'приготовление пищи (общее понятие)',
    latvian: 'gatavot ēdienu',
    polish: 'gotowanie, przygotowywanie (ogólne)',
    french: 'cuisine, travail culinaire',
    spanish: 'cocina, preparación (general)',
  },
  {
    av: 22910,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + spot: many spots of dirt)',
    english: 'dirt, soil',
    swedish: 'smuts',
    norwegian: 'skitt',
    finnish: 'lika',
    hungarian: 'piszok, szenny',
    german: 'Dreck, Schmutz',
    dutch: 'vuil (zelfst.nw)',
    afrikaans: 'vuil, grond',
    russian: 'грязь',
    latvian: 'dubļi, augsne',
    polish: 'brud, kurz, zanieczyszczenie',
    french: 'saleté, crasse',
    spanish: 'suciedad',
  },
  {
    av: 22912,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sadness + future (uncertain): concern about the future because of its uncertainties)',
    english: 'fear, fright, concern',
    swedish: 'rädsla',
    norwegian: 'frykt, skrekk, engstelse, redsel',
    finnish: 'pelko',
    hungarian: 'autoagresszív, önmagána',
    german: 'Angst, Furcht, Schreck',
    dutch: 'schrik, angst',
    afrikaans: 'vrees, skrik, bekommer',
    russian: 'страх, боязнь',
    latvian: 'bailes, izbīlis',
    polish: 'strach, obawa, przerażenie, zaniepokojenie, zmartwienie',
    french: 'peur, inquiétude, préoccupation',
    spanish: 'temor, preocupación',
  },
  {
    av: 22915,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(religion (God based) + description indicator) SYNONYM',
    english: 'religious (God based)',
    swedish: 'religiös, troende (gudsbaserad)',
    norwegian: 'religiøs, troende (tro på Gud)',
    finnish: 'uskonnollinen',
    hungarian: 'vallásos, Istenhívő',
    german: 'religiös',
    dutch: 'religieus',
    afrikaans: 'godsdienstige (God gebaseer)',
    russian: 'верующий, набожный',
    latvian: 'reliģiozs, balstīts ticībā Dievam',
    polish: 'religijne (boskie)',
    french: 'religieux (basé sur dieu)',
    spanish: 'religioso (basado en un Dios)',
  },
  {
    av: 22916,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(self-harm + description indicator)',
    english: 'self-harming',
    swedish: 'självdestruktiv',
    norwegian: 'selvdestruktiv, selvskadet',
    finnish: 'itsetuhoinen',
    hungarian: 'autoagresszív, önmagát bántó, magának bajt okozó',
    german: 'selbstverletzend, autoaggressiv',
    dutch: 'automutulatie (bijvoeg.nw)',
    afrikaans: 'self-benadeling',
    russian: 'саморазрушающий',
    latvian: 'pašnodarījums',
    polish: 'masturbacyjny',
    french: 'automutilant',
    spanish: 'autodestructivo',
  },
  {
    av: 22917,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mind + intensity: striking mental abilities)',
    english: 'smartness, brightness, cleverness, intelligence',
    swedish: 'klokhet, begåvning',
    norwegian: 'klokskap, smarthet, kløkt',
    finnish: 'viisaus, älykkyys, nokkeluus, etevyys',
    hungarian: 'okosság, értelmesség',
    german: 'klug, tüchtig, gescheit, schlau, intelligent',
    dutch: 'intelligentie',
    afrikaans: 'intelligensie, slim',
    russian: 'мудрость, талант',
    latvian: 'gudrība, attapība',
    polish: 'spryt, inteligencja',
    french: 'intelligence',
    spanish: 'sabiduría, talento ',
  },
  {
    av: 22918,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(doubt, uncertainty + description indicator)',
    english: 'uncertain, unsure',
    swedish: 'osäker, obestämd',
    norwegian: 'usikker',
    finnish: 'epävarma, epätietoinen',
    hungarian: 'kételkedő, bizonytalan, habozó',
    german: 'unsicher',
    dutch: 'onzeker, twijfelend',
    afrikaans: 'onseker',
    russian: 'неопределённый',
    latvian: 'neskaidrs, nedrošs',
    polish: 'niepewny',
    french: 'incertain',
    spanish: 'incierto, inseguro',
  },
  {
    av: 23001,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to speak + opposition)',
    english: 'accusation',
    swedish: 'anklagelse, beskyllning, klander',
    norwegian: 'anklage',
    finnish: 'syytös',
    hungarian: 'vád, vádlás',
    german: 'Anklage, Beschuldigung, Vorwurf',
    dutch: 'beschuldiging, verdenking',
    afrikaans: 'beskuldiging',
    russian: 'обвинение',
    latvian: 'apsūdzēšana',
    polish: 'oskarżenie, zarzut',
    french: 'accusation',
    spanish: 'acusación',
  },
  {
    av: 23002,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(accusation + judgement, law (in combinations))',
    english: 'accusation (legal), charge, prosecution',
    swedish: 'anklagelse (juridiskt), åtal',
    norwegian: 'påtale (juridisk)',
    finnish: 'oikeussyyte',
    hungarian: 'vádemelés, bűnvádi eljárás',
    german: 'Anklage, Strafverfolgung',
    dutch: 'vervolging, rechtsvervolging',
    afrikaans: 'beskuldiging (wetlike), vervolging',
    russian: 'обвинение (юридическое)',
    latvian: 'apsūdzēt, iesūdzēt, juridiska lietas ierosināšana ',
    polish: 'oskarżenie sądowe, zarzut w sądzie (prawo)',
    french: 'accusation, plainte (justice)',
    spanish: 'acusación (legal), cargos',
  },
  {
    av: 23003,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(accusation + action indicator)',
    english: 'accuse-(to)',
    swedish: 'anklaga, beskylla, klandra',
    norwegian: 'anklage, beskylde',
    finnish: 'syyttää',
    hungarian: 'vádolni, megvádolni',
    german: 'beschuldigen',
    dutch: 'beschuldigen',
    afrikaans: 'beskuldig (om te)',
    russian: 'обвинять',
    latvian: 'apsūdzēt, iesūdzēt ',
    polish: 'zarzucić, oskarżyć',
    french: 'accuser',
    spanish: 'acusar ',
  },
  {
    av: 23004,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(accusation + judgement, law (in combinations) + action indicator)',
    english: 'accuse (legal), charge, prosecute-(to)',
    swedish: 'anklaga (juridiskt), åtala',
    norwegian: 'påtale (å) (juridisk)',
    finnish: 'syyttää oikeudessa',
    hungarian: 'vádat emelni, bűnvádi eljárásba vonni',
    german: 'anklagen (Jura)',
    dutch: 'vervolgen, gerechtelijk vervolgen',
    afrikaans: 'beskuldig (wetlike), vervolg (om te)',
    russian: 'обвинять (юридически)',
    latvian: 'apsūdzēt, juridiski, ierosināt lietu',
    polish: 'oskarżać (prawo)',
    french: 'accuser, porter plainte',
    spanish: 'acusar (legal), presentar cargos',
  },
  {
    av: 23005,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(action, demonstration (in favour of) + action indicator)',
    english: 'act, demonstrate (in favour of)-(to)',
    swedish: 'agera, företräda, demonstrera (för)',
    norwegian: 'aksjonere for, demonstrere for ',
    finnish: 'kannustaa',
    hungarian: 'képviselni',
    german: 'agieren, vertreten, demonstrieren',
    dutch: 'handelen, aantonen',
    afrikaans: 'wet ten gunste van (om te), demonstreer ten gunste van (om te)',
    russian: 'демонстрировать, представлять',
    latvian: 'rīcība, darbība demonstrācija',
    polish: 'działać na rzecz',
    french: 'agir en faveur de, exécuter',
    spanish: 'actuar a favor de',
  },
  {
    av: 23006,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(action, demonstration (in favour of) + judgement, law (in combinations) + action indicator)',
    english: 'act in favour of (legal)-(to)',
    swedish: 'företräda (juridiskt)',
    norwegian: 'bistå (juridisk)',
    finnish: 'puolustaa (oikeudessa), edustaa (oikeudessa), ajaa asiaa',
    hungarian: 'jogilag képviselni valakit, ügyében eljárni',
    german: 'vertreten, repräsentieren (Jura)',
    dutch: 'bevoordelen, begunstigen',
    afrikaans: 'wet ten gunste van (wetelike) (om te)',
    russian: 'представлять интересы (юридический термин)',
    latvian: 'rīcība kāda labā, juridiska rīcība',
    polish: 'działać na rzecz (prawne)',
    french: 'agir en faveur de (justice)',
    spanish: 'actuar a favor de (legal)',
  },
  {
    av: 23007,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + purpose)',
    english: 'action, demonstration (in favour of)',
    swedish: 'aktion, företrädande, demonstration (för)',
    norwegian: 'aksjon for, demonstrasjon for',
    finnish: 'kannustus',
    hungarian: 'képviselet',
    german: 'Handlung (für), Aktivität (für), Demonstration (für)',
    dutch: 'handeling, daad, actie',
    afrikaans: 'tree op ten gunste van',
    russian: 'представление, демонстрация',
    latvian: 'darbība, rīcība, demonstrācija kāda labā',
    polish: 'działanie na rzecz',
    french: 'action en faveur',
    spanish: 'acción a favor de',
  },
  {
    av: 23008,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + activity)',
    english: 'activity centre',
    swedish: 'aktivitetscenter',
    norwegian: 'aktivitetssenter',
    finnish: 'toimintakeskus',
    hungarian: 'közösségi ház, tevékenységek háza',
    german: 'Aktivitätszentrum',
    dutch: 'activiteitencentrum ',
    afrikaans: 'aktiwiteitsentrum',
    russian: 'центр занятости',
    latvian: 'nodarbību centrs',
    polish: 'świetlica, ośrodek aktywności, klub ',
    french: "centre d'activités",
    spanish: 'centro de actividades',
  },
  {
    av: 23009,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity centre + child)',
    english: 'activity centre (children)',
    swedish: 'aktivitetscenter (barn)',
    norwegian: 'aktivitetssenter (barn)',
    finnish: 'toimintakeskus (lapsille)',
    hungarian: 'gyermekprogramok központja',
    german: 'Aktivitätszentrum (Kinder)',
    dutch: 'activiteitencentrum (kinderen)',
    afrikaans: 'aktiwiteitsentrum (kinders)',
    russian: 'ценрт занятости детей, детский ценрт',
    latvian: 'bērnu nodarbību centrs',
    polish: 'świetlica dla dzieci, klub dla dzieci',
    french: "centre d'activités (enfants)",
    spanish: 'centro de actividades (infantil)',
  },
  {
    av: 23010,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity centre + freedom)',
    english: 'activity centre (leisure time), after school club, youth club',
    swedish: 'fritidsgård',
    norwegian: 'skole-fritidsordning, SFO',
    finnish: 'iltapäiväkerho, nuorisokeskus',
    hungarian: 'szabadidő központ, klub',
    german: 'nachschulische Betreuung (Kinder)',
    dutch: 'activiteitencentrum (vrije tijd)',
    afrikaans: 'aktiwiteitsentrum (ontspanning klub)',
    russian: 'центр досуга',
    latvian: 'brīvā laika centrs, ārpusskolas aktivitāšu centrs',
    polish: 'świetlica szkolna, świetlica po szkole',
    french: 'centre de loisirs',
    spanish: 'centro de actividades (ocio)',
  },
  {
    av: 23011,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity centre + teenager)',
    english: 'activity centre (teenagers)',
    swedish: 'aktivitetscenter (ungdom), ungdomsgård',
    norwegian: 'aktivitetssenter (ungdom)',
    finnish: 'toimintakeskus (nuorille)',
    hungarian: 'tini-klub, serdülők tevékenységi központja',
    german: 'Jugendzentrum',
    dutch: 'activiteitencentrum (adolescent)',
    afrikaans: 'aktiwiteitsentrum (tieners)',
    russian: 'центр занятости подростков',
    latvian: 'pusaudžu nodarbību centrs',
    polish: 'ośrodek młodzieżowy, klub młodzieżowy, młodzieżowy dom kultury',
    french: "centre d'activités (adolescents)",
    spanish: 'centro de actividades (adolescentes)',
  },
  {
    av: 23012,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + action in favour of)',
    english: 'advocate',
    swedish: 'aktivist (för), företrädare',
    norwegian: 'aktivist for',
    finnish: 'asianajaja, edustaja',
    hungarian: 'támogató, pártoló',
    german:
      'Anwalt, Anwältin, Rechtsanwalt, Rechtsanwältin, Verteidiger (Gericht), Verteidigerin (Gericht)',
    dutch: 'advocaat',
    afrikaans: 'advokaat',
    russian: 'представитель',
    latvian: 'aizstāvis, advokāts',
    polish: 'orędownik, zwolennik',
    french: 'partisan, militant',
    spanish: 'defensor',
  },
  {
    av: 23013,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(advocacy + action indicator: to speak for a purpose)',
    english: 'advocate-(to)',
    swedish: 'förespråka, propagera (för)',
    norwegian: 'argumentere for',
    finnish: 'puolustaa',
    hungarian: 'szót emelni valakiért, védelmet nyújtani',
    german: 'befürworten, (Meinung) vertreten',
    dutch: 'pleiten, bepleiten',
    afrikaans: 'pleit, bepleit (om te)',
    russian: 'защищать ',
    latvian: 'aizstāvēt',
    polish: 'przemawiać, mówić w czyimś interesie',
    french: 'plaider, soutenir',
    spanish: 'defender',
  },
  {
    av: 23014,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(legal person + action in favour of)',
    english: 'advocate (legal)',
    swedish: 'advokat',
    norwegian: 'advokat',
    finnish: 'asianajaja',
    hungarian: 'jogtanácsos',
    german: 'Anwalt, Anwältin',
    dutch: 'pleiten, bepleiten',
    afrikaans: 'pleit, bepleit',
    russian: 'правозащитник',
    latvian: 'advokatūra',
    polish: 'adwokat, rzecznik, osoba która działa na rzecz (prawo)',
    french: 'avocat (justice)',
    spanish: 'defensor (legal)',
  },
  {
    av: 23015,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(advocate-(to) + judgement, law (in combinations) + action indicator)',
    english: 'advocate (legal)-(to)',
    swedish: 'representera (juridiskt)',
    norwegian: 'argumentere for, representere (juridisk)',
    finnish: 'puolustaa (oikeudessa)',
    hungarian: 'jogi segítséget nyújtani',
    german: 'verteidigen (Gericht), plädieren (Gericht)',
    dutch: 'pleiten',
    afrikaans: 'pleit (om te)',
    russian: 'защищать права',
    latvian: 'aizstāvēt tiesības',
    polish: 'bronić, występować w obronie (prawo)',
    french: 'plaider, défendre (en justice)',
    spanish: 'defender (legal)',
  },
  {
    av: 23016,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(legal person + advocate-(to))',
    english: 'advocate (legal, speaking)',
    swedish: 'talesperson (juridisk), advokat',
    norwegian: 'talsmann for (juridisk)',
    finnish: 'asianajaja, puolestapuhuja',
    hungarian: 'jogi szószóló, képviselő',
    german: 'Anwalt, Anwältin',
    dutch: 'pleiten, bepleiten',
    afrikaans: 'pleit, bepleit',
    russian: 'адвокат',
    latvian: 'aizstāvības runa',
    polish: 'adwokat, mówca, osoba która mówi w czyjejś obronie (mowa obrońcy)',
    french: 'avocat (plaidant oralement en justice)',
    spanish: 'defensor (legal, hablando)',
  },
  {
    av: 23017,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + advocate-(to))',
    english: 'advocate (speaking), spokesperson',
    swedish: 'förespråkare, talesperson',
    norwegian: 'talsmann for',
    finnish: 'puolestapuhuja, suosittelija',
    hungarian: 'közbenjáró, érdekvédő',
    german:
      'Anwalt, Anwältin, Rechtsanwalt, Rechtsanwältin, Verteidiger (Gericht), Verteidigerin (Gericht)',
    dutch: 'pleiten, bepleiten',
    afrikaans: 'pleit, bepleit (woordvoerder)',
    russian: 'адвокат, защитник',
    latvian: 'aizstāvība, runa',
    polish: 'przemowa, mowa w obronie, mowa na rzecz...',
    french: 'partisan, militant (plaidant oralement)',
    spanish: 'defensor (hablando)',
  },
  {
    av: 23018,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + high + thing indicator)',
    english: 'altimeter',
    swedish: 'höjdmätare, altimeter',
    norwegian: 'høydemåler, altimeter',
    finnish: 'korkeusmittari',
    hungarian: 'magasságmérő',
    german: 'Höhenmesser',
    dutch: 'hoogtemeter',
    afrikaans: 'hoogtemeter, altimeter',
    russian: 'высотомер, альтиметр',
    latvian: 'altimetrs, augstuma mērītājs',
    polish: 'wysokościomierz',
    french: 'altimètre',
    spanish: 'altímetro',
  },
  {
    av: 23019,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + wind + thing indicator)',
    english: 'anemometer',
    swedish: 'vindmätare, anemometer',
    norwegian: 'vindmåler, anemometer',
    finnish: 'tuulimittari',
    hungarian: 'szélmérő',
    german: 'Windgeschwindigkeitsmesser, Anemometer',
    dutch: 'anemometer, windmeter',
    afrikaans: 'anemometer, windmeter',
    russian: 'анемометр',
    latvian: 'anemometrs',
    polish: 'wiatromierz',
    french: 'anémomètre',
    spanish: 'anemómetro',
  },
  {
    av: 23020,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(measurement + angle)',
    english: 'angle (measurement)',
    swedish: 'vinkel, vinkelmått',
    norwegian: 'vinkelmåler',
    finnish: 'kulma (mittaus)',
    hungarian: 'szögmérés',
    german: 'Winkel, Ecke',
    dutch: 'hoek',
    afrikaans: 'hoek',
    russian: 'угольник',
    latvian: 'leņķis, leņķmērs',
    polish: 'kątomierz',
    french: 'angle (amplitude)',
    spanish: 'ángulo (medida)',
  },
  {
    av: 23021,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(a + day)',
    english: 'any day, someday',
    swedish: 'någon dag, endera dagen',
    norwegian: 'en dag (i framtiden)',
    finnish: 'jonakin päivänä',
    hungarian: 'akármelyik nap, bármleyik nap, valamelyik nap',
    german: 'eines Tages',
    dutch: 'op een dag',
    afrikaans: 'enige dag',
    russian: 'любой день',
    latvian: 'jekurā dienā, kādu dienu',
    polish: 'każdego dnia, kiedyś',
    french: "un jour ou l'autre, un de ces jours",
    spanish: 'cualquier día, algún día',
  },
  {
    av: 23022,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + many + floor, storey, level, etage)',
    english: 'apartment block',
    swedish: 'höghus',
    norwegian: 'boligblokk, høyblokk',
    finnish: 'kerrostalo',
    hungarian: 'lakótelep',
    german: 'Appartementhaus, Etagenhaus, Wohnhaus',
    dutch: 'appartementsgebouw',
    afrikaans: 'woonstel blok',
    russian: 'многоэтажный дом',
    latvian: 'dzīvojamo māju kvartāls',
    polish: 'blok mieszkalny, dom wielopiętrowy, apartamentowiec, wieżowiec',
    french: "immeuble d'appartements",
    spanish: 'bloque de apartamentos',
  },
  {
    av: 23023,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + island)',
    english: 'archipelago',
    swedish: 'skärgård',
    norwegian: 'øyhav, skjærgård',
    finnish: 'saaristo',
    hungarian: 'szigetvilág, archipelago',
    german: 'Archipel, Inselgruppe',
    dutch: 'archipel, eilandengroep',
    afrikaans: 'argipel',
    russian: 'архипелаг',
    latvian: 'arhipelāgs',
    polish: 'archipelag',
    french: 'archipel',
    spanish: 'archipiélago',
  },
  {
    av: 23024,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(measurement + enclosure)',
    english: 'area (measurement)',
    swedish: 'yta, ytmått, area, areal',
    norwegian: 'areal',
    finnish: 'alue, pinta-ala',
    hungarian: 'terep, terület, térség',
    german: 'Fläche, Areal, Bodenfläche',
    dutch: 'gebied, oppervlakte',
    afrikaans: 'area, gebied',
    russian: 'измеритель площади',
    latvian: 'teritorija, apgabals',
    polish: 'obszar, areał',
    french: 'surface',
    spanish: 'zona, área',
  },
  {
    av: 23025,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(capture, catch, seize-(to) + judgement, law (in combinations) + action indicator)',
    english: 'arrest-(to)',
    swedish: 'anhålla, gripa',
    norwegian: 'arrestere',
    finnish: 'pidättää',
    hungarian: 'letartóztatni',
    german: 'verhaften, festnehmen',
    dutch: 'arresteren',
    afrikaans: 'hegtenis (om in hegtenis te neem) (om te)',
    russian: 'арестовывать',
    latvian: 'arestēt',
    polish: 'aresztować',
    french: 'arrêter, appréhender (justice)',
    spanish: 'detener, arrestar',
  },
  {
    av: 23027,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + bread)',
    english: 'bakery',
    swedish: 'bageri',
    norwegian: 'bakeri',
    finnish: 'leipomo',
    hungarian: 'pékség, pékbolt',
    german: 'Bäckerei',
    dutch: 'bakkerij',
    afrikaans: 'bakkery',
    russian: 'булочная, пекарня',
    latvian: 'ceptuve',
    polish: 'piekarnia',
    french: 'boulangerie',
    spanish: 'panadería',
  },
  {
    av: 23028,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + pressure + air + thing indicator)',
    english: 'barometer, manometer',
    swedish: 'barometer, manometer',
    norwegian: 'barometer, manometer',
    finnish: 'barometri, ilmapuntari',
    hungarian: 'barométer, nyomásmérő',
    german: 'Barometer, Luftdruckmesser, Druckmesser, Manometer',
    dutch: 'barometer',
    afrikaans: 'barometer',
    russian: 'барометр, манометр',
    latvian: 'barometrs, monometrs',
    polish: 'barometr, manometr',
    french: 'baromètre',
    spanish: 'barómetro, manómetro',
  },
  {
    av: 23030,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + biology [contr.])',
    english: 'biology (class)',
    swedish: 'biologi (skolämne)',
    norwegian: 'biologi (fag)',
    finnish: 'biologia (kouluaine)',
    hungarian: 'biológia (tantárgy)',
    german: 'Biologie (Schulfach)',
    dutch: 'biologie',
    afrikaans: 'biologie (klas)',
    russian: 'биология (предмет)',
    latvian: 'bioloģijas nodarbības',
    polish: 'biologia (kategoria)',
    french: 'cours de biologie',
    spanish: 'biología (clase)',
  },
  {
    av: 23031,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + Blissymbol)',
    english: 'Bliss, Bliss language, Blissymbolics',
    swedish: 'bliss, blisspråket',
    norwegian: 'bliss, blisspråk',
    finnish: 'blisskieli',
    hungarian: 'Bliss-nyelv, Bliss-jelkép',
    german: 'BLISS-Symbol-System, BLISS-Symbol-Sprache',
    dutch: 'Blisstaal',
    afrikaans: 'Blisstaal',
    russian: 'блисс, блисс язык',
    latvian: 'Bliss, Bliss valoda, Bliss simboli',
    polish: 'Bliss, język Bliss, Blissymbolics, System Symboli Bliss',
    french: 'Bliss, langue Bliss, symbolique Bliss',
    spanish: 'Bliss, lenguaje Bliss, símbolos Bliss',
  },
  {
    av: 23032,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + Bliss language)',
    english: 'Bliss (class)',
    swedish: 'bliss (skolämne)',
    norwegian: 'bliss (fag)',
    finnish: 'blisskieli (kouluaine)',
    hungarian: 'Bliss-nyelv (tantárgy)',
    german: 'Blissunterricht',
    dutch: 'Blissles',
    afrikaans: 'Bliss (klas)',
    russian: 'блисс (предмет)',
    latvian: 'Bliss nodarbība',
    polish: 'Bliss (kategoria)',
    french: 'cours de Bliss',
    spanish: 'Bliss (clase)',
  },
  {
    av: 23033,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(board and lodging, room and board + action indicator)',
    english: 'board-(to)',
    swedish: 'bo inackorderad',
    norwegian: 'ha kost og losji',
    finnish: 'asua täysihoitolassa',
    hungarian: 'ellátásban lenni, étkezést és szállást kapni',
    german: 'in Pension sein',
    dutch: 'inwonen',
    afrikaans: 'gaan aan boord (om te)',
    russian: 'проживать в пансионате',
    latvian: 'dzīvot pansionātā',
    polish: 'stołować, wynajmować kwaterę z posiłkiem',
    french: 'être en pension',
    spanish: 'hospedarse',
  },
  {
    av: 23034,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + book)',
    english: 'bookshop',
    swedish: 'bokhandel',
    norwegian: 'bokhandel',
    finnish: 'kirjakauppa',
    hungarian: 'könyvesbolt, könyvkereskedés',
    german: 'Buchladen',
    dutch: 'boekhandel, boekwinkel',
    afrikaans: 'boekwinkel',
    russian: 'книжный магазин',
    latvian: 'grāmatveikals',
    polish: 'księgarnia',
    french: 'librairie',
    spanish: 'librería',
  },
  {
    av: 23035,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(metal [contr.] + tin [contr.] + copper [contr.])',
    english: 'bronze',
    swedish: 'brons',
    norwegian: 'bronse',
    finnish: 'pronssi',
    hungarian: 'bronz',
    german: 'Bronze',
    dutch: 'brons',
    afrikaans: 'brons',
    russian: 'бронза',
    latvian: 'bronza',
    polish: 'brąz (metal)',
    french: 'bronze',
    spanish: 'bronce',
  },
  {
    av: 23036,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(past time + bronze [contr.])',
    english: 'bronze age',
    swedish: 'bronsåldern',
    norwegian: 'bronsealder',
    finnish: 'pronssikausi',
    hungarian: 'bronzkor',
    german: 'Bronzezeit',
    dutch: 'Bronzen tijdperk, Bronstijd',
    afrikaans: 'bronstydperk',
    russian: 'бронзовый век',
    latvian: 'bronzas laikmets',
    polish: 'Epoka brązu',
    french: 'âge de bronze',
    spanish: 'edad de bronce',
  },
  {
    av: 23037,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + meat)',
    english: 'butcher shop',
    swedish: 'charkuteri',
    norwegian: 'slakterbutikk',
    finnish: 'lihakauppa',
    hungarian: 'húsbolt, hentesbolt',
    german: 'Fleischerei, Metzgerei',
    dutch: 'slagerij, beenhouwerij',
    afrikaans: 'slaghuis',
    russian: 'мясной магазин',
    latvian: 'skārnis, gaļas veikals',
    polish: 'sklep mięsny',
    french: 'boucherie',
    spanish: 'carnicería',
  },
  {
    av: 23038,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + protection)',
    english: 'care centre',
    swedish: 'skyddat boende (etc)',
    norwegian: 'omsorgsbolig',
    finnish: 'turvakoti, hoivakoti',
    hungarian: 'gondozó központ',
    german: 'Pflegeheim, Betreuungsplätze, Einrichtungen für Opferhilfe',
    dutch: 'zorgcentrum',
    afrikaans: 'versorgingssentrum, sorgsentrum',
    russian: 'социальный центр',
    latvian: 'aprūpes centrs',
    polish: 'centrum opieki',
    french: "centre d'accueil",
    spanish: 'centro de cuidados',
  },
  {
    av: 23039,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(price + small + description indicator) Preferred NEW SYNONYM, replacing 13155',
    english: 'cheap, inexpensive',
    swedish: 'billig',
    norwegian: 'billig',
    finnish: 'halpa',
    hungarian: 'olcsó, nem drága',
    german: 'billig',
    dutch: 'goedkoop',
    afrikaans: 'goedkoop',
    russian: 'дешёвый',
    latvian: 'lēts, nedārgs',
    polish: 'tanie, niedrogie',
    french: 'bon marché',
    spanish: 'barato',
  },
  {
    av: 23040,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + chemistry [contr.])',
    english: 'chemistry (class)',
    swedish: 'kemi (skolämne)',
    norwegian: 'kjemi (fag)',
    finnish: 'kemia (kouluaine)',
    hungarian: 'kémia (tantárgy)',
    german: 'Chemieunterricht',
    dutch: 'scheikunde',
    afrikaans: 'chemie',
    russian: 'химия (предмет)',
    latvian: 'ķīmijas nodarbība',
    polish: 'chemiczny (kategoria)',
    french: 'cours de chimie',
    spanish: 'Química (clase)',
  },
  {
    av: 23041,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(helper + judgement, law (in combinations))',
    english: 'clerk, legal aid',
    swedish: 'juridiskt biträde',
    norwegian: 'juridisk hjelp',
    finnish: 'oikeusapulainen',
    hungarian: 'jogsegélyt nyújtó tisztviselő',
    german: 'Rechtsbeistand',
    dutch: 'rechtshulp, rechtsbijstand',
    afrikaans: 'klerk, regshulp',
    russian: 'юрисконсульт',
    latvian: 'ierēdnis, jurista palīgs',
    polish: 'urzędnik, pomoc prawna',
    french: 'auxiliaire de justice, assistant en justice',
    spanish: 'secretario, asistencia legal',
  },
  {
    av: 23042,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + clothing)',
    english: 'clothing shop',
    swedish: 'klädaffär',
    norwegian: 'klesbutikk',
    finnish: 'vaatekauppa',
    hungarian: 'ruhabolt, ruhakereskedés',
    german: 'Kleiderladen',
    dutch: 'kledingswinkel, kledingzaak',
    afrikaans: 'klerewinkel',
    russian: 'магазин одежды',
    latvian: 'apģērbu veikals',
    polish: 'sklep odzieżowy',
    french: 'magasin de vêtements',
    spanish: 'tienda de ropa',
  },
  {
    av: 23043,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chicken + male)',
    english: 'cockerel, rooster',
    swedish: 'tupp',
    norwegian: 'hanekylling',
    finnish: 'kukko',
    hungarian: 'kiskakas',
    german: 'junger Hahn',
    dutch: 'haan',
    afrikaans: 'haan',
    russian: 'петух',
    latvian: 'gailēns, kauslis',
    polish: 'kogucik',
    french: 'coq, coquelet',
    spanish: 'gallo joven, gallito',
  },
  {
    av: 23045,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tower + airplane)',
    english: 'control tower',
    swedish: 'kontrolltorn',
    norwegian: 'kontrolltårn',
    finnish: 'lennonjohtotorni',
    hungarian: 'repülésirányító torony',
    german: 'Kontrollturm, Flugleitung',
    dutch: 'verkeerstoren',
    afrikaans: 'beheertoring',
    russian: 'контрольная башня',
    latvian: 'dispečeru tornis',
    polish: 'wieża kontrolna',
    french: 'tour de contrôle',
    spanish: 'torre de control',
  },
  {
    av: 23046,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(metal [contr.] + pot + past time)',
    english: 'copper',
    swedish: 'koppar',
    norwegian: 'kobber',
    finnish: 'kupari',
    hungarian: 'réz',
    german: 'Kupfer',
    dutch: 'koper',
    afrikaans: 'koper',
    russian: 'медь',
    latvian: 'varš ',
    polish: 'miedź',
    french: 'cuivre',
    spanish: 'cobre',
  },
  {
    av: 23047,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + long)',
    english: 'corridor, hall',
    swedish: 'korridor',
    norwegian: 'korridor, hall',
    finnish: 'käytävä',
    hungarian: 'folyosó',
    german: 'Flur, Treppenabsatz, Korridor',
    dutch: 'hall, gang',
    afrikaans: 'gang',
    russian: 'коридор, холл',
    latvian: 'gaitenis, koridors, priekštelpa',
    polish: 'korytarz, hol',
    french: 'corridor, hall',
    spanish: 'pasillo, salón',
  },
  {
    av: 23048,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(material + flower, bloom, blossom + cloth: textile fibre made from the boll of the cotton plant)',
    english: 'cotton',
    swedish: 'bomull',
    norwegian: 'bomull',
    finnish: 'puuvilla',
    hungarian: 'gyapot',
    german: 'Baumwolle, Watte, Wattebällchen',
    dutch: 'katoen',
    afrikaans: 'katoen',
    russian: 'хлопок',
    latvian: 'kokvilna',
    polish: 'bawełna',
    french: 'coton (matière)',
    spanish: 'algodón',
  },
  {
    av: 23049,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(cloth + flower, bloom, blossom: fabric woven from cotton fibre [contr.] )',
    english: 'cotton fabric',
    swedish: 'bomullstyg',
    norwegian: 'bomullstøy',
    finnish: 'puuvillakangas',
    hungarian: 'pamut',
    german: 'Baumwollstoff, Baumwollgewebe',
    dutch: 'katoenen weefsel',
    afrikaans: 'katoen materiaal',
    russian: 'хлопок (ткань)',
    latvian: 'kokvilnas audums',
    polish: 'tkanina bawełniana',
    french: 'coton (tissu, étoffe)',
    spanish: 'tejido de algodón',
  },
  {
    av: 23050,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(measurement + number)',
    english: 'count',
    swedish: 'räknemått, antal',
    norwegian: 'opptelling, sum',
    finnish: 'laskenta',
    hungarian: 'számlálás, számolás, megszámolás',
    german: 'Vermessung, Anzahl',
    dutch: 'aantal',
    afrikaans: 'tel',
    russian: 'количество',
    latvian: 'skaits, numurs',
    polish: 'rachunek, kalkulacja',
    french: 'compte (mesure)',
    spanish: 'cuenta, número',
  },
  {
    av: 23051,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + judgement, law (in combinations))',
    english: 'court, courthouse',
    swedish: 'domstol, rätt (juridisk)',
    norwegian: 'rettsbygning, tinghus',
    finnish: 'oikeustalo',
    hungarian: 'bíróság, törvényszék',
    german: 'Hof, Innenhof',
    dutch: 'gerechtsgebouw',
    afrikaans: 'hof',
    russian: 'здание суда',
    latvian: 'tiesa, tiesas ēka',
    polish: 'sąd (budynek)',
    french: 'palais de justice',
    spanish: 'tribunal, corte',
  },
  {
    av: 23052,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(public room + judgement, law (in combinations))',
    english: 'court, courtroom',
    swedish: 'rättssal',
    norwegian: 'rett, rettslokale',
    finnish: 'oikeussali',
    hungarian: 'tárgyalóterem',
    german: 'Gericht, Gerichtshof',
    dutch: 'gerechtszaal',
    afrikaans: 'hofsaal',
    russian: 'зал суда',
    latvian: 'tiesas zāle',
    polish: 'sala sądowa',
    french: 'cour (tribunal)',
    spanish: 'tribunal',
  },
  {
    av: 23053,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(crab, shellfish with claws + small)',
    english: 'crayfish',
    swedish: 'kräfta',
    norwegian: 'kreps',
    finnish: 'rapu',
    hungarian: 'rák, folyami rák, édesvízi rák',
    german: 'Languste, Krebs',
    dutch: 'rivierkreeft',
    afrikaans: 'kreef',
    russian: 'рак',
    latvian: 'vēzis (saldūdens vēzis)',
    polish: 'rak (zwierzę)',
    french: 'écrevisse',
    spanish: 'cangrejo de río',
  },
  {
    av: 23054,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(24 + hour)',
    english: 'day and night',
    swedish: 'dygn',
    norwegian: 'døgn',
    finnish: 'vuorokausi',
    hungarian: 'éjjel-nappal, 24 órán át',
    german: '24 Stunden, (ganzer) Tag, Tag und Nacht',
    dutch: 'dag en nacht, etmaal',
    afrikaans: 'dag en nag',
    russian: 'сутки',
    latvian: 'diennakts',
    polish: 'doba, dzień i noc, 24 godziny',
    french: 'jour et nuit, 24 h',
    spanish: 'día y noche',
  },
  {
    av: 23055,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity centre + day)',
    english: 'day centre',
    swedish: 'dagcentral',
    norwegian: 'dagsenter',
    finnish: 'päivätoimintakeskus',
    hungarian: 'napközi',
    german: 'Tagesstätte, Tageszentrum',
    dutch: 'dagcentrum',
    afrikaans: 'dagsentrum',
    russian: 'дневной центр',
    latvian: 'dienas centrs (dienas aprūpes centrs)',
    polish: 'dzienne centrum, ośrodek terapii zajęciowej, świetlica',
    french: 'centre de jour',
    spanish: 'centro diurno',
  },
  {
    av: 23056,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + protection)',
    english: 'care, protection, defence',
    swedish: 'omsorg, beskydd, försvar',
    norwegian: 'omsorg, beskyttelse, forsvar',
    finnish: 'puolustus',
    hungarian: 'megvédés, oltalmazás, törődés',
    german: 'Pflege, Betreuung',
    dutch: 'verdediging, bescherming, zorg',
    afrikaans: 'sorg, beskerming, verdediging',
    russian: 'забота',
    latvian: 'rūpes, rūpēšanās, aizsargāšana',
    polish: 'obrona czynna, ochrona',
    french: 'protection, défense, soin',
    spanish: 'defensa, protección',
  },
  {
    av: 23057,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to speak + todefend + judgement, law (in combinations))',
    english: 'defence (legal)',
    swedish: 'försvar (juridiskt)',
    norwegian: 'forsvar (juridisk)',
    finnish: 'puolustus (oikeudessa)',
    hungarian: 'jogi védelem',
    german: 'Verteidigung (Gericht)',
    dutch: 'verdediging (in rechtszaak)',
    afrikaans: 'verdedig (wetlike)',
    russian: 'правовая защита',
    latvian: 'aizstāvība',
    polish: 'obrona prawna, obrona przed sądem',
    french: 'défense (légale)',
    spanish: 'defensa (legal)',
  },
  {
    av: 23058,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to speak + to protect)',
    english: 'defence (spoken)',
    swedish: 'försvar (muntligt)',
    norwegian: 'forsvar (muntlig)',
    finnish: 'puolustuspuhe',
    hungarian: 'védőbeszéd, valaki védelmében szólás',
    german: 'Verteidigung (mündlich)',
    dutch: 'verdediging (mondeling)',
    afrikaans: 'verdedig (gesproke)',
    russian: 'защита (вербально)',
    latvian: 'aizstāvēšana',
    polish: 'obrona słowna',
    french: 'défense (orale)',
    spanish: 'defensa (hablada)',
  },
  {
    av: 23059,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(defence + action indicator)',
    english: 'care, protect, defend-(to)',
    swedish: 'ha omsorg om, beskydda, försvara',
    norwegian: 'ha omsorg for, beskytte, forsvare',
    finnish: 'puolustaa',
    hungarian: 'megvédeni, oltalmazni, törődni',
    german: 'sorgen (für), kümmern (um)',
    dutch: 'verdedigen, beschermen, zorgen',
    afrikaans: 'sorg, beskerm, verdedig (om te)',
    russian: 'защищать, заботиться',
    latvian: 'rūpes, aizsardzība, aizsargāšana',
    polish: 'bronić, chronić',
    french: 'protéger, défendre, prendre soin',
    spanish: 'defender, proteger',
  },
  {
    av: 23060,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(defence (legal) + action indicator)',
    english: 'defend (legal)-(to)',
    swedish: 'försvara (juridiskt)',
    norwegian: 'forsvare (juridisk)',
    finnish: 'puolustaa (oikeudessa)',
    hungarian: 'jogi védelmet nyújtani',
    german: '(vor Gericht) verteidigen',
    dutch: 'verdedigen (in rechtszaak)',
    afrikaans: 'verdedig (om te)',
    russian: 'защищать права',
    latvian: 'aizstāvēt (juridiski)',
    polish: 'bronić przed sądem',
    french: 'défendre (en justice)',
    spanish: 'defender (legal)',
  },
  {
    av: 23061,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(defence (spoken) + action indicator)',
    english: 'defend (speak)-(to)',
    swedish: 'försvara (muntligt)',
    norwegian: 'forsvare (muntlig)',
    finnish: 'pitää puolustuspuhe',
    hungarian: 'megvédeni (szóban)',
    german: '(jemanden) verteidigen, (für jemanden) argumentieren',
    dutch: 'verdedigen (mondeling)',
    afrikaans: 'verdedig (gesproke) (om te)',
    russian: 'защищать (вербально)',
    latvian: 'aizstāvēšana (juridiska)',
    polish: 'bronić (słownie)',
    french: 'défendre (en paroles)',
    spanish: 'defender (hablando)',
  },
  {
    av: 23062,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(defence (spoken) + judgement, law (in combinations) + action indicator)',
    english: 'defend (speak, legal)-(to)',
    swedish: 'försvara (muntligt, juridiskt)',
    norwegian: 'forsvare (muntlig, juridisk)',
    finnish: 'puolustaa (oikeudessa)',
    hungarian: 'védőbeszédet tartani, jogilag védeni',
    german: '(vor Gericht) verteidigen',
    dutch: 'verdedigen (mondeling in rechtszaak)',
    afrikaans: 'verdedig (gesproke) (om te)',
    russian: 'защищать права (вербально)',
    latvian: 'aizstāvēt (juridiski)',
    polish: 'bronić się słownie przed sądem',
    french: 'défendre en justice (oralement)',
    spanish: 'defender (hablando legalmente)',
  },
  {
    av: 23063,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + care, protection, defence)',
    english: 'caregiver, protector, defender',
    swedish: 'omsorgsgivare, beskyddare, försvarare',
    norwegian: 'omsorgsgiver, beskytter, forsvarer',
    finnish: 'puolustusasianajaja',
    hungarian: 'gondozó, oltalmaz, pártfogó',
    german: 'Verteidiger, Verteidigerin',
    dutch: 'verdediger, verdedigend advocaat, raadsman, pleitbezorger',
    afrikaans: 'versorger, beskermer, verdediger',
    russian: 'воспитатель, покровитель, защитник',
    latvian: 'aprūpētājs, aizbildnis, aizstāvis',
    polish: 'obrońca (ktoś kto chroni)',
    french: 'protecteur, défenseur',
    spanish: 'protector, defensor',
  },
  {
    av: 23064,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(value + money + plus: money will be worth more)',
    english: 'deflation',
    swedish: 'deflation',
    norwegian: 'deflasjon',
    finnish: 'deflaatio, rahan arvon nousu',
    hungarian: 'defláció (árszint csökkenés)',
    german: 'Deflation',
    dutch: 'deflatie',
    afrikaans: 'deflasie',
    russian: 'дефляция',
    latvian: 'deflācija',
    polish: 'deflacja (wzrost wartości pieniądza)',
    french: 'déflation',
    spanish: 'deflación',
  },
  {
    av: 23065,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(action, demonstration (against) + action indicator)',
    english: 'act, demonstrate (against)-(to)',
    swedish: 'agera, demonstrera (mot)',
    norwegian: 'demonstrere (mot), aksjonere',
    finnish: 'demonstroida, osoittaa mieltä',
    hungarian: 'tenni, cselekedni valami ellen, demonstrálni',
    german: 'agieren, demonstrieren (gegen)',
    dutch: 'demonstreren, betogen',
    afrikaans: 'betoog (om te)',
    russian: 'демонстрировать',
    latvian: 'demonstrācija (paust viedokli pret kaut ko)',
    polish: 'demonstrować przeciwko …',
    french: 'manifester (contre)',
    spanish: 'manifestarse (en contra)',
  },
  {
    av: 23066,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + opposition, counter purpose)',
    english: 'action, demonstration (against)',
    swedish: 'aktion, demonstration (mot)',
    norwegian: 'demonstrasjon (mot), aksjon',
    finnish: 'demonstraatio, mielenosoitus',
    hungarian: 'tevékenység valami ellenében, demonstráció',
    german: 'Einspruch, Widerspruch, Protest',
    dutch: 'demonstratie, betoging',
    afrikaans: 'betoging',
    russian: 'демонстрация',
    latvian: 'akcija, demonstrācija (pret kaut ko)',
    polish: 'demonstracja, protest',
    french: 'manifestion (contre)',
    spanish: 'manifestación (en contra)',
  },
  {
    av: 23067,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + many + part)',
    english: 'department store',
    swedish: 'varuhus',
    norwegian: 'varehus',
    finnish: 'tavaratalo',
    hungarian: 'áruház',
    german: 'Kaufhaus',
    dutch: 'warenhuis',
    afrikaans: 'pakhuis',
    russian: 'универмаг',
    latvian: 'universālveikals',
    polish: 'dom towarowy, sklep wielobranżowy (ośrodek ze sklepikami o różnym asortymencie)',
    french: 'grand magasin',
    spanish: 'grandes almacenes',
  },
  {
    av: 23068,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(price + minus)',
    english: 'discount',
    swedish: 'rabatt, avdrag',
    norwegian: 'prisreduksjon, avslag (pris)',
    finnish: 'hinnanalennus',
    hungarian: 'árengedmény, árkedvezmény, leárazás',
    german: 'Diskont, Abschlag (Finanzen), Rabatt',
    dutch: 'korting',
    afrikaans: 'afslag',
    russian: 'скидка',
    latvian: 'atlaide, diskonts',
    polish: 'rabat, obniżka, zniżka',
    french: 'remise, rabais, ristourne',
    spanish: 'descuento',
  },
  {
    av: 23069,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + discount)',
    english: 'discount sale',
    swedish: 'realisation',
    norwegian: 'utsalg',
    finnish: 'alennusmyynti',
    hungarian: 'árengedményes akció',
    german: 'Verkauf',
    dutch: 'uitverkoop, solden (periode) (Vl)',
    afrikaans: 'uitverkoping',
    russian: 'распродажа',
    latvian: 'atlaides, izpārdošana',
    polish: 'wyprzedaż, sprzedaż z rabatem',
    french: 'soldes',
    spanish: 'ventas con rebaja',
  },
  {
    av: 23070,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + discount [contraction])',
    english: 'discount store',
    swedish: 'lågprisbutik',
    norwegian: 'lavprisbutikk',
    finnish: 'alennusmyymälä, halpahalli',
    hungarian: 'leértékelt áruk boltja, diszkount áruház',
    german: 'Diskontladen',
    dutch: 'discountwinkel',
    afrikaans: 'afslag winkel',
    russian: 'дисконтный магазин',
    latvian: 'nocenoto preču veikals',
    polish: 'sklep ze zniżkami, promocjami',
    french: 'magasin à prix réduits, solderie',
    spanish: 'tienda de precios bajos',
  },
  {
    av: 23072,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + medical)',
    english: 'drugstore, pharmacy',
    swedish: 'apotek',
    norwegian: 'apotek',
    finnish: 'apteekki',
    hungarian: 'gyógyszertár, drogéria',
    german: 'Drogerie, Apotheke',
    dutch: 'apotheek',
    afrikaans: 'apteek',
    russian: 'аптека',
    latvian: 'aptieka',
    polish: 'apteka',
    french: 'pharmacie',
    spanish: 'droguería, farmacia',
  },
  {
    av: 23073,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(protection with pointer + thing indicator: roof with a pointer to the eaves) - (character with thing indicator)',
    english: 'eaves',
    swedish: 'takfot, takskägg',
    norwegian: 'takskjegg',
    finnish: 'räystäs',
    hungarian: 'eresz, csurgó',
    german: 'Dachrinne',
    dutch: 'dakrand',
    afrikaans: 'dakrand',
    russian: 'карниз',
    latvian: 'dzega',
    polish: 'okap',
    french: 'corniche',
    spanish: 'alero',
  },
  {
    av: 23074,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + business)',
    english: 'economics (class)',
    swedish: 'ekonomi (skolämne)',
    norwegian: 'økonomifag',
    finnish: 'taloustiede (kouluaine)',
    hungarian: 'közgazdaságtan (tantárgy)',
    german: 'Wirtschaftswissenschaften',
    dutch: 'economie (les)',
    afrikaans: 'ekonomie (klas)',
    russian: 'экономика (предмет)',
    latvian: 'ekonomiskā klase',
    polish: 'ekonomiczny, gospodarczy (kategoria)',
    french: "cours d'économie",
    spanish: 'economía (clase)',
  },
  {
    av: 23075,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + electricity + thing indicator)',
    english: 'electricity meter',
    swedish: 'elmätare',
    norwegian: 'strømmåler',
    finnish: 'sähkömittari',
    hungarian: 'villanyóra, elektromosság mérő',
    german: 'Voltmeter, Spannungsmesser',
    dutch: 'elektriciteitsmeter',
    afrikaans: 'elektrisiteits meter',
    russian: 'электросчётчик',
    latvian: 'elektrības skaitītājs',
    polish: 'licznik energii elektrycznej',
    french: 'compteur électrique',
    spanish: 'medidor de electricidad',
  },
  {
    av: 23076,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(school [contr.] + child) Use appropriate specifier for other stages of schools',
    english: 'elementary school, primary school',
    swedish: 'grundskola (låg- och mellanstadiet)',
    norwegian: 'grunnskole',
    finnish: 'peruskoulu',
    hungarian: 'általános iskola',
    german: 'Grundschule',
    dutch: 'lagere school, basisschool',
    afrikaans: 'laerskool',
    russian: 'начальная школа',
    latvian: 'pamatskola',
    polish: 'szkoła podstawowa',
    french: 'école primaire',
    spanish: 'escuela de primaria',
  },
  {
    av: 23077,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + English)',
    english: 'English (class)',
    swedish: 'engelska (skolämne)',
    norwegian: 'engelskfag',
    finnish: 'englanti (kouluaine)',
    hungarian: 'angol nyelv (tantárgy)',
    german: 'Englischunterricht',
    dutch: 'Engels (les)',
    afrikaans: 'Engels (les)',
    russian: 'английский язык (предмет)',
    latvian: 'angļu valodas nodarbība',
    polish: 'angielski (kategoria)',
    french: "cours d'anglais",
    spanish: 'Inglés (clase)',
  },
  {
    av: 23078,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + England [contr.])',
    english: 'English (language)',
    swedish: 'engelska',
    norwegian: 'engelsk',
    finnish: 'englanti (kieli)',
    hungarian: 'angol nyelv',
    german: 'Englisch (Sprache)',
    dutch: 'Engels (taal)',
    afrikaans: 'Engels (taal)',
    russian: 'английский язык',
    latvian: 'angļu valoda ',
    polish: 'język angielski',
    french: 'anglais (langue)',
    spanish: 'Inglés (idioma)',
  },
  {
    av: 23079,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fact + judgement, law (in combinations))',
    english: 'evidence',
    swedish: 'bevis',
    norwegian: 'bevis',
    finnish: 'todiste, todistuskappale',
    hungarian: 'bizonyíték, tanújel',
    german: 'Beweisstück, Anhaltspunkt',
    dutch: 'bewijsmateriaal',
    afrikaans: 'bewyse',
    russian: 'доказательство',
    latvian: 'pierādījums, liecība',
    polish: 'dowód, świadectwo winy',
    french: 'preuve, témoignage',
    spanish: 'prueba, evidencia',
  },
  {
    av: 23080,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(price + big + description indicator) Preferred NEW SYNONYM, replacing 14129',
    english: 'expensive',
    swedish: 'dyr',
    norwegian: 'kostbar, dyr (høy pris)',
    finnish: 'kallis',
    hungarian: 'drága, költséges',
    german: 'teuer',
    dutch: 'duur',
    afrikaans: 'duur',
    russian: 'дорогой',
    latvian: 'dārgs',
    polish: 'drogo',
    french: 'cher, coûteux',
    spanish: 'caro',
  },
  {
    av: 23081,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(judgement + same/equal + description indicator)',
    english: 'just, fair',
    swedish: 'rättvis',
    norwegian: 'rettferdig',
    finnish: 'oikeudenmukainen',
    hungarian: 'igazságos, pártatlan',
    german: 'gerecht, fair',
    dutch: 'fair, rechtvaardig, eerlijk',
    afrikaans: 'regverdig',
    russian: 'справедливый',
    latvian: 'godīgs',
    polish: 'sprawiedliwy, uczciwy',
    french: 'juste, équitable',
    spanish: 'justo, equitativo',
  },
  {
    av: 23082,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + after + guilt)',
    english: 'fine (penalty)',
    swedish: 'böter, bot',
    norwegian: 'bot, mulkt',
    finnish: 'sakko',
    hungarian: 'bírság, pénzbírság, pénzbüntetés',
    german: 'Strafzettel, Strafmandat',
    dutch: 'boete, bekeuring',
    afrikaans: 'boete',
    russian: 'штраф',
    latvian: 'sods, soda nauda',
    polish: 'grzywna (kara)',
    french: 'amende, contravention',
    spanish: 'multa',
  },
  {
    av: 23083,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + low)',
    english: 'flatfish',
    swedish: 'plattfisk',
    norwegian: 'flatfisk',
    finnish: 'kampela',
    hungarian: 'lepényhal',
    german: 'Plattfisch, Flunder',
    dutch: 'platvis',
    afrikaans: 'platvis',
    russian: 'камбала',
    latvian: 'plakanzivs (plekste, bute u.c.)',
    polish: 'płaszczka, płastuga',
    french: 'poisson plat',
    spanish: 'lenguado',
  },
  {
    av: 23084,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(material + stalk + cloth: textile fibre made from the stalk of the flax plant)',
    english: 'flax',
    swedish: 'lin, linne',
    norwegian: 'lin',
    finnish: 'pellava',
    hungarian: 'len',
    german: 'Flachs',
    dutch: 'vlas',
    afrikaans: 'vlas',
    russian: 'лён',
    latvian: 'lins',
    polish: 'len',
    french: 'lin (matière)',
    spanish: 'lino',
  },
  {
    av: 23086,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(storey + 42) Use appropriate number for other floors.',
    english: 'floor (42nd)',
    swedish: 'våning (nr 42)',
    norwegian: 'etasje (42.)',
    finnish: 'kerros neljäkymmentäkaksi, neljäskymmenestoinen kerros',
    hungarian: 'emelet (valahányadik)',
    german: 'Stockwerk (42. Stock)',
    dutch: 'etage (42ste), verdieping (42ste)',
    afrikaans: 'verdieping (42ste), vloer',
    russian: 'этаж (к примеру 42-й)',
    latvian: 'stāvā (piem., 42. stāvā)',
    polish: 'piętro numer ... (liczba może być zmieniana, chodzi o zasadę numeracji pieter)',
    french: 'étage 42',
    spanish: 'planta (42)',
  },
  {
    av: 23087,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(storey + one) Use appropriate number for other floors.',
    english: 'floor (first)',
    swedish: 'våning (första)',
    norwegian: 'etasje (første)',
    finnish: 'pohjakerros, katutaso, ensimmäinen kerros',
    hungarian: 'földszint (USA: első emelet)',
    german: 'Stockwerk (1. Stock)',
    dutch: 'etage, gelijksvloers (Vl)',
    afrikaans: 'vloer (eerste)',
    russian: 'этаж (первый)',
    latvian: 'stāvs (piem., pirmais stāvs)',
    polish: 'piętro (pierwsze)',
    french: 'rez-de-chaussée',
    spanish: 'planta (primera)',
  },
  {
    av: 23088,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + flower)',
    english: 'florist',
    swedish: 'blomsteraffär',
    norwegian: 'blomsterbutikk',
    finnish: 'kukkakauppa',
    hungarian: 'virágbolt',
    german: 'Florist, Floristin',
    dutch: 'bloemist, bloemenwinkel',
    afrikaans: 'bloemiste',
    russian: 'цветочный магазин',
    latvian: 'ziedu veikals',
    polish: 'kwiaciarnia',
    french: 'magasin de fleurs',
    spanish: 'florista',
  },
  {
    av: 23090,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + gasoline + thing indicator)',
    english: 'fuel gauge',
    swedish: 'bränslemätare',
    norwegian: 'brenselmåler',
    finnish: 'polttoainemittari',
    hungarian: 'üzemanyag mérő',
    german: 'Benzinanzeige, Füllstandsanzeige',
    dutch: 'brandstofmeter',
    afrikaans: 'brandstofmeter',
    russian: 'датчик уровня топлива',
    latvian: 'degvielas skaitītājs',
    polish: 'wskaźnik poziomu benzyny, paliwa',
    french: 'jauge à essence',
    spanish: 'medidor de gasolina',
  },
  {
    av: 23091,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + garden)',
    english: 'garden centre',
    swedish: 'trädgårdscentrum',
    norwegian: 'hagesenter',
    finnish: 'puutarhakeskus',
    hungarian: 'kertészeti áruház, kert-centrum, kertészbolt',
    german: 'Gärtnerei',
    dutch: 'tuincentrum',
    afrikaans: 'tuinsentrum',
    russian: 'садовый центр',
    latvian: 'dārzkopības preču veikals',
    polish: 'centrum ogrodnicze, sklep ogrodniczy',
    french: 'jardinerie',
    spanish: 'vivero',
  },
  {
    av: 23092,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(scale, measurement + thing indicator) - (character with thing indicator)',
    english: 'gauge, gage, meter',
    swedish: 'mätinstrument',
    norwegian: 'måleinstrument',
    finnish: 'mittari',
    hungarian: 'mérce',
    german: 'Messgerät',
    dutch: 'meter (instrument), meetinstrument',
    afrikaans: 'meter',
    russian: 'измерительный прибор',
    latvian: 'skaitītājs',
    polish: 'miernik, wskaźnik',
    french: 'jauge',
    spanish: 'medidor, calibre',
  },
  {
    av: 23093,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(body of learning + earth)',
    english: 'geography',
    swedish: 'geografi',
    norwegian: 'geografi',
    finnish: 'maantiede',
    hungarian: 'földrajz',
    german: 'Erdkunde, Geographie',
    dutch: 'aardrijkskunde',
    afrikaans: 'aardrykskunde',
    russian: 'география',
    latvian: 'ģeogrāfija',
    polish: 'geografia',
    french: 'géographie (science)',
    spanish: 'geografía',
  },
  {
    av: 23094,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + geography [contr.])',
    english: 'geography (class)',
    swedish: 'geografi (skolämne)',
    norwegian: 'geografifag',
    finnish: 'maantieto (kouluaine)',
    hungarian: 'földrajz (tantárgy)',
    german: 'Erdkundeunterricht, Geographiestunde, Geographieunterricht',
    dutch: 'aardrijkskunde (les)',
    afrikaans: 'aardrykskunde (les)',
    russian: 'география (предмет)',
    latvian: 'ģeogrāfijas nodarbība',
    polish: 'geograficzny (kategoria)',
    french: 'cours de géographie',
    spanish: 'geografía (clase)',
  },
  {
    av: 23095,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + earth: scientific study of the origins, history and structure of the earth)',
    english: 'geology (class)',
    swedish: 'geologi (skolämne)',
    norwegian: 'geologifag',
    finnish: 'maantieto (kouluaine)',
    hungarian: 'földtan, geológia (tantárgy)',
    german: 'Geologie',
    dutch: 'geologie (les)',
    afrikaans: 'geologie (les)',
    russian: 'геология (предмет)',
    latvian: 'ģeoloģijas nodarbība',
    polish: 'geologiczny (kategoria)',
    french: 'cours de géologie',
    spanish: 'geología (clase)',
  },
  {
    av: 23096,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + gift)',
    english: 'gift shop',
    swedish: 'presentaffär',
    norwegian: 'gavebutikk',
    finnish: 'lahjatavaraliike',
    hungarian: 'ajándékbolt',
    german: 'Geschenkeladen',
    dutch: 'cadeauwinkel',
    afrikaans: 'geskenk winkel',
    russian: 'магазин подарков',
    latvian: 'dāvanu veikals',
    polish: 'sklep z upominkami, pamiątkami',
    french: 'boutique de cadeaux',
    spanish: 'tienda de regalos',
  },
  {
    av: 23098,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(God + father)',
    english: 'God the father',
    swedish: 'Gud Fader, Fadern',
    norwegian: 'Gud Fader',
    finnish: 'Jumala (isä)',
    hungarian: 'Isten, az atya',
    german: 'Gott, Göttin',
    dutch: 'God de vader',
    afrikaans: 'God die Vader',
    russian: 'Бог Отец',
    latvian: 'Dievs Tēvs',
    polish: 'Bóg Ojciec',
    french: 'Dieu le père',
    spanish: 'Dios padre',
  },
  {
    av: 23099,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(God + son)',
    english: 'God the son',
    swedish: 'Guds Son, Sonen',
    norwegian: 'Guds Sønn',
    finnish: 'Jumala (poika)',
    hungarian: 'Isten, a Fiú',
    german: 'Christus, Jesus',
    dutch: 'God de zoon',
    afrikaans: 'God die Seun',
    russian: 'Бог Сын',
    latvian: 'Dievs Dēls',
    polish: 'Syn Boży',
    french: 'Dieu le fils',
    spanish: 'Dios hijo',
  },
  {
    av: 23100,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(metal [contr.] + ring)',
    english: 'gold',
    swedish: 'guld',
    norwegian: 'gull',
    finnish: 'kulta',
    hungarian: 'arany',
    german: 'Gold (Material)',
    dutch: 'goud',
    afrikaans: 'goud',
    russian: 'золото',
    latvian: 'zelts',
    polish: 'złoto',
    french: 'or',
    spanish: 'oro',
  },
  {
    av: 23101,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + vegetable)',
    english: 'greengrocer',
    swedish: 'grönsaksaffär',
    norwegian: 'grønnsaksbutikk',
    finnish: 'vihanneskauppa',
    hungarian: 'zöldségbolt',
    german: 'Gemüsehändler',
    dutch: 'groentewinkel',
    afrikaans: 'groentewinkel',
    russian: 'овощной магазин',
    latvian: 'dārzeņu veikals',
    polish: 'warzywniak, sklep z warzywami',
    french: 'magasin de primeurs, magasin de fruits et légumes',
    spanish: 'verdulero',
  },
  {
    av: 23102,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + food) Preferred NEW SYNONYM, replacing 14645',
    english: 'grocery store, food store, supermarket',
    swedish: 'livsmedelsbutik, mataffär, stormarknad',
    norwegian: 'matbutikk, supermarked',
    finnish: 'ruokakauppa, marketti',
    hungarian: 'élelmiszerbolt, szupermarket, közért',
    german: 'Supermarkt, Lebensmittelgeschäft, Lebensmittelladen',
    dutch: 'supermarkt',
    afrikaans: 'kruidenierswinkel, kruidenierswarewinkel, supermark',
    russian: 'магазин продуктовый, супермаркет',
    latvian: 'produktu veikals, lielveikals',
    polish: 'sklep spożywczy',
    french: "magasin d'alimentation, épicerie",
    spanish: 'tienda de alimentos, supermercado',
  },
  {
    av: 23103,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + eaves + thing indicator)',
    english: 'gutter, eaves trough',
    swedish: 'takränna',
    norwegian: 'takrenne',
    finnish: 'räystäskouru, sadevesikouru',
    hungarian: 'csatorna, esővízcsatorna',
    german: 'Dachrinne',
    dutch: 'dakgoot',
    afrikaans: 'geut',
    russian: 'жёлоб, водосток',
    latvian: 'noteka, notekcaurule, tekne',
    polish: 'rynna, ściek',
    french: 'gouttière',
    spanish: 'cuneta, aleros',
  },
  {
    av: 23104,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(30 + minute)',
    english: 'half an hour',
    swedish: 'halvtimma',
    norwegian: 'halvtime',
    finnish: 'puoli tuntia',
    hungarian: 'félóra',
    german: 'halbe Stunde',
    dutch: 'half uur',
    afrikaans: 'half uur',
    russian: 'полчаса',
    latvian: 'pusstunda',
    polish: 'pół godziny, 30 minut',
    french: 'demi-heure',
    spanish: 'media hora',
  },
  {
    av: 23105,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + between + room: space between rooms)',
    english: 'hall',
    swedish: 'hall',
    norwegian: 'hall',
    finnish: 'halli, aula',
    hungarian: 'hall, átjáró',
    german: 'Flur, Korridor',
    dutch: 'hall',
    afrikaans: 'saal',
    russian: 'холл, зал',
    latvian: 'zāle, vestibils',
    polish: 'korytarz',
    french: 'vestibule, couloir',
    spanish: 'sala',
  },
  {
    av: 23106,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + craft)',
    english: 'handicraft shop',
    swedish: 'hemslöjdsaffär',
    norwegian: 'husflidsbutikk',
    finnish: 'käsityökauppa',
    hungarian: 'kézműves bolt, iparművészeti bolt',
    german: 'Handarbeitsladen, Kunsthandwerksladen',
    dutch: 'handwerkwinkel, winkel (zelfgemaakte voorw.)',
    afrikaans: 'handwerk winkel',
    russian: 'ремесленная лавка',
    latvian: 'rokdarbu veikals',
    polish: 'sklep z rękodziełem',
    french: "magasin d'artisanat, boutique d'artisanat",
    spanish: 'tienda de artesanías',
  },
  {
    av: 23107,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knowledge (class [contr.]) + write + hand)',
    english: 'handwriting, penmanship (class)',
    swedish: 'välskrivning, skrivstil (skolämne)',
    norwegian: 'skrivefag, skjønnskrift',
    finnish: 'kaunokirjoitus (kouluaine)',
    hungarian: 'szépírás és külalak (tantárgy)',
    german: 'Handschrift (Unterricht)',
    dutch: 'schoon schrift (les)',
    afrikaans: 'handskrif, manier van skryf (les)',
    russian: 'чистописание (предмет)',
    latvian: 'glītrakstīšana, kaligrāfijas nodarbība',
    polish: 'charakter pisma, grafologia (kategoria)',
    french: 'cours de calligraphie',
    spanish: 'escritura a mano, caligrafía (clase)',
  },
  {
    av: 23108,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + health)',
    english: 'health goods shop',
    swedish: 'hälsokostaffär',
    norwegian: 'helsekostbutikk',
    finnish: 'luontaistuotekauppa',
    hungarian: 'gyógytermékek boltja, egészség-bolt, fitotéka',
    german: 'Bioladen',
    dutch: 'winkel (gezondheidsvoorwerpen)',
    afrikaans: 'gesondheids winkel',
    russian: 'магазин здорового питания',
    latvian: 'veselīgas pārtikas veikals',
    polish: 'sklep ze zdrową żywnością, ekologiczny',
    french: 'magasin de diététique',
    spanish: 'parafarmacia',
  },
  {
    av: 23109,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knowledge (class [contr.]) + Hebrew)',
    english: 'Hebrew (class)',
    swedish: 'hebreiska (skolämne)',
    norwegian: 'hebraisk (fag)',
    finnish: 'hebrea (kouluaine)',
    hungarian: 'héber nyelv (tantárgy)',
    german: 'Hebräischunterricht',
    dutch: 'Hebreeuws (les)',
    afrikaans: 'Hebreeus (les)',
    russian: 'еврейский язык (предмет)',
    latvian: 'ebreju valodas nodarbība',
    polish: 'hebrajski, żydowski (kategoria)',
    french: "cours d'hébreu",
    spanish: 'Hebreo (clase)',
  },
  {
    av: 23110,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + Jewish (Israel [contr.]))',
    english: 'Hebrew (language)',
    swedish: 'hebreiska',
    norwegian: 'hebraisk',
    finnish: 'hebrea (kieli)',
    hungarian: 'héber nyelv',
    german: 'Hebräisch (Sprache)',
    dutch: 'Hebreeuws (taal)',
    afrikaans: 'Hebreeus (taal)',
    russian: 'еврейский язык ',
    latvian: 'ebreju valoda ',
    polish: 'hebrajski język',
    french: 'hébreu (langue)',
    spanish: 'Hebreo (idioma)',
  },
  {
    av: 23111,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plant + taste)',
    english: 'herb, spice plant',
    swedish: 'kryddväxt',
    norwegian: 'urteplante',
    finnish: 'maustekasvi, yrtti',
    hungarian: 'gyógynövény, fűszernövény',
    german: 'Kraut',
    dutch: 'kruid',
    afrikaans: 'kruie, spesery plant',
    russian: 'пряное растение',
    latvian: 'augs, garšvielas augs',
    polish: 'zioło, pachnąca roślina',
    french: 'plante aromatique, herbe aromatique',
    spanish: 'hierba, planta de especias',
  },
  {
    av: 23112,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knowledge + past: (class [contr.] + history [contr.])',
    english: 'history (class)',
    swedish: 'historia (skolämne)',
    norwegian: 'historiefag',
    finnish: 'historia (kouluaine)',
    hungarian: 'történelem (tantárgy)',
    german: 'Geschichtsunterricht',
    dutch: 'geschiedenis',
    afrikaans: 'geskiedenis (les)',
    russian: 'история (предмет)',
    latvian: 'vēstures nodarbība',
    polish: 'historyczny (kategoria)',
    french: "cours d'histoire",
    spanish: 'historia (clase)',
  },
  {
    av: 23113,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + history (class): teacher [contr.] + history [contr.])',
    english: 'history teacher',
    swedish: 'historielärare',
    norwegian: 'historielærer',
    finnish: 'historian opettaja',
    hungarian: 'történelem tanár',
    german: 'Geschichtslehrer, Geschichtslehrerin',
    dutch: 'geschiedenisleraar',
    afrikaans: 'geskiedenis onderwyser',
    russian: 'учитель истории',
    latvian: 'vēstures skolotājs',
    polish: 'nauczyciel historii',
    french: "professeur d'histoire",
    spanish: 'profesor de historia',
  },
  {
    av: 23114,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(God + fire)',
    english: 'Holy Spirit',
    swedish: 'Anden, Den Helige Ande',
    norwegian: 'Den Hellige Ånd',
    finnish: 'pyhä henki',
    hungarian: 'Szentlélek',
    german: 'Heilige Geist',
    dutch: 'Heilige Geest',
    afrikaans: 'Heilige Gees',
    russian: 'Святой Дух',
    latvian: 'Svētais Gars',
    polish: 'Duch Święty',
    french: 'Saint-Esprit',
    spanish: 'Espíritu Santo',
  },
  {
    av: 23115,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(God + three + life)',
    english: 'Holy Trinity',
    swedish: 'treenigheten',
    norwegian: 'treenighet',
    finnish: 'pyhä kolminaisuus',
    hungarian: 'Szentháromság',
    german: 'Dreieinigkeit',
    dutch: 'Drie-eenheid (christelijk)',
    afrikaans: 'Drie-eenheid (Heilige)',
    russian: 'Пресвятая Троица',
    latvian: 'Svētā Trīsvienība',
    polish: 'Święta Trójca',
    french: 'Sainte-Trinité',
    spanish: 'sagrada trinidad',
  },
  {
    av: 23116,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(horizontal-(a) + description indicator)',
    english: 'horizontal',
    swedish: 'vågrät, horisontell',
    norwegian: 'horisontal',
    finnish: 'vaakasuora, horisontaalinen',
    hungarian: 'vízszintes, horizontális (mn.)',
    german: 'horizantal, waagerecht',
    dutch: 'horizontaal (bijv.nw)',
    afrikaans: 'horisontaal, horisontale',
    russian: 'горизонтальный',
    latvian: 'horizontāls',
    polish: 'poziomy, horyzontalny',
    french: 'horizontal',
    spanish: 'horizontal',
  },
  {
    av: 23118,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + law + description indicator)',
    english: 'illegal, criminal',
    swedish: 'olaglig',
    norwegian: 'ulovlig, kriminell, illegal',
    finnish: 'laiton, lainvastainen',
    hungarian: 'törvénytelen, illegális, kriminális',
    german: 'unerlaubt, ungesetzlich, illegal',
    dutch: 'crimineel, misdadig',
    afrikaans: 'onwettig, onwettige, krimineel, kriminele, misdadiger',
    russian: 'нелегальный, незаконный',
    latvian: 'pretlikumīgs, nelegāls, krimināls',
    polish: 'nielegalne, przestępcze, kryminalne',
    french: 'illégal',
    spanish: 'ilegal',
  },
  {
    av: 23119,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(value + money + minus: money will be worth less)',
    english: 'inflation',
    swedish: 'inflation',
    norwegian: 'inflasjon',
    finnish: 'inflaatio, rahan arvon lasku',
    hungarian: 'infláció, árszint emelkedés',
    german: 'Inflation, Preisanstieg',
    dutch: 'inflatie',
    afrikaans: 'inflasie',
    russian: 'инфляция',
    latvian: 'inflācija',
    polish: 'inflacja ',
    french: 'inflation',
    spanish: 'inflación',
  },
  {
    av: 23120,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(judgement + positive: in a trial a person who is judged positively is judged not guilty)',
    english: 'innocence',
    swedish: 'oskuld (utan skuld)',
    norwegian: 'uskyld (juridisk)',
    finnish: 'viattomuus, syyttömyys',
    hungarian: 'ártatlanság',
    german: 'Unschuld',
    dutch: 'onschuld',
    afrikaans: 'onskuld',
    russian: 'невиновность',
    latvian: 'nevainība',
    polish: 'niewinność',
    french: 'innocence',
    spanish: 'inocencia',
  },
  {
    av: 23121,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(innocence + description indicator)',
    english: 'innocent, not guilty',
    swedish: 'oskyldig',
    norwegian: 'uskyldig',
    finnish: 'viaton, syytön',
    hungarian: 'ártatlan, nem bűnös',
    german: 'unschuldig',
    dutch: 'onschuldig',
    afrikaans: 'onskuld, onskuldig',
    russian: 'невиновный',
    latvian: 'nevainīgs, nav vainīgs',
    polish: 'niewinny',
    french: 'innocent, non coupable',
    spanish: 'inocente, no culpable',
  },
  {
    av: 23122,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(metal [contr.] + nail)',
    english: 'iron',
    swedish: 'järn',
    norwegian: 'jern',
    finnish: 'rauta',
    hungarian: 'vas',
    german: 'Eisen',
    dutch: 'staal',
    afrikaans: 'yster',
    russian: 'железо',
    latvian: 'dzelzs',
    polish: 'żelazo',
    french: 'fer',
    spanish: 'hierro',
  },
  {
    av: 23123,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(past time + nail (iron [contr.]))',
    english: 'iron age',
    swedish: 'järnåldern',
    norwegian: 'jernalder',
    finnish: 'rautakausi',
    hungarian: 'vaskor',
    german: 'Eisenzeit',
    dutch: 'ijzeren tijdperk, ijzertijd',
    afrikaans: 'ystertydperk',
    russian: 'железный век',
    latvian: 'dzelzs laikmets',
    polish: 'epoka żelaza',
    french: 'âge du fer',
    spanish: 'edad de hierro',
  },
  {
    av: 23125,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(legal person + above/superior: a person who presides over legal proceedings and hands down a judgement)',
    english: 'judge',
    swedish: 'domare',
    norwegian: 'dommer',
    finnish: 'tuomari',
    hungarian: 'bíró',
    german: 'Richter, Richterin',
    dutch: 'rechter (gerecht)',
    afrikaans: 'regter',
    russian: 'судья',
    latvian: 'tiesnesis',
    polish: 'sędzia',
    french: 'juge',
    spanish: 'juez',
  },
  {
    av: 23126,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(judgement + action indicator)',
    english: 'judge-(to)',
    swedish: 'döma',
    norwegian: 'dømme',
    finnish: 'tuomita',
    hungarian: 'bíráskodni, elbírálni, megítélni',
    german: 'urteilen, beurteilen',
    dutch: 'vonnissen, oordelen, beoordelen, rechtspreken',
    afrikaans: 'oordeel (om te)',
    russian: 'судить',
    latvian: 'tiesāt',
    polish: 'sądzić, rozstrzygać',
    french: 'juger',
    spanish: 'juzgar',
  },
  {
    av: 23128,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(judgement + description indicator)',
    english: 'juridical',
    swedish: 'juridisk',
    norwegian: 'juridisk',
    finnish: 'juridinen, lainopillinen',
    hungarian: 'bírói, törvényes',
    german: 'rechtlich, juristisch',
    dutch: 'juridisch',
    afrikaans: 'juridiese',
    russian: 'законный, юридический',
    latvian: 'tiesisks, ikumīgs, juridisks',
    polish: 'prawne',
    french: 'juridique',
    spanish: 'jurídico',
  },
  {
    av: 23129,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(group of + peer + legal [contr.]: a group of persons equal in standing before the law to the person being tried)',
    english: 'jury',
    swedish: 'nämndemän, jury',
    norwegian: 'jury',
    finnish: 'valamiehistö',
    hungarian: 'esküdtszék, esküdtbíróság',
    german: 'Geschworene (der), Geschworene (die), Schöffe, Schöffin',
    dutch: 'jury (gerecht)',
    afrikaans: 'jurie',
    russian: 'жюри',
    latvian: 'zvērinātie, žūrija',
    polish: 'jury, sędziowie, komisja oceniająca',
    french: 'jury',
    spanish: 'jurado',
  },
  {
    av: 23130,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(judgement + same/equal)',
    english: 'justice',
    swedish: 'rättvisa',
    norwegian: 'rettferdighet',
    finnish: 'oikeus, oikeudenmukaisuus',
    hungarian: 'igazság',
    german: 'Justiz, Gerechtigkeit',
    dutch: 'gerechtigheid, recht (juridisch)',
    afrikaans: 'geregtigheid',
    russian: 'правосудие, справедливость',
    latvian: 'taisnība, taisnīgums',
    polish: 'sprawiedliwość',
    french: 'justice',
    spanish: 'justicia',
  },
  {
    av: 23131,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + language)',
    english: 'language (class)',
    swedish: 'språk (skolämne)',
    norwegian: 'språkfag',
    finnish: 'äidinkieli (kouluaine)',
    hungarian: 'nyelv (tantárgy)',
    german: 'Sprachenklasse',
    dutch: 'taalles',
    afrikaans: 'taalklas',
    russian: 'язык (предмет)',
    latvian: 'valodu nodarbība',
    polish: 'język (kategoria)',
    french: 'cours de langue',
    spanish: 'idioma (clase)',
  },
  {
    av: 23132,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(science, body of learning + judgement, law (in combinations)',
    english: 'law',
    swedish: 'juridik, rättsvetenskap',
    norwegian: 'jus (som vitenskap)',
    finnish: 'lakitiede',
    hungarian: 'jog, jogrend',
    german: 'Jura',
    dutch: 'wet',
    afrikaans: 'wet',
    russian: 'право, юриспруденция',
    latvian: 'likums, noteikumi',
    polish: 'prawo (ogólnie)',
    french: 'droit (science)',
    spanish: 'ley, derecho (ciencia)',
  },
  {
    av: 23133,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(legal [contr.] + paper: judgement put into writing or recorded)',
    english: 'law-(a)',
    swedish: 'lag (juridisk)',
    norwegian: 'lov (juridisk)',
    finnish: 'laki',
    hungarian: 'jogszabály, törvény',
    german: 'Gesetz',
    dutch: 'wet, wetboek',
    afrikaans: "wet ('n)",
    russian: 'закон',
    latvian: 'likums (jurisprudencē)',
    polish: 'prawo (pojedynczy przepis, ustawa)',
    french: 'loi (texte)',
    spanish: 'ley',
  },
  {
    av: 23134,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(judgement + book)',
    english: 'law, The Law',
    swedish: 'lagen, lagbok',
    norwegian: 'lovbok, loven',
    finnish: 'lakikirja',
    hungarian: 'törvénykönyv',
    german: 'Gesetz',
    dutch: 'wet, wetboek',
    afrikaans: 'die wet',
    russian: ' кодекс',
    latvian: 'likums, statūti',
    polish: 'ustawy, prawa, przepisy ',
    french: 'loi, législation, code',
    spanish: 'ley, la ley',
  },
  {
    av: 23135,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + law )',
    english: 'lawyer',
    swedish: 'jurist, advokat',
    norwegian: 'advokat, jurist',
    finnish: 'lakimies, juristi',
    hungarian: 'jogász',
    german: 'Rechtsanwalt',
    dutch: 'jurist',
    afrikaans: 'prokureur',
    russian: 'юрист, адвокат',
    latvian: 'jurists, advokāts',
    polish: 'adwokat, notariusz, prawnik',
    french: 'homme de loi',
    spanish: 'abogado',
  },
  {
    av: 23136,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(legal person + to speak + to protect)',
    english: 'lawyer (for the defence)',
    swedish: 'försvarsadvokat',
    norwegian: 'forsvarsadvokat',
    finnish: 'puolustusasianajaja',
    hungarian: 'védőügyvéd',
    german: 'Anwalt, Anwältin',
    dutch: 'advocaat (wettelijk)',
    afrikaans: 'prokureur (vir die verdediging)',
    russian: 'адвокат, защитник',
    latvian: 'aizstāvis, advokāts (aizstāvībai)',
    polish: 'obrońca (prawnik)',
    french: 'avocat de la défense',
    spanish: 'abogado (defensor)',
  },
  {
    av: 23137,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(metal [contr.] + a weight + thing ind.)',
    english: 'lead',
    swedish: 'bly',
    norwegian: 'blylodd',
    finnish: 'lyijy',
    hungarian: 'ólom',
    german: 'Blei (Material)',
    dutch: 'lood',
    afrikaans: 'lei',
    russian: 'свинец',
    latvian: 'svins',
    polish: 'ołów',
    french: 'plomb (métal)',
    spanish: 'plomo',
  },
  {
    av: 23138,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(law + description indicator)',
    english: 'legal',
    swedish: 'laglig',
    norwegian: 'lovlig',
    finnish: 'lainmukainen',
    hungarian: 'jogi, jogos, jogszerű, jog-',
    german: 'gesetzlich, gesetzmäßig, legal',
    dutch: 'legaal, wettelijk',
    afrikaans: 'wetlike',
    russian: 'законный',
    latvian: 'likumisks, likumīgs, legāls',
    polish: 'prawne, prawnicze',
    french: 'légal',
    spanish: 'legal',
  },
  {
    av: 23139,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(help + legal [contr.])',
    english: 'legal aid',
    swedish: 'rättshjälp',
    norwegian: 'rettshjelp',
    finnish: 'oikeusapu',
    hungarian: 'jogsegély',
    german: 'Rechtshilfe, Prozesskostenhilfe',
    dutch: 'rechtshulp, rechtsbijstand',
    afrikaans: 'regshulp',
    russian: 'юридическая помощь',
    latvian: 'juridiskā palīdzība',
    polish: 'pomoc prawna',
    french: 'conseil juridique',
    spanish: 'ayuda legal',
  },
  {
    av: 23140,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + legal {contr.]) Used in conjunction with a specifier',
    english: 'legal person (in combinations)',
    swedish: 'juridisk person (i kombinationer)',
    norwegian: 'person juridisk',
    finnish: 'juristi',
    hungarian: 'jogászember, joggal foglalkozó (szóösszetételben)',
    german: '(juristische) Person',
    dutch: 'rechtspersoon (in combinaties)',
    afrikaans: 'regspersoon',
    russian: 'юрист (в кобиации)',
    latvian: 'juridiska persona (dažādās nozīmēs)',
    polish: 'osoba prawna (osobowość prawna)',
    french: 'homme de loi (classificateur)',
    spanish: 'persona jurídica (en combinaciones)',
  },
  {
    av: 23141,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(time + free)',
    english: 'leisure time',
    swedish: 'fritid',
    norwegian: 'fritid',
    finnish: 'vapaa-aika',
    hungarian: 'szabadidő',
    german: 'Freizeit',
    dutch: 'vrijetijd, ontspanning',
    afrikaans: 'vrye tyd',
    russian: 'свободное время',
    latvian: 'brīvais laiks',
    polish: 'czas wolny',
    french: 'loisirs',
    spanish: 'tiempo libre',
  },
  {
    av: 23142,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + light + thing indicator)',
    english: 'light meter',
    swedish: 'ljusmätare',
    norwegian: 'lysmåler',
    finnish: 'valomittari, fotometri',
    hungarian: 'fénymérő',
    german: 'Belichtungsmesser, Fotometer',
    dutch: 'lichtmeter',
    afrikaans: 'ligmeter',
    russian: 'люксметр',
    latvian: 'eksponometrs, luksmetrs, gaismas mēraparāts',
    polish: 'światłomierz, miernik oświetlenia',
    french: 'luxmètre',
    spanish: 'medidor de luz',
  },
  {
    av: 23143,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tower + lamp + thing indicator)',
    english: 'lighthouse',
    swedish: 'fyr',
    norwegian: 'fyrtårn',
    finnish: 'majakka',
    hungarian: 'világítótorony',
    german: 'Leuchtturm',
    dutch: 'vuurtoren',
    afrikaans: 'vuurtoring',
    russian: 'маяк',
    latvian: 'bāka',
    polish: 'latarnia morska',
    french: 'phare',
    spanish: 'faro',
  },
  {
    av: 23144,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + stalk: fabric woven from flax [contr.] )',
    english: 'linen, flax fabric',
    swedish: 'linne',
    norwegian: 'linstoff',
    finnish: 'pellavakangas',
    hungarian: 'vászon, lenvászon',
    german: 'Leinen',
    dutch: 'linnen',
    afrikaans: 'linne',
    russian: 'лён (ткань)',
    latvian: 'lins, lina materiāls, lina audums',
    polish: 'len, płótno lniane',
    french: 'lin (textile, tissu)',
    spanish: 'lino',
  },
  {
    av: 23145,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + liquor)',
    english: 'liquor shop, liquor store',
    swedish: 'Systembolag, spritbutik',
    norwegian: 'vinmonopol',
    finnish: 'alko, viinakauppa',
    hungarian: 'italbolt',
    german: 'Wein- und Spirituosenhandlung',
    dutch: 'drankshop, drankhandel',
    afrikaans: 'drankwinkel',
    russian: 'ликеро-водочный магазин',
    latvian: 'alkohola veikals',
    polish: 'sklep monopolowy, sklep z akloholem',
    french: 'magasin de spiritueux',
    spanish: 'tienda de licores',
  },
  {
    av: 23146,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shellfish with claws + big)',
    english: 'lobster',
    swedish: 'hummer',
    norwegian: 'hummer',
    finnish: 'hummeri',
    hungarian: 'homár, tengeri rák',
    german: 'Languste, Krebs',
    dutch: 'kreeft',
    afrikaans: 'kreef',
    russian: 'лобстер',
    latvian: 'jūras vēzis, omārs',
    polish: 'homar',
    french: 'homard',
    spanish: 'langosta',
  },
  {
    av: 23147,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + store + limited time)',
    english: 'market',
    swedish: 'marknad',
    norwegian: 'marked',
    finnish: 'marketti',
    hungarian: 'piac',
    german: 'Markt',
    dutch: 'markt',
    afrikaans: 'mark',
    russian: 'рынок',
    latvian: 'tirgus',
    polish: 'sklep, supermarket',
    french: 'marché',
    spanish: 'mercado',
  },
  {
    av: 23148,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + mathematics [contr.])',
    english: 'math, mathematics (class) (1)',
    swedish: 'matte, matematik (skolämne) (1)',
    norwegian: 'matematikkfag (1)',
    finnish: 'matematiikka (kouluaine)',
    hungarian: 'matematika (tantárgy)',
    german: 'Mathematik, Arithmetik, Rechnen, Mathe (1)',
    dutch: 'wiskunde (les), rekenen (les), rekenles (1)',
    afrikaans: 'wiskunde (les) (1)',
    russian: 'математика (предмет) (1)',
    latvian: 'matemātika, matemātikas nodarbība (1)',
    polish: 'matematyka, liczenie (wiedza +liczba)',
    french: 'math (cours) (1)',
    spanish: 'matemática (clase o materia)',
  },
  {
    av: 23149,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(metal [contr.] + thermometer + thing indicator)',
    english: 'mercury',
    swedish: 'kvicksilver',
    norwegian: 'kvikksølv',
    finnish: 'elohopea',
    hungarian: 'higany',
    german: 'Quecksilber',
    dutch: 'kwik',
    afrikaans: 'kwik',
    russian: 'ртуть',
    latvian: 'dzīvsudrabs',
    polish: 'rtęć',
    french: 'mercure',
    spanish: 'mercurio',
  },
  {
    av: 23151,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(may + many + many + building)',
    english: 'city, metropolis',
    swedish: 'storstad, stad, metropol',
    norwegian: 'metropol, storby',
    finnish: 'metropoli, miljoonakaupunki',
    hungarian: 'világváros, nagyváros, metropólisz',
    german: 'Großstadt, Hauptstadt, Metropole',
    dutch: 'metropool',
    afrikaans: 'stad, metropool',
    russian: 'мегаполис',
    latvian: 'lielpilsēta, metropole',
    polish: 'metropolia (bardzo duży zespół miejski)',
    french: 'métropole, grande ville',
    spanish: 'metrópoli',
  },
  {
    av: 23152,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hour + 24)',
    english: 'midnight',
    swedish: 'midnatt',
    norwegian: 'midnatt',
    finnish: 'keskiyö',
    hungarian: 'éjfél',
    german: 'Mitternacht',
    dutch: 'middernacht',
    afrikaans: 'middernag',
    russian: 'полночь',
    latvian: 'pusnakts',
    polish: 'północ (czas)',
    french: 'minuit',
    spanish: 'medianoche',
  },
  {
    av: 23153,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + storey)',
    english: 'multi storey building',
    swedish: 'flervåningshus',
    norwegian: 'høyblokk, høyhus',
    finnish: 'kerrostalo',
    hungarian: 'emeletes épület, emeletes ház',
    german: 'Gebäude mit mehreren Stockwerken',
    dutch: 'huis met meerdere verdiepen',
    afrikaans: 'multi verdieping gebou',
    russian: 'многоэтажное здание',
    latvian: 'daudzstāvu celtne',
    polish: 'budynek wielopiętrowy',
    french: 'immeuble à plusieurs étages',
    spanish: 'edificio de varias plantas',
  },
  {
    av: 23154,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + combination of storey and home)',
    english: 'multi storey home',
    swedish: 'flerplansvilla',
    norwegian: 'boligblokk',
    finnish: 'kerrostaloasunto',
    hungarian: 'emeletes otthon',
    german: 'mehrstöckiges Zuhause, Eigenheim, Heim',
    dutch: 'thuis (met meerdere verdiepingen',
    afrikaans: 'multi verdieping huis',
    russian: 'многоэтажный дом',
    latvian: 'daudzstāvu māja',
    polish: 'mieszkanie, dom w bloku, budynku wielopiętrowym',
    french: 'immeuble à plusieurs logements',
    spanish: 'casa de varias plantas',
  },
  {
    av: 23155,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ceremony + name)',
    english: 'naming ceremony',
    swedish: 'namngivningsceremoni',
    norwegian: 'dåp',
    finnish: 'kastetilaisuus',
    hungarian: 'névadó ünnepség, névadás',
    german: 'Taufe, Namensgebung',
    dutch: 'naamceremonie',
    afrikaans: 'benaming seremonie',
    russian: 'именование',
    latvian: 'vārda došanas ceremonija, kristības, krustabas',
    polish: 'ceremonia nadania imienia (chrzest nie religijny)',
    french: "baptême, attribution d'un nom",
    spanish: 'bautizo',
  },
  {
    av: 23156,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(religious ceremony + name)',
    english: 'naming ceremony (religious)',
    swedish: 'namngivningsceremoni (religiös)',
    norwegian: 'dåp (religiøs)',
    finnish: 'kirkkokaste, kastetilaisuus kirkossa',
    hungarian: 'névadó vallási ünnepség',
    german: 'Taufe, Namensgebung (religiös)',
    dutch: 'naamceremonie',
    afrikaans: 'benaming seremonie (godsdienstige)',
    russian: 'имянаречение',
    latvian: 'vārda došanas ceremonija, reliģiska, piem., kristības',
    polish: 'chrzest (religijny)',
    french: 'baptême religieux',
    spanish: 'bautizo (religioso)',
  },
  {
    av: 23157,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hour + 12)',
    english: 'noon',
    swedish: 'middagstid, mitt på dagen, lunchtid',
    norwegian: 'midt på dagen, lunsjtid',
    finnish: 'keskipäivä',
    hungarian: 'dél',
    german: 'Mittag, Mittagsstunde',
    dutch: '12 uur, middag',
    afrikaans: 'middag',
    russian: 'полдень',
    latvian: 'dienas vidus, pusdiena, dienvidus',
    polish: 'Południe, 12:00',
    french: 'midi',
    spanish: 'mediodía',
  },
  {
    av: 23158,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + paper + legal [contr.]: person working with legal issues)',
    english: 'notary',
    swedish: 'notarie, sekreterare (rättslig)',
    norwegian: 'notar, sekretær (rettslig)',
    finnish: 'kaupanvahvistaja, notaari',
    hungarian: 'jegyző',
    german: 'Notar, Notarin',
    dutch: 'notaris',
    afrikaans: 'notaris',
    russian: 'нотариус',
    latvian: 'notārs, notāra palīgs',
    polish: 'notariusz',
    french: 'greffier',
    spanish: 'notario',
  },
  {
    av: 23159,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(legal person + paper: combination of legal person and law)',
    english: 'notary (lawyer)',
    swedish: 'tingsnotarie',
    norwegian: 'notarius publicus',
    finnish: 'notaari',
    hungarian: 'közjegyző',
    german: 'Referendar, Referendarin',
    dutch: 'notaris (jurist)',
    afrikaans: 'notaris (prokureur)',
    russian: 'нотариус (судебный)',
    latvian: 'notārs, jurists',
    polish: 'adwokat',
    french: 'notaire, juriste',
    spanish: 'notario (abogado)',
  },
  {
    av: 23160,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water creature + eight + arm)',
    english: 'octopus',
    swedish: 'bläckfisk',
    norwegian: 'blekksprut',
    finnish: 'mustekala',
    hungarian: 'polip',
    german: 'Tintenfisch, Oktopus',
    dutch: 'octopus, inktvis',
    afrikaans: 'seekat',
    russian: 'осьминог',
    latvian: 'astoņkājis',
    polish: 'ośmiornica',
    french: 'pieuvre',
    spanish: 'pulpo',
  },
  {
    av: 23162,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + oil + thing indicator)',
    english: 'oil gauge',
    swedish: 'oljemätare',
    norwegian: 'oljemåler',
    finnish: 'öljymittari',
    hungarian: 'olajmérő',
    german: 'Ölanzeige, Ölstandsmesser',
    dutch: 'oliemeter',
    afrikaans: 'oliemeter',
    russian: 'масляный манометр',
    latvian: 'eļļas mērītājs',
    polish: 'wskaźnik poziomu oleju',
    french: 'jauge à huile',
    spanish: 'medidor de gasolina',
  },
  {
    av: 23163,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(one + storey)',
    english: 'one storey building, bungalow',
    swedish: 'envåningshus',
    norwegian: 'bygning enetasjes, bungalow',
    finnish: 'yksikerrostalo, bungalowi',
    hungarian: 'egyszintes épület, bugaló',
    german: 'einstöckiges Gebäude',
    dutch: 'huis met 1 verdieping, bungalow',
    afrikaans: 'enkel verdieping gebou',
    russian: 'одноэтажное здание',
    latvian: 'vienstāva ēka, bungalo, kotedža',
    polish: 'budynek jednopiętrowy, parterowy',
    french: 'immeuble à un niveau, bungalow',
    spanish: 'edificio de una planta, bungalow',
  },
  {
    av: 23164,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(one + storey + feeling: 1 + combination of storey and home)',
    english: 'one storey home',
    swedish: 'enplansvilla',
    norwegian: 'hjem enetasjes',
    finnish: 'huvila, kartano, yksikerroksinen talo',
    hungarian: 'egyszintes otthon ',
    german: 'einstöckiges Zuhause, Eigenheim, Heim',
    dutch: 'thuis (met 1 verdieping)',
    afrikaans: 'enkel verdieping huis',
    russian: 'одноэтажный дом',
    latvian: 'vienstāva māja',
    polish: 'dom jednopiętrowy (mieszkanie)',
    french: 'maison de plain-pied',
    spanish: 'casa de una planta',
  },
  {
    av: 23165,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + same, equal, equality)',
    english: 'peer',
    swedish: 'jämlike',
    norwegian: 'likemann',
    finnish: 'ikätoveri, vertainen',
    hungarian: 'társ, egyenrangú partner',
    german: 'Gleichgestellte (der), Gleichgestellte (die)',
    dutch: 'leeftijdsgenoot',
    afrikaans: 'eweknie',
    russian: 'ровня',
    latvian: 'vienaudzis',
    polish: 'rówieśnik',
    french: 'pair, égal, confrère',
    spanish: 'par, igual',
  },
  {
    av: 23166,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + pen, pencil)',
    english: 'pencil case, pencil box',
    swedish: 'pennskrin',
    norwegian: 'pennal',
    finnish: 'kynäkotelo, penaali',
    hungarian: 'tolltartó',
    german: 'Federkasten, Griffelkasten',
    dutch: 'pennenzak',
    afrikaans: 'potloodsak, potloodboks',
    russian: 'пенал',
    latvian: 'penālis',
    polish: 'piórnik, pojemnik na długopisy',
    french: 'plumier, trousse',
    spanish: 'caja de lápices',
  },
  {
    av: 23167,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knowledge + energy: class [contr.] + physics [contr.])',
    english: 'physics (class)',
    swedish: 'fysik (skolämne)',
    norwegian: 'fysikkfag',
    finnish: 'fysiikka (kouluaine)',
    hungarian: 'fizika (tantárgy)',
    german: 'Physikunterricht',
    dutch: 'fysica (les)',
    afrikaans: 'fisika (les)',
    russian: 'физика (предмет)',
    latvian: 'fizikas nodarbība',
    polish: 'fizyka (kategoria)',
    french: 'cours de physique',
    spanish: 'física (clase)',
  },
  {
    av: 23168,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shellfish without claws + big)',
    english: 'prawn',
    swedish: 'jätteräka',
    norwegian: 'reke (stor)',
    finnish: 'iso katkarapu',
    hungarian: 'garnélarák',
    german: 'Krabbe, Garnele',
    dutch: 'gamba, garnaal',
    afrikaans: 'garnaal',
    russian: 'королевская креветка',
    latvian: 'garnele',
    polish: 'krewetka (duża)',
    french: 'crevette (rose)',
    spanish: 'camarón',
  },
  {
    av: 23170,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + pressure + thing indicator)',
    english: 'pressure gauge',
    swedish: 'tryckmätare',
    norwegian: 'trykkmåler',
    finnish: 'painemittari',
    hungarian: 'nyomásmérő',
    german: 'Druckanzeige, Druckmessgerät, Manometer',
    dutch: 'drukmeter',
    afrikaans: 'drukmeter',
    russian: 'манометр',
    latvian: 'spiediena mērītājs',
    polish: 'ciśnieniomierz',
    french: 'jauge de pression, manomètre',
    spanish: 'manómetro',
  },
  {
    av: 23171,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(price + plus)',
    english: 'price rise',
    swedish: 'prisökning',
    norwegian: 'prisøkning',
    finnish: 'hinnankorotus',
    hungarian: 'áremelkedés',
    german: 'Preisanstieg, Preiserhöhung, Preissteigerung',
    dutch: 'prijsstijging',
    afrikaans: 'styging',
    russian: 'рост цен',
    latvian: 'cenu kāpums',
    polish: 'wzrost cen, inflacja',
    french: 'hausse des prix',
    spanish: 'subida de precios',
  },
  {
    av: 23172,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(promotion + action indicator)',
    english: 'promote-(to)',
    swedish: 'verka för, stödja, gynna',
    norwegian: 'begunstige, fremme',
    finnish: 'kannattaa',
    hungarian: 'előmozdítani, előrelendíteni, reklámozni',
    german: 'bewerben, Werbung machen',
    dutch: 'promoten',
    afrikaans: 'bevorder (om te)',
    russian: 'содействовать',
    latvian: 'virzīt, sekmēt',
    polish: 'promować, wspierać, działać na rzecz jakiegoś celu',
    french: 'promouvoir, favoriser',
    spanish: 'promover',
  },
  {
    av: 23173,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + in order to)',
    english: 'promotion',
    swedish: 'stöd för, gynnande',
    norwegian: 'støtte for, favorisering',
    finnish: 'kannatus',
    hungarian: 'előmozdítás, előléptetés, hírverés, reklámozás',
    german: 'Befürwortung, Bestätigung',
    dutch: 'bevordering, promotie',
    afrikaans: 'bevordering',
    russian: 'содействие',
    latvian: 'virzīšana, sekmēšana',
    polish: 'promocja, wsparcie',
    french: 'promotion',
    spanish: 'promoción',
  },
  {
    av: 23176,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(legal person + to accuse)',
    english: 'prosecutor',
    swedish: 'åklagare',
    norwegian: 'aktor, påtalemyndighet',
    finnish: 'syyttäjä',
    hungarian: 'ügyész',
    german: 'Staatsanwalt, Staatsanwältin',
    dutch: 'aanklager, officier van justitie, openbare aanklager',
    afrikaans: 'aanklaer',
    russian: 'прокурор',
    latvian: 'prasītājs, prokurors',
    polish: 'prokurator, oskarżyciel',
    french: 'procureur',
    spanish: 'fiscal',
  },
  {
    av: 23177,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to speak + against)',
    english: 'protest, objection, opposition',
    swedish: 'protest, motstånd, opposition',
    norwegian: 'protest, innsigelse, motstand',
    finnish: 'vastustus, vastaansanominen',
    hungarian: 'tiltakozás, ellenvetés, ellenzés, kifogás (szóbeli)',
    german: 'Einspruch, Widerspruch, Protest',
    dutch: 'protest, verzet',
    afrikaans: 'protes, beswaar, opposisie',
    russian: 'протест, возражение',
    latvian: 'iebilst, protostēt, pretoties',
    polish: 'protest, sprzeciw (słowny)',
    french: 'protestation, opposition',
    spanish: 'protesta, oposición',
  },
  {
    av: 23178,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(protest + action indicator)',
    english: 'protest, resist-(to)',
    swedish: 'motsätta sig, protestera',
    norwegian: 'protestere, stå imot',
    finnish: 'protestoida, vastustaa',
    hungarian: 'tiltakozni, ellenállni',
    german: 'protestieren',
    dutch: 'protesteren, weerstand bieden, verzetten (zich)',
    afrikaans: 'protes, weerstand (om te)',
    russian: 'протестовать, сопротивляться',
    latvian: 'iebilst, pretoties',
    polish: 'protestować, sprzeciwiać się (czynny)',
    french: 'protester, résister',
    spanish: 'protestar, resistirse',
  },
  {
    av: 23179,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + against)',
    english: 'protest, resistance',
    swedish: 'protest, motstånd',
    norwegian: 'protest, motstand',
    finnish: 'vastustus, vastarinta, protesti',
    hungarian: 'tiltakozás, ellenállás (tevőlegesen)',
    german: 'Einspruch, Widerspruch, Protest',
    dutch: 'protest, verzet',
    afrikaans: 'protes, weerstand',
    russian: 'протест, сопротивление',
    latvian: 'protests, pretošanās',
    polish: 'protest, sprzeciw (czynny)',
    french: 'protestation, résistance',
    spanish: 'protesta, resistencia',
  },
  {
    av: 23180,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + angle + thing indicator)',
    english: 'protractor',
    swedish: 'vinkelmätare, gradskiva',
    norwegian: 'vinkelmåler, transportør',
    finnish: 'kulmamitta, astemitta',
    hungarian: 'szögmérő',
    german: 'Winkelmesser, Goniometer',
    dutch: 'passer',
    afrikaans: 'gradeboog',
    russian: 'транспортир',
    latvian: 'leņķmērs, protraktors',
    polish: 'kątomierz',
    french: 'rapporteur',
    spanish: 'transportador',
  },
  {
    av: 23181,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + mind + feeling: person + psychology [contr.]) Preferred NEW SYNONYM, replacing 21587',
    english: 'psychologist',
    swedish: 'psykolog',
    norwegian: 'psykolog',
    finnish: 'psykologi',
    hungarian: 'pszichológus',
    german: 'Psychologe, Psychologin',
    dutch: 'psycholoog',
    afrikaans: 'sielkundige',
    russian: 'психолог',
    latvian: 'psihologs',
    polish: 'psycholog',
    french: 'psychologue',
    spanish: 'psicólogo',
  },
  {
    av: 23182,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + psychology: researcher + psychology [contr.]) Preferred NEW SYNONYM, replacing 21586',
    english: 'psychologist (researcher)',
    swedish: 'psykolog (forskare)',
    norwegian: 'psykolog (forsker)',
    finnish: 'psykologi',
    hungarian: 'kutatópszichológus',
    german: 'Psychologe, Psychologin (Forscher)',
    dutch: 'psycholoog (onderzoeker)',
    afrikaans: 'sielkundige (navorser)',
    russian: 'психолог (научный)',
    latvian: 'psihologs (pētnieks)',
    polish: 'psycholog (naukowiec)',
    french: 'psychologue (chercheur)',
    spanish: 'psicólogo (investigador)',
  },
  {
    av: 23183,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(body of knowledge + mind + feeling) Preferred NEW SYNONYM, replacing 21552',
    english: 'psychology',
    swedish: 'psykologi',
    norwegian: 'psykologi',
    finnish: 'psykologia',
    hungarian: 'pszichológia',
    german: 'Psychologie',
    dutch: 'psychologie',
    afrikaans: 'sielkunde',
    russian: 'психология ',
    latvian: 'psiholoģija',
    polish: 'psychologia (nauka)',
    french: 'psychologie (science)',
    spanish: 'psicología',
  },
  {
    av: 23184,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(teacher, pedagogue, educator (in combinations) + mind + feeling: teacher + psychology [contr.]) Preferred NEW SYNONYM, replacing 21588',
    english: 'psychology teacher',
    swedish: 'psykologilärare',
    norwegian: 'psykologilærer',
    finnish: 'psykologian opettaja',
    hungarian: 'pszichológia tanár',
    german: 'Psychologielehrer, Psychologielehrerin',
    dutch: 'psychologieleraar',
    afrikaans: 'sielkunde onderwyser',
    russian: 'учитель психологии',
    latvian: 'psiholoģijas skolotājs',
    polish: 'wykładowca psychologii',
    french: 'enseignant en psychologie',
    spanish: 'profesor de psicología',
  },
  {
    av: 23185,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(15 + minute)',
    english: 'quarter of an hour',
    swedish: 'kvart',
    norwegian: 'kvarter (tid)',
    finnish: '15 minuuttia, viisitoista minuuttia, vartti',
    hungarian: 'negyedóra',
    german: 'Viertelstunde',
    dutch: 'kwartier',
    afrikaans: 'kwartier',
    russian: 'четверть часа',
    latvian: 'ceturtdaļstunda',
    polish: 'kwadrans, 15 min',
    french: "quart d'heure",
    spanish: 'cuarto de hora',
  },
  {
    av: 23186,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + rain + thing indicator)',
    english: 'rain gauge',
    swedish: 'regnmätare',
    norwegian: 'regnmåler',
    finnish: 'sademittari',
    hungarian: 'csapadékmérő',
    german: 'Niederschlagsmesser, Regenmesser',
    dutch: 'regenmeter',
    afrikaans: 'reenmeter',
    russian: 'дождемер',
    latvian: 'lietus mērītājs',
    polish: 'deszczomierz, miernik deszczu',
    french: 'pluviomètre',
    spanish: 'pluviómetro, medidor de lluvia',
  },
  {
    av: 23187,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + reading)',
    english: 'reading (class)',
    swedish: 'läsning (skolämne)',
    norwegian: 'lesefag',
    finnish: 'lukeminen (kouluaine)',
    hungarian: 'olvasás (tantárgy)',
    german: 'Leseunterricht',
    dutch: 'leesonderricht, leesles',
    afrikaans: 'lees (les)',
    russian: 'чтение (предмет)',
    latvian: 'lasīšanas nodarbība',
    polish: 'czytanie (kategoria)',
    french: 'cours de lecture',
    spanish: 'lectura (clase)',
  },
  {
    av: 23188,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lesson + reading)',
    english: 'reading lesson',
    swedish: 'läslektion',
    norwegian: 'lesetime',
    finnish: 'lukutunti',
    hungarian: 'olvasásóra',
    german: 'Leseunterricht',
    dutch: 'lezen (les)',
    afrikaans: 'leesles',
    russian: 'урок чтения',
    latvian: 'lasīšanas stunda',
    polish: 'lekcja czytania',
    french: 'leçon de lecture',
    spanish: 'lección de lectura',
  },
  {
    av: 23189,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + religion)',
    english: 'religion (class)',
    swedish: 'religionskunskap (skolämne)',
    norwegian: 'religionsfag',
    finnish: 'uskonto (kouluaine)',
    hungarian: 'hittan (tantárgy)',
    german: 'Religionsunterricht',
    dutch: 'godsdienst (les)',
    afrikaans: 'godsdiens (les)',
    russian: 'религия (предмет)',
    latvian: 'reliģijas nodarbība',
    polish: 'religia (kategoria) religijne',
    french: 'cours de religion',
    spanish: 'religión (clase)',
  },
  {
    av: 23190,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(body of learning + religion)',
    english: 'religion (science of), theology',
    swedish: 'religionsvetenskap',
    norwegian: 'religionsvitenskap',
    finnish: 'teologia, jumaluusoppi',
    hungarian: 'hittudomány, teológia',
    german: 'Religion, Teologie',
    dutch: 'godsgeleerdheid, theologie',
    afrikaans: 'godsdiens (wetenskap van), teologie',
    russian: 'религия, теология',
    latvian: 'reliģija, teoloģijas zinātne',
    polish: 'religioznawstwo (badanie religii)',
    french: 'religion, confession (science)',
    spanish: 'religión (teología)',
  },
  {
    av: 23191,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(teacher [contr.] + religion)',
    english: 'religion teacher',
    swedish: 'religionslärare',
    norwegian: 'religionslærer',
    finnish: 'uskonnon opettaja',
    hungarian: 'hittan tanár, teológia tanár, vallás tanár',
    german: 'Religionslehrer, Religionslehrerin',
    dutch: 'godsdienstleraar',
    afrikaans: 'godsdiens onderwyser',
    russian: 'учитель религии',
    latvian: 'reliģijas skolotājs',
    polish: 'katecheta, teolog',
    french: 'religion (professeur)',
    spanish: 'profesor de religión',
  },
  {
    av: 23192,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(service + religion)',
    english: 'religious service',
    swedish: 'religiös ritual',
    norwegian: 'religiøst rituale',
    finnish: 'uskonnollinen toimitus',
    hungarian: 'egyházi szertartás, vallási ceremónia',
    german: 'Gottesdienst',
    dutch: 'religieuze dienst',
    afrikaans: 'godsdiens diens',
    russian: 'религиозный ритуал',
    latvian: 'reliģiska kalpošana, reliģisks rituāls',
    polish: 'nabożeństwo (dowolnej religii)',
    french: 'service religieux, cérémonie religieuse',
    spanish: 'servicio religioso',
  },
  {
    av: 23194,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + to sell)',
    english: 'sale',
    swedish: 'försäljning',
    norwegian: 'salg',
    finnish: 'myynti',
    hungarian: 'árusítás, eladás, értékesítés',
    german: 'Verkauf',
    dutch: 'uitverkoop',
    afrikaans: 'verkoop',
    russian: 'продажа',
    latvian: 'pārdošana',
    polish: 'sprzedaż',
    french: 'vente',
    spanish: 'venta',
  },
  {
    av: 23195,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + jump + river)',
    english: 'salmon',
    swedish: 'lax',
    norwegian: 'laks',
    finnish: 'lohi',
    hungarian: 'lazac',
    german: 'Lachs',
    dutch: 'zalm',
    afrikaans: 'salm',
    russian: 'лосось',
    latvian: 'lasis',
    polish: 'łosoś',
    french: 'saumon',
    spanish: 'salmón',
  },
  {
    av: 23196,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bread + spread)',
    english: 'sandwich (open face)',
    swedish: 'smörgås',
    norwegian: 'smørbrød',
    finnish: 'voileipä',
    hungarian: 'szendvics',
    german: 'belegtes Brot, Stulle',
    dutch: 'sandwich (brood)',
    afrikaans: 'toebroodjie',
    russian: 'бутерброд',
    latvian: 'sviestmaize',
    polish: 'kanapka (na jednej kromce)',
    french: 'sandwich (ouvert)',
    spanish: 'emparedado sin tapa',
  },
  {
    av: 23197,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + weight + thing indicator)',
    english: 'scale (weighing)',
    swedish: 'våg (vägning)',
    norwegian: 'vektskala',
    finnish: 'vaaka, painomittari',
    hungarian: 'súlymérleg, mérleg',
    german: 'Waage',
    dutch: 'weegschaal',
    afrikaans: 'weegskaal',
    russian: 'весы',
    latvian: 'svari, svēršana',
    polish: 'waga (jednostka wagi)',
    french: 'balance, bascule',
    spanish: 'balanza (de peso)',
  },
  {
    av: 23198,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(house + knowledge: house + to teach [contr.]) Used in conjunction with a specifier.',
    english: 'school (in combinations)',
    swedish: 'skola (i kombinationer)',
    norwegian: 'skole (brukes i kombinasjon)',
    finnish: 'koulu',
    hungarian: 'iskola (szóösszetételben)',
    german: 'Schule (in Kombinationen)',
    dutch: 'school (in combinaties)',
    afrikaans: 'skool (in kombinasies)',
    russian: 'школа (в комбинации)',
    latvian: 'skola (dažādās nozīmēs)',
    polish: 'szkoła (budynek +wiedza)',
    french: 'école (avec spécificateur)',
    spanish: 'escuela (en combinaciones)',
  },
  {
    av: 23199,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + year)',
    english: 'season',
    swedish: 'årstid',
    norwegian: 'årstid',
    finnish: 'vuodenaika',
    hungarian: 'évszak',
    german: 'Jahreszeit',
    dutch: 'seizoen, jaargetijde',
    afrikaans: 'seisoen',
    russian: 'время года',
    latvian: 'gadalaiks, sezona',
    polish: 'sezon, pora roku',
    french: 'saison',
    spanish: 'temporada',
  },
  {
    av: 23200,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to get + intensity + action indicator)',
    english: 'capture, catch, seize-(to)',
    swedish: 'fånga, gripa',
    norwegian: 'fange, gripe',
    finnish: 'siepata, ottaa kiinni, pyydystää',
    hungarian: 'elkapni, megfogni, megragadni',
    german: 'fangen, auffangen',
    dutch: 'vangen',
    afrikaans: 'vang, gryp (om te)',
    russian: 'захватить, поймать',
    latvian: 'noķert, saķert, sagrābt',
    polish: 'chwycić, przejąć, zawładnąć, złapać (dostać +znak intensywności)',
    french: 'saisir, attraper, empoigner',
    spanish: 'capturar',
  },
  {
    av: 23202,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to say + other + guilty)',
    english: 'sentence, condemn-(to)',
    swedish: 'förklara skyldig, döma',
    norwegian: 'avsi dom',
    finnish: 'julistaa tuomio',
    hungarian: 'elítélni, ítélni, valamire ítélni, ítéletet hozni',
    german: 'verurteilen, Urteil verkünden',
    dutch: 'veroordelen, schuldig verklaren',
    afrikaans: 'veroordeel, skuldig verklaar (om te)',
    russian: 'приговорить, осудить',
    latvian: 'notiesāt, sodīt',
    polish: 'potępiać, krytykować',
    french: 'prononcer la sentence, condamner',
    spanish: 'sentenciar, condenar',
  },
  {
    av: 23203,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + plan)',
    english: 'service (work)',
    swedish: 'service (tjänst)',
    norwegian: 'service (arbeid)',
    finnish: 'palvelu (työ)',
    hungarian: 'szolgáltatás',
    german: 'Service, Dienstleistung',
    dutch: 'dienst (werk)',
    afrikaans: 'diens werk',
    russian: 'обслуживание',
    latvian: 'pakalpojumi',
    polish: 'usługa (rodzaj pracy)',
    french: 'service (travail)',
    spanish: 'reparación (trabajo)',
  },
  {
    av: 23205,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + protection + work)',
    english: 'sheltered workshop',
    swedish: 'daglig verksamhet',
    norwegian: 'arbeidssted vernet',
    finnish: 'suojatyöpaikka, toimintakeskus',
    hungarian: 'védett munkahely',
    german: 'Behindertenwerkstatt, Werkstatt (für behinderte Menschen)',
    dutch: 'sociale werkplaats',
    afrikaans: 'beskutte werksplek',
    russian: 'центр занятости',
    latvian: 'specializētās darbnīcas',
    polish: 'zakład pracy chronionej',
    french: 'atelier protégé',
    spanish: 'taller protegido, taller adaptado',
  },
  {
    av: 23206,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + fish)',
    english: 'shoal, school (of fish)',
    swedish: 'fiskstim',
    norwegian: 'fiskestim',
    finnish: 'kalaparvi',
    hungarian: 'halraj',
    german: 'Fischschwarm',
    dutch: 'school (veel vissen))',
    afrikaans: 'skool visse',
    russian: 'стая рыб',
    latvian: 'zivju bars',
    polish: 'ławica ryb',
    french: 'banc de poissons',
    spanish: 'cardumen, banco (de peces)',
  },
  {
    av: 23207,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + store) Preferred NEW SYNONYM, replacing 16961',
    english: 'shopping centre, mall, plaza',
    swedish: 'affärscentrum, köpcentrum',
    norwegian: 'handelssentrum',
    finnish: 'ostoskeskus',
    hungarian: 'bevásárló központ, plaza',
    german: 'Einkaufszentrum',
    dutch: 'winkelcentrum',
    afrikaans: 'winkelsentrum, mall, plaza',
    russian: 'торговый ценрт',
    latvian: 'tirdzniecības centrs, iepirkšanās centrs',
    polish: 'centrum handlowe, hipermarket, galeria handlowa',
    french: 'centre commercial',
    spanish: 'centro comercial',
  },
  {
    av: 23208,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + shopping centre)',
    english: 'shopping mall',
    swedish: 'köpcentrum, galleria',
    norwegian: 'kjøpesenter',
    finnish: 'kauppakeskus',
    hungarian: 'bevásárló központ (maga az épület)',
    german: 'Einkaufszentrum',
    dutch: 'koopcentrum, shoppingcentrum',
    afrikaans: 'inkopie sentrum',
    russian: 'торговый ряд',
    latvian: 'tirdzniecības centrs, tirdzniecības mols',
    polish: 'budynek centrum handlowego, galeria handlowa',
    french: 'achat par correspondance',
    spanish: 'centro comercial',
  },
  {
    av: 23209,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + limited time: home [contr.] + limited time)',
    english: 'short time home',
    swedish: 'bostad (tillfällig)',
    norwegian: 'korttidshjem',
    finnish: 'sijaiskoti',
    hungarian: 'eltávozás, hazalátogatás ',
    german: 'Behelfsheim, Übergangswohnung',
    dutch: 'huis (korte tijd)',
    afrikaans: 'kort tyd huis',
    russian: 'временное жильё',
    latvian: 'īslaicīgas uzturēšanās dzīvesvieta',
    polish: 'dom do wynajęcia na krótko',
    french: 'temps de pause à la maison',
    spanish: 'vivienda (temporaria)',
  },
  {
    av: 23210,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shellfish without claws + small)',
    english: 'shrimp',
    swedish: 'räka',
    norwegian: 'reke',
    finnish: 'katkarapu',
    hungarian: 'apró tengeri rák, shrimp, kis garnélarák',
    german: 'Garnele',
    dutch: 'garnaal',
    afrikaans: 'garnaal',
    russian: 'креветка',
    latvian: 'garnele',
    polish: 'krewetki (małe)',
    french: 'crevette',
    spanish: 'camarón',
  },
  {
    av: 23211,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + worm + cloth: textile fibre produced by silk worms)',
    english: 'silk',
    swedish: 'silke',
    norwegian: 'silke',
    finnish: 'silkki',
    hungarian: 'selyem',
    german: 'Seide, Seidenstoff',
    dutch: 'zijde (weefsel)',
    afrikaans: 'sy (weefsel)',
    russian: 'шёлк',
    latvian: 'zīds',
    polish: 'jedwab',
    french: 'soie (matière)',
    spanish: 'seda',
  },
  {
    av: 23212,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + worm: fabric woven from silk fibre [contr.])',
    english: 'silk fabric',
    swedish: 'siden',
    norwegian: 'silkestoff',
    finnish: 'silkkikangas',
    hungarian: 'selyemszövet',
    german: 'Seidengewebe',
    dutch: 'zijden stof',
    afrikaans: 'sy (materiaal)',
    russian: 'шёлк (ткань)',
    latvian: 'zīda audums',
    polish: 'tkanina jedwabna, jedwabny materiał',
    french: 'soie (textile)',
    spanish: 'tela de seda',
  },
  {
    av: 23213,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(metal [contr.] + spoon)',
    english: 'silver',
    swedish: 'silver',
    norwegian: 'sølv',
    finnish: 'hopea',
    hungarian: 'ezüst',
    german: 'Silber',
    dutch: 'zilver',
    afrikaans: 'silwer',
    russian: 'серебро',
    latvian: 'sudrabs',
    polish: 'srebro',
    french: 'argent (métal)',
    spanish: 'plata',
  },
  {
    av: 23214,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(measurement + big)',
    english: 'size',
    swedish: 'storlek',
    norwegian: 'størrelse',
    finnish: 'koko, suuruus, laajuus',
    hungarian: 'méret',
    german: 'Größe',
    dutch: 'grootte, maat',
    afrikaans: 'grootte',
    russian: 'размер',
    latvian: 'izmērs',
    polish: 'rozmiar (np. ubrania)',
    french: 'taille (mesure)',
    spanish: 'tamaño',
  },
  {
    av: 23215,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + many + many + storey: building with many storeys)',
    english: 'skyscraper',
    swedish: 'skyskrapa',
    norwegian: 'skyskraper',
    finnish: 'pilvenpiirtäjä, tornitalo',
    hungarian: 'felhőkarcoló',
    german: 'Wolkenkratzer',
    dutch: 'wolkenkrabber',
    afrikaans: 'wolkekrabber',
    russian: 'небоскрёб',
    latvian: 'debesskrāpis',
    polish: 'drapacz chmur (budynek)',
    french: 'gratte-ciel',
    spanish: 'rascacielos',
  },
  {
    av: 23216,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(measurement + fast)',
    english: 'speed',
    swedish: 'fart, hastighet',
    norwegian: 'fart, hastighet',
    finnish: 'vauhti, nopeus',
    hungarian: 'sebesség',
    german: 'Schnelligkeit, Geschwindigkeit, Tempo',
    dutch: 'snelheid',
    afrikaans: 'spoed, snelheid',
    russian: 'скорость',
    latvian: 'ātrums',
    polish: 'pomiar prędkości',
    french: 'vitesse',
    spanish: 'velocidad',
  },
  {
    av: 23217,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + fast + thing indicator)',
    english: 'speedometer',
    swedish: 'hastighetsmätare',
    norwegian: 'fartsmåler',
    finnish: 'nopeusmittari',
    hungarian: 'sebességmérő',
    german: 'Geschwindigkeitsmesser, Geschwindigkeitsanzeige, Tachometer',
    dutch: 'snelheidsmeter',
    afrikaans: 'snelheidsmeter',
    russian: 'спидометр',
    latvian: 'spidometrs',
    polish: 'prędkościomierz',
    french: 'compteur de vitesse',
    spanish: 'velocímetro',
  },
  {
    av: 23218,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lesson + sport)',
    english: 'sport lesson',
    swedish: 'idrottslektion',
    norwegian: 'gymtime',
    finnish: 'liikunta (kouluaine), voimistelu (kouluaine), urheilu (kouluaine)',
    hungarian: 'edzés, sportóra',
    german: 'Sportunterricht',
    dutch: 'sportles, turnles',
    afrikaans: 'sport les',
    russian: 'урок физкультуры',
    latvian: 'sporta stunda, nodarbība',
    polish: 'lekcje zajęć sportowych, w-f',
    french: 'leçon de sport',
    spanish: 'lección deportiva',
  },
  {
    av: 23219,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + sport)',
    english: 'sport shop',
    swedish: 'sportaffär',
    norwegian: 'sportsbutikk',
    finnish: 'urheiluvälinekauppa',
    hungarian: 'sportbolt',
    german: 'Sportgeschäft',
    dutch: 'sportzaak, sportwinkel',
    afrikaans: 'sport winkel',
    russian: 'спортивный магазин',
    latvian: 'sporta preču veikals',
    polish: 'sklep sportowy',
    french: 'magasin de sport',
    spanish: 'tienda deportiva',
  },
  {
    av: 23220,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water creature + star) Preferred NEW SYNONYM, replacing 17253',
    english: 'starfish',
    swedish: 'sjöstjärna',
    norwegian: 'sjøstjerne',
    finnish: 'meritähti',
    hungarian: 'tengeri csillag',
    german: 'Seestern',
    dutch: 'zeester',
    afrikaans: 'seester',
    russian: 'морская звезда',
    latvian: 'jūraszvaigzne',
    polish: 'rozgwiazda',
    french: 'étoile de mer',
    spanish: 'estrella de mar',
  },
  {
    av: 23221,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(to write + to say + legal [contr.]: testimony written down or recorded)',
    english: 'statement',
    swedish: 'sakframställning',
    norwegian: 'kunngjøring, saksframstilling (juridisk)',
    finnish: 'lausunto, todistajanlausunto',
    hungarian: 'nyilatkozat, állítás, vallomás',
    german: 'Behauptung, Aussage',
    dutch: 'stelling',
    afrikaans: 'stelling',
    russian: 'заявление',
    latvian: 'apgalvojums',
    polish: 'oświadczenie, deklaracja',
    french: 'déposition, témoignage',
    spanish: 'declaración',
  },
  {
    av: 23222,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(past + stone)',
    english: 'stone age',
    swedish: 'stenåldern',
    norwegian: 'steinalder',
    finnish: 'kivikausi',
    hungarian: 'kőkorszak',
    german: 'Steinzeit',
    dutch: 'stenen tijdperk',
    afrikaans: 'steentydperk',
    russian: 'каменный век',
    latvian: 'akmens laikmets',
    polish: 'epoka kamienia łupanego',
    french: 'âge de pierre',
    spanish: 'edad de piedra',
  },
  {
    av: 23224,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to speak + in order to)',
    english: 'support (oral)',
    swedish: 'bifall, uppmuntran, stöd (muntligt)',
    norwegian: 'støtte (muntlig)',
    finnish: 'tuki (suullinen), kannatus (suullinen)',
    hungarian: 'támogatás, alátámasztás (szóban)',
    german: 'Unterstützung (sprachlich), Rückhalt',
    dutch: 'steun (mondeling), ondersteuning (mondeling)',
    afrikaans: 'ondersteuning (mondelings)',
    russian: 'поддержка (устная)',
    latvian: 'atbalsts, mutisks atbalsts',
    polish: 'wsparcie (werbalne, moralne)',
    french: 'soutien (oral)',
    spanish: 'apoyo (verbal)',
  },
  {
    av: 23225,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(support (oral) + action indicator)',
    english: 'support (orally)-(to)',
    swedish: 'tala för, stödja',
    norwegian: 'støtte, holde med',
    finnish: 'tukea suullisesti, kannattaa suullisesti',
    hungarian: 'támogatni (szóban)',
    german: 'befürworten, unterstützen',
    dutch: 'steunen (mondeling), ondersteunen (mondeling)',
    afrikaans: 'ondersteun (mondelings) (om te)',
    russian: 'поддерживать (устно)',
    latvian: 'atbalstīt, mutiski atbalstīt',
    polish: 'wspierać, pocieszać (słownie)',
    french: 'soutenir (oralement)',
    spanish: 'apoyar (verbalmente)',
  },
  {
    av: 23226,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + Swedish)',
    english: 'Swedish (class)',
    swedish: 'svenska (skolämne)',
    norwegian: 'svenskfag',
    finnish: 'ruotsi (kouluaine)',
    hungarian: 'svéd nyelv (tantárgy)',
    german: 'Schwedischunterricht',
    dutch: 'Zweeds (les)',
    afrikaans: 'Sweedse (les)',
    russian: 'Швецкий (класс)',
    latvian: 'zviedru valodas nodarbība',
    polish: 'szwedzki (kategoria)',
    french: 'cours de suédois',
    spanish: 'Sueco (clase)',
  },
  {
    av: 23227,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + 3 + crown: language + Sweden [contr.])',
    english: 'Swedish (language)',
    swedish: 'svenska',
    norwegian: 'svensk',
    finnish: 'ruotsi (kieli)',
    hungarian: 'svéd nyelv',
    german: 'Schwedisch (Sprache)',
    dutch: 'Zweeds (taal)',
    afrikaans: 'Sweedse (taal)',
    russian: 'шведский язык',
    latvian: 'zviedru valodas nodarbība',
    polish: 'szwedzki (język)',
    french: 'suédois (langue)',
    spanish: 'Sueco (idioma)',
  },
  {
    av: 23228,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + candy)',
    english: 'sweet shop, candy store',
    swedish: 'godisaffär',
    norwegian: 'godteributikk',
    finnish: 'karkkikauppa',
    hungarian: 'édességbolt, cukorkaüzlet',
    german: 'Süßigkeitengeschäft',
    dutch: 'snoepwinkel',
    afrikaans: 'snoepwinkel',
    russian: 'кондитерский магазин',
    latvian: 'saldumu veikals',
    polish: 'cukiernia, sklep ze słodyczami',
    french: 'magasin de confiserie',
    spanish: 'tienda de dulces',
  },
  {
    av: 23229,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(material + chemical product + cloth: textile fibre produced by a chemical process)',
    english: 'synthetic fabric',
    swedish: 'syntetiskt tyg',
    norwegian: 'syntetisk stoff',
    finnish: 'synteettinen kangas',
    hungarian: 'műanyag, szintetikus anyag',
    german: 'Kunststoff',
    dutch: 'synthetisch weefsel',
    afrikaans: 'sintetiese materiaal',
    russian: 'синтетическая ткань',
    latvian: 'sintētiska šķiedra, audums',
    polish: 'tkanina syntetyczna',
    french: 'synthétique (tissu)',
    spanish: 'tejido sintético',
  },
  {
    av: 23231,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tax + country: tax + government [contr.])',
    english: 'tax (national, federal)',
    swedish: 'skatt (statlig)',
    norwegian: 'statsskatt',
    finnish: 'valtionvero',
    hungarian: 'adó - állami',
    german: 'Bundessteuer',
    dutch: 'belasting (federaal)',
    afrikaans: 'belasting (federaal)',
    russian: 'государственный налог',
    latvian: 'nodoklis (valsts)',
    polish: 'podatek (federalny)',
    french: 'taxe gouvernementale',
    spanish: 'impuesto (federal)',
  },
  {
    av: 23232,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tax + building)',
    english: 'tax (real estate)',
    swedish: 'fastighetsskatt',
    norwegian: 'boligskatt',
    finnish: 'kiinteistövero',
    hungarian: 'adó – ingatlan: ingatlanadó, házadó',
    german: 'Grundsteuer',
    dutch: 'belasting (gemeente)',
    afrikaans: 'belasting (eiendom)',
    russian: 'налог на недвижимость',
    latvian: 'nodoklis (nekustamā īpašuma)',
    polish: 'podatek od nieruchomości',
    french: 'taxe sur biens immobiliers, impôts fonciers',
    spanish: 'impuesto (inmobiliario)',
  },
  {
    av: 23233,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tax + to sell)',
    english: 'tax (sales)',
    swedish: 'moms',
    norwegian: 'moms',
    finnish: 'arvonlisävero',
    hungarian: 'adó – kereskedelmi, eladási (Áfa)',
    german: 'Umsatzsteuer, Verkaufssteuer, Mehrwertsteuer',
    dutch: 'belasting (BTW)',
    afrikaans: 'belasting (verkoops)',
    russian: 'НДС',
    latvian: 'nodoklis (pievienotās vērtības)',
    polish: 'podatek od sprzedaży',
    french: 'taxe (vente), TVA',
    spanish: 'impuesto (ventas)',
  },
  {
    av: 23234,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tax + province)',
    english: 'tax (state, regional)',
    swedish: 'landstingsskatt',
    norwegian: 'fylkesskatt',
    finnish: 'kunnallisvero',
    hungarian: 'adó – helyi, regionális, önkormányzati',
    german: '(einzelstaatliche) Steuer',
    dutch: 'belasting (provincie)',
    afrikaans: 'belasting (staat, plaaslike)',
    russian: 'региональный налог',
    latvian: 'nodoklis (valsts, reģionālais)',
    polish: 'podatek (krajowy, regionalny)',
    french: 'taxe provinciale, taxe régionale',
    spanish: 'impuesto (estatal, regional)',
  },
  {
    av: 23235,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(testimony + action indicator)',
    english: 'testify-(to)',
    swedish: 'vittna',
    norwegian: 'vitne (å)',
    finnish: 'todistaa',
    hungarian: 'tanúsítani, tanúskodni, tanúvallomást tenni',
    german: '(als Zeuge) aussagen, bezeugen',
    dutch: 'getuigen',
    afrikaans: 'getuig (om te)',
    russian: 'давать показание',
    latvian: 'nodot liecību, apliecināt',
    polish: 'oświadczać, potwierdzać',
    french: 'témoigner, déposer',
    spanish: 'testificar',
  },
  {
    av: 23236,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(to say + observation + legal [contr.]: to state under oath what one has observed)',
    english: 'testimony',
    swedish: 'vittnesmål',
    norwegian: 'vitneforklaring',
    finnish: 'todistajanlausunto, todistus',
    hungarian: 'tanúság, tanúvallomás',
    german: 'Aussage, Bekundung, Zeugenaussage',
    dutch: 'getuigenverklaring',
    afrikaans: 'getuienis',
    russian: 'свидетельское показание',
    latvian: 'liecība, apliecinājums',
    polish: 'świadectwo, dowód',
    french: 'témoignage, déposition',
    spanish: 'testimonio',
  },
  {
    av: 23237,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + to see + to hear)',
    english: 'theatre',
    swedish: 'teater',
    norwegian: 'teater',
    finnish: 'teatteri',
    hungarian: 'színház',
    german: 'Theater, Schauspielhaus',
    dutch: 'schouwburg, theater',
    afrikaans: 'teater',
    russian: 'театр',
    latvian: 'teātris',
    polish: 'teatr',
    french: 'théâtre',
    spanish: 'teatro',
  },
  {
    av: 23238,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + time + thing indicator)',
    english: 'timer',
    swedish: 'tidtagarur, timer',
    norwegian: 'tidsur',
    finnish: 'ajastin',
    hungarian: 'időmérő',
    german: 'Eieruhr, Kurzzeitwecker, Timer, Küchentimer',
    dutch: 'kookwekker, timer',
    afrikaans: 'tydhouer horlosie',
    russian: 'таймер',
    latvian: 'skaitītājs, taimeris',
    polish: 'minutnik, timer, stoper',
    french: 'sablier, minuteur, chronomètre',
    spanish: 'temporizador',
  },
  {
    av: 23239,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(metal [contr.] + cup + past time)',
    english: 'tin',
    swedish: 'tenn',
    norwegian: 'tinn',
    finnish: 'tina',
    hungarian: 'bádog, cin',
    german: 'Zinn',
    dutch: 'blik',
    afrikaans: 'blik',
    russian: 'олово',
    latvian: 'alva',
    polish: 'cyna',
    french: 'étain',
    spanish: 'estaño',
  },
  {
    av: 23241,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store + toy)',
    english: 'toy shop',
    swedish: 'leksaksaffär',
    norwegian: 'lekebutikk',
    finnish: 'leikkikalukauppa',
    hungarian: 'játékbolt',
    german: 'Spielwarengeschäft',
    dutch: 'speelgoedwinkel',
    afrikaans: 'speelgoedwinkel',
    russian: 'магазин игрушек',
    latvian: 'rotaļlietu veikals',
    polish: 'sklep z zabawkami',
    french: 'magasin de jouets',
    spanish: 'juguetería',
  },
  {
    av: 23242,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gathering + legal [contr.])',
    english: 'trial',
    swedish: 'rättegång',
    norwegian: 'rettsmøte',
    finnish: 'oikeudenkäynti',
    hungarian: 'tárgyalás (bírósági)',
    german: 'Gerichtsverhandlung',
    dutch: 'rechtszaak, proces, rechtsgeding',
    afrikaans: 'hofsaak',
    russian: 'судебный процесс',
    latvian: 'tiesas process',
    polish: 'próba, test',
    french: 'procès',
    spanish: 'juicio, prueba, ensayo',
  },
  {
    av: 23243,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(two + storey)',
    english: 'two storey building',
    swedish: 'tvåvåningshus',
    norwegian: 'bygning toetasjes',
    finnish: 'kaksikerrostalo',
    hungarian: 'kétszintes épület',
    german: 'zweistöckiges Gebäude',
    dutch: 'gebouw (twee verdiepingen)',
    afrikaans: 'dubbelverdieping',
    russian: 'двухэтажный дом',
    latvian: 'divstāvu ēka',
    polish: 'budynek dwupoziomowy',
    french: 'immeuble à 2 étages',
    spanish: 'edificio de dos plantas',
  },
  {
    av: 23244,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + fair + description indicator)',
    english: 'unfair, unjust',
    swedish: 'orättvis',
    norwegian: 'urettferdig',
    finnish: 'epäoikeudenmukainen, epäreilu',
    hungarian: 'igazságtalan, méltánytalan, tisztességtelen',
    german: 'ungerecht, unfair',
    dutch: 'oneerlijk, onrechtvaardig, unfair',
    afrikaans: 'onregverdig, oneerlik, onreg',
    russian: 'нечестный, несправедливый, неправильный',
    latvian: 'negodīgs, netaisnīgs',
    polish: 'niesprawiedliwe',
    french: 'injuste inéquitable',
    spanish: 'injusto',
  },
  {
    av: 23245,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tower + observation)',
    english: 'watch tower, observation tower',
    swedish: 'vakttorn',
    norwegian: 'vakttårn',
    finnish: 'vartiotorni',
    hungarian: 'őrtorony, megfigyelő torony',
    german: 'Aussichtsturm',
    dutch: 'observatietoren',
    afrikaans: 'uitkyktoring',
    russian: 'сторожевая башня',
    latvian: 'novērošanas tornis, skatu tornis',
    polish: 'strażnica, wieża widokowa',
    french: "tour de guet, tour d'observation, tour panoramique",
    spanish: 'torre de vigilancia',
  },
  {
    av: 23246,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + water + thing indicator)',
    english: 'water meter',
    swedish: 'vattenmätare',
    norwegian: 'vannmåler',
    finnish: 'vesimittari',
    hungarian: 'vízmérő',
    german: 'Wassermesser, Wasseruhr, Wasserzähler',
    dutch: 'watermeter',
    afrikaans: 'watermeter',
    russian: 'водомер',
    latvian: 'ūdensskaitītājs',
    polish: 'wodomierz',
    french: "compteur d'eau",
    spanish: 'medidor de agua',
  },
  {
    av: 23247,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tower + water)',
    english: 'water tower',
    swedish: 'vattentorn',
    norwegian: 'vanntårn',
    finnish: 'vesitorni',
    hungarian: 'víztorony',
    german: 'Wasserturm',
    dutch: 'watertoren',
    afrikaans: 'watertoring',
    russian: 'водонапорная башня',
    latvian: 'ūdens tornis',
    polish: 'wieża ciśnień',
    french: "château d'eau",
    spanish: 'torre de agua',
  },
  {
    av: 23248,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(measurement + weight)',
    english: 'weight (measurement)',
    swedish: 'viktmått',
    norwegian: 'vektmål',
    finnish: 'kantavuus, paino',
    hungarian: 'súlymérce, súlymérő, súly',
    german: 'Gewicht',
    dutch: 'gewicht',
    afrikaans: 'gewig (weeg)',
    russian: 'вес',
    latvian: 'svars, mērvienība',
    polish: 'waga, masa (pomiar)',
    french: 'poids (mesure)',
    spanish: 'peso (medida)',
  },
  {
    av: 23249,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(vertical-(a) + description indicator)',
    english: 'vertical',
    swedish: 'lodrät',
    norwegian: 'vertikal',
    finnish: 'pystysuora, vertikaalinen',
    hungarian: 'függőleges, vertikális (mn.)',
    german: 'senkrecht, vertikal',
    dutch: 'vertikaal (bijv.nw.)',
    afrikaans: 'vertikaal (byv.nw.)',
    russian: 'вертикальный',
    latvian: 'vertikāls',
    polish: 'pionowy',
    french: 'vertical',
    spanish: 'vertical',
  },
  {
    av: 23251,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + observation + legal [contr.]: person + to testify [contr.])',
    english: 'witness',
    swedish: 'vittne',
    norwegian: 'vitne',
    finnish: 'todistaja',
    hungarian: 'tanú',
    german: 'Zeuge, Zeugin',
    dutch: 'getuige',
    afrikaans: 'getuie',
    russian: 'свидетель',
    latvian: 'liecinieks, aculiecinieks',
    polish: 'świadek',
    french: 'témoin',
    spanish: 'testigo',
  },
  {
    av: 23252,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + work)',
    english: 'workplace',
    swedish: 'arbetsplats',
    norwegian: 'arbeidsplass',
    finnish: 'työpaikka',
    hungarian: 'munkahely',
    german: 'Arbeitsraum, Arbeitszimmer',
    dutch: 'werkplaats',
    afrikaans: 'werksplek',
    russian: 'место работы',
    latvian: 'darbavieta',
    polish: 'miejsce pracy',
    french: 'lieu de travail',
    spanish: 'lugar de trabajo',
  },
  {
    av: 23253,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + to write)',
    english: 'writing (class)',
    swedish: 'skrivning (skolämne)',
    norwegian: 'skrivefag',
    finnish: 'kirjoitus (kouluaine)',
    hungarian: 'írás (tantárgy)',
    german: 'Schreibunterricht',
    dutch: 'schrijven (les), spelling (les)',
    afrikaans: 'skryf (les)',
    russian: 'письмо (предмет)',
    latvian: 'rakstīšanas, literatūras nodarbība',
    polish: 'pismo (kategoria)',
    french: "cours d'écriture",
    spanish: 'escritura (clase)',
  },
  {
    av: 23401,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(inside + vehicle + description indicator) Use appropriate specifier.',
    english: 'aboard, on board',
    swedish: 'ombord',
    norwegian: 'ombord',
    finnish: 'kyydissä',
    hungarian: 'buszon, vonaton lévő, utazó',
    german: '(an) Bord',
    dutch: 'aan boord',
    afrikaans: 'aan boord',
    russian: 'находящийся на борту',
    latvian: 'uz klāja, uz kuģa',
    polish: 'w samochodzie, w pojeździe',
    french: 'dans un véhicule, à bord',
    spanish: 'a bordo',
  },
  {
    av: 23402,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(name + place + house) Use appropriate speciifier.',
    english: 'address',
    swedish: 'adress',
    norwegian: 'adresse',
    finnish: 'osoite',
    hungarian: 'cím',
    german: 'Adresse',
    dutch: 'adres',
    afrikaans: 'adres',
    russian: 'адресс',
    latvian: 'adrese',
    polish: 'adres',
    french: 'adresse postale',
    spanish: 'dirección',
  },
  {
    av: 23403,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(computer program + protection)',
    english: 'anti-virus program',
    swedish: 'antivirusprogram',
    norwegian: 'antivirusprogram',
    finnish: 'viruksentorjuntaohjelma',
    hungarian: 'vírusirtó program, vírusellenes program',
    german: 'Anti-Virus-Programm',
    dutch: 'anti virus programma',
    afrikaans: 'anti virus program',
    russian: 'программа антивируса',
    latvian: 'pretvīrusu programma',
    polish: 'program antywirusowy, antywirus',
    french: 'antivirus (programme informatique)',
    spanish: 'programa antivirus',
  },
  {
    av: 23404,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(debarkation, disembarkation (ashore) + description indicator)',
    english: 'ashore',
    swedish: 'iland',
    norwegian: 'i land',
    finnish: 'rantautunut',
    hungarian: 'parti, parton, partra',
    german: 'an Land, zu Lande',
    dutch: 'aan land',
    afrikaans: 'aanlandig',
    russian: 'береговой',
    latvian: 'krasta virzienā, krastā',
    polish: 'ląd, zejście na ląd, wyjść na brzeg',
    french: 'à terre (débarqué)',
    spanish: 'en tierra',
  },
  {
    av: 23405,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + bank card)',
    english: 'ATM, cash machine',
    swedish: 'bankomat, uttagsautomat',
    norwegian: 'minibank, bankautomat',
    finnish: 'pankkiautomaatti',
    hungarian: 'pénzautomata, pénzkiadó automata, ATM',
    german: 'Geldautomat',
    dutch: 'geldautomaat',
    afrikaans: 'kitsbank ATM',
    russian: 'банкомат',
    latvian: 'naudas automāts, bankomāts',
    polish: 'bankomat',
    french: 'distributeur de billets, ATM ',
    spanish: 'cajero automático',
  },
  {
    av: 23407,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(attachment (computer) + action indicator)',
    english: 'attach (computer)-(to)',
    swedish: 'bifoga (dator)',
    norwegian: 'vedlegge (PC)',
    finnish: 'liittää (tietokone)',
    hungarian: 'rácsatlakoztatni, összekapcsolni (számítógépet)',
    german: '(Datei) anhängen',
    dutch: 'bijvoegen (computer)',
    afrikaans: 'heg, aanheg (rekenaar) (om te)',
    russian: 'добавить (ПК)',
    latvian: 'savienot (datoru ar..)',
    polish: 'podłączać (komputer)',
    french: 'attacher, joindre (informatique))',
    spanish: 'adjuntar (ordenador)',
  },
  {
    av: 23408,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(attachment (computer) + description indicator)',
    english: 'attached (computer)',
    swedish: 'bifogad (dator)',
    norwegian: 'vedlagt (PC)',
    finnish: 'liitetty (tietokone)',
    hungarian: 'rácsatlakoztatott, összekapcsolt (számítógép)',
    german: 'angehängt (Datei an Email)',
    dutch: 'bijgevoegd (computer)',
    afrikaans: 'aangeheg (rekenaar)',
    russian: 'добавленный (ПК)',
    latvian: 'savienots dators',
    polish: 'podłączony (komputer)',
    french: 'attaché, joint (informatique)',
    spanish: 'adjuntado (ordenador)',
  },
  {
    av: 23410,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(attachment + file)',
    english: 'attachment (computer)',
    swedish: 'bilaga (dator)',
    norwegian: 'vedlegg (PC)',
    finnish: 'liitetiedosto (tietokone)',
    hungarian: 'csatolmány (számítógép)',
    german: 'Anhang (Datei an Email)',
    dutch: 'bijlage (computer)',
    afrikaans: 'bybehore (rekenaar)',
    russian: 'вложение (ПК)',
    latvian: 'pielikums (datorā)',
    polish: 'załącznik (komputer)',
    french: 'pièce jointe, attachement (informatique)',
    spanish: 'archivo adjunto (ordenador)',
  },
  {
    av: 23411,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to delete + backwards)',
    english: 'backspace (computer)-(to)',
    swedish: 'radera (backspace) (dator)',
    norwegian: 'returtast, tilbaketast (PC)',
    finnish: 'poistaa merkki (tietokone), backspace (tietokone)',
    hungarian: 'visszalépés, hátralépés (számítógép)',
    german: '(rückwärts) löschen',
    dutch: 'backspace (computer)',
    afrikaans: 'backspace (rekenaar) (om te)',
    russian: 'удалять (ПК)',
    latvian: 'atpakaļatkāpe, izdzēšana (datorā)',
    polish: 'backspace, cofnij i skasuj (komputer)',
    french: 'supprimer en revenant en arrière (touche informatique)',
    spanish: 'borrar (ordenador)',
  },
  {
    av: 23412,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + bread)',
    english: 'baker',
    swedish: 'bagare',
    norwegian: 'baker',
    finnish: 'leipuri',
    hungarian: 'pék',
    german: 'Bäcker',
    dutch: 'bakker',
    afrikaans: 'bakker',
    russian: 'пекарь',
    latvian: 'maiznieks',
    polish: 'piekarz',
    french: 'boulanger',
    spanish: 'panadero',
  },
  {
    av: 23413,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(foundation + many + ball: a partial enclosure containing many balls)',
    english: 'ball pool',
    swedish: 'bollbad',
    norwegian: 'ballbasseng',
    finnish: 'pallomeri',
    hungarian: '',
    german: 'Ballbecken, Kugelbecken',
    dutch: 'ballenbad',
    afrikaans: 'bal swembad',
    russian: 'сухой бассейн',
    latvian: 'ūdens (baseina) bumbas',
    polish: 'Chiński basen, basen z piłeczkami',
    french: 'piscine de balles',
    spanish: 'bola de billar',
  },
  {
    av: 23414,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + toe + music)',
    english: 'ballet',
    swedish: 'balett',
    norwegian: 'ballett',
    finnish: 'baletti',
    hungarian: 'balett',
    german: 'Ballett',
    dutch: 'ballet',
    afrikaans: 'ballet',
    russian: 'балет',
    latvian: 'balets',
    polish: 'balet',
    french: 'ballet',
    spanish: 'ballet',
  },
  {
    av: 23415,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(card + money)',
    english: 'bank card, money card',
    swedish: 'bankkort',
    norwegian: 'bankkort',
    finnish: 'pankkikortti',
    hungarian: 'bankkártya',
    german: 'Kreditkarte, EC-Karte',
    dutch: 'bankkaart',
    afrikaans: 'bankkaart',
    russian: 'банковская карта',
    latvian: 'bankas karte',
    polish: 'karta bankowa, karta płatnicza',
    french: 'carte bancaire',
    spanish: 'tarjeta de crédito, tarjeta de débito',
  },
  {
    av: 23416,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wagon + garden)',
    english: 'barrow, garden cart, wheelbarrow',
    swedish: 'skottkärra',
    norwegian: 'trillebår',
    finnish: 'kottikärryt',
    hungarian: 'talicska, taliga, targonca',
    german: 'Schubkarre',
    dutch: 'kruiwagen',
    afrikaans: 'kruiwa',
    russian: 'тачка',
    latvian: 'ķerra',
    polish: 'taczka',
    french: 'brouette, charrette à bras',
    spanish: 'carretilla',
  },
  {
    av: 23417,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(compound berry + black)',
    english: 'blackberry',
    swedish: 'björnbär',
    norwegian: 'bjørnebær',
    finnish: 'karhunvatukka',
    hungarian: 'szeder, földi szeder',
    german: 'Brombeere',
    dutch: 'braambes (Vl), braam (Nl)',
    afrikaans: 'braambessie, braambes',
    russian: 'ежевика',
    latvian: 'upenes',
    polish: 'jeżyna',
    french: 'mûre',
    spanish: 'zarzamora',
  },
  {
    av: 23418,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(courage + description indicator)',
    english: 'brave, courageous',
    swedish: 'modig',
    norwegian: 'modig, tapper',
    finnish: 'rohkea',
    hungarian: 'bátor',
    german: 'tapfer, mutig, unerschrocken, furchtlos',
    dutch: 'dapper, moedig',
    afrikaans: 'dapper, moedig',
    russian: 'храбрый, смелый, отважный',
    latvian: 'drosmīgs, drošsirdīgs',
    polish: 'waleczny, odważny',
    french: 'brave, courageux',
    spanish: 'valiente',
  },
  {
    av: 23419,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + brick)',
    english: 'bricklayer',
    swedish: 'murare',
    norwegian: 'murer, steinlegger',
    finnish: 'muurari',
    hungarian: 'kőműves',
    german: 'Maurer',
    dutch: 'metselaar',
    afrikaans: 'messelaar',
    russian: 'каменщик',
    latvian: 'mūrnieks',
    polish: 'murarz',
    french: 'maçon',
    spanish: 'albañil',
  },
  {
    av: 23420,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bag + paper)',
    english: 'briefcase',
    swedish: 'portfölj',
    norwegian: 'dokumentmappe, stresskoffert',
    finnish: 'salkku',
    hungarian: 'aktatáska',
    german: 'Aktentasche, Aktenmappe',
    dutch: 'aktentas',
    afrikaans: 'aktetas',
    russian: 'портфель, кейс',
    latvian: 'mape, portfelis',
    polish: 'aktówka',
    french: 'serviette, porte-documents',
    spanish: 'maletín',
  },
  {
    av: 23421,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dinosaur + big)',
    english: 'Brontosaurus',
    swedish: 'Brontosaurie',
    norwegian: 'brontosaurus, tordenøgle',
    finnish: 'brontosaurus, apatosaurus',
    hungarian: 'brontoszaurusz',
    german: 'Brontosaurier',
    dutch: 'brontosaurus',
    afrikaans: 'brontosourus',
    russian: 'бронтозавр',
    latvian: 'brontozaurs',
    polish: 'brontozaur',
    french: 'brontosaure',
    spanish: 'Brontosaurio',
  },
  {
    av: 23422,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(little person + house)',
    english: 'brownie, house elf',
    swedish: 'hustomte',
    norwegian: 'fantasifigur husnisse, husalv',
    finnish: 'kotitonttu',
    hungarian: 'manóház, tündérház, elf-ház',
    german: 'Hauskobold',
    dutch: 'huiself',
    afrikaans: 'huis elf',
    russian: 'домовой',
    latvian: 'mājas gariņš, rūķītis',
    polish: 'duszek, skrzat domowy',
    french: 'personnage imaginaire (elfe de maison)',
    spanish: 'duende que cuida la casa',
  },
  {
    av: 23423,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + Buddhism)',
    english: 'Buddha',
    swedish: 'Buddha',
    norwegian: 'Buddha',
    finnish: 'Buddha',
    hungarian: 'Buddha',
    german: 'Buddha',
    dutch: 'Boeddha',
    afrikaans: 'Buddha',
    russian: 'Будда',
    latvian: 'Buda',
    polish: 'Budda',
    french: 'Bouddha',
    spanish: 'Buda',
  },
  {
    av: 23424,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(religion + dharma wheel)',
    english: 'Buddhism',
    swedish: 'buddhism',
    norwegian: 'buddhisme',
    finnish: 'buddhalaisuus',
    hungarian: 'buddhizmus',
    german: 'Buddhismus',
    dutch: 'Boeddhisme',
    afrikaans: 'Boeddhisme',
    russian: 'буддизм',
    latvian: 'budisms',
    polish: 'buddyzm',
    french: 'bouddhisme',
    spanish: 'Budismo',
  },
  {
    av: 23425,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(dharma wheel + description indicator)',
    english: 'buddhist',
    swedish: 'buddhistisk',
    norwegian: 'buddhistisk',
    finnish: 'buddhalainen',
    hungarian: 'buddhista (mn.)',
    german: 'buddhistisch',
    dutch: 'boeddhistisch',
    afrikaans: 'Boeddhistiese',
    russian: 'буддийский',
    latvian: 'budists',
    polish: 'buddyjski',
    french: 'bouddhiste (adj)',
    spanish: 'budista',
  },
  {
    av: 23426,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + dharma wheel: person + buddhist)',
    english: 'buddhist (person)',
    swedish: 'buddhist ',
    norwegian: 'buddhist',
    finnish: 'buddhalainen',
    hungarian: 'buddhista (fn.)',
    german: 'Buddhist, Buddhistin',
    dutch: 'boeddhist',
    afrikaans: 'Boeddhis (persoon)',
    russian: 'буддист',
    latvian: 'budists, persona',
    polish: 'buddysta (osoba)',
    french: 'bouddhiste (personne)',
    spanish: 'budista (persona)',
  },
  {
    av: 23427,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plan + business)',
    english: 'budget, business plan',
    swedish: 'budget, affärsplan',
    norwegian: 'budsjett',
    finnish: 'budjetti, talousarvio',
    hungarian: 'költségvetés, költségterv, büdzsé',
    german: 'Budget, Haushaltsplan, Etat',
    dutch: 'budget, business plan',
    afrikaans: 'begroting besigheids plan',
    russian: 'бюджет',
    latvian: 'budžets',
    polish: 'budżet',
    french: 'budget',
    spanish: 'presupuesto',
  },
  {
    av: 23428,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + meat)',
    english: 'butcher',
    swedish: 'charkuterist',
    norwegian: 'slakter',
    finnish: 'lihakauppias, teurastaja',
    hungarian: 'mészáros',
    german: 'Metzger, Metzgerin, Fleischer, Fleischerin',
    dutch: 'slager',
    afrikaans: 'slagter',
    russian: 'мясник',
    latvian: 'miesnieks',
    polish: 'rzeźnik',
    french: 'boucher',
    spanish: 'carnicero',
  },
  {
    av: 23429,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(mechanic + car)',
    english: 'car mechanic',
    swedish: 'bilmekaniker',
    norwegian: 'bilmekaniker',
    finnish: 'automekaanikko',
    hungarian: 'autószerelő',
    german: 'Mechaniker, Mechanikerin',
    dutch: 'monteur',
    afrikaans: 'motorwerktuigkundige',
    russian: 'автомеханик',
    latvian: 'automehāniķis',
    polish: 'mechanik samochodowy',
    french: 'mécanicien (automobile)',
    spanish: 'mecánico de coche',
  },
  {
    av: 23430,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(track + car)',
    english: 'car track',
    swedish: 'bilbana',
    norwegian: 'bilbane',
    finnish: 'autorata',
    hungarian: 'autósáv, nyomvonal',
    german: 'Autorennbahn',
    dutch: 'rijbaan',
    afrikaans: 'pad, ry baan',
    russian: 'картрек',
    latvian: 'auto trase',
    polish: 'tor samochodowy, tor wyścigowy',
    french: 'voie routière',
    spanish: 'circuito de coches',
  },
  {
    av: 23432,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play [contr.] + card)',
    english: 'card game',
    swedish: 'kortspel',
    norwegian: 'kortspill',
    finnish: 'korttipeli',
    hungarian: 'kártyajáték',
    german: 'Spielkarte',
    dutch: 'kaartspel',
    afrikaans: 'kaart spel',
    russian: 'игральная карта',
    latvian: 'kāršu spēle',
    polish: 'gra w karty',
    french: 'partie de cartes, jeu de cartes',
    spanish: 'juego de cartas',
  },
  {
    av: 23433,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + cartography)',
    english: 'cartographer',
    swedish: 'kartograf',
    norwegian: 'kartograf',
    finnish: 'kartoittaja, kartanpiirtäjä',
    hungarian: 'térképész',
    german: 'Kartenzeichner',
    dutch: 'kartograaf',
    afrikaans: 'kartograaf',
    russian: 'картограф',
    latvian: 'katrogrāfs',
    polish: 'kartograf',
    french: 'cartographe',
    spanish: 'cartógrafo',
  },
  {
    av: 23434,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(body of learning + map)',
    english: 'cartography',
    swedish: 'kartografi',
    norwegian: 'kartografi',
    finnish: 'kartografia, karttaoppi',
    hungarian: 'térképészet',
    german: 'Kartographie',
    dutch: 'kartografie',
    afrikaans: 'kartografie',
    russian: 'картография ',
    latvian: 'kartogrāfija',
    polish: 'kartografia',
    french: 'cartographie',
    spanish: 'cartografía',
  },
  {
    av: 23435,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(film + pencil: film on which images are drawn)',
    english: 'cartoon, animated picture',
    swedish: 'film (tecknad)',
    norwegian: 'tegnefilm, animert bilde',
    finnish: 'piirretty elokuva, piirroselokuva',
    hungarian: 'rajzfilm, animáció',
    german: 'Zeichentrickfilm, Cartoon',
    dutch: 'tekenfilm',
    afrikaans: 'animasie prent',
    russian: 'мультипликация ',
    latvian: 'multiplikācija, animācija',
    polish: 'animacja, film animowany',
    french: 'dessin animé',
    spanish: 'dibujos animados',
  },
  {
    av: 23436,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + container + oven: a food baked and served in the container in which it was cooked)',
    english: 'casserole',
    swedish: 'gratäng, gryta (maträtt) (etc)',
    norwegian: 'ovnsrett ',
    finnish: 'laatikkoruoka',
    hungarian: 'tűzálló edény',
    german: 'Schmortopf, Kasserolle',
    dutch: 'ovenschotel (voeding)',
    afrikaans: 'kasserol, oondskottel',
    russian: 'запеканка',
    latvian: 'kastrolis, sautējums, sacepums, ēdiens',
    polish: 'garnek, naczynie do gotowania',
    french: 'plat au four, gratin',
    spanish: 'cazuela',
  },
  {
    av: 23438,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(castle + crown)',
    english: 'castle, palace (royal)',
    swedish: 'slott, palats (kungligt)',
    norwegian: 'slott, palass (kongelig)',
    finnish: 'kuninkaanlinna',
    hungarian: 'királyi vár, királyi palota',
    german: 'Schloss, Burg',
    dutch: 'koninklijk palieis, paleis',
    afrikaans: 'kasteel, paleis (koninklik)',
    russian: 'королевский дворец',
    latvian: 'pils, karaļa pils',
    polish: 'zamek, pałac (królewski)',
    french: 'château, palais royal',
    spanish: 'castillo, palacio (Real)',
  },
  {
    av: 23440,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(feeling + coldness, cold + description indicator)',
    english: 'chilly',
    swedish: 'frusen, kall',
    norwegian: 'kjølig, kald',
    finnish: 'paleltunut, kylmettynyt, viluinen',
    hungarian: 'hűvös, borzongató',
    german: 'kalt, frieren',
    dutch: 'koud',
    afrikaans: 'yskoud',
    russian: 'холодно',
    latvian: 'vēss',
    polish: 'chłodny, obojętny, oschły (uczucie)',
    french: 'froid, glacial',
    spanish: 'frío',
  },
  {
    av: 23441,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(designer + bridge)',
    english: 'civil engineer',
    swedish: 'ingenjör, civilingenjör',
    norwegian: 'sivilingeniør',
    finnish: 'insinööri',
    hungarian: 'általános mérnök, építőmérnök, kultúrmérnök',
    german: 'Bauingenieur, Bauingenieurin',
    dutch: 'burgerlijk ingenieur',
    afrikaans: 'siviele ingenieur',
    russian: 'инженер-строитель',
    latvian: 'inženieris celtnieks',
    polish: 'inżynier',
    french: 'ingénieur civil',
    spanish: 'ingeniero civil',
  },
  {
    av: 23443,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + face + colour)',
    english: 'clown',
    swedish: 'clown',
    norwegian: 'klovn',
    finnish: 'pelle, klovni',
    hungarian: 'bohóc',
    german: 'Clown',
    dutch: 'clown',
    afrikaans: 'nar',
    russian: 'клоун',
    latvian: 'klauns',
    polish: 'pajac, klaun',
    french: 'clown',
    spanish: 'payaso',
  },
  {
    av: 23444,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to feel + coldness, cold + action indicator)',
    english: 'be cold-(to)',
    swedish: 'frysa',
    norwegian: 'fryse, bli kald',
    finnish: 'palella, tuntea kylmää',
    hungarian: 'fázni',
    german: 'frieren',
    dutch: 'het koud hebben',
    afrikaans: 'koud wees (voel, kry) (om te)',
    russian: 'мёрзнуть',
    latvian: 'auksti, salt',
    polish: 'być zimny, oziębły, bez emocji',
    french: 'avoir froid',
    spanish: 'tener frío',
  },
  {
    av: 23445,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play + up: play + happy [contr.])',
    english: 'comedy',
    swedish: 'komedi',
    norwegian: 'komedie',
    finnish: 'komedia',
    hungarian: 'vígjáték, komédia',
    german: 'Komödie',
    dutch: 'komedie',
    afrikaans: 'komedie',
    russian: 'комедия',
    latvian: 'komēdija',
    polish: 'komedia',
    french: 'comédie',
    spanish: 'comedia',
  },
  {
    av: 23446,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + gathering)',
    english: 'community centre, town hall, village hall',
    swedish: 'folkets hus, stadshus',
    norwegian: 'rådhus (o.l.)',
    finnish: 'kaupungintalo, kunnantalo',
    hungarian: 'közösségi ház, faluház, városháza',
    german: 'Rathaus',
    dutch: 'buurthuis',
    afrikaans: 'stadsaal',
    russian: 'общественный центр',
    latvian: 'mikrorajona centrs, pilsētas/ciemata rātsnams',
    polish: 'dom kultury, sala spotkań',
    french: 'centre communautaire, hôtel de ville, mairie',
    spanish: 'ayuntamiento, centro comunitario',
  },
  {
    av: 23447,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + digits (computer)) Preferred NEW SYNONYM, replacing 13394',
    english: 'computer',
    swedish: 'dator',
    norwegian: 'datamaskin, computer, PC',
    finnish: 'tietokone',
    hungarian: 'számítógép, kompjúter',
    german: 'Computer, PC',
    dutch: 'computer',
    afrikaans: 'rekenaar',
    russian: 'компьютер',
    latvian: 'dators, kompjūters',
    polish: 'komputer',
    french: 'ordinateur',
    spanish: 'ordenador, computadora',
  },
  {
    av: 23448,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + computer)',
    english: 'computer case',
    swedish: 'datorlåda, datorchassi',
    norwegian: 'dataveske',
    finnish: 'tietokonelaukku',
    hungarian: 'számítógéptáska',
    german: 'Computergehäuse, Computerkoffer',
    dutch: 'computertas',
    afrikaans: 'rekenaar tas',
    russian: 'компьютерный корпус',
    latvian: 'datora soma',
    polish: 'obudowa komputera',
    french: "valisette d'ordinateur, sacoche d'ordinateur",
    spanish: 'funda de ordenador',
  },
  {
    av: 23450,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + computer)',
    english: 'computer peripheral',
    swedish: 'datortillbehör',
    norwegian: 'datatilbehør',
    finnish: 'tietokoneen oheislaitteet',
    hungarian: 'számítógép periféria',
    german: 'Computerperipherie, Zusatzgeräte (Computer)',
    dutch: 'computertoebehoren',
    afrikaans: 'rekenaar toebehore, bybehore',
    russian: 'аксессуары для компьютера',
    latvian: 'datora piederumi, aksesuāri',
    polish: 'urządzenia peryferyjne komputera',
    french: 'périphérique (informatique)',
    spanish: 'periférico de ordenador',
  },
  {
    av: 23451,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + eye + digits (computer))',
    english: 'computer screen, monitor',
    swedish: 'bildskärm, monitor, dataskärm',
    norwegian: 'dataskjerm, monitor',
    finnish: 'tietokoneen näyttö',
    hungarian: 'számítógépernyő, monitor',
    german: 'Monitor',
    dutch: 'scherm (computer)',
    afrikaans: 'rekenaar skerm',
    russian: 'монитор компьютера',
    latvian: 'datora ekrāns, monitors',
    polish: 'monitor, ekran komputera, LCD',
    french: 'écran (informatique), moniteur (informatique)',
    spanish: 'pantalla de ordenador, monitor',
  },
  {
    av: 23452,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + music)',
    english: 'concert',
    swedish: 'konsert',
    norwegian: 'konsert',
    finnish: 'konsertti',
    hungarian: 'koncert, hangverseny',
    german: 'Konzert',
    dutch: 'concert',
    afrikaans: 'konsert',
    russian: 'концерт',
    latvian: 'koncerts',
    polish: 'koncert',
    french: 'concert',
    spanish: 'concierto',
  },
  {
    av: 23453,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(wand + action indicator)',
    english: 'conjure, turn to, transform-(to)',
    swedish: 'trolla',
    norwegian: 'trylle',
    finnish: 'loihtia, taikoa',
    hungarian: 'bűvészkedik, bűvészmutatványt végez',
    german: 'zaubern, beschwören',
    dutch: 'toveren',
    afrikaans: 'verander, roep (om te)',
    russian: 'колдовать',
    latvian: 'apvārdot, burt',
    polish: 'wyczarować, zamieniać, przekształcić',
    french: 'faire surgir, changer en, transformer',
    spanish: 'conjurar, cambiar, transformar',
  },
  {
    av: 23454,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(block + together)',
    english: 'constructional blocks, lego (etc)',
    swedish: 'byggkloss, legobit (etc)',
    norwegian: 'byggekloss, lego (o.l.)',
    finnish: 'rakennuspalikka, lego',
    hungarian: 'építőjáték (pl. lego, kockák)',
    german: 'Lego, Baustein, Legobaustein',
    dutch: 'lego, bouwblokken (Vl)',
    afrikaans: 'boublokkies, lego',
    russian: 'строительный блок, лего-блок',
    latvian: 'konstruktors, lego klucīši',
    polish: 'kocki konstrukcyjne, LEGO, itp.',
    french: 'jeu de construction, cubes, blocs, légo',
    spanish: 'bloques de construcción, Lego (etc.)',
  },
  {
    av: 23455,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(toy [contr.] + structure)',
    english: 'constructional toy',
    swedish: 'byggleksak, lego (etc)',
    norwegian: 'byggespill',
    finnish: 'rakennussarja',
    hungarian: 'összerakós játék',
    german: 'Baustein, Konstruktionsspielzeug (Lego)',
    dutch: 'constructiespel',
    afrikaans: 'konstruksie speelding, opvoedkundige speelding',
    russian: 'конструктор, лего и пр.',
    latvian: 'rotaļlieta konstruktors',
    polish: 'zabawki konstrukcyjne',
    french: 'jeu de construction',
    spanish: 'juego de construcción',
  },
  {
    av: 23456,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + copy + paper)',
    english: 'copier, photocopier',
    swedish: 'kopiator',
    norwegian: 'kopimaskin',
    finnish: 'kopiokone',
    hungarian: 'fénymásoló, másológép',
    german: 'Kopiergerät',
    dutch: 'kopieermachine, kopieerapparaat',
    afrikaans: 'kopieermasjien, fotostaatmasjien',
    russian: 'копировальная машина, ксерокс',
    latvian: 'kopētājs',
    polish: 'kopiarka, ksero',
    french: 'photocopieuse, copieur, photocopieur',
    spanish: 'copiadora, fotocopiadora',
  },
  {
    av: 23457,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(water creature + plant: water animals forming structures that may appear similar to plants and flowers)',
    english: 'coral',
    swedish: 'korall',
    norwegian: 'korall',
    finnish: 'koralli',
    hungarian: 'korall',
    german: 'Koralle',
    dutch: 'koraal',
    afrikaans: 'koraal',
    russian: 'коралл',
    latvian: 'korallis',
    polish: 'koral, roślina podwodna',
    french: 'corail',
    spanish: 'coral',
  },
  {
    av: 23458,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + many + coral)',
    english: 'coral reef',
    swedish: 'korallrev',
    norwegian: 'korallrev',
    finnish: 'koralliriutta',
    hungarian: 'korallszirt, korallzátony',
    german: 'Riff',
    dutch: 'rif (koraal)',
    afrikaans: 'koraal rif',
    russian: 'коралловый риф',
    latvian: 'koraļļu rifs',
    polish: 'rafa koralowa',
    french: 'récif de corail, barrière de corail',
    spanish: 'arrecife de coral',
  },
  {
    av: 23459,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(telephone + back and forth: telephone that can be carried around)',
    english: 'cordless phone',
    swedish: 'telefon (trådlös)',
    norwegian: 'trådløs telefon, telefon trådløs',
    finnish: 'langaton puhelin',
    hungarian: 'vezetéknélküli telefon',
    german: 'Schnurlostelefon',
    dutch: 'draadloze telefoon',
    afrikaans: 'koordlose telefoon',
    russian: 'беспроводной телефон',
    latvian: 'bezvada telefopns',
    polish: 'telefon bezprzewodowy',
    french: 'téléphone sans fil',
    spanish: 'teléfono inalámbrico',
  },
  {
    av: 23460,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + strong)',
    english: 'courage',
    swedish: 'mod',
    norwegian: 'mot (subst.)',
    finnish: 'rohkeus, urhoollisuus',
    hungarian: 'bátorság',
    german: 'tapfer, mutig, unerschrocken, furchtlos',
    dutch: 'moed',
    afrikaans: 'moed',
    russian: 'мужество',
    latvian: 'drosme',
    polish: 'odwaga',
    french: 'courage',
    spanish: 'valentía, coraje',
  },
  {
    av: 23461,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + cowardice)',
    english: 'coward',
    swedish: 'feg person, fegis',
    norwegian: 'feiging',
    finnish: 'pelkuri, nynny',
    hungarian: 'gyáva (fn.)',
    german: 'Feigling, Angsthase',
    dutch: 'lafaard',
    afrikaans: 'lafaard',
    russian: 'трус',
    latvian: 'gļēvulis',
    polish: 'tchórz',
    french: 'lâche, poltron',
    spanish: 'cobarde',
  },
  {
    av: 23462,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(minus + courage)',
    english: 'cowardice',
    swedish: 'feghet',
    norwegian: 'feighet',
    finnish: 'pelkuruus, arkuus',
    hungarian: 'gyávaság',
    german: 'Feigheit',
    dutch: 'lafheid',
    afrikaans: 'lafhartigheid',
    russian: 'трусость',
    latvian: 'gļēvulība',
    polish: 'tchórzostwo',
    french: 'lâcheté',
    spanish: 'cobardía',
  },
  {
    av: 23463,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(cowardice + description indicator)',
    english: 'cowardly',
    swedish: 'feg',
    norwegian: 'feigt',
    finnish: 'pelkurimainen, arka',
    hungarian: 'gyáva (mn.), gyáván',
    german: 'feig, feige',
    dutch: 'laf',
    afrikaans: 'lafhartig',
    russian: 'трусливый',
    latvian: 'gļēvi',
    polish: 'tchórzliwy',
    french: 'lâche',
    spanish: 'cobardemente',
  },
  {
    av: 23464,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + country)',
    english: 'currency',
    swedish: 'valuta',
    norwegian: 'valuta',
    finnish: 'valuutta',
    hungarian: 'pénznem',
    german: 'Währung',
    dutch: 'valuta',
    afrikaans: 'valuta, geldeenheid',
    russian: 'валюта',
    latvian: 'valūta',
    polish: 'waluta',
    french: 'devise, unité monétaire',
    spanish: 'moneda',
  },
  {
    av: 23465,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(take, bring, carry, move-(to) + digits (computer): to move digitally)',
    english: 'cut and paste (computer)-(to)',
    swedish: 'flytta (dator)',
    norwegian: 'klipp og lim (PC), flytte (PC)',
    finnish: 'leikkaa ja liitä (tietokone)',
    hungarian: 'kivágni-beilleszteni (szgép)',
    german: 'ausschneiden und einfügen',
    dutch: 'knippen en plakken (computer)',
    afrikaans: 'knip en plak (rekenaar) (om te)',
    russian: 'переносить (ПК)',
    latvian: 'izgriezt un ielīmēt (darbības datorā)',
    polish: 'wytnij i wklej (informatyka)',
    french: 'couper-coller (informatique)',
    spanish: 'cortar y pegar (ordenador)',
  },
  {
    av: 23466,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(brave + activity + action indicator)',
    english: 'dare-(to)',
    swedish: 'våga',
    norwegian: 'våge',
    finnish: 'rohjeta, uskaltaa',
    hungarian: 'bátorkodni, merészelni',
    german: 'wagen, riskieren',
    dutch: 'durven',
    afrikaans: 'wed (om te)',
    russian: 'осмелиться, решиться',
    latvian: 'uzdrošināties',
    polish: 'prowokować, wyzywać, ośmielać się',
    french: 'oser',
    spanish: 'atreverse',
  },
  {
    av: 23467,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(information + digits (computer): digital information)',
    english: 'data (digital information)',
    swedish: 'datainformation, data',
    norwegian: 'datainformasjon',
    finnish: 'data',
    hungarian: 'adat, digitális információ',
    german: 'Daten (digital), Digitaldaten',
    dutch: 'digitale gegevens, gegevens (digitaal)',
    afrikaans: 'data digitale (informasie)',
    russian: 'компьютерная информация',
    latvian: 'dati, digitalizēta informācija',
    polish: 'dane (cyfrowe)',
    french: 'donnée informatique',
    spanish: 'datos (información digital)',
  },
  {
    av: 23468,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to delete + forward + action indicator)',
    english: 'delete (computer)-(to)',
    swedish: 'radera (delete) (dator)',
    norwegian: 'slette framover (PC), delete',
    finnish: 'poistaa (tietokone)',
    hungarian: 'kitörölni (szgép)',
    german: 'löschen',
    dutch: 'verwijderen (computer), delete',
    afrikaans: 'uitvee (rekenaar) (om te)',
    russian: 'удалять (ПК)',
    latvian: 'izdzēst, atsaukt (darbības datorā)',
    polish: 'usuwać, kasować (w komputerze)',
    french: 'supprimer (informatique)',
    spanish: 'borrar, eliminar (ordenador)',
  },
  {
    av: 23469,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + design)',
    english: 'designer, planner',
    swedish: 'designer, formgivare',
    norwegian: 'planlegger, designer',
    finnish: 'suunnittelija, muotoilija',
    hungarian: 'tervező',
    german: 'Planer, Planerin, Konstrukteur, Konstrukteurin',
    dutch: 'ontwerper, bedenker',
    afrikaans: 'ontwerper beplanner',
    russian: 'дизайнер, планировщик',
    latvian: 'projektētājs, konstruktors, dizaineris, plānotājs',
    polish: 'projektant, planista',
    french: 'concepteur, créateur',
    spanish: 'diseñador, planificador',
  },
  {
    av: 23470,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(computer + tabletop)',
    english: 'desktop computer',
    swedish: 'dator (stationär), desktop',
    norwegian: 'datamaskin stasjonær',
    finnish: 'pöytäkone, tietokone',
    hungarian: 'asztali számítógép',
    german: 'Computer, PC',
    dutch: 'desktop (computer)',
    afrikaans: 'lessenaar rekenaar',
    russian: 'стационарный компьютер',
    latvian: 'galda dators, stacionārais dators',
    polish: 'komputer stacjonarny',
    french: 'ordinateur de bureau',
    spanish: 'ordenador de escritorio',
  },
  {
    av: 23471,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(detachment, separation, breakup + action indicator)',
    english: 'detach, take apart-(to)',
    swedish: 'ta isär, skilja',
    norwegian: 'løsrive, skille fra',
    finnish: 'erottaa, irrottaa',
    hungarian: 'elválasztani, különválasztani',
    german: 'trennen, abtrennen',
    dutch: 'scheiden (dingen), ontkoppelen',
    afrikaans: 'losmaak, ontkoppel (om te)',
    russian: 'отсоединить, разобрать',
    latvian: 'atdalīt, noņemt',
    polish: 'odłączyć, rozdzielić, rozerwać, rozłączyć',
    french: 'détacher',
    spanish: 'separar, desmontar',
  },
  {
    av: 23473,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + piece: meat cut into small pieces)',
    english: 'meat (diced), diced meat, chunks of meat',
    swedish: 'kött i bitar, grytbitar',
    norwegian: 'kjøtt skivet, kjøttbiter',
    finnish: 'liha (paloiteltu), liha (kuutioitu)',
    hungarian: 'húskockák, kockára vágott/darabolt/szeletelt hús',
    german: 'Fleischwürfel',
    dutch: 'vlees in blokjes',
    afrikaans: 'vleis (blokkies)',
    russian: 'мясо кусочками',
    latvian: 'gaļas gabaliņi, kapāta gaļa',
    polish: 'kawałki mięsa',
    french: 'viande en morceaux, carbonnade',
    spanish: 'carne en trozos',
  },
  {
    av: 23474,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(digits (computer) + description indicator)',
    english: 'digital',
    swedish: 'digital',
    norwegian: 'digital',
    finnish: 'digitaalinen',
    hungarian: 'digitális ',
    german: 'digital',
    dutch: 'digitaal (bijv.nw.)',
    afrikaans: 'digitaal (byv.nw.)',
    russian: 'цифровой, электронный',
    latvian: 'digitāls, elektronisks; ciparu tehnoloģijā',
    polish: 'cyfrowe, informatyczne',
    french: 'digital, numérique',
    spanish: 'digital',
  },
  {
    av: 23478,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to exit + vehicle + action indicator)',
    english: 'disembark-(to)',
    swedish: 'gå av (fordon)',
    norwegian: 'gå av (kjøretøy)',
    finnish: 'tulla ulos kulkuneuvosta, astua ulos kulkuneuvosta',
    hungarian: 'leszállni járműről',
    german: 'aussteigen, von Bord gehen',
    dutch: 'ontschepen (vliegtuig), uitstappen (voertuig)',
    afrikaans: 'afklim (om te)',
    russian: 'высаживаться',
    latvian: 'izcelties krastā',
    polish: 'wysiadać (z pojazdu)',
    french: "débarquer, sortir d'un véhicule",
    spanish: 'desembarcar',
  },
  {
    av: 23479,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + pen)',
    english: 'document, written record',
    swedish: 'dokument',
    norwegian: 'dokument',
    finnish: 'dokumentti, asiakirja',
    hungarian: 'dokumentum, írásos feljegyzés, jegyzet',
    german: 'Dokument, Akte',
    dutch: 'document',
    afrikaans: 'dokument, geskryfde rekord',
    russian: 'документ',
    latvian: 'dokuments, rakstisks ieraksts',
    polish: 'dokument',
    french: 'document',
    spanish: 'documento',
  },
  {
    av: 23480,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(play + up and down: play portraying conflicting emotions and upsetting events)',
    english: 'drama',
    swedish: 'drama',
    norwegian: 'drama',
    finnish: 'draama',
    hungarian: 'színdarab, színmű',
    german: 'Drama, Spiel, Theaterstück',
    dutch: 'drama (toneelstuk)',
    afrikaans: 'drama toneelstuk',
    russian: 'драма',
    latvian: 'drāma',
    polish: 'dramat, przedstawienie',
    french: 'pièce dramatique, tragédie',
    spanish: 'drama',
  },
  {
    av: 23481,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(little person + beard: imaginary small person with beard)',
    english: 'dwarf, gnome',
    swedish: 'dvärg, tomte (etc)',
    norwegian: 'fantasifigur gnom, dverg, nisse',
    finnish: 'tonttu, kääpiö',
    hungarian: 'manó, gnóm, törpe',
    german: 'Zwerg, Gnom, Wichtel',
    dutch: 'dwerg, kabouter',
    afrikaans: 'dwerg, kabouter',
    russian: 'гном',
    latvian: 'punduris',
    polish: 'krasnolud, karzeł, gnom',
    french: 'personnage imaginaire (nain à barbe)',
    spanish: 'enanos, gnomos',
  },
  {
    av: 23482,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(designer + electricity)',
    english: 'electrical engineer',
    swedish: 'elektroingenjör',
    norwegian: 'elektroingeniør',
    finnish: 'sähköinsinööri',
    hungarian: 'elektromérnök, villamosmérnök',
    german: 'Elektroingenieur, Elektroingenieurin',
    dutch: 'elektricien',
    afrikaans: 'elektriese ingenieur',
    russian: 'инженер-электрик',
    latvian: 'elektroinženieris',
    polish: 'inżynier elektryk',
    french: 'électricien, ingénieur électricien',
    spanish: 'ingeniero eléctrico',
  },
  {
    av: 23483,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(little person + fog)',
    english: 'elf (fog)',
    swedish: 'älva, alf, alv (dimma)',
    norwegian: 'fantasifigur alv (tåke)',
    finnish: 'sumutonttu',
    hungarian: 'ködbeli elf, tündérke, pöttöm ködemberke',
    german: 'Alb, Elfe',
    dutch: 'elf (mist)',
    afrikaans: 'elf (mis)',
    russian: 'туманный эльф',
    latvian: 'miglas elfs',
    polish: 'elf (duszek mgielny)',
    french: 'personnage imaginaire (elfe des brumes)',
    spanish: 'elfo (niebla)',
  },
  {
    av: 23484,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(little person + star)',
    english: 'elf (star)',
    swedish: 'älva, alf, alv (stjärna)',
    norwegian: 'fantasifigur alv (stjerne)',
    finnish: 'tähtitonttu',
    hungarian: 'csillag-elf, fénytündér, csillagtündér',
    german: 'Alb, Elfe',
    dutch: 'sterrekind',
    afrikaans: 'elf (ster)',
    russian: 'звёздный эльф',
    latvian: 'zvaigžņu elfs',
    polish: 'elf (duszek gwiezdny)',
    french: 'personnage imaginaire (elfe des étoiles)',
    spanish: 'elfo (estrella)',
  },
  {
    av: 23485,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(letter + digits (computer))',
    english: 'e-mail, email',
    swedish: 'e-post, e-brev, mejl',
    norwegian: 'e-mail, e-post',
    finnish: 'sähköposti',
    hungarian: 'e-mail, elektronikus levél',
    german: 'Email',
    dutch: 'e-mail',
    afrikaans: 'e-pos',
    russian: 'электронная почта',
    latvian: 'e-pasts',
    polish: 'E-mail',
    french: 'e-mail, courriel',
    spanish: 'e-mail',
  },
  {
    av: 23486,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(name + place + e-mail)',
    english: 'e-mail address, email address',
    swedish: 'e-postadress, mejladress',
    norwegian: 'e-mailadresse, e-postadresse',
    finnish: 'sähköpostiosoite',
    hungarian: 'e-mail cím, elektronikus cím',
    german: 'Emailadresse',
    dutch: 'e-mailadres',
    afrikaans: 'e-pos adres',
    russian: 'адресс электронной почты',
    latvian: 'e-pasta adrese',
    polish: 'adres e-mailowy',
    french: 'adresse e-mail, adresse de courriel',
    spanish: 'dirección de e-mail',
  },
  {
    av: 23487,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to enter + vehicle + action indicator)',
    english: 'embark, board-(to)',
    swedish: 'gå på (fordon), gå ombord',
    norwegian: 'entre, gå på (kjøretøy)',
    finnish: 'mennä kulkuneuvoon, nousta kulkuneuvoon',
    hungarian: 'felszállni, beszállni (járműre)',
    german: 'einschiffen, an Bord gehen',
    dutch: 'inschepen (vliegtuig), instappen',
    afrikaans: 'aan boord gaan (om te)',
    russian: 'входить в транспорт, вступать на борт',
    latvian: 'kāpt uz kuģa',
    polish: 'załadować na (pojazd)',
    french: 'embarquer, entrer dans un véhicule',
    spanish: 'embarcar, abordar',
  },
  {
    av: 23489,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(out of, exit (forward) + contents)',
    english: 'export',
    swedish: 'export',
    norwegian: 'eksport',
    finnish: 'vienti',
    hungarian: 'export (fn.)',
    german: 'Export, Ausfuhr',
    dutch: 'export, geëxporteerde goederen',
    afrikaans: 'uitvoer',
    russian: 'экспорт',
    latvian: 'eksports',
    polish: 'eksport, wysyłanie towaru, wywóz',
    french: 'exportation',
    spanish: 'exportación',
  },
  {
    av: 23490,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(export + action indicator)',
    english: 'export-(to)',
    swedish: 'exportera',
    norwegian: 'eksportere',
    finnish: 'viedä ulkomaille',
    hungarian: 'exportálni',
    german: 'exportieren (Daten), auslesen (Daten)',
    dutch: 'exporteren',
    afrikaans: 'uitvoer (om te)',
    russian: 'экспортировать, вывозить',
    latvian: 'eksportēt',
    polish: 'wysyłać, eksportować',
    french: 'exporter',
    spanish: 'exportar',
  },
  {
    av: 23491,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(out of, exit (forward) + digits (computer) + action indicator)',
    english: 'export (computer)-(to)',
    swedish: 'exportera (dator)',
    norwegian: 'eksportere (PC)',
    finnish: 'viedä (tietokone)',
    hungarian: 'exportálni, áthelyezni (szgépen)',
    german: 'exportieren (Daten), auslesen (Daten)',
    dutch: 'exporteren (computer)',
    afrikaans: 'uitvoer (rekenaar) (om te)',
    russian: 'экспорт (компьютер)',
    latvian: 'eksportēt (darbība datorā)',
    polish: 'wysyłać, przesyłać (informatyczne)',
    french: 'exporter (informatique)',
    spanish: 'exportar (ordenador)',
  },
  {
    av: 23492,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(export + description indicator)',
    english: 'exported',
    swedish: 'exporterad',
    norwegian: 'eksportert',
    finnish: 'viety ulkomaille',
    hungarian: 'export (mn.)',
    german: 'exportiert, ausgeführt (Waren)',
    dutch: 'geëxporteerd',
    afrikaans: 'uitgevoer',
    russian: 'экспортируемый, экспортированный',
    latvian: 'eksportēt',
    polish: 'wyeksportowany',
    french: 'exporté',
    spanish: 'exportado',
  },
  {
    av: 23493,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pointing device + eye)',
    english: 'eye mouse, eye gaze',
    swedish: 'ögonstyrning',
    norwegian: 'øyemus (PC)',
    finnish: 'katseohjain, katsehiiri',
    hungarian: 'szemegér, szemmel mutatás',
    german: 'Blicksteuerung (Computer)',
    dutch: 'oogmuis',
    afrikaans: 'oogmuis oog blik',
    russian: 'глазная компьютерная мышь',
    latvian: 'sekotājacs (datorā)',
    polish:
      'tracker pro, blink it itp. - urządzenie do kontrolowania komputera wzrokiem (myszka wzrokowa)',
    french: 'pointeur visuel',
    spanish: 'control con la vista',
  },
  {
    av: 23494,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe woman + wand)',
    english: 'fairy, fairy godmother',
    swedish: 'fe',
    norwegian: 'fantasifigur fe',
    finnish: 'keiju, haltijatar',
    hungarian: 'tündér (fn.)',
    german: 'Fee',
    dutch: 'fee',
    afrikaans: 'fee, fee peetma',
    russian: 'фея',
    latvian: 'lauma, laumiņa, feja',
    polish: 'wróżka, czarodziejka',
    french: 'personnage imaginaire (fée)',
    spanish: 'hada, hada madrina',
  },
  {
    av: 23495,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to go + asleep + action indicator)',
    english: 'fall asleep-(to)',
    swedish: 'somna',
    norwegian: 'sovne',
    finnish: 'nukahtaa',
    hungarian: 'elaludni',
    german: 'einschlafen',
    dutch: 'in slaap vallen',
    afrikaans: 'aan die slaap raak (om te)',
    russian: 'засыпать, заснуть',
    latvian: 'aizmigt',
    polish: 'zasypiać',
    french: "endormir-(s')",
    spanish: 'dormirse',
  },
  {
    av: 23496,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(designer + clothes)',
    english: 'fashion designer',
    swedish: 'kläddesigner, modeskapare',
    norwegian: 'moteskaper, klesdesigner',
    finnish: 'vaatesuunnittelija',
    hungarian: 'divattervező',
    german: 'Modedisigner, Modedisignerin',
    dutch: 'modeontwerper',
    afrikaans: 'mode ontwerper',
    russian: 'модельер, дизайнер одежды',
    latvian: 'modelētājs, modes dizainers',
    polish: 'projektant, kreator mody',
    french: 'créateur de mode, dessinateur de mode',
    spanish: 'diseñador de moda',
  },
  {
    av: 23497,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + telephone)',
    english: 'fax',
    swedish: 'fax',
    norwegian: 'faks',
    finnish: 'faksi',
    hungarian: 'fax, faxüzenet',
    german: 'Fax, Telefax',
    dutch: 'fax, faxbericht',
    afrikaans: 'faksimilieë',
    russian: 'факс',
    latvian: 'fakss',
    polish: 'Fax (list przesłany faksem)',
    french: 'fax, télécopie',
    spanish: 'fax',
  },
  {
    av: 23498,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(fax + action indicator)',
    english: 'fax-(to)',
    swedish: 'faxa',
    norwegian: 'fakse',
    finnish: 'faksata, lähettää faksi',
    hungarian: 'faxolni, elfaxolni ',
    german: 'faxen',
    dutch: 'faxen',
    afrikaans: 'faks (om te)',
    russian: 'послать факс',
    latvian: 'nosūtīt faksu',
    polish: 'faksować, wysyłać fax',
    french: 'faxer',
    spanish: 'enviar un fax',
  },
  {
    av: 23499,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + fax)',
    english: 'fax (machine)',
    swedish: 'fax (maskin)',
    norwegian: 'faks (maskin)',
    finnish: 'faksilaite',
    hungarian: 'faxológép, faxgép',
    german: 'Faxgerät',
    dutch: 'faxapparaat',
    afrikaans: 'faks (masjien)',
    russian: 'факс (аппарат)',
    latvian: 'faksa aparāts',
    polish: 'fax (urządzenie)',
    french: 'télécopieur',
    spanish: 'fax (máquina)',
  },
  {
    av: 23501,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(filling, fill, fullness + description after the fact indicator)',
    english: 'filled, stuffed',
    swedish: 'fylld',
    norwegian: 'fylt',
    finnish: 'täytetty',
    hungarian: 'töltött, megtöltött',
    german: 'gefüllt',
    dutch: 'gevuld',
    afrikaans: 'gevul',
    russian: 'заполненный',
    latvian: 'aizpildīts, pārpildīts',
    polish: 'napełniony, wypełniony, wypchany, nadziany',
    french: 'fourré, farci',
    spanish: 'relleno, lleno',
  },
  {
    av: 23502,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cabbage + filled)',
    english: 'filled cabbage, stuffed cabbage',
    swedish: 'kåldolmar',
    norwegian: 'kålrulett',
    finnish: 'kaalikääryle',
    hungarian: 'töltött káposzta',
    german: '(gefüllter) Weißkohl, Krautwickel',
    dutch: 'gevulde kool, opgevulde kool',
    afrikaans: 'gevulde kool',
    russian: 'голубцы',
    latvian: 'kāpostu pildījums',
    polish: 'gołąbki (potrawa)',
    french: 'chou farci',
    spanish: 'repollo relleno',
  },
  {
    av: 23503,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + filled)',
    english: 'filled food, stuffed food',
    swedish: 'mat med fyllning',
    norwegian: 'mat fylt',
    finnish: 'ruoka (täytetty)',
    hungarian: 'töltött étel (pl. csirke)',
    german: '(gefüllte) Speise',
    dutch: 'opgevuld voedsel, gevuld voedsel',
    afrikaans: 'gevulde voedsel',
    russian: 'еда с начинкой',
    latvian: 'pildījumi (ēdienā)',
    polish: 'potrawa faszerowana, nadziewana',
    french: 'aliment farci',
    spanish: 'comida rellena',
  },
  {
    av: 23504,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(leaf + filled)',
    english: 'filled leaf, dolma',
    swedish: 'dolme, dolma, blad med fyllning',
    norwegian: 'dolma, blad med fyll',
    finnish: 'dolma, lehtikääryle',
    hungarian: 'töltött szőlőlevél, dolma',
    german: '(gefülltes) Weinblatt',
    dutch: 'opgevulde bladeren, dolma (Nl)',
    afrikaans: 'gevulde blare (koolblare) dolma',
    russian: 'долма',
    latvian: 'dārzāja lapā ietīts ēdiens, dolma',
    polish: 'gołąbki z liści winogron (potrawa turecka)',
    french: 'feuille farcie',
    spanish: 'rollos de relleno',
  },
  {
    av: 23505,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vegetable + filled)',
    english: 'filled vegetable, stuffed vegetable',
    swedish: 'grönsak med fyllning',
    norwegian: 'grønnsak fylt',
    finnish: 'vihannekset (täytetyt)',
    hungarian: 'töltött zöldségféle (pl. paprika, gomba)',
    german: '(gefülltes) Gemüse',
    dutch: 'opgevulde groente, gevulde groente',
    afrikaans: 'gevulde groente',
    russian: 'фаршированные овощи',
    latvian: 'pildīti dārzeņi',
    polish: 'warzywa nadziewane, warzywa faszerowane',
    french: 'légume farci',
    spanish: 'vegetal relleno',
  },
  {
    av: 23506,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(alphabet + hand)',
    english: 'finger spelling, finger alphabet',
    swedish: 'handalfabetet',
    norwegian: 'fingerbokstavering, håndalfabet',
    finnish: 'sormiaakkoset',
    hungarian: 'ujjábécé',
    german: 'Fingersprache, Fingeralphabet',
    dutch: 'vingeralfabet',
    afrikaans: 'vinger alfabet spelling',
    russian: 'жестовый алфавит',
    latvian: 'kurlmēmo ābece, zīmju ābece',
    polish: 'alfabet palcowy (odmiana języka migowego dla głuchoniewidomych)',
    french: 'alphabet signé',
    spanish: 'deletreo con las manos, alfabeto dactilológico',
  },
  {
    av: 23507,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(finger spelling + action indicator)',
    english: 'fingerspell-(to)',
    swedish: 'stava med handalfabetet',
    norwegian: 'fingerbokstavere',
    finnish: 'sormittaa',
    hungarian: 'ujjábécével beszélni, azt használni',
    german: 'buchstabieren (mit Fingern)',
    dutch: 'vingerspellen',
    afrikaans: 'vinger spel (om te)',
    russian: 'говорить на языке жестов',
    latvian: 'zīmju valoda, kulmēmo valoda',
    polish: 'porozumiewać się alfabetem palcowym',
    french: 'signer (alphabet de langue des signes)',
    spanish: 'deletrear con las manos',
  },
  {
    av: 23508,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + linear thing + thing indicator: fish food shaped into sticks)',
    english: 'fish finger',
    swedish: 'fiskpinne',
    norwegian: 'fiskepinne',
    finnish: 'kalapuikko',
    hungarian: 'halrudacska, halrúd',
    german: 'Fischstäbchen',
    dutch: 'visticks',
    afrikaans: 'vis vinger (voedsel)',
    russian: 'рыбные палочки',
    latvian: 'zivju nūjiņas',
    polish: 'paluszki rybne',
    french: 'stick de poisson',
    spanish: 'varita de pescado',
  },
  {
    av: 23509,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + fish)',
    english: 'fisherman',
    swedish: 'fiskare',
    norwegian: 'fisker',
    finnish: 'kalastaja',
    hungarian: 'halász, horgász',
    german: 'Fischer, Fischerin',
    dutch: 'visser',
    afrikaans: 'visserman',
    russian: 'рыбак',
    latvian: 'zvejnieks',
    polish: 'rybak, wędkarz',
    french: 'pêcheur',
    spanish: 'pescador',
  },
  {
    av: 23510,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(little person + flower)',
    english: 'flower fairy',
    swedish: 'blomsterälva, blomsteralv',
    norwegian: 'fantasifigur blomsteralv',
    finnish: 'kukkaiskeiju',
    hungarian: 'virágtündér',
    german: 'Blumenfee',
    dutch: 'bloemenfee',
    afrikaans: 'blomme fee',
    russian: 'цветочная фея',
    latvian: 'ziedu laumiņa, ziedu feja',
    polish: 'kwiatowa wróżka',
    french: 'personnage imaginaire (fée des fleurs)',
    spanish: 'hada de las flores',
  },
  {
    av: 23512,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + file)',
    english: 'folder (digital)',
    swedish: 'mapp (dator)',
    norwegian: 'mappe (PC)',
    finnish: 'kansio (tietokone)',
    hungarian: 'mappa (szgépen)',
    german: 'Ordner',
    dutch: 'map (computer)',
    afrikaans: 'leêr (digitaal)',
    russian: 'папка (компьютер)',
    latvian: 'mape (elektroniska)',
    polish: 'folder (w komputerze)',
    french: 'fichier (informatique)',
    spanish: 'carpeta (digital)',
  },
  {
    av: 23513,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(similar + home)',
    english: 'foster home',
    swedish: 'fosterhem',
    norwegian: 'fosterhjem',
    finnish: 'kasvatuskoti',
    hungarian: 'nevelőszülői otthon, nevelőotthon',
    german: 'Ersatzfamilie, Pflegefamilie',
    dutch: 'vervangingstehuis, pleeghuis',
    afrikaans: 'pleeg huis kinder huis',
    russian: 'детский дом',
    latvian: 'audžuģimenes mājas',
    polish: 'dom zastępczy (dom dziecka)',
    french: "maison d'accueil, foyer d'accueil",
    spanish: 'hogar adoptivo',
  },
  {
    av: 23514,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cupboard + ice)',
    english: 'freezer',
    swedish: 'frys',
    norwegian: 'fryser',
    finnish: 'pakastin',
    hungarian: 'fagyasztó, mélyhűtő',
    german: 'Tiefkühltruhe, Gefrierschrank',
    dutch: 'diepvries, vriezer',
    afrikaans: 'vrieskas',
    russian: 'морозилка',
    latvian: 'saldētava',
    polish: 'zamrażarka, lodówka',
    french: 'congélateur, surgélateur',
    spanish: 'congelador',
  },
  {
    av: 23515,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pudding, cream + fruit)',
    english: 'fruit cream, compote',
    swedish: 'kräm, fruktkräm, kompott',
    norwegian: 'fruktsalat, fruktkompott',
    finnish: 'hedelmähilloke',
    hungarian: 'gyümölcskrém, kompót',
    german: 'Kompott',
    dutch: 'vruchtenmoes, moes van vruchten',
    afrikaans: 'vrugte room moes',
    russian: 'фруктовый крем',
    latvian: 'augļu kompots, augļu krēms',
    polish: 'krem owocowy, deser owocowy',
    french: 'compote',
    spanish: 'crema de fruta, compota',
  },
  {
    av: 23516,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ability (half sized) + work)',
    english: 'function',
    swedish: 'funktion',
    norwegian: 'funksjon',
    finnish: 'toiminta',
    hungarian: 'működés, funkció',
    german: 'funktionell, funktionstüchtig',
    dutch: 'functie',
    afrikaans: 'funksie',
    russian: 'функция',
    latvian: 'funkcija',
    polish: 'funkcja, działanie',
    french: 'fonction',
    spanish: 'función',
  },
  {
    av: 23517,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(function + action indicator)',
    english: 'function-(to)',
    swedish: 'fungera',
    norwegian: 'fungere',
    finnish: 'toimia',
    hungarian: 'működni, funkcionálni',
    german: 'funktionieren, wirken',
    dutch: 'functioneren',
    afrikaans: 'funksioneer (om te)',
    russian: 'функционировать',
    latvian: 'funkcionēt',
    polish: 'działać, funkcjonować',
    french: 'fonctionner',
    spanish: 'funcionar',
  },
  {
    av: 23518,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(function + description indicator)',
    english: 'functional',
    swedish: 'fungerande',
    norwegian: 'funksjonelt',
    finnish: 'toimiva',
    hungarian: 'működési, funkcionális, gyakorlati',
    german: 'funktionell, funktionstüchtig',
    dutch: 'functioneel',
    afrikaans: 'funksioneel',
    russian: 'функциональный',
    latvian: 'funkcionāls',
    polish: 'funkcjonalny, działający, wygodny',
    french: 'fonctionnel',
    spanish: 'funcional',
  },
  {
    av: 23519,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + garden)',
    english: 'gardener',
    swedish: 'trädgårdsmästare',
    norwegian: 'gartner',
    finnish: 'puutarhuri',
    hungarian: 'kertész',
    german: 'Gärtner, Gärtnerin',
    dutch: 'tuinman',
    afrikaans: 'tuinier',
    russian: 'садовник',
    latvian: 'dārznieks',
    polish: 'ogrodnik',
    french: 'jardinier',
    spanish: 'jardinero',
  },
  {
    av: 23520,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(make-believe person + transparent) Preferred NEW SYNONYM, replacing 14436',
    english: 'ghost, phantom',
    swedish: 'spöke',
    norwegian: 'fantasifigur spøkelse',
    finnish: 'kummitus, haamu, aave',
    hungarian: 'kísértet, fantom',
    german: 'Gespenst',
    dutch: 'spook',
    afrikaans: 'spook, gedaante',
    russian: 'призрак, привидение',
    latvian: 'spoks, fantoms',
    polish: 'duch',
    french: 'personnage imaginaire (fantôme)',
    spanish: 'fantasma',
  },
  {
    av: 23521,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe person + gigantic)',
    english: 'giant',
    swedish: 'jätte',
    norwegian: 'fantasifigur gigant, rise, jette',
    finnish: 'jättiläinen',
    hungarian: 'óriás (mesében)',
    german: 'Riese',
    dutch: 'reus',
    afrikaans: 'reus',
    russian: 'великан',
    latvian: 'milzis, gigants',
    polish: 'olbrzym, gigant, tytan (postać mitologiczna)',
    french: 'personnage imaginaire (géant)',
    spanish: 'gigante',
  },
  {
    av: 23522,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + gigantic)',
    english: 'giant (human)',
    swedish: 'jätte (mänsklig)',
    norwegian: 'gigant (person)',
    finnish: 'pitkä ihminen',
    hungarian: 'óriásnövésű ember',
    german: 'Riese (Person)',
    dutch: 'reus (groot persoon)',
    afrikaans: 'reus (mens)',
    russian: 'гигант',
    latvian: 'milzis (cilvēks)',
    polish: 'olbrzym, gigant, wielkolud (człowiek)',
    french: 'géant (homme)',
    spanish: 'gigante (humano)',
  },
  {
    av: 23523,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(debarkation, disembarkation (ashore) + action indicator)',
    english: 'go ashore-(to)',
    swedish: 'gå iland',
    norwegian: 'gå i land',
    finnish: 'rantautua',
    hungarian: 'partra szállni',
    german: '(ans Ufer) gehen, (an Land) gehen',
    dutch: 'aan land gaan',
    afrikaans: 'aan land gaan (om te)',
    russian: 'сойти на берег',
    latvian: 'izkāpt krastā',
    polish: 'zejść na ląd',
    french: 'débarquer (embarcation)',
    spanish: 'ir hacia la costa',
  },
  {
    av: 23524,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(boarding, embarkation (to sea) + action indicator)',
    english: 'go to sea-(to)',
    swedish: 'gå till sjöss',
    norwegian: 'dra til sjøs',
    finnish: 'lähteä merille',
    hungarian: 'vízre szállni, tengerre szállni',
    german: '(zur See) fahren',
    dutch: 'uitvaren',
    afrikaans: 'uitvaar (om te)',
    russian: 'уходить в море',
    latvian: 'doties jūrā',
    polish: 'podróżować przez morze',
    french: 'prendre la mer',
    spanish: 'ir al mar',
  },
  {
    av: 23525,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe person + night)',
    english: 'goblin',
    swedish: 'svartalf',
    norwegian: 'fantasifigur nattalv',
    finnish: 'menninkäinen',
    hungarian: 'kobold, gonosz szellem, manó',
    german: 'Kobold, Alb',
    dutch: 'kobold (sprookjesfiguur)',
    afrikaans: 'kabouter',
    russian: 'гоблин',
    latvian: 'rūķītis, mājas gariņš',
    polish: 'goblin, skrzat',
    french: 'personnage imaginaire (nocturne), gobelin',
    spanish: 'duende',
  },
  {
    av: 23526,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pointing device + head)',
    english: 'headmouse',
    swedish: 'huvudmus',
    norwegian: 'hodemus',
    finnish: 'otsahiiri, päähiiri',
    hungarian: 'fejegér',
    german: 'Kopfmaus (Computer)',
    dutch: 'hoofdmuis',
    afrikaans: 'hoofmuis',
    russian: 'головная компьютерная мышь',
    latvian: 'ar galvu vadāma pele (datoram)',
    polish: 'komputerowa mysz nagłowna (urządzenie sterujące komputerem za pomocą ruchów głowy)',
    french: 'pointeur frontal',
    spanish: 'ratón virtual',
  },
  {
    av: 23528,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(person + heroic)',
    english: 'hero',
    swedish: 'hjälte',
    norwegian: 'helt',
    finnish: 'sankari',
    hungarian: 'hős (fn.)',
    german: 'Supermann, Actionfigur, Held',
    dutch: 'superman',
    afrikaans: 'held',
    russian: 'герой',
    latvian: 'varonis',
    polish: 'bohater',
    french: 'héros',
    spanish: 'héroe',
  },
  {
    av: 23529,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(brave + intensity + description indicator)',
    english: 'heroic',
    swedish: 'djärv, hjältemodig, tapper',
    norwegian: 'heroisk',
    finnish: 'sankarillinen',
    hungarian: 'hősies, hős (mn.)',
    german: 'heldenhaft, heroisch',
    dutch: 'heldhaftig, heroïsch',
    afrikaans: 'heldhaftig',
    russian: 'героический',
    latvian: 'varonīgs',
    polish: 'bohaterski, odważny',
    french: 'héroïque',
    spanish: 'heroico',
  },
  {
    av: 23530,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + colour + silver [contr.]: often called “silver of the sea”)',
    english: 'herring, sardine',
    swedish: 'sill, sardin',
    norwegian: 'sild, sardin',
    finnish: 'silli, silakka, sardiini',
    hungarian: 'hering, szardínia',
    german: 'Hering',
    dutch: 'haring, sardien, sardientje (Nl)',
    afrikaans: 'sardien',
    russian: 'сельдь, сардина',
    latvian: 'siļķe, sardīne',
    polish: 'śledź, sardynka (ryba+jedzenie+łyżka)',
    french: 'hareng, sardine',
    spanish: 'arenque, sardina',
  },
  {
    av: 23531,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(little person + foot)',
    english: 'hobbit',
    swedish: 'hobbit',
    norwegian: 'fantasifigur hobbit',
    finnish: 'hobitti',
    hungarian: 'hobbit',
    german: 'Hobbit (fiktives Wesen)',
    dutch: 'hobbit',
    afrikaans: 'hobbit',
    russian: 'хоббит',
    latvian: 'hobits',
    polish: 'hobbit',
    french: 'personnage imaginaire (hobbit)',
    spanish: 'hobbit',
  },
  {
    av: 23532,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hand + goods + action indicator)',
    english: 'hold (with hand)-(to)',
    swedish: 'hålla',
    norwegian: 'holde',
    finnish: 'pitää kiinni, pidellä',
    hungarian: 'fogni, tartani, megtartani, kézben fogni/tartani',
    german: 'halten',
    dutch: 'vasthouden',
    afrikaans: 'vashou (met hand) (om te)',
    russian: 'держать',
    latvian: 'turēt (ar roku)',
    polish: 'trzymać w ręku',
    french: 'tenir (à la main)',
    spanish: 'detener, retener (con la mano)',
  },
  {
    av: 23533,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + knowledge + house: study work done at home [contr.])',
    english: 'homework, home studying',
    swedish: 'läxa',
    norwegian: 'hjemmelekse',
    finnish: 'läksyt, kotitehtävät',
    hungarian: 'házi feladat',
    german: 'Hausaufgaben',
    dutch: 'huiswerk',
    afrikaans: 'huiswerk, tuis studie',
    russian: 'домашнее задание',
    latvian: 'mājas darbs, mājas uzdevums',
    polish: 'praca domowa, zadanie domowe',
    french: 'devoir scolaire',
    spanish: 'tarea, estudio en casa',
  },
  {
    av: 23534,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(happy + future (uncertain))',
    english: 'hope',
    swedish: 'hopp',
    norwegian: 'håp',
    finnish: 'toivo',
    hungarian: 'remény',
    german: 'Hoffnung',
    dutch: 'hoop',
    afrikaans: 'hoop',
    russian: 'надежда',
    latvian: 'cerība',
    polish: 'nadzieja',
    french: 'espoir, espérance',
    spanish: 'esperanza',
  },
  {
    av: 23535,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(hope + description indicator)',
    english: 'hopeful',
    swedish: 'hoppfull',
    norwegian: 'håpefull',
    finnish: 'toiveikas',
    hungarian: 'reményteljes, ígéretes, remélhetőleg',
    german: 'hoffnungsvoll',
    dutch: 'hoopvol',
    afrikaans: 'hoopvol',
    russian: 'надеющийся',
    latvian: 'cerīgs',
    polish: 'pełen nadziei',
    french: "prometteur, plein d'espoir, encourageant",
    spanish: 'esperanzado',
  },
  {
    av: 23536,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + house: work to maintain a house)',
    english: 'house work, housekeeping, housework',
    swedish: 'hushållsarbete, hemarbete',
    norwegian: 'hjemmearbeid',
    finnish: 'kotityöt, taloustyöt',
    hungarian: 'házimunka',
    german: 'Haushaltsführung',
    dutch: 'huiswerk',
    afrikaans: 'tuisteskepper, huiswerk',
    russian: 'домашняя работа',
    latvian: 'saimniecības darbi',
    polish: 'prace domowe',
    french: 'ménage (travaux de), tâches ménagères',
    spanish: 'tareas domésticas',
  },
  {
    av: 23537,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hunt, hunting + action indicator)',
    english: 'hunt-(to)',
    swedish: 'jaga, skjuta',
    norwegian: 'jakte',
    finnish: 'metsästää',
    hungarian: 'vadászni',
    german: 'jagen',
    dutch: 'jagen',
    afrikaans: 'jag (om te)',
    russian: 'охотиться',
    latvian: 'medīt',
    polish: 'polować (na zwierzęta)',
    french: 'chasser (un animal)',
    spanish: 'cazar',
  },
  {
    av: 23538,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(into + contents)',
    english: 'import',
    swedish: 'import',
    norwegian: 'import',
    finnish: 'tuonti',
    hungarian: 'import (fn.)',
    german: 'Importgut, Einfuhrgut',
    dutch: 'import, geïmporteerde goederen',
    afrikaans: 'invoer',
    russian: 'импорт, ввоз',
    latvian: 'imports',
    polish: 'import (towar)',
    french: 'importation',
    spanish: 'importación',
  },
  {
    av: 23539,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(import + action indicator)',
    english: 'import-(to)',
    swedish: 'importera',
    norwegian: 'importere',
    finnish: 'tuoda ulkomailta',
    hungarian: 'importálni',
    german: 'importieren (Waren), einführen (Waren)',
    dutch: 'importeren',
    afrikaans: 'invoer (om te)',
    russian: 'импортитовать, ввозить, привозить',
    latvian: 'importēt, ievest',
    polish: 'importować',
    french: 'importer',
    spanish: 'importar',
  },
  {
    av: 23540,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(into + data (digital information) + action indicator)',
    english: 'import (computer)-(to)',
    swedish: 'importera (dator)',
    norwegian: 'import (PC)',
    finnish: 'tuoda (tietokone)',
    hungarian: 'importálni (szgép)',
    german: 'importieren (Daten), einlesen (Daten)',
    dutch: 'importeren (computer)',
    afrikaans: 'invoer (rekenaar, data) om te)',
    russian: 'импортировать (компьютер)',
    latvian: 'importēt (darbība datorā)',
    polish: 'import danych (informatyka)',
    french: 'importer (ordinateur)',
    spanish: 'importar (ordenador)',
  },
  {
    av: 23541,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(import + description indicator)',
    english: 'imported',
    swedish: 'importerad',
    norwegian: 'importert',
    finnish: 'tuotu ulkomailta',
    hungarian: 'importált',
    german: 'importiert, eingeführt (Waren)',
    dutch: 'geïmporteerd',
    afrikaans: 'ingevoer',
    russian: 'импортированный',
    latvian: 'importēts, ievests',
    polish: 'importowane',
    french: 'importé (ordinateur)',
    spanish: 'importado',
  },
  {
    av: 23543,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(net + digital world) SYMBOL SYNONYM',
    english: 'internet (1)',
    swedish: 'internet (1)',
    norwegian: 'internett (1)',
    finnish: 'internetti, netti, internet',
    hungarian: 'internet, világháló',
    german: 'Internet (1)',
    dutch: 'internet (2)',
    afrikaans: 'internet (1)',
    russian: 'интернет (1)',
    latvian: 'internets (1)',
    polish: 'Internet (1)',
    french: 'Internet (1)',
    spanish: 'internet (1)',
  },
  {
    av: 23544,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(exchange + digital world) SYMBOL SYNONYM',
    english: 'internet (2)',
    swedish: 'internet (2)',
    norwegian: 'internett (2)',
    finnish: 'internetti, netti, internet',
    hungarian: 'internet, világháló',
    german: 'Internet (2)',
    dutch: 'internet (2)',
    afrikaans: 'internet (2)',
    russian: 'интернет (2)',
    latvian: 'internets (2)',
    polish: 'Internet (2)',
    french: 'Internet (2)',
    spanish: 'internet (2)',
  },
  {
    av: 23545,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(net + digital space (limited)) SYMBOL SYNONYM',
    english: 'intranet (1)',
    swedish: 'intranet (1)',
    norwegian: 'intranett (1)',
    finnish: 'intranetti, intranet',
    hungarian: 'intranet',
    german: 'Intranet (begrenztes Netzwerk) (1)',
    dutch: 'intranet (1)',
    afrikaans: 'intranet (1)',
    russian: 'интранет (1)',
    latvian: 'iekštīkls (1)',
    polish: 'Intranet (1)',
    french: 'intranet (1)',
    spanish: 'intranet (1)',
  },
  {
    av: 23546,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(exchange + digital space (limited)) SYMBOL SYNONYM',
    english: 'intranet (2)',
    swedish: 'intranet (2)',
    norwegian: 'intranett (2)',
    finnish: 'intranetti, intranet',
    hungarian: 'intranet',
    german: 'Intranet (begrenztes Netzwerk) (2)',
    dutch: 'Intranet (2)',
    afrikaans: 'intranet (2)',
    russian: 'интранет (2)',
    latvian: 'Iekštīkls (2)',
    polish: 'Intranet (2)',
    french: 'intranet (2)',
    spanish: 'intranet (2)',
  },
  {
    av: 23547,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to say + name + action indicator)',
    english: 'introduce, present-(to)',
    swedish: 'presentera',
    norwegian: 'introdusere, presentere',
    finnish: 'esitellä, kertoa nimi',
    hungarian: 'bemutatni, bemutatkozni, nevet megmondani',
    german: '(sich) vorstellen',
    dutch: 'voorstellen (zich), introduceren',
    afrikaans: 'voorstel (om te)',
    russian: 'представляться',
    latvian: 'ieviest, iepazīstināt, stādīt priekšā',
    polish: 'wprowadzić, przedstawić, zaprezentować',
    french: 'introduire, présenter',
    spanish: 'presentar, introducir',
  },
  {
    av: 23548,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(writer + news)',
    english: 'journalist',
    swedish: 'journalist',
    norwegian: 'journalist',
    finnish: 'journalisti',
    hungarian: 'újságíró, publicista',
    german: 'Journalist',
    dutch: 'journalist',
    afrikaans: 'joernalis',
    russian: 'журналист',
    latvian: 'žurnālists',
    polish: 'dziennikarz',
    french: 'journaliste',
    spanish: 'periodista',
  },
  {
    av: 23549,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pointing device + linear thing + thing indicator)',
    english: 'joystick',
    swedish: 'joystick, styrspak',
    norwegian: 'joystick, styrespak',
    finnish: 'joystick, ohjain',
    hungarian: 'joystick, botkormány',
    german: 'Joystick',
    dutch: 'joystick',
    afrikaans: 'stuurstok, joystick',
    russian: 'джойстик',
    latvian: 'vadības pults',
    polish: 'joystick',
    french: 'joystick',
    spanish: 'palanca de mando, joystick',
  },
  {
    av: 23551,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + horse)',
    english: 'Kazakhstan',
    swedish: 'Kazakstan',
    norwegian: 'Kazakhstan',
    finnish: 'Kazakstan',
    hungarian: 'Kazahsztán',
    german: 'Kasakstan',
    dutch: 'Kazachstan',
    afrikaans: 'Kazakhstan',
    russian: 'Казахстан',
    latvian: 'Kazahija',
    polish: 'Kazachstan',
    french: 'Kazakhstan',
    spanish: 'Kazajstán',
  },
  {
    av: 23552,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tomato sauce + intensity)',
    english: 'ketchup',
    swedish: 'ketchup',
    norwegian: 'ketchup',
    finnish: 'ketsuppi',
    hungarian: 'kecsöp',
    german: 'Ketchup',
    dutch: 'ketchup',
    afrikaans: 'tamatiesous',
    russian: 'кетчуп',
    latvian: 'asa tomātu mērce, kečups',
    polish: 'ketchup',
    french: 'ketchup',
    spanish: 'ketchup, salsa de tomate',
  },
  {
    av: 23553,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part + keyboard)',
    english: 'key (computer)',
    swedish: 'tangent (dator)',
    norwegian: 'tast (PC)',
    finnish: 'näppäin (tietokone)',
    hungarian: 'billentyű (szgép)',
    german: 'Taste, Eingabetaste',
    dutch: 'toets (toetsenbord)',
    afrikaans: 'toets (rekenaar)',
    russian: 'клавиша (компьютер)',
    latvian: 'taustiņš, datora',
    polish: 'przycisk, klawisz klawiatury komputerowej',
    french: 'touche de clavier (ordinateur)',
    spanish: 'tecla (ordenador)',
  },
  {
    av: 23554,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(help + keyboard + thing indicator)',
    english: 'key guard',
    swedish: 'tangentbordsöverlägg, raster (dator)',
    norwegian: 'hjelpetastatur',
    finnish: 'reikälevy',
    hungarian: 'billentyűvédő, billentyűmaszk',
    german: 'Tastaturabdeckung, Speichelschutz (Tastatur)',
    dutch: 'rooster voor toetsenbord, raster voor toetsenbord',
    afrikaans: 'rooster voor toetsbord rekenaar',
    russian: 'вспомогательная накладка для клавиатуры',
    latvian: 'tautiņu slēgs',
    polish: 'nakładka na klawiaturę',
    french: 'guide-doigts',
    spanish: 'protector de teclado',
  },
  {
    av: 23555,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + alphabet)',
    english: 'keyboard (computer)',
    swedish: 'tangentbord (dator)',
    norwegian: 'tastatur (PC)',
    finnish: 'tietokoneen näppäimistö, tietokoneen näppis',
    hungarian: 'billentyűzet, klaviatúra (szgép)',
    german: 'Tastatur (Computer)',
    dutch: 'toetsenbord',
    afrikaans: 'sleutelbord (rekenaar)',
    russian: 'клавиатура (компьютер)',
    latvian: 'tastatūra, datora',
    polish: 'klawiatura komputerowa',
    french: 'clavier (ordinateur)',
    spanish: 'teclado (ordenador)',
  },
  {
    av: 23556,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(keyboard + big)',
    english: 'keyboard (expanded)',
    swedish: 'tangentbord (förstorat)',
    norwegian: 'tastatur utvidet (PC)',
    finnish: 'laajennettu näppäimistö, laajennettu näppis',
    hungarian: 'billentyűzet– óriás, óriás klaviatúra',
    german: '(erweiterte) Tastatur',
    dutch: 'toetsenbord (groot)',
    afrikaans: 'sleutelbord (rekenaar) (vergroot)',
    russian: 'клавиатура (расширенная)',
    latvian: 'tastatūra, paplašināta',
    polish: 'klawiatura komputerowa rozszerzona',
    french: 'clavier (étendu)',
    spanish: 'teclado (ampliado)',
  },
  {
    av: 23557,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(keyboard + small)',
    english: 'keyboard (mini)',
    swedish: 'tangentbord (förminskat)',
    norwegian: 'tastatur mini',
    finnish: 'mininäppäimistö, mininäppis',
    hungarian: 'billentyűzet – mini, miniatűr klaviatúra',
    german: 'Minitastatur',
    dutch: 'toetsenbord (klein)',
    afrikaans: 'sleutelbord (rekenaar) (klein)',
    russian: 'мини клавиатура',
    latvian: 'tastatūra, mini',
    polish: 'klawiatura komputerowa mini',
    french: 'clavier (mini)',
    spanish: 'teclado (mini)',
  },
  {
    av: 23558,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + child)',
    english: 'kindergarten, preschool, nursery, play group',
    swedish: 'förskola',
    norwegian: 'barnehage, førskole',
    finnish: 'esikoulu, lastentarha',
    hungarian: 'óvoda, bölcsőde, játszócsoport',
    german: 'Kindergarten, Kinderkrippe, Vorschule, Kindertagesstätte, Hort',
    dutch: 'crèche, kinderdagverblijf',
    afrikaans: 'kleuterskool',
    russian: 'детский сад, дошкольное учреждение',
    latvian: 'bērnudārzs, pirmsskola, silīte, rotaļlaukums',
    polish: 'przedszkole',
    french: "jardin d'enfants, école maternelle",
    spanish: 'guardería',
  },
  {
    av: 23559,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + crown)',
    english: 'king',
    swedish: 'kung',
    norwegian: 'konge',
    finnish: 'kuningas',
    hungarian: 'király',
    german: 'König',
    dutch: 'koning',
    afrikaans: 'koning',
    russian: 'король',
    latvian: 'karalis',
    polish: 'król',
    french: 'roi',
    spanish: 'rey',
  },
  {
    av: 23560,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(design + garden)',
    english: 'landscape design',
    swedish: 'landskapsarkitektur',
    norwegian: 'landskapsarkitektur',
    finnish: 'maisema-arkkitehtuuri',
    hungarian: 'parkosítás, tájkertészet',
    german: 'Landschaftsplanung',
    dutch: 'landschapsarchitectuur',
    afrikaans: 'landskap ontwerp',
    russian: 'ландшафтный дизайн',
    latvian: 'ainavu plānošana',
    polish: 'projektowanie ogrodów, krajobrazów',
    french: 'architecture de jardin, architecture du paysage',
    spanish: 'diseño de jardines',
  },
  {
    av: 23561,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(designer + garden)',
    english: 'landscape designer',
    swedish: 'landskapsarkitekt',
    norwegian: 'landskapsarkitekt',
    finnish: 'maisema-arkkitehti',
    hungarian: 'tájkertész, tájkerttervező',
    german: 'Lands chaftsplaner, Landschaftsplanerin',
    dutch: 'landschapsarchitect',
    afrikaans: 'landskap argitek, landskap ontwerper',
    russian: 'ландшафтный дизайнер',
    latvian: 'ainavu plānotājs',
    polish: 'projektant ogrodów, krajobrazów',
    french: 'architecte-paysagiste',
    spanish: 'diseñador de jardines',
  },
  {
    av: 23562,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(computer + to carry)',
    english: 'laptop',
    swedish: 'dator (bärbar), laptop',
    norwegian: 'laptop, bærbar datamaskin',
    finnish: 'kannettava tietokone, läppäri',
    hungarian: 'laptop',
    german: 'Notebook-Computer, tragbarer Rechner, tragbarer PC',
    dutch: 'laptop',
    afrikaans: 'skootrekenaar',
    russian: 'ноутбук, лэптоп',
    latvian: 'klēpjdators, portatīvais dators',
    polish: 'laptop, netbook, przenośny komputer',
    french: 'ordinateur portable',
    spanish: 'ordenador portátil, computadora portátil',
  },
  {
    av: 23563,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(tabletop + glassware + action indicator)',
    english: 'lay the table-(to)',
    swedish: 'duka',
    norwegian: 'dekke bordet, duke',
    finnish: 'kattaa pöytä',
    hungarian: 'megteríteni az asztalt, asztalt teríteni',
    german: 'den Tisch decken',
    dutch: 'tafel dekken',
    afrikaans: 'tafel dek (om te)',
    russian: 'накрывать на стол',
    latvian: 'klāt galdu',
    polish: 'nakrywać do stołu',
    french: 'mettre la table',
    spanish: 'poner la mesa',
  },
  {
    av: 23564,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to speak + knowledge + limited time)',
    english: 'lecture',
    swedish: 'föreläsning',
    norwegian: 'forelesning',
    finnish: 'esitelmä, luento',
    hungarian: 'előadás',
    german: 'Vortrag',
    dutch: 'lezing, voordracht',
    afrikaans: 'lesing',
    russian: 'лекция',
    latvian: 'lekcija',
    polish: 'wykład',
    french: 'cours, conférence',
    spanish: 'clase, conferencia',
  },
  {
    av: 23565,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(lecture + action indicator)',
    english: 'lecture-(to)',
    swedish: 'föreläsa',
    norwegian: 'forelese',
    finnish: 'esitelmöidä, luennoida',
    hungarian: 'előadni, oktatni',
    german: 'vortragen, (Vortrag) halten',
    dutch: 'lezing geven, voordracht houden',
    afrikaans: 'lesing gee (om te)',
    russian: 'читать лекцию',
    latvian: 'lasīt lekciju',
    polish: 'wykładać',
    french: 'donner un cours, faire une conférence',
    spanish: 'dar clase, dar una conferencia',
  },
  {
    av: 23566,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(little person + shamrock)',
    english: 'leprechaun',
    swedish: 'leprechaun (Irland)',
    norwegian: 'fantasifigur leprechaun (irsk)',
    finnish: 'leprechaun, haltija, tonttu',
    hungarian: 'kobold, manó (Írország)',
    german: 'Kobold',
    dutch: 'leperkaantje (Iers)',
    afrikaans: 'dwerg',
    russian: 'гном, лепрекон',
    latvian: 'gariņš, rūķis (ļauns, nerātns)',
    polish: 'krasnoludek, skrzat',
    french: 'personnage imaginaire (lutin)',
    spanish: 'duende',
  },
  {
    av: 23567,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limited time + to learn [contr.])',
    english: 'lesson, lecture, class',
    swedish: 'lektion',
    norwegian: 'skoletime',
    finnish: 'oppitunti',
    hungarian: 'óra, leckeóra, előadás',
    german: 'Unterrichtsstunde, Lektion, Stunde',
    dutch: 'lestijd, lesuur, les',
    afrikaans: 'les, lesing, klas',
    russian: 'урок, лекция',
    latvian: 'stunda, lekcija, nodarbība',
    polish: 'lekcja, zajęcia w szkole, na uczelni',
    french: 'cours, leçon',
    spanish: 'lección, clase',
  },
  {
    av: 23568,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + library)',
    english: 'librarian',
    swedish: 'bibliotekarie',
    norwegian: 'bibliotekar',
    finnish: 'kirjastonhoitaja',
    hungarian: 'könyvtáros',
    german: 'Bibliothekar, Bibliothekarin',
    dutch: 'bibliothecaris',
    afrikaans: 'bibliotekaris',
    russian: 'библиотекарь',
    latvian: 'bibliotekārs',
    polish: 'bibliotekarz',
    french: 'bibliothécaire',
    spanish: 'bibliotecario',
  },
  {
    av: 23569,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + cause + light)',
    english: 'light switch',
    swedish: 'kontakt, strömbrytare',
    norwegian: 'lysbryter',
    finnish: 'valokatkaisija',
    hungarian: 'villanykapcsoló',
    german: 'Schalter, Lichtschalter',
    dutch: 'lichtschakelaar',
    afrikaans: 'lig skakelaar',
    russian: 'выключатель света',
    latvian: 'gaismas slēdzis',
    polish: 'włącznik światła, kontakt',
    french: "interrupteur d'éclairage",
    spanish: 'interruptor',
  },
  {
    av: 23570,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe person + little)',
    english: 'little person',
    swedish: 'pyssling, vätte (etc)',
    norwegian: 'fantasifigur dverg, vette',
    finnish: 'menninkäinen, tonttu',
    hungarian: 'kicsike (fn.; átvitt értelemben)',
    german: 'Phantasiewesen (klein)',
    dutch: 'klein sprookjesfiguur',
    afrikaans: 'klein (persoon)',
    russian: 'гном (маленький человек)',
    latvian: 'liliputs, punduris, mazs cilvēks',
    polish: 'krasnoludek, gnom, mała mityczna istota',
    french: 'personnage imaginaire (nain)',
    spanish: 'persona pequeña',
  },
  {
    av: 23571,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play [contr.] + card + number)',
    english: 'lotto, bingo (etc)',
    swedish: 'lotto, bingo (etc)',
    norwegian: 'lotto, bingo (o.l.)',
    finnish: 'lotto, bingo',
    hungarian: 'lottó, bingó, egyéb szerencsjáték',
    german: 'Bilderlotto',
    dutch: 'lotto, bingo',
    afrikaans: 'lotto, bingo (ens)',
    russian: 'лотто, бинго',
    latvian: 'loterija, loto, bingo',
    polish: 'lotto, bingo',
    french: 'jeu de loto, bingo',
    spanish: 'lotería, bingo (etc)',
  },
  {
    av: 23572,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to cut + tree)',
    english: 'lumberjack',
    swedish: 'skogsarbetare',
    norwegian: 'tømmerhogger',
    finnish: 'metsuri',
    hungarian: 'favágó, fatelepi dolgozó',
    german: 'Holzfäller, Holzfällerin',
    dutch: 'houthakker',
    afrikaans: 'houthakker',
    russian: 'лесоруб',
    latvian: 'mežacirtējs',
    polish: 'drwal',
    french: 'bûcheron',
    spanish: 'leñador',
  },
  {
    av: 23573,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bag + food) Use appropriate classifier.',
    english: 'lunch box',
    swedish: 'matlåda',
    norwegian: 'matboks',
    finnish: 'eväslaukku',
    hungarian: 'uzsonnadoboz',
    german: 'Essensdose, Lunchbox, Brotbüchse, Brotdose',
    dutch: 'broodtrommel, brooddoos',
    afrikaans: 'kosblik',
    russian: 'коробка для ланча',
    latvian: 'launaga kastīte',
    polish: 'pudełko śniadaniowe',
    french: 'boîte à tartines, musette, boîte à lunch',
    spanish: 'caja para el almuerzo',
  },
  {
    av: 23574,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to cause + mystery)',
    english: 'magician',
    swedish: 'trollkonstnär, magiker',
    norwegian: 'tryllekunstner, trollmann',
    finnish: 'taikuri',
    hungarian: 'bűvész, varázsló',
    german: 'Zauberer, Magier',
    dutch: 'goochelaar',
    afrikaans: 'towenaar',
    russian: 'маг, фокусник',
    latvian: 'iluzionists, mags, burvis',
    polish: 'czarownik, magik',
    french: 'magicien',
    spanish: 'mago',
  },
  {
    av: 23575,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cover + bed + action indicator)',
    english: 'make the bed-(to)',
    swedish: 'bädda',
    norwegian: 're seng',
    finnish: 'sijata vuode, pedata sänky',
    hungarian: 'megágyazni, ágyat vetni',
    german: '(Bett) machen',
    dutch: 'bed opmaken',
    afrikaans: 'bed opmaak (om te)',
    russian: 'застилать кровать',
    latvian: 'klāt gultu',
    polish: 'zasłać łóżko',
    french: 'faire le lit',
    spanish: 'hacer la cama',
  },
  {
    av: 23578,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe person + tree)',
    english: 'make-believe person (in forest)',
    swedish: 'övernaturligt väsen (i skogen)',
    norwegian: 'fantasifigur skogsalv',
    finnish: 'mielikuvitusolento (asuu metsässä)',
    hungarian: 'képzelt személy az erdőben, faember, nimfa',
    german: 'Phantasiewesen (im Wald)',
    dutch: 'sprookjesfiguur (bos)',
    afrikaans: 'verbeeldings figuur persoon (in woud)',
    russian: 'сверхъестественное существо (в лесу)',
    latvian: 'iedomāta, neīsta parādība (mežā)',
    polish: 'mityczna istota z lasu (leśny elf, duszek lasu)',
    french: 'personnage imaginaire (arbre)',
    spanish: 'ser sobrenatural (en el bosque)',
  },
  {
    av: 23579,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe person + water)',
    english: 'make-believe person (in water), water nymph',
    swedish: 'övernaturligt väsen (i vatten)',
    norwegian: 'fantasifigur vannnymfe',
    finnish: 'mielikuvitusolento (asuu vedessä), vesinymfi',
    hungarian: 'képzelt személy a vízben, vízitündér, sellő',
    german: 'Wassernymphe',
    dutch: 'waternimf, sprookjesfiguur (water)',
    afrikaans: 'verbeeldings figuur persoon (in water) nimf',
    russian: 'сверхъестественное существо (в воде)',
    latvian: 'iedomāta, neīsta parādība (ūdenī)',
    polish: 'mityczna istota wodna (wodnik, nimfa wodna)',
    french: 'personnage imaginaire (eau)',
    spanish: 'ser sobrenatural (en el agua), ninfa del agua',
  },
  {
    av: 23580,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe person + under (ground level))',
    english: 'make-believe person (under ground)',
    swedish: 'övernaturligt väsen (under jord)',
    norwegian: 'fantasifigur gnom',
    finnish: 'mielikuvitusolento (asuu maan alla)',
    hungarian: 'képzelt személy a föld alatt',
    german: 'Phantasiewesen (Unterwelt)',
    dutch: 'sprookjesfiguur (onder de grond)',
    afrikaans: 'verbeeldings figuur persoon (onder gronds)',
    russian: 'сверхъестественное существо (под водой)',
    latvian: 'iedomāta, neīsta parādība pazemē',
    polish: 'mityczna istota z podziemi (krasnolud, gnom)',
    french: 'personnage imaginaire (sous terre)',
    spanish: 'ser sobrenatural (bajo tierra)',
  },
  {
    av: 23582,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(man + man-made)',
    english: 'man doll (e.g. Ken)',
    swedish: 'docka (manlig) (t ex Ken)',
    norwegian: 'dokke (hankjønn) (f. eks. Ken)',
    finnish: 'miesnukke, Ken',
    hungarian: 'játékbaba (fiú, pl. Ken)',
    german: 'Puppe (männlich z.B. Ken)',
    dutch: 'pop (mannelijk zoals Ken), jongenspop',
    afrikaans: 'pop manlik (b.v.Ken)',
    russian: 'Кен (кукла)',
    latvian: 'lelle-jauneklis (piem., Kens)',
    polish: 'lalka (rodzaju męskiego np. Ken)',
    french: 'poupée masculine (ex. Ken)',
    spanish: 'muñeco (p.ej. Ken)',
  },
  {
    av: 23584,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play [contr.] + same)',
    english: 'matching game',
    swedish: 'matchningsspel',
    norwegian: 'matchingsspill',
    finnish: 'yhdistä samanlaiset -peli',
    hungarian: 'egyeztető játék',
    german: 'Matching-Spiel z.B. Memory ',
    dutch: 'matchingspel',
    afrikaans: 'ooreenstem spel',
    russian: 'комбинационная игра',
    latvian: 'spēles kombinācija',
    polish: 'memory, dopasowywanie elementów (gra)',
    french: "jeu d'identification, loto",
    spanish: 'partido empatado',
  },
  {
    av: 23585,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(subject [contr.] + mathematics) SYMBOL SYNONYM',
    english: 'math, mathematics (class) (2)',
    swedish: 'matte, matematik (skolämne) (2)',
    norwegian: 'matematikkfag, matte (fag) (2)',
    finnish: 'matematiikka (kouluaine)',
    hungarian: 'matematika, matek (tantárgy)',
    german: 'Mathematik, Arithmetik, Rechnen, Mathe (2)',
    dutch: 'wiskunde (les), rekenen (les), rekenles (2)',
    afrikaans: 'wiskunde (les) (2)',
    russian: 'математика (предмет) (2)',
    latvian: 'aritmētika, matemātika (nodarbība) (2)',
    polish: 'matematyka (wiedza +matematyka)',
    french: 'math (cours) (2)',
    spanish: 'matemática (clase)',
  },
  {
    av: 23586,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sauce + animal + lump(s): combination of sauce and minced meat)',
    english: 'meat sauce',
    swedish: 'köttfärssås',
    norwegian: 'kjøttsaus',
    finnish: 'jauhelihakastike',
    hungarian: 'húsos mártás',
    german: 'Fleischsoße',
    dutch: 'vleessaus',
    afrikaans: 'vleis sous',
    russian: 'мясной соус',
    latvian: 'gaļas mērce',
    polish: 'sos mięsny',
    french: 'jus de viande',
    spanish: 'salsa de carne',
  },
  {
    av: 23587,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + machine)',
    english: 'mechanic, technician',
    swedish: 'mekaniker, tekniker',
    norwegian: 'mekaniker, tekniker',
    finnish: 'mekaanikko',
    hungarian: 'technicus, szerelő',
    german: 'Mechaniker, Mechanikerin',
    dutch: 'monteur',
    afrikaans: 'motorwerktuigkundige, tegnikus',
    russian: 'механик, техник',
    latvian: 'mehāniķis, tehniķis',
    polish: 'mechanik',
    french: 'mécanicien',
    spanish: 'mecánico',
  },
  {
    av: 23588,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(designer + machine)',
    english: 'mechanical engineer',
    swedish: 'maskiningenjör',
    norwegian: 'mekanikkingeniør',
    finnish: 'koneinsinööri',
    hungarian: 'gépészmérnök',
    german: 'Maschinenbauingenieur, Maschinenbauingenieurin',
    dutch: 'werktuigbouwkundige',
    afrikaans: 'meganiese ingenieur',
    russian: 'инженер-механик',
    latvian: 'inženieris mehāniķis',
    polish: 'inżynier mechanik',
    french: 'ingénieur mécanicien',
    spanish: 'ingeniero mecánico',
  },
  {
    av: 23590,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe woman + fish: imaginary woman having a tail of a fish)',
    english: 'mermaid',
    swedish: 'sjöjungfru',
    norwegian: 'fantasifigur havfrue',
    finnish: 'merenneito',
    hungarian: 'sellő',
    german: 'Meeresjungfrau',
    dutch: 'zeemeermin',
    afrikaans: 'meermin',
    russian: 'русалка',
    latvian: 'nāriņa',
    polish: 'syrena (półkobieta, półryba)',
    french: 'sirène',
    spanish: 'sirena',
  },
  {
    av: 23591,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + bits)',
    english: 'meat (minced), minced meat, ground meat',
    swedish: 'köttfärs',
    norwegian: 'kjøttdeig',
    finnish: 'jauheliha',
    hungarian: 'darált hús',
    german: 'Hackfleisch, Faschiertes (Österreich)',
    dutch: 'gehakt (vlees)',
    afrikaans: 'vleis gemaal',
    russian: 'мясной фарш',
    latvian: 'gaļa, maltā gaļa',
    polish: 'mięso mielone',
    french: 'viande hâchée',
    spanish: 'carne picada',
  },
  {
    av: 23592,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(telephone + to carry)',
    english: 'mobile phone, cellphone',
    swedish: 'mobiltelefon',
    norwegian: 'mobiltelefon',
    finnish: 'matkapuhelin, kännykkä',
    hungarian: 'mobiltelefon, mobil',
    german: 'Handy, Mobiltelefon',
    dutch: 'mobiele telefoon, GSM (Vl), mobieltje (Nl)',
    afrikaans: 'selfoon',
    russian: 'мобильный телефон',
    latvian: 'mobilais tālrunis',
    polish: 'komórka, telefon komórkowy',
    french: 'téléphone portable',
    spanish: 'teléfono móvil, móvil',
  },
  {
    av: 23593,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + pointer)',
    english: 'mouse, pointing device',
    swedish: 'mus (dator), pekdon',
    norwegian: 'mus (PC)',
    finnish: 'hiiri (tietokone)',
    hungarian: 'egér (szgép), mutató eszköz, egérkiváltó',
    german: 'Maus, Computermaus',
    dutch: 'muis (computer)',
    afrikaans: 'muis rekenaar, wys toestel',
    russian: 'указывающее устройство',
    latvian: 'pele, kursora virzītājs (datorā)',
    polish: 'myszka (komp), urządzenie wskazujące ',
    french: 'souris (pointeur informatique)',
    spanish: 'ratón, dispositivo señalador',
  },
  {
    av: 23594,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play + music [contr.])',
    english: 'musical',
    swedish: 'musikal',
    norwegian: 'musikal',
    finnish: 'musikaali',
    hungarian: 'musical, zenés játék',
    german: 'Musical',
    dutch: 'musical',
    afrikaans: 'musikaal',
    russian: 'мюзикл',
    latvian: 'muzikāls',
    polish: 'musical',
    french: 'comédie musicale',
    spanish: 'musical',
  },
  {
    av: 23595,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(net + to catch)',
    english: 'net',
    swedish: 'nät, fångstnät',
    norwegian: 'fangstnett',
    finnish: 'verkko, saalistusverkko',
    hungarian: 'háló',
    german: 'Netz, Fischnetz',
    dutch: 'net',
    afrikaans: 'net',
    russian: 'сеть',
    latvian: 'tīkls',
    polish: 'siatka',
    french: 'filet',
    spanish: 'red, red de captura',
  },
  {
    av: 23596,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(toy [contr.] + sound)',
    english: 'noisemaker, musical toy',
    swedish: 'ljudleksak',
    norwegian: 'musikkleke',
    finnish: 'musiikkilelu',
    hungarian: 'zenélő játék, hangadó játék',
    german: 'Musikspielzeug',
    dutch: 'muziekspeelgoed',
    afrikaans: 'musiek speelding',
    russian: 'музыкальная игрушка',
    latvian: 'muzikāla rotaļlieta, skaņas rotaļlieta',
    polish: 'zabawka dźwiękowa, muzyczna',
    french: 'crécelle, jouet musical',
    spanish: 'juguete musical',
  },
  {
    av: 23597,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(play + music [contr.] + up and down: play and music portraying conflicting emotions and upsetting events)',
    english: 'opera',
    swedish: 'opera',
    norwegian: 'opera',
    finnish: 'ooppera',
    hungarian: 'opera',
    german: 'Oper',
    dutch: 'opera',
    afrikaans: 'opera',
    russian: 'опера',
    latvian: 'opera',
    polish: 'opera',
    french: 'opéra',
    spanish: 'ópera',
  },
  {
    av: 23598,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + glasses)',
    english: 'optician',
    swedish: 'optiker',
    norwegian: 'optiker',
    finnish: 'optikko',
    hungarian: 'látszerész, optikus ',
    german: 'Optiker',
    dutch: 'opticien',
    afrikaans: 'oogkundige',
    russian: 'оптик',
    latvian: 'optiķis',
    polish: 'optyk',
    french: 'opticien',
    spanish: 'óptico',
  },
  {
    av: 23600,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + on)',
    english: 'overlay',
    swedish: 'överlägg',
    norwegian: 'overlegg',
    finnish: 'alustalomake',
    hungarian: 'előlap, fedőlap',
    german: 'Overlay, Einlegefolie, Überzug, Deckschicht für Tastaturen',
    dutch: 'overlay',
    afrikaans: 'oortreksel',
    russian: 'покрытие, плёнка',
    latvian: 'pārvalks, pārklājums',
    polish: 'pokrycie, powłoka, coś do okrycia',
    french: 'revêtement, recouvrement',
    spanish: 'superposición',
  },
  {
    av: 23601,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(keyboard + plan)',
    english: 'overlay keyboard, membrane keyboard',
    swedish: 'styrplatta, membrantangentbord',
    norwegian: 'styreplate',
    finnish: 'muokattu näppäimistö',
    hungarian: 'billyentyű fedőlap, membrános billyentyűzet',
    german: 'Sondertastatur',
    dutch: 'raster (toetsenbord)',
    afrikaans: 'oortreksel sleutelbord',
    russian: 'мембранная клавиатура',
    latvian: 'skārienpanelis, membrānas tastatūra',
    polish: 'klawiatura nakładkowa (np. Intellikeys)',
    french: 'plan de clavier',
    spanish: 'teclado superpuesto',
  },
  {
    av: 23602,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tablet + little)',
    english: 'palmtop, PDA',
    swedish: 'handdator',
    norwegian: 'PDA, håndholdt PC',
    finnish: 'kämmenmikro',
    hungarian: 'palmtop, tenyérszámítógép, zsebszámítógép',
    german: 'Palmtop (Minicomputer in der Gröβe einer Handfläche)',
    dutch: 'computer (handcomputer)',
    afrikaans: 'hand rekenaar',
    russian: 'КПК',
    latvian: 'plaukstdators',
    polish: 'palmtop, pda, (mały komputer ręczny)',
    french: 'ordinateur de poche, PDA',
    spanish: 'ordenador de bolsillo, PDA',
  },
  {
    av: 23604,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + paper)',
    english: 'paper money, bill',
    swedish: 'sedel',
    norwegian: 'pengeseddel',
    finnish: 'paperiraha, lasku',
    hungarian: 'papírpénz, bankjegy',
    german: 'Banknote, Geldschein',
    dutch: 'rekening, nota (rekening)',
    afrikaans: 'geld papiernoot',
    russian: 'банкнота',
    latvian: 'papīra nauda, banknote',
    polish: 'banknot, czek',
    french: 'billet de banque',
    spanish: 'billete, papel moneda',
  },
  {
    av: 23605,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(person + to ride)',
    english: 'passenger',
    swedish: 'passagerare',
    norwegian: 'passasjer',
    finnish: 'matkustaja',
    hungarian: 'utas (fn.)',
    german: 'Fahrgast, Passagier, Passagierin',
    dutch: 'passagier',
    afrikaans: 'passasier',
    russian: 'пассажир',
    latvian: 'pasažieris',
    polish: 'pasażer',
    french: 'passager, voyageur',
    spanish: 'pasajero',
  },
  {
    av: 23606,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + education, didactics, pedagogy)',
    english: 'educationalist, educationist (academic)',
    swedish: 'pedagog (forskare), didaktiker',
    norwegian: 'pedagog (akademiker), didaktiker',
    finnish: 'pedagogi, opettaja',
    hungarian: 'oktatáskutató',
    german: 'Erziehungswissenschaftler(in), Pädagoge, Pädagogin ',
    dutch: 'pedagoog',
    afrikaans: 'pedagoog (akademikus), opvoedkundige',
    russian: 'научно-педагогический работник',
    latvian: 'pedagogs, pedagoģijas speciālists, akadēmiķis',
    polish: 'pedagog (naukowiec)',
    french: 'pédagogue (scientifique)',
    spanish: 'pedagogo (académico)',
  },
  {
    av: 23607,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(body of learning + to exchange + knowledge)',
    english: 'education, didactics, pedagogy',
    swedish: 'pedagogik, didaktik',
    norwegian: 'pedagogikk, didaktikk',
    finnish: 'kasvatusoppi, pedagogiikka',
    hungarian: 'pedagógia, didaktika, oktatás-nevelés',
    german: 'Pädagogik',
    dutch: 'pedagogie',
    afrikaans: 'pedagogie, didatiek, onderwys',
    russian: 'педагогика, дидактика',
    latvian: 'izglītība, didaktika, pedagoģija',
    polish: 'pedagogika (nauka)',
    french: 'pédagogie',
    spanish: 'pedagogía',
  },
  {
    av: 23608,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(horse + wings)',
    english: 'Pegasus',
    swedish: 'Pegasus',
    norwegian: 'Pegasus',
    finnish: 'Pegasos',
    hungarian: 'Pegazus',
    german: 'Pegasus, geflügeltes Pferd (griech. Sage)',
    dutch: 'Pegasus, vliegend paard',
    afrikaans: 'Pegasus',
    russian: 'Пегас',
    latvian: 'Pegazs',
    polish: 'Pegaz (latający koń)',
    french: 'pégase',
    spanish: 'Pegaso',
  },
  {
    av: 23609,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(performance + action indicator)',
    english: 'perform-(to)',
    swedish: 'uppföra, uppträda',
    norwegian: 'framføre, opptre',
    finnish: 'näytellä, esiintyä',
    hungarian: 'előadni, szerepelni, eljátszani',
    german: '(Konzert) geben, auftreten',
    dutch: 'optreden',
    afrikaans: 'optree (om te)',
    russian: 'выступать',
    latvian: 'izpildīt, izrādīt',
    polish: 'przedstawiać, wykonywać, odgrywać',
    french: 'représenter (spectacle)',
    spanish: 'actuar, realizar',
  },
  {
    av: 23610,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + showplace)',
    english: 'performance, show',
    swedish: 'föreställning, show',
    norwegian: 'forestilling, show',
    finnish: 'näytäntö, show, esitys',
    hungarian: 'előadás, show',
    german: 'Spiel, Theaterstück',
    dutch: 'voorstelling (show), show, optreden (zelfst.nw)',
    afrikaans: 'optrede',
    russian: 'выступление, шоу',
    latvian: 'uzvedums, izrāde',
    polish: 'pokaz, przedstawienie',
    french: 'représentation, spectacle',
    spanish: 'actuación, show',
  },
  {
    av: 23611,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + medicine)',
    english: 'pharmacist',
    swedish: 'apotekare, farmaceut',
    norwegian: 'farmasøyt',
    finnish: 'apteekkari, farmaseutti',
    hungarian: 'gyógyszerész, patikus',
    german: 'Apotheker, Apothekerin',
    dutch: 'apotheker',
    afrikaans: 'apteker',
    russian: 'фармацевт, провизор',
    latvian: 'farmaceits',
    polish: 'farmaceuta, aptekarz',
    french: 'pharmacien',
    spanish: 'farmacéutico',
  },
  {
    av: 23612,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + causality)',
    english: 'philosopher',
    swedish: 'filosof',
    norwegian: 'tenker (filosof)',
    finnish: 'filosofi',
    hungarian: 'filozófus',
    german: 'Philosoph, Philosophin',
    dutch: 'filosoof',
    afrikaans: 'filosoof',
    russian: 'философ',
    latvian: 'filozofs',
    polish: 'filozof',
    french: 'philosophe',
    spanish: 'filósofo',
  },
  {
    av: 23613,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + philosophy)',
    english: 'philosopher (academic)',
    swedish: 'filosof (akademiker)',
    norwegian: 'filosof (akademiker)',
    finnish: 'filosofi (akateeminen)',
    hungarian: 'filozófuskutató',
    german: 'Philosoph, Philosophin',
    dutch: 'filosoof (academisch)',
    afrikaans: 'folosoof (akademikus)',
    russian: 'философ (академик)',
    latvian: 'filozofs, zinātnieks',
    polish: 'filozof (naukowiec)',
    french: 'philosophe (scientifique)',
    spanish: 'filósofo (académico)',
  },
  {
    av: 23614,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(body of learning + causality)',
    english: 'philosophy',
    swedish: 'filosofi',
    norwegian: 'filosofi',
    finnish: 'filosofia',
    hungarian: 'filozófia',
    german: 'Philosophie',
    dutch: 'filosofie',
    afrikaans: 'filosofie',
    russian: 'философия',
    latvian: 'filozofija',
    polish: 'filozofia (nauka)',
    french: 'philosophie',
    spanish: 'filosofía',
  },
  {
    av: 23615,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + causality)',
    english: 'philosophy (class)',
    swedish: 'filosofi (skolämne)',
    norwegian: 'filosofifag',
    finnish: 'filosofia (kouluaine)',
    hungarian: 'filozófia (tantárgy)',
    german: 'Weltanschauungsunterricht, Philosophie-Unterricht',
    dutch: 'filosofieles',
    afrikaans: 'filosofie (les)',
    russian: 'философия (предмет)',
    latvian: 'filozofijas nodarbība',
    polish: 'filozoficzny (kategoria)',
    french: 'cours de philosophie',
    spanish: 'filosofía (clase)',
  },
  {
    av: 23616,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(sailor + receiving + negative + intensity: sailor + to rob [contr.] )',
    english: 'pirate',
    swedish: 'sjörövare, pirat',
    norwegian: 'pirat, sjørøver',
    finnish: 'merirosvo, piraatti',
    hungarian: 'kalóz',
    german: 'Pirat, Piratin',
    dutch: 'piraat',
    afrikaans: 'seerower',
    russian: 'пират',
    latvian: 'pirāts',
    polish: 'pirat',
    french: 'pirate',
    spanish: 'pirata',
  },
  {
    av: 23617,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + story)',
    english: 'play (theater)',
    swedish: 'skådespel',
    norwegian: 'skuespill',
    finnish: 'näytelmä, esitys',
    hungarian: 'játék (színházban)',
    german: 'Schauspiel (Theater)',
    dutch: 'toneelstuk, voorstelling',
    afrikaans: 'toneelstuk (teater)',
    russian: 'спектакль',
    latvian: 'luga, izrāde',
    polish: 'gra (aktorska, teatralna)',
    french: 'jeu théâtral',
    spanish: 'obra (teatro)',
  },
  {
    av: 23618,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + feeling: contraction of play, recreation) Used in conjunction with a specifier.',
    english: 'play, game (in combinations)',
    swedish: 'lek, spel (i kombinationer)',
    norwegian: 'spill (brukes i kombinasjon)',
    finnish: 'leikki, peli',
    hungarian: 'játék, játszás (egyéb összefüggésekben)',
    german: 'Spiel, Gesellschaftsspiel (Kombinationen)',
    dutch: 'toneelstuk, voorstelling',
    afrikaans: 'toneelstuk (in kombinasies)',
    russian: 'игра (в комбинации)',
    latvian: 'luga, izrāde, spēle (dažādās nozīmēs)',
    polish: 'grać (w symbolu złożonym)',
    french: 'jeu (classificateur)',
    spanish: 'juego (en combinaciones)',
  },
  {
    av: 23620,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(hedgehog + teeth: combination of hedgehog and rodent) Preferred NEW SYNONYM, replacing 16222',
    english: 'porcupine',
    swedish: 'piggsvin',
    norwegian: 'hulepinnsvin',
    finnish: 'piikkisika',
    hungarian: 'tarajos sül',
    german: 'Stachelschwein',
    dutch: 'stekelvarken',
    afrikaans: 'krimpvark',
    russian: 'дикобраз',
    latvian: 'dzeloņcūka',
    polish: 'jeżozwierz',
    french: 'porc-épic',
    spanish: 'puerco espín',
  },
  {
    av: 23621,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pudding, cream + grain, cereal)',
    english: 'porridge',
    swedish: 'gröt, pudding',
    norwegian: 'grøt',
    finnish: 'puuro',
    hungarian: 'zabkása',
    german: 'Haferbrei, Haferflockenbrei',
    dutch: 'havermoutpap',
    afrikaans: 'pap',
    russian: 'каша',
    latvian: 'biezputra',
    polish: 'owsianka',
    french: 'porridge',
    spanish: 'gachas de avena',
  },
  {
    av: 23622,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(boy + crown)',
    english: 'prince',
    swedish: 'prins',
    norwegian: 'prins',
    finnish: 'prinssi',
    hungarian: 'herceg, hercegfiú, hercegfi',
    german: 'Prinz',
    dutch: 'prins',
    afrikaans: 'prins',
    russian: 'принц',
    latvian: 'princis',
    polish: 'książę',
    french: 'prince',
    spanish: 'príncipe',
  },
  {
    av: 23623,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(girl + crown)',
    english: 'princess',
    swedish: 'prinsessa',
    norwegian: 'prinsesse',
    finnish: 'prinsessa',
    hungarian: 'hercegkisasszony, herceglány',
    german: 'Prinzessin',
    dutch: 'prinses',
    afrikaans: 'prinses',
    russian: 'принцесса',
    latvian: 'princese',
    polish: 'księżniczka',
    french: 'princesse',
    spanish: 'princesa',
  },
  {
    av: 23624,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(machine + to write + action indicator)',
    english: 'print-(to)',
    swedish: 'skriva ut (från skrivare)',
    norwegian: 'trykke, printe, skrive',
    finnish: 'tulostaa, printata',
    hungarian: 'nyomtatni, printelni',
    german: 'drucken',
    dutch: 'afdrukken, uitprinten, printen',
    afrikaans: 'druk (om te)',
    russian: 'распечатывать',
    latvian: 'drukāt, izdrukāt',
    polish: 'drukować',
    french: 'imprimer',
    spanish: 'imprimir',
  },
  {
    av: 23625,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dinosaur + wings)',
    english: 'Pterosaur, Pterodactyl',
    swedish: 'Pterosaurie, flygödla',
    norwegian: 'Pterodactyl, Pterosaur, flygeøgle',
    finnish: 'pteranodon, lentolisko',
    hungarian: 'pteroszaurusz, pterodaktil',
    german: 'Pterosaurier, Flugsaurier, Pterodactylus, Pteranodon (prähist. Flugechse)',
    dutch: 'Pterosaurus',
    afrikaans: 'Pterosaur, Pterodactyl',
    russian: 'птерозавр',
    latvian: 'pterozaurs, pterodaktils',
    polish: 'pterodaktyl',
    french: 'ptérodactyle',
    spanish: 'Pterodáctilo',
  },
  {
    av: 23626,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(woman + crown)',
    english: 'queen',
    swedish: 'drottning',
    norwegian: 'dronning',
    finnish: 'kuningatar',
    hungarian: 'királynő',
    german: 'Königin',
    dutch: 'koningin',
    afrikaans: 'koningin',
    russian: 'королева',
    latvian: 'karaliene',
    polish: 'królowa',
    french: 'reine',
    spanish: 'reina',
  },
  {
    av: 23628,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(track + train)',
    english: 'railway track',
    swedish: 'järnvägsspår, räls',
    norwegian: 'jerbanespor',
    finnish: 'junarata, kiskot, rautatie',
    hungarian: 'vonatsín',
    german: 'Eisenbahnschiene, Schiene',
    dutch: 'spoorweg, rails, treinrails',
    afrikaans: 'spoor lyn',
    russian: 'железная дорога, рельсы',
    latvian: 'dzelzceļa trase',
    polish: 'tory kolejowe',
    french: 'voie ferrée',
    spanish: 'vía del tren',
  },
  {
    av: 23630,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to add + action + before, in front of, prior to + action indicator)',
    english: 'redo-(to)',
    swedish: 'göra om',
    norwegian: 'gjøre om, endre',
    finnish: 'tehdä uudelleen, remontoida',
    hungarian: 'átalakítani, helyrehozni, újra elvégezni/megcsinálni',
    german: 'wiederherstellen (Computeraktion)',
    dutch: 'opnieuw doen, herhalen, herstellen',
    afrikaans: 'herhaal oordoen (om te)',
    russian: 'повторить действие',
    latvian: 'pārtaisīt, darīt vēlreiz',
    polish: 'przerabiać, powtarzać, ponawiać czynność',
    french: 'refaire',
    spanish: 'rehacer',
  },
  {
    av: 23631,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(jump + digits (computer) + action indicator)',
    english: 'redo (computer)-(to)',
    swedish: 'göra om (dator)',
    norwegian: 'endre (PC)',
    finnish: 'toista-painike (tietokone)',
    hungarian: 'visszahozni, újra elvégezni (szgép), redo',
    german: 'wiederherstellen (Computeraktion)',
    dutch: 'opnieuw doen, herstellen',
    afrikaans: 'herhaal oordoen (rekenaar) (om te)',
    russian: 'повторить (компьютер)',
    latvian: 'atsaukt (darbību datorā)',
    polish: 'powtarzać, ponawiać, kopiować (komputerowe)',
    french: 'refaire, répéter (informatique)',
    spanish: 'rehacer (ordenador)',
  },
  {
    av: 23632,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cupboard + cold) Preferred NEW SYNONYM, replacing 16476',
    english: 'refrigerator, fridge',
    swedish: 'kylskåp',
    norwegian: 'kjøleskap',
    finnish: 'jääkaappi',
    hungarian: 'hűtő, hűtőszekrény, jégszekrény',
    german: 'Kühlschrank',
    dutch: 'koelkast, ijskast',
    afrikaans: 'koelkas, yskas',
    russian: 'холодильник',
    latvian: 'ledusskapis, saldētava',
    polish: 'lodówka',
    french: 'frigo, frigidaire, réfrigérateur',
    spanish: 'refrigerador, nevera',
  },
  {
    av: 23634,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(memory + action indicator) Preferred NEW SYNONYM, replacing 16485',
    english: 'remember, recall-(to)',
    swedish: 'komma ihåg, minnas',
    norwegian: 'huske, gjenkalle',
    finnish: 'muistaa',
    hungarian: 'emlékezni, felidézni',
    german: 'erinnern, sich erinnern',
    dutch: 'herinneren, zich herinneren',
    afrikaans: 'herinner, herroep (om te)',
    russian: 'запомнить, запоминать',
    latvian: 'atcerēties, atsaukt atmiņā',
    polish: 'pamiętać, przypominać sobie',
    french: 'souvenir-(se), rappeler-(se)',
    spanish: 'recordar',
  },
  {
    av: 23635,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + science)',
    english: 'research',
    swedish: 'forskning',
    norwegian: 'forskning',
    finnish: 'tutkimus',
    hungarian: 'kutatás',
    german: 'Forschung',
    dutch: 'onderzoek, research',
    afrikaans: 'navorsing',
    russian: 'исследование',
    latvian: 'pētījums, izpēte',
    polish: 'badanie, odkrywanie czegoś',
    french: 'recherche',
    spanish: 'investigación',
  },
  {
    av: 23636,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pudding + rice)',
    english: 'rice pudding, rice porridge',
    swedish: 'risgrynsgröt, risgrynspudding',
    norwegian: 'rispudding, risgrøt',
    finnish: 'riisipuuro, riisivanukas',
    hungarian: 'rizspuding, rizskása',
    german: 'Reisbrei, Reispudding',
    dutch: 'rijstpap, rijstebrij',
    afrikaans: 'rys poeding, rys pap',
    russian: 'рисовая каша, рисовый пудинг',
    latvian: 'rīsu pudiņš, rīsu putra',
    polish: 'pudding ryżowy, budyń ryżowy',
    french: 'riz au lait',
    spanish: 'arroz con leche',
  },
  {
    av: 23637,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to steal + intensity + action indicator)',
    english: 'rob-(to)',
    swedish: 'råna',
    norwegian: 'rane',
    finnish: 'varastaa, rosvota, ryöstää',
    hungarian: 'rabolni, elrabolni, kirabolni, megrabolni',
    german: 'rauben',
    dutch: 'beroven',
    afrikaans: 'beroof (om te)',
    russian: 'грабить',
    latvian: 'laupīt',
    polish: 'kraść, okradać, rabować',
    french: 'voler, prendre',
    spanish: 'robar',
  },
  {
    av: 23638,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to rob [contr.])',
    english: 'robber',
    swedish: 'rånare',
    norwegian: 'raner',
    finnish: 'varas, rosvo',
    hungarian: 'rabló (fn.)',
    german: 'Räuber, Räuberin',
    dutch: 'rover',
    afrikaans: 'rower',
    russian: 'грабитель',
    latvian: 'laupītājs',
    polish: 'rabuś, złodziej',
    french: 'voleur',
    spanish: 'ladrón',
  },
  {
    av: 23639,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + person + man-made)',
    english: 'robot doll',
    swedish: 'robotdocka',
    norwegian: 'robotdokke',
    finnish: 'robottinukke',
    hungarian: 'robotember, robotbaba',
    german: 'Roboter',
    dutch: 'robotpop',
    afrikaans: 'robot pop',
    russian: 'робот, игрушка',
    latvian: 'robotlelle',
    polish: 'lalka robot, robot zabawka',
    french: 'poupée mécanique, robot',
    spanish: 'muñeca robot',
  },
  {
    av: 23640,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(rotation + ground + action indicator)',
    english: 'roll-(to)',
    swedish: 'rulla',
    norwegian: 'rulle',
    finnish: 'kierittää, kieriä',
    hungarian: 'forogni, csavarni, forogni, göngyölíteni',
    german: 'rollen, kugeln',
    dutch: 'omdraaien, rollen',
    afrikaans: 'rol (om te)',
    russian: 'заматывать, скручивать',
    latvian: 'rullēt',
    polish: 'toczyć się, kręcić się po podłożu',
    french: 'rouler, faire rouler',
    spanish: 'rodar',
  },
  {
    av: 23641,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + destroyed) SYMBOL SYNONYM',
    english: 'ruin, wreck, wreckage (building) (2)',
    swedish: 'ruin (2)',
    norwegian: 'ruin, rønne (2)',
    finnish: 'rauniot (2)',
    hungarian: 'rom, romház (2)',
    german: 'Ruine (2)',
    dutch: 'ruïne (2)',
    afrikaans: 'wrak, ruïne (gebou) (2)',
    russian: 'руины, развалины (2)',
    latvian: 'iznīcināt, sagraut, nojaukt (celtni) (2)',
    polish: 'ruina, rudera (2)',
    french: 'ruine (2)',
    spanish: 'ruina (2)',
  },
  {
    av: 23642,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: "(country + bear's head: the country of the bear)",
    english: 'Russia',
    swedish: 'Ryssland',
    norwegian: 'Russland',
    finnish: 'Venäjä',
    hungarian: 'Oroszország',
    german: 'Russland, Russische Föderation',
    dutch: 'Rusland',
    afrikaans: 'Rusland',
    russian: 'Россия',
    latvian: 'Krievija',
    polish: 'Rosja',
    french: 'Russie',
    spanish: 'Rusia',
  },
  {
    av: 23643,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bread + filled)',
    english: 'samosa, pirogue',
    swedish: 'pirog',
    norwegian: 'pirog',
    finnish: 'samosa, pasteija',
    hungarian: 'szamósza (India), pirog (orosz); töltött kenyér',
    german: 'Samosa (gefüllte Teigtasche)',
    dutch: 'samosa',
    afrikaans: 'samoesa',
    russian: 'пирог',
    latvian: 'piroga, laivas paveids',
    polish: 'pieróg indyjski',
    french: 'samosa, pain fourré',
    spanish: 'piragua',
  },
  {
    av: 23644,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play [contr.] + sand)',
    english: 'sand play',
    swedish: 'sandlek',
    norwegian: 'sandlek',
    finnish: 'hiekkaleikki',
    hungarian: 'homokozás',
    german: 'spielen (im Sand), spielen (mit Sand)',
    dutch: 'spel in het zand',
    afrikaans: 'sand spel',
    russian: 'игра с песком',
    latvian: 'spēlēties smiltīs',
    polish: 'zabawy w piasku',
    french: 'jeu dans le sable',
    spanish: 'juego con arena',
  },
  {
    av: 23645,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(toy [contr.] + sand)',
    english: 'sand toy',
    swedish: 'sandleksak',
    norwegian: 'sandleke',
    finnish: 'hiekkalelu',
    hungarian: 'homokozó játék',
    german: 'Sandspielzeug, Buddelsachen',
    dutch: 'zandspeelgoed, strandspeelgoed',
    afrikaans: 'sand speelding',
    russian: 'игрушка для песка',
    latvian: 'pludmales, smilšu rotaļlietas',
    polish: 'foremki do piasku, zabawki do piaskownicy',
    french: 'jouet de sable',
    spanish: 'juguete para arena',
  },
  {
    av: 23646,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe man + to sleep: make-believe man who puts one to sleep)',
    english: 'Sandman',
    swedish: 'John Blund',
    norwegian: 'fantasifigur Ole Lukkøye',
    finnish: 'Nukkumatti',
    hungarian: 'Álommanó, Sandman',
    german: 'Sandmännchen',
    dutch: 'zandmannetje',
    afrikaans: 'sandman',
    russian: 'Дрёма',
    latvian: 'Miega vīriņš',
    polish: 'Sandman (bóg snu)',
    french: 'marchand de sable',
    spanish: 'Sandman',
  },
  {
    av: 23647,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + beard + evergreen tree)',
    english: 'Santa Claus, Father Christmas',
    swedish: 'jultomte, jultomten',
    norwegian: 'julenisse',
    finnish: 'Joulupukki',
    hungarian: 'Mikulás, Télapó',
    german: 'an den Weihnachtsmann/Sankt Nikolaus glauben',
    dutch: 'kerstman',
    afrikaans: 'Kersvader',
    russian: 'Санта клаус, Дед Мороз',
    latvian: 'Santa Klauss, Ziemassvētku vecītis',
    polish: 'Święty Mikołaj, Gwiazdor',
    french: 'père Noël',
    spanish: 'Santa Claus, Papá Noel',
  },
  {
    av: 23648,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(file, data file (digital) + future: combination of to keep and file + action indicator)',
    english: 'save (computer)-(to)',
    swedish: 'spara (dator)',
    norwegian: 'lagre (PC)',
    finnish: 'tallentaa (tietokone)',
    hungarian: 'menteni, elmenteni (szgép)',
    german: '(Datei) sichern',
    dutch: 'bewaren (computer), save (computer)',
    afrikaans: 'stoor, bewaar (rekenaar) (om te)',
    russian: 'сохранять (компьютер)',
    latvian: 'saglabāt (darbība datorā)',
    polish: 'zapisz, zachowaj (komp)',
    french: 'enregistrer, sauvergarder, sauver (informatique)',
    spanish: 'guardar (ordenador)',
  },
  {
    av: 23649,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(save (computer)-(to) + name + action indicator)',
    english: 'save as (computer)-(to)',
    swedish: 'spara som (dator)',
    norwegian: 'lagre som (PC)',
    finnish: 'tallentaa nimellä (tietokone)',
    hungarian: 'menteni másként (szgép)',
    german: 'speichern (unter neuem Namen)',
    dutch: 'bewaren als (computer), save as (computer)',
    afrikaans: 'stoor as (rekenaar) (om te)',
    russian: 'сохранять как (компьютер)',
    latvian: 'saglabāt kā (darbība datorā)',
    polish: 'zapisz jako (komp)',
    french: 'enregistrer sous, sauvergarder sous, sauver sous (informatique)',
    spanish: 'guardar como (ordenador)',
  },
  {
    av: 23650,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bag + book) Use appropriate classifier.',
    english: 'schoolbag',
    swedish: 'skolväska',
    norwegian: 'skolesekk',
    finnish: 'koululaukku',
    hungarian: 'iskolatáska',
    german: 'Schultasche',
    dutch: 'boekentas',
    afrikaans: 'skooltas',
    russian: 'ранец, портфель',
    latvian: 'skolassoma',
    polish: 'tornister',
    french: "cartable, mallette, sac d'école",
    spanish: 'mochila, bolso',
  },
  {
    av: 23651,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(causality + event: to research the cause of events)',
    english: 'science',
    swedish: 'vetenskap',
    norwegian: 'vitenskap',
    finnish: 'tiede',
    hungarian: 'tudomány',
    german: 'Naturwissenschaft, Wissenschaft',
    dutch: 'wetenschap',
    afrikaans: 'wetenskap',
    russian: 'наука',
    latvian: 'zinātne',
    polish: 'nauka, odkrywanie',
    french: 'science',
    spanish: 'ciencia',
  },
  {
    av: 23652,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + science)',
    english: 'scientist, researcher',
    swedish: 'forskare, vetenskapsman',
    norwegian: 'vitenskapsmann, forsker',
    finnish: 'tiedemies, tutkija',
    hungarian: 'tudós, kutató',
    german: 'Forscher, Forscherin',
    dutch: 'onderzoeker',
    afrikaans: 'wetenskaplike, navorser',
    russian: 'учёный',
    latvian: 'zinātnieks, pētnieks, līdzstrādnieks',
    polish: 'naukowiec, badacz',
    french: 'scientifique, chercheur',
    spanish: 'científico, investigador',
  },
  {
    av: 23653,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water creature + flower: water creature looking similar to a flower)',
    english: 'sea anemone',
    swedish: 'havsanemon, sjöanemon',
    norwegian: 'sjøanemone',
    finnish: 'merivuokko',
    hungarian: 'tengeri rózsa',
    german: 'Seeanemone',
    dutch: 'zeeanemoon',
    afrikaans: 'see anemoon',
    russian: 'актиния',
    latvian: 'aktīnija',
    polish: 'ukwiał, koralowiec (roślina podwodna)',
    french: 'anémone de mer, actinie',
    spanish: 'anémona de mar',
  },
  {
    av: 23654,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water creature + oval shape)',
    english: 'sea cucumber',
    swedish: 'sjögurka',
    norwegian: 'sjøpølse',
    finnish: 'merimakkara',
    hungarian: 'tengeri uborka',
    german: 'Seegurke',
    dutch: 'zeekomkommer',
    afrikaans: 'see komkommer',
    russian: 'морской огурец',
    latvian: 'jūras gurķis',
    polish: 'strzykwa, ogórek morski',
    french: 'concombre de mer, holothurie',
    spanish: 'pepino de mar',
  },
  {
    av: 23655,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water mammal (with tail) + to shout)',
    english: 'sea lion',
    swedish: 'sjölejon',
    norwegian: 'sjøløve',
    finnish: 'merileijona',
    hungarian: 'oroszlánfóka',
    german: 'Seelöwe',
    dutch: 'zeeleeuw',
    afrikaans: 'see leeu',
    russian: 'морской лев',
    latvian: 'jūras lauva',
    polish: 'uchatka, lew morski',
    french: 'lion de mer',
    spanish: 'león marino',
  },
  {
    av: 23656,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water creature + quills)',
    english: 'sea urchin',
    swedish: 'sjöborre',
    norwegian: 'sjøpinnsvin',
    finnish: 'merisiili',
    hungarian: 'tengeri sün',
    german: 'Seeigel',
    dutch: 'zee-egel',
    afrikaans: 'see urchin (pampoentjie)',
    russian: 'морской ёж',
    latvian: 'jūras ezis',
    polish: 'jeżowiec, szkarłupień',
    french: 'oursin',
    spanish: 'erizo de mar',
  },
  {
    av: 23657,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water mammal (with tail) + fur)',
    english: 'seal',
    swedish: 'säl',
    norwegian: 'sel',
    finnish: 'hylje',
    hungarian: 'fóka',
    german: 'Seehund, Robbe',
    dutch: 'zeehond',
    afrikaans: 'rob',
    russian: 'тюлень',
    latvian: 'ronis',
    polish: 'foka',
    french: 'phoque',
    spanish: 'sello',
  },
  {
    av: 23659,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to select + all + action indicator)',
    english: 'select all, mark all-(to)',
    swedish: 'markera allt',
    norwegian: 'velg alt(PC), merk alt (PC)',
    finnish: 'valita kaikki',
    hungarian: 'mindet kiválasztani, összest kijelölni',
    german: '(alles) markieren',
    dutch: 'selecteer alles',
    afrikaans: 'selekteer alles, merk alles (om te)',
    russian: 'выбирать всё',
    latvian: 'iezīmēt visu (darbība datorā)',
    polish: 'zaznacz wszystko',
    french: 'sélectionner tout',
    spanish: 'seleccionar todo, marcar todo',
  },
  {
    av: 23660,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + clam)',
    english: 'shellfish',
    swedish: 'skaldjur',
    norwegian: 'skalldyr',
    finnish: 'äyriäinen',
    hungarian: 'mészhéjú álaltok, pl. kagylók, rákfélék',
    german: 'Krebstier, Schalentier',
    dutch: 'zeevruchten',
    afrikaans: 'skulpvis',
    russian: 'моллюск',
    latvian: 'vēžveidīgais, mīkstmiesis',
    polish: 'małż, skorupiak (w muszli)',
    french: 'crustacés',
    spanish: 'marisco',
  },
  {
    av: 23661,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + sheep)',
    english: 'shepherd',
    swedish: 'herde',
    norwegian: 'gjeter',
    finnish: 'lammaspaimen',
    hungarian: 'juhpásztor, juhász, pásztor',
    german: 'Schäfer, Schäferin',
    dutch: 'herder',
    afrikaans: 'herder',
    russian: 'пастух',
    latvian: 'gans',
    polish: 'pasterz',
    french: 'berger',
    spanish: 'pastor',
  },
  {
    av: 23662,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(gun + action indicator)',
    english: 'shoot-(to)',
    swedish: 'skjuta',
    norwegian: 'skyte',
    finnish: 'ampua',
    hungarian: 'lőni',
    german: 'schießen, abfeuern',
    dutch: 'schieten',
    afrikaans: 'skiet (om te)',
    russian: 'стрелять',
    latvian: 'šaut, izšaut',
    polish: 'strzelać',
    french: 'tirer',
    spanish: 'disparar',
  },
  {
    av: 23663,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe woman + tree)',
    english: 'siren of the woods',
    swedish: 'skogsrå, huldra',
    norwegian: 'fantasifigur skogsalv, hulder',
    finnish: 'metsänneito',
    hungarian: 'erdei nimfa',
    german: 'Waldelfe, Sirene des Waldes',
    dutch: 'boomnimf',
    afrikaans: 'boomnimf woudnimf',
    russian: 'Лесная фея',
    latvian: 'Meža nimfa',
    polish: 'syrena drzewna, nimfa leśna lub galion',
    french: 'personnage imaginaire féminin (arbre)',
    spanish: 'sirena del bosque',
  },
  {
    av: 23664,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plan + digits (computer))',
    english: 'software, computer program, application, app',
    swedish: 'dataprogram, program (dator), applikation, app',
    norwegian: 'dataprogram, software',
    finnish: 'tietokoneohjelma',
    hungarian: 'szoftver, számítógép program',
    german: 'Computerprogramm, Software, App',
    dutch: 'software, computer programma',
    afrikaans: 'sagteware, rekenaar program, applikasie',
    russian: 'программное обеспечение, компьютерная программа',
    latvian: 'programmatūra datoram',
    polish: 'program komputerowy, software',
    french: 'logiciel, programme informatique',
    spanish: 'software, programa de ordenador',
  },
  {
    av: 23665,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(alphabet + action indicator)',
    english: 'spell-(to)',
    swedish: 'stava',
    norwegian: 'stave',
    finnish: 'tavata',
    hungarian: 'betűzni',
    german: 'buchstabieren',
    dutch: 'spellen',
    afrikaans: 'spel (om te)',
    russian: 'читать по буквам, читать по слогам',
    latvian: 'lādēt, nolādēt',
    polish: 'literować',
    french: 'orthographier, épeler',
    spanish: 'deletrear',
  },
  {
    av: 23666,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(little person + sport)',
    english: 'sport elf',
    swedish: 'sportälva, sportalf',
    norwegian: 'fantasifigur sportsalv',
    finnish: 'urheilukeiju',
    hungarian: 'sportmanó, sport-elf, sporttündér',
    german: 'Sportelfe (Island)',
    dutch: 'sportelf',
    afrikaans: 'sport kabouter',
    russian: 'спортивный эльф',
    latvian: 'sporta elfs, elfa',
    polish: 'duch sportu (istota)',
    french: 'personnage imaginaire (elfe des sports)',
    spanish: 'mascota de deporte',
  },
  {
    av: 23667,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to take + negative + action indicator)',
    english: 'steal-(to)',
    swedish: 'stjäla',
    norwegian: 'stjele',
    finnish: 'varastaa, anastaa',
    hungarian: 'lopni, ellopni, meglopni',
    german: 'stehlen, klauen',
    dutch: 'stelen',
    afrikaans: 'steel (om te)',
    russian: 'красть, воровать',
    latvian: 'zagt, nozagt',
    polish: 'kraść',
    french: "voler, prendre, s'approprier",
    spanish: 'robar',
  },
  {
    av: 23668,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sauce + animal + part: combination of sauce and diced meat)',
    english: 'stew',
    swedish: 'köttgryta',
    norwegian: 'stuing, kjøttgryte',
    finnish: 'lihapata, muhennos',
    hungarian: 'pörkölt, ragu',
    german: 'Eintopf, Eintopfgericht',
    dutch: 'vleessaus',
    afrikaans: 'bredie',
    russian: 'тушеное мясо',
    latvian: 'sautējums, gaļas',
    polish: 'gulasz mięsny',
    french: 'ragoût',
    spanish: 'estofado',
  },
  {
    av: 23669,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + knowledge)',
    english: 'subject (of study)',
    swedish: 'ämneskunskap, ämne',
    norwegian: 'studieemne',
    finnish: 'oppiaine',
    hungarian: 'tantárgy',
    german: 'Fachgebiet',
    dutch: 'vak (studie), studievak',
    afrikaans: 'vak (studie)',
    russian: 'тема (в обучении)',
    latvian: 'pētījuma jautājums, temats',
    polish: 'część, wycinek wiedzy, studiów',
    french: 'sujet, matière (cours, étude)',
    spanish: 'materia (de estudio)',
  },
  {
    av: 23670,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + cause + action)',
    english: 'switch',
    swedish: 'kontakt',
    norwegian: 'håndtak, vrider',
    finnish: 'katkaisija, kytkin',
    hungarian: 'kapcsoló',
    german: 'Taste, Druckschalter, Schalter',
    dutch: 'schakelaar',
    afrikaans: 'skakelaar',
    russian: 'переключатель',
    latvian: 'slēdzis',
    polish: 'przełącznik, włącznik',
    french: 'interrupteur',
    spanish: 'Interruptor',
  },
  {
    av: 23671,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + sword)',
    english: 'swordfish',
    swedish: 'svärdfisk',
    norwegian: 'sverdfisk',
    finnish: 'miekkakala',
    hungarian: 'kardhal',
    german: 'Schwertfisch',
    dutch: 'zwaardvis',
    afrikaans: 'swaardvis',
    russian: 'рыба-меч',
    latvian: 'zobenzivs',
    polish: 'ryba miecz, miecznik',
    french: 'espadon',
    spanish: 'pez espada',
  },
  {
    av: 23672,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(computer + hand) SYMBOL SYNONYM',
    english: 'tablet computer, tablet, tablet PC (2)',
    swedish: 'datorplatta, pekdator (2)',
    norwegian: 'datamaskin håndholdt, tablet (PC) (2)',
    finnish: 'tablet PC',
    hungarian: 'tablet, táblagép',
    german: 'Tablet, Flachcomputer (2)',
    dutch: 'tablet computer, tablet (computer) (2)',
    afrikaans: 'tabletrekenaar (2)',
    russian: 'планшетный компьютер, планшет (2)',
    latvian: 'planšetdators (2)',
    polish: 'tablet PC, komputer z ekranem dotykowym',
    french: 'tablette PC, tablette électronique, ordinateur tablette (2)',
    spanish: 'tablet PC (2)',
  },
  {
    av: 23674,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to make + clothes)',
    english: 'tailor, dressmaker, seamstress',
    swedish: 'skräddare, sömmerska',
    norwegian: 'skredder',
    finnish: 'räätäli, ompelija',
    hungarian: 'szabó, varrónő',
    german: 'Schneider, Schneiderin',
    dutch: 'kleermaker, naaister',
    afrikaans: 'naaldwerker',
    russian: 'портной',
    latvian: 'drēbnieks, šuvēja',
    polish: 'krawiec, krawcowa, szwaczka',
    french: 'tailleur, couturier',
    spanish: 'modista, sastre, costurera',
  },
  {
    av: 23675,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to exchange + knowledge)',
    english: 'teacher, pedagogue, educator',
    swedish: 'lärare, pedagog',
    norwegian: 'lærer, pedagog',
    finnish: 'opettaja, pedagogi',
    hungarian: 'tanító, tanár, pedagógus',
    german: 'Lehrer, Lehrerin, Pädagoge, Pädagogin',
    dutch: 'onderwijzer, onderwijzeres, leraar, juf, leerkracht',
    afrikaans: 'onderwyseres, juffrou, pedagoog, opvoedkundige',
    russian: 'учитель, педагог, преподаватель',
    latvian: 'skolotājs, pedagogs, izglītības darbinieks, (-ce)',
    polish: 'nauczyciel, pedagog, wychowawca',
    french: 'enseignant, pédagogue, éducateur',
    spanish: 'maestro, pedagogo, educador',
  },
  {
    av: 23676,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + knowledge: person + to teach [contr.]) Used in conjunction with a specifier.',
    english: 'teacher, pedagogue, educator (in combinations)',
    swedish: 'lärare, pedagog (i kombinationer)',
    norwegian: 'pedagog (brukes i kombinasjon)',
    finnish: 'opettaja, pedagogi',
    hungarian: 'tanító, tanár, pedagógus (szóösszetételben)',
    german: 'Lehrer, Lehrerin, Pädagoge, Pädagogin (in Kombinationen)',
    dutch: 'onderwijzer, onderwijzeres, leraar, juf, leerkracht',
    afrikaans: 'onderwyseres, juffrou, pedagoog, opvoedkundige (in kombinasie)',
    russian: 'учитель, педагог (в комбинации)',
    latvian: 'skolotājs, pedagogs, izglītības darbinieks (dažādās nozīmēs)',
    polish: 'nauczyciel, pedagog (specjalista)',
    french: 'enseignant (classificateur)',
    spanish: 'maestro, pedagogo, educador (en combinaciones)',
  },
  {
    av: 23677,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(card + telephone)',
    english: 'telephone card',
    swedish: 'telefonkort',
    norwegian: 'telefonkort',
    finnish: 'puhelinkortti',
    hungarian: 'telefonkártya',
    german: 'Telefonkarte',
    dutch: 'telefoonkaart',
    afrikaans: 'telefoonkaart',
    russian: 'телефонная карта',
    latvian: 'telefona karte',
    polish: 'karta telefoniczna',
    french: 'carte de téléphone',
    spanish: 'tarjeta de teléfonos',
  },
  {
    av: 23678,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(home + limited time)',
    english: 'temporary home',
    swedish: 'korttidshem',
    norwegian: 'bolig midlertidig',
    finnish: 'sijaiskoti, tilapäiskoti',
    hungarian: 'átmeneti othon',
    german: 'Behelfsheim, Übergangswohnung',
    dutch: 'kortverblijf',
    afrikaans: 'tydelike verblyf',
    russian: 'временный дом',
    latvian: 'pagaidu mājas',
    polish: 'mieszkanie tymczasowe',
    french: 'logement temporaire',
    spanish: 'casa temporal',
  },
  {
    av: 23679,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(telephone + alphabet)',
    english: 'text phone',
    swedish: 'texttelefon',
    norwegian: 'teksttelefon',
    finnish: 'tekstipuhelin',
    hungarian: 'szövegtelefon (hallássérültek részére)',
    german: 'Fernschreiber',
    dutch: 'teksttelefoon',
    afrikaans: 'teks telefoon',
    russian: 'текстофон',
    latvian: 'teksta telefons',
    polish: 'telefon tekstowy',
    french: 'message téléphonique écrit',
    spanish: 'teléfono de texto',
  },
  {
    av: 23680,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + theology',
    english: 'theologian, theologist',
    swedish: 'teolog',
    norwegian: 'teolog',
    finnish: 'teologi, uskontotieteilijä',
    hungarian: 'teológus, hittudós',
    german: 'Theologe, Theologin',
    dutch: 'theoloog',
    afrikaans: 'teoloog',
    russian: 'теолог, теологист',
    latvian: 'teologs',
    polish: 'teolog',
    french: 'théologien',
    spanish: 'teólogo',
  },
  {
    av: 23681,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(body of learning + God-based religion: system of religious beliefs and theories)',
    english: 'theology, philosophy of religion',
    swedish: 'teologi',
    norwegian: 'teologi, religionsvitenskap',
    finnish: 'teologia, uskonnon filosofia',
    hungarian: 'teológia, hittudomány',
    german: 'Theologie',
    dutch: 'theologie',
    afrikaans: 'teologie, filosofie van geloof',
    russian: 'теология',
    latvian: 'teoloģija, reliģijas filozofija',
    polish: 'teologia, filozofia religijna',
    french: 'théologie, philosophie religieuse (science)',
    spanish: 'teología, filosofía de la religión',
  },
  {
    av: 23682,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(building + therapy)',
    english: 'therapy centre, rehabilitation centre',
    swedish: 'rehabiliteringscenter, habiliteringscenter',
    norwegian: 'rehabiliteringssenter, habiliteringssenter',
    finnish: 'kuntoutuskeskus, kuntoutuslaitos',
    hungarian: 'rehabilitációs központ, terápiás centrum ',
    german: 'Rehabilitationszentrum',
    dutch: 'revalidatiecentrum',
    afrikaans: 'terapie sentrum, rehabilitasie sentrum',
    russian: 'реабилитационный центр, ценрт терапии',
    latvian: 'terapijas centrs, rehabilitācijas centrs',
    polish: 'ośrodek terapii, ośrodek rehabilitacyjny',
    french: 'centre de rééducation, centre de revalidation',
    spanish: 'centro de rehabilitación',
  },
  {
    av: 23683,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + receiving + negative: person + to steal [contr.])',
    english: 'thief',
    swedish: 'tjuv',
    norwegian: 'tyv',
    finnish: 'varas',
    hungarian: 'tolvaj',
    german: 'Dieb, Einbrecher',
    dutch: 'inbreker, dief',
    afrikaans: 'dief, inbreker',
    russian: 'вор',
    latvian: 'zaglis',
    polish: 'złodziej',
    french: 'voleur, cambrioleur',
    spanish: 'ladrón',
  },
  {
    av: 23684,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + dharma wheel)',
    english: 'Tibet',
    swedish: 'Tibet',
    norwegian: 'Tibet',
    finnish: 'Tiibet',
    hungarian: 'Tibet',
    german: 'Tibet',
    dutch: 'Tibet',
    afrikaans: 'Tibet',
    russian: 'Тибет',
    latvian: 'Tibeta',
    polish: 'Tybet',
    french: 'Tibet',
    spanish: 'Tibet ',
  },
  {
    av: 23685,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sauce + tomato)',
    english: 'tomato sauce',
    swedish: 'tomatsås, tomatpuré',
    norwegian: 'tomatsaus',
    finnish: 'tomaattikastike',
    hungarian: 'paradicsomszósz',
    german: 'Tomatenmark, Tomatensoße',
    dutch: 'tomatenpuree, tomatensaus',
    afrikaans: 'tamatie sous, tamatie puree',
    russian: 'томатный соус',
    latvian: 'tomātu biezenis',
    polish: 'sos pomidorowy',
    french: 'sauce tomate',
    spanish: 'salsa de tomate',
  },
  {
    av: 23686,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(fairy + teeth)',
    english: 'tooth fairy',
    swedish: 'tandfe',
    norwegian: 'fantasifigur tannfe',
    finnish: 'hammaskeiju',
    hungarian: 'Fogtündér, Fogmanó',
    german: 'Zahnfee',
    dutch: 'tandenfee',
    afrikaans: 'tande fee',
    russian: 'зубная фея',
    latvian: 'zobu laumiņa, feja',
    polish: 'zębowa wróżka, wróżka – zębuszka',
    french: 'personnage imaginaire (fée des dents)',
    spanish: 'ratoncito Pérez',
  },
  {
    av: 23687,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(computer screen, monitor + hand)',
    english: 'touch screen',
    swedish: 'pekskärm',
    norwegian: 'berøringsskjerm, touch screen (PC), pekeskjerm',
    finnish: 'kosketusnäyttö',
    hungarian: 'érintő képernyő',
    german: 'Touchscreen',
    dutch: 'aanraakscherm',
    afrikaans: 'raak skerm',
    russian: 'сенсорный экран',
    latvian: 'skārienjutīgs ekrāns',
    polish: 'ekran dotykowy',
    french: 'écran tactile',
    spanish: 'pantalla táctil',
  },
  {
    av: 23688,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pointing device + finger)',
    english: 'touchpad, trackpad',
    swedish: 'styrplatta (pekdon)',
    norwegian: 'berøringstast (PC), touch pad, trackpad (PC)',
    finnish: 'tasohiiri',
    hungarian: 'touchpad, trackpad, tapipad, ujjbeviteli vezérlő',
    german: 'Touchpad, Trackpad',
    dutch: 'touchpad',
    afrikaans: 'raakblad, touchpad, trackpad',
    russian: 'сенсорная панель',
    latvian: 'skārienjutīgs panelis',
    polish: 'touchpad, gładzik',
    french: 'pointeur tactile',
    spanish: 'touchpad',
  },
  {
    av: 23689,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + feeling: thing + play [contr.]) Used in conjunction with a specifier.',
    english: 'toy (in combinations)',
    swedish: 'leksak (i kombinationer)',
    norwegian: 'leke (brukes i kombinasjon)',
    finnish: 'leikkikalu, lelu',
    hungarian: 'játék, játékeszköz (szóösszetételben)',
    german: 'Spielzeug',
    dutch: 'speelgoed',
    afrikaans: 'speelgoed (in kombinasie)',
    russian: 'игрушка (в комбинации)',
    latvian: 'rotaļlieta (dažādās nozīmēs)',
    polish: 'zabawka (jako część symbolu złożonego)',
    french: 'jouet (classificateur)',
    spanish: 'juguete (en combinaciones)',
  },
  {
    av: 23691,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pointing device + ball)',
    english: 'trackball',
    swedish: 'styrkula, rullboll',
    norwegian: 'styrekule (PC), kulemus (PC)',
    finnish: 'pallohiiri, trackball',
    hungarian: 'trackball, hanyattegér',
    german: 'Trackball',
    dutch: 'trackball',
    afrikaans: 'trackball',
    russian: 'трекбол',
    latvian: 'kursorbumba',
    polish: 'trackball',
    french: 'trackball, pointeur balle, boule de commande',
    spanish: 'trackball',
  },
  {
    av: 23692,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play (theater) + down: play (theater) + sad [contr.])',
    english: 'tragedy',
    swedish: 'tragedi',
    norwegian: 'tragedie',
    finnish: 'tragedia',
    hungarian: 'tragédia',
    german: 'Tragödie',
    dutch: 'tragedie',
    afrikaans: 'tragedie',
    russian: 'трагедия',
    latvian: 'traģēdija',
    polish: 'tragedia (przedstawienie)',
    french: 'drame, tragédie',
    spanish: 'tragedia',
  },
  {
    av: 23693,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + travel)',
    english: 'traveller',
    swedish: 'resenär',
    norwegian: 'reisende',
    finnish: 'matkustaja',
    hungarian: 'utazó (fn.)',
    german: 'Reisende (männlich), Reisende (weiblich)',
    dutch: 'reiziger',
    afrikaans: 'reisiger',
    russian: 'путешественник',
    latvian: 'ceļotājs',
    polish: 'podróżnik',
    french: 'voyageur',
    spanish: 'viajero',
  },
  {
    av: 23694,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dinosaur + three + horn)',
    english: 'Triceratops',
    swedish: 'Triceratops',
    norwegian: 'Triceratops',
    finnish: 'triceratops',
    hungarian: 'triceratopsz',
    german: 'Triceratops',
    dutch: 'Triceratops',
    afrikaans: 'Triceratops',
    russian: 'Трицераптор',
    latvian: 'triceratops, dinozauru paveids',
    polish: 'triceratops',
    french: 'tricératops',
    spanish: 'Triceratops ',
  },
  {
    av: 23695,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(make-believe person + stone: trolls turn into stones when the sun rises)',
    english: 'troll',
    swedish: 'troll',
    norwegian: 'fantasifigur troll',
    finnish: 'peikko',
    hungarian: 'troll: misztikus, félelmetes lény (skandináv)',
    german: 'Troll, Waldschrat',
    dutch: 'trol',
    afrikaans: 'trol',
    russian: 'тролль',
    latvian: 'trollis',
    polish: 'troll',
    french: 'personnage imaginaire (troll des roches)',
    spanish: 'trol',
  },
  {
    av: 23696,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(make-believe person + linear thing + buttocks + thing ind.: trolls that have tails)',
    english: 'troll (tailed)',
    swedish: 'troll (med svans)',
    norwegian: 'fantasifigur troll (med hale)',
    finnish: 'peikko (hännällinen)',
    hungarian: 'troll farokkal, farkos troll',
    german: 'Troll, Waldschrat',
    dutch: 'trol (met staart)',
    afrikaans: 'trol (met stert)',
    russian: 'тролль с хвостом',
    latvian: 'trollis, ar asti',
    polish: 'trolli ogoniasty',
    french: 'personnage imaginaire (troll)',
    spanish: 'trol (con cola)',
  },
  {
    av: 23697,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + huge)',
    english: 'tuna fish',
    swedish: 'tonfisk',
    norwegian: 'tunfisk',
    finnish: 'tonnikala',
    hungarian: 'tonhal',
    german: 'Thunfisch',
    dutch: 'tonijn',
    afrikaans: 'tuna vis',
    russian: 'тунец',
    latvian: 'tuncis',
    polish: 'tuńczyk',
    french: 'thon',
    spanish: 'atún',
  },
  {
    av: 23698,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to write + machine + action indicator)',
    english: 'type-(to)',
    swedish: 'skriva (på tangentbord)',
    norwegian: 'taste',
    finnish: 'kirjoittaa koneella, konekirjoittaa',
    hungarian: 'gépelni',
    german: 'tippen, Schreibmaschine schreiben',
    dutch: 'typen',
    afrikaans: 'tik (om te)',
    russian: 'печатать',
    latvian: 'rakstīt uz tastatūras',
    polish: 'pisać na maszynie',
    french: 'taper, dactylographier',
    spanish: 'escribir',
  },
  {
    av: 23699,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dinosaur + crown: the “King” of dinosaurs)',
    english: 'Tyrannosaurus Rex',
    swedish: 'Tyrannosaurus Rex',
    norwegian: 'Tyrannosaurus Rex',
    finnish: 'tyrannosaurus, tyrannosaurus rex, tyrannilisko',
    hungarian: 'tirannoszaurusz rex, zsarnokgyík',
    german: 'Tyrannosaurus',
    dutch: 'Tyrannosaurus Rex',
    afrikaans: 'Tyrannosaurus Rex',
    russian: 'тираннозавр рекс',
    latvian: 'tiranozaurs rex',
    polish: 'tyrannosaurus rex',
    french: 'tyrannosaurus rex',
    spanish: 'Tyrannosaurus Rex ',
  },
  {
    av: 23700,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to take away + action + in front of + action indicator)',
    english: 'undo-(to)',
    swedish: 'ångra, ändra sig',
    norwegian: 'gjøre om, angre',
    finnish: 'kumota, peruuttaa',
    hungarian: 'semmissé tenni, meg nem történtté tenni',
    german: '(rückgängig) machen',
    dutch: 'herstellen',
    afrikaans: 'ongedaan maak (om te)',
    russian: 'вернуться, возвращяться отменить, изменить',
    latvian: 'atsaukt, likvidēt, anulēt',
    polish: 'zaniechanie, poniechanie',
    french: 'annuler',
    spanish: 'deshacer',
  },
  {
    av: 23701,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(jump (backward) + digits (computer) + action indicator)',
    english: 'undo (computer)-(to)',
    swedish: 'ångra (dator)',
    norwegian: 'gjøre om, endre (PC)',
    finnish: 'kumota (tietokone)',
    hungarian: 'visszacsinálni, visszahozni (szgép)',
    german: '(rückgängig) machen',
    dutch: 'undo (computer)',
    afrikaans: 'ongedaan maak (rekenaar) (om te)',
    russian: 'отменить (компьютер)',
    latvian: 'atsaukt (darbība datorā)',
    polish: 'cofnij (informatyka)',
    french: 'annuler (informatique)',
    spanish: 'deshacer (ordenador)',
  },
  {
    av: 23703,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to go + awake + action indicator)',
    english: 'wake up-(to)',
    swedish: 'vakna',
    norwegian: 'våkne',
    finnish: 'herättää, herätä',
    hungarian: ' ébredni, ébreszteni, felébredni, felébreszteni',
    german: 'aufwachen',
    dutch: 'wakker worden',
    afrikaans: 'wakker word (om te)',
    russian: 'вставать, просыпаться',
    latvian: 'pamosties',
    polish: 'budzić się',
    french: "éveiller-(s')",
    spanish: 'despertar, despertarse',
  },
  {
    av: 23704,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water creature with tail + teeth)',
    english: 'walrus',
    swedish: 'valross',
    norwegian: 'hvalross',
    finnish: 'mursu',
    hungarian: 'rozmár',
    german: 'Walross',
    dutch: 'walrus',
    afrikaans: 'walrus',
    russian: 'морж',
    latvian: 'valzirgs',
    polish: 'mors',
    french: 'morse',
    spanish: 'morsa',
  },
  {
    av: 23705,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to wash + glassware + action indicator)',
    english: 'wash up, do the dishes-(to)',
    swedish: 'diska',
    norwegian: 'vaske opp',
    finnish: 'pestä astiat, tiskata',
    hungarian: 'mosogatni, elmosogatni',
    german: 'waschen (Geschirr), abwaschen',
    dutch: 'afwassen, vaat doen',
    afrikaans: 'skottelgoed was (om te)',
    russian: 'мыть посуду',
    latvian: 'mazgāt traukus',
    polish: 'umyć się',
    french: 'faire la vaisselle',
    spanish: 'lavar los platos',
  },
  {
    av: 23707,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play [contr.] + water)',
    english: 'water play',
    swedish: 'vattenlek',
    norwegian: 'vannlek',
    finnish: 'vesileikki',
    hungarian: 'vízben játszás, vízi játék',
    german: 'Wasserspiel, (spielen mit) Wasser',
    dutch: 'waterspel',
    afrikaans: 'water spel',
    russian: 'игра с водой',
    latvian: 'ūdensspēles',
    polish: 'zabawy w wodzie',
    french: "jeu d'eau",
    spanish: 'juego de agua',
  },
  {
    av: 23708,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(toy [contr.] + water)',
    english: 'water toy',
    swedish: 'vattenleksak',
    norwegian: 'vannleke',
    finnish: 'vesilelu',
    hungarian: 'vízijáték',
    german: 'Spielzeug',
    dutch: 'waterspeelgoed, badspeelgoed',
    afrikaans: 'water speelding',
    russian: 'игрушка для игр с водой ',
    latvian: 'ūdens rotaļlietas',
    polish: 'zabawki wodne',
    french: "jouet d'eau",
    spanish: 'juguete acuático',
  },
  {
    av: 23709,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(name + place + digital world)',
    english: 'website, domain name, homepage, internet domain',
    swedish: 'webbsida',
    norwegian: 'webside',
    finnish: 'webbisivu',
    hungarian: 'honlap, website',
    german: 'Website, Webseite, Internetseite',
    dutch: 'website',
    afrikaans: 'webwerf',
    russian: 'интернет сайт',
    latvian: 'interneta vietne',
    polish: 'strona internetowa',
    french: 'web, site web',
    spanish: 'sitio web',
  },
  {
    av: 23710,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + vegetable (above ground))',
    english: 'vegetable(s)',
    swedish: 'grönsak, grönsaker (allmänt)',
    norwegian: 'grønnsaker',
    finnish: 'vihannekset',
    hungarian: 'zöldségféle',
    german: '(gemischtes) Gemüse',
    dutch: 'groenten',
    afrikaans: 'groente(s)',
    russian: 'овощи',
    latvian: 'dārzeņi',
    polish: 'warzywa',
    french: 'légumes',
    spanish: 'hortalizas',
  },
  {
    av: 23711,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(program + to destroy)',
    english: 'virus (computer)',
    swedish: 'virus (dator)',
    norwegian: 'virus (PC)',
    finnish: 'tietokonevirus',
    hungarian: 'vírus (számítógépes)',
    german: 'Virus, Computervirus',
    dutch: 'virus (computer)',
    afrikaans: 'virus (rekenaar)',
    russian: 'компьютерный вирус',
    latvian: 'datorvīruss',
    polish: 'wirus (komputerowy)',
    french: 'virus (informatique)',
    spanish: 'virus (ordenador)',
  },
  {
    av: 23712,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe woman + broom)',
    english: 'witch',
    swedish: 'häxa',
    norwegian: 'fantasifigur heks',
    finnish: 'noita',
    hungarian: 'boszorkány, boszorka',
    german: 'Hexe',
    dutch: 'heks',
    afrikaans: 'heks',
    russian: 'ведьма',
    latvian: 'ragana',
    polish: 'wiedźma',
    french: 'personnage imaginaire (sorcière)',
    spanish: 'bruja',
  },
  {
    av: 23713,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe man + wand)',
    english: 'wizard',
    swedish: 'trollkarl',
    norwegian: 'fantasifigur trollmann',
    finnish: 'velho, taikuri',
    hungarian: 'varázsló, mágus, boszorkánymester',
    german: 'Zauberer, Hexenmeister',
    dutch: 'tovenaar',
    afrikaans: 'towenaar',
    russian: 'волшебник, колдун',
    latvian: 'mags, burvis, brīnumdaris',
    polish: 'czarodziej',
    french: 'personnage imaginaire (magicien, enchanteur)',
    spanish: 'mago',
  },
  {
    av: 23714,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(woman + man-made)',
    english: 'woman doll (e.g. Barbie)',
    swedish: 'docka (kvinnlig) (t ex Barbie)',
    norwegian: 'dokke (hunkjønn) (f. eks. Barbie)',
    finnish: 'naisnukke, Barbie',
    hungarian: 'játékbaba (lány, pl. Barbi)',
    german: 'Puppe',
    dutch: 'pop (barbie), pop (vrouwelijk), meisjespop',
    afrikaans: 'pop (vroulik) (b.v. Barbie)',
    russian: 'Барби (кукла)',
    latvian: 'lelle-jaunkundze (piem., Bārbija)',
    polish: 'lalka kobieta (np. Barbie)',
    french: 'poupée (ex. Barbie)',
    spanish: 'muñeca (p.ej. Barbie)',
  },
  {
    av: 23715,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + to work)',
    english: 'worksheet',
    swedish: 'arbetsblad',
    norwegian: 'arbeidsark',
    finnish: 'tehtäväpaperi',
    hungarian: 'feladatlap',
    german: 'Arbeitsblatt',
    dutch: 'werkblad',
    afrikaans: 'werksblad',
    russian: 'рабочий лист',
    latvian: 'darba lapa',
    polish: 'arkusz',
    french: 'feuille de travail',
    spanish: 'hoja de cálculo',
  },
  {
    av: 23716,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to write)',
    english: 'writer, author',
    swedish: 'författare',
    norwegian: 'forfatter',
    finnish: 'kirjailija',
    hungarian: 'író, szerző (fn.)',
    german: 'Schreiber, Schreiberin',
    dutch: 'schrijver, auteur',
    afrikaans: 'skrywer',
    russian: 'писатель, автор',
    latvian: 'rakstnieks, autors',
    polish: 'pisarz, autor',
    french: 'écrivain, auteur',
    spanish: 'escritor, autor',
  },
  {
    av: 23801,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + negative + intensity)',
    english: 'accident',
    swedish: 'olycka, olyckshändelse',
    norwegian: 'ulykke',
    finnish: 'onnettomuus',
    hungarian: 'baleset, szerencsétlenség',
    german: 'Unglück, Unfall',
    dutch: 'ongeluk',
    afrikaans: 'ongeluk',
    russian: 'авария',
    latvian: 'nelaimes gadījums',
    polish: 'wypadek',
    french: 'accident',
    spanish: 'accidente',
  },
  {
    av: 23802,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wind instrument + back and forth)',
    english: 'accordion',
    swedish: 'dragspel',
    norwegian: 'trekkspill',
    finnish: 'haitari, harmonikka, hanuri',
    hungarian: 'harmonika, tangóharmonika',
    german: 'Akkordeon, Schifferklavier',
    dutch: 'accordeon',
    afrikaans: 'trekklavier',
    russian: 'аккордион',
    latvian: 'akordeons',
    polish: 'akordeon',
    french: 'accordéon',
    spanish: 'acordeón',
  },
  {
    av: 23804,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + more + sound + intensity) SYMBOL SYNONYM',
    english: 'amplifier (1)',
    swedish: 'förstärkare (ljud) (1)',
    norwegian: 'forsterker (lyd) (1)',
    finnish: 'vahvistin',
    hungarian: 'erősítő, hangerősítő',
    german: 'Verstärker (1)',
    dutch: 'versterker (1)',
    afrikaans: 'versterker (1)',
    russian: 'усилитель звука (1)',
    latvian: 'pastiprinātājs (1)',
    polish: 'wzmacniacz (1)',
    french: 'amplificateur (1)',
    spanish: 'amplificador (1)',
  },
  {
    av: 23805,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + more + sound + intensity) SYMBOL SYNONYM',
    english: 'amplifier (2)',
    swedish: 'förstärkare (ljud) (2)',
    norwegian: 'forsterker (lyd) (2)',
    finnish: 'vahvistin',
    hungarian: 'erősítő, hangerősítő',
    german: 'Verstärker (2)',
    dutch: 'versterker (2)',
    afrikaans: 'versterker (2)',
    russian: 'усилитель звука (2)',
    latvian: 'pastiprinātājs (2)',
    polish: 'wzmacniacz (2)',
    french: 'amplificateur (2)',
    spanish: 'amplificador (2)',
  },
  {
    av: 23806,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + group of + string + table)',
    english: 'autoharp, zither, kantele',
    swedish: 'cittra, kantele (etc)',
    norwegian: 'harpe, sitar, kantele',
    finnish: 'kantele, sitra',
    hungarian: 'citera, autoharp, kantele (finn)',
    german: 'Zither',
    dutch: 'cither',
    afrikaans: 'outoharp, siter, kantele',
    russian: 'цитра, кантеле',
    latvian: 'cītara',
    polish: 'cytra, kantele, odmiana cytry',
    french: 'cithare',
    spanish: 'cítara diatónica, cítara, kantele',
  },
  {
    av: 23807,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wind instrument + bag)',
    english: 'bagpipe',
    swedish: 'säckpipa',
    norwegian: 'sekkepipe',
    finnish: 'säkkipilli',
    hungarian: 'duda',
    german: 'Dudelsack, Sackpfeife',
    dutch: 'doedelzak',
    afrikaans: 'doedelsak',
    russian: 'волынка',
    latvian: 'dūdas',
    polish: 'dudy',
    french: 'cornemuse',
    spanish: 'gaita',
  },
  {
    av: 23808,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(string instrument + metal [contr.])',
    english: 'banjo',
    swedish: 'banjo',
    norwegian: 'banjo',
    finnish: 'banjo',
    hungarian: 'bendzsó',
    german: 'Banjo',
    dutch: 'banjo',
    afrikaans: 'banjo',
    russian: 'банджо',
    latvian: 'bandžo',
    polish: 'banjo',
    french: 'banjo',
    spanish: 'banjo',
  },
  {
    av: 23810,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clarinet + big)',
    english: 'bass clarinet',
    swedish: 'basklarinett',
    norwegian: 'bassklarinett',
    finnish: 'bassoklarinetti',
    hungarian: 'basszus klarinét',
    german: 'Bassklarinette',
    dutch: 'basklarinet',
    afrikaans: 'bas klarinet',
    russian: 'бас-кларнет',
    latvian: 'basa klarnete',
    polish: 'klarnet basowy',
    french: 'clarinette basse',
    spanish: 'clarinete bajo',
  },
  {
    av: 23811,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(string instrument + bass)',
    english: 'bass guitar',
    swedish: 'basgitarr',
    norwegian: 'bassgitar',
    finnish: 'bassokitara',
    hungarian: 'basszusgitár',
    german: 'Bassgitarre',
    dutch: 'basgitaar',
    afrikaans: 'bas kitaar',
    russian: 'бас-гитара',
    latvian: 'basģitāra',
    polish: 'gitara basowa',
    french: 'guitare basse',
    spanish: 'guitarra baja',
  },
  {
    av: 23812,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(oboe (1) + big) SYMBOL SYNONYM',
    english: 'bassoon (1)',
    swedish: 'fagott (1)',
    norwegian: 'fagott (1)',
    finnish: 'fagotti',
    hungarian: 'basszuskürt',
    german: 'Fagott (1)',
    dutch: 'fagot (1)',
    afrikaans: 'fagot (1)',
    russian: 'фагот (1)',
    latvian: 'fagots (1)',
    polish: 'fagot (1)',
    french: 'basson (1)',
    spanish: 'fagot (1)',
  },
  {
    av: 23813,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(oboe (2) + tenor) SYMBOL SYNONYM',
    english: 'bassoon (2)',
    swedish: 'fagott (2)',
    norwegian: 'fagott (2)',
    finnish: 'fagotti',
    hungarian: 'fagott',
    german: 'Fagott (2)',
    dutch: 'fagot (2)',
    afrikaans: 'fagot (2)',
    russian: 'фагот (2)',
    latvian: 'fagots (2)',
    polish: 'fagot (2)',
    french: 'basson (2)',
    spanish: 'fagot (2)',
  },
  {
    av: 23814,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + bell, chime bar)',
    english: 'bells, chime bars, tubular bells',
    swedish: 'klockspel',
    norwegian: 'klokkespill',
    finnish: 'kellopeli',
    hungarian: 'harangjáték, csőharang',
    german: 'Schellenring',
    dutch: 'klokkenspel',
    afrikaans: 'klokke',
    russian: 'карильон',
    latvian: 'zvaniņi, zvanu spēle',
    polish: 'dzwony, gongi, dzwonki rurowe',
    french: 'clochette, carillon, gong',
    spanish: 'campanas, carillones, gongs',
  },
  {
    av: 23815,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + between + street)',
    english: 'block, city block',
    swedish: 'kvarter',
    norwegian: 'kvartal (by)',
    finnish: 'kortteli',
    hungarian: 'blokk, egy saroknyi ház, utcával határolt egység',
    german: 'Häuserreihe, Häuserblock, Karree',
    dutch: 'huizenblok, wijk',
    afrikaans: 'blok, dorps blok',
    russian: 'квартал, городской квартал',
    latvian: 'kvartāls, pilsētas kvartāls',
    polish: 'przecznica, kwadrat ulic (w mieście)',
    french: 'bloc (de maisons en ville)',
    spanish: 'manzana urbana',
  },
  {
    av: 23816,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + hand + to repeat)',
    english: 'bongo drum, hand drum',
    swedish: 'bongotrumma, handtrumma',
    norwegian: 'bongotromme, håndtromme',
    finnish: 'bongorummut',
    hungarian: 'bongó dob, kézidob',
    german: 'Bongotrommel',
    dutch: 'djembe, handtrommel',
    afrikaans: 'bongo handtrom',
    russian: 'бонго, ручной барабан',
    latvian: 'bongo, rokas bungas',
    polish: 'bębny ręcznie, perkusja',
    french: 'tambour, djembé, tam-tam',
    spanish: 'tambor, bongo',
  },
  {
    av: 23820,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + bow and string)',
    english: 'bow and string instrument',
    swedish: 'stråk- och stränginstrument',
    norwegian: 'strykeinstrument',
    finnish: 'jousisoitin',
    hungarian: 'vonós és húros hangszer, húros és vonós hanszer',
    german: 'Streichinstrument (Saiteninstrument)',
    dutch: 'strijkinstrument',
    afrikaans: 'boog en snaar strykstok (musiek)',
    russian: 'струнный инструмент',
    latvian: 'lociņa un stīgu mūzikas instrumenti',
    polish: 'instrument smyczkowy',
    french: 'instrument à cordes frottées',
    spanish: 'instrumento de arco y cuerdas',
  },
  {
    av: 23821,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + stop)',
    english: 'brake (general)',
    swedish: 'broms (allmänt)',
    norwegian: 'brems',
    finnish: 'jarru',
    hungarian: 'fék',
    german: 'Bremse, Rollstuhlbremse (allgemein)',
    dutch: 'rem',
    afrikaans: 'rem (algemeen)',
    russian: 'тормоз (общий термин)',
    latvian: 'bremze',
    polish: 'hamulec (ogólne)',
    french: 'frein (général)',
    spanish: 'freno (general)',
  },
  {
    av: 23822,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + stop + to move)',
    english: 'brake (vehicle)',
    swedish: 'broms (på fordon)',
    norwegian: 'brems (på kjøretøy)',
    finnish: 'jarru (kulkuneuvo)',
    hungarian: 'járműfék, autófék',
    german: 'Bremse, Rollstuhlbremse (Fahrzeug)',
    dutch: 'rem (voertuig)',
    afrikaans: 'rem (voertuig)',
    russian: 'тормоз (транспорт)',
    latvian: 'bremze (automašīnas)',
    polish: 'hamulce (pojazd)',
    french: 'frein (de véhicule)',
    spanish: 'freno (vehículo)',
  },
  {
    av: 23823,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + metal [contr.])',
    english: 'brass instrument',
    swedish: 'mässingsinstrument',
    norwegian: 'messinginstrument',
    finnish: 'vaskipuhallin',
    hungarian: 'basszus hangszer',
    german: 'Bassinstrument',
    dutch: 'koper blaasinstrument',
    afrikaans: 'koper (instrument)',
    russian: 'духовой инструмент',
    latvian: 'pūšaminstruments',
    polish: 'instrument dęty',
    french: 'cuivres (instruments de musique)',
    spanish: 'instrumento de metal',
  },
  {
    av: 23824,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wind + little)',
    english: 'breeze',
    swedish: 'bris',
    norwegian: 'bris',
    finnish: 'tuulenhenkäys, tuulahdus',
    hungarian: 'szellő, fuvallat',
    german: 'Brise',
    dutch: 'briesje, tocht (wind)',
    afrikaans: 'bries',
    russian: 'ветерок, бриз',
    latvian: 'vēsma, viegls vējš, brīze',
    polish: 'wietrzyk, bryza',
    french: 'brise',
    spanish: 'brisa',
  },
  {
    av: 23825,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(horn + combat) SYMBOL SYNONYM',
    english: 'bugle (1)',
    swedish: 'signalhorn, bygelhorn (etc) (1)',
    norwegian: 'signalhorn',
    finnish: 'flyygelitorvi',
    hungarian: 'kürt',
    german: 'Horn, Jagdhorn, Waldhorn, Signalhorn (1)',
    dutch: 'bugel (1)',
    afrikaans: 'beuel (1)',
    russian: 'горн (1)',
    latvian: 'rags, taure (1)',
    polish: 'róg myśliwski, trąbka (1)',
    french: 'clairon (1)',
    spanish: 'corneta (1)',
  },
  {
    av: 23826,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(brass instrument + 0 + disc: horn with no valves) SYMBOL SYNONYM',
    english: 'bugle (2)',
    swedish: 'signalhorn, bygelhorn (etc) (2)',
    norwegian: 'signaltrompet',
    finnish: 'flyygelitorvi',
    hungarian: 'kürt',
    german: 'Horn, Jagdhorn, Waldhorn, Signalhorn (2)',
    dutch: 'bugel (2)',
    afrikaans: 'beuel (2)',
    russian: 'горн (2)',
    latvian: 'rags, taure (2)',
    polish: 'róg myśliwski, trąbka (2)',
    french: 'clairon (2)',
    spanish: 'corneta (2)',
  },
  {
    av: 23828,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + wind)',
    english: 'calm, lull',
    swedish: 'stiltje',
    norwegian: 'stille (i stilla)',
    finnish: 'tyyni sää',
    hungarian: 'szélcsend',
    german: 'beruhigen, einlullen',
    dutch: 'windstil',
    afrikaans: 'windstilte, kalm',
    russian: 'штиль',
    latvian: 'bezvējš',
    polish: 'cisza, zastój, bezwietrzna pogoda',
    french: 'calme, quiétude',
    spanish: 'calma, tranquilidad',
  },
  {
    av: 23829,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(calm + description indicator)',
    english: 'calm (weather)',
    swedish: 'vindstilla',
    norwegian: 'vindstille',
    finnish: 'tuuleton, tyyni',
    hungarian: 'szélcsendes, nyugodt idő',
    german: 'Flaute, Windstille',
    dutch: 'windstil',
    afrikaans: 'kalm (weer)',
    russian: 'безветренный',
    latvian: 'mierīgs, bezvēja laiks',
    polish: 'cisza, bezwietrznie (pogoda)',
    french: 'calme (temps)',
    spanish: 'calma (clima)',
  },
  {
    av: 23830,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(disc + finger) SYMBOL SYNONYM',
    english: 'castanets (1)',
    swedish: 'kastanjett (1)',
    norwegian: 'kastanjett (1)',
    finnish: 'kastanjetit',
    hungarian: 'kasztanyetta, csattogtató',
    german: 'Kastagnette (1)',
    dutch: 'castagnetten (1)',
    afrikaans: 'kastanjette (1)',
    russian: 'кастаньеты (1)',
    latvian: 'kastaņetes (1)',
    polish: 'kastaniety (1)',
    french: 'castagnettes (1)',
    spanish: 'castañuelas (1)',
  },
  {
    av: 23831,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + up and down + disc + finger) SYMBOL SYNONYM',
    english: 'castanets (2)',
    swedish: 'kastanjett (2)',
    norwegian: 'kastanjett (2)',
    finnish: 'kastanjetit',
    hungarian: 'kasztanyetta, csattogtató',
    german: 'Kastagnette (2)',
    dutch: 'castagnetten (2)',
    afrikaans: 'kastanjette (2)',
    russian: 'кастаньеты (2)',
    latvian: 'kastaņetes (2)',
    polish: 'kastaniety (2)',
    french: 'castagnettes (2)',
    spanish: 'castañuelas (2)',
  },
  {
    av: 23832,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + CD, record)',
    english: 'CD cover',
    swedish: 'cd-fodral',
    norwegian: 'cd cover, cd futteral',
    finnish: 'CD-kotelo',
    hungarian: 'CD borító',
    german: 'CD-Hülle, CD-Gehäuse',
    dutch: 'CD hoes',
    afrikaans: 'CD beskermer',
    russian: 'футляр для CD ',
    latvian: 'CD diska vāciņi',
    polish: 'okładka płyty CD',
    french: 'pochette de CD',
    spanish: 'caja de cd',
  },
  {
    av: 23834,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bow and string instrument + tenor)',
    english: 'cello',
    swedish: 'cello',
    norwegian: 'cello',
    finnish: 'sello',
    hungarian: 'cselló, gordonka',
    german: 'Cello',
    dutch: 'cello',
    afrikaans: 'tjello',
    russian: 'виолончель',
    latvian: 'čells',
    polish: 'wiolonczela',
    french: 'violoncelle',
    spanish: 'violonchelo',
  },
  {
    av: 23835,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(song + child)',
    english: "children's song, nursery rhyme",
    swedish: 'barnvisa',
    norwegian: 'barnesang',
    finnish: 'lastenlaulu',
    hungarian: 'gyerekdal, mondóka',
    german: 'Kinderlied, Wiegenlied',
    dutch: 'kinderlied',
    afrikaans: 'kinder lied rym',
    russian: 'детская песня',
    latvian: 'bērnu dziesma, skaitāmpantiņš ',
    polish: 'piosenki dla dzieci, wierszyk dziecinny',
    french: 'chanson enfantine',
    spanish: 'canción de cuna, canción infantil',
  },
  {
    av: 23837,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flute, recorder + reed) SYMBOL SYNONYM',
    english: 'clarinet, reed instrument (1)',
    swedish: 'klarinett, rörbladsinstrument (1)',
    norwegian: 'klarinett, rørbladinstrument (1)',
    finnish: 'klarinetti',
    hungarian: 'klarinét, egyéb nádfuvókás hangszer',
    german: 'Klarinette, Rohrblattinstrument (1)',
    dutch: 'klarinet (1)',
    afrikaans: 'klarinet, riet instrument (1)',
    russian: 'кларнет, духовой инструмент (1) ',
    latvian: 'klarnete, pūšaminstruments, stabuļu instrumenti (1)',
    polish: 'klarnet (1)',
    french: 'instrument à anche, clarinette (1)',
    spanish: 'clarinete, instrumento de lengüeta (1)',
  },
  {
    av: 23838,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + reed) SYMBOL SYNONYM',
    english: 'clarinet, reed instrument (2)',
    swedish: 'klarinett, rörbladsinstrument (2)',
    norwegian: 'klarinett, rørbladinstrument (2)',
    finnish: 'klarinetti, puhallinsoitin',
    hungarian: 'klarinét, egyéb nádfuvókás hangszer',
    german: 'Klarinette, Rohrblattinstrument (2)',
    dutch: 'klarinet (2)',
    afrikaans: 'klarinet, riet instrument (2)',
    russian: 'кларнет, духовой инструмент (2)',
    latvian: 'klarnete, pūšaminstruments, stabuļu instrumenti (2)',
    polish: 'klarnet (2)',
    french: 'instrument à anche, clarinette (2)',
    spanish: 'clarinete, instrumento de lengüeta (2)',
  },
  {
    av: 23840,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(condensation + action indicator)',
    english: 'condense-(to)',
    swedish: 'kondensera',
    norwegian: 'kondensere',
    finnish: 'kondensoida, tiivistyä, tislata',
    hungarian: 'sűríteni, összesűríteni, kondenzálni',
    german: 'verdichten, kondensieren, komprimieren',
    dutch: 'condenseren',
    afrikaans: 'kondenseer (om te)',
    russian: 'конденсироваться',
    latvian: 'kondensēties',
    polish: 'kondensować, skraplać',
    french: 'condenser',
    spanish: 'condensar',
  },
  {
    av: 23841,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(music + countryside)',
    english: 'country music',
    swedish: 'countrymusik',
    norwegian: 'countrymusikk',
    finnish: 'countrymusiikki, kantri',
    hungarian: 'countryzene',
    german: 'Country Musik',
    dutch: 'countrymuziek',
    afrikaans: 'volksmusiek, country musiek',
    russian: 'кантри-музыка',
    latvian: 'kantri mūzika',
    polish: 'mucyka country',
    french: 'musique country',
    spanish: 'música country',
  },
  {
    av: 23842,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + disc + together)',
    english: 'cymbal',
    swedish: 'cymbal',
    norwegian: 'cymbal',
    finnish: 'symbaali, lautanen (soitin)',
    hungarian: 'cintányér',
    german: 'Zimbel, Becken',
    dutch: 'cymbaal',
    afrikaans: 'simbaal',
    russian: 'тарелки, кимвалы',
    latvian: 'cimbala',
    polish: 'talerz, czynel (muzyka)',
    french: 'cymbale',
    spanish: 'platillo',
  },
  {
    av: 23843,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(music + legs and feet: music + dance [contr.])',
    english: 'dance music',
    swedish: 'dansmusik',
    norwegian: 'dansemusikk',
    finnish: 'tanssimusiikki',
    hungarian: 'tánczene',
    german: 'Tanzmusik',
    dutch: 'dansmuziek',
    afrikaans: 'dans musiek',
    russian: 'танцевальная музыка',
    latvian: 'deju mūzika',
    polish: 'muzyka taneczna, muzyka do tańca',
    french: 'musique de danse',
    spanish: 'música de baile',
  },
  {
    av: 23844,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(without + light + description indicator) Preferred NEW SYNONYM, replacing 13634',
    english: 'dark',
    swedish: 'mörk',
    norwegian: 'mørk',
    finnish: 'pimeä, tumma',
    hungarian: 'sötét',
    german: 'dunkel',
    dutch: 'donker',
    afrikaans: 'donker',
    russian: 'темно, тёмный',
    latvian: 'tumsa',
    polish: 'ciemny, mroczny, bez światła',
    french: 'sombre',
    spanish: 'oscuro',
  },
  {
    av: 23845,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(feeling + negative + intensity + intensity + action indicator)',
    english: 'detest, despise-(to)',
    swedish: 'avsky (verb)',
    norwegian: 'avsky (å)',
    finnish: 'inhota, inhottaa',
    hungarian: 'lenézni, megvetni, utálni',
    german: 'hassen, verachten, verschmähen, verabscheuen',
    dutch: 'verafschuwen',
    afrikaans: 'verafsku (om te)',
    russian: 'ненавидеть, презирать',
    latvian: 'ienīst, nicināt, just riebumu',
    polish: 'nienawidzić, pogardzać, nie cierpieć (bardzo mocno)',
    french: 'détester, mépriser',
    spanish: 'detestar, despreciar',
  },
  {
    av: 23846,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + negative + intensity + intensity)',
    english: 'disaster, catastrophe',
    swedish: 'katastrof',
    norwegian: 'katastrofe',
    finnish: 'katastrofi, suuronnettomuus',
    hungarian: 'szerencsétlenség, katasztrófa',
    german: 'Katastrophe, Unglück, Verhängnis, Desaster, Zusammenbruch',
    dutch: 'catastrofe, ramp',
    afrikaans: 'katastrofe ramp',
    russian: 'катастрофа',
    latvian: 'posts, nelaime, katastrofa',
    polish: 'katastrofa, niszczycielski żywioł',
    french: 'catastrophe, désastre',
    spanish: 'desastre, catástrofe',
  },
  {
    av: 23847,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + countryside)',
    english: 'district, area, neighbourhood (country)',
    swedish: 'distrikt, bygd, trakt, område',
    norwegian: 'bygd, grend, distrikt, område',
    finnish: 'alue, naapurusto',
    hungarian: 'környék, szomszédság (vidéken)',
    german: 'Bezirk (ländliche Gegend)',
    dutch: 'omgeving, buurt',
    afrikaans: 'omgewing buurt (platteland)',
    russian: 'район сельской местности',
    latvian: 'apgabals, rajons, apkārtne (laukos)',
    polish: 'okolica (wieś)',
    french: 'quartier, région (de campagne)',
    spanish: 'distrito, vecindario (rural)',
  },
  {
    av: 23848,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + city)',
    english: 'district, city district, neighbourhood (town)',
    swedish: 'stadsdel',
    norwegian: 'bydel',
    finnish: 'kaupunginosa, taajama',
    hungarian: 'környék, szomszédság (városban)',
    german: 'Stadtbezirk, Stadtteil',
    dutch: 'omgeving (stad), stadsdeel, wijk',
    afrikaans: 'omgewing buurt stad (dorp)',
    russian: 'район города',
    latvian: 'apgabals, rajons, apkārtne (pilsētā)',
    polish: 'dzielnica (miasto)',
    french: 'quartier de ville',
    spanish: 'distrito, vecindario (urbano)',
  },
  {
    av: 23849,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(string and bow instrument + bass)',
    english: 'double bass, bass fiddle, contrabass',
    swedish: 'basfiol, kontrabas',
    norwegian: 'kontrabass',
    finnish: 'kontrabasso',
    hungarian: 'nagybőgő, gordon, kontrabasszus nagybőgő',
    german: 'Kontrabass',
    dutch: 'contrabas',
    afrikaans: 'kontrabas, viool',
    russian: 'контрабас',
    latvian: 'kontrabass',
    polish: 'kontrabas (instrument muzyczny)',
    french: 'contrebasse',
    spanish: 'contrabajo',
  },
  {
    av: 23850,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bassoon (1) + bass) SYMBOL SYNONYM',
    english: 'contrabassoon, double bassoon (1)',
    swedish: 'kontrafagott (1)',
    norwegian: 'kontrafagott (1)',
    finnish: 'kontrafagotti',
    hungarian: 'basszusfagott, kontrafagott',
    german: 'Bassfagott, Kontrafagott (1)',
    dutch: 'contrafagot (1)',
    afrikaans: 'kontrafagot (1)',
    russian: 'двойной фагот (1)',
    latvian: 'kontrafagots (1)',
    polish: 'fagot francuski (dłuższy) (1)',
    french: 'contrebasson (1)',
    spanish: 'bajo doble (1)',
  },
  {
    av: 23851,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(oboe (2) + bass) SYMBOL SYNONYM',
    english: 'contrabassoon, double bassoon (2)',
    swedish: 'kontrafagott (2)',
    norwegian: 'kontrafagott (2)',
    finnish: 'kontrafagotti',
    hungarian: 'basszusfagott, kontrafagott',
    german: 'Bassfagott, Kontrafagott (2)',
    dutch: 'contrafagot (2)',
    afrikaans: 'kontrafagot (2)',
    russian: 'контрафагот (2)',
    latvian: 'kontrafagots (2)',
    polish: 'fagot francuski (dłuższy) (2)',
    french: 'contrebasson (2)',
    spanish: 'bajo doble (2)',
  },
  {
    av: 23852,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(dryness + description after the fact indicator)',
    english: 'dried',
    swedish: 'torkad',
    norwegian: 'tørket',
    finnish: 'kuivattu',
    hungarian: 'aszalt, szárított',
    german: 'getrocknet',
    dutch: 'gedroogd',
    afrikaans: 'gedroog',
    russian: 'высушенный',
    latvian: 'žāvēts',
    polish: 'ususzone',
    french: 'sec',
    spanish: 'seco',
  },
  {
    av: 23853,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(card + activity + vehicle)',
    english: 'driving license',
    swedish: 'körkort',
    norwegian: 'kjørekort',
    finnish: 'ajokortti',
    hungarian: 'jogosítvány',
    german: 'Führerschein',
    dutch: 'rijbewijs, ',
    afrikaans: 'bestuurders lisensie',
    russian: 'водительские права',
    latvian: 'autovadītāja apliecība',
    polish: 'prawo jazdy',
    french: 'permis de conduire',
    spanish: 'permiso de conducir',
  },
  {
    av: 23855,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(percussion instrument + to repeat) SYMBOL SYNONYM',
    english: 'drum (2)',
    swedish: 'trumma (2)',
    norwegian: 'tromme (2)',
    finnish: 'rummut',
    hungarian: 'dob',
    german: 'Trommel (2)',
    dutch: 'trommel, drum (2)',
    afrikaans: 'trom (2)',
    russian: 'барабан (2)',
    latvian: 'bungas (2)',
    polish: 'bęben (2)',
    french: 'tambour (2)',
    spanish: 'tambor (2)',
  },
  {
    av: 23856,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + drum)',
    english: 'drumstick',
    swedish: 'trumpinne, trumstock',
    norwegian: 'trommestikke',
    finnish: 'rumpukapula',
    hungarian: 'dobütő, dobverő',
    german: 'Trommelstock, Schläger',
    dutch: 'drumstok',
    afrikaans: 'tromstok',
    russian: 'барабанная палочка',
    latvian: 'bungu vālīte',
    polish: 'pałeczka do bębna, pałka perkusyjna',
    french: 'baguette de tambour',
    spanish: 'palillo de tambor, baquetas',
  },
  {
    av: 23857,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(dryness + description indicator) Preferred NEW SYNONYM, replacing 13887',
    english: 'dry',
    swedish: 'torr',
    norwegian: 'tørr',
    finnish: 'kuiva',
    hungarian: 'száraz',
    german: 'trocken',
    dutch: 'droog',
    afrikaans: 'droog',
    russian: 'сухой',
    latvian: 'sauss',
    polish: 'suchy, sucha, suche',
    french: 'sec, sèche',
    spanish: 'seco',
  },
  {
    av: 23858,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(dryness + action indicator) Preferred NEW SYNONYM, replacing 13888',
    english: 'dry-(to)',
    swedish: 'torka',
    norwegian: 'tørke',
    finnish: 'kuivata',
    hungarian: 'száradni, szárítani',
    german: 'trocknen',
    dutch: 'drogen, droogmaken',
    afrikaans: 'droog (om te)',
    russian: 'сушить',
    latvian: 'nosusināt, izžāvēt',
    polish: 'suszyć',
    french: 'sécher',
    spanish: 'secar',
  },
  {
    av: 23860,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(feeling + intensity + description indicator)',
    english: 'eager, keen, willing',
    swedish: 'ivrig, pigg på',
    norwegian: 'ivrig, villig',
    finnish: 'innokas',
    hungarian: 'készséges, buzgó, lelkes, szolgálatkész, szíves',
    german: 'eifrig, begierig, bereit, willig',
    dutch: 'enthousiast, welwillend, gemotiveerd',
    afrikaans: 'entoesiasties, gemotiveerd, bereid',
    russian: 'нетерпеливый',
    latvian: 'kvēls, dedzīgs',
    polish: 'chętny, gorliwy, skwapliwy, gotowy',
    french: 'impatient, enthousiaste, fervent, passionné',
    spanish: 'ansiosos, deseosos, dispuestos',
  },
  {
    av: 23861,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(ease, easiness, simplicity + description indicator) Preferred NEW SYNONYM, replacing 13905',
    english: 'easy, easily',
    swedish: 'lätt, enkel',
    norwegian: 'lett, enkel',
    finnish: 'helppo',
    hungarian: 'könnyű, könnyen',
    german: 'leicht',
    dutch: 'gemakkelijk',
    afrikaans: 'maklik, met gemak',
    russian: 'легко',
    latvian: 'viegls, viegli',
    polish: 'łatwy, łatwe',
    french: 'facile',
    spanish: 'fácil',
  },
  {
    av: 23862,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + keyboard + electricity)',
    english: 'electric piano',
    swedish: 'elpiano',
    norwegian: 'piano elektrisk',
    finnish: 'sähköpiano',
    hungarian: 'elektromos zongora',
    german: 'E-Piano',
    dutch: 'piano (elektrisch)',
    afrikaans: 'elektriese klavier',
    russian: 'электрическое пианино',
    latvian: 'elektriskās klavieres',
    polish: 'pianino elektryczne (keyborad)',
    french: 'piano électrique',
    spanish: 'piano eléctrico',
  },
  {
    av: 23863,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(emptying, voidance, evacuation + description indicator) Preferred NEW SYNONYM, replacing 13932',
    english: 'empty',
    swedish: 'tom',
    norwegian: 'tom',
    finnish: 'tyhjä',
    hungarian: 'üres',
    german: 'leer',
    dutch: 'leeg',
    afrikaans: 'leeg',
    russian: 'пустой',
    latvian: 'tukšs',
    polish: 'puste, opróżnione',
    french: 'vide',
    spanish: 'vacío',
  },
  {
    av: 23864,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(emptying, voidance, evacuation + description indicator) Preferred NEW SYNONYM, replacing 13933',
    english: 'empty, evacuate, throw away, void-(to)',
    swedish: 'tömma, hälla ut',
    norwegian: 'tømme, helle ut',
    finnish: 'tyhjentää',
    hungarian: 'kiüríteni, kiüresíteni, kidobni, érvényteleníteni',
    german: 'leeren, ausleeren, entleeren, ausschütten',
    dutch: 'weggooien, ledigen, leegmaken',
    afrikaans: 'leegmaak, weggooi (om te)',
    russian: 'опустошать, опорожнять',
    latvian: 'iztukšot, aizvākt, izvākt, aizmest projām, atbrīvot',
    polish: 'opróżniać, wyrzucać',
    french: 'vider, jeter',
    spanish: 'vaciar, tirar',
  },
  {
    av: 23865,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(electricity + mind)',
    english: 'energy (mental)',
    swedish: 'energi (mental)',
    norwegian: 'energi (mental)',
    finnish: 'henkinen energia',
    hungarian: 'energia (szellemi)',
    german: 'Tatkraft, Arbeitsvermögen (mental)',
    dutch: 'energie (mentaal)',
    afrikaans: 'energie (verstandelike) (breinkrag)',
    russian: 'энергия (ментальная)',
    latvian: 'enerģija (garīgā)',
    polish: 'energia umysłowa (samopoczucie)',
    french: 'énergie mentale',
    spanish: 'energía (mental)',
  },
  {
    av: 23866,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(electricity + body)',
    english: 'energy (physical)',
    swedish: 'energi (fysisk)',
    norwegian: 'energi (fysisk)',
    finnish: 'fyysinen energia',
    hungarian: 'energia (testi, fizikai)',
    german: 'Energie, Kraft (fysisch)',
    dutch: 'energie (fysiek)',
    afrikaans: 'fisiese (energie)',
    russian: 'энергия (физическая)',
    latvian: 'enerģija (fiziskā)',
    polish: 'energia ciała (siła fizyczna)',
    french: 'énergie corporelle',
    spanish: 'energía (física)',
  },
  {
    av: 23867,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + negative)',
    english: 'error, mishap',
    swedish: 'missöde',
    norwegian: 'feil, uhell, ulykke',
    finnish: 'haaveri, virhe, erehdys, erhe',
    hungarian: 'tévedés, botlás, balszerencse',
    german: 'Fehler, Missgeschick',
    dutch: 'fout, vergissing',
    afrikaans: 'fout, ongeluk',
    russian: 'ошибка, неудача',
    latvian: 'kļūda, kļūdīšanās',
    polish: 'błąd, wypadek, przypadek (nieszczęśliwy)',
    french: 'mésaventure, incident',
    spanish: 'error, contratiempo',
  },
  {
    av: 23868,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(excitement + description indicator)',
    english: 'exciting, excitingly, excited, excitedly',
    swedish: 'upphetsad, upphetsande',
    norwegian: 'opphisset',
    finnish: 'jännittävä',
    hungarian: 'izgalmas, izgató, érdekfeszítő, nem unalmas',
    german: 'aufgeregt, gespannt',
    dutch: 'opgewonden',
    afrikaans: 'opgewonde, opgewondenheid',
    russian: 'возбуждённый, взволнованный',
    latvian: 'aizraujošs, aizraujoši, aizrautīgs, aizrautīgi, uzbudinošs, uztraucošs',
    polish: 'ekscytujący, podekscytowany',
    french: 'excitant, passionnant',
    spanish: 'emocionado',
  },
  {
    av: 23869,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + intensity + intensity)',
    english: 'excitement',
    swedish: 'upphetsning',
    norwegian: 'opphisselse',
    finnish: 'jännitys, kiihtymys',
    hungarian: 'izgalom, izgatottság, felfokozottság',
    german: 'Aufregung, Erregung',
    dutch: 'opwinding',
    afrikaans: 'opwinding',
    russian: 'возбуждение, волнение',
    latvian: 'aizrautība, uzbudinājums, uztraukums',
    polish: 'podniecenie, zdenerwowanie, podekscytowanie',
    french: 'excitation, enthousiasme',
    spanish: 'emoción',
  },
  {
    av: 23873,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wind instrument + alto)',
    english: 'flute (alto)',
    swedish: 'flöjt (alt)',
    norwegian: 'fløyte alt',
    finnish: 'alttohuilu',
    hungarian: 'furulya – alt',
    german: 'Flöte (Alt)',
    dutch: 'blokfluit (alt), alt(blok)fluit',
    afrikaans: 'fluit (alto)',
    russian: 'флейта (альт)',
    latvian: 'flauta, alta',
    polish: 'flet, flet altowy',
    french: 'flûte (alto)',
    spanish: 'flauta (alto)',
  },
  {
    av: 23874,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wind instrument + soprano)',
    english: 'flute (soprano)',
    swedish: 'flöjt (sopran)',
    norwegian: 'fløyte sopran',
    finnish: 'sopraanohuilu',
    hungarian: 'furulya – szoprán',
    german: 'Flöte (Sopran)',
    dutch: 'blokfluit (sopraan)',
    afrikaans: 'fluit (soprano)',
    russian: 'флейта (сопрано)',
    latvian: 'flauta, soprāna',
    polish: 'flet sopranowy',
    french: 'flûte (soprano)',
    spanish: 'flauta (soprano)',
  },
  {
    av: 23875,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + many + bubble)',
    english: 'foam, mousse',
    swedish: 'skum, mousse',
    norwegian: 'skum, mousse',
    finnish: 'vaahto',
    hungarian: 'hab, tajték',
    german: 'Schaum, Mousse',
    dutch: 'schuim, mousse',
    afrikaans: 'skuim, borrels',
    russian: 'пена, мусс',
    latvian: 'putas',
    polish: 'piana, mus',
    french: 'mousse, écume',
    spanish: 'espuma, mousse',
  },
  {
    av: 23876,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(horn + to circle: instrument with circularly coiled tubing) SYMBOL SYNONYM',
    english: 'French horn, horn (1)',
    swedish: 'valthorn (1)',
    norwegian: 'valthorn (1)',
    finnish: 'käyrätorvi',
    hungarian: 'kürt, natúrkürt',
    german: 'Waldhorn, Horn (1)',
    dutch: 'hoorn (muziekinstrument) (1)',
    afrikaans: 'Franse horing, horing (1)',
    russian: 'валторна (1)',
    latvian: 'mežrags (1)',
    polish: 'waltornia (1)',
    french: "cor d'harmonie (1)",
    spanish: 'cuerno (1)',
  },
  {
    av: 23877,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(brass instrument + to circle: instrument with circularly coiled tubing) SYMBOL SYNONYM',
    english: 'French horn, horn (2)',
    swedish: 'valthorn (2)',
    norwegian: 'valthorn (2)',
    finnish: 'käyrätorvi',
    hungarian: 'kürt, natúrkürt',
    german: 'Waldhorn, Horn (2)',
    dutch: 'hoorn (muziekinstrument) (2)',
    afrikaans: 'Franse horing, horing (2)',
    russian: 'валторна (2)',
    latvian: 'mežrags (2)',
    polish: 'waltornia (2)',
    french: "cor d'harmonie (2)",
    spanish: 'cuerno (2)',
  },
  {
    av: 23878,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(percussion instrument + 1 + musical note)',
    english: 'gong',
    swedish: 'gong-gong',
    norwegian: 'gonggong',
    finnish: 'gongi',
    hungarian: 'gong',
    german: 'Gong',
    dutch: 'gong',
    afrikaans: 'gong',
    russian: 'гонг',
    latvian: 'gongs',
    polish: 'gong, sygnał dźwiękowy (dzwonek do drzwi, sygnał w kierownicy itp.)',
    french: 'gong',
    spanish: 'gong',
  },
  {
    av: 23879,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + string)',
    english: 'guitar, string instrument',
    swedish: 'gitarr, stränginstrument',
    norwegian: 'gitar',
    finnish: 'kitara',
    hungarian: 'gitár, húros hangszer',
    german: 'Gitarre',
    dutch: 'gitaar, snaarinstrument',
    afrikaans: 'kitaar, snaar instrument',
    russian: 'гитара, струнный инструмент',
    latvian: 'ģitāra, stīgu instruments',
    polish: 'gitara, instrument strunowy',
    french: 'instrument à corde, guitare',
    spanish: 'guitarra, instrumento de cuerda',
  },
  {
    av: 23880,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spray + hair)',
    english: 'hair spray',
    swedish: 'hårspray',
    norwegian: 'hårspray',
    finnish: 'hiuslakka',
    hungarian: 'hajlakk',
    german: 'Haarspray',
    dutch: 'haarlak',
    afrikaans: 'haar sprei',
    russian: 'спрей для волос',
    latvian: 'matu laka',
    polish: 'lakier do włosów',
    french: 'laque',
    spanish: 'laca de pelo, spray para el pelo',
  },
  {
    av: 23881,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + many + string + finger)',
    english: 'harp',
    swedish: 'harpa',
    norwegian: 'harpe',
    finnish: 'harppu',
    hungarian: 'hárfa',
    german: 'Harfe',
    dutch: 'harp',
    afrikaans: 'harp',
    russian: 'арфа',
    latvian: 'arfa',
    polish: 'harfa',
    french: 'harpe',
    spanish: 'arpa',
  },
  {
    av: 23882,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + hook + string)',
    english: 'harpsichord',
    swedish: 'cembalo',
    norwegian: 'cembalo',
    finnish: 'cembalo',
    hungarian: 'csembaló',
    german: 'Cembalo',
    dutch: 'klavecimbel',
    afrikaans: 'klavesimbel',
    russian: 'клавесин',
    latvian: 'klavihords',
    polish: 'klawesyn',
    french: 'clavecin',
    spanish: 'clavicémbalo',
  },
  {
    av: 23883,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(hate, hatred + action indicator) Preferred NEW SYNONYM, replacing 14683',
    english: 'hate-(to)',
    swedish: 'hata',
    norwegian: 'hate',
    finnish: 'vihata',
    hungarian: 'utálni, gyűlölni',
    german: 'etwas ungern tun, hassen',
    dutch: 'haten',
    afrikaans: 'haat (om te)',
    russian: 'ненавидеть',
    latvian: 'ienīst',
    polish: 'nienawidzić',
    french: 'haïr, détester',
    spanish: 'odiar',
  },
  {
    av: 23884,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to sing + without + word + action indicator)',
    english: 'hum-(to)',
    swedish: 'nynna',
    norwegian: 'nynne',
    finnish: 'hymistä, hyräillä',
    hungarian: 'zümmögni',
    german: '(eine Melodie) summen',
    dutch: 'neuriën',
    afrikaans: 'neurie (om te)',
    russian: 'напевать с закрытым ртом',
    latvian: 'dungot',
    polish: 'buczenie, brzęczenie, szum, warkot',
    french: 'fredonner',
    spanish: 'zumbar',
  },
  {
    av: 23885,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(humidity + description indicator)',
    english: 'humid, damp, moist',
    swedish: 'fuktig',
    norwegian: 'fuktig',
    finnish: 'kostea',
    hungarian: 'nedves, nyirkos',
    german: 'feucht',
    dutch: 'vochtig, klam',
    afrikaans: 'vogtig, klam',
    russian: 'влажный, сырой',
    latvian: 'mitrs, valgs, mimitrums',
    polish: 'wilgotny',
    french: 'humide, moite',
    spanish: 'húmedo',
  },
  {
    av: 23887,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(much + storm: i.e., much + much + much + wind)',
    english: 'hurricane',
    swedish: 'orkan',
    norwegian: 'orkan',
    finnish: 'pyörremyrsky, hurrikaani',
    hungarian: 'hurrikán',
    german: 'Wirbelsturm, Orkan, Hurrikan',
    dutch: 'orkaan',
    afrikaans: 'orkaan',
    russian: 'ураган',
    latvian: 'viesuļvētra',
    polish: 'huragan, tajfun',
    french: 'ouragan',
    spanish: 'huracán',
  },
  {
    av: 23888,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(musical instrument + sound + mouth: device which modifies the sound of a persons voice)',
    english: 'kazoo',
    swedish: 'kazoo',
    norwegian: 'kazoo',
    finnish: 'kazoo',
    hungarian: 'kazoo (szivaralakú kis hangszer)',
    german: 'Kazoo',
    dutch: 'kazoo',
    afrikaans: 'kazoo',
    russian: 'казу',
    latvian: 'rotaļinstruments ar membrānu',
    polish: 'mirliton – instrument muz.',
    french: 'mirliton',
    spanish: 'mirlitón',
  },
  {
    av: 23889,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + hot + long) SYMBOL SYNONYM',
    english: 'kebab (Middle East)',
    swedish: 'kebab (Mellanöstern)',
    norwegian: 'kebab (Midt Østen)',
    finnish: 'kebab (lähi-itä)',
    hungarian: 'kebab (Közép-Kelet)',
    german: 'Döner, Kebab (Mittelosten)',
    dutch: 'kebab (Midden-Oosten)',
    afrikaans: 'kebab, sosatie (Middel Ooste)',
    russian: 'кебаб (восточный)',
    latvian: 'kebabs (vidusaustrumnieku)',
    polish: 'kebab (znak bliskowschodni)',
    french: 'kebab (Moyen-Orient)',
    spanish: 'kebab (Oriente medio)',
  },
  {
    av: 23890,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + rotation + to cut) SYMBOL SYNONYM',
    english: 'kebab (Scandinavia)',
    swedish: 'kebab',
    norwegian: 'kebab (Skandinavia)',
    finnish: 'kebab (skandinavia)',
    hungarian: 'kebab (skandinávia)',
    german: 'Döner, Kebab (Skandinavien)',
    dutch: 'kebab (Scandinavia)',
    afrikaans: 'kebab, sosatie (Skandinawië)',
    russian: 'кебаб (скандинавский)',
    latvian: 'kebabs (skandināvu)',
    polish: 'kebab (znak skandynawski)',
    french: 'kebab (Scandinavie)',
    spanish: 'kebab (Escandinavia)',
  },
  {
    av: 23891,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + part of + linear thing) SYMBOL SYNONYM',
    english: 'kebab (UK, NL)',
    swedish: 'kebab (Storbritannien, Holland)',
    norwegian: 'kebab (Storbritannia, Nederland)',
    finnish: 'kebab (iso-britannia, hollanti)',
    hungarian: 'kebab (EK, Hollandia)',
    german: 'Döner, Kebab (Groβbritannien, Holland))',
    dutch: 'kebab (UK, Nl, Vl)',
    afrikaans: 'kebab, sosatie (UK, NL)',
    russian: 'кебаб (голландский)',
    latvian: 'kebabs (Apvien.Karalistē, Nīderlandē)',
    polish: 'kebab (znak angielski)',
    french: 'kebab (UK, NL)',
    spanish: 'kebab (UK, NL)',
  },
  {
    av: 23893,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(person + end + description indicator) Person can be replaced by an appropriate other classifier.',
    english: 'last (person, etc)',
    swedish: 'sist',
    norwegian: 'sist',
    finnish: 'viimeinen',
    hungarian: 'utolsó',
    german: 'letzter, zuletzt (Person etc)',
    dutch: 'laatste (persoon)',
    afrikaans: 'laaste (persoon)',
    russian: 'последний',
    latvian: 'beidzot',
    polish: 'ostatni (człowiek)',
    french: 'dernier',
    spanish: 'última (persona, etc.)',
  },
  {
    av: 23894,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(purpose + without + truth) Preferred NEW SYNONYM, replacing 15203',
    english: 'lie',
    swedish: 'lögn',
    norwegian: 'løgn',
    finnish: 'valhe, vale',
    hungarian: 'hazugság',
    german: 'Lüge',
    dutch: 'leugen',
    afrikaans: 'lieg, jok',
    russian: 'ложь',
    latvian: 'meli',
    polish: 'kłamstwo',
    french: 'mensonge',
    spanish: 'mentira',
  },
  {
    av: 23895,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(lie + action indicator) Preferred NEW SYNONYM, replacing 15204',
    english: 'lie-(to)',
    swedish: 'ljuga',
    norwegian: 'lyve',
    finnish: 'valehdella',
    hungarian: 'hazudni',
    german: 'lügen',
    dutch: 'liegen',
    afrikaans: 'lieg, jok (om te)',
    russian: 'лгать',
    latvian: 'melot',
    polish: 'kłamać',
    french: 'mentir',
    spanish: 'mentir',
  },
  {
    av: 23896,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(line + many + person) Person can be replaced by an appropriate other specifier.',
    english: 'line, queue',
    swedish: 'kö',
    norwegian: 'kø',
    finnish: 'jono',
    hungarian: 'sor',
    german: 'anstehen (in Schlange)',
    dutch: 'rij',
    afrikaans: 'lyn, ry, tou (mense)',
    russian: 'очередь',
    latvian: 'rinda',
    polish: 'kolejka (ludzie stojący w kolejce)',
    french: 'file de personnes, queue',
    spanish: 'línea, cola',
  },
  {
    av: 23897,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(competition + loss + action indicator) Preferred NEW SYNONYM, replacing 15395',
    english: 'lose (fail to win)-(to)',
    swedish: 'förlora',
    norwegian: 'tape',
    finnish: 'hävitä',
    hungarian: 'veszíteni, nem nyerni',
    german: 'verlieren',
    dutch: 'verliezen (wedstrijd, spel)',
    afrikaans: 'verloor (wedstryd, spel) (om te)',
    russian: 'проигрывать',
    latvian: 'zaudēt',
    polish: 'przegrać',
    french: 'perdre, échouer',
    spanish: 'perder (no ganar)',
  },
  {
    av: 23898,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + sound + intensity + out)',
    english: 'loudspeaker',
    swedish: 'högtalare',
    norwegian: 'høyttaler',
    finnish: 'kaiutin',
    hungarian: 'hangfal, hangosbeszélő',
    german: 'Lautsprecher, Lautsprecherbox',
    dutch: 'luidspreker',
    afrikaans: 'luidspreker',
    russian: 'громкоговоритель',
    latvian: 'skaļrunis, skanda',
    polish: 'głośniki',
    french: 'haut-parleur',
    spanish: 'altavoz',
  },
  {
    av: 23899,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(string instrument + man + blissymbolics: an instrument associated with Charles Bliss)',
    english: 'mandolin',
    swedish: 'mandolin',
    norwegian: 'mandolin',
    finnish: 'mandoliini',
    hungarian: 'mandolin',
    german: 'Mandoline',
    dutch: 'mandoline',
    afrikaans: 'mandolien',
    russian: 'мандолина',
    latvian: 'mandolīna',
    polish: 'mandolina',
    french: 'mandoline',
    spanish: 'mandolina',
  },
  {
    av: 23900,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rythm instrument + fruit)',
    english: 'maracas, calabash (etc)',
    swedish: 'maracas (etc)',
    norwegian: 'marakas',
    finnish: 'marakassi',
    hungarian: 'kalabas, rázótök, rumbatojás stb.',
    german: 'Maraca (Musik)',
    dutch: 'marecas',
    afrikaans: 'maracas',
    russian: 'маракасы',
    latvian: 'kalabase, pudeļveida ķirbis',
    polish: 'grzechotka, tykwa (instrument muzyczny)',
    french: 'maracas, hochet',
    spanish: 'maracas, calabaza (etc.)',
  },
  {
    av: 23901,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wind instrument + mouth + keyboard)',
    english: 'melodica, blow-organ',
    swedish: 'melodika',
    norwegian: 'melodika',
    finnish: 'melodika',
    hungarian: 'orgona (levegőbefújásos)',
    german: 'Melodica',
    dutch: 'melodika',
    afrikaans: 'melodika',
    russian: 'мелодическая гармоника',
    latvian: 'stabuļu pūšaminstruments',
    polish: 'organy (muz)',
    french: 'harmonica',
    spanish: 'melódica',
  },
  {
    av: 23902,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + sound + into)',
    english: 'microphone',
    swedish: 'mikrofon',
    norwegian: 'mikrofon',
    finnish: 'mikrofoni',
    hungarian: 'mikrofon',
    german: 'Mikrofon',
    dutch: 'microfoon',
    afrikaans: 'mikrofoon',
    russian: 'микрофон',
    latvian: 'mikrofons',
    polish: 'mikrofon',
    french: 'microphone',
    spanish: 'micrófono',
  },
  {
    av: 23903,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to listen + carry)',
    english: 'MP3 player, iPod (etc)',
    swedish: 'MP3-spelare, iPod (etc)',
    norwegian: 'MP3-spiller, iPod (o.l.)',
    finnish: 'MP3-soitin, iPod',
    hungarian: 'MP3 lejátszó, iPod, lejátszók',
    german: 'MP3-Player, iPod (etc.)',
    dutch: 'Ipod, MP3-speler',
    afrikaans: 'MP3 speler, iPod (ens.)',
    russian: 'MP3-плеер, айпад',
    latvian: 'MP3 mūzikas atskaņotājs, iPod u.c.',
    polish: 'odtwarzacz muzyki, mp3, iPod (itp.)',
    french: 'lecteur de cd portable, baladeur, lecteur de musique portable',
    spanish: 'reproductor MP3, iPod (etc.)',
  },
  {
    av: 23905,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + many + string)',
    english: 'musical instrument (with many strings)',
    swedish: 'stränginstrument',
    norwegian: 'strenginstrument',
    finnish: 'kielisoitin',
    hungarian: 'húros hangszer',
    german: 'Musikinstrument, Streichinstrument',
    dutch: 'muziekinstrument (met snaren)',
    afrikaans: 'musiek instrument (met baie stringe)',
    russian: 'струнный инструмент',
    latvian: 'mūzikas instruments (stīgu)',
    polish: 'wielostrunowy instrument muzyczny',
    french: 'instrument de musique à plusieurs cordes',
    spanish: 'instrumento musical (con muchas cuerdas)',
  },
  {
    av: 23906,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(without + time + description indicator) Preferred NEW SYNONYM, replacing 15709',
    english: 'never',
    swedish: 'aldrig',
    norwegian: 'aldri',
    finnish: 'ei koskaan, ei ikinä',
    hungarian: 'soha',
    german: 'nie, niemals',
    dutch: 'nooit',
    afrikaans: 'nooit',
    russian: 'никогда',
    latvian: 'nekad',
    polish: 'nigdy',
    french: 'jamais',
    spanish: 'nunca',
  },
  {
    av: 23907,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(without + thing) Preferred NEW SYNONYM, replacing 15725',
    english: 'nothing, none',
    swedish: 'ingen, ingenting',
    norwegian: 'ingenting, ingen',
    finnish: 'ei mitään, ei kukaan',
    hungarian: 'semmi, egyáltalán nem',
    german: 'nichts, niemand',
    dutch: 'niets, niks',
    afrikaans: 'niks, geen',
    russian: 'ничего',
    latvian: 'nekas, neviens',
    polish: 'nic',
    french: 'rien (pas de chose)',
    spanish: 'nada',
  },
  {
    av: 23908,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flute, recorder + 2 + reed) SYMBOL SYNONYM',
    english: 'oboe (1)',
    swedish: 'oboe (1)',
    norwegian: 'obo (1)',
    finnish: 'oboe',
    hungarian: 'oboa',
    german: 'Oboe (1)',
    dutch: 'hobo (1)',
    afrikaans: 'hobo, oboe (1)',
    russian: 'гобой (1)',
    latvian: 'oboja (1)',
    polish: 'obój (muz) (1)',
    french: 'hautbois (1)',
    spanish: 'oboe (1)',
  },
  {
    av: 23909,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + 2 + reed) SYMBOL SYNONYM',
    english: 'oboe (2)',
    swedish: 'oboe (2)',
    norwegian: 'obo (2)',
    finnish: 'oboe',
    hungarian: 'oboa',
    german: 'Oboe (2)',
    dutch: 'hobo (2)',
    afrikaans: 'hobo, oboe (2)',
    russian: 'гобой (2)',
    latvian: 'oboja (2)',
    polish: 'obój (muz) (2)',
    french: 'hautbois (2)',
    spanish: 'oboe (2)',
  },
  {
    av: 23910,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(many + year + description indicator) See also 15915',
    english: 'old',
    swedish: 'gammal',
    norwegian: 'gammel',
    finnish: 'vanha',
    hungarian: 'öreg, idős',
    german: 'alt, gebraucht',
    dutch: 'oud',
    afrikaans: 'oud',
    russian: 'старый',
    latvian: 'vecs',
    polish: 'stary (czas)',
    french: 'âgé, ancien',
    spanish: 'viejo',
  },
  {
    av: 23911,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wind instrument + many + tube)',
    english: 'organ, pipe organ',
    swedish: 'orgel, piporgel',
    norwegian: 'orgel',
    finnish: 'urut, kirkkourut',
    hungarian: 'oroganasíp',
    german: 'Orgel',
    dutch: 'orgel',
    afrikaans: 'orrel, pyp orrel',
    russian: 'орган',
    latvian: 'ērģeles, stabuļu mūzikas instruments',
    polish: 'organy piszczałkowe',
    french: 'flûte de Pan (à vent)',
    spanish: 'órgano, órgano de tubos',
  },
  {
    av: 23912,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wood instrument + many + tube)',
    english: 'panpipe',
    swedish: 'panflöjt',
    norwegian: 'panfløyte',
    finnish: 'panhuilu',
    hungarian: 'pánsíp',
    german: 'Panflöte',
    dutch: 'panfluit',
    afrikaans: 'panfluit',
    russian: 'панфлейта',
    latvian: 'pānflauta (vienkāršs stabuļu mūzikas instruments)',
    polish: 'fujarka',
    french: 'flûte de Pan',
    spanish: 'zampoña',
  },
  {
    av: 23913,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(parking lot + action indicator)',
    english: 'park-(to)',
    swedish: 'parkera',
    norwegian: 'parkere',
    finnish: 'parkkeerata auto, ajaa auto parkkiin',
    hungarian: 'parkolni, parkírozni, leparkolni',
    german: 'parken',
    dutch: 'parkeren',
    afrikaans: 'parkeer (om te)',
    russian: 'парковать, припарковать',
    latvian: 'autostāvvieta, novietot automašīnu',
    polish: 'parkować',
    french: 'garer',
    spanish: 'aparcar, estacionar',
  },
  {
    av: 23914,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(card + parking lot)',
    english: 'parking permit',
    swedish: 'parkeringstillstånd',
    norwegian: 'parkeringstillatelse',
    finnish: 'pysäköintilippu',
    hungarian: 'parkolási engedély',
    german: 'Parkausweis, Parkerlaubnis',
    dutch: 'parkeertoelating (Vl), bewonerskaart',
    afrikaans: 'parkeertoelatings kaart',
    russian: 'разрешение на стоянку',
    latvian: 'autostāvvietas atļauja',
    polish: 'zezwolenie na parkowanie',
    french: 'carte de stationnement, permis de stationnement, vignette de stationnement',
    spanish: 'permiso de estacionamiento',
  },
  {
    av: 23915,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + parking place)',
    english: 'parking ticket',
    swedish: 'parkeringsbiljett',
    norwegian: 'parkeringsbillett',
    finnish: 'pysäköintisakko, parkkisakko',
    hungarian: 'parkolási bírságcédula',
    german: 'Parkschein, Parkticket',
    dutch: 'parkeerticket',
    afrikaans: 'parkeer (boete)',
    russian: 'парковочный билет',
    latvian: 'autostāvvietas biļete',
    polish: 'bilet parkingowy',
    french: 'ticket de stationnement',
    spanish: 'multa por estacionamiento indebido',
  },
  {
    av: 23916,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + participation)',
    english: 'participant',
    swedish: 'deltagare',
    norwegian: 'deltaker',
    finnish: 'osallistuja, mukanaolija, osanottaja',
    hungarian: 'résztvevő',
    german: 'Teilnehmer, Teilnehmerin',
    dutch: 'deelnemer',
    afrikaans: 'deelnemer',
    russian: 'участник',
    latvian: 'dalībnieks',
    polish: 'uczestnik',
    french: 'participant',
    spanish: 'participante',
  },
  {
    av: 23917,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(participation + activity indicator)',
    english: 'participate-(to)',
    swedish: 'delta',
    norwegian: 'delta',
    finnish: 'osallistua, ottaa osaa',
    hungarian: 'résztvenni',
    german: 'beteiligen, teilnehmen',
    dutch: 'deelnemen',
    afrikaans: 'deelneem (om te)',
    russian: 'участвовать',
    latvian: 'piedalīties, ņemt dalību',
    polish: 'uczestniczyć',
    french: 'participer',
    spanish: 'participar',
  },
  {
    av: 23918,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + together)',
    english: 'participation',
    swedish: 'deltagande, medverkan',
    norwegian: 'deltakelse, medvirkning',
    finnish: 'osanotto, osallisuus, mukanaolo, osallistuminen',
    hungarian: 'részvétel',
    german: 'Teilnahme',
    dutch: 'deelname, participatie',
    afrikaans: 'deelname',
    russian: 'участие',
    latvian: 'dalība, līdzdalība, piedalīšanās',
    polish: 'udział',
    french: 'participation',
    spanish: 'participación',
  },
  {
    av: 23919,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + participation)',
    english: 'participation, involvement',
    swedish: 'delaktighet, gemenskap',
    norwegian: 'delaktighet',
    finnish: 'osallistuminen, mukanaolo, osallisuus',
    hungarian: 'bevonódás, részvétel',
    german: 'Teilnahme, Beteiligung, Engagemment, Einbeziehung',
    dutch: 'betrokkenheid',
    afrikaans: 'betrokkenheid, deelname',
    russian: 'участие, вовлечение',
    latvian: 'piedalīšanās, iesaistīšanās',
    polish: 'zaangażowanie, aktywny udział',
    french: 'investissement, engagement',
    spanish: 'participación',
  },
  {
    av: 23920,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + downwards + soprano: explanation?)',
    english: 'pennywhistle, tin whistle',
    swedish: 'bleckflöjt, irländsk flöjt',
    norwegian: 'fløyte (irlandsk)',
    finnish: 'peltihuilu',
    hungarian: 'síp',
    german: 'Blechflöte',
    dutch: 'pennywhistle (Iers), Ierse fluit',
    afrikaans: 'penniefluit',
    russian: 'свистулька',
    latvian: 'svilpīte, svilpe',
    polish: 'piszczałka z ustnikiem (muz)',
    french: 'pipeau, flûtiau',
    spanish: 'flauta tin whistle',
  },
  {
    av: 23921,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + mallet)',
    english: 'percussion instrument',
    swedish: 'slaginstrument, slagverk',
    norwegian: 'slaginstrument',
    finnish: 'lyömäsoitin',
    hungarian: 'ütőhangszer',
    german: 'Schlaginstrument, Perkussion',
    dutch: 'slaginstrument',
    afrikaans: 'slag instrument',
    russian: 'ударный инструмент, перкуссия',
    latvian: 'perkusijas',
    polish: 'instrument perkusyjny',
    french: 'instrument à percussion',
    spanish: 'instrumento de percusión',
  },
  {
    av: 23922,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + keyboard) SYMBOL SYNONYM',
    english: 'piano (1)',
    swedish: 'piano (1)',
    norwegian: 'piano (1)',
    finnish: 'piano',
    hungarian: 'zongora',
    german: 'Klavier (1)',
    dutch: 'piano (1)',
    afrikaans: 'klavier (1)',
    russian: 'пианино, фортепиано (1)',
    latvian: 'klavieres, (pianīns) (1)',
    polish: 'pianino, fortepian (1)',
    french: 'piano (1)',
    spanish: 'piano (1)',
  },
  {
    av: 23923,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(percussion instrument + string) SYMBOL SYNONYM',
    english: 'piano (2)',
    swedish: 'piano (2)',
    norwegian: 'piano (2)',
    finnish: 'piano',
    hungarian: 'zongora',
    german: 'Klavier (2)',
    dutch: 'piano (2)',
    afrikaans: 'klavier (2)',
    russian: 'пианино, фортепиано (2)',
    latvian: 'klavieres, (pianīns) (2)',
    polish: 'pianino, fortepian (2)',
    french: 'piano (2)',
    spanish: 'piano (2)',
  },
  {
    av: 23924,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flute, transverse flute + little) SYMBOL SYNONYM',
    english: 'piccolo (1)',
    swedish: 'piccolaflöjt (1)',
    norwegian: 'fløyte piccolo (1)',
    finnish: 'pikkolohuilu',
    hungarian: 'pikoló, pikolófuvola, kisfuvola',
    german: 'Piccoloflöte (1)',
    dutch: 'piccolo (1)',
    afrikaans: 'piccolo (1)',
    russian: 'малая флейта, пикколо (1)',
    latvian: 'pikolo flauta (1)',
    polish: 'flet piccolo (1)',
    french: 'flûte piccolo (1)',
    spanish: 'piccolo (1)',
  },
  {
    av: 23925,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wind intrument + soprano + little) SYMBOL SYNONYM',
    english: 'piccolo (2)',
    swedish: 'piccolaflöjt (2)',
    norwegian: 'fløyte piccolo (2)',
    finnish: 'pikkolohuilu',
    hungarian: 'pikoló, pikolófuvola, kisfuvola',
    german: 'Piccoloflöte (2)',
    dutch: 'piccolo (2)',
    afrikaans: 'piccolo (2)',
    russian: 'малая флейта, пикколо (2)',
    latvian: 'pikolo flauta (2)',
    polish: 'flet piccolo (2)',
    french: 'flûte piccolo (2)',
    spanish: 'piccolo (2)',
  },
  {
    av: 23928,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(stave, staff + musical note)',
    english: 'key, tonality',
    swedish: 'tonläge, tonhöjd (musik)',
    norwegian: 'toneleie',
    finnish: 'sävelkorkeus (musiikki)',
    hungarian: 'hangnem, tonalitás',
    german: 'Tonhöhe, Tonalität, Farbton, Tönung',
    dutch: 'muzieksleutel',
    afrikaans: 'musieksleutel, tonaliteit',
    russian: 'ключ, тональность',
    latvian: 'toņkārta, atslēga, tonalitāte',
    polish: 'nastroić, stroić, ustawiać ton (muz)',
    french: 'tonalité (de la partition)',
    spanish: 'tecla, llave (sonido)',
  },
  {
    av: 23930,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(musical instrument + action indicator)',
    english: 'play (instrument)-(to)',
    swedish: 'spela (instrument)',
    norwegian: 'spille (instrument)',
    finnish: 'soittaa soittimella',
    hungarian: 'játszani (zeneszerszámon)',
    german: 'spielen (Instrument)',
    dutch: 'muziekinstrument bespelen, spelen muziekinstrument',
    afrikaans: 'speel (musiek instrument) (om te)',
    russian: 'играть на музыкальном инструменте',
    latvian: 'spēlēt instrumentu',
    polish: 'grać (na instrumencie muzycznym)',
    french: "jouer d'un instrument",
    spanish: 'tocar (instrumento)',
  },
  {
    av: 23931,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(music + many + many + person)',
    english: 'pop music',
    swedish: 'popmusik',
    norwegian: 'popmusikk',
    finnish: 'popmusiikki',
    hungarian: 'popzene',
    german: 'Popmusik',
    dutch: 'popmuziek',
    afrikaans: 'pop musiek',
    russian: 'поп-музыка',
    latvian: 'popmūzika',
    polish: 'muzyka pop',
    french: 'musique pop',
    spanish: 'música pop',
  },
  {
    av: 23932,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(music + hair + up)',
    english: 'punk rock',
    swedish: 'punkmusik',
    norwegian: 'punk (musikk)',
    finnish: 'punk (musiikki)',
    hungarian: 'punkzene',
    german: 'Punkrock',
    dutch: 'punk (muziek)',
    afrikaans: 'punk rock',
    russian: 'панк-рок',
    latvian: 'pankroks',
    polish: 'punk, punk rock, muzyka punkowa',
    french: 'musique de rock punk',
    spanish: 'punk rock',
  },
  {
    av: 23933,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bow, arc + many + colour)',
    english: 'rainbow',
    swedish: 'regnbåge',
    norwegian: 'regnbue',
    finnish: 'sateenkaari',
    hungarian: 'szivárvány',
    german: 'Regenbogen',
    dutch: 'regenboog',
    afrikaans: 'reënboog',
    russian: 'радуга',
    latvian: 'varavīksne',
    polish: 'tęcza',
    french: 'arc-en-ciel',
    spanish: 'arco iris',
  },
  {
    av: 23934,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(song + same + speak-(to))',
    english: 'rap (music)',
    swedish: 'rap, rapmusik',
    norwegian: 'rap (musikk)',
    finnish: 'rap (musiikki)',
    hungarian: 'rapzene',
    german: 'Rap, Hip-Hop (Musik)',
    dutch: 'rap (muziek)',
    afrikaans: 'rap (musiek)',
    russian: 'рэп',
    latvian: 'reps',
    polish: 'rap (muzyka)',
    french: 'musique rap',
    spanish: 'rap',
  },
  {
    av: 23935,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + rotation + noise (loud))',
    english: 'rattle',
    swedish: 'skallra',
    norwegian: 'rangle',
    finnish: 'kolina, räminä, kalina',
    hungarian: 'csörgés, csörgetés, kereplés',
    german: 'Babyrassel, Rassel',
    dutch: 'ratel, rammelaar',
    afrikaans: 'ratel',
    russian: 'погремушка',
    latvian: 'grabulis',
    polish: 'grzechotka (zabawka)',
    french: 'hochet, grelot, crécelle',
    spanish: 'matraca (instrumento musical)',
  },
  {
    av: 23936,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + rotation + noise (loud))',
    english: 'rattle (musical instrument)',
    swedish: 'skrammelinstrument',
    norwegian: 'skramleinstrument',
    finnish: 'helistin',
    hungarian: 'kereplő',
    german: 'Klang, Knarre, Rassel',
    dutch: 'ratel (muziek)',
    afrikaans: 'ratel (musiek instrument)',
    russian: 'погремушка (музыкальный инструмент)',
    latvian: 'grabulis (mūzikas instruments)',
    polish: 'grzechotka (instrument muzyczny)',
    french: 'crécelle',
    spanish: 'matraca (instrumento musical)',
  },
  {
    av: 23937,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flute, recorder + tree: where tree is a contraction of wood)',
    english: 'recorder',
    swedish: 'blockflöjt',
    norwegian: 'blokkfløyte',
    finnish: 'nokkahuilu',
    hungarian: 'fafurulya',
    german: 'Blockflöte',
    dutch: 'blokfluit',
    afrikaans: 'blokfluit',
    russian: 'блок-флейта',
    latvian: 'magnetafons, skaņas ierakstīšanas aparatūra',
    polish: 'rożek angielski (flet) (obój, fagot, kontrafagot)',
    french: 'flûte à bec',
    spanish: 'flauta dulce',
  },
  {
    av: 23938,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(recorder + alto)',
    english: 'recorder (alto)',
    swedish: 'blockflöjt (alt)',
    norwegian: 'blokkfløyte (alt)',
    finnish: 'alttonokkahuilu',
    hungarian: 'furulya – alt',
    german: 'Blockflöte (Alt)',
    dutch: 'blokfluit-(alt)',
    afrikaans: 'blokfluit (alto)',
    russian: 'блок-флейта (альт)',
    latvian: 'blokflauta, alta',
    polish: 'rożek angielski (flet) (altowy) (obój, fagot, kontrafagot)',
    french: 'flûte alto (bois)',
    spanish: 'flautín (alto)',
  },
  {
    av: 23939,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(recorder + bass)',
    english: 'recorder (bass)',
    swedish: 'blockflöjt (bas)',
    norwegian: 'blokkfløyte (bass)',
    finnish: 'bassonokkahuilu',
    hungarian: 'furulya – basszus',
    german: 'Blockflöte (Bass)',
    dutch: 'blokfluit (bass)',
    afrikaans: 'blokfluit (bas)',
    russian: 'блок-флейта (бас)',
    latvian: 'blokflauta, basa',
    polish: 'rożek angielski (flet) (basowy)(obój, fagot, kontrafagot)',
    french: 'flûte basse (bois)',
    spanish: 'flautín (bajo)',
  },
  {
    av: 23940,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(recorder + soprano)',
    english: 'recorder (soprano)',
    swedish: 'blockflöjt (sopran)',
    norwegian: 'blokkfløyte (sopran)',
    finnish: 'sopraanonokkahuilu',
    hungarian: 'furulya – szoprán',
    german: 'Blockflöte (Sopran)',
    dutch: 'blokfluit (sporaan)',
    afrikaans: 'blokfluit (soprano)',
    russian: 'блок-флейта (сопрано)',
    latvian: 'bloklauta, soprāna',
    polish: 'rożek angielski (flet) (sopranowy)(obój, fagot, kontrafagot)',
    french: 'flûte soprano (bois)',
    spanish: 'flautín (soprano)',
  },
  {
    av: 23941,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(recorder + tenor)',
    english: 'recorder (tenor)',
    swedish: 'blockflöjt (tenor)',
    norwegian: 'blokkfløyte (tenor)',
    finnish: 'tenorinokkahuilu',
    hungarian: 'furulya – tenor',
    german: 'Blockflöte (Tenor)',
    dutch: 'blokfluit (tenor',
    afrikaans: 'blokfluit (tenoor)',
    russian: 'блок-флейта (тенор)',
    latvian: 'blokflauta, tenora',
    polish: 'rożek angielski (flet) (tenorowy)(obój, fagot, kontrafagot)',
    french: 'flûte ténor (bois)',
    spanish: 'flautín (tenor)',
  },
  {
    av: 23943,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + up and down)',
    english: 'rhythm instrument',
    swedish: 'rytminstrument',
    norwegian: 'rytmeinstrument',
    finnish: 'rytmisoitin',
    hungarian: 'ritmus hangszer',
    german: 'Rhytmusinstrument',
    dutch: 'percussieinstrument',
    afrikaans: 'perkussie instrument',
    russian: 'ритмичный инструмент',
    latvian: 'ritma instruments',
    polish: 'instrument rytmiczny (muz.)',
    french: 'instrument (de musique) rythmique',
    spanish: 'instrumento de ritmo',
  },
  {
    av: 23944,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(deer + little)',
    english: 'roe deer',
    swedish: 'rådjur',
    norwegian: 'rådyr',
    finnish: 'metsäkauris, kauris',
    hungarian: 'őz',
    german: 'Reh, Rehwild',
    dutch: 'ree',
    afrikaans: 'gemsbok',
    russian: 'косуля',
    latvian: 'stirna',
    polish: 'sarna',
    french: 'chevreuil, daim',
    spanish: 'corzo',
  },
  {
    av: 23945,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + rotation)',
    english: 'rotisserie, spit',
    swedish: 'grillkött',
    norwegian: 'grillkjøtt på roterende spyd',
    finnish: 'varrasliha',
    hungarian: 'nyárson sült étel',
    german: 'Grill, (Brat)Spieβ',
    dutch: 'gebraad',
    afrikaans: 'spitbraai',
    russian: 'шашлык, мясо на вертеле',
    latvian: 'grilēta gaļa, uz iesma cepta gaļa',
    polish: 'rożen',
    french: 'viande à la broche',
    spanish: 'asador',
  },
  {
    av: 23946,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clarinet, reed instrument (1) + metal [contraction]) SYMBOL SYNONYM',
    english: 'saxophone (1)',
    swedish: 'saxofon (1)',
    norwegian: 'saksofon (1)',
    finnish: 'saksofoni',
    hungarian: 'szaxofon',
    german: 'Saxophon (1)',
    dutch: 'saxofoon (1)',
    afrikaans: 'saksofoon (1)',
    russian: 'саксофон (1)',
    latvian: 'saksofons (1)',
    polish: 'saksofon (1)',
    french: 'saxophone (1)',
    spanish: 'saxofón (1)',
  },
  {
    av: 23947,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clarinet, reed instrument (2) + metal [contraction]) SYMBOL SYNONYM',
    english: 'saxophone (2)',
    swedish: 'saxofon (2)',
    norwegian: 'saksofon (2)',
    finnish: 'saksofoni',
    hungarian: 'szaxofon',
    german: 'Saxophon (2)',
    dutch: 'saxofoon (2)',
    afrikaans: 'saksofoon (2)',
    russian: 'сакосфон (2)',
    latvian: 'saksofons (2)',
    polish: 'saksofon (2)',
    french: 'saxophone (2)',
    spanish: 'saxofón (2)',
  },
  {
    av: 23949,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pancak + little)',
    english: 'small pancake, blini',
    swedish: 'plättar, blinier',
    norwegian: 'pannekake liten, blini',
    finnish: 'blini, lettu, räiskäle, ohukainen',
    hungarian: 'kelt palacsinta, blini',
    german: 'Blini, kleine Pfannkuchen',
    dutch: 'blini, poffertjes (Nl)',
    afrikaans: 'blini klein pannekoek, plaatkoek',
    russian: 'оладьи, блинчик',
    latvian: 'rauga pankūkas, bliņas',
    polish: 'blin, placuszek naleśnikowy',
    french: 'crêpe, blin',
    spanish: 'torta pequeña',
  },
  {
    av: 23950,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vehicle + snow)',
    english: 'snowmobile',
    swedish: 'snöskoter',
    norwegian: 'snøscooter',
    finnish: 'moottorikelkka',
    hungarian: 'motorosszán',
    german: 'Schneescooter',
    dutch: 'sneeuwscooter',
    afrikaans: 'sneeuscooter',
    russian: 'снегоход',
    latvian: 'sniega visurgājējs',
    polish: 'skuter śnieżny',
    french: 'véhicule de neige',
    spanish: 'motonieve',
  },
  {
    av: 23951,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vehicle + minus + snow)',
    english: 'snowplow, snowplough',
    swedish: 'snöplog',
    norwegian: 'snøplog',
    finnish: 'lumilinko, lumiaura',
    hungarian: 'hókotró, hóeke',
    german: 'Schneepflug',
    dutch: 'sneeuwruimer, sneeuwploeg',
    afrikaans: 'sneeuploeg',
    russian: 'снегоочеститель',
    latvian: 'sniega tīrītājs',
    polish: 'odśnieżarka, pług śnieżny, pługopiaskarka',
    french: 'chasse-neige',
    spanish: 'quitanieves',
  },
  {
    av: 23953,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(spray, vaporization + action indicator)',
    english: 'spray, vaporize-(to)',
    swedish: 'spreja, förånga',
    norwegian: 'spraye',
    finnish: 'spreijata, haihtua',
    hungarian: 'porlasztani, permetezni',
    german: 'sprühen, besprühen, spritzen, zerstäuben',
    dutch: 'spuiten, sprayen, verstuiven',
    afrikaans: 'spuit, sprei, verdamp (om te)',
    russian: 'распылять',
    latvian: 'izsmidzināt',
    polish: 'spryskiwać, zraszać',
    french: 'vaporiser',
    spanish: 'pulverizar, vaporizar',
  },
  {
    av: 23954,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bottle + spray, vaporization)',
    english: 'spray bottle, vaporizer, spray can',
    swedish: 'sprejflaska',
    norwegian: 'sprayflaske',
    finnish: 'spraypullo',
    hungarian: 'porlasztó palack (pl. hajlakk)',
    german: 'Sprühdose',
    dutch: 'spuitbus',
    afrikaans: 'sprei bottel, sprei kan, sprei blik',
    russian: 'спрей, распылитель',
    latvian: 'aerosols, pulverizators, aerosola pudele',
    polish: 'sprej, butelka, naczynie ze zraszaczem',
    french: 'vaporisateur',
    spanish: 'vaporizador',
  },
  {
    av: 23956,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(much + gale: i.e., much + much + wind)',
    english: 'storm',
    swedish: 'storm',
    norwegian: 'storm',
    finnish: 'hirmumyrsky',
    hungarian: 'vihar',
    german: 'Sturm',
    dutch: 'storm',
    afrikaans: 'storm',
    russian: 'шторм, буря, ураган',
    latvian: 'vētra',
    polish: 'sztorm',
    french: 'tempête',
    spanish: 'tormenta',
  },
  {
    av: 23957,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(stress (for time) + description indicator: having a feeling of lacking time for an activity)',
    english: 'stressed (for time), pushed (for time), in a rush',
    swedish: 'stressad, jäktad',
    norwegian: 'stresset',
    finnish: 'stressaantunut, ylirasittunut',
    hungarian: 'stresszes, feszült',
    german: 'gestresst, angespannt, angestrengt',
    dutch: 'gestrest, gespannen',
    afrikaans: 'gespanne',
    russian: 'стрессовый',
    latvian: 'sanervozējies, stresa pilns',
    polish: 'zestresowany, spięty (z braku czasu)',
    french: 'stressé, tendu',
    spanish: 'estresado',
  },
  {
    av: 23960,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + what, question mark + intensity: a feeling of unexpectedness)',
    english: 'surprise',
    swedish: 'överraskning',
    norwegian: 'overraskelse',
    finnish: 'yllätys',
    hungarian: 'meglepetés',
    german: 'Überraschung',
    dutch: 'verrassing',
    afrikaans: 'verrassing',
    russian: 'сюрприз',
    latvian: 'pārsteigums',
    polish: 'niespodzianka',
    french: 'surprise, étonnement',
    spanish: 'sorpresa',
  },
  {
    av: 23961,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(cause-(to) + surprise + action indicator) Preferred NEW SYNONYM, replacing 17470',
    english: 'surprise-(to)',
    swedish: 'överraska',
    norwegian: 'overraske',
    finnish: 'yllättää',
    hungarian: 'meglepni, meglepődni',
    german: 'überraschen',
    dutch: 'verrassen',
    afrikaans: 'verras (om te)',
    russian: 'удивлять',
    latvian: 'pārsteigt',
    polish: 'zaskakiwać, robić niespodziankę',
    french: 'surprendre, provoquer la surprise',
    spanish: 'sorprender',
  },
  {
    av: 23962,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(surprise + description indicator)',
    english: 'surprised',
    swedish: 'överraskad',
    norwegian: 'overrasket',
    finnish: 'yllättynyt',
    hungarian: 'meglepett, meglepődött',
    german: 'überrascht, verwundert',
    dutch: 'verrast, verbaasd',
    afrikaans: 'verras, verbaas',
    russian: 'удивлённый',
    latvian: 'pārsteigts, izbrīnīts',
    polish: 'zaskoczony',
    french: 'surpris, étonné',
    spanish: 'sorprendido',
  },
  {
    av: 23963,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(piano (1) + digits (computer): a digital keyboard instrument) ',
    english: 'synthesizer, synthesiser, keyboard',
    swedish: 'synt, synthesizer, keyboard',
    norwegian: 'synthesiser, keyboard',
    finnish: 'syntetisaattori',
    hungarian: 'szintetizátor, szintetizátor billentyűzete',
    german: 'Keyboard, elektronisches Klavier, elektronische Orgel',
    dutch: 'syntheziser',
    afrikaans: 'sintetiseerder, sleutelbord',
    russian: 'синтезатор',
    latvian: 'sintezators',
    polish: 'syntezator, klawisze (muz.)',
    french: 'synthétiseur',
    spanish: 'sintetizador, teclado',
  },
  {
    av: 23964,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drum + up and down) SYMBOL SYNONYM',
    english: 'tambourine (1)',
    swedish: 'tamburin (1)',
    norwegian: 'tamburin (1)',
    finnish: 'tamburiini',
    hungarian: 'tamburin, csörgődob',
    german: 'Tamburin (1)',
    dutch: 'tamboerijn (1)',
    afrikaans: 'tamboeryn (1)',
    russian: 'тамбурин (1)',
    latvian: 'tamburīns (1)',
    polish: 'tamburyn (1)',
    french: 'tambourin (1)',
    spanish: 'pandereta (1)',
  },
  {
    av: 23965,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rhythm instrument + disk + hand) SYMBOL SYNONYM',
    english: 'tambourine (2)',
    swedish: 'tamburin (2)',
    norwegian: 'tamburin (2)',
    finnish: 'tamburiini',
    hungarian: 'tamburin, csörgődob',
    german: 'Tamburin (2)',
    dutch: 'tamboerijn (2)',
    afrikaans: 'tamboeryn (2)',
    russian: 'тамбурин (2)',
    latvian: 'tamburīns (2)',
    polish: 'tamburyn (2)',
    french: 'tambourin (2)',
    spanish: 'pandereta (2)',
  },
  {
    av: 23967,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gale + rotation: a stron rotating wind)',
    english: 'tornado',
    swedish: 'virvelstorm, tornado',
    norwegian: 'tornado',
    finnish: 'pyörremyrsky, tornado, trombi',
    hungarian: 'tornádó',
    german: 'Wirbelsturm, Tornado',
    dutch: 'tornado',
    afrikaans: 'tornado',
    russian: 'торнадо',
    latvian: 'tornado, rotējoša viesuļvētra',
    polish: 'tornado',
    french: 'tornade',
    spanish: 'tornado',
  },
  {
    av: 23968,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(triangle [contraction] + mallet) SYMBOL SYNONYM',
    english: 'triangle (instrument) (1)',
    swedish: 'triangel (instrument) (1)',
    norwegian: 'triangel instrument (1)',
    finnish: 'triangeli',
    hungarian: 'triangulum',
    german: 'Triangel (Instrument) (1)',
    dutch: 'triangel (1)',
    afrikaans: 'driehoek (instrument) (1)',
    russian: 'музыкальный треугольник (1)',
    latvian: 'trīsstūris (perkusijas instruments) (1)',
    polish: 'trójkąt (instrument) (1)',
    french: 'triangle (instrument) (1)',
    spanish: 'triángulo (instrumento) (1)',
  },
  {
    av: 23969,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + triangle (instrument) (1)) SYMBOL SYNONYM',
    english: 'triangle (instrument) (2)',
    swedish: 'triangel (instrument) (2)',
    norwegian: 'triangel instrument (2)',
    finnish: 'triangeli',
    hungarian: 'triangulum',
    german: 'Triangel (Instrument) (2)',
    dutch: 'triangel (2)',
    afrikaans: 'driehoek (instrument) (2)',
    russian: 'музыкальный треугольник (2)',
    latvian: 'trīsstūris (perkusijas instruments) (2)',
    polish: 'trójkąt (instrument) (2)',
    french: 'triangle (instrument) (2)',
    spanish: 'triángulo (instrumento) (2)',
  },
  {
    av: 23970,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(brass instrument + back and forth)',
    english: 'trombone',
    swedish: 'trombon',
    norwegian: 'trombone',
    finnish: 'pasuuna, vetopasuuna',
    hungarian: 'harsona',
    german: 'Posaune',
    dutch: 'trombone',
    afrikaans: 'tromboon',
    russian: 'тромбон ',
    latvian: 'trombons',
    polish: 'puzon',
    french: 'trombone',
    spanish: 'trombón',
  },
  {
    av: 23971,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(brass instrument + 3 + disc: the three discs represening the three valves of a trumpet) SYMBOL SYNONYM',
    english: 'trumpet, horn, cornet (2)',
    swedish: 'trumpet, kornett (2)',
    norwegian: 'trompet, kornett (2)',
    finnish: 'trumpetti',
    hungarian: 'kürt, trombita',
    german: 'Trompete, Kornett (2)',
    dutch: 'trompet, hoorn (muziekinstrument) (2)',
    afrikaans: 'trompet, horing (musiekinstrument) (2)',
    russian: 'труба, горн, корнет (2)',
    latvian: 'trompete, rags, kornete (2)',
    polish: 'trąbka, róg (2)',
    french: 'trompette, cor, cornet à piston (2)',
    spanish: 'trompeta, cuerno, corneta (2)',
  },
  {
    av: 23972,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tidal wave + intensity: a very big tidal wave)',
    english: 'tsunami',
    swedish: 'tsunami',
    norwegian: 'tsunami',
    finnish: 'tsunami, hyökyaalto',
    hungarian: 'cunami',
    german: 'Tsunami',
    dutch: 'tsunami',
    afrikaans: 'tsunami',
    russian: 'цунами',
    latvian: 'cunami',
    polish: 'tsunami',
    french: 'tsunami',
    spanish: 'tsunami',
  },
  {
    av: 23973,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(trumpet + big) SYMBOL SYNONYM',
    english: 'tuba (1)',
    swedish: 'tuba (1)',
    norwegian: 'tuba (1)',
    finnish: 'tuuba',
    hungarian: 'tuba',
    german: 'Tuba (1)',
    dutch: 'tuba (1)',
    afrikaans: 'tuba (1)',
    russian: 'труба (муз. инструмент) (1)',
    latvian: 'tūba (1)',
    polish: 'tuba (1)',
    french: 'tuba (1)',
    spanish: 'tuba (1)',
  },
  {
    av: 23974,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(brass instument + bass) SYMBOL SYNONYM',
    english: 'tuba (2)',
    swedish: 'tuba (2)',
    norwegian: 'tuba (2)',
    finnish: 'tuuba',
    hungarian: 'tuba',
    german: 'Tuba (2)',
    dutch: 'tuba (2)',
    afrikaans: 'tuba (2)',
    russian: 'труба (муз. инструмент) (2)',
    latvian: 'tūba (2)',
    polish: 'tuba (2)',
    french: 'tuba (2)',
    spanish: 'tuba (2)',
  },
  {
    av: 23975,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fork + musical note)',
    english: 'tuning fork',
    swedish: 'stämgaffel',
    norwegian: 'stemmegaffel',
    finnish: 'äänirauta',
    hungarian: 'hangvilla',
    german: 'Stimmgabel ',
    dutch: 'stemvork',
    afrikaans: 'stem vurk',
    russian: 'камертон',
    latvian: 'kamertonis',
    polish: 'kamerton',
    french: 'diapason',
    spanish: 'diapasón',
  },
  {
    av: 23976,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(brother + same + birth)',
    english: 'twin brother',
    swedish: 'tvillingbror',
    norwegian: 'tvillingbror',
    finnish: 'kaksoisveli',
    hungarian: 'ikerfivér',
    german: 'Zwillingsbruder',
    dutch: 'tweelingbroer',
    afrikaans: 'tweeling broer',
    russian: 'брат-близнец',
    latvian: 'dvīņi',
    polish: 'brat bliźniak',
    french: 'jumeau (frère)',
    spanish: 'hermano gemelo',
  },
  {
    av: 23977,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(sister + same + birth)',
    english: 'twin sister',
    swedish: 'tvillingsyster',
    norwegian: 'tvillingsøster',
    finnish: 'kaksoissisko',
    hungarian: 'ikertestvér – lány',
    german: 'Zwillingsschwester',
    dutch: 'tweelingzus',
    afrikaans: 'tweeling suster',
    russian: 'сестра-близнец',
    latvian: 'dvīnes',
    polish: 'siostra bliźniaczka',
    french: 'jumelle (soeur)',
    spanish: 'hermana gemela',
  },
  {
    av: 23978,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(2 + person + same + birth)',
    english: 'twins',
    swedish: 'tvillingar',
    norwegian: 'tvillinger',
    finnish: 'kaksoset',
    hungarian: 'ikrek',
    german: 'Zwilling',
    dutch: 'tweeling',
    afrikaans: 'tweeling',
    russian: 'близнецы',
    latvian: 'dvīņi',
    polish: 'bliźniaki, bliźnięta',
    french: 'jumeaux',
    spanish: 'gemelos',
  },
  {
    av: 23979,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(guitar, string instrument + little)',
    english: 'ukulele',
    swedish: 'ukulele',
    norwegian: 'ukulele',
    finnish: 'ukulele',
    hungarian: 'ukulele',
    german: 'Ukulele, Hawaiigitarre',
    dutch: 'ukelele',
    afrikaans: 'ukulele',
    russian: 'гавайская гитара',
    latvian: 'havajiešu ģitāra',
    polish: 'ukulele',
    french: 'guitare hawaïenne, ukulélé',
    spanish: 'ukelele',
  },
  {
    av: 23980,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(unfolding + action indicator) Preferred NEW SYNONYM, replacing 17976',
    english: 'unfold-(to)',
    swedish: 'vika upp, veckla ut',
    norwegian: 'brette ut',
    finnish: 'avata, kääriä auki',
    hungarian: 'szétbontani, széthajtogatni, leleplezni, kitárni',
    german: 'entfalten',
    dutch: 'openvouwen',
    afrikaans: 'oopvou (om te)',
    russian: 'раскрывать, разворачивать(ся)',
    latvian: 'atlocīt, atvērt, atklāt',
    polish: 'rozwinąć, rozłożyć, rozpakować',
    french: 'déplier',
    spanish: 'desplegar',
  },
  {
    av: 23981,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + wind)',
    english: 'wind instrument',
    swedish: 'blåsinstrument',
    norwegian: 'blåseinstrument',
    finnish: 'puhallinsoitin',
    hungarian: 'fúvós hangszer',
    german: 'Blasinstrument',
    dutch: 'blaasinstrument',
    afrikaans: 'blaas instrument',
    russian: 'духовой инструмент',
    latvian: 'pūšaminstruments (vara)',
    polish: 'instrumenty dęte',
    french: 'instrument à vent',
    spanish: 'instrumento de viento',
  },
  {
    av: 23982,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bow and string instrument + alto)',
    english: 'viola',
    swedish: 'viola',
    norwegian: 'altfiolin',
    finnish: 'alttoviulu',
    hungarian: 'mélyhegedű, brácsa, viola',
    german: 'Bratsche, Viola',
    dutch: 'altviool',
    afrikaans: 'viool alt',
    russian: 'виола',
    latvian: 'alts',
    polish: 'altówka',
    french: 'violon alto',
    spanish: 'viola',
  },
  {
    av: 23983,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bow and string instrument + soprano)',
    english: 'violin',
    swedish: 'fiol, violin',
    norwegian: 'fiolin',
    finnish: 'viulu',
    hungarian: 'hegedű',
    german: 'Violine, Geige',
    dutch: 'viool',
    afrikaans: 'viool',
    russian: 'скрипка',
    latvian: 'vijole',
    polish: 'skrzypce',
    french: 'violon',
    spanish: 'violín',
  },
  {
    av: 23984,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sound + mouth)',
    english: 'voice',
    swedish: 'röst',
    norwegian: 'stemme',
    finnish: 'ääni',
    hungarian: 'hang',
    german: 'Stimme',
    dutch: 'stem',
    afrikaans: 'stem',
    russian: 'голос',
    latvian: 'balss',
    polish: 'głos',
    french: 'voix',
    spanish: 'voz',
  },
  {
    av: 23985,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wind instrument + wood [contraction]',
    english: 'woodwind instrument',
    swedish: 'träblåsinstrument',
    norwegian: 'treblåserinstrument',
    finnish: 'puupuhallin',
    hungarian: 'fafúvós hangszer',
    german: 'Holzbläser, Holzblasinstrument',
    dutch: 'houtblazer, houten blaasinstrument',
    afrikaans: 'blaas instrument hout',
    russian: 'деревянный духовой инструмент',
    latvian: 'pūšaminstruments (koka)',
    polish: 'instrument dęty drewniany',
    french: 'bois',
    spanish: 'instrumento de viento de madera',
  },
  {
    av: 23986,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(keyboard + mallet) SYMBOL SYNONYM',
    english: 'xylophone, vibraphone (1)',
    swedish: 'xylofon, vibrafon (1)',
    norwegian: 'xylofon, vibrafon (1)',
    finnish: 'ksylofoni, vibrafoni',
    hungarian: 'xilofon, vibrafon',
    german: 'Xylophon, Vibraphon (1)',
    dutch: 'xylofoon (1)',
    afrikaans: 'xylofoon, vibrafoon (1)',
    russian: 'ксилофон, вибрафон (1)',
    latvian: 'ksilofons, vibrofons (1)',
    polish: 'ksylofon, wibrafon (1)',
    french: 'xylophone, vibraphone (1)',
    spanish: 'xilófono, vibráfono (1)',
  },
  {
    av: 23987,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(percussion instrument + keyboard) SYMBOL SYNONYM',
    english: 'xylophone, vibraphone (2)',
    swedish: 'xylofon, vibrafon (2)',
    norwegian: 'xylofon, vibrafon (2)',
    finnish: 'ksylofoni, vibrafoni',
    hungarian: 'xilofon, vibrafon',
    german: 'Xylophon, Vibraphon (2)',
    dutch: 'xylofoon (2)',
    afrikaans: 'xylofoon, vibrafoon (2)',
    russian: 'ксилофон, вибрафон (2)',
    latvian: 'ksilofons, vibrofons (2)',
    polish: 'ksylofon, wibrafon (2)',
    french: 'xylophone, vibraphone (2)',
    spanish: 'xilófono, vibráfono (2)',
  },
  {
    av: 24001,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + gymnastics + show [contr.])',
    english: 'acrobat',
    swedish: 'akrobat',
    norwegian: 'akrobat',
    finnish: 'akrobaatti',
    hungarian: 'akrobata',
    german: 'Akrobat',
    dutch: 'acrobaat',
    afrikaans: 'akrobaat',
    russian: 'акробат',
    latvian: 'akrobāts',
    polish: 'akrobata',
    french: 'acrobate',
    spanish: 'acróbata',
  },
  {
    av: 24002,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + gymnastics + show [contr.])',
    english: 'acrobatics',
    swedish: 'akrobatik',
    norwegian: 'akrobatikk',
    finnish: 'akrobatia',
    hungarian: 'akrobatika',
    german: 'Akrobatik',
    dutch: 'acrobatie',
    afrikaans: 'akrobaties',
    russian: 'акробатика',
    latvian: 'akrobātika',
    polish: 'akrobatyka',
    french: 'acrobatie',
    spanish: 'acrobacia',
  },
  {
    av: 24003,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(addition + thing indicator) - (character with thing indicator)',
    english: 'adding, additive',
    swedish: 'tillsats',
    norwegian: 'tillegg',
    finnish: 'lisäaine',
    hungarian: 'adalék, adalékanyag, kiegészítő',
    german: 'Addition, Gewinn, Zugewinn, Ergänzung',
    dutch: 'additief, toevoeging',
    afrikaans: 'toevoeging, toevoeg',
    russian: 'добавка, добаввление',
    latvian: 'piedeva, pievienojums',
    polish: 'dodatek do czegoś',
    french: 'additif',
    spanish: 'añadir, aditivo',
  },
  {
    av: 24004,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limited time + before + Christmas)',
    english: 'Advent',
    swedish: 'advent',
    norwegian: 'advent',
    finnish: 'adventti',
    hungarian: 'Advent',
    german: 'Advent',
    dutch: 'advent',
    afrikaans: 'Advent',
    russian: 'Адвент',
    latvian: 'Advents',
    polish: 'Adwent',
    french: 'Avent',
    spanish: 'Advenimiento',
  },
  {
    av: 24005,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(doubt + God: belief that we don't know of either the existence or the nonexistence of God)",
    english: 'agnosticism',
    swedish: 'agnosticism',
    norwegian: 'agnostisisme',
    finnish: 'agnostisismi, agnostismi',
    hungarian: 'agnoszticizmus',
    german: 'Agnostizismus',
    dutch: 'agnosticisme',
    afrikaans: 'agnostisisme',
    russian: 'агнотицизм',
    latvian: 'agnosticisms',
    polish: 'agnostycyzm',
    french: 'agnosticisme',
    spanish: 'agnosticismo',
  },
  {
    av: 24006,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mouth + agreement: spoken agreement)',
    english: 'agreement (spoken)',
    swedish: 'överenskommelse (muntlig), avtal',
    norwegian: 'overenskomst, avtale (muntlig)',
    finnish: 'suullinen sopimus',
    hungarian: 'beleegyezés, megegyezés, megállapodás – szóbeli',
    german: 'Vereinbarung (mündlich)',
    dutch: 'overeenkomst (mondeling)',
    afrikaans: 'ooreenkoms (gesproke)',
    russian: 'соглашение (устное)',
    latvian: 'vienošanās (mutiska)',
    polish: 'umowa ustna',
    french: 'accord verbal, contrat oral',
    spanish: 'acuerdo (verbal)',
  },
  {
    av: 24007,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + agreement: agreement by a written document)',
    english: 'agreement (written), contract',
    swedish: 'överenskommelse (skriven), kontrakt',
    norwegian: 'overenskomst, avtale (skriftlig), kontrakt',
    finnish: 'kirjallinen sopimus',
    hungarian: 'beleegyezés, megegyezés, megállapodás – írásbeli',
    german: 'Vereinbarung (schriftlich), Vertrag',
    dutch: 'overeenkomst (schriftelijk), contract',
    afrikaans: 'ooreenkoms (skriftelik), kontrak',
    russian: 'соглашение (письменное), договор',
    latvian: 'vienošanās (rakstiska)',
    polish: 'umowa pisemna',
    french: 'accord écrit, traité, contrat',
    spanish: 'acuerdo (escrito)',
  },
  {
    av: 24008,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(store room + aid)',
    english: 'aid store room',
    swedish: 'hjälpmedelsförråd',
    norwegian: 'hjelpemiddellager',
    finnish: 'apuvälinevarasto',
    hungarian: 'segédeszköz raktár, segédeszköz tároló',
    german: 'Lagerraum, Vorratskammer',
    dutch: 'hulpmiddelenlokaal',
    afrikaans: 'hulpmiddel stoor kamer',
    russian: ' кладовка для реабилитационного оборудования',
    latvian: 'tehnisko palīdlīdzekļu telpa',
    polish: 'ambulatorium, pomieszczenie pierwszej pomocy',
    french: "entrepôt d'aides techniques",
    spanish: 'almacén de ayuda',
  },
  {
    av: 24009,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(waste + animal)',
    english: 'animal droppings',
    swedish: 'djurspillning',
    norwegian: 'dyreekskrementer',
    finnish: 'lanta, sonta',
    hungarian: 'állati ürülék',
    german: 'Tiermist, Tierexkrement, Mist, Dung',
    dutch: 'uitwerpselen (van dier), poep (van dier)',
    afrikaans: 'dier mis',
    russian: 'навоз',
    latvian: 'kūtsmēsli',
    polish: 'odchody zwierząt, guano, ',
    french: 'crotte',
    spanish: 'excremento de animal',
  },
  {
    av: 24010,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(aid + bones with joint + ankle + thing indicator: support for the ankle joint)',
    english: 'ankle splint',
    swedish: 'fotskena',
    norwegian: 'ankelskinne',
    finnish: 'nilkkalasta',
    hungarian: 'bokasín',
    german: 'Sprunggelenkschiene',
    dutch: 'spalk (enkel)',
    afrikaans: 'enkel spalk',
    russian: 'голеностопный тутор',
    latvian: 'potītes šina',
    polish: 'szyna zakładana na kostkę u nogi',
    french: 'attelle de cheville',
    spanish: 'férula de tobillo (soporte)',
  },
  {
    av: 24011,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(thing + two) See also: other, another (person) 15938',
    english: 'other, another (thing)',
    swedish: 'annan, annat',
    norwegian: 'annen, annet',
    finnish: 'toinen, muu',
    hungarian: 'másik, egy másik, más (dolog)',
    german: '(ein) anderer, (eine) andere, (jemand) anders',
    dutch: 'ander (ding), iets anders',
    afrikaans: 'ander iets (voorwerp, ding)',
    russian: 'другой',
    latvian: 'cits, cita, otra lieta, jautājums',
    polish: 'inny, kolejny, następny, drugi',
    french: 'autre (objet)',
    spanish: 'otro',
  },
  {
    av: 24012,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(apricot + dry)',
    english: 'apricot (dried)',
    swedish: 'aprikos (torkad)',
    norwegian: 'aprikose (tørket)',
    finnish: 'aprikoosi (kuivattu)',
    hungarian: 'aszalt sárgabarack',
    german: '(getrocknete) Aprikose',
    dutch: 'abrikoos (gedroogd)',
    afrikaans: 'gedroogde appelkoos',
    russian: 'курага (сушёный абрикос)',
    latvian: 'žāvēti aprikozi',
    polish: 'morela suszona',
    french: 'abricot sec',
    spanish: 'melocotón seco',
  },
  {
    av: 24013,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(up + Christ)',
    english: 'Ascension (of Christ)',
    swedish: 'Kristi himmelsfärd',
    norwegian: 'Kristi Himmelfart',
    finnish: 'kristuksen taivaaseenastuminen',
    hungarian: 'Jézus mennybemenetele',
    german: 'Himmelfahrt',
    dutch: 'Hemelvaart',
    afrikaans: 'Hemelvaart (van Christus)',
    russian: 'Вознесение',
    latvian: 'Kristus debesbraukšana',
    polish: 'Wniebowstąpienie (Chrystusa)',
    french: 'Ascension (du Christ)',
    spanish: 'Ascensión (de Cristo)',
  },
  {
    av: 24014,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + Ascension)',
    english: 'Ascension Day',
    swedish: 'Kristi himmelsfärdsdag',
    norwegian: 'Kristi Himmelfartsdag',
    finnish: 'helatorstai',
    hungarian: 'áldozócsütörtök, a mennybemenetel napja',
    german: 'Himmelfahrtstag, Christi Himmelfahrt',
    dutch: 'Hemelvaartsdag',
    afrikaans: 'Hemelvaart Dag',
    russian: 'День Вознесения',
    latvian: 'Debesbraukšanas diena',
    polish: 'Wniebowstąpienie, Święto Wniebowstąpienia Pańskiego',
    french: "Ascension, jour de l'Ascension (du Christ)",
    spanish: 'Día de la Ascención',
  },
  {
    av: 24016,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + assessment)',
    english: 'assessment room',
    swedish: 'utredningsrum, utprovningsrum',
    norwegian: 'utredningsrom, utprøvingsrom',
    finnish: 'arviointihuone',
    hungarian: 'vizsgáló szoba, diagnosztikai/felmérő szoba',
    german: 'Prüfungsraum, Prüfungszimmer',
    dutch: 'onderzoekslokaal',
    afrikaans: 'assessering saal lokaal kamer',
    russian: 'комната диагностики',
    latvian: 'pieņemšanas telpa',
    polish: 'pomieszczenie egzaminacyjne, pomieszczenie komisji',
    french: "local d'évaluation",
    spanish: 'sala de examen',
  },
  {
    av: 24017,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(end + description indicator)',
    english: "at one's destination, there",
    swedish: 'framme',
    norwegian: 'framme, der',
    finnish: 'perille saapunut',
    hungarian: 'célhoz érő, megérkező, célnál lévő, ott lévő',
    german: 'angekommen, eingetroffen, am Ziel sein',
    dutch: 'bestemming',
    afrikaans: 'daar, bestemming',
    russian: 'конечный',
    latvian: 'uz galamērķi, galapunktu, turp',
    polish: 'u celu, w miejscu przeznaczenia, tam',
    french: "à destination, à l'arrivée",
    spanish: 'en destino, ahí',
  },
  {
    av: 24018,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + watch [contr.] + money)',
    english: 'auditor, accountant',
    swedish: 'revisor, kamrer',
    norwegian: 'revisor',
    finnish: 'kirjanpitäjä, tilintarkastaja',
    hungarian: 'könyvelő, revizor, számvevő, auditor',
    german: 'Rechnungsprüfer, Rechnungsprüferin, Buchprüfer, Buchprüferin',
    dutch: 'accountant, auditer, boekhouder',
    afrikaans: 'ouditeur, rekenmeester',
    russian: 'аудитор',
    latvian: 'revidents, auditors (grāmatvedībā)',
    polish: 'rewident, księgowy',
    french: 'vérificateur des comptes, commissaire aux comptes',
    spanish: 'auditor, contable',
  },
  {
    av: 24019,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(snow + down + mountain)',
    english: 'avalanche',
    swedish: 'lavin',
    norwegian: 'snøskred',
    finnish: 'lumivyöry',
    hungarian: 'lavina',
    german: 'Lawine',
    dutch: 'lawine',
    afrikaans: 'sneeustorting',
    russian: 'лавина',
    latvian: 'lavīna',
    polish: 'lawina',
    french: 'avalanche',
    spanish: 'avalancha',
  },
  {
    av: 24020,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + dog + action indicator)',
    english: 'bark-(to)',
    swedish: 'skälla (hund)',
    norwegian: 'bjeffe',
    finnish: 'haukkua',
    hungarian: 'ugatni ',
    german: 'bellen (Hund)',
    dutch: 'blaffen',
    afrikaans: 'blaf (om te)',
    russian: 'лаять, гавкать',
    latvian: 'riet',
    polish: 'szczekać',
    french: 'aboyer',
    spanish: 'ladrar',
  },
  {
    av: 24021,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bean + dry) Preferred NEW SYNONYM, replacing 13880',
    english: 'bean (dried), chick-pea, kidney bean, pinto bean',
    swedish: 'böna (torkad)',
    norwegian: 'bønne (tørket) (o.l.)',
    finnish: 'papu (kuivattu), pintopapu, kidneypapu',
    hungarian: 'szárazbab',
    german: '(getrocknete) Bohne',
    dutch: 'boon (gedroogd), gedroogde bonen',
    afrikaans: 'boon (gedroog), keker ert, pinto boon, nier boon',
    russian: 'фасоль (сушёная)',
    latvian: 'pupas, pupiņas (kaltētas)',
    polish: 'Fasola suszona',
    french: 'haricot sec',
    spanish: 'alubia seca, grano seco',
  },
  {
    av: 24022,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + activity + bicycle)',
    english: 'bicycle path',
    swedish: 'cykelbana',
    norwegian: 'sykkelsti, sykkelbane',
    finnish: 'pyörätie',
    hungarian: 'kerékpárút',
    german: 'Fahrradweg, Radweg',
    dutch: 'fietspad',
    afrikaans: 'fietsry pad, baan',
    russian: 'велосипедная дорожка',
    latvian: 'riteņbraucēju celiņš',
    polish: 'ścieżka rowerowa',
    french: 'piste cyclable',
    spanish: 'carril de bicicletas',
  },
  {
    av: 24023,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(bisexuality + description indicator)',
    english: 'bisexual',
    swedish: 'bisexuell',
    norwegian: 'biseksuell',
    finnish: 'biseksuaalinen',
    hungarian: 'biszexuális',
    german: 'bisexuell',
    dutch: 'biseksueel',
    afrikaans: 'biseksueel',
    russian: 'бисексуальный',
    latvian: 'biseksuāls, -a',
    polish: 'biseksualny',
    french: 'bisexuel',
    spanish: 'bisexual',
  },
  {
    av: 24024,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + male and female + both)',
    english: 'bisexuality',
    swedish: 'bisexualitet',
    norwegian: 'biseksualitet',
    finnish: 'biseksuaalisuus',
    hungarian: 'biszexualitás',
    german: 'Bisexualität',
    dutch: 'biseksualiteit',
    afrikaans: 'biseksualiteit',
    russian: 'бисексуальность',
    latvian: 'biseksualitāte',
    polish: 'biseksualizm',
    french: 'bisexualité',
    spanish: 'bisexualidad',
  },
  {
    av: 24025,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(metal [contr.] + mouth + horse)',
    english: 'bit (horse)',
    swedish: 'betsel',
    norwegian: 'bitt',
    finnish: 'kuolaimet',
    hungarian: 'zabla',
    german: 'Gebiss (Pferdezaum)',
    dutch: 'bit (paard)',
    afrikaans: 'bit (perd)',
    russian: 'уздечка (для лошади)',
    latvian: 'pavada',
    polish: 'wędzidło (koń)',
    french: 'mors (cheval)',
    spanish: 'freno (caballo), brida (caballo)',
  },
  {
    av: 24026,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + sheep + action indicator)',
    english: 'bleat, baa-(to)',
    swedish: 'bräka',
    norwegian: 'breke',
    finnish: 'määkiä',
    hungarian: 'bégetni',
    german: 'blöken',
    dutch: 'blaten',
    afrikaans: 'blêr (om te)',
    russian: 'блеять',
    latvian: 'blēt, blēšana',
    polish: 'beczeć, muczeć',
    french: 'bêler',
    spanish: 'balar',
  },
  {
    av: 24027,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(fanatic + blissymbol)',
    english: 'Bliss fanatic',
    swedish: 'blissfanatiker',
    norwegian: 'blissfanatiker',
    finnish: 'bliss fanaatikko',
    hungarian: 'Bliss-őrült, Bliss-drukker, Bliss-bolond stb.',
    german: 'Bliss-Fanatiker, Bliss-Fanatikerin',
    dutch: 'Blissfanaat, Blissfan',
    afrikaans: 'Bliss, fanaat',
    russian: 'фанатик Блисс',
    latvian: 'Bliss programmas fanātiķis, -e',
    polish: 'Fan Blissa',
    french: 'fanatique de Bliss',
    spanish: 'fanático del Bliss',
  },
  {
    av: 24028,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tube + blood [contr.])',
    english: 'blood vessel',
    swedish: 'blodkärl',
    norwegian: 'blodåre',
    finnish: 'verisuoni',
    hungarian: 'véredény',
    german: 'Blutgefäß',
    dutch: 'ader',
    afrikaans: 'bloedvaat',
    russian: 'кровеносный сосуд',
    latvian: 'asinsvadi',
    polish: 'naczynie krwionośne',
    french: 'vaisseau sanguin',
    spanish: 'vaso sanguíneo',
  },
  {
    av: 24029,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(face + red + action indicator)',
    english: 'blush-(to)',
    swedish: 'rodna',
    norwegian: 'rødme',
    finnish: 'punastua',
    hungarian: 'elpirulni',
    german: 'erröten, (sich) schämen, rot anlaufen',
    dutch: 'blozen',
    afrikaans: 'bloos (om te)',
    russian: 'румяна',
    latvian: 'sarkt, nosarkt',
    polish: 'rumienić się',
    french: 'rougir',
    spanish: 'ruborizarse',
  },
  {
    av: 24030,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(aid + bones with joint + body + thing indicator: bones with joint representing joint [contr.], support for the hip joint and the spine)',
    english: 'body brace, corset',
    swedish: 'stödkorsett',
    norwegian: 'støttekorsett',
    finnish: 'tukiliivi, korsetti',
    hungarian: 'derékfűző, korzett',
    german: 'Stützkorsett',
    dutch: 'korset',
    afrikaans: 'korset',
    russian: 'корсет для тела',
    latvian: 'korsete, ķermeņa korsete',
    polish: 'gorset',
    french: 'corset',
    spanish: 'corsé',
  },
  {
    av: 24031,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + body)',
    english: 'body fluid',
    swedish: 'kroppsvätska',
    norwegian: 'kroppsvæske',
    finnish: 'ruumiinnesteet',
    hungarian: 'testnedv',
    german: 'Körperflüssigkeit',
    dutch: 'lichaamsvlocht',
    afrikaans: 'liggaams vloeistof',
    russian: 'жидкость организма',
    latvian: 'ķermeņa šķidrums',
    polish: 'płyn ustrojowy',
    french: 'sécrétion corporelle',
    spanish: 'fluido corporal',
  },
  {
    av: 24032,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hair + body)',
    english: 'body hair',
    swedish: 'kroppshår',
    norwegian: 'kroppshår',
    finnish: 'ihokarvat',
    hungarian: 'testszőrzet',
    german: 'Körperbehaarung, Körperhaar',
    dutch: 'lichaamshaar, beharing',
    afrikaans: 'liggaams hare',
    russian: 'волосяной покров',
    latvian: 'ķermeņa apmatojums',
    polish: 'owłosienie ciała',
    french: 'poils corporels',
    spanish: 'vello corporal',
  },
  {
    av: 24033,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + body)',
    english: 'body part',
    swedish: 'kroppsdel',
    norwegian: 'kroppsdel',
    finnish: 'kehonosa',
    hungarian: 'testrész',
    german: 'Körperteil',
    dutch: 'lichaamsdeel',
    afrikaans: 'liggaams deel',
    russian: 'часть тела',
    latvian: 'ķermeņa daļas',
    polish: 'części ciała',
    french: 'partie du corps',
    spanish: 'parte del cuerpo',
  },
  {
    av: 24034,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(temperature + body)',
    english: 'body temperature',
    swedish: 'kroppstemperatur',
    norwegian: 'kroppstemperatur',
    finnish: 'ruumiinlämpö',
    hungarian: 'testhőmérséklet',
    german: 'Körpertemperatur',
    dutch: 'lichaamstemperatuur',
    afrikaans: 'liggaams temperatuur',
    russian: 'температура тела ',
    latvian: 'ķermeņa temperatūra',
    polish: 'temperatura ciała',
    french: 'température corporelle',
    spanish: 'temperatura corporal',
  },
  {
    av: 24035,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(horse + three intensity characters + danger + action indicator)',
    english: 'bolt (horse)-(to)',
    swedish: 'skena (häst)',
    norwegian: 'løpe løpsk',
    finnish: 'pillastua (hevonen)',
    hungarian: 'megbokrosodni',
    german: 'durchgehen (Pferd)',
    dutch: 'op hol slaan',
    afrikaans: 'wegspring, weghardloop (perd) (om te)',
    russian: 'понести (лошадь)',
    latvian: 'aizauļot',
    polish: 'spłoszyć się, ponieść (koń)',
    french: "emballer-(s')",
    spanish: 'desbocarse',
  },
  {
    av: 24036,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(explosion + thing indicator) - (character with thing indicator)',
    english: 'bomb, explosive',
    swedish: 'bomb, sprängämne',
    norwegian: 'bombe, eksplosiv',
    finnish: 'pommi, räjähde',
    hungarian: 'bomba, robbanóanyag, robbanószer',
    german: 'Bombe',
    dutch: 'explosief (zelfst.nw), bom, springtuig',
    afrikaans: 'bom plofbare',
    russian: 'бомба, взрывчатка',
    latvian: 'bumba, sprāgstviela',
    polish: 'bomba, materiały wybuchowe',
    french: 'bombe, explosif',
    spanish: 'bomba, explosivo',
  },
  {
    av: 24037,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(curve + thing indicator: bow, as in 'bow and arrow', etc.) - (character with thing indicator)",
    english: 'bow',
    swedish: 'båge',
    norwegian: 'bue',
    finnish: 'kaari',
    hungarian: 'íj',
    german: 'Bogen',
    dutch: 'boog',
    afrikaans: 'boog',
    russian: 'лук, арбалет',
    latvian: 'loks, stops',
    polish: 'łuk (przedmiot)',
    french: 'arc (flèche)',
    spanish: 'arco',
  },
  {
    av: 24038,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(harness + muzzle + thing indicator)',
    english: 'bridle, headstall',
    swedish: 'träns',
    norwegian: 'bissel',
    finnish: 'suitset, päitset',
    hungarian: 'kantár',
    german: 'Zaumzeug, Halfter',
    dutch: 'teugel',
    afrikaans: 'toom',
    russian: 'трензель, уздечка',
    latvian: 'iemaukti',
    polish: 'uzda, ogłowie, kantar, tranzelka',
    french: 'bride (cheval)',
    spanish: 'riendas, jáquimas',
  },
  {
    av: 24039,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + activity + bus)',
    english: 'bus lane',
    swedish: 'bussfil',
    norwegian: 'bussfil',
    finnish: 'bussikaista, linja-autokaista',
    hungarian: 'buszsáv, autóbuszsáv',
    german: 'Busspur, Busfahrspur',
    dutch: 'busbaan, busstrook',
    afrikaans: 'bus laan',
    russian: 'автобусная полоса',
    latvian: 'autobusa josla',
    polish: 'pas autobusowy',
    french: 'voie des bus',
    spanish: 'carril para autobús',
  },
  {
    av: 24040,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(station + bus)',
    english: 'bus station',
    swedish: 'busstation',
    norwegian: 'busstasjon',
    finnish: 'linja-autoasema',
    hungarian: 'buszpályaudvar, autóbusz pályaudvar',
    german: 'Busbahnhof',
    dutch: 'busstation',
    afrikaans: 'bus stasie',
    russian: 'автостанция',
    latvian: 'autobusu stacija',
    polish: 'dworzec autobusowy',
    french: 'gare des bus',
    spanish: 'estación de autobuses',
  },
  {
    av: 24041,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(platform + bus) Preferred NEW SYNONYM, replacing 13090',
    english: 'bus stop, bus bay',
    swedish: 'busshållplats',
    norwegian: 'busstopp',
    finnish: 'bussipysäkki, linja-autopysäkki',
    hungarian: 'buszmegálló, autóbusz megálló',
    german: 'Bushaltestelle',
    dutch: 'bushalte, halte (bus)',
    afrikaans: 'bus stop, bus hawe',
    russian: 'автобусная остановка',
    latvian: 'autobusu pietura',
    polish: 'przystanek autobusowy, zatoka autobusowa',
    french: 'arrêt de bus',
    spanish: 'parada de autobús',
  },
  {
    av: 24042,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + ascending and descending)',
    english: 'cable car',
    swedish: 'linbana, kabinbana',
    norwegian: 'kabelbane',
    finnish: 'köysirata',
    hungarian: 'drótkötélpálya, siklóvasút',
    german: 'Gondel, Seilbahn',
    dutch: 'cable car, kabellift',
    afrikaans: 'kabel kar',
    russian: 'канатная дорога, фуникулёр',
    latvian: 'trošu dzelzceļš',
    polish: 'kolejka linowa',
    french: 'téléphérique, télécabine, funiculaire',
    spanish: 'teleférico',
  },
  {
    av: 24043,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + cell + repetition)',
    english: 'cancer',
    swedish: 'cancer',
    norwegian: 'kreft',
    finnish: 'syöpä',
    hungarian: 'rák (betegség)',
    german: 'Krebs, Krebserkrankung',
    dutch: 'kanker',
    afrikaans: 'kanker',
    russian: 'рак (болезнь)',
    latvian: 'vēzis',
    polish: 'rak (choroba)',
    french: 'cancer',
    spanish: 'cáncer',
  },
  {
    av: 24044,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(trot (horse)-(to) + intensity + action indicator)',
    english: 'canter-(to)',
    swedish: 'rida i kort galopp',
    norwegian: 'ri i kort galopp',
    finnish: 'ratsastaa lyhyttä laukkaa',
    hungarian: 'vágtázni ',
    german: 'leicht galoppieren',
    dutch: 'galopperen (handgalop)',
    afrikaans: 'drafstap (om te)',
    russian: 'скакать галопом',
    latvian: 'jāt rikšiem',
    polish: 'galopować (koń)',
    french: 'aller au petit galop',
    spanish: 'ir a medio galope',
  },
  {
    av: 24047,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chastity + religion)',
    english: 'celibacy (religious)',
    swedish: 'celibat, avhållsamhet (sexuell) ',
    norwegian: 'sølibat (religiøs)',
    finnish: 'seksuaalinen pidättäytyminen (uskonnon takia)',
    hungarian: 'cölibátus, papi nőtlenség',
    german: 'Zölibat, Ehelosigkeit (religiös)',
    dutch: 'celibaat',
    afrikaans: 'selibaatheid (godsdienstig)',
    russian: 'обет безбрачия (религия)',
    latvian: 'celibāts, ',
    polish: 'celibat (religijny)',
    french: 'abstinence sexuelle, célibat, chasteté',
    spanish: 'celibato (religioso)',
  },
  {
    av: 24048,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(craft + clay)',
    english: 'ceramics, pottery',
    swedish: 'keramik',
    norwegian: 'keramikk',
    finnish: 'keramiikka, savityö, saviesine',
    hungarian: 'kerámia, cserépedény, fazekasáru',
    german: 'Keramik, Töpferei',
    dutch: 'keramiek',
    afrikaans: 'keramiek',
    russian: 'керамика',
    latvian: 'keramika, māla trauki',
    polish: 'ceramika, garncarstwo',
    french: 'céramique, poterie',
    spanish: 'cerámica, alfarería',
  },
  {
    av: 24049,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(without + doubt + description indicator) Preferred NEW SYNONYM, replacing 13146',
    english: 'certain, sure',
    swedish: 'säker, bestämd, tillförlitlig',
    norwegian: 'sikker, bestemt',
    finnish: 'varma',
    hungarian: 'biztos, bizonyos, határozott, biztosan',
    german: 'sicher, gewiss, bestimmt',
    dutch: 'zeker',
    afrikaans: 'seker',
    russian: 'уверенный, определённый',
    latvian: 'noteikts, konkrēts, pārliecinošs',
    polish: 'pewność, brak wątpliwości',
    french: 'certain, sûr',
    spanish: 'cierto, seguro',
  },
  {
    av: 24050,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(seat, sitting + ascending and descending)',
    english: 'chairlift',
    swedish: 'sittlift, stollift',
    norwegian: 'stolheis',
    finnish: 'hiihtohissi, tuolihissi',
    hungarian: 'libegő',
    german: 'Sessellift',
    dutch: 'stoeltjeslift',
    afrikaans: 'stoel hyser',
    russian: 'кресельный подьёмник',
    latvian: 'krēsla pacēlājs',
    polish: 'wyciąg krzesełkowy',
    french: 'télésiège',
    spanish: 'telesilla',
  },
  {
    av: 24052,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(opposition + cause + action)',
    english: 'challenge',
    swedish: 'utmaning',
    norwegian: 'utfordring',
    finnish: 'haaste',
    hungarian: 'kihívás, alkalom az erőpróbára',
    german: 'Herausforderung',
    dutch: 'uitdaging',
    afrikaans: 'uitdaging',
    russian: 'вызов',
    latvian: 'izaicinājums',
    polish: 'wyzwanie',
    french: 'défi',
    spanish: 'desafío',
  },
  {
    av: 24053,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(personality + positive)',
    english: 'charm',
    swedish: 'charm',
    norwegian: 'sjarm',
    finnish: 'charmi, viehätysvoima',
    hungarian: 'báj, kedvesség, vonzerő, sárm',
    german: 'Charme, Reiz',
    dutch: 'charme',
    afrikaans: 'sjarme',
    russian: 'очарование, шарм, обаяние',
    latvian: 'burvība, šarms, pievilcība',
    polish: 'urok, charyzma, atrakcyjność (osoba)',
    french: 'charme',
    spanish: 'encanto',
  },
  {
    av: 24054,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(charm + description indicator)',
    english: 'charming',
    swedish: 'charmig',
    norwegian: 'sjarmerende',
    finnish: 'viehättävä, hurmaava, charmikas',
    hungarian: 'bájos, elbájoló, elbűvölő, sármos',
    german: 'charmant, reizend, entzückend',
    dutch: 'charmant',
    afrikaans: 'sjarmant',
    russian: 'очаровательный, обаятельный',
    latvian: 'pievilcīgs, šarmants',
    polish: 'uroczy, charyzmatyczny, atrakcyjny',
    french: 'charmant',
    spanish: 'encantador',
  },
  {
    av: 24055,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(many + grid + description indicator)',
    english: 'checked',
    swedish: 'rutig',
    norwegian: 'rutet',
    finnish: 'ruutukuvioinen',
    hungarian: 'kockás',
    german: 'kariert, gewürfelt',
    dutch: 'geruit',
    afrikaans: 'geruit',
    russian: 'клетчатый',
    latvian: 'pārbaudīts',
    polish: 'kratka, kraciaste',
    french: 'à carreaux',
    spanish: 'cuadriculado',
  },
  {
    av: 24056,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hair + chest)',
    english: 'chest hair',
    swedish: 'hår på bröstet',
    norwegian: 'hår på brystet',
    finnish: 'rintakarvat',
    hungarian: 'mellkasi szőrzet',
    german: 'Brusthaar',
    dutch: 'borsthaar',
    afrikaans: 'bors (haar)',
    russian: 'волосы на груди',
    latvian: 'krūšu apmatojums',
    polish: 'owłosienie na klatce piersiowej, na tułowiu',
    french: 'poils de poitrine',
    spanish: 'vello pectoral, pelo en el pecho',
  },
  {
    av: 24057,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(care + child) Child can be replaced by an appropriate specifier.',
    english: 'child care',
    swedish: 'barnomsorg',
    norwegian: 'barnepass',
    finnish: 'lastenhoito',
    hungarian: 'gyermekgondozűs',
    german: 'Kinderfürsorge',
    dutch: 'kinderopvang',
    afrikaans: 'kinder sorg',
    russian: 'забота о детях',
    latvian: 'bērnu aprūpe, bērna kopšana',
    polish: 'opieka nad dzieckiem',
    french: "garderie, protection de l'enfant",
    spanish: 'cuidado infantil',
  },
  {
    av: 24058,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(harness + child)',
    english: 'child harness, walking reins',
    swedish: 'barnsele',
    norwegian: 'barnesele',
    finnish: 'lasten valjaat',
    hungarian: 'gyermekkantár, sétáltató kantár',
    german: 'Babytrage, Babybrustgeschirr, Laufleine, Lauflernhilfe',
    dutch: 'kinderbeveiliging (gordel)',
    afrikaans: 'kinder gordel (veiligheids, harnas)',
    russian: 'детский ремень безопасности',
    latvian: 'groži, siksnas bērnu staigāšanas apmācībai',
    polish: 'szelki dla dzieci, uprząż dla dzieci',
    french: 'harnais pour enfant',
    spanish: 'arnés para niños',
  },
  {
    av: 24059,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + child)',
    english: "Children's Day",
    swedish: 'Barnens dag',
    norwegian: 'Barnas dag',
    finnish: 'lasten päivä',
    hungarian: 'Gyermeknap',
    german: 'Tag des Kindes, Kindertag',
    dutch: 'kinderdag',
    afrikaans: 'jeug dag',
    russian: 'День защиты детей',
    latvian: 'Bērnu diena',
    polish: 'Dzień Dziecka',
    french: 'Fête des enfants',
    spanish: 'Día del Niño',
  },
  {
    av: 24060,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + bird + action indicator)',
    english: 'chirp, twitter-(to)',
    swedish: 'kvittra',
    norwegian: 'kvitre',
    finnish: 'visertää',
    hungarian: 'csiripelni, csicseregni',
    german: 'zwitschern, zirpen',
    dutch: 'fluiten (vogel), tsjilpen',
    afrikaans: 'fluit, tjirp, tweet (om te)',
    russian: 'щебетать, чирикать',
    latvian: 'čiepstēt, čivināt',
    polish: 'ćwierkać, szczebiotać, pigolić (śpiew ptaków)',
    french: 'gazouiller, pépier',
    spanish: 'gorjear',
  },
  {
    av: 24061,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(showplace + cloth: i.e. showplace + tent [contr.])',
    english: 'circus',
    swedish: 'cirkus',
    norwegian: 'sirkus',
    finnish: 'sirkus',
    hungarian: 'cirkusz',
    german: 'Zirkus',
    dutch: 'circus',
    afrikaans: 'sirkus',
    russian: 'цирк',
    latvian: 'cirks',
    polish: 'cyrk',
    french: 'cirque',
    spanish: 'circo',
  },
  {
    av: 24062,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(without + spot + description indicator) Preferred NEW SYNONYM, replacing 13356',
    english: 'clean',
    swedish: 'ren',
    norwegian: 'støvfritt, rent',
    finnish: 'puhdas, siisti',
    hungarian: 'tiszta, folttalan',
    german: 'sauber',
    dutch: 'schoon (Nl), proper-(Vl)',
    afrikaans: 'skoon',
    russian: 'чистый',
    latvian: 'tīrs',
    polish: 'czysty',
    french: 'propre',
    spanish: 'limpio',
  },
  {
    av: 24063,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + clothes)',
    english: 'cloakroom, walk-in closet',
    swedish: 'klädkammare, garderob',
    norwegian: 'garderobe',
    finnish: 'vaatehuone, vaatekomero',
    hungarian: 'ruhatár, gardrób szoba',
    german: 'Garderobe',
    dutch: 'vestiaire, garderobe',
    afrikaans: 'klere kas, hang kas',
    russian: 'гардеробная',
    latvian: 'garderobe',
    polish: 'szatnia, garderoba',
    french: 'vestiaire',
    spanish: 'guardarropa',
  },
  {
    av: 24064,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(compound berry + marsh)',
    english: 'cloudberry',
    swedish: 'hjortron',
    norwegian: 'multe',
    finnish: 'lakka, suomuurain',
    hungarian: 'törpemálna',
    german: 'Moltebeere',
    dutch: 'bes (vochtige grond), vossebes',
    afrikaans: 'braam bessie (wit blom)',
    russian: 'морошка',
    latvian: 'lācenes',
    polish: 'malina moroszka',
    french: 'mûre (des marais)',
    spanish: 'mora de los pantanos',
  },
  {
    av: 24065,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + liquid + nose)',
    english: 'cold, common cold',
    swedish: 'förkylning',
    norwegian: 'forkjølelse, snue',
    finnish: 'nuha',
    hungarian: 'nátha, meghűlés, megfázás',
    german: 'Schnupfen, Erkältung',
    dutch: 'verkoudheid',
    afrikaans: 'verkoue',
    russian: 'простуда',
    latvian: 'saaukstēties',
    polish: 'katar, zaziębienie, przeziębienie, infekcja',
    french: 'rhume',
    spanish: 'resfriado común',
  },
  {
    av: 24066,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to have + together + description indicator)',
    english: 'common, mutual, shared',
    swedish: 'gemensam',
    norwegian: 'felles',
    finnish: 'yhteinen, jaettu',
    hungarian: 'közös, kölcsönös, megosztott ',
    german: 'gemeinsam',
    dutch: 'gemeenschappelijk, gezamenlijk',
    afrikaans: 'gemeenskaplik',
    russian: 'общий, совместный',
    latvian: 'kopīgs, savstarpējs',
    polish: 'wspólne, wzajemne',
    french: 'en commun, en partage',
    spanish: ' mutuo, compartido',
  },
  {
    av: 24067,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(train + back and forth)',
    english: 'commuter train',
    swedish: 'pendeltåg',
    norwegian: 'lokaltog, pendeltog',
    finnish: 'lähijuna',
    hungarian: 'helyiérdekű vasút, HÉV, ingázók vonata',
    german: 'Pendelzug',
    dutch: 'forenzentrein (NL), pendeltrein',
    afrikaans: 'pendel trein',
    russian: 'пригородный поезд',
    latvian: 'piepilsētas vilciens',
    polish: 'pociąg podmiejski, kolejka miejska, skm',
    french: 'train de banlieue',
    spanish: 'tren para cercanías',
  },
  {
    av: 24068,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(education + plus + therapy)',
    english: 'conductive education',
    swedish: 'konduktiv pedagogik',
    norwegian: 'konduktiv pedagogikk',
    finnish: 'konduktiivinen pedagogiikka',
    hungarian: 'konduktív pedagógia, kondukció',
    german: 'Petö-Therapie, konduktive Förderung nach Petö',
    dutch: 'Pëto-methode',
    afrikaans: 'geleidende leidende onderwys',
    russian: 'кондуктивная педагогика',
    latvian: 'vadītspējīga pedagoģija',
    polish: 'nauczanie prowadzące',
    french: 'pédagogie conductive, éducation conductive',
    spanish: 'educación conductiva',
  },
  {
    av: 24069,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + conductive education)',
    english: 'conductor (teacher, therapist)',
    swedish: 'konduktor',
    norwegian: 'konduktor',
    finnish: 'konduktiivinen opettaja',
    hungarian: 'konduktor, konduktív terapeuta',
    german: 'Konduktor',
    dutch: 'conductor (Pëto)',
    afrikaans: 'leier (onderwyser, terapeut)',
    russian: 'кондуктивный педагог, терапист',
    latvian: 'vadītājs, skolotājs, terapeits',
    polish: 'przewodnik (nauczyciel terapeuta)',
    french: 'conducteur (pédagogie conductive), pédagogue (pédagogie conductive)',
    spanish: 'conductor (profesor, terapeuta)',
  },
  {
    av: 24070,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bowel movement [contr.] + stop) SYMBOL SYNONYM',
    english: 'constipation (1)',
    swedish: 'förstoppning (1)',
    norwegian: 'forstoppelse',
    finnish: 'ummetus',
    hungarian: 'székrekedés',
    german: 'Verstopfung (1)',
    dutch: 'constipatie, verstopping (1)',
    afrikaans: 'hardlywigheid (1)',
    russian: 'запор (1)',
    latvian: 'aizcietējums (1)',
    polish: 'zaparcie (1)',
    french: 'constipation (1)',
    spanish: 'estreñimiento (1), constipación',
  },
  {
    av: 24071,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + bowel movement [contr.] + stop) SYMBOL SYNONYM',
    english: 'constipation (2)',
    swedish: 'förstoppning (2)',
    norwegian: 'forstoppelse (sykdom)',
    finnish: 'ummetus',
    hungarian: 'székrekedés',
    german: 'Verstopfung (2)',
    dutch: 'constipatie, verstopping (2)',
    afrikaans: 'hardlywigheid (2)',
    russian: 'запор (2)',
    latvian: 'aizcietējums (2)',
    polish: 'zaparcie (2)',
    french: 'constipation (2)',
    spanish: 'estreñimiento (2), constipación',
  },
  {
    av: 24072,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plan, design, method, system + country)',
    english: 'constitution',
    swedish: 'författning, konstitution',
    norwegian: 'konstitusjon, forfatning',
    finnish: 'perustuslaki, valtiosääntö',
    hungarian: 'alkotmány',
    german: 'Verfassung, Grundgesetz',
    dutch: 'grondwet',
    afrikaans: 'konstitusie grondwet',
    russian: 'конституция',
    latvian: 'uzbūve, konstitūcija',
    polish: 'konstytucja',
    french: 'constitution',
    spanish: 'constitución',
  },
  {
    av: 24073,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + frog + action indicator)',
    english: 'croak (frog)-(to)',
    swedish: 'kväka',
    norwegian: 'kvekke',
    finnish: 'kurnuttaa',
    hungarian: 'brekegni',
    german: 'quaken, krächzen',
    dutch: 'kwaken',
    afrikaans: 'kwaak (om te)',
    russian: 'квакать',
    latvian: 'kurkstēt',
    polish: 'skrzeczeć, kumkać (żaba)',
    french: 'coasser',
    spanish: 'croar (rana)',
  },
  {
    av: 24074,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(prince + future)',
    english: 'crown prince',
    swedish: 'kronprins',
    norwegian: 'kronprins',
    finnish: 'kruununprinssi',
    hungarian: 'trónörökös, koronaherceg',
    german: 'Kronprinz',
    dutch: 'kroonprins',
    afrikaans: 'kroon prins',
    russian: 'наследный принц',
    latvian: 'kroņprincis',
    polish: 'książę, następca tronu',
    french: 'prince héritier',
    spanish: 'príncipe heredero',
  },
  {
    av: 24075,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(princess + future)',
    english: 'crown princess',
    swedish: 'kronprinsessa',
    norwegian: 'kronprinsesse',
    finnish: 'kruununprinsessa',
    hungarian: 'trónörökösnő, koronahercegnő',
    german: 'Kronprinzessin',
    dutch: 'kroonprinses',
    afrikaans: 'kroon prinses',
    russian: 'наследная принцесса',
    latvian: 'kroņprincese',
    polish: 'księżna',
    french: 'princesse héritière',
    spanish: 'princesa heredera',
  },
  {
    av: 24076,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hug + feeling + action indicator)',
    english: 'cuddle-(to)',
    swedish: 'kela',
    norwegian: 'klemme, kose med',
    finnish: 'syleillä, hyväillä',
    hungarian: 'ölelni, ölelgetni, megölelni, átkarolni',
    german: 'schmusen, kuscheln, knuddeln',
    dutch: 'knuffelen, een knuffel geven',
    afrikaans: 'druk (om te)',
    russian: 'обнимать(ся)',
    latvian: 'apkampties, samīļoties',
    polish: 'przytulić',
    french: 'câliner',
    spanish: 'abrazar',
  },
  {
    av: 24077,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to destroy + illness + action indicator)',
    english: 'cure-(to)',
    swedish: 'bota',
    norwegian: 'kurere, helbrede',
    finnish: 'parantaa',
    hungarian: 'gyógyítani, meggógyítani, kúrálni, kikúrálni',
    german: 'heilen, auskurieren, behandeln',
    dutch: 'genezen',
    afrikaans: 'genees (skakel siekte uit) (om te)',
    russian: 'исцелить, вылечить',
    latvian: 'ārstēt',
    polish: 'leczyć, uzdrawiać',
    french: 'guérir',
    spanish: 'curar',
  },
  {
    av: 24078,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(therapy + dance)',
    english: 'dancing therapy',
    swedish: 'dansterapi',
    norwegian: 'danseterapi',
    finnish: 'tanssiterapia',
    hungarian: 'táncterápia',
    german: 'Tanztherapie',
    dutch: 'danstherapie',
    afrikaans: 'dans terapie',
    russian: 'танцевальная терапия',
    latvian: 'dejas terapija',
    polish: 'choreoterapia, terapia tańcem i ruchem',
    french: 'thérapie par la danse',
    spanish: 'danzaterapia',
  },
  {
    av: 24079,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(adding + beautiful + thing indicator) Preferred NEW SYNONYM, replacing 13650',
    english: 'decoration, ornament',
    swedish: 'prydnadssak, dekoration, utsmyckning',
    norwegian: 'dekorasjon, utsmykning',
    finnish: 'koriste',
    hungarian: 'díszítés, dekoráció',
    german: 'Dekoration, Verzierung',
    dutch: 'versiering',
    afrikaans: 'versiering, ornament',
    russian: 'украшение, орнамент',
    latvian: 'rotājums, dekorācija, ornaments',
    polish: 'dekoracja, ornament, ozdoba',
    french: 'décoration, garniture, ornement',
    spanish: 'decoración, ornamento',
  },
  {
    av: 24080,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + to permit + choice)',
    english: 'democracy (country)',
    swedish: 'demokrati (stat)',
    norwegian: 'demokrati',
    finnish: 'demokratia, kansanvalta',
    hungarian: 'demokrácia',
    german: 'Demokratie',
    dutch: 'democratie',
    afrikaans: 'demokrasie',
    russian: 'демократия',
    latvian: 'demokrātija',
    polish: 'demokracja',
    french: 'démocratie',
    spanish: 'democracia',
  },
  {
    av: 24082,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(devotion + description indicator)',
    english: 'devoted',
    swedish: 'engagerad, hängiven',
    norwegian: 'hengiven, engasjert, begeistret',
    finnish: 'omistaunut, kiintynyt',
    hungarian: 'odaadó, hű',
    german: 'gewidmet, hingebungsvoll',
    dutch: 'toegewijd, devoot',
    afrikaans: 'teoegewyd',
    russian: 'преданный своему делу',
    latvian: 'veltījies, nodevies kaut kam',
    polish: 'wielbiący, oddany, poświęcony czemuś',
    french: 'consacré à, voué à',
    spanish: 'dedicado',
  },
  {
    av: 24083,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + devotion)',
    english: 'devotee, fan',
    swedish: 'anhängare, fantast',
    norwegian: 'tilhenger av, fan',
    finnish: 'fani, kannattaja',
    hungarian: 'híve, rajongója, imádója vminek, vkinek',
    german: 'Anhänger, Anhängerin, Fanatiker, Fanatikerin, Fan',
    dutch: 'fan, toegewijd persoon',
    afrikaans: 'toegewyde persoon',
    russian: 'последователь, фанат',
    latvian: 'sekotājs, cienītājs, līdzjutējs',
    polish: 'wielbiciel, fan',
    french: 'passionné, adepte, partisan',
    spanish: 'hincha, simpatizante',
  },
  {
    av: 24084,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + important)',
    english: 'devotion',
    swedish: 'engagemang, hängivenhet, inlevelse',
    norwegian: 'hengivenhet, begeistring, engasjement',
    finnish: 'antaumus, kiintymys, omistautuminen',
    hungarian: 'rajongás, hűség, odaadás',
    german: 'Anhänger, Anhängerin, Fanatiker, Fanatikerin, Fan',
    dutch: 'toewijding, devotie, overgave',
    afrikaans: 'toewyding',
    russian: 'преданность делу, приверженность',
    latvian: 'veltīšanās, nodošanās',
    polish: 'oddanie, poświęcenie',
    french: 'dévouement, attachement',
    spanish: 'devoción',
  },
  {
    av: 24085,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + bowel movement + intensity)',
    english: 'diarrhea, diarrhoea',
    swedish: 'diarré',
    norwegian: 'diaré',
    finnish: 'ripuli',
    hungarian: 'hasmenés',
    german: 'Durchfall',
    dutch: 'diarree, buikloop',
    afrikaans: 'diarree',
    russian: 'диарея',
    latvian: 'caureja',
    polish: 'biegunka',
    french: 'diarrhée',
    spanish: 'diarrea',
  },
  {
    av: 24086,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(in + country + description indicator)',
    english: 'domestic',
    swedish: 'inrikes, inhemsk',
    norwegian: 'innenlands, innenriks',
    finnish: 'kotimainen',
    hungarian: 'hazai',
    german: 'heimisch, inländisch',
    dutch: 'binnenlands',
    afrikaans: 'huishoudelik',
    russian: 'внутригосударственный, отечественный ',
    latvian: 'mājas, iekšlietu',
    polish: 'krajowe',
    french: 'national, intérieur',
    spanish: 'doméstico, nacional',
  },
  {
    av: 24087,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(many + dot + description indicator)',
    english: 'dotted',
    swedish: 'prickig',
    norwegian: 'flekket, prikket',
    finnish: 'pilkullinen, täplikäs',
    hungarian: 'pettyes',
    german: 'gepunktet',
    dutch: 'gestippeld',
    afrikaans: 'gestippel',
    russian: 'пятнистый, точечный',
    latvian: 'punktains',
    polish: 'kropkowany',
    french: 'à pois',
    spanish: 'punteado',
  },
  {
    av: 24088,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cupboard + to dry + cloth)',
    english: 'drying cupboard, airing cupboard',
    swedish: 'torkskåp',
    norwegian: 'tørkeskap',
    finnish: 'kuivauskaappi',
    hungarian: 'szárítószekrény',
    german: 'Trockenschrank',
    dutch: 'droogkast',
    afrikaans: 'droograk, droogkas',
    russian: 'сушильный шкаф',
    latvian: 'žāvēšana, žāvējamais skapītis',
    polish: 'suszarka (szafka do suszenia)',
    french: 'séchoir (armoire)',
    spanish: 'armario de secado',
  },
  {
    av: 24089,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + to dry + cloth)',
    english: 'drying room, drying chamber',
    swedish: 'torkrum',
    norwegian: 'tørkerom',
    finnish: 'kuivaushuone',
    hungarian: 'szárítószoba, szárító kamra',
    german: 'Trockenboden, Trockenkeller, Trockenraum',
    dutch: 'droogkamer',
    afrikaans: 'droog kamer',
    russian: 'сушильная комната',
    latvian: 'žāvējamā istaba',
    polish: 'suszarnia, pomieszczenie do suszenia',
    french: 'séchoir (salle)',
    spanish: 'sala de secado',
  },
  {
    av: 24090,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(waste + action indicator)',
    english: 'dump, dispose-(to)',
    swedish: 'slänga, kasta, kassera',
    norwegian: 'kaste, kvitte seg med',
    finnish: 'viedä roskat, viedä jätteet',
    hungarian: 'szemét, hulladék',
    german: 'wegwerfen',
    dutch: 'dumpen, weggooien',
    afrikaans: 'weggooi (om te)',
    russian: 'утилизировать, выбрасывать',
    latvian: 'izgāzt, atbrīvoties, izmest',
    polish: 'wyrzucać, likwidować',
    french: 'déverser, jeter des déchets',
    spanish: 'volcar, disponer',
  },
  {
    av: 24091,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(aid + bones with joint + elbow + thing indicator: bones with joint representing joint [contr.], support for the elbow joint)',
    english: 'elbow splint',
    swedish: 'armbågsskena',
    norwegian: 'albuskinne',
    finnish: 'kyynärpäälasta',
    hungarian: 'könyöksín',
    german: 'Alu-Polsterschiene für den Ellbogen',
    dutch: 'spalk (elleboog)',
    afrikaans: 'spalk elmboog',
    russian: 'локтевой тутор',
    latvian: 'elkoņa šina',
    polish: 'szyna na łokieć',
    french: 'attelle de coude',
    spanish: 'codera, férula para codo',
  },
  {
    av: 24092,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + to choose: person who chooses or votes for a public official)',
    english: 'voter, elector',
    swedish: 'väljare',
    norwegian: 'velger',
    finnish: 'äänestäjä, valitsija',
    hungarian: 'választópolgár, választó, szavazó (fn.)',
    german: 'Wähler, Wählerin',
    dutch: 'kiezer',
    afrikaans: 'kieser, keurvors',
    russian: 'избиратель, участник голосования',
    latvian: 'vēlētājs',
    polish: 'wyborca',
    french: 'électeur',
    spanish: 'votante, elector',
  },
  {
    av: 24093,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(electorate + plural indicator)',
    english: 'electorate',
    swedish: 'väljarkår',
    norwegian: 'valg',
    finnish: 'äänestäjät, valitsijat',
    hungarian: 'választók, választókerület, választók csoportja',
    german: 'Wählerschaft',
    dutch: 'kiezers',
    afrikaans: 'kiesers',
    russian: 'избиратели, электорат',
    latvian: 'vēlētāji, elektorāts',
    polish: 'wyborcy, elektorat (liczba mnoga)',
    french: 'électorat',
    spanish: 'electorado',
  },
  {
    av: 24094,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(danger + delete + description before the fact indicator)',
    english: 'endangered',
    swedish: 'utrotningshotad',
    norwegian: 'truet, utrydningstruet',
    finnish: 'uhanalainen',
    hungarian: 'veszélyeztetett',
    german: 'vom Aussterben bedroht, gefährdet',
    dutch: 'bedreigd',
    afrikaans: 'bedreig',
    russian: 'находящийся под угрозой исчезновения',
    latvian: 'apdraudēts',
    polish: 'zagrożony',
    french: 'menacé',
    spanish: 'en peligro de extinción',
  },
  {
    av: 24095,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + to observe + Christ)',
    english: 'Epiphany',
    swedish: 'trettondagen',
    norwegian: 'helligtrekongersdag, trettendedag jul',
    finnish: 'loppiainen, epifania',
    hungarian: 'epifánia, a lényeg felismerése, istenség revelációja',
    german: 'Heilige-Drei-Könige',
    dutch: 'Epiphany',
    afrikaans: 'epifanie',
    russian: 'Богоявление',
    latvian: 'epifānija, trīs Austrumu gudro ierašanās diena',
    polish: 'Święto Trzech Króli',
    french: 'Epiphanie',
    spanish: 'Epifanía',
  },
  {
    av: 24096,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(stairs + up and down)',
    english: 'escalator, moving stairs',
    swedish: 'rulltrappa',
    norwegian: 'rulletrapp',
    finnish: 'rullaportaat',
    hungarian: 'mozgólépcső',
    german: 'Rolltreppe',
    dutch: 'roltrap',
    afrikaans: 'rol trap',
    russian: 'эскалатор',
    latvian: 'eskalators',
    polish: 'schody ruchome',
    french: 'escalier roulant, escalier mécanique',
    spanish: ' escaleras mecánicas',
  },
  {
    av: 24097,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + song: in E. singing, e g in choirs, is very important)',
    english: 'Estonia',
    swedish: 'Estland',
    norwegian: 'Estonia',
    finnish: 'Viro',
    hungarian: ' Észtország',
    german: 'Estland',
    dutch: 'Estland',
    afrikaans: 'Estonië',
    russian: 'Эстония',
    latvian: 'Igaunija',
    polish: 'Estonia (kraj)',
    french: 'Estonie',
    spanish: 'Estonia',
  },
  {
    av: 24099,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(experiment + action indicator)',
    english: 'experiment-(to)',
    swedish: 'experimentera',
    norwegian: 'eksperimentere',
    finnish: 'tehdä koe, kokeilla',
    hungarian: 'kísérletezni',
    german: 'experimentieren',
    dutch: 'experimenteren, een experiment uitvoeren',
    afrikaans: 'eksperimenteer (om te)',
    russian: 'экспериментировать',
    latvian: 'eksperimentēt',
    polish: 'eksperymentować, doświadczać',
    french: 'expérimenter',
    spanish: 'experimentar',
  },
  {
    av: 24100,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(explosion + description after the fact indicator)',
    english: 'exploded',
    swedish: 'exploderad, sprängd',
    norwegian: 'eksplodert, sprengt, detonert',
    finnish: 'räjähtänyt',
    hungarian: 'robbantott, felrobantott',
    german: 'explodiert',
    dutch: 'ontploft, geëxplodeerd',
    afrikaans: 'ontplof (het ge)',
    russian: 'взорванный',
    latvian: 'uzsprāgt, eksplodēt',
    polish: 'rozsadzony, zdetonowany, wysadzony',
    french: "explosé (qu'on a fait exploser)",
    spanish: 'explotado',
  },
  {
    av: 24101,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(explosion + description before the fact indicator)',
    english: 'explosive',
    swedish: 'explosiv',
    norwegian: 'eksplosiv, sprenglegeme',
    finnish: 'räjähtävä, räjähdysherkkä, räjähdysmäinen',
    hungarian: 'robbanó, felrobbanó, szétrobbanó',
    german: 'explosiv, brisant',
    dutch: 'explosief',
    afrikaans: 'plofbaar',
    russian: 'взрывоопасный, взрывчатый',
    latvian: 'sprāgstviela',
    polish: 'wybuchowy, służący do wyburzania, powodowania eksplozji',
    french: 'explosif',
    spanish: 'explosivo',
  },
  {
    av: 24102,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hair + face)',
    english: 'facial hair',
    swedish: 'ansiktshår',
    norwegian: 'ansiktshår',
    finnish: 'naamakarvat',
    hungarian: 'arcszőrzet',
    german: 'Gesichtsbehaarung',
    dutch: 'aangezichtsbeharing',
    afrikaans: 'gesig hare',
    russian: 'волосы на лице',
    latvian: 'sejas apmatojums',
    polish: 'zarost, broda, wąsy',
    french: 'poils du visage',
    spanish: 'vello facial',
  },
  {
    av: 24103,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + family)',
    english: 'Family Day',
    swedish: 'Familjens dag',
    norwegian: 'familiedag',
    finnish: 'perhepäivä',
    hungarian: 'Család Napja',
    german: 'Familientag, Tag der Familie',
    dutch: 'familiedag',
    afrikaans: 'Familie dag, Gesins dag',
    russian: 'День семьи',
    latvian: 'Ģimenes diena',
    polish: 'Święto Rodziny',
    french: 'Fête des familles, jour de la Famille',
    spanish: 'Día de la familia',
  },
  {
    av: 24104,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + wind)',
    english: 'fan (machine)',
    swedish: 'fläkt',
    norwegian: 'vifte',
    finnish: 'tuuletin',
    hungarian: 'ventillátor',
    german: 'Ventilator',
    dutch: 'ventilator',
    afrikaans: 'waaier (masjien)',
    russian: 'вентилятор',
    latvian: 'ventilators',
    polish: 'wentylator',
    french: 'ventilateur',
    spanish: 'ventilador (máquina)',
  },
  {
    av: 24105,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(devotion + intensity + description indicator)',
    english: 'fanatic',
    swedish: 'fanatisk',
    norwegian: 'fanatisk',
    finnish: 'fanaattinen, kiihkoilija',
    hungarian: 'fanatikus, megszállott, rajongó',
    german: 'fanatisch',
    dutch: 'fanatiek',
    afrikaans: 'fanatikus',
    russian: 'фанатичный',
    latvian: 'fanātisks',
    polish: 'fanatyczny, zagorzały, zaprzysięgły, zaślepiony, zapamiętały',
    french: 'fanatique',
    spanish: 'fanático',
  },
  {
    av: 24106,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(devotee + intensity)',
    english: 'fanatic (person)',
    swedish: 'fanatiker',
    norwegian: 'fanatiker',
    finnish: 'fanaatikko',
    hungarian: 'fanatikus, megszállott, rajongó (fn.)',
    german: 'Fanatiker, Fanatikerin',
    dutch: 'fanatiekeling',
    afrikaans: 'fanatiese (persoon)',
    russian: 'фанатик (персона)',
    latvian: 'fanātiķis, -e',
    polish: 'fanatyk (osoba)',
    french: 'fanatique (personne)',
    spanish: 'fanático (persona)',
  },
  {
    av: 24107,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + hoof)',
    english: 'farrier',
    swedish: 'hovslagare',
    norwegian: 'hovslager',
    finnish: 'hevosenkengittäjä',
    hungarian: 'patkolókovács',
    german: 'Hufschmied',
    dutch: 'hoefsmid',
    afrikaans: 'hoefsmid',
    russian: 'коваль, кузнец',
    latvian: 'kalējs',
    polish: 'kowal',
    french: 'maréchal-ferrant',
    spanish: 'herrador, herrero',
  },
  {
    av: 24108,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + father)',
    english: "Father's Day",
    swedish: 'Fars dag',
    norwegian: 'farsdag',
    finnish: 'isänpäivä',
    hungarian: 'Apák napja',
    german: 'Vatertag',
    dutch: 'vaderdag',
    afrikaans: 'Vaders dag',
    russian: 'День отца',
    latvian: 'Tēva diena',
    polish: 'Dzień Ojca',
    french: 'fête des Pères',
    spanish: 'Día del padre',
  },
  {
    av: 24109,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + for + activity)',
    english: 'fee',
    swedish: 'avgift',
    norwegian: 'avgift',
    finnish: 'maksu, hinta',
    hungarian: 'díj, fizetés, honorárium',
    german: 'Gebühr',
    dutch: 'vergoeding, tarief',
    afrikaans: 'fooi',
    russian: 'плата, вознаграждение',
    latvian: 'maksa, cena',
    polish: 'wynagrodzenie, opłata, zapłata, honorarium',
    french: 'honoraires, tarif',
    spanish: 'cuota',
  },
  {
    av: 24110,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(conception + description after the fact indicator)',
    english: 'fertilized',
    swedish: 'befruktad',
    norwegian: 'fertil, befruktet',
    finnish: 'hedelmöittynyt',
    hungarian: 'megtermékenyített',
    german: 'befruchtet',
    dutch: 'bevrucht',
    afrikaans: 'kunsmis',
    russian: 'оплодотворённый',
    latvian: 'apaugļots',
    polish: 'zapłodniony',
    french: 'fécondé',
    spanish: 'fecundado',
  },
  {
    av: 24111,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(number + small + description indicator) Preferred NEW SYNONYM, replacing 14171',
    english: 'few, little',
    swedish: 'lite, få',
    norwegian: 'få, lite',
    finnish: 'muutama',
    hungarian: 'kicsi, kevés, néhány',
    german: 'wenig',
    dutch: 'weinig, enkele',
    afrikaans: 'weinig, min, enkele',
    russian: 'мало, немного',
    latvian: 'daži, maz',
    polish: 'niewiele, mało, mała liczba',
    french: 'peu de',
    spanish: 'pocos',
  },
  {
    av: 24112,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(body temperature + high)',
    english: 'fever, temperature',
    swedish: 'feber',
    norwegian: 'feber',
    finnish: 'kuume',
    hungarian: 'láz',
    german: 'Fieber',
    dutch: 'temperatuur (koorts), koorts',
    afrikaans: 'koors, temperatuur',
    russian: 'лихорадка, жар, высокая температура',
    latvian: 'drudzis, temperatūra',
    polish: 'gorączka, temperatura',
    french: 'fièvre, température',
    spanish: 'fiebre',
  },
  {
    av: 24113,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(help + with + money)',
    english: 'financial support',
    swedish: 'stöd (ekonomiskt)',
    norwegian: 'finansiell støtte',
    finnish: 'avustus, taloudellinen tuki',
    hungarian: 'anyagi támogatás, segély',
    german: 'Finanzhilfe, finanzielle Unterstützung',
    dutch: 'sponsoring, financiële ondersteuning',
    afrikaans: 'finansiële ondersteuning',
    russian: 'финансовая поддержка',
    latvian: 'finansiālais atbalsts',
    polish: 'wsparcie finansowe',
    french: 'aide financière',
    spanish: 'apoyo financiero',
  },
  {
    av: 24114,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + finger)',
    english: 'fingernail, nail',
    swedish: 'nagel, fingernagel',
    norwegian: 'fingernegl, negl',
    finnish: 'sormenkynsi, kynsi',
    hungarian: 'köröm, ujjköröm',
    german: 'Fingernagel',
    dutch: 'nagel (vinger)',
    afrikaans: 'nael vinger',
    russian: 'ноготь',
    latvian: 'roku pirkstu nagi, nagi',
    polish: 'paznokieć',
    french: 'ongle',
    spanish: 'uñas',
  },
  {
    av: 24115,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + dry)',
    english: 'fish (dried)',
    swedish: 'fisk (torkad)',
    norwegian: 'fisk (tørket)',
    finnish: 'kala (kuivattu)',
    hungarian: 'szárított hal',
    german: 'getrockneter Fisch',
    dutch: 'vis (gedroogd), gedroogde vis',
    afrikaans: 'vis (gedroog)',
    russian: 'рыба (сушёная)',
    latvian: 'zivs, žāvēta, kaltēta',
    polish: 'ryba suszona',
    french: 'poisson séché',
    spanish: 'pescado seco',
  },
  {
    av: 24116,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flower + dry)',
    english: 'flower (dried)',
    swedish: 'blomma (torkad)',
    norwegian: 'blomst (tørket)',
    finnish: 'kukka (kuivattu)',
    hungarian: 'szárított virág, szalmavirág',
    german: 'getrocknete Blume',
    dutch: 'bloem (gedroogd), gedroogde bloem',
    afrikaans: 'blom (gedroog)',
    russian: 'сухоцвет, цветок (засушенный)',
    latvian: 'ziedi, kaltēti',
    polish: 'ususzony kwiat, ususzona roślina',
    french: 'fleur séchée',
    spanish: 'flor seca',
  },
  {
    av: 24117,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + body + intensity: your entire body is aching)',
    english: 'flu, influenza',
    swedish: 'influensa',
    norwegian: 'influensa',
    finnish: 'flunssa, influenssa',
    hungarian: 'influenza',
    german: 'Grippe',
    dutch: 'griep',
    afrikaans: 'griep, verkoue',
    russian: 'грипп',
    latvian: 'gripa',
    polish: 'grypa',
    french: 'grippe',
    spanish: 'gripe',
  },
  {
    av: 24118,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(out + country + description indicator)',
    english: 'foreign',
    swedish: 'utrikes, utländsk',
    norwegian: 'utenlandsk, utenriks',
    finnish: 'vierasmaalainen, ulkomaalainen',
    hungarian: 'külföldi, idegen',
    german: 'ausländisch',
    dutch: 'buitenlands',
    afrikaans: 'buitelands',
    russian: 'иностранный',
    latvian: 'ārzemju',
    polish: 'zagraniczny, obcy, cudzoziemski',
    french: 'étranger, étrangère',
    spanish: 'extranjero',
  },
  {
    av: 24119,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(castle + war)',
    english: 'fort, fortress',
    swedish: 'fästning, borg',
    norwegian: 'borg, fort',
    finnish: 'linnoitus, linnake',
    hungarian: 'erőd, erődítmény',
    german: 'Schloss, Burg',
    dutch: 'fort, burcht',
    afrikaans: 'fort',
    russian: 'форт, крепость',
    latvian: 'cietoksnis',
    polish: 'fort, forteca, warownia, twierdza',
    french: 'fort, forteresse, château fort',
    spanish: 'fuerte, fortaleza',
  },
  {
    av: 24121,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fruit + dry)',
    english: 'fruit (dried)',
    swedish: 'frukt (torkad)',
    norwegian: 'frukt (tørket)',
    finnish: 'hedelmä (kuivattu)',
    hungarian: 'szárított gyümölcs',
    german: 'getrocknete Frucht',
    dutch: 'fruit (gedroogd), gedroogd fruit',
    afrikaans: 'vrugte (gedroog)',
    russian: 'сухофрукт',
    latvian: 'augļi, žāvēti, kaltēti',
    polish: 'suszony owoc',
    french: 'fruit sec',
    spanish: 'fruta seca',
  },
  {
    av: 24122,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(foundation + description indicator)',
    english: 'fundamental, basic',
    swedish: 'grundläggande, basal, grund-, bas-',
    norwegian: 'grunnleggende, basal',
    finnish: 'perus, fundamentaalinen',
    hungarian: 'alapvető, alap-, fundamentális',
    german: 'fundamental, grundsätzlich, grundlegend',
    dutch: 'basis-, fundamenteel, essentieel',
    afrikaans: 'fondamenteel, basiese, essensiële',
    russian: 'фундаментальный, базовый',
    latvian: 'pamata, fundamentāls',
    polish: 'podstawowy, bazowy',
    french: 'fondamental',
    spanish: 'fundamental, básico',
  },
  {
    av: 24123,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(law + fundamental)',
    english: 'fundamental law',
    swedish: 'grundlag',
    norwegian: 'grunnlov',
    finnish: 'perustuslaki',
    hungarian: 'alapjog, alapvető jogok',
    german: 'Verfassung, Grundgesetz',
    dutch: 'grondwet',
    afrikaans: 'fondamentele wet',
    russian: 'основной закон',
    latvian: 'pamatlikums',
    polish: 'podstawa prawna',
    french: 'loi fondamentale',
    spanish: 'ley fundamental',
  },
  {
    av: 24124,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rule + fundamental)',
    english: 'fundamental rule',
    swedish: 'grundregel',
    norwegian: 'grunnleggende regel, grunnregel',
    finnish: 'perussääntö',
    hungarian: 'alapszabály',
    german: 'Grundregel',
    dutch: 'basisregel',
    afrikaans: 'fondamentele reël',
    russian: 'основное правило',
    latvian: 'pamatnoteikums',
    polish: 'podstawowe zasady',
    french: 'règle fondamentale, statuts',
    spanish: 'regla fundamental',
  },
  {
    av: 24125,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(belief + fundamental)',
    english: 'fundamentalism',
    swedish: 'fundamentalism',
    norwegian: 'fundamentalisme',
    finnish: 'fundamentalismi',
    hungarian: 'fundamentalizmus, merev ragaszkodás',
    german: 'Fundamentalismus',
    dutch: 'fundamentalisme',
    afrikaans: 'fundamentalisme',
    russian: 'фундаментализм',
    latvian: 'fundamentālisms',
    polish: 'fundamentalizm',
    french: 'intégrisme, fondamentalisme',
    spanish: 'fundamentalismo',
  },
  {
    av: 24126,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(religion + fundamental)',
    english: 'fundamentalism (religious)',
    swedish: 'fundamentalism (religiös)',
    norwegian: 'fundamentalisme religiøs',
    finnish: 'fundamentalismi (uskonnollinen)',
    hungarian: 'fundamentalizmus (vallási értelemben)',
    german: 'Fundamentalismus (religiös)',
    dutch: 'fundamentalisme (religieus)',
    afrikaans: 'fundamentalisme (godsdienstig)',
    russian: 'фундаментализм (религия)',
    latvian: 'fundamentālisms, reliģijas',
    polish: 'fundamentalizm religijny',
    french: 'intégrisme, fondamentalisme (religieux)',
    spanish: 'fundamentalismo (religioso)',
  },
  {
    av: 24127,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + fundamentalism)',
    english: 'fundamentalist',
    swedish: 'fundamentalist',
    norwegian: 'fundamentalist',
    finnish: 'fundamentalisti',
    hungarian: 'fundamentalista',
    german: 'Fundamentalist, Fundamentalistin',
    dutch: 'fundamentalist',
    afrikaans: 'fundamentalis',
    russian: 'фундаменталист',
    latvian: 'fundamentāists',
    polish: 'fundamentalista',
    french: 'intégriste, fondamentaliste',
    spanish: 'fundamentalista',
  },
  {
    av: 24128,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + fundamentalism (religious))',
    english: 'fundamentalist (religious)',
    swedish: 'fundamentalist (religiös)',
    norwegian: 'fundamentalist (religiøs)',
    finnish: 'fundamentalisti (uskonnollinen)',
    hungarian: ' fundamentalista (vallási értelemben)',
    german: 'Fundamentalist, Fundamentalistin (religiös)',
    dutch: 'fundamentalist (religieus)',
    afrikaans: 'fundamentalis (godsdienstig)',
    russian: 'фундаменталист (религия)',
    latvian: 'fundamentālists, reliģijā',
    polish: 'fundamentalista religijny',
    french: 'fondamentaliste (religieux)',
    spanish: 'fundamentalista (religioso)',
  },
  {
    av: 24129,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(gallop + action indicator)',
    english: 'gallop-(to)',
    swedish: 'galoppera',
    norwegian: 'galoppere',
    finnish: 'laukata',
    hungarian: 'vágtázni, galoppozni',
    german: 'galoppieren',
    dutch: 'galopperen (rengalop)',
    afrikaans: 'galop (om te)',
    russian: 'бежать галопом',
    latvian: 'aulekšot, auļot',
    polish: 'galopować',
    french: 'galoper',
    spanish: 'galopar',
  },
  {
    av: 24130,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(stallion + sterilized)',
    english: 'gelding',
    swedish: 'valack',
    norwegian: 'vallak',
    finnish: 'ruuna',
    hungarian: 'herélt',
    german: 'Wallach, kastriertes Tier',
    dutch: 'castratie (paard)',
    afrikaans: 'reun',
    russian: 'мерин, кастрированный жеребец',
    latvian: 'kastrēšana, kastrēts dzīvnieks',
    polish: 'wałach',
    french: 'hongre',
    spanish: 'caballo castrado',
  },
  {
    av: 24131,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(generalization + description indicator)',
    english: 'general',
    swedish: 'generell',
    norwegian: 'generell',
    finnish: 'yleinen',
    hungarian: 'általános, általában, általánosságban',
    german: 'allgemein',
    dutch: 'algemeen',
    afrikaans: 'algemeen',
    russian: 'обобщённый',
    latvian: 'galvenais, ģenerālais',
    polish: 'generalny, ogólny',
    french: 'général, global, générique',
    spanish: 'general',
  },
  {
    av: 24132,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + waist + horse + thing indicator)',
    english: 'girth, cinch',
    swedish: 'sadelgjord',
    norwegian: 'bukgjord',
    finnish: 'satulavyö',
    hungarian: 'heveder, nyeregheveder',
    german: 'Gurt, Körperumfang, Sattelgurt',
    dutch: 'singel (paard), buikriem (paard)',
    afrikaans: 'buikriem',
    russian: 'подпруга',
    latvian: 'seglu josta',
    polish: 'popręg (pas mocujący siodło na koniu)',
    french: 'sangle, ventrière',
    spanish: 'cincha',
  },
  {
    av: 24133,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ice + river: ice that moves in response to gravity)',
    english: 'glacier',
    swedish: 'glaciär',
    norwegian: 'isbre',
    finnish: 'jäätikkö',
    hungarian: 'gleccser',
    german: 'Gletscher',
    dutch: 'gletsjer',
    afrikaans: 'gletser',
    russian: 'ледник',
    latvian: 'ledājs',
    polish: 'lodowiec, góra lodowa',
    french: 'glacier',
    spanish: 'glaciar',
  },
  {
    av: 24134,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(craft + glass [contr.])',
    english: 'glass craft',
    swedish: 'glaskonst',
    norwegian: 'håndlaget glass, glasskunst',
    finnish: 'lasityö',
    hungarian: 'üvegművesség',
    german: 'Glashandwerk',
    dutch: 'glaskunst',
    afrikaans: 'glas kuns',
    russian: 'стекольное ремесло',
    latvian: 'stikla pūtējs',
    polish: 'szklarstwo (robienie, tworzenie szklanych naczyń)',
    french: 'verrerie artisanale',
    spanish: 'artesanía de cristal',
  },
  {
    av: 24135,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(light + fire + end)',
    english: 'glow',
    swedish: 'glöd',
    norwegian: 'glo',
    finnish: 'loiste, hehku',
    hungarian: 'izzás, parázslás',
    german: 'Glühen',
    dutch: 'gloed, glans, schijnsel',
    afrikaans: 'glans, gloed, skyn',
    russian: 'свечение, зарево',
    latvian: 'svelme, kvēle, blāzma',
    polish: 'żar, poświata, poblask',
    french: 'éclat, rougeoiement',
    spanish: 'brasa',
  },
  {
    av: 24136,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(glow + action indicator)',
    english: 'glow-(to)',
    swedish: 'glöda',
    norwegian: 'gløde',
    finnish: 'loistaa, hehkua',
    hungarian: 'izzani, parázslani',
    german: 'glühen, glimmen',
    dutch: 'gloeien',
    afrikaans: 'gloei (om te)',
    russian: 'светиться, гореть, сверкать',
    latvian: 'degt, kvēlot',
    polish: 'żarzyć, błyszczeć, świecić (poświata)',
    french: 'briller, rougeoyer',
    spanish: 'resplandecer',
  },
  {
    av: 24137,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to work + to protect + horse)',
    english: 'groom (horse)',
    swedish: 'hästskötare',
    norwegian: 'hestepasser',
    finnish: 'tallirenki',
    hungarian: 'lovász, lóápoló, istállófiú',
    german: 'Stallbursche, Stallknecht',
    dutch: 'verzorger (paard)',
    afrikaans: 'versorger, stalkneg (perd)',
    russian: 'конюх',
    latvian: 'zirgupuisis, zirgkopis',
    polish: 'stajenny, koniuszy',
    french: 'palefrenier, lad',
    spanish: 'mozo de cuadra',
  },
  {
    av: 24138,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(horse brush + action indicator)',
    english: 'groom (horse)-(to)',
    swedish: 'rykta',
    norwegian: 'stelle hest',
    finnish: 'sukia hevosta, harjata hevosta',
    hungarian: 'csutakolni, kefélni, tisztántartani (lovat)',
    german: 'striegeln',
    dutch: 'borstelen (paard)',
    afrikaans: 'versorg, kam, borsel (perd) (om te)',
    russian: 'чистить лошадь ',
    latvian: 'apkopt zirgu',
    polish: 'czyścić, oporządzać konia',
    french: 'panser, toiletter',
    spanish: 'cepillar un caballo',
  },
  {
    av: 24139,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + opposition + dog + action indicator)',
    english: 'growl (dog)-(to)',
    swedish: 'morra',
    norwegian: 'gjø',
    finnish: 'murista (koira)',
    hungarian: 'morogni (kutya)',
    german: 'brummen, knurren',
    dutch: 'grommen',
    afrikaans: 'grom (om te)',
    russian: 'рычать',
    latvian: 'ņurdēt, rūkt',
    polish: 'warczeć (pies)',
    french: 'grogner, gronder',
    spanish: 'gruñir (perro)',
  },
  {
    av: 24140,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + pig + action indicator)',
    english: 'grunt (pig)-(to)',
    swedish: 'grymta',
    norwegian: 'grynte',
    finnish: 'röhkiä',
    hungarian: 'röfögni ',
    german: 'grunzen',
    dutch: 'knorren',
    afrikaans: 'knor (om te)',
    russian: 'хрюкать',
    latvian: 'rukšķēt',
    polish: 'chrząkać (świnia)',
    french: 'grogner',
    spanish: 'gruñir (cerdo)',
  },
  {
    av: 24141,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + to dry + hair)',
    english: 'hair drier, blow dryer',
    swedish: 'hårtork',
    norwegian: 'hårtørrer',
    finnish: 'hiustenkuivaaja',
    hungarian: 'hajszárító',
    german: 'Föhn, Haartrockner',
    dutch: 'haardroger',
    afrikaans: 'haar droër',
    russian: 'фен',
    latvian: 'matu žāvētājs',
    polish: 'suszarka do włosów',
    french: 'sèche-cheveux',
    spanish: 'secador de pelo',
  },
  {
    av: 24142,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid + joint [contr ] + hand + thing indicator)',
    english: 'hand splint',
    swedish: 'handskena, handortos',
    norwegian: 'håndskinne',
    finnish: 'käsilasta',
    hungarian: 'kézsín',
    german: 'Armgurt, Handgelenkgurt',
    dutch: 'handspalk, spalk (hand)',
    afrikaans: 'hand spalk',
    russian: 'лучезапястный тутор',
    latvian: 'rokas šina',
    polish: 'szyna na rękę, opatrunek gipsowy na ręku',
    french: 'attelle de main',
    spanish: 'férula de mano, muñequera',
  },
  {
    av: 24143,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + linear thing + combination + thing indicator)',
    english: 'harness',
    swedish: 'sele, bälte',
    norwegian: 'sele (hest)',
    finnish: 'valjaat',
    hungarian: 'hám',
    german: 'Laufgurt',
    dutch: 'harnas',
    afrikaans: 'harnas',
    russian: 'упряжь, сбруя',
    latvian: 'raža',
    polish: 'uprząż, pasy bezpieczeństwa, pasy mocujące',
    french: 'harnachement',
    spanish: 'arreos',
  },
  {
    av: 24144,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(harness + action indicator + thing indicator)',
    english: 'harness-(to)',
    swedish: 'sätta på sele, sätta på bälte',
    norwegian: 'sette på sele, sette på belte',
    finnish: 'valjastaa',
    hungarian: 'felszerszámozni',
    german: 'anleinen',
    dutch: 'harnas aandoen',
    afrikaans: 'harnas (om te)',
    russian: 'запрягать',
    latvian: 'ievākt ražu',
    polish: 'zapiąć pasy, założyć uprząż ',
    french: 'harnacher, atteler',
    spanish: 'poner los arreos',
  },
  {
    av: 24145,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(harness + horse + thing indicator)',
    english: 'harness (horse)',
    swedish: 'seldon',
    norwegian: 'seletøy (hest)',
    finnish: 'hevosen valjaat',
    hungarian: 'lószerszám',
    german: 'Pferdegeschirr',
    dutch: 'gareel (paard)',
    afrikaans: 'harnas (perd)',
    russian: 'упряжка',
    latvian: 'iejūgts zirgs',
    polish: 'uprząż końska',
    french: 'harnachement du cheval',
    spanish: 'arreos',
  },
  {
    av: 24146,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(harness + horse + action indicator + thing indicator)',
    english: 'harness (horse)-(to)',
    swedish: 'sela på',
    norwegian: 'sele på (hest)',
    finnish: 'valjastaa hevonen',
    hungarian: 'felnyergelni',
    german: 'anschirren, zügeln',
    dutch: 'optuigen (paard), inspannen (paard)',
    afrikaans: 'inspan (perd) (om te)',
    russian: 'впрягать',
    latvian: 'iejūgt zirgu',
    polish: 'zaprząc konia',
    french: 'harnacher, atteler le cheval',
    spanish: 'enjaezar',
  },
  {
    av: 24147,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(grass + dry)',
    english: 'hay',
    swedish: 'hö',
    norwegian: 'høy',
    finnish: 'heinä',
    hungarian: 'széna',
    german: 'Stroh',
    dutch: 'hooi',
    afrikaans: 'hooi',
    russian: 'сено',
    latvian: 'siens',
    polish: 'siano',
    french: 'foin',
    spanish: 'heno',
  },
  {
    av: 24148,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to become + healthy + action indicator)',
    english: 'heal-(to)',
    swedish: 'läka, tillfriskna',
    norwegian: 'bli frisk, leges (å)',
    finnish: 'parantaa, parantua',
    hungarian: 'gyógyulni, meggyógyulni',
    german: 'heilen, gesund werden',
    dutch: 'genezen',
    afrikaans: 'genees (om gesond te word) (om te)',
    russian: 'исцелять',
    latvian: 'izārstēt',
    polish: 'zdrowieć, wyzdrowieć',
    french: 'guérir, cicatriser',
    spanish: 'sanar, curar',
  },
  {
    av: 24149,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(world + God)',
    english: 'Heaven, Kingdom of God',
    swedish: 'Himlen',
    norwegian: 'himmelrike, himmelen',
    finnish: 'Jumalan valtakunta, taivas',
    hungarian: 'mennyország, Isten birodalma',
    german: 'Himmel',
    dutch: 'hemel',
    afrikaans: 'hemel (Koninkryk van God)',
    russian: 'небеса (религия)',
    latvian: 'Paradīze, Dieva valstība',
    polish: 'Niebo, Raj',
    french: 'paradis, royaume de Dieu',
    spanish: 'Cielo, Reino de Dios',
  },
  {
    av: 24150,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sleep + winter)',
    english: 'hibernation',
    swedish: 'vinterdvala',
    norwegian: 'dvale',
    finnish: 'talviuni, horros',
    hungarian: 'lefagyasztás, lehűtés, hibernáció',
    german: 'Überwinterung, Winterschlaf',
    dutch: 'winterslaap',
    afrikaans: 'hiberneer',
    russian: 'зимняя спячка',
    latvian: 'ziemas guļa',
    polish: 'hibernacja, sen zimowy',
    french: 'hibernation',
    spanish: 'hibernación',
  },
  {
    av: 24151,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + opposition + cat + action indicator)',
    english: 'hiss (cat)-(to)',
    swedish: 'fräsa (katt)',
    norwegian: 'hvese (katt)',
    finnish: 'sähistä',
    hungarian: 'fújni, prüszkölni (macska)',
    german: 'zischen (Katze)',
    dutch: 'blazen (kat)',
    afrikaans: 'sis, blaas (kat) (om te)',
    russian: 'шипеть (кот)',
    latvian: 'šņākt, kaķa šņākšana',
    polish: 'syk kota (przeciwieństwo miauczenia)',
    french: 'cracher, souffler, feuler (félin)',
    spanish: 'bufar (gato)',
  },
  {
    av: 24152,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to fasten + animal + action indicator)',
    english: 'hitch, tie up, fix up-(to)',
    swedish: 'binda fast, tjudra',
    norwegian: 'tjore, binde fast',
    finnish: 'köyttää, sitoa',
    hungarian: 'befogni, megkötni',
    german: 'anbinden, festbinden',
    dutch: 'vastbinden (dier)',
    afrikaans: 'vasbind (om te)',
    russian: 'привязывать животное',
    latvian: 'piesiet, aizāķēt',
    polish: 'schwytać, pojmać zwierzę ',
    french: 'accrocher, attacher (animal)',
    spanish: 'enganchar, atar',
  },
  {
    av: 24153,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(homosexuality + description indicator)',
    english: 'homosexual',
    swedish: 'homosexuell',
    norwegian: 'homoseksuell, homofil',
    finnish: 'homoseksuaalinen',
    hungarian: 'homoszexuális',
    german: 'homosexuell',
    dutch: 'homoseksueel',
    afrikaans: 'homoseksueel',
    russian: 'гомосексуальный',
    latvian: 'homoseksuāls',
    polish: 'homoseksualne',
    french: 'homosexuel',
    spanish: 'homosexual',
  },
  {
    av: 24154,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + couple (male) + couple (female): combination of male and female homosexuality, representing homosexuality in general, either male or female)',
    english: 'homosexuality',
    swedish: 'homosexualitet',
    norwegian: 'homoseksualitet, homofili',
    finnish: 'homoseksuaalisuus',
    hungarian: 'homoszexualitás',
    german: 'Homosexualität',
    dutch: 'homosexualiteit',
    afrikaans: 'homoseksualiteit',
    russian: 'гомосексуальность',
    latvian: 'homoseksualitāte',
    polish: 'homoseksualizm',
    french: 'homosexualité',
    spanish: 'homosexualidad',
  },
  {
    av: 24156,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + hoof)',
    english: 'hoof pick',
    swedish: 'hovskrapa',
    norwegian: 'hovskrape',
    finnish: 'kaviorauta, kavionpuhdistusrauta',
    hungarian: 'körömkés (patkolókovácsé)',
    german: 'Hufkratzer',
    dutch: 'hoevenkrabber',
    afrikaans: 'hoef pik skoonmaker',
    russian: 'скребок для копыт',
    latvian: 'zirga nagu tīrītājs',
    polish: 'narzędzie do pielęgnacji kopyt',
    french: 'cure-pied',
    spanish: 'escarbacascos',
  },
  {
    av: 24157,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + horse)',
    english: 'horse box, stall',
    swedish: 'spilta, hästbox',
    norwegian: 'hesteboks, spilt',
    finnish: 'pilttuu',
    hungarian: 'lóállás, rekesz, box',
    german: 'Pferdebox, Stand',
    dutch: 'paardenstal, paardenbox',
    afrikaans: 'perde stal',
    russian: 'стойло',
    latvian: 'stallis',
    polish: 'stajnia, boks',
    french: 'box, stalle',
    spanish: 'trailer para caballos',
  },
  {
    av: 24158,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(brush + horse)',
    english: 'horse brush, body brush',
    swedish: 'ryktborste',
    norwegian: 'hestebørste, striglebørste',
    finnish: 'suka, hevosharja',
    hungarian: 'lókefe',
    german: 'Kardätsche',
    dutch: 'paardenborstel, borstel (paard), rosborstel',
    afrikaans: 'perde borsel, kam',
    russian: 'щётка для лошади',
    latvian: 'zirga birste',
    polish: 'zgrzebło, szczotka do czyszczenia koni',
    french: 'brosse (cheval)',
    spanish: 'cepillo para caballos',
  },
  {
    av: 24159,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + protection + horse)',
    english: 'horse cloth',
    swedish: 'hästtäcke',
    norwegian: 'hestedekke',
    finnish: 'loimi',
    hungarian: 'lótakaró, lóterítő ',
    german: 'Pferdedecke',
    dutch: 'paardendeken',
    afrikaans: 'perde kleed',
    russian: 'покрывало для лошади',
    latvian: 'zirga sega',
    polish: 'derka końska',
    french: 'couverture de cheval',
    spanish: 'manta para caballos',
  },
  {
    av: 24160,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(waste + horse)',
    english: 'horse droppings',
    swedish: 'hästspillning',
    norwegian: 'hestemøkk',
    finnish: 'hevosen lanta',
    hungarian: 'lótrágya',
    german: 'Pferdeäpfel',
    dutch: 'paardenuitwerpsel',
    afrikaans: 'perde mis',
    russian: 'лошадиный навоз',
    latvian: 'zirga mēsli',
    polish: 'końskie odchody',
    french: 'crottin de cheval',
    spanish: 'excremento de caballo',
  },
  {
    av: 24161,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(trailer, container transport + horse)',
    english: 'horse trailer, horsebox',
    swedish: 'hästtransport (kärra)',
    norwegian: 'hestehenger',
    finnish: 'hevoskuljetusvaunu, hevoskuljetusauto',
    hungarian: 'lószálíltó',
    german: 'Pferdekarre',
    dutch: 'trailer (paard)',
    afrikaans: 'perde sleepwa',
    russian: 'лошадиная повозка, телега',
    latvian: 'zirga pārvadājamais treileris',
    polish: 'przyczepa do przewozu koni',
    french: 'van',
    spanish: 'transporte para caballos',
  },
  {
    av: 24162,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + hair + horse)',
    english: 'horsehair',
    swedish: 'hästtagel',
    norwegian: 'hestehår',
    finnish: 'hevosenkarva',
    hungarian: 'lószőr',
    german: 'Rosshaar, Pferdehaar',
    dutch: 'paardenhaar',
    afrikaans: 'perde haar',
    russian: 'конский волос',
    latvian: 'zirgu astri',
    polish: 'końskie włosie',
    french: 'crin',
    spanish: 'crin (de caballo)',
  },
  {
    av: 24163,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + hoof)',
    english: 'horseshoe',
    swedish: 'hästsko',
    norwegian: 'hestesko',
    finnish: 'hevosenkenkä',
    hungarian: 'lópatkó, patkó',
    german: 'Hufeisen',
    dutch: 'hoefijzer',
    afrikaans: 'hoefyster',
    russian: 'подкова',
    latvian: 'pakavs',
    polish: 'podkowa',
    french: 'fer à cheval',
    spanish: 'herradura',
  },
  {
    av: 24164,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pin + horseshoe)',
    english: 'horseshoe nail',
    swedish: 'hästskosöm',
    norwegian: 'hesteskosøm',
    finnish: 'hevosenkenkänaula',
    hungarian: 'patkószög',
    german: 'Hufnagel',
    dutch: 'hoefnagel',
    afrikaans: 'perdeskoenspyker',
    russian: 'гвоздь для подковы',
    latvian: 'pakava naglas',
    polish: 'hufnal (podkowiak), gwóźdź do podkowy',
    french: 'clou de fer à cheval',
    spanish: 'clavo de herradura',
  },
  {
    av: 24165,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(a country that is a bridge between East and West)',
    english: 'Hungary',
    swedish: 'Ungern',
    norwegian: 'Ungarn',
    finnish: 'Unkari',
    hungarian: 'Magyarország',
    german: 'Ungarn',
    dutch: 'Hongarije',
    afrikaans: 'Hongarye',
    russian: 'Венгрия',
    latvian: 'Ungārija',
    polish: 'Węgry',
    french: 'Hongrie',
    spanish: 'Hungría',
  },
  {
    av: 24166,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(time + fast)',
    english: 'hurry, rush',
    swedish: 'brådska',
    norwegian: 'hastverk, hast',
    finnish: 'kiire',
    hungarian: 'sietség, hajsza, rohanás',
    german: 'Eile',
    dutch: 'haast, spoed',
    afrikaans: 'gou-gou, vinnig, haastig',
    russian: 'спешка, поспешность, торопливость',
    latvian: 'steiga',
    polish: 'pospiech, pęd',
    french: 'hâte, empressement',
    spanish: 'Prisa, apuro',
  },
  {
    av: 24167,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hurry + action indicator)',
    english: 'hurry, rush-(to)',
    swedish: 'skynda sig',
    norwegian: 'skynde seg',
    finnish: 'pitää kiirettä, kiirehtiä',
    hungarian: 'sietni',
    german: 'beeilen',
    dutch: 'haasten, opschieten',
    afrikaans: 'haas, gou, vinnig (om te)',
    russian: 'спешить, торопиться',
    latvian: 'steigties',
    polish: 'śpieszyć się, pędzić',
    french: 'hâter-(se), dépêcher-(se)',
    spanish: 'Apresurar, apresurarse',
  },
  {
    av: 24168,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(hurry + description indicator)',
    english: 'hurry (in a), hurried, rushed',
    swedish: 'bråttom',
    norwegian: 'travel',
    finnish: 'kiireinen',
    hungarian: 'sietős, sietősen, rohanva, kapkodva',
    german: 'eilig, es eilig haben',
    dutch: 'haastig, spoedig',
    afrikaans: 'haastig, vinnig, gou-gou',
    russian: 'торопливый',
    latvian: 'steigties, sasteigts',
    polish: 'pośpiesznie, w biegu',
    french: 'pressé',
    spanish: 'prisa (con)',
  },
  {
    av: 24169,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(therapy + activity + water)',
    english: 'hydrotherapy',
    swedish: 'vattenterapi',
    norwegian: 'vannterapi',
    finnish: 'vesiterapia',
    hungarian: 'hidroterápia',
    german: 'Hydrotherapie',
    dutch: 'hydrotherapie',
    afrikaans: 'hidroterapie',
    russian: 'гидротерапия',
    latvian: 'hidroterapija',
    polish: 'hydroterapia',
    french: 'hydrothérapie',
    spanish: 'hidroterapia',
  },
  {
    av: 24170,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(much + ice)',
    english: 'ice field',
    swedish: 'isfält',
    norwegian: 'isområde',
    finnish: 'jääkenttä',
    hungarian: 'jégmező',
    german: 'Eisfeld',
    dutch: 'ijsvlakte, ijsveld',
    afrikaans: 'ys veld',
    russian: 'ледяное поле ',
    latvian: 'ledus laukums',
    polish: 'lodowisko, pole lodowe',
    french: 'glace (banquise, patinoire)',
    spanish: 'pista de hielo',
  },
  {
    av: 24171,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mountain + ice)',
    english: 'iceberg',
    swedish: 'isberg',
    norwegian: 'isfjell',
    finnish: 'jäävuori',
    hungarian: 'jéghegy',
    german: 'Eisberg',
    dutch: 'ijsberg',
    afrikaans: 'ysberg',
    russian: 'айсберг',
    latvian: 'aisbergs',
    polish: 'góra lodowa, lodowiec',
    french: 'iceberg',
    spanish: 'iceberg',
  },
  {
    av: 24172,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(ability + self + description indicator)',
    english: 'independent',
    swedish: 'oberoende, självständig',
    norwegian: 'uavhengig, selvstendig',
    finnish: 'itsenäinen',
    hungarian: 'független, önálló',
    german: 'unabhängig, selbständig',
    dutch: 'onafhankelijk, zelfstandig',
    afrikaans: 'onafhanklik, sefstandig',
    russian: 'независимый',
    latvian: 'neatkarīgs',
    polish: 'niezależnie',
    french: 'indépendant',
    spanish: 'independiente',
  },
  {
    av: 24173,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + to see + description indicator)',
    english: 'invisible',
    swedish: 'osynlig',
    norwegian: 'usynlig',
    finnish: 'näkymätön',
    hungarian: 'láthatatlan',
    german: 'unsichtbar',
    dutch: 'onzichtbaar',
    afrikaans: 'onsigbaar, onsigbare',
    russian: 'невидимый',
    latvian: 'neredzams',
    polish: 'niewidoczny, niewidzialny',
    french: 'invisible',
    spanish: 'invisible',
  },
  {
    av: 24175,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + group of + spot: fur with small dots within larger rosette markings)',
    english: 'jaguar',
    swedish: 'jaguar',
    norwegian: 'jaguar',
    finnish: 'jaguaari',
    hungarian: 'jaguár',
    german: 'Jaguar',
    dutch: 'jaguar',
    afrikaans: 'jaguar',
    russian: 'ягуар',
    latvian: 'jaguārs',
    polish: 'jaguar (zwierzę)',
    french: 'jaguar',
    spanish: 'jaguar',
  },
  {
    av: 24177,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(combination + string + thing indicator)',
    english: 'knot',
    swedish: 'knut',
    norwegian: 'knute',
    finnish: 'solmu',
    hungarian: 'csomó, bog',
    german: 'Knoten',
    dutch: 'knoop (in de war)',
    afrikaans: 'knoop',
    russian: 'узел',
    latvian: 'mezgls',
    polish: 'węzeł',
    french: 'nœud (lien)',
    spanish: 'nudo',
  },
  {
    av: 24178,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limited time + before + Easter)',
    english: 'Lent',
    swedish: 'fastan',
    norwegian: 'fastetid, faste',
    finnish: 'paastoaika',
    hungarian: 'nagyböjt',
    german: 'Fastenzeit',
    dutch: 'vastentijd, vasten (christelijk)',
    afrikaans: 'Lent, vastyd',
    russian: 'Великий пост',
    latvian: 'Lielais gavēnis',
    polish: 'Wielki Post',
    french: 'carême (durée, période)',
    spanish: 'Cuaresma',
  },
  {
    av: 24179,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cause + freedom)',
    english: 'liberation',
    swedish: 'befrielse',
    norwegian: 'befrielse, frigjøring',
    finnish: 'vapautus, vapautuminen, liberaatio',
    hungarian: 'felszabadítás, megszabadulás, felszabadulás',
    german: 'Befreiung',
    dutch: 'bevrijding',
    afrikaans: 'bevryding',
    russian: 'освобождение',
    latvian: 'atbrīvošana, palaišana brīvībā',
    polish: 'oswobodzenie, wyzwolenie',
    french: 'salut',
    spanish: 'liberación',
  },
  {
    av: 24180,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(horizontal line + thing indicator) - (character with thing indicator)',
    english: 'linear thing (horizontal), bar',
    swedish: 'rak sak (vågrät), räcke, ribba',
    norwegian: 'rett sak (vannrett)',
    finnish: 'tanko, rekki',
    hungarian: 'rúd, egyenes tárgy (fekvő)',
    german: 'lineare, geradelinige Sache (waagerecht)',
    dutch: 'reep, horizontaal ding',
    afrikaans: 'lineêre voorwerp (horisontaal) voorwerp',
    russian: 'прямая вещь (горизонтальная)',
    latvian: 'lineārs, horizontāls stienis, barjera u.c.',
    polish: 'drążek, poręcz, prosty poziomy przedmiot, ',
    french: 'barre horizontale',
    spanish: 'barra, cosa lineal (horizontal)',
  },
  {
    av: 24181,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(limited time + long + description indicator)',
    english: 'long time',
    swedish: 'länge',
    norwegian: 'lenge',
    finnish: 'pitkä aika, kauan',
    hungarian: 'hosszú idő, hosszú ideje, régen',
    german: 'lange, langjährig',
    dutch: 'lange tijd',
    afrikaans: 'lang tyd',
    russian: 'долгий, длительный',
    latvian: 'ilgs laiks',
    polish: 'długo, przez długi czas',
    french: 'longtemps',
    spanish: 'mucho tiempo',
  },
  {
    av: 24182,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(below + waist)',
    english: 'lower body',
    swedish: 'underkropp, nedre kroppshalvan',
    norwegian: 'underkropp',
    finnish: 'alavartalo',
    hungarian: 'deréktól lefelé, a test alsó része',
    german: 'Unterkörper',
    dutch: 'onderlichaam',
    afrikaans: 'laer liggaam',
    russian: 'нижняя часть тела',
    latvian: 'ķermeņa apakšdaļa',
    polish: 'dolne części ciała',
    french: 'partie inférieure du corps, bas du corps',
    spanish: 'parte inferior del cuerpo',
  },
  {
    av: 24183,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(sign of the cross + action indicator)',
    english: 'make sign of the cross-(to)',
    swedish: 'göra korstecken',
    norwegian: 'gjøre korsets tegn, korse seg',
    finnish: 'tehdä ristin merkki',
    hungarian: 'keresztet vetni',
    german: 'bekreuzigen',
    dutch: 'kruisteken maken',
    afrikaans: 'kruisteken maak (om te)',
    russian: 'перекреститься',
    latvian: 'pārmest krustu, pārkrustīties',
    polish: 'przeżegnać się',
    french: 'faire le signe de croix',
    spanish: 'hacer el signo de la cruz',
  },
  {
    av: 24184,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hair + horse neck)',
    english: 'mane (horse)',
    swedish: 'man (häst)',
    norwegian: 'man (hest)',
    finnish: 'hevosen harja',
    hungarian: 'ló sörénye, sörény',
    german: 'Mähne (Pferd)',
    dutch: 'manen (paard)',
    afrikaans: 'maanhare (perd)',
    russian: 'грива',
    latvian: 'krēpes',
    polish: 'grzywa (końska)',
    french: 'crinière',
    spanish: 'crin (caballo)',
  },
  {
    av: 24185,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(addition + to grow + thing indicator)',
    english: 'manure, fertilizer',
    swedish: 'gödning, gödsel',
    norwegian: 'gjødsel',
    finnish: 'lannoite, lanta, apulanta',
    hungarian: 'trágya, műtrágya',
    german: 'Dünger, Düngemittel',
    dutch: 'humus',
    afrikaans: 'mis, kunsmis',
    russian: 'навоз, удобрение',
    latvian: 'mēsli, mēslojums, kūtsmēsli',
    polish: 'nawóz, obornik',
    french: 'engrais, fumier',
    spanish: 'abono, fertilizante',
  },
  {
    av: 24186,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(horse + female)',
    english: 'mare',
    swedish: 'sto',
    norwegian: 'merr',
    finnish: 'tamma',
    hungarian: 'kanca',
    german: 'Stute',
    dutch: 'merrie',
    afrikaans: 'merrie',
    russian: 'кобыла',
    latvian: 'ķēve',
    polish: 'klacz',
    french: 'jument',
    spanish: 'yegua',
  },
  {
    av: 24187,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + dry)',
    english: 'meat (dried), dried meat',
    swedish: 'kött (torkat)',
    norwegian: 'mat (tørket)',
    finnish: 'liha (kuivattu)',
    hungarian: 'szárított hús',
    german: 'getrocknetes Fleisch',
    dutch: 'gedroogd vlees',
    afrikaans: 'gedroogde vleis, biltong',
    russian: 'мясо (сушёное)',
    latvian: 'gaļa, kaltēta, žāvēta',
    polish: 'mięso suszone',
    french: 'viande séchée',
    spanish: 'carne seca',
  },
  {
    av: 24188,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(help + medical)',
    english: 'medical treatment, medical care',
    swedish: 'behandling (medicinsk), sjukvård',
    norwegian: 'behandling medisinsk',
    finnish: 'lääkinnällinen hoito',
    hungarian: 'egészségügyi ellátás, egészségügyi kezelés',
    german: 'medizinische Behandlung, ärztliche Behandlung',
    dutch: 'medische hulp, medische behandeling',
    afrikaans: 'mediese behandeling, mediese bystand',
    russian: 'медицинская помощь ',
    latvian: 'ārstniecība, medicīniskā aprūpe',
    polish: 'pomoc lekarska',
    french: 'traitement médical',
    spanish: 'tratamiento médico, asistencia médica',
  },
  {
    av: 24189,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(blood + uterus [contr.])',
    english: 'menstrual blood',
    swedish: 'mensblod',
    norwegian: 'blod menstruelt',
    finnish: 'kuukautisveri',
    hungarian: 'menstruációs vér',
    german: 'Menstruationsblut',
    dutch: 'menstruatiebloed',
    afrikaans: 'menstruasie bloed',
    russian: 'менструальная кровь',
    latvian: 'menstruālās asinis',
    polish: 'krew menstruacyjna',
    french: 'menstruation, règles',
    spanish: 'flujo menstrual',
  },
  {
    av: 24190,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(craft + metal [contr.])',
    english: 'metal craft',
    swedish: 'metallslöjd',
    norwegian: 'metallsløyd, metallhåndverk',
    finnish: 'metallityö',
    hungarian: 'fémmegmunkálás',
    german: 'Metallbearbeitung',
    dutch: 'metalen kunst',
    afrikaans: 'metaal kuns',
    russian: 'ремесло по металлу',
    latvian: 'metāla amatniecība',
    polish: 'obróbka metalu',
    french: 'ferronnerie artisanale',
    spanish: 'artesanía de metal',
  },
  {
    av: 24191,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + cat + action indicator)',
    english: 'mew, meow-(to)',
    swedish: 'jama',
    norwegian: 'mjaue',
    finnish: 'naukua',
    hungarian: 'nyávogni',
    german: 'miauen',
    dutch: 'miauwen',
    afrikaans: 'miaau (om te)',
    russian: 'мяукать',
    latvian: 'ņaudēt',
    polish: 'miauczeć',
    french: 'miauler',
    spanish: 'miau, maullar',
  },
  {
    av: 24192,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(leader + country)',
    english: 'minister (government)',
    swedish: 'minister',
    norwegian: 'minister',
    finnish: 'ministeri',
    hungarian: 'miniszter',
    german: 'Minister, Ministerin (Regierung)',
    dutch: 'minister',
    afrikaans: 'minister (goewerment)',
    russian: 'министр',
    latvian: 'ministrs, valdība',
    polish: 'minister (rząd)',
    french: 'ministre (gouvernement)',
    spanish: 'ministro (gobierno)',
  },
  {
    av: 24193,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + royal)',
    english: 'monarchy',
    swedish: 'monarki',
    norwegian: 'monarki',
    finnish: 'monarkia',
    hungarian: 'királyság, monarchia',
    german: 'Monarchie',
    dutch: 'monarchie, koningschap',
    afrikaans: 'monargie',
    russian: 'монархия',
    latvian: 'monarhija',
    polish: 'monarchia',
    french: 'monarchie',
    spanish: 'monarquía',
  },
  {
    av: 24194,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + cow + action indicator)',
    english: 'moo, bellow-(to)',
    swedish: 'råma',
    norwegian: 'raute',
    finnish: 'ammua',
    hungarian: 'bőgni (tehén)',
    german: 'muhen',
    dutch: 'loeien',
    afrikaans: 'loei, moo (om te)',
    russian: 'мычать',
    latvian: 'maurot',
    polish: 'muczeć (jak krowa)',
    french: 'meugler',
    spanish: 'mugir',
  },
  {
    av: 24195,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + mother)',
    english: "Mother's Day",
    swedish: 'Mors dag',
    norwegian: 'morsdag',
    finnish: 'äitienpäivä',
    hungarian: 'Anyák napja',
    german: 'Muttertag',
    dutch: 'moederdag',
    afrikaans: 'Moeders dag',
    russian: 'День матери',
    latvian: 'Mātes diena',
    polish: 'Dzień Matki',
    french: 'fête des mères, jour des mères',
    spanish: 'Día de la madre',
  },
  {
    av: 24197,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(craft + plant)',
    english: 'nature craft',
    swedish: 'naturslöjd',
    norwegian: 'naturprodukt',
    finnish: 'taidekäsityö',
    hungarian: 'virágkészítés??',
    german: 'Naturhandwerk',
    dutch: 'kunst (natuuurlijk materiaal)',
    afrikaans: 'natuurlike kuns',
    russian: 'изделие из природного материала',
    latvian: 'dabas māksla',
    polish: 'ogrodnictwo',
    french: 'art floral',
    spanish: 'artesanía natural',
  },
  {
    av: 24199,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + horse + action indicator)',
    english: 'neigh, whinny-(to)',
    swedish: 'gnägga',
    norwegian: 'vrinske',
    finnish: 'hirnua',
    hungarian: 'nyeríteni',
    german: 'wiehern',
    dutch: 'hinniken',
    afrikaans: 'runnik (om te)',
    russian: 'ржать',
    latvian: 'zviegt, grudzināt',
    polish: 'rżeć',
    french: 'hennir',
    spanish: 'relinchar',
  },
  {
    av: 24200,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(therapy + activity)',
    english: 'occupational therapy',
    swedish: 'arbetsterapi',
    norwegian: 'arbeidsterapi',
    finnish: 'toimintaterapia',
    hungarian: 'foglalkozásterápia, foglalkoztató terápia',
    german: 'Ergotherapie',
    dutch: 'ergotherapie, bezigheidstherapie',
    afrikaans: 'arbeidsterapie ',
    russian: 'трудотерапия',
    latvian: 'darba terapija',
    polish: 'terapia zajęciowa',
    french: 'ergothérapie',
    spanish: 'terapia ocupacional',
  },
  {
    av: 24201,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + occupational therapy)',
    english: 'occupational therapy room',
    swedish: 'arbetsterapirum',
    norwegian: 'arbeidsterapirom',
    finnish: 'toimintaterapiahuone, toimintaterapeutin huone',
    hungarian: 'foglalkozásterápiás szoba',
    german: 'Ergotherapiezimmer',
    dutch: 'bezigheidstherapieruimte, ergotherapielokaal',
    afrikaans: 'arbeidsterapie kamer',
    russian: 'комната трудовой терапии',
    latvian: 'darbas terapijas telpa',
    polish: 'sala terapii zajęciowej',
    french: "salle d'ergothérapie",
    spanish: 'sala de terapia ocupacional',
  },
  {
    av: 24203,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + field + small)',
    english: 'paddock',
    swedish: 'fålla, inhägnad',
    norwegian: 'havnehage',
    finnish: 'aitaus, aidattu niitty',
    hungarian: 'bekerített kifutó, bekerített legelő, nyergelő',
    german: 'Koppel',
    dutch: 'wei, kraal (wei)',
    afrikaans: 'kamp, kraal',
    russian: 'загон',
    latvian: 'aploks',
    polish: 'padok, wybieg (mała ogrodzona łąka)',
    french: 'paddock, enclos',
    spanish: 'corral',
  },
  {
    av: 24204,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(craft + paper)',
    english: 'paper craft',
    swedish: 'pappersslöjd, pappslöjd',
    norwegian: 'papirsløyd, pappsløyd',
    finnish: 'paperityö',
    hungarian: 'papírművesség',
    german: 'Papierhandwerk',
    dutch: 'papierkunst, kunst (papier)',
    afrikaans: 'papier handwerk (kuns)',
    russian: 'бумажное ремесло',
    latvian: 'papīra amatniecība',
    polish: 'rękodzieło z papieru (origami itp.)',
    french: 'art du papier',
    spanish: 'artesanía de papel',
  },
  {
    av: 24205,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(harness + parachute + thing indicator)',
    english: 'parachute harness',
    swedish: 'fallskärmssele',
    norwegian: 'fallskjermsele',
    finnish: 'laskuvarjon valjaat',
    hungarian: 'ejtőernyőkantár, ejtőernyő heveder',
    german: 'Fallschirmgurt',
    dutch: 'harnas (parachute)',
    afrikaans: 'valskerm harnas',
    russian: 'парашютные ремни безопасности',
    latvian: 'izpletņlēkšanas piederumi',
    polish: 'uprzęż spadochronowa',
    french: 'harnais de parachute',
    spanish: 'arnés de paracaídas',
  },
  {
    av: 24206,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + vehicle)',
    english: 'parking lot',
    swedish: 'parkeringsplats',
    norwegian: 'parkeringsplass',
    finnish: 'pysäköintialue, parkkipaikka, paikoitusalue',
    hungarian: 'parkoló (fn.)',
    german: 'Parkplatz',
    dutch: 'parkeerterrein',
    afrikaans: 'parkeerterrein',
    russian: 'стоянка для машин',
    latvian: 'automašīnu stāvvieta',
    polish: 'parking',
    french: 'aire de stationnement',
    spanish: 'sitio de aparcamiento',
  },
  {
    av: 24207,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + permission, allowance + travel)',
    english: 'passport',
    swedish: 'pass',
    norwegian: 'pass',
    finnish: 'passi',
    hungarian: 'útlevél',
    german: 'Pass, Reisepass',
    dutch: 'paspoort',
    afrikaans: 'paspoort',
    russian: 'паспорт',
    latvian: 'pase',
    polish: 'paszport',
    french: 'passeport',
    spanish: 'pasaporte',
  },
  {
    av: 24208,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(enclosure + field)',
    english: 'pasture, enclosed field',
    swedish: 'hage, inhägnad',
    norwegian: 'beite',
    finnish: 'aitaus, keto',
    hungarian: 'legelő, körülkerített mező',
    german: 'Wiese, Weide, Weideland',
    dutch: 'wei, weide',
    afrikaans: 'weiding, geslote veld',
    russian: 'пастбище',
    latvian: 'ganības, aploks',
    polish: 'pastwisko, ogrodzona łąka',
    french: 'pâturage, herbage, champ',
    spanish: 'pastos, parcela',
  },
  {
    av: 24209,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(platform + to walk)',
    english: 'pavement, sidewalk',
    swedish: 'trottoar',
    norwegian: 'fortau',
    finnish: 'jalkakäytävä',
    hungarian: 'járda',
    german: 'Gehsteig',
    dutch: 'stoep, trottoir, voetpad',
    afrikaans: 'sypaadjie',
    russian: 'тротуар',
    latvian: 'ietve',
    polish: 'chodnik',
    french: 'trottoir',
    spanish: 'pavimento, acera',
  },
  {
    av: 24211,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(therapy + muscle)',
    english: 'physiotherapy',
    swedish: 'sjukgymnastik',
    norwegian: 'fysioterapi',
    finnish: 'fysioterapia',
    hungarian: 'gyógytorna, fizioterápia, mozgásfejlesztés',
    german: 'Physiotherapie',
    dutch: 'kinesitherapie (VL), fysiotherapie (Nl)',
    afrikaans: 'fisioterapie',
    russian: 'лечебная физкультура (ЛФК)',
    latvian: 'fizioterapija',
    polish: 'fizjoterapia',
    french: 'kinésithérapie, physiothérapie',
    spanish: 'fisioterapia',
  },
  {
    av: 24212,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + physiotherapy)',
    english: 'physiotherapy room',
    swedish: 'sjukgymnastikrum',
    norwegian: 'fysioterapirom',
    finnish: 'fysioterapiahuone, fysioterapeutin huone',
    hungarian: 'mozgásfejlesztő szoba',
    german: 'Physiotherpieraum',
    dutch: 'fysiotherapie-ruimte, kine-lokaal',
    afrikaans: 'fisioterapie kamer',
    russian: 'комната ЛФК',
    latvian: 'fizioterapijas telpa',
    polish: 'sala fizjoterapii',
    french: 'salle de kinésithérapie, salle de physiothérapie',
    spanish: 'sala de fisioterapia',
  },
  {
    av: 24215,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + politics)',
    english: 'politician',
    swedish: 'politiker',
    norwegian: 'politiker',
    finnish: 'poliitikko',
    hungarian: 'politikus (fn.)',
    german: 'Politiker, Politikerin',
    dutch: 'politicus',
    afrikaans: 'politikus',
    russian: 'политик',
    latvian: 'pilitiķis, -e',
    polish: 'polityk',
    french: 'politicien',
    spanish: 'político',
  },
  {
    av: 24217,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(harness + baby + thing indicator)',
    english: 'pram straps, safety harness',
    swedish: 'babysele, barnvagnssele',
    norwegian: 'sikkerhetssele baby',
    finnish: 'turvavaljaat, vauvan valjaat',
    hungarian: 'babakocsi biztonsági öve',
    german: 'Sicherheitsgurt für den Kinderwagen',
    dutch: 'riem voor kinderwagen',
    afrikaans: 'stootwaentjie bande, veiligheidsharnas',
    russian: 'ремни безопасности для детей',
    latvian: 'bērnu ratiņu drošības siksnas',
    polish: 'pasy przy wózku, pasy bezpieczeństwa dla dziecka',
    french: 'harnais de landau',
    spanish: 'arnés de seguridad',
  },
  {
    av: 24218,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(first + in front of + description indicator) Preferred NEW SYNONYM, replacing 16239',
    english: 'preceding, previous, former, earlier',
    swedish: 'föregående',
    norwegian: 'foregående, tidligere',
    finnish: 'edellinen, edeltäjä',
    hungarian: 'előbbi, előző, megelőző, korábbi',
    german: 'vorhergehend',
    dutch: 'eerder, vorige',
    afrikaans: 'voorafgaande, vorige, vroeër',
    russian: 'передыдущий, предшествуюший',
    latvian: 'iepriekšējais, bijušais, agrākais',
    polish: 'poprzedni, wcześniejszy',
    french: 'précédent, antécédent (adj)',
    spanish: 'anterior, primero, antes',
  },
  {
    av: 24219,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + medicine)',
    english: 'prescription',
    swedish: 'recept (på läkemedel)',
    norwegian: 'resept',
    finnish: 'lääkemääräys, resepti',
    hungarian: 'recept',
    german: 'Rezept (Medikamente)',
    dutch: 'voorschrift',
    afrikaans: 'voorskrif',
    russian: 'рецепт',
    latvian: 'recepte, zāļu',
    polish: 'recepta',
    french: 'prescription médicale, ordonnance médicale',
    spanish: 'prescripción',
  },
  {
    av: 24220,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(chairman + country)',
    english: 'president',
    swedish: 'president',
    norwegian: 'president',
    finnish: 'presidentti',
    hungarian: 'államelnök',
    german: 'Präsident',
    dutch: 'president',
    afrikaans: 'president',
    russian: 'президент',
    latvian: 'prezidents',
    polish: 'prezydent, przywódca państwa',
    french: "président d'un pays",
    spanish: 'presidente',
  },
  {
    av: 24221,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(leader + country + first)',
    english: 'prime minister',
    swedish: 'statsminister',
    norwegian: 'statsminister',
    finnish: 'pääministeri',
    hungarian: 'miniszterelnök',
    german: 'Ministerpräsident, Ministerpräsidentin',
    dutch: 'minister president, premier, eerste minister',
    afrikaans: 'eerste minister',
    russian: 'премьер министр',
    latvian: 'premjerministrs',
    polish: 'premier',
    french: 'premier ministre',
    spanish: 'primer ministro',
  },
  {
    av: 24222,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + plan + future: e.g. radio and tv)',
    english: 'program, programme',
    swedish: 'program',
    norwegian: 'program',
    finnish: 'ohjelmalehtinen',
    hungarian: 'program',
    german: 'Programm',
    dutch: 'programma',
    afrikaans: 'program',
    russian: 'программа, план',
    latvian: 'programma, izrādes, uzveduma',
    polish: 'program, plan (imprezy, konferencji)',
    french: 'programme (écrit)',
    spanish: 'programa',
  },
  {
    av: 24223,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(protection + description after the fact indicator)',
    english: 'protected, saved',
    swedish: 'fridlyst, skyddad',
    norwegian: 'beskyttet, reddet',
    finnish: 'suojeltu, rauhoitettu',
    hungarian: 'védett',
    german: 'geschützt, gerettet',
    dutch: 'beschermd',
    afrikaans: 'beskermd, gered',
    russian: 'защищённый, охраняемый',
    latvian: 'aizsargāts, saglabāts',
    polish: 'chronione',
    french: 'protégé',
    spanish: 'protegido, guardado',
  },
  {
    av: 24224,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + environment)',
    english: 'protection of the environment',
    swedish: 'miljövård, naturskydd',
    norwegian: 'miljøvern',
    finnish: 'ympäristönsuojelu',
    hungarian: 'környezetvédelem',
    german: 'Bewahrung, Umweltschutz',
    dutch: 'landschapsbescherming',
    afrikaans: 'beskerming van die omgewing',
    russian: 'защита окружающей среды',
    latvian: 'vides aizsardzība',
    polish: 'ochrona środowiska',
    french: "protection de l'environnement",
    spanish: 'protección del medioambiente',
  },
  {
    av: 24225,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plum + dry) Preferred NEW SYNONYM, replacing 16424',
    english: 'prune',
    swedish: 'katrinplommon',
    norwegian: 'sviske',
    finnish: 'kuivattu luumu',
    hungarian: 'aszalt szilva',
    german: 'Backpflaume, Dörrpflaume',
    dutch: 'pruim (gedroogd)',
    afrikaans: 'snoei',
    russian: 'чернослив',
    latvian: 'žāvēta plūme',
    polish: 'suszona śliwka',
    french: 'pruneau',
    spanish: 'podar',
  },
  {
    av: 24226,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + psychology (class))',
    english: 'psychology room',
    swedish: 'psykologrum',
    norwegian: 'psykologirom',
    finnish: 'psykologin huone',
    hungarian: 'pszichológia szoba',
    german: 'Psychologenraum',
    dutch: 'spreekkamer (psycholoog), lokaal (psycholoog)',
    afrikaans: 'sielkunde spreekkamer',
    russian: 'комната психолога',
    latvian: 'psihologa telpa',
    polish: 'gabinet psychologiczny',
    french: 'salle de psychologie',
    spanish: 'sala de psicología',
  },
  {
    av: 24227,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + bus)',
    english: 'public transport',
    swedish: 'kollektivtrafik',
    norwegian: 'offentlig transport, kollektivtransport',
    finnish: 'joukkoliikenne, yleiset kulkuneuvot',
    hungarian: 'tömegközlekedés',
    german: 'öffentlicher Nahverkehr',
    dutch: 'openbaar vervoer',
    afrikaans: 'Publieke vervoer',
    russian: 'общественный транспорт',
    latvian: 'sabiedriskais transports',
    polish: 'transport publiczny',
    french: 'transports en commun, transports publics',
    spanish: 'transporte público',
  },
  {
    av: 24228,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + feeling + cat + action indicator)',
    english: 'purr (cat)-(to)',
    swedish: 'spinna (katt)',
    norwegian: 'male (katt)',
    finnish: 'kehrätä',
    hungarian: 'dorombolni',
    german: 'schnurren (Katze)',
    dutch: 'spinnen (kat)',
    afrikaans: 'purr, spin (om te)',
    russian: 'мурлыкать',
    latvian: 'murrāt',
    polish: 'mruczenie kota',
    french: 'ronronner',
    spanish: 'ronronear (gato)',
  },
  {
    av: 24230,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(horse + Iceland + action indicator: a pace typical for Icelandic horses)',
    english: 'rack, single-foot-(to)',
    swedish: 'tölta',
    norwegian: 'gå passgang, tølte',
    finnish: 'kulkea tasakäyntiä',
    hungarian: 'poroszkálni (ló)',
    german: 'Tölt',
    dutch: 'jagen (ijslandse paarden)',
    afrikaans: 'stadig draf, trippel (Yslandse perde) (om te)',
    russian: 'ходить с важным видом, стойка (?)',
    latvian: 'stends, statīvs, balsts',
    polish: 'inochód (rodzaj chodu u koni)',
    french: "aller à l'amble (allure du cheval islandais)",
    spanish: 'aire en que cada casco toca el suelo por separado',
  },
  {
    av: 24231,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(grape, grapes + dry) Preferred NEW SYNONYM, replacing 16460',
    english: 'raisin(s), currant(s)',
    swedish: 'russin',
    norwegian: 'rosin, korint',
    finnish: 'rusina, korintti',
    hungarian: 'mazsola',
    german: 'Rosine',
    dutch: 'rozijn',
    afrikaans: 'rosyne, korente',
    russian: 'изюм',
    latvian: 'rozīnes, jāņogas',
    polish: 'rodzynki',
    french: 'raisins secs',
    spanish: 'pasas',
  },
  {
    av: 24232,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + dot + body: where body represents skin [contr.])',
    english: 'rash (skin)',
    swedish: 'utslag',
    norwegian: 'utslett (hud)',
    finnish: 'ihottuma',
    hungarian: 'bőrkiütés, kiütés, pörsenés',
    german: 'Ausschlag (Haut)',
    dutch: 'huiduitslag, eczeem',
    afrikaans: 'uitslag (vel)',
    russian: 'сыпь',
    latvian: 'izsitumi, ādas',
    polish: 'wysypka na ciele',
    french: 'éruption, rougeur',
    spanish: 'sarpullido (piel)',
  },
  {
    av: 24233,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to dry + land + action indicator)',
    english: 'reclaim (marshes etc)-(to)',
    swedish: 'torrlägga, dränera',
    norwegian: 'drenere, tørrlegge',
    finnish: 'kuivata suota',
    hungarian: 'visszanyerni, visszahódítani földet, lecsapolni',
    german: 'Land wieder kulturfähig machen, Land trockenlegen ',
    dutch: 'terugvorderen (moeras)',
    afrikaans: 'herwin, terugneem (om te)',
    russian: 'осушать (болото и пр.)',
    latvian: 'atgūt, nosusināt',
    polish: 'osuszać (ziemię np. bagno)',
    french: 'assécher, drainer',
    spanish: 'drenar',
  },
  {
    av: 24234,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(fanatic + religion)',
    english: 'religious fanatic',
    swedish: 'fanatiker (religiös)',
    norwegian: 'fanatiker (religiøs)',
    finnish: 'uskonnollinen fanaatikko',
    hungarian: 'vallási fanatikus',
    german: 'Fanatiker, Fanatikerin (religiös)',
    dutch: 'fanaticus (religieus), fanaat (religieus)',
    afrikaans: 'godsdiens fanatikus',
    russian: 'религиозный фанатик',
    latvian: 'reliģiozs fanātiķis, reliģioza fanātiķe',
    polish: 'fanatyk religijny (dowolnej religii)',
    french: 'fanatique (naturalisme)',
    spanish: 'fanático religioso',
  },
  {
    av: 24235,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(fanatic + religion (God based))',
    english: 'religious fanatic (God based)',
    swedish: 'fanatiker (religiös, gudsbaserad)',
    norwegian: 'fanatiker (religiøs, tro på Gud)',
    finnish: 'uskonnollinen fanaatikko',
    hungarian: 'vallási fanatikus (Istenhívő)',
    german: 'Fanatiker, Fanatikerin (religiös, basiert auf Gott)',
    dutch: 'fanaticus (religieus), fanaat (religieus)',
    afrikaans: 'godsdiens fanatikus (God gebaseer)',
    russian: 'религиозный фанатик (церковь)',
    latvian: 'reliģiozs fanātiķis, dievticīgs',
    polish: 'fanatyk religijny (w religii opartej na Bogu)',
    french: 'fanatique religieux (basé sur dieu)',
    spanish: 'fanático religioso (basado en un Dios)',
  },
  {
    av: 24236,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + to repair)',
    english: 'repair room',
    swedish: 'verkstad (rum)',
    norwegian: 'verksted (rom)',
    finnish: 'korjaushuone, askarteluhuone',
    hungarian: 'barkácsműhely',
    german: 'Werkstatt (Raum)',
    dutch: 'herstellingsplaats (lokaal)',
    afrikaans: 'herstelkamer',
    russian: 'ремонтный цех',
    latvian: 'remontēt istabu',
    polish: 'warsztat (pomieszczenie)',
    french: 'atelier de réparation (local)',
    spanish: 'sala de reparaciones',
  },
  {
    av: 24237,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + to repair)',
    english: 'repair shop',
    swedish: 'verkstad (byggnad)',
    norwegian: 'verksted',
    finnish: 'verstas, korjaamo',
    hungarian: 'javítóműhely',
    german: 'Werkstatt (Gebäude)',
    dutch: 'herstellingsplaats (gebouw)',
    afrikaans: 'herstelwinkel',
    russian: 'ремонтная мастерская',
    latvian: 'remontdarbu veikals',
    polish: 'warsztat naprawczy (punkt usługowy)',
    french: 'atelier de réparation',
    spanish: 'taller',
  },
  {
    av: 24238,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + leader + choice)',
    english: 'republic',
    swedish: 'republik',
    norwegian: 'republikk',
    finnish: 'tasavalta',
    hungarian: 'köztársaság',
    german: 'Republik',
    dutch: 'republiek',
    afrikaans: 'republiek',
    russian: 'република',
    latvian: 'republika',
    polish: 'republika',
    french: 'république',
    spanish: 'república',
  },
  {
    av: 24239,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + breath)',
    english: 'respirator',
    swedish: 'respirator',
    norwegian: 'respirator',
    finnish: 'hengityslaite',
    hungarian: 'lélegeztetőgép',
    german: 'Respirator, Atmungsübungsgerät',
    dutch: 'beademingstoestel',
    afrikaans: 'respirator, asemhalingstoestel',
    russian: 'респиратор',
    latvian: 'respirators',
    polish: 'respirator',
    french: "appareil d'assistance respiratoire",
    spanish: 'respirador',
  },
  {
    av: 24241,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(responsibility + description indicator)',
    english: 'responsible',
    swedish: 'ansvarig, ansvarsfull',
    norwegian: 'ansvarlig, ansvarsfull',
    finnish: 'vastuullinen',
    hungarian: 'felelős (mn.)',
    german: 'verantwortlich',
    dutch: 'verantwoordelijk',
    afrikaans: 'verantwoordelik',
    russian: 'ответственный',
    latvian: 'atbildīgs, -a',
    polish: 'odpowiedzialny',
    french: 'responsable',
    spanish: 'responsable',
  },
  {
    av: 24242,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(resurrection + Christ)',
    english: 'Resurrection of Christ',
    swedish: 'Kristi uppståndelse',
    norwegian: 'Kristi oppstandelse',
    finnish: 'Jeesuksen ylösnousemus, Kristuksen ylösnousemus',
    hungarian: 'Jézus feltámadása',
    german: 'Auferstehung von Jesu Christi',
    dutch: 'Verrijzenis van Christus',
    afrikaans: 'Opstanding van Christus',
    russian: 'Воскресение Христа',
    latvian: 'Kristus Augšāmcelšanās',
    polish: 'zmartwychwstanie Jezusa',
    french: 'Résurrection (du Christ)',
    spanish: 'resurrección de Cristo',
  },
  {
    av: 24243,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boots + horse: where horse represents riding [contr.])',
    english: 'riding boots',
    swedish: 'ridstövlar',
    norwegian: 'ridestøvler',
    finnish: 'ratsastussaappaat',
    hungarian: 'lovaglócsizma',
    german: 'Reitstiefel',
    dutch: 'rijlaars',
    afrikaans: 'rystewels',
    russian: 'сапоги для верховой езды',
    latvian: 'jāšanas zābaki',
    polish: 'oficerki (buty do jazdy konnej)',
    french: "botte d'équitation",
    spanish: 'botas de montar',
  },
  {
    av: 24244,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothes + horse: where horse represents riding [contr.])',
    english: 'riding clothes',
    swedish: 'ridkläder',
    norwegian: 'rideklær',
    finnish: 'ratsastusvaatteet',
    hungarian: 'lovaglóruha',
    german: 'Reitbekleidung',
    dutch: 'paardrijkledij',
    afrikaans: 'ryklere',
    russian: 'одежда для верховой езды',
    latvian: 'jāšanas apģērbs',
    polish: 'strój do jazdy konnej',
    french: "tenue d'équitation",
    spanish: 'ropa de montar',
  },
  {
    av: 24245,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(teacher [contr.] + horse: where horse represents riding [contr.])',
    english: 'riding instructor',
    swedish: 'ridlärare',
    norwegian: 'rideinstruktør',
    finnish: 'ratsastuksenohjaaja',
    hungarian: 'lovasoktató',
    german: 'Reitlehrer, Reitlehrerin',
    dutch: 'paardrijinstructeur',
    afrikaans: 'ry instrukteur',
    russian: 'инструктор верховой езды',
    latvian: 'jāšanas instruktors',
    polish: 'instruktor jazdy konnej, instruktor jeździecki',
    french: "moniteur d'équitation",
    spanish: 'profesor de equitación',
  },
  {
    av: 24246,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + knowledge + horse: a place for training)',
    english: 'riding school, manege',
    swedish: 'ridbana, manege',
    norwegian: 'ridehall, manesje',
    finnish: 'ratsastuskoulu, maneesi',
    hungarian: 'lovasiskola',
    german: 'Reitschule, Manege',
    dutch: 'manege',
    afrikaans: 'perdryskool',
    russian: 'школа верховой езды, манеж',
    latvian: 'jāšanas skola, manēža',
    polish: 'ujeżdżalnia, maneż, szkoła jazdy',
    french: "école d'équitation, manège",
    spanish: 'picadero, escuela de monta',
  },
  {
    av: 24247,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + activity + vehicle) SYMBOL SYNONYM',
    english: 'road (2)',
    swedish: 'väg, körbana (2)',
    norwegian: 'vei, kjørebane (2)',
    finnish: 'maantie',
    hungarian: 'út',
    german: 'Landstraße (2)',
    dutch: 'weg (straat), straat (2)',
    afrikaans: 'straat, pad, hoofweg (2)',
    russian: 'дорога (2)',
    latvian: 'ceļš (2)',
    polish: 'droga (2)',
    french: 'route (2)',
    spanish: 'carretera (2)',
  },
  {
    av: 24248,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to talk + lion + action indicator)',
    english: 'roar (lion)-(to)',
    swedish: 'ryta (lejon)',
    norwegian: 'brøle (løve)',
    finnish: 'karjua (leijona)',
    hungarian: 'bőgni, ordítani (oroszlán)',
    german: 'brüllen',
    dutch: 'brullen (brullen)',
    afrikaans: 'brul (leeu) (om te)',
    russian: 'рычать',
    latvian: 'rēkt',
    polish: 'ryczeć (lew)',
    french: 'rugir',
    spanish: 'rugir (león)',
  },
  {
    av: 24250,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(crown + description indicator)',
    english: 'royal',
    swedish: 'kunglig',
    norwegian: 'kongelig',
    finnish: 'kuninkaallinen',
    hungarian: 'királyi',
    german: 'königlich',
    dutch: 'koninklijk',
    afrikaans: 'koninklike',
    russian: 'королевский',
    latvian: 'karalisks',
    polish: 'królewski',
    french: 'royal',
    spanish: 'real',
  },
  {
    av: 24251,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(family + royal)',
    english: 'royal family',
    swedish: 'kungafamilj',
    norwegian: 'kongefamilie',
    finnish: 'kuninkaallinen perhe, kuningassuku, kuninkaalliset',
    hungarian: 'királyi család',
    german: 'die königliche Familie',
    dutch: 'koninklijke familie',
    afrikaans: 'koninklike familie',
    russian: 'королевская семья',
    latvian: 'karaliskā ģimene',
    polish: 'rodzina królewska',
    french: 'famille royale',
    spanish: 'familia real',
  },
  {
    av: 24252,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + saddle)',
    english: 'saddle pad, saddle blanket',
    swedish: 'sadelfilt',
    norwegian: 'salpute, salteppe',
    finnish: 'satulahuopa',
    hungarian: 'nyeregpárna, nyeregtakaró',
    german: 'Satteldecke',
    dutch: 'zadeldeken',
    afrikaans: 'saalkombers',
    russian: 'вальтрап',
    latvian: 'sedlu polsteris, sedlu sega',
    polish: 'derka pod siodło, czaprak, potnik',
    french: 'tapis de selle',
    spanish: 'sudadera, cojín',
  },
  {
    av: 24253,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liberation + religious)',
    english: 'salvation (religious)',
    swedish: 'frälsning (religiös)',
    norwegian: 'frelse (religiøs)',
    finnish: 'pelastus',
    hungarian: 'üdvösség, üdvözülés (vall.)',
    german: 'Erlösung, Seelenheil (religös)',
    dutch: 'redding-(christelijk), verlossing (christelijk)',
    afrikaans: 'redding (godsdienstige)',
    russian: 'спасение (религия)',
    latvian: 'glābšana, pestīšana (reliģijā)',
    polish: 'zbawienie (religijne)',
    french: 'salut (religieux)',
    spanish: 'salvación (religioso)',
  },
  {
    av: 24254,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(insect + skin + plural indicator)',
    english: 'scabies',
    swedish: 'skabb',
    norwegian: 'skabb',
    finnish: 'syyhy',
    hungarian: 'rüh, rühösség',
    german: 'Krätze, Skabies',
    dutch: 'schurft',
    afrikaans: 'jeuksiekte',
    russian: 'чесотка',
    latvian: 'kašķis',
    polish: 'świerzb',
    french: 'gale',
    spanish: 'sarna',
  },
  {
    av: 24255,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(harness + vehicle + thing indicator)',
    english: 'seat belt',
    swedish: 'säkerhetsbälte, bilbälte',
    norwegian: 'bilbelte',
    finnish: 'turvavyö',
    hungarian: 'biztonsági öv',
    german: 'Sicherheitsgurt',
    dutch: 'gordel, veiligheidsgordel, autogordel',
    afrikaans: 'veiligheidsgordel',
    russian: 'ремень безопасности',
    latvian: 'drošības josta',
    polish: 'pasy bezpieczeństwa',
    french: 'ceinture de sécurité',
    spanish: 'cinturón de seguridad',
  },
  {
    av: 24256,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + to give + help)',
    english: 'service (help)',
    swedish: 'service (hjälp), betjäning',
    norwegian: 'service (hjelp)',
    finnish: 'palvelu, apu',
    hungarian: 'szolgálat (segítő)',
    german: 'Service, Dienstleistung',
    dutch: 'dienst',
    afrikaans: 'diens (hulp)',
    russian: 'сервис (помощь)',
    latvian: 'pakalpojumi, palīdzība, atbalsts',
    polish: 'usługa, pomoc, oferta pomocy',
    french: "service (d'aide)",
    spanish: 'ayuda, servicio',
  },
  {
    av: 24257,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + sexual)',
    english: 'sexual activity',
    swedish: 'sexualliv',
    norwegian: 'seksuell aktivitet',
    finnish: 'seksuaalinen toiminta, seksuaalinen aktiivisuus',
    hungarian: 'szexuális aktivitás, nemi tevékenység',
    german: 'sexuelle Aktivität',
    dutch: 'seksuele activiteit',
    afrikaans: 'seksuele aktiwiteit',
    russian: 'сексуальная активность ',
    latvian: 'dzimumattiecības, seksuālas darbības',
    polish: 'aktywność seksualna',
    french: 'activité sexuelle',
    spanish: 'actividad sexual',
  },
  {
    av: 24258,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid + sexual + thing indicator)',
    english: 'sexual aid',
    swedish: 'sexhjälpmedel',
    norwegian: 'seksuelt hjelpemiddel, sexhjelpemiddel',
    finnish: 'seksiväline',
    hungarian: 'szexuális segédeszköz',
    german: 'Sex-Hilfsmittel',
    dutch: 'seksueel hulpmiddel',
    afrikaans: 'seksuele hulp',
    russian: 'вспомогательное средство для секса',
    latvian: 'seksa palīglīdzekļi',
    polish: 'pomoc seksualna',
    french: 'aide technique pour la sexualité',
    spanish: 'ayuda sexual',
  },
  {
    av: 24259,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play + sexual)',
    english: 'sexual play',
    swedish: 'sexlek',
    norwegian: 'seksuell lek, sexlek',
    finnish: 'seksileikki',
    hungarian: 'szexuális játék',
    german: 'Sexspiel',
    dutch: 'seksspel',
    afrikaans: 'seksuele spel',
    russian: 'сексуальная игра',
    latvian: 'intīmas rotaļas',
    polish: 'gry, zabawy seksualne',
    french: 'jeu sexuel',
    spanish: 'juego sexual',
  },
  {
    av: 24260,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(mature + sexual + description indicator)',
    english: 'sexually mature',
    swedish: 'könsmogen',
    norwegian: 'kjønnsmoden',
    finnish: 'sukukypsä aikuinen',
    hungarian: 'szexuálisan érett, nemileg érett',
    german: 'geschlechtsreif',
    dutch: 'geslachtsrijp',
    afrikaans: 'seksueel volwasse',
    russian: 'половозрелый',
    latvian: 'dzimumnobriedis',
    polish: 'dojrzały płciowo',
    french: 'mâture (sexuellement)',
    spanish: 'sexualmente maduro',
  },
  {
    av: 24261,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(then + action indicator: auxiliary verb for future)',
    english: 'shall, will-(modal aux v)',
    swedish: 'skall, kommer att',
    norwegian: 'skulle, ville',
    finnish: 'aikoa',
    hungarian: 'fogni (jövő idejű segédige)',
    german: 'werden ',
    dutch: 'zullen',
    afrikaans: 'sal (hulp ww.)',
    russian: 'будет (вспом. глагол)',
    latvian: 'gatavoties kaut ko darīt',
    polish: 'będzie (czas przyszły być)',
    french: 'auxiliaire du futur',
    spanish: 'seré, estaré (modal)',
  },
  {
    av: 24262,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(shampoo + action indicator)',
    english: 'shampoo-(to)',
    swedish: 'tvätta håret',
    norwegian: 'vaske håret',
    finnish: 'pestä hiukset',
    hungarian: 'sampon, hajmosószer',
    german: 'waschen (Haare)',
    dutch: 'haren wassen',
    afrikaans: 'hare was (om te)',
    russian: 'мыть волосы',
    latvian: 'šampūns',
    polish: 'myć włosy',
    french: 'faire un shampooing, shampooiner, shampouiner',
    spanish: 'lavar con champú',
  },
  {
    av: 24263,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(knife + hair + action indicator)',
    english: 'shave-(to)',
    swedish: 'raka',
    norwegian: 'barbere',
    finnish: 'leikata karvat',
    hungarian: 'borotválni, borotválkozni',
    german: 'rasieren',
    dutch: 'scheren',
    afrikaans: 'skeer (om te)',
    russian: 'бриться',
    latvian: 'skūt',
    polish: 'golić się',
    french: 'raser',
    spanish: 'afeitar',
  },
  {
    av: 24264,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(then + conditional indicator: auxiliary verb for future conditional)',
    english: 'should, would-(modal aux v)',
    swedish: 'skulle',
    norwegian: 'skulle, ville (preteritum futurum)',
    finnish: 'pitäisi',
    hungarian: 'volna, lenne, -na, -ne, -ná, -né',
    german: 'würden',
    dutch: 'zullen (voorwaardelijke-wijs)',
    afrikaans: 'behoort, sou (hulp ww.)',
    russian: 'следовало бы (вспом. глагол)',
    latvian: 'nosacījums vai iespēja',
    polish: 'powinien był (tryb przyp. czas przesz.)',
    french: 'auxiliaire conditionnel (futur)',
    spanish: 'debe (modal)',
  },
  {
    av: 24265,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hand + cross: where the cross represents Christ [contr.])',
    english: 'sign of the cross',
    swedish: 'korstecken',
    norwegian: 'korsets tegn',
    finnish: 'ristin merkki',
    hungarian: 'a kereszt jele',
    german: 'Bekreuzigung',
    dutch: 'kruisteken',
    afrikaans: 'teken van die kruis',
    russian: 'крестное знамение',
    latvian: 'krusta zīme',
    polish: 'znak krzyża, przeżegnanie się',
    french: 'signe de croix',
    spanish: 'signo de la cruz',
  },
  {
    av: 24266,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + skin)',
    english: 'skin disease, eczema',
    swedish: 'hudsjukdom, eksem',
    norwegian: 'hudsykdom, eksem',
    finnish: 'ihosairaus, ihottuma',
    hungarian: 'bőrbetegség, ekzéma',
    german: 'Hautkrankheit, Ekzem',
    dutch: 'eczeem, huidziekte',
    afrikaans: 'velsiekte, ekseem',
    russian: 'кожное заболевание, экзема',
    latvian: 'ādas slimība, ekzēma',
    polish: 'choroba skóry',
    french: 'maladie de la peau',
    spanish: 'enfermedad de la piel',
  },
  {
    av: 24267,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vehicle + above)',
    english: 'skytrain, monorail',
    swedish: 'monorail, skytrain, balktåg',
    norwegian: 'monorail, enskinnetog',
    finnish: '1-raiteinen luotijuna',
    hungarian: 'egysínű vasút',
    german: 'Einschienenbahn',
    dutch: 'monorail',
    afrikaans: 'monorail',
    russian: 'лёгкое метро, монорельсовый транспорт',
    latvian: 'viensliežu dzelzceļš',
    polish: 'kolejka liniowa, kolejka jednoszynowa napowietrzna',
    french: 'monorail',
    spanish: 'monoriel',
  },
  {
    av: 24268,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(forward + negative + description indicator) Preferred NEW SYNONYM, replacing 17014',
    english: 'slow, slowly',
    swedish: 'långsam, sakta',
    norwegian: 'sakte',
    finnish: 'hidas, hitaasti',
    hungarian: 'lassú, lassan',
    german: 'langsam',
    dutch: 'langzaam, traag',
    afrikaans: 'stadig, stadige',
    russian: 'медленно, медленный',
    latvian: 'lēns, lēni',
    polish: 'powoli, wolno',
    french: 'lent, lentement',
    spanish: 'lento, poco a poco',
  },
  {
    av: 24269,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(society + description indicator)',
    english: 'social',
    swedish: 'social',
    norwegian: 'sosial',
    finnish: 'sosiaalinen, seurallinen',
    hungarian: 'társadalmi, szociális',
    german: 'sozial',
    dutch: 'sociaal',
    afrikaans: 'sosiaal',
    russian: 'социальный',
    latvian: 'sociāls',
    polish: 'społeczny, socjalny',
    french: 'social',
    spanish: 'social',
  },
  {
    av: 24270,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + citizen)',
    english: 'society',
    swedish: 'samhället',
    norwegian: 'samfunn',
    finnish: 'yhteisö',
    hungarian: 'társadalom',
    german: 'Gesellschaft',
    dutch: 'samenleving, maatschappij',
    afrikaans: 'gemeenskap',
    russian: 'общество',
    latvian: 'sabiedrība',
    polish: 'społeczeństwo',
    french: 'société',
    spanish: 'sociedad',
  },
  {
    av: 24273,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(somersault + person) SYMBOL SYNONYM',
    english: 'somersault (person)',
    swedish: 'kullerbytta (2)',
    norwegian: 'salto, kollbøtte (2)',
    finnish: 'kuperkeikka, voltti',
    hungarian: 'bukfenc',
    german: 'Purzelbaum, Salto (2)',
    dutch: 'salto (mens)',
    afrikaans: 'bolmakiesie (2)',
    russian: 'кувырок (2)',
    latvian: 'kūlenis (2)',
    polish: 'salto, fikołek (2)',
    french: 'culbute, tonneau, saut périlleux (2)',
    spanish: 'voltereta (2)',
  },
  {
    av: 24274,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flame + star)',
    english: 'spark',
    swedish: 'gnista',
    norwegian: 'gnist',
    finnish: 'kipinä',
    hungarian: 'szikra',
    german: 'Funke',
    dutch: 'vonk',
    afrikaans: 'vonk ',
    russian: 'искра',
    latvian: 'dzirkstele',
    polish: 'iskra',
    french: 'étincelle',
    spanish: 'chispa',
  },
  {
    av: 24275,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + muscle + sudden)',
    english: 'spasm',
    swedish: 'spasm, tics',
    norwegian: 'spasme, tics',
    finnish: 'kramppi, kouristus',
    hungarian: 'görcs, izomgörcs',
    german: 'Krampf, Anfall',
    dutch: 'spasme',
    afrikaans: 'spasma',
    russian: 'спазм',
    latvian: 'spazma',
    polish: 'skurcz',
    french: 'spasme',
    spanish: 'espasmo',
  },
  {
    av: 24276,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(therapy + language)',
    english: 'speech therapy',
    swedish: 'logopedi',
    norwegian: 'logopedi',
    finnish: 'puheterapia',
    hungarian: 'beszédterápia, logopédia, beszédfejlesztés',
    german: 'Sprachtherapie',
    dutch: 'logopedie',
    afrikaans: 'spraakterapie',
    russian: 'логопед',
    latvian: 'runas terapija, logopēdija',
    polish: 'logoterapia, logopedia',
    french: 'thérapie du langage, logopédie, orthophonie',
    spanish: 'logopedia',
  },
  {
    av: 24277,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + speech therapy)',
    english: 'speech therapy room',
    swedish: 'logopedrum, talklinik',
    norwegian: 'logopedrom',
    finnish: 'puheterapiahuone, puheterapeutin huone',
    hungarian: 'logopédia szoba',
    german: 'Sprachtherapiezimmer',
    dutch: 'spraaktherapie-ruimte, logopedieruimte',
    afrikaans: 'spraakterapie kamer',
    russian: 'кабинет логопеда',
    latvian: 'runas terapijas telpa',
    polish: 'gabinet logopedyczny',
    french: 'local de logopédie',
    spanish: 'sala de logopedia',
  },
  {
    av: 24278,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(insight + spirit)',
    english: 'spiritual awareness',
    swedish: 'andlig medvetenhet',
    norwegian: 'åndelig bevissthet',
    finnish: 'henkinen tietoisuus',
    hungarian: 'lelki, szellemi tudatosság',
    german: 'spirituelles Erwachen ',
    dutch: 'spiritueel bewustzijn',
    afrikaans: 'geestelike bewustheid',
    russian: 'духовное осознание',
    latvian: 'garīga apzināšanās',
    polish: 'świadomość duchowa',
    french: 'spiritualité',
    spanish: 'percepción espiritual',
  },
  {
    av: 24279,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(aid + bones with joint + thing indicator: where bones with joint represents joint [contr.])',
    english: 'splint (orthopedic)',
    swedish: 'ortos, skena, stödbandage',
    norwegian: 'skinne (ortopedisk), støttebandasje',
    finnish: 'lasta',
    hungarian: 'sín (ortopédiai)',
    german: 'Schiene (Medizin)',
    dutch: 'spalk (orthopedisch)',
    afrikaans: 'spalk (ortopediese)',
    russian: 'шина, ортез, тутор (ортопедия)',
    latvian: 'šina, ortopēdijā',
    polish: 'szyna ortopedyczna, usztywnienie',
    french: 'attelle',
    spanish: 'escayola (ortopédica), férula',
  },
  {
    av: 24280,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(fanatic + sport)',
    english: 'sport fanatic',
    swedish: 'sportfanatiker',
    norwegian: 'sportsfanatiker',
    finnish: 'urheiluhullu',
    hungarian: 'sportőrült, sportmegszállott, sportfanatikus',
    german: 'Sportfanatiker, Sportfanatikerin',
    dutch: 'sportfanaat',
    afrikaans: 'sport fanatikus',
    russian: 'фанатик спорта',
    latvian: 'sporta fanātiķis',
    polish: 'fanatyk sportu',
    french: 'fanatique de sport',
    spanish: 'fanático del deporte',
  },
  {
    av: 24282,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(horse + male)',
    english: 'stallion, entire',
    swedish: 'hingst',
    norwegian: 'hingst',
    finnish: 'ori',
    hungarian: 'csődör, mén',
    german: 'Hengst',
    dutch: 'hengst',
    afrikaans: 'hings',
    russian: 'жеребец',
    latvian: 'ērzelis, nekastrēts dzīvnieks',
    polish: 'ogier',
    french: 'étalon',
    spanish: 'semental',
  },
  {
    av: 24283,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(life + without + food)',
    english: 'starvation',
    swedish: 'svält',
    norwegian: 'sult',
    finnish: 'nälänhätä',
    hungarian: 'éhezés',
    german: 'Hungern, Hungertod',
    dutch: 'uithongering, verhongering',
    afrikaans: 'hongersnood',
    russian: 'голодание',
    latvian: 'badošanās',
    polish: 'poszczenie, głodzenie się',
    french: 'famine',
    spanish: 'hambruna',
  },
  {
    av: 24284,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + platform)',
    english: 'station',
    swedish: 'station',
    norwegian: 'stasjon',
    finnish: 'asema',
    hungarian: 'állomás, pályaudvar',
    german: 'Station, Bahnhof',
    dutch: 'station',
    afrikaans: 'stasie',
    russian: 'станция',
    latvian: 'stacija',
    polish: 'stacja',
    french: 'gare',
    spanish: 'estación',
  },
  {
    av: 24285,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(continuance, continuation + description indicator)',
    english: 'still, continuing, ongoing',
    swedish: 'ännu',
    norwegian: 'fortsatt, enda, pågående',
    finnish: 'jatkuva',
    hungarian: 'még, folyamatos, folytatólagos, szakadatlan',
    german: 'noch, immer noch, weiterhin',
    dutch: 'steeds, nog steeds, voortdurend',
    afrikaans: 'steeds, voortgesette, deurlopende',
    russian: 'продолжительный',
    latvian: 'turpināties, notikt, pašreizējs',
    polish: 'jeszcze, nadal',
    french: 'en cours, continu',
    spanish: 'continuo, permanente',
  },
  {
    av: 24286,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(time + to continue + description indicator)',
    english: 'still, continuously',
    swedish: 'fortfarande',
    norwegian: 'kontinuerlig, fremdeles',
    finnish: 'jatkuvasti, yhtä mittaa, alati',
    hungarian: 'folyamatosan, még mindig folyamatban lévő',
    german: 'noch, immer noch, weiterhin',
    dutch: 'aanhoudend, voortdurend',
    afrikaans: 'steeds, voortdurend',
    russian: 'постоянный',
    latvian: 'joprojām, nepārtraukti',
    polish: 'ciągle',
    french: 'continuellement, sans arrêt',
    spanish: 'continuamente, aún',
  },
  {
    av: 24287,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(support + foot + riding [contr.] + thing indicator)',
    english: 'stirrup',
    swedish: 'stigbygel',
    norwegian: 'stigbøyle',
    finnish: 'jalustin',
    hungarian: 'kengyel',
    german: 'Steigbügel',
    dutch: 'stijgbeugel',
    afrikaans: 'stiebeuel',
    russian: 'стремя',
    latvian: 'kāpslis',
    polish: 'strzemię',
    french: 'étrier',
    spanish: 'estribo',
  },
  {
    av: 24288,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + vomit)',
    english: 'stomach flu',
    swedish: 'maginfluensa, kräksjuka',
    norwegian: 'kvalme',
    finnish: 'mahatauti, vatsatauti',
    hungarian: 'gyomorrontás',
    german: 'Magen-Darm-Grippe',
    dutch: 'buikgriep',
    afrikaans: 'maaggriep',
    russian: 'желудочно-кишечная инфекция',
    latvian: 'vēdera vīruss',
    polish: 'grypa żołądkowa, wymioty',
    french: 'grippe intestinale, gastro-entérite',
    spanish: 'gastroenteritis',
  },
  {
    av: 24289,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + stomach)',
    english: 'stomach illness',
    swedish: 'magsjukdom',
    norwegian: 'magesykdom',
    finnish: 'vatsakipu, mahakipu',
    hungarian: 'gyomorbaj, gyomorbetegség',
    german: 'Magenkrankheit',
    dutch: 'maagziekte',
    afrikaans: 'maagsiekte',
    russian: 'заболевание желудка',
    latvian: 'vēdera dobuma slimība',
    polish: 'choroba żołądka',
    french: 'mal de ventre',
    spanish: 'enfermedad estomacal',
  },
  {
    av: 24290,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(platform + vehicle) Preferred NEW SYNONYM, replacing 16198',
    english: 'stop, platform (vehicle)',
    swedish: 'hållplats, perrong',
    norwegian: 'holdeplass, perrong',
    finnish: 'pysäkki (kulkuneuvo)',
    hungarian: 'jármű állomás, platform',
    german: 'Haltestelle, Bahnsteig',
    dutch: 'perron, halte',
    afrikaans: 'stop, platform (voertuig)',
    russian: 'платформа, остановка',
    latvian: 'pietura, paaugstinājums, platforma',
    polish: 'przystanek, postój pojazdu',
    french: 'quai (véhicule terrestre), arrêt (véhicule terrestre)',
    spanish: 'plataforma de detención (vehículo)',
  },
  {
    av: 24291,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to make + long + action indicator)',
    english: 'stretch (elongate)-(to)',
    swedish: 'sträcka ut',
    norwegian: 'forlenge, strekke ut',
    finnish: 'venyttää',
    hungarian: 'nyújtani, ki/megnyújtani',
    german: 'strecken, dehnen',
    dutch: 'uitrekken, rekken',
    afrikaans: 'rek, verleng, uitrek (om te)',
    russian: 'растягивать',
    latvian: 'izstiept, pastiept, pagarināt',
    polish: 'rozciągać, wydłużać, ciągnąć',
    french: 'étirer, étendre',
    spanish: 'estirar (elongar)',
  },
  {
    av: 24292,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(muscle + long + action indicator)',
    english: 'stretch (muscles)-(to)',
    swedish: 'stretcha',
    norwegian: 'strekke (muskler)',
    finnish: 'venytellä',
    hungarian: 'izmokat megnyújtani',
    german: 'dehnen, strecken, anspannen (Muskel)',
    dutch: 'uitrekken (spier), rekken (spier)',
    afrikaans: 'strek (spiere) (om te)',
    russian: 'растянуть, потянуть (мышцу)',
    latvian: 'stiept, izstaipīt (muskuļus)',
    polish: 'rozciąganie mięśni',
    french: 'étirer',
    spanish: 'estirar (músculos)',
  },
  {
    av: 24293,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(many + line + description indicator)',
    english: 'striped',
    swedish: 'randig',
    norwegian: 'stripete',
    finnish: 'raidallinen',
    hungarian: 'csíkos',
    german: 'gestreift',
    dutch: 'gestreept',
    afrikaans: 'gestreepte',
    russian: 'полосатый',
    latvian: 'svītrains',
    polish: 'paskowany',
    french: 'à ligne, rayé',
    spanish: 'a rayas',
  },
  {
    av: 24294,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(activity + learning + action indicator)',
    english: 'study-(to)',
    swedish: 'studera',
    norwegian: 'studere',
    finnish: 'opiskella',
    hungarian: 'tanulmányozni',
    german: 'lernen',
    dutch: 'studeren, leren',
    afrikaans: 'studeer (om te)',
    russian: 'учиться',
    latvian: 'mācīties, studēt',
    polish: 'studiować, uczyć się',
    french: 'étudier',
    spanish: 'estudiar',
  },
  {
    av: 24295,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(without + smartness + description indicator) Preferred NEW SYNONYM, replacing 17447',
    english: 'stupid, dumb',
    swedish: 'dum, obegåvad',
    norwegian: 'dum',
    finnish: 'tyhmä',
    hungarian: 'buta, ostoba, hülye',
    german: 'dumm, doof, blöde, idiotisch',
    dutch: 'dom, idioot, stom',
    afrikaans: 'onnosel, dom',
    russian: 'глупый, тупой, дурацкий',
    latvian: 'dumjš, muļķīgs',
    polish: 'głupi',
    french: 'stupide, idiot, bête',
    spanish: 'estúpido',
  },
  {
    av: 24296,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vehicle + under)',
    english: 'subway, metro, underground, tube',
    swedish: 'tunnelbana',
    norwegian: 'undergrunn, metro, t-bane',
    finnish: 'maanalainen, metro',
    hungarian: 'metró, földalatti',
    german: 'U-Bahn',
    dutch: 'metro, ondergrondse',
    afrikaans: 'ondergrondse stasie, duikweg, metro',
    russian: 'метро, подземный транспорт',
    latvian: 'metro, pazemes metro līnija',
    polish: 'metro, kolej podziemna',
    french: 'métro',
    spanish: 'metro',
  },
  {
    av: 24297,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flower + sun)',
    english: 'sunflower',
    swedish: 'solros',
    norwegian: 'solsikke',
    finnish: 'auringonkukka',
    hungarian: 'napraforgó, napvirág',
    german: 'Sonnenblume',
    dutch: 'zonnebloem',
    afrikaans: 'sonneblom',
    russian: 'подсолнух',
    latvian: 'saulespuķe',
    polish: 'słonecznik',
    french: 'tournesol',
    spanish: 'girasol',
  },
  {
    av: 24298,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(aid + activity + walk + thing indicator) SYMBOL SYNONYM (See also 18032)',
    english: 'walker, walking aid (1)',
    swedish: 'gånghjälpmedel',
    norwegian: 'ganghjelpemiddel',
    finnish: 'kävelytuki',
    hungarian: 'swash, járókengyel',
    german: 'Gehhilfe',
    dutch: 'looprek, rollator',
    afrikaans: 'gekabbel, geklots, kletteren',
    russian: 'вспомогательные средства для ходьбы',
    latvian: 'šļaksts, spēcīgs sitiens',
    polish: 'chodzik, urządzenie pomagające stawiać kroki',
    french: 'aide technique pour marcher, déambulateur, tribune',
    spanish: 'andador',
  },
  {
    av: 24299,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(switch + minus + action indicator)',
    english: 'switch off, turn off-(to)',
    swedish: 'stänga av, slå av, släcka',
    norwegian: 'slå av',
    finnish: 'sammuttaa, sulkea, laittaa pois päältä',
    hungarian: 'kikapcsolni, lekapcsolni',
    german: 'ausschalten, abschalten',
    dutch: 'uitzetten, uitschakelen',
    afrikaans: 'afskakel (om te)',
    russian: 'выключать',
    latvian: 'izslēgt, nogriezt',
    polish: 'wyłączać',
    french: 'éteindre',
    spanish: 'apagar',
  },
  {
    av: 24300,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(switch + plus + action indicator)',
    english: 'switch on, turn on-(to)',
    swedish: 'sätta på, slå på, tända',
    norwegian: 'slå på, tenne',
    finnish: 'avata, laittaa päälle',
    hungarian: 'bekapcsolni, felgyújtani',
    german: 'anschalten, einschalten',
    dutch: 'aanzetten, aanschakelen',
    afrikaans: 'aanskakel (om te)',
    russian: 'включать',
    latvian: 'ieslēgt, uzgriezt',
    polish: 'włączać',
    french: 'allumer',
    spanish: 'encender',
  },
  {
    av: 24301,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + tool + horse)',
    english: 'tack room',
    swedish: 'sadelkammare',
    norwegian: 'seletøyrom',
    finnish: 'satulahuone',
    hungarian: 'lószerszám-tároló',
    german: 'Sattelkammer',
    dutch: 'optuigkamer (paard)',
    afrikaans: 'spykerkamer',
    russian: 'комната хранения инвентаря для лошадей',
    latvian: 'zirglietu telpa',
    polish: 'siodlarnia (pomieszczenie na uprząż końską)',
    french: 'sellerie',
    spanish: 'cuarto de monturas',
  },
  {
    av: 24303,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hair + horse rump)',
    english: 'tail (horse)',
    swedish: 'hästsvans',
    norwegian: 'hestehale',
    finnish: 'hevosenhäntä',
    hungarian: 'lófarok, a ló farka',
    german: 'Schwanz',
    dutch: 'paardenstaart',
    afrikaans: 'perdestert',
    russian: 'хвост (лошадь)',
    latvian: 'aste, zirga',
    polish: 'ogon (koń)',
    french: 'queue (du cheval)',
    spanish: 'cola (caballo)',
  },
  {
    av: 24304,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(platform + up and down)',
    english: 'tail lift, lift',
    swedish: 'lift',
    norwegian: 'lift',
    finnish: 'lastaushissi',
    hungarian: 'beemelőszerkezet, autólift',
    german: 'Fahrstuhl, Aufzug, Lift',
    dutch: 'lift (platform)',
    afrikaans: 'stert lift',
    russian: 'лифт',
    latvian: 'pacelt, celts (asti, pakaļgalu)',
    polish: 'winda',
    french: 'élévateur (objet)',
    spanish: 'elevador, montacargas',
  },
  {
    av: 24305,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + together)',
    english: 'teamwork',
    swedish: 'teamarbete, grupparbete, lagarbete',
    norwegian: 'teamarbeid, gruppearbeid',
    finnish: 'ryhmätyö',
    hungarian: 'csapatmunka, teammunka',
    german: 'Gruppenarbeit',
    dutch: 'groepswerk, teamwerk',
    afrikaans: 'spanwerk',
    russian: 'совместная работа, работа в команде',
    latvian: 'grupu darbs, komandas darbs',
    polish: 'praca w zespole, zespołowa',
    french: "travail d'équipe",
    spanish: 'trabajo en equipo',
  },
  {
    av: 24306,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(decision + without + alcohol)',
    english: 'teetotalism',
    swedish: 'absolutism, nykterism',
    norwegian: 'total avhold (alkohol)',
    finnish: 'raittius, absolutismi',
    hungarian: 'antialkoholizmus',
    german: 'Abstinenz',
    dutch: 'geheelonthouding (drank)',
    afrikaans: 'abstinentie, geheelonthouding',
    russian: 'трезвенник',
    latvian: 'atturēšanās no alkohola',
    polish: 'abstynencja (alkoholowa)',
    french: "abstinence d'alcool",
    spanish: 'abstemio',
  },
  {
    av: 24307,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(limited time + description indicator)',
    english: 'temporary',
    swedish: 'tillfällig',
    norwegian: 'midlertidig',
    finnish: 'väliaikainen, tilapäinen',
    hungarian: 'átmeneti, ideiglenes, időszakos',
    german: 'vorübergehend, vorläufig',
    dutch: 'tijdelijk, voorlopig',
    afrikaans: 'tydelik, tydelike',
    russian: 'временный',
    latvian: 'īslaicīgs, pagaidu',
    polish: 'chwilowy',
    french: 'temporaire',
    spanish: 'temporal',
  },
  {
    av: 24308,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(craft + cloth)',
    english: 'textile craft',
    swedish: 'textilslöjd, textilhantverk',
    norwegian: 'tekstilhåndverk',
    finnish: 'tekstiilityö',
    hungarian: 'textilművesség',
    german: 'Textilhandwerk',
    dutch: 'handwerk, kunst (stof)',
    afrikaans: 'tekstiel handwerk kuns',
    russian: 'текстильное ремесло',
    latvian: 'tekstila amatniecība',
    polish: 'przemysł włókienniczy',
    french: 'art textile',
    spanish: 'artesanía textil',
  },
  {
    av: 24310,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(therapy + riding)',
    english: 'therapeutic riding',
    swedish: 'ridning (som terapi)',
    norwegian: 'terapiridning',
    finnish: 'ratsastusterapia',
    hungarian: 'gyógylovaglás, terápiás lovaglás',
    german: 'Reittherapie',
    dutch: 'hippotherapie',
    afrikaans: 'terapeutiese perdry',
    russian: 'иппотерапия',
    latvian: 'reitterapija',
    polish: 'hipoterapia',
    french: 'hippothérapie, équithérapie',
    spanish: 'equitación terapéutica',
  },
  {
    av: 24311,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(knot + action indicator + thing indicator)',
    english: 'tie, bind together, lash-(to)',
    swedish: 'knyta',
    norwegian: 'knyte',
    finnish: 'sitoa, köyttää',
    hungarian: 'összekötni',
    german: 'verbinden, binden',
    dutch: 'vastbinden, strikken, knopen',
    afrikaans: 'vasbind, bind aanmekaar (om te)',
    russian: 'связывать, завязывать',
    latvian: 'sasiet, piesiet',
    polish: 'wiązać',
    french: 'attacher, nouer',
    spanish: 'atar',
  },
  {
    av: 24312,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + dry)',
    english: 'towel',
    swedish: 'handduk',
    norwegian: 'håndkle',
    finnish: 'pyyhe, pyyheliina',
    hungarian: 'törülköző',
    german: 'Handtuch',
    dutch: 'handdoek',
    afrikaans: 'handdoek',
    russian: 'полотенце',
    latvian: 'dvielis',
    polish: 'ręcznik',
    french: 'serviette de bain',
    spanish: 'toalla',
  },
  {
    av: 24314,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + train)',
    english: 'train station (building)',
    swedish: 'resecentrum, järnvägsstation',
    norwegian: 'jernbanestasjon, stasjonsbygning',
    finnish: 'rautatieasema',
    hungarian: 'állomásépület (vonat)',
    german: 'Bahnhof, Station (Gebäude)',
    dutch: 'station (trein)',
    afrikaans: 'treinstasie (gebou)',
    russian: 'железнодорожный вокзал',
    latvian: 'stacijas ēka',
    polish: 'dworzec kolejowy (1) stacja kolejowa',
    french: 'gare des trains, gare ferroviaire (bâtiment)',
    spanish: 'estación de trenes (edificio)',
  },
  {
    av: 24315,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(station + train)',
    english: 'train station (platforms)',
    swedish: 'järnvägsstation',
    norwegian: 'jernbanestasjon (plattform)',
    finnish: 'rautatieasema',
    hungarian: 'vonatállomás',
    german: 'Bahnhof, Station (Bahnsteig)',
    dutch: 'station (trein)',
    afrikaans: 'treinstasie (platform)',
    russian: 'железнодорожная станция',
    latvian: 'stacijas platforma',
    polish: 'dworzec kolejowy (2)',
    french: 'gare des trains, gare ferroviaire (quai)',
    spanish: 'estación de trenes (plataforma)',
  },
  {
    av: 24316,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(long vehicle + track)',
    english: 'tram',
    swedish: 'spårvagn',
    norwegian: 'trikk',
    finnish: 'raitiovaunu',
    hungarian: 'villamos',
    german: 'Straßenbahn, Tram',
    dutch: 'tram',
    afrikaans: 'trem',
    russian: 'трамвай',
    latvian: 'tramvajs',
    polish: 'tramwaj',
    french: 'tram',
    spanish: 'tranvía',
  },
  {
    av: 24317,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(medical treatment + action indicator)',
    english: 'treat, care for (medically)-(to)',
    swedish: 'behandla, vårda (medicinskt)',
    norwegian: 'behandle (medisinsk)',
    finnish: 'hoitaa',
    hungarian: 'egészségügyileg ellátni, kezelni',
    german: 'medizinisch behandeln',
    dutch: 'behandelen (medisch)',
    afrikaans: 'behandel (mediese) (om te)',
    russian: 'лечить (медицина)',
    latvian: 'ārstēt, dziedināt (medicīniski)',
    polish: 'leczyć, opiekować się (medycyna)',
    french: 'traiter (médicalement), soigner',
    spanish: 'tratar (médicamente), ',
  },
  {
    av: 24318,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bus + electricity)',
    english: 'trolleybus',
    swedish: 'trådbuss',
    norwegian: 'trolleybuss',
    finnish: 'johdinauto, trolleybussi',
    hungarian: 'trolibusz',
    german: 'Obus, Oberleitungsomnibus',
    dutch: 'trolley',
    afrikaans: 'trolliebus',
    russian: 'троллейбус',
    latvian: 'trolejbuss',
    polish: 'trolejbus',
    french: 'trolleybus',
    spanish: 'trolebús ',
  },
  {
    av: 24319,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(horse + intensity + action indicator)',
    english: 'trot (horse)-(to)',
    swedish: 'trava',
    norwegian: 'trave (hest)',
    finnish: 'ravata',
    hungarian: 'ügetni (ló)',
    german: 'traben',
    dutch: 'draven',
    afrikaans: 'draf (perd) (om te)',
    russian: 'ездить рысью',
    latvian: 'rikšiem',
    polish: 'kłus (koń)',
    french: 'trotter',
    spanish: 'trotar (caballo)',
  },
  {
    av: 24320,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + dry + cloth)',
    english: 'tumble-drier, tumble-dryer',
    swedish: 'torktumlare',
    norwegian: 'tørketrommel',
    finnish: 'kuivausrumpu',
    hungarian: 'szárítógép',
    german: 'Wäschetrockner',
    dutch: 'droogkast',
    afrikaans: 'tuimeldroër',
    russian: 'сушильная машина',
    latvian: 'centrifūga, žāvētājs',
    polish: 'suszarka do ubrań (bębnowa)',
    french: 'sèche-linge',
    spanish: 'secadora',
  },
  {
    av: 24321,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pipe + under)',
    english: 'tunnel, subway, underpass',
    swedish: 'tunnel',
    norwegian: 'tunnel, undergang',
    finnish: 'alikulkutunneli',
    hungarian: 'aluljáró',
    german: 'Tunnel, U-Bahn',
    dutch: 'tunnel, onderdoorgang',
    afrikaans: 'tonnel, onderdoorgang, duikweg',
    russian: 'туннель',
    latvian: 'tunelis, apakšzemes eja, apakšzemes pāreja',
    polish: 'tunel, metro',
    french: 'tunnel, passage souterrain',
    spanish: 'túnel, metro, paso subterráneo',
  },
  {
    av: 24322,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(station + under)',
    english: 'underground station, subway station',
    swedish: 'tunnelbanestation',
    norwegian: 'undergrunnstasjon',
    finnish: 'metroasema',
    hungarian: 'metróállomás, földalatti állomás',
    german: 'U-Bahnhof',
    dutch: 'metrostation',
    afrikaans: 'ondergrondse stasie, duikweg, metro',
    russian: 'станция метро',
    latvian: 'apakšzemes transporta pietura, stacija, metro stacija ',
    polish: 'stacja metra, stacja kolejki podziemnej',
    french: 'station de métro',
    spanish: 'estación de metro',
  },
  {
    av: 24323,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to remove + harness + horse + action indicator + thing indicator)',
    english: 'unharness (horse)-(to)',
    swedish: 'sela av',
    norwegian: 'sele av (hest)',
    finnish: 'irrottaa hevoselta valjaat, ottaa hevoselta pois valjaat',
    hungarian: 'kifogni, leszerszámozni',
    german: 'abschirren, (Pferd) abspannen',
    dutch: 'uitspannen (paard)',
    afrikaans: 'aftuig (om `n perd af te tuig) (om te)',
    russian: 'распрягать лошадь',
    latvian: 'izjūgt (zirgu)',
    polish: 'rozprzęgać (konie)',
    french: 'déharnacher le cheval, dételer (cheval)',
    spanish: 'desenjaezar (caballo)',
  },
  {
    av: 24324,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(group of + country + together) Add specific letters for the appropriate union e g NATO.',
    english: 'union (political unit)',
    swedish: 'union',
    norwegian: 'union',
    finnish: 'valtioliitto, unioni',
    hungarian: 'szövetség (politikai), szakszervezet',
    german: 'Union',
    dutch: 'unie (politiek)',
    afrikaans: 'unie (politieke eenheid)',
    russian: 'союз, объединение (политическое)',
    latvian: 'vienība, savienība (politiska savienība)',
    polish: 'unia (polityczna)',
    french: 'union (politique)',
    spanish: 'sindicato (unidad política)',
  },
  {
    av: 24325,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(above + waist)',
    english: 'upper body',
    swedish: 'överkropp, övre kroppshalvan',
    norwegian: 'overkropp',
    finnish: 'ylävartalo',
    hungarian: 'felsőtest',
    german: 'Oberkörper',
    dutch: 'bovenlichaam',
    afrikaans: 'bolyf',
    russian: 'верхная часть тела',
    latvian: 'ķermeņa augšgals',
    polish: 'górna część ciała, od pasa w górę',
    french: 'partie supérieure du corps, haut du corps',
    spanish: 'parte superior del cuerpo',
  },
  {
    av: 24326,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + vagina + down)',
    english: 'vaginal discharge',
    swedish: 'flytning (från slidan)',
    norwegian: 'utflod',
    finnish: 'emätinvuoto, valkovuoto',
    hungarian: 'hüvelyfolyás',
    german: 'Scheidenausfluss',
    dutch: 'vaginale afscheiding',
    afrikaans: 'vaginale afskeiding',
    russian: 'вагинальное выделение',
    latvian: 'maksts izdalījumi',
    polish: 'upław',
    french: 'écoulement vaginal, pertes blanches',
    spanish: 'secreción vaginal',
  },
  {
    av: 24327,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(horse + action indicator)',
    english: 'walk (horse)-(to)',
    swedish: 'skritta',
    norwegian: 'gå en hest, skritte',
    finnish: 'kävellä (hevonen)',
    hungarian: 'lépni, lépésben haladni (ló)',
    german: 'im Schritt reiten',
    dutch: 'stappen (paard)',
    afrikaans: 'loop (perd) (om te)',
    russian: 'прогуливаться верхом',
    latvian: 'izjāt pastaigā (zirgu)',
    polish: 'stęp (koń)',
    french: 'aller au pas, marcher (cheval)',
    spanish: 'llevar al paso (caballo)',
  },
  {
    av: 24328,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + activity + to walk)',
    english: 'walkway, footpath',
    swedish: 'gångbana, stig',
    norwegian: 'gangvei, sti',
    finnish: 'kävelytie, polku',
    hungarian: 'gyalogút, ösvény, parki sétány',
    german: 'Fußweg, Gehweg, Bürgersteig',
    dutch: 'voetpad',
    afrikaans: 'voetpad',
    russian: 'пешеходная дорожка, тропа',
    latvian: 'gājēju celiņš, taka',
    polish: 'chodnik',
    french: 'allée, chemin, trottoir',
    spanish: 'pasarela, sendero',
  },
  {
    av: 24329,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dot + genitals)',
    english: 'wart, papilloma (venereal)',
    swedish: 'vårta, papillom (venerisk)',
    norwegian: 'vorte, papillomer (venerisk)',
    finnish: 'papillooma, syylä',
    hungarian: 'vírusos szemölcs (mint nemibetegség)',
    german: 'Warze, Papillom (geschlechtlich)',
    dutch: 'wrat (genitaal)',
    afrikaans: 'vrat (genitaal)',
    russian: 'бородавка, папиллома (венерическая)',
    latvian: 'kārpa papiloma (veneriska)',
    polish: 'brodawki, brodawczaki (weneryczne)',
    french: 'verrue vénérienne',
    spanish: 'verruga, papiloma (venéreo)',
  },
  {
    av: 24330,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to give + water + action indicator)',
    english: 'water-(to)',
    swedish: 'vattna',
    norwegian: 'vanne',
    finnish: 'kastella',
    hungarian: 'öntözni, locsolni',
    german: 'gießen',
    dutch: 'gieten, water geven',
    afrikaans: 'natlei (om nat te lei)',
    russian: 'поливать, обливать (водой)',
    latvian: 'ūdens, laistīt',
    polish: 'nawadniać, podlewać, lać wodę',
    french: 'arroser',
    spanish: 'regar',
  },
  {
    av: 24331,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bucket + water)',
    english: 'water bucket',
    swedish: 'vattenhink, vattenspann',
    norwegian: 'vannkanne',
    finnish: 'vesisanko, vesiämpäri',
    hungarian: 'vizesvödör',
    german: 'Gießkanne',
    dutch: 'emmer',
    afrikaans: 'water emmer',
    russian: 'ведро для воды ',
    latvian: 'ziedu trauks, spainis',
    polish: 'wiadro wody',
    french: "seau d'eau",
    spanish: 'balde de agua',
  },
  {
    av: 24333,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + sexual)',
    english: 'venereal disease',
    swedish: 'könssjukdom',
    norwegian: 'venerisk sykdom, kjønnssykdom',
    finnish: 'sukupuolitauti',
    hungarian: 'nemibetegség, nemi baj',
    german: 'Geschlechtskrankheit',
    dutch: 'geslachtsziekte',
    afrikaans: 'geslagsiekte',
    russian: 'венерическое заболевание',
    latvian: 'veneriska slimība',
    polish: 'choroba weneryczna',
    french: 'maladie vénérienne',
    spanish: 'enfermedad venérea',
  },
  {
    av: 24334,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + wart, papilloma (venereal))',
    english: 'venereal papilloma',
    swedish: 'kondylom',
    norwegian: 'vorter veneriske, papillomer veneriske',
    finnish: 'papillooma (sukupuolitauti), syylät',
    hungarian: 'nemi úton terjedő papilloma (szemölcs)',
    german: 'Kondylom, Feigwarze',
    dutch: 'wratten (genitaal)',
    afrikaans: 'veneriese papilloma',
    russian: 'кондиломы',
    latvian: 'vereriska papiloma',
    polish: 'brodawka płciowa',
    french: 'papillome vénérien',
    spanish: 'papiloma venéreo',
  },
  {
    av: 24335,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(harness + wheelchair + thing indicator)',
    english: 'wheelchair straps',
    swedish: 'rullstolsbälte',
    norwegian: 'rullestolseler',
    finnish: 'pyörätuolin kiinnitysvyöt',
    hungarian: 'kerekesszék heveder, rögzítő szíj, biztonsági öv',
    german: 'Rollstuhlgurt',
    dutch: 'riem (rolstoel)',
    afrikaans: 'rolstoel bande',
    russian: 'ремни безопасности для инвалидной коляски',
    latvian: 'ratiņkrēsla siksnas',
    polish: 'pasy wózka inwalidzkiego',
    french: 'sangle (de chaise roulante)',
    spanish: 'cinturón para silla de ruedas',
  },
  {
    av: 24336,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(strawberry + small)',
    english: 'wild strawberry',
    swedish: 'smultron',
    norwegian: 'markjordbær',
    finnish: 'metsämansikka',
    hungarian: 'erdei szamóca',
    german: 'wilde Erdbeeren',
    dutch: 'wilde aardbei',
    afrikaans: 'wilde aarbei',
    russian: 'земляника',
    latvian: 'meža zemenes',
    polish: 'poziomka',
    french: 'fraise sauvage',
    spanish: 'fresas silvestres',
  },
  {
    av: 24337,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + permission + travel)',
    english: 'visa',
    swedish: 'visum',
    norwegian: 'visum',
    finnish: 'viisumi',
    hungarian: 'vízum',
    german: 'Visum',
    dutch: 'visum',
    afrikaans: 'visa',
    russian: 'виза (документ)',
    latvian: 'vīza',
    polish: 'wiza',
    french: 'visa',
    spanish: 'visado',
  },
  {
    av: 24338,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(horse + rotation + action indicator: a circular movement executed by a horse in manège)',
    english: 'volte (horse)-(to)',
    swedish: 'rida i volt',
    norwegian: 'volte (hest)',
    finnish: 'tehdä kierrähdys hevosella',
    hungarian: 'körbenjáratni lovat (voltézni)',
    german: 'Voltigieren',
    dutch: 'volte (paardendressuur)',
    afrikaans: 'volte (om `n perd te volte)',
    russian: 'ездить вольтами (лошадь)',
    latvian: 'voltižēt, pagriezt (zirgu)',
    polish: 'wolta, zataczać koło (jeździectwo)',
    french: 'pirouetter',
    spanish: 'volteo (a caballo)',
  },
  {
    av: 24339,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(craft + wood)',
    english: 'woodcraft',
    swedish: 'träslöjd, trähantverk',
    norwegian: 'trehåndverk, tresløyd',
    finnish: 'puutyö',
    hungarian: 'faművesség',
    german: 'Holzarbeit',
    dutch: 'kunst (hout)',
    afrikaans: 'hout handwerk',
    russian: 'мастерство по дереву',
    latvian: 'kokapstrādes amatniecība',
    polish: 'narzędzia stolarskie',
    french: 'artisanat du bois, ébénisterie',
    spanish: 'artesanía en madera',
  },
  {
    av: 24340,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid + bones with joint + wrist + thing indicator)',
    english: 'wrist splint',
    swedish: 'handledsskena, handledsortos',
    norwegian: 'håndleddskinne, håndleddstøtte',
    finnish: 'rannelasta',
    hungarian: 'csuklósín',
    german: 'Handgelenkschutz',
    dutch: 'spalk (pols)',
    afrikaans: 'pols spalk',
    russian: 'шина для запястья',
    latvian: 'plaukstas locītavas šina',
    polish: 'szyna nadgarstka, usztywnienie nadgarstka',
    french: 'attelle de poignet',
    spanish: 'férula de muñeca, muñequera',
  },
  {
    av: 24401,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(achievement + action indicator)',
    english: 'achieve-(to)',
    swedish: 'prestera, uträtta',
    norwegian: 'fullføre, gjennomføre, prestere',
    finnish: 'saada aikaiseksi, saavuttaa',
    hungarian: 'elérni, kivívni, véghezvinni, megvalósítani',
    german: '(etwas) erreichen, erzielen',
    dutch: 'bereiken, verkrijgen',
    afrikaans: 'bereik (om te)',
    russian: 'достигать',
    latvian: 'sasniegt',
    polish: 'osiągać, zdziałać',
    french: 'réaliser, accomplir',
    spanish: 'lograr',
  },
  {
    av: 24402,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(effect + proud)',
    english: 'achievement',
    swedish: 'prestation',
    norwegian: 'fullføring, gjennomføring, prestasjon',
    finnish: 'saavutus',
    hungarian: 'teljesítmény, véghezvitel, eredmény',
    german: 'Leistung, Erfolg',
    dutch: 'verworvenheid, prestatie',
    afrikaans: 'prestasie, bereik',
    russian: 'достижение',
    latvian: 'sasniegums',
    polish: 'osiągnięcie',
    french: 'réussite, exploit',
    spanish: 'logro',
  },
  {
    av: 24403,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + addiction)',
    english: 'addict',
    swedish: 'missbrukare',
    norwegian: 'stoffmisbruker',
    finnish: 'huumeiden käyttäjä',
    hungarian: 'szenvedélybeteg, rabja valaminek, addikt',
    german: 'der Süchtige, der Drogenabhängige',
    dutch: 'verslaafde',
    afrikaans: 'verslaafde',
    russian: 'наркоман',
    latvian: 'atkarīgais, narkomāns',
    polish: 'uzależniony od czegoś, narkoman',
    french: 'personne dépendante (maladie)',
    spanish: 'adicto',
  },
  {
    av: 24404,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + need)',
    english: 'addiction',
    swedish: 'missbruk (alkohol etc)',
    norwegian: 'henfallenhet, misbruk',
    finnish: 'riippuvuus, himo, addiktio',
    hungarian: 'szenvedélybetegség, hozzászokás, addikció',
    german: 'Süchtigkeit, Abhängigkeit (Alkohol etc.)',
    dutch: 'verslaving',
    afrikaans: 'verslawing ',
    russian: 'наркомания, наркозависимость',
    latvian: 'atkarība, narkomānija',
    polish: 'uzależnienie',
    french: 'dépendance (maladie)',
    spanish: 'adicción',
  },
  {
    av: 24405,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + need)',
    english: 'alcoholism, alcohol addiction',
    swedish: 'alkoholism, alkoholberoende',
    norwegian: 'alkoholmisbruk',
    finnish: 'alkoholismi',
    hungarian: 'alkohol-betegség, alkoholfüggés',
    german: 'Alkoholismus',
    dutch: 'alcoholisme, alcoholverslaving',
    afrikaans: 'alkoholisme, alkohol verslawing',
    russian: 'алкоголизм',
    latvian: 'alkoholisms, alkohola atkarība',
    polish: 'alkoholizm (1)',
    french: "dépendance à l'alcool, alcoolisme",
    spanish: 'alcoholismo (2)',
  },
  {
    av: 24406,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(negative dependency + alcohol)',
    english: 'alcohol abuse, alcohol addiction',
    swedish: 'alkoholmissbruk, alkoholberoende',
    norwegian: 'alkoholavhengighet',
    finnish: 'alkoholismi',
    hungarian: 'alkoholizmus, iszákosság',
    german: 'Alkoholmissbrauch',
    dutch: 'alcoholmisbruik',
    afrikaans: 'alkoholmisbruik, alkohol verslawing',
    russian: 'зависимость от алкоголя',
    latvian: 'alkohola atkarība, alkohola ļaunprātīga lietošana',
    polish: 'alkoholizm (2)',
    french: "abus d'alcool, alcoolisme",
    spanish: 'alcoholismo, adicción al alcohol',
  },
  {
    av: 24407,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(reaction + body)',
    english: 'allergy, hypersensitivity',
    swedish: 'allergi, överkänslighet',
    norwegian: 'allergi, overfølsomhet',
    finnish: 'yliherkkyys, allergia',
    hungarian: 'allergia, túlérzékenység',
    german: 'Allergie, Überempfindlichkeit ',
    dutch: 'allergie',
    afrikaans: 'allergie, hipersensitiwiteit',
    russian: 'аллергия, гиперчувствительность',
    latvian: 'alerģija, hiperjutīgums',
    polish: 'alergia, nadwrażliwość',
    french: 'allergie',
    spanish: 'alergia, hipersensibilidad',
  },
  {
    av: 24408,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + baby)',
    english: 'baby animal',
    swedish: 'djurunge',
    norwegian: 'dyreunge',
    finnish: 'eläimen poikanen',
    hungarian: 'kölyökállat, kisállat',
    german: 'Tierbaby',
    dutch: 'jong',
    afrikaans: 'baba dier',
    russian: 'детёныш животного',
    latvian: 'dzīvnieku mazulis',
    polish: 'młode zwierzę, osesek',
    french: 'petit (animal), jeune, bébé animal',
    spanish: 'cría de animal',
  },
  {
    av: 24409,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bottle + baby)',
    english: 'baby bottle, feeding bottle',
    swedish: 'nappflaska',
    norwegian: 'tåteflaske, barneflaske',
    finnish: 'tuttipullo',
    hungarian: 'cumisüveg',
    german: 'Nuckelflasche, Babyflasche',
    dutch: 'zuigfles, fles (baby)',
    afrikaans: 'baba bottel, voeding bottel',
    russian: 'бутылочка для детей',
    latvian: 'piena pudelīte, barojamā pudelīte',
    polish: 'butelka dla niemowląt',
    french: 'biberon',
    spanish: 'biberón',
  },
  {
    av: 24410,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + bacterium)',
    english: 'bacterial infection',
    swedish: 'bakterieinfektion',
    norwegian: 'bakterieinfeksjon',
    finnish: 'bakteeri-infektio',
    hungarian: 'baktériumfertőzés, bakteriális fertőzés',
    german: 'bakterielle Infektion',
    dutch: 'bacteriële infectie',
    afrikaans: 'bakteriële infeksie',
    russian: 'бактериальная инфекция',
    latvian: 'bakteriāla infekcija',
    polish: 'zakażenie bakteryjne, infekcja bakteryjna',
    french: 'infection bactérienne',
    spanish: 'infección bacteriana',
  },
  {
    av: 24411,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(1 + micro-organism: single cell micro-organism)',
    english: 'bacterium',
    swedish: 'bakterie',
    norwegian: 'bakterie',
    finnish: 'bakteeri',
    hungarian: 'baktérium',
    german: 'Bakterie',
    dutch: 'bacterie',
    afrikaans: 'bakterie',
    russian: 'бактерия',
    latvian: 'baktērijas',
    polish: 'bakteria',
    french: 'bactérie',
    spanish: 'bacteria',
  },
  {
    av: 24412,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(curved line + action indicator)',
    english: 'bend-(to)',
    swedish: 'böja',
    norwegian: 'bøye',
    finnish: 'taivuttaa, kääntää',
    hungarian: 'hajlítani, kanyarítani',
    german: 'biegen',
    dutch: 'buigen',
    afrikaans: 'buig (om te)',
    russian: 'согнуть, згибать, наклонить',
    latvian: 'ieliekt, saliekt',
    polish: 'zgiąć',
    french: 'courber, pencher',
    spanish: 'doblar',
  },
  {
    av: 24413,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + competition)',
    english: 'bet',
    swedish: 'vad, insats',
    norwegian: 'veddemål',
    finnish: 'veto',
    hungarian: 'tét',
    german: 'Wette, Wetteinsatz',
    dutch: 'gok, inzet',
    afrikaans: 'weddenskap',
    russian: 'ставка (денежная)',
    latvian: 'derības',
    polish: 'zakład (hazard)',
    french: 'pari',
    spanish: 'apuesta',
  },
  {
    av: 24414,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(bet + action indicator)',
    english: 'bet-(to)',
    swedish: 'slå vad',
    norwegian: 'vedde',
    finnish: 'lyödä vetoa',
    hungarian: 'fogadni (pénzben)',
    german: 'spielen, zocken, wetten',
    dutch: 'inzetten (geld)',
    afrikaans: 'wed (om te)',
    russian: 'делать ставку',
    latvian: 'derēt',
    polish: 'stawiać na, zakładać się (hazard)',
    french: 'parier',
    spanish: 'apostar',
  },
  {
    av: 24415,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + bet)',
    english: 'betting',
    swedish: 'vadslagning',
    norwegian: 'vedding',
    finnish: 'vedonlyönti',
    hungarian: 'fogadás (pénzben)',
    german: 'Wetten, Wettspiel',
    dutch: 'weddenschap',
    afrikaans: 'verbintenis, weddenskappe',
    russian: 'денежное пари',
    latvian: 'derēšana',
    polish: 'robić zakłady (hazard)',
    french: 'pari (activité)',
    spanish: 'apuesta',
  },
  {
    av: 24417,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + iron [contr.])',
    english: 'blacksmith',
    swedish: 'smed',
    norwegian: 'smed',
    finnish: 'seppä',
    hungarian: 'kovács',
    german: 'Schmied, Schmiedin',
    dutch: 'hoefsmid, smid',
    afrikaans: 'ystersmid',
    russian: 'кузнец',
    latvian: 'kalējs',
    polish: 'kowal',
    french: 'forgeron',
    spanish: 'herrero',
  },
  {
    av: 24418,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(bottleneck, bottle opening + baby: modified baby bottle with a pointer, to nipple)',
    english: 'bottle nipple, teat',
    swedish: 'flasknapp',
    norwegian: 'flaskesmokk',
    finnish: 'tuttipullon tutti',
    hungarian: 'cumi',
    german: 'Nuckelflasche, Babyflasche',
    dutch: 'speen',
    afrikaans: 'speen, tepel, tiet (bottel)',
    russian: 'соска для бутылочки',
    latvian: 'knupītis, pudeles knupis',
    polish: 'smoczek na butelkę, butelka z dziubkiem dla dzieci',
    french: 'tétine',
    spanish: 'tetina (biberón)',
  },
  {
    av: 24419,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spot + blue)',
    english: 'bruise, contusion, haematoma',
    swedish: 'blåmärke',
    norwegian: 'blåmerke',
    finnish: 'mustelma, verenpurkauma, ruhje',
    hungarian: 'zúzódás, vérömleny, hematóma',
    german: 'blauer Fleck',
    dutch: 'blauwe plek',
    afrikaans: 'kontusie, hematoom',
    russian: 'синяк',
    latvian: 'nobrāzums, kontūzija, hematoma',
    polish: 'siniaki, stłuczenia, krwiaki',
    french: 'bleu, contusion, hématome',
    spanish: 'hematoma, contusión, moretón',
  },
  {
    av: 24420,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spot + bump)',
    english: 'bruise, dent',
    swedish: 'bula, buckla, svullnad',
    norwegian: 'støtmerke, slagmerke',
    finnish: 'lommo, ruttu, kolhu',
    hungarian: 'ütés nyoma, sérülés',
    german: 'Prellung, blauer Fleck, Beule, Delle',
    dutch: 'kneuzing',
    afrikaans: 'kneusplek, kneusing, duik',
    russian: 'след от удара, вмятина, отёк',
    latvian: 'nobrāzums, ieplīsums',
    polish: 'stłuczenie, ślad uderzenia, upadku',
    french: 'dégât en surface, emboutissage',
    spanish: 'arañazo, rozadura, hematoma',
  },
  {
    av: 24421,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(bruise, dent + description indicator)',
    english: 'bruised, dented',
    swedish: 'bucklig, svullen',
    norwegian: 'støtmerket, slagmerket, hovent',
    finnish: 'kolhittu, rutattu',
    hungarian: 'sérült, megütött',
    german: 'verletzt, zerschrammt, verbeult',
    dutch: 'gekneusd',
    afrikaans: 'gekneus, ingeduik',
    russian: 'опухший, отёкший',
    latvian: 'nobrāzts, ieplīsis',
    polish: 'poobijane, rozbite',
    french: 'abimé, défoncé, embouti',
    spanish: 'abollado, golpeado',
  },
  {
    av: 24423,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(bump, press, pressing + action indicator)',
    english: 'bump, press-(to)',
    swedish: 'stöta',
    norwegian: 'støte',
    finnish: 'törmätä maahan, pudota',
    hungarian: 'dudor',
    german: 'stoßen, rempeln, anrempeln',
    dutch: 'stoten',
    afrikaans: 'stamp, druk (om te)',
    russian: 'ударять, нажимать',
    latvian: 'belzt, saspiest, sasist',
    polish: 'uderzać, rozbijać, spadać, upadać',
    french: 'cogner, heurter',
    spanish: 'tropezar con',
  },
  {
    av: 24424,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(agreement + stop + war)',
    english: 'cease-fire, armistice',
    swedish: 'vapenvila',
    norwegian: 'våpenhvile',
    finnish: 'tulitauko, aselepo',
    hungarian: 'fegyverszünet, tűzszünet',
    german: 'Feuereinstellung, Waffenruhe, Waffenstillstand',
    dutch: 'wapenstilstand',
    afrikaans: 'skietstilstand, wapenstilstand',
    russian: 'прекращение огня, перемирие',
    latvian: 'pārtraukt uguni, pamiers',
    polish: 'zawieszenie broni, rozejm',
    french: 'cessez-le-feu, armistice',
    spanish: 'alto el fuego, tregua',
  },
  {
    av: 24425,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dwarf planet + middle)',
    english: 'Ceres (dwarf planet)',
    swedish: 'Ceres',
    norwegian: 'Ceres (planet)',
    finnish: 'Ceres (planeetta)',
    hungarian: 'Ceresz (törpebolygó)',
    german: 'Ceres (Zwergplanet)',
    dutch: 'Ceres (dwergplaneet)',
    afrikaans: 'Ceres (dwergplaneet)',
    russian: 'Церера (карликовая планета)',
    latvian: 'Cereza, pundurplanēta',
    polish: 'Ceres (planetoida)',
    french: 'planète naine Cérès',
    spanish: 'Ceres (planeta enano)',
  },
  {
    av: 24426,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(choice + future (uncertain))',
    english: 'chance, risk',
    swedish: 'chans, risk',
    norwegian: 'sjanse, risiko',
    finnish: 'riski, mahdollisuus',
    hungarian: 'kockázat, eshetőség, rizikó',
    german: 'Chance, Möglichkeit, Risiko',
    dutch: 'kans, risico',
    afrikaans: 'kans, risiko',
    russian: 'шанс, риск',
    latvian: 'iespēja, gadījums, risks',
    polish: 'szansa, ryzyko',
    french: 'hasard, risque',
    spanish: 'oportunidad, riesgo',
  },
  {
    av: 24427,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(onion + grass)',
    english: 'chive',
    swedish: 'gräslök',
    norwegian: 'gressløk',
    finnish: 'purjosipuli',
    hungarian: 'metélőhagyma, snidling',
    german: 'Schnittlauch',
    dutch: 'bieslook',
    afrikaans: 'grasui',
    russian: 'зелёный лук',
    latvian: 'maurloki',
    polish: 'szczypiorek',
    french: 'ciboulette',
    spanish: 'cebollino',
  },
  {
    av: 24429,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(need + intensity)',
    english: 'dependency',
    swedish: 'beroende (subst.)',
    norwegian: 'avhengighet',
    finnish: 'riippuvuus',
    hungarian: 'függőség, kiszolgáltatottság',
    german: 'Abhängigkeit',
    dutch: 'afhankelijkheid',
    afrikaans: 'afhanklikheid',
    russian: 'зависимость',
    latvian: 'atkarība, narkomānija',
    polish: 'zależność',
    french: 'dépendance (besoin)',
    spanish: 'dependencia',
  },
  {
    av: 24431,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sieve + glassware)',
    english: 'dish rack',
    swedish: 'diskställ',
    norwegian: 'oppvaskstativ',
    finnish: 'astioiden kuivausteline',
    hungarian: 'edényszárító, edénycsöpögtető',
    german: 'Geschirrtrockner, Abtropfbrett ',
    dutch: 'afdruiprek',
    afrikaans: 'skottelgoed rak, droog rak',
    russian: 'сушилка для посуды',
    latvian: 'trauku žāvētājs',
    polish: 'suszarka do naczyń',
    french: 'égouttoir',
    spanish: 'escurreplatos, secaplatos',
  },
  {
    av: 24432,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(game [contr.] + tile)',
    english: 'domino',
    swedish: 'domino',
    norwegian: 'domino spill',
    finnish: 'dominopeli',
    hungarian: 'dominó',
    german: 'Domino',
    dutch: 'dominospel',
    afrikaans: 'domino',
    russian: 'домино',
    latvian: 'domino',
    polish: 'domino',
    french: 'domino (jeu)',
    spanish: 'dominó',
  },
  {
    av: 24433,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(saliva + down + action indicator)',
    english: 'dribble-(to)',
    swedish: 'dregla',
    norwegian: 'sikle',
    finnish: 'kuolata',
    hungarian: 'nyáladzani',
    german: 'sabbern, dribbeln',
    dutch: 'kwijlen',
    afrikaans: 'kwyl (om te)',
    russian: 'пускать слюни',
    latvian: 'driblēt',
    polish: 'kapać, skapywać, ciec po brodzie',
    french: 'baver',
    spanish: 'babear',
  },
  {
    av: 24434,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + drug addiction [contr.])',
    english: 'drug addict',
    swedish: 'drogmissbrukare',
    norwegian: 'rusmisbruker',
    finnish: 'narkomaani, huumeaddikti, huumeiden väärinkäyttäjä',
    hungarian: 'drogfüggő, drogos, narkós (fn.)',
    german: 'der Drogenabhängige, der Drogensüchtige',
    dutch: 'druggebruiker',
    afrikaans: 'dwelmverslaafde',
    russian: 'лекарственный наркоман',
    latvian: 'atkarīgais, narkomāns',
    polish: 'narkoman',
    french: 'drogué, toxicomane',
    spanish: 'adicto a las drogas',
  },
  {
    av: 24435,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(addiction + drug)',
    english: 'drug addiction',
    swedish: 'drogmissbruk',
    norwegian: 'rusmisbruk',
    finnish: 'huumeriippuvuus',
    hungarian: 'drogbetegség, narkománia',
    german: 'Drogensuch, Drogenabhängigkeit',
    dutch: 'drugsverslaafd',
    afrikaans: 'dwelmverslawing',
    russian: 'лекарственная наркомания',
    latvian: 'atkarība no zālēm, narkotikām',
    polish: 'uzależnienie od narkotyków, narkomania (1)',
    french: 'toxicomanie',
    spanish: 'adicción a las drogas',
  },
  {
    av: 24436,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(negative dependency + drug)',
    english: 'drug dependency',
    swedish: 'drogberoende',
    norwegian: 'rusavhengighet',
    finnish: 'huumeriippuvuus',
    hungarian: 'drogfüggőség',
    german: 'Drogenabhängigkeit',
    dutch: 'drugafhankelijk',
    afrikaans: 'dwelmafhanklikheid',
    russian: 'лекарственная наркозависимость',
    latvian: 'atkarība no zālēm, narkotikām',
    polish: 'uzależnienie od narkotyków, narkomania (2)',
    french: 'dépendance à la drogue',
    spanish: 'dependencia a las drogas',
  },
  {
    av: 24437,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(planet + small)',
    english: 'dwarf planet',
    swedish: 'dvärgplanet',
    norwegian: 'dvergplanet',
    finnish: 'kääpiöplaneetta',
    hungarian: 'törpebolygó',
    german: 'Zwergplanet ',
    dutch: 'dwergplaneet',
    afrikaans: 'dwergplaneet',
    russian: 'карликовая планета',
    latvian: 'pundurplanēta',
    polish: 'planeta karłowata',
    french: 'planète naine',
    spanish: 'planeta enano',
  },
  {
    av: 24438,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rock planet + water)',
    english: 'Earth, Tellus (planet)',
    swedish: 'Tellus, Jorden',
    norwegian: 'Jorda (planet), Tellus',
    finnish: 'maa (planeetta)',
    hungarian: 'Föld (bolygó)',
    german: 'Erde, Tellus (Planet)',
    dutch: 'aarde, Tellus (planeet)',
    afrikaans: 'aarde, Tellus (planeet)',
    russian: 'Земля, Теллус (планета)',
    latvian: 'Zeme, Tellus planēta',
    polish: 'Ziemia (planeta ludzi)',
    french: 'planète tellurique',
    spanish: 'Tierra, Tellus (planeta)',
  },
  {
    av: 24439,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mental illness + food)',
    english: 'eating disorder',
    swedish: 'ätstörningar',
    norwegian: 'spisevegring, spiseforstyrrelse',
    finnish: 'anoreksia, syömishäiriö',
    hungarian: 'evési rendellenesség',
    german: 'Essstörung',
    dutch: 'eetstoornis',
    afrikaans: 'eetversteuring',
    russian: 'расстройство питания',
    latvian: 'ēšanas traucējumi',
    polish: 'zaburzenia odżywiania, anoreksja, bulimia itp.',
    french: 'trouble du comportement alimentaire',
    spanish: 'trastorno de la alimentación',
  },
  {
    av: 24440,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dwarf planet + angle)',
    english: 'Eris (dwarf planet)',
    swedish: 'Eris',
    norwegian: 'Eris (planet)',
    finnish: 'eris (planeetta)',
    hungarian: 'Erisz (törpebolygó)',
    german: 'Eris (Zwergplanet)',
    dutch: 'Eris (dwergplaneet)',
    afrikaans: 'Eris (dwergplaneet)',
    russian: 'Эрис (планета)',
    latvian: 'Eris, pundurplanēta',
    polish: 'Eris (planeta)',
    french: 'planète naine Eris',
    spanish: 'Eris (planeta enano)',
  },
  {
    av: 24441,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to observe + evaluation)',
    english: 'examination, investigation',
    swedish: 'undersökning',
    norwegian: 'undersøkelse',
    finnish: 'tutkiminen, tutkinta',
    hungarian: 'vizsgálat, kivizsgálás, nyomozás',
    german: 'Untersuchung',
    dutch: 'onderzoek',
    afrikaans: 'ondersoek',
    russian: 'исследование',
    latvian: 'pārbaude, izmeklējumi',
    polish: 'badanie, dochodzenie, kontrola',
    french: 'examen, investigation',
    spanish: 'examen, investigación',
  },
  {
    av: 24442,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(medical examination + action indicator)',
    english: 'examine (medically)-(to)',
    swedish: 'läkarundersöka',
    norwegian: 'undersøke medisinsk',
    finnish: 'tutkia (lääk.)',
    hungarian: 'kivizsgálni, megvizsgálni (orvosilag)',
    german: 'ärztliche Untersuchung',
    dutch: 'medische onderzoeken',
    afrikaans: 'ondersoek (medies) (om te)',
    russian: 'исследовать (медицинсоке)',
    latvian: 'izmeklēt (medicīniski)',
    polish: 'badać (medyczne)',
    french: 'examiner (médicalement)',
    spanish: 'examinar (médicamente)',
  },
  {
    av: 24444,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(failure + action indicator)',
    english: 'fail-(to)',
    swedish: 'misslyckas',
    norwegian: 'mislykkes, feile',
    finnish: 'epäonnistua',
    hungarian: 'kudarcot vallani, meghiúsulni, elbukni',
    german: 'versagen, durchfallen, scheitern',
    dutch: 'falen, mislukken',
    afrikaans: 'misluk',
    russian: 'терпеть неудачу, проиграть',
    latvian: 'neizdoties, nepaveikties, nenokārtot eksāmenu, testu',
    polish: 'ponieść klęskę, odnieść porażkę, zawieść, oblać (egzamin), ',
    french: 'échouer',
    spanish: 'fracasar',
  },
  {
    av: 24446,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(club [contr.] + feeling)',
    english: 'fan club',
    swedish: 'fan club, supporterklubb',
    norwegian: 'fanklubb, supporterklubb',
    finnish: 'ihailijakerho, fanklubi',
    hungarian: 'rajongói klub',
    german: 'Fanclub, Anhängerverein',
    dutch: 'fan club',
    afrikaans: 'bewonderaarsklub',
    russian: 'фан-клуб, клуб по интересам',
    latvian: 'atbalstītāju, līdzjutēju klubs, fanu klubs',
    polish: 'klub fanowski, klub miłośników',
    french: 'club de fans, cercle de fans, fans club',
    spanish: 'club de fans',
  },
  {
    av: 24447,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + young)',
    english: 'fledgeling',
    swedish: 'fågelunge',
    norwegian: 'fugleunge',
    finnish: 'linnunpoikanen',
    hungarian: 'fióka, fiatal madár',
    german: 'Grünschnabel, Neuling',
    dutch: 'vogeltje (babyvogel), kuiken',
    afrikaans: 'voëltjie, jong',
    russian: 'птенец',
    latvian: 'putnēns, tikko piedzimis',
    polish: 'pisklak',
    french: 'oisillon',
    spanish: 'pichón',
  },
  {
    av: 24448,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(horse + young)',
    english: 'foal',
    swedish: 'föl',
    norwegian: 'føll',
    finnish: 'varsa',
    hungarian: 'csikó',
    german: 'Fohlen',
    dutch: 'veulen',
    afrikaans: 'vul',
    russian: 'жеребёнок',
    latvian: 'ērzelēns, kumeļš, atnesties',
    polish: 'źrebak, źrebię',
    french: 'poulain, ânon',
    spanish: 'potro',
  },
  {
    av: 24449,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(club [contr.] + football [contr.])',
    english: 'football supporters club',
    swedish: 'supporterklubb (fotboll), fotbollsklubb',
    norwegian: 'supporterklubb fotball',
    finnish: 'jalkapalloilun kannattajakerho',
    hungarian: 'futballrajongók köre',
    german: 'Fanclub eines Fussballvereins',
    dutch: 'voetbal supportersclub',
    afrikaans: 'voetbal sokker ondersteuners klub',
    russian: 'футбольный клуб',
    latvian: 'futbolas atbalstītāju, līdzjutēju, fanu klubs',
    polish: 'klub kibiców piłkarskich',
    french: 'club de supporters de football',
    spanish: 'peña de fútbol',
  },
  {
    av: 24450,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group + football [contr.])',
    english: 'football team',
    swedish: 'fotbollslag',
    norwegian: 'fotballag',
    finnish: 'jalkapallojoukkue',
    hungarian: 'futballcsapat',
    german: 'Fussballmannschaft',
    dutch: 'voetbalploeg, voetbalteam',
    afrikaans: 'voetbal span, sokker span',
    russian: 'футбольная команда',
    latvian: 'futbola komanda',
    polish: 'drużyna piłkarska, skład',
    french: 'équipe de football',
    spanish: 'equipo de fútbol',
  },
  {
    av: 24452,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(competition + money)',
    english: 'gamble',
    swedish: 'spel (om pengar)',
    norwegian: 'pengespill',
    finnish: 'uhkapeli',
    hungarian: 'szerencsejáték, hazárdjáték',
    german: 'Glücksspiel, Lotteriespiel (um Geld)',
    dutch: 'gokwedstrijd',
    afrikaans: 'dobbel',
    russian: 'азартная игра (на деньги)',
    latvian: 'azartspēles',
    polish: 'hazard',
    french: 'pari, mise',
    spanish: 'apuesta',
  },
  {
    av: 24453,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(gamble + action indicator)',
    english: 'gamble-(to)',
    swedish: 'spela (om pengar)',
    norwegian: 'spille (om penger), gamble',
    finnish: 'pelata uhkapeliä',
    hungarian: 'szerencsejátékot játszani, hazardírozni',
    german: 'um Geld spielen, Risiken eingehen',
    dutch: 'gokken',
    afrikaans: 'dobbel (om te)',
    russian: 'играть в азартные игры',
    latvian: 'spēlēt azarspēles',
    polish: 'ryzykować, uprawiać hazard',
    french: 'parier, miser',
    spanish: 'jugar',
  },
  {
    av: 24454,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + gamble)',
    english: 'gambler',
    swedish: 'spelare (om pengar)',
    norwegian: 'spiller (om penger), gambler',
    finnish: 'uhkapeluri',
    hungarian: 'szerencsejátékos (fn.)',
    german: 'Glücksspieler, Hasardeur (um Geld)',
    dutch: 'gokker',
    afrikaans: 'dobbelaar',
    russian: 'азартный игрок',
    latvian: 'spēlmanis',
    polish: 'hazardzista, gracz',
    french: 'joueur',
    spanish: 'jugador',
  },
  {
    av: 24455,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(planet + gas)',
    english: 'gas planet',
    swedish: 'gasplanet',
    norwegian: 'planet gass, gassplanet',
    finnish: 'kaasuplaneetta',
    hungarian: 'gázbolygó, óriásbolygó, gázóriás',
    german: 'Gasplanet, Gasriese ',
    dutch: 'gasplaneet',
    afrikaans: 'gasplaneet',
    russian: 'газовая планета',
    latvian: 'gāzu planēta',
    polish: 'gazowa planeta',
    french: 'planète gazeuse',
    spanish: 'planeta gaseoso',
  },
  {
    av: 24456,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + gold [contr.])',
    english: 'goldsmith',
    swedish: 'guldsmed',
    norwegian: 'gullsmed',
    finnish: 'kultaseppä',
    hungarian: 'aranyműves',
    german: 'Goldschmied, Goldschmiedin',
    dutch: 'goudsmid',
    afrikaans: 'goudsmit',
    russian: 'ювелир',
    latvian: 'juvelieris',
    polish: 'złotnik (człowiek)',
    french: 'orfèvre',
    spanish: 'orfebre',
  },
  {
    av: 24457,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(goodbye + day)',
    english: 'Good day (bye)',
    swedish: 'goddag (avsked)',
    norwegian: 'god dag (farvel)',
    finnish: 'hyvää päivän jatkoa!',
    hungarian: 'Viszlát! Szia! További szép napot!',
    german: 'Guten Tag (Verabschiedung)',
    dutch: 'tot ziens',
    afrikaans: 'totsiens, goeie dag (afskeid)',
    russian: 'Хорошего дня! Пока!',
    latvian: 'Visu labu! Palieciet sveiki!',
    polish: 'Do widzenia (pa, papa, cześć)',
    french: 'au revoir (bye), bonne journée',
    spanish: 'buenos días (adiós)',
  },
  {
    av: 24458,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(hello + day)',
    english: 'Good day (hello)',
    swedish: 'goddag (möte)',
    norwegian: 'god dag (hei)',
    finnish: 'hyvää päivää!',
    hungarian: 'Helló! Jó napot! Szia!',
    german: 'Guten Tag, Hallo (Begrüßung)',
    dutch: 'goededag',
    afrikaans: 'goeiedag (groet hallo)',
    russian: 'Добрый день!',
    latvian: 'Labdien! Sveicināti!',
    polish: 'Dzień dobry, Cześć, witaj',
    french: 'bonjour (hello, la journée)',
    spanish: 'buenos días (hola)',
  },
  {
    av: 24459,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(goodbye + evening)',
    english: 'Good evening (bye)',
    swedish: 'godkväll (avsked)',
    norwegian: 'god kveld (farvel)',
    finnish: 'hyvää illan jatkoa',
    hungarian: 'Viszlát! Szia! Szép estét!',
    german: 'Guten Abend (Verabschiedung)',
    dutch: 'goedenavond (bij vertrek)',
    afrikaans: 'goeienaand (afskeid)',
    russian: 'Хорошего вечера! Пока!',
    latvian: 'Ar labvakaru!',
    polish: 'Dobranoc (pożegnanie)',
    french: 'bonsoir (bye), bonne soirée',
    spanish: 'buenas tardes (adiós)',
  },
  {
    av: 24460,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(hello + evening)',
    english: 'Good evening (hello)',
    swedish: 'godkväll (möte)',
    norwegian: 'god kveld (hei)',
    finnish: 'hyvää iltaa!',
    hungarian: 'Helló! Jó estét! Szia!',
    german: 'Guten Abend (Begrüßung)',
    dutch: 'goedenavond (bij aankomst)',
    afrikaans: 'goeienaand (groet hallo)',
    russian: 'Добрый вечер!',
    latvian: 'Labvakar!',
    polish: 'Dobry wieczór (przywitanie)',
    french: 'bonsoir (hello)',
    spanish: 'buenas tardes (hola)',
  },
  {
    av: 24461,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(goodbye + morning)',
    english: 'Good morning (bye)',
    swedish: 'godmorgon (avsked)',
    norwegian: 'god morgen (farvel)',
    finnish: 'hyvää huomenta!',
    hungarian: 'Viszlát! Szia!',
    german: 'Guten Morgen (Verabschiedung)',
    dutch: 'goedemorgen (bij vertrek)',
    afrikaans: 'goeie more (afskeid)',
    russian: 'Хорошего утра! Пока!',
    latvian: 'Ar labu rītu! ',
    polish: 'Dobrego dnia',
    french: 'au revoir, bonne matinée (bye)',
    spanish: 'buenos días (adiós)',
  },
  {
    av: 24462,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(hello + morning)',
    english: 'Good morning (hello)',
    swedish: 'godmorgon (möte)',
    norwegian: 'god morgen (hei)',
    finnish: 'hyvää huomenta!',
    hungarian: 'Helló! Jó reggelt! Szia!',
    german: 'Guten Morgen (Begrüßung)',
    dutch: 'goedemorgen (bij aankomst)',
    afrikaans: 'goeie more (groet hallo)',
    russian: 'Доброе утро!',
    latvian: 'Labrīt!',
    polish: 'Dzień dobry',
    french: 'bonjour (hello, le matin)',
    spanish: 'buenos días (hola)',
  },
  {
    av: 24463,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(goodbye + night)',
    english: 'Good night (bye)',
    swedish: 'godnatt (avsked)',
    norwegian: 'god natt (farvel)',
    finnish: 'hyvää yötä!',
    hungarian: 'Viszlát, jó éjszakát!',
    german: 'Gute Nacht (Verabschiedung)',
    dutch: 'goedenacht (bij vertrek), slaapwel, welterusten',
    afrikaans: 'goeie nag (afskeid)',
    russian: 'Доброй ночи! Пока!',
    latvian: 'Ar labu nakti!',
    polish: 'Dobranoc (pożegnanie)',
    french: 'au revoir, bonne nuit (bye)',
    spanish: 'buenas noches (adiós)',
  },
  {
    av: 24464,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(hello + night)',
    english: 'Good night (hello)',
    swedish: 'godnatt (möte)',
    norwegian: 'god natt (hei)',
    finnish: 'hyvää yötä!',
    hungarian: 'Helló! Szia! (éjjel)',
    german: 'Gute Nacht (Begrüßung)',
    dutch: 'goedenacht (bij aankomst)',
    afrikaans: 'goeie nag (groet hallo)',
    russian: 'Доброй ночи! (приветствие)',
    latvian: 'Labvakar!',
    polish: 'Dobry wieczór',
    french: 'bonsoir, bonne nuit (hello)',
    spanish: 'buenas noches (hola)',
  },
  {
    av: 24465,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + guest)',
    english: 'guest room',
    swedish: 'gästrum',
    norwegian: 'gjesterom',
    finnish: 'vierashuone',
    hungarian: 'vendégszoba',
    german: 'Gästezimmer',
    dutch: 'logeerkamer',
    afrikaans: 'gastekamer',
    russian: 'гостевая комната',
    latvian: 'viesistaba',
    polish: 'pokój gościnny',
    french: "chambre d'hôte",
    spanish: 'habitación de huéspedes',
  },
  {
    av: 24466,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(impact + action indicator)',
    english: 'have impact on-(to)',
    swedish: 'inverka på',
    norwegian: 'innvirke på',
    finnish: 'vaikuttaa',
    hungarian: 'hatni vmire, befolyással/hatással lenni vmire',
    german: 'etwas beeinflussen, aich auf etwas auswirken',
    dutch: 'beïnvloeden',
    afrikaans: 'beïnvloed, impak op (om te)',
    russian: 'влиять, оказывать влияние',
    latvian: 'ietekmēt',
    polish: 'mieć wpływ na',
    french: "influencer, avoir un impact sur, avoir de l'effet sur",
    spanish: 'tener impacto en',
  },
  {
    av: 24467,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(effect + intensity)',
    english: 'impact',
    swedish: 'inverkan',
    norwegian: 'innvirkning',
    finnish: 'vaikutus',
    hungarian: 'befolyás, hatás, behatás',
    german: 'Wirkung, Folge, Ergebnis, Effekt',
    dutch: 'impact',
    afrikaans: 'impak',
    russian: 'влияние',
    latvian: 'ietekme',
    polish: 'wpływ',
    french: 'impact',
    spanish: 'impacto',
  },
  {
    av: 24468,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cause + infection + action indicator + thing indicator)',
    english: 'infect-(to)',
    swedish: 'smitta, infektera',
    norwegian: 'smitte, infektere',
    finnish: 'tartuttaa, infektoida',
    hungarian: 'megfertőzni',
    german: 'anstecken, infizieren',
    dutch: 'infecteren',
    afrikaans: 'besmet (om te)',
    russian: 'заражать',
    latvian: 'aplipināt, inficēt',
    polish: 'zarazić, zainfekować',
    french: 'infecter, contaminer',
    spanish: 'infectar',
  },
  {
    av: 24469,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(infection + description after the fact indicator + thing indicator)',
    english: 'infected',
    swedish: 'smittad, infekterad',
    norwegian: 'smittet, infektert',
    finnish: 'tartunnan saanut, infektoitunut',
    hungarian: 'fertőzött, megfertőzödött',
    german: 'angesteckt, infiziert',
    dutch: 'geïnfecteerd',
    afrikaans: 'besmet',
    russian: 'заражённый',
    latvian: 'inficēts',
    polish: 'zarażony, zakażony',
    french: 'infecté',
    spanish: 'infectado',
  },
  {
    av: 24470,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + micro-organism + thing indicator)',
    english: 'infection',
    swedish: 'infektion',
    norwegian: 'infeksjon, smitte',
    finnish: 'infektio, tartunta',
    hungarian: 'fertőzés',
    german: 'Ansteckung, Infektion',
    dutch: 'infectie, besmetting',
    afrikaans: 'infeksie',
    russian: 'инфекция',
    latvian: 'infekcija',
    polish: 'zaraza, zakażenie, infekcja',
    french: 'infection',
    spanish: 'infección',
  },
  {
    av: 24471,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(infection + description before the fact indicator + thing indicator)',
    english: 'infectious, contagious',
    swedish: 'smittsam',
    norwegian: 'smittsom, smittefarlig',
    finnish: 'tarttuva, tartuntaa levittävä',
    hungarian: 'fertőző, ragályos',
    german: 'ansteckend',
    dutch: 'besmettelijk',
    afrikaans: 'aansteeklik, aansteeklike',
    russian: 'инфекционный',
    latvian: 'lipīgs, infekciozs',
    polish: 'zakaźna, zaraźliwa',
    french: 'contagieux, infectieux',
    spanish: 'infecciosa, contagiosa',
  },
  {
    av: 24472,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(uncomfortable + scratch)',
    english: 'itch',
    swedish: 'klåda',
    norwegian: 'kløe, kribling',
    finnish: 'kutina',
    hungarian: 'viszketés',
    german: 'Hautjucken, Juckreiz',
    dutch: 'jeuk',
    afrikaans: 'jeuk',
    russian: 'зуд',
    latvian: 'nieze',
    polish: 'grzybica',
    french: 'démangeaison',
    spanish: 'picazón',
  },
  {
    av: 24473,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gas planet + big)',
    english: 'Jupiter (planet)',
    swedish: 'Jupiter',
    norwegian: 'Jupiter (planet)',
    finnish: 'jupiter (planeetta)',
    hungarian: 'Jupiter (bolygó)',
    german: 'Jupiter (Planet)',
    dutch: 'Jupiter',
    afrikaans: 'Jupiter (planeet)',
    russian: 'Юпитер (планета)',
    latvian: 'Jupīters, planēta',
    polish: 'Jupiter (planeta)',
    french: 'planète Jupiter',
    spanish: 'Júpiter ',
  },
  {
    av: 24474,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cat + young) Preferred NEW SYNONYM, replacing 15156',
    english: 'kitten',
    swedish: 'kattunge',
    norwegian: 'kattunge',
    finnish: 'kissanpentu',
    hungarian: 'cica, kismacska, cicakölyök ',
    german: 'Kätzchen',
    dutch: 'poesje, katje',
    afrikaans: 'katjie',
    russian: 'котёнок',
    latvian: 'kaķēns',
    polish: 'kociak',
    french: 'chaton',
    spanish: 'gatito',
  },
  {
    av: 24475,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sheep + young)',
    english: 'lamb',
    swedish: 'lamm',
    norwegian: 'lam',
    finnish: 'karitsa',
    hungarian: 'bárány',
    german: 'Lamm',
    dutch: 'lam, lammetje',
    afrikaans: 'lam, lammertjie',
    russian: 'ягнёнок ',
    latvian: 'jēriņš',
    polish: 'jagnięcina',
    french: 'agnelet, agneau',
    spanish: 'cordero',
  },
  {
    av: 24476,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(onion + leaf)',
    english: 'leek',
    swedish: 'purjolök',
    norwegian: 'purreløk',
    finnish: 'purjo',
    hungarian: 'póréhagyma',
    german: 'Porree, Lauch',
    dutch: 'prei',
    afrikaans: 'prei',
    russian: 'лук-порей',
    latvian: 'puravs',
    polish: 'por',
    french: 'poireau',
    spanish: 'puerro',
  },
  {
    av: 24477,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play [contr.] + money + number)',
    english: 'lottery, game of chance',
    swedish: 'lotteri',
    norwegian: 'lotteri, lotterispill',
    finnish: 'lotto',
    hungarian: 'lottó, más hasonló szerencsejáték',
    german: 'Lotterie, Verlosung',
    dutch: 'kansspel, loterij',
    afrikaans: 'lotery, spel van kans',
    russian: 'игра в лотерею',
    latvian: 'loterija, laimes spēle',
    polish: 'loteria, gra losowa',
    french: 'loterie, jeu de hasard',
    spanish: 'lotería, juego de azar',
  },
  {
    av: 24478,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + to look + little: tool to look at small things)',
    english: 'magnifier, magnifying glass',
    swedish: 'förstoringsglas',
    norwegian: 'forstørrelsesglass',
    finnish: 'suurennuslasi',
    hungarian: 'nagyító, nagyítóüveg',
    german: 'Vergrößerungsglas, Lupe',
    dutch: 'vergrootglas',
    afrikaans: 'vergrootglas',
    russian: 'лупа',
    latvian: 'palielināmais stikls, lupa',
    polish: 'szkło powiększające, lupa',
    french: 'loupe',
    spanish: 'lupa',
  },
  {
    av: 24479,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rock planet + dust)',
    english: 'Mars (planet)',
    swedish: 'Mars (planet)',
    norwegian: 'Mars (planet)',
    finnish: 'mars (planeetta)',
    hungarian: 'Mars (bolygó)',
    german: 'Mars (Planet)',
    dutch: 'Mars',
    afrikaans: 'Mars (planeet)',
    russian: 'Марс (планета)',
    latvian: 'Marss, planēta',
    polish: 'Mars (planeta)',
    french: 'planète Mars',
    spanish: 'Marte',
  },
  {
    av: 24480,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(examination + medical)',
    english: 'medical examination',
    swedish: 'läkarundersökning',
    norwegian: 'legeundersøkelse',
    finnish: 'lääkärintarkastus',
    hungarian: 'orvosi vizsgálat',
    german: 'medizinische Untersuchung',
    dutch: 'medisch onderzoek',
    afrikaans: 'mediese ondersoek',
    russian: 'медицинское обследование ',
    latvian: 'medicīniska izmeklēšana',
    polish: 'badanie lekarskie',
    french: 'examen médical',
    spanish: 'examen médico',
  },
  {
    av: 24481,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + gathering)',
    english: 'meeting room, auditorium',
    swedish: 'konferensrum, mötesrum',
    norwegian: 'møterom, auditorium',
    finnish: 'kokoushuone, auditorio',
    hungarian: 'előadóterem, gyűlésterem',
    german: 'Konferenzraum, Aula, Hörsaal, Auditorium',
    dutch: 'auditorium, vergaderzaal, vergaderlokaal',
    afrikaans: 'saal, ouditorium',
    russian: 'конференц-зал, аудитория',
    latvian: 'tikšanaš telpa, sapulču telpa, auditorija',
    polish: 'sala konferencyjna, aula',
    french: 'salle de réunion, auditorium',
    spanish: 'sala de reuniones, auditorio',
  },
  {
    av: 24483,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rock planet + fire)',
    english: 'Mercury (planet)',
    swedish: 'Merkurius',
    norwegian: 'Merkur (planet)',
    finnish: 'merkurius (planeetta)',
    hungarian: 'Merkúr (bolygó)',
    german: 'Merkur (Planet)',
    dutch: 'Mercurius',
    afrikaans: 'Mercurius (planeet)',
    russian: 'Меркурий (планета)',
    latvian: 'Merkūrijs, planēta',
    polish: 'Merkury (planeta)',
    french: 'planète Mercure',
    spanish: 'Mercurio',
  },
  {
    av: 24484,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(information + forward)',
    english: 'message',
    swedish: 'meddelande',
    norwegian: 'budskap, beskjed',
    finnish: 'viesti',
    hungarian: 'üzenet',
    german: 'Mitteilung, Nachricht',
    dutch: 'boodschap',
    afrikaans: 'boodskap',
    russian: 'сообщение',
    latvian: 'ziņa, ziņojums',
    polish: 'wiadomość',
    french: 'message, commission',
    spanish: 'mensaje',
  },
  {
    av: 24485,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(substance + communication)',
    english: 'message, content (communication)',
    swedish: 'budskap, mening, innehåll',
    norwegian: 'budskap, innhold (kommunikasjon)',
    finnish: 'kommunikaatioviesti',
    hungarian: 'közlés, üzenettartalom, kommunikációs tartalom',
    german: 'Botschaft, Sinn, Inhalt (Kommunikation)',
    dutch: 'boodschap',
    afrikaans: 'boodskap, inhoud (kommunikasie)',
    russian: 'контейнер для сообещений',
    latvian: 'ziņojuma saturs, komunikācijā',
    polish: 'wiadomość, informacja, komunikat',
    french: 'message (contenu)',
    spanish: 'mensaje (contenido)',
  },
  {
    av: 24486,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(being + small + thing indicator)',
    english: 'micro-organism',
    swedish: 'mikroorganism',
    norwegian: 'mikroorganisme',
    finnish: 'mikro-organismi, pieneliö, mikrobi',
    hungarian: 'mikroorganizmus',
    german: 'Mikroorganismus',
    dutch: 'micro-organisme',
    afrikaans: 'mikro organisme',
    russian: 'микроорганизм',
    latvian: 'mikroorganisms',
    polish: 'mikroorganizm',
    french: 'micro-organisme',
    spanish: 'microorganismo',
  },
  {
    av: 24487,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + to look + cell)',
    english: 'microscope',
    swedish: 'mikroskop',
    norwegian: 'mikroskop',
    finnish: 'mikroskooppi',
    hungarian: 'mikroszkóp',
    german: 'Mikroskop',
    dutch: 'microscoop',
    afrikaans: 'mikroskoop',
    russian: 'микроскоп',
    latvian: 'mikroskops',
    polish: 'mikroskop',
    french: 'microscope',
    spanish: 'microscopio',
  },
  {
    av: 24488,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical product + mind)',
    english: 'drug, mind-altering drug',
    swedish: 'drog, narkotika (etc)',
    norwegian: 'narkotika, drug (o.l.)',
    finnish: 'mielialalääke',
    hungarian: 'tudatmódosító szer',
    german: 'Droge, bewusstseinsverändernde Droge',
    dutch: 'psychofarmaca',
    afrikaans: 'psychofarmaca',
    russian: 'наркотический лекарственный препарат',
    latvian: 'narkotiska viela',
    polish: 'halucynogen, narkotyk halucynogenny',
    french: 'stupéfiant',
    spanish: 'droga psicotrópica',
  },
  {
    av: 24489,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + often: e.g. child allowance)',
    english: 'money on a regular basis',
    swedish: 'utbetalning (regelbunden)',
    norwegian: 'utbetaling (regelmessig), trygd',
    finnish: 'tulo (säännöllinen)',
    hungarian: 'rendszeres bevétel, rendszeres jövedelem',
    german: 'Auszahlung (regelmässig)',
    dutch: 'loon, wedde (Vl)',
    afrikaans: "geld op 'n gereelde basis",
    russian: 'регулярный платеж',
    latvian: 'nauda, regulāri maksājumi/ienākumi/izdevumi',
    polish: 'zabezpieczenie finansowe, zaplecze finansowe',
    french: 'argent perçu régulièrement',
    spanish: 'dinero de manera habitual',
  },
  {
    av: 24491,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dependency + negative)',
    english: 'negative dependency',
    swedish: 'beroende (negativt, subst.)',
    norwegian: 'avhengighet negativ',
    finnish: 'negatiivinen riippuvuus',
    hungarian: 'negatív függőség',
    german: 'Abhängigkeit (negativ)',
    dutch: 'afhankelijkheid (negatief)',
    afrikaans: 'negatiewe afhanklikheid',
    russian: 'негативная зависимость',
    latvian: 'negatīva atkarība',
    polish: 'uzależnienie, zależność (negatywnie)',
    french: 'dépendance négative',
    spanish: 'dependencia negativa',
  },
  {
    av: 24492,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gas planet + wind)',
    english: 'Neptune (planet)',
    swedish: 'Neptunus',
    norwegian: 'Neptun (planet)',
    finnish: 'neptunus (planeetta)',
    hungarian: 'Neptun (bolygó)',
    german: 'Neptun (Planet)',
    dutch: 'Neptunus',
    afrikaans: 'Neptunus (planeet)',
    russian: 'Нептун (планета)',
    latvian: 'Neptūns, planēta',
    polish: 'Neptun (planeta)',
    french: 'planète Neptune',
    spanish: 'Neptuno',
  },
  {
    av: 24493,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + old)',
    english: 'old-age pension',
    swedish: 'ålderspension',
    norwegian: 'alderspensjon',
    finnish: 'vanhuuseläke',
    hungarian: 'nyugdíj, időskori nyugellátás',
    german: 'Pension, Altersrente',
    dutch: 'pensioen (geld)',
    afrikaans: 'ouderdomspensioen',
    russian: 'пенсия по старости',
    latvian: 'vecuma pensija',
    polish: 'emerytura',
    french: 'pension de vieillesse',
    spanish: 'pensión de jubilación',
  },
  {
    av: 24494,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(being + thing indicator) - (character with thing indicator)',
    english: 'organism',
    swedish: 'organism',
    norwegian: 'organisme',
    finnish: 'organismi, eliö',
    hungarian: 'szervezet (biol.), organizmus',
    german: 'Organismus',
    dutch: 'organisme',
    afrikaans: 'organisme',
    russian: 'организм',
    latvian: 'organisms',
    polish: 'organizm',
    french: 'organisme (être vivant)',
    spanish: 'organismo',
  },
  {
    av: 24495,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(effect + activity: consequence of activity)',
    english: 'outcome, result',
    swedish: 'resultat',
    norwegian: 'resultat',
    finnish: 'lopputulos',
    hungarian: 'kimenetel, eredmény',
    german: 'Ergebnis, Resultat',
    dutch: 'resultaat, uitkomst',
    afrikaans: 'uitkoms, resultaat',
    russian: 'результат',
    latvian: 'iznākums, rezultāts',
    polish: 'wynik, rezultat',
    french: 'conséquence, résultat',
    spanish: 'resultado',
  },
  {
    av: 24496,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + baby + mouth)',
    english: 'pacifier, dummy',
    swedish: 'napp',
    norwegian: 'smokk',
    finnish: 'tutti',
    hungarian: 'cumi, cucli',
    german: 'Schnuller, Nuckel',
    dutch: 'speen, fopspeen',
    afrikaans: 'fopspeen',
    russian: 'соска',
    latvian: 'knupis, knupītis',
    polish: 'smoczek',
    french: 'tétine, sucette, lolette',
    spanish: 'chupete, muñeco',
  },
  {
    av: 24497,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + old age pension)',
    english: 'pensioner',
    swedish: 'pensionär',
    norwegian: 'pensjonist',
    finnish: 'eläkeläinen',
    hungarian: 'nyugdíjas (fn.)',
    german: 'Rentner, Rentnerin',
    dutch: 'gepensioneerde',
    afrikaans: 'pensioenaris',
    russian: 'пенсионер',
    latvian: 'pensionārs',
    polish: 'emeryt',
    french: 'retraité, pensionné',
    spanish: 'pensionista',
  },
  {
    av: 24498,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dwarf planet ice)',
    english: 'Pluto (dwarf planet)',
    swedish: 'Pluto',
    norwegian: 'Pluto (planet)',
    finnish: 'pluto (planeetta)',
    hungarian: 'Plutó (törpeboglyó)',
    german: 'Pluto (Planet)',
    dutch: 'Pluto',
    afrikaans: 'Pluto (planeet)',
    russian: 'Плутон (планета)',
    latvian: 'Plutons (pundurplanēta)',
    polish: 'Pluton (planeta)',
    french: 'planète Pluton',
    spanish: 'Plutón',
  },
  {
    av: 24499,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limited time + to see + to hear)',
    english: 'program, programme, presentation',
    swedish: 'program, presentation',
    norwegian: 'program, presentasjon',
    finnish: 'ohjelma, esitys',
    hungarian: 'előadás, prezentáció, program',
    german: 'Programm, Präsentation',
    dutch: 'programma',
    afrikaans: 'program',
    russian: 'праграмма, презентация',
    latvian: 'programma, prezentācija',
    polish: 'program (TV, radiowy itp.)',
    french: 'programme',
    spanish: 'programa, presentación',
  },
  {
    av: 24500,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(reaction + action indicator)',
    english: 'react-(to)',
    swedish: 'reagera',
    norwegian: 'reagere',
    finnish: 'reagoida',
    hungarian: 'reagálni, visszahatni',
    german: 'auf etwas reagieren',
    dutch: 'reageren',
    afrikaans: 'reageer',
    russian: 'реагировать',
    latvian: 'reaģēt',
    polish: 'reagować, odpowiadać na …',
    french: 'réagir',
    spanish: 'reaccionar',
  },
  {
    av: 24501,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + backward, back + effect)',
    english: 'reaction',
    swedish: 'reaktion',
    norwegian: 'reaksjon',
    finnish: 'reaktio',
    hungarian: 'reakció, ellenhatás, visszahatás',
    german: 'Reaktion',
    dutch: 'reactie',
    afrikaans: 'reaksie',
    russian: 'реакция',
    latvian: 'reakcija',
    polish: 'reakcja, odpowiedź',
    french: 'réaction',
    spanish: 'reacción',
  },
  {
    av: 24502,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(entrance + question)',
    english: 'reception',
    swedish: 'reception',
    norwegian: 'resepsjon',
    finnish: 'vastaanotto',
    hungarian: 'recepció, fogadás',
    german: 'Empfang, Rezeption',
    dutch: 'receptie (onthaal), onthaal (Vl)',
    afrikaans: 'ontvangs',
    russian: 'приёмная, регистратура',
    latvian: 'uzņemšana, reģistratūra',
    polish: 'recepcja',
    french: 'réception, accueil',
    spanish: 'recepción',
  },
  {
    av: 24503,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + stop + work)',
    english: 'retirement pension',
    swedish: 'pension, avtalspension (etc)',
    norwegian: 'avtalepensjon',
    finnish: 'eläke',
    hungarian: 'öregségi nyugdíj',
    german: 'Rente, Pension',
    dutch: 'pensioenuitkering',
    afrikaans: 'aftree pensioen',
    russian: 'пенсия по выслуге лет',
    latvian: 'izdienas pensija',
    polish: 'emerytura',
    french: 'pension de retraite, rente de retraite',
    spanish: 'pensión de jubilación',
  },
  {
    av: 24504,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(planet + stone, rock)',
    english: 'rock planet, terrestrial planet',
    swedish: 'stenplanet',
    norwegian: 'stenplanet',
    finnish: 'maankaltainen-planeetta, kiviplaneetta',
    hungarian: 'földszerű, sziklás bolygók',
    german: 'Steinplanet',
    dutch: 'steenplaneet',
    afrikaans: 'aardse planeet',
    russian: ' скалистая планета',
    latvian: 'akmens iežu planēta',
    polish: 'planeta skalista, glob',
    french: 'planète rocheuse',
    spanish: 'planeta rocoso, planeta terrestre',
  },
  {
    av: 24505,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gas planet + ring)',
    english: 'Saturn (planet)',
    swedish: 'Saturnus',
    norwegian: 'Saturn (planet)',
    finnish: 'saturnus (planeetta)',
    hungarian: 'Szaturnusz (bolygó)',
    german: 'Saturn (Planet)',
    dutch: 'Saturnus',
    afrikaans: 'Saturnus (planeet)',
    russian: 'Сатурн (планета)',
    latvian: 'Saturns, planēta',
    polish: 'Saturn (planeta)',
    french: 'planète Saturne',
    spanish: 'Saturno',
  },
  {
    av: 24506,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(finger + back and forth)',
    english: 'scratch',
    swedish: 'kliande',
    norwegian: 'kløe, kløing',
    finnish: 'naarmu, raapaisu',
    hungarian: 'vakarás, vakarózás, kaparás, kapirgálás',
    german: 'Kratzen',
    dutch: 'krab (wond)',
    afrikaans: 'krap (om te)',
    russian: 'чесание рукой',
    latvian: 'skramba, nobrāzums',
    polish: 'zadrapanie',
    french: 'griffe, grattement',
    spanish: 'arañazo',
  },
  {
    av: 24507,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(scratch + action indicator)',
    english: 'scratch-(to)',
    swedish: 'klia',
    norwegian: 'klø',
    finnish: 'raapaista, raapia, kynsiä',
    hungarian: 'vakarni, vakarózni, kaparni, kapirgálni',
    german: 'kratzen',
    dutch: 'krabben',
    afrikaans: 'krap (om te)',
    russian: 'чесать(ся)',
    latvian: 'skrāpēt, norīvēt, noberzt',
    polish: 'zadrapać, podrapać',
    french: 'gratter, griffer',
    spanish: 'rayar',
  },
  {
    av: 24508,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + old)',
    english: 'senior citizen',
    swedish: 'senior, äldre person',
    norwegian: 'senior, eldre person',
    finnish: 'vanhus',
    hungarian: 'nyugdíjas (fn.), nyugdíjas állampolgár',
    german: 'älterer Bürger, ältere Bürgerin',
    dutch: 'senior, oudere',
    afrikaans: 'senior burger',
    russian: 'пожилой человек',
    latvian: 'vecāka gadagājuma pilsonis',
    polish: 'emeryt, senior, staruszek, człowiek w podeszłym wieku',
    french: 'personne âgée (du troisième âge)',
    spanish: 'persona mayor',
  },
  {
    av: 24509,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(letter + telephone)',
    english: 'short message system (SMS), text message',
    swedish: 'SMS',
    norwegian: 'SMS, tekstmelding',
    finnish: 'tekstiviesti',
    hungarian: 'SMS, szöveges üzenet',
    german: '(SMS) versenden, (Textnachricht) versenden',
    dutch: 'SMS, tekstbericht',
    afrikaans: '(SMS) teksboodskap, kort boodskap stelsel',
    russian: 'СМС',
    latvian: 'īsziņa, teksta ziņa, SMS',
    polish: 'sms, krótka wiadomość tekstowa',
    french: 'SMS, message texte, texto',
    spanish: 'SMS, mensaje de texto',
  },
  {
    av: 24510,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + silver [contr.])',
    english: 'silversmith',
    swedish: 'silversmed',
    norwegian: 'sølvsmed',
    finnish: 'hopeaseppä',
    hungarian: 'ezüstműves',
    german: 'Schmied, Schmiedin',
    dutch: 'zilversmid',
    afrikaans: 'silwersmit',
    russian: 'серебряник (серебряных дел мастер)',
    latvian: 'sudrabkalis',
    polish: 'złotnik',
    french: 'orfèvre (argent)',
    spanish: 'platero',
  },
  {
    av: 24511,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bath, washing + thing indicator) - (character with thing indicator)',
    english: 'sink, basin',
    swedish: 'tvättställ, handfat (etc)',
    norwegian: 'fat, balje',
    finnish: 'pesuallas, lavuaari, tiskiallas',
    hungarian: 'mosdókagyló, mosdótál, mosogató',
    german: 'Waschbecken, Spülbecken',
    dutch: 'gootsteen, wastafel, lavabo',
    afrikaans: 'wasbak',
    russian: ' умывальник, раковина',
    latvian: 'izlietne',
    polish: 'zlew, umywalka, zlewozmywak',
    french: 'lavabo, évier, bassin',
    spanish: 'fregadero',
  },
  {
    av: 24512,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(addiction + smoking) SYMBOL SYNONYM',
    english: 'smoking addiction (2)',
    swedish: 'nikotinberoende, nikotinmissbruk (2)',
    norwegian: 'nikotinavhengighet, nikotinmisbruk (2)',
    finnish: 'tupakkariippuvuus, riippuvuus tupakasta',
    hungarian: 'dohányfüggő, nikotinista',
    german: 'Nikotinabhängigkeit (2)',
    dutch: 'rookverslaving, nicotineverslaving (2)',
    afrikaans: 'rook verslawing (2)',
    russian: 'никотиновая зависимость (2)',
    latvian: 'smēķēšanas atkarība (2)',
    polish: 'palenie narkotyków (1)',
    french: 'dépendance au tabac (2)',
    spanish: 'adicción al tabaco (1)',
  },
  {
    av: 24513,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(negative dependency + smoking) SYMBOL SYNONYM',
    english: 'smoking addiction (1)',
    swedish: 'nikotinberoende, nikotinmissbruk (1)',
    norwegian: 'nikotinavhengighet, nikotinmisbruk (1)',
    finnish: 'tupakkariippuvuus, riippuvuus tupakasta',
    hungarian: 'dohányszenvedély, cigarettaszenvedély',
    german: 'Nikotinabhängigkeit (1)',
    dutch: 'rookverslaving, nicotineverslaving (1)',
    afrikaans: 'rook verslawing (1)',
    russian: 'никотиновая зависимость (1)',
    latvian: 'smēķēšanas atkarība (1)',
    polish: 'palenie narkotyków (2)',
    french: 'dépendance au tabac (1)',
    spanish: 'adicción al tabaco (2)',
  },
  {
    av: 24516,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + water) SYMBOL SYNONYM',
    english: 'tap (1)',
    swedish: 'vattenkran (1)',
    norwegian: 'vannkran (1)',
    finnish: 'hana',
    hungarian: 'vízcsap, csap',
    german: 'Wasserhahn (1)',
    dutch: 'kraan (water) (1)',
    afrikaans: 'kraan (water) (1)',
    russian: 'водопроводный кран (1)',
    latvian: 'krāns (1)',
    polish: 'kran (1)',
    french: 'robinet (1)',
    spanish: 'grifo (1)',
  },
  {
    av: 24517,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + to cause + water) SYMBOL SYNONYM',
    english: 'tap (2)',
    swedish: 'vattenkran (2)',
    norwegian: 'vannkran (2)',
    finnish: 'vesihana',
    hungarian: 'vízcsap, csap',
    german: 'Wasserhahn (2)',
    dutch: 'kraan (water) (2)',
    afrikaans: 'kraan (water) (2)',
    russian: 'водопроводный кран (2)',
    latvian: 'krāns (2)',
    polish: 'kran (2)',
    french: 'robinet (2)',
    spanish: 'grifo (2)',
  },
  {
    av: 24519,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + therapy)',
    english: 'treatment',
    swedish: 'behandling',
    norwegian: 'behandling',
    finnish: 'kuntoutus',
    hungarian: 'kezelés, gyógykezelés, eljárás',
    german: 'medizinische Behandlung, ärztliche Behandlung',
    dutch: 'behandeling, therapie',
    afrikaans: 'behandeling, ',
    russian: 'лечение',
    latvian: 'ārstniecība ',
    polish: 'leczenie, kuracja, terapia',
    french: 'traitement',
    spanish: 'tratamiento',
  },
  {
    av: 24520,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(all + galaxy)',
    english: 'Universe',
    swedish: 'Universum',
    norwegian: 'universet',
    finnish: 'universumi, maailmankaikkeus',
    hungarian: 'világegyetem, univerzum',
    german: 'Universum, Weltall',
    dutch: 'universum',
    afrikaans: 'heelal',
    russian: 'Вселенная',
    latvian: 'Visums, pasaule, kosmoss',
    polish: 'wszechświat',
    french: 'Univers',
    spanish: 'Universo',
  },
  {
    av: 24521,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gas planet + ice)',
    english: 'Uranus (planet)',
    swedish: 'Uranus',
    norwegian: 'Uranus (planet)',
    finnish: 'uranus (planeetta)',
    hungarian: 'Uranusz (bolygó)',
    german: 'Uranus (Planet)',
    dutch: 'Uranus',
    afrikaans: 'Uranus (planeet)',
    russian: 'Уран (планета)',
    latvian: 'Urāns (planēta)',
    polish: 'Uran (planeta)',
    french: 'planète Uranus',
    spanish: 'Urano ',
  },
  {
    av: 24522,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rock planet + cloud)',
    english: 'Venus (planet)',
    swedish: 'Venus',
    norwegian: 'Venus (planet)',
    finnish: 'venus (planeetta)',
    hungarian: 'Vénusz (bolygó)',
    german: 'Venus (Planet)',
    dutch: 'Venus',
    afrikaans: 'Venus (planeet)',
    russian: 'Венера (планета)',
    latvian: 'Venēra, planēta',
    polish: 'Wenus (planeta)',
    french: 'planète Vénus',
    spanish: 'Venus ',
  },
  {
    av: 24523,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + virus)',
    english: 'viral infection',
    swedish: 'virusinfektion',
    norwegian: 'virusinfeksjon',
    finnish: 'virusinfektio',
    hungarian: 'vírusfertőzés',
    german: 'Virusinfektion',
    dutch: 'virale infectie',
    afrikaans: 'virale infeksie',
    russian: 'вирусная инфекция',
    latvian: 'vīrusu infekcija',
    polish: 'zakażenie wirusowe',
    french: 'infection virale',
    spanish: 'infección viral',
  },
  {
    av: 24524,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(micro-organism + duplicate: replicating microorganism)',
    english: 'virus',
    swedish: 'virus',
    norwegian: 'virus',
    finnish: 'virus',
    hungarian: 'vírus',
    german: 'Virus',
    dutch: 'virus',
    afrikaans: 'virus',
    russian: 'вирус',
    latvian: 'vīruss',
    polish: 'wirus',
    french: 'virus',
    spanish: 'virus',
  },
  {
    av: 24525,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + young)',
    english: 'young animal',
    swedish: 'ungdjur',
    norwegian: 'ungdyr',
    finnish: 'nuori eläin',
    hungarian: 'állatkölyök',
    german: 'junges Tier',
    dutch: 'jong (zelfst.nw dier)',
    afrikaans: 'jong dier',
    russian: 'молодняк, молодое животное',
    latvian: 'jauns dzīvnieks',
    polish: 'młode zwierzę',
    french: 'jeune (animal)',
    spanish: 'cachorro',
  },
  {
    av: 24602,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(exchange + signal + thing indicator)',
    english: 'aerial, antenna',
    swedish: 'antenn',
    norwegian: 'antenne',
    finnish: 'antenni',
    hungarian: 'antenna, légvezeték',
    german: 'Antenne',
    dutch: 'antenne',
    afrikaans: 'lugdraad, antenna',
    russian: 'антенна',
    latvian: 'antena',
    polish: 'antena',
    french: 'antenne',
    spanish: 'antena aérea',
  },
  {
    av: 24603,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plan + gathering)',
    english: 'agenda',
    swedish: 'dagordning',
    norwegian: 'agenda, møteplan',
    finnish: 'esityslista, ohjelma',
    hungarian: 'napirend',
    german: 'Tagesordnung, Geschäftsordnung',
    dutch: 'agenda (planning)',
    afrikaans: 'agenda',
    russian: 'повестка дня',
    latvian: 'dienas kārtība',
    polish: 'porządek obrad, program spotkania',
    french: 'agenda',
    spanish: 'agenda del día',
  },
  {
    av: 24604,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + stop + boat)',
    english: 'anchor',
    swedish: 'ankare',
    norwegian: 'anker',
    finnish: 'ankkuri',
    hungarian: 'horgony',
    german: 'Anker',
    dutch: 'anker',
    afrikaans: 'anker',
    russian: 'якорь',
    latvian: 'enkurs',
    polish: 'kotwica',
    french: 'ancre',
    spanish: 'ancla',
  },
  {
    av: 24607,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(land + tiger)',
    english: 'Bangladesh',
    swedish: 'Bangladesh',
    norwegian: 'Bangladesh',
    finnish: 'Bangladesh',
    hungarian: 'Banglades',
    german: 'Bangladesch',
    dutch: 'Bangladesh',
    afrikaans: 'Bangladesh',
    russian: 'Бангладеш',
    latvian: 'Bangladeša',
    polish: 'Bangladesz',
    french: 'Bangladesh',
    spanish: 'Bangladesh',
  },
  {
    av: 24608,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(grain + straw + long: ear of grain with long tassels)',
    english: 'barley',
    swedish: 'korn',
    norwegian: 'bygg',
    finnish: 'ohra',
    hungarian: 'árpa',
    german: 'Gerste',
    dutch: 'gerst',
    afrikaans: 'gars',
    russian: 'ячмень',
    latvian: 'mieži',
    polish: 'jęczmień',
    french: 'orge',
    spanish: 'cebada',
  },
  {
    av: 24610,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bed + boat)',
    english: 'berth, bunk',
    swedish: 'koj, brits',
    norwegian: 'køye',
    finnish: 'ankkuripaikka, punkka',
    hungarian: 'hálóhely (hajón)',
    german: 'Schlafkoje, Liegeplatz',
    dutch: 'kooi (boot)',
    afrikaans: 'kajuitbed',
    russian: 'койка (судно)',
    latvian: 'kajīte, kuģa',
    polish: 'koja (na statku)',
    french: 'couchette (de bateau)',
    spanish: 'litera, cucheta',
  },
  {
    av: 24611,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + leader)',
    english: 'board, board of directors, executive',
    swedish: 'styrelse',
    norwegian: 'styre (subst.)',
    finnish: 'toimeenpaneva elin, lautakunta',
    hungarian: 'vezetőség, irányító testület',
    german: 'Vorstand',
    dutch: 'bestuur (zelfst.nw)',
    afrikaans: 'raad van direkteure, uitvoerend',
    russian: 'правление, совет директоров',
    latvian: 'valde, direkcija, izpildorgāns',
    polish: 'zarząd, rada zarządu',
    french: "conseil d'administration, direction (cadre de)",
    spanish: 'junta de directores, ejecutivos',
  },
  {
    av: 24612,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ladder + boat)',
    english: 'boat ladder',
    swedish: 'lejdare',
    norwegian: 'båtleider',
    finnish: 'venetikkaat',
    hungarian: 'hajólétra',
    german: 'Leiter für Boote, Badeleiter',
    dutch: 'bootladder, touwladder (boot)',
    afrikaans: 'boot leer',
    russian: 'лестница на судне',
    latvian: 'laivas kāpnes',
    polish: 'trap',
    french: 'échelle (de bateau)',
    spanish: 'escala (de un barco)',
  },
  {
    av: 24613,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + car)',
    english: 'boot, trunk, roof box, luggage compartment',
    swedish: 'bagageutrymme, takbox',
    norwegian: 'takboks',
    finnish: 'tavaratila, takakontti, matkatavaratila, matkatavarasäiliö',
    hungarian: 'csomagtartó, tetőcsomagtartó',
    german: 'Kofferraum, Dachbox',
    dutch: 'dakkoffer',
    afrikaans: 'kattebak, bagasie kompartement',
    russian: 'багажник',
    latvian: 'bagažnieks, bagāžas novietne, nodalījums',
    polish: 'bagażnik, bagażnik dachowy',
    french: 'coffre, coffre de toit (voiture)',
    spanish: 'maletero, portamaletas, portaequipajes',
  },
  {
    av: 24615,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(signal + action indicator)',
    english: 'broadcast, transmit-(to)',
    swedish: 'sända ut, överföra',
    norwegian: 'kringkaste, overføre',
    finnish: 'lähettää ohjelmaa, kuuluttaa',
    hungarian: 'közvetíteni, sugározni, leadni',
    german: 'Übertragung, Sendung',
    dutch: 'uitzenden (TV radio)',
    afrikaans: 'uitsending, transmissie (om te)',
    russian: 'транслировать, передавать',
    latvian: 'pārraidīt',
    polish: 'transmisja, przekaz',
    french: 'émettre, transmettre',
    spanish: 'transmitir',
  },
  {
    av: 24616,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + noise)',
    english: 'buzzer',
    swedish: 'summer, larm (etc)',
    norwegian: 'lydsignal, alarm',
    finnish: 'summeri',
    hungarian: 'berregő, jelzőhang',
    german: 'Wecker, Summer',
    dutch: 'zoemer, bel',
    afrikaans: 'bel',
    russian: 'сигнализация, зуммер',
    latvian: 'zummers',
    polish: 'brzęczyk, dzwonek, sygnał dźwiękowy',
    french: 'sirène, sonnerie, sifflet',
    spanish: 'zumbador',
  },
  {
    av: 24617,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + boat)',
    english: 'cabin (boat)',
    swedish: 'hytt',
    norwegian: 'lugar',
    finnish: 'hytti',
    hungarian: 'hajókabin',
    german: 'Häuschen, Hütte',
    dutch: 'hut (boot), kajuit',
    afrikaans: 'kajuit (boot)',
    russian: 'каюта',
    latvian: 'kabīne, kajīte (kuģa)',
    polish: 'kabina (łódź)',
    french: 'cabine (bateau)',
    spanish: 'cabina (barco)',
  },
  {
    av: 24618,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(car + house)',
    english: 'camper van, RV',
    swedish: 'husbil',
    norwegian: 'bobil',
    finnish: 'asuntoauto',
    hungarian: 'lakókocsi, lakóautó',
    german: 'Wohnmobil',
    dutch: 'kampeerauto',
    afrikaans: 'karavaan',
    russian: 'кемпер, автодом',
    latvian: 'autofurgons, pārvadājamā māja, treileris',
    polish: 'karawaning (samochód kempingowy)',
    french: 'camping-car',
    spanish: 'autocaravana, camper, casa rodante',
  },
  {
    av: 24619,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(waterway + man-made)',
    english: 'canal (water)',
    swedish: 'kanal',
    norwegian: 'kanal (vann)',
    finnish: 'kanava, kanaali',
    hungarian: 'csatorna',
    german: 'Kanal',
    dutch: 'kanaal',
    afrikaans: 'kanaal (water)',
    russian: 'водный канал',
    latvian: 'kanāls, ūdens',
    polish: 'kanał (woda)',
    french: 'canal (voie fluviale)',
    spanish: 'canal (acuático)',
  },
  {
    av: 24620,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(leader + help)',
    english: 'care manager, care plan manager',
    swedish: 'vårdplanerare',
    norwegian: 'omsorgsleder',
    finnish: 'palveluohjaaja',
    hungarian: 'gondozásirányító, ellátásszervező',
    german: 'Pflegemanager, Pflegemanagerin',
    dutch: 'zorgmanager',
    afrikaans: 'sorg bestuurder, sorg plan bestuurder',
    russian: 'куратор (менеджер) по уходу',
    latvian: 'aprūpes organizators, aprūpes menedžeris',
    polish: 'kierownik opieki, kierownik planu opieki, osoba nadzorująca pomoc',
    french: 'chef du service social',
    spanish: 'tramitador planificador de asistencia médica',
  },
  {
    av: 24621,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(disc + file)',
    english: 'CD',
    swedish: 'CD',
    norwegian: 'CD',
    finnish: 'data-CD, romppu',
    hungarian: 'CD',
    german: 'CD, Kompaktdisk',
    dutch: 'CD',
    afrikaans: 'CD',
    russian: 'CD',
    latvian: 'CD disks',
    polish: 'CD, DVD (płyta kompaktowa)',
    french: 'CD',
    spanish: 'CD',
  },
  {
    av: 24622,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(signal + choice)',
    english: 'channel (programs)',
    swedish: 'kanal (TV, radio etc)',
    norwegian: 'kanal (TV, radio o.l.)',
    finnish: 'ohjelmakanava',
    hungarian: 'tv csatorna, programcsatorna ',
    german: 'Kanal, Programm',
    dutch: 'kanaal (TV radio)',
    afrikaans: 'kanaal (TV radio)',
    russian: 'каналл (TV, радио и пр.)',
    latvian: 'kanāls, programma',
    polish: 'kanał, program (TV, radio)',
    french: 'chaîne (programme TV)',
    spanish: 'canal (programas)',
  },
  {
    av: 24623,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(song + Christmas [contr.])',
    english: 'Christmas song, carol',
    swedish: 'julsång',
    norwegian: 'julesang',
    finnish: 'joululaulu',
    hungarian: 'karácsonyi dal',
    german: 'Weihnachtslied',
    dutch: 'kertlied',
    afrikaans: 'Kersfees liedjie',
    russian: 'рождественская песня',
    latvian: 'Ziemassvētku dziesma',
    polish: 'pastorałka, kolęda',
    french: 'chant de Noël',
    spanish: 'villancico',
  },
  {
    av: 24624,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(satellite + exchange, substitution: exchange representing communication [contr.])',
    english: 'communication satellite',
    swedish: 'kommunikationssatellit',
    norwegian: 'kommunikasjonssatelitt',
    finnish: 'tietoliikennesatelliitti',
    hungarian: 'távközlési műhold',
    german: 'Kommunikationssatellit',
    dutch: 'communicatiesateliet',
    afrikaans: 'kommunikasie satelliet',
    russian: 'спутниковая связь',
    latvian: 'komunikācijas satelīts',
    polish: 'satelita telekomunikacyjny',
    french: 'satellite de communication',
    spanish: 'satélite de comunicación',
  },
  {
    av: 24625,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + train)',
    english: 'compartment',
    swedish: 'kupé',
    norwegian: 'togkupe',
    finnish: 'vaunuosasto',
    hungarian: 'fülke, szakasz',
    german: 'Abteilung, Coupé',
    dutch: 'compartiment',
    afrikaans: 'kompartement',
    russian: 'купе ',
    latvian: 'nodalījums, kupeja',
    polish: 'przedział (w wagonie)',
    french: 'compartiment (train)',
    spanish: 'compartimento',
  },
  {
    av: 24626,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + north + thing indicator)',
    english: 'compass',
    swedish: 'kompass',
    norwegian: 'kompass',
    finnish: 'kompassi',
    hungarian: 'iránytű',
    german: 'Kompass',
    dutch: 'kompas',
    afrikaans: 'kompas',
    russian: 'компас',
    latvian: 'kompass',
    polish: 'kompas',
    french: 'boussole',
    spanish: 'brújula',
  },
  {
    av: 24627,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(entrance + digits (computer))',
    english: 'connection (computer)',
    swedish: 'anslutning, koppling, kontakt (dator)',
    norwegian: 'kontakt (PC)',
    finnish: 'tietokoneen kytkentä',
    hungarian: 'csatlakozás, kapcsolat, összeköttetés (szgép)',
    german: 'Verbindung',
    dutch: 'aansluiting (computer), verbinding (computer)',
    afrikaans: 'koppelvlak (rekenaar)',
    russian: 'соединение (ПК)',
    latvian: 'savienojums, datora',
    polish: 'połączenie (komputer)',
    french: 'connexion (ordinateur)',
    spanish: 'conexión (ordenador)',
  },
  {
    av: 24628,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(connection + thing indicator)',
    english: 'connector, interface box',
    swedish: 'adapter, kopplingsdosa',
    norwegian: 'kontakt, koblingsboks',
    finnish: 'adapteri, sovitin',
    hungarian: 'csatlakozó, illesztőegység, interfész',
    german: 'Adapter, Steckverbinder',
    dutch: 'interface, connector',
    afrikaans: 'verbindingsboks, koppelvlak boks',
    russian: 'разъём, интерфейсный блок',
    latvian: 'savienojums, interfeiss, saskarne',
    polish: 'złącze, interfejs',
    french: 'connecteur',
    spanish: 'adaptador, caja de conexión',
  },
  {
    av: 24630,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hole + narrow)',
    english: 'crack, gap, cleft',
    swedish: 'spricka',
    norwegian: 'kløft, sprekk',
    finnish: 'halkeama, rako, railo, kuilu',
    hungarian: 'rés, nyílás, hézag, hasadék',
    german: 'Riss, Sprung, Lücke',
    dutch: 'scheur, spleet',
    afrikaans: 'kraak, gat, spleet, skeur',
    russian: 'трещина, расщелина ',
    latvian: 'plaisa, sprauga, atstarpe',
    polish: 'pęknięcie, przerwa, luka, rozszczep',
    french: 'trouer, faire une brèche, fêler, crevasser',
    spanish: 'grieta, hendidura',
  },
  {
    av: 24631,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(opening + volcano)',
    english: 'crater',
    swedish: 'krater',
    norwegian: 'krater',
    finnish: 'kraatteri',
    hungarian: 'kráter',
    german: 'Krater',
    dutch: 'krater',
    afrikaans: 'krater',
    russian: 'кратер вулкана',
    latvian: 'krāteris',
    polish: 'krater wulkanu',
    french: 'cratère',
    spanish: 'cráter',
  },
  {
    av: 24632,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + future: money you pay after time agreed upon)',
    english: 'credit',
    swedish: 'kredit',
    norwegian: 'kreditt',
    finnish: 'luotto',
    hungarian: 'hitel',
    german: 'Kredit',
    dutch: 'krediet',
    afrikaans: 'krediet',
    russian: 'кредит',
    latvian: 'kredīts',
    polish: 'kredyt',
    french: 'crédit',
    spanish: 'crédito',
  },
  {
    av: 24633,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(card + credit)',
    english: 'credit card',
    swedish: 'kreditkort',
    norwegian: 'kredittkort',
    finnish: 'luottokortti',
    hungarian: 'hitelkártya',
    german: 'Kreditkarte',
    dutch: 'kredietkaart, creditcard',
    afrikaans: 'kredietkaart',
    russian: 'кредитная карточка',
    latvian: 'kredītkarte',
    polish: 'karta kredytowa',
    french: 'carte de crédit',
    spanish: 'tarjeta de crédito',
  },
  {
    av: 24634,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(group of + worker)',
    english: 'crew, staff',
    swedish: 'personal, arbetsstyrka, besättning',
    norwegian: 'personale, stab',
    finnish: 'henkilökunta, miehistö',
    hungarian: 'személyzet, stáb, csapat, munkatársak',
    german: 'Besatzung, Mannschaft, Bemannung',
    dutch: 'staf (personeel), boordpersoneel',
    afrikaans: 'personeel, bemanning',
    russian: 'трудовой коллектив, команда',
    latvian: 'komanda, ekipāža, brigāde',
    polish: 'załoga, pracownicy',
    french: 'équipe',
    spanish: 'tripulación, personal',
  },
  {
    av: 24635,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(crew, staff + boat)',
    english: 'crew (boat)',
    swedish: 'besättning (båt)',
    norwegian: 'mannskap (båt)',
    finnish: 'laivan miehistö',
    hungarian: 'legénység (hajó)',
    german: 'Bootsmannschaft (Boot)',
    dutch: 'boordpersoneel (boot), bemanning (boot)',
    afrikaans: 'personeel (boot), boot bemanning',
    russian: 'судовая команда',
    latvian: 'komanda, apkalpe, kuģa',
    polish: 'załoga (łódź)',
    french: 'équipage (de bateau)',
    spanish: 'tripulación (barco)',
  },
  {
    av: 24636,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(crew, staff + airplane)',
    english: 'crew (plane)',
    swedish: 'besättning (flygplan)',
    norwegian: 'flypersonale, crew',
    finnish: 'lentokoneen miehistö',
    hungarian: 'legénység (repülő)',
    german: 'Kabinenbesatzung (Flugzeug)',
    dutch: 'boordpersoneel (vliegtuig), bemanning (vliegtuig)',
    afrikaans: 'personeel (vliegtuig), kajuitpersoneel',
    russian: 'экипаж',
    latvian: 'komanda, lidmašīnas',
    polish: 'załoga (samolot)',
    french: 'équipage (avion)',
    spanish: 'tripulación (avión)',
  },
  {
    av: 24637,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(need + intensity + description indicator)',
    english: 'dependent',
    swedish: 'beroende (adj.)',
    norwegian: 'avhengig',
    finnish: 'riippuvainen',
    hungarian: 'függő, eltartott',
    german: 'der Abhängige',
    dutch: 'afhankelijk',
    afrikaans: 'afhanklik',
    russian: 'зависимый',
    latvian: 'atkarīgs',
    polish: 'zależny',
    french: 'dépendant',
    spanish: 'dependiente',
  },
  {
    av: 24639,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(signal + digits)',
    english: 'digital signal',
    swedish: 'signal (digital), digital signal',
    norwegian: 'digitalt signal',
    finnish: 'digitaalinen signaali',
    hungarian: 'digitális jel',
    german: 'digitales Signal',
    dutch: 'digitaal signaal',
    afrikaans: 'digitale sein',
    russian: 'цифровой сигнал',
    latvian: 'digitāls, elektronisks signāls',
    polish: 'sygnał cyfrowy',
    french: 'signal numérique',
    spanish: 'señal digital',
  },
  {
    av: 24640,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(file, data file (digital) + future: combination of file and save)',
    english: 'digital memory, digital storage',
    swedish: 'datalagring, digitalt minne, dataminne',
    norwegian: 'digital lagring',
    finnish: 'digitaalinen tallennus',
    hungarian: 'digitális memória',
    german: 'Digitalspeicher, digitale Datenspeicherung',
    dutch: 'geheugen (computer), digitaal geheugen',
    afrikaans: 'digitale geheue',
    russian: 'цифровая память',
    latvian: 'elektroniska atmiņa, uzglabāšana',
    polish: 'przechowywanie cyfrowe',
    french: 'fichier de sauvegarde',
    spanish: 'memorial digital, almacenamiento digital',
  },
  {
    av: 24641,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(digital device + save)',
    english: 'digital storage device',
    swedish: 'digital lagringsenhet, lagringsminne (digitalt)',
    norwegian: 'digital lagringsenhet',
    finnish: 'digitaalinen tallennusväline',
    hungarian: 'digitális tárolóeszköz',
    german: 'digitales Speichergerät',
    dutch: 'digitaal geheugen toestel',
    afrikaans: 'digitale stoor toestel',
    russian: 'цифровое запоминающее устройство',
    latvian: 'elektroniskās uzglabāšanas iekārta',
    polish: 'cyfrowe urządzenie magazynujące (dysk, dyskietka itp.)',
    french: 'support de sauvegarde, disque de sauvegarde',
    spanish: 'dispositivo de almacenamiento digital',
  },
  {
    av: 24642,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(feeling + rotation + description indicator)',
    english: 'dizzy',
    swedish: 'yr',
    norwegian: 'ør, svimmel',
    finnish: 'huimaava, pyörryttävä, heikottava',
    hungarian: 'szédülő, szédítő',
    german: 'schwindlig',
    dutch: 'duizelig',
    afrikaans: 'duiselig',
    russian: 'головокружительный',
    latvian: 'reibonis',
    polish: 'zawrót głowy, mdłości',
    french: 'étourdi, vertigineux',
    spanish: 'mareo',
  },
  {
    av: 24643,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(document [contr.] + digits (computer))',
    english: 'document (electronic), digital document',
    swedish: 'dokument (elektroniskt), digitalt dokument',
    norwegian: 'dokument (elektronisk)',
    finnish: 'sähköinen asiakirja, sähköinen dokumentti',
    hungarian: 'digitális dokumentum, elektronikus feljegyzés',
    german: 'Dokument (elektronisch)',
    dutch: 'document (computer)',
    afrikaans: 'dokument (rekenaar)',
    russian: 'электронный документ',
    latvian: 'dokuments, elektronisks, digitāls',
    polish: 'dokument (cyfrowy)',
    french: 'document (informatique)',
    spanish: 'documento (electrónico), documento digital',
  },
  {
    av: 24644,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(anchor + action indicator)',
    english: 'drop anchor-(to)',
    swedish: 'ankra, kasta ankar',
    norwegian: 'kaste anker, ankre',
    finnish: 'laskea ankkuri, pudottaa ankkuri',
    hungarian: 'horgonyt vetni, lehorgonyozni',
    german: 'ankern',
    dutch: 'voor anker gaan',
    afrikaans: 'anker gooi (om te)',
    russian: 'бросать якорь',
    latvian: 'izmest enkuru',
    polish: 'zakotwiczyć, rzucić kotwicę',
    french: "jeter l'ancre",
    spanish: 'echar anclas',
  },
  {
    av: 24645,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(recording disk + many + file)',
    english: 'DVD',
    swedish: 'DVD',
    norwegian: 'DVD',
    finnish: 'DVD-levy',
    hungarian: 'DVD',
    german: 'DVD',
    dutch: 'DVD',
    afrikaans: 'DVD',
    russian: 'DVD',
    latvian: 'DVD disks',
    polish: 'DVD (czytnik dvd w komputerze)',
    french: 'DVD',
    spanish: 'DVD',
  },
  {
    av: 24646,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(recording disk + eye + ear: a disk for seeing images and film, and listening to sounds and music)',
    english: 'DVD, movie disc',
    swedish: 'DVD-film',
    norwegian: 'DVD film',
    finnish: 'DVD-elokuva',
    hungarian: 'DVD, filmlemez',
    german: 'DVD-Film',
    dutch: 'DVD, DVD film',
    afrikaans: 'DVD film',
    russian: 'DVD фильм, диск',
    latvian: 'DVD disks, filma',
    polish: 'DVD (film na DVD)',
    french: 'DVD, disque vidéo',
    spanish: 'DVD (disco de películas)',
  },
  {
    av: 24647,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + DVD, movie disc)',
    english: 'DVD player',
    swedish: 'DVD-spelare',
    norwegian: 'DVD spiller',
    finnish: 'DVD-soitin',
    hungarian: 'DVD lejátszó',
    german: 'DVD-Spieler',
    dutch: 'DVD speler',
    afrikaans: 'DVD speler',
    russian: 'DVD проигрыватель',
    latvian: 'DVD diska atskaņotājs',
    polish: 'odtwarzacz dvd (stacjonarny)',
    french: 'lecteur de DVD',
    spanish: 'reproductor de DVD',
  },
  {
    av: 24651,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(eruption + action indicator)',
    english: 'erupt-(to)',
    swedish: 'få utbrott (vulkan)',
    norwegian: 'ha utbrudd (vulkan)',
    finnish: 'purkautua (tulivuori)',
    hungarian: 'kitörni (vulkán)',
    german: 'aufkommen, aufbrausen, ausbrechen',
    dutch: 'uitbarsten (vulkaan)',
    afrikaans: 'uitbars (om te)',
    russian: 'извергать',
    latvian: 'izvirst',
    polish: 'wybuchać (o wulkanie)',
    french: 'entrer en éruption',
    spanish: 'erupcionar',
  },
  {
    av: 24652,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(steam + volcano)',
    english: 'eruption',
    swedish: 'vulkanutbrott, utbrott',
    norwegian: 'vulkanutbrudd',
    finnish: 'tulivuorenpurkaus',
    hungarian: 'kitörés, vulkánkitörés, erupció',
    german: 'Vulkanausbruch, Eruption',
    dutch: 'uitbarsting (vulkaan)',
    afrikaans: 'uitbarsting',
    russian: 'извержение',
    latvian: 'izvirdums',
    polish: 'wybuch, erupcja',
    french: 'éruption',
    spanish: 'erupción',
  },
  {
    av: 24653,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(exchange + thing indicator) - (character with thing indicator) To be used with specifiers, e.g., heat exchanger, air exchanger, etc. ',
    english: 'exchanger',
    swedish: 'omvandlare',
    norwegian: 'veksler, omformer',
    finnish: 'vaihtaja',
    hungarian: 'cserélő (pl. hőcserélő)',
    german: 'Tauscher, Austauscher, Umwandler',
    dutch: 'uitwisselaar',
    afrikaans: 'wisselaar',
    russian: 'обменник, конвертор',
    latvian: 'apmainītājs',
    polish: 'zamiennik',
    french: 'échangeur',
    spanish: 'convertidor',
  },
  {
    av: 24654,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(digital storage device + big)',
    english: 'external hard drive',
    swedish: 'extern hårddisk',
    norwegian: 'ekstern harddisk, harddisk, ekstern',
    finnish: 'ulkoinen kiintolevy',
    hungarian: 'külső meghajtó',
    german: 'externes Laufwerk (Computer)',
    dutch: 'externe harde schijf',
    afrikaans: 'eksterne hardeskyf',
    russian: 'внешний жёсткий диск',
    latvian: 'ārējais cietais disks',
    polish: 'zewnętrzny dysk twardy',
    french: 'disque dur externe',
    spanish: 'disco duro externo',
  },
  {
    av: 24655,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(explosion + many + colour)',
    english: 'firework',
    swedish: 'fyrverkeri',
    norwegian: 'fyrverkeri',
    finnish: 'ilotulite',
    hungarian: 'tűzijáték',
    german: 'Feuerwerk',
    dutch: 'vuurwerk',
    afrikaans: 'vuurwerk, klapper',
    russian: 'фейерверк',
    latvian: 'uguņošana',
    polish: 'fajerwerk, sztuczne ognie',
    french: "feux d'artifice",
    spanish: 'fuegos artificiales',
  },
  {
    av: 24656,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cage + fish)',
    english: 'fish cage',
    swedish: 'fisksump',
    norwegian: 'fiskenett',
    finnish: 'katiska',
    hungarian: 'halketrec',
    german: 'Fischkasten',
    dutch: 'fuik',
    afrikaans: 'vis hok vistenk',
    russian: 'отстойник для рыбы',
    latvian: 'zivjaudzētava',
    polish: 'sieć, klatka dla ryb',
    french: 'casier (à poissons)',
    spanish: 'vivero de peces',
  },
  {
    av: 24657,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(potato [contr.] + linear thing + oil + thing indicator) Preferred NEW SYNONYM, replacing 14398',
    english: 'French fries, chips',
    swedish: 'pommes frites (etc)',
    norwegian: 'franske poteter, chips (o.l.)',
    finnish: 'ranskalaiset perunat, sipsit, perunalastut',
    hungarian: 'hasábburgonya, szalmakrumpli, rósejbni',
    german: 'Pommes frites, Pommes',
    dutch: 'frieten (Vl), patates frites (Nl), friet',
    afrikaans: 'gebakte aartappel skyfies',
    russian: 'картофель фри',
    latvian: 'franču kartupeļu čipsi',
    polish: 'frytki',
    french: 'frite',
    spanish: 'patatas fritas',
  },
  {
    av: 24658,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(kitchen + boat)',
    english: 'galley (boat)',
    swedish: 'kabyss, pentry (båt)',
    norwegian: 'bysse (båt)',
    finnish: 'laivan keittiö',
    hungarian: 'hajókonyha',
    german: 'Galeere, Schiffsküche',
    dutch: 'kombuis',
    afrikaans: 'galei (boot)',
    russian: 'камбуз',
    latvian: 'galera, laivas veids',
    polish: 'kambuz (kuchnia na statku, łodzi)',
    french: 'cuisine de bateau (local)',
    spanish: 'cocina de un barco',
  },
  {
    av: 24659,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(digital device + game [contr.])',
    english: 'game box',
    swedish: 'dataspel, game box, spelkonsol',
    norwegian: 'spilleautomat',
    finnish: 'pelikonsoli',
    hungarian: 'gamebox, játékkonzol',
    german: 'Gameboy, Spielcomputer',
    dutch: 'spel console',
    afrikaans: 'speel boks',
    russian: 'компьютерная игра',
    latvian: 'datorspēle',
    polish: 'konsola do gry',
    french: 'console de jeux',
    spanish: 'consola de juegos',
  },
  {
    av: 24660,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(digital device + communication satellite + place)',
    english: 'GPS, satnav',
    swedish: 'GPS, GPS-navigator, satellitnavigator',
    norwegian: 'GPS satelittnavigasjon',
    finnish: 'satelliittipaikannin, GPS, navigaattori',
    hungarian: 'GPS, helymeghatározó navigáció',
    german: 'GPS-Empfänger',
    dutch: 'GPS toestel',
    afrikaans: 'GPS satnav',
    russian: 'спутниковый GPS-навигатор',
    latvian: 'GPS navigācija',
    polish: 'GPS, nawigacja satelitarna',
    french: 'GPS, navigation par satellite',
    spanish: 'GPS, navegador satelital',
  },
  {
    av: 24661,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + communication satellite + place)',
    english: 'GPS (system)',
    swedish: 'GPS (systemet)',
    norwegian: 'GPS system',
    finnish: 'satelliittipaikannus',
    hungarian: 'GPS, helymeghatározó navigációs rendszer',
    german: 'GPS (System)',
    dutch: 'GPS systeem',
    afrikaans: 'GPS sisteem',
    russian: 'система GPS',
    latvian: 'GPS sistēma',
    polish: 'GPS (system nawigacji)',
    french: 'GPS (système)',
    spanish: 'GPS (sistema)',
  },
  {
    av: 24662,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(swing + cloth + lie down + thing indicator)',
    english: 'hammock',
    swedish: 'hängmatta',
    norwegian: 'hengekøye, hammock',
    finnish: 'riippumatto',
    hungarian: 'függőágy',
    german: 'Hängematte',
    dutch: 'hangmat',
    afrikaans: 'hangmat',
    russian: 'гамак',
    latvian: 'guļamtīkls, šūpuļtīkls',
    polish: 'hamak',
    french: 'hamac',
    spanish: 'hamaca',
  },
  {
    av: 24663,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(music + up and down + intensity)',
    english: 'hard rock',
    swedish: 'hårdrock',
    norwegian: 'hardrock',
    finnish: 'hard rock (musiikki)',
    hungarian: 'kemény rock, hard rock',
    german: 'Rockmusik',
    dutch: 'hardrock',
    afrikaans: 'hardrock',
    russian: 'тяжелый рок',
    latvian: 'smagais roks',
    polish: 'hard rock',
    french: 'musique de rock, hard rock',
    spanish: 'rock duro',
  },
  {
    av: 24664,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(need + time + action indicator)',
    english: 'I need more time, give me time',
    swedish: 'ge mig tid',
    norwegian: 'gi meg tid (utsagn)',
    finnish: 'tarvitsen lisää aikaa',
    hungarian: 'Több időre van szükségem! Adj egy kis időt!',
    german: 'gib mir bitte (mehr) Zeit, geben Sie mir bitte (mehr) Zeit',
    dutch: 'meer tijd geven',
    afrikaans: 'meer tyd nodig',
    russian: 'давать время',
    latvian: 'dodiet man laiku, man nepieciešams laiks',
    polish: 'potrzebuję czasu, daj mi chwilę',
    french: 'avoir besoin de temps',
    spanish: 'necesito más tiempo, deme más tiempo',
  },
  {
    av: 24680,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(fire + intensity + description before the fact indicator)',
    english: 'inflammable, flammable',
    swedish: 'eldfarlig',
    norwegian: 'brennbart',
    finnish: 'palava, syttyvä',
    hungarian: 'gyúlékony, tűzveszélyes',
    german: 'brennbar, entflammbar',
    dutch: 'brandbaar',
    afrikaans: 'onvlambaar, onvlambare, vlambaar, vlambare',
    russian: 'огнеопасный, легковоспламеняющийся',
    latvian: 'ugunsnedrošs',
    polish: 'łatwopalne',
    french: 'inflammable (très)',
    spanish: 'inflamable',
  },
  {
    av: 24681,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + before + money)',
    english: 'invoice',
    swedish: 'räkning, faktura',
    norwegian: 'faktura',
    finnish: 'ostoslasku, kauppalasku',
    hungarian: 'számla',
    german: 'Rechnung',
    dutch: 'rekening, factuur',
    afrikaans: 'faktuur',
    russian: 'счёт, счёт-фактура',
    latvian: 'pavadzīme, rēķins',
    polish: 'faktura (finansowe)',
    french: 'facture',
    spanish: 'factura',
  },
  {
    av: 24682,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fruit + heavy)',
    english: 'jackfruit',
    swedish: 'jackfrukt',
    norwegian: 'jackfrukt',
    finnish: 'jakkihedelmä',
    hungarian: 'jákafa, dzsekkfrút, jackfruit, kenyérfaféle',
    german: 'Jackfrucht',
    dutch: 'jackfruit',
    afrikaans: 'jackfruit',
    russian: 'джекфрут',
    latvian: 'džekfrūts',
    polish: 'Dżakfrut, chakka – owoc z kuchni indyjskiej',
    french: 'jaque, jacque (fruit du jacquier)',
    spanish: 'nanjea (jackfruit), jaca',
  },
  {
    av: 24683,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + help + house)',
    english: 'janitor, caretaker',
    swedish: 'vaktmästare, fastighetsskötare',
    norwegian: 'vaktmester, dørvakt',
    finnish: 'talonmies, huoltomies',
    hungarian: 'kertész',
    german: 'Hausmeister, Hausmeisterin',
    dutch: 'conciërge',
    afrikaans: 'opsigter',
    russian: 'вахтёр, дворник',
    latvian: 'vārtsargs, sētnieks',
    polish: 'dozorca',
    french: 'concierge',
    spanish: 'portero, conserje',
  },
  {
    av: 24684,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + volcano)',
    english: 'lava, magma',
    swedish: 'lava',
    norwegian: 'lava',
    finnish: 'laava, magma',
    hungarian: 'láva, magma',
    german: 'Lava, Magma',
    dutch: 'lava',
    afrikaans: 'lawa, magma',
    russian: 'лава, магма',
    latvian: 'lava, magma',
    polish: 'lawa',
    french: 'lave, magma',
    spanish: 'lava, magma',
  },
  {
    av: 24685,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + without + wind)',
    english: 'lee, shelter',
    swedish: 'lä, vindskydd',
    norwegian: 'ly, le (for vind), vinskydd',
    finnish: 'tuulensuoja',
    hungarian: 'szélárnyékos/szélmentes menedék',
    german: 'Lee, Windschutz',
    dutch: 'beschutting',
    afrikaans: 'skuil, skuiling',
    russian: 'укрытие, подветренная сторона',
    latvian: 'aizsegs, patvērums',
    polish: 'osłona (przed wiatrem), wiata, schronisko',
    french: 'endroit abrité du vent, porche',
    spanish: 'sotavento, refugio, abrigo',
  },
  {
    av: 24686,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hand + fall-(to) + action indicator)',
    english: 'let fall, drop-(to)',
    swedish: 'släppa',
    norwegian: 'la falle, droppe, slippe',
    finnish: 'pudottaa, tiputtaa',
    hungarian: 'leejteni, lepottyantani, hagyni leesni',
    german: '(auf den Boden) fallen lassen',
    dutch: 'laten vallen',
    afrikaans: 'laat val (om te)',
    russian: 'ронять, уронить, бросать',
    latvian: 'ļaut nokrist, nomest',
    polish: 'upuszczać, wyrzucać',
    french: 'lâcher, laisser tomber',
    spanish: 'dejar caer',
  },
  {
    av: 24687,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothes + float-(to))',
    english: 'life-jacket',
    swedish: 'flytväst',
    norwegian: 'redningsvest, flytedress',
    finnish: 'pelastusliivi',
    hungarian: 'mentőmellény',
    german: 'Schwimmweste, Rettungsweste',
    dutch: 'reddingsvest',
    afrikaans: 'reddingsbaadjie',
    russian: 'жилет безопасности',
    latvian: 'glābšanas veste',
    polish: 'kapok, kamizelka ratunkowa',
    french: 'gilet de sauvetage',
    spanish: 'chaleco salvavidas',
  },
  {
    av: 24688,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(activity + down + action indicator)',
    english: 'lower-(to)',
    swedish: 'hala, sänka',
    norwegian: 'senke, fire (å)',
    finnish: 'madaltaa, alentaa',
    hungarian: 'leengedni, lebocsátani',
    german: 'herablassen, senken',
    dutch: 'neerlaten, laten zakken',
    afrikaans: 'laer (om laer te maak) (om te)',
    russian: 'снижаться, опускать',
    latvian: 'pazemināt, pazemināties',
    polish: 'spuszczać w dół, opuszczać',
    french: 'baisser',
    spanish: 'disminuir',
  },
  {
    av: 24689,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(song + sleep)',
    english: 'lullaby',
    swedish: 'vaggvisa',
    norwegian: 'godnattsang',
    finnish: 'kehtolaulu, tuutulaulu',
    hungarian: 'altatódal',
    german: 'Schlaflied, Wiegenlied',
    dutch: 'wiegeliedje, slaapliedje',
    afrikaans: 'slaapliedjie, wiegeliedjie',
    russian: 'колыбельная',
    latvian: 'šūpuļdziesma',
    polish: 'kołysanka',
    french: 'berceuse (chanson)',
    spanish: 'canción de cuna',
  },
  {
    av: 24690,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(moon + behind + earth)',
    english: 'lunar eclipse',
    swedish: 'månförmörkelse',
    norwegian: 'måneformørkelse',
    finnish: 'kuunpimennys',
    hungarian: 'holdfogyatkozás',
    german: 'Mondfinsternis',
    dutch: 'maansverduistering',
    afrikaans: 'maansverduistering',
    russian: 'лунное затмение',
    latvian: 'mēness aptumsums',
    polish: 'zaćmienie Księżyca',
    french: 'éclipse lunaire',
    spanish: 'eclipse lunar',
  },
  {
    av: 24691,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(digital device + eye + ear)',
    english: 'media player',
    swedish: 'mediaspelare',
    norwegian: 'mediaspiller',
    finnish: 'mediasoitin',
    hungarian: 'médialejátszó',
    german: 'Media Player',
    dutch: 'mediaplayer',
    afrikaans: 'media speler',
    russian: 'медиаплеер',
    latvian: 'atskaņotājs, datora programma',
    polish: 'odtwarzacz multimedialny, player, mp4',
    french: 'lecteur multimédia',
    spanish: 'reproductor de medios',
  },
  {
    av: 24692,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + belong to + group)',
    english: 'member',
    swedish: 'medlem',
    norwegian: 'medlem',
    finnish: 'jäsen',
    hungarian: 'tag',
    german: 'Mitglied',
    dutch: 'lid',
    afrikaans: 'lid',
    russian: 'член, участник',
    latvian: 'dalībnieks, biedrs',
    polish: 'członek (partii, stowarzyszenia, grupy)',
    french: 'membre (personne)',
    spanish: 'miembro',
  },
  {
    av: 24693,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + memory)',
    english: 'memo, reminder note',
    swedish: 'minneslapp, kom-ihåg-lapp',
    norwegian: 'huskeliste, huskelapp',
    finnish: 'muistio, muistiinpanot',
    hungarian: 'feljegyzés, emlékeztető, figyelmeztető cédula',
    german: 'Notiz, Notizzettel',
    dutch: 'memo, nota',
    afrikaans: 'memo, herinneringsnota',
    russian: 'памятка',
    latvian: 'zīmīte, memorands',
    polish: 'memo, notatka, żółta karteczka',
    french: 'pense-bête, note',
    spanish: 'memorándum, recordatorio',
  },
  {
    av: 24694,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(digital storage device + small)',
    english: 'memory stick, USB-memory',
    swedish: 'USB-minne, minnespinne',
    norwegian: 'minnepenn, USB-penn',
    finnish: 'USB-tikku, muistitikku',
    hungarian: 'pendrive, hordozható/mobil memória',
    german: 'Memorystick, Speicherstift',
    dutch: 'USB-stick, memory stick',
    afrikaans: 'USB-stokkie, geheuestokkie',
    russian: 'ручка памяти USB',
    latvian: 'atmiņas karte, USB atmiņa',
    polish: 'pendive, pamięć USB, pamięć flash, pamięć przenośna, pen',
    french: 'clef USB, clé USB',
    spanish: 'tarjeta de memoria, memoria USB',
  },
  {
    av: 24695,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rock music + metal [contr.])',
    english: 'metal (music)',
    swedish: 'heavy metal, metal-musik',
    norwegian: 'heavy metal',
    finnish: 'metallimusiikki, hevimetalli',
    hungarian: 'metál (zenei műfaj)',
    german: 'Metal, Heavy metal',
    dutch: 'metal (muziek)',
    afrikaans: 'metal musiek',
    russian: 'хэви-метал (музыка)',
    latvian: 'metāla mūzika, mūzikas stils',
    polish: 'muzyka heavy metal',
    french: 'musique métal',
    spanish: 'metálica (música)',
  },
  {
    av: 24696,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(document [contr.] + after + gathering)',
    english: 'minutes',
    swedish: 'protokoll, minnesanteckningar',
    norwegian: 'referat, protokoll',
    finnish: 'pöytäkirja',
    hungarian: 'jegyzőkönyv',
    german: 'Protokoll, Sitzungsprotokoll, Niederschrift ',
    dutch: 'notulen, verslag',
    afrikaans: 'notule',
    russian: 'протокол, служебная запись',
    latvian: 'protokols (sēdes, sapulces)',
    polish: 'protokół, sprawozdanie',
    french: 'procès-verbal, compte rendu, minutes',
    spanish: 'actas',
  },
  {
    av: 24697,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(use + wrong)',
    english: 'misuse',
    swedish: 'missbruk',
    norwegian: 'misbruk',
    finnish: 'väärinkäyttö',
    hungarian: 'visszaélés, helytelen/rossz/téves használat',
    german: 'Missbrauch, falsche Anwendung',
    dutch: 'verkeerd gebruikt',
    afrikaans: 'misbruik',
    russian: 'злоупотребление',
    latvian: 'ļaunprātīga, nepareiza izmantošana',
    polish: 'nadużycie',
    french: 'mauvais emploi, mauvais usage',
    spanish: 'mal uso',
  },
  {
    av: 24698,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(misuse + action indicator)',
    english: 'misuse-(to)',
    swedish: 'missbruka',
    norwegian: 'misbruke',
    finnish: 'väärinkäyttää',
    hungarian: 'visszaélni, rossz célra/tévesen fel/használni',
    german: 'missbrauchen, falsch anwenden, falsch gebrauchen',
    dutch: 'verkeerd gebruiken',
    afrikaans: 'misbruik (om te)',
    russian: 'злоупотреблять',
    latvian: 'ļaunprātīgi, nepareizi izmantot',
    polish: 'nadużywać',
    french: 'mal employer, mal utiliser',
    spanish: 'usar incorrectamente',
  },
  {
    av: 24699,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(picture + telephone)',
    english: 'MMS',
    swedish: 'MMS',
    norwegian: 'MMS',
    finnish: 'multimediaviesti',
    hungarian: 'MMS',
    german: 'MMS (Multimedia Messaging Service)',
    dutch: 'MMS',
    afrikaans: 'MMS',
    russian: 'MMS',
    latvian: 'MMS',
    polish: 'MMS',
    french: 'MMS',
    spanish: 'MMS',
  },
  {
    av: 24700,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work of art, art object + memory + thing indicator)',
    english: 'monument, commemorative work',
    swedish: 'monument, minnesmärke',
    norwegian: 'monument, minnesmerke',
    finnish: 'muistomerkki, monumentti',
    hungarian: 'emlékmű, műemlék, szobor',
    german: 'Monument, Denkmal',
    dutch: 'monument',
    afrikaans: 'monument, herdenkings werk',
    russian: 'памятник',
    latvian: 'piemineklis, piemiņas plāksne',
    polish: 'pomnik, statua, rzeźba',
    french: 'monument (commémoratif)',
    spanish: 'monumento',
  },
  {
    av: 24701,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(movement, motion (2) + action indicator)',
    english: 'move (change position)-(to)',
    swedish: 'röra sig, flytta sig',
    norwegian: 'flytte seg, bevege seg',
    finnish: 'vaihtaa paikkaa, siirtyä',
    hungarian: 'mozdulni, elmozdulni, helyet változtatni',
    german: 'umziehen (in ein anderes Haus)',
    dutch: 'bewegen, verplaatsen',
    afrikaans: 'beweeg (posisie te verander) (om te)',
    russian: 'двигаться, перемещаться',
    latvian: 'pārvietoties, kustēties',
    polish: 'ruszać się, poruszać, zmieniać pozycję',
    french: 'bouger (changer de position), déplacer',
    spanish: 'moverse (cambiar de posición)',
  },
  {
    av: 24702,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + back and forth)',
    english: 'movement, motion (1)',
    swedish: 'rörelse, förflyttning (1)',
    norwegian: 'bevegelse, forflytning (1)',
    finnish: 'liike',
    hungarian: 'mozdulás, elmozdulás, mozgás',
    german: 'Bewegung (1)',
    dutch: 'beweging op muziek (1)',
    afrikaans: 'beweging (1)',
    russian: 'движение, перемещение (1)',
    latvian: 'pārvietošanās, kustība (1)',
    polish: 'ruch, poruszanie się (1)',
    french: 'mouvement (1)',
    spanish: 'movimiento (21)',
  },
  {
    av: 24703,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + back and forth)',
    english: 'movement, motion (2)',
    swedish: 'rörelse, förflyttning (2)',
    norwegian: 'bevegelse, forflytning (2)',
    finnish: 'liike',
    hungarian: 'mozdulat, mozgás, helyváltoztatás',
    german: 'Bewegung (2)',
    dutch: 'beweging op muziek (2)',
    afrikaans: 'beweging (2)',
    russian: 'движение, перемещение (2)',
    latvian: 'pārvietošanās, kustība (2)',
    polish: 'ruch, poruszanie się (2)',
    french: 'mouvement (2)',
    spanish: 'movimiento (2)',
  },
  {
    av: 24704,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sign + boat)',
    english: 'navigational sign',
    swedish: 'sjömärke',
    norwegian: 'navigasjonssignal, sjømerke',
    finnish: 'merimerkki',
    hungarian: 'hajózási jelzések (pl. bólya, fényjelzések)',
    german: 'Seezeichen, Schifffahrtszeichen',
    dutch: 'navigatiesignaal (boot)',
    afrikaans: 'navigasie teken',
    russian: 'навигационный знак',
    latvian: 'navigācijas signāls',
    polish: 'znak nawigacyjny',
    french: 'signal de navigation',
    spanish: 'señal de navegación',
  },
  {
    av: 24705,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(grain + bits: grain gathered in a cluster)',
    english: 'oats',
    swedish: 'havre',
    norwegian: 'havre',
    finnish: 'kaura',
    hungarian: 'zab',
    german: 'Hafer, Haferflocken',
    dutch: 'haver',
    afrikaans: 'hawer',
    russian: 'овёс',
    latvian: 'auzas',
    polish: 'zboże, owies',
    french: 'avoine',
    spanish: 'avena',
  },
  {
    av: 24706,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fruit (pointed) + soft)',
    english: "okra, lady's finger",
    swedish: 'okra',
    norwegian: "okra, lady's finger",
    finnish: 'okra, bhindi',
    hungarian: "okra, gombó, gumbo, hölgyujj, lady's finger",
    german: 'Okraschote',
    dutch: 'okra (groente)',
    afrikaans: 'okra',
    russian: 'окра (бамия)',
    latvian: 'okra, dāmu pirkstiņi, augs',
    polish: 'okra (rodzaj warzywa)',
    french: 'okra, gombo',
    spanish: 'okra',
  },
  {
    av: 24707,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(money (buy [contr.]) + over + economy + action indicator)',
    english: 'overspend, buy over budget-(to)',
    swedish: 'göra av med pengar, spendera',
    norwegian: 'overtrekke budsjett',
    finnish: 'ylittää budjetti, kuluttaa liikaa',
    hungarian: 'túlköltekezni, keretet kimeríteni',
    german: 'zu viel Geld ausgeben, ein Budget überschreiten',
    dutch: 'te veel uitgeven, over het budget',
    afrikaans: 'oorbestee, oorspandeer (om te)',
    russian: 'сорить деньгами',
    latvian: 'pārtērēt',
    polish: 'przepłacać, wydawać za dużo',
    french: 'dépenser au-dessus de ses moyens',
    spanish: 'gastar de más, pasarse del presupuesto',
  },
  {
    av: 24708,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(channel (programs) + money)',
    english: 'pay channel',
    swedish: 'betal-TV',
    norwegian: 'betalingskanal',
    finnish: 'maksukanava',
    hungarian: 'fizetős tévécsatorna',
    german: 'Abo-Kanal',
    dutch: 'betaal TV',
    afrikaans: 'betaalkanaal',
    russian: 'платный TV-канал',
    latvian: 'maksas kanāls',
    polish: 'płatny kanał, płatna stacja',
    french: 'chaîne payante (programme TV)',
    spanish: 'canal de TV pago',
  },
  {
    av: 24709,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(finger + to get + action indicator)',
    english: 'pick-(to)',
    swedish: 'plocka',
    norwegian: 'plukke',
    finnish: 'noukkia, poimia',
    hungarian: 'kiválogatni, csipegetni, szemezgetni',
    german: 'aufheben ',
    dutch: 'opnemen, oppakken',
    afrikaans: 'pluk (om te)',
    russian: 'собирать',
    latvian: 'izvēlēties, izcelt',
    polish: 'zbierać',
    french: 'cueillir, ramasser',
    spanish: 'coger, recoger, tomar',
  },
  {
    av: 24710,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(connection (computer) + action indicator)',
    english: 'plug in, connect (digital)-(to)',
    swedish: 'ansluta (digitalt)',
    norwegian: 'plugge inn, slå på (digitalt)',
    finnish: 'kytkeä, yhdistää (tietokone)',
    hungarian: 'rácsatlakozni, összekapcsolni',
    german: 'verbinden (digital)',
    dutch: 'verbinden (digitaal)',
    afrikaans: 'koppel aan, bewind (digitale) (om te)',
    russian: 'подключать (цифровая техника)',
    latvian: 'pieslēgums, savienojums (digitāls)',
    polish: 'podłączyć do (komp)',
    french: 'brancher',
    spanish: 'enchufar, conectar (digital)',
  },
  {
    av: 24711,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(plug [modification] + action indicator)',
    english: 'plug in, connect (power)-(to)',
    swedish: 'ansluta (elektriskt)',
    norwegian: 'plugge inn, slå på',
    finnish: 'laittaa virta päälle',
    hungarian: 'bekapcsolni, bedugni, csatlakoztatni',
    german: 'verbinden, verknüpfen (elekronisch)',
    dutch: 'in het stopcontact steken',
    afrikaans: 'koppel aan, bewind (om te)',
    russian: 'подключать (электричество)',
    latvian: 'pieslēgt, pievienot (elektroenerģiju)',
    polish: 'podłączyć do prądu',
    french: 'prise de courant',
    spanish: 'enchufar, conectar (electricidad)',
  },
  {
    av: 24712,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(left turn, left (position or direction) + boat)',
    english: 'port (boat)',
    swedish: 'babord',
    norwegian: 'babord',
    finnish: 'paapuuri',
    hungarian: 'hajókikötő',
    german: 'Backbord',
    dutch: 'bakboord',
    afrikaans: 'hawe (boot)',
    russian: 'порт(морской)',
    latvian: 'osta, kuģu piestātne',
    polish: 'port (dla łodzi)',
    french: 'bâbord (bateau)',
    spanish: 'babor (barco)',
  },
  {
    av: 24713,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(opening + connection (computer))',
    english: 'port (device)',
    swedish: 'port, kontakt (dator)',
    norwegian: 'port (PC), kontakt (PC)',
    finnish: 'tietokoneen portti',
    hungarian: 'port, számítógépes bemeneti-kimeneti kapu',
    german: 'Anschluss (Computer)',
    dutch: 'poort (computer)',
    afrikaans: 'port (toestel, masjien)',
    russian: 'порт (техника)',
    latvian: 'ports (datortehnika)',
    polish: 'port (w urządzeniu, np. USB)',
    french: 'port (dispositif informatique)',
    spanish: 'puerto (dispositivo)',
  },
  {
    av: 24715,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(portability + action indicator)',
    english: 'portable',
    swedish: 'bärbar, portabel',
    norwegian: 'flyttbar, transportabel, bærbar',
    finnish: 'siirrettävä, kannettava, liikuteltava',
    hungarian: 'hordozható',
    german: 'tragbar',
    dutch: 'draagbaar',
    afrikaans: 'draagbaar, draagbare',
    russian: 'портативный',
    latvian: 'pārvietojams, pārnēsājams',
    polish: 'przenośny',
    french: 'portable',
    spanish: 'portátil',
  },
  {
    av: 24716,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(vegetable (below ground) (potato [contr.]) + disc) Preferred NEW SYNONYM, replacing 16231',
    english: 'potato chip(s), chip(s), crisp(s)',
    swedish: 'chips, potatischips (etc)',
    norwegian: 'potetgull, chips',
    finnish: 'perunalastut, sipsit',
    hungarian: 'chips, burgonyszirom',
    german: 'Kartoffelchip(s), Chip(s)',
    dutch: 'chips',
    afrikaans: 'chips, skyfies (aartapples)',
    russian: 'картофельные чипсы',
    latvian: 'kartupeļu skaidiņas (vārītas eļļā), kartupeļu čipsi',
    polish: 'chipsy, chrupki ziemniaczane',
    french: 'chips',
    spanish: 'patatas fritas',
  },
  {
    av: 24720,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(evaluation, value + type, kind, sort, category)',
    english: 'quality',
    swedish: 'kvalitet',
    norwegian: 'kvalitet',
    finnish: 'ominaisuus',
    hungarian: 'minőség',
    german: 'Qualität ',
    dutch: 'kwaliteit',
    afrikaans: 'kwaliteit',
    russian: 'качество',
    latvian: 'kvalitāte',
    polish: 'jakość',
    french: 'qualité',
    spanish: 'calidad (medida)',
  },
  {
    av: 24721,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(measurement + quality)',
    english: 'quality (measurement)',
    swedish: 'kvalitet (mått)',
    norwegian: 'kvalitetsmåling',
    finnish: 'laadunmittaus',
    hungarian: 'minőségmérés',
    german: 'Qualität (Bewertung, Messung)',
    dutch: 'kwaliteit',
    afrikaans: 'kwaliteit (meting)',
    russian: 'измеритель качества',
    latvian: 'kvalitāte (mērvienība)',
    polish: 'miernik jakości',
    french: 'qualité (mesure)',
    spanish: 'calidad (medida)',
  },
  {
    av: 24722,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(measurement + multitude)',
    english: 'quantity (measurement)',
    swedish: 'kvantitet (mått)',
    norwegian: 'kvantitetsmåling',
    finnish: 'määränmittaus',
    hungarian: 'mérés (mennyiség)',
    german: 'Quantität, Menge (Messgröβe)',
    dutch: 'kwantiteit',
    afrikaans: 'hoeveelheid (mates)',
    russian: 'измеритель количества',
    latvian: 'daudzums, kvantitāte (mērvienība)',
    polish: 'miernik ilości',
    french: 'quantité (mesure)',
    spanish: 'cantidad (medida)',
  },
  {
    av: 24723,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(activity + up + action indicator)',
    english: 'raise-(to)',
    swedish: 'hissa, höja, resa upp',
    norwegian: 'reise opp, heise',
    finnish: 'kohottaa, nostaa',
    hungarian: 'felemelni, megemelni, magasra emelni',
    german: 'heben, hochheben, anheben',
    dutch: 'opvoeden, omhoogbrengen, optillen',
    afrikaans: 'opvoeding, om groot te maak (om te)',
    russian: 'поднимать(ся)',
    latvian: 'pacelties, saslieties, izaugt, palielināties',
    polish: 'rosnąć, zwiększać się',
    french: 'hisser, relever, hausser',
    spanish: ' levantar',
  },
  {
    av: 24724,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + after + money)',
    english: 'receipt',
    swedish: 'kvitto',
    norwegian: 'kvittering',
    finnish: 'kuitti, tosite',
    hungarian: 'nyugta',
    german: 'Quittung',
    dutch: 'ontvangstbewijs, betalingsbewijs',
    afrikaans: 'kwitansie',
    russian: 'квитанция, чек',
    latvian: 'kvīts',
    polish: 'pokwitowanie, paragon',
    french: 'reçu',
    spanish: 'recepción',
  },
  {
    av: 24725,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(receiving + thing indicator) - (character with thing indicator)',
    english: 'receiver',
    swedish: 'mottagare',
    norwegian: 'mottaker',
    finnish: 'vastaanotin',
    hungarian: 'vevőkészülék, telefonkagyló',
    german: 'Empfänger, Anschrift',
    dutch: 'ontvanger',
    afrikaans: 'ontvanger',
    russian: 'приёмник, ресивер',
    latvian: 'saņēmējs, uztvērējs',
    polish: 'odbiornik, antena',
    french: 'récepteur',
    spanish: 'receptor',
  },
  {
    av: 24728,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(decrease, reduce-(to) + sail + action indicator)',
    english: 'reef-(to)',
    swedish: 'reva',
    norwegian: 'reve (seil)',
    finnish: 'reivata',
    hungarian: 'kurtítani vitorlát, reffelni',
    german: 'reffen',
    dutch: 'reven',
    afrikaans: 'rif (om te)',
    russian: 'брать рифы',
    latvian: 'ierēvēt',
    polish: 'refować, zwijać (żagiel)',
    french: 'prendre un ris dans une voile, arriser',
    spanish: 'rizar (vela)',
  },
  {
    av: 24729,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + leadership, guidance + horse + thing indicator)',
    english: 'rein',
    swedish: 'tygel, töm',
    norwegian: 'tøyle',
    finnish: 'ohjakset, suitset',
    hungarian: 'gyeplőszár, kantárszár',
    german: 'Zügel',
    dutch: 'teugel',
    afrikaans: 'toom',
    russian: 'вожжа, повод',
    latvian: 'turēt grožus, valdīt',
    polish: 'lejce, cugle, wodze (koń)',
    french: 'rênes',
    spanish: 'rienda',
  },
  {
    av: 24730,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + channel (programs))',
    english: 'remote control',
    swedish: 'fjärrkontroll',
    norwegian: 'fjernstyring, fjernkontroll',
    finnish: 'kauko-ohjain',
    hungarian: 'távirányító, távkapcsoló',
    german: 'Fernbedienung',
    dutch: 'afstandsbediening',
    afrikaans: 'afstandbeheer',
    russian: 'пульт дистанционного управления',
    latvian: 'tālvadība, tālvadības',
    polish: 'pilot (zdalnego sterowania)',
    french: 'télécommande',
    spanish: 'mando a distancia, control remoto',
  },
  {
    av: 24731,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cost, price + limited time)',
    english: 'rent',
    swedish: 'hyra (subst.)',
    norwegian: 'leie',
    finnish: 'vuokra',
    hungarian: 'bérleti díj, bérösszeg',
    german: 'Miete (Substantiv)',
    dutch: 'huur',
    afrikaans: 'huur',
    russian: 'аренда',
    latvian: 'īre, rente, noma',
    polish: 'wynajem, dzierżawa',
    french: 'location',
    spanish: 'renta, alquiler',
  },
  {
    av: 24732,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(pay, spend-(to) + limited time + action indicator)',
    english: 'rent, lease, let-(to)',
    swedish: 'hyra ut',
    norwegian: 'leie ut, lease ut',
    finnish: 'vuokrata, ottaa vuokralle',
    hungarian: 'bérbe adni',
    german: 'vermieten, ausleihen',
    dutch: 'verhuren',
    afrikaans: 'verhuur (om te)',
    russian: 'сдавать в аренду',
    latvian: 'īrēt, izīrēt, iznomāt',
    polish: 'wynajmować od kogoś, czarterować, brać w leasing',
    french: 'louer (prendre en location)',
    spanish: 'arrendar, alquilar',
  },
  {
    av: 24733,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(get, acquire, receive-(to) + money + limited time + action indicator)',
    english: 'rent, lease, hire, charter-(to)',
    swedish: 'hyra (verb)',
    norwegian: 'leie, lease',
    finnish: 'vuokrata, antaa vuokralle',
    hungarian: 'bérbe venni, kibérelni',
    german: 'mieten, leihen (Verb)',
    dutch: 'huren',
    afrikaans: 'huur, verhuur (om te)',
    russian: 'брать на прокат',
    latvian: 'izīrēt, iznomāt, nolīgt',
    polish: 'wynajmować komuś, wydzierżawiać, odnajmować',
    french: 'louer (donner en location)',
    spanish: 'arrendar, alquilar, fletar',
  },
  {
    av: 24734,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(illness + breathe-(to))',
    english: 'respiratory illness',
    swedish: 'luftvägssjukdom, astma (etc)',
    norwegian: 'lutveissykdom',
    finnish: 'hengitystiesairaus, astma',
    hungarian: 'légzőszervi betegség',
    german: 'Atemwegskrankheit, Asthma (etc)',
    dutch: 'ademhalingsziekte',
    afrikaans: 'respiratoriese siekte',
    russian: 'заболевание дыхательных путей',
    latvian: 'elpošanas ceļu saslimšana',
    polish: 'choroba układu oddechowego',
    french: 'maladie respiratoire',
    spanish: 'enfermedad respiratoria',
  },
  {
    av: 24735,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sign + vehicle)',
    english: 'road sign, traffic signal',
    swedish: 'vägmärke',
    norwegian: 'veiskilt',
    finnish: 'liikennemerkki, tienviitta',
    hungarian: 'jelzőtábla, közlekedési jelzés, útjelző tábla',
    german: 'Verkehrsschild',
    dutch: 'verkeersbord',
    afrikaans: 'padteken',
    russian: 'дорожный знак',
    latvian: 'ceļaļazīme',
    polish: 'znak drogowy',
    french: 'panneau de signalisation',
    spanish: 'señal de tráfico',
  },
  {
    av: 24736,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(music + up and down)',
    english: "rock music, rock'n'roll, rock",
    swedish: 'rockmusik',
    norwegian: 'rockemusikk',
    finnish: 'rockmusiikki, rokki',
    hungarian: 'rockzene',
    german: 'Rockmusik',
    dutch: 'rockmuziek',
    afrikaans: 'rock musiek',
    russian: 'рок-музыка',
    latvian: 'rokmūzika',
    polish: 'rock, muzyka rockowa',
    french: 'musique rock',
    spanish: 'música de rock',
  },
  {
    av: 24737,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(much, many, very + wave)',
    english: 'rough sea',
    swedish: 'sjögång',
    norwegian: 'grov sjø',
    finnish: 'myrskyävä meri',
    hungarian: 'hullámzó tenger',
    german: 'Seegang, unruhige See',
    dutch: 'wilde zee',
    afrikaans: 'rowwe see',
    russian: 'бурные волны',
    latvian: 'bangojoša jūra',
    polish: 'wzburzone morze',
    french: 'houle',
    spanish: 'mar agitado',
  },
  {
    av: 24738,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(grain + linear thing + small + thing indicator: ear of grain with short tassels)',
    english: 'rye',
    swedish: 'råg',
    norwegian: 'rug',
    finnish: 'ruis',
    hungarian: 'rozs',
    german: 'Roggen',
    dutch: 'rogge',
    afrikaans: 'rog',
    russian: 'рожь',
    latvian: 'rudzi',
    polish: 'żyto',
    french: 'seigle',
    spanish: 'centeno',
  },
  {
    av: 24740,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(signal receiver (1) + communication satellite) SYMBOL SYNONYM',
    english: 'satellite dish (1)',
    swedish: 'satellitmottagare (1)',
    norwegian: 'satelittmottaker (1)',
    finnish: 'satelliittilautanen',
    hungarian: 'műholdas adóvevő, szatellita dish',
    german: 'Satellitenschüssel (1)',
    dutch: 'schotelantenne (1)',
    afrikaans: 'satellietskottel (1)',
    russian: 'спутниковая антенна (1)',
    latvian: 'satelītantena (diskveida) (1)',
    polish: 'antena satelitarna (1)',
    french: 'antenne parabolique (1)',
    spanish: 'antena satelital (1)',
  },
  {
    av: 24741,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(signal receiver (2) + communication satellite) SYMBOL SYNONYM',
    english: 'satellite dish (2)',
    swedish: 'satellitmottagare (2)',
    norwegian: 'satelittmottaker (2)',
    finnish: 'satelliittiantenni',
    hungarian: 'műholdvevő tányérantenna',
    german: 'Satellitenschüssel (2)',
    dutch: 'schotelantenne (2)',
    afrikaans: 'satellietskottel (2)',
    russian: 'спутниковая антенна (2)',
    latvian: 'satelītantena (diskveida) (2)',
    polish: 'antena satelitarna (2)',
    french: 'antenne parabolique (2)',
    spanish: 'antena satelital (2)',
  },
  {
    av: 24742,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(signal, broadcast, transmitting + satellite)',
    english: 'satellite signal',
    swedish: 'satellitsignal',
    norwegian: 'satelittsignal',
    finnish: 'satelliittisignaali',
    hungarian: 'műholdas jelzés',
    german: 'Satellitensignal',
    dutch: 'signaal (antenne)',
    afrikaans: 'satelliet sein',
    russian: 'сигнал спутника',
    latvian: 'satelīta signāls',
    polish: 'sygnał satelitarny',
    french: 'onde satellite, signal satellite',
    spanish: 'señal satelital',
  },
  {
    av: 24743,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothes + school [contr.])',
    english: 'school uniform',
    swedish: 'skoluniform',
    norwegian: 'skoleuniform',
    finnish: 'koulupuku',
    hungarian: 'egyenruha (iskolai)',
    german: 'Schuluniform',
    dutch: 'schooluniform',
    afrikaans: 'skool uniform',
    russian: 'школьная форма',
    latvian: 'skolas formastērps',
    polish: 'mundurek szkolny',
    french: 'uniforme scolaire',
    spanish: 'uniforme escolar',
  },
  {
    av: 24744,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(leader + boat)',
    english: 'sea captain, skipper',
    swedish: 'sjökapten, skeppare',
    norwegian: 'sjøkaptein, skipper',
    finnish: 'merikapteeni, kippari',
    hungarian: 'hajóskapitány',
    german: 'Kapitän, Schiffer',
    dutch: 'kapitein',
    afrikaans: 'see kaptein skipper',
    russian: 'морской капитан, шкипер',
    latvian: 'kuģa kapteinis, komandas kapteinis',
    polish: 'kapitan statku, kapitan marynarki',
    french: 'capitaine',
    spanish: 'capitán de mar',
  },
  {
    av: 24745,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + water (ground level) (sea [contr.]))',
    english: 'sea chart',
    swedish: 'sjökort',
    norwegian: 'sjøkart',
    finnish: 'merikartta, merikortti',
    hungarian: 'térkép (tengeri)',
    german: 'Seekarte',
    dutch: 'navigatiekaart',
    afrikaans: 'see kaart grafiek koordinate',
    russian: 'морская карта',
    latvian: 'jūras karte',
    polish: 'mapa morska',
    french: 'carte maritime',
    spanish: 'carta marina',
  },
  {
    av: 24746,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + without + light)',
    english: 'shadow, shade',
    swedish: 'skugga',
    norwegian: 'skygge',
    finnish: 'varjo, katve, siimes',
    hungarian: 'árnyék',
    german: 'Schattierung, Schatten',
    dutch: 'schaduw',
    afrikaans: 'skaduwee',
    russian: 'тень',
    latvian: 'ēna',
    polish: 'cień',
    french: 'ombre',
    spanish: 'sombra',
  },
  {
    av: 24747,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(weather forecast + water (ground level) (sea [contr.]))',
    english: 'shipping forecast',
    swedish: 'sjörapport',
    norwegian: 'sjøværvarsel',
    finnish: 'merisäätiedotus',
    hungarian: 'hajózási időjárásjelzés',
    german: 'Seewetterbericht',
    dutch: 'weersvoorspelling (zee)',
    afrikaans: 'weer voorspelling see',
    russian: 'морской прогноз',
    latvian: 'piegādes prognoze',
    polish: 'morska prognoza pogody',
    french: 'météorologie marine',
    spanish: 'pronóstico marino',
  },
  {
    av: 24748,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chair + shower)',
    english: 'shower chair',
    swedish: 'duschstol',
    norwegian: 'dusjstol',
    finnish: 'suihkutuoli',
    hungarian: 'zuhanyszék, zuhanyülőke',
    german: 'Duschstuhl',
    dutch: 'douchestoel, douchezitje',
    afrikaans: 'stort stoel',
    russian: 'стул для душ',
    latvian: 'dušas krēsls',
    polish: 'krzesło prysznicowe',
    french: 'siège de douche',
    spanish: 'silla para ducha',
  },
  {
    av: 24749,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + information) Preferred NEW SYNONYM, replacing 16978',
    english: 'sign, signal',
    swedish: 'märke, tecken, signal, skylt',
    norwegian: 'tegn, signal',
    finnish: 'merkki, signaali, opastin',
    hungarian: 'jel, jelzés',
    german: 'Signal, Zeichen',
    dutch: 'signaal, teken',
    afrikaans: 'teken, sein',
    russian: 'знак, указатель, сигнал',
    latvian: 'zīme, signāls',
    polish: 'znak, sygnał',
    french: 'signal, signalisation',
    spanish: 'signo, señal, marca',
  },
  {
    av: 24751,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(signal reception + thing indicator) SYMBOL SYNONYM',
    english: 'signal receiver (1)',
    swedish: 'signalmottagare (1)',
    norwegian: 'signalmottaker (1)',
    finnish: 'signaalin vastaanotin',
    hungarian: 'jelfogó, adásvevő',
    german: 'Signalempfänger (1)',
    dutch: 'signaalontvanger (1)',
    afrikaans: 'sein ontvanger (1)',
    russian: 'приёмник сигнала (1)',
    latvian: 'signāla uztvērējs (1)',
    polish: 'odbiornik sygnału (1)',
    french: 'récepteur parabolique (1)',
    spanish: 'receptor de señal (1)',
  },
  {
    av: 24752,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(receiver, dish + signal) SYMBOL SYNONYM',
    english: 'signal receiver (2)',
    swedish: 'signalmottagare (2)',
    norwegian: 'signalmottaker (2)',
    finnish: 'signaalin vastaanotin',
    hungarian: 'jelfogó, adásvevő',
    german: 'Signalempfänger (2)',
    dutch: 'signaalontvanger (2)',
    afrikaans: 'sein ontvanger (2)',
    russian: 'приёмник сигнала (2)',
    latvian: 'signāla uztvērējs (2)',
    polish: 'odbiornik sygnału (2)',
    french: 'récepteur parabolique (2)',
    spanish: 'receptor de señal (2)',
  },
  {
    av: 24753,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to get + signal, broadcast, transmitting)',
    english: 'signal reception',
    swedish: 'signalmottagning',
    norwegian: 'signalmottak',
    finnish: 'signaalin vastaanotto',
    hungarian: 'adásvétel (pl. műholdas)',
    german: 'Signalempfang',
    dutch: 'signaalontvangst',
    afrikaans: 'sein ontvangs opvangs',
    russian: 'приём сигнала',
    latvian: 'signāla uztvere',
    polish: 'odbiór sygnału',
    french: "réception (d'ondes)",
    spanish: 'recepción de señal',
  },
  {
    av: 24754,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + song + all)',
    english: 'singalong',
    swedish: 'allsång',
    norwegian: 'allsang',
    finnish: 'yhteislaulu',
    hungarian: 'éneklés csoportosan, spontán együtt éneklés',
    german: 'Lieder zum Mitsingen',
    dutch: 'samenzang',
    afrikaans: 'sing saam',
    russian: 'хоровое пение',
    latvian: 'kopkoris, dziedāšana kopā',
    polish: 'wspólne śpiewanie',
    french: 'chant en chœur',
    spanish: 'cantemos todos',
  },
  {
    av: 24755,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sun + behind + moon)',
    english: 'solar eclipse',
    swedish: 'solförmörkelse',
    norwegian: 'solformørkelse',
    finnish: 'auringonpimennys',
    hungarian: 'napfogyatkozás',
    german: 'Sonnenfinsternis',
    dutch: 'zonsverduistering',
    afrikaans: 'sonsverduistering',
    russian: 'солнечное затмение',
    latvian: 'saules aptumsums',
    polish: 'zaćmienie słońca',
    french: 'éclipse solaire',
    spanish: 'eclipse solar',
  },
  {
    av: 24756,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + mouth)',
    english: 'speech',
    swedish: 'tal',
    norwegian: 'tale',
    finnish: 'puhuminen, puhe',
    hungarian: 'beszéd, beszédtevékenység, beszélés',
    german: 'Rede',
    dutch: 'toespraak, speech',
    afrikaans: 'toespraak',
    russian: 'речь',
    latvian: 'runa',
    polish: 'mowa',
    french: 'parole, langage, discours',
    spanish: 'discurso',
  },
  {
    av: 24757,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to buy + intensity)',
    english: 'spending spree',
    swedish: 'slöseri',
    norwegian: 'pengesløsing',
    finnish: 'tuhlaus, tuhlaaminen',
    hungarian: 'költekezés',
    german: 'Verschwendung',
    dutch: 'uitgave',
    afrikaans: 'bestedingsboemel',
    russian: 'трата денег',
    latvian: 'tērēšanās, svaidīšanās ar naudu',
    polish: 'wydatki na przyjemności',
    french: "frénésie d'achat",
    spanish: 'despilfarro',
  },
  {
    av: 24758,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(spending + action indicator)',
    english: 'splurge-(to)',
    swedish: 'slösa',
    norwegian: 'sløse (penger)',
    finnish: 'törsätä, tuhlata, tuhlailla',
    hungarian: 'költekezni, kirúgni a hámból',
    german: 'prassen, protzen, verschwenden',
    dutch: 'spenderen, uitgeven',
    afrikaans: 'verkwis (om te)',
    russian: 'тратить деньги',
    latvian: 'dižoties, plātīties',
    polish: 'przepuszczać pieniądze, wydawać na przyjemności',
    french: 'acheter à profusion',
    spanish: 'derrochar',
  },
  {
    av: 24759,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(person + activity + another)',
    english: 'stand-in, substitute, alternate',
    swedish: 'vikarie, ersättare (etc)',
    norwegian: 'vikar, stand-in',
    finnish: 'sijainen',
    hungarian: 'helyettes, beugró (fn.), dublőr',
    german: 'Vertretung, Ersatz, Stellvertreter, Stellvertreterin',
    dutch: 'vervanger, stand in',
    afrikaans: 'plaasvervanger, substituut, alternatief',
    russian: 'заместитель',
    latvian: 'nomainīt, samainīt, aizstāt',
    polish: 'zastępca',
    french: 'remplaçant, suppléant',
    spanish: 'reemplazar, substituir',
  },
  {
    av: 24760,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(right turn, right (position or direction) + boat)',
    english: 'starboard',
    swedish: 'styrbord',
    norwegian: 'styrbord',
    finnish: 'tyyrpuuri',
    hungarian: 'hajó jobb oldala',
    german: 'Steuerbord',
    dutch: 'stuurboord',
    afrikaans: 'stuurboord',
    russian: 'правый борт',
    latvian: 'labais borts',
    polish: 'sterburta (prawa burta statku)',
    french: 'tribord',
    spanish: 'estribor',
  },
  {
    av: 24762,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + unknown)',
    english: 'stranger, unknown (person)',
    swedish: 'främling, okänd (person)',
    norwegian: 'fremmed, ukjent person',
    finnish: 'tuntematon henkilö',
    hungarian: 'ismeretlen ember, idegen személy ',
    german: 'Fremde, Fremder',
    dutch: 'vreemdeling, onbekende',
    afrikaans: 'vreemdeling, onbekende persoon',
    russian: 'незнакомец, неизвестный (человек)',
    latvian: 'svešinieks, nepazīstama persona',
    polish: 'obcy, nieznany (osoba), nie wiadomo kto',
    french: 'étranger, inconnu (personne)',
    spanish: 'extraño, desconocido (persona)',
  },
  {
    av: 24763,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rock + under + water (ground level) (sea [contr.]))',
    english: 'submerged rock, reef',
    swedish: 'undervattensgrund',
    norwegian: 'undervannsskjær, rev',
    finnish: 'vedenalainen kari',
    hungarian: 'vízalatti szikla, elsüllyedt szikla',
    german: 'unter Wasser liegende Klippe',
    dutch: 'onzichtbare rots, berg onder water',
    afrikaans: 'onder water rots, onsigbare klip',
    russian: 'подводные скалы',
    latvian: 'zemūdens klints',
    polish: 'rafa, mielizna (skała podwodna)',
    french: 'écueil, rocher submergé',
    spanish: 'roca sumergida',
  },
  {
    av: 24764,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sofa + sun)',
    english: 'sun lounger, deck chair',
    swedish: 'solstol',
    norwegian: 'solseng',
    finnish: 'aurinkotuoli, rantatuoli',
    hungarian: 'napozóágy, napozószék',
    german: 'Liege, Liegestuhl, Deckstuhl',
    dutch: 'ligzetel (zon), ligstoel',
    afrikaans: 'dekstoel',
    russian: 'шезлонг, лежак',
    latvian: 'sauļošanās krēsls',
    polish: 'leżak',
    french: 'transat',
    spanish: 'tumbona',
  },
  {
    av: 24765,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to rest + sun + action indicator)',
    english: 'sunbathe-(to)',
    swedish: 'solbada, sola sig',
    norwegian: 'solbade, sole seg',
    finnish: 'ottaa aurinkoa',
    hungarian: 'napozni, napfürdőzni',
    german: 'sich sonnen',
    dutch: 'zonnebaden',
    afrikaans: 'sonbaai, sonbad (om te)',
    russian: 'принимать солнечные ванны',
    latvian: 'sauļoties',
    polish: 'opalać się',
    french: 'prendre un bain de soleil',
    spanish: 'tomar sol',
  },
  {
    av: 24766,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(suntan + intensity)',
    english: 'sunburn',
    swedish: 'solbränna, solsveda ',
    norwegian: 'solbrenthet',
    finnish: 'auringonpolttama, päivetys',
    hungarian: 'napégés, leégés',
    german: 'Sonnenbrand',
    dutch: 'zonnebrand',
    afrikaans: 'sonbrand',
    russian: 'солнечный ожог',
    latvian: 'saules apdegums',
    polish: 'oparzenie słoneczne',
    french: 'coup de soleil',
    spanish: 'quemadura de sol',
  },
  {
    av: 24767,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(glasses + sun)',
    english: 'sunglasses',
    swedish: 'solglasögon',
    norwegian: 'solbriller',
    finnish: 'aurinkolasit',
    hungarian: 'napszemüveg',
    german: 'Sonnenbrille',
    dutch: 'zonnebril',
    afrikaans: 'sonbril',
    russian: 'солнечные очки',
    latvian: 'saulesbrilles',
    polish: 'okulary słoneczne',
    french: 'lunettes de soleil',
    spanish: 'gafas',
  },
  {
    av: 24768,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(colour + effect + sun)',
    english: 'suntan',
    swedish: 'solbränna',
    norwegian: 'solbrun, solfarge',
    finnish: 'rusketus',
    hungarian: 'napbarnulás, lesülés',
    german: 'Sonnenbrand',
    dutch: 'kleurtje (zon), zongebruind',
    afrikaans: 'sonbrand',
    russian: 'загар',
    latvian: 'saules iedegums',
    polish: 'opalenizna',
    french: 'bronzage',
    spanish: 'bronceado',
  },
  {
    av: 24769,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(use + time + action indicator)',
    english: 'Take your time!',
    swedish: 'Ta den tid du behöver!',
    norwegian: 'ta den tid du trenger! (utsagn)',
    finnish: 'kaikessa rauhassa!',
    hungarian: 'Nem kell sietni! Van időd, nyugi! Csak nyugodtan! ',
    german: 'Nimm dir deine Zeit! Nehmen Sie Ihre Zeit!',
    dutch: 'neem je tijd',
    afrikaans: 'neem jou tyd',
    russian: 'Не спеши! Торопиться некуда!',
    latvian: 'nesteidzies!',
    polish: 'spiesz się!',
    french: 'prendre le temps',
    spanish: '¡Tómate tu tiempo!',
  },
  {
    av: 24770,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chair + toilet)',
    english: 'toilet chair, commode chair',
    swedish: 'toalettstol',
    norwegian: 'toalettstol',
    finnish: 'wc-tuoli',
    hungarian: 'szobavécé',
    german: 'Toilettensitz',
    dutch: 'toiletstoel',
    afrikaans: 'toilet stoel',
    russian: 'туалетный стул',
    latvian: 'tualetes pods',
    polish: 'krzesło toaletowe, sedes',
    french: 'chaise percée',
    spanish: 'taza del váter, inodoro',
  },
  {
    av: 24771,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(visitor + place)',
    english: 'tourist',
    swedish: 'turist',
    norwegian: 'turist',
    finnish: 'matkailija, turisti',
    hungarian: 'turista',
    german: 'Tourist, Touristin',
    dutch: 'toerist',
    afrikaans: 'toeris',
    russian: 'турист',
    latvian: 'tūrists (-e)',
    polish: 'turysta',
    french: 'touriste',
    spanish: 'turista',
  },
  {
    av: 24772,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(visitor + country)',
    english: 'tourist (foreign)',
    swedish: 'turist (utländsk)',
    norwegian: 'turist (utenlandsk)',
    finnish: 'ulkomaalainen turisti, ulkomaalainen matkailija',
    hungarian: 'turista (külföldi)',
    german: 'Tourist, Touristin (ausländisch)',
    dutch: 'toerist',
    afrikaans: 'toeris (buitelandse)',
    russian: 'турист (иностранец)',
    latvian: 'ārzemju tūrists (-e)',
    polish: 'turysta (zagraniczny)',
    french: 'touriste (étranger)',
    spanish: 'turista (extranjero)',
  },
  {
    av: 24773,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + channel)',
    english: 'TV programme, TV show, radio programme',
    swedish: 'TV-program, radioprogram',
    norwegian: 'TV-program, fjernsynsprogram',
    finnish: 'tv-ohjelma, televisio-ohjelma',
    hungarian: 'tévéműsor, rádióműsor',
    german: 'TV-Programm, Fernsehprogramm, Radioprogramm',
    dutch: 'TV programma, radioprogramme',
    afrikaans: 'TV program, radioprogram',
    russian: 'телепрограмма, радиопрограмма',
    latvian: 'TV programma, uzvedums, radio programma',
    polish: 'program TV',
    french: 'programme TV',
    spanish: 'programa de TV, programa de radio',
  },
  {
    av: 24774,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + signal, broadcast, transmitting)',
    english: 'TV studio, radio studio',
    swedish: 'TV-studio, radiostudio',
    norwegian: 'TV-studio, radiostudio',
    finnish: 'tv-studio, radio-studio',
    hungarian: 'tévéstúdió/műterem, rádióstúdió/műterem',
    german: 'Fernsehstudio, Rundfunkstudio',
    dutch: 'TV studio, radio studio',
    afrikaans: 'TV studio, radio studio',
    russian: 'телестудия, радиостудия',
    latvian: 'TV studija, radiostudija',
    polish: 'studio nadawcze (TV, radio)',
    french: 'studio de TV, studio de radio',
    spanish: 'estudio de TV, estudio de radio',
  },
  {
    av: 24775,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bottle + urine)',
    english: 'urine bottle',
    swedish: 'urinflaska',
    norwegian: 'urinflaske',
    finnish: 'pissapullo, sorsa',
    hungarian: 'vizeletgyjűtő (palack, zacskó)',
    german: 'Urinflasche',
    dutch: 'plasfles',
    afrikaans: 'urine bottel',
    russian: 'бутылка для мочи',
    latvian: 'urīna analīžu trauks',
    polish: 'butelka na mocz',
    french: 'urinal, panne',
    spanish: 'botella para orinar',
  },
  {
    av: 24776,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + star + stripe)',
    english: 'USA',
    swedish: 'USA',
    norwegian: 'USA',
    finnish: 'USA, Amerikan yhdysvallat',
    hungarian: 'Amerikai Egyesült Államok, USA',
    german: 'Vereinigte Staaten, USA',
    dutch: 'USA',
    afrikaans: 'USA',
    russian: 'США',
    latvian: 'ASV',
    polish: 'USA',
    french: 'USA, Etats-Unis',
    spanish: 'EE.UU.',
  },
  {
    av: 24777,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + bring + food)',
    english: 'waiter, waitress',
    swedish: 'servitör, servitris',
    norwegian: 'servitør, servitrise',
    finnish: 'tarjoilija, tarjoilijatar',
    hungarian: 'pincér, pincérnő',
    german: 'Bedienung, Kellner, Kellnerin, Ober',
    dutch: 'serveerster, ober',
    afrikaans: 'kelner, kelnerin',
    russian: 'официант',
    latvian: 'viesmīlis, -e',
    polish: 'kelner, kelnerka',
    french: 'serveur',
    spanish: 'mesero, mesera',
  },
  {
    av: 24779,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(communication satellite + camera)',
    english: 'weather satellite, spy satellite',
    swedish: 'vädersatellit, spionsatellit',
    norwegian: 'værsatelitt',
    finnish: 'sääsatelliitti, vakoilusatelliitti',
    hungarian: 'időjárásjelző műhold, kém műhold',
    german: 'Wettersatellit, Spionensatellit',
    dutch: 'weersateliet, spionagesateliet',
    afrikaans: 'weer satelliet, spioenasie satelliet',
    russian: 'метеорологический спутник, спутник-шпион',
    latvian: 'laika ziņu satelīts',
    polish: 'satelita meteorologiczny, satelita szpiegowski',
    french: 'satellite météo, satellite espion',
    spanish: 'satélite climático, satélite espía',
  },
  {
    av: 24780,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(grain + without + linear thing + thing indicator: ear of grain without tassels)',
    english: 'wheat',
    swedish: 'vete',
    norwegian: 'hvete',
    finnish: 'vehnä',
    hungarian: 'búza',
    german: 'Weizen',
    dutch: 'tarwe',
    afrikaans: 'koring',
    russian: 'пщеница',
    latvian: 'kvieši',
    polish: 'pszenica',
    french: 'blé, froment',
    spanish: 'trigo',
  },
  {
    av: 24781,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(telephone + camera)',
    english: 'video phone',
    swedish: 'bildtelefon, videotelefon',
    norwegian: 'bildetelefon, videotelefon',
    finnish: 'kuvapuhelin',
    hungarian: 'videotelefon',
    german: 'Bildtelefon',
    dutch: 'videotelefoon',
    afrikaans: 'videofoon',
    russian: 'видеотелефон',
    latvian: 'video telefons',
    polish: 'wideo telefon',
    french: 'vidéophone, visiophone',
    spanish: 'videoteléfono',
  },
  {
    av: 24802,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(musical instrument + 1 + musical note)',
    english: 'bell, chime bar',
    swedish: 'tonstav, klocka',
    norwegian: 'tonestav, klokke (instr.) ',
    finnish: 'kellopeli',
    hungarian: 'csengő, harangjáték',
    german: 'Glockenspiel, Klangstab',
    dutch: 'bel',
    afrikaans: 'bel, slaan, klingel',
    russian: 'колокол, звонок, будильник',
    latvian: 'zvans, zvani',
    polish: 'dzwonek, gong (dźwięk)',
    french: 'cloche, carillon',
    spanish: 'campana, carillón',
  },
  {
    av: 24803,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(making, production, fashioning + thing indicator) - (character with thing indicator)',
    english: 'man-made item, artefact, artifact, product',
    swedish: 'produkt, tillverkad sak',
    norwegian: 'gjenstand, produkt (menneskelaget)',
    finnish: 'ihmisen tekemä tuote',
    hungarian: 'mesterséges/szintetikus termék, műtermék, mű-',
    german: 'künstlicher Gegenstand, Produkt, Artefakt',
    dutch: 'product, ding (gemaakt door mensen)',
    afrikaans: 'mensgemaakte ding, produk, artefak',
    russian: 'искусственно созданный объект, артефакт',
    latvian: 'mākslīgi izgatavots priekšmets, artefakts',
    polish: 'produkt, produkcja (rzeczownik) ',
    french: 'objet fait main, objet artisanal',
    spanish: 'artículo, artefacto artificial, hecho por el hombre',
  },
  {
    av: 24804,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + intensity)',
    english: 'eagerness, keenness, willingness',
    swedish: 'iver',
    norwegian: 'iver',
    finnish: 'into, aulius',
    hungarian: 'készségesség, szolgálatkészség, szívesség',
    german: 'Eifer, Ungeduld, Versessenheit, Willigkeit',
    dutch: 'bereidheid',
    afrikaans: 'gretigheid, bereidwilligheid',
    russian: 'рвение, увлечённость',
    latvian: 'kāre, aizrautība, vēlme',
    polish: 'gorliwość, pragnienie, zapał',
    french: 'volonté, enthousiasme',
    spanish: 'entusiasmo, buena voluntad',
  },
  {
    av: 24808,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(harmony, harmoniousness, concord, concordance + description indicator)',
    english: 'agreed, in agreement, harmonious',
    swedish: 'överens, enig',
    norwegian: 'enig, overens',
    finnish: 'sopusointuinen, yksimielinen',
    hungarian: 'egyetértő, összehangzó, harmonikus',
    german: 'übereinstimmend, in Übereinstimmung sein',
    dutch: 'overeenkomstig',
    afrikaans: 'ooreengekom, ooreenkoms, harmonieus',
    russian: 'согласный',
    latvian: 'panākt vienošanos, vienotībā, harmonijā',
    polish: 'uzgodnione, w porozumieniu',
    french: 'en accord',
    spanish: 'acordado, de acuerdo, conforme',
  },
  {
    av: 24809,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sink, basin + length, longness + thing indicator)',
    english: 'bathtub, bath, tub',
    swedish: 'badkar',
    norwegian: 'badekar',
    finnish: 'kylpyamme, vanna, amme',
    hungarian: 'fürdőkád',
    german: 'Badewanne',
    dutch: 'bad',
    afrikaans: 'bad',
    russian: 'ванна',
    latvian: 'vanna',
    polish: 'wanna',
    french: 'baignoire',
    spanish: 'bañera, tina',
  },
  {
    av: 24810,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(trumpet, horn, cornet (1) + animal)',
    english: 'bugle (hunting)',
    swedish: 'jakthorn',
    norwegian: 'jakthorn',
    finnish: 'metsästystorvi',
    hungarian: 'vadászkürt',
    german: 'Jagdhorn',
    dutch: 'signaaltrompet',
    afrikaans: 'beuel (jag)',
    russian: 'охотничий рожок',
    latvian: 'pūst ragu, taurēt (medībās)',
    polish: 'róg myśliwski (polowanie)',
    french: 'clairon, cor de chasse',
    spanish: 'clarín (cacería), corneta',
  },
  {
    av: 24811,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(leader, director, guide (1) + musical note (music [contr.])) Preferred NEW SYNONYM, replacing 13399',
    english: 'conductor (music)',
    swedish: 'dirigent',
    norwegian: 'dirigent',
    finnish: 'orkesterinjohtaja, kuoronjohtaja',
    hungarian: 'karmester',
    german: 'Dirigent (Musik)',
    dutch: 'dirigent',
    afrikaans: 'dirigent (musiek)',
    russian: 'дирижёр',
    latvian: 'diriģents (mūzikā)',
    polish: 'dyrygent (muzyka)',
    french: "chef d'orchestre",
    spanish: 'director (música)',
  },
  {
    av: 24812,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(board, board of directors, executive + country) Preferred NEW SYNONYM, replacing 14462',
    english: 'government',
    swedish: 'regering',
    norwegian: 'regjering',
    finnish: 'hallitus',
    hungarian: 'kormány',
    german: 'Regierung',
    dutch: 'regering',
    afrikaans: 'regering',
    russian: 'правительство',
    latvian: 'valdība',
    polish: 'rząd',
    french: 'gouvernement',
    spanish: 'gobierno',
  },
  {
    av: 24813,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(homosexuality (female), lesbianism + description indicator)',
    english: 'homosexual (female), lesbian',
    swedish: 'homosexuell, lesbisk',
    norwegian: 'homoseksuell (kvinne), homofil (kvinne), lesbisk',
    finnish: 'homoseksuaalinen, lesbo',
    hungarian: 'homoszexuális nő, leszbikus',
    german: 'Homosexualität, (lesbisch)',
    dutch: 'homoseksueel (vrouw), lesbisch',
    afrikaans: 'homoseksueel (vroulik)lesbies',
    russian: 'гомосексуальный, лесбийский',
    latvian: 'homoseksuāla sieviete, lezbiete',
    polish: 'homoseksualistka, lesbijka',
    french: 'homosexuelle, lesbienne',
    spanish: 'homosexual (mujer) lesbiana',
  },
  {
    av: 24814,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(homosexuality (male) + description indicator)',
    english: 'homosexual (male), gay',
    swedish: 'homosexuell, gay',
    norwegian: 'homoseksuell (mann), homofil (mann), gay',
    finnish: 'homoseksuaalinen, gay',
    hungarian: 'homoszexuális férfi, meleg',
    german: 'Homosexualität (schwul)',
    dutch: 'homoseksueel (man)',
    afrikaans: 'homoseksueel (manlik)',
    russian: 'гомосексуальный, гейский',
    latvian: 'homoseksuāls vīrietis, gejs',
    polish: 'homoseksualista, gej',
    french: 'homosexuel (masculin)',
    spanish: 'homosexual (hombre) gay',
  },
  {
    av: 24815,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(love, affection + description indicator)',
    english: 'in love',
    swedish: 'kär, förälskad',
    norwegian: 'forelsket',
    finnish: 'rakastunut, ihastunut',
    hungarian: 'szerelmes (mn.)',
    german: 'verliebt',
    dutch: 'verliefd',
    afrikaans: 'verlief',
    russian: 'влюблённый',
    latvian: 'iemīlējies, iemīlējusies',
    polish: 'zakochany',
    french: 'amoureux',
    spanish: 'enamorado(a)',
  },
  {
    av: 24816,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(massage + action indicator)',
    english: 'massage-(to)',
    swedish: 'massera',
    norwegian: 'massere',
    finnish: 'hieroa',
    hungarian: 'maszírozni',
    german: 'massieren',
    dutch: 'masseren',
    afrikaans: 'masseer (om te)',
    russian: 'делать массаж',
    latvian: 'masēt',
    polish: 'masować',
    french: 'masser',
    spanish: 'masajear',
  },
  {
    av: 24817,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(offspring, child + sibling: child of a sibling)',
    english: 'niece or nephew',
    swedish: 'syskonbarn',
    norwegian: 'niese, nevø, søskenbarn',
    finnish: 'veljenpoika, veljentytär, sisarenpoika, sisarentytär',
    hungarian: 'unokahúg, unokaöcs',
    german: 'Nichte oder Neffe',
    dutch: 'nicht of neef',
    afrikaans: 'niggie of neef',
    russian: 'племянник, племянница',
    latvian: 'brāļameita, māsasmeita, brāļadēls, māsasdēls',
    polish: 'siostrzeniec, siostrzenica, kuzyn, kuzynka, krewny',
    french: 'nièce, neveu',
    spanish: 'sobrina o sobrino',
  },
  {
    av: 24818,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(knowledge, class (in combinations) + mind + feeling: where mind + feeling represents psychology [contr.]',
    english: 'psychology (class)',
    swedish: 'psykologi (skolämne)',
    norwegian: 'psykologifag',
    finnish: 'psykologia (kouluaine)',
    hungarian: 'pszichológia (tantárgy)',
    german: 'Psychologie (Schulfach)',
    dutch: 'psychologie (les)',
    afrikaans: 'sielkunde (klas)',
    russian: 'психология (предмет)',
    latvian: 'psiholoģijas nodarbība',
    polish: 'psychologiczny/ne/na',
    french: 'cours de psychologie',
    spanish: 'psicología (clase)',
  },
  {
    av: 24819,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(forward + intensity)',
    english: 'quickness, rapidity, speediness',
    swedish: 'snabbhet',
    norwegian: 'raskhet, kvikkhet',
    finnish: 'nopeus',
    hungarian: 'gyorsaság, sebesség',
    german: 'Schnelligkeit, Geschwindigkeit, Tempo',
    dutch: 'snelheid',
    afrikaans: 'vinnig, spoed',
    russian: 'скорость',
    latvian: 'ātrums',
    polish: 'szybkość, prędkość',
    french: 'vitesse, rapidité',
    spanish: 'rapidez, celeridad',
  },
  {
    av: 24820,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cause + terror, panic)',
    english: 'terrorism',
    swedish: 'terrorism',
    norwegian: 'terrorisme',
    finnish: 'terrorismi',
    hungarian: 'terrorizmus',
    german: 'Terrorismus',
    dutch: 'terrorisme',
    afrikaans: 'terrorisme',
    russian: 'тероризм',
    latvian: 'terorisms',
    polish: 'terroryzm',
    french: 'terrorisme',
    spanish: 'terrorismo',
  },
  {
    av: 24821,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(trouble + description indicator)',
    english: 'troublesome',
    swedish: 'besvärlig',
    norwegian: 'besværlig, vanskelig',
    finnish: 'hankala, vaivalloinen, ongelmallinen',
    hungarian: 'bajos, kellemetlen, kínos, zavaró',
    german: 'beschwerlich, lästig',
    dutch: 'lastig',
    afrikaans: 'lastig, lastige',
    russian: 'трудный, хлопотный',
    latvian: 'uztraucošs',
    polish: 'kłopotliwy, uciążliwy',
    french: 'gênant, pénible',
    spanish: 'problemático(a)',
  },
  {
    av: 24822,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + up and down: unsettled feelings)',
    english: 'upset, disturbance, agitation',
    swedish: 'upprördhet',
    norwegian: 'opprørthet, uro',
    finnish: 'levottomuus',
    hungarian: 'zaklatottság, feldúltság, izgatottság, zavarodottság',
    german: 'verärgert, Unruhe, Aufregung (Adjektiv eller substantiv?)',
    dutch: 'verontrusting',
    afrikaans: 'ontstel, roering',
    russian: 'расстройство, возмущение',
    latvian: 'apbēdinājums, uztraukums, uzbudinājums',
    polish: 'zdenerwowanie, pobudzenie',
    french: 'trouble, dérangement, perturbation, agitation',
    spanish: 'molestia, malestar, agitación',
  },
  {
    av: 24823,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(say, speak, talk, tell, express-(to) + intensity + action indicator)',
    english: 'cry out, call-(to)',
    swedish: 'ropa',
    norwegian: 'rope',
    finnish: 'huudahtaa',
    hungarian: 'kiáltani, kiabálni',
    german: 'rufen',
    dutch: 'roepen',
    afrikaans: 'ontsteld uitroep (om te)',
    russian: 'кричать',
    latvian: 'izkliegt',
    polish: 'krzyczeć, wzywać',
    french: 'appeler, crier',
    spanish: 'gritar',
  },
  {
    av: 24824,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(happiness + mouth: expression of happiness with the mouth by laughing)',
    english: 'laugh, laughter',
    swedish: 'skratt',
    norwegian: 'latter',
    finnish: 'nauru',
    hungarian: 'nevetés',
    german: 'Lachen, Gelächter',
    dutch: 'lach',
    afrikaans: 'lag',
    russian: 'смех',
    latvian: 'smieties, smiekli',
    polish: 'śmiech, radość',
    french: 'amusement, rire',
    spanish: 'risa',
  },
  {
    av: 24826,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + jewel)',
    english: 'jewelry, jewellery',
    swedish: 'smycke',
    norwegian: 'smykke, juvel',
    finnish: 'jalokivet, korut',
    hungarian: 'ékszer',
    german: 'Juwelen, Schmuck',
    dutch: 'juwelen',
    afrikaans: 'juweliersware',
    russian: 'ювелирное украшение',
    latvian: 'rotaslietas, dārglietas',
    polish: 'biżuteria',
    french: 'bijouterie',
    spanish: 'joyería, joya',
  },
  {
    av: 24827,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(sadness, sorrow, unhappiness + mouth: mouth displaying an unhappy and bored feeling)',
    english: 'boring, dull, depressing',
    swedish: 'tråkig',
    norwegian: 'tråkig, kjedelig',
    finnish: 'tylsä, masentava, pitkäveteinen',
    hungarian: 'unalmas, lehangoló, fakó, tompa, deprimáló',
    german: 'langweilig, uninteressant',
    dutch: 'vervelend, saai',
    afrikaans: 'vervelend, vervelig',
    russian: 'скучный, унылый',
    latvian: 'garlaicīgs, nomācošs, depresīvs',
    polish: 'nudne, smutne, przygnębiające',
    french: 'ennuyeux, morne, déprimant',
    spanish: 'aburrido, deprimente',
  },
  {
    av: 24828,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + bath, washing + clothing)',
    english: 'laundry (workplace)',
    swedish: 'tvättstuga',
    norwegian: 'vaskerom',
    finnish: 'pesula',
    hungarian: 'mosoda, mosókonyha',
    german: 'Waschsalon',
    dutch: 'wasplaats, waslokaal',
    afrikaans: 'wasgoed',
    russian: 'прачечная',
    latvian: 'veļas mazgātuve (darbavieta)',
    polish: 'pralnia (pomieszczenie)',
    french: 'lavoir',
    spanish: 'lavandería (lugar de trabajo)',
  },
  {
    av: 24829,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(good, well, fine, ok, okay, all right + intensity + description indicator)',
    english: 'great, wonderful, fantastic',
    swedish: 'fantastisk, underbar, jättebra',
    norwegian: 'skjønn, fantastisk, kjempebra',
    finnish: 'fantastinen, loistava',
    hungarian: 'csodálatos, fantasztikus, nagyszerű',
    german: 'wundervoll, wunderbar',
    dutch: 'geweldig',
    afrikaans: 'wonderlik, fantasties',
    russian: 'отличный, замечательный, фантастический',
    latvian: 'lielisks, brīnumains, fantastisks',
    polish: 'wspaniały, fantastyczny',
    french: 'important, merveilleux, fantastique',
    spanish: 'hermoso, fantástico',
  },
  {
    av: 24830,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hot spring + intensity)',
    english: 'geyser',
    swedish: 'gejser, geysir',
    norwegian: 'varm kilde, geysir',
    finnish: 'geysir',
    hungarian: 'gejzír, hővízvulkán, forró víz kitörés',
    german: 'Geisir',
    dutch: 'geiser',
    afrikaans: 'geiser, warmwatertoestel',
    russian: 'гейзер',
    latvian: 'geizeris',
    polish: 'gejzer',
    french: 'geyser',
    spanish: 'géiser',
  },
  {
    av: 24831,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fear + intensity)',
    english: 'terror, panic',
    swedish: 'skräck, fasa, panik',
    norwegian: 'panikk, skrekk',
    finnish: 'kauhu, paniikki',
    hungarian: 'rettegés, rémület, terror, pánik',
    german: 'Terror, Panik, Bestürzung',
    dutch: 'terreur, paniek',
    afrikaans: 'terreur, verskrikking, paniek',
    russian: 'ужас, паника',
    latvian: 'terors, panika',
    polish: 'strach, panika',
    french: 'frayeur, panique',
    spanish: 'terror, pánico',
  },
  {
    av: 24832,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(end, arrival, stop + limited time: a halt for a limited time)',
    english: 'wait, waiting',
    swedish: 'väntan',
    norwegian: 'venting',
    finnish: 'odotus, odottaminen',
    hungarian: 'várás, várakozás',
    german: 'Warten',
    dutch: 'wacht',
    afrikaans: 'wag',
    russian: 'ожидание',
    latvian: 'gaidīt, gaidīšana',
    polish: 'czekanie, oczekiwanie',
    french: 'attente',
    spanish: 'espera, esperando',
  },
  {
    av: 24834,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + fire: an emotional desire, a strong feeling shown by fire) See also: wish, desire 24833',
    english: 'want, desire',
    swedish: 'vilja (subst.)',
    norwegian: 'ønske, vilje',
    finnish: 'halu, tahto',
    hungarian: 'akarat, óhajtás, vágyakozás',
    german: 'Mangel, Sehnsucht',
    dutch: 'verlangen, wens',
    afrikaans: 'behoefte, begeerte',
    russian: 'хотение',
    latvian: 'vēlme, iekāre',
    polish: 'pożądanie, pragnienie',
    french: 'désir',
    spanish: 'deseo',
  },
  {
    av: 24835,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + ago, then (past))',
    english: 'last month',
    swedish: 'förra månaden',
    norwegian: 'forrige måned',
    finnish: 'viime kuukausi',
    hungarian: 'az előző hónap',
    german: 'letzten Monat',
    dutch: 'vorige maand',
    afrikaans: 'laas maand',
    russian: 'прошлый месяц',
    latvian: 'iepriekšējais mēnesis',
    polish: 'w zeszłym miesiącu',
    french: 'le mois passé',
    spanish: 'el mes pasado',
  },
  {
    av: 24840,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + anthropology)',
    english: 'anthropologist',
    swedish: 'antropolog',
    norwegian: 'antropolog',
    finnish: 'antropologi',
    hungarian: 'antropológus',
    german: 'Anthropologe, Anthropologin',
    dutch: 'antropologist',
    afrikaans: 'antropoloog',
    russian: 'антрополог',
    latvian: 'antropologs',
    polish: '',
    french: 'anthropologue',
    spanish: 'antropólogo(a)',
  },
  {
    av: 24841,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + child)',
    english: "children's room",
    swedish: 'barnrum',
    norwegian: 'barnerom',
    finnish: 'lastenhuone',
    hungarian: 'gyerekszoba',
    german: 'Kinderzimmer',
    dutch: 'kinderkamer',
    afrikaans: 'kinderkamer',
    russian: 'детская комната',
    latvian: 'bērnistaba',
    polish: '',
    french: "chambre d'enfant",
    spanish: 'habitación de los niños',
  },
  {
    av: 24842,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(cost, price + action indicator)',
    english: 'cost-(to)',
    swedish: 'kosta',
    norwegian: 'koste',
    finnish: 'maksaa',
    hungarian: 'kerülni (vmibe)',
    german: 'kosten',
    dutch: 'kosten',
    afrikaans: 'koste (om te)',
    russian: 'стоить',
    latvian: 'cena, izmaksas',
    polish: '',
    french: 'coûter',
    spanish: 'costar',
  },
  {
    av: 24843,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(exhibitionism, immodesty, indecent exposure + action indicator)',
    english: 'expose oneself indecently-(to)',
    swedish: 'blotta sig',
    norwegian: 'blotte seg',
    finnish: 'paljastaa itsensä',
    hungarian: 'szemérmetlenül mutogatni, exhibicionálni',
    german: 'sich entblöβen (unanständig/Exhibitionist)',
    dutch: 'zichzelf te kijk zetten (onfatsoenlijk)',
    afrikaans: 'jouself onsedelik blootstel (om te)',
    russian: 'подвергать себя непристойностям',
    latvian: 'izrādīt sevi nepieklājīgā, piedauzīgā apģērbā; ekshibicionēt ',
    polish: '',
    french: "commettre un outrage à la pudeur, exhiber-(s')",
    spanish: 'exponerse de manera indecente',
  },
  {
    av: 24844,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to do + all + description indicator)',
    english: 'finished, complete, completed, all done, done (finished)',
    swedish: 'färdig, klar, avslutad',
    norwegian: 'fullført, ferdig, avsluttet',
    finnish: 'loppuun tehty, valmis',
    hungarian: 'teljes, befejezett, komplett',
    german: 'fertig, abgeschlossen',
    dutch: 'afgewerkt, compleet, voltooid',
    afrikaans: 'klaar, voledig, voledige',
    russian: 'законченный, полный, завершённый',
    latvian: 'pabeigts',
    polish: '',
    french: 'fini, complet, terminé',
    spanish: 'terminado, completo',
  },
  {
    av: 24845,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(light + description indicator)',
    english: 'light (not dark)',
    swedish: 'ljus (adj.)',
    norwegian: 'lys (adj.)',
    finnish: 'valoisa, kirkas',
    hungarian: 'világos',
    german: 'hell (nicht dunkel)',
    dutch: 'licht (niet donker)',
    afrikaans: 'lig (nie donker nie)',
    russian: 'светлый, светло',
    latvian: 'gaisma (ant. tumsa)',
    polish: '',
    french: 'lumineux',
    spanish: 'iluminado (no oscuro)',
  },
  {
    av: 24848,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(arm + around)',
    english: 'hug, squeeze, embrace',
    swedish: 'kram',
    norwegian: 'klem, omfavnelse',
    finnish: 'halaus, syleily',
    hungarian: 'ölelés, megölelés, karolás, átkarolás',
    german: 'Umarmung',
    dutch: 'omhelzing, omarming, knuffel',
    afrikaans: 'drukkie, omhels',
    russian: 'объятие',
    latvian: 'apkampt, apskaut',
    polish: '',
    french: 'étreinte',
    spanish: 'abrazo',
  },
  {
    av: 24849,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(leader, director, guide (1) + work, employment, job) Preferred NEW SYNONYM, replacing 12878',
    english: 'boss, supervisor',
    swedish: 'chef, arbetsledare, föreståndare',
    norwegian: 'sjef, arbeidsleder',
    finnish: 'johtaja, työnjohtaja, esimies',
    hungarian: 'főnök, szupervizor',
    german: 'Chef, Chefin, der/die Vorgesetzte, Leiter, Leiterin',
    dutch: 'baas, supervisor',
    afrikaans: 'baas, opsigter, toesighouer',
    russian: 'начальник, руководитель',
    latvian: 'priekšnieks, pārraugs, vadītājs, boss',
    polish: '',
    french: 'chef, patron',
    spanish: 'jefe, supervisor',
  },
  {
    av: 24850,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(brake (general) + action indicator)',
    english: 'brake (general)-(to)',
    swedish: 'bromsa (allmänt)',
    norwegian: 'bremse',
    finnish: 'jarruttaa',
    hungarian: 'fékezni, lefékezni',
    german: 'bremsen (generell)',
    dutch: 'remmen',
    afrikaans: 'rem (algemeen) (om te)',
    russian: 'тормозить (общ.термин)',
    latvian: 'lauzt, salauzt',
    polish: '',
    french: 'freiner (général)',
    spanish: 'frenar (general)',
  },
  {
    av: 24851,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(brake (vehicle) + action indicator)',
    english: 'brake (vehicle)-(to)',
    swedish: 'bromsa (fordon)',
    norwegian: 'bremse (kjøretøy)',
    finnish: 'jarruttaa (kulkuväline)',
    hungarian: 'fékezni, megállítani (járművet)',
    german: 'bremsen (Fahrzeug)',
    dutch: 'remmen (voertuig)',
    afrikaans: 'rem (voertuig), trap die rem (van die voertuig) (om te)',
    russian: 'тормозить (транспорт)',
    latvian: 'bremzēt',
    polish: '',
    french: 'freiner (véhicule)',
    spanish: 'frenar (vehículo)',
  },
  {
    av: 24853,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(legs and feet + musical note: stepping to the rhythm of music)',
    english: 'dance, dancing',
    swedish: 'dans',
    norwegian: 'dans',
    finnish: 'tanssiminen',
    hungarian: 'tánc, táncolás',
    german: 'Tanz',
    dutch: 'dans',
    afrikaans: 'dans',
    russian: 'танец',
    latvian: 'deja, dejošana',
    polish: '',
    french: 'danse',
    spanish: 'baile',
  },
  {
    av: 24854,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(death + water)',
    english: 'drowning',
    swedish: 'drunkning',
    norwegian: 'drukning',
    finnish: 'hukkuminen',
    hungarian: 'vízbefúlás, megfulladás',
    german: 'Ertrinken',
    dutch: 'verdrinking',
    afrikaans: 'verdrink',
    russian: 'утопление',
    latvian: 'slīkšana, noslīkšana',
    polish: '',
    french: 'noyade',
    spanish: 'ahogo',
  },
  {
    av: 24857,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(platform, stage + boat, ship) Preferred NEW SYNONYM, replacing 16174',
    english: 'pier',
    swedish: 'brygga, kaj',
    norwegian: 'brygge, kai',
    finnish: 'laituri',
    hungarian: 'móló, rakpart',
    german: 'Pier, Mole, Anlegestelle',
    dutch: 'pier, aanlegsteiger',
    afrikaans: 'hawe, pier',
    russian: 'пирс',
    latvian: 'dambis, ostas dambis, mols',
    polish: '',
    french: 'quai (bateau), ponton, embarcadère',
    spanish: 'muelle',
  },
  {
    av: 24871,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mouth + purpose: speaking for a purpose)',
    english: 'advocacy',
    swedish: 'förespråkande',
    norwegian: 'argumentasjon for (muntlig)',
    finnish: 'puolustus',
    hungarian: 'képviselet, pártfogás, szószólás',
    german: 'befürworten, (Meinung) vertreten',
    dutch: 'voorspraak',
    afrikaans: 'voorspraak',
    russian: 'пропаганда',
    latvian: 'aizstāvība, advokatūra',
    polish: '',
    french: 'défense orale, plaidoyer',
    spanish: 'defensa',
  },
  {
    av: 24872,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(advocacy + legal [contr.])',
    english: 'advocacy, representation (legal)',
    swedish: 'representation, försvar (juridiskt)',
    norwegian: 'argumentasjon for, representasjon (juridisk, muntlig)',
    finnish: 'puolustuspuhe (oikeudessa)',
    hungarian: 'ügyvédi képviselet',
    german: 'verteidigen (Gericht), plädieren (Gericht)',
    dutch: 'voorspraak (legaal)',
    afrikaans: 'voorspraak, verteenwoordiging, (wetlike)',
    russian: 'юридическая пропаганда',
    latvian: 'aizstāvība, advokatūra (juridiska)',
    polish: '',
    french: 'défense orale (justice), plaidoirie',
    spanish: 'defensa, representación legal',
  },
  {
    av: 24873,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(group + musical instrument (in combinations)) Preferred NEW SYNONYM, replacing 12624',
    english: 'band, orchestra',
    swedish: 'orkester, musikgrupp (instrumental)',
    norwegian: 'orkester, band, musikkgruppe',
    finnish: 'yhtye, orkesteri',
    hungarian: 'együttes, banda',
    german: 'Orchester, Band',
    dutch: 'orkest',
    afrikaans: 'strook, band, orkes',
    russian: 'оркестр, музыкальная группа',
    latvian: 'mūzikas grupa, orķestris',
    polish: '',
    french: 'groupe musical, orchestre',
    spanish: 'banda, orquesta',
  },
  {
    av: 24874,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(name, label, term, title + action indicator)',
    english: 'be named, be called-(to)',
    swedish: 'heta',
    norwegian: 'hete, kalles',
    finnish: 'olla nimeltään',
    hungarian: 'nevezni, elnevezni, hívni valahogy',
    german: 'benennen, genannt werden, heißen',
    dutch: 'noemen, heten',
    afrikaans: 'genoem word (om te)',
    russian: 'называться',
    latvian: 'nosaukt',
    polish: '',
    french: "appeler-(s'), nommer-(se)",
    spanish: 'apodarse, llamarse',
  },
  {
    av: 24876,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(house, building, dwelling, residence + plus + food: dwelling with food)',
    english: 'board and lodging, room and board',
    swedish: 'kost och logi',
    norwegian: 'kost og losji',
    finnish: 'täysihoito',
    hungarian: 'szállás és étkezés, bentlakás',
    german: 'Unterkunft, Beherbergung, Unterbringung',
    dutch: 'kost en inwoon (Vl), kost en inwoning (Nl)',
    afrikaans: 'kamer en raad',
    russian: 'пансион (проживание и питание)',
    latvian: 'ēdināšanas un izmitināšanas mītne',
    polish: '',
    french: 'hébergement et restauration, gîte et couvert',
    spanish: 'hospedaje y comida',
  },
  {
    av: 24877,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(structure, construction + action indicator)',
    english: 'build, construct-(to)',
    swedish: 'bygga, konstruera',
    norwegian: 'bygge, konstruere',
    finnish: 'rakentaa',
    hungarian: 'építeni, készíteni, szerkeszteni',
    german: 'bauen, errichten',
    dutch: 'bouwen',
    afrikaans: 'bou, oprig (om te)',
    russian: 'строить, конструировать',
    latvian: 'būvēt, celt',
    polish: '',
    french: 'construire, structurer, édifier',
    spanish: 'construir',
  },
  {
    av: 24878,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(eye + through: the quality of being possibe to see through)',
    english: 'clearness, clarity, transparency, transparence',
    swedish: 'genomskinlighet',
    norwegian: 'gjennomsiktighet',
    finnish: 'läpinäkyvyys, kirkkaus, selkeys',
    hungarian: 'átlátszóság, átláthatóság, áttetszőség, tisztaság',
    german: 'Anschaulichkeit, Klarheit',
    dutch: 'helderheid, transparantie',
    afrikaans: 'helderheid, helder, deursigtig, deursigtigheid',
    russian: 'прозрачность, ясность, чёткость',
    latvian: 'skaidrība, caurspīdīgums',
    polish: '',
    french: 'clarté, transparence',
    spanish: 'claridad, transparencia',
  },
  {
    av: 24881,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(forward [modification, extended] + reference line [half-sized]: the arrow passes a reference line and continues on) Character (superimposed - modified)',
    english: 'continuance, continuation',
    swedish: 'fortsättning',
    norwegian: 'fortsettelse',
    finnish: 'jatkuminen, jatkuvuus',
    hungarian: 'folyamatosság, folytonosság, folytatás',
    german: 'Beständigkeit, Fortdauer, Fortsetzung, Weiterführung',
    dutch: 'voortzetting',
    afrikaans: 'voorsetting',
    russian: 'продолжение',
    latvian: 'turpināšanās, turpinājums',
    polish: '',
    french: 'continuation, suite',
    spanish: 'continuación',
  },
  {
    av: 24882,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(money + crown)',
    english: 'crown (currency)',
    swedish: 'krona (valuta)',
    norwegian: 'krone (valuta)',
    finnish: 'kruunu (valuutta)',
    hungarian: 'korona (pénznem)',
    german: 'Krone (Währung)',
    dutch: 'kroon (munteenheid)',
    afrikaans: 'kroon (geldstelsel)',
    russian: 'крона (валюта)',
    latvian: 'krona (valūta)',
    polish: '',
    french: 'couronne (devise)',
    spanish: 'corona (moneda)',
  },
  {
    av: 24885,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hate + intensity)',
    english: 'disgust',
    swedish: 'avsky (subst.)',
    norwegian: 'avsky',
    finnish: 'inho',
    hungarian: 'undor, utálat',
    german: 'Ekel, Abstoβ, Empörung',
    dutch: 'afschuw',
    afrikaans: 'walging, afgryse',
    russian: 'отвращение',
    latvian: 'riebums, pretīgums',
    polish: '',
    french: 'dégoût',
    spanish: 'repugnancia',
  },
  {
    av: 24886,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(disgust + description indicator)',
    english: 'disgusting (general)',
    swedish: 'avskyvärd',
    norwegian: 'avskyelig',
    finnish: 'inhottava',
    hungarian: 'undorító, utálatos, felháborító, förtelmes',
    german: 'abscheulich, ekelhaft',
    dutch: 'afschuwelijk',
    afrikaans: 'walglik, afskuwelike',
    russian: 'отвратительный',
    latvian: 'riebīgs, pretīgs (vispārējā noz.)',
    polish: '',
    french: 'dégoûtant',
    spanish: 'repugnante (general)',
  },
  {
    av: 24888,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(division + description indicator)',
    english: 'divided',
    swedish: 'delad',
    norwegian: 'delt',
    finnish: 'jaettu',
    hungarian: 'osztott, felosztott, megosztott, részekre osztott',
    german: 'geteilt, gespalten',
    dutch: 'verdeeld',
    afrikaans: 'verdeel',
    russian: 'разделенный, делённый',
    latvian: 'sadalīts',
    polish: '',
    french: 'divisé',
    spanish: 'dividido(a)',
  },
  {
    av: 24893,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + purpose + answer)',
    english: 'experiment',
    swedish: 'experiment',
    norwegian: 'eksperiment',
    finnish: 'koe, kokeilu',
    hungarian: 'kísérlet',
    german: 'Experiment',
    dutch: 'experiment',
    afrikaans: 'eksperiment',
    russian: 'эксперимент',
    latvian: 'eksperiments',
    polish: '',
    french: 'expérimentation, expérience',
    spanish: 'experimento',
  },
  {
    av: 24894,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(down + intensity)',
    english: 'fall, drop, spill, tumble',
    swedish: 'fall',
    norwegian: 'fall',
    finnish: 'putoaminen',
    hungarian: 'esés, bukás, leesés',
    german: 'Sturz, Fall',
    dutch: 'val',
    afrikaans: 'val',
    russian: 'падение, обрушение',
    latvian: 'krist, pilēt izliet, sagāzties',
    polish: '',
    french: 'chute',
    spanish: 'derrame, caída, ',
  },
  {
    av: 24898,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to make + to work: making something work again)',
    english: 'fixing, fix, mending, mend, repair, reparation',
    swedish: 'lagning',
    norwegian: 'reparasjon',
    finnish: 'korjaaminen, kunnostaminen',
    hungarian: 'javítás, megjavítás, helyrehozás',
    german: 'Befestigen, Fixierung, Reparatur, Ausbesserung',
    dutch: 'repareren, herstellen, maken',
    afrikaans: 'regmaak, herstel',
    russian: 'отладка, починка',
    latvian: 'salabot, savest kārtībā, izremontēt',
    polish: '',
    french: 'réparation',
    spanish: 'arreglar, reparar, restaurar',
  },
  {
    av: 24900,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + water (ground level) + up)',
    english: 'fountain',
    swedish: 'fontän',
    norwegian: 'fontene',
    finnish: 'kaivo',
    hungarian: 'szökőkút',
    german: 'Fontäne, Springbrunnen',
    dutch: 'fontein',
    afrikaans: 'fontein',
    russian: 'фонтан',
    latvian: 'strūklaka',
    polish: '',
    french: 'fontaine',
    spanish: 'fuente',
  },
  {
    av: 24901,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(canter-(to) + intensity)',
    english: 'gallop',
    swedish: 'galopp',
    norwegian: 'galopp',
    finnish: 'laukka',
    hungarian: 'galopp, vágta, galoppvágta',
    german: 'Galopp',
    dutch: 'galop',
    afrikaans: 'galop',
    russian: 'галоп',
    latvian: 'galops',
    polish: '',
    french: 'galop',
    spanish: 'galope',
  },
  {
    av: 24902,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(scientist, academic + earth, globe, world)',
    english: 'geographer',
    swedish: 'geograf',
    norwegian: 'geograf',
    finnish: 'maantieteilijä',
    hungarian: 'földrajztudós, geográfus',
    german: 'Geograph, Geographin',
    dutch: 'geograaf',
    afrikaans: 'geograaf',
    russian: 'географ',
    latvian: 'ģeogrāfs',
    polish: '',
    french: 'géographe',
    spanish: 'geógrafo',
  },
  {
    av: 24905,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(flower + up: to come up as flowers do. CKB says that this symbol applies primarily to agriculture and horticulture, but that it may be used in a general sense (i.e., growth of children).)',
    english: 'growth, growing',
    swedish: 'tillväxt',
    norwegian: 'vekst',
    finnish: 'kasvaminen, kasvu',
    hungarian: 'növés, növekedés, felnövés',
    german: 'Wachstum',
    dutch: 'groei',
    afrikaans: 'groei',
    russian: 'рост',
    latvian: 'izaugsme, augšana',
    polish: '',
    french: 'croissance',
    spanish: 'crecimiento',
  },
  {
    av: 24908,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dislike + intensity)',
    english: 'hate, hatred',
    swedish: 'hat',
    norwegian: 'hat',
    finnish: 'viha',
    hungarian: 'gyűlölet',
    german: 'Hass',
    dutch: 'haat',
    afrikaans: 'haat',
    russian: 'ненависть',
    latvian: 'ienīst, naids',
    polish: '',
    french: 'haine',
    spanish: 'odio',
  },
  {
    av: 24910,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(heterosexuality + description indicator)',
    english: 'heterosexual',
    swedish: 'heterosexuell',
    norwegian: 'hetroseksuell',
    finnish: 'hetereseksuaalinen',
    hungarian: 'heteroszexuális',
    german: 'heterosexuell',
    dutch: 'heteroseksueel',
    afrikaans: 'heteroseksueel',
    russian: 'гетеросексуальный',
    latvian: 'heteroseksuāls, -a',
    polish: '',
    french: 'hétérosexuel',
    spanish: 'heterosexual',
  },
  {
    av: 24911,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(linear thing (horizontal), bar + attachment, appendix, annex + horse: a bar for tieing up horses, thus the modification of hitch, tie up, fix up-(to) 24152',
    english: 'hitchrack, hitching bar',
    swedish: 'hästräcke',
    norwegian: 'tjoringsrekkverk',
    finnish: 'kytkintanko',
    hungarian: 'rúd, összekötő rúd',
    german: 'Anhängevorrichtung, Anbindevorrichtung mit Stange',
    dutch: 'leidsel',
    afrikaans: 'haakplek rak',
    russian: 'перила для привязывания лошади',
    latvian: 'steliņģa barjera',
    polish: '',
    french: 'brancard',
    spanish: 'amarre para caballos',
  },
  {
    av: 24914,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(indoor (character) + description indicator)',
    english: 'indoor, indoors',
    swedish: 'inomhus',
    norwegian: 'innomhus, inne',
    finnish: 'kotona',
    hungarian: 'szobai, házon belüli, fedett',
    german: 'innen (Haus)',
    dutch: 'binnen (in huis)',
    afrikaans: 'binnenshuis',
    russian: 'внутренний (в помещении)',
    latvian: 'iekštelpu, istabas, telpu',
    polish: '',
    french: "intérieur, d'intérieur, en salle",
    spanish: 'interior, adentro',
  },
  {
    av: 24919,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(smell, odour + negative)',
    english: 'malodor, malodour, stench',
    swedish: 'odör, stank',
    norwegian: 'stank, odør',
    finnish: 'löyhkä, lemu',
    hungarian: 'büdösség, bűz',
    german: 'Gestank, Geruch',
    dutch: 'stank',
    afrikaans: 'stank',
    russian: 'зловоние',
    latvian: 'smaka, smirdoņa',
    polish: '',
    french: 'mauvaise odeur, puanteur',
    spanish: 'mal olor, maloliente',
  },
  {
    av: 24921,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + then (future))',
    english: 'next month',
    swedish: 'nästa månad',
    norwegian: 'måned (neste)',
    finnish: 'ensi kuukausi',
    hungarian: 'jövő hónap, következő hónap',
    german: 'nächsten Monat',
    dutch: 'volgende maand',
    afrikaans: 'volgende maand',
    russian: 'следующий месяц',
    latvian: 'nākošais mēnesis',
    polish: '',
    french: 'mois prochain',
    spanish: 'mes siguiente',
  },
  {
    av: 24922,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sound + intensity)',
    english: 'noise (loud)',
    swedish: 'oljud, oväsen',
    norwegian: 'støy, ulyd',
    finnish: 'melu, meteli, kova ääni',
    hungarian: 'zaj, hangosság',
    german: 'Krach, Lärm',
    dutch: 'lawaai',
    afrikaans: 'geraas, lawaai, geluid (harde)',
    russian: 'шум, гул, грохот',
    latvian: 'skaņa, troksnis',
    polish: '',
    french: 'bruit',
    spanish: 'ruido (fuerte)',
  },
  {
    av: 24923,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part, bit, piece, portion, part of + crown (currency))',
    english: 'oere (currency)',
    swedish: 'öre (valuta)',
    norwegian: 'øre (valuta)',
    finnish: 'äyri (valuutta)',
    hungarian: 'öre (pénznem)',
    german: 'Öre (Währung)',
    dutch: 'Öre (munteenheid)',
    afrikaans: 'Oere (geldeenheid)',
    russian: 'эре (шведская валюта)',
    latvian: 'ēra (valūta)',
    polish: '',
    french: 'centime de couronne (devise)',
    spanish: 'centavo de SEK (centavo de corona sueca)',
  },
  {
    av: 24924,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(oval, ellipse + description indicator)',
    english: 'oval, elliptic, elliptical',
    swedish: 'oval, elliptisk',
    norwegian: 'oval, eliptisk',
    finnish: 'ovaalin muotoinen, elliptinen',
    hungarian: 'ovális, tojásdad, elliptikus (mn.)',
    german: 'oval, eiförmig',
    dutch: 'ovaal',
    afrikaans: 'ovaal, elliptiese',
    russian: 'овальный, эллиптический',
    latvian: 'ovāls',
    polish: '',
    french: 'ovale, elliptique',
    spanish: 'elíptico, oval',
  },
  {
    av: 24928,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + physics)',
    english: 'physicist',
    swedish: 'fysiker',
    norwegian: 'fysiker',
    finnish: 'fyysikko',
    hungarian: 'fizikus (fn.)',
    german: 'Physiker, Physikerin',
    dutch: 'fysicus',
    afrikaans: 'fisikus',
    russian: 'физик',
    latvian: 'fiziķis',
    polish: '',
    french: 'physicien',
    spanish: 'físico',
  },
  {
    av: 24929,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + for (the purpose of) + future: something done in order to be ready for the future)',
    english: 'preparation, readying, readiness, preparedness',
    swedish: 'förberedelse',
    norwegian: 'forberedelse',
    finnish: 'valmistelu',
    hungarian: 'előkészület, előkészítés, készülődés',
    german: 'Vorbereitung',
    dutch: 'voorbereiding',
    afrikaans: 'voorbereiding, gereedheid',
    russian: 'подготовка, приготовление',
    latvian: 'sagatavošana, sagatavošanās, gatavība',
    polish: '',
    french: 'préparation, préparatifs',
    spanish: 'preparación, alistamiento',
  },
  {
    av: 24930,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(mouth (to say) + activity + future: to say that something will be done in the future)',
    english: 'promise',
    swedish: 'löfte',
    norwegian: 'løfte (subst.)',
    finnish: 'lupaaminen',
    hungarian: 'ígéret',
    german: 'Versprechen, Zusage',
    dutch: 'belofte',
    afrikaans: 'belofte',
    russian: 'обещание',
    latvian: 'solījums, apslolījums',
    polish: '',
    french: 'promesse',
    spanish: 'promesa',
  },
  {
    av: 24931,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(protection, shelter + description indicator)',
    english: 'protected, sheltered',
    swedish: 'skyddad',
    norwegian: 'beskyttet',
    finnish: 'suojattu, turvattu',
    hungarian: 'védett',
    german: 'geschützt, behütet',
    dutch: 'beschermd',
    afrikaans: 'beskerm, beskutte',
    russian: 'защищённый',
    latvian: 'aizsargāts, pasargāts',
    polish: '',
    french: 'protégé, abrité',
    spanish: 'protegido',
  },
  {
    av: 24933,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(eye (to see) + paper, card, page: the act of seeing and perceiving what is written on the printed page)',
    english: 'reading',
    swedish: 'läsning',
    norwegian: 'lesning',
    finnish: 'lukeminen',
    hungarian: 'olvasás',
    german: 'Lesen',
    dutch: 'lezen (zelfst.nw)',
    afrikaans: 'lees',
    russian: 'чтение',
    latvian: 'lasīšana',
    polish: '',
    french: 'lecture',
    spanish: 'lectura',
  },
  {
    av: 24935,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(research + action indicator)',
    english: 'research-(to)',
    swedish: 'forska',
    norwegian: 'forske',
    finnish: 'tutkia',
    hungarian: 'kutatni',
    german: 'forschen, untersuchen',
    dutch: 'onderzoeken',
    afrikaans: 'navors (om te)',
    russian: 'исследовать, заниматься исследованием',
    latvian: 'izpētīt',
    polish: '',
    french: 'faire de la recherche',
    spanish: 'investigar',
  },
  {
    av: 24936,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + horse)',
    english: 'riding, horseback riding',
    swedish: 'ridning',
    norwegian: 'ridning',
    finnish: 'ratsastaminen',
    hungarian: 'lovaglás',
    german: 'Reiten',
    dutch: 'paardrijden',
    afrikaans: 'perdry',
    russian: 'езда на лошади',
    latvian: 'jāšana, jāt uz zirga',
    polish: '',
    french: 'équitation',
    spanish: 'cabalgar',
  },
  {
    av: 24939,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knowledge, class (in combinations) + sport)',
    english: 'sport (class)',
    swedish: 'idrott (skolämne)',
    norwegian: 'idrett (fag), gym ',
    finnish: 'urheilutunti, voimistelutunti, liikuntatunti ',
    hungarian: 'testnevelés (tantárgy)',
    german: 'Sport (Schulfach)',
    dutch: 'sportles, turnles',
    afrikaans: 'sport (klas)',
    russian: 'физкультура (предмет)',
    latvian: 'sporta nodarbība',
    polish: '',
    french: 'cours de sport, cours de gymnastique',
    spanish: 'deporte (clase)',
  },
  {
    av: 24942,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + without + time + activity: a feeling of lacking time for an activity)',
    english: 'stress (for time)',
    swedish: 'stress, jäkt',
    norwegian: 'stress',
    finnish: 'stressi, ylirasitus',
    hungarian: 'stressz, feszültség, igénybevétel',
    german: 'Stress',
    dutch: 'stress',
    afrikaans: 'spanning, stress',
    russian: 'стресс',
    latvian: 'spriedze, stress',
    polish: '',
    french: 'stress',
    spanish: 'estrés',
  },
  {
    av: 24943,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(stress (for time) + action indicator: acting with a feeling of lacking time for the activity)',
    english: 'stress (for time)-(to)',
    swedish: 'stressa, jäkta',
    norwegian: 'stresse',
    finnish: 'stressaantua, ylirasittua ',
    hungarian: 'stresszelni, feszültségben lenni',
    german: 'im Stress sein, jagen, hetzen',
    dutch: 'stressen',
    afrikaans: 'spanning (om spanning te he), stress (om te)',
    russian: 'чувствовать стресс',
    latvian: 'saspringt, satraukties',
    polish: '',
    french: "angoisser-(s')",
    spanish: 'estresar',
  },
  {
    av: 24945,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(supernatural-(noun) + description indicator)',
    english: 'supernatural',
    swedish: 'övernaturlig',
    norwegian: 'overnaturlig',
    finnish: 'yliluonnollinen',
    hungarian: 'természetfeletti',
    german: 'überirdisch',
    dutch: 'bovennatuurlijk',
    afrikaans: 'bonatuurlike',
    russian: 'сверхъестественный, неземной',
    latvian: 'pārdabisks',
    polish: '',
    french: 'surnaturel, merveilleux, fantastique',
    spanish: 'sobrenatural',
  },
  {
    av: 24946,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(taste + up: pleasant taste)',
    english: 'sweetness, sweet',
    swedish: 'sötma',
    norwegian: 'søthet',
    finnish: 'makeus',
    hungarian: 'édesség, édes íz',
    german: 'süß',
    dutch: 'zoet',
    afrikaans: 'soet, soetigheid',
    russian: 'сладость',
    latvian: 'saldums, salds',
    polish: '',
    french: 'sucrosité, goût sucré',
    spanish: 'dulzura, dulce',
  },
  {
    av: 24947,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(through + water: motion through water)',
    english: 'swimming, swim',
    swedish: 'simning',
    norwegian: 'svømming',
    finnish: 'uiminen',
    hungarian: 'úszás',
    german: 'Schwimmen',
    dutch: 'zwemmen (zelfst.nw)',
    afrikaans: 'swem',
    russian: 'плавание',
    latvian: 'peldēšana, peldēt',
    polish: '',
    french: 'nage, natation',
    spanish: 'natación, nadar',
  },
  {
    av: 24948,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + now)',
    english: 'this month',
    swedish: 'den här månaden',
    norwegian: 'måned (denne)',
    finnish: 'tämä kuukausi',
    hungarian: 'ebben a hónapban',
    german: 'diesen Monat',
    dutch: 'deze maand',
    afrikaans: 'hierdie maand',
    russian: 'текущий месяц',
    latvian: 'šomēnes',
    polish: '',
    french: 'ce mois-ci',
    spanish: 'este mes',
  },
  {
    av: 24950,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(out of, exit (forward) + food: expelling of food)',
    english: 'vomiting, vomit, puking',
    swedish: 'kräkning',
    norwegian: 'brekning',
    finnish: 'oksentaminen, ylenantaminen ',
    hungarian: 'hányás',
    german: 'sich erbrechen, sich übergeben',
    dutch: 'overgeven, braken',
    afrikaans: 'braak, braking',
    russian: 'рвота',
    latvian: 'vemšana, izvemšanās',
    polish: '',
    french: 'vomissement, régurgitation',
    spanish: 'vómito',
  },
  {
    av: 24963,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(port (boat) + description indicator)',
    english: 'aport',
    swedish: 'babord (riktning)',
    norwegian: 'babord (retning)',
    finnish: 'paapuuriin',
    hungarian: 'hajó bal oldala felőli',
    german: 'Backbord (Richtung)',
    dutch: 'bakboord (bijv.nw)',
    afrikaans: 'bakboord',
    russian: 'левобортный',
    latvian: 'kreisais borts',
    polish: '',
    french: '',
    spanish: 'babor (dirección)',
  },
  {
    av: 24964,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(starboard + description indicator)',
    english: 'astarboard',
    swedish: 'styrbord (riktning)',
    norwegian: 'styrbord (retning)',
    finnish: 'tyyrpuuriin',
    hungarian: 'hajó jobb oldala felőli',
    german: 'Steuerbord (Richtung)',
    dutch: 'stuurboord (bijv.nw)',
    afrikaans: 'stuurboord',
    russian: 'правобортный',
    latvian: 'labais borts (virziens)',
    polish: '',
    french: '',
    spanish: 'estribor (dirección)',
  },
  {
    av: 24965,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gun + animal)',
    english: 'hunt, hunting',
    swedish: 'jakt',
    norwegian: 'jakt',
    finnish: 'metsästys, metsästäminen',
    hungarian: '',
    german: 'Jagd',
    dutch: 'jacht',
    afrikaans: 'jag',
    russian: 'охота',
    latvian: 'medīt, medības, medīšana',
    polish: '',
    french: '',
    spanish: 'caza',
  },
  {
    av: 24966,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(church, mosque, temple + deletion, cancellation, destruction) SYMBOL SYNONYM',
    english: 'church ruin, temple ruin, wreck, wreckage (church, temple, mosque) (2)',
    swedish: 'kyrkoruin, tempelruin (2)',
    norwegian: 'kirkeruin, tempelruin (2)',
    finnish: 'kirkon rauniot, temppelin rauniot (2)',
    hungarian: '',
    german: 'Kirchenruine, Tempelruine (2)',
    dutch: 'ruïne (kerk, tempel) (2)',
    afrikaans: 'kerk ondergang, kerk wrak (2)',
    russian: 'разрушенная церковь (2)',
    latvian: 'baznīcas drupas, tempļa drupas, krāsmatas, gruveši (2)',
    polish: '',
    french: '',
    spanish: ' ruina de iglesia, ruina de templo (2)',
  },
  {
    av: 24967,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(military, armed forces, armed services + earth, ground, land)',
    english: 'army, regular army, ground forces',
    swedish: 'armé, markstyrkor',
    norwegian: 'hær, bakkestyrke',
    finnish: 'maavoimat, kenttäarmeija',
    hungarian: 'hadsereg',
    german: 'Armee',
    dutch: 'grondtroepen (leger)',
    afrikaans: 'weermag',
    russian: 'армия, сухопутное войско',
    latvian: 'armija, regulārā armija, sauszemes karaspēks',
    polish: 'wojsko, armia',
    french: 'armée',
    spanish: 'ejército',
  },
  {
    av: 24968,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(deletion, cancellation, destruction + description indicator)',
    english: 'destroyed, ruined, demolished, deleted, erased, cancelled',
    swedish: 'förstörd, borttagen, raderad, struken, utsuddad, utplånad',
    norwegian: 'ødelagt, strøket, kansellert',
    finnish: '',
    hungarian: '',
    german: 'zerstört, ruiniert, abgerissen, gelöscht, ausradiert, annulliert',
    dutch: 'vernietigd, verwijderd, verwoest',
    afrikaans: 'vernietig, verwoes, gesloop, geskrap, gekanselleer',
    russian: 'разрушенный',
    latvian: 'iznīcināts, sagrauts',
    polish: '',
    french: '',
    spanish: 'destruido, eliminado, borrado, anulado',
  },
  {
    av: 25001,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(accessibility + action indicator)',
    english: 'access-(to)',
    swedish: 'få tillräde (till), få åtkomst (till), få tillgång (till)',
    norwegian: 'få adgang til, få tilgang til',
    finnish: 'saavuttaa',
    hungarian: '',
    german: 'Zutritt, Zugang',
    dutch: 'toegang hebben tot',
    afrikaans: 'toegang (om te)',
    russian: 'получить доступ',
    latvian: 'piekļūt pie',
    polish: '',
    french: '',
    spanish: 'acceso (a), ',
  },
  {
    av: 25002,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(being (state of) + through: being possible to get through to)',
    english: 'accessibility, access',
    swedish: 'tillgänglighet, tillgång, åtkomlighet',
    norwegian: 'tilgjengelighet, tilgang',
    finnish: 'saatavuus',
    hungarian: '',
    german: 'Zugänglichkeit, Erreichbarkeit',
    dutch: 'toegankelijkheid',
    afrikaans: 'toeganklikheid',
    russian: 'доступность, наличие доступа',
    latvian: 'piekļuve, pieeja',
    polish: '',
    french: '',
    spanish: 'accesibilidad',
  },
  {
    av: 25003,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(accessibility + description indicator)',
    english: 'accessible',
    swedish: 'tillgänglig, åtkomlig',
    norwegian: 'tilgjengelig',
    finnish: 'saavutettu',
    hungarian: '',
    german: 'zugänglich, erreichbar',
    dutch: 'toegankelijk',
    afrikaans: 'toeganklik',
    russian: 'доступный, проходимый',
    latvian: 'pieejams, aizsniedzams',
    polish: '',
    french: '',
    spanish: 'accesible',
  },
  {
    av: 25004,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(adoption + action indicator)',
    english: 'adopt-(to)',
    swedish: 'adoptera',
    norwegian: 'adoptere',
    finnish: 'adoptoida',
    hungarian: '',
    german: 'adoptieren',
    dutch: 'adopteren',
    afrikaans: 'aaneem (om te)',
    russian: 'приёмный, усыновлённый',
    latvian: 'pieņemt, adoptēt',
    polish: '',
    french: '',
    spanish: 'adoptar',
  },
  {
    av: 25005,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + legal + parent: the act of becoming a legal parent of a child)',
    english: 'adoption',
    swedish: 'adoption',
    norwegian: 'adopsjon',
    finnish: 'adoptio',
    hungarian: '',
    german: 'Adoption',
    dutch: 'adoptie',
    afrikaans: 'aanneming',
    russian: 'опёка, усыновление',
    latvian: 'pieņemšana, adoptēšana',
    polish: '',
    french: '',
    spanish: 'adopción',
  },
  {
    av: 25006,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + thrilling + intensity) Preferred NEW SYNONYM, replacing 24601',
    english: 'adventure',
    swedish: 'äventyr',
    norwegian: 'eventyr, opplevelse',
    finnish: 'seikkailu',
    hungarian: '',
    german: 'Abenteuer',
    dutch: 'avontuur',
    afrikaans: 'avontuur',
    russian: 'приключение',
    latvian: 'piedzīvojumi',
    polish: 'przygoda',
    french: '',
    spanish: 'aventura',
  },
  {
    av: 25007,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(adventure + description indicator)',
    english: 'adventurous',
    swedish: 'äventyrlig',
    norwegian: 'eventyrlig',
    finnish: 'seikkaileva',
    hungarian: '',
    german: 'abenteuerlich, unternehmenslustig',
    dutch: 'avontuurlijk',
    afrikaans: 'avontuurlustige',
    russian: 'приключенческий',
    latvian: 'piedzīvojumu',
    polish: '',
    french: '',
    spanish: 'aventurero',
  },
  {
    av: 25008,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + kite)',
    english: 'Afghanistan',
    swedish: 'Afghanistan',
    norwegian: 'Afghanistan',
    finnish: 'Afganistan',
    hungarian: '',
    german: 'Afghanistan',
    dutch: 'Afghanistan',
    afrikaans: 'Afghanistan',
    russian: 'Афганистан',
    latvian: 'Afganistāna',
    polish: '',
    french: '',
    spanish: 'Afganistán',
  },
  {
    av: 25009,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(open + little: slightly open)',
    english: 'ajar',
    swedish: 'på glänt',
    norwegian: 'på gløtt',
    finnish: 'raollaan oleva',
    hungarian: '',
    german: 'angelehnt, halboffen',
    dutch: 'kiertje, op een kier',
    afrikaans: 'kier',
    russian: 'приоткрытый',
    latvian: 'pusvirus',
    polish: '',
    french: '',
    spanish: 'entreabierto',
  },
  {
    av: 25010,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical product + liquor)',
    english: 'alcohol, ethanol',
    swedish: 'alkohol, etanol',
    norwegian: 'alkohol, etanol',
    finnish: 'alkoholi, etanoli',
    hungarian: '',
    german: 'Alkohol, Ehtanol',
    dutch: 'alcohol, etanol',
    afrikaans: 'alkohol, etanol',
    russian: 'спирт, этанол',
    latvian: 'alkohols, etanols',
    polish: '',
    french: '',
    spanish: 'alcohol, etanol',
  },
  {
    av: 25012,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(applause + action indicator)',
    english: 'applaud, clap-(to)',
    swedish: 'applådera, klappa händerna',
    norwegian: 'applaudere, klappe hendene',
    finnish: 'aplodeerata, osoittaa suosiota, taputtaa käsiä, antaa aplodit',
    hungarian: '',
    german: 'applaudieren, (Hände) klatschen',
    dutch: 'applaudisseren',
    afrikaans: 'toejuig (om te)',
    russian: 'аплодировать, хлопать в ладоши',
    latvian: 'aplaudēt, piekrišanas izpausme',
    polish: '',
    french: '',
    spanish: 'aplaudir',
  },
  {
    av: 25013,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(2 + hand + intensity + sound: clapping the hands together as a demonstration of approval)',
    english: 'applause, clapping',
    swedish: 'applåd, handklappning',
    norwegian: 'applaus, håndklapp',
    finnish: 'suosionosoitukset, aplodit, tapututukset',
    hungarian: '',
    german: 'Applaus, Händeklatschen',
    dutch: 'applaus',
    afrikaans: 'applous, handeklap',
    russian: 'аплодистменты',
    latvian: 'applaudēšana, piekrišanas izpausme',
    polish: '',
    french: '',
    spanish: 'aplauso',
  },
  {
    av: 25014,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(weapon + description indicator)',
    english: 'armed',
    swedish: 'beväpnad',
    norwegian: 'bevæpnet',
    finnish: 'aseistettu',
    hungarian: '',
    german: 'bewaffnet',
    dutch: 'bewapend, gewapend',
    afrikaans: 'bewapende',
    russian: 'вооружённый',
    latvian: 'bruņots',
    polish: '',
    french: '',
    spanish: 'armado',
  },
  {
    av: 25015,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + musical note (music [contr.]) + mountain)',
    english: 'Austria',
    swedish: 'Österrike',
    norwegian: 'Østerrike',
    finnish: 'Itävalta',
    hungarian: '',
    german: 'Österreich',
    dutch: 'Oostenrijk',
    afrikaans: 'Oostenryk',
    russian: 'Австрия',
    latvian: 'Austrija',
    polish: '',
    french: '',
    spanish: 'Austria',
  },
  {
    av: 25017,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + getting + weapon: i.e., thief [contr.] using a weapon to steal)',
    english: 'bandit, armed robber',
    swedish: 'bandit, rånare (beväpnad)',
    norwegian: 'banditt, raner',
    finnish: 'bandiitti, maantierosvo',
    hungarian: '',
    german: 'Bandit, Räuber, Gangster (bewaffnet)',
    dutch: 'bandiet, overvaller (gewapend)',
    afrikaans: 'bandiet, gewapende rower',
    russian: 'бандит, вооружённый грабитель',
    latvian: 'bandīts, bruņots laupītājs',
    polish: '',
    french: '',
    spanish: 'bandido, ladrón armado',
  },
  {
    av: 25018,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + store + small)',
    english: 'bazaar',
    swedish: 'basar',
    norwegian: 'basar, marked',
    finnish: 'markkinat, basaari',
    hungarian: '',
    german: 'Basar, Bazar',
    dutch: 'markt',
    afrikaans: 'mark, bazaar',
    russian: 'базар (множество маленьких магазинов)',
    latvian: 'tirgus, labdarības tirdziņš, liela tirdzniecības zāle',
    polish: '',
    french: '',
    spanish: 'bazar',
  },
  {
    av: 25019,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + ask + being (state of))',
    english: 'beggar',
    swedish: 'tiggare',
    norwegian: 'tigger',
    finnish: 'kerjäläinen',
    hungarian: '',
    german: 'Bettler',
    dutch: 'bedelaar',
    afrikaans: 'bedelaar',
    russian: 'нищий, попрошайка, бедняк',
    latvian: 'ubags, ubagotājs',
    polish: '',
    french: '',
    spanish: 'méndigo',
  },
  {
    av: 25020,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(country + buffalo + tree (wood [contr.]): the country of the European Bison, or Wisent)',
    english: 'Belarus',
    swedish: 'Vitryssland',
    norwegian: 'Hviterussland, Belarus',
    finnish: 'Valko-Venäjä',
    hungarian: '',
    german: 'Weißrussland',
    dutch: 'Wit Rusland',
    afrikaans: 'Wit Rusland',
    russian: 'Беларусь',
    latvian: 'Baltkrievija',
    polish: '',
    french: '',
    spanish: 'Bielorrusia',
  },
  {
    av: 25021,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(energy + plant)',
    english: 'bioenergy',
    swedish: 'bioenergi',
    norwegian: 'bioenergi',
    finnish: 'bioenergia',
    hungarian: '',
    german: 'Bioenergie',
    dutch: 'bio-energie',
    afrikaans: 'bio-energie',
    russian: 'биоэнергетика',
    latvian: 'bioenerģija',
    polish: '',
    french: '',
    spanish: 'bioenergía',
  },
  {
    av: 25022,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(braid + action indicator)',
    english: 'braid, plait-(to)',
    swedish: 'fläta (verb)',
    norwegian: 'flette (å)',
    finnish: 'letittää, punoa',
    hungarian: '',
    german: 'Zopf binden, flechten (Verb)',
    dutch: 'vlechten',
    afrikaans: 'vleg (om te)',
    russian: 'плести',
    latvian: 'pīt',
    polish: '',
    french: '',
    spanish: 'trenzar',
  },
  {
    av: 25023,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(to mix + 3 + linear thing) 3 can be replaced by an appropriate number.',
    english: 'braid, plait, pigtail(s)',
    swedish: 'fläta (subst.)',
    norwegian: 'flette',
    finnish: 'letti, punos',
    hungarian: '',
    german: 'Zopf, Haarzopf, Flechte',
    dutch: 'vlecht',
    afrikaans: 'vlegsel',
    russian: 'коса (плетение)',
    latvian: 'bize',
    polish: '',
    french: '',
    spanish: 'trenza',
  },
  {
    av: 25024,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + ball + legs and feet: country of football [contr.])',
    english: 'Brazil',
    swedish: 'Brasilien',
    norwegian: 'Brasil',
    finnish: 'Brasilia',
    hungarian: '',
    german: 'Brasilien',
    dutch: 'Brazilië',
    afrikaans: 'Brasilië',
    russian: 'Бразилия',
    latvian: 'Brazīlija',
    polish: '',
    french: '',
    spanish: 'Brasil',
  },
  {
    av: 25025,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(cheering + action indicator)',
    english: 'cheer-(to)',
    swedish: 'hurra, heja på',
    norwegian: 'hurra, heie på',
    finnish: 'hurrata, kannustaa',
    hungarian: '',
    german: 'zurufen, anfeuern, zujubeln, mitfiebern',
    dutch: 'aanmoedigen',
    afrikaans: 'aanmoedig (om te)',
    russian: 'одобрять, подбадривать, апплодировать',
    latvian: 'uzmundrināt, atbalstīt',
    polish: '',
    french: '',
    spanish: 'animar',
  },
  {
    av: 25026,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(support (oral) + intensity)',
    english: 'cheering (the sound)',
    swedish: 'hurra, leve',
    norwegian: 'hurra, heia',
    finnish: 'hurraaminen, kannustaminen',
    hungarian: '',
    german: 'hurra rufen',
    dutch: 'aanmoediging (geluid)',
    afrikaans: 'juigende (die geluid)',
    russian: 'Ура ! Апплодисмент! Молодец!',
    latvian: 'uzmundrināšana, atbalstīšana',
    polish: '',
    french: '',
    spanish: 'hurra (animando)',
  },
  {
    av: 25027,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(leader + cheering)',
    english: 'cheerleader',
    swedish: 'hejarklacksledare',
    norwegian: 'heialeder, cheerleader',
    finnish: 'huutosakin johtaja, cheerleader',
    hungarian: '',
    german: 'Cheerleader',
    dutch: 'chearleader',
    afrikaans: 'sangleier, dirigent',
    russian: 'болельщик',
    latvian: 'karsējmeitenes',
    polish: '',
    french: '',
    spanish: 'líder (grupo de fans)',
  },
  {
    av: 25028,
    group: 'word',
    pos: 'GRAY',
    derivationExplanation: '(say, speak, talk, tell, express-(to) + alcoholic drink + up)',
    english: 'cheers (toast)',
    swedish: 'skål',
    norwegian: 'skål',
    finnish: 'kippis, terveydeksi',
    hungarian: '',
    german: 'Prost!, zum Wohl!',
    dutch: 'gezondheid, proost',
    afrikaans: 'gesondheid',
    russian: 'тост',
    latvian: 'uz veselību!',
    polish: '',
    french: '',
    spanish: 'salud (brindis)',
  },
  {
    av: 25029,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(country + middle, centre; 中国 zhōng guó is the official name of China, which literally means middle or central country)',
    english: 'China',
    swedish: 'Kina',
    norwegian: 'Kina',
    finnish: 'Kiina',
    hungarian: '',
    german: 'China',
    dutch: 'China',
    afrikaans: 'China',
    russian: 'Китай',
    latvian: 'Ķīna',
    polish: '',
    french: '',
    spanish: 'China',
  },
  {
    av: 25030,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(move + see + village: where village represents city [contr.])',
    english: 'city tour',
    swedish: 'stadsrundtur (etc)',
    norwegian: 'byrundtur',
    finnish: 'kaupunkiajelu, kaupunkikierros',
    hungarian: '',
    german: 'Stadtrundfahrt',
    dutch: 'citytrip',
    afrikaans: 'stadstoer',
    russian: 'экскурсия по городу',
    latvian: 'pilsētas apskates ekskursija',
    polish: '',
    french: '',
    spanish: 'tour por la ciudad',
  },
  {
    av: 25031,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalisation + weather)',
    english: 'climate',
    swedish: 'klimat',
    norwegian: 'klima',
    finnish: 'ilmasto',
    hungarian: '',
    german: 'Klima',
    dutch: 'klimaat',
    afrikaans: 'klimaat',
    russian: 'климат',
    latvian: 'klimats',
    polish: '',
    french: '',
    spanish: 'clima',
  },
  {
    av: 25032,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(number + secret)',
    english: 'code, password',
    swedish: 'kod, lösenord',
    norwegian: 'kode, passord',
    finnish: 'koodi, salasana',
    hungarian: '',
    german: 'Kode, Kennzahl, Kennwort',
    dutch: 'code, paswoord',
    afrikaans: 'kode, wagwoord',
    russian: 'код, пароль',
    latvian: 'kods, parole',
    polish: '',
    french: '',
    spanish: 'código, contraseña',
  },
  {
    av: 25033,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + together)',
    english: 'collection, pile, tussock (etc)',
    swedish: 'hög, stapel, trave, samling, tuva, knippa, bukett (etc)',
    norwegian: 'stabel, haug, samling',
    finnish: 'pino, kasa, läjä',
    hungarian: '',
    german: 'Haufen, Stapel, Büschel',
    dutch: 'collectie, verzameling, stapel',
    afrikaans: 'versameling, hoop',
    russian: 'коллекция, стопка, сборник',
    latvian: 'kolekcija, kaudze, krājums',
    polish: '',
    french: '',
    spanish: 'colección, pila (etc)',
  },
  {
    av: 25034,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(theft + leadership)',
    english: 'coup, hijack, takeover',
    swedish: 'kupp, kapning',
    norwegian: 'kapring, kupp',
    finnish: 'kaappaus, kapina',
    hungarian: '',
    german: 'Coup, Putsch, Entführung',
    dutch: 'kaping',
    afrikaans: 'kaping, staatsgreep',
    russian: 'переворот, угон, захват',
    latvian: 'veikls gājiens, nolaupīšana, pārņemšana, iegūšana',
    polish: '',
    french: '',
    spanish: 'golpe, secuestro',
  },
  {
    av: 25035,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(coup + country)',
    english: "coup, coup d'etat",
    swedish: 'statskupp, revolt',
    norwegian: 'statskupp',
    finnish: 'vallankumous, vallankaappaus',
    hungarian: '',
    german: 'Staatsstreich',
    dutch: 'staatsgreep',
    afrikaans: 'staatsgreep',
    russian: 'государственный переворот',
    latvian: 'apvērsums, valsts apvērsums',
    polish: '',
    french: '',
    spanish: 'golpe de estado',
  },
  {
    av: 25036,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + illegal, criminal)',
    english: 'crime',
    swedish: 'brott',
    norwegian: 'lovbrudd',
    finnish: 'rikos',
    hungarian: '',
    german: 'Verbrechen',
    dutch: 'misdaad',
    afrikaans: 'misdaad',
    russian: 'преступление',
    latvian: 'noziegums',
    polish: '',
    french: '',
    spanish: 'crimen',
  },
  {
    av: 25037,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + illegal, criminal: where illegal represents crime [contr.])',
    english: 'criminal (person)',
    swedish: 'brottsling, kriminell person',
    norwegian: 'kriminell person, lovbryter',
    finnish: 'rikollinen, kriminaali',
    hungarian: '',
    german: 'Kriminelle',
    dutch: 'misdadiger, crimineel',
    afrikaans: 'misdadiger, krimineel',
    russian: 'преступник, уголовник',
    latvian: 'noziedznieks',
    polish: '',
    french: '',
    spanish: 'criminal',
  },
  {
    av: 25038,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + illegal, criminal)',
    english: 'criminality, crime',
    swedish: 'brottslighet, kriminalitet',
    norwegian: 'kriminalitet, krim',
    finnish: 'rikollisuus',
    hungarian: '',
    german: 'Kriminalität, Verbrechertum',
    dutch: 'criminaliteit, misdaad',
    afrikaans: 'misdadigheid, misdaad',
    russian: 'криминал, преступность',
    latvian: 'noziedzība, noziegums',
    polish: '',
    french: '',
    spanish: 'criminalidad',
  },
  {
    av: 25039,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wish + knowledge)',
    english: 'curiosity, curiousness, inquisitiveness, wonder',
    swedish: 'frågvishet, vetgirighet',
    norwegian: 'nygjerrighet, vitebegjær',
    finnish: 'uteliaisuus, tiedonhakuisuus',
    hungarian: '',
    german: 'Neugier, Wissbegier',
    dutch: 'nieuwsgierigheid',
    afrikaans: 'nuuskierigheid',
    russian: 'любопытсвто',
    latvian: 'izbrīns, ziņkārība, ziņkārīgums, zinātkāre',
    polish: '',
    french: '',
    spanish: 'curiosidad',
  },
  {
    av: 25040,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(curiosity + description indicator)',
    english: 'curious, inquisitive',
    swedish: 'nyfiken (positiv), frågvis, vetgirig',
    norwegian: 'nysgjerrig, vitebegjærlig',
    finnish: 'utelias, tiedonhakuinen',
    hungarian: '',
    german: 'neugierig, wissbegierig',
    dutch: 'nieuwsgierig (bijv.nw)',
    afrikaans: 'nuuskierige',
    russian: 'любопытный',
    latvian: 'ziņkārīgs, izbrīnīts, ieinteresēts',
    polish: '',
    french: '',
    spanish: 'curioso',
  },
  {
    av: 25041,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure + imprint, depression: where imprint, depression represents soft [contr.])',
    english: 'cushion',
    swedish: 'kudde, dyna',
    norwegian: 'pute, dyne',
    finnish: 'tyyny',
    hungarian: '',
    german: 'Kissen, Sofakissen',
    dutch: 'kussen (zelfst.nw)',
    afrikaans: 'kussing',
    russian: 'подушка',
    latvian: 'spilvens',
    polish: '',
    french: '',
    spanish: 'almohadilla',
  },
  {
    av: 25042,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cushion + seat)',
    english: 'cushion (seat)',
    swedish: 'sittdyna',
    norwegian: 'sittepute',
    finnish: 'istuintyyny',
    hungarian: '',
    german: 'Sitzkissen',
    dutch: 'zitkussen',
    afrikaans: 'kussing (vir `n sitplek)',
    russian: 'подушка для сиденья',
    latvian: 'spilvens (krēsla)',
    polish: '',
    french: '',
    spanish: 'almohadilla (asiento)',
  },
  {
    av: 25043,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + beer)',
    english: 'Czech Republic',
    swedish: 'Tjeckien',
    norwegian: 'Tsjekkia',
    finnish: 'Tsekin tasavalta, Tsekki',
    hungarian: '',
    german: 'Tschechien',
    dutch: 'Tsjechië ',
    afrikaans: 'Tsjeggiese Republiek',
    russian: 'Чешская республика',
    latvian: 'Čehijas Republika',
    polish: '',
    french: '',
    spanish: 'República Checa',
  },
  {
    av: 25044,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(out of, exit (forward) + air + action indicator) Air can be replaced by an appropriate specifier.',
    english: 'deflate, let out air-(to)',
    swedish: 'läcka (luft), släppa ut luft',
    norwegian: 'lekke luft, slippe ut luft',
    finnish: 'tyhjentyä ilmasta',
    hungarian: '',
    german: 'entleeren, abblasen',
    dutch: 'ontluchten, lucht uitlaten',
    afrikaans: 'afblaas (om te)',
    russian: 'спускать, выпускать вохздух',
    latvian: 'izpūst, izlaist gaisu',
    polish: '',
    french: '',
    spanish: 'desinflar',
  },
  {
    av: 25045,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + wakefulness, alertness + information: where wakefulness represents search-(to) [contr.])',
    english: 'detective, investigator',
    swedish: 'detektiv',
    norwegian: 'detektiv',
    finnish: 'etsivä, salapoliisi',
    hungarian: '',
    german: 'Detektiv, Ermittler, Ermittlerin',
    dutch: 'detective',
    afrikaans: 'speurder, ondersoeker',
    russian: 'детектив, сыщик',
    latvian: 'izmeklētājs, detektīvs',
    polish: '',
    french: '',
    spanish: 'detective, investigador',
  },
  {
    av: 25046,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(muscle + middle)',
    english: 'diaphragm, midriff',
    swedish: 'diafragma, mellangärde',
    norwegian: 'diafragma, mellomgolvet',
    finnish: 'pallea',
    hungarian: '',
    german: 'Diaphragma, Zwerchfell',
    dutch: 'middenrif, diafragma',
    afrikaans: 'diafragma, middellyf',
    russian: 'диафрагма',
    latvian: 'diafragma',
    polish: '',
    french: '',
    spanish: 'diafragma',
  },
  {
    av: 25047,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical product + bath, washing + medical)',
    english: 'disinfectant, antiseptic',
    swedish: 'desinfektionsmedel, tvättsprit (etc)',
    norwegian: 'desinfeksjonsmiddel',
    finnish: 'antiseptinen aine, desifiointiaine',
    hungarian: '',
    german: 'Antiseptikum',
    dutch: 'ontsmettingszeep, desinfecteermiddel, desinfectans',
    afrikaans: 'ontsmettingsmiddel, disinfektant, antiseptiese',
    russian: 'дезинфицирующее средство',
    latvian: 'dezinfekcijas līdzeklis, antiseptiķis',
    polish: '',
    french: '',
    spanish: 'desinfectante, antiséptico',
  },
  {
    av: 25048,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + rotation + through)',
    english: 'drill',
    swedish: 'borr',
    norwegian: 'bor, drill',
    finnish: 'pora',
    hungarian: '',
    german: 'Handbohrmaschine',
    dutch: 'boor (kop)',
    afrikaans: 'boor',
    russian: 'дрель',
    latvian: 'urbis',
    polish: '',
    french: '',
    spanish: 'perforadora',
  },
  {
    av: 25049,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + rotation + gas)',
    english: 'drilling rig (gas)',
    swedish: 'borrigg (för gas)',
    norwegian: 'borerigg (for gass)',
    finnish: 'kaasunporaustorni',
    hungarian: '',
    german: 'Bohrturm (nach Gas)',
    dutch: 'boormachine (gas)',
    afrikaans: 'boormasjien (gas)',
    russian: 'буровая установка (газ)',
    latvian: 'urbšanas ierīce (gāzei)',
    polish: '',
    french: '',
    spanish: 'plataforma de perforación (gas)',
  },
  {
    av: 25050,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + rotation + oil)',
    english: 'drilling rig (oil)',
    swedish: 'borrigg (för olja)',
    norwegian: 'borerigg (for olje)',
    finnish: 'öljynporaustorni',
    hungarian: '',
    german: 'Bohrturm (nach Öl)',
    dutch: 'boormachine (olie)',
    afrikaans: 'boormasjien (olie)',
    russian: 'буровая установка (нефть)',
    latvian: 'urbjtornis (naftas)',
    polish: '',
    french: '',
    spanish: 'plataforma de perforación (petróleo)',
  },
  {
    av: 25051,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + rotation + water)',
    english: 'drilling rig (water)',
    swedish: 'borrigg (för vatten)',
    norwegian: 'borerigg (for vann)',
    finnish: 'vedenporaustorni',
    hungarian: '',
    german: 'Bohrturm (nach Wasser)',
    dutch: 'boormachine (water)',
    afrikaans: 'boormasjien (water)',
    russian: 'буровая установка (вода)',
    latvian: 'urbjtornis (ūdens)',
    polish: '',
    french: '',
    spanish: 'plataforma de perforación (agua)',
  },
  {
    av: 25052,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(person + back and forth + person)',
    english: 'each other, one another',
    swedish: 'varandra',
    norwegian: 'hverandre',
    finnish: 'toisiaan',
    hungarian: '',
    german: 'einander',
    dutch: 'ieder',
    afrikaans: 'ander een, elke een',
    russian: 'друг с другом',
    latvian: 'viens otrs, katrs nākošais, viens aiz otra',
    polish: '',
    french: '',
    spanish: 'mutuamente, el uno al otro',
  },
  {
    av: 25053,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(encouragement + action indicator)',
    english: 'encourage-(to)',
    swedish: 'uppmuntra',
    norwegian: 'oppmuntre',
    finnish: 'yllyttää, rohkaista',
    hungarian: '',
    german: 'ermutigen, bestärken, unterstützen, fördern, helfen',
    dutch: 'moed geven, bemoedigen',
    afrikaans: 'aanmoedig (om te)',
    russian: 'подбадривать',
    latvian: 'iedrošināt',
    polish: '',
    french: '',
    spanish: 'alentar',
  },
  {
    av: 25054,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to give + courage)',
    english: 'encouragement',
    swedish: 'uppmuntran',
    norwegian: 'oppmuntring',
    finnish: 'yllytys, rohkaiseminen',
    hungarian: '',
    german: 'Ermutigung, Aufmunterung',
    dutch: 'bemoediging, aanmoediging',
    afrikaans: 'aanmoediging',
    russian: 'подбадривание',
    latvian: 'iedrošinājums',
    polish: '',
    french: '',
    spanish: 'aliento',
  },
  {
    av: 25055,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(out of, exit (forward) + intensity)',
    english: 'escape',
    swedish: 'flykt',
    norwegian: 'flukt',
    finnish: 'pako, pakeneminen',
    hungarian: '',
    german: 'Flucht, Entkommen',
    dutch: 'ontsnapping, vlucht (ontsnapping)',
    afrikaans: 'ontsnapping',
    russian: 'побег, бегство',
    latvian: 'bēgšana, izbēgšana',
    polish: '',
    french: '',
    spanish: 'escape',
  },
  {
    av: 25056,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(escape + action indicator)',
    english: 'escape-(to)',
    swedish: 'fly ',
    norwegian: 'flykte',
    finnish: 'paeta',
    hungarian: '',
    german: 'ausbrechen, fliehen, entfliehen',
    dutch: 'ontsnappen',
    afrikaans: 'ontsnap (om te)',
    russian: 'бежать, сбегать, убегать',
    latvian: 'aizbēgt, izbēgt',
    polish: '',
    french: '',
    spanish: 'escapar',
  },
  {
    av: 25057,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to search + secret + information)',
    english: 'espionage, spying',
    swedish: 'spionage',
    norwegian: 'spionasje',
    finnish: 'vakoilu, vakoileminen',
    hungarian: '',
    german: 'Spionage, Bespitzelung',
    dutch: 'spionage',
    afrikaans: 'spioenasie, spioenerend',
    russian: 'шпионаж',
    latvian: 'spiegošana',
    polish: '',
    french: '',
    spanish: 'espionaje',
  },
  {
    av: 25058,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(exploration + action indicator)',
    english: 'explore-(to)',
    swedish: 'utforska, upptäcka',
    norwegian: 'utforske, oppdage',
    finnish: 'tehdä tutkimusmatka',
    hungarian: '',
    german: 'untersuchen, erforschen',
    dutch: 'verkennen, ontdekken',
    afrikaans: 'verken (om te)',
    russian: 'исследовать',
    latvian: 'izpētīt',
    polish: '',
    french: '',
    spanish: 'explorar',
  },
  {
    av: 25059,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + explore)',
    english: 'explorer, enquirer',
    swedish: 'upptäcktsresande (etc)',
    norwegian: 'oppdager, utforsker ',
    finnish: 'tutkimusmatkailija',
    hungarian: '',
    german: 'Erforscher, Erforscherin',
    dutch: 'verkenner, ontdekker',
    afrikaans: 'ontdekkingsreisiger, verkenner',
    russian: 'исследователь',
    latvian: 'pētnieks',
    polish: '',
    french: '',
    spanish: 'explorador',
  },
  {
    av: 25060,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gas + buttocks, bottom, bum, rear, ass)',
    english: 'fart, wind',
    swedish: 'fis, fjärt, prutt',
    norwegian: 'fis, fjert, promp, tarmgass',
    finnish: 'pieru, ilmavaivat',
    hungarian: '',
    german: 'Furz',
    dutch: 'windje (gas darmen), scheet',
    afrikaans: 'wind, poep',
    russian: 'газоиспускание, метеоризм',
    latvian: 'laist gāzes, gāzes, pirdiens, pirst',
    polish: '',
    french: '',
    spanish: 'pedo, flatulencia',
  },
  {
    av: 25061,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to cause + death + description indicator)',
    english: 'fatal, lethal',
    swedish: 'dödande',
    norwegian: 'dødelig, drepende',
    finnish: 'kuolettava, tappava',
    hungarian: '',
    german: 'tödlich',
    dutch: 'dodelijk, fataal',
    afrikaans: 'noodlottige, fataal, dodelike',
    russian: 'смертельный, летальный',
    latvian: 'liktenīgs, fatāls, nāvīgs, letāls',
    polish: '',
    french: '',
    spanish: 'fatal, letal',
  },
  {
    av: 25062,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fuel + plant + passed time)',
    english: 'fossil fuel, coal (etc)',
    swedish: 'fossilt bränsle, kol (etc)',
    norwegian: 'fossil brensel, kull',
    finnish: 'fossiilinen polttoaine, hiili',
    hungarian: '',
    german: 'fossiler Brennstoff, Kohle',
    dutch: 'fossiele brandstof, kolen (brandstof)',
    afrikaans: 'fossielbrandstof, steenkool',
    russian: 'ископаемое топливо, уголь',
    latvian: 'derīgie izrakteņi, nafta, ogles',
    polish: '',
    french: '',
    spanish: 'combustibles fósiles, carbón',
  },
  {
    av: 25063,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + champagne)',
    english: 'France',
    swedish: 'Frankrike',
    norwegian: 'Frankrike',
    finnish: 'Ranska',
    hungarian: '',
    german: 'Frankreich',
    dutch: 'Frankrijk',
    afrikaans: 'Frankryk',
    russian: 'Франция',
    latvian: 'Francija',
    polish: '',
    french: '',
    spanish: 'Francia',
  },
  {
    av: 25064,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 5 + five (index number): small 5 of ISO standard) SYMBOL SYNONYM (replacing 14400)',
    english: 'Friday (day5)',
    swedish: 'fredag (dag 5)',
    norwegian: 'fredag (dag 5)',
    finnish: 'perjantai (päivä viisi)',
    hungarian: '',
    german: 'Freitag (Tag 5)',
    dutch: 'vrijdag (dag 5)',
    afrikaans: 'Vrydag (dag 5)',
    russian: 'пятница (день 5)',
    latvian: 'piektdiena (5.diena)',
    polish: '',
    french: '',
    spanish: 'Viernes (día 5)',
  },
  {
    av: 25065,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 6 + five (index number): small 5 of ISO standard) SYMBOL SYNONYM (replacing 14400)',
    english: 'Friday (day6)',
    swedish: 'fredag (dag 6)',
    norwegian: 'fredag (dag 6)',
    finnish: 'perjantai (päivä kuusi)',
    hungarian: '',
    german: 'Freitag (Tag 6)',
    dutch: 'vrijdag (dag 6)',
    afrikaans: 'Vrydag (dag 6)',
    russian: 'пятница (день 6)',
    latvian: 'piektdiena (6.diena)',
    polish: '',
    french: '',
    spanish: 'Viernes (día 6)',
  },
  {
    av: 25066,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 7 + five (index number): small 5 of ISO standard) SYMBOL SYNONYM (replacing 14400)',
    english: 'Friday (day7)',
    swedish: 'fredag (dag 7)',
    norwegian: 'fredag (dag 7)',
    finnish: 'perjantai (päivä seitsemän)',
    hungarian: '',
    german: 'Freitag (Tag 7)',
    dutch: 'vrijdag (dag 7)',
    afrikaans: 'Vrydag (dag 7)',
    russian: 'пятница (день 7)',
    latvian: 'piektdiena (7.diena)',
    polish: '',
    french: '',
    spanish: 'Viernes (día 7)',
  },
  {
    av: 25067,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fuel + gas)',
    english: 'gas (fuel)',
    swedish: 'gas (bränsle)',
    norwegian: 'gass (brensel)',
    finnish: 'polttoaine',
    hungarian: '',
    german: 'Heizgas',
    dutch: 'gas (brandstof)',
    afrikaans: 'gas (brandstof)',
    russian: 'газ (топливо)',
    latvian: 'gāze (kurināmais)',
    polish: '',
    french: '',
    spanish: 'combustible',
  },
  {
    av: 25068,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fuel + gas + plant)',
    english: 'gas (fuel from biomass)',
    swedish: 'biogas',
    norwegian: 'biogass',
    finnish: 'biopolttoaine',
    hungarian: '',
    german: 'Biogas',
    dutch: 'gas (brandstof van biomassa)',
    afrikaans: 'gas (brandstof van biomassa)',
    russian: 'биогаз',
    latvian: 'gāze (biomasas degviela)',
    polish: '',
    french: '',
    spanish: 'biogas',
  },
  {
    av: 25069,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(energy + ground)',
    english: 'geothermal energy',
    swedish: 'geotermisk energi',
    norwegian: 'geotermisk energi',
    finnish: 'geoterminen energia',
    hungarian: '',
    german: 'Erdwärmeenergie',
    dutch: 'geothermische energie',
    afrikaans: 'geotermiese energie',
    russian: 'геотермальная энегрия',
    latvian: 'ģeotermālā enerģija',
    polish: '',
    french: '',
    spanish: 'energía geotérmica',
  },
  {
    av: 25071,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + five (digit), 5 + ring: The Olympics [contr.])',
    english: 'Greece',
    swedish: 'Grekland',
    norwegian: 'Hellas',
    finnish: 'Kreikka',
    hungarian: '',
    german: 'Griechenland',
    dutch: 'Griekenland',
    afrikaans: 'Griekeland',
    russian: 'Греция',
    latvian: 'Grieķija',
    polish: '',
    french: '',
    spanish: 'Grecia',
  },
  {
    av: 25072,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + usually)',
    english: 'habit, custom',
    swedish: 'vana, sed',
    norwegian: 'vane, sed',
    finnish: 'tapa, käytäntö',
    hungarian: '',
    german: 'Gewohnheit, Brauch, Sitte',
    dutch: 'gewoonte',
    afrikaans: 'gewoonte, manier',
    russian: 'привычка, обычай',
    latvian: 'paradums, tradīcija',
    polish: '',
    french: '',
    spanish: 'hábito, costumbre',
  },
  {
    av: 25073,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(group of + imaginary person + electricity: Literary figures in the Moomin books by Tove Jansson - tall, thin, ghost-like creatures that become electrical during thunderstorms)',
    english: 'Hattifatteners',
    swedish: 'Hattifnattar',
    norwegian: 'Hattifnatt',
    finnish: 'Hattivatit',
    hungarian: '',
    german: 'Hatifnatten',
    dutch: 'Hattifnattar (fantasiefiguur)',
    afrikaans: 'Hattifatteners',
    russian: 'Хатифнатты',
    latvian: 'Hatifnaters',
    polish: '',
    french: '',
    spanish: 'Hattifatteners',
  },
  {
    av: 25074,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(imaginary person + 1 + interest: Literary figures in the Moomin books by Tove Jansson - occupied with one specific interest)',
    english: 'Hemulen',
    swedish: 'Hemulen',
    norwegian: 'Hemulen',
    finnish: 'Hemuli',
    hungarian: '',
    german: 'Hemule',
    dutch: 'Hemulen (fantasiefiguur)',
    afrikaans: 'Hemulen',
    russian: 'Хемули',
    latvian: 'Hemulens',
    polish: '',
    french: '',
    spanish: 'Hemulen',
  },
  {
    av: 25075,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sound + diaphragm) SYMBOL SYNONYM',
    english: 'hiccup(s) (1)',
    swedish: 'hicka (1)',
    norwegian: 'stønn',
    finnish: 'hikka, nikotus',
    hungarian: '',
    german: 'Schluckauf (1)',
    dutch: 'hik (zelfst.nw) (1)',
    afrikaans: 'hik (1)',
    russian: 'икота (1)',
    latvian: 'žagas (1)',
    polish: '',
    french: '',
    spanish: 'hipo (1)',
  },
  {
    av: 25076,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sound + out of body (upward) + repetition) SYMBOL SYNONYM',
    english: 'hiccup(s) (2)',
    swedish: 'hicka (2)',
    norwegian: 'hikk',
    finnish: 'hikka, nikotus',
    hungarian: '',
    german: 'Schluckauf (2)',
    dutch: 'hik (zelfst.nw) (2)',
    afrikaans: 'hik (2)',
    russian: 'икота (2)',
    latvian: 'žagas (2)',
    polish: '',
    french: '',
    spanish: 'hipo',
  },
  {
    av: 25077,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hiding place + action indicator)',
    english: 'hide, conceal (secret)-(to)',
    swedish: 'gömma ',
    norwegian: 'gjemme',
    finnish: 'piiloutua, mennä piiloon',
    hungarian: '',
    german: 'verstecken',
    dutch: 'verstoppen, verzwijgen',
    afrikaans: 'vel, verberg, weg steek (om te)',
    russian: 'прятаться, утаиваться',
    latvian: 'noslēpt, noklusēt (noslēpumu)',
    polish: '',
    french: '',
    spanish: 'ocultar (secreto), esconder',
  },
  {
    av: 25078,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play (in combinations) + hiding place)',
    english: 'hide and seek',
    swedish: 'kurragömma',
    norwegian: 'gjemsel',
    finnish: 'piiloleikki',
    hungarian: '',
    german: 'Verstecken (Spiel), Versteckspiel ',
    dutch: 'verstoppertje (spel)',
    afrikaans: 'wegkruipertjie',
    russian: 'игра в прятки',
    latvian: 'paslēpes',
    polish: '',
    french: '',
    spanish: 'a las escondidas',
  },
  {
    av: 25079,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + secret)',
    english: 'hiding place, cache',
    swedish: 'gömställe',
    norwegian: 'gjemmested',
    finnish: 'piilopaikka',
    hungarian: '',
    german: 'Versteck',
    dutch: 'verstopplaats',
    afrikaans: 'wegkruip plek',
    russian: 'укрытие, убежище',
    latvian: 'slēptuve, slēpnis',
    polish: '',
    french: '',
    spanish: 'escondite',
  },
  {
    av: 25081,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(coup, hijack, takeover + action indicator)',
    english: 'hijack, make a coup-(to)',
    swedish: 'kapa, kuppa',
    norwegian: 'kapre, kuppe',
    finnish: 'kaapata, kapinoida',
    hungarian: '',
    german: 'entführen, (sich an die Macht) putschen',
    dutch: 'kapen',
    afrikaans: 'kaap (om te)',
    russian: 'угонять, захватывать',
    latvian: 'nolaupīt, aizdzīt',
    polish: '',
    french: '',
    spanish: 'secuestrar, hacer un golpe de estado',
  },
  {
    av: 25082,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + coup, hijack, takeover)',
    english: 'hijacker, coup maker',
    swedish: 'kapare, kuppmakare',
    norwegian: 'kaprer',
    finnish: 'kaappaaja, kaappari, kapinoija',
    hungarian: '',
    german: 'Putschist',
    dutch: 'kaper',
    afrikaans: 'kaper',
    russian: 'угонщик, захватчик',
    latvian: 'nolaupītājs (-a), aizdzinējs (-a)',
    polish: '',
    french: '',
    spanish: 'secuestrador',
  },
  {
    av: 25083,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(goods, contents + action indicator)',
    english: 'hold, contain (2)-(to)',
    swedish: 'innehålla, rymma (2)',
    norwegian: 'inneholde, romme (2)',
    finnish: 'pitää sisällään, sisältää',
    hungarian: '',
    german: 'halten, enthalten (2)',
    dutch: 'houden, bevatten, vasthouden (2)',
    afrikaans: 'hou, bevat (2) (om te)',
    russian: 'содержать, размещать (2)',
    latvian: 'turēt, saturēt (2)',
    polish: '',
    french: '',
    spanish: 'contiene, contener (2)',
  },
  {
    av: 25084,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + oppression, captivity, slavery + for (in exchange for)) SYMBOL SYNONYM',
    english: 'hostage (1)',
    swedish: 'gisslan (1)',
    norwegian: 'gissel (1)',
    finnish: 'panttivanki',
    hungarian: '',
    german: 'Geisel (1)',
    dutch: 'gijzelaar (1)',
    afrikaans: 'gyselaar (1)',
    russian: 'заложник (1)',
    latvian: 'kīlnieks (1)',
    polish: '',
    french: '',
    spanish: 'rehén (1)',
  },
  {
    av: 25085,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + oppression, captivity, slavery + for (in exchange for) + money) Money can be replaced by an appropriate specifier. SYMBOL SYNONYM',
    english: 'hostage (2)',
    swedish: 'gisslan (2)',
    norwegian: 'gissel (2)',
    finnish: 'panttivanki',
    hungarian: '',
    german: 'Geisel (2)',
    dutch: 'gijzelaar (2)',
    afrikaans: 'gyselaar (2)',
    russian: 'заложник (2)',
    latvian: 'ķīlnieks (2)',
    polish: '',
    french: '',
    spanish: 'rehén (2)',
  },
  {
    av: 25086,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + hunt, hunting)',
    english: 'hunter',
    swedish: 'jägare',
    norwegian: 'jeger',
    finnish: 'metsästäjä',
    hungarian: '',
    german: 'Jäger',
    dutch: 'jager',
    afrikaans: 'jagter',
    russian: 'охотник',
    latvian: 'mednieks',
    polish: '',
    french: '',
    spanish: 'cazador',
  },
  {
    av: 25087,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(energy + water)',
    english: 'hydropower, hydro energy',
    swedish: 'vattenkraft',
    norwegian: 'vannkraft',
    finnish: 'vesivoima',
    hungarian: '',
    german: 'Wasserenergie',
    dutch: 'waterkracht, waterenergie',
    afrikaans: 'hidrokrag, hidro-energie',
    russian: 'гидроэнергетика',
    latvian: 'hidroelektronenerģija',
    polish: '',
    french: '',
    spanish: 'energía hidroeléctrica',
  },
  {
    av: 25088,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(card + name + number)',
    english: 'identity card',
    swedish: 'legitimation',
    norwegian: 'legitimasjon, legitimasjonskort',
    finnish: 'henkilöllisyystodistus',
    hungarian: '',
    german: 'Ausweis',
    dutch: 'identiteitskaart, paspoort',
    afrikaans: 'identiteits kaart',
    russian: 'идентификационная карта, удостоверение личности',
    latvian: 'personas apliecība',
    polish: '',
    french: '',
    spanish: 'carnet de identidad',
  },
  {
    av: 25089,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(page + content)',
    english: 'index, list of contents (in a book etc)',
    swedish: 'innehållsförteckning, index',
    norwegian: 'innholdsfortegnelse, index',
    finnish: 'sisällysluettelo',
    hungarian: '',
    german: 'Index, Verzeichnis, Register',
    dutch: 'inhoudstafel, index (boek)',
    afrikaans: 'indeks, inhoudsopgawe',
    russian: 'оглавление, предметный указатель',
    latvian: 'saraksts, satura rādītājs, saturs',
    polish: '',
    french: '',
    spanish: 'índice, lista de contenidos (en un libro etc)',
  },
  {
    av: 25090,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + flavouring)',
    english: 'India',
    swedish: 'Indien',
    norwegian: 'India',
    finnish: 'Intia',
    hungarian: '',
    german: 'Indien',
    dutch: 'India',
    afrikaans: 'Indië',
    russian: 'Индия',
    latvian: 'Indija',
    polish: '',
    french: '',
    spanish: 'India',
  },
  {
    av: 25091,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(entrance + air + action indicator) Air can be replaced by an appropriate specifier.',
    english: 'inflate-(to)',
    swedish: 'blåsa upp, pumpa upp',
    norwegian: 'blåse opp, pumpe opp',
    finnish: 'täyttää ilmalla',
    hungarian: '',
    german: 'aufblasen',
    dutch: 'opblazen',
    afrikaans: 'opblaas (om te)',
    russian: 'надувать, нагнетать воздух',
    latvian: 'piepūst',
    polish: '',
    french: '',
    spanish: 'inflar',
  },
  {
    av: 25093,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(say, speak, talk, tell, express-(to) + fidelity, loyalty, solidarity)',
    english: 'invitation (general spoken)',
    swedish: 'inbjudan (muntlig)',
    norwegian: 'innbydelse, invitasjon (muntlig)',
    finnish: 'suullinen kutsu',
    hungarian: '',
    german: 'Einladung (allgemein gesprochen)',
    dutch: 'uitnodiging (mondeling algemeen)',
    afrikaans: 'uitnodiging (algemeen gesproke)',
    russian: 'приглашение (устное)',
    latvian: 'ielūgums (mutisks)',
    polish: '',
    french: '',
    spanish: 'invitación (verbal)',
  },
  {
    av: 25094,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + fidelity, loyalty, solidarity)',
    english: 'invitation (general written)',
    swedish: 'inbjudan (skriftlig)',
    norwegian: 'innbydelse, invitasjon (skriftlig)',
    finnish: 'kirjallinen kutsu',
    hungarian: '',
    german: 'Einladung (allgemein geschrieben)',
    dutch: 'uitnodiging (schriftelijk algemeen)',
    afrikaans: 'uitnodiging (algemeen geskrewe)',
    russian: 'приглашение (письменное)',
    latvian: 'ielūgums (rakstisks)',
    polish: '',
    french: '',
    spanish: 'invitación (escrito)',
  },
  {
    av: 25095,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(say, speak, talk, tell, express-(to) + welcome)',
    english: 'invitation (spoken)',
    swedish: 'välkomsthälsning (muntlig)',
    norwegian: 'velkomsthilsen (muntlig)',
    finnish: 'suullinen kutsu kylään',
    hungarian: '',
    german: 'Einladung (mündlich)',
    dutch: 'uitnodiging (mondeling)',
    afrikaans: 'uitnodiging (gesproke)',
    russian: 'приглашение (устное)',
    latvian: 'ielūgšana (mutiska)',
    polish: '',
    french: '',
    spanish: 'invitación (oral)',
  },
  {
    av: 25096,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + welcome)',
    english: 'invitation (written)',
    swedish: 'välkomsthälsning (skriftlig)',
    norwegian: 'velkomsthilsen (skriftlig)',
    finnish: 'kirjallinen kutsu kylään',
    hungarian: '',
    german: 'Einladung (geschrieben)',
    dutch: 'uitnodiging (schriftelijk)',
    afrikaans: 'uitnodiging (geskrewe)',
    russian: 'приглашение (письменное)',
    latvian: 'ielūgšana (rakstiska)',
    polish: '',
    french: '',
    spanish: 'invitación (escrita)',
  },
  {
    av: 25097,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(country + garden + stairs: refers to the Hanging Gardens of Babylon – and of queen Semiramis)',
    english: 'Iraq',
    swedish: 'Irak',
    norwegian: 'Irak',
    finnish: 'Irak',
    hungarian: '',
    german: 'Irak',
    dutch: 'Irak',
    afrikaans: 'Irak',
    russian: 'Ирак',
    latvian: 'Iraka',
    polish: '',
    french: '',
    spanish: 'Irak',
  },
  {
    av: 25098,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + opera)',
    english: 'Italy',
    swedish: 'Italien',
    norwegian: 'Italia',
    finnish: 'Italia',
    hungarian: '',
    german: 'Italien',
    dutch: 'Italië',
    afrikaans: 'Italië',
    russian: 'Италия',
    latvian: 'Itālija',
    polish: '',
    french: '',
    spanish: 'Italia',
  },
  {
    av: 25099,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + sunrise)',
    english: 'Japan',
    swedish: 'Japan',
    norwegian: 'Japan',
    finnish: 'Japani',
    hungarian: '',
    german: 'Japan',
    dutch: 'Japan',
    afrikaans: 'Japan',
    russian: 'Япония',
    latvian: 'Japāna',
    polish: '',
    french: '',
    spanish: 'Japón',
  },
  {
    av: 25100,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(theft + person + action indicator)',
    english: 'kidnap-(to)',
    swedish: 'kidnappa',
    norwegian: 'kidnappe',
    finnish: 'kidnapata',
    hungarian: '',
    german: 'kidnappen, entführen',
    dutch: 'kidnappen',
    afrikaans: 'ontvoer (om te)',
    russian: 'похищать детей',
    latvian: 'bērna nolaupīšana',
    polish: '',
    french: '',
    spanish: 'secuestrar',
  },
  {
    av: 25101,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + kidnap-(to))',
    english: 'kidnapper',
    swedish: 'kidnappare',
    norwegian: 'kidnapper',
    finnish: 'kidnappaaja',
    hungarian: '',
    german: 'Kidnapper, Entführer, Entführerin',
    dutch: 'kidnapper',
    afrikaans: 'ontvoerder',
    russian: 'похититель детей',
    latvian: 'bērna nolaupītājs, -a',
    polish: '',
    french: '',
    spanish: 'secuestrador',
  },
  {
    av: 25103,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + manslaughter)',
    english: 'killer, murderer',
    swedish: 'dråpare, mördare',
    norwegian: 'drapsperson',
    finnish: 'tappaja',
    hungarian: '',
    german: 'Mörder, Killer',
    dutch: 'moordenaar',
    afrikaans: 'moordenaar',
    russian: 'киллер, убийца',
    latvian: 'slepkava',
    polish: '',
    french: '',
    spanish: 'asesino',
  },
  {
    av: 25104,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cause + death)',
    english: 'killing, murder, slaughter',
    swedish: 'dråp, mord',
    norwegian: 'drap, mord',
    finnish: 'tappaminen, teurastus',
    hungarian: '',
    german: 'Tötung, Mord',
    dutch: 'moord, doding',
    afrikaans: 'moord, slagting, vermoor',
    russian: 'убийство',
    latvian: 'nogalināšana, noslepkavošana, slepkavošana',
    polish: '',
    french: '',
    spanish: 'asesinato',
  },
  {
    av: 25105,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(knock + action indicator)',
    english: 'knock, tap-(to)',
    swedish: 'knacka',
    norwegian: 'banke, knakke',
    finnish: 'koputusääni',
    hungarian: '',
    german: 'klopfen (an die Tür)',
    dutch: 'kloppen',
    afrikaans: 'klop (om te)',
    russian: 'стучать',
    latvian: 'klauvēt',
    polish: '',
    french: '',
    spanish: 'golpear',
  },
  {
    av: 25106,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(noise (loud) + short)',
    english: 'knock, tap (sound)',
    swedish: 'knackning (ljud)',
    norwegian: 'banking (lyd)',
    finnish: 'koputtaa',
    hungarian: '',
    german: 'anklopfen, klopfen (Laut)',
    dutch: 'klop, tik',
    afrikaans: 'klop (geluid)',
    russian: 'стук (звук)',
    latvian: 'klauvējiens',
    polish: '',
    french: '',
    spanish: 'golpe (sonido, ruido)',
  },
  {
    av: 25107,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hand + intensity + sound)',
    english: 'knocking',
    swedish: 'knackning ',
    norwegian: 'banking, knakking',
    finnish: 'koputtaminen, koputus',
    hungarian: '',
    german: 'Klopfen, Klopflaut',
    dutch: 'kloppend ',
    afrikaans: 'klop',
    russian: 'стук (действие)',
    latvian: 'klauvēšana',
    polish: '',
    french: '',
    spanish: 'golpe',
  },
  {
    av: 25108,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(landing (rocket) + action indicator)',
    english: 'land (rocket)-(to)',
    swedish: 'landa (rymdraket)',
    norwegian: 'lande (romrakett)',
    finnish: 'laskeutua (raketti)',
    hungarian: '',
    german: '(Rakete) landen',
    dutch: 'landen van een raket',
    afrikaans: 'land vuurpyl (om te)',
    russian: 'приземляться (ракета)',
    latvian: 'piezemēties, nolaisties',
    polish: '',
    french: '',
    spanish: 'aterrizar',
  },
  {
    av: 25109,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rocket + downward and forward)',
    english: 'landing (rocket)',
    swedish: 'landning (rymdraket)',
    norwegian: 'landing (romrakett)',
    finnish: 'laskeutuminen (raketti)',
    hungarian: '',
    german: 'Landung (Rakete)',
    dutch: 'landing van een raket ',
    afrikaans: 'landing vuurpyl',
    russian: 'приземление (ракета)',
    latvian: 'piezemēšanās, nolaišanās',
    polish: '',
    french: '',
    spanish: 'aterrizaje',
  },
  {
    av: 25110,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(imaginary person + girl + against, opposed to: Literary figure in the Moomin books by Tove Jansson - she is a small determined fiercely independent Mymble. Little My is brash, aggressive, mischievous and disrespectful.)',
    english: 'Little My',
    swedish: 'Lilla My',
    norwegian: 'Lille My',
    finnish: 'Pikku Myy',
    hungarian: '',
    german: 'Kleine My',
    dutch: 'Little My (fantasiefiguur)',
    afrikaans: 'Little My',
    russian: 'Маленькая Мю',
    latvian: 'Mans mazais',
    polish: '',
    french: '',
    spanish: 'Pequeña My',
  },
  {
    av: 25111,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(much/many + together + container)',
    english: 'load',
    swedish: 'last, lass, packning',
    norwegian: 'last, lass',
    finnish: 'kuorma',
    hungarian: '',
    german: 'Fracht, Ladung',
    dutch: 'last, lading',
    afrikaans: 'vrag',
    russian: 'погрузка, загрузка',
    latvian: 'iekraut, krava',
    polish: '',
    french: '',
    spanish: 'carga',
  },
  {
    av: 25112,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(speech (event) + action indicator)',
    english: 'make a speech-(to)',
    swedish: 'hålla tal',
    norwegian: 'tale, holde tale',
    finnish: 'pitää puhe',
    hungarian: '',
    german: 'eine Rede halten',
    dutch: 'speech maken',
    afrikaans: "maak 'n toespraak (om te)",
    russian: 'произносить речь',
    latvian: 'teikt runu',
    polish: '',
    french: '',
    spanish: 'hacer un discurso',
  },
  {
    av: 25113,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 1 + one (index number): small 1 of ISO standard) SYMBOL SYNONYM (replacing 15483)',
    english: 'Monday (day1)',
    swedish: 'måndag (dag 1)',
    norwegian: 'mandag (dag 1)',
    finnish: 'maanantai (päivä yksi)',
    hungarian: '',
    german: 'Montag (Tag 1)',
    dutch: 'maandag (dag 1)',
    afrikaans: 'Maandag (dag1)',
    russian: 'Понедельник (день 1)',
    latvian: 'pirmdiena (1.diena)',
    polish: '',
    french: '',
    spanish: 'Lunes (día1)',
  },
  {
    av: 25114,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 2 + one (index number): small 1 of ISO standard) SYMBOL SYNONYM (replacing 15483)',
    english: 'Monday (day2)',
    swedish: 'måndag (dag 2)',
    norwegian: 'mandag (dag 2)',
    finnish: 'maanantai (päivä kaksi)',
    hungarian: '',
    german: 'Montag (Tag 2)',
    dutch: 'maandag (dag 2)',
    afrikaans: 'Maandag (dag2)',
    russian: 'Понедельник (день 2)',
    latvian: 'pirmdiena (2.diena)',
    polish: '',
    french: '',
    spanish: 'Lunes (día2)',
  },
  {
    av: 25115,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 3 + one (index number): small 1 of ISO standard) SYMBOL SYNONYM (replacing 15483)',
    english: 'Monday (day3)',
    swedish: 'måndag (dag 3)',
    norwegian: 'mandag (dag 3)',
    finnish: 'maanantai (päivä kolme)',
    hungarian: '',
    german: 'Montag (Tag 3)',
    dutch: 'maandag (dag 3)',
    afrikaans: 'Maandag (dag3)',
    russian: 'Понедельник (день 3)',
    latvian: 'pirmdiena (3.diena)',
    polish: '',
    french: '',
    spanish: 'Lunes (día3)',
  },
  {
    av: 25116,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(Moomintroll [contr.] + mother: Literary figure in the Moomin books by Tove Jansson - she is the mother of Moomintroll.)',
    english: 'Moominmamma',
    swedish: 'Muminmamman',
    norwegian: 'Mummimamma',
    finnish: 'Muumimamma',
    hungarian: '',
    german: 'Muminmama',
    dutch: 'Moominmamma (fantasiefiguur)',
    afrikaans: 'Moominmamma',
    russian: 'Муми-мама',
    latvian: 'Muminu mamma',
    polish: '',
    french: '',
    spanish: 'Moominmamma',
  },
  {
    av: 25117,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(Moomintroll [contr.] + father: Literary figure in the Moomin books by Tove Jansson - he is the father of Moomintroll.)',
    english: 'Moominpappa',
    swedish: 'Muminpappan',
    norwegian: 'Mummipappa',
    finnish: 'Muumipappa',
    hungarian: '',
    german: 'Muminpapa',
    dutch: 'Moominpappa (fantasiefiguur)',
    afrikaans: 'Moominpappa',
    russian: 'Муми-папа',
    latvian: 'Muminu tētis',
    polish: '',
    french: '',
    spanish: 'Moominpappa',
  },
  {
    av: 25118,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(imaginary person + imprint, depression + M: Literary figure in the Moomin books by Tove Jansson - the main character of most of the books, imprint, depression represents soft [contr.])',
    english: 'Moomintroll',
    swedish: 'Mumintrollet',
    norwegian: 'Mummitrollet',
    finnish: 'Muumipeikko',
    hungarian: '',
    german: 'Mumintroll',
    dutch: 'Moomintroll (fantasiefiguur)',
    afrikaans: 'Moomintroll',
    russian: 'Муми-тролль',
    latvian: 'Mumintrollis',
    polish: '',
    french: '',
    spanish: 'Moomins',
  },
  {
    av: 25120,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(body + dead + cloth)',
    english: 'mummy (general)',
    swedish: 'mumie (generell)',
    norwegian: 'mumie (generell)',
    finnish: 'muumio',
    hungarian: '',
    german: 'Mumie (generell)',
    dutch: 'mummie',
    afrikaans: 'mummie (algemeen)',
    russian: 'мумия (общее понятие)',
    latvian: 'mūmija',
    polish: '',
    french: '',
    spanish: 'momia',
  },
  {
    av: 25121,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(imaginary person + dead + cloth)',
    english: 'mummy (imaginary)',
    swedish: 'mumie (övernaturligt väsen)',
    norwegian: 'mumie (overnaturlig vesen)',
    finnish: 'muumio (mielikuvitusolento)',
    hungarian: '',
    german: 'Mumie (imaginär)',
    dutch: 'mummie (fantasiefiguur)',
    afrikaans: 'mummie (denkbeeldig)',
    russian: 'мумия (мнимая)',
    latvian: 'mūmija (pārcilvēciska būtne)',
    polish: '',
    french: '',
    spanish: 'momia (imaginario)',
  },
  {
    av: 25122,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(killing + plan)',
    english: 'murder',
    swedish: 'mord',
    norwegian: 'mord (overlagt)',
    finnish: 'murha, murhaaminen',
    hungarian: '',
    german: 'Mord',
    dutch: 'moord (met voorbedachte rade)',
    afrikaans: 'moord (beplan)',
    russian: 'убийство',
    latvian: 'slepkavība, slepkava',
    polish: '',
    french: '',
    spanish: 'asesinato',
  },
  {
    av: 25123,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(murder + action indicator)',
    english: 'murder-(to)',
    swedish: 'mörda ',
    norwegian: 'myrde, drepe (planlagt)',
    finnish: 'murhata',
    hungarian: '',
    german: 'töten, ermorden',
    dutch: 'vermoorden, moorden',
    afrikaans: 'moordpleeg (om te)',
    russian: 'убивать',
    latvian: 'nogalināt, noslepkavot',
    polish: '',
    french: '',
    spanish: 'asesinar',
  },
  {
    av: 25124,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + murder)',
    english: 'murderer',
    swedish: 'mördare',
    norwegian: 'morder (overlagt drap)',
    finnish: 'murhaaja',
    hungarian: '',
    german: 'Mörder, Mörderin',
    dutch: 'moordenaar',
    afrikaans: 'moordenaar',
    russian: 'убийца',
    latvian: 'slepkava',
    polish: '',
    french: '',
    spanish: 'asesino',
  },
  {
    av: 25125,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(curious, inquisitive + negative + description indicator)',
    english: 'nosy',
    swedish: 'nyfiken (negativt)',
    norwegian: 'nesevis',
    finnish: 'uteleva',
    hungarian: '',
    german: 'neugierig, naseweis',
    dutch: 'nieuwsgierig (negatief), bemoeizuchtig',
    afrikaans: 'nuuskierig',
    russian: 'любопытный (негативное значение)',
    latvian: 'ziņkārīgs, izbrīnīts, ieinteresēts',
    polish: '',
    french: '',
    spanish: 'fisgón',
  },
  {
    av: 25126,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fuel + nucleus)',
    english: 'nuclear fuel',
    swedish: 'kärnbränsle, atombränsle',
    norwegian: 'atombrensel',
    finnish: 'ydinpolttoaine',
    hungarian: '',
    german: 'Kernbrennstoff, Reaktorbrennstoff',
    dutch: 'kernenergie',
    afrikaans: 'kern brandstof',
    russian: 'ядерное топливо',
    latvian: 'kodolenerģija',
    polish: '',
    french: '',
    spanish: 'combustible nuclear',
  },
  {
    av: 25127,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fuel + oil)',
    english: 'oil (fuel)',
    swedish: 'olja (bränsle)',
    norwegian: 'oljebrensel',
    finnish: 'polttoöljy',
    hungarian: '',
    german: 'Öl',
    dutch: 'olie (brandstof)',
    afrikaans: 'olie (brandstof)',
    russian: 'масло (топливо)',
    latvian: 'eļļa (degviela)',
    polish: '',
    french: '',
    spanish: 'gasolina (combustible)',
  },
  {
    av: 25128,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(energy + oil)',
    english: 'oil power, oil energy',
    swedish: 'oljeenergi',
    norwegian: 'oljeenergi',
    finnish: 'öljyenergia',
    hungarian: '',
    german: 'Ölenergie',
    dutch: 'olie-energie ',
    afrikaans: 'olie krag, olie-energie',
    russian: 'энергетическое масло',
    latvian: 'eļļas degviela',
    polish: '',
    french: '',
    spanish: 'energia del petróleo',
  },
  {
    av: 25129,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(feeling + enough + description indicator)',
    english: 'OK, alright',
    swedish: 'lagom, OK',
    norwegian: 'ok, i orden',
    finnish: 'selvä, okei',
    hungarian: '',
    german: 'okay, gut',
    dutch: 'oké',
    afrikaans: 'OK, alles reg',
    russian: 'согласный, ОК',
    latvian: 'labs ir, viss kārtībā',
    polish: '',
    french: '',
    spanish: 'bien, bueno, OK',
  },
  {
    av: 25130,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(competition + 5 + ring)',
    english: 'Olympics, Olympic games',
    swedish: 'olympiad, OS',
    norwegian: 'OL, olympiske leker',
    finnish: 'olympialaiset',
    hungarian: '',
    german: 'Olympische Spiele',
    dutch: 'Olympische Spelen',
    afrikaans: 'Olimpiese Spele',
    russian: 'Олимпийские игры',
    latvian: 'Olimpiāde, Olimpiskās spēles',
    polish: '',
    french: '',
    spanish: 'Juegos Olímpicos, Olimpiadas',
  },
  {
    av: 25131,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(oppression, captivity, slavery + description indicator)',
    english: 'oppressed, unfree',
    swedish: 'ofri, i fångenskap, förtryckt',
    norwegian: 'undertrykt, ufri, i fangenskap',
    finnish: 'sorrettu, orjuutettu',
    hungarian: '',
    german: 'geschunden, unterdrückt, unfrei',
    dutch: 'onderdrukt, onvrij',
    afrikaans: 'verdruktes, onvrye',
    russian: 'несвободный, угнетённый',
    latvian: 'apspiests, nebrīvs',
    polish: '',
    french: '',
    spanish: 'opreso, oprimido',
  },
  {
    av: 25136,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(passivity + description indicator)',
    english: 'passive',
    swedish: 'passiv',
    norwegian: 'passiv',
    finnish: 'passiivinen',
    hungarian: '',
    german: 'passiv',
    dutch: 'passief',
    afrikaans: 'passief',
    russian: 'пассивный',
    latvian: 'neaktīvs, pasīvs',
    polish: '',
    french: '',
    spanish: 'pasivo',
  },
  {
    av: 25137,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + activity)',
    english: 'passivity',
    swedish: 'passivitet',
    norwegian: 'passivitet',
    finnish: 'passiivisuus',
    hungarian: '',
    german: 'Passivität',
    dutch: 'passiviteit',
    afrikaans: 'passiwiteit',
    russian: 'пассивность',
    latvian: 'neaktivitāte, pasivitāte',
    polish: '',
    french: '',
    spanish: 'pasividad',
  },
  {
    av: 25138,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + time + pill, tablet)',
    english: 'pill box',
    swedish: 'dosett (medicin)',
    norwegian: 'dosett, pilleboks',
    finnish: 'dosetti, lääkeannostelija',
    hungarian: '',
    german: 'Tablettendose',
    dutch: 'pillendoos, medicijnendoos',
    afrikaans: 'pil boks houer',
    russian: 'коробка для таблеток',
    latvian: 'zāļu kastīte',
    polish: '',
    french: '',
    spanish: 'caja de píldoras',
  },
  {
    av: 25139,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + field)',
    english: 'Poland',
    swedish: 'Polen',
    norwegian: 'Polen',
    finnish: 'Puola',
    hungarian: '',
    german: 'Polen',
    dutch: 'Polen',
    afrikaans: 'Pole',
    russian: 'Польша',
    latvian: 'Polija',
    polish: '',
    french: '',
    spanish: 'Polonia',
  },
  {
    av: 25140,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(country + wakefulness, alertness + new: country of discoveries (search [contr.] + new))',
    english: 'Portugal',
    swedish: 'Portugal',
    norwegian: 'Portugal',
    finnish: 'Portugali',
    hungarian: '',
    german: 'Portugal',
    dutch: 'Portugal',
    afrikaans: 'Portugal',
    russian: 'Португалия',
    latvian: 'Portugāle',
    polish: '',
    french: '',
    spanish: 'Portugal',
  },
  {
    av: 25141,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + energy)',
    english: 'power plant, power station',
    swedish: 'kraftverk, kraftstation',
    norwegian: 'kraftverk, kraftstasjon',
    finnish: 'voimalaitos',
    hungarian: '',
    german: 'Kraftwerk',
    dutch: 'krachtcentrale',
    afrikaans: 'kragstasie',
    russian: 'электростанция',
    latvian: 'spēkstacija',
    polish: '',
    french: '',
    spanish: 'central eléctrica',
  },
  {
    av: 25142,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(value + feeling + and, also, plus, too + description indicator: value characterized by a positive feeling of fond affection for)',
    english: 'precious, treasured',
    swedish: 'värdefull, dyrbar',
    norwegian: 'verdifull, dyrebar',
    finnish: 'kallisarvoinen, arvokas',
    hungarian: '',
    german: 'kostbar, wertvoll',
    dutch: 'kostbaar, waardevol',
    afrikaans: 'kosbare kosbaar',
    russian: 'драгоценный',
    latvian: 'dārgs, vērtīgs, augstu vērtēts',
    polish: '',
    french: '',
    spanish: 'preciado',
  },
  {
    av: 25143,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + precious)',
    english: 'precious thing, treasure',
    swedish: 'dyrbarhet, dyrgrip, värdesak',
    norwegian: 'verdisak',
    finnish: 'aarre',
    hungarian: '',
    german: 'kostbares, wertvolles Ding, Sammlung, Schatz',
    dutch: 'waardevol voorwerp, kostbaar ding, schat',
    afrikaans: 'kosbare ding, skat',
    russian: 'драгоценность',
    latvian: 'dārglieta, vērtslieta',
    polish: '',
    french: '',
    spanish: 'cosa preciosa, tesoro',
  },
  {
    av: 25144,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + work + barred window: the barred window representing prison [contr])',
    english: 'prison officer',
    swedish: 'fångvårdare',
    norwegian: 'fangevokter',
    finnish: 'vanginvartija',
    hungarian: '',
    german: 'Gefängnisaufseher, Gefängnisaufseherin',
    dutch: 'cipier',
    afrikaans: 'gevangenis offisier',
    russian: 'тюремщик',
    latvian: 'cietuma amatpersona',
    polish: '',
    french: '',
    spanish: 'oficial de la prision',
  },
  {
    av: 25145,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + barred window: the barred window representing prison [contr])',
    english: 'prisoner',
    swedish: 'fånge',
    norwegian: 'fange',
    finnish: 'vanki',
    hungarian: '',
    german: 'Häftling, Gefangener',
    dutch: 'gevangene',
    afrikaans: 'gevangene',
    russian: 'заключённый',
    latvian: 'cietumnieks',
    polish: '',
    french: '',
    spanish: 'preso',
  },
  {
    av: 25146,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + pressure)',
    english: 'pump',
    swedish: 'pump',
    norwegian: 'pumpe',
    finnish: 'pumppu',
    hungarian: '',
    german: 'Pumpe',
    dutch: 'pomp',
    afrikaans: 'pomp',
    russian: 'насос',
    latvian: 'pumpis',
    polish: '',
    french: '',
    spanish: 'bomba (a presión)',
  },
  {
    av: 25147,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(pump + action indicator)',
    english: 'pump-(to)',
    swedish: 'pumpa',
    norwegian: 'pumpe (å)',
    finnish: 'pumpata',
    hungarian: '',
    german: 'aufpumpen, pumpen',
    dutch: 'pompen',
    afrikaans: 'pomp (om te)',
    russian: 'качать, выкачивать',
    latvian: 'pumpēt',
    polish: '',
    french: '',
    spanish: 'bombear',
  },
  {
    av: 25148,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + broken)',
    english: 'rag',
    swedish: 'trasa, trasor',
    norwegian: 'fille, filler',
    finnish: 'rääsyt, rikkinäiset vaatteet',
    hungarian: '',
    german: 'Lappen, Lumpen, Fetzen',
    dutch: 'vodden, doek',
    afrikaans: 'lap doek',
    russian: 'тряпка',
    latvian: 'lupata',
    polish: '',
    french: '',
    spanish: 'trapo',
  },
  {
    av: 25149,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothes + usage, use + end)',
    english: 'rags (worn-out clothes)',
    swedish: 'paltor, slitna kläder',
    norwegian: 'slitte klær',
    finnish: 'loppuunkuluneet vaatteet',
    hungarian: '',
    german: 'Klamotten, Haderlumpen',
    dutch: 'tweedehands kleding, ',
    afrikaans: 'flenters tweedehandse klere',
    russian: 'ветошь, изношенная одежда',
    latvian: 'lupatas, novalkātas drēbes',
    polish: '',
    french: '',
    spanish: 'harapos',
  },
  {
    av: 25150,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(resignation (1) + action indicator) SYMBOL SYNONYM',
    english: 'resign, quit (1)-(to)',
    swedish: 'säga upp sig, sluta (sitt arbete), avgå (1)',
    norwegian: 'si opp, slutte, gå av (arbeid) (1)',
    finnish: 'erota työstä, irtisanoutua',
    hungarian: '',
    german: 'Kündigen (1)',
    dutch: 'ontslagen, ontslag krijgen, ontslag geven (1)',
    afrikaans: 'bedank ontslag (1) (om te)',
    russian: 'уходить в отставку, увольняться (1)',
    latvian: 'atkāpties no amata, iesniegt atlūgumu (1)',
    polish: '',
    french: '',
    spanish: 'renunciar',
  },
  {
    av: 25151,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(resignation (2) + action indicator) SYMBOL SYNONYM',
    english: 'resign, quit (2)-(to)',
    swedish: 'säga upp sig, sluta (sitt arbete), avgå (2)',
    norwegian: 'si opp, slutte, gå av (arbeid) (2)',
    finnish: 'erota työstä, irtisanoutua',
    hungarian: '',
    german: 'Kündigen (2)',
    dutch: 'ontslagen, ontslag krijgen, ontslag geven (2)',
    afrikaans: 'bedank ontslag (2) (om te)',
    russian: 'уходить в отставку, увольняться (2)',
    latvian: 'atkāpties no amata, iesniegt atlūgumu (2)',
    polish: '',
    french: '',
    spanish: 'renunciar',
  },
  {
    av: 25152,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(end + work: to stop (a) work) SYMBOL SYNONYM',
    english: 'resignation (1)',
    swedish: 'uppsägning, avgång (från arbete) (1)',
    norwegian: 'oppsigelse, avgang (fra arbeid) (1)',
    finnish: 'työstä eroaminen, irtisanoutuminen',
    hungarian: '',
    german: 'Rücktritt (1)',
    dutch: 'ontslag (1)',
    afrikaans: 'bedanking (1)',
    russian: 'отставка, увольнение (1)',
    latvian: 'atkāpšanās, atlūgums (1)',
    polish: '',
    french: '',
    spanish: 'resignación (1)',
  },
  {
    av: 25153,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(departure + work: to leave (a) work) SYMBOL SYNONYM',
    english: 'resignation (2)',
    swedish: 'uppsägning, avgång (från arbete) (2)',
    norwegian: 'oppsigelse, avgang (fra arbeid) (2)',
    finnish: 'työstä eroaminen, irtisanoutuminen',
    hungarian: '',
    german: 'Rücktritt (2)',
    dutch: 'ontslag (2)',
    afrikaans: 'bedanking (2)',
    russian: 'отставка, увольнение (2)',
    latvian: 'atkāpšanās, atlūgums (2)',
    polish: '',
    french: '',
    spanish: 'resignación (2)',
  },
  {
    av: 25154,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(retirement + action indicator)',
    english: 'retire-(to)',
    swedish: 'gå i pension',
    norwegian: 'pensjoneres',
    finnish: 'jäädä eläkkeelle',
    hungarian: '',
    german: 'in den Ruhestand treten, in Pension gehen',
    dutch: 'op pensioen gaan',
    afrikaans: 'om af te tree',
    russian: 'уходить на пенсию',
    latvian: 'aiziet pensijā',
    polish: '',
    french: '',
    spanish: 'retirarse',
  },
  {
    av: 25155,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(retirement + description indicator)',
    english: 'retired',
    swedish: 'pensionerad',
    norwegian: 'pensjonert',
    finnish: 'olla eläkkeellä, eläkeläinen',
    hungarian: '',
    german: 'pensioniert',
    dutch: 'gepensioneerd',
    afrikaans: 'afgetree',
    russian: 'ушедший на пенсию',
    latvian: 'pensionārs',
    polish: '',
    french: '',
    spanish: 'jubilado',
  },
  {
    av: 25156,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(resignation (1) + year)',
    english: 'retirement',
    swedish: 'pension, pensionering',
    norwegian: 'pensjon, pensjonering',
    finnish: 'eläkevuodet',
    hungarian: '',
    german: 'Ruhestand, Pensionierung',
    dutch: 'pensioen',
    afrikaans: 'aftrede',
    russian: 'уход на пенсию',
    latvian: 'pensija (dzīves periods)',
    polish: '',
    french: '',
    spanish: 'jubilación',
  },
  {
    av: 25157,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + big)',
    english: 'roast, joint (of meat)',
    swedish: 'stek, köttstycke (större)',
    norwegian: 'stek, kjøttstykke (stort)',
    finnish: 'paisti',
    hungarian: '',
    german: 'Braten, Rostbraten (grösseres Fleischstück)',
    dutch: 'gebraad (vlees)',
    afrikaans: 'gebraaide (vleis)',
    russian: 'ростбиф, большой кусок мяса',
    latvian: 'cepetis',
    polish: '',
    french: '',
    spanish: 'filete',
  },
  {
    av: 25158,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + activity + person)',
    english: 'robot',
    swedish: 'robot',
    norwegian: 'robot',
    finnish: 'robotti',
    hungarian: '',
    german: 'Roboter',
    dutch: 'robot',
    afrikaans: 'robot',
    russian: 'робот',
    latvian: 'robots',
    polish: '',
    french: '',
    spanish: 'robot',
  },
  {
    av: 25159,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(dismissal + action indicator)',
    english: 'sack, dismiss-(to)',
    swedish: 'avskeda',
    norwegian: 'avskjedige',
    finnish: 'erottaa työstä, sanoa irti työstä',
    hungarian: '',
    german: 'entlassen, feuern',
    dutch: 'ontslagen (verplicht)',
    afrikaans: 'afdank, ontslaan (om te)',
    russian: 'увольнять ',
    latvian: 'atlaist, atbrīvot no darba',
    polish: '',
    french: '',
    spanish: 'despedir',
  },
  {
    av: 25160,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(dismissal + description indicator)',
    english: 'sacked, dismissed',
    swedish: 'avskedad',
    norwegian: 'avskjediget',
    finnish: 'työstä erotettu, irtisanottu',
    hungarian: '',
    german: 'gekündigt, entlassen, gefeuert',
    dutch: 'ontslagen (verplicht)',
    afrikaans: 'afgedank, ontslaan',
    russian: 'уволенный',
    latvian: 'atlaists, atbrīvots no darba',
    polish: '',
    french: '',
    spanish: 'despedido',
  },
  {
    av: 25161,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(resignation (1) + force)',
    english: 'sacking, dismissal',
    swedish: 'avsked (från arbete)',
    norwegian: 'avskjed (fra arbeid)',
    finnish: 'työstä erottaminen, irtisanominen',
    hungarian: '',
    german: 'Kündigung, Entlassung',
    dutch: 'ontslag',
    afrikaans: 'afdanking, ontslag',
    russian: 'увольнение',
    latvian: 'atlaišana, atbrīvošana no darba',
    polish: '',
    french: '',
    spanish: 'despido',
  },
  {
    av: 25162,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(move, movement + see, look, watch-(to) + animal)',
    english: 'safari, wildlife expedition',
    swedish: 'safari',
    norwegian: 'safari',
    finnish: 'safari',
    hungarian: '',
    german: 'Safari',
    dutch: 'safari',
    afrikaans: 'safari, wild kyk ekspedisie',
    russian: 'сафари',
    latvian: 'ekspedīcija, safari, (savvaļas, dzīvās dabas)',
    polish: '',
    french: '',
    spanish: 'safari, expedición salvaje',
  },
  {
    av: 25163,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 1 + six (index number): small 6 of ISO standard) SYMBOL SYNONYM (replacing 16722)',
    english: 'Saturday (day1)',
    swedish: 'lördag (dag 1)',
    norwegian: 'lørdag (dag 1)',
    finnish: 'lauantai (päivä yksi)',
    hungarian: '',
    german: 'Samstag, Sonnabend (Tag 1)',
    dutch: 'zaterdag (dag 1)',
    afrikaans: 'Saterdag (dag 1)',
    russian: 'Суббота (день1)',
    latvian: 'sestdiena (1.diena)',
    polish: '',
    french: '',
    spanish: 'Sábado (1)',
  },
  {
    av: 25164,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 6 + six (index number): small 6 of ISO standard) SYMBOL SYNONYM (replacing 16722)',
    english: 'Saturday (day6)',
    swedish: 'lördag (dag 6)',
    norwegian: 'lørdag (dag 6)',
    finnish: 'lauantai (päivä kuusi)',
    hungarian: '',
    german: 'Samstag, Sonnabend (Tag 6)',
    dutch: 'zaterdag (dag 6)',
    afrikaans: 'Saterdag (dag 7)',
    russian: 'Суббота (день 6)',
    latvian: 'sestdiena (6.diena)',
    polish: '',
    french: '',
    spanish: 'Sábado (6)',
  },
  {
    av: 25165,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 7 + six (index number): small 6 of ISO standard) SYMBOL SYNONYM (replacing 16722)',
    english: 'Saturday (day7)',
    swedish: 'lördag (dag 7)',
    norwegian: 'lørdag (dag 7)',
    finnish: 'lauantai (päivä seitsemän)',
    hungarian: '',
    german: 'Samstag, Sonnabend (Tag 7)',
    dutch: 'zaterdag (dag 7)',
    afrikaans: 'Saterdag (dag 7)',
    russian: 'Суббота (день 7)',
    latvian: 'sestdiena (7.diena)',
    polish: '',
    french: '',
    spanish: 'Sábado (7)',
  },
  {
    av: 25166,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + mean, cruel)',
    english: 'scoundrel, villain',
    swedish: 'bov, skurk, buse',
    norwegian: 'skurk',
    finnish: 'konna, roisto, kelmi',
    hungarian: '',
    german: 'Schurke, Schurkin, Schuft, Bösewicht',
    dutch: 'schurk, boef',
    afrikaans: 'skurk, rampokker',
    russian: 'негодяй, злодей',
    latvian: 'nelietis, zemisks cilvēks',
    polish: '',
    french: '',
    spanish: 'bribón, villano',
  },
  {
    av: 25167,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + safety, security)',
    english: 'protector, guard',
    swedish: 'väktare, vakt',
    norwegian: 'vekter, vakt',
    finnish: 'vartija, suojelija',
    hungarian: '',
    german: 'Beschützer, Beschützerin, Wächter, Wächterin ',
    dutch: 'beschermer, bewaker',
    afrikaans: 'beskermer, bewaker',
    russian: 'защитник, охранник',
    latvian: 'aizsargs, sargs',
    polish: '',
    french: '',
    spanish: 'protector, guardian',
  },
  {
    av: 25168,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(imaginary person + scared: Literary figure in the Moomin books by Tove Jansson - friend of Moomin, a real coward, and very interested in money.)',
    english: 'Sniff',
    swedish: 'Sniff',
    norwegian: 'Sniff',
    finnish: 'Nipsu',
    hungarian: '',
    german: 'Schnüferl/Sniff',
    dutch: 'Sniff (fantasiefiguur)',
    afrikaans: 'Sniff',
    russian: 'Снифф',
    latvian: 'Snifs',
    polish: '',
    french: '',
    spanish: 'Sniff',
  },
  {
    av: 25169,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      "(imaginary person + imprint, depression + glasses: Literary figure in the Moomin books by Tove Jansson - The Snork Maiden's brother, wears glasses, inteligent, avid inventor who has strong belief in the power of science, imprint, depression represents soft [contr.])",
    english: 'Snork',
    swedish: 'Snorken',
    norwegian: 'Snorken',
    finnish: 'Niiskuneiti',
    hungarian: '',
    german: 'Snork',
    dutch: 'Snork (fantasiefiguur)',
    afrikaans: 'Snork',
    russian: 'Снорк',
    latvian: 'Snorks',
    polish: '',
    french: '',
    spanish: 'Snork',
  },
  {
    av: 25170,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      "(imaginary person + imprint, depression + ring: Literary figure in the Moomin books by Tove Jansson - Moomintroll's fair lady friend and admirer, and sports a golden anklet, imprint, depression represents soft [contr.])",
    english: 'Snork Maiden',
    swedish: 'Snorkfröken',
    norwegian: 'Snorkfrøken',
    finnish: 'Niisku',
    hungarian: '',
    german: 'Snorkfräulein',
    dutch: 'Snork Maidenc (fantasiefiguur)',
    afrikaans: 'Snork Maiden',
    russian: 'Фрёкен Снорк',
    latvian: 'Snorkes jaunkundze',
    polish: '',
    french: '',
    spanish: 'Señorita Snork',
  },
  {
    av: 25171,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      "(imaginary person + boy + musical instrument: Literary figure in the Moomin books by Tove Jansson - Moomintroll's best friend, who lives in a tent, smokes a pipe, and plays the harmonica.)",
    english: 'Snufkin',
    swedish: 'Snusmumriken',
    norwegian: 'Snusmumriken',
    finnish: 'Nuuskamuikkunen',
    hungarian: '',
    german: 'Snufkin',
    dutch: 'Snufkin (fantasiefiguur)',
    afrikaans: 'Snufkin',
    russian: 'Снусмумрик',
    latvian: 'Murmulis',
    polish: '',
    french: '',
    spanish: 'Snufkin',
  },
  {
    av: 25172,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(energy + sun)',
    english: 'solar energy, solar power',
    swedish: 'solenergi',
    norwegian: 'solenergi',
    finnish: 'aurinkoenergia, aurinkovoima',
    hungarian: '',
    german: 'Sonnenenergie',
    dutch: 'zonne-energie',
    afrikaans: 'sonkrag, son energie',
    russian: 'солнечная энергия',
    latvian: 'saules enerģija',
    polish: '',
    french: '',
    spanish: 'energía solar',
  },
  {
    av: 25173,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(move, movement + galaxy)',
    english: 'space travel, space voyage, space flight',
    swedish: 'rymdfärd',
    norwegian: 'romferd',
    finnish: 'avaruusmatka',
    hungarian: '',
    german: 'Weltraumflug, Weltraumfahrt, Raumfahrt',
    dutch: 'ruimtereis, ruimtevaart',
    afrikaans: 'ruimtereis',
    russian: 'космическое путешествие ',
    latvian: 'kosmosa ceļojumi',
    polish: '',
    french: '',
    spanish: 'viaje espacial',
  },
  {
    av: 25174,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(say, speak, talk, tell, express-(to) + event + group of + person)',
    english: 'speech (event)',
    swedish: 'tal, anförande',
    norwegian: 'tale (til flere)',
    finnish: 'puhe',
    hungarian: '',
    german: 'Rede (Veranstaltung)',
    dutch: 'speech, toespraak',
    afrikaans: 'toespraak',
    russian: 'речь, выступление',
    latvian: 'runa (notikums)',
    polish: '',
    french: '',
    spanish: 'dirscurso',
  },
  {
    av: 25175,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + secret + information)',
    english: 'secret agent, spy',
    swedish: 'spion, hemlig agent',
    norwegian: 'spion, hemmelig agent',
    finnish: 'salainen agentti, vakoilija',
    hungarian: '',
    german: 'Geheimagent, Geheimagentin, Spion, Spionin',
    dutch: 'spion, geheimagent',
    afrikaans: 'geheime agentskap, spioen',
    russian: 'тайный агент, шпион',
    latvian: 'slepenais aģents, spiegs',
    polish: '',
    french: '',
    spanish: 'agente secreto, espía',
  },
  {
    av: 25176,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meat + slice + thing indicator)',
    english: 'steak',
    swedish: 'biff, köttskiva',
    norwegian: 'biff, kjøttskive, kotelett',
    finnish: 'pihvi',
    hungarian: '',
    german: 'Steak',
    dutch: 'steak, biefstuk',
    afrikaans: 'biefstuk, steak',
    russian: 'стейк, отбивная',
    latvian: 'gaļas gabals, bifšteks, steiks',
    polish: '',
    french: '',
    spanish: 'filete, carne de res',
  },
  {
    av: 25177,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(without + back and forth + description indicator: back and forth rrepresenting movement, motion (2) [contr.])',
    english: 'still, calm, peaceful, tranquil',
    swedish: 'stilla, stillsam, lugn',
    norwegian: 'stille, rolig, fredelig',
    finnish: 'rauhallinen, tyyni',
    hungarian: '',
    german: 'ruhig, still, gefasst, friedlich, gelassen',
    dutch: 'stil (geen beweging), vredig, rustig',
    afrikaans: 'kalm, stil, rustig',
    russian: 'спокойный, тихий',
    latvian: 'mierīgs, rimts, rāms',
    polish: '',
    french: '',
    spanish: 'tranquilo, calmado, relajado',
  },
  {
    av: 25178,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(goods + theft)',
    english: 'stolen goods',
    swedish: 'stöldgods',
    norwegian: 'tyvegods',
    finnish: 'varastettu tavara',
    hungarian: '',
    german: 'Diebesgut, Hehlerwaren',
    dutch: 'gestolen goederen',
    afrikaans: 'gesteelde goedere',
    russian: 'украденные товары',
    latvian: 'zagtas preces, lietas',
    polish: '',
    french: '',
    spanish: 'bienes robados',
  },
  {
    av: 25179,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(content + information + short)',
    english: 'summary, abstract',
    swedish: 'sammandrag, sammanfattning',
    norwegian: "sammendrag, resyme'",
    finnish: 'yhteenveto, tiivistelmä',
    hungarian: '',
    german: 'Zusammenfassung, Auszug',
    dutch: 'samenvatting, abstract',
    afrikaans: 'opsomming, abstrak',
    russian: 'резюме, аннотация, сводка',
    latvian: 'kopsavilkums, anotācija',
    polish: '',
    french: '',
    spanish: 'resumen',
  },
  {
    av: 25180,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 1 + seven (index number): small 7 of ISO standard) SYMBOL SYNONYM (replacing 17464)',
    english: 'Sunday (day1)',
    swedish: 'söndag (dag 1)',
    norwegian: 'søndag (dag 1)',
    finnish: 'sunnuntai (päivä yksi)',
    hungarian: '',
    german: 'Sonntag (Tag 1)',
    dutch: 'zondag (dag 1)',
    afrikaans: 'Sondag (dag 1)',
    russian: 'Воскресение (день1)',
    latvian: 'svētdiena (1.diena)',
    polish: '',
    french: '',
    spanish: 'Domingo (día1)',
  },
  {
    av: 25181,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 2 + seven (index number): small 7 of ISO standard) SYMBOL SYNONYM (replacing 17464)',
    english: 'Sunday (day2)',
    swedish: 'söndag (dag 2)',
    norwegian: 'søndag (dag 2)',
    finnish: 'sunnuntai (päivä kaksi)',
    hungarian: '',
    german: 'Sonntag (Tag 2)',
    dutch: 'zondag (dag 2)',
    afrikaans: 'Sondag (dag 2)',
    russian: 'Воскресениье (день 2)',
    latvian: 'svētdiena (2.diena)',
    polish: '',
    french: '',
    spanish: 'Domingo (día2)',
  },
  {
    av: 25182,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 7 + seven (index number): small 7 of ISO standard) SYMBOL SYNONYM (replacing 17464)',
    english: 'Sunday (day7)',
    swedish: 'söndag (dag 7)',
    norwegian: 'søndag (dag 7)',
    finnish: 'sunnuntai (päivä seitsemän)',
    hungarian: '',
    german: 'Sonntag (Tag 7)',
    dutch: 'zondag (dag 7)',
    afrikaans: 'Sondag (dag 7)',
    russian: 'Воскресенье (день 7)',
    latvian: 'svētdiena (7.diena)',
    polish: '',
    french: '',
    spanish: 'Domingo (día7)',
  },
  {
    av: 25183,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(group + support (oral) + intensity)',
    english: 'supporters, cheering section',
    swedish: 'supportrar, hejarklack',
    norwegian: 'supportere',
    finnish: 'kannattajat',
    hungarian: '',
    german: 'Fans, Anhänger, Anhängerin, Anhängerschaft',
    dutch: 'supporters',
    afrikaans: 'ondersteuners, toeskouers juigende',
    russian: 'сторонники, группа поддержки',
    latvian: 'atbalstītāji, karsējmeiteņu grupa',
    polish: '',
    french: '',
    spanish: 'hinchada, fanáticos',
  },
  {
    av: 25184,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + clock + thing indicator)',
    english: 'Switzerland',
    swedish: 'Schweiz',
    norwegian: 'Sveits',
    finnish: 'Sveitsi',
    hungarian: '',
    german: 'Schweiz',
    dutch: 'Zwitserland',
    afrikaans: 'Switserland',
    russian: 'Швейцария',
    latvian: 'Šveice',
    polish: '',
    french: '',
    spanish: 'Suiza',
  },
  {
    av: 25186,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(takeoff (rocket) + action indicator)',
    english: 'take off (rocket)-(to)',
    swedish: 'starta (rymdraket)',
    norwegian: 'skyte ut (romrakett)',
    finnish: 'nousta ilmaan (raketti)',
    hungarian: '',
    german: 'abheben (Rakete)',
    dutch: 'opstijgen-(raket)',
    afrikaans: 'opstyg (vuurpyl) (om te)',
    russian: 'взлетать, запускать (ракета)',
    latvian: 'pacelšanās, startēšana (raķete)',
    polish: '',
    french: '',
    spanish: 'despegar',
  },
  {
    av: 25187,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rocket, spaceship + intensity)',
    english: 'takeoff (rocket)',
    swedish: 'start (rymdraket)',
    norwegian: 'utskytning (romrakett)',
    finnish: 'raketin lähtö',
    hungarian: '',
    german: 'Abflug, Abhebung, Raketenstart (Raket)',
    dutch: 'takeoff (raket), het opstijgen (raket)',
    afrikaans: 'opstyg (vuurpyl)',
    russian: 'запуск (ракета)',
    latvian: 'pacelšānās, startēšana (raķetes)',
    polish: '',
    french: '',
    spanish: 'despegue',
  },
  {
    av: 25189,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + machine)',
    english: 'technology',
    swedish: 'teknik',
    norwegian: 'teknikk',
    finnish: 'teknologia',
    hungarian: '',
    german: 'Technik, Technologie',
    dutch: 'technologie',
    afrikaans: 'tegnologie',
    russian: 'технология',
    latvian: 'tehnoloģija',
    polish: '',
    french: '',
    spanish: 'tecnología',
  },
  {
    av: 25190,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(imaginary person + coldness, cold: Literary figure in the Moomin books by Tove Jansson - She is cold and ghostlike, and represents loneliness and all that is scary in the world of Moomin.)',
    english: 'The Groke',
    swedish: 'Mårran',
    norwegian: 'Hufsa',
    finnish: 'Mörkö',
    hungarian: '',
    german: 'Morra',
    dutch: 'de Groke (fantasiefiguur)',
    afrikaans: 'The Groke',
    russian: 'Морра',
    latvian: 'Morra',
    polish: '',
    french: '',
    spanish: 'El Groke',
  },
  {
    av: 25191,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(receiving + negative)',
    english: 'theft',
    swedish: 'stöld ',
    norwegian: 'tyveri',
    finnish: 'varastettu tavara',
    hungarian: '',
    german: 'Diebstahl',
    dutch: 'diefstal',
    afrikaans: 'diefstal',
    russian: 'кража, воровство',
    latvian: 'zādzība, zagšana',
    polish: '',
    french: '',
    spanish: 'robo',
  },
  {
    av: 25192,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(feeling + expectation, anticipation + intensity + description indicator)',
    english: 'thrilling, scary',
    swedish: 'spännande, skrämmande',
    norwegian: 'spennende, skremmende',
    finnish: 'pelottava',
    hungarian: '',
    german: 'aufregend, spannend, furchterregend, unheimlich, gruselig',
    dutch: 'spannend, eng',
    afrikaans: 'skrikwekkend',
    russian: 'волнительно, страшно',
    latvian: 'aizgrābjošs, saviļņojošs, biedējošs',
    polish: '',
    french: '',
    spanish: 'suspenso, emocionante',
  },
  {
    av: 25193,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 4 + four (index number): small 4 of ISO standard) SYMBOL SYNONYM (replacing 17728)',
    english: 'Thursday (day4)',
    swedish: 'torsdag (dag 4)',
    norwegian: 'torsdag (dag 4)',
    finnish: 'torstai (päivä neljä)',
    hungarian: '',
    german: 'Donnerstag (Tag 4)',
    dutch: 'donderdag (dag 4)',
    afrikaans: 'Donderday (dag 4)',
    russian: 'Четверг (день 4)',
    latvian: 'ceturtdiena (4.diena)',
    polish: '',
    french: '',
    spanish: 'Jueves (día4)',
  },
  {
    av: 25194,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 5 + four (index number): small 4 of ISO standard) SYMBOL SYNONYM (replacing 17728)',
    english: 'Thursday (day5)',
    swedish: 'torsdag (dag 5)',
    norwegian: 'torsdag (dag 5)',
    finnish: 'torstai (päivä viisi)',
    hungarian: '',
    german: 'Donnerstag (Tag 5)',
    dutch: 'donderdag (dag 5)',
    afrikaans: 'Donderday (dag 5)',
    russian: 'Четверг (день 5)',
    latvian: 'ceturdiena (5.diena)',
    polish: '',
    french: '',
    spanish: 'Jueves (día5)',
  },
  {
    av: 25195,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 6 + four (index number): small 4 of ISO standard) SYMBOL SYNONYM (replacing 17728)',
    english: 'Thursday (day6)',
    swedish: 'torsdag (dag 6)',
    norwegian: 'torsdag (dag 6)',
    finnish: 'torstai (päivä kuusi)',
    hungarian: '',
    german: 'Donnerstag (Tag 6)',
    dutch: 'donderdag (dag 6)',
    afrikaans: 'Donderday (dag 6)',
    russian: 'Четверг (день 6)',
    latvian: 'ceturtdiena (6.diena)',
    polish: '',
    french: '',
    spanish: 'Jueves (día6)',
  },
  {
    av: 25196,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      "(imaginary person + sadness, sorrow, unhappiness: Literary figure in the Moomin books by Tove Jansson - Toffles are small creatures, shy, scared and confused. 'Toffle' is the main character in Who Will Comfort Toffle?.)",
    english: 'Toffle',
    swedish: 'Knyttet',
    norwegian: 'Knøttet ',
    finnish: 'Nyyti',
    hungarian: '',
    german: 'Lillan',
    dutch: 'Toffle (fantasiefiguur)',
    afrikaans: 'Toffle',
    russian: 'Тофл',
    latvian: 'Tofle',
    polish: '',
    french: '',
    spanish: 'Toffle',
  },
  {
    av: 25198,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(move, movement + to see)',
    english: 'tour, sightseeing',
    swedish: 'rundtur, sightseeing',
    norwegian: 'rundtur, sightseeing',
    finnish: 'kiertoajelu, nähtävyyksien katselu',
    hungarian: '',
    german: 'Rundfahrt, Besichtigung, Sightseeing',
    dutch: 'rondreis, sightseeing',
    afrikaans: 'besigtigings, toer',
    russian: 'тур, путешествие',
    latvian: 'ekskursija, ievērojamu vietu apskates ekskursija',
    polish: '',
    french: '',
    spanish: 'tour',
  },
  {
    av: 25199,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + capture + plan)',
    english: 'trap',
    swedish: 'fälla',
    norwegian: 'felle',
    finnish: 'ansa',
    hungarian: '',
    german: 'Falle',
    dutch: 'valstrik',
    afrikaans: 'strik lokval',
    russian: 'ловушка, капкан',
    latvian: 'slazds',
    polish: '',
    french: '',
    spanish: 'trampa',
  },
  {
    av: 25200,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(trap + action indicator)',
    english: 'trap-(to)',
    swedish: 'fånga (i fälla)',
    norwegian: 'fange (i felle)',
    finnish: 'virittää ansa',
    hungarian: '',
    german: 'fangen (in einer Falle)',
    dutch: 'verstrikken, in de val lokken',
    afrikaans: 'strik lokval (om te)',
    russian: 'ловить, поймать в капкан',
    latvian: 'noķert slazdā',
    polish: '',
    french: '',
    spanish: 'atrapar',
  },
  {
    av: 25201,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(jewel + secret)',
    english: 'hidden treasure, treasure trove',
    swedish: 'skatt (hemlig)',
    norwegian: 'skatt (hemmelig)',
    finnish: 'kätketty aarre, aarrekätkö',
    hungarian: '',
    german: 'Schatz (geheim)',
    dutch: 'schat (verborgen)',
    afrikaans: 'verborge skat',
    russian: 'клад, тайное сокровище',
    latvian: 'apslēptās bagātības',
    polish: '',
    french: '',
    spanish: 'tesoro escondido',
  },
  {
    av: 25202,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(grove + equator: grove representing forest [contr.])',
    english: 'tropical rain forest, jungle',
    swedish: 'regnskog, djungel',
    norwegian: 'regnskog, jungel',
    finnish: 'sademetsä, viidakko',
    hungarian: '',
    german: 'Dschungel, Urwald',
    dutch: 'tropisch regenwoud',
    afrikaans: 'tropiese reënwoud bosse wildernis',
    russian: 'тропический лес, джунгли',
    latvian: 'tropu lietus, lietusmežs, džungļi',
    polish: '',
    french: '',
    spanish: 'jungla',
  },
  {
    av: 25203,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 2 + two (index number): small 2 of ISO standard) SYMBOL SYNONYM (replacing 17790)',
    english: 'Tuesday (day2)',
    swedish: 'tisdag (dag 2)',
    norwegian: 'tirsdag (dag 2)',
    finnish: 'tiistai (päivä kaksi)',
    hungarian: '',
    german: 'Dienstag (Tag 2)',
    dutch: 'dinsdag (dag 2)',
    afrikaans: 'Dinsdag (dag 2)',
    russian: 'Вторник (день 2)',
    latvian: 'otrdiena (2.diena)',
    polish: '',
    french: '',
    spanish: 'Martes (día2)',
  },
  {
    av: 25204,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 3 + two (index number): small 2 of ISO standard) SYMBOL SYNONYM (replacing 17790)',
    english: 'Tuesday (day3)',
    swedish: 'tisdag (dag 3)',
    norwegian: 'tirsdag (dag 3)',
    finnish: 'tiistai (päivä kolme)',
    hungarian: '',
    german: 'Dienstag (Tag 3)',
    dutch: 'dinsdag (dag 3)',
    afrikaans: 'Dinsdag (dag 3)',
    russian: 'Вторний (день3)',
    latvian: 'otrdiena (3.diena',
    polish: '',
    french: '',
    spanish: 'Martes (día3)',
  },
  {
    av: 25205,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 4 + two (index number): small 2 of ISO standard) SYMBOL SYNONYM (replacing 17790)',
    english: 'Tuesday (day4)',
    swedish: 'tisdag (dag 4)',
    norwegian: 'tirsdag (dag 4)',
    finnish: 'tiistai (päivä neljä)',
    hungarian: '',
    german: 'Dienstag (Tag 4)',
    dutch: 'dinsdag (dag 4)',
    afrikaans: 'Dinsdag (dag 4)',
    russian: 'Вторник (день 4)',
    latvian: 'otrdiena (4.diena)',
    polish: '',
    french: '',
    spanish: 'Martes (día4)',
  },
  {
    av: 25206,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + bazaar)',
    english: 'Turkey',
    swedish: 'Turkiet',
    norwegian: 'Tyrkia',
    finnish: 'Turkki',
    hungarian: '',
    german: 'Türkei',
    dutch: 'Turkije',
    afrikaans: 'Turkye',
    russian: 'Турция',
    latvian: 'Turcija',
    polish: '',
    french: '',
    spanish: 'Turquía',
  },
  {
    av: 25207,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + wheat)',
    english: 'Ukraine',
    swedish: 'Ukraina',
    norwegian: 'Ukraina',
    finnish: 'Ukraina',
    hungarian: '',
    german: 'Ukraine',
    dutch: 'Oekraïne',
    afrikaans: 'Oekraïne',
    russian: 'Украина',
    latvian: 'Ukraina',
    polish: '',
    french: '',
    spanish: 'Ucrania',
  },
  {
    av: 25208,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(habit, custom + action indicator)',
    english: 'usually do, habitually do-(to)',
    swedish: 'bruka, ha för vana',
    norwegian: 'bruke, ha for vane',
    finnish: 'tehdä tavallisesti, tehdä useimmiten',
    hungarian: '',
    german: 'normalerweise, meistens, gewöhnlich',
    dutch: 'gewoon zijn om',
    afrikaans: 'om gewoonlik te doen',
    russian: 'иметь привычку',
    latvian: 'parasti darīt, ierasti darīt',
    polish: '',
    french: '',
    spanish: 'generalmente hacer, habitualmente hacer',
  },
  {
    av: 25209,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(imaginary person + blood)',
    english: 'vampire',
    swedish: 'vampyr',
    norwegian: 'vampyr',
    finnish: 'vampyyri',
    hungarian: '',
    german: 'Vampir',
    dutch: 'vampier',
    afrikaans: 'vampier',
    russian: 'вампир',
    latvian: 'vampīrs',
    polish: '',
    french: '',
    spanish: 'vampiro',
  },
  {
    av: 25210,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(warning + action indicator)',
    english: 'warn-(to)',
    swedish: 'varna ',
    norwegian: 'advare',
    finnish: 'varoittaa',
    hungarian: '',
    german: 'warnen',
    dutch: 'waarschuwen',
    afrikaans: 'waarsku (om te)',
    russian: 'предупредить',
    latvian: 'brīdināt',
    polish: '',
    french: '',
    spanish: 'advertir',
  },
  {
    av: 25211,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(say, speak, talk, tell, express-(to) + danger)',
    english: 'warning',
    swedish: 'varning',
    norwegian: 'advarsel',
    finnish: 'varoitus',
    hungarian: '',
    german: 'Warnung, Mahnung',
    dutch: 'waarschuwing',
    afrikaans: 'waarskuwing',
    russian: 'предупреждение',
    latvian: 'brīdinājums',
    polish: '',
    french: '',
    spanish: 'advertencia',
  },
  {
    av: 25212,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(energy + wave)',
    english: 'wave power, wave energy',
    swedish: 'vågkraft',
    norwegian: 'bølgekraft',
    finnish: 'aaltovoima, aaltoenergia',
    hungarian: '',
    german: 'Wellenkraft',
    dutch: 'golfenergie',
    afrikaans: 'golfkrag, golf energie',
    russian: 'энергия волн',
    latvian: 'viļņu enerģija, viļņu elektronenerģija',
    polish: '',
    french: '',
    spanish: 'energía de las olas',
  },
  {
    av: 25213,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + death)',
    english: 'weapon',
    swedish: 'vapen',
    norwegian: 'våpen',
    finnish: 'ase',
    hungarian: '',
    german: 'Waffe',
    dutch: 'wapen',
    afrikaans: 'wapen',
    russian: 'оружие',
    latvian: 'ierocis',
    polish: '',
    french: '',
    spanish: 'arma',
  },
  {
    av: 25214,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 3 + three (index number): small 3 of ISO standard) SYMBOL SYNONYM (replacing 18216)',
    english: 'Wednesday (day3)',
    swedish: 'onsdag (dag 3)',
    norwegian: 'onsdag (dag 3)',
    finnish: 'keskiviikko (päivä neljä)',
    hungarian: '',
    german: 'Mittwoch (Tag 3)',
    dutch: 'woensdag (dag 3)',
    afrikaans: 'Woensdag (dag 3)',
    russian: 'Среда (день 3)',
    latvian: 'trešdiena (3.diena)',
    polish: '',
    french: '',
    spanish: 'Míercoles (día3)',
  },
  {
    av: 25215,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 4 + three (index number): small 3 of ISO standard) SYMBOL SYNONYM (replacing 18216)',
    english: 'Wednesday (day4)',
    swedish: 'onsdag (dag 4)',
    norwegian: 'onsdag (dag 4)',
    finnish: 'keskiviikko (päivä viisi)',
    hungarian: '',
    german: 'Mittwoch (Tag 4)',
    dutch: 'woensdag (dag 4)',
    afrikaans: 'Woensdag (dag 4)',
    russian: 'Среда (день 4)',
    latvian: 'trešdiena (4.diena)',
    polish: '',
    french: '',
    spanish: 'Míercoles (día4)',
  },
  {
    av: 25216,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + 5 + three (index number): small 3 of ISO standard) SYMBOL SYNONYM (replacing 18216)',
    english: 'Wednesday (day5)',
    swedish: 'onsdag (dag 5)',
    norwegian: 'onsdag (dag 5)',
    finnish: 'keskiviikko (päivä kuusi)',
    hungarian: '',
    german: 'Mittwoch (Tag 5)',
    dutch: 'woensdag (dag 5)',
    afrikaans: 'Woensdag (dag 5)',
    russian: 'Среда (день 5)',
    latvian: 'trešdiena (5.diena)',
    polish: '',
    french: '',
    spanish: 'Míercoles (día5)',
  },
  {
    av: 25217,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(end + week) (Added week day number neutral) SYMBOL SYNONYM',
    english: 'weekend',
    swedish: 'veckoslut',
    norwegian: 'ukeslutt',
    finnish: 'viikonloppu',
    hungarian: '',
    german: 'Wochenende',
    dutch: 'weekend',
    afrikaans: 'naweek',
    russian: 'конец недели, выходные',
    latvian: 'nedēļas nogale',
    polish: '',
    french: '',
    spanish: 'fin de semana',
  },
  {
    av: 25218,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(imaginary person + wolf)',
    english: 'werewolf',
    swedish: 'varulv',
    norwegian: 'varulv',
    finnish: 'Ihmissusi',
    hungarian: '',
    german: 'Werwolf',
    dutch: 'weerwolf',
    afrikaans: 'weerwolf',
    russian: 'оборотень',
    latvian: 'vilkacis',
    polish: '',
    french: '',
    spanish: 'hombre lobo',
  },
  {
    av: 25220,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(energy + wind)',
    english: 'wind power, wind energy, wind farm',
    swedish: 'vindkraft',
    norwegian: 'vindkraft',
    finnish: 'tuulivoima, tuulienergia',
    hungarian: '',
    german: 'Windkraft',
    dutch: 'windenergie, windkracht',
    afrikaans: 'windkrag, wind energie, windplaas',
    russian: 'энергия ветра',
    latvian: 'vēja enerģija, vēja elektroenerģija, vēja turbīnas',
    polish: '',
    french: '',
    spanish: 'energía eolica',
  },
  {
    av: 25221,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(usage, use + end + description indicator)',
    english: 'worn-out, raddled',
    swedish: 'utsliten, utnött',
    norwegian: 'utslitt, utbrukt',
    finnish: 'loppuunkulunut, loppuunkäytetty',
    hungarian: '',
    german: 'abgenutzt, ausgetreten',
    dutch: 'versleten',
    afrikaans: 'uitgeput',
    russian: 'изношенный',
    latvian: 'novalkāts, apbružāts',
    polish: '',
    french: '',
    spanish: 'desgastado',
  },
  {
    av: 25222,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(imaginary person + dead + walk)',
    english: 'zombie',
    swedish: 'zombie',
    norwegian: 'zombie',
    finnish: 'Zombie, Zombi, elävä kuollut',
    hungarian: '',
    german: 'Zombie',
    dutch: 'zombie',
    afrikaans: 'zombie',
    russian: 'зомби',
    latvian: 'zombijs',
    polish: '',
    french: '',
    spanish: 'zombie',
  },
  {
    av: 25223,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + hand)',
    english: 'touch, touching',
    swedish: 'beröring',
    norwegian: 'berøring',
    finnish: 'koskettaminen, kosketus',
    hungarian: '',
    german: 'Berührung',
    dutch: 'aanraking',
    afrikaans: 'voel vat aanraak',
    russian: 'прикосновение, касание',
    latvian: 'pieskāriens, skāriens, pieskaršanās',
    polish: '',
    french: '',
    spanish: 'toque',
  },
  {
    av: 25250,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(military, armed forces, armed services + sky)',
    english: 'airforce, air force',
    swedish: 'flygvapen',
    norwegian: 'flyvåpen',
    finnish: 'ilmavoimat',
    hungarian: '',
    german: 'Luftwaffe',
    dutch: 'luchtmacht',
    afrikaans: 'lugmag',
    russian: 'военно-воздушные силы',
    latvian: 'gaisa spēki, gaisa karflote',
    polish: '',
    french: '',
    spanish: 'fuerza aérea',
  },
  {
    av: 25251,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(public room + airplane)',
    english: 'airport terminal',
    swedish: 'flygterminal',
    norwegian: 'flyterminal',
    finnish: 'lentoaseman terminaali',
    hungarian: '',
    german: 'Flughafengebäude',
    dutch: 'terminal (luchthaven)',
    afrikaans: 'lughawe terminaal',
    russian: 'терминал аэропорта',
    latvian: 'lidostas terminālis',
    polish: '',
    french: '',
    spanish: 'terminal del aeropuerto',
  },
  {
    av: 25252,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(leader + group of + airplane)',
    english: 'air traffic controller',
    swedish: 'flygledare',
    norwegian: 'flyleder',
    finnish: 'lennonjohtaja',
    hungarian: '',
    german: 'Flugsicherungslotse',
    dutch: 'luchtverkeersleider',
    afrikaans: 'lugbeheersbeampte',
    russian: 'авиадиспетчер',
    latvian: 'gaisa satiksmes kontrolieris',
    polish: '',
    french: '',
    spanish: 'controlador aéreo',
  },
  {
    av: 25253,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + noise (loud) + intensity)',
    english: 'alarm',
    swedish: 'larm',
    norwegian: 'alarm',
    finnish: 'hälytys',
    hungarian: '',
    german: 'Alarm, Alarmknopf',
    dutch: 'alarm',
    afrikaans: 'alarm',
    russian: 'тревога, сигнализация',
    latvian: 'signalizācija, trauksmes signāls',
    polish: '',
    french: '',
    spanish: 'alarma',
  },
  {
    av: 25254,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(alternation + action indicator)',
    english: 'alternate-(to)',
    swedish: 'växla',
    norwegian: 'veksle, alternere',
    finnish: 'vaihdella',
    hungarian: '',
    german: 'alternieren, abwechseln',
    dutch: 'afwisselen',
    afrikaans: 'afwissel (om te)',
    russian: 'чередовать',
    latvian: 'mainīties, mainīt',
    polish: '',
    french: '',
    spanish: 'alternar',
  },
  {
    av: 25255,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(alternation + description indicator)',
    english: 'alternating',
    swedish: 'växlande, omväxlande',
    norwegian: 'vekslende, avvekslende, alternativt',
    finnish: 'vaihteleva',
    hungarian: '',
    german: 'abwechselnd, wechselhaft',
    dutch: 'afwisselend',
    afrikaans: 'afwisselend',
    russian: 'переменный',
    latvian: 'mainīšanās, maiņa',
    polish: '',
    french: '',
    spanish: 'alternador',
  },
  {
    av: 25256,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(stream + electricity + alternation)',
    english: 'alternating current, AC',
    swedish: 'växelström',
    norwegian: 'vekselstrøm',
    finnish: 'vaihtovirta',
    hungarian: '',
    german: ' Wechselstrom',
    dutch: 'wisselstroom',
    afrikaans: 'wisselstroom',
    russian: 'переменный ток',
    latvian: 'maiņstrāva',
    polish: '',
    french: '',
    spanish: 'corriente alterna',
  },
  {
    av: 25257,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(forward + backward [modification, short arrows]) Character (superimposed - modified)',
    english: 'alternation',
    swedish: 'växling, omväxling',
    norwegian: 'veksling, skifte',
    finnish: 'vaihtelu',
    hungarian: '',
    german: 'Abwechslung, Wechsel',
    dutch: 'afwisseling',
    afrikaans: 'afwisseling',
    russian: 'чередование',
    latvian: 'mainīšana, mīšana',
    polish: '',
    french: '',
    spanish: 'alternación',
  },
  {
    av: 25258,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + electric current + thing indicator)',
    english: 'ammeter',
    swedish: 'amperemätare',
    norwegian: 'amperemeter',
    finnish: 'ampeerimittari',
    hungarian: '',
    german: 'Amperemeter, Strommesser',
    dutch: 'amperemeter',
    afrikaans: 'ammeter',
    russian: 'амперметр',
    latvian: 'ampērmetrs',
    polish: '',
    french: '',
    spanish: 'amperímetro',
  },
  {
    av: 25259,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(measurement + height, tallness + wave)',
    english: 'amplitude',
    swedish: 'amplitud',
    norwegian: 'amplityde',
    finnish: 'amplitudi, värähdyslaajuus',
    hungarian: '',
    german: 'Amplitude, Fülle, Umfang, Breite, Grösse',
    dutch: 'amplitude',
    afrikaans: 'amplitude',
    russian: 'амплитуда',
    latvian: 'amplitūda, vēriens, plašums',
    polish: '',
    french: '',
    spanish: 'amplitud',
  },
  {
    av: 25260,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + Muslim, Moslem, Islamic)',
    english: 'Arabic (language)',
    swedish: 'arabiska',
    norwegian: 'arabisk',
    finnish: 'arabia (kieli)',
    hungarian: '',
    german: 'Arabisch (Sprache)',
    dutch: 'Arabisch (taal)',
    afrikaans: 'Arabiese (taal)',
    russian: 'арабский язык',
    latvian: 'arābu valoda',
    polish: '',
    french: '',
    spanish: 'Árabe (lengua)',
  },
  {
    av: 25261,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + war)',
    english: 'attack',
    swedish: 'anfall, attack, angrepp',
    norwegian: 'angrep',
    finnish: 'hyökkäys',
    hungarian: '',
    german: 'Anschlag, Angriff, Anfall',
    dutch: 'aanval (leger)',
    afrikaans: 'aanval, aanrand',
    russian: 'атака, нападение',
    latvian: 'uzbrukums',
    polish: '',
    french: '',
    spanish: 'ataque',
  },
  {
    av: 25262,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(attack + action indicator)',
    english: 'attack-(to)',
    swedish: 'anfalla, attackera, angripa',
    norwegian: 'angripe',
    finnish: 'hyökätä',
    hungarian: '',
    german: 'angreifen, anfallen, attackieren',
    dutch: 'aanvallen (leger)',
    afrikaans: 'aanval, aanrand (om te)',
    russian: 'атаковать, нападать',
    latvian: 'uzbrukt',
    polish: '',
    french: '',
    spanish: 'atacar',
  },
  {
    av: 25263,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(make-believe person + bat (animal))',
    english: 'Batman',
    swedish: 'Batman, Läderlappen',
    norwegian: 'Batman',
    finnish: 'Lepakkomies, Batman',
    hungarian: '',
    german: 'Batman',
    dutch: 'batman',
    afrikaans: 'Batman',
    russian: 'Бэтмен',
    latvian: 'Betmens',
    polish: '',
    french: '',
    spanish: 'Batman',
  },
  {
    av: 25264,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(louse, stinging insect + indoor)',
    english: 'bedbug, wall louse',
    swedish: 'vägglus',
    norwegian: 'vegglus',
    finnish: 'seinälude, lutikka',
    hungarian: '',
    german: 'Bettwanze',
    dutch: 'wandluis',
    afrikaans: 'weeluis luis',
    russian: 'клоп',
    latvian: 'blakts',
    polish: '',
    french: '',
    spanish: 'chinches',
  },
  {
    av: 25265,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + earth, ground, land + snow: combination of brown and white)',
    english: 'beige',
    swedish: 'beige',
    norwegian: 'beige',
    finnish: 'beige, beesi',
    hungarian: '',
    german: 'beige',
    dutch: 'beige',
    afrikaans: 'beige',
    russian: 'бежевый',
    latvian: 'smilškrāsa, bēšs',
    polish: '',
    french: '',
    spanish: 'beige',
  },
  {
    av: 25266,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + skies + gun)',
    english: 'biathlon',
    swedish: 'skidskytte',
    norwegian: 'skiskyting',
    finnish: 'ampumahiihto',
    hungarian: '',
    german: 'Biathlon',
    dutch: 'biathlon',
    afrikaans: 'biathlon, tweekamp',
    russian: 'биатлон',
    latvian: 'biatlons',
    polish: '',
    french: '',
    spanish: 'biathlon',
  },
  {
    av: 25268,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(give + peace + protection + action indicator)',
    english: 'bless-(to)',
    swedish: 'välsigna',
    norwegian: 'velsigne',
    finnish: 'siunata',
    hungarian: '',
    german: 'segnen',
    dutch: 'zegenen',
    afrikaans: 'seën (om te)',
    russian: 'благословить',
    latvian: 'svētīt',
    polish: '',
    french: '',
    spanish: 'bendecir',
  },
  {
    av: 25269,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(opinion + action indicator)',
    english: 'have a view, have an opinion-(to)',
    swedish: 'tycka, anse, mena, ha åsikt om',
    norwegian: 'mene, synes',
    finnish: 'olla jotakin mieltä',
    hungarian: '',
    german: 'meinen, eine Meinung haben, eine Ansicht haben',
    dutch: 'mening hebben',
    afrikaans: 'om opinie te hê',
    russian: 'иметь мнение',
    latvian: 'uzskats, viedoklis',
    polish: '',
    french: '',
    spanish: 'opinar',
  },
  {
    av: 25270,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + airplane)',
    english: 'cabin (airplane)',
    swedish: 'kabin (flygplan)',
    norwegian: 'flykabin',
    finnish: 'lentokoneen matkustamo',
    hungarian: '',
    german: 'Kabine',
    dutch: 'cabine (vliegtuig)',
    afrikaans: 'kajuit (vliegtuig)',
    russian: 'кабина (самолет)',
    latvian: 'lidmašīnas kabīne',
    polish: '',
    french: '',
    spanish: 'cabin (avión)',
  },
  {
    av: 25271,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(cloth + reclining, lying (person lying down): can be viewed as a combination of rug, carpet, mat and reclining)',
    english: 'camping mat, sleeping mat',
    swedish: 'liggunderlag',
    norwegian: 'liggeunderlag',
    finnish: 'makuualusta, kenttäpatja, retkipatja',
    hungarian: '',
    german: 'Schlafmatte, Isoliermatte',
    dutch: 'slaapmat',
    afrikaans: 'kamp mat, slaap mat',
    russian: 'туристический коврик',
    latvian: 'tūristu paklājs',
    polish: '',
    french: '',
    spanish: 'colchoneta de dormir',
  },
  {
    av: 25272,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(stove + carry)',
    english: 'camping stove',
    swedish: 'campingkök, stormkök',
    norwegian: 'grill (flyttbar)',
    finnish: 'retkikeitin',
    hungarian: '',
    german: 'Kocher',
    dutch: 'kampeervuur, camping vuur',
    afrikaans: 'kamp stoof',
    russian: 'походная печь',
    latvian: 'tūristu plītiņa',
    polish: '',
    french: '',
    spanish: 'estufa de camping',
  },
  {
    av: 25273,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(knife + shape + action indicator)',
    english: 'carve-(to)',
    swedish: 'tälja, rista',
    norwegian: 'skjære ut, snitte, spikke',
    finnish: 'veistää, vuolla',
    hungarian: '',
    german: 'schnitzen, einschneiden',
    dutch: 'kerven',
    afrikaans: 'kerf, uitsny (om te)',
    russian: 'вырезать',
    latvian: 'grebt, izgrebt',
    polish: '',
    french: '',
    spanish: 'tallar',
  },
  {
    av: 25274,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(forward + forward) – Character (sequenced)',
    english: 'chase',
    swedish: 'jagande, jakt',
    norwegian: 'forfølgelse, jakt',
    finnish: 'takaa-ajaminen',
    hungarian: '',
    german: 'verfolgen, jagen',
    dutch: 'jacht, achtervolging',
    afrikaans: 'jaag',
    russian: 'погоня',
    latvian: 'vajāt, sekot',
    polish: '',
    french: '',
    spanish: 'persecución',
  },
  {
    av: 25275,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(chase + action indicator)',
    english: 'chase-(to)',
    swedish: 'jaga, följa efter',
    norwegian: 'forfølge, jakte',
    finnish: 'ajaa takaa',
    hungarian: '',
    german: 'jagen, verfolgen',
    dutch: 'jagen, achtervolgen',
    afrikaans: 'jaag (om te)',
    russian: 'преследовать, гнаться',
    latvian: 'vajāt, sekot, dzīties pakaļ',
    polish: '',
    french: '',
    spanish: 'seguir, perseguir',
  },
  {
    av: 25276,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(alphabet, letters (lowercase) + secret)',
    english: 'cipher',
    swedish: 'chiffer, kryptering',
    norwegian: 'hemmelig skrift, kryptering',
    finnish: 'salakirjoitus',
    hungarian: '',
    german: 'Ziffer, Chiffre, Geheimschrift',
    dutch: 'geheimschrift, codetaal',
    afrikaans: 'kodering',
    russian: 'шифр',
    latvian: 'šifrs, kods',
    polish: '',
    french: '',
    spanish: 'código',
  },
  {
    av: 25277,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(enclosure + description indicator)',
    english: 'closed',
    swedish: 'stängd',
    norwegian: 'lukket',
    finnish: 'suljettu',
    hungarian: '',
    german: 'geschlossen, zu',
    dutch: 'gesloten',
    afrikaans: 'gesluit',
    russian: 'закрытый',
    latvian: 'slēgts',
    polish: '',
    french: '',
    spanish: 'cerrado',
  },
  {
    av: 25278,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(information + to + answer)',
    english: 'clue',
    swedish: 'ledtråd',
    norwegian: 'spor, ledetråd, holdepunkt',
    finnish: 'johtolanka',
    hungarian: '',
    german: 'Anhaltspunkt, Schlüssel',
    dutch: 'aanwijzing, hint',
    afrikaans: 'leidraad',
    russian: 'подсказка, ключ к разгадке',
    latvian: 'pavediens, uzvedinājums',
    polish: '',
    french: '',
    spanish: 'pista ',
  },
  {
    av: 25279,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(son + sibling(s) + parent: the son of an uncle or aunt)',
    english: 'cousin (male)',
    swedish: 'kusin (manlig)',
    norwegian: 'fetter',
    finnish: 'serkku (mies)',
    hungarian: '',
    german: 'Vetter, Cousin (männlich)',
    dutch: 'kozijn (Vl), neef',
    afrikaans: 'neef',
    russian: 'кузин, двоюродный брат',
    latvian: 'brālēns',
    polish: '',
    french: '',
    spanish: 'primo',
  },
  {
    av: 25280,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(daughter + sibling(s) + parent: the son of an uncle or aunt)',
    english: 'cousin (female)',
    swedish: 'kusin (kvinnlig)',
    norwegian: 'kusine',
    finnish: 'serkku (nainen)',
    hungarian: '',
    german: 'Cousine (weiblich)',
    dutch: 'nicht',
    afrikaans: 'niggie',
    russian: 'кузина, двоюродная сестра',
    latvian: 'māsīca',
    polish: '',
    french: '',
    spanish: 'prima',
  },
  {
    av: 25281,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(electric current + forward)',
    english: 'direct current, DC',
    swedish: 'likström',
    norwegian: 'likestrøm',
    finnish: 'tasavirta',
    hungarian: '',
    german: 'Gleichstrom',
    dutch: 'gelijkstroom',
    afrikaans: 'direkte stroom (DC)',
    russian: 'постоянный ток',
    latvian: 'līdzstrāva',
    polish: '',
    french: '',
    spanish: 'corriente continua',
  },
  {
    av: 25282,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cylinder + breathing)',
    english: 'cylinder for breathing',
    swedish: 'syrgastub',
    norwegian: 'pusterør',
    finnish: 'happisäiliö, ilmasäiliö, happipullo',
    hungarian: '',
    german: 'Sauerstoffmaske',
    dutch: 'ademhalingscanule',
    afrikaans: 'silinder vir asemhaling',
    russian: 'кислородный баллон',
    latvian: 'elpošanas maska',
    polish: '',
    french: '',
    spanish: 'tubo de oxígeno',
  },
  {
    av: 25285,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(memory + digits (computer))',
    english: 'digital memory, RAM',
    swedish: 'minne (digitalt), RAM-minne',
    norwegian: 'RAM, digitalt minne',
    finnish: 'digitaalinen muisti, keskusmuisti',
    hungarian: '',
    german: 'Digitalspeicher',
    dutch: 'digitaal geheugen, RAM',
    afrikaans: 'digitale geheue, RAM',
    russian: 'цифровая память, RAM',
    latvian: 'elektroniska, digitāla atmiņa, RAM',
    polish: '',
    french: '',
    spanish: 'memoria digital',
  },
  {
    av: 25286,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + pyramid)',
    english: 'Egypt',
    swedish: 'Egypten',
    norwegian: 'Egypt',
    finnish: 'Egypti',
    hungarian: '',
    german: 'Ägypten',
    dutch: 'Egypte',
    afrikaans: 'Egipte',
    russian: 'Египет',
    latvian: 'Ēģipte',
    polish: '',
    french: '',
    spanish: 'Egipto',
  },
  {
    av: 25287,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ring + electricity)',
    english: 'electric circuit',
    swedish: 'elektrisk krets',
    norwegian: 'strømkrets',
    finnish: 'virtapiiri',
    hungarian: '',
    german: '(elektrischer) Schaltkreis',
    dutch: 'elektrisch circuit',
    afrikaans: 'elektriese stroombaan',
    russian: 'электрическая цепь',
    latvian: 'elektriskā strāva',
    polish: '',
    french: '',
    spanish: 'circuito eléctrico',
  },
  {
    av: 25289,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(stream + electricity)',
    english: 'electric current',
    swedish: 'elektrisk ström, ström (elektrisk)',
    norwegian: 'elektrisitet, strøm (elektrisk)',
    finnish: 'sähkövirta',
    hungarian: '',
    german: 'Strom, elektrische Stromstärke',
    dutch: 'elektrische stroom',
    afrikaans: 'elektriese stroom',
    russian: 'электрический ток',
    latvian: 'elektriskā strāva',
    polish: '',
    french: '',
    spanish: 'corriente eléctrica',
  },
  {
    av: 25291,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(impermeable material, insulation (material) + electricity)',
    english: 'electric insulator, electrical insulator',
    swedish: 'elektrisk isolator, isolator (elektricitet)',
    norwegian: 'elektrisk isolator',
    finnish: 'sähköeriste',
    hungarian: '',
    german: 'elektrischer Isolator ',
    dutch: 'elektrische isolator',
    afrikaans: 'elektriese isolator',
    russian: 'электрический изолятор',
    latvian: 'elektroizolācija, elektrības izolators',
    polish: '',
    french: '',
    spanish: 'aislador eléctrico',
  },
  {
    av: 25292,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + magnetism + electricity)',
    english: 'electro magnet',
    swedish: 'elektromagnet',
    norwegian: 'elektromagnet',
    finnish: 'sähkömagneetti',
    hungarian: '',
    german: 'Elektromagnetismus ',
    dutch: 'elektro magneet',
    afrikaans: 'elektromagneet',
    russian: 'электромагнит',
    latvian: 'elektromagnēts',
    polish: '',
    french: '',
    spanish: 'electroimán',
  },
  {
    av: 25293,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(before + marriage)',
    english: 'engagement',
    swedish: 'förlovning',
    norwegian: 'forlovelse',
    finnish: 'kihlaus',
    hungarian: '',
    german: 'Verlobung',
    dutch: 'verloving',
    afrikaans: 'verlowing',
    russian: 'помолвка',
    latvian: 'saderināšanās',
    polish: '',
    french: '',
    spanish: 'compromiso',
  },
  {
    av: 25295,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + Estonia)',
    english: 'Estonian (language)',
    swedish: 'estniska',
    norwegian: 'estonisk',
    finnish: 'viro (kieli)',
    hungarian: '',
    german: 'Estnisch (Sprache)',
    dutch: 'Estonisch (taal)',
    afrikaans: 'Estonian (taal)',
    russian: 'эстонский язык',
    latvian: 'Igaunija',
    polish: '',
    french: '',
    spanish: 'Estonio (idioma)',
  },
  {
    av: 25296,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + engagement)',
    english: 'fiance, groom-to-be',
    swedish: 'fästman',
    norwegian: 'brudgom',
    finnish: 'sulhanen',
    hungarian: '',
    german: 'Verlobter',
    dutch: 'verloofde (man)',
    afrikaans: 'verloofde (man) aanstaande bruidgom',
    russian: 'жених',
    latvian: 'līgavainis, nākamais vīrs',
    polish: '',
    french: '',
    spanish: 'novio, novio-a-ser',
  },
  {
    av: 25297,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(woman + engagement)',
    english: 'fiancee, bride-to-be',
    swedish: 'fästmö',
    norwegian: 'brud',
    finnish: 'morsian',
    hungarian: '',
    german: 'Verlobte',
    dutch: 'verloofde (vrouw)',
    afrikaans: 'verloofde (vrou), aanstaande bruid',
    russian: 'невеста',
    latvian: 'līgava, nākamā sieva',
    polish: '',
    french: '',
    spanish: 'novia, novia-a-ser',
  },
  {
    av: 25298,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(imprint + finger)',
    english: 'fingerprint',
    swedish: 'fingeravtryck',
    norwegian: 'fingeravtrykk',
    finnish: 'sormenjälki',
    hungarian: '',
    german: 'Fingerabdruck',
    dutch: 'vingerafdruk',
    afrikaans: 'vingerafdruk',
    russian: 'отпечаток пальца',
    latvian: 'pirkstu nospiedumi',
    polish: '',
    french: '',
    spanish: 'huella dactilar',
  },
  {
    av: 25299,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + Finnish)',
    english: 'Finnish (class)',
    swedish: 'finska (skolämne)',
    norwegian: 'finsk (fag)',
    finnish: 'suomi (kouluaine)',
    hungarian: '',
    german: 'Finnisch (Schulfach)',
    dutch: 'Finse (les)',
    afrikaans: 'Finse (klas)',
    russian: 'финский язык (предмет)',
    latvian: 'somu valodas nodarbība',
    polish: '',
    french: '',
    spanish: 'Finlandés (clase)',
  },
  {
    av: 25300,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + Finland [contr.])',
    english: 'Finnish (language)',
    swedish: 'finska',
    norwegian: 'finsk (språk)',
    finnish: 'suomi (kieli)',
    hungarian: '',
    german: 'Finnisch (Sprache)',
    dutch: 'Fins',
    afrikaans: 'Fins (taal)',
    russian: 'финский язык',
    latvian: 'somu valoda',
    polish: '',
    french: '',
    spanish: 'Finlandés (idioma), fines',
  },
  {
    av: 25301,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cylinder + extinction, extinguishing (fire))',
    english: 'fire extinguisher',
    swedish: 'brandsläckare',
    norwegian: 'brannslokningsapparat',
    finnish: 'palosammutin',
    hungarian: '',
    german: 'Hydrant, Feuerlöscher',
    dutch: 'brandblusser, brandblusapparaat',
    afrikaans: 'brandblusser',
    russian: 'огнетушитель',
    latvian: 'ugusndzēsējs',
    polish: '',
    french: '',
    spanish: 'extintor de incendios',
  },
  {
    av: 25302,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + stove)',
    english: 'fire place, campfire site',
    swedish: 'eldstad',
    norwegian: 'bålplass',
    finnish: 'nuotion paikka',
    hungarian: '',
    german: 'Feuerstelle',
    dutch: 'kampvuurplaats',
    afrikaans: 'kampvuur plek, boma',
    russian: 'камин, мангал',
    latvian: 'kamīns',
    polish: '',
    french: '',
    spanish: 'hogar, sitio fogata',
  },
  {
    av: 25303,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knowledge + activity + fire)',
    english: 'firecraft',
    swedish: 'eldkunskap',
    norwegian: 'ildingskunnskap, fyringskunnskap',
    finnish: 'leirinuotio',
    hungarian: '',
    german: 'Feuerkunst',
    dutch: 'kunst (vuur)',
    afrikaans: 'vuur kuns',
    russian: 'пожарная безопаснолсть',
    latvian: 'ugunsdzēsība',
    polish: '',
    french: '',
    spanish: 'conocimiento para con el fuego',
  },
  {
    av: 25304,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(medical aid + first + thing indicator)',
    english: 'first aid kit',
    swedish: 'första hjälpen',
    norwegian: 'førstehjelp',
    finnish: 'ensiapu',
    hungarian: '',
    german: 'Erste Hilfe',
    dutch: 'eerste hulp bij ongevallen',
    afrikaans: 'noodhulp',
    russian: 'первая помощь',
    latvian: 'pirmā palīdzība',
    polish: '',
    french: '',
    spanish: 'primeros auxilios',
  },
  {
    av: 25305,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bone + fish)',
    english: 'fish bone',
    swedish: 'fiskben',
    norwegian: 'fiskeben',
    finnish: 'kalanruoto',
    hungarian: '',
    german: 'Gräte',
    dutch: 'graat (vis)',
    afrikaans: 'graat (vis)',
    russian: 'рыбная кость',
    latvian: 'asaka',
    polish: '',
    french: '',
    spanish: 'espina de pescado',
  },
  {
    av: 25306,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + airplane + thing indicator)',
    english: 'flight instrument(s)',
    swedish: 'flygplansinstrument',
    norwegian: 'flyinstrument',
    finnish: 'lentokoneen mittaristo',
    hungarian: '',
    german: 'Flugzeugarmatur',
    dutch: 'boordinstrumenten (vliegtuig)',
    afrikaans: 'vlug instrument',
    russian: 'авиационный прибор',
    latvian: 'lidojuma instrumenti',
    polish: '',
    french: '',
    spanish: 'instrumentos de vuelo',
  },
  {
    av: 25307,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + pilot)',
    english: 'flight deck, cockpit',
    swedish: 'cockpit',
    norwegian: 'cockpit',
    finnish: 'lentokoneen ohjaamo',
    hungarian: '',
    german: 'Cockpit, Flugdeck',
    dutch: 'cockpit (vliegtuig)',
    afrikaans: 'kajuit, cockpit (vliegtuig)',
    russian: 'место для пилота, кокпит',
    latvian: 'lidmašīnas vadības kabīne',
    polish: '',
    french: '',
    spanish: 'cabina de piloto',
  },
  {
    av: 25308,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(imprint, trace, track + foot)',
    english: 'footprint',
    swedish: 'fotspår, fotavtryck',
    norwegian: 'fotavtrykk',
    finnish: 'jalanjälki',
    hungarian: '',
    german: 'Fußabdruck, Fußstapfen',
    dutch: 'voetafdruk',
    afrikaans: 'voetspoor',
    russian: 'след, отпечаток стопы',
    latvian: 'kāju nospiedumi',
    polish: '',
    french: '',
    spanish: 'huella',
  },
  {
    av: 25309,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + France [contr.])',
    english: 'French (language)',
    swedish: 'franska',
    norwegian: 'fransk (språk)',
    finnish: 'ranska (kieli)',
    hungarian: '',
    german: 'Französisch (Sprache)',
    dutch: 'Frans',
    afrikaans: 'Frans (taal)',
    russian: 'французский язык',
    latvian: 'franču valoda',
    polish: '',
    french: '',
    spanish: 'Francés (idioma)',
  },
  {
    av: 25310,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(frequency + wave)',
    english: 'frequency (wave motion)',
    swedish: 'frekvens (vågrörelse)',
    norwegian: 'frekvens (bølgebevegelse)',
    finnish: 'aalto (fysiikka)',
    hungarian: '',
    german: 'Frequenz (Wellenbewegung)',
    dutch: 'frequentie',
    afrikaans: 'frekwensie (golfbeweging)',
    russian: 'частота волн',
    latvian: 'biežums (viļņu kustība)',
    polish: '',
    french: '',
    spanish: 'frecuencia (movimiento de las olas)',
  },
  {
    av: 25312,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(feeling + full + food + description indicator)',
    english: 'full, satisfied',
    swedish: 'mätt',
    norwegian: 'tilfreds, fornøyd, mett',
    finnish: 'kylläinen',
    hungarian: '',
    german: 'voll, zufrieden',
    dutch: 'voldaan',
    afrikaans: 'voldaan, versadig',
    russian: 'сытый',
    latvian: 'apmierināts, pārpilns',
    polish: '',
    french: '',
    spanish: 'lleno, satisfecho ',
  },
  {
    av: 25313,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + protection + electricity)',
    english: 'fuse',
    swedish: 'propp, säkring',
    norwegian: 'sikring',
    finnish: 'sulake',
    hungarian: '',
    german: 'Sicherung (elektrisch)',
    dutch: 'zekering',
    afrikaans: 'smeltdraad',
    russian: 'предохранитель',
    latvian: 'drošinātājs',
    polish: '',
    french: '',
    spanish: 'fusible',
  },
  {
    av: 25314,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(body + airplane)',
    english: 'fuselage',
    swedish: 'flygplanskropp',
    norwegian: 'flykropp',
    finnish: 'lentokoneen runko',
    hungarian: '',
    german: 'Flugzeugrumpf',
    dutch: 'romp (vliegtuig)',
    afrikaans: 'romp',
    russian: 'фюзеляж',
    latvian: 'fizelāža',
    polish: '',
    french: '',
    spanish: 'fuselaje',
  },
  {
    av: 25315,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cylinder + gas)',
    english: 'gas cylinder',
    swedish: 'gastub',
    norwegian: 'gassbeholder',
    finnish: 'kaasupullo',
    hungarian: '',
    german: 'Gasflasche',
    dutch: 'gascylinder',
    afrikaans: 'gassilinder',
    russian: 'газовый баллон',
    latvian: 'gāzes balons',
    polish: '',
    french: '',
    spanish: 'cilindro de gas',
  },
  {
    av: 25316,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gathering + scouting)',
    english: 'gathering of scouts, jamboree',
    swedish: 'scoutmöte, jamboree',
    norwegian: 'speiderleir, speidermøte',
    finnish: 'partioleiri, jamboree',
    hungarian: '',
    german: 'Pfadfindertreffen',
    dutch: 'scoutsvergadering, jamboree',
    afrikaans: 'verkennerssvergadering (bymekaarkoms van verkenners)',
    russian: 'слёт скаутов',
    latvian: 'skautu salidojums, džamboreja',
    polish: '',
    french: '',
    spanish: 'junta de exploradores',
  },
  {
    av: 25317,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(garage + airplane)',
    english: 'hangar',
    swedish: 'hangar',
    norwegian: 'hangar',
    finnish: 'lentokonehalli, hangaari',
    hungarian: '',
    german: 'Flugzeughalle, Hangar',
    dutch: 'vliegtuighangaar',
    afrikaans: 'vliegtuighangaar',
    russian: 'авиационный ангар',
    latvian: 'pakaramais',
    polish: '',
    french: '',
    spanish: 'hangar',
  },
  {
    av: 25318,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(louse, stinging insect + hair)',
    english: 'head louse',
    swedish: 'huvudlus',
    norwegian: 'hodelus',
    finnish: 'päätäi',
    hungarian: '',
    german: 'Kopflaus',
    dutch: 'hoofdluis',
    afrikaans: 'kopluis',
    russian: 'головная вошь',
    latvian: 'matu uts',
    polish: '',
    french: '',
    spanish: 'piojo',
  },
  {
    av: 25319,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(earmuffs + signal)',
    english: 'headset',
    swedish: 'headset',
    norwegian: 'hodetelefon, headset',
    finnish: 'headsetti, kuulokemikrofoni, kuulokesetti, sankaluuri',
    hungarian: '',
    german: 'Kopfhörer',
    dutch: 'koptelefoon',
    afrikaans: 'kopstuk',
    russian: 'наушник, гарнитура',
    latvian: 'radioaustiņas, austiņas',
    polish: '',
    french: '',
    spanish: 'auriculares',
  },
  {
    av: 25320,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hiking + action indicator)',
    english: 'hike-(to)',
    swedish: 'vandra',
    norwegian: 'gå fottur',
    finnish: 'patikoida, vaeltaa',
    hungarian: '',
    german: 'wandern',
    dutch: 'wandelen',
    afrikaans: 'stap (om te)',
    russian: 'ходить в поход, путешествовать',
    latvian: 'doties pārgājienā',
    polish: '',
    french: '',
    spanish: 'caminar',
  },
  {
    av: 25321,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + legs and feet + open)',
    english: 'hiking',
    swedish: 'vandring',
    norwegian: 'fottur',
    finnish: 'patikointi, vaellus',
    hungarian: '',
    german: 'Bergwandern, Wandern',
    dutch: 'wandeling',
    afrikaans: 'stap',
    russian: 'поход',
    latvian: 'pāgājiens',
    polish: '',
    french: '',
    spanish: 'caminata',
  },
  {
    av: 25322,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + ice + fire: ice + fire representing Iceland [contr.])',
    english: 'Icelandic (language)',
    swedish: 'isländska',
    norwegian: 'islandsk-(språk)',
    finnish: 'islanti (kieli)',
    hungarian: '',
    german: 'Isländisch (Sprache)',
    dutch: 'Ijslands',
    afrikaans: 'Yslands (taal)',
    russian: 'исландский язык',
    latvian: 'islandiešu valoda',
    polish: '',
    french: '',
    spanish: 'Islandes (idioma)',
  },
  {
    av: 25323,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(illustrtion + action indicator)',
    english: 'illustrate-(to)',
    swedish: 'illustrera',
    norwegian: 'illustrere, belyse',
    finnish: 'kuvittaa',
    hungarian: '',
    german: 'darstellen, illustrieren',
    dutch: 'illustreren',
    afrikaans: 'illustreer (om te)',
    russian: 'иллюстрировать',
    latvian: 'ilustrēt',
    polish: '',
    french: '',
    spanish: 'ilustrar',
  },
  {
    av: 25324,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(illustrtion + description indicator)',
    english: 'illustrated, illustrating',
    swedish: 'illustrerad',
    norwegian: 'illustrert, belyst',
    finnish: 'kuvitettu',
    hungarian: '',
    german: 'illustriert, erklärt',
    dutch: 'geïllustreerd',
    afrikaans: 'geïllustreerd',
    russian: 'иллюстрированный',
    latvian: 'ilustrēts, ilustrēšana',
    polish: '',
    french: '',
    spanish: 'ilustrado, ',
  },
  {
    av: 25325,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(making, production, fashioning + picture)',
    english: 'illustration',
    swedish: 'illustration',
    norwegian: 'illustrasjon',
    finnish: 'kuvitus',
    hungarian: '',
    german: 'Illustration, Bild',
    dutch: 'illustratie',
    afrikaans: 'illustrasie',
    russian: 'иллюстрация',
    latvian: 'ilustrācija',
    polish: '',
    french: '',
    spanish: 'ilustración',
  },
  {
    av: 25326,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + stop)',
    english: 'impermeable material, insulation (material)',
    swedish: 'isolering (material)',
    norwegian: 'ugjennomtrengelig materiale, isolasjonsmateriale',
    finnish: 'läpäisemätön aine',
    hungarian: '',
    german: 'undurchlässiges Material, Isolation (Material)',
    dutch: 'ondoorlaatbaar materiaal, isolatie (materiaal)',
    afrikaans: 'ondeurdringbare materiaal, insulasie',
    russian: 'непроницаемый материал, изоляция',
    latvian: 'necaurlaidīgs materiāls, izolācija',
    polish: '',
    french: '',
    spanish: 'material impermeable, aislante (material)',
  },
  {
    av: 25327,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(effekt + bump, press, pressing)',
    english: 'imprint, trace, track',
    swedish: 'avtryck, spår',
    norwegian: 'avtrykk, spor',
    finnish: 'jälki',
    hungarian: '',
    german: 'Aufdruck, Abdruck, Spur, ',
    dutch: 'afdruk, spoor (afdruk)',
    afrikaans: 'afdruk, spoor',
    russian: 'отпечаток',
    latvian: 'nospiedums, pēdas',
    polish: '',
    french: '',
    spanish: 'impresión, pie de imprenta',
  },
  {
    av: 25328,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(medical aid + breath)',
    english: 'inhaler',
    swedish: 'inhalator',
    norwegian: 'inhalator',
    finnish: 'astmapiippu, inhalaattori',
    hungarian: '',
    german: 'inhalieren',
    dutch: 'inhalator',
    afrikaans: 'inhaleerder',
    russian: 'ингалятор',
    latvian: 'inhalators',
    polish: '',
    french: '',
    spanish: 'inhalador',
  },
  {
    av: 25329,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(state of mind + without + sleep)',
    english: 'insomnia',
    swedish: 'sömnlöshet, insomnia',
    norwegian: 'søvnløshet',
    finnish: 'unettomuus',
    hungarian: '',
    german: 'Schlafstörung',
    dutch: 'slapeloosheid',
    afrikaans: 'slapeloosheid',
    russian: 'бессонница ',
    latvian: 'bezmiegs',
    polish: '',
    french: '',
    spanish: 'insomnio',
  },
  {
    av: 25330,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + poetry)',
    english: 'Iran',
    swedish: 'Iran',
    norwegian: 'Iran',
    finnish: 'Iran',
    hungarian: '',
    german: 'Iran',
    dutch: 'Iran',
    afrikaans: 'Iran',
    russian: 'Иран',
    latvian: 'Irāna',
    polish: '',
    french: '',
    spanish: 'Irán',
  },
  {
    av: 25331,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + shamrock: shamrock representing Ireland [contr.])',
    english: 'Irish (language)',
    swedish: 'irländska',
    norwegian: 'irsk (språk)',
    finnish: 'irlanti (kieli)',
    hungarian: '',
    german: 'Irisch (Sprache)',
    dutch: 'Iers (taal)',
    afrikaans: 'Iers (taal)',
    russian: 'ирландский язык',
    latvian: 'īru valoda',
    polish: '',
    french: '',
    spanish: 'Irlandés (idioma)',
  },
  {
    av: 25332,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + opera: opera representing Italy [contr.])',
    english: 'Italian (language)',
    swedish: 'italienska',
    norwegian: 'italiensk (språk)',
    finnish: 'italia (kieli)',
    hungarian: '',
    german: 'Italienisch (Sprache)',
    dutch: 'Italiaans (taal)',
    afrikaans: 'Italiaans (taal)',
    russian: 'итальянский язык',
    latvian: 'itāļu valoda',
    polish: '',
    french: '',
    spanish: 'Italiano (idioma)',
  },
  {
    av: 25333,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bug + dot)',
    english: 'ladybird',
    swedish: 'nyckelpiga',
    norwegian: 'marihøne',
    finnish: 'leppäkerttu',
    hungarian: '',
    german: 'Marienkäfer',
    dutch: 'lieveheersbeestje',
    afrikaans: 'liewenheersbesie',
    russian: 'божья коровка',
    latvian: 'mārīte',
    polish: '',
    french: '',
    spanish: 'vaca de San Antón, mariquita',
  },
  {
    av: 25334,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wheel + airplane)',
    english: 'landing gear',
    swedish: 'landningsställ',
    norwegian: 'landingshjul',
    finnish: 'laskuteline',
    hungarian: '',
    german: 'Fahrwerk, Landungsgestell',
    dutch: 'landingsgestel',
    afrikaans: 'landingsgestel',
    russian: 'шасси',
    latvian: 'šasija',
    polish: '',
    french: '',
    spanish: 'tren de aterrizaje',
  },
  {
    av: 25335,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(strap, string, velcro, rope, cord + help)',
    english: 'lifeline',
    swedish: 'livlina, räddningslina',
    norwegian: 'livline, redningsline',
    finnish: 'turvaköysi',
    hungarian: '',
    german: 'Rettungsleine',
    dutch: 'reddingstouw',
    afrikaans: 'reddingsboei, lewenslyn',
    russian: 'спасательный трос',
    latvian: 'glābšanas virve',
    polish: '',
    french: '',
    spanish: 'línea de vida',
  },
  {
    av: 25336,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(weight + little + description indicator)',
    english: 'light (weight)',
    swedish: 'lätt (vikt)',
    norwegian: 'lett (vekt)',
    finnish: 'kevyt',
    hungarian: '',
    german: 'leicht (Gewicht)',
    dutch: 'licht (gewicht)',
    afrikaans: 'lig (gewig)',
    russian: 'лёгкий',
    latvian: 'viegls (svars)',
    polish: '',
    french: '',
    spanish: 'ligero',
  },
  {
    av: 25337,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + water)',
    english: 'liquid',
    swedish: 'vätska',
    norwegian: 'væske',
    finnish: 'neste',
    hungarian: '',
    german: 'Flüssigkeit',
    dutch: 'vloeistof',
    afrikaans: 'vloeistof',
    russian: 'жидкость',
    latvian: 'šķidrums',
    polish: '',
    french: '',
    spanish: 'líquido',
  },
  {
    av: 25338,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + magnetism)',
    english: 'magnet',
    swedish: 'magnet',
    norwegian: 'magnet',
    finnish: 'magneetti',
    hungarian: '',
    german: 'Magnet',
    dutch: 'magneet',
    afrikaans: 'magneet',
    russian: 'магнит',
    latvian: 'magnēts',
    polish: '',
    french: '',
    spanish: 'imán',
  },
  {
    av: 25341,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(activity + fire + action indicator)',
    english: 'make and tend a fire-(to)',
    swedish: 'elda, göra upp eld',
    norwegian: 'gjøre opp ild, tenne',
    finnish: 'tehdä ja ylläpitää tulta',
    hungarian: '',
    german: 'ein Feuer machen (und es unterhalten)',
    dutch: 'vuur maken en bewaken',
    afrikaans: 'om vuur te maak',
    russian: 'разжечь огонь',
    latvian: 'pielaist uguni',
    polish: '',
    french: '',
    spanish: 'hacer fuego, hacer una fogata',
  },
  {
    av: 25342,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(medicine + breath)',
    english: 'medication for breathing',
    swedish: 'astmamedicin, andningsmedicin',
    norwegian: 'pustemedisin',
    finnish: 'hengityslääke',
    hungarian: '',
    german: 'Inhalator (Asthma)',
    dutch: 'medicatie om te ademen',
    afrikaans: 'medikasie vir asemhaling',
    russian: 'противоастмастический препарат',
    latvian: 'elpošanas medikamenti',
    polish: '',
    french: '',
    spanish: 'medicamento para la respiración',
  },
  {
    av: 25343,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(game [contr.] + memory)',
    english: "memory game, Kim's game",
    swedish: 'minneslek, Kims lek',
    norwegian: 'memoryspill, Kims lek',
    finnish: 'muistipeli, kim-peli',
    hungarian: '',
    german: 'Memory (Spiel)',
    dutch: 'memory (spel)',
    afrikaans: 'geheue speletjie',
    russian: 'игра для развития памяти',
    latvian: 'atmiņas spēle, Kima spēle',
    polish: '',
    french: '',
    spanish: 'juego de memoria, juego de Kim',
  },
  {
    av: 25344,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(country + descripton indicator)',
    english: 'national',
    swedish: 'nationell',
    norwegian: 'nasjonal',
    finnish: 'kansallinen',
    hungarian: '',
    german: 'national',
    dutch: 'nationaal',
    afrikaans: 'nasionale ',
    russian: 'национальный',
    latvian: 'nacionāls, -a',
    polish: '',
    french: '',
    spanish: 'nacional',
  },
  {
    av: 25345,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + country)',
    english: 'national day',
    swedish: 'nationaldag',
    norwegian: 'nasjonaldag',
    finnish: 'kansallispäivä',
    hungarian: '',
    german: 'Nationalfeiertag',
    dutch: 'nationale dag, nationale feestdag',
    afrikaans: 'nasionale dag',
    russian: 'национальный праздник',
    latvian: 'valsts svētki',
    polish: '',
    french: '',
    spanish: 'Día Nacional',
  },
  {
    av: 25346,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(activity + sign, signal + airplane + action indicator)',
    english: 'navigate airplane-(to)',
    swedish: 'navigera (flygplan)',
    norwegian: 'flynavigering',
    finnish: 'navigoida (lentokone)',
    hungarian: '',
    german: 'navigieren, lenken, steuern (Flugzeug)',
    dutch: 'navigeren (vliegtuig)',
    afrikaans: 'navigeer vliegtuig (om te)',
    russian: 'управлять самолётом',
    latvian: 'vadīt lidmašīnu',
    polish: '',
    french: '',
    spanish: 'navegar, pilotar',
  },
  {
    av: 25347,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + fjord: fjord representing Norway [contr.])',
    english: 'Norwegian (language)',
    swedish: 'norska',
    norwegian: 'norsk (språk)',
    finnish: 'norja (kieli)',
    hungarian: '',
    german: 'Norwegisch (Sprache)',
    dutch: 'Noors (taal)',
    afrikaans: 'Noors (taal)',
    russian: 'норвежский язык',
    latvian: 'norvēģu valoda',
    polish: '',
    french: '',
    spanish: 'Noruego (idioma)',
  },
  {
    av: 25348,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plan + many + thing)',
    english: 'organization, organizing',
    swedish: 'ordning, organisation, ',
    norwegian: 'organisasjon, organisering',
    finnish: 'organisointi, järjestäminen',
    hungarian: '',
    german: 'Ordnung, Organisation',
    dutch: 'organisatie',
    afrikaans: 'organisasie, organiseer',
    russian: 'порядок, организация',
    latvian: 'organizācija, organizēšana',
    polish: '',
    french: '',
    spanish: 'organizacíon',
  },
  {
    av: 25349,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(orienteering (sport) + action indicator)',
    english: 'orienteer (sport)-(to)',
    swedish: 'orientera (sport)',
    norwegian: 'orientere (sport)',
    finnish: 'suunnistaa (urheilu)',
    hungarian: '',
    german: 'Orientierungslauf (Sport)',
    dutch: 'oriëntatielopen',
    afrikaans: 'oriënteer (sport) (om te)',
    russian: 'ориентироваться на местности (спорт)',
    latvian: 'orientēšanās sports',
    polish: '',
    french: '',
    spanish: 'orientar (deporte)',
  },
  {
    av: 25350,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(map reading + action indicator)',
    english: 'orienteer, read map-(to)',
    swedish: 'läsa kartan, orientera',
    norwegian: 'orientere, lese kart',
    finnish: 'suunnistaa, lukea karttaa',
    hungarian: '',
    german: 'Karte lesen (Orientierungslauf)',
    dutch: 'oriënteren, kaart lezen',
    afrikaans: 'oriënteer (om te), om kaart te lees',
    russian: 'ориентироваться на местности',
    latvian: 'orientēšanās, pārvietošanās pēc azimuta',
    polish: '',
    french: '',
    spanish: 'leer mapa, orientador',
  },
  {
    av: 25351,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + map)',
    english: 'orienteering (sport)',
    swedish: 'orientering (sport)',
    norwegian: 'orientering (sport)',
    finnish: 'suunnistus (urheilu)',
    hungarian: '',
    german: 'Orientierungslauf',
    dutch: 'oriëntatiesport',
    afrikaans: 'oriëntering (sport)',
    russian: 'ориентирование (спорт)',
    latvian: 'orientēšanās sports',
    polish: '',
    french: '',
    spanish: 'orientador (deporte)',
  },
  {
    av: 25352,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + map)',
    english: 'map reading',
    swedish: 'kartläsning, orientering, ',
    norwegian: 'orienteringskart',
    finnish: 'suunnistus, kartan lukeminen',
    hungarian: '',
    german: 'Kartenlesen',
    dutch: 'oriëntatie',
    afrikaans: 'kaartlees',
    russian: 'чтение карты',
    latvian: 'orientēšanās pēc kartes, azimuta',
    polish: '',
    french: '',
    spanish: 'lectura de mapas',
  },
  {
    av: 25354,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(breathing aid + pressure + thing indicator)',
    english: 'PEP mask',
    swedish: 'PEP-mask, andningsmask',
    norwegian: 'PEP maske',
    finnish: 'pep-maski',
    hungarian: '',
    german: 'PEP Maske, Atemmaske, Vollmaske',
    dutch: 'ademhalingsmasker',
    afrikaans: 'veiligheids masker',
    russian: 'PEP маска',
    latvian: 'respirators, PEP maska',
    polish: '',
    french: '',
    spanish: 'PEP máscara',
  },
  {
    av: 25355,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fish + quill(s), spine(s))',
    english: 'perch (fish)',
    swedish: 'abborre',
    norwegian: 'åbor',
    finnish: 'ahven',
    hungarian: '',
    german: 'Barsch',
    dutch: 'baars (vis)',
    afrikaans: 'baars (vis)',
    russian: 'окунь',
    latvian: 'asaris',
    polish: '',
    french: '',
    spanish: 'perca',
  },
  {
    av: 25356,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limited time + wave)',
    english: 'period (wave motion)',
    swedish: 'period (vågrörelse)',
    norwegian: 'periode (bølgevis)',
    finnish: 'aaltoliikkeen jakso',
    hungarian: '',
    german: 'Periode, Zeitraum (Wellenbewegung)',
    dutch: 'getijde',
    afrikaans: 'tydperk (golfbeweging)',
    russian: 'период волны',
    latvian: 'periods (viļņu kustības)',
    polish: '',
    french: '',
    spanish: 'periodo (ondulación)',
  },
  {
    av: 25357,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + through)',
    english: 'permeable material',
    swedish: 'genomsläppligt material',
    norwegian: 'gjennomtrengelig materiale',
    finnish: 'läpäisevä aine',
    hungarian: '',
    german: 'durchlässiges Material',
    dutch: 'doorlaatbaar materiaal',
    afrikaans: 'deurlaatbaar materiaal',
    russian: 'проницаемый материал',
    latvian: 'ūdenscaurlaidīgs materiāls',
    polish: '',
    french: '',
    spanish: 'material permeable',
  },
  {
    av: 25358,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + poetry: poetry representing Iran [contr.]',
    english: 'Persian (language)',
    swedish: 'persiska',
    norwegian: 'persisk (språk)',
    finnish: 'persia (kieli)',
    hungarian: '',
    german: 'Persisch, Farsi (Sprache)',
    dutch: 'Perzisch (taal)',
    afrikaans: 'Persies (taal)',
    russian: 'персидский язык',
    latvian: 'persiešu valoda',
    polish: '',
    french: '',
    spanish: 'persa (idioma)',
  },
  {
    av: 25359,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(measurement + self)',
    english: 'personal measurement',
    swedish: 'personliga mått',
    norwegian: 'personlig mål',
    finnish: 'henkilövaaka',
    hungarian: '',
    german: 'personbezogene (Mess)Grösse',
    dutch: 'lichaamslengte',
    afrikaans: 'persoonlike liggaams meting',
    russian: 'индивидуальные измерения',
    latvian: 'individuālie mērījumi',
    polish: '',
    french: '',
    spanish: 'medida personal',
  },
  {
    av: 25360,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(louse, stinging insect + plant)',
    english: 'plant-louse',
    swedish: 'bladlus',
    norwegian: 'plantelus',
    finnish: 'kirva',
    hungarian: '',
    german: 'Blattlaus',
    dutch: 'plantenluis',
    afrikaans: 'plantluis',
    russian: 'тля',
    latvian: 'laputs',
    polish: '',
    french: '',
    spanish: 'pulgón',
  },
  {
    av: 25363,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(enclosure + ear + signal, broadcast, transmitting: a device for hearing radio transmissions)',
    english: 'radio (2)',
    swedish: 'radio (2)',
    norwegian: 'radio (2)',
    finnish: 'radio',
    hungarian: '',
    german: 'Radio (2)',
    dutch: 'radio (2)',
    afrikaans: 'radio (2)',
    russian: 'радио (2)',
    latvian: 'radio (2)',
    polish: '',
    french: '',
    spanish: 'radio (2)',
  },
  {
    av: 25365,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(quarrel, row + description indicator)',
    english: 'rowdy, raucous',
    swedish: 'stökig, bråkig',
    norwegian: 'pøbelaktig, bråkete',
    finnish: 'sekasortoinen',
    hungarian: '',
    german: 'gewalttätig, rauflustig',
    dutch: 'luidruchtig',
    afrikaans: 'rumoerige, lawaaierige',
    russian: 'шумный, скандальный',
    latvian: 'kauslis, huligāns',
    polish: '',
    french: '',
    spanish: 'desordenado',
  },
  {
    av: 25366,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + airplane + ascending and descending)',
    english: 'runway (airport)',
    swedish: 'landningsbana',
    norwegian: 'rullebane',
    finnish: 'kiitorata',
    hungarian: '',
    german: 'Start- und Landebahn',
    dutch: 'landingsbaan',
    afrikaans: 'aanloopbaan (lughawe)',
    russian: 'посадочная полоса',
    latvian: 'starta ceļš, pacelšanās celiņš (lidmašīnai)',
    polish: '',
    french: '',
    spanish: 'pista de aterrizaje',
  },
  {
    av: 25367,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + Russia)',
    english: 'Russian (language)',
    swedish: 'ryska',
    norwegian: 'russisk (språk)',
    finnish: 'venäjä (kieli)',
    hungarian: '',
    german: 'Russisch (Sprache)',
    dutch: 'Russich (taal)',
    afrikaans: 'Russiese (taal)',
    russian: 'русский язык',
    latvian: 'krievu valoda',
    polish: '',
    french: '',
    spanish: 'ruso (idioma)',
  },
  {
    av: 25368,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(same, equal, equality + description indicator)',
    english: 'equal, same',
    swedish: 'lika, samma',
    norwegian: 'lik, samme',
    finnish: 'samanlainen',
    hungarian: '',
    german: 'gleich, gleichberechtigt, der/die/das Gleiche',
    dutch: 'gelijk, hetzelfde',
    afrikaans: 'gelyk, dieselfde',
    russian: 'одинаковый, равный',
    latvian: 'līdzīgs, līdzvērtīgs, vienāds ar',
    polish: '',
    french: '',
    spanish: 'igual',
  },
  {
    av: 25369,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity center + science)',
    english: 'science centre',
    swedish: 'vetenskapscenter',
    norwegian: 'vitenskapssenter, vitensenter',
    finnish: 'tiedekeskus',
    hungarian: '',
    german: 'Wissenschaftszentrum, Forschungszentrum',
    dutch: 'wetenschapshuis',
    afrikaans: 'wetenskap sentrum',
    russian: 'научный центр',
    latvian: 'zinātniskais centrs',
    polish: '',
    french: '',
    spanish: 'centro de la ciencia',
  },
  {
    av: 25370,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + scouting)',
    english: 'scout (etc)',
    swedish: 'scout',
    norwegian: 'speider',
    finnish: 'partiolainen',
    hungarian: '',
    german: 'Pfadfinder',
    dutch: 'scout',
    afrikaans: 'verkenner',
    russian: 'скаут, следопыт',
    latvian: 'skauts',
    polish: '',
    french: '',
    spanish: 'explorador',
  },
  {
    av: 25371,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knowledge + activity + help)',
    english: 'scouting (etc)',
    swedish: 'scouting',
    norwegian: 'speiding',
    finnish: 'partio',
    hungarian: '',
    german: 'Aufklärungs...',
    dutch: 'scouts',
    afrikaans: 'verkenning',
    russian: 'скаутинг',
    latvian: 'skautu izlūkošana',
    polish: '',
    french: '',
    spanish: 'exploración',
  },
  {
    av: 25372,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + signal, broadcast, transmitting + thing indicator)',
    english: 'signal strength meter',
    swedish: 'signalmätare, mätare för signalstyrka',
    norwegian: 'signalmåler, styrkemåler',
    finnish: 'tasomittari',
    hungarian: '',
    german: 'Signalstärkenmesser',
    dutch: 'sterktemeter signaal',
    afrikaans: 'seinsterkte meter',
    russian: 'измеритель уровня звука',
    latvian: 'singāla stipruma mērītājs',
    polish: '',
    french: '',
    spanish: 'medidor de señal',
  },
  {
    av: 25373,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(feeling + without + sleep + description indicator)',
    english: 'sleepy',
    swedish: 'sömnig',
    norwegian: 'trøtt, søvnig',
    finnish: 'uninen',
    hungarian: '',
    german: 'schläfrig, müde, verschlafen',
    dutch: 'slaperig',
    afrikaans: 'slaperig',
    russian: 'сонный',
    latvian: 'miegains',
    polish: '',
    french: '',
    spanish: 'dormido',
  },
  {
    av: 25374,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dog + nose + information)',
    english: 'sniffer dog',
    swedish: 'spårhund',
    norwegian: 'narkotikahund',
    finnish: 'huumekoira',
    hungarian: '',
    german: 'Spürhund',
    dutch: 'snuffelhond',
    afrikaans: 'snuffelhond',
    russian: 'разыскная собака, ищейка',
    latvian: 'suns pēddzinis (narkotiku, sprāgstvielu u.c.)',
    polish: '',
    french: '',
    spanish: 'perro rastreador',
  },
  {
    av: 25375,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(exchange + digital world + person: digital world representing the Internet (contr.))',
    english: 'social network, facebook (etc)',
    swedish: 'socialt nätverk, Facebook (etc)',
    norwegian: 'sosialt nettverk, facebook (etc)',
    finnish: 'sosiaalinen media, facebook',
    hungarian: '',
    german: 'soziales Netzwerk wie z.B. Facebook',
    dutch: 'sociaal netwerk, facebook',
    afrikaans: 'sosiale netwerk, facebook',
    russian: 'социальная сеть',
    latvian: 'sociālie tīkli, Facebook, Draugiem u.c.',
    polish: '',
    french: '',
    spanish: 'red social, Facebook',
  },
  {
    av: 25376,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + castanet)',
    english: 'Spain',
    swedish: 'Spanien',
    norwegian: 'Spania',
    finnish: 'Espanja',
    hungarian: '',
    german: 'Spanien',
    dutch: 'Spanje',
    afrikaans: 'Spanje',
    russian: 'Испания',
    latvian: 'Spānija',
    polish: '',
    french: '',
    spanish: 'España',
  },
  {
    av: 25377,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(language + castle, palace: Castilian being the 'language of castles', the main language of Spain)",
    english: 'Spanish, Castilian (language)',
    swedish: 'spanska, kastilianska',
    norwegian: 'spansk (språk)',
    finnish: 'espanja (kieli)',
    hungarian: '',
    german: 'Kastilisch, Spanisch (Sprache)',
    dutch: 'Spaans',
    afrikaans: 'Spaans (taal)',
    russian: 'испанский, кастильский язык',
    latvian: 'spāņu, kastīliešu valodas',
    polish: '',
    french: '',
    spanish: 'español, castellano (idioma)',
  },
  {
    av: 25378,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe person + spider)',
    english: 'Spiderman',
    swedish: 'Spiderman, Spindelmannen',
    norwegian: 'Spiderman',
    finnish: 'Hämähäkkimies',
    hungarian: '',
    german: 'Spiderman',
    dutch: 'spiderman',
    afrikaans: 'Spiderman',
    russian: 'Человек-Паук',
    latvian: 'Zirnekļcilvēks',
    polish: '',
    french: '',
    spanish: 'Spiderman, Hombre Araña',
  },
  {
    av: 25380,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cause + death + self)',
    english: 'suicide',
    swedish: 'självmord',
    norwegian: 'selvmord',
    finnish: 'itsemurha',
    hungarian: '',
    german: 'Selbstmord',
    dutch: 'zelfmoord',
    afrikaans: 'selfmoord',
    russian: 'суицид',
    latvian: 'pašnāvība',
    polish: '',
    french: '',
    spanish: 'suicida',
  },
  {
    av: 25381,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe person + brave + S)',
    english: 'Superman',
    swedish: 'Superman, Stålmannen',
    norwegian: 'Supermann',
    finnish: 'Teräsmies',
    hungarian: '',
    german: 'Supermann',
    dutch: 'superman',
    afrikaans: 'Superman',
    russian: 'Супермен',
    latvian: 'supermenis, Supermens',
    polish: '',
    french: '',
    spanish: 'Superman',
  },
  {
    av: 25382,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rear, back of a thing + airplane)',
    english: 'tail (airplane)',
    swedish: 'flygplansstjärt',
    norwegian: 'flyhale',
    finnish: 'lentokoneen pyrstö',
    hungarian: '',
    german: 'Hinterflügel (Flugzeug)',
    dutch: 'staart (vliegtuig)',
    afrikaans: 'stert (vliegtuig)',
    russian: 'хвост самолёта',
    latvian: 'lidmašīnas aste',
    polish: '',
    french: '',
    spanish: 'cola de la aeronave',
  },
  {
    av: 25383,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wing(s) + tail (airplane))',
    english: 'tail wing (airplane)',
    swedish: 'stjärtvinge (flygplan)',
    norwegian: 'halevinge (fly)',
    finnish: 'lentokoneen takasiipi',
    hungarian: '',
    german: 'Hinterflügel (Flugzeug)',
    dutch: 'staartvleugel',
    afrikaans: 'stert vleuel (vlerk)',
    russian: 'хвостовое оперение самолёта',
    latvian: 'antispārns (lidmašīnas)',
    polish: '',
    french: '',
    spanish: 'timón de avion',
  },
  {
    av: 25384,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(takeoff, take-off, airplane take-off + action indicator)',
    english: 'take off (airplane)-(to)',
    swedish: 'lyfta (flygplan)',
    norwegian: 'lette (å) (fly)',
    finnish: 'nousta (lentokone)',
    hungarian: '',
    german: 'Start (Flugzeug)',
    dutch: 'opstijgen',
    afrikaans: 'op te styf (vliegtuig) (om)',
    russian: 'взлетать (самолёт)',
    latvian: 'pacelšanās (lidmašīnas)',
    polish: '',
    french: '',
    spanish: 'despegar',
  },
  {
    av: 25385,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(make-believe person + djungle)',
    english: 'Tarzan',
    swedish: 'Tarzan',
    norwegian: 'Tarzan',
    finnish: 'Tarzan',
    hungarian: '',
    german: 'Tarzan',
    dutch: 'Tarzan',
    afrikaans: 'Tarzan',
    russian: 'Тарзан',
    latvian: 'Tarzāns',
    polish: '',
    french: '',
    spanish: 'Tarzan',
  },
  {
    av: 25386,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(whipping knot + action indicator)',
    english: 'tie whipping knot-(to)',
    swedish: 'tagla',
    norwegian: 'surre (tauverk, hyssing o.l.)',
    finnish: 'tehdä rihmos',
    hungarian: '',
    german: 'takeln',
    dutch: 'knopen, geselen',
    afrikaans: 'knoop (sweep) (om te)',
    russian: 'вязать плётку',
    latvian: 'saadīt mezglu',
    polish: '',
    french: '',
    spanish: 'embarrilar',
  },
  {
    av: 25388,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + wakefulness, alertness + imprint, trace, track: alertness representing to watch [contr.])',
    english: 'tracker',
    swedish: 'spårare',
    norwegian: 'sporfinner',
    finnish: 'jäljittäjä',
    hungarian: '',
    german: 'Fährtensucher, Aufspürer',
    dutch: 'spoorzoeker',
    afrikaans: 'spoorsnyer',
    russian: 'следопыт',
    latvian: 'pēddzinis, okšķeris',
    polish: '',
    french: '',
    spanish: 'rastreador',
  },
  {
    av: 25389,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(colour + sky + grass: a combination of blue and green)',
    english: 'turquoise',
    swedish: 'turkos',
    norwegian: 'turkis',
    finnish: 'turkoosi',
    hungarian: '',
    german: 'Türkis',
    dutch: 'turkoois',
    afrikaans: 'turkoois',
    russian: 'бирюзовый',
    latvian: 'tirkīzs',
    polish: '',
    french: '',
    spanish: 'turquesa',
  },
  {
    av: 25390,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothes + crew, staff)',
    english: 'uniform',
    swedish: 'uniform',
    norwegian: 'uniform',
    finnish: 'univormu, työasu',
    hungarian: '',
    german: 'Uniform',
    dutch: 'uniform',
    afrikaans: 'uniform',
    russian: 'униформа',
    latvian: 'formastērps',
    polish: '',
    french: '',
    spanish: 'uniforme',
  },
  {
    av: 25391,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lenght + wave)',
    english: 'wave length',
    swedish: 'våglängd',
    norwegian: 'bølgelengde',
    finnish: 'aallonpituus',
    hungarian: '',
    german: 'Wellenlänge bei Seegang',
    dutch: 'golflengte',
    afrikaans: 'golflengte',
    russian: 'длина волны',
    latvian: 'viļņu garums',
    polish: '',
    french: '',
    spanish: 'largo de ondas',
  },
  {
    av: 25392,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(doctor + animal)',
    english: 'veterinarian',
    swedish: 'veterinär',
    norwegian: 'veterinær',
    finnish: 'eläinlääkäri',
    hungarian: '',
    german: 'Veterinär, Veterinärin, Tierarzt, Tierärztin',
    dutch: 'dierenarts',
    afrikaans: 'veearts',
    russian: 'ветеринар',
    latvian: 'veterinārs, veterinārārsts, -e',
    polish: '',
    french: '',
    spanish: 'veterinario',
  },
  {
    av: 25393,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spiral + strap, string, velcro, rope, cord)',
    english: 'whipping knot',
    swedish: 'tagling',
    norwegian: 'surring',
    finnish: 'rihmos',
    hungarian: '',
    german: 'Takling',
    dutch: 'knoop, gesel, zweep',
    afrikaans: 'sweep knoop',
    russian: 'плётка',
    latvian: 'pletne',
    polish: '',
    french: '',
    spanish: 'embarrilado',
  },
  {
    av: 25394,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(windmill + electricity)',
    english: 'wind turbine',
    swedish: 'vindkraftverk, vindsnurra',
    norwegian: 'vindmølle (elektrisk)',
    finnish: 'tuuliturbiini',
    hungarian: '',
    german: 'Windrad, Windturbine',
    dutch: 'windturbine',
    afrikaans: 'wind turbine',
    russian: 'ветровая турбина',
    latvian: 'vēja turbīna',
    polish: '',
    french: '',
    spanish: 'turbina eolica',
  },
  {
    av: 25395,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tower + propeller, rotor (blades))',
    english: 'windmill',
    swedish: 'väderkvarn',
    norwegian: 'vindmølle',
    finnish: 'tuulimylly',
    hungarian: '',
    german: 'Windrad',
    dutch: 'windmolen',
    afrikaans: 'windpomp',
    russian: 'ветряная мельница',
    latvian: 'vējdzirnavas',
    polish: '',
    french: '',
    spanish: 'molino',
  },
  {
    av: 25397,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gauge + voltage + thing indicator)',
    english: 'voltmeter',
    swedish: 'voltmeter',
    norwegian: 'voltmeter',
    finnish: 'volttimittari, jännitemittari',
    hungarian: '',
    german: 'Voltmeter, Spannungsmesser',
    dutch: 'voltmeter',
    afrikaans: 'voltmeter',
    russian: 'вольтметр',
    latvian: 'voltmetrs',
    polish: '',
    french: '',
    spanish: 'voltímetro',
  },
  {
    av: 25398,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(spiral + action indicator)',
    english: 'wrap, wind-(to)',
    swedish: 'vira, linda, surra',
    norwegian: 'vikle, tvinne, surre',
    finnish: 'kietoa, kääriä',
    hungarian: '',
    german: 'wickeln, schlingen, aufziehen',
    dutch: 'omwikkelen, indraaien',
    afrikaans: 'draai (om te)',
    russian: 'обматывать, накручивать',
    latvian: 'ietīt, satīt',
    polish: '',
    french: '',
    spanish: 'enrollar',
  },
  {
    av: 25399,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(airplane + deletion, cancellation, destruction)',
    english: 'wreck, wreckage (airplane)',
    swedish: 'flygplansvrak',
    norwegian: 'flyvrak',
    finnish: 'lentokoneen hylky',
    hungarian: '',
    german: 'Wrack (Flugzeug)',
    dutch: 'wrak (vliegtuig)',
    afrikaans: 'wrak (vliegtuig)',
    russian: 'авиакрушение',
    latvian: 'avarējušas lidmašinas atliekas',
    polish: '',
    french: '',
    spanish: 'naufragio de avión',
  },
  {
    av: 25400,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(boat + deletion, cancellation, destruction)',
    english: 'wreck, wreckage (boat)',
    swedish: 'båtvrak',
    norwegian: 'båtvrak',
    finnish: 'laivan hylky',
    hungarian: '',
    german: 'Wrack, Schiffbruch',
    dutch: 'wrak (boot)',
    afrikaans: 'wrak (boot)',
    russian: 'кораблекрушение',
    latvian: 'avarējuša kuģa atliekas',
    polish: '',
    french: '',
    spanish: 'naufragio',
  },
  {
    av: 25402,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(landing, airplane landing + action indicator)',
    english: 'land (airplane)-(to)',
    swedish: 'landa (flygplan)',
    norwegian: 'lande',
    finnish: 'laskeutua (lentokone)',
    hungarian: '',
    german: 'Landung (Flugzeug)',
    dutch: 'landen (vliegtuig)',
    afrikaans: 'land (vliegtuig) (om te)',
    russian: 'приземляться (самолёт)',
    latvian: 'piezemēšanās, nosēšanās (lidmašīnas)',
    polish: '',
    french: '',
    spanish: 'aterrizar',
  },
  {
    av: 25405,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(different, other, difference + description indicator)',
    english: 'different, other, unequal',
    swedish: 'olika, annorlunda',
    norwegian: 'ulik, forskjellig, annerledes',
    finnish: 'erilainen',
    hungarian: '',
    german: 'anders, unterschiedlich, verschieden',
    dutch: 'verschillend, anders',
    afrikaans: 'verskillend, anders',
    russian: 'неодинаковый, разные, непохожий',
    latvian: 'atšķirīgs, cits, citāds',
    polish: '',
    french: '',
    spanish: 'diferente',
  },
  {
    av: 25407,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(South Pole + magnetism)',
    english: 'magnetic pole',
    swedish: 'magnetpol, magnetisk pol',
    norwegian: 'magnetisk pol',
    finnish: 'magneettinen napa',
    hungarian: '',
    german: 'magnetischer Pol, Magnetpol',
    dutch: 'magnetische pool',
    afrikaans: 'magnetiese pool',
    russian: 'магнитный полюс',
    latvian: 'magnētiskais pols',
    polish: '',
    french: '',
    spanish: 'polo magnético',
  },
  {
    av: 25409,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid, device, support + breath + thing indicator)',
    english: 'breathing aid',
    swedish: 'andningshjälpmedel',
    norwegian: 'pustehjelpemiddel',
    finnish: 'hengityslaite',
    hungarian: '',
    german: 'Beatmungsgerät, Atemgerät',
    dutch: 'hulpmiddel om te ademen',
    afrikaans: 'asemhaling hulp',
    russian: 'дыхательный аппарат',
    latvian: 'elpošanas aparāts',
    polish: '',
    french: '',
    spanish: 'soporte respiratorio',
  },
  {
    av: 25410,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + seat, sitting (sitting person))',
    english: 'sitting mat',
    swedish: 'sittunderlag',
    norwegian: 'sitteunderlag',
    finnish: 'istuinmatto',
    hungarian: '',
    german: 'Sitzmatte',
    dutch: 'zitkussen',
    afrikaans: 'sit mat',
    russian: 'коврик для сиденья',
    latvian: 'paliktnis sēdēšanai',
    polish: '',
    french: '',
    spanish: 'estera',
  },
  {
    av: 25411,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(number + limited time: nuber of something per time measure)',
    english: 'frequency',
    swedish: 'frekvens',
    norwegian: 'frekvens',
    finnish: 'taajuus',
    hungarian: '',
    german: 'Frequenz',
    dutch: 'frequentie',
    afrikaans: 'frekwensie',
    russian: 'частота, периодичность',
    latvian: 'biežums (viļņu kustība)',
    polish: '',
    french: '',
    spanish: 'frecuencia',
  },
  {
    av: 25412,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(insomnia + description indicator)',
    english: 'sleepless',
    swedish: 'sömnlös ',
    norwegian: 'søvnløs',
    finnish: 'uneton',
    hungarian: '',
    german: 'schlaflos',
    dutch: 'slapeloos',
    afrikaans: 'slapeloos',
    russian: 'бессонный',
    latvian: 'bezmiegs',
    polish: '',
    french: '',
    spanish: 'desvelado',
  },
  {
    av: 25413,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + gathering + negative)',
    english: 'quarrel, row',
    swedish: 'stök, bråk',
    norwegian: 'krangle, trette',
    finnish: 'sekasorto',
    hungarian: '',
    german: 'Streit, Krach, Auseinandersetzung',
    dutch: 'ruzie',
    afrikaans: 'rusie, woordewisseling',
    russian: 'ссора, раздор',
    latvian: 'strīds, strīdēšanās',
    polish: '',
    french: '',
    spanish: 'riña, pelea',
  },
  {
    av: 25414,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + D + E + U)',
    english: 'Germany',
    swedish: 'Tyskland',
    norwegian: 'Tyskland',
    finnish: 'Saksa',
    hungarian: '',
    german: 'Deutschland',
    dutch: 'Duitsland',
    afrikaans: 'Duitsland',
    russian: 'Германия',
    latvian: 'Vācija',
    polish: '',
    french: '',
    spanish: 'Alemania',
  },
  {
    av: 25415,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + Germany)',
    english: 'German (language)',
    swedish: 'tyska',
    norwegian: 'tysk',
    finnish: 'saksa (kieli)',
    hungarian: '',
    german: 'Deutsch (Sprache)',
    dutch: 'Duits (taal)',
    afrikaans: 'Duits (taal)',
    russian: 'немецкий язык',
    latvian: 'vācu valoda',
    polish: '',
    french: '',
    spanish: 'alemán (idioma)',
  },
  {
    av: 25416,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + T + H + A)',
    english: 'Thailand',
    swedish: 'Thailand',
    norwegian: 'Thailand',
    finnish: 'Thaimaa',
    hungarian: '',
    german: 'Thailand',
    dutch: 'Thailand',
    afrikaans: 'Thailand',
    russian: 'Таиланд',
    latvian: 'Taizeme',
    polish: '',
    french: '',
    spanish: 'Tailandia',
  },
  {
    av: 25417,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + R + O + U)',
    english: 'Romania',
    swedish: 'Rumänien',
    norwegian: 'Romania',
    finnish: 'Romania',
    hungarian: '',
    german: 'Rumänien',
    dutch: 'Roemenië',
    afrikaans: 'Romenië',
    russian: 'Румыния',
    latvian: 'Rumānija',
    polish: '',
    french: '',
    spanish: 'Rumenia',
  },
  {
    av: 25418,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(military, armed forces, armed services + cannon, gun)',
    english: 'artillery',
    swedish: 'artilleri',
    norwegian: 'artilleri',
    finnish: 'tykistö',
    hungarian: '',
    german: 'Artillerie',
    dutch: 'artillerie',
    afrikaans: 'artillerie',
    russian: 'артиллерийские войска',
    latvian: 'artilērija',
    polish: '',
    french: '',
    spanish: 'artillería',
  },
  {
    av: 25419,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class + German (language))',
    english: 'German (class)',
    swedish: 'tyska (skolämne)',
    norwegian: 'tysk (skolefag)',
    finnish: 'saksa (kouluaine)',
    hungarian: '',
    german: 'Deutsch (Schulfach)',
    dutch: 'Duitse (les)',
    afrikaans: 'Duits (klas)',
    russian: 'немецкий язык (предмет)',
    latvian: 'vācu valodas nodarbība',
    polish: '',
    french: '',
    spanish: 'alemán (clase)',
  },
  {
    av: 25420,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class + Romanian (language))',
    english: 'Romanian (class)',
    swedish: 'rumänska (skolämne)',
    norwegian: 'rumensk (skolefag)',
    finnish: 'romania (kouluaine)',
    hungarian: '',
    german: 'Rumänisch (Schulfach)',
    dutch: 'Roemeense (les)',
    afrikaans: 'Romeense (klas)',
    russian: 'румынский язык (предмет)',
    latvian: 'rumāņu valodas nodarbība',
    polish: '',
    french: '',
    spanish: 'rumano (clase)',
  },
  {
    av: 25421,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + Romania)',
    english: 'Romanian (language)',
    swedish: 'rumänska',
    norwegian: 'rumensk',
    finnish: 'romania (kieli)',
    hungarian: '',
    german: 'Rumänisch (Sprache)',
    dutch: 'Roemeens (taal)',
    afrikaans: 'Romeens (taal)',
    russian: 'румынский язык',
    latvian: 'rumāņu valoda ',
    polish: '',
    french: '',
    spanish: 'rumano (idioma)',
  },
  {
    av: 25422,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(military, armed forces, armed services + tank)',
    english: 'armoured force, tank force',
    swedish: 'pansarstyrka',
    norwegian: 'panserstyrke',
    finnish: 'panssarijoukot',
    hungarian: '',
    german: 'Panzerverband, gepanzerter Verband, Panzereinheit',
    dutch: 'tankdivisie (leger)',
    afrikaans: 'gepanserde tank',
    russian: 'бронетанковые силы',
    latvian: 'bruņotie spēki, bruņutanku vienība ',
    polish: '',
    french: '',
    spanish: 'fuerzas armadas',
  },
  {
    av: 25423,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class + Thai (language))',
    english: 'Thai (class)',
    swedish: 'thailändska (skolämne)',
    norwegian: 'thai (skolefag)',
    finnish: 'thai (kouluaine)',
    hungarian: '',
    german: 'Thai (Schulfach)',
    dutch: 'Thaise (les)',
    afrikaans: 'Thaise (klas)',
    russian: 'тайский язык (предмет)',
    latvian: 'taizemiešu valodas nodarbība',
    polish: '',
    french: '',
    spanish: 'Tailandes (clase)',
  },
  {
    av: 25424,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + Thailand)',
    english: 'Thai (language)',
    swedish: 'thailändska',
    norwegian: 'thai',
    finnish: 'thai (kieli)',
    hungarian: '',
    german: 'Thai (Sprache)',
    dutch: 'Thais (taal)',
    afrikaans: 'Thai (taal)',
    russian: 'тайский язык',
    latvian: 'taizemiešu valodas nodarbība',
    polish: '',
    french: '',
    spanish: 'Tailandes (idioma)',
  },
  {
    av: 25430,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(intestine(s), bowel(s), gut(s) + end, arrival, stop: The intestine that stops in a dead end)',
    english: 'appendix, cecum, caecum',
    swedish: 'blindtarm, appendix',
    norwegian: 'blindtarm',
    finnish: 'umpisuoli',
    hungarian: '',
    german: 'Blinddarm, Appendix',
    dutch: 'appendix, blinde darm',
    afrikaans: 'blindederm',
    russian: 'апендикс, слепая кишка',
    latvian: 'aklā zarna, apendicīts',
    polish: '',
    french: '',
    spanish: 'apéndice',
  },
  {
    av: 25431,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(beginning, start + year)',
    english: 'beginning of year',
    swedish: 'årets början',
    norwegian: 'årsstart',
    finnish: 'alkuvuosi',
    hungarian: '',
    german: 'Jahresbeginn',
    dutch: 'begin van het jaar',
    afrikaans: 'begin van jaar',
    russian: 'начало года',
    latvian: 'gada sākums',
    polish: '',
    french: '',
    spanish: 'comienzo de año',
  },
  {
    av: 25432,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(picture, image, icon, painting + body + brush: Panting on skin made with brush)',
    english: 'body painting',
    swedish: 'kroppsmålning',
    norwegian: 'kroppsmaling',
    finnish: 'ihomaalaus',
    hungarian: '',
    german: 'Bodypainting',
    dutch: 'bodypainting',
    afrikaans: 'liggaam skildery',
    russian: 'боди-арт, рисунок по телу',
    latvian: 'ķermeņa apgleznošana',
    polish: '',
    french: '',
    spanish: 'pintura de cuerpo',
  },
  {
    av: 25433,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(jewelry + arm)',
    english: 'bracelet',
    swedish: 'armband',
    norwegian: 'armbånd',
    finnish: 'rannerengas',
    hungarian: '',
    german: 'Armband',
    dutch: 'armband',
    afrikaans: 'armband',
    russian: 'браслет',
    latvian: 'rokassprādze',
    polish: '',
    french: '',
    spanish: 'pulsera',
  },
  {
    av: 25435,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bone + chest)',
    english: 'breastbone, sternum',
    swedish: 'bröstben',
    norwegian: 'brystben',
    finnish: 'rintalasta',
    hungarian: '',
    german: 'Brustbein, Brustknochen',
    dutch: 'borstbeen, sternum',
    afrikaans: 'borsbeen, sternum',
    russian: 'грудина, грудная клетка, грудная кость',
    latvian: 'krūšukauls',
    polish: '',
    french: '',
    spanish: 'esternón',
  },
  {
    av: 25436,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(jewelry + clothing: Jewelry to put on clothes)',
    english: 'brooch',
    swedish: 'brosch, slipsnål (etc)',
    norwegian: 'brosje, slipsnål (o.l.)',
    finnish: 'rintaneula, rintakoru',
    hungarian: '',
    german: 'Brosche',
    dutch: 'broche, sierspeld',
    afrikaans: 'borsspeld',
    russian: 'брошь',
    latvian: 'piespraude',
    polish: '',
    french: '',
    spanish: 'broche',
  },
  {
    av: 25437,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(medical tube, catheter, cannula + needle)',
    english: 'cannula (with needle)',
    swedish: 'kanyl',
    norwegian: 'kanyle',
    finnish: 'kanyyli',
    hungarian: '',
    german: 'Kanüle',
    dutch: 'cannule (met naald)',
    afrikaans: 'dreineerbuis (met naald)',
    russian: 'канюля (с иглой) ',
    latvian: 'drenāžas caurulīte (medicīniskai manipulācijai)',
    polish: '',
    french: '',
    spanish: 'cánula (con aguja)',
  },
  {
    av: 25438,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalisation + organ + heart)',
    english: 'cardiovascular system',
    swedish: 'hjärt- kärlsystem, kardiovaskulärt system',
    norwegian: 'hjerte-karsystem',
    finnish: 'verenkiertojärjestelmä, kardiovaskulaarinen järjestelmä',
    hungarian: '',
    german: 'kardiovaskuläres System, Herz-Kreislauf-System',
    dutch: 'cardiovasculair systeem',
    afrikaans: 'kardiovaskulêre stelsel',
    russian: 'сердечно-сосудистая система',
    latvian: 'sirds asinsvadu, kardiovaskulārā sistēma',
    polish: '',
    french: '',
    spanish: 'sistema cardiovascular',
  },
  {
    av: 25439,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(medical tube, catheter, cannula + urine)',
    english: 'catheter (urine)',
    swedish: 'kateter',
    norwegian: 'kateter (urin)',
    finnish: 'katetri (virtsa)',
    hungarian: '',
    german: 'Katheter ',
    dutch: 'urinecatheter',
    afrikaans: 'kateter (urine)',
    russian: 'катетер',
    latvian: 'katetrs (urīnpušļa manipulācijai)',
    polish: '',
    french: '',
    spanish: 'catéter (orina)',
  },
  {
    av: 25440,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water, fluid, liquid + cell)',
    english: 'cellular fluid',
    swedish: 'cellvätska',
    norwegian: 'cellevæske',
    finnish: 'soluneste',
    hungarian: '',
    german: 'Zellflüssigkeit',
    dutch: 'cellulaire vloeistof',
    afrikaans: 'sellulêre vloeistof',
    russian: 'клеточная жидкость',
    latvian: 'audu šķidrums',
    polish: '',
    french: '',
    spanish: 'líquido celular',
  },
  {
    av: 25441,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + before + birth + cross, Christianity (in combinations): where birth + cross represents Christmas [contr.], i.e., the birth of Jesus Christ)',
    english: 'Christmas Eve (day)',
    swedish: 'julafton (dag)',
    norwegian: 'julaften (dag)',
    finnish: 'jouluaatto (päivä)',
    hungarian: '',
    german: 'Heiligabend, Heiliger Abend, Weihnachtsabend (Tag)',
    dutch: 'dag voor kerstdag',
    afrikaans: 'Oukersdag (dag)',
    russian: 'канун Рождества (день)',
    latvian: 'Ziemassvētku diena',
    polish: '',
    french: '',
    spanish: 'Nochebuena (día)',
  },
  {
    av: 25442,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(evening + before + birth + cross, Christianity (in combinations): where birth + cross represents Christmas [contr.], i.e., the birth of Jesus Christ)',
    english: 'Christmas Eve (evening)',
    swedish: 'julafton (kväll)',
    norwegian: 'julaften',
    finnish: 'jouluaatto (ilta)',
    hungarian: '',
    german: 'Heiligabend, Heiliger Abend, Weihnachtsabend (Abend)',
    dutch: 'kerstavond',
    afrikaans: 'Oukersaand (aand)',
    russian: 'канун Рождества (вечер)',
    latvian: 'Ziemassvētku vakars',
    polish: '',
    french: '',
    spanish: 'Nochebuena (tarde)',
  },
  {
    av: 25443,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalisation + organ + rotation)',
    english: 'circulatory system',
    swedish: 'cirkulationssystem (kropp)',
    norwegian: 'sirkulasjonssystem (kropp)',
    finnish: 'verenkiertojärjestelmä (keho)',
    hungarian: '',
    german: 'Kreislaufsystem (Körper)',
    dutch: 'bloedsomloop',
    afrikaans: 'bloedsomloopstelsel',
    russian: 'система кровообращения',
    latvian: 'asinsrites sistēma',
    polish: '',
    french: '',
    spanish: 'sistema circulatorio',
  },
  {
    av: 25444,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(bone + shoulder + in front of: A bone on the upper part of the front of the body, linking the scapula and sternum)',
    english: 'collarbone, clavicle',
    swedish: 'nyckelben',
    norwegian: 'krageben',
    finnish: 'solisluu',
    hungarian: '',
    german: 'Schlüsselbein',
    dutch: 'sleutelbeen',
    afrikaans: 'sleutelbeen',
    russian: 'ключица',
    latvian: 'atslēgas kauls',
    polish: '',
    french: '',
    spanish: 'clavícula',
  },
  {
    av: 25445,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + before + holiday)',
    english: 'day before holiday',
    swedish: 'dag före röd dag, afton (dag)',
    norwegian: 'dag før fridag, dag før helg',
    finnish: 'aatto',
    hungarian: '',
    german: 'Tag vor Fest- und Feiertagen',
    dutch: 'dag voor een verlofdag',
    afrikaans: 'dag voor vakansie',
    russian: 'предпраздничный день',
    latvian: 'pirmssvētku diena',
    polish: '',
    french: '',
    spanish: 'día antes de vacaciones',
  },
  {
    av: 25446,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(leaf + chemical product: where chemical product represents drug [contr.]: Leaves used as drugs) (kerned)',
    english: 'drug (leaf based)',
    swedish: 'drog (av blad)',
    norwegian: 'rusmiddel (blad), drug (blad)',
    finnish: 'kannabis, hasis, marihuana',
    hungarian: '',
    german: 'Droge (von Blättern)',
    dutch: 'drugs (op basis van blad)',
    afrikaans: 'dwelm (blaar gebaseer)',
    russian: 'наркотик (из листьев)',
    latvian: 'narkotika (augu lapu)',
    polish: '',
    french: '',
    spanish: 'droga (hoja de base)',
  },
  {
    av: 25447,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(jewelry + ear)',
    english: 'earring',
    swedish: 'örhänge(n)',
    norwegian: 'ørepynt',
    finnish: 'korvakoru',
    hungarian: '',
    german: 'Ohrring',
    dutch: 'oorring',
    afrikaans: 'oorbel',
    russian: 'серьги',
    latvian: 'auskars',
    polish: '',
    french: '',
    spanish: 'pendiente, aro',
  },
  {
    av: 25448,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(end, arrival, stop + year)',
    english: 'end of year',
    swedish: 'årets slut, årsslut',
    norwegian: 'årsslutt',
    finnish: 'loppuvuosi',
    hungarian: '',
    german: 'Jahresende',
    dutch: 'jaareinde',
    afrikaans: 'einde van die jaar',
    russian: 'конец года',
    latvian: 'gada beigas',
    polish: '',
    french: '',
    spanish: 'fin de año',
  },
  {
    av: 25449,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalisation + gland: The system involving the glands) (kerned)',
    english: 'endocrine system',
    swedish: 'endokrint system, körtlar (kropp)',
    norwegian: 'indresekretorisk systeme',
    finnish: 'umpieritysjärjestelmä',
    hungarian: '',
    german: 'Hormonsystem, das endokrine System',
    dutch: 'endocrien systeem',
    afrikaans: 'endokriene stelsel',
    russian: 'эндокринная система',
    latvian: 'endokrīnā sistēma',
    polish: '',
    french: '',
    spanish: 'sistema endocrino',
  },
  {
    av: 25450,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(medical tube, catheter, cannula + food)',
    english: 'feeding tube',
    swedish: 'sond (för mat)',
    norwegian: 'sonde',
    finnish: 'syöttöletku',
    hungarian: '',
    german: 'Ernährungssonde',
    dutch: 'sonde (voor voeding)',
    afrikaans: 'voedingsbuis',
    russian: 'пищевой зонд',
    latvian: 'pārtikas zonde',
    polish: '',
    french: '',
    spanish: 'tubo para alimentar ',
  },
  {
    av: 25451,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalisation + organ + food)',
    english: 'gastrointestinal system',
    swedish: 'matsmältningssystem',
    norwegian: 'fordøyelsessystem',
    finnish: 'ruoansulatusjärjestelmä',
    hungarian: '',
    german: 'Magen-Darm-System, Verdauungssystem',
    dutch: 'gastrointestinaal systeem',
    afrikaans: 'spysverteringstelsel',
    russian: 'желудочно-кишечная система',
    latvian: 'kuņģa-zarnu trakta sistēma',
    polish: '',
    french: '',
    spanish: 'sistema gastrointestinal',
  },
  {
    av: 25452,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(organ + chemical product: organ that produces chemicals) (kerned)',
    english: 'gland',
    swedish: 'körtel',
    norwegian: 'kjertel',
    finnish: 'rauhanen',
    hungarian: '',
    german: 'Drüse',
    dutch: 'klier',
    afrikaans: 'klier',
    russian: 'железы',
    latvian: 'mandeles',
    polish: '',
    french: '',
    spanish: 'glándula',
  },
  {
    av: 25453,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lump(s) + star: Small pieces that shine, like stars)',
    english: 'glitter',
    swedish: 'glitter, strass',
    norwegian: 'glitter',
    finnish: 'kimalle',
    hungarian: '',
    german: 'Glitter, Funkeln',
    dutch: 'glitter',
    afrikaans: 'glinster, vonkel, glitter',
    russian: 'блёстки, стразы',
    latvian: 'mirdzumi, gliteri',
    polish: '',
    french: '',
    spanish: 'brillo',
  },
  {
    av: 25454,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(rest period, break + drink + action indicator: The activity of having a break with beverage)',
    english: 'have a tea break, have a coffee break-(to)',
    swedish: 'fika (verb)',
    norwegian: 'ta en kaffepause, ta en tepause',
    finnish: 'olla juomatauolla, pitää juomatauko',
    hungarian: '',
    german: 'Kaffee trinken',
    dutch: 'pauzeren (om iets te drinken)',
    afrikaans: 'om koffiebreek te neem, om teebreek te neem',
    russian: 'прерываться на чай/кофе',
    latvian: 'tējas/kafijas pauze',
    polish: '',
    french: '',
    spanish: 'tener una pausa para el té (café)',
  },
  {
    av: 25455,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(protection + heel: Ccombination of shoe and heel. The heel on the shoe)',
    english: 'heel (shoe)',
    swedish: 'klack',
    norwegian: 'skohæl',
    finnish: 'kengän kanta, kengän korko',
    hungarian: '',
    german: 'Absatz (Schuh)',
    dutch: 'hiel (schoen), hak (schoen) ',
    afrikaans: 'hak (skoen)',
    russian: 'каблук',
    latvian: 'papēdis (apava)',
    polish: '',
    french: '',
    spanish: 'tacón (zapatos)',
  },
  {
    av: 25456,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(heel (shoe) + high)',
    english: 'high heeled shoes, high heels',
    swedish: 'högklackade skor',
    norwegian: 'høyhælte sko',
    finnish: 'korkokantakenkä, korkokenkä',
    hungarian: '',
    german: 'Stöckelschuhe',
    dutch: 'schoenen met hoge hakken ',
    afrikaans: 'hoë hak skoene, hoë hakke',
    russian: 'обувь на высоком каблуке',
    latvian: 'augstpapēžu kurpes',
    polish: '',
    french: '',
    spanish: 'zapatos de tacón alto',
  },
  {
    av: 25457,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bone + upper arm)',
    english: 'humerus, upper arm bone',
    swedish: 'överarmsben',
    norwegian: 'overarmsben',
    finnish: 'olkaluu',
    hungarian: '',
    german: 'Humerus, Oberarmknochen',
    dutch: 'bovenarm',
    afrikaans: 'bo-arm been, humerus',
    russian: 'плечевая кость',
    latvian: 'plecakauls, augšdelma kauls',
    polish: '',
    french: '',
    spanish: 'humero',
  },
  {
    av: 25459,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(chemical product + cell + work: the chemical substance that regulates the oxidation of suger, providing the energy needed for the cells to work)',
    english: 'insulin',
    swedish: 'insulin',
    norwegian: 'insulin',
    finnish: 'insuliini',
    hungarian: '',
    german: 'Insulin',
    dutch: 'insuline',
    afrikaans: 'insulien',
    russian: 'инсулин',
    latvian: 'insulīns',
    polish: '',
    french: '',
    spanish: 'insulina',
  },
  {
    av: 25460,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(organ + food + tube) Preferred NEW SYNONYM, replacing 12883',
    english: 'intestine(s), bowel(s), gut(s)',
    swedish: 'tarm, tarmar',
    norwegian: 'tarm, tarmer',
    finnish: 'suoli, suolisto',
    hungarian: '',
    german: 'Darm, Dickdarm, Dünndarm, Eingeweide',
    dutch: 'darm (lichaam)',
    afrikaans: 'derms',
    russian: 'кишечник',
    latvian: 'tievā zarna, iekšas',
    polish: '',
    french: '',
    spanish: 'intestino(s)',
  },
  {
    av: 25461,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(intestine(s), bowel(s), gut(s) + short: the shorter, but wider, part of the intestines)',
    english: 'large intestine',
    swedish: 'tjocktarm',
    norwegian: 'tykktarm',
    finnish: 'paksusuoli',
    hungarian: '',
    german: 'Dickdarm ',
    dutch: 'dikke darm',
    afrikaans: 'dikderm',
    russian: 'толстый кишечник',
    latvian: 'resnā zarna',
    polish: '',
    french: '',
    spanish: 'intestino grueso',
  },
  {
    av: 25462,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gland + group + action: a gland with many functions)',
    english: 'liver',
    swedish: 'lever (kropp) ',
    norwegian: 'lever (kropp)',
    finnish: 'maksa',
    hungarian: '',
    german: 'Leber',
    dutch: 'lever',
    afrikaans: 'lewer',
    russian: 'печень (орган)',
    latvian: 'aknas',
    polish: '',
    french: '',
    spanish: 'hígado',
  },
  {
    av: 25463,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(arm + under)',
    english: 'lower arm',
    swedish: 'underarm',
    norwegian: 'underarm',
    finnish: 'kyynärvarsi',
    hungarian: '',
    german: 'Unterarm',
    dutch: 'onderarm',
    afrikaans: 'onderarm',
    russian: 'предплечье',
    latvian: 'apakšdelms',
    polish: '',
    french: '',
    spanish: 'antebrazo',
  },
  {
    av: 25464,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bone + lower arm)',
    english: 'lower arm bone(s)',
    swedish: 'underarmsben',
    norwegian: 'underarmsben',
    finnish: 'kyynäsvarren luu',
    hungarian: '',
    german: 'Unterarmknochen',
    dutch: 'onderarmbeen',
    afrikaans: 'onderarm been',
    russian: 'предплечевая кость',
    latvian: 'apakšdelma kauls',
    polish: '',
    french: '',
    spanish: 'radio',
  },
  {
    av: 25465,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(organ + breath: The major organ for breathing)',
    english: 'lung(s)',
    swedish: 'lunga, lungor',
    norwegian: 'lunge, lunger',
    finnish: 'keuhkot',
    hungarian: '',
    german: 'Lunge, Lungen',
    dutch: 'long(en)',
    afrikaans: 'long(e)',
    russian: 'лёгкое, лёгкие (орган)',
    latvian: 'plauša, plaušas',
    polish: '',
    french: '',
    spanish: 'pulmón',
  },
  {
    av: 25466,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cellular fluid + protection)',
    english: 'lymph',
    swedish: 'lymfa',
    norwegian: 'lymfe',
    finnish: 'imuneste, lymfa',
    hungarian: '',
    german: 'Lymphe, Gewebsflüssigkeit',
    dutch: 'lymfe',
    afrikaans: 'limf',
    russian: 'лимфа',
    latvian: 'limfa',
    polish: '',
    french: '',
    spanish: 'linfa',
  },
  {
    av: 25467,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(organ + lymph: where organ represents gland [contr.])',
    english: 'lymph node, lymph gland',
    swedish: 'lymfkörtel',
    norwegian: 'lymfekjertel',
    finnish: 'imusolmuke',
    hungarian: '',
    german: 'Lymphknoten, Lymphdrüse',
    dutch: 'lymfeknoop',
    afrikaans: 'limfnode, limfklierkanker',
    russian: 'лимфатический узел',
    latvian: 'limfmezgls',
    polish: '',
    french: '',
    spanish: 'ganglio linfático',
  },
  {
    av: 25468,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalisation + lymph)',
    english: 'lymphatic system',
    swedish: 'lymfatiskt system',
    norwegian: 'lymfesystem',
    finnish: 'imusuonisto',
    hungarian: '',
    german: 'Lymphgefäßsystem, lymphatisches System',
    dutch: 'lymfatisch systeem',
    afrikaans: 'limfatiese stelsel',
    russian: 'лимфатическая система',
    latvian: 'limfatiskā sistēma',
    polish: '',
    french: '',
    spanish: 'sistema linfático',
  },
  {
    av: 25469,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(tube + medical: a tube used for medical purposes. Add appropriate specifier when needed)',
    english: 'medical tube, catheter, cannula',
    swedish: 'kateter, kanyl, sond (etc)',
    norwegian: 'kateter, kanyle, sonde',
    finnish: 'kanyyli, katetri',
    hungarian: '',
    german: 'Katheter, Kanüle, Sonde (etc.)',
    dutch: 'catheter (medisch), sonde (medisch)',
    afrikaans: 'mediese buis, kateter',
    russian: 'медицинская трубка, катетер, канюля',
    latvian: 'medicinīniskais katetrs',
    polish: '',
    french: '',
    spanish: 'tubo médico, catéter, cánula',
  },
  {
    av: 25470,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(jewelry + neck)',
    english: 'necklace',
    swedish: 'halsband, halskedja',
    norwegian: 'halssmykke',
    finnish: 'kaulakoru',
    hungarian: '',
    german: 'Halskette',
    dutch: 'halsketting, ketting (hals)',
    afrikaans: 'halssnoer',
    russian: 'колье, ожерелье',
    latvian: 'kaklarota',
    polish: '',
    french: '',
    spanish: 'collar',
  },
  {
    av: 25471,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + neuron)',
    english: 'nerve',
    swedish: 'nerv',
    norwegian: 'nerve',
    finnish: 'hermo',
    hungarian: '',
    german: 'Nerv',
    dutch: 'zenuw',
    afrikaans: 'senuwee',
    russian: 'нервы',
    latvian: 'nervs',
    polish: '',
    french: '',
    spanish: 'nervio',
  },
  {
    av: 25472,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalisation + neuron)',
    english: 'nervous system',
    swedish: 'nervsystem',
    norwegian: 'nervesystem',
    finnish: 'hermojärjestelmä',
    hungarian: '',
    german: 'Nervensystem ',
    dutch: 'zenuwstelsel',
    afrikaans: 'senuweestelsel',
    russian: 'нервная система',
    latvian: 'neiroloģiskā sistēma',
    polish: '',
    french: '',
    spanish: 'sistema nervioso',
  },
  {
    av: 25473,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cell + electricity)',
    english: 'neuron',
    swedish: 'nervcell, neuron',
    norwegian: 'nevron',
    finnish: 'hermosolu',
    hungarian: '',
    german: 'Neuron',
    dutch: 'neuron',
    afrikaans: 'neuron',
    russian: 'нейрон',
    latvian: 'neirons',
    polish: '',
    french: '',
    spanish: 'neurona',
  },
  {
    av: 25474,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + beginning + year: First day of a new year (eg. school, calendar))',
    english: 'New Year (general)',
    swedish: 'nyårsdag',
    norwegian: 'nyttårsstart',
    finnish: 'uusi vuosi',
    hungarian: '',
    german: 'Neujahr',
    dutch: 'nieuwjaar',
    afrikaans: 'nuwe jaar (algemeen)',
    russian: 'Новый Год (день)',
    latvian: 'Jaunais gads (vispārīgā noz.)',
    polish: '',
    french: '',
    spanish: 'Año nuevo',
  },
  {
    av: 25475,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + before + birth + year: Day before the birth of a year)',
    english: "New Year's eve (day)",
    swedish: 'nyårsafton (dag)',
    norwegian: 'nyttårsaften (dag)',
    finnish: 'uudenvuodenaatto (päivä)',
    hungarian: '',
    german: 'Silvester (Tag)',
    dutch: 'oudejaarsdag',
    afrikaans: 'nuwejaarsdag',
    russian: 'канун Нового Года (день)',
    latvian: 'Vecgada vakars',
    polish: '',
    french: '',
    spanish: 'vispera de año nuevo',
  },
  {
    av: 25476,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(evening + before + birth + year: Evening before the birth of a year)',
    english: "New Year's eve (evening)",
    swedish: 'nyårsafton (kväll)',
    norwegian: 'nyttårsaften',
    finnish: 'uudenvuodenaatto (ilta)',
    hungarian: '',
    german: 'Silvester (Abend)',
    dutch: 'oudejaarsavond',
    afrikaans: 'nuwejaarsdag',
    russian: 'канун Нового Года (вечер)',
    latvian: 'Jaungada diena',
    polish: '',
    french: '',
    spanish: 'vispera de año nuevo',
  },
  {
    av: 25477,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + end + year: Last day of a year)',
    english: "New Year's eve, end of year (day)",
    swedish: 'nyårsafton, årets sista dag ',
    norwegian: 'nyttårsaften, årets siste dag',
    finnish: 'vuoden viimeinen päivä (päivä)',
    hungarian: '',
    german: 'Silvester, der letzte Tag des Jahres',
    dutch: 'nieuwjaarsdag',
    afrikaans: 'nuwejaarsdag',
    russian: 'Новый Год (праздник)',
    latvian: 'Jaunais Gads (svētki)',
    polish: '',
    french: '',
    spanish: 'vispera de año nuevo, último dia del año',
  },
  {
    av: 25478,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(evening + end + year: Last evening of a year)',
    english: "New Year's eve, end of year (evening)",
    swedish: 'nyårssafton, årets sista kväll',
    norwegian: 'nyttårsaften, årets siste kveld',
    finnish: 'vuoden viimeinen päivä (ilta)',
    hungarian: '',
    german: 'Silvester, der letzte Abend des Jahres',
    dutch: 'nieuwjaarsavond',
    afrikaans: 'nuwejaarsdag, einde van die jaar (aand)',
    russian: 'вечер Нового Года',
    latvian: 'Vecgada vakars',
    polish: '',
    french: '',
    spanish: 'vispera de año nuevo, último noche del año',
  },
  {
    av: 25479,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(organ + food + receive + tube: The food goes into the container (of the stomach) by a tube)',
    english: 'oesophagus, gullet',
    swedish: 'matsrupe',
    norwegian: 'spiserør',
    finnish: 'ruokatorvi',
    hungarian: '',
    german: 'Speiseröhre',
    dutch: 'slokdarm, oesophagus',
    afrikaans: 'slukderm',
    russian: 'пищевод',
    latvian: 'barības vads',
    polish: '',
    french: '',
    spanish: 'esófago',
  },
  {
    av: 25481,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gland + insulin: The gland that produces insulin) (kerned)',
    english: 'pancreas',
    swedish: 'bukspottkörtel',
    norwegian: 'bukspyttkjertel',
    finnish: 'haima',
    hungarian: '',
    german: 'Bauchspeicheldrüse',
    dutch: 'pancreas',
    afrikaans: 'pankreas',
    russian: 'пожделудочная железа',
    latvian: 'aizkuņģa dziedzeris',
    polish: '',
    french: '',
    spanish: 'páncreas',
  },
  {
    av: 25482,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(through + jewelry + action indicator)',
    english: 'pierce (jewellery)-(to)',
    swedish: 'pierca, ta hål (för smycke)',
    norwegian: 'pierce, ta hull for smykke',
    finnish: 'puhkaista, läpäistä, lävistää',
    hungarian: '',
    german: 'durchstechen verschiedener Hautstellen (Körperschmuck)',
    dutch: 'doorprikken (voor piercing)',
    afrikaans: 'gaatjies maak in vel (juwele) (om te)',
    russian: 'делать прокол для украшения',
    latvian: 'caurdurt, izdurt (caurumus pīrsingam)',
    polish: '',
    french: '',
    spanish: 'hacer un piercing',
  },
  {
    av: 25483,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(through + knife + action indicator: The knife representing sharp. To penetrate with a sharp instrument)',
    english: 'pierce-(to)',
    swedish: 'sticka igenom, genomborra',
    norwegian: 'stikke gjennom',
    finnish: 'tehdä lävistys korulle',
    hungarian: '',
    german: 'durchbohren, durchstechen',
    dutch: 'doorsnijden',
    afrikaans: 'gaatjies maak in vel (om te)',
    russian: 'прокалывать, делать прокол',
    latvian: 'caurdurt, izdurt (caurumus pīrsingam)',
    polish: '',
    french: '',
    spanish: 'perforar, atravezar',
  },
  {
    av: 25484,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(jewelry + through)',
    english: 'piercing (thing)',
    swedish: 'piercingsmycke',
    norwegian: 'piercingsmykke, piersingsmykke',
    finnish: 'lävistäminen, puhkaiseminen, läpäiseminen',
    hungarian: '',
    german: 'Piercing (Schmuck)',
    dutch: 'piercing',
    afrikaans: 'gaatjies drukker, pons',
    russian: 'пирсинг (украшение)',
    latvian: 'pīrsings (ķermeņa dekorācija)',
    polish: '',
    french: '',
    spanish: 'piercing',
  },
  {
    av: 25485,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(intestine(s), bowel(s), gut(s) + waste)',
    english: 'rectum',
    swedish: 'ändtarm, rectum',
    norwegian: 'endetarm, rektum',
    finnish: 'peräsuoli',
    hungarian: '',
    german: 'Mastdarm, Enddarm, Rektum',
    dutch: 'aars',
    afrikaans: 'rektum',
    russian: 'прямая кишка',
    latvian: 'taisnā zarna',
    polish: '',
    french: '',
    spanish: 'recto',
  },
  {
    av: 25486,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalisation + lung(s))',
    english: 'respiratory system',
    swedish: 'andningssystem',
    norwegian: 'åndedrettssystem, respirasjonssystem',
    finnish: 'hengityselimistö',
    hungarian: '',
    german: 'Atemweg, Atmungssystem, Atmungsorgane ',
    dutch: 'ademhalingssysteem',
    afrikaans: 'respiratoriese stelsel',
    russian: 'дыхательная система',
    latvian: 'elpošanas sistēma',
    polish: '',
    french: '',
    spanish: 'sistema respiratorio',
  },
  {
    av: 25487,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bone + side (body))',
    english: 'rib(s)',
    swedish: 'revben (kropp)',
    norwegian: 'ribben',
    finnish: 'kylkiluu',
    hungarian: '',
    german: 'Rippen (Körper)',
    dutch: 'rib',
    afrikaans: 'rib(bes)',
    russian: 'ребро',
    latvian: 'riba',
    polish: '',
    french: '',
    spanish: 'costilla',
  },
  {
    av: 25488,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(jewelry + finger)',
    english: 'ring (finger)',
    swedish: 'ring (finger)',
    norwegian: 'ring (smykke)',
    finnish: 'nimetön (sormi)',
    hungarian: '',
    german: 'Ring (Finger)',
    dutch: 'ring (vinger)',
    afrikaans: 'ring vinger',
    russian: 'кольцо (украшение)',
    latvian: 'pirksta kauliņš, pirkstu kauiliņi',
    polish: '',
    french: '',
    spanish: 'anillo',
  },
  {
    av: 25489,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(organ + saliva: Organ representing gland[contr.]. A gland that produces saliva)',
    english: 'salivary gland',
    swedish: 'spottkörtel',
    norwegian: 'spyttkjertel',
    finnish: 'sylkirauhanen',
    hungarian: '',
    german: 'Speicheldrüse',
    dutch: 'speekselklier',
    afrikaans: 'speekselklier',
    russian: 'слюнная железа',
    latvian: 'siekalu dziedzeris',
    polish: '',
    french: '',
    spanish: 'glándula salivaria',
  },
  {
    av: 25490,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(glitter + cloth: Glitter attached to cloth)',
    english: 'sequin(s), spangle(s)',
    swedish: 'paljetter',
    norwegian: 'paljetter',
    finnish: 'paljetti, sekiini',
    hungarian: '',
    german: 'Flitter, Paillette',
    dutch: 'pailletten',
    afrikaans: 'paillet',
    russian: 'блёстка, пайетка',
    latvian: 'vizulis, vizuļi',
    polish: '',
    french: '',
    spanish: 'lentejuelas',
  },
  {
    av: 25491,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bone + shoulder + behind)',
    english: 'shoulder blade, scapula',
    swedish: 'skulderblad',
    norwegian: 'skulderblad',
    finnish: 'lapaluu',
    hungarian: '',
    german: 'Schulterblatt',
    dutch: 'schouderblad, claviculum',
    afrikaans: 'bladbeen, skapula',
    russian: 'лопаточная кость',
    latvian: 'plecu lāpstiņas',
    polish: '',
    french: '',
    spanish: 'escápula, omóplato',
  },
  {
    av: 25492,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bone + head)',
    english: 'skull, cranium',
    swedish: 'skalle, kranium',
    norwegian: 'hodeskalle, kranium',
    finnish: 'kallo',
    hungarian: '',
    german: 'Schädel, Totenkopf, Hirnschädel, Cranium',
    dutch: 'schedel',
    afrikaans: 'skedel',
    russian: 'череп',
    latvian: 'galvasskauss',
    polish: '',
    french: '',
    spanish: 'cráneo',
  },
  {
    av: 25493,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(intestine(s), bowel(s), gut(s) + long: The longer, but thinner, part of the intestines)',
    english: 'small intestine',
    swedish: 'tunntarm',
    norwegian: 'tynntarm',
    finnish: 'ohutsuoli',
    hungarian: '',
    german: 'Dünndarm',
    dutch: 'dunne darm',
    afrikaans: 'dunderm',
    russian: 'тонкий кишечник',
    latvian: 'tievā zarna',
    polish: '',
    french: '',
    spanish: 'intestino delgado',
  },
  {
    av: 25494,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(drug (leaf based) + nose: Leaf based drug that is taken through the nose) (kerned)',
    english: 'snuff (nose)',
    swedish: 'snus (näsa), luktsnus',
    norwegian: 'snus',
    finnish: 'nuuska',
    hungarian: '',
    german: 'Schnupftabak (für die Nase)',
    dutch: 'drugs (neus)',
    afrikaans: 'snuif (neus)',
    russian: 'нюхательный табак',
    latvian: 'ost, ostīt, saost',
    polish: '',
    french: '',
    spanish: 'snus (nariz)',
  },
  {
    av: 25495,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(drug (leaf based) + mouth: Leaf based drug that is taken through the mouth (kerned)',
    english: 'snuff, kat, coca',
    swedish: 'snus (etc)',
    norwegian: 'snus, khat (o.l.)',
    finnish: 'nuuskattava huume (kokaiini jne.)',
    hungarian: '',
    german: 'Lutschtabak, Schweden-Snus, Qat, Koka (etc)',
    dutch: 'drugs (mond), cocaïne',
    afrikaans: 'snuif',
    russian: 'жевательный табак, снюс',
    latvian: 'šņaucams, šņaucamais ',
    polish: '',
    french: '',
    spanish: 'coca, snus',
  },
  {
    av: 25496,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(gland + blood: Gland that assists in production of blood cells) (kerned)',
    english: 'spleen',
    swedish: 'mjälte',
    norwegian: 'milt',
    finnish: 'perna',
    hungarian: '',
    german: 'Milz',
    dutch: 'milt',
    afrikaans: 'milt',
    russian: 'селезёнка',
    latvian: 'liesa',
    polish: '',
    french: '',
    spanish: 'bazo',
  },
  {
    av: 25497,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hole + medical)',
    english: 'stoma, medical hole',
    swedish: 'stoma, medicinskt hål',
    norwegian: 'stoma, medisinsk hull',
    finnish: 'avanne',
    hungarian: '',
    german: 'Stoma, Atmungsloch, Spaltöffnung',
    dutch: 'stoma',
    afrikaans: 'stoma, mediese gat',
    russian: 'стома',
    latvian: 'stoma, mākslīgi radīts medicīnisks caurums',
    polish: '',
    french: '',
    spanish: 'estoma, agujero medicinal',
  },
  {
    av: 25498,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(organ + food + container)',
    english: 'stomach, tummy, tum',
    swedish: 'magsäck',
    norwegian: 'magesekk',
    finnish: 'vatsalaukku, mahalaukku',
    hungarian: '',
    german: 'Magen',
    dutch: 'maag',
    afrikaans: 'maag',
    russian: 'желудок',
    latvian: 'vēders, puncis',
    polish: '',
    french: '',
    spanish: 'estómago, barriguita, barriga, panza',
  },
  {
    av: 25499,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(picture + body + needle: where picture + body represents tattoo [contr.], tattoo made with needle)',
    english: 'tattoo (permanent)',
    swedish: 'tatuering (permanent)',
    norwegian: 'tatovering (permanent)',
    finnish: 'tatuointi',
    hungarian: '',
    german: 'Tätowierung, Tattoo (permanent)',
    dutch: 'tattoe (permanent)',
    afrikaans: 'tatoeëermerk (permanent)',
    russian: 'татуировка (постоянная)',
    latvian: 'tetovējums (permanentais)',
    polish: '',
    french: '',
    spanish: 'tatuaje (permanente)',
  },
  {
    av: 25500,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(picture + body + attachment: where picture + body represents tattoo [contr.], tattoo made from a sticker)',
    english: 'tattoo (sticker)',
    swedish: 'tatuering (klisterbild)',
    norwegian: 'tatovering (klistremerke)',
    finnish: 'tatuointitarra',
    hungarian: '',
    german: 'Tätowierung, Tattoo (Aufkleber, Kleber, Sticker)',
    dutch: 'tattoe (sticker)',
    afrikaans: 'tatoeëermerk (plakker)',
    russian: 'татуировка (наклейка)',
    latvian: 'tetovējuma uzlīme',
    polish: '',
    french: '',
    spanish: 'tatuaje (sticker)',
  },
  {
    av: 25501,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(picture + skin)',
    english: 'tattoo, picture on skin',
    swedish: 'tatuering, bild på hud',
    norwegian: 'tatovering, bilde på hud',
    finnish: 'vartalotatuointi',
    hungarian: '',
    german: 'Tätowierung, Tattoo (Motiv mit Tinte in die Haut eingebracht)',
    dutch: 'tattoe',
    afrikaans: 'tatoeëermerk, prentjie op die vel',
    russian: 'татуировка (рисунок)',
    latvian: 'tetovējuma zīmējums uz ādas',
    polish: '',
    french: '',
    spanish: 'tatuaje',
  },
  {
    av: 25502,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rest period, break + drink: A break to have a non alcoholic drink)',
    english: 'tea break, coffee break',
    swedish: 'fikapaus',
    norwegian: 'kaffepause, tepause, drikkepause',
    finnish: 'juomatauko',
    hungarian: '',
    german: 'Kaffeepause',
    dutch: 'koffiepauze, pauze',
    afrikaans: 'teetyd, koffietyd',
    russian: 'чайная/кофейная пауза',
    latvian: 'tējas/kafijas pauze',
    polish: '',
    french: '',
    spanish: 'pausa para el café',
  },
  {
    av: 25503,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(linear thing + muscle + bone: A cord or band of inelastic tissue that connects bones and muscles with each other)',
    english: 'tendon',
    swedish: 'sena (kropp)',
    norwegian: 'sene (kropp)',
    finnish: 'jänne',
    hungarian: '',
    german: 'Sehne (Körper)',
    dutch: 'pees',
    afrikaans: 'sening',
    russian: 'сухожилие',
    latvian: 'cīpsla',
    polish: '',
    french: '',
    spanish: 'tendón',
  },
  {
    av: 25504,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + cell: An aggregation of cells forms a tissue)',
    english: 'tissue (body)',
    swedish: 'vävnad (kropp)',
    norwegian: 'cellevev',
    finnish: 'kudos',
    hungarian: '',
    german: 'Gewebe (Körper)',
    dutch: 'weefsel (lichaam)',
    afrikaans: 'liggaamsweefsel',
    russian: 'ткань (биологическая)',
    latvian: 'audi',
    polish: '',
    french: '',
    spanish: 'tejido (cuerpo)',
  },
  {
    av: 25505,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(lung(s) + tube: The tube that transports the air to and from the lungs)',
    english: 'trachea, wind pipe',
    swedish: 'luftstrupe, luftrör, trakea',
    norwegian: 'luftrør, trakea',
    finnish: 'henkitorvi',
    hungarian: '',
    german: 'Luftröhre, Trachee',
    dutch: 'luchtpijp, trachea',
    afrikaans: 'tragea, wind pyp',
    russian: 'трахея',
    latvian: 'elpvads, traheja',
    polish: '',
    french: '',
    spanish: 'tráquea, tubo de viento',
  },
  {
    av: 25506,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(medical tube, catheter, cannula + breath: A catheter inserted directly into trachea to help a person to breathe)',
    english: 'tracheotomy tube, tracheal tube',
    swedish: 'trakealtub',
    norwegian: 'trakealtube',
    finnish: 'trakeostomiaputki',
    hungarian: '',
    german: 'Endotrachealschlauch',
    dutch: 'ademhalingscanule, canule (adem)',
    afrikaans: 'trageale buis',
    russian: 'трахеостома',
    latvian: 'trahektomija',
    polish: '',
    french: '',
    spanish: 'tubo endotraqueal',
  },
  {
    av: 25507,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(arm + above)',
    english: 'upper arm',
    swedish: 'överarm ',
    norwegian: 'overarm',
    finnish: 'olkavarsi',
    hungarian: '',
    german: 'Oberarm',
    dutch: 'bovenarm',
    afrikaans: 'boarm',
    russian: 'предплечие',
    latvian: 'augšdelms',
    polish: '',
    french: '',
    spanish: 'parte superior del brazo',
  },
  {
    av: 25508,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalisation + organ + blood)',
    english: 'vascular system',
    swedish: 'vaskulärt system, kärlsystem',
    norwegian: 'vaskulært system',
    finnish: 'verenkierto',
    hungarian: '',
    german: 'Gefäßsystem',
    dutch: 'vasculairsysteem',
    afrikaans: 'vaskulêre stelsel',
    russian: 'сосудистая система',
    latvian: 'asisnsvadu sistēma',
    polish: '',
    french: '',
    spanish: 'sistema vascular',
  },
  {
    av: 25509,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + work: all days except weekend)',
    english: 'work day',
    swedish: 'arbetsdag, vardag',
    norwegian: 'arbeidsdag, hverdag',
    finnish: 'työpäivä',
    hungarian: '',
    german: '',
    dutch: 'werkdag',
    afrikaans: 'werksdag',
    russian: 'рабочий день',
    latvian: 'darbdiena',
    polish: '',
    french: '',
    spanish: 'día de trabajo',
  },
  {
    av: 25650,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + play (theatre))',
    english: 'actor',
    swedish: 'skådespelare',
    norwegian: 'skuespiller, aktør',
    finnish: '',
    hungarian: '',
    german: 'Schauspieler, Schauspielerin',
    dutch: 'acteur, toneelspeler',
    afrikaans: 'akteur',
    russian: 'актёр',
    latvian: 'aktieris, aktrise',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25651,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(blissname + girl + curiosity, curiousness, inquisitiveness)',
    english: 'Alice (in Wonderland)',
    swedish: 'Alice i Underlandet',
    norwegian: 'Alice i Eventyrland',
    finnish: '',
    hungarian: '',
    german: 'Alice im Wunderland',
    dutch: 'Alice in Wonderland',
    afrikaans: 'Alice (in Wonderland)',
    russian: 'Алиса в Стране Чудес',
    latvian: 'Alise Brīnumzemē',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25652,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(give, offer, provide-(to) + consideration, thoughtfulness)',
    english: 'altruism, selflessness',
    swedish: 'osjälviskhet, altruism',
    norwegian: 'altruisme, uegennytte',
    finnish: '',
    hungarian: '',
    german: 'Altruismus, Selbstlosigkeit',
    dutch: 'altruïsme',
    afrikaans: 'altruïsme, onselfsugtigheid',
    russian: 'альтруизм, бескорыстие',
    latvian: 'altruisms, pašaizliedzība',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25653,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(between + many)',
    english: 'among, amongst',
    swedish: 'bland',
    norwegian: 'blant',
    finnish: '',
    hungarian: '',
    german: 'unter, zwischen, inmitten, mitten unter',
    dutch: 'tussen, in het midden van',
    afrikaans: 'tussen, onder',
    russian: 'среди',
    latvian: 'pa vidu, starp',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25654,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + art)',
    english: 'artist',
    swedish: 'kostnär',
    norwegian: 'artist',
    finnish: '',
    hungarian: '',
    german: 'Künstler, Künstlerin',
    dutch: 'kunstenaar',
    afrikaans: 'kunstenaar',
    russian: 'артист',
    latvian: 'mākslinieks, māksliniece',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25655,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bread + long)',
    english: 'baguette',
    swedish: 'baguette',
    norwegian: 'baguett',
    finnish: '',
    hungarian: '',
    german: 'Baguette',
    dutch: 'stokbrood',
    afrikaans: 'baguette, Franse brood',
    russian: 'багет',
    latvian: 'bagete',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25656,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(powder + bun + up)',
    english: 'baking powder',
    swedish: 'bakpulver',
    norwegian: 'bakepulver',
    finnish: '',
    hungarian: '',
    german: 'Backpulver',
    dutch: 'bakpoeder',
    afrikaans: 'bakpoeier',
    russian: 'разрыхлитель, пекарский порошок',
    latvian: 'cepampulveris',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25657,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper, card, page + choice, selection, election)',
    english: 'ballot, voting slip',
    swedish: 'valsedel',
    norwegian: 'stemmeseddel',
    finnish: '',
    hungarian: '',
    german: 'Stimmzettel, Stimmabschnitt',
    dutch: 'stembiljet',
    afrikaans: 'stembrief',
    russian: 'избирательный бюллетень',
    latvian: 'vēlēšanu biļetens',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25658,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + grain)',
    english: 'barn',
    swedish: 'lada',
    norwegian: 'låve',
    finnish: '',
    hungarian: '',
    german: 'Scheune',
    dutch: 'graanschuur',
    afrikaans: 'stal',
    russian: 'сарай, амбар',
    latvian: 'klēts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25659,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(container + bird + egg)',
    english: 'bird nest, birdnest',
    swedish: 'fågelbo',
    norwegian: 'fuglereir, reir',
    finnish: '',
    hungarian: '',
    german: 'Vogelnest',
    dutch: 'vogelnest',
    afrikaans: 'voëlnes',
    russian: 'гнездо',
    latvian: 'ligzda',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25660,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + bird)',
    english: 'birdhouse, house for bird',
    swedish: 'fågelholk',
    norwegian: 'fuglekasse, holk',
    finnish: '',
    hungarian: '',
    german: 'Vogelhaus',
    dutch: 'nestkast, nestkastje',
    afrikaans: 'voëlhok',
    russian: 'курятник',
    latvian: 'putnu māja, putnu būris',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25661,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + day + digits (computer))',
    english: 'blog, web blog',
    swedish: 'blogg',
    norwegian: 'blogg',
    finnish: '',
    hungarian: '',
    german: 'Blog, Weblog',
    dutch: 'blog',
    afrikaans: 'web blog',
    russian: 'блог',
    latvian: 'blogs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25662,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pig + male)',
    english: 'boar',
    swedish: 'galt',
    norwegian: 'råne, galte',
    finnish: '',
    hungarian: '',
    german: 'Eber, Keiler, Wildschwein',
    dutch: 'beer (mannetjesvarken)',
    afrikaans: 'varke',
    russian: 'кабан, хряк',
    latvian: 'kuilis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25663,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + love)',
    english: 'boyfriend',
    swedish: 'pojkvän',
    norwegian: 'kjæreste (hankjønn)',
    finnish: '',
    hungarian: '',
    german: 'Freund (Liebe)',
    dutch: 'vriend (boyfriend)',
    afrikaans: 'kêrel, ou, vriend',
    russian: 'возлюбленный',
    latvian: 'iemīļotais (vīrietis)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25664,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bread + knife: bread cut into slices)',
    english: 'bread (sliced), sliced bread',
    swedish: 'bröd (skivat), skuret bröd',
    norwegian: 'brødskive',
    finnish: '',
    hungarian: '',
    german: 'Brot (aufgeschnitten), geschnittenes Brot',
    dutch: 'brood (gesneden), gesneden brood',
    afrikaans: 'gesnyde brood',
    russian: 'хлеб в нарезку',
    latvian: 'sagriezta maize',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25665,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(crust + bread)',
    english: 'bread crust',
    swedish: 'brödskorpa',
    norwegian: 'brødskorpe',
    finnish: '',
    hungarian: '',
    german: 'Brotrinde, Brotkruste',
    dutch: 'broodkorst',
    afrikaans: 'broodkorsie',
    russian: 'хлебные корочки',
    latvian: 'maizes garoza',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25666,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knife + bread)',
    english: 'bread knife',
    swedish: 'brödkniv',
    norwegian: 'brødkniv',
    finnish: '',
    hungarian: '',
    german: 'Brotmesser',
    dutch: 'broodmes',
    afrikaans: 'broodmes',
    russian: 'хлебный нож',
    latvian: 'maizes nazis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25667,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bread + fruit)',
    english: 'bread with fruit',
    swedish: 'bröd med frukt',
    norwegian: 'brød med frukt',
    finnish: '',
    hungarian: '',
    german: 'Brot mit Obst',
    dutch: 'brood met fruit',
    afrikaans: 'brood met vrugte',
    russian: 'хлеб с фруктами',
    latvian: 'maize ar augļiem',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25668,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bread + seed)',
    english: 'bread with seeds',
    swedish: 'bröd med frön',
    norwegian: 'brød med frø',
    finnish: '',
    hungarian: '',
    german: 'Brot mit Samen',
    dutch: 'granenbrood, brood met granen',
    afrikaans: 'brood met sade',
    russian: 'хлеб с семечками',
    latvian: 'sēklu maize',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25669,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(brother + husband)',
    english: "brother-in-law (husband's brother)",
    swedish: 'svåger (makens bror)',
    norwegian: 'svoger (ektemanns bror)',
    finnish: '',
    hungarian: '',
    german: 'Schwager (Bruder des Ehemannes)',
    dutch: 'schoonbroer (broer van echtgenoot), zwager(broer van echtgenoot)',
    afrikaans: 'swaer (man se broer)',
    russian: 'брат мужа, деверь',
    latvian: 'svainis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25670,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(brother + spouse)',
    english: "brother-in-law (partner's brother)",
    swedish: 'svåger (partners bror)',
    norwegian: 'svoger (partners bror)',
    finnish: '',
    hungarian: '',
    german: 'Schwager (Bruder des Partners)',
    dutch: 'schoonbroer (broer van partner), zwager(broer van partner)',
    afrikaans: 'swaer (vernoot se broer)',
    russian: 'брат партнёра',
    latvian: 'partnera brālis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25671,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(brother + wife)',
    english: "brother-in-law (wife's brother)",
    swedish: 'svåger (makas bror)',
    norwegian: 'svoger (kones bror)',
    finnish: '',
    hungarian: '',
    german: 'Schwager (Bruder der Ehefrau)',
    dutch: 'schoonbroer (broer van echtgenote), zwager (broer van echtgenote)',
    afrikaans: 'swaer (vrou se broer)',
    russian: 'брат жены, шурин',
    latvian: 'sievas brālis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25672,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(roll + imprint, depression: where imprint, depression represents soft [contr.])',
    english: 'bun (soft), roll (soft), scone, brioche',
    swedish: 'bulle (mjuk yta), scones, brioche',
    norwegian: 'bolle, brioche, rullekake, rulade, muffin',
    finnish: '',
    hungarian: '',
    german: 'Brötchen, Rundstück, Schrippe, Semmel, Rolle (weich), Brioche',
    dutch: 'broodje zacht, sandwich, bolletje (broodje)',
    afrikaans: 'broodrolletjie (sag), botterbroodjie, skon',
    russian: 'мягкая булочка, бриошь',
    latvian: 'bulciņa, smalkmaizīte',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25673,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(idea + business)',
    english: 'business idea',
    swedish: 'affärsidé',
    norwegian: 'forretningside´',
    finnish: '',
    hungarian: '',
    german: 'Geschäftsidee',
    dutch: 'business idee',
    afrikaans: 'sake, besigheids idee',
    russian: 'бизнес-идея',
    latvian: 'biznesa ideja',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25674,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plant + quill(s), spine(s))',
    english: 'cactus',
    swedish: 'kaktus',
    norwegian: 'kaktus',
    finnish: '',
    hungarian: '',
    german: 'Kaktus',
    dutch: 'cactus',
    afrikaans: 'kaktus',
    russian: 'кактус',
    latvian: 'kaktus',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25675,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(talk + back and forth + digits (computer))',
    english: 'chat (online)',
    swedish: 'chat (online)',
    norwegian: 'chatting',
    finnish: '',
    hungarian: '',
    german: 'Chat (im Internet)',
    dutch: 'chat (online)',
    afrikaans: 'gesels (aanlyn)',
    russian: 'чат (онлайн)',
    latvian: 'čats, saruna (tiešsaistē)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25676,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(chat (online) + action indicator)',
    english: 'chat (online)-(to)',
    swedish: 'chatta (online)',
    norwegian: 'chatte (å)',
    finnish: '',
    hungarian: '',
    german: 'im Internet chatten',
    dutch: 'chatten (online)',
    afrikaans: 'gesels (aanlyn) (om te)',
    russian: 'общаться в чате',
    latvian: 'čatot, sarunāties (tiešsaistē)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25677,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(cheating + action indicator)',
    english: 'cheat-(to)',
    swedish: 'fuska, lura, luras',
    norwegian: 'lure (å), bedra (å)',
    finnish: '',
    hungarian: '',
    german: 'betrügen, mogeln, schummeln',
    dutch: 'bedriegen',
    afrikaans: 'om oneerlik te wees, bedrieg (om te)',
    russian: 'обманывть, обмануть',
    latvian: 'krāpt, mānīt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25678,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + without + truth)',
    english: 'cheating',
    swedish: 'fusk, lurendrejeri',
    norwegian: 'lureri, bedrageri',
    finnish: '',
    hungarian: '',
    german: 'Betrug, Mogelei, Mogeln',
    dutch: 'bedrog',
    afrikaans: 'kullery',
    russian: 'обман, мошенничество',
    latvian: 'krāpšana, manīšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25679,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chicken (bird) + child)',
    english: 'chick',
    swedish: 'kyckling',
    norwegian: 'kylling',
    finnish: '',
    hungarian: '',
    german: 'Küken',
    dutch: 'kuiken',
    afrikaans: 'kuiken',
    russian: 'цыплёнок',
    latvian: 'cālis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25680,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + equal + classroom [contr.])',
    english: 'classmate',
    swedish: 'klasskamrat',
    norwegian: 'klassekamerat',
    finnish: '',
    hungarian: '',
    german: 'Klassenkamerad, Klassenkameradin; Mitschüler, Mitschülerin',
    dutch: 'klasgenoot, medeleerling',
    afrikaans: 'klasmaat',
    russian: 'одноклассник',
    latvian: 'klasesbiedrs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25682,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + give + help)',
    english: 'client, customer',
    swedish: 'kund, klient',
    norwegian: 'klient, kunde',
    finnish: '',
    hungarian: '',
    german: 'Kunde, Kundin; Klient, Klientin; Auftraggeber, Auftraggeberin',
    dutch: 'cliënt, klant',
    afrikaans: 'kliënt',
    russian: 'клиент, покупатель',
    latvian: 'klients, pircējs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25683,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + equal + work)',
    english: 'colleague',
    swedish: 'kollega, arbetskamrat',
    norwegian: 'kollega',
    finnish: '',
    hungarian: '',
    german: 'Kollege, Kollegin',
    dutch: 'collega',
    afrikaans: 'kollega',
    russian: 'коллега',
    latvian: 'kolēģis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25684,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + knife + grain)',
    english: 'combine (harvester)',
    swedish: 'skördetröska',
    norwegian: 'skurtresker, slåmaskin, forhøster',
    finnish: '',
    hungarian: '',
    german: 'Mähdrescher, Erntemaschine, Kombine',
    dutch: 'maaimachine',
    afrikaans: 'kombineer (stroper)',
    russian: 'комбайн для уборки урожая',
    latvian: 'kombains (ražas novākšanai)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25685,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + circle)',
    english: 'compass (drawing)',
    swedish: 'passare',
    norwegian: 'passer',
    finnish: '',
    hungarian: '',
    german: 'Zirkel',
    dutch: 'passer',
    afrikaans: ' kompas (teken)',
    russian: 'циркуль',
    latvian: 'cirkulis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25686,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fruit + evergreen tree, spruce, fir, fir tree)',
    english: 'cone, conifer cone, strobilus',
    swedish: 'kotte',
    norwegian: 'kongle (nåletre)',
    finnish: '',
    hungarian: '',
    german: 'Zapfen, Konifere',
    dutch: 'denappel',
    afrikaans: 'keëldraende boom, naaldboom, konifeer',
    russian: 'шишка',
    latvian: 'čiekurs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25687,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + middle)',
    english: 'core activity',
    swedish: 'kärnverksamhet',
    norwegian: 'core (aktivitet)',
    finnish: '',
    hungarian: '',
    german: 'Hauptaktivität, Kernaktivität',
    dutch: 'kernactiviteit ',
    afrikaans: 'kern aktiwiteit',
    russian: 'основной вид деятельности',
    latvian: 'pamatnodarbošanās',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25688,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + animal (bovine), bovine, ovine)',
    english: 'cowshed',
    swedish: 'kostall, ladugård',
    norwegian: 'fjøs',
    finnish: '',
    hungarian: '',
    german: 'Kuhstall, Viehstall',
    dutch: 'koeienstal',
    afrikaans: 'koeistal',
    russian: 'коровник',
    latvian: 'govju kūts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25689,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(wife + offspring, child)',
    english: 'daughter-in-law',
    swedish: 'svärdotter',
    norwegian: 'svigerdatter',
    finnish: '',
    hungarian: '',
    german: 'Schwiegertochter',
    dutch: 'schoondochter',
    afrikaans: 'skoondogter',
    russian: 'невестка',
    latvian: 'vedekla',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25690,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(explanation + meaning)',
    english: 'definition',
    swedish: 'definition, precisering',
    norwegian: 'definisjon, forklaring',
    finnish: '',
    hungarian: '',
    german: 'Definition',
    dutch: 'definitie',
    afrikaans: 'definisie',
    russian: 'определение',
    latvian: 'definīcija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25691,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(block, brick + number)',
    english: 'dice, die',
    swedish: 'tärning',
    norwegian: 'terning',
    finnish: '',
    hungarian: '',
    german: 'Würfel, Spielwürfel',
    dutch: 'dobbelsteen',
    afrikaans: 'dobbelsteen',
    russian: 'игральная кость',
    latvian: 'metamais kauliņš',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25692,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mind + division + 2)',
    english: 'dichotomy, duality',
    swedish: 'dikotomi',
    norwegian: 'dikotomi, begrepsmotsetning, dobbelthet, dualitet',
    finnish: '',
    hungarian: '',
    german: 'Gegensätzlichkeit, Dichotomie',
    dutch: 'dichotomie, tweeledigheid',
    afrikaans: 'digotomie, tweeledigheid, tweevoudigheid',
    russian: 'дихотомия, раздвоенность',
    latvian: 'dihotomija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25694,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + decide + without + choice)',
    english: 'dictatorship (country)',
    swedish: 'diktatur',
    norwegian: 'diktatur',
    finnish: '',
    hungarian: '',
    german: 'Diktatur',
    dutch: 'dictatuur',
    afrikaans: 'diktatorskap',
    russian: 'диктатура',
    latvian: 'diktatūra',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25695,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(question + difficult + choice)',
    english: 'dilemma',
    swedish: 'dilemma, villrådighet',
    norwegian: 'dilemma, klemme, tvilrådighet',
    finnish: '',
    hungarian: '',
    german: 'Dilemma, Zwangslage',
    dutch: 'dilemma, tweestrijd',
    afrikaans: 'dilemma',
    russian: 'дилемма',
    latvian: 'dilemma',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25696,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(wagon, cart, truck + doll: a combination of (baby carriage, buggy, pram, pushchair, stroller and doll)',
    english: 'doll pram, doll carriage',
    swedish: 'dockvagn',
    norwegian: 'dokkevogn',
    finnish: '',
    hungarian: '',
    german: 'Puppenwagen',
    dutch: 'poppenwagen',
    afrikaans: 'popstootwaentjie',
    russian: 'кукольная коляска',
    latvian: 'leļļu rati',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25697,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + doll)',
    english: 'dollhouse, doll house',
    swedish: 'dockskåp',
    norwegian: 'dokkehus',
    finnish: '',
    hungarian: '',
    german: 'Puppenhaus, Puppenstube',
    dutch: 'poppenhuis',
    afrikaans: 'pophuis',
    russian: 'кукольный домик',
    latvian: 'leļļu māja',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25698,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(science + house work, housekeeping, housework)',
    english: 'domestic science, home economics',
    swedish: 'hushållsvetenskap',
    norwegian: 'hushold, husholdningslære',
    finnish: '',
    hungarian: '',
    german: 'Hauswirtschaftslehre',
    dutch: 'economische wetenschap',
    afrikaans: 'huishoudkunde, huishoudkunde',
    russian: 'наука быта, домоводство',
    latvian: 'mājturības zinātne',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25699,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + house work, housekeeping, housework)',
    english: 'domestic science, home economics (class)',
    swedish: 'hemkunskap',
    norwegian: 'heimkunnskap, mat og helse',
    finnish: '',
    hungarian: '',
    german: 'Hauswirtschaftslehre (Unterricht)',
    dutch: 'economie (les)',
    afrikaans: 'huishoudkunde, huishoudkunde (klas)',
    russian: 'домоводство (предмет)',
    latvian: 'mājturības stunda',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25700,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rodent + sleep)',
    english: 'dormouse (sleepy rodent)',
    swedish: 'hasselmus, sovmus',
    norwegian: 'hasselmus, sovemus',
    finnish: '',
    hungarian: '',
    german: 'Bilch, Schlafmaus, Haselmaus',
    dutch: 'hazelmuis (slaperig knaagdier)',
    afrikaans: 'waaierstertmuis, bosstertmuis, relmuis (slaperig knaagdier)',
    russian: 'сонная мышь',
    latvian: 'miega pele',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25701,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dot + water, fluid, liquid)',
    english: 'drop',
    swedish: 'droppe',
    norwegian: 'dråpe',
    finnish: '',
    hungarian: '',
    german: 'Tropfen',
    dutch: 'druppel',
    afrikaans: 'druppel',
    russian: 'капля',
    latvian: 'lāse',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25702,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(work + description indicator)',
    english: 'employed, working',
    swedish: 'anställd, arbetande',
    norwegian: 'ansatt (adj.), yrkesaktiv',
    finnish: '',
    hungarian: '',
    german: 'angestellt, berufstätig',
    dutch: 'werkzaam',
    afrikaans: 'onderneming, werk',
    russian: 'работающий, трудоустроенный',
    latvian: 'strādājošs (-a)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25703,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + work + agreement)',
    english: 'employee',
    swedish: 'antälld (person)',
    norwegian: 'arbeidstaker, ansatt',
    finnish: '',
    hungarian: '',
    german: 'der Angestellte, die Angestellte; Arbeitnehmer, Arbeitnehmerin',
    dutch: 'bediende',
    afrikaans: 'werknemer',
    russian: 'сотрудник',
    latvian: 'darba ņēmējs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25704,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(triangle + 3 + equal, same)',
    english: 'equilateral triangle',
    swedish: 'triangel (liksidig), liksidig triangel',
    norwegian: 'likesidet triangel, trekant',
    finnish: '',
    hungarian: '',
    german: 'gleichseitiges Dreieck ',
    dutch: 'driehoek (gelijkzijdig)',
    afrikaans: 'gelyksydige driehoek',
    russian: 'равносторонний треугольник',
    latvian: 'vienādmalu trīsstūris',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25705,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sheep + female)',
    english: 'ewe',
    swedish: 'tacka (djur)',
    norwegian: 'søye, hunsau',
    finnish: '',
    hungarian: '',
    german: 'Mutterschaf (Tier)',
    dutch: 'ooi',
    afrikaans: 'ooi',
    russian: 'овца',
    latvian: 'aita',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25706,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(number + multiplication + 2: a number which can be divided evenly into groups of two)',
    english: 'even number',
    swedish: 'jämnt tal, jämn siffra, jämnt antal',
    norwegian: 'partall',
    finnish: '',
    hungarian: '',
    german: 'gerade Zahl',
    dutch: 'even getal',
    afrikaans: 'ewe, gelyke getal',
    russian: 'чётное число',
    latvian: 'pāra skaitlis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25707,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + digging, excavation)',
    english: 'excavator, digger, power shovel',
    swedish: 'grävmaskin, grävskopa',
    norwegian: 'gravemaskin',
    finnish: '',
    hungarian: '',
    german: 'Ausgräber, Ausgräberin ',
    dutch: 'graafmachine',
    afrikaans: 'graafmasjien',
    russian: 'экскаватар',
    latvian: 'ekskavators',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25708,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knowledge + activity + self)',
    english: 'experience',
    swedish: 'erfarenhet',
    norwegian: 'egenerfaring, erfaring',
    finnish: '',
    hungarian: '',
    german: 'Erfahrung',
    dutch: 'ervaring',
    afrikaans: 'ervaring',
    russian: 'опыт',
    latvian: 'pieredze',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25709,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(mouth + understanding, comprehension: something said to make something undertood)',
    english: 'explanation, reason',
    swedish: 'förklaring, skäl',
    norwegian: 'forklaring, begrunnelse',
    finnish: '',
    hungarian: '',
    german: 'Erklärung, Grund, Ursache',
    dutch: 'uitleg, verklaring',
    afrikaans: 'verduideliking, rede',
    russian: 'объяснение',
    latvian: 'pamatojums, iemesls',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25714,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + farm)',
    english: 'farmhouse',
    swedish: 'bondgård',
    norwegian: 'gårdsbygning',
    finnish: '',
    hungarian: '',
    german: 'Bauernhaus',
    dutch: 'huis op de boerderij',
    afrikaans: 'plaashuis',
    russian: 'фермерский дом',
    latvian: 'lauku sēta',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25715,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(father + spouse)',
    english: "father-in-law (partner's father)",
    swedish: 'svärfar',
    norwegian: 'svigerfar (partners far)',
    finnish: '',
    hungarian: '',
    german: 'Schwiegervater (Vater des Partners)',
    dutch: 'schoonvader (vader van de partner)',
    afrikaans: 'skoonvader, skoonpa (vernoot se vader/pa)',
    russian: 'тесть, свёкр',
    latvian: 'sievas tēvs, vīra tēvs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25716,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(woman + friend)',
    english: 'female friend',
    swedish: 'vän (kvinnlig)',
    norwegian: 'venninnne',
    finnish: '',
    hungarian: '',
    german: 'Freundin (freundschaftlich)',
    dutch: 'vriendin',
    afrikaans: 'vriendin',
    russian: 'подруга',
    latvian: 'draudzene',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25717,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meadow + flower)',
    english: 'flower meadow',
    swedish: 'blomsteräng',
    norwegian: 'blomstereng',
    finnish: '',
    hungarian: '',
    german: 'Blumenwiese',
    dutch: 'bloemenweide',
    afrikaans: 'blom veld',
    russian: 'цветочный луг',
    latvian: 'ziedu pļava',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25718,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(engagement + action indicator)',
    english: 'get engaged-(to)',
    swedish: 'förlova sig',
    norwegian: 'forlove seg (å)',
    finnish: '',
    hungarian: '',
    german: 'sich verloben',
    dutch: 'verloven',
    afrikaans: 'om verloof te raak',
    russian: 'помолвиться',
    latvian: 'saderināties',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25719,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(woman + love)',
    english: 'girlfriend',
    swedish: 'flickvän',
    norwegian: 'kjæreste (hunkjønn)',
    finnish: '',
    hungarian: '',
    german: 'Freundin (Liebe)',
    dutch: 'vriendin (girlfriend)',
    afrikaans: 'meisie',
    russian: 'возлюбленная',
    latvian: 'mīļotā',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25720,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(child + grandparents)',
    english: 'grandchild',
    swedish: 'barnbarn',
    norwegian: 'barnebarn',
    finnish: '',
    hungarian: '',
    german: 'Enkelkind; Enkel, Enkelin',
    dutch: 'kleinkind',
    afrikaans: 'kleinkind ',
    russian: 'внук',
    latvian: 'mazbērni',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25721,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(eat + grass + action Indicator)',
    english: 'graze-(to)',
    swedish: 'beta',
    norwegian: 'beite, gresse',
    finnish: '',
    hungarian: '',
    german: 'grasen',
    dutch: 'grazen',
    afrikaans: 'wei (om te)',
    russian: 'пастись',
    latvian: 'ganīties',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25722,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(handicraft + action Indicator)',
    english: 'handcraft, craft-(to)',
    swedish: 'slöjda, pyssla, tillverka för hand',
    norwegian: 'lage (å) (for hånd)',
    finnish: '',
    hungarian: '',
    german: 'kunstvoll fertigen, basteln, fertigen',
    dutch: 'knutselen',
    afrikaans: 'handkunswerk (om te)',
    russian: 'рукодельничать',
    latvian: 'nodarboties ar rokdarbiem',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25723,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(handmade object, handicraft + animal)',
    english: 'handmade figure, handicraft (animal)',
    swedish: 'handgjord sak (djur)',
    norwegian: 'håndlaget figur (dyr)',
    finnish: '',
    hungarian: '',
    german: 'handgemachte Figur, Handwerk (Tier)',
    dutch: 'dier (geknutseld)',
    afrikaans: 'handgemaakte figuur (dier)',
    russian: 'вещь ручной работы (животное)',
    latvian: 'rokdarbs, figūriņa (dzīvnieks)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25724,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(handmade object, handicraft + person)',
    english: 'handmade figure, handicraft (person)',
    swedish: 'handgjord sak (figur)',
    norwegian: 'håndlaget figur (menneske)',
    finnish: '',
    hungarian: '',
    german: 'handgemachte Figur, Handwerk (Person)',
    dutch: 'handgemaakt figuur',
    afrikaans: 'handgemaakte figuur (persoon)',
    russian: 'вещь ручной работы (человек)',
    latvian: 'rokdarbs, figūriņa (persona)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25725,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rodent + ear + big)',
    english: 'hare',
    swedish: 'hare',
    norwegian: 'hare',
    finnish: '',
    hungarian: '',
    german: 'Hase',
    dutch: 'haas',
    afrikaans: 'haas (wild)',
    russian: 'заяц',
    latvian: 'zaķis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25726,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(scale, measurement + height, altitude)',
    english: 'height, altitude',
    swedish: 'höjd, altitud',
    norwegian: 'høyde, høydemål',
    finnish: '',
    hungarian: '',
    german: 'Höhe, Höhepunkt',
    dutch: 'hoogte',
    afrikaans: 'hoogte',
    russian: 'шкала выстоты',
    latvian: 'augstuma mērijums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25727,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chicken (bird) + female)',
    english: 'hen',
    swedish: 'höna',
    norwegian: 'høne',
    finnish: '',
    hungarian: '',
    german: 'Henne, Huhn',
    dutch: 'hen',
    afrikaans: 'hen',
    russian: 'курица ',
    latvian: 'vista',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25728,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + chicken (bird))',
    english: 'henhouse, chicken coop',
    swedish: 'hönshus',
    norwegian: 'hønsehus',
    finnish: '',
    hungarian: '',
    german: 'Hühnerstall',
    dutch: 'kippenhok, kippenren',
    afrikaans: 'hoenderhok',
    russian: 'курятник',
    latvian: 'vistu kūts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25729,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + work + money + house)',
    english: 'home worker',
    swedish: 'person som arbetar hemifrån',
    norwegian: 'person som arbeider hjemme',
    finnish: '',
    hungarian: '',
    german: 'Heimarbeiter ',
    dutch: 'thuiswerker',
    afrikaans: 'huiswerker',
    russian: 'надомник',
    latvian: 'persona, kura strādā mājās',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25730,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(house work, housekeeping, housework + action indicator)',
    english: 'housekeep, housework-(to)',
    swedish: 'arbeta i hushållet',
    norwegian: 'gjøre husarbeid-(å)',
    finnish: '',
    hungarian: '',
    german: 'haushalten',
    dutch: 'huishouden',
    afrikaans: 'huishou (om te), om huiswerk te doen',
    russian: 'работать по дому',
    latvian: 'strādāt mājās',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25731,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + house work, housekeeping, housework)',
    english: 'housekeeper',
    swedish: 'hushållsarbetare',
    norwegian: 'hjemmearbeidende',
    finnish: '',
    hungarian: '',
    german: 'Haushälter, Haushälterin',
    dutch: 'huishoudster',
    afrikaans: 'huishoudster',
    russian: 'домохозяйка',
    latvian: 'mājsaimniece',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25732,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(layer, level + ice)',
    english: 'ice layer',
    swedish: 'islager',
    norwegian: 'islag',
    finnish: '',
    hungarian: '',
    german: 'Eisschicht',
    dutch: 'ijslaag',
    afrikaans: 'yslaag',
    russian: 'ледяной покров, слой льда',
    latvian: 'ledus kārta',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25733,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + ice skates: ice scates representing skating [contr.])',
    english: 'ice skating rink (indoor)',
    swedish: 'ishall',
    norwegian: 'ishall',
    finnish: '',
    hungarian: '',
    german: 'Eishalle, Eislaufhalle',
    dutch: 'schaatsbaan, ijspiste',
    afrikaans: 'skaatsbaan',
    russian: 'ледовый дворец, крытый каток',
    latvian: 'slidotava (telpās)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25734,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spread, paste + powdered sugar, icing sugar)',
    english: 'icing',
    swedish: 'glasyr',
    norwegian: 'glasur',
    finnish: '',
    hungarian: '',
    german: 'Glasur, Kuchenglasur',
    dutch: 'suikerglazuur',
    afrikaans: 'versiersuiker',
    russian: 'глазурь',
    latvian: 'glazūra',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25735,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cause + change, alteration)',
    english: 'influence',
    swedish: 'inflytande, påverkan',
    norwegian: 'påvirkning, innflytelse, innvirkning, influering',
    finnish: '',
    hungarian: '',
    german: 'Einfluss, Einwirkung',
    dutch: 'invloed',
    afrikaans: 'invloed',
    russian: 'влияние, воздействие',
    latvian: 'ietekme, influence',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25736,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(influence + action indicator)',
    english: 'influence, affect-(to)',
    swedish: 'ha inflytande, påverka',
    norwegian: 'påvirke (å), ha innflytelse på (å), innvirke på (å), influere (å)',
    finnish: '',
    hungarian: '',
    german: 'beeinflussen',
    dutch: 'beïnvloeden',
    afrikaans: 'beïnvloed, affekteer (om te)',
    russian: 'влиять, воздействовать',
    latvian: 'ietekmēt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25737,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(influence + description indicator)',
    english: 'influenced, affected',
    swedish: 'influerad, påverkad',
    norwegian: 'influert, påvirket',
    finnish: '',
    hungarian: '',
    german: 'beeinflusst, betroffen',
    dutch: 'beïnvloed',
    afrikaans: 'beïnvloed, geraak',
    russian: 'влияющий, воздействующий',
    latvian: 'ietekmēts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25738,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cause + want, desire + activity)',
    english: 'inspiration',
    swedish: 'inspiration',
    norwegian: 'inspirasjon, stimulering',
    finnish: '',
    hungarian: '',
    german: 'Inspiration',
    dutch: 'inspiratie',
    afrikaans: 'inspirasie',
    russian: 'вдохновение',
    latvian: 'iedvesma',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25739,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(inspiration + action indicator)',
    english: 'inspire-(to)',
    swedish: 'inspirera',
    norwegian: 'inspirere (å), stimulere (å)',
    finnish: '',
    hungarian: '',
    german: 'inspirieren, anregen, begeistern',
    dutch: 'inspireren',
    afrikaans: 'inspireer (om te)',
    russian: 'вдохновлять',
    latvian: 'iedvesmot',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25740,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(inspiration + description indicator)',
    english: 'inspired',
    swedish: 'inspirerad',
    norwegian: 'inspirert, stimulert',
    finnish: '',
    hungarian: '',
    german: 'inspiriert',
    dutch: 'geïnspireerd',
    afrikaans: 'geïnspireerde',
    russian: 'вдохновлённый',
    latvian: 'iedvesmots',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25741,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(interruption + action indicator)',
    english: 'interrupt (in conversation)-(to)',
    swedish: 'avbryta (tal)',
    norwegian: 'avbryte, forstyrre (i samtale)',
    finnish: '',
    hungarian: '',
    german: 'unterbrechen (Gespräch)',
    dutch: 'onderbreken (tijdens spreken)',
    afrikaans: 'onderbreek (in gesprek) (om te)',
    russian: 'прерывать, перебивать',
    latvian: 'pārtraukt, iejaukties (sarunā)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25742,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(say, speak, talk, tell, express-(to) + across)',
    english: 'interruption (in conversation)',
    swedish: 'avbrytande (tal)',
    norwegian: 'avbrytels, forstyrrelse (i samtale)',
    finnish: '',
    hungarian: '',
    german: 'Unterbrechung (Gespräch)',
    dutch: 'onderbreking (tijdens spreken)',
    afrikaans: 'onderbreking (in gesprek)',
    russian: 'прерывание, перебивание',
    latvian: 'pārtraukšana, iejaukšanās (sarunā)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25743,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knowledge + inside)',
    english: 'intuition',
    swedish: 'intuition',
    norwegian: 'intuisjon',
    finnish: '',
    hungarian: '',
    german: 'Intuition, Einfühlungsgabe',
    dutch: 'intuïtie',
    afrikaans: 'intuïsie',
    russian: 'интуиция',
    latvian: 'intuīcija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25744,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(triangle + 2 + same, equal, equality)',
    english: 'isosceles triangle',
    swedish: 'triangel (likbent), likbent triangel',
    norwegian: 'likebent triangel, trekant',
    finnish: '',
    hungarian: '',
    german: 'gleichschenkliges Dreieck ',
    dutch: 'gelijkbenige driehoek, driehoek (gelijkbenig)',
    afrikaans: 'gelykbenige driehoek',
    russian: 'равнобедренный треугольник',
    latvian: 'vienādsānu trīsstūris',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25745,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + exchange + work)',
    english: 'jobcentre, job-centre',
    swedish: 'arbetsförmedling, jobbcenter',
    norwegian: 'arbeidsformidling, arbeidskontor, NAV',
    finnish: '',
    hungarian: '',
    german: 'Arbeitsvermittlungsstelle',
    dutch: 'arbeidsbureau',
    afrikaans: 'werksentrum',
    russian: 'центр занятости',
    latvian: 'nodarbinātības centrs vai dienests',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25746,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + shield + knife, sword)',
    english: 'knight',
    swedish: 'riddare',
    norwegian: 'ridder',
    finnish: '',
    hungarian: '',
    german: 'Ritter',
    dutch: 'ridder',
    afrikaans: 'ridder',
    russian: 'рыцарь',
    latvian: 'bruņinieks',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25747,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to cut + grass)',
    english: 'lawn mower, mower',
    swedish: 'gräsklippare',
    norwegian: 'gressklipper',
    finnish: '',
    hungarian: '',
    german: 'Rasenmäher ',
    dutch: 'grasmachine, maaier',
    afrikaans: 'grassnyer',
    russian: 'газонокосилка',
    latvian: 'zāles pļāvējs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25749,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(longing, yearning + action indicator)',
    english: 'long for, yearn-(to)',
    swedish: 'längta',
    norwegian: 'lengte etter (å), savne (å)',
    finnish: '',
    hungarian: '',
    german: 'sich nach etwas sehnen, Sehnsucht haben',
    dutch: 'verlangen',
    afrikaans: 'verlang na (om te)',
    russian: 'страстно желать, тосковать',
    latvian: 'ilgoties',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25750,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(want, desire + intensity)',
    english: 'longing, yearning',
    swedish: 'längtan',
    norwegian: 'lengsel, savn',
    finnish: '',
    hungarian: '',
    german: 'Sehnsucht',
    dutch: 'verlangen (znw)',
    afrikaans: 'verlange, hunkering',
    russian: 'сильное желание, тоска',
    latvian: 'ilgošanās',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25751,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to make + cheese)',
    english: 'make cheese-(to)',
    swedish: 'ysta',
    norwegian: 'yste (å)',
    finnish: '',
    hungarian: '',
    german: 'käsen',
    dutch: 'kaas maken',
    afrikaans: 'maak kaas, om kaas te maak',
    russian: 'делать сыр',
    latvian: 'taisīt sieru',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25752,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(man + friend)',
    english: 'male friend',
    swedish: 'vän (manlig)',
    norwegian: 'kamerat, venn (hankjønn)',
    finnish: '',
    hungarian: '',
    german: 'Freund',
    dutch: 'vriend (mannelijk)',
    afrikaans: 'manlike vriend',
    russian: 'друг мужского пола',
    latvian: 'draugs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25753,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(marriage + description indicator)',
    english: 'married (to be)',
    swedish: 'gift (äktenskap)',
    norwegian: 'gift (å være)',
    finnish: '',
    hungarian: '',
    german: 'verheiratet mit (Ehe)',
    dutch: 'getrouwd (bijv nw)',
    afrikaans: 'getroud (om getroud te wees)',
    russian: 'замужняя, женатый',
    latvian: 'būt precētam',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25754,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mug, cup + measurement, measure)',
    english: 'measuring cup',
    swedish: 'mått (kopp)',
    norwegian: 'målekopp',
    finnish: '',
    hungarian: '',
    german: 'Messbecher ',
    dutch: 'maatbeker',
    afrikaans: 'maatkoppie',
    russian: 'мерная кружка',
    latvian: 'mēramkrūze, mēramtrauks',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25755,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to lead + without + truth + action indicator)',
    english: 'mislead-(to)',
    swedish: 'vilseleda, förvilla',
    norwegian: 'villede, føre vill, forlede (å)',
    finnish: '',
    hungarian: '',
    german: 'beirren, verleiten',
    dutch: 'misleiden',
    afrikaans: 'mislei (om te)',
    russian: 'вводить в заблуждение',
    latvian: 'maldināt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25756,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(syrup [contr.] + dark + thing indicator)',
    english: 'molasses, dark syrup, black treacle',
    swedish: 'sirap (mörk), mörk sirap, melass',
    norwegian: 'sirup (mørk), melasse',
    finnish: '',
    hungarian: '',
    german: 'Melasse, Sirup, schwarzer Rübensirup',
    dutch: 'suikerstroop, stroop',
    afrikaans: 'molasse, stroop',
    russian: 'тёмный сироп',
    latvian: 'tumšs sīrups',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25757,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(mother + spouse)',
    english: "mother-in-law (partner's mother)",
    swedish: 'svärmor',
    norwegian: 'svigermor (partners mor)',
    finnish: '',
    hungarian: '',
    german: 'Schwiegermutter (Mutter des Partners)',
    dutch: 'schoonmoeder (moeder van partner)',
    afrikaans: 'skoonmoeder, skoonma (vernoot se moeder)',
    russian: 'свекровь, тёща',
    latvian: 'sievas māte, vīra māte',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25758,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(motivation + action indicator)',
    english: 'motivate-(to)',
    swedish: 'motivera',
    norwegian: 'motivere (å)',
    finnish: '',
    hungarian: '',
    german: 'motivieren',
    dutch: 'motiveren',
    afrikaans: 'motiveer (om te)',
    russian: 'мотивировать',
    latvian: 'motivēt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25759,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(motivation + description indicator)',
    english: 'motivated',
    swedish: 'motverad',
    norwegian: 'motivert',
    finnish: '',
    hungarian: '',
    german: 'motiviert',
    dutch: 'gemotiveerd',
    afrikaans: 'gemotiveer',
    russian: 'мотивированный',
    latvian: 'motivēts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25760,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cause + feeling + activity)',
    english: 'motivation',
    swedish: 'motivation',
    norwegian: 'motivasjon',
    finnish: '',
    hungarian: '',
    german: 'Motivation',
    dutch: 'motivatie',
    afrikaans: 'motivering',
    russian: 'мотивация',
    latvian: 'motivācija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25761,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(number + multiplication + 2 + plus + 1: a number which cannot be divided evenly into groups of two)',
    english: 'odd number',
    swedish: 'udda tal, udda siffra, udda antal',
    norwegian: 'oddetall',
    finnish: '',
    hungarian: '',
    german: 'ungerade Zahl',
    dutch: 'oneven nummers',
    afrikaans: 'onewe getal',
    russian: 'нечётное число',
    latvian: 'nepāra skaitlis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25762,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + together + person)',
    english: 'partner (game, dancing, business)',
    swedish: 'partner (spel, dans, affärer)',
    norwegian: 'makker, partner (spill, dans, forretninger)',
    finnish: '',
    hungarian: '',
    german: 'Partner (Spiel, Tanz, Geschäfte)',
    dutch: 'partner (spel, dans)',
    afrikaans: 'vernoot, maat (speel, dans, besigheid)',
    russian: 'партнёр (игра, танец и пр.)',
    latvian: 'partneris (-e) (spēlē, dejā, biznesā)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25763,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(meadow + animal)',
    english: 'pasture',
    swedish: 'betesmark',
    norwegian: 'eng, beite',
    finnish: '',
    hungarian: '',
    german: 'Weide, Weideland',
    dutch: 'weide',
    afrikaans: 'weiveld',
    russian: 'пастбище',
    latvian: 'ganības',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25764,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(pasture + action indicator)',
    english: 'pasture, put out to pasture-(to)',
    swedish: 'släppa på bete',
    norwegian: 'beite, gresse, la beite (å)',
    finnish: '',
    hungarian: '',
    german: 'weiden',
    dutch: 'weiden (ww), hoeden (ww)',
    afrikaans: 'wei (gaan) (om te)',
    russian: 'пастисть',
    latvian: 'izlaist ganībās',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25765,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(patience + description indicator)',
    english: 'patient, enduring',
    swedish: 'tålmodig',
    norwegian: 'tålmodig, utholdende',
    finnish: '',
    hungarian: '',
    german: 'geduldig, beständig, andauernd',
    dutch: 'geduldig',
    afrikaans: 'geduldig, ',
    russian: 'терпеливый',
    latvian: 'pacietīgs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25766,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + get + medicine, medical practice: where medicine represents medical treatment, medical care [contr.])',
    english: 'patient (in medical care)',
    swedish: 'patient',
    norwegian: 'pasient',
    finnish: '',
    hungarian: '',
    german: 'Patient, Patientin',
    dutch: 'patiënt (medisch)',
    afrikaans: 'pasiënt (in mediese sorg)',
    russian: 'пациент',
    latvian: 'pacients (medicinā)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25767,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pig + open: where open represents wild)',
    english: 'pig (wild), boar (wild)',
    swedish: 'vildsvin',
    norwegian: 'villsvin',
    finnish: '',
    hungarian: '',
    german: 'Wildschwein',
    dutch: 'everzwijn, wildzwijn',
    afrikaans: 'vark (wilde)',
    russian: 'дикий кабан',
    latvian: 'mežakuilis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25768,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + pig)',
    english: 'piggery',
    swedish: 'svinstia, svinstall',
    norwegian: 'grisehus',
    finnish: '',
    hungarian: '',
    german: 'Schweinestall, Schweinezucht',
    dutch: 'varkenskwekerij',
    afrikaans: 'varkboerdery',
    russian: 'свинарник',
    latvian: 'cūku kūts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25769,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pig + child)',
    english: 'piglet',
    swedish: 'griskulting',
    norwegian: 'grisunge',
    finnish: '',
    hungarian: '',
    german: 'Schweinchen, Ferkel',
    dutch: 'big',
    afrikaans: 'varkie',
    russian: 'поросёнок',
    latvian: 'sivēns',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25770,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + play [contr.])',
    english: 'playhouse, play house',
    swedish: 'lekstuga',
    norwegian: 'lekehus, lekestue',
    finnish: '',
    hungarian: '',
    german: 'Spielhäuschen',
    dutch: 'speelhuis, speelhuisje',
    afrikaans: 'speel huis',
    russian: 'игровой домик',
    latvian: 'spēļu māja',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25771,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sugar [contr.] + powder + thing indicator)',
    english: 'powdered sugar, icing sugar',
    swedish: 'florsocker',
    norwegian: 'melis',
    finnish: '',
    hungarian: '',
    german: 'Puderzucker',
    dutch: 'poedersuiker, bloemsuiker',
    afrikaans: 'suiker poeier, versiersuiker',
    russian: 'сахарная пудра',
    latvian: 'pūdercukurs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25772,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(leader + school [contr.])',
    english: 'principal, headteacher',
    swedish: 'rektor',
    norwegian: 'rektor, skolestyrer',
    finnish: '',
    hungarian: '',
    german: 'Schulleiter, Schulleiterin',
    dutch: 'directeur (school)',
    afrikaans: 'skoolhoof, senior onderwyser',
    russian: 'директор школы, ректор',
    latvian: 'skolas direktors',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25773,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + win-(to))',
    english: 'prize, award, trophy',
    swedish: 'pris (tävling), pokal, buckla',
    norwegian: 'pris, trofe´, utmerkelse',
    finnish: '',
    hungarian: '',
    german: 'Preis, Auszeichnung, Trophäe, Pokal',
    dutch: 'prijs, onderscheiding, trofee',
    afrikaans: 'prys, toekenning, trofee',
    russian: 'приз, награда',
    latvian: 'balva, apbalvojums, trofeja',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25774,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(giving + dispersion, dissemination, scattering, spread, spreading)',
    english: 'publication',
    swedish: 'publikation, edition',
    norwegian: 'bekjentgjøring, kunngjøring, publisering',
    finnish: '',
    hungarian: '',
    german: 'Veröffentlichung, Publikation',
    dutch: 'publicatie',
    afrikaans: 'publikasie',
    russian: 'публикация',
    latvian: 'publikācija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25775,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(publication + action indicator)',
    english: 'publish-(to)',
    swedish: 'publicera, förlägga, ge ut (skrift)',
    norwegian: 'bekjentgjøre (å), kunngjøre (å), publisere (å)',
    finnish: '',
    hungarian: '',
    german: 'veröffentlichen, verlegen, herausgeben',
    dutch: 'publiceren',
    afrikaans: 'publiseer (om te)',
    russian: 'публиковать',
    latvian: 'publicēt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25776,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + publication)',
    english: 'publisher',
    swedish: 'förläggare, utgivare',
    norwegian: 'forlegger, utgiver',
    finnish: '',
    hungarian: '',
    german: 'Verleger, Verlegerin; Herausgeber, Herausgeberin',
    dutch: 'uitgever',
    afrikaans: 'uitgewer',
    russian: 'издатель',
    latvian: 'izdevējs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25778,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sheep + male)',
    english: 'ram',
    swedish: 'bagge',
    norwegian: 'vær',
    finnish: '',
    hungarian: '',
    german: 'Schafbock',
    dutch: 'ram',
    afrikaans: 'ram',
    russian: 'баран',
    latvian: 'auns',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25780,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(help + danger)',
    english: 'rescue',
    swedish: 'räddning, undsättning',
    norwegian: 'berging, redning, befrielse',
    finnish: '',
    hungarian: '',
    german: 'Rettung, Befreiung',
    dutch: 'redding',
    afrikaans: 'redding',
    russian: 'спасение',
    latvian: 'izglābšana',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25781,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(rescue + action indicator)',
    english: 'rescue-(to)',
    swedish: 'rädda, undsätta',
    norwegian: 'berge, redde, befri (å)',
    finnish: '',
    hungarian: '',
    german: 'retten, befreien',
    dutch: 'redden',
    afrikaans: 'red (om te)',
    russian: 'спасать',
    latvian: 'izglābt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25782,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(triangle + angle (right), right angle)',
    english: 'right triangle',
    swedish: 'triangel (rätvinklig), rätvinklig triangel',
    norwegian: 'rettvinklet trekant, triangel',
    finnish: '',
    hungarian: '',
    german: 'rechtwinkliges Dreieck',
    dutch: 'rechthoekige driehoek, driehoek (rechthoekig)',
    afrikaans: 'reg driehoek',
    russian: 'прямоугольный треугольник',
    latvian: 'taisnleņķa trīstūris',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25784,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(castle + deletion, cancellation, destruction)',
    english: 'ruin (castle), castle ruin',
    swedish: 'slottsruin',
    norwegian: 'ruin, slottsruin',
    finnish: '',
    hungarian: '',
    german: 'Schlossruine, Burgruine',
    dutch: 'ruïne (kasteel)',
    afrikaans: 'kasteel ruine',
    russian: 'руины замка',
    latvian: 'pilsdrupas',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25785,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to sell)',
    english: 'salesperson, shop owner',
    swedish: 'försäljare, säljare',
    norwegian: 'ekspeditør, selger',
    finnish: '',
    hungarian: '',
    german: 'Verkäufer, Verkäuferin; Händler, Händlerin ',
    dutch: 'verkoper',
    afrikaans: 'verkoopspersoon, winkeleienaar',
    russian: 'продавец',
    latvian: 'pardevējs, veikala īpašnieks',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25786,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(triangle + different)',
    english: 'scalene triangle',
    swedish: 'triangel (oliksidig), oliksidig triangel',
    norwegian: 'ulikesidet trekant, triangel',
    finnish: '',
    hungarian: '',
    german: 'ungleichseitiges Dreieck',
    dutch: 'ongelijkzijdige driehoek, driehoek (ongelijkzijdig)',
    afrikaans: 'ongelyksydige driehoek',
    russian: 'разносторонний треугольник',
    latvian: 'dažādmalu trīsstūris',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25787,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(scepticism + description indicator)',
    english: 'sceptical, skeptical, questioning',
    swedish: 'skeptisk, tvivlande',
    norwegian: 'skeptisk, spørrende, tvilende',
    finnish: '',
    hungarian: '',
    german: 'skeptisch, kritisch',
    dutch: 'sceptisch',
    afrikaans: 'skepties',
    russian: 'скептичный, сомневающийся',
    latvian: 'skeptisks',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25788,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(doubt + opinion)',
    english: 'scepticism, skepticism',
    swedish: 'skepsis, skepticism, tvivel',
    norwegian: 'skeptisisme, skepsis, tvil',
    finnish: '',
    hungarian: '',
    german: 'Skepsis, Skeptizismus, Zweifel',
    dutch: 'sceptisme',
    afrikaans: 'skeptisisme',
    russian: 'скептицизм, сомнение',
    latvian: 'skepticisms',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25789,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + equal + school [contr.])',
    english: 'schoolmate',
    swedish: 'skolkamrat',
    norwegian: 'skolekamerat',
    finnish: '',
    hungarian: '',
    german: 'Mitschüler, Mitschülerin; Schulfreund, Schulfreundin',
    dutch: 'klasgenoot, medeleerling',
    afrikaans: 'skoolmaat',
    russian: 'школьный друг',
    latvian: 'skolas biedrs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25790,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work of art, art object + 3 + space, dimension)',
    english: 'sculpture',
    swedish: 'skulptur, staty',
    norwegian: 'skulptur, statue',
    finnish: '',
    hungarian: '',
    german: 'Skulptur',
    dutch: 'beeldhouwwerk',
    afrikaans: 'beeldhouwerk',
    russian: 'скульптура',
    latvian: 'skulptūra',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25791,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(flour + up)',
    english: 'self-raising flour',
    swedish: 'mjöl med jäsmedel',
    norwegian: 'mel selvhevende',
    finnish: '',
    hungarian: '',
    german: 'mit Backpulver gemischtes Mehl ',
    dutch: 'bloem (zelfrijzende)',
    afrikaans: 'bruismeel',
    russian: 'дрожжевая мука',
    latvian: 'milti ar raugu',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25792,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(angle (right), right angle + thing indicator) - (character with thing indicator)',
    english: 'set square',
    swedish: 'vinkelhake',
    norwegian: 'vinkelhake',
    finnish: '',
    hungarian: '',
    german: 'Geodreieck, Zeichendreieck, Zeichenwinkel',
    dutch: 'hoek (rechte hoek)',
    afrikaans: 'stel vierkante',
    russian: 'угольник',
    latvian: 'taisnstūris',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25793,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + knife, sword)',
    english: 'sheath',
    swedish: 'knivslida, svärdslida',
    norwegian: 'slire',
    finnish: '',
    hungarian: '',
    german: 'Scheide (für Schwert, Messer, etc.)',
    dutch: 'schede (zwaard)',
    afrikaans: 'skede',
    russian: 'ножны',
    latvian: 'maksts (naža)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25794,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + sheep)',
    english: 'sheep shed, sheep barn',
    swedish: 'fårhus, fårstall',
    norwegian: 'sauefjøs',
    finnish: '',
    hungarian: '',
    german: 'Schafstall ',
    dutch: 'schapenstal',
    afrikaans: 'skaapskuur',
    russian: 'овчарня',
    latvian: 'aitu kūts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25795,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(sister + husband)',
    english: "sister-in-law (husband's sister)",
    swedish: 'svägerska (makes syster)',
    norwegian: 'svigerinne (ektemanns søster)',
    finnish: '',
    hungarian: '',
    german: 'Schwägerin (Schwester des Ehemannes)',
    dutch: 'schoonzus (zus van echtgenoot)',
    afrikaans: 'skoonsuster (man se suster)',
    russian: 'сестра мужа, золовка',
    latvian: 'vīra māsa',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25796,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(sister + spouse)',
    english: "sister-in-law (partner's sister)",
    swedish: 'svägerska (partners syster)',
    norwegian: 'svigerinne (partners søster)',
    finnish: '',
    hungarian: '',
    german: 'Schwägerin (Schwester des Partners)',
    dutch: 'schoonzus (zus van partner)',
    afrikaans: 'skoonsuster (vennoot se suster)',
    russian: 'золовка, свояченица',
    latvian: 'partnera māsa',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25797,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(sister + wife)',
    english: "sister-in-law (wife's sister)",
    swedish: 'svägerska (makas syster)',
    norwegian: 'svigerinne (kones søster)',
    finnish: '',
    hungarian: '',
    german: 'Schwägerin (Schwester der Ehefrau)',
    dutch: 'schoonzus (zus van echtgenote)',
    afrikaans: 'skoonsuster',
    russian: 'сестра жены, свояченица',
    latvian: 'sievas māsa',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25798,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knife + animal)',
    english: 'slaughter',
    swedish: 'slakt',
    norwegian: 'slakt, slakting',
    finnish: '',
    hungarian: '',
    german: 'Schlacht, Schlachtung',
    dutch: 'slachting',
    afrikaans: 'slagter',
    russian: 'забой, убой (скота)',
    latvian: 'kaušana (dzīvnieku)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25799,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(slaughter + action indicator)',
    english: 'slaughter-(to)',
    swedish: 'slakta',
    norwegian: 'slakte (å)',
    finnish: '',
    hungarian: '',
    german: 'schlachten',
    dutch: 'slachten',
    afrikaans: 'slag (om te)',
    russian: 'забивать скот',
    latvian: 'kaut (dzīvniekus)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25800,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + slaughter)',
    english: 'slaughterer',
    swedish: 'slaktare',
    norwegian: 'slakter',
    finnish: '',
    hungarian: '',
    german: ' Schlachter, Schlächter',
    dutch: 'slachter',
    afrikaans: 'slagter',
    russian: 'мясник',
    latvian: 'kāvējs, miesnieks',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25801,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + slaughter)',
    english: 'slaughterhouse, abattoir',
    swedish: 'slakteri, slakthus',
    norwegian: 'slakteri',
    finnish: '',
    hungarian: '',
    german: 'Schlachthof, Schlachterei, Schlachthaus',
    dutch: 'slachthuis',
    afrikaans: 'slagpale, abattoir',
    russian: 'скотобойня',
    latvian: 'kautuve',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25802,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(slice + bread + thing indicator)',
    english: 'slice of bread, bread slice',
    swedish: 'brödskiva',
    norwegian: 'brødskive, brødstykke',
    finnish: '',
    hungarian: '',
    german: 'Brotscheibe, Scheibe Brot',
    dutch: 'boterham',
    afrikaans: 'sny brood',
    russian: 'ломтик хлеба',
    latvian: 'maizes sķēle',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25803,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(downward and forward + action indicator)',
    english: 'slide, skid, slip-(to)',
    swedish: 'kana, glida, rutscha',
    norwegian: 'gli, skli, ake, rutsje (å)',
    finnish: '',
    hungarian: '',
    german: 'gleiten, rutschen, schleudern, schlüpfen',
    dutch: 'glijden, uitglijden',
    afrikaans: 'gly (om te)',
    russian: 'скользить',
    latvian: 'noslīdēt, paslīdēt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25804,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(digital device + telephone)',
    english: 'smartphone, digital phone',
    swedish: 'mobiltelefon, mobil, smartphone',
    norwegian: 'mobil, mobiltelefon, smarttelefon',
    finnish: '',
    hungarian: '',
    german: 'Handy, Smartphone',
    dutch: 'smartphone ',
    afrikaans: 'slimifoon, digitale telefoon',
    russian: 'смартфон, цифровой телефон',
    latvian: 'viedtālrunis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25805,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(husband + offspring: the husband of a son or daughter)',
    english: 'son-in-law',
    swedish: 'svärson',
    norwegian: 'svigersønn',
    finnish: '',
    hungarian: '',
    german: 'Schwiegersohn',
    dutch: 'schoonzoon',
    afrikaans: 'skoonseun',
    russian: 'зять',
    latvian: 'znots',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25806,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pig + female)',
    english: 'sow',
    swedish: 'sugga, so',
    norwegian: 'gris (hunkjønn), purke, sugge, so',
    finnish: '',
    hungarian: '',
    german: 'Sau',
    dutch: 'zeug',
    afrikaans: 'sog',
    russian: 'свиноматка',
    latvian: 'sivēnmāte',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25807,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to talk + limited time)',
    english: 'speaker, lecturer',
    swedish: 'talare, föreläsare',
    norwegian: 'taler, foreleser, foredragsholder',
    finnish: '',
    hungarian: '',
    german: 'Redner, Rednerin; Specher, Sprecherin',
    dutch: 'spreker, lector',
    afrikaans: 'spreker, dosent',
    russian: 'докладчик, лектор',
    latvian: 'ziņotājs, runātājs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25808,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(software, computer program, application, app + talk + pen: software that recognizes and transcribes speech)',
    english: 'speech recognition',
    swedish: 'taligenkänning',
    norwegian: 'talegjenkjenning',
    finnish: '',
    hungarian: '',
    german: 'Sprachanalyse, Spracherkennung',
    dutch: 'spraakherkenning',
    afrikaans: 'spraakherkenning',
    russian: 'распознование речи',
    latvian: 'runas atpazīšana (datorizēta programma)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25809,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth, fabric, material, textile, net + spider)',
    english: 'spider web, cobweb, orb web',
    swedish: 'spindelnät',
    norwegian: 'spindelvev, edderkoppnett',
    finnish: '',
    hungarian: '',
    german: 'Spinnennetz, Spinngewebe',
    dutch: 'spinnenweb',
    afrikaans: 'spinnerak, spinnekop web',
    russian: 'паутина',
    latvian: 'zirnekļa tīkls',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25810,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + sport)',
    english: 'sports centre',
    swedish: 'sporthall',
    norwegian: 'idrettshall, sportssenter',
    finnish: '',
    hungarian: '',
    german: 'Sportzentrum, Sportgelände',
    dutch: 'sportcentrum',
    afrikaans: 'sportsentrum',
    russian: 'спортивный центр',
    latvian: 'sporta centrs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25811,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(daughter + step-parent)',
    english: 'stepdaughter',
    swedish: 'styvdotter',
    norwegian: 'stedatter',
    finnish: '',
    hungarian: '',
    german: 'Stieftochter ',
    dutch: 'stiefdochter',
    afrikaans: 'stiefdogter',
    russian: 'падчерица',
    latvian: 'audžu meita',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25813,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(son + step-parent)',
    english: 'stepson',
    swedish: 'styvson',
    norwegian: 'stesønn',
    finnish: '',
    hungarian: '',
    german: 'Stiefsohn',
    dutch: 'stiefzoon',
    afrikaans: 'stiefseun',
    russian: 'пасынок',
    latvian: 'audžu dēls',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25814,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plan + stairs: plan to reach a goal step by step)',
    english: 'strategy',
    swedish: 'strategi, taktik',
    norwegian: 'strategi, teknikk',
    finnish: '',
    hungarian: '',
    german: 'Strategie',
    dutch: 'strategie',
    afrikaans: 'strategie',
    russian: 'стратегия',
    latvian: 'stratēģija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25815,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sugar [contr.] + block, brick + thing indicator)',
    english: 'sugar lump, cube (sugar)',
    swedish: 'sockerbit',
    norwegian: 'sukkerbit',
    finnish: '',
    hungarian: '',
    german: 'Würfelzucker',
    dutch: 'suikerklontje',
    afrikaans: 'suiker klont klontjie',
    russian: 'сахар кусковой',
    latvian: 'cukurgrauds',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25816,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(around + description indicator)',
    english: 'surrounded, encircled, surrounding',
    swedish: 'omgiven, omringad, omgivande',
    norwegian: 'omgitt, omringet',
    finnish: '',
    hungarian: '',
    german: 'umgeben von, eingekreist, umliegend, umzingelnd',
    dutch: 'omcirkeld, omgeven',
    afrikaans: 'omring',
    russian: 'окружающий, окружённый',
    latvian: 'ieskauj, ietver',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25817,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + swimming)',
    english: 'swim centre',
    swedish: 'badhus, simhall',
    norwegian: 'svømmesenter, badesenter, badeland',
    finnish: '',
    hungarian: '',
    german: 'Hallenbad, Hallenschwimmbad',
    dutch: 'zwembad (gebouw)',
    afrikaans: 'swemskool, swemsentrum',
    russian: 'плавательный центр',
    latvian: 'peldēšanas centrs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25818,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + swimming)',
    english: 'swimming hall, indoor swimming pool',
    swedish: 'simhall',
    norwegian: 'svømmehall, svømmebasseng innendørs',
    finnish: '',
    hungarian: '',
    german: 'Schwimmhalle, Hallenbad',
    dutch: 'binnenzwembad ',
    afrikaans: 'swemsaal, binnenshuise swembad',
    russian: 'плавательный зал',
    latvian: 'peldēšanas zāle, baseins',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25819,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(speech + digits (computer)',
    english: 'synthetic speech, text-to-speech, tts',
    swedish: 'talsyntes, syntetiskt tal, text-till-tal',
    norwegian: 'talesyntese, syntetisk tale, tekst til tale',
    finnish: '',
    hungarian: '',
    german: 'synthetischer Sprache, Text-To-Speech',
    dutch: 'synthetische spraak, spraak (synthetisch)',
    afrikaans: 'sintetiese spraak, teks na spraak',
    russian: 'синтетическая речь',
    latvian: 'sintētiska runa',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25820,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(digital device + enclosure: the enclosure representing the touch screen) SYMBOL SYNONYM',
    english: 'tablet computer, tablet, tablet PC (1)',
    swedish: 'datorplatta, pekdator (1)',
    norwegian: 'nettbrett',
    finnish: '',
    hungarian: '',
    german: 'Tablet-Computer, Tablet-PC, Tablet (1)',
    dutch: 'tablet computer, tablet (computer) (1)',
    afrikaans: 'tabletrekenaar (1)',
    russian: 'планшет, планшетный ПК (1)',
    latvian: 'planšete (PC) (1)',
    polish: '',
    french: 'tablette PC, tablette électronique, ordinateur tablette (1)',
    spanish: 'tablet PC (1)',
  },
  {
    av: 25821,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shell, crust + corn)',
    english: 'taco, taco shell',
    swedish: 'tacoskal',
    norwegian: 'taco, tacoskjell',
    finnish: '',
    hungarian: '',
    german: 'Tacos, Taco Shells',
    dutch: 'taco',
    afrikaans: 'taco skulp',
    russian: 'тако',
    latvian: 'tako',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25823,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + work)',
    english: 'unemployed',
    swedish: 'arbetslös',
    norwegian: 'arbeidsløs',
    finnish: '',
    hungarian: '',
    german: 'arbeitslos',
    dutch: 'werkloos',
    afrikaans: 'werklose',
    russian: 'безработный',
    latvian: 'bezdarbnieks',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25824,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hole + water) ',
    english: 'well, water well',
    swedish: 'brunn, källa, vattenkälla',
    norwegian: 'brønn, kilde, vannkilde',
    finnish: '',
    hungarian: '',
    german: 'Brunnen, Quelle, Brunnenwasser, Wasserbrunnen',
    dutch: 'waterput, waterbron',
    afrikaans: 'put, watergat',
    russian: 'родник, скважина, колодец',
    latvian: 'aka, ūdens aka',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25825,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(volunteering + description indicator)',
    english: 'voluntary',
    swedish: 'frivillig, ideell, volontär',
    norwegian: 'frivillig',
    finnish: '',
    hungarian: '',
    german: ' freiwillig, ehrenamtlich',
    dutch: 'vrijwillig',
    afrikaans: 'vrywillige',
    russian: 'добровольный, волонтёрский',
    latvian: 'brīvprātīgs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25826,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + without + money)',
    english: 'voluntary work, unpaid work',
    swedish: 'frivilligt arbete, ideellt arbete, volontärarbete',
    norwegian: 'frivillig arbeid, arbeid frivillig, arbeid ubetalt',
    finnish: '',
    hungarian: '',
    german: 'Freiwilligenarbeit, unbezahlte Arbeit',
    dutch: 'vrijwilligerswerk',
    afrikaans: 'onbetaalde werk, vrywillige werk',
    russian: 'волонтёрская работа',
    latvian: 'brīvprātīgais darbs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25827,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(help + free)',
    english: 'volunteering',
    swedish: 'frivillighet, idealitet',
    norwegian: 'frivillighet',
    finnish: '',
    hungarian: '',
    german: 'ehrenamtliche Arbeit',
    dutch: 'vrijwillig (zelfstandig nw)',
    afrikaans: 'vrywilliglik',
    russian: 'волонтёрство',
    latvian: 'nodarboties ar brīvprātīgo darbu',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25828,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(working from home + action indicator)',
    english: 'work from home-(to)',
    swedish: 'arbeta hemifrån',
    norwegian: 'arbeide hjemmefra (betalt) (å)',
    finnish: '',
    hungarian: '',
    german: 'von zuhause aus arbeiten',
    dutch: 'thuiswerken',
    afrikaans: 'om van die huis af te werk',
    russian: 'работать на дому',
    latvian: 'strādāt no mājām',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25829,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + money + house)',
    english: 'working from home',
    swedish: 'arbete hemifrån',
    norwegian: 'hjemmearbeid (betalt)',
    finnish: '',
    hungarian: '',
    german: 'Arbeit von zuhause aus',
    dutch: 'werk (thuis), thuiswerk',
    afrikaans: 'werk van die huis af',
    russian: 'надомная работа',
    latvian: 'strādāšana no mājām',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25830,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(micro-organism + roll, bun + up)',
    english: 'yeast',
    swedish: 'jäst',
    norwegian: 'gjær',
    finnish: '',
    hungarian: '',
    german: 'Hefe',
    dutch: 'gist',
    afrikaans: 'gis',
    russian: 'дрожжи',
    latvian: 'raugs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25831,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(possibility + description indicator)',
    english: 'possible',
    swedish: 'möjlig, eventuell',
    norwegian: 'mulig',
    finnish: 'mahdollinen',
    hungarian: 'lehetséges',
    german: 'möglich',
    dutch: 'mogelijk',
    afrikaans: 'moontlik',
    russian: 'возможный',
    latvian: 'iespējams',
    polish: 'możliwe, ewentualne',
    french: 'possible, réalisable, éventuel',
    spanish: 'posible',
  },
  {
    av: 25832,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(scepticism + action indicator)',
    english: 'question, be sceptical, doubt-(to)',
    swedish: 'ifrågasätta, vara skeptisk, betvivla',
    norwegian: 'betvile (å), sette spørsmål ved (å), være skeptisk (å)',
    finnish: '',
    hungarian: '',
    german: 'in Frage stellen, skeptisch sein, bezweifeln',
    dutch: 'twijfelen, aarzelen',
    afrikaans: 'skepties (om skepties te wees), twyfel (om te)',
    russian: 'сомневаться',
    latvian: 'šaubīties, būt skeptiskam',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25840,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(number + year)',
    english: 'age',
    swedish: 'ålder',
    norwegian: 'alder',
    finnish: '',
    hungarian: '',
    german: 'Alter',
    dutch: 'leeftijd',
    afrikaans: 'ouderdom',
    russian: 'возраст',
    latvian: 'vecums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25841,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(similar + dwarf planet)',
    english: 'asteroid',
    swedish: 'asteroid',
    norwegian: 'asteroide',
    finnish: '',
    hungarian: '',
    german: 'Asteroid',
    dutch: 'asteroïde',
    afrikaans: 'asteroïde',
    russian: 'астероид',
    latvian: 'astroīds',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25842,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(information + position + body: information to the brain about body position)',
    english: 'balance, sense of balance',
    swedish: 'balans, balanssinne',
    norwegian: 'balanse, balanseevne',
    finnish: '',
    hungarian: '',
    german: 'Gleichgewicht, Gleichgewichtssinn',
    dutch: 'evenwicht, evenwichtszin',
    afrikaans: 'gevoel van balans, balans',
    russian: 'баланс, равновесие',
    latvian: 'līdzsvars, balans',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25843,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + without + fall, drop, spill, tumble)',
    english: 'balance (general), poise',
    swedish: 'balans (generellt)',
    norwegian: 'balanse (generell)',
    finnish: '',
    hungarian: '',
    german: 'Gleichgewicht (generell)',
    dutch: 'evenwicht',
    afrikaans: 'balans (algemeen)',
    russian: 'баланс, уравновешенность',
    latvian: 'līdzsvarotība',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25844,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(balance (general), poise + action indicator)',
    english: 'balance (general), poise-(to)',
    swedish: 'hålla balansen',
    norwegian: 'holde balansen (å)',
    finnish: '',
    hungarian: '',
    german: 'balancieren',
    dutch: 'in evenwicht zijn, balanceren, evenwicht houden',
    afrikaans: 'balans (algemeen) (om te)',
    russian: 'держать равновесие',
    latvian: 'turēt līdzsvaru',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25845,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(walk, go-(to) + without + fall, drop, spill, tumble + action indicator: walking without falling, change classifier to “sit”, when more appropriate)',
    english: 'balance (walking, standing)-(to)',
    swedish: 'balansera (stående och gående)',
    norwegian: 'balansere (gående, stående) (å)',
    finnish: '',
    hungarian: '',
    german: 'balancieren (stehend und gehend)',
    dutch: 'balanceren (wandelen, staan), evenwicht houden ',
    afrikaans: 'balanseer (om te)',
    russian: 'балансировать (ходьба, стояние)',
    latvian: 'turēt līdzsvaru (ejot, stāvot)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25846,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(collection + stone + grave)',
    english: 'barrow, grave mound',
    swedish: 'dös, gånggrift etc',
    norwegian: 'gravrøys, gravhaug',
    finnish: '',
    hungarian: '',
    german: ' Egge, Grabhügel ',
    dutch: 'grafheuvel',
    afrikaans: 'graf heuwel',
    russian: 'курган, могильный холм',
    latvian: 'kapu uzbērums, kurgāns',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25847,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rule, regulation + pool)',
    english: 'bathing rule(s)',
    swedish: 'badregel, badregler (plur)',
    norwegian: 'baderegel',
    finnish: '',
    hungarian: '',
    german: 'Baderegeln',
    dutch: 'zwemreglement',
    afrikaans: 'badreël(s)',
    russian: 'правила купания',
    latvian: 'baseina izmantošanas noteikumi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25848,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lamp [contr.] + bike + thing indicator)',
    english: 'bike lamp',
    swedish: 'cykellampa',
    norwegian: 'sykkellykt',
    finnish: '',
    hungarian: '',
    german: 'Fahrradlicht, Fahrradlampe',
    dutch: 'fietslamp',
    afrikaans: 'fietslamp',
    russian: 'велосипедная лампа',
    latvian: 'velosipēda lampa',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25849,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(tree + white + north: tree with white trunk, birch is typical in the north)',
    english: 'birch',
    swedish: 'björk',
    norwegian: 'bjørk',
    finnish: '',
    hungarian: '',
    german: 'Birke',
    dutch: 'berk',
    afrikaans: 'berke',
    russian: 'берёза',
    latvian: 'bērzs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25850,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + food + comma + bird: place to feed [contr.] birds)',
    english: 'birdfeeder, bird table',
    swedish: 'fågelbord',
    norwegian: 'fuglebrett',
    finnish: '',
    hungarian: '',
    german: 'Futterhäuschen, Futterplatz für Vögel',
    dutch: 'voedertafel (vogel)',
    afrikaans: 'voëlvoerder',
    russian: 'кормушка для птиц',
    latvian: 'putnu barotava',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25851,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + thick)',
    english: 'cardboard, paperboard',
    swedish: 'kartong (papper), tjockt papper',
    norwegian: 'papp, kartong',
    finnish: '',
    hungarian: '',
    german: 'Pappe, Karton',
    dutch: 'kaft',
    afrikaans: 'karton bord',
    russian: 'картон',
    latvian: 'kartons',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25852,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation:
      '(game + crown: crown representing king [contr.], the king is the target of the game)',
    english: 'chess',
    swedish: 'schack',
    norwegian: 'sjakk',
    finnish: '',
    hungarian: '',
    german: 'Schach',
    dutch: 'schaakspel',
    afrikaans: 'skaak',
    russian: 'шахматы',
    latvian: 'šahs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25853,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(candy + teeth: candy to chew)',
    english: 'chewing-gum',
    swedish: 'tuggummi',
    norwegian: 'tyggegummi',
    finnish: '',
    hungarian: '',
    german: 'Kaugummi',
    dutch: 'kauwgom',
    afrikaans: 'kougom',
    russian: 'жевательная резинка',
    latvian: 'kožļājamā gumija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25854,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + clothes + neck [body])',
    english: 'collar',
    swedish: 'krage',
    norwegian: 'krage',
    finnish: '',
    hungarian: '',
    german: 'Kragen',
    dutch: 'kraag',
    afrikaans: 'kraag',
    russian: 'воротник',
    latvian: 'apkaklīte',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25855,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + eye: the cornea covers the eye)',
    english: 'cornea',
    swedish: 'hornhinna, cornea',
    norwegian: 'hornhinne, cornea',
    finnish: '',
    hungarian: '',
    german: 'Hornhaut des Auges, Cornea',
    dutch: 'cornea, hoornvlies',
    afrikaans: 'kornea',
    russian: 'роговица',
    latvian: 'radzene',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25856,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(make + invisible + description indicator: made invisible)',
    english: 'covered, hidden',
    swedish: 'gömd, täckt, osynliggjord',
    norwegian: 'gjemt, dekket, usynlig',
    finnish: '',
    hungarian: '',
    german: 'bedeckt, zugedeckt, versteckt',
    dutch: 'verstopt, verborgen',
    afrikaans: 'gedek, verborge',
    russian: 'невидимый, скрытый',
    latvian: 'paslēptais, noslēptais',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25857,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(factory + milk)',
    english: 'dairy',
    swedish: 'mejeri',
    norwegian: 'meieri',
    finnish: '',
    hungarian: '',
    german: 'Molkerei',
    dutch: 'melkerij',
    afrikaans: 'suiwelprodukte',
    russian: 'молочный завод',
    latvian: 'piena kombināts, pienotava',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25858,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(minus + light)',
    english: 'darkness',
    swedish: 'mörker',
    norwegian: 'mørke',
    finnish: '',
    hungarian: '',
    german: 'Dunkelheit, Finsternis',
    dutch: 'donker (zelfs nw)',
    afrikaans: 'donkerte, duister, duisternis',
    russian: 'темнота',
    latvian: 'tumsa',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25859,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hole + animal: the hole is the entrance to a hidden place)',
    english: 'den, lair',
    swedish: 'lya, kula, håla, gryt',
    norwegian: 'hi, hule',
    finnish: '',
    hungarian: '',
    german: 'Bude, Höhle, Versteck',
    dutch: 'hol (dier)',
    afrikaans: 'lêplek',
    russian: 'логово, берлога',
    latvian: 'ala, midzenis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25860,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(density + description indicator)',
    english: 'dense, thick, compact, tight, jammed',
    swedish: 'tät, tjock, kompakt',
    norwegian: 'tett, tykt, kompakt',
    finnish: '',
    hungarian: '',
    german: 'dicht, dick, kompakt, eng',
    dutch: 'compact, strak',
    afrikaans: 'digte, duk, kompak, vas, vasgesteek',
    russian: 'плотный, густой, компактный',
    latvian: 'biezs, kompakts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25861,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + thing + closeness)',
    english: 'density, denseness, compactness, tightness (general)',
    swedish: 'täthet, kompakthet, (allmänt)',
    norwegian: 'tetthet, tykkelse',
    finnish: '',
    hungarian: '',
    german: 'Dichte, Dichtheit, Konzentration (generell)',
    dutch: 'densiteit, compactheid',
    afrikaans: 'digtheid, kompaktheid, benoude (algemene)',
    russian: 'плотность, компактность',
    latvian: 'biezums, kompaktums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25862,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(measurement + thing + closeness: the spatial property of being crowded together)',
    english: 'density, denseness, concentration (measurement)',
    swedish: 'täthet, koncentration (mått)',
    norwegian: 'tetthet, konsentrasjon (mål)',
    finnish: '',
    hungarian: '',
    german: 'Dichte, Dichtheit, Konzentration (Maß)',
    dutch: 'densiteit, concentratie (meetwaarde)',
    afrikaans: 'digtheid, konsentrasie, mate, meet',
    russian: 'плотность, концентрация (измерение)',
    latvian: 'koncentrācija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25863,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(disagreement + action indicator)',
    english: 'disagree, discord, disaccord-(to)',
    swedish: 'vara oense, vara osams',
    norwegian: 'være uenig (å)',
    finnish: '',
    hungarian: '',
    german: 'widersprechen',
    dutch: 'oneens zijn',
    afrikaans: 'verskil (om te)',
    russian: 'не соглашаться',
    latvian: 'nepiekrist',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25864,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + feeling + agreement)',
    english: 'disagreement, discord',
    swedish: 'oenighet, skiljaktighet',
    norwegian: 'uenighet, uoverensstemmelse',
    finnish: '',
    hungarian: '',
    german: 'Meinungsverschiedenheit, Uneinigkeit',
    dutch: 'onenigheid',
    afrikaans: 'onenigheid, onmin',
    russian: 'несогласие, раздор',
    latvian: 'nesaprašanās',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25865,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(disagreement + description indicator)',
    english: 'discordant',
    swedish: 'oense, osams',
    norwegian: 'uenig',
    finnish: '',
    hungarian: '',
    german: 'widersprechend, disharmonisch, uneinig',
    dutch: 'oneens',
    afrikaans: 'afwyk',
    russian: 'несогласный',
    latvian: 'pretrunīgs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25866,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + diving (activity))',
    english: 'diver (active under water)',
    swedish: 'dykare',
    norwegian: 'dykker',
    finnish: '',
    hungarian: '',
    german: 'Taucher (aktiv unter Wasser)',
    dutch: 'duiker (actie onder water)',
    afrikaans: 'duiker (aktiwiteit onder water)',
    russian: 'дайвер, водолаз',
    latvian: 'ūdens līdējs (-a), nirējs (-a)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25867,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + diving (sport))',
    english: 'diver (jump)',
    swedish: 'simhoppare',
    norwegian: 'stuper',
    finnish: '',
    hungarian: '',
    german: 'Springer, Turmspringer',
    dutch: 'duiker (sport), schoonspringer',
    afrikaans: 'duiker (spring)',
    russian: 'прыгун в воду',
    latvian: 'trampalīnlēcējs (ūdenī)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25868,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + under + water)',
    english: 'diving, activity under water',
    swedish: 'diving, activity under water',
    norwegian: 'dykking, aktivitet under vann',
    finnish: '',
    hungarian: '',
    german: 'Tauchen, Aktivität unter Wasser',
    dutch: 'duik (zelfs nw)',
    afrikaans: 'duik, aktiwiteit onder water',
    russian: 'дайвинг',
    latvian: 'daivings',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25869,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation:
      '(group of + thing + diving: combination of equipment, gear + diving, activity under water)',
    english: 'diving equipment, diving gear',
    swedish: 'dykutrustning',
    norwegian: 'dykkeutstyr',
    finnish: '',
    hungarian: '',
    german: 'Tauchgerät, Tauchausrüstung, Taucherausrüstung',
    dutch: 'duikuitrusting',
    afrikaans: 'duik toerusting',
    russian: 'оснащение для дайвинга',
    latvian: 'niršanas piederumi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25870,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(door + fence)',
    english: 'doorway, gate',
    swedish: 'grind, port',
    norwegian: 'grind, port',
    finnish: '',
    hungarian: '',
    german: 'Eingang, Tor',
    dutch: 'poortje, hek',
    afrikaans: 'poort, hek',
    russian: 'ворота',
    latvian: 'vārti ',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25871,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + peace)',
    english: 'dove',
    swedish: 'duva',
    norwegian: 'due',
    finnish: '',
    hungarian: '',
    german: 'Taube',
    dutch: 'duif',
    afrikaans: 'duif',
    russian: 'голубь',
    latvian: 'dūja',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25872,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(storm + dust)',
    english: 'dust storm, duster, sirocco',
    swedish: 'dammstorm, sirocco',
    norwegian: 'sandstorm',
    finnish: '',
    hungarian: '',
    german: 'Staubsturm, Schirokko',
    dutch: 'zandstorm',
    afrikaans: 'stof storm, stoffer',
    russian: 'пыльная буря',
    latvian: 'putekļu vētra',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25873,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + seed + grain)',
    english: 'ear, spike, capitulum',
    swedish: 'ax',
    norwegian: 'aks',
    finnish: '',
    hungarian: '',
    german: 'Ähre',
    dutch: 'aar',
    afrikaans: 'oor, capitulum',
    russian: 'ростки злака',
    latvian: 'vārpa',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25874,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(forward + east + description indicator: forward representing (direction [contr.])',
    english: 'eastward',
    swedish: 'österut',
    norwegian: 'østover, østlig',
    finnish: '',
    hungarian: '',
    german: 'ostwärts',
    dutch: 'oostelijk',
    afrikaans: 'ooste',
    russian: 'направленный на восток',
    latvian: 'uz austrumiem',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25875,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(group of + thing + activity: a group of things for a certain activity)',
    english: 'equipment, gear',
    swedish: 'utrustning',
    norwegian: 'utstyr, utrustning',
    finnish: '',
    hungarian: '',
    german: 'Gerät, Ausrüstung',
    dutch: 'uitrusting',
    afrikaans: 'toerusting',
    russian: 'оборудование, оснащение',
    latvian: 'aprīkojums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25876,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(story, tale + imaginary + meaning: an imaginary story with a specific meaning)',
    english: 'fable, allegory, parable',
    swedish: 'fabel, allegori, liknelse',
    norwegian: 'fabel, allegori, lignelse',
    finnish: '',
    hungarian: '',
    german: 'Fabel, Mythe',
    dutch: 'fabel, parabel',
    afrikaans: 'fabel',
    russian: 'аллегория, басня',
    latvian: 'fabula, alegorija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25877,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(story, tale + imaginary person)',
    english: 'fairy tale',
    swedish: 'saga',
    norwegian: 'eventyr',
    finnish: '',
    hungarian: '',
    german: 'Märchen',
    dutch: 'sprookje',
    afrikaans: 'feëverhaal',
    russian: 'сказка',
    latvian: 'pasaka',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25879,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(story, tale + past + imaginary person: story from the past about imaginary persons)',
    english: 'folk tale, legend',
    swedish: 'folksaga, legend',
    norwegian: 'folkeeventyr, legende',
    finnish: '',
    hungarian: '',
    german: 'Volkserzählung, Volksmärchen, Volkssage, Legende ',
    dutch: 'legende, volkssprookje',
    afrikaans: 'sprokie, legende',
    russian: 'народная сказка, легенда',
    latvian: 'tautas pasaka, leģenda',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25880,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rule, regulation + football [contr.])',
    english: 'football rule(s)',
    swedish: 'fotbollsregel, fotbollsregler (plur)',
    norwegian: 'fotballregel',
    finnish: '',
    hungarian: '',
    german: 'Fußballregeln',
    dutch: 'voetbalreglement',
    afrikaans: 'sokkerreël',
    russian: 'правила игры в футбол',
    latvian: 'futbola spēles noteikumi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25881,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shamrock + 4 + leaf: shamrock representing clover)',
    english: 'four-leaf clover',
    swedish: 'fyrklöver',
    norwegian: 'firkløver',
    finnish: '',
    hungarian: '',
    german: 'vierblättriges Kleeblatt, Vierklee ',
    dutch: 'klavertjevier',
    afrikaans: 'vier klawertje',
    russian: 'четырёхлистный клевер',
    latvian: 'četrlapu āboliņš',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25882,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + cost + description indicator)',
    english: 'free of charge, gratis, for free',
    swedish: 'gratis, kostnadsfri',
    norwegian: 'gratis, kostnadsfri',
    finnish: '',
    hungarian: '',
    german: 'kostenlos, gratis, umsonst',
    dutch: 'gratis',
    afrikaans: 'verniet, gratis',
    russian: 'бесплатный',
    latvian: 'bezmaksas',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25883,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rule, regulation + game [contr.])',
    english: 'game rule(s)',
    swedish: 'spelregel, spelregler (plur)',
    norwegian: 'spilleregel',
    finnish: '',
    hungarian: '',
    german: 'Spielregeln',
    dutch: 'spelregel(s)',
    afrikaans: 'reël van die spel',
    russian: 'правило игры, правила игры',
    latvian: 'spēles noteikumi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25884,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(birth (reproduction) + action indicator)',
    english: 'give birth-(to)',
    swedish: 'föda',
    norwegian: 'føde, nedkomme (å)',
    finnish: '',
    hungarian: '',
    german: 'entbinden, zur Welt bringen',
    dutch: 'bevallen',
    afrikaans: 'geboorte skenk (kraam) (om te)',
    russian: 'рожать, родить',
    latvian: 'dzemdēt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25885,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(earth, globe, world + man-made)',
    english: 'globe (map)',
    swedish: 'jordglob',
    norwegian: 'globus',
    finnish: '',
    hungarian: '',
    german: 'Globus, Erdkugel',
    dutch: 'wereldbol',
    afrikaans: 'wêreld (kaart)',
    russian: 'глобус',
    latvian: 'globuss',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25886,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + grave + past)',
    english: 'grave field',
    swedish: 'gravfält',
    norwegian: 'gravfelt',
    finnish: '',
    hungarian: '',
    german: 'Gräberfeld',
    dutch: 'kerkhof (vroeger), grafveld',
    afrikaans: 'begraafplaas',
    russian: 'кладбище',
    latvian: 'kapu lauks',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25887,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + live)',
    english: 'habitation, dwelling place, site',
    swedish: 'boplats',
    norwegian: 'boplass',
    finnish: '',
    hungarian: '',
    german: 'Wohnung, Wohnen, Wohnstätte',
    dutch: 'woonplaats, bewoning, woonwijk',
    afrikaans: 'woning, woonplek',
    russian: 'место проживания',
    latvian: 'dzīves vieta',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25888,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lamp [contr.] + head + thing indicator)',
    english: 'head lamp',
    swedish: 'pannlampa',
    norwegian: 'hodelykt',
    finnish: '',
    hungarian: '',
    german: 'Frontscheinwerfer',
    dutch: 'hoofdlamp',
    afrikaans: 'hoof lamp, kop lamp',
    russian: 'головная лампа',
    latvian: 'galvas lampa',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25889,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(collection + sand)',
    english: 'heap of sand',
    swedish: 'sandhög',
    norwegian: 'sandhaug',
    finnish: '',
    hungarian: '',
    german: 'Sandhaufen',
    dutch: 'zandhoop',
    afrikaans: 'hoop sand',
    russian: 'куча песка',
    latvian: 'smilšu kaudze',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25890,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(information + ear: information to the brain from the ears)',
    english: 'hearing, audition, auditory sense',
    swedish: 'hörsel, hörselsinne',
    norwegian: 'hørsel, hørselssans',
    finnish: '',
    hungarian: '',
    german: 'Hören, Audition, Hörempfindung ',
    dutch: 'auditieve prikkel, gehoor',
    afrikaans: 'gehoor sintuig, ouditiewe sintuig',
    russian: 'слух, слуховое восприятие',
    latvian: 'dzirde',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25891,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(forward + home + description indicator: forward representing direction [contr.])',
    english: 'homeward',
    swedish: 'hemåt',
    norwegian: 'hjemover',
    finnish: '',
    hungarian: '',
    german: 'heimwärts',
    dutch: 'huiswaarts',
    afrikaans: 'huiswaarts',
    russian: 'направляюшийся домой',
    latvian: 'uz mājām, uz māju pusi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25892,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(ice covering + description indicator)',
    english: 'ice coated, ice covered',
    swedish: 'istäckt',
    norwegian: 'isdekket',
    finnish: '',
    hungarian: '',
    german: 'mit Eis bedeckt',
    dutch: 'met ijs bedekt',
    afrikaans: 'ys bedek',
    russian: 'покрытый льдом',
    latvian: 'noklāts ar ledu',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25893,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ice + shell: ice like a crust which can cover any side of a thing)',
    english: 'ice covering, ice crust, ice coating',
    swedish: 'istäcke, isskorpa',
    norwegian: 'isdekke, islag',
    finnish: '',
    hungarian: '',
    german: 'Eisdecke, Eispanzer, Eisschicht',
    dutch: 'ijslaag, ijskorst',
    afrikaans: 'ys bedek, ys kors, ys laag',
    russian: 'ледяное покрытие',
    latvian: 'ledus parsegs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25897,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(protection + eye + light: muscular diaphragm which thus protects the eye from too much or too little light)',
    english: 'iris (eye)',
    swedish: 'regnbågshinna, iris',
    norwegian: 'regnbuehinne, iris',
    finnish: '',
    hungarian: '',
    german: 'Iris (Auge)',
    dutch: 'iris (oog)',
    afrikaans: 'iris (oog)',
    russian: 'радужная оболочка',
    latvian: 'varavīksnene (acs)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25898,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + difficult + out of, exit (forward))',
    english: 'labyrinth, maze',
    swedish: 'labyrint',
    norwegian: 'labyrint',
    finnish: '',
    hungarian: '',
    german: 'Labyrinth, Irrgarten',
    dutch: 'labyrint, doolhof',
    afrikaans: 'labirint, doolhof',
    russian: 'лабиринт',
    latvian: 'labirints',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25899,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(birth + sheep + action indicator)',
    english: 'lamb-(to)',
    swedish: 'lamma',
    norwegian: 'lamme (å)',
    finnish: '',
    hungarian: '',
    german: 'lammen',
    dutch: 'lammeren',
    afrikaans: 'lam (om te)',
    russian: 'родить ягнёнка',
    latvian: 'dzemdēt jēriņu',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25900,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(ethnic group + north + deer, cervine (animal), cervid: deer representing reindeer [contr.])',
    english: 'Sami(s)',
    swedish: 'same(r), lapp(ar)',
    norwegian: 'reinsamer',
    finnish: '',
    hungarian: '',
    german: 'Lappländer, Lappen, Samen',
    dutch: 'Lap (inwoner van Lapland)',
    afrikaans: 'Lapps, Lapplander(s), Sami(s)',
    russian: 'саамы, лопари',
    latvian: 'Lapi, Sāmi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25901,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(country + L + A + T)',
    english: 'Latvia',
    swedish: 'Lettland',
    norwegian: 'Latvia',
    finnish: '',
    hungarian: '',
    german: 'Lettland',
    dutch: 'Letland',
    afrikaans: 'Latvië',
    russian: 'Латвия',
    latvian: 'Latvija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25902,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + Latvian)',
    english: 'Latvian (class)',
    swedish: 'lettiska (skolämne)',
    norwegian: 'latvisk (skolefag)',
    finnish: '',
    hungarian: '',
    german: 'Lettisch (Schulfach), Lettistik',
    dutch: 'Letlands (les)',
    afrikaans: 'Latviese (klas)',
    russian: 'латышский язык (предмет)',
    latvian: 'Latviešu valodas stunda',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25903,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(language + Latvia)',
    english: 'Latvian (language)',
    swedish: 'lettiska (språk)',
    norwegian: 'latvisk (språk)',
    finnish: '',
    hungarian: '',
    german: 'Lettisch (Sprache)',
    dutch: 'Letlands (taal)',
    afrikaans: 'Latvies (taal)',
    russian: 'латышский язык',
    latvian: 'Latviesu valoda',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25904,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + fold, folding, pleating)',
    english: 'leaf, flap',
    swedish: 'klaff, flik',
    norwegian: 'klaff, brett, lem',
    finnish: '',
    hungarian: '',
    german: 'Klappe, Lasche',
    dutch: 'flap, blad (kaft)',
    afrikaans: 'blaar, flap',
    russian: 'створка',
    latvian: 'vaks',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25905,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(tongue + action indicator)',
    english: 'lick-(to)',
    swedish: 'slicka',
    norwegian: 'slikke (å)',
    finnish: '',
    hungarian: '',
    german: 'lecken, ablecken',
    dutch: 'likken',
    afrikaans: 'lek (om te)',
    russian: 'лизать',
    latvian: 'laizīt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25906,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + key)',
    english: 'lock',
    swedish: 'lås',
    norwegian: 'lås',
    finnish: '',
    hungarian: '',
    german: 'Schloss, Türschloss',
    dutch: 'slot',
    afrikaans: 'slot',
    russian: 'замок',
    latvian: 'slēdzene',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25907,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(leg + under)',
    english: 'lower leg, shank, shin',
    swedish: 'vad, underben',
    norwegian: 'legg, skinnlegg',
    finnish: '',
    hungarian: '',
    german: 'Unterschenkel, Schaft, Schienbein',
    dutch: 'onderbeen',
    afrikaans: 'onderbeen, skeen',
    russian: 'голень',
    latvian: 'stilbs',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25908,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cause + mystery)',
    english: 'magic',
    swedish: 'magi, magik',
    norwegian: 'magi',
    finnish: '',
    hungarian: '',
    german: 'magisch',
    dutch: 'magie',
    afrikaans: 'towerkuns',
    russian: 'магия',
    latvian: 'brīnums, maģija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25909,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(magic + description indicator)',
    english: 'magical',
    swedish: 'magisk',
    norwegian: 'magisk',
    finnish: '',
    hungarian: '',
    german: 'Magie, Zauber',
    dutch: 'magisch',
    afrikaans: 'magiese',
    russian: 'магический',
    latvian: 'brīnumains, maģisks',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25910,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lid + opening + ground)',
    english: 'manhole cover',
    swedish: 'brunnslock',
    norwegian: 'kumlokk',
    finnish: '',
    hungarian: '',
    german: 'Gullydeckel, Kanaldeckel, Schachtdeckel',
    dutch: 'putdeksel',
    afrikaans: 'mangatdeksel',
    russian: 'крышка люка',
    latvian: 'akas, lūkas vāks ',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25911,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sun + night)',
    english: 'midnight sun',
    swedish: 'midnattssol',
    norwegian: 'midnattssol',
    finnish: '',
    hungarian: '',
    german: 'Mitternachtssonne',
    dutch: 'middernachtzon',
    afrikaans: 'middernag son',
    russian: 'полуночное солнце',
    latvian: 'pusnakts saule',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25912,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(woman + mountain pasture)',
    english: 'milkmaid, dairymaid',
    swedish: 'säterjänta, fäbodstinta',
    norwegian: 'budeie, seterjente',
    finnish: '',
    hungarian: '',
    german: 'Melkerin, Milchmädchen',
    dutch: 'herderin, melkmeisje',
    afrikaans: 'melkmeisie, diensmeisie',
    russian: 'доярка',
    latvian: 'gane, slaucēja',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25913,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(insect + group of, much of, many of, quantity of + legs and feet)',
    english: 'millepede',
    swedish: 'tusenfoting',
    norwegian: 'tusenben',
    finnish: '',
    hungarian: '',
    german: 'Tausendfüßer, Doppelfüßer ',
    dutch: 'duizendpoot',
    afrikaans: 'duisendpoot',
    russian: 'сороконожка',
    latvian: 'simtkājis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25914,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(milk + mother)',
    english: "mother's milk",
    swedish: 'modersmjölk',
    norwegian: 'morsmelk',
    finnish: '',
    hungarian: '',
    german: 'Muttermilch ',
    dutch: 'borstvoeding',
    afrikaans: 'moedersmelk',
    russian: 'материнское молоко',
    latvian: 'mātes piens',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25915,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + mountain + animal)',
    english: 'mountain pasture',
    swedish: 'fäbod, säter',
    norwegian: 'seter',
    finnish: '',
    hungarian: '',
    german: 'Alm, Almweide, Alpweide, Almen',
    dutch: 'berghut',
    afrikaans: 'berg weiding',
    russian: 'горное пастбище',
    latvian: 'kalnu ganības',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25916,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mouth + open)',
    english: 'mouth (wide-open), open mouth, gape',
    swedish: 'gap, öppen mun',
    norwegian: 'gap, åpen munn',
    finnish: '',
    hungarian: '',
    german: 'Mund (weit offen), offener Mund, Rachen, Schlund',
    dutch: 'geopende mond, open mond',
    afrikaans: 'mond (wyd oop), oop mond, mondhoeke',
    russian: 'зевок, открытый рот',
    latvian: 'plati atvērta mute',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25917,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(story, tale + imaginary + event: imaginary tale of an event)',
    english: 'myth',
    swedish: 'myt',
    norwegian: 'myte',
    finnish: '',
    hungarian: '',
    german: 'Mythos',
    dutch: 'mythe',
    afrikaans: 'miete',
    russian: 'миф',
    latvian: 'mīts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25918,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(forward + north + description indicator: forward representing direction [contr.])',
    english: 'northward',
    swedish: 'norrut',
    norwegian: 'nordover, nordlig',
    finnish: '',
    hungarian: '',
    german: 'nördlich, nordwärts, nach Norden',
    dutch: 'noordwaarts',
    afrikaans: 'noordekant',
    russian: 'направленный на север',
    latvian: 'uz ziemeļiem',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25919,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(mouth (wide-open), open mouth, gape + action indicator)',
    english: "open one's mouth, hold one's mouth open, gape-(to)",
    swedish: 'gapa, öppna munnen',
    norwegian: 'gape, åpne munnen (å)',
    finnish: '',
    hungarian: '',
    german: 'den Mund aufmachen',
    dutch: 'gapen, aangapen',
    afrikaans: 'jou mond oop maak, mondhoeke (om te)',
    russian: 'зевать, открывать рот',
    latvian: 'atvērt plati muti',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25920,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(other + plural indicator)',
    english: 'others (persons)',
    swedish: 'andra (personer)',
    norwegian: 'andre (personer)',
    finnish: '',
    hungarian: '',
    german: 'andere (Personen), die anderen',
    dutch: 'andere (persoon)',
    afrikaans: 'ander (mense)',
    russian: 'другой (человек)',
    latvian: 'citi (personas)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25921,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(turn + fall, drop, spill, tumble + action indicator)',
    english: 'overturn, turn over, tip over-(to)',
    swedish: 'välta, tippa',
    norwegian: 'velte, tippe over (å)',
    finnish: '',
    hungarian: '',
    german: 'umkippen, stürzen, überschlagen, kippen',
    dutch: 'omvallen, kantelen',
    afrikaans: 'omkeer, ongedaan, om slaan (om te)',
    russian: 'опрокинуть, перевернуть',
    latvian: 'apvelties, novelties',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25922,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + paper + together)',
    english: 'paper clip',
    swedish: 'gem',
    norwegian: 'binders',
    finnish: '',
    hungarian: '',
    german: 'Aktenklammer, Briefklammer, Büroklammer',
    dutch: 'paperclip',
    afrikaans: 'skuifspeld',
    russian: 'скрепка для бумаг',
    latvian: 'papīra saspraude',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25923,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ethnic group + north)',
    english: 'people in the north (Lapps, Eskimos)',
    swedish: 'folkgrupper i norr (samer, eskimåer)',
    norwegian: 'folkegruppe i nord (samer, eskimoer, inuitter)',
    finnish: '',
    hungarian: '',
    german: 'Völkergruppen im Norden (Lappen, Samen, Eskimos)',
    dutch: "mensen van het Noorden (Lappen, Eskimo's)",
    afrikaans: 'mense in die noorde (Lapps, Eskimos)',
    russian: 'народы Севера',
    latvian: 'ziemeļu tautas (sāmi, eskimosi u.t.t)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25924,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + give + food: feeding place in general)',
    english: 'place to feed, feeding place, feeding ground',
    swedish: 'matställe, matplats, foderplats, utfordringsställe',
    norwegian: 'matplass, foringsplass',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'voedselplaats',
    afrikaans: 'plaas om te voed, voeding plek',
    russian: 'место питания',
    latvian: 'barotava',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25925,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plant + food)',
    english: 'plant (edible)',
    swedish: 'växt, planta (ätlig)',
    norwegian: 'fôrplante, plante spiselig',
    finnish: '',
    hungarian: '',
    german: 'Pflanze (essbar)',
    dutch: 'plant (eetbaar), eetbare plant',
    afrikaans: 'plant (eetbare)',
    russian: 'съедобное растение',
    latvian: 'dārzeņi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25926,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bear + ice)',
    english: 'polar bear',
    swedish: 'isbjörn',
    norwegian: 'isbjørn, polarbjørn',
    finnish: '',
    hungarian: '',
    german: 'Eisbär, Polarbär',
    dutch: 'ijsbeer',
    afrikaans: 'ysbeer',
    russian: 'белый медведь',
    latvian: 'polārlācis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25927,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(night + north)',
    english: 'polar night',
    swedish: 'polarnatt, midvinternatt',
    norwegian: 'polarnatt',
    finnish: '',
    hungarian: '',
    german: 'Polarnacht',
    dutch: 'poolnacht',
    afrikaans: 'polêre nag',
    russian: 'полярная ночь',
    latvian: 'polārnakts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25928,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(opening + eye)',
    english: 'pupil (eye)',
    swedish: 'pupill',
    norwegian: 'pupill',
    finnish: '',
    hungarian: '',
    german: 'Pupille',
    dutch: 'pupil',
    afrikaans: 'pupil (oog)',
    russian: 'зрачок',
    latvian: 'acu zīlītes',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25929,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dot + rain: combination of drop and rain)',
    english: 'raindrop',
    swedish: 'regndroppe',
    norwegian: 'regndråpe',
    finnish: '',
    hungarian: '',
    german: 'Regentropfen',
    dutch: 'regendruppel',
    afrikaans: 'reëndruppel',
    russian: 'дождевая капля',
    latvian: 'lietus lāse',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25930,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(show of hands + action indicator)',
    english: "raise one's hand, put up one's hand-(to)",
    swedish: 'räcka upp handen',
    norwegian: 'rekke opp hånden (å)',
    finnish: '',
    hungarian: '',
    german: 'durch Handzeichen, die Hand erheben ',
    dutch: 'hand omhoog steken',
    afrikaans: 'steek op jou hand (om te)',
    russian: 'поднимать руку вверх',
    latvian: 'pacelt roku',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25931,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(grass + big)',
    english: 'reed, bamboo (tall grass)',
    swedish: 'vass, bambu (högt gräs)',
    norwegian: 'siv, gress høyt',
    finnish: '',
    hungarian: '',
    german: 'Ried, Schilfrohr, Bambusrohr, Bambus (hohes Gras)',
    dutch: 'riet, bamboe',
    afrikaans: 'riet, bamboes, lang gras',
    russian: 'тростник, бамбук',
    latvian: 'gara zāle, bambuss',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25932,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(type, kind, sort, category + stone)',
    english: 'rock (geology)',
    swedish: 'bergart',
    norwegian: 'bergart',
    finnish: '',
    hungarian: '',
    german: 'Fels',
    dutch: 'gesteente',
    afrikaans: 'rots, geologie',
    russian: 'горная порода',
    latvian: 'iezis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25933,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + group of + fiber)',
    english: 'rope, hawser',
    swedish: 'rep, tross, tamp, lina',
    norwegian: 'tau, trosse, line',
    finnish: '',
    hungarian: '',
    german: 'Seil, Leine, Strick, Trosse, Tau',
    dutch: 'touw, kabel',
    afrikaans: 'tou, tros',
    russian: 'верёвка, трос, канат',
    latvian: 'virve, trose',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25934,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(storm + sand)',
    english: 'sandstorm',
    swedish: 'sandstorm',
    norwegian: 'sandstorm',
    finnish: '',
    hungarian: '',
    german: 'Sandsturm',
    dutch: 'zandstorm',
    afrikaans: 'sandstorm',
    russian: 'песчаная буря',
    latvian: 'smilšuvētra',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25935,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(way + school)',
    english: 'school way',
    swedish: 'skolväg',
    norwegian: 'skolevei',
    finnish: '',
    hungarian: '',
    german: 'Schulweg',
    dutch: 'weg naar school, schoolweg',
    afrikaans: 'skool pad',
    russian: 'путь в школу',
    latvian: 'ceļs uz skolu',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25936,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(season + darkness)',
    english: 'season of darkness',
    swedish: 'mörka säsongen, mörka tiden på året',
    norwegian: 'mørketid',
    finnish: '',
    hungarian: '',
    german: 'die dunkle Jahreszeit',
    dutch: 'donker seizoen (Noorden)',
    afrikaans: 'seisoen van duisternis',
    russian: 'сезон темноты',
    latvian: 'tumšais gada periods',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25937,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(generalization + vision + hearing [contr.]: information to the brain, generalization for all senses)',
    english: 'sense',
    swedish: 'sinne',
    norwegian: 'sans',
    finnish: '',
    hungarian: '',
    german: 'Sinn, Gefühl',
    dutch: 'zintuig',
    afrikaans: 'sin',
    russian: 'восприятие',
    latvian: 'uztvere',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25938,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hand + up)',
    english: 'show of hands',
    swedish: 'handuppräckning',
    norwegian: 'håndsopprekkingsyn',
    finnish: '',
    hungarian: '',
    german: '(durch) Handzeichen',
    dutch: 'opgestoken hand',
    afrikaans: 'opsteek van hande',
    russian: 'поднимание руки',
    latvian: 'pacelt roku, nobalsot',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25939,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(information + eye: information to the brain from the eyes)',
    english: 'sight, vision, visual sense',
    swedish: 'syn, synsinne',
    norwegian: 'syn, synssans',
    finnish: '',
    hungarian: '',
    german: 'Sicht, Blick, Gesichtssinn ',
    dutch: 'gezicht, visuele prikkel',
    afrikaans: 'sig, visie, visuele sin',
    russian: 'зрение, зрительное восприятие',
    latvian: 'redze',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25940,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(information + nose: information to the brain from the nose)',
    english: 'smell, sense of smell, olfaction',
    swedish: 'lukt, luktsinne',
    norwegian: 'lukt, luktesans',
    finnish: '',
    hungarian: '',
    german: 'Geruch, Duft, Geruchssinn, ',
    dutch: 'reuk (zintuig)',
    afrikaans: 'sin van die reuk, reuk',
    russian: 'обоняние, запах',
    latvian: 'oža',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25941,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(snake + danger)',
    english: 'snake (dangerous), viper, boa (etc)',
    swedish: 'orm (farlig), giftorm, huggorm, boaorm',
    norwegian: 'slange (farlig), giftslange, hoggorm',
    finnish: '',
    hungarian: '',
    german: 'Schlange (gefährlich), Otter, Giftschlange, Boa etc.',
    dutch: 'slang (gevaarlijk)',
    afrikaans: 'slang (gevaarlik)',
    russian: 'ядовитая змея, гадюка, удав',
    latvian: 'čūska (bīstama)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25942,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(snake + minus + danger)',
    english: 'snake (not dangerous), grass snake (etc)',
    swedish: 'orm (ofarlig), snok',
    norwegian: 'slange (ufarlig), snok',
    finnish: '',
    hungarian: '',
    german: 'Schlange (nicht gefährlich), Ringelnatter etc.',
    dutch: 'slang (ongevaarlijk)',
    afrikaans: 'slang (nie gevaarlik nie)',
    russian: 'безопасная змея, уж',
    latvian: 'čūska (nav bīstama)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25943,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bottom + shoe)',
    english: 'sole (of shoe)',
    swedish: 'sula, skosula',
    norwegian: 'såle, skosåle',
    finnish: '',
    hungarian: '',
    german: 'Schuhsohle ',
    dutch: 'schoenzool',
    afrikaans: 'skoensool',
    russian: 'подошва обуви',
    latvian: 'kurpju zole',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25944,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(forward + south + description indicator: forward representing direction [contr.])',
    english: 'southward',
    swedish: 'söderut',
    norwegian: 'sørover, sydover, sydlig',
    finnish: '',
    hungarian: '',
    german: 'südlich, nach Süden gerichtet',
    dutch: 'zuidwaards',
    afrikaans: 'suide',
    russian: 'направленный на юг',
    latvian: 'uz dienvidiem, dienvidu virzienā',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25945,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(cause + dirt + action indicator)',
    english: 'spill, slop-(to)',
    swedish: 'spilla, söla',
    norwegian: 'søle (å)',
    finnish: '',
    hungarian: '',
    german: 'verschütten, ausschütten, überlaufen, überschwappen',
    dutch: 'morsen',
    afrikaans: 'mors (om te)',
    russian: 'засорять, загрязнять',
    latvian: 'izliet, izšļakstīt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25946,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(start + growth, growing + action indicator)',
    english: 'sprout, germinate-(to)',
    swedish: 'gro, spira',
    norwegian: 'gro, spire, vokse (å)',
    finnish: '',
    hungarian: '',
    german: 'aufkeimen, keimen, sprießen, wachsen',
    dutch: 'ontkiemen, kiemen',
    afrikaans: 'spruit, ontkeim (om te)',
    russian: 'прорастать',
    latvian: 'laist asnus',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25947,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(story, tale + past)',
    english: 'story (historical), historic story',
    swedish: 'berättelse (historisk)',
    norwegian: 'fortelling (historisk)',
    finnish: '',
    hungarian: '',
    german: 'Erzählung (historisch)',
    dutch: 'historisch verhaal',
    afrikaans: 'verhaal (historiese)',
    russian: 'рассказ (исторический)',
    latvian: 'stāsts (vesturisks)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25948,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + summer: only numbers are used, as seasons are different in different parts of the world)',
    english: 'summer day',
    swedish: 'sommardag',
    norwegian: 'sommerdag',
    finnish: '',
    hungarian: '',
    german: 'Sommertag',
    dutch: 'zomerdag',
    afrikaans: 'somersdag',
    russian: 'летний день',
    latvian: 'vasaras diena',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25949,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(house + summer: only numbers are used, as seasons are different in different parts of the world)',
    english: 'summer house, summerhouse',
    swedish: 'sommarstuga, sommarbostad',
    norwegian: 'hytte, sommerbolig, sommerhus, feriehus',
    finnish: '',
    hungarian: '',
    german: 'Sommerhaus, Sommerresidenz, Ferienhaus',
    dutch: 'vakantiehuis, zomerhuis',
    afrikaans: 'somerhuis',
    russian: 'летний дом, дача',
    latvian: 'vasarnīca',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25950,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rule, regulation + swimming)',
    english: 'swimming rule(s)',
    swedish: 'simregel, simregler (plur)',
    norwegian: 'svømmeregel',
    finnish: '',
    hungarian: '',
    german: 'Schwimmregeln',
    dutch: 'zwemreglement',
    afrikaans: 'swemreëls',
    russian: 'правила плавания',
    latvian: 'peldēšanas noteikumi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25951,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(truck, lorry + water, fluid, liquid)',
    english: 'tanker truck, tank lorry',
    swedish: 'tankbil',
    norwegian: 'tankbil',
    finnish: '',
    hungarian: '',
    german: 'Tanksattelzug, Tanker, Tankerfahrzeug',
    dutch: 'tankwagen',
    afrikaans: 'vragmotor, lorrie, tenksip',
    russian: 'автоцистерна',
    latvian: 'atocisterna',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25952,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(information + taste; information to the brain from the nose and the mouth)',
    english: 'taste, gustation, sense of taste',
    swedish: 'smak, smaksinne, smak',
    norwegian: 'smak, smakssans',
    finnish: '',
    hungarian: '',
    german: 'Geschmack, Geschmackssinn',
    dutch: 'smaak (zintuig)',
    afrikaans: 'proe, sin van die smaak',
    russian: 'вкус, дегустация, ощущение вкуса',
    latvian: 'garšas sajūta',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25953,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drop + eye)',
    english: 'tear, teardrop',
    swedish: 'tår (från ögat)',
    norwegian: 'tåre',
    finnish: '',
    hungarian: '',
    german: 'Träne',
    dutch: 'traan',
    afrikaans: 'traan, traandruppel',
    russian: 'слеза',
    latvian: 'asara',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25954,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(quickness, rapidity, speediness + action indicator: moving fast forward)',
    english: 'tear along, advance fast, go fast-(to)',
    swedish: 'rusa iväg, skynda iväg',
    norwegian: 'skynde seg, haste, ile (å)',
    finnish: '',
    hungarian: '',
    german: 'entlangrasen, sich vorwärtsbewegen, avancieren, sich beeilen',
    dutch: 'rennen, hollen',
    afrikaans: 'gaan vinnig, bevorder vinnige, om vinnig te vorder',
    russian: 'спешить, мчаться',
    latvian: 'steigties, traukties',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25955,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(leg + over)',
    english: 'thigh, upper leg',
    swedish: 'lår, överben',
    norwegian: 'lår',
    finnish: '',
    hungarian: '',
    german: 'Schenkel, Oberschenkel',
    dutch: 'bovenbeen, dijbeen',
    afrikaans: 'dy, bobeen',
    russian: 'бедро',
    latvian: 'ciska',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25956,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of, much of, many of, quantity of + fiber)',
    english: 'thread, string, cord',
    swedish: 'tråd, snöre, snodd',
    norwegian: 'tråd, snor',
    finnish: '',
    hungarian: '',
    german: 'Faden, Garn, Faser, Schnur',
    dutch: 'draad, koord',
    afrikaans: 'draad, string, koord',
    russian: 'нить, струна, шнур',
    latvian: 'diegs, aukla, striķis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25957,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(information + skin: information to the brain from the skin)',
    english: 'touch, sense of touch, tactile sense',
    swedish: 'känsel, känselsinne',
    norwegian: 'følesans, taktilsans',
    finnish: '',
    hungarian: '',
    german: 'Berührung, Tastsinn',
    dutch: 'gevoel (zintuig)',
    afrikaans: 'tassintuig, tasbare gevoel',
    russian: 'осязание, тактильное ощущение',
    latvian: 'taktīlā sajūta',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25958,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rule, regulation + traffic)',
    english: 'traffic rule(s)',
    swedish: 'trafikregel, trafikregler (plur)',
    norwegian: 'trafikkregel',
    finnish: '',
    hungarian: '',
    german: 'Straßenverkehrsordnung [StVO], Verkehrsvorschriften',
    dutch: 'verkeersreglement, verkeersregels',
    afrikaans: 'verkeersreëls',
    russian: 'правило дорожного движения',
    latvian: 'satiksmes noteikumi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25959,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(swing + acrobatics [contr.])',
    english: 'trapeze',
    swedish: 'trapets',
    norwegian: 'trapes',
    finnish: '',
    hungarian: '',
    german: 'Trapez',
    dutch: 'trapeze',
    afrikaans: 'sweefstok, hangstok',
    russian: 'трапеция (тренажёр)',
    latvian: 'trapece (trenažieris)',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25960,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothing + chest + T)',
    english: 'T-shirt, tee shirt, jersey',
    swedish: 'T-tröja, T-shirt',
    norwegian: 'T-skjorte, T-trøye',
    finnish: '',
    hungarian: '',
    german: 'T-Shirt',
    dutch: 'T-shirt',
    afrikaans: 't-hemp, hemp, trui',
    russian: 'футболка',
    latvian: 'T - krekls',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25961,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(collection, pile, tussock (etc) + grass)',
    english: 'tuft of grass, tussock',
    swedish: 'tuva, grästuva',
    norwegian: 'tue, gresstue',
    finnish: '',
    hungarian: '',
    german: 'Grasbüschel, Büschel',
    dutch: 'graskluit ',
    afrikaans: 'graspol',
    russian: 'связка сена',
    latvian: 'zāles kušķis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25962,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dog + watch)',
    english: 'watchdog',
    swedish: 'vakthund',
    norwegian: 'vakthund',
    finnish: '',
    hungarian: '',
    german: 'Wachhund',
    dutch: 'waakhond',
    afrikaans: 'waghond',
    russian: 'сторожевая собака',
    latvian: 'sargsuns',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25963,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + forward: a place on the ground leading forward)',
    english: 'way',
    swedish: 'väg',
    norwegian: 'vei',
    finnish: '',
    hungarian: '',
    german: 'Weg',
    dutch: 'weg (zelfst nw)',
    afrikaans: 'pad',
    russian: 'путь, дорога',
    latvian: 'ceļš',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25964,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(very + very + description indicator)',
    english: 'very much, very many',
    swedish: 'väldigt mycket, väldigt många',
    norwegian: 'veldig mye, veldig mange',
    finnish: '',
    hungarian: '',
    german: 'sehr viel',
    dutch: 'heel veel',
    afrikaans: 'baie, meer, klomp',
    russian: 'очень много',
    latvian: 'ļoti daudz',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25965,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(forward + west + description indicator: forward representing direction [contr.])',
    english: 'westward',
    swedish: 'västerut',
    norwegian: 'vestover, vestlig',
    finnish: '',
    hungarian: '',
    german: 'westlich',
    dutch: 'westwaards',
    afrikaans: 'weswaarts',
    russian: 'направленный на запад',
    latvian: 'uz rietumiem',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25966,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tricycle + wheelchair)',
    english: 'wheelchair tricycle',
    swedish: 'trehjulig rullstol med tre hjul',
    norwegian: 'rullestol med tre hjul',
    finnish: '',
    hungarian: '',
    german: 'Rollstuhl-Dreirad, Dreirad, Rollstuhl mit drei Rädern',
    dutch: 'rolstoel met drie wielen',
    afrikaans: 'driewiel rolstoel',
    russian: 'инвалидная коляска трицикл',
    latvian: 'ratiņkrēsls ar trīs riteņiem',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25967,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(day + winter: only numbers are used, as seasons are different in different parts of the world)',
    english: 'winter day',
    swedish: 'vinterdag',
    norwegian: 'vinterdag',
    finnish: '',
    hungarian: '',
    german: 'Wintertag',
    dutch: 'winterdag',
    afrikaans: 'wintersdag',
    russian: 'зимний день',
    latvian: 'ziemas diena',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25968,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(house + winter: only numbers are used, as seasons are different in different parts of the world)',
    english: 'winter house',
    swedish: 'vinterbostad',
    norwegian: 'vinterbolig, vinterhus',
    finnish: '',
    hungarian: '',
    german: 'Winterresidenz',
    dutch: 'winterhuis',
    afrikaans: 'wintershuis',
    russian: 'зимний дом',
    latvian: 'ziemas māja',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25969,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bird + chop-(to))',
    english: 'woodpecker',
    swedish: 'hackspett',
    norwegian: 'hakkespett',
    finnish: '',
    hungarian: '',
    german: 'Specht',
    dutch: 'specht',
    afrikaans: 'houtkapperkie',
    russian: 'дятел',
    latvian: 'dzenis',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25970,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plan, design, method, system + work)',
    english: 'work method',
    swedish: 'arbetsmetod, arbetssätt',
    norwegian: 'arbeidsmetode, arbeidsmåte',
    finnish: '',
    hungarian: '',
    german: 'Arbeitsmethoden ',
    dutch: 'werkmethode',
    afrikaans: 'werkswyse',
    russian: 'метод работы',
    latvian: 'darba metode',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25971,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(zigzag line + description indicator)',
    english: 'zigzag',
    swedish: 'sicksack, i sicksack',
    norwegian: 'sikksakk',
    finnish: '',
    hungarian: '',
    german: 'Zickzack',
    dutch: 'zigzag',
    afrikaans: 'sig-sag',
    russian: 'зигзагообразный',
    latvian: 'zigzags',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25980,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(signal + limit(s), limitation, restriction: signal or frequencies in a certain range) Preferred NEW SYNONYM, replacing 24606',
    english: 'band (of frequencies)',
    swedish: 'frekvensband, frekvensområde',
    norwegian: 'frekvensbånd',
    finnish: 'taajuuskaista',
    hungarian: 'frekvenciasáv',
    german: 'Frequenzband',
    dutch: 'frequentieband',
    afrikaans: 'frekwensiesband',
    russian: 'диапазон частот',
    latvian: 'frekvenču josla',
    polish: 'pasmo (częstotliwości)',
    french: 'bande (de fréquences)',
    spanish: 'banda (de frecuencias)',
  },
  {
    av: 25981,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tennis (activity) + beach) Preferred NEW SYNONYM, replacing 12641',
    english: 'beach tennis (activity)',
    swedish: 'strandtennis (aktivitet)',
    norwegian: 'strandtennis (aktivitet)',
    finnish: 'rantatennis',
    hungarian: 'strandlabda (játék, sport)',
    german: 'Strandtennis (Aktivität)',
    dutch: 'strandtennis',
    afrikaans: 'strandtennis (aktiwiteit)',
    russian: 'пляжный теннис',
    latvian: 'pludmales teniss',
    polish: 'tenis plażowy (aktywności)',
    french: 'tennis de plage (activité)',
    spanish: 'tenis de playa (actividad)',
  },
  {
    av: 25982,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(tennis, racket sport, racquet sport + beach) Preferred NEW SYNONYM, replacing 20604',
    english: 'beach tennis (sport)',
    swedish: 'strandtennis (sport)',
    norwegian: 'strandtennis (sport)',
    finnish: 'rantatennis',
    hungarian: 'strandtenisz',
    german: 'Strandtennis (Sport)',
    dutch: 'strandtennis (sport)',
    afrikaans: 'strandtennis (sport)',
    russian: 'пляжный теннис (спорт)',
    latvian: 'pludmales teniss (sports)',
    polish: 'tenis plażowy (sport)',
    french: 'tennis de plage (sport)',
    spanish: 'tenis de playa (deporte)',
  },
  {
    av: 25983,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(outside + limit(s), limitation, restriction + description indicator) Preferred NEW SYNONYM, replacing 12670',
    english: 'beyond, past',
    swedish: 'bortom',
    norwegian: 'bortenfor',
    finnish: 'ulkopuolella, entinen',
    hungarian: 'túl, valamin kívül, amott',
    german: 'jenseits',
    dutch: 'voorbij, verder dan',
    afrikaans: 'verby, verlede, buite, afgelope',
    russian: 'прошедщий',
    latvian: 'pāri, pēc',
    polish: 'poza czymś, w przeszłości',
    french: "au-delà, de l'autre côté de",
    spanish: 'más allá',
  },
  {
    av: 25984,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + to look + distance) Preferred NEW SYNONYM, replacing 24416',
    english: 'binoculars, field glass',
    swedish: 'kikare',
    norwegian: 'kikkert',
    finnish: 'kiikarit',
    hungarian: 'távcső, kétcsövű látcső',
    german: 'Fernglas',
    dutch: 'verrekijker, telescoop',
    afrikaans: 'verkyker',
    russian: 'бинокль',
    latvian: 'binoklis',
    polish: 'lornetki, lornetka polowa',
    french: 'jumelles, longue-vue',
    spanish: 'binoculares, prismáticos',
  },
  {
    av: 25985,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(band (of frequencies) + fast) Preferred NEW SYNONYM, replacing 24614',
    english: 'broadband',
    swedish: 'bredband',
    norwegian: 'bredbånd',
    finnish: 'laajakaista',
    hungarian: 'szélessávú',
    german: 'Breitband',
    dutch: 'breedband',
    afrikaans: 'breëband',
    russian: 'широкополосная передача',
    latvian: 'garie viļņi (frekvence)',
    polish: 'szerokopasmowe',
    french: 'large bande (télécommunications)',
    spanish: 'banda ancha',
  },
  {
    av: 25986,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(ruin, wreck, wreckage (building) (1) + God: combination of ruin and church, mosque, temple) SYMBOL SYNONYM',
    english: 'church ruin, temple ruin, wreck, wreckage (church, temple, mosque) (1)',
    swedish: 'kyrkoruin, tempelruin (1)',
    norwegian: 'kirkeruin, tempelruin (1)',
    finnish: 'kirkon rauniot, temppelin rauniot (1)',
    hungarian: '',
    german: 'Kirchenruine, Tempelruine (1)',
    dutch: 'ruïne (kerk, tempel) (1)',
    afrikaans: 'kerk ondergang, kerk wrak (1)',
    russian: 'церковные руины (1)',
    latvian: 'baznīcas drupas, tempļa drupas, krāsmatas, gruveši (1)',
    polish: '',
    french: '',
    spanish: ' ruina de iglesia, ruina de templo (1)',
  },
  {
    av: 25987,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(leadership + limit(s), limitation, restriction) Preferred NEW SYNONYM, replacing 24428',
    english: 'control',
    swedish: 'kontroll',
    norwegian: 'kontroll',
    finnish: 'hallinta, kontrolli',
    hungarian: 'ellenőrzés, felügyelet, kontroll',
    german: 'Kontrolle',
    dutch: 'controle',
    afrikaans: 'beheer',
    russian: 'контроль',
    latvian: 'kontrolēt, pārbaudīt',
    polish: 'kontrola',
    french: 'contrôle',
    spanish: 'control',
  },
  {
    av: 25988,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(abuse [contr.] + power, powerfulness [contr.] + selfish) Preferred NEW SYNONYM, replacing 24629',
    english: 'corruption',
    swedish: 'korruption',
    norwegian: 'korrupsjon',
    finnish: 'korruptio, lahjonta',
    hungarian: 'megvesztegetés, lekenyerezés, korrupció',
    german: 'Korruption, Bestechlichkeit',
    dutch: 'corruptie, omkoping',
    afrikaans: 'korrupsie',
    russian: 'коррупция',
    latvian: 'korupcija, piekukuļošana',
    polish: 'korupcja',
    french: 'corruption',
    spanish: 'corrupción',
  },
  {
    av: 25989,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(class [contr.] + Danish (language)) ',
    english: 'Danish (class)',
    swedish: 'danska (skolämne)',
    norwegian: 'dansk (skolefag)',
    finnish: '',
    hungarian: '',
    german: 'Dänisch (Schulfach)',
    dutch: 'Deens (les)',
    afrikaans: 'Deens (klas)',
    russian: 'датский язык (предмет)',
    latvian: 'Dāņu valodas stunda',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 25990,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(language + 3 + water: based on Denmark [contr.]) Preferred NEW SYNONYM, replacing 25283',
    english: 'Danish (language)',
    swedish: 'danska',
    norwegian: 'dansk (språk)',
    finnish: 'tanska (kieli)',
    hungarian: '',
    german: 'Dänisch (Sprache)',
    dutch: 'Deens (taal)',
    afrikaans: 'Deens (taal)',
    russian: 'датский язык',
    latvian: 'dāņu valoda',
    polish: '',
    french: '',
    spanish: 'Danés (lenguage)',
  },
  {
    av: 25991,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(country + 3 + water: country divided by three channels of water) Preferred NEW SYNONYM, replacing 13654',
    english: 'Denmark',
    swedish: 'Danmark',
    norwegian: 'Danmark',
    finnish: 'Tanska',
    hungarian: 'Dánia',
    german: 'Dänemark',
    dutch: 'Denemarken',
    afrikaans: 'Denemarke',
    russian: 'Дания',
    latvian: 'Dānija',
    polish: 'Dania',
    french: 'Danemark',
    spanish: 'Dinamarca',
  },
  {
    av: 25992,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(ability, capability, capacity, potential + limit(s), limitation, restriction) Preferred NEW SYNONYM, replacing 13684',
    english: 'disability, handicap, impairment',
    swedish: 'handikapp, funktionshinder, funktionsnedsättning',
    norwegian: 'handikap, funksjonshemming',
    finnish: 'vamma',
    hungarian: 'fogyatékosság, akadályozottság, korlátozottság',
    german: 'Behinderung, Körperbehinderung',
    dutch: 'handicap, beperking',
    afrikaans: 'gestremdheid, voorgee, aantasting',
    russian: 'ограниченная возможность, инвалидность',
    latvian: 'ierobežotas iespējas, invaliditāte',
    polish: 'niepełnosprawność',
    french: 'handicap, incapacité',
    spanish: 'discapacidad',
  },
  {
    av: 25993,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(money + disability, handicap, impairment) Preferred NEW SYNONYM, replacing 24430',
    english: 'disability benefit',
    swedish: 'aktivitetsersättning, sjukersättning',
    norwegian: 'uførhetstrygd, sykelønn',
    finnish: 'vammaisetu, vammaisavustus',
    hungarian: 'fogyatékossági támogatás, rokkantsági járadék',
    german: 'Schwerbehintertenrente',
    dutch: 'uitkering voor pers. met beperking',
    afrikaans: 'ongeskiktheidsvoordeel, toelaag',
    russian: 'пособие по нетрудоспособности',
    latvian: 'darbnespējas/invaliditātes pabalsts',
    polish: 'renta, świadczenie dla niepełnosprawnych',
    french: "pension d'invalidité, rente d'invalidité",
    spanish: 'beneficio por discapacidad',
  },
  {
    av: 25994,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      "(intellectual impairment, cognitive impairment, mental impairment + description indicator: having limits to one's mental abilities) Preferred NEW SYNONYM, replacing 15457",
    english: 'disabled, impaired, handicapped (intellectually, mentally)',
    swedish: 'förståndshandikappad, utvecklingsstörd',
    norwegian: 'funksjonshemming (intellektuell, mental)',
    finnish: 'kehitysvammainen',
    hungarian: 'értelmileg akadályozott',
    german: 'geistig behindert',
    dutch: 'verstandelijke beperking, mentale handicap',
    afrikaans: 'gestremde, (intellektuele, kognitiewe, verstandelike)',
    russian: 'умственно отсталый',
    latvian:
      'invalīds, cilvēks ar īpašām vajadzībām (ar intelektuāliem, garīgiem, kustību traucējumiem)',
    polish: 'niepełnosprawny intelektualnie',
    french: 'handicapé mental',
    spanish: 'discapacitado (intelectual o mental)',
  },
  {
    av: 25995,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      "(physical impairment, physical disability + description indicator: having limits to one's physical abilities) Preferred NEW SYNONYM, replacing 16170",
    english: 'disabled, impaired, handicapped (physically)',
    swedish: 'rörelsehindrad',
    norwegian: 'funksjonshemmet (fysisk), bevegelseshemmet',
    finnish: 'liikuntavammainen',
    hungarian: 'sérült, fogyatékos, korlátozott (fizikailag)',
    german: 'körperbehindert',
    dutch: 'motorische beperking, lichamelijk beperking, fysich gehandicapt',
    afrikaans: 'gestremde, verswakte (liggaamlik, fisies)',
    russian: 'физически неспособный',
    latvian: 'invalīds, cilvēks ar īpašām vajadzībām (ar fizisku invaliditāti)',
    polish: 'niepełnosprawny fizycznie',
    french: 'handicapé physique',
    spanish: 'discapacitado (con discapacidad física)',
  },
  {
    av: 25996,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(measurement + farness, remoteness, farawayness) Preferred NEW SYNONYM, replacing 23071',
    english: 'distance',
    swedish: 'avstånd',
    norwegian: 'distanse, avstand',
    finnish: 'välimatka, etäisyys',
    hungarian: 'távolság',
    german: 'Abstand, Distanz',
    dutch: 'afstand',
    afrikaans: 'afstand',
    russian: 'расстояние, дистанция',
    latvian: 'ceļa posms, distance',
    polish: 'odległość',
    french: 'distance',
    spanish: 'distancia',
  },
  {
    av: 25997,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(empowerment + action indicator) Preferred NEW SYNONYM, replacing 24648',
    english: 'empower-(to)',
    swedish: 'ge egenmakt, ge rättighet, stärka',
    norwegian: 'bemyndige, gi fullmakt til (å)',
    finnish: 'valtuuttaa',
    hungarian: 'képessé tenni, megerősíteni, feljogosítani',
    german: 'ermächtigen, bevollmächtigen',
    dutch: 'machtigen, in staat stellen',
    afrikaans: 'bemagtig (om te)',
    russian: 'уполномочивать',
    latvian: 'pilnvarots',
    polish: 'upoważniać',
    french: 'autoriser, habiliter',
    spanish: 'autorizar',
  },
  {
    av: 25998,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(empowerment + description indicator) Preferred NEW SYNONYM, replacing 24649',
    english: 'empowered',
    swedish: 'berättigad, styrkt',
    norwegian: 'bemyndiget',
    finnish: 'valtuutettu',
    hungarian: 'képessé tett, feljogosított, megerősített',
    german: 'ermächtigt',
    dutch: 'gemachtigd',
    afrikaans: 'bemagtig',
    russian: 'уполномоченный',
    latvian: 'pilnvarots (adj)',
    polish: 'upoważniony',
    french: 'autorisé, habilité',
    spanish: 'autorizado(a)',
  },
  {
    av: 25999,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(give + power, powerfulness [contr.]) Preferred NEW SYNONYM, replacing 24650',
    english: 'empowerment',
    swedish: 'egenmakt, befogenhet',
    norwegian: 'bemyndigelse, fullmakt',
    finnish: 'valtuutus',
    hungarian: 'képessé tétel, erőnyújtás, megerősítés',
    german: 'Bevollmächtigung, Ermächtigung',
    dutch: 'machtiging',
    afrikaans: 'bemagtiging',
    russian: 'полномочие',
    latvian: 'pilnvarošana',
    polish: 'upoważnienie',
    french: 'autorisation',
    spanish: 'autorización',
  },
  {
    av: 26000,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(eternity, infinity + description indicator) Preferred NEW SYNONYM, replacing 21332',
    english: 'eternal',
    swedish: 'evig',
    norwegian: 'evig',
    finnish: 'ikuinen, loputon',
    hungarian: 'örök, örökös, szüntelen, örökkévaló',
    german: 'ewig',
    dutch: 'eeuwig',
    afrikaans: 'ewige',
    russian: 'вечный',
    latvian: 'mūžīgs',
    polish: 'wieczny, trwały',
    french: 'éternel',
    spanish: 'eterno',
  },
  {
    av: 26001,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(time + infiniteness, boundlessness, limitlessness) Preferred NEW SYNONYM, replacing 24892',
    english: 'eternity, infinity',
    swedish: 'evighet, oändlighet',
    norwegian: 'evighet, uendelighet',
    finnish: 'ikuisuus, loputtomuus',
    hungarian: 'örökkévalóság, végtelenség',
    german: 'Ewigkeit, Unendlichkeit, Endlosigkeit',
    dutch: 'eeuwigheid',
    afrikaans: 'ewigheid',
    russian: 'вечность, бесконечность',
    latvian: 'mūžība, bezgalība',
    polish: '',
    french: 'éternité, infini (temps)',
    spanish: 'eternidad, infinito',
  },
  {
    av: 26002,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(farness, remoteness, farawayness + description indicator) Preferred NEW SYNONYM, replacing 14150',
    english: 'far, distant, remote',
    swedish: 'långt bort, avlägsen, fjärran',
    norwegian: 'fjern, langt borte',
    finnish: '',
    hungarian: '',
    german: 'weit, fern',
    dutch: 'ver',
    afrikaans: 'ver, verre',
    russian: 'дальний, удалённый',
    latvian: 'tāls, attāls',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26003,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(fatness, thickness + description indicator) Preferred NEW SYNONYM, replacing 14156',
    english: 'fat, thick',
    swedish: 'tjock, fet',
    norwegian: 'tykk, fet',
    finnish: 'lihava, paksu',
    hungarian: 'kövér, vastag',
    german: 'dick, fett',
    dutch: 'dik, vet',
    afrikaans: 'vet, dik',
    russian: 'толстый, тучный',
    latvian: 'resns, biezs',
    polish: 'grube, szerokie',
    french: 'gros, gras',
    spanish: 'gordo, grueso',
  },
  {
    av: 26004,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(doubt + plus minus: reason on the basis of information of uncertain accuracy)',
    english: 'guess, estimation',
    swedish: 'gissning, uppskattning, bedömning',
    norwegian: 'gjetning, vurdering, bedømmelse, estimering',
    finnish: '',
    hungarian: '',
    german: 'Schätzung, Vermutung, Mutmaßung ',
    dutch: 'schatting',
    afrikaans: 'raai, skatting',
    russian: 'отгадка, догадка',
    latvian: 'minējums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26005,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + sport) Preferred NEW SYNONYM, replacing 14656',
    english: 'gym, gymnasium',
    swedish: 'gymnastiksal, gym',
    norwegian: 'gymsal, trimrom',
    finnish: 'voimistelusali',
    hungarian: 'tornaterem, tornacsarnok',
    german: 'Turnhalle, Gymnastikhalle',
    dutch: 'gymzaal, sportzaal',
    afrikaans: 'gimnasium',
    russian: 'спортзал',
    latvian: 'sporta zāle',
    polish: 'siłownia, sala gimnastyczna',
    french: 'gymnase',
    spanish: 'gimnasio',
  },
  {
    av: 26006,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rug, carpet, mat + sport) Preferred NEW SYNONYM, replacing 14657',
    english: 'gym mat',
    swedish: 'gymnastikmatta',
    norwegian: 'gymmatte, treningsmatte',
    finnish: 'voimistelumatto',
    hungarian: 'tornamatrac, polifóm',
    german: 'Gymnastikmatte, Weichbodenmatte, Turnmatte',
    dutch: 'mat (gym, turnen), turnmat',
    afrikaans: 'gimnasium mat',
    russian: 'гимнастические маты',
    latvian: 'vingrošanas paklājs',
    polish: 'mata / materac do ćwiczeń',
    french: 'tapis de gym',
    spanish: 'alfombra de gimnasia',
  },
  {
    av: 26007,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + ghost, phantom) Preferred NEW SYNONYM, replacing 14662',
    english: 'Halloween',
    swedish: 'Halloween',
    norwegian: 'Halloween',
    finnish: 'halloween, pyhäinpäivä',
    hungarian: 'Halloween, Mindenszentek előestéje',
    german: 'Halloween, Abend vor Allerheiligen',
    dutch: 'Allerheiligen, Halloween',
    afrikaans: "Halloween, All Saint's Day",
    russian: 'Хэллоуин',
    latvian: 'Helovīns, Visu Svēto dienas priekšvakars',
    polish: 'Halloween, Dzień wszystkich Świętych',
    french: 'halloween, Toussaint',
    spanish: 'halloween',
  },
  {
    av: 26008,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(limit(s), limitation, restriction + ear: ear representing hearing or to hear)',
    english: 'hearing impairment',
    swedish: 'hörselskada, hörselnedsättning',
    norwegian: 'hørselshemming',
    finnish: '',
    hungarian: '',
    german: 'Hörbehinderung, Gehörschädigung',
    dutch: 'auditieve beperking',
    afrikaans: 'gehoorgebrek, gehoorverlies, gehoorstoornis, gehoorgestremdheid',
    russian: 'нарушение слуха, ограничение слуха',
    latvian: 'dzirdes traucējumi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26009,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(hearing impairment + description indicator) Preferred NEW SYNONYM, replacing 14694',
    english: 'hearing-impaired',
    swedish: 'hörselskadad',
    norwegian: 'hørselshemmet',
    finnish: 'kuulovammainen',
    hungarian: 'hallássérült',
    german: 'hörbehindert',
    dutch: 'slechthorend, gehoorgestoord (bijv.nw)',
    afrikaans: 'gehoorgestremd',
    russian: 'слабослышащий, ограниченный слух',
    latvian: 'ar dzirdes traucējumiem',
    polish: 'niedosłyszący',
    french: 'malentendant',
    spanish: 'discapacitado auditivo',
  },
  {
    av: 26010,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(infiniteness, boundlessness, limitlessness + description indicator) Preferred NEW SYNONYM, replacing 14940',
    english: 'infinite, limitless',
    swedish: 'obegränsad, gränslös, oändlig',
    norwegian: 'ubegrenset, grenseløs',
    finnish: 'ääretön, rajaton',
    hungarian: 'határtalan/ul, korlátlan/ul, végtelen/ül',
    german: 'unendlich, unbegrenzt',
    dutch: 'oneindig, onbegrensd',
    afrikaans: 'oneindige, onbeperkde',
    russian: 'неограниченный, безграничный',
    latvian: 'bezgalīgs, neierobežots, bezgalīgs',
    polish: 'nieskończone, nieograniczone',
    french: 'illimité, infini',
    spanish: 'infinito',
  },
  {
    av: 26011,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(minus, no, without + limit(s), limitation, restriction) Preferred NEW SYNONYM, replacing 24915',
    english: 'infiniteness, boundlessness, limitlessness',
    swedish: 'gränslöshet, oändlighet',
    norwegian: 'ubegrensning, grenseløshet',
    finnish: '',
    hungarian: '',
    german: 'Unendlichkeit, Grenzenlosigkeit',
    dutch: 'oneindigheid',
    afrikaans: 'oneindigheid',
    russian: 'неограниченность, беспредельность',
    latvian: 'nebeidzamība, bezgalīgums',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26012,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(limit(s), limitation, restriction + mind, intellect, reason: limitation to one's mental abilities)",
    english: 'intellectual impairment, cognitive impairment, mental impairment',
    swedish: 'förståndshandikappad, utvecklingsstörd',
    norwegian: 'funksjonshemming (intellektuell, mental)',
    finnish: '',
    hungarian: '',
    german: 'geistige Behinderung, kognitive Beeinträchtigung',
    dutch: 'mentale beperking',
    afrikaans: 'intellektuele gestremdheid, kognitiewe inkorting, verstandelike gestremdheid',
    russian: 'умственная отсталость, интеллектуальное ограничение',
    latvian: 'intelektuālie, kognitīvie traucējumi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26013,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(tennis, racket sport, racquet sport + group: group representing team (sport) [contr.]) Preferred NEW SYNONYM, replacing 22102',
    english: 'lacrosse (sport)',
    swedish: 'lacrosse (sport)',
    norwegian: 'lacrosse (sport)',
    finnish: 'lacrosse, haavipallo',
    hungarian: 'lacrosse, kanadai labdajáték',
    german: 'Lacrosse (kanad. Nationalsport)',
    dutch: 'lacrosse',
    afrikaans: 'lacrosse (sport)',
    russian: 'лакросс (спорт)',
    latvian: 'lakross',
    polish: 'lacrosse (sport)- odmiana hokeja na trawie',
    french: 'crosse (sport)',
    spanish: 'lacrosse',
  },
  {
    av: 26014,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(limit(s), limitation, restriction + description indicator)',
    english: 'limit, restrict, restrain, confine-(to)',
    swedish: 'begränsa, avgränsa, inskränka',
    norwegian: 'begrense, innskrenke, avgrense (å)',
    finnish: '',
    hungarian: '',
    german: 'begrenzen, einschränken, beschränken, abgrenzen',
    dutch: 'begrenzen, beperken',
    afrikaans: 'limiet, beperk (om te)',
    russian: 'ограничивать',
    latvian: 'ierobežot, limitēt',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26015,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(limit(s), limitation, restriction + action indicator)',
    english: 'limited, restricted, confined',
    swedish: 'begränsad, avgränsad, inskränkt',
    norwegian: 'begrenset, innskrenket, avgrenset',
    finnish: '',
    hungarian: '',
    german: 'eingeschränkt, beschränkt, begrenzt, limitiert',
    dutch: 'begrensd, beperkt',
    afrikaans: 'beperkte',
    russian: 'ограниченный',
    latvian: 'ierobežots, limitēts',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26016,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(Nordic God + lie: the God of falseness) Preferred NEW SYNONYM, replacing 22822',
    english: 'Loki',
    swedish: 'Loke',
    norwegian: 'Loke',
    finnish: 'Loke, Loki, Lopt',
    hungarian: 'Loki (északi istenség)',
    german: 'Loki (nordischer Gott)',
    dutch: 'Loki (Noorse God)',
    afrikaans: 'Loki',
    russian: 'Локи (скадинавский Бог)',
    latvian: 'Loki',
    polish: 'Loki (skandynawski bóg kłamstwa)',
    french: 'Loki (mythologie nordique)',
    spanish: 'Loki',
  },
  {
    av: 26017,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + jump + far, distant) Preferred NEW SYNONYM, replacing 21845',
    english: 'long jump (sport)',
    swedish: 'längdhopp (sport)',
    norwegian: 'lengdehopp (sport)',
    finnish: 'pituushyppy',
    hungarian: 'távolugrás',
    german: 'Weitsprung (Sport)',
    dutch: 'verspringen (sport)',
    afrikaans: 'verspring',
    russian: 'прыжки в длину',
    latvian: 'tāllēkšana',
    polish: 'skok w dal (sport)',
    french: 'saut en longueur (sport)',
    spanish: 'salto de longitud',
  },
  {
    av: 26018,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(insect + puncture, prick-(to): insect that punctures, the skin or leaves or stems of plants)',
    english: 'louse, stinging insect',
    swedish: 'lus, stickande insekt',
    norwegian: 'insekt (stikkende) (lus, loppe etc)',
    finnish: '',
    hungarian: '',
    german: 'Laus, stechendes Insekt',
    dutch: 'luis, insect (prikkend)',
    afrikaans: 'branderige insek, stekerige insek',
    russian: 'вошь, жалящее насекомое ',
    latvian: 'uts, dzeļošs insekts ',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26019,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(gauge + farness, remoteness, farawayness + thing indicator: a meter that measures distance) Preferred NEW SYNONYM, replacing 23161',
    english: 'odometer',
    swedish: 'vägmätare, odometer',
    norwegian: 'avstandsmåler, odometer',
    finnish: 'matkamittari, odometri',
    hungarian: 'távolságmérő, útmérő, hodométer',
    german: 'Hodometer, Kilometerzähler',
    dutch: 'kilometerteller',
    afrikaans: 'odometer',
    russian: 'одометр',
    latvian: 'odometrs',
    polish: 'miernik odległości, drogomierz',
    french: 'compteur kilométrique, odomètre',
    spanish: 'cuentakilómetros',
  },
  {
    av: 26020,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(limit(s), limitation, restriction + body: limitations to one's physical abilities)",
    english: 'physical impairment, physical disability',
    swedish: 'rörelsehinder',
    norwegian: 'funksjonshemming (fysisk), forflytningshemming',
    finnish: '',
    hungarian: '',
    german: 'körperlicher Beeinträchtigung, Körperbehinderung',
    dutch: 'fysische beperking, ',
    afrikaans: 'fisiese inkorting, fisiese gestremdheid',
    russian: 'физическое ограничение, нарушение движений',
    latvian: 'fiziski traucējumi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26021,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(organ + food + fetus) Preferred NEW SYNONYM, replacing 24213',
    english: 'placenta',
    swedish: 'moderkaka, placenta',
    norwegian: 'morkake, placenta',
    finnish: 'istukka',
    hungarian: 'méhlepény, placenta',
    german: 'Plazenta, Mutterkuchen',
    dutch: 'placenta',
    afrikaans: 'plasenta',
    russian: 'плацента',
    latvian: 'placenta',
    polish: 'łożysko',
    french: 'placenta',
    spanish: 'placenta',
  },
  {
    av: 26022,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ability + control) Preferred NEW SYNONYM, replacing 24718',
    english: 'power, powerfulness',
    swedish: 'makt',
    norwegian: 'makt, kraft',
    finnish: 'valta',
    hungarian: 'erő, erőteljesség, hathatósság',
    german: 'Kraft, Macht',
    dutch: 'vermogen, kracht',
    afrikaans: 'krag',
    russian: 'сила',
    latvian: 'spēks, enerģija, stiprums, enerģiskums',
    polish: 'moc, kontrola nad czymś',
    french: 'pouvoir, puissance',
    spanish: 'poder',
  },
  {
    av: 26023,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(power, powerfulness + description indicator) Preferred NEW SYNONYM, replacing 24719',
    english: 'powerful, mighty',
    swedish: 'mäktig',
    norwegian: 'mektig, kraftig',
    finnish: 'mahtava, valtava',
    hungarian: 'erős, erőteljes, hathatós, tekintélyes',
    german: 'mächtig, kraftvoll',
    dutch: 'krachtig, machtig',
    afrikaans: 'kragtig, sterk',
    russian: 'сильный',
    latvian: 'stiprs, spēcīgs, varens',
    polish: 'potężny, silny',
    french: 'puissant',
    spanish: 'poderoso',
  },
  {
    av: 26024,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + sitski, sit ski)',
    english: 'sitski, sit ski (sport)',
    swedish: 'sitski (sport)',
    norwegian: 'sitski (sport)',
    finnish: 'hiihtokelkka, biski-kelkka',
    hungarian: 'ülősí',
    german: 'Sitzski, Skischlitten, Sit-Ski (Sport)',
    dutch: 'zitski (sport)',
    afrikaans: 'sitski (sport)',
    russian: 'сидячие лыжи (спорт)',
    latvian: 'sēdslēpes (sports)',
    polish: 'narty z siedziskiem ew nartosanki (sport)',
    french: 'ski assis (sport)',
    spanish: 'silla esquí (deporte)',
  },
  {
    av: 26025,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      "(speech impairment, dysarthria + description indicator: having limits to one's physical abilities) Preferred NEW SYNONYM, replacing 17225",
    english: 'speech impaired',
    swedish: 'talskadad',
    norwegian: 'talehemmet',
    finnish: 'puhevammainen, puhehäiriöinen',
    hungarian: 'beszédsérült, beszédfogyatékos, beszédzavaros',
    german: 'sprachbehindert',
    dutch: 'spraakstoornis',
    afrikaans: 'spraakgestremd',
    russian: 'неговорящий, нарушенная речь',
    latvian: 'runas invaliditāte',
    polish: 'zaburzenia mowy',
    french: 'handicapé de la parole',
    spanish: 'discapacitado del habla',
  },
  {
    av: 26026,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(limit(s), limitation, restriction + to speak: having difficulties to speak intelligibly)',
    english: 'speech impairment, dysarthria',
    swedish: 'talskada, dysartri',
    norwegian: 'talehemming',
    finnish: '',
    hungarian: '',
    german: 'Sprachbehinderung, Sprachstörung, Dysathrie',
    dutch: 'dysarthrie, spraakstoornis',
    afrikaans: 'spraakgebrek',
    russian: 'нарушение речи, дизартрия',
    latvian: 'runas traucējumi, disartrija',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26027,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(tennis, racket sport, racquet sport + room) Preferred NEW SYNONYM, replacing 22101',
    english: 'squash (sport)',
    swedish: 'squash (sport)',
    norwegian: 'squash (sport)',
    finnish: 'squash (urheilu)',
    hungarian: 'fallabda, squash (mint sportág)',
    german: 'Squash (Sport)',
    dutch: 'squash',
    afrikaans: 'muurbal',
    russian: 'сквош',
    latvian: 'skvošs',
    polish: 'squash (sport)',
    french: 'squash, tennis en salle (sport)',
    spanish: 'squash (deporte)',
  },
  {
    av: 26028,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(tennis (activity) + table: game like tennis, played on a table) Preferred NEW SYNONYM, replacing 16183',
    english: 'table tennis, ping-pong (activity)',
    swedish: 'bordtennis (aktivitet)',
    norwegian: 'bordtennis (aktivitet)',
    finnish: 'pöytätennis',
    hungarian: 'asztalitenisz, pingpong (játék, sport)',
    german: 'Tischtennis, Ping Pong (Aktivität)',
    dutch: 'tafeltennis, pingpong (activiteit)',
    afrikaans: 'tafeltennis, pingpong',
    russian: 'настольный теннис',
    latvian: 'galda teniss',
    polish: 'ping-pong, tenis stołowy',
    french: 'ping-pong, tennis de table (activité)',
    spanish: 'ping-pong',
  },
  {
    av: 26029,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(tennis, racket sport, racquet sport + table) Preferred NEW SYNONYM, replacing 20603',
    english: 'table tennis, ping-pong (sport)',
    swedish: 'bordtennis (sport)',
    norwegian: 'bordtennis (sport)',
    finnish: 'pöytätennis',
    hungarian: 'asztalitenisz, pingpong',
    german: 'Tischtennis, Ping Pong (Sport)',
    dutch: 'tafeltennis, pingpong (sport)',
    afrikaans: 'tafeltennis, pingpong',
    russian: 'настольный теннис (спорт)',
    latvian: 'galda teniss (sports)',
    polish: 'tenis stołowy',
    french: 'tennis de table',
    spanish: 'tenis de mesa, ping pong',
  },
  {
    av: 26030,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + racket, racquet) Preferred NEW SYNONYM, replacing 20602',
    english: 'tennis, racket sport, racquet sport',
    swedish: 'tennis, racketsport',
    norwegian: 'tennis (sport)',
    finnish: 'tennis',
    hungarian: 'tenisz',
    german: 'Tennis, Ballsportarten mit Schläger',
    dutch: 'racketsport, tennis (sport)',
    afrikaans: 'raketsport',
    russian: 'теннис, ракетный спорт',
    latvian: 'teniss (sports)',
    polish: 'tenis (sport)',
    french: 'tennis (sport)',
    spanish: 'tenis (deporte con raqueta)',
  },
  {
    av: 26031,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + racket, racquet: game played with racquets) Preferred NEW SYNONYM, replacing 17522',
    english: 'tennis (activity)',
    swedish: 'tennis (aktivitet)',
    norwegian: 'tennis (aktivitet)',
    finnish: 'tennis',
    hungarian: 'tenisz (játék, sport)',
    german: 'Tennis (Aktivität)',
    dutch: 'tennis (activiteit)',
    afrikaans: 'tennis',
    russian: 'теннис',
    latvian: 'teniss',
    polish: 'tenis (aktywność)',
    french: 'tennis (activité)',
    spanish: 'tenis (actividad)',
  },
  {
    av: 26032,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limit(s), limitation, restriction + to see: difficulties to see)',
    english: 'visual impairment',
    swedish: 'synskada, synnedsättning',
    norwegian: 'synshemming',
    finnish: '',
    hungarian: '',
    german: 'Sehbehinderung',
    dutch: 'visuele beperking',
    afrikaans: 'gesiggestremdheid, visueel gestremdheid',
    russian: 'нарушение зрения, ограничение зрения',
    latvian: 'redzes traucējumi',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26033,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(visual impairment + description indicator: having difficulties to see) Preferred NEW SYNONYM, replacing 18019',
    english: 'visually impaired',
    swedish: 'synskadad',
    norwegian: 'synshemmet',
    finnish: 'näkövammainen',
    hungarian: 'látássérült, gyengénlátó (mn.)',
    german: 'sehbehindert',
    dutch: 'slechtziend',
    afrikaans: 'gesiggestremde, visueel gestremde',
    russian: 'слабовидящий, нарушенное зрение',
    latvian: 'redzes invaliditāte, ar redzes traucējumiem',
    polish: 'niedowidzący',
    french: 'malvoyant',
    spanish: 'discapacitado visual',
  },
  {
    av: 26100,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + knife: ”sharp”, ”cutting” and harmful behaviour)',
    english: 'cruelty, mercilessness, ruthlessness',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26102,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + end)',
    english: 'endlessness',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26103,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(floating container + description indicator)',
    english: 'floating, afloat',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26104,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(question + intensity)',
    english: 'interrogation',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26105,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(competition + loss)',
    english: 'loss (competition)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26106,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sadness + loss)',
    english: 'mourning, grief',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26107,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bridge + language)',
    english: 'translation',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26108,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(under (ground level) + description indicator)',
    english: 'underground, below ground',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26120,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + all + saint)',
    english: "All Saints' Day",
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26121,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal, beast + temperature + up and down: animal with varying body temperature, generally depending on the external temperature of the environment)',
    english: 'animal (cold-blooded), cold-blooded animal, poikilotherm, ectotherm',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26122,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal, beast + temperature + same, equal, equality: animal with stable body temperature, generally controlled by internal bodily functions)',
    english: 'animal (warm-blooded), warm-blooded animal, homeotherm, endotherm',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26123,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(generalisation + shellfish (without claws): invertebrate animals having an external skeleton, a segmented body, and jointed appendages, include insects, arachnids (spiders etc.), myriapods, and crustaceans (crabs, crayfish, shrimps etc.))',
    english: 'arthropod(s)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26124,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(dog, canine (animal), canid + help, aid, assistance, support)',
    english: 'assistance dog',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26125,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + map)',
    english: 'atlas, book of maps',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26126,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(forward + difficulty: forward move, with difficulty)',
    english: 'attempt, effort, try',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26127,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + group: documentation of a group of people)',
    english: 'attendance list, register list, contact list',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26128,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalisation + organ, inner organ, inner body part + ear)',
    english: 'auditory system',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26129,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + smell, odour [contraction of mustelid] + many + line)',
    english: 'badger',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26130,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(time + bed)',
    english: 'bedtime',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26131,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(many + flower + attachment, appendix, annex: many flowers together)',
    english: 'bouquet (flowers)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26132,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(river, stream, current + littleness, smallness: a small stream of water)',
    english: 'brook, creek',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26133,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(grave + group of + stone: a heap of stones and earth placed over typically prehistoric tombs)',
    english: 'burial mound, grave mound',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26134,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(town, city + country, state: the city of primary status in a country, state, or province, usually as its seat of government)',
    english: 'capital, capital city',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26135,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal, beast + meat: animal that eats (the meat of) other animals)',
    english: 'carnivore',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26136,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(person + carpentry [contraction with omission of work]) ',
    english: 'carpenter',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26137,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(work + tool + tree [contraction of wood (material + tree)]: work with tools for building with wood)',
    english: 'carpentry, wood work',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26138,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(person + story, tale)',
    english: 'character (in a story)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26139,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(fill-(to) + electricity + action indicator)',
    english: 'charge (electricity)-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26140,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(full + electricity + description indicator)',
    english: 'charged (electricity)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26141,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + filling, fill, fullness + electricity: thing for charging with electricity)',
    english: 'charger, battery charger',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26142,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(cat, feline (animal), felid + quickness, rapidity, speediness: cat animal that is the swiftest mammal)',
    english: 'cheetah',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26143,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(fiber, fibre, fibril, filament, strand, + atom + spiral [the latter two is a contraction of the DNA molecule]: the threadlike body in the cell nucleus that carries the DNA spiral molecule with genes in a linear order)',
    english: 'chromosome',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26144,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(filament [contraction of thread, string, cord] + dryness: line for drying clothes etc.)',
    english: 'clothes line, drying line',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26145,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + pen + colour)',
    english: 'coloring book',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26146,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(communication impairment + description indicator)',
    english: 'communication impaired',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26147,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limit(s), limitation, restriction + communication)',
    english: 'communication impairment',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26148,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(mixture + change, alteration + earth, ground, land: mixture that is transformed into earth)',
    english: 'compost',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26149,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling, emotion, sensation + mixture: mixed feelings about something)',
    english: 'confusion (feeling)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26150,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mind, intellect, reason + mixture: mixed thinking about something)',
    english: 'confusion (mental)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26151,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + cooking, cookery, preparation (general))',
    english: 'cookbook, cookery book',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26152,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(rotation, circulation, orbit, lap, circle, round + life: the cycle of generation of life, life span, death, and regeneration of new life)',
    english: 'cycle of life, life cycle',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26153,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(book + word: a reference book containing an alphabetical list of words with information about them)',
    english: 'dictionary, lexicon, wordbook',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26154,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(play (in combinations) + digits (computer): any kind of digital game on computers, game consoles or mobile devices) - Preferred NEW SYNONYM, replacing computer game (OLD) 23449',
    english: 'digital game, video game, computer game',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26155,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(group of, much of, many of, quantity of + different, other, difference, inequality: many of something being different in character, a heterogeneous group)',
    english: 'diversity, variety (general)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26156,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(atom [contraction of molecule] + life + spiral: the spiral formed DNA molecule of life carrying the genetic code)',
    english: 'DNA',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26157,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(receiving + digits (computer): the getting of digital data from a server on the internet)',
    english: 'download',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26158,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(download + action indicator)',
    english: 'download-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26159,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal, beast + fire)',
    english: 'dragon',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26160,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(structure, construction + dryness, drought: construction for drying something)',
    english: 'drying rack',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26161,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drying rack + cloth)',
    english: 'drying rack (cloth)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26162,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drying rack + fish)',
    english: 'drying rack (fish)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26163,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bone + ear)',
    english: 'ear bone, ossicle, auditory ossicle',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26164,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(membrane, drumhead, drum skin + ear)',
    english: 'eardrum, tympanic membrane',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26166,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(same, equal, equality + society: a certain level of general social equality among citizens of a state or community)',
    english: 'equality (social)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26167,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + health: work, in order to maintain health)',
    english: 'exercise (physical)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26168,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(picture, image, icon, painting + face + brush: painting on the face made with brush)',
    english: 'face painting',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26169,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fear, fright, concern + height, tallness)',
    english: 'fear of heights, acrophobia',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26170,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(filament [contraction of thread, string, cord] + reception + fish: line for catching fish)',
    english: 'fishing line',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26171,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(linear thing, pole + reception + fish + thing indicator: rod for catching fish)',
    english: 'fishing rod',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26172,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hand + fold, folding)',
    english: 'fist',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26173,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(worker + airplane, aeroplane, plane)',
    english: 'flight attendant',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26174,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(part, bit, piece, portion, part of + DNA: section of the DNA molecule that encodes the production of a certain polypeptide chain, a unit of heredity)',
    english: 'gene',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26175,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science, body of learning + atom + spiral: contraction of science + gene)',
    english: 'genetics',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26176,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(organ, inner organ, inner body part + breath + fish: The respiratory organ of fish and other aquatic animals)',
    english: 'gill',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26177,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal, beast + food + plant: animals that primarily eat plants)',
    english: 'herbivore',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26178,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(layer, level + plan, design, method, system: a series of ordered groupings or levels of people or things within a system)',
    english: 'hierarchy',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26179,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(honesty + description indicator)',
    english: 'honest, honestly',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26180,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(purpose + truth: strive for truth)',
    english: 'honesty',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26181,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal, beast + sound + up, upward + mouth [up + mouth is a contraction of laugh, laughter]: the hyena is known for its laughing sound)',
    english: 'hyena',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26182,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(feeling + illness + inner organ + food [organ + food is a contraction of stomach, tummy, tum])',
    english: 'indigestion, heartburn',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26183,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + factory, plant)',
    english: 'industry',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26184,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(different, other, difference + society: social inequality among citizens or members of a state or community)',
    english: 'inequality',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26185,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + without + spine, backbone)',
    english: 'invertebrate',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26186,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(support (oral) + correctness)',
    english: 'justification',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26187,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(justification + description indicator)',
    english: 'justified',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26188,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(justification + action indicator)',
    english: 'justify-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26189,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(development + language)',
    english: 'language development',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26190,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(time + life + all: the period during which something lives or is functional, as between birth and death)',
    english: 'lifetime, life-time, lifespan',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26191,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + book)',
    english: 'literature',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26192,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(limitation + eye + nearness, closeness, proximity: difficulty to see near objects)',
    english: 'longsightedness, farsightedness, presbyopia, hyperopia',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26193,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(presbyopia, hyperopia, farsightedness, longsightedness + description indicator)',
    english: 'longsighted, farsighted, presbyopic, hyperopic',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26194,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cat + ear + hair: medium sized wild cat with usually tufted ears)',
    english: 'lynx, bobcat',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26195,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(compost + action indicator)',
    english: 'make compost-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26196,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + milk: warm-blooded vertebrate having the skin more or less covered with hair; young are born alive and nourished with milk)',
    english: 'mammal',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26198,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(mustelid (animal) [contraction] + fur: the mink being a mustelid animal valued for its fur)',
    english: 'mink',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26199,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(thing + change + signal, broadcast, transmitting: a device that modulates signal transmissions between different formats)',
    english: 'modem',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26200,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(newness, novelty + intensity + description indicator: novelty with some kind of emphasis)',
    english: 'modern',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26201,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(group of + atom: a group of two or more atoms held together by chemical bonds)',
    english: 'molecule',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26202,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(generalization + snail: invertebrate animals having a soft unsegmented body usually enclosed in a shell)',
    english: 'mollusk(s), mollusc(s)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26203,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(axis + moon: the Moon's spin axis, around which it turns in about the same time that it circles the Earth)",
    english: 'moon axis',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26204,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      "(limited time, interval, period + moon: appearances of the Moon's state of illumination) Additional specifier can be added, such as ”full” , ”half”, ”first quarter” and ”last quarter”",
    english: 'moon phase, phase of the moon',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26205,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(plant + without + root(s): small flowerless, non-vascular plants, lacking proper root systems, and that usually grow in dense green clumps or mats, in damp or shady locations)',
    english: 'moss',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26206,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(group of + mountain)',
    english: 'mountain range',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26207,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + smell + intensity: family of carnivorous mammals, including the weasel, badger, etc. Mustelids are typically known for producing a strong-smelling secretion)',
    english: 'mustelid (animal)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26208,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(park + country, state: an area of land declared by the national government to be public property)',
    english: 'national park',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26209,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(limitation + eye + farness, remoteness: difficulty to see distant objects)',
    english: 'nearsightedness, shortsightedness, myopia',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26210,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(myopia, nearsightedness, shortsightedness + description indicator)',
    english: 'nearsighted, shortsighted, myopic',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26213,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(substance + giving + health)',
    english: 'nutrient, nutrition',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26214,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + food + animal + plant: an animal or person that feeds on both animal and vegetable food)',
    english: 'omnivore',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26215,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(1 + time + past)',
    english: 'once upon a time',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26216,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(digital game, video game + internet (1) [contraction])',
    english: 'online game, multiplayer game, network game',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26217,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(orbit + moon)',
    english: 'orbit of the moon',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26218,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limited time, period + life)',
    english: 'period of life',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26219,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(finger + pliers: a grip with the fingers, as if with pliers or pincer)',
    english: 'pinch, pincer grip',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26220,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(pinch, pincer grip + action indicator)',
    english: 'pinch, pluck, tweeze-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26221,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + plant)',
    english: 'plant-book, dictionary of plants',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26222,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sack, bag + material + chemical product [contraction of plastic])',
    english: 'plastic bag',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26223,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plough + past: ancient plough)',
    english: 'plough (ancient), ard, ard plough, scratch plough',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26224,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + repetition: work at something repeatedly to develop skill)',
    english: 'practice, drill, exercise, rehearsal',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26225,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + waste sorting, garbage sorting)',
    english: 'recycling station',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26226,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + decision + sport)',
    english: 'referee, judge (sport)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26227,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + decision + football, soccer (sport) [contraction])',
    english: 'referee (football, soccer)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26228,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(usage, use + again)',
    english: 'reuse, recycling',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26229,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(reuse, recycling + action indicator)',
    english: 'reuse, use again, recycle-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26230,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(rot, decomposition, rotting matter + action indicator + thing indicator)',
    english: 'rot, decompose-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26231,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(change, alteration, conversion + organism + deletion, cancellation, destruction + thing indicator: the decomposing change of organic material performed by organisms, primarily micro-organisms, breaking it down)',
    english: 'rot, decomposition, rotting matter',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26232,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(rot, decomposition, rotting matter + description indicator + thing indicator)',
    english: 'rotten, decomposed',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26233,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(connector, interface box + signal, broadcast, transmitting + thing indicator: a networking device that forwards data packets between computer networks)',
    english: 'router',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26234,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + run)',
    english: 'run, jog',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26235,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(flavouring, condiment, seasoning + salt crystal [contraction]) Preferred NEW SYNONYM, replacing 20523',
    english: 'salt',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26236,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(water + salt crystal [contraction]: water containing salts)',
    english: 'saltwater, seawater',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26237,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(taste + salt crystal [contraction] + description indicator) Preferred NEW SYNONYM, replacing 16712',
    english: 'salty',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26238,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(animal + food + dead: animals that feed on carrion and other dead organisms)',
    english: 'scavenger, carrion eater',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26239,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(year + school (in combinations)) ',
    english: 'school year',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26240,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(photograph, photo, pic + self: photo taken on oneself)',
    english: 'selfie',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26241,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(computer + combination, connection: a computer that provides client stations with access to programs, files, printers etc. as shared resources in a computer network)',
    english: 'server, host (computer)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26242,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(downward and forward + description indicator)',
    english: 'sloping, sloped, slanting, slanted',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26243,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(type, kind, sort, category + action indicator)',
    english: 'sort, differentiate, separate, classify-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26244,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(waste sorting + action indicator)',
    english: 'sort garbage, separate waste-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26247,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bone + back (body))',
    english: 'spine, backbone',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26248,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(sloping, sloped, slanting, slanted + intensity + description indicator)',
    english: 'steep',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26249,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(river, stream, current + digits (computer): a stream of digital data)',
    english: 'stream (digital), data stream',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26250,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(stream (digital), data stream + action indicator: to stream digital data, typically media content over the internet)',
    english: 'stream (digital data)-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26251,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(stream (digital), data stream + description indicator: digital data, typically media content, streaming over the internet)',
    english: 'streamed, streaming (digital data)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26252,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(sweat, perspiration + description indicator)',
    english: 'sweaty, sweating, perspiring',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26253,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(season + school (in combinations))',
    english: 'term, semester',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26254,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(taste + seaweed: one of the five basic tastes (together with sweetness, sourness, bitterness, and saltiness) first identified in Japan from kombu seaweed)',
    english: 'umami',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26255,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(umami + description indicator)',
    english: 'umami tasting',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26256,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + finished, complete, completed + description indicator)',
    english: 'unfinished',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26257,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(1 + wheel: one wheeled vehicle)',
    english: 'unicycle, monocycle, one-wheeled vehicle',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26258,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(without + finished, complete, completed + description indicator)',
    english: 'unicycle, ride a one-wheeled vehicle-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26259,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(untruth, falsity, falsehood + description indicator)',
    english: 'untrue, false',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26260,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + truth)',
    english: 'untruth, falsity, falsehood',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26261,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(giving, gift + digits (computer): the sharing of digital data to a server on the internet)',
    english: 'upload',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26262,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(upload + action indicator)',
    english: 'upload-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26263,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(action + legs and feet: the act of walking (somewhere))',
    english: 'walk, walking',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26264,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(type, kind, sort, category + waste, garbage, rubbish, trash: separation of different kinds of waste for recycling)',
    english: 'waste sorting, garbage sorting, source separation (of waste)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26265,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + spine, backbone: animals with a backbone or spinal column)',
    english: 'vertebrate',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26266,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(eye + description indicator)',
    english: 'visible, sighted',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26267,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(light + through + thing: shortwave radiation passing through otherwise non-transparent things, used in medical diagnosis etc.)',
    english: 'X-ray',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26268,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(X-ray + action indicator)',
    english: 'X-ray-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26280,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(get + mind + action indicator: to receive reasons)',
    english: 'accept-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26281,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + sound)',
    english: 'audio book',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26282,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(medical aid + teeth)',
    english: 'brace(s) (dental), dental brace(s) (medical)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26283,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid + teeth + line: help to set the teeth in a row)',
    english: 'brace(s) (dental), dental brace(s)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26284,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(medical aid + neck)',
    english: 'brace (neck, medical), neck brace, cervical collar, neck collar',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26285,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(damage + brain)',
    english: 'brain injury',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26286,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothes + without + sleeve [contraction])',
    english: 'cape, poncho, clothing without sleeves',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26287,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(two + linear thing + food: tools for eating food)',
    english: 'chopstick(s)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26288,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(damage + central nervous system)',
    english: 'CNS injury',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26289,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(mind + activity: an alert cognitive state in which you are aware)',
    english: 'consciousness, awareness',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26290,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + pan: all kinds of cooking pans in a kitchen)',
    english: 'cooking vessel, pots and pans',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26291,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation:
      '(person + evaluate: a person that evaluates things eg. best restaurant or best film',
    english: 'critic, evaluator',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26292,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fibre + teeth: a string for cleaning between the teeth)',
    english: 'dental floss',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26293,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(outcome + evaluation medical)',
    english: 'diagnosis (medical)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26294,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(disappointment + description after the fact indicator)',
    english: 'disappointed',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26295,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(disappointment + description indicator) ',
    english: 'disappointing',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26296,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sadness + after + desire)',
    english: 'disappointment',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26297,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(limitation + mathematics[contraction]: limited ability in mathematics)',
    english: 'dyscalculia',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26298,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limitation + writing; limited ability to learn to write)',
    english: 'dysgraphia',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26299,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limitation + reading: limited ability to learn to read)',
    english: 'dyslexia',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26300,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + muscle + up and down; neurological movement disorder with sustained or repetitive muscle contractions)',
    english: 'dystonia',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26301,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + digits)',
    english: 'e-book, digital book',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26302,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of egg [contraction] + white: the albumin surrounding the yolk)',
    english: 'egg white, white of egg, albumin, glair',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26303,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of egg [contraction] + yellow: the center part of an egg, )',
    english: 'egg yolk, yolk',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26304,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shell + egg: the shell of an egg)',
    english: 'eggshell',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26305,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(fainting + action indicator)',
    english: 'faint, pass out-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26306,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(mind + without + activity + limited time: a spontaneous loss of consciousness for a limited period of time)',
    english: 'fainting, absence',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26307,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + hair + together)',
    english: 'hair accessory',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26308,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + hair + linear thing)',
    english: 'hair pin, bobby pin',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26309,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thing + hair + ring)',
    english: 'hair tie',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26310,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + protection + health: activity concerned with the maintenance of health)',
    english: 'hygiene',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26311,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + protection + health + person: activity concerned with the maintenance of personal health)',
    english: 'hygiene (personal)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26312,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(brush + teeth + between: a small brush made for cleaning between the teeth)',
    english: 'interdental brush, interdental rager',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26313,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(martial arts + kick [contraction]): martial art including fight with hands and feet)',
    english: 'karate',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26314,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(two + linear thing + cloth: needles used for knitting)',
    english: 'knitting needle(s)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26315,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + waste: the leftovers of food that is thrown away)',
    english: 'leftovers, left overs, food waste (food thrown away)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26316,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + again: leftovers of food that is served again time)',
    english: 'leftovers, left overs (food used again)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26317,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(difficulty + mathematics [contraction)]: difficulties with mathematics)',
    english: 'mathematical difficulty',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26318,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hair + mouth + pointer to the upper lip)',
    english: 'moustache',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26319,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(movie + activity + fast, quick)',
    english: 'movie, action film, action movie, film (action)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26320,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(movie + love)',
    english: 'movie, romance movie, romance film, film (romantic)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26321,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(neuron + description indicator)',
    english: 'neurological',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26322,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(limitation + activity + muscle: a limited ability or loss of a voluntary muscle function)',
    english: 'paralysis, palsy',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26324,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + bowel movement: a place where a user can defecate)',
    english: 'privy, outhouse',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26325,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(difficulty + reading: difficulties with reading)',
    english: 'reading difficulty',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26326,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(understand + suddenly [contraction] + action indicator',
    english: 'realize, realise-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26327,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(outcome + most: the extreme outcome)',
    english: 'record (achievement)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26328,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(get + again: get or find back)',
    english: 'regain, recover, retrieve-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26329,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothes + arm)',
    english: 'sleeve(s)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26330,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + up + clothes)',
    english: 'suspender(s)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26332,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + muscle + back and forth: an involuntary vibration)',
    english: 'tremor, shudder',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26333,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(mind + without + activity: a state of lacking awareness, sometimes deep and prolonged unconsciousness)',
    english: 'unconscious, comatose',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26334,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(unconsciousness + description indicator)',
    english: 'unconsciousness, coma, comatoseness',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26335,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(food + plant + description indicator)',
    english: 'vegetarian (food)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26336,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + food + plant: a person who eats plants and not any meat)',
    english: 'vegetarian (person)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26337,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(curiosity + action indicator)',
    english: 'wonder, inquire, enquire, be curious-(to)',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26338,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(difficulty + writing: difficulties with writing',
    english: 'writing difficulty',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 26339,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(thread + fabric: thread used in sewing, knitting and weaving)',
    english: 'yarn',
    swedish: '',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27001,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(concept + description indicator)',
    english: 'abstract',
    swedish: 'abstrakt',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27002,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(word + evaluation: evaluation words)',
    english: 'adjective',
    swedish: 'adjektiv',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27003,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(word + evaluation + action)',
    english: 'adverb',
    swedish: 'adverb',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27004,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(unit + together + language)',
    english: 'affix',
    swedish: 'affix',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27005,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(life + descriptive indicator)',
    english: 'alive',
    swedish: 'levande',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27006,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wrapping + [contr.]metal)',
    english: 'aluminium foil, tin foil',
    swedish: 'folie, aluminiumfolie',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27007,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + feeling: loss of feeling)',
    english: 'anaesthesia, numbness',
    swedish: 'bedövning, anestesi',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27008,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(medication + end + feeling)',
    english: 'anaesthetic',
    swedish: 'bedövningsmedel',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27009,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part + language + the)',
    english: 'article',
    swedish: 'artikel (gramatik)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27010,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(linear + after, behind )-Character (sequenced) ',
    english: 'beside',
    swedish: 'brevid, vid sidan av',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27011,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(effect + bite: effect of a bite (being bitten))',
    english: 'bite',
    swedish: 'bett',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27012,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(circulation + blood)',
    english: 'blood circulation',
    swedish: 'blodcirkulation',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27013,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pressure + blood)',
    english: 'blood pressure',
    swedish: 'blodtryck',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27014,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fracture + bone)',
    english: 'bone fracture',
    swedish: 'benbrott, fraktur',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27015,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(boring + after fact indicator)',
    english: 'bored',
    swedish: 'uttråkad',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27016,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(sickness + without + energy [contr.] + description indicator) ',
    english: 'burned out, burnt out',
    swedish: 'utbränd',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27017,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fruit + cactus)',
    english: 'cactus fruit (dragon fruit, cherimoya)',
    swedish: 'katusfikon, cherimoya',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27018,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(candy + root)',
    english: 'candy (liquorice)',
    swedish: 'lakrits (-godis)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27019,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(leaf + medical + star)',
    english: 'cannabis',
    swedish: 'cannabis',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27020,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lamp + car)',
    english: 'car light(s)',
    swedish: 'billycktor, billampor',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27021,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(stop + heart: stop of the heart)',
    english: 'cardiac arrest',
    swedish: 'hjärtstopp, hjärtstillestånd',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27022,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(right + child) ',
    english: 'children’s rights',
    swedish: 'barnrätt, barnens rätt (FN)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27023,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(restaurant [contr.] + French fries)',
    english: 'chip shop',
    swedish: 'gatukök',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27024,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sickness + tired + intensity + intensity + intensity)',
    english: 'chronic fatigue syndrome',
    swedish: 'kroniskt trötthetssyndrom',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27025,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(village + agreement: A group of housing with agreement)',
    english: 'co-housing',
    swedish: 'kollektivboende',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27026,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(small character of thought)',
    english: 'concept',
    swedish: 'koncept, grundtanke',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27027,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(concept + action indicator)',
    english: 'conceptualise-(to)',
    swedish: 'gestalta',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27028,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(thing + description indicator)',
    english: 'concrete',
    swedish: 'konkret',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27029,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(word + combination)',
    english: 'conjunction',
    swedish: 'konjunktion',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27030,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(squash, pumpkin + long)',
    english: 'courgette, zucchini',
    swedish: 'squash, zuccini',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27031,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(four crumbs (two in high and two in low positions): indicating particles)-charachter (superimposed-sequenced)',
    english: 'crumbs',
    swedish: 'smulor',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27032,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(the + description indicator)',
    english: 'definite',
    swedish: 'bestämd form',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27033,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + feeling + interesting)',
    english: 'delicacy, speciality (food)',
    swedish: 'delikatess, specialitet (-mat)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27034,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lead + permission + choice)',
    english: 'democracy (general)',
    swedish: 'demokrati (allmänt)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27035,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(leader + permission + without +choice)',
    english: 'dictator (general)',
    swedish: 'diktator (allmänt)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27036,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(lead + permission + without + choice)',
    english: 'dictatorship (general)',
    swedish: 'diktatur (allmänt)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27037,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(discovery + action indicator',
    english: 'discover-(to)',
    swedish: 'upptäcka',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27038,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: 'find + new)',
    english: 'discovery',
    swedish: 'upptäckt',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27039,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(washer + dish)',
    english: 'dishwasher',
    swedish: 'diskmaskin',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27040,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(drink + mix)',
    english: 'drink mix, shake, smoothie',
    swedish: 'smootie, shake',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27041,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(category + [contr.] noun + two)',
    english: 'dual',
    swedish: 'dualis',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27042,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + must: protected requirements eg in law)',
    english: 'duty, obligation',
    swedish: 'plikt, skyldighet',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27043,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(substance + ear: substance of the ear) ',
    english: 'earwax',
    swedish: 'öronvax',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27044,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + descriptive indicator before fact)',
    english: 'edible, eatable',
    swedish: 'ätlig, ätbar',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27045,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(material + through + electricity)',
    english: 'electric conductor',
    swedish: 'elektrisk ledare',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27046,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(toothbrush + electicity)',
    english: 'electric toothbrush',
    swedish: 'elektrisk tandborste',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27047,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fiber + electric)',
    english: 'electric wire, electric cord, cord, cable, lead',
    swedish: 'elektrisk tråd, elektrisk kabel, elektrisk ledare',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27048,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(call + danger)',
    english: 'emergency call, emergency telephone',
    swedish: 'nödsamtal',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27049,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + medical + danger)',
    english: 'emergency room (medical)',
    swedish: 'akutmottagning',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27050,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sickness + spread)',
    english: 'epidemic',
    swedish: 'epidemi',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27051,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part + throat + lid)',
    english: 'epiglottis',
    swedish: 'epiglottis, struplock',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27052,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(feeling + without + energy [contr.] + description indicator)',
    english: 'exhausted, worn out',
    swedish: 'utmattad, utsliten',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27053,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '([contr.] search + new)',
    english: 'exploration',
    swedish: 'utforskning',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27054,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + fast)',
    english: 'fast food',
    swedish: 'snabbmat',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27055,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid + medical + first)',
    english: 'first aid',
    swedish: 'första hjälpen',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27056,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + fish)',
    english: 'fish skin',
    swedish: 'fiskskinn',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27057,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(category + language + future: language category of future time)',
    english: 'future tense',
    swedish: 'framtid, futurum',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27058,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(start + grow) ',
    english: 'germination',
    swedish: 'groning, groddning',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27059,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + grain + descriptive indicator)',
    english: 'gluten-free',
    swedish: 'glutenfri',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27060,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rules + word: rules of the language)',
    english: 'grammar (general)',
    swedish: 'gramatik(-allmänt)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27061,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(unit + small + different + write: the smallest unit that makes difference in writing). Contraction of smallest',
    english: 'grapheme',
    swedish: 'grafem',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27062,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(body + pointer to groin)-Character (superimposed + pointer)',
    english: 'groin',
    swedish: 'ljumske',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27063,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sickness + heart + lightning)',
    english: 'heart attack',
    swedish: 'hjärtattack',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27064,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sickness + heart)',
    english: 'heart disease',
    swedish: 'hjärtsjukdom',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27065,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(help+aid+assistant+support+description indicator)',
    english: 'helpful, assistive, supportive',
    swedish: 'hjälpsam, assisterande, stödjande',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27066,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(right + person)',
    english: 'human rights',
    swedish: 'mänskliga rättigheter',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27067,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(immunity + evaluation indicator)',
    english: 'immune (medical)',
    swedish: 'immun (-medicinsk)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27068,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(against + sickness)',
    english: 'immunity (medical)',
    swedish: 'immunitet (-medicinsk)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27069,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(improvement + act.indicator: the effect of being better in a rational sense)',
    english: 'improve-(to)',
    swedish: 'förbättra',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27070,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(effect + more + correct +: the effect of being better in a rational sense) se also improve-(to) ',
    english: 'improvement, enhancement',
    swedish: 'förbättring, förändring',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27071,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(live + independent)',
    english: 'independent living',
    swedish: 'självständigt boende',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27072,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(unit + language + inside)',
    english: 'infix',
    swedish: 'infix',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27073,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(inflate + description before fact indicator)',
    english: 'inflatable',
    swedish: 'uppblåsbar',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27074,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(word + feeling)',
    english: 'interjection',
    swedish: 'interjektion',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27075,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + car + cross: a place where cars cross the road)',
    english: 'intersection, crossroad',
    swedish: 'vägkorsning',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27076,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + comma + funny) se also joke-(to) (general)',
    english: 'joke (general)',
    swedish: 'skämt (allmänt)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27077,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to say + comma + funny) see also joke-(to) (spoken) 14974',
    english: 'joke (spoken)',
    swedish: 'skämt (talat)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27078,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(joke (general) + act.indicator) see also joke (general)',
    english: 'joke-(to) (general)',
    swedish: 'skämta (allmänt)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27079,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(animal + container + jump)',
    english: 'kangaroo, wallaby',
    swedish: 'kängeru, vallaby',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27080,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: showing a particle )',
    english: 'kernel, particle',
    swedish: 'kärna, partikel',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27081,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(room + business)- charachter (superimposed)',
    english: 'kiosk, booth, stall',
    swedish: 'kiosk',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27082,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bone + back + curve)',
    english: 'kyphosis, scoliosis',
    swedish: 'skolios, kufos',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27083,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part + throat + activity + sound)',
    english: 'larynx',
    swedish: 'struphuvud',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27084,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(limitation + learning)',
    english: 'learning difficulty',
    swedish: 'inlärningssvårigheter',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27085,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pictograph: showing lichen growing on a stone)',
    english: 'lichen',
    swedish: 'lav, lavar',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27086,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(warm + little + hand + description indicator)',
    english: 'lukewarm, handwarm, tepid',
    swedish: 'fingervarmt',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27087,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(furred animal + nose)',
    english: 'mammoth',
    swedish: 'mammut',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27088,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(candy + [contr.]soft)',
    english: 'marshmallow',
    swedish: 'mashmallow',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27089,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(smoothie + [contr.] milk)',
    english: 'milkshake',
    swedish: 'milkshake',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27090,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(unit +[contr.] + small + different + words [contr.] word: the smallest unit that makes difference in words). Contraction of smallest',
    english: 'morpheme',
    swedish: 'morfem',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27091,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rules + structure + word: rules of the language structure)',
    english: 'morphology',
    swedish: 'morfologi',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27092,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(inside + nose)',
    english: 'nasal cavity',
    swedish: 'näshåla',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27093,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(activity + sign + action indicator)',
    english: 'navigate-(to) (general)',
    swedish: 'navigera (allmänt)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27094,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + sign)',
    english: 'navigation (general)',
    swedish: 'navigering (allmänt)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27095,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + alcohol)',
    english: 'non-alcoholic',
    swedish: 'alkoholfri',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27096,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(word + name) ',
    english: 'noun',
    swedish: 'substantiv',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27097,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(nudity + descriptive indicator)',
    english: 'nude, naked',
    swedish: 'naken ',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27098,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(without + clothes)',
    english: 'nudity',
    swedish: 'nakenhet',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27099,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(word + number: numeral words)',
    english: 'number, numeral',
    swedish: 'nummer, siffra',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27100,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(inside + mouth)',
    english: 'oral cavity',
    swedish: 'munhåla',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27101,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + oven)',
    english: 'oven paper',
    swedish: 'bakplåtspapper',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27102,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(roof + mouth)',
    english: 'palate, roof of mouth',
    swedish: 'gom',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27103,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sickness + spread + intensity)',
    english: 'pandemic',
    swedish: 'pandemi',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27104,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(category + word)',
    english: 'part of speech',
    swedish: 'dela av tal',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27105,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(category + language + past: language category of past time)',
    english: 'past tense',
    swedish: 'dåtid, preteritum',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27106,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(seed + combination: seeds joined in combination)',
    english: 'peanut',
    swedish: 'jordnöt',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27107,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(unit + [contr.] + small + different + sound: the smallest sound unit that makes difference). Contraction of smallest',
    english: 'phoneme',
    swedish: 'fonem',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27108,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rules + sound + word: rules of language sounds) ',
    english: 'phonology',
    swedish: 'fonologi',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27109,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(restaurant [contr.] + pizza)',
    english: 'pizzeria',
    swedish: 'pizzeria',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27110,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sickness + first + micro-organism + intensity)',
    english: 'plague',
    swedish: 'pest',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27111,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wrapping + [contr.]plastic)',
    english: 'plastic wrap',
    swedish: 'hushållsplast, plastfolie',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27112,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(category + [contr.] noun + many)',
    english: 'plural',
    swedish: 'flertal, plural',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27113,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pointing + thing indicator)',
    english: 'pointer',
    swedish: 'pekare',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27114,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear thing + big)',
    english: 'pole',
    swedish: 'påle, stång',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27115,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(powder + flower)',
    english: 'pollen',
    swedish: 'pollen',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27116,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(word + after)',
    english: 'post position',
    swedish: 'postposition',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27117,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(unit + language + beginning: language units in the beginning of a word)',
    english: 'prefix',
    swedish: 'prefix',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27118,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(word + in front of)',
    english: 'preposition',
    swedish: 'preposition',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27119,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(category + language + present: language category of present time)',
    english: 'present tense',
    swedish: 'nutid, presens',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27120,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(word + in exchange for + name: in exchange for nouns)',
    english: 'pronoun',
    swedish: 'pronomen',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27121,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(protection + freedom: protection of freedom)',
    english: 'right(s)',
    swedish: 'rättighet, rättigheter',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27122,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(right + person + limited)',
    english: 'rights of persons with disabilities, disability rights',
    swedish: 'rättighet för personer med funktionsnedsättning',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27123,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + car + rotate: a place where the cars can turn)',
    english: 'roundabout',
    swedish: 'rondell, cirkulationsplats',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27124,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(science + language + meaning: study/science of linguistic/language meanings)',
    english: 'semantics',
    swedish: 'semantik',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27125,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(house + share: shared housing, groupliving)',
    english: 'shared housing',
    swedish: 'delat boende',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27126,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(category + [contr.] noun + one) ',
    english: 'singular',
    swedish: 'ental, singular',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27127,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(medication + sleep)',
    english: 'sleep medication',
    swedish: 'sömnmedel',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27128,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pill + sleep)',
    english: 'sleeping pill',
    swedish: 'sömnpiller',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27129,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + sleep + animal)',
    english: 'sleeping place, nest (animals)',
    swedish: 'boplats, viloplats (djur)',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27130,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(substance + nose: substance of the nose)',
    english: 'snot',
    swedish: 'snor',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27131,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plant + start)',
    english: 'sprout',
    swedish: 'grodd',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27132,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fruit + star)',
    english: 'starfruit, carambola',
    swedish: 'stjärnfrukt, carambola',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27133,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + medical + sound)',
    english: 'stethoscope',
    swedish: 'stetoskop',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27134,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bandage + together: contracted bandage sticky)',
    english: 'sticking plaster, bandaid',
    swedish: 'plåster',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27135,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(mix + spoon + action indicator)',
    english: 'stir-(to)',
    swedish: 'röra ihop',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27136,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + pressure)',
    english: 'stress',
    swedish: 'stress ',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27137,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(stress + descriptive indicator)',
    english: 'stressed, stressful',
    swedish: 'stressad, stressande',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27138,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(stuttering + action indicator)',
    english: 'stutter-(to)',
    swedish: 'stamma',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27139,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(limitation + mouth + repeat: speech limitation, repetition of sounds and blocks)',
    english: 'stuttering',
    swedish: 'stamning',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27140,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(mouth + into (backward) + action indicator)',
    english: 'suck-(to)',
    swedish: 'suga',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27141,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(unit + language + end: language units in the end of a word)',
    english: 'suffix',
    swedish: 'suffix',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27142,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: 'ball + [contr.]rice+fish',
    english: 'sushi',
    swedish: 'sushi',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27143,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rules + sentence: rules of the language sentences)',
    english: 'syntax',
    swedish: 'syntax',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27144,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(category + language + time: language category of time)',
    english: 'tense',
    swedish: 'tempus',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27145,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gland + throat)',
    english: 'thyroid gland',
    swedish: 'sköldkörtel',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27146,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(need+rest+description indicator: need of rest)',
    english: 'tired, weary',
    swedish: 'trött, uttröttad',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27147,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part + throat + immunity)',
    english: 'tonsils',
    swedish: 'tonsill',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27148,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(lamp + [contr.] traffic)',
    english: 'traffic light',
    swedish: 'trafikljus',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27149,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(male + female + description indicator)-Character (superimposed)',
    english: 'transgender',
    swedish: 'transgender',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27150,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: 'male + female + person) )-Character (superimposed)',
    english: 'transgender person',
    swedish: 'transperson',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27151,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(food + only + plant)',
    english: 'vegan food',
    swedish: 'vegansk kost',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27152,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(word + action: action words)',
    english: 'verb',
    swedish: 'verb',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27153,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(stinging insect + wings + exclamation mark)',
    english: 'wasp',
    swedish: 'geting',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27154,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(mix + kitchen tool, utensil + action indicator)',
    english: 'whisk, beat-(to)',
    swedish: 'vispa',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27155,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fiber + metal [contr.])',
    english: 'wire, cable',
    swedish: 'tråd, kabel',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27156,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(signal + digital + minus + fiber) Bliss-word synonym',
    english: 'wireless connection',
    swedish: 'trådlöst nätverk, wifi, trådlös uppkoppling',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27157,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(spiral + thing indicator)',
    english: 'wrapping',
    swedish: 'omslag',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 27158,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(wrapping + paper)',
    english: 'wrapping, paper roll',
    swedish: 'omslagspapper, presentpapper, pappersrulle',
    norwegian: '',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28001,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(purpose + forward)',
    english: 'aim,intention',
    swedish: 'avsikt,syfte,mening',
    norwegian: 'intensjon,mål',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'mikpunt,voorneme,intensie',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28002,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(allow + before_fact)',
    english: 'allowable,permissable',
    swedish: 'tillåtelse',
    norwegian: 'tillatelig,mulig_tillatt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'toelaatbaar,toelaatbaar',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28003,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(allow + after_fact)',
    english: 'allowed,permitted',
    swedish: 'tillåtet',
    norwegian: 'tillatt,autorisert',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'toegelaat,',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28004,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(park + excitement)',
    english: 'amusement_park,theme_park',
    swedish: 'nöjespark,tivoli',
    norwegian: 'fornøyelsespark',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'pretpark',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28005,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid + arm)',
    english: 'arm_support',
    swedish: 'armstöd',
    norwegian: 'armstøtte',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'armstut',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28007,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(group + see + hear)',
    english: 'audience',
    swedish: 'publik,åhörare',
    norwegian: 'publikum',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'gehoor',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28008,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + basketball [contraction])',
    english: 'basketball_player',
    swedish: 'basketbollspelare',
    norwegian: 'basketballspiller',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'basketbal_speler',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28009,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(festival + costume)',
    english: 'carnival',
    swedish: 'karneval',
    norwegian: 'karneval',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'karnival',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28010,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(climate [contraction] + development)',
    english: 'climate_change',
    swedish: 'klimatförändring',
    norwegian: 'klimaendring',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'klimaatverandering',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28011,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(climate change + danger)',
    english: 'climate_emergency',
    swedish: 'klimathot',
    norwegian: 'karneval',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'klimaat_nood',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28012,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(change + forward [modification,short arrow]:change through progression) - Character (superimposed - modified)',
    english: 'development',
    swedish: 'utveckling',
    norwegian: 'utvikling',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'ontwikkeling',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28013,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(discrimination + action indicator)',
    english: 'discriminate-(to)',
    swedish: 'diskriminera',
    norwegian: 'diskriminere-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'diskrimineer-(om_te)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28014,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(discriminate-(to) + person)',
    english: 'discriminate_(person)-(to)',
    swedish: 'diskriminera (person)',
    norwegian: 'diskriminere_(person)-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: "diskrimineer_persoon-(om_'n_persoon_te_diskrimineer)",
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28015,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(discriminatory + person)',
    english: 'discriminated_(person)',
    swedish: 'diskriminerad',
    norwegian: 'diskriminert_(person)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'gediskrimineerde_persoon',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28016,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sort + different)',
    english: 'discrimination',
    swedish: 'diskriminering',
    norwegian: 'diskriminering',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'diskriminasie',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28017,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(discrimination + person)',
    english: 'discrimination_(person)',
    swedish: 'diskriminering,fördom',
    norwegian: 'diskriminering_(person)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'diskriminerende_persoon',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28018,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(discrimination + description indicator)',
    english: 'discriminatory',
    swedish: 'diskriminerad',
    norwegian: 'diskriminerende',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'diskriminerend',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28019,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(certain + action indicator [remove doubt]) ',
    english: 'ensure,guarantee-(to)',
    swedish: 'försäkra,garantera',
    norwegian: 'forsikre,garantere-(to)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'verseker,waarborg-(om_te)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28020,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + costume)',
    english: 'event_dressing_up,carnival',
    swedish: 'maskerad,karneval',
    norwegian: 'maskerade',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'geleentheid_aantrek_karnaval, ',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28021,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pointing + eye)',
    english: 'eye_pointing',
    swedish: 'ögonpekning',
    norwegian: 'øyepeking,blikkpaking',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'oogbediening',
    afrikaans: 'oogvolg ',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28022,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(eye_pointing + digital)',
    english: 'eye_pointing_(digital)',
    swedish: 'ögonpekning (digital)',
    norwegian: 'øyepeking_(digital)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'oogbediening_(digitaal)',
    afrikaans: 'oogvolg_(digitaal)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28023,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(gathering + costume)',
    english: 'fancy_dress_party',
    swedish: 'kostymfest,maskerad',
    norwegian: 'utkledingsfest,kostymefest',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'stylpartytjie,kostuumpartytjie',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28024,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + excitement)',
    english: 'festival',
    swedish: 'festival',
    norwegian: 'festival',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'festival',
    afrikaans: 'fees',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28025,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + football [contraction])',
    english: 'football_field,soccer_field',
    swedish: 'fotbollsplan',
    norwegian: 'fotballbane',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'voetbalveld',
    afrikaans: 'sokkerveld',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28026,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(competition + football [contraction])',
    english: 'football_game,match,soccer_game',
    swedish: 'fotbollsmatch',
    norwegian: 'fotballkamp',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'voetbalwedstrijd',
    afrikaans: 'sokker_wedstryd',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28027,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + football [contraction])',
    english: 'football_player,soccer_player',
    swedish: 'fotbollsspelare',
    norwegian: 'fotballspiller',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'voetbalspeler',
    afrikaans: 'sokkerspeler',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28028,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(climate change + temperature + rising)',
    english: 'global_warming',
    swedish: 'global uppvärmning',
    norwegian: 'global_oppvarming',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'globale_opwarming',
    afrikaans: 'aardverwarming',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28029,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pole [contraction] + goal)',
    english: 'goalpost',
    swedish: 'målstolpe',
    norwegian: 'målstolpe',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'doellat,lat_(doel)',
    afrikaans: 'doelpaal',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28030,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + football [contraction])',
    english: 'goal_keeper',
    swedish: 'målvakt',
    norwegian: 'målvakt,keeper',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'keeper',
    afrikaans: 'doelwagter',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28031,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fabric + goal)',
    english: 'goal_net',
    swedish: 'målnät',
    norwegian: 'målnett',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'net_(doel)',
    afrikaans: 'doel_net',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28032,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(goal + intensity) [the goal you make in a game]',
    english: 'goal_(result),score',
    swedish: 'mål',
    norwegian: 'mål_(resultat),skåring',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'goal,doelpunt',
    afrikaans: 'doel_(resultaat),telling',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28033,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(purpose + end)',
    english: 'goal,target',
    swedish: 'målsättning,syfte',
    norwegian: 'mål,målretting',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'doel,einddoel',
    afrikaans: 'doelwit,teiken',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28034,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + handball [contraction])',
    english: 'handball_court',
    swedish: 'handbollsplan',
    norwegian: 'håndballbane',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'handbalveld',
    afrikaans: 'handbalbaan',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28035,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(competition + handball [contraction])',
    english: 'handball_game',
    swedish: 'handbollsmatch',
    norwegian: 'håndballkamp',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'handball_(competitie)',
    afrikaans: 'handbal_wedstryd',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28036,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + handball [contraction])',
    english: 'handball_player',
    swedish: 'handbollsspelare',
    norwegian: 'håndballspiller',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'handbalspeler',
    afrikaans: ' handbalspeler',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28037,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid + head)',
    english: 'head_support',
    swedish: 'huvudstöd',
    norwegian: 'hodestøtte',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'hoofdsteun',
    afrikaans: 'kopstut',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28038,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(nation + feeling) (country + feeling) should be "state", instead of "nation"',
    english: 'homeland,nationality_(loyalty)',
    swedish: 'hemland,fosterland',
    norwegian: 'hjemland, nasjonal_(lojal)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'thuisland',
    afrikaans: 'tuisland,nasionaliteit,lojaliteit',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28039,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shirt + protection + head)',
    english: 'hoodie',
    swedish: 'huvtröja,hoodie',
    norwegian: 'hettegenser,hoodie',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'hoodie',
    afrikaans: 'kappie',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28040,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + ice hockey [contraction])',
    english: 'ice_hockey_rink',
    swedish: 'ishockeyrink',
    norwegian: 'ishocky_bane,',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'ijshockeyveld?',
    afrikaans: 'yshokkiebaan',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28041,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(implementation + action indicator)',
    english: 'implement-(to)',
    swedish: 'genomföra,realisera',
    norwegian: 'gjennomføre,realiserie,implementere_(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'implementeren,realiseren',
    afrikaans: 'implementeer-(om_te)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28042,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cause + happen)',
    english: 'implementation,realization',
    swedish: 'genomförande,realisering',
    norwegian: 'gjennomføring, realisering',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'implemantatie, realisatie',
    afrikaans: 'implementering,besef',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28047,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(insurance + action indicator)',
    english: 'insure-(to)',
    swedish: 'försäkra',
    norwegian: 'forsikre-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'verzekeren',
    afrikaans: 'verseker-(om_te)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28048,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + hear)',
    english: 'listener',
    swedish: 'åhörare,lyssnare',
    norwegian: 'lytter,tilhører',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'luisteraar',
    afrikaans: 'luisteraar',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28049,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(time + long)',
    english: 'long_lasting,durable',
    swedish: 'långvarig,varaktig',
    norwegian: 'langvarig,varig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'duurzaam',
    afrikaans: 'langdurige,duursaam',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28050,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + citizen)',
    english: 'manner,manners',
    swedish: 'sätt,uppträdande',
    norwegian: 'maner,atferd,sedvane',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'manier,maniere',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28051,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + most)',
    english: 'manner,way,mode,style_(habit)',
    swedish: 'sätt,bruk,vana',
    norwegian: 'måte,stil',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'manier,mode,stijl',
    afrikaans: 'wyse,manier,styl_(gewoonte)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28052,
    group: 'word',
    pos: 'GREY',
    derivationExplanation:
      '(grammatical modification (small) [half size, crossing baseline]) - Character (modified)',
    english: 'modifier_(diminutive_form)',
    swedish: 'modifier (diminutiv form)',
    norwegian: 'modifikasjon_(diminutiv_form)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'wysiger_(verkleinwoord)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28053,
    group: 'word',
    pos: 'GREY',
    derivationExplanation:
      '(grammatical modification (feminine) [half size, crossing baseline]) - Character (modified)',
    english: 'modifier_(feminine_form)',
    swedish: 'modifier (feminin form)',
    norwegian: 'modifikasjon_(feminin_form)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'wysiger_(vroulike_vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28055,
    group: 'word',
    pos: 'GREY',
    derivationExplanation:
      '(grammatical modification (masculine) [half size, crossing baseline]) - Character (modified)',
    english: 'modifier_(masculine_form)',
    swedish: 'modifier (maskulin form)',
    norwegian: 'modifikator_(maskulin_form)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'wysiger_manlike_vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28056,
    group: 'word',
    pos: 'GREY',
    derivationExplanation:
      '(grammatical modification (neuter) [bottom part of symbol for person, half size, crossing baseline]) - Character (modified)',
    english: 'modifier_(neuter_form)',
    swedish: 'modifier (neutrumform)',
    norwegian: 'modifikator_(nøytral_form)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'wysiger_(onsydige_vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28057,
    group: 'word',
    pos: 'GREY',
    derivationExplanation:
      '(grammatical modification (to) [half size, crossing baseline]) - Character (modified)',
    english: 'modifier_(object_form,direct_object,accusative)',
    swedish: 'modifier (direkt objektsform,ackustiv)',
    norwegian: 'modifiikator_objekt_form,direkte_objekt,akkusativ',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'wysiger_(voorwerp_vorm,direkte_voorwerp,akkusatief)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28058,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(festival + music [contraction]) ',
    english: 'music_festival',
    swedish: 'musikfestival',
    norwegian: 'musikkfestival',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'muziek_festival',
    afrikaans: 'musiekfees',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28059,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(nation + paper) should be state_paper',
    english: 'nationality_(official)',
    swedish: 'nationalitet',
    norwegian: 'statsborgerskap,natsjonalitet_(offisiell)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'nationaliteit',
    afrikaans: 'nasionaliteit_(amptelik)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28060,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(consequence + minus)',
    english: 'negative_outcome',
    swedish: 'negativt resultat',
    norwegian: 'resultat_negativt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'negatief_resultaat',
    afrikaans: 'negatiewe_uitkoms',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28061,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(aid + head_and_neck) should be neck (head)',
    english: 'neck_support',
    swedish: 'nackstöd',
    norwegian: 'nakkestøtte',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'nek_ondersteuning,nekstut',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28062,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(case + paint [contraction])',
    english: 'paint_box',
    swedish: 'färglåda',
    norwegian: 'vannfargeskrin',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'verfpot',
    afrikaans: 'verf_boks',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28063,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(punishment + sport)',
    english: 'penalty_(sport)',
    swedish: 'straff (sport)',
    norwegian: 'straff_(sport)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'strafpunt_(sport),penalty',
    afrikaans: 'straf_(sport)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28064,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(consequence + plus)',
    english: 'positive_outcome',
    swedish: 'resultat (positivt)',
    norwegian: 'resultat_positivt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'positief_resultaat',
    afrikaans: 'positiewe_uitkoms',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28065,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(event + feeling + equality)',
    english: 'pride_parade,festival_of_equality',
    swedish: 'pridefestival',
    norwegian: 'pride_parade',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'parade,festival',
    afrikaans: 'trots,parade,fees_van_gelykheid',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28066,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(consequence + negative)',
    english: 'punishment',
    swedish: 'bestraffning',
    norwegian: 'straff,avstraffelse',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'straf',
    afrikaans: 'straf',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28067,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(reality + description indicator)',
    english: 'realistic',
    swedish: 'verklig,realistisk',
    norwegian: 'realistisk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'realistisch',
    afrikaans: 'realisties',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28068,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to cause + reality)',
    english: 'realize-(to)',
    swedish: 'förverkliga',
    norwegian: 'realisere-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'realiseren',
    afrikaans: 'besef-(om_te),om_te_besef',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28069,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(card + red) [penalty in sporting game]',
    english: 'red_card,penalty_card_(sports)',
    swedish: 'rött kort,straffkort (sport)',
    norwegian: 'rødt_kort,straff_kort_(sport)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'rode_kaart',
    afrikaans: 'rooikaart,strafkaart_(sport)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28070,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(generalization + idea)',
    english: 'reference,references,source,sources',
    swedish: 'uppslag,referenser,källa (till information),',
    norwegian: 'referanse,kilde',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'referentie,bron_(referentie)',
    afrikaans: 'verwysing,verwysings,bron,bronne',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28071,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + references)',
    english: 'reference_list',
    swedish: 'referenslista',
    norwegian: 'referanseliste',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'referentielijst',
    afrikaans: 'verwysingslys',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28072,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(consequence + positive)',
    english: 'reward',
    swedish: 'belöning',
    norwegian: 'belønning',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'beloning',
    afrikaans: 'beloning',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28073,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(vehicle + up + turn + fast)',
    english: 'roller_coaster',
    swedish: 'bergochdalbana',
    norwegian: 'berg-og-dal-bane',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'roller_coaster',
    afrikaans: 'tuimeltrein',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28074,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + rugby [contraction])',
    english: 'rugby_field,football_field_(N.A.)',
    swedish: 'rugbyplan',
    norwegian: 'rugby_bane',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'rugbyveld',
    afrikaans: 'rugbyveld,sokker_veld',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28075,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(attachment + fabric)',
    english: 'seam_(fabric)',
    swedish: 'söm,tygsöm',
    norwegian: 'søm_(tekstil)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'naad_(kleding)',
    afrikaans: 'soom_(materiaal)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28076,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + see)',
    english: 'spectator',
    swedish: 'åskådare',
    norwegian: 'tilskuer',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'toeschouwer',
    afrikaans: 'toeskouer',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28077,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(digital device + speak)',
    english: 'speech_generating_device,voice_output_device,speech_output_device,talker',
    swedish: 'talapparat,talsyntesapparat',
    norwegian: 'talemaskin',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'spraakcomputer,communicatiehulpmiddel',
    afrikaans:
      'spraak_generende_toestel,stem_uitset_toestel,spraak_uitset_toestel,kommunikasie_toestel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28078,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(protection + action indicator + future)',
    english: 'sustain-(to)',
    swedish: 'upprätthålla,bevara',
    norwegian: 'opprettholde-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'behouden',
    afrikaans: 'volhou-(om_vol_te_hou)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28079,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(attachment + medical)',
    english: 'suture,join,seam_(medical)',
    swedish: 'sutur,stygn (kirurgi)',
    norwegian: 'sutur,søm_(medisinsk)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'gewricht',
    afrikaans: 'hegting,saamvoeg,naat',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28080,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shirt + over)',
    english: 'sweater,jumper,pullover',
    swedish: 'tröja,kofta,jumper,sweater',
    norwegian: 'genser,pullover',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'trui,pull,pullover',
    afrikaans: 'trui,oortrektrui',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28081,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(clothes + group)',
    english: 'uniform',
    swedish: 'uniform',
    norwegian: 'uniform',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'uniform',
    afrikaans: 'uniform',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28082,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(amusement park + pool)',
    english: 'water_park',
    swedish: 'vattenpark,vattenland',
    norwegian: 'badeland',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'pretpark',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28083,
    group: 'word',
    pos: 'GREY',
    derivationExplanation:
      '(emotion + talking + hand+ intensity [superimposed]: something you say to play down a small accident)',
    english: 'whoops,oops',
    swedish: 'hoppsan!,Oj_då!',
    norwegian: 'oi,heisann,oppsann',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'oeps,o_gits',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28084,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(card + yellow: warning for bad behavior in sporting game)',
    english: 'yellow_card,penalty_card_(sports)',
    swedish: 'gult_kort,straffkort',
    norwegian: 'gult_kort,straff_kort_(sport)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'gele_kaart',
    afrikaans: 'geelkaart,strafkaart_(sport)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29001,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + address [contraction])',
    english: 'address_book,contact_list',
    swedish: 'adressbok',
    norwegian: 'adressebok',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'adres_boek,kontaklys',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29002,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(time + after)',
    english: 'afterwards',
    swedish: 'efteråt,därefter',
    norwegian: 'etterpå',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'agterna',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29005,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(time + 2_(digital))',
    english: 'another_time',
    swedish: 'en_annan_gång',
    norwegian: 'en_annen_gang',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: "n_ander_keer,met_'n_ander_geleentheid,volgende_keer",
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29006,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + question + application)',
    english: 'applicant',
    swedish: 'sökande',
    norwegian: 'søker,jobbsøker',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'aansoeker',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29007,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(question + decision)',
    english: 'application',
    swedish: 'ansökan',
    norwegian: 'søknad',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'aansoek',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29008,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(activity + application + action indicator)',
    english: 'apply-(to)',
    swedish: 'ansöka_om',
    norwegian: 'søke_om-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'aansoek_doen-(om_te)(om_aansoek_te_doen)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29009,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(collection + important)',
    english: 'archive',
    swedish: 'arkiv',
    norwegian: 'arkiv',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'argief',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29010,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + thing + baby)',
    english: 'baby_shop,baby_store',
    swedish: 'babybutik',
    norwegian: 'babybutikk,babyutstyrsbutikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'baba_winkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29011,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + bag)',
    english: 'bag_shop,bag_store,luggage_shop,luggage_store',
    swedish: 'väskaffär',
    norwegian: 'veskebutikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'sak_winkel,bagasie_winkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29012,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(time + before)',
    english: 'beforehand',
    swedish: 'innan,på_förhand',
    norwegian: 'på_forhånd',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'vooraf',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29013,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + bicycle)',
    english: 'bicycle_shop,bicycle_store',
    swedish: 'cykelaffär',
    norwegian: 'sykkelbutikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'fiets_winkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29014,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(folder + ring)',
    english: 'binder,ring_binder',
    swedish: 'pärm,ringpärm',
    norwegian: 'ringperm',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'binder,ringbinder',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29015,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(fiber + stretching + hook)',
    english: 'bungee',
    swedish: 'elastisk_stropp,bagagestropp',
    norwegian: 'elastisk_stropp,bagasjestropp   ',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'rekspring,reksprong',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29016,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + car)',
    english: 'car_dealer,car_dealership',
    swedish: 'bilhandlare,bilaffär',
    norwegian: 'bilforretning,bilforhandler',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'motorhandelaar',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29017,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + digital_device)',
    english: 'computer_shop,computer_store,electronics_shop,electronics_store',
    swedish: 'datoraffär,elektronikaffär',
    norwegian: 'databutikk,elektrobutikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'rekenaar_winkel,elektroniese_winkel,',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29018,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(concavity + description indicator)',
    english: 'concave',
    swedish: 'konkav',
    norwegian: 'konkav',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'konkaaf',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29019,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(concavity: lines curving inward) - Character',
    english: 'concavity',
    swedish: 'kon_(formen)',
    norwegian: 'konkav',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'konkawiteit',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29020,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + cone)',
    english: 'cone_(shape)',
    swedish: 'konform',
    norwegian: 'kjegleform',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'keëlvorm',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29021,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(convexity + description indicator)',
    english: 'convex',
    swedish: 'konvex',
    norwegian: 'konveks',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'konveks ',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29022,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(convexity: lines curving or bulging outward) - Character',
    english: 'convexity',
    swedish: 'lins_(konvex)',
    norwegian: 'konveks',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'konveksiteit',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29023,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(virus + crown)',
    english: 'Corona_virus',
    swedish: 'coronavirus',
    norwegian: 'Coronavirus',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: ' Koronavirus',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29024,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(corona_virus + 19)',
    english: 'Covid_19',
    swedish: 'covid_19',
    norwegian: 'Covid_19',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'Kovid_19',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29025,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + cube)',
    english: 'cube_(shape)',
    swedish: 'kub_(formen)',
    norwegian: 'kubeform',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'kubus_(vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29026,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + cylinder)',
    english: 'cylinder_(shape)',
    swedish: 'cylinder_(formen)',
    norwegian: 'sylinderform',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'silinder_(vorm),silindriese(vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29027,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(year + month + day)',
    english: 'date(1)',
    swedish: 'datum',
    norwegian: 'dato(1)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'datum(1)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29028,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(day + month + year)',
    english: 'date(2)',
    swedish: 'datum',
    norwegian: 'dato(2)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'datum(2)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29029,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(month + day + year)',
    english: 'date(3)',
    swedish: 'datum',
    norwegian: 'dato(3)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'datum(3)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29030,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + corner [contraction] + 10)',
    english: 'decagon',
    swedish: 'tiohörning,dekagon',
    norwegian: 'tikant,dekagon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'tienhoek',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29031,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(enclosed_space + pen + digital)',
    english: 'digital_board,interactive_board,smart_board',
    swedish: 'smartboard,elektronisk_tavla',
    norwegian: 'elektronisk_tavle,smart-board',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'digitale_bord,interaktiewe_bord,slimbord',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29032,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(toward + exclamation mark)',
    english: 'direct,directly',
    swedish: 'direkt',
    norwegian: 'direkte',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'direk',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29033,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(string + stretching)',
    english: 'elastic_cord,elastic_band',
    swedish: 'resår,gummiband,gummicord,resårband,gummistropp',
    norwegian: 'elastisk_bånd,strikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'elastiese_koord',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29034,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + thing + electricity)',
    english: 'electrical_shop,electrical_store',
    swedish: 'el-affär,el-butik',
    norwegian: 'elektrobutikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'elektriese winkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29035,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(destroy + thing indicator) - Character',
    english: 'eraser',
    swedish: 'radergummi,suddgummi,sak_att_ta_bort_med',
    norwegian: 'viskelær',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'uitveër',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29036,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(all + place)',
    english: 'everywhere',
    swedish: 'överallt',
    norwegian: 'overalt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'oral',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29037,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + stretching)',
    english: 'fabric_shop,fabric_store',
    swedish: 'tygaffär',
    norwegian: 'tekstilbutikk,stoffbutikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'materiaal_winkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29038,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chest_of_drawers + folder)',
    english: 'filing_cabinet',
    swedish: 'arkivskåp,dokumentskåp',
    norwegian: 'arkivskap',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'liasseerkabinet',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29039,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(earth + description indicator)',
    english: 'global',
    swedish: 'global,världsomfattande',
    norwegian: 'global',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'wêreldwyd',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29040,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(glue + tube [pictorial])',
    english: 'glue_stick,glue_tube',
    swedish: 'klistertub,limstift',
    norwegian: 'limstift,limtube',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'gom_stok,gom_buis',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29041,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + tool)',
    english: 'hardware_store_(goods)',
    swedish: 'järnhandel',
    norwegian: 'jernvarehandel,jernvareforretning                                      ',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'hardeware_winkel_(items,goedere)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29042,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + heart)',
    english: 'heart_(shape)',
    swedish: 'hjärta_(formen)',
    norwegian: 'hjerteform',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'hart_(vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29043,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + corner [contraction] + 7)',
    english: 'heptagon',
    swedish: 'sjuhörning,heptagon',
    norwegian: 'sjukant,heptagon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'sewehoek',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29044,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + corner [contraction] + 6)',
    english: 'hexagon',
    swedish: 'sexhörning,hexagon',
    norwegian: 'sekskant,heksagon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'seshoek',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29045,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pen + colour + interest)',
    english: 'highlighter,marker',
    swedish: 'överstrykningspenna,markeringpenna',
    norwegian: 'markeringspenn,markeringstusj',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'merker',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29046,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(being_(state_of) + 1) [being alone]',
    english: 'isolation',
    swedish: 'isolering,avskildhet',
    norwegian: 'isolasjon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'isolasie',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29047,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + jewelry)',
    english: 'jewelry_shop,jewellery_store,jewellers',
    swedish: 'guldsmed_(affär),juvelerare_(affär)',
    norwegian: 'gullsmedbutikk,smykkebutikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'juwelierswinkel,juweliers',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29048,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(application + work)',
    english: 'job_application,work_application',
    swedish: 'arbetsansökan,jobbansökan',
    norwegian: 'jobbsøknad,søknad_(arbeid)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'werk_aansoek',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29049,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(card + profession)',
    english: 'job_qualification',
    swedish: 'yrkeskvalifikation,yrkescertifikatlegitimation_(yrke),yrkeslegitimation',
    norwegian: 'fagbrev,yrkessertifikat,jobbkvalifikasjon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'werkskwalifikasie',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29050,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(place + description indicator)',
    english: 'local',
    swedish: 'närliggande,lokal_(närområde)',
    norwegian: 'lokal_(i_nærområdet)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'lokaal',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29051,
    group: 'word',
    pos: 'WHITE',
    derivationExplanation: '(limited_time + long + ago)',
    english: 'long_time_ago',
    swedish: 'för_längesedan,längesedan,längesen',
    norwegian: 'lenge_siden',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'lang_tyd_gelede, lank_gelede',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29052,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cloth + stretching)',
    english: 'lycra,spandex,stretchy_fabric',
    swedish: 'elasta,stretchtyg,elastiskt_tyg',
    norwegian: 'lycra,elastisk_stoff',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'lycra,spandex,rekbare_materiaal',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29053,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(most: noun form)',
    english: 'maximum',
    swedish: 'maximum',
    norwegian: 'maksimum',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'maksimum',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29054,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(opposite_meaning + maximum)',
    english: 'minimum',
    swedish: 'minimum',
    norwegian: 'minimum',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'minimum',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29055,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + record)',
    english: 'music_shop,music_store',
    swedish: 'musikaffär',
    norwegian: 'musikkbutikk,musikkforretning',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'musiekwinkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29056,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + nail)',
    english: 'nail_gun',
    swedish: 'spikpistol',
    norwegian: 'spikerpistol',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'spykergeweer',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29057,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(enclosed_space + information)',
    english: 'notice_board,bulletin_board',
    swedish: 'anslagstavla',
    norwegian: 'oppslagstavle',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'kennisgewingbord,bulletinbord',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29058,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + corner [contraction] + 8)',
    english: 'octagon',
    swedish: 'octagon,åttahörning,oktagon',
    norwegian: 'åttekant,oktagon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'agthoek',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29059,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(quadrilateral+ parallel + 2)',
    english: 'parallelogram',
    swedish: 'parallellogram',
    norwegian: 'parallellogram',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'parallelogram',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29060,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + cake)',
    english: 'pastry_shop,patisserie',
    swedish: 'konditori',
    norwegian: 'konditori',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'gebak_winkel,patisserie',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29061,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + corner [contraction] + 5)',
    english: 'pentagon',
    swedish: 'femhörning,pentagon',
    norwegian: 'femkant,pentagon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'vyfhoek',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29062,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + perfume)',
    english: 'perfumery',
    swedish: 'parfymeri',
    norwegian: 'parfymeri',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'parfumerie',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29063,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + animal)',
    english: 'pet_shop,pet_store',
    swedish: 'djuraffär,zooaffär',
    norwegian: 'dyrebutikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'troeteldier_winkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29064,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + gereralization+ corner [contraction])',
    english: 'polygon_(category)',
    swedish: 'månghörning,polygon',
    norwegian: 'mangekant,polygon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'veelhoek_(kategorie)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29065,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(paper + memory + attached)[a paper for your memory which can be attached somewhere]',
    english: 'post-it_note,reminder_note',
    swedish: 'post-itlapp,minneslapp',
    norwegian: 'post-it_lapp,huskelapp',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'post-it_nota,post-it_herhinnering_nota',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29066,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plan + activity + purpose)',
    english: 'project',
    swedish: 'projekt',
    norwegian: 'prosjekt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'projek',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29067,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + pyramid)',
    english: 'pyramid_(shape)',
    swedish: 'pyramid_(formen)',
    norwegian: 'pyramideform',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'piramide_(vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29068,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + corner [contraction] + 4)',
    english: 'quadrilateral',
    swedish: 'fyrhörning,fyrkant,kvadrat',
    norwegian: 'firkant,kvadrat',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'vierhoek',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29069,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(isolation + medicine)',
    english: 'quarantine',
    swedish: 'karantän',
    norwegian: 'karantene',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'kwarantyn',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29070,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + record)',
    english: 'record_shop,record_store,music_shop_music_store',
    swedish: 'skivaffär,musikaffär',
    norwegian: 'platebutikk,plateforretning',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'plate_winkel,musiek_winkel,',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29071,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(full + information)',
    english: 'report',
    swedish: 'rapport',
    norwegian: 'rapport',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'verslag',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29072,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(use + again + description indicator before fact)',
    english: 're-usable,recycable',
    swedish: 'återanvändbar,återbrukbar',
    norwegian: 'gjenbrukbar,resirkulerbar',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'herbruikbaar,herwinbaar',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29073,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(use + again + description indicator after fact)',
    english: 're-used,recycled',
    swedish: 'återanvänd,återbrukad',
    norwegian: 'gjenbrukt,resirkulert',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'hergebruik,herwin',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29074,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ring + stretching)',
    english: 'rubber_band',
    swedish: 'gummiband',
    norwegian: 'gummistrikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'rekkie',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29075,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(linear_thing + glue)',
    english: 'scotch_tape,adhesive_tape',
    swedish: 'tejp,klisterremsa',
    norwegian: 'teip,limbånd',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'kleeflint,kleefband',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29076,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(second_hand + description indicator)',
    english: 'second_hand',
    swedish: 'second_hand,begagnad',
    norwegian: 'second_hand,brukt,gjenbrukt,resirkulert',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'tweede handse (items, goedere)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29077,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(goods + again) [things which can be used or sold again]',
    english: 'second_hand_(goods)',
    swedish: 'second_hand_(varor),begagnade_varor,loppisföremål',
    norwegian: 'second_hand_(varer),gjenbruk_(varer),resirkulert_(varer)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'tweedehandse_winkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29078,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + clothes + second hand [contraction])',
    english: 'second_hand_clothes_shop,second_hand_clothing_shop',
    swedish: 'second_hand_affär_(kläder)',
    norwegian: 'bruktbutikk_(klær),second_hand_(klær)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'tweedehandse_klere_winkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29079,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + second hand)',
    english: 'second_hand_shop,charity_shop,vintage_shop',
    swedish: 'secondhandaffär,loppis',
    norwegian: 'bruktbutikk,second_hand-butikk,gjenbruksbutikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'tweedehandse_winkel,liefdadigheidswinkel,antiekwinkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29080,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + half_circle)',
    english: 'semicircle,half_circle_(shape)',
    swedish: 'halvcirkel',
    norwegian: 'halvsirkel',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'halfsirkel,half_sirkel_(vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29081,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(eye + thing) - Character (superimposed)',
    english: 'shape_(in_combinations)',
    swedish: 'form_(i_kombinationer)',
    norwegian: 'form_(i_kombinasjon)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'vorm_(in_kombinasie)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29082,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + shoe)',
    english: 'shoe_shop,shoe_store',
    swedish: 'skoaffär',
    norwegian: 'skobutikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'skoenwinkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29083,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + destroy + paper)',
    english: 'shredder_(paper),paper_shredder',
    swedish: 'dokumentförstörare',
    norwegian: 'makuleringsmaskin',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'versnipperaar_(papier),papier_versnipperaar',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29084,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(at_a_distance + person)',
    english: 'social_distance',
    swedish: 'social_distans,avstånd,distans_(socialt)',
    norwegian: 'sosial_distanse,sosial_avstand',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'sosiale_afstand, sosiale_distansiëring',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29085,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(at_a_distance + person + action indicator)',
    english: 'social_distance-(to)',
    swedish: 'hålla_avstånd_(socialt)',
    norwegian: 'holde_sosial_avstand-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'om_sosiale_afstand_te_hanteer',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29086,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(folder + spiral)',
    english: 'spiral_binder',
    swedish: 'spiralpärm,spiralblock,mapp_(med_spiral)',
    norwegian: 'spiralperm',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'spiraal_binder, spiraal_bindmiddel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29087,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + pin + material)',
    english: 'staple_gun',
    swedish: 'häftpistol',
    norwegian: 'stiftepistol',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'stapelgeweer',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29088,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + remove + pin)',
    english: 'staple_remover',
    swedish: 'stiftborttagare,borttagare _av_klammer',
    norwegian: 'stiftefjerner',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'krammetjie_verwyderaar',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29089,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + pin + paper)',
    english: 'stapler',
    swedish: 'häftapparat',
    norwegian: 'stiftemaskin',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'krammasjien',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29090,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + star)',
    english: 'star_(shape)',
    swedish: 'stjärnform',
    norwegian: 'stjerneform',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'ster_vorm',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29091,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(shop + generalization + pen) [pen represents all writing material in the stationery shop]',
    english: 'stationery_shop,stationery_store',
    swedish: 'pappershandel',
    norwegian: 'papirhandel,bokhandel',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'skryfbehoeftewinkel',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29092,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(card + little + information)',
    english: 'tag,sticker,label',
    swedish: 'etikett,sticker,namnlapp',
    norwegian: 'merkelapp',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'merk, etiket, plakker',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29093,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(3 + decimal point + description indicator) [the dot indicates an ordinal numeral]',
    english: 'third_(ordinal)',
    swedish: 'tredje',
    norwegian: 'tredje',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'derde_ordinaal',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29094,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(afternoon + now)',
    english: 'this_afternoon',
    swedish: 'i_eftermiddag',
    norwegian: 'i_ettermiddag',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'vanmiddag',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29095,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(evening + now)',
    english: 'this_evening',
    swedish: 'ikväll,i_kväll',
    norwegian: 'i_kveld',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'vanaand',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29096,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(morning_(early) + now)',
    english: 'this_morning',
    swedish: 'imorse,i_morse',
    norwegian: 'i_morges',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'vanoggend',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29097,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(little,small + intensity)',
    english: 'tiny,mini,minscule,teeny-tiny',
    swedish: 'pytteliten,mini',
    norwegian: 'bitte_liten,minimal',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'klein, minusieus,minuskuul,minuskule,piepklein',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29098,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + corner [contraction] + 4 + parallel + 1)',
    english: 'trapezoid,trapezium',
    swedish: 'parallelltrapets,trapets_(geometrisk_form)',
    norwegian: 'trapes,trapesform',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'trapesoïed, trapesium',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29099,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shape + tube)',
    english: 'tube_(shape)',
    swedish: 'rörform',
    norwegian: 'rørform,tubeform',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'silindervormige_(vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29100,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + car + second hand [contraction])',
    english: 'used_car_dealer',
    swedish: 'affär_för_begagnade_bilar',
    norwegian: 'bruktbilforretning,bruktbilforhandler',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'tweedehandse_motor_handelaar',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29101,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(vaccination + action indicator)',
    english: 'vaccinate',
    swedish: 'vaccinera',
    norwegian: 'vaksinere-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'inent',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29102,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(vaccination + description indicator after fact)',
    english: 'vaccinated',
    swedish: 'vaccinerad',
    norwegian: 'vaksinert',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'ingeënt',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29103,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(injection + liquid + protection)',
    english: 'vaccination',
    swedish: 'vaccination',
    norwegian: 'vaksinasjon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'inenting',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29104,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(liquid + medicine + protection)',
    english: 'vaccine',
    swedish: 'vaccin',
    norwegian: 'vaksine',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'entstof',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29105,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(talk + high pitch)',
    english: 'whine-(to)',
    swedish: 'gnälla  ',
    norwegian: 'klynke',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'kerm, tjank, sanik',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29106,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(enclosed_space + pen + white)',
    english: 'whiteboard',
    swedish: 'whiteboard',
    norwegian: 'whiteboard',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'witbord',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29107,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + destroy + wood)',
    english: 'wood_shredder,garden_shredder',
    swedish: 'flistugg,flishugg',
    norwegian: 'kvistkvern,kvistkutter,kompostkvern',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'houtversnipperaar',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29108,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(interview + work)',
    english: 'work_interview',
    swedish: 'anställningsintervju',
    norwegian: 'ansettelsesintervju,jobbintervju',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'werksonderhoud',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29109,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(paper + time + work)',
    english: 'work_schedule',
    swedish: 'arbetsschema',
    norwegian: 'arbeidsplan,arbeidsskjema,fremdriftsplan',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'werk skedule',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29110,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(report + pen)',
    english: 'written_report',
    swedish: 'rapport,skriftlig_rapport',
    norwegian: 'rapport_skriftlig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'geskrewe verslag',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29111,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + yarn [contraction])',
    english: 'yarn_shop,yarn_store,wool_shop,wool_store',
    swedish: 'garnaffär',
    norwegian: 'garnbutikk,strikkebutikk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: 'wolmark',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29201,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(smell + positive + description indicator)',
    english: 'aromatic',
    swedish: 'aromatisk,väldoftande',
    norwegian: 'velduftende,aromatisk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29202,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to stink + description indicator)',
    english: 'smelly_(bad)',
    swedish: 'illaluktande,stinkande',
    norwegian: 'stinkende',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29203,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to boil (liquid) + description indicator)',
    english: 'boiling',
    swedish: 'kokande',
    norwegian: 'kokende',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29204,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(substance + coffee)',
    english: 'caffeine',
    swedish: 'koffein',
    norwegian: 'koffein',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29205,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + caffein + description indicator)',
    english: 'decaffeinated',
    swedish: 'koffeinfri',
    norwegian: 'koffeinfri',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29206,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + grain)',
    english: 'gluten',
    swedish: 'gluten',
    norwegian: 'gluten',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29207,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(part of + milk)',
    english: 'lactose',
    swedish: 'laktos',
    norwegian: 'laktose',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29208,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + lactose + description indicator)',
    english: 'lactose_free',
    swedish: 'laktosfri',
    norwegian: 'laktosefri',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29209,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + milk + description indicator)',
    english: 'milk_free,dairy_free',
    swedish: 'mjölkfri',
    norwegian: 'melkefri',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29210,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(man-maid_item, product + milk)',
    english: 'milk_product,dairy_product',
    swedish: 'mjölkprodukt',
    norwegian: 'melkeprodukt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29211,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + law (in combination) + Jewish: food prepared according to Jewish law)',
    english: 'kosher_food',
    swedish: 'koshermat',
    norwegian: 'kosher_mat',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29212,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(food + law (in combination) + Islamic: food prepared according to Islamic law, shariah)',
    english: 'halal_food',
    swedish: 'halalmat',
    norwegian: 'halal_mat',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29213,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(development + complete [contr.] + descriptive indicator)',
    english: 'ripe,fully_developed',
    swedish: 'mogen',
    norwegian: 'moden',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29214,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(development + complete [contr.] + action indicator)',
    english: 'ripen,fully_develop-(to)',
    swedish: 'mogna',
    norwegian: 'modne-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29215,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(ripe,fully_developed + description indicator, before fact)',
    english: 'ripening',
    swedish: 'omogen',
    norwegian: 'modning',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29216,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to sort + waste, garbage)',
    english: 'recycling_station_worker,garbage_station_worker',
    swedish: 'källsorterare,renhållningasarbetare',
    norwegian: 'gjenvinningsoperatør,renovasjonsarbeider',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29217,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + work + garbage)',
    english: 'garbage_man,bin_collector',
    swedish: 'renållningsman,sopgubbe',
    norwegian: 'søppeltømmer,renholdsarbeider,renovasjonsarbeider',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29218,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to learn + work + action indicator: to work as an apprentice, intern or trainee)',
    english: 'apprentice,intern-(to),serve_as_an_apprentice,intern,trainee-(to)',
    swedish: 'prakticera',
    norwegian: 'praktisere,få_opplæring-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29219,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to learn + work: the position of apprentice)',
    english: 'apprenticeship,internship,professional_training,traineeship',
    swedish: 'praktik',
    norwegian: 'læretid,praksis,praksisopphold',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29220,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to learn + activity)',
    english: 'training,practice',
    swedish: 'övning',
    norwegian: 'opplæring,øving,praksis',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29221,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(to learn + activity + action indicator)',
    english: 'train,practice-(to)',
    swedish: 'öva',
    norwegian: 'trene,øve-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29222,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + work + part of + time)',
    english: 'part-time_employee',
    swedish: 'deltidsanställd,deltidsarbetare',
    norwegian: 'deltidsansatt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29223,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(employee + limited time, period)',
    english: 'temporary_employee',
    swedish: 'timanställd_(person)',
    norwegian: 'midlertidig_ansatt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29224,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(helper + limited time)',
    english: 'relief,substitute,respite_carer',
    swedish: 'stödperson',
    norwegian: 'avlaster,støttekontakt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29225,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(teacher (in combination) + kindergarten, preschool)',
    english: 'kindergarten_teacher,preschool_teacher',
    swedish: 'förskollärare,',
    norwegian: 'barnehagelærer,førskolelærer',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29226,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: 'Add coach, Changes made',
    english: 'leader,director,guide,coach',
    swedish: 'ledare,chef',
    norwegian: 'leder,sjef',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29227,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(leader, coach + sport)',
    english: 'coach_(sport)',
    swedish: 'coach,tränare_(sport)',
    norwegian: 'trener_(sport)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29228,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(teacher, instructor (in combination) + to swim)',
    english: 'swimming_instructor,swimming_teacher',
    swedish: 'simlärare',
    norwegian: 'svømmelærer,svømmetrener,svømmeinstruktør',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29229,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(client, customer + bank [contr.])',
    english: 'bank_customer',
    swedish: 'bankkund',
    norwegian: 'bankkunde',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29230,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + bank)',
    english: 'banker,bank_clerk,bank_teller,bank_employee',
    swedish: 'banktjänsteman',
    norwegian: 'bankfunksjonær,bankansatt,bankmedarbeider',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29231,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + office)',
    english: 'office_worker',
    swedish: 'kontorsarbetare',
    norwegian: 'kontormedarbeider,merkantilt_personale',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29232,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + work + structure)',
    english: 'construction_worker,builder',
    swedish: 'konstruktör,byggnadsarbetare',
    norwegian: 'bygningsarbeider',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29233,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(protector [contr.] + other + intensity ',
    english: 'body_guard,security_guard',
    swedish: 'livvakt',
    norwegian: 'livvakt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29234,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(goods + to bring) – Character (superimposed)',
    english: 'delivery_(goods)',
    swedish: 'leverans',
    norwegian: 'vareutlevering',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29235,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(delivery + action indicator',
    english: 'deliver_(goods)-(to)',
    swedish: 'leverera',
    norwegian: 'utlevere_varer-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29236,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + delivery)',
    english: 'delivery_man,deliverer,delivery_person,delivery_agent',
    swedish: 'varubud,bud_(person)',
    norwegian: 'varebud,bud',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29237,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + work + clean)',
    english: 'cleaner,house_maid,maid',
    swedish: 'lokalvårdare, städare,städerska',
    norwegian: 'renholder,vaskehjelp',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29238,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + work + electricity)',
    english: 'electrician',
    swedish: 'elektriker',
    norwegian: 'elektriker',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29239,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + most + knowledge)',
    english: 'expert,specialist',
    swedish: 'specialist,expert',
    norwegian: 'ekspert,spesialist',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29240,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(specialist + digital)',
    english: 'computer_specialist,data_expert',
    swedish: 'dataspecialist,dataexpert',
    norwegian: 'dataekspert,dataspesialist,IT-spesialist',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29241,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(knowledge + description indicator before fact: capable of being known)',
    english: 'knowable',
    swedish: 'begriplig,förståelig',
    norwegian: 'forståelig,fattbart',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29242,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(knowledge + description indicator after fact)',
    english: 'known',
    swedish: 'känd,känt',
    norwegian: 'kjent,stadfestet',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29243,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to translate, interpret)',
    english: 'interpreter,translator',
    swedish: 'översättare,tolk',
    norwegian: 'tolk,oversetter',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29244,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + work + pipe, hose, tube (2))',
    english: 'plumber',
    swedish: 'rörmokare,rörläggare',
    norwegian: 'rørlegger',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29245,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(metal [contr.] + fluid + action indicator: heat changing solid metal to fluid) – Character (superimposed)',
    english: 'melt_(metal)-(to)',
    swedish: 'smälta_(metall)',
    norwegian: 'smelte_(metall)-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29246,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(to join + to melt (metal) + action indicator: to join together by melting metal)',
    english: 'weld-(to)',
    swedish: 'svetsa,löda',
    norwegian: 'sveise-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29247,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + to weld)',
    english: 'welder',
    swedish: 'svetsare',
    norwegian: 'sveiser',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29248,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(much + activity + exclamation mark + description indicator)',
    english: 'busy',
    swedish: 'upptagen',
    norwegian: 'opptatt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29249,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(put-(to) + place + action indicator: to put in place)',
    english: 'tidy-(to)',
    swedish: 'lägga_i_ordning',
    norwegian: 'rydde-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29250,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to put+ thing + place + action indicator: to put things in place)',
    english: 'tidy_up-(to)',
    swedish: 'lägga_sak_på_plats',
    norwegian: 'rydde,sette_på_plass-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29251,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(to tidy_up + description indicator)',
    english: 'tidy,put_in_place',
    swedish: 'i _ordning,iordning',
    norwegian: 'ryddig_(på_plass)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29252,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(not [contr.] + tidy + description indicator: things are not in their right places)',
    english: 'untidy',
    swedish: 'stökigt,i_oordning',
    norwegian: 'rotete,uryddig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29253,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + plan + description indicator)',
    english: 'unplanned',
    swedish: 'oplanerad',
    norwegian: 'ikke_planlagt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29254,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + to cut + paper)',
    english: 'paper_cutter,guillotine_(paper)',
    swedish: 'pappersskärare',
    norwegian: 'papirkutter,skjæremaskin',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29255,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(board + paper + to attach)',
    english: 'clipboard',
    swedish: 'skrivplatta,clipboard',
    norwegian: 'utklippstavle',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29256,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + repetition + voice)',
    english: 'voicemail,voice_message',
    swedish: 'röstbrevlåda,röstmeddelande',
    norwegian: 'talepost,talemelding',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29257,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to sell)',
    english: 'vending_machine',
    swedish: 'varuautomat',
    norwegian: 'salgsautomat',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29258,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to blow + leaf)',
    english: 'leaf_blower',
    swedish: 'lövblås',
    norwegian: 'løvblåser',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29259,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + to blow + snow)',
    english: 'snow_blower',
    swedish: 'snöslunga',
    norwegian: 'snøfreser',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29260,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: 'snow_remover added to (23951)',
    english: 'snowplow,snowplough,snow_remover',
    swedish: 'snöplog',
    norwegian: 'snøplog',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29261,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(snow + limited time: a lot of snow falls in a short time)',
    english: 'snowfall',
    swedish: 'snöby',
    norwegian: 'snøfall',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29262,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(collection + snow)',
    english: 'snow_pile,pile_of_snow',
    swedish: 'snödriva',
    norwegian: 'snøfonn',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29263,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rain + snow)',
    english: 'sleet',
    swedish: 'snöblandat_regn',
    norwegian: 'sludd',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29264,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ice + linear thing)',
    english: 'icicle',
    swedish: 'istapp',
    norwegian: 'istapp',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29265,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(hail + action indicator)',
    english: 'hail-(to)',
    swedish: 'hagla',
    norwegian: 'hagle-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29266,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rain + ice: rain which turns into ice when it hits the cold ground)',
    english: 'freezing_rain',
    swedish: 'underkylt_regn',
    norwegian: 'underkjølt_regn',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29267,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(rain + dust: rain with drops as fine as dust)',
    english: 'drizzle',
    swedish: 'duggregn',
    norwegian: 'yr',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29268,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ice + crystal: ice as crystals)',
    english: 'hoar_frost',
    swedish: 'rimfrost',
    norwegian: 'frost',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29269,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(disaster + environment)',
    english: 'natural_disaster',
    swedish: 'naturkatastrof',
    norwegian: 'naturkatastrofe',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29270,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(earth + to slide + danger: a slide of a large mass of dirt and rock)',
    english: 'landslide',
    swedish: 'jordskred',
    norwegian: 'jordskred',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29271,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hole + down + danger)',
    english: 'sinkhole',
    swedish: 'slukhål',
    norwegian: 'synkehull',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29272,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(middle + earthquake: the centre of an earthquake)',
    english: 'earthquake_epicentre',
    swedish: 'jordbävningsepicentrum,epicentrum_i_jordbävning',
    norwegian: 'jordskjelv,episenter',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29273,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(much + storm)',
    english: 'hurricane,cyclone,typhoon',
    swedish: 'orkan,tyfon,cyklon',
    norwegian: 'orkan,syklon,tyfon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29274,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(star + moon + description indicator) – Character (sequenced)',
    english: 'Muslim,Moslem,Islamic',
    swedish: 'muslimsk,islamsk',
    norwegian: 'muslimsk,islamsk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29275,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(religion_(God_based) + Muslim: religion based on the teaching of the prophet Muhammed)',
    english: 'Islam',
    swedish: 'Islam',
    norwegian: 'Islam',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29276,
    group: 'word',
    pos: 'BLUE',
    derivationExplanation: '(person + Muslim,Moslem,Islamic) ',
    english: 'Muslim,Moslem',
    swedish: 'muslim',
    norwegian: 'muslim',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29301,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(breakfast [contraction] + hotel [contraction]) ',
    english: 'hotel_breakfast',
    swedish: 'hotellfrukost',
    norwegian: 'hotellfrokost',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29302,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ticket + aeroplane)',
    english: 'plane_ticket,airline_ticket',
    swedish: 'flygbiljett',
    norwegian: 'flybillett',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29303,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(trip,journey,travel,voyage + aeroplane)',
    english: 'flight,air_travel',
    swedish: 'flygresa',
    norwegian: 'flyreise',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29304,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(trip,journey,travel,voyage + train)',
    english: 'train_journey',
    swedish: 'tågresa',
    norwegian: 'togreise',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29305,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(trip,journey,travel,voyage + car)',
    english: 'car_journey',
    swedish: 'bilresa',
    norwegian: 'bilreise',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29306,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(trip,journey,travel,voyage + boat)',
    english: 'boat_journey,journey_by_boat,sea_voyage',
    swedish: 'båtresa',
    norwegian: 'båtreise',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29307,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + out + car: a tour by car without a certain goal)',
    english: 'car_outing,car_drive',
    swedish: 'biltur',
    norwegian: 'biltur,kjøretur',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29308,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + out + boat: a tour by boat without a certain goal)',
    english: 'boat_trip,outing_by_boat',
    swedish: 'båttur',
    norwegian: 'båttur',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29309,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(activity + out + boat + fish: a fishing tour by boat, just for pleasure)',
    english: 'fishing_trip_(by_boat)',
    swedish: 'fisketur',
    norwegian: 'fisketur',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29310,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(getting + fish: catching fish)',
    english: 'fishing,angling',
    swedish: 'fiske',
    norwegian: 'fisking',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29311,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sport + to fish)',
    english: 'sport_fishing,fishing,angling_(sport)',
    swedish: 'sportfiske',
    norwegian: 'sportsfiske',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29312,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(hike-(to) [contraction] + mountain: hiking in the mountain)',
    english: 'mountain_hiking,hill_walking',
    swedish: 'fjällvandring',
    norwegian: 'fjelltur',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29313,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(conveyor,conveyor_belt) Character, (pictograph)',
    english: 'conveyor,conveyor_belt',
    swedish: 'transportband',
    norwegian: 'transportbånd',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29314,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(conveyor_belt + baggage, luggage, suitcase)',
    english: 'baggage_handling_belt',
    swedish: 'bagageband',
    norwegian: 'bagasjebånd',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29315,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(conveyor_belt + health + walking [contraction]: a conveyor belt for healthy walking exercise)',
    english: 'treadmill',
    swedish: 'gåband',
    norwegian: 'tredemølle',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29316,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(conveyor_belt + health + bike)',
    english: 'exercise_bike',
    swedish: 'motionscykel',
    norwegian: 'treningssykkel',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29317,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(conveyor_belt + walking [contraction])',
    english: 'travelator,moving_pavement,moving_walkway',
    swedish: 'rörlig_gångväg',
    norwegian: 'rullende_fortau',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29318,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(conveyor_belt + walking [contraction]+ ascending_and_descending)',
    english: 'travelator_(up_and_down_a_slope)',
    swedish: 'rörlig_gångväg_upp_eller_ner',
    norwegian: 'rullende_fortau_(i_helling)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29319,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(camera + action indicator)',
    english: 'photograph-(to)',
    swedish: 'fotografera,ta_kort',
    norwegian: 'fotografere-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29320,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + photograph,photo,picture)',
    english: 'photo_album',
    swedish: 'fotoalbum',
    norwegian: 'fotoalbum',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29321,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + summer)',
    english: 'summer_job',
    swedish: 'sommarjobb',
    norwegian: 'sommerjobb',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29322,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(work + season)',
    english: 'seasonal_work',
    swedish: 'säsongsarbete',
    norwegian: 'sesongarbeid',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29323,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(sew-(to)  + art + action indicator)',
    english: 'embroider-(to)',
    swedish: 'brodera',
    norwegian: 'brodere-(å)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29324,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(art + needle: a form of artistic sewing)',
    english: 'embroidery',
    swedish: 'broderi',
    norwegian: 'broderi',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29325,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(activity + needle)',
    english: 'sewing',
    swedish: 'sömnad',
    norwegian: 'sying,søm',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29326,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(picture) character, superimposed Synonym for',
    english: 'picture_(SYN)',
    swedish: 'bild',
    norwegian: 'bilde_(SYN)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29327,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(book + picture + scissor)',
    english: 'scrapbook',
    swedish: 'scrapbook,urklippsalbum,klippbok',
    norwegian: 'scrapbook,utklippsbok',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29328,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(collection + stamp)',
    english: 'stamp_collection',
    swedish: 'frimärkssamling',
    norwegian: 'frimerkesamling',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29329,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(collection + coin)',
    english: 'coin_collection',
    swedish: 'myntsamling',
    norwegian: 'myntsamling',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29330,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(grid, matrix + word)',
    english: 'crossword',
    swedish: 'korsord',
    norwegian: 'kryssord',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29331,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(grid, matrix + number)',
    english: 'sudoku',
    swedish: 'sudoku',
    norwegian: 'sudoku',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29332,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(question + mind)',
    english: 'quiz,puzzle',
    swedish: 'frågesport',
    norwegian: 'quiz',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29333,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(quiz + ABC)',
    english: 'letter_game,letter_puzzle',
    swedish: 'bokstavslek,bokstavsspel,alfapet',
    norwegian: 'bokstavspill,bokstavlek',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29334,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(play, game (in  combinations) + word)',
    english: 'wordplay,pun,punning',
    swedish: 'ordlek',
    norwegian: 'ordspill,ordlek',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29335,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(quiz + picture)',
    english: 'picture_puzzle,rebus',
    swedish: 'rebus',
    norwegian: 'rebus',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29336,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(feeling + health)',
    english: 'wellbeing',
    swedish: 'välbefinnande',
    norwegian: 'velvære',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29337,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(knowledge + craft)',
    english: 'handcraft_(class),craft_(class)',
    swedish: 'slöjdlektion',
    norwegian: 'kunst_og_håndverk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29338,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(sadness + anticipation, expectation + loss: the feelings of sadness anticipating an inevitable loss)',
    english: 'anticipatory_grief',
    swedish: 'väntesorg',
    norwegian: 'ventesorg',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29339,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(strap + luggage)',
    english: 'luggage_strap',
    swedish: 'bagagerem',
    norwegian: 'bagasjerem',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29340,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(place + wellbeing + water:A resort area offering wellbeing and healthy bath)',
    english: 'spa',
    swedish: 'spa',
    norwegian: 'spa',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29341,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(golf_(sport) + little)',
    english: 'minigolf_(sport)',
    swedish: 'bangolf_( sport)',
    norwegian: 'minigolf_(sport)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29342,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(golf_(activity) + little)',
    english: 'minigolf_(activity)',
    swedish: 'minigolf',
    norwegian: 'minigolf_(aktivitet)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29401,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(tool + through + paper: a tool, which makes holes in paper)',
    english: 'hole_punch',
    swedish: 'låte_(gi_fra_seg_et-dyre-læte)',
    norwegian: 'hullemaskin',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29402,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical_product + OH)',
    english: 'ethanol,sanitizer,alcohol_(chemical)',
    swedish: 'alkohol_(kemisk),etanol, desinfektionsmedel',
    norwegian: 'etanol,rensemiddel',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29403,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ethanol,sanititzer,alcohol_(chemical) + hand)',
    english: 'hand_sanitizer',
    swedish: 'handsprit',
    norwegian: 'hånddesinfeksjonsmiddel',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29404,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(digital_world + buy)',
    english: 'online_shop,online_store,webstore,webshop',
    swedish: 'näthandel',
    norwegian: 'netthandel',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29405,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(opposite of most) Character (sequenced)',
    english: 'minimum_(2)',
    swedish: 'minimum',
    norwegian: 'minimum',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29406,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(opposite of most + description indicator)',
    english: 'fewest,least,minimum_(2)',
    swedish: 'minst,färst',
    norwegian: 'færrest,minst_(antall),minimum',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29407,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(opposite of more + description indicator) Character (sequenced)',
    english: 'fewer,less_(2)',
    swedish: 'färre,mindre',
    norwegian: 'færre,mindre_(antall)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29408,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(say + snake + action indicator)',
    english: 'hiss_(snake)-(to)',
    swedish: 'väsa',
    norwegian: 'hvese',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29409,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(sound + animal)',
    english: 'sound_of_animal,animal_sound',
    swedish: 'djurläte',
    norwegian: 'dyrelyd',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29410,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(say + hen [contraction] + feeling: the sound of a hen at ease)',
    english: 'cluck-(to)',
    swedish: 'klucka',
    norwegian: 'klukke',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29412,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pitch + up: elevated pitch)',
    english: 'high_pitch',
    swedish: 'hög_tonhöjd',
    norwegian: 'høy_tone',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29413,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(say + animal + opposition + action indicator: an animal expression against something or someone)',
    english: 'growl,snarl-(to)',
    swedish: 'morra',
    norwegian: 'knurre',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29414,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(shout + animal + action indicator )',
    english: 'roar-(to)',
    swedish: 'vråla',
    norwegian: 'brøle',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29415,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '',
    english: 'yap-(to)',
    swedish: 'gläfsa',
    norwegian: 'låte_(gi_fra_seg_et-dyre-læte)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29417,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(say + animal + low_pitch + action indicator)',
    english: 'growl,grumble-(to)',
    swedish: 'ryta',
    norwegian: 'klynke,jamre_(lavt)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29418,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pitch + down: lowered pitch)',
    english: 'low_pitch',
    swedish: 'låg_tonhöjd',
    norwegian: 'lav_tone',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29419,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(say + wolf + action indicator)',
    english: 'howl_(wolf)-(to)',
    swedish: 'yla',
    norwegian: 'ule',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29420,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(sing + bird + action indicator)',
    english: 'sing_(bird)-(to)',
    swedish: 'sjunga_(fågel)',
    norwegian: 'synge_(fugle)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29421,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(say + rooster + action indicator)',
    english: 'crow-(to)',
    swedish: 'gala',
    norwegian: 'gale',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29422,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(say + chicken + action indicator)',
    english: 'cluck,cackle-(to)',
    swedish: 'kackla',
    norwegian: 'kakle',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29423,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(say + flying­ insect + action indicator)',
    english: 'buzz,hum,drone-(to)',
    swedish: 'surra,brumma',
    norwegian: 'surre,brumme',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29425,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(say + bull + action indicator)',
    english: 'bellow-(to)',
    swedish: 'bröla',
    norwegian: 'raute',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29426,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(say + mouse + action indicator)',
    english: 'squeak-(to)',
    swedish: 'pipa_(djur)',
    norwegian: 'pipe',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29501,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(address + action indicator)',
    english: 'address-(to)',
    swedish: 'adressera',
    norwegian: 'adressere',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29502,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(adversity,hardship + description indicator)',
    english: 'adverse',
    swedish: 'ogynnsam',
    norwegian: 'ugunstig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29503,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(air + description indicator)',
    english: 'airy',
    swedish: 'luftig',
    norwegian: 'luftig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29504,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bloom + action indicator)',
    english: 'bloom,flower,blossom-(to)',
    swedish: 'blomma_(att)',
    norwegian: 'blomstre',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29505,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cause + boredom: to bore someone)',
    english: 'bore-(to)',
    swedish: 'uttråka',
    norwegian: 'kjede_(noen),være_kjedelig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29506,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(boredom + description indicator after fact: a feeling of being uninterested in anything at all)',
    english: 'bored,lacking_interest',
    swedish: 'uttråkad',
    norwegian: 'kjede_seg',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29508,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(feeling + without interest)',
    english: 'boredom,monotony',
    swedish: 'uttråkning',
    norwegian: 'kjedsomhet',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29509,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(boredom + description indicator)',
    english: 'boring',
    swedish: 'tråkig',
    norwegian: 'kjedelig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29511,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(boredom with action indicator)',
    english: 'feel_bored,be_bored-(to)',
    swedish: 'vara_uttråkad',
    norwegian: 'være_lei',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29512,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(surface + up and down + description indicator: a surface with many bumps)',
    english: 'bumpy_(surface)',
    swedish: 'ojämn',
    norwegian: 'humpete',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29513,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(card + digital)',
    english: 'card,key,pass_(digital)',
    swedish: 'passerkort',
    norwegian: 'nøkkelkort',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29514,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(minus,without + careful + description indicator)',
    english: 'careless',
    swedish: 'vårdslös,oförsiktig',
    norwegian: 'uforsiktig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29515,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + plan + total)',
    english: 'chaos',
    swedish: 'kaos',
    norwegian: 'kaos',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29516,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(chaos + description indicator)',
    english: 'chaotic',
    swedish: 'kaotisk',
    norwegian: 'kaotisk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29518,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(confusion + description after the fact indicator)',
    english: 'confused_(feeling)',
    swedish: 'förvirrad_(känsla)',
    norwegian: 'forvirred_(følelse)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29519,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(confusion + description indicator, after fact)',
    english: 'confused_(mentally)',
    swedish: 'förvirrad_(mentalt)',
    norwegian: 'forvirret_(mentalt)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29520,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(confusion + description indicator)',
    english: 'confusing_(feeling)',
    swedish: 'förvirrande_(känsla)',
    norwegian: 'forvirrende_(følelses-     messig)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29521,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(confusion + description indicator)',
    english: 'confusing_(mentally)',
    swedish: 'förvirrande_(mentalt)',
    norwegian: 'forvirrende_(mentalt)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29522,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(depression + after fact)',
    english: 'depressed',
    swedish: 'deprimerad',
    norwegian: 'deprimert',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29523,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(depression+ before fact)',
    english: 'depressing',
    swedish: '',
    norwegian: 'deprimerende',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29527,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(minus,without + honest + description indicator)',
    english: 'dishonest',
    swedish: 'oärlig,ohederlig',
    norwegian: 'uærlig,uhederlig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29528,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(die + plant + action indicator: a plant fading or withering towards dying)',
    english: 'fade,die,wither_(plant)-(to)',
    swedish: 'vissna',
    norwegian: 'visne',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29529,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(to fade, wither + description indicator, after fact)',
    english: 'faded,withered_(plant)',
    swedish: 'vissen_(växt)',
    norwegian: 'visnet',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29530,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(cause + down + toilet + action indicator: flush down the content in a toilet)',
    english: 'flush-(to)',
    swedish: 'spola,spola_ned',
    norwegian: 'trekke_ned',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29531,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(angry + exclamation-mark)',
    english: 'furious',
    swedish: 'rasande',
    norwegian: 'rasende',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29532,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(activity + throat + liquid + action indicator)',
    english: 'gargle-(to)',
    swedish: 'gurgla,gurgla_sig',
    norwegian: 'gurgle',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29533,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(glue,adhesive, paste + description indicator after fact)',
    english: 'glued,stuck',
    swedish: 'klistrad,fastlimmad,fastklistrad',
    norwegian: 'limt,fast',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29534,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(chemical product + hair)',
    english: 'hair_product,conditioner,foam,balm,mousse_(hair)',
    swedish: 'hårbalsam,hårprodukt,balsam_(hår)',
    norwegian: 'balsam',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29535,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(harvest + action indicator)',
    english: 'harvest-(to)',
    swedish: 'skörda',
    norwegian: 'skjørde',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29536,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(irritation + description before the fact indicator: can be irritating)',
    english: 'irritable',
    swedish: 'irritabel,retlig',
    norwegian: 'irritabel',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29537,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(cause + irritation + action indicator)',
    english: 'irritate,annoy-(to)',
    swedish: 'irritera,besvära,oroa',
    norwegian: 'irritere,ergre',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29538,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(irritation + description after the fact indicator: feeling of being irritated by something or someone)',
    english: 'irritated',
    swedish: 'irriterad',
    norwegian: 'irritert',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29539,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(irritation + description indicator: ongoing irritation)',
    english: 'irritating',
    swedish: 'irriterande',
    norwegian: 'irriterende',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29540,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(angry without many)',
    english: 'irritation,annoyance',
    swedish: 'irritation',
    norwegian: 'irritasjon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29542,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + plan + many + thing)',
    english: 'mess',
    swedish: 'oordning,röra_(saker)',
    norwegian: 'rot,uorden',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29543,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(mess + description indicator)',
    english: 'messy',
    swedish: 'stökigt,rörigt_(saker)',
    norwegian: 'rotete,uryddig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29544,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(chemical product + for + moist: chemical product for the purpose of moisterizing)',
    english: 'moisturizer',
    swedish: 'fuktighetskräm,lotion',
    norwegian: 'fuktighetskrem',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29545,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(cut + grass)',
    english: 'mow-(to)',
    swedish: 'slå,klippa_gräs',
    norwegian: 'slå,klippe',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29546,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(not,negative + description indicator)',
    english: 'negative',
    swedish: 'negativ',
    norwegian: 'negativ',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29547,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chemical_product + protection + skin [contraction])',
    english: 'ointment',
    swedish: 'hudprodukt,hudkräm,salva',
    norwegian: 'salve',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29548,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(plan, system + total, everything: everything is according to the plan or system)',
    english: 'order',
    swedish: 'ordning',
    norwegian: 'orden_(i_orden)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29549,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(ask + buy)',
    english: 'order,place_an_order-(to)',
    swedish: 'beställa',
    norwegian: 'bestille',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29550,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(order + description indicator)',
    english: 'orderly',
    swedish: 'ordentlig,välordnad,iordning',
    norwegian: 'velordnet,ordentlig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29551,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(plow + action indicator)',
    english: 'plough,plow-(to)',
    swedish: 'plöja',
    norwegian: 'pløye',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29552,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(pollen + action indicator)',
    english: 'pollinate-(to)',
    swedish: 'pollinera,befrukta_(växt)',
    norwegian: 'pollinere,befrukte_(planter)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29553,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(positive + description indicator)',
    english: 'positively',
    swedish: 'positiv',
    norwegian: 'positiv',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29554,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(makeup + action indicator)',
    english: 'put_on_makeup-(to)',
    swedish: 'sminka,sminka_sig',
    norwegian: 'sminke,sminke_seg)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29555,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(rake + action indicator)',
    english: 'rake-(to)',
    swedish: 'kratta,räfsa-(att)',
    norwegian: 'rake',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29556,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      'surface + sand + description indicator: a surface uneven like covered with sand)',
    english: 'rough,coarse,abrasive_(surface)',
    swedish: 'grov,skrovlig_(yta)',
    norwegian: 'grov',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29557,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(state of mind + important + description indicator: thought of as important)',
    english: 'serious,sincere',
    swedish: 'allvarlig,seriös,uppriktig',
    norwegian: 'alvorlig,oppriktig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29558,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(activity + nonsense + description indicator: action in a silly way)',
    english: 'silly,crazy',
    swedish: 'fånig,löjlig,knäpp',
    norwegian: 'tullete,sprø,gal',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29560,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(surface + glass + description indicator: a surface smooth like a glass)',
    english: 'smooth_(surface)',
    swedish: 'jämn_(yta)',
    norwegian: 'glatt,jevn',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29561,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(glue + description indicator)',
    english: 'sticky,gluey,adhesive',
    swedish: 'Klibbig,klistrig',
    norwegian: 'klissete,klebrig',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29562,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      'layer + pointer: the pointer indicates the topp part of the top layer) – Character (superimposed)',
    english: 'surface',
    swedish: 'yta',
    norwegian: 'overflate',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29563,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(hand + laugh+ action indicator)',
    english: 'tickle-(to)',
    swedish: 'kittla,killa',
    norwegian: 'kile',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29564,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(card + time + work)',
    english: 'time_card',
    swedish: 'stämpelkort,tidkort',
    norwegian: 'stemplingskort',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29565,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(remove + clothes)',
    english: 'undress-(to)',
    swedish: 'klä_av,klä_av_sig',
    norwegian: 'kle_av,kle_av_seg',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29566,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(without + smooth + description indicator: without smoothness)',
    english: 'uneven,not_smooth_(surface)',
    swedish: 'ojämn_(yta)',
    norwegian: 'ujevn',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29567,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(cause + wake up)',
    english: 'wake-(to)',
    swedish: 'väcka',
    norwegian: 'vekke',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29568,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(plant + minus + want: plants not wanted)',
    english: 'weed',
    swedish: 'ogräs',
    norwegian: 'ugress',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29569,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(weed + action indicator)',
    english: 'weed-(to)',
    swedish: 'rensa',
    norwegian: 'luke,luke_ut,fjerne',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29570,
    group: 'word',
    pos: 'RED',
    derivationExplanation: '(worry + description indicator)',
    english: 'worried',
    swedish: 'orolig,ängslig',
    norwegian: 'bekymret',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29571,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(many + fold + description indicator)',
    english: 'wrinkled',
    swedish: 'veckad,rynkad',
    norwegian: 'rynkete,skrukkete',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29580,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(alternation + description indicator)',
    english: 'alternating',
    swedish: '',
    norwegian: 'vekslende',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29601,
    group: 'word',
    pos: 'RED',
    derivationExplanation:
      '(outcome,result + to cultivate [contraction]: the outcome of cultivation)',
    english: 'crop_(agriculture),harvest_(agriculture)',
    swedish: 'skörd',
    norwegian: 'avling',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29602,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plant + container: a plant in a pot)',
    english: 'potted_plant',
    swedish: 'krukväxt',
    norwegian: 'potteplante',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29604,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(grass + sweet_(taste)): a kind of thick sweet grass)',
    english: 'sugar_cane',
    swedish: 'sockerrör',
    norwegian: 'sukkerrør',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29605,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(van, minibus + goods: a car for transport of goods)',
    english: 'transport_van',
    swedish: 'varubil',
    norwegian: 'varebil',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29606,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(bus + school [in combination])',
    english: 'school_bus',
    swedish: 'skolbuss',
    norwegian: 'skolebuss',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29607,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(car + police)',
    english: 'police_car',
    swedish: 'polisbil',
    norwegian: 'politibil',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29608,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(car + mail,post)',
    english: 'mail_van',
    swedish: 'postbil',
    norwegian: 'postbil',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29609,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(app + parking_lot)',
    english: 'parking_app',
    swedish: 'parkeringsapp',
    norwegian: 'parkeringsapp',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29610,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + wash + car)',
    english: 'car_wash',
    swedish: 'biltvätt',
    norwegian: 'bilvask',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29621,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(line + many + bushes)',
    english: 'hedge',
    swedish: 'häck',
    norwegian: 'hekk',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29622,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: 'Character',
    english: 'slope_(up)',
    swedish: 'sluttning,lutning_(uppåt)',
    norwegian: 'sluttning_(opp)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29623,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: 'Character',
    english: 'slope_(down)',
    swedish: 'sluttning,lutning_(nedåt)',
    norwegian: 'sluttning_(ned)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29624,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(earth + slope_(up): an uphill slope)',
    english: 'upward_slope',
    swedish: 'uppförsbacke,backe_(uppför)',
    norwegian: 'oppover-bakke',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29625,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(upward_slope + description indicator)',
    english: 'upward,uphill',
    swedish: 'backig_(uppför),uppför',
    norwegian: 'oppover',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29626,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(earth + slope_(down): an downhill slope)',
    english: 'downward_slope',
    swedish: 'utförsbacke,nerförsbacke,backe_(nerför)',
    norwegian: 'nedover-bakke',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29627,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(downward_slope + description indicator)',
    english: 'downward,downhill',
    swedish: 'backig_(nerför),nerför',
    norwegian: 'nedover',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29628,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: 'Character',
    english: 'slant_(forward),skew_(forward)',
    swedish: 'snedd,skevhet',
    norwegian: 'skjevhet',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29629,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation: '(slant_(forward) + description indicator)',
    english: 'slanted,slanting',
    swedish: 'sned',
    norwegian: 'skråstilt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29630,
    group: 'word',
    pos: 'GREEN',
    derivationExplanation:
      '(skew_(forward) + parallel + description indicator): the slanted line is skew in comparison with the parallel lines)',
    english: 'skew,askew,not_straight',
    swedish: 'skev',
    norwegian: 'skeiv',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29631,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(repair_shop_[contraction] + car)',
    english: 'car_repair_shop',
    swedish: 'bilverkstad',
    norwegian: 'bilverksted',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29632,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chair + child)',
    english: 'baby_chair',
    swedish: 'barnstol_(hög)',
    norwegian: 'barnestol',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29633,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chair + child + vehicle)',
    english: 'child_seat',
    swedish: 'bilbarnstol',
    norwegian: 'barnesete',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29634,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(chair + high + child)',
    english: 'high_chair_(child)',
    swedish: 'barnstol_(hög)',
    norwegian: 'høy_barnestol',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29635,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(support + society [contraction]: support provided by government)',
    english: 'social_support,social_services',
    swedish: 'socialhjälp,socialtjänst',
    norwegian: 'trygd,sosial_støtte,so-  siale_tjenester',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29636,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(support + society [contraction] + disability [contraction]: support provided by government for people with disabilities)',
    english: 'disability_support',
    swedish: 'handikapphjälp',
    norwegian: 'uføretrygd',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29637,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation:
      '(social_support + travel: Support by the society for those with limitations with regard to transportation)',
    english: 'transport_service',
    swedish: 'färdtjänst',
    norwegian: 'TT-transport',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29638,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(machine + pay [contraction] + parking lot)',
    english: 'parking_meter,parking_machine',
    swedish: 'parkeringsautomat',
    norwegian: 'parkeringsautomat',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29639,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(plug + vehicle)',
    english: 'charging_plug_(vehicle)',
    swedish: 'laddningsplugg',
    norwegian: 'ladeplugg',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29640,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(place + electricity +vehicle: a place for charging vehicle batteries)',
    english: 'charging_station',
    swedish: 'laddningsstation',
    norwegian: 'ladestasjon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29641,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(card + number + vehicle)',
    english: 'license_plate',
    swedish: 'registreringsskylt,registreringsplåt',
    norwegian: 'bilskilt',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 29642,
    group: 'word',
    pos: 'YELLOW',
    derivationExplanation: '(shop + gasoline, petrol)',
    english: 'petrol_station,gas_station',
    swedish: 'bensinstation,mack',
    norwegian: 'bensinstasjon',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: '',
    afrikaans: '',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28044,
    group: 'diacritics',
    pos: 'GREY',
    derivationExplanation: '(indicator (plural + definite))',
    english: 'indicator_(plural_definite)',
    swedish: 'operator (substantiv;plural,bestämd form)',
    norwegian: 'indikator_(flertall,bestemt_form',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'indicator_(mv+bepaald)',
    afrikaans: 'aanwyser_(meervoud,definitiewe_vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28045,
    group: 'diacritics',
    pos: 'GREY',
    derivationExplanation: '(indicator (thing + definite))',
    english: 'indicator_(thing_definite)',
    swedish: 'operator( konkret substantiv,bestämd form)',
    norwegian: 'indikator_(ting,bestemt_form)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'indictor_(ding+bepaald)',
    afrikaans: 'aanwyser_(ding, definitiewe_vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
  {
    av: 28046,
    group: 'diacritics',
    pos: 'GREY',
    derivationExplanation: '(indicator (thing + plural + definite))',
    english: 'indicator_(thing_plural_definite)',
    swedish: 'operator (sak,plural,bestämd form)',
    norwegian: 'indikator_(ting,flertall,bestemt_form)',
    finnish: '',
    hungarian: '',
    german: '',
    dutch: 'indicator_(ding+mv+bepaald)',
    afrikaans: 'aanwyser_(ding,meervoud,definitiewe_vorm)',
    russian: '',
    latvian: '',
    polish: '',
    french: '',
    spanish: '',
  },
];
